"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// Exported from "PacGroup.PacWorld.Web.Models.AdditionalPriceShow"
var App;
(function (App) {
    let AdditionalPriceShow;
    (function (AdditionalPriceShow) {
        AdditionalPriceShow[AdditionalPriceShow["None"] = 0] = "None";
        AdditionalPriceShow[AdditionalPriceShow["ToPay"] = 1] = "ToPay";
        AdditionalPriceShow[AdditionalPriceShow["Full"] = 2] = "Full";
    })(AdditionalPriceShow = App.AdditionalPriceShow || (App.AdditionalPriceShow = {}));
})(App || (App = {}));
var App;
(function (App) {
    var _a, _Cookie_build, _Cookie_getDomain;
    class Cookie {
        static get(key) {
            const options = App.app.settings.cookies[key];
            return Cookies.get(options ? options.name : key);
        }
        static set(key, value) {
            const options = App.app.settings.cookies[key];
            if (!options)
                Cookies.set(key, value);
            else
                Cookies.set(options.name, value, __classPrivateFieldGet(_a, _a, "m", _Cookie_build).call(_a, options));
        }
        static remove(key) {
            const options = App.app.settings.cookies[key];
            if (!options)
                Cookies.remove(key);
            else
                Cookies.remove(options.name, __classPrivateFieldGet(_a, _a, "m", _Cookie_build).call(_a, options));
        }
    }
    _a = Cookie, _Cookie_build = function _Cookie_build(options) {
        var _b;
        let expires = new Date();
        if (options.expiration)
            expires = new Date(expires.getTime() + App.parseTimeSpan(options.expiration));
        return {
            expires,
            path: (_b = options.path) !== null && _b !== void 0 ? _b : '/',
            domain: __classPrivateFieldGet(_a, _a, "m", _Cookie_getDomain).call(_a, window.location.hostname),
            secure: options.securePolicy === 1 /* CookieSecurePolicy.Always */
                || (options.securePolicy === 0 /* CookieSecurePolicy.SameAsRequest */ && window.location.protocol === 'https'),
        };
    }, _Cookie_getDomain = function _Cookie_getDomain(host) {
        if (host === 'localhost')
            return undefined;
        let pos = host.lastIndexOf('.');
        if (pos < 0)
            return undefined;
        pos = host.lastIndexOf('.', pos - 1);
        if (pos < 0)
            return `.${host}`;
        return host.substring(pos);
    };
    App.Cookie = Cookie;
})(App || (App = {}));
var App;
(function (App) {
    var _NetPricePresenter_instances, _NetPricePresenter_options, _NetPricePresenter_root, _NetPricePresenter_onCheckboxClick;
    class NetPricePresenter {
        constructor(options) {
            _NetPricePresenter_instances.add(this);
            _NetPricePresenter_options.set(this, void 0);
            _NetPricePresenter_root.set(this, void 0);
            Object.defineProperty(this, "type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const defaults = {
                root: '.js-filter-netto-link',
            };
            __classPrivateFieldSet(this, _NetPricePresenter_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _NetPricePresenter_options, "f");
            if (typeof root === 'string')
                __classPrivateFieldSet(this, _NetPricePresenter_root, $(root), "f");
            else
                __classPrivateFieldSet(this, _NetPricePresenter_root, root, "f");
            if (!__classPrivateFieldGet(this, _NetPricePresenter_root, "f").length)
                return;
            this.type = App.app.userSettings.pricePermission;
            if (__classPrivateFieldGet(this, _NetPricePresenter_options, "f").desired != null) {
                if (this.type === App.AdditionalPriceShow.Full)
                    this.type = __classPrivateFieldGet(this, _NetPricePresenter_options, "f").desired;
                else if (this.type === App.AdditionalPriceShow.ToPay)
                    this.type = __classPrivateFieldGet(this, _NetPricePresenter_options, "f").desired === App.AdditionalPriceShow.Full ? App.AdditionalPriceShow.ToPay : __classPrivateFieldGet(this, _NetPricePresenter_options, "f").desired;
            }
            __classPrivateFieldGet(this, _NetPricePresenter_root, "f").on('click', '.js-filter-netto-link', e => __classPrivateFieldGet(this, _NetPricePresenter_instances, "m", _NetPricePresenter_onCheckboxClick).call(this, e));
        }
        /**
         * Инициализация
         */
        init() {
            // Проверяет, надо ли проставлять чекбокс нетто-цены
            $('.js-filter-netto-link', __classPrivateFieldGet(this, _NetPricePresenter_root, "f"))
                .find('.js-filter-netto-check')
                .toggleClass('_active', NetPricePresenter.getVisibility());
        }
        /**
         * Проверить, показывать нетто-цены или нет
         * И вернуть данные с результатом проверки
         */
        static getVisibility() {
            return App.Cookie.get("netPrice" /* KnownCookie.NetPrice */) === '1';
        }
        /**
         * Устанавливает видимость элементам с нетто-ценой
         * @param content - контент, где надо установить
         * @param value - показывать нетто-цены или нет
         */
        static setVisibility(content, value) {
            $('.js-netto-price', content).toggleByClass(value);
        }
    }
    _NetPricePresenter_options = new WeakMap(), _NetPricePresenter_root = new WeakMap(), _NetPricePresenter_instances = new WeakSet(), _NetPricePresenter_onCheckboxClick = function _NetPricePresenter_onCheckboxClick(e) {
        const target = $(e.currentTarget);
        const filterNettCheck = target.find('.js-filter-netto-check');
        const netPrice = $('.js-netto-price');
        const show = !filterNettCheck.hasClass('_active');
        if (show) {
            filterNettCheck.addClass('_active');
            netPrice.showByClass();
            App.Cookie.set("netPrice" /* KnownCookie.NetPrice */, '1');
        }
        else {
            filterNettCheck.removeClass('_active');
            netPrice.hideByClass();
            App.Cookie.set("netPrice" /* KnownCookie.NetPrice */, '0');
        }
        __classPrivateFieldGet(this, _NetPricePresenter_root, "f").trigger("NetPricePresenter:click" /* Events.NetPricePresenterClick */, [{ show }]);
    };
    App.NetPricePresenter = NetPricePresenter;
})(App || (App = {}));
/// <reference path='api/base/SameSiteMode.ts' />
/// <reference path='api/models/common/AdditionalPriceShow.generated.ts' />
/// <reference path='common/components/Cookie.ts' />
/// <reference path='common/components/NetPricePresenter.ts' />
var App;
(function (App) {
    var _Application_instances, _a, _Application_cookieDefaults, _Application_settingDefaults, _Application_userSettingDefaults, _Application_options, _Application_updateSentryUser, _Application_isCrossOriginRequest;
    class Application {
        constructor(options) {
            _Application_instances.add(this);
            _Application_options.set(this, void 0);
            // Заполняется до загрузки DOM.
            Object.defineProperty(this, "http", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "config", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "settings", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "userSettings", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "url", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "language", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // Заполняется после загрузки DOM.
            Object.defineProperty(this, "container", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "appContainer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "appContainerHeader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "appContainerContent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "appContainerFooter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "auth", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "seo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /** Модули в текущем окружении. */
            Object.defineProperty(this, "modules", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {}
            });
            /** Текущая страница. Не удалять, используется в razor-вьюхах! */
            Object.defineProperty(this, "page", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _Application_options, options, "f");
            Sentry.init({
                dsn: __classPrivateFieldGet(this, _Application_options, "f").sentryDsn,
                debug: __classPrivateFieldGet(this, _Application_options, "f").debug,
                release: __classPrivateFieldGet(this, _Application_options, "f").version,
                environment: __classPrivateFieldGet(this, _Application_options, "f").environment,
                beforeSend: (event, hint) => {
                    // Данная проверка используется для логирования в консоли всех исключений, проходящих через Sentry, кроме
                    // необработанных, которые по-умолчанию и так логируются в консоли внутренними механизмами Sentry.
                    if ((hint === null || hint === void 0 ? void 0 : hint.syntheticException) != null) {
                        // https://github.com/getsentry/sentry-javascript/issues/1600#issuecomment-557191040
                        setTimeout(() => { var _b; return console.error((_b = hint === null || hint === void 0 ? void 0 : hint.originalException) !== null && _b !== void 0 ? _b : hint === null || hint === void 0 ? void 0 : hint.syntheticException); }, 0);
                    }
                    return event;
                },
                autoSessionTracking: false,
            });
            this.http = new App.Http({
                baseUrl: location.origin,
                throwOnResponseError: true,
                defaultRequestHeaders: {
                    'Accept': 'application/json',
                },
                handlers: [
                    // Note: изменения продублировать в обработчике события 'ajaxSend' для 'jQuery'.
                    (request, next) => __awaiter(this, void 0, void 0, function* () {
                        if (!__classPrivateFieldGet(_a, _a, "m", _Application_isCrossOriginRequest).call(_a, request.url)) {
                            // Доп.инфа для разбора полета при возникновении ошибки в ajax-запросе.
                            request.headers.append('X-Pac-Referrer', window.location.href);
                            Object.keys(__classPrivateFieldGet(this, _Application_options, "f").customHeaders).forEach(v => {
                                request.headers.append(v, __classPrivateFieldGet(this, _Application_options, "f").customHeaders[v]);
                            });
                            if ((App.app === null || App.app === void 0 ? void 0 : App.app.settings) != null && request.method !== 'GET' && request.method !== 'HEAD' && request.method !== 'OPTIONS') {
                                const csrfToken = App.Cookie.get("CSRF-TOKEN" /* KnownCookie.CsrfToken */);
                                if (csrfToken)
                                    request.headers.append('RequestVerificationToken', csrfToken);
                            }
                        }
                        return yield next(request);
                    }),
                ],
            });
            this.config = new App.ConfigService({ client: this.http });
            // Note: debug-режим отключен, т.к. в этом режиме submit формы после валидации не производится (см. https://jqueryvalidation.org/validate/)
            // $.validator.setDefaults({ debug: this.settings.debug });
            $.validator.autoCreateRanges = true;
            Inputmask.extendDefaults({
                autoUnmask: true,
            });
            $.datepicker.setDefaults({
                dateFormat: 'dd.mm.yy',
                firstDay: 1,
                changeYear: true,
                changeMonth: true,
            });
            // Note: костыль из-за google-переводчика.
            /* eslint-disable */
            const oldDatepicker = $.fn.datepicker;
            $.fn.datepicker = function datepicker(...args) {
                const result = oldDatepicker.apply(this, args);
                if (args.length <= 0 || typeof args[0] !== 'string')
                    $('.ui-datepicker').addClass('notranslate');
                return result;
            };
            /* eslint-enable */
            this.modules.imageLazyLoader = new App.ImageLazyLoader({
                containers: [
                    '.js-tours-output',
                    '.js-tours-output-block',
                    '.js-tours-output-table',
                    '.js-hotels-town-output-map',
                    '.js-tours-output-image',
                    '.js-tour-block',
                    '.js-tour-table-block',
                    '.js-hotels-town-output-map',
                    '.js-tours-output-image',
                    '.hotel-stoks-wrap',
                ],
            });
            this.modules.infoMessageCloser = new App.InfoMessageCloser();
        }
        run(signal) {
            return __awaiter(this, void 0, void 0, function* () {
                let resizeTimer;
                $(window)
                    .on('load', () => {
                    // Note: из-за асинхронного вызова событий window.onload и $(document).ready, в jQuery 3+ не гарантируется вызов
                    // window.onload строго после $(document).ready, т.е. $('body') на этот момент может быть еще недоступен.
                    $(() => $('body').trigger("app:loaded" /* Events.Loaded */));
                })
                    .on('resize', () => {
                    $(document).trigger("win:resizeStart" /* Events.WinResizeStart */);
                    if (resizeTimer)
                        clearTimeout(resizeTimer);
                    resizeTimer = window.setTimeout(() => {
                        $(document).trigger("win:resizeEnd" /* Events.WinResizeEnd */);
                    }, 500);
                });
                $(document)
                    // Note: изменения продублировать в обработчике для 'Http'.
                    .on('ajaxSend', (event, jqXHR, ajaxOptions) => {
                    var _b;
                    if (__classPrivateFieldGet(_a, _a, "m", _Application_isCrossOriginRequest).call(_a, (_b = ajaxOptions.url) !== null && _b !== void 0 ? _b : window.location.href))
                        return;
                    // Доп.инфа для разбора полета при возникновении ошибки в ajax-запросе.
                    jqXHR.setRequestHeader('X-Pac-Referrer', window.location.href);
                    Object.keys(__classPrivateFieldGet(this, _Application_options, "f").customHeaders).forEach(v => {
                        jqXHR.setRequestHeader(v, __classPrivateFieldGet(this, _Application_options, "f").customHeaders[v]);
                    });
                    if ((App.app === null || App.app === void 0 ? void 0 : App.app.settings) != null && ajaxOptions.method !== 'GET' && ajaxOptions.method !== 'HEAD' && ajaxOptions.method !== 'OPTIONS') {
                        const csrfToken = App.Cookie.get("CSRF-TOKEN" /* KnownCookie.CsrfToken */);
                        if (csrfToken)
                            jqXHR.setRequestHeader('RequestVerificationToken', csrfToken);
                    }
                })
                    .on("app:loggedin" /* Events.LoggedIn */, (_, data) => __awaiter(this, void 0, void 0, function* () {
                    var _b;
                    this.userSettings.isAuthenticated = data.isAuthenticated;
                    this.userSettings.username = data.username;
                    // TODO: add retry.
                    this.userSettings = (_b = yield this.config.userSettings({}, App.noneSignal)) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(_a, _a, "f", _Application_userSettingDefaults);
                    __classPrivateFieldGet(this, _Application_instances, "m", _Application_updateSentryUser).call(this);
                    // TODO: убрать обновление текущей страницы после того, как все страницы научатся реагировать на событие.
                    window.location.reload();
                }))
                    .on("app:userstatus" /* Events.UserStatus */, (_, data) => __awaiter(this, void 0, void 0, function* () {
                    var _b;
                    if (this.userSettings.username === data.username)
                        return;
                    // TODO: add retry.
                    this.userSettings = (_b = yield this.config.userSettings({}, App.noneSignal)) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(_a, _a, "f", _Application_userSettingDefaults);
                    __classPrivateFieldGet(this, _Application_instances, "m", _Application_updateSentryUser).call(this);
                }))
                    .on("app:loggedout" /* Events.LoggedOut */, () => __awaiter(this, void 0, void 0, function* () {
                    var _b;
                    this.userSettings.isAuthenticated = false;
                    this.userSettings.username = '';
                    // TODO: add retry.
                    this.userSettings = (_b = yield this.config.userSettings({}, App.noneSignal)) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(_a, _a, "f", _Application_userSettingDefaults);
                    __classPrivateFieldGet(this, _Application_instances, "m", _Application_updateSentryUser).call(this);
                    // TODO: убрать обновление текущей страницы после того, как все страницы научатся реагировать на событие.
                    window.location.reload();
                }))
                    .on("app:currencychanged" /* Events.CurrencyChanged */, (_, newCurrencyCode) => __awaiter(this, void 0, void 0, function* () {
                    yield App.CurrencyManager.changeCurrentCurrency(newCurrencyCode, App.noneSignal);
                }))
                    .on('click', '.js-button-expired-new', e => {
                    const target = $(e.currentTarget);
                    const url = target.attr('data-url');
                    App.popupHide();
                    if (url)
                        window.location.href = url;
                    else
                        window.location.href = `${window.location.origin}${window.location.pathname.substring(0, window.location.pathname.indexOf('/', 1))}/search`;
                })
                    .on('click', '.js-button-expired-refresh', () => {
                    window.location.reload();
                })
                    // TODO: убрать после замены данной разметки на partial-шаблон ActionInfo и компонент ActionInfoComponent.
                    .on('click', '.js-show-cancellation-conditions', e => {
                    const target = $(e.currentTarget);
                    const conditionsBlock = target.find('.js-reserve-info-block');
                    conditionsBlock.toggle();
                    if (conditionsBlock.is(':visible'))
                        conditionsBlock.trigger("booking-conditions:show" /* Events.BookingConditionsShow */, [{ type: target.attr('data-type'), key: target.attr('data-key') }]);
                    else
                        conditionsBlock.trigger("booking-conditions:hide" /* Events.BookingConditionsHide */, [{ type: target.attr('data-type'), key: target.attr('data-key') }]);
                })
                    // Note: http://store.pac.ru/docs/AdvBanner (search for 'store:pac:adv:blockloaded')
                    .on("store:pac:adv:blockloaded" /* widgets.Events.AdvBlockLoaded */, (e) => __awaiter(this, void 0, void 0, function* () {
                    yield App.CurrencyManager.convertAll($(`#${e.originalEvent.detail}`));
                }));
                yield Promise.all([
                    this.config.settings({}, signal).then(v => {
                        this.settings = v !== null && v !== void 0 ? v : __classPrivateFieldGet(_a, _a, "f", _Application_settingDefaults);
                    }),
                    this.config.userSettings({}, signal).then(v => {
                        this.userSettings = v !== null && v !== void 0 ? v : __classPrivateFieldGet(_a, _a, "f", _Application_userSettingDefaults);
                        __classPrivateFieldGet(this, _Application_instances, "m", _Application_updateSentryUser).call(this);
                    }),
                ]);
                this.url = new App.UrlHelper(this.settings.route);
                this.language = App.getUICulture();
                const dateFnsLanguage = this.language === 'en' ? 'enUS' : this.language;
                // TODO: fix ASAP
                // eslint-disable-next-line
                dateFns.setDefaultOptions({ locale: dateFns.locale[dateFnsLanguage] });
                Globalize.locale(this.language);
                let currentCurrencyCode = App.Cookie.get("currency" /* KnownCookie.Currency */);
                if (currentCurrencyCode == null || (currentCurrencyCode !== App.CurrencyManager.defaults.neutralCurrencyCode
                    && !this.settings.supportedCurrencies.includes(currentCurrencyCode)))
                    currentCurrencyCode = this.settings.defaultCurrency;
                App.CurrencyManager.init(currentCurrencyCode, new App.CurrencyConverter({ configService: this.config }));
                // Note: при использовании обработчиков события ready в других местах приложения не стоит рассчитывать, что данные,
                // инициализирующиеся в данном обработчике, будут доступны в этих других обработчиках.
                // Note: для добавления модулей, зависящих от конкретной страницы, использовать событие 'app:initializing'.
                $(() => __awaiter(this, void 0, void 0, function* () {
                    // Добавляем браузерные классы.
                    // Note: перенесено выше создания модулей, т.к. они при инициализации могут зависеть от этих css-классов.
                    const ua = window.navigator.userAgent.toLowerCase();
                    const isEdge = ua.includes('edge/');
                    if (ua.includes('firefox'))
                        $('html').addClass('ff');
                    if (ua.includes('chrome') && !isEdge)
                        $('html').addClass('chrome');
                    if (/msie|trident/.test(ua))
                        $('html').addClass('ie');
                    if (/iphone|ipad|ipod|ios/.test(ua))
                        $('html').addClass('ios');
                    if (ua.includes('mac'))
                        $('html').addClass('mac');
                    // Определяем основной контейнер приложения для различных взаимодействий со скроллом.
                    if (App.isTouch) {
                        this.container = $(`.${_a.defaults.appContainerClass}`, $('body'));
                        this.appContainer = this.container;
                        // Перемещаем пикер в контейнер для правильного позиционирования на touch устройствах.
                        setTimeout(() => {
                            this.container.append($('#ui-datepicker-div'));
                        }, 1000);
                        /* eslint-disable */
                        $.datepicker.setDefaults({
                            beforeShow: (input, inst) => {
                                setTimeout(() => {
                                    var _b, _c, _d;
                                    const jqInput = $(input);
                                    const jqInputOffset = (_b = jqInput.offset()) !== null && _b !== void 0 ? _b : { left: 0, top: 0 };
                                    const containerOffset = this.container.offset();
                                    inst.dpDiv.css({
                                        top: jqInputOffset.top * 1 + ((_c = this.container.scrollTop()) !== null && _c !== void 0 ? _c : 0) + ((_d = jqInput.height()) !== null && _d !== void 0 ? _d : 0) + 3,
                                        left: jqInputOffset.left - (containerOffset != null ? containerOffset.left : 0),
                                        // Контейнер в который переместили z-index = 9, у бокового меню 100. БМ перекрывает попап.
                                        zIndex: 100,
                                    });
                                }, 10);
                                return {};
                            },
                        });
                        /* eslint-enable */
                    }
                    else {
                        this.container = $('html');
                        this.appContainer = $(`.${_a.defaults.appContainerClass}`, this.container);
                    }
                    this.appContainerHeader = $(`.${_a.defaults.appContainerHeaderClass}`, this.appContainer);
                    this.appContainerContent = $(`.${_a.defaults.appContainerContentClass}`, this.appContainer);
                    this.appContainerFooter = $(`.${_a.defaults.appContainerFooterClass}`, this.appContainer);
                    // Note: перенесено внутрь события ready, т.к. нижеуказанный код использует this.container, который инициализируется в
                    // событии ready. Модули являются единственными подписчиками на это событие.
                    if (App.isTouch) {
                        $(window).on('scroll touchend', $.throttle(300, () => {
                            let pos;
                            const event = window.setInterval(() => {
                                const top = this.container.scrollTop();
                                $(document).trigger("win:scroll" /* Events.WinScroll */, { scrollTop: top });
                                if (pos !== top)
                                    clearTimeout(event);
                                pos = top !== null && top !== void 0 ? top : 0;
                            }, 100);
                        }));
                    }
                    else {
                        $(window).on('scroll', () => {
                            $(document).trigger("win:scroll" /* Events.WinScroll */, { scrollTop: this.container.scrollTop() });
                        });
                    }
                    $('.js-left-sidebar-currency').on('click', e => {
                        var _b, _c;
                        const target = $(e.currentTarget);
                        const currencyCode = (_b = target.attr('data-code')) !== null && _b !== void 0 ? _b : '';
                        const currencySymbol = (_c = target.attr('data-symbol')) !== null && _c !== void 0 ? _c : '';
                        // Для Debug устанавливается здесь, для Staging / Production - в скриптах основного сайта.
                        if (__classPrivateFieldGet(this, _Application_options, "f").debug) {
                            App.Cookie.set("currency" /* KnownCookie.Currency */, currencyCode);
                            target.parents('.js-currency-travel-selector').hide();
                            target.parents('.js-global-currency').find('.js-currency-travel-header-title').html(currencyCode + ', <b>' + currencySymbol + '</b>');
                        }
                        $('body').trigger("app:currencychanged" /* Events.CurrencyChanged */, [currencyCode]);
                    });
                    // Для Debug устанавливается здесь, для Staging / Production - в скриптах основного сайта.
                    if (__classPrivateFieldGet(this, _Application_options, "f").debug) {
                        $('.js-currency-travel-header').on('click', () => $('.js-currency-travel-selector').show());
                    }
                    this.auth = new App.Authentication({
                        loginUrl: _a.urls.login,
                        statusUrl: _a.urls.status,
                        logoutUrl: _a.urls.logout,
                        restorePasswordUrl: _a.urls.restorePassword,
                        registrationUrl: this.userSettings.canRegister ? _a.urls.registration : undefined,
                    });
                    this.seo = new App.Seo({
                        fields: __classPrivateFieldGet(this, _Application_options, "f").seo,
                    });
                    // Создание модулей, присутствующих на каждой странице.
                    // Для Staging / Production используется переделанный вариант от сайта, загружаемый в скриптах сайта.
                    if (__classPrivateFieldGet(this, _Application_options, "f").debug)
                        this.modules.leftSidebar = new App.LeftSidebar();
                    Fancybox.bind('[data-fancybox]');
                    $(document).trigger("app:initializing" /* Events.Initializing */);
                    if (this.page != null) {
                        this.page.mount();
                        yield this.page.run(signal);
                    }
                    $(document).trigger("app:initialized" /* Events.Initialized */);
                }));
            });
        }
    }
    _a = Application, _Application_options = new WeakMap(), _Application_instances = new WeakSet(), _Application_updateSentryUser = function _Application_updateSentryUser() {
        if (this.userSettings.isAuthenticated)
            Sentry.configureScope(scope => scope.setUser({ username: this.userSettings.username }));
        else
            Sentry.configureScope(scope => scope.setUser(null));
    }, _Application_isCrossOriginRequest = function _Application_isCrossOriginRequest(url) {
        const objUrl = new URL(url, window.location.href);
        return objUrl.origin !== window.location.origin;
    };
    Object.defineProperty(Application, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            appContainerClass: 'js-app-container',
            appContainerHeaderClass: 'js-app-container-header',
            appContainerContentClass: 'js-app-container-content',
            appContainerFooterClass: 'js-app-container-footer',
        }
    });
    Object.defineProperty(Application, "urls", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            settings: '/config/settings/',
            userSettings: '/config/usersettings/',
            exchangeRates: '/config/exchangerates/',
            login: '/account/login/',
            status: '/account/status/',
            logout: '/account/logout/',
            lockout: '/account/lockout/',
            restorePassword: '/account/restorepassword/',
            registration: '/account/registration/',
            unauthorized: '/error/401/',
            accessDenied: '/error/403/',
            notFound: '/error/404/',
        }
    });
    _Application_cookieDefaults = { value: {
            name: '',
            httpOnly: false,
            sameSite: -1 /* SameSiteMode.Unspecified */,
            securePolicy: 0 /* CookieSecurePolicy.SameAsRequest */,
            expiration: '365.00:00:00',
            isEssential: false,
        } };
    _Application_settingDefaults = { value: {
            defaultUrl: '/my/order/',
            cookies: {
                activityTypeView: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'activityTypeView' }),
                authType: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'authType' }),
                cruiseTypeView: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'cruiseTypeView' }),
                currency: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'currency' }),
                hotelCompare: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'hotelCompare' }),
                hotelTypeView: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'hotelTypeView' }),
                location: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'location' }),
                netPrice: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'netPrice' }),
                theme: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'theme' }),
                tourTypeView: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'tourTypeView' }),
                visaAssistance: Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _Application_cookieDefaults)), { name: 'visaAssistance' }),
            },
            route: {
                lowercaseUrls: true,
                appendTrailingSlash: true,
            },
            supportedLanguages: ['RU'],
            defaultLanguage: 'RU',
            defaultTimezone: 'utc',
            supportedCurrencies: ['RUB'],
            defaultCurrency: 'RUB',
            relevantResultTime: 30 * 60 * 1000,
            bonusServiceTypes: [],
            minSearchTermLength: 3,
            sentryDsn: '',
            tenant: 1,
            aviaOptions: {
                minDateShift: 1,
                defaultDateShift: 1,
            },
            cruiseOptions: {
                defaultCheckinDateShift: 1,
                defaultCheckinDateInterval: 7,
                maxCheckinDateOffset: 30,
                minPrice: 0,
                maxPrice: 2000000,
                maxChildAge: 17,
                bannerIncutPositions: {},
            },
            hotelOptions: {
                defaultCitizenship: 'RU',
            },
            tourOptions: {
                minCheckinDateShift: 1,
                maxCheckinDateOffset: 30,
                maxProgramCheckinDateOffset: 30,
                maxHotelCheckinDateOffset: 30,
                defaultCheckinDateShift: 1,
                defaultCheckinDateInterval: 7,
                defaultAdultCount: 2,
                minAdultAge: 18,
                bannerIncutPositions: {},
            },
        } };
    _Application_userSettingDefaults = { value: {
            isAuthenticated: false,
            username: '',
            pricePermission: App.AdditionalPriceShow.None,
            canRegister: false,
            isAgentInBlackList: false,
        } };
    App.Application = Application;
})(App || (App = {}));
var App;
(function (App) {
    class Money extends HTMLElement {
        get group() {
            return this.getAttribute('group');
        }
        set group(value) {
            if (value)
                this.setAttribute('group', value);
            else
                this.removeAttribute('group');
        }
        get type() {
            const value = this.getAttribute('type');
            return value === 'money' || value === 'amount' || value === 'currency' ? value : null;
        }
        set type(value) {
            if (value)
                this.setAttribute('type', value);
            else
                this.removeAttribute('type');
        }
        get amount() {
            const value = this.getAttribute('amount');
            return value == null ? 0 : Number(value);
        }
        set amount(value) {
            this.setAttribute('amount', value.toString());
        }
        get currency() {
            var _a;
            return (_a = this.getAttribute('currency')) !== null && _a !== void 0 ? _a : App.app.settings.defaultCurrency;
        }
        set currency(value) {
            this.setAttribute('currency', value);
        }
        get format() {
            return this.getAttribute('format');
        }
        set format(value) {
            if (value)
                this.setAttribute('format', value);
            else
                this.removeAttribute('format');
        }
        get fixed() {
            const value = this.getAttribute('fixed');
            return value == null ? false : Boolean(value);
        }
        set fixed(value) {
            if (value)
                this.setAttribute('fixed', 'true');
            else
                this.removeAttribute('fixed');
        }
        static get observedAttributes() {
            return ['group', 'type', 'amount', 'currency', 'format', 'fixed'];
        }
        attributeChangedCallback(name, oldValue, newValue) {
            return __awaiter(this, void 0, void 0, function* () {
                if (oldValue === newValue)
                    return;
                yield this.update(App.noneSignal);
            });
        }
        connectedCallback() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.querySelector('span')) {
                    const root = document.createElement('span');
                    root.classList.add('money');
                    this.append(root);
                }
                document.addEventListener("currencymanager:currencychanged" /* App.Events.CurrencyManagerCurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.update(App.noneSignal); }));
                if (App.CurrencyManager.initialized)
                    yield this.update(App.noneSignal);
                else
                    document.addEventListener("currencymanager:initialized" /* App.Events.CurrencyManagerInitialized */, () => __awaiter(this, void 0, void 0, function* () { return yield this.update(App.noneSignal); }));
            });
        }
        update(signal) {
            return __awaiter(this, void 0, void 0, function* () {
                const root = this.querySelector('span');
                if (!root)
                    return;
                // TODO: перенести форматирование или сюда или в utility-функцию, а из CurrencyManager - убрать.
                root.textContent = yield App.CurrencyManager.format(this.group, this.type, this.amount, this.currency, this.format, this.fixed, signal);
            });
        }
    }
    Object.defineProperty(Money, "tagName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'pg-money'
    });
    App.Money = Money;
})(App || (App = {}));
customElements.define(App.Money.tagName, App.Money);
var App;
(function (App) {
    var _PageBase_instances, _PageBase_root, _PageBase_tryMount;
    class PageBase {
        // TODO: полагаю, что "общение" между т.н. компонентами должно все же происходить при помощи событий.
        get digest() {
            return this.components.find(v => v instanceof App.Digest);
        }
        constructor(options = {}) {
            _PageBase_instances.add(this);
            _PageBase_root.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "components", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            __classPrivateFieldSet(this, _PageBase_root, options.root, "f");
            // TODO: убрать после разнесения кода в конструкторах страниц по методам mount/hydrate/run.
            if (document.readyState !== 'loading')
                __classPrivateFieldGet(this, _PageBase_instances, "m", _PageBase_tryMount).call(this);
        }
        mount() {
            __classPrivateFieldGet(this, _PageBase_instances, "m", _PageBase_tryMount).call(this);
            // TODO: mount components
        }
        run(signal) {
            signal.throwIfAborted();
            return Promise.resolve();
        }
    }
    _PageBase_root = new WeakMap(), _PageBase_instances = new WeakSet(), _PageBase_tryMount = function _PageBase_tryMount() {
        var _a;
        if (this.root)
            return;
        // TODO: перенести в mount после разнесения кода в конструкторах страниц по методам mount/hydrate/run.
        const root = (_a = __classPrivateFieldGet(this, _PageBase_root, "f")) !== null && _a !== void 0 ? _a : App.app.appContainer;
        if (typeof root === 'string')
            this.root = $(root);
        else
            this.root = root;
    };
    App.PageBase = PageBase;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _ChangePasswordPage_instances, _ChangePasswordPage_options, _ChangePasswordPage_form, _ChangePasswordPage_popup, _ChangePasswordPage_responseValidator, _ChangePasswordPage_onSubmitAsync;
    class ChangePasswordPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-changepassword-form' }, options));
            _ChangePasswordPage_instances.add(this);
            _ChangePasswordPage_options.set(this, void 0);
            _ChangePasswordPage_form.set(this, void 0);
            _ChangePasswordPage_popup.set(this, void 0);
            _ChangePasswordPage_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _ChangePasswordPage_options, options, "f");
            __classPrivateFieldSet(this, _ChangePasswordPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _ChangePasswordPage_form, new App.Form({ root: $('form', this.root) }), "f");
            __classPrivateFieldSet(this, _ChangePasswordPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _ChangePasswordPage_popup, "f")),
                validator: __classPrivateFieldGet(this, _ChangePasswordPage_form, "f").validator,
            }), "f");
            $('.js-changepassword-submit', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if ((_a = __classPrivateFieldGet(this, _ChangePasswordPage_form, "f")) === null || _a === void 0 ? void 0 : _a.validator.valid())
                    yield __classPrivateFieldGet(this, _ChangePasswordPage_instances, "m", _ChangePasswordPage_onSubmitAsync).call(this, e);
            }));
        }
    }
    _ChangePasswordPage_options = new WeakMap(), _ChangePasswordPage_form = new WeakMap(), _ChangePasswordPage_popup = new WeakMap(), _ChangePasswordPage_responseValidator = new WeakMap(), _ChangePasswordPage_instances = new WeakSet(), _ChangePasswordPage_onSubmitAsync = function _ChangePasswordPage_onSubmitAsync(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _ChangePasswordPage_form, "f") || !__classPrivateFieldGet(this, _ChangePasswordPage_form, "f").validator.form())
                return;
            const data = __classPrivateFieldGet(this, _ChangePasswordPage_form, "f").root.serializeArray();
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _ChangePasswordPage_options, "f").url,
                method: 'POST',
                data,
            });
            try {
                const response = yield xhr;
                __classPrivateFieldGet(this, _ChangePasswordPage_responseValidator, "f").process(response);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ChangePasswordPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.ChangePasswordPage = ChangePasswordPage;
})(App || (App = {}));
var App;
(function (App) {
    var _RegistrationGoogleAutocompletePlace_options;
    class RegistrationGoogleAutocompletePlace {
        constructor(options) {
            _RegistrationGoogleAutocompletePlace_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const defaults = {
                root: '.js-registration-form',
            };
            __classPrivateFieldSet(this, _RegistrationGoogleAutocompletePlace_options, Object.assign(defaults, options), "f");
            const { root } = __classPrivateFieldGet(this, _RegistrationGoogleAutocompletePlace_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
        }
        activateCitySearchInstance(placeId, cityId, regionId, countryId) {
            const el = document.getElementById(placeId);
            const ac = new google.maps.places.Autocomplete(el, { types: ['locality'] });
            ac.addListener('place_changed', () => {
                var _a;
                const place = ac.getPlace();
                if (!place.geometry || !place.geometry.location) {
                    console.log('Ошибка выбора города');
                }
                const components = place.address_components;
                if (components) {
                    $('#' + cityId, this.root).val(Enumerable.from(components).first(v => Enumerable.from(v.types).any(x => x == 'locality')).long_name);
                    const area = (_a = Enumerable.from(components).firstOrDefault(v => Enumerable.from(v.types).any(x => x == 'administrative_area_level_1'))) === null || _a === void 0 ? void 0 : _a.long_name;
                    if (area)
                        $('#' + regionId, this.root).val(area);
                    $('#' + countryId, this.root).val(Enumerable.from(components).first(v => Enumerable.from(v.types).any(x => x == 'country')).long_name);
                }
            });
        }
    }
    _RegistrationGoogleAutocompletePlace_options = new WeakMap();
    App.RegistrationGoogleAutocompletePlace = RegistrationGoogleAutocompletePlace;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _RegistrationPage_instances, _RegistrationPage_options, _RegistrationPage_form, _RegistrationPage_popup, _RegistrationPage_responseValidator, _RegistrationPage_onCompanyPlaceKeypress, _RegistrationPage_onCompanyPlaceFocusOut, _RegistrationPage_onSubmitAsync;
    class RegistrationPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-registration-form' }, options));
            _RegistrationPage_instances.add(this);
            _RegistrationPage_options.set(this, void 0);
            _RegistrationPage_form.set(this, void 0);
            _RegistrationPage_popup.set(this, void 0);
            _RegistrationPage_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _RegistrationPage_options, options, "f");
            __classPrivateFieldSet(this, _RegistrationPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _RegistrationPage_responseValidator, new App.ResponseValidatorOld({ messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _RegistrationPage_popup, "f")) }), "f");
            __classPrivateFieldSet(this, _RegistrationPage_form, new App.Form({ root: $('form', this.root) }), "f");
            $('.js-registration-submit', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if ((_a = __classPrivateFieldGet(this, _RegistrationPage_form, "f")) === null || _a === void 0 ? void 0 : _a.validator.valid())
                    yield __classPrivateFieldGet(this, _RegistrationPage_instances, "m", _RegistrationPage_onSubmitAsync).call(this, e);
            }));
            $('.js-company-place', this.root)
                .on('keypress', e => __classPrivateFieldGet(this, _RegistrationPage_instances, "m", _RegistrationPage_onCompanyPlaceKeypress).call(this, e))
                .on('focusout', e => __classPrivateFieldGet(this, _RegistrationPage_instances, "m", _RegistrationPage_onCompanyPlaceFocusOut).call(this, e));
            $.validator.addMethod('regex', function (value, element) {
                const mask = $(element).attr('data-val-regex-pattern');
                if (mask) {
                    Object.assign($.validator.messages, {
                        regex: $(element).attr('data-val-regex') || 'Введите корректное значение',
                    });
                    return this.optional(element) || (typeof value === 'string' && new RegExp(mask).test(value));
                }
                return false;
            });
        }
    }
    _RegistrationPage_options = new WeakMap(), _RegistrationPage_form = new WeakMap(), _RegistrationPage_popup = new WeakMap(), _RegistrationPage_responseValidator = new WeakMap(), _RegistrationPage_instances = new WeakSet(), _RegistrationPage_onCompanyPlaceKeypress = function _RegistrationPage_onCompanyPlaceKeypress(e) {
        const target = $(e.currentTarget);
        const parentBlock = target.parent();
        $('.js-company-place-city', parentBlock).val('');
    }, _RegistrationPage_onCompanyPlaceFocusOut = function _RegistrationPage_onCompanyPlaceFocusOut(e) {
        const target = $(e.currentTarget);
        const parentBlock = target.parent();
        if (!$('.js-company-place-city', parentBlock).valString())
            target.val('');
    }, _RegistrationPage_onSubmitAsync = function _RegistrationPage_onSubmitAsync(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _RegistrationPage_form, "f") || !__classPrivateFieldGet(this, _RegistrationPage_form, "f").validator.form())
                return;
            const data = __classPrivateFieldGet(this, _RegistrationPage_form, "f").root.serializeArray();
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _RegistrationPage_options, "f").url,
                method: 'POST',
                data,
            });
            try {
                const response = yield xhr;
                if (__classPrivateFieldGet(this, _RegistrationPage_responseValidator, "f").process(response))
                    window.location.replace('/my');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _RegistrationPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.RegistrationPage = RegistrationPage;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _RestorePasswordPage_instances, _RestorePasswordPage_options, _RestorePasswordPage_form, _RestorePasswordPage_popup, _RestorePasswordPage_responseValidator, _RestorePasswordPage_onSubmitAsync;
    class RestorePasswordPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-restorepassword-form' }, options));
            _RestorePasswordPage_instances.add(this);
            _RestorePasswordPage_options.set(this, void 0);
            _RestorePasswordPage_form.set(this, void 0);
            _RestorePasswordPage_popup.set(this, void 0);
            _RestorePasswordPage_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _RestorePasswordPage_options, options, "f");
            __classPrivateFieldSet(this, _RestorePasswordPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _RestorePasswordPage_responseValidator, new App.ResponseValidatorOld({ messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _RestorePasswordPage_popup, "f")) }), "f");
            __classPrivateFieldSet(this, _RestorePasswordPage_form, new App.Form({ root: $('form', this.root) }), "f");
            $('.js-restorepassword-submit', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if ((_a = __classPrivateFieldGet(this, _RestorePasswordPage_form, "f")) === null || _a === void 0 ? void 0 : _a.validator.valid())
                    yield __classPrivateFieldGet(this, _RestorePasswordPage_instances, "m", _RestorePasswordPage_onSubmitAsync).call(this, e);
            }));
        }
    }
    _RestorePasswordPage_options = new WeakMap(), _RestorePasswordPage_form = new WeakMap(), _RestorePasswordPage_popup = new WeakMap(), _RestorePasswordPage_responseValidator = new WeakMap(), _RestorePasswordPage_instances = new WeakSet(), _RestorePasswordPage_onSubmitAsync = function _RestorePasswordPage_onSubmitAsync(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _RestorePasswordPage_form, "f") || !__classPrivateFieldGet(this, _RestorePasswordPage_form, "f").validator.form())
                return;
            const data = __classPrivateFieldGet(this, _RestorePasswordPage_form, "f").root.serializeArray();
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _RestorePasswordPage_options, "f").url,
                method: 'POST',
                data,
            });
            try {
                const response = yield xhr;
                __classPrivateFieldGet(this, _RestorePasswordPage_responseValidator, "f").process(response);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _RestorePasswordPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.RestorePasswordPage = RestorePasswordPage;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Базовый класс для мобильных страниц.
     *
     */
    class PageMobileBase extends App.PageBase {
        constructor(options = {}) {
            super(Object.assign({}, options));
            Object.defineProperty(this, "onFilterChangedEvent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.onFilterChangedEvent = v => this.onFilterChanged(v);
            // слушаем изменения фильтров
            PwStore.AddListener(this); // => onCommit
        }
        onCommit(eventName, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (eventName == 'filters/updated') {
                    // NOTE: не слушаем изменения кодом (предполагается, если кодом меняем значения, то и обработаем там же)
                    // no-op
                }
                else if (eventName == 'filters/changed') {
                    // произошли изменения пользователем
                    yield this.onFilterChangedEvent(payload); // => onFilterChanged
                }
                else if (eventName == 'filters/changeFilter') {
                    // no-op
                }
            });
        }
        /**
         * Произошли изменения в фильтрах (выбрали что-то) пользователем (не кодом).
         * Выполняем автопоиск, либо обновляем зависимые фильтры (например, при смене страны обновляем список городов в фильтре).
         * Возможно еще слушать аналогичное событие непосредственно от фильтров FiltersMobileBase, либо тут, на всю страницу.
         * @param filterName
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                // console.log('--- PageMobileBase смена фильтра: "' + filterName + '" ---');
                /*
                --- Примеры обработки ---
                if (filterName == PwStore.FILTER_ALL) {
                    console.log('Выполнили сброс всех фильтров');
    
                } else if (filterName == 'hotelFeatures') {
                    const v = PwStore.GetFilterItems<PwStore.IFilterSelectListValue>('hotelFeatures', false);
                    console.log('Выбрали особенности отеля: ' + v.map(item => item.label).join(', '));
    
                } else if (filterName == 'dateFrom') {
                    const v = PwStore.GetFilter<Date>('dateFrom');
                    console.log('Выбрали дату: ' + v.toString());
                }
                */
            });
        }
        /**
         * Получение текущего значения от контрола.
         * NOTE: Если котрол содержит перечисления, то будет получен весь список (и не выбранные),
         * в таком случае следует применять или getControlItemValues.
         * @param filterName
         * @returns
         */
        getControlValue(filterName) {
            return PwStore.GetFilter(filterName);
        }
        /**
         * Получение текущего значения от контрола переключателя.
         * @param filterName
         * @returns
         */
        getControlToggle(filterName) {
            return PwStore.GetFilter(filterName);
        }
        /**
         * Получение текущего выбранного значения приведенной к строке.
         * @param filters
         * @param filterName
         * @returns
         */
        getControlValueString(filters, filterName) {
            return filters.getControlValueString(filterName);
        }
        /**
         * Получение текущего выбранного одного элемента из массива значений от контрола.
         * NOTE: если необходимо значение единственного переключателя (который может быть false),
         * то использовать либо getControlValue, либо getControlToggle.
         * @param filterName
         * @returns
         */
        getControlItemValue(filterName) {
            return PwStore.GetFilterItem(filterName, false);
        }
        /**
         * Отдает список выбранных фильтров.
         * NOTE: если контрол содержит одно значение (не список),
         * то использовать getControlValue.
         * @param filterName
         * @returns
         */
        getControlItemValues(filterName) {
            return PwStore.GetFilterItems(filterName, false);
        }
        /**
         * Отдает первый (должен быть и единственный) выбранный фильтр из списка.
         * @param filterName
         * @returns
         */
        getControlListItem(filterName) {
            return PwStore.GetFilterItem(filterName, false);
        }
        /**
         * Установка нового значения контролу.
         * Как правило, когда пришли новые данные и необходимо изменить начальное значение контролу.
         * NOTE: если контрол это список (isArray), то передавать в массиве значение (даже если оно одно).
         * @param filterName
         * @param value
         */
        setControlValue(filterName, value, triggerChange = true) {
            PwStore.ChangeFilter(filterName, value, triggerChange);
        }
    }
    App.PageMobileBase = PageMobileBase;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
/// <reference path='../common/PageBase.Mobile.ts' />
var App;
(function (App) {
    var _ActivityBookPageMobile_instances, _ActivityBookPageMobile_options, _ActivityBookPageMobile_bookDigest, _ActivityBookPageMobile_validator, _ActivityBookPageMobile_popup, _ActivityBookPageMobile_responseValidator, _ActivityBookPageMobile_pricePresenter, _ActivityBookPageMobile_bookingForm, _ActivityBookPageMobile_filters, _ActivityBookPageMobile_bookingBlock, _ActivityBookPageMobile_bookingTemplate, _ActivityBookPageMobile_agentBlackListComponent, _ActivityBookPageMobile_reactivate, _ActivityBookPageMobile_onBookFilterChanged, _ActivityBookPageMobile_onBookSend, _ActivityBookPageMobile_onBookingButtonClick, _ActivityBookPageMobile_booking;
    class ActivityBookPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-booking-block' }, options));
            _ActivityBookPageMobile_instances.add(this);
            _ActivityBookPageMobile_options.set(this, void 0);
            _ActivityBookPageMobile_bookDigest.set(this, void 0);
            // #form: Form;
            _ActivityBookPageMobile_validator.set(this, void 0);
            _ActivityBookPageMobile_popup.set(this, void 0);
            _ActivityBookPageMobile_responseValidator.set(this, void 0);
            _ActivityBookPageMobile_pricePresenter.set(this, void 0);
            _ActivityBookPageMobile_bookingForm.set(this, void 0);
            _ActivityBookPageMobile_filters.set(this, void 0);
            _ActivityBookPageMobile_bookingBlock.set(this, void 0);
            _ActivityBookPageMobile_bookingTemplate.set(this, void 0);
            _ActivityBookPageMobile_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _ActivityBookPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _ActivityBookPageMobile_bookingBlock, $('.js-activity-booking-block'), "f");
            __classPrivateFieldSet(this, _ActivityBookPageMobile_bookingTemplate, App.templates.Activity.BookingForm_Mobile, "f");
            __classPrivateFieldSet(this, _ActivityBookPageMobile_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
        }
        /**
         * Отрисовывает бронирование
         * @param activityVariant вариант для бронирования
         * @param activityOffer само предложение по экскурсии
         * @param context - контекст (номер заказа)
         */
        renderBookingSection(activityVariant, activityOffer, context, allowBooking, existingPassengers) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const bookingActivityVariant = activityVariant;
                if (__classPrivateFieldGet(this, _ActivityBookPageMobile_bookingTemplate, "f") != null) {
                    // TODO: из-за сложностей с обработкой дат в JS пока не делаю ограничения на даты в датапикере. Пихаю в поля min и max строкой
                    bookingActivityVariant.adults = new Array();
                    for (let i = 0; activityVariant.adultCount > i; i++) {
                        bookingActivityVariant.adults.push(new App.BookingTouristMobile(
                        // первым должен быть взрослый, все остальные могут быть кем угодно.
                        i === 0 ? __classPrivateFieldGet(this, _ActivityBookPageMobile_options, "f").minAdultAge : 0, __classPrivateFieldGet(this, _ActivityBookPageMobile_options, "f").maxAdultAge, App.parseIsoDate(activityVariant.beginDate), existingPassengers));
                    }
                    bookingActivityVariant.children = new Array();
                    if (activityVariant.childAges) {
                        activityVariant.childAges.forEach(childAge => {
                            bookingActivityVariant.children.push(new App.BookingChildMobile(__classPrivateFieldGet(this, _ActivityBookPageMobile_options, "f").minChildAge, __classPrivateFieldGet(this, _ActivityBookPageMobile_options, "f").maxChildAge, App.parseIsoDate(activityVariant.beginDate), childAge, existingPassengers));
                        });
                    }
                    const bookingData = {
                        variant: activityVariant, // NOTE: разве не bookingActivityVariant должно быть?
                        activityOffer,
                        context: context ? { number: context } : undefined,
                        ticketsNotIncluded: activityOffer.ticketsNotIncluded,
                        allowBooking,
                        // Для BookDigestFooter
                        servicePrices: [],
                        netPrice: activityVariant.netPrice,
                        grossPrice: activityVariant.grossPrice,
                        discount: activityVariant.grossPrice - ((_a = activityVariant.price) !== null && _a !== void 0 ? _a : activityVariant.grossPrice),
                        price: (_b = activityVariant.price) !== null && _b !== void 0 ? _b : activityVariant.grossPrice,
                        currencyCode: activityVariant.currencyCode,
                        hasDetails: false,
                        pricePresenter: {
                            type: __classPrivateFieldGet(this, _ActivityBookPageMobile_pricePresenter, "f").type,
                            show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                        },
                        notes: [],
                    };
                    const content = $(__classPrivateFieldGet(this, _ActivityBookPageMobile_bookingTemplate, "f").call(this, bookingData));
                    __classPrivateFieldGet(this, _ActivityBookPageMobile_bookingBlock, "f").empty();
                    __classPrivateFieldGet(this, _ActivityBookPageMobile_bookingBlock, "f").append(content);
                    yield __classPrivateFieldGet(this, _ActivityBookPageMobile_instances, "m", _ActivityBookPageMobile_reactivate).call(this, bookingData, bookingData.allowBooking);
                }
            });
        }
        /**
         * открывает блок бронирования
         */
        pageOpen() {
            __classPrivateFieldGet(this, _ActivityBookPageMobile_bookingBlock, "f").showByClass();
        }
        /**
         * скрывает блок бронирования
         */
        pageClose() {
            __classPrivateFieldGet(this, _ActivityBookPageMobile_bookingBlock, "f").hideByClass();
        }
        /**
         * Прокрутка страницы к результатам
         */
        scrollToOutputBlock() {
            // инит блока здесь, т.к. в момент инициализации страницы элемента еще нет, он появляется при отрисовке данных
            const scrollToBlock = $('.js-room-booking', __classPrivateFieldGet(this, _ActivityBookPageMobile_bookingBlock, "f"));
            if (scrollToBlock) {
                const scrollOffset = scrollToBlock.offset();
                if (scrollOffset)
                    window.scrollTo(scrollOffset.left, scrollOffset.top);
            }
        }
    }
    _ActivityBookPageMobile_options = new WeakMap(), _ActivityBookPageMobile_bookDigest = new WeakMap(), _ActivityBookPageMobile_validator = new WeakMap(), _ActivityBookPageMobile_popup = new WeakMap(), _ActivityBookPageMobile_responseValidator = new WeakMap(), _ActivityBookPageMobile_pricePresenter = new WeakMap(), _ActivityBookPageMobile_bookingForm = new WeakMap(), _ActivityBookPageMobile_filters = new WeakMap(), _ActivityBookPageMobile_bookingBlock = new WeakMap(), _ActivityBookPageMobile_bookingTemplate = new WeakMap(), _ActivityBookPageMobile_agentBlackListComponent = new WeakMap(), _ActivityBookPageMobile_instances = new WeakSet(), _ActivityBookPageMobile_reactivate = function _ActivityBookPageMobile_reactivate(digestData, allowBooking) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _ActivityBookPageMobile_bookingForm, $('form', this.root), "f");
            __classPrivateFieldGet(this, _ActivityBookPageMobile_bookingForm, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityBookPageMobile_instances, "m", _ActivityBookPageMobile_onBookingButtonClick).call(this, e); }));
            // Дайджест
            // this.components.push(new Digest({ container: this.root }));
            __classPrivateFieldSet(this, _ActivityBookPageMobile_bookDigest, new App.DigestMobile({
                buttonTitle: 'Забронировать',
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _ActivityBookPageMobile_instances, "m", _ActivityBookPageMobile_onBookSend).call(this),
                allowBooking: allowBooking,
            }), "f");
            __classPrivateFieldGet(this, _ActivityBookPageMobile_bookDigest, "f").empty();
            const digestContent = $(App.templates.Activity.BookDigest_Content_Mobile(digestData));
            const digestFloater = $(App.templates.Activity.BookDigest_Floater_Mobile(digestData));
            yield __classPrivateFieldGet(this, _ActivityBookPageMobile_bookDigest, "f").setContent(digestContent);
            __classPrivateFieldGet(this, _ActivityBookPageMobile_bookDigest, "f").setFloater(digestFloater);
            // this.components.push(new ExistingPassengersMobile());
            // this.components.push(new FindTouristMobile());
            App.ExistingPassengersMobile.Creates();
            App.FindTouristMobile.Creates();
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _ActivityBookPageMobile_agentBlackListComponent, new App.AgentBlackListMobile({ useForm: true }), "f");
                this.components.push(__classPrivateFieldGet(this, _ActivityBookPageMobile_agentBlackListComponent, "f"));
            }
            // const filter = new Filter({ root: this.#bookingForm });
            const filter = new App.FilterMobile({
                root: __classPrivateFieldGet(this, _ActivityBookPageMobile_bookingForm, "f"),
                onFilterChanged: () => __classPrivateFieldGet(this, _ActivityBookPageMobile_instances, "m", _ActivityBookPageMobile_onBookFilterChanged).call(this),
            });
            __classPrivateFieldSet(this, _ActivityBookPageMobile_validator, filter.validator, "f");
            __classPrivateFieldSet(this, _ActivityBookPageMobile_filters, filter.filters, "f");
            // this.#form = new Form({ root: filter.root });
            __classPrivateFieldSet(this, _ActivityBookPageMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _ActivityBookPageMobile_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _ActivityBookPageMobile_popup, "f")),
                validator: filter.validator, // this.#form.validator,
            }), "f");
        });
    }, _ActivityBookPageMobile_onBookFilterChanged = function _ActivityBookPageMobile_onBookFilterChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            // no-op
        });
    }, _ActivityBookPageMobile_onBookSend = function _ActivityBookPageMobile_onBookSend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _ActivityBookPageMobile_bookDigest, "f"))
                __classPrivateFieldGet(this, _ActivityBookPageMobile_bookDigest, "f").close();
            $('.js-booking-submit').trigger('click');
        });
    }, _ActivityBookPageMobile_onBookingButtonClick = function _ActivityBookPageMobile_onBookingButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _ActivityBookPageMobile_validator, "f").form())
                return;
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _ActivityBookPageMobile_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityBookPageMobile_instances, "m", _ActivityBookPageMobile_booking).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _ActivityBookPageMobile_instances, "m", _ActivityBookPageMobile_booking).call(this);
            }
        });
    }, _ActivityBookPageMobile_booking = function _ActivityBookPageMobile_booking() {
        return __awaiter(this, void 0, void 0, function* () {
            // const formData = this.#bookingForm.find('input').serialize();
            // ?? const formData = this.#filters.serializeArray();
            const formData = __classPrivateFieldGet(this, _ActivityBookPageMobile_filters, "f").serialize();
            const xhr = $.ajax({
                url: App.app.url.route(App.ActivityPageUrls.Book),
                method: 'POST',
                dataType: 'json',
                data: formData,
            });
            const popupGroup = __classPrivateFieldGet(this, _ActivityBookPageMobile_popup, "f").show({
                group: 'main',
                content: App.templates.Activity.Popups.Booking({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _ActivityBookPageMobile_responseValidator, "f").process(response))
                    return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ActivityBookPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _ActivityBookPageMobile_popup, "f").hide(popupGroup);
            }
        });
    };
    App.ActivityBookPageMobile = ActivityBookPageMobile;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _ActivityBookPage_instances, _ActivityBookPage_options, _ActivityBookPage_form, _ActivityBookPage_popup, _ActivityBookPage_responseValidator, _ActivityBookPage_pricePresenter, _ActivityBookPage_bookingForm, _ActivityBookPage_bookingBlock, _ActivityBookPage_bookingTemplate, _ActivityBookPage_agentBlackListComponent, _ActivityBookPage_reactivate, _ActivityBookPage_onBookingButtonClick, _ActivityBookPage_booking;
    class ActivityBookPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-booking-block' }, options));
            _ActivityBookPage_instances.add(this);
            _ActivityBookPage_options.set(this, void 0);
            _ActivityBookPage_form.set(this, void 0);
            _ActivityBookPage_popup.set(this, void 0);
            _ActivityBookPage_responseValidator.set(this, void 0);
            _ActivityBookPage_pricePresenter.set(this, void 0);
            _ActivityBookPage_bookingForm.set(this, void 0);
            _ActivityBookPage_bookingBlock.set(this, void 0);
            _ActivityBookPage_bookingTemplate.set(this, void 0);
            _ActivityBookPage_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _ActivityBookPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _ActivityBookPage_bookingBlock, $('.js-activity-booking-block'), "f");
            __classPrivateFieldSet(this, _ActivityBookPage_bookingTemplate, App.templates.Activity.BookingForm, "f");
            __classPrivateFieldSet(this, _ActivityBookPage_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
        }
        /**
         * Отрисовывает бронирование
         * @param activityVariant вариант для бронирования
         * @param activityOffer само предложение по экскурсии
         * @param context - контекст (номер заказа)
         */
        renderBookingSection(activityVariant, activityOffer, context, allowBooking, existingPassengers) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const bookingActivityVariant = activityVariant;
                if (__classPrivateFieldGet(this, _ActivityBookPage_bookingTemplate, "f") != null) {
                    // TODO: из-за сложностей с обработкой дат в JS пока не делаю ограничения на даты в датапикере. Пихаю в поля min и max строкой
                    bookingActivityVariant.adults = new Array();
                    for (let i = 0; activityVariant.adultCount > i; i++) {
                        bookingActivityVariant.adults.push(new App.BookingTourist(
                        // первым должен быть взрослый, все остальные могут быть кем угодно.
                        i === 0 ? __classPrivateFieldGet(this, _ActivityBookPage_options, "f").minAdultAge : 0, __classPrivateFieldGet(this, _ActivityBookPage_options, "f").maxAdultAge, App.parseIsoDate(activityVariant.beginDate), existingPassengers));
                    }
                    bookingActivityVariant.children = new Array();
                    if (activityVariant.childAges) {
                        activityVariant.childAges.forEach(childAge => {
                            bookingActivityVariant.children.push(new App.BookingChild(__classPrivateFieldGet(this, _ActivityBookPage_options, "f").minChildAge, __classPrivateFieldGet(this, _ActivityBookPage_options, "f").maxChildAge, App.parseIsoDate(activityVariant.beginDate), childAge, existingPassengers));
                        });
                    }
                    const bookingData = {
                        variant: activityVariant,
                        activityOffer,
                        context: context ? { number: context } : undefined,
                        ticketsNotIncluded: activityOffer.ticketsNotIncluded,
                        allowBooking,
                        // Для BookDigestFooter
                        servicePrices: [],
                        netPrice: activityVariant.netPrice,
                        grossPrice: activityVariant.grossPrice,
                        discount: activityVariant.grossPrice - ((_a = activityVariant.price) !== null && _a !== void 0 ? _a : activityVariant.grossPrice),
                        price: (_b = activityVariant.price) !== null && _b !== void 0 ? _b : activityVariant.grossPrice,
                        currencyCode: activityVariant.currencyCode,
                        hasDetails: false,
                        pricePresenter: {
                            type: __classPrivateFieldGet(this, _ActivityBookPage_pricePresenter, "f").type,
                            show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                        },
                        notes: [],
                    };
                    const content = $(__classPrivateFieldGet(this, _ActivityBookPage_bookingTemplate, "f").call(this, bookingData));
                    __classPrivateFieldGet(this, _ActivityBookPage_bookingBlock, "f").empty();
                    __classPrivateFieldGet(this, _ActivityBookPage_bookingBlock, "f").append(content);
                    __classPrivateFieldGet(this, _ActivityBookPage_instances, "m", _ActivityBookPage_reactivate).call(this);
                }
            });
        }
        /**
         * открывает блок бронирования
         */
        pageOpen() {
            __classPrivateFieldGet(this, _ActivityBookPage_bookingBlock, "f").showByClass();
        }
        /**
         * скрывает блок бронирования
         */
        pageClose() {
            __classPrivateFieldGet(this, _ActivityBookPage_bookingBlock, "f").hideByClass();
        }
        /**
         * Прокрутка страницы к результатам
         */
        scrollToOutputBlock() {
            // инит блока здесь, т.к. в момент инициализации страницы элемента еще нет, он появляется при отрисовке данных
            const scrollToBlock = $('.js-room-booking', __classPrivateFieldGet(this, _ActivityBookPage_bookingBlock, "f"));
            if (scrollToBlock) {
                const scrollOffset = scrollToBlock.offset();
                if (scrollOffset)
                    window.scrollTo(scrollOffset.left, scrollOffset.top);
            }
        }
    }
    _ActivityBookPage_options = new WeakMap(), _ActivityBookPage_form = new WeakMap(), _ActivityBookPage_popup = new WeakMap(), _ActivityBookPage_responseValidator = new WeakMap(), _ActivityBookPage_pricePresenter = new WeakMap(), _ActivityBookPage_bookingForm = new WeakMap(), _ActivityBookPage_bookingBlock = new WeakMap(), _ActivityBookPage_bookingTemplate = new WeakMap(), _ActivityBookPage_agentBlackListComponent = new WeakMap(), _ActivityBookPage_instances = new WeakSet(), _ActivityBookPage_reactivate = function _ActivityBookPage_reactivate() {
        __classPrivateFieldSet(this, _ActivityBookPage_bookingForm, $('form', this.root), "f");
        __classPrivateFieldGet(this, _ActivityBookPage_bookingForm, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityBookPage_instances, "m", _ActivityBookPage_onBookingButtonClick).call(this, e); }));
        // Дайджест
        this.components.push(new App.Digest({ container: this.root }));
        // Переключение пола М/Ж
        $('.js-form-gender', this.root).each((index, element) => {
            const icon = $('.js-form-gender-icon', element);
            const input = $('.js-form-gender-input', element);
            input.on('change', event => {
                // Чтобы в MVC контроллере пришло в виде перечисления полов, надо, чтобы value у радиобатонов полов были male и
                // female (в шаблоне)
                icon.toggleClass('_man', $(event.target).is(':checked') && $(event.target).val() === 'Male');
                icon.toggleClass('_woman', $(event.target).is(':checked') && $(event.target).val() === 'Female');
            }).filter(':checked').trigger('change');
        });
        // Инициализация дат рождения
        // TODO: пересекается с инитом датапикера в Filter. Оставила этот метод, т.к. здесь делается возможность выбора месяца и года
        const currentYear = new Date().getFullYear();
        // Человеком, который прожил самую долгую жизнь, считается француженка Жанна Кальман. Она успела отметить свой 122 день
        // рождения прежде, чем отошла в мир иной.
        const minYear = currentYear - 125;
        $('.js-form-date', this.root).each((index, element) => {
            const el = $(element);
            el
                .attr('autocomplete', 'off')
                .inputmask('date');
            el.datepicker({
                constrainInput: true,
                yearRange: `${minYear}:${currentYear}`,
            });
        });
        // Инициализация полей, содержащих данные ФИО:
        $('.js-form-fio', this.root).on('change', e => {
            const target = $(e.currentTarget);
            target.val(App.transliterateName(target.valString()));
        });
        this.components.push(new App.ExistingPassengers(), new App.FindTourist());
        if (App.app.userSettings.isAgentInBlackList) {
            __classPrivateFieldSet(this, _ActivityBookPage_agentBlackListComponent, new App.AgentBlackListComponent({ useForm: true }), "f");
            this.components.push(__classPrivateFieldGet(this, _ActivityBookPage_agentBlackListComponent, "f"));
        }
        const filter = new App.Filter({ root: __classPrivateFieldGet(this, _ActivityBookPage_bookingForm, "f") });
        __classPrivateFieldSet(this, _ActivityBookPage_form, new App.Form({ root: filter.root }), "f");
        __classPrivateFieldSet(this, _ActivityBookPage_popup, new App.Popup(), "f");
        __classPrivateFieldSet(this, _ActivityBookPage_responseValidator, new App.ResponseValidatorOld({
            messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _ActivityBookPage_popup, "f")),
            validator: __classPrivateFieldGet(this, _ActivityBookPage_form, "f").validator,
        }), "f");
    }, _ActivityBookPage_onBookingButtonClick = function _ActivityBookPage_onBookingButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _ActivityBookPage_form, "f").validator.form())
                return;
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _ActivityBookPage_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityBookPage_instances, "m", _ActivityBookPage_booking).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _ActivityBookPage_instances, "m", _ActivityBookPage_booking).call(this);
            }
        });
    }, _ActivityBookPage_booking = function _ActivityBookPage_booking() {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = __classPrivateFieldGet(this, _ActivityBookPage_bookingForm, "f").find('input').serialize();
            const xhr = $.ajax({
                url: App.app.url.route(App.ActivityPageUrls.Book),
                method: 'POST',
                dataType: 'json',
                data: formData,
            });
            const popupGroup = __classPrivateFieldGet(this, _ActivityBookPage_popup, "f").show({
                group: 'main',
                content: App.templates.Activity.Popups.Booking({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _ActivityBookPage_responseValidator, "f").process(response))
                    return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ActivityBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _ActivityBookPage_popup, "f").hide(popupGroup);
            }
        });
    };
    App.ActivityBookPage = ActivityBookPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ActivityDetailPageMobile_instances, _a, _ActivityDetailPageMobile_detailFilters, _ActivityDetailPageMobile_tabsBlock, _ActivityDetailPageMobile_shortDescriptionBlock, _ActivityDetailPageMobile_errorPlace, _ActivityDetailPageMobile_detailsBlock, _ActivityDetailPageMobile_leftColumn, _ActivityDetailPageMobile_landmarkLink, _ActivityDetailPageMobile_bookScrollToWrap, _ActivityDetailPageMobile_mapButton, _ActivityDetailPageMobile_onSearchButtonClick, _ActivityDetailPageMobile_onLandmarkClick, _ActivityDetailPageMobile_onScrollLinkClick, _ActivityDetailPageMobile_setBookingPosition;
    class ActivityDetailPageMobile extends App.PageBase {
        // #form: Form;
        constructor(options) {
            super(Object.assign({ root: '.js-activity-details-block' }, options));
            _ActivityDetailPageMobile_instances.add(this);
            _ActivityDetailPageMobile_detailFilters.set(this, void 0);
            Object.defineProperty(this, "detailsSliderBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // По умолчанию прокручивается на блок с картинками. Можно переустановить в специальном методе
            Object.defineProperty(this, "scrollToBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "scrollBookLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "detailFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "resultOutputBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ActivityDetailPageMobile_tabsBlock.set(this, void 0);
            _ActivityDetailPageMobile_shortDescriptionBlock.set(this, void 0);
            _ActivityDetailPageMobile_errorPlace.set(this, void 0);
            _ActivityDetailPageMobile_detailsBlock.set(this, void 0);
            _ActivityDetailPageMobile_leftColumn.set(this, void 0);
            Object.defineProperty(this, "descriptionBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #searchButton: JQuery;
            _ActivityDetailPageMobile_landmarkLink.set(this, void 0);
            _ActivityDetailPageMobile_bookScrollToWrap.set(this, void 0);
            _ActivityDetailPageMobile_mapButton.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_detailFilters, options.detailFilters, "f");
            // инициализация элементов
            this.detailFilter = $('.js-activity-detail-filter', this.root);
            this.detailsSliderBlock = $('.tour-slider-and-info-block', this.root);
            this.scrollToBlock = this.detailsSliderBlock;
            this.scrollBookLink = $('.js-scroll-book-link', this.root);
            this.resultOutputBlock = $('.js-output-block', this.root);
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_detailsBlock, $('.js-activity-details-block'), "f");
            this.descriptionBlock = $('.js-description-block', this.root);
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_shortDescriptionBlock, $('.js-short-description-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_errorPlace, $('.js-error-place', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_tabsBlock, $('.js-tabs-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_leftColumn, $('.js-digest-fx', this.root), "f");
            // this.#searchButton = $('.js-m-filter-submit', this.detailFilter);
            this.detailsSliderBlock = $('.tour-slider-and-info-block', this.root);
            this.scrollToBlock = this.detailsSliderBlock;
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_bookScrollToWrap, $('.js-book-to-scroll', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_mapButton, $('.js-showMap', this.root), "f");
            this.scrollLinkShow();
            // this.components.push(new Digest({ container: this.root }));
            this.components.push(new App.PrintComponent({
                modes: {
                    'text': 'Программа без картинок',
                    'image': 'Программа с картинками',
                    'default': 'Страница целиком',
                },
            }));
            // this.#form = new Form({ root: this.detailFilter });
            // события
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом - выбираем из выпадающего списка стрелками и Enter. потом жмем Enter - и ничего. Возможно из-за того, что перемудрили с контролами
            this.detailFilter.on('submit', e => __classPrivateFieldGet(this, _ActivityDetailPageMobile_instances, "m", _ActivityDetailPageMobile_onSearchButtonClick).call(this, e));
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _ActivityDetailPageMobile_instances, "m", _ActivityDetailPageMobile_setBookingPosition).call(this)));
            this.scrollBookLink.on('click', () => __classPrivateFieldGet(this, _ActivityDetailPageMobile_instances, "m", _ActivityDetailPageMobile_onScrollLinkClick).call(this));
        }
        getMapButton() {
            return __classPrivateFieldGet(this, _ActivityDetailPageMobile_mapButton, "f");
        }
        getErrorPlace() {
            return __classPrivateFieldGet(this, _ActivityDetailPageMobile_errorPlace, "f");
        }
        getDetailBlock() {
            return __classPrivateFieldGet(this, _ActivityDetailPageMobile_detailsBlock, "f");
        }
        /**
         * Показать блок с табами
         */
        showTabsBlocks() {
            __classPrivateFieldGet(this, _ActivityDetailPageMobile_tabsBlock, "f").showByClass();
        }
        /**
         * Скрыть блок с табами
         */
        hideTabsBlocks() {
            __classPrivateFieldGet(this, _ActivityDetailPageMobile_tabsBlock, "f").hideByClass();
        }
        /**
         * Показать блок слева
         */
        showLeftColumn() {
            __classPrivateFieldGet(this, _ActivityDetailPageMobile_leftColumn, "f").showByClass();
        }
        /**
         * Скрыть блок с табами
         */
        hideLeftColumn() {
            __classPrivateFieldGet(this, _ActivityDetailPageMobile_leftColumn, "f").hideByClass();
        }
        /**
         * Переустанавливает элемент, на который прокручивать при отображении старницы.
         * ть значение по умолчанию
         * @param element
         */
        setScrollToBlock(element) {
            this.scrollToBlock = element;
        }
        /**
         * Прокрутка страницы к результатам
         */
        scrollToOutputBlock() {
            const scrollOffset = this.scrollToBlock.offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
        /**
         * Полностью открывает блок страницы
         */
        pageOpen() {
            __classPrivateFieldGet(this, _ActivityDetailPageMobile_detailsBlock, "f").showByClass();
            this.detailFilter.show();
            this.scrollLinkShow();
            this.showTabsBlocks();
            this.showLeftColumn();
        }
        /**
         * скрывает блок страницы
         */
        pageClose() {
            __classPrivateFieldGet(this, _ActivityDetailPageMobile_detailsBlock, "f").hideByClass();
        }
        /**
         * Отрисовывает часть с инфой и картинкой
         * @param item - элемент для отрисовки (вообще, экскурсия или достопримечательность. any - говнокод)
         */
        renderInfo(activity) {
            var _b, _c;
            const content = $(App.templates.Activity.DetailInfo_Mobile(activity));
            this.detailsSliderBlock.empty();
            this.detailsSliderBlock.append(content);
            // Инициализируем
            this.pageOpen();
            this.components.push(new App.MediaGalleryMobile());
            // соц сети
            (_c = (_b = window.pac) === null || _b === void 0 ? void 0 : _b.api) === null || _c === void 0 ? void 0 : _c.SocialLikes();
            // Инициализируем клик на ссылку с достопримечательностью
            __classPrivateFieldSet(this, _ActivityDetailPageMobile_landmarkLink, $('.js-landmark', this.root), "f");
            __classPrivateFieldGet(this, _ActivityDetailPageMobile_landmarkLink, "f").on('click', e => __classPrivateFieldGet(_a, _a, "m", _ActivityDetailPageMobile_onLandmarkClick).call(_a, e));
        }
        renderDescription(description, shortDescription) {
            if (description)
                this.descriptionBlock.html(description).show();
            else
                this.descriptionBlock.html('').hide();
            if (shortDescription)
                __classPrivateFieldGet(this, _ActivityDetailPageMobile_shortDescriptionBlock, "f").html(shortDescription).show();
            else
                __classPrivateFieldGet(this, _ActivityDetailPageMobile_shortDescriptionBlock, "f").html('').hide();
        }
        // getSearchButton(): JQuery {
        //   return this.#searchButton;
        // }
        getSearchElement() {
            // return this.#searchButton;
            return this.root;
        }
        // getDetailFilter(): JQuery {
        //   return this.detailFilter;
        // }
        getDetailValidator() {
            return __classPrivateFieldGet(this, _ActivityDetailPageMobile_detailFilters, "f").validator;
        }
        /**
         * Возвращает ссылки на достопримечательности,
         * но они инициализированы только после того, как отрисовалась инфа об экскурсии
         */
        getLandmarkLink() {
            return __classPrivateFieldGet(this, _ActivityDetailPageMobile_landmarkLink, "f");
        }
        filterSerializeArray() {
            // return this.detailFilter.find('input').serializeArray();
            if (!__classPrivateFieldGet(this, _ActivityDetailPageMobile_detailFilters, "f"))
                return [];
            return __classPrivateFieldGet(this, _ActivityDetailPageMobile_detailFilters, "f").filters.serializeArray();
        }
        renderTicketsNotIncluded() {
            const content = $(App.templates.TicketsNotIncluded({})); // TODO: to mobile?
            this.descriptionBlock.prepend(content);
        }
        /** Скрывает форму поиска */
        hideSearchForm() {
            this.detailFilter.hide();
            this.hideTabsBlocks();
            this.hideLeftColumn();
        }
        /** Показать (или нет) кнопку 'К бронированию' */
        scrollLinkShow() {
            if ((this.resultOutputBlock.height() || 0) > 0)
                this.scrollBookLink.show();
            else
                this.scrollBookLink.hide();
        }
    }
    _a = ActivityDetailPageMobile, _ActivityDetailPageMobile_detailFilters = new WeakMap(), _ActivityDetailPageMobile_tabsBlock = new WeakMap(), _ActivityDetailPageMobile_shortDescriptionBlock = new WeakMap(), _ActivityDetailPageMobile_errorPlace = new WeakMap(), _ActivityDetailPageMobile_detailsBlock = new WeakMap(), _ActivityDetailPageMobile_leftColumn = new WeakMap(), _ActivityDetailPageMobile_landmarkLink = new WeakMap(), _ActivityDetailPageMobile_bookScrollToWrap = new WeakMap(), _ActivityDetailPageMobile_mapButton = new WeakMap(), _ActivityDetailPageMobile_instances = new WeakSet(), _ActivityDetailPageMobile_onSearchButtonClick = function _ActivityDetailPageMobile_onSearchButtonClick(event) {
        event.preventDefault();
        // if (!this.#form.validator.form())
        // return;
        if (__classPrivateFieldGet(this, _ActivityDetailPageMobile_detailFilters, "f") && !__classPrivateFieldGet(this, _ActivityDetailPageMobile_detailFilters, "f").validator.form())
            return;
        // this.#searchButton.trigger(Events.DetailSearchButtonClick);
        this.getSearchElement().trigger("detailSearchButton:click" /* Events.DetailSearchButtonClick */);
    }, _ActivityDetailPageMobile_onLandmarkClick = function _ActivityDetailPageMobile_onLandmarkClick(event) {
        event.preventDefault();
        $(event.currentTarget).trigger("landmark:click" /* Events.LandmarkClick */);
    }, _ActivityDetailPageMobile_onScrollLinkClick = function _ActivityDetailPageMobile_onScrollLinkClick() {
        // TODO: дублирование кода - есть в классе TourProgrammPage.ts
        const dest = this.resultOutputBlock;
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += (App.app.container.scrollTop() || 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    }, _ActivityDetailPageMobile_setBookingPosition = function _ActivityDetailPageMobile_setBookingPosition() {
        // TODO: https://jquery.com/upgrade-guide/3.0/#breaking-change-outerwidth-or-outerheight-on-window-includes-scrollbar-width-height
        const scrolledPos = ($(window).scrollTop() || 0) + ($(window).outerHeight() || 0);
        const offset = __classPrivateFieldGet(this, _ActivityDetailPageMobile_bookScrollToWrap, "f").offset();
        const offsetTop = (offset != null ? offset.top : 0);
        if (scrolledPos >= offsetTop && scrolledPos < offsetTop + (__classPrivateFieldGet(this, _ActivityDetailPageMobile_bookScrollToWrap, "f").outerHeight() || 0))
            this.scrollBookLink.addClass('_fixed_book');
        else
            this.scrollBookLink.removeClass('_fixed_book');
    };
    App.ActivityDetailPageMobile = ActivityDetailPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _ActivityDetailPage_instances, _a, _ActivityDetailPage_tabsBlock, _ActivityDetailPage_shortDescriptionBlock, _ActivityDetailPage_errorPlace, _ActivityDetailPage_detailsBlock, _ActivityDetailPage_leftColumn, _ActivityDetailPage_searchButton, _ActivityDetailPage_landmarkLink, _ActivityDetailPage_bookScrollToWrap, _ActivityDetailPage_mapButton, _ActivityDetailPage_hideMapButton, _ActivityDetailPage_form, _ActivityDetailPage_onSearchButtonClick, _ActivityDetailPage_onLandmarkClick, _ActivityDetailPage_onScrollLinkClick, _ActivityDetailPage_setBookingPosition;
    class ActivityDetailPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-details-block' }, options));
            _ActivityDetailPage_instances.add(this);
            Object.defineProperty(this, "detailsSliderBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // По умолчанию прокручивается на блок с картинками. Можно переустановить в специальном методе
            Object.defineProperty(this, "scrollToBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "scrollBookLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "detailFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "resultOutputBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ActivityDetailPage_tabsBlock.set(this, void 0);
            _ActivityDetailPage_shortDescriptionBlock.set(this, void 0);
            _ActivityDetailPage_errorPlace.set(this, void 0);
            _ActivityDetailPage_detailsBlock.set(this, void 0);
            _ActivityDetailPage_leftColumn.set(this, void 0);
            Object.defineProperty(this, "descriptionBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ActivityDetailPage_searchButton.set(this, void 0);
            _ActivityDetailPage_landmarkLink.set(this, void 0);
            _ActivityDetailPage_bookScrollToWrap.set(this, void 0);
            _ActivityDetailPage_mapButton.set(this, void 0);
            _ActivityDetailPage_hideMapButton.set(this, void 0);
            _ActivityDetailPage_form.set(this, void 0);
            if (!this.root.length)
                return;
            // инициализация элементов
            this.detailFilter = $('.js-activity-detail-filter', this.root);
            this.detailsSliderBlock = $('.tour-slider-and-info-block', this.root);
            this.scrollToBlock = this.detailsSliderBlock;
            this.scrollBookLink = $('.js-scroll-book-link', this.root);
            this.resultOutputBlock = $('.js-output-block', this.root);
            __classPrivateFieldSet(this, _ActivityDetailPage_detailsBlock, $('.js-activity-details-block'), "f");
            this.descriptionBlock = $('.js-description-block', this.root);
            __classPrivateFieldSet(this, _ActivityDetailPage_shortDescriptionBlock, $('.js-short-description-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPage_errorPlace, $('.js-error-place', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPage_tabsBlock, $('.js-tabs-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPage_leftColumn, $('.js-digest-fx', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPage_searchButton, $('.js-m-filter-submit', this.detailFilter), "f");
            this.detailsSliderBlock = $('.tour-slider-and-info-block', this.root);
            this.scrollToBlock = this.detailsSliderBlock;
            __classPrivateFieldSet(this, _ActivityDetailPage_bookScrollToWrap, $('.js-book-to-scroll', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPage_mapButton, $('.js-showMap', this.root), "f");
            __classPrivateFieldSet(this, _ActivityDetailPage_hideMapButton, $('.js-hideMap', this.root), "f");
            this.scrollLinkShow();
            this.components.push(new App.Digest({ container: this.root }));
            this.components.push(new App.PrintComponent({
                modes: {
                    'text': 'Программа без картинок',
                    'image': 'Программа с картинками',
                    'default': 'Страница целиком',
                },
            }));
            __classPrivateFieldSet(this, _ActivityDetailPage_form, new App.Form({ root: this.detailFilter }), "f");
            // события
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом - выбираем из выпадающего списка стрелками и Enter. потом жмем Enter - и ничего. Возможно из-за того, что перемудрили с контролами
            this.detailFilter.on('submit', e => __classPrivateFieldGet(this, _ActivityDetailPage_instances, "m", _ActivityDetailPage_onSearchButtonClick).call(this, e));
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _ActivityDetailPage_instances, "m", _ActivityDetailPage_setBookingPosition).call(this)));
            this.scrollBookLink.on('click', () => __classPrivateFieldGet(this, _ActivityDetailPage_instances, "m", _ActivityDetailPage_onScrollLinkClick).call(this));
        }
        getMapButton() {
            return __classPrivateFieldGet(this, _ActivityDetailPage_mapButton, "f");
        }
        getHideMapButton() {
            return __classPrivateFieldGet(this, _ActivityDetailPage_hideMapButton, "f");
        }
        getErrorPlace() {
            return __classPrivateFieldGet(this, _ActivityDetailPage_errorPlace, "f");
        }
        getDetailBlock() {
            return __classPrivateFieldGet(this, _ActivityDetailPage_detailsBlock, "f");
        }
        /**
         * Показать блок с табами
         */
        showTabsBlocks() {
            __classPrivateFieldGet(this, _ActivityDetailPage_tabsBlock, "f").showByClass();
        }
        /**
         * Скрыть блок с табами
         */
        hideTabsBlocks() {
            __classPrivateFieldGet(this, _ActivityDetailPage_tabsBlock, "f").hideByClass();
        }
        /**
         * Показать блок слева
         */
        showLeftColumn() {
            __classPrivateFieldGet(this, _ActivityDetailPage_leftColumn, "f").showByClass();
            this.root.removeClass('single-column');
        }
        /**
         * Скрыть блок с табами
         */
        hideLeftColumn() {
            __classPrivateFieldGet(this, _ActivityDetailPage_leftColumn, "f").hideByClass();
            this.root.addClass('single-column');
        }
        /**
         * Переустанавливает элемент, на который прокручивать при отображении старницы.
         * ть значение по умолчанию
         * @param element
         */
        setScrollToBlock(element) {
            this.scrollToBlock = element;
        }
        /**
         * Прокрутка страницы к результатам
         */
        scrollToOutputBlock() {
            const scrollOffset = this.scrollToBlock.offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
        /**
         * Полностью открывает блок страницы
         */
        pageOpen() {
            __classPrivateFieldGet(this, _ActivityDetailPage_detailsBlock, "f").showByClass();
            this.detailFilter.show();
            this.scrollLinkShow();
            this.showTabsBlocks();
            this.showLeftColumn();
        }
        /**
         * скрывает блок страницы
         */
        pageClose() {
            __classPrivateFieldGet(this, _ActivityDetailPage_detailsBlock, "f").hideByClass();
        }
        /**
         * Отрисовывает часть с инфой и картинкой
         * @param item - элемент для отрисовки (вообще, экскурсия или достопримечательность. any - говнокод)
         */
        renderInfo(activity) {
            var _b, _c;
            const content = $(App.templates.Activity.DetailInfo(activity));
            this.detailsSliderBlock.empty();
            this.detailsSliderBlock.append(content);
            // Инициализируем слайдер тура с пейджером
            // TODO: пусть пока будет так - т.к. при ините слайдера блок скрыт (класс _hidden-2 (display:none)), slick глючит.
            // пробовала opacity: 0, height: 0px - все равно получается большой пустой блок внизу, когда блок info скрыт.
            // Поэтому, чтобы слайдер не инициализировался криво, перед инитом открывают страницу.
            this.pageOpen();
            this.components.push(new App.MediaGallery());
            // соц сети
            (_c = (_b = window.pac) === null || _b === void 0 ? void 0 : _b.api) === null || _c === void 0 ? void 0 : _c.SocialLikes();
            // Инициализируем клик на ссылку с достопримечательностью
            __classPrivateFieldSet(this, _ActivityDetailPage_landmarkLink, $('.js-landmark', this.root), "f");
            __classPrivateFieldGet(this, _ActivityDetailPage_landmarkLink, "f").on('click', e => __classPrivateFieldGet(_a, _a, "m", _ActivityDetailPage_onLandmarkClick).call(_a, e));
        }
        renderDescription(description, shortDescription) {
            if (description)
                this.descriptionBlock.html(description).show();
            else
                this.descriptionBlock.html('').hide();
            if (shortDescription)
                __classPrivateFieldGet(this, _ActivityDetailPage_shortDescriptionBlock, "f").html(shortDescription).show();
            else
                __classPrivateFieldGet(this, _ActivityDetailPage_shortDescriptionBlock, "f").html('').hide();
        }
        getSearchButton() {
            return __classPrivateFieldGet(this, _ActivityDetailPage_searchButton, "f");
        }
        getDetailFilter() {
            return this.detailFilter;
        }
        /**
         * Возвращает ссылки на достопримечательности,
         * но они инициализированы только после того, как отрисовалась инфа об экскурсии
         */
        getLandmarkLink() {
            return __classPrivateFieldGet(this, _ActivityDetailPage_landmarkLink, "f");
        }
        filterSerializeArray() {
            return this.detailFilter.find('input').serializeArray();
        }
        renderTicketsNotIncluded() {
            const content = $(App.templates.TicketsNotIncluded({}));
            this.descriptionBlock.prepend(content);
        }
        /** Скрывает форму поиска */
        hideSearchForm() {
            this.detailFilter.hide();
            this.hideTabsBlocks();
            this.hideLeftColumn();
        }
        /** Показать (или нет) кнопку 'К бронированию' */
        scrollLinkShow() {
            if ((this.resultOutputBlock.height() || 0) > 0)
                this.scrollBookLink.show();
            else
                this.scrollBookLink.hide();
        }
    }
    _a = ActivityDetailPage, _ActivityDetailPage_tabsBlock = new WeakMap(), _ActivityDetailPage_shortDescriptionBlock = new WeakMap(), _ActivityDetailPage_errorPlace = new WeakMap(), _ActivityDetailPage_detailsBlock = new WeakMap(), _ActivityDetailPage_leftColumn = new WeakMap(), _ActivityDetailPage_searchButton = new WeakMap(), _ActivityDetailPage_landmarkLink = new WeakMap(), _ActivityDetailPage_bookScrollToWrap = new WeakMap(), _ActivityDetailPage_mapButton = new WeakMap(), _ActivityDetailPage_hideMapButton = new WeakMap(), _ActivityDetailPage_form = new WeakMap(), _ActivityDetailPage_instances = new WeakSet(), _ActivityDetailPage_onSearchButtonClick = function _ActivityDetailPage_onSearchButtonClick(event) {
        event.preventDefault();
        if (!__classPrivateFieldGet(this, _ActivityDetailPage_form, "f").validator.form())
            return;
        __classPrivateFieldGet(this, _ActivityDetailPage_searchButton, "f").trigger("detailSearchButton:click" /* Events.DetailSearchButtonClick */);
    }, _ActivityDetailPage_onLandmarkClick = function _ActivityDetailPage_onLandmarkClick(event) {
        event.preventDefault();
        $(event.currentTarget).trigger("landmark:click" /* Events.LandmarkClick */);
    }, _ActivityDetailPage_onScrollLinkClick = function _ActivityDetailPage_onScrollLinkClick() {
        // TODO: дублирование кода - есть в классе TourProgrammPage.ts
        const dest = this.resultOutputBlock;
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += (App.app.container.scrollTop() || 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    }, _ActivityDetailPage_setBookingPosition = function _ActivityDetailPage_setBookingPosition() {
        // TODO: https://jquery.com/upgrade-guide/3.0/#breaking-change-outerwidth-or-outerheight-on-window-includes-scrollbar-width-height
        const scrolledPos = ($(window).scrollTop() || 0) + ($(window).outerHeight() || 0);
        const offset = __classPrivateFieldGet(this, _ActivityDetailPage_bookScrollToWrap, "f").offset();
        const offsetTop = (offset != null ? offset.top : 0);
        if (scrolledPos >= offsetTop && scrolledPos < offsetTop + (__classPrivateFieldGet(this, _ActivityDetailPage_bookScrollToWrap, "f").outerHeight() || 0))
            this.scrollBookLink.addClass('_fixed_book');
        else
            this.scrollBookLink.removeClass('_fixed_book');
    };
    App.ActivityDetailPage = ActivityDetailPage;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _ActivityLandmarkPageMobile_instances, _ActivityLandmarkPageMobile_landmarkFilters, _ActivityLandmarkPageMobile_filterMain, _ActivityLandmarkPageMobile_landmarkBlock, _ActivityLandmarkPageMobile_descriptionBlock, _ActivityLandmarkPageMobile_detailsSliderBlock, _ActivityLandmarkPageMobile_scrollToBlock, _ActivityLandmarkPageMobile_errorPlace, _ActivityLandmarkPageMobile_mapButton, _ActivityLandmarkPageMobile_tabs, _ActivityLandmarkPageMobile_offers, _ActivityLandmarkPageMobile_landmartStatData, _ActivityLandmarkPageMobile_renderPointInfo, _ActivityLandmarkPageMobile_renderDescription, _ActivityLandmarkPageMobile_onSearchButtonClick, _ActivityLandmarkPageMobile_onClickTab;
    class ActivityLandmarkPageMobile extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-landmark-block' }, options));
            _ActivityLandmarkPageMobile_instances.add(this);
            _ActivityLandmarkPageMobile_landmarkFilters.set(this, void 0);
            _ActivityLandmarkPageMobile_filterMain.set(this, void 0);
            // #searchButton: JQuery;
            _ActivityLandmarkPageMobile_landmarkBlock.set(this, void 0);
            _ActivityLandmarkPageMobile_descriptionBlock.set(this, void 0);
            _ActivityLandmarkPageMobile_detailsSliderBlock.set(this, void 0);
            _ActivityLandmarkPageMobile_scrollToBlock.set(this, void 0);
            _ActivityLandmarkPageMobile_errorPlace.set(this, void 0);
            _ActivityLandmarkPageMobile_mapButton.set(this, void 0);
            // #form: Form;
            _ActivityLandmarkPageMobile_tabs.set(this, void 0);
            _ActivityLandmarkPageMobile_offers.set(this, void 0);
            _ActivityLandmarkPageMobile_landmartStatData.set(this, []);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_landmarkFilters, options.landmarkFilters, "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_filterMain, $('.js-activity-landmark-filter', this.root), "f");
            // this.#searchButton = $('.js-m-filter-submit', this.#filterMain);
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_landmarkBlock, $('.js-activity-landmark-block'), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_descriptionBlock, $('.js-description-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_detailsSliderBlock, $('.tour-slider-and-info-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_errorPlace, $('.js-error-place', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_mapButton, $('.js-showMap', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_scrollToBlock, __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_detailsSliderBlock, "f"), "f");
            // this.components.push(new Digest({ container: this.root }));
            // this.#form = new Form({ root: this.#filterMain });
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_filterMain, "f").on('submit', e => __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_instances, "m", _ActivityLandmarkPageMobile_onSearchButtonClick).call(this, e));
        }
        getMapButton() {
            return __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_mapButton, "f");
        }
        // getSearchButton(): JQuery {
        //   return this.#searchButton;
        // }
        getSearchElement() {
            // return this.#searchButton;
            return this.root;
        }
        getErrorPlace() {
            return __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_errorPlace, "f");
        }
        getLandmarkValidator() {
            return __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmarkFilters, "f").validator;
        }
        filterSerializeArray() {
            // return this.#filterMain.find('input').serializeArray();
            var _a;
            // if (!this.#landmarkFilters)
            //   return [];
            // return this.#landmarkFilters.filters.serializeArray();
            let arr = (_a = __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmarkFilters, "f")) === null || _a === void 0 ? void 0 : _a.filters.serializeArray();
            if (!arr)
                arr = [];
            // данные с добавкой статичных данных (не из фильтров, а некоторые на странице приезжают)
            return arr.concat(__classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmartStatData, "f"));
        }
        setScrollToBlock(element) {
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_scrollToBlock, element, "f");
        }
        renderInfo(landmark) {
            const content = $(App.templates.Activity.LandmarkInfo_Mobile(landmark));
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_detailsSliderBlock, "f").empty();
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_detailsSliderBlock, "f").append(content);
            // Инициализируем слайдер тура с пейджером
            this.components.push(new App.MediaGalleryMobile());
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_instances, "m", _ActivityLandmarkPageMobile_renderDescription).call(this, landmark.description);
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_instances, "m", _ActivityLandmarkPageMobile_renderPointInfo).call(this, landmark);
            // событие на клик по табу добавляем перед инициализацией табов
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_instances, "m", _ActivityLandmarkPageMobile_onClickTab).call(this, e));
            // инициализация табов
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_tabs, new App.Tabs({ self: '.js-activity-landmark-block' }), "f");
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_tabs, "f").showActive();
        }
        pageOpen() {
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_filterMain, "f").showByClass();
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmarkBlock, "f").showByClass();
        }
        scrollToOutputBlock() {
            const scrollOffset = __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_scrollToBlock, "f").offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
        saveSearchResult(offers) {
            __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_offers, offers, "f");
        }
    }
    _ActivityLandmarkPageMobile_landmarkFilters = new WeakMap(), _ActivityLandmarkPageMobile_filterMain = new WeakMap(), _ActivityLandmarkPageMobile_landmarkBlock = new WeakMap(), _ActivityLandmarkPageMobile_descriptionBlock = new WeakMap(), _ActivityLandmarkPageMobile_detailsSliderBlock = new WeakMap(), _ActivityLandmarkPageMobile_scrollToBlock = new WeakMap(), _ActivityLandmarkPageMobile_errorPlace = new WeakMap(), _ActivityLandmarkPageMobile_mapButton = new WeakMap(), _ActivityLandmarkPageMobile_tabs = new WeakMap(), _ActivityLandmarkPageMobile_offers = new WeakMap(), _ActivityLandmarkPageMobile_landmartStatData = new WeakMap(), _ActivityLandmarkPageMobile_instances = new WeakSet(), _ActivityLandmarkPageMobile_renderPointInfo = function _ActivityLandmarkPageMobile_renderPointInfo(landmark) {
        // $('input[name="PointKey"]', this.#filterMain).val(landmark.key);
        // $('input[name="PointName"]', this.#filterMain).val(landmark.name);
        __classPrivateFieldSet(this, _ActivityLandmarkPageMobile_landmartStatData, [], "f");
        __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmartStatData, "f").push({ name: 'PointKey', value: landmark.key.toString() });
        __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmartStatData, "f").push({ name: 'PointName', value: landmark.name });
        __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmartStatData, "f").push({ name: 'PointType', value: 'landmark' });
    }, _ActivityLandmarkPageMobile_renderDescription = function _ActivityLandmarkPageMobile_renderDescription(description) {
        if (description)
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_descriptionBlock, "f").html(description).show();
        else
            __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_descriptionBlock, "f").html('').hide();
    }, _ActivityLandmarkPageMobile_onSearchButtonClick = function _ActivityLandmarkPageMobile_onSearchButtonClick(event) {
        event.preventDefault();
        if (__classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmarkFilters, "f") && !__classPrivateFieldGet(this, _ActivityLandmarkPageMobile_landmarkFilters, "f").validator.form())
            return;
        __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_tabs, "f").show('placement');
        this.getSearchElement().trigger("searchButton:click" /* Events.SearchButtonClick */);
    }, _ActivityLandmarkPageMobile_onClickTab = function _ActivityLandmarkPageMobile_onClickTab(event) {
        if ($(event.currentTarget).attr('id') === 'placementTab') {
            if (!__classPrivateFieldGet(this, _ActivityLandmarkPageMobile_offers, "f") || __classPrivateFieldGet(this, _ActivityLandmarkPageMobile_offers, "f").length === 0) {
                // this.#searchButton.trigger(Events.SearchButtonClick);
                this.getSearchElement().trigger("searchButton:click" /* Events.SearchButtonClick */);
            }
        }
    };
    App.ActivityLandmarkPageMobile = ActivityLandmarkPageMobile;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _ActivityLandmarkPage_instances, _ActivityLandmarkPage_filterMain, _ActivityLandmarkPage_searchButton, _ActivityLandmarkPage_landmarkBlock, _ActivityLandmarkPage_descriptionBlock, _ActivityLandmarkPage_detailsSliderBlock, _ActivityLandmarkPage_scrollToBlock, _ActivityLandmarkPage_errorPlace, _ActivityLandmarkPage_mapButton, _ActivityLandmarkPage_progressDataLoading, _ActivityLandmarkPage_form, _ActivityLandmarkPage_tabs, _ActivityLandmarkPage_offers, _ActivityLandmarkPage_renderPointInfo, _ActivityLandmarkPage_renderDescription, _ActivityLandmarkPage_onSearchButtonClick, _ActivityLandmarkPage_onClickTab;
    class ActivityLandmarkPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-landmark-block' }, options));
            _ActivityLandmarkPage_instances.add(this);
            _ActivityLandmarkPage_filterMain.set(this, void 0);
            _ActivityLandmarkPage_searchButton.set(this, void 0);
            _ActivityLandmarkPage_landmarkBlock.set(this, void 0);
            _ActivityLandmarkPage_descriptionBlock.set(this, void 0);
            _ActivityLandmarkPage_detailsSliderBlock.set(this, void 0);
            _ActivityLandmarkPage_scrollToBlock.set(this, void 0);
            _ActivityLandmarkPage_errorPlace.set(this, void 0);
            _ActivityLandmarkPage_mapButton.set(this, void 0);
            _ActivityLandmarkPage_progressDataLoading.set(this, void 0);
            _ActivityLandmarkPage_form.set(this, void 0);
            _ActivityLandmarkPage_tabs.set(this, void 0);
            _ActivityLandmarkPage_offers.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _ActivityLandmarkPage_filterMain, $('.js-activity-landmark-filter', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_searchButton, $('.js-m-filter-submit', __classPrivateFieldGet(this, _ActivityLandmarkPage_filterMain, "f")), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_landmarkBlock, $('.js-activity-landmark-block'), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_descriptionBlock, $('.js-description-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_detailsSliderBlock, $('.tour-slider-and-info-block', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_progressDataLoading, $('.js-progress-data-loading', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_errorPlace, $('.js-error-place', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_mapButton, $('.js-showMap', this.root), "f");
            __classPrivateFieldSet(this, _ActivityLandmarkPage_scrollToBlock, __classPrivateFieldGet(this, _ActivityLandmarkPage_detailsSliderBlock, "f"), "f");
            this.components.push(new App.Digest({ container: this.root }));
            __classPrivateFieldSet(this, _ActivityLandmarkPage_form, new App.Form({ root: __classPrivateFieldGet(this, _ActivityLandmarkPage_filterMain, "f") }), "f");
            __classPrivateFieldGet(this, _ActivityLandmarkPage_filterMain, "f").on('submit', e => __classPrivateFieldGet(this, _ActivityLandmarkPage_instances, "m", _ActivityLandmarkPage_onSearchButtonClick).call(this, e));
        }
        getMapButton() {
            return __classPrivateFieldGet(this, _ActivityLandmarkPage_mapButton, "f");
        }
        getSearchButton() {
            return __classPrivateFieldGet(this, _ActivityLandmarkPage_searchButton, "f");
        }
        getErrorPlace() {
            return __classPrivateFieldGet(this, _ActivityLandmarkPage_errorPlace, "f");
        }
        filterSerializeArray() {
            return __classPrivateFieldGet(this, _ActivityLandmarkPage_filterMain, "f").find('input').serializeArray();
        }
        setScrollToBlock(element) {
            __classPrivateFieldSet(this, _ActivityLandmarkPage_scrollToBlock, element, "f");
        }
        renderInfo(landmark) {
            const content = $(App.templates.Activity.LandmarkInfo(landmark));
            __classPrivateFieldGet(this, _ActivityLandmarkPage_detailsSliderBlock, "f").empty();
            __classPrivateFieldGet(this, _ActivityLandmarkPage_detailsSliderBlock, "f").append(content);
            // Инициализируем слайдер тура с пейджером
            this.components.push(new App.MediaGallery());
            __classPrivateFieldGet(this, _ActivityLandmarkPage_instances, "m", _ActivityLandmarkPage_renderDescription).call(this, landmark.description);
            __classPrivateFieldGet(this, _ActivityLandmarkPage_instances, "m", _ActivityLandmarkPage_renderPointInfo).call(this, landmark);
            // событие на клик по табу добавляем перед инициализацией табов
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _ActivityLandmarkPage_instances, "m", _ActivityLandmarkPage_onClickTab).call(this, e));
            // инициализация табов
            __classPrivateFieldSet(this, _ActivityLandmarkPage_tabs, new App.Tabs({ self: '.js-activity-landmark-block' }), "f");
            __classPrivateFieldGet(this, _ActivityLandmarkPage_tabs, "f").showActive();
        }
        pageOpen() {
            __classPrivateFieldGet(this, _ActivityLandmarkPage_filterMain, "f").showByClass();
            __classPrivateFieldGet(this, _ActivityLandmarkPage_landmarkBlock, "f").showByClass();
        }
        scrollToOutputBlock() {
            const scrollOffset = __classPrivateFieldGet(this, _ActivityLandmarkPage_scrollToBlock, "f").offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
        saveSearchResult(offers) {
            __classPrivateFieldSet(this, _ActivityLandmarkPage_offers, offers, "f");
        }
        /**
         * Показывает прогресс загрузки данных
         */
        showProgressDataLoader() {
            if (__classPrivateFieldGet(this, _ActivityLandmarkPage_progressDataLoading, "f"))
                __classPrivateFieldGet(this, _ActivityLandmarkPage_progressDataLoading, "f").show();
        }
        /**
         * Скрывает прогресс загрузки данных
         */
        hideProgressDataLoader() {
            if (__classPrivateFieldGet(this, _ActivityLandmarkPage_progressDataLoading, "f"))
                __classPrivateFieldGet(this, _ActivityLandmarkPage_progressDataLoading, "f").hide();
        }
    }
    _ActivityLandmarkPage_filterMain = new WeakMap(), _ActivityLandmarkPage_searchButton = new WeakMap(), _ActivityLandmarkPage_landmarkBlock = new WeakMap(), _ActivityLandmarkPage_descriptionBlock = new WeakMap(), _ActivityLandmarkPage_detailsSliderBlock = new WeakMap(), _ActivityLandmarkPage_scrollToBlock = new WeakMap(), _ActivityLandmarkPage_errorPlace = new WeakMap(), _ActivityLandmarkPage_mapButton = new WeakMap(), _ActivityLandmarkPage_progressDataLoading = new WeakMap(), _ActivityLandmarkPage_form = new WeakMap(), _ActivityLandmarkPage_tabs = new WeakMap(), _ActivityLandmarkPage_offers = new WeakMap(), _ActivityLandmarkPage_instances = new WeakSet(), _ActivityLandmarkPage_renderPointInfo = function _ActivityLandmarkPage_renderPointInfo(landmark) {
        $('input[name="PointKey"]', __classPrivateFieldGet(this, _ActivityLandmarkPage_filterMain, "f")).val(landmark.key);
        $('input[name="PointName"]', __classPrivateFieldGet(this, _ActivityLandmarkPage_filterMain, "f")).val(landmark.name);
    }, _ActivityLandmarkPage_renderDescription = function _ActivityLandmarkPage_renderDescription(description) {
        if (description)
            __classPrivateFieldGet(this, _ActivityLandmarkPage_descriptionBlock, "f").html(description).show();
        else
            __classPrivateFieldGet(this, _ActivityLandmarkPage_descriptionBlock, "f").html('').hide();
    }, _ActivityLandmarkPage_onSearchButtonClick = function _ActivityLandmarkPage_onSearchButtonClick(event) {
        event.preventDefault();
        if (!__classPrivateFieldGet(this, _ActivityLandmarkPage_form, "f").validator.form())
            return;
        __classPrivateFieldGet(this, _ActivityLandmarkPage_tabs, "f").show('placement');
        __classPrivateFieldGet(this, _ActivityLandmarkPage_searchButton, "f").trigger("searchButton:click" /* Events.SearchButtonClick */);
    }, _ActivityLandmarkPage_onClickTab = function _ActivityLandmarkPage_onClickTab(event) {
        if ($(event.currentTarget).attr('id') === 'placementTab') {
            if (!__classPrivateFieldGet(this, _ActivityLandmarkPage_offers, "f") || __classPrivateFieldGet(this, _ActivityLandmarkPage_offers, "f").length === 0)
                __classPrivateFieldGet(this, _ActivityLandmarkPage_searchButton, "f").trigger("searchButton:click" /* Events.SearchButtonClick */);
        }
    };
    App.ActivityLandmarkPage = ActivityLandmarkPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ActivityPageManagerMobile_instances, _a, _ActivityPageManagerMobile_options, _ActivityPageManagerMobile_preloaderField, _ActivityPageManagerMobile_hotFilterSearchField, _ActivityPageManagerMobile_hotFilterDetailField, _ActivityPageManagerMobile_hotFilterLandmarkField, _ActivityPageManagerMobile_searchMainFilters, _ActivityPageManagerMobile_searchResultField, _ActivityPageManagerMobile_searchPageField, _ActivityPageManagerMobile_detailFilter, _ActivityPageManagerMobile_landmarkFilter, _ActivityPageManagerMobile_detailResultField, _ActivityPageManagerMobile_detailPageField, _ActivityPageManagerMobile_bookPageField, _ActivityPageManagerMobile_landmarkPageField, _ActivityPageManagerMobile_landmarkResultField, _ActivityPageManagerMobile_searchExecuting, _ActivityPageManagerMobile_applicationActivitiesData, _ActivityPageManagerMobile_applicationVariantsData, _ActivityPageManagerMobile_applicationLandmarkData, _ActivityPageManagerMobile_hotFilterSetField, _ActivityPageManagerMobile_existingPassengers, _ActivityPageManagerMobile_currentDataUrl, _ActivityPageManagerMobile_activeRequest, _ActivityPageManagerMobile_requiredUrlCheckerField, _ActivityPageManagerMobile_emptyUrlCheckerField, _ActivityPageManagerMobile_preloader_get, _ActivityPageManagerMobile_hotFilterSearch_get, _ActivityPageManagerMobile_hotFilterDetail_get, _ActivityPageManagerMobile_hotFilterLandmark_get, _ActivityPageManagerMobile_hotFilterSet_get, _ActivityPageManagerMobile_hotFilterSet_set, _ActivityPageManagerMobile_searchPage_get, _ActivityPageManagerMobile_detailResult_get, _ActivityPageManagerMobile_detailPage_get, _ActivityPageManagerMobile_bookPage_get, _ActivityPageManagerMobile_landmarkPage_get, _ActivityPageManagerMobile_searchResult_get, _ActivityPageManagerMobile_landmarkResult_get, _ActivityPageManagerMobile_requiredUrlChecker_get, _ActivityPageManagerMobile_emptyUrlChecker_get, _ActivityPageManagerMobile_start, _ActivityPageManagerMobile_onHistoryPopState, _ActivityPageManagerMobile_searchHistoryChange, _ActivityPageManagerMobile_detailHistoryChange, _ActivityPageManagerMobile_landmarkHistoryChange, _ActivityPageManagerMobile_setManualSearch, _ActivityPageManagerMobile_searchActivityVariants, _ActivityPageManagerMobile_showDetails, _ActivityPageManagerMobile_showLandmark, _ActivityPageManagerMobile_onShowMapClick, _ActivityPageManagerMobile_getMapData, _ActivityPageManagerMobile_showResultSearchActivitiesForLandmark, _ActivityPageManagerMobile_searchActivities, _ActivityPageManagerMobile_searchActivitiesForLandmark, _ActivityPageManagerMobile_searchActivity, _ActivityPageManagerMobile_searchActivitiesForDetail, _ActivityPageManagerMobile_searchActivitiesForBooking, _ActivityPageManagerMobile_searchLandmark, _ActivityPageManagerMobile_book, _ActivityPageManagerMobile_onBlockClick, _ActivityPageManagerMobile_onShowLandmarkClick, _ActivityPageManagerMobile_onDetailBlockClick, _ActivityPageManagerMobile_setNewVariantUrl, _ActivityPageManagerMobile_activitiesDataTransformation, _ActivityPageManagerMobile_variantsDataTransformation, _ActivityPageManagerMobile_landmarksDataTransformation, _ActivityPageManagerMobile_createLandmarkTypeIcons, _ActivityPageManagerMobile_onBeforeSearch, _ActivityPageManagerMobile_validateSearchResponse, _ActivityPageManagerMobile_validateVariantResponse, _ActivityPageManagerMobile_getSeo, _ActivityPageManagerMobile_sendPostRequest, _ActivityPageManagerMobile_stopRequest, _ActivityPageManagerMobile_clearActiveRequest;
    // Класс, управляющий страницами.
    // аналог ActivityPageManagerMobile
    class ActivityPageManagerMobile {
        constructor(options) {
            _ActivityPageManagerMobile_instances.add(this);
            _ActivityPageManagerMobile_options.set(this, void 0);
            _ActivityPageManagerMobile_preloaderField.set(this, void 0);
            _ActivityPageManagerMobile_hotFilterSearchField.set(this, void 0);
            _ActivityPageManagerMobile_hotFilterDetailField.set(this, void 0);
            _ActivityPageManagerMobile_hotFilterLandmarkField.set(this, void 0);
            _ActivityPageManagerMobile_searchMainFilters.set(this, void 0);
            _ActivityPageManagerMobile_searchResultField.set(this, void 0);
            _ActivityPageManagerMobile_searchPageField.set(this, void 0);
            _ActivityPageManagerMobile_detailFilter.set(this, void 0);
            _ActivityPageManagerMobile_landmarkFilter.set(this, void 0);
            _ActivityPageManagerMobile_detailResultField.set(this, void 0);
            _ActivityPageManagerMobile_detailPageField.set(this, void 0);
            _ActivityPageManagerMobile_bookPageField.set(this, void 0);
            _ActivityPageManagerMobile_landmarkPageField.set(this, void 0);
            _ActivityPageManagerMobile_landmarkResultField.set(this, void 0);
            // признак того, что сейчас производится поиск. Чтобы новый не начинать
            _ActivityPageManagerMobile_searchExecuting.set(this, false);
            // данные
            _ActivityPageManagerMobile_applicationActivitiesData.set(this, void 0);
            _ActivityPageManagerMobile_applicationVariantsData.set(this, void 0);
            _ActivityPageManagerMobile_applicationLandmarkData.set(this, void 0);
            _ActivityPageManagerMobile_hotFilterSetField.set(this, void 0);
            _ActivityPageManagerMobile_existingPassengers.set(this, void 0);
            _ActivityPageManagerMobile_currentDataUrl.set(this, void 0);
            // Запрос для последующей остановки
            _ActivityPageManagerMobile_activeRequest.set(this, void 0);
            _ActivityPageManagerMobile_requiredUrlCheckerField.set(this, void 0);
            _ActivityPageManagerMobile_emptyUrlCheckerField.set(this, void 0);
            Object.defineProperty(this, "components", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_options, options, "f");
            // console.log('-- ActivityPageManagerMobile --');
            // console.log(options);
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onHistoryPopState).call(this); }));
            // TODO: переделать как в отелях (может нет смысла, т.к. в отелях здесь все равно есть инициализация ввиде присваивания
            // неиспользуемой переменной)
            // NOTE: создаем ДО первого использования this.#detailPage
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_detailFilter, new App.ActivityDetailMainFilterMobile({
                datesOptions: {
                    maxDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").maxDateToOffset,
                    defaultDateFromShift: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateFromShift,
                    defaultDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateToShift - __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateFromShift,
                    minDateFromShift: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").minDateFromShift,
                    minDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").minDateToOffset,
                },
                peopleOptions: {
                    maxChildAge: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").maxChildAge,
                    defaultAdultCountValue: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultAdultCount,
                },
            }), "f");
            const dateFromLimit = __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").dateFromLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").dateFromLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").dateFromLimit.max) };
            // NOTE: создаем ДО первого использования this.#landmarkPage
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_landmarkFilter, new App.ActivityLandmarkMainFilterMobile({
                datesOptions: {
                    minDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.min,
                    maxDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.max,
                    maxDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").maxDateToOffset,
                    defaultDateFromShift: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateFromShift,
                    defaultDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateToShift - __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateFromShift,
                    minDateFromShift: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").minDateFromShift,
                    minDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").minDateToOffset,
                },
                peopleOptions: {
                    maxChildAge: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").maxChildAge,
                    defaultAdultCountValue: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultAdultCount,
                },
            }), "f");
            // TODO: переделать на событие https://keestalkstech.com/2016/03/strongly-typed-event-handlers-in-typescript-part-1/
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getSearchBlock().on("block:click" /* Events.BlockClick */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onBlockClick).call(this, e, data); }));
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).getDetailBlock().on("block:click" /* Events.BlockClick */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onDetailBlockClick).call(this, e, data); }));
            // проверка на валидность фильтра делается в странице при возбуждении события
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getSearchButton().on("searchButton:click" /* Events.SearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivities).call(this); }));
            // this.#detailPage.getSearchButton().on(Events.DetailSearchButtonClick, async () => await this.#searchActivityVariants());
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).getSearchElement().on("detailSearchButton:click" /* Events.DetailSearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivityVariants).call(this); }));
            // this.#landmarkPage.getSearchButton().on(Events.SearchButtonClick, async () => await this.#searchActivitiesForLandmark());
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).getSearchElement().on("searchButton:click" /* Events.SearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivitiesForLandmark).call(this); }));
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchMainFilters, new App.ActivitySearchMainFilterMobile({
                datesOptions: {
                    minDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.min,
                    maxDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.max,
                    maxDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").maxDateToOffset,
                    defaultDateFromShift: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateFromShift,
                    defaultDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateToShift - __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultDateFromShift,
                    minDateFromShift: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").minDateFromShift,
                    minDateToOffset: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").minDateToOffset,
                },
                peopleOptions: {
                    maxChildAge: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").maxChildAge,
                    defaultAdultCountValue: __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").defaultAdultCount,
                },
            }), "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).setMainFilter(__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchMainFilters, "f"));
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_stopRequest).call(_a, __classPrivateFieldGet(this, _ActivityPageManagerMobile_activeRequest, "f"));
                    inst.hide();
                }
            });
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                if (App.app.url.routeData.action !== 'info')
                    return;
                const activity = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f")[0];
                const filters = Enumerable.from(__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).filterSerializeArray());
                // TODO Titov: договориться с Кириллом и заменить '#offer-sub-ids' на 'input[name="pacngo-offer-sub-ids"]'.
                const variantKeys = $('input[name="pacngo-offer-sub-ids"]').valString().split(';').filter(v => v !== '');
                const variants = variantKeys
                    .map(v => __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f").find(x => App.formatDate(x.beginDate, 'shortDate') === v))
                    .filter(App.notUndefined);
                const data = {
                    type: 'activity',
                    filter: {
                        adultCount: filters
                            .where(v => v.name === 'Tourist.AdultCount')
                            .select(v => parseInt(v.value, 10))
                            .first(),
                        childAges: filters
                            .where(v => v.name === 'Tourist.ChildAges.Age')
                            .where(v => !!v.value)
                            .select(v => parseInt(v.value, 10))
                            .toArray(),
                    },
                    info: {
                        key: activity.key,
                        name: activity.name,
                        country: activity.country,
                        city: activity.city,
                        guideTypeName: activity.guideType.name,
                        isGroup: activity.isGroup,
                        transportTypeName: activity.transportType.name,
                        titleImage: activity.titleImage,
                        facilityNames: activity.facilities
                            .map(v => v.name),
                        landmarks: activity.landmarks
                            .map(v => ({
                            key: v.key,
                            name: v.name,
                        })),
                        duration: (activity.duration.days * App.hoursPerDay + activity.duration.hours) * App.minutesPerHour
                            + activity.duration.minutes,
                    },
                    variants: variants
                        .map(v => ({
                        beginDate: App.parseIsoDate(v.beginDate),
                        netPrice: v.netPrice,
                        grossPrice: v.grossPrice,
                        price: v.price,
                        currencyCode: v.currencyCode,
                    })),
                };
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта (при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data,
                    },
                }));
            });
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_start).call(this); }))();
        }
        /**
         * Начинает бронирование - отображает форму
         * @param activityVariant вариант для бронирования
         * @param activityOffer само предложение по экскурсии
         * @param context - контекст (номер заказа)
         */
        showBookingForm(activityVariant, activityOffer, context, allowBooking) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!activityVariant)
                    return;
                if (!activityVariant.key)
                    return;
                // передать данные в шаблон и вставить его
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).renderBookingSection(activityVariant, activityOffer, context, allowBooking, __classPrivateFieldGet(this, _ActivityPageManagerMobile_existingPassengers, "f"));
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).pageClose();
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageClose();
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).pageOpen();
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getHeader().html(localizer.bookingExcursion);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).scrollToOutputBlock();
            });
        }
    }
    _a = ActivityPageManagerMobile, _ActivityPageManagerMobile_options = new WeakMap(), _ActivityPageManagerMobile_preloaderField = new WeakMap(), _ActivityPageManagerMobile_hotFilterSearchField = new WeakMap(), _ActivityPageManagerMobile_hotFilterDetailField = new WeakMap(), _ActivityPageManagerMobile_hotFilterLandmarkField = new WeakMap(), _ActivityPageManagerMobile_searchMainFilters = new WeakMap(), _ActivityPageManagerMobile_searchResultField = new WeakMap(), _ActivityPageManagerMobile_searchPageField = new WeakMap(), _ActivityPageManagerMobile_detailFilter = new WeakMap(), _ActivityPageManagerMobile_landmarkFilter = new WeakMap(), _ActivityPageManagerMobile_detailResultField = new WeakMap(), _ActivityPageManagerMobile_detailPageField = new WeakMap(), _ActivityPageManagerMobile_bookPageField = new WeakMap(), _ActivityPageManagerMobile_landmarkPageField = new WeakMap(), _ActivityPageManagerMobile_landmarkResultField = new WeakMap(), _ActivityPageManagerMobile_searchExecuting = new WeakMap(), _ActivityPageManagerMobile_applicationActivitiesData = new WeakMap(), _ActivityPageManagerMobile_applicationVariantsData = new WeakMap(), _ActivityPageManagerMobile_applicationLandmarkData = new WeakMap(), _ActivityPageManagerMobile_hotFilterSetField = new WeakMap(), _ActivityPageManagerMobile_existingPassengers = new WeakMap(), _ActivityPageManagerMobile_currentDataUrl = new WeakMap(), _ActivityPageManagerMobile_activeRequest = new WeakMap(), _ActivityPageManagerMobile_requiredUrlCheckerField = new WeakMap(), _ActivityPageManagerMobile_emptyUrlCheckerField = new WeakMap(), _ActivityPageManagerMobile_instances = new WeakSet(), _ActivityPageManagerMobile_preloader_get = function _ActivityPageManagerMobile_preloader_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_preloaderField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_preloaderField, "f");
    }, _ActivityPageManagerMobile_hotFilterSearch_get = function _ActivityPageManagerMobile_hotFilterSearch_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterSearchField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_hotFilterSearchField, new App.ActivitySearchHotFilterMobile(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterSearchField, "f");
    }, _ActivityPageManagerMobile_hotFilterDetail_get = function _ActivityPageManagerMobile_hotFilterDetail_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterDetailField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_hotFilterDetailField, new App.ActivityDetailHotFilterMobile(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterDetailField, "f");
    }, _ActivityPageManagerMobile_hotFilterLandmark_get = function _ActivityPageManagerMobile_hotFilterLandmark_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterLandmarkField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_hotFilterLandmarkField, new App.ActivityLandmarkHotFilterMobile(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterLandmarkField, "f");
    }, _ActivityPageManagerMobile_hotFilterSet_get = function _ActivityPageManagerMobile_hotFilterSet_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterSetField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_hotFilterSetField, new App.ActivityHotFilterSet(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_hotFilterSetField, "f");
    }, _ActivityPageManagerMobile_hotFilterSet_set = function _ActivityPageManagerMobile_hotFilterSet_set(value) {
        __classPrivateFieldSet(this, _ActivityPageManagerMobile_hotFilterSetField, value, "f");
    }, _ActivityPageManagerMobile_searchPage_get = function _ActivityPageManagerMobile_searchPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchPageField, new App.ActivitySearchPageMobile(__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f")), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_searchPageField, "f");
    }, _ActivityPageManagerMobile_detailResult_get = function _ActivityPageManagerMobile_detailResult_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_detailResultField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_detailResultField, new App.ActivityDetailResultMobile(Object.assign({ hotFilter: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterDetail_get) }, __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f"))), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailResultField, "f");
    }, _ActivityPageManagerMobile_detailPage_get = function _ActivityPageManagerMobile_detailPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_detailPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_detailPageField, new App.ActivityDetailPageMobile(Object.assign({ detailFilters: __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f") }, __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f"))), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailPageField, "f");
    }, _ActivityPageManagerMobile_bookPage_get = function _ActivityPageManagerMobile_bookPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_bookPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_bookPageField, new App.ActivityBookPageMobile(__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f")), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_bookPageField, "f");
    }, _ActivityPageManagerMobile_landmarkPage_get = function _ActivityPageManagerMobile_landmarkPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_landmarkPageField, new App.ActivityLandmarkPageMobile(Object.assign({ landmarkFilters: __classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkFilter, "f") }, __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f"))), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkPageField, "f");
    }, _ActivityPageManagerMobile_searchResult_get = function _ActivityPageManagerMobile_searchResult_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchResultField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchResultField, new App.ActivityResultMobile({ hotFilter: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSearch_get) }), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_searchResultField, "f");
    }, _ActivityPageManagerMobile_landmarkResult_get = function _ActivityPageManagerMobile_landmarkResult_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkResultField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_landmarkResultField, new App.ActivityLandmarkResultMobile({ hotFilter: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterLandmark_get) }), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkResultField, "f");
    }, _ActivityPageManagerMobile_requiredUrlChecker_get = function _ActivityPageManagerMobile_requiredUrlChecker_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_requiredUrlCheckerField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_requiredUrlCheckerField, new App.RequiredUrlChecker(new App.ActivityUrlParameters()), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_requiredUrlCheckerField, "f");
    }, _ActivityPageManagerMobile_emptyUrlChecker_get = function _ActivityPageManagerMobile_emptyUrlChecker_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_emptyUrlCheckerField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_emptyUrlCheckerField, new App.EmptyUrlChecker(new App.ActivityUrlParameters()), "f");
        return __classPrivateFieldGet(this, _ActivityPageManagerMobile_emptyUrlCheckerField, "f");
    }, _ActivityPageManagerMobile_start = function _ActivityPageManagerMobile_start() {
        return __awaiter(this, void 0, void 0, function* () {
            const actionName = App.app.url.routeData.action;
            if (!actionName)
                return;
            // Установка параметра автопоиска this.options.manual (подробный коммент в методе)
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_setManualSearch).call(this, actionName);
            // проверяем, откуда начинать
            switch (actionName) {
                case 'search':
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageOpen();
                    // если надо делать автопоиск сразу при загрузке скрипта
                    // Это делается, если введен url в браузер и надо найти все, что в нем
                    if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual) {
                        // подставить соответствующие значения урла на форму поиска
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_searchMainFilters, "f").setMainFilter(App.UrlParameterHelper.urlParse());
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivities).call(this);
                    }
                    break;
                case 'info':
                    if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual)
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivity).call(this);
                    else
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivitiesForDetail).call(this);
                    break;
                case 'book':
                    if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual)
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivitiesForBooking).call(this);
                    break;
                case 'landmark':
                    if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual) {
                        // подставить соответствующие значения урла на форму поиска
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkFilter, "f").setMainFilter(App.UrlParameterHelper.urlParse());
                    }
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchLandmark).call(this);
                    break;
                // no default
            }
        });
    }, _ActivityPageManagerMobile_onHistoryPopState = function _ActivityPageManagerMobile_onHistoryPopState() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentUrl = window.location.pathname.toLowerCase();
            const regExpMatch = new RegExp('^/activity/[a-zA-Z]+').exec(currentUrl);
            if (!regExpMatch)
                return;
            const mainRoute = regExpMatch[0];
            switch (mainRoute) {
                case App.ActivityPageUrls.Search:
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchHistoryChange).call(this);
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageOpen();
                    break;
                case App.ActivityPageUrls.Info:
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).pageOpen();
                    if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f"))
                        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).resetDataSource();
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_detailHistoryChange).call(this);
                    break;
                case App.ActivityPageUrls.Landmark:
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_landmarkHistoryChange).call(this);
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).pageOpen();
                    break;
                case App.ActivityPageUrls.Book:
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_book).call(this);
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).pageOpen();
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getHeader().html(localizer.bookingExcursion);
                    break;
                // no default
            }
        });
    }, _ActivityPageManagerMobile_searchHistoryChange = function _ActivityPageManagerMobile_searchHistoryChange() {
        return __awaiter(this, void 0, void 0, function* () {
            // Парсим урл
            const urlParameters = App.UrlParameterHelper.urlParse();
            // соответсвуют данные урлу или нет
            const dataMatchUrl = App.UrlParameterHelper.contains(__classPrivateFieldGet(this, _ActivityPageManagerMobile_currentDataUrl, "f"));
            // 1. Если данные соответствуют урлу, просто отображаем данные в соответствии с параметрами, не загружаем данные заново
            // 2. Если данные не соответствуют урлу, пихаем параметры поиска в главный фильтр и запускаем поиск
            // 3. Если это страница поиска, т.е.урл типа activity/search, то скрываем отображённое, очищаем фильтры и оставляем только форму
            const canSearch = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_requiredUrlChecker_get).isValid(urlParameters) && !App.UrlParameterHelper.isManual(urlParameters);
            if (dataMatchUrl) {
                // устанавливаем параметры необходимые для работы с данными
                const dataManipulateParameters = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).setDataManipulateParameters(urlParameters);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSearch_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSet_get), dataManipulateParameters.filtering);
                if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f") && __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").length > 0)
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f"));
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoSearch), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).filterSerializeArray());
            }
            else if (canSearch) {
                // подставить соответствующие значения урла на форму поиска
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_searchMainFilters, "f").setMainFilter(urlParameters);
                // запустить поиск
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivities).call(this);
            }
            else {
                // TODO: возможно, надо будет  сделать очистку формы, но пока пусть будет так
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).resetDataSource();
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoSearch), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).filterSerializeArray());
            }
        });
    }, _ActivityPageManagerMobile_detailHistoryChange = function _ActivityPageManagerMobile_detailHistoryChange() {
        return __awaiter(this, void 0, void 0, function* () {
            // Парсим урл
            const urlParameters = App.UrlParameterHelper.urlParse();
            // соответсвуют данные урлу или нет
            const dataMatchUrl = App.UrlParameterHelper.contains(__classPrivateFieldGet(this, _ActivityPageManagerMobile_currentDataUrl, "f"));
            // 1. Если данные соответсвуют урлу, просто отображаем данные в сответсвии с парамтерами, не загружаем данные заново
            // 2. Если данные не соответсвуют урлу, пихаем парамтры поиска в главный фильтр и запускаем поиск
            // 3. Если это страница инфо об экскурсии, т.е. урл типа activity/info/55, то показываем только инфо
            const activityId = App.app.url.routeData.id;
            const doSearch = activityId != null && !App.UrlParameterHelper.isManual(urlParameters);
            if (dataMatchUrl) {
                if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").length > 0) {
                    // устанавливаем параметры, необходимые для работы с данными
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).setDataManipulateParameters(urlParameters);
                    // сначала ищем в экскусриях и берем ТОЛЬКО экскурсию
                    const currentActivity = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").find(item => item.key === activityId);
                    // потмо берем _applicationVariantsData, т.к. мы уже могли поискать в вариантах и они не совпадают с теми,
                    // что в _applicationActivitiesData
                    if (currentActivity)
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showDetails).call(this, currentActivity, __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f"));
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoInfo, activityId), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).filterSerializeArray());
                }
            }
            else if (doSearch) {
                // подставить соответсвующие значения урла на форму поиска
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f").setMainFilter(urlParameters);
                // запустить поиск
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_searchActivitiesForDetail).call(this);
            }
            else {
                if (activityId != null) {
                    // сюда приходим, если вернулись с достопримечательностей или подбора вариантов
                    const currentActivity = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").find(item => item.key === activityId);
                    if (currentActivity) {
                        yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showDetails).call(this, currentActivity, new Array());
                        // Скрыть сообщение об ошибке. оставшееся от предыдущих действий
                        const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).getErrorPlace() });
                        messages.hide();
                    }
                }
                else {
                    // TODO: возможно, надо будет  сделать очистку формы, но пока пусть будет так
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).resetDataSource();
                }
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoInfo, activityId), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).filterSerializeArray());
            }
        });
    }, _ActivityPageManagerMobile_landmarkHistoryChange = function _ActivityPageManagerMobile_landmarkHistoryChange() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            // Для достопримечательностей надо просто хранить их в переменной и проверять по ключу - совпадает или нет.
            const landmarkId = parseInt((_b = App.app.url.routeData.id) !== null && _b !== void 0 ? _b : '0', 10);
            let landmark;
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationLandmarkData, "f") && __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationLandmarkData, "f").key === landmarkId)
                landmark = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationLandmarkData, "f");
            //  Если не совпадает, ищем в загруженных экскурсиях
            if (!landmark) {
                landmark = Enumerable.from(__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f"))
                    .select(v => v.landmarks.find(x => x.key === landmarkId))
                    .firstOrDefault(v => !!v);
            }
            if (!landmark)
                return;
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showLandmark).call(this, landmark);
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getSeo).call(this, App.UrlParameterHelper.urlParse(), App.app.url.route(App.ActivityPageUrls.SeoLandmark, landmarkId));
        });
    }, _ActivityPageManagerMobile_setManualSearch = function _ActivityPageManagerMobile_setManualSearch(actionName) {
        return __awaiter(this, void 0, void 0, function* () {
            const urlParameters = App.UrlParameterHelper.urlParse();
            // Установить фильтр
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_searchMainFilters, "f").setMainFilter(urlParameters);
            // TODO: Пока тупая проверка на заполненность (наличие контекста не учитываем)
            // Если параметров нет или он один и содержит  контекст = значит грузим чистую форму
            // Если один параметр и содержит tour, тоже типа auto, но форма не нужна и обрабатываем это дальше
            let isValid = false;
            switch (actionName) {
                case 'search':
                    isValid = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_requiredUrlChecker_get).isValid(urlParameters);
                    break;
                case 'info':
                    isValid = App.app.url.routeData.id != null;
                    break;
                case 'book':
                    isValid = App.app.url.routeData.id != null;
                    break;
                case 'landmark':
                    isValid = App.app.url.routeData.id != null;
                    break;
            }
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual = !isValid || App.UrlParameterHelper.isManual(urlParameters) || App.UrlParameterHelper.isTourBook(urlParameters);
        });
    }, _ActivityPageManagerMobile_searchActivityVariants = function _ActivityPageManagerMobile_searchActivityVariants() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).resetDataSource();
            // TODO: все запросы тут делаются через метод с колбеком - вынести
            const xhr = $.ajax({
                url: App.app.url.route(App.ActivityPageUrls.Variants, App.app.url.routeData.id),
                method: 'POST',
                dataType: 'json',
                data: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).filterSerializeArray(),
            });
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onBeforeSearch).call(this, xhr, 500);
            try {
                const response = yield xhr;
                const responseData = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_validateVariantResponse).call(this, response, messages);
                if (!responseData)
                    return;
                const responseVariants = responseData.variants || new Array(0);
                App.app.seo.update(responseData.seo);
                const activityId = (_b = App.app.url.routeData.id) !== null && _b !== void 0 ? _b : '0';
                const newUrl = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_setNewVariantUrl).call(this, activityId);
                // Если поиск происходит после ввода адреса с параметрами, не перезаписывать историю, т.к. этот адрес итак в истории, а
                // другие парамтеры удаляются, например, хотфильтры.
                if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual)
                    App.UrlParameterHelper.setUrlAsIs(newUrl);
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_currentDataUrl, newUrl, "f");
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationVariantsData, __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_variantsDataTransformation).call(this, responseVariants, activityId), "f");
                if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f").length > 0) {
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).pageOpen();
                    yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f"));
                }
                else {
                    messages.show(App.Message.SearchNoVariants);
                }
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual = true;
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).scrollLinkShow();
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).scrollToOutputBlock();
            }
            finally {
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_preloader_get).hide();
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_clearActiveRequest).call(this);
            }
        });
    }, _ActivityPageManagerMobile_showDetails = function _ActivityPageManagerMobile_showDetails(activity, variants) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageClose();
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_bookPage_get).pageClose();
            if (!activity)
                return;
            const activityId = activity.key;
            if (!activityId)
                return;
            $('.js-pacngo-activity-details-block', __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).root)
                .addBack('.js-pacngo-activity-details-block')
                .attr('data-pacngo-offer-uid', activityId)
                // TODO Titov: договориться с Кириллом и убрать вариант data-pacngo-offer-uid (оставить только data-pacngo-offer-uid).
                .attr('data-offer-uid', activityId);
            // передать данные в шаблон и вставить его
            __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_landmarksDataTransformation).call(_a, activity.landmarks);
            activity.isHostUa = window.location.hostname === 'www.pac.ua';
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).renderInfo(activity);
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).getLandmarkLink().on("landmark:click" /* Events.LandmarkClick */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onShowLandmarkClick).call(this, e); }));
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).getMapButton().on('click', e => __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onShowMapClick).call(this, e));
            // вставить описание в нужные блоки
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).renderDescription(activity.description, activity.shortDescription);
            if (activity.ticketsNotIncluded)
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).renderTicketsNotIncluded();
            const urlParameters = App.UrlParameterHelper.urlParse();
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f").setMainFilter(urlParameters);
            if (variants && variants.length > 0) {
                const newVariants = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_variantsDataTransformation).call(this, variants, activityId);
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).changeDataSource(newVariants);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).scrollToOutputBlock();
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).pageOpen();
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).resetDataSource();
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).scrollLinkShow();
            }
            if (!activity.showSearchForm || urlParameters.some(param => param.name === App.ActivityUrlParameters.tour))
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).hideSearchForm();
        });
    }, _ActivityPageManagerMobile_showLandmark = function _ActivityPageManagerMobile_showLandmark(landmark) {
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).resetDataSource();
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).pageClose();
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).pageClose();
        __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_createLandmarkTypeIcons).call(_a, landmark);
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).renderInfo(landmark);
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).pageOpen();
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).setScrollToBlock(__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getHeader());
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).scrollToOutputBlock();
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).getMapButton().on('click', e => __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onShowMapClick).call(this, e));
    }, _ActivityPageManagerMobile_onShowMapClick = function _ActivityPageManagerMobile_onShowMapClick(event) {
        var _b;
        const target = $(event.currentTarget);
        const buttonWrap = target.parents('.resort-town-page');
        buttonWrap.hide();
        target.parents('.activity-details-block').find('.js-resort-town-page').show();
        const pageType = ((_b = target.attr('data-type-active-section')) === null || _b === void 0 ? void 0 : _b.toString()) || '';
        const data = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getMapData).call(this, pageType);
        if (data[0].length == 0 || data[1].length == 0)
            return;
        const mapModel = {
            mapTitle: localizer.sitesVisitedOnMap,
            showHide: false,
            mapPoints: data[1],
        };
        this.components.push(new App.UnfoldMap(mapModel, false, data[0]));
    }, _ActivityPageManagerMobile_getMapData = function _ActivityPageManagerMobile_getMapData(pageType) {
        let selector = '';
        let points = [];
        if (pageType == 'activity') {
            selector = '.js-activity-details-block .js-resort-town-page';
            points = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f")[0].landmarks.map(landmark => ({
                coordinates: landmark.coordinate,
                text: landmark.name,
                type: "places" /* MapPointType.Places */,
            }));
        }
        else if (pageType == 'landmark') {
            selector = '.js-activity-landmark-block .js-resort-town-page';
            points = [{
                    coordinates: __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationLandmarkData, "f").coordinate,
                    text: __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationLandmarkData, "f").name,
                    type: "places" /* MapPointType.Places */,
                    selected: true,
                }];
        }
        return [selector, points];
    }, _ActivityPageManagerMobile_showResultSearchActivitiesForLandmark = function _ActivityPageManagerMobile_showResultSearchActivitiesForLandmark(data, mes) {
        return __awaiter(this, void 0, void 0, function* () {
            const responseOffers = data.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_instances, data.subFilters, "a", _ActivityPageManagerMobile_hotFilterSet_set);
            // Если поиск происходит после ввода адреса с параметрами - не перезаписывать историю,
            // т.к. этот адрес и так в истории, а другие параметры удаляются, например, хотфильтры
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual) {
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkResult_get).setDataManipulateParameters();
                App.UrlParameterHelper.setUrlAsIs(data.seo.url);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterLandmark_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSet_get));
            }
            else {
                // устанавливаем параметры необходимые для работы с данными
                const urlParameters = App.UrlParameterHelper.urlParse();
                const dataManipulateParameters = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkResult_get).setDataManipulateParameters(urlParameters);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterLandmark_get).setFilterSortItems(dataManipulateParameters.sorting);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterLandmark_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSet_get), dataManipulateParameters.filtering);
            }
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_currentDataUrl, data.seo.url, "f");
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkFilter, "f")), "f");
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").length > 0) {
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f"));
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).saveSearchResult(__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f"));
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkResult_get).resetDataSource();
                mes.show(App.Message.SearchNoVariants);
            }
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual = true;
        });
    }, _ActivityPageManagerMobile_searchActivities = function _ActivityPageManagerMobile_searchActivities() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).resetDataSource();
            const response = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.Search), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).filterSerializeArray());
            const responseData = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_validateSearchResponse).call(this, response, messages);
            if (!responseData)
                return;
            if (!new App.SearchLocker().check(response.data))
                return;
            const responseOffers = responseData.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_instances, responseData.subFilters, "a", _ActivityPageManagerMobile_hotFilterSet_set);
            // Если поиск происходит после ввода адреса с параметрами - не перезаписывать историю,
            // т.к. этот адрес и так в истории, а другие параметры удаляются, например, хотфильтры
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual) {
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).setDataManipulateParameters();
                App.UrlParameterHelper.setUrlAsIs(responseData.seo.url);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSearch_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSet_get));
            }
            else {
                // устанавливаем параметры необходимые для работы с данными
                const urlParameters = App.UrlParameterHelper.urlParse();
                const dataManipulateParameters = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).setDataManipulateParameters(urlParameters);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSearch_get).setFilterSortItems(dataManipulateParameters.sorting);
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSearch_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_hotFilterSet_get), dataManipulateParameters.filtering);
            }
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_currentDataUrl, responseData.seo.url, "f");
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManagerMobile_searchMainFilters, "f")), "f");
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").length > 0) {
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f"));
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).resetDataSource();
                messages.show(App.Message.SearchNoVariantsWithLink(window.location.href, __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").isPacUa));
            }
            App.app.seo.update(responseData.seo);
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual = true;
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).scrollToOutputBlock();
        });
    }, _ActivityPageManagerMobile_searchActivitiesForLandmark = function _ActivityPageManagerMobile_searchActivitiesForLandmark() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkResult_get).resetDataSource();
            const popup2 = new App.Popup({ root: $('.js-popup-search', '.js-activity-landmark-block') });
            const popupGroup = popup2.show({
                group: 'main',
                content: App.templates.Activity.Popups.Searching({}),
                modal: true,
            });
            const xhr = $.ajax({
                url: App.app.url.route(App.ActivityPageUrls.LandmarkActivity),
                method: 'POST',
                data: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).filterSerializeArray(),
            });
            // const validator = this.#landmarkFilter.root.validate({ ignore: '' });
            const validator = __classPrivateFieldGet(this, _ActivityPageManagerMobile_landmarkFilter, "f").validator; // this.#landmarkPage.getLandmarkValidator
            const responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()), validator });
            try {
                const response = yield xhr;
                if (!responseValidator.process(response))
                    return;
                if (!new App.SearchLocker().check(response.data))
                    return;
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showResultSearchActivitiesForLandmark).call(this, response.data, messages);
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, false, "f");
                popup2.hide(popupGroup);
            }
        });
    }, _ActivityPageManagerMobile_searchActivity = function _ActivityPageManagerMobile_searchActivity() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getErrorPlace() });
            messages.hide();
            const activityId = App.app.url.routeData.id;
            if (activityId == null)
                return;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.Info, activityId), new Array(0));
            if (!App.validateResponse(response, messages))
                return;
            const { activity } = response.data;
            if (!activity)
                return;
            App.app.seo.update(response.data.seo);
            activity.landmarks = __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_landmarksDataTransformation).call(_a, activity.landmarks);
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationActivitiesData, [activity], "f");
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showDetails).call(this, activity, new Array());
        });
    }, _ActivityPageManagerMobile_searchActivitiesForDetail = function _ActivityPageManagerMobile_searchActivitiesForDetail() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f").setMainFilter(App.UrlParameterHelper.urlParse());
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).resetDataSource();
            const activityId = App.app.url.routeData.id;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.SearchActivity, activityId), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).filterSerializeArray(), true, 500);
            const responseData = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_validateSearchResponse).call(this, response, messages);
            if (!responseData)
                return;
            App.app.seo.update(responseData.seo);
            // Здесь приходит инфа только по одному отелю с набором вариантов
            const responseOffers = responseData.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f")), "f");
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").length > 0) {
                if (!activityId)
                    return;
                const currentActivity = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f")[0];
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_currentDataUrl, currentActivity.link, "f");
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationVariantsData, currentActivity.variants, "f");
                if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual)
                    App.UrlParameterHelper.setUrlAsIs(currentActivity.link);
                yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showDetails).call(this, currentActivity, __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f"));
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailResult_get).resetDataSource();
                messages.show(App.Message.SearchNoVariants);
            }
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual = true;
        });
    }, _ActivityPageManagerMobile_searchActivitiesForBooking = function _ActivityPageManagerMobile_searchActivitiesForBooking() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f").setMainFilter(App.UrlParameterHelper.urlParse());
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchResult_get).resetDataSource();
            const activityId = App.app.url.routeData.id;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.SearchActivity, activityId), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).filterSerializeArray());
            const responseData = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_validateSearchResponse).call(this, response, messages);
            if (!responseData)
                return;
            const responseOffers = responseData.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f")), "f");
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").length > 0) {
                if (!activityId)
                    return;
                const currentActivity = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").find(activity => activity.key === activityId);
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationVariantsData, currentActivity
                    ? currentActivity.variants
                    : new Array(), "f");
                const currentBookingUrl = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_book).call(this);
                if (currentBookingUrl) {
                    __classPrivateFieldSet(this, _ActivityPageManagerMobile_currentDataUrl, currentBookingUrl, "f");
                    if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual)
                        App.UrlParameterHelper.setUrlAsIs(currentBookingUrl);
                }
            }
            else {
                messages.show({
                    type: 1 /* MessageType.Warning */,
                    text: 'Экскурсия уже недоступна',
                });
            }
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_options, "f").manual = true;
        });
    }, _ActivityPageManagerMobile_searchLandmark = function _ActivityPageManagerMobile_searchLandmark() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_landmarkPage_get).getErrorPlace() });
            messages.hide();
            const landmarkId = App.app.url.routeData.id;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.Landmark, landmarkId), new Array(0), false);
            if (!App.validateResponse(response, messages))
                return;
            const { landmark } = response.data;
            if (!landmark) {
                messages.show(App.Message.SearchNoVariants);
            }
            App.app.seo.update(response.data.seo);
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationLandmarkData, landmark, "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showLandmark).call(this, landmark);
        });
    }, _ActivityPageManagerMobile_book = function _ActivityPageManagerMobile_book(variantKey) {
        return __awaiter(this, void 0, void 0, function* () {
            // парсим урл и делаем запрос к результату для вывода вариантов
            const urlParameters = App.UrlParameterHelper.urlParse();
            const variantUrl = urlParameters.find(item => item.name === 'variant');
            if (!variantUrl && !variantKey)
                return '';
            const activityId = App.app.url.routeData.id;
            if (activityId == null)
                return '';
            // Ищем экскурсию для отображения инфы об экскурсии
            const currentActivity = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").find(data => data.key === activityId);
            if (!currentActivity)
                return '';
            // Нужный вариант ищем в отдельном свойстве варианта, т.к. при каждом поиске вариантов именно оно обновляется новыми данными
            const currentVariant = __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f").find(data => {
                // TODO: переделать на более универсальный код. Сейчас делаем различие между тем, запрос это после клика на цены, когда
                // приходит ключ и между вводом урла, когда имеем не ключ, а набор дата+цена
                if (!variantKey && variantUrl) {
                    const variantParameter = variantUrl.values.join(',');
                    const variantParameterByString = `${data.beginDate},${data.grossPrice}`;
                    return variantParameterByString.toLowerCase() === variantParameter.toLowerCase();
                }
                return data.key === variantKey;
            });
            let currentBookingUrl = '';
            if (currentVariant) {
                // проверим, есть ли в урле контекст
                const context = urlParameters.find(item => item.name === 'context');
                const contextNumber = context ? context.values[0] : '';
                // Проверка авторизации
                const loggedIn = yield App.app.auth.getStatus();
                if (!loggedIn) {
                    $(document).trigger("app:loggingin" /* Events.LoggingIn */);
                    return '';
                }
                // Сделаем запрос существующих туристов, если это добавление услуги в заказ
                // Делаем проверку на наличие туристов. Такое может быть, если уже переходили на фому бронирования, потом вернулись на
                // поиск, а потом опять перешли на бронирование
                if (contextNumber && !__classPrivateFieldGet(this, _ActivityPageManagerMobile_existingPassengers, "f")) {
                    const response = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.ExistingTourists, { context: contextNumber }), new Array(0));
                    // TODO: мне кажется, тут обработку ошибок можно пропустить - если что-то пойдет не так, просто не будет
                    // предыдущих туристов.
                    if (response.data)
                        __classPrivateFieldSet(this, _ActivityPageManagerMobile_existingPassengers, response.data, "f");
                    else
                        __classPrivateFieldSet(this, _ActivityPageManagerMobile_existingPassengers, undefined, "f");
                }
                const bookData = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.BookData), new Array(0));
                yield this.showBookingForm(currentVariant, currentActivity, contextNumber, bookData.data.allowBooking);
                currentBookingUrl = currentVariant.link;
            }
            return currentBookingUrl;
        });
    }, _ActivityPageManagerMobile_onBlockClick = function _ActivityPageManagerMobile_onBlockClick(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: посмотреть в резалте может избавиться от передачи данных, только ключ передавать
            const activities = data.data;
            const { targetId } = data;
            const currentActivity = activities.find(item => item.key === targetId);
            if (!currentActivity)
                return;
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationVariantsData, currentActivity.variants, "f");
            /* открытие в новом окне*/
            /*
            const typeView = $('.js-search-hot-filter').find('.js-view-item[data-code="table"]').hasClass('_active') ? 'table' : 'block';
            let currentBlock = $(event.currentTarget);
            currentBlock = typeView === 'block' ? currentBlock.find(`a#${targetId}`) : currentBlock.find(`div#${targetId}`);
            if (currentBlock.attr('target') === '_blank') {
                window.open(currentActivity.link);
                return;
            }
            */
            /* открытие в новом окне*/
            App.UrlParameterHelper.setUrlAsIs(currentActivity.link);
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showDetails).call(this, currentActivity, __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationVariantsData, "f"));
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getSeo).call(this, App.UrlParameterHelper.urlParse(), App.app.url.route(App.ActivityPageUrls.SeoInfo, currentActivity.key), __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).filterSerializeArray());
        });
    }, _ActivityPageManagerMobile_onShowLandmarkClick = function _ActivityPageManagerMobile_onShowLandmarkClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.currentTarget);
            const link = target.attr('href');
            if (link)
                App.UrlParameterHelper.setUrlAsIs(link);
            const landmarkId = parseInt((_b = App.app.url.routeData.id) !== null && _b !== void 0 ? _b : '0', 10);
            if (Number.isNaN(landmarkId))
                return;
            if (!__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f") || __classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f").length === 0)
                return;
            const landmark = Enumerable.from(__classPrivateFieldGet(this, _ActivityPageManagerMobile_applicationActivitiesData, "f"))
                .select(v => v.landmarks.find(x => x.key === landmarkId))
                .firstOrDefault(v => !!v);
            if (!landmark)
                return;
            __classPrivateFieldSet(this, _ActivityPageManagerMobile_applicationLandmarkData, landmark, "f");
            __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_showLandmark).call(this, landmark);
            yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_getSeo).call(this, App.UrlParameterHelper.urlParse(), App.app.url.route(App.ActivityPageUrls.SeoLandmark, landmarkId));
        });
    }, _ActivityPageManagerMobile_onDetailBlockClick = function _ActivityPageManagerMobile_onDetailBlockClick(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentBookingUrl = yield __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_book).call(this, data.targetId);
            if (currentBookingUrl)
                App.UrlParameterHelper.setUrlAsIs(currentBookingUrl);
        });
    }, _ActivityPageManagerMobile_setNewVariantUrl = function _ActivityPageManagerMobile_setNewVariantUrl(activityId) {
        const mainFilterParameters = __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f").getUrlDataFromFilter();
        return App.app.url.route(App.ActivityPageUrls.Info, activityId, mainFilterParameters);
    }, _ActivityPageManagerMobile_activitiesDataTransformation = function _ActivityPageManagerMobile_activitiesDataTransformation(rawData, mainFilter) {
        const mainFilterParameters = mainFilter.getUrlDataFromFilter();
        // удалим лишние параметры из параметров урла
        const reducedSearchUrlParameters = mainFilterParameters
            .filter(item => item.name !== App.ActivityUrlParameters.location);
        return rawData.map(item => {
            item.firstVariantDate = new Date(item.beginDate).toLocaleString('ru', { year: 'numeric', month: 'numeric', day: 'numeric' });
            item.link = App.app.url.route(App.ActivityPageUrls.Info, item.key, reducedSearchUrlParameters);
            item.landmarks = __classPrivateFieldGet(_a, _a, "m", _ActivityPageManagerMobile_landmarksDataTransformation).call(_a, item.landmarks);
            return item;
        });
    }, _ActivityPageManagerMobile_variantsDataTransformation = function _ActivityPageManagerMobile_variantsDataTransformation(variants, activityId) {
        // соберем параметры с детального фильтра
        const detailFilterParameters = __classPrivateFieldGet(this, _ActivityPageManagerMobile_detailFilter, "f").getUrlDataFromFilter();
        return variants.map(item => {
            // добавим параметр для варианта
            let urlParameters = new Array();
            urlParameters = urlParameters.concat(detailFilterParameters);
            urlParameters.push({ name: 'variant', values: [`${item.beginDate},${item.grossPrice}`] });
            // сформируем урл для бронирования
            item.link = App.app.url.route(App.ActivityPageUrls.Book, activityId, urlParameters);
            return item;
        });
    }, _ActivityPageManagerMobile_landmarksDataTransformation = function _ActivityPageManagerMobile_landmarksDataTransformation(landmarks) {
        return landmarks.map(item => {
            item.link = App.app.url.route(App.ActivityPageUrls.Landmark, item.key);
            return item;
        });
    }, _ActivityPageManagerMobile_createLandmarkTypeIcons = function _ActivityPageManagerMobile_createLandmarkTypeIcons(landmark) {
        landmark.types.map(type => {
            type.icon = `landmark_${type.code}`;
            return type;
        });
    }, _ActivityPageManagerMobile_onBeforeSearch = function _ActivityPageManagerMobile_onBeforeSearch(xhr, delayTime) {
        __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_preloader_get).show({ delay: delayTime });
        __classPrivateFieldSet(this, _ActivityPageManagerMobile_activeRequest, xhr, "f");
    }, _ActivityPageManagerMobile_validateSearchResponse = function _ActivityPageManagerMobile_validateSearchResponse(response, messages) {
        // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо
        // их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
        if (!response.status.success || response.data == null) {
            if (response.status.modelState) {
                const validator = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_searchPage_get).getMainFilterValidator(); // $(this.#searchPage.getMainFilter()).validate();
                validator.showErrors(response.status.modelState.errors);
            }
            else if (response.status.messages) {
                messages.show(response.status.messages);
            }
            return undefined;
        }
        if (response.redirect != null)
            window.location.href = response.redirect;
        // TODO: пока не удалось убрать ошибку валидации для туристов. е сли из урла удалить туристов. появится ошибка. если потмо
        // туристов заполнить и послать запрос. ошибка не убирается
        // validator.resetForm();
        return response.data;
    }, _ActivityPageManagerMobile_validateVariantResponse = function _ActivityPageManagerMobile_validateVariantResponse(response, messages) {
        // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо
        // их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
        if (!response.status.success || response.data == null) {
            if (response.status.modelState) {
                // const validator = $(this.#detailPage.getDetailFilter()).validate();
                const validator = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_detailPage_get).getDetailValidator();
                validator.showErrors(response.status.modelState.errors);
            }
            else if (response.status.messages) {
                messages.show(response.status.messages);
            }
            return undefined;
        }
        if (response.redirect != null)
            window.location.href = response.redirect;
        // TODO: пока не удалось убрать ошибку валидации для туристов. е сли из урла удалить туристов. появится ошибка. если потмо
        // туристов заполнить и послать запрос. ошибка не убирается
        // validator.resetForm();
        return response.data;
    }, _ActivityPageManagerMobile_getSeo = function _ActivityPageManagerMobile_getSeo(urlParameters, url, formFields) {
        return __awaiter(this, void 0, void 0, function* () {
            let form = formFields || new Array();
            // Если форма типа-пустая, то оставляем в ней только context и передаем таким образом на сервер
            if (__classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_emptyUrlChecker_get).isEmpty(urlParameters))
                form = form.filter(item => item.name === App.ActivityFilterFields.Context);
            const xhr = __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_sendPostRequest).call(this, url, form);
            try {
                const response = yield xhr;
                App.app.seo.update(response.data);
            }
            catch (e) {
                // TODO: кажется, тут не надо выводить ошибку, т.к. это не основной запрос на странице
            }
        });
    }, _ActivityPageManagerMobile_sendPostRequest = function _ActivityPageManagerMobile_sendPostRequest(url_1, sendData_1) {
        return __awaiter(this, arguments, void 0, function* (url, sendData, showPreloader = true, delay = 0) {
            const xhr = $.ajax({
                url,
                method: 'POST',
                dataType: 'json',
                data: sendData,
            });
            if (showPreloader)
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_onBeforeSearch).call(this, xhr, delay);
            try {
                return yield xhr;
            }
            finally {
                if (showPreloader)
                    __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "a", _ActivityPageManagerMobile_preloader_get).hide();
                __classPrivateFieldSet(this, _ActivityPageManagerMobile_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _ActivityPageManagerMobile_instances, "m", _ActivityPageManagerMobile_clearActiveRequest).call(this);
            }
        });
    }, _ActivityPageManagerMobile_stopRequest = function _ActivityPageManagerMobile_stopRequest(xhr) {
        if (xhr)
            xhr.abort();
    }, _ActivityPageManagerMobile_clearActiveRequest = function _ActivityPageManagerMobile_clearActiveRequest() {
        __classPrivateFieldSet(this, _ActivityPageManagerMobile_activeRequest, undefined, "f");
    };
    App.ActivityPageManagerMobile = ActivityPageManagerMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _ActivityPageManager_instances, _a, _ActivityPageManager_options, _ActivityPageManager_preloaderField, _ActivityPageManager_hotFilterSearchField, _ActivityPageManager_hotFilterDetailField, _ActivityPageManager_hotFilterLandmarkField, _ActivityPageManager_searchMainFilters, _ActivityPageManager_searchResultField, _ActivityPageManager_searchPageField, _ActivityPageManager_detailFilter, _ActivityPageManager_landmarkFilter, _ActivityPageManager_detailResultField, _ActivityPageManager_detailPageField, _ActivityPageManager_bookPageField, _ActivityPageManager_landmarkPageField, _ActivityPageManager_landmarkResultField, _ActivityPageManager_searchExecuting, _ActivityPageManager_applicationActivitiesData, _ActivityPageManager_applicationVariantsData, _ActivityPageManager_applicationLandmarkData, _ActivityPageManager_hotFilterSetField, _ActivityPageManager_existingPassengers, _ActivityPageManager_currentDataUrl, _ActivityPageManager_activeRequest, _ActivityPageManager_requiredUrlCheckerField, _ActivityPageManager_emptyUrlCheckerField, _ActivityPageManager_preloader_get, _ActivityPageManager_hotFilterSearch_get, _ActivityPageManager_hotFilterDetail_get, _ActivityPageManager_hotFilterLandmark_get, _ActivityPageManager_hotFilterSet_get, _ActivityPageManager_hotFilterSet_set, _ActivityPageManager_searchPage_get, _ActivityPageManager_detailResult_get, _ActivityPageManager_detailPage_get, _ActivityPageManager_bookPage_get, _ActivityPageManager_landmarkPage_get, _ActivityPageManager_searchResult_get, _ActivityPageManager_landmarkResult_get, _ActivityPageManager_requiredUrlChecker_get, _ActivityPageManager_emptyUrlChecker_get, _ActivityPageManager_start, _ActivityPageManager_onHistoryPopState, _ActivityPageManager_searchHistoryChange, _ActivityPageManager_detailHistoryChange, _ActivityPageManager_landmarkHistoryChange, _ActivityPageManager_setManualSearch, _ActivityPageManager_searchActivityVariants, _ActivityPageManager_showDetails, _ActivityPageManager_showLandmark, _ActivityPageManager_onShowMapClick, _ActivityPageManager_onHideMapClick, _ActivityPageManager_getMapData, _ActivityPageManager_showResultSearchActivitiesForLandmark, _ActivityPageManager_searchActivities, _ActivityPageManager_searchActivitiesForLandmark, _ActivityPageManager_searchActivity, _ActivityPageManager_searchActivitiesForDetail, _ActivityPageManager_searchActivitiesForBooking, _ActivityPageManager_searchLandmark, _ActivityPageManager_book, _ActivityPageManager_onBlockClick, _ActivityPageManager_onShowLandmarkClick, _ActivityPageManager_onDetailBlockClick, _ActivityPageManager_setNewVariantUrl, _ActivityPageManager_activitiesDataTransformation, _ActivityPageManager_variantsDataTransformation, _ActivityPageManager_landmarksDataTransformation, _ActivityPageManager_createLandmarkTypeIcons, _ActivityPageManager_onBeforeSearch, _ActivityPageManager_validateSearchResponse, _ActivityPageManager_validateVariantResponse, _ActivityPageManager_getSeo, _ActivityPageManager_sendPostRequest, _ActivityPageManager_stopRequest, _ActivityPageManager_clearActiveRequest;
    // Класс, управляющий страницами.
    // Идея в том, что здесь должны собираться в кучку остальные классы - конкретные Result, Filter и некотоыре другие.
    // В Page оставила только то, что относится непосредственно к разметке - объявление блоков, подписка на события.
    // Dom-элементы , которые нужны здесь, возвращаются из Page типа - геттерами(переделать на прямо - геттеры)
    // Примерно такая идеология
    // 1. Поиск(Url activity / search)
    //    a. При клике по кнопке фильтра
    //        - поиск на сервере
    //        - Установка applicationData
    //        - Установка _currentDataUrl
    //        - Установка истории
    //        - Отдаются все экскурсии, соответствующие фильтру с вариантами
    //    b. При клике по блоку
    //        - Поиск в applicationData
    //        - Нет установки applicationData
    //        - Нет установки _currentDataUrl
    //        - Есть установка истории
    //    c. При поиске по фильтру в вариантах
    //        - поиск на сервере по одному отелю
    //        - ? Установка applicationData - ведь мы можем вернуться на поиск экскурсий.
    //        - ? Установка _currentDataUrl
    //        - Установка истории
    //    d. Назад
    //        - т.к.всегда меняется Url после поиска и данные, то каждый раз новый поиск
    // 2. Ввод url activity / search - тоже самое кроме того, что не устанавливаем историю по options.manual = false
    // 3. Поиск вариантов по фильтру вариантов(Url activity / variant)
    //    a. При клике по кнопке фильтра -
    //        - поиск на сервере
    //        - Установка applicationData
    //        - Установка _currentDataUrl
    //        - Установка истории
    //        - Отдается одна экскурсия, соответствующая фильтру с ЕЁ вариантами
    //    b. При клике по блоку
    //        - Поиск в applicationData
    //        - Нет установки applicationData
    //        - Нет установки _currentDataUrl
    //        - Есть установка истории
    //    c. При поиске по фильтру в вариантах
    //        - поиск на сервере по одному отелю
    //        - ? Установка applicationData - ведь мы можем вернуться на поиск экскурсий.
    //        - ? Установка _currentDataUrl
    //        - Установка истории
    //    d. Назад
    //        - Поиски могут меняться, значит данные уже новые и урлы новые - т.е.новый поиск по отелю
    //        - Может быть, что сразу вернутсья на search - тогда поиска еще не было, данные те же и url тот же.
    // Итого
    //  1. При поисках на сервере менять _currentDataUrl и applicationData
    //      a. При переходах по клику не менять
    //  2. В поиске если !options.manual - НЕ менять history,
    // При кликах - менять history
    class ActivityPageManager {
        constructor(options) {
            _ActivityPageManager_instances.add(this);
            _ActivityPageManager_options.set(this, void 0);
            _ActivityPageManager_preloaderField.set(this, void 0);
            _ActivityPageManager_hotFilterSearchField.set(this, void 0);
            _ActivityPageManager_hotFilterDetailField.set(this, void 0);
            _ActivityPageManager_hotFilterLandmarkField.set(this, void 0);
            _ActivityPageManager_searchMainFilters.set(this, void 0);
            _ActivityPageManager_searchResultField.set(this, void 0);
            _ActivityPageManager_searchPageField.set(this, void 0);
            _ActivityPageManager_detailFilter.set(this, void 0);
            _ActivityPageManager_landmarkFilter.set(this, void 0);
            _ActivityPageManager_detailResultField.set(this, void 0);
            _ActivityPageManager_detailPageField.set(this, void 0);
            _ActivityPageManager_bookPageField.set(this, void 0);
            _ActivityPageManager_landmarkPageField.set(this, void 0);
            _ActivityPageManager_landmarkResultField.set(this, void 0);
            // признак того, что сейчас производится поиск. Чтобы новый не начинать
            _ActivityPageManager_searchExecuting.set(this, false);
            // данные
            _ActivityPageManager_applicationActivitiesData.set(this, void 0);
            _ActivityPageManager_applicationVariantsData.set(this, void 0);
            _ActivityPageManager_applicationLandmarkData.set(this, void 0);
            _ActivityPageManager_hotFilterSetField.set(this, void 0);
            _ActivityPageManager_existingPassengers.set(this, void 0);
            /**
             * главный url поиска, который формируется при нажатии на кнопку поиска
             * Т.е. это Url, который соответсвует имеющимся на странице данным
             * Меняется как при поиске экскурсий, так и при поиске вариантов
             */
            _ActivityPageManager_currentDataUrl.set(this, void 0);
            // Запрос для последующей остановки
            _ActivityPageManager_activeRequest.set(this, void 0);
            _ActivityPageManager_requiredUrlCheckerField.set(this, void 0);
            _ActivityPageManager_emptyUrlCheckerField.set(this, void 0);
            Object.defineProperty(this, "components", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            __classPrivateFieldSet(this, _ActivityPageManager_options, options, "f");
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onHistoryPopState).call(this); }));
            // TODO: переделать на событие https://keestalkstech.com/2016/03/strongly-typed-event-handlers-in-typescript-part-1/
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getSearchBlock().on("block:click" /* Events.BlockClick */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onBlockClick).call(this, e, data); }));
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getDetailBlock().on("block:click" /* Events.BlockClick */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onDetailBlockClick).call(this, e, data); }));
            // проверка на валидность фильтра делается в странице при возбуждении события
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getSearchButton().on("searchButton:click" /* Events.SearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivities).call(this); }));
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getSearchButton().on("detailSearchButton:click" /* Events.DetailSearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivityVariants).call(this); }));
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).getSearchButton().on("searchButton:click" /* Events.SearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivitiesForLandmark).call(this); }));
            // TODO: переделать как в отелях (может нет смысла, т.к. в отелях здесь все равно есть инициализация ввиде присваивания
            // неиспользуемой переменной)
            __classPrivateFieldSet(this, _ActivityPageManager_detailFilter, new App.ActivityDetailMainFilter({
                datesOptions: {
                    maxDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").maxDateToOffset,
                    defaultDateFromShift: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateFromShift,
                    defaultDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateToShift - __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateFromShift,
                    minDateFromShift: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").minDateFromShift,
                    minDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").minDateToOffset,
                },
                peopleOptions: {
                    maxChildAge: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").maxChildAge,
                    defaultAdultCountValue: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultAdultCount,
                },
            }), "f");
            const dateFromLimit = __classPrivateFieldGet(this, _ActivityPageManager_options, "f").dateFromLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _ActivityPageManager_options, "f").dateFromLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _ActivityPageManager_options, "f").dateFromLimit.max) };
            __classPrivateFieldSet(this, _ActivityPageManager_searchMainFilters, new App.ActivitySearchMainFilter({
                datesOptions: {
                    minDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.min,
                    maxDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.max,
                    maxDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").maxDateToOffset,
                    defaultDateFromShift: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateFromShift,
                    defaultDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateToShift - __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateFromShift,
                    minDateFromShift: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").minDateFromShift,
                    minDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").minDateToOffset,
                },
                peopleOptions: {
                    maxChildAge: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").maxChildAge,
                    defaultAdultCountValue: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultAdultCount,
                },
            }), "f");
            __classPrivateFieldSet(this, _ActivityPageManager_landmarkFilter, new App.ActivityLandmarkMainFilter({
                datesOptions: {
                    minDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.min,
                    maxDateFrom: dateFromLimit === null || dateFromLimit === void 0 ? void 0 : dateFromLimit.max,
                    maxDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").maxDateToOffset,
                    defaultDateFromShift: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateFromShift,
                    defaultDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateToShift - __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultDateFromShift,
                    minDateFromShift: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").minDateFromShift,
                    minDateToOffset: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").minDateToOffset,
                },
                peopleOptions: {
                    maxChildAge: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").maxChildAge,
                    defaultAdultCountValue: __classPrivateFieldGet(this, _ActivityPageManager_options, "f").defaultAdultCount,
                },
            }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_stopRequest).call(_a, __classPrivateFieldGet(this, _ActivityPageManager_activeRequest, "f"));
                    inst.hide();
                }
            });
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                if (App.app.url.routeData.action !== 'info')
                    return;
                const activity = __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f")[0];
                const filters = Enumerable.from(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).filterSerializeArray());
                // TODO Titov: договориться с Кириллом и заменить '#offer-sub-ids' на 'input[name="pacngo-offer-sub-ids"]'.
                const variantKeys = $('input[name="pacngo-offer-sub-ids"]').valString().split(';').filter(v => v !== '');
                const variants = variantKeys
                    .map(v => __classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f").find(x => App.formatDate(x.beginDate, 'shortDate') === v))
                    .filter(App.notUndefined);
                const data = {
                    type: 'activity',
                    filter: {
                        adultCount: filters
                            .where(v => v.name === 'Tourist.AdultCount')
                            .select(v => parseInt(v.value, 10))
                            .first(),
                        childAges: filters
                            .where(v => v.name === 'Tourist.ChildAges.Age')
                            .where(v => !!v.value)
                            .select(v => parseInt(v.value, 10))
                            .toArray(),
                    },
                    info: {
                        key: activity.key,
                        name: activity.name,
                        country: activity.country,
                        city: activity.city,
                        guideTypeName: activity.guideType.name,
                        isGroup: activity.isGroup,
                        transportTypeName: activity.transportType.name,
                        titleImage: activity.titleImage,
                        facilityNames: activity.facilities
                            .map(v => v.name),
                        landmarks: activity.landmarks
                            .map(v => ({
                            key: v.key,
                            name: v.name,
                        })),
                        duration: (activity.duration.days * App.hoursPerDay + activity.duration.hours) * App.minutesPerHour
                            + activity.duration.minutes,
                    },
                    variants: variants
                        .map(v => ({
                        beginDate: App.parseIsoDate(v.beginDate),
                        netPrice: v.netPrice,
                        grossPrice: v.grossPrice,
                        price: v.price,
                        currencyCode: v.currencyCode,
                    })),
                };
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта (при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data,
                    },
                }));
            });
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_start).call(this); }))();
        }
        /**
         * Начинает бронирование - отображает форму
         * @param activityVariant вариант для бронирования
         * @param activityOffer само предложение по экскурсии
         * @param context - контекст (номер заказа)
         */
        showBookingForm(activityVariant, activityOffer, context, allowBooking) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!activityVariant)
                    return;
                if (!activityVariant.key)
                    return;
                // передать данные в шаблон и вставить его
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).renderBookingSection(activityVariant, activityOffer, context, allowBooking, __classPrivateFieldGet(this, _ActivityPageManager_existingPassengers, "f"));
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).pageClose();
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageClose();
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).pageOpen();
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getHeader().html(localizer.bookingExcursion);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).scrollToOutputBlock();
            });
        }
    }
    _a = ActivityPageManager, _ActivityPageManager_options = new WeakMap(), _ActivityPageManager_preloaderField = new WeakMap(), _ActivityPageManager_hotFilterSearchField = new WeakMap(), _ActivityPageManager_hotFilterDetailField = new WeakMap(), _ActivityPageManager_hotFilterLandmarkField = new WeakMap(), _ActivityPageManager_searchMainFilters = new WeakMap(), _ActivityPageManager_searchResultField = new WeakMap(), _ActivityPageManager_searchPageField = new WeakMap(), _ActivityPageManager_detailFilter = new WeakMap(), _ActivityPageManager_landmarkFilter = new WeakMap(), _ActivityPageManager_detailResultField = new WeakMap(), _ActivityPageManager_detailPageField = new WeakMap(), _ActivityPageManager_bookPageField = new WeakMap(), _ActivityPageManager_landmarkPageField = new WeakMap(), _ActivityPageManager_landmarkResultField = new WeakMap(), _ActivityPageManager_searchExecuting = new WeakMap(), _ActivityPageManager_applicationActivitiesData = new WeakMap(), _ActivityPageManager_applicationVariantsData = new WeakMap(), _ActivityPageManager_applicationLandmarkData = new WeakMap(), _ActivityPageManager_hotFilterSetField = new WeakMap(), _ActivityPageManager_existingPassengers = new WeakMap(), _ActivityPageManager_currentDataUrl = new WeakMap(), _ActivityPageManager_activeRequest = new WeakMap(), _ActivityPageManager_requiredUrlCheckerField = new WeakMap(), _ActivityPageManager_emptyUrlCheckerField = new WeakMap(), _ActivityPageManager_instances = new WeakSet(), _ActivityPageManager_preloader_get = function _ActivityPageManager_preloader_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_preloaderField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_preloaderField, "f");
    }, _ActivityPageManager_hotFilterSearch_get = function _ActivityPageManager_hotFilterSearch_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_hotFilterSearchField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_hotFilterSearchField, new App.ActivitySearchHotFilter(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_hotFilterSearchField, "f");
    }, _ActivityPageManager_hotFilterDetail_get = function _ActivityPageManager_hotFilterDetail_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_hotFilterDetailField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_hotFilterDetailField, new App.ActivityDetailHotFilter(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_hotFilterDetailField, "f");
    }, _ActivityPageManager_hotFilterLandmark_get = function _ActivityPageManager_hotFilterLandmark_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_hotFilterLandmarkField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_hotFilterLandmarkField, new App.ActivityLandmarkHotFilter(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_hotFilterLandmarkField, "f");
    }, _ActivityPageManager_hotFilterSet_get = function _ActivityPageManager_hotFilterSet_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_hotFilterSetField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_hotFilterSetField, new App.ActivityHotFilterSet(), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_hotFilterSetField, "f");
    }, _ActivityPageManager_hotFilterSet_set = function _ActivityPageManager_hotFilterSet_set(value) {
        __classPrivateFieldSet(this, _ActivityPageManager_hotFilterSetField, value, "f");
    }, _ActivityPageManager_searchPage_get = function _ActivityPageManager_searchPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_searchPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_searchPageField, new App.ActivitySearchPage(__classPrivateFieldGet(this, _ActivityPageManager_options, "f")), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_searchPageField, "f");
    }, _ActivityPageManager_detailResult_get = function _ActivityPageManager_detailResult_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_detailResultField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_detailResultField, new App.ActivityDetailResult(Object.assign({ hotFilter: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterDetail_get) }, __classPrivateFieldGet(this, _ActivityPageManager_options, "f"))), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_detailResultField, "f");
    }, _ActivityPageManager_detailPage_get = function _ActivityPageManager_detailPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_detailPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_detailPageField, new App.ActivityDetailPage(__classPrivateFieldGet(this, _ActivityPageManager_options, "f")), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_detailPageField, "f");
    }, _ActivityPageManager_bookPage_get = function _ActivityPageManager_bookPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_bookPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_bookPageField, new App.ActivityBookPage(__classPrivateFieldGet(this, _ActivityPageManager_options, "f")), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_bookPageField, "f");
    }, _ActivityPageManager_landmarkPage_get = function _ActivityPageManager_landmarkPage_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_landmarkPageField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_landmarkPageField, new App.ActivityLandmarkPage(__classPrivateFieldGet(this, _ActivityPageManager_options, "f")), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_landmarkPageField, "f");
    }, _ActivityPageManager_searchResult_get = function _ActivityPageManager_searchResult_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_searchResultField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_searchResultField, new App.ActivityResult({ hotFilter: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSearch_get) }), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_searchResultField, "f");
    }, _ActivityPageManager_landmarkResult_get = function _ActivityPageManager_landmarkResult_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_landmarkResultField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_landmarkResultField, new App.ActivityLandmarkResult({ hotFilter: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterLandmark_get) }), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_landmarkResultField, "f");
    }, _ActivityPageManager_requiredUrlChecker_get = function _ActivityPageManager_requiredUrlChecker_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_requiredUrlCheckerField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_requiredUrlCheckerField, new App.RequiredUrlChecker(new App.ActivityUrlParameters()), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_requiredUrlCheckerField, "f");
    }, _ActivityPageManager_emptyUrlChecker_get = function _ActivityPageManager_emptyUrlChecker_get() {
        if (!__classPrivateFieldGet(this, _ActivityPageManager_emptyUrlCheckerField, "f"))
            __classPrivateFieldSet(this, _ActivityPageManager_emptyUrlCheckerField, new App.EmptyUrlChecker(new App.ActivityUrlParameters()), "f");
        return __classPrivateFieldGet(this, _ActivityPageManager_emptyUrlCheckerField, "f");
    }, _ActivityPageManager_start = function _ActivityPageManager_start() {
        return __awaiter(this, void 0, void 0, function* () {
            const actionName = App.app.url.routeData.action;
            if (!actionName)
                return;
            // Установка параметра автопоиска this.options.manual (подробный коммент в методе)
            yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_setManualSearch).call(this, actionName);
            // проверяем, откуда начинать
            switch (actionName) {
                case 'search':
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageOpen();
                    // если надо делать автопоиск сразу при загрузке скрипта
                    // Это делается, если введен url в браузер и надо найти все, что в нем
                    if (!__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual) {
                        // подставить соответствующие значения урла на форму поиска
                        yield __classPrivateFieldGet(this, _ActivityPageManager_searchMainFilters, "f").setMainFilter(App.UrlParameterHelper.urlParse());
                        yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivities).call(this);
                        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getPromoBlock().hide();
                    }
                    break;
                case 'info':
                    if (__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual)
                        yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivity).call(this);
                    else
                        yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivitiesForDetail).call(this);
                    break;
                case 'book':
                    if (!__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual)
                        yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivitiesForBooking).call(this);
                    break;
                case 'landmark':
                    if (!__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual) {
                        // подставить соответствующие значения урла на форму поиска
                        yield __classPrivateFieldGet(this, _ActivityPageManager_landmarkFilter, "f").setMainFilter(App.UrlParameterHelper.urlParse());
                    }
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchLandmark).call(this);
                    break;
                // no default
            }
        });
    }, _ActivityPageManager_onHistoryPopState = function _ActivityPageManager_onHistoryPopState() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentUrl = window.location.pathname.toLowerCase();
            const regExpMatch = new RegExp('^/activity/[a-zA-Z]+').exec(currentUrl);
            if (!regExpMatch)
                return;
            const mainRoute = regExpMatch[0];
            switch (mainRoute) {
                case App.ActivityPageUrls.Search:
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchHistoryChange).call(this);
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageOpen();
                    break;
                case App.ActivityPageUrls.Info:
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).pageOpen();
                    if (!__classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f"))
                        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).resetDataSource();
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_detailHistoryChange).call(this);
                    break;
                case App.ActivityPageUrls.Landmark:
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_landmarkHistoryChange).call(this);
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).pageOpen();
                    break;
                case App.ActivityPageUrls.Book:
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_book).call(this);
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageClose();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).pageOpen();
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getHeader().html(localizer.bookingExcursion);
                    break;
                // no default
            }
        });
    }, _ActivityPageManager_searchHistoryChange = function _ActivityPageManager_searchHistoryChange() {
        return __awaiter(this, void 0, void 0, function* () {
            // Парсим урл
            const urlParameters = App.UrlParameterHelper.urlParse();
            // соответсвуют данные урлу или нет
            const dataMatchUrl = App.UrlParameterHelper.contains(__classPrivateFieldGet(this, _ActivityPageManager_currentDataUrl, "f"));
            // 1. Если данные соответствуют урлу, просто отображаем данные в соответствии с параметрами, не загружаем данные заново
            // 2. Если данные не соответствуют урлу, пихаем параметры поиска в главный фильтр и запускаем поиск
            // 3. Если это страница поиска, т.е.урл типа activity/search, то скрываем отображённое, очищаем фильтры и оставляем только форму
            const canSearch = __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_requiredUrlChecker_get).isValid(urlParameters) && !App.UrlParameterHelper.isManual(urlParameters);
            if (dataMatchUrl) {
                // устанавливаем параметры необходимые для работы с данными
                const dataManipulateParameters = __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).setDataManipulateParameters(urlParameters);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSearch_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSet_get), dataManipulateParameters.filtering);
                if (__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f") && __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").length > 0)
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f"));
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoSearch), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).filterSerializeArray());
            }
            else if (canSearch) {
                // подставить соответствующие значения урла на форму поиска
                yield __classPrivateFieldGet(this, _ActivityPageManager_searchMainFilters, "f").setMainFilter(urlParameters);
                // запустить поиск
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivities).call(this);
            }
            else {
                // TODO: возможно, надо будет  сделать очистку формы, но пока пусть будет так
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).resetDataSource();
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoSearch), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).filterSerializeArray());
            }
        });
    }, _ActivityPageManager_detailHistoryChange = function _ActivityPageManager_detailHistoryChange() {
        return __awaiter(this, void 0, void 0, function* () {
            // Парсим урл
            const urlParameters = App.UrlParameterHelper.urlParse();
            // соответсвуют данные урлу или нет
            const dataMatchUrl = App.UrlParameterHelper.contains(__classPrivateFieldGet(this, _ActivityPageManager_currentDataUrl, "f"));
            // 1. Если данные соответсвуют урлу, просто отображаем данные в сответсвии с парамтерами, не загружаем данные заново
            // 2. Если данные не соответсвуют урлу, пихаем парамтры поиска в главный фильтр и запускаем поиск
            // 3. Если это страница инфо об экскурсии, т.е. урл типа activity/info/55, то показываем только инфо
            const activityId = App.app.url.routeData.id;
            const doSearch = activityId != null && !App.UrlParameterHelper.isManual(urlParameters);
            if (dataMatchUrl) {
                if (__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").length > 0) {
                    // устанавливаем параметры, необходимые для работы с данными
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).setDataManipulateParameters(urlParameters);
                    // сначала ищем в экскусриях и берем ТОЛЬКО экскурсию
                    const currentActivity = __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").find(item => item.key === activityId);
                    // потмо берем _applicationVariantsData, т.к. мы уже могли поискать в вариантах и они не совпадают с теми,
                    // что в _applicationActivitiesData
                    if (currentActivity)
                        yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showDetails).call(this, currentActivity, __classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f"));
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoInfo, activityId), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).filterSerializeArray());
                }
            }
            else if (doSearch) {
                // подставить соответсвующие значения урла на форму поиска
                yield __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f").setMainFilter(urlParameters);
                // запустить поиск
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_searchActivitiesForDetail).call(this);
            }
            else {
                if (activityId != null) {
                    // сюда приходим, если вернулись с достопримечательностей или подбора вариантов
                    const currentActivity = __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").find(item => item.key === activityId);
                    if (currentActivity) {
                        yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showDetails).call(this, currentActivity, new Array());
                        // Скрыть сообщение об ошибке. оставшееся от предыдущих действий
                        const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getErrorPlace() });
                        messages.hide();
                    }
                }
                else {
                    // TODO: возможно, надо будет  сделать очистку формы, но пока пусть будет так
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).resetDataSource();
                }
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getSeo).call(this, urlParameters, App.app.url.route(App.ActivityPageUrls.SeoInfo, activityId), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).filterSerializeArray());
            }
        });
    }, _ActivityPageManager_landmarkHistoryChange = function _ActivityPageManager_landmarkHistoryChange() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            // Для достопримечательностей надо просто хранить их в переменной и проверять по ключу - совпадает или нет.
            const landmarkId = parseInt((_b = App.app.url.routeData.id) !== null && _b !== void 0 ? _b : '0', 10);
            let landmark;
            if (__classPrivateFieldGet(this, _ActivityPageManager_applicationLandmarkData, "f") && __classPrivateFieldGet(this, _ActivityPageManager_applicationLandmarkData, "f").key === landmarkId)
                landmark = __classPrivateFieldGet(this, _ActivityPageManager_applicationLandmarkData, "f");
            //  Если не совпадает, ищем в загруженных экскурсиях
            if (!landmark) {
                landmark = Enumerable.from(__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f"))
                    .select(v => v.landmarks.find(x => x.key === landmarkId))
                    .firstOrDefault(v => !!v);
            }
            if (!landmark)
                return;
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showLandmark).call(this, landmark);
            yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getSeo).call(this, App.UrlParameterHelper.urlParse(), App.app.url.route(App.ActivityPageUrls.SeoLandmark, landmarkId));
        });
    }, _ActivityPageManager_setManualSearch = function _ActivityPageManager_setManualSearch(actionName) {
        return __awaiter(this, void 0, void 0, function* () {
            const urlParameters = App.UrlParameterHelper.urlParse();
            // Установить фильтр
            yield __classPrivateFieldGet(this, _ActivityPageManager_searchMainFilters, "f").setMainFilter(urlParameters);
            // TODO: Пока тупая проверка на заполненность (наличие контекста не учитываем)
            // Если параметров нет или он один и содержит  контекст = значит грузим чистую форму
            // Если один параметр и содержит tour, тоже типа auto, но форма не нужна и обрабатываем это дальше
            let isValid = false;
            switch (actionName) {
                case 'search':
                    isValid = __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_requiredUrlChecker_get).isValid(urlParameters);
                    break;
                case 'info':
                    isValid = App.app.url.routeData.id != null;
                    break;
                case 'book':
                    isValid = App.app.url.routeData.id != null;
                    break;
                case 'landmark':
                    isValid = App.app.url.routeData.id != null;
                    break;
            }
            __classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual = !isValid || App.UrlParameterHelper.isManual(urlParameters) || App.UrlParameterHelper.isTourBook(urlParameters);
        });
    }, _ActivityPageManager_searchActivityVariants = function _ActivityPageManager_searchActivityVariants() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManager_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).resetDataSource();
            // TODO: все запросы тут делаются через метод с колбеком - вынести
            const xhr = $.ajax({
                url: App.app.url.route(App.ActivityPageUrls.Variants, App.app.url.routeData.id),
                method: 'POST',
                dataType: 'json',
                data: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).filterSerializeArray(),
            });
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onBeforeSearch).call(this, xhr, 500);
            try {
                const response = yield xhr;
                const responseData = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_validateVariantResponse).call(this, response, messages);
                if (!responseData)
                    return;
                const responseVariants = responseData.variants || new Array(0);
                App.app.seo.update(responseData.seo);
                const activityId = (_b = App.app.url.routeData.id) !== null && _b !== void 0 ? _b : '0';
                const newUrl = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_setNewVariantUrl).call(this, activityId);
                // Если поиск происходит после ввода адреса с параметрами, не перезаписывать историю, т.к. этот адрес итак в истории, а
                // другие парамтеры удаляются, например, хотфильтры.
                if (__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual)
                    App.UrlParameterHelper.setUrlAsIs(newUrl);
                __classPrivateFieldSet(this, _ActivityPageManager_currentDataUrl, newUrl, "f");
                __classPrivateFieldSet(this, _ActivityPageManager_applicationVariantsData, __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_variantsDataTransformation).call(this, responseVariants, activityId), "f");
                // Определение наличия результатов поиска
                if (__classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f").length > 0) {
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).pageOpen();
                    yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f"));
                }
                else {
                    messages.show(App.Message.SearchNoVariants);
                }
                __classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual = true;
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).scrollLinkShow();
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).scrollToOutputBlock();
            }
            finally {
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_preloader_get).hide();
                __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_clearActiveRequest).call(this);
            }
        });
    }, _ActivityPageManager_showDetails = function _ActivityPageManager_showDetails(activity, variants) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageClose();
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_bookPage_get).pageClose();
            if (!activity)
                return;
            const activityId = activity.key;
            if (!activityId)
                return;
            $('.js-pacngo-activity-details-block', __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).root)
                .addBack('.js-pacngo-activity-details-block')
                .attr('data-pacngo-offer-uid', activityId)
                // TODO Titov: договориться с Кириллом и убрать вариант data-pacngo-offer-uid (оставить только data-pacngo-offer-uid).
                .attr('data-offer-uid', activityId);
            // передать данные в шаблон и вставить его
            __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_landmarksDataTransformation).call(_a, activity.landmarks);
            activity.isHostUa = window.location.hostname === 'www.pac.ua';
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).renderInfo(activity);
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getLandmarkLink().on("landmark:click" /* Events.LandmarkClick */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onShowLandmarkClick).call(this, e); }));
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getMapButton().on('click', e => __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onShowMapClick).call(this, e));
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getHideMapButton().on('click', e => __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onHideMapClick).call(this, e));
            // вставить описание в нужные блоки
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).renderDescription(activity.description, activity.shortDescription);
            if (activity.ticketsNotIncluded)
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).renderTicketsNotIncluded();
            const urlParameters = App.UrlParameterHelper.urlParse();
            yield __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f").setMainFilter(urlParameters);
            if (variants && variants.length > 0) {
                const newVariants = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_variantsDataTransformation).call(this, variants, activityId);
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).changeDataSource(newVariants);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).scrollToOutputBlock();
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).pageOpen();
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).resetDataSource();
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).scrollLinkShow();
            }
            if (!activity.showSearchForm || urlParameters.some(param => param.name === App.ActivityUrlParameters.tour))
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).hideSearchForm();
        });
    }, _ActivityPageManager_showLandmark = function _ActivityPageManager_showLandmark(landmark) {
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).resetDataSource();
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).pageClose();
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).pageClose();
        __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_createLandmarkTypeIcons).call(_a, landmark);
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).renderInfo(landmark);
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).pageOpen();
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).setScrollToBlock(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getHeader());
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).scrollToOutputBlock();
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).getMapButton().on('click', e => __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onShowMapClick).call(this, e));
    }, _ActivityPageManager_onShowMapClick = function _ActivityPageManager_onShowMapClick(event) {
        var _b;
        const target = $(event.currentTarget);
        const buttonWrap = target.parents('.resort-town-page');
        buttonWrap.hide();
        target.parents('.activity-details-block').find('.js-resort-town-page').show();
        target.parents('.activity-details-block').find('.js-hideMap').parents('.resort-town-page').show();
        const pageType = ((_b = target.attr('data-type-active-section')) === null || _b === void 0 ? void 0 : _b.toString()) || '';
        const data = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getMapData).call(this, pageType);
        if (data[0].length == 0 || data[1].length == 0)
            return;
        const mapModel = {
            mapTitle: localizer.sitesVisitedOnMap,
            showHide: false,
            mapPoints: data[1],
        };
        this.components.push(new App.UnfoldMap(mapModel, false, data[0]));
    }, _ActivityPageManager_onHideMapClick = function _ActivityPageManager_onHideMapClick(event) {
        const target = $(event.currentTarget);
        target.parents('.resort-town-page').hide();
        target.parents('.activity-details-block').find('.js-resort-town-page').hide();
        target.parents('.activity-details-block').find('.js-showMap').parents('.resort-town-page').show();
    }, _ActivityPageManager_getMapData = function _ActivityPageManager_getMapData(pageType) {
        let selector = '';
        let points = [];
        if (pageType == 'activity') {
            selector = '.js-activity-details-block .js-resort-town-page';
            points = __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f")[0].landmarks.map(landmark => ({
                coordinates: landmark.coordinate,
                text: landmark.name,
                type: "places" /* MapPointType.Places */,
            }));
        }
        else if (pageType == 'landmark') {
            selector = '.js-activity-landmark-block .js-resort-town-page';
            points = [{
                    coordinates: __classPrivateFieldGet(this, _ActivityPageManager_applicationLandmarkData, "f").coordinate,
                    text: __classPrivateFieldGet(this, _ActivityPageManager_applicationLandmarkData, "f").name,
                    type: "places" /* MapPointType.Places */,
                    selected: true,
                }];
        }
        return [selector, points];
    }, _ActivityPageManager_showResultSearchActivitiesForLandmark = function _ActivityPageManager_showResultSearchActivitiesForLandmark(data, mes) {
        return __awaiter(this, void 0, void 0, function* () {
            const responseOffers = data.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManager_instances, data.subFilters, "a", _ActivityPageManager_hotFilterSet_set);
            // Если поиск происходит после ввода адреса с параметрами - не перезаписывать историю,
            // т.к. этот адрес и так в истории, а другие параметры удаляются, например, хотфильтры
            if (__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual) {
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkResult_get).setDataManipulateParameters();
                App.UrlParameterHelper.setUrlAsIs(data.seo.url);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterLandmark_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSet_get));
            }
            else {
                // устанавливаем параметры необходимые для работы с данными
                const urlParameters = App.UrlParameterHelper.urlParse();
                const dataManipulateParameters = __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkResult_get).setDataManipulateParameters(urlParameters);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterLandmark_get).setFilterSortItems(dataManipulateParameters.sorting);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterLandmark_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSet_get), dataManipulateParameters.filtering);
            }
            __classPrivateFieldSet(this, _ActivityPageManager_currentDataUrl, data.seo.url, "f");
            __classPrivateFieldSet(this, _ActivityPageManager_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManager_landmarkFilter, "f")), "f");
            // Определение наличия результатов поиска
            if (__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").length > 0) {
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f"));
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).saveSearchResult(__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f"));
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkResult_get).resetDataSource();
                mes.show(App.Message.SearchNoVariants);
            }
            __classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual = true;
        });
    }, _ActivityPageManager_searchActivities = function _ActivityPageManager_searchActivities() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManager_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).resetDataSource();
            const response = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.Search), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).filterSerializeArray());
            const responseData = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_validateSearchResponse).call(this, response, messages);
            if (!responseData)
                return;
            if (!new App.SearchLocker().check(response.data))
                return;
            const responseOffers = responseData.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManager_instances, responseData.subFilters, "a", _ActivityPageManager_hotFilterSet_set);
            // Если поиск происходит после ввода адреса с параметрами - не перезаписывать историю,
            // т.к. этот адрес и так в истории, а другие параметры удаляются, например, хотфильтры
            if (__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual) {
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).setDataManipulateParameters();
                App.UrlParameterHelper.setUrlAsIs(responseData.seo.url);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSearch_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSet_get));
            }
            else {
                // устанавливаем параметры необходимые для работы с данными
                const urlParameters = App.UrlParameterHelper.urlParse();
                const dataManipulateParameters = __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).setDataManipulateParameters(urlParameters);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSearch_get).setFilterSortItems(dataManipulateParameters.sorting);
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSearch_get).refreshHotFilters(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_hotFilterSet_get), dataManipulateParameters.filtering);
            }
            __classPrivateFieldSet(this, _ActivityPageManager_currentDataUrl, responseData.seo.url, "f");
            __classPrivateFieldSet(this, _ActivityPageManager_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManager_searchMainFilters, "f")), "f");
            // Определение наличия результатов поиска
            if (__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").length > 0) {
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).changeDataSource(__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f"));
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).resetDataSource();
                messages.show(App.Message.SearchNoVariantsWithLink(window.location.href, __classPrivateFieldGet(this, _ActivityPageManager_options, "f").isPacUa));
            }
            App.app.seo.update(responseData.seo);
            __classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual = true;
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).scrollToOutputBlock();
        });
    }, _ActivityPageManager_searchActivitiesForLandmark = function _ActivityPageManager_searchActivitiesForLandmark() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManager_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkResult_get).resetDataSource();
            const popup2 = new App.Popup({ root: $('.js-popup-search', '.js-activity-landmark-block') });
            const popupGroup = popup2.show({
                group: 'main',
                content: App.templates.Activity.Popups.Searching({}),
                modal: true,
            });
            const xhr = $.ajax({
                url: App.app.url.route(App.ActivityPageUrls.LandmarkActivity),
                method: 'POST',
                data: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).filterSerializeArray(),
            });
            const validator = __classPrivateFieldGet(this, _ActivityPageManager_landmarkFilter, "f").root.validate({ ignore: '' });
            const responseValidator = new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()), validator });
            try {
                const response = yield xhr;
                if (!responseValidator.process(response))
                    return;
                if (!new App.SearchLocker().check(response.data))
                    return;
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showResultSearchActivitiesForLandmark).call(this, response.data, messages);
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, false, "f");
                popup2.hide(popupGroup);
            }
        });
    }, _ActivityPageManager_searchActivity = function _ActivityPageManager_searchActivity() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getErrorPlace() });
            messages.hide();
            const activityId = App.app.url.routeData.id;
            if (activityId == null)
                return;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.Info, activityId), new Array(0));
            if (!App.validateResponse(response, messages))
                return;
            const { activity } = response.data;
            if (!activity)
                return;
            App.app.seo.update(response.data.seo);
            activity.landmarks = __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_landmarksDataTransformation).call(_a, activity.landmarks);
            __classPrivateFieldSet(this, _ActivityPageManager_applicationActivitiesData, [activity], "f");
            yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showDetails).call(this, activity, new Array());
        });
    }, _ActivityPageManager_searchActivitiesForDetail = function _ActivityPageManager_searchActivitiesForDetail() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f").setMainFilter(App.UrlParameterHelper.urlParse());
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManager_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).resetDataSource();
            const activityId = App.app.url.routeData.id;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.SearchActivity, activityId), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).filterSerializeArray(), true, 500);
            const responseData = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_validateSearchResponse).call(this, response, messages);
            if (!responseData)
                return;
            App.app.seo.update(responseData.seo);
            // Здесь приходит инфа только по одному отелю с набором вариантов
            const responseOffers = responseData.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManager_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f")), "f");
            // Определение наличия результатов поиска
            if (__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").length > 0) {
                if (!activityId)
                    return;
                const currentActivity = __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f")[0];
                __classPrivateFieldSet(this, _ActivityPageManager_currentDataUrl, currentActivity.link, "f");
                __classPrivateFieldSet(this, _ActivityPageManager_applicationVariantsData, currentActivity.variants, "f");
                if (__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual)
                    App.UrlParameterHelper.setUrlAsIs(currentActivity.link);
                yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showDetails).call(this, currentActivity, __classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f"));
            }
            else {
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailResult_get).resetDataSource();
                messages.show(App.Message.SearchNoVariants);
            }
            __classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual = true;
        });
    }, _ActivityPageManager_searchActivitiesForBooking = function _ActivityPageManager_searchActivitiesForBooking() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f").setMainFilter(App.UrlParameterHelper.urlParse());
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getErrorPlace() });
            messages.hide();
            if (__classPrivateFieldGet(this, _ActivityPageManager_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, true, "f");
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchResult_get).resetDataSource();
            const activityId = App.app.url.routeData.id;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.SearchActivity, activityId), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).filterSerializeArray());
            const responseData = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_validateSearchResponse).call(this, response, messages);
            if (!responseData)
                return;
            const responseOffers = responseData.offers || new Array(0);
            __classPrivateFieldSet(this, _ActivityPageManager_applicationActivitiesData, __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_activitiesDataTransformation).call(_a, responseOffers, __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f")), "f");
            // Определение наличия результатов поиска
            if (__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").length > 0) {
                if (!activityId)
                    return;
                const currentActivity = __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").find(activity => activity.key === activityId);
                __classPrivateFieldSet(this, _ActivityPageManager_applicationVariantsData, currentActivity
                    ? currentActivity.variants
                    : new Array(), "f");
                const currentBookingUrl = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_book).call(this);
                if (currentBookingUrl) {
                    __classPrivateFieldSet(this, _ActivityPageManager_currentDataUrl, currentBookingUrl, "f");
                    if (__classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual)
                        App.UrlParameterHelper.setUrlAsIs(currentBookingUrl);
                }
            }
            else {
                messages.show({
                    type: 1 /* MessageType.Warning */,
                    text: 'Экскурсия уже недоступна',
                });
            }
            __classPrivateFieldGet(this, _ActivityPageManager_options, "f").manual = true;
        });
    }, _ActivityPageManager_searchLandmark = function _ActivityPageManager_searchLandmark() {
        return __awaiter(this, void 0, void 0, function* () {
            const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_landmarkPage_get).getErrorPlace() });
            messages.hide();
            const landmarkId = App.app.url.routeData.id;
            const response = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.Landmark, landmarkId), new Array(0), false);
            if (!App.validateResponse(response, messages))
                return;
            const { landmark } = response.data;
            if (!landmark) {
                messages.show(App.Message.SearchNoVariants);
            }
            App.app.seo.update(response.data.seo);
            __classPrivateFieldSet(this, _ActivityPageManager_applicationLandmarkData, landmark, "f");
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showLandmark).call(this, landmark);
        });
    }, _ActivityPageManager_book = function _ActivityPageManager_book(variantKey) {
        return __awaiter(this, void 0, void 0, function* () {
            // парсим урл и делаем запрос к результату для вывода вариантов
            const urlParameters = App.UrlParameterHelper.urlParse();
            const variantUrl = urlParameters.find(item => item.name === 'variant');
            if (!variantUrl && !variantKey)
                return '';
            const activityId = App.app.url.routeData.id;
            if (activityId == null)
                return '';
            // Ищем экскурсию для отображения инфы об экскурсии
            const currentActivity = __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").find(data => data.key === activityId);
            if (!currentActivity)
                return '';
            // Нужный вариант ищем в отдельном свойстве варианта, т.к. при каждом поиске вариантов именно оно обновляется новыми данными
            const currentVariant = __classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f").find(data => {
                // TODO: переделать на более универсальный код. Сейчас делаем различие между тем, запрос это после клика на цены, когда
                // приходит ключ и между вводом урла, когда имеем не ключ, а набор дата+цена
                if (!variantKey && variantUrl) {
                    const variantParameter = variantUrl.values.join(',');
                    const variantParameterByString = `${data.beginDate},${data.grossPrice}`;
                    return variantParameterByString.toLowerCase() === variantParameter.toLowerCase();
                }
                return data.key === variantKey;
            });
            let currentBookingUrl = '';
            if (currentVariant) {
                // проверим, есть ли в урле контекст
                const context = urlParameters.find(item => item.name === 'context');
                const contextNumber = context ? context.values[0] : '';
                // Проверка авторизации
                const loggedIn = yield App.app.auth.getStatus();
                if (!loggedIn) {
                    $(document).trigger("app:loggingin" /* Events.LoggingIn */);
                    return '';
                }
                // Сделаем запрос существующих туристов, если это добавление услуги в заказ
                // Делаем проверку на наличие туристов. Такое может быть, если уже переходили на фому бронирования, потом вернулись на
                // поиск, а потом опять перешли на бронирование
                if (contextNumber && !__classPrivateFieldGet(this, _ActivityPageManager_existingPassengers, "f")) {
                    const response = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.ExistingTourists, { context: contextNumber }), new Array(0));
                    // TODO: мне кажется, тут обработку ошибок можно пропустить - если что-то пойдет не так, просто не будет
                    // предыдущих туристов.
                    if (response.data)
                        __classPrivateFieldSet(this, _ActivityPageManager_existingPassengers, response.data, "f");
                    else
                        __classPrivateFieldSet(this, _ActivityPageManager_existingPassengers, undefined, "f");
                }
                const bookData = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, App.app.url.route(App.ActivityPageUrls.BookData), new Array(0));
                yield this.showBookingForm(currentVariant, currentActivity, contextNumber, bookData.data.allowBooking);
                currentBookingUrl = currentVariant.link;
            }
            return currentBookingUrl;
        });
    }, _ActivityPageManager_onBlockClick = function _ActivityPageManager_onBlockClick(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: посмотреть в резалте может избавиться от передачи данных, только ключ передавать
            const activities = data.data;
            const { targetId } = data;
            const currentActivity = activities.find(item => item.key === targetId);
            if (!currentActivity)
                return;
            __classPrivateFieldSet(this, _ActivityPageManager_applicationVariantsData, currentActivity.variants, "f");
            /* открытие в новом окне*/
            const typeView = $('.js-search-hot-filter').find('.js-view-item[data-code="table"]').hasClass('_active') ? 'table' : 'block';
            let currentBlock = $(event.currentTarget);
            currentBlock = typeView === 'block' ? currentBlock.find(`a#${targetId}`) : currentBlock.find(`div#${targetId}`);
            if (currentBlock.attr('target') === '_blank') {
                window.open(currentActivity.link);
                return;
            }
            /* открытие в новом окне*/
            App.UrlParameterHelper.setUrlAsIs(currentActivity.link);
            yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showDetails).call(this, currentActivity, __classPrivateFieldGet(this, _ActivityPageManager_applicationVariantsData, "f"));
            yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getSeo).call(this, App.UrlParameterHelper.urlParse(), App.app.url.route(App.ActivityPageUrls.SeoInfo, currentActivity.key), __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).filterSerializeArray());
        });
    }, _ActivityPageManager_onShowLandmarkClick = function _ActivityPageManager_onShowLandmarkClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.currentTarget);
            const link = target.attr('href');
            if (link)
                App.UrlParameterHelper.setUrlAsIs(link);
            const landmarkId = parseInt((_b = App.app.url.routeData.id) !== null && _b !== void 0 ? _b : '0', 10);
            if (Number.isNaN(landmarkId))
                return;
            if (!__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f") || __classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f").length === 0)
                return;
            const landmark = Enumerable.from(__classPrivateFieldGet(this, _ActivityPageManager_applicationActivitiesData, "f"))
                .select(v => v.landmarks.find(x => x.key === landmarkId))
                .firstOrDefault(v => !!v);
            if (!landmark)
                return;
            __classPrivateFieldSet(this, _ActivityPageManager_applicationLandmarkData, landmark, "f");
            __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_showLandmark).call(this, landmark);
            yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_getSeo).call(this, App.UrlParameterHelper.urlParse(), App.app.url.route(App.ActivityPageUrls.SeoLandmark, landmarkId));
        });
    }, _ActivityPageManager_onDetailBlockClick = function _ActivityPageManager_onDetailBlockClick(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentBookingUrl = yield __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_book).call(this, data.targetId);
            if (currentBookingUrl)
                App.UrlParameterHelper.setUrlAsIs(currentBookingUrl);
        });
    }, _ActivityPageManager_setNewVariantUrl = function _ActivityPageManager_setNewVariantUrl(activityId) {
        const mainFilterParameters = __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f").getUrlDataFromFilter();
        return App.app.url.route(App.ActivityPageUrls.Info, activityId, mainFilterParameters);
    }, _ActivityPageManager_activitiesDataTransformation = function _ActivityPageManager_activitiesDataTransformation(rawData, mainFilter) {
        const mainFilterParameters = mainFilter.getUrlDataFromFilter();
        // удалим лишние параметры из параметров урла
        const reducedSearchUrlParameters = mainFilterParameters
            .filter(item => item.name !== App.ActivityUrlParameters.location);
        return rawData.map(item => {
            item.firstVariantDate = new Date(item.beginDate).toLocaleString('ru', { year: 'numeric', month: 'numeric', day: 'numeric' });
            item.link = App.app.url.route(App.ActivityPageUrls.Info, item.key, reducedSearchUrlParameters);
            item.landmarks = __classPrivateFieldGet(_a, _a, "m", _ActivityPageManager_landmarksDataTransformation).call(_a, item.landmarks);
            return item;
        });
    }, _ActivityPageManager_variantsDataTransformation = function _ActivityPageManager_variantsDataTransformation(variants, activityId) {
        // соберем параметры с детального фильтра
        const detailFilterParameters = __classPrivateFieldGet(this, _ActivityPageManager_detailFilter, "f").getUrlDataFromFilter();
        return variants.map(item => {
            // добавим параметр для варианта
            let urlParameters = new Array();
            urlParameters = urlParameters.concat(detailFilterParameters);
            urlParameters.push({ name: 'variant', values: [`${item.beginDate},${item.grossPrice}`] });
            // сформируем урл для бронирования
            item.link = App.app.url.route(App.ActivityPageUrls.Book, activityId, urlParameters);
            return item;
        });
    }, _ActivityPageManager_landmarksDataTransformation = function _ActivityPageManager_landmarksDataTransformation(landmarks) {
        return landmarks.map(item => {
            item.link = App.app.url.route(App.ActivityPageUrls.Landmark, item.key);
            return item;
        });
    }, _ActivityPageManager_createLandmarkTypeIcons = function _ActivityPageManager_createLandmarkTypeIcons(landmark) {
        landmark.types.map(type => {
            type.icon = `landmark_${type.code}`;
            return type;
        });
    }, _ActivityPageManager_onBeforeSearch = function _ActivityPageManager_onBeforeSearch(xhr, delayTime) {
        __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_preloader_get).show({ delay: delayTime });
        __classPrivateFieldSet(this, _ActivityPageManager_activeRequest, xhr, "f");
    }, _ActivityPageManager_validateSearchResponse = function _ActivityPageManager_validateSearchResponse(response, messages) {
        // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо
        // их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
        if (!response.status.success || response.data == null) {
            if (response.status.modelState) {
                const validator = $(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_searchPage_get).getMainFilter()).validate();
                validator.showErrors(response.status.modelState.errors);
            }
            else if (response.status.messages) {
                messages.show(response.status.messages);
            }
            return undefined;
        }
        if (response.redirect != null)
            window.location.href = response.redirect;
        // TODO: пока не удалось убрать ошибку валидации для туристов. е сли из урла удалить туристов. появится ошибка. если потмо
        // туристов заполнить и послать запрос. ошибка не убирается
        // validator.resetForm();
        return response.data;
    }, _ActivityPageManager_validateVariantResponse = function _ActivityPageManager_validateVariantResponse(response, messages) {
        // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо
        // их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
        if (!response.status.success || response.data == null) {
            if (response.status.modelState) {
                const validator = $(__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_detailPage_get).getDetailFilter()).validate();
                validator.showErrors(response.status.modelState.errors);
            }
            else if (response.status.messages) {
                messages.show(response.status.messages);
            }
            return undefined;
        }
        if (response.redirect != null)
            window.location.href = response.redirect;
        // TODO: пока не удалось убрать ошибку валидации для туристов. е сли из урла удалить туристов. появится ошибка. если потмо
        // туристов заполнить и послать запрос. ошибка не убирается
        // validator.resetForm();
        return response.data;
    }, _ActivityPageManager_getSeo = function _ActivityPageManager_getSeo(urlParameters, url, formFields) {
        return __awaiter(this, void 0, void 0, function* () {
            let form = formFields || new Array();
            // Если форма типа-пустая, то оставляем в ней только context и передаем таким образом на сервер
            if (__classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_emptyUrlChecker_get).isEmpty(urlParameters))
                form = form.filter(item => item.name === App.ActivityFilterFields.Context);
            const xhr = __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_sendPostRequest).call(this, url, form);
            try {
                const response = yield xhr;
                App.app.seo.update(response.data);
            }
            catch (e) {
                // TODO: кажется, тут не надо выводить ошибку, т.к. это не основной запрос на странице
            }
        });
    }, _ActivityPageManager_sendPostRequest = function _ActivityPageManager_sendPostRequest(url_1, sendData_1) {
        return __awaiter(this, arguments, void 0, function* (url, sendData, showPreloader = true, delay = 0) {
            const xhr = $.ajax({
                url,
                method: 'POST',
                dataType: 'json',
                data: sendData,
            });
            if (showPreloader)
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_onBeforeSearch).call(this, xhr, delay);
            try {
                return yield xhr;
            }
            finally {
                if (showPreloader)
                    __classPrivateFieldGet(this, _ActivityPageManager_instances, "a", _ActivityPageManager_preloader_get).hide();
                __classPrivateFieldSet(this, _ActivityPageManager_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _ActivityPageManager_instances, "m", _ActivityPageManager_clearActiveRequest).call(this);
            }
        });
    }, _ActivityPageManager_stopRequest = function _ActivityPageManager_stopRequest(xhr) {
        if (xhr)
            xhr.abort();
    }, _ActivityPageManager_clearActiveRequest = function _ActivityPageManager_clearActiveRequest() {
        __classPrivateFieldSet(this, _ActivityPageManager_activeRequest, undefined, "f");
    };
    App.ActivityPageManager = ActivityPageManager;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _ActivitySearchPageMobile_instances, _ActivitySearchPageMobile_options, _ActivitySearchPageMobile_filterMain, _ActivitySearchPageMobile_searchButton, _ActivitySearchPageMobile_searchBlock, _ActivitySearchPageMobile_errorPlace, _ActivitySearchPageMobile_scrollToBlock, _ActivitySearchPageMobile_header, _ActivitySearchPageMobile_mainFilter, _ActivitySearchPageMobile_onSearchButtonClick;
    class ActivitySearchPageMobile extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-page' }, options));
            _ActivitySearchPageMobile_instances.add(this);
            _ActivitySearchPageMobile_options.set(this, void 0);
            _ActivitySearchPageMobile_filterMain.set(this, void 0);
            _ActivitySearchPageMobile_searchButton.set(this, void 0);
            _ActivitySearchPageMobile_searchBlock.set(this, void 0);
            _ActivitySearchPageMobile_errorPlace.set(this, void 0);
            _ActivitySearchPageMobile_scrollToBlock.set(this, void 0);
            _ActivitySearchPageMobile_header.set(this, void 0);
            // #form: Form;
            _ActivitySearchPageMobile_mainFilter.set(this, void 0);
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            // инициализация элементов
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_filterMain, $('.js-activity-main-filter', this.root), "f");
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_searchButton, $('.js-m-filter-submit', __classPrivateFieldGet(this, _ActivitySearchPageMobile_filterMain, "f")), "f");
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_searchBlock, $('.js-activity-search-block'), "f");
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_errorPlace, $('.js-error-place'), "f");
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_scrollToBlock, __classPrivateFieldGet(this, _ActivitySearchPageMobile_searchBlock, "f"), "f");
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_header, $('h1.js-header'), "f");
            // this.#form = new Form({ root: this.#filterMain });
            // события
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом - выбираем из выпадающего списка стрелками и Enter? потм ожмум Enter - и ничего. Возможно из-за того, что перемудрили с контролами
            __classPrivateFieldGet(this, _ActivitySearchPageMobile_filterMain, "f").on('submit', e => __classPrivateFieldGet(this, _ActivitySearchPageMobile_instances, "m", _ActivitySearchPageMobile_onSearchButtonClick).call(this, e));
            // TODO: сделать функцию по отображению ошибок и перенести вверх
            if (__classPrivateFieldGet(this, _ActivitySearchPageMobile_options, "f").searchError) {
                const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivitySearchPageMobile_errorPlace, "f") });
                messages.hide();
                messages.show({ type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(this, _ActivitySearchPageMobile_options, "f").searchError });
            }
        }
        setMainFilter(mainFilter) {
            __classPrivateFieldSet(this, _ActivitySearchPageMobile_mainFilter, mainFilter, "f");
        }
        getMainFilterValidator() {
            // if (!this.#mainFilter)
            // return this.#filterMain.validate();
            return __classPrivateFieldGet(this, _ActivitySearchPageMobile_mainFilter, "f").validator;
        }
        getSearchButton() {
            return __classPrivateFieldGet(this, _ActivitySearchPageMobile_searchButton, "f");
        }
        getErrorPlace() {
            return __classPrivateFieldGet(this, _ActivitySearchPageMobile_errorPlace, "f");
        }
        // getMainFilter(): JQuery {
        //   return this.#filterMain;
        // }
        getSearchBlock() {
            return __classPrivateFieldGet(this, _ActivitySearchPageMobile_searchBlock, "f");
        }
        getHeader() {
            return __classPrivateFieldGet(this, _ActivitySearchPageMobile_header, "f");
        }
        filterSerializeArray() {
            // return this.#filterMain.find('input').serializeArray();
            if (!__classPrivateFieldGet(this, _ActivitySearchPageMobile_mainFilter, "f"))
                return [];
            return __classPrivateFieldGet(this, _ActivitySearchPageMobile_mainFilter, "f").filters.serializeArray();
        }
        // Прокрутка страницы к результатам
        scrollToOutputBlock() {
            const scrollOffset = __classPrivateFieldGet(this, _ActivitySearchPageMobile_scrollToBlock, "f").offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
        // открывает блок поиска
        pageOpen() {
            __classPrivateFieldGet(this, _ActivitySearchPageMobile_filterMain, "f").showByClass();
            __classPrivateFieldGet(this, _ActivitySearchPageMobile_searchBlock, "f").showByClass();
        }
        // скрывает блок поиска
        pageClose() {
            __classPrivateFieldGet(this, _ActivitySearchPageMobile_filterMain, "f").hideByClass();
            __classPrivateFieldGet(this, _ActivitySearchPageMobile_searchBlock, "f").hideByClass();
        }
    }
    _ActivitySearchPageMobile_options = new WeakMap(), _ActivitySearchPageMobile_filterMain = new WeakMap(), _ActivitySearchPageMobile_searchButton = new WeakMap(), _ActivitySearchPageMobile_searchBlock = new WeakMap(), _ActivitySearchPageMobile_errorPlace = new WeakMap(), _ActivitySearchPageMobile_scrollToBlock = new WeakMap(), _ActivitySearchPageMobile_header = new WeakMap(), _ActivitySearchPageMobile_mainFilter = new WeakMap(), _ActivitySearchPageMobile_instances = new WeakSet(), _ActivitySearchPageMobile_onSearchButtonClick = function _ActivitySearchPageMobile_onSearchButtonClick(event) {
        event.preventDefault();
        // if (!this.#form.validator.form())
        // return;
        if (__classPrivateFieldGet(this, _ActivitySearchPageMobile_mainFilter, "f") && !__classPrivateFieldGet(this, _ActivitySearchPageMobile_mainFilter, "f").validator.form())
            return;
        __classPrivateFieldGet(this, _ActivitySearchPageMobile_searchButton, "f").trigger("searchButton:click" /* Events.SearchButtonClick */);
    };
    App.ActivitySearchPageMobile = ActivitySearchPageMobile;
})(App || (App = {}));
/// <reference path='../common/PageBase.ts' />
var App;
(function (App) {
    var _ActivitySearchPage_instances, _ActivitySearchPage_options, _ActivitySearchPage_filterMain, _ActivitySearchPage_searchButton, _ActivitySearchPage_searchBlock, _ActivitySearchPage_promoBlock, _ActivitySearchPage_errorPlace, _ActivitySearchPage_scrollToBlock, _ActivitySearchPage_header, _ActivitySearchPage_form, _ActivitySearchPage_onSearchButtonClick;
    class ActivitySearchPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-page' }, options));
            _ActivitySearchPage_instances.add(this);
            _ActivitySearchPage_options.set(this, void 0);
            _ActivitySearchPage_filterMain.set(this, void 0);
            _ActivitySearchPage_searchButton.set(this, void 0);
            _ActivitySearchPage_searchBlock.set(this, void 0);
            _ActivitySearchPage_promoBlock.set(this, void 0);
            _ActivitySearchPage_errorPlace.set(this, void 0);
            _ActivitySearchPage_scrollToBlock.set(this, void 0);
            _ActivitySearchPage_header.set(this, void 0);
            _ActivitySearchPage_form.set(this, void 0);
            __classPrivateFieldSet(this, _ActivitySearchPage_options, options, "f");
            if (!this.root.length)
                return;
            // инициализация элементов
            __classPrivateFieldSet(this, _ActivitySearchPage_filterMain, $('.js-activity-main-filter', this.root), "f");
            __classPrivateFieldSet(this, _ActivitySearchPage_searchButton, $('.js-m-filter-submit', __classPrivateFieldGet(this, _ActivitySearchPage_filterMain, "f")), "f");
            __classPrivateFieldSet(this, _ActivitySearchPage_searchBlock, $('.js-activity-search-block'), "f");
            __classPrivateFieldSet(this, _ActivitySearchPage_promoBlock, $('.js-activity-promo-block'), "f");
            __classPrivateFieldSet(this, _ActivitySearchPage_errorPlace, $('.js-error-place'), "f");
            __classPrivateFieldSet(this, _ActivitySearchPage_scrollToBlock, __classPrivateFieldGet(this, _ActivitySearchPage_searchBlock, "f"), "f");
            __classPrivateFieldSet(this, _ActivitySearchPage_header, $('h1.js-header'), "f");
            __classPrivateFieldSet(this, _ActivitySearchPage_form, new App.Form({ root: __classPrivateFieldGet(this, _ActivitySearchPage_filterMain, "f") }), "f");
            // события
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом - выбираем из выпадающего списка стрелками и Enter? потм ожмум Enter - и ничего. Возможно из-за того, что перемудрили с контролами
            __classPrivateFieldGet(this, _ActivitySearchPage_filterMain, "f").on('submit', e => __classPrivateFieldGet(this, _ActivitySearchPage_instances, "m", _ActivitySearchPage_onSearchButtonClick).call(this, e));
            // TODO: сделать функцию по отображению ошибок и перенести вверх
            if (__classPrivateFieldGet(this, _ActivitySearchPage_options, "f").searchError) {
                const messages = new App.Messages({ root: __classPrivateFieldGet(this, _ActivitySearchPage_errorPlace, "f") });
                messages.hide();
                messages.show({ type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(this, _ActivitySearchPage_options, "f").searchError });
            }
            new App.Digest({ container: this.root });
        }
        getSearchButton() {
            return __classPrivateFieldGet(this, _ActivitySearchPage_searchButton, "f");
        }
        getErrorPlace() {
            return __classPrivateFieldGet(this, _ActivitySearchPage_errorPlace, "f");
        }
        getMainFilter() {
            return __classPrivateFieldGet(this, _ActivitySearchPage_filterMain, "f");
        }
        getSearchBlock() {
            return __classPrivateFieldGet(this, _ActivitySearchPage_searchBlock, "f");
        }
        getPromoBlock() {
            return __classPrivateFieldGet(this, _ActivitySearchPage_promoBlock, "f");
        }
        getHeader() {
            return __classPrivateFieldGet(this, _ActivitySearchPage_header, "f");
        }
        filterSerializeArray() {
            return __classPrivateFieldGet(this, _ActivitySearchPage_filterMain, "f").find('input').serializeArray();
        }
        // Прокрутка страницы к результатам
        scrollToOutputBlock() {
            const scrollOffset = __classPrivateFieldGet(this, _ActivitySearchPage_scrollToBlock, "f").offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
        // открывает блок поиска
        pageOpen() {
            __classPrivateFieldGet(this, _ActivitySearchPage_filterMain, "f").showByClass();
            __classPrivateFieldGet(this, _ActivitySearchPage_promoBlock, "f").show();
        }
        // скрывает блок поиска
        pageClose() {
            __classPrivateFieldGet(this, _ActivitySearchPage_filterMain, "f").hideByClass();
            __classPrivateFieldGet(this, _ActivitySearchPage_searchBlock, "f").hideByClass();
            __classPrivateFieldGet(this, _ActivitySearchPage_promoBlock, "f").hide();
        }
    }
    _ActivitySearchPage_options = new WeakMap(), _ActivitySearchPage_filterMain = new WeakMap(), _ActivitySearchPage_searchButton = new WeakMap(), _ActivitySearchPage_searchBlock = new WeakMap(), _ActivitySearchPage_promoBlock = new WeakMap(), _ActivitySearchPage_errorPlace = new WeakMap(), _ActivitySearchPage_scrollToBlock = new WeakMap(), _ActivitySearchPage_header = new WeakMap(), _ActivitySearchPage_form = new WeakMap(), _ActivitySearchPage_instances = new WeakSet(), _ActivitySearchPage_onSearchButtonClick = function _ActivitySearchPage_onSearchButtonClick(event) {
        event.preventDefault();
        if (!__classPrivateFieldGet(this, _ActivitySearchPage_form, "f").validator.form())
            return;
        __classPrivateFieldGet(this, _ActivitySearchPage_searchButton, "f").trigger("searchButton:click" /* Events.SearchButtonClick */);
        __classPrivateFieldGet(this, _ActivitySearchPage_promoBlock, "f").hide();
    };
    App.ActivitySearchPage = ActivitySearchPage;
})(App || (App = {}));
var App;
(function (App) {
    var _Filter_options;
    class Filter {
        constructor(options) {
            _Filter_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "controls", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            const defaults = {
                root: '.js-filter',
                maxChildAge: 12,
                autocompleteOptions: {
                    minLength: App.app.settings.minSearchTermLength,
                },
            };
            __classPrivateFieldSet(this, _Filter_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _Filter_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            // TODO: перейти на идентификаторы *-form-* после склейки стилей.
            const filterSelectBlock = this.root.find('.js-filter-select-block, .js-form-select-block');
            const filterScrollBlock = this.root.find('.js-filter-scroll-block, .js-form-scroll-block');
            const filterAutocompleteBlock = this.root.find('.js-filter-autocomplete-block, .js-form-autocomplete-block');
            const filterSliderBlock = this.root.find('.js-filter-slider-block, .js-form-slider-block');
            const filterTimeOfDaySliderBlock = this.root.find('.js-filter-timeofday-slider-block, .js-form-timeofday-slider-block');
            const filterDateBlock = this.root.find('.js-filter-date-block, .js-form-date-block');
            const filterDatesBlock = this.root.find('.js-filter-dates-block, .js-form-dates-block');
            const filterPeopleBlock = this.root.find('.js-filter-people-block, .js-form-people-block');
            const filterSlidingBtn = this.root.find('.js-filter-sliding-btn-b, .js-form-sliding-btn-b');
            const filterRadioBtn = this.root.find('.js-filter-radio-btn, .js-form-radio-btn');
            const filterMoreOpts = this.root.find('.js-filter-more-opts, .js-form-more-opts');
            const filterSingleCheckBox = this.root.find('.js-filter-single-checkbox, .js-form-single-checkbox');
            // Обходим каждый блок с выпадающим списком
            filterSelectBlock.each((i, v) => { this.controls.push(new App.FilterSelectBlock({ root: $(v) })); });
            // Обходим каждый блок со списком прокрутки
            filterScrollBlock.each((i, v) => { this.controls.push(new App.FilterScrollBlock({ root: $(v) })); });
            // обходим каждый блок с autocomplete
            filterAutocompleteBlock.each((i, v) => {
                this.controls.push(new App.FilterAutocompleteBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _Filter_options, "f").autocompleteOptions)));
            });
            // Обходим каждый блок со слайдером по цене
            filterSliderBlock.each((i, v) => {
                this.controls.push(new App.FilterSliderBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _Filter_options, "f").sliderOptions)));
            });
            // Обходим каждый блок со слайдером по времени
            filterTimeOfDaySliderBlock.each((i, v) => {
                this.controls.push(new App.FilterTimeOfDaySliderBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _Filter_options, "f").sliderOptions)));
            });
            // Обходим каждый блок с календарем
            filterDateBlock.each((i, v) => { this.controls.push(new App.FilterDateBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _Filter_options, "f").dateOptions))); });
            filterDatesBlock.each((i, v) => { this.controls.push(new App.FilterDatesBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _Filter_options, "f").datesOptions))); });
            // Обходим каждый блок с туристами
            filterPeopleBlock.each((i, v) => {
                this.controls.push(new App.FilterPeopleBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _Filter_options, "f").peopleOptions)));
            });
            // Обходим каждый блок с услугами
            this.root.find('.js-services-block').each((i, v) => { this.controls.push(new App.FilterServicesBlock({ root: $(v) })); });
            // Блок Категория отеля
            this.root.find('.js-hotel-stars-block').each((i, v) => {
                this.controls.push(new App.FilterHotelStarsBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _Filter_options, "f").hotelStarsValues)));
            });
            // Название предложения
            const filterOfferName = this.root.find('.js-filter-offer-name');
            this.controls.push(new App.FilterNameBlock({ root: $(filterOfferName) }));
            // Блок со скользящим переключателем (sliding button)
            filterSlidingBtn.each((i, v) => { this.controls.push(new App.FilterSlidingButtonBlock({ root: $(v) })); });
            // Блок с радио переключателем (radio button)
            filterRadioBtn.on('click', e => {
                const target = $(e.currentTarget);
                const input = target.closest('.js-filter-radio-btn-group').find('input');
                filterRadioBtn.removeClass('_on');
                target.addClass('_on');
                input.val(target.closest('.js-filter-radio-btn-group').find('.js-filter-radio-btn').filter('._on').attr('data-id') || '');
                // TODO: в данном случае instance будет ссылаться на текущий экземпляр Filter, а не на экземпляр класса с радио переключателем! Для фикса необходимо вынести этот код в отдельный класс.
                target.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
            });
            this.root.find('.js-filter-radio-label').on('click', e => {
                $(e.currentTarget).closest('.js-filter-radio-wrap').find('.js-filter-radio-btn').trigger('click');
            });
            // Блок Подобрать, клик по ссылке Дополнительные параметры
            filterMoreOpts.on('click', e => this.showMore(e));
            filterSingleCheckBox.each((_, v) => { this.controls.push(new App.FilterSingleCheckBoxBlock({ root: $(v) })); });
            // Клик по 'Очистить фильтр' - сбрасываем все значения во всех фильтрах в Основном фильтре
            this.root.find('.js-clear-filter').on('click', () => this.reset());
            // Спойлеры формы
            $('.js-form-spoiler', this.root).each((i, v) => {
                const jqElement = $(v);
                const toggle = $('.js-form-spoiler-toggle', jqElement);
                const content = $('.js-form-spoiler-content', jqElement);
                toggle.on('click', () => {
                    content.slideToggle(400, () => {
                        toggle.toggleClass('_opened');
                    });
                });
            });
            // Обрабатываем счетчик +/- 1
            $('.js-form-counter', this.root).each((i, v) => {
                const jqElement = $(v);
                const plus = jqElement.siblings('.plus');
                const minus = jqElement.siblings('.minus');
                jqElement.inputmask({
                    regex: '[0-9 ]*',
                    placeholder: '0',
                });
                plus.on('click', () => {
                    const value = jqElement.valNumber() || 0;
                    jqElement.val(value + 1);
                });
                minus.on('click', () => {
                    const value = jqElement.valNumber() || 0;
                    jqElement.val(value - 1 >= 0 ? value - 1 : 0);
                });
            });
            // Поля дат
            $('.js-filter-date, .js-form-date', this.root).each((i, v) => {
                const jqElement = $(v);
                const range = jqElement.attr('range')
                    || jqElement.attr('data-rule-range')
                    || jqElement.attr('data-rule-daterange');
                const rangePair = (range ? range.substring(1, range.length - 2).split(',') : null);
                const min = (rangePair ? rangePair[0] : null)
                    || jqElement.attr('min')
                    || /* TODO Obsolete */ jqElement.attr('data-min')
                    || jqElement.attr('data-rule-min')
                    || jqElement.attr('data-rule-datemin');
                const minDate = min ? App.parseIsoDate(min) : null;
                const minDateYear = minDate ? `${minDate.getFullYear()}` : null;
                const max = (rangePair ? rangePair[1] : null)
                    || jqElement.attr('max')
                    || /* TODO Obsolete */ jqElement.attr('data-max')
                    || jqElement.attr('data-rule-max')
                    || jqElement.attr('data-rule-datemax');
                const maxDate = max ? App.parseIsoDate(max) : null;
                const maxDateYear = maxDate ? `${maxDate.getFullYear()}` : null;
                jqElement
                    .attr('autocomplete', 'off')
                    .inputmask('date');
                jqElement
                    .datepicker({
                    minDate,
                    maxDate,
                    yearRange: (minDateYear && maxDateYear ? `${minDateYear}:${maxDateYear}` : undefined),
                    dateFormat: 'dd.mm.yy',
                    constrainInput: true,
                    onClose: () => {
                        jqElement.valid();
                        /* стандартное событие change в jQuery datepicker срабатывает только тогда,
                        когда дата выбирается из самого календаря, но не при ручном вводе даты с клавиатуры и потере фокус.
                        Поэтому вручную вызывается событие change */
                        // TODO: вызывать событие только при реальном изменении данных
                        jqElement.trigger('change');
                    },
                })
                    .on('change', () => jqElement.valid());
            });
            $(document).on("win:resizeEnd" /* Events.WinResizeEnd */, () => {
                $('.js-filter-date, .js-form-date').datepicker('refresh');
            });
            // Зависимость кнопки от чекбоксов [data-depends="name1,name1,..."]
            $('[data-depends]', this.root).each((i, v) => {
                const jqElement = $(v);
                const selector = ($(v).attr('data-depends') || '').split(',')
                    .map(x => `[name="${x}"]`)
                    .join(', ');
                const depends = this.root.find(selector);
                depends.on('change', () => {
                    if (depends.filter(':checked').length !== depends.length)
                        jqElement.attr('disabled', 'disabled');
                    else
                        jqElement.removeAttr('disabled');
                }).trigger('change');
            });
            // TODO: по идее данный код должен быть в блоке с обработкой контролов-интервалов.
            const filterNightsFrom = this.root.find('[data-name="filter_nights_from"]');
            const filterNightsTo = this.root.find('[data-name="filter_nights_to"]');
            if (filterNightsFrom.length && filterNightsTo.length) {
                filterNightsFrom.on("filter:change" /* Events.FilterChange */, () => {
                    const fromVal = filterNightsFrom.find('.js-jelect-input').valNumber() || 0;
                    const toVal = filterNightsTo.find('.js-jelect-input').valNumber() || 0;
                    if (fromVal > toVal)
                        filterNightsTo.find(`.js-filter-option[data-val='${fromVal}']`).trigger('click');
                });
                filterNightsTo.on("filter:change" /* Events.FilterChange */, () => {
                    const fromVal = filterNightsFrom.find('.js-jelect-input').valNumber() || 0;
                    const toVal = filterNightsTo.find('.js-jelect-input').valNumber() || 0;
                    if (toVal < fromVal)
                        filterNightsFrom.find(`.js-filter-option[data-val='${toVal}']`).trigger('click');
                });
            }
        }
        showMore(e) {
            $(e.currentTarget).toggleClass('_on');
            this.root.toggleClass('_more');
        }
        findControl(name) {
            const searchName = name.toUpperCase();
            const result = this.controls.find(v => v.name != null && v.name.toUpperCase() === searchName);
            if (!result)
                return result;
            // TODO: неплохо было бы для debug здесь иметь проверку типа контрола, но TypeScript (по крайней мере до v2.8.3) пока не
            // позволяет это сделать без доп.аргумента (см.https://github.com/microsoft/TypeScript/issues/5236#issuecomment-147652993).
            // if (app.settings.debug && !(result instanceof T))
            //   console.warn(`The requested type '${T.name}' of the '${name}' control isn't assignable to the type '${result.name}' of
            //   obtained real object.`);
            return result;
        }
        reset() {
            // TODO: возможность передавать список названий полей, только которые сбрасывать.
            this.controls.forEach(item => item.reset());
        }
        clear() {
            // TODO: возможность передавать список названий полей, только которые очищать.
            this.controls.forEach(item => item.clear());
        }
    }
    _Filter_options = new WeakMap();
    App.Filter = Filter;
})(App || (App = {}));
/// <reference path='Filter.ts' />
var App;
(function (App) {
    var _HotFilter_instances, _a, _HotFilter_viewItem, _HotFilter_filterResortsSort, _HotFilter_progressDataLoading, _HotFilter_filterSortItem, _HotFilter_getTypeViewCookieCode, _HotFilter_showView, _HotFilter_getActiveSorting, _HotFilter_updateActiveView, _HotFilter_onOnlyTableView, _HotFilter_onFlightSwitch;
    class HotFilter extends App.Filter {
        constructor(options) {
            super(Object.assign({ root: '.js-hot-filter' }, options));
            _HotFilter_instances.add(this);
            _HotFilter_viewItem.set(this, void 0);
            _HotFilter_filterResortsSort.set(this, void 0);
            _HotFilter_progressDataLoading.set(this, void 0);
            Object.defineProperty(this, "filterFoundTitle", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _HotFilter_filterSortItem.set(this, void 0);
            Object.defineProperty(this, "activeSorting", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "activeView", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pageController", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pageAction", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const queryParams = new App.QueryParams(window.location.pathname);
            this.pageController = queryParams.getController();
            this.pageAction = queryParams.getAction();
            __classPrivateFieldSet(this, _HotFilter_viewItem, $('.js-view-item', this.root), "f");
            const flightSwitch = $('.js-filter-flight-switch', this.root);
            __classPrivateFieldSet(this, _HotFilter_filterResortsSort, $('.js-filter-resorts-sort', this.root), "f");
            __classPrivateFieldSet(this, _HotFilter_progressDataLoading, $('.js-progress-data-loading', this.root), "f");
            this.hideProgressDataLoader();
            this.filterFoundTitle = $('.js-filter-found-title', this.root);
            __classPrivateFieldSet(this, _HotFilter_filterSortItem, $('.js-sort-item', this.root), "f");
            // Включаем блочную или табличную выдачу
            __classPrivateFieldGet(this, _HotFilter_viewItem, "f").on('click', e => __classPrivateFieldGet(this, _HotFilter_instances, "m", _HotFilter_showView).call(this, e));
            // Показываем / скрываем туры с перелетом
            flightSwitch.on('click', e => __classPrivateFieldGet(_a, _a, "m", _HotFilter_onFlightSwitch).call(_a, e));
            this.activeSorting = __classPrivateFieldGet(this, _HotFilter_instances, "m", _HotFilter_getActiveSorting).call(this);
            // Клики по кнопкам сортировки (дата вылета, цена)
            __classPrivateFieldGet(this, _HotFilter_filterSortItem, "f").on('click', e => {
                const target = $(e.currentTarget);
                if (target.hasClass('_active')) {
                    target.toggleClass('_sort-up _sort-down');
                }
                else {
                    target.addClass('_active');
                    target.siblings('.js-sort-item').removeClass('_active');
                }
                const sorting = __classPrivateFieldGet(this, _HotFilter_instances, "m", _HotFilter_getActiveSorting).call(this);
                this.activeSorting = sorting;
                this.root.trigger("filter:sort" /* Events.FilterSort */, [sorting]);
            });
            // Если на странице есть ТОЛЬКО табличный вид
            // Триггер события в tours.js -> bind_tour_blocks()
            this.root.on("tours:only-table-view" /* Events.ToursOnlyTableView */, () => __classPrivateFieldGet(this, _HotFilter_instances, "m", _HotFilter_onOnlyTableView).call(this));
            // Определяем активный вид
            __classPrivateFieldGet(this, _HotFilter_instances, "m", _HotFilter_updateActiveView).call(this);
            this.root.on("filter:change" /* Events.FilterChange */, (e, data) => this.onHotFiltersChange(e, data));
            new App.NetPricePresenter({ root: this.root }).init();
            $('.js-progress-data-loading-cancel', __classPrivateFieldGet(this, _HotFilter_progressDataLoading, "f")).on('click', e => $(e.currentTarget).trigger("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */));
        }
        show() {
            this.root.showByClass();
        }
        hide() {
            this.root.hideByClass();
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('hotFilterFoundTitle', { count: data.length }));
        }
        /**
         * устанавливает элементы управления сортировкой по заданным значениям (только кнопки, поле не устанавливает)
         * @param sortingInfo - параметры сортировки
         * @param triggerIt - признак, что надо инициировать клик на кнопку
         * @returns {}
         */
        setFilterSortItems(sortingInfo, triggerIt) {
            const filterSortItem = this.root.find('.js-sort-item');
            filterSortItem.removeClass('_active');
            const targetSortItem = filterSortItem.siblings(`[data-sort='${sortingInfo.field}']`);
            if (targetSortItem) {
                targetSortItem.addClass('_active')
                    .removeClass('_sort-up')
                    .removeClass('_sort-down')
                    .addClass(sortingInfo.reverse ? '_sort-down' : '_sort-up');
            }
            // Инициируем сразу событие для дальнейшего перехвата, а не просто клик на кнопку, т.к. при клике на кнопку меняется направление
            // сортировки, а здесь уже выставляется нужное направление.
            if (triggerIt)
                this.root.trigger("filter:sort" /* Events.FilterSort */, [{ field: targetSortItem.attr('data-sort') || '', reverse: sortingInfo.reverse }]);
        }
        /**
         * Показывает прогресс загрузки данных
         */
        showProgressDataLoader() {
            if (__classPrivateFieldGet(this, _HotFilter_progressDataLoading, "f"))
                __classPrivateFieldGet(this, _HotFilter_progressDataLoading, "f").show();
        }
        /**
         * Скрывает прогресс загрузки данных
         */
        hideProgressDataLoader() {
            if (__classPrivateFieldGet(this, _HotFilter_progressDataLoading, "f"))
                __classPrivateFieldGet(this, _HotFilter_progressDataLoading, "f").hide();
        }
        /**
         * Функция на изменение хот фильтров
         * Если нужна, переопределить.
         * TODO: Пока не нашла, как сделать универсально и гибко, поэтому тело функции убрала. Кому было надо, сорян
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        onHotFiltersChange(e, data) {
            // TODO: по идее здесь должно инициироваться событие HotFilterChange, т.к. данный метод ловит событие "FilterChange" всех своих контролов, или нужно терминировать события Events.FilterChange дочерних контролов и инициировать новое такое же, т.е. Events.FilterChange.
        }
        /**
         * Изменяет текущий активный вид
         */
        changeActiveView() {
            __classPrivateFieldGet(this, _HotFilter_instances, "m", _HotFilter_updateActiveView).call(this);
        }
    }
    _a = HotFilter, _HotFilter_viewItem = new WeakMap(), _HotFilter_filterResortsSort = new WeakMap(), _HotFilter_progressDataLoading = new WeakMap(), _HotFilter_filterSortItem = new WeakMap(), _HotFilter_instances = new WeakSet(), _HotFilter_getTypeViewCookieCode = function _HotFilter_getTypeViewCookieCode() {
        switch (this.pageController) {
            case 'cruise':
                return "cruiseTypeView" /* KnownCookie.CruiseTypeView */;
            case 'tour':
                {
                    if (this.pageAction == 'program')
                        return "tourProgramTypeView" /* KnownCookie.TourProgramTypeView */;
                    return "tourTypeView" /* KnownCookie.TourTypeView */;
                }
            case 'activity':
                return "activityTypeView" /* KnownCookie.ActivityTypeView */;
            case 'hotel':
                return "hotelTypeView" /* KnownCookie.HotelTypeView */;
            default:
                return undefined;
        }
    }, _HotFilter_showView = function _HotFilter_showView(e) {
        const target = $(e.currentTarget);
        if (target.hasClass('_active'))
            return;
        __classPrivateFieldGet(this, _HotFilter_viewItem, "f").removeClass('_active');
        target.addClass('_active');
        const code = target.attr('data-code');
        __classPrivateFieldGet(this, _HotFilter_filterResortsSort, "f").toggleByClass(code !== 'map');
        switch (code) {
            case 'block':
                // Обработчик в tours_blocks.js
                $('body').trigger("tours-block:show-block-view" /* Events.ToursBlockShowBlockView */);
                break;
            case 'table':
                // Обработчик в tours_blocks.js
                $('body').trigger("tours-block:show-table-view" /* Events.ToursBlockShowTableView */);
                // Обработчик события в tours_page.js
                // Обработчик события в countries_h_list.js
                $('body').trigger("tours-page:table-view" /* Events.ToursPageTableView */);
                break;
            case 'map':
                $('body').trigger("tours-block:show-map-view" /* Events.ToursBlockShowMapView */);
                break;
            case 'image':
                $('body').trigger("toursProgram-block:show-image-view" /* Events.ToursProgramBlockShowImageView */);
                break;
            case 'simple':
                $('body').trigger("toursProgram-block:show-simple-view" /* Events.ToursProgramBlockShowSimpleView */);
                break;
            default:
                return;
        }
        if (code !== 'map') {
            const cookie = __classPrivateFieldGet(this, _HotFilter_instances, "m", _HotFilter_getTypeViewCookieCode).call(this);
            if (cookie)
                App.Cookie.set(cookie, code);
        }
        this.activeView = code;
    }, _HotFilter_getActiveSorting = function _HotFilter_getActiveSorting() {
        const target = __classPrivateFieldGet(this, _HotFilter_filterSortItem, "f").filter('._active');
        return { field: target.attr('data-sort') || '', reverse: target.hasClass('_sort-down') };
    }, _HotFilter_updateActiveView = function _HotFilter_updateActiveView() {
        const code = __classPrivateFieldGet(this, _HotFilter_viewItem, "f")
            .filter('._active')
            .first()
            .attr('data-code');
        this.activeView = code == null ? 'block' : code;
    }, _HotFilter_onOnlyTableView = function _HotFilter_onOnlyTableView() {
        __classPrivateFieldGet(this, _HotFilter_viewItem, "f").filter('[data-code="block"]').hide();
        __classPrivateFieldGet(this, _HotFilter_viewItem, "f").filter('[data-code="table"]').hide();
    }, _HotFilter_onFlightSwitch = function _HotFilter_onFlightSwitch(e) {
        const target = $(e.currentTarget);
        if (target.hasClass('_active')) {
            target.removeClass('_active');
            target.text('Скрыть туры без перелета');
            $('html').removeClass('_no-flight');
        }
        else {
            target.addClass('_active');
            target.text('Показать туры без перелета');
            $('html').addClass('_no-flight');
        }
    };
    App.HotFilter = HotFilter;
})(App || (App = {}));
/// <reference path='HotFilter.ts' />
var App;
(function (App) {
    var _HotFilterMobile_instances, _HotFilterMobile_filterResortsSort, _HotFilterMobile_hotFilterBtn, _HotFilterMobile_filterBodyElement, _HotFilterMobile_sortKey, _HotFilterMobile_sortData, _HotFilterMobile_sortTitle, _HotFilterMobile_convertSortDataItem, _HotFilterMobile_getSortTitle, _HotFilterMobile_refreshSortView, _HotFilterMobile_getActiveData, _HotFilterMobile_getActiveSorting;
    class HotFilterMobile extends App.HotFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-hot-filter' }, options));
            _HotFilterMobile_instances.add(this);
            Object.defineProperty(this, "customFilterClass", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: '__custom__filter__'
            });
            _HotFilterMobile_filterResortsSort.set(this, null);
            _HotFilterMobile_hotFilterBtn.set(this, null);
            // Тело фильтра, перемещенное в модалку. Хранится per-instance, т.к. на странице может быть
            // несколько хотфильтров (например, в экскурсиях: поиск, детальная, место посещения).
            _HotFilterMobile_filterBodyElement.set(this, null);
            _HotFilterMobile_sortKey.set(this, void 0);
            _HotFilterMobile_sortData.set(this, []);
            _HotFilterMobile_sortTitle.set(this, void 0);
            __classPrivateFieldSet(this, _HotFilterMobile_sortKey, (options === null || options === void 0 ? void 0 : options.sortKey) || 'Sort.HotFilter', "f");
            __classPrivateFieldSet(this, _HotFilterMobile_filterResortsSort, $('.js-filter-resorts-sort', this.root), "f");
            __classPrivateFieldSet(this, _HotFilterMobile_hotFilterBtn, $('.js-filter-hot-filter', this.root), "f");
            __classPrivateFieldSet(this, _HotFilterMobile_sortTitle, $('.js-sort-mobile-title', this.root), "f");
            // мы не реактивные - подписываемся на события (обновление разметки по событию от Vue)
            PwStore.AddFilterListener(this); // => onFilterChanged
            console.log('PwStore.AddFilterListener(this);', this);
            // сортировка (данные)
            const metaSort = this.root.find('.js-sort-mobile-meta');
            if (metaSort) {
                const dataVal = metaSort.val();
                if (dataVal && typeof (dataVal) != 'undefined' && dataVal != '') {
                    const metaData = JSON.parse(dataVal);
                    if (metaData) {
                        metaData.forEach(m => {
                            __classPrivateFieldGet(this, _HotFilterMobile_sortData, "f").push(...__classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_convertSortDataItem).call(this, m));
                        });
                    }
                }
                // чистим dom, больше не требуется это в разметке
                metaSort.remove();
            }
            // добавляем фильтры (без события, иначе сбросится URL - когда нет checked хоть одного)
            PwStore.AddFilter(__classPrivateFieldGet(this, _HotFilterMobile_sortKey, "f"), __classPrivateFieldGet(this, _HotFilterMobile_sortData, "f"), false);
            // view
            __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_refreshSortView).call(this);
            // show sort modal
            const modalOpts = {
                headerTitleAreaLabel: 'Сортировка',
                applyChangesLabel: 'Применить',
                filterItems: __classPrivateFieldGet(this, _HotFilterMobile_sortKey, "f"),
                type: 'radio',
                triggerModalKey: options === null || options === void 0 ? void 0 : options.triggerModalKey,
            };
            __classPrivateFieldGet(this, _HotFilterMobile_filterResortsSort, "f").on('click', () => {
                PwStore.OpenModal('select-list-filter', modalOpts);
            });
            const filterModalOpts = {
                triggerModalKey: 'filter-modal',
                title: 'Фильтры',
                applyTitle: 'Применить',
                variant: 'sidebar-left',
                color: 'secondary',
                getContent: () => { return 'загрузка...'; },
                onRender: ($placer) => {
                    var _a;
                    const allowedFilters = ($el) => $el.filter(`.${this.customFilterClass}`).each(function (_, el) { $(el).show(); });
                    // Если элемент уже перемещен - используем его
                    if ((_a = __classPrivateFieldGet(this, _HotFilterMobile_filterBodyElement, "f")) === null || _a === void 0 ? void 0 : _a.length) {
                        $placer
                            .html('')
                            .append(allowedFilters(__classPrivateFieldGet(this, _HotFilterMobile_filterBodyElement, "f")));
                        return;
                    }
                    // Первый раз - находим и перемещаем (только свой, в пределах своего root)
                    const $filterBody = $('.js-filter-body', this.root);
                    if ($filterBody.length) {
                        __classPrivateFieldSet(this, _HotFilterMobile_filterBodyElement, $filterBody.detach(), "f");
                        $placer
                            .html('')
                            .append(allowedFilters(__classPrivateFieldGet(this, _HotFilterMobile_filterBodyElement, "f")));
                    }
                },
            };
            __classPrivateFieldGet(this, _HotFilterMobile_hotFilterBtn, "f").on('click', () => {
                PwStore.OpenModal('custom-content-modal', filterModalOpts);
            });
            // refresh current sort
            this.activeSorting = __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_getActiveSorting).call(this);
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                if (filterName == __classPrivateFieldGet(this, _HotFilterMobile_sortKey, "f")) { // если изменился наш фильтр
                    const activeData = __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_getActiveData).call(this);
                    const sorting = __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_getActiveSorting).call(this, activeData);
                    this.activeSorting = sorting;
                    this.root.trigger("filter:sort" /* Events.FilterSort */, [sorting]);
                    // view
                    __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_refreshSortView).call(this, activeData);
                }
            });
        }
        /**
         * устанавливает элементы управления сортировкой по заданным значениям (только кнопки, поле не устанавливает)
         * @param sortingInfo - параметры сортировки
         * @param triggerIt - признак, что надо инициировать клик на кнопку
         * @returns {}
         */
        setFilterSortItems(sortingInfo, triggerIt) {
            super.setFilterSortItems(sortingInfo, triggerIt);
            if (!sortingInfo)
                return;
            if (!__classPrivateFieldGet(this, _HotFilterMobile_sortData, "f"))
                return;
            // change data
            __classPrivateFieldGet(this, _HotFilterMobile_sortData, "f").forEach(d => {
                d.checked = (d.value == (sortingInfo.field + (sortingInfo.reverse ? '_DESC' : '_ASC')));
            });
            PwStore.ChangeFilter(__classPrivateFieldGet(this, _HotFilterMobile_sortKey, "f"), __classPrivateFieldGet(this, _HotFilterMobile_sortData, "f"), triggerIt);
        }
    }
    _HotFilterMobile_filterResortsSort = new WeakMap(), _HotFilterMobile_hotFilterBtn = new WeakMap(), _HotFilterMobile_filterBodyElement = new WeakMap(), _HotFilterMobile_sortKey = new WeakMap(), _HotFilterMobile_sortData = new WeakMap(), _HotFilterMobile_sortTitle = new WeakMap(), _HotFilterMobile_instances = new WeakSet(), _HotFilterMobile_convertSortDataItem = function _HotFilterMobile_convertSortDataItem(sortData) {
        const items = [];
        // asc
        items.push({
            label: __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_getSortTitle).call(this, sortData, false), // sortData.value + ' ↑',
            value: sortData.key + '_ASC',
            key: sortData.key,
            checked: (sortData.selected == true && (!sortData.selectedDesc)),
            reverse: false,
        });
        // desc
        items.push({
            label: __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_getSortTitle).call(this, sortData, true), // sortData.value + ' ↓',
            value: sortData.key + '_DESC',
            key: sortData.key,
            checked: (sortData.selected == true && sortData.selectedDesc == true),
            reverse: true,
        });
        return items;
    }, _HotFilterMobile_getSortTitle = function _HotFilterMobile_getSortTitle(sortData, isReverse) {
        // exact
        if (sortData.value) {
            return (sortData.value + (isReverse ? ' ↓' : ' ↑'));
        }
        // defaults
        if (sortData.key == 'price')
            return (isReverse ? 'Сначала дорогие' : 'Сначала дешевые');
        if (sortData.key == 'date')
            return (isReverse ? 'По дате ↓' : 'По дате ↑');
        // none
        return (isReverse ? ' ↓' : ' ↑');
    }, _HotFilterMobile_refreshSortView = function _HotFilterMobile_refreshSortView(activeData) {
        let title = 'Без сортировки';
        const item = activeData || __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_getActiveData).call(this);
        if (item)
            title = item.label;
        // view
        __classPrivateFieldGet(this, _HotFilterMobile_sortTitle, "f").html(title);
    }, _HotFilterMobile_getActiveData = function _HotFilterMobile_getActiveData() {
        return PwStore.GetFilterItem(__classPrivateFieldGet(this, _HotFilterMobile_sortKey, "f"), false);
    }, _HotFilterMobile_getActiveSorting = function _HotFilterMobile_getActiveSorting(activeData) {
        let item = activeData;
        if (!item)
            item = __classPrivateFieldGet(this, _HotFilterMobile_instances, "m", _HotFilterMobile_getActiveData).call(this);
        if (!item)
            return { field: '', reverse: false };
        return { field: item.key, reverse: item.reverse };
    };
    App.HotFilterMobile = HotFilterMobile;
})(App || (App = {}));
/// <reference path='../../../common/components/HotFilter.Mobile.ts' />
var App;
(function (App) {
    var _ActivityBaseHotFilterMobile_instances, _a, _ActivityBaseHotFilterMobile_setSelectedOptions, _ActivityBaseHotFilterMobile_getSelectListDefaultOption, _ActivityBaseHotFilterMobile_convertOptions, _ActivityBaseHotFilterMobile_onHotFiltersChangeMobile;
    class ActivityBaseHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-search-hot-filter' }, options));
            _ActivityBaseHotFilterMobile_instances.add(this);
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // mobile filters
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: () => this.onSelfFilterChanged() });
        }
        onSelfFilterChanged() {
            return __awaiter(this, void 0, void 0, function* () {
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                // this.root.trigger(Events.FilterChange); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
                __classPrivateFieldGet(this, _ActivityBaseHotFilterMobile_instances, "m", _ActivityBaseHotFilterMobile_onHotFiltersChangeMobile).call(this);
            });
        }
        // Обновляет хот-фильтры
        refreshHotFilters(activityHotFilters, selectedFilters) {
            const activityHotFilterKeys = Object.keys(activityHotFilters);
            for (let i = 0; i < activityHotFilterKeys.length; i++) {
                const key = activityHotFilterKeys[i];
                switch (key.toLowerCase()) {
                    case App.ActivityHotFilterFields.ActivityAttributes: {
                        const optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_setSelectedOptions).call(_a, App.ActivityHotFilterFields.ActivityAttributes, activityHotFilters.activityAttributes, selectedFilters);
                        this.filters.setControlValue(key, __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_convertOptions).call(_a, optionListData), false);
                        break;
                    }
                    case App.ActivityHotFilterFields.GuideTypes: {
                        const isDefSelected = !selectedFilters
                            || selectedFilters.every(v => v.name.toLowerCase() !== App.ActivityHotFilterFields.GuideTypes);
                        let optionListData = new Array();
                        optionListData.push(__classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_getSelectListDefaultOption).call(_a, isDefSelected));
                        optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_setSelectedOptions).call(_a, App.ActivityHotFilterFields.GuideTypes, activityHotFilters.guideTypes, selectedFilters);
                        this.filters.setControlValue(key, __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_convertOptions).call(_a, optionListData), false);
                        break;
                    }
                    case App.ActivityHotFilterFields.IsGroup: {
                        const optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_setSelectedOptions).call(_a, App.ActivityHotFilterFields.IsGroup, activityHotFilters.isGroup, selectedFilters);
                        this.filters.setControlValue(key, __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_convertOptions).call(_a, optionListData), false);
                        break;
                    }
                    case App.ActivityHotFilterFields.LandmarkNames: {
                        const optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_setSelectedOptions).call(_a, App.ActivityHotFilterFields.LandmarkNames, activityHotFilters.landmarkNames, selectedFilters);
                        this.filters.setControlValue(key, __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_convertOptions).call(_a, optionListData), false);
                        break;
                    }
                    case App.ActivityHotFilterFields.TransportTypes: {
                        const optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_setSelectedOptions).call(_a, App.ActivityHotFilterFields.TransportTypes, activityHotFilters.transportTypes, selectedFilters);
                        this.filters.setControlValue(key, __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilterMobile_convertOptions).call(_a, optionListData), false);
                        break;
                    }
                    // no default
                }
            }
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('activity/hotFilterFoundTitle', { count: data.length }));
        }
        onHotFiltersChange() {
            // const mapper = new HotFilterMapper(this.root);
            // this.root.trigger(Events.FilterFilter, { items: mapper.execute() });
            // NOTE: ничего не делаем по "обычной" подписке - обработаем сами
            // NOTE: этот метод оставлен, чтобы не переписывать весь HotFilter ради изменения в одной строчке кода
        }
        reset() {
            super.reset();
            this.filters.reset();
        }
        clear() {
            super.clear();
            this.filters.clear();
        }
    }
    _a = ActivityBaseHotFilterMobile, _ActivityBaseHotFilterMobile_instances = new WeakSet(), _ActivityBaseHotFilterMobile_setSelectedOptions = function _ActivityBaseHotFilterMobile_setSelectedOptions(parameterName, hotFilterOptionList, selectedFilters) {
        let optionListData = hotFilterOptionList;
        if (selectedFilters) {
            const currentSelectedFilter = selectedFilters
                .find(filter => filter.name === parameterName);
            if (currentSelectedFilter && currentSelectedFilter.values.length > 0) {
                // если в списке хотфильтра есть такие значения, как в параметрах, помечаем их выбранными
                optionListData = hotFilterOptionList
                    .map(listItem => {
                    // если среди параметров есть значение элемента. делаем элемент выбранным
                    let itemSelected = false;
                    if (currentSelectedFilter.values.some(value => value === listItem.value))
                        itemSelected = true;
                    return {
                        value: listItem.value,
                        text: listItem.text,
                        selected: itemSelected,
                        custom: listItem.custom,
                    };
                });
            }
        }
        return optionListData;
    }, _ActivityBaseHotFilterMobile_getSelectListDefaultOption = function _ActivityBaseHotFilterMobile_getSelectListDefaultOption(selected) {
        return { value: '', text: localizer.all, selected };
    }, _ActivityBaseHotFilterMobile_convertOptions = function _ActivityBaseHotFilterMobile_convertOptions(arrFrom) {
        return App.MobileFilterBlockBase.convertArrayFromListOptions(arrFrom);
    }, _ActivityBaseHotFilterMobile_onHotFiltersChangeMobile = function _ActivityBaseHotFilterMobile_onHotFiltersChangeMobile() {
        const mapper = new App.HotFilterMapperMobile(this.root, this.filters);
        this.root.trigger("filter:filter" /* Events.FilterFilter */, { items: mapper.execute() });
    };
    App.ActivityBaseHotFilterMobile = ActivityBaseHotFilterMobile;
})(App || (App = {}));
/// <reference path='../../../common/components/HotFilter.ts' />
var App;
(function (App) {
    var _ActivityBaseHotFilter_instances, _a, _ActivityBaseHotFilter_setSelectedOptions, _ActivityBaseHotFilter_initSelectListDefaultOption;
    class ActivityBaseHotFilter extends App.HotFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-search-hot-filter' }, options));
            _ActivityBaseHotFilter_instances.add(this);
        }
        // Обновляет хот-фильтры
        refreshHotFilters(activityHotFilters, selectedFilters) {
            const activityHotFilterKeys = Object.keys(activityHotFilters);
            for (let i = 0; i < activityHotFilterKeys.length; i++) {
                const key = activityHotFilterKeys[i];
                const filterControl = this.findControl(key);
                if (!filterControl)
                    return;
                let optionListData = new Array();
                switch (key.toLowerCase()) {
                    case App.ActivityHotFilterFields.ActivityAttributes:
                        optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilter_setSelectedOptions).call(_a, App.ActivityHotFilterFields.ActivityAttributes, activityHotFilters.activityAttributes, selectedFilters);
                        break;
                    case App.ActivityHotFilterFields.GuideTypes:
                        filterControl.clearOptions(false);
                        // если есть хотя бы один выбранный элемент, 'Все' не выбраны
                        __classPrivateFieldGet(this, _ActivityBaseHotFilter_instances, "m", _ActivityBaseHotFilter_initSelectListDefaultOption).call(this, App.ActivityHotFilterFields.GuideTypes, !selectedFilters || selectedFilters.every(v => v.name.toLowerCase() !== App.ActivityHotFilterFields.GuideTypes));
                        optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilter_setSelectedOptions).call(_a, App.ActivityHotFilterFields.GuideTypes, activityHotFilters.guideTypes, selectedFilters);
                        break;
                    case App.ActivityHotFilterFields.IsGroup:
                        optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilter_setSelectedOptions).call(_a, App.ActivityHotFilterFields.IsGroup, activityHotFilters.isGroup, selectedFilters);
                        break;
                    case App.ActivityHotFilterFields.LandmarkNames:
                        optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilter_setSelectedOptions).call(_a, App.ActivityHotFilterFields.LandmarkNames, activityHotFilters.landmarkNames, selectedFilters);
                        break;
                    case App.ActivityHotFilterFields.TransportTypes:
                        optionListData = __classPrivateFieldGet(_a, _a, "m", _ActivityBaseHotFilter_setSelectedOptions).call(_a, App.ActivityHotFilterFields.TransportTypes, activityHotFilters.transportTypes, selectedFilters);
                        break;
                    // no default
                }
                filterControl.replaceOptions(optionListData, true);
            }
        }
        onHotFiltersChange() {
            const mapper = new App.HotFilterMapper(this.root);
            this.root.trigger("filter:filter" /* Events.FilterFilter */, { items: mapper.execute() });
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('activity/hotFilterFoundTitle', { count: data.length }));
        }
    }
    _a = ActivityBaseHotFilter, _ActivityBaseHotFilter_instances = new WeakSet(), _ActivityBaseHotFilter_setSelectedOptions = function _ActivityBaseHotFilter_setSelectedOptions(parameterName, hotFilterOptionList, selectedFilters) {
        let optionListData = hotFilterOptionList;
        if (selectedFilters) {
            const currentSelectedFilter = selectedFilters
                .find(filter => filter.name === parameterName);
            if (currentSelectedFilter && currentSelectedFilter.values.length > 0) {
                // если в списке хотфильтра есть такие значения, как в параметрах, помечаем их выбранными
                optionListData = hotFilterOptionList
                    .map(listItem => {
                    // если среди параметров есть значение элемента. делаем элемент выбранным
                    let itemSelected = false;
                    if (currentSelectedFilter.values.some(value => value === listItem.value))
                        itemSelected = true;
                    return {
                        value: listItem.value,
                        text: listItem.text,
                        selected: itemSelected,
                        custom: listItem.custom,
                    };
                });
            }
        }
        return optionListData;
    }, _ActivityBaseHotFilter_initSelectListDefaultOption = function _ActivityBaseHotFilter_initSelectListDefaultOption(controlName, selected) {
        const control = this.findControl(controlName);
        if (control) {
            const allOption = { value: '', text: localizer.all, selected };
            control.replaceOptions([allOption], true);
        }
    };
    App.ActivityBaseHotFilter = ActivityBaseHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    class ActivityDetailHotFilterMobile extends App.ActivityBaseHotFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-detail-hot-filter' }, options));
        }
    }
    App.ActivityDetailHotFilterMobile = ActivityDetailHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class ActivityDetailHotFilter extends App.ActivityBaseHotFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-detail-hot-filter' }, options));
        }
    }
    App.ActivityDetailHotFilter = ActivityDetailHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    class ActivityLandmarkHotFilterMobile extends App.ActivityBaseHotFilterMobile {
        constructor() {
            super({ root: '.js-landmark-hot-filter' });
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
        }
    }
    App.ActivityLandmarkHotFilterMobile = ActivityLandmarkHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class ActivityLandmarkHotFilter extends App.ActivityBaseHotFilter {
        constructor() {
            super({ root: '.js-landmark-hot-filter' });
        }
    }
    App.ActivityLandmarkHotFilter = ActivityLandmarkHotFilter;
})(App || (App = {}));
/// <reference path='ActivityBaseHotFilter.Mobile.ts' />
var App;
(function (App) {
    class ActivitySearchHotFilterMobile extends App.ActivityBaseHotFilterMobile {
        constructor() {
            super({ root: '.js-search-hot-filter' });
            // Скрываем тело фильтра на странице и помечаем его для переноса в модалку "Фильтры" (см. HotFilterMobile).
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
        }
    }
    App.ActivitySearchHotFilterMobile = ActivitySearchHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class ActivitySearchHotFilter extends App.ActivityBaseHotFilter {
        constructor() {
            super({ root: '.js-search-hot-filter' });
        }
    }
    App.ActivitySearchHotFilter = ActivitySearchHotFilter;
})(App || (App = {}));
/* eslint-disable @typescript-eslint/no-unsafe-call */
var App;
(function (App) {
    var _FilterMobile_options;
    class FilterMobile {
        constructor(options) {
            var _a;
            _FilterMobile_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "controls", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const defaults = {
                root: '.js-filter',
                maxChildAge: 12,
                ignoreValidator: false,
                autocompleteOptions: {
                    minLength: App.app.settings.minSearchTermLength,
                },
            };
            __classPrivateFieldSet(this, _FilterMobile_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _FilterMobile_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            // mobile filters
            if (__classPrivateFieldGet(this, _FilterMobile_options, "f").customFilters) {
                const customFilters = new App.MobileCustomContentModal(__classPrivateFieldGet(this, _FilterMobile_options, "f").customFilters);
                this.filters = customFilters.filters;
            }
            else {
                // filters root
                let filtersRoot = this.root;
                if (__classPrivateFieldGet(this, _FilterMobile_options, "f").filtersRoot) {
                    const froot = __classPrivateFieldGet(this, _FilterMobile_options, "f").filtersRoot;
                    if (typeof froot === 'string')
                        filtersRoot = $(froot);
                    else
                        filtersRoot = froot;
                }
                // filters do
                this.filters = new App.FiltersMobileBase({
                    root: filtersRoot,
                    onFilterChanged: v => this.onFilterChanged(v),
                    ignoreValidator: __classPrivateFieldGet(this, _FilterMobile_options, "f").ignoreValidator,
                    validatorRules: __classPrivateFieldGet(this, _FilterMobile_options, "f").validatorRules,
                });
            }
            // validator
            this.validator = (_a = this.filters) === null || _a === void 0 ? void 0 : _a.validator;
            // некие не мобильные контролы
            const filterSliderBlock = this.root.find('.js-filter-slider-block, .js-form-slider-block');
            const filterPeopleBlock = this.root.find('.js-filter-people-block, .js-form-people-block');
            const filterSlidingBtn = this.root.find('.js-filter-sliding-btn-b, .js-form-sliding-btn-b');
            const filterRadioBtn = this.root.find('.js-filter-radio-btn, .js-form-radio-btn');
            const filterMoreOpts = this.root.find('.js-filter-more-opts, .js-form-more-opts');
            const filterSingleCheckBox = this.root.find('.js-filter-single-checkbox, .js-form-single-checkbox');
            // gender
            const genderInputs = this.root.find('.js-mobile-filter-gender-block');
            if (genderInputs) {
                // возможно множество таких контролов
                genderInputs.each((i, g) => {
                    var _a;
                    const $g = $(g);
                    const genderKey = $g.attr('data-name');
                    const genderIcon = $g.parents('.js-form-gender').find('.js-form-gender-icon'); // this.root.find('.js-form-gender-icon');
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    const ctrlGender = (_a = this.filters) === null || _a === void 0 ? void 0 : _a.getControl(genderKey);
                    if (ctrlGender) {
                        ctrlGender.setCustomEventChange((v) => {
                            // иконка туриста
                            if (genderIcon)
                                genderIcon.toggleClass('_woman', (v == App.MobileFilterGenderValue.Female));
                        });
                    }
                });
            }
            // Обходим каждый блок со слайдером
            // TODO: переделать на мобильный контрол?
            filterSliderBlock.each((i, v) => {
                this.controls.push(new App.FilterSliderBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _FilterMobile_options, "f").sliderOptions)));
            });
            // Обходим каждый блок с туристами
            // TODO: переделать на мобильный контрол?
            filterPeopleBlock.each((i, v) => {
                this.controls.push(new App.FilterPeopleBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _FilterMobile_options, "f").peopleOptions)));
            });
            // Обходим каждый блок с услугами
            // TODO: переделать на мобильный контрол?
            this.root.find('.js-services-block').each((i, v) => { this.controls.push(new App.FilterServicesBlock({ root: $(v) })); });
            // Блок Категория отеля
            // TODO: переделать на мобильный контрол?
            this.root.find('.js-hotel-stars-block').each((i, v) => {
                this.controls.push(new App.FilterHotelStarsBlock(Object.assign({ root: $(v) }, __classPrivateFieldGet(this, _FilterMobile_options, "f").hotelStarsValues)));
            });
            // Название предложения
            // TODO: переделать на мобильный контрол?
            const filterOfferName = this.root.find('.js-filter-offer-name');
            this.controls.push(new App.FilterNameBlock({ root: $(filterOfferName) }));
            // Блок со скользящим переключателем (sliding button)
            // TODO: переделать на мобильный контрол?
            filterSlidingBtn.each((i, v) => { this.controls.push(new App.FilterSlidingButtonBlock({ root: $(v) })); });
            // Блок с радио переключателем (radio button)
            // TODO: переделать на мобильный контрол?
            filterRadioBtn.on('click', e => {
                const target = $(e.currentTarget);
                const input = target.closest('.js-filter-radio-btn-group').find('input');
                filterRadioBtn.removeClass('_on');
                target.addClass('_on');
                input.val(target.closest('.js-filter-radio-btn-group').find('.js-filter-radio-btn').filter('._on').attr('data-id') || '');
                // TODO: в данном случае instance будет ссылаться на текущий экземпляр Filter, а не на экземпляр класса с радио переключателем! Для фикса необходимо вынести этот код в отдельный класс.
                target.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
            });
            this.root.find('.js-filter-radio-label').on('click', e => {
                $(e.currentTarget).closest('.js-filter-radio-wrap').find('.js-filter-radio-btn').trigger('click');
            });
            // Блок Подобрать, клик по ссылке Дополнительные параметры
            filterMoreOpts.on('click', e => this.showMore(e));
            filterSingleCheckBox.each((_, v) => { this.controls.push(new App.FilterSingleCheckBoxBlock({ root: $(v) })); });
            // Клик по 'Очистить фильтр' - сбрасываем все значения во всех фильтрах в Основном фильтре
            this.root.find('.js-clear-filter').on('click', () => this.reset());
            // Спойлеры формы
            $('.js-form-spoiler', this.root).each((i, v) => {
                const jqElement = $(v);
                const toggle = $('.js-form-spoiler-toggle', jqElement);
                const content = $('.js-form-spoiler-content', jqElement);
                toggle.on('click', () => {
                    content.slideToggle(400, () => {
                        toggle.toggleClass('_opened');
                    });
                });
            });
            // Обрабатываем счетчик +/- 1
            // TODO: переделать на мобильный контрол?
            $('.js-form-counter', this.root).each((i, v) => {
                const jqElement = $(v);
                const plus = jqElement.siblings('.plus');
                const minus = jqElement.siblings('.minus');
                jqElement.inputmask({
                    regex: '[0-9 ]*',
                    placeholder: '0',
                });
                plus.on('click', () => {
                    const value = jqElement.valNumber() || 0;
                    jqElement.val(value + 1);
                });
                minus.on('click', () => {
                    const value = jqElement.valNumber() || 0;
                    jqElement.val(value - 1 >= 0 ? value - 1 : 0);
                });
            });
            // Зависимость кнопки от чекбоксов [data-depends="name1,name1,..."]
            // TODO: переехать в FiltersMobileBase.ts?
            $('[data-depends]', this.root).each((i, v) => {
                const jqElement = $(v);
                const selector = ($(v).attr('data-depends') || '').split(',')
                    .map(x => `[name="${x}"]`)
                    .join(', ');
                const depends = this.root.find(selector);
                depends.on('change', () => {
                    if (depends.filter(':checked').length !== depends.length)
                        jqElement.attr('disabled', 'disabled');
                    else
                        jqElement.removeAttr('disabled');
                }).trigger('change');
            });
            // TODO: по идее данный код должен быть в блоке с обработкой контролов-интервалов.
            // TODO: переделать на мобильный контрол?
            const filterNightsFrom = this.root.find('[data-name="filter_nights_from"]');
            const filterNightsTo = this.root.find('[data-name="filter_nights_to"]');
            if (filterNightsFrom.length && filterNightsTo.length) {
                filterNightsFrom.on("filter:change" /* Events.FilterChange */, () => {
                    const fromVal = filterNightsFrom.find('.js-jelect-input').valNumber() || 0;
                    const toVal = filterNightsTo.find('.js-jelect-input').valNumber() || 0;
                    if (fromVal > toVal)
                        filterNightsTo.find(`.js-filter-option[data-val='${fromVal}']`).trigger('click');
                });
                filterNightsTo.on("filter:change" /* Events.FilterChange */, () => {
                    const fromVal = filterNightsFrom.find('.js-jelect-input').valNumber() || 0;
                    const toVal = filterNightsTo.find('.js-jelect-input').valNumber() || 0;
                    if (toVal < fromVal)
                        filterNightsFrom.find(`.js-filter-option[data-val='${toVal}']`).trigger('click');
                });
            }
        }
        /**
         * Уничтожение объекта.
         * Отвязка своих контролов от прослушки/посылки событий.
         */
        dispose() {
            if (this.filters)
                this.filters.dispose();
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                // пробрасываем событие - что слушают через опции
                if (__classPrivateFieldGet(this, _FilterMobile_options, "f").onFilterChanged)
                    yield __classPrivateFieldGet(this, _FilterMobile_options, "f").onFilterChanged(filterName);
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
            });
        }
        validate() {
            return this.filters.validate();
        }
        getOptions() {
            return __classPrivateFieldGet(this, _FilterMobile_options, "f");
        }
        showMore(e) {
            $(e.currentTarget).toggleClass('_on');
            this.root.toggleClass('_more');
        }
        /**
         * Поиск среди фильтров (НЕ Мобильных).
         * НЕ ДОЛЖНО БЫТЬ ТАКОГО МЕТОДА В МОБИЛЬНОЙ ЛОГИКЕ.
         * Искать лучше среди мобильных фильтров в this.filters.findControl.
         */
        findControl(name) {
            const searchName = name.toUpperCase();
            const result = this.controls.find(v => v.name != null && v.name.toUpperCase() === searchName);
            if (!result)
                return result;
            // NOTE: тут поиск только НЕ мобильных контролов
            // TODO: неплохо было бы для debug здесь иметь проверку типа контрола, но TypeScript (по крайней мере до v2.8.3) пока не
            // позволяет это сделать без доп.аргумента (см.https://github.com/microsoft/TypeScript/issues/5236#issuecomment-147652993).
            // if (app.settings.debug && !(result instanceof T))
            //   console.warn(`The requested type '${T.name}' of the '${name}' control isn't assignable to the type '${result.name}' of
            //   obtained real object.`);
            return result;
        }
        reset() {
            // TODO: возможность передавать список названий полей, только которые сбрасывать.
            this.controls.forEach(item => item.reset());
            this.filters.reset();
        }
        clear() {
            // TODO: возможность передавать список названий полей, только которые очищать.
            this.controls.forEach(item => item.clear());
            this.filters.clear();
        }
    }
    _FilterMobile_options = new WeakMap();
    App.FilterMobile = FilterMobile;
})(App || (App = {}));
/// <reference path='Filter.Mobile.ts' />
var App;
(function (App) {
    var _MainFilterMobile_instances, _MainFilterMobile_openFilterText, _MainFilterMobile_currencySelected, _MainFilterMobile_currencyBlock, _MainFilterMobile_currencyOption, _MainFilterMobile_actionsSwitch, _MainFilterMobile_yearsSwitch, _MainFilterMobile_countrySelected, _MainFilterMobile_countriesBlock, _MainFilterMobile_countryOption, _MainFilterMobile_citySelected, _MainFilterMobile_citiesBlock, _MainFilterMobile_cityOption, _MainFilterMobile_timeout, _MainFilterMobile_onMainFilterOpen, _MainFilterMobile_addOverflowVisible, _MainFilterMobile_currencyShow, _MainFilterMobile_currencyChange, _MainFilterMobile_countriesShow, _MainFilterMobile_countriesHide, _MainFilterMobile_onOutsideCountriesClick, _MainFilterMobile_countriesChange, _MainFilterMobile_citiesSelectBind, _MainFilterMobile_countryChangeCities, _MainFilterMobile_citiesShow, _MainFilterMobile_citiesHide, _MainFilterMobile_onOutsideCitiesClick, _MainFilterMobile_citiesChange, _MainFilterMobile_citiesMulticolsChange, _MainFilterMobile_filterActions, _MainFilterMobile_filterNews;
    class MainFilterMobile extends App.FilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-main-filter' }, options));
            _MainFilterMobile_instances.add(this);
            Object.defineProperty(this, "submitButton", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _MainFilterMobile_openFilterText.set(this, void 0);
            _MainFilterMobile_currencySelected.set(this, void 0);
            _MainFilterMobile_currencyBlock.set(this, void 0);
            _MainFilterMobile_currencyOption.set(this, void 0);
            _MainFilterMobile_actionsSwitch.set(this, void 0);
            _MainFilterMobile_yearsSwitch.set(this, void 0);
            _MainFilterMobile_countrySelected.set(this, void 0);
            _MainFilterMobile_countriesBlock.set(this, void 0);
            _MainFilterMobile_countryOption.set(this, void 0);
            _MainFilterMobile_citySelected.set(this, void 0);
            _MainFilterMobile_citiesBlock.set(this, void 0);
            _MainFilterMobile_cityOption.set(this, void 0);
            _MainFilterMobile_timeout.set(this, void 0);
            this.submitButton = $('.js-m-filter-submit', this.root);
            const openFilter = $('.js-open-m-filter', this.root);
            __classPrivateFieldSet(this, _MainFilterMobile_openFilterText, $('.js-open-m-filter-text', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_currencySelected, $('.js-currency-selected', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_currencyBlock, $('.js-currency-block', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_currencyOption, $('.js-currency-option', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_actionsSwitch, $('.js-filter-actions-switch', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_yearsSwitch, $('.js-filter-year-switch', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_countrySelected, $('.js-country-selected', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_countriesBlock, $('.js-countries-block', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_countryOption, $('.js-country-option', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_citySelected, $('.js-city-selected', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_citiesBlock, $('.js-cities-block', this.root), "f");
            __classPrivateFieldSet(this, _MainFilterMobile_cityOption, $('.js-city-option', this.root), "f");
            // ТОЛЬКО  ДЛЯ  ОТЛАДКИ начало
            const showAgentsBtn = $('.js-filter-show-agent-b', this.root);
            const showResultsBtn = $('.js-filter-show-results-b', this.root);
            showAgentsBtn.on('click', () => {
                this.root.toggleClass('_agent');
            });
            showResultsBtn.on('click', () => {
                this.root.toggleClass('_results');
            });
            // ТОЛЬКО  ДЛЯ  ОТЛАДКИ конец
            // Раскрываем основной фильтр
            openFilter.on('click', () => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_onMainFilterOpen).call(this));
            // Переключаем валюту
            __classPrivateFieldGet(this, _MainFilterMobile_currencySelected, "f").on('click', () => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_currencyShow).call(this));
            __classPrivateFieldGet(this, _MainFilterMobile_currencyOption, "f").on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_currencyChange).call(this, e));
            // Переключаем даты
            // this.#dateSelected.on('click', () => this.#datesShow());
            // this.#dateOption.on('click', e => this.#dateChange(e));
            // $('html').on('click', e => this.#onOutsideDatesClick(e));
            // Переключаем страны
            __classPrivateFieldGet(this, _MainFilterMobile_countrySelected, "f").on('click', () => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_countriesShow).call(this));
            __classPrivateFieldGet(this, _MainFilterMobile_countryOption, "f").on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_countriesChange).call(this, e));
            $('html').on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_onOutsideCountriesClick).call(this, e));
            // Переключаем города
            __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesSelectBind).call(this);
            $('html').on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_onOutsideCitiesClick).call(this, e));
            // Обрабатываем фильтрацию акций по типу
            __classPrivateFieldGet(this, _MainFilterMobile_actionsSwitch, "f").on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_filterActions).call(this, e));
            // Обрабатывает фильтрацию новостей по году
            __classPrivateFieldGet(this, _MainFilterMobile_yearsSwitch, "f").on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_filterNews).call(this, e));
        }
    }
    _MainFilterMobile_openFilterText = new WeakMap(), _MainFilterMobile_currencySelected = new WeakMap(), _MainFilterMobile_currencyBlock = new WeakMap(), _MainFilterMobile_currencyOption = new WeakMap(), _MainFilterMobile_actionsSwitch = new WeakMap(), _MainFilterMobile_yearsSwitch = new WeakMap(), _MainFilterMobile_countrySelected = new WeakMap(), _MainFilterMobile_countriesBlock = new WeakMap(), _MainFilterMobile_countryOption = new WeakMap(), _MainFilterMobile_citySelected = new WeakMap(), _MainFilterMobile_citiesBlock = new WeakMap(), _MainFilterMobile_cityOption = new WeakMap(), _MainFilterMobile_timeout = new WeakMap(), _MainFilterMobile_instances = new WeakSet(), _MainFilterMobile_onMainFilterOpen = function _MainFilterMobile_onMainFilterOpen() {
        this.root.toggleClass('_unfolded');
        // Добавляем / удаляем класс '_overflow-visible'
        if (this.root.hasClass('_unfolded')) {
            __classPrivateFieldGet(this, _MainFilterMobile_openFilterText, "f").text('Свернуть подбор тура');
            __classPrivateFieldSet(this, _MainFilterMobile_timeout, window.setTimeout(() => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_addOverflowVisible).call(this), 350), "f");
        }
        else {
            __classPrivateFieldGet(this, _MainFilterMobile_openFilterText, "f").text('Развернуть подбор тура');
            this.root.removeClass('_overflow-visible');
        }
    }, _MainFilterMobile_addOverflowVisible = function _MainFilterMobile_addOverflowVisible() {
        this.root.addClass('_overflow-visible');
        clearTimeout(__classPrivateFieldGet(this, _MainFilterMobile_timeout, "f"));
    }, _MainFilterMobile_currencyShow = function _MainFilterMobile_currencyShow() {
        __classPrivateFieldGet(this, _MainFilterMobile_currencyBlock, "f").addClass('_open');
    }, _MainFilterMobile_currencyChange = function _MainFilterMobile_currencyChange(e) {
        const target = $(e.currentTarget);
        __classPrivateFieldGet(this, _MainFilterMobile_currencyOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilterMobile_currencyBlock, "f").removeClass('_open');
        __classPrivateFieldGet(this, _MainFilterMobile_currencySelected, "f").text(target.text());
    }, _MainFilterMobile_countriesShow = function _MainFilterMobile_countriesShow() {
        __classPrivateFieldGet(this, _MainFilterMobile_countriesBlock, "f").fadeIn(150);
        __classPrivateFieldGet(this, _MainFilterMobile_countriesBlock, "f").addClass('_open');
    }, _MainFilterMobile_countriesHide = function _MainFilterMobile_countriesHide() {
        __classPrivateFieldGet(this, _MainFilterMobile_countriesBlock, "f").removeClass('_open');
        __classPrivateFieldGet(this, _MainFilterMobile_countriesBlock, "f").hide();
    }, _MainFilterMobile_onOutsideCountriesClick = function _MainFilterMobile_onOutsideCountriesClick(e) {
        const target = $(e.target);
        if (!target.hasClass('js-countries-block') && !target.hasClass('js-country-option') && !target.hasClass('js-country-selected'))
            __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_countriesHide).call(this);
    }, _MainFilterMobile_countriesChange = function _MainFilterMobile_countriesChange(e) {
        const target = $(e.currentTarget);
        const index = target.index();
        const id = target.attr('data-id');
        if (!id)
            return;
        // Позиционируем попап с датами вверх/вниз в зависимости от выбранной даты
        if (index === 0)
            __classPrivateFieldGet(this, _MainFilterMobile_countriesBlock, "f").removeAttr('style');
        else if (index < 9)
            __classPrivateFieldGet(this, _MainFilterMobile_countriesBlock, "f").css({ 'margin-top': `-${index * 29}px` });
        else
            __classPrivateFieldGet(this, _MainFilterMobile_countriesBlock, "f").css({ 'margin-top': `-${9 * 29}px` });
        __classPrivateFieldGet(this, _MainFilterMobile_countryOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_countriesHide).call(this);
        __classPrivateFieldGet(this, _MainFilterMobile_countrySelected, "f").text(target.text());
        __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_countryChangeCities).call(this, id);
    }, _MainFilterMobile_citiesSelectBind = function _MainFilterMobile_citiesSelectBind() {
        const cities = __classPrivateFieldGet(this, _MainFilterMobile_cityOption, "f").filter('._enabled');
        const citiesCount = cities.length - 1;
        if (citiesCount > 15) {
            const colLength = Math.round(citiesCount / 2) + 1;
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").append('<li class="fake-li"><ul class="col col-left"></ul></li>');
            const colLeft = __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").find('.col-left');
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").append('<li class="fake-li"><ul class="col col-right"></ul></li>');
            const colRight = __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").find('.col-right');
            for (let i = 0; i <= citiesCount; i++) {
                if (i < colLength)
                    cities.eq(i).appendTo(colLeft);
                else
                    cities.eq(i).appendTo(colRight);
            }
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").addClass('_with-cols');
            cities.on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesMulticolsChange).call(this, e));
        }
        else {
            cities.on('click', e => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesChange).call(this, e));
        }
        __classPrivateFieldGet(this, _MainFilterMobile_citySelected, "f").on('click', () => __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesShow).call(this));
    }, _MainFilterMobile_countryChangeCities = function _MainFilterMobile_countryChangeCities(id) {
        // Если города в 2 колонки
        if (__classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").hasClass('_with-cols')) {
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").removeClass('_with-cols');
            __classPrivateFieldGet(this, _MainFilterMobile_cityOption, "f").detach();
            __classPrivateFieldGet(this, _MainFilterMobile_cityOption, "f").appendTo(__classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f"));
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").find('.fake-li').remove();
        }
        __classPrivateFieldGet(this, _MainFilterMobile_cityOption, "f").removeClass('_enabled _active _last');
        __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").removeAttr('style');
        const enabledOptions = __classPrivateFieldGet(this, _MainFilterMobile_cityOption, "f").filter(`[data-country=${id}]`);
        const firstOptions = enabledOptions.eq(0);
        enabledOptions.addClass('_enabled');
        firstOptions.addClass('_active');
        enabledOptions.last().addClass('_last');
        __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesSelectBind).call(this);
        __classPrivateFieldGet(this, _MainFilterMobile_citySelected, "f").text(firstOptions.text());
    }, _MainFilterMobile_citiesShow = function _MainFilterMobile_citiesShow() {
        __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").fadeIn(150);
        __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").addClass('_open');
    }, _MainFilterMobile_citiesHide = function _MainFilterMobile_citiesHide() {
        __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").removeClass('_open');
        __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").hide();
    }, _MainFilterMobile_onOutsideCitiesClick = function _MainFilterMobile_onOutsideCitiesClick(e) {
        const target = $(e.target);
        if (!target.hasClass('js-cities-block') && !target.hasClass('js-city-option') && !target.hasClass('js-city-selected'))
            __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesHide).call(this);
    }, _MainFilterMobile_citiesChange = function _MainFilterMobile_citiesChange(e) {
        const target = $(e.currentTarget);
        const index = target.index('._enabled');
        // Позиционируем попап с городами вверх/вниз в зависимости от выбранного города
        if (index === 0)
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").removeAttr('style');
        else if (index < 9)
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").css({ 'margin-top': `-${index * 29}px` });
        else
            __classPrivateFieldGet(this, _MainFilterMobile_citiesBlock, "f").css({ 'margin-top': `-${9 * 29}px` });
        __classPrivateFieldGet(this, _MainFilterMobile_cityOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesHide).call(this);
        __classPrivateFieldGet(this, _MainFilterMobile_citySelected, "f").text(target.text());
    }, _MainFilterMobile_citiesMulticolsChange = function _MainFilterMobile_citiesMulticolsChange(e) {
        const target = $(e.currentTarget);
        __classPrivateFieldGet(this, _MainFilterMobile_cityOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilterMobile_instances, "m", _MainFilterMobile_citiesHide).call(this);
        __classPrivateFieldGet(this, _MainFilterMobile_citySelected, "f").text(target.text());
    }, _MainFilterMobile_filterActions = function _MainFilterMobile_filterActions(e) {
        const target = $(e.currentTarget);
        // Если клик НЕ по уже выбранному типу
        if (!target.hasClass('_active')) {
            __classPrivateFieldGet(this, _MainFilterMobile_actionsSwitch, "f").removeClass('_active');
            target.addClass('_active');
        }
    }, _MainFilterMobile_filterNews = function _MainFilterMobile_filterNews(e) {
        const target = $(e.currentTarget);
        // Если клик НЕ по уже выбранному типу
        if (!target.hasClass('_active')) {
            __classPrivateFieldGet(this, _MainFilterMobile_yearsSwitch, "f").removeClass('_active');
            target.addClass('_active');
        }
    };
    App.MainFilterMobile = MainFilterMobile;
})(App || (App = {}));
/// <reference path='../../../common/components/MainFilter.Mobile.ts' />
var App;
(function (App) {
    var _ActivityMainFilterMobile_options;
    class ActivityMainFilterMobile extends App.MainFilterMobile {
        constructor(options) {
            super(Object.assign(Object.assign({}, ActivityMainFilterMobile.s_defaults), options));
            _ActivityMainFilterMobile_options.set(this, void 0);
            __classPrivateFieldSet(this, _ActivityMainFilterMobile_options, this.getOptions(), "f");
        }
        onFilterChanged(filterName) {
            const _super = Object.create(null, {
                onFilterChanged: { get: () => super.onFilterChanged }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                yield _super.onFilterChanged.call(this, filterName);
                if (filterName == 'DateFrom') {
                    const dateFrom = this.findFilter('DateFrom');
                    const dateTo = this.findFilter('DateTo');
                    if (dateFrom && dateTo) {
                        // TODO: я так и не понял, сколько дней от даты начала? на боевом сайте это число меняется, если переключать дату С-По
                        const dateOffset = ((_a = __classPrivateFieldGet(this, _ActivityMainFilterMobile_options, "f").datesOptions) === null || _a === void 0 ? void 0 : _a.defaultDateToOffset) || 0;
                        dateTo === null || dateTo === void 0 ? void 0 : dateTo.setValueAndAddDays(dateFrom === null || dateFrom === void 0 ? void 0 : dateFrom.getValue(), dateOffset, true);
                    }
                }
            });
        }
        findFilter(name) {
            // const searchName = name.toUpperCase();
            // const result = this.controls.find(v => v.name != null && v.name.toUpperCase() === searchName);
            const result = this.filters.findControl(name);
            if (!result)
                return result;
            return result;
        }
        setMainFilter(urlParametersToFilter) {
            return __awaiter(this, void 0, void 0, function* () {
                // сначала очистить форму
                this.root.find('.js-clear-filter').trigger('click');
                // УСТАНОВИТЬ ЗНАЧЕНИЯ ПОЛЕЙ
                // Значение автокомплита
                let pointType = '';
                let pointKey = '';
                const location = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.location);
                if (location && location.values.length === 2)
                    [pointType, pointKey] = location.values;
                if (pointKey && pointType) {
                    const response = yield $.ajax({
                        url: App.app.url.route(App.ActivityPageUrls.FindPointName),
                        method: 'POST',
                        dataType: 'json',
                        data: { Key: pointKey, Type: pointType },
                    });
                    // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
                    if (!response.status.success || response.data == null)
                        return;
                    this.setPointInput(response.data.name, parseInt(pointKey, 10), pointType, false);
                }
                // Значение туристов
                const tourist = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.tourist);
                if (tourist) {
                    const adultCount = parseInt(tourist.values[0], 10);
                    // дети из параметров урла - это значения после нулевого индекса (tourist-3,2,4,3 - дети - 2,4,3)
                    const childAges = tourist.values.splice(1).map(child => parseInt(child, 10)); // .filter(age => age >= 0);
                    const filterControl = this.findFilter('Tourist');
                    if (filterControl)
                        filterControl.setValue({ adults: adultCount, childAges: childAges }, false);
                }
                // значения дат
                const datesFrom = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.datefrom);
                if (datesFrom) {
                    const dateFilter = this.findFilter('DateFrom');
                    if (dateFilter)
                        dateFilter.setValue(App.parseIsoDate(datesFrom.values[0]), false);
                }
                const datesTo = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.dateto);
                if (datesTo) {
                    const dateFilter = this.findFilter('DateTo');
                    if (dateFilter)
                        dateFilter.setValue(App.parseIsoDate(datesTo.values[0]), false);
                }
            });
        }
        /**
         * Устанавливает значения инпуту места (город, аэропорт....)
         */
        setPointInput(pointName, pointKey, pointType, triggerChange) {
            // const filterAuto = this.findControl<FilterAutocompleteBlock>('pickupPoint');
            // if (filterAuto)
            // filterAuto.setValue(pointName, pointKey, pointType);
            const point = this.findFilter('Point');
            if (point)
                point.setValueByGuide(pointName, pointKey, pointType, triggerChange);
        }
        // получает параметры с главного фильтра
        getUrlDataFromFilter() {
            // установить значения в url
            const urlParameters = new Array(0);
            let touristAdult = '';
            const childs = new Array(0);
            let pointtype = '';
            let pointkey = '';
            let context = '';
            // this.root.find('input').serializeArray()
            this.filters.serializeArray()
                // превращаем сериализованный массив в массив типа IUrlParameter
                .forEach(serializedArrayItem => {
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.TouristAdultCount) {
                    touristAdult = serializedArrayItem.value;
                }
                if (serializedArrayItem.name.toLowerCase().includes(App.ActivityFilterFields.TouristChildAges)) {
                    childs.push(serializedArrayItem.value);
                }
                if (serializedArrayItem.name.toLowerCase().includes('date')) {
                    serializedArrayItem.value = App.localDateToIso(serializedArrayItem.value);
                    urlParameters.push({
                        name: serializedArrayItem.name.toLowerCase(),
                        values: [serializedArrayItem.value],
                    });
                }
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.PointKey) {
                    pointkey = serializedArrayItem.value;
                }
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.PointType) {
                    pointtype = serializedArrayItem.value;
                }
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.Context) {
                    // Контекст должен быть в САМОМ начале строки
                    context = serializedArrayItem.value;
                }
            });
            // туриста надо сформировать как 1,3,4,5, где первая цифра - количество взрослых, остальные - возраст детей
            if (touristAdult) {
                if (childs.length > 0)
                    childs.unshift(touristAdult);
                urlParameters.push({
                    name: App.ActivityUrlParameters.tourist,
                    values: childs.length > 0 ? childs : [touristAdult],
                });
            }
            if (pointtype && pointkey)
                urlParameters.unshift({ name: App.ActivityUrlParameters.location, values: [pointtype, pointkey] });
            if (context)
                urlParameters.unshift({ name: App.ActivityUrlParameters.context, values: [context] });
            return urlParameters;
        }
    }
    _ActivityMainFilterMobile_options = new WeakMap();
    Object.defineProperty(ActivityMainFilterMobile, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-activity-page',
            maxChildAge: 12,
        }
    });
    App.ActivityMainFilterMobile = ActivityMainFilterMobile;
})(App || (App = {}));
/// <reference path='ActivityMainFilter.Mobile.ts' />
var App;
(function (App) {
    class ActivityDetailMainFilterMobile extends App.ActivityMainFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-detail-filter', customFilters: {
                    root: '.js-activity-detail-filter',
                    clickSelector: '.js-activity-detail-filters-open',
                    modalKey: 'activity-detail-filters-modal',
                    contentSelector: '#js-activity-detail-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать', // TODO: @Localizer.Text("Auto.SearchButton")
                } }, options));
        }
    }
    App.ActivityDetailMainFilterMobile = ActivityDetailMainFilterMobile;
})(App || (App = {}));
/// <reference path='Filter.ts' />
var App;
(function (App) {
    var _MainFilter_instances, _MainFilter_openFilterText, _MainFilter_currencySelected, _MainFilter_currencyBlock, _MainFilter_currencyOption, _MainFilter_actionsSwitch, _MainFilter_yearsSwitch, _MainFilter_dateSelected, _MainFilter_datesBlock, _MainFilter_dateOption, _MainFilter_countrySelected, _MainFilter_countriesBlock, _MainFilter_countryOption, _MainFilter_citySelected, _MainFilter_citiesBlock, _MainFilter_cityOption, _MainFilter_timeout, _MainFilter_onMainFilterOpen, _MainFilter_addOverflowVisible, _MainFilter_currencyShow, _MainFilter_currencyChange, _MainFilter_datesShow, _MainFilter_datesHide, _MainFilter_onOutsideDatesClick, _MainFilter_dateChange, _MainFilter_countriesShow, _MainFilter_countriesHide, _MainFilter_onOutsideCountriesClick, _MainFilter_countriesChange, _MainFilter_citiesSelectBind, _MainFilter_countryChangeCities, _MainFilter_citiesShow, _MainFilter_citiesHide, _MainFilter_onOutsideCitiesClick, _MainFilter_citiesChange, _MainFilter_citiesMulticolsChange, _MainFilter_filterActions, _MainFilter_filterNews;
    class MainFilter extends App.Filter {
        constructor(options) {
            super(Object.assign({ root: '.js-main-filter' }, options));
            _MainFilter_instances.add(this);
            Object.defineProperty(this, "submitButton", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _MainFilter_openFilterText.set(this, void 0);
            _MainFilter_currencySelected.set(this, void 0);
            _MainFilter_currencyBlock.set(this, void 0);
            _MainFilter_currencyOption.set(this, void 0);
            _MainFilter_actionsSwitch.set(this, void 0);
            _MainFilter_yearsSwitch.set(this, void 0);
            _MainFilter_dateSelected.set(this, void 0);
            _MainFilter_datesBlock.set(this, void 0);
            _MainFilter_dateOption.set(this, void 0);
            _MainFilter_countrySelected.set(this, void 0);
            _MainFilter_countriesBlock.set(this, void 0);
            _MainFilter_countryOption.set(this, void 0);
            _MainFilter_citySelected.set(this, void 0);
            _MainFilter_citiesBlock.set(this, void 0);
            _MainFilter_cityOption.set(this, void 0);
            _MainFilter_timeout.set(this, void 0);
            this.submitButton = $('.js-m-filter-submit', this.root);
            const openFilter = $('.js-open-m-filter', this.root);
            __classPrivateFieldSet(this, _MainFilter_openFilterText, $('.js-open-m-filter-text', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_currencySelected, $('.js-currency-selected', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_currencyBlock, $('.js-currency-block', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_currencyOption, $('.js-currency-option', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_actionsSwitch, $('.js-filter-actions-switch', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_yearsSwitch, $('.js-filter-year-switch', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_dateSelected, $('.js-date-selected', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_datesBlock, $('.js-dates-block', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_dateOption, $('.js-date-option', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_countrySelected, $('.js-country-selected', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_countriesBlock, $('.js-countries-block', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_countryOption, $('.js-country-option', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_citySelected, $('.js-city-selected', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_citiesBlock, $('.js-cities-block', this.root), "f");
            __classPrivateFieldSet(this, _MainFilter_cityOption, $('.js-city-option', this.root), "f");
            // ТОЛЬКО  ДЛЯ  ОТЛАДКИ начало
            const showAgentsBtn = $('.js-filter-show-agent-b', this.root);
            const showResultsBtn = $('.js-filter-show-results-b', this.root);
            showAgentsBtn.on('click', () => {
                this.root.toggleClass('_agent');
            });
            showResultsBtn.on('click', () => {
                this.root.toggleClass('_results');
            });
            // ТОЛЬКО  ДЛЯ  ОТЛАДКИ конец
            // Раскрываем основной фильтр
            openFilter.on('click', () => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_onMainFilterOpen).call(this));
            // Переключаем валюту
            __classPrivateFieldGet(this, _MainFilter_currencySelected, "f").on('click', () => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_currencyShow).call(this));
            __classPrivateFieldGet(this, _MainFilter_currencyOption, "f").on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_currencyChange).call(this, e));
            // Переключаем даты
            __classPrivateFieldGet(this, _MainFilter_dateSelected, "f").on('click', () => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_datesShow).call(this));
            __classPrivateFieldGet(this, _MainFilter_dateOption, "f").on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_dateChange).call(this, e));
            $('html').on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_onOutsideDatesClick).call(this, e));
            // Переключаем страны
            __classPrivateFieldGet(this, _MainFilter_countrySelected, "f").on('click', () => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_countriesShow).call(this));
            __classPrivateFieldGet(this, _MainFilter_countryOption, "f").on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_countriesChange).call(this, e));
            $('html').on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_onOutsideCountriesClick).call(this, e));
            // Переключаем города
            __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesSelectBind).call(this);
            $('html').on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_onOutsideCitiesClick).call(this, e));
            // Обрабатываем фильтрацию акций по типу
            __classPrivateFieldGet(this, _MainFilter_actionsSwitch, "f").on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_filterActions).call(this, e));
            // Обрабатывает фильтрацию новостей по году
            __classPrivateFieldGet(this, _MainFilter_yearsSwitch, "f").on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_filterNews).call(this, e));
        }
    }
    _MainFilter_openFilterText = new WeakMap(), _MainFilter_currencySelected = new WeakMap(), _MainFilter_currencyBlock = new WeakMap(), _MainFilter_currencyOption = new WeakMap(), _MainFilter_actionsSwitch = new WeakMap(), _MainFilter_yearsSwitch = new WeakMap(), _MainFilter_dateSelected = new WeakMap(), _MainFilter_datesBlock = new WeakMap(), _MainFilter_dateOption = new WeakMap(), _MainFilter_countrySelected = new WeakMap(), _MainFilter_countriesBlock = new WeakMap(), _MainFilter_countryOption = new WeakMap(), _MainFilter_citySelected = new WeakMap(), _MainFilter_citiesBlock = new WeakMap(), _MainFilter_cityOption = new WeakMap(), _MainFilter_timeout = new WeakMap(), _MainFilter_instances = new WeakSet(), _MainFilter_onMainFilterOpen = function _MainFilter_onMainFilterOpen() {
        this.root.toggleClass('_unfolded');
        // Добавляем / удаляем класс '_overflow-visible'
        if (this.root.hasClass('_unfolded')) {
            __classPrivateFieldGet(this, _MainFilter_openFilterText, "f").text('Свернуть подбор тура');
            __classPrivateFieldSet(this, _MainFilter_timeout, window.setTimeout(() => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_addOverflowVisible).call(this), 350), "f");
        }
        else {
            __classPrivateFieldGet(this, _MainFilter_openFilterText, "f").text('Развернуть подбор тура');
            this.root.removeClass('_overflow-visible');
        }
    }, _MainFilter_addOverflowVisible = function _MainFilter_addOverflowVisible() {
        this.root.addClass('_overflow-visible');
        clearTimeout(__classPrivateFieldGet(this, _MainFilter_timeout, "f"));
    }, _MainFilter_currencyShow = function _MainFilter_currencyShow() {
        __classPrivateFieldGet(this, _MainFilter_currencyBlock, "f").addClass('_open');
    }, _MainFilter_currencyChange = function _MainFilter_currencyChange(e) {
        const target = $(e.currentTarget);
        __classPrivateFieldGet(this, _MainFilter_currencyOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilter_currencyBlock, "f").removeClass('_open');
        __classPrivateFieldGet(this, _MainFilter_currencySelected, "f").text(target.text());
    }, _MainFilter_datesShow = function _MainFilter_datesShow() {
        __classPrivateFieldGet(this, _MainFilter_datesBlock, "f").fadeIn(150);
        __classPrivateFieldGet(this, _MainFilter_datesBlock, "f").addClass('_open');
    }, _MainFilter_datesHide = function _MainFilter_datesHide() {
        __classPrivateFieldGet(this, _MainFilter_datesBlock, "f").removeClass('_open');
        __classPrivateFieldGet(this, _MainFilter_datesBlock, "f").hide();
    }, _MainFilter_onOutsideDatesClick = function _MainFilter_onOutsideDatesClick(e) {
        const target = $(e.target);
        if (!target.hasClass('js-dates-block') && !target.hasClass('js-date-option') && !target.hasClass('js-date-selected'))
            __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_datesHide).call(this);
    }, _MainFilter_dateChange = function _MainFilter_dateChange(e) {
        const target = $(e.currentTarget);
        const index = target.index();
        // Позиционируем попап с датами вверх/вниз в зависимости от выбранной даты
        if (index === 0)
            __classPrivateFieldGet(this, _MainFilter_datesBlock, "f").removeAttr('style');
        else if (index < 9)
            __classPrivateFieldGet(this, _MainFilter_datesBlock, "f").css({ 'margin-top': `-${index * 29}px` });
        else
            __classPrivateFieldGet(this, _MainFilter_datesBlock, "f").css({ 'margin-top': `-${9 * 29}px` });
        __classPrivateFieldGet(this, _MainFilter_dateOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_datesHide).call(this);
        __classPrivateFieldGet(this, _MainFilter_dateSelected, "f").text(target.text());
    }, _MainFilter_countriesShow = function _MainFilter_countriesShow() {
        __classPrivateFieldGet(this, _MainFilter_countriesBlock, "f").fadeIn(150);
        __classPrivateFieldGet(this, _MainFilter_countriesBlock, "f").addClass('_open');
    }, _MainFilter_countriesHide = function _MainFilter_countriesHide() {
        __classPrivateFieldGet(this, _MainFilter_countriesBlock, "f").removeClass('_open');
        __classPrivateFieldGet(this, _MainFilter_countriesBlock, "f").hide();
    }, _MainFilter_onOutsideCountriesClick = function _MainFilter_onOutsideCountriesClick(e) {
        const target = $(e.target);
        if (!target.hasClass('js-countries-block') && !target.hasClass('js-country-option') && !target.hasClass('js-country-selected'))
            __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_countriesHide).call(this);
    }, _MainFilter_countriesChange = function _MainFilter_countriesChange(e) {
        const target = $(e.currentTarget);
        const index = target.index();
        const id = target.attr('data-id');
        if (!id)
            return;
        // Позиционируем попап с датами вверх/вниз в зависимости от выбранной даты
        if (index === 0)
            __classPrivateFieldGet(this, _MainFilter_countriesBlock, "f").removeAttr('style');
        else if (index < 9)
            __classPrivateFieldGet(this, _MainFilter_countriesBlock, "f").css({ 'margin-top': `-${index * 29}px` });
        else
            __classPrivateFieldGet(this, _MainFilter_countriesBlock, "f").css({ 'margin-top': `-${9 * 29}px` });
        __classPrivateFieldGet(this, _MainFilter_countryOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_countriesHide).call(this);
        __classPrivateFieldGet(this, _MainFilter_countrySelected, "f").text(target.text());
        __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_countryChangeCities).call(this, id);
    }, _MainFilter_citiesSelectBind = function _MainFilter_citiesSelectBind() {
        const cities = __classPrivateFieldGet(this, _MainFilter_cityOption, "f").filter('._enabled');
        const citiesCount = cities.length - 1;
        if (citiesCount > 15) {
            const colLength = Math.round(citiesCount / 2) + 1;
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").append('<li class="fake-li"><ul class="col col-left"></ul></li>');
            const colLeft = __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").find('.col-left');
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").append('<li class="fake-li"><ul class="col col-right"></ul></li>');
            const colRight = __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").find('.col-right');
            for (let i = 0; i <= citiesCount; i++) {
                if (i < colLength)
                    cities.eq(i).appendTo(colLeft);
                else
                    cities.eq(i).appendTo(colRight);
            }
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").addClass('_with-cols');
            cities.on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesMulticolsChange).call(this, e));
        }
        else {
            cities.on('click', e => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesChange).call(this, e));
        }
        __classPrivateFieldGet(this, _MainFilter_citySelected, "f").on('click', () => __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesShow).call(this));
    }, _MainFilter_countryChangeCities = function _MainFilter_countryChangeCities(id) {
        // Если города в 2 колонки
        if (__classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").hasClass('_with-cols')) {
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").removeClass('_with-cols');
            __classPrivateFieldGet(this, _MainFilter_cityOption, "f").detach();
            __classPrivateFieldGet(this, _MainFilter_cityOption, "f").appendTo(__classPrivateFieldGet(this, _MainFilter_citiesBlock, "f"));
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").find('.fake-li').remove();
        }
        __classPrivateFieldGet(this, _MainFilter_cityOption, "f").removeClass('_enabled _active _last');
        __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").removeAttr('style');
        const enabledOptions = __classPrivateFieldGet(this, _MainFilter_cityOption, "f").filter(`[data-country=${id}]`);
        const firstOptions = enabledOptions.eq(0);
        enabledOptions.addClass('_enabled');
        firstOptions.addClass('_active');
        enabledOptions.last().addClass('_last');
        __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesSelectBind).call(this);
        __classPrivateFieldGet(this, _MainFilter_citySelected, "f").text(firstOptions.text());
    }, _MainFilter_citiesShow = function _MainFilter_citiesShow() {
        __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").fadeIn(150);
        __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").addClass('_open');
    }, _MainFilter_citiesHide = function _MainFilter_citiesHide() {
        __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").removeClass('_open');
        __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").hide();
    }, _MainFilter_onOutsideCitiesClick = function _MainFilter_onOutsideCitiesClick(e) {
        const target = $(e.target);
        if (!target.hasClass('js-cities-block') && !target.hasClass('js-city-option') && !target.hasClass('js-city-selected'))
            __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesHide).call(this);
    }, _MainFilter_citiesChange = function _MainFilter_citiesChange(e) {
        const target = $(e.currentTarget);
        const index = target.index('._enabled');
        // Позиционируем попап с городами вверх/вниз в зависимости от выбранного города
        if (index === 0)
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").removeAttr('style');
        else if (index < 9)
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").css({ 'margin-top': `-${index * 29}px` });
        else
            __classPrivateFieldGet(this, _MainFilter_citiesBlock, "f").css({ 'margin-top': `-${9 * 29}px` });
        __classPrivateFieldGet(this, _MainFilter_cityOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesHide).call(this);
        __classPrivateFieldGet(this, _MainFilter_citySelected, "f").text(target.text());
    }, _MainFilter_citiesMulticolsChange = function _MainFilter_citiesMulticolsChange(e) {
        const target = $(e.currentTarget);
        __classPrivateFieldGet(this, _MainFilter_cityOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _MainFilter_instances, "m", _MainFilter_citiesHide).call(this);
        __classPrivateFieldGet(this, _MainFilter_citySelected, "f").text(target.text());
    }, _MainFilter_filterActions = function _MainFilter_filterActions(e) {
        const target = $(e.currentTarget);
        // Если клик НЕ по уже выбранному типу
        if (!target.hasClass('_active')) {
            __classPrivateFieldGet(this, _MainFilter_actionsSwitch, "f").removeClass('_active');
            target.addClass('_active');
        }
    }, _MainFilter_filterNews = function _MainFilter_filterNews(e) {
        const target = $(e.currentTarget);
        // Если клик НЕ по уже выбранному типу
        if (!target.hasClass('_active')) {
            __classPrivateFieldGet(this, _MainFilter_yearsSwitch, "f").removeClass('_active');
            target.addClass('_active');
        }
    };
    App.MainFilter = MainFilter;
})(App || (App = {}));
/// <reference path='../../../common/components/MainFilter.ts' />
var App;
(function (App) {
    class ActivityMainFilter extends App.MainFilter {
        constructor(options) {
            super(options);
        }
        setMainFilter(urlParametersToFilter) {
            return __awaiter(this, void 0, void 0, function* () {
                // сначала очистить форму
                this.root.find('.js-clear-filter').trigger('click');
                // УСТАНОВИТЬ ЗНАЧЕНИЯ ПОЛЕЙ
                // Значение автокомплита
                let pointType = '';
                let pointKey = '';
                const location = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.location);
                if (location && location.values.length === 2)
                    [pointType, pointKey] = location.values;
                if (pointKey && pointType) {
                    const response = yield $.ajax({
                        url: App.app.url.route(App.ActivityPageUrls.FindPointName),
                        method: 'POST',
                        dataType: 'json',
                        data: { Key: pointKey, Type: pointType },
                    });
                    // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
                    if (!response.status.success || response.data == null)
                        return;
                    this.setPointInput(response.data.name, parseInt(pointKey, 10), pointType);
                }
                // Значение туристов
                const tourist = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.tourist);
                if (tourist) {
                    const adultCount = parseInt(tourist.values[0], 10);
                    // дети из параметров урла - это значения после нулевого индекса (tourist-3,2,4,3 - дети - 2,4,3)
                    const childAges = tourist.values.splice(1).map(child => parseInt(child, 10));
                    const filterControl = this.findControl('Tourist');
                    if (filterControl)
                        filterControl.setValues(adultCount, childAges);
                }
                // значения дат
                const datesFrom = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.datefrom);
                const datesTo = urlParametersToFilter.find(v => v.name.toLowerCase() === App.ActivityUrlParameters.dateto);
                if (datesFrom && datesTo) {
                    const dateFilter = this.findControl('dates');
                    if (dateFilter) {
                        const dateFrom = App.parseIsoDate(datesFrom.values[0]);
                        const dateTo = App.parseIsoDate(datesTo.values[0]);
                        dateFilter.setValues(dateFrom, dateTo);
                    }
                }
            });
        }
        /**
         * Устанавливает значения инпуту места (город, аэропорт....)
         * @param pointName
         * @param pointKey
         * @param pointType
         */
        setPointInput(pointName, pointKey, pointType) {
            const filterAuto = this.findControl('pickupPoint');
            if (filterAuto)
                filterAuto.setValue(pointName, pointKey, pointType);
        }
        // получает параметры с главного фильтра
        getUrlDataFromFilter() {
            // установить значения в url
            const urlParameters = new Array(0);
            let touristAdult = '';
            const childs = new Array(0);
            let pointtype = '';
            let pointkey = '';
            let context = '';
            this.root.find('input').serializeArray()
                // превращаем сериализованный массив в массив типа IUrlParameter
                .forEach(serializedArrayItem => {
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.TouristAdultCount) {
                    touristAdult = serializedArrayItem.value;
                }
                if (serializedArrayItem.name.toLowerCase().includes(App.ActivityFilterFields.TouristChildAges)) {
                    childs.push(serializedArrayItem.value);
                }
                if (serializedArrayItem.name.toLowerCase().includes('date')) {
                    serializedArrayItem.value = App.localDateToIso(serializedArrayItem.value);
                    urlParameters.push({
                        name: serializedArrayItem.name.toLowerCase(),
                        values: [serializedArrayItem.value],
                    });
                }
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.PointKey) {
                    pointkey = serializedArrayItem.value;
                }
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.PointType) {
                    pointtype = serializedArrayItem.value;
                }
                if (serializedArrayItem.name.toLowerCase() === App.ActivityFilterFields.Context) {
                    // Контекст должен быть в САМОМ начале строки
                    context = serializedArrayItem.value;
                }
            });
            // туриста надо сформировать как 1,3,4,5, где первая цифра - количество взрослых, остальные - возраст детей
            if (touristAdult) {
                if (childs.length > 0)
                    childs.unshift(touristAdult);
                urlParameters.push({
                    name: App.ActivityUrlParameters.tourist,
                    values: childs.length > 0 ? childs : [touristAdult],
                });
            }
            if (pointtype && pointkey)
                urlParameters.unshift({ name: App.ActivityUrlParameters.location, values: [pointtype, pointkey] });
            if (context)
                urlParameters.unshift({ name: App.ActivityUrlParameters.context, values: [context] });
            return urlParameters;
        }
    }
    App.ActivityMainFilter = ActivityMainFilter;
})(App || (App = {}));
/// <reference path='ActivityMainFilter.ts' />
var App;
(function (App) {
    class ActivityDetailMainFilter extends App.ActivityMainFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-detail-filter' }, options));
        }
    }
    App.ActivityDetailMainFilter = ActivityDetailMainFilter;
})(App || (App = {}));
/// <reference path='ActivityMainFilter.Mobile.ts' />
var App;
(function (App) {
    class ActivityLandmarkMainFilterMobile extends App.ActivityMainFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-landmark-filter', customFilters: {
                    root: '.js-activity-landmark-filter',
                    clickSelector: '.js-activity-landmark-filters-open',
                    modalKey: 'activity-landmark-filters-modal',
                    contentSelector: '#js-activity-landmark-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать', // TODO: @Localizer.Text("Auto.SearchButton")
                } }, options));
        }
    }
    App.ActivityLandmarkMainFilterMobile = ActivityLandmarkMainFilterMobile;
})(App || (App = {}));
/// <reference path='ActivityMainFilter.ts' />
var App;
(function (App) {
    class ActivityLandmarkMainFilter extends App.ActivityMainFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-landmark-filter' }, options));
        }
    }
    App.ActivityLandmarkMainFilter = ActivityLandmarkMainFilter;
})(App || (App = {}));
/// <reference path='ActivityMainFilter.Mobile.ts' />
var App;
(function (App) {
    class ActivitySearchMainFilterMobile extends App.ActivityMainFilterMobile {
        constructor(options = {}) {
            super(Object.assign({ root: '.js-activity-main-filter' }, options));
            // данные Point отдавать ключи для поиска без точек в названиях
            // TODO: это только для этого (ActivitySearchMainFilterMobile) или для всех в ActivityMainFilterMobile определить?
            const pointFilter = this.findFilter('Point');
            if (pointFilter != null)
                pointFilter.setOptions({ serializeNameWithoutDot: true });
        }
    }
    App.ActivitySearchMainFilterMobile = ActivitySearchMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class ActivitySearchMainFilter extends App.ActivityMainFilter {
        constructor(options = {}) {
            super(Object.assign({ root: '.js-activity-main-filter' }, options));
        }
    }
    App.ActivitySearchMainFilter = ActivitySearchMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _Result_instances, _a, _Result_options, _Result_toursOutputBlock, _Result_toursOutputTable, _Result_toursOutputMap, _Result_toursOutputImage, _Result_tourBlocks, _Result_tourTableBlocks, _Result_compare, _Result_showMoreToursBlock, _Result_showMoreToursLink, _Result_showMoreToursCurrent, _Result_showToursCountSelected, _Result_showToursCountOption, _Result_showMoreTotal, _Result_onlyTable, _Result_resolveTemplate, _Result_onBlockClick, _Result_scrollBlockText, _Result_onTouchBlockClick, _Result_onInfoBlockScroll, _Result_switchBlockCount, _Result_setBlockCountSwitcher, _Result_clearData, _Result_showMoreBlocks, _Result_updateBlocks, _Result_checkTourProgramTableView, _Result_showBlockView, _Result_showTableView, _Result_showImageView, _Result_showSimpleView, _Result_onFilterSort, _Result_triggerChangePaging, _Result_onFilterFiltering;
    // TODO: вынести всю специфику в TourResult, HotelResult И т.д.
    class Result {
        get hasData() {
            return this.data.length > 0;
        }
        constructor(options) {
            _Result_instances.add(this);
            _Result_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _Result_toursOutputBlock.set(this, void 0);
            _Result_toursOutputTable.set(this, void 0);
            _Result_toursOutputMap.set(this, void 0);
            _Result_toursOutputImage.set(this, void 0);
            _Result_tourBlocks.set(this, void 0);
            _Result_tourTableBlocks.set(this, void 0);
            _Result_compare.set(this, void 0);
            _Result_showMoreToursBlock.set(this, void 0);
            _Result_showMoreToursLink.set(this, void 0);
            _Result_showMoreToursCurrent.set(this, void 0);
            _Result_showToursCountSelected.set(this, void 0);
            _Result_showToursCountOption.set(this, void 0);
            _Result_showMoreTotal.set(this, void 0);
            _Result_onlyTable.set(this, void 0);
            Object.defineProperty(this, "blockTemplate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tableTemplate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "data", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            Object.defineProperty(this, "filtering", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: { items: [] }
            });
            Object.defineProperty(this, "sorting", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: { field: 'price', reverse: false }
            });
            Object.defineProperty(this, "paging", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: { index: 0, size: 0 }
            });
            const defaults = {
                root: App.app.appContainer,
                hotFilter: null,
                maxHotelsToCompare: 4,
            };
            __classPrivateFieldSet(this, _Result_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _Result_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            __classPrivateFieldSet(this, _Result_toursOutputBlock, $('.js-tours-output-block', this.root), "f");
            __classPrivateFieldSet(this, _Result_toursOutputTable, $('.js-tours-output-table', this.root), "f");
            __classPrivateFieldSet(this, _Result_toursOutputMap, $('.js-hotels-town-output-map', this.root), "f");
            __classPrivateFieldSet(this, _Result_toursOutputImage, $('.js-tours-output-image', this.root), "f");
            __classPrivateFieldSet(this, _Result_compare, new App.CompareAndBookmarkBinder(this.root, __classPrivateFieldGet(this, _Result_options, "f").maxHotelsToCompare), "f");
            __classPrivateFieldSet(this, _Result_tourBlocks, $('.js-tour-block', __classPrivateFieldGet(this, _Result_toursOutputBlock, "f")), "f");
            __classPrivateFieldSet(this, _Result_tourTableBlocks, $('.js-tour-table-block', __classPrivateFieldGet(this, _Result_toursOutputTable, "f")), "f");
            __classPrivateFieldSet(this, _Result_showMoreToursBlock, $('.js-show-more', this.root), "f");
            __classPrivateFieldSet(this, _Result_showMoreToursLink, $('.js-show-more-link', this.root), "f");
            __classPrivateFieldSet(this, _Result_showMoreToursCurrent, $('.js-show-more-current', this.root), "f");
            __classPrivateFieldSet(this, _Result_showToursCountSelected, $('.js-show-count-selected', this.root), "f");
            __classPrivateFieldSet(this, _Result_showToursCountOption, $('.js-show-count-option', this.root), "f");
            __classPrivateFieldSet(this, _Result_showMoreTotal, $('.js-show-more-total', this.root), "f");
            if (__classPrivateFieldGet(this, _Result_showToursCountSelected, "f").length > 0)
                this.paging.size = parseInt(__classPrivateFieldGet(this, _Result_showToursCountSelected, "f").text(), 10);
            __classPrivateFieldSet(this, _Result_onlyTable, __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").length <= 0
                && __classPrivateFieldGet(this, _Result_toursOutputTable, "f").length > 0
                && !!__classPrivateFieldGet(this, _Result_toursOutputMap, "f")
                && __classPrivateFieldGet(this, _Result_toursOutputImage, "f").length == 0, "f");
            this.blockTemplate = __classPrivateFieldGet(_a, _a, "m", _Result_resolveTemplate).call(_a, __classPrivateFieldGet(this, _Result_options, "f").blockTemplate);
            this.tableTemplate = __classPrivateFieldGet(_a, _a, "m", _Result_resolveTemplate).call(_a, __classPrivateFieldGet(this, _Result_options, "f").tableTemplate);
            // Переключаем 'Показывать по'
            __classPrivateFieldGet(this, _Result_showToursCountOption, "f").on('click', e => __classPrivateFieldGet(this, _Result_instances, "m", _Result_switchBlockCount).call(this, e));
            // Показываем еще (следующую страницу)
            __classPrivateFieldGet(this, _Result_showMoreToursLink, "f").on('click', () => __classPrivateFieldGet(this, _Result_instances, "m", _Result_showMoreBlocks).call(this));
            // TODO: сделать одно событие с параметром (тип выдачи).
            // События из фильтра при смене видов / типов выдачи
            $('body')
                .on("tours-block:show-block-view" /* Events.ToursBlockShowBlockView */, () => __classPrivateFieldGet(this, _Result_instances, "m", _Result_showBlockView).call(this))
                .on("tours-block:show-table-view" /* Events.ToursBlockShowTableView */, () => __classPrivateFieldGet(this, _Result_instances, "m", _Result_showTableView).call(this))
                .on("tours-block:show-map-view" /* Events.ToursBlockShowMapView */, e => this.showMapView(e))
                .on("toursProgram-block:show-image-view" /* Events.ToursProgramBlockShowImageView */, () => __classPrivateFieldGet(this, _Result_instances, "m", _Result_showImageView).call(this))
                .on("toursProgram-block:show-simple-view" /* Events.ToursProgramBlockShowSimpleView */, () => __classPrivateFieldGet(this, _Result_instances, "m", _Result_showSimpleView).call(this));
            // TODO: создавать экземпляр в классе страницы, связать между собой событиями.
            // У каждого результата свой фильтр, со своим рутовым элементом. Иначе события перехватываются всеми фильтрами на странице и
            // возникает неожиданное поведение. При создании конкретного хот-фильтра надо задать ему свой класс, а в конкретном результате
            // надо создать экземпляр фильтра и передать туда этот класс. По-умолчанию создается хот-фильтр с зашитым в него классом.
            this.hotFilter = __classPrivateFieldGet(this, _Result_options, "f").hotFilter || new App.HotFilter();
            this.hotFilter.root.on("filter:sort" /* Events.FilterSort */, (e, data) => __classPrivateFieldGet(this, _Result_instances, "m", _Result_onFilterSort).call(this, e, data));
            this.hotFilter.root.on("filter:filter" /* Events.FilterFilter */, (e, data) => __classPrivateFieldGet(this, _Result_instances, "m", _Result_onFilterFiltering).call(this, e, data));
            this.sorting = this.hotFilter.activeSorting;
            // Навешиваем обработчики блокам с турами
            this.root.on('click', '.js-clickable-block', { items: this.data }, e => __classPrivateFieldGet(this, _Result_instances, "m", _Result_onBlockClick).call(this, e));
            if (App.isTouch) {
                this.root
                    .on('click', '.js-tour-block', e => __classPrivateFieldGet(this, _Result_instances, "m", _Result_onTouchBlockClick).call(this, e))
                    .on('scroll', '.js-tour-info-wrap', e => __classPrivateFieldGet(_a, _a, "m", _Result_onInfoBlockScroll).call(_a, e));
            }
            else {
                this.root
                    .on('mouseenter', '.js-tour-info-block', e => __classPrivateFieldGet(_a, _a, "m", _Result_scrollBlockText).call(_a, e))
                    .on('mousemove', '.js-tour-info-block', e => __classPrivateFieldGet(_a, _a, "m", _Result_scrollBlockText).call(_a, e));
            }
            this.bindBlocks();
        }
        /**
         * Изменяет данные и отрисовывает их
         * @param data
         * @param append - добавление данных к имеющимся
         */
        changeDataSource(data, append = false) {
            if (data.length === 0)
                return Promise.resolve();
            // TODO: данный фильтр для некоторых форм является основным, т.е. его скрывать/показывать нельзя!
            this.hotFilter.show();
            this.data = data;
            if (!append) {
                App.emptyArray(this.filtering.items);
                this.paging.index = 0;
            }
            // установим значение размера страницы в соответствующий блок в разметке
            __classPrivateFieldGet(this, _Result_instances, "m", _Result_setBlockCountSwitcher).call(this, this.paging.size.toString(), __classPrivateFieldGet(this, _Result_showToursCountOption, "f").siblings(`:contains('${this.paging.size}')`));
            __classPrivateFieldGet(this, _Result_instances, "m", _Result_updateBlocks).call(this);
            // TODO: надо отказаться от this.#onlyTable, т.к. скрывать ненужный вид выдачи надо на уровне шаблона - не отрисовывать его и не
            // отрисовывать кнпоку (управление этим есть во вьюхе разоровской HotFilter? используется пока в отелях и экскурсиях).
            // TODO: к тому же в HotFilter есть специальное свойство, показывающее, какой вид активен
            // TODO: переделать, т.к. возможно ошибочное открытие двух блоков, если до этого был поиск, пользователь переключился на
            // табличный вид, а потом запустил новый поиск.
            // if (this.#onlyTable)
            //  this.#toursOutputTable.showByClass();
            // else
            //  this.#toursOutputBlock.showByClass();
            switch (this.hotFilter.activeView) {
                case 'block':
                    __classPrivateFieldGet(this, _Result_instances, "m", _Result_showBlockView).call(this);
                    break;
                case 'map':
                    this.showMapView();
                    break;
                case 'image':
                    __classPrivateFieldGet(this, _Result_instances, "m", _Result_showImageView).call(this);
                    break;
                case 'simple':
                    __classPrivateFieldGet(this, _Result_instances, "m", _Result_showSimpleView).call(this);
                    break;
                default:
                    __classPrivateFieldGet(this, _Result_instances, "m", _Result_showTableView).call(this);
                    break;
            }
            return Promise.resolve();
        }
        // TODO: название метода не отражает того, что он делает - собственно, данные он не сбрасывает
        resetDataSource() {
            __classPrivateFieldGet(this, _Result_instances, "m", _Result_clearData).call(this);
            // TODO: данный фильтр для некоторых форм является основным, т.е. его скрывать/показывать нельзя!
            // this.hotFilter.hideByClass();
            // TODO: данный фильтр для некоторых форм является основным, т.е. его скрывать/показывать нельзя! P.S. - для экскурсий он не
            // основной. ввести параметр или тот горячий фильтр, который типа основной, не считать горячим фильтром
            this.hotFilter.hide();
            __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").hideByClass();
            __classPrivateFieldGet(this, _Result_toursOutputTable, "f").hideByClass();
            __classPrivateFieldGet(this, _Result_toursOutputMap, "f").hideByClass();
            __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").hideByClass();
        }
        applyFilters(items) {
            return items;
        }
        applySorting(items) {
            return items;
        }
        applyPaging(items, addBlock) {
            if (addBlock) {
                const skipCount = this.paging.index * this.paging.size;
                return items.slice(skipCount, skipCount + this.paging.size);
            }
            return items.slice(0, (this.paging.index + 1) * this.paging.size);
        }
        /**
         * Навешивает обработчики блокам с турами
         */
        bindBlocks() {
            __classPrivateFieldGet(this, _Result_compare, "f").bind([__classPrivateFieldGet(this, _Result_tourBlocks, "f"), __classPrivateFieldGet(this, _Result_tourTableBlocks, "f")]);
            // Если на странице есть ТОЛЬКО табличный вид
            if (__classPrivateFieldGet(this, _Result_onlyTable, "f")) {
                // Показываем табличный вид и скрываем кнопки переключения видов выдачи
                // Обработчик события в filter.js
                this.hotFilter.root.trigger("tours:only-table-view" /* Events.ToursOnlyTableView */);
            }
        }
        /**
         * Удаляет обработчики у блоков с турами
         */
        unbindBlocks() {
            __classPrivateFieldGet(this, _Result_compare, "f").unbind();
        }
        /**
         * Инициализация блока с картой
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        initMapBlock(data, addBlock) {
        }
        /* eslint-enable @typescript-eslint/no-unused-vars */
        /**
         * Показывает выдачу туров на карте
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        showMapView(event) {
            __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").hideByClass();
            __classPrivateFieldGet(this, _Result_toursOutputTable, "f").hideByClass();
            __classPrivateFieldGet(this, _Result_toursOutputMap, "f").showByClass();
            __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").hideByClass();
        }
        /* eslint-enable @typescript-eslint/no-unused-vars */
        /**
         * Сортировка
         * @param a
         * @param b
         * @param altA
         * @param altB
         * @param invert
         */
        static sort(a, b, altA, altB, invert) {
            if (a < b)
                return (invert ? 1 : -1);
            if (a > b)
                return (invert ? -1 : 1);
            if (altA < altB)
                return (invert ? 1 : -1);
            if (altA > altB)
                return (invert ? -1 : 1);
            return 0;
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        prepareData(viewType, items, addBlock) {
            return items;
        }
    }
    _a = Result, _Result_options = new WeakMap(), _Result_toursOutputBlock = new WeakMap(), _Result_toursOutputTable = new WeakMap(), _Result_toursOutputMap = new WeakMap(), _Result_toursOutputImage = new WeakMap(), _Result_tourBlocks = new WeakMap(), _Result_tourTableBlocks = new WeakMap(), _Result_compare = new WeakMap(), _Result_showMoreToursBlock = new WeakMap(), _Result_showMoreToursLink = new WeakMap(), _Result_showMoreToursCurrent = new WeakMap(), _Result_showToursCountSelected = new WeakMap(), _Result_showToursCountOption = new WeakMap(), _Result_showMoreTotal = new WeakMap(), _Result_onlyTable = new WeakMap(), _Result_instances = new WeakSet(), _Result_resolveTemplate = function _Result_resolveTemplate(template) {
        if (template == null)
            return undefined;
        if (typeof template === 'string')
            return App.findTemplate(template);
        return template;
    }, _Result_onBlockClick = function _Result_onBlockClick(event) {
        // Сначала обрабатываем открытие ссылки в новой вкладке по ctrl+мышь и shift+мышь
        if (event.ctrlKey || event.shiftKey)
            return;
        event.preventDefault();
        // найдем id выбранного блока
        const target = $(event.currentTarget);
        const targetId = target.attr('data-id');
        this.root.trigger("block:click" /* Events.BlockClick */, { targetId, data: this.data });
    }, _Result_scrollBlockText = function _Result_scrollBlockText(e) {
        const target = $(e.currentTarget);
        const root = target.closest('.js-tour-block');
        const selfH = target.outerHeight() || 0;
        const scrollWrap = root.find('.js-tour-info-wrap');
        const scrollWrapH = scrollWrap.height() || 0;
        const scrollWrapOffset = scrollWrap.offset();
        const startY = scrollWrapOffset != null ? scrollWrapOffset.top : 0;
        const gradTop = root.find('.js-tour-grad-top');
        const gradBottom = root.find('.js-tour-grad-bottom');
        const ratio = (selfH - scrollWrapH) / scrollWrapH;
        if (selfH > scrollWrapH) {
            const delta = (startY - e.pageY) * ratio;
            target.css({ 'top': `${delta}px` });
            // Показываем / скрываем градиенты
            if (delta <= -10)
                gradTop.addClass('_visible');
            else if (delta > -10)
                gradTop.removeClass('_visible');
            if (delta - 5 <= scrollWrapH - selfH)
                gradBottom.removeClass('_visible');
            else if (delta - 5 > scrollWrapH - selfH)
                gradBottom.addClass('_visible');
        }
    }, _Result_onTouchBlockClick = function _Result_onTouchBlockClick(e) {
        const target = $(e.currentTarget);
        const isHover = target.hasClass('_hover');
        // Если по блоку еще не кликали
        if (!isHover) {
            e.preventDefault();
            __classPrivateFieldGet(this, _Result_tourBlocks, "f").removeClass('_hover');
            target.addClass('_hover');
        }
    }, _Result_onInfoBlockScroll = function _Result_onInfoBlockScroll(e) {
        const target = $(e.currentTarget);
        const scroll = target.scrollTop() || 0;
        const selfH = target.height() || 0;
        const content = target.find('.js-tour-info-block');
        const contentH = content.outerHeight() || 0;
        const gradTop = target.siblings('.js-tour-grad-top');
        const gradBottom = target.siblings('.js-tour-grad-bottom');
        // Показываем / скрываем верхний градиент
        if (scroll >= 15)
            gradTop.addClass('_visible');
        else if (scroll < 15)
            gradTop.removeClass('_visible');
        // Показываем / скрываем нижний градиент
        if (scroll >= contentH - selfH - 10)
            gradBottom.removeClass('_visible');
        else
            gradBottom.addClass('_visible');
    }, _Result_switchBlockCount = function _Result_switchBlockCount(e) {
        const target = $(e.currentTarget);
        __classPrivateFieldGet(this, _Result_instances, "m", _Result_setBlockCountSwitcher).call(this, target.text(), target);
        this.paging.index = 0;
        this.paging.size = parseInt(target.text(), 10);
        __classPrivateFieldGet(this, _Result_instances, "m", _Result_triggerChangePaging).call(this);
        __classPrivateFieldGet(this, _Result_instances, "m", _Result_updateBlocks).call(this);
    }, _Result_setBlockCountSwitcher = function _Result_setBlockCountSwitcher(value, target) {
        __classPrivateFieldGet(this, _Result_showToursCountOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _Result_showToursCountSelected, "f").text(value);
        __classPrivateFieldGet(this, _Result_showMoreToursCurrent, "f").text(value);
        App.Cookie.set("showCount" /* KnownCookie.ShowCount */, value);
    }, _Result_clearData = function _Result_clearData() {
        this.unbindBlocks();
        __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").empty();
        __classPrivateFieldGet(this, _Result_toursOutputTable, "f").empty();
    }, _Result_showMoreBlocks = function _Result_showMoreBlocks() {
        __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").addClass('_pulsate');
        this.paging.index += 1;
        __classPrivateFieldGet(this, _Result_instances, "m", _Result_triggerChangePaging).call(this);
        __classPrivateFieldGet(this, _Result_instances, "m", _Result_updateBlocks).call(this, true);
        __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").removeClass('_pulsate');
    }, _Result_updateBlocks = function _Result_updateBlocks(addBlock = false) {
        let data = this.applyFilters(this.data);
        data = this.applySorting(data);
        const remainingData = data.length - (this.paging.index + 1) * this.paging.size;
        __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").toggleByClass(remainingData > 0 && this.hotFilter.activeView !== 'map');
        __classPrivateFieldGet(this, _Result_showMoreTotal, "f").text(remainingData);
        // если remainingData меньше, чем this.#paging.size => меняем this.#showMoreToursCurrent
        if (remainingData <= this.paging.size && !__classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").hasClass('_hidden-2'))
            __classPrivateFieldGet(this, _Result_showMoreToursCurrent, "f").text(remainingData);
        this.hotFilter.updateFoundCount(data);
        // инициализация карты
        if (__classPrivateFieldGet(this, _Result_toursOutputMap, "f").length > 0)
            this.initMapBlock(data, addBlock);
        if (this.paging.size > 0)
            data = this.applyPaging(data, addBlock);
        // Проверка показывать нетто цены или нет и возврат данных с признаком showNett
        const showNetPrice = App.NetPricePresenter.getVisibility();
        // TODO: кажется, что это не лучшее решение, более правильно рендерить именно то, что нужно выводить в данный момент.
        if (this.blockTemplate != null) {
            data = this.prepareData('block', data, addBlock);
            const content = $(this.blockTemplate(data));
            App.NetPricePresenter.setVisibility(content, showNetPrice);
            if (!addBlock)
                __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").empty();
            __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").not('.js-no-ajax-output').append(content);
        }
        if (this.tableTemplate != null) {
            data = this.prepareData('table', data, addBlock);
            const content = $(this.tableTemplate(data));
            App.NetPricePresenter.setVisibility(content, showNetPrice);
            if (!addBlock)
                __classPrivateFieldGet(this, _Result_toursOutputTable, "f").empty();
            __classPrivateFieldGet(this, _Result_toursOutputTable, "f").not('.js-no-ajax-output').append(content);
            __classPrivateFieldGet(this, _Result_instances, "m", _Result_checkTourProgramTableView).call(this);
        }
        this.unbindBlocks();
        this.bindBlocks();
        if (__classPrivateFieldGet(this, _Result_options, "f").onAfterDataDraw)
            __classPrivateFieldGet(this, _Result_options, "f").onAfterDataDraw();
    }, _Result_checkTourProgramTableView = function _Result_checkTourProgramTableView() {
        if (this.hotFilter.activeView == 'simple')
            $('.js-tourProgram-group-title-hotel', __classPrivateFieldGet(this, _Result_toursOutputImage, "f")).addClass('_simple');
    }, _Result_showBlockView = function _Result_showBlockView() {
        __classPrivateFieldGet(this, _Result_toursOutputTable, "f").hideByClass();
        __classPrivateFieldGet(this, _Result_toursOutputMap, "f").hideByClass();
        __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").showByClass();
        // если в блоке 'показать еще' количество предложения для показа больше нуля, показываем
        // TODO: я бы лучше считала по данным, а не тексту из разметки...
        if (Number(__classPrivateFieldGet(this, _Result_showMoreTotal, "f").text()) > 0)
            __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").showByClass();
    }, _Result_showTableView = function _Result_showTableView() {
        __classPrivateFieldGet(this, _Result_toursOutputBlock, "f").hideByClass();
        __classPrivateFieldGet(this, _Result_toursOutputMap, "f").hideByClass();
        __classPrivateFieldGet(this, _Result_toursOutputTable, "f").showByClass();
        // если в блоке 'показать еще' количество предложения для показа больше нуля, показываем
        if (Number(__classPrivateFieldGet(this, _Result_showMoreTotal, "f").text()) > 0)
            __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").showByClass();
    }, _Result_showImageView = function _Result_showImageView() {
        __classPrivateFieldGet(this, _Result_toursOutputMap, "f").hideByClass();
        __classPrivateFieldGet(this, _Result_toursOutputTable, "f").showByClass();
        $('.js-tourProgram-group-title-hotel', __classPrivateFieldGet(this, _Result_toursOutputImage, "f")).removeClass('_simple');
        // если в блоке 'показать еще' количество предложения для показа больше нуля, показываем
        if (Number(__classPrivateFieldGet(this, _Result_showMoreTotal, "f").text()) > 0)
            __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").showByClass();
    }, _Result_showSimpleView = function _Result_showSimpleView() {
        __classPrivateFieldGet(this, _Result_toursOutputMap, "f").hideByClass();
        __classPrivateFieldGet(this, _Result_toursOutputTable, "f").showByClass();
        $('.js-tourProgram-group-title-hotel', __classPrivateFieldGet(this, _Result_toursOutputImage, "f")).addClass('_simple');
        // если в блоке 'показать еще' количество предложения для показа больше нуля, показываем
        if (Number(__classPrivateFieldGet(this, _Result_showMoreTotal, "f").text()) > 0)
            __classPrivateFieldGet(this, _Result_showMoreToursBlock, "f").showByClass();
    }, _Result_onFilterSort = function _Result_onFilterSort(event, data) {
        this.sorting = data;
        // TODO: кажется все же лучше оставлять на экране столько данных, сколько уже выведено. Убедиться в правильности этого решение
        // и либо убрать TODO, либо исправить.
        // this.paging.index = 0;
        __classPrivateFieldGet(this, _Result_instances, "m", _Result_updateBlocks).call(this);
    }, _Result_triggerChangePaging = function _Result_triggerChangePaging() {
        this.root.trigger("paging:change" /* Events.PagingChange */, this.paging);
    }, _Result_onFilterFiltering = function _Result_onFilterFiltering(event, data) {
        this.filtering = data;
        __classPrivateFieldGet(this, _Result_instances, "m", _Result_updateBlocks).call(this);
    };
    App.Result = Result;
})(App || (App = {}));
/// <reference path='../../../common/components/Result.ts' />
var App;
(function (App) {
    var _ActivityDetailResult_instances, _ActivityDetailResult_urlChangeStrategy, _ActivityDetailResult_resultOutputBlock, _ActivityDetailResult_setSortingByUrlParameters, _ActivityDetailResult_setPagingByUrlParameters;
    class ActivityDetailResult extends App.Result {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-details-block', tableTemplate: App.templates.Activity.DetailTableOutput }, options));
            _ActivityDetailResult_instances.add(this);
            _ActivityDetailResult_urlChangeStrategy.set(this, void 0);
            _ActivityDetailResult_resultOutputBlock.set(this, void 0);
            if (!this.root.length)
                return;
            this.sorting.field = 'date';
            __classPrivateFieldSet(this, _ActivityDetailResult_urlChangeStrategy, new App.UrlReplaceStrategy(new App.ActivityHotFilterSet()), "f");
            __classPrivateFieldGet(this, _ActivityDetailResult_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
            __classPrivateFieldSet(this, _ActivityDetailResult_resultOutputBlock, $('.js-output-block', this.root), "f");
        }
        applySorting(items) {
            // TODO: вынести в какой-нить абстрактный класс типа как в фильтрах
            switch (this.sorting.field) {
                case 'date': {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.beginDate)
                            .thenByDescending(v => v.grossPrice)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.beginDate)
                        .thenBy(v => v.grossPrice)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.grossPrice)
                            .thenByDescending(v => v.key)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.grossPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
            }
        }
        resetDataSource() {
            __classPrivateFieldGet(this, _ActivityDetailResult_resultOutputBlock, "f").hideByClass();
            super.resetDataSource();
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                __classPrivateFieldGet(this, _ActivityDetailResult_resultOutputBlock, "f").showByClass();
                yield _super.changeDataSource.call(this, data, append);
            });
        }
        // ДУБЛИРОВАНИЕ с ActivityResult
        // устаналивает параметры, которые влияют на манипуляцию с данными (фильтры, сортировка и т.д.)
        // параметры - массив парамтеров урла. Передаем весь, в методе отделятся нужные, не нужные не будут использоваться
        setDataManipulateParameters(urlParameters) {
            __classPrivateFieldGet(this, _ActivityDetailResult_instances, "m", _ActivityDetailResult_setSortingByUrlParameters).call(this, urlParameters);
            __classPrivateFieldGet(this, _ActivityDetailResult_instances, "m", _ActivityDetailResult_setPagingByUrlParameters).call(this, urlParameters);
        }
    }
    _ActivityDetailResult_urlChangeStrategy = new WeakMap(), _ActivityDetailResult_resultOutputBlock = new WeakMap(), _ActivityDetailResult_instances = new WeakSet(), _ActivityDetailResult_setSortingByUrlParameters = function _ActivityDetailResult_setSortingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters.find(item => item.name === 'sort');
        if (pageUrlParameter) {
            [this.sorting.field] = pageUrlParameter.values;
            this.sorting.reverse = pageUrlParameter.values[1] === 'desc';
        }
    }, _ActivityDetailResult_setPagingByUrlParameters = function _ActivityDetailResult_setPagingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters.find(item => item.name === 'page');
        if (pageUrlParameter) {
            this.paging.index = parseInt(pageUrlParameter.values[0], 10);
            this.paging.size = parseInt(pageUrlParameter.values[1], 10);
        }
    };
    App.ActivityDetailResult = ActivityDetailResult;
})(App || (App = {}));
/// <reference path='ActivityDetailResult.ts' />
var App;
(function (App) {
    class ActivityDetailResultMobile extends App.ActivityDetailResult {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-details-block', tableTemplate: App.templates.Activity.DetailTableOutput_Mobile }, options));
            if (!this.root.length)
                return;
        }
    }
    App.ActivityDetailResultMobile = ActivityDetailResultMobile;
})(App || (App = {}));
/// <reference path='../../../common/components/Result.ts' />
var App;
(function (App) {
    var _ActivityLandmarkResult_instances, _ActivityLandmarkResult_setSortingByUrlParameters, _ActivityLandmarkResult_setHotFiltersByUrlParameters, _ActivityLandmarkResult_setPagingByUrlParameters, _ActivityLandmarkResult_filter;
    class ActivityLandmarkResult extends App.Result {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-landmark-block', blockTemplate: App.templates.Activity.BlockOutput, tableTemplate: App.templates.Activity.TableOutput }, options));
            _ActivityLandmarkResult_instances.add(this);
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case 'date': {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.beginDate)
                            .thenBy(v => v.grossPrice)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.beginDate)
                        .thenBy(v => v.grossPrice)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.grossPrice)
                            .thenBy(v => v.key)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.grossPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
            }
        }
        applyFilters(items) {
            if (typeof this.filtering === 'undefined')
                return items;
            const activities = items;
            if (activities == null || activities.length <= 0)
                return items;
            return __classPrivateFieldGet(this, _ActivityLandmarkResult_instances, "m", _ActivityLandmarkResult_filter).call(this, activities);
        }
        /**
         * устанавливает параметры, которые влияют на манипуляцию с данными (фильтры, сортировка и т.д.)
         * параметры - массив параметров урла. Передаем весь, в методе отделятся нужные, не нужные не будут использоваться
         * @param urlParameter - параметры урла для установки. Если пустой массив - сортировка и пейджинг берутся предыдущие, хотфильтры
         * сбрасываются
         */
        setDataManipulateParameters(urlParameters) {
            if (!urlParameters) {
                return {
                    filtering: __classPrivateFieldGet(this, _ActivityLandmarkResult_instances, "m", _ActivityLandmarkResult_setHotFiltersByUrlParameters).call(this, urlParameters),
                    sorting: this.sorting,
                    paging: this.paging,
                };
            }
            return {
                filtering: __classPrivateFieldGet(this, _ActivityLandmarkResult_instances, "m", _ActivityLandmarkResult_setHotFiltersByUrlParameters).call(this, urlParameters),
                sorting: __classPrivateFieldGet(this, _ActivityLandmarkResult_instances, "m", _ActivityLandmarkResult_setSortingByUrlParameters).call(this, urlParameters),
                paging: __classPrivateFieldGet(this, _ActivityLandmarkResult_instances, "m", _ActivityLandmarkResult_setPagingByUrlParameters).call(this, urlParameters),
            };
        }
    }
    _ActivityLandmarkResult_instances = new WeakSet(), _ActivityLandmarkResult_setSortingByUrlParameters = function _ActivityLandmarkResult_setSortingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'sort');
        if (pageUrlParameter) {
            [this.sorting.field] = pageUrlParameter.values;
            this.sorting.reverse = pageUrlParameter.values[1] === 'desc';
        }
        return this.sorting;
    }, _ActivityLandmarkResult_setHotFiltersByUrlParameters = function _ActivityLandmarkResult_setHotFiltersByUrlParameters(urlParameters) {
        if (urlParameters) {
            this.filtering.items = urlParameters
                .filter(v => {
                const itemName = v.name.toLowerCase();
                return itemName === App.ActivityHotFilterFields.ActivityAttributes
                    || itemName === App.ActivityHotFilterFields.GuideTypes
                    || itemName === App.ActivityHotFilterFields.IsGroup
                    || itemName === App.ActivityHotFilterFields.LandmarkNames
                    || itemName === App.ActivityHotFilterFields.TransportTypes;
            })
                .map(v => ({ name: v.name, values: v.values }));
        }
        else {
            this.filtering.items = new Array();
        }
        return this.filtering.items;
    }, _ActivityLandmarkResult_setPagingByUrlParameters = function _ActivityLandmarkResult_setPagingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'page');
        if (pageUrlParameter) {
            this.paging.index = parseInt(pageUrlParameter.values[0], 10);
            this.paging.size = parseInt(pageUrlParameter.values[1], 10);
        }
        return this.paging;
    }, _ActivityLandmarkResult_filter = function _ActivityLandmarkResult_filter(activities) {
        let result = activities;
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            switch (filter.name.toLowerCase()) {
                case App.ActivityHotFilterFields.ActivityAttributes:
                    result = result
                        .filter(item => item.facilities
                        .some(facility => filter.values
                        .some(currentFilter => facility.key.toString() === currentFilter)));
                    break;
                case App.ActivityHotFilterFields.GuideTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => item.guideType.key.toString() === currentFilter));
                    break;
                case App.ActivityHotFilterFields.IsGroup:
                    result = result
                        // потому что boolean-значение только true или false
                        .filter(item => item.isGroup.toString() === filter.values[0]);
                    break;
                case App.ActivityHotFilterFields.LandmarkNames:
                    result = result
                        .filter(item => item.landmarks
                        .some(landmarks => filter.values
                        .some(currentFilter => landmarks.key.toString() === currentFilter)));
                    break;
                case App.ActivityHotFilterFields.TransportTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => currentFilter === item.transportType.key.toString()));
                    break;
                // no default
            }
        }
        return result;
    };
    App.ActivityLandmarkResult = ActivityLandmarkResult;
})(App || (App = {}));
/// <reference path='ActivityLandmarkResult.ts' />
var App;
(function (App) {
    class ActivityLandmarkResultMobile extends App.ActivityLandmarkResult {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-landmark-block', blockTemplate: App.templates.Activity.BlockOutput, tableTemplate: App.templates.Activity.TableOutput }, options));
        }
    }
    App.ActivityLandmarkResultMobile = ActivityLandmarkResultMobile;
})(App || (App = {}));
/// <reference path='../../../common/components/Result.ts' />
var App;
(function (App) {
    var _ActivityResultMobile_instances, _ActivityResultMobile_urlChangeStrategy, _ActivityResultMobile_setSortingByUrlParameters, _ActivityResultMobile_setHotFiltersByUrlParameters, _ActivityResultMobile_setPagingByUrlParameters, _ActivityResultMobile_filter;
    class ActivityResultMobile extends App.Result {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-search-block', blockTemplate: App.templates.Activity.BlockOutput, tableTemplate: App.templates.Activity.TableOutput }, options));
            _ActivityResultMobile_instances.add(this);
            _ActivityResultMobile_urlChangeStrategy.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _ActivityResultMobile_urlChangeStrategy, new App.UrlChangeStrategy(new App.ActivityHotFilterSet()), "f");
            __classPrivateFieldGet(this, _ActivityResultMobile_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case 'date': {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.beginDate)
                            .thenBy(v => v.grossPrice)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.beginDate)
                        .thenBy(v => v.grossPrice)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.grossPrice)
                            .thenBy(v => v.key)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.grossPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
            }
        }
        applyFilters(items) {
            if (typeof this.filtering === 'undefined')
                return items;
            const activities = items;
            if (activities == null || activities.length <= 0)
                return items;
            return __classPrivateFieldGet(this, _ActivityResultMobile_instances, "m", _ActivityResultMobile_filter).call(this, activities);
        }
        /**
         * устанавливает параметры, которые влияют на манипуляцию с данными (фильтры, сортировка и т.д.)
         * параметры - массив параметров урла. Передаем весь, в методе отделятся нужные, не нужные не будут использоваться
         * @param urlParameter - параметры урла для установки. Если пустой массив - сортировка и пейджинг берутся предыдущие, хотфильтры
         * сбрасываются
         */
        setDataManipulateParameters(urlParameters) {
            if (!urlParameters) {
                return {
                    filtering: __classPrivateFieldGet(this, _ActivityResultMobile_instances, "m", _ActivityResultMobile_setHotFiltersByUrlParameters).call(this, urlParameters),
                    sorting: this.sorting,
                    paging: this.paging,
                };
            }
            return {
                filtering: __classPrivateFieldGet(this, _ActivityResultMobile_instances, "m", _ActivityResultMobile_setHotFiltersByUrlParameters).call(this, urlParameters),
                sorting: __classPrivateFieldGet(this, _ActivityResultMobile_instances, "m", _ActivityResultMobile_setSortingByUrlParameters).call(this, urlParameters),
                paging: __classPrivateFieldGet(this, _ActivityResultMobile_instances, "m", _ActivityResultMobile_setPagingByUrlParameters).call(this, urlParameters),
            };
        }
    }
    _ActivityResultMobile_urlChangeStrategy = new WeakMap(), _ActivityResultMobile_instances = new WeakSet(), _ActivityResultMobile_setSortingByUrlParameters = function _ActivityResultMobile_setSortingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'sort');
        if (pageUrlParameter) {
            [this.sorting.field] = pageUrlParameter.values;
            this.sorting.reverse = pageUrlParameter.values[1] === 'desc';
        }
        return this.sorting;
    }, _ActivityResultMobile_setHotFiltersByUrlParameters = function _ActivityResultMobile_setHotFiltersByUrlParameters(urlParameters) {
        if (urlParameters) {
            this.filtering.items = urlParameters
                .filter(v => {
                const itemName = v.name.toLowerCase();
                return itemName === App.ActivityHotFilterFields.ActivityAttributes
                    || itemName === App.ActivityHotFilterFields.GuideTypes
                    || itemName === App.ActivityHotFilterFields.IsGroup
                    || itemName === App.ActivityHotFilterFields.LandmarkNames
                    || itemName === App.ActivityHotFilterFields.TransportTypes;
            })
                .map(v => ({ name: v.name, values: v.values }));
        }
        else {
            this.filtering.items = new Array();
        }
        return this.filtering.items;
    }, _ActivityResultMobile_setPagingByUrlParameters = function _ActivityResultMobile_setPagingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'page');
        if (pageUrlParameter) {
            this.paging.index = parseInt(pageUrlParameter.values[0], 10);
            this.paging.size = parseInt(App.Cookie.get("showCount" /* KnownCookie.ShowCount */) || pageUrlParameter.values[1], 10);
        }
        return this.paging;
    }, _ActivityResultMobile_filter = function _ActivityResultMobile_filter(activities) {
        let result = activities;
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            switch (filter.name.toLowerCase()) {
                case App.ActivityHotFilterFields.ActivityAttributes:
                    result = result
                        .filter(item => item.facilities
                        .some(facility => filter.values
                        .some(currentFilter => facility.key.toString() === currentFilter)));
                    break;
                case App.ActivityHotFilterFields.GuideTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => item.guideType.key.toString() === currentFilter));
                    break;
                case App.ActivityHotFilterFields.IsGroup:
                    result = result
                        // потому что boolean-значение только true или false
                        .filter(item => item.isGroup.toString() === filter.values[0]);
                    break;
                case App.ActivityHotFilterFields.LandmarkNames:
                    result = result
                        .filter(item => item.landmarks
                        .some(landmarks => filter.values
                        .some(currentFilter => landmarks.key.toString() === currentFilter)));
                    break;
                case App.ActivityHotFilterFields.TransportTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => currentFilter === item.transportType.key.toString()));
                    break;
                // no default
            }
        }
        return result;
    };
    App.ActivityResultMobile = ActivityResultMobile;
})(App || (App = {}));
/// <reference path='../../../common/components/Result.ts' />
var App;
(function (App) {
    var _ActivityResult_instances, _ActivityResult_urlChangeStrategy, _ActivityResult_setSortingByUrlParameters, _ActivityResult_setHotFiltersByUrlParameters, _ActivityResult_setPagingByUrlParameters, _ActivityResult_filter;
    class ActivityResult extends App.Result {
        constructor(options) {
            super(Object.assign({ root: '.js-activity-search-block', blockTemplate: App.templates.Activity.BlockOutput, tableTemplate: App.templates.Activity.TableOutput }, options));
            _ActivityResult_instances.add(this);
            _ActivityResult_urlChangeStrategy.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _ActivityResult_urlChangeStrategy, new App.UrlChangeStrategy(new App.ActivityHotFilterSet()), "f");
            __classPrivateFieldGet(this, _ActivityResult_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
        }
        changeDataSource(data, append = false) {
            const result = super.changeDataSource(data, append);
            if (data.length > 0)
                this.root.showByClass();
            return result;
        }
        resetDataSource() {
            this.root.hideByClass();
            super.resetDataSource();
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case 'date': {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.beginDate)
                            .thenBy(v => v.grossPrice)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.beginDate)
                        .thenBy(v => v.grossPrice)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .orderByDescending(v => v.grossPrice)
                            .thenBy(v => v.key)
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .orderBy(v => v.grossPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
            }
        }
        applyFilters(items) {
            if (typeof this.filtering === 'undefined')
                return items;
            const activities = items;
            if (activities == null || activities.length <= 0)
                return items;
            return __classPrivateFieldGet(this, _ActivityResult_instances, "m", _ActivityResult_filter).call(this, activities);
        }
        /**
         * устанавливает параметры, которые влияют на манипуляцию с данными (фильтры, сортировка и т.д.)
         * параметры - массив параметров урла. Передаем весь, в методе отделятся нужные, не нужные не будут использоваться
         * @param urlParameter - параметры урла для установки. Если пустой массив - сортировка и пейджинг берутся предыдущие, хотфильтры
         * сбрасываются
         */
        setDataManipulateParameters(urlParameters) {
            if (!urlParameters) {
                return {
                    filtering: __classPrivateFieldGet(this, _ActivityResult_instances, "m", _ActivityResult_setHotFiltersByUrlParameters).call(this, urlParameters),
                    sorting: this.sorting,
                    paging: this.paging,
                };
            }
            return {
                filtering: __classPrivateFieldGet(this, _ActivityResult_instances, "m", _ActivityResult_setHotFiltersByUrlParameters).call(this, urlParameters),
                sorting: __classPrivateFieldGet(this, _ActivityResult_instances, "m", _ActivityResult_setSortingByUrlParameters).call(this, urlParameters),
                paging: __classPrivateFieldGet(this, _ActivityResult_instances, "m", _ActivityResult_setPagingByUrlParameters).call(this, urlParameters),
            };
        }
    }
    _ActivityResult_urlChangeStrategy = new WeakMap(), _ActivityResult_instances = new WeakSet(), _ActivityResult_setSortingByUrlParameters = function _ActivityResult_setSortingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'sort');
        if (pageUrlParameter) {
            [this.sorting.field] = pageUrlParameter.values;
            this.sorting.reverse = pageUrlParameter.values[1] === 'desc';
        }
        return this.sorting;
    }, _ActivityResult_setHotFiltersByUrlParameters = function _ActivityResult_setHotFiltersByUrlParameters(urlParameters) {
        if (urlParameters) {
            this.filtering.items = urlParameters
                .filter(v => {
                const itemName = v.name.toLowerCase();
                return itemName === App.ActivityHotFilterFields.ActivityAttributes
                    || itemName === App.ActivityHotFilterFields.GuideTypes
                    || itemName === App.ActivityHotFilterFields.IsGroup
                    || itemName === App.ActivityHotFilterFields.LandmarkNames
                    || itemName === App.ActivityHotFilterFields.TransportTypes;
            })
                .map(v => ({ name: v.name, values: v.values }));
        }
        else {
            this.filtering.items = new Array();
        }
        return this.filtering.items;
    }, _ActivityResult_setPagingByUrlParameters = function _ActivityResult_setPagingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'page');
        if (pageUrlParameter) {
            this.paging.index = parseInt(pageUrlParameter.values[0], 10);
            this.paging.size = parseInt(App.Cookie.get("showCount" /* KnownCookie.ShowCount */) || pageUrlParameter.values[1], 10);
        }
        return this.paging;
    }, _ActivityResult_filter = function _ActivityResult_filter(activities) {
        let result = activities;
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            switch (filter.name.toLowerCase()) {
                case App.ActivityHotFilterFields.ActivityAttributes:
                    result = result
                        .filter(item => item.facilities
                        .some(facility => filter.values
                        .some(currentFilter => facility.key.toString() === currentFilter)));
                    break;
                case App.ActivityHotFilterFields.GuideTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => item.guideType.key.toString() === currentFilter));
                    break;
                case App.ActivityHotFilterFields.IsGroup:
                    result = result
                        // потому что boolean-значение только true или false
                        .filter(item => item.isGroup.toString() === filter.values[0]);
                    break;
                case App.ActivityHotFilterFields.LandmarkNames:
                    result = result
                        .filter(item => item.landmarks
                        .some(landmarks => filter.values
                        .some(currentFilter => landmarks.key.toString() === currentFilter)));
                    break;
                case App.ActivityHotFilterFields.TransportTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => currentFilter === item.transportType.key.toString()));
                    break;
                // no default
            }
        }
        return result;
    };
    App.ActivityResult = ActivityResult;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Названия полей главного фильтра для отелей
     */
    let ActivityFilterFields;
    (function (ActivityFilterFields) {
        ActivityFilterFields.PointType = 'pointtype';
        ActivityFilterFields.PointKey = 'pointkey';
        ActivityFilterFields.CheckinDatesCheckin = 'checkindates.checkin';
        ActivityFilterFields.CheckinDatesCheckout = 'checkindates.checkout';
        ActivityFilterFields.Context = 'context';
        ActivityFilterFields.TouristAdultCount = 'tourist.adultcount';
        ActivityFilterFields.TouristChildAges = 'tourist.childages';
    })(ActivityFilterFields = App.ActivityFilterFields || (App.ActivityFilterFields = {}));
})(App || (App = {}));
var App;
(function (App) {
    let ActivityHotFilterFields;
    (function (ActivityHotFilterFields) {
        ActivityHotFilterFields.ActivityAttributes = 'activityattributes';
        ActivityHotFilterFields.GuideTypes = 'guidetypes';
        ActivityHotFilterFields.IsGroup = 'isgroup';
        ActivityHotFilterFields.LandmarkNames = 'landmarknames';
        ActivityHotFilterFields.TransportTypes = 'transporttypes';
    })(ActivityHotFilterFields = App.ActivityHotFilterFields || (App.ActivityHotFilterFields = {}));
})(App || (App = {}));
var App;
(function (App) {
    class ActivityHotFilterSet {
        constructor() {
            Object.defineProperty(this, "activityAttributes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "guideTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "landmarkNames", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "transportTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    { name: App.ActivityHotFilterFields.ActivityAttributes },
                    { name: App.ActivityHotFilterFields.GuideTypes },
                    { name: App.ActivityHotFilterFields.IsGroup },
                    { name: App.ActivityHotFilterFields.LandmarkNames },
                    { name: App.ActivityHotFilterFields.TransportTypes },
                ]
            });
        }
    }
    App.ActivityHotFilterSet = ActivityHotFilterSet;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Урлы для страниц с отелями
     */
    let ActivityPageUrls;
    (function (ActivityPageUrls) {
        ActivityPageUrls.Search = '/activity/search/';
        ActivityPageUrls.FindPointName = '/activity/findpointname/';
        ActivityPageUrls.SearchActivity = '/activity/searchactivity/';
        ActivityPageUrls.Info = '/activity/info/';
        ActivityPageUrls.Book = '/activity/book/';
        ActivityPageUrls.BookData = '/activity/bookdata/';
        ActivityPageUrls.Landmark = '/activity/landmark/';
        ActivityPageUrls.LandmarkActivity = '/activity/landmarkactivities/';
        ActivityPageUrls.ExistingTourists = '/activity/existingtourists/';
        ActivityPageUrls.Variants = '/activity/variants/';
        ActivityPageUrls.SeoSearch = '/activity/seosearch/';
        ActivityPageUrls.SeoInfo = '/activity/seoinfo/';
        ActivityPageUrls.SeoLandmark = '/activity/seolandmark/';
    })(ActivityPageUrls = App.ActivityPageUrls || (App.ActivityPageUrls = {}));
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Названия параметров урла для экскурсий
     */
    class ActivityUrlParameters {
        constructor() {
            Object.defineProperty(this, "emptyItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    ActivityUrlParameters.context,
                    ActivityUrlParameters.tour,
                ]
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    ActivityUrlParameters.location,
                ]
            });
        }
    }
    Object.defineProperty(ActivityUrlParameters, "location", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'location'
    });
    Object.defineProperty(ActivityUrlParameters, "tourist", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'tourist'
    });
    Object.defineProperty(ActivityUrlParameters, "datefrom", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'datefrom'
    });
    Object.defineProperty(ActivityUrlParameters, "dateto", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'dateto'
    });
    Object.defineProperty(ActivityUrlParameters, "context", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'context'
    });
    /**
     * Параметр для определения, что переход был с туров.
     * На деле нужен только для того, чтобы скрыть форму бронирования на странице инфо.
     * Но обрабатывать буду на общих основаниях
     */
    Object.defineProperty(ActivityUrlParameters, "tour", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'tour'
    });
    App.ActivityUrlParameters = ActivityUrlParameters;
})(App || (App = {}));
var App;
(function (App) {
    var _ApiServiceBase_client;
    class ApiServiceBase {
        constructor(options) {
            _ApiServiceBase_client.set(this, void 0);
            __classPrivateFieldSet(this, _ApiServiceBase_client, options.client, "f");
        }
        send(endpoint, method, data, signal) {
            return __classPrivateFieldGet(this, _ApiServiceBase_client, "f").sendJson(endpoint, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                signal,
            });
        }
    }
    _ApiServiceBase_client = new WeakMap();
    App.ApiServiceBase = ApiServiceBase;
})(App || (App = {}));
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// Exported from "PacGroup.PacWorld.Web.ServiceReferences.KnownGender"
var App;
(function (App) {
    let KnownGender;
    (function (KnownGender) {
        KnownGender[KnownGender["Male"] = 1] = "Male";
        KnownGender[KnownGender["Female"] = 2] = "Female";
    })(KnownGender = App.KnownGender || (App.KnownGender = {}));
})(App || (App = {}));
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// Exported from "PacGroup.PacWorld.Web.ServiceReferences.Office.OrderDiscountType"
var App;
(function (App) {
    let OrderDiscountType;
    (function (OrderDiscountType) {
        OrderDiscountType[OrderDiscountType["None"] = 0] = "None";
        OrderDiscountType[OrderDiscountType["BonusDiscount"] = 1] = "BonusDiscount";
        OrderDiscountType[OrderDiscountType["BestPrice"] = 2] = "BestPrice";
    })(OrderDiscountType = App.OrderDiscountType || (App.OrderDiscountType = {}));
})(App || (App = {}));
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// Exported from "PacGroup.PacWorld.Web.ServiceReferences.Packets.KnownPacketServiceType"
var App;
(function (App) {
    let KnownPacketServiceType;
    (function (KnownPacketServiceType) {
        KnownPacketServiceType[KnownPacketServiceType["Flight"] = 1] = "Flight";
        KnownPacketServiceType[KnownPacketServiceType["Transfer"] = 2] = "Transfer";
        KnownPacketServiceType[KnownPacketServiceType["Hotel"] = 3] = "Hotel";
        KnownPacketServiceType[KnownPacketServiceType["Excursion"] = 4] = "Excursion";
        KnownPacketServiceType[KnownPacketServiceType["Visa"] = 5] = "Visa";
        KnownPacketServiceType[KnownPacketServiceType["Insurance"] = 6] = "Insurance";
        KnownPacketServiceType[KnownPacketServiceType["Cruise"] = 7] = "Cruise";
        KnownPacketServiceType[KnownPacketServiceType["Undefined"] = 0] = "Undefined";
        KnownPacketServiceType[KnownPacketServiceType["Custom"] = -1] = "Custom";
    })(KnownPacketServiceType = App.KnownPacketServiceType || (App.KnownPacketServiceType = {}));
})(App || (App = {}));
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// Exported from "PacGroup.PacWorld.Web.ServiceReferences.Packets.QuotaStatus"
var App;
(function (App) {
    let QuotaStatus;
    (function (QuotaStatus) {
        QuotaStatus[QuotaStatus["None"] = 0] = "None";
        QuotaStatus[QuotaStatus["Yes"] = 1] = "Yes";
        QuotaStatus[QuotaStatus["No"] = 2] = "No";
        QuotaStatus[QuotaStatus["Few"] = 3] = "Few";
        QuotaStatus[QuotaStatus["Request"] = 4] = "Request";
    })(QuotaStatus = App.QuotaStatus || (App.QuotaStatus = {}));
})(App || (App = {}));
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
// Exported from "PacGroup.PacWorld.Web.ServiceReferences.Packets.TourTransportType"
var App;
(function (App) {
    let TourTransportType;
    (function (TourTransportType) {
        TourTransportType[TourTransportType["Unknown"] = 0] = "Unknown";
        TourTransportType[TourTransportType["Flight"] = 1] = "Flight";
        TourTransportType[TourTransportType["Rail"] = 2] = "Rail";
        TourTransportType[TourTransportType["Bus"] = 3] = "Bus";
    })(TourTransportType = App.TourTransportType || (App.TourTransportType = {}));
})(App || (App = {}));
// This file was autogenerated by https://github.com/NeVeSpl/NTypewriter
// Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
var App;
(function (App) {
    class ConfigService extends App.ApiServiceBase {
        settings(request, signal) {
            return super.send('/config/settings/', 'get', undefined, signal);
        }
        userSettings(request, signal) {
            return super.send('/config/usersettings/', 'get', undefined, signal);
        }
        exchangeRates(request, signal) {
            return super.send('/config/exchangerates/', 'get', undefined, signal);
        }
        proxy(url, signal) {
            return super.send(`/config/proxy/?url=${encodeURIComponent(url)}`, 'get', undefined, signal);
        }
    }
    App.ConfigService = ConfigService;
})(App || (App = {}));
/// <reference path='../common/PageBase.Mobile.ts' />
// TODO: при переходе через history сравнивать параметры в адресной строки текущие и предыдущие, если они разные - то грузить предыдущие результаты поиска
var App;
(function (App) {
    var _AutoPageMobile_instances, _a, _AutoPageMobile_options, _AutoPageMobile_mainFilters, _AutoPageMobile_hotFilter, _AutoPageMobile_result, _AutoPageMobile_routeHotFilter, _AutoPageMobile_routeResult, _AutoPageMobile_preloader, _AutoPageMobile_queryParams, _AutoPageMobile_formBook, _AutoPageMobile_popup, _AutoPageMobile_popupInfo, _AutoPageMobile_validator, _AutoPageMobile_responseValidator, _AutoPageMobile_searchExecuting, _AutoPageMobile_expirationPopup, _AutoPageMobile_context, _AutoPageMobile_searchResultsWrapClass, _AutoPageMobile_searchResultsHotFilterClass, _AutoPageMobile_searchResultsWrap, _AutoPageMobile_routeWrapClass, _AutoPageMobile_routeHotFilterClass, _AutoPageMobile_routeWrap, _AutoPageMobile_resultBlocksWrap, _AutoPageMobile_resultTableWrap, _AutoPageMobile_resultElement, _AutoPageMobile_bookWrapClass, _AutoPageMobile_bookWrap, _AutoPageMobile_bookFilters, _AutoPageMobile_bookDigest, _AutoPageMobile_bookForm, _AutoPageMobile_header, _AutoPageMobile_mapWrapClass, _AutoPageMobile_termWrapClass, _AutoPageMobile_states, _AutoPageMobile_state, _AutoPageMobile_seo, _AutoPageMobile_results, _AutoPageMobile_routeResults, _AutoPageMobile_currentVehiclesByRoute, _AutoPageMobile_currentVehicle, _AutoPageMobile_routeNumber, _AutoPageMobile_offerNumber, _AutoPageMobile_reserveKey, _AutoPageMobile_basketCode, _AutoPageMobile_providerKey, _AutoPageMobile_allowBooking, _AutoPageMobile_passengers, _AutoPageMobile_extraServices, _AutoPageMobile_searchXhr, _AutoPageMobile_pricePresenter, _AutoPageMobile_agentBlackListComponent, _AutoPageMobile_run, _AutoPageMobile_cleanPage, _AutoPageMobile_setHeader, _AutoPageMobile_updateSeo, _AutoPageMobile_showSearchFilter, _AutoPageMobile_showSearchResultsPage, _AutoPageMobile_renderSearchResultsPage, _AutoPageMobile_showSearchResults, _AutoPageMobile_renderSearchResults, _AutoPageMobile_showRoutePage, _AutoPageMobile_renderRoutePage, _AutoPageMobile_showRoutes, _AutoPageMobile_renderRoutes, _AutoPageMobile_showBookPage, _AutoPageMobile_renderBookPage, _AutoPageMobile_showBook, _AutoPageMobile_renderBook, _AutoPageMobile_onBookSend, _AutoPageMobile_saveState, _AutoPageMobile_formatTime, _AutoPageMobile_formatDate, _AutoPageMobile_checkMainFilter, _AutoPageMobile_getParamsFromFiltersMobile, _AutoPageMobile_getParamsFromSortBlock, _AutoPageMobile_addParamSearchBlock, _AutoPageMobile_getParamsFromMainFiltersSearchBlock, _AutoPageMobile_getParamsForBook, _AutoPageMobile_getValidateAttributes, _AutoPageMobile_getBirthdayValidateAttrs, _AutoPageMobile_getBookDataDigest, _AutoPageMobile_getBookFloaterDigest, _AutoPageMobile_getBookContentDigest, _AutoPageMobile_getBookContentMainBlock, _AutoPageMobile_getVehicleExtrasData, _AutoPageMobile_getParamsOfHotFilter, _AutoPageMobile_prepareDataForSearch, _AutoPageMobile_prepareDataForBook, _AutoPageMobile_initRoutePageScripts, _AutoPageMobile_initBookPageScripts, _AutoPageMobile_onBookFilterChanged, _AutoPageMobile_getRoutes, _AutoPageMobile_getCurrentRoute, _AutoPageMobile_getVehiclesByRoute, _AutoPageMobile_getCurrentVehicle, _AutoPageMobile_getVehicle, _AutoPageMobile_getReserveKey, _AutoPageMobile_showMap, _AutoPageMobile_searchRoutes, _AutoPageMobile_getVehicleTerms, _AutoPageMobile_reserveOffer, _AutoPageMobile_getExistingPassengers, _AutoPageMobile_book, _AutoPageMobile_fillExtraServices, _AutoPageMobile_recalcExtraServices, _AutoPageMobile_updateExtraServiceDigest, _AutoPageMobile_updateExtraServiceDigestPrice, _AutoPageMobile_focusFirstInvalidField, _AutoPageMobile_onHistoryStateChange, _AutoPageMobile_onMainFilterSearch, _AutoPageMobile_onOfferClick, _AutoPageMobile_onAllowBookButtonClick, _AutoPageMobile_onBookButtonClick, _AutoPageMobile_onExtraServisesChange, _AutoPageMobile_onShowMapClick, _AutoPageMobile_onShowTermsClick, _AutoPageMobile_onShowTermsSimpleClick, _AutoPageMobile_onLinkClick;
    class AutoPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: `.js-auto-page .${App.Application.defaults.appContainerContentClass}` }, options));
            _AutoPageMobile_instances.add(this);
            _AutoPageMobile_options.set(this, void 0);
            _AutoPageMobile_mainFilters.set(this, void 0);
            _AutoPageMobile_hotFilter.set(this, void 0);
            _AutoPageMobile_result.set(this, void 0);
            _AutoPageMobile_routeHotFilter.set(this, void 0);
            _AutoPageMobile_routeResult.set(this, void 0);
            _AutoPageMobile_preloader.set(this, void 0);
            _AutoPageMobile_queryParams.set(this, void 0);
            _AutoPageMobile_formBook.set(this, void 0);
            _AutoPageMobile_popup.set(this, void 0);
            _AutoPageMobile_popupInfo.set(this, void 0);
            _AutoPageMobile_validator.set(this, void 0);
            _AutoPageMobile_responseValidator.set(this, void 0);
            _AutoPageMobile_searchExecuting.set(this, false);
            _AutoPageMobile_expirationPopup.set(this, void 0);
            _AutoPageMobile_context.set(this, void 0);
            // Элементы страницы
            _AutoPageMobile_searchResultsWrapClass.set(this, void 0);
            _AutoPageMobile_searchResultsHotFilterClass.set(this, void 0);
            // обертка для результатов поиска и вторичного фильтра
            _AutoPageMobile_searchResultsWrap.set(this, void 0);
            // обертка для результатов поиска в блочном виде и табличном
            _AutoPageMobile_routeWrapClass.set(this, void 0);
            _AutoPageMobile_routeHotFilterClass.set(this, void 0);
            _AutoPageMobile_routeWrap.set(this, void 0);
            // обертка для описания круиза
            _AutoPageMobile_resultBlocksWrap.set(this, void 0);
            _AutoPageMobile_resultTableWrap.set(this, void 0);
            _AutoPageMobile_resultElement.set(this, void 0);
            _AutoPageMobile_bookWrapClass.set(this, void 0);
            _AutoPageMobile_bookWrap.set(this, void 0);
            _AutoPageMobile_bookFilters.set(this, void 0);
            _AutoPageMobile_bookDigest.set(this, void 0);
            // обертка для бронирования круиза
            _AutoPageMobile_bookForm.set(this, void 0);
            _AutoPageMobile_header.set(this, void 0);
            _AutoPageMobile_mapWrapClass.set(this, void 0);
            _AutoPageMobile_termWrapClass.set(this, void 0);
            // состояния
            _AutoPageMobile_states.set(this, void 0);
            _AutoPageMobile_state.set(this, void 0);
            _AutoPageMobile_seo.set(this, void 0);
            // результаты
            _AutoPageMobile_results.set(this, void 0);
            _AutoPageMobile_routeResults.set(this, void 0);
            _AutoPageMobile_currentVehiclesByRoute.set(this, void 0);
            _AutoPageMobile_currentVehicle.set(this, void 0);
            _AutoPageMobile_routeNumber.set(this, void 0);
            _AutoPageMobile_offerNumber.set(this, void 0);
            _AutoPageMobile_reserveKey.set(this, void 0);
            _AutoPageMobile_basketCode.set(this, void 0);
            _AutoPageMobile_providerKey.set(this, void 0);
            _AutoPageMobile_allowBooking.set(this, void 0);
            _AutoPageMobile_passengers.set(this, void 0);
            _AutoPageMobile_extraServices.set(this, void 0);
            _AutoPageMobile_searchXhr.set(this, void 0);
            _AutoPageMobile_pricePresenter.set(this, void 0);
            _AutoPageMobile_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _AutoPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AutoPageMobile_searchResultsWrapClass, '.js-auto-search-results', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_searchResultsHotFilterClass, '.js-auto-search-results .js-auto-hot-filter', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_routeWrapClass, '.js-auto-route', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_routeHotFilterClass, '.js-auto-route .js-auto-route-hot-filter', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_bookWrapClass, '.js-auto-book', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_queryParams, new App.QueryParams(window.location.pathname), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_context, __classPrivateFieldGet(this, _AutoPageMobile_queryParams, "f").getContext(), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_preloader, new App.Preloader(), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_seo, {}, "f");
            __classPrivateFieldSet(this, _AutoPageMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_header, $('.js-header', this.root), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_mapWrapClass, 'js-auto-point-map-wrap', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_termWrapClass, 'js-auto-terms-wrap', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_searchResultsWrap, $(__classPrivateFieldGet(this, _AutoPageMobile_searchResultsWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_routeWrap, $(__classPrivateFieldGet(this, _AutoPageMobile_routeWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_resultBlocksWrap, $('.js-tours-output-block', __classPrivateFieldGet(this, _AutoPageMobile_routeWrap, "f")), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_resultTableWrap, $('.js-tours-output-table', __classPrivateFieldGet(this, _AutoPageMobile_routeWrap, "f")), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_resultElement, '.js-result-item', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_bookWrap, $(__classPrivateFieldGet(this, _AutoPageMobile_bookWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_bookForm, $('.js-form-order', this.root), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_routeNumber, $('#routeNumber').valString(), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_offerNumber, $('#offerNumber').valString(), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_states, {
                'search': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showSearchFilter).call(this))),
                    actionName: 'search',
                },
                'search_results': {
                    handler: () => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showSearchResultsPage).call(this),
                    actionName: 'search',
                },
                'route': {
                    handler: () => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showRoutePage).call(this),
                    actionName: 'route',
                },
                'book': {
                    handler: () => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showBookPage).call(this),
                    actionName: 'book',
                },
            }, "f");
            __classPrivateFieldSet(this, _AutoPageMobile_state, $('input[name="state"]', this.root).valString(), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_mainFilters, new App.AutoMainFilterMobile({ root: '.js-auto-main-filter-mobile' }), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_validator, __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").validator, "f");
            __classPrivateFieldSet(this, _AutoPageMobile_responseValidator, new App.ResponseValidator({
                messenger: new App.BlockMessenger(new App.Messages()),
                validator: __classPrivateFieldGet(this, _AutoPageMobile_validator, "f"),
            }), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_hotFilter, new App.AutoHotFilterMobile({
                root: __classPrivateFieldGet(this, _AutoPageMobile_searchResultsHotFilterClass, "f"),
            }), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_result, new App.AutoResultMobile({
                root: __classPrivateFieldGet(this, _AutoPageMobile_searchResultsWrapClass, "f"),
                hotFilter: __classPrivateFieldGet(this, _AutoPageMobile_hotFilter, "f"),
            }), "f");
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onHistoryStateChange).call(this); }));
            __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").searchFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onMainFilterSearch).call(this); }));
            // Прокрутка якорных ссылок
            this.root.on('click', '.js-scroll-to', e => App.scrollLinkClickHandler(e));
            // Читать полностью
            this.root.on('click', '.js-read-more', e => App.readMoreClickHandler(e));
            // открытие ссылок внутри блоков (ссылок)
            this.root.on('click', '[data-href]', e => __classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_onLinkClick).call(_a, e));
            // показать на карте
            this.root.on('click', '.js-show-on-map', (e) => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onShowMapClick).call(this, e));
            // показать условия аренды
            this.root.on('click', '.js-show-terms', e => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onShowTermsClick).call(this, e));
            this.root.on('click', '.js-show-terms-simple', e => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onShowTermsSimpleClick).call(this, e));
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _AutoPageMobile_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            App.History.replaceState(__classPrivateFieldGet(this, _AutoPageMobile_state, "f"), __classPrivateFieldGet(this, _AutoPageMobile_queryParams, "f").getUrl());
            (() => __awaiter(this, void 0, void 0, function* () {
                if (__classPrivateFieldGet(this, _AutoPageMobile_state, "f") === 'search_results' || __classPrivateFieldGet(this, _AutoPageMobile_state, "f") === 'route') {
                    yield new Promise(resolve => setTimeout(resolve, 0)); // Yield to the event loop for filters initialization.
                }
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_run).call(this);
            }))();
        }
        // typeTopScroll: 1 - body, 2 - сам элемент jqObj
        static show(jqObj, scrollTop, typeTopScroll) {
            jqObj.showByClass();
            if (jqObj && scrollTop) {
                const scrollObj = typeTopScroll === 1 ? $('body') : jqObj;
                const scrollObjOffset = scrollObj.offset();
                $('html, body').animate({ scrollTop: (scrollObjOffset != null ? scrollObjOffset.top : 0) }, 'slow');
            }
        }
    }
    _a = AutoPageMobile, _AutoPageMobile_options = new WeakMap(), _AutoPageMobile_mainFilters = new WeakMap(), _AutoPageMobile_hotFilter = new WeakMap(), _AutoPageMobile_result = new WeakMap(), _AutoPageMobile_routeHotFilter = new WeakMap(), _AutoPageMobile_routeResult = new WeakMap(), _AutoPageMobile_preloader = new WeakMap(), _AutoPageMobile_queryParams = new WeakMap(), _AutoPageMobile_formBook = new WeakMap(), _AutoPageMobile_popup = new WeakMap(), _AutoPageMobile_popupInfo = new WeakMap(), _AutoPageMobile_validator = new WeakMap(), _AutoPageMobile_responseValidator = new WeakMap(), _AutoPageMobile_searchExecuting = new WeakMap(), _AutoPageMobile_expirationPopup = new WeakMap(), _AutoPageMobile_context = new WeakMap(), _AutoPageMobile_searchResultsWrapClass = new WeakMap(), _AutoPageMobile_searchResultsHotFilterClass = new WeakMap(), _AutoPageMobile_searchResultsWrap = new WeakMap(), _AutoPageMobile_routeWrapClass = new WeakMap(), _AutoPageMobile_routeHotFilterClass = new WeakMap(), _AutoPageMobile_routeWrap = new WeakMap(), _AutoPageMobile_resultBlocksWrap = new WeakMap(), _AutoPageMobile_resultTableWrap = new WeakMap(), _AutoPageMobile_resultElement = new WeakMap(), _AutoPageMobile_bookWrapClass = new WeakMap(), _AutoPageMobile_bookWrap = new WeakMap(), _AutoPageMobile_bookFilters = new WeakMap(), _AutoPageMobile_bookDigest = new WeakMap(), _AutoPageMobile_bookForm = new WeakMap(), _AutoPageMobile_header = new WeakMap(), _AutoPageMobile_mapWrapClass = new WeakMap(), _AutoPageMobile_termWrapClass = new WeakMap(), _AutoPageMobile_states = new WeakMap(), _AutoPageMobile_state = new WeakMap(), _AutoPageMobile_seo = new WeakMap(), _AutoPageMobile_results = new WeakMap(), _AutoPageMobile_routeResults = new WeakMap(), _AutoPageMobile_currentVehiclesByRoute = new WeakMap(), _AutoPageMobile_currentVehicle = new WeakMap(), _AutoPageMobile_routeNumber = new WeakMap(), _AutoPageMobile_offerNumber = new WeakMap(), _AutoPageMobile_reserveKey = new WeakMap(), _AutoPageMobile_basketCode = new WeakMap(), _AutoPageMobile_providerKey = new WeakMap(), _AutoPageMobile_allowBooking = new WeakMap(), _AutoPageMobile_passengers = new WeakMap(), _AutoPageMobile_extraServices = new WeakMap(), _AutoPageMobile_searchXhr = new WeakMap(), _AutoPageMobile_pricePresenter = new WeakMap(), _AutoPageMobile_agentBlackListComponent = new WeakMap(), _AutoPageMobile_instances = new WeakSet(), _AutoPageMobile_run = function _AutoPageMobile_run() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_cleanPage).call(this);
            yield __classPrivateFieldGet(this, _AutoPageMobile_states, "f")[__classPrivateFieldGet(this, _AutoPageMobile_state, "f")].handler();
        });
    }, _AutoPageMobile_cleanPage = function _AutoPageMobile_cleanPage() {
        __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").searchFilter.hideByClass();
        __classPrivateFieldGet(this, _AutoPageMobile_searchResultsWrap, "f").hideByClass();
        __classPrivateFieldGet(this, _AutoPageMobile_routeWrap, "f").hideByClass();
        __classPrivateFieldGet(this, _AutoPageMobile_bookWrap, "f").hideByClass();
    }, _AutoPageMobile_setHeader = function _AutoPageMobile_setHeader(header) {
        __classPrivateFieldGet(this, _AutoPageMobile_header, "f").html(header);
    }, _AutoPageMobile_updateSeo = function _AutoPageMobile_updateSeo(seoInfo) {
        App.app.seo.update(seoInfo);
    }, _AutoPageMobile_showSearchFilter = function _AutoPageMobile_showSearchFilter() {
        _a.show(__classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").searchFilter, true, 1);
    }, _AutoPageMobile_showSearchResultsPage = function _AutoPageMobile_showSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: если поиска маршрутов не было или результаты поиска отличаются от формы => новый поиск
            if (!__classPrivateFieldGet(this, _AutoPageMobile_results, "f"))
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderSearchResultsPage).call(this, true);
            else
                __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showSearchResults).call(this);
        });
    }, _AutoPageMobile_renderSearchResultsPage = function _AutoPageMobile_renderSearchResultsPage(needHotFilterData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPageMobile_validator, "f").form())
                return;
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showSearchFilter).call(this);
            if (!(yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_searchRoutes).call(this, false, needHotFilterData)))
                return;
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderSearchResults).call(this);
            let isStateReplace = false;
            if (__classPrivateFieldGet(this, _AutoPageMobile_state, "f") !== 'search')
                isStateReplace = true;
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_saveState).call(this, 'search_results', __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getParamsFromFiltersMobile).call(this, __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").filters, __classPrivateFieldGet(this, _AutoPageMobile_hotFilter, "f").filters), null, isStateReplace);
        });
    }, _AutoPageMobile_showSearchResults = function _AutoPageMobile_showSearchResults() {
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showSearchFilter).call(this);
        _a.show(__classPrivateFieldGet(this, _AutoPageMobile_searchResultsWrap, "f"));
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_updateSeo).call(this, __classPrivateFieldGet(this, _AutoPageMobile_seo, "f")[__classPrivateFieldGet(this, _AutoPageMobile_state, "f")]);
    }, _AutoPageMobile_renderSearchResults = function _AutoPageMobile_renderSearchResults() {
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showSearchResults).call(this);
    }, _AutoPageMobile_showRoutePage = function _AutoPageMobile_showRoutePage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AutoPageMobile_results, "f") && __classPrivateFieldGet(this, _AutoPageMobile_results, "f").length !== 0)
                __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showRoutes).call(this);
            else
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderRoutePage).call(this);
        });
    }, _AutoPageMobile_renderRoutePage = function _AutoPageMobile_renderRoutePage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPageMobile_validator, "f").form())
                return;
            if (!(yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_searchRoutes).call(this, true, false)))
                return;
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderRoutes).call(this);
        });
    }, _AutoPageMobile_showRoutes = function _AutoPageMobile_showRoutes() {
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showSearchFilter).call(this);
        _a.show(__classPrivateFieldGet(this, _AutoPageMobile_routeWrap, "f"), true, 1);
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_updateSeo).call(this, __classPrivateFieldGet(this, _AutoPageMobile_seo, "f")[__classPrivateFieldGet(this, _AutoPageMobile_state, "f")]);
    }, _AutoPageMobile_renderRoutes = function _AutoPageMobile_renderRoutes() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getVehiclesByRoute).call(this);
            // отписываемся, иначе будут дубли онклик
            __classPrivateFieldGet(this, _AutoPageMobile_resultBlocksWrap, "f").off('click', __classPrivateFieldGet(this, _AutoPageMobile_resultElement, "f"));
            __classPrivateFieldGet(this, _AutoPageMobile_resultTableWrap, "f").off('click', __classPrivateFieldGet(this, _AutoPageMobile_resultElement, "f"));
            __classPrivateFieldGet(this, _AutoPageMobile_searchResultsWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showRoutes).call(this);
            // подписываемся
            __classPrivateFieldGet(this, _AutoPageMobile_resultBlocksWrap, "f").on('click', __classPrivateFieldGet(this, _AutoPageMobile_resultElement, "f"), (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onOfferClick).call(this, e); }));
            __classPrivateFieldGet(this, _AutoPageMobile_resultTableWrap, "f").on('click', __classPrivateFieldGet(this, _AutoPageMobile_resultElement, "f"), (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onOfferClick).call(this, e); }));
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_initRoutePageScripts).call(this);
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_saveState).call(this, 'route', __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getParamsFromFiltersMobile).call(this, __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").filters, __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f") ? __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f").filters : undefined), null, false);
        });
    }, _AutoPageMobile_showBookPage = function _AutoPageMobile_showBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f"))
                __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showBook).call(this);
            else if (yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_searchRoutes).call(this, true, false))
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderBookPage).call(this);
        });
    }, _AutoPageMobile_renderBookPage = function _AutoPageMobile_renderBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getVehiclesByRoute).call(this);
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getCurrentVehicle).call(this);
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getReserveKey).call(this);
            const queryParams = new App.QueryParams(window.location.pathname);
            queryParams.clear();
            if (!__classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f") || !__classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f") || !__classPrivateFieldGet(this, _AutoPageMobile_reserveKey, "f")) {
                const mes = new App.Messages();
                queryParams.setAction('route');
                queryParams.add('', [__classPrivateFieldGet(this, _AutoPageMobile_routeNumber, "f").toString()]);
                const add = __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").searchFilter.length > 0
                    ? __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getParamsFromFiltersMobile).call(this, __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").filters, __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f") ? __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f").filters : undefined)
                    : __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getParamsForBook).call(this);
                Object.getOwnPropertyNames(add).forEach(param => {
                    queryParams.add(param, add[param]);
                });
                const url = queryParams.getUrl();
                mes.show({ type: 0 /* MessageType.Information */, text: `Данное предложение не найдено. Попробуйте <a href="${url}">новый поиск</a>.` });
                return;
            }
            const messenger = new App.PopupMessenger(__classPrivateFieldGet(this, _AutoPageMobile_popup, "f"));
            __classPrivateFieldSet(this, _AutoPageMobile_responseValidator, new App.ResponseValidatorOld({ messenger, validator: __classPrivateFieldGet(this, _AutoPageMobile_validator, "f") }), "f");
            const popupGroup = __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Valuating({}),
                modal: true,
            });
            if (!(yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_reserveOffer).call(this))) {
                __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").hide(popupGroup);
                return;
            }
            __classPrivateFieldSet(this, _AutoPageMobile_expirationPopup, App.scheduleExpirationPopup({
                interval: App.app.settings.relevantResultTime,
                url: __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.searchRoutes,
            }), "f");
            if (__classPrivateFieldGet(this, _AutoPageMobile_context, "f"))
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getExistingPassengers).call(this);
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderBook).call(this);
            __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").hide(popupGroup);
            App.History.saveState('book', __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").url);
        });
    }, _AutoPageMobile_showBook = function _AutoPageMobile_showBook() {
        _a.show(__classPrivateFieldGet(this, _AutoPageMobile_bookWrap, "f"), true, 1);
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_setHeader).call(this, __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").vehicle.name);
    }, _AutoPageMobile_renderBook = function _AutoPageMobile_renderBook() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").searchFilter.hideByClass(); // this.#filter
            __classPrivateFieldGet(this, _AutoPageMobile_searchResultsWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _AutoPageMobile_routeWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showBook).call(this);
            // $('.main-block__left-col', this.#bookWrap).empty();
            __classPrivateFieldSet(this, _AutoPageMobile_bookDigest, new App.DigestMobile({
                buttonTitle: 'Забронировать',
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onBookSend).call(this),
                allowBooking: __classPrivateFieldGet(this, _AutoPageMobile_allowBooking, "f"),
            }), "f");
            __classPrivateFieldGet(this, _AutoPageMobile_bookDigest, "f").empty();
            // $('.main-block__right-col', this.#bookWrap).empty();
            $('.js-auto-book-content', __classPrivateFieldGet(this, _AutoPageMobile_bookWrap, "f")).empty();
            // TODO: переделать на мобильные??
            __classPrivateFieldSet(this, _AutoPageMobile_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
            const currentRouteEl = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getCurrentRoute).call(this, __classPrivateFieldGet(this, _AutoPageMobile_routeNumber, "f"));
            const digestData = yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getBookDataDigest).call(this, currentRouteEl);
            const digestContent = yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getBookContentDigest).call(this, digestData);
            const digestFloater = yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getBookFloaterDigest).call(this, digestData);
            const mainBookBlock = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getBookContentMainBlock).call(this, currentRouteEl);
            // $('.main-block__left-col', this.#bookWrap).append([digestContent]);
            yield __classPrivateFieldGet(this, _AutoPageMobile_bookDigest, "f").setContent(digestContent);
            __classPrivateFieldGet(this, _AutoPageMobile_bookDigest, "f").setFloater(digestFloater);
            // $('.main-block__right-col', this.#bookWrap).append(mainBookBlock);
            $('.js-auto-book-content', __classPrivateFieldGet(this, _AutoPageMobile_bookWrap, "f")).append(mainBookBlock);
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_initBookPageScripts).call(this);
        });
    }, _AutoPageMobile_onBookSend = function _AutoPageMobile_onBookSend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AutoPageMobile_bookDigest, "f"))
                __classPrivateFieldGet(this, _AutoPageMobile_bookDigest, "f").close();
            // await this.#onAllowBookButtonClick();
            $('#allowBook').trigger('click');
        });
    }, _AutoPageMobile_saveState = function _AutoPageMobile_saveState(state, add, replace, isReplace = false) {
        __classPrivateFieldSet(this, _AutoPageMobile_state, state, "f");
        const queryParams = new App.QueryParams(window.location.pathname);
        queryParams.clear();
        queryParams.setAction(__classPrivateFieldGet(this, _AutoPageMobile_states, "f")[__classPrivateFieldGet(this, _AutoPageMobile_state, "f")].actionName);
        if (add) {
            Object.getOwnPropertyNames(add).forEach(param => {
                queryParams.add(param, add[param]);
            });
        }
        if (replace) {
            Object.getOwnPropertyNames(replace).forEach(param => {
                queryParams.replace(param, replace[param]);
            });
        }
        const url = queryParams.getUrl();
        if (isReplace)
            App.History.replaceState(__classPrivateFieldGet(this, _AutoPageMobile_state, "f"), url, true);
        else
            App.History.saveState(__classPrivateFieldGet(this, _AutoPageMobile_state, "f"), url);
    }, _AutoPageMobile_formatTime = function _AutoPageMobile_formatTime(time) {
        // 12:00:00 -> 1200
        const timeParts = time.split(':');
        return timeParts[0] + timeParts[1];
    }, _AutoPageMobile_formatDate = function _AutoPageMobile_formatDate(date) {
        // 25.03.2017 -> 20170325 - Russian
        const dateParts = date.split('.');
        return dateParts[2] + dateParts[1] + dateParts[0];
    }, _AutoPageMobile_checkMainFilter = function _AutoPageMobile_checkMainFilter() {
        return true;
    }, _AutoPageMobile_getParamsFromFiltersMobile = function _AutoPageMobile_getParamsFromFiltersMobile(filter, otherHotFilter) {
        const params = {};
        let filterParams = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getParamsFromMainFiltersSearchBlock).call(this, filter);
        if (otherHotFilter) {
            const hotFilterParams = otherHotFilter.getParamsForSearch(true);
            filterParams = filterParams.concat(hotFilterParams);
            filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_getParamsFromSortBlock).call(_a, otherHotFilter.root));
        }
        filterParams.forEach(value => {
            params[value.key] = value.value;
        });
        return params;
    }, _AutoPageMobile_getParamsFromSortBlock = function _AutoPageMobile_getParamsFromSortBlock(filter) {
        var _b;
        const params = [];
        const sortValue = (_b = $('.js-sort-item._active', filter).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
        params.push({ key: 'sort', value: [sortValue] });
        return params;
    }, _AutoPageMobile_addParamSearchBlock = function _AutoPageMobile_addParamSearchBlock(params, key, value) {
        if (!value || value.length <= 0)
            return;
        if (value.length == 1 && (value[0] == 'false' || value[0] == '0' || value[0] == ''))
            return;
        const existKey = params.findIndex(el => el.key === key);
        if (existKey !== -1)
            params[existKey].value = params[existKey].value.concat(value);
        else
            params.push({ key, value });
    }, _AutoPageMobile_getParamsFromMainFiltersSearchBlock = function _AutoPageMobile_getParamsFromMainFiltersSearchBlock(filter) {
        const params = [];
        // pickup
        const pickupValues = [];
        const pickup = filter.getControlItemValue('Pickup');
        pickupValues.push(`${pickup.typeCode.toLowerCase()},${pickup.key}`);
        pickupValues.push(__classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_formatDate).call(this, filter.getControlValueString('Pickup.Date')));
        pickupValues.push(__classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_formatTime).call(_a, filter.getControlValueString('Pickup.Time')));
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_addParamSearchBlock).call(this, params, 'pickup', pickupValues);
        // dropoff
        const dropoffValues = [];
        const dropoff = filter.getControlItemValue('Dropoff');
        dropoffValues.push(`${dropoff.typeCode.toLowerCase()},${dropoff.key}`);
        dropoffValues.push(__classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_formatDate).call(this, filter.getControlValueString('Dropoff.Date')));
        dropoffValues.push(__classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_formatTime).call(_a, filter.getControlValueString('Dropoff.Time')));
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_addParamSearchBlock).call(this, params, 'dropoff', dropoffValues);
        // driverage
        __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_addParamSearchBlock).call(this, params, 'driverage', filter.getControlValueStringArr('DriverAge'));
        return params;
    }, _AutoPageMobile_getParamsForBook = function _AutoPageMobile_getParamsForBook() {
        const params = [];
        __classPrivateFieldGet(this, _AutoPageMobile_options, "f").searchData.forEach(val => {
            let key = val.name;
            if (key === 'state' || key.includes('SameDropoff'))
                return true;
            let value = val.value.toLowerCase();
            if (key.includes('Date'))
                value = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_formatDate).call(this, value);
            if (key.includes('Time'))
                value = __classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_formatTime).call(_a, value);
            if (value === '0')
                return true;
            if (key.includes('.'))
                key = key.substring(0, key.indexOf('.'));
            const values = [value];
            if (key.length > 0 && values.length > 0) {
                const existKey = params.findIndex(el => el.key === key);
                if (existKey !== -1)
                    params[existKey].value = params[existKey].value.concat(values);
                else
                    params.push({ key, value: values });
            }
            return true;
        });
        const p = {};
        params.forEach(value => {
            p[value.key.toLowerCase()] = value.value;
        });
        return p;
    }, _AutoPageMobile_getValidateAttributes = function _AutoPageMobile_getValidateAttributes(currentRouteEl) {
        const attributes = {};
        attributes.birthdayAttributes = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getBirthdayValidateAttrs).call(this, currentRouteEl);
        return attributes;
    }, _AutoPageMobile_getBirthdayValidateAttrs = function _AutoPageMobile_getBirthdayValidateAttrs(currentRouteEl) {
        const date = new Date(currentRouteEl.pickup.date);
        date.setHours(23, 0, 0, 0);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const currentDriverAge = Number(__classPrivateFieldGet(this, _AutoPageMobile_queryParams, "f").param('driverage')[0]);
        const minBirthDay = new Date(year - currentDriverAge - 1, month, day - 1);
        // тут new Date(year, month, day) время не устанавливается (т.е. равно 0), toISOString применяет часовой пояс => дата после
        // преобразования получается на 1 день меньше нужной, поэтому тут вычитаю смещение часовй пояса, а потом уже toISOString
        // TODO Titov: потенциальная ошибка, нельзя использовать getTimezoneOffset на клиенте, исправить!
        let tzoffset = minBirthDay.getTimezoneOffset() * 60000; // offset in milliseconds
        const minBirthDayString = (new Date(minBirthDay.getTime() - tzoffset)).toISOString().slice(0, 10);
        const maxBirthDay = new Date(year - currentDriverAge, month, day);
        // тут new Date(year, month, day) время не устанавливается (т.е. равно 0), toISOString применяет часовой пояс => дата после
        // преобразования получается на 1 день меньше нужной, поэтому тут вычитаю смещение часовй пояса, а потом уже toISOString
        // TODO Titov: потенциальная ошибка, нельзя использовать getTimezoneOffset на клиенте, исправить!
        tzoffset = maxBirthDay.getTimezoneOffset() * 60000; // offset in milliseconds
        const maxBirthDayString = (new Date(maxBirthDay.getTime() - tzoffset)).toISOString().slice(0, 10);
        return `required data-rule-dateiso="true" data-rule-datemax="${maxBirthDayString}" data-rule-datemin="${minBirthDayString}"`;
    }, _AutoPageMobile_getBookDataDigest = function _AutoPageMobile_getBookDataDigest(currentRouteEl) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            return {
                vehicle: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f"),
                currentRoute: currentRouteEl,
                bookDigestData: {
                    servicePrices: [],
                    netPrice: typeof __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").netPrice !== 'undefined' ? __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").netPrice : undefined,
                    grossPrice: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice,
                    discount: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice - ((_b = __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").price) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice),
                    price: (_c = __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").price) !== null && _c !== void 0 ? _c : __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice,
                    currencyCode: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").currencyCode,
                    hasDetails: false,
                    pricePresenter: {
                        type: __classPrivateFieldGet(this, _AutoPageMobile_pricePresenter, "f").type,
                        show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                    },
                    notes: [],
                },
            };
        });
    }, _AutoPageMobile_getBookFloaterDigest = function _AutoPageMobile_getBookFloaterDigest(model) {
        return __awaiter(this, void 0, void 0, function* () {
            return $(App.templates.Auto.Book.BlockDigest_Floater_Mobile(model));
        });
    }, _AutoPageMobile_getBookContentDigest = function _AutoPageMobile_getBookContentDigest(model) {
        return __awaiter(this, void 0, void 0, function* () {
            return $(App.templates.Auto.Book.BlockDigest_Mobile(model));
        });
    }, _AutoPageMobile_getBookContentMainBlock = function _AutoPageMobile_getBookContentMainBlock(currentRouteEl) {
        const attributes = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getValidateAttributes).call(this, currentRouteEl);
        return $(App.templates.Auto.Book.BlockMain_Mobile({
            vehicle: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f"),
            vehicleExtrasData: __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getVehicleExtrasData).call(this, __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f")),
            existingPassengers: __classPrivateFieldGet(this, _AutoPageMobile_passengers, "f"),
            existingPassengerData: App.ExistingPassengersMobile.ViewModelByExistingPassengers(__classPrivateFieldGet(this, _AutoPageMobile_passengers, "f")),
            checkAttributes: attributes,
            allowBooking: __classPrivateFieldGet(this, _AutoPageMobile_allowBooking, "f"),
            // NOTE: в этом модуле турист только один, поэтому достаточно один экземпляр данных для поиска туриста
            findTouristData: App.FindTouristMobile.ViewModel({ minLength: 4 }),
            dateTourist: {
                meta: {
                    minDate: App.addDays(new Date(), App.MobileFilterDateBlock.yearRangeLeft * 365),
                    maxDate: App.addDays(new Date(), App.MobileFilterDateBlock.yearRangeRight * 365),
                    formatReturn: 'isoDate',
                },
            },
        }));
    }, _AutoPageMobile_getVehicleExtrasData = function _AutoPageMobile_getVehicleExtrasData(vehicle) {
        const ret = {};
        if (!vehicle || !vehicle.extras)
            return ret;
        vehicle.extras.forEach(extra => {
            const items = [];
            for (let i = 0; i <= extra.maxQuantity; i++) {
                const t = i.toString();
                items.push({
                    value: t,
                    label: t,
                    name: t,
                    checked: i == 0,
                    original: extra,
                });
            }
            ret[extra.key] = items;
        });
        return ret;
    }, _AutoPageMobile_getParamsOfHotFilter = function _AutoPageMobile_getParamsOfHotFilter() {
        const queryParams = new App.QueryParams(window.location.pathname);
        const elements = [];
        const checkValues = [
            App.AutoHotFilterFields.PickupPlace,
            App.AutoHotFilterFields.DropoffPlace,
            App.AutoHotFilterFields.Category,
            App.AutoHotFilterFields.Model,
            App.AutoHotFilterFields.Provider,
            App.AutoHotFilterFields.Transmission,
            App.AutoHotFilterFields.PassengersCount,
            App.AutoHotFilterFields.FreeCancellation,
        ];
        checkValues.forEach(v => {
            const val = queryParams.param(v).map(s => decodeURIComponent(s).toLowerCase());
            elements.push({ name: v, value: val.join(',') });
        });
        return elements;
    }, _AutoPageMobile_prepareDataForSearch = function _AutoPageMobile_prepareDataForSearch(needHotFilterData) {
        let elements = [];
        if (__classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").searchFilter.length > 0)
            elements = __classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").filters.serializeArray();
        else if (__classPrivateFieldGet(this, _AutoPageMobile_options, "f").searchData.length > 0)
            elements = __classPrivateFieldGet(this, _AutoPageMobile_options, "f").searchData;
        if (needHotFilterData)
            elements = elements.concat(__classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_getParamsOfHotFilter).call(_a));
        const data = {};
        $.each(elements, (i, v) => {
            if (v.value == null || v.value === '')
                return true;
            data[v.name] = v.value;
            return true;
        });
        return data;
    }, _AutoPageMobile_prepareDataForBook = function _AutoPageMobile_prepareDataForBook() {
        let elements = __classPrivateFieldGet(this, _AutoPageMobile_bookFilters, "f").filters.serializeArray();
        elements.push({ name: 'Key', value: __classPrivateFieldGet(this, _AutoPageMobile_reserveKey, "f") });
        elements.push({ name: 'BasketCode', value: __classPrivateFieldGet(this, _AutoPageMobile_basketCode, "f") });
        elements.push({ name: 'ProviderKey', value: __classPrivateFieldGet(this, _AutoPageMobile_providerKey, "f").toString() });
        elements.push({ name: 'RouteNumber', value: __classPrivateFieldGet(this, _AutoPageMobile_routeNumber, "f").toString() });
        if (__classPrivateFieldGet(this, _AutoPageMobile_options, "f").searchData.length > 0) {
            elements = elements.concat(__classPrivateFieldGet(this, _AutoPageMobile_options, "f").searchData);
        }
        else {
            elements = elements.concat(__classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").filters.serializeArray());
        }
        const data = {};
        $.each(elements, (i, v) => {
            if (v.value == null || v.value === '')
                return true;
            data[v.name] = v.value;
            return true;
        });
        return data;
    }, _AutoPageMobile_initRoutePageScripts = function _AutoPageMobile_initRoutePageScripts() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f")) {
                __classPrivateFieldSet(this, _AutoPageMobile_routeHotFilter, new App.AutoRouteHotFilterMobile({ root: __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilterClass, "f") }), "f");
            }
            else if (__classPrivateFieldGet(this, _AutoPageMobile_routeResult, "f")) {
                __classPrivateFieldGet(this, _AutoPageMobile_routeResult, "f").clearFilteringData();
            }
            if (!__classPrivateFieldGet(this, _AutoPageMobile_routeResult, "f")) {
                __classPrivateFieldSet(this, _AutoPageMobile_routeResult, new App.AutoRouteResultMobile({
                    root: __classPrivateFieldGet(this, _AutoPageMobile_routeWrapClass, "f"),
                    hotFilter: __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f"),
                }), "f");
            }
            __classPrivateFieldGet(this, _AutoPageMobile_routeResult, "f").resetDataSource();
            yield __classPrivateFieldGet(this, _AutoPageMobile_routeResult, "f").changeDataSource(__classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f"));
            const paramsHotFilter = __classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_getParamsOfHotFilter).call(_a);
            __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f").refreshHotFilters(__classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f"), paramsHotFilter.map(s => ({ name: s.name, values: s.value.split(',') })));
            __classPrivateFieldGet(this, _AutoPageMobile_routeHotFilter, "f").routeHotFilter.trigger("filter:change" /* Events.FilterChange */);
        });
    }, _AutoPageMobile_initBookPageScripts = function _AutoPageMobile_initBookPageScripts() {
        return __awaiter(this, void 0, void 0, function* () {
            /*
            this.components.push(
                new ExistingPassengersMobile(),
                new FindTouristMobile(),
            );
            */
            App.ExistingPassengersMobile.Creates();
            App.FindTouristMobile.Creates();
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _AutoPageMobile_agentBlackListComponent, new App.AgentBlackListMobile(), "f");
                this.components.push(__classPrivateFieldGet(this, _AutoPageMobile_agentBlackListComponent, "f"));
            }
            __classPrivateFieldSet(this, _AutoPageMobile_bookFilters, new App.FilterMobile({
                root: '.js-form-order',
                onFilterChanged: v => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onBookFilterChanged).call(this, v),
            }), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_formBook, new App.Form({ root: __classPrivateFieldGet(this, _AutoPageMobile_bookFilters, "f").root }), "f");
            this.components.push(__classPrivateFieldGet(this, _AutoPageMobile_formBook, "f"));
            __classPrivateFieldSet(this, _AutoPageMobile_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AutoPageMobile_popup, "f")),
                validator: __classPrivateFieldGet(this, _AutoPageMobile_bookFilters, "f").validator, // this.#formBook.validator,
            }), "f");
            __classPrivateFieldSet(this, _AutoPageMobile_bookForm, $('.js-form-order', this.root), "f");
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_fillExtraServices).call(this);
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_recalcExtraServices).call(this);
            // $('.js-flightNumber', this.#bookForm).inputmask('flightnumber');
            $('.js-flightNumber .js-mobile-filter-value', __classPrivateFieldGet(this, _AutoPageMobile_bookForm, "f")).inputmask('flightnumber');
            // разлочить кнопку бронирования
            $('.form-btn', __classPrivateFieldGet(this, _AutoPageMobile_bookWrap, "f")).removeAttr('disabled');
            $('#allowBook', __classPrivateFieldGet(this, _AutoPageMobile_bookForm, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onAllowBookButtonClick).call(this); }));
        });
    }, _AutoPageMobile_onBookFilterChanged = function _AutoPageMobile_onBookFilterChanged(filterName) {
        return __awaiter(this, void 0, void 0, function* () {
            // если выбраны доп услуги - добавить стоимость доп услуг
            if (filterName.startsWith('Service.Extras')) {
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onExtraServisesChange).call(this);
            }
        });
    }, _AutoPageMobile_getRoutes = function _AutoPageMobile_getRoutes() {
        const routes = new Array();
        __classPrivateFieldGet(this, _AutoPageMobile_results, "f").forEach(value => {
            const el = routes.find(val => val.uniqueKey === value.uniqueKey);
            if (el) {
                el.count += value.items.length;
                el.grossPrice = Math.min(el.grossPrice, value.grossPrice);
                if (el.netPrice && value.netPrice)
                    el.netPrice = Math.min(el.netPrice, value.netPrice);
                if (el.price && value.price)
                    el.price = Math.min(el.price, value.price);
                if (value.pickup.airportId === -1) {
                    el.pickupPoints.push(value.pickup);
                }
                if (value.dropoff.airportId === -1) {
                    el.dropoffPoints.push(value.dropoff);
                }
            }
            else {
                const route = {
                    pickup: value.pickup,
                    dropoff: value.dropoff,
                    uniqueKey: value.uniqueKey,
                    countDays: value.countDays,
                    count: value.items.length,
                    currencyCode: value.currencyCode,
                    grossPrice: value.grossPrice,
                    url: value.url,
                    freeCancellation: value.freeCancellation,
                    pickupPoints: [value.pickup],
                    dropoffPoints: [value.dropoff],
                };
                if (value.price)
                    route.price = value.price;
                if (value.netPrice)
                    route.netPrice = value.netPrice;
                routes.push(route);
            }
        });
        routes.forEach(value => {
            value.countCars = App.formatMessage('auto/cars', { count: value.count });
            value.pickupPoints = Enumerable.from(value.pickupPoints).distinct().toArray();
            value.dropoffPoints = Enumerable.from(value.dropoffPoints).distinct().toArray();
        });
        __classPrivateFieldSet(this, _AutoPageMobile_routeResults, routes, "f");
    }, _AutoPageMobile_getCurrentRoute = function _AutoPageMobile_getCurrentRoute(routeNumber) {
        const route = __classPrivateFieldGet(this, _AutoPageMobile_routeResults, "f").find(value => routeNumber === value.uniqueKey);
        return route || {};
    }, _AutoPageMobile_getVehiclesByRoute = function _AutoPageMobile_getVehiclesByRoute() {
        let cars = new Array();
        __classPrivateFieldGet(this, _AutoPageMobile_results, "f").forEach(value => {
            if (value.uniqueKey === __classPrivateFieldGet(this, _AutoPageMobile_routeNumber, "f")) {
                value.items.forEach(car => {
                    car.pickup = value.pickup;
                    car.dropoff = value.dropoff;
                });
                cars = cars.concat(value.items);
            }
        });
        if (cars.length > 0)
            __classPrivateFieldSet(this, _AutoPageMobile_currentVehiclesByRoute, cars, "f");
    }, _AutoPageMobile_getCurrentVehicle = function _AutoPageMobile_getCurrentVehicle() {
        if (!__classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f"))
            return;
        const vehicle = __classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f").find(value => value.uniqueKey === __classPrivateFieldGet(this, _AutoPageMobile_offerNumber, "f"));
        if (vehicle)
            __classPrivateFieldSet(this, _AutoPageMobile_currentVehicle, vehicle, "f");
    }, _AutoPageMobile_getVehicle = function _AutoPageMobile_getVehicle(vehicleUniqueKey) {
        if (!__classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f"))
            return {};
        const vehicle = __classPrivateFieldGet(this, _AutoPageMobile_currentVehiclesByRoute, "f").find(value => value.uniqueKey === vehicleUniqueKey);
        return vehicle || {};
    }, _AutoPageMobile_getReserveKey = function _AutoPageMobile_getReserveKey() {
        if (__classPrivateFieldGet(this, _AutoPageMobile_reserveKey, "f") || !__classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f"))
            return;
        __classPrivateFieldSet(this, _AutoPageMobile_reserveKey, __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").key, "f");
    }, _AutoPageMobile_showMap = function _AutoPageMobile_showMap(target) {
        var _b;
        const key = (_b = $(target).parents('.js-auto-route-block,.digest-block-item,.js-auto-result-block').attr('data-key')) !== null && _b !== void 0 ? _b : '';
        const isPickupPart = $(target).hasClass('js-map-pickup');
        let points = {};
        // со страницы с результатов поиска
        const route = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getCurrentRoute).call(this, key);
        if (Object.keys(route).length > 0) {
            points = isPickupPart ? route.pickupPoints : route.dropoffPoints;
        }
        else {
            // со страницы маршрута
            const vehicle = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getVehicle).call(this, key);
            points = isPickupPart ? [vehicle.pickup] : [vehicle.dropoff];
        }
        // из корзины
        if (__classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f")) {
            points = isPickupPart ? [__classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").pickup] : [__classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").dropoff];
        }
        const ps = points.map(p => ({
            coordinate: p.coordinate,
            title: p.name,
            id: p.airportId,
        }));
        this.components.push(new App.SimpleGoogleMap(ps, $('.js-popup').find(`.${__classPrivateFieldGet(this, _AutoPageMobile_mapWrapClass, "f")}`)));
    }, _AutoPageMobile_searchRoutes = function _AutoPageMobile_searchRoutes(onlySearch, needHotFilterData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AutoPageMobile_searchExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _AutoPageMobile_searchExecuting, true, "f");
            if (__classPrivateFieldGet(this, _AutoPageMobile_expirationPopup, "f") != null)
                __classPrivateFieldGet(this, _AutoPageMobile_expirationPopup, "f").cancel();
            // TODO: че так долго было ждать (прелоадер еще не в разметке?)?
            // Если что - то еще важное грузилось, то все равно делать это под завесой загрузки
            // this.#preloader.show({ delay: 3000 });
            __classPrivateFieldGet(this, _AutoPageMobile_preloader, "f").show({ delay: 100 });
            if (!onlySearch)
                __classPrivateFieldGet(this, _AutoPageMobile_result, "f").resetDataSource();
            const data = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_prepareDataForSearch).call(this, needHotFilterData);
            if (__classPrivateFieldGet(this, _AutoPageMobile_context, "f"))
                data.context = __classPrivateFieldGet(this, _AutoPageMobile_context, "f");
            let returnS = false;
            __classPrivateFieldSet(this, _AutoPageMobile_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.searchRoutes,
                method: 'POST',
                data,
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _AutoPageMobile_searchXhr, "f");
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").process(response))
                    return false;
                if (!new App.SearchLocker().check(response.data))
                    return false;
                if (response.data.seo != null)
                    __classPrivateFieldGet(this, _AutoPageMobile_seo, "f")[__classPrivateFieldGet(this, _AutoPageMobile_state, "f")] = response.data.seo;
                if (!response.data.offers || response.data.offers.length <= 0) {
                    __classPrivateFieldGet(this, _AutoPageMobile_result, "f").resetDataSource();
                    return false;
                }
                __classPrivateFieldSet(this, _AutoPageMobile_results, response.data.offers, "f");
                __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getRoutes).call(this);
                __classPrivateFieldSet(this, _AutoPageMobile_expirationPopup, App.scheduleExpirationPopup({
                    interval: response.data.dataExpiration,
                    url: __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.searchRoutes,
                }), "f");
                if (!onlySearch) {
                    __classPrivateFieldGet(this, _AutoPageMobile_hotFilter, "f").refreshHotFilters(response.data.hotFilter);
                    yield __classPrivateFieldGet(this, _AutoPageMobile_result, "f").changeDataSource(__classPrivateFieldGet(this, _AutoPageMobile_routeResults, "f"));
                    // TODO Timoshkina: некорректное использование, данное событие должно инициироваться только в наследниках FilterBlockBase.
                    __classPrivateFieldGet(this, _AutoPageMobile_hotFilter, "f").hotFilter.trigger("filter:change" /* Events.FilterChange */);
                }
                returnS = true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _AutoPageMobile_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _AutoPageMobile_preloader, "f").hide();
            }
            return returnS;
        });
    }, _AutoPageMobile_getVehicleTerms = function _AutoPageMobile_getVehicleTerms(key, url) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: url,
                method: 'POST',
                data: { key },
            });
            try {
                const response = yield xhr;
                let term = 'Произошла ошибка. Попробуйте еще раз позднее.';
                let isDebit = false;
                let isCredit = false;
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").process(response)) {
                    if (response.status.messages && response.status.messages.length > 0)
                        term = response.status.messages[0].text;
                }
                else {
                    term = response.data.term;
                    const domNodes = jQuery.parseHTML(response.data.searchText);
                    let searchText = $(domNodes).find('h4').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dt').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dd').text();
                    if (searchText.includes('дебетов'))
                        isDebit = true;
                    if (searchText.includes('кредитн'))
                        isCredit = true;
                    if (response.data.isNeedCarDeposit)
                        isCredit = true;
                }
                const termContent = $(App.templates.VehicleTerms({ term, isDebit, isCredit }));
                $('.js-popup').find(`.${__classPrivateFieldGet(this, _AutoPageMobile_termWrapClass, "f")}`).empty().append(termContent);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _AutoPageMobile_reserveOffer = function _AutoPageMobile_reserveOffer() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = false;
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.reserveOffer,
                method: 'POST',
                data: { key: __classPrivateFieldGet(this, _AutoPageMobile_reserveKey, "f"), context: __classPrivateFieldGet(this, _AutoPageMobile_context, "f") },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").process(response))
                    return false;
                __classPrivateFieldSet(this, _AutoPageMobile_basketCode, response.data.basketCode, "f");
                __classPrivateFieldSet(this, _AutoPageMobile_providerKey, response.data.providerKey, "f");
                __classPrivateFieldSet(this, _AutoPageMobile_allowBooking, response.data.allowBooking, "f");
                Object.assign(__classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f"), response.data.offer);
                if (response.data.seo != null)
                    __classPrivateFieldGet(this, _AutoPageMobile_seo, "f")[__classPrivateFieldGet(this, _AutoPageMobile_state, "f")] = response.data.seo;
                result = true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            return result;
        });
    }, _AutoPageMobile_getExistingPassengers = function _AutoPageMobile_getExistingPassengers() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AutoPageMobile_passengers, undefined, "f");
            const age = __classPrivateFieldGet(this, _AutoPageMobile_queryParams, "f").param('driverage')[0];
            const pickupObj = __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").pickup.date;
            if (!pickupObj || !age)
                return;
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.getExistingPassengers,
                method: 'GET',
                data: {
                    context: __classPrivateFieldGet(this, _AutoPageMobile_context, "f"),
                    age,
                    pickupDate: pickupObj,
                },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldSet(this, _AutoPageMobile_passengers, response.data.existingPassengers, "f");
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _AutoPageMobile_book = function _AutoPageMobile_book() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_prepareDataForBook).call(this);
            if (__classPrivateFieldGet(this, _AutoPageMobile_context, "f"))
                data.context = __classPrivateFieldGet(this, _AutoPageMobile_context, "f");
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.book,
                method: 'POST',
                dataType: 'json',
                data,
            });
            const popupGroup = __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Auto.Messages.Booking({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").process(response))
                    return;
                return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").hide(popupGroup);
            }
        });
    }, _AutoPageMobile_fillExtraServices = function _AutoPageMobile_fillExtraServices() {
        __classPrivateFieldSet(this, _AutoPageMobile_extraServices, __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").vehicle.feeAtDeliveries.map(value => ({
            name: value.description,
            price: value.totalPrice,
            currency: value.currencyCode,
        })), "f");
    }, _AutoPageMobile_recalcExtraServices = function _AutoPageMobile_recalcExtraServices() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_updateExtraServiceDigest).call(this);
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_updateExtraServiceDigestPrice).call(this);
        });
    }, _AutoPageMobile_updateExtraServiceDigest = function _AutoPageMobile_updateExtraServiceDigest() {
        const servicesNamesBlock = $('.js-auto-extra-services-names', __classPrivateFieldGet(this, _AutoPageMobile_bookWrap, "f"));
        if (__classPrivateFieldGet(this, _AutoPageMobile_extraServices, "f").length === 0) {
            servicesNamesBlock.hideByClass();
            return;
        }
        // чистим весь дайджест
        $('.js-digest-extraServices-names', servicesNamesBlock).empty();
        const serviceBlocks = __classPrivateFieldGet(this, _AutoPageMobile_extraServices, "f").map(service => $(App.templates.Auto.Book.ExtraServiceBlockDigest({ service })));
        serviceBlocks.forEach(v => $('.js-digest-extraServices-names', servicesNamesBlock).append(v));
        _a.show(servicesNamesBlock);
        // Обновляем размеры дайджеста.
        $(document).trigger("digest:update" /* Events.DigestUpdate */);
    }, _AutoPageMobile_updateExtraServiceDigestPrice = function _AutoPageMobile_updateExtraServiceDigestPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            const containerFooter = $('.js-digest-footer', this.root);
            containerFooter.empty();
            const services = __classPrivateFieldGet(this, _AutoPageMobile_extraServices, "f").map(v => ({
                name: v.name,
                nameDetails: '',
                isBonus: false,
                grossPrice: v.price,
                discount: 0,
                price: v.price,
                currencyCode: v.currency,
            }));
            const data = {
                servicePrices: [],
                netPrice: typeof __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").netPrice !== 'undefined' ? __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").netPrice : undefined,
                grossPrice: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice,
                discount: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice - ((_b = __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").price) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice),
                price: (_c = __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").price) !== null && _c !== void 0 ? _c : __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").grossPrice,
                currencyCode: __classPrivateFieldGet(this, _AutoPageMobile_currentVehicle, "f").currencyCode,
                hasDetails: false,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _AutoPageMobile_pricePresenter, "f").type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                servicePayOnDeliveryPrices: services,
                notes: [],
            };
            const contentFooter = $(App.templates.BookDigestFooter(data));
            containerFooter.append(contentFooter);
            // Обновляем размеры дайджеста.
            $(document).trigger("digest:update" /* Events.DigestUpdate */);
        });
    }, _AutoPageMobile_focusFirstInvalidField = function _AutoPageMobile_focusFirstInvalidField() {
        const invalidField = __classPrivateFieldGet(this, _AutoPageMobile_bookForm, "f").find('._invalid').first();
        const position = invalidField.offset();
        $('html, body').animate({ scrollTop: position ? position.top : 0 }, 'slow');
        setTimeout(() => { invalidField.trigger('focus'); }, 1000);
    }, _AutoPageMobile_onHistoryStateChange = function _AutoPageMobile_onHistoryStateChange() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AutoPageMobile_state, App.History.getState(), "f");
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_run).call(this);
        });
    }, _AutoPageMobile_onMainFilterSearch = function _AutoPageMobile_onMainFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(_a, _a, "m", _AutoPageMobile_checkMainFilter).call(_a))
                return;
            // if (!this.#formMainFilter.validator.form())
            // return;
            if (!__classPrivateFieldGet(this, _AutoPageMobile_mainFilters, "f").validator.form())
                return;
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_cleanPage).call(this);
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderSearchResultsPage).call(this, false);
        });
    }, _AutoPageMobile_onOfferClick = function _AutoPageMobile_onOfferClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            event.preventDefault();
            // TODO: при клике на [data-href] - отменять дальнейшие события, там свой обработчик
            if ($(event.target).hasClass('js-show-terms') || $(event.target).hasClass('js-show-on-map'))
                return;
            __classPrivateFieldSet(this, _AutoPageMobile_reserveKey, (_b = $(event.currentTarget).attr('data-reserve-key')) !== null && _b !== void 0 ? _b : '', "f");
            __classPrivateFieldSet(this, _AutoPageMobile_offerNumber, (_c = $(event.currentTarget).attr('data-key')) !== null && _c !== void 0 ? _c : '', "f");
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_renderBookPage).call(this);
        });
    }, _AutoPageMobile_onAllowBookButtonClick = function _AutoPageMobile_onAllowBookButtonClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPageMobile_bookFilters, "f").validator.form()) {
                __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_focusFirstInvalidField).call(this);
                return;
            }
            if (__classPrivateFieldGet(this, _AutoPageMobile_options, "f").isAgentRF) {
                this.root.off('click', '#acceptBookAuto');
                const popupGroup = __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").show({
                    group: 'allowBook',
                    content: App.templates.Auto.Messages.AllowBook({}),
                });
                $('.js-auto-page').off('click', '#acceptBookAuto');
                $('.js-auto-page').on('click', '#acceptBookAuto', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_onBookButtonClick).call(this, e, popupGroup); }));
                $('.js-auto-page').on('click', '#declineBookAuto', () => __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").hide(popupGroup));
            }
            else {
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_book).call(this);
            }
        });
    }, _AutoPageMobile_onBookButtonClick = function _AutoPageMobile_onBookButtonClick(event, popupGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            const allowForm = new App.Form({ root: $('.js-allowBookAuto', '.js-auto-page') });
            if (!allowForm.validator.form())
                return;
            __classPrivateFieldGet(this, _AutoPageMobile_popup, "f").hide(popupGroup);
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _AutoPageMobile_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_book).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_book).call(this);
            }
        });
    }, _AutoPageMobile_onExtraServisesChange = function _AutoPageMobile_onExtraServisesChange() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_fillExtraServices).call(this);
            $('.js-order-extras').find('.table-row').each((index, row) => {
                var _b, _c;
                const rowFilterName = $(row).find('.js-extra-services-list').attr('data-name');
                const count = __classPrivateFieldGet(this, _AutoPageMobile_bookFilters, "f").filters.getControlListItem(rowFilterName).value;
                const currency = (_b = $('[name="' + rowFilterName + '"]').parents('label.table-row').attr('data-currency')) !== null && _b !== void 0 ? _b : '';
                if (count && count > 0) {
                    const price = Math.round(parseFloat((_c = $(row).attr('data-price')) !== null && _c !== void 0 ? _c : '0'));
                    const value = price * count;
                    const name = $(row).find('.insurance-data__name').html();
                    __classPrivateFieldGet(this, _AutoPageMobile_extraServices, "f").push({
                        name,
                        price: value,
                        currency,
                    });
                }
            });
            yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_recalcExtraServices).call(this);
        });
    }, _AutoPageMobile_onShowMapClick = function _AutoPageMobile_onShowMapClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _AutoPageMobile_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _AutoPageMobile_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _AutoPageMobile_mapWrapClass, "f")}"><div style="width: 100%; height: 100% !important; min-height: 600px;" class="js-auto-point-map"></div></div>`),
            onShowDelegate: () => __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_showMap).call(this, event.currentTarget),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _AutoPageMobile_onShowTermsClick = function _AutoPageMobile_onShowTermsClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _AutoPageMobile_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _AutoPageMobile_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _AutoPageMobile_termWrapClass, "f")}"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getVehicleTerms).call(this, (_b = $(event.currentTarget).attr('data-reserve-key')) !== null && _b !== void 0 ? _b : '', __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.getVehicleTerm); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _AutoPageMobile_onShowTermsSimpleClick = function _AutoPageMobile_onShowTermsSimpleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _AutoPageMobile_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _AutoPageMobile_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _AutoPageMobile_termWrapClass, "f")}"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _AutoPageMobile_instances, "m", _AutoPageMobile_getVehicleTerms).call(this, (_b = $(event.currentTarget).attr('href')) !== null && _b !== void 0 ? _b : '', __classPrivateFieldGet(this, _AutoPageMobile_options, "f").urls.getVehicleTermSimple); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _AutoPageMobile_onLinkClick = function _AutoPageMobile_onLinkClick(event) {
        var _b;
        event.preventDefault();
        event.stopPropagation();
        const link = (_b = $(event.currentTarget).attr('data-href')) !== null && _b !== void 0 ? _b : '';
        window.open(link);
        return false;
    };
    App.AutoPageMobile = AutoPageMobile;
})(App || (App = {}));
// TODO: при переходе через history сравнивать параметры в адресной строки текущие и предыдущие, если они разные - то грузить предыдущие результаты поиска
var App;
(function (App) {
    var _AutoPage_instances, _a, _AutoPage_options, _AutoPage_filter, _AutoPage_hotFilter, _AutoPage_result, _AutoPage_routeHotFilter, _AutoPage_routeResult, _AutoPage_preloader, _AutoPage_queryParams, _AutoPage_formMainFilter, _AutoPage_formBook, _AutoPage_popup, _AutoPage_popupInfo, _AutoPage_validator, _AutoPage_responseValidator, _AutoPage_searchExecuting, _AutoPage_expirationPopup, _AutoPage_context, _AutoPage_searchResultsWrapClass, _AutoPage_searchResultsHotFilterClass, _AutoPage_searchResultsWrap, _AutoPage_routeWrapClass, _AutoPage_routeHotFilterClass, _AutoPage_routeWrap, _AutoPage_resultBlocksWrap, _AutoPage_resultTableWrap, _AutoPage_resultElement, _AutoPage_bookWrapClass, _AutoPage_bookWrap, _AutoPage_bookForm, _AutoPage_header, _AutoPage_mapWrapClass, _AutoPage_termWrapClass, _AutoPage_states, _AutoPage_state, _AutoPage_seo, _AutoPage_results, _AutoPage_routeResults, _AutoPage_currentVehiclesByRoute, _AutoPage_currentVehicle, _AutoPage_routeNumber, _AutoPage_offerNumber, _AutoPage_reserveKey, _AutoPage_basketCode, _AutoPage_providerKey, _AutoPage_allowBooking, _AutoPage_passengers, _AutoPage_extraServices, _AutoPage_searchXhr, _AutoPage_pricePresenter, _AutoPage_agentBlackListComponent, _AutoPage_run, _AutoPage_cleanPage, _AutoPage_setHeader, _AutoPage_updateSeo, _AutoPage_showSearchPage, _AutoPage_showSearchResultsPage, _AutoPage_renderSearchResultsPage, _AutoPage_showSearchResults, _AutoPage_renderSearchResults, _AutoPage_showRoutePage, _AutoPage_renderRoutePage, _AutoPage_showRoutes, _AutoPage_renderRoutes, _AutoPage_showBookPage, _AutoPage_renderBookPage, _AutoPage_showBook, _AutoPage_renderBook, _AutoPage_saveState, _AutoPage_formatTime, _AutoPage_formatDate, _AutoPage_checkMainFilter, _AutoPage_getParamsFromFilters, _AutoPage_getParamsFromSortBlock, _AutoPage_getParamsFromSearchBlock, _AutoPage_getParamsOfSelectElementByFilter, _AutoPage_getParamsOfInputElementByFilter, _AutoPage_getParamsForBook, _AutoPage_getValidateAttributes, _AutoPage_getBirthdayValidateAttrs, _AutoPage_getBookContentDigest, _AutoPage_getBookContentMainBlock, _AutoPage_getParamsOfHotFilter, _AutoPage_prepareDataForSearch, _AutoPage_prepareDataForBook, _AutoPage_initRoutePageScripts, _AutoPage_initBookPageScripts, _AutoPage_getRoutes, _AutoPage_getCurrentRoute, _AutoPage_getVehiclesByRoute, _AutoPage_getCurrentVehicle, _AutoPage_getVehicle, _AutoPage_getReserveKey, _AutoPage_showMap, _AutoPage_searchRoutes, _AutoPage_getVehicleTerms, _AutoPage_reserveOffer, _AutoPage_getExistingPassengers, _AutoPage_book, _AutoPage_fillExtraServices, _AutoPage_recalcExtraServices, _AutoPage_updateExtraServiceDigest, _AutoPage_updateExtraServiceDigestPrice, _AutoPage_focusFirstInvalidField, _AutoPage_onHistoryStateChange, _AutoPage_onMainFilterSearch, _AutoPage_onOfferClick, _AutoPage_onAllowBookButtonClick, _AutoPage_onBookButtonClick, _AutoPage_onFioChange, _AutoPage_onGenderSliderClick, _AutoPage_onExtraServisesChange, _AutoPage_onShowMapClick, _AutoPage_onShowTermsClick, _AutoPage_onShowTermsSimpleClick, _AutoPage_onLinkClick;
    class AutoPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: `.js-auto-page .${App.Application.defaults.appContainerContentClass}` }, options));
            _AutoPage_instances.add(this);
            _AutoPage_options.set(this, void 0);
            _AutoPage_filter.set(this, void 0);
            _AutoPage_hotFilter.set(this, void 0);
            _AutoPage_result.set(this, void 0);
            _AutoPage_routeHotFilter.set(this, void 0);
            _AutoPage_routeResult.set(this, void 0);
            _AutoPage_preloader.set(this, void 0);
            _AutoPage_queryParams.set(this, void 0);
            _AutoPage_formMainFilter.set(this, void 0);
            _AutoPage_formBook.set(this, void 0);
            _AutoPage_popup.set(this, void 0);
            _AutoPage_popupInfo.set(this, void 0);
            _AutoPage_validator.set(this, void 0);
            _AutoPage_responseValidator.set(this, void 0);
            _AutoPage_searchExecuting.set(this, false);
            _AutoPage_expirationPopup.set(this, void 0);
            _AutoPage_context.set(this, void 0);
            // Элементы страницы
            _AutoPage_searchResultsWrapClass.set(this, void 0);
            _AutoPage_searchResultsHotFilterClass.set(this, void 0);
            // обертка для результатов поиска и вторичного фильтра
            _AutoPage_searchResultsWrap.set(this, void 0);
            // обертка для результатов поиска в блочном виде и табличном
            _AutoPage_routeWrapClass.set(this, void 0);
            _AutoPage_routeHotFilterClass.set(this, void 0);
            _AutoPage_routeWrap.set(this, void 0);
            // обертка для описания круиза
            _AutoPage_resultBlocksWrap.set(this, void 0);
            _AutoPage_resultTableWrap.set(this, void 0);
            _AutoPage_resultElement.set(this, void 0);
            _AutoPage_bookWrapClass.set(this, void 0);
            _AutoPage_bookWrap.set(this, void 0);
            // обертка для бронирования круиза
            _AutoPage_bookForm.set(this, void 0);
            _AutoPage_header.set(this, void 0);
            _AutoPage_mapWrapClass.set(this, void 0);
            _AutoPage_termWrapClass.set(this, void 0);
            // состояния
            _AutoPage_states.set(this, void 0);
            _AutoPage_state.set(this, void 0);
            _AutoPage_seo.set(this, void 0);
            // результаты
            _AutoPage_results.set(this, void 0);
            _AutoPage_routeResults.set(this, void 0);
            _AutoPage_currentVehiclesByRoute.set(this, void 0);
            _AutoPage_currentVehicle.set(this, void 0);
            _AutoPage_routeNumber.set(this, void 0);
            _AutoPage_offerNumber.set(this, void 0);
            _AutoPage_reserveKey.set(this, void 0);
            _AutoPage_basketCode.set(this, void 0);
            _AutoPage_providerKey.set(this, void 0);
            _AutoPage_allowBooking.set(this, void 0);
            _AutoPage_passengers.set(this, void 0);
            _AutoPage_extraServices.set(this, void 0);
            _AutoPage_searchXhr.set(this, void 0);
            _AutoPage_pricePresenter.set(this, void 0);
            _AutoPage_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _AutoPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AutoPage_searchResultsWrapClass, '.js-auto-search-results', "f");
            __classPrivateFieldSet(this, _AutoPage_searchResultsHotFilterClass, '.js-auto-search-results .js-auto-hot-filter', "f");
            __classPrivateFieldSet(this, _AutoPage_routeWrapClass, '.js-auto-route', "f");
            __classPrivateFieldSet(this, _AutoPage_routeHotFilterClass, '.js-auto-route .js-auto-route-hot-filter', "f");
            __classPrivateFieldSet(this, _AutoPage_bookWrapClass, '.js-auto-book', "f");
            __classPrivateFieldSet(this, _AutoPage_queryParams, new App.QueryParams(window.location.pathname), "f");
            __classPrivateFieldSet(this, _AutoPage_context, __classPrivateFieldGet(this, _AutoPage_queryParams, "f").getContext(), "f");
            __classPrivateFieldSet(this, _AutoPage_preloader, new App.Preloader(), "f");
            __classPrivateFieldSet(this, _AutoPage_seo, {}, "f");
            __classPrivateFieldSet(this, _AutoPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AutoPage_header, $('.js-header', this.root), "f");
            __classPrivateFieldSet(this, _AutoPage_mapWrapClass, 'js-auto-point-map-wrap', "f");
            __classPrivateFieldSet(this, _AutoPage_termWrapClass, 'js-auto-terms-wrap', "f");
            __classPrivateFieldSet(this, _AutoPage_searchResultsWrap, $(__classPrivateFieldGet(this, _AutoPage_searchResultsWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _AutoPage_routeWrap, $(__classPrivateFieldGet(this, _AutoPage_routeWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _AutoPage_resultBlocksWrap, $('.js-tours-output-block', __classPrivateFieldGet(this, _AutoPage_routeWrap, "f")), "f");
            __classPrivateFieldSet(this, _AutoPage_resultTableWrap, $('.js-tours-output-table', __classPrivateFieldGet(this, _AutoPage_routeWrap, "f")), "f");
            __classPrivateFieldSet(this, _AutoPage_resultElement, '.js-result-item', "f");
            __classPrivateFieldSet(this, _AutoPage_bookWrap, $(__classPrivateFieldGet(this, _AutoPage_bookWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _AutoPage_bookForm, $('.js-form-order', this.root), "f");
            __classPrivateFieldSet(this, _AutoPage_routeNumber, $('#routeNumber').valString(), "f");
            __classPrivateFieldSet(this, _AutoPage_offerNumber, $('#offerNumber').valString(), "f");
            __classPrivateFieldSet(this, _AutoPage_states, {
                'search': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showSearchPage).call(this))),
                    actionName: 'search',
                },
                'search_results': {
                    handler: () => __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showSearchResultsPage).call(this),
                    actionName: 'search',
                },
                'route': {
                    handler: () => __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showRoutePage).call(this),
                    actionName: 'route',
                },
                'book': {
                    handler: () => __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showBookPage).call(this),
                    actionName: 'book',
                },
            }, "f");
            __classPrivateFieldSet(this, _AutoPage_state, $('input[name="state"]', this.root).valString(), "f");
            const pickupDateLimit = __classPrivateFieldGet(this, _AutoPage_options, "f").pickupDateLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _AutoPage_options, "f").pickupDateLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _AutoPage_options, "f").pickupDateLimit.max) };
            __classPrivateFieldSet(this, _AutoPage_filter, new App.AutoMainFilter({
                root: '.js-auto-main-filter',
                urls: __classPrivateFieldGet(this, _AutoPage_options, "f").urls,
                defaults: __classPrivateFieldGet(this, _AutoPage_options, "f").defaults,
                datesOptions: {
                    minDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.min,
                    maxDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.max,
                    minDateFromShift: __classPrivateFieldGet(this, _AutoPage_options, "f").defaults.minPickupDateShift,
                    defaultDateFromShift: __classPrivateFieldGet(this, _AutoPage_options, "f").defaults.defaultPickupDateShift,
                    minDateToOffset: __classPrivateFieldGet(this, _AutoPage_options, "f").defaults.minDropoffDateOffset,
                    defaultDateToOffset: __classPrivateFieldGet(this, _AutoPage_options, "f").defaults.defaultDropoffDateOffset,
                    maxDateToOffset: __classPrivateFieldGet(this, _AutoPage_options, "f").defaults.maxDropoffDateOffset,
                },
            }), "f");
            __classPrivateFieldSet(this, _AutoPage_formMainFilter, new App.Form({ root: __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter }), "f");
            __classPrivateFieldSet(this, _AutoPage_validator, __classPrivateFieldGet(this, _AutoPage_filter, "f").root.validate({ ignore: '' }), "f");
            __classPrivateFieldSet(this, _AutoPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.BlockMessenger(new App.Messages()),
                validator: __classPrivateFieldGet(this, _AutoPage_validator, "f"),
            }), "f");
            __classPrivateFieldSet(this, _AutoPage_hotFilter, new App.AutoHotFilter({
                root: __classPrivateFieldGet(this, _AutoPage_searchResultsHotFilterClass, "f"),
            }), "f");
            __classPrivateFieldSet(this, _AutoPage_result, new App.AutoResult({
                root: __classPrivateFieldGet(this, _AutoPage_searchResultsWrapClass, "f"),
                hotFilter: __classPrivateFieldGet(this, _AutoPage_hotFilter, "f"),
            }), "f");
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onHistoryStateChange).call(this); }));
            __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onMainFilterSearch).call(this); }));
            // Прокрутка якорных ссылок
            this.root.on('click', '.js-scroll-to', e => App.scrollLinkClickHandler(e));
            // Читать полностью
            this.root.on('click', '.js-read-more', e => App.readMoreClickHandler(e));
            // открытие ссылок внутри блоков (ссылок)
            this.root.on('click', '[data-href]', e => __classPrivateFieldGet(_a, _a, "m", _AutoPage_onLinkClick).call(_a, e));
            // показать на карте
            this.root.on('click', '.js-show-on-map', (e) => __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onShowMapClick).call(this, e));
            // показать условия аренды
            this.root.on('click', '.js-show-terms', e => __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onShowTermsClick).call(this, e));
            this.root.on('click', '.js-show-terms-simple', e => __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onShowTermsSimpleClick).call(this, e));
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _AutoPage_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            App.History.replaceState(__classPrivateFieldGet(this, _AutoPage_state, "f"), __classPrivateFieldGet(this, _AutoPage_queryParams, "f").getUrl());
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_run).call(this); }))();
        }
        // typeTopScroll: 1 - body, 2 - сам элемент jqObj
        static show(jqObj, scrollTop, typeTopScroll) {
            jqObj.showByClass();
            if (jqObj && scrollTop) {
                const scrollObj = typeTopScroll === 1 ? $('body') : jqObj;
                const scrollObjOffset = scrollObj.offset();
                $('html, body').animate({ scrollTop: (scrollObjOffset != null ? scrollObjOffset.top : 0) }, 'slow');
            }
        }
    }
    _a = AutoPage, _AutoPage_options = new WeakMap(), _AutoPage_filter = new WeakMap(), _AutoPage_hotFilter = new WeakMap(), _AutoPage_result = new WeakMap(), _AutoPage_routeHotFilter = new WeakMap(), _AutoPage_routeResult = new WeakMap(), _AutoPage_preloader = new WeakMap(), _AutoPage_queryParams = new WeakMap(), _AutoPage_formMainFilter = new WeakMap(), _AutoPage_formBook = new WeakMap(), _AutoPage_popup = new WeakMap(), _AutoPage_popupInfo = new WeakMap(), _AutoPage_validator = new WeakMap(), _AutoPage_responseValidator = new WeakMap(), _AutoPage_searchExecuting = new WeakMap(), _AutoPage_expirationPopup = new WeakMap(), _AutoPage_context = new WeakMap(), _AutoPage_searchResultsWrapClass = new WeakMap(), _AutoPage_searchResultsHotFilterClass = new WeakMap(), _AutoPage_searchResultsWrap = new WeakMap(), _AutoPage_routeWrapClass = new WeakMap(), _AutoPage_routeHotFilterClass = new WeakMap(), _AutoPage_routeWrap = new WeakMap(), _AutoPage_resultBlocksWrap = new WeakMap(), _AutoPage_resultTableWrap = new WeakMap(), _AutoPage_resultElement = new WeakMap(), _AutoPage_bookWrapClass = new WeakMap(), _AutoPage_bookWrap = new WeakMap(), _AutoPage_bookForm = new WeakMap(), _AutoPage_header = new WeakMap(), _AutoPage_mapWrapClass = new WeakMap(), _AutoPage_termWrapClass = new WeakMap(), _AutoPage_states = new WeakMap(), _AutoPage_state = new WeakMap(), _AutoPage_seo = new WeakMap(), _AutoPage_results = new WeakMap(), _AutoPage_routeResults = new WeakMap(), _AutoPage_currentVehiclesByRoute = new WeakMap(), _AutoPage_currentVehicle = new WeakMap(), _AutoPage_routeNumber = new WeakMap(), _AutoPage_offerNumber = new WeakMap(), _AutoPage_reserveKey = new WeakMap(), _AutoPage_basketCode = new WeakMap(), _AutoPage_providerKey = new WeakMap(), _AutoPage_allowBooking = new WeakMap(), _AutoPage_passengers = new WeakMap(), _AutoPage_extraServices = new WeakMap(), _AutoPage_searchXhr = new WeakMap(), _AutoPage_pricePresenter = new WeakMap(), _AutoPage_agentBlackListComponent = new WeakMap(), _AutoPage_instances = new WeakSet(), _AutoPage_run = function _AutoPage_run() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_cleanPage).call(this);
            yield __classPrivateFieldGet(this, _AutoPage_states, "f")[__classPrivateFieldGet(this, _AutoPage_state, "f")].handler();
        });
    }, _AutoPage_cleanPage = function _AutoPage_cleanPage() {
        __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.hideByClass();
        __classPrivateFieldGet(this, _AutoPage_searchResultsWrap, "f").hideByClass();
        __classPrivateFieldGet(this, _AutoPage_routeWrap, "f").hideByClass();
        __classPrivateFieldGet(this, _AutoPage_bookWrap, "f").hideByClass();
    }, _AutoPage_setHeader = function _AutoPage_setHeader(header) {
        __classPrivateFieldGet(this, _AutoPage_header, "f").html(header);
    }, _AutoPage_updateSeo = function _AutoPage_updateSeo(seoInfo) {
        App.app.seo.update(seoInfo);
    }, _AutoPage_showSearchPage = function _AutoPage_showSearchPage() {
        _a.show(__classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter, true, 1);
    }, _AutoPage_showSearchResultsPage = function _AutoPage_showSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: если поиска маршрутов не было или результаты поиска отличаются от формы => новый поиск
            if (!__classPrivateFieldGet(this, _AutoPage_results, "f"))
                yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderSearchResultsPage).call(this, true);
            else
                __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showSearchResults).call(this);
        });
    }, _AutoPage_renderSearchResultsPage = function _AutoPage_renderSearchResultsPage(needHotFilterData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPage_validator, "f").form())
                return;
            _a.show(__classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter, true, 1);
            if (!(yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_searchRoutes).call(this, false, needHotFilterData)))
                return;
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderSearchResults).call(this);
            let isStateReplace = false;
            if (__classPrivateFieldGet(this, _AutoPage_state, "f") !== 'search')
                isStateReplace = true;
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_saveState).call(this, 'search_results', __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsFromFilters).call(this, __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter, __classPrivateFieldGet(this, _AutoPage_hotFilter, "f") ? __classPrivateFieldGet(this, _AutoPage_hotFilter, "f").hotFilter : $()), null, isStateReplace);
        });
    }, _AutoPage_showSearchResults = function _AutoPage_showSearchResults() {
        _a.show(__classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter, true, 1);
        _a.show(__classPrivateFieldGet(this, _AutoPage_searchResultsWrap, "f"));
        __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_updateSeo).call(this, __classPrivateFieldGet(this, _AutoPage_seo, "f")[__classPrivateFieldGet(this, _AutoPage_state, "f")]);
        // Скролл к результатам поиска
        setTimeout(() => {
            const scrollOffset = __classPrivateFieldGet(this, _AutoPage_searchResultsWrap, "f").offset();
            if (scrollOffset) {
                $('html, body').stop(true, true);
                window.scrollTo(0, scrollOffset.top);
            }
        }, 700);
    }, _AutoPage_renderSearchResults = function _AutoPage_renderSearchResults() {
        __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showSearchResults).call(this);
    }, _AutoPage_showRoutePage = function _AutoPage_showRoutePage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AutoPage_results, "f") && __classPrivateFieldGet(this, _AutoPage_results, "f").length !== 0)
                __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showRoutes).call(this);
            else
                yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderRoutePage).call(this);
        });
    }, _AutoPage_renderRoutePage = function _AutoPage_renderRoutePage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPage_validator, "f").form())
                return;
            if (!(yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_searchRoutes).call(this, true, false)))
                return;
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderRoutes).call(this);
        });
    }, _AutoPage_showRoutes = function _AutoPage_showRoutes() {
        _a.show(__classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter, true, 1);
        _a.show(__classPrivateFieldGet(this, _AutoPage_routeWrap, "f"), true, 1);
        __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_updateSeo).call(this, __classPrivateFieldGet(this, _AutoPage_seo, "f")[__classPrivateFieldGet(this, _AutoPage_state, "f")]);
    }, _AutoPage_renderRoutes = function _AutoPage_renderRoutes() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getVehiclesByRoute).call(this);
            // отписываемся, иначе будут дубли онклик
            __classPrivateFieldGet(this, _AutoPage_resultBlocksWrap, "f").off('click', __classPrivateFieldGet(this, _AutoPage_resultElement, "f"));
            __classPrivateFieldGet(this, _AutoPage_resultTableWrap, "f").off('click', __classPrivateFieldGet(this, _AutoPage_resultElement, "f"));
            __classPrivateFieldGet(this, _AutoPage_searchResultsWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showRoutes).call(this);
            // подписываемся
            __classPrivateFieldGet(this, _AutoPage_resultBlocksWrap, "f").on('click', __classPrivateFieldGet(this, _AutoPage_resultElement, "f"), (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onOfferClick).call(this, e); }));
            __classPrivateFieldGet(this, _AutoPage_resultTableWrap, "f").on('click', __classPrivateFieldGet(this, _AutoPage_resultElement, "f"), (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onOfferClick).call(this, e); }));
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_initRoutePageScripts).call(this);
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_saveState).call(this, 'route', __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsFromFilters).call(this, __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter, __classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f") ? __classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f").routeHotFilter : $()), null, false);
        });
    }, _AutoPage_showBookPage = function _AutoPage_showBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f"))
                __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showBook).call(this);
            else if (yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_searchRoutes).call(this, true, false))
                yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderBookPage).call(this);
        });
    }, _AutoPage_renderBookPage = function _AutoPage_renderBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getVehiclesByRoute).call(this);
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getCurrentVehicle).call(this);
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getReserveKey).call(this);
            const queryParams = new App.QueryParams(window.location.pathname);
            queryParams.clear();
            if (!__classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f") || !__classPrivateFieldGet(this, _AutoPage_currentVehicle, "f") || !__classPrivateFieldGet(this, _AutoPage_reserveKey, "f")) {
                const mes = new App.Messages();
                queryParams.setAction('route');
                queryParams.add('', [__classPrivateFieldGet(this, _AutoPage_routeNumber, "f").toString()]);
                const add = __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.length > 0
                    ? __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsFromFilters).call(this, __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter, __classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f") ? __classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f").routeHotFilter : $())
                    : __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsForBook).call(this);
                Object.getOwnPropertyNames(add).forEach(param => {
                    queryParams.add(param, add[param]);
                });
                const url = queryParams.getUrl();
                mes.show({ type: 0 /* MessageType.Information */, text: `Данное предложение не найдено. Попробуйте <a href="${url}">новый поиск</a>.` });
                return;
            }
            const messenger = new App.PopupMessenger(__classPrivateFieldGet(this, _AutoPage_popup, "f"));
            __classPrivateFieldSet(this, _AutoPage_responseValidator, new App.ResponseValidatorOld({ messenger, validator: __classPrivateFieldGet(this, _AutoPage_validator, "f") }), "f");
            const popupGroup = __classPrivateFieldGet(this, _AutoPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Valuating({}),
                modal: true,
            });
            if (!(yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_reserveOffer).call(this))) {
                __classPrivateFieldGet(this, _AutoPage_popup, "f").hide(popupGroup);
                return;
            }
            __classPrivateFieldSet(this, _AutoPage_expirationPopup, App.scheduleExpirationPopup({
                interval: App.app.settings.relevantResultTime,
                url: __classPrivateFieldGet(this, _AutoPage_options, "f").urls.searchRoutes,
            }), "f");
            if (__classPrivateFieldGet(this, _AutoPage_context, "f"))
                yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getExistingPassengers).call(this);
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderBook).call(this);
            __classPrivateFieldGet(this, _AutoPage_popup, "f").hide(popupGroup);
            App.History.saveState('book', __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").url);
        });
    }, _AutoPage_showBook = function _AutoPage_showBook() {
        _a.show(__classPrivateFieldGet(this, _AutoPage_bookWrap, "f"), true, 1);
        __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_setHeader).call(this, __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").vehicle.name);
    }, _AutoPage_renderBook = function _AutoPage_renderBook() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.hideByClass();
            __classPrivateFieldGet(this, _AutoPage_searchResultsWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _AutoPage_routeWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showBook).call(this);
            $('.main-block__left-col', __classPrivateFieldGet(this, _AutoPage_bookWrap, "f")).empty();
            $('.main-block__right-col', __classPrivateFieldGet(this, _AutoPage_bookWrap, "f")).empty();
            __classPrivateFieldSet(this, _AutoPage_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
            const currentRouteEl = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getCurrentRoute).call(this, __classPrivateFieldGet(this, _AutoPage_routeNumber, "f"));
            const digest = yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getBookContentDigest).call(this, currentRouteEl);
            const mainBookBlock = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getBookContentMainBlock).call(this, currentRouteEl);
            $('.main-block__left-col', __classPrivateFieldGet(this, _AutoPage_bookWrap, "f")).append([digest]);
            $('.main-block__right-col', __classPrivateFieldGet(this, _AutoPage_bookWrap, "f")).append(mainBookBlock);
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_initBookPageScripts).call(this);
        });
    }, _AutoPage_saveState = function _AutoPage_saveState(state, add, replace, isReplace = false) {
        __classPrivateFieldSet(this, _AutoPage_state, state, "f");
        const queryParams = new App.QueryParams(window.location.pathname);
        queryParams.clear();
        queryParams.setAction(__classPrivateFieldGet(this, _AutoPage_states, "f")[__classPrivateFieldGet(this, _AutoPage_state, "f")].actionName);
        if (add) {
            Object.getOwnPropertyNames(add).forEach(param => {
                queryParams.add(param, add[param]);
            });
        }
        if (replace) {
            Object.getOwnPropertyNames(replace).forEach(param => {
                queryParams.replace(param, replace[param]);
            });
        }
        const url = queryParams.getUrl();
        if (isReplace)
            App.History.replaceState(__classPrivateFieldGet(this, _AutoPage_state, "f"), url, true);
        else
            App.History.saveState(__classPrivateFieldGet(this, _AutoPage_state, "f"), url);
    }, _AutoPage_formatTime = function _AutoPage_formatTime(time) {
        // 12:00:00 -> 1200
        const timeParts = time.split(':');
        return timeParts[0] + timeParts[1];
    }, _AutoPage_formatDate = function _AutoPage_formatDate(date) {
        // 25.03.2017 -> 20170325 - Russian
        const dateParts = date.split('.');
        return dateParts[2] + dateParts[1] + dateParts[0];
    }, _AutoPage_checkMainFilter = function _AutoPage_checkMainFilter() {
        return true;
    }, _AutoPage_getParamsFromFilters = function _AutoPage_getParamsFromFilters(filter, hotFilter) {
        const params = {};
        let filterParams = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsFromSearchBlock).call(this, filter);
        const hotFilterParams = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsFromSearchBlock).call(this, hotFilter);
        filterParams = filterParams.concat(hotFilterParams);
        filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _AutoPage_getParamsFromSortBlock).call(_a, hotFilter));
        filterParams.forEach(value => {
            params[value.key] = value.value;
        });
        return params;
    }, _AutoPage_getParamsFromSortBlock = function _AutoPage_getParamsFromSortBlock(filter) {
        var _b;
        const params = [];
        const sortValue = (_b = $('.js-sort-item._active', filter).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
        params.push({ key: 'sort', value: [sortValue] });
        return params;
    }, _AutoPage_getParamsFromSearchBlock = function _AutoPage_getParamsFromSearchBlock(filter) {
        const params = [];
        filter.find('.filter-block').each((index, element) => {
            var _b, _c, _d;
            let key = ((_b = $(element).attr('data-key')) !== null && _b !== void 0 ? _b : '').toLowerCase();
            const name = (_c = $(element).attr('data-name')) !== null && _c !== void 0 ? _c : '';
            const select = (_d = $(element).attr('data-select')) !== null && _d !== void 0 ? _d : '';
            let value = [];
            if (select.length > 0) {
                if (key === '')
                    key = select.toLowerCase();
                value = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsOfSelectElementByFilter).call(this, element);
            }
            else if (name.length > 0) {
                if (key === '')
                    key = name.toLowerCase();
                value = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getParamsOfInputElementByFilter).call(this, element);
            }
            if (key.length > 0 && value.length > 0) {
                const existKey = params.findIndex(el => el.key === key);
                if (existKey !== -1)
                    params[existKey].value = params[existKey].value.concat(value);
                else
                    params.push({ key, value });
            }
        });
        return params;
    }, _AutoPage_getParamsOfSelectElementByFilter = function _AutoPage_getParamsOfSelectElementByFilter(el) {
        const values = [];
        $(el).find('.js-filter-option._active').each((index, element) => {
            const value = $(element).attr('data-val') || '';
            if (value.length > 0 && value !== '0')
                values.push(value.toString());
        });
        return values;
    }, _AutoPage_getParamsOfInputElementByFilter = function _AutoPage_getParamsOfInputElementByFilter(el) {
        const values = [];
        $(el).find('input').each((index, element) => {
            if ($(element).hasClass('js-not_for_filter'))
                return;
            let value = $(element).valString().toLowerCase();
            if ($(el).hasClass('js-filter-dates-block'))
                value = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_formatDate).call(this, value);
            if ($(el).hasClass('js-filter-time-block'))
                value = __classPrivateFieldGet(_a, _a, "m", _AutoPage_formatTime).call(_a, value);
            if (value)
                values.push(value.toString());
        });
        return values;
    }, _AutoPage_getParamsForBook = function _AutoPage_getParamsForBook() {
        const params = [];
        __classPrivateFieldGet(this, _AutoPage_options, "f").searchData.forEach(val => {
            let key = val.name;
            if (key === 'state' || key.includes('SameDropoff'))
                return true;
            let value = val.value.toLowerCase();
            if (key.includes('Date'))
                value = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_formatDate).call(this, value);
            if (key.includes('Time'))
                value = __classPrivateFieldGet(_a, _a, "m", _AutoPage_formatTime).call(_a, value);
            if (value === '0')
                return true;
            if (key.includes('.'))
                key = key.substring(0, key.indexOf('.'));
            const values = [value];
            if (key.length > 0 && values.length > 0) {
                const existKey = params.findIndex(el => el.key === key);
                if (existKey !== -1)
                    params[existKey].value = params[existKey].value.concat(values);
                else
                    params.push({ key, value: values });
            }
            return true;
        });
        const p = {};
        params.forEach(value => {
            p[value.key.toLowerCase()] = value.value;
        });
        return p;
    }, _AutoPage_getValidateAttributes = function _AutoPage_getValidateAttributes(currentRouteEl) {
        const attributes = {};
        attributes.birthdayAttributes = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getBirthdayValidateAttrs).call(this, currentRouteEl);
        return attributes;
    }, _AutoPage_getBirthdayValidateAttrs = function _AutoPage_getBirthdayValidateAttrs(currentRouteEl) {
        const date = new Date(currentRouteEl.pickup.date);
        date.setHours(23, 0, 0, 0);
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const currentDriverAge = Number(__classPrivateFieldGet(this, _AutoPage_queryParams, "f").param('driverage')[0]);
        const minBirthDay = new Date(year - currentDriverAge - 1, month, day - 1);
        // тут new Date(year, month, day) время не устанавливается (т.е. равно 0), toISOString применяет часовой пояс => дата после
        // преобразования получается на 1 день меньше нужной, поэтому тут вычитаю смещение часовй пояса, а потом уже toISOString
        // TODO Titov: потенциальная ошибка, нельзя использовать getTimezoneOffset на клиенте, исправить!
        let tzoffset = minBirthDay.getTimezoneOffset() * 60000; // offset in milliseconds
        const minBirthDayString = (new Date(minBirthDay.getTime() - tzoffset)).toISOString().slice(0, 10);
        const maxBirthDay = new Date(year - currentDriverAge, month, day);
        // тут new Date(year, month, day) время не устанавливается (т.е. равно 0), toISOString применяет часовой пояс => дата после
        // преобразования получается на 1 день меньше нужной, поэтому тут вычитаю смещение часовй пояса, а потом уже toISOString
        // TODO Titov: потенциальная ошибка, нельзя использовать getTimezoneOffset на клиенте, исправить!
        tzoffset = maxBirthDay.getTimezoneOffset() * 60000; // offset in milliseconds
        const maxBirthDayString = (new Date(maxBirthDay.getTime() - tzoffset)).toISOString().slice(0, 10);
        return `data-rule-dateiso="true" data-rule-datemax="${maxBirthDayString}" data-rule-datemin="${minBirthDayString}"`;
    }, _AutoPage_getBookContentDigest = function _AutoPage_getBookContentDigest(currentRouteEl) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            return $(App.templates.Auto.Book.BlockDigest({
                vehicle: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f"),
                currentRoute: currentRouteEl,
                bookDigestData: {
                    servicePrices: [],
                    netPrice: typeof __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").netPrice !== 'undefined' ? __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").netPrice : undefined,
                    grossPrice: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice,
                    discount: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice - ((_b = __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").price) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice),
                    price: (_c = __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").price) !== null && _c !== void 0 ? _c : __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice,
                    currencyCode: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").currencyCode,
                    hasDetails: false,
                    pricePresenter: {
                        type: __classPrivateFieldGet(this, _AutoPage_pricePresenter, "f").type,
                        show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                    },
                    notes: [],
                },
            }));
        });
    }, _AutoPage_getBookContentMainBlock = function _AutoPage_getBookContentMainBlock(currentRouteEl) {
        const attributes = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getValidateAttributes).call(this, currentRouteEl);
        return $(App.templates.Auto.Book.BlockMain({
            vehicle: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f"),
            existingPassengers: __classPrivateFieldGet(this, _AutoPage_passengers, "f"),
            checkAttributes: attributes,
            allowBooking: __classPrivateFieldGet(this, _AutoPage_allowBooking, "f"),
        }));
    }, _AutoPage_getParamsOfHotFilter = function _AutoPage_getParamsOfHotFilter() {
        const queryParams = new App.QueryParams(window.location.pathname);
        const elements = [];
        const checkValues = [
            App.AutoHotFilterFields.PickupPlace,
            App.AutoHotFilterFields.DropoffPlace,
            App.AutoHotFilterFields.Category,
            App.AutoHotFilterFields.Model,
            App.AutoHotFilterFields.Provider,
            App.AutoHotFilterFields.Transmission,
            App.AutoHotFilterFields.PassengersCount,
            App.AutoHotFilterFields.FreeCancellation,
        ];
        checkValues.forEach(v => {
            const val = queryParams.param(v).map(s => decodeURIComponent(s).toLowerCase());
            elements.push({ name: v, value: val.join(',') });
        });
        return elements;
    }, _AutoPage_prepareDataForSearch = function _AutoPage_prepareDataForSearch(needHotFilterData) {
        let elements = [];
        if (__classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.length > 0)
            elements = __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.serializeArray();
        else if (__classPrivateFieldGet(this, _AutoPage_options, "f").searchData.length > 0)
            elements = __classPrivateFieldGet(this, _AutoPage_options, "f").searchData;
        if (needHotFilterData)
            elements = elements.concat(__classPrivateFieldGet(_a, _a, "m", _AutoPage_getParamsOfHotFilter).call(_a));
        const data = {};
        $.each(elements, (i, v) => {
            if (v.value == null || v.value === '')
                return true;
            data[v.name] = v.value;
            return true;
        });
        return data;
    }, _AutoPage_prepareDataForBook = function _AutoPage_prepareDataForBook() {
        let elements = __classPrivateFieldGet(this, _AutoPage_bookWrap, "f").find('input').serializeArray();
        elements.push({ name: 'Key', value: __classPrivateFieldGet(this, _AutoPage_reserveKey, "f") });
        elements.push({ name: 'BasketCode', value: __classPrivateFieldGet(this, _AutoPage_basketCode, "f") });
        elements.push({ name: 'ProviderKey', value: __classPrivateFieldGet(this, _AutoPage_providerKey, "f").toString() });
        elements.push({ name: 'RouteNumber', value: __classPrivateFieldGet(this, _AutoPage_routeNumber, "f").toString() });
        elements.push({ name: 'DriverAge', value: __classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.find('input[data-name="driverAge"]').valString() });
        if (__classPrivateFieldGet(this, _AutoPage_options, "f").searchData.length > 0)
            elements = elements.concat(__classPrivateFieldGet(this, _AutoPage_options, "f").searchData);
        else
            elements = elements.concat(__classPrivateFieldGet(this, _AutoPage_filter, "f").searchFilter.find('input').serializeArray());
        const data = {};
        $.each(elements, (i, v) => {
            if (v.value == null || v.value === '')
                return true;
            data[v.name] = v.value;
            return true;
        });
        return data;
    }, _AutoPage_initRoutePageScripts = function _AutoPage_initRoutePageScripts() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f")) {
                __classPrivateFieldSet(this, _AutoPage_routeHotFilter, new App.AutoRouteHotFilter({ root: __classPrivateFieldGet(this, _AutoPage_routeHotFilterClass, "f") }), "f");
            }
            else if (__classPrivateFieldGet(this, _AutoPage_routeResult, "f")) {
                __classPrivateFieldGet(this, _AutoPage_routeResult, "f").clearFilteringData();
            }
            if (!__classPrivateFieldGet(this, _AutoPage_routeResult, "f")) {
                __classPrivateFieldSet(this, _AutoPage_routeResult, new App.AutoRouteResult({
                    root: __classPrivateFieldGet(this, _AutoPage_routeWrapClass, "f"),
                    hotFilter: __classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f"),
                }), "f");
            }
            __classPrivateFieldGet(this, _AutoPage_routeResult, "f").resetDataSource();
            yield __classPrivateFieldGet(this, _AutoPage_routeResult, "f").changeDataSource(__classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f"));
            const paramsHotFilter = __classPrivateFieldGet(_a, _a, "m", _AutoPage_getParamsOfHotFilter).call(_a);
            __classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f").refreshHotFilters(__classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f"), paramsHotFilter.map(s => ({ name: s.name, values: s.value.split(',') })));
            __classPrivateFieldGet(this, _AutoPage_routeHotFilter, "f").routeHotFilter.trigger("filter:change" /* Events.FilterChange */);
        });
    }, _AutoPage_initBookPageScripts = function _AutoPage_initBookPageScripts() {
        return __awaiter(this, void 0, void 0, function* () {
            this.components.push(new App.Digest({ container: this.root }), new App.ExistingPassengers(), new App.FindTourist());
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _AutoPage_agentBlackListComponent, new App.AgentBlackListComponent(), "f");
                this.components.push(__classPrivateFieldGet(this, _AutoPage_agentBlackListComponent, "f"));
            }
            const filter = new App.Filter({ root: '.js-form-order' });
            __classPrivateFieldSet(this, _AutoPage_formBook, new App.Form({ root: filter.root }), "f");
            __classPrivateFieldSet(this, _AutoPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AutoPage_popup, "f")),
                validator: __classPrivateFieldGet(this, _AutoPage_formBook, "f").validator,
            }), "f");
            __classPrivateFieldSet(this, _AutoPage_bookForm, $('.js-form-order', this.root), "f");
            $('.js-form-item-field.js-fioFields, .js-flightNumber', __classPrivateFieldGet(this, _AutoPage_bookForm, "f")).on('change', e => __classPrivateFieldGet(_a, _a, "m", _AutoPage_onFioChange).call(_a, e));
            $('.js-sliding-btn', __classPrivateFieldGet(this, _AutoPage_bookForm, "f")).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AutoPage_onGenderSliderClick).call(_a, e));
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_fillExtraServices).call(this);
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_recalcExtraServices).call(this);
            // если выбраны доп услуги - добавить стоимость доп услуг
            $('.booking-content-add_info', __classPrivateFieldGet(this, _AutoPage_bookForm, "f")).on('change', 'select', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onExtraServisesChange).call(this, e); }));
            // формат календаря для даты рождения
            const currentYear = new Date().getFullYear();
            // Человеком, который прожил самую долгую жизнь, считается француженка Жанна Кальман. Она успела отметить свой 122 день рождения
            // прежде, чем отошла в мир иной.
            const minYear = currentYear - 125;
            const calendars = $('.js-form-date', __classPrivateFieldGet(this, _AutoPage_bookForm, "f"));
            calendars.inputmask('date');
            const calendarIcons = $('.js-filter-date-from-icon', __classPrivateFieldGet(this, _AutoPage_bookForm, "f"));
            calendarIcons.on('click', e => $(e.currentTarget).prev('.js-form-date').trigger('focus'));
            const calendarBirthday = $('._birthday .js-form-date', __classPrivateFieldGet(this, _AutoPage_bookForm, "f"));
            calendarBirthday.datepicker('option', {
                yearRange: `${minYear}:${currentYear}`,
                minDate: -110 * 365,
                maxDate: 50 * 365,
            });
            $('.js-flightNumber', __classPrivateFieldGet(this, _AutoPage_bookForm, "f")).inputmask('flightnumber');
            // разлочить кнопку бронирования
            $('.form-btn', __classPrivateFieldGet(this, _AutoPage_bookWrap, "f")).removeAttr('disabled');
            $('#allowBook', __classPrivateFieldGet(this, _AutoPage_bookForm, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onAllowBookButtonClick).call(this); }));
        });
    }, _AutoPage_getRoutes = function _AutoPage_getRoutes() {
        const routes = new Array();
        __classPrivateFieldGet(this, _AutoPage_results, "f").forEach(value => {
            const el = routes.find(val => val.uniqueKey === value.uniqueKey);
            if (el) {
                el.count += value.items.length;
                el.grossPrice = Math.min(el.grossPrice, value.grossPrice);
                if (el.netPrice && value.netPrice)
                    el.netPrice = Math.min(el.netPrice, value.netPrice);
                if (el.price && value.price)
                    el.price = Math.min(el.price, value.price);
                if (value.pickup.airportId === -1) {
                    el.pickupPoints.push(value.pickup);
                }
                if (value.dropoff.airportId === -1) {
                    el.dropoffPoints.push(value.dropoff);
                }
            }
            else {
                const route = {
                    pickup: value.pickup,
                    dropoff: value.dropoff,
                    uniqueKey: value.uniqueKey,
                    countDays: value.countDays,
                    count: value.items.length,
                    currencyCode: value.currencyCode,
                    grossPrice: value.grossPrice,
                    url: value.url,
                    freeCancellation: value.freeCancellation,
                    pickupPoints: [value.pickup],
                    dropoffPoints: [value.dropoff],
                };
                if (value.price)
                    route.price = value.price;
                if (value.netPrice)
                    route.netPrice = value.netPrice;
                routes.push(route);
            }
        });
        routes.forEach(value => {
            value.countCars = App.formatMessage('auto/cars', { count: value.count });
            value.pickupPoints = Enumerable.from(value.pickupPoints).distinct().toArray();
            value.dropoffPoints = Enumerable.from(value.dropoffPoints).distinct().toArray();
        });
        __classPrivateFieldSet(this, _AutoPage_routeResults, routes, "f");
    }, _AutoPage_getCurrentRoute = function _AutoPage_getCurrentRoute(routeNumber) {
        const route = __classPrivateFieldGet(this, _AutoPage_routeResults, "f").find(value => routeNumber === value.uniqueKey);
        return route || {};
    }, _AutoPage_getVehiclesByRoute = function _AutoPage_getVehiclesByRoute() {
        let cars = new Array();
        __classPrivateFieldGet(this, _AutoPage_results, "f").forEach(value => {
            if (value.uniqueKey === __classPrivateFieldGet(this, _AutoPage_routeNumber, "f")) {
                value.items.forEach(car => {
                    car.pickup = value.pickup;
                    car.dropoff = value.dropoff;
                });
                cars = cars.concat(value.items);
            }
        });
        if (cars.length > 0)
            __classPrivateFieldSet(this, _AutoPage_currentVehiclesByRoute, cars, "f");
    }, _AutoPage_getCurrentVehicle = function _AutoPage_getCurrentVehicle() {
        if (!__classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f"))
            return;
        const vehicle = __classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f").find(value => value.uniqueKey === __classPrivateFieldGet(this, _AutoPage_offerNumber, "f"));
        if (vehicle)
            __classPrivateFieldSet(this, _AutoPage_currentVehicle, vehicle, "f");
    }, _AutoPage_getVehicle = function _AutoPage_getVehicle(vehicleUniqueKey) {
        if (!__classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f"))
            return {};
        const vehicle = __classPrivateFieldGet(this, _AutoPage_currentVehiclesByRoute, "f").find(value => value.uniqueKey === vehicleUniqueKey);
        return vehicle || {};
    }, _AutoPage_getReserveKey = function _AutoPage_getReserveKey() {
        if (__classPrivateFieldGet(this, _AutoPage_reserveKey, "f") || !__classPrivateFieldGet(this, _AutoPage_currentVehicle, "f"))
            return;
        __classPrivateFieldSet(this, _AutoPage_reserveKey, __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").key, "f");
    }, _AutoPage_showMap = function _AutoPage_showMap(target) {
        var _b;
        const key = (_b = $(target).parents('.js-auto-route-block,.digest-block-item,.js-auto-result-block').attr('data-key')) !== null && _b !== void 0 ? _b : '';
        const isPickupPart = $(target).hasClass('js-map-pickup');
        let points = {};
        // со страницы с результатов поиска
        const route = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getCurrentRoute).call(this, key);
        if (Object.keys(route).length > 0) {
            points = isPickupPart ? route.pickupPoints : route.dropoffPoints;
        }
        else {
            // со страницы маршрута
            const vehicle = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getVehicle).call(this, key);
            points = isPickupPart ? [vehicle.pickup] : [vehicle.dropoff];
        }
        // из корзины
        if (__classPrivateFieldGet(this, _AutoPage_currentVehicle, "f")) {
            points = isPickupPart ? [__classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").pickup] : [__classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").dropoff];
        }
        const ps = points.map(p => ({
            coordinate: p.coordinate,
            title: p.name,
            id: p.airportId,
        }));
        this.components.push(new App.SimpleGoogleMap(ps, $('.js-popup').find(`.${__classPrivateFieldGet(this, _AutoPage_mapWrapClass, "f")}`)));
    }, _AutoPage_searchRoutes = function _AutoPage_searchRoutes(onlySearch, needHotFilterData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AutoPage_searchExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _AutoPage_searchExecuting, true, "f");
            if (__classPrivateFieldGet(this, _AutoPage_expirationPopup, "f") != null)
                __classPrivateFieldGet(this, _AutoPage_expirationPopup, "f").cancel();
            __classPrivateFieldGet(this, _AutoPage_preloader, "f").show({ delay: 3000 });
            if (!onlySearch)
                __classPrivateFieldGet(this, _AutoPage_result, "f").resetDataSource();
            const data = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_prepareDataForSearch).call(this, needHotFilterData);
            if (__classPrivateFieldGet(this, _AutoPage_context, "f"))
                data.context = __classPrivateFieldGet(this, _AutoPage_context, "f");
            let returnS = false;
            __classPrivateFieldSet(this, _AutoPage_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AutoPage_options, "f").urls.searchRoutes,
                method: 'POST',
                data,
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _AutoPage_searchXhr, "f");
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").process(response))
                    return false;
                if (!new App.SearchLocker().check(response.data))
                    return false;
                if (response.data.seo != null)
                    __classPrivateFieldGet(this, _AutoPage_seo, "f")[__classPrivateFieldGet(this, _AutoPage_state, "f")] = response.data.seo;
                // Определение наличия результатов поиска
                if (!response.data.offers || response.data.offers.length <= 0) {
                    __classPrivateFieldGet(this, _AutoPage_result, "f").resetDataSource();
                    return false;
                }
                __classPrivateFieldSet(this, _AutoPage_results, response.data.offers, "f");
                __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getRoutes).call(this);
                __classPrivateFieldSet(this, _AutoPage_expirationPopup, App.scheduleExpirationPopup({
                    interval: response.data.dataExpiration,
                    url: __classPrivateFieldGet(this, _AutoPage_options, "f").urls.searchRoutes,
                }), "f");
                if (!onlySearch) {
                    __classPrivateFieldGet(this, _AutoPage_hotFilter, "f").refreshHotFilters(response.data.hotFilter);
                    yield __classPrivateFieldGet(this, _AutoPage_result, "f").changeDataSource(__classPrivateFieldGet(this, _AutoPage_routeResults, "f"));
                    // TODO Timoshkina: некорректное использование, данное событие должно инициироваться только в наследниках FilterBlockBase.
                    __classPrivateFieldGet(this, _AutoPage_hotFilter, "f").hotFilter.trigger("filter:change" /* Events.FilterChange */);
                }
                returnS = true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _AutoPage_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _AutoPage_preloader, "f").hide();
            }
            return returnS;
        });
    }, _AutoPage_getVehicleTerms = function _AutoPage_getVehicleTerms(key, url) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: url,
                method: 'POST',
                data: { key },
            });
            try {
                const response = yield xhr;
                let term = 'Произошла ошибка. Попробуйте еще раз позднее.';
                let isDebit = false;
                let isCredit = false;
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").process(response)) {
                    if (response.status.messages && response.status.messages.length > 0)
                        term = response.status.messages[0].text;
                }
                else {
                    term = response.data.term;
                    const domNodes = jQuery.parseHTML(response.data.searchText);
                    let searchText = $(domNodes).find('h4').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dt').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dd').text();
                    if (searchText.includes('дебетов'))
                        isDebit = true;
                    if (searchText.includes('кредитн'))
                        isCredit = true;
                    if (response.data.isNeedCarDeposit)
                        isCredit = true;
                }
                const termContent = $(App.templates.VehicleTerms({ term, isDebit, isCredit }));
                $('.js-popup').find(`.${__classPrivateFieldGet(this, _AutoPage_termWrapClass, "f")}`).empty().append(termContent);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _AutoPage_reserveOffer = function _AutoPage_reserveOffer() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = false;
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _AutoPage_options, "f").urls.reserveOffer,
                method: 'POST',
                data: { key: __classPrivateFieldGet(this, _AutoPage_reserveKey, "f"), context: __classPrivateFieldGet(this, _AutoPage_context, "f") },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").process(response))
                    return false;
                __classPrivateFieldSet(this, _AutoPage_basketCode, response.data.basketCode, "f");
                __classPrivateFieldSet(this, _AutoPage_providerKey, response.data.providerKey, "f");
                __classPrivateFieldSet(this, _AutoPage_allowBooking, response.data.allowBooking, "f");
                Object.assign(__classPrivateFieldGet(this, _AutoPage_currentVehicle, "f"), response.data.offer);
                if (response.data.seo != null)
                    __classPrivateFieldGet(this, _AutoPage_seo, "f")[__classPrivateFieldGet(this, _AutoPage_state, "f")] = response.data.seo;
                result = true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            return result;
        });
    }, _AutoPage_getExistingPassengers = function _AutoPage_getExistingPassengers() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AutoPage_passengers, undefined, "f");
            const age = __classPrivateFieldGet(this, _AutoPage_queryParams, "f").param('driverage')[0];
            const pickupObj = __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").pickup.date;
            if (!pickupObj || !age)
                return;
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _AutoPage_options, "f").urls.getExistingPassengers,
                method: 'GET',
                data: {
                    context: __classPrivateFieldGet(this, _AutoPage_context, "f"),
                    age,
                    pickupDate: pickupObj,
                },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldSet(this, _AutoPage_passengers, response.data.existingPassengers, "f");
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _AutoPage_book = function _AutoPage_book() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_prepareDataForBook).call(this);
            if (__classPrivateFieldGet(this, _AutoPage_context, "f"))
                data.context = __classPrivateFieldGet(this, _AutoPage_context, "f");
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _AutoPage_options, "f").urls.book,
                method: 'POST',
                dataType: 'json',
                data,
            });
            const popupGroup = __classPrivateFieldGet(this, _AutoPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Auto.Messages.Booking({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").process(response))
                    return;
                return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AutoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _AutoPage_popup, "f").hide(popupGroup);
            }
        });
    }, _AutoPage_fillExtraServices = function _AutoPage_fillExtraServices() {
        __classPrivateFieldSet(this, _AutoPage_extraServices, __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").vehicle.feeAtDeliveries.map(value => ({
            name: value.description,
            price: value.totalPrice,
            currency: value.currencyCode,
        })), "f");
    }, _AutoPage_recalcExtraServices = function _AutoPage_recalcExtraServices() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_updateExtraServiceDigest).call(this);
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_updateExtraServiceDigestPrice).call(this);
        });
    }, _AutoPage_updateExtraServiceDigest = function _AutoPage_updateExtraServiceDigest() {
        const servicesNamesBlock = $('.js-auto-extra-services-names', __classPrivateFieldGet(this, _AutoPage_bookWrap, "f"));
        if (__classPrivateFieldGet(this, _AutoPage_extraServices, "f").length === 0) {
            servicesNamesBlock.hideByClass();
            return;
        }
        // чистим весь дайджест
        $('.js-digest-extraServices-names', servicesNamesBlock).empty();
        const serviceBlocks = __classPrivateFieldGet(this, _AutoPage_extraServices, "f").map(service => $(App.templates.Auto.Book.ExtraServiceBlockDigest({ service })));
        serviceBlocks.forEach(v => $('.js-digest-extraServices-names', servicesNamesBlock).append(v));
        _a.show(servicesNamesBlock);
        // Обновляем размеры дайджеста.
        $(document).trigger("digest:update" /* Events.DigestUpdate */);
    }, _AutoPage_updateExtraServiceDigestPrice = function _AutoPage_updateExtraServiceDigestPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            const containerFooter = $('.js-digest-footer', this.root);
            containerFooter.empty();
            const services = __classPrivateFieldGet(this, _AutoPage_extraServices, "f").map(v => ({
                name: v.name,
                nameDetails: '',
                isBonus: false,
                grossPrice: v.price,
                discount: 0,
                price: v.price,
                currencyCode: v.currency,
            }));
            const data = {
                servicePrices: [],
                netPrice: typeof __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").netPrice !== 'undefined' ? __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").netPrice : undefined,
                grossPrice: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice,
                discount: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice - ((_b = __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").price) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice),
                price: (_c = __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").price) !== null && _c !== void 0 ? _c : __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").grossPrice,
                currencyCode: __classPrivateFieldGet(this, _AutoPage_currentVehicle, "f").currencyCode,
                hasDetails: false,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _AutoPage_pricePresenter, "f").type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                servicePayOnDeliveryPrices: services,
                notes: [],
            };
            const contentFooter = $(App.templates.BookDigestFooter(data));
            containerFooter.append(contentFooter);
            // Обновляем размеры дайджеста.
            $(document).trigger("digest:update" /* Events.DigestUpdate */);
        });
    }, _AutoPage_focusFirstInvalidField = function _AutoPage_focusFirstInvalidField() {
        const invalidField = __classPrivateFieldGet(this, _AutoPage_bookForm, "f").find('._invalid').first();
        const position = invalidField.offset();
        $('html, body').animate({ scrollTop: position ? position.top : 0 }, 'slow');
        setTimeout(() => { invalidField.trigger('focus'); }, 1000);
    }, _AutoPage_onHistoryStateChange = function _AutoPage_onHistoryStateChange() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AutoPage_state, App.History.getState(), "f");
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_run).call(this);
        });
    }, _AutoPage_onMainFilterSearch = function _AutoPage_onMainFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(_a, _a, "m", _AutoPage_checkMainFilter).call(_a))
                return;
            if (!__classPrivateFieldGet(this, _AutoPage_formMainFilter, "f").validator.form())
                return;
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_cleanPage).call(this);
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderSearchResultsPage).call(this, false);
        });
    }, _AutoPage_onOfferClick = function _AutoPage_onOfferClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            event.preventDefault();
            // TODO: при клике на [data-href] - отменять дальнейшие события, там свой обработчик
            if ($(event.target).hasClass('js-show-terms') || $(event.target).hasClass('js-show-on-map'))
                return;
            __classPrivateFieldSet(this, _AutoPage_reserveKey, (_b = $(event.currentTarget).attr('data-reserve-key')) !== null && _b !== void 0 ? _b : '', "f");
            __classPrivateFieldSet(this, _AutoPage_offerNumber, (_c = $(event.currentTarget).attr('data-key')) !== null && _c !== void 0 ? _c : '', "f");
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_renderBookPage).call(this);
        });
    }, _AutoPage_onAllowBookButtonClick = function _AutoPage_onAllowBookButtonClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AutoPage_formBook, "f").validator.form()) {
                __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_focusFirstInvalidField).call(this);
                return;
            }
            if (__classPrivateFieldGet(this, _AutoPage_options, "f").isAgentRF) {
                this.root.off('click', '#acceptBookAuto');
                const popupGroup = __classPrivateFieldGet(this, _AutoPage_popup, "f").show({
                    group: 'allowBook',
                    content: App.templates.Auto.Messages.AllowBook({}),
                });
                $('.js-auto-page').on('click', '#acceptBookAuto', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_onBookButtonClick).call(this, e, popupGroup); }));
                $('.js-auto-page').on('click', '#declineBookAuto', () => __classPrivateFieldGet(this, _AutoPage_popup, "f").hide(popupGroup));
            }
            else {
                yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_book).call(this);
            }
        });
    }, _AutoPage_onBookButtonClick = function _AutoPage_onBookButtonClick(event, popupGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            const allowForm = new App.Form({ root: $('.js-allowBookAuto', '.js-auto-page') });
            if (!allowForm.validator.form())
                return;
            __classPrivateFieldGet(this, _AutoPage_popup, "f").hide(popupGroup);
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _AutoPage_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_book).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_book).call(this);
            }
        });
    }, _AutoPage_onFioChange = function _AutoPage_onFioChange(event) {
        $(event.currentTarget).val(App.transliterateName($(event.currentTarget).valString()));
    }, _AutoPage_onGenderSliderClick = function _AutoPage_onGenderSliderClick(event) {
        const target = $(event.currentTarget);
        const input = target.find('input');
        target.toggleClass('_left _right');
        const value = target.hasClass('_left') ? 'Female' : 'Male';
        input.val(value);
        target.parents('.js-form-gender')
            .find('.js-form-gender-icon')
            .toggleClass('_woman', target.hasClass('_left'));
    }, _AutoPage_onExtraServisesChange = function _AutoPage_onExtraServisesChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // вставить кол-во в скрытый input для POST
            $(event.target)
                .next('.js-extra-services-quantity')
                .val($(event.currentTarget).find('option:selected').valNumber() || 0);
            __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_fillExtraServices).call(this);
            $('.js-order-extras').find('.table-row').each((index, row) => {
                var _b, _c;
                const count = $(row).find('.js-extra-services-select-count option:selected').valNumber() || 0;
                const currency = (_b = $(event.currentTarget).parents('label.table-row').attr('data-currency')) !== null && _b !== void 0 ? _b : '';
                if (count) {
                    const price = Math.round(parseFloat((_c = $(row).attr('data-price')) !== null && _c !== void 0 ? _c : '0'));
                    const value = price * count;
                    const name = $(row).find('.insurance-data__name').html();
                    __classPrivateFieldGet(this, _AutoPage_extraServices, "f").push({
                        name,
                        price: value,
                        currency,
                    });
                }
            });
            yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_recalcExtraServices).call(this);
        });
    }, _AutoPage_onShowMapClick = function _AutoPage_onShowMapClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _AutoPage_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _AutoPage_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _AutoPage_mapWrapClass, "f")}"><div style="width: 700px; height: 600px !important; min-height: 600px;" class="js-auto-point-map"></div></div>`),
            onShowDelegate: () => __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_showMap).call(this, event.currentTarget),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _AutoPage_onShowTermsClick = function _AutoPage_onShowTermsClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _AutoPage_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _AutoPage_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _AutoPage_termWrapClass, "f")}"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getVehicleTerms).call(this, (_b = $(event.currentTarget).attr('data-reserve-key')) !== null && _b !== void 0 ? _b : '', __classPrivateFieldGet(this, _AutoPage_options, "f").urls.getVehicleTerm); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _AutoPage_onShowTermsSimpleClick = function _AutoPage_onShowTermsSimpleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _AutoPage_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _AutoPage_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _AutoPage_termWrapClass, "f")}"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _AutoPage_instances, "m", _AutoPage_getVehicleTerms).call(this, (_b = $(event.currentTarget).attr('href')) !== null && _b !== void 0 ? _b : '', __classPrivateFieldGet(this, _AutoPage_options, "f").urls.getVehicleTermSimple); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _AutoPage_onLinkClick = function _AutoPage_onLinkClick(event) {
        var _b;
        event.preventDefault();
        event.stopPropagation();
        const link = (_b = $(event.currentTarget).attr('data-href')) !== null && _b !== void 0 ? _b : '';
        window.open(link);
        return false;
    };
    App.AutoPage = AutoPage;
})(App || (App = {}));
var App;
(function (App) {
    var _AutoHotFilterMobile_instances, _a, _AutoHotFilterMobile_getSelectListDefaultOption, _AutoHotFilterMobile_convertOptions, _AutoHotFilterMobile_getFilters, _AutoHotFilterMobile_onHotFiltersChangeMobile;
    class AutoHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(options);
            _AutoHotFilterMobile_instances.add(this);
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
            if (!this.root.length) {
                this.hotFilter = $();
                return;
            }
            this.hotFilter = this.root;
            // this.root.on(Events.FilterChange, (e, data: IFilterChangeData) => this.onHotFiltersChange());
            // mobile filters
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: () => this.onSelfFilterChanged() });
        }
        onSelfFilterChanged() {
            return __awaiter(this, void 0, void 0, function* () {
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
                __classPrivateFieldGet(this, _AutoHotFilterMobile_instances, "m", _AutoHotFilterMobile_onHotFiltersChangeMobile).call(this);
            });
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('auto/hotFilterFoundTitle', { count: data.reduce((prev, cur) => prev + cur.count, 0) }));
        }
        // Обновляет хот-фильтры
        refreshHotFilters(autoHotFilters) {
            if (autoHotFilters.pickupPlace.length <= 1 && autoHotFilters.dropoffPlace.length <= 1) {
                this.hotFilter.find('.js-filter-select-block').hideByClass();
                return;
            }
            Object.keys(autoHotFilters).forEach(key => {
                switch (key.toLowerCase()) {
                    case App.AutoHotFilterFields.PickupPlace: {
                        const isDefSelected = !Enumerable.from(autoHotFilters.pickupPlace).any(v => v.selected === true);
                        let optionListData = new Array();
                        optionListData.push(__classPrivateFieldGet(_a, _a, "m", _AutoHotFilterMobile_getSelectListDefaultOption).call(_a, isDefSelected));
                        optionListData = optionListData.concat(autoHotFilters.pickupPlace);
                        this.filters.setControlValue(key, __classPrivateFieldGet(_a, _a, "m", _AutoHotFilterMobile_convertOptions).call(_a, optionListData), false);
                        break;
                    }
                    case App.AutoHotFilterFields.DropoffPlace: {
                        const isDefSelected = !Enumerable.from(autoHotFilters.dropoffPlace).any(v => v.selected === true);
                        let optionListData = new Array();
                        optionListData.push(__classPrivateFieldGet(_a, _a, "m", _AutoHotFilterMobile_getSelectListDefaultOption).call(_a, isDefSelected));
                        optionListData = optionListData.concat(autoHotFilters.dropoffPlace);
                        this.filters.setControlValue(key, __classPrivateFieldGet(_a, _a, "m", _AutoHotFilterMobile_convertOptions).call(_a, optionListData), false);
                        break;
                    }
                    case App.AutoHotFilterFields.FreeCancellation: {
                        // TODO: странный контрол, если много раз включать и выключать,
                        // TODO: то у Маршрутов в результатах наращивается урл с /freecancellation-true/
                        // TODO: такое поведение и в оригинале (на бое) - эта проблема не в этом месте
                        this.filters.setControlValue(key, autoHotFilters.freeCancellation, false);
                        break;
                    }
                    default:
                }
            });
            this.hotFilter.find('.js-filter-body').showByClass();
        }
        onHotFiltersChange() {
            // const filters = this.#getFilters();
            // this.hotFilter.trigger(Events.FilterFilter, { items: filters });
            // NOTE: ничего не делаем по "обычной" подписке - обработаем сами
            // NOTE: этот метод оставлен, чтобы не переписывать весь HotFilter ради изменения в одной строчке кода
        }
        reset() {
            super.reset();
            this.filters.reset();
        }
        clear() {
            super.clear();
            this.filters.clear();
        }
    }
    _a = AutoHotFilterMobile, _AutoHotFilterMobile_instances = new WeakSet(), _AutoHotFilterMobile_getSelectListDefaultOption = function _AutoHotFilterMobile_getSelectListDefaultOption(selected) {
        return { value: '', text: localizer.all, selected };
    }, _AutoHotFilterMobile_convertOptions = function _AutoHotFilterMobile_convertOptions(arrFrom) {
        return App.MobileFilterBlockBase.convertArrayFromListOptions(arrFrom);
    }, _AutoHotFilterMobile_getFilters = function _AutoHotFilterMobile_getFilters() {
        // const selectedHotFilters = this.hotFilter.find('input').serializeArray();
        const selectedHotFilters = this.filters.serializeArray();
        return selectedHotFilters
            // не false значения (их не передаем)
            .filter(item => item.value != null && item.value != 'false')
            // превращаем сериализованный массив в массив типа IFilterCriterion
            .map(item => ({
            name: item.name,
            values: item.value ? item.value.split(',') : new Array(),
        }))
            // возвращаем только заполненные значения
            .filter(item => item.values.length > 0);
    }, _AutoHotFilterMobile_onHotFiltersChangeMobile = function _AutoHotFilterMobile_onHotFiltersChangeMobile() {
        const filters = __classPrivateFieldGet(this, _AutoHotFilterMobile_instances, "m", _AutoHotFilterMobile_getFilters).call(this);
        this.hotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        // TODO: сделать как в Activities??
        // const mapper = new HotFilterMapperMobile(this.root, this.filters);
        // this.root.trigger(Events.FilterFilter, { items: mapper.execute() });
    };
    App.AutoHotFilterMobile = AutoHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AutoHotFilter_instances, _a, _AutoHotFilter_getSelectListDefaultOption, _AutoHotFilter_getFilters;
    class AutoHotFilter extends App.HotFilter {
        constructor(options) {
            super(options);
            _AutoHotFilter_instances.add(this);
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.hotFilter = $();
                return;
            }
            this.hotFilter = this.root;
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('auto/hotFilterFoundTitle', { count: data.reduce((prev, cur) => prev + cur.count, 0) }));
        }
        // Обновляет хот-фильтры
        refreshHotFilters(autoHotFilters) {
            if (autoHotFilters.pickupPlace.length <= 1 && autoHotFilters.dropoffPlace.length <= 1) {
                this.hotFilter.find('.js-filter-select-block').hideByClass();
                return;
            }
            Object.keys(autoHotFilters).forEach(key => {
                const filterControl = this.findControl(key);
                if (!filterControl)
                    return;
                switch (key.toLowerCase()) {
                    case App.AutoHotFilterFields.PickupPlace: {
                        const filterListBlockBase = filterControl;
                        const isDefSelected = !Enumerable.from(autoHotFilters.pickupPlace).any(v => v.selected === true);
                        let optionListData = new Array();
                        optionListData.push(__classPrivateFieldGet(_a, _a, "m", _AutoHotFilter_getSelectListDefaultOption).call(_a, isDefSelected));
                        optionListData = optionListData.concat(autoHotFilters.pickupPlace);
                        if (filterListBlockBase)
                            filterListBlockBase.replaceOptions(optionListData, false);
                        break;
                    }
                    case App.AutoHotFilterFields.DropoffPlace: {
                        const filterListBlockBase = filterControl;
                        const isDefSelected = !Enumerable.from(autoHotFilters.dropoffPlace).any(v => v.selected === true);
                        let optionListData = new Array();
                        optionListData.push(__classPrivateFieldGet(_a, _a, "m", _AutoHotFilter_getSelectListDefaultOption).call(_a, isDefSelected));
                        optionListData = optionListData.concat(autoHotFilters.dropoffPlace);
                        if (filterListBlockBase)
                            filterListBlockBase.replaceOptions(optionListData, false);
                        break;
                    }
                    case App.AutoHotFilterFields.FreeCancellation: {
                        const control = filterControl;
                        if (control)
                            control.setValue(autoHotFilters.freeCancellation.toString(), false);
                        break;
                    }
                    default:
                }
            });
            this.hotFilter.find('.js-filter-body').showByClass();
        }
        onHotFiltersChange() {
            const filters = __classPrivateFieldGet(this, _AutoHotFilter_instances, "m", _AutoHotFilter_getFilters).call(this);
            this.hotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
    }
    _a = AutoHotFilter, _AutoHotFilter_instances = new WeakSet(), _AutoHotFilter_getSelectListDefaultOption = function _AutoHotFilter_getSelectListDefaultOption(selected) {
        return { value: '', text: localizer.all, selected };
    }, _AutoHotFilter_getFilters = function _AutoHotFilter_getFilters() {
        const selectedHotFilters = this.hotFilter.find('input').serializeArray();
        return selectedHotFilters
            // превращаем сериализованный массив в массив типа IFilterCriterion
            .map(item => ({
            name: item.name,
            values: item.value ? item.value.split(',') : new Array(),
        }))
            // возвращаем только заполненные значения
            .filter(item => item.values.length > 0);
    };
    App.AutoHotFilter = AutoHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    class AutoMainFilterMobile extends App.MainFilter {
        constructor(options) {
            super(options);
            // readonly #options: IAutoMainFilterMobileOptions;
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // this.#options = options;
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            // mobile filters
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: v => this.onFilterChanged(v) });
            this.validator = this.filters.validator;
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                // console.log('--- смена фильтра: "' + filterName + '" ---');
                if (filterName == PwStore.FILTER_ALL) {
                    // console.log('Выполнили сброс всех фильтров');
                }
                else if (filterName == 'Pickup') {
                    const isSameDropoff = this.filters.getControlToggle('SameDropoff');
                    if (isSameDropoff) {
                        const v = this.filters.getControlItemValues('Pickup');
                        this.filters.setControlValue('Dropoff', v, false);
                    }
                }
                else if (filterName == 'Pickup.Date') {
                    const v = this.filters.getControlValue('Pickup.Date');
                    if (v) {
                        const dropDate = this.filters.getControl('Dropoff.Date');
                        dropDate.setMinDate(v, 1);
                    }
                }
                else if (filterName == 'SameDropoff') {
                    const isSameDropoff = this.filters.getControlToggle('SameDropoff');
                    const ctrlDropoff = this.filters.getControl('Dropoff');
                    if (isSameDropoff) {
                        ctrlDropoff === null || ctrlDropoff === void 0 ? void 0 : ctrlDropoff.setEnabled(false);
                        ctrlDropoff === null || ctrlDropoff === void 0 ? void 0 : ctrlDropoff.setValue(this.filters.getControlItemValues('Pickup'));
                    }
                    else {
                        ctrlDropoff === null || ctrlDropoff === void 0 ? void 0 : ctrlDropoff.setEnabled(true);
                    }
                }
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
            });
        }
        reset() {
            this.filters.reset();
        }
    }
    App.AutoMainFilterMobile = AutoMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AutoMainFilter_instances, _a, _AutoMainFilter_options, _AutoMainFilter_filters, _AutoMainFilter_initSearchFilterEvents, _AutoMainFilter_getFilterControls, _AutoMainFilter_validateDates, _AutoMainFilter_validateFromValue, _AutoMainFilter_switchPointInfoBlocks, _AutoMainFilter_onFilterSearch, _AutoMainFilter_onSwitcherClick, _AutoMainFilter_onPickupAutocompleteOptionClick;
    class AutoMainFilter extends App.MainFilter {
        constructor(options) {
            super(options);
            _AutoMainFilter_instances.add(this);
            _AutoMainFilter_options.set(this, void 0);
            _AutoMainFilter_filters.set(this, void 0);
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _AutoMainFilter_options, options, "f");
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_initSearchFilterEvents).call(this);
        }
        reset() {
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").pickup.block)
                __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").pickup.block.reset();
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").checkinFrom.block) {
                const dateBlock = __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").checkinFrom.block;
                dateBlock.clear();
            }
            __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").timeFrom.element.val(__classPrivateFieldGet(this, _AutoMainFilter_options, "f").defaults.pickupTime);
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block)
                __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block.reset();
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").checkinTo.block) {
                const dateBlock = __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").checkinTo.block;
                dateBlock.clear();
            }
            __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").timeTo.element.val(__classPrivateFieldGet(this, _AutoMainFilter_options, "f").defaults.dropoffTime);
            __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").driverAge.element.val('');
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").switcher.element.find('input').val() !== __classPrivateFieldGet(this, _AutoMainFilter_options, "f").defaults.sameDropoff.toString())
                __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").switcher.element.find('.js-sliding-btn').trigger('click');
        }
    }
    _a = AutoMainFilter, _AutoMainFilter_options = new WeakMap(), _AutoMainFilter_filters = new WeakMap(), _AutoMainFilter_instances = new WeakSet(), _AutoMainFilter_initSearchFilterEvents = function _AutoMainFilter_initSearchFilterEvents() {
        __classPrivateFieldSet(this, _AutoMainFilter_filters, __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_getFilterControls).call(this, this.searchFilter), "f");
        $('.js-point-time', this.searchFilter).inputmask('time');
        __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_validateDates).call(this);
        // обработчик на слайдер - при выборе 'Возврат там же' -> 'лочить' возвратные поля + подставлять dropoff точку
        __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").switcher.element.on('click', () => __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_onSwitcherClick).call(this));
        // обработчик на клик по варианту получения: если выбран 'Возврат там же' ->  сразу подставлять такую же dropoff точку
        if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").pickup.block != null)
            __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").pickup.block.root.on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, () => __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_onPickupAutocompleteOptionClick).call(this));
        this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_onFilterSearch).call(this, e));
        __classPrivateFieldGet(_a, _a, "m", _AutoMainFilter_switchPointInfoBlocks).call(_a, false);
        // правильное положение слайдера, когда есть параметры
        if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").switcher.element.find('input').val() === 'true') {
            __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").switcher.element.find('.js-sliding-btn').trigger('click');
            __classPrivateFieldGet(_a, _a, "m", _AutoMainFilter_switchPointInfoBlocks).call(_a, true);
        }
    }, _AutoMainFilter_getFilterControls = function _AutoMainFilter_getFilterControls(container) {
        return {
            pickup: {
                element: container.find('.js-search-location[data-name="pickup"] .js-point-select-input'),
                block: this.findControl('pickup'),
                changeType: 'pickup',
            },
            dropoff: {
                element: container.find('.js-search-location[data-select="dropoff"] .js-point-select-input'),
                block: this.findControl('dropoff'),
                changeType: 'dropoff',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                block: this.findControl('pickupDate'),
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                block: this.findControl('dropoffDate'),
                changeType: 'checkin',
            },
            timeFrom: {
                element: container.find('.js-filter-time-block[data-name="pickupTime"]  .js-point-time'),
                changeType: 'time',
            },
            timeTo: {
                element: container.find('.js-filter-time-block[data-name="dropoffTime"] .js-point-time'),
                changeType: 'time',
            },
            switcher: {
                element: container.find('.js-filter-sliding-btn-b'),
                changeType: 'switcher',
            },
            driverAge: {
                element: container.find('.filter-wrap__input[data-name="driverAge"]'),
                changeType: 'driverAge',
            },
        };
    }, _AutoMainFilter_validateDates = function _AutoMainFilter_validateDates() {
        const calendarFrom = __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").checkinFrom.element;
        const calendarTo = __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").checkinTo.element;
        // Создаем календарь 'От'
        calendarFrom.datepicker('option', 'onSelect', (dateText, inst) => {
            __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_validateFromValue).call(this, calendarFrom, calendarTo);
            inst.input.trigger('change');
        });
        // Создаем календарь 'До'
        calendarTo.datepicker('option', 'onSelect', (dateText, inst) => {
            inst.input.trigger('change');
        });
        __classPrivateFieldGet(this, _AutoMainFilter_instances, "m", _AutoMainFilter_validateFromValue).call(this, calendarFrom, calendarTo);
    }, _AutoMainFilter_validateFromValue = function _AutoMainFilter_validateFromValue(calendarFrom, calendarTo) {
        const dateFrom = calendarFrom.datepicker('getDate');
        const minValue = App.addDays(new Date(), __classPrivateFieldGet(this, _AutoMainFilter_options, "f").defaults.minPickupDateShift);
        const newValue = dateFrom < minValue ? minValue : dateFrom;
        calendarTo.datepicker('option', 'minDate', App.addDays(newValue, __classPrivateFieldGet(this, _AutoMainFilter_options, "f").defaults.minDropoffDateOffset));
        calendarTo.datepicker('option', 'maxDate', App.addDays(newValue, __classPrivateFieldGet(this, _AutoMainFilter_options, "f").defaults.maxDropoffDateOffset - 1));
    }, _AutoMainFilter_switchPointInfoBlocks = function _AutoMainFilter_switchPointInfoBlocks(isShow) {
        const infoBlocks = $('.info-blocks', $('.js-auto-page'));
        infoBlocks.hide();
        if (!isShow)
            infoBlocks.show();
    }, _AutoMainFilter_onFilterSearch = function _AutoMainFilter_onFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    }, _AutoMainFilter_onSwitcherClick = function _AutoMainFilter_onSwitcherClick() {
        const dropoffKey = $('#Dropoff_Key');
        const dropoffType = $('#Dropoff_Type');
        const dropoffName = $('#Dropoff_Name');
        const btn = __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").switcher.element.find('.js-sliding-btn');
        if (btn.hasClass('_on')) {
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block)
                __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block.root.addClass('overlayed');
            dropoffKey.val($('#Pickup_Key').val() || '');
            dropoffType.val($('#Pickup_Type').val() || '');
            dropoffName.val($('#Pickup_Name').val() || '');
        }
        else {
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block)
                __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block.root.removeClass('overlayed');
            dropoffKey.val(0);
            dropoffType.val(0);
            dropoffName.val('');
        }
        if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block)
            __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block.switchInputIcons();
        __classPrivateFieldGet(_a, _a, "m", _AutoMainFilter_switchPointInfoBlocks).call(_a, btn.hasClass('_on'));
    }, _AutoMainFilter_onPickupAutocompleteOptionClick = function _AutoMainFilter_onPickupAutocompleteOptionClick() {
        if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").switcher.element.find('.js-sliding-btn').hasClass('_on')) {
            $('#Dropoff_Key').val($('#Pickup_Key').val() || '');
            $('#Dropoff_Type').val($('#Pickup_Type').val() || '');
            $('#Dropoff_Name').val($('#Pickup_Name').val() || '');
            if (__classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block)
                __classPrivateFieldGet(this, _AutoMainFilter_filters, "f").dropoff.block.switchInputIcons();
        }
    };
    App.AutoMainFilter = AutoMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _AutoResult_urlChangeStrategy;
    class AutoResult extends App.Result {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Auto.Search.BlockOutput }, options));
            _AutoResult_urlChangeStrategy.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AutoResult_urlChangeStrategy, new App.UrlChangeStrategy(new App.AutoHotFilterSet()), "f");
            __classPrivateFieldGet(this, _AutoResult_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
        }
        clearFilteringData() {
            this.filtering.items = [];
        }
        applySorting(items) {
            if (this.sorting.reverse) {
                return Enumerable.from(items)
                    .orderByDescending(v => v.grossPrice)
                    .thenByDescending(v => v.count)
                    .toArray();
            }
            return Enumerable.from(items)
                .orderBy(v => v.grossPrice)
                .thenBy(v => v.count)
                .toArray();
        }
        applyFilters(items) {
            let result = items;
            let checkHotFilterParams = false;
            this.filtering.items.forEach(filter => {
                if (filter.values.length <= 0)
                    return;
                switch (filter.name.toLowerCase()) {
                    case App.AutoHotFilterFields.PickupPlace:
                        result = result.filter(item => filter.values.some(v => v === item.pickup.airportId.toString()));
                        break;
                    case App.AutoHotFilterFields.DropoffPlace:
                        result = result.filter(item => filter.values.some(v => v === item.dropoff.airportId.toString()));
                        break;
                    case App.AutoHotFilterFields.FreeCancellation:
                        result = result.filter(item => item.freeCancellation === (filter.values[0].toLowerCase() === 'true'));
                        checkHotFilterParams = true;
                        break;
                    // no default
                }
            });
            if (checkHotFilterParams) {
                result.forEach(item => {
                    item.url += App.AutoHotFilterFields.FreeCancellation.toLowerCase();
                    item.url += '-true/';
                });
            }
            return result;
        }
    }
    _AutoResult_urlChangeStrategy = new WeakMap();
    App.AutoResult = AutoResult;
})(App || (App = {}));
/// <reference path="./AutoResult.ts" />
var App;
(function (App) {
    class AutoResultMobile extends App.AutoResult {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Auto.Search.BlockOutput_Mobile }, options));
            if (!this.root.length)
                return;
        }
    }
    App.AutoResultMobile = AutoResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AutoRouteHotFilterMobile_instances, _a, _AutoRouteHotFilterMobile_findElementByKey, _AutoRouteHotFilterMobile_refreshSelectList, _AutoRouteHotFilterMobile_getSelectListDefaultOption;
    class AutoRouteHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(options);
            _AutoRouteHotFilterMobile_instances.add(this);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
            // mobile filters
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: () => this.onSelfFilterChanged() });
        }
        onSelfFilterChanged() {
            return __awaiter(this, void 0, void 0, function* () {
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
            });
        }
        refreshHotFilters(autoOffers, filters) {
            const routeHotFilterValues = new App.AutoHotFilterSet();
            routeHotFilterValues.filters.forEach(f => {
                const name = f.name.toLowerCase();
                const selectedValues = __classPrivateFieldGet(_a, _a, "m", _AutoRouteHotFilterMobile_findElementByKey).call(_a, filters, name);
                switch (name) {
                    case App.AutoHotFilterFields.PickupPlace: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.pickup.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilterMobile_instances, "m", _AutoRouteHotFilterMobile_refreshSelectList).call(this, App.AutoHotFilterFields.PickupPlace, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.DropoffPlace: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.dropoff.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilterMobile_instances, "m", _AutoRouteHotFilterMobile_refreshSelectList).call(this, App.AutoHotFilterFields.DropoffPlace, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.Category: {
                        const optionListData = Enumerable.from(autoOffers)
                            .selectMany(v => v.vehicle.category.split(','))
                            .select(v => v.trim())
                            .distinct()
                            .select(v => createListOption(selectedValues, v))
                            .orderBy(v => v.text, (a, b) => a.localeCompare(b))
                            .toArray();
                        __classPrivateFieldGet(this, _AutoRouteHotFilterMobile_instances, "m", _AutoRouteHotFilterMobile_refreshSelectList).call(this, App.AutoHotFilterFields.Category, optionListData, selectedValues.length > 0, false);
                        break;
                    }
                    case App.AutoHotFilterFields.Model: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.vehicle.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilterMobile_instances, "m", _AutoRouteHotFilterMobile_refreshSelectList).call(this, App.AutoHotFilterFields.Model, optionListData, selectedValues.length > 0, false);
                        break;
                    }
                    case App.AutoHotFilterFields.Provider: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.provider.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilterMobile_instances, "m", _AutoRouteHotFilterMobile_refreshSelectList).call(this, App.AutoHotFilterFields.Provider, optionListData, selectedValues.length > 0, false);
                        break;
                    }
                    case App.AutoHotFilterFields.Transmission: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.vehicle.transmissionType.code, val.vehicle.transmissionType.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilterMobile_instances, "m", _AutoRouteHotFilterMobile_refreshSelectList).call(this, App.AutoHotFilterFields.Transmission, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.PassengersCount: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.vehicle.passengerCount.toString()))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilterMobile_instances, "m", _AutoRouteHotFilterMobile_refreshSelectList).call(this, App.AutoHotFilterFields.PassengersCount, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.FreeCancellation: {
                        this.filters.setControlValue(App.AutoHotFilterFields.FreeCancellation, selectedValues[0], false);
                        break;
                    }
                }
            });
            function createListOption(selectedVals, value, text = '', checkValue = '') {
                const v = value.toLowerCase();
                return {
                    value: v,
                    text: text === '' ? v : text,
                    selected: selectedVals.includes(checkValue === '' ? v : checkValue),
                };
            }
            function unique(value, index, self) {
                return self.findIndex(val => val.value === value.value) === index;
            }
        }
        onHotFiltersChange(event) {
            const selectedHotFilters = this.filters.serializeArray();
            const filters = selectedHotFilters
                // не false значения (их не передаем)
                .filter(item => item.value != null && item.value != 'false')
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            this.routeHotFilter.trigger("routeHotFilter:beforeFiltering" /* Events.RouteHotFilterBeforeFiltering */, [filters, event.target]);
            this.routeHotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('auto/hotFilterFoundTitle', { count: data.length }));
        }
        reset() {
            super.reset();
            this.filters.reset();
        }
        clear() {
            super.clear();
            this.filters.clear();
        }
    }
    _a = AutoRouteHotFilterMobile, _AutoRouteHotFilterMobile_instances = new WeakSet(), _AutoRouteHotFilterMobile_findElementByKey = function _AutoRouteHotFilterMobile_findElementByKey(filters, key) {
        const filter = filters.find(value => value.name === key);
        if (filter)
            return filter.values;
        return Array();
    }, _AutoRouteHotFilterMobile_refreshSelectList = function _AutoRouteHotFilterMobile_refreshSelectList(key, options, defaultOptionSelected, needDefaultOption) {
        let optionListData = [];
        if (needDefaultOption)
            optionListData.push(__classPrivateFieldGet(_a, _a, "m", _AutoRouteHotFilterMobile_getSelectListDefaultOption).call(_a, defaultOptionSelected));
        optionListData = optionListData.concat(options);
        this.filters.setControlValueByListOptions(key, optionListData, false);
    }, _AutoRouteHotFilterMobile_getSelectListDefaultOption = function _AutoRouteHotFilterMobile_getSelectListDefaultOption(selected) {
        return { text: localizer.all, value: '', selected };
    };
    App.AutoRouteHotFilterMobile = AutoRouteHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AutoRouteHotFilter_instances, _a, _AutoRouteHotFilter_refreshSelectList, _AutoRouteHotFilter_findElementByKey, _AutoRouteHotFilter_getSelectListDefaultOption;
    class AutoRouteHotFilter extends App.HotFilter {
        constructor(options) {
            super(options);
            _AutoRouteHotFilter_instances.add(this);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
        }
        refreshHotFilters(autoOffers, filters) {
            const routeHotFilterValues = new App.AutoHotFilterSet();
            routeHotFilterValues.filters.forEach(f => {
                const name = f.name.toLowerCase();
                const filterControl = this.findControl(f.name);
                if (!filterControl)
                    return;
                const selectedValues = __classPrivateFieldGet(_a, _a, "m", _AutoRouteHotFilter_findElementByKey).call(_a, filters, name);
                switch (name) {
                    case App.AutoHotFilterFields.PickupPlace: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.pickup.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilter_instances, "m", _AutoRouteHotFilter_refreshSelectList).call(this, filterControl, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.DropoffPlace: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.dropoff.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilter_instances, "m", _AutoRouteHotFilter_refreshSelectList).call(this, filterControl, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.Category: {
                        const optionListData = Enumerable.from(autoOffers)
                            .selectMany(v => v.vehicle.category.split(','))
                            .select(v => v.trim())
                            .distinct()
                            .select(v => createListOption(selectedValues, v))
                            .orderBy(v => v.text, (a, b) => a.localeCompare(b))
                            .toArray();
                        __classPrivateFieldGet(this, _AutoRouteHotFilter_instances, "m", _AutoRouteHotFilter_refreshSelectList).call(this, filterControl, optionListData, selectedValues.length > 0, false);
                        break;
                    }
                    case App.AutoHotFilterFields.Model: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.vehicle.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilter_instances, "m", _AutoRouteHotFilter_refreshSelectList).call(this, filterControl, optionListData, selectedValues.length > 0, false);
                        break;
                    }
                    case App.AutoHotFilterFields.Provider: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.provider.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilter_instances, "m", _AutoRouteHotFilter_refreshSelectList).call(this, filterControl, optionListData, selectedValues.length > 0, false);
                        break;
                    }
                    case App.AutoHotFilterFields.Transmission: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.vehicle.transmissionType.code, val.vehicle.transmissionType.name))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilter_instances, "m", _AutoRouteHotFilter_refreshSelectList).call(this, filterControl, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.PassengersCount: {
                        const optionListData = autoOffers
                            .map(val => createListOption(selectedValues, val.vehicle.passengerCount.toString()))
                            .filter(unique)
                            .sort((a, b) => a.text.localeCompare(b.text));
                        __classPrivateFieldGet(this, _AutoRouteHotFilter_instances, "m", _AutoRouteHotFilter_refreshSelectList).call(this, filterControl, optionListData, selectedValues.length > 0, true);
                        break;
                    }
                    case App.AutoHotFilterFields.FreeCancellation: {
                        filterControl.setValue(selectedValues[0], false);
                        break;
                    }
                }
            });
            function createListOption(selectedVals, value, text = '') {
                const v = value.toLowerCase();
                return {
                    value: v,
                    text: text === '' ? value : text,
                    selected: selectedVals.includes(v),
                };
            }
            function unique(value, index, self) {
                return self.findIndex(val => val.value === value.value) === index;
            }
        }
        onHotFiltersChange(event) {
            const selectedHotFilters = this.routeHotFilter.find('input').serializeArray();
            const filters = selectedHotFilters
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            this.routeHotFilter.trigger("routeHotFilter:beforeFiltering" /* Events.RouteHotFilterBeforeFiltering */, [filters, event.target]);
            this.routeHotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('auto/hotFilterFoundTitle', { count: data.length }));
        }
    }
    _a = AutoRouteHotFilter, _AutoRouteHotFilter_instances = new WeakSet(), _AutoRouteHotFilter_refreshSelectList = function _AutoRouteHotFilter_refreshSelectList(control, options, defaultOptionSelected, needDefaultOption) {
        let optionListData = [];
        const filterListBlockBase = control;
        filterListBlockBase.clearOptions(false);
        if (needDefaultOption)
            optionListData.push(__classPrivateFieldGet(_a, _a, "m", _AutoRouteHotFilter_getSelectListDefaultOption).call(_a, defaultOptionSelected));
        optionListData = optionListData.concat(options);
        filterListBlockBase.replaceOptions(optionListData, true);
    }, _AutoRouteHotFilter_findElementByKey = function _AutoRouteHotFilter_findElementByKey(filters, key) {
        const t = filters.find(value => value.name === key);
        if (t)
            return t.values;
        return Array();
    }, _AutoRouteHotFilter_getSelectListDefaultOption = function _AutoRouteHotFilter_getSelectListDefaultOption(selected) {
        return { text: localizer.all, selected };
    };
    App.AutoRouteHotFilter = AutoRouteHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _AutoRouteResultMobile_urlChangeStrategy, _AutoRouteResultMobile_filterOffers;
    class AutoRouteResultMobile extends App.Result {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Auto.Route.BlockOutput_Mobile, tableTemplate: App.templates.Auto.Route.BlockOutput_Mobile }, options));
            _AutoRouteResultMobile_urlChangeStrategy.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AutoRouteResultMobile_urlChangeStrategy, new App.UrlChangeStrategy(new App.AutoHotFilterSet()), "f");
            __classPrivateFieldGet(this, _AutoRouteResultMobile_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
        }
        applySorting(items) {
            if (this.sorting.reverse) {
                return Enumerable.from(items)
                    .orderByDescending(v => v.grossPrice)
                    .thenByDescending(v => v.vehicle.name)
                    .toArray();
            }
            return Enumerable.from(items)
                .orderBy(v => v.grossPrice)
                .thenBy(v => v.vehicle.name)
                .toArray();
        }
        applyFilters(items) {
            let result = items;
            this.filtering.items.forEach(filter => {
                result = result.filter(item => __classPrivateFieldGet(_a, _a, "m", _AutoRouteResultMobile_filterOffers).call(_a, filter, item));
            });
            return result;
        }
        clearFilteringData() {
            this.filtering.items = [];
        }
    }
    _a = AutoRouteResultMobile, _AutoRouteResultMobile_urlChangeStrategy = new WeakMap(), _AutoRouteResultMobile_filterOffers = function _AutoRouteResultMobile_filterOffers(filter, item) {
        switch (filter.name.toLowerCase()) {
            case App.AutoHotFilterFields.PickupPlace:
                return filter.values.includes(item.pickup.name.toLowerCase());
            case App.AutoHotFilterFields.DropoffPlace:
                return filter.values.includes(item.dropoff.name.toLowerCase());
            case App.AutoHotFilterFields.Category:
                return item.vehicle.category.split(',')
                    .map(v => v.trim())
                    .some(v => filter.values.includes(v.toLowerCase()));
            case App.AutoHotFilterFields.Model:
                return filter.values.includes(item.vehicle.name.toLowerCase());
            case App.AutoHotFilterFields.Provider:
                return filter.values.includes(item.provider.name.toLowerCase());
            case App.AutoHotFilterFields.Transmission:
                return item.vehicle.transmissionType == null
                    ? false
                    : filter.values.includes(item.vehicle.transmissionType.code.toLowerCase());
            case App.AutoHotFilterFields.PassengersCount:
                return filter.values.includes(item.vehicle.passengerCount.toString());
            case App.AutoHotFilterFields.FreeCancellation:
                return filter.values.includes(item.freeCancellation.toString());
            default:
                return true;
        }
    };
    App.AutoRouteResultMobile = AutoRouteResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _AutoRouteResult_urlChangeStrategy, _AutoRouteResult_filterOffers;
    class AutoRouteResult extends App.Result {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Auto.Route.BlockOutput, tableTemplate: App.templates.Auto.Route.TableOutput }, options));
            _AutoRouteResult_urlChangeStrategy.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AutoRouteResult_urlChangeStrategy, new App.UrlChangeStrategy(new App.AutoHotFilterSet()), "f");
            __classPrivateFieldGet(this, _AutoRouteResult_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
            new App.Digest({ container: this.root });
        }
        applySorting(items) {
            if (this.sorting.reverse) {
                return Enumerable.from(items)
                    .orderByDescending(v => v.grossPrice)
                    .thenByDescending(v => v.vehicle.name)
                    .toArray();
            }
            return Enumerable.from(items)
                .orderBy(v => v.grossPrice)
                .thenBy(v => v.vehicle.name)
                .toArray();
        }
        applyFilters(items) {
            let result = items;
            this.filtering.items.forEach(filter => {
                result = result.filter(item => __classPrivateFieldGet(_a, _a, "m", _AutoRouteResult_filterOffers).call(_a, filter, item));
            });
            return result;
        }
        clearFilteringData() {
            this.filtering.items = [];
        }
    }
    _a = AutoRouteResult, _AutoRouteResult_urlChangeStrategy = new WeakMap(), _AutoRouteResult_filterOffers = function _AutoRouteResult_filterOffers(filter, item) {
        switch (filter.name.toLowerCase()) {
            case App.AutoHotFilterFields.PickupPlace:
                return filter.values.includes(item.pickup.name.toLowerCase());
            case App.AutoHotFilterFields.DropoffPlace:
                return filter.values.includes(item.dropoff.name.toLowerCase());
            case App.AutoHotFilterFields.Category:
                return item.vehicle.category.split(',')
                    .map(v => v.trim())
                    .some(v => filter.values.includes(v.toLowerCase()));
            case App.AutoHotFilterFields.Model:
                return filter.values.includes(item.vehicle.name.toLowerCase());
            case App.AutoHotFilterFields.Provider:
                return filter.values.includes(item.provider.name.toLowerCase());
            case App.AutoHotFilterFields.Transmission:
                return item.vehicle.transmissionType == null
                    ? false
                    : filter.values.includes(item.vehicle.transmissionType.code.toLowerCase());
            case App.AutoHotFilterFields.PassengersCount:
                return filter.values.includes(item.vehicle.passengerCount.toString());
            case App.AutoHotFilterFields.FreeCancellation:
                return filter.values.includes(item.freeCancellation.toString());
            default:
                return true;
        }
    };
    App.AutoRouteResult = AutoRouteResult;
})(App || (App = {}));
var App;
(function (App) {
    let AutoHotFilterFields;
    (function (AutoHotFilterFields) {
        AutoHotFilterFields.PickupPlace = 'pickupplace';
        AutoHotFilterFields.DropoffPlace = 'dropoffplace';
        AutoHotFilterFields.Category = 'category';
        AutoHotFilterFields.Model = 'model';
        AutoHotFilterFields.Transmission = 'transmission';
        AutoHotFilterFields.Provider = 'provider';
        AutoHotFilterFields.PassengersCount = 'passengerscount';
        AutoHotFilterFields.FreeCancellation = 'freecancellation';
    })(AutoHotFilterFields = App.AutoHotFilterFields || (App.AutoHotFilterFields = {}));
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Набор хот фильтров авто
     */
    class AutoHotFilterSet {
        constructor() {
            Object.defineProperty(this, "pickupPlace", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dropoffPlace", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "category", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "model", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "transmission", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "provider", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "passengersCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "freeCancellation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    { name: App.AutoHotFilterFields.PickupPlace },
                    { name: App.AutoHotFilterFields.DropoffPlace },
                    { name: App.AutoHotFilterFields.Category },
                    { name: App.AutoHotFilterFields.Model },
                    { name: App.AutoHotFilterFields.Transmission },
                    { name: App.AutoHotFilterFields.Provider },
                    { name: App.AutoHotFilterFields.PassengersCount },
                    { name: App.AutoHotFilterFields.FreeCancellation },
                ]
            });
        }
    }
    App.AutoHotFilterSet = AutoHotFilterSet;
})(App || (App = {}));
/// <reference path="../common/components/MainFilter.ts" />
var App;
(function (App) {
    var _AviaFormBaseMobile_instances, _a, _AviaFormBaseMobile_options, _AviaFormBaseMobile_customInfoBlocks, _AviaFormBaseMobile_commonInfoBlocksTemplate, _AviaFormBaseMobile_requiredUrlChecker, _AviaFormBaseMobile_extraRules, _AviaFormBaseMobile_setDependencies, _AviaFormBaseMobile_setSubmitAvailability;
    class AviaFormBaseMobile extends App.PageMobileBase {
        get requiredUrlChecker() {
            if (!__classPrivateFieldGet(this, _AviaFormBaseMobile_requiredUrlChecker, "f"))
                __classPrivateFieldSet(this, _AviaFormBaseMobile_requiredUrlChecker, new App.RequiredUrlChecker(new App.AviaUrlParameters()), "f");
            return __classPrivateFieldGet(this, _AviaFormBaseMobile_requiredUrlChecker, "f");
        }
        constructor(options) {
            super(Object.assign({}, options));
            _AviaFormBaseMobile_instances.add(this);
            _AviaFormBaseMobile_options.set(this, void 0);
            Object.defineProperty(this, "form", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "mainForm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "mainFilters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // protected mainFormInputs: JQuery;
            Object.defineProperty(this, "submitButton", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "submitButtonDependencies", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AviaFormBaseMobile_customInfoBlocks.set(this, void 0);
            _AviaFormBaseMobile_commonInfoBlocksTemplate.set(this, void 0);
            Object.defineProperty(this, "controls", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            Object.defineProperty(this, "renderSpeed", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0 /* RenderSpeed.slow */.toString()
            });
            _AviaFormBaseMobile_requiredUrlChecker.set(this, void 0);
            __classPrivateFieldSet(this, _AviaFormBaseMobile_options, options, "f");
            // console.log('AviaFormBaseMobile ---> ', this.#options);
            if (!this.root.length)
                return;
            if (__classPrivateFieldGet(this, _AviaFormBaseMobile_options, "f").content) {
                this.root
                    .empty()
                    .append(__classPrivateFieldGet(this, _AviaFormBaseMobile_options, "f").content);
            }
            __classPrivateFieldGet(_a, _a, "m", _AviaFormBaseMobile_extraRules).call(_a);
            __classPrivateFieldSet(this, _AviaFormBaseMobile_customInfoBlocks, App.templates.Avia.Messages.InfoBlocks({}), "f");
            __classPrivateFieldSet(this, _AviaFormBaseMobile_commonInfoBlocksTemplate, App.templates.InfoBlocks, "f");
            if (__classPrivateFieldGet(this, _AviaFormBaseMobile_options, "f").mainForm) {
                // TODO: MOBILE -> this.mainForm сделать AviaFormMobile и убрать this.form вообще
                this.mainForm = $(__classPrivateFieldGet(this, _AviaFormBaseMobile_options, "f").mainForm, this.root);
                this.form = new App.Form({ root: this.mainForm });
                // TODO: MOBILE
                // this.mainFormInputs = $('.js-form-item-field', this.mainForm);
                // this.mainFormInputs.on('change', e => this.checkOnError($(e.currentTarget)));
                this.submitButton = $('.js-submit-button', this.mainForm);
                this.submitButton.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield this.submitForm(e); }));
                __classPrivateFieldGet(this, _AviaFormBaseMobile_instances, "m", _AviaFormBaseMobile_setDependencies).call(this, this.mainForm);
            }
        }
        setMainFitlers(mainFilters) {
            this.mainFilters = mainFilters;
            if (!this.mainFilters)
                return;
            // вешаем доп проверки на наши контролы
            this.mainFilters.filters.controls.forEach(f => {
                const input = f.getInputRef();
                if (input) {
                    // inputmasks
                    input.addClass('js-form-item-field'); // TODO: скорее всего, это должно быть глобально всегда??
                    input.inputmask();
                    // validator rules
                    if (input.attr('data-regex')) {
                        input.rules('add', { aviaregex: true, messages: { aviaregex: 'Введите корректное значение.' } });
                    }
                    if (input.attr(`data-${"minlength" /* ValidationAttribute.MinLength */}`)) {
                        input.rules('add', { aviaminlength: true });
                    }
                    if (input.attr(`data-${"maxlength" /* ValidationAttribute.MaxLength */}`)) {
                        input.rules('add', { aviamaxlength: true });
                    }
                    if (f.root.attr('data-type') == 'email' || input.attr('data-type') == 'email') {
                        input.rules('add', { aviaemail: true });
                    }
                    if (f.root.attr('data-type') == 'documentnumber' || input.attr('data-type') == 'documentnumber') {
                        input.rules('add', { aviadocumentnumber: true });
                    }
                    if (f.root.attr('data-type') == 'lastname' || input.attr('data-type') == 'lastname') {
                        input.rules('add', { lastname: true });
                    }
                    if (f.root.attr('data-type') == 'firstname' || input.attr('data-type') == 'firstname') {
                        input.rules('add', { firstname: true });
                    }
                    if (f.root.attr('data-type') == 'middlename' || input.attr('data-type') == 'middlename') {
                        input.rules('add', { middlename: true });
                    }
                }
            });
        }
        reinitSubmitButton() {
            this.submitButton = $('.js-submit-button', this.mainForm);
            this.submitButton.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield this.submitForm(e); }));
            __classPrivateFieldGet(this, _AviaFormBaseMobile_instances, "m", _AviaFormBaseMobile_setDependencies).call(this, this.mainForm);
        }
        clear() {
        }
        checkOnError( /* target: JQuery*/) {
            // this.nameChanging(target);
            // this.birthdayChanging(target);
            /*
            target.closest('.js-form-field-block')
                .toggleClass('_invalid', !AviaFormBaseMobile.validateField(target));
            */
        }
        // можно ли отправлять форму
        formCanSend() {
            const form = this.mainForm;
            if (!form)
                return false;
            // TODO: у мобильных контролов смотрим через разметку класс?
            if (form.find('._invalid').length !== 0)
                form.addClass('_disabled');
            else
                form.removeClass('_disabled');
            return !form.hasClass('_disabled');
        }
        submitForm(event) {
            return __awaiter(this, void 0, void 0, function* () {
                /*
                if (this.form && !this.form.validator.form())
                    return true;
                */
                if (event)
                    event.preventDefault();
                if (this.mainFilters) {
                    this.mainFilters.filters.validate();
                    // ручная проверка каждого контрола на валидацию
                    if (!this.mainFilters.filters.validateControls()) {
                        // курсор на ошибку
                        // this.mainFormInputs.find('._invalid').first().find('input, textarea').trigger('focus');
                        return true;
                    }
                    // console.log(' -- try.. this.mainFilters.validator.form --> ' + (this.mainFilters.validator.form()), this.mainFilters);
                    if (!this.mainFilters.validator.form()) {
                        // this.mainFormInputs.find('._invalid').first().find('input, textarea').trigger('focus');
                        return true;
                    }
                }
                /*
                $.each(this.mainFormInputs, (i, item) => {
                    this.checkOnError($(item));
                });
    
                if (!this.formCanSend()) {
                    this.mainFormInputs.find('._invalid').first().find('input, textarea').trigger('focus');
                    if (event)
                        event.preventDefault();
                    return false;
                }
                */
                yield this.sendForm();
                if (this.mainForm)
                    this.mainForm.removeClass('js-not-send');
                return true;
            });
        }
        getInfoBlock(selector) {
            return $(__classPrivateFieldGet(this, _AviaFormBaseMobile_customInfoBlocks, "f")).find(selector);
        }
        getCommonInfoBlockCompact(message) {
            return this.getCommonInfoBlock(message.type, message.text);
        }
        getCommonInfoBlock(messageType, text) {
            return $(__classPrivateFieldGet(this, _AviaFormBaseMobile_commonInfoBlocksTemplate, "f").call(this, { type: messageType, text }));
        }
        static doAction(url_1) {
            return __awaiter(this, arguments, void 0, function* (url, data = {}, before = () => { }, always = () => { }) {
                try {
                    const xhr = $.ajax({
                        url,
                        method: 'POST',
                        data,
                        beforeSend: () => before(),
                        complete: () => always(),
                    });
                    return yield xhr;
                }
                catch (e) {
                    window.console.error(e);
                    return undefined;
                }
            });
        }
    }
    _a = AviaFormBaseMobile, _AviaFormBaseMobile_options = new WeakMap(), _AviaFormBaseMobile_customInfoBlocks = new WeakMap(), _AviaFormBaseMobile_commonInfoBlocksTemplate = new WeakMap(), _AviaFormBaseMobile_requiredUrlChecker = new WeakMap(), _AviaFormBaseMobile_instances = new WeakSet(), _AviaFormBaseMobile_extraRules = function _AviaFormBaseMobile_extraRules() {
        // однократно
        if ($.validator.methods.aviaregex)
            return;
        // extra rules
        // NOTE: чтобы не конфликтовать с другими логикой, то тут с префиксом avia - но в разметке у элементов без префикса
        $.validator.addMethod('aviaregex', function (value, element) {
            const mask = $(element).attr('data-regex');
            if (mask) {
                Object.assign($.validator.messages, { aviaregex: $(element).attr('data-msg-regex') || 'Введите корректное значение' });
                return this.optional(element) || (typeof value === 'string' && new RegExp(mask).test(value));
            }
            return false;
        });
        $.validator.addMethod('aviaemail', function (value, element) {
            Object.assign($.validator.messages, { aviaemail: $(element).attr('data-msg-email') || 'Укажите e-mail' });
            return this.optional(element) || (typeof value === 'string' && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zа-яёії\-0-9]+\.)+[a-zа-яёії]{2,}))$/i.test(value));
        });
        $.validator.addMethod('aviadocumentnumber', function () {
            // Object.assign($.validator.messages, { aviadocumentnumber: $(element).attr('data-msg-documentnumber')
            // || 'Укажите номер документа' });
            // return this.optional(element) || (typeof value === 'string' && /..$/.test(value));
            // TODO: в разметке нашел тип 'documentnumber', но не нашел метод валидации логику
            return true;
        });
        $.validator.addMethod('aviaminlength', function (value, element) {
            const minLen = $(element).attr(`data-${"minlength" /* ValidationAttribute.MinLength */}`);
            if (minLen) {
                Object.assign($.validator.messages, { aviaminlength: $(element).attr('data-msg-minlength') || ('Длина строки должна быть не менее ' + minLen + ' символов') });
                return this.optional(element) || (typeof value === 'string' && value.length >= parseInt(minLen, 10));
            }
            return false;
        });
        $.validator.addMethod('aviamaxlength', function (value, element) {
            const maxLen = $(element).attr(`data-${"maxlength" /* ValidationAttribute.MaxLength */}`);
            if (maxLen) {
                Object.assign($.validator.messages, { aviamaxlength: $(element).attr('data-msg-maxlength') || ('Длина строки должна быть не более ' + maxLen + ' символов') });
                return this.optional(element) || (typeof value === 'string' && value.length <= parseInt(maxLen, 10));
            }
            return false;
        });
        $.validator.addMethod('lastname', function (value, element) {
            Object.assign($.validator.messages, { lastname: $(element).attr('data-msg-lastname') || 'Введите фамилию' });
            return this.optional(element) || (typeof value === 'string' && /^[A-Z][A-Z-]{1,}$/.test(value));
        });
        $.validator.addMethod('firstname', function (value, element) {
            Object.assign($.validator.messages, { firstname: $(element).attr('data-msg-firstname') || 'Введите имя' });
            return this.optional(element) || (typeof value === 'string' && /^[A-Z][A-Z-]{1,}( [A-Z])?$/.test(value));
        });
        $.validator.addMethod('middlename', function (value, element) {
            Object.assign($.validator.messages, { middlename: $(element).attr('data-msg-middlename') || 'Введите отчество' });
            return this.optional(element) || (typeof value === 'string' && /^[A-Z]{2,}$/.test(value));
        });
    }, _AviaFormBaseMobile_setDependencies = function _AviaFormBaseMobile_setDependencies(mainForm) {
        const dependencies = this.submitButton.attr('data-depends');
        if (dependencies) {
            this.submitButtonDependencies = mainForm.find(`[data-name="${dependencies.split(',').join('"], [data-name="')}"]`);
            // Зависимость кнопки от чекбоксов [data-depends="name1,name1,..."]
            this.submitButtonDependencies
                .off()
                .on('change', () => __classPrivateFieldGet(this, _AviaFormBaseMobile_instances, "m", _AviaFormBaseMobile_setSubmitAvailability).call(this))
                .trigger('change');
        }
    }, _AviaFormBaseMobile_setSubmitAvailability = function _AviaFormBaseMobile_setSubmitAvailability() {
        if (this.submitButtonDependencies.filter(':checked').length !== this.submitButtonDependencies.length)
            this.submitButton.attr('disabled', 'disabled');
        else
            this.submitButton.removeAttr('disabled');
    };
    App.AviaFormBaseMobile = AviaFormBaseMobile;
})(App || (App = {}));
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/// <reference path='AviaFormBase.Mobile.ts' />
var App;
(function (App) {
    var _AviaBookPageMobile_instances, _AviaBookPageMobile_options, _AviaBookPageMobile_bookDigest, _AviaBookPageMobile_bookFilters, _AviaBookPageMobile_selectedGroup, _AviaBookPageMobile_selectedVariant, _AviaBookPageMobile_items, _AviaBookPageMobile_fareGroupComponent, _AviaBookPageMobile_submitExecuting, _AviaBookPageMobile_popup, _AviaBookPageMobile_responseValidator, _AviaBookPageMobile_contactTemplate, _AviaBookPageMobile_agentBlackListComponent, _AviaBookPageMobile_onBookFilterChanged, _AviaBookPageMobile_getBookFloaterDigest, _AviaBookPageMobile_getBookContentDigest, _AviaBookPageMobile_onBookSend, _AviaBookPageMobile_onChangeFare, _AviaBookPageMobile_book, _AviaBookPageMobile_getPassport;
    class AviaBookPageMobile extends App.AviaFormBaseMobile {
        constructor(options) {
            var _a;
            super(Object.assign({ root: '.js-avia-book-page', mainForm: '.js-quick-booking-form' }, options));
            _AviaBookPageMobile_instances.add(this);
            _AviaBookPageMobile_options.set(this, void 0);
            _AviaBookPageMobile_bookDigest.set(this, void 0);
            _AviaBookPageMobile_bookFilters.set(this, void 0);
            _AviaBookPageMobile_selectedGroup.set(this, void 0); // TODO: IAviaGroupMobile
            _AviaBookPageMobile_selectedVariant.set(this, void 0);
            _AviaBookPageMobile_items.set(this, void 0); // TODO: IAviaGroupMobile
            _AviaBookPageMobile_fareGroupComponent.set(this, void 0);
            // нельзя выносить в базовый класс!
            _AviaBookPageMobile_submitExecuting.set(this, void 0);
            _AviaBookPageMobile_popup.set(this, void 0);
            _AviaBookPageMobile_responseValidator.set(this, void 0);
            // #existingPassengers: ExistingPassengers;
            _AviaBookPageMobile_contactTemplate.set(this, void 0);
            _AviaBookPageMobile_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _AviaBookPageMobile_options, options, "f");
            __classPrivateFieldSet(this, _AviaBookPageMobile_selectedGroup, __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").group, "f");
            __classPrivateFieldSet(this, _AviaBookPageMobile_selectedVariant, __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").variant, "f");
            __classPrivateFieldSet(this, _AviaBookPageMobile_items, Enumerable.from(__classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").items).select(v => App.deepCopy(v)).toArray(), "f");
            __classPrivateFieldSet(this, _AviaBookPageMobile_submitExecuting, false, "f");
            // digest
            __classPrivateFieldSet(this, _AviaBookPageMobile_bookDigest, new App.DigestMobile({
                buttonTitle: 'Продолжить', // Забронировать
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_onBookSend).call(this),
                allowBooking: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").allowBooking,
            }), "f");
            __classPrivateFieldGet(this, _AviaBookPageMobile_bookDigest, "f").empty();
            __classPrivateFieldSet(this, _AviaBookPageMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaBookPageMobile_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaBookPageMobile_popup, "f")),
                validator: (_a = this.form) === null || _a === void 0 ? void 0 : _a.validator,
                allowEmptyData: true,
            }), "f");
            __classPrivateFieldSet(this, _AviaBookPageMobile_fareGroupComponent, new App.AviaFareGroupComponentMobile({
                root: this.root,
                items: __classPrivateFieldGet(this, _AviaBookPageMobile_items, "f"),
            }), "f");
            __classPrivateFieldGet(this, _AviaBookPageMobile_fareGroupComponent, "f").root.on("avia:changeFare" /* Events.AviaChangeFare */, (e, fare) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_onChangeFare).call(this, e, fare); }));
            App.ExistingPassengersMobile.Creates();
            App.FindTouristMobile.Creates();
            __classPrivateFieldSet(this, _AviaBookPageMobile_bookFilters, new App.FilterMobile({
                root: this.root,
                onFilterChanged: v => __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_onBookFilterChanged).call(this, v),
            }), "f");
            this.setMainFitlers(__classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f"));
            // TODO: to mobile?
            this.components.push(new App.AviaRulesComponent({
                root: this.root,
                popup: __classPrivateFieldGet(this, _AviaBookPageMobile_popup, "f"),
                responseValidator: __classPrivateFieldGet(this, _AviaBookPageMobile_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").urls.getFareRules,
                getVariantKey: () => __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f").key,
                getTranslationUrl: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").urls.getTranslation,
            }), new App.AviaTimeLimitComponent({
                root: this.root,
                responseValidator: __classPrivateFieldGet(this, _AviaBookPageMobile_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").urls.getExactTimeLimit,
                getVariant: () => __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f"),
            }), new App.AviaBrandFareComponent({
                root: this.root,
                popup: __classPrivateFieldGet(this, _AviaBookPageMobile_popup, "f"),
                responseValidator: __classPrivateFieldGet(this, _AviaBookPageMobile_responseValidator, "f"),
            }), __classPrivateFieldGet(this, _AviaBookPageMobile_fareGroupComponent, "f"));
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _AviaBookPageMobile_agentBlackListComponent, new App.AgentBlackListMobile({ useForm: true }), "f");
                this.components.push(__classPrivateFieldGet(this, _AviaBookPageMobile_agentBlackListComponent, "f"));
            }
            // this.mainFormInputs.inputmask();
            // $('.js-middle-name-absent', this.root).on('click', e => AviaBookPageMobile.#toggleMiddleName(e));
        }
        /**
         * Уничтожение объекта.
         * Отвязка своих контролов от прослушки/посылки событий.
         */
        dispose() {
            if (__classPrivateFieldGet(this, _AviaBookPageMobile_fareGroupComponent, "f"))
                __classPrivateFieldGet(this, _AviaBookPageMobile_fareGroupComponent, "f").dispose();
            if (__classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f"))
                __classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f").dispose();
        }
        refreshDigestData(data) {
            return __awaiter(this, void 0, void 0, function* () {
                const digestContent = yield __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_getBookContentDigest).call(this, data);
                yield App.CurrencyManager.convertAll(digestContent);
                const digestFloater = yield __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_getBookFloaterDigest).call(this, data);
                yield App.CurrencyManager.convertAll(digestFloater);
                yield __classPrivateFieldGet(this, _AviaBookPageMobile_bookDigest, "f").setContent(digestContent);
                __classPrivateFieldGet(this, _AviaBookPageMobile_bookDigest, "f").setFloater(digestFloater);
            });
        }
        /*
        #onTouristChosen(event: JQuery.TriggeredEvent, passengerWrap: JQuery): void {
            $('input', passengerWrap).each((i, v) => AviaFormBaseMobile.validateField($(v)));
            this.birthdayChanging(passengerWrap);
        }
        */
        nameChanging(target) {
            const dmw = target.attr('data-mask-words');
            if (typeof dmw === 'undefined')
                return;
            target.val(App.transliterateName(target.valString()));
        }
        birthdayChanging() {
            // если дата рождения всех туристов меньше 18 лет на дату вылета, то показываем сообщение
            // если хотя бы одна дата рождения не установлена, сообщение не показываем
            const minAdultAge = 18;
            const dspn = '_dspn';
            const msgBlock = $('#noAdultMessageBlock', this.root); // form);
            const departureDate = App.parseIsoDate(__classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f").legs[0].date);
            let hasAdult = false;
            const filtersBirths = __classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f").filters.filterControls(undefined, '.Birthday');
            $.each(filtersBirths, (i, item) => {
                const value = item.getValue() || ''; // $(item).val();
                if (!value) {
                    hasAdult = true;
                    return false;
                }
                const birthday = value;
                hasAdult = hasAdult
                    || ((departureDate.getFullYear() - birthday.getFullYear() > minAdultAge)
                        || (departureDate.getFullYear() - birthday.getFullYear() === minAdultAge
                            && (departureDate.getMonth() > birthday.getMonth()
                                || (departureDate.getMonth() === birthday.getMonth() && departureDate.getDate() >= birthday.getDate()))));
                return true;
            });
            if (!hasAdult)
                msgBlock.removeClass(dspn);
            else if (!msgBlock.hasClass(dspn))
                msgBlock.addClass(dspn);
        }
        /*
        static #toggleMiddleName(event: JQuery.ClickEvent): void {
            const target = $(event.currentTarget);
            const checked = target.is(':checked');
            const container = target.closest('.js-passenger');
            const requirement = checked ? 'Absent' : 'Required';
            $('.js-middle-name-requirement', container).val(requirement);
            const input = $('input[data-type="middlename"]', container);
            input.closest('.js-form-field').toggle(!checked);
            if (checked)
                input.closest('.js-form-field-block').removeAttr('_invalid');
        }
        */
        sendForm() {
            return __awaiter(this, void 0, void 0, function* () {
                if (__classPrivateFieldGet(this, _AviaBookPageMobile_submitExecuting, "f"))
                    return;
                __classPrivateFieldSet(this, _AviaBookPageMobile_submitExecuting, true, "f");
                if (__classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f").quickBooking) {
                    if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _AviaBookPageMobile_agentBlackListComponent, "f").checkAgree()) {
                        $(document)
                            .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                            .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_book).call(this); }));
                    }
                    else {
                        yield __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_book).call(this);
                    }
                }
                else {
                    yield __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_getPassport).call(this);
                }
                __classPrivateFieldSet(this, _AviaBookPageMobile_submitExecuting, false, "f");
            });
        }
        show(speed) {
            this.root.show(speed);
            if (this.mainForm)
                this.mainForm.fadeIn(400);
        }
        hide() {
            this.root.hide();
        }
    }
    _AviaBookPageMobile_options = new WeakMap(), _AviaBookPageMobile_bookDigest = new WeakMap(), _AviaBookPageMobile_bookFilters = new WeakMap(), _AviaBookPageMobile_selectedGroup = new WeakMap(), _AviaBookPageMobile_selectedVariant = new WeakMap(), _AviaBookPageMobile_items = new WeakMap(), _AviaBookPageMobile_fareGroupComponent = new WeakMap(), _AviaBookPageMobile_submitExecuting = new WeakMap(), _AviaBookPageMobile_popup = new WeakMap(), _AviaBookPageMobile_responseValidator = new WeakMap(), _AviaBookPageMobile_contactTemplate = new WeakMap(), _AviaBookPageMobile_agentBlackListComponent = new WeakMap(), _AviaBookPageMobile_instances = new WeakSet(), _AviaBookPageMobile_onBookFilterChanged = function _AviaBookPageMobile_onBookFilterChanged(filterName) {
        return __awaiter(this, void 0, void 0, function* () {
            // если сменили год рождения
            if (filterName.endsWith('.Birthday')) {
                this.birthdayChanging();
            }
            // отчество (подтверждение отсутствия)
            if (filterName.endsWith('.__New_IsMiddleNameAbsent')) {
                const ctrlToggle = __classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f").filters.findControl(filterName);
                if (ctrlToggle) {
                    const passengerIndex = ctrlToggle.root.attr('data-index');
                    // ставим/снимаем фильтру признак required
                    const ctrlMiddleNameFilterKey = 'Form.Passengers[' + passengerIndex + '].MiddleName';
                    const ctrlMiddleName = __classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f").filters.findControl(ctrlMiddleNameFilterKey);
                    const checked = ctrlToggle.getValue();
                    if (ctrlMiddleName) {
                        ctrlMiddleName.setRequired(!checked);
                        ctrlMiddleName.root.removeAttr('_invalid'); // ????
                    }
                    // .New.MiddleNameRequirement
                    const requirement = checked ? 'Absent' : 'Required';
                    const ctrlMiddleNameRequirementFilterKey = 'Form.Passengers[' + passengerIndex + '].New.MiddleNameRequirement';
                    const ctrlMiddleNameRequirement = __classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f").filters.findControl(ctrlMiddleNameRequirementFilterKey);
                    if (ctrlMiddleNameRequirement) {
                        ctrlMiddleNameRequirement.setValue(requirement, true);
                    }
                }
            }
        });
    }, _AviaBookPageMobile_getBookFloaterDigest = function _AviaBookPageMobile_getBookFloaterDigest(model) {
        return __awaiter(this, void 0, void 0, function* () {
            return $(App.templates.Avia.BookDigest_Floater_Mobile(model));
        });
    }, _AviaBookPageMobile_getBookContentDigest = function _AviaBookPageMobile_getBookContentDigest(model) {
        return __awaiter(this, void 0, void 0, function* () {
            return $(App.templates.Avia.BookDigest_Mobile(model));
        });
    }, _AviaBookPageMobile_onBookSend = function _AviaBookPageMobile_onBookSend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AviaBookPageMobile_bookDigest, "f"))
                __classPrivateFieldGet(this, _AviaBookPageMobile_bookDigest, "f").close();
            // do
            yield this.submitForm();
        });
    }, _AviaBookPageMobile_onChangeFare = function _AviaBookPageMobile_onChangeFare(event, fare) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaBookPageMobile_selectedGroup, fare, "f");
            const variant = __classPrivateFieldGet(this, _AviaBookPageMobile_fareGroupComponent, "f").defineCurrentFareFlight(__classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f"));
            if (variant)
                __classPrivateFieldSet(this, _AviaBookPageMobile_selectedVariant, variant, "f");
            const content = $(App.templates.Avia.FarePassengerInfo_Mobile(__classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f")));
            $('.js-fare-passenger-info-block', this.root)
                .empty()
                .append(content);
            yield App.CurrencyManager.convertAll(content);
            const showNetPrice = App.NetPricePresenter.getVisibility();
            __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").pricePresenter.show = showNetPrice;
            /*
            content = $(templates.Avia.BookDigest({
                ...this.#selectedGroup,
                selectedVariant: this.#selectedVariant,
                pricePresenter: this.#options.pricePresenter,
            }));
            $('.js-digest-fx', this.root)
                .empty()
                .append(content);
            await CurrencyManager.convertAll(content);
            this.components.push(new Digest({ container: this.root }));
            */
            yield this.refreshDigestData(Object.assign(Object.assign({}, __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f")), { selectedVariant: __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f"), pricePresenter: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").pricePresenter }));
            App.NetPricePresenter.setVisibility(__classPrivateFieldGet(this, _AviaBookPageMobile_bookDigest, "f").getContent(), showNetPrice);
            this.root.trigger("avia:changeVariantFare" /* Events.AviaVariantFareChange */, [__classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f"), __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f")]);
        });
    }, _AviaBookPageMobile_book = function _AviaBookPageMobile_book() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mainForm || !__classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f"))
                return;
            const variantKey = __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f").key;
            const searchAction = this.mainForm.attr('data-search-action') || '';
            const bookAction = this.mainForm.attr('data-action') || '';
            // const formData = this.mainForm.serialize();
            const formData = __classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f").filters.serialize();
            console.log('book -->', formData);
            const defaultErrorTitle = 'Ошибка бронирования';
            const defaultErrorMessage = 'Ошибка бронирования. Попробуйте еще раз через некоторое время.';
            const response = yield App.AviaFormBaseMobile.doAction(bookAction, `${formData}&Form.Variant=${variantKey}`, () => App.modalShow(this.getInfoBlock('.js-booking-message-block')));
            if (!response) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                return;
            }
            if (!response.status.success) {
                if (response.status.messages && response.status.messages.length > 0) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]), defaultErrorTitle);
                }
                else if (response.status.modelState) {
                    if (response.status.modelState.isValid === false && response.status.modelState.errors && response.status.modelState.errors[''])
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, response.status.modelState.errors[''][0]));
                    else
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                else {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                return;
            }
            if (response.redirect)
                window.location.href = response.redirect;
            // доп.информация: повторный поиск, дубли бронирвоаний и т.д.
            if (!response.data) {
                App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, 'Услуга успешно забронирована.'));
                return;
            }
            if (response.data.doubleBooking) {
                __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f").doubleBooking = true;
                const data = __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f");
                // TODO: to mobile
                const content = App.templates.Avia.BookAgreementBlock(Object.assign({}, data));
                $('.js-avia-booking-agreement-block').empty().append(content);
                this.components.push(new App.AviaRulesComponent({
                    root: this.root,
                    popup: __classPrivateFieldGet(this, _AviaBookPageMobile_popup, "f"),
                    responseValidator: __classPrivateFieldGet(this, _AviaBookPageMobile_responseValidator, "f"),
                    url: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").urls.getFareRules,
                    getVariantKey: () => __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f").key,
                    getTranslationUrl: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").urls.getTranslation,
                }));
                // TODO: разобраться почему нельзя вызвать через "super.reinitSubmitButton()"?
                this.reinitSubmitButton();
                this.root
                    .find('.js-agree-block')
                    .find(':checkbox:not(.js-agree-double-booking-input)')
                    .prop('checked', 'checked');
                const infoBlock = this.getInfoBlock('.js-double-booking-message-block');
                $('.js-message', infoBlock).text(response.data.message);
                $('.js-note', infoBlock).show();
                App.popupShow(infoBlock, 'Предупреждение');
                return;
            }
            // если данные протухли
            if (response.data.needSearch) {
                yield App.AviaFormBaseMobile.doAction(searchAction, formData, () => {
                    $('#results').empty();
                    App.modalShow(this.getInfoBlock('.js-result-expired-message-block'));
                });
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                    return;
                }
                if (!response.status.success) {
                    if (response.status.messages)
                        App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]), defaultErrorTitle);
                    else
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                    return;
                }
                yield __classPrivateFieldGet(this, _AviaBookPageMobile_instances, "m", _AviaBookPageMobile_book).call(this);
            }
            // для полного бронирования
            if (response.redirect)
                window.location.href = response.redirect;
            if (response.data && response.data.dialog)
                App.modalShow($(App.templates.RelatedServiceDialog(response.data.dialog)));
        });
    }, _AviaBookPageMobile_getPassport = function _AviaBookPageMobile_getPassport() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.mainForm || !__classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f"))
                return;
            const variantKey = __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f").key;
            const passportAction = this.mainForm.attr('data-passport-action') || '';
            // const formData = this.mainForm.serialize();
            const formData = __classPrivateFieldGet(this, _AviaBookPageMobile_bookFilters, "f").filters.serialize();
            // console.log('getPassport -->', formData);
            const defaultErrorTitle = 'Ошибка';
            const defaultErrorMessage = 'Ошибка. Попробуйте еще раз через некоторое время.';
            const response = yield App.AviaFormBaseMobile.doAction(passportAction, `${formData}&Form.Variant=${variantKey}`, () => App.modalShow(this.getInfoBlock('.js-passport-skip-message-block')));
            // console.log('getPassport response -->', response);
            App.popupHide();
            if (!response) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                return;
            }
            if (!response.status.success) {
                if (response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]), defaultErrorTitle);
                }
                else if (response.status.modelState) {
                    if (response.status.modelState.isValid === false && response.status.modelState.errors && response.status.modelState.errors[''])
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, response.status.modelState.errors[''][0]));
                    else
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                else {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                return;
            }
            if (response.data) {
                if (response.data.doubleBooking) {
                    const infoBlock = this.getInfoBlock('.js-double-booking-message-block');
                    if (response.data.message)
                        infoBlock.text(response.data.message);
                    App.popupShow(infoBlock, 'Предупреждение');
                }
                else if (!response.data.result) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                    return;
                }
            }
            if (response.data.result) {
                this.root.empty().append(response.data.result);
            }
            __classPrivateFieldSet(this, _AviaBookPageMobile_contactTemplate, App.templates.Avia.Contacts_Mobile, "f");
            __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f").doubleBooking = (_a = response.data.doubleBooking) !== null && _a !== void 0 ? _a : false;
            $('.js-contact-block', this.root).append(__classPrivateFieldGet(this, _AviaBookPageMobile_contactTemplate, "f").call(this, __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f")));
            // console.log('---> new App.PassportPageMobile <---');
            App.app.page = new App.PassportPageMobile({
                quickBooking: __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f").quickBooking,
                isDomestic: __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f").isDomestic,
                arrivalsInfo: __classPrivateFieldGet(this, _AviaBookPageMobile_selectedGroup, "f").arrivalsInfo,
                urls: {
                    skipFillPassport: '/avia/skipFillPassport/',
                },
            });
            this.components.push(new App.AviaRulesComponent({
                root: this.root,
                popup: __classPrivateFieldGet(this, _AviaBookPageMobile_popup, "f"),
                responseValidator: __classPrivateFieldGet(this, _AviaBookPageMobile_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").urls.getFareRules,
                getVariantKey: () => __classPrivateFieldGet(this, _AviaBookPageMobile_selectedVariant, "f").key,
                getTranslationUrl: __classPrivateFieldGet(this, _AviaBookPageMobile_options, "f").urls.getTranslation,
            }));
            const offset = this.root.offset();
            $('html, body').animate({ scrollTop: (offset != null ? offset.top : 0) }, this.renderSpeed);
        });
    };
    App.AviaBookPageMobile = AviaBookPageMobile;
})(App || (App = {}));
/// <reference path="../common/components/MainFilter.ts" />
var App;
(function (App) {
    var _AviaFormBase_instances, _AviaFormBase_options, _AviaFormBase_customInfoBlocks, _AviaFormBase_commonInfoBlocksTemplate, _AviaFormBase_requiredUrlChecker, _AviaFormBase_setDependencies, _AviaFormBase_setSubmitAvailability;
    class AviaFormBase extends App.PageBase {
        get requiredUrlChecker() {
            if (!__classPrivateFieldGet(this, _AviaFormBase_requiredUrlChecker, "f"))
                __classPrivateFieldSet(this, _AviaFormBase_requiredUrlChecker, new App.RequiredUrlChecker(new App.AviaUrlParameters()), "f");
            return __classPrivateFieldGet(this, _AviaFormBase_requiredUrlChecker, "f");
        }
        constructor(options) {
            super(Object.assign({}, options));
            _AviaFormBase_instances.add(this);
            _AviaFormBase_options.set(this, void 0);
            Object.defineProperty(this, "form", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "mainForm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "mainFormInputs", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "submitButton", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "submitButtonDependencies", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AviaFormBase_customInfoBlocks.set(this, void 0);
            _AviaFormBase_commonInfoBlocksTemplate.set(this, void 0);
            Object.defineProperty(this, "controls", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            Object.defineProperty(this, "renderSpeed", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 0 /* RenderSpeed.slow */.toString()
            });
            _AviaFormBase_requiredUrlChecker.set(this, void 0);
            __classPrivateFieldSet(this, _AviaFormBase_options, options, "f");
            if (!this.root.length)
                return;
            if (__classPrivateFieldGet(this, _AviaFormBase_options, "f").content) {
                this.root
                    .empty()
                    .append(__classPrivateFieldGet(this, _AviaFormBase_options, "f").content);
            }
            __classPrivateFieldSet(this, _AviaFormBase_customInfoBlocks, App.templates.Avia.Messages.InfoBlocks({}), "f");
            __classPrivateFieldSet(this, _AviaFormBase_commonInfoBlocksTemplate, App.templates.InfoBlocks, "f");
            if (__classPrivateFieldGet(this, _AviaFormBase_options, "f").mainForm) {
                this.mainForm = $(__classPrivateFieldGet(this, _AviaFormBase_options, "f").mainForm, this.root);
                this.form = new App.Form({ root: this.mainForm });
                this.mainFormInputs = $('.js-form-item-field', this.mainForm);
                this.mainFormInputs.on('change', e => this.checkOnError($(e.currentTarget)));
                this.submitButton = $('.js-submit-button', this.mainForm);
                this.submitButton.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield this.submitForm(e); }));
                __classPrivateFieldGet(this, _AviaFormBase_instances, "m", _AviaFormBase_setDependencies).call(this, this.mainForm);
            }
            const filterSelectBlock = this.root.find('.js-form-select-block');
            const filterScrollBlock = this.root.find('.js-form-scroll-block');
            const filterAutocompleteBlock = this.root.find('.js-form-autocomplete-block');
            const formDateBlock = this.root.find('.js-form-date-block');
            const filterSlidingBtn = this.root.find('.js-sliding-btn');
            // Обходим каждый блок с выпадающим списком
            filterSelectBlock.each((i, v) => { this.controls.push(new App.FilterSelectBlock({ root: $(v) })); });
            // Обходим каждый блок со списком прокрутки
            filterScrollBlock.each((i, v) => { this.controls.push(new App.FilterScrollBlock({ root: $(v) })); });
            // обходим каждый блок с autocomplete
            filterAutocompleteBlock.each((i, v) => { this.controls.push(new App.FilterAutocompleteBlock({ root: $(v) })); });
            filterSlidingBtn.on('click', e => {
                const target = $(e.currentTarget);
                const input = target.closest('.js-form-sliding-btn-b').find('input');
                target.toggleClass('_left _right');
                const value = target.hasClass('_right') ? 'Female' : 'Male';
                input.val(value);
                target.closest('.js-passenger').find('.js-form-gender-icon').toggleClass('_woman', target.hasClass('_right'));
            });
            formDateBlock.each((i, v) => {
                const dateOptions = {
                    root: $(v),
                    changeMonthYear: true,
                };
                const input = $(v).find('.js-form-date');
                const min = input.attr('data-min');
                if (min !== undefined) {
                    const minDate = App.parseDate(min);
                    dateOptions.minDate = minDate;
                }
                const max = input.attr('data-max');
                if (max !== undefined) {
                    const maxDate = App.parseDate(max);
                    dateOptions.maxDate = maxDate;
                }
                this.controls.push(new App.FilterDateBlock(dateOptions));
            });
            $(document).on("win:resizeEnd" /* Events.WinResizeEnd */, () => $('.js-form-date').datepicker('refresh'));
        }
        reinitSubmitButton() {
            this.submitButton = $('.js-submit-button', this.mainForm);
            this.submitButton.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield this.submitForm(e); }));
            __classPrivateFieldGet(this, _AviaFormBase_instances, "m", _AviaFormBase_setDependencies).call(this, this.mainForm);
        }
        clear() {
        }
        checkOnError(target) {
            this.nameChanging(target);
            this.birthdayChanging(target);
            target.closest('.js-form-field-block')
                .toggleClass('_invalid', !AviaFormBase.validateField(target));
        }
        nameChanging(target) {
            let newVal = '';
            const parentBlock = target.closest('.js-form-field-block');
            if (parentBlock.attr('data-type') !== 'documentnumber') {
                target.val(App.transliterateName(target.valString()));
                return;
            }
            const passenger = target.closest('.js-form-gender');
            const docType = $('.js-person-document-type', passenger).find('.js-jelect-input').val();
            newVal = target.valString().trim().toUpperCase();
            if (passenger) {
                if (docType === 'BirthdayNotification') {
                    // транслитирируем, если надо, при передаче поставщику на сервисах
                    target.val(newVal);
                }
                else {
                    newVal = App.transliterate(newVal);
                    target.val(newVal);
                }
            }
            else {
                newVal = App.transliterate(newVal);
                target.val(newVal);
            }
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        birthdayChanging(target) {
        }
        /* eslint-enable @typescript-eslint/no-unused-vars */
        static validateField(field) {
            if (!field.is(':visible') || field.is(':hidden'))
                return true;
            const wrap = field.closest('.js-form-field-block');
            const value = field.valString();
            const type = field.attr('data-type');
            const required = field.attr("required" /* ValidationAttribute.Required */);
            let isValid = !required && value.length <= 0;
            if (isValid)
                return true;
            if (required && value.length <= 0) {
                $('.form-item-error', wrap).text('Не заполнено поле');
                return false;
            }
            // если тип не указан, то, возможно, валидация настраивается отдельно скриптом и кладется в data-атрибуты ValidationAttribute
            if (!type) {
                const regex = field.attr(`data-${"regex" /* ValidationAttribute.Regex */}`);
                if (!regex)
                    return true;
                const error = field.attr(`data-${"error-message" /* ValidationAttribute.ErrorMessage */}`);
                // TODO: придумать текст сообщения
                if (!error || error.length <= 0)
                    $('.form-item-error', wrap).text('Неверно заполнено поле!');
                else
                    $('.form-item-error', wrap).text(error);
                isValid = new RegExp(regex).test(value);
                if (!isValid)
                    return false;
                const minLen = field.attr(`data-${"minlength" /* ValidationAttribute.MinLength */}`);
                if (minLen)
                    isValid = value.length >= parseInt(minLen, 10);
                if (!isValid)
                    return false;
                const maxLen = field.attr(`data-${"maxlength" /* ValidationAttribute.MaxLength */}`);
                if (maxLen)
                    isValid = value.length <= parseInt(maxLen, 10);
                if (!isValid)
                    return false;
            }
            else if (type === 'email') {
                isValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zа-яёії\-0-9]+\.)+[a-zа-яёії]{2,}))$/i
                    .test(value);
            }
            else if (type === 'date' || type === 'birthday') {
                if (App.parseDate(value))
                    isValid = true;
                else
                    isValid = false;
            }
            else if (type === 'lastname') {
                isValid = /^[A-Z][A-Z-]{1,}$/.test(value);
            }
            else if (type === 'firstname') {
                isValid = /^[A-Z][A-Z-]{1,}( [A-Z])?$/.test(value); // через пробел можно добавить первую букву отчества
            }
            else if (type === 'middlename') {
                isValid = /^[A-Z]{2,}$/.test(value);
            }
            return isValid;
        }
        // можно ли отправлять форму
        formCanSend() {
            const form = this.mainForm;
            if (!form)
                return false;
            if (form.find('._invalid').length !== 0)
                form.addClass('_disabled');
            else
                form.removeClass('_disabled');
            return !form.hasClass('_disabled');
        }
        submitForm(event) {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.form && !this.form.validator.form())
                    return true;
                $.each(this.mainFormInputs, (i, item) => {
                    this.checkOnError($(item));
                });
                if (!this.formCanSend()) {
                    this.mainFormInputs.find('._invalid').first().find('input, textarea').trigger('focus');
                    event.preventDefault();
                    return false;
                }
                yield this.sendForm();
                if (this.mainForm)
                    this.mainForm.removeClass('js-not-send');
                return true;
            });
        }
        getInfoBlock(selector) {
            return $(__classPrivateFieldGet(this, _AviaFormBase_customInfoBlocks, "f")).find(selector);
        }
        getCommonInfoBlockCompact(message) {
            return this.getCommonInfoBlock(message.type, message.text);
        }
        getCommonInfoBlock(messageType, text) {
            return $(__classPrivateFieldGet(this, _AviaFormBase_commonInfoBlocksTemplate, "f").call(this, { type: messageType, text }));
        }
        static doAction(url_1) {
            return __awaiter(this, arguments, void 0, function* (url, data = {}, before = () => { }, always = () => { }) {
                try {
                    const xhr = $.ajax({
                        url,
                        method: 'POST',
                        data,
                        beforeSend: () => before(),
                        complete: () => always(),
                    });
                    return yield xhr;
                }
                catch (e) {
                    window.console.error(e);
                    return undefined;
                }
            });
        }
    }
    _AviaFormBase_options = new WeakMap(), _AviaFormBase_customInfoBlocks = new WeakMap(), _AviaFormBase_commonInfoBlocksTemplate = new WeakMap(), _AviaFormBase_requiredUrlChecker = new WeakMap(), _AviaFormBase_instances = new WeakSet(), _AviaFormBase_setDependencies = function _AviaFormBase_setDependencies(mainForm) {
        const dependencies = this.submitButton.attr('data-depends');
        if (dependencies) {
            this.submitButtonDependencies = mainForm.find(`[data-name="${dependencies.split(',').join('"], [data-name="')}"]`);
            // Зависимость кнопки от чекбоксов [data-depends="name1,name1,..."]
            this.submitButtonDependencies
                .off()
                .on('change', () => __classPrivateFieldGet(this, _AviaFormBase_instances, "m", _AviaFormBase_setSubmitAvailability).call(this))
                .trigger('change');
        }
    }, _AviaFormBase_setSubmitAvailability = function _AviaFormBase_setSubmitAvailability() {
        if (this.submitButtonDependencies.filter(':checked').length !== this.submitButtonDependencies.length)
            this.submitButton.attr('disabled', 'disabled');
        else
            this.submitButton.removeAttr('disabled');
    };
    App.AviaFormBase = AviaFormBase;
})(App || (App = {}));
/// <reference path='AviaFormBase.ts' />
var App;
(function (App) {
    var _AviaBookPage_instances, _a, _AviaBookPage_options, _AviaBookPage_selectedGroup, _AviaBookPage_selectedVariant, _AviaBookPage_items, _AviaBookPage_fareGroupComponent, _AviaBookPage_submitExecuting, _AviaBookPage_popup, _AviaBookPage_responseValidator, _AviaBookPage_existingPassengers, _AviaBookPage_contactTemplate, _AviaBookPage_agentBlackListComponent, _AviaBookPage_onChangeFare, _AviaBookPage_onTouristChosen, _AviaBookPage_toggleMiddleName, _AviaBookPage_book, _AviaBookPage_getPassport, _AviaBookPage_checkPassengerUnique;
    class AviaBookPage extends App.AviaFormBase {
        constructor(options) {
            var _b;
            super(Object.assign({ root: '.js-avia-book-page', mainForm: '.js-quick-booking-form' }, options));
            _AviaBookPage_instances.add(this);
            _AviaBookPage_options.set(this, void 0);
            _AviaBookPage_selectedGroup.set(this, void 0);
            _AviaBookPage_selectedVariant.set(this, void 0);
            _AviaBookPage_items.set(this, void 0);
            _AviaBookPage_fareGroupComponent.set(this, void 0);
            // нельзя выносить в базовый класс!
            _AviaBookPage_submitExecuting.set(this, void 0);
            _AviaBookPage_popup.set(this, void 0);
            _AviaBookPage_responseValidator.set(this, void 0);
            _AviaBookPage_existingPassengers.set(this, void 0);
            _AviaBookPage_contactTemplate.set(this, void 0);
            _AviaBookPage_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _AviaBookPage_options, options, "f");
            __classPrivateFieldSet(this, _AviaBookPage_selectedGroup, __classPrivateFieldGet(this, _AviaBookPage_options, "f").group, "f");
            __classPrivateFieldSet(this, _AviaBookPage_selectedVariant, __classPrivateFieldGet(this, _AviaBookPage_options, "f").variant, "f");
            __classPrivateFieldSet(this, _AviaBookPage_items, Enumerable.from(__classPrivateFieldGet(this, _AviaBookPage_options, "f").items).select(v => App.deepCopy(v)).toArray(), "f");
            __classPrivateFieldSet(this, _AviaBookPage_submitExecuting, false, "f");
            this.components.push(new App.Digest({ container: this.root }), new App.FindTourist());
            if (__classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f").quickBooking && App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _AviaBookPage_agentBlackListComponent, new App.AgentBlackListComponent({ useForm: true }), "f");
                this.components.push(__classPrivateFieldGet(this, _AviaBookPage_agentBlackListComponent, "f"));
            }
            // TODO: сделать для прямой ссылки на бронирование.
            /* const data = {
                getFareRulesAction: this.options.urls.getFareRules,
                bookAction: this.options.urls.book,
                ...this.selectedGroup,
            };
            const content = $(this.bookTemplate(data));
            this.show(this.renderSpeed);*/
            // TODO Dragushin this.#form = new Form({ root: this.#filter.root, disableStepValidation: true });
            __classPrivateFieldSet(this, _AviaBookPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaBookPage_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaBookPage_popup, "f")),
                validator: (_b = this.form) === null || _b === void 0 ? void 0 : _b.validator,
                allowEmptyData: true,
            }), "f");
            __classPrivateFieldSet(this, _AviaBookPage_fareGroupComponent, new App.AviaFareGroupComponent({
                root: this.root,
                items: __classPrivateFieldGet(this, _AviaBookPage_items, "f"),
            }), "f");
            __classPrivateFieldGet(this, _AviaBookPage_fareGroupComponent, "f").root.on("avia:changeFare" /* Events.AviaChangeFare */, (e, fare) => __classPrivateFieldGet(this, _AviaBookPage_instances, "m", _AviaBookPage_onChangeFare).call(this, e, fare));
            this.components.push(new App.AviaRulesComponent({
                root: this.root,
                popup: __classPrivateFieldGet(this, _AviaBookPage_popup, "f"),
                responseValidator: __classPrivateFieldGet(this, _AviaBookPage_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaBookPage_options, "f").urls.getFareRules,
                getVariantKey: () => __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f").key,
                getTranslationUrl: __classPrivateFieldGet(this, _AviaBookPage_options, "f").urls.getTranslation,
            }), new App.AviaTimeLimitComponent({
                root: this.root,
                responseValidator: __classPrivateFieldGet(this, _AviaBookPage_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaBookPage_options, "f").urls.getExactTimeLimit,
                getVariant: () => __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f"),
            }), new App.AviaBrandFareComponent({
                root: this.root,
                popup: __classPrivateFieldGet(this, _AviaBookPage_popup, "f"),
                responseValidator: __classPrivateFieldGet(this, _AviaBookPage_responseValidator, "f"),
            }), __classPrivateFieldGet(this, _AviaBookPage_fareGroupComponent, "f"));
            this.mainFormInputs.inputmask();
            __classPrivateFieldSet(this, _AviaBookPage_existingPassengers, new App.ExistingPassengers(), "f");
            __classPrivateFieldGet(this, _AviaBookPage_existingPassengers, "f").root.on("tourist:choose" /* Events.TouristChoose */, (e, passengerWrap) => __classPrivateFieldGet(this, _AviaBookPage_instances, "m", _AviaBookPage_onTouristChosen).call(this, e, passengerWrap));
            $('.js-middle-name-absent', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaBookPage_toggleMiddleName).call(_a, e));
        }
        nameChanging(target) {
            const dmw = target.attr('data-mask-words');
            if (typeof dmw === 'undefined')
                return;
            target.val(App.transliterateName(target.valString()));
        }
        birthdayChanging(target) {
            // если дата рождения всех туристов меньше 18 лет на дату вылета, то показываем сообщение
            // если хотя бы одна дата рождения не установлена, сообщение не показываем
            if (!target.hasClass('js-form-date'))
                return;
            const minAdultAge = 18;
            const dspn = '_dspn';
            const form = target.closest('form');
            const msgBlock = $('#noAdultMessageBlock', form);
            const departureDate = App.parseIsoDate(__classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f").legs[0].date);
            let hasAdult = false;
            $.each(form.find('.js-form-date'), (i, item) => {
                const value = $(item).val();
                if (!value) {
                    hasAdult = true;
                    return false;
                }
                const vals = value.split('.');
                const birthday = new Date(parseInt(vals[2], 10), parseInt(vals[1], 10) - 1, parseInt(vals[0], 10));
                hasAdult = hasAdult
                    || ((departureDate.getFullYear() - birthday.getFullYear() > minAdultAge)
                        || (departureDate.getFullYear() - birthday.getFullYear() === minAdultAge
                            && (departureDate.getMonth() > birthday.getMonth()
                                || (departureDate.getMonth() === birthday.getMonth() && departureDate.getDate() >= birthday.getDate()))));
                return true;
            });
            if (!hasAdult)
                msgBlock.removeClass(dspn);
            else if (!msgBlock.hasClass(dspn))
                msgBlock.addClass(dspn);
        }
        formCanSend() {
            return __classPrivateFieldGet(this, _AviaBookPage_instances, "m", _AviaBookPage_checkPassengerUnique).call(this, this.mainForm.find('.js-passenger')) ? super.formCanSend() : false;
        }
        sendForm() {
            return __awaiter(this, void 0, void 0, function* () {
                if (__classPrivateFieldGet(this, _AviaBookPage_submitExecuting, "f"))
                    return;
                __classPrivateFieldSet(this, _AviaBookPage_submitExecuting, true, "f");
                if (__classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f").quickBooking) {
                    if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _AviaBookPage_agentBlackListComponent, "f").checkAgree()) {
                        $(document)
                            .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                            .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaBookPage_instances, "m", _AviaBookPage_book).call(this); }));
                    }
                    else {
                        yield __classPrivateFieldGet(this, _AviaBookPage_instances, "m", _AviaBookPage_book).call(this);
                    }
                }
                else {
                    yield __classPrivateFieldGet(this, _AviaBookPage_instances, "m", _AviaBookPage_getPassport).call(this);
                }
                __classPrivateFieldSet(this, _AviaBookPage_submitExecuting, false, "f");
            });
        }
        show(speed) {
            this.root.show(speed);
            if (this.mainForm)
                this.mainForm.fadeIn(400);
        }
        hide() {
            this.root.hide();
        }
    }
    _a = AviaBookPage, _AviaBookPage_options = new WeakMap(), _AviaBookPage_selectedGroup = new WeakMap(), _AviaBookPage_selectedVariant = new WeakMap(), _AviaBookPage_items = new WeakMap(), _AviaBookPage_fareGroupComponent = new WeakMap(), _AviaBookPage_submitExecuting = new WeakMap(), _AviaBookPage_popup = new WeakMap(), _AviaBookPage_responseValidator = new WeakMap(), _AviaBookPage_existingPassengers = new WeakMap(), _AviaBookPage_contactTemplate = new WeakMap(), _AviaBookPage_agentBlackListComponent = new WeakMap(), _AviaBookPage_instances = new WeakSet(), _AviaBookPage_onChangeFare = function _AviaBookPage_onChangeFare(event, fare) {
        __classPrivateFieldSet(this, _AviaBookPage_selectedGroup, fare, "f");
        const variant = __classPrivateFieldGet(this, _AviaBookPage_fareGroupComponent, "f").defineCurrentFareFlight(__classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f"));
        if (variant)
            __classPrivateFieldSet(this, _AviaBookPage_selectedVariant, variant, "f");
        let content = $(App.templates.Avia.FarePassengerInfo(__classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f")));
        $('.js-fare-passenger-info-block', this.root)
            .empty()
            .append(content);
        const showNetPrice = App.NetPricePresenter.getVisibility();
        __classPrivateFieldGet(this, _AviaBookPage_options, "f").pricePresenter.show = showNetPrice;
        content = $(App.templates.Avia.BookDigest(Object.assign(Object.assign({}, __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f")), { selectedVariant: __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f"), pricePresenter: __classPrivateFieldGet(this, _AviaBookPage_options, "f").pricePresenter })));
        $('.js-digest-fx', this.root)
            .empty()
            .append(content);
        this.components.push(new App.Digest({ container: this.root }));
        App.NetPricePresenter.setVisibility(content, showNetPrice);
        this.root.trigger("avia:changeVariantFare" /* Events.AviaVariantFareChange */, [__classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f"), __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f")]);
    }, _AviaBookPage_onTouristChosen = function _AviaBookPage_onTouristChosen(event, passengerWrap) {
        $('input', passengerWrap).each((i, v) => App.AviaFormBase.validateField($(v)));
        this.birthdayChanging(passengerWrap);
    }, _AviaBookPage_toggleMiddleName = function _AviaBookPage_toggleMiddleName(event) {
        const target = $(event.currentTarget);
        const checked = target.is(':checked');
        const container = target.closest('.js-passenger');
        const requirement = checked ? 'Absent' : 'Required';
        $('.js-middle-name-requirement', container).val(requirement);
        const input = $('input[data-type="middlename"]', container);
        input.closest('.js-form-field').toggle(!checked);
        if (checked)
            input.closest('.js-form-field-block').removeAttr('_invalid');
    }, _AviaBookPage_book = function _AviaBookPage_book() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mainForm)
                return;
            const variantKey = __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f").key;
            const searchAction = this.mainForm.attr('data-search-action') || '';
            const bookAction = this.mainForm.attr('data-action') || '';
            const formData = this.mainForm.serialize();
            const defaultErrorTitle = 'Ошибка бронирования';
            const defaultErrorMessage = 'Ошибка бронирования. Попробуйте еще раз через некоторое время.';
            const response = yield App.AviaFormBase.doAction(bookAction, `${formData}&Form.Variant=${variantKey}`, () => App.modalShow(this.getInfoBlock('.js-booking-message-block')));
            if (!response) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                return;
            }
            if (!response.status.success) {
                if (response.status.messages && response.status.messages.length > 0) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]), defaultErrorTitle);
                }
                else if (response.status.modelState) {
                    if (response.status.modelState.isValid === false && response.status.modelState.errors && response.status.modelState.errors[''])
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, response.status.modelState.errors[''][0]));
                    else
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                else {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                return;
            }
            if (response.redirect)
                window.location.href = response.redirect;
            // доп.информация: повторный поиск, дубли бронирований и т.д.
            if (!response.data) {
                App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, 'Услуга успешно забронирована.'));
                return;
            }
            if (response.data.doubleBooking) {
                __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f").doubleBooking = true;
                const data = __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f");
                const content = App.templates.Avia.BookAgreementBlock(Object.assign({}, data));
                $('.js-avia-booking-agreement-block').empty().append(content);
                this.components.push(new App.AviaRulesComponent({
                    root: this.root,
                    popup: __classPrivateFieldGet(this, _AviaBookPage_popup, "f"),
                    responseValidator: __classPrivateFieldGet(this, _AviaBookPage_responseValidator, "f"),
                    url: __classPrivateFieldGet(this, _AviaBookPage_options, "f").urls.getFareRules,
                    getVariantKey: () => __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f").key,
                    getTranslationUrl: __classPrivateFieldGet(this, _AviaBookPage_options, "f").urls.getTranslation,
                }));
                // TODO: разобраться почему нельзя вызвать через "super.reinitSubmitButton()"?
                this.reinitSubmitButton();
                this.root
                    .find('.js-agree-block')
                    .find(':checkbox:not(.js-agree-double-booking-input)')
                    .prop('checked', 'checked');
                const infoBlock = this.getInfoBlock('.js-double-booking-message-block');
                $('.js-message', infoBlock).text(response.data.message);
                $('.js-note', infoBlock).show();
                App.popupShow(infoBlock, 'Предупреждение');
                return;
            }
            // если данные протухли
            if (response.data.needSearch) {
                yield App.AviaFormBase.doAction(searchAction, formData, () => {
                    $('#results').empty();
                    App.modalShow(this.getInfoBlock('.js-result-expired-message-block'));
                });
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                    return;
                }
                if (!response.status.success) {
                    if (response.status.messages)
                        App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]), defaultErrorTitle);
                    else
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                    return;
                }
                yield __classPrivateFieldGet(this, _AviaBookPage_instances, "m", _AviaBookPage_book).call(this);
            }
            // для полного бронирования
            if (response.redirect)
                window.location.href = response.redirect;
            if (response.data && response.data.dialog)
                App.modalShow($(App.templates.RelatedServiceDialog(response.data.dialog)));
        });
    }, _AviaBookPage_getPassport = function _AviaBookPage_getPassport() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            if (!this.mainForm)
                return;
            const variantKey = __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f").key;
            const passportAction = this.mainForm.attr('data-passport-action') || '';
            const formData = this.mainForm.serialize();
            const defaultErrorTitle = 'Ошибка';
            const defaultErrorMessage = 'Ошибка. Попробуйте еще раз через некоторое время.';
            const response = yield App.AviaFormBase.doAction(passportAction, `${formData}&Form.Variant=${variantKey}`, () => App.modalShow(this.getInfoBlock('.js-passport-skip-message-block')));
            App.popupHide();
            if (!response) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                return;
            }
            if (!response.status.success) {
                if (response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]), defaultErrorTitle);
                }
                else if (response.status.modelState) {
                    if (response.status.modelState.isValid === false && response.status.modelState.errors && response.status.modelState.errors[''])
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, response.status.modelState.errors[''][0]));
                    else
                        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                else {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                }
                return;
            }
            if (response.data) {
                if (response.data.doubleBooking) {
                    const infoBlock = this.getInfoBlock('.js-double-booking-message-block');
                    if (response.data.message)
                        infoBlock.text(response.data.message);
                    App.popupShow(infoBlock, 'Предупреждение');
                }
                else if (!response.data.result) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, defaultErrorMessage));
                    return;
                }
            }
            if (response.data.result) {
                this.root.empty().append(response.data.result);
            }
            __classPrivateFieldSet(this, _AviaBookPage_contactTemplate, App.templates.Avia.Contacts, "f");
            __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f").doubleBooking = (_b = response.data.doubleBooking) !== null && _b !== void 0 ? _b : false;
            $('.js-contact-block', this.root).append(__classPrivateFieldGet(this, _AviaBookPage_contactTemplate, "f").call(this, __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f")));
            App.app.page = new App.PassportPage({
                quickBooking: __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f").quickBooking,
                isDomestic: __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f").isDomestic,
                arrivalsInfo: __classPrivateFieldGet(this, _AviaBookPage_selectedGroup, "f").arrivalsInfo,
                urls: {
                    skipFillPassport: '/avia/skipFillPassport/',
                },
            });
            this.components.push(new App.AviaRulesComponent({
                root: this.root,
                popup: __classPrivateFieldGet(this, _AviaBookPage_popup, "f"),
                responseValidator: __classPrivateFieldGet(this, _AviaBookPage_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaBookPage_options, "f").urls.getFareRules,
                getVariantKey: () => __classPrivateFieldGet(this, _AviaBookPage_selectedVariant, "f").key,
                getTranslationUrl: __classPrivateFieldGet(this, _AviaBookPage_options, "f").urls.getTranslation,
            }));
            const offset = this.root.offset();
            $('html, body').animate({ scrollTop: (offset != null ? offset.top : 0) }, this.renderSpeed);
        });
    }, _AviaBookPage_checkPassengerUnique = function _AviaBookPage_checkPassengerUnique(bookingList) {
        const errorMessage = 'Создание бронирования на пассажиров с одинаковыми ФИО и датами рождения запрещено.';
        const bookingItemArray = bookingList.toArray();
        const passengerStringSet = new Set();
        bookingItemArray.forEach(bookingItem => {
            let passengerString = '';
            $(bookingItem).find('[data-type="lastname"],[data-type="firstname"],[data-type="middlename"],[data-type="birthday"]')
                .each((_, element) => {
                passengerString += $(element).valString().toUpperCase().trim();
            });
            passengerStringSet.add(passengerString);
        });
        if (bookingItemArray.length === passengerStringSet.size)
            return true;
        App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, errorMessage));
        return false;
    };
    App.AviaBookPage = AviaBookPage;
})(App || (App = {}));
/// <reference path='AviaFormBase.ts' />
var App;
(function (App) {
    var _AviaGroupPageMobile_instances, _a, _AviaGroupPageMobile_options, _AviaGroupPageMobile_fareGroupComponent, _AviaGroupPageMobile_items, _AviaGroupPageMobile_selectedItem, _AviaGroupPageMobile_selectedVariant, _AviaGroupPageMobile_quickBookingButton, _AviaGroupPageMobile_timeLimitBlock, _AviaGroupPageMobile_popup, _AviaGroupPageMobile_responseValidator, _AviaGroupPageMobile_selectSingleRoute, _AviaGroupPageMobile_variantChoose, _AviaGroupPageMobile_informationToggle, _AviaGroupPageMobile_onStopsClick, _AviaGroupPageMobile_quickBookingToggle;
    class AviaGroupPageMobile extends App.AviaFormBase {
        constructor(options) {
            super(Object.assign({ root: '.js-avia-group-page' }, options));
            _AviaGroupPageMobile_instances.add(this);
            _AviaGroupPageMobile_options.set(this, void 0);
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AviaGroupPageMobile_fareGroupComponent.set(this, void 0);
            _AviaGroupPageMobile_items.set(this, void 0);
            _AviaGroupPageMobile_selectedItem.set(this, void 0);
            _AviaGroupPageMobile_selectedVariant.set(this, void 0);
            _AviaGroupPageMobile_quickBookingButton.set(this, void 0);
            _AviaGroupPageMobile_timeLimitBlock.set(this, void 0);
            _AviaGroupPageMobile_popup.set(this, void 0);
            _AviaGroupPageMobile_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _AviaGroupPageMobile_options, options, "f");
            __classPrivateFieldSet(this, _AviaGroupPageMobile_items, Enumerable.from(__classPrivateFieldGet(this, _AviaGroupPageMobile_options, "f").items).select(v => App.deepCopy(v)).orderBy(v => v.price).toArray(), "f");
            __classPrivateFieldSet(this, _AviaGroupPageMobile_selectedItem, __classPrivateFieldGet(this, _AviaGroupPageMobile_items, "f").find(v => v.selected) || __classPrivateFieldGet(this, _AviaGroupPageMobile_items, "f")[0], "f");
            this.root.find('.js-avia-variant-block-wrap._active').show();
            // TODO Dragushin this.#form = new Form({ root: this.#filter.root, disableStepValidation: true });
            __classPrivateFieldSet(this, _AviaGroupPageMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaGroupPageMobile_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaGroupPageMobile_popup, "f")),
                /* TODO
                validator: this.#form.validator,
                allowEmptyData: true,
                */
            }), "f");
            __classPrivateFieldSet(this, _AviaGroupPageMobile_fareGroupComponent, new App.AviaFareGroupComponentMobile({
                root: this.root,
                items: __classPrivateFieldGet(this, _AviaGroupPageMobile_items, "f"),
            }), "f");
            this.components.push(new App.AviaTimeLimitComponent({
                root: this.root,
                responseValidator: __classPrivateFieldGet(this, _AviaGroupPageMobile_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaGroupPageMobile_options, "f").urls.getExactTimeLimit,
                getVariant: () => __classPrivateFieldGet(this, _AviaGroupPageMobile_selectedVariant, "f") || null,
            }), __classPrivateFieldGet(this, _AviaGroupPageMobile_fareGroupComponent, "f"));
            __classPrivateFieldSet(this, _AviaGroupPageMobile_timeLimitBlock, $('.js-get-timelimit-block', this.root), "f");
            __classPrivateFieldGet(this, _AviaGroupPageMobile_timeLimitBlock, "f").hide();
            __classPrivateFieldGet(this, _AviaGroupPageMobile_instances, "m", _AviaGroupPageMobile_selectSingleRoute).call(this);
            __classPrivateFieldSet(this, _AviaGroupPageMobile_quickBookingButton, $('.js-quick-booking-btn', this.root), "f");
            __classPrivateFieldGet(this, _AviaGroupPageMobile_quickBookingButton, "f").on('click', () => __classPrivateFieldGet(this, _AviaGroupPageMobile_instances, "m", _AviaGroupPageMobile_quickBookingToggle).call(this));
            $('.js-segment-stop-info', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaGroupPageMobile_onStopsClick).call(_a, e));
            $('.js-baggage-btn', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaGroupPageMobile_informationToggle).call(_a, e));
            // mobile filters
            /*
            this.filters = new FiltersMobileBase({
                root: this.root,
                ignoreValidator: true,
                onFilterChanged: v => this.onFilterChanged(v),
            });
            */
        }
        /**
         * Уничтожение объекта.
         * Отвязка своих контролов от прослушки/посылки событий.
         */
        dispose() {
            if (this.filters)
                this.filters.dispose();
            if (__classPrivateFieldGet(this, _AviaGroupPageMobile_fareGroupComponent, "f"))
                __classPrivateFieldGet(this, _AviaGroupPageMobile_fareGroupComponent, "f").dispose();
        }
        onFilterChanged( /* filterName: string*/) {
            return __awaiter(this, void 0, void 0, function* () {
                // TODO:
            });
        }
        updateFares(items) {
            return __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _AviaGroupPageMobile_fareGroupComponent, "f").update(items);
            });
        }
        show(speed) {
            if (speed.length > 0)
                this.root.show(speed);
            else
                this.root.show();
        }
        hide() {
            this.root.hide();
        }
        sendForm() {
            throw new Error('Not implemented');
        }
    }
    _a = AviaGroupPageMobile, _AviaGroupPageMobile_options = new WeakMap(), _AviaGroupPageMobile_fareGroupComponent = new WeakMap(), _AviaGroupPageMobile_items = new WeakMap(), _AviaGroupPageMobile_selectedItem = new WeakMap(), _AviaGroupPageMobile_selectedVariant = new WeakMap(), _AviaGroupPageMobile_quickBookingButton = new WeakMap(), _AviaGroupPageMobile_timeLimitBlock = new WeakMap(), _AviaGroupPageMobile_popup = new WeakMap(), _AviaGroupPageMobile_responseValidator = new WeakMap(), _AviaGroupPageMobile_instances = new WeakSet(), _AviaGroupPageMobile_selectSingleRoute = function _AviaGroupPageMobile_selectSingleRoute() {
        // в мобильной версии только один вариант всегда
        __classPrivateFieldGet(this, _AviaGroupPageMobile_instances, "m", _AviaGroupPageMobile_variantChoose).call(this);
    }, _AviaGroupPageMobile_variantChoose = function _AviaGroupPageMobile_variantChoose() {
        const chosenFlights = [];
        $.each($('.js-avia-leg', this.root), (_, item) => {
            var _b;
            chosenFlights.push((_b = $(item).attr('data-flights')) !== null && _b !== void 0 ? _b : '');
        });
        const flightKey = chosenFlights.join();
        // ищем перелет
        const variant = __classPrivateFieldGet(this, _AviaGroupPageMobile_selectedItem, "f").variants
            .find(v => v.legs.map(x => x.flightNumbers).join(',') === flightKey);
        if (variant) {
            __classPrivateFieldSet(this, _AviaGroupPageMobile_selectedVariant, variant, "f");
            // TODO: проверить, всегда ли в одном блоке у всех перелетов один и тот же ТЛ.
            __classPrivateFieldGet(this, _AviaGroupPageMobile_timeLimitBlock, "f").toggle(variant !== undefined);
            if (variant) {
                $('.js-time-limit', this.root).text(variant.timeLimit);
                $('.js-get-exact-timelimit-block', this.root).toggle(!variant.timeLimitIsExact);
                $('.js-awaiter', this.root).hide();
            }
            // сделано: в урл добавляется выбранный перелет.
            // TODO: сделать переход на страницу группы с выделением указанного перелета.
            /* const variantIdx = window.location.href.indexOf('variant');
            let url: string;
            if (variantIdx > 0)
                url = `${window.location.href.substring(0, variantIdx + 8)}${variant.compositeKey}/`;
            else
                url = `${window.location.href}variant-${variant.compositeKey}/`;
            window.history.replaceState({ state: 2 }, 'Выбран перелет', url);*/
        }
        else {
            __classPrivateFieldSet(this, _AviaGroupPageMobile_selectedVariant, undefined, "f");
        }
        return true;
    }, _AviaGroupPageMobile_informationToggle = function _AviaGroupPageMobile_informationToggle(event) {
        const target = $(event.currentTarget);
        target.siblings('.js-baggage-content').slideToggle();
        target.toggleClass('_opened _closed');
    }, _AviaGroupPageMobile_onStopsClick = function _AviaGroupPageMobile_onStopsClick(event) {
        const target = $(event.currentTarget);
        const info = target.attr('data-info');
        if (!info)
            return;
        const infos = info.split('|');
        const form = $(App.templates.Avia.Stop({}));
        $.each(infos, (index, item) => $('.js-info', form).append($(`<div>${item}</div>`)));
        App.popupShow(form, 'Техническая посадка');
    }, _AviaGroupPageMobile_quickBookingToggle = function _AviaGroupPageMobile_quickBookingToggle() {
        if (!__classPrivateFieldGet(this, _AviaGroupPageMobile_selectedVariant, "f")) {
            App.popupShow(this.getInfoBlock('.js-booking-toggle-message-block'));
            return;
        }
        __classPrivateFieldSet(this, _AviaGroupPageMobile_selectedVariant, __classPrivateFieldGet(this, _AviaGroupPageMobile_fareGroupComponent, "f").defineCurrentFareFlight(__classPrivateFieldGet(this, _AviaGroupPageMobile_selectedVariant, "f")), "f");
        if (__classPrivateFieldGet(this, _AviaGroupPageMobile_selectedVariant, "f"))
            this.root.trigger("avia:book" /* Events.AviaBook */, [__classPrivateFieldGet(this, _AviaGroupPageMobile_selectedItem, "f"), __classPrivateFieldGet(this, _AviaGroupPageMobile_selectedVariant, "f")]);
    };
    App.AviaGroupPageMobile = AviaGroupPageMobile;
})(App || (App = {}));
/// <reference path='AviaFormBase.ts' />
var App;
(function (App) {
    var _AviaGroupPage_instances, _a, _AviaGroupPage_options, _AviaGroupPage_fareGroupComponent, _AviaGroupPage_items, _AviaGroupPage_selectedItem, _AviaGroupPage_selectedVariant, _AviaGroupPage_quickBookingButton, _AviaGroupPage_timeLimitBlock, _AviaGroupPage_popup, _AviaGroupPage_responseValidator, _AviaGroupPage_selectSingleRoute, _AviaGroupPage_sortVariants, _AviaGroupPage_onVariantChoose, _AviaGroupPage_variantChoose, _AviaGroupPage_showMoreVariants, _AviaGroupPage_informationToggle, _AviaGroupPage_onStopsClick, _AviaGroupPage_quickBookingToggle;
    class AviaGroupPage extends App.AviaFormBase {
        constructor(options) {
            super(Object.assign({ root: '.js-avia-group-page' }, options));
            _AviaGroupPage_instances.add(this);
            _AviaGroupPage_options.set(this, void 0);
            _AviaGroupPage_fareGroupComponent.set(this, void 0);
            _AviaGroupPage_items.set(this, void 0);
            _AviaGroupPage_selectedItem.set(this, void 0);
            _AviaGroupPage_selectedVariant.set(this, void 0);
            _AviaGroupPage_quickBookingButton.set(this, void 0);
            _AviaGroupPage_timeLimitBlock.set(this, void 0);
            _AviaGroupPage_popup.set(this, void 0);
            _AviaGroupPage_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _AviaGroupPage_options, options, "f");
            __classPrivateFieldSet(this, _AviaGroupPage_items, Enumerable.from(__classPrivateFieldGet(this, _AviaGroupPage_options, "f").items).select(v => App.deepCopy(v)).orderBy(v => v.price).toArray(), "f");
            __classPrivateFieldSet(this, _AviaGroupPage_selectedItem, __classPrivateFieldGet(this, _AviaGroupPage_items, "f").find(v => v.selected) || __classPrivateFieldGet(this, _AviaGroupPage_items, "f")[0], "f");
            this.root.find('.js-avia-variant-block-wrap._active').show();
            // TODO Dragushin this.#form = new Form({ root: this.#filter.root, disableStepValidation: true });
            __classPrivateFieldSet(this, _AviaGroupPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaGroupPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaGroupPage_popup, "f")),
                /* TODO
                validator: this.#form.validator,
                allowEmptyData: true,
                */
            }), "f");
            __classPrivateFieldSet(this, _AviaGroupPage_fareGroupComponent, new App.AviaFareGroupComponent({
                root: this.root,
                items: __classPrivateFieldGet(this, _AviaGroupPage_items, "f"),
            }), "f");
            this.components.push(new App.AviaTimeLimitComponent({
                root: this.root,
                responseValidator: __classPrivateFieldGet(this, _AviaGroupPage_responseValidator, "f"),
                url: __classPrivateFieldGet(this, _AviaGroupPage_options, "f").urls.getExactTimeLimit,
                getVariant: () => __classPrivateFieldGet(this, _AviaGroupPage_selectedVariant, "f") || null,
            }), __classPrivateFieldGet(this, _AviaGroupPage_fareGroupComponent, "f"));
            __classPrivateFieldSet(this, _AviaGroupPage_timeLimitBlock, $('.js-get-timelimit-block', this.root), "f");
            __classPrivateFieldGet(this, _AviaGroupPage_timeLimitBlock, "f").hide();
            __classPrivateFieldGet(this, _AviaGroupPage_instances, "m", _AviaGroupPage_selectSingleRoute).call(this);
            __classPrivateFieldSet(this, _AviaGroupPage_quickBookingButton, $('.js-quick-booking-btn', this.root), "f");
            __classPrivateFieldGet(this, _AviaGroupPage_quickBookingButton, "f").on('click', () => __classPrivateFieldGet(this, _AviaGroupPage_instances, "m", _AviaGroupPage_quickBookingToggle).call(this));
            $(this.root).on('click', '.js-show-more-variants', e => __classPrivateFieldGet(_a, _a, "m", _AviaGroupPage_showMoreVariants).call(_a, e));
            $('.js-avia-variant-block', this.root).on('click', e => __classPrivateFieldGet(this, _AviaGroupPage_instances, "m", _AviaGroupPage_onVariantChoose).call(this, e));
            $('.js-sort-item', this.root).on('click', e => __classPrivateFieldGet(this, _AviaGroupPage_instances, "m", _AviaGroupPage_sortVariants).call(this, e));
            $('.js-segment-stop-info', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaGroupPage_onStopsClick).call(_a, e));
            $('.js-baggage-btn', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaGroupPage_informationToggle).call(_a, e));
        }
        updateFares(items) {
            __classPrivateFieldGet(this, _AviaGroupPage_fareGroupComponent, "f").update(items);
        }
        static legSort(wrapper, target, value) {
            const items = wrapper.find('.js-avia-variant-block-wrap');
            const showMoreBlock = wrapper.find('.js-show-more-variants');
            const array = [];
            $.each(items, (i, item) => {
                array.push({ key: $(item).attr(`data-${value}`) || '', value: $(item), arrivalDate: $(item).attr('data-arrival') || '' });
                $(item).remove();
            });
            const sort = (a, b, sign) => {
                const ai = parseInt(a, 10);
                const bi = parseInt(b, 10);
                if (ai === bi)
                    return 0;
                return (ai > bi ? 1 : -1) * sign;
            };
            let sortedArray;
            if (target) {
                if (!target.hasClass('_active')) {
                    sortedArray = array.sort((a, b) => sort(a.key, b.key, 1));
                    target.addClass('_active');
                    target.siblings('.js-sort-item').removeClass('_active');
                }
                else {
                    sortedArray = array.sort((a, b) => sort(a.key, b.key, target.hasClass('_sort-up') ? -1 : 1));
                    target.toggleClass('_sort-up _sort-down');
                }
            }
            else {
                sortedArray = Enumerable.from(array).orderBy(v => v.key).thenBy(v => v.arrivalDate).toArray();
            }
            showMoreBlock.remove();
            $.each(sortedArray, (i, item) => {
                wrapper.append(item.value);
            });
            wrapper.append(showMoreBlock);
        }
        show(speed) {
            if (speed.length > 0)
                this.root.show(speed);
            else
                this.root.show();
        }
        hide() {
            this.root.hide();
        }
        sendForm() {
            throw new Error('Not implemented');
        }
    }
    _a = AviaGroupPage, _AviaGroupPage_options = new WeakMap(), _AviaGroupPage_fareGroupComponent = new WeakMap(), _AviaGroupPage_items = new WeakMap(), _AviaGroupPage_selectedItem = new WeakMap(), _AviaGroupPage_selectedVariant = new WeakMap(), _AviaGroupPage_quickBookingButton = new WeakMap(), _AviaGroupPage_timeLimitBlock = new WeakMap(), _AviaGroupPage_popup = new WeakMap(), _AviaGroupPage_responseValidator = new WeakMap(), _AviaGroupPage_instances = new WeakSet(), _AviaGroupPage_selectSingleRoute = function _AviaGroupPage_selectSingleRoute() {
        // всем единственным перелетам в плече добавляем класс _active
        $.each($('.js-avia-variants-wrap', this.root), (i, item) => {
            const variants = $(item).find('.js-avia-variant-block-wrap');
            if (variants.length === 1)
                __classPrivateFieldGet(this, _AviaGroupPage_instances, "m", _AviaGroupPage_variantChoose).call(this, $(variants[0]));
            $(item).find('.js-show-more-variants').hide();
        });
    }, _AviaGroupPage_sortVariants = function _AviaGroupPage_sortVariants(event) {
        const target = $(event.currentTarget);
        const wrapper = target.closest('.js-avia-variants-wrap');
        const sortField = target.attr('data-sort-field');
        if (!sortField)
            return;
        _a.legSort(wrapper, target, sortField);
        $('.js-avia-variant-block', this.root).on('click', e => __classPrivateFieldGet(this, _AviaGroupPage_instances, "m", _AviaGroupPage_onVariantChoose).call(this, e));
    }, _AviaGroupPage_onVariantChoose = function _AviaGroupPage_onVariantChoose(event) {
        const selfWrapper = $(event.currentTarget).closest('.js-avia-variant-block-wrap');
        return __classPrivateFieldGet(this, _AviaGroupPage_instances, "m", _AviaGroupPage_variantChoose).call(this, selfWrapper);
    }, _AviaGroupPage_variantChoose = function _AviaGroupPage_variantChoose(variantWrapper) {
        var _b;
        const wrap = variantWrapper.closest('.js-avia-variants-wrap');
        const others = wrap.find('.js-avia-variant-block-wrap');
        const showMore = wrap.find('.js-show-more-variants');
        const sorting = wrap.find('.js-avia-variants-sort');
        if (variantWrapper.hasClass('_active'))
            return false;
        others.filter('._active').removeClass('_active');
        variantWrapper.addClass('_active');
        others.not('._active').slideUp();
        sorting.slideUp();
        showMore.removeClass('_unfolded');
        showMore.addClass('_folded');
        showMore.slideDown();
        const chosenFlights = [];
        $.each($('.js-avia-variant-block-wrap._active', this.root), (_, item) => {
            var _b;
            chosenFlights.push((_b = $(item).attr('data-flights')) !== null && _b !== void 0 ? _b : '');
        });
        const flightKey = chosenFlights.join();
        // ищем перелет
        const variant = __classPrivateFieldGet(this, _AviaGroupPage_selectedItem, "f").variants
            .find(v => v.legs.map(x => x.flightNumbers).join(',') === flightKey);
        if (variant) {
            __classPrivateFieldSet(this, _AviaGroupPage_selectedVariant, variant, "f");
            // TODO: проверить, всегда ли в одном блоке у всех перелетов один и тот же ТЛ.
            __classPrivateFieldGet(this, _AviaGroupPage_timeLimitBlock, "f").toggle(variant !== undefined);
            if (variant) {
                $('.js-time-limit', this.root).text(variant.timeLimit);
                $('.js-get-exact-timelimit-block', this.root).toggle(!variant.timeLimitIsExact);
                $('.js-awaiter', this.root).hide();
            }
            // сделано: в урл добавляется выбранный перелет.
            // TODO: сделать переход на страницу группы с выделением указанного перелета.
            /* const variantIdx = window.location.href.indexOf('variant');
            let url: string;
            if (variantIdx > 0)
                url = `${window.location.href.substring(0, variantIdx + 8)}${variant.compositeKey}/`;
            else
                url = `${window.location.href}variant-${variant.compositeKey}/`;
            window.history.replaceState({ state: 2 }, 'Выбран перелет', url);*/
        }
        else {
            __classPrivateFieldSet(this, _AviaGroupPage_selectedVariant, undefined, "f");
        }
        // УСТАНОВКА ДОСТУПНЫХ ПЕРЕЛЕТОВ
        // у каждой группы есть свой хидн-список маршрутов вида 123.234.345;456.567;678.789|123.230.345;450.567;678.780
        // блокируем те варианты, которые не составляют существующие марштуты.
        const { legCount } = __classPrivateFieldGet(this, _AviaGroupPage_selectedItem, "f");
        const legSeparator = ';';
        // берем ВСЕ выбранные перелеты
        const selectedRoutes = [];
        $('.js-avia-variants-wrap', this.root).each((i, item) => {
            const block = $('.js-avia-variant-block-wrap._active', item);
            if (block.length > 0)
                selectedRoutes[i] = block.attr('data-flights') || '';
        });
        // проходим по всем другим плечам и закрываем те невыбранные, которых нет среди существующих маршрутов.
        // Если в группе есть выбранный вариант, то помечаем все несуществующие варианты специальным атрибутом.
        // При раскрытии вариантов открываем только варианты без этого атрибута.
        $.each(this.root.find(`.js-avia-variant-block-wrap[name!=${(_b = variantWrapper.attr('name')) !== null && _b !== void 0 ? _b : '0'}]`).not('._active'), (i, block) => {
            const legIndex = parseInt($(block).attr('name') || '0', 10); // индекс плеча.
            let routeExists = false;
            // проходим по всем существующим подходящим маршрутам
            $.each(__classPrivateFieldGet(this, _AviaGroupPage_selectedItem, "f").routes, (j, item) => {
                if (!routeExists) {
                    let found = true;
                    // проходим по выбранному маршруту
                    for (let k = 0; k < legCount.length; k++) {
                        // если плечо то же, то выбранный в нем вариант не проверяем на присутствие в существующих маршрутах
                        if (legIndex === k || selectedRoutes[k] == null)
                            continue;
                        if (selectedRoutes[k] !== item.split(legSeparator)[k]) {
                            found = false;
                            break;
                        }
                    }
                    // нашли один из похожих маршрутов, ищем вхождения в него checkbox-маршрута
                    if (found && item.split(legSeparator)[legIndex] === ($(block).attr('data-flights') || ''))
                        routeExists = true;
                }
            });
            if (!routeExists) {
                $(block).hide('fast');
                $(block).attr('absent', 'true');
            }
            else {
                $(block).removeAttr('absent');
                // показываем только те варианты, которые уже видны (не свернуты)
                const showVariants = $(block).closest('.js-avia-variants-wrap').find('.js-show-more-variants');
                // либо нет выбранного варианта, либо выбран, но раскрыты альтернативы.
                if ($(block).closest('.js-avia-variants-wrap').find('.js-avia-variant-block-wrap._active').length === 0
                    || (showVariants.hasClass('_unfolded') && !showVariants.is(':visible')))
                    $(block).show('fast');
            }
        });
        return true;
    }, _AviaGroupPage_showMoreVariants = function _AviaGroupPage_showMoreVariants(event) {
        const self = $(event.currentTarget);
        const wrap = self.closest('.js-avia-variants-wrap');
        const others = wrap.find('.js-avia-variant-block-wrap').not('._active').not('[absent]');
        const sorting = wrap.find('.js-avia-variants-sort');
        if (self.hasClass('_folded')) {
            others.slideDown();
            sorting.slideDown();
            self.removeClass('_folded');
            self.addClass('_unfolded');
            self.slideUp();
        }
    }, _AviaGroupPage_informationToggle = function _AviaGroupPage_informationToggle(event) {
        const target = $(event.currentTarget);
        target.siblings('.js-baggage-content').slideToggle();
        target.toggleClass('_opened _closed');
    }, _AviaGroupPage_onStopsClick = function _AviaGroupPage_onStopsClick(event) {
        const target = $(event.currentTarget);
        const info = target.attr('data-info');
        if (!info)
            return;
        const infos = info.split('|');
        const form = $(App.templates.Avia.Stop({}));
        $.each(infos, (index, item) => $('.js-info', form).append($(`<div>${item}</div>`)));
        App.popupShow(form, 'Техническая посадка');
    }, _AviaGroupPage_quickBookingToggle = function _AviaGroupPage_quickBookingToggle() {
        if (!__classPrivateFieldGet(this, _AviaGroupPage_selectedVariant, "f")) {
            App.popupShow(this.getInfoBlock('.js-booking-toggle-message-block'));
            return;
        }
        __classPrivateFieldSet(this, _AviaGroupPage_selectedVariant, __classPrivateFieldGet(this, _AviaGroupPage_fareGroupComponent, "f").defineCurrentFareFlight(__classPrivateFieldGet(this, _AviaGroupPage_selectedVariant, "f")), "f");
        if (__classPrivateFieldGet(this, _AviaGroupPage_selectedVariant, "f"))
            this.root.trigger("avia:book" /* Events.AviaBook */, [__classPrivateFieldGet(this, _AviaGroupPage_selectedItem, "f"), __classPrivateFieldGet(this, _AviaGroupPage_selectedVariant, "f")]);
    };
    App.AviaGroupPage = AviaGroupPage;
})(App || (App = {}));
/// <reference path='AviaFormBase.ts' />
/// <reference path='../common/models/ISelectListItem.ts' />
var App;
(function (App) {
    var _AviaPage_instances, _a, _AviaPage_options, _AviaPage_partialSearchFirstInterval, _AviaPage_partialSearchInterval, _AviaPage_partialLastSearchInterval, _AviaPage_usePartialSearch, _AviaPage_defaultPageSize, _AviaPage_messages, _AviaPage_preloader, _AviaPage_filter, _AviaPage_popup, _AviaPage_responseValidator, _AviaPage_hotFilter, _AviaPage_groupPage, _AviaPage_bookPage, _AviaPage_searchType, _AviaPage_stopPartialSearch, _AviaPage_searchData, _AviaPage_searchInitXhr, _AviaPage_searchXhr, _AviaPage_searchResponse, _AviaPage_searchExpirationPopup, _AviaPage_currentItems, _AviaPage_currentGroups, _AviaPage_selectedGroupKey, _AviaPage_selectedGroup, _AviaPage_selectedVariant, _AviaPage_currentPage, _AviaPage_hotFilterContainer, _AviaPage_resultBlock, _AviaPage_digest, _AviaPage_totalsContainer, _AviaPage_resultContainer, _AviaPage_showMoreBlock, _AviaPage_showMoreLink, _AviaPage_showMoreCurrent, _AviaPage_showMoreCountSelected, _AviaPage_showMoreCountOption, _AviaPage_showMoreTotal, _AviaPage_totalsTemplate, _AviaPage_resultTemplate, _AviaPage_hotFilterTemplate, _AviaPage_pagingTemplate, _AviaPage_groupTemplate, _AviaPage_bookTemplate, _AviaPage_currentResultType, _AviaPage_currentPageSize, _AviaPage_currentPageNumber, _AviaPage_currentSortingInfo, _AviaPage_historyStates, _AviaPage_pageState, _AviaPage_pricePresenter, _AviaPage_currencyConverter, _AviaPage_tabs, _AviaPage_canSearch, _AviaPage_onSearch, _AviaPage_onSearchPartial, _AviaPage_searchByDate, _AviaPage_onStartPartialSearch, _AviaPage_checkControlSum, _AviaPage_doPartialSearch, _AviaPage_addGroups, _AviaPage_searchByBestPrice, _AviaPage_onSearchBefore, _AviaPage_resetData, _AviaPage_resetControls, _AviaPage_showResults, _AviaPage_showBestPriceResults, _AviaPage_onMatrixCellSearch, _AviaPage_showServerHotFilter, _AviaPage_showHotFilter, _AviaPage_activateHotFilter, _AviaPage_changeData, _AviaPage_appendGroups, _AviaPage_getSortVariants, _AviaPage_onSorting, _AviaPage_initViewTypeTabs, _AviaPage_onChangeResultType, _AviaPage_initPageNumbers, _AviaPage_changePageNumber, _AviaPage_changePageSize, _AviaPage_onShowMoreGroupsClick, _AviaPage_showShowMoreGroups, _AviaPage_onHotFilterChange, _AviaPage_renderTotals, _AviaPage_onChangeGroupFare, _AviaPage_onChangeVariantFare, _AviaPage_onGroupClick, _AviaPage_getGroup, _AviaPage_getCurrentGroups, _AviaPage_getGroups, _AviaPage_sort, _AviaPage_setCurrentPageType, _AviaPage_setCurrentSorting, _AviaPage_getCurrentPageType, _AviaPage_gotoGroupPage, _AviaPage_findVariant, _AviaPage_gotoBookPage, _AviaPage_onAviaBook, _AviaPage_prepareBookPage, _AviaPage_onHistoryPopState, _AviaPage_hideSearchPage, _AviaPage_showSearchPage, _AviaPage_showResultPage, _AviaPage_showResultPageCase, _AviaPage_hideGroupPage, _AviaPage_showGroupPage, _AviaPage_hideBookPage, _AviaPage_showBookPage;
    let AviaSearchType;
    (function (AviaSearchType) {
        AviaSearchType[AviaSearchType["Date"] = 0] = "Date";
        AviaSearchType[AviaSearchType["BestPrice"] = 1] = "BestPrice";
    })(AviaSearchType || (AviaSearchType = {}));
    let AviaSortVariant;
    (function (AviaSortVariant) {
        AviaSortVariant[AviaSortVariant["Price"] = 0] = "Price";
        AviaSortVariant[AviaSortVariant["DepartureTime"] = 1] = "DepartureTime";
        AviaSortVariant[AviaSortVariant["ArrivalTime"] = 2] = "ArrivalTime";
        AviaSortVariant[AviaSortVariant["ChangeAircraftDuration"] = 3] = "ChangeAircraftDuration";
        AviaSortVariant[AviaSortVariant["TotalWayTime"] = 4] = "TotalWayTime";
    })(AviaSortVariant || (AviaSortVariant = {}));
    let AviaResultType;
    (function (AviaResultType) {
        AviaResultType[AviaResultType["group"] = 0] = "group";
        AviaResultType[AviaResultType["flat"] = 1] = "flat";
    })(AviaResultType = App.AviaResultType || (App.AviaResultType = {}));
    class AviaPage extends App.AviaFormBase {
        constructor(options) {
            var _b, _c, _d, _e, _f, _g;
            super(Object.assign({ root: '.js-avia-page' }, options));
            _AviaPage_instances.add(this);
            _AviaPage_options.set(this, void 0);
            _AviaPage_usePartialSearch.set(this, true);
            _AviaPage_messages.set(this, void 0);
            _AviaPage_preloader.set(this, void 0);
            _AviaPage_filter.set(this, void 0);
            // #form: Form;
            _AviaPage_popup.set(this, void 0);
            _AviaPage_responseValidator.set(this, void 0);
            _AviaPage_hotFilter.set(this, void 0);
            _AviaPage_groupPage.set(this, void 0);
            _AviaPage_bookPage.set(this, void 0);
            _AviaPage_searchType.set(this, void 0);
            _AviaPage_stopPartialSearch.set(this, false);
            _AviaPage_searchData.set(this, void 0);
            _AviaPage_searchInitXhr.set(this, void 0);
            _AviaPage_searchXhr.set(this, void 0);
            _AviaPage_searchResponse.set(this, void 0);
            _AviaPage_searchExpirationPopup.set(this, void 0);
            // текущие плоские результаты, с учетом фильтрации и др.
            _AviaPage_currentItems.set(this, void 0);
            _AviaPage_currentGroups.set(this, void 0);
            _AviaPage_selectedGroupKey.set(this, void 0);
            _AviaPage_selectedGroup.set(this, void 0);
            _AviaPage_selectedVariant.set(this, void 0);
            _AviaPage_currentPage.set(this, 0 /* AviaPageState.Search */);
            _AviaPage_hotFilterContainer.set(this, void 0);
            _AviaPage_resultBlock.set(this, void 0);
            _AviaPage_digest.set(this, void 0);
            _AviaPage_totalsContainer.set(this, void 0);
            _AviaPage_resultContainer.set(this, void 0);
            _AviaPage_showMoreBlock.set(this, void 0);
            _AviaPage_showMoreLink.set(this, void 0);
            _AviaPage_showMoreCurrent.set(this, void 0);
            _AviaPage_showMoreCountSelected.set(this, void 0);
            _AviaPage_showMoreCountOption.set(this, void 0);
            _AviaPage_showMoreTotal.set(this, void 0);
            _AviaPage_totalsTemplate.set(this, void 0);
            _AviaPage_resultTemplate.set(this, void 0);
            _AviaPage_hotFilterTemplate.set(this, void 0);
            _AviaPage_pagingTemplate.set(this, void 0);
            _AviaPage_groupTemplate.set(this, void 0);
            _AviaPage_bookTemplate.set(this, void 0);
            _AviaPage_currentResultType.set(this, void 0);
            _AviaPage_currentPageSize.set(this, void 0);
            _AviaPage_currentPageNumber.set(this, void 0);
            _AviaPage_currentSortingInfo.set(this, void 0);
            _AviaPage_historyStates.set(this, void 0);
            _AviaPage_pageState.set(this, void 0);
            _AviaPage_pricePresenter.set(this, void 0);
            _AviaPage_currencyConverter.set(this, void 0);
            _AviaPage_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _AviaPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AviaPage_selectedGroupKey, options === null || options === void 0 ? void 0 : options.groupKey, "f");
            __classPrivateFieldSet(this, _AviaPage_selectedVariant, { key: __classPrivateFieldGet(this, _AviaPage_options, "f").variantKey }, "f");
            __classPrivateFieldSet(this, _AviaPage_currentResultType, AviaResultType.flat, "f");
            __classPrivateFieldSet(this, _AviaPage_currentPageSize, __classPrivateFieldGet(_a, _a, "f", _AviaPage_defaultPageSize), "f");
            __classPrivateFieldSet(this, _AviaPage_currentSortingInfo, {
                field: AviaSortVariant[AviaSortVariant.Price],
                reverse: false,
            }, "f");
            __classPrivateFieldSet(this, _AviaPage_messages, new App.Messages(), "f");
            __classPrivateFieldSet(this, _AviaPage_preloader, new App.Preloader(), "f");
            const dateLimit = __classPrivateFieldGet(this, _AviaPage_options, "f").dateLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _AviaPage_options, "f").dateLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _AviaPage_options, "f").dateLimit.max) };
            __classPrivateFieldSet(this, _AviaPage_filter, new App.AviaMainFilter({
                dateOptions: {
                    minDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.min,
                    maxDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.max,
                    defaultDateShift: App.app.settings.aviaOptions.defaultDateShift,
                },
                datesOptions: {
                    minDateFrom: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.min,
                    maxDateFrom: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.max,
                    minDateFromShift: App.app.settings.aviaOptions.minDateShift,
                    defaultDateFromShift: App.app.settings.aviaOptions.defaultDateShift,
                },
                minStartDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.min,
                maxStartDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.max,
            }), "f");
            if (__classPrivateFieldGet(this, _AviaPage_usePartialSearch, "f")) {
                // порционка
                __classPrivateFieldGet(this, _AviaPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onSearchPartial).call(this, e, data); }));
                this.root.on("filter:startPartialSearch" /* Events.FilterStartPartialSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onStartPartialSearch).call(this, e, data); }));
            }
            else {
                // всё сразу
                __classPrivateFieldGet(this, _AviaPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onSearch).call(this, e, data); }));
            }
            // TODO Dragushin this.#form = new Form({ root: this.#filter.root, disableStepValidation: true });
            __classPrivateFieldSet(this, _AviaPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaPage_popup, "f")),
                /* TODO
                validator: this.#form.validator,
                allowEmptyData: true,
                */
            }), "f");
            __classPrivateFieldSet(this, _AviaPage_historyStates, {
                // 'search_form': {
                0: {
                    handler: () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showSearchPage).call(this),
                    actionName: 'search',
                    title: 'Поиск авиабилетов',
                },
                // , 'get_results': {
                1: {
                    handler: () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResultPage).call(this),
                    actionName: 'results',
                    title: 'Результаты поиска авиабилетов',
                },
                // , 'show_group': {
                2: {
                    handler: () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showGroupPage).call(this),
                    actionName: 'group',
                    params: ['group'],
                    title: 'Выбранная группа авиабилетов',
                },
                3: {
                    handler: () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showBookPage).call(this),
                    actionName: 'book',
                    params: ['group', 'variant'],
                    title: 'Бронирование авиабилетов',
                },
            }, "f");
            __classPrivateFieldSet(this, _AviaPage_resultBlock, $('.js-avia-results-block', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_digest, $('.js-digest', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_totalsContainer, $('.js-avia-totals', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_resultContainer, $('.js-avia-results', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_hotFilterContainer, $('.js-subfilter-block', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_showMoreBlock, $('.js-show-more', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_showMoreLink, $('.js-show-more-link', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_showMoreCurrent, $('.js-show-more-current', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_showMoreCountSelected, $('.js-show-count-selected', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_showMoreCountOption, $('.js-show-count-option', this.root), "f");
            __classPrivateFieldSet(this, _AviaPage_showMoreTotal, $('.js-show-more-total', this.root), "f");
            __classPrivateFieldGet(this, _AviaPage_showMoreLink, "f").on('click', () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onShowMoreGroupsClick).call(this));
            __classPrivateFieldGet(this, _AviaPage_showMoreCountOption, "f").on('click', e => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_changePageSize).call(this, e));
            __classPrivateFieldSet(this, _AviaPage_totalsTemplate, App.findTemplate((_b = __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").attr('data-totals')) !== null && _b !== void 0 ? _b : ''), "f");
            __classPrivateFieldSet(this, _AviaPage_resultTemplate, App.findTemplate((_c = __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").attr('data-template')) !== null && _c !== void 0 ? _c : ''), "f");
            if (__classPrivateFieldGet(this, _AviaPage_usePartialSearch, "f"))
                __classPrivateFieldSet(this, _AviaPage_hotFilterTemplate, App.findTemplate((_d = __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").attr('data-hotfilter-template')) !== null && _d !== void 0 ? _d : ''), "f");
            __classPrivateFieldSet(this, _AviaPage_pagingTemplate, App.findTemplate((_e = __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").attr('data-paging-template')) !== null && _e !== void 0 ? _e : ''), "f");
            __classPrivateFieldSet(this, _AviaPage_groupTemplate, App.findTemplate((_f = __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").attr('data-group-template')) !== null && _f !== void 0 ? _f : ''), "f");
            __classPrivateFieldSet(this, _AviaPage_bookTemplate, App.findTemplate((_g = __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").attr('data-book-template')) !== null && _g !== void 0 ? _g : ''), "f");
            __classPrivateFieldSet(this, _AviaPage_pricePresenter, new App.NetPricePresenter({ root: this.root, desired: App.AdditionalPriceShow.ToPay }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    if (__classPrivateFieldGet(this, _AviaPage_searchInitXhr, "f"))
                        __classPrivateFieldGet(this, _AviaPage_searchInitXhr, "f").abort();
                    if (__classPrivateFieldGet(this, _AviaPage_searchXhr, "f"))
                        __classPrivateFieldGet(this, _AviaPage_searchXhr, "f").abort();
                    __classPrivateFieldSet(this, _AviaPage_stopPartialSearch, true, "f");
                    inst.hide();
                }
            });
            if (__classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_canSearch).call(this))
                $('body').on("app:loaded" /* Events.Loaded */, () => __classPrivateFieldGet(this, _AviaPage_filter, "f").search());
            $(window).on('popstate', () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onHistoryPopState).call(this));
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                if (__classPrivateFieldGet(this, _AviaPage_pageState, "f") === 2 /* AviaPageState.Group */) {
                    const result = new Array();
                    this.root.find('.js-avia-variants-wrap').each((i, v) => {
                        const container = $(v);
                        const variants = container.find('.js-avia-variant-block-wrap:visible');
                        const activeVariant = variants.filter('._active');
                        const selectedVariants = activeVariant.length > 0 ? activeVariant : variants;
                        const item = new Array();
                        selectedVariants.each((j, x) => {
                            if (!__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f"))
                                return;
                            const flightKey = $(x).attr('data-flights');
                            const variant = __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f").variants.find(y => y.legs[i].flightNumbers === flightKey);
                            if (variant)
                                item.push(variant.legs[i]);
                        });
                        result.push(item);
                    });
                    // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                    // addEventListener на стороне сайта (при помощи своей копии jQuery).
                    document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                        detail: {
                            // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                            state: e.detail,
                            data: Object.assign(Object.assign({}, __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f")), { variants: result }),
                        },
                    }));
                }
                else if (__classPrivateFieldGet(this, _AviaPage_pageState, "f") === 1 /* AviaPageState.Results */) {
                    const container = $(e.detail.container);
                    const offerId = container.parents('[data-offer-uid]').attr('data-offer-uid');
                    // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                    // addEventListener на стороне сайта (при помощи своей копии jQuery).
                    document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                        detail: {
                            // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                            state: e.detail,
                            data: __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this).find(v => v.key === offerId),
                        },
                    }));
                }
            });
        }
        sendForm() {
            throw new Error('Not implemented');
        }
        updateHistory(url, pageState, changeHistory = true) {
            if (!changeHistory)
                return;
            const curState = __classPrivateFieldGet(this, _AviaPage_pageState, "f");
            if (curState === pageState) {
                window.history.replaceState({ state: __classPrivateFieldGet(this, _AviaPage_pageState, "f") }, `title: ${__classPrivateFieldGet(this, _AviaPage_historyStates, "f")[__classPrivateFieldGet(this, _AviaPage_pageState, "f")].title}`, url);
            }
            else {
                __classPrivateFieldSet(this, _AviaPage_pageState, pageState, "f");
                window.history.pushState({ state: __classPrivateFieldGet(this, _AviaPage_pageState, "f") }, `title: ${__classPrivateFieldGet(this, _AviaPage_historyStates, "f")[__classPrivateFieldGet(this, _AviaPage_pageState, "f")].title}`, url);
            }
        }
    }
    _a = AviaPage, _AviaPage_options = new WeakMap(), _AviaPage_usePartialSearch = new WeakMap(), _AviaPage_messages = new WeakMap(), _AviaPage_preloader = new WeakMap(), _AviaPage_filter = new WeakMap(), _AviaPage_popup = new WeakMap(), _AviaPage_responseValidator = new WeakMap(), _AviaPage_hotFilter = new WeakMap(), _AviaPage_groupPage = new WeakMap(), _AviaPage_bookPage = new WeakMap(), _AviaPage_searchType = new WeakMap(), _AviaPage_stopPartialSearch = new WeakMap(), _AviaPage_searchData = new WeakMap(), _AviaPage_searchInitXhr = new WeakMap(), _AviaPage_searchXhr = new WeakMap(), _AviaPage_searchResponse = new WeakMap(), _AviaPage_searchExpirationPopup = new WeakMap(), _AviaPage_currentItems = new WeakMap(), _AviaPage_currentGroups = new WeakMap(), _AviaPage_selectedGroupKey = new WeakMap(), _AviaPage_selectedGroup = new WeakMap(), _AviaPage_selectedVariant = new WeakMap(), _AviaPage_currentPage = new WeakMap(), _AviaPage_hotFilterContainer = new WeakMap(), _AviaPage_resultBlock = new WeakMap(), _AviaPage_digest = new WeakMap(), _AviaPage_totalsContainer = new WeakMap(), _AviaPage_resultContainer = new WeakMap(), _AviaPage_showMoreBlock = new WeakMap(), _AviaPage_showMoreLink = new WeakMap(), _AviaPage_showMoreCurrent = new WeakMap(), _AviaPage_showMoreCountSelected = new WeakMap(), _AviaPage_showMoreCountOption = new WeakMap(), _AviaPage_showMoreTotal = new WeakMap(), _AviaPage_totalsTemplate = new WeakMap(), _AviaPage_resultTemplate = new WeakMap(), _AviaPage_hotFilterTemplate = new WeakMap(), _AviaPage_pagingTemplate = new WeakMap(), _AviaPage_groupTemplate = new WeakMap(), _AviaPage_bookTemplate = new WeakMap(), _AviaPage_currentResultType = new WeakMap(), _AviaPage_currentPageSize = new WeakMap(), _AviaPage_currentPageNumber = new WeakMap(), _AviaPage_currentSortingInfo = new WeakMap(), _AviaPage_historyStates = new WeakMap(), _AviaPage_pageState = new WeakMap(), _AviaPage_pricePresenter = new WeakMap(), _AviaPage_currencyConverter = new WeakMap(), _AviaPage_tabs = new WeakMap(), _AviaPage_instances = new WeakSet(), _AviaPage_canSearch = function _AviaPage_canSearch() {
        const urlParameters = App.UrlParameterHelper.urlParse();
        return this.requiredUrlChecker.isValid(urlParameters) && !App.UrlParameterHelper.isManual(urlParameters);
    }, _AviaPage_onSearch = function _AviaPage_onSearch(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AviaPage_messages, "f").hide();
            if (data.newSearch === 'true') {
                __classPrivateFieldSet(this, _AviaPage_selectedGroupKey, undefined, "f");
                __classPrivateFieldSet(this, _AviaPage_selectedVariant, undefined, "f");
                __classPrivateFieldGet(this, _AviaPage_options, "f").variantKey = undefined;
            }
            __classPrivateFieldSet(this, _AviaPage_groupPage, undefined, "f");
            if (data['Form.By'] === AviaSearchType[AviaSearchType.Date])
                __classPrivateFieldSet(this, _AviaPage_searchType, AviaSearchType.Date, "f");
            else
                __classPrivateFieldSet(this, _AviaPage_searchType, AviaSearchType.BestPrice, "f");
            __classPrivateFieldSet(this, _AviaPage_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.search,
                method: 'POST',
                data,
                beforeSend: () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onSearchBefore).call(this),
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _AviaPage_searchXhr, "f");
                const form = new App.Form({ root: __classPrivateFieldGet(this, _AviaPage_filter, "f").getCurrentForm() });
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _AviaPage_messages, "f"), form.validator))
                    return;
                if (!response || !response.data)
                    return;
                __classPrivateFieldSet(this, _AviaPage_searchResponse, response.data, "f");
                if (__classPrivateFieldGet(this, _AviaPage_searchType, "f") == AviaSearchType.Date)
                    yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResults).call(this, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f"), true);
                else
                    __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showBestPriceResults).call(this, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f"));
            }
            finally {
                __classPrivateFieldGet(this, _AviaPage_preloader, "f").hide();
            }
        });
    }, _AviaPage_onSearchPartial = function _AviaPage_onSearchPartial(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AviaPage_messages, "f").hide();
            __classPrivateFieldSet(this, _AviaPage_groupPage, undefined, "f");
            __classPrivateFieldSet(this, _AviaPage_currentGroups, null, "f");
            if (__classPrivateFieldGet(this, _AviaPage_searchInitXhr, "f"))
                __classPrivateFieldGet(this, _AviaPage_searchInitXhr, "f").abort();
            if (__classPrivateFieldGet(this, _AviaPage_searchXhr, "f"))
                __classPrivateFieldGet(this, _AviaPage_searchXhr, "f").abort();
            if (data['Form.By'] === AviaSearchType[AviaSearchType.Date]) {
                yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_searchByDate).call(this, data);
                return;
            }
            yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_searchByBestPrice).call(this, data);
        });
    }, _AviaPage_searchByDate = function _AviaPage_searchByDate(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (data.newSearch === 'true') {
                __classPrivateFieldSet(this, _AviaPage_selectedGroupKey, undefined, "f");
                __classPrivateFieldSet(this, _AviaPage_selectedVariant, undefined, "f");
                __classPrivateFieldGet(this, _AviaPage_options, "f").variantKey = undefined;
                __classPrivateFieldSet(this, _AviaPage_hotFilter, undefined, "f");
            }
            __classPrivateFieldSet(this, _AviaPage_searchXhr, undefined, "f");
            __classPrivateFieldSet(this, _AviaPage_stopPartialSearch, false, "f");
            __classPrivateFieldSet(this, _AviaPage_searchResponse, {}, "f");
            __classPrivateFieldSet(this, _AviaPage_searchType, AviaSearchType.Date, "f");
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onSearchBefore).call(this);
            __classPrivateFieldSet(this, _AviaPage_searchData, data, "f");
            this.root.trigger("filter:startPartialSearch" /* Events.FilterStartPartialSearch */, [data]);
            __classPrivateFieldSet(this, _AviaPage_searchInitXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.search,
                method: 'POST',
                data,
            }), "f");
            try {
                yield __classPrivateFieldGet(this, _AviaPage_searchInitXhr, "f");
                __classPrivateFieldSet(this, _AviaPage_stopPartialSearch, true, "f");
            }
            catch (ex) {
                window.console.log(ex);
                /* TODO
                if (!this.#responseValidator.processError(ex))
                    throw ex;
                */
            }
        });
    }, _AviaPage_onStartPartialSearch = function _AviaPage_onStartPartialSearch(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            window.setTimeout(() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_doPartialSearch).call(this, data); }), __classPrivateFieldGet(_a, _a, "f", _AviaPage_partialSearchFirstInterval));
        });
    }, _AviaPage_checkControlSum = function _AviaPage_checkControlSum(data) {
        return data === __classPrivateFieldGet(this, _AviaPage_searchData, "f");
    }, _AviaPage_doPartialSearch = function _AviaPage_doPartialSearch(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_checkControlSum).call(this, data))
                return;
            let lastLoop = false;
            if (__classPrivateFieldGet(this, _AviaPage_stopPartialSearch, "f")) {
                lastLoop = true;
                data.LastLoop = 'true';
            }
            try {
                __classPrivateFieldSet(this, _AviaPage_searchXhr, $.ajax({
                    url: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.continueSearch,
                    method: 'POST',
                    data,
                }), "f");
                const response = yield __classPrivateFieldGet(this, _AviaPage_searchXhr, "f");
                if (lastLoop && !__classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result) {
                    __classPrivateFieldGet(this, _AviaPage_preloader, "f").hide();
                    const form = new App.Form({ root: __classPrivateFieldGet(this, _AviaPage_filter, "f").getCurrentForm() });
                    if (!App.validateResponse(response, __classPrivateFieldGet(this, _AviaPage_messages, "f"), form.validator))
                        return;
                }
                if (!response || !response.data)
                    return;
                if (!__classPrivateFieldGet(this, _AviaPage_searchResponse, "f"))
                    return;
                if (!response.data.result) {
                    if (!__classPrivateFieldGet(this, _AviaPage_searchResponse, "f").seo) {
                        __classPrivateFieldSet(this, _AviaPage_searchResponse, response.data, "f");
                        yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResults).call(this, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f"), true);
                    }
                }
                else {
                    const groupsLength = __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result ? __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result.groups.length : 0;
                    if (!__classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result) {
                        __classPrivateFieldSet(this, _AviaPage_searchResponse, response.data, "f");
                        __classPrivateFieldSet(this, _AviaPage_currentItems, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result.groups, "f");
                    }
                    else {
                        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_addGroups).call(this, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result.groups, response.data.result.groups);
                        // делаем по очереди, т.к. в текущих результатах уже могут произойти изменений, как то: втор.фильтрация.
                        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_addGroups).call(this, __classPrivateFieldGet(this, _AviaPage_currentItems, "f"), response.data.result.groups);
                    }
                    yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResults).call(this, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f"), true);
                    // после конкатирования новой порции флайтов от бэка триггерим HotFilterChange, чтобы отфильтровать новую порцию.
                    if (groupsLength > 0 && __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result.groups.length > groupsLength) {
                        __classPrivateFieldGet(this, _AviaPage_hotFilter, "f").fire(__classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result.groups);
                        // this.#hotFilter!.root.trigger(Events.HotFilterChange, [this.#hotFilter!.getResult()]);
                    }
                    __classPrivateFieldGet(this, _AviaPage_preloader, "f").hide();
                }
                if (lastLoop) {
                    $('.js-progress-data-loading', this.root).hide();
                }
                else {
                    // не начинать поиск
                    data.startSearch = 'false';
                    window.setTimeout(() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_doPartialSearch).call(this, data); }), (__classPrivateFieldGet(this, _AviaPage_stopPartialSearch, "f") ? __classPrivateFieldGet(_a, _a, "f", _AviaPage_partialLastSearchInterval) : __classPrivateFieldGet(_a, _a, "f", _AviaPage_partialSearchInterval)));
                }
            }
            catch (ex) {
                __classPrivateFieldGet(this, _AviaPage_preloader, "f").hide();
                window.console.log(ex);
            }
        });
    }, _AviaPage_addGroups = function _AviaPage_addGroups(groups, newGroups) {
        newGroups.forEach(newGroup => {
            const oldGroup = groups.find(v => v.key === newGroup.key);
            if (oldGroup) {
                newGroup.variants.forEach(variant => {
                    if (oldGroup.variants.findIndex(v => v.key === variant.key) < 0)
                        oldGroup.variants.push(variant);
                });
            }
            else {
                groups.push(newGroup);
            }
        });
    }, _AviaPage_searchByBestPrice = function _AviaPage_searchByBestPrice(data) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaPage_searchType, AviaSearchType.BestPrice, "f");
            __classPrivateFieldSet(this, _AviaPage_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.search,
                method: 'POST',
                data,
                beforeSend: () => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onSearchBefore).call(this),
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _AviaPage_searchXhr, "f");
                const form = new App.Form({ root: __classPrivateFieldGet(this, _AviaPage_filter, "f").getCurrentForm() });
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _AviaPage_messages, "f"), form.validator))
                    return;
                if (!response || !response.data)
                    return;
                __classPrivateFieldSet(this, _AviaPage_searchResponse, response.data, "f");
                __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showBestPriceResults).call(this, response.data);
            }
            finally {
                __classPrivateFieldGet(this, _AviaPage_preloader, "f").hide();
            }
        });
    }, _AviaPage_onSearchBefore = function _AviaPage_onSearchBefore() {
        var _b;
        (_b = __classPrivateFieldGet(this, _AviaPage_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
        __classPrivateFieldSet(this, _AviaPage_searchExpirationPopup, undefined, "f");
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_resetData).call(this);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_resetControls).call(this);
        __classPrivateFieldGet(this, _AviaPage_preloader, "f").show();
    }, _AviaPage_resetData = function _AviaPage_resetData() {
        __classPrivateFieldSet(this, _AviaPage_currentPageNumber, 1, "f");
        __classPrivateFieldSet(this, _AviaPage_currentPageSize, __classPrivateFieldGet(_a, _a, "f", _AviaPage_defaultPageSize), "f");
    }, _AviaPage_resetControls = function _AviaPage_resetControls() {
        __classPrivateFieldGet(this, _AviaPage_hotFilterContainer, "f").empty();
        __classPrivateFieldGet(this, _AviaPage_hotFilterContainer, "f").hide();
        __classPrivateFieldGet(this, _AviaPage_totalsContainer, "f").empty();
        __classPrivateFieldGet(this, _AviaPage_resultContainer, "f").empty();
        __classPrivateFieldGet(this, _AviaPage_showMoreBlock, "f").hide();
        const val = App.Cookie.get("showCount" /* KnownCookie.ShowCount */);
        if (val) {
            __classPrivateFieldGet(this, _AviaPage_showMoreCountOption, "f").removeClass('_active');
            __classPrivateFieldGet(this, _AviaPage_showMoreCountOption, "f").parent().find('li:contains("' + val + '")').addClass('_active');
            __classPrivateFieldGet(this, _AviaPage_showMoreCountSelected, "f").text(val);
            __classPrivateFieldGet(this, _AviaPage_showMoreCurrent, "f").text(val);
        }
    }, _AviaPage_showResults = function _AviaPage_showResults(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, changeHistory = false) {
            var _b;
            if (data.seo)
                App.app.seo.update(data.seo);
            // Определение наличия результатов поиска
            if (!data.result || !data.result.groups) {
                __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").hideByClass();
                return;
            }
            // в фильтр передаем плоский список, чтобы его же и вернуть.
            const groups = __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").result.groups;
            if (changeHistory) {
                if (data.subfilter)
                    __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showServerHotFilter).call(this, data.subfilter, groups);
                else if (groups)
                    __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showHotFilter).call(this, groups);
            }
            if (!__classPrivateFieldGet(this, _AviaPage_currencyConverter, "f"))
                __classPrivateFieldSet(this, _AviaPage_currencyConverter, yield App.CurrencyManager.findConverter({ name: '', signal: App.noneSignal }), "f");
            new App.Digest({ container: this.root });
            const changedData = new App.ChangedData();
            __classPrivateFieldSet(_a, _a, data.pageSize, "f", _AviaPage_defaultPageSize);
            changedData.pageSize = __classPrivateFieldGet(_a, _a, "f", _AviaPage_defaultPageSize);
            changedData.pageNumber = 1;
            // приводим к нужному типу группировки
            changedData.groups = __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this, true);
            changedData.href = data.seo.url;
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_changeData).call(this, changedData, changeHistory);
            if (__classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentPageType).call(this) == 0 /* AviaPageState.Search */)
                __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResultPageCase).call(this, true);
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_renderTotals).call(this, changedData);
            if (changeHistory) {
                if (groups.length > 0) {
                    if (!__classPrivateFieldGet(this, _AviaPage_searchExpirationPopup, "f")) {
                        __classPrivateFieldSet(this, _AviaPage_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: data.ttl,
                            url: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.search,
                        }), "f");
                    }
                }
                if (__classPrivateFieldGet(this, _AviaPage_usePartialSearch, "f"))
                    $('.js-progress-data-loading', this.root).show();
            }
            if ((_b = __classPrivateFieldGet(this, _AviaPage_selectedVariant, "f")) === null || _b === void 0 ? void 0 : _b.key)
                yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_gotoBookPage).call(this, __classPrivateFieldGet(this, _AviaPage_selectedVariant, "f").key);
            else if (__classPrivateFieldGet(this, _AviaPage_selectedGroupKey, "f"))
                __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_gotoGroupPage).call(this, __classPrivateFieldGet(this, _AviaPage_selectedGroupKey, "f"));
        });
    }, _AviaPage_showBestPriceResults = function _AviaPage_showBestPriceResults(data) {
        App.app.seo.update(data.seo);
        // Определение наличия результатов поиска
        if (!data.result) {
            __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").hideByClass();
            return;
        }
        __classPrivateFieldGet(this, _AviaPage_resultContainer, "f").append(data.result.bestPrice);
        $('#bestPricesTable .js-matrix-cell-search').on('click', e => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onMatrixCellSearch).call(this, e));
        // чтобы не было случайного перехода после поиска матрицы и выбора даты.
        __classPrivateFieldSet(this, _AviaPage_selectedGroupKey, undefined, "f");
        __classPrivateFieldSet(this, _AviaPage_selectedVariant, undefined, "f");
        __classPrivateFieldGet(this, _AviaPage_options, "f").variantKey = undefined;
        this.updateHistory(data.seo.url, 1 /* AviaPageState.Results */);
        __classPrivateFieldSet(this, _AviaPage_searchExpirationPopup, App.scheduleExpirationPopup({
            interval: data.ttl,
            url: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.search,
        }), "f");
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResultPageCase).call(this, true);
    }, _AviaPage_onMatrixCellSearch = function _AviaPage_onMatrixCellSearch(event) {
        var _b;
        const self = $(event.currentTarget);
        const legDateBlock = '.date-block';
        const legDateLabel = 'label.flight-date';
        // 29896|LX|22.11.2014|06.12.2014
        const vals = ((_b = self.attr('data-value')) !== null && _b !== void 0 ? _b : '').split('|');
        if (vals.length < 3 || vals.length > 4)
            return;
        // выставляем даты
        $('input.js-filter-date-from', this.root)
            .val(vals[2])
            .closest(legDateBlock)
            .find(legDateLabel)
            .text(vals[2]);
        $('input.js-filter-date, input.js-filter-date-to', this.root)
            .val(vals[3])
            .closest(legDateBlock)
            .find(legDateLabel)
            .text(vals[3]);
        // Поиск по конкретной дате
        $('.js-tab-wrap:visible') // идем от видимой закладки, т.к. радио-батоны в 2х закладках!
            .find('.js-filter-radio-btn-flight-type')
            .filter('[data-id="Date"]')
            .trigger('click');
        __classPrivateFieldGet(this, _AviaPage_filter, "f").search(true);
    }, _AviaPage_showServerHotFilter = function _AviaPage_showServerHotFilter(subfilter, groups) {
        __classPrivateFieldGet(this, _AviaPage_hotFilterContainer, "f").show();
        __classPrivateFieldGet(this, _AviaPage_hotFilterContainer, "f").prepend(subfilter);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_activateHotFilter).call(this, groups);
    }, _AviaPage_showHotFilter = function _AviaPage_showHotFilter(groups) {
        const model = App.AviaHotFilter.getModel(__classPrivateFieldGet(this, _AviaPage_hotFilter, "f"), groups, __classPrivateFieldGet(this, _AviaPage_filter, "f").getTripType(), __classPrivateFieldGet(this, _AviaPage_filter, "f").isDirect());
        const hotfilter = $(__classPrivateFieldGet(this, _AviaPage_hotFilterTemplate, "f").call(this, model));
        __classPrivateFieldGet(this, _AviaPage_hotFilterContainer, "f").empty().prepend(hotfilter);
        __classPrivateFieldGet(this, _AviaPage_hotFilterContainer, "f").show();
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_activateHotFilter).call(this, groups);
    }, _AviaPage_activateHotFilter = function _AviaPage_activateHotFilter(groups) {
        __classPrivateFieldSet(this, _AviaPage_hotFilter, new App.AviaHotFilter(groups), "f");
        __classPrivateFieldGet(this, _AviaPage_hotFilter, "f").root.on("hotfilter:change" /* Events.HotFilterChange */, (e, data) => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onHotFilterChange).call(this, e, data));
        // можно и пересоздать, т.к. могут появиться новые блоки фильтров, которые нужно обработать и навесить события. Можно
        // инициализацию вынести в отдельный метод, и данные передавать не в конструкторе, но тогда обязательная передача данных будет
        // неочевидна.
        /* TODO
        if (!this.hotFilter) {
            this.hotFilter = new AviaHotFilter(groups);
            this.hotFilter.root.on(Events.HotFilterChange, async (e, data) => await this.onHotFilterChange(e, data));
        } else {
            this.hotFilter.fire(groups);
        }
        */
    }, _AviaPage_changeData = function _AviaPage_changeData(data, changeHistory = false) {
        var _b;
        if (data.showMore)
            __classPrivateFieldSet(this, _AviaPage_currentPageNumber, (_b = __classPrivateFieldGet(this, _AviaPage_currentPageNumber, "f"), _b++, _b), "f");
        else if (data.pageNumber)
            __classPrivateFieldSet(this, _AviaPage_currentPageNumber, data.pageNumber, "f");
        else
            __classPrivateFieldSet(this, _AviaPage_currentPageNumber, 1, "f");
        if (data.pageSize)
            __classPrivateFieldSet(this, _AviaPage_currentPageSize, data.pageSize, "f");
        if (!data.groups)
            data.groups = __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this, true);
        let pageGroups;
        if (data.showMore) {
            pageGroups = data.groups.slice(0, __classPrivateFieldGet(this, _AviaPage_currentPageSize, "f") * __classPrivateFieldGet(this, _AviaPage_currentPageNumber, "f"));
        }
        else {
            const skipCount = (__classPrivateFieldGet(this, _AviaPage_currentPageNumber, "f") - 1) * __classPrivateFieldGet(this, _AviaPage_currentPageSize, "f");
            pageGroups = data.groups.slice(skipCount, skipCount + __classPrivateFieldGet(this, _AviaPage_currentPageSize, "f"));
        }
        $.each(pageGroups, (index, item) => (item.href = `${App.removeEndChar(data.href, '/')}/group-${item.key}/`));
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_appendGroups).call(this, pageGroups);
        this.updateHistory(data.href, 1 /* AviaPageState.Results */, changeHistory);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_initViewTypeTabs).call(this);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_initPageNumbers).call(this, data.groups.length, __classPrivateFieldGet(this, _AviaPage_currentPageNumber, "f"), __classPrivateFieldGet(this, _AviaPage_currentPageSize, "f"));
    }, _AviaPage_appendGroups = function _AviaPage_appendGroups(groups) {
        const data = {
            dynamicFlight: false,
            sortItems: __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getSortVariants).call(this),
            sortUp: !__classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse,
            resultType: AviaResultType[__classPrivateFieldGet(this, _AviaPage_currentResultType, "f")],
            groups,
        };
        const content = $(__classPrivateFieldGet(this, _AviaPage_resultTemplate, "f").call(this, data));
        App.NetPricePresenter.setVisibility(content, App.app.userSettings.isAuthenticated && App.NetPricePresenter.getVisibility());
        __classPrivateFieldGet(this, _AviaPage_resultContainer, "f")
            .empty()
            .append(content);
        $('.js-avia-card-block', __classPrivateFieldGet(this, _AviaPage_resultContainer, "f")).on('click', e => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onGroupClick).call(this, e));
        $('.js-sort-item', __classPrivateFieldGet(this, _AviaPage_resultContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onSorting).call(this, e); }));
        this.components.push(new App.AviaBrandFareComponent({
            root: this.root,
            popup: __classPrivateFieldGet(this, _AviaPage_popup, "f"),
            responseValidator: __classPrivateFieldGet(this, _AviaPage_responseValidator, "f"),
        }));
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showShowMoreGroups).call(this);
    }, _AviaPage_getSortVariants = function _AviaPage_getSortVariants() {
        return [
            { text: 'Цена', value: AviaSortVariant[AviaSortVariant.Price], selected: __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.Price] },
            { text: 'Вылет', value: AviaSortVariant[AviaSortVariant.DepartureTime], selected: __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.DepartureTime] },
            { text: 'Прилет', value: AviaSortVariant[AviaSortVariant.ArrivalTime], selected: __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.ArrivalTime] },
            { text: 'Пересадки', value: AviaSortVariant[AviaSortVariant.ChangeAircraftDuration], selected: __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.ChangeAircraftDuration] },
            { text: 'В пути', value: AviaSortVariant[AviaSortVariant.TotalWayTime], selected: __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.TotalWayTime] },
        ];
    }, _AviaPage_onSorting = function _AviaPage_onSorting(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = $(e.currentTarget).attr('data-sort');
            if (value && Object.values(AviaSortVariant).includes(value))
                __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_setCurrentSorting).call(this, AviaSortVariant[value]);
            __classPrivateFieldSet(this, _AviaPage_currentGroups, null, "f");
            yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResults).call(this, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f"));
        });
    }, _AviaPage_initViewTypeTabs = function _AviaPage_initViewTypeTabs() {
        __classPrivateFieldSet(this, _AviaPage_tabs, $('.js-tab', __classPrivateFieldGet(this, _AviaPage_resultContainer, "f")), "f");
        __classPrivateFieldGet(this, _AviaPage_tabs, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onChangeResultType).call(this, e); }));
    }, _AviaPage_onChangeResultType = function _AviaPage_onChangeResultType(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const tabName = $(e.target).attr('data-tab');
            if (tabName === AviaResultType[__classPrivateFieldGet(this, _AviaPage_currentResultType, "f")])
                return;
            if (tabName === AviaResultType[AviaResultType.flat]) {
                __classPrivateFieldSet(this, _AviaPage_currentResultType, AviaResultType.flat, "f");
            }
            else {
                __classPrivateFieldSet(this, _AviaPage_currentResultType, AviaResultType.group, "f");
            }
            __classPrivateFieldSet(this, _AviaPage_currentGroups, null, "f");
            yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResults).call(this, __classPrivateFieldGet(this, _AviaPage_searchResponse, "f"));
            if (tabName) {
                App.Cookie.set("aviaResultType" /* KnownCookie.AviaResultType */, tabName);
            }
        });
    }, _AviaPage_initPageNumbers = function _AviaPage_initPageNumbers(groupCount, selectedPageNumber, pageSize) {
        const pageCountApx = groupCount / pageSize;
        const pageCountAdd = pageCountApx > Math.floor(pageCountApx) ? 1 : 0;
        const pageCount = Math.floor(pageCountApx) + pageCountAdd;
        const pageNumbersBlock = $(this.root).find('.js-page-numbers-block');
        pageNumbersBlock.empty();
        if (pageCount <= 1)
            return false;
        const pages = [];
        for (let i = 1; i <= pageCount; i++)
            pages[i - 1] = [i, i === selectedPageNumber];
        const pageBlock = __classPrivateFieldGet(this, _AviaPage_pagingTemplate, "f").call(this, pages);
        pageNumbersBlock.append(pageBlock);
        pageNumbersBlock.find('.js-active-paging-item').not('.selected').on('click', e => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_changePageNumber).call(this, e));
        return true;
    }, _AviaPage_changePageNumber = function _AviaPage_changePageNumber(event) {
        var _b;
        const el = $(event.currentTarget);
        const changedData = new App.ChangedData();
        changedData.pageNumber = parseInt((_b = $(el).attr('data-value')) !== null && _b !== void 0 ? _b : '1', 10);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_changeData).call(this, changedData);
    }, _AviaPage_changePageSize = function _AviaPage_changePageSize(event) {
        const target = $(event.currentTarget);
        const currentValue = parseInt(target.text(), 10);
        __classPrivateFieldGet(this, _AviaPage_showMoreCountOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _AviaPage_showMoreCountSelected, "f").text(currentValue);
        App.Cookie.set("showCount" /* KnownCookie.ShowCount */, currentValue.toString());
        __classPrivateFieldSet(this, _AviaPage_currentPageSize, currentValue, "f");
        __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").pageSize = currentValue;
        const remainingData = __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this).length - __classPrivateFieldGet(this, _AviaPage_currentPageNumber, "f") * __classPrivateFieldGet(this, _AviaPage_currentPageSize, "f");
        __classPrivateFieldGet(this, _AviaPage_showMoreCurrent, "f").text(Math.min(remainingData, currentValue));
        const changedData = new App.ChangedData();
        changedData.pageNumber = 1;
        changedData.pageSize = parseInt(target.text(), 10);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_changeData).call(this, changedData);
    }, _AviaPage_onShowMoreGroupsClick = function _AviaPage_onShowMoreGroupsClick() {
        __classPrivateFieldGet(this, _AviaPage_showMoreBlock, "f").addClass('_pulsate');
        const changedData = new App.ChangedData();
        changedData.showMore = true;
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_changeData).call(this, changedData);
        __classPrivateFieldGet(this, _AviaPage_showMoreBlock, "f").removeClass('_pulsate');
    }, _AviaPage_showShowMoreGroups = function _AviaPage_showShowMoreGroups() {
        const remainingData = Math.max(0, __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this).length - __classPrivateFieldGet(this, _AviaPage_currentPageNumber, "f") * __classPrivateFieldGet(this, _AviaPage_currentPageSize, "f"));
        if (remainingData > 0) {
            __classPrivateFieldGet(this, _AviaPage_showMoreBlock, "f").show();
            __classPrivateFieldGet(this, _AviaPage_showMoreBlock, "f").toggleByClass(true);
        }
        else {
            __classPrivateFieldGet(this, _AviaPage_showMoreBlock, "f").hide();
            __classPrivateFieldGet(this, _AviaPage_showMoreBlock, "f").toggleByClass(false);
        }
        __classPrivateFieldGet(this, _AviaPage_showMoreCurrent, "f").text(Math.min(remainingData, __classPrivateFieldGet(this, _AviaPage_currentPageSize, "f")));
        __classPrivateFieldGet(this, _AviaPage_showMoreTotal, "f").text(remainingData);
    }, _AviaPage_onHotFilterChange = function _AviaPage_onHotFilterChange(e, groups) {
        e.preventDefault();
        const changedData = new App.ChangedData();
        changedData.pageNumber = 1;
        __classPrivateFieldSet(this, _AviaPage_currentItems, groups, "f");
        __classPrivateFieldSet(this, _AviaPage_currentGroups, null, "f");
        changedData.groups = __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_renderTotals).call(this, changedData);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_changeData).call(this, changedData);
    }, _AviaPage_renderTotals = function _AviaPage_renderTotals(data) {
        const count = data.groups
            .map(v => v.variants.length)
            .reduce((prev, cur) => prev + cur, 0);
        __classPrivateFieldGet(this, _AviaPage_totalsContainer, "f").empty().append($(__classPrivateFieldGet(this, _AviaPage_totalsTemplate, "f").call(this, {
            total: `${count} ${App.pluralRu(count, 'предложение', 'предложения', 'предложений')}`,
            priceCheckBoxVisibility: App.app.userSettings.isAuthenticated,
            checked: App.NetPricePresenter.getVisibility(),
        })));
    }, _AviaPage_onChangeGroupFare = function _AviaPage_onChangeGroupFare(event, fare) {
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_gotoGroupPage).call(this, fare.key, true);
    }, _AviaPage_onChangeVariantFare = function _AviaPage_onChangeVariantFare(event, group, variant) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaPage_selectedGroup, group, "f");
            __classPrivateFieldSet(this, _AviaPage_selectedVariant, variant, "f");
            const url = `${window.location.origin}${App.removeEndChar(__classPrivateFieldGet(this, _AviaPage_searchResponse, "f").seo.url.replace('avia/search', 'avia/book'), '/')}/group-${__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f").key}/variant-${__classPrivateFieldGet(this, _AviaPage_selectedVariant, "f").key}/`;
            this.updateHistory(url, 3 /* AviaPageState.Book */);
        });
    }, _AviaPage_onGroupClick = function _AviaPage_onGroupClick(e) {
        e.preventDefault();
        const key = $(e.currentTarget).attr('data-key');
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_gotoGroupPage).call(this, key);
    }, _AviaPage_getGroup = function _AviaPage_getGroup() {
        return __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this).find(v => v.key === __classPrivateFieldGet(this, _AviaPage_selectedGroupKey, "f"));
    }, _AviaPage_getCurrentGroups = function _AviaPage_getCurrentGroups(refresh = false) {
        if (refresh || !__classPrivateFieldGet(this, _AviaPage_currentGroups, "f"))
            __classPrivateFieldSet(this, _AviaPage_currentGroups, __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getGroups).call(this), "f");
        return __classPrivateFieldGet(this, _AviaPage_currentGroups, "f");
    }, _AviaPage_getGroups = function _AviaPage_getGroups() {
        if (__classPrivateFieldGet(this, _AviaPage_currentResultType, "f") == AviaResultType.flat) {
            const copy = App.deepCopy(__classPrivateFieldGet(this, _AviaPage_currentItems, "f"));
            return __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_sort).call(this, copy);
        }
        else {
            let result = new Array();
            Enumerable.from(App.deepCopy(__classPrivateFieldGet(this, _AviaPage_currentItems, "f")))
                .groupBy(v => v.groupKey, v => v, (k, v) => {
                v.forEach(x => {
                    x.key = k;
                });
                return v.toArray();
            }).forEach(v => {
                const group = v[0];
                group.variants = Enumerable.from(v)
                    .selectMany(x => x.variants)
                    .orderBy(x => x.departureDateTime)
                    .thenBy(x => x.arrivalDateTime)
                    .toArray();
                group.hasMoreVariants = v.length > 1;
                group.routes = Enumerable.from(v).selectMany(x => x.routes).distinct().toArray();
                group.tags = Enumerable.from(v).selectMany(x => x.tags).distinct(x => x[0]).toArray();
                group.privateFare = Enumerable.from(v).any(x => x.privateFare);
                result.push(group);
                result = __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_sort).call(this, result);
            });
            return result;
        }
    }, _AviaPage_sort = function _AviaPage_sort(groups) {
        switch (__classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field) {
            case AviaSortVariant[AviaSortVariant.Price]:
                {
                    return __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse
                        ? Enumerable.from(groups)
                            .orderByDescending(v => {
                            var _b;
                            return __classPrivateFieldGet(this, _AviaPage_currencyConverter, "f")
                                ? ((_b = __classPrivateFieldGet(this, _AviaPage_currencyConverter, "f").exchange(v.grossPrice, v.currency, App.CurrencyManager.currentCurrencyCode)) !== null && _b !== void 0 ? _b : v.grossPrice)
                                : v.grossPrice;
                        })
                            .toArray()
                        : Enumerable.from(groups)
                            .orderBy(v => {
                            var _b;
                            return __classPrivateFieldGet(this, _AviaPage_currencyConverter, "f")
                                ? ((_b = __classPrivateFieldGet(this, _AviaPage_currencyConverter, "f").exchange(v.grossPrice, v.currency, App.CurrencyManager.currentCurrencyCode)) !== null && _b !== void 0 ? _b : v.grossPrice)
                                : v.grossPrice;
                        })
                            .toArray();
                }
            case AviaSortVariant[AviaSortVariant.DepartureTime]:
                return __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).select(x => x.departureDateTime).min())
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).select(x => x.departureDateTime).min())
                        .toArray();
            case AviaSortVariant[AviaSortVariant.ArrivalTime]:
                return __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).select(x => x.arrivalDateTime).min())
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).select(x => x.arrivalDateTime).min())
                        .toArray();
            case AviaSortVariant[AviaSortVariant.ChangeAircraftDuration]:
                return __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).min(x => x.totalChangeAircraftDelay))
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).min(x => x.totalChangeAircraftDelay))
                        .toArray();
            case AviaSortVariant[AviaSortVariant.TotalWayTime]:
                return __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).select(x => x.totalWayTime).min())
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).select(x => x.totalWayTime).min())
                        .toArray();
        }
        return groups;
    }, _AviaPage_setCurrentPageType = function _AviaPage_setCurrentPageType(value) {
        __classPrivateFieldSet(this, _AviaPage_currentPage, value, "f");
    }, _AviaPage_setCurrentSorting = function _AviaPage_setCurrentSorting(value) {
        if (__classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field === AviaSortVariant[value]) {
            __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse = !__classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse;
        }
        else {
            __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").field = AviaSortVariant[value];
            __classPrivateFieldGet(this, _AviaPage_currentSortingInfo, "f").reverse = false;
        }
    }, _AviaPage_getCurrentPageType = function _AviaPage_getCurrentPageType() {
        return __classPrivateFieldGet(this, _AviaPage_currentPage, "f");
    }, _AviaPage_gotoGroupPage = function _AviaPage_gotoGroupPage(key, onChangeFare = null) {
        if (onChangeFare != true && __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentPageType).call(this) == 2 /* AviaPageState.Group */)
            return;
        if (key) {
            __classPrivateFieldSet(this, _AviaPage_groupPage, undefined, "f");
            __classPrivateFieldSet(this, _AviaPage_selectedGroupKey, key, "f");
        }
        __classPrivateFieldSet(this, _AviaPage_selectedGroup, __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getGroup).call(this), "f");
        if (!__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f")) {
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResultPage).call(this);
            return;
        }
        const items = __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this)
            .filter(v => v.fareGroupKey === __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f").fareGroupKey);
        if (!items)
            return;
        items.forEach(v => { var _b; v.selected = (v.key === ((_b = __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f")) === null || _b === void 0 ? void 0 : _b.key)); });
        // items = AviaGroupPage.calcPriceDelta(items, this.selectedGroup);
        if (__classPrivateFieldGet(this, _AviaPage_groupPage, "f")) {
            // обновляем только тарифы
            __classPrivateFieldGet(this, _AviaPage_groupPage, "f").updateFares(items);
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideSearchPage).call(this);
        }
        else {
            const data = {
                canSwitchFare: (items.length > 1),
                selectedGroup: __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f"),
                items,
            };
            const content = $(__classPrivateFieldGet(this, _AviaPage_groupTemplate, "f").call(this, data));
            $.each(content.find('.js-avia-variants-wrap'), (i, v) => {
                App.AviaGroupPage.legSort($(v), undefined, 'departure');
            });
            __classPrivateFieldSet(this, _AviaPage_groupPage, new App.AviaGroupPage({
                content,
                urls: __classPrivateFieldGet(this, _AviaPage_options, "f").urls,
                items,
            }), "f");
            if (onChangeFare != true) {
                __classPrivateFieldGet(this, _AviaPage_groupPage, "f").root
                    .off("avia:changeFare" /* Events.AviaChangeFare */)
                    .on("avia:changeFare" /* Events.AviaChangeFare */, (e, fare) => __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onChangeGroupFare).call(this, e, fare));
                __classPrivateFieldGet(this, _AviaPage_groupPage, "f").root
                    .off("avia:book" /* Events.AviaBook */)
                    .on("avia:book" /* Events.AviaBook */, (e, group, variant) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onAviaBook).call(this, e, group, variant); }));
            }
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showGroupPage).call(this, onChangeFare !== true);
        }
        const url = `${window.location.origin}${App.removeEndChar(__classPrivateFieldGet(this, _AviaPage_searchResponse, "f").seo.url, '/')}/group-${__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f").key}/`;
        this.updateHistory(url, 2 /* AviaPageState.Group */);
    }, _AviaPage_findVariant = function _AviaPage_findVariant(key) {
        var _b;
        if (!__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f"))
            return;
        const variants = __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f").variants.filter(v => v.key === key);
        if (!variants || variants.length <= 0) {
            __classPrivateFieldSet(this, _AviaPage_selectedVariant, undefined, "f");
            return;
        }
        _b = this, [({ set value(_c) { __classPrivateFieldSet(_b, _AviaPage_selectedVariant, _c, "f"); } }).value] = variants;
    }, _AviaPage_gotoBookPage = function _AviaPage_gotoBookPage(variantKey) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaPage_selectedGroup, __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getGroup).call(this), "f");
            if (!__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f")) {
                __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResultPage).call(this);
                return;
            }
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_findVariant).call(this, variantKey);
            if (!__classPrivateFieldGet(this, _AviaPage_selectedVariant, "f")) {
                __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_gotoGroupPage).call(this, undefined);
                return;
            }
            yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_prepareBookPage).call(this);
        });
    }, _AviaPage_onAviaBook = function _AviaPage_onAviaBook(event, group, variant) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaPage_selectedGroupKey, group.key, "f");
            __classPrivateFieldSet(this, _AviaPage_selectedGroup, group, "f");
            __classPrivateFieldSet(this, _AviaPage_selectedVariant, variant, "f");
            yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_prepareBookPage).call(this);
        });
    }, _AviaPage_prepareBookPage = function _AviaPage_prepareBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentPageType).call(this) == 3 /* AviaPageState.Book */)
                return;
            if (!__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f") || !__classPrivateFieldGet(this, _AviaPage_selectedVariant, "f"))
                return;
            const items = __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentGroups).call(this).filter(g => g.fareGroupKey === __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f").fareGroupKey
                && g.variants.some(v => v.compositeKey === __classPrivateFieldGet(this, _AviaPage_selectedVariant, "f").compositeKey));
            if (!items)
                return;
            items.forEach(v => { var _b; v.selected = (v.key === ((_b = __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f")) === null || _b === void 0 ? void 0 : _b.key)); });
            const loggedIn = yield App.app.auth.getStatus();
            // если авторизован, то сразу переходим, добавляя в историю страницу группы.
            if (!loggedIn) {
                $(document).trigger("app:loggingin" /* Events.LoggingIn */);
                return;
            }
            const url = `${window.location.origin}${App.removeEndChar(__classPrivateFieldGet(this, _AviaPage_searchResponse, "f").seo.url.replace('avia/search', 'avia/book'), '/')}/group-${__classPrivateFieldGet(this, _AviaPage_selectedGroup, "f").key}/variant-${__classPrivateFieldGet(this, _AviaPage_selectedVariant, "f").key}/`;
            this.updateHistory(url, 3 /* AviaPageState.Book */);
            const bookData = yield $.ajax({
                url: App.app.url.route('/avia/bookdata/'),
                method: 'POST',
                dataType: 'json',
                data: new Array(0),
            });
            const showNetPrice = App.NetPricePresenter.getVisibility();
            const data = Object.assign(Object.assign({ selectedVariant: __classPrivateFieldGet(this, _AviaPage_selectedVariant, "f"), getFareRulesAction: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.getFareRules, bookAction: __classPrivateFieldGet(this, _AviaPage_options, "f").urls.book, agentCountryGenitiveName: __classPrivateFieldGet(this, _AviaPage_searchResponse, "f").agentCountryGenitiveName, allowBooking: bookData.data.allowBooking }, __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f")), { pricePresenter: {
                    type: __classPrivateFieldGet(this, _AviaPage_pricePresenter, "f").type,
                    show: showNetPrice,
                }, canSwitchFare: (items.length > 1), items });
            const content = $(__classPrivateFieldGet(this, _AviaPage_bookTemplate, "f").call(this, data));
            App.NetPricePresenter.setVisibility(content, showNetPrice);
            __classPrivateFieldSet(this, _AviaPage_bookPage, new App.AviaBookPage({
                group: __classPrivateFieldGet(this, _AviaPage_selectedGroup, "f"),
                variant: __classPrivateFieldGet(this, _AviaPage_selectedVariant, "f"),
                content,
                urls: __classPrivateFieldGet(this, _AviaPage_options, "f").urls,
                items,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _AviaPage_pricePresenter, "f").type,
                    show: showNetPrice,
                },
            }), "f");
            __classPrivateFieldGet(this, _AviaPage_bookPage, "f").root
                .off("avia:changeVariantFare" /* Events.AviaVariantFareChange */)
                .on("avia:changeVariantFare" /* Events.AviaVariantFareChange */, (e, group, variant) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_onChangeVariantFare).call(this, e, group, variant); }));
            __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showBookPage).call(this);
        });
    }, _AviaPage_onHistoryPopState = function _AviaPage_onHistoryPopState() {
        if (!window.history.state)
            return;
        const state = window.history.state;
        const prevPage = __classPrivateFieldGet(this, _AviaPage_pageState, "f");
        __classPrivateFieldSet(this, _AviaPage_pageState, state.state, "f");
        __classPrivateFieldGet(this, _AviaPage_historyStates, "f")[__classPrivateFieldGet(this, _AviaPage_pageState, "f")].handler();
        // обнуляем предыдущие страницы, чтобы по время поиска не было повторного на них перехода
        if (state.state == 1 /* AviaPageState.Results */ && prevPage == 2 /* AviaPageState.Group */) {
            __classPrivateFieldSet(this, _AviaPage_groupPage, undefined, "f");
            __classPrivateFieldSet(this, _AviaPage_selectedGroupKey, undefined, "f");
        }
        if (state.state == 2 /* AviaPageState.Group */ && prevPage == 3 /* AviaPageState.Book */) {
            __classPrivateFieldSet(this, _AviaPage_bookPage, undefined, "f");
            __classPrivateFieldSet(this, _AviaPage_selectedVariant, undefined, "f");
        }
    }, _AviaPage_hideSearchPage = function _AviaPage_hideSearchPage() {
        var _b;
        __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").hideByClass();
        __classPrivateFieldGet(this, _AviaPage_filter, "f").root.hide();
        (_b = __classPrivateFieldGet(this, _AviaPage_digest, "f")) === null || _b === void 0 ? void 0 : _b.hide();
    }, _AviaPage_showSearchPage = function _AviaPage_showSearchPage() {
        var _b;
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideGroupPage).call(this);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideBookPage).call(this);
        __classPrivateFieldGet(this, _AviaPage_filter, "f").root.show();
        __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").hideByClass();
        (_b = __classPrivateFieldGet(this, _AviaPage_digest, "f")) === null || _b === void 0 ? void 0 : _b.show();
        const filterRootOffset = __classPrivateFieldGet(this, _AviaPage_filter, "f").root.offset();
        $('html, body').animate({ scrollTop: (filterRootOffset != null ? filterRootOffset.top : 0) }, this.renderSpeed);
    }, _AviaPage_showResultPage = function _AviaPage_showResultPage() {
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_showResultPageCase).call(this, true);
    }, _AviaPage_showResultPageCase = function _AviaPage_showResultPageCase(firstGroup) {
        var _b, _c;
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_setCurrentPageType).call(this, 1 /* AviaPageState.Results */);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideGroupPage).call(this);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideBookPage).call(this);
        __classPrivateFieldGet(this, _AviaPage_filter, "f").root.show();
        if (__classPrivateFieldGet(this, _AviaPage_searchType, "f") === AviaSearchType.Date) {
            __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").showByClass();
            (_b = __classPrivateFieldGet(this, _AviaPage_digest, "f")) === null || _b === void 0 ? void 0 : _b.show();
            if (firstGroup) {
                const subfilterContainerOffset = __classPrivateFieldGet(this, _AviaPage_hotFilterContainer, "f").offset();
                $('html, body').animate({ scrollTop: (subfilterContainerOffset != null ? subfilterContainerOffset.top : 0) }, this.renderSpeed);
            }
        }
        else {
            __classPrivateFieldGet(this, _AviaPage_resultBlock, "f").showByClass();
            (_c = __classPrivateFieldGet(this, _AviaPage_digest, "f")) === null || _c === void 0 ? void 0 : _c.show();
        }
    }, _AviaPage_hideGroupPage = function _AviaPage_hideGroupPage() {
        if (__classPrivateFieldGet(this, _AviaPage_groupPage, "f")) {
            __classPrivateFieldGet(this, _AviaPage_groupPage, "f").hide();
        }
    }, _AviaPage_showGroupPage = function _AviaPage_showGroupPage(animate = false) {
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_setCurrentPageType).call(this, 2 /* AviaPageState.Group */);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideSearchPage).call(this);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideBookPage).call(this);
        if (__classPrivateFieldGet(this, _AviaPage_groupPage, "f"))
            __classPrivateFieldGet(this, _AviaPage_groupPage, "f").show('');
        if (animate) {
            const rootOffset = this.root.offset();
            $('html, body').animate({ scrollTop: (rootOffset != null ? rootOffset.top : 0) }, this.renderSpeed);
        }
    }, _AviaPage_hideBookPage = function _AviaPage_hideBookPage() {
        if (__classPrivateFieldGet(this, _AviaPage_bookPage, "f")) {
            __classPrivateFieldGet(this, _AviaPage_bookPage, "f").hide();
        }
    }, _AviaPage_showBookPage = function _AviaPage_showBookPage() {
        if (__classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_getCurrentPageType).call(this) == 3 /* AviaPageState.Book */)
            return;
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_setCurrentPageType).call(this, 3 /* AviaPageState.Book */);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideSearchPage).call(this);
        __classPrivateFieldGet(this, _AviaPage_instances, "m", _AviaPage_hideGroupPage).call(this);
        if (__classPrivateFieldGet(this, _AviaPage_bookPage, "f")) {
            __classPrivateFieldGet(this, _AviaPage_bookPage, "f").show(this.renderSpeed);
            const rootOffset = this.root.offset();
            $('html, body').animate({ scrollTop: (rootOffset != null ? rootOffset.top : 0) }, this.renderSpeed);
        }
    };
    _AviaPage_partialSearchFirstInterval = { value: 5000 };
    _AviaPage_partialSearchInterval = { value: 2000 };
    _AviaPage_partialLastSearchInterval = { value: 1000 };
    _AviaPage_defaultPageSize = { value: void 0 };
    App.AviaPage = AviaPage;
})(App || (App = {}));
/// <reference path='AviaPage.ts' />
/// <reference path='AviaFormBase.Mobile.ts' />
/// <reference path='../common/models/ISelectListItem.ts' />
var App;
(function (App) {
    var _AviaPageMobile_instances, _a, _AviaPageMobile_options, _AviaPageMobile_partialSearchFirstInterval, _AviaPageMobile_partialSearchInterval, _AviaPageMobile_partialLastSearchInterval, _AviaPageMobile_usePartialSearch, _AviaPageMobile_defaultPageSize, _AviaPageMobile_messages, _AviaPageMobile_preloader, _AviaPageMobile_filter, _AviaPageMobile_popup, _AviaPageMobile_responseValidator, _AviaPageMobile_hotFilter, _AviaPageMobile_groupPage, _AviaPageMobile_bookPage, _AviaPageMobile_searchType, _AviaPageMobile_stopPartialSearch, _AviaPageMobile_searchData, _AviaPageMobile_searchInitXhr, _AviaPageMobile_searchXhr, _AviaPageMobile_searchResponse, _AviaPageMobile_searchExpirationPopup, _AviaPageMobile_currentItems, _AviaPageMobile_currentGroups, _AviaPageMobile_selectedGroupKey, _AviaPageMobile_selectedGroup, _AviaPageMobile_selectedVariant, _AviaPageMobile_currentPage, _AviaPageMobile_hotFilterContainer, _AviaPageMobile_resultBlock, _AviaPageMobile_resultContainer, _AviaPageMobile_showMoreBlock, _AviaPageMobile_showMoreLink, _AviaPageMobile_showMoreCurrent, _AviaPageMobile_showMoreCountSelected, _AviaPageMobile_showMoreCountOption, _AviaPageMobile_showMoreTotal, _AviaPageMobile_resultTemplate, _AviaPageMobile_hotFilterTemplate, _AviaPageMobile_pagingTemplate, _AviaPageMobile_groupTemplate, _AviaPageMobile_bookTemplate, _AviaPageMobile_currentResultType, _AviaPageMobile_currentPageSize, _AviaPageMobile_currentPageNumber, _AviaPageMobile_currentSortingInfo, _AviaPageMobile_historyStates, _AviaPageMobile_pageState, _AviaPageMobile_pricePresenter, _AviaPageMobile_canSearch, _AviaPageMobile_onSearch, _AviaPageMobile_onSearchPartial, _AviaPageMobile_searchByDate, _AviaPageMobile_onStartPartialSearch, _AviaPageMobile_checkControlSum, _AviaPageMobile_doPartialSearch, _AviaPageMobile_searchByBestPrice, _AviaPageMobile_parseResponse, _AviaPageMobile_parseResponseGetKey, _AviaPageMobile_onSearchBefore, _AviaPageMobile_resetData, _AviaPageMobile_resetControls, _AviaPageMobile_showResults, _AviaPageMobile_showBestPriceResults, _AviaPageMobile_onMatrixCellSearch, _AviaPageMobile_showServerHotFilter, _AviaPageMobile_showHotFilter, _AviaPageMobile_activateHotFilter, _AviaPageMobile_changeData, _AviaPageMobile_appendGroups, _AviaPageMobile_getSortVariants, _AviaPageMobile_onSorting, _AviaPageMobile_initPageNumbers, _AviaPageMobile_changePageNumber, _AviaPageMobile_changePageSize, _AviaPageMobile_onShowMoreGroupsClick, _AviaPageMobile_showShowMoreGroups, _AviaPageMobile_onHotFilterChange, _AviaPageMobile_onChangeGroupFare, _AviaPageMobile_onChangeVariantFare, _AviaPageMobile_onGroupClick, _AviaPageMobile_getGroup, _AviaPageMobile_getCurrentGroups, _AviaPageMobile_getGroups, _AviaPageMobile_sort, _AviaPageMobile_setCurrentPageType, _AviaPageMobile_setCurrentSorting, _AviaPageMobile_getCurrentPageType, _AviaPageMobile_gotoGroupPage, _AviaPageMobile_findVariant, _AviaPageMobile_gotoBookPage, _AviaPageMobile_onAviaBook, _AviaPageMobile_prepareBookPage, _AviaPageMobile_onHistoryPopState, _AviaPageMobile_hideSearchPage, _AviaPageMobile_showSearchPage, _AviaPageMobile_showResultPage, _AviaPageMobile_showResultPageCase, _AviaPageMobile_hideGroupPage, _AviaPageMobile_showGroupPage, _AviaPageMobile_hideBookPage, _AviaPageMobile_showBookPage;
    let AviaSearchType;
    (function (AviaSearchType) {
        AviaSearchType[AviaSearchType["Date"] = 0] = "Date";
        AviaSearchType[AviaSearchType["BestPrice"] = 1] = "BestPrice";
    })(AviaSearchType || (AviaSearchType = {}));
    let AviaSortVariant;
    (function (AviaSortVariant) {
        AviaSortVariant[AviaSortVariant["Price"] = 0] = "Price";
        AviaSortVariant[AviaSortVariant["DepartureTime"] = 1] = "DepartureTime";
        AviaSortVariant[AviaSortVariant["ArrivalTime"] = 2] = "ArrivalTime";
        AviaSortVariant[AviaSortVariant["ChangeAircraftDuration"] = 3] = "ChangeAircraftDuration";
        AviaSortVariant[AviaSortVariant["TotalWayTime"] = 4] = "TotalWayTime";
    })(AviaSortVariant || (AviaSortVariant = {}));
    class AviaPageMobile extends App.AviaFormBaseMobile {
        // #tabs: JQuery;
        constructor(options) {
            var _b, _c, _d, _e, _f;
            super(Object.assign({ root: '.js-avia-page' }, options));
            _AviaPageMobile_instances.add(this);
            _AviaPageMobile_options.set(this, void 0);
            _AviaPageMobile_usePartialSearch.set(this, true);
            _AviaPageMobile_messages.set(this, void 0);
            _AviaPageMobile_preloader.set(this, void 0);
            _AviaPageMobile_filter.set(this, void 0);
            // #form: Form;
            _AviaPageMobile_popup.set(this, void 0);
            _AviaPageMobile_responseValidator.set(this, void 0);
            _AviaPageMobile_hotFilter.set(this, void 0);
            _AviaPageMobile_groupPage.set(this, void 0);
            _AviaPageMobile_bookPage.set(this, void 0);
            _AviaPageMobile_searchType.set(this, void 0);
            _AviaPageMobile_stopPartialSearch.set(this, false);
            _AviaPageMobile_searchData.set(this, void 0);
            _AviaPageMobile_searchInitXhr.set(this, void 0);
            _AviaPageMobile_searchXhr.set(this, void 0);
            _AviaPageMobile_searchResponse.set(this, void 0);
            _AviaPageMobile_searchExpirationPopup.set(this, void 0);
            // текущие плоские результаты, с учетом фильтрации и др.
            _AviaPageMobile_currentItems.set(this, void 0);
            _AviaPageMobile_currentGroups.set(this, void 0);
            _AviaPageMobile_selectedGroupKey.set(this, void 0);
            _AviaPageMobile_selectedGroup.set(this, void 0);
            _AviaPageMobile_selectedVariant.set(this, void 0);
            _AviaPageMobile_currentPage.set(this, 0 /* AviaPageState.Search */);
            _AviaPageMobile_hotFilterContainer.set(this, void 0);
            _AviaPageMobile_resultBlock.set(this, void 0);
            _AviaPageMobile_resultContainer.set(this, void 0);
            _AviaPageMobile_showMoreBlock.set(this, void 0);
            _AviaPageMobile_showMoreLink.set(this, void 0);
            _AviaPageMobile_showMoreCurrent.set(this, void 0);
            _AviaPageMobile_showMoreCountSelected.set(this, void 0);
            _AviaPageMobile_showMoreCountOption.set(this, void 0);
            _AviaPageMobile_showMoreTotal.set(this, void 0);
            _AviaPageMobile_resultTemplate.set(this, void 0);
            _AviaPageMobile_hotFilterTemplate.set(this, void 0);
            _AviaPageMobile_pagingTemplate.set(this, void 0);
            _AviaPageMobile_groupTemplate.set(this, void 0);
            _AviaPageMobile_bookTemplate.set(this, void 0);
            _AviaPageMobile_currentResultType.set(this, void 0);
            _AviaPageMobile_currentPageSize.set(this, void 0);
            _AviaPageMobile_currentPageNumber.set(this, void 0);
            _AviaPageMobile_currentSortingInfo.set(this, void 0);
            _AviaPageMobile_historyStates.set(this, void 0);
            _AviaPageMobile_pageState.set(this, void 0);
            _AviaPageMobile_pricePresenter.set(this, void 0);
            __classPrivateFieldSet(this, _AviaPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            // console.log('AviaPageMobile -->', this.#options);
            __classPrivateFieldSet(this, _AviaPageMobile_selectedGroupKey, options === null || options === void 0 ? void 0 : options.groupKey, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, { key: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").variantKey }, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_currentResultType, App.AviaResultType.flat, "f"); // AviaResultType.group;
            __classPrivateFieldSet(this, _AviaPageMobile_currentPageSize, __classPrivateFieldGet(_a, _a, "f", _AviaPageMobile_defaultPageSize), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_currentSortingInfo, {
                field: AviaSortVariant[AviaSortVariant.Price],
                reverse: false,
            }, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_messages, new App.Messages(), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_preloader, new App.Preloader(), "f");
            const dateLimit = __classPrivateFieldGet(this, _AviaPageMobile_options, "f").dateLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _AviaPageMobile_options, "f").dateLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _AviaPageMobile_options, "f").dateLimit.max) };
            __classPrivateFieldSet(this, _AviaPageMobile_filter, new App.AviaMainFilterMobile({
                dateOptions: {
                    minDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.min,
                    maxDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.max,
                    defaultDateShift: App.app.settings.aviaOptions.defaultDateShift,
                },
                datesOptions: {
                    minDateFrom: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.min,
                    maxDateFrom: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.max,
                    minDateFromShift: App.app.settings.aviaOptions.minDateShift,
                    defaultDateFromShift: App.app.settings.aviaOptions.defaultDateShift,
                },
                minStartDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.min,
                maxStartDate: dateLimit === null || dateLimit === void 0 ? void 0 : dateLimit.max,
            }), "f");
            if (__classPrivateFieldGet(this, _AviaPageMobile_usePartialSearch, "f")) {
                // порционка
                __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onSearchPartial).call(this, e, data); }));
                this.root.on("filter:startPartialSearch" /* Events.FilterStartPartialSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onStartPartialSearch).call(this, e, data); }));
            }
            else {
                // всё сразу
                __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onSearch).call(this, e, data); }));
            }
            // TODO Dragushin this.#form = new Form({ root: this.#filter.root, disableStepValidation: true });
            __classPrivateFieldSet(this, _AviaPageMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaPageMobile_popup, "f")),
                /* TODO
                validator: this.#form.validator,
                allowEmptyData: true,
                */
            }), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_historyStates, {
                // 'search_form': {
                0: {
                    handler: () => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showSearchPage).call(this),
                    actionName: 'search',
                    title: 'Поиск авиабилетов',
                },
                // , 'get_results': {
                1: {
                    handler: () => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResultPage).call(this),
                    actionName: 'results',
                    title: 'Результаты поиска авиабилетов',
                },
                // , 'show_group': {
                2: {
                    handler: () => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showGroupPage).call(this),
                    actionName: 'group',
                    params: ['group'],
                    title: 'Выбранная группа авиабилетов',
                },
                3: {
                    handler: () => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showBookPage).call(this),
                    actionName: 'book',
                    params: ['group', 'variant'],
                    title: 'Бронирование авиабилетов',
                },
            }, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_resultBlock, $('.js-avia-results-block', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_resultContainer, $('.js-avia-results', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_hotFilterContainer, $('.js-subfilter-block', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_showMoreBlock, $('.js-show-more', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_showMoreLink, $('.js-show-more-link', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_showMoreCurrent, $('.js-show-more-current', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_showMoreCountSelected, $('.js-show-count-selected', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_showMoreCountOption, $('.js-show-count-option', this.root), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_showMoreTotal, $('.js-show-more-total', this.root), "f");
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreLink, "f").on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onShowMoreGroupsClick).call(this); }));
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCountOption, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_changePageSize).call(this, e); }));
            __classPrivateFieldSet(this, _AviaPageMobile_resultTemplate, App.findTemplate((_b = __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").attr('data-template')) !== null && _b !== void 0 ? _b : ''), "f");
            if (__classPrivateFieldGet(this, _AviaPageMobile_usePartialSearch, "f"))
                __classPrivateFieldSet(this, _AviaPageMobile_hotFilterTemplate, App.findTemplate((_c = __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").attr('data-hotfilter-template')) !== null && _c !== void 0 ? _c : ''), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_pagingTemplate, App.findTemplate((_d = __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").attr('data-paging-template')) !== null && _d !== void 0 ? _d : ''), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_groupTemplate, App.findTemplate((_e = __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").attr('data-group-template')) !== null && _e !== void 0 ? _e : ''), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_bookTemplate, App.findTemplate((_f = __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").attr('data-book-template')) !== null && _f !== void 0 ? _f : ''), "f");
            __classPrivateFieldSet(this, _AviaPageMobile_pricePresenter, new App.NetPricePresenter({ root: this.root, desired: App.AdditionalPriceShow.ToPay }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    if (__classPrivateFieldGet(this, _AviaPageMobile_searchInitXhr, "f"))
                        __classPrivateFieldGet(this, _AviaPageMobile_searchInitXhr, "f").abort();
                    if (__classPrivateFieldGet(this, _AviaPageMobile_searchXhr, "f"))
                        __classPrivateFieldGet(this, _AviaPageMobile_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            if (__classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_canSearch).call(this))
                $('body').on("app:loaded" /* Events.Loaded */, () => __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").search());
            $(window).on('popstate', () => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onHistoryPopState).call(this));
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                if (__classPrivateFieldGet(this, _AviaPageMobile_pageState, "f") === 2 /* AviaPageState.Group */) {
                    const result = new Array();
                    this.root.find('.js-avia-variants-wrap').each((i, v) => {
                        const container = $(v);
                        const variants = container.find('.js-avia-variant-block-wrap:visible');
                        const activeVariant = variants.filter('._active');
                        const selectedVariants = activeVariant.length > 0 ? activeVariant : variants;
                        const item = new Array();
                        selectedVariants.each((j, x) => {
                            if (!__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f"))
                                return;
                            const flightKey = $(x).attr('data-flights');
                            const variant = __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f").variants.find(y => y.legs[i].flightNumbers === flightKey);
                            if (variant)
                                item.push(variant.legs[i]);
                        });
                        result.push(item);
                    });
                    // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                    // addEventListener на стороне сайта (при помощи своей копии jQuery).
                    document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                        detail: {
                            // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                            state: e.detail,
                            data: Object.assign(Object.assign({}, __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f")), { variants: result }),
                        },
                    }));
                }
                else if (__classPrivateFieldGet(this, _AviaPageMobile_pageState, "f") === 1 /* AviaPageState.Results */) {
                    const container = $(e.detail.container);
                    const offerId = container.parents('[data-offer-uid]').attr('data-offer-uid');
                    // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                    // addEventListener на стороне сайта (при помощи своей копии jQuery).
                    document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                        detail: {
                            // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                            state: e.detail,
                            data: __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this).find(v => v.key === offerId),
                        },
                    }));
                }
            });
        }
        /**
         * Произошли изменения в фильтрах (выбрали что-то) пользователем (не кодом).
         * Выполняем автопоиск, либо обновляем зависимые фильтры (например, при смене страны обновляем список городов в фильтре).
         * Возможно еще слушать аналогичное событие непосредственно от фильтров FiltersMobileBase, либо тут, на всю страницу.
         * @param filterName
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!filterName)
                    return;
                console.log('onFilterChanged in AviaPage: ' + filterName);
                // смена сортировки
                if (filterName == 'Sort.HotFilter')
                    yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onSorting).call(this);
            });
        }
        sendForm() {
            throw new Error('Not implemented');
        }
        updateHistory(url, pageState, changeHistory = true) {
            if (!changeHistory)
                return;
            const curState = __classPrivateFieldGet(this, _AviaPageMobile_pageState, "f");
            if (curState === pageState) {
                window.history.replaceState({ state: __classPrivateFieldGet(this, _AviaPageMobile_pageState, "f") }, `title: ${__classPrivateFieldGet(this, _AviaPageMobile_historyStates, "f")[__classPrivateFieldGet(this, _AviaPageMobile_pageState, "f")].title}`, url);
            }
            else {
                __classPrivateFieldSet(this, _AviaPageMobile_pageState, pageState, "f");
                window.history.pushState({ state: __classPrivateFieldGet(this, _AviaPageMobile_pageState, "f") }, `title: ${__classPrivateFieldGet(this, _AviaPageMobile_historyStates, "f")[__classPrivateFieldGet(this, _AviaPageMobile_pageState, "f")].title}`, url);
            }
        }
    }
    _a = AviaPageMobile, _AviaPageMobile_options = new WeakMap(), _AviaPageMobile_usePartialSearch = new WeakMap(), _AviaPageMobile_messages = new WeakMap(), _AviaPageMobile_preloader = new WeakMap(), _AviaPageMobile_filter = new WeakMap(), _AviaPageMobile_popup = new WeakMap(), _AviaPageMobile_responseValidator = new WeakMap(), _AviaPageMobile_hotFilter = new WeakMap(), _AviaPageMobile_groupPage = new WeakMap(), _AviaPageMobile_bookPage = new WeakMap(), _AviaPageMobile_searchType = new WeakMap(), _AviaPageMobile_stopPartialSearch = new WeakMap(), _AviaPageMobile_searchData = new WeakMap(), _AviaPageMobile_searchInitXhr = new WeakMap(), _AviaPageMobile_searchXhr = new WeakMap(), _AviaPageMobile_searchResponse = new WeakMap(), _AviaPageMobile_searchExpirationPopup = new WeakMap(), _AviaPageMobile_currentItems = new WeakMap(), _AviaPageMobile_currentGroups = new WeakMap(), _AviaPageMobile_selectedGroupKey = new WeakMap(), _AviaPageMobile_selectedGroup = new WeakMap(), _AviaPageMobile_selectedVariant = new WeakMap(), _AviaPageMobile_currentPage = new WeakMap(), _AviaPageMobile_hotFilterContainer = new WeakMap(), _AviaPageMobile_resultBlock = new WeakMap(), _AviaPageMobile_resultContainer = new WeakMap(), _AviaPageMobile_showMoreBlock = new WeakMap(), _AviaPageMobile_showMoreLink = new WeakMap(), _AviaPageMobile_showMoreCurrent = new WeakMap(), _AviaPageMobile_showMoreCountSelected = new WeakMap(), _AviaPageMobile_showMoreCountOption = new WeakMap(), _AviaPageMobile_showMoreTotal = new WeakMap(), _AviaPageMobile_resultTemplate = new WeakMap(), _AviaPageMobile_hotFilterTemplate = new WeakMap(), _AviaPageMobile_pagingTemplate = new WeakMap(), _AviaPageMobile_groupTemplate = new WeakMap(), _AviaPageMobile_bookTemplate = new WeakMap(), _AviaPageMobile_currentResultType = new WeakMap(), _AviaPageMobile_currentPageSize = new WeakMap(), _AviaPageMobile_currentPageNumber = new WeakMap(), _AviaPageMobile_currentSortingInfo = new WeakMap(), _AviaPageMobile_historyStates = new WeakMap(), _AviaPageMobile_pageState = new WeakMap(), _AviaPageMobile_pricePresenter = new WeakMap(), _AviaPageMobile_instances = new WeakSet(), _AviaPageMobile_canSearch = function _AviaPageMobile_canSearch() {
        const urlParameters = App.UrlParameterHelper.urlParse();
        return this.requiredUrlChecker.isValid(urlParameters) && !App.UrlParameterHelper.isManual(urlParameters);
    }, _AviaPageMobile_onSearch = function _AviaPageMobile_onSearch(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AviaPageMobile_messages, "f").hide();
            if (data.newSearch === 'true') {
                __classPrivateFieldSet(this, _AviaPageMobile_selectedGroupKey, undefined, "f");
                __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, undefined, "f");
                __classPrivateFieldGet(this, _AviaPageMobile_options, "f").variantKey = undefined;
            }
            if (__classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f")) {
                __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").dispose();
                __classPrivateFieldSet(this, _AviaPageMobile_groupPage, undefined, "f");
            }
            if (data['Form.By'] === AviaSearchType[AviaSearchType.Date])
                __classPrivateFieldSet(this, _AviaPageMobile_searchType, AviaSearchType.Date, "f");
            else
                __classPrivateFieldSet(this, _AviaPageMobile_searchType, AviaSearchType.BestPrice, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.search,
                method: 'POST',
                data,
                beforeSend: () => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onSearchBefore).call(this),
            }), "f");
            try {
                const response = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_parseResponse).call(this, yield __classPrivateFieldGet(this, _AviaPageMobile_searchXhr, "f"));
                // const form = new App.Form({ root: this.#filter.getCurrentForm() });
                const form = __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").getCurrentForm();
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _AviaPageMobile_messages, "f"), form.getValidator()))
                    return;
                if (!response || !response.data)
                    return;
                __classPrivateFieldSet(this, _AviaPageMobile_searchResponse, response.data, "f");
                if (__classPrivateFieldGet(this, _AviaPageMobile_searchType, "f") == AviaSearchType.Date)
                    yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResults).call(this, __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f"), true);
                else
                    __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showBestPriceResults).call(this, __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f"));
            }
            finally {
                __classPrivateFieldGet(this, _AviaPageMobile_preloader, "f").hide();
            }
        });
    }, _AviaPageMobile_onSearchPartial = function _AviaPageMobile_onSearchPartial(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('#onSearchPartial --', data);
            __classPrivateFieldGet(this, _AviaPageMobile_messages, "f").hide();
            if (__classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f")) {
                __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").dispose();
                __classPrivateFieldSet(this, _AviaPageMobile_groupPage, undefined, "f");
            }
            __classPrivateFieldSet(this, _AviaPageMobile_currentGroups, null, "f");
            if (__classPrivateFieldGet(this, _AviaPageMobile_searchInitXhr, "f"))
                __classPrivateFieldGet(this, _AviaPageMobile_searchInitXhr, "f").abort();
            if (__classPrivateFieldGet(this, _AviaPageMobile_searchXhr, "f"))
                __classPrivateFieldGet(this, _AviaPageMobile_searchXhr, "f").abort();
            if (data['Form.By'] === AviaSearchType[AviaSearchType.Date]) {
                yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_searchByDate).call(this, data);
                return;
            }
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_searchByBestPrice).call(this, data);
        });
    }, _AviaPageMobile_searchByDate = function _AviaPageMobile_searchByDate(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (data.newSearch === 'true') {
                __classPrivateFieldSet(this, _AviaPageMobile_selectedGroupKey, undefined, "f");
                __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, undefined, "f");
                __classPrivateFieldGet(this, _AviaPageMobile_options, "f").variantKey = undefined;
                if (__classPrivateFieldGet(this, _AviaPageMobile_hotFilter, "f"))
                    __classPrivateFieldGet(this, _AviaPageMobile_hotFilter, "f").dispose();
                __classPrivateFieldSet(this, _AviaPageMobile_hotFilter, undefined, "f");
            }
            __classPrivateFieldSet(this, _AviaPageMobile_searchXhr, undefined, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_stopPartialSearch, false, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_searchResponse, {}, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_searchType, AviaSearchType.Date, "f");
            __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onSearchBefore).call(this);
            __classPrivateFieldSet(this, _AviaPageMobile_searchData, data, "f");
            this.root.trigger("filter:startPartialSearch" /* Events.FilterStartPartialSearch */, [data]);
            __classPrivateFieldSet(this, _AviaPageMobile_searchInitXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.search,
                method: 'POST',
                data,
            }), "f");
            try {
                yield __classPrivateFieldGet(this, _AviaPageMobile_searchInitXhr, "f");
                __classPrivateFieldSet(this, _AviaPageMobile_stopPartialSearch, true, "f");
            }
            catch (ex) {
                window.console.log(ex);
                /* TODO
                if (!this.#responseValidator.processError(ex))
                    throw ex;
                */
            }
        });
    }, _AviaPageMobile_onStartPartialSearch = function _AviaPageMobile_onStartPartialSearch(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            window.setTimeout(() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_doPartialSearch).call(this, data); }), __classPrivateFieldGet(_a, _a, "f", _AviaPageMobile_partialSearchFirstInterval));
        });
    }, _AviaPageMobile_checkControlSum = function _AviaPageMobile_checkControlSum(data) {
        return data === __classPrivateFieldGet(this, _AviaPageMobile_searchData, "f");
    }, _AviaPageMobile_doPartialSearch = function _AviaPageMobile_doPartialSearch(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_checkControlSum).call(this, data))
                return;
            let lastLoop = false;
            if (__classPrivateFieldGet(this, _AviaPageMobile_stopPartialSearch, "f")) {
                lastLoop = true;
                data.LastLoop = 'true';
            }
            try {
                __classPrivateFieldSet(this, _AviaPageMobile_searchXhr, $.ajax({
                    url: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.continueSearch,
                    method: 'POST',
                    data,
                }), "f");
                const response = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_parseResponse).call(this, yield __classPrivateFieldGet(this, _AviaPageMobile_searchXhr, "f"));
                if (lastLoop && !__classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").result) {
                    __classPrivateFieldGet(this, _AviaPageMobile_preloader, "f").hide();
                    // const form = new App.Form({ root: this.#filter.getCurrentForm() });
                    const form = __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").getCurrentForm();
                    if (!App.validateResponse(response, __classPrivateFieldGet(this, _AviaPageMobile_messages, "f"), form.getValidator()))
                        return;
                }
                if (!response || !response.data)
                    return;
                if (!__classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f"))
                    return;
                if (!response.data.result) {
                    if (!__classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").seo) {
                        __classPrivateFieldSet(this, _AviaPageMobile_searchResponse, response.data, "f");
                        yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResults).call(this, __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f"), true);
                    }
                }
                else {
                    if (!__classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").result) {
                        __classPrivateFieldSet(this, _AviaPageMobile_searchResponse, response.data, "f");
                        __classPrivateFieldSet(this, _AviaPageMobile_currentItems, __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").result.groups = __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").result.groups
                            .sort((v1, v2) => (v1.grossPrice > v2.grossPrice ? 1 : -1)), "f");
                    }
                    else {
                        __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").result.groups = __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").result.groups
                            .concat(response.data.result.groups)
                            .sort((v1, v2) => (v1.grossPrice > v2.grossPrice ? 1 : -1))
                            // убираем дубликаты
                            .filter((v, i, a) => a.map(x => x.key).indexOf(v.key) === i);
                        // делаем по очереди, т.к. в текущих результатах уже могут произойти изменений, как то: втор.фильтрация.
                        __classPrivateFieldSet(this, _AviaPageMobile_currentItems, __classPrivateFieldGet(this, _AviaPageMobile_currentItems, "f")
                            .concat(response.data.result.groups)
                            .sort((v1, v2) => (v1.grossPrice > v2.grossPrice ? 1 : -1))
                            // убираем дубликаты
                            .filter((v, i, a) => a.map(x => x.key).indexOf(v.key) === i), "f");
                    }
                    yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResults).call(this, __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f"), true);
                    __classPrivateFieldGet(this, _AviaPageMobile_preloader, "f").hide();
                }
                if (lastLoop) {
                    $('.js-progress-data-loading', this.root).hide();
                }
                else {
                    window.setTimeout(() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_doPartialSearch).call(this, data); }), (__classPrivateFieldGet(this, _AviaPageMobile_stopPartialSearch, "f") ? __classPrivateFieldGet(_a, _a, "f", _AviaPageMobile_partialLastSearchInterval) : __classPrivateFieldGet(_a, _a, "f", _AviaPageMobile_partialSearchInterval)));
                }
            }
            catch (ex) {
                __classPrivateFieldGet(this, _AviaPageMobile_preloader, "f").hide();
                window.console.log(ex);
            }
        });
    }, _AviaPageMobile_searchByBestPrice = function _AviaPageMobile_searchByBestPrice(data) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('#searchByBestPrice --');
            __classPrivateFieldSet(this, _AviaPageMobile_searchType, AviaSearchType.BestPrice, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.search,
                method: 'POST',
                data,
                beforeSend: () => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onSearchBefore).call(this),
            }), "f");
            try {
                const response = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_parseResponse).call(this, yield __classPrivateFieldGet(this, _AviaPageMobile_searchXhr, "f"));
                // const form = new App.Form({ root: this.#filter.getCurrentForm() });
                const form = __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").getCurrentForm();
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _AviaPageMobile_messages, "f"), form.getValidator()))
                    return;
                if (!response || !response.data)
                    return;
                __classPrivateFieldSet(this, _AviaPageMobile_searchResponse, response.data, "f");
                __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showBestPriceResults).call(this, response.data);
            }
            finally {
                __classPrivateFieldGet(this, _AviaPageMobile_preloader, "f").hide();
            }
        });
    }, _AviaPageMobile_parseResponse = function _AviaPageMobile_parseResponse(responseOriginal) {
        if (!responseOriginal)
            return responseOriginal;
        const response = responseOriginal;
        // переводим все имена контролов к мобильным именам
        if (response.status && response.status.modelState && response.status.modelState.errors) {
            const errs = {};
            // маппинг имен к мобильным версиям
            Object.entries(response.status.modelState.errors).forEach(([k, v]) => {
                const key = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_parseResponseGetKey).call(this, k);
                errs[key] = v;
            });
            // подменяем ошибки
            response.status.modelState.errors = errs;
        }
        // console.log(response);
        return response;
    }, _AviaPageMobile_parseResponseGetKey = function _AviaPageMobile_parseResponseGetKey(keyOriginal) {
        let key = keyOriginal;
        const currentFormKey = __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").getCurrentForm().key;
        // -- fix names --
        if (key.endsWith('.ArrivalLocationName')) {
            key = key.slice(0, key.length - 'Name'.length);
        }
        else if (key.endsWith('.DepartureLocationName')) {
            key = key.slice(0, key.length - 'Name'.length);
        }
        // -- by tabs --
        // если в Одну сторону
        if (currentFormKey == 'OneWay') {
            if (key.endsWith('.Date')) {
                key = key + '.OneWay';
            }
        }
        // если Сложный маршрут
        if (currentFormKey == 'Composite') {
            // ко всем добавляем спец имя
            key = key + '.CompositeExtraKey';
        }
        return key;
    }, _AviaPageMobile_onSearchBefore = function _AviaPageMobile_onSearchBefore() {
        var _b;
        (_b = __classPrivateFieldGet(this, _AviaPageMobile_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
        __classPrivateFieldSet(this, _AviaPageMobile_searchExpirationPopup, undefined, "f");
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_resetData).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_resetControls).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_preloader, "f").show();
    }, _AviaPageMobile_resetData = function _AviaPageMobile_resetData() {
        __classPrivateFieldSet(this, _AviaPageMobile_currentPageNumber, 1, "f");
        __classPrivateFieldSet(this, _AviaPageMobile_currentPageSize, __classPrivateFieldGet(_a, _a, "f", _AviaPageMobile_defaultPageSize), "f");
    }, _AviaPageMobile_resetControls = function _AviaPageMobile_resetControls() {
        __classPrivateFieldGet(this, _AviaPageMobile_hotFilterContainer, "f").empty();
        __classPrivateFieldGet(this, _AviaPageMobile_hotFilterContainer, "f").hide();
        __classPrivateFieldGet(this, _AviaPageMobile_resultContainer, "f").empty();
        __classPrivateFieldGet(this, _AviaPageMobile_showMoreBlock, "f").hide();
        const val = App.Cookie.get("showCount" /* KnownCookie.ShowCount */);
        if (val) {
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCountOption, "f").removeClass('_active');
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCountOption, "f").parent().find('li:contains("' + val + '")').addClass('_active');
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCountSelected, "f").text(val);
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCurrent, "f").text(val);
        }
    }, _AviaPageMobile_showResults = function _AviaPageMobile_showResults(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, changeHistory = false) {
            var _b;
            if (data.seo)
                App.app.seo.update(data.seo);
            if (!data.result || !data.result.groups)
                return;
            // в фильтр передаем плоский список, чтобы его же и вернуть.
            const groups = __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").result.groups;
            if (changeHistory) {
                if (data.subfilter)
                    __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showServerHotFilter).call(this, data.subfilter, groups);
                else if (groups)
                    __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showHotFilter).call(this, groups);
            }
            const changedData = new App.ChangedDataMobile();
            __classPrivateFieldSet(_a, _a, data.pageSize, "f", _AviaPageMobile_defaultPageSize);
            changedData.pageSize = __classPrivateFieldGet(_a, _a, "f", _AviaPageMobile_defaultPageSize);
            changedData.pageNumber = 1;
            // приводим к нужному типу группировки
            changedData.groups = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this, true);
            changedData.href = data.seo.url;
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_changeData).call(this, changedData, changeHistory);
            if (__classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentPageType).call(this) == 0 /* AviaPageState.Search */)
                __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResultPageCase).call(this, true);
            if (changeHistory) {
                if (groups.length > 0) {
                    if (!__classPrivateFieldGet(this, _AviaPageMobile_searchExpirationPopup, "f")) {
                        __classPrivateFieldSet(this, _AviaPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: data.ttl,
                            url: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.search,
                        }), "f");
                    }
                }
            }
            if ((_b = __classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f")) === null || _b === void 0 ? void 0 : _b.key)
                yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_gotoBookPage).call(this, __classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f").key);
            else if (__classPrivateFieldGet(this, _AviaPageMobile_selectedGroupKey, "f"))
                yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_gotoGroupPage).call(this, __classPrivateFieldGet(this, _AviaPageMobile_selectedGroupKey, "f"));
        });
    }, _AviaPageMobile_showBestPriceResults = function _AviaPageMobile_showBestPriceResults(data) {
        App.app.seo.update(data.seo);
        if (!data.result)
            return;
        __classPrivateFieldGet(this, _AviaPageMobile_resultContainer, "f").append(data.result.bestPrice);
        $('#bestPricesTable .js-matrix-cell-search').on('click', e => __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onMatrixCellSearch).call(this, e));
        // чтобы не было случайного перехода после поиска матрицы и выбора даты.
        __classPrivateFieldSet(this, _AviaPageMobile_selectedGroupKey, undefined, "f");
        __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, undefined, "f");
        __classPrivateFieldGet(this, _AviaPageMobile_options, "f").variantKey = undefined;
        this.updateHistory(data.seo.url, 1 /* AviaPageState.Results */);
        __classPrivateFieldSet(this, _AviaPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
            interval: data.ttl,
            url: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.search,
        }), "f");
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResultPageCase).call(this, true);
    }, _AviaPageMobile_onMatrixCellSearch = function _AviaPageMobile_onMatrixCellSearch(event) {
        var _b;
        const self = $(event.currentTarget);
        const legDateBlock = '.date-block';
        const legDateLabel = 'label.flight-date';
        // 29896|LX|22.11.2014|06.12.2014
        const vals = ((_b = self.attr('data-value')) !== null && _b !== void 0 ? _b : '').split('|');
        if (vals.length < 3 || vals.length > 4)
            return;
        // выставляем даты
        $('input.js-filter-date-from', this.root)
            .val(vals[2])
            .closest(legDateBlock)
            .find(legDateLabel)
            .text(vals[2]);
        $('input.js-filter-date, input.js-filter-date-to', this.root)
            .val(vals[3])
            .closest(legDateBlock)
            .find(legDateLabel)
            .text(vals[3]);
        // Поиск по конкретной дате
        $('.js-tab-wrap:visible') // идем от видимой закладки, т.к. радио-батоны в 2х закладках!
            .find('.js-filter-radio-btn-flight-type')
            .filter('[data-id="Date"]')
            .trigger('click');
        __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").search(true);
    }, _AviaPageMobile_showServerHotFilter = function _AviaPageMobile_showServerHotFilter(subfilter, groups) {
        __classPrivateFieldGet(this, _AviaPageMobile_hotFilterContainer, "f").show();
        __classPrivateFieldGet(this, _AviaPageMobile_hotFilterContainer, "f").prepend(subfilter);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_activateHotFilter).call(this, groups);
    }, _AviaPageMobile_showHotFilter = function _AviaPageMobile_showHotFilter(groups) {
        const model = App.AviaHotFilterMobile.getModel(__classPrivateFieldGet(this, _AviaPageMobile_hotFilter, "f"), groups, __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").getTripType(), __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").isDirect());
        const viewModel = Object.assign(Object.assign({}, model), { showNetPrice: groups.some(g => g.discount > 0), checked: App.NetPricePresenter.getVisibility() });
        const hotfilter = $(__classPrivateFieldGet(this, _AviaPageMobile_hotFilterTemplate, "f").call(this, viewModel));
        __classPrivateFieldGet(this, _AviaPageMobile_hotFilterContainer, "f").empty().prepend(hotfilter);
        __classPrivateFieldGet(this, _AviaPageMobile_hotFilterContainer, "f").show();
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_activateHotFilter).call(this, groups);
    }, _AviaPageMobile_activateHotFilter = function _AviaPageMobile_activateHotFilter(groups) {
        if (__classPrivateFieldGet(this, _AviaPageMobile_hotFilter, "f"))
            __classPrivateFieldGet(this, _AviaPageMobile_hotFilter, "f").dispose();
        __classPrivateFieldSet(this, _AviaPageMobile_hotFilter, new App.AviaHotFilterMobile(groups), "f");
        __classPrivateFieldGet(this, _AviaPageMobile_hotFilter, "f").root.on("hotfilter:change" /* Events.HotFilterChange */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onHotFilterChange).call(this, e, data); }));
    }, _AviaPageMobile_changeData = function _AviaPageMobile_changeData(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, changeHistory = false) {
            var _b;
            const subfilterInfoCount = $(this.root).find('.js-filter-count');
            if (data.showMore)
                __classPrivateFieldSet(this, _AviaPageMobile_currentPageNumber, (_b = __classPrivateFieldGet(this, _AviaPageMobile_currentPageNumber, "f"), _b++, _b), "f");
            else if (data.pageNumber)
                __classPrivateFieldSet(this, _AviaPageMobile_currentPageNumber, data.pageNumber, "f");
            else
                __classPrivateFieldSet(this, _AviaPageMobile_currentPageNumber, 1, "f");
            if (data.pageSize)
                __classPrivateFieldSet(this, _AviaPageMobile_currentPageSize, data.pageSize, "f");
            if (!data.groups)
                data.groups = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this, true);
            let pageGroups;
            if (data.showMore) {
                pageGroups = data.groups.slice(0, __classPrivateFieldGet(this, _AviaPageMobile_currentPageSize, "f") * __classPrivateFieldGet(this, _AviaPageMobile_currentPageNumber, "f"));
            }
            else {
                const skipCount = (__classPrivateFieldGet(this, _AviaPageMobile_currentPageNumber, "f") - 1) * __classPrivateFieldGet(this, _AviaPageMobile_currentPageSize, "f");
                pageGroups = data.groups.slice(skipCount, skipCount + __classPrivateFieldGet(this, _AviaPageMobile_currentPageSize, "f"));
            }
            $.each(pageGroups, (index, item) => (item.href = `${App.removeEndChar(data.href, '/')}/group-${item.key}/`));
            const count = data.groups
                .map(v => v.variants.length)
                .reduce((prev, cur) => prev + cur, 0);
            subfilterInfoCount.html(`${count} ${App.pluralRu(count, 'предложение', 'предложения', 'предложений')}`);
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_appendGroups).call(this, pageGroups);
            this.updateHistory(data.href, 1 /* AviaPageState.Results */, changeHistory);
            // this.#initViewTypeTabs();
            __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_initPageNumbers).call(this, data.groups.length, __classPrivateFieldGet(this, _AviaPageMobile_currentPageNumber, "f"), __classPrivateFieldGet(this, _AviaPageMobile_currentPageSize, "f"));
        });
    }, _AviaPageMobile_appendGroups = function _AviaPageMobile_appendGroups(groups) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = {
                dynamicFlight: false,
                sortItems: JSON.stringify(__classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getSortVariants).call(this)),
                sortUp: !__classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse,
                resultType: App.AviaResultType[__classPrivateFieldGet(this, _AviaPageMobile_currentResultType, "f")],
                groups,
            };
            const content = $(__classPrivateFieldGet(this, _AviaPageMobile_resultTemplate, "f").call(this, data));
            yield App.CurrencyManager.convertAll(content);
            App.NetPricePresenter.setVisibility(content, App.NetPricePresenter.getVisibility());
            __classPrivateFieldGet(this, _AviaPageMobile_resultContainer, "f")
                .empty()
                .append(content);
            if (!__classPrivateFieldGet(this, _AviaPageMobile_usePartialSearch, "f"))
                $('.js-progress-data-loading', this.root).hide();
            $('.js-avia-card-block', __classPrivateFieldGet(this, _AviaPageMobile_resultContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onGroupClick).call(this, e); }));
            // sort
            // $('.js-sort-item', this.#resultContainer).on('click', async e => await this.#onSorting(e));
            new App.HotFilterMobile({ root: '.js-filter-avia-sort' });
            this.components.push(new App.AviaBrandFareComponent({
                root: this.root,
                popup: __classPrivateFieldGet(this, _AviaPageMobile_popup, "f"),
                responseValidator: __classPrivateFieldGet(this, _AviaPageMobile_responseValidator, "f"),
            }));
            __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showShowMoreGroups).call(this);
        });
    }, _AviaPageMobile_getSortVariants = function _AviaPageMobile_getSortVariants() {
        return [
            { value: 'Цена', key: AviaSortVariant[AviaSortVariant.Price], selectedDesc: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse, selected: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.Price] },
            { value: 'Вылет', key: AviaSortVariant[AviaSortVariant.DepartureTime], selectedDesc: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse, selected: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.DepartureTime] },
            { value: 'Прилет', key: AviaSortVariant[AviaSortVariant.ArrivalTime], selectedDesc: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse, selected: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.ArrivalTime] },
            { value: 'Пересадки', key: AviaSortVariant[AviaSortVariant.ChangeAircraftDuration], selectedDesc: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse, selected: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.ChangeAircraftDuration] },
            { value: 'В пути', key: AviaSortVariant[AviaSortVariant.TotalWayTime], selectedDesc: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse, selected: __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field === AviaSortVariant[AviaSortVariant.TotalWayTime] },
        ];
    }, _AviaPageMobile_onSorting = function _AviaPageMobile_onSorting() {
        return __awaiter(this, void 0, void 0, function* () {
            const sortSelected = PwStore.GetFilterItem('Sort.HotFilter', false);
            const value = (sortSelected ? sortSelected.key : '');
            if (value && Object.values(AviaSortVariant).includes(value))
                __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_setCurrentSorting).call(this, AviaSortVariant[value]);
            __classPrivateFieldSet(this, _AviaPageMobile_currentGroups, null, "f");
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResults).call(this, __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f"));
        });
    }, _AviaPageMobile_initPageNumbers = function _AviaPageMobile_initPageNumbers(groupCount, selectedPageNumber, pageSize) {
        const pageCountApx = groupCount / pageSize;
        const pageCountAdd = pageCountApx > Math.floor(pageCountApx) ? 1 : 0;
        const pageCount = Math.floor(pageCountApx) + pageCountAdd;
        const pageNumbersBlock = $(this.root).find('.js-page-numbers-block');
        pageNumbersBlock.empty();
        if (pageCount <= 1)
            return false;
        const pages = [];
        for (let i = 1; i <= pageCount; i++)
            pages[i - 1] = [i, i === selectedPageNumber];
        const pageBlock = __classPrivateFieldGet(this, _AviaPageMobile_pagingTemplate, "f").call(this, pages);
        pageNumbersBlock.append(pageBlock);
        pageNumbersBlock.find('.js-active-paging-item').not('.selected').on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_changePageNumber).call(this, e); }));
        return true;
    }, _AviaPageMobile_changePageNumber = function _AviaPageMobile_changePageNumber(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const el = $(event.currentTarget);
            const changedData = new App.ChangedDataMobile();
            changedData.pageNumber = parseInt((_b = $(el).attr('data-value')) !== null && _b !== void 0 ? _b : '1', 10);
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_changeData).call(this, changedData);
        });
    }, _AviaPageMobile_changePageSize = function _AviaPageMobile_changePageSize(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const currentValue = parseInt(target.text(), 10);
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCountOption, "f").removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCountSelected, "f").text(currentValue);
            App.Cookie.set("showCount" /* KnownCookie.ShowCount */, currentValue.toString());
            __classPrivateFieldSet(this, _AviaPageMobile_currentPageSize, currentValue, "f");
            __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").pageSize = currentValue;
            const remainingData = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this).length - __classPrivateFieldGet(this, _AviaPageMobile_currentPageNumber, "f") * __classPrivateFieldGet(this, _AviaPageMobile_currentPageSize, "f");
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreCurrent, "f").text(Math.min(remainingData, currentValue));
            const changedData = new App.ChangedDataMobile();
            changedData.pageNumber = 1;
            changedData.pageSize = parseInt(target.text(), 10);
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_changeData).call(this, changedData);
        });
    }, _AviaPageMobile_onShowMoreGroupsClick = function _AviaPageMobile_onShowMoreGroupsClick() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreBlock, "f").addClass('_pulsate');
            const changedData = new App.ChangedDataMobile();
            changedData.showMore = true;
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_changeData).call(this, changedData);
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreBlock, "f").removeClass('_pulsate');
        });
    }, _AviaPageMobile_showShowMoreGroups = function _AviaPageMobile_showShowMoreGroups() {
        const remainingData = Math.max(0, __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this).length - __classPrivateFieldGet(this, _AviaPageMobile_currentPageNumber, "f") * __classPrivateFieldGet(this, _AviaPageMobile_currentPageSize, "f"));
        if (remainingData > 0) {
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreBlock, "f").show();
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreBlock, "f").toggleByClass(true);
        }
        else {
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreBlock, "f").hide();
            __classPrivateFieldGet(this, _AviaPageMobile_showMoreBlock, "f").toggleByClass(false);
        }
        __classPrivateFieldGet(this, _AviaPageMobile_showMoreCurrent, "f").text(Math.min(remainingData, __classPrivateFieldGet(this, _AviaPageMobile_currentPageSize, "f")));
        __classPrivateFieldGet(this, _AviaPageMobile_showMoreTotal, "f").text(remainingData);
    }, _AviaPageMobile_onHotFilterChange = function _AviaPageMobile_onHotFilterChange(e, groups) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const changedData = new App.ChangedDataMobile();
            changedData.pageNumber = 1;
            __classPrivateFieldSet(this, _AviaPageMobile_currentItems, groups, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_currentGroups, null, "f");
            changedData.groups = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this);
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_changeData).call(this, changedData);
        });
    }, _AviaPageMobile_onChangeGroupFare = function _AviaPageMobile_onChangeGroupFare(event, fare) {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_gotoGroupPage).call(this, fare.key, true);
        });
    }, _AviaPageMobile_onChangeVariantFare = function _AviaPageMobile_onChangeVariantFare(event, group, variant) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaPageMobile_selectedGroup, group, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, variant, "f");
            const url = `${window.location.origin}${App.removeEndChar(__classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").seo.url.replace('avia/search', 'avia/book'), '/')}/group-${__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f").key}/variant-${__classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f").key}/`;
            this.updateHistory(url, 3 /* AviaPageState.Book */);
        });
    }, _AviaPageMobile_onGroupClick = function _AviaPageMobile_onGroupClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const key = $(e.currentTarget).attr('data-key');
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_gotoGroupPage).call(this, key);
        });
    }, _AviaPageMobile_getGroup = function _AviaPageMobile_getGroup() {
        return __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this).find(v => v.key === __classPrivateFieldGet(this, _AviaPageMobile_selectedGroupKey, "f"));
    }, _AviaPageMobile_getCurrentGroups = function _AviaPageMobile_getCurrentGroups(refresh = false) {
        if (refresh || !__classPrivateFieldGet(this, _AviaPageMobile_currentGroups, "f"))
            __classPrivateFieldSet(this, _AviaPageMobile_currentGroups, __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getGroups).call(this), "f");
        return __classPrivateFieldGet(this, _AviaPageMobile_currentGroups, "f");
    }, _AviaPageMobile_getGroups = function _AviaPageMobile_getGroups() {
        /*
        if (this.#currentResultType == AviaResultType.flat) {
            const copy = App.deepCopy(this.#currentItems);
            return this.#sort(copy);
        } else {
            let result = new Array<IAviaGroupMobile>();
            Enumerable.from(App.deepCopy(this.#currentItems))
                .groupBy(v => v.groupKey,
                    v => v,
                    (k, v) => {
                        v.forEach(x => {
                            x.key = k;
                        });
                        return v.toArray();
                    },
                ).forEach(v => {
                    const group = v[0];
                    group.variants = Enumerable.from(v)
                        .selectMany(x => x.variants)
                        .orderBy(x => x.departureDateTime)
                        .thenBy(x => x.arrivalDateTime)
                        .toArray();
                    group.hasMoreVariants = v.length > 1;
                    group.routes = Enumerable.from(v).selectMany(x => x.routes).distinct().toArray();
                    group.tags = Enumerable.from(v).selectMany(x => x.tags).distinct(x => x[0]).toArray();
                    group.privateFare = Enumerable.from(v).any(x => x.privateFare);
                    result.push(group);
                    result = this.#sort(result);
                });

            return result;
        }
        */
        const copy = App.deepCopy(__classPrivateFieldGet(this, _AviaPageMobile_currentItems, "f"));
        return __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_sort).call(this, copy);
    }, _AviaPageMobile_sort = function _AviaPageMobile_sort(groups) {
        switch (__classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field) {
            case AviaSortVariant[AviaSortVariant.Price]:
                return __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => v.grossPrice)
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => v.grossPrice)
                        .toArray();
            case AviaSortVariant[AviaSortVariant.DepartureTime]:
                return __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).select(x => x.departureDateTime).min())
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).select(x => x.departureDateTime).min())
                        .toArray();
            case AviaSortVariant[AviaSortVariant.ArrivalTime]:
                return __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).select(x => x.arrivalDateTime).min())
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).select(x => x.arrivalDateTime).min())
                        .toArray();
            case AviaSortVariant[AviaSortVariant.ChangeAircraftDuration]:
                return __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).select(x => x.maxChangeAircraftDelay).min())
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).select(x => x.maxChangeAircraftDelay).min())
                        .toArray();
            case AviaSortVariant[AviaSortVariant.TotalWayTime]:
                return __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse
                    ? Enumerable.from(groups)
                        .orderByDescending(v => Enumerable.from(v.variants).select(x => x.totalWayTime).min())
                        .toArray()
                    : Enumerable.from(groups)
                        .orderBy(v => Enumerable.from(v.variants).select(x => x.totalWayTime).min())
                        .toArray();
        }
        return groups;
    }, _AviaPageMobile_setCurrentPageType = function _AviaPageMobile_setCurrentPageType(value) {
        __classPrivateFieldSet(this, _AviaPageMobile_currentPage, value, "f");
    }, _AviaPageMobile_setCurrentSorting = function _AviaPageMobile_setCurrentSorting(value) {
        if (__classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field === AviaSortVariant[value]) {
            __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse = !__classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse;
        }
        else {
            __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").field = AviaSortVariant[value];
            __classPrivateFieldGet(this, _AviaPageMobile_currentSortingInfo, "f").reverse = false;
        }
    }, _AviaPageMobile_getCurrentPageType = function _AviaPageMobile_getCurrentPageType() {
        return __classPrivateFieldGet(this, _AviaPageMobile_currentPage, "f");
    }, _AviaPageMobile_gotoGroupPage = function _AviaPageMobile_gotoGroupPage(key_1) {
        return __awaiter(this, arguments, void 0, function* (key, onChangeFare = null) {
            if (onChangeFare != true && __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentPageType).call(this) == 2 /* AviaPageState.Group */)
                return;
            if (key) {
                if (__classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f")) {
                    __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").dispose();
                    __classPrivateFieldSet(this, _AviaPageMobile_groupPage, undefined, "f");
                }
                __classPrivateFieldSet(this, _AviaPageMobile_selectedGroupKey, key, "f");
            }
            __classPrivateFieldSet(this, _AviaPageMobile_selectedGroup, __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getGroup).call(this), "f");
            if (!__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f")) {
                __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResultPage).call(this);
                return;
            }
            const items = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this)
                .filter(v => v.fareGroupKey === __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f").fareGroupKey);
            if (!items)
                return;
            items.forEach(v => { var _b; v.selected = (v.key === ((_b = __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f")) === null || _b === void 0 ? void 0 : _b.key)); });
            // items = AviaGroupPageMobile.calcPriceDelta(items, this.selectedGroup);
            if (__classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f")) {
                // обновляем только тарифы
                yield __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").updateFares(items);
                __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideSearchPage).call(this);
            }
            else {
                const data = {
                    canSwitchFare: (items.length > 1),
                    selectedGroup: __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f"),
                    items,
                };
                const content = $(__classPrivateFieldGet(this, _AviaPageMobile_groupTemplate, "f").call(this, data));
                yield App.CurrencyManager.convertAll(content);
                /*
                $.each(content.find('.js-avia-variants-wrap'), (i, v) => {
                    AviaGroupPageMobile.legSort($(v), undefined, 'departure');
                });
                */
                __classPrivateFieldSet(this, _AviaPageMobile_groupPage, new App.AviaGroupPageMobile({
                    content,
                    urls: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls,
                    items,
                }), "f");
                if (onChangeFare != true) {
                    __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").root
                        .off("avia:changeFare" /* Events.AviaChangeFare */)
                        .on("avia:changeFare" /* Events.AviaChangeFare */, (e, fare) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onChangeGroupFare).call(this, e, fare); }));
                    __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").root
                        .off("avia:book" /* Events.AviaBook */)
                        .on("avia:book" /* Events.AviaBook */, (e, group, variant) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onAviaBook).call(this, e, group, variant); }));
                }
                __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showGroupPage).call(this, onChangeFare !== true);
            }
            const url = `${window.location.origin}${App.removeEndChar(__classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").seo.url, '/')}/group-${__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f").key}/`;
            this.updateHistory(url, 2 /* AviaPageState.Group */);
        });
    }, _AviaPageMobile_findVariant = function _AviaPageMobile_findVariant(key) {
        var _b;
        if (!__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f"))
            return;
        const variants = __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f").variants.filter(v => v.key === key);
        if (!variants || variants.length <= 0) {
            __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, undefined, "f");
            return;
        }
        _b = this, [({ set value(_c) { __classPrivateFieldSet(_b, _AviaPageMobile_selectedVariant, _c, "f"); } }).value] = variants;
    }, _AviaPageMobile_gotoBookPage = function _AviaPageMobile_gotoBookPage(variantKey) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaPageMobile_selectedGroup, __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getGroup).call(this), "f");
            if (!__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f")) {
                __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResultPage).call(this);
                return;
            }
            __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_findVariant).call(this, variantKey);
            if (!__classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f")) {
                yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_gotoGroupPage).call(this, undefined);
                return;
            }
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_prepareBookPage).call(this);
        });
    }, _AviaPageMobile_onAviaBook = function _AviaPageMobile_onAviaBook(event, group, variant) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaPageMobile_selectedGroupKey, group.key, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_selectedGroup, group, "f");
            __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, variant, "f");
            yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_prepareBookPage).call(this);
        });
    }, _AviaPageMobile_prepareBookPage = function _AviaPageMobile_prepareBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentPageType).call(this) == 3 /* AviaPageState.Book */)
                return;
            if (!__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f") || !__classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f"))
                return;
            const items = __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentGroups).call(this).filter(v => { var _b, _c; return v.fareGroupKey === ((_c = (_b = __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f")) === null || _b === void 0 ? void 0 : _b.fareGroupKey) !== null && _c !== void 0 ? _c : ''); });
            if (!items)
                return;
            items.forEach(v => { var _b; v.selected = (v.key === ((_b = __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f")) === null || _b === void 0 ? void 0 : _b.key)); });
            const loggedIn = yield App.app.auth.getStatus();
            // если авторизован, то сразу переходим, добавляя в историю страницу группы.
            if (!loggedIn) {
                $(document).trigger("app:loggingin" /* Events.LoggingIn */);
                return;
            }
            const url = `${window.location.origin}${App.removeEndChar(__classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").seo.url.replace('avia/search', 'avia/book'), '/')}/group-${__classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f").key}/variant-${__classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f").key}/`;
            this.updateHistory(url, 3 /* AviaPageState.Book */);
            const bookData = yield $.ajax({
                url: App.app.url.route('/avia/bookdata/'),
                method: 'POST',
                dataType: 'json',
                data: new Array(0),
            });
            const showNetPrice = App.NetPricePresenter.getVisibility();
            const data = Object.assign(Object.assign({ selectedVariant: __classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f"), getFareRulesAction: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.getFareRules, bookAction: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls.book, agentCountryGenitiveName: __classPrivateFieldGet(this, _AviaPageMobile_searchResponse, "f").agentCountryGenitiveName, allowBooking: bookData.data.allowBooking }, __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f")), { pricePresenter: {
                    type: __classPrivateFieldGet(this, _AviaPageMobile_pricePresenter, "f").type,
                    show: showNetPrice,
                }, canSwitchFare: (items.length > 1), items });
            // extra data
            if (data.passengers) {
                data.passengers.forEach(p => {
                    p.needMiddleNameCode = p.needMiddleName ? 'Required' : 'None';
                    p.existingPassengerData = App.ExistingPassengersMobile.ViewModelByExistingPassengers(p.existingPassengers);
                    p.findTouristData = App.FindTouristMobile.ViewModel({ minLength: 4 });
                });
            }
            // console.log('prepareBookPage -->', data);
            const content = $(__classPrivateFieldGet(this, _AviaPageMobile_bookTemplate, "f").call(this, data));
            yield App.CurrencyManager.convertAll(content);
            App.NetPricePresenter.setVisibility(content, showNetPrice);
            __classPrivateFieldSet(this, _AviaPageMobile_bookPage, new App.AviaBookPageMobile({
                group: __classPrivateFieldGet(this, _AviaPageMobile_selectedGroup, "f"),
                variant: __classPrivateFieldGet(this, _AviaPageMobile_selectedVariant, "f"),
                allowBooking: bookData.data.allowBooking,
                content,
                urls: __classPrivateFieldGet(this, _AviaPageMobile_options, "f").urls,
                items,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _AviaPageMobile_pricePresenter, "f").type,
                    show: showNetPrice,
                },
            }), "f");
            yield __classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f").refreshDigestData(data);
            __classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f").root
                .off("avia:changeVariantFare" /* Events.AviaVariantFareChange */)
                .on("avia:changeVariantFare" /* Events.AviaVariantFareChange */, (e, group, variant) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_onChangeVariantFare).call(this, e, group, variant); }));
            __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showBookPage).call(this);
        });
    }, _AviaPageMobile_onHistoryPopState = function _AviaPageMobile_onHistoryPopState() {
        if (!window.history.state)
            return;
        const state = window.history.state;
        const prevPage = __classPrivateFieldGet(this, _AviaPageMobile_pageState, "f");
        __classPrivateFieldSet(this, _AviaPageMobile_pageState, state.state, "f");
        __classPrivateFieldGet(this, _AviaPageMobile_historyStates, "f")[__classPrivateFieldGet(this, _AviaPageMobile_pageState, "f")].handler();
        // обнуляем предыдущие страницы, чтобы по время поиска не было повторного на них перехода
        if (state.state == 1 /* AviaPageState.Results */ && prevPage == 2 /* AviaPageState.Group */) {
            if (__classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f")) {
                __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").dispose();
                __classPrivateFieldSet(this, _AviaPageMobile_groupPage, undefined, "f");
            }
            __classPrivateFieldSet(this, _AviaPageMobile_selectedGroupKey, undefined, "f");
        }
        if (state.state == 2 /* AviaPageState.Group */ && prevPage == 3 /* AviaPageState.Book */) {
            if (__classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f") != null) {
                __classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f").dispose();
                __classPrivateFieldSet(this, _AviaPageMobile_bookPage, undefined, "f");
            }
            __classPrivateFieldSet(this, _AviaPageMobile_selectedVariant, undefined, "f");
        }
    }, _AviaPageMobile_hideSearchPage = function _AviaPageMobile_hideSearchPage() {
        __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").hide();
        __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").root.hide();
    }, _AviaPageMobile_showSearchPage = function _AviaPageMobile_showSearchPage() {
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideGroupPage).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideBookPage).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").root.show();
        __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").hide();
        const filterRootOffset = __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").root.offset();
        $('html, body').animate({ scrollTop: (filterRootOffset != null ? filterRootOffset.top : 0) }, this.renderSpeed);
    }, _AviaPageMobile_showResultPage = function _AviaPageMobile_showResultPage() {
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_showResultPageCase).call(this, true);
    }, _AviaPageMobile_showResultPageCase = function _AviaPageMobile_showResultPageCase(firstGroup) {
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_setCurrentPageType).call(this, 1 /* AviaPageState.Results */);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideGroupPage).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideBookPage).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_filter, "f").root.show();
        if (__classPrivateFieldGet(this, _AviaPageMobile_searchType, "f") === AviaSearchType.Date) {
            __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").show();
            if (firstGroup) {
                const subfilterContainerOffset = __classPrivateFieldGet(this, _AviaPageMobile_hotFilterContainer, "f").offset();
                $('html, body').animate({ scrollTop: (subfilterContainerOffset != null ? subfilterContainerOffset.top : 0) }, this.renderSpeed);
            }
        }
        else {
            __classPrivateFieldGet(this, _AviaPageMobile_resultBlock, "f").show();
        }
    }, _AviaPageMobile_hideGroupPage = function _AviaPageMobile_hideGroupPage() {
        if (__classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f")) {
            __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").hide();
        }
    }, _AviaPageMobile_showGroupPage = function _AviaPageMobile_showGroupPage(animate = false) {
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_setCurrentPageType).call(this, 2 /* AviaPageState.Group */);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideSearchPage).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideBookPage).call(this);
        if (__classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f"))
            __classPrivateFieldGet(this, _AviaPageMobile_groupPage, "f").show('');
        if (animate) {
            const rootOffset = this.root.offset();
            $('html, body').animate({ scrollTop: (rootOffset != null ? rootOffset.top : 0) }, this.renderSpeed);
        }
    }, _AviaPageMobile_hideBookPage = function _AviaPageMobile_hideBookPage() {
        if (__classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f")) {
            __classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f").hide();
        }
    }, _AviaPageMobile_showBookPage = function _AviaPageMobile_showBookPage() {
        if (__classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_getCurrentPageType).call(this) == 3 /* AviaPageState.Book */)
            return;
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_setCurrentPageType).call(this, 3 /* AviaPageState.Book */);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideSearchPage).call(this);
        __classPrivateFieldGet(this, _AviaPageMobile_instances, "m", _AviaPageMobile_hideGroupPage).call(this);
        if (__classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f")) {
            __classPrivateFieldGet(this, _AviaPageMobile_bookPage, "f").show(this.renderSpeed);
            const rootOffset = this.root.offset();
            $('html, body').animate({ scrollTop: (rootOffset != null ? rootOffset.top : 0) }, this.renderSpeed);
        }
    };
    _AviaPageMobile_partialSearchFirstInterval = { value: 5000 };
    _AviaPageMobile_partialSearchInterval = { value: 2000 };
    _AviaPageMobile_partialLastSearchInterval = { value: 1000 };
    _AviaPageMobile_defaultPageSize = { value: void 0 };
    App.AviaPageMobile = AviaPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Названия параметров урла для авиа
     */
    class AviaUrlParameters {
        constructor() {
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    AviaUrlParameters.route,
                ]
            });
        }
    }
    Object.defineProperty(AviaUrlParameters, "type", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'type'
    });
    Object.defineProperty(AviaUrlParameters, "by", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'by'
    });
    Object.defineProperty(AviaUrlParameters, "route", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'route'
    });
    Object.defineProperty(AviaUrlParameters, "class", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'class'
    });
    Object.defineProperty(AviaUrlParameters, "direct", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'direct'
    });
    Object.defineProperty(AviaUrlParameters, "manualSearch", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'manual'
    });
    App.AviaUrlParameters = AviaUrlParameters;
})(App || (App = {}));
/// <reference path='AviaFormBase.ts' />
var App;
(function (App) {
    var _PassportPageMobile_instances, _a, _PassportPageMobile_options, _PassportPageMobile_digest, _PassportPageMobile_filters, _PassportPageMobile_submitExecuting, _PassportPageMobile_skipButton, _PassportPageMobile_agentBlackListComponent, _PassportPageMobile_initDigest, _PassportPageMobile_refreshDigestData, _PassportPageMobile_onDigestSend, _PassportPageMobile_onBookFilterChanged, _PassportPageMobile_getPersonContainer, _PassportPageMobile_getFilterValueString, _PassportPageMobile_initTouristDocumentProperties, _PassportPageMobile_onChangeTouristCitizenship, _PassportPageMobile_onChangeTouristDocumentType, _PassportPageMobile_tuneTouristDocumentPropertiesForAvia, _PassportPageMobile_tuneTouristDocumentProperties, _PassportPageMobile_setDocumentNumberMask, _PassportPageMobile_getDocumentNumberMask, _PassportPageMobile_tuneTouristDocumentExpirationDate, _PassportPageMobile_setMinExpirationDate, _PassportPageMobile_onIssuingCountryChange, _PassportPageMobile_skipFillPassport, _PassportPageMobile_book, _PassportPageMobile_onContinueAviaBooking;
    class PassportPageMobile extends App.AviaFormBaseMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-passport-page', mainForm: '.js-passport-form' }, options));
            _PassportPageMobile_instances.add(this);
            _PassportPageMobile_options.set(this, void 0);
            _PassportPageMobile_digest.set(this, void 0);
            _PassportPageMobile_filters.set(this, void 0);
            _PassportPageMobile_submitExecuting.set(this, void 0);
            // #selectBlocks: JQuery;
            // #documentTypeSelectBlocks: JQuery;
            // #citizenshipSelectBlocks: JQuery;
            // #issuingCountrySelectBlocks: JQuery;
            // #aviaAirlineBlock: JQuery;
            // #airlineCurrent: string;
            // #airlineCurrentCode: string;
            _PassportPageMobile_skipButton.set(this, void 0);
            _PassportPageMobile_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _PassportPageMobile_options, options, "f");
            __classPrivateFieldSet(this, _PassportPageMobile_submitExecuting, false, "f");
            // this.#selectBlocks = $('.js-form-select-block', this.root);
            this.root.find('.js-passport-person').each((_, v) => __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_initTouristDocumentProperties).call(this, $(v)));
            __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_initDigest).call(this);
            __classPrivateFieldSet(this, _PassportPageMobile_filters, new App.FilterMobile({
                root: this.root,
                onFilterChanged: v => __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_onBookFilterChanged).call(this, v),
                ignoreValidator: false,
            }), "f");
            this.setMainFitlers(__classPrivateFieldGet(this, _PassportPageMobile_filters, "f"));
            // airlines maps
            const filterAirlines = __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").filters.filterControls(undefined, '.CardAirlineCode');
            if (filterAirlines) {
                filterAirlines.forEach(f => {
                    App.AviaMainFilterMobile.mapAirlinesResponseModel(f);
                });
            }
            // ???
            __classPrivateFieldSet(this, _PassportPageMobile_skipButton, $('.js-skip-button', this.root), "f");
            __classPrivateFieldGet(this, _PassportPageMobile_skipButton, "f").on('click', () => __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_skipFillPassport).call(this));
            /*
            this.#documentTypeSelectBlocks = this.#selectBlocks.filter('.js-person-document-type');
            this.#documentTypeSelectBlocks.on('change', '.js-jelect', e => this.#onChangeTouristDocumentType(e));

            this.#citizenshipSelectBlocks = this.#selectBlocks.filter('.js-person-citizenship');
            this.#citizenshipSelectBlocks.on('change', '.js-jelect', e => this.#onChangeTouristCitizenship(e));

            this.#issuingCountrySelectBlocks = this.#selectBlocks.filter('.js-person-document-issuecountry');
            this.#issuingCountrySelectBlocks.on('change', '.js-jelect', e => this.#onIssuingCountryChange(e));
            */
            // чтобы установать правила валидации нужно сначала привязать валидатор к форме:
            // $('.js-passport-form', this.root).validate();
            __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").validate();
            // запускаем событие, чтобы установить валидаторы и отфильтровать типы документов по стране.
            /*
            $.each($('input', this.#citizenshipSelectBlocks),
                (index, item) => {
                    $(item).trigger('change');
                });
            */
            const filterCitizenships = __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").filters.filterControls(undefined, '.Citizenship');
            if (filterCitizenships) {
                filterCitizenships.forEach(f => {
                    const personContainer = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getPersonContainer).call(this, f.name);
                    __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_onChangeTouristCitizenship).call(this, personContainer);
                });
            }
            if (!__classPrivateFieldGet(this, _PassportPageMobile_options, "f").quickBooking && App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _PassportPageMobile_agentBlackListComponent, new App.AgentBlackListComponent({ useForm: true }), "f");
                this.components.push(__classPrivateFieldGet(this, _PassportPageMobile_agentBlackListComponent, "f"));
            }
        }
        /**
         * Уничтожение объекта.
         * Отвязка своих контролов от прослушки/посылки событий.
         */
        dispose() {
            if (__classPrivateFieldGet(this, _PassportPageMobile_filters, "f"))
                __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").dispose();
        }
        static getSelectItemFilterValueString(filterName, defaultValue = '') {
            const item = PwStore.GetFilterItem(filterName);
            if (item)
                return item.value;
            return defaultValue;
        }
        static tuneTouristDocumentPropertiesForTour(personContainer, isDomestic, filters, skipDocTypeTuning = false) {
            // TODO: протестировать ??
            // const citizenshipKey = $('.js-person-citizenship .js-jelect-input', personContainer).valNumber();
            const personIndex = personContainer.attr('data-index');
            const citizenshipKey = parseInt(_a.getSelectItemFilterValueString('Form.Passengers[' + personIndex + '].Citizenship', '0'), 10);
            let eCitizenship;
            if (citizenshipKey === 460)
                eCitizenship = App.Citizenship.russian;
            else if (citizenshipKey === 5)
                eCitizenship = App.Citizenship.ukrainian;
            else
                eCitizenship = App.Citizenship.undefined;
            __classPrivateFieldGet(_a, _a, "m", _PassportPageMobile_tuneTouristDocumentProperties).call(_a, $(personContainer), isDomestic, eCitizenship, skipDocTypeTuning, filters);
        }
        sendForm() {
            return __awaiter(this, void 0, void 0, function* () {
                if (__classPrivateFieldGet(this, _PassportPageMobile_submitExecuting, "f"))
                    return;
                if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _PassportPageMobile_agentBlackListComponent, "f").checkAgree()) {
                    $(document)
                        .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                        .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_book).call(this); }));
                }
                else {
                    yield __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_book).call(this);
                }
            });
        }
    }
    _a = PassportPageMobile, _PassportPageMobile_options = new WeakMap(), _PassportPageMobile_digest = new WeakMap(), _PassportPageMobile_filters = new WeakMap(), _PassportPageMobile_submitExecuting = new WeakMap(), _PassportPageMobile_skipButton = new WeakMap(), _PassportPageMobile_agentBlackListComponent = new WeakMap(), _PassportPageMobile_instances = new WeakSet(), _PassportPageMobile_initDigest = function _PassportPageMobile_initDigest() {
        // TODO: сначала в разметке подготовить (аналогично, как в AviaBookPageMobile)
        // if ($('.js-digest', this.root).length)
        // this.components.push(new Digest({ container: this.root }));
        const digestDomWrapper = this.root.find('.js-avia-passport-digest-wrapper');
        if (!digestDomWrapper || digestDomWrapper.length <= 0)
            return;
        __classPrivateFieldSet(this, _PassportPageMobile_digest, new App.DigestMobile({
            buttonTitle: 'Забронировать',
            headerTitle: 'Детали',
            onClick: () => __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_onDigestSend).call(this),
            allowBooking: false, // кнопка Забронировать со своей логикой активности на странице (тут не дублируем)
        }), "f");
        __classPrivateFieldGet(this, _PassportPageMobile_digest, "f").empty();
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                yield __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_refreshDigestData).call(this);
            }
            catch (error) {
                console.error('Error in Passport.Digest init', error);
            }
        }))();
    }, _PassportPageMobile_refreshDigestData = function _PassportPageMobile_refreshDigestData() {
        return __awaiter(this, void 0, void 0, function* () {
            /*
            // data
            let dataModel: unknown = {};
            const dataBlock = this.root.find('.js-avia-passport-digest-meta');
            if (dataBlock) {
                const dataVal = dataBlock.val();
                if (dataVal && typeof (dataVal) != 'undefined' && dataVal != '') {
                    dataModel = JSON.parse(dataVal as string);
                }
                dataBlock.remove();
            }
            */
            // content
            const contentDom = '.js-avia-passport-digest-content-dom';
            const contentBlock = this.root.find(contentDom);
            if (contentBlock) {
                const digestContent = contentBlock.clone();
                yield App.CurrencyManager.convertAll(digestContent);
                yield __classPrivateFieldGet(this, _PassportPageMobile_digest, "f").setContent(digestContent);
                __classPrivateFieldGet(this, _PassportPageMobile_digest, "f").getContent().find(contentDom).show();
                contentBlock.remove();
            }
            // floater
            const floaterDom = '.js-avia-passport-digest-floater-dom';
            const floaterBlock = this.root.find(floaterDom);
            if (floaterBlock) {
                const digestContent = floaterBlock.clone();
                yield App.CurrencyManager.convertAll(digestContent);
                __classPrivateFieldGet(this, _PassportPageMobile_digest, "f").setFloater(digestContent);
                __classPrivateFieldGet(this, _PassportPageMobile_digest, "f").getContent().find(floaterDom).show();
                floaterBlock.remove();
            }
        });
    }, _PassportPageMobile_onDigestSend = function _PassportPageMobile_onDigestSend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _PassportPageMobile_digest, "f"))
                __classPrivateFieldGet(this, _PassportPageMobile_digest, "f").close();
            yield this.submitForm();
        });
    }, _PassportPageMobile_onBookFilterChanged = function _PassportPageMobile_onBookFilterChanged(filterName) {
        return __awaiter(this, void 0, void 0, function* () {
            // смена типа документа
            if (filterName.endsWith('.DocumentType')) {
                const personContainer = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getPersonContainer).call(this, filterName);
                __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_onChangeTouristDocumentType).call(this, personContainer);
            }
            // смена гражданства
            if (filterName.endsWith('.Citizenship')) {
                const personContainer = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getPersonContainer).call(this, filterName);
                __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_onChangeTouristCitizenship).call(this, personContainer);
            }
            // смена страны выдачи документа
            if (filterName.endsWith('.IssuingCountry')) {
                const personContainer = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getPersonContainer).call(this, filterName);
                __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_onIssuingCountryChange).call(this, personContainer);
            }
        });
    }, _PassportPageMobile_getPersonContainer = function _PassportPageMobile_getPersonContainer(filterName) {
        if (!__classPrivateFieldGet(this, _PassportPageMobile_filters, "f"))
            return undefined;
        const filter = __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").filters.getControl(filterName);
        if (!filter)
            return undefined;
        return filter.root.closest('.js-form-gender');
    }, _PassportPageMobile_getFilterValueString = function _PassportPageMobile_getFilterValueString(filterName) {
        if (!__classPrivateFieldGet(this, _PassportPageMobile_filters, "f"))
            return '';
        const filter = __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").filters.getControl(filterName);
        if (!filter)
            return '';
        return filter.getControlValueString();
    }, _PassportPageMobile_initTouristDocumentProperties = function _PassportPageMobile_initTouristDocumentProperties(personContainer) {
        if (!personContainer)
            return;
        __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_tuneTouristDocumentPropertiesForAvia).call(this, personContainer, __classPrivateFieldGet(this, _PassportPageMobile_options, "f").isDomestic);
    }, _PassportPageMobile_onChangeTouristCitizenship = function _PassportPageMobile_onChangeTouristCitizenship(personContainer) {
        if (!personContainer)
            return;
        // event.preventDefault();
        // для любого перелета для неграждан РФ и Украины доступен только паспорт.
        // const self = $(event.currentTarget);
        // const personContainer = self.closest('.js-form-gender');
        __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_tuneTouristDocumentPropertiesForAvia).call(this, personContainer, __classPrivateFieldGet(this, _PassportPageMobile_options, "f").isDomestic);
    }, _PassportPageMobile_onChangeTouristDocumentType = function _PassportPageMobile_onChangeTouristDocumentType(personContainer) {
        if (!personContainer)
            return;
        // event.preventDefault();
        // const self = $(event.currentTarget);
        // const personContainer = self.closest('.js-form-gender');
        const personIndex = personContainer.attr('data-index');
        const citizenship = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getFilterValueString).call(this, 'Form.Passengers[' + personIndex + '].Citizenship');
        const docType = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getFilterValueString).call(this, 'Form.Passengers[' + personIndex + '].DocumentType');
        __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_tuneTouristDocumentPropertiesForAvia).call(this, personContainer, __classPrivateFieldGet(this, _PassportPageMobile_options, "f").isDomestic, true);
        __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_setMinExpirationDate).call(this, personContainer, docType, citizenship);
    }, _PassportPageMobile_tuneTouristDocumentPropertiesForAvia = function _PassportPageMobile_tuneTouristDocumentPropertiesForAvia(personContainer, isDomestic, skipDocTypeTuning = false) {
        // const citizenship = $('.js-person-citizenship .js-jelect-input', personContainer).valString();
        // const documentType = $('.js-person-document-type .js-jelect-input', personContainer).valString();
        const personIndex = personContainer.attr('data-index');
        const citizenship = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getFilterValueString).call(this, 'Form.Passengers[' + personIndex + '].Citizenship');
        const documentType = __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_getFilterValueString).call(this, 'Form.Passengers[' + personIndex + '].DocumentType');
        let eCitizenship;
        if (citizenship === 'RU')
            eCitizenship = App.Citizenship.russian;
        else if (citizenship === 'UA')
            eCitizenship = App.Citizenship.ukrainian;
        else
            eCitizenship = App.Citizenship.undefined;
        __classPrivateFieldGet(_a, _a, "m", _PassportPageMobile_tuneTouristDocumentProperties).call(_a, $(personContainer), isDomestic, eCitizenship, skipDocTypeTuning, __classPrivateFieldGet(this, _PassportPageMobile_filters, "f"));
        __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_setMinExpirationDate).call(this, personContainer, documentType, citizenship);
    }, _PassportPageMobile_tuneTouristDocumentProperties = function _PassportPageMobile_tuneTouristDocumentProperties(personContainer, isDomestic, citizenship, skipDocTypeTuning, filters) {
        // const docTypeSelectBlock = $('.js-person-document-type', personContainer);
        // const docTypeSelectJelect = $('.js-jelect', docTypeSelectBlock);
        // const docTypeSelectOptions = docTypeSelectBlock.find('.js-filter-option');
        // let docType: string = $('.js-jelect-input', docTypeSelectBlock).valString();
        const personIndex = personContainer.attr('data-index');
        let docType = _a.getSelectItemFilterValueString('Form.Passengers[' + personIndex + '].Citizenship');
        const docTypeItems = PwStore.GetFilterItems('Form.Passengers[' + personIndex + '].DocumentType', true);
        const docTypeFilter = !filters ? undefined : filters.filters.findControl('Form.Passengers[' + personIndex + '].DocumentType');
        if (!skipDocTypeTuning) {
            if (docTypeFilter != null) {
                if (citizenship === App.Citizenship.russian || citizenship === App.Citizenship.ukrainian) {
                    // если внутри РФ, а также в Армению и Казахстан, то документ любой. в противном случае только загран
                    if (isDomestic) {
                        let hasBirthdayNotification = false;
                        $.each(docTypeItems, (i, item) => {
                            // hasBirthdayNotification = ($(item).attr('data-val') === 'BirthdayNotification');
                            // NOTE: оригинальное условие странное, оно может быть false, если после BirthdayNotification последует иное
                            // тут решаю сделать условие иначе, что если хоть раз встречается BirthdayNotification,
                            // то не сбрасываем флаг
                            if (item.value === 'BirthdayNotification')
                                hasBirthdayNotification = true;
                        });
                        $.each(docTypeItems, (i, item) => {
                            // const val = $(item).attr('data-val') || '';
                            const val = item.value || '';
                            if (hasBirthdayNotification && val === 'Passport') {
                                // docTypeSelectJelect.jelect('disable', val);
                                item.hided = true;
                                item.checked = false;
                            }
                            else {
                                // docTypeSelectJelect.jelect('enable', val);
                                item.hided = false;
                            }
                        });
                        // refresh items
                        docTypeFilter.setFilters(docTypeItems, false, false);
                        if (hasBirthdayNotification) {
                            docType = 'BirthdayNotification';
                            // docTypeSelectJelect.jelect('setValue', docType);
                        }
                        else {
                            docType = 'Passport';
                            // docTypeSelectJelect.jelect('setValue', docType);
                        }
                        // set items
                        docTypeFilter.setValueChecked(docType);
                    }
                    else {
                        $.each(docTypeItems, (i, item) => {
                            // const val = $(item).attr('data-val') || '';
                            const val = item.value || '';
                            if (val !== 'ForeignPassport') {
                                // docTypeSelectJelect.jelect('disable', val);
                                item.hided = true;
                                item.checked = false;
                            }
                            else {
                                // docTypeSelectJelect.jelect('enable', val);
                                item.hided = false;
                            }
                        });
                        // refresh items
                        docTypeFilter.setFilters(docTypeItems, false, false);
                        docType = 'ForeignPassport';
                        // docTypeSelectJelect.jelect('setValue', docType);
                        docTypeFilter.setValueChecked(docType);
                    }
                }
                else {
                    // только паспорт
                    $.each(docTypeItems, (i, item) => {
                        // const val = $(item).attr('data-val') || '';
                        const val = item.value || '';
                        if (val === 'Passport') {
                            // docTypeSelectJelect.jelect('enable', val);
                            item.hided = false;
                        }
                        else {
                            // docTypeSelectJelect.jelect('disable', val);
                            item.hided = true;
                            item.checked = false;
                        }
                    });
                    // refresh items
                    docTypeFilter.setFilters(docTypeItems, false, false);
                    docType = 'Passport';
                    // docTypeSelectJelect.jelect('setValue', docType);
                    docTypeFilter.setValueChecked(docType);
                }
            }
        }
        else {
            __classPrivateFieldGet(_a, _a, "m", _PassportPageMobile_setDocumentNumberMask).call(_a, personContainer, citizenship, filters);
            __classPrivateFieldGet(_a, _a, "m", _PassportPageMobile_tuneTouristDocumentExpirationDate).call(_a, personContainer, docType, citizenship, filters);
        }
    }, _PassportPageMobile_setDocumentNumberMask = function _PassportPageMobile_setDocumentNumberMask(personContainer, citizenship, filters) {
        // const documentTypeBlock = $('.js-person-document-type', personContainer);
        // const documentType = $('.js-jelect-input', documentTypeBlock).valString();
        // const documentInput = $('.js-person-document-number .js-form-item-field', personContainer);
        const personIndex = personContainer.attr('data-index');
        const documentType = _a.getSelectItemFilterValueString('Form.Passengers[' + personIndex + '].Citizenship');
        const mask = __classPrivateFieldGet(_a, _a, "m", _PassportPageMobile_getDocumentNumberMask).call(_a, documentType, citizenship);
        // documentTypeBlock.val(mask.type); //? это зачем?
        const docNumberFilter = !filters ? undefined : filters.filters.findControl('Form.Passengers[' + personIndex + '].DocumentNumber');
        if (docNumberFilter) {
            const documentInput = (docNumberFilter).getInputRef();
            documentInput.inputmask(mask.inputmask);
        }
    }, _PassportPageMobile_getDocumentNumberMask = function _PassportPageMobile_getDocumentNumberMask(documentType, citizenship) {
        // TODO Titov: перенести в ConfigController.Settings.
        const defaultMask = { type: 'Passport', inputmask: { mask: '*{6,18}', autoUnmask: true, greedy: false } };
        if (citizenship === App.Citizenship.undefined)
            return defaultMask;
        if (citizenship === App.Citizenship.russian) {
            if (documentType == 'ForeignPassport') {
                return {
                    type: 'ForeignPassport',
                    inputmask: {
                        mask: '99-9999999',
                        autoUnmask: true,
                    },
                };
            }
            if (documentType == 'Passport') {
                return {
                    type: 'Passport',
                    inputmask: {
                        mask: '9999-999999',
                        autoUnmask: true,
                    },
                };
            }
        }
        else if (citizenship === App.Citizenship.ukrainian) {
            if (documentType != null && documentType != 'BirthdayNotification') {
                return {
                    type: documentType,
                    inputmask: {
                        regex: '[a-zA-Z]{2}-[0-9]{6}',
                        mask: '',
                        autoUnmask: true,
                    },
                };
            }
        }
        if (documentType == 'BirthdayNotification') {
            return {
                type: 'BirthdayNotification',
                inputmask: {
                    regex: '[ivxlcdm]{1,4}[а-я]{2}[0-9]{6}|[IVXLCDM]{1,4}[А-Я]{2}[0-9]{6}',
                    // Note: обязательно, т.к. при изменение типа документа маска с предыдущего состояния не изменяется. undefined не
                    // работает.
                    mask: '',
                    autoUnmask: true,
                    greedy: false,
                },
            };
        }
        return defaultMask;
    }, _PassportPageMobile_tuneTouristDocumentExpirationDate = function _PassportPageMobile_tuneTouristDocumentExpirationDate(personContainer, docType, citizenship, filters) {
        const expiredDateBlock = $('.js-person-document-expirationdate', personContainer);
        // const expiredDateInput = $('input', expiredDateBlock);
        const personIndex = personContainer.attr('data-index');
        const expiredDateFilter = !filters ? undefined : filters.filters.findControl('Form.Passengers[' + personIndex + '].DocumentValidThrough');
        if ((citizenship === App.Citizenship.russian || citizenship === App.Citizenship.ukrainian) && (docType === 'Passport' || docType === 'BirthdayNotification')) {
            expiredDateBlock.hide();
            // expiredDateInput.val(personContainer.attr('data-passport-expired') || '');
            if (expiredDateFilter)
                expiredDateFilter.setValueByStr(personContainer.attr('data-passport-expired') || '', 'shortDate', true); // need test
        }
        else {
            expiredDateBlock.show();
            // expiredDateInput.val(personContainer.attr('data-document-expired') || '');
            if (expiredDateFilter)
                expiredDateFilter.setValueByStr(personContainer.attr('data-document-expired') || '', 'shortDate', true); // need test
        }
    }, _PassportPageMobile_setMinExpirationDate = function _PassportPageMobile_setMinExpirationDate(personContainer, citizenship, docType) {
        if (docType === 'ForeignPassport') {
            const pairs = __classPrivateFieldGet(this, _PassportPageMobile_options, "f").arrivalsInfo.split(',');
            // const expiredDateBlock = $('.js-person-document-expirationdate', personContainer);
            // const expiredDateInput = $('input', expiredDateBlock);
            const personIndex = personContainer.attr('data-index');
            const expiredDateFilter = !__classPrivateFieldGet(this, _PassportPageMobile_filters, "f") ? undefined : __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").filters.findControl('Form.Passengers[' + personIndex + '].DocumentValidThrough');
            $.each(pairs, (index, item) => {
                const pair = item.split(':');
                if (pair[0] !== citizenship) {
                    const dateParts = pair[1].split('.');
                    const minDate = new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0], 10));
                    // expiredDateInput.datepicker('option', 'minDate', minDate);
                    if (expiredDateFilter)
                        expiredDateFilter.setMinDate(minDate, 0, true); // need test
                }
            });
        }
    }, _PassportPageMobile_onIssuingCountryChange = function _PassportPageMobile_onIssuingCountryChange(personContainer) {
        if (!personContainer)
            return;
        // event.preventDefault();
        // НОВЫЕ ВВОДНЫЕ:
        // Если страна выдачи НЕ Росиия, то показывать все типы документов - с 20230127 для граждан НЕ РФ и Украины показываем
        // только ПАСПОРТ.
        // Если страна выдачи Россия, то
        // - для внутренних перелетов показывать все типы
        // - для международных перелетов скрывать внурт.паспорт
        // const self = $(event.currentTarget);
        // const passenger = self.closest('.js-form-gender');
        __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_tuneTouristDocumentPropertiesForAvia).call(this, personContainer, __classPrivateFieldGet(this, _PassportPageMobile_options, "f").isDomestic);
    }, _PassportPageMobile_skipFillPassport = function _PassportPageMobile_skipFillPassport() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mainForm || !__classPrivateFieldGet(this, _PassportPageMobile_filters, "f"))
                return;
            const response = yield _a.doAction(__classPrivateFieldGet(this, _PassportPageMobile_options, "f").urls.skipFillPassport, __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").filters.serialize(), // this.mainForm.serialize(),
            () => App.modalShow(this.getInfoBlock('.js-passport-skip-message-block')));
            if (!response || !response.status.success) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                return;
            }
            if (response.redirect)
                window.location.href = response.redirect;
            if (response.data && response.data.dialog)
                App.modalShow($(App.templates.RelatedServiceDialog(response.data.dialog)));
        });
    }, _PassportPageMobile_book = function _PassportPageMobile_book() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mainForm || !__classPrivateFieldGet(this, _PassportPageMobile_filters, "f"))
                return;
            __classPrivateFieldSet(this, _PassportPageMobile_submitExecuting, true, "f");
            const response = yield _a.doAction(this.mainForm.attr('data-action') || '', __classPrivateFieldGet(this, _PassportPageMobile_filters, "f").filters.serialize(), // this.mainForm.serialize(),
            () => App.modalShow(this.getInfoBlock(__classPrivateFieldGet(this, _PassportPageMobile_options, "f").quickBooking ? '.js-passport-message-block' : '.js-booking-message-block')));
            __classPrivateFieldSet(this, _PassportPageMobile_submitExecuting, false, "f");
            let message = 'При передаче паспортных данных произошла ошибка. Попробуйте еще раз через некоторое время.';
            if (!response) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, message));
                return;
            }
            if (!response.status.success) {
                if (response.status.messages)
                    message = response.status.messages[0].text;
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, message), 'Ошибка');
                return;
            }
            if (response.data) {
                if (response.data.doubleBooking) {
                    const infoBlock = this.getInfoBlock('.js-the-same-booking-message-block');
                    if (response.data.message)
                        infoBlock.text(response.data.message);
                    App.popupShow(infoBlock, 'Ошибка');
                    return;
                }
                if (response.data.priceHasChanged) {
                    const dialog = $(App.templates.Avia.Messages.SearchPriceChanged(response.data));
                    dialog.on('click', '.js-cancel-avia-booking', () => App.popupHide());
                    dialog.on('click', '.js-continue-avia-booking', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PassportPageMobile_instances, "m", _PassportPageMobile_onContinueAviaBooking).call(this, e); }));
                    App.popupShow(dialog, 'Внимание!');
                    yield App.CurrencyManager.convertAll(dialog);
                    return;
                }
            }
            if (response.redirect)
                window.location.href = response.redirect;
            if (response.data && response.data.dialog)
                App.modalShow($(App.templates.RelatedServiceDialog(response.data.dialog)));
        });
    }, _PassportPageMobile_onContinueAviaBooking = function _PassportPageMobile_onContinueAviaBooking(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: так нельзя, т.к. записывается значение с точкой, а с ней биндинг не принимает значение как число.
            // const newPrice = $(event.currentTarget).attr('data-newprice');
            const parent = $(event.currentTarget).closest('.js-newprice-dialog');
            const newPrice = $('.js-newprice', parent).valString();
            if (newPrice) {
                // записываем новую цену для передачи на сервис.
                // $('.js-avia-newbookingprice', this.root).val(newPrice);
                PwStore.ChangeFilter('Form.NewBookingPrice', newPrice, true);
                yield this.sendForm();
            }
        });
    };
    App.PassportPageMobile = PassportPageMobile;
})(App || (App = {}));
/// <reference path='AviaFormBase.ts' />
var App;
(function (App) {
    var _PassportPage_instances, _a, _PassportPage_options, _PassportPage_submitExecuting, _PassportPage_selectBlocks, _PassportPage_documentTypeSelectBlocks, _PassportPage_citizenshipSelectBlocks, _PassportPage_issuingCountrySelectBlocks, _PassportPage_aviaAirlineBlock, _PassportPage_airlineCurrent, _PassportPage_airlineCurrentCode, _PassportPage_skipButton, _PassportPage_agentBlackListComponent, _PassportPage_initTouristDocumentProperties, _PassportPage_onChangeTouristCitizenship, _PassportPage_onChangeTouristDocumentType, _PassportPage_tuneTouristDocumentPropertiesForAvia, _PassportPage_tuneTouristDocumentProperties, _PassportPage_setDocumentIssueDateValidationForAvia, _PassportPage_setDocumentNumberMask, _PassportPage_getDocumentNumberMask, _PassportPage_tuneTouristDocumentExpirationDate, _PassportPage_setMinExpirationDate, _PassportPage_onIssuingCountryChange, _PassportPage_skipFillPassport, _PassportPage_book, _PassportPage_onContinueAviaBooking;
    let Citizenship;
    (function (Citizenship) {
        Citizenship[Citizenship["russian"] = 0] = "russian";
        Citizenship[Citizenship["ukrainian"] = 1] = "ukrainian";
        Citizenship[Citizenship["undefined"] = 2] = "undefined";
    })(Citizenship = App.Citizenship || (App.Citizenship = {}));
    let DocumentType;
    (function (DocumentType) {
        DocumentType[DocumentType["BirthdayNotification"] = 0] = "BirthdayNotification";
        DocumentType[DocumentType["Passport"] = 1] = "Passport";
        DocumentType[DocumentType["ForeignPassport"] = 2] = "ForeignPassport";
    })(DocumentType = App.DocumentType || (App.DocumentType = {}));
    class PassportPage extends App.AviaFormBase {
        constructor(options) {
            super(Object.assign({ root: '.js-passport-page', mainForm: '.js-passport-form' }, options));
            _PassportPage_instances.add(this);
            _PassportPage_options.set(this, void 0);
            _PassportPage_submitExecuting.set(this, void 0);
            _PassportPage_selectBlocks.set(this, void 0);
            _PassportPage_documentTypeSelectBlocks.set(this, void 0);
            _PassportPage_citizenshipSelectBlocks.set(this, void 0);
            _PassportPage_issuingCountrySelectBlocks.set(this, void 0);
            _PassportPage_aviaAirlineBlock.set(this, void 0);
            _PassportPage_airlineCurrent.set(this, void 0);
            _PassportPage_airlineCurrentCode.set(this, void 0);
            _PassportPage_skipButton.set(this, void 0);
            _PassportPage_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _PassportPage_options, options, "f");
            __classPrivateFieldSet(this, _PassportPage_submitExecuting, false, "f");
            __classPrivateFieldSet(this, _PassportPage_selectBlocks, $('.js-form-select-block', this.root), "f");
            this.root.find('.js-passport-person').each((_, v) => __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_initTouristDocumentProperties).call(this, $(v)));
            if ($('.js-digest', this.root).length)
                this.components.push(new App.Digest({ container: this.root }));
            __classPrivateFieldSet(this, _PassportPage_skipButton, $('.js-skip-button', this.root), "f");
            __classPrivateFieldGet(this, _PassportPage_skipButton, "f").on('click', () => __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_skipFillPassport).call(this));
            __classPrivateFieldSet(this, _PassportPage_documentTypeSelectBlocks, __classPrivateFieldGet(this, _PassportPage_selectBlocks, "f").filter('.js-person-document-type'), "f");
            __classPrivateFieldGet(this, _PassportPage_documentTypeSelectBlocks, "f").on('change', '.js-jelect', e => __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_onChangeTouristDocumentType).call(this, e));
            __classPrivateFieldSet(this, _PassportPage_citizenshipSelectBlocks, __classPrivateFieldGet(this, _PassportPage_selectBlocks, "f").filter('.js-person-citizenship'), "f");
            __classPrivateFieldGet(this, _PassportPage_citizenshipSelectBlocks, "f").on('change', '.js-jelect', e => __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_onChangeTouristCitizenship).call(this, e));
            __classPrivateFieldSet(this, _PassportPage_issuingCountrySelectBlocks, __classPrivateFieldGet(this, _PassportPage_selectBlocks, "f").filter('.js-person-document-issuecountry'), "f");
            __classPrivateFieldGet(this, _PassportPage_issuingCountrySelectBlocks, "f").on('change', '.js-jelect', e => __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_onIssuingCountryChange).call(this, e));
            // Инпуты авиакомпаний
            __classPrivateFieldSet(this, _PassportPage_aviaAirlineBlock, $('.js-airline-block', this.root), "f");
            __classPrivateFieldGet(this, _PassportPage_aviaAirlineBlock, "f").each((index, el) => {
                const airlineBlock = $(el);
                const airlineInput = airlineBlock.find('.js-airline-input');
                const airlineInputCode = airlineBlock.find('.js-airline-code');
                const airlinePlaceholder = airlineBlock.find('.js-airline-placeholder');
                const airlineAutocomplete = airlineBlock.find('.js-airline-autocomplete');
                const airlineResults = airlineBlock.find('.js-airline-results');
                const passengerBlock = airlineBlock.closest('.js-form-passenger-block');
                const airlineDefaultText = 'Введите название';
                let otherAirline;
                airlineBlock.attr('id', `airline-block-${index}`);
                __classPrivateFieldSet(this, _PassportPage_airlineCurrent, airlineDefaultText, "f");
                __classPrivateFieldSet(this, _PassportPage_airlineCurrentCode, '', "f");
                $('html').on('click', e => {
                    if (!$(e.target).closest(`#airline-block-${index}`).length) {
                        if (airlineAutocomplete.is(':visible')) {
                            airlineAutocomplete.hide();
                            airlinePlaceholder.html('');
                            airlineInput.val(__classPrivateFieldGet(this, _PassportPage_airlineCurrent, "f"));
                            airlineInputCode.val(__classPrivateFieldGet(this, _PassportPage_airlineCurrentCode, "f"));
                        }
                    }
                });
                // Функция инициализирует виджет autocomplete для поисковой строки
                const scrollerWrap = $('.js-scroller-wrap', airlineBlock);
                const scroll = scrollerWrap.baron({
                    scroller: '.js-scroller',
                    track: '.js-scroller-bar-wrap',
                    bar: '.js-scroller-bar',
                    barOnCls: 'baron',
                });
                $.widget('app.autocomplete', $.ui.autocomplete, {
                    // Формируем вывод результатов поиска в выпадающем меню
                    _renderItem(ul, item) {
                        const re = new RegExp(`(${this.term})`, 'gi');
                        const template = '<span class="ui-state-highlight">$1</span>';
                        const label = item.label.replace(re, template);
                        const li = $('<li class="ui-menu-item">').appendTo(ul);
                        otherAirline = passengerBlock.find('.js-airline-input').valString();
                        li
                            .attr('data-value', item.value)
                            .attr('data-code', item.key)
                            .html(label);
                        if (item.value === otherAirline)
                            li.hide();
                        return li;
                    },
                });
                if (this.mainForm) {
                    const mainForm = this.mainForm;
                    airlineInput.autocomplete({
                        minLength: App.app.settings.minSearchTermLength,
                        source: (request, response) => {
                            /* eslint-disable @typescript-eslint/no-floating-promises */
                            $.ajax({
                                url: mainForm.attr('data-airlines'),
                                method: 'GET',
                                data: {
                                    'search': request.term,
                                },
                                success: (data) => {
                                    response(data.data.map(v => ({ key: v[0], label: `${v[0]} ${v[1]}` })));
                                },
                            });
                            /* eslint-enable @typescript-eslint/no-floating-promises */
                        },
                        appendTo: airlineResults,
                        // Добавляем подсказку ввода внутрь инпута
                        response: (_, ui) => {
                            const result = ui.content[0];
                            const searchValue = airlineInput.valString();
                            otherAirline = passengerBlock.find('.js-airline-input').valString();
                            let hint;
                            if (result !== undefined) {
                                airlineAutocomplete.show();
                                scroll.update();
                                if (result.label !== otherAirline)
                                    hint = result.label;
                                else
                                    hint = '';
                            }
                            else {
                                hint = '';
                            }
                            const hintBegin = hint.substring(0, searchValue.length);
                            if (hintBegin.toUpperCase() === searchValue.toUpperCase())
                                airlinePlaceholder.html(`<span>${searchValue}</span>${hint.substring(searchValue.length)}`);
                            else
                                airlinePlaceholder.html('');
                        },
                        // Убираем подсказку из инпута, при выборе результата
                        select: (_, ui) => {
                            var _b;
                            const input = airlineInput;
                            const value = (_b = ui.item.value) !== null && _b !== void 0 ? _b : '';
                            const selectedWrap = airlineAutocomplete.find('.js-airline-selected');
                            const selected = airlineAutocomplete.find('.js-airline-selected-item');
                            const isSelected = selected.filter(`[data-value="${value}"]`).length;
                            // Выставляем текст в инпуте
                            if (!isSelected) {
                                const inputValue = input.valString();
                                if (inputValue.toUpperCase() === value.toUpperCase())
                                    input.val(value);
                                else
                                    input.val(`${inputValue},${value}`);
                                const li = $(`<div class='airline-dropdown__selected-item js-airline-selected-item' data-value='${value}'><i class='js-airline-selected-delete'></i><span>${value}</span></div>`);
                                li.appendTo(selectedWrap);
                                selectedWrap.show();
                                airlinePlaceholder.html('');
                            }
                            airlineAutocomplete.hide();
                        },
                        // Убираем подсказку из инпута, при выборе результата
                        focus: (_, ui) => {
                            const result = ui.item.label;
                            const searchValue = airlineInput.valString();
                            let hint;
                            if (result != null)
                                hint = result;
                            else
                                hint = '';
                            if (hint.toUpperCase() === searchValue.toUpperCase())
                                airlinePlaceholder.html(hint);
                            else
                                airlinePlaceholder.html('');
                        },
                    });
                }
                // выбор авиакомпании из выпадающего списка
                airlineBlock.on('click', '.ui-menu-item', event => {
                    const self = $(event.currentTarget);
                    const value = self.attr('data-value') || '';
                    const code = self.attr('data-code') || '';
                    event.preventDefault();
                    // Выставляем текст в инпуте
                    airlineInput.val(value);
                    airlineInputCode.val(code);
                    __classPrivateFieldSet(this, _PassportPage_airlineCurrent, airlineInput.valString(), "f");
                    __classPrivateFieldSet(this, _PassportPage_airlineCurrentCode, airlineInputCode.valString(), "f");
                    airlinePlaceholder.html('');
                    airlineAutocomplete.hide();
                    airlineInput.trigger('blur');
                });
                airlineInput.on('focus', () => {
                    const selected = airlineAutocomplete.find('.js-airline-selected-item');
                    airlineResults.find('ul').html('');
                    __classPrivateFieldSet(this, _PassportPage_airlineCurrent, airlineInput.valString(), "f");
                    __classPrivateFieldSet(this, _PassportPage_airlineCurrentCode, airlineInputCode.valString(), "f");
                    airlineInput.val('');
                    if (selected.length)
                        airlineAutocomplete.show();
                });
                // Отслеживаем изменение значения поля
                airlineInput.on('change', () => {
                    const selected = airlineAutocomplete.find('.js-airline-selected-item');
                    if (!selected.length) {
                        airlineInput.val(airlineDefaultText);
                        airlineInputCode.val('');
                    }
                    if (airlineInput.val() === '')
                        airlinePlaceholder.html('');
                });
                // Отслеживаем снятие фокуса с поля
                airlineInput.on('blur', () => {
                    airlinePlaceholder.html('');
                    if (airlineInput.val() === '' || airlineInput.val() !== __classPrivateFieldGet(this, _PassportPage_airlineCurrent, "f")) {
                        airlineInput.val(__classPrivateFieldGet(this, _PassportPage_airlineCurrent, "f"));
                        airlineInputCode.val(__classPrivateFieldGet(this, _PassportPage_airlineCurrentCode, "f"));
                    }
                });
            });
            // чтобы установать правила валидации нужно сначала привязать валидатор к форме:
            $('.js-passport-form', this.root).validate();
            // запускаем событие, чтобы установить валидаторы и отфильтровать типы документов по стране.
            $.each($('input', __classPrivateFieldGet(this, _PassportPage_citizenshipSelectBlocks, "f")), (index, item) => {
                $(item).trigger('change');
            });
            if (!__classPrivateFieldGet(this, _PassportPage_options, "f").quickBooking && App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _PassportPage_agentBlackListComponent, new App.AgentBlackListComponent({ useForm: true }), "f");
                this.components.push(__classPrivateFieldGet(this, _PassportPage_agentBlackListComponent, "f"));
            }
            $(document).on("win:resizeEnd" /* Events.WinResizeEnd */, () => {
                $('.js-form-date').datepicker('refresh');
            });
        }
        static tuneTouristDocumentPropertiesForTour(personContainer, touristType, isDomestic, skipDocTypeTuning = false) {
            const citizenshipKey = $('.js-person-citizenship .js-jelect-input', personContainer).valNumber();
            let eCitizenship;
            if (citizenshipKey === 460)
                eCitizenship = Citizenship.russian;
            else if (citizenshipKey === 5)
                eCitizenship = Citizenship.ukrainian;
            else
                eCitizenship = Citizenship.undefined;
            __classPrivateFieldGet(_a, _a, "m", _PassportPage_tuneTouristDocumentProperties).call(_a, $(personContainer), touristType, isDomestic, eCitizenship, skipDocTypeTuning);
            _a.setDocumentIssueDateValidationForTour($(personContainer));
        }
        static setDocumentIssueDateValidationForTour(personContainer) {
            const birthdayVal = $('.js-person-birthday', personContainer).valString();
            if (birthdayVal == '')
                return;
            const birthday = App.parseDate(birthdayVal, 'dd.MM.yyyy');
            const documentType = $('.js-person-document-type', personContainer).valString();
            const citizenship = $('.js-person-citizenship .js-jelect-input', personContainer).valString();
            const targetInput = $('.js-person-document-issuedate input', personContainer);
            _a.setDocumentIssueDateValidation(birthday, documentType, citizenship, targetInput);
        }
        /** Ограничение дат выдачи документа:
         * - для внутреннего паспорта РФ - не ранее возраста пассажира 14 лет;
         * - для свидетельства о рождении - не ранее даты рождения пассажира;
         * - для загранпаспорта РФ – не ранее 10 лет от текущей даты, но не ранее даты рождения пассажира;
         * - для всех остальных – не ранее даты рождения пассажира.
         * @param birthday
         * @param documentType
         * @param citizenship
         * @param targetInput
         */
        static setDocumentIssueDateValidation(birthday, documentType, citizenship, targetInput) {
            let minDate;
            const maxDate = new Date();
            if (['RU', '460', 'Russia'].includes(citizenship)) {
                switch (documentType) {
                    case DocumentType[DocumentType.Passport]: {
                        minDate = new Date(birthday.getFullYear() + 14, birthday.getMonth(), birthday.getDate());
                        if (App.getAge(birthday) < 14)
                            minDate = new Date(birthday);
                        break;
                    }
                    case DocumentType[DocumentType.ForeignPassport]: {
                        minDate = new Date(maxDate.getFullYear() - 10, maxDate.getMonth(), maxDate.getDate());
                        if (birthday > minDate)
                            minDate = new Date(birthday);
                        break;
                    }
                    case DocumentType[DocumentType.BirthdayNotification]: {
                        minDate = new Date(birthday);
                        break;
                    }
                    default: {
                        minDate = new Date(birthday);
                        break;
                    }
                }
            }
            else {
                minDate = new Date(birthday);
            }
            if (minDate) {
                targetInput.rules('remove', 'datemin datemax');
                targetInput.rules('add', {
                    datemin: App.formatDate(minDate, 'isoDate'),
                    datemax: App.formatDate(maxDate, 'isoDate'),
                    normalizer(value) {
                        return App.formatDate($.datepicker.parseDate($(this).datepicker('option', 'dateFormat'), value), 'isoDate');
                    },
                });
                targetInput.datepicker('option', 'minDate', minDate);
                targetInput.datepicker('option', 'maxDate', maxDate);
                if (targetInput.valString() != '')
                    targetInput.trigger('focusout');
            }
        }
        sendForm() {
            return __awaiter(this, void 0, void 0, function* () {
                if (__classPrivateFieldGet(this, _PassportPage_submitExecuting, "f"))
                    return;
                if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _PassportPage_agentBlackListComponent, "f").checkAgree()) {
                    $(document)
                        .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                        .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_book).call(this); }));
                }
                else {
                    yield __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_book).call(this);
                }
            });
        }
    }
    _a = PassportPage, _PassportPage_options = new WeakMap(), _PassportPage_submitExecuting = new WeakMap(), _PassportPage_selectBlocks = new WeakMap(), _PassportPage_documentTypeSelectBlocks = new WeakMap(), _PassportPage_citizenshipSelectBlocks = new WeakMap(), _PassportPage_issuingCountrySelectBlocks = new WeakMap(), _PassportPage_aviaAirlineBlock = new WeakMap(), _PassportPage_airlineCurrent = new WeakMap(), _PassportPage_airlineCurrentCode = new WeakMap(), _PassportPage_skipButton = new WeakMap(), _PassportPage_agentBlackListComponent = new WeakMap(), _PassportPage_instances = new WeakSet(), _PassportPage_initTouristDocumentProperties = function _PassportPage_initTouristDocumentProperties(personContainer) {
        __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_tuneTouristDocumentPropertiesForAvia).call(this, personContainer, __classPrivateFieldGet(this, _PassportPage_options, "f").isDomestic);
    }, _PassportPage_onChangeTouristCitizenship = function _PassportPage_onChangeTouristCitizenship(event) {
        event.preventDefault();
        // для любого перелета для неграждан РФ и Украины доступен только паспорт.
        const self = $(event.currentTarget);
        const personContainer = self.closest('.js-passport-person');
        __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_tuneTouristDocumentPropertiesForAvia).call(this, personContainer, __classPrivateFieldGet(this, _PassportPage_options, "f").isDomestic);
    }, _PassportPage_onChangeTouristDocumentType = function _PassportPage_onChangeTouristDocumentType(event) {
        event.preventDefault();
        const self = $(event.currentTarget);
        const personContainer = self.closest('.js-passport-person');
        const citizenship = $('.js-person-citizenship', personContainer).find('.js-jelect-input').valString();
        const docType = self.valString();
        __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_tuneTouristDocumentPropertiesForAvia).call(this, personContainer, __classPrivateFieldGet(this, _PassportPage_options, "f").isDomestic, true);
        __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_setMinExpirationDate).call(this, personContainer, citizenship, docType);
    }, _PassportPage_tuneTouristDocumentPropertiesForAvia = function _PassportPage_tuneTouristDocumentPropertiesForAvia(personContainer, isDomestic, skipDocTypeTuning = false) {
        const citizenship = $('.js-person-citizenship .js-jelect-input', personContainer).valString();
        const documentType = $('.js-person-document-type .js-jelect-input', personContainer).valString();
        let eCitizenship;
        if (citizenship === 'RU')
            eCitizenship = Citizenship.russian;
        else if (citizenship === 'UA')
            eCitizenship = Citizenship.ukrainian;
        else
            eCitizenship = Citizenship.undefined;
        const index = $('[name="Form.Passengers.Index"]', personContainer).valNumber();
        const touristType = $(`[name="Form.Passengers[${index}].PassengerType"]`, personContainer).valString();
        __classPrivateFieldGet(_a, _a, "m", _PassportPage_tuneTouristDocumentProperties).call(_a, $(personContainer), touristType, isDomestic, eCitizenship, skipDocTypeTuning);
        __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_setDocumentIssueDateValidationForAvia).call(this, $(personContainer), index);
        // TODO: добавить для туров
        __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_setMinExpirationDate).call(this, personContainer, citizenship, documentType);
    }, _PassportPage_tuneTouristDocumentProperties = function _PassportPage_tuneTouristDocumentProperties(personContainer, touristType, isDomestic, citizenship, skipDocTypeTuning) {
        const docTypeSelectBlock = $('.js-person-document-type', personContainer);
        const docTypeSelectJelect = $('.js-jelect', docTypeSelectBlock);
        const docTypeSelectOptions = docTypeSelectBlock.find('.js-filter-option');
        let docType = $('.js-jelect-input', docTypeSelectBlock).valString();
        if (!skipDocTypeTuning) {
            if (citizenship === Citizenship.russian || citizenship === Citizenship.ukrainian) {
                // если по РФ и в страны CIS (passportCountries && birthdayNotificationCountries). Иначе, только загран.
                if (isDomestic) { // isDomestic && isCis
                    const isAdult = touristType.toLowerCase() === 'adult';
                    $.each(docTypeSelectOptions, (i, item) => {
                        const val = $(item).attr('data-val') || '';
                        if (!isAdult && val === DocumentType[DocumentType.Passport]) {
                            docTypeSelectJelect.jelect('disable', val);
                        }
                        else {
                            docTypeSelectJelect.jelect('enable', val);
                            docType = DocumentType[DocumentType.Passport];
                            docTypeSelectJelect.jelect('setValue', docType);
                        }
                    });
                    let hasBirthdayNotification = false;
                    $.each(docTypeSelectOptions, (i, item) => {
                        hasBirthdayNotification = ($(item).attr('data-val') === DocumentType[DocumentType.BirthdayNotification]);
                    });
                    if (hasBirthdayNotification)
                        docType = DocumentType[DocumentType.BirthdayNotification];
                    else
                        docType = DocumentType[DocumentType.Passport];
                    docTypeSelectJelect.jelect('setValue', docType);
                }
                else {
                    $.each(docTypeSelectOptions, (i, item) => {
                        const val = $(item).attr('data-val') || '';
                        if (val !== DocumentType[DocumentType.ForeignPassport]) {
                            docTypeSelectJelect.jelect('disable', val);
                        }
                        else {
                            docTypeSelectJelect.jelect('enable', val);
                        }
                    });
                    docType = DocumentType[DocumentType.ForeignPassport];
                    docTypeSelectJelect.jelect('setValue', docType);
                }
            }
            else {
                // только паспорт
                $.each(docTypeSelectOptions, (i, item) => {
                    const val = $(item).attr('data-val') || '';
                    if (val === DocumentType[DocumentType.Passport]) {
                        docTypeSelectJelect.jelect('enable', val);
                    }
                    else {
                        docTypeSelectJelect.jelect('disable', val);
                    }
                });
                docType = DocumentType[DocumentType.Passport];
                docTypeSelectJelect.jelect('setValue', docType);
            }
        }
        else {
            __classPrivateFieldGet(_a, _a, "m", _PassportPage_setDocumentNumberMask).call(_a, personContainer, citizenship);
            __classPrivateFieldGet(_a, _a, "m", _PassportPage_tuneTouristDocumentExpirationDate).call(_a, personContainer, docType, citizenship);
        }
    }, _PassportPage_setDocumentIssueDateValidationForAvia = function _PassportPage_setDocumentIssueDateValidationForAvia(personContainer, index) {
        const birthday = App.parseDate($(`[name="Form.Passengers[${index}].Birthday"]`, personContainer).valString(), 'dd.MM.yyyy HH:mm:ss');
        const documentType = $('.js-person-document-type', personContainer).valString();
        const citizenship = $('.js-person-citizenship .js-jelect-input', personContainer).valString();
        const targetInput = $('.js-person-document-issuedate input', personContainer);
        _a.setDocumentIssueDateValidation(birthday, documentType, citizenship, targetInput);
    }, _PassportPage_setDocumentNumberMask = function _PassportPage_setDocumentNumberMask(personContainer, citizenship) {
        const documentTypeBlock = $('.js-person-document-type', personContainer);
        const documentType = $('.js-jelect-input', documentTypeBlock).valString();
        const documentInput = $('.js-person-document-number .js-form-item-field', personContainer);
        const mask = __classPrivateFieldGet(_a, _a, "m", _PassportPage_getDocumentNumberMask).call(_a, documentType, citizenship);
        documentTypeBlock.val(mask.type);
        documentInput.inputmask(mask.inputmask);
    }, _PassportPage_getDocumentNumberMask = function _PassportPage_getDocumentNumberMask(documentType, citizenship) {
        // TODO Titov: перенести в ConfigController.Settings.
        const defaultMask = { type: DocumentType[DocumentType.Passport], inputmask: { mask: '*{6,18}', autoUnmask: true, greedy: false } };
        if (citizenship === Citizenship.undefined)
            return defaultMask;
        if (citizenship === Citizenship.russian) {
            if (documentType == DocumentType[DocumentType.ForeignPassport]) {
                return {
                    type: DocumentType[DocumentType.ForeignPassport],
                    inputmask: {
                        mask: '99-9999999',
                        autoUnmask: true,
                    },
                };
            }
            if (documentType == DocumentType[DocumentType.Passport]) {
                return {
                    type: DocumentType[DocumentType.Passport],
                    inputmask: {
                        mask: '9999-999999',
                        autoUnmask: true,
                    },
                };
            }
        }
        else if (citizenship === Citizenship.ukrainian) {
            if (documentType != null && documentType != DocumentType[DocumentType.BirthdayNotification]) {
                return {
                    type: documentType,
                    inputmask: {
                        regex: '[a-zA-Z]{2}-[0-9]{6}',
                        mask: '',
                        autoUnmask: true,
                    },
                };
            }
        }
        if (documentType == DocumentType[DocumentType.BirthdayNotification]) {
            return {
                type: DocumentType[DocumentType.BirthdayNotification],
                inputmask: {
                    regex: '[ivxlcdm]{1,4}[а-я]{2}[0-9]{6}|[IVXLCDM]{1,4}[А-Я]{2}[0-9]{6}',
                    // Note: обязательно, т.к. при изменение типа документа маска с предыдущего состояния не изменяется. undefined не
                    // работает.
                    mask: '',
                    autoUnmask: true,
                    greedy: false,
                },
            };
        }
        return defaultMask;
    }, _PassportPage_tuneTouristDocumentExpirationDate = function _PassportPage_tuneTouristDocumentExpirationDate(personContainer, docType, citizenship) {
        const expiredDateBlock = $('.js-person-document-expirationdate', personContainer);
        const expiredDateInput = $('input', expiredDateBlock);
        if ((citizenship === Citizenship.russian || citizenship === Citizenship.ukrainian)
            && (docType === DocumentType[DocumentType.Passport] || docType === DocumentType[DocumentType.BirthdayNotification])) {
            expiredDateBlock.hide();
            expiredDateInput.val(expiredDateInput.attr('data-passport-expired') || '');
        }
        else {
            expiredDateBlock.show();
            expiredDateInput.val(expiredDateInput.attr('data-document-expired') || '');
        }
    }, _PassportPage_setMinExpirationDate = function _PassportPage_setMinExpirationDate(personContainer, citizenship, docType) {
        if (docType === DocumentType[DocumentType.ForeignPassport]) {
            const pairs = __classPrivateFieldGet(this, _PassportPage_options, "f").arrivalsInfo.split(',');
            const expiredDateBlock = $('.js-person-document-expirationdate', personContainer);
            const expiredDateInput = $('input', expiredDateBlock);
            $.each(pairs, (index, item) => {
                const pair = item.split(':');
                if (pair[0] !== citizenship) {
                    const dateParts = pair[1].split('.');
                    const minDate = new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0], 10));
                    expiredDateInput.datepicker('option', 'minDate', minDate);
                }
            });
        }
    }, _PassportPage_onIssuingCountryChange = function _PassportPage_onIssuingCountryChange(event) {
        event.preventDefault();
        // НОВЫЕ ВВОДНЫЕ:
        // Если страна выдачи НЕ Росиия, то показывать все типы документов - с 20230127 для граждан НЕ РФ и Украины показываем
        // только ПАСПОРТ.
        // Если страна выдачи Россия, то
        // - для внутренних перелетов показывать все типы
        // - для международных перелетов скрывать внурт.паспорт
        const self = $(event.currentTarget);
        const passenger = self.closest('.js-passport-person');
        __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_tuneTouristDocumentPropertiesForAvia).call(this, passenger, __classPrivateFieldGet(this, _PassportPage_options, "f").isDomestic);
    }, _PassportPage_skipFillPassport = function _PassportPage_skipFillPassport() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mainForm)
                return;
            const response = yield App.AviaFormBase.doAction(__classPrivateFieldGet(this, _PassportPage_options, "f").urls.skipFillPassport, this.mainForm.serialize(), () => App.modalShow(this.getInfoBlock('.js-passport-skip-message-block')));
            if (!response || !response.status.success) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                return;
            }
            if (response.redirect)
                window.location.href = response.redirect;
            if (response.data && response.data.dialog)
                App.modalShow($(App.templates.RelatedServiceDialog(response.data.dialog)));
        });
    }, _PassportPage_book = function _PassportPage_book() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mainForm)
                return;
            __classPrivateFieldSet(this, _PassportPage_submitExecuting, true, "f");
            const response = yield App.AviaFormBase.doAction(this.mainForm.attr('data-action') || '', this.mainForm.serialize(), () => App.modalShow(this.getInfoBlock(__classPrivateFieldGet(this, _PassportPage_options, "f").quickBooking ? '.js-passport-message-block' : '.js-booking-message-block')));
            __classPrivateFieldSet(this, _PassportPage_submitExecuting, false, "f");
            let message = 'При передаче паспортных данных произошла ошибка. Попробуйте еще раз через некоторое время.';
            if (!response) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, message));
                return;
            }
            if (!response.status.success) {
                if (response.status.messages)
                    message = response.status.messages[0].text;
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, message), 'Ошибка');
                return;
            }
            if (response.data) {
                if (response.data.doubleBooking) {
                    const infoBlock = this.getInfoBlock('.js-the-same-booking-message-block');
                    if (response.data.message)
                        infoBlock.text(response.data.message);
                    App.popupShow(infoBlock, 'Ошибка');
                    return;
                }
                if (response.data.priceHasChanged) {
                    const dialog = $(App.templates.Avia.Messages.SearchPriceChanged(response.data));
                    dialog.on('click', '.js-cancel-avia-booking', () => App.popupHide());
                    dialog.on('click', '.js-continue-avia-booking', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PassportPage_instances, "m", _PassportPage_onContinueAviaBooking).call(this, e); }));
                    App.popupShow(dialog, 'Внимание!');
                    return;
                }
            }
            if (response.redirect)
                window.location.href = response.redirect;
            if (response.data && response.data.dialog)
                App.modalShow($(App.templates.RelatedServiceDialog(response.data.dialog)));
        });
    }, _PassportPage_onContinueAviaBooking = function _PassportPage_onContinueAviaBooking(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: так нельзя, т.к. записывается значение с точкой, а с ней биндинг не принимает значение как число.
            // const newPrice = $(event.currentTarget).attr('data-newprice');
            const parent = $(event.currentTarget).closest('.js-newprice-dialog');
            const newPrice = $('.js-newprice', parent).valString();
            if (newPrice) {
                // записываем новую цену для передачи на сервис.
                $('.js-avia-newbookingprice', this.root).val(newPrice);
                yield this.sendForm();
            }
        });
    };
    App.PassportPage = PassportPage;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _VisaPage_visaTypeSwitcher, _VisaPage_changeVisaType;
    class VisaPage extends App.AviaFormBase {
        constructor(options) {
            super(Object.assign({ root: '.js-avia-visa-page', mainForm: '.js-avia-visa-form' }, options));
            _VisaPage_visaTypeSwitcher.set(this, void 0);
            __classPrivateFieldSet(this, _VisaPage_visaTypeSwitcher, $('.js-tab', this.root), "f");
            __classPrivateFieldGet(this, _VisaPage_visaTypeSwitcher, "f").on('click', e => __classPrivateFieldGet(_a, _a, "m", _VisaPage_changeVisaType).call(_a, e));
            __classPrivateFieldGet(this, _VisaPage_visaTypeSwitcher, "f").filter('[data-tab="true"]').trigger('click');
        }
        clear() {
            super.clear();
        }
        sendForm() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.mainForm)
                    return;
                const response = yield $.ajax({
                    url: this.mainForm.attr('data-action'),
                    method: this.mainForm.attr('data-method'),
                    dataType: 'json',
                    data: this.mainForm.serialize(),
                    beforeSend: () => {
                        App.modalShow(this.getInfoBlock('.js-visa-submit-message-block'));
                    },
                });
                if (response) {
                    if (response.status.success) {
                        if (response.redirect)
                            window.location.href = response.redirect;
                    }
                    else if (response.status.messages && response.status.messages.length > 0) {
                        App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]), 'Ошибка бронирования');
                    }
                }
                else {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'При передаче паспортных данных произошла ошибка. Обратитесь к администратору.'), 'Ошибка бронирования');
                }
            });
        }
    }
    _a = VisaPage, _VisaPage_visaTypeSwitcher = new WeakMap(), _VisaPage_changeVisaType = function _VisaPage_changeVisaType(event) {
        const self = $(event.currentTarget);
        const isActive = self.hasClass('_active');
        const data = self.attr('data-tab');
        if (!data)
            return;
        const container = self.closest('.js-visa-container');
        const visaTypeBlock = $('.js-visa-type[data-visa-type="true"]', container);
        const woVisaTypeBlock = $('.js-visa-type[data-visa-type="false"]', container);
        if (!isActive) {
            self.siblings('.js-tab').removeClass('_active');
            self.addClass('_active');
            visaTypeBlock.toggle(data);
            $('input', visaTypeBlock).prop('disabled', !data);
            woVisaTypeBlock.toggle(!data);
            $('input', woVisaTypeBlock).prop('disabled', data);
            $('.js-has-visa', container).val(data);
        }
    };
    App.VisaPage = VisaPage;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaBrandFareComponent_instances, _AviaBrandFareComponent_options, _AviaBrandFareComponent_executing, _AviaBrandFareComponent_execute;
    class AviaBrandFareComponent {
        constructor(options) {
            _AviaBrandFareComponent_instances.add(this);
            _AviaBrandFareComponent_options.set(this, void 0);
            _AviaBrandFareComponent_executing.set(this, false);
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _AviaBrandFareComponent_options, Object.assign(defaults, options), "f");
            $('.js-brand-name', __classPrivateFieldGet(this, _AviaBrandFareComponent_options, "f").root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaBrandFareComponent_instances, "m", _AviaBrandFareComponent_execute).call(this, e); }));
        }
    }
    _AviaBrandFareComponent_options = new WeakMap(), _AviaBrandFareComponent_executing = new WeakMap(), _AviaBrandFareComponent_instances = new WeakSet(), _AviaBrandFareComponent_execute = function _AviaBrandFareComponent_execute(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            e.preventDefault();
            e.stopPropagation();
            if (__classPrivateFieldGet(this, _AviaBrandFareComponent_executing, "f"))
                return;
            __classPrivateFieldSet(this, _AviaBrandFareComponent_executing, true, "f");
            const target = $(e.currentTarget);
            const title = `Тариф ${(_a = target.attr('data-brand-name')) !== null && _a !== void 0 ? _a : ''}<br/><small>а/к ${(_b = target.attr('data-carrier-name')) !== null && _b !== void 0 ? _b : ''}</small>`;
            __classPrivateFieldGet(this, _AviaBrandFareComponent_options, "f").popup.show({
                group: 'main',
                title,
                content: App.templates.Avia.Messages.BrandLoading({}),
            });
            const xhr = $.ajax({
                url: '/avia/getbrandfarerules/',
                method: 'POST',
                data: {
                    'carrier': target.attr('data-carrier-code'),
                    'programSystemCode': target.attr('data-program-system-code'),
                    'programCode': target.attr('data-program-code'),
                    'brand': target.attr('data-brand-id'),
                },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AviaBrandFareComponent_options, "f").responseValidator.process(response))
                    return;
                __classPrivateFieldGet(this, _AviaBrandFareComponent_options, "f").popup.show({
                    group: 'main',
                    title,
                    content: App.templates.Avia.Messages.Brand({
                        rules: response.data.rules,
                        url: response.data.url,
                        isUrlContent: response.data.isUrlContent,
                    }),
                });
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AviaBrandFareComponent_options, "f").responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _AviaBrandFareComponent_executing, false, "f");
            }
        });
    };
    App.AviaBrandFareComponent = AviaBrandFareComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaFareGroupComponentMobile_instances, _a, _AviaFareGroupComponentMobile_options, _AviaFareGroupComponentMobile_items, _AviaFareGroupComponentMobile_selectedItem, _AviaFareGroupComponentMobile_popup, _AviaFareGroupComponentMobile_responseValidator, _AviaFareGroupComponentMobile_onGroupFareSelect, _AviaFareGroupComponentMobile_renderItemsModal, _AviaFareGroupComponentMobile_render, _AviaFareGroupComponentMobile_onBrandFareClick, _AviaFareGroupComponentMobile_calcPriceDelta, _AviaFareGroupComponentMobile_segmentFormat;
    class AviaFareGroupComponentMobile {
        constructor(options) {
            _AviaFareGroupComponentMobile_instances.add(this);
            _AviaFareGroupComponentMobile_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AviaFareGroupComponentMobile_items.set(this, void 0);
            _AviaFareGroupComponentMobile_selectedItem.set(this, void 0);
            _AviaFareGroupComponentMobile_popup.set(this, void 0);
            _AviaFareGroupComponentMobile_responseValidator.set(this, void 0);
            Object.defineProperty(this, "components", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_options, options, "f");
            this.root = $('.js-avia-fare-group-block', __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_options, "f").root);
            __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_items, __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_options, "f").items, "f");
            __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_selectedItem, __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f").find(v => v.selected) || __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f")[0], "f");
            // console.log('--- AviaFareGroupComponentMobile ctor ---');
            __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaFareGroupComponentMobile_popup, "f")),
                /* TODO
                validator: this.#form.validator,
                allowEmptyData: true,
                */
            }), "f");
            // отображаем список Тарифов
            $(this.root).on('click', '.js-groupfare-change-btn', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_instances, "m", _AviaFareGroupComponentMobile_onGroupFareSelect).call(this); }));
            // $(this.root).on('click', '.js-brand-fare-header:not(._selected)', async e => await this.#onBrandFareClick(e));
            // $(this.root).on('click', '.js-brand-fare-header', async e => await this.#onGroupFareSelect());
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_instances, "m", _AviaFareGroupComponentMobile_render).call(this); }))();
        }
        /**
         * Уничтожение объекта.
         * Отвязка своих контролов от прослушки/посылки событий.
         */
        dispose() {
            // nop
        }
        update(items) {
            return __awaiter(this, void 0, void 0, function* () {
                if (items.length <= __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f").length)
                    return;
                __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_items, items, "f");
                yield __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_instances, "m", _AviaFareGroupComponentMobile_render).call(this);
            });
        }
        defineCurrentFareFlight(source) {
            if (!source)
                return undefined;
            const currentRoute = Enumerable.from(source.legs)
                .selectMany(v => v.segments)
                .select(v => __classPrivateFieldGet(_a, _a, "m", _AviaFareGroupComponentMobile_segmentFormat).call(_a, v))
                .toJoinedString(',');
            const variant = Enumerable.from(Enumerable.from(__classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f"))
                .first(v => v.selected).variants)
                .firstOrDefault(v => Enumerable.from(v.legs)
                .selectMany(x => x.segments)
                .select(x => __classPrivateFieldGet(_a, _a, "m", _AviaFareGroupComponentMobile_segmentFormat).call(_a, x)).toJoinedString(',') === currentRoute);
            return variant;
        }
    }
    _a = AviaFareGroupComponentMobile, _AviaFareGroupComponentMobile_options = new WeakMap(), _AviaFareGroupComponentMobile_items = new WeakMap(), _AviaFareGroupComponentMobile_selectedItem = new WeakMap(), _AviaFareGroupComponentMobile_popup = new WeakMap(), _AviaFareGroupComponentMobile_responseValidator = new WeakMap(), _AviaFareGroupComponentMobile_instances = new WeakSet(), _AviaFareGroupComponentMobile_onGroupFareSelect = function _AviaFareGroupComponentMobile_onGroupFareSelect() {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('onGroupFareSelect -->');
            const modalMeta = {
                key: 'groupFareModal',
                title: 'Тариф',
                applyTitle: 'Применить',
                variant: 'sidebar-left',
                getContent: () => { return 'загрузка..'; },
                onRender: ($placer) => __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_instances, "m", _AviaFareGroupComponentMobile_renderItemsModal).call(this, $placer, true),
                onApplyClick: () => { this.root.trigger('submit'); return false; },
            };
            PwStore.OpenModal('custom-content-modal', modalMeta);
        });
    }, _AviaFareGroupComponentMobile_renderItemsModal = function _AviaFareGroupComponentMobile_renderItemsModal($placer, withEvents) {
        return __awaiter(this, void 0, void 0, function* () {
            // content
            const $content = $(App.templates.Avia.GroupFaresItems_Mobile({
                selectedGroup: __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_selectedItem, "f"),
                items: __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f"),
            }));
            $placer.html('');
            $placer.append($content.clone(true));
            yield App.CurrencyManager.convertAll($placer);
            // events
            if (withEvents) {
                this.components.push(new App.AviaBrandFareComponent({
                    root: $placer,
                    popup: __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_popup, "f"),
                    responseValidator: __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_responseValidator, "f"),
                }));
                $placer.find('.js-brand-fare-header').off('click');
                $placer.on('click', '.js-brand-fare-header:not(._selected)', (e) => __awaiter(this, void 0, void 0, function* () {
                    yield __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_instances, "m", _AviaFareGroupComponentMobile_onBrandFareClick).call(this, e);
                    yield __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_instances, "m", _AviaFareGroupComponentMobile_renderItemsModal).call(this, $placer, false);
                    // закрываем окно с выбором тарифа
                    // NOTE: если надо будет не закрывать сразу, то фиксить, чтобы повторно отрабатывал this.#onBrandFareClick
                    PwStore.CloseModal();
                }));
            }
        });
    }, _AviaFareGroupComponentMobile_render = function _AviaFareGroupComponentMobile_render() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_items, __classPrivateFieldGet(_a, _a, "m", _AviaFareGroupComponentMobile_calcPriceDelta).call(_a, __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f"), __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_selectedItem, "f")), "f");
            const content = $(App.templates.Avia.GroupFares_Mobile({
                canSwitchFare: (__classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f").length > 1),
                selectedGroup: __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_selectedItem, "f"),
                items: __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f"),
            }));
            // console.log('render selected -->', this.#selectedItem);
            // console.log('render root -->', this.root);
            this.root
                .empty()
                .append(content);
            yield App.CurrencyManager.convertAll(content);
            // this.#initComponents();
        });
    }, _AviaFareGroupComponentMobile_onBrandFareClick = function _AviaFareGroupComponentMobile_onBrandFareClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const key = target.attr('data-key');
            // console.log('onBrandFareClick -> ' + key);
            if (!key)
                return;
            __classPrivateFieldSet(this, _AviaFareGroupComponentMobile_selectedItem, __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f").find(v => v.key === key) || __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_items, "f")[0], "f");
            yield __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_instances, "m", _AviaFareGroupComponentMobile_render).call(this);
            this.root.trigger("avia:changeFare" /* Events.AviaChangeFare */, __classPrivateFieldGet(this, _AviaFareGroupComponentMobile_selectedItem, "f"));
        });
    }, _AviaFareGroupComponentMobile_calcPriceDelta = function _AviaFareGroupComponentMobile_calcPriceDelta(items, selectedGroup) {
        items.forEach(v => {
            var _b, _c;
            v.selected = (v.key === (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.key));
            v.delta = Math.abs(v.price - ((_b = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.price) !== null && _b !== void 0 ? _b : 0));
            v.deltaSign = (v.price - ((_c = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.price) !== null && _c !== void 0 ? _c : 0) >= 0) ? '+' : '—';
        });
        return items.sort((v1, v2) => (v1.price > v2.price ? 1 : -1));
    }, _AviaFareGroupComponentMobile_segmentFormat = function _AviaFareGroupComponentMobile_segmentFormat(source) {
        return `${source.date}-${source.endDate}-${source.flightNumber}`;
    };
    App.AviaFareGroupComponentMobile = AviaFareGroupComponentMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaFareGroupComponent_instances, _a, _AviaFareGroupComponent_options, _AviaFareGroupComponent_items, _AviaFareGroupComponent_selectedItem, _AviaFareGroupComponent_popup, _AviaFareGroupComponent_responseValidator, _AviaFareGroupComponent_initComponents, _AviaFareGroupComponent_render, _AviaFareGroupComponent_onBrandFareClick, _AviaFareGroupComponent_calcPriceDelta, _AviaFareGroupComponent_segmentFormat;
    class AviaFareGroupComponent {
        constructor(options) {
            _AviaFareGroupComponent_instances.add(this);
            _AviaFareGroupComponent_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AviaFareGroupComponent_items.set(this, void 0);
            _AviaFareGroupComponent_selectedItem.set(this, void 0);
            _AviaFareGroupComponent_popup.set(this, void 0);
            _AviaFareGroupComponent_responseValidator.set(this, void 0);
            Object.defineProperty(this, "components", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            __classPrivateFieldSet(this, _AviaFareGroupComponent_options, options, "f");
            this.root = $('.js-avia-fare-group-block', __classPrivateFieldGet(this, _AviaFareGroupComponent_options, "f").root);
            __classPrivateFieldSet(this, _AviaFareGroupComponent_items, __classPrivateFieldGet(this, _AviaFareGroupComponent_options, "f").items, "f");
            __classPrivateFieldSet(this, _AviaFareGroupComponent_selectedItem, __classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f").find(v => v.selected) || __classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f")[0], "f");
            __classPrivateFieldSet(this, _AviaFareGroupComponent_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _AviaFareGroupComponent_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaFareGroupComponent_popup, "f")),
                /* TODO
                validator: this.#form.validator,
                allowEmptyData: true,
                */
            }), "f");
            $(this.root).on('click', '.js-brand-fare-header:not(._selected)', e => __classPrivateFieldGet(this, _AviaFareGroupComponent_instances, "m", _AviaFareGroupComponent_onBrandFareClick).call(this, e));
            __classPrivateFieldGet(this, _AviaFareGroupComponent_instances, "m", _AviaFareGroupComponent_render).call(this);
        }
        update(items) {
            if (items.length <= __classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f").length)
                return;
            __classPrivateFieldSet(this, _AviaFareGroupComponent_items, items, "f");
            __classPrivateFieldGet(this, _AviaFareGroupComponent_instances, "m", _AviaFareGroupComponent_render).call(this);
        }
        defineCurrentFareFlight(source) {
            if (!source)
                return undefined;
            const currentRoute = Enumerable.from(source.legs)
                .selectMany(v => v.segments)
                .select(v => __classPrivateFieldGet(_a, _a, "m", _AviaFareGroupComponent_segmentFormat).call(_a, v))
                .toJoinedString(',');
            const variant = Enumerable.from(Enumerable.from(__classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f"))
                .first(v => v.selected).variants)
                .firstOrDefault(v => Enumerable.from(v.legs)
                .selectMany(x => x.segments)
                .select(x => __classPrivateFieldGet(_a, _a, "m", _AviaFareGroupComponent_segmentFormat).call(_a, x)).toJoinedString(',') === currentRoute);
            return variant;
        }
    }
    _a = AviaFareGroupComponent, _AviaFareGroupComponent_options = new WeakMap(), _AviaFareGroupComponent_items = new WeakMap(), _AviaFareGroupComponent_selectedItem = new WeakMap(), _AviaFareGroupComponent_popup = new WeakMap(), _AviaFareGroupComponent_responseValidator = new WeakMap(), _AviaFareGroupComponent_instances = new WeakSet(), _AviaFareGroupComponent_initComponents = function _AviaFareGroupComponent_initComponents() {
        this.components.push(new App.AviaBrandFareComponent({
            root: this.root,
            popup: __classPrivateFieldGet(this, _AviaFareGroupComponent_popup, "f"),
            responseValidator: __classPrivateFieldGet(this, _AviaFareGroupComponent_responseValidator, "f"),
        }));
    }, _AviaFareGroupComponent_render = function _AviaFareGroupComponent_render() {
        __classPrivateFieldSet(this, _AviaFareGroupComponent_items, __classPrivateFieldGet(_a, _a, "m", _AviaFareGroupComponent_calcPriceDelta).call(_a, __classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f"), __classPrivateFieldGet(this, _AviaFareGroupComponent_selectedItem, "f")), "f");
        const content = $(App.templates.Avia.GroupFares({
            canSwitchFare: (__classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f").length > 1),
            selectedGroup: __classPrivateFieldGet(this, _AviaFareGroupComponent_selectedItem, "f"),
            items: __classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f"),
        }));
        this.root
            .empty()
            .append(content);
        __classPrivateFieldGet(this, _AviaFareGroupComponent_instances, "m", _AviaFareGroupComponent_initComponents).call(this);
    }, _AviaFareGroupComponent_onBrandFareClick = function _AviaFareGroupComponent_onBrandFareClick(event) {
        const target = $(event.currentTarget);
        const key = target.attr('data-key');
        if (!key)
            return;
        __classPrivateFieldSet(this, _AviaFareGroupComponent_selectedItem, __classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f").find(v => v.key === key) || __classPrivateFieldGet(this, _AviaFareGroupComponent_items, "f")[0], "f");
        __classPrivateFieldGet(this, _AviaFareGroupComponent_instances, "m", _AviaFareGroupComponent_render).call(this);
        this.root.trigger("avia:changeFare" /* Events.AviaChangeFare */, __classPrivateFieldGet(this, _AviaFareGroupComponent_selectedItem, "f"));
    }, _AviaFareGroupComponent_calcPriceDelta = function _AviaFareGroupComponent_calcPriceDelta(items, selectedGroup) {
        items.forEach(v => {
            var _b, _c;
            v.selected = (v.key === (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.key));
            v.delta = Math.abs(v.price - ((_b = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.price) !== null && _b !== void 0 ? _b : 0));
            v.deltaSign = (v.price - ((_c = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.price) !== null && _c !== void 0 ? _c : 0) >= 0) ? '+' : '—';
        });
        return items.sort((v1, v2) => (v1.price > v2.price ? 1 : -1));
    }, _AviaFareGroupComponent_segmentFormat = function _AviaFareGroupComponent_segmentFormat(source) {
        return `${source.date}-${source.endDate}-${source.flightNumber}`;
    };
    App.AviaFareGroupComponent = AviaFareGroupComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaFormMobile_options;
    class AviaFormMobile {
        // public validator: JQueryValidation.Validator;
        constructor(key, options) {
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AviaFormMobile_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.key = key;
            const defaults = {
                root: '.js-tab-noname',
                ignoreValidator: false,
            };
            __classPrivateFieldSet(this, _AviaFormMobile_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _AviaFormMobile_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            // mobile filters
            this.filters = new App.FiltersMobileBase({
                root: this.root,
                ignoreValidator: __classPrivateFieldGet(this, _AviaFormMobile_options, "f").ignoreValidator,
                // TODO: onFilterChanged: v => this.onFilterChanged(v),
            });
            // this.validator = this.filters.validator;
        }
        getValidator() {
            this.filters.validate();
            return this.filters.validator;
        }
        /* async onFilterChanged(filterName: string): Promise<void> {
            // TODO: callback from options
        }*/
        serializeArray(separator = ',') {
            return this.filters.serializeArray(separator);
        }
    }
    _AviaFormMobile_options = new WeakMap();
    App.AviaFormMobile = AviaFormMobile;
})(App || (App = {}));
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
var App;
(function (App) {
    var _AviaHotFilterMobile_instances, _a, _AviaHotFilterMobile_customFilterClass, _AviaHotFilterMobile_filterBodyElement, _AviaHotFilterMobile_groups, _AviaHotFilterMobile_dynamicDepartureDate, _AviaHotFilterMobile_result, _AviaHotFilterMobile_initFilterModal, _AviaHotFilterMobile_setData, _AviaHotFilterMobile_carrierBrandsToMobileList, _AviaHotFilterMobile_getHotFilterCarrierBrands, _AviaHotFilterMobile_getHotFilterChangeAircraftAmount, _AviaHotFilterMobile_getHotFilterChangeAircraftDelays, _AviaHotFilterMobile_getHotFilterBaggage, _AviaHotFilterMobile_getHotFilterDepartureAirports, _AviaHotFilterMobile_getHotFilterArrivalAirports, _AviaHotFilterMobile_getHotFilterBackArrivalAirports, _AviaHotFilterMobile_getHotFilterFlightTypes, _AviaHotFilterMobile_getHotFilterServiceClasses, _AviaHotFilterMobile_getHotFilterAirportWillBeChanged, _AviaHotFilterMobile_getHotFilterAdditionalDiscount, _AviaHotFilterMobile_blockModel, _AviaHotFilterMobile_getBlockValue, _AviaHotFilterMobile_apply, _AviaHotFilterMobile_containsGroup;
    class AviaHotFilterMobile {
        constructor(groups, dynamicDepartureDate) {
            _AviaHotFilterMobile_instances.add(this);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // Фильтр, перемещенный в модалку.
            _AviaHotFilterMobile_filterBodyElement.set(this, null);
            _AviaHotFilterMobile_groups.set(this, void 0);
            _AviaHotFilterMobile_dynamicDepartureDate.set(this, void 0);
            // #selectBlocks: JQuery; // TODO: to del
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AviaHotFilterMobile_result.set(this, void 0);
            this.root = $('.js-avia-hotfilter');
            __classPrivateFieldSet(this, _AviaHotFilterMobile_groups, groups, "f");
            __classPrivateFieldSet(this, _AviaHotFilterMobile_result, groups, "f");
            __classPrivateFieldSet(this, _AviaHotFilterMobile_dynamicDepartureDate, dynamicDepartureDate, "f");
            if (!this.root.length)
                return;
            // this.#selectBlocks = $('.js-avia-select-block', this.root); // TODO: to del !!!!!!!!!!!!!!!
            // Скрываем фильтр на странице и открываем его в модалке "Фильтры" по кнопке
            // (по аналогии с другими сервисами, см. HotFilterMobile).
            __classPrivateFieldGet(this, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_initFilterModal).call(this);
            // mobile filters
            this.filters = new App.FiltersMobileBase({
                root: this.root,
                ignoreValidator: true,
                onFilterChanged: v => this.onFilterChanged(v),
            });
            // this.#init();
        }
        /**
         * Уничтожение объекта.
         * Отвязка своих контролов от прослушки/посылки событий.
         */
        dispose() {
            $(document).off('click.aviaFilterModal', '.js-avia-filter-hot-filter');
            this.filters.dispose();
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                const filter = this.filters.findControl(filterName);
                if (filter) {
                    __classPrivateFieldGet(this, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_apply).call(this, true);
                }
            });
        }
        fire(groups) {
            // this.#init();
            __classPrivateFieldGet(this, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_setData).call(this, groups);
            __classPrivateFieldGet(this, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_apply).call(this, false);
        }
        getResult() {
            return __classPrivateFieldGet(this, _AviaHotFilterMobile_result, "f");
        }
        /*
        static #toggleBrands(invoker: JQuery): void {
            const shown = invoker.attr('data-shown');
            if (shown === '1')
                $(invoker).attr('data-shown', '0');
            else
                $(invoker).attr('data-shown', '1');
            $(invoker).find('.js-brand-block').toggle('slide', 300);
        }
        */
        static getModel(instance, groups, tripType, isDirect) {
            const carriers = __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterCarrierBrands).call(this, instance, groups);
            return {
                tripType: tripType,
                carrierBrands: {
                    options: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_carrierBrandsToMobileList).call(_a, carriers),
                    selected: {
                        value: Enumerable.from(carriers).where(v => v.selected).toJoinedString(',', v => v.value),
                        text: Enumerable.from(carriers).any(v => v.selected)
                            ? Enumerable.from(carriers).where(v => v.selected).toJoinedString(',', v => v.text)
                            : 'Любой',
                    },
                },
                departureRange: { name: 'departureRange', label: 'Время вылета' },
                arrivalRange: { name: 'arrivalRange', label: 'Время прилета' },
                backDepartureRange: { name: 'backDepartureRange', label: 'Время обратного вылета' },
                backArrivalRange: { name: 'backArrivalRange', label: 'Время обратного прилета' },
                changeAircraftAmount: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Количество пересадок', App.HotFilterBlockName.changeAircraftAmount, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterChangeAircraftAmount).call(this, instance, groups, isDirect)),
                changeAircraftDelay: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Длительность пересадок', App.HotFilterBlockName.changeAircraftDelay, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterChangeAircraftDelays).call(this, instance, isDirect)),
                baggageInfo: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Наличие багажа', App.HotFilterBlockName.baggageInfo, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterBaggage).call(this, instance, groups)),
                departureAirports: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Аэропорт отправления', App.HotFilterBlockName.departureAirport, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterDepartureAirports).call(this, instance, groups)),
                arrivalAirports: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Аэропорт прилета', App.HotFilterBlockName.arrivalAirport, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterArrivalAirports).call(this, instance, groups)),
                backArrivalAirports: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Аэропорт обратного прилета', App.HotFilterBlockName.backArrivalAirport, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterBackArrivalAirports).call(this, instance, groups)),
                flightType: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Тип рейса', App.HotFilterBlockName.flightType, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterFlightTypes).call(this, instance, groups)),
                serviceClasses: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Класс обслуживания', App.HotFilterBlockName.serviceClass, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterServiceClasses).call(this, instance, groups)),
                airportWillBeChanged: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Смена аэропорта при пересадке', App.HotFilterBlockName.airportWillBeChanged, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterAirportWillBeChanged).call(this, instance, groups)),
                additionalDiscount: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_blockModel).call(_a, 'Дополнительная скидка', App.HotFilterBlockName.additionalDiscount, __classPrivateFieldGet(this, _a, "m", _AviaHotFilterMobile_getHotFilterAdditionalDiscount).call(this, instance, groups)),
            };
        }
    }
    _a = AviaHotFilterMobile, _AviaHotFilterMobile_filterBodyElement = new WeakMap(), _AviaHotFilterMobile_groups = new WeakMap(), _AviaHotFilterMobile_dynamicDepartureDate = new WeakMap(), _AviaHotFilterMobile_result = new WeakMap(), _AviaHotFilterMobile_instances = new WeakSet(), _AviaHotFilterMobile_initFilterModal = function _AviaHotFilterMobile_initFilterModal() {
        $('.js-filter-body', this.root).hide().addClass(__classPrivateFieldGet(_a, _a, "f", _AviaHotFilterMobile_customFilterClass));
        // Кнопка может находиться вне root (например, в блоке сортировки .js-filter-avia-sort),
        // поэтому обработчик вешаем на document. Класс отдельный (js-avia-filter-hot-filter),
        // чтобы кнопку не перехватывал сортировочный HotFilterMobile.
        $(document)
            .off('click.aviaFilterModal', '.js-avia-filter-hot-filter')
            .on('click.aviaFilterModal', '.js-avia-filter-hot-filter', () => {
            PwStore.OpenModal('custom-content-modal', {
                triggerModalKey: 'filter-modal',
                title: 'Фильтры',
                applyTitle: 'Применить',
                variant: 'sidebar-left',
                color: 'secondary',
                getContent: () => 'загрузка...',
                onRender: ($placer) => {
                    var _b;
                    // Если элемент уже перемещен - используем его, иначе находим и перемещаем (только свой, в пределах своего root)
                    if (!((_b = __classPrivateFieldGet(this, _AviaHotFilterMobile_filterBodyElement, "f")) === null || _b === void 0 ? void 0 : _b.length)) {
                        const $filterBody = $('.js-filter-body', this.root);
                        __classPrivateFieldSet(this, _AviaHotFilterMobile_filterBodyElement, $filterBody.length ? $filterBody.detach() : null, "f");
                    }
                    if (!__classPrivateFieldGet(this, _AviaHotFilterMobile_filterBodyElement, "f"))
                        return;
                    $placer
                        .html('')
                        .append(__classPrivateFieldGet(this, _AviaHotFilterMobile_filterBodyElement, "f").show());
                },
            });
        });
    }, _AviaHotFilterMobile_setData = function _AviaHotFilterMobile_setData(groups) {
        __classPrivateFieldSet(this, _AviaHotFilterMobile_groups, groups, "f");
    }, _AviaHotFilterMobile_carrierBrandsToMobileList = function _AviaHotFilterMobile_carrierBrandsToMobileList(carriers) {
        if (!carriers)
            return [];
        const list = [];
        carriers.forEach(c => {
            // item
            const item = {
                label: c.text,
                name: c.text,
                value: c.value,
                checked: c.selected,
                select_all: (!c.value),
            };
            // brands (children) - only 1 level
            if (c.brands && c.brands.length > 0) {
                item.children = [];
                c.brands.forEach(b => {
                    const child = {
                        label: 'тариф ' + b.brandName,
                        name: 'тариф ' + b.brandName,
                        value: `${item.value}:${b.brandId}`, // NOTE: в дебаг запросах в brandId лежит brandName
                        checked: false,
                    };
                    if (item.children)
                        item.children.push(child);
                });
            }
            // add
            list.push(item);
        });
        return list;
    }, _AviaHotFilterMobile_getHotFilterCarrierBrands = function _AviaHotFilterMobile_getHotFilterCarrierBrands(instance, groups) {
        const values = !instance ? '' : Enumerable.from((__classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.carriers)).split(',')).select(v => v.trim()).toArray();
        const segments = Enumerable.from(groups)
            .selectMany(v => v.variants)
            .selectMany(v => v.legs)
            .selectMany(v => v.segments);
        return Enumerable.from([{
                text: 'Любой',
                value: '',
                selected: values.indexOf('') !== -1,
            }])
            .union(segments
            .distinct(v => v.airlineCode)
            .orderBy(v => v.airlineName)
            .select(v => ({
            text: v.airlineName ? v.airlineName.replace('KIWI', 'Лоукостеры') : '',
            value: v.airlineCode,
            selected: values.indexOf(v.airlineCode) !== -1,
            brands: segments
                .where(s => s.airlineCode === v.airlineCode)
                .selectMany(s => s.brandFares)
                .distinct(x => x.brandId)
                .select(x => ({
                brandId: x.brandId,
                brandName: x.brandName,
                programSystemCode: x.programSystemCode,
                programCode: x.programCode,
                selected: values.indexOf(x.brandId) !== -1,
                airline: {
                    code: x.airline.code,
                    name: x.airline.name,
                },
            }))
                // чтобы не было пустых брендовых тарифов
                .where(x => x.brandName !== null && x.brandName.length > 0)
                .toArray(),
        })))
            .toArray();
    }, _AviaHotFilterMobile_getHotFilterChangeAircraftAmount = function _AviaHotFilterMobile_getHotFilterChangeAircraftAmount(instance, groups, isDirect) {
        let value = !instance ? '-1' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.changeAircraftAmount);
        // если такого блока нет
        value = value === '' ? '-1' : value;
        const options = [{ value: '-1', text: 'Любое', selected: value === '-1' }];
        if (isDirect)
            return options;
        const legs = Enumerable.from(groups)
            .selectMany(v => v.variants)
            .selectMany(v => v.legs)
            .toArray();
        const changes = Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => Enumerable.from(v.legs.map(leg => leg.segmentCount - 1)).orderByDescending(s => s).first())
            .distinct()
            .orderBy(v => v)
            .toArray();
        if (changes.indexOf(0) > -1) {
            if (Enumerable.from(legs)
                .any(v => v.segments.length === 1
                && Enumerable.from(v.segments).any(x => x.stops === null)))
                options.push({ value: '0', text: 'Прямые рейсы', selected: value === '0' });
            if (Enumerable.from(legs).any(v => v.segments.length === 1
                && Enumerable.from(v.segments).any(x => x.stops !== null)))
                options.push({ value: '-2', text: 'Прямые с тех. посадкой', selected: value === '-2' });
            changes.shift();
        }
        $.each(changes, (i, v) => {
            options.push({ value: v.toString(), text: App.pluralRu(v, `${v} пересадка`, `${v} пересадки`, `${v} пересадок`), selected: value === v.toString() });
        });
        return options;
    }, _AviaHotFilterMobile_getHotFilterChangeAircraftDelays = function _AviaHotFilterMobile_getHotFilterChangeAircraftDelays(instance, isDirect) {
        let value = !instance ? '-1' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.changeAircraftDelay);
        // если такого блока нет
        value = value === '' ? '-1' : value;
        const options = [{ value: '-1', text: 'Любая', selected: value === '-1' }];
        if (isDirect)
            return options;
        $.each([2, 5, 8, 10], (i, v) => options.push({ value: v.toString(), text: `Не более ${v} часов`, selected: value === v.toString() }));
        return options;
    }, _AviaHotFilterMobile_getHotFilterBaggage = function _AviaHotFilterMobile_getHotFilterBaggage(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.baggageInfo);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Не важно', selected: value === 'All' }];
        if (Enumerable.from(groups).any(o => o.withBaggage))
            options.push({ value: 'With', text: 'С багажом', selected: value === 'With' });
        if (Enumerable.from(groups).any(o => o.withoutBaggage))
            options.push({ value: 'Without', text: 'Без багажа', selected: value === 'Without' });
        return options;
    }, _AviaHotFilterMobile_getHotFilterDepartureAirports = function _AviaHotFilterMobile_getHotFilterDepartureAirports(instance, groups) {
        const value = !instance ? '' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.departureAirport);
        const options = [{ value: '', text: 'Любой', selected: value === '' }];
        $.each(Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => v.legs[0])
            .select(v => v.segments[0])
            .distinct(v => v.airportCode)
            .toArray(), (i, v) => options.push({ value: v.airportCode, text: `${v.airportName}, ${v.cityName}`, selected: v.airportCode === value }));
        return options;
    }, _AviaHotFilterMobile_getHotFilterArrivalAirports = function _AviaHotFilterMobile_getHotFilterArrivalAirports(instance, groups) {
        const value = !instance ? '' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.arrivalAirport);
        const options = [{ value: '', text: 'Любой', selected: value === '' }];
        $.each(Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => v.legs[0])
            .select(v => v.segments[v.segments.length - 1])
            .distinct(v => v.endAirportCode)
            .toArray(), (i, v) => options.push({ value: v.endAirportCode, text: `${v.endAirportName}, ${v.endCityName}`, selected: v.endAirportCode === value }));
        return options;
    }, _AviaHotFilterMobile_getHotFilterBackArrivalAirports = function _AviaHotFilterMobile_getHotFilterBackArrivalAirports(instance, groups) {
        const value = !instance ? '' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.backArrivalAirport);
        const options = [{ value: '', text: 'Любой', selected: value === '' }];
        if (Enumerable.from(groups)
            .selectMany(v => v.variants)
            .all(v => v.legs.length < 2))
            return options;
        $.each(Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => v.legs[1])
            .select(v => v.segments[v.segments.length - 1])
            .distinct(v => v.endAirportCode)
            .toArray(), (i, v) => options.push({ value: v.endAirportCode, text: `${v.endAirportName}, ${v.endCityName}`, selected: v.endAirportCode === value }));
        return options;
    }, _AviaHotFilterMobile_getHotFilterFlightTypes = function _AviaHotFilterMobile_getHotFilterFlightTypes(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.flightType);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Все', selected: value === 'All' }];
        if (Enumerable.from(groups).any(o => !o.charter))
            options.push({ value: 'Regular', text: 'Регулярный рейс', selected: value === 'Regular' });
        if (Enumerable.from(groups).any(o => o.charter))
            options.push({ value: 'Charter', text: 'Чартерный рейс', selected: value === 'Charter' });
        return options;
    }, _AviaHotFilterMobile_getHotFilterServiceClasses = function _AviaHotFilterMobile_getHotFilterServiceClasses(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.serviceClass);
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Любой', selected: value === 'All' }];
        const classes = Enumerable.from(groups)
            .select(v => v.serviceClass)
            .distinct(v => v.code)
            .toArray();
        $.each(classes, (i, v) => {
            options.push({ value: v.code, text: v.name, selected: value === v.code });
        });
        return options;
    }, _AviaHotFilterMobile_getHotFilterAirportWillBeChanged = function _AviaHotFilterMobile_getHotFilterAirportWillBeChanged(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.airportWillBeChanged);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Не важно', selected: value === 'All' }];
        if (Enumerable.from(groups).any(o => o.airportWillBeChanged)) {
            options.push({ value: 'With', text: 'Есть', selected: value === 'With' });
            options.push({ value: 'Without', text: 'Нет', selected: value === 'Without' });
        }
        return options;
    }, _AviaHotFilterMobile_getHotFilterAdditionalDiscount = function _AviaHotFilterMobile_getHotFilterAdditionalDiscount(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilterMobile_instances, "m", _AviaHotFilterMobile_getBlockValue).call(instance, App.HotFilterBlockName.airportWillBeChanged);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Не важно', selected: value === 'All' }];
        if (Enumerable.from(groups).any(o => o.discount > 0)) {
            options.push({ value: 'With', text: 'Со скидкой', selected: value === 'With' });
            options.push({ value: 'Without', text: 'Без скидки', selected: value === 'Without' });
        }
        return options;
    }, _AviaHotFilterMobile_blockModel = function _AviaHotFilterMobile_blockModel(label, data, options) {
        return new App.AviaSelectListModelMobile({
            label,
            data: App.HotFilterBlockName[data],
            items: options,
        });
    }, _AviaHotFilterMobile_getBlockValue = function _AviaHotFilterMobile_getBlockValue(blockName) {
        /*
        // в уже существующем фильтре блока может и не быть из-за недостаточного кол-ва опций.
        return this.#selectBlocks
            .filter(`[data-type="${HotFilterBlockName[blockName]}"]`)
            .find('.js-jelect-input')
            .valString()
            .trim();
        */
        return this.filters.getControlValueString(App.HotFilterBlockName[blockName]);
    }, _AviaHotFilterMobile_apply = function _AviaHotFilterMobile_apply(fireEvent) {
        // делаем копию, чтобы оригинал сохранился.
        let newGroups = App.deepCopy(__classPrivateFieldGet(this, _AviaHotFilterMobile_groups, "f"));
        // на выходе сгруппированные перелеты + сами варианты перелета.
        $.each(this.filters.controls, (index, control) => {
            // const jqElement = $(element);
            const type = control.name; // jqElement.attr('data-type');
            const input = control; // $('.js-jelect-input', jqElement);
            const newItems = [];
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.carriers]) {
                const value = input.getControlValueString(); // input.valString();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const brandIds = [];
                        $.each(item.variants, (iv, variant) => {
                            $.each(variant.legs, (il, leg) => {
                                $.each(leg.segments, (is, segment) => {
                                    $.each(segment.brandFares, (ib, brand) => {
                                        if (!brandIds.includes(brand.brandId))
                                            brandIds.push(brand.brandId);
                                    });
                                });
                            });
                        });
                        if (value.split(',').some(carrier => __classPrivateFieldGet(_a, _a, "m", _AviaHotFilterMobile_containsGroup).call(_a, carrier, item.marketingAirlines, brandIds)))
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.changeAircraftAmount]) {
                const val = input.getControlValueNumber(-1);
                const value = val == null ? -1 : val;
                if (value > -1) {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(variant => (variant.legs
                            .filter(leg => leg.segmentCount === value + 1).length <= item.legCount.length)
                            && (variant.legs.filter(leg => leg.segmentCount === value + 1).length > 0)
                            && (variant.legs.filter(leg => leg.segmentCount > value + 1).length === 0));
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
                // прямые с технической посадкой
                if (value === -2) {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(variant => variant.legs.filter(leg => leg.segmentCount <= 1).length === item.legCount.length
                            // и есть тех.посадка
                            && variant.legs.some(leg => leg.stopsCount > 0));
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.changeAircraftDelay]) {
                const value = input.getControlValueNumber(0);
                if (value > 0) {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.maxChangeAircraftDelay <= value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.baggageInfo]) {
                const value = input.getControlValueString();
                if (value === 'With') {
                    $.each(newGroups, (i, item) => {
                        if (item.withBaggage)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Without') {
                    $.each(newGroups, (i, item) => {
                        if (item.withoutBaggage)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.departureAirport]) {
                const value = input.getControlValueString();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.legs[0].segments[0].airportCode === value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.arrivalAirport]) {
                const value = input.getControlValueString();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.legs[0].segments[v.legs[0].segments.length - 1].endAirportCode === value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.backArrivalAirport]) {
                const value = input.getControlValueString();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.legs[1].segments[v.legs[1].segments.length - 1].endAirportCode === value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.flightType]) {
                const value = input.getControlValueString();
                if (value === 'Regular') {
                    $.each(newGroups, (i, item) => {
                        if (!item.charter)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Charter') {
                    $.each(newGroups, (i, item) => {
                        if (item.charter)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.serviceClass]) {
                const value = input.getControlValueString();
                if (value !== 'All') {
                    $.each(newGroups, (i, item) => {
                        if (item.serviceClass.code === value)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.airportWillBeChanged]) {
                const value = input.getControlValueString();
                if (value === 'With') {
                    $.each(newGroups, (i, item) => {
                        if (item.airportWillBeChanged)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Without') {
                    $.each(newGroups, (i, item) => {
                        if (!item.airportWillBeChanged)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.sameDayDeparture]) {
                const value = input.getControlValueString();
                if (value && __classPrivateFieldGet(this, _AviaHotFilterMobile_dynamicDepartureDate, "f")) {
                    const dynamicDepartureDate = __classPrivateFieldGet(this, _AviaHotFilterMobile_dynamicDepartureDate, "f").getTime();
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => new App.XDate(App.parseIsoDate(v.legs[0].segments[0].date))
                            .trimTime()
                            .getTime() === dynamicDepartureDate);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.departureRange]) {
                const range = control.getValuesInMinutes();
                $.each(newGroups, (i, item) => {
                    const newVariants = item.variants.filter(variant => variant.departureTotalMinutes >= range[0] && variant.departureTotalMinutes < range[1]);
                    if (newVariants.length > 0) {
                        const newItem = item;
                        newItem.variants = newVariants;
                        newItems.push(newItem);
                    }
                    newGroups = newItems;
                });
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.arrivalRange]) {
                const range = control.getValuesInMinutes();
                $.each(newGroups, (i, item) => {
                    const newVariants = item.variants.filter(variant => variant.arrivalTotalMinutes >= range[0] && variant.arrivalTotalMinutes < range[1]);
                    if (newVariants.length > 0) {
                        const newItem = item;
                        newItem.variants = newVariants;
                        newItems.push(newItem);
                    }
                    newGroups = newItems;
                });
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.backDepartureRange]) {
                const range = control.getValuesInMinutes();
                $.each(newGroups, (i, item) => {
                    const newVariants = item.variants.filter(variant => variant.backDepartureTotalMinutes >= range[0]
                        && variant.backDepartureTotalMinutes < range[1]);
                    if (newVariants.length > 0) {
                        const newItem = item;
                        newItem.variants = newVariants;
                        newItems.push(newItem);
                    }
                    newGroups = newItems;
                });
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.backArrivalRange]) {
                const range = control.getValuesInMinutes();
                $.each(newGroups, (i, item) => {
                    const newVariants = item.variants.filter(variant => variant.backArrivalTotalMinutes >= range[0] && variant.backArrivalTotalMinutes < range[1]);
                    if (newVariants.length > 0) {
                        const newItem = item;
                        newItem.variants = newVariants;
                        newItems.push(newItem);
                    }
                    newGroups = newItems;
                });
            }
            if (type === App.HotFilterBlockName[App.HotFilterBlockName.additionalDiscount]) {
                const value = input.getControlValueString();
                if (value === 'With') {
                    $.each(newGroups, (i, item) => {
                        if (item.discount > 0)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Without') {
                    $.each(newGroups, (i, item) => {
                        if (item.discount == 0)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
        });
        $.each(newGroups, (index, el) => {
            if (el.variants.length > 1)
                el.hasMoreVariants = true;
            else
                el.hasMoreVariants = false;
        });
        __classPrivateFieldSet(this, _AviaHotFilterMobile_result, newGroups, "f");
        // console.log('---> HotFilterChange <---', this.#result);
        if (fireEvent)
            this.root.trigger("hotfilter:change" /* Events.HotFilterChange */, [newGroups]);
    }, _AviaHotFilterMobile_containsGroup = function _AviaHotFilterMobile_containsGroup(carrier, marketingAirlines, brandIds) {
        if (!carrier.includes(':'))
            return marketingAirlines.includes(carrier);
        const carrierAndBrand = carrier.split(':');
        return marketingAirlines.includes(carrierAndBrand[0]) && brandIds.includes(carrierAndBrand[1]);
    };
    // Класс для переноса фильтра в модалку "Фильтры" (по аналогии с HotFilterMobile).
    _AviaHotFilterMobile_customFilterClass = { value: '__custom__filter__' };
    App.AviaHotFilterMobile = AviaHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaHotFilter_instances, _a, _AviaHotFilter_groups, _AviaHotFilter_dynamicDepartureDate, _AviaHotFilter_selectBlocks, _AviaHotFilter_result, _AviaHotFilter_init, _AviaHotFilter_setData, _AviaHotFilter_toggleBrands, _AviaHotFilter_getHotFilterCarrierBrands, _AviaHotFilter_getHotFilterChangeAircraftAmount, _AviaHotFilter_getHotFilterChangeAircraftDelays, _AviaHotFilter_getHotFilterBaggage, _AviaHotFilter_getHotFilterDepartureAirports, _AviaHotFilter_getHotFilterArrivalAirports, _AviaHotFilter_getHotFilterBackArrivalAirports, _AviaHotFilter_getHotFilterFlightTypes, _AviaHotFilter_getHotFilterServiceClasses, _AviaHotFilter_getHotFilterAirportWillBeChanged, _AviaHotFilter_getHotFilterAdditionalDiscount, _AviaHotFilter_blockModel, _AviaHotFilter_getBlockValue, _AviaHotFilter_apply, _AviaHotFilter_containsGroup;
    let HotFilterBlockName;
    (function (HotFilterBlockName) {
        HotFilterBlockName[HotFilterBlockName["carriers"] = 0] = "carriers";
        HotFilterBlockName[HotFilterBlockName["departureRange"] = 1] = "departureRange";
        HotFilterBlockName[HotFilterBlockName["arrivalRange"] = 2] = "arrivalRange";
        HotFilterBlockName[HotFilterBlockName["backDepartureRange"] = 3] = "backDepartureRange";
        HotFilterBlockName[HotFilterBlockName["backArrivalRange"] = 4] = "backArrivalRange";
        HotFilterBlockName[HotFilterBlockName["changeAircraftAmount"] = 5] = "changeAircraftAmount";
        HotFilterBlockName[HotFilterBlockName["changeAircraftDelay"] = 6] = "changeAircraftDelay";
        HotFilterBlockName[HotFilterBlockName["baggageInfo"] = 7] = "baggageInfo";
        HotFilterBlockName[HotFilterBlockName["departureAirport"] = 8] = "departureAirport";
        HotFilterBlockName[HotFilterBlockName["arrivalAirport"] = 9] = "arrivalAirport";
        HotFilterBlockName[HotFilterBlockName["backArrivalAirport"] = 10] = "backArrivalAirport";
        HotFilterBlockName[HotFilterBlockName["sameDayDeparture"] = 11] = "sameDayDeparture";
        HotFilterBlockName[HotFilterBlockName["flightType"] = 12] = "flightType";
        HotFilterBlockName[HotFilterBlockName["serviceClass"] = 13] = "serviceClass";
        HotFilterBlockName[HotFilterBlockName["airportWillBeChanged"] = 14] = "airportWillBeChanged";
        HotFilterBlockName[HotFilterBlockName["additionalDiscount"] = 15] = "additionalDiscount";
    })(HotFilterBlockName = App.HotFilterBlockName || (App.HotFilterBlockName = {}));
    // TODO: сделать наследником HotFilter.
    class AviaHotFilter {
        constructor(groups, dynamicDepartureDate) {
            _AviaHotFilter_instances.add(this);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #region Взято из Filter.ts, убрать после установки AviaHotFilter наследником Filter.
            Object.defineProperty(this, "controls", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            // #endregion
            _AviaHotFilter_groups.set(this, void 0);
            _AviaHotFilter_dynamicDepartureDate.set(this, void 0);
            _AviaHotFilter_selectBlocks.set(this, void 0);
            _AviaHotFilter_result.set(this, void 0);
            this.root = $('.js-avia-hotfilter');
            __classPrivateFieldSet(this, _AviaHotFilter_groups, groups, "f");
            __classPrivateFieldSet(this, _AviaHotFilter_result, groups, "f");
            __classPrivateFieldSet(this, _AviaHotFilter_dynamicDepartureDate, dynamicDepartureDate, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AviaHotFilter_selectBlocks, $('.js-avia-select-block', this.root), "f");
            __classPrivateFieldGet(this, _AviaHotFilter_instances, "m", _AviaHotFilter_init).call(this);
        }
        fire(groups) {
            // this.#init();
            __classPrivateFieldGet(this, _AviaHotFilter_instances, "m", _AviaHotFilter_setData).call(this, groups);
            __classPrivateFieldGet(this, _AviaHotFilter_instances, "m", _AviaHotFilter_apply).call(this, true);
        }
        getResult() {
            return __classPrivateFieldGet(this, _AviaHotFilter_result, "f");
        }
        static getModel(instance, groups, tripType, isDirect) {
            const carriers = __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterCarrierBrands).call(this, instance, groups);
            return {
                tripType: tripType,
                carrierBrands: {
                    options: carriers,
                    selected: {
                        value: Enumerable.from(carriers).where(v => v.selected).toJoinedString(',', v => v.value),
                        text: Enumerable.from(carriers).any(v => v.selected)
                            ? Enumerable.from(carriers).where(v => v.selected).toJoinedString(',', v => v.text)
                            : 'Любой',
                    },
                },
                departureRange: { name: 'departureRange', label: 'Время вылета' },
                arrivalRange: { name: 'arrivalRange', label: 'Время прилета' },
                backDepartureRange: { name: 'backDepartureRange', label: 'Время обратного вылета' },
                backArrivalRange: { name: 'backArrivalRange', label: 'Время обратного прилета' },
                changeAircraftAmount: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Количество пересадок', HotFilterBlockName.changeAircraftAmount, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterChangeAircraftAmount).call(this, instance, groups, isDirect)),
                changeAircraftDelay: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Длительность пересадок', HotFilterBlockName.changeAircraftDelay, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterChangeAircraftDelays).call(this, instance, isDirect)),
                baggageInfo: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Наличие багажа', HotFilterBlockName.baggageInfo, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterBaggage).call(this, instance, groups)),
                departureAirports: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Аэропорт отправления', HotFilterBlockName.departureAirport, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterDepartureAirports).call(this, instance, groups)),
                arrivalAirports: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Аэропорт прилета', HotFilterBlockName.arrivalAirport, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterArrivalAirports).call(this, instance, groups)),
                backArrivalAirports: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Аэропорт обратного прилета', HotFilterBlockName.backArrivalAirport, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterBackArrivalAirports).call(this, instance, groups)),
                flightType: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Тип рейса', HotFilterBlockName.flightType, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterFlightTypes).call(this, instance, groups)),
                serviceClasses: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Класс обслуживания', HotFilterBlockName.serviceClass, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterServiceClasses).call(this, instance, groups)),
                airportWillBeChanged: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Смена аэропорта при пересадке', HotFilterBlockName.airportWillBeChanged, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterAirportWillBeChanged).call(this, instance, groups)),
                additionalDiscount: __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_blockModel).call(_a, 'Дополнительная скидка', HotFilterBlockName.additionalDiscount, __classPrivateFieldGet(this, _a, "m", _AviaHotFilter_getHotFilterAdditionalDiscount).call(this, instance, groups)),
            };
        }
    }
    _a = AviaHotFilter, _AviaHotFilter_groups = new WeakMap(), _AviaHotFilter_dynamicDepartureDate = new WeakMap(), _AviaHotFilter_selectBlocks = new WeakMap(), _AviaHotFilter_result = new WeakMap(), _AviaHotFilter_instances = new WeakSet(), _AviaHotFilter_init = function _AviaHotFilter_init() {
        __classPrivateFieldGet(this, _AviaHotFilter_selectBlocks, "f").each((index, element) => {
            const jqElement = $(element);
            const jelect = $('.js-jelect', jqElement);
            const scrollerWrap = $('.js-scroller-wrap', jqElement);
            const filterOption = $('.js-filter-option', jqElement);
            const hasIcons = jqElement.hasClass('js-icons-select');
            const hasCheckbox = jqElement.hasClass('js-checkbox-select');
            jelect.jelect();
            // Стилизуем скролл
            const scroll = scrollerWrap.baron({
                scroller: '.js-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            jelect.on('click', () => scroll.update());
            // Если блок содержит иконки или чекбоксы
            if (hasIcons || hasCheckbox) {
                // Обратаываем клики по элементам списков
                filterOption.on('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    let target = $(e.currentTarget);
                    const active = '_active';
                    const isCarrierBlock = target.hasClass('js-brands');
                    let isCarrierCheckbox = false;
                    if (isCarrierBlock) {
                        // видимость блока с брендами
                        __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_toggleBrands).call(_a, target);
                        return false;
                    }
                    const isBrandCheckbox = target.hasClass('js-brand-checkbox');
                    if (target.hasClass('js-jelect-option-value')) {
                        isCarrierCheckbox = true;
                        target = target.closest('.js-jelect-option');
                    }
                    const input = target.closest('.filter-select-block').find('.jelect-current');
                    const hiddenInput = target.closest('.filter-select-block').find('.js-jelect-input');
                    // Сняли выделение с пункта
                    if (target.hasClass(active)) {
                        target.removeClass(active);
                        // снимаем галки только с брендов данного перевозчика
                        if (isCarrierCheckbox)
                            target.find('.js-filter-option').removeClass(active);
                        if (isBrandCheckbox)
                            target.closest('.js-brands').removeClass(active);
                        // Если в результате нет активных пунктов, выбираем пункт 'Все ... (страны, например)'
                        if (filterOption.filter('._active').length === 0) {
                            filterOption.filter('.js-filter-option-all').trigger('click');
                            return false;
                        }
                    }
                    else {
                        // Если выбран вариант 'Все'
                        if (target.hasClass('js-filter-option-all'))
                            filterOption.filter('._active').removeClass(active);
                        else
                            filterOption.filter('.js-filter-option-all').removeClass(active);
                        target.addClass(active);
                        // если выбрана а/к, то выделяем все бренды
                        if (isCarrierCheckbox) {
                            target.find('.js-filter-option')
                                .not('.js-jelect-option-value')
                                .addClass(active);
                        }
                        if (isBrandCheckbox) {
                            target.closest('.js-brands')
                                .toggleClass(active, target.siblings('.js-filter-option').not('._active').length === 0);
                        }
                    }
                    // Выставляем текст в инпуте
                    const inputAr = [];
                    const hidderInputAr = [];
                    filterOption.filter('._active')
                        .each((index2, element2) => {
                        const jqElement2 = $(element2);
                        if (jqElement2.hasClass('js-brand-checkbox') && jqElement2.closest('.js-brands').hasClass(active))
                            return; // == continue
                        inputAr.push(jqElement2.attr('data-text') || '');
                        hidderInputAr.push(jqElement2.attr('data-val') || '');
                    });
                    const airlines = inputAr.join(', ');
                    input.text(airlines);
                    input.attr('title', airlines);
                    hiddenInput.val(hidderInputAr.join(','));
                    __classPrivateFieldGet(this, _AviaHotFilter_instances, "m", _AviaHotFilter_apply).call(this, true);
                    return false;
                });
            }
            else {
                jelect.on('change', () => {
                    __classPrivateFieldGet(this, _AviaHotFilter_instances, "m", _AviaHotFilter_apply).call(this, true);
                    return false;
                });
            }
        });
        const filterSliderBlock = this.root.find('.js-filter-slider-block');
        filterSliderBlock.each((i, v) => {
            const sliderBlock = new App.FilterTimeOfDaySliderBlock({ root: $(v) });
            sliderBlock.root.on("filter:change" /* Events.FilterChange */, () => __classPrivateFieldGet(this, _AviaHotFilter_instances, "m", _AviaHotFilter_apply).call(this, true));
            this.controls.push(sliderBlock);
        });
        // #region Взято из Filter.ts, убрать после установки AviaHotFilter наследником Filter.
        const filterSlidingBtn = this.root.find('.js-filter-sliding-btn-b, .js-form-sliding-btn-b');
        filterSlidingBtn.each((i, v) => { this.controls.push(new App.FilterSlidingButtonBlock({ root: $(v) })); });
        filterSlidingBtn.on('change', () => __classPrivateFieldGet(this, _AviaHotFilter_instances, "m", _AviaHotFilter_apply).call(this, true));
        // #endregion
    }, _AviaHotFilter_setData = function _AviaHotFilter_setData(groups) {
        __classPrivateFieldSet(this, _AviaHotFilter_groups, groups, "f");
    }, _AviaHotFilter_toggleBrands = function _AviaHotFilter_toggleBrands(invoker) {
        const shown = invoker.attr('data-shown');
        if (shown === '1')
            $(invoker).attr('data-shown', '0');
        else
            $(invoker).attr('data-shown', '1');
        $(invoker).find('.js-brand-block').toggle('slide', 300);
    }, _AviaHotFilter_getHotFilterCarrierBrands = function _AviaHotFilter_getHotFilterCarrierBrands(instance, groups) {
        const values = !instance ? '' : Enumerable.from((__classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.carriers)).split(',')).select(v => v.trim()).toArray();
        const segments = Enumerable.from(groups)
            .selectMany(v => v.variants)
            .selectMany(v => v.legs)
            .selectMany(v => v.segments);
        return Enumerable.from([{
                text: 'Любой',
                value: '',
                selected: values.indexOf('') !== -1,
            }])
            .union(segments
            .distinct(v => v.airlineCode)
            .orderBy(v => v.airlineName)
            .select(v => ({
            text: v.airlineName ? v.airlineName.replace('KIWI', 'Лоукостеры') : '',
            value: v.airlineCode,
            selected: values.indexOf(v.airlineCode) !== -1,
            brands: segments
                .where(s => s.airlineCode === v.airlineCode)
                .selectMany(s => s.brandFares)
                .distinct(x => x.brandId)
                .select(x => ({
                brandId: x.brandId,
                brandName: x.brandName,
                programSystemCode: x.programSystemCode,
                programCode: x.programCode,
                selected: values.indexOf(x.brandId) !== -1,
                airline: {
                    code: x.airline.code,
                    name: x.airline.name,
                },
            }))
                // чтобы не было пустых брендовых тарифов
                .where(x => x.brandName !== null && x.brandName.length > 0)
                .toArray(),
        })))
            .toArray();
    }, _AviaHotFilter_getHotFilterChangeAircraftAmount = function _AviaHotFilter_getHotFilterChangeAircraftAmount(instance, groups, isDirect) {
        let value = !instance ? '-1' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.changeAircraftAmount);
        // если такого блока нет
        value = value === '' ? '-1' : value;
        const options = [{ value: '-1', text: 'Любое', selected: value === '-1' }];
        if (isDirect)
            return options;
        const legs = Enumerable.from(groups)
            .selectMany(v => v.variants)
            .selectMany(v => v.legs)
            .toArray();
        const changes = Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => Enumerable.from(v.legs.map(leg => leg.segmentCount - 1)).orderByDescending(s => s).first())
            .distinct()
            .orderBy(v => v)
            .toArray();
        if (changes.indexOf(0) > -1) {
            if (Enumerable.from(legs)
                .any(v => v.segments.length === 1
                && Enumerable.from(v.segments).any(x => x.stops === null)))
                options.push({ value: '0', text: 'Прямые рейсы', selected: value === '0' });
            if (Enumerable.from(legs).any(v => v.segments.length === 1
                && Enumerable.from(v.segments).any(x => x.stops !== null)))
                options.push({ value: '-2', text: 'Прямые с тех. посадкой', selected: value === '-2' });
            changes.shift();
        }
        $.each(changes, (i, v) => {
            options.push({ value: v.toString(), text: App.pluralRu(v, `${v} пересадка`, `${v} пересадки`, `${v} пересадок`), selected: value === v.toString() });
        });
        return options;
    }, _AviaHotFilter_getHotFilterChangeAircraftDelays = function _AviaHotFilter_getHotFilterChangeAircraftDelays(instance, isDirect) {
        let value = !instance ? '-1' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.changeAircraftDelay);
        // если такого блока нет
        value = value === '' ? '-1' : value;
        const options = [{ value: '-1', text: 'Любая', selected: value === '-1' }];
        if (isDirect)
            return options;
        $.each([2, 5, 8, 10], (i, v) => options.push({ value: v.toString(), text: `Не более ${v} часов`, selected: value === v.toString() }));
        return options;
    }, _AviaHotFilter_getHotFilterBaggage = function _AviaHotFilter_getHotFilterBaggage(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.baggageInfo);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Не важно', selected: value === 'All' }];
        if (Enumerable.from(groups).any(o => o.withBaggage))
            options.push({ value: 'With', text: 'С багажом', selected: value === 'With' });
        if (Enumerable.from(groups).any(o => o.withoutBaggage))
            options.push({ value: 'Without', text: 'Без багажа', selected: value === 'Without' });
        return options;
    }, _AviaHotFilter_getHotFilterDepartureAirports = function _AviaHotFilter_getHotFilterDepartureAirports(instance, groups) {
        const value = !instance ? '' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.departureAirport);
        const options = [{ value: '', text: 'Любой', selected: value === '' }];
        $.each(Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => v.legs[0])
            .select(v => v.segments[0])
            .distinct(v => v.airportCode)
            .toArray(), (i, v) => options.push({ value: v.airportCode, text: `${v.airportName}, ${v.cityName}`, selected: v.airportCode === value }));
        return options;
    }, _AviaHotFilter_getHotFilterArrivalAirports = function _AviaHotFilter_getHotFilterArrivalAirports(instance, groups) {
        const value = !instance ? '' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.arrivalAirport);
        const options = [{ value: '', text: 'Любой', selected: value === '' }];
        $.each(Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => v.legs[0])
            .select(v => v.segments[v.segments.length - 1])
            .distinct(v => v.endAirportCode)
            .toArray(), (i, v) => options.push({ value: v.endAirportCode, text: `${v.endAirportName}, ${v.endCityName}`, selected: v.endAirportCode === value }));
        return options;
    }, _AviaHotFilter_getHotFilterBackArrivalAirports = function _AviaHotFilter_getHotFilterBackArrivalAirports(instance, groups) {
        const value = !instance ? '' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.backArrivalAirport);
        const options = [{ value: '', text: 'Любой', selected: value === '' }];
        if (Enumerable.from(groups)
            .selectMany(v => v.variants)
            .all(v => v.legs.length < 2))
            return options;
        $.each(Enumerable.from(groups)
            .selectMany(v => v.variants)
            .select(v => v.legs[1])
            .select(v => v.segments[v.segments.length - 1])
            .distinct(v => v.endAirportCode)
            .toArray(), (i, v) => options.push({ value: v.endAirportCode, text: `${v.endAirportName}, ${v.endCityName}`, selected: v.endAirportCode === value }));
        return options;
    }, _AviaHotFilter_getHotFilterFlightTypes = function _AviaHotFilter_getHotFilterFlightTypes(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.flightType);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Все', selected: value === 'All' }];
        if (Enumerable.from(groups).any(o => !o.charter))
            options.push({ value: 'Regular', text: 'Регулярный рейс', selected: value === 'Regular' });
        if (Enumerable.from(groups).any(o => o.charter))
            options.push({ value: 'Charter', text: 'Чартерный рейс', selected: value === 'Charter' });
        return options;
    }, _AviaHotFilter_getHotFilterServiceClasses = function _AviaHotFilter_getHotFilterServiceClasses(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.serviceClass);
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Любой', selected: value === 'All' }];
        const classes = Enumerable.from(groups)
            .select(v => v.serviceClass)
            .distinct(v => v.code)
            .toArray();
        $.each(classes, (i, v) => {
            options.push({ value: v.code, text: v.name, selected: value === v.code });
        });
        return options;
    }, _AviaHotFilter_getHotFilterAirportWillBeChanged = function _AviaHotFilter_getHotFilterAirportWillBeChanged(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.airportWillBeChanged);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Не важно', selected: value === 'All' }];
        if (Enumerable.from(groups).any(o => o.airportWillBeChanged)) {
            options.push({ value: 'With', text: 'Есть', selected: value === 'With' });
            options.push({ value: 'Without', text: 'Нет', selected: value === 'Without' });
        }
        return options;
    }, _AviaHotFilter_getHotFilterAdditionalDiscount = function _AviaHotFilter_getHotFilterAdditionalDiscount(instance, groups) {
        let value = !instance ? 'All' : __classPrivateFieldGet(instance, _AviaHotFilter_instances, "m", _AviaHotFilter_getBlockValue).call(instance, HotFilterBlockName.airportWillBeChanged);
        // если такого блока нет
        value = value === '' ? 'All' : value;
        const options = [{ value: 'All', text: 'Не важно', selected: value === 'All' }];
        if (groups.some(o => o.hasDiscount)) {
            options.push({ value: 'With', text: 'Со скидкой', selected: value === 'With' });
            options.push({ value: 'Without', text: 'Без скидки', selected: value === 'Without' });
        }
        return options;
    }, _AviaHotFilter_blockModel = function _AviaHotFilter_blockModel(label, data, options) {
        return new App.AviaSelectListModel({
            label,
            data: HotFilterBlockName[data],
            items: options,
        });
    }, _AviaHotFilter_getBlockValue = function _AviaHotFilter_getBlockValue(blockName) {
        // в уже существующем фильтре блока может и не быть из-за недостаточного кол-ва опций.
        return __classPrivateFieldGet(this, _AviaHotFilter_selectBlocks, "f") // getSelectBlocks()
            .filter(`[data-type="${HotFilterBlockName[blockName]}"]`)
            .find('.js-jelect-input')
            .valString()
            .trim();
    }, _AviaHotFilter_apply = function _AviaHotFilter_apply(fireEvent) {
        // делаем копию, чтобы оригинал сохранился.
        let newGroups = App.deepCopy(__classPrivateFieldGet(this, _AviaHotFilter_groups, "f"));
        // на выходе сгруппированные перелеты + сами варианты перелета.
        $.each(__classPrivateFieldGet(this, _AviaHotFilter_selectBlocks, "f"), (index, element) => {
            const jqElement = $(element);
            const type = jqElement.attr('data-type');
            const input = $('.js-jelect-input', jqElement);
            const newItems = [];
            if (type === HotFilterBlockName[HotFilterBlockName.carriers]) {
                const value = input.valString();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const brandIds = [];
                        $.each(item.variants, (iv, variant) => {
                            $.each(variant.legs, (il, leg) => {
                                $.each(leg.segments, (is, segment) => {
                                    $.each(segment.brandFares, (ib, brand) => {
                                        if (!brandIds.includes(brand.brandId))
                                            brandIds.push(brand.brandId);
                                    });
                                });
                            });
                        });
                        if (value.split(',').some(carrier => __classPrivateFieldGet(_a, _a, "m", _AviaHotFilter_containsGroup).call(_a, carrier, item.marketingAirlines, brandIds)))
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.changeAircraftAmount]) {
                const val = input.valNumber();
                const value = val == null ? -1 : val;
                if (value > -1) {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(variant => (variant.legs
                            .filter(leg => leg.segmentCount === value + 1).length <= item.legCount.length)
                            && (variant.legs.filter(leg => leg.segmentCount === value + 1).length > 0)
                            && (variant.legs.filter(leg => leg.segmentCount > value + 1).length === 0));
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
                // прямые с технической посадкой
                if (value === -2) {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(variant => variant.legs.filter(leg => leg.segmentCount <= 1).length === item.legCount.length
                            // и есть тех.посадка
                            && variant.legs.some(leg => leg.stopsCount > 0));
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.changeAircraftDelay]) {
                let value = input.valNumber() || 0;
                if (value > 0) {
                    value = value * 60;
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.maxChangeAircraftDelay <= value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.baggageInfo]) {
                const value = input.val();
                if (value === 'With') {
                    $.each(newGroups, (i, item) => {
                        if (item.withBaggage)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Without') {
                    $.each(newGroups, (i, item) => {
                        if (item.withoutBaggage)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.departureAirport]) {
                const value = input.val();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.legs[0].segments[0].airportCode === value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.arrivalAirport]) {
                const value = input.val();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.legs[0].segments[v.legs[0].segments.length - 1].endAirportCode === value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.backArrivalAirport]) {
                const value = input.val();
                if (value !== '') {
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants
                            .filter(v => v.legs[1].segments[v.legs[1].segments.length - 1].endAirportCode === value);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.flightType]) {
                const value = input.val();
                if (value === 'Regular') {
                    $.each(newGroups, (i, item) => {
                        if (!item.charter)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Charter') {
                    $.each(newGroups, (i, item) => {
                        if (item.charter)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.serviceClass]) {
                const value = input.val();
                if (value !== 'All') {
                    $.each(newGroups, (i, item) => {
                        if (item.serviceClass.code === value)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.airportWillBeChanged]) {
                const value = input.val();
                if (value === 'With') {
                    $.each(newGroups, (i, item) => {
                        if (item.airportWillBeChanged)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Without') {
                    $.each(newGroups, (i, item) => {
                        if (!item.airportWillBeChanged)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
            if (type === HotFilterBlockName[HotFilterBlockName.additionalDiscount]) {
                const value = input.val();
                if (value === 'With') {
                    $.each(newGroups, (i, item) => {
                        if (item.hasDiscount)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
                if (value === 'Without') {
                    $.each(newGroups, (i, item) => {
                        if (!item.hasDiscount)
                            newItems.push(item);
                    });
                    newGroups = newItems;
                }
            }
        });
        this.controls.forEach(filter => {
            switch (filter.name) {
                case HotFilterBlockName[HotFilterBlockName.sameDayDeparture]: {
                    const value = filter.getValue();
                    if (value && __classPrivateFieldGet(this, _AviaHotFilter_dynamicDepartureDate, "f")) {
                        const dynamicDepartureDate = __classPrivateFieldGet(this, _AviaHotFilter_dynamicDepartureDate, "f").getTime();
                        const newItems = [];
                        $.each(newGroups, (i, item) => {
                            const newVariants = item.variants
                                .filter(v => new App.XDate(App.parseIsoDate(v.legs[0].segments[0].date))
                                .trimTime()
                                .getTime() === dynamicDepartureDate);
                            if (newVariants.length > 0) {
                                const newItem = item;
                                newItem.variants = newVariants;
                                newItems.push(newItem);
                            }
                        });
                        newGroups = newItems;
                    }
                    break;
                }
                case HotFilterBlockName[HotFilterBlockName.departureRange]: {
                    const control = filter;
                    const range = control.getValues();
                    const newItems = [];
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants.filter(variant => variant.departureTotalMinutes >= range[0]
                            && variant.departureTotalMinutes <= range[1]);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                        newGroups = newItems;
                    });
                    break;
                }
                case HotFilterBlockName[HotFilterBlockName.arrivalRange]: {
                    const control = filter;
                    const range = control.getValues();
                    const newItems = [];
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants.filter(variant => variant.arrivalTotalMinutes >= range[0]
                            && variant.arrivalTotalMinutes <= range[1]);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                        newGroups = newItems;
                    });
                    break;
                }
                case HotFilterBlockName[HotFilterBlockName.backDepartureRange]: {
                    const control = filter;
                    const range = control.getValues();
                    const newItems = [];
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants.filter(variant => variant.backDepartureTotalMinutes >= range[0]
                            && variant.backDepartureTotalMinutes <= range[1]);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                        newGroups = newItems;
                    });
                    break;
                }
                case HotFilterBlockName[HotFilterBlockName.backArrivalRange]: {
                    const control = filter;
                    const range = control.getValues();
                    const newItems = [];
                    $.each(newGroups, (i, item) => {
                        const newVariants = item.variants.filter(variant => variant.backArrivalTotalMinutes >= range[0]
                            && variant.backArrivalTotalMinutes <= range[1]);
                        if (newVariants.length > 0) {
                            const newItem = item;
                            newItem.variants = newVariants;
                            newItems.push(newItem);
                        }
                        newGroups = newItems;
                    });
                    break;
                }
                default:
                    break;
            }
        });
        $.each(newGroups, (index, el) => {
            if (el.variants.length > 1)
                el.hasMoreVariants = true;
            else
                el.hasMoreVariants = false;
        });
        __classPrivateFieldSet(this, _AviaHotFilter_result, newGroups, "f");
        if (fireEvent)
            this.root.trigger("hotfilter:change" /* Events.HotFilterChange */, [newGroups]);
    }, _AviaHotFilter_containsGroup = function _AviaHotFilter_containsGroup(carrier, marketingAirlines, brandIds) {
        if (!carrier.includes(':'))
            return marketingAirlines.includes(carrier);
        const carrierAndBrand = carrier.split(':');
        return marketingAirlines.includes(carrierAndBrand[0]) && brandIds.includes(carrierAndBrand[1]);
    };
    App.AviaHotFilter = AviaHotFilter;
})(App || (App = {}));
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
var App;
(function (App) {
    var _AviaMainFilterMobile_instances, _a, _AviaMainFilterMobile_options, _AviaMainFilterMobile_othMaxDays, _AviaMainFilterMobile_roudTripDatesDiff, _AviaMainFilterMobile_tab, _AviaMainFilterMobile_tabWrap, _AviaMainFilterMobile_forms, _AviaMainFilterMobile_currentForm, _AviaMainFilterMobile_commonForm, _AviaMainFilterMobile_filterBackOnewayOnly, _AviaMainFilterMobile_filterBackOnly, _AviaMainFilterMobile_filterRouteComposite, _AviaMainFilterMobile_addRouteBtn, _AviaMainFilterMobile_filterRadioBtn, _AviaMainFilterMobile_newRowTemplate, _AviaMainFilterMobile_setCurrentForm, _AviaMainFilterMobile_onAutocompleteOptionClick, _AviaMainFilterMobile_setNextCompositeLocation, _AviaMainFilterMobile_copyPoints, _AviaMainFilterMobile_togglePoints, _AviaMainFilterMobile_flightTypeClick, _AviaMainFilterMobile_tuneTabs, _AviaMainFilterMobile_tuneTabInputs, _AviaMainFilterMobile_onAdultChange, _AviaMainFilterMobile_onNotAdultChange, _AviaMainFilterMobile_recalcPassengers, _AviaMainFilterMobile_getJelectValue, _AviaMainFilterMobile_setOptions, _AviaMainFilterMobile_resetCalendars, _AviaMainFilterMobile_resetAviaCompany, _AviaMainFilterMobile_onChangeRoudTripDateDepart, _AviaMainFilterMobile_onChangeRoudTripDateArrive, _AviaMainFilterMobile_calcRoudTripDatesDiff, _AviaMainFilterMobile_onChangeCompositeDate, _AviaMainFilterMobile_calcCompositeCompositeDatesDiff, _AviaMainFilterMobile_onChangeCompositeArrive, _AviaMainFilterMobile_addRouteRow, _AviaMainFilterMobile_removeRouteRow, _AviaMainFilterMobile_changeSearchType, _AviaMainFilterMobile_onSearch;
    class AviaMainFilterMobile extends App.MainFilterMobile {
        constructor(options) {
            var _b;
            super(Object.assign({ filtersRoot: '.js-filter-top', onFilterChanged: v => this.onFilterChangedByOptions(v) }, options));
            _AviaMainFilterMobile_instances.add(this);
            _AviaMainFilterMobile_options.set(this, void 0);
            // на один меньше, чем макс.дата сегмента OTH.
            _AviaMainFilterMobile_othMaxDays.set(this, 359);
            // разница в днях между вылетом и прилетом в RT
            _AviaMainFilterMobile_roudTripDatesDiff.set(this, 1);
            // #aviaCompanyDefaultText: string;
            // TODO: использовать контрол Tabs или создать его наследника
            _AviaMainFilterMobile_tab.set(this, void 0);
            _AviaMainFilterMobile_tabWrap.set(this, void 0);
            // #tripType: JQuery;
            _AviaMainFilterMobile_forms.set(this, {});
            _AviaMainFilterMobile_currentForm.set(this, void 0);
            _AviaMainFilterMobile_commonForm.set(this, void 0);
            _AviaMainFilterMobile_filterBackOnewayOnly.set(this, void 0);
            _AviaMainFilterMobile_filterBackOnly.set(this, void 0);
            // #aviaCompanyBlock: JQuery;
            // #aviaCompanyInput: JQuery;
            // #aviaCompanyResults: JQuery;
            // #aviaCompanyInputCodes: JQuery;
            // #aviaCompanyPlaceholder: JQuery;
            // #aviaCompanyAutocomplete: JQuery;
            // #class: FilterSelectBlock;
            // #adults: FilterSelectBlock;
            // #children: FilterSelectBlock;
            // #handinfants: FilterSelectBlock;
            // #infants: FilterSelectBlock;
            // #filterSlidingBtn: JQuery;
            _AviaMainFilterMobile_filterRouteComposite.set(this, void 0);
            _AviaMainFilterMobile_addRouteBtn.set(this, void 0);
            _AviaMainFilterMobile_filterRadioBtn.set(this, void 0);
            _AviaMainFilterMobile_newRowTemplate.set(this, void 0);
            __classPrivateFieldSet(this, _AviaMainFilterMobile_options, options, "f");
            if (!this.root.length)
                return;
            // this.#aviaCompanyDefaultText = 'Любая';
            // тип перелета
            __classPrivateFieldSet(this, _AviaMainFilterMobile_tab, $('.js-tab', this.root), "f");
            __classPrivateFieldSet(this, _AviaMainFilterMobile_tabWrap, $('.js-tab-wrap', this.root), "f");
            // формы
            __classPrivateFieldGet(this, _AviaMainFilterMobile_tabWrap, "f").each((i, v) => {
                const $t = $(v);
                const k = $t.attr('data-tab') || 'noname';
                __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f")[k] = new App.AviaFormMobile(k, { root: $t, ignoreValidator: true });
            });
            __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_setCurrentForm).call(this);
            __classPrivateFieldSet(this, _AviaMainFilterMobile_commonForm, new App.AviaFormMobile('Common', { root: $('.js-common-form', this.root) }), "f");
            __classPrivateFieldSet(this, _AviaMainFilterMobile_filterBackOnewayOnly, $('.js-filter-back-oneway-only', this.root), "f");
            __classPrivateFieldSet(this, _AviaMainFilterMobile_filterBackOnly, $('.js-filter-back-only', this.root), "f");
            __classPrivateFieldGet(this, _AviaMainFilterMobile_tab, "f").on('click', e => __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_flightTypeClick).call(this, e));
            __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_tuneTabs).call(this);
            // this.#tripType = $('.js-flight-type', this.root);
            $('.js-filter-toggle-points', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_togglePoints).call(_a, e));
            const today = new Date();
            let minDate = today;
            if (__classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").minStartDate && minDate < __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").minStartDate)
                minDate = __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").minStartDate;
            // const minDays = Math.max(Math.ceil((minDate.getTime() - today.getTime()) / App.millisecondsPerDay), 0);
            const othMaxDate = App.addDays(today, __classPrivateFieldGet(this, _AviaMainFilterMobile_othMaxDays, "f"));
            let maxDate = othMaxDate;
            if (__classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").maxStartDate && maxDate > __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").maxStartDate)
                maxDate = __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").maxStartDate;
            // const maxDays = Math.min(Math.ceil((maxDate.getTime() - today.getTime()) / App.millisecondsPerDay), this.#othMaxDays);
            // RT
            /*
            const datesFilter = this.findControl<FilterDatesBlock>('dates');
            if (datesFilter) {
                datesFilter.setOptions({ minDateFromShift: minDays, maxDateFromShift: maxDays, absoluteMaxDateToOffset: maxDays });
            }*/
            if (__classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").RoundTrip) {
                const datesFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").RoundTrip.filters.filterControls('', '.Date');
                if (datesFilter && datesFilter.length > 0) {
                    datesFilter.forEach(dt => {
                        dt.setMinDate(minDate);
                        dt.setMaxDate(maxDate);
                    });
                }
                // разница в днях между Вылетом и Прилетом
                __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_calcRoudTripDatesDiff).call(this);
            }
            // OW
            /*
            const dateFilter = this.findControl<FilterDateBlock>('date');
            if (dateFilter) {
                dateFilter.setOptions({ minDate: minDate, maxDate: maxDate });
            }
            */
            if (__classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").OneWay) {
                const datesFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").OneWay.filters.filterControls('', '.Date.OneWay');
                if (datesFilter && datesFilter.length > 0) {
                    datesFilter.forEach(dt => {
                        dt.setMinDate(minDate);
                        dt.setMaxDate(maxDate);
                    });
                }
            }
            minDate = today;
            // Comby
            // Выставляем минимальные даты для комбинированного перелета
            if (__classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite) {
                // first line
                if (__classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").minStartDate && __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").minStartDate > minDate)
                    minDate = __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").minStartDate;
                if (__classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").maxStartDate && __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").maxStartDate < maxDate)
                    maxDate = __classPrivateFieldGet(this, _AviaMainFilterMobile_options, "f").maxStartDate;
                else
                    maxDate = App.addDays(today, __classPrivateFieldGet(this, _AviaMainFilterMobile_othMaxDays, "f"));
                const datesFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.filterControls('', '[0].Date.CompositeExtraKey');
                if (datesFilter && datesFilter.length > 0) {
                    datesFilter.forEach(dt => {
                        dt.setMinDate(minDate);
                        dt.setMaxDate(maxDate);
                    });
                }
                // other lines
                minDate = App.addDays(minDate, 7);
                maxDate = App.addDays(today, __classPrivateFieldGet(this, _AviaMainFilterMobile_othMaxDays, "f"));
                const datesOtherFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.filterControls('', '.Date.CompositeExtraKey', '', '[0].Date.CompositeExtraKey');
                if (datesOtherFilter && datesOtherFilter.length > 0) {
                    datesOtherFilter.forEach(dt => {
                        dt.setMinDate(minDate);
                        dt.setMaxDate(maxDate);
                    });
                }
                //
                __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_calcCompositeCompositeDatesDiff).call(this);
            }
            __classPrivateFieldSet(this, _AviaMainFilterMobile_addRouteBtn, $('.js-avia-filter-route-add', this.root), "f");
            __classPrivateFieldGet(this, _AviaMainFilterMobile_addRouteBtn, "f").on('click', e => __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_addRouteRow).call(this, e));
            __classPrivateFieldSet(this, _AviaMainFilterMobile_filterRouteComposite, $('.js-filter-route-composite', this.root), "f");
            $('.js-avia-filter-route-remove', __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f")).on('click', e => __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_removeRouteRow).call(this, e));
            __classPrivateFieldSet(this, _AviaMainFilterMobile_newRowTemplate, App.findTemplate((_b = this.root.attr('data-newrow-template')) !== null && _b !== void 0 ? _b : ''), "f");
            // airlines maps
            const filterAirlines = __classPrivateFieldGet(this, _AviaMainFilterMobile_commonForm, "f").filters.findControl('Form.Airlines');
            if (filterAirlines) {
                _a.mapAirlinesResponseModel(filterAirlines);
            }
            __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_recalcPassengers).call(this);
            // чтобы в а/к было дефолтное название.
            $('html').trigger('click');
            __classPrivateFieldSet(this, _AviaMainFilterMobile_filterRadioBtn, $('.js-filter-radio-btn-flight-type', this.root), "f");
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRadioBtn, "f").on('click', e => __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_changeSearchType).call(this, e));
            this.root.on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, e => __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onAutocompleteOptionClick).call(this, e));
            this.root.on('click', '.js-m-filter-submit', e => __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onSearch).call(this, e));
            // чтобы дефолтное
            this.reset();
        }
        onFilterChangedByOptions(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!filterName)
                    return;
                // console.log('onFilterChangedByOptions:: ' + filterName);
                // смена даты Вылета в ТудаОбратно
                if (filterName.endsWith('[0].Date'))
                    __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onChangeRoudTripDateDepart).call(this, filterName);
                // смена даты Прилета в ТудаОбратно
                if (filterName.endsWith('[1].Date'))
                    __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onChangeRoudTripDateArrive).call(this);
                // смена даты Сложного маршрута
                if (filterName.endsWith('.Date.CompositeExtraKey'))
                    __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onChangeCompositeDate).call(this);
                // смена Куда в Сложном маршруте
                if (filterName.endsWith('.ArrivalLocation.CompositeExtraKey'))
                    __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onChangeCompositeArrive).call(this, filterName);
                // смена взрослых и детей
                if (filterName == 'Form.Adult')
                    __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onAdultChange).call(this, filterName);
                else if (filterName == 'Form.Child' || filterName == 'Form.HandInfant' || filterName == 'Form.Infant')
                    __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_onNotAdultChange).call(this);
            });
        }
        static mapAirlinesResponseModel(filterAirlines) {
            if (!filterAirlines)
                return;
            filterAirlines.setMapDataToItems((response) => {
                if (!response)
                    return [];
                const d = response;
                if (!Array.isArray(d.data))
                    return [];
                const items = d.data.map(item => ({
                    original: Object.assign({}, item),
                    value: item[0],
                    name: `${item[0]} ${item[1]}`,
                    label: `${item[0]} ${item[1]}`,
                    isGroup: false,
                }));
                return items;
            });
        }
        getCurrentForm() {
            return __classPrivateFieldGet(this, _AviaMainFilterMobile_currentForm, "f");
        }
        getTripType() {
            const filterValue = PwStore.GetFilter('Form.Type');
            return App.AviaTripType[filterValue];
        }
        isDirect() {
            return this.filters.getControlValue('Form.Direct');
        }
        /*
        static #getJelectValue(item: JQuery<unknown>): number {
            return $('.js-jelect-input', item).valNumber() || 0;
        }

        static #setOptions(selector: JQuery, count: number): void {
            $.each($('.js-filter-option', selector), (index, item) => {
                AviaMainFilterMobile.#setOptionVisibility($(item), count < parseInt($(item).attr('data-val') ?? '0', 10));
            });
        }

        static #setOptionVisibility(option: JQuery, hide: boolean): void {
            if (hide) {
                option.hide();
                option.prop('disabled', true);
            } else {
                option.show();
                option.prop('disabled', false);
            }
        }
        */
        reset() {
            // не нужен базовый резет, т.к. очищаются списки.
            // super.reset();
            __classPrivateFieldGet(this, _AviaMainFilterMobile_tab, "f").eq(0).trigger('click');
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRadioBtn, "f").eq(0).trigger('click');
            // this.#filterSlidingBtn.removeClass('_on').addClass('_off');
            __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_resetCalendars).call(_a);
            __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_resetAviaCompany).call(this);
            // PwStore.ResetAllFilters();
            PwStore.SetFilterOptionsChecked('Form.Class', '');
            PwStore.SetFilterOptionsChecked('Form.Adult', '1');
            PwStore.SetFilterOptionsChecked('Form.Child', '0');
            PwStore.SetFilterOptionsChecked('Form.HandInfant', '0');
            PwStore.SetFilterOptionsChecked('Form.Infant', '0');
            /*
            $('.js-point-select-input', this.root)
                .each((i, el) => {
                    $(el).val('');
                });

            $('.js-point-code', this.root)
                .each((i, el) => {
                    $(el).val('');
                });

            $('.js-filter-route-row', this.#filterRouteComposite)
                .each((i, el) => {
                    const jqElement = $(el);
                    const row = jqElement.attr('data-row');
                    if (row && parseInt(row, 10) > 2)
                        jqElement.remove();
                });
            */
        }
        search(newSearch) {
            const elements = __classPrivateFieldGet(this, _AviaMainFilterMobile_currentForm, "f").serializeArray().concat(__classPrivateFieldGet(this, _AviaMainFilterMobile_commonForm, "f").serializeArray());
            const data = {};
            $.each(elements, (i, item) => {
                let itemName = item.name;
                // удаляем служебные префиксы из ключей фильтров
                if (itemName.endsWith('.OneWay'))
                    itemName = itemName.slice(0, itemName.length - '.OneWay'.length);
                else if (itemName.endsWith('.CompositeExtraKey'))
                    itemName = itemName.slice(0, itemName.length - '.CompositeExtraKey'.length);
                // set
                data[itemName] = item.value.includes(',') ? item.value.split(',') : item.value;
            });
            // чтобы очищались groupKey & variantKey
            if (newSearch === true)
                data.newSearch = 'true';
            // TODO: переделать на событие экземпляра текущего класса.
            this.root.trigger("filter:search" /* Events.FilterSearch */, [data]);
        }
    }
    _a = AviaMainFilterMobile, _AviaMainFilterMobile_options = new WeakMap(), _AviaMainFilterMobile_othMaxDays = new WeakMap(), _AviaMainFilterMobile_roudTripDatesDiff = new WeakMap(), _AviaMainFilterMobile_tab = new WeakMap(), _AviaMainFilterMobile_tabWrap = new WeakMap(), _AviaMainFilterMobile_forms = new WeakMap(), _AviaMainFilterMobile_currentForm = new WeakMap(), _AviaMainFilterMobile_commonForm = new WeakMap(), _AviaMainFilterMobile_filterBackOnewayOnly = new WeakMap(), _AviaMainFilterMobile_filterBackOnly = new WeakMap(), _AviaMainFilterMobile_filterRouteComposite = new WeakMap(), _AviaMainFilterMobile_addRouteBtn = new WeakMap(), _AviaMainFilterMobile_filterRadioBtn = new WeakMap(), _AviaMainFilterMobile_newRowTemplate = new WeakMap(), _AviaMainFilterMobile_instances = new WeakSet(), _AviaMainFilterMobile_setCurrentForm = function _AviaMainFilterMobile_setCurrentForm() {
        const tab = __classPrivateFieldGet(this, _AviaMainFilterMobile_tab, "f").filter('._active').attr('data-tab');
        if (tab) {
            // this.#currentForm = this.#tabWrap.filter(`[data-tab="${tab}"]`).find('form').first();
            __classPrivateFieldSet(this, _AviaMainFilterMobile_currentForm, __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f")[tab], "f");
            // set filter
            PwStore.ChangeFilter('Form.Type', tab);
        }
    }, _AviaMainFilterMobile_onAutocompleteOptionClick = function _AviaMainFilterMobile_onAutocompleteOptionClick(event) {
        // TODO: сделать то же самое при переходе по табуляции
        const self = $(event.target);
        const tab = self.closest('.js-tab-wrap');
        if (tab.data('tab') === 'Composite') {
            __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_setNextCompositeLocation).call(_a, self);
            return;
        }
        __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_copyPoints).call(this, self);
    }, _AviaMainFilterMobile_setNextCompositeLocation = function _AviaMainFilterMobile_setNextCompositeLocation(self) {
        const tab = self.closest('.js-tab-wrap');
        if (tab.data('tab') !== 'Composite')
            return;
        if (!self.hasClass('_to'))
            return;
        // TODO: to MOBILE
        const legSelector = '.js-filter-route-row';
        const legDepartureLocation = 'input.js-point-select-input';
        const legDepartureCode = 'input.js-point-code';
        const nextLeg = self.closest(legSelector).nextAll(`${legSelector}:first`).find('._from');
        const nextLegLocation = nextLeg.find(legDepartureLocation);
        const nextLegCode = nextLeg.find(legDepartureCode);
        if (nextLegLocation.val() === '' || nextLegCode.val() === '') {
            nextLegLocation.val($(self.find(legDepartureLocation)[0]).val() || '');
            nextLegCode.val($(self.find(legDepartureCode)[0]).val() || '');
        }
    }, _AviaMainFilterMobile_copyPoints = function _AviaMainFilterMobile_copyPoints(self) {
        // TODO: to MOBILE
        const tabWrap = '.js-tab-wrap';
        const block = `.js-filter-autocomplete-block.${self.hasClass('_to') ? '_to' : '_from'}`;
        const text = '.js-point-select-input';
        const code = '.js-point-code';
        const tab = self.closest(tabWrap);
        let toTab;
        if (tab.data('tab') === 'OneWay')
            toTab = $(tabWrap, this.root).filter('[data-tab="RoundTrip"]');
        else
            toTab = $(tabWrap, this.root).filter('[data-tab="OneWay"]');
        toTab.find(block).find(text).val(tab.find(block).find(text).val() || '');
        toTab.find(block).find(code).val(tab.find(block).find(code).val() || '');
    }, _AviaMainFilterMobile_togglePoints = function _AviaMainFilterMobile_togglePoints(event) {
        const target = $(event.currentTarget);
        const pname1 = target.attr('data-swap-p1');
        const pname2 = target.attr('data-swap-p2');
        if (!pname1 || !pname2)
            return;
        // NOTE: имена в разных вкладках (RT, OW) совпадают - смена будет во всех вкладках
        const p1 = PwStore.GetFilterItem(pname1, false);
        const p2 = PwStore.GetFilterItem(pname2, false);
        PwStore.SetFilter(pname2, p1 ? [p1] : [], false);
        PwStore.SetFilter(pname1, p2 ? [p2] : [], false);
    }, _AviaMainFilterMobile_flightTypeClick = function _AviaMainFilterMobile_flightTypeClick(event) {
        const self = $(event.currentTarget);
        const isActive = self.hasClass('_active');
        const flightType = self.attr('data-tab');
        if (!flightType)
            return;
        // this.#tripType.val(flightType);
        // ? PwStore.ChangeFilter('Form.Type', flightType);
        if (!isActive) {
            self.siblings('.js-tab').removeClass('_active');
            self.addClass('_active');
            __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_setCurrentForm).call(this);
            __classPrivateFieldGet(this, _AviaMainFilterMobile_tabWrap, "f").hide();
            __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_tuneTabInputs).call(this, flightType);
        }
    }, _AviaMainFilterMobile_tuneTabs = function _AviaMainFilterMobile_tuneTabs() {
        __classPrivateFieldGet(this, _AviaMainFilterMobile_tab, "f").filter('._active').each((i, v) => { var _b; return __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_tuneTabInputs).call(this, (_b = $(v).attr('data-tab')) !== null && _b !== void 0 ? _b : ''); });
    }, _AviaMainFilterMobile_tuneTabInputs = function _AviaMainFilterMobile_tuneTabInputs(flightType) {
        __classPrivateFieldGet(this, _AviaMainFilterMobile_tabWrap, "f").filter(`[data-tab='${flightType}']`).fadeIn();
        if (flightType === 'RoundTrip') {
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterBackOnewayOnly, "f").show();
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterBackOnly, "f").show();
        }
        else if (flightType === 'OneWay') {
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterBackOnewayOnly, "f").show();
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterBackOnly, "f").hide();
        }
        else if (flightType === 'Composite') {
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterBackOnewayOnly, "f").hide();
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterBackOnly, "f").hide();
        }
    }, _AviaMainFilterMobile_onAdultChange = function _AviaMainFilterMobile_onAdultChange(filterName) {
        __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_recalcPassengers).call(this);
        const value = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, filterName);
        const handInfantValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.HandInfant');
        const infantValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.Infant');
        const childValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.Child');
        if (handInfantValue > value)
            PwStore.SetFilterOptionsChecked('Form.HandInfant', value.toString());
        if (infantValue > value)
            PwStore.SetFilterOptionsChecked('Form.Infant', value.toString());
        if (value === 0 && childValue === 0)
            PwStore.SetFilterOptionsChecked('Form.Child', '1');
    }, _AviaMainFilterMobile_onNotAdultChange = function _AviaMainFilterMobile_onNotAdultChange() {
        const adultValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.Adult');
        const childValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.Child');
        if (adultValue === 0 && childValue === 0)
            PwStore.SetFilterOptionsChecked('Form.Adult', '1');
        __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_recalcPassengers).call(this);
    }, _AviaMainFilterMobile_recalcPassengers = function _AviaMainFilterMobile_recalcPassengers() {
        const adultVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.Adult');
        const childVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.Child');
        const handinfantVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.HandInfant');
        const infantVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_getJelectValue).call(_a, 'Form.Infant');
        const maxPeopleCount = 9;
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_setOptions).call(_a, 'Form.Adult', maxPeopleCount - childVal - handinfantVal - infantVal);
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_setOptions).call(_a, 'Form.Child', maxPeopleCount - adultVal - handinfantVal - infantVal);
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_setOptions).call(_a, 'Form.HandInfant', Math.min(adultVal, maxPeopleCount - adultVal - childVal - infantVal));
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_setOptions).call(_a, 'Form.Infant', Math.min(adultVal, maxPeopleCount - adultVal - childVal - handinfantVal));
    }, _AviaMainFilterMobile_getJelectValue = function _AviaMainFilterMobile_getJelectValue(filterName, defaultNumber = 0) {
        const filterItem = PwStore.GetFilterItem(filterName);
        if (!filterItem)
            return defaultNumber;
        const filterProps = filterItem;
        if (!filterProps.value)
            return defaultNumber;
        return parseInt(filterProps.value, 10);
    }, _AviaMainFilterMobile_setOptions = function _AviaMainFilterMobile_setOptions(filterName, count) {
        const filterItems = PwStore.GetFilterDefault(filterName);
        if (!filterItems)
            return;
        // включаем все обратно
        const filtersOn = [];
        filterItems.forEach(i => filtersOn.push(i.value.toString()));
        PwStore.SetFilterOptionsVisible(filterName, false, filtersOn);
        // выключаем
        const filtersOff = [];
        filterItems.forEach(i => {
            if (count < parseInt(i.value, 10))
                filtersOff.push(i.value.toString());
        });
        if (filtersOff && filtersOff.length > 0) {
            PwStore.SetFilterOptionsVisible(filterName, true, filtersOff);
            // выбираем наименьший доступный, если выбранный стал скрытым
            const minOff = parseInt(filtersOff[0], 10);
            const current = PwStore.GetFilterItem(filterName);
            if (!current || parseInt(current.value, 10) >= minOff) {
                if (minOff > 0)
                    PwStore.SetFilterOptionsChecked(filterName, (minOff - 1).toString(), false, false);
            }
        }
    }, _AviaMainFilterMobile_resetCalendars = function _AviaMainFilterMobile_resetCalendars() {
        /* TODO
        $date_to.datepicker('option', 'minDate', +1);

        $date_from.datepicker('setDate', +1);
        $date_to.datepicker('option', 'minDate', +1);
        $date_to.datepicker('setDate', +15);*/
    }, _AviaMainFilterMobile_resetAviaCompany = function _AviaMainFilterMobile_resetAviaCompany() {
        // this.#aviaCompanyBlock.find('.js-avia-company-selected-item').remove();
        // this.#aviaCompanyInputCodes.val('');
        // this.#aviaCompanyInput.val(this.#aviaCompanyDefaultText);
        PwStore.SetFilter('Form.Airlines', []);
    }, _AviaMainFilterMobile_onChangeRoudTripDateDepart = function _AviaMainFilterMobile_onChangeRoudTripDateDepart(filterDepartName) {
        const dateDepartFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").RoundTrip.filters.findControl(filterDepartName);
        const filterArriveName = filterDepartName.replace('[0]', '[1]');
        const dateArriveFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").RoundTrip.filters.findControl(filterArriveName);
        if (dateDepartFilter && dateArriveFilter && dateDepartFilter.getValue()) {
            const dateFrom = dateDepartFilter.getValue();
            dateArriveFilter.setMinDate(dateFrom);
            dateArriveFilter.setValueAndAddDays(dateFrom, __classPrivateFieldGet(this, _AviaMainFilterMobile_roudTripDatesDiff, "f"), true);
        }
    }, _AviaMainFilterMobile_onChangeRoudTripDateArrive = function _AviaMainFilterMobile_onChangeRoudTripDateArrive() {
        __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_calcRoudTripDatesDiff).call(this);
    }, _AviaMainFilterMobile_calcRoudTripDatesDiff = function _AviaMainFilterMobile_calcRoudTripDatesDiff() {
        var _b, _c;
        const d0 = (_b = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").RoundTrip.filters.findControl('form.Route[0].Date')) === null || _b === void 0 ? void 0 : _b.getValueOrigin();
        const d1 = (_c = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").RoundTrip.filters.findControl('form.Route[1].Date')) === null || _c === void 0 ? void 0 : _c.getValueOrigin();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        __classPrivateFieldSet(this, _AviaMainFilterMobile_roudTripDatesDiff, App.MobileFilterDateBlock.getDaysDiff(d0, d1), "f");
    }, _AviaMainFilterMobile_onChangeCompositeDate = function _AviaMainFilterMobile_onChangeCompositeDate() {
        __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_calcCompositeCompositeDatesDiff).call(this);
    }, _AviaMainFilterMobile_calcCompositeCompositeDatesDiff = function _AviaMainFilterMobile_calcCompositeCompositeDatesDiff() {
        const triggerFlag = false; // без триггера, т.к. событие при смене значения
        const datesFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.filterControls('', '.Date.CompositeExtraKey');
        // каждая последующая "линия" даты не должна быть меньше предыдущей
        if (datesFilter && datesFilter.length > 0) {
            let minDate;
            // перебираем все "линии" дат по порядку
            datesFilter.sort((a, b) => a.name.localeCompare(b.name)).forEach(d => {
                if (!minDate) {
                    minDate = d.getValue();
                }
                else {
                    if (!d.getValue()) {
                        d.setMinDate(minDate, 0, triggerFlag);
                        d.setValue(minDate, triggerFlag);
                    }
                    else {
                        const date = d.getValue();
                        // если дата контрола меньше минимальной
                        if (date < minDate) {
                            d.setMinDate(minDate, 0, triggerFlag);
                            d.setValue(minDate, triggerFlag);
                        }
                        else { // если дата контрола больше минимальной
                            d.setMinDate(minDate, 0, triggerFlag);
                            // для следующей "линии" даты минимальную смещаем на нашу
                            minDate = d.getValue();
                        }
                    }
                }
            });
        }
    }, _AviaMainFilterMobile_onChangeCompositeArrive = function _AviaMainFilterMobile_onChangeCompositeArrive(filterName) {
        // если в следующем маршруте ("линии") не указано Откуда, то проставляем наше значение (от прошлой Куда)
        const arriveFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.findControl(filterName);
        // узнаем свой текущий индекс из названия поля
        const indexStr = filterName.slice(filterName.indexOf('[') + 1, filterName.lastIndexOf(']'));
        const indexNum = parseInt(indexStr, 10);
        // узнаем индекс следующего поля
        let filterDepartName = filterName.replace('[' + indexStr + ']', '[' + (indexNum + 1).toString() + ']');
        filterDepartName = filterDepartName.replace('.ArrivalLocation', '.DepartureLocation');
        // устанавливаем
        const departFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.findControl(filterDepartName);
        if (departFilter && !departFilter.getValue() && arriveFilter && arriveFilter.getValue()) {
            const p1 = arriveFilter.getValue();
            departFilter.setValue(p1);
        }
    }, _AviaMainFilterMobile_addRouteRow = function _AviaMainFilterMobile_addRouteRow(event) {
        const target = $(event.currentTarget);
        const type = target.attr('data-type');
        const legSelector = '.js-filter-route-row';
        let filterRouteRows = $(legSelector, __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f"));
        const rowsCount = filterRouteRows.length;
        if (rowsCount >= 8)
            return false;
        const firstRow = filterRouteRows.first();
        const firstRow_Index = parseInt(firstRow.attr('data-row') || '0', 10);
        const firstDepartName = 'form.Route[' + (firstRow_Index).toString() + '].DepartureLocation.CompositeExtraKey';
        // const firstArriveName = 'form.Route[' + (firstRow_Index).toString() + '].ArrivalLocation.CompositeExtraKey';
        const lastRow = filterRouteRows.last();
        const lastRow_Index = parseInt(lastRow.attr('data-row') || '0', 10);
        // const lastDepartName = 'form.Route[' + (lastRow_Index).toString() + '].DepartureLocation.CompositeExtraKey';
        const lastArriveName = 'form.Route[' + (lastRow_Index).toString() + '].ArrivalLocation.CompositeExtraKey';
        // -- вставляем в разметку новые контролы --
        __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f").append(__classPrivateFieldGet(this, _AviaMainFilterMobile_newRowTemplate, "f").call(this, {
            'index': rowsCount,
        }));
        filterRouteRows = $(legSelector, __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f"));
        const newLastRow = filterRouteRows.last();
        const newLastRow_Index = parseInt(newLastRow.attr('data-row') || '0', 10);
        $('.js-avia-filter-route-remove', newLastRow).on('click', e => __classPrivateFieldGet(this, _AviaMainFilterMobile_instances, "m", _AviaMainFilterMobile_removeRouteRow).call(this, e));
        $('.js-filter-toggle-points', newLastRow).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaMainFilterMobile_togglePoints).call(_a, e));
        // инициализация новых контролов в разметке
        __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.addControls(newLastRow);
        // -- города вылета/прилета --
        const newDepartName = 'form.Route[' + (newLastRow_Index).toString() + '].DepartureLocation.CompositeExtraKey';
        const newArriveName = 'form.Route[' + (newLastRow_Index).toString() + '].ArrivalLocation.CompositeExtraKey';
        if (newLastRow_Index == 0) {
            const p1 = PwStore.GetFilterItem(lastArriveName, false);
            PwStore.SetFilter(newArriveName, p1 ? [p1] : [], false);
        }
        else if (type === 'close') {
            const p1 = PwStore.GetFilterItem(firstDepartName, false);
            const p2 = PwStore.GetFilterItem(lastArriveName, false);
            PwStore.SetFilter(newDepartName, p2 ? [p2] : [], false);
            PwStore.SetFilter(newArriveName, p1 ? [p1] : [], false);
        }
        else {
            const p1 = PwStore.GetFilterItem(lastArriveName, false);
            PwStore.SetFilter(newDepartName, p1 ? [p1] : [], false);
        }
        // -- даты --
        let lastDate = new Date();
        // достаем дату от последней "линии"
        const lastDateName = 'form.Route[' + (rowsCount - 1).toString() + '].Date.CompositeExtraKey';
        const lastDateFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.findControl(lastDateName);
        if (lastDateFilter)
            lastDate = lastDateFilter.getValue() || lastDate;
        const today = new Date();
        let minDate = today;
        if (lastDate)
            minDate = new Date(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate());
        // ставим дату к новой "линии"
        const newDateName = 'form.Route[' + (rowsCount).toString() + '].Date.CompositeExtraKey';
        const newDateFilter = __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.findControl(newDateName);
        if (newDateFilter)
            newDateFilter.setValueAndAddDays(minDate, 7);
        // $('.js-filter-date', newDateBlock.root).on('change', e => this.#onChangeCompositeDate(e));
        $('.js-avia-filter-route-remove').toggle(__classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f").find(legSelector).length > 1);
        return true;
    }, _AviaMainFilterMobile_removeRouteRow = function _AviaMainFilterMobile_removeRouteRow(event) {
        var _b;
        const self = $(event.currentTarget);
        const legSelector = '.js-filter-route-row';
        const parent = $(self).closest(legSelector);
        const idx = parseInt((_b = parent.attr('data-row')) !== null && _b !== void 0 ? _b : '0', 10);
        if (idx < __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f").find(legSelector).length) {
            // Если есть плечи под ней, то идем по всем видимым строкам и переписываем значения из каждой следующей строки в
            // предыдущую, а последнюю скрываем.
            __classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f").find(legSelector).each((_, item) => {
                var _b, _c;
                const jqItem = $(item);
                const index = parseInt((_b = jqItem.attr('data-row')) !== null && _b !== void 0 ? _b : '0', 10);
                if (index >= idx) {
                    const nextItem = jqItem.nextAll(legSelector).filter(':first');
                    if (nextItem) {
                        const nextIndex = parseInt((_c = nextItem.attr('data-row')) !== null && _c !== void 0 ? _c : '0', 10);
                        // get values from next line
                        const nextValueDepart = PwStore.GetFilterItems('form.Route[' + nextIndex + '].DepartureLocation.CompositeExtraKey', false);
                        const nextValueArrive = PwStore.GetFilterItems('form.Route[' + nextIndex + '].ArrivalLocation.CompositeExtraKey', false);
                        const nextValueDate = PwStore.GetFilter('form.Route[' + nextIndex + '].Date.CompositeExtraKey');
                        // set values to current line
                        PwStore.SetFilter('form.Route[' + index + '].DepartureLocation.CompositeExtraKey', nextValueDepart, false);
                        PwStore.SetFilter('form.Route[' + index + '].ArrivalLocation.CompositeExtraKey', nextValueArrive, false);
                        PwStore.SetFilter('form.Route[' + index + '].Date.CompositeExtraKey', nextValueDate, false);
                    }
                    else {
                        // jqItem.find('input').each((index2, value2) => {
                        // $(value2).val('');
                        // });
                    }
                }
            });
            // удаляем последнее плечо
            // this.#filterRouteComposite.find(legSelector).filter(':last').remove();
            __classPrivateFieldGet(this, _AviaMainFilterMobile_forms, "f").Composite.filters.removeControls(__classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f").find(legSelector).filter(':last'), true);
            $('.js-avia-filter-route-remove').toggle(__classPrivateFieldGet(this, _AviaMainFilterMobile_filterRouteComposite, "f").find(legSelector).length > 1);
        }
    }, _AviaMainFilterMobile_changeSearchType = function _AviaMainFilterMobile_changeSearchType(event) {
        event.preventDefault();
        const self = $(event.currentTarget);
        const wrapper = self.closest('.js-avia-filter-search-options');
        const input = wrapper.find('input');
        const id = self.attr('data-id');
        const typeBlock = wrapper.find('.js-filter-radio-btn-flight-type');
        typeBlock.removeClass('_on');
        input.val(id || 'Date');
        self.addClass('_on');
        // change filter
        const filterExtraKey = wrapper.attr('data-extra');
        PwStore.ChangeFilter('Form.By' + filterExtraKey, id);
        $('.js-matrix-info-block', self.closest('.js-avia-filter-search-options-block')).toggleClass('_dspn', id === 'Date');
    }, _AviaMainFilterMobile_onSearch = function _AviaMainFilterMobile_onSearch(e) {
        e.preventDefault();
        this.search(true);
    };
    App.AviaMainFilterMobile = AviaMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaMainFilter_instances, _a, _AviaMainFilter_options, _AviaMainFilter_othMaxDays, _AviaMainFilter_aviaCompanyDefaultText, _AviaMainFilter_tab, _AviaMainFilter_tabWrap, _AviaMainFilter_tripType, _AviaMainFilter_currentForm, _AviaMainFilter_commonForm, _AviaMainFilter_filterBackOnewayOnly, _AviaMainFilter_filterBackOnly, _AviaMainFilter_aviaCompanyBlock, _AviaMainFilter_aviaCompanyInput, _AviaMainFilter_aviaCompanyResults, _AviaMainFilter_aviaCompanyInputCodes, _AviaMainFilter_aviaCompanyPlaceholder, _AviaMainFilter_aviaCompanyAutocomplete, _AviaMainFilter_adults, _AviaMainFilter_children, _AviaMainFilter_handinfants, _AviaMainFilter_infants, _AviaMainFilter_infantsInfo, _AviaMainFilter_filterSlidingBtn, _AviaMainFilter_filterRouteComposite, _AviaMainFilter_addRouteBtn, _AviaMainFilter_filterRadioBtn, _AviaMainFilter_newRowTemplate, _AviaMainFilter_setCurrentForm, _AviaMainFilter_onAutocompleteOptionClick, _AviaMainFilter_setNextCompositeLocation, _AviaMainFilter_copyPoints, _AviaMainFilter_togglePoints, _AviaMainFilter_flightTypeClick, _AviaMainFilter_tuneTabs, _AviaMainFilter_tuneTabInputs, _AviaMainFilter_onDirectChange, _AviaMainFilter_onAviaCompanyFocus, _AviaMainFilter_onAviaCompanyChange, _AviaMainFilter_onAdultChange, _AviaMainFilter_onNotAdultChange, _AviaMainFilter_onInfantChange, _AviaMainFilter_recalcPassengers, _AviaMainFilter_getJelectValue, _AviaMainFilter_setOptions, _AviaMainFilter_setOptionVisibility, _AviaMainFilter_onGetIntoMilk, _AviaMainFilter_onAviaCompanyDelete, _AviaMainFilter_resetCalendars, _AviaMainFilter_resetAviaCompany, _AviaMainFilter_onChangeCompositeDate, _AviaMainFilter_addRouteRow, _AviaMainFilter_removeRouteRow, _AviaMainFilter_changeSearchType, _AviaMainFilter_onSearch;
    let AviaTripType;
    (function (AviaTripType) {
        AviaTripType[AviaTripType["RoundTrip"] = 0] = "RoundTrip";
        AviaTripType[AviaTripType["OneWay"] = 1] = "OneWay";
        AviaTripType[AviaTripType["Composite"] = 2] = "Composite";
    })(AviaTripType = App.AviaTripType || (App.AviaTripType = {}));
    class AviaMainFilter extends App.MainFilter {
        constructor(options) {
            var _b;
            super(options);
            _AviaMainFilter_instances.add(this);
            _AviaMainFilter_options.set(this, void 0);
            // на один меньше, чем макс.дата сегмента OTH.
            _AviaMainFilter_othMaxDays.set(this, 359);
            _AviaMainFilter_aviaCompanyDefaultText.set(this, void 0);
            // TODO: использовать контрол Tabs или создать его наследника
            _AviaMainFilter_tab.set(this, void 0);
            _AviaMainFilter_tabWrap.set(this, void 0);
            _AviaMainFilter_tripType.set(this, void 0);
            _AviaMainFilter_currentForm.set(this, void 0);
            _AviaMainFilter_commonForm.set(this, void 0);
            _AviaMainFilter_filterBackOnewayOnly.set(this, void 0);
            _AviaMainFilter_filterBackOnly.set(this, void 0);
            _AviaMainFilter_aviaCompanyBlock.set(this, void 0);
            _AviaMainFilter_aviaCompanyInput.set(this, void 0);
            _AviaMainFilter_aviaCompanyResults.set(this, void 0);
            _AviaMainFilter_aviaCompanyInputCodes.set(this, void 0);
            _AviaMainFilter_aviaCompanyPlaceholder.set(this, void 0);
            _AviaMainFilter_aviaCompanyAutocomplete.set(this, void 0);
            _AviaMainFilter_adults.set(this, void 0);
            _AviaMainFilter_children.set(this, void 0);
            _AviaMainFilter_handinfants.set(this, void 0);
            _AviaMainFilter_infants.set(this, void 0);
            _AviaMainFilter_infantsInfo.set(this, void 0);
            _AviaMainFilter_filterSlidingBtn.set(this, void 0);
            _AviaMainFilter_filterRouteComposite.set(this, void 0);
            _AviaMainFilter_addRouteBtn.set(this, void 0);
            _AviaMainFilter_filterRadioBtn.set(this, void 0);
            _AviaMainFilter_newRowTemplate.set(this, void 0);
            __classPrivateFieldSet(this, _AviaMainFilter_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _AviaMainFilter_aviaCompanyDefaultText, 'Любая', "f");
            // тип перелета
            __classPrivateFieldSet(this, _AviaMainFilter_tab, $('.js-tab', this.root), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_tabWrap, $('.js-tab-wrap', this.root), "f");
            __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_setCurrentForm).call(this);
            __classPrivateFieldSet(this, _AviaMainFilter_commonForm, $('.js-common-form', this.root), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_filterBackOnewayOnly, $('.js-filter-back-oneway-only', this.root), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_filterBackOnly, $('.js-filter-back-only', this.root), "f");
            __classPrivateFieldGet(this, _AviaMainFilter_tab, "f").on('click', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_flightTypeClick).call(this, e));
            __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_tuneTabs).call(this);
            __classPrivateFieldSet(this, _AviaMainFilter_tripType, $('.js-flight-type', this.root), "f");
            $('.js-filter-toggle-points', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_togglePoints).call(_a, e));
            __classPrivateFieldSet(this, _AviaMainFilter_addRouteBtn, $('.js-avia-filter-route-add', this.root), "f");
            __classPrivateFieldGet(this, _AviaMainFilter_addRouteBtn, "f").on('click', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_addRouteRow).call(this, e));
            __classPrivateFieldSet(this, _AviaMainFilter_filterRouteComposite, $('.js-filter-route-composite', this.root), "f");
            $('.js-avia-filter-route-remove', __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f")).on('click', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_removeRouteRow).call(this, e));
            $('.js-filter-date', __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f")).datepicker().on('change', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onChangeCompositeDate).call(this, e));
            const today = new Date();
            let minDate = today;
            if (__classPrivateFieldGet(this, _AviaMainFilter_options, "f").minStartDate && minDate < __classPrivateFieldGet(this, _AviaMainFilter_options, "f").minStartDate)
                minDate = __classPrivateFieldGet(this, _AviaMainFilter_options, "f").minStartDate;
            const minDays = Math.max(Math.ceil((minDate.getTime() - today.getTime()) / App.millisecondsPerDay), 0);
            const othMaxDate = App.addDays(today, __classPrivateFieldGet(this, _AviaMainFilter_othMaxDays, "f"));
            let maxDate = othMaxDate;
            if (__classPrivateFieldGet(this, _AviaMainFilter_options, "f").maxStartDate && maxDate > __classPrivateFieldGet(this, _AviaMainFilter_options, "f").maxStartDate)
                maxDate = __classPrivateFieldGet(this, _AviaMainFilter_options, "f").maxStartDate;
            const maxDays = Math.min(Math.ceil((maxDate.getTime() - today.getTime()) / App.millisecondsPerDay), __classPrivateFieldGet(this, _AviaMainFilter_othMaxDays, "f"));
            // RT
            const datesFilter = this.findControl('dates');
            if (datesFilter) {
                datesFilter.setOptions({
                    defaultDateFromShift: minDays,
                    minDateFromShift: minDays,
                    maxDateFromShift: maxDays,
                    absoluteMaxDateToOffset: maxDays,
                });
            }
            // OW
            const dateFilter = this.findControl('date');
            if (dateFilter) {
                dateFilter.setOptions({ minDate: minDate, maxDate: maxDate });
            }
            minDate = today;
            // Comby
            // Выставляем минимальные даты для комбинированного перелета
            $.each(__classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").find('.js-filter-route-row'), (index, item) => {
                if (index === 0 && __classPrivateFieldGet(this, _AviaMainFilter_options, "f").minStartDate && __classPrivateFieldGet(this, _AviaMainFilter_options, "f").minStartDate > minDate)
                    minDate = __classPrivateFieldGet(this, _AviaMainFilter_options, "f").minStartDate;
                if (index === 0 && __classPrivateFieldGet(this, _AviaMainFilter_options, "f").maxStartDate && __classPrivateFieldGet(this, _AviaMainFilter_options, "f").maxStartDate < maxDate)
                    maxDate = __classPrivateFieldGet(this, _AviaMainFilter_options, "f").maxStartDate;
                else
                    maxDate = App.addDays(today, __classPrivateFieldGet(this, _AviaMainFilter_othMaxDays, "f"));
                const newDateBlock = new App.FilterDateBlock({
                    root: $('.js-filter-date-block', item),
                    minDate,
                    maxDate,
                });
                $('.js-filter-date', $(item)).datepicker('option', 'minDate', minDate);
                $('.js-filter-date', $(item)).datepicker('option', 'maxDate', maxDate);
                $('.js-filter-date', newDateBlock.root).on('change', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onChangeCompositeDate).call(this, e));
                minDate = App.addDays(minDate, 7);
            });
            __classPrivateFieldSet(this, _AviaMainFilter_newRowTemplate, App.findTemplate((_b = this.root.attr('data-newrow-template')) !== null && _b !== void 0 ? _b : ''), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_aviaCompanyBlock, $('.js-avia-company-block', this.root), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_aviaCompanyInput, $('.js-avia-company-input', __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f")), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_aviaCompanyResults, __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f").find('.js-avia-company-results'), "f");
            // коды а/к через запятую
            __classPrivateFieldSet(this, _AviaMainFilter_aviaCompanyInputCodes, $('.js-avia-company-input-codes', __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f")), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_aviaCompanyPlaceholder, $('.js-avia-company-placeholder', __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f")), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_aviaCompanyAutocomplete, $('.js-avia-company-autocomplete', __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f")), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_adults, this.findControl('adult'), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_children, this.findControl('child'), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_handinfants, this.findControl('handinfant'), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_infants, this.findControl('infant'), "f");
            __classPrivateFieldSet(this, _AviaMainFilter_infantsInfo, $(`[data-info-type="${__classPrivateFieldGet(this, _AviaMainFilter_infants, "f").root.attr('data-select')}"]`, this.root), "f");
            // если кто-то откроет прямую ссылку где есть "/infant-" то скрывать Info по идее не надо
            if (__classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_infants, "f").root) === 0)
                __classPrivateFieldGet(this, _AviaMainFilter_infantsInfo, "f").hide();
            __classPrivateFieldGet(this, _AviaMainFilter_adults, "f").root.on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onAdultChange).call(this, e));
            __classPrivateFieldGet(this, _AviaMainFilter_children, "f").root.on("filter:change" /* Events.FilterChange */, () => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onNotAdultChange).call(this));
            __classPrivateFieldGet(this, _AviaMainFilter_handinfants, "f").root.on("filter:change" /* Events.FilterChange */, () => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onNotAdultChange).call(this));
            __classPrivateFieldGet(this, _AviaMainFilter_infants, "f").root.on("filter:change" /* Events.FilterChange */, e => {
                __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onNotAdultChange).call(this);
                __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onInfantChange).call(this, e);
            });
            __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_recalcPassengers).call(this);
            const scrollerWrap = $('.js-scroller-wrap', __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f"));
            // Стилизуем скролл
            const scroll = scrollerWrap.baron({
                scroller: '.js-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").autocomplete({
                minLength: App.app.settings.minSearchTermLength,
                source: (request, response) => {
                    /* eslint-disable @typescript-eslint/no-floating-promises */
                    $.ajax({
                        url: $(this.root).attr('data-airlines'),
                        method: 'GET',
                        data: {
                            'search': request.term,
                        },
                        success: (data) => {
                            response(data.data.map(v => ({ key: v[0], label: `${v[0]} ${v[1]}`, name: `${v[0]} ${v[1]}` })));
                        },
                    });
                    /* eslint-enable @typescript-eslint/no-floating-promises */
                },
                appendTo: __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyResults, "f"),
                // Добавляем подсказку ввода внутрь инпута
                response: (_, ui) => {
                    const result = ui.content[0];
                    const searchValue = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").valString();
                    let hint;
                    if (result) {
                        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").show();
                        scroll.update();
                        hint = result.label;
                    }
                    else {
                        hint = '';
                    }
                    const hintBegin = hint.substring(0, searchValue.length);
                    if (hintBegin.toUpperCase() === searchValue.toUpperCase())
                        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyPlaceholder, "f").html(`<span>${searchValue}</span>${hint.substring(searchValue.length)}`);
                    else
                        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyPlaceholder, "f").html('');
                },
                // Убираем подсказку из инпута, при выборе результата
                select: (_, ui) => {
                    const { key, value } = ui.item;
                    const selectedWrap = $('.js-avia-company-selected', __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f"));
                    let selected = $('.js-avia-company-selected-item', __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f"));
                    // выбранная а/к уже есть в списке выбранных
                    const isSelected = selected.filter(`[data-value="${value}"]`).length;
                    // Выставляем текст в инпуте
                    if (!isSelected) {
                        const li = $(`<div class="avia-company-dropdown__selected-item js-avia-company-selected-item" data-value="${value}" data-code="${key}"><i class="js-avia-company-selected-delete"></i><span>${value}</span></div>`);
                        li.appendTo(selectedWrap);
                        selectedWrap.show();
                        selected = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").find('.js-avia-company-selected-item');
                        const acs = selected.get().map(item => $(item).attr('data-value')).join(', ');
                        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").val(acs);
                        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInputCodes, "f").val(selected.get().map(item => $(item).attr('data-code')).join(','));
                    }
                    __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").hide();
                    __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").trigger('blur');
                },
                focus: (_, ui) => {
                    const result = ui.item.label;
                    const searchValue = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").valString();
                    let hint;
                    if (result)
                        hint = result;
                    else
                        hint = '';
                    if (hint.toUpperCase() === searchValue.toUpperCase())
                        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyPlaceholder, "f").html(hint);
                    else
                        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyPlaceholder, "f").html('');
                },
            });
            __classPrivateFieldSet(this, _AviaMainFilter_filterSlidingBtn, this.root.find('.js-sliding-btn-direct'), "f");
            __classPrivateFieldGet(this, _AviaMainFilter_filterSlidingBtn, "f").on('click', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onDirectChange).call(this, e));
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").on('focus', () => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onAviaCompanyFocus).call(this));
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").on('change', () => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onAviaCompanyChange).call(this));
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f").on('click', '.js-avia-company-selected-delete', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onAviaCompanyDelete).call(this, e));
            $('html').on('click', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onGetIntoMilk).call(this, e));
            // чтобы в а/к было дефолтное название.
            $('html').trigger('click');
            __classPrivateFieldSet(this, _AviaMainFilter_filterRadioBtn, $('.js-filter-radio-btn-flight-type', this.root), "f");
            __classPrivateFieldGet(this, _AviaMainFilter_filterRadioBtn, "f").on('click', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_changeSearchType).call(this, e));
            this.root.on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onAutocompleteOptionClick).call(this, e));
            this.root.on('click', '.js-m-filter-submit', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onSearch).call(this, e));
        }
        getCurrentForm() {
            return __classPrivateFieldGet(this, _AviaMainFilter_currentForm, "f");
        }
        getTripType() {
            return AviaTripType[__classPrivateFieldGet(this, _AviaMainFilter_tripType, "f").valString()];
        }
        isDirect() {
            return this.root.find('input.js-direct').valString() === 'true' ? true : false;
        }
        reset() {
            // не нужен базовый резет, т.к. очищаются списки.
            // super.reset();
            __classPrivateFieldGet(this, _AviaMainFilter_tab, "f").eq(0).trigger('click');
            __classPrivateFieldGet(this, _AviaMainFilter_filterRadioBtn, "f").eq(0).trigger('click');
            __classPrivateFieldGet(this, _AviaMainFilter_filterSlidingBtn, "f").removeClass('_on').addClass('_off');
            __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_resetCalendars).call(_a);
            __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_resetAviaCompany).call(this);
            $('[data-select="class"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="adult"] .js-filter-option', this.root).eq(1).trigger('click');
            $('[data-select="child"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="handinfant"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="infant"] .js-filter-option', this.root).eq(0).trigger('click');
            $('.js-point-select-input', this.root)
                .each((i, el) => {
                $(el).val('');
            });
            $('.js-point-code', this.root)
                .each((i, el) => {
                $(el).val('');
            });
            $('.js-filter-route-row', __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f"))
                .each((i, el) => {
                const jqElement = $(el);
                const row = jqElement.attr('data-row');
                if (row && parseInt(row, 10) > 2)
                    jqElement.remove();
            });
        }
        search(newSearch) {
            const elements = __classPrivateFieldGet(this, _AviaMainFilter_currentForm, "f").serializeArray().concat(__classPrivateFieldGet(this, _AviaMainFilter_commonForm, "f").serializeArray());
            const data = {};
            $.each(elements, (i, item) => {
                data[item.name] = item.value.includes(',') ? item.value.split(',') : item.value;
            });
            // чтобы очищались groupKey & variantKey
            if (newSearch === true)
                data.newSearch = 'true';
            data.startSearch = 'true';
            // TODO: переделать на событие экземпляра текущего класса.
            this.root.trigger("filter:search" /* Events.FilterSearch */, [data]);
        }
    }
    _a = AviaMainFilter, _AviaMainFilter_options = new WeakMap(), _AviaMainFilter_othMaxDays = new WeakMap(), _AviaMainFilter_aviaCompanyDefaultText = new WeakMap(), _AviaMainFilter_tab = new WeakMap(), _AviaMainFilter_tabWrap = new WeakMap(), _AviaMainFilter_tripType = new WeakMap(), _AviaMainFilter_currentForm = new WeakMap(), _AviaMainFilter_commonForm = new WeakMap(), _AviaMainFilter_filterBackOnewayOnly = new WeakMap(), _AviaMainFilter_filterBackOnly = new WeakMap(), _AviaMainFilter_aviaCompanyBlock = new WeakMap(), _AviaMainFilter_aviaCompanyInput = new WeakMap(), _AviaMainFilter_aviaCompanyResults = new WeakMap(), _AviaMainFilter_aviaCompanyInputCodes = new WeakMap(), _AviaMainFilter_aviaCompanyPlaceholder = new WeakMap(), _AviaMainFilter_aviaCompanyAutocomplete = new WeakMap(), _AviaMainFilter_adults = new WeakMap(), _AviaMainFilter_children = new WeakMap(), _AviaMainFilter_handinfants = new WeakMap(), _AviaMainFilter_infants = new WeakMap(), _AviaMainFilter_infantsInfo = new WeakMap(), _AviaMainFilter_filterSlidingBtn = new WeakMap(), _AviaMainFilter_filterRouteComposite = new WeakMap(), _AviaMainFilter_addRouteBtn = new WeakMap(), _AviaMainFilter_filterRadioBtn = new WeakMap(), _AviaMainFilter_newRowTemplate = new WeakMap(), _AviaMainFilter_instances = new WeakSet(), _AviaMainFilter_setCurrentForm = function _AviaMainFilter_setCurrentForm() {
        const tab = __classPrivateFieldGet(this, _AviaMainFilter_tab, "f").filter('._active').attr('data-tab');
        if (tab)
            __classPrivateFieldSet(this, _AviaMainFilter_currentForm, __classPrivateFieldGet(this, _AviaMainFilter_tabWrap, "f").filter(`[data-tab="${tab}"]`).find('form').first(), "f");
    }, _AviaMainFilter_onAutocompleteOptionClick = function _AviaMainFilter_onAutocompleteOptionClick(event) {
        // TODO: сделать то же самое при переходе по табуляции
        const self = $(event.target);
        const tab = self.closest('.js-tab-wrap');
        if (tab.data('tab') === 'Composite') {
            __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_setNextCompositeLocation).call(_a, self);
            return;
        }
        __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_copyPoints).call(this, self);
    }, _AviaMainFilter_setNextCompositeLocation = function _AviaMainFilter_setNextCompositeLocation(self) {
        const tab = self.closest('.js-tab-wrap');
        if (tab.data('tab') !== 'Composite')
            return;
        if (!self.hasClass('_to'))
            return;
        const legSelector = '.js-filter-route-row';
        const legDepartureLocation = 'input.js-point-select-input';
        const legDepartureCode = 'input.js-point-code';
        const nextLeg = self.closest(legSelector).nextAll(`${legSelector}:first`).find('._from');
        const nextLegLocation = nextLeg.find(legDepartureLocation);
        const nextLegCode = nextLeg.find(legDepartureCode);
        if (nextLegLocation.val() === '' || nextLegCode.val() === '') {
            nextLegLocation.val($(self.find(legDepartureLocation)[0]).val() || '');
            nextLegCode.val($(self.find(legDepartureCode)[0]).val() || '');
        }
    }, _AviaMainFilter_copyPoints = function _AviaMainFilter_copyPoints(self) {
        const tabWrap = '.js-tab-wrap';
        const block = `.js-filter-autocomplete-block.${self.hasClass('_to') ? '_to' : '_from'}`;
        const text = '.js-point-select-input';
        const code = '.js-point-code';
        const tab = self.closest(tabWrap);
        let toTab;
        if (tab.data('tab') === 'OneWay')
            toTab = $(tabWrap, this.root).filter('[data-tab="RoundTrip"]');
        else
            toTab = $(tabWrap, this.root).filter('[data-tab="OneWay"]');
        toTab.find(block).find(text).val(tab.find(block).find(text).val() || '');
        toTab.find(block).find(code).val(tab.find(block).find(code).val() || '');
    }, _AviaMainFilter_togglePoints = function _AviaMainFilter_togglePoints(event) {
        const target = $(event.currentTarget);
        const row = target.closest('.js-filter-route-row');
        const points = row.find('.js-filter-autocomplete-block');
        if (points.length !== 2)
            return;
        const input11 = $(points[0]).find('.js-point-select-input');
        const input12 = $(points[0]).find('.js-point-code');
        const input21 = $(points[1]).find('.js-point-select-input');
        const input22 = $(points[1]).find('.js-point-code');
        const name1 = input11.val() || '';
        const code1 = input12.val() || '';
        input11.val(input21.val() || '');
        input12.val(input22.val() || '');
        input21.val(name1);
        input22.val(code1);
    }, _AviaMainFilter_flightTypeClick = function _AviaMainFilter_flightTypeClick(event) {
        const self = $(event.currentTarget);
        const isActive = self.hasClass('_active');
        const flightType = self.attr('data-tab');
        if (!flightType)
            return;
        __classPrivateFieldGet(this, _AviaMainFilter_tripType, "f").val(flightType);
        if (!isActive) {
            self.siblings('.js-tab').removeClass('_active');
            self.addClass('_active');
            __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_setCurrentForm).call(this);
            __classPrivateFieldGet(this, _AviaMainFilter_tabWrap, "f").hide();
            __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_tuneTabInputs).call(this, flightType);
        }
    }, _AviaMainFilter_tuneTabs = function _AviaMainFilter_tuneTabs() {
        __classPrivateFieldGet(this, _AviaMainFilter_tab, "f").filter('._active').each((i, v) => { var _b; return __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_tuneTabInputs).call(this, (_b = $(v).attr('data-tab')) !== null && _b !== void 0 ? _b : ''); });
    }, _AviaMainFilter_tuneTabInputs = function _AviaMainFilter_tuneTabInputs(flightType) {
        __classPrivateFieldGet(this, _AviaMainFilter_tabWrap, "f").filter(`[data-tab='${flightType}']`).fadeIn();
        if (flightType === 'RoundTrip') {
            __classPrivateFieldGet(this, _AviaMainFilter_filterBackOnewayOnly, "f").show();
            __classPrivateFieldGet(this, _AviaMainFilter_filterBackOnly, "f").show();
        }
        else if (flightType === 'OneWay') {
            __classPrivateFieldGet(this, _AviaMainFilter_filterBackOnewayOnly, "f").show();
            __classPrivateFieldGet(this, _AviaMainFilter_filterBackOnly, "f").hide();
        }
        else if (flightType === 'Composite') {
            __classPrivateFieldGet(this, _AviaMainFilter_filterBackOnewayOnly, "f").hide();
            __classPrivateFieldGet(this, _AviaMainFilter_filterBackOnly, "f").hide();
        }
    }, _AviaMainFilter_onDirectChange = function _AviaMainFilter_onDirectChange(event) {
        const target = $(event.currentTarget);
        const input = this.root.find('input.js-direct');
        target.toggleClass('_off _on');
        input.val(target.hasClass('_on').toString());
    }, _AviaMainFilter_onAviaCompanyFocus = function _AviaMainFilter_onAviaCompanyFocus() {
        const selected = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").find('.js-avia-company-selected-item');
        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyResults, "f").find('ul').html('');
        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").val('');
        if (selected.length)
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").show();
    }, _AviaMainFilter_onAviaCompanyChange = function _AviaMainFilter_onAviaCompanyChange() {
        const selected = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").find('.js-avia-company-selected-item');
        if (!selected.length) {
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").val(__classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyDefaultText, "f"));
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInputCodes, "f").val('');
        }
        if (__classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").val() === '')
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyPlaceholder, "f").html('');
    }, _AviaMainFilter_onAdultChange = function _AviaMainFilter_onAdultChange(event) {
        __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_recalcPassengers).call(this);
        const target = $(event.currentTarget);
        const value = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, target);
        const handInfantValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_handinfants, "f").root);
        const infantValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_infants, "f").root);
        const childValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_children, "f").root);
        if (handInfantValue > value)
            __classPrivateFieldGet(this, _AviaMainFilter_handinfants, "f").setValue(value.toString());
        if (infantValue > value)
            __classPrivateFieldGet(this, _AviaMainFilter_infants, "f").setValue(value.toString());
        if (value === 0 && childValue === 0)
            __classPrivateFieldGet(this, _AviaMainFilter_children, "f").setValue('1');
    }, _AviaMainFilter_onNotAdultChange = function _AviaMainFilter_onNotAdultChange() {
        const adultValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_adults, "f").root);
        const childValue = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_children, "f").root);
        if (adultValue === 0 && childValue === 0)
            __classPrivateFieldGet(this, _AviaMainFilter_adults, "f").setValue('1');
        __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_recalcPassengers).call(this);
    }, _AviaMainFilter_onInfantChange = function _AviaMainFilter_onInfantChange(event) {
        const value = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, $(event.currentTarget));
        __classPrivateFieldGet(this, _AviaMainFilter_infantsInfo, "f").toggle(value > 0);
    }, _AviaMainFilter_recalcPassengers = function _AviaMainFilter_recalcPassengers() {
        const adultVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_adults, "f").root);
        const childVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_children, "f").root);
        const handinfantVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_handinfants, "f").root);
        const infantVal = __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_getJelectValue).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_infants, "f").root);
        const maxPeopleCount = 9;
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_setOptions).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_adults, "f").root, maxPeopleCount - childVal - handinfantVal - infantVal);
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_setOptions).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_children, "f").root, maxPeopleCount - adultVal - handinfantVal - infantVal);
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_setOptions).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_handinfants, "f").root, Math.min(adultVal, maxPeopleCount - adultVal - childVal - infantVal));
        __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_setOptions).call(_a, __classPrivateFieldGet(this, _AviaMainFilter_infants, "f").root, Math.min(adultVal, maxPeopleCount - adultVal - childVal - handinfantVal));
    }, _AviaMainFilter_getJelectValue = function _AviaMainFilter_getJelectValue(item) {
        return $('.js-jelect-input', item).valNumber() || 0;
    }, _AviaMainFilter_setOptions = function _AviaMainFilter_setOptions(selector, count) {
        $.each($('.js-filter-option', selector), (index, item) => {
            var _b;
            __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_setOptionVisibility).call(_a, $(item), count < parseInt((_b = $(item).attr('data-val')) !== null && _b !== void 0 ? _b : '0', 10));
        });
    }, _AviaMainFilter_setOptionVisibility = function _AviaMainFilter_setOptionVisibility(option, hide) {
        if (hide) {
            option.hide();
            option.prop('disabled', true);
        }
        else {
            option.show();
            option.prop('disabled', false);
        }
    }, _AviaMainFilter_onGetIntoMilk = function _AviaMainFilter_onGetIntoMilk(event) {
        // окошко с выбранными а/к
        if (!$(event.target).closest('.js-avia-company-block').length) {
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").hide();
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyPlaceholder, "f").html('');
            let value = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").find('.js-avia-company-selected-item').get()
                .map(item => $(item).attr('data-value'))
                .join(', ');
            if (value === '')
                value = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyDefaultText, "f");
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").val(value);
        }
    }, _AviaMainFilter_onAviaCompanyDelete = function _AviaMainFilter_onAviaCompanyDelete(event) {
        const self = $(event.currentTarget);
        const selectedItem = self.closest('.js-avia-company-selected-item');
        const selectedWrap = selectedItem.closest('.js-avia-company-selected');
        selectedItem.remove();
        const selected = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").find('.js-avia-company-selected-item');
        let value = selected.get().map(item => $(item).attr('data-value')).join(', ');
        if (value === '')
            value = __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyDefaultText, "f");
        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").val(value);
        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInputCodes, "f").val(selected.get().map(item => $(item).attr('data-code')).join(', '));
        if (!selected.length) {
            selectedWrap.hide();
            __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyAutocomplete, "f").hide();
        }
    }, _AviaMainFilter_resetCalendars = function _AviaMainFilter_resetCalendars() {
        /* TODO
        $date_to.datepicker('option', 'minDate', +1);

        $date_from.datepicker('setDate', +1);
        $date_to.datepicker('option', 'minDate', +1);
        $date_to.datepicker('setDate', +15);*/
    }, _AviaMainFilter_resetAviaCompany = function _AviaMainFilter_resetAviaCompany() {
        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyBlock, "f").find('.js-avia-company-selected-item').remove();
        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInputCodes, "f").val('');
        __classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyInput, "f").val(__classPrivateFieldGet(this, _AviaMainFilter_aviaCompanyDefaultText, "f"));
    }, _AviaMainFilter_onChangeCompositeDate = function _AviaMainFilter_onChangeCompositeDate(event) {
        const dateControl = $(event.currentTarget);
        const minDate = dateControl.datepicker('getDate');
        const row = dateControl.closest('.js-filter-route-row');
        // Выставляем минимальные даты для комбинированного перелета
        $.each(__classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").find('.js-filter-route-row'), (_, item) => {
            const itemRowNumber = Number($(item).attr('data-row'));
            const rowNumber = Number($(row).attr('data-row'));
            if (itemRowNumber > rowNumber) {
                const itemMinDate = $('.js-filter-date', $(item)).datepicker('option', 'minDate');
                // Для следующей строки безусловно устанавливаем мин.дату. для всех остальных ставим только в том случае, когда их
                // мин.дата меньше текущей выбранной.
                if (itemRowNumber === rowNumber + 1 || minDate > itemMinDate)
                    $('.js-filter-date', $(item)).datepicker('option', 'minDate', minDate);
            }
        });
    }, _AviaMainFilter_addRouteRow = function _AviaMainFilter_addRouteRow(event) {
        const target = $(event.currentTarget);
        const type = target.attr('data-type');
        const legSelector = '.js-filter-route-row';
        let filterRouteRows = $(legSelector, __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f"));
        const rowsCount = filterRouteRows.length;
        if (rowsCount >= 8)
            return false;
        const firstRow = filterRouteRows.first();
        const lastRow = filterRouteRows.last();
        const firstDepartureBlock = $('.js-filter-autocomplete-block._from', firstRow);
        const lastArrivalBlock = $('.js-filter-autocomplete-block._to', lastRow);
        const lastDateBlock = $('.js-filter-date-block', lastRow);
        __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").append(__classPrivateFieldGet(this, _AviaMainFilter_newRowTemplate, "f").call(this, {
            'index': rowsCount,
        }));
        filterRouteRows = $(legSelector, __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f"));
        const newLastRow = filterRouteRows.last();
        $('.js-avia-filter-route-remove', newLastRow).on('click', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_removeRouteRow).call(this, e));
        $('.js-filter-toggle-points', newLastRow).on('click', e => __classPrivateFieldGet(_a, _a, "m", _AviaMainFilter_togglePoints).call(_a, e));
        newLastRow.find('.js-filter-autocomplete-block').each((i, item) => {
            const newCityBlock = new App.FilterAutocompleteBlock({ root: $(item) });
            if (i === 0)
                newCityBlock.setValueStr($('.js-point-select-input', lastArrivalBlock).valString(), $('.js-point-code', lastArrivalBlock).valString(), '');
            else if (type === 'close')
                newCityBlock.setValueStr($('.js-point-select-input', firstDepartureBlock).valString(), $('.js-point-code', firstDepartureBlock).valString(), '');
        });
        const lastDate = $('.js-filter-date', lastDateBlock).datepicker('getDate');
        const today = new Date();
        let minDate = today;
        if (lastDate)
            minDate = new Date(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate());
        const newDateBlock = new App.FilterDateBlock({
            root: $('.js-filter-date-block', newLastRow),
            minDate,
            maxDate: App.addDays(today, __classPrivateFieldGet(this, _AviaMainFilter_othMaxDays, "f")),
        });
        newDateBlock.setValue(App.addDays(minDate, 7));
        $('.js-filter-date', newDateBlock.root).on('change', e => __classPrivateFieldGet(this, _AviaMainFilter_instances, "m", _AviaMainFilter_onChangeCompositeDate).call(this, e));
        $('.js-avia-filter-route-remove').toggle(__classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").find(legSelector).length > 1);
        return true;
    }, _AviaMainFilter_removeRouteRow = function _AviaMainFilter_removeRouteRow(event) {
        var _b;
        const self = $(event.currentTarget);
        const legSelector = '.js-filter-route-row';
        const legDeparture = '._from';
        const legArrival = '._to';
        const legLocation = 'input.js-point-select-input';
        const legCode = 'input.js-point-code';
        const legDateInput = 'input.js-filter-date';
        const parent = $(self).closest(legSelector);
        const idx = parseInt((_b = parent.attr('data-row')) !== null && _b !== void 0 ? _b : '0', 10);
        if (idx < __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").find(legSelector).length) {
            // Если есть плечи под ней, то идем по всем видимым строкам и переписываем значения из каждой следующей строки в
            // предыдущую, а последнюю скрываем.
            __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").find(legSelector).each((_, item) => {
                const jqItem = $(item);
                if (Number(jqItem.attr('data-row')) >= idx) {
                    const nextItem = jqItem.nextAll(legSelector).filter(':first');
                    if (nextItem) {
                        const depBlock = jqItem.find(legDeparture);
                        const arrBlock = jqItem.find(legArrival);
                        const nextDepBlock = nextItem.find(legDeparture);
                        const nextArrBlock = nextItem.find(legArrival);
                        depBlock.find(legLocation).val(nextDepBlock.find(legLocation).val() || '');
                        depBlock.find(legCode).val(nextDepBlock.find(legCode).val() || '');
                        arrBlock.find(legLocation).val(nextArrBlock.find(legLocation).val() || '');
                        arrBlock.find(legCode).val(nextArrBlock.find(legCode).val() || '');
                        jqItem.find(legDateInput).val(nextItem.find(legDateInput).val() || '');
                    }
                    else {
                        jqItem.find('input').each((index2, value2) => {
                            $(value2).val('');
                        });
                        // TODO: label свертывается по высоте.
                    }
                }
            });
            // удаляем последнее плечо
            __classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").find(legSelector).filter(':last').remove();
            $('.js-avia-filter-route-remove').toggle(__classPrivateFieldGet(this, _AviaMainFilter_filterRouteComposite, "f").find(legSelector).length > 1);
        }
    }, _AviaMainFilter_changeSearchType = function _AviaMainFilter_changeSearchType(event) {
        event.preventDefault();
        const self = $(event.currentTarget);
        const wrapper = self.closest('.js-avia-filter-search-options');
        const input = wrapper.find('input');
        const id = self.attr('data-id');
        const typeBlock = wrapper.find('.js-filter-radio-btn-flight-type');
        typeBlock.removeClass('_on');
        input.val(id || 'Date');
        self.addClass('_on');
        $('.js-matrix-info-block', self.closest('.js-avia-filter-search-options-block')).toggleClass('_dspn', id === 'Date');
    }, _AviaMainFilter_onSearch = function _AviaMainFilter_onSearch(e) {
        e.preventDefault();
        this.search(true);
    };
    App.AviaMainFilter = AviaMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaResultComponent_instances, _a, _AviaResultComponent_options, _AviaResultComponent_orderAgreement, _AviaResultComponent_orderAgreementTemplate, _AviaResultComponent_flightData, _AviaResultComponent_filter, _AviaResultComponent_loading, _AviaResultComponent_stopPartialSearch, _AviaResultComponent_interruptSearch, _AviaResultComponent_popup, _AviaResultComponent_popupGroup, _AviaResultComponent_responseValidator, _AviaResultComponent_firstBasketEntryAviaScroll, _AviaResultComponent_currencyConverter, _AviaResultComponent_sortCurrencyCode, _AviaResultComponent_searchFlightsCore, _AviaResultComponent_searchFlightsPartial, _AviaResultComponent_onStartPartialSearch, _AviaResultComponent_doPartialSearch, _AviaResultComponent_buildUrl, _AviaResultComponent_onFinishWaitForAviaMinPrice, _AviaResultComponent_renderCheapestFlight, _AviaResultComponent_fillFlightResults, _AviaResultComponent_onHotFilterChange, _AviaResultComponent_buildHotFilter, _AviaResultComponent_changeData, _AviaResultComponent_appendGroups, _AviaResultComponent_onAviaGroupClick, _AviaResultComponent_changeFlightView, _AviaResultComponent_afterFlightChange;
    class AviaResultComponent {
        constructor(options) {
            _AviaResultComponent_instances.add(this);
            _AviaResultComponent_options.set(this, void 0);
            _AviaResultComponent_orderAgreement.set(this, void 0);
            _AviaResultComponent_orderAgreementTemplate.set(this, void 0);
            _AviaResultComponent_flightData.set(this, void 0);
            _AviaResultComponent_filter.set(this, void 0);
            _AviaResultComponent_loading.set(this, void 0);
            // флаг окончания инициализирующего поиска
            _AviaResultComponent_stopPartialSearch.set(this, false);
            // флаг прерывания всех стадий поиска, например, в случае изменения первичных фильтров
            _AviaResultComponent_interruptSearch.set(this, false);
            _AviaResultComponent_popup.set(this, void 0);
            _AviaResultComponent_popupGroup.set(this, void 0);
            _AviaResultComponent_responseValidator.set(this, void 0);
            _AviaResultComponent_firstBasketEntryAviaScroll.set(this, false);
            _AviaResultComponent_currencyConverter.set(this, void 0);
            _AviaResultComponent_sortCurrencyCode.set(this, "RUB" /* KnownCurrencyCode.RUB */);
            Object.defineProperty(this, "components", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _AviaResultComponent_options, Object.assign(defaults, options), "f");
            const orderAgreement = $('.js-order-agreement', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").formRoot);
            __classPrivateFieldSet(this, _AviaResultComponent_orderAgreement, orderAgreement, "f");
            __classPrivateFieldSet(this, _AviaResultComponent_orderAgreementTemplate, App.templates.Avia.BookAgreement, "f");
            __classPrivateFieldGet(this, _AviaResultComponent_orderAgreement, "f").toggle(true);
            const container = __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root;
            const variantContainer = $('.js-basic-variants', container);
            const outputBlock = $('.js-cards-output', variantContainer);
            const scrollerWrap = $('._basket').find('.js-scroller-wrap');
            __classPrivateFieldSet(this, _AviaResultComponent_flightData, {
                subfilter: $('.js-subfilter-block', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root),
                subfilterTemplate: App.templates.Avia.HotFilter,
                container,
                current: $('.js-flights-current', container),
                variantContainer,
                variantItemContainer: $('.js-basic-variant', variantContainer),
                outputBlock,
                input: $('.js-flight-offer-key', container),
                template: App.templates.Avia.Results,
                groupBlock: $('.js-flights-services', container),
                groupTemplate: App.templates.Tour.BookFlights,
                detailBlock: $('.js-avia-booking', container),
                detailTemplate: App.templates.Avia.Group,
                scroll: scrollerWrap.baron({
                    scroller: '.js-scroller',
                    track: '.js-scroller-bar-wrap',
                    bar: '.js-scroller-bar',
                    barOnCls: 'baron',
                }),
                renderSpeed: 'slow',
            }, "f");
            __classPrivateFieldSet(this, _AviaResultComponent_filter, $('.js-filter-block-top', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root), "f");
            __classPrivateFieldSet(this, _AviaResultComponent_loading, $('.js-progress-data-loading', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root), "f");
            variantContainer.on('click', '.js-variants-show-more-link-show', () => {
                __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current.hide();
            });
            variantContainer.on('click', '.js-variants-show-more-link-hide', () => {
                __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current.show();
            });
            container.on('click', '.js-flights-view-button', e => {
                const view = $(e.currentTarget).attr('data-view');
                if (!view)
                    return;
                __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_changeFlightView).call(this, view);
            });
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").detailBlock.on('click', '.js-baggage-btn', e => {
                const target = $(e.currentTarget);
                target.siblings('.js-baggage-content').slideToggle();
                target.toggleClass('_opened _closed');
            });
            __classPrivateFieldSet(this, _AviaResultComponent_popup, new App.Popup({
                onShow: () => {
                    $('.js-popup-select-cheapest', __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").root).on('click', () => {
                        this.selectFlightVariant();
                        __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").hide();
                    });
                    $('.js-popup-open-variants', __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").root).on('click', () => {
                        if (__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").outputBlock)
                            App.VariantsShowMoreComponent.show(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").outputBlock);
                        __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").hide();
                        __classPrivateFieldGet(this, _AviaResultComponent_filter, "f").show();
                        const aviaResults = __classPrivateFieldGet(this, _AviaResultComponent_filter, "f").offset();
                        $('html, body').animate({ scrollTop: (aviaResults != null ? aviaResults.top : 0) }, 500);
                    });
                    $('.js-popup-close', __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").hide());
                },
            }), "f");
            __classPrivateFieldSet(this, _AviaResultComponent_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _AviaResultComponent_popup, "f")),
                allowEmptyData: true,
            }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_searchFlightsCore).call(this); }))();
        }
        getRoot() {
            return __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root;
        }
        newSearch(data_1) {
            return __awaiter(this, arguments, void 0, function* (data, signal = App.noneSignal) {
                __classPrivateFieldGet(this, _AviaResultComponent_options, "f").data = data;
                __classPrivateFieldSet(this, _AviaResultComponent_interruptSearch, __classPrivateFieldSet(this, _AviaResultComponent_stopPartialSearch, true, "f"), "f");
                yield App.delay(_a.newSearchDelay, signal);
                yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_searchFlightsPartial).call(this);
            });
        }
        // TODO: код из AviaPage.ts - совместить, вынести в отдельный компонент, например, AviaResult
        // Выбираем минимальный или ранее выбранный перелет.
        selectFlightVariant(oldVariantKey) {
            if (!__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results)
                return;
            const newSelectedKey = Enumerable.from(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.flights)
                .selectMany(v => v.variants)
                .where(v => v.compositeKey === oldVariantKey)
                .defaultIfEmpty(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.flights[0].variants[0])
                .select(v => v.key)
                .first();
            const cardBlocks = $('.js-avia-card-block', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").outputBlock);
            let newSelectedBlock = cardBlocks.filter(`[data-key="${newSelectedKey}"]`);
            if (newSelectedBlock.length <= 0)
                newSelectedBlock = cardBlocks.first();
            newSelectedBlock.trigger('click');
        }
        static initMiddleName(root, needMiddleName) {
            if (needMiddleName) {
                $('.js-middle-name-absent', root).on('click', e => this.onToggleMiddleName(e));
                $('input[data-type="middlename"]', root).attr('required', 'required');
            }
            else {
                $('input[data-type="middlename"]', root).removeAttr('required');
            }
            $('.js-middle-name-requirement', root).val(needMiddleName ? 'Required' : 'Absent');
            $('.js-middle-name-block', root).toggle(needMiddleName);
        }
        static onToggleMiddleName(event) {
            const target = $(event.currentTarget);
            const checked = target.is(':checked');
            const container = target.closest('.js-form-gender');
            const requirement = checked ? 'Absent' : 'Required';
            const input = $('input[data-type="middlename"]', container);
            const block = input.closest('.js-middle-name-block');
            $('.js-middle-name-requirement', container).val(requirement);
            input.prop('disabled', checked);
            block.find('.form-item-error').toggle(!checked);
            if (checked) {
                block.removeAttr('_invalid');
                input.removeAttr('required');
            }
            else {
                input.attr('required', '');
            }
        }
        getResults() {
            return __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results;
        }
    }
    _a = AviaResultComponent, _AviaResultComponent_options = new WeakMap(), _AviaResultComponent_orderAgreement = new WeakMap(), _AviaResultComponent_orderAgreementTemplate = new WeakMap(), _AviaResultComponent_flightData = new WeakMap(), _AviaResultComponent_filter = new WeakMap(), _AviaResultComponent_loading = new WeakMap(), _AviaResultComponent_stopPartialSearch = new WeakMap(), _AviaResultComponent_interruptSearch = new WeakMap(), _AviaResultComponent_popup = new WeakMap(), _AviaResultComponent_popupGroup = new WeakMap(), _AviaResultComponent_responseValidator = new WeakMap(), _AviaResultComponent_firstBasketEntryAviaScroll = new WeakMap(), _AviaResultComponent_currencyConverter = new WeakMap(), _AviaResultComponent_sortCurrencyCode = new WeakMap(), _AviaResultComponent_instances = new WeakSet(), _AviaResultComponent_searchFlightsCore = function _AviaResultComponent_searchFlightsCore(oldVariantKey) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.on("filter:startPartialSearch" /* Events.FilterStartPartialSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_onStartPartialSearch).call(this, e, data); }));
            __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.on("avia:finishWaitForMinPrice" /* Events.FinishWaitForAviaMinPrice */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_onFinishWaitForAviaMinPrice).call(this); }));
            yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_searchFlightsPartial).call(this, oldVariantKey);
        });
    }, _AviaResultComponent_searchFlightsPartial = function _AviaResultComponent_searchFlightsPartial(oldVariantKey_1) {
        return __awaiter(this, arguments, void 0, function* (oldVariantKey, signal = App.noneSignal) {
            var _b;
            __classPrivateFieldSet(this, _AviaResultComponent_stopPartialSearch, false, "f");
            __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.trigger("avia:toggleBookButton" /* Events.AviaToggleBookButton */, [true]);
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").variantContainer.hide();
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results = undefined;
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current.hide();
            __classPrivateFieldGet(this, _AviaResultComponent_filter, "f").hide();
            __classPrivateFieldGet(this, _AviaResultComponent_loading, "f").show();
            if ((_b = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f")) === null || _b === void 0 ? void 0 : _b.subfilter)
                $('.js-progress-data-loading', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").subfilter).show();
            const data = __classPrivateFieldGet(this, _AviaResultComponent_options, "f").data;
            const url = __classPrivateFieldGet(_a, _a, "m", _AviaResultComponent_buildUrl).call(_a, __classPrivateFieldGet(this, _AviaResultComponent_options, "f").urls.flightsInitialize, data);
            __classPrivateFieldSet(this, _AviaResultComponent_popupGroup, __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").show({
                group: 'main',
                content: App.templates.Tour.Messages.GettingFlights({}),
                delay: 1000,
                modal: true,
            }), "f");
            let hasData = false;
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                data.push({ name: 'oldVariantKey', value: oldVariantKey });
                __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.trigger("filter:startPartialSearch" /* Events.FilterStartPartialSearch */, [data]);
                __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.trigger("avia:finishWaitForMinPrice" /* Events.FinishWaitForAviaMinPrice */);
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const xhr = $.ajax({
                        url,
                        method: 'POST',
                        // data: data TODO: использовать data вместо urlBuilder (сейчас не хватает значения поля Tourist!).
                    });
                    const result = yield xhr;
                    if (!__classPrivateFieldGet(this, _AviaResultComponent_responseValidator, "f").process(result))
                        return null;
                    return result;
                }), signal);
                hasData = (response === null || response === void 0 ? void 0 : response.data) != null;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AviaResultComponent_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _AviaResultComponent_stopPartialSearch, true, "f");
                __classPrivateFieldGet(this, _AviaResultComponent_filter, "f").show();
                if (hasData)
                    __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").hide(__classPrivateFieldGet(this, _AviaResultComponent_popupGroup, "f"));
            }
        });
    }, _AviaResultComponent_onStartPartialSearch = function _AviaResultComponent_onStartPartialSearch(event_1, data_1) {
        return __awaiter(this, arguments, void 0, function* (event, data, signal = App.noneSignal) {
            var _b;
            yield App.delay(_a.partialAviaSearchFirstInterval, signal);
            // ожидаем окончания последнего потока и разблокируем поиск
            __classPrivateFieldSet(this, _AviaResultComponent_interruptSearch, false, "f");
            if (!(yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_doPartialSearch).call(this, data))) {
                if (!__classPrivateFieldGet(this, _AviaResultComponent_interruptSearch, "f")) {
                    __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").show({
                        content: App.templates.Message(App.Message.DynamicAviaSearchNoVariants),
                    });
                    // TODO: костыль с show/hide разных контейнеров.
                    __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").variantContainer.show();
                    $('.js-variants-show-more-link-show', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").variantContainer).hide();
                    $('.js-variants-show-more-link-hide', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").variantContainer).hide();
                    __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").variantItemContainer.hide();
                    __classPrivateFieldGet(this, _AviaResultComponent_loading, "f").hide();
                    if ((_b = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f")) === null || _b === void 0 ? void 0 : _b.subfilter)
                        $('.js-progress-data-loading', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").subfilter).hide();
                    __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results = undefined;
                    yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_afterFlightChange).call(this);
                }
            }
        });
    }, _AviaResultComponent_doPartialSearch = function _AviaResultComponent_doPartialSearch(dataWoTourist_1) {
        return __awaiter(this, arguments, void 0, function* (dataWoTourist, signal = App.noneSignal) {
            var _b, _c, _d;
            if (__classPrivateFieldGet(this, _AviaResultComponent_interruptSearch, "f"))
                return false;
            const lastLoop = __classPrivateFieldGet(this, _AviaResultComponent_stopPartialSearch, "f");
            const data = __classPrivateFieldGet(this, _AviaResultComponent_options, "f").data;
            const url = __classPrivateFieldGet(_a, _a, "m", _AviaResultComponent_buildUrl).call(_a, __classPrivateFieldGet(this, _AviaResultComponent_options, "f").urls.flightsPartial, data);
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const xhr = $.ajax({
                        url,
                        method: 'POST',
                        // data: data TODO: использовать data вместо urlBuilder (сейчас не хватает значения поля Tourist!).
                    });
                    const result = yield xhr;
                    if (!__classPrivateFieldGet(this, _AviaResultComponent_responseValidator, "f").process(result))
                        return null;
                    return result;
                }), signal);
                if (__classPrivateFieldGet(this, _AviaResultComponent_interruptSearch, "f"))
                    return false;
                if (!response)
                    return false;
                if (lastLoop && !(response.data && response.data.groups) && !__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results)
                    return false;
                if (response.data && response.data.groups) {
                    let priceGetted = false;
                    let groups;
                    if (__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results) {
                        groups = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.flights;
                        response.data.groups.forEach(newGroup => {
                            var _b;
                            const oldGroup = groups.find(v => v.key === newGroup.key);
                            if (oldGroup) {
                                newGroup.variants.forEach(variant => {
                                    if (oldGroup.variants.findIndex(v => v.key === variant.key) < 0)
                                        oldGroup.variants.push(variant);
                                });
                            }
                            else {
                                newGroup.sortPrice = (_b = __classPrivateFieldGet(this, _AviaResultComponent_currencyConverter, "f")) === null || _b === void 0 ? void 0 : _b.exchange(newGroup.grossPrice, newGroup.currency, __classPrivateFieldGet(this, _AviaResultComponent_sortCurrencyCode, "f"));
                                groups.push(newGroup);
                            }
                        });
                    }
                    else {
                        groups = response.data.groups;
                        __classPrivateFieldSet(this, _AviaResultComponent_currencyConverter, yield App.CurrencyManager.findConverter({ signal }), "f");
                        __classPrivateFieldSet(this, _AviaResultComponent_sortCurrencyCode, groups[0].currency, "f");
                    }
                    groups.sort((v1, v2) => { var _b, _c; return ((_b = v1.sortPrice) !== null && _b !== void 0 ? _b : v1.grossPrice) - ((_c = v2.sortPrice) !== null && _c !== void 0 ? _c : v2.grossPrice); });
                    if (response.data.baseAviaSearchCompleted && !(((_b = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results) === null || _b === void 0 ? void 0 : _b.minPriceGetted) === true))
                        priceGetted = true;
                    __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_fillFlightResults).call(this, groups, response.data.cityMappings, priceGetted);
                    const changedData = new App.ChangedData();
                    changedData.pageNumber = 1;
                    changedData.groups = groups;
                    __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_changeData).call(this, changedData);
                    if (priceGetted)
                        yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_renderCheapestFlight).call(this, data);
                    $('.js-scroller-wrap', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").container).toggleClass('_tall', groups.length > 3);
                    if (__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current.is(':visible'))
                        App.VariantsShowMoreComponent.toggle(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").variantContainer, groups.length <= 0);
                }
                if (lastLoop) {
                    if (!(((_c = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results) === null || _c === void 0 ? void 0 : _c.minPriceGetted) === true))
                        yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_renderCheapestFlight).call(this, data);
                    if (__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results
                        && __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.selectedFlight.grossPrice > __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.flights[0].grossPrice) {
                        __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").show({
                            content: App.templates.Tour.Messages.CheaperFlightVariant({}),
                            modal: true,
                        });
                    }
                    __classPrivateFieldGet(this, _AviaResultComponent_loading, "f").hide();
                    if ((_d = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f")) === null || _d === void 0 ? void 0 : _d.subfilter)
                        $('.js-progress-data-loading', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").subfilter).hide();
                }
                else {
                    const delayBetweenParts = __classPrivateFieldGet(this, _AviaResultComponent_stopPartialSearch, "f")
                        ? _a.partialAviaSearchLastInterval
                        : _a.partialAviaSearchInterval;
                    yield App.delay(delayBetweenParts, signal);
                    return yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_doPartialSearch).call(this, dataWoTourist);
                }
            }
            catch (ex) {
                /* TODO: на текущий момент игнорируем все ошибки для данных ajax-вызовов, т.к. непонятно как их обрабатывать и что
                 * показывать клиенту (и нужно ли вообще что-то показывать в этом случае).
                if (!this.responseValidator.processError(ex))
                    throw ex;
                */
            }
            return true;
        });
    }, _AviaResultComponent_buildUrl = function _AviaResultComponent_buildUrl(url, data) {
        const urlBuilder = new App.QueryParams(url);
        const formDirect = data.find(v => v.name === 'Form.Direct');
        if (formDirect)
            urlBuilder.replace('direct', [formDirect && formDirect.value === 'true' ? '1' : '0']);
        const formClass = data.find(v => v.name === 'Form.Class');
        if (formClass)
            urlBuilder.replace('class', [formClass ? formClass.value.toLowerCase() : '']);
        return urlBuilder.getUrl();
    }, _AviaResultComponent_onFinishWaitForAviaMinPrice = function _AviaResultComponent_onFinishWaitForAviaMinPrice() {
        return __awaiter(this, arguments, void 0, function* (signal = App.noneSignal) {
            if (!__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results)
                return;
            yield App.delay(_a.aviaGetMinPriceWaitTime, signal);
            if (!(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.minPriceGetted === true)) {
                yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_renderCheapestFlight).call(this, __classPrivateFieldGet(this, _AviaResultComponent_options, "f").data);
                window.console.log(`%c за ${(_a.aviaGetMinPriceWaitTime / 1000)} секунд основной поиск не завершился`, 'background: #222; color: #bada55');
            }
        });
    }, _AviaResultComponent_renderCheapestFlight = function _AviaResultComponent_renderCheapestFlight(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            if (__classPrivateFieldGet(this, _AviaResultComponent_interruptSearch, "f"))
                return;
            this.selectFlightVariant((_b = data.find(x => x.name === 'oldVariantKey')) === null || _b === void 0 ? void 0 : _b.value);
            __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.trigger("avia:searchCompleted" /* Events.AviaSearchCompleted */);
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").outputBlock.scrollTop();
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").scroll.update();
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").variantContainer.show();
            __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.trigger("avia:toggleBookButton" /* Events.AviaToggleBookButton */, [false]);
            __classPrivateFieldGet(this, _AviaResultComponent_popup, "f").hide(__classPrivateFieldGet(this, _AviaResultComponent_popupGroup, "f"));
            if (__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results)
                __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.minPriceGetted = true;
        });
    }, _AviaResultComponent_fillFlightResults = function _AviaResultComponent_fillFlightResults(groups, cityMappings, priceGetted) {
        __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_buildHotFilter).call(this, groups);
        const aviaHotFilter = new App.AviaHotFilter(groups, __classPrivateFieldGet(this, _AviaResultComponent_options, "f").beginDate);
        aviaHotFilter.root.on("hotfilter:change" /* Events.HotFilterChange */, (e, data) => __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_onHotFilterChange).call(this, e, data));
        if (!__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results) {
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results = {
                hotFilter: aviaHotFilter,
                flights: groups,
                flightCityMappings: cityMappings,
                selectedFlight: groups[0],
                minPriceGetted: priceGetted,
            };
        }
        else {
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.flights = groups;
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.hotFilter = aviaHotFilter;
            if (priceGetted)
                __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.minPriceGetted = priceGetted;
            /* TODO: merge & distinct flightCityMappings
            this.flightData.results.flightCityMappings = this.flightData.results.flightCityMappings.concat()
                .filter((v, i, a) => a.map(x => x.key).indexOf(v.key) === i);
            */
        }
    }, _AviaResultComponent_onHotFilterChange = function _AviaResultComponent_onHotFilterChange(e, groups) {
        e.preventDefault();
        const changedData = new App.ChangedData();
        changedData.pageNumber = 1;
        changedData.groups = groups;
        __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_changeData).call(this, changedData);
    }, _AviaResultComponent_buildHotFilter = function _AviaResultComponent_buildHotFilter(groups) {
        var _b, _c;
        const model = App.AviaHotFilter.getModel((_b = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results) === null || _b === void 0 ? void 0 : _b.hotFilter, groups, App.AviaTripType.RoundTrip, ((_c = __classPrivateFieldGet(this, _AviaResultComponent_options, "f").data.find(v => v.name === 'Form.Direct')) === null || _c === void 0 ? void 0 : _c.value) === 'True' ? true : false);
        const hotfilter = $(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").subfilterTemplate(model));
        __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").subfilter.empty().prepend(hotfilter).show();
    }, _AviaResultComponent_changeData = function _AviaResultComponent_changeData(data) {
        const pageGroups = data.groups;
        __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_appendGroups).call(this, pageGroups);
        const subfilterInfoCount = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").subfilter.find('.js-filter-count');
        const count = data.groups
            .map(v => v.variants.length)
            .reduce((prev, cur) => prev + cur, 0);
        subfilterInfoCount.html(`${count} ${App.pluralRu(count, 'предложение', 'предложения', 'предложений')}`);
    }, _AviaResultComponent_appendGroups = function _AviaResultComponent_appendGroups(groups) {
        const data = { resultType: App.AviaResultType[App.AviaResultType.flat], dynamicFlight: true, groups };
        const content = $(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").template(data));
        __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").outputBlock
            // отписываемся, иначе будут дубли онклик.
            .off('click', '.js-avia-card-block')
            .empty()
            .append(content)
            .show(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").renderSpeed)
            .on('click', '.js-avia-card-block', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_onAviaGroupClick).call(this, e); }));
        $('.scroll-avia-cards-list').show();
    }, _AviaResultComponent_onAviaGroupClick = function _AviaResultComponent_onAviaGroupClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c, _d, _e;
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results)
                return;
            const key = (_b = $(e.currentTarget).attr('data-key')) !== null && _b !== void 0 ? _b : '';
            $('.js-avia-card-block').removeClass('_active');
            $(e.currentTarget).addClass('_active');
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").input.val(key);
            const selectedFlight = (_c = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.flights.find(v => v.key === key)) !== null && _c !== void 0 ? _c : __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.flights[0];
            __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results.selectedFlight = selectedFlight;
            const data = Object.assign({ dynamicFlight: true }, selectedFlight);
            __classPrivateFieldGet(this, _AviaResultComponent_orderAgreement, "f")
                .empty()
                .append(__classPrivateFieldGet(this, _AviaResultComponent_orderAgreementTemplate, "f").call(this, data));
            __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_changeFlightView).call(this, 'brief');
            App.VariantsShowMoreComponent.hide($(e.currentTarget));
            __classPrivateFieldGet(this, _AviaResultComponent_filter, "f").hide();
            // Переход к информации по выбранному перелету, при инициализации корзины, переход не делаем.
            if (__classPrivateFieldGet(this, _AviaResultComponent_firstBasketEntryAviaScroll, "f")) {
                const aviaBookingOffset = $('.js-flights-view-content').offset();
                $('html, body').animate({ scrollTop: (aviaBookingOffset != null ? aviaBookingOffset.top : 0) }, 500);
            }
            else {
                __classPrivateFieldSet(this, _AviaResultComponent_firstBasketEntryAviaScroll, true, "f");
            }
            // TODO: очередной костыль с ручным управлением обязательными полями.
            const needDocument = (_d = selectedFlight.needDocument) !== null && _d !== void 0 ? _d : false;
            const needIssueDate = needDocument && ((_e = selectedFlight.needIssueDate) !== null && _e !== void 0 ? _e : false);
            const needMiddleName = selectedFlight.needMiddleName;
            __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.trigger("avia:groupClick" /* Events.AviaGroupClick */, [{ needDocument, needIssueDate, needMiddleName }]);
            yield __classPrivateFieldGet(this, _AviaResultComponent_instances, "m", _AviaResultComponent_afterFlightChange).call(this);
        });
    }, _AviaResultComponent_changeFlightView = function _AviaResultComponent_changeFlightView(view) {
        if (!__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results)
            return;
        const { selectedFlight } = __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").results;
        if (!selectedFlight)
            return;
        __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current.show();
        $('.js-flights-view-button', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current).show();
        $(`.js-flights-view-button[data-view="${view}"]`, __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current).hide();
        $('.js-flights-view-content', __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current).hide();
        switch (view) {
            case 'detail':
                {
                    /* TODO: раскоментить, если потребуется смена тарифа
                    let items = this.flightData.results.flights.filter(v => v.fareGroupKey === selectedFlight.fareGroupKey);
                    if (!items)
                        return;
                    items = AviaGroupPage.calcPriceDelta(items, selectedFlight);
                    */
                    const data = { dynamicFlight: true, selectedGroup: selectedFlight /* , items */ };
                    const content = $(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").detailTemplate(data));
                    __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").detailBlock
                        .empty()
                        .append(content)
                        .show(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").renderSpeed);
                    // TODO: проверить, всегда ли в одном блоке у всех перелетов одна дата ТЛ.
                    const variant = selectedFlight.variants[0];
                    $('.js-get-timelimit-block', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root).toggle(variant !== undefined);
                    if (variant) {
                        $('.js-time-limit', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root).text(variant.timeLimit);
                        $('.js-get-exact-timelimit-block', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root).toggle(!variant.timeLimitIsExact);
                        $('.js-awaiter', __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root).hide();
                    }
                }
                break;
            default:
                {
                    const data = {
                        nonExchangable: selectedFlight.nonExchangable,
                        nonRefundable: selectedFlight.nonRefundable,
                        withBaggage: selectedFlight.withBaggage,
                        baggage: selectedFlight.baggage,
                        tags: selectedFlight.tags,
                        brands: selectedFlight.brands,
                        showProvider: selectedFlight.showProvider,
                        provider: selectedFlight.provider,
                        grossPrice: selectedFlight.grossPrice,
                        currency: selectedFlight.currency,
                        airportWillBeChanged: selectedFlight.airportWillBeChanged,
                        services: selectedFlight.variants[0].legs
                            .map((v, i) => ({
                            route: {
                                departure: v.segments[0].cityName,
                                arrival: v.segments[v.segments.length - 1].endCityName,
                            },
                            variants: [{
                                    beginDate: v.date,
                                    quota: v.available == null || v.available ? App.QuotaStatus.Yes : App.QuotaStatus.No,
                                    dynamicFlight: true,
                                    selectedCount: 1,
                                    endDate: v.endDate,
                                    flight: {
                                        departureAirportCode: v.segments[0].airportCode,
                                        arrivalAirportCode: v.segments[v.segments.length - 1].endAirportCode,
                                        airlineCode: v.segments[0].airlineCode,
                                        flightNumber: v.segments[0].flightNumber,
                                        connections: Enumerable.range(0, v.segments.length - 1)
                                            .select(x => ({
                                            cityName: v.segments[x].endCityName,
                                            airportName: v.segments[x].endAirportName,
                                            date: v.segments[x].endDate,
                                            endAirportName: v.segments[x + 1].airportName,
                                            endDate: v.segments[x + 1].date,
                                            duration: v.segments[x].transferDuration,
                                        }))
                                            .toArray(),
                                    },
                                    serviceClassName: v.segments[0].serviceClass,
                                    nextDayArrival: v.nextDayArrival && i <= 0,
                                }],
                        })),
                    };
                    const content = $(__classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").groupTemplate(data));
                    __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").groupBlock
                        .empty()
                        .append(content);
                }
                break;
        }
        $(`.js-flights-view-content[data-view="${view}"]`, __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").current).show();
        this.components.push(new App.AviaRulesComponent({
            root: __classPrivateFieldGet(this, _AviaResultComponent_orderAgreement, "f"),
            popup: __classPrivateFieldGet(this, _AviaResultComponent_popup, "f"),
            responseValidator: __classPrivateFieldGet(this, _AviaResultComponent_responseValidator, "f"),
            url: __classPrivateFieldGet(this, _AviaResultComponent_options, "f").urls.flightFareRules,
            getVariantKey: () => (selectedFlight ? selectedFlight.variants[0].key : null),
            getTranslationUrl: __classPrivateFieldGet(this, _AviaResultComponent_options, "f").urls.getTranslation,
        }), new App.AviaTimeLimitComponent({
            root: __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").container,
            responseValidator: __classPrivateFieldGet(this, _AviaResultComponent_responseValidator, "f"),
            url: __classPrivateFieldGet(this, _AviaResultComponent_options, "f").urls.flightTimeLimit,
            getVariant: () => (selectedFlight ? selectedFlight.variants[0] : null),
        }), new App.AviaBrandFareComponent({
            root: __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").container,
            popup: __classPrivateFieldGet(this, _AviaResultComponent_popup, "f"),
            responseValidator: __classPrivateFieldGet(this, _AviaResultComponent_responseValidator, "f"),
        }), new App.AviaFareGroupComponent({
            root: __classPrivateFieldGet(this, _AviaResultComponent_flightData, "f").container,
            items: [selectedFlight],
        }));
    }, _AviaResultComponent_afterFlightChange = function _AviaResultComponent_afterFlightChange() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _AviaResultComponent_options, "f").root.trigger("avia:flightChanged" /* Events.AviaFlightChanged */);
        });
    };
    Object.defineProperty(AviaResultComponent, "partialAviaSearchFirstInterval", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8000
    });
    Object.defineProperty(AviaResultComponent, "partialAviaSearchInterval", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1000
    });
    Object.defineProperty(AviaResultComponent, "partialAviaSearchLastInterval", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 500
    });
    Object.defineProperty(AviaResultComponent, "aviaGetMinPriceWaitTime", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 16000
    });
    // Таймаут перед новым поиском в случае изменения первичного фильтра для того, чтобы успеть завершить предыдущие частичные поиски,
    // и чтобы результаты поиска не накладывались друг на друга.
    Object.defineProperty(AviaResultComponent, "newSearchDelay", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1000
    });
    App.AviaResultComponent = AviaResultComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaRulesComponent_instances, _a, _AviaRulesComponent_options, _AviaRulesComponent_translationStates, _AviaRulesComponent_segmentList, _AviaRulesComponent_segmentRules, _AviaRulesComponent_showTranslation, _AviaRulesComponent_loaderHtml, _AviaRulesComponent_onCarrierRules, _AviaRulesComponent_changeRuleSegment, _AviaRulesComponent_onCarrierRulesClick, _AviaRulesComponent_restoreTranslationState, _AviaRulesComponent_onCommonRules, _AviaRulesComponent_onPrivateFareRules, _AviaRulesComponent_onCruiseFareRules, _AviaRulesComponent_onIssueWithoutAdults, _AviaRulesComponent_onCharterBooking, _AviaRulesComponent_onDoubleBooking, _AviaRulesComponent_listenAgreeButton, _AviaRulesComponent_onRulesButtonClick, _AviaRulesComponent_initializeTranslationStates, _AviaRulesComponent_setTranslationState, _AviaRulesComponent_getTranslationState, _AviaRulesComponent_toggleTranslation, _AviaRulesComponent_showOriginalRules, _AviaRulesComponent_showTranslatedRules, _AviaRulesComponent_translateRulesAsync;
    class AviaRulesComponent {
        constructor(options) {
            _AviaRulesComponent_instances.add(this);
            _AviaRulesComponent_options.set(this, void 0);
            _AviaRulesComponent_translationStates.set(this, new WeakMap());
            _AviaRulesComponent_segmentList.set(this, void 0);
            _AviaRulesComponent_segmentRules.set(this, void 0);
            _AviaRulesComponent_showTranslation.set(this, false);
            __classPrivateFieldSet(this, _AviaRulesComponent_options, options, "f");
            $('.js-agree-carrier', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onCarrierRules).call(this, e); }));
            $('.js-agree-avia', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").root).on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onCommonRules).call(this, e));
            $('.js-agree-private-fare', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").root).on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onPrivateFareRules).call(this, e));
            $('.js-agree-cruise-fare', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").root).on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onCruiseFareRules).call(this, e));
            $('.js-agree-noadults', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").root).on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onIssueWithoutAdults).call(this, e));
            $('.js-agree-сharter', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").root).on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onCharterBooking).call(this, e));
            $('.js-agree-double-booking', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").root).on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onDoubleBooking).call(this, e));
        }
    }
    _a = AviaRulesComponent, _AviaRulesComponent_options = new WeakMap(), _AviaRulesComponent_translationStates = new WeakMap(), _AviaRulesComponent_segmentList = new WeakMap(), _AviaRulesComponent_segmentRules = new WeakMap(), _AviaRulesComponent_showTranslation = new WeakMap(), _AviaRulesComponent_instances = new WeakSet(), _AviaRulesComponent_onCarrierRules = function _AviaRulesComponent_onCarrierRules(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const variantKey = __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").getVariantKey();
            if (!variantKey)
                return;
            __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
                group: 'main',
                title: 'Правила перевозчика',
                content: App.templates.Avia.Messages.CarrierRulesLoading({}),
            });
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").url, { body: new URLSearchParams({ offerKey: variantKey }) });
                if (!__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").responseValidator.process(response))
                    return;
                __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
                    group: 'main',
                    title: 'Правила перевозчика',
                    content: App.templates.Avia.Messages.CarrierRules(response.data),
                });
                if (response.data.segmentRules.length > 1) {
                    __classPrivateFieldSet(this, _AviaRulesComponent_segmentList, $('.js-segment-list', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root), "f");
                    outputSegments(__classPrivateFieldGet(this, _AviaRulesComponent_segmentList, "f"), Enumerable.from(response.data.segmentRules)
                        .select(v => v.index)
                        .toArray());
                    $('.js-segment-index', __classPrivateFieldGet(this, _AviaRulesComponent_segmentList, "f")).on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_changeRuleSegment).call(this, e));
                }
                const carrierSegmentRules = $('.js-rules-block', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root);
                outputSegmentRules(carrierSegmentRules, response.data.segmentRules);
                __classPrivateFieldSet(this, _AviaRulesComponent_segmentRules, $('.js-segment-rules', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root), "f");
                __classPrivateFieldSet(this, _AviaRulesComponent_showTranslation, false, "f");
                __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_initializeTranslationStates).call(this);
                $('.js-carrier-rules-switcher', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onCarrierRulesClick).call(this, e); }));
                $('.js-carrier-rules-translation-switcher', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root).on('click', () => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_toggleTranslation).call(this));
                __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_listenAgreeButton).call(this, $(event.currentTarget));
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").responseValidator.processError(ex))
                    throw ex;
            }
            function outputSegments(container, indexes) {
                container
                    .empty()
                    .append(App.templates.Avia.RuleSegments(indexes));
            }
            function outputSegmentRules(container, segmentRules) {
                container.empty();
                $.each(segmentRules, (i, item) => {
                    const obj = {
                        segmentRules: item,
                        show: item.index === 1,
                    };
                    container.append(App.templates.Avia.SegmentRules(obj));
                });
            }
        });
    }, _AviaRulesComponent_changeRuleSegment = function _AviaRulesComponent_changeRuleSegment(e) {
        const showMore = 'avia-rule__show-more';
        const target = $(e.currentTarget);
        __classPrivateFieldGet(this, _AviaRulesComponent_segmentList, "f").find('.js-segment-index').addClass(showMore);
        target.removeClass(showMore);
        __classPrivateFieldGet(this, _AviaRulesComponent_segmentRules, "f").hide();
        const segment = target.attr('data-segment');
        if (segment)
            __classPrivateFieldGet(this, _AviaRulesComponent_segmentRules, "f").filter(`[data-segment="${segment}"]`).show();
    }, _AviaRulesComponent_onCarrierRulesClick = function _AviaRulesComponent_onCarrierRulesClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const variantKey = __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").getVariantKey();
            if (!variantKey)
                return;
            const target = $(e.currentTarget);
            const root = target.parents('.js-segment-rules');
            const carrierFareRules = $('.js-carrier-fare-rules', root);
            const element = carrierFareRules[0];
            const previousState = __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_getTranslationState).call(this, carrierFareRules);
            const segmentStr = root.attr('data-segment');
            const segment = !segmentStr ? undefined : parseInt(segmentStr, 10);
            if (element)
                __classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").delete(element);
            carrierFareRules
                .attr('data-rules-loading', 'true')
                .empty();
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").url, {
                    body: App.createUrlSearchParams({
                        offerKey: variantKey,
                        fullList: true,
                        segment,
                    }),
                });
                if (!__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").responseValidator.process(response)) {
                    __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_restoreTranslationState).call(this, carrierFareRules, previousState);
                    return;
                }
                carrierFareRules.removeAttr('data-rules-loading');
                __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_setTranslationState).call(this, carrierFareRules, response.data.rules);
                target.hide();
                if (__classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f"))
                    __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_showTranslatedRules).call(this, carrierFareRules);
            }
            catch (ex) {
                __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_restoreTranslationState).call(this, carrierFareRules, previousState);
                if (!__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").responseValidator.processError(ex))
                    throw ex;
            }
        });
    }, _AviaRulesComponent_restoreTranslationState = function _AviaRulesComponent_restoreTranslationState(block, state) {
        block.removeAttr('data-rules-loading');
        const element = block[0];
        if (!state || !element)
            return;
        __classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").set(element, state);
        if (__classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f"))
            __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_showTranslatedRules).call(this, block);
        else
            block.html(state.original);
    }, _AviaRulesComponent_onCommonRules = function _AviaRulesComponent_onCommonRules(e) {
        __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
            group: 'main',
            title: 'Правила бронирования',
            content: App.templates.Avia.Messages.CommonRules({}),
        });
        __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_listenAgreeButton).call(this, $(e.currentTarget));
    }, _AviaRulesComponent_onPrivateFareRules = function _AviaRulesComponent_onPrivateFareRules(e) {
        __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
            group: 'main',
            title: 'Правила спецтарифа',
            content: App.templates.Avia.Messages.PrivateFareRules({}),
        });
        __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_listenAgreeButton).call(this, $(e.currentTarget));
    }, _AviaRulesComponent_onCruiseFareRules = function _AviaRulesComponent_onCruiseFareRules(e) {
        __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
            group: 'main',
            title: 'Правила бронирования круизного тарифа',
            content: App.templates.Avia.Messages.CruiseFareRules({}),
        });
        __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_listenAgreeButton).call(this, $(e.currentTarget));
    }, _AviaRulesComponent_onIssueWithoutAdults = function _AviaRulesComponent_onIssueWithoutAdults(e) {
        __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
            group: 'main',
            title: 'Информация',
            content: App.templates.Avia.Messages.IssueWithoutAdultsFareRules({}),
        });
        __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_listenAgreeButton).call(this, $(e.currentTarget));
    }, _AviaRulesComponent_onCharterBooking = function _AviaRulesComponent_onCharterBooking(e) {
        __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
            group: 'main',
            title: 'Информация',
            content: App.templates.Avia.Messages.CharterFareRules({}),
        });
        __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_listenAgreeButton).call(this, $(e.currentTarget));
    }, _AviaRulesComponent_onDoubleBooking = function _AviaRulesComponent_onDoubleBooking(e) {
        __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.show({
            group: 'main',
            title: 'Информация',
            content: App.templates.Avia.Messages.DoubleBookingRules({}),
        });
        __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_listenAgreeButton).call(this, $(e.currentTarget));
    }, _AviaRulesComponent_listenAgreeButton = function _AviaRulesComponent_listenAgreeButton(target) {
        $('.js-rules-agree', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root)
            .on('click', e => __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_onRulesButtonClick).call(this, e, target.parents('.js-agree-block').find(':checkbox')));
    }, _AviaRulesComponent_onRulesButtonClick = function _AviaRulesComponent_onRulesButtonClick(e, agreementInput) {
        if (!agreementInput.prop('checked'))
            agreementInput.prop('checked', true).trigger('change');
        __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.hide('main');
    }, _AviaRulesComponent_initializeTranslationStates = function _AviaRulesComponent_initializeTranslationStates() {
        $('.js-carrier-fare-rules', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root).each((_, element) => {
            var _b;
            const block = $(element);
            __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_setTranslationState).call(this, block, (_b = block.html()) !== null && _b !== void 0 ? _b : '');
        });
    }, _AviaRulesComponent_setTranslationState = function _AviaRulesComponent_setTranslationState(block, original) {
        const state = { original };
        const element = block[0];
        if (element)
            __classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").set(element, state);
        block.html(original);
        return state;
    }, _AviaRulesComponent_getTranslationState = function _AviaRulesComponent_getTranslationState(block) {
        var _b;
        const element = block[0];
        if (!element)
            return null;
        let state = __classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").get(element);
        if (!state) {
            state = { original: (_b = block.html()) !== null && _b !== void 0 ? _b : '' };
            __classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").set(element, state);
        }
        return state;
    }, _AviaRulesComponent_toggleTranslation = function _AviaRulesComponent_toggleTranslation() {
        __classPrivateFieldSet(this, _AviaRulesComponent_showTranslation, !__classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f"), "f");
        $('.js-carrier-rules-translation-switcher', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root)
            .val(__classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f") ? 'Показать оригинал' : 'Показать перевод');
        $('.js-carrier-fare-rules', __classPrivateFieldGet(this, _AviaRulesComponent_options, "f").popup.root).each((_, element) => {
            const block = $(element);
            if (block.attr('data-rules-loading') === 'true')
                return;
            if (__classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f"))
                __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_showTranslatedRules).call(this, block);
            else
                __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_showOriginalRules).call(this, block);
        });
    }, _AviaRulesComponent_showOriginalRules = function _AviaRulesComponent_showOriginalRules(block) {
        const state = __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_getTranslationState).call(this, block);
        if (state) {
            block.css('white-space', '');
            block.html(state.original);
        }
    }, _AviaRulesComponent_showTranslatedRules = function _AviaRulesComponent_showTranslatedRules(block) {
        const state = __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_getTranslationState).call(this, block);
        if (!state)
            return;
        block.css('white-space', 'pre-line');
        if (state.translated !== undefined) {
            block.html(state.translated);
            return;
        }
        block.html(__classPrivateFieldGet(_a, _a, "f", _AviaRulesComponent_loaderHtml));
        if (!state.request)
            state.request = __classPrivateFieldGet(this, _AviaRulesComponent_instances, "m", _AviaRulesComponent_translateRulesAsync).call(this, block, state);
    }, _AviaRulesComponent_translateRulesAsync = function _AviaRulesComponent_translateRulesAsync(block, state) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const element = block[0];
            if (!element)
                return;
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").getTranslationUrl, { body: new URLSearchParams({ text: state.original }) });
                if (!__classPrivateFieldGet(this, _AviaRulesComponent_options, "f").responseValidator.process(response)) {
                    if (__classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").get(element) === state && __classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f"))
                        block.html(state.original);
                    return;
                }
                state.translated = (_b = response.data) !== null && _b !== void 0 ? _b : state.original;
                if (__classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").get(element) === state && __classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f"))
                    block.html(state.translated);
            }
            catch (ex) {
                if (__classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").get(element) === state && __classPrivateFieldGet(this, _AviaRulesComponent_showTranslation, "f"))
                    block.html(state.original);
                console.error('Ошибка перевода правил перевозчика', ex);
            }
            finally {
                if (__classPrivateFieldGet(this, _AviaRulesComponent_translationStates, "f").get(element) === state)
                    state.request = undefined;
            }
        });
    };
    _AviaRulesComponent_loaderHtml = { value: '<img src="/img/main/load-sm.gif" />' };
    App.AviaRulesComponent = AviaRulesComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _AviaTimeLimitComponent_instances, _AviaTimeLimitComponent_options, _AviaTimeLimitComponent_getExactTimeLimitExecuting, _AviaTimeLimitComponent_getExactTimeLimit;
    class AviaTimeLimitComponent {
        constructor(options) {
            _AviaTimeLimitComponent_instances.add(this);
            _AviaTimeLimitComponent_options.set(this, void 0);
            _AviaTimeLimitComponent_getExactTimeLimitExecuting.set(this, false);
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _AviaTimeLimitComponent_options, Object.assign(defaults, options), "f");
            $('.js-get-exact-timelimit', __classPrivateFieldGet(this, _AviaTimeLimitComponent_options, "f").root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _AviaTimeLimitComponent_instances, "m", _AviaTimeLimitComponent_getExactTimeLimit).call(this, e); }));
        }
    }
    _AviaTimeLimitComponent_options = new WeakMap(), _AviaTimeLimitComponent_getExactTimeLimitExecuting = new WeakMap(), _AviaTimeLimitComponent_instances = new WeakSet(), _AviaTimeLimitComponent_getExactTimeLimit = function _AviaTimeLimitComponent_getExactTimeLimit(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const variant = __classPrivateFieldGet(this, _AviaTimeLimitComponent_options, "f").getVariant();
            if (!variant)
                return;
            if (__classPrivateFieldGet(this, _AviaTimeLimitComponent_getExactTimeLimitExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _AviaTimeLimitComponent_getExactTimeLimitExecuting, true, "f");
            const target = $(event.currentTarget);
            const topBlock = target.closest('.js-get-timelimit-block');
            const parentBlock = target.closest('.js-get-exact-timelimit-block');
            const awaiter = parentBlock.find('.js-awaiter');
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _AviaTimeLimitComponent_options, "f").url,
                method: 'POST',
                data: {
                    offerKey: variant.key,
                },
            });
            awaiter.show();
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _AviaTimeLimitComponent_options, "f").responseValidator.process(response))
                    return;
                variant.timeLimit = response.data.value;
                variant.timeLimitIsExact = true;
                topBlock.find('.js-get-exact-timelimit-block').hide();
                topBlock.find('.js-time-limit').text(response.data.value);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _AviaTimeLimitComponent_options, "f").responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                awaiter.hide();
                __classPrivateFieldSet(this, _AviaTimeLimitComponent_getExactTimeLimitExecuting, false, "f");
            }
        });
    };
    App.AviaTimeLimitComponent = AviaTimeLimitComponent;
})(App || (App = {}));
var App;
(function (App) {
    class ChangedDataMobile {
        constructor() {
            Object.defineProperty(this, "pageSize", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pageSizes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pageNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "showMore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "groups", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "href", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
    }
    App.ChangedDataMobile = ChangedDataMobile;
})(App || (App = {}));
var App;
(function (App) {
    class ChangedData {
        constructor() {
            Object.defineProperty(this, "pageSize", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pageSizes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pageNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "showMore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "groups", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "href", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
    }
    App.ChangedData = ChangedData;
})(App || (App = {}));
var App;
(function (App) {
    class AviaSelectListModelMobile {
        constructor(options) {
            Object.defineProperty(this, "label", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "data", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.label = options.label;
            this.data = options.data;
            this.items = new Array();
            // to mobile
            const originalItems = options.items || new Array();
            originalItems.forEach(i => {
                this.items.push({
                    label: i.text,
                    name: i.text,
                    value: i.value,
                    checked: i.selected,
                });
            });
        }
    }
    App.AviaSelectListModelMobile = AviaSelectListModelMobile;
})(App || (App = {}));
var App;
(function (App) {
    class AviaSelectListModel {
        get selected() {
            const result = this.items.filter(v => v.selected);
            if (result) {
                return {
                    value: Enumerable.from(result).toJoinedString(',', v => v.value),
                    text: Enumerable.from(result).toJoinedString(',', v => v.text),
                };
            }
            return this.items.length > 0 ? this.items[0] : null;
        }
        constructor(options) {
            Object.defineProperty(this, "label", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "data", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.label = options.label;
            this.data = options.data;
            this.items = options.items || new Array();
        }
    }
    App.AviaSelectListModel = AviaSelectListModel;
})(App || (App = {}));
/// <reference path='IAviaGroup.ts' />
var App;
(function (App) {
    class BonusBookingComPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            this.components.push(new App.Filter());
            const bonusHistory = $('.js-bonus-history');
            $('.js-bonus-period .js-jelect').on('change', (e) => __awaiter(this, void 0, void 0, function* () {
                const target = $(e.target);
                const value = target.valString();
                yield $.post(window.location.pathname, { period: value }, (result) => {
                    bonusHistory.html(result);
                });
            }));
        }
    }
    App.BonusBookingComPage = BonusBookingComPage;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _BonusGoldCollectionPage_filter, _BonusGoldCollectionPage_tabs, _BonusGoldCollectionPage_changeFilterType;
    class BonusGoldCollectionPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _BonusGoldCollectionPage_filter.set(this, void 0);
            _BonusGoldCollectionPage_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _BonusGoldCollectionPage_filter, new App.Filter(), "f");
            __classPrivateFieldSet(this, _BonusGoldCollectionPage_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _BonusGoldCollectionPage_tabs, "f").showActive();
            $('.js-radio-btn-filter-type', this.root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _BonusGoldCollectionPage_changeFilterType).call(_a, e));
            const orderBlock = $('.js-goldcollection-result-order');
            __classPrivateFieldGet(this, _BonusGoldCollectionPage_filter, "f").root.on('submit', (e) => __awaiter(this, void 0, void 0, function* () {
                e.preventDefault();
                $('.js-loading', this.root).toggle();
                orderBlock.empty();
                const data = __classPrivateFieldGet(this, _BonusGoldCollectionPage_filter, "f").root.serialize();
                yield $.post(window.location.pathname, data, (result) => {
                    orderBlock.html(result);
                    $('.js-loading', this.root).toggle();
                });
            }));
        }
    }
    _a = BonusGoldCollectionPage, _BonusGoldCollectionPage_filter = new WeakMap(), _BonusGoldCollectionPage_tabs = new WeakMap(), _BonusGoldCollectionPage_changeFilterType = function _BonusGoldCollectionPage_changeFilterType(event) {
        event.preventDefault();
        const self = $(event.currentTarget);
        const wrapper = self.closest('.js-filter-type-block');
        const input = wrapper.find('input');
        wrapper.find('.js-radio-btn-filter-type').removeClass('_on');
        input.val(self.attr('data-id') || '');
        self.addClass('_on');
    };
    App.BonusGoldCollectionPage = BonusGoldCollectionPage;
})(App || (App = {}));
var App;
(function (App) {
    var _BonusProkachkaPage_instances, _BonusProkachkaPage_form, _BonusProkachkaPage_result, _BonusProkachkaPage_messenger, _BonusProkachkaPage_popup, _BonusProkachkaPage_responseValidator, _BonusProkachkaPage_onSubmitAsync, _BonusProkachkaPage_onProkachkaRules;
    class BonusProkachkaPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _BonusProkachkaPage_instances.add(this);
            _BonusProkachkaPage_form.set(this, void 0);
            _BonusProkachkaPage_result.set(this, void 0);
            _BonusProkachkaPage_messenger.set(this, void 0);
            _BonusProkachkaPage_popup.set(this, void 0);
            _BonusProkachkaPage_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _BonusProkachkaPage_form, new App.Form({ root: $('form', this.root) }), "f");
            __classPrivateFieldSet(this, _BonusProkachkaPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _BonusProkachkaPage_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _BonusProkachkaPage_responseValidator, new App.ResponseValidator({ messenger: __classPrivateFieldGet(this, _BonusProkachkaPage_messenger, "f"), validator: __classPrivateFieldGet(this, _BonusProkachkaPage_form, "f").validator }), "f");
            __classPrivateFieldSet(this, _BonusProkachkaPage_result, $('.js-prokachka-result', this.root), "f");
            $('.js-prokachka-agree', this.root).on('click', () => __classPrivateFieldGet(this, _BonusProkachkaPage_instances, "m", _BonusProkachkaPage_onProkachkaRules).call(this));
            $('.js-prokachka-submit', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if ((_a = __classPrivateFieldGet(this, _BonusProkachkaPage_form, "f")) === null || _a === void 0 ? void 0 : _a.validator.valid())
                    yield __classPrivateFieldGet(this, _BonusProkachkaPage_instances, "m", _BonusProkachkaPage_onSubmitAsync).call(this, e);
            }));
        }
    }
    _BonusProkachkaPage_form = new WeakMap(), _BonusProkachkaPage_result = new WeakMap(), _BonusProkachkaPage_messenger = new WeakMap(), _BonusProkachkaPage_popup = new WeakMap(), _BonusProkachkaPage_responseValidator = new WeakMap(), _BonusProkachkaPage_instances = new WeakSet(), _BonusProkachkaPage_onSubmitAsync = function _BonusProkachkaPage_onSubmitAsync(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _BonusProkachkaPage_form, "f") || !__classPrivateFieldGet(this, _BonusProkachkaPage_form, "f").validator.form())
                return;
            $('.js-loading', this.root).toggle(true);
            __classPrivateFieldGet(this, _BonusProkachkaPage_result, "f").empty();
            const data = __classPrivateFieldGet(this, _BonusProkachkaPage_form, "f").root.serializeArray();
            const xhr = $.ajax({
                url: window.location.pathname,
                method: 'POST',
                data,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _BonusProkachkaPage_responseValidator, "f").process(response))
                    return;
                $('.js-loading', this.root).toggle(false);
                __classPrivateFieldGet(this, _BonusProkachkaPage_popup, "f").show({ content: App.templates.Message({ type: response.data.isSuccess ? 0 /* MessageType.Information */ : 1 /* MessageType.Warning */, text: `${response.data.message}` }) });
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _BonusProkachkaPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _BonusProkachkaPage_onProkachkaRules = function _BonusProkachkaPage_onProkachkaRules() {
        __classPrivateFieldGet(this, _BonusProkachkaPage_popup, "f").show({
            group: 'main',
            title: 'Условия начисления бонусов',
            content: App.templates.Bonus.Messages.ProkachkaRules({}),
        });
    };
    App.BonusProkachkaPage = BonusProkachkaPage;
})(App || (App = {}));
var App;
(function (App) {
    App.templates = {};
    App.findTemplate = (name) => {
        const context = App.templates;
        let currentContext = context;
        const nameParts = name.split('.');
        for (let i = 0; i < nameParts.length; i++) {
            if (typeof currentContext === 'function')
                break;
            currentContext = currentContext[nameParts[i]];
            if (currentContext === undefined)
                break;
        }
        if (typeof currentContext === 'function')
            return currentContext;
        throw new Error(`The template with name ${name} doesn't exist.`);
    };
    const unsafeTemplate = (value) => {
        const defaultOptions = {
            allowProtoPropertiesByDefault: true,
            allowProtoMethodsByDefault: true,
        };
        return (ctx, options) => value(ctx, Object.assign(Object.assign({}, defaultOptions), options));
    };
    App.hbsTemplate = (precompilation) => (unsafeTemplate(Handlebars.template(precompilation)));
})(App || (App = {}));
var App;
(function (App) {
    var _ActionInfoComponent_options;
    class ActionInfoComponent {
        constructor(options) {
            _ActionInfoComponent_options.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _ActionInfoComponent_options, Object.assign(defaults, options), "f");
            __classPrivateFieldGet(this, _ActionInfoComponent_options, "f").root.on('click', '.js-action-info', e => {
                const target = $(e.currentTarget);
                const container = target.find('.js-action-info-container');
                container.toggle();
                if (container.is(':visible'))
                    container.trigger("action-info:show" /* Events.ActionInfoShow */, [{ type: target.attr('data-type'), key: target.attr('data-key') }]);
                else
                    container.trigger("action-info:hide" /* Events.ActionInfoHide */, [{ type: target.attr('data-type'), key: target.attr('data-key') }]);
            });
        }
    }
    _ActionInfoComponent_options = new WeakMap();
    App.ActionInfoComponent = ActionInfoComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _AgentBlackListMobile_instances, _AgentBlackListMobile_dialog, _AgentBlackListMobile_dialogId, _AgentBlackListMobile_popup, _AgentBlackListMobile_options, _AgentBlackListMobile_isAgree, _AgentBlackListMobile_onAgreeButtonClick, _AgentBlackListMobile_onDisagreeButtonClick;
    class AgentBlackListMobile {
        constructor(options) {
            _AgentBlackListMobile_instances.add(this);
            _AgentBlackListMobile_dialog.set(this, void 0);
            _AgentBlackListMobile_dialogId.set(this, void 0);
            _AgentBlackListMobile_popup.set(this, void 0);
            _AgentBlackListMobile_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AgentBlackListMobile_isAgree.set(this, void 0);
            const defaults = { container: App.app.appContainer };
            __classPrivateFieldSet(this, _AgentBlackListMobile_options, Object.assign(defaults, options), "f");
            const root = $('.js-agent-black-list-component', __classPrivateFieldGet(this, _AgentBlackListMobile_options, "f").container);
            if (root.length <= 0 || !App.app.userSettings.isAgentInBlackList)
                return;
            this.root = root;
            __classPrivateFieldSet(this, _AgentBlackListMobile_dialog, $('.js-agent-black-list-component-dialog', root), "f");
            __classPrivateFieldGet(this, _AgentBlackListMobile_dialog, "f")[0].id = __classPrivateFieldSet(this, _AgentBlackListMobile_dialogId, App.Guid.newGuid(), "f");
            const agreeButton = $('.js-agent-black-list-component-agree-button', __classPrivateFieldGet(this, _AgentBlackListMobile_dialog, "f"));
            const disagreeButton = $('.js-agent-black-list-component-disagree-button', __classPrivateFieldGet(this, _AgentBlackListMobile_dialog, "f"));
            __classPrivateFieldSet(this, _AgentBlackListMobile_popup, new App.Popup({
                onShow: () => $('.js-popup-close', __classPrivateFieldGet(this, _AgentBlackListMobile_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _AgentBlackListMobile_popup, "f").hide()),
            }), "f");
            agreeButton.on('click', e => __classPrivateFieldGet(this, _AgentBlackListMobile_instances, "m", _AgentBlackListMobile_onAgreeButtonClick).call(this, e));
            disagreeButton.on('click', e => __classPrivateFieldGet(this, _AgentBlackListMobile_instances, "m", _AgentBlackListMobile_onDisagreeButtonClick).call(this, e));
            if (App.app.url.routeData.action === 'book') {
                Fancybox.show([{ src: `#${__classPrivateFieldGet(this, _AgentBlackListMobile_dialogId, "f")}` }]);
            }
        }
        checkAgree() {
            if (!__classPrivateFieldGet(this, _AgentBlackListMobile_isAgree, "f"))
                Fancybox.show([{ src: `#${__classPrivateFieldGet(this, _AgentBlackListMobile_dialogId, "f")}` }]);
            return __classPrivateFieldGet(this, _AgentBlackListMobile_isAgree, "f");
        }
        /**
         * Инициализация AgentBlackListMobile.
         * @param root
         * @returns
         */
        static Creates( /* root?: string | JQuery */) {
        }
    }
    _AgentBlackListMobile_dialog = new WeakMap(), _AgentBlackListMobile_dialogId = new WeakMap(), _AgentBlackListMobile_popup = new WeakMap(), _AgentBlackListMobile_options = new WeakMap(), _AgentBlackListMobile_isAgree = new WeakMap(), _AgentBlackListMobile_instances = new WeakSet(), _AgentBlackListMobile_onAgreeButtonClick = function _AgentBlackListMobile_onAgreeButtonClick(e) {
        e.preventDefault();
        const bookingForm = $('.js-form-booking, .js-form-order, .js-form-room-booking');
        const useForm = __classPrivateFieldGet(this, _AgentBlackListMobile_options, "f").useForm ? 'form.' : '';
        const hiddenInput = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', `${useForm}IsAgentInBlackList`)
            .attr('value', 'true');
        hiddenInput.appendTo(bookingForm);
        __classPrivateFieldSet(this, _AgentBlackListMobile_isAgree, true, "f");
        this.root.trigger("agentInBlackList:agree" /* Events.AgentInBlackListAgree */);
        Fancybox.close(true);
    }, _AgentBlackListMobile_onDisagreeButtonClick = function _AgentBlackListMobile_onDisagreeButtonClick(e) {
        e.preventDefault();
        __classPrivateFieldSet(this, _AgentBlackListMobile_isAgree, false, "f");
        Fancybox.close(true);
    };
    App.AgentBlackListMobile = AgentBlackListMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _AgentBlackListComponent_instances, _AgentBlackListComponent_dialog, _AgentBlackListComponent_dialogId, _AgentBlackListComponent_popup, _AgentBlackListComponent_options, _AgentBlackListComponent_isAgree, _AgentBlackListComponent_onAgreeButtonClick, _AgentBlackListComponent_onDisagreeButtonClick;
    class AgentBlackListComponent {
        constructor(options) {
            _AgentBlackListComponent_instances.add(this);
            _AgentBlackListComponent_dialog.set(this, void 0);
            _AgentBlackListComponent_dialogId.set(this, void 0);
            _AgentBlackListComponent_popup.set(this, void 0);
            _AgentBlackListComponent_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _AgentBlackListComponent_isAgree.set(this, void 0);
            const defaults = { container: App.app.appContainer };
            __classPrivateFieldSet(this, _AgentBlackListComponent_options, Object.assign(defaults, options), "f");
            const root = $('.js-agent-black-list-component', __classPrivateFieldGet(this, _AgentBlackListComponent_options, "f").container);
            if (root.length <= 0 || !App.app.userSettings.isAgentInBlackList)
                return;
            this.root = root;
            __classPrivateFieldSet(this, _AgentBlackListComponent_dialog, $('.js-agent-black-list-component-dialog', root), "f");
            __classPrivateFieldGet(this, _AgentBlackListComponent_dialog, "f")[0].id = __classPrivateFieldSet(this, _AgentBlackListComponent_dialogId, App.Guid.newGuid(), "f");
            const agreeButton = $('.js-agent-black-list-component-agree-button', __classPrivateFieldGet(this, _AgentBlackListComponent_dialog, "f"));
            const disagreeButton = $('.js-agent-black-list-component-disagree-button', __classPrivateFieldGet(this, _AgentBlackListComponent_dialog, "f"));
            __classPrivateFieldSet(this, _AgentBlackListComponent_popup, new App.Popup({
                onShow: () => $('.js-popup-close', __classPrivateFieldGet(this, _AgentBlackListComponent_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _AgentBlackListComponent_popup, "f").hide()),
            }), "f");
            agreeButton.on('click', e => __classPrivateFieldGet(this, _AgentBlackListComponent_instances, "m", _AgentBlackListComponent_onAgreeButtonClick).call(this, e));
            disagreeButton.on('click', e => __classPrivateFieldGet(this, _AgentBlackListComponent_instances, "m", _AgentBlackListComponent_onDisagreeButtonClick).call(this, e));
            if (App.app.url.routeData.action === 'book') {
                Fancybox.show([{ src: `#${__classPrivateFieldGet(this, _AgentBlackListComponent_dialogId, "f")}` }]);
            }
        }
        checkAgree() {
            if (!__classPrivateFieldGet(this, _AgentBlackListComponent_isAgree, "f"))
                Fancybox.show([{ src: `#${__classPrivateFieldGet(this, _AgentBlackListComponent_dialogId, "f")}` }]);
            return __classPrivateFieldGet(this, _AgentBlackListComponent_isAgree, "f");
        }
    }
    _AgentBlackListComponent_dialog = new WeakMap(), _AgentBlackListComponent_dialogId = new WeakMap(), _AgentBlackListComponent_popup = new WeakMap(), _AgentBlackListComponent_options = new WeakMap(), _AgentBlackListComponent_isAgree = new WeakMap(), _AgentBlackListComponent_instances = new WeakSet(), _AgentBlackListComponent_onAgreeButtonClick = function _AgentBlackListComponent_onAgreeButtonClick(e) {
        e.preventDefault();
        const bookingForm = $('.js-form-booking, .js-form-order, .js-form-room-booking, .js-passport-form, .js-quick-booking-form');
        const useForm = __classPrivateFieldGet(this, _AgentBlackListComponent_options, "f").useForm ? 'form.' : '';
        const hiddenInput = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', `${useForm}IsAgentInBlackList`)
            .attr('value', 'true');
        hiddenInput.appendTo(bookingForm);
        __classPrivateFieldSet(this, _AgentBlackListComponent_isAgree, true, "f");
        this.root.trigger("agentInBlackList:agree" /* Events.AgentInBlackListAgree */);
        Fancybox.close(true);
    }, _AgentBlackListComponent_onDisagreeButtonClick = function _AgentBlackListComponent_onDisagreeButtonClick(e) {
        e.preventDefault();
        __classPrivateFieldSet(this, _AgentBlackListComponent_isAgree, false, "f");
        Fancybox.close(true);
    };
    App.AgentBlackListComponent = AgentBlackListComponent;
})(App || (App = {}));
var App;
(function (App) {
    class AjaxError extends Error {
        constructor(status) {
            super('Ajax error');
            Object.defineProperty(this, "status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, AjaxError.prototype);
            this.status = status;
        }
    }
    App.AjaxError = AjaxError;
})(App || (App = {}));
var App;
(function (App) {
    App.nameof = (name) => name;
})(App || (App = {}));
var App;
(function (App) {
    var _Authentication_instances, _a, _Authentication_options, _Authentication_userContainer, _Authentication_loginExecuting, _Authentication_reqLoginExecuting, _Authentication_logoutExecuting, _Authentication_popup, _Authentication_responseValidator, _Authentication_consoleResponseValidator, _Authentication_reqResponseValidator, _Authentication_form, _Authentication_reqForm, _Authentication_onShowUserPanelClick, _Authentication_onShowUserDialogClick, _Authentication_renderAuthDialog, _Authentication_onLoginClick, _Authentication_executeLoginRequest, _Authentication_removePathLastSegment, _Authentication_onCloseUserDialogClick, _Authentication_onShowRequiredUserDialogClick, _Authentication_onRequiredLoginClick, _Authentication_onCloseRequiredUserDialogClick, _Authentication_onLogoutClick, _Authentication_onCloseUserPanelClick, _Authentication_updateUserInfo;
    class Authentication {
        constructor(options) {
            _Authentication_instances.add(this);
            _Authentication_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _Authentication_userContainer.set(this, void 0);
            _Authentication_loginExecuting.set(this, false);
            _Authentication_reqLoginExecuting.set(this, false);
            _Authentication_logoutExecuting.set(this, false);
            // TODO #forgotPasswordExecuting = false;
            _Authentication_popup.set(this, void 0);
            _Authentication_responseValidator.set(this, void 0);
            _Authentication_consoleResponseValidator.set(this, void 0);
            _Authentication_reqResponseValidator.set(this, void 0);
            _Authentication_form.set(this, void 0);
            _Authentication_reqForm.set(this, void 0);
            const defaults = {
                root: '.js-authorization',
                loginUrl: '/account/login',
                statusUrl: '/account/status',
                logoutUrl: '/account/logout',
                // forgotPasswordUrl: '/account/forgotpassword',
                lockoutUrl: '/account/lockout',
            };
            __classPrivateFieldSet(this, _Authentication_options, Object.assign(defaults, options), "f");
            const { root } = __classPrivateFieldGet(this, _Authentication_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            __classPrivateFieldSet(this, _Authentication_userContainer, this.root.find('.js-authorization-user'), "f");
            __classPrivateFieldSet(this, _Authentication_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _Authentication_responseValidator, new App.ResponseValidatorOld({ messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _Authentication_popup, "f")) }), "f");
            __classPrivateFieldSet(this, _Authentication_consoleResponseValidator, new App.ResponseValidatorOld({ messenger: App.ConsoleMessenger.instance }), "f");
            this.root.on('click', '.js-authorization-btn-user', () => __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onShowUserPanelClick).call(this));
            this.root.on('click', '.js-authorization-btn-login', () => __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onShowUserDialogClick).call(this));
            $(document).on("app:loggingin" /* Events.LoggingIn */, () => __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onShowRequiredUserDialogClick).call(this));
            // TODO: не реализовано this.root.on('click', '.js-authorization-btn-rmd', () => this.onShowForgotPasswordClick());
            this.root.on('click', '.js-authorization-userdialog .js-auth-login', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onLoginClick).call(this, e); }));
            this.root.on('click', '.js-authorization-userdialog .js-close', () => __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onCloseUserDialogClick).call(this));
            // TODO: не реализовано this.root.on('click', '.js-authorization-userdialog .js-authorization-userdialog-remindblock', () => this.onCloseUserDialogClick());
            this.root.on('keyup', '.js-authorization-userdialog input', (e) => __awaiter(this, void 0, void 0, function* () {
                if (e.key === App.Key.Enter)
                    yield __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onLoginClick).call(this, e);
                if (e.key === App.Key.Escape)
                    __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onCloseUserDialogClick).call(this);
            }));
            this.root.on('click', '.js-authorization-userpanel .js-auth-logout', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onLogoutClick).call(this, e); }));
            this.root.on('click', '.js-authorization-userpanel .js-close', () => __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onCloseUserPanelClick).call(this));
            // TODO: не реализовано loginDialog.on('click', '.enterremind', async () => await this.onForgotPasswordClick());
        }
        getStatus() {
            return __awaiter(this, void 0, void 0, function* () {
                const xhr = $.ajax({
                    url: __classPrivateFieldGet(this, _Authentication_options, "f").statusUrl,
                });
                try {
                    const response = yield xhr;
                    if (!__classPrivateFieldGet(this, _Authentication_consoleResponseValidator, "f").process(response))
                        return App.app.userSettings.isAuthenticated;
                    if (App.app.userSettings.isAuthenticated !== response.data.isAuthenticated
                        || App.app.userSettings.username !== response.data.username)
                        __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_updateUserInfo).call(this, response.data);
                    this.root.trigger("app:userstatus" /* Events.UserStatus */, [response.data]);
                }
                catch (ex) {
                    console.log('Failed retrieve current user status from the server. Using the last cached value...');
                }
                return App.app.userSettings.isAuthenticated;
            });
        }
    }
    _a = Authentication, _Authentication_options = new WeakMap(), _Authentication_userContainer = new WeakMap(), _Authentication_loginExecuting = new WeakMap(), _Authentication_reqLoginExecuting = new WeakMap(), _Authentication_logoutExecuting = new WeakMap(), _Authentication_popup = new WeakMap(), _Authentication_responseValidator = new WeakMap(), _Authentication_consoleResponseValidator = new WeakMap(), _Authentication_reqResponseValidator = new WeakMap(), _Authentication_form = new WeakMap(), _Authentication_reqForm = new WeakMap(), _Authentication_instances = new WeakSet(), _Authentication_onShowUserPanelClick = function _Authentication_onShowUserPanelClick() {
        const username = this.root.find('.js-authorization-btn-user').text();
        this.root.append(App.templates.AuthPanel({ username }));
    }, _Authentication_onShowUserDialogClick = function _Authentication_onShowUserDialogClick() {
        this.root.append(__classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_renderAuthDialog).call(this));
        const container = this.root.find('.js-authorization-userdialog');
        container.find('input').first().trigger('focus');
        const filter = new App.Filter({ root: container.find('form') });
        __classPrivateFieldSet(this, _Authentication_form, new App.Form({ root: filter.root }), "f");
    }, _Authentication_renderAuthDialog = function _Authentication_renderAuthDialog() {
        return App.templates.AuthDialog({
            restorePasswordUrl: __classPrivateFieldGet(this, _Authentication_options, "f").restorePasswordUrl,
            registrationUrl: __classPrivateFieldGet(this, _Authentication_options, "f").registrationUrl,
        });
    }, _Authentication_onLoginClick = function _Authentication_onLoginClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _Authentication_form, "f") || !__classPrivateFieldGet(this, _Authentication_form, "f").validator.form())
                return;
            if (__classPrivateFieldGet(this, _Authentication_loginExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _Authentication_loginExecuting, true, "f");
            const data = __classPrivateFieldGet(this, _Authentication_form, "f").root.serializeArray();
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _Authentication_options, "f").loginUrl,
                method: 'POST',
                data,
            });
            const popupGroup = __classPrivateFieldGet(this, _Authentication_popup, "f").show({
                group: 'login',
                content: App.templates.Messages.Executing({}),
                modal: true,
                delay: 2000,
            });
            try {
                const success = yield __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_executeLoginRequest).call(this, xhr, __classPrivateFieldGet(this, _Authentication_responseValidator, "f"));
                if (success)
                    __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onCloseUserDialogClick).call(this);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _Authentication_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _Authentication_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _Authentication_loginExecuting, false, "f");
            }
        });
    }, _Authentication_executeLoginRequest = function _Authentication_executeLoginRequest(xhr, validator) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield xhr;
            if (!validator.process(response))
                return false;
            if (response.data.redirectUrl) {
                window.location.replace(response.data.redirectUrl);
                return false;
            }
            __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_updateUserInfo).call(this, response.data);
            const baseUrl = __classPrivateFieldGet(_a, _a, "m", _Authentication_removePathLastSegment).call(_a, App.Application.urls.login);
            if (window.location.pathname.startsWith(baseUrl))
                window.location.href = App.app.settings.defaultUrl;
            else
                this.root.trigger("app:loggedin" /* Events.LoggedIn */, [response.data]);
            return true;
        });
    }, _Authentication_removePathLastSegment = function _Authentication_removePathLastSegment(path) {
        if (path == null || path.length <= 0)
            return '/';
        let pos = path.lastIndexOf('/', path.length - 2);
        if (pos < 0)
            return '/';
        if (path.endsWith('/'))
            pos += 1;
        return path.substring(0, pos);
    }, _Authentication_onCloseUserDialogClick = function _Authentication_onCloseUserDialogClick() {
        __classPrivateFieldSet(this, _Authentication_form, undefined, "f");
        this.root.find('.js-authorization-userdialog').remove();
        return false;
    }, _Authentication_onShowRequiredUserDialogClick = function _Authentication_onShowRequiredUserDialogClick() {
        const popupId = __classPrivateFieldGet(this, _Authentication_popup, "f").show({
            group: 'requiredLogin',
            content: __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_renderAuthDialog).call(this),
            modal: true,
        });
        const container = __classPrivateFieldGet(this, _Authentication_popup, "f").root.find('.js-authorization-userdialog');
        container.find('input').first().trigger('focus');
        const filter = new App.Filter({ root: container.find('form') });
        __classPrivateFieldSet(this, _Authentication_reqForm, new App.Form({ root: filter.root }), "f");
        __classPrivateFieldSet(this, _Authentication_reqResponseValidator, new App.ResponseValidatorOld({
            messenger: new App.BlockMessenger(new App.Messages({ root: '.js-auth-messages' })),
            validator: __classPrivateFieldGet(this, _Authentication_reqForm, "f").validator,
        }), "f");
        __classPrivateFieldGet(this, _Authentication_popup, "f").root.on('click', '.js-authorization-userdialog .js-auth-login', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onRequiredLoginClick).call(this, e, popupId); }));
        __classPrivateFieldGet(this, _Authentication_popup, "f").root.on('click', '.js-authorization-userdialog .js-close', e => __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onCloseRequiredUserDialogClick).call(this, e, popupId));
    }, _Authentication_onRequiredLoginClick = function _Authentication_onRequiredLoginClick(e, popupId) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _Authentication_reqForm, "f") || !__classPrivateFieldGet(this, _Authentication_reqForm, "f").validator.form())
                return;
            if (__classPrivateFieldGet(this, _Authentication_reqLoginExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _Authentication_reqLoginExecuting, true, "f");
            const data = __classPrivateFieldGet(this, _Authentication_reqForm, "f").root.serializeArray();
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _Authentication_options, "f").loginUrl,
                method: 'POST',
                data,
            });
            try {
                const success = yield __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_executeLoginRequest).call(this, xhr, __classPrivateFieldGet(this, _Authentication_reqResponseValidator, "f"));
                if (success)
                    __classPrivateFieldGet(this, _Authentication_popup, "f").hide(popupId);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _Authentication_reqResponseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _Authentication_reqLoginExecuting, false, "f");
            }
        });
    }, _Authentication_onCloseRequiredUserDialogClick = function _Authentication_onCloseRequiredUserDialogClick(e, popupId) {
        __classPrivateFieldSet(this, _Authentication_reqForm, undefined, "f");
        __classPrivateFieldGet(this, _Authentication_popup, "f").hide(popupId);
        return false;
    }, _Authentication_onLogoutClick = function _Authentication_onLogoutClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (__classPrivateFieldGet(this, _Authentication_logoutExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _Authentication_logoutExecuting, true, "f");
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _Authentication_options, "f").logoutUrl,
                method: 'POST',
            });
            const popupGroup = __classPrivateFieldGet(this, _Authentication_popup, "f").show({
                group: 'logout',
                content: App.templates.Messages.Executing({}),
                modal: true,
                delay: 2000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _Authentication_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_updateUserInfo).call(this, {
                    isAuthenticated: false,
                    username: '',
                    name: '',
                });
                __classPrivateFieldGet(this, _Authentication_instances, "m", _Authentication_onCloseUserPanelClick).call(this);
                this.root.trigger("app:loggedout" /* Events.LoggedOut */);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _Authentication_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _Authentication_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _Authentication_logoutExecuting, false, "f");
            }
        });
    }, _Authentication_onCloseUserPanelClick = function _Authentication_onCloseUserPanelClick() {
        this.root.find('.js-authorization-userpanel').remove();
        return false;
    }, _Authentication_updateUserInfo = function _Authentication_updateUserInfo(data) {
        __classPrivateFieldGet(this, _Authentication_userContainer, "f").empty();
        if (data.isAuthenticated) {
            this.root.addClass('_authorize');
            __classPrivateFieldGet(this, _Authentication_userContainer, "f").append(App.templates.AuthenticatedUser({
                username: data.username,
                name: data.name,
            }));
        }
        else {
            this.root.removeClass('_authorize');
            __classPrivateFieldGet(this, _Authentication_userContainer, "f").append(App.templates.UnauthenticatedUser({}));
        }
    };
    App.Authentication = Authentication;
})(App || (App = {}));
var App;
(function (App) {
    var _BestPriceComponent_instances, _BestPriceComponent_dialog, _BestPriceComponent_dialogId, _BestPriceComponent_formElement, _BestPriceComponent_form, _BestPriceComponent_responseValidator, _BestPriceComponent_popup, _BestPriceComponent_options, _BestPriceComponent_onButtonClick, _BestPriceComponent_onSendButtonClick;
    class BestPriceComponent {
        constructor(options) {
            _BestPriceComponent_instances.add(this);
            _BestPriceComponent_dialog.set(this, void 0);
            _BestPriceComponent_dialogId.set(this, void 0);
            _BestPriceComponent_formElement.set(this, void 0);
            _BestPriceComponent_form.set(this, void 0);
            _BestPriceComponent_responseValidator.set(this, void 0);
            _BestPriceComponent_popup.set(this, void 0);
            _BestPriceComponent_options.set(this, void 0);
            const defaults = {
                container: App.app.appContainer,
                getData: () => [],
            };
            __classPrivateFieldSet(this, _BestPriceComponent_options, Object.assign(defaults, options), "f");
            const root = $('.js-best-price-component', __classPrivateFieldGet(this, _BestPriceComponent_options, "f").container);
            if (root.length <= 0)
                return;
            const button = $('.js-best-price-component-button', root);
            __classPrivateFieldSet(this, _BestPriceComponent_dialog, $('.js-best-price-component-dialog', root), "f");
            __classPrivateFieldGet(this, _BestPriceComponent_dialog, "f")[0].id = __classPrivateFieldSet(this, _BestPriceComponent_dialogId, App.Guid.newGuid(), "f");
            const sendButton = $('.js-best-price-component-send-button', __classPrivateFieldGet(this, _BestPriceComponent_dialog, "f"));
            __classPrivateFieldSet(this, _BestPriceComponent_formElement, $('form', __classPrivateFieldGet(this, _BestPriceComponent_dialog, "f")), "f");
            __classPrivateFieldSet(this, _BestPriceComponent_form, new App.Form({ root: __classPrivateFieldGet(this, _BestPriceComponent_formElement, "f") }), "f");
            __classPrivateFieldSet(this, _BestPriceComponent_responseValidator, new App.ResponseValidator({
                messenger: new App.BlockMessenger(new App.Messages()),
                validator: __classPrivateFieldGet(this, _BestPriceComponent_form, "f").validator,
            }), "f");
            __classPrivateFieldSet(this, _BestPriceComponent_popup, new App.Popup({
                onShow: () => $('.js-popup-close', __classPrivateFieldGet(this, _BestPriceComponent_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _BestPriceComponent_popup, "f").hide()),
            }), "f");
            button.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _BestPriceComponent_instances, "m", _BestPriceComponent_onButtonClick).call(this, e); }));
            sendButton.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _BestPriceComponent_instances, "m", _BestPriceComponent_onSendButtonClick).call(this, e); }));
        }
    }
    _BestPriceComponent_dialog = new WeakMap(), _BestPriceComponent_dialogId = new WeakMap(), _BestPriceComponent_formElement = new WeakMap(), _BestPriceComponent_form = new WeakMap(), _BestPriceComponent_responseValidator = new WeakMap(), _BestPriceComponent_popup = new WeakMap(), _BestPriceComponent_options = new WeakMap(), _BestPriceComponent_instances = new WeakSet(), _BestPriceComponent_onButtonClick = function _BestPriceComponent_onButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            Fancybox.show([{ src: `#${__classPrivateFieldGet(this, _BestPriceComponent_dialogId, "f")}` }]);
        });
    }, _BestPriceComponent_onSendButtonClick = function _BestPriceComponent_onSendButtonClick(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _BestPriceComponent_form, "f").validator.form())
                return;
            const body = new FormData(__classPrivateFieldGet(this, _BestPriceComponent_formElement, "f").get(0));
            const data = __classPrivateFieldGet(this, _BestPriceComponent_options, "f").getData();
            data.push({ key: 'currentBasketLink', value: window.location.href });
            $.each(data, (_, item) => body.append(item.key, item.value));
            try {
                const response = yield App.app.http.postPwJson(App.app.url.route(App.FitPageUrls.SaveOrderFromBestPrice), { body, signal });
                if (!__classPrivateFieldGet(this, _BestPriceComponent_responseValidator, "f").process(response))
                    return;
                Fancybox.close(true);
                __classPrivateFieldGet(this, _BestPriceComponent_popup, "f").show({
                    group: 'main',
                    content: `<div>Ваш запрос <a target="_blank" href="/fit/${response.data.id}">${response.data.id}</a> успешно отправлен, отслеживайте состояние в системе PAC Fit.</div>`,
                });
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _BestPriceComponent_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.BestPriceComponent = BestPriceComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _BlockMessenger_messages;
    class BlockMessenger {
        constructor(messages) {
            _BlockMessenger_messages.set(this, void 0);
            __classPrivateFieldSet(this, _BlockMessenger_messages, messages, "f");
        }
        show(messageOrMessages, options) {
            __classPrivateFieldGet(this, _BlockMessenger_messages, "f").show(messageOrMessages, options);
        }
        hide(group) {
            __classPrivateFieldGet(this, _BlockMessenger_messages, "f").hide(group);
        }
    }
    _BlockMessenger_messages = new WeakMap();
    App.BlockMessenger = BlockMessenger;
})(App || (App = {}));
var App;
(function (App) {
    var _BookingTouristMobile_instances, _a, _BookingTouristMobile_limitExistingTouristByAges, _BookingTouristMobile_prepareExistingTourist;
    /**
     * Класс для описания туриста для формы бронирования
     */
    class BookingTouristMobile {
        /**
         *
         * @param minAge Минимальный возраст
         * @param maxAge Максимальный возраст
         * @param countdownDate дата отсчета для расчета возраста (например, дата начала экскурсии или дата заезда в отель)
         * @param allExistingPassengers все существующе туристы (не разделеные на взрослых и детей)
         */
        constructor(minAge, maxAge, countdownDate, allExistingPassengers) {
            _BookingTouristMobile_instances.add(this);
            Object.defineProperty(this, "minBirthDay", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maxBirthDay", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minBirthDayString", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maxBirthDayString", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "existingPassengers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "existingPassengerData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "findTouristData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const year = countdownDate.getFullYear();
            const month = countdownDate.getMonth();
            const day = countdownDate.getDate();
            // TODO: взято из текущего пак ворда из Активити контроллера
            this.minBirthDay = new Date(year - maxAge - 1, month, day + 1);
            this.minBirthDayString = App.formatDate(this.minBirthDay, 'isoDate');
            this.maxBirthDay = new Date(year - minAge, month, day + 1);
            this.maxBirthDayString = App.formatDate(this.maxBirthDay, 'isoDate');
            const limitedByAgeExistingTourists = __classPrivateFieldGet(this, _BookingTouristMobile_instances, "m", _BookingTouristMobile_limitExistingTouristByAges).call(this, allExistingPassengers);
            if (limitedByAgeExistingTourists)
                this.existingPassengers = __classPrivateFieldGet(_a, _a, "m", _BookingTouristMobile_prepareExistingTourist).call(_a, limitedByAgeExistingTourists);
            //
            // this.existingPassengerData = ExistingPassengersMobile.ViewModelByExistingPassengers(allExistingPassengers);
            this.existingPassengerData = App.ExistingPassengersMobile.ViewModelByExistingPassengers(limitedByAgeExistingTourists);
            this.findTouristData = App.FindTouristMobile.ViewModel({ minLength: 4 });
        }
    }
    _a = BookingTouristMobile, _BookingTouristMobile_instances = new WeakSet(), _BookingTouristMobile_limitExistingTouristByAges = function _BookingTouristMobile_limitExistingTouristByAges(allExistingPassengers) {
        if (!allExistingPassengers)
            return undefined;
        return allExistingPassengers.filter(item => {
            const birthDay = new Date(item.birthday);
            return birthDay > this.minBirthDay && birthDay < this.maxBirthDay;
        });
    }, _BookingTouristMobile_prepareExistingTourist = function _BookingTouristMobile_prepareExistingTourist(existingPassengers) {
        // делаем через Object.assign, т.к. нам не надо, чтобы отформатированные поля сохранялись в исходном массиве, особенно дата
        return existingPassengers
            .map(item => (Object.assign(Object.assign({}, item), { 
            // TODO: здесь нестрогое равенство, потому что с сервера приходит число (на C#-enum, в строку если преобразовывать,
            // анонимный класс не подходит, а я не стала плодить классов на C#, т.к. там уже есть класс ExistingPassengers и он мне
            // тоже не подходит)
            /* eslint-disable eqeqeq */
            gender: item.gender == '1' ? 'Male' : 'Female', 
            /* eslint-enable eqeqeq */
            birthday: App.formatDate(new Date(item.birthday), 'shortDate') })));
    };
    App.BookingTouristMobile = BookingTouristMobile;
})(App || (App = {}));
/// <reference path='BookingTourist.Mobile.ts' />
var App;
(function (App) {
    /**
     * Класс для описания РЕБЕНКА-туриста для формы бронирования
     */
    class BookingChildMobile extends App.BookingTouristMobile {
        constructor(minAge, maxAge, countdownDate, childAge, allExistingPassengers) {
            super(minAge, childAge, countdownDate, allExistingPassengers);
            Object.defineProperty(this, "childAge", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.childAge = childAge;
        }
    }
    App.BookingChildMobile = BookingChildMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _BookingTourist_instances, _a, _BookingTourist_limitExistingTouristByAges, _BookingTourist_prepareExistingTourist;
    /**
     * Класс для описания туриста для формы бронирования
     */
    class BookingTourist {
        /**
         *
         * @param minAge Минимальный возраст
         * @param maxAge Максимальный возраст
         * @param countdownDate дата отсчета для расчета возраста (например, дата начала экскурсии или дата заезда в отель)
         * @param allExistingPassengers все существующе туристы (не разделеные на взрослых и детей)
         */
        constructor(minAge, maxAge, countdownDate, allExistingPassengers) {
            _BookingTourist_instances.add(this);
            Object.defineProperty(this, "minBirthDay", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maxBirthDay", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minBirthDayString", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maxBirthDayString", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "existingPassengers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const year = countdownDate.getFullYear();
            const month = countdownDate.getMonth();
            const day = countdownDate.getDate();
            // TODO: взято из текущего пак ворда из Активити контроллера
            this.minBirthDay = new Date(year - maxAge - 1, month, day + 1);
            this.minBirthDayString = App.formatDate(this.minBirthDay, 'isoDate');
            this.maxBirthDay = new Date(year - minAge, month, day + 1);
            this.maxBirthDayString = App.formatDate(this.maxBirthDay, 'isoDate');
            const limitedByAgeExistingTourists = __classPrivateFieldGet(this, _BookingTourist_instances, "m", _BookingTourist_limitExistingTouristByAges).call(this, allExistingPassengers);
            if (limitedByAgeExistingTourists)
                this.existingPassengers = __classPrivateFieldGet(_a, _a, "m", _BookingTourist_prepareExistingTourist).call(_a, limitedByAgeExistingTourists);
        }
    }
    _a = BookingTourist, _BookingTourist_instances = new WeakSet(), _BookingTourist_limitExistingTouristByAges = function _BookingTourist_limitExistingTouristByAges(allExistingPassengers) {
        if (!allExistingPassengers)
            return undefined;
        return allExistingPassengers.filter(item => {
            const birthDay = new Date(item.birthday);
            return birthDay > this.minBirthDay && birthDay < this.maxBirthDay;
        });
    }, _BookingTourist_prepareExistingTourist = function _BookingTourist_prepareExistingTourist(existingPassengers) {
        // делаем через Object.assign, т.к. нам не надо, чтобы отформатированные поля сохранялись в исходном массиве, особенно дата
        return existingPassengers
            .map(item => (Object.assign(Object.assign({}, item), { 
            // TODO: здесь нестрогое равенство, потому что с сервера приходит число (на C#-enum, в строку если преобразовывать,
            // анонимный класс не подходит, а я не стала плодить классов на C#, т.к. там уже есть класс ExistingPassengers и он мне
            // тоже не подходит)
            /* eslint-disable eqeqeq */
            gender: item.gender == '1' ? 'Male' : 'Female', 
            /* eslint-enable eqeqeq */
            birthday: App.formatDate(new Date(item.birthday), 'shortDate') })));
    };
    App.BookingTourist = BookingTourist;
})(App || (App = {}));
/// <reference path='BookingTourist.ts' />
var App;
(function (App) {
    /**
     * Класс для описания РЕБЕНКА-туриста для формы бронирования
     */
    class BookingChild extends App.BookingTourist {
        constructor(minAge, maxAge, countdownDate, childAge, allExistingPassengers) {
            super(minAge, childAge, countdownDate, allExistingPassengers);
            Object.defineProperty(this, "childAge", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "showChildAge", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.childAge = childAge;
            this.showChildAge = childAge != null;
        }
    }
    App.BookingChild = BookingChild;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _ComparerBuilder_criteria, _ComparerBuilder_createComparer;
    App.defaultComparer = (a, b) => {
        return a === b ? 0 : a > b ? 1 : -1;
    };
    App.defaultNumberComparer = (a, b) => {
        return a - b;
    };
    App.defaultStringComparer = (a, b) => {
        return a.localeCompare(b);
    };
    App.defaultDateComparer = (a, b) => {
        return a.getTime() - b.getTime();
    };
    App.StringComparer = (() => {
        const currentLocale = new Intl.Collator(navigator.language, { usage: 'sort', sensitivity: 'variant', caseFirst: 'upper' });
        const currentLocaleIgnoreCase = new Intl.Collator(navigator.language, { usage: 'sort', sensitivity: 'accent', caseFirst: 'upper' });
        const invariantLocale = new Intl.Collator('en', { usage: 'sort', sensitivity: 'variant', caseFirst: 'upper' });
        const invariantLocaleIgnoreCase = new Intl.Collator('en', { usage: 'sort', sensitivity: 'accent', caseFirst: 'upper' });
        return {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            currentLocale: currentLocale.compare,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            currentLocaleIgnoreCase: currentLocaleIgnoreCase.compare,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            invariantLocale: invariantLocale.compare,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            invariantLocaleIgnoreCase: invariantLocaleIgnoreCase.compare,
        };
    })();
    /**
     * USAGE EXAMPLE:
     *
     * // Declare item type.
     * type Item = { key: number, code: string, name: string, sortPrice: number };
     *
     * // Build comparer from provided criteria.
     * const comparer = new ComparerBuilder<Item>()
     *  .add({ selector: v => v.sortPrice })
     *  .add({ selector: v => v.code, descending: true, comparer: StringComparer.currentLocaleIgnoreCase })
     *  .add({ selector: v => v.name, comparer: new Intl.Collator('ru').compare })
     *  .add({ selector: v => v.key, comparer: defaultNumberComparer })
     *  .build();
     *
     * // Use built comparer for multiple calls.
     * const items1: Item[] = [...];
     * // Note: we are using spread operator to prevent original array mutation (sort method works so).
     * const sortedItems1 = [...items1].sort(comparer);
     *
     * const items2: Item[] = [...];
     * // Note: we are using spread operator to prevent original array mutation (sort method works so).
     * const sortedItems2 = [...items2].sort(comparer);
     */
    class ComparerBuilder {
        constructor() {
            _ComparerBuilder_criteria.set(this, []);
        }
        add(criterion) {
            __classPrivateFieldGet(this, _ComparerBuilder_criteria, "f").push(next => __classPrivateFieldGet(_a, _a, "m", _ComparerBuilder_createComparer).call(_a, criterion, next));
            return this;
        }
        build(bottomComparer) {
            let comparer = bottomComparer;
            for (let i = __classPrivateFieldGet(this, _ComparerBuilder_criteria, "f").length - 1; i >= 0; i--)
                comparer = __classPrivateFieldGet(this, _ComparerBuilder_criteria, "f")[i](comparer);
            return comparer !== null && comparer !== void 0 ? comparer : App.defaultComparer;
        }
    }
    _a = ComparerBuilder, _ComparerBuilder_criteria = new WeakMap(), _ComparerBuilder_createComparer = function _ComparerBuilder_createComparer(criterion, next) {
        var _b;
        const comparer = (_b = criterion.comparer) !== null && _b !== void 0 ? _b : App.defaultComparer;
        return (a, b) => {
            var _b;
            const av = criterion.selector(a);
            const bv = criterion.selector(b);
            const comparison = comparer(av, bv);
            if (comparison === 0)
                return (_b = next === null || next === void 0 ? void 0 : next(a, b)) !== null && _b !== void 0 ? _b : 0;
            return criterion.descending ? -comparison : comparison;
        };
    };
    App.ComparerBuilder = ComparerBuilder;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _ConsoleMessenger_showMessage;
    class ConsoleMessenger {
        // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/no-empty-function
        constructor() {
        }
        show(messageOrMessages, options) {
            if (options && options.group)
                console.info(`[${options.group}]show messenger`);
            else
                console.info('show messenger');
            if (messageOrMessages instanceof Array)
                messageOrMessages.forEach(v => __classPrivateFieldGet(_a, _a, "m", _ConsoleMessenger_showMessage).call(_a, v));
            else
                __classPrivateFieldGet(_a, _a, "m", _ConsoleMessenger_showMessage).call(_a, messageOrMessages);
        }
        hide(group) {
            if (group)
                console.info(`[${group}]hide messenger`);
            else
                console.info('hide messenger');
        }
    }
    _a = ConsoleMessenger, _ConsoleMessenger_showMessage = function _ConsoleMessenger_showMessage(message) {
        if (message.type === 0 /* MessageType.Information */)
            console.info(message.text);
        else if (message.type === 1 /* MessageType.Warning */)
            console.warn(message.text);
        else
            console.error(message.text);
    };
    Object.defineProperty(ConsoleMessenger, "instance", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new _a()
    });
    App.ConsoleMessenger = ConsoleMessenger;
})(App || (App = {}));
var App;
(function (App) {
    var _CurrencyConverter_options, _CurrencyConverter_cacheExpiration, _CurrencyConverter_exchangeRates;
    class CurrencyConverter {
        constructor(options) {
            _CurrencyConverter_options.set(this, void 0);
            _CurrencyConverter_cacheExpiration.set(this, void 0);
            _CurrencyConverter_exchangeRates.set(this, void 0);
            __classPrivateFieldSet(this, _CurrencyConverter_options, options, "f");
            __classPrivateFieldSet(this, _CurrencyConverter_cacheExpiration, new Date(0), "f");
            __classPrivateFieldSet(this, _CurrencyConverter_exchangeRates, {}, "f");
        }
        ensureExchangeRates(signal) {
            return __awaiter(this, void 0, void 0, function* () {
                if (__classPrivateFieldGet(this, _CurrencyConverter_exchangeRates, "f") != null && __classPrivateFieldGet(this, _CurrencyConverter_cacheExpiration, "f") > new Date())
                    return null;
                signal.throwIfAborted();
                const response = yield __classPrivateFieldGet(this, _CurrencyConverter_options, "f").configService.exchangeRates({}, signal);
                __classPrivateFieldSet(this, _CurrencyConverter_cacheExpiration, new Date(new Date().getTime() + response.expires), "f");
                const exchangeRates = {};
                response.exchangeRates.forEach(v => {
                    if (!exchangeRates[v.destinationCurrencyCode])
                        exchangeRates[v.destinationCurrencyCode] = {};
                    exchangeRates[v.destinationCurrencyCode][v.sourceCurrencyCode] = v.rate;
                });
                __classPrivateFieldSet(this, _CurrencyConverter_exchangeRates, exchangeRates, "f");
                const result = new Array();
                if (response.currencies != null)
                    result.push(...response.currencies);
                return result;
            });
        }
        exchange(amount, srcCurrencyCode, dstCurrencyCode) {
            if (srcCurrencyCode === dstCurrencyCode)
                return amount;
            const dstRates = __classPrivateFieldGet(this, _CurrencyConverter_exchangeRates, "f")[dstCurrencyCode];
            if (dstRates == null)
                return null;
            const rate = dstRates[srcCurrencyCode];
            if (rate == null)
                return null;
            return amount * rate;
        }
    }
    _CurrencyConverter_options = new WeakMap(), _CurrencyConverter_cacheExpiration = new WeakMap(), _CurrencyConverter_exchangeRates = new WeakMap();
    App.CurrencyConverter = CurrencyConverter;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _CurrencyManager_s_registeredConverters, _CurrencyManager_s_converters, _CurrencyManager_s_currentCurrencyCode, _CurrencyManager_s_currencies, _CurrencyManager_convert, _CurrencyManager_convertGroup, _CurrencyManager_convertItem, _CurrencyManager_getRecalcElementGroups, _CurrencyManager_getRecalcElements, _CurrencyManager_findConverter, _CurrencyManager_findMoneyElements, _CurrencyManager_format, _CurrencyManager_formatAmount, _CurrencyManager_formatMoney;
    class CurrencyManager {
        static get currentCurrencyCode() {
            return __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currentCurrencyCode);
        }
        /**
         * Регистрирует новый конвертер с указанным кодом для пересчета сумм из одной валюты в другую.
         * Конвертеры с кодами отличными от '' (код по-умолчанию) могут быть полезны, если на странице присутствуют элементы, которые должны
         * пересчитываться по разному в рамках одной и той же расчетной даты.
         * @param converter Конвертер, используемый для пересчета сумм.
         * @param type Строковый тип для идентификации конвертера.
         */
        static register(converter, type = '') {
            if (__classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_registeredConverters)[type])
                throw new Error(`The currency converter with type '${type}' already registered.`);
            __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_registeredConverters)[type] = converter;
            delete __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_converters)[type];
            return _a;
        }
        /**
         * Инициализация менеджера.
         * @param currentCurrencyCode Установка валюты, которую менеджер будет считать текущей для первоначального пересчета сумм.
         * @param defaultConverter Конвертер сумм для использования по-умолчанию.
         */
        static init(currentCurrencyCode, defaultConverter) {
            if (_a.initialized)
                throw new Error('The currency manager has already been initialized.');
            _a.initialized = true;
            __classPrivateFieldSet(_a, _a, currentCurrencyCode, "f", _CurrencyManager_s_currentCurrencyCode);
            _a.register(defaultConverter);
            document.dispatchEvent(new Event("currencymanager:initialized" /* Events.CurrencyManagerInitialized */));
            // После загрузки страницы (onready) обработать элементы с отсутствующим атрибутом 'data-money-current'. Это, к примеру, могут
            // быть элементы из статической разметки.
            $(() => __awaiter(this, void 0, void 0, function* () { return yield _a.convertAll(document, App.noneSignal); }));
        }
        /**
         * Изменение текущей валюты и пересчет всех сумм на нее.
         * @param currencyCode ISO-код новой валюты. Если не указан, то текущая валюта останется неизменной, но будет запущен механизм
         * пересчета нерасчитанных сумм. Это, например, необходимо для расчета сумм (на этапе onready) для статической разметки, добавленной
         * на страницу.
         */
        static changeCurrentCurrency(currencyCode, signal) {
            return __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldSet(_a, _a, currencyCode, "f", _CurrencyManager_s_currentCurrencyCode);
                document.dispatchEvent(new Event("currencymanager:currencychanged" /* Events.CurrencyManagerCurrencyChanged */));
                yield _a.convertAll(document, signal);
            });
        }
        /**
         * Запуск пересчета сумм всех элементов в указанном контейнере.
         * @param container Контейнер для получения списка элементов, которые будут участвовать в пересчете.
         */
        static convertAll(container_1) {
            return __awaiter(this, arguments, void 0, function* (container, 
            // TODO: убрать default значение.
            signal = App.noneSignal) {
                const elements = __classPrivateFieldGet(this, _a, "m", _CurrencyManager_findMoneyElements).call(this, container);
                yield __classPrivateFieldGet(_a, _a, "m", _CurrencyManager_convert).call(_a, elements, signal);
            });
        }
        static format(group, type, amount, currency, format, isFixedCurrency, signal) {
            return __awaiter(this, void 0, void 0, function* () {
                const converter = yield _a.findConverter({ name: group !== null && group !== void 0 ? group : '', signal });
                const result = __classPrivateFieldGet(this, _a, "m", _CurrencyManager_convertItem).call(this, converter, type, amount, currency, format, isFixedCurrency);
                return result == null ? null : result.value;
            });
        }
        /**
         * Конвертация суммы из одной валюты в другую.
         */
        static exchange(amount_1, srcCurrencyCode_1, dstCurrencyCode_1, group_1) {
            return __awaiter(this, arguments, void 0, function* (amount, srcCurrencyCode, dstCurrencyCode, group, 
            // TODO: убрать default значение.
            signal = App.noneSignal) {
                const currencyCode = dstCurrencyCode !== null && dstCurrencyCode !== void 0 ? dstCurrencyCode : __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currentCurrencyCode);
                if (srcCurrencyCode === currencyCode || currencyCode === _a.defaults.neutralCurrencyCode)
                    return amount;
                const converter = yield _a.findConverter({ name: group, signal });
                if (converter == null)
                    return null;
                return converter.exchange(amount, srcCurrencyCode, currencyCode);
            });
        }
        static findConverter() {
            return __awaiter(this, arguments, void 0, function* ({ name = '', fallback = true, 
            // TODO: убрать default значение - заменить на "signal = requiredParam('signal'),".
            signal = App.noneSignal, } = {}) {
                let result = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_converters)[name];
                if (result == null) {
                    result = __classPrivateFieldGet(_a, _a, "m", _CurrencyManager_findConverter).call(_a, name, fallback, signal);
                    __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_converters)[name] = result;
                }
                return yield result;
            });
        }
    }
    _a = CurrencyManager, _CurrencyManager_convert = function _CurrencyManager_convert(elementOrElements_1) {
        return __awaiter(this, arguments, void 0, function* (elementOrElements, 
        // TODO: убрать default значение.
        signal = App.noneSignal) {
            const tasks = new Array();
            const elementGroups = Object.entries(__classPrivateFieldGet(_a, _a, "m", _CurrencyManager_getRecalcElementGroups).call(_a, elementOrElements));
            for (let i = 0; i < elementGroups.length; i++) {
                const [elementGroupKey, elementGroupValue] = elementGroups[i];
                tasks.push(__classPrivateFieldGet(_a, _a, "m", _CurrencyManager_convertGroup).call(_a, elementGroupKey, elementGroupValue, signal));
            }
            yield Promise.all(tasks);
        });
    }, _CurrencyManager_convertGroup = function _CurrencyManager_convertGroup(elementGroupKey, elementGroupValue, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            const converter = yield _a.findConverter({ name: elementGroupKey, signal });
            elementGroupValue.forEach(v => {
                var _b, _c;
                const result = __classPrivateFieldGet(this, _a, "m", _CurrencyManager_convertItem).call(this, converter, v.getAttribute(_a.defaults.typeAttribute), Number((_b = v.getAttribute(_a.defaults.amountAttribute)) !== null && _b !== void 0 ? _b : '0'), v.getAttribute(_a.defaults.currencyAttribute), v.getAttribute(_a.defaults.formatAttribute), v.classList.contains(_a.defaults.fixedMoneyClass));
                if (result == null)
                    return;
                v.setAttribute(_a.defaults.currentCurrencyAttribute, result.currency);
                if (v.tagName === 'INPUT')
                    v.value = (_c = result.value) !== null && _c !== void 0 ? _c : '';
                else
                    v.textContent = result.value;
            });
        });
    }, _CurrencyManager_convertItem = function _CurrencyManager_convertItem(converter, type, amount, currency, format, isFixedCurrency) {
        const currentCurrencyCode = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currentCurrencyCode);
        if (currency == null) {
            console.debug('One or more money elements group doesn\'t contain currency attribute specified.');
            return null;
        }
        let dstCurrency;
        let rate;
        const leaveInitialCurrency = currentCurrencyCode === _a.defaults.neutralCurrencyCode || isFixedCurrency;
        if (converter == null || leaveInitialCurrency) {
            // вывод суммы в первоначальной валюте
            rate = 1.0;
            dstCurrency = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currencies)[currency];
        }
        else {
            dstCurrency = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currencies)[currentCurrencyCode];
            const dstRate = converter.exchange(1, currency, dstCurrency.code);
            if (dstRate == null) {
                // отсутствует курс -> вывод суммы в первоначальной валюте
                rate = 1.0;
                dstCurrency = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currencies)[currency];
            }
            else {
                rate = dstRate;
            }
        }
        let value;
        switch (type) {
            case 'currency':
                value = dstCurrency.symbol;
                break;
            case 'amount':
                value = __classPrivateFieldGet(_a, _a, "m", _CurrencyManager_format).call(_a, amount * rate, dstCurrency, format, true);
                break;
            default:
                value = __classPrivateFieldGet(_a, _a, "m", _CurrencyManager_format).call(_a, amount * rate, dstCurrency, format, false);
                break;
        }
        return { value, currency: dstCurrency.code };
    }, _CurrencyManager_getRecalcElementGroups = function _CurrencyManager_getRecalcElementGroups(elementOrElements) {
        const elementGroups = {};
        __classPrivateFieldGet(_a, _a, "m", _CurrencyManager_getRecalcElements).call(_a, elementOrElements).forEach(v => {
            var _b;
            const group = (_b = v.getAttribute(_a.defaults.groupAttribute)) !== null && _b !== void 0 ? _b : '';
            if (!elementGroups[group])
                elementGroups[group] = new Array();
            elementGroups[group].push(v);
        });
        return elementGroups;
    }, _CurrencyManager_getRecalcElements = function _CurrencyManager_getRecalcElements(elementOrElements) {
        const elements = new Array();
        if (elementOrElements instanceof Array)
            elementOrElements.forEach(v => elements.push(v));
        else
            elements.push(elementOrElements);
        const currentCurrencyCode = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currentCurrencyCode);
        return elements.filter(v => v.getAttribute(_a.defaults.currentCurrencyAttribute) !== currentCurrencyCode);
    }, _CurrencyManager_findConverter = function _CurrencyManager_findConverter(name, fallback, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            let converter = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_registeredConverters)[name];
            if (!converter && fallback && name !== '')
                converter = __classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_registeredConverters)[''];
            if (converter) {
                const currencies = yield converter.ensureExchangeRates(signal);
                if (currencies != null)
                    currencies.forEach(v => (__classPrivateFieldGet(_a, _a, "f", _CurrencyManager_s_currencies)[v.code] = v));
            }
            return converter;
        });
    }, _CurrencyManager_findMoneyElements = function _CurrencyManager_findMoneyElements(containerOrElement) {
        if (containerOrElement instanceof Document)
            return Array.from(containerOrElement.getElementsByClassName(_a.defaults.moneyClass));
        if (containerOrElement instanceof Element) {
            if (containerOrElement.classList.contains(_a.defaults.moneyClass))
                return [containerOrElement];
            return Array.from(containerOrElement.getElementsByClassName(_a.defaults.moneyClass));
        }
        if (containerOrElement.length <= 0)
            return [];
        if (containerOrElement.length === 1 && containerOrElement.hasClass(_a.defaults.moneyClass))
            return containerOrElement.get();
        return $(`.${_a.defaults.moneyClass}`, containerOrElement).get();
    }, _CurrencyManager_format = function _CurrencyManager_format(amount, currency, format, isAmountOnly) {
        let result = __classPrivateFieldGet(_a, _a, "m", _CurrencyManager_formatAmount).call(_a, amount, currency, format);
        if (!isAmountOnly)
            result = __classPrivateFieldGet(_a, _a, "m", _CurrencyManager_formatMoney).call(_a, result, currency);
        return result;
    }, _CurrencyManager_formatAmount = function _CurrencyManager_formatAmount(amount, currency, format) {
        let preparedAmount = amount;
        let exponent;
        let prefix = '';
        if (format != null && format.length > 0) {
            let precisionSpecifierIndex = 0;
            if (format.charAt(0) === '±') {
                precisionSpecifierIndex++;
                prefix = preparedAmount === 0 ? '' : preparedAmount < 0 ? '- ' : '+ ';
                preparedAmount = Math.abs(preparedAmount);
            }
            if (format.charAt(precisionSpecifierIndex) === 'N')
                precisionSpecifierIndex++;
            exponent = Number(format.substring(precisionSpecifierIndex));
        }
        else {
            exponent = currency.exponent;
        }
        return prefix + App.formatNumber(preparedAmount, { minimumFractionDigits: exponent, maximumFractionDigits: exponent });
    }, _CurrencyManager_formatMoney = function _CurrencyManager_formatMoney(amount, currency) {
        var _b, _c;
        if (currency.amountPrefixing)
            return amount + ((_b = currency.amountSeparator) !== null && _b !== void 0 ? _b : '') + currency.symbol;
        return currency.symbol + ((_c = currency.amountSeparator) !== null && _c !== void 0 ? _c : '') + amount;
    };
    /**
     * Default-опции используемых css-классов и т.д.
     */
    Object.defineProperty(CurrencyManager, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            moneyClass: 'js-money',
            fixedMoneyClass: 'js-money-fixed',
            amountAttribute: 'data-money-amount',
            currencyAttribute: 'data-money-currency',
            groupAttribute: 'data-money-group',
            typeAttribute: 'data-money-type',
            formatAttribute: 'data-money-format',
            currentCurrencyAttribute: 'data-money-current',
            neutralCurrencyCode: 'NUC',
        }
    });
    _CurrencyManager_s_registeredConverters = { value: {} };
    _CurrencyManager_s_converters = { value: {} };
    Object.defineProperty(CurrencyManager, "initialized", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    _CurrencyManager_s_currentCurrencyCode = { value: void 0 };
    _CurrencyManager_s_currencies = { value: {} };
    App.CurrencyManager = CurrencyManager;
})(App || (App = {}));
var App;
(function (App) {
    var _DatesPopup_instances, _DatesPopup_options, _DatesPopup_group, _DatesPopup_slider, _DatesPopup_datepicker, _DatesPopup_datesSlider, _DatesPopup_switchGroup;
    class DatesPopup {
        constructor(options) {
            _DatesPopup_instances.add(this);
            _DatesPopup_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _DatesPopup_group.set(this, void 0);
            _DatesPopup_slider.set(this, void 0);
            _DatesPopup_datepicker.set(this, void 0);
            // @ts-expect-error костыль для отключения ошибки TS6133
            _DatesPopup_datesSlider.set(this, void 0);
            const defaults = {
                container: 'body',
                root: '.js-dates-popup',
                data: {},
            };
            __classPrivateFieldSet(this, _DatesPopup_options, Object.assign(Object.assign({}, defaults), options), "f");
            const container = $(__classPrivateFieldGet(this, _DatesPopup_options, "f").container);
            this.root = $(__classPrivateFieldGet(this, _DatesPopup_options, "f").root, container);
            if (this.root.length > 0)
                this.root.remove();
            container.append(App.templates.DatesPopup(__classPrivateFieldGet(this, _DatesPopup_options, "f").data.groups));
            this.root = $(__classPrivateFieldGet(this, _DatesPopup_options, "f").root, container);
            $('.js-dp-close', this.root).on('click', () => this.hide());
            __classPrivateFieldSet(this, _DatesPopup_group, $('.js-dp-label', this.root), "f");
            __classPrivateFieldGet(this, _DatesPopup_group, "f").on('click', e => __classPrivateFieldGet(this, _DatesPopup_instances, "m", _DatesPopup_switchGroup).call(this, e));
            __classPrivateFieldSet(this, _DatesPopup_slider, $('.js-carousel-slider', this.root), "f");
            __classPrivateFieldSet(this, _DatesPopup_datepicker, $('.js-dp-cal', this.root), "f");
            __classPrivateFieldSet(this, _DatesPopup_datesSlider, new App.CarouselSlider({
                root: this.root,
                slidesNum: 4,
                speed: 450,
                cals: true,
            }), "f");
        }
        show(element) {
            if (__classPrivateFieldGet(this, _DatesPopup_options, "f").selectedGroup)
                __classPrivateFieldGet(this, _DatesPopup_group, "f").filter(`[data-key="${__classPrivateFieldGet(this, _DatesPopup_options, "f").selectedGroup}"]`).trigger('click');
            else
                __classPrivateFieldGet(this, _DatesPopup_group, "f").eq(0).trigger('click');
            const elementOffset = element.offset();
            let top = elementOffset != null ? elementOffset.top : 0;
            if (App.isTouch)
                top += (App.app.container.scrollTop() || 0);
            this.root.css({ top: `${top + 26}px` });
            this.root.fadeIn(250);
            const linkRect = __classPrivateFieldGet(this, _DatesPopup_options, "f").link && __classPrivateFieldGet(this, _DatesPopup_options, "f").link[0]
                ? __classPrivateFieldGet(this, _DatesPopup_options, "f").link[0].getBoundingClientRect()
                : null;
            if (linkRect) {
                const linkCenter = linkRect.left + linkRect.width / 2;
                const arrowPosition = parseFloat((linkCenter - this.root[0].getBoundingClientRect().left - 7).toFixed(2));
                this.root[0].style.setProperty('--arrow-position', `${arrowPosition}px`);
            }
        }
        hide() {
            this.root.fadeOut(250);
            $('body').trigger("carousel-slider:remove" /* Events.CarouselSliderRemove */);
        }
    }
    _DatesPopup_options = new WeakMap(), _DatesPopup_group = new WeakMap(), _DatesPopup_slider = new WeakMap(), _DatesPopup_datepicker = new WeakMap(), _DatesPopup_datesSlider = new WeakMap(), _DatesPopup_instances = new WeakSet(), _DatesPopup_switchGroup = function _DatesPopup_switchGroup(e) {
        const target = $(e.currentTarget);
        const groupKey = target.attr('data-key');
        if (!groupKey)
            return;
        // Удаляем предыдущую карусель и календари, если они уже были показаны.
        if (__classPrivateFieldGet(this, _DatesPopup_slider, "f").html() !== '') {
            $('body').trigger("carousel-slider:remove" /* Events.CarouselSliderRemove */);
            __classPrivateFieldGet(this, _DatesPopup_slider, "f").html('');
        }
        let initialSlide = 0;
        Enumerable.from(__classPrivateFieldGet(this, _DatesPopup_options, "f").data.dates[groupKey])
            .groupBy(v => (v.getFullYear() - 1900) * 12 + v.getMonth())
            .orderBy(v => v.key())
            .forEach((v, i) => {
            const sliderItem = $('<li class="carousel-slider__item"><div class="dates-popup__cal js-dp-cal"></div></li>');
            __classPrivateFieldGet(this, _DatesPopup_slider, "f").append(sliderItem);
            const calendar = $('.js-dp-cal', sliderItem);
            const months = v.key();
            const minDate = new Date(0, months, 1);
            const maxDate = new Date(0, months + 1, 0);
            const beforeShowDay = __classPrivateFieldGet(this, _DatesPopup_options, "f").data.beforeShowDayFactory
                ? __classPrivateFieldGet(this, _DatesPopup_options, "f").data.beforeShowDayFactory(groupKey)
                : undefined;
            calendar.datepicker({
                minDate,
                maxDate,
                constrainInput: false,
                beforeShowDay,
                onSelect: () => {
                    __classPrivateFieldGet(this, _DatesPopup_options, "f").data.onSelect(__classPrivateFieldGet(this, _DatesPopup_group, "f").filter('._active').attr('data-key') || '', calendar.datepicker('getDate'));
                    this.hide();
                },
            });
            if (__classPrivateFieldGet(this, _DatesPopup_options, "f").selectedDate
                && __classPrivateFieldGet(this, _DatesPopup_options, "f").selectedDate.getTime() >= minDate.getTime()
                && __classPrivateFieldGet(this, _DatesPopup_options, "f").selectedDate.getTime() >= maxDate.getTime())
                initialSlide = i;
            // Снимаем выделение даты по умолчанию
            calendar.find('.ui-state-active').removeClass('ui-state-active ui-state-hover');
            calendar.find('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
        });
        __classPrivateFieldSet(this, _DatesPopup_datepicker, $('.js-dp-cal', this.root), "f");
        // TODO: не использовать получателя событий в названии событий. В качестве префикса использовать название класса / прототипа,
        // инициирующего данное событие.
        $('body').trigger("carousel-slider:init" /* Events.CarouselSliderInit */, [{ cals: __classPrivateFieldGet(this, _DatesPopup_datepicker, "f"), initialSlide }]);
        __classPrivateFieldGet(this, _DatesPopup_group, "f").removeClass('_active');
        target.addClass('_active');
    };
    App.DatesPopup = DatesPopup;
})(App || (App = {}));
var App;
(function (App) {
    var _DigestMobile_instances, _DigestMobile_options, _DigestMobile_root, _DigestMobile_floater, _DigestMobile_spoiler, _DigestMobile_cost, _DigestMobile_button, _DigestMobile_content, _DigestMobile_contentHeader, _DigestMobile_contentPlacer, _DigestMobile_onScroll, _DigestMobile_onResize, _DigestMobile_resizeDigest, _DigestMobile_onClick, _DigestMobile_eventEmptyClick, _DigestMobile_showContent, _DigestMobile_hideContent;
    class DigestMobile {
        constructor(options) {
            _DigestMobile_instances.add(this);
            _DigestMobile_options.set(this, void 0);
            _DigestMobile_root.set(this, void 0);
            _DigestMobile_floater.set(this, void 0);
            _DigestMobile_spoiler.set(this, void 0);
            _DigestMobile_cost.set(this, void 0);
            _DigestMobile_button.set(this, void 0);
            _DigestMobile_content.set(this, void 0);
            _DigestMobile_contentHeader.set(this, void 0);
            _DigestMobile_contentPlacer.set(this, void 0);
            const defaults = {
                root: '.js-digest-component',
                buttonTitle: 'Забронировать',
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_eventEmptyClick).call(this),
                allowBooking: true,
            };
            __classPrivateFieldSet(this, _DigestMobile_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _DigestMobile_options, "f");
            if (typeof root === 'string')
                __classPrivateFieldSet(this, _DigestMobile_root, $(root), "f");
            else
                __classPrivateFieldSet(this, _DigestMobile_root, root, "f");
            if (!__classPrivateFieldGet(this, _DigestMobile_root, "f").length)
                return;
            __classPrivateFieldSet(this, _DigestMobile_floater, $('.js-digest-floater', __classPrivateFieldGet(this, _DigestMobile_root, "f")), "f");
            __classPrivateFieldSet(this, _DigestMobile_spoiler, $('.js-digest-floater-spoiler', __classPrivateFieldGet(this, _DigestMobile_root, "f")), "f");
            __classPrivateFieldGet(this, _DigestMobile_spoiler, "f").on('click', () => __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_showContent).call(this));
            __classPrivateFieldSet(this, _DigestMobile_cost, $('.js-digest-floater-cost', __classPrivateFieldGet(this, _DigestMobile_root, "f")), "f");
            __classPrivateFieldSet(this, _DigestMobile_button, $('.js-digest-floater-button', __classPrivateFieldGet(this, _DigestMobile_root, "f")), "f");
            __classPrivateFieldSet(this, _DigestMobile_content, $('.js-digest-content', __classPrivateFieldGet(this, _DigestMobile_root, "f")), "f");
            __classPrivateFieldSet(this, _DigestMobile_contentHeader, $('.js-digest-content-header', __classPrivateFieldGet(this, _DigestMobile_root, "f")), "f");
            __classPrivateFieldSet(this, _DigestMobile_contentPlacer, $('.js-digest-content-placer', __classPrivateFieldGet(this, _DigestMobile_root, "f")), "f");
            // opts
            __classPrivateFieldGet(this, _DigestMobile_button, "f").html(__classPrivateFieldGet(this, _DigestMobile_options, "f").buttonTitle || '');
            __classPrivateFieldGet(this, _DigestMobile_contentHeader, "f").html(__classPrivateFieldGet(this, _DigestMobile_options, "f").headerTitle || '');
            if (!__classPrivateFieldGet(this, _DigestMobile_options, "f").allowBooking)
                this.showButton(false);
            // events
            $('.js-digest-content-close', __classPrivateFieldGet(this, _DigestMobile_root, "f")).on('click', () => __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_hideContent).call(this));
            __classPrivateFieldGet(this, _DigestMobile_button, "f").on('click', () => __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_onClick).call(this));
            $(document)
                .on("win:scroll" /* Events.WinScroll */, (e, data) => __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_onScroll).call(this, e, data))
                .on(`${"win:resizeEnd" /* Events.WinResizeEnd */} ${"digest:update" /* Events.DigestUpdate */}`, () => __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_onResize).call(this));
            // Выставляем начальную высоту сайдбара
            __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_resizeDigest).call(this, App.app.container.scrollTop() || 0);
            // авто скрытие изначально
            this.empty();
        }
        showButton(isShow) {
            if (isShow)
                __classPrivateFieldGet(this, _DigestMobile_button, "f").show();
            else
                __classPrivateFieldGet(this, _DigestMobile_button, "f").hide();
        }
        hide() {
            __classPrivateFieldGet(this, _DigestMobile_floater, "f").hideByClass();
            __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_hideContent).call(this);
        }
        showFloater() {
            __classPrivateFieldGet(this, _DigestMobile_floater, "f").showByClass();
        }
        setFloaterIndex(zIndex = 950) {
            __classPrivateFieldGet(this, _DigestMobile_floater, "f").css('z-index', zIndex);
        }
        empty() {
            // this.setContent($('<div>'));
            this.hide();
        }
        close() {
            __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_hideContent).call(this);
        }
        open() {
            __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_showContent).call(this);
        }
        setFloater(html) {
            __classPrivateFieldGet(this, _DigestMobile_cost, "f").html('');
            __classPrivateFieldGet(this, _DigestMobile_cost, "f").append(html);
            this.showFloater();
        }
        setContent(html) {
            return __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(this, _DigestMobile_contentPlacer, "f").html('');
                __classPrivateFieldGet(this, _DigestMobile_contentPlacer, "f").append(html);
            });
        }
        getContent() {
            return __classPrivateFieldGet(this, _DigestMobile_contentPlacer, "f");
        }
    }
    _DigestMobile_options = new WeakMap(), _DigestMobile_root = new WeakMap(), _DigestMobile_floater = new WeakMap(), _DigestMobile_spoiler = new WeakMap(), _DigestMobile_cost = new WeakMap(), _DigestMobile_button = new WeakMap(), _DigestMobile_content = new WeakMap(), _DigestMobile_contentHeader = new WeakMap(), _DigestMobile_contentPlacer = new WeakMap(), _DigestMobile_instances = new WeakSet(), _DigestMobile_onScroll = function _DigestMobile_onScroll(e, data) {
        __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_resizeDigest).call(this, data.scrollTop || 0);
    }, _DigestMobile_onResize = function _DigestMobile_onResize() {
        __classPrivateFieldGet(this, _DigestMobile_instances, "m", _DigestMobile_resizeDigest).call(this, App.app.container.scrollTop() || 0);
    }, _DigestMobile_resizeDigest = function _DigestMobile_resizeDigest(scrollTop) {
        // TODO: see in original class.
    }, _DigestMobile_onClick = function _DigestMobile_onClick() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: debounce
            yield __classPrivateFieldGet(this, _DigestMobile_options, "f").onClick();
        });
    }, _DigestMobile_eventEmptyClick = function _DigestMobile_eventEmptyClick() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('onClick not setted in Digest');
        });
    }, _DigestMobile_showContent = function _DigestMobile_showContent() {
        __classPrivateFieldGet(this, _DigestMobile_content, "f").showByClass();
        // floater
        __classPrivateFieldGet(this, _DigestMobile_spoiler, "f").hideByClass();
        __classPrivateFieldGet(this, _DigestMobile_cost, "f").hideByClass();
        __classPrivateFieldGet(this, _DigestMobile_button, "f").addClass('full_btn');
    }, _DigestMobile_hideContent = function _DigestMobile_hideContent() {
        __classPrivateFieldGet(this, _DigestMobile_content, "f").hideByClass();
        // floater
        __classPrivateFieldGet(this, _DigestMobile_spoiler, "f").showByClass();
        __classPrivateFieldGet(this, _DigestMobile_cost, "f").showByClass();
        __classPrivateFieldGet(this, _DigestMobile_button, "f").removeClass('full_btn');
    };
    App.DigestMobile = DigestMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _DigestInstance_instances, _DigestInstance_root, _DigestInstance_digestScrollerWrap, _DigestInstance_digestScroller, _DigestInstance_digestBaron, _DigestInstance_resizeBaron, _DigestInstance_onDigestScrollerScroll, _DigestInstance_digestScrollerScroll, _DigestInstance_resizeDigest, _Digest_instances, _Digest_options, _Digest_instances_1, _Digest_onScroll, _Digest_onResize;
    // Внутренний класс для одного экземпляра Digest
    class DigestInstance {
        constructor(root) {
            _DigestInstance_instances.add(this);
            _DigestInstance_root.set(this, void 0);
            _DigestInstance_digestScrollerWrap.set(this, void 0);
            _DigestInstance_digestScroller.set(this, void 0);
            _DigestInstance_digestBaron.set(this, void 0);
            _DigestInstance_resizeBaron.set(this, void 0);
            __classPrivateFieldSet(this, _DigestInstance_root, root, "f");
            __classPrivateFieldSet(this, _DigestInstance_digestScrollerWrap, $('.js-digest-scroller-wrapper', __classPrivateFieldGet(this, _DigestInstance_root, "f")), "f");
            __classPrivateFieldSet(this, _DigestInstance_digestScroller, $('.js-digest-scroller', __classPrivateFieldGet(this, _DigestInstance_digestScrollerWrap, "f")), "f");
            // Инициализация кастомного скролла
            __classPrivateFieldSet(this, _DigestInstance_digestBaron, __classPrivateFieldGet(this, _DigestInstance_digestScrollerWrap, "f").baron({
                scroller: __classPrivateFieldGet(this, _DigestInstance_digestScroller, "f").get(0),
                bar: '.js-digest-scroller-bar',
                track: '.js-digest-scroller-bar-wrap',
                barOnCls: 'baron',
            }), "f");
            if (!App.isTouch) {
                // Обрабатываем прокрутку скроллера
                if (__classPrivateFieldGet(this, _DigestInstance_digestScroller, "f").length) {
                    __classPrivateFieldGet(this, _DigestInstance_digestScroller, "f").on('scroll', e => __classPrivateFieldGet(this, _DigestInstance_instances, "m", _DigestInstance_onDigestScrollerScroll).call(this, e));
                    __classPrivateFieldGet(this, _DigestInstance_instances, "m", _DigestInstance_digestScrollerScroll).call(this, __classPrivateFieldGet(this, _DigestInstance_digestScroller, "f"));
                }
            }
            // Выставляем начальную высоту
            __classPrivateFieldGet(this, _DigestInstance_instances, "m", _DigestInstance_resizeDigest).call(this);
        }
        onScroll() {
            __classPrivateFieldGet(this, _DigestInstance_instances, "m", _DigestInstance_resizeDigest).call(this);
            if (__classPrivateFieldGet(this, _DigestInstance_resizeBaron, "f"))
                clearTimeout(__classPrivateFieldGet(this, _DigestInstance_resizeBaron, "f"));
            __classPrivateFieldSet(this, _DigestInstance_resizeBaron, window.setTimeout(() => __classPrivateFieldGet(this, _DigestInstance_digestBaron, "f").update(), 300), "f");
        }
        onResize() {
            __classPrivateFieldGet(this, _DigestInstance_instances, "m", _DigestInstance_resizeDigest).call(this);
            setTimeout(() => __classPrivateFieldGet(this, _DigestInstance_digestBaron, "f").update(), 300);
        }
        // Публичный метод для обновления
        update() {
            __classPrivateFieldGet(this, _DigestInstance_digestBaron, "f").update();
        }
        // Очистка ресурсов
        destroy() {
            __classPrivateFieldGet(this, _DigestInstance_digestScroller, "f").off('scroll');
            if (__classPrivateFieldGet(this, _DigestInstance_resizeBaron, "f")) {
                clearTimeout(__classPrivateFieldGet(this, _DigestInstance_resizeBaron, "f"));
            }
            __classPrivateFieldGet(this, _DigestInstance_digestBaron, "f").dispose();
        }
    }
    _DigestInstance_root = new WeakMap(), _DigestInstance_digestScrollerWrap = new WeakMap(), _DigestInstance_digestScroller = new WeakMap(), _DigestInstance_digestBaron = new WeakMap(), _DigestInstance_resizeBaron = new WeakMap(), _DigestInstance_instances = new WeakSet(), _DigestInstance_onDigestScrollerScroll = function _DigestInstance_onDigestScrollerScroll(event) {
        __classPrivateFieldGet(this, _DigestInstance_instances, "m", _DigestInstance_digestScrollerScroll).call(this, $(event.currentTarget));
    }, _DigestInstance_digestScrollerScroll = function _DigestInstance_digestScrollerScroll(element) {
        const scroll = element.scrollTop() || 0;
        const parent = element.parent();
        const barWrap = element.siblings('.js-digest-scroller-bar-wrap');
        const bar = barWrap.find('.js-digest-scroller-bar');
        // Показываем / скрываем верхний градиент
        if (scroll >= 20)
            parent.addClass('_top');
        else if (scroll < 20)
            parent.removeClass('_top');
        // Показываем / скрываем нижний градиент
        if ((bar.height() || 0) + bar.position().top >= (barWrap.height() || 0))
            parent.removeClass('_bottom');
        else
            parent.addClass('_bottom');
    }, _DigestInstance_resizeDigest = function _DigestInstance_resizeDigest() {
        const viewportHeight = $(window).height() || 0;
        const height = viewportHeight - __classPrivateFieldGet(this, _DigestInstance_root, "f")[0].getBoundingClientRect().top;
        __classPrivateFieldGet(this, _DigestInstance_root, "f").height(height);
    };
    class Digest {
        constructor(options) {
            _Digest_instances.add(this);
            _Digest_options.set(this, void 0);
            _Digest_instances_1.set(this, []);
            const defaults = {
                container: App.app.appContainer,
                root: '.js-digest',
            };
            __classPrivateFieldSet(this, _Digest_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { container } = __classPrivateFieldGet(this, _Digest_options, "f");
            const containerEl = typeof container === 'string' ? $(container) : container;
            // Находим все элементы .js-digest в контейнере
            const digestElements = containerEl.find(__classPrivateFieldGet(this, _Digest_options, "f").root);
            if (!digestElements.length)
                return;
            // Создаем отдельный экземпляр для каждого элемента
            digestElements.each((index, element) => {
                __classPrivateFieldGet(this, _Digest_instances_1, "f").push(new DigestInstance($(element)));
            });
            // Навешиваем глобальные обработчики
            $(document)
                .on("win:scroll" /* Events.WinScroll */, () => __classPrivateFieldGet(this, _Digest_instances, "m", _Digest_onScroll).call(this))
                .on(`${"win:resizeEnd" /* Events.WinResizeEnd */} ${"digest:update" /* Events.DigestUpdate */}`, () => __classPrivateFieldGet(this, _Digest_instances, "m", _Digest_onResize).call(this));
        }
        // Публичный метод для принудительного обновления всех экземпляров
        updateAll() {
            __classPrivateFieldGet(this, _Digest_instances_1, "f").forEach(instance => {
                // Ждем немного чтобы DOM успел обновиться
                setTimeout(() => {
                    instance.onResize();
                }, 50);
            });
        }
        // Очистка всех экземпляров
        destroy() {
            __classPrivateFieldGet(this, _Digest_instances_1, "f").forEach(instance => instance.destroy());
            __classPrivateFieldGet(this, _Digest_instances_1, "f").length = 0;
            // Снимаем глобальные обработчики
            $(document)
                .off("win:scroll" /* Events.WinScroll */, () => __classPrivateFieldGet(this, _Digest_instances, "m", _Digest_onScroll).call(this))
                .off(`${"win:resizeEnd" /* Events.WinResizeEnd */} ${"digest:update" /* Events.DigestUpdate */}`, () => __classPrivateFieldGet(this, _Digest_instances, "m", _Digest_onResize).call(this));
        }
        // Получить количество экземпляров
        getInstanceCount() {
            return __classPrivateFieldGet(this, _Digest_instances_1, "f").length;
        }
    }
    _Digest_options = new WeakMap(), _Digest_instances_1 = new WeakMap(), _Digest_instances = new WeakSet(), _Digest_onScroll = function _Digest_onScroll() {
        __classPrivateFieldGet(this, _Digest_instances_1, "f").forEach(instance => instance.onScroll());
    }, _Digest_onResize = function _Digest_onResize() {
        __classPrivateFieldGet(this, _Digest_instances_1, "f").forEach(instance => instance.onResize());
    };
    App.Digest = Digest;
})(App || (App = {}));
var App;
(function (App) {
    var _ExistingPassengersMobile_wrapper, _ExistingPassengersMobile_nameParts, _ExistingPassengersMobile_nameTypedMaps, _ExistingPassengersMobile_selectKey, _ExistingPassengersMobile_dateFormat;
    class ExistingPassengersMobile {
        /**
         * Выбор туриста. Если на странице возможно множество такой выборки, то использовать ExistingPassengersMobile.Creates().
         * @param root
         * @returns
         */
        constructor(root) {
            // readonly self: string;
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ExistingPassengersMobile_wrapper.set(this, void 0);
            _ExistingPassengersMobile_nameParts.set(this, void 0);
            _ExistingPassengersMobile_nameTypedMaps.set(this, void 0);
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ExistingPassengersMobile_selectKey.set(this, void 0);
            _ExistingPassengersMobile_dateFormat.set(this, void 0);
            if (root) {
                if (typeof root === 'string')
                    this.root = $(root);
                else
                    this.root = root;
            }
            else {
                this.root = $('.js-passenger');
            }
            if (!this.root || this.root.length <= 0)
                return;
            __classPrivateFieldSet(this, _ExistingPassengersMobile_wrapper, $('.js-existing-passengers-data-item', this.root), "f");
            // props
            __classPrivateFieldSet(this, _ExistingPassengersMobile_dateFormat, __classPrivateFieldGet(this, _ExistingPassengersMobile_wrapper, "f").attr('data-date-format') || 'dd.MM.yyyy', "f");
            __classPrivateFieldSet(this, _ExistingPassengersMobile_nameParts, ['key', 'lastname', 'firstname', 'middlename', 'birthday', 'gender',
                // для туров:
                'citizenship', 'documentType', 'documentNumber', 'documentIssueCountry', 'documentIssueDate', 'documentExpirationDate'], "f");
            // мобильные контролы не имеют псевдонимов (data-type) в логике (имеют только в размекте аттрибут),
            // тянем в ручную, потом будем маппить data-type на имя контрола
            __classPrivateFieldSet(this, _ExistingPassengersMobile_nameTypedMaps, {}, "f");
            const target = __classPrivateFieldGet(this, _ExistingPassengersMobile_wrapper, "f").closest('.js-passenger');
            $.each(__classPrivateFieldGet(this, _ExistingPassengersMobile_nameParts, "f"), (__, item2) => {
                const ctrlsTyped = target.find(`[data-type='${item2}']`);
                if (ctrlsTyped.length > 0) {
                    ctrlsTyped.each((i, ctrlTypedIn) => {
                        const ctrlTyped = $(ctrlTypedIn);
                        const ctrlTypeName = $(ctrlTyped).attr('data-type');
                        if (!__classPrivateFieldGet(this, _ExistingPassengersMobile_nameTypedMaps, "f")[ctrlTypeName])
                            __classPrivateFieldGet(this, _ExistingPassengersMobile_nameTypedMaps, "f")[ctrlTypeName] = [];
                        __classPrivateFieldGet(this, _ExistingPassengersMobile_nameTypedMaps, "f")[ctrlTypeName].push(ctrlTyped.attr('data-name'));
                    });
                }
            });
            // фильтры (по сути единственный, автокомплит)
            this.filters = new App.FiltersMobileBase({
                root: __classPrivateFieldGet(this, _ExistingPassengersMobile_wrapper, "f"), // '.js-existing-passengers-data-item',
                onFilterChanged: v => this.onFilterChanged(v),
                ignoreValidator: true,
            });
            // ключи к фильтрам
            __classPrivateFieldSet(this, _ExistingPassengersMobile_selectKey, 'passengers', "f");
            // ключ к фильтру (он уникальный в рамках этого типа контролов)
            const selectBlock = this.root.find('.js-mobile-filter-selectlist-block');
            if (selectBlock) {
                __classPrivateFieldSet(this, _ExistingPassengersMobile_selectKey, selectBlock.attr('data-name'), "f");
            }
        }
        /**
         * Инициализация множества ExistingPassengersMobile.
         * @param root
         * @returns
         */
        static Creates(root) {
            const rootRef = root != null && typeof root !== 'string'
                ? root
                : $(root !== null && root !== void 0 ? root : '.js-passenger');
            const items = [];
            rootRef.each((i, r) => { items.push(new ExistingPassengersMobile($(r))); });
            return items;
        }
        /**
         * Модель данных для разметки (для _ExistingPassengerMobile.hbs).
         * @param options
         * @returns
         */
        static ViewModel(options) {
            return Object.assign({ name: 'existingpassengers_finder_' + App.FindTouristMobile.GuidGenerator(), caption: 'Выбрать существующего туриста из заказа', isOnlyCaption: true, isHtmlLabels: true, dateFormat: 'dd.MM.yyyy' }, options);
        }
        /**
         * Модель данных для разметки (для _ExistingPassengerMobile.hbs).
         * @param options
         * @returns
         */
        static ViewModelByExistingPassengers(passengers, options) {
            return ExistingPassengersMobile.ViewModel(Object.assign(Object.assign({}, options), {
                items: passengers === null || passengers === void 0 ? void 0 : passengers.map(m => {
                    // NOTE: в данных по факту приходит это поле,
                    // а в интерфейсе его нет(не всегда приходит или забыли добавить ?)
                    // const t = m.displayName;
                    const t = `${m.lastName} ${m.firstName} ${m.middleName || ''}, ${App.formatDate(m.birthday, 'shortDate')}`;
                    return {
                        value: t,
                        label: t,
                        name: t,
                        svg: m.imageName,
                        checked: false,
                        original: m,
                    };
                }),
            }));
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                // обновилось значение в автокомплите (выбрали пользователя по поиску)
                if (filterName == __classPrivateFieldGet(this, _ExistingPassengersMobile_selectKey, "f")) {
                    const itms = this.filters.getControlAutocompleteOriginalValues(__classPrivateFieldGet(this, _ExistingPassengersMobile_selectKey, "f"));
                    if (!itms || itms.length <= 0)
                        return;
                    const selectedItem = itms[0];
                    // обновляем все (заинтересованные) контролы новыми значениями от выбранного объекта
                    $.each(__classPrivateFieldGet(this, _ExistingPassengersMobile_nameParts, "f"), (__, ctrlTypeName) => {
                        const controlRealNames = __classPrivateFieldGet(this, _ExistingPassengersMobile_nameTypedMaps, "f")[ctrlTypeName];
                        let value;
                        value = selectedItem[ctrlTypeName];
                        // у объекта данных свойство может имень название не в нижнем регистре
                        // перебираем все свойства объекта в нижнем регистре (т.к. ключи мы указали в нижнем)
                        if (!value) {
                            Object.keys(selectedItem).forEach(key => {
                                if (key.toLowerCase() == ctrlTypeName) {
                                    value = selectedItem[key];
                                    return true;
                                }
                            });
                        }
                        // некоторые преобразования формата (не как пришло от dto)
                        if (ctrlTypeName == 'gender') {
                            value = ((value == 'Male' || value == '1') ? App.MobileFilterGenderValue.Male : App.MobileFilterGenderValue.Female);
                        }
                        else if (ctrlTypeName == 'birthday') {
                            value = __classPrivateFieldGet(this, _ExistingPassengersMobile_dateFormat, "f") == 'none' ? value : App.parseDate(value, __classPrivateFieldGet(this, _ExistingPassengersMobile_dateFormat, "f"));
                        }
                        // set
                        if (controlRealNames && controlRealNames.length > 0) {
                            controlRealNames.forEach(controlRealName => { PwStore.ChangeFilter(controlRealName, value, true); });
                        }
                    });
                    // event
                    // this.root.trigger(Events.TouristChoose, [passengerWrap]);
                    this.root.trigger("tourist:choose" /* Events.TouristChoose */, [this.root]);
                }
            });
        }
    }
    _ExistingPassengersMobile_wrapper = new WeakMap(), _ExistingPassengersMobile_nameParts = new WeakMap(), _ExistingPassengersMobile_nameTypedMaps = new WeakMap(), _ExistingPassengersMobile_selectKey = new WeakMap(), _ExistingPassengersMobile_dateFormat = new WeakMap();
    App.ExistingPassengersMobile = ExistingPassengersMobile;
})(App || (App = {}));
var App;
(function (App) {
    class ExistingPassengers {
        constructor() {
            Object.defineProperty(this, "self", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.self = '.js-passenger';
            this.root = $(this.self);
            const prev = $('.js-previous-data-item', this.root);
            prev.each((_, item) => {
                const wrap = $(item);
                const select = wrap.find('.js-previous-data-select');
                const passengerWrap = $(wrap.closest(this.self));
                select.on('click', e => {
                    e.stopPropagation();
                    $(e.currentTarget).toggleClass('_opened');
                });
                $('html').on('click', () => select.removeClass('_opened'));
                select.on('click', '.js-previous-data-option', e => {
                    const target = $(e.currentTarget);
                    const nameParts = ['key', 'lastname', 'firstname', 'middlename', 'birthday', 'gender',
                        // для туров:
                        'citizenship', 'documentType', 'documentNumber', 'documentIssueCountry', 'documentIssueDate', 'documentExpirationDate'];
                    $.each(nameParts, (__, item2) => {
                        var _a;
                        const input = passengerWrap.find(`input[data-type='${item2}']`);
                        if (input.length > 0)
                            input.val((_a = target.attr(`data-${item2}`)) !== null && _a !== void 0 ? _a : '');
                    });
                    passengerWrap.find('.js-form-gender-icon').toggleClass('_woman', target.data('gender') === 'Female');
                    // TODO: начало. кусок для экскурсий и отелей, т.к. моя форма не совпадает по верстке с формой авиа и остальных,
                    // которые уже сделаны по этому шаблону, а переделывать формы пока не охота.
                    const genderInput = passengerWrap.find('input[name*="gender"], .js-form-gender-input');
                    if (genderInput.is(':radio')) {
                        const gender = target.attr('data-gender');
                        if (gender)
                            genderInput.filter(`[value=${gender}]`).prop('checked', true).trigger('change');
                    }
                    // TODO: конец
                    /* select-боксы -> */
                    $.each(nameParts, (__, item2) => {
                        const value = target.attr(`data-${item2}`);
                        if (value) {
                            const selectBlock = passengerWrap.find(`.js-form-select-block[data-type='${item2}']`);
                            if (selectBlock.length > 0) {
                                const block = new App.FilterSelectBlock({ root: $(selectBlock) });
                                block.setValue(value);
                            }
                        }
                    });
                    /* <- select-боксы */
                    this.root.trigger("tourist:choose" /* Events.TouristChoose */, [passengerWrap]);
                });
            });
        }
    }
    App.ExistingPassengers = ExistingPassengers;
})(App || (App = {}));
var App;
(function (App) {
    class ExistingTourists {
        constructor() {
            Object.defineProperty(this, "self", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.self = '.js-et-tourist-self';
            this.root = $(this.self);
            const prev = $('.js-data-item', this.root);
            prev.each((_, item) => {
                const wrap = $(item);
                const select = wrap.find('.js-data-select');
                const passengerWrap = $(wrap.closest(this.self));
                select.on('click', e => {
                    e.stopPropagation();
                    $(e.currentTarget).toggleClass('_opened');
                });
                $('html').on('click', () => select.removeClass('_opened'));
                select.on('click', '.js-data-option', e => {
                    e.stopPropagation();
                    const target = $(e.currentTarget);
                    const nameParts = ['touristkey', 'lastname', 'firstname', 'middlename', 'phonenumber', 'documentnumber', 'email', 'address', 'countries'];
                    $.each(nameParts, (__, namePart) => {
                        var _a, _b, _c, _d;
                        if (namePart === 'documentnumber') {
                            const input2 = passengerWrap.find(`input[data-type='${namePart}']`);
                            const blockDocTypes = passengerWrap.find('.js-jelect-ep-document-types');
                            const docTypesSelectBlock = new App.FilterSelectBlock({ root: blockDocTypes });
                            if (target.attr('data-passport-ru')) {
                                docTypesSelectBlock.setValue('RU01001');
                                input2.val((_a = target.attr('data-passport-ru-value')) !== null && _a !== void 0 ? _a : '');
                            }
                            if (target.attr('data-passport-zagran')) {
                                docTypesSelectBlock.setValue('RU01004');
                                input2.val((_b = target.attr('data-passport-zagran-value')) !== null && _b !== void 0 ? _b : '');
                            }
                        }
                        else if (namePart === 'countries') {
                            const blockCountries = passengerWrap.find('.js-jelect-ep-countries');
                            const countriesSelectBlock = new App.FilterSelectBlock({ root: blockCountries });
                            countriesSelectBlock.setValue((_c = target.attr(`data-${namePart}`)) !== null && _c !== void 0 ? _c : '');
                        }
                        else {
                            const input = passengerWrap.find(`input[data-type='${namePart}']`);
                            input.val((_d = target.attr(`data-${namePart}`)) !== null && _d !== void 0 ? _d : '');
                        }
                    });
                    // this.root.trigger(Events.TouristChoose, [passengerWrap]);
                });
            });
        }
    }
    App.ExistingTourists = ExistingTourists;
})(App || (App = {}));
var App;
(function (App) {
    var _ExpansionPanelComponent_instances, _ExpansionPanelComponent_options, _ExpansionPanelComponent_toggle;
    class ExpansionPanelComponent {
        constructor(options) {
            _ExpansionPanelComponent_instances.add(this);
            _ExpansionPanelComponent_options.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _ExpansionPanelComponent_options, Object.assign(defaults, options), "f");
            __classPrivateFieldGet(this, _ExpansionPanelComponent_options, "f").root.on('click', '.js-expansion-panel', e => __classPrivateFieldGet(this, _ExpansionPanelComponent_instances, "m", _ExpansionPanelComponent_toggle).call(this, $(e.currentTarget)));
        }
    }
    _ExpansionPanelComponent_options = new WeakMap(), _ExpansionPanelComponent_instances = new WeakSet(), _ExpansionPanelComponent_toggle = function _ExpansionPanelComponent_toggle(root) {
        const container = root.find('.js-expansion-panel-container');
        const isOpened = container.is(':visible');
        root.trigger("expansion-panel:beforetoggle" /* Events.ExpansionPanelBeforeToggle */, [{ opened: isOpened, type: root.attr('data-type'), key: root.attr('data-key') }]);
        container.toggle();
        root.trigger("expansion-panel:aftertoggle" /* Events.ExpansionPanelAfterToggle */, [{ opened: !isOpened, type: root.attr('data-type'), key: root.attr('data-key') }]);
    };
    App.ExpansionPanelComponent = ExpansionPanelComponent;
})(App || (App = {}));
var App;
(function (App) {
    // https://datatracker.ietf.org/doc/html/rfc7231#section-4.2.2
    // https://datatracker.ietf.org/doc/html/rfc7231#section-8.1.3
    const idempotentMethods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'PUT', 'TRACE'];
    const isIdempotentRequest = (request) => idempotentMethods.includes(request.method);
    App.fetchErrorDetectionStrategy = () => ({
        isTransient: (error) => {
            if (error instanceof App.HttpError) {
                // Request Timeout
                if (error.code === 408)
                    return true;
                // Too Many Requests
                if (error.code === 429)
                    return true;
                // Отмена http-запроса клиентом на стороне сервера.
                if (error.code === 499)
                    return false;
                // Internal Server Error
                if (error.code === 500)
                    return true;
                // Service Unavailable
                if (error.code === 503)
                    return true;
                if (error.request && isIdempotentRequest(error.request)) {
                    // Bad Gateway
                    if (error.code === 502)
                        return true;
                    // Gateway Timeout
                    if (error.code === 504)
                        return true;
                }
            }
            if (error instanceof Error) {
                // Отмена http-запроса клиентом на стороне клиента (вызов AbortController.abort()).
                if (error.name === 'AbortError')
                    return false;
                // Http-запрос отвалился по timeout на клиенте.
                if (error.name === 'TimeoutError')
                    return true;
            }
            Sentry.captureException(error);
            return false;
        },
    });
})(App || (App = {}));
var App;
(function (App) {
    var _FindTouristMobile_instances, _FindTouristMobile_autocompleteKey, _FindTouristMobile_findtouristWrap, _FindTouristMobile_nameParts, _FindTouristMobile_nameTypedMaps, _FindTouristMobile_dateFormat, _FindTouristMobile_mapDataToItems;
    class FindTouristMobile {
        /**
         * Поиск туриста. Если на странице возможно множество такой выборки, то использовать FindTouristMobile.Creates().
         * @param root
         * @returns
         */
        constructor(root) {
            _FindTouristMobile_instances.add(this);
            // readonly self: string;
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _FindTouristMobile_autocompleteKey.set(this, void 0);
            _FindTouristMobile_findtouristWrap.set(this, void 0);
            _FindTouristMobile_nameParts.set(this, void 0);
            _FindTouristMobile_nameTypedMaps.set(this, void 0);
            _FindTouristMobile_dateFormat.set(this, void 0);
            if (root) {
                if (typeof root === 'string')
                    this.root = $(root);
                else
                    this.root = root;
            }
            else {
                this.root = $('.js-passenger');
            }
            if (!this.root || this.root.length <= 0)
                return;
            __classPrivateFieldSet(this, _FindTouristMobile_findtouristWrap, $('.js-findtourist-data-item', this.root), "f");
            // props
            __classPrivateFieldSet(this, _FindTouristMobile_dateFormat, __classPrivateFieldGet(this, _FindTouristMobile_findtouristWrap, "f").attr('data-date-format') || 'dd.MM.yyyy', "f");
            __classPrivateFieldSet(this, _FindTouristMobile_nameParts, ['key', 'lastname', 'firstname', 'middlename', 'birthday', 'gender',
                // для туров:
                'citizenship', 'documentType', 'documentNumber', 'documentIssueCountry', 'documentIssueDate', 'documentExpirationDate',
                // для заказов:
                'citizenshipCountryName', 'documentCountryName', 'inn'], "f");
            // мобильные контролы не имеют псевдонимов (data-type) в логике (имеют только в размекте аттрибут),
            // тянем в ручную, потом будем маппить data-type на имя контрола
            __classPrivateFieldSet(this, _FindTouristMobile_nameTypedMaps, {}, "f");
            const target = __classPrivateFieldGet(this, _FindTouristMobile_findtouristWrap, "f").closest('.js-passenger');
            $.each(__classPrivateFieldGet(this, _FindTouristMobile_nameParts, "f"), (__, item2) => {
                const ctrlsTyped = target.find(`[data-type='${item2}']`);
                if (ctrlsTyped.length > 0) {
                    ctrlsTyped.each((i, ctrlTypedIn) => {
                        const ctrlTyped = $(ctrlTypedIn);
                        const ctrlTypeName = $(ctrlTyped).attr('data-type');
                        if (!__classPrivateFieldGet(this, _FindTouristMobile_nameTypedMaps, "f")[ctrlTypeName])
                            __classPrivateFieldGet(this, _FindTouristMobile_nameTypedMaps, "f")[ctrlTypeName] = [];
                        __classPrivateFieldGet(this, _FindTouristMobile_nameTypedMaps, "f")[ctrlTypeName].push(ctrlTyped.attr('data-name'));
                    });
                }
            });
            // фильтры (по сути единственный, автокомплит)
            this.filters = new App.FiltersMobileBase({
                root: __classPrivateFieldGet(this, _FindTouristMobile_findtouristWrap, "f"), // '.js-findtourist-data-item',
                onFilterChanged: v => this.onFilterChanged(v),
                ignoreValidator: true,
            });
            // ключи к фильтрам
            __classPrivateFieldSet(this, _FindTouristMobile_autocompleteKey, 'tourist', "f");
            // ключ к фильтру (он уникальный в рамках этого типа контролов)
            const autocompleteBlock = this.root.find('.js-mobile-filter-autocomplete-block');
            if (autocompleteBlock) {
                __classPrivateFieldSet(this, _FindTouristMobile_autocompleteKey, autocompleteBlock.attr('data-name'), "f");
            }
            // свой тип данных у контрола автокомплит
            const ctrlTourist = this.filters.getControl(__classPrivateFieldGet(this, _FindTouristMobile_autocompleteKey, "f"));
            if (ctrlTourist)
                ctrlTourist.setMapDataToItems((data) => __classPrivateFieldGet(this, _FindTouristMobile_instances, "m", _FindTouristMobile_mapDataToItems).call(this, data));
        }
        /**
         * Инициализация множества FindTouristMobile.
         * @param root
         * @returns
         */
        static Creates(root) {
            const rootRef = root != null && typeof root !== 'string'
                ? root
                : $(root !== null && root !== void 0 ? root : '.js-passenger');
            const items = [];
            rootRef.each((i, r) => { items.push(new FindTouristMobile($(r))); });
            return items;
        }
        /**
         * Модель данных для разметки (для _FindTouristsMobile.hbs).
         * NOTE: эта модель данных должны использоваться для каждого туриста своя.
         * @param options
         * @returns
         */
        static ViewModel(options) {
            return Object.assign({ name: 'tourist_finder_' + FindTouristMobile.GuidGenerator(), minLength: App.app.settings.minSearchTermLength, caption: 'Выбрать постоянного туриста', searchPlaceholder: 'Укажите часть фамилии', isOnlyCaption: true, isHtmlLabels: true, dateFormat: 'dd.MM.yyyy' }, options);
        }
        // TODO: to library
        static GuidGenerator() {
            return App.MobileFilterBlockBase.GuidGenerator();
        }
        /**
         * Преобразование модели данных.
         * Функция идентична как в оригинале (в FindTourist.ts).
         * TODO: эта функция и в FindTourist.ts должны использовать один общий метод преобразования.
         * @param data
         * @returns
         */
        dataToDTO(data) {
            if (!data)
                return [];
            const dto = data.map(v => ({
                key: v.key,
                name: v.hasMultiDocuments == '0'
                    // eslint-disable-next-line no-irregular-whitespace
                    ? (`${v.lastname} ${v.firstname} ${v.middlename}, ${v.birthday}${(v.phoneNumber != null && v.phoneNumber != '') ? (`, <span class="phone">тел:</span>&nbsp;﻿${v.phoneNumber}`) : ''}${(v.docSeries != null && v.docSeries != '') ? (`, <span class= "doc-type" >${(v.isRussianPassport == '1' ? 'ГП' : 'ОЗП')}:</span>&nbsp;${v.docSeries}&nbsp;﻿${v.docNumber}`) : ''}`)
                    : (v.docIndex == '1'
                        // eslint-disable-next-line no-irregular-whitespace
                        ? `${v.lastname} ${v.firstname} ${v.middlename}, ${v.birthday}${(v.phoneNumber != null && v.phoneNumber != '') ? (`, <span class="phone">тел:</span>&nbsp;﻿${v.phoneNumber}`) : ''} <br/>&emsp;— <span class="doc-type mt-7">${(v.isRussianPassport == '1' ? 'ГП' : 'ОЗП')}:</span>&nbsp;${v.docSeries}&nbsp;﻿${v.docNumber}`
                        // eslint-disable-next-line no-irregular-whitespace
                        : `&emsp;— <span class="doc-type">${(v.isRussianPassport == '1' ? 'ГП' : 'ОЗП')}:</span>&nbsp;${v.docSeries}&nbsp;﻿${v.docNumber}`),
                firstname: v.firstname,
                lastname: v.lastname,
                middlename: v.middlename,
                birthday: v.birthday,
                gender: v.gender,
                phoneNumber: v.phoneNumber,
                email: v.email,
                docSeries: v.docSeries,
                docNumber: v.docNumber,
                docIndex: v.docIndex,
                hasMultiDocuments: v.hasMultiDocuments,
                documentNumber: `${v.docSeries}${v.docNumber}`,
                documentIssueDate: v.documentIssueDate,
                documentExpirationDate: v.documentExpirationDate,
                isRussianPassport: v.isRussianPassport,
                citizenshipCountry: v.citizenshipCountry,
                documentCountry: v.documentCountry,
                citizenshipCountryName: v.citizenshipCountryName,
                documentCountryName: v.documentCountryName,
                inn: v.inn,
            }));
            return dto;
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                // обновилось значение в автокомплите (выбрали пользователя по поиску)
                if (filterName == __classPrivateFieldGet(this, _FindTouristMobile_autocompleteKey, "f")) {
                    const itms = this.filters.getControlAutocompleteOriginalValues(__classPrivateFieldGet(this, _FindTouristMobile_autocompleteKey, "f"));
                    if (!itms || itms.length <= 0)
                        return;
                    const selectedItem = itms[0];
                    // обновляем все (заинтересованные) контролы новыми значениями от выбранного объекта
                    $.each(__classPrivateFieldGet(this, _FindTouristMobile_nameParts, "f"), (__, ctrlTypeName) => {
                        const controlRealNames = __classPrivateFieldGet(this, _FindTouristMobile_nameTypedMaps, "f")[ctrlTypeName];
                        let value;
                        value = selectedItem[ctrlTypeName];
                        // некоторые преобразования формата (не как пришло от dto)
                        if (ctrlTypeName == 'gender')
                            value = (value == '0' ? App.MobileFilterGenderValue.Male : App.MobileFilterGenderValue.Female);
                        else if (ctrlTypeName == 'birthday')
                            value = App.parseDate(value, __classPrivateFieldGet(this, _FindTouristMobile_dateFormat, "f"));
                        // set
                        if (controlRealNames && controlRealNames.length > 0) {
                            controlRealNames.forEach(controlRealName => { PwStore.ChangeFilter(controlRealName, value, true); });
                        }
                    });
                    // сбрасываем соседний Выбор существующего
                    // NOTE: это нужно в том случае, когда выбрали Существующего, потом решили выбрать Поиском туриста
                    //     и после этого решили снова выбрать Существующего - но тот контрол считает его уже выбранным
                    //     и не даст снова его перевыбрать
                    // WARNING: мы должны быть убежденены, что в рамках этого блока не будет в разметке других selectlist,
                    //     чтобы не сбросить не тот контрол
                    const target = __classPrivateFieldGet(this, _FindTouristMobile_findtouristWrap, "f").closest('.js-passenger');
                    if (target) {
                        const existsSelect = target.find('.js-mobile-filter-selectlist-block');
                        if (existsSelect) {
                            const existsSelectkey = existsSelect.attr('data-name');
                            PwStore.ResetFilterByName(existsSelectkey || '');
                        }
                    }
                }
            });
        }
    }
    _FindTouristMobile_autocompleteKey = new WeakMap(), _FindTouristMobile_findtouristWrap = new WeakMap(), _FindTouristMobile_nameParts = new WeakMap(), _FindTouristMobile_nameTypedMaps = new WeakMap(), _FindTouristMobile_dateFormat = new WeakMap(), _FindTouristMobile_instances = new WeakSet(), _FindTouristMobile_mapDataToItems = function _FindTouristMobile_mapDataToItems(data) {
        if (!data)
            return [];
        const d = data;
        const dto = this.dataToDTO(d.data);
        const items = dto.map(item => ({
            original: Object.assign({}, item),
            value: item.key,
            name: '', // $('<div>').html(item.name).text(),
            label: item.name,
            isGroup: false,
        }));
        return items;
    };
    App.FindTouristMobile = FindTouristMobile;
})(App || (App = {}));
var App;
(function (App) {
    class FindTourist {
        constructor() {
            Object.defineProperty(this, "self", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.self = '.js-passenger';
            this.root = $(this.self);
            // Стилизуем скролл
            const scrollerWrap = $('.js-findtourist-scroller-wrap', this.root);
            const scroll = scrollerWrap.baron({
                scroller: '.js-findtourist-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            const prev = $('.js-findtourist-data-item', this.root);
            const nameParts = ['key', 'lastname', 'firstname', 'middlename', 'birthday', 'gender',
                // для туров:
                'citizenship', 'documentType', 'documentNumber', 'documentIssueCountry', 'documentIssueDate', 'documentExpirationDate',
                // для заказов:
                'phoneNumber', 'email', 'citizenshipCountryName', 'documentCountryName', 'inn'];
            $('html').on('click', e => {
                if ($(e.target).closest('.js-findtourist-data-item').length == 0) {
                    this.root.find('.js-findtourist-data-select').removeClass('_opened');
                }
            });
            prev.each((_, item) => {
                const wrap = $(item);
                const select = wrap.find('.js-findtourist-data-select');
                const search = wrap.find('.js-findtourist-input');
                // поиск постоянных туристов
                const touristsBlock = select.find('.js-findtourist-block');
                const touristsInput = $('.js-findtourist-input', touristsBlock);
                const touristsResults = touristsBlock.find('.js-findtourist-results');
                const touristsAutocomplete = $('.js-findtourist-autocomplete', touristsBlock);
                const target = wrap.closest('.js-passenger');
                select.on('click', e => {
                    if ($(e.target).is('[id]')) {
                        $(e.currentTarget).removeClass('_opened');
                        search.val('');
                        touristsAutocomplete.hide();
                    }
                    else {
                        $(e.currentTarget).addClass('_opened');
                        search.trigger('focus');
                    }
                });
                touristsInput.autocomplete({
                    minLength: 4,
                    appendTo: touristsResults,
                    source: (request, response) => {
                        /* eslint-disable @typescript-eslint/no-floating-promises */
                        $.ajax({
                            url: $(touristsBlock).attr('data-findtourist-url'),
                            method: 'GET',
                            data: {
                                'search': request.term,
                                'type': $(touristsBlock).attr('data-findtourist-type'),
                            },
                            success: (data) => {
                                const dto = data.data.map(v => ({
                                    key: v.key,
                                    name: v.hasMultiDocuments == '0'
                                        // eslint-disable-next-line no-irregular-whitespace
                                        ? (`${v.lastname} ${v.firstname} ${v.middlename}, ${v.birthday}${(v.phoneNumber != null && v.phoneNumber != '') ? (`, <span class="phone">тел:</span>&nbsp;﻿${v.phoneNumber}`) : ''}${(v.docSeries != null && v.docSeries != '') ? (`, <span class= "doc-type" >${(v.isRussianPassport == '1' ? 'ГП' : 'ОЗП')}:</span>&nbsp;${v.docSeries}&nbsp;﻿${v.docNumber}`) : ''}`)
                                        : (v.docIndex == '1'
                                            // eslint-disable-next-line no-irregular-whitespace
                                            ? `${v.lastname} ${v.firstname} ${v.middlename}, ${v.birthday}${(v.phoneNumber != null && v.phoneNumber != '') ? (`, <span class="phone">тел:</span>&nbsp;﻿${v.phoneNumber}`) : ''} <br/>&emsp;— <span class="doc-type mt-7">${(v.isRussianPassport == '1' ? 'ГП' : 'ОЗП')}:</span>&nbsp;${v.docSeries}&nbsp;﻿${v.docNumber}`
                                            // eslint-disable-next-line no-irregular-whitespace
                                            : `&emsp;— <span class="doc-type">${(v.isRussianPassport == '1' ? 'ГП' : 'ОЗП')}:</span>&nbsp;${v.docSeries}&nbsp;﻿${v.docNumber}`),
                                    firstname: v.firstname,
                                    lastname: v.lastname,
                                    middlename: v.middlename,
                                    birthday: v.birthday,
                                    gender: v.gender,
                                    phoneNumber: v.phoneNumber,
                                    email: v.email,
                                    docSeries: v.docSeries,
                                    docNumber: v.docNumber,
                                    docIndex: v.docIndex,
                                    hasMultiDocuments: v.hasMultiDocuments,
                                    documentNumber: `${v.docSeries}${v.docNumber}`,
                                    documentIssueDate: v.documentIssueDate,
                                    documentExpirationDate: v.documentExpirationDate,
                                    isRussianPassport: v.isRussianPassport,
                                    citizenshipCountry: v.citizenshipCountry,
                                    documentCountry: v.documentCountry,
                                    citizenshipCountryName: v.citizenshipCountryName,
                                    documentCountryName: v.documentCountryName,
                                    inn: v.inn,
                                }));
                                response(dto);
                            },
                        });
                        /* eslint-enable @typescript-eslint/no-floating-promises */
                    },
                    response: (__, ui) => {
                        if (ui.content.length > 0) {
                            touristsAutocomplete.show();
                            scroll.update();
                        }
                    },
                    select: (event, ui) => {
                        event.preventDefault();
                        $.each(nameParts, (__, item2) => {
                            const input = target.find(`input[data-type='${item2}']`);
                            if (input.length > 0) {
                                input.val('');
                                input.val(ui.item[item2]).trigger('change');
                            }
                        });
                        $('.js-form-gender-input', App.app.container).trigger('change');
                        // TODO: из ExixtingPassegers.ts начало. кусок для экскурсий и отелей, т.к. моя форма не совпадает по верстке с формой авиа и остальных,
                        // которые уже сделаны по этому шаблону, а переделывать формы пока не охота.
                        // gender разные вариации 2 и 3 .
                        const genderInput = target.find('input[name*="gender"], .js-form-gender-input');
                        if (genderInput.is(':radio')) {
                            if (ui.item.gender == '1') {
                                // gender разные вариации 3.
                                genderInput.filter('[value="Female"]').prop('checked', true).trigger('change');
                                genderInput.filter('[value="Male"]').prop('checked', false).trigger('change');
                            }
                            else {
                                // gender разные вариации 3.
                                genderInput.filter('[value="Female"]').prop('checked', false).trigger('change');
                                genderInput.filter('[value="Male"]').prop('checked', true).trigger('change');
                            }
                        }
                        // TODO: конец
                        // иконка туриста
                        target.find('.js-form-gender-icon').toggleClass('_woman', ui.item.gender === '1');
                        /* select-боксы -> */
                        $.each(nameParts, (__, item2) => {
                            const value = ui.item[item2];
                            if (value) {
                                const selectBlock = target.find(`.js-form-select-block[data-type='${item2}']`);
                                if (selectBlock.length > 0) {
                                    const sblock = new App.FilterSelectBlock({ root: $(selectBlock) });
                                    sblock.setValue(value);
                                }
                            }
                        });
                        /* <- select-боксы */
                        $(target).trigger("findTouristOption:click" /* Events.FindTouristOptionClick */, ui.item);
                    },
                });
            });
        }
    }
    App.FindTourist = FindTourist;
})(App || (App = {}));
var App;
(function (App) {
    var _Form_instances, _a, _Form_options, _Form_tabs, _Form_filesSingle, _Form_filesMultiple, _Form_filesAjax, _Form_defaultValidationRules, _Form_getFilename, _Form_createValidator, _Form_getContainer, _Form_ignoreValidation;
    class Form {
        constructor(options) {
            _Form_instances.add(this);
            _Form_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "steps", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _Form_tabs.set(this, void 0);
            _Form_filesSingle.set(this, void 0);
            _Form_filesMultiple.set(this, void 0);
            _Form_filesAjax.set(this, void 0);
            _Form_defaultValidationRules.set(this, {});
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const defaults = {
                root: '.js-form',
                disableStepValidation: false,
                disableInstantValidation: false,
            };
            __classPrivateFieldSet(this, _Form_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _Form_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            this.steps = new App.FormStep({
                root: this.root.find('.js-form-steps'),
                form: this.root,
                disableValidation: __classPrivateFieldGet(this, _Form_options, "f").disableStepValidation,
            });
            __classPrivateFieldSet(this, _Form_tabs, new App.Tabs({ root: this.root }), "f");
            // Поля загрузки файлов, одиночный, множественный, через ajax
            __classPrivateFieldSet(this, _Form_filesSingle, $('.js-form-file[type="file"]', this.root), "f");
            __classPrivateFieldSet(this, _Form_filesMultiple, $('.js-form-files[type="file"]', this.root), "f");
            __classPrivateFieldSet(this, _Form_filesAjax, $('.js-form-files-ajax[type="file"]', this.root), "f");
            // Задаем правила валидации для файлов
            $(__classPrivateFieldGet(this, _Form_filesSingle, "f")).add(__classPrivateFieldGet(this, _Form_filesMultiple, "f")).add(__classPrivateFieldGet(this, _Form_filesAjax, "f")).each((i, v) => {
                const name = $(v).attr('name');
                if (name)
                    __classPrivateFieldGet(this, _Form_defaultValidationRules, "f")[name] = { file: true };
            });
            // Задаем маски по атрибуту words (только буквы)
            // TODO Obsolete: вместо этого использовать атрибуты data-inputmask-alias="names" и data-rule-mask="true".
            $('[data-mask-words]', this.root).each((i, v) => {
                $(v).inputmask({
                    regex: '^[а-яА-ЯёЁa-zA-Z -]+$',
                    placeholder: '',
                });
            });
            // Задаем маски по атрибуту phone (телефон по маске)
            // TODO Obsolete: вместо этого использовать атрибуты data-inputmask-alias="phone" (или "phoneru")
            // data-inputmask-keepstatic="false" data-inputmask-autounmask="true" и data-rule-mask="true".
            $('[data-mask-phone]', this.root).each((i, v) => {
                const jqElement = $(v);
                const name = jqElement.attr('name');
                jqElement.inputmask({
                    mask: '8 (999) 999 - 99 - 99',
                    showMaskOnHover: false,
                });
                if (name)
                    __classPrivateFieldGet(this, _Form_defaultValidationRules, "f")[name] = { phone: true };
            });
            $('[data-mask-phoneru]', this.root).each((i, v) => {
                const jqElement = $(v);
                const name = jqElement.attr('name');
                jqElement.inputmask({
                    mask: '+7 (999) 999 - 99 - 99',
                    showMaskOnHover: false,
                });
                if (name)
                    __classPrivateFieldGet(this, _Form_defaultValidationRules, "f")[name] = { phoneRu: true };
            });
            $('[data-mask-time]', this.root).each((i, v) => {
                const jq = $(v);
                const name = jq.attr('name');
                jq.inputmask({
                    mask: '99:99',
                    // placeholder: '_',
                    showMaskOnHover: false,
                });
                if (name)
                    __classPrivateFieldGet(this, _Form_defaultValidationRules, "f")[name] = { time: true };
            });
            // Используется для считывания настроек маски ввода из атрибутов.
            $('.js-form-item-field', this.root).inputmask();
            // Проверить поля при изменении значения (дополнение к стандартным проверкам jquery.validate).
            // this.#inputs.change(e => $(e.currentTarget).valid());
            this.root.on('change', '.js-form-item-field', e => $(e.currentTarget).valid());
            // Устанавливаем валидацию формы
            this.validator = __classPrivateFieldGet(this, _Form_instances, "m", _Form_createValidator).call(this);
            // Показываем активные вкладки
            __classPrivateFieldGet(this, _Form_tabs, "f").showActive();
            // Обработка полей файлов, просто один файл
            __classPrivateFieldGet(this, _Form_filesSingle, "f").on('change', e => {
                var _b;
                const target = $(e.currentTarget);
                const wrapper = target.parent();
                const lbl = wrapper.find('.label');
                if (target.attr('type') !== 'file')
                    return;
                let fileName;
                const { files } = target[0];
                if (files != null)
                    fileName = files[0].name;
                else
                    fileName = __classPrivateFieldGet(_a, _a, "m", _Form_getFilename).call(_a, target.valString());
                if (!fileName.length)
                    lbl.text((_b = target.attr('data-label')) !== null && _b !== void 0 ? _b : '');
                else
                    lbl.text(fileName);
            });
            // Обработка полей файлов, загрузка вместе с формой
            __classPrivateFieldGet(this, _Form_filesMultiple, "f").on('change', e => {
                const target = $(e.currentTarget);
                const list = target.closest('.form-item').find('.form-item__multiple-files ul');
                list.empty();
                const { files } = target[0];
                if (files != null) {
                    for (let i = 0; i < files.length; i++)
                        list.append(`<li data-idx="${i}"><div class="form-close-icon"></div>${files[i].name}</li>`);
                }
                else {
                    const fileName = __classPrivateFieldGet(_a, _a, "m", _Form_getFilename).call(_a, target.valString());
                    list.append(`<li><div class="form-close-icon"></div>${fileName}</li>`);
                }
                list.on('click', '.form-close-icon', e2 => {
                    const listTarget = $(e2.currentTarget);
                    listTarget.parent().remove();
                    if (!list.find('li').length) {
                        target.wrap('<form>').closest('form').get(0).reset();
                        target.unwrap();
                    }
                    // Невозможно удалить нужен другой метод
                    // delete target[0].files[listTarget.parent().data('idx')];
                    setTimeout(() => {
                        target.valid();
                    }, 100);
                    // $('input[type="file"]').on('change', () => { $(this).append('<input type="file" name="file[]" />'});
                });
            });
            // Обработка полей файлов, автоматом загрузка ajax
            __classPrivateFieldGet(this, _Form_filesAjax, "f").on('change', e => {
                var _b;
                const target = $(e.currentTarget);
                const wrapper = target.parent();
                const field = target.closest('.form-item-field');
                const url = (_b = target.closest('form').attr('action')) !== null && _b !== void 0 ? _b : '';
                const bar = wrapper.find('.percentage');
                const lbl = wrapper.find('.label');
                const form = $(`<form action="${url}" method="post" enctype="multipart/form-data">`);
                lbl.empty();
                const { files } = target[0];
                if (files != null) {
                    for (let i = 0; i < files.length; i++)
                        lbl[0].innerHTML += (i ? ', ' : '') + files[i].name;
                }
                else {
                    lbl.text(__classPrivateFieldGet(_a, _a, "m", _Form_getFilename).call(_a, target.valString()));
                }
                if (target.valid() && files != null && files.length > 0) {
                    form.append(target);
                    form.ajaxForm({
                        beforeSend: () => {
                            const percentVal = '0%';
                            bar.width(percentVal);
                            field.removeClass('_uploaded').addClass('_uploading');
                        },
                        uploadProgress: (event, position, total, percentComplete) => {
                            const percentVal = `${percentComplete}%`;
                            bar.width(percentVal);
                        },
                        success: () => {
                            const percentVal = '100%';
                            bar.width(percentVal);
                            field.addClass('_uploaded');
                        },
                        complete: () => {
                            field.removeClass('_uploading');
                        },
                    }).trigger('submit');
                }
                field.on('click', '.js-form-files-close', () => {
                    var _b;
                    field.removeClass('_uploaded');
                    form.resetForm();
                    wrapper.append(target);
                    lbl.text((_b = target.attr('data-label')) !== null && _b !== void 0 ? _b : '');
                });
            });
        }
    }
    _a = Form, _Form_options = new WeakMap(), _Form_tabs = new WeakMap(), _Form_filesSingle = new WeakMap(), _Form_filesMultiple = new WeakMap(), _Form_filesAjax = new WeakMap(), _Form_defaultValidationRules = new WeakMap(), _Form_instances = new WeakSet(), _Form_getFilename = function _Form_getFilename(path) {
        return path.slice(path.lastIndexOf('\\') + 1);
    }, _Form_createValidator = function _Form_createValidator() {
        const defaults = {
            errorClass: '_invalid',
            validClass: '_valid',
            normalizer(value) {
                if (!value || value === '')
                    return '';
                const element = $(this);
                if (element.hasClass('hasDatepicker') && typeof value === 'string') {
                    const date = $.datepicker.parseDate(element.datepicker('option', 'dateFormat'), value);
                    if (date)
                        return App.formatDate(date, 'isoDate');
                }
                return value;
            },
            errorPlacement: (error, element) => {
                __classPrivateFieldGet(_a, _a, "m", _Form_getContainer).call(_a, element).find('.form-item-error').first().text(error.text());
            },
            highlight: (element, errorClass, validClass) => {
                __classPrivateFieldGet(_a, _a, "m", _Form_getContainer).call(_a, element).addClass(errorClass).removeClass(validClass);
            },
            unhighlight: (element, errorClass, validClass) => {
                __classPrivateFieldGet(_a, _a, "m", _Form_getContainer).call(_a, element).removeClass(errorClass).addClass(validClass);
            },
            rules: Object.assign({}, __classPrivateFieldGet(this, _Form_defaultValidationRules, "f")),
        };
        // Note: переопределена опция ignore, т.к. по-умолчанию игнорируются скрытые поля (ignore: ':hidden'), что неприемлемо для
        // формы, состоящей из нескольких шагов, которые валидируются все разом.
        if (__classPrivateFieldGet(this, _Form_options, "f").disableStepValidation) {
            // TODO: учитывать step-контейнер поля.
            defaults.ignore = '';
        }
        else {
            defaults.ignore = __classPrivateFieldGet(_a, _a, "m", _Form_ignoreValidation);
        }
        if (__classPrivateFieldGet(this, _Form_options, "f").disableInstantValidation) {
            defaults.onfocusout = false;
            defaults.onkeyup = false;
            defaults.onclick = false;
        }
        return this.root.validate(Object.assign(Object.assign({}, defaults), __classPrivateFieldGet(this, _Form_options, "f").validationOptions));
    }, _Form_getContainer = function _Form_getContainer(element) {
        return $(element).closest('.form-item, .js-form-item');
    }, _Form_ignoreValidation = function _Form_ignoreValidation(index, element) {
        let field = $(element);
        if (field.hasClass('js-jelect-input'))
            field = field.closest('.js-jelect');
        return field.is(':hidden');
    };
    App.Form = Form;
})(App || (App = {}));
var App;
(function (App) {
    var _FormStep_instances, _FormStep_options, _FormStep_root, _FormStep_tabs, _FormStep_content, _FormStep_current, _FormStep_total, _FormStep_scrollTimer, _FormStep_showStep, _FormStep_onNextClick, _FormStep_onPrevClick, _FormStep_validate, _FormStep_disabled, _FormStep_getNext, _FormStep_getPrev;
    class FormStep {
        constructor(options) {
            _FormStep_instances.add(this);
            _FormStep_options.set(this, void 0);
            _FormStep_root.set(this, void 0);
            _FormStep_tabs.set(this, void 0);
            _FormStep_content.set(this, void 0);
            _FormStep_current.set(this, void 0);
            _FormStep_total.set(this, void 0);
            _FormStep_scrollTimer.set(this, null);
            const defaults = {
                root: '.js-form-steps',
                disableValidation: false,
            };
            __classPrivateFieldSet(this, _FormStep_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _FormStep_options, "f");
            if (typeof root === 'string')
                __classPrivateFieldSet(this, _FormStep_root, $(root), "f");
            else
                __classPrivateFieldSet(this, _FormStep_root, root, "f");
            __classPrivateFieldSet(this, _FormStep_tabs, $('.js-form-step', __classPrivateFieldGet(this, _FormStep_root, "f")), "f");
            __classPrivateFieldSet(this, _FormStep_content, $('.js-form-step-content', __classPrivateFieldGet(this, _FormStep_root, "f")), "f");
            const next = $('.js-form-steps-next', __classPrivateFieldGet(this, _FormStep_root, "f"));
            const prev = $('.js-form-steps-prev', __classPrivateFieldGet(this, _FormStep_root, "f"));
            __classPrivateFieldSet(this, _FormStep_total, __classPrivateFieldGet(this, _FormStep_content, "f").length, "f");
            // Устанавливаем активный шаг
            __classPrivateFieldSet(this, _FormStep_current, __classPrivateFieldGet(this, _FormStep_content, "f").filter('._active').length ? __classPrivateFieldGet(this, _FormStep_content, "f").filter('._active').index() : 0, "f");
            if (__classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_disabled).call(this, __classPrivateFieldGet(this, _FormStep_current, "f")))
                __classPrivateFieldSet(this, _FormStep_current, __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_getNext).call(this, __classPrivateFieldGet(this, _FormStep_current, "f")), "f");
            __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_showStep).call(this, __classPrivateFieldGet(this, _FormStep_current, "f"));
            // Если отключена пошаговая валидация, то позволяем переходить на любой шаг через нажатие на заголовок закладки.
            if (__classPrivateFieldGet(this, _FormStep_options, "f").disableValidation) {
                __classPrivateFieldGet(this, _FormStep_tabs, "f").each((i, v) => {
                    $(v).on('click', () => this.show(i));
                });
            }
            // Кнопки переключения закладок
            next.on('click', () => __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_onNextClick).call(this));
            prev.on('click', () => __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_onPrevClick).call(this));
        }
        // Функция прокручиает до указателей шагов если нужно
        show(current) {
            if (current < 0 || __classPrivateFieldGet(this, _FormStep_current, "f") === current || __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_disabled).call(this, current))
                return;
            const rootOffset = __classPrivateFieldGet(this, _FormStep_root, "f").offset();
            const containerScrollTop = App.app.container.scrollTop() || 0;
            let top = (rootOffset != null ? rootOffset.top : 0);
            if (App.isTouch)
                top += containerScrollTop;
            if (containerScrollTop > top - 20) {
                App.app.container.animate({ scrollTop: top - 20 }, 500, () => {
                    if (__classPrivateFieldGet(this, _FormStep_scrollTimer, "f"))
                        clearTimeout(__classPrivateFieldGet(this, _FormStep_scrollTimer, "f"));
                    __classPrivateFieldSet(this, _FormStep_scrollTimer, window.setTimeout(() => {
                        if (!__classPrivateFieldGet(this, _FormStep_options, "f").form || current <= __classPrivateFieldGet(this, _FormStep_current, "f") || __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_validate).call(this))
                            __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_showStep).call(this, current);
                        $(document).trigger("digest:update" /* Events.DigestUpdate */);
                    }, 40), "f");
                });
            }
            else {
                if (!__classPrivateFieldGet(this, _FormStep_options, "f").form || current <= __classPrivateFieldGet(this, _FormStep_current, "f") || __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_validate).call(this))
                    __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_showStep).call(this, current);
                $(document).trigger("digest:update" /* Events.DigestUpdate */);
            }
        }
    }
    _FormStep_options = new WeakMap(), _FormStep_root = new WeakMap(), _FormStep_tabs = new WeakMap(), _FormStep_content = new WeakMap(), _FormStep_current = new WeakMap(), _FormStep_total = new WeakMap(), _FormStep_scrollTimer = new WeakMap(), _FormStep_instances = new WeakSet(), _FormStep_showStep = function _FormStep_showStep(num) {
        // Переключаем табы
        __classPrivateFieldGet(this, _FormStep_tabs, "f").removeClass('_active').eq(num).addClass('_active');
        __classPrivateFieldGet(this, _FormStep_content, "f").stop()
            .hide()
            .removeClass('_active')
            .eq(num)
            .fadeIn()
            .addClass('_active');
        // Выставляем переключатели шагов вперед/назад/сабмит
        __classPrivateFieldGet(this, _FormStep_root, "f").removeClass('form-steps_start form-steps_end');
        if (num === 0)
            __classPrivateFieldGet(this, _FormStep_root, "f").addClass('form-steps_start');
        else if (num === __classPrivateFieldGet(this, _FormStep_total, "f") - 1)
            __classPrivateFieldGet(this, _FormStep_root, "f").addClass('form-steps_end');
        // Активный шаг
        __classPrivateFieldSet(this, _FormStep_current, num, "f");
        return true;
    }, _FormStep_onNextClick = function _FormStep_onNextClick() {
        const current = __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_getNext).call(this, __classPrivateFieldGet(this, _FormStep_current, "f"));
        if (current >= 0)
            this.show(current);
    }, _FormStep_onPrevClick = function _FormStep_onPrevClick() {
        const current = __classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_getPrev).call(this, __classPrivateFieldGet(this, _FormStep_current, "f"));
        if (current >= 0)
            this.show(current);
    }, _FormStep_validate = function _FormStep_validate() {
        if (__classPrivateFieldGet(this, _FormStep_options, "f").disableValidation)
            return true;
        const inputs = __classPrivateFieldGet(this, _FormStep_content, "f").eq(__classPrivateFieldGet(this, _FormStep_current, "f")).find('.js-form-item-field');
        if (!inputs.length)
            return true;
        return inputs.valid();
    }, _FormStep_disabled = function _FormStep_disabled(num) {
        return __classPrivateFieldGet(this, _FormStep_tabs, "f").eq(num).hasClass('_disabled');
    }, _FormStep_getNext = function _FormStep_getNext(current) {
        if (current + 1 >= __classPrivateFieldGet(this, _FormStep_total, "f"))
            return -1;
        for (let i = current + 1; i < __classPrivateFieldGet(this, _FormStep_total, "f"); i++) {
            if (!__classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_disabled).call(this, i))
                return i;
        }
        return -1;
    }, _FormStep_getPrev = function _FormStep_getPrev(current) {
        if (current - 1 < 0)
            return -1;
        for (let i = current - 1; i >= 0; i--) {
            if (!__classPrivateFieldGet(this, _FormStep_instances, "m", _FormStep_disabled).call(this, i))
                return i;
        }
        return -1;
    };
    App.FormStep = FormStep;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _Guid_s_empty, _Guid_s_newGuid, _Guid_newGuidCryptoUuid, _Guid_newGuidCryptoRandom, _Guid_newGuidMathRandom;
    class Guid {
        static get empty() {
            return __classPrivateFieldGet(_a, _a, "f", _Guid_s_empty);
        }
        static newGuid() {
            return __classPrivateFieldGet(_a, _a, "f", _Guid_s_newGuid).call(_a);
        }
    }
    _a = Guid, _Guid_newGuidCryptoUuid = function _Guid_newGuidCryptoUuid() {
        return crypto.randomUUID();
    }, _Guid_newGuidCryptoRandom = function _Guid_newGuidCryptoRandom() {
        return `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, c => {
            const n = Number(c);
            return (n ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> n / 4).toString(16);
        });
    }, _Guid_newGuidMathRandom = function _Guid_newGuidMathRandom() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    _Guid_s_empty = { value: '00000000-0000-0000-0000-000000000000' };
    _Guid_s_newGuid = { value: typeof crypto === 'undefined'
            ? __classPrivateFieldGet(_a, _a, "m", _Guid_newGuidMathRandom)
            : typeof crypto.randomUUID !== 'undefined'
                ? __classPrivateFieldGet(_a, _a, "m", _Guid_newGuidCryptoUuid)
                : typeof crypto.getRandomValues !== 'undefined'
                    ? __classPrivateFieldGet(_a, _a, "m", _Guid_newGuidCryptoRandom)
                    : __classPrivateFieldGet(_a, _a, "m", _Guid_newGuidMathRandom) };
    App.Guid = Guid;
})(App || (App = {}));
var App;
(function (App) {
    var _HandlerBuilder_invokers, _HandlerDispatcher_instances, _HandlerDispatcher_bottomInvoker, _HandlerDispatcher_handlers, _HandlerDispatcher_invokeCore;
    class HandlerBuilder {
        constructor() {
            _HandlerBuilder_invokers.set(this, []);
        }
        add(...handlers) {
            for (let i = 0; i < handlers.length; i++)
                __classPrivateFieldGet(this, _HandlerBuilder_invokers, "f").push(next => (request) => handlers[i](request, next));
            return this;
        }
        build(bottomInvoker) {
            let invoker = bottomInvoker;
            for (let i = __classPrivateFieldGet(this, _HandlerBuilder_invokers, "f").length - 1; i >= 0; i--)
                invoker = __classPrivateFieldGet(this, _HandlerBuilder_invokers, "f")[i](invoker);
            return invoker;
        }
    }
    _HandlerBuilder_invokers = new WeakMap();
    App.HandlerBuilder = HandlerBuilder;
    class HandlerDispatcher {
        constructor(bottomInvoker) {
            _HandlerDispatcher_instances.add(this);
            _HandlerDispatcher_bottomInvoker.set(this, void 0);
            _HandlerDispatcher_handlers.set(this, []);
            __classPrivateFieldSet(this, _HandlerDispatcher_bottomInvoker, bottomInvoker, "f");
        }
        use(...handlers) {
            for (let i = 0; i < handlers.length; i++)
                __classPrivateFieldGet(this, _HandlerDispatcher_handlers, "f").push(handlers[i]);
            return this;
        }
        invoke(request) {
            return __classPrivateFieldGet(this, _HandlerDispatcher_instances, "m", _HandlerDispatcher_invokeCore).call(this, request, 0);
        }
    }
    _HandlerDispatcher_bottomInvoker = new WeakMap(), _HandlerDispatcher_handlers = new WeakMap(), _HandlerDispatcher_instances = new WeakSet(), _HandlerDispatcher_invokeCore = function _HandlerDispatcher_invokeCore(request, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const handler = __classPrivateFieldGet(this, _HandlerDispatcher_handlers, "f")[index];
            return yield handler(request, () => {
                if (index < __classPrivateFieldGet(this, _HandlerDispatcher_handlers, "f").length - 1)
                    return __classPrivateFieldGet(this, _HandlerDispatcher_instances, "m", _HandlerDispatcher_invokeCore).call(this, request, index + 1);
                return __classPrivateFieldGet(this, _HandlerDispatcher_bottomInvoker, "f").call(this, request);
            });
        });
    };
    App.HandlerDispatcher = HandlerDispatcher;
})(App || (App = {}));
var App;
(function (App) {
    class History {
        static saveState(data, url) {
            window.history.pushState(data, 'title: ', url);
        }
        static replaceState(data, url, changeUrl = false) {
            const newData = data !== null && data !== void 0 ? data : window.history.state;
            window.history.replaceState(newData, 'title: ', changeUrl ? url : window.location.pathname);
        }
        static getState() {
            return window.history.state;
        }
    }
    App.History = History;
})(App || (App = {}));
var App;
(function (App) {
    var _HotFilterMapperMobile_filters;
    /**
     * Класс для мэппинга элементов формы хотфильтра в массив IFilterCriterion
     */
    class HotFilterMapperMobile {
        constructor(hotFilterRoot, filters) {
            /**
             * контейнер хотфильтра
             */
            // readonly #root: JQuery;
            _HotFilterMapperMobile_filters.set(this, void 0);
            if (!hotFilterRoot)
                throw new Error('hot filter root is undefined');
            if (!filters)
                throw new Error('hot filter filters is undefined');
            // this.#root = hotFilterRoot;
            __classPrivateFieldSet(this, _HotFilterMapperMobile_filters, filters, "f");
        }
        /**
         * Выполняет мэппинг.
         * Делает простой мэппинг - просто переводит сериализованный массив элементов формы в массив IFilterCriterion
         */
        execute() {
            const selectedHotFilters = __classPrivateFieldGet(this, _HotFilterMapperMobile_filters, "f").serializeArray();
            return selectedHotFilters
                // не false значения (их не передаем)
                .filter(item => item.value != null && item.value != 'false')
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
        }
    }
    _HotFilterMapperMobile_filters = new WeakMap();
    App.HotFilterMapperMobile = HotFilterMapperMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotFilterMapper_root;
    /**
     * Класс для мэппинга элементов формы хотфильтра в массив IFilterCriterion
     */
    class HotFilterMapper {
        constructor(hotFilterRoot) {
            /**
             * контейнер хотфильтра
             */
            _HotFilterMapper_root.set(this, void 0);
            if (!hotFilterRoot)
                throw new Error('hot filter root is undefined');
            __classPrivateFieldSet(this, _HotFilterMapper_root, hotFilterRoot, "f");
        }
        /**
         * Выполняет мэппинг.
         * Делает простой мэппинг - просто переводит сериализованный массив элементов формы в массив IFilterCriterion
         */
        execute() {
            const selectedHotFilters = __classPrivateFieldGet(this, _HotFilterMapper_root, "f").serializeArray();
            const filters = selectedHotFilters
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            return filters;
        }
    }
    _HotFilterMapper_root = new WeakMap();
    App.HotFilterMapper = HotFilterMapper;
})(App || (App = {}));
var App;
(function (App) {
    var _ImageLazyLoader_instances, _ImageLazyLoader_options, _ImageLazyLoader_lozadObserver, _ImageLazyLoader_init;
    class ImageLazyLoader {
        constructor(options) {
            _ImageLazyLoader_instances.add(this);
            _ImageLazyLoader_options.set(this, void 0);
            _ImageLazyLoader_lozadObserver.set(this, void 0);
            const defaults = {
                containers: [],
            };
            __classPrivateFieldSet(this, _ImageLazyLoader_options, Object.assign(defaults, options), "f");
            // Инициализация после загрузки DOM
            document.addEventListener('DOMContentLoaded', () => {
                // Глобальная инициализация для статических элементов
                __classPrivateFieldSet(this, _ImageLazyLoader_lozadObserver, window.lozad('.lozad', {
                    rootMargin: '50px 0px',
                    threshold: 0.1,
                }), "f");
                __classPrivateFieldGet(this, _ImageLazyLoader_lozadObserver, "f").observe();
                // Инициализация наблюдения за динамическими контейнерами
                __classPrivateFieldGet(this, _ImageLazyLoader_options, "f").containers.forEach(container => __classPrivateFieldGet(this, _ImageLazyLoader_instances, "m", _ImageLazyLoader_init).call(this, container));
            });
        }
    }
    _ImageLazyLoader_options = new WeakMap(), _ImageLazyLoader_lozadObserver = new WeakMap(), _ImageLazyLoader_instances = new WeakSet(), _ImageLazyLoader_init = function _ImageLazyLoader_init(containerSelector) {
        const containers = document.querySelectorAll(containerSelector);
        containers.forEach(container => {
            const mutationObserver = new MutationObserver(mutations => {
                const shouldUpdate = mutations.some(mutation => {
                    for (let i = 0; i < mutation.addedNodes.length; i++) {
                        const node = mutation.addedNodes[i];
                        if (node.nodeType !== Node.ELEMENT_NODE)
                            continue;
                        const el = node;
                        if ((el.matches && el.matches('.lozad'))
                            || (el.querySelectorAll && el.querySelectorAll('.lozad').length > 0))
                            return true;
                    }
                    return false;
                });
                if (shouldUpdate)
                    __classPrivateFieldGet(this, _ImageLazyLoader_lozadObserver, "f").observe();
            });
            mutationObserver.observe(container, {
                childList: true,
                subtree: true,
            });
        });
    };
    App.ImageLazyLoader = ImageLazyLoader;
})(App || (App = {}));
var App;
(function (App) {
    class InfoMessageCloser {
        constructor() {
            $(document).on('click', '.js-info-msg-close', e => {
                $(e.currentTarget)
                    .closest('.js-info-msg')
                    .hide();
                e.stopPropagation();
            });
        }
    }
    App.InfoMessageCloser = InfoMessageCloser;
})(App || (App = {}));
var App;
(function (App) {
    App.jqueryAjaxErrorDetectionStrategy = () => ({
        isTransient: (error) => {
            if (App.isJQueryAjaxErrorInfo(error)) {
                // Отмена запроса клиентом на стороне клиента (вызов xhr.abort()).
                if (error.statusText === 'abort')
                    return false;
                // Запрос отвалился по timeout, указанному в ajax-запросе на клиенте (например, $.ajax({ timeout: 1000 })).
                if (error.statusText === 'timeout')
                    return true;
                // Ошибка при парсинге ответа.
                if (error.statusText === 'parsererror')
                    return true;
                // Не получен ответ от сервера (например, если сервер недоступен).
                if (error.statusText === 'error')
                    return true;
            }
            Sentry.captureException(error);
            return false;
        },
    });
})(App || (App = {}));
var App;
(function (App) {
    var _LeftSidebar_instances, _a, _LeftSidebar_options, _LeftSidebar_sidebarUnfoldBtn, _LeftSidebar_sidebarCloseBtn, _LeftSidebar_sidebarCurrency, _LeftSidebar_sidebarLinks, _LeftSidebar_sidebarUnfold, _LeftSidebar_popupLinks, _LeftSidebar_baron, _LeftSidebar_unfoldSidebar, _LeftSidebar_closeSidebar, _LeftSidebar_unfoldPopup, _LeftSidebar_foldPopup, _LeftSidebar_showPopupLinks, _LeftSidebar_checkWidth, _LeftSidebar_onCurrencyClick, _LeftSidebar_onScrollerScroll, _LeftSidebar_onWinResize, _LeftSidebar_onAppLoad, _LeftSidebar_onCoverScroll, _LeftSidebar_onCoverClick;
    class LeftSidebar {
        constructor(options) {
            _LeftSidebar_instances.add(this);
            _LeftSidebar_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _LeftSidebar_sidebarUnfoldBtn.set(this, void 0);
            _LeftSidebar_sidebarCloseBtn.set(this, void 0);
            _LeftSidebar_sidebarCurrency.set(this, void 0);
            _LeftSidebar_sidebarLinks.set(this, void 0);
            _LeftSidebar_sidebarUnfold.set(this, void 0);
            _LeftSidebar_popupLinks.set(this, void 0);
            _LeftSidebar_baron.set(this, void 0);
            const defaults = {
                self: '.js-left-sidebar',
            };
            __classPrivateFieldSet(this, _LeftSidebar_options, Object.assign(Object.assign({}, defaults), options), "f");
            this.root = $(__classPrivateFieldGet(this, _LeftSidebar_options, "f").self);
            if (!this.root.length)
                return;
            const sidebar = $(this.root);
            __classPrivateFieldSet(this, _LeftSidebar_sidebarUnfoldBtn, $('.js-l-nav-unfold', this.root), "f");
            __classPrivateFieldSet(this, _LeftSidebar_sidebarCloseBtn, $('.js-l-nav-close', this.root), "f");
            __classPrivateFieldSet(this, _LeftSidebar_sidebarCurrency, $('.js-left-sidebar-currency', this.root), "f");
            __classPrivateFieldSet(this, _LeftSidebar_sidebarLinks, $('.js-l-nav-link', this.root), "f");
            __classPrivateFieldSet(this, _LeftSidebar_sidebarUnfold, $('.js-left-sidebar-nav'), "f");
            const sidebarPopup = $('.js-l-nav-popup', __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfold, "f"));
            __classPrivateFieldSet(this, _LeftSidebar_popupLinks, $('.js-l-nav-popup__links', __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfold, "f")), "f");
            const scroller = $('.js-scroller', __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfold, "f"));
            const scrollerBar = $('.js-nav-scroller-bar', sidebar);
            // Раскрываем левое меню
            __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfoldBtn, "f").on('click', () => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_unfoldSidebar).call(this));
            // Сворачиваем левое меню
            __classPrivateFieldGet(this, _LeftSidebar_sidebarCloseBtn, "f").on('click', () => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_closeSidebar).call(this));
            // Показываем / скрываем вспомогательное менюs
            __classPrivateFieldGet(this, _LeftSidebar_sidebarLinks, "f").on('mouseenter', e => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_unfoldPopup).call(this, e));
            __classPrivateFieldGet(this, _LeftSidebar_sidebarLinks, "f").on('mouseleave', () => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_foldPopup).call(this));
            __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfold, "f").on('mouseenter', e => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_unfoldPopup).call(this, e));
            __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfold, "f").on('mouseleave', () => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_foldPopup).call(this));
            // Показываем / скрываем выпадающее меню
            __classPrivateFieldGet(this, _LeftSidebar_sidebarLinks, "f").on('mouseenter', e => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_showPopupLinks).call(this, e));
            __classPrivateFieldGet(this, _LeftSidebar_sidebarCurrency, "f").on('click', e => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_onCurrencyClick).call(this, e));
            __classPrivateFieldSet(this, _LeftSidebar_baron, sidebarPopup.baron({
                scroller: scroller.get(0),
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            }), "f");
            $('.js-nav-scroller__wrap').baron({
                scroller: '.js-nav-scroller',
                track: '.js-nav-scroller-bar-wrap',
                bar: '.js-nav-scroller-bar',
                barOnCls: 'baron',
            });
            // Предотвращаем ховер на пункты меню при скролле меню
            scrollerBar.on('mousedown', e => __classPrivateFieldGet(_a, _a, "m", _LeftSidebar_onScrollerScroll).call(_a, e));
            $('html').on('mouseup', e => __classPrivateFieldGet(_a, _a, "m", _LeftSidebar_onScrollerScroll).call(_a, e));
            // Обрабатываем ресайз документа
            $(window).on('resize', () => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_onWinResize).call(this));
            // Обрабатываем загрузку документа
            $('body').on("app:loaded" /* Events.Loaded */, () => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_onAppLoad).call(this));
            // Для тачей: предотвращаем скролл подложки
            if (App.isTouch)
                $(window).on('touchmove', e => __classPrivateFieldGet(_a, _a, "m", _LeftSidebar_onCoverScroll).call(_a, e));
            // Закрываем подложку
            App.app.appContainer.on('click', () => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_onCoverClick).call(this));
        }
    }
    _a = LeftSidebar, _LeftSidebar_options = new WeakMap(), _LeftSidebar_sidebarUnfoldBtn = new WeakMap(), _LeftSidebar_sidebarCloseBtn = new WeakMap(), _LeftSidebar_sidebarCurrency = new WeakMap(), _LeftSidebar_sidebarLinks = new WeakMap(), _LeftSidebar_sidebarUnfold = new WeakMap(), _LeftSidebar_popupLinks = new WeakMap(), _LeftSidebar_baron = new WeakMap(), _LeftSidebar_instances = new WeakSet(), _LeftSidebar_unfoldSidebar = function _LeftSidebar_unfoldSidebar() {
        const closeBtn = __classPrivateFieldGet(this, _LeftSidebar_sidebarCloseBtn, "f");
        $('html').addClass('_nav-unfolded');
        __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfoldBtn, "f").fadeOut(250, () => {
            closeBtn.fadeIn(250);
        });
    }, _LeftSidebar_closeSidebar = function _LeftSidebar_closeSidebar() {
        const unfoldBtn = __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfoldBtn, "f");
        $('html').removeClass('_nav-unfolded _only-nav-unfolded');
        __classPrivateFieldGet(this, _LeftSidebar_sidebarCloseBtn, "f").fadeOut(250, () => {
            unfoldBtn.fadeIn(250);
        });
    }, _LeftSidebar_unfoldPopup = function _LeftSidebar_unfoldPopup(e) {
        const target = $(e.currentTarget);
        const hasNav = target.is('[data-nav]');
        const id = target.attr('data-id');
        if (!id)
            return;
        // Если не момент скролла меню
        if (!$('html').hasClass('_no-menu-hover')) {
            // Показываем ховер
            __classPrivateFieldGet(this, _LeftSidebar_sidebarLinks, "f").filter(`[data-id="${id}"]`).addClass('_hover');
            // Если у пункта меню есть вложенные пункты, показываем их
            if (hasNav)
                $('html').addClass('_left-popup');
        }
    }, _LeftSidebar_foldPopup = function _LeftSidebar_foldPopup() {
        $('html').removeClass('_left-popup');
        __classPrivateFieldGet(this, _LeftSidebar_sidebarLinks, "f").removeClass('_hover');
    }, _LeftSidebar_showPopupLinks = function _LeftSidebar_showPopupLinks(e) {
        const target = $(e.currentTarget);
        const id = target.attr('data-id');
        if (!id)
            return;
        const el = __classPrivateFieldGet(this, _LeftSidebar_popupLinks, "f").filter(`[data-id="${id}"]`);
        __classPrivateFieldGet(this, _LeftSidebar_popupLinks, "f").hide();
        // Если есть вложенная плашка с подпунктами, показываем ее и обновляем baron
        if (el.length > 0) {
            // Если быстро-быстро водить курсором над пунктами, то в выпадющее меню собираются пункты из разных
            // групп, на которые попадала мышь. Для предотвращения этого вызываем stop(true, true)
            el.stop(true, true).fadeIn(200);
            __classPrivateFieldGet(this, _LeftSidebar_sidebarUnfold, "f").data('id', id);
            // Обновляем скролл
            __classPrivateFieldGet(this, _LeftSidebar_baron, "f").update();
        }
    }, _LeftSidebar_checkWidth = function _LeftSidebar_checkWidth() {
        // Если панель левого меню свернута
        if ((this.root.width() || 0) > 68)
            $('html').addClass('_only-nav-unfolded');
        else
            $('html').removeClass('_only-nav-unfolded');
    }, _LeftSidebar_onCurrencyClick = function _LeftSidebar_onCurrencyClick(e) {
        const target = $(e.currentTarget);
        __classPrivateFieldGet(this, _LeftSidebar_sidebarCurrency, "f").removeClass('_active');
        target.addClass('_active');
        // Сворачиваем / разворачиваем меню
        if (!$('html').hasClass('_only-nav-unfolded')) {
            if (__classPrivateFieldGet(this, _LeftSidebar_sidebarUnfoldBtn, "f").filter(':visible').length)
                __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_unfoldSidebar).call(this);
            else
                __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_closeSidebar).call(this);
        }
    }, _LeftSidebar_onScrollerScroll = function _LeftSidebar_onScrollerScroll(e) {
        if (e.type === 'mousedown')
            $('html').addClass('_no-menu-hover');
        else if (e.type === 'mouseup')
            $('html').removeClass('_no-menu-hover');
    }, _LeftSidebar_onWinResize = function _LeftSidebar_onWinResize() {
        window.setTimeout(() => __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_checkWidth).call(this), 500);
    }, _LeftSidebar_onAppLoad = function _LeftSidebar_onAppLoad() {
        // Если панель левого меню свернута
        if ((this.root.width() || 0) > 68)
            $('html').addClass('_only-nav-unfolded');
        else
            $('html').removeClass('_only-nav-unfolded');
    }, _LeftSidebar_onCoverScroll = function _LeftSidebar_onCoverScroll(e) {
        const target = $(e.target);
        if ($('html').hasClass('_nav-unfolded') && target.hasClass('js-app-container')) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }, _LeftSidebar_onCoverClick = function _LeftSidebar_onCoverClick() {
        if ($('html').hasClass('_nav-unfolded'))
            __classPrivateFieldGet(this, _LeftSidebar_instances, "m", _LeftSidebar_closeSidebar).call(this);
    };
    App.LeftSidebar = LeftSidebar;
})(App || (App = {}));
/// <reference path='../models/MessageType.ts' />
var App;
(function (App) {
    class Message {
        constructor(type, text) {
            Object.defineProperty(this, "type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: type
            });
            Object.defineProperty(this, "text", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: text
            });
        }
    }
    Object.defineProperty(Message, "SearchErrorTryAgain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Message(2 /* MessageType.Error */, 'Произошла ошибка при подборе вариантов. Попробуйте снова через некоторое время.')
    });
    Object.defineProperty(Message, "SearchNoVariants", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Message(0 /* MessageType.Information */, 'Вариантов, соответствующих заданным критериям, нет.')
    });
    Object.defineProperty(Message, "SearchNoVariantsWithLink", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function (url, isPacUa) {
            const link = isPacUa
                ? 'запрос на <a href="mailto:info@pac.ua">info@pac.ua</a> нашим специалистам'
                : `<a href="https://online.pac.ru/fit/agency/FitOrderSimple.aspx?baseurl=${encodeURIComponent(url)}" target="_blank">запрос нашим специалистам </a>`;
            return new Message(0 /* MessageType.Information */, `<b>Вариантов, соответствующих заданным критериям, нет.</b><br>Отправьте ${link} для подбора необходимого варианта.`);
        }
    });
    Object.defineProperty(Message, "DataErrorTryAgain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Message(2 /* MessageType.Error */, 'Произошла ошибка при запросе данных. Попробуйте снова через некоторое время.')
    });
    Object.defineProperty(Message, "BookErrorTryAgain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Message(2 /* MessageType.Error */, 'Произошла ошибка при бронировании выбранных предложений. Попробуйте снова через некоторое время.')
    });
    // TODO: как бы это common-компонент, в нем не должно быть ничего, связанного с конкретными услугами, т.к. планируется разнесение и отдельная загрузка скриптов под каждую услугу отдельно.
    Object.defineProperty(Message, "DynamicAviaSearchNoVariants", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Message(1 /* MessageType.Warning */, 'Для данного класса обслуживания отсутствуют доступные варианты перелета. Измените параметры поиска и произведите новый подбор вариантов​.')
    });
    App.Message = Message;
})(App || (App = {}));
var App;
(function (App) {
    // Класс для вывода сообщений.
    class Messages {
        constructor(options) {
            var _a;
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const root = (_a = options === null || options === void 0 ? void 0 : options.root) !== null && _a !== void 0 ? _a : '.js-messages';
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            if (!this.root.length)
                return;
            this.root.on('click', '.js-message-close .js-close-btn', e => {
                $(e.currentTarget).closest('.js-message').remove();
            });
        }
        show(messageOrMessages, options) {
            const opts = Object.assign(Object.assign({}, Messages.defaults), options);
            if (opts.group)
                this.hide(opts.group);
            if (messageOrMessages instanceof Array)
                (messageOrMessages).forEach(v => this.root.append(App.templates.Message(Object.assign(Object.assign({}, v), opts))));
            else
                this.root.append(App.templates.Message(Object.assign(Object.assign({}, messageOrMessages), opts)));
            if (opts.showOnPage) {
                const rootOffset = this.root.offset();
                $('html, body').animate({ scrollTop: (rootOffset != null ? rootOffset.top - 50 : 0) }, 'slow');
            }
        }
        hide(group) {
            if (group)
                $(`.js-message[data-message-group=${group}]`, this.root).remove();
            else
                $('.js-message', this.root).remove();
        }
    }
    Object.defineProperty(Messages, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            inline: true,
            canHide: true,
        }
    });
    App.Messages = Messages;
})(App || (App = {}));
var App;
(function (App) {
    var _MiddlewareBuilder_invokers, _MiddlewareDispatcher_instances, _MiddlewareDispatcher_middlewares, _MiddlewareDispatcher_invokeCore;
    /**
     * USAGE EXAMPLE:
     *
     * // Declare context.
     * interface IHttpContext {
     *   method: string;
     *   timeout?: number;
     * }
     *
     * // Build invoker from provided middlewares.
     * const invoker = new MiddlewareBuilder<IHttpContext>()
     *  .use(async (context, next) => {
     *    // Short-curcuit the pipeline if the method in the context is already 'post'.
     *    if (context.method !== 'post') {
     *      context.method = 'post';
     *      await next(context);
     *    }
     *  })
     *  .use(async (context, next) => {
     *    if (!context.timeout)
     *      context.timeout = 1000;
     *    await next(context);
     *  })
     *  .build();
     *
     * // Use built invoker for multiple calls on different contexts.
     * const context1: IHttpContext = { method: 'get' };
     * invoker(context1);
     * console.log(context1);
     * // output: { method: 'post', timeout: 1000 }
     * const context2: IHttpContext = { method: 'post' };
     * invoker(context2);
     * console.log(context2);
     * // output: { method: 'post' }
     */
    class MiddlewareBuilder {
        constructor() {
            _MiddlewareBuilder_invokers.set(this, []);
        }
        use(...middlewares) {
            for (let i = 0; i < middlewares.length; i++)
                __classPrivateFieldGet(this, _MiddlewareBuilder_invokers, "f").push(next => (context) => middlewares[i](context, next));
            return this;
        }
        build() {
            let invoker = () => Promise.resolve();
            for (let i = __classPrivateFieldGet(this, _MiddlewareBuilder_invokers, "f").length - 1; i >= 0; i--)
                invoker = __classPrivateFieldGet(this, _MiddlewareBuilder_invokers, "f")[i](invoker);
            return invoker;
        }
    }
    _MiddlewareBuilder_invokers = new WeakMap();
    App.MiddlewareBuilder = MiddlewareBuilder;
    class MiddlewareDispatcher {
        constructor() {
            _MiddlewareDispatcher_instances.add(this);
            _MiddlewareDispatcher_middlewares.set(this, []);
        }
        use(...middlewares) {
            for (let i = 0; i < middlewares.length; i++)
                __classPrivateFieldGet(this, _MiddlewareDispatcher_middlewares, "f").push(middlewares[i]);
            return this;
        }
        invoke(context) {
            return __classPrivateFieldGet(this, _MiddlewareDispatcher_instances, "m", _MiddlewareDispatcher_invokeCore).call(this, context, 0);
        }
    }
    _MiddlewareDispatcher_middlewares = new WeakMap(), _MiddlewareDispatcher_instances = new WeakSet(), _MiddlewareDispatcher_invokeCore = function _MiddlewareDispatcher_invokeCore(context, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const middleware = __classPrivateFieldGet(this, _MiddlewareDispatcher_middlewares, "f")[index];
            return yield middleware(context, () => {
                if (index < __classPrivateFieldGet(this, _MiddlewareDispatcher_middlewares, "f").length - 1)
                    return __classPrivateFieldGet(this, _MiddlewareDispatcher_instances, "m", _MiddlewareDispatcher_invokeCore).call(this, context, index + 1);
                return Promise.resolve();
            });
        });
    };
    App.MiddlewareDispatcher = MiddlewareDispatcher;
})(App || (App = {}));
var App;
(function (App) {
    var _Popup_instances, _Popup_options, _Popup_header, _Popup_container, _Popup_closeButton, _Popup_timer, _Popup_show, _Popup_open, _Popup_close;
    class Popup {
        constructor(options) {
            _Popup_instances.add(this);
            _Popup_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _Popup_header.set(this, void 0);
            _Popup_container.set(this, void 0);
            _Popup_closeButton.set(this, void 0);
            _Popup_timer.set(this, void 0);
            _Popup_show.set(this, void 0);
            const defaults = {
                root: '.js-popup',
                header: '.js-popup-title',
                container: '.js-popup-container',
                closeButton: '.js-popup-close',
                onShow: () => { },
                onHide: () => { },
            };
            __classPrivateFieldSet(this, _Popup_options, Object.assign(Object.assign({}, defaults), options), "f");
            const { root } = __classPrivateFieldGet(this, _Popup_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            __classPrivateFieldSet(this, _Popup_header, $(__classPrivateFieldGet(this, _Popup_options, "f").header, this.root), "f");
            __classPrivateFieldSet(this, _Popup_container, $(__classPrivateFieldGet(this, _Popup_options, "f").container, this.root), "f");
            __classPrivateFieldSet(this, _Popup_closeButton, $(__classPrivateFieldGet(this, _Popup_options, "f").closeButton, this.root), "f");
            __classPrivateFieldGet(this, _Popup_closeButton, "f").on('click', () => __classPrivateFieldGet(this, _Popup_instances, "m", _Popup_close).call(this));
        }
        show(options) {
            var _a;
            // TODO: возможно имеет смысл автоматически генерировать значение group, если оно не указано пользователем.
            this.root.attr('data-group', (_a = options.group) !== null && _a !== void 0 ? _a : '');
            __classPrivateFieldGet(this, _Popup_header, "f")
                .empty()
                .append(options.title ? options.title : '')
                .toggle(!!options.title);
            __classPrivateFieldGet(this, _Popup_container, "f")
                .empty()
                .append(options.content);
            __classPrivateFieldGet(this, _Popup_closeButton, "f").toggle(!options.modal);
            __classPrivateFieldSet(this, _Popup_show, true, "f");
            if (options.delay)
                __classPrivateFieldSet(this, _Popup_timer, window.setTimeout(() => __classPrivateFieldGet(this, _Popup_instances, "m", _Popup_open).call(this, options), options.delay), "f");
            else
                __classPrivateFieldGet(this, _Popup_instances, "m", _Popup_open).call(this, options);
            return options.group;
        }
        hide(group) {
            if (this.root.attr('data-group') === (group !== null && group !== void 0 ? group : ''))
                __classPrivateFieldGet(this, _Popup_instances, "m", _Popup_close).call(this);
        }
    }
    _Popup_options = new WeakMap(), _Popup_header = new WeakMap(), _Popup_container = new WeakMap(), _Popup_closeButton = new WeakMap(), _Popup_timer = new WeakMap(), _Popup_show = new WeakMap(), _Popup_instances = new WeakSet(), _Popup_open = function _Popup_open(options) {
        var _a;
        if (!__classPrivateFieldGet(this, _Popup_show, "f"))
            return;
        if (this.root.attr('data-group') !== ((_a = options.group) !== null && _a !== void 0 ? _a : ''))
            return;
        this.root.fadeIn(250, __classPrivateFieldGet(this, _Popup_options, "f").onShow);
        if (options.timeout)
            setTimeout(() => __classPrivateFieldGet(this, _Popup_instances, "m", _Popup_close).call(this), options.timeout);
    }, _Popup_close = function _Popup_close() {
        __classPrivateFieldSet(this, _Popup_show, false, "f");
        if (__classPrivateFieldGet(this, _Popup_timer, "f"))
            clearTimeout(__classPrivateFieldGet(this, _Popup_timer, "f"));
        this.root.fadeOut(250, __classPrivateFieldGet(this, _Popup_options, "f").onHide);
    };
    App.Popup = Popup;
})(App || (App = {}));
var App;
(function (App) {
    var _PopupMessenger_popup;
    class PopupMessenger {
        constructor(popup) {
            _PopupMessenger_popup.set(this, void 0);
            __classPrivateFieldSet(this, _PopupMessenger_popup, popup, "f");
        }
        show(messageOrMessages) {
            let content = '';
            if (messageOrMessages instanceof Array)
                messageOrMessages.forEach(v => (content += App.templates.Message(Object.assign({}, v))));
            else
                content = App.templates.Message(Object.assign({}, messageOrMessages));
            __classPrivateFieldGet(this, _PopupMessenger_popup, "f").show({
                content,
            });
        }
        hide() {
            __classPrivateFieldGet(this, _PopupMessenger_popup, "f").hide();
        }
    }
    _PopupMessenger_popup = new WeakMap();
    App.PopupMessenger = PopupMessenger;
})(App || (App = {}));
var App;
(function (App) {
    var _PopupOld_instances, _PopupOld_options, _PopupOld_show, _PopupOld_hide;
    class PopupOld {
        constructor(options) {
            _PopupOld_instances.add(this);
            _PopupOld_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            const defaults = {
                self: '.js-popup',
                header: '.js-popup-title',
                container: '.js-popup-container',
                closeButton: '.js-popup-close',
                scroll: true,
                modal: false,
                content: '',
                onShowDelegate: () => { },
                onHideDelegate: () => { },
            };
            __classPrivateFieldSet(this, _PopupOld_options, Object.assign(Object.assign({}, defaults), options), "f");
            this.root = $(__classPrivateFieldGet(this, _PopupOld_options, "f").self, this.root);
            if (!this.root.length)
                return;
            const header = $(__classPrivateFieldGet(this, _PopupOld_options, "f").header);
            if (__classPrivateFieldGet(this, _PopupOld_options, "f").title && __classPrivateFieldGet(this, _PopupOld_options, "f").title.length > 0) {
                header
                    .empty()
                    .append(__classPrivateFieldGet(this, _PopupOld_options, "f").title)
                    .show();
            }
            else {
                header.hide();
            }
            const container = $(__classPrivateFieldGet(this, _PopupOld_options, "f").container);
            container
                .empty()
                .append(__classPrivateFieldGet(this, _PopupOld_options, "f").content);
            $('body')
                .off("popup:open" /* Events.PopupOpen */, () => __classPrivateFieldGet(this, _PopupOld_instances, "m", _PopupOld_show).call(this))
                .off("popup:close" /* Events.PopupClose */, e => __classPrivateFieldGet(this, _PopupOld_instances, "m", _PopupOld_hide).call(this, e))
                .on("popup:open" /* Events.PopupOpen */, () => __classPrivateFieldGet(this, _PopupOld_instances, "m", _PopupOld_show).call(this))
                .on("popup:close" /* Events.PopupClose */, e => __classPrivateFieldGet(this, _PopupOld_instances, "m", _PopupOld_hide).call(this, e));
            // Закрываем попап
            const closeButton = $(__classPrivateFieldGet(this, _PopupOld_options, "f").closeButton);
            if (__classPrivateFieldGet(this, _PopupOld_options, "f").modal) {
                closeButton.hide();
            }
            else {
                closeButton
                    .show()
                    .off('click', e => __classPrivateFieldGet(this, _PopupOld_instances, "m", _PopupOld_hide).call(this, e))
                    .on('click', e => __classPrivateFieldGet(this, _PopupOld_instances, "m", _PopupOld_hide).call(this, e));
            }
        }
    }
    _PopupOld_options = new WeakMap(), _PopupOld_instances = new WeakSet(), _PopupOld_show = function _PopupOld_show() {
        this.root.fadeIn(250, __classPrivateFieldGet(this, _PopupOld_options, "f").onShowDelegate);
    }, _PopupOld_hide = function _PopupOld_hide(event) {
        // чтобы не закрывались остальные попапы
        event.stopPropagation();
        __classPrivateFieldGet(this, _PopupOld_options, "f").onShowDelegate = () => { };
        this.root.fadeOut(250, __classPrivateFieldGet(this, _PopupOld_options, "f").onHideDelegate);
        __classPrivateFieldGet(this, _PopupOld_options, "f").onHideDelegate = () => { };
    };
    App.PopupOld = PopupOld;
})(App || (App = {}));
var App;
(function (App) {
    var _Preloader_instances, _Preloader_options, _Preloader_vehicle, _Preloader_interval, _Preloader_timer, _Preloader_show, _Preloader_open, _Preloader_close, _Preloader_moveVehicle;
    class Preloader {
        constructor(options) {
            _Preloader_instances.add(this);
            _Preloader_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _Preloader_vehicle.set(this, void 0);
            _Preloader_interval.set(this, void 0);
            _Preloader_timer.set(this, void 0);
            _Preloader_show.set(this, void 0);
            const defaults = {
                self: '.js-preloader',
            };
            __classPrivateFieldSet(this, _Preloader_options, Object.assign(Object.assign({}, defaults), options), "f");
            this.root = $(__classPrivateFieldGet(this, _Preloader_options, "f").self);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _Preloader_vehicle, $('.js-preloader-vehicle', this.root), "f");
            $('.js-preloader-action', this.root).on('click', e => {
                const target = $(e.target);
                $('body').trigger("preloader:action" /* Events.PreloaderAction */, [this, target.attr('data-action')]);
            });
            $('body').on("preloader:start" /* Events.PreloaderStart */, () => this.show());
        }
        show(options = {}) {
            __classPrivateFieldSet(this, _Preloader_show, true, "f");
            if (options.delay && options.delay > 0)
                __classPrivateFieldSet(this, _Preloader_timer, window.setTimeout(() => __classPrivateFieldGet(this, _Preloader_instances, "m", _Preloader_open).call(this), options.delay), "f");
            else
                __classPrivateFieldGet(this, _Preloader_instances, "m", _Preloader_open).call(this);
        }
        hide() {
            __classPrivateFieldGet(this, _Preloader_instances, "m", _Preloader_close).call(this);
        }
    }
    _Preloader_options = new WeakMap(), _Preloader_vehicle = new WeakMap(), _Preloader_interval = new WeakMap(), _Preloader_timer = new WeakMap(), _Preloader_show = new WeakMap(), _Preloader_instances = new WeakSet(), _Preloader_open = function _Preloader_open() {
        if (!__classPrivateFieldGet(this, _Preloader_show, "f"))
            return;
        __classPrivateFieldGet(this, _Preloader_vehicle, "f").addClass('_transition');
        $('html').addClass('_preloader-show');
        __classPrivateFieldGet(this, _Preloader_instances, "m", _Preloader_moveVehicle).call(this);
    }, _Preloader_close = function _Preloader_close() {
        __classPrivateFieldSet(this, _Preloader_show, false, "f");
        if (__classPrivateFieldGet(this, _Preloader_timer, "f"))
            clearTimeout(__classPrivateFieldGet(this, _Preloader_timer, "f"));
        clearInterval(__classPrivateFieldGet(this, _Preloader_interval, "f"));
        $('html').removeClass('_preloader-show');
        $('body').trigger("preloader:closed" /* Events.PreloaderClosed */);
    }, _Preloader_moveVehicle = function _Preloader_moveVehicle() {
        const step = 906 / 60 / 6;
        let i = 0;
        __classPrivateFieldSet(this, _Preloader_interval, window.setInterval(() => {
            i++;
            if (step * i >= 906)
                __classPrivateFieldGet(this, _Preloader_vehicle, "f").removeClass('_transition');
            if (step * i >= 915)
                i = 1;
            if (step * i >= 5)
                __classPrivateFieldGet(this, _Preloader_vehicle, "f").addClass('_transition');
            __classPrivateFieldGet(this, _Preloader_vehicle, "f").css({ left: `${step * i}px` });
        }, 100), "f");
    };
    App.Preloader = Preloader;
})(App || (App = {}));
var App;
(function (App) {
    var _PrintComponent_instances, _PrintComponent_options, _PrintComponent_popup, _PrintComponent_code, _PrintComponent_onSubmit, _PrintComponent_onBeforePrint, _PrintComponent_onAfterPrint, _PrintComponent_onPrint;
    class PrintComponent {
        constructor(options) {
            _PrintComponent_instances.add(this);
            _PrintComponent_options.set(this, void 0);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _PrintComponent_popup.set(this, void 0);
            _PrintComponent_code.set(this, void 0);
            const defaults = {
                root: '.js-print',
                modes: {},
            };
            __classPrivateFieldSet(this, _PrintComponent_options, Object.assign(Object.assign({}, defaults), options), "f");
            if (!__classPrivateFieldGet(this, _PrintComponent_options, "f").modes)
                return;
            const { root } = __classPrivateFieldGet(this, _PrintComponent_options, "f");
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            __classPrivateFieldSet(this, _PrintComponent_popup, new App.Popup(), "f");
            $(window)
                .on('beforeprint', () => __classPrivateFieldGet(this, _PrintComponent_instances, "m", _PrintComponent_onBeforePrint).call(this))
                .on('afterprint', () => __classPrivateFieldGet(this, _PrintComponent_instances, "m", _PrintComponent_onAfterPrint).call(this));
            $('.js-print-submit', this.root).on('click', () => __classPrivateFieldGet(this, _PrintComponent_instances, "m", _PrintComponent_onSubmit).call(this));
        }
    }
    _PrintComponent_options = new WeakMap(), _PrintComponent_popup = new WeakMap(), _PrintComponent_code = new WeakMap(), _PrintComponent_instances = new WeakSet(), _PrintComponent_onSubmit = function _PrintComponent_onSubmit() {
        __classPrivateFieldGet(this, _PrintComponent_popup, "f").show({
            group: 'print',
            content: App.templates.Messages.Print({ modes: __classPrivateFieldGet(this, _PrintComponent_options, "f").modes }),
        });
        $(':button', __classPrivateFieldGet(this, _PrintComponent_popup, "f").root).on('click', e => __classPrivateFieldGet(this, _PrintComponent_instances, "m", _PrintComponent_onPrint).call(this, e));
    }, _PrintComponent_onBeforePrint = function _PrintComponent_onBeforePrint() {
        $('.tour-preamble-wrap').removeClass('_folded');
        $('.js-read-more-gradient').addClass('_hidden');
        if (__classPrivateFieldGet(this, _PrintComponent_code, "f"))
            $('html').addClass(`print-${__classPrivateFieldGet(this, _PrintComponent_code, "f")}`);
    }, _PrintComponent_onAfterPrint = function _PrintComponent_onAfterPrint() {
        $('html').removeClass((i, v) => (v.match(/(^|\s)print-\S+/g) || []).join(' '));
        __classPrivateFieldSet(this, _PrintComponent_code, undefined, "f");
        $('.tour-preamble-wrap').addClass('_folded');
        $('.js-read-more-gradient').removeClass('_hidden');
    }, _PrintComponent_onPrint = function _PrintComponent_onPrint(e) {
        __classPrivateFieldSet(this, _PrintComponent_code, $(e.currentTarget).attr('data-code') || 'default', "f");
        window.print();
    };
    App.PrintComponent = PrintComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _PromoCodeComponentMobile_instances, _PromoCodeComponentMobile_options, _PromoCodeComponentMobile_containerNew, _PromoCodeComponentMobile_input, _PromoCodeComponentMobile_state, _PromoCodeComponentMobile_stateInfo, _PromoCodeComponentMobile_buttonSubmit, _PromoCodeComponentMobile_containerExisting, _PromoCodeComponentMobile_buttonRemove, _PromoCodeComponentMobile_filters, _PromoCodeComponentMobile_onPromoSubmitClick, _PromoCodeComponentMobile_onPromoRemoveClick, _PromoCodeComponentMobile_updatePromo;
    class PromoCodeComponentMobile {
        constructor(options) {
            _PromoCodeComponentMobile_instances.add(this);
            _PromoCodeComponentMobile_options.set(this, void 0);
            _PromoCodeComponentMobile_containerNew.set(this, void 0);
            _PromoCodeComponentMobile_input.set(this, void 0);
            _PromoCodeComponentMobile_state.set(this, void 0);
            _PromoCodeComponentMobile_stateInfo.set(this, void 0);
            _PromoCodeComponentMobile_buttonSubmit.set(this, void 0);
            _PromoCodeComponentMobile_containerExisting.set(this, void 0);
            _PromoCodeComponentMobile_buttonRemove.set(this, void 0);
            _PromoCodeComponentMobile_filters.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_options, Object.assign(defaults, options), "f");
            const container = $('.js-promo', __classPrivateFieldGet(this, _PromoCodeComponentMobile_options, "f").root);
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_containerNew, $('.js-promo-new', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_input, $('.js-promo-input', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_state, $('.js-promo-state', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_stateInfo, $('.js-promo-state-info', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_buttonSubmit, $('.js-promo-submit', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_containerExisting, $('.js-promo-existing', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_buttonRemove, $('.js-promo-remove', container), "f");
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_buttonSubmit, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PromoCodeComponentMobile_instances, "m", _PromoCodeComponentMobile_onPromoSubmitClick).call(this, e); }));
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_buttonRemove, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PromoCodeComponentMobile_instances, "m", _PromoCodeComponentMobile_onPromoRemoveClick).call(this, e); }));
            container.find('.js-mobile-filter-input-block').removeAttr('flag-inited');
            __classPrivateFieldSet(this, _PromoCodeComponentMobile_filters, new App.FiltersMobileBase({ root: container }), "f");
        }
    }
    _PromoCodeComponentMobile_options = new WeakMap(), _PromoCodeComponentMobile_containerNew = new WeakMap(), _PromoCodeComponentMobile_input = new WeakMap(), _PromoCodeComponentMobile_state = new WeakMap(), _PromoCodeComponentMobile_stateInfo = new WeakMap(), _PromoCodeComponentMobile_buttonSubmit = new WeakMap(), _PromoCodeComponentMobile_containerExisting = new WeakMap(), _PromoCodeComponentMobile_buttonRemove = new WeakMap(), _PromoCodeComponentMobile_filters = new WeakMap(), _PromoCodeComponentMobile_instances = new WeakSet(), _PromoCodeComponentMobile_onPromoSubmitClick = function _PromoCodeComponentMobile_onPromoSubmitClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const filter = __classPrivateFieldGet(this, _PromoCodeComponentMobile_filters, "f").findControl('Form.PromoCode');
            if (!filter)
                return;
            const code = filter.getValue(); // this.#input.valString();
            if (code.length <= 0)
                return;
            const isApplied = yield __classPrivateFieldGet(this, _PromoCodeComponentMobile_options, "f").onSubmit(code);
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_instances, "m", _PromoCodeComponentMobile_updatePromo).call(this, isApplied);
        });
    }, _PromoCodeComponentMobile_onPromoRemoveClick = function _PromoCodeComponentMobile_onPromoRemoveClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const filter = __classPrivateFieldGet(this, _PromoCodeComponentMobile_filters, "f").findControl('Form.PromoCode');
            if (!filter)
                return;
            filter.clear(); // this.#input.val('');
            yield __classPrivateFieldGet(this, _PromoCodeComponentMobile_options, "f").onRemove();
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_instances, "m", _PromoCodeComponentMobile_updatePromo).call(this, false);
        });
    }, _PromoCodeComponentMobile_updatePromo = function _PromoCodeComponentMobile_updatePromo(isApplied) {
        if (isApplied) {
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_state, "f").removeClass('_invalid');
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_state, "f").addClass('_valid-promo');
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_stateInfo, "f").html('Промокод применен');
        }
        else if (__classPrivateFieldGet(this, _PromoCodeComponentMobile_input, "f").valString().length > 0) {
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_state, "f").removeClass('_valid-promo');
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_state, "f").addClass('_invalid');
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_stateInfo, "f").html('Ой, промокод не найден');
        }
        else {
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_state, "f").removeClass('_invalid');
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_state, "f").removeClass('_valid-promo');
            __classPrivateFieldGet(this, _PromoCodeComponentMobile_stateInfo, "f").html('');
        }
        __classPrivateFieldGet(this, _PromoCodeComponentMobile_containerNew, "f").toggle(!isApplied);
        __classPrivateFieldGet(this, _PromoCodeComponentMobile_containerExisting, "f").toggle(isApplied);
    };
    App.PromoCodeComponentMobile = PromoCodeComponentMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _PromoCodeComponent_instances, _PromoCodeComponent_options, _PromoCodeComponent_containerNew, _PromoCodeComponent_input, _PromoCodeComponent_state, _PromoCodeComponent_stateInfo, _PromoCodeComponent_buttonSubmit, _PromoCodeComponent_containerExisting, _PromoCodeComponent_buttonRemove, _PromoCodeComponent_onPromoSubmitClick, _PromoCodeComponent_onPromoRemoveClick, _PromoCodeComponent_updatePromo;
    class PromoCodeComponent {
        constructor(options) {
            _PromoCodeComponent_instances.add(this);
            _PromoCodeComponent_options.set(this, void 0);
            _PromoCodeComponent_containerNew.set(this, void 0);
            _PromoCodeComponent_input.set(this, void 0);
            _PromoCodeComponent_state.set(this, void 0);
            _PromoCodeComponent_stateInfo.set(this, void 0);
            _PromoCodeComponent_buttonSubmit.set(this, void 0);
            _PromoCodeComponent_containerExisting.set(this, void 0);
            _PromoCodeComponent_buttonRemove.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _PromoCodeComponent_options, Object.assign(defaults, options), "f");
            const container = $('.js-promo', __classPrivateFieldGet(this, _PromoCodeComponent_options, "f").root);
            __classPrivateFieldSet(this, _PromoCodeComponent_containerNew, $('.js-promo-new', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponent_input, $('.js-promo-input', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponent_state, $('.js-promo-state', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponent_stateInfo, $('.js-promo-state-info', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponent_buttonSubmit, $('.js-promo-submit', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponent_containerExisting, $('.js-promo-existing', container), "f");
            __classPrivateFieldSet(this, _PromoCodeComponent_buttonRemove, $('.js-promo-remove', container), "f");
            __classPrivateFieldGet(this, _PromoCodeComponent_buttonSubmit, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PromoCodeComponent_instances, "m", _PromoCodeComponent_onPromoSubmitClick).call(this, e); }));
            __classPrivateFieldGet(this, _PromoCodeComponent_buttonRemove, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _PromoCodeComponent_instances, "m", _PromoCodeComponent_onPromoRemoveClick).call(this, e); }));
        }
    }
    _PromoCodeComponent_options = new WeakMap(), _PromoCodeComponent_containerNew = new WeakMap(), _PromoCodeComponent_input = new WeakMap(), _PromoCodeComponent_state = new WeakMap(), _PromoCodeComponent_stateInfo = new WeakMap(), _PromoCodeComponent_buttonSubmit = new WeakMap(), _PromoCodeComponent_containerExisting = new WeakMap(), _PromoCodeComponent_buttonRemove = new WeakMap(), _PromoCodeComponent_instances = new WeakSet(), _PromoCodeComponent_onPromoSubmitClick = function _PromoCodeComponent_onPromoSubmitClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const code = __classPrivateFieldGet(this, _PromoCodeComponent_input, "f").valString();
            if (code.length <= 0)
                return;
            const isApplied = yield __classPrivateFieldGet(this, _PromoCodeComponent_options, "f").onSubmit(code);
            __classPrivateFieldGet(this, _PromoCodeComponent_instances, "m", _PromoCodeComponent_updatePromo).call(this, isApplied);
        });
    }, _PromoCodeComponent_onPromoRemoveClick = function _PromoCodeComponent_onPromoRemoveClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            __classPrivateFieldGet(this, _PromoCodeComponent_input, "f").val('');
            yield __classPrivateFieldGet(this, _PromoCodeComponent_options, "f").onRemove();
            __classPrivateFieldGet(this, _PromoCodeComponent_instances, "m", _PromoCodeComponent_updatePromo).call(this, false);
        });
    }, _PromoCodeComponent_updatePromo = function _PromoCodeComponent_updatePromo(isApplied) {
        if (isApplied) {
            __classPrivateFieldGet(this, _PromoCodeComponent_state, "f").removeClass('_invalid');
            __classPrivateFieldGet(this, _PromoCodeComponent_state, "f").addClass('_valid-promo');
            __classPrivateFieldGet(this, _PromoCodeComponent_stateInfo, "f").html('Промокод применен');
        }
        else if (__classPrivateFieldGet(this, _PromoCodeComponent_input, "f").valString().length > 0) {
            __classPrivateFieldGet(this, _PromoCodeComponent_state, "f").removeClass('_valid-promo');
            __classPrivateFieldGet(this, _PromoCodeComponent_state, "f").addClass('_invalid');
            __classPrivateFieldGet(this, _PromoCodeComponent_stateInfo, "f").html('Ой, промокод не найден');
        }
        else {
            __classPrivateFieldGet(this, _PromoCodeComponent_state, "f").removeClass('_invalid');
            __classPrivateFieldGet(this, _PromoCodeComponent_state, "f").removeClass('_valid-promo');
            __classPrivateFieldGet(this, _PromoCodeComponent_stateInfo, "f").html('');
        }
        __classPrivateFieldGet(this, _PromoCodeComponent_containerNew, "f").toggle(!isApplied);
        __classPrivateFieldGet(this, _PromoCodeComponent_containerExisting, "f").toggle(isApplied);
    };
    App.PromoCodeComponent = PromoCodeComponent;
})(App || (App = {}));
var App;
(function (App) {
    var _QueryParams_data, _QueryParams_controller, _QueryParams_action, _QueryParams_context, _QueryParams_idRoute, _QueryParams_ancher, _QueryParams_paramAncher;
    class QueryParams {
        constructor(url = '') {
            _QueryParams_data.set(this, void 0);
            _QueryParams_controller.set(this, void 0);
            _QueryParams_action.set(this, void 0);
            _QueryParams_context.set(this, void 0);
            _QueryParams_idRoute.set(this, void 0);
            _QueryParams_ancher.set(this, void 0);
            _QueryParams_paramAncher.set(this, void 0);
            __classPrivateFieldSet(this, _QueryParams_data, {}, "f");
            const params = url.split('/');
            params.shift();
            __classPrivateFieldSet(this, _QueryParams_controller, params.shift() || '', "f");
            __classPrivateFieldSet(this, _QueryParams_action, params.shift() || '', "f");
            __classPrivateFieldSet(this, _QueryParams_idRoute, '', "f");
            __classPrivateFieldSet(this, _QueryParams_paramAncher, '', "f");
            this.prepareAncher();
            params.forEach(param => {
                let pos = param.indexOf('-');
                const [key, value] = [param.substring(0, pos), param.substring(++pos)];
                if (key === '' && value !== '')
                    __classPrivateFieldSet(this, _QueryParams_idRoute, value, "f");
                if (value !== undefined && value.length > 0) {
                    const vals = value.split(',');
                    __classPrivateFieldGet(this, _QueryParams_data, "f")[key] = vals;
                }
            });
            __classPrivateFieldSet(this, _QueryParams_context, __classPrivateFieldGet(this, _QueryParams_data, "f").context ? __classPrivateFieldGet(this, _QueryParams_data, "f").context[0] : '', "f");
            delete __classPrivateFieldGet(this, _QueryParams_data, "f").context;
        }
        prepareAncher() {
            const ancher = window.location.hash;
            const elems = ancher.split(',', 2);
            __classPrivateFieldSet(this, _QueryParams_ancher, elems[0], "f");
            if (elems.length > 1)
                __classPrivateFieldSet(this, _QueryParams_paramAncher, elems[1], "f");
        }
        getContext() {
            return __classPrivateFieldGet(this, _QueryParams_context, "f");
        }
        getController() {
            return __classPrivateFieldGet(this, _QueryParams_controller, "f");
        }
        getAction() {
            return __classPrivateFieldGet(this, _QueryParams_action, "f");
        }
        getAncher() {
            return __classPrivateFieldGet(this, _QueryParams_ancher, "f");
        }
        getParamAncher() {
            return __classPrivateFieldGet(this, _QueryParams_paramAncher, "f");
        }
        setAction(action) {
            __classPrivateFieldSet(this, _QueryParams_action, action, "f");
        }
        setAncher(ancher) {
            __classPrivateFieldSet(this, _QueryParams_ancher, ancher, "f");
        }
        setParamAncher(paramAncher) {
            __classPrivateFieldSet(this, _QueryParams_paramAncher, paramAncher, "f");
        }
        clear() {
            __classPrivateFieldSet(this, _QueryParams_data, {}, "f");
        }
        getUrl(allowEmpty = false) {
            let prefix = ['', __classPrivateFieldGet(this, _QueryParams_controller, "f"), __classPrivateFieldGet(this, _QueryParams_action, "f")].join('/');
            if (__classPrivateFieldGet(this, _QueryParams_idRoute, "f").length > 0)
                prefix += `/${__classPrivateFieldGet(this, _QueryParams_idRoute, "f")}`;
            let url = Object.getOwnPropertyNames(__classPrivateFieldGet(this, _QueryParams_data, "f")).reduce((prevValue, curValue) => {
                let paramStr = '';
                if (__classPrivateFieldGet(this, _QueryParams_data, "f")[curValue].length > 0 || allowEmpty)
                    paramStr = `/${curValue}-${__classPrivateFieldGet(this, _QueryParams_data, "f")[curValue].join(',')}`;
                if (curValue.length === 0)
                    return prevValue;
                return prevValue + paramStr;
            }, prefix);
            if (__classPrivateFieldGet(this, _QueryParams_context, "f") !== undefined && __classPrivateFieldGet(this, _QueryParams_context, "f").length > 0)
                url += `/context-${__classPrivateFieldGet(this, _QueryParams_context, "f")}`;
            if (App.app.settings.route.appendTrailingSlash && !url.endsWith('/'))
                url += '/';
            if (__classPrivateFieldGet(this, _QueryParams_ancher, "f").length > 0)
                url += (App.app.settings.route.appendTrailingSlash ? '' : '/') + __classPrivateFieldGet(this, _QueryParams_ancher, "f");
            if (__classPrivateFieldGet(this, _QueryParams_paramAncher, "f").length > 0)
                url += ',' + __classPrivateFieldGet(this, _QueryParams_paramAncher, "f");
            return url;
        }
        replace(key, values) {
            __classPrivateFieldGet(this, _QueryParams_data, "f")[key] = values;
        }
        add(key, values) {
            __classPrivateFieldGet(this, _QueryParams_data, "f")[key] = (__classPrivateFieldGet(this, _QueryParams_data, "f")[key] || []).concat(values);
        }
        remove(key, value = '') {
            if (!Object.prototype.hasOwnProperty.call(__classPrivateFieldGet(this, _QueryParams_data, "f"), key))
                return;
            if (value.length === 0) {
                delete __classPrivateFieldGet(this, _QueryParams_data, "f")[key];
            }
            else {
                const index = __classPrivateFieldGet(this, _QueryParams_data, "f")[key].indexOf(value);
                if (index !== -1)
                    __classPrivateFieldGet(this, _QueryParams_data, "f")[key].splice(index, 1);
            }
        }
        param(key) {
            if (!Object.prototype.hasOwnProperty.call(__classPrivateFieldGet(this, _QueryParams_data, "f"), key))
                return [];
            return __classPrivateFieldGet(this, _QueryParams_data, "f")[key];
        }
        getParams() {
            return __classPrivateFieldGet(this, _QueryParams_data, "f");
        }
    }
    _QueryParams_data = new WeakMap(), _QueryParams_controller = new WeakMap(), _QueryParams_action = new WeakMap(), _QueryParams_context = new WeakMap(), _QueryParams_idRoute = new WeakMap(), _QueryParams_ancher = new WeakMap(), _QueryParams_paramAncher = new WeakMap();
    App.QueryParams = QueryParams;
})(App || (App = {}));
var App;
(function (App) {
    var _ResponseValidator_instances, _a, _ResponseValidator_s_messengerGroup, _ResponseValidator_s_commonErrorText, _ResponseValidator_s_emptyErrorText, _ResponseValidator_s_emptyDataErrorText, _ResponseValidator_options, _ResponseValidator_showMessenger, _ResponseValidator_hideMessenger;
    /**
     * Обработчик ответов от наших веб-сервисов.
     * Отличие от ResponseValidatorOld состоит в том, что в вызове process не обрабатываются ошибки, а при их наличии выбрасывается
     * исключение другого типа для дальнейшей их централизованной обработки в processError (который теоретически можно будет вынести в
     * реализацию ITransientErrorDetectionStrategy и использовать в retry policy).
     */
    class ResponseValidator {
        constructor(options) {
            _ResponseValidator_instances.add(this);
            _ResponseValidator_options.set(this, void 0);
            const defaults = {
                messenger: App.ConsoleMessenger.instance,
                allowEmptyData: false,
            };
            __classPrivateFieldSet(this, _ResponseValidator_options, Object.assign(defaults, options), "f");
        }
        /**
         * Обработка ответа ajax-запроса.
         * Выбрасывает исключение при любой ошибке.
         * Возвращает true, если ответ был успешен и можно продолжать обработку.
         * Возвращает false, если ответ был успешен, но дальнейшая обработка не нужна (например, при редиректах).
         * @param response
         */
        process(response) {
            __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_hideMessenger).call(this);
            if (!response) {
                throw new App.AjaxError({
                    success: false,
                    messages: [{
                            type: 2 /* MessageType.Error */,
                            text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_emptyErrorText),
                        }],
                });
            }
            if (!response.status.success)
                throw new App.AjaxError(response.status);
            if (response.redirect != null) {
                window.location.href = response.redirect;
                return false;
            }
            if (response.status.messages) {
                const messages = response.status.messages.filter(v => v.type !== 3 /* MessageType.Fatal */ && v.type !== 2 /* MessageType.Error */);
                if (messages.length > 0) {
                    __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_showMessenger).call(this, messages);
                    return true;
                }
            }
            if (!__classPrivateFieldGet(this, _ResponseValidator_options, "f").allowEmptyData && !response.data) {
                if (!response.status.messages)
                    response.status.messages = new Array();
                response.status.messages.push({
                    type: 2 /* MessageType.Error */,
                    text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_emptyDataErrorText),
                });
                throw new App.AjaxError(response.status);
            }
            return true;
        }
        /**
         * Обработка ошибки выполнения ajax-запроса. Возвращает true, если ошибка была успешно обработана и не нужно повторно выбрасывать
         * исключение.
         * @param error
         */
        processError(error) {
            __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_hideMessenger).call(this);
            if (App.isJQueryAjaxErrorInfo(error)) {
                if (error.status === 401) {
                    $(document).trigger("app:loggingin" /* Events.LoggingIn */);
                    return true;
                }
                // Отмена http-запроса клиентом на стороне сервера.
                if (error.status === 499)
                    return true;
                if (error.status >= 400) {
                    // Note: костыль, необходимо обрабатывать только с определенным content-type (например, application/problem+json или
                    // application/json) и/или с определенным форматом ответа (например, RFC 7807: Problem Details for HTTP APIs).
                    if (error.responseText == null || error.responseText.includes('<html'))
                        App.app.appContainerContent.html(App.templates.Error({ status: error.status }));
                    else
                        App.app.appContainerContent.html(App.templates.Error({ status: error.status, text: [error.responseText] }));
                    return true;
                }
            }
            if (error instanceof App.HttpError) {
                if (error.code === 401) {
                    $(document).trigger("app:loggingin" /* Events.LoggingIn */);
                    return true;
                }
                // Отмена http-запроса клиентом на стороне сервера.
                if (error.code === 499)
                    return true;
                if (error.code >= 400) {
                    // Note: костыль, необходимо обрабатывать только с определенным content-type (например, application/problem+json или
                    // application/json) и/или с определенным форматом ответа (например, RFC 7807: Problem Details for HTTP APIs).
                    if (error.text == null || error.text.includes('<html'))
                        App.app.appContainerContent.html(App.templates.Error({ status: error.code }));
                    else
                        App.app.appContainerContent.html(App.templates.Error({ status: error.code, text: [error.text] }));
                    return true;
                }
            }
            if (error instanceof App.AjaxError) {
                if (error.status.messages != null && error.status.messages.length > 0) {
                    const messages = error.status.messages.filter(v => v.type === 3 /* MessageType.Fatal */).map(v => v.text);
                    if (messages.length > 0) {
                        App.app.appContainerContent.html(App.templates.Error({ status: 500, text: messages }));
                        return true;
                    }
                    __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_showMessenger).call(this, error.status.messages);
                    return true;
                }
                if (error.status.modelState && !error.status.modelState.isValid) {
                    const modelErrors = new Array();
                    const fieldErrors = {};
                    let hasFieldErrors = false;
                    Object.entries(error.status.modelState.errors).forEach(([key, value]) => {
                        if (key) {
                            fieldErrors[key] = value.join('<br />');
                            hasFieldErrors = true;
                        }
                        else {
                            value.forEach(v => modelErrors.push(v));
                        }
                    });
                    if (modelErrors.length > 0)
                        __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: modelErrors.join('<br />') });
                    if (hasFieldErrors) {
                        if (__classPrivateFieldGet(this, _ResponseValidator_options, "f").validator)
                            __classPrivateFieldGet(this, _ResponseValidator_options, "f").validator.showErrors(fieldErrors);
                        // TODO else: показать ошибки при помощи messenger (отформатировать их при помощи шаблона), если validator недоступен.
                    }
                    return true;
                }
                return false;
            }
            if (App.isJQueryAjaxErrorInfo(error)) {
                // Отмена http-запроса клиентом на стороне клиента (вызов xhr.abort()).
                if (error.statusText === 'abort')
                    return true;
                // Http-запрос отвалился по timeout, указанному в ajax-запросе на клиенте (например, в $.ajax({ timeout: 1000 })).
                // TODO Titov: не уверен, что это хорошее решение, т.к. на клиенте может быть настроена политика повторного выполнения
                // запроса, и функция processError может принимать некий параметр, по которому определять будет ли повторная попытка или
                // вывести ошибку.
                if (error.statusText === 'timeout') {
                    __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_commonErrorText) });
                    return true;
                }
                // Ошибка при парсинге ответа.
                // TODO Titov: не уверен, что это хорошее решение, т.к. на клиенте может быть настроена политика повторного выполнения
                // запроса, и функция processError может принимать некий параметр, по которому определять будет ли повторная попытка или
                // вывести ошибку.
                if (error.statusText === 'parsererror') {
                    __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_commonErrorText) });
                    return true;
                }
                // Не получен ответ от сервера (например, если сервер недоступен).
                // TODO Titov: не уверен, что это хорошее решение, т.к. на клиенте может быть настроена политика повторного выполнения
                // запроса, и функция processError может принимать некий параметр, по которому определять будет ли повторная попытка или
                // вывести ошибку.
                if (error.statusText === 'error') {
                    __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_commonErrorText) });
                    return true;
                }
            }
            if (error instanceof Error) {
                // Отмена http-запроса клиентом на стороне клиента (вызов AbortController.abort()).
                if (error.name === 'AbortError')
                    return true;
                // Http-запрос отвалился по timeout, указанному в ajax-запросе на клиенте (например, в fetch).
                // TODO Titov: не уверен, что это хорошее решение, т.к. на клиенте может быть настроена политика повторного выполнения
                // запроса, и функция processError может принимать некий параметр, по которому определять будет ли повторная попытка или
                // вывести ошибку.
                if (error.name === 'TimeoutError') {
                    __classPrivateFieldGet(this, _ResponseValidator_instances, "m", _ResponseValidator_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_commonErrorText) });
                    return true;
                }
            }
            // Все остальные ошибки.
            return false;
        }
    }
    _a = ResponseValidator, _ResponseValidator_options = new WeakMap(), _ResponseValidator_instances = new WeakSet(), _ResponseValidator_showMessenger = function _ResponseValidator_showMessenger(messageOrMessages) {
        __classPrivateFieldGet(this, _ResponseValidator_options, "f").messenger.show(messageOrMessages, { group: __classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_messengerGroup) });
    }, _ResponseValidator_hideMessenger = function _ResponseValidator_hideMessenger() {
        __classPrivateFieldGet(this, _ResponseValidator_options, "f").messenger.hide(__classPrivateFieldGet(_a, _a, "f", _ResponseValidator_s_messengerGroup));
    };
    _ResponseValidator_s_messengerGroup = { value: 'ajax' };
    _ResponseValidator_s_commonErrorText = { value: 'Произошла ошибка. Пожалуйста, попробуйте повторить операцию или обновите страницу.' };
    _ResponseValidator_s_emptyErrorText = { value: 'Произошла ошибка (пустой ответ от сервера). Попробуйте еще раз через некоторое время.' };
    _ResponseValidator_s_emptyDataErrorText = { value: 'Произошла ошибка (отсутствуют данные). Попробуйте еще раз через некоторое время.' };
    App.ResponseValidator = ResponseValidator;
})(App || (App = {}));
var App;
(function (App) {
    var _ResponseValidatorOld_instances, _a, _ResponseValidatorOld_s_messengerGroup, _ResponseValidatorOld_s_commonErrorText, _ResponseValidatorOld_s_emptyErrorText, _ResponseValidatorOld_s_emptyDataErrorText, _ResponseValidatorOld_options, _ResponseValidatorOld_showMessenger, _ResponseValidatorOld_hideMessenger;
    /**
     * Обработчик ответов от наших веб-сервисов.
     */
    /** @deprecated use {@link ResponseValidator} instead. */
    class ResponseValidatorOld {
        constructor(options) {
            _ResponseValidatorOld_instances.add(this);
            _ResponseValidatorOld_options.set(this, void 0);
            const defaults = {
                messenger: App.ConsoleMessenger.instance,
                allowEmptyData: false,
            };
            __classPrivateFieldSet(this, _ResponseValidatorOld_options, Object.assign(defaults, options), "f");
        }
        /**
         * Обработка ответа ajax-запроса. Возвращает true, если ответ был успешен и содержит данные, которые можно дальше обрабатывать.
         * @param response
         */
        process(response) {
            __classPrivateFieldGet(this, _ResponseValidatorOld_instances, "m", _ResponseValidatorOld_hideMessenger).call(this);
            if (!response) {
                // TODO: use templates.Messages.GeneralError for text property
                __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").messenger.show({
                    type: 2 /* MessageType.Error */,
                    text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidatorOld_s_emptyErrorText),
                });
                return false /* Error->RequestError?*/;
            }
            // TODO: возможно имеет смысл проверять еще вариант данных с редиректом и сообщениями => выводить сообщения и потом (при
            // закрытии контейнера с сообщениями или нажатии на кнопку в контейнере, например, Продолжить) производить редирект.
            if (response.redirect != null) {
                window.location.href = response.redirect;
                // Запрос успешен, но дальнейшая обработка не нужна.
                // TODO Titov: неоднозначно:
                //  - с одной стороны ошибки нет, но т.к. в вызывающем коде обычно стоит проверка 'if (!...process(...)) return;', то мы
                //  пойдем по стандартному пути, где практически 100% идет расчет на наличие данных в переменной data
                //  - но с другой стороны мы производим редирект и поэтому дальнейшая обработка не нужна. Но т.к. возврат false считается,
                //  что вызов был с ошибкой, мы совершенно легитимно внутри 'if (!...process(...)) ...' можем или логгировать якобы
                //  ошибочный запрос (или еще что похуже).
                // Решение:
                //  - в вызывающем коде после 'if (!...process(...)) return;' еще проверять наличие успешного вызова (например, наличие
                //  данных, т.е. не ShortCircuit-вызова), например вот так 'if (!response.data) return;'
                //  - в данном методе возвращать не boolean, а некое перечисление с вариантами, например, 'Success', 'Failed',
                //  'ShortCircuit' и в вызывающем коде, в зависимости от необходимых дальнейших действий, проверять или
                //  'if (...process(...) == Failed)' или 'if (...process(...) != Success)'.
                return false /* ShortCircuit & Success -> Redirect[Success]*/;
            }
            if (response.status.messages && response.status.messages.length > 0) {
                const messages = response.status.messages.filter(v => v.type === 3 /* MessageType.Fatal */).map(v => v.text);
                if (messages.length > 0) {
                    App.app.appContainerContent.html(App.templates.Error({ status: 500, text: messages }));
                    return false /* Error->MessageError|ClientError*/;
                }
            }
            __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").messenger.hide();
            if (response.status.messages && response.status.messages.length > 0) {
                __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").messenger.show(response.status.messages);
                return response.status.messages
                    .every(v => v.type !== 2 /* MessageType.Error */ && v.type !== 3 /* MessageType.Fatal */) /* Error->MessageError | Success*/;
            }
            if (response.status.modelState && !response.status.modelState.isValid) {
                const modelErrors = new Array();
                const fieldErrors = {};
                let hasFieldErrors = false;
                Object.entries(response.status.modelState.errors).forEach(([key, value]) => {
                    if (key) {
                        fieldErrors[key] = value.join('<br />');
                        hasFieldErrors = true;
                    }
                    else {
                        value.forEach(v => modelErrors.push(v));
                    }
                });
                if (modelErrors.length > 0) {
                    // TODO: use templates.Messages.ModelValidationError for text property
                    __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").messenger.show({ type: 2 /* MessageType.Error */, text: modelErrors.join('<br />') });
                }
                if (hasFieldErrors) {
                    if (__classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").validator)
                        __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").validator.showErrors(fieldErrors);
                    // TODO else: показать ошибки при помощи messenger (отформатировать их при помощи шаблона), если validator недоступен.
                }
                return false /* Error->ValidationError*/;
            }
            if (!__classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").allowEmptyData && !response.data) {
                // TODO: use templates.Messages.EmptyData for text property
                __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").messenger.show({
                    type: 2 /* MessageType.Error */,
                    text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidatorOld_s_emptyDataErrorText),
                });
                return false /* Error->Data[Absent]Error*/;
            }
            return response.status.success /* Error->[General]Error | Success*/;
        }
        /**
         * Обработка ошибки выполнения ajax-запроса. Возвращает true, если ошибка была успешно обработана и не нужно повторно выбрасывать
         * исключение.
         * @param error
         */
        processError(error) {
            __classPrivateFieldGet(this, _ResponseValidatorOld_instances, "m", _ResponseValidatorOld_hideMessenger).call(this);
            if (App.isJQueryAjaxErrorInfo(error)) {
                if (error.status === 401) {
                    $(document).trigger("app:loggingin" /* Events.LoggingIn */);
                    return true;
                }
                // Отмена http-запроса клиентом на стороне сервера.
                if (error.status === 499)
                    return true;
                if (error.status >= 400) {
                    // Note: костыль, необходимо обрабатывать только с определенным content-type (например, application/problem+json или
                    // application/json) и/или с определенным форматом ответа (например, RFC 7807: Problem Details for HTTP APIs).
                    if (error.responseText == null || error.responseText.includes('<html'))
                        App.app.appContainerContent.html(App.templates.Error({ status: error.status }));
                    else
                        App.app.appContainerContent.html(App.templates.Error({ status: error.status, text: [error.responseText] }));
                    return true;
                }
            }
            if (App.isJQueryAjaxErrorInfo(error)) {
                // Отмена http-запроса клиентом на стороне клиента (вызов xhr.abort()).
                if (error.statusText === 'abort')
                    return true;
                // Http-запрос отвалился по timeout, указанному в ajax-запросе на клиенте (например, в $.ajax({ timeout: 1000 })).
                // TODO Titov: не уверен, что это хорошее решение, т.к. на клиенте может быть настроена политика повторного выполнения
                // запроса, и функция processError может принимать некий параметр, по которому определять будет ли повторная попытка или
                // вывести ошибку.
                if (error.statusText === 'timeout') {
                    __classPrivateFieldGet(this, _ResponseValidatorOld_instances, "m", _ResponseValidatorOld_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidatorOld_s_commonErrorText) });
                    return true;
                }
                // Ошибка при парсинге ответа.
                // TODO Titov: не уверен, что это хорошее решение, т.к. на клиенте может быть настроена политика повторного выполнения
                // запроса, и функция processError может принимать некий параметр, по которому определять будет ли повторная попытка или
                // вывести ошибку.
                if (error.statusText === 'parsererror') {
                    __classPrivateFieldGet(this, _ResponseValidatorOld_instances, "m", _ResponseValidatorOld_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidatorOld_s_commonErrorText) });
                    return true;
                }
                // Не получен ответ от сервера (например, если сервер недоступен).
                // TODO Titov: не уверен, что это хорошее решение, т.к. на клиенте может быть настроена политика повторного выполнения
                // запроса, и функция processError может принимать некий параметр, по которому определять будет ли повторная попытка или
                // вывести ошибку.
                if (error.statusText === 'error') {
                    __classPrivateFieldGet(this, _ResponseValidatorOld_instances, "m", _ResponseValidatorOld_showMessenger).call(this, { type: 2 /* MessageType.Error */, text: __classPrivateFieldGet(_a, _a, "f", _ResponseValidatorOld_s_commonErrorText) });
                    return true;
                }
            }
            // Все остальные ошибки.
            return false;
        }
    }
    _a = ResponseValidatorOld, _ResponseValidatorOld_options = new WeakMap(), _ResponseValidatorOld_instances = new WeakSet(), _ResponseValidatorOld_showMessenger = function _ResponseValidatorOld_showMessenger(messageOrMessages) {
        __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").messenger.show(messageOrMessages, { group: __classPrivateFieldGet(_a, _a, "f", _ResponseValidatorOld_s_messengerGroup) });
    }, _ResponseValidatorOld_hideMessenger = function _ResponseValidatorOld_hideMessenger() {
        __classPrivateFieldGet(this, _ResponseValidatorOld_options, "f").messenger.hide(__classPrivateFieldGet(_a, _a, "f", _ResponseValidatorOld_s_messengerGroup));
    };
    _ResponseValidatorOld_s_messengerGroup = { value: 'ajax' };
    _ResponseValidatorOld_s_commonErrorText = { value: 'Произошла ошибка. Пожалуйста, попробуйте повторить операцию или обновите страницу.' };
    _ResponseValidatorOld_s_emptyErrorText = { value: 'Произошла ошибка (пустой ответ от сервера). Попробуйте еще раз через некоторое время.' };
    _ResponseValidatorOld_s_emptyDataErrorText = { value: 'Произошла ошибка (отсутствуют данные). Попробуйте еще раз через некоторое время.' };
    App.ResponseValidatorOld = ResponseValidatorOld;
})(App || (App = {}));
var App;
(function (App) {
    const getErrorString = (error) => Object.prototype.toString.call(error);
    const getErrorType = (error) => (error instanceof Error ? error.constructor.name : getErrorString(error));
    class Retry {
        static createFixedInterval(name = null, retryCount = Retry.defaults.clientRetryCount, retryInterval = Retry.defaults.retryInterval, firstFastRetry = Retry.defaults.firstFastRetry) {
            return {
                name: name !== null && name !== void 0 ? name : 'FixedInterval',
                fastFirstRetry: firstFastRetry,
                getShouldRetry: () => {
                    if (retryCount === 0) {
                        return () => ({
                            retryInterval: 0,
                            shouldRetry: false,
                        });
                    }
                    return (currentRetryCount) => {
                        if (currentRetryCount < retryCount) {
                            return {
                                retryInterval,
                                shouldRetry: true,
                            };
                        }
                        return {
                            retryInterval: 0,
                            shouldRetry: false,
                        };
                    };
                },
            };
        }
        static createIncremental(name = null, retryCount = Retry.defaults.clientRetryCount, initialInterval = Retry.defaults.retryInterval, increment = Retry.defaults.retryIncrement, firstFastRetry = Retry.defaults.firstFastRetry) {
            return {
                name: name !== null && name !== void 0 ? name : 'Incremental',
                fastFirstRetry: firstFastRetry,
                getShouldRetry: () => (currentRetryCount) => {
                    if (currentRetryCount < retryCount) {
                        return {
                            retryInterval: initialInterval + increment * currentRetryCount,
                            shouldRetry: true,
                        };
                    }
                    return {
                        retryInterval: 0,
                        shouldRetry: false,
                    };
                },
            };
        }
        static createExponentialBackoff(name = null, retryCount = Retry.defaults.clientRetryCount, minBackoff = Retry.defaults.minBackoff, maxBackoff = Retry.defaults.maxBackoff, deltaBackoff = Retry.defaults.clientBackoff, firstFastRetry = Retry.defaults.firstFastRetry) {
            return {
                name: name !== null && name !== void 0 ? name : 'ExponentialBackoff',
                fastFirstRetry: firstFastRetry,
                getShouldRetry: () => (currentRetryCount) => {
                    if (currentRetryCount < retryCount) {
                        const minDeltaBackoff = Math.floor(deltaBackoff * 0.8);
                        const maxDeltaBackoff = Math.floor(deltaBackoff * 1.2);
                        const currentDeltaBackoff = Math.random() * (maxDeltaBackoff - minDeltaBackoff) + minDeltaBackoff;
                        const backoff = Math.floor((Math.pow(2, currentRetryCount) - 1) * currentDeltaBackoff);
                        return {
                            retryInterval: Math.floor(Math.min(minBackoff + backoff, maxBackoff)),
                            shouldRetry: true,
                        };
                    }
                    return {
                        retryInterval: 0,
                        shouldRetry: false,
                    };
                },
            };
        }
        static createRetryPolicy(errorDetectionStrategy, retryStrategy) {
            return {
                execute(funcFactory, signal) {
                    return __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        let retryCount = 0;
                        const shouldRetry = retryStrategy.getShouldRetry();
                        // Использование await в цикле и константного условия в while - это by design.
                        /* eslint-disable no-await-in-loop */
                        /* eslint-disable-next-line no-constant-condition */
                        while (true) {
                            signal.throwIfAborted();
                            let delay;
                            try {
                                return yield funcFactory();
                            }
                            catch (ex) {
                                console.debug(`The attempt ${retryCount}${(retryCount <= 0 ? ' (i.e. original operation)' : '')} failed because of '${getErrorType(ex)}' error: '${getErrorString(ex)}'.`);
                                if (!errorDetectionStrategy.isTransient(ex)) {
                                    console.debug(`The Retry was aborted after ${retryCount + 1} attempt(s), since the error wasn't considered as transient.`);
                                    throw ex;
                                }
                                const retryOptions = shouldRetry(retryCount++);
                                if (!retryOptions.shouldRetry) {
                                    console.debug(`The Retry was aborted after ${retryCount - 1} attempt(s), because shouldRetry returned 'false'.`);
                                    throw ex;
                                }
                                delay = retryOptions.retryInterval > 0 ? retryOptions.retryInterval : 0;
                                if (delay < 0)
                                    delay = 0;
                            }
                            signal.throwIfAborted();
                            if (retryCount > 1 || !retryStrategy.fastFirstRetry) {
                                console.debug(`The next retry attempt was scheduled with ${delay}ms delay.`);
                                yield App.delay(delay, signal);
                            }
                            else {
                                console.debug('The next retry attempt was scheduled without delay.');
                            }
                        }
                        /* eslint-enable no-await-in-loop */
                    });
                },
            };
        }
    }
    /**
     * Default-опции.
     */
    Object.defineProperty(Retry, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            clientRetryCount: 10,
            clientBackoff: 10 * 1000,
            maxBackoff: 30 * 1000,
            minBackoff: 1 * 1000,
            retryInterval: 1 * 1000,
            retryIncrement: 1 * 1000,
            firstFastRetry: true,
        }
    });
    /**
     * Returns a default policy that performs no retries, but invokes the action only once.
     */
    Object.defineProperty(Retry, "noRetry", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: Retry.createFixedInterval(null, 0)
    });
    /**
     * Returns a default policy that implements a fixed retry interval configured with the "defaultClientRetryCount" and
     * "defaultRetryInterval" parameters.
     * The default retry policy treats all caught exceptions as transient errors.
     */
    Object.defineProperty(Retry, "defaultFixed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: Retry.createFixedInterval(null)
    });
    /**
     * Returns a default policy that implements a progressive retry interval configured with the "defaultClientRetryCount",
     * "defaultRetryInterval", and "defaultRetryIncrement" parameters.
     * The default retry policy treats all caught exceptions as transient errors.
     */
    Object.defineProperty(Retry, "defaultProgressive", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: Retry.createIncremental()
    });
    /**
     * Returns a default policy that implements a random exponential retry interval configured with the "defaultClientRetryCount",
     * "defaultMinBackoff", "defaultMaxBackoff", and "defaultClientBackoff" parameters.
     * The default retry policy treats all caught exceptions as transient errors.
     */
    Object.defineProperty(Retry, "defaultExponential", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: Retry.createExponentialBackoff()
    });
    App.Retry = Retry;
})(App || (App = {}));
var App;
(function (App) {
    var _SearchLocker_instances, _SearchLocker_options, _SearchLocker_url, _SearchLocker_show, _SearchLocker_openUrl;
    class SearchLocker {
        constructor(options) {
            _SearchLocker_instances.add(this);
            _SearchLocker_options.set(this, void 0);
            Object.defineProperty(this, "container", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _SearchLocker_url.set(this, void 0);
            const defaults = {
                container: '.js-messages',
                // root: '.js-...',
            };
            __classPrivateFieldSet(this, _SearchLocker_options, Object.assign(Object.assign({}, defaults), options), "f");
            this.container = $(__classPrivateFieldGet(this, _SearchLocker_options, "f").container);
        }
        check(data) {
            if (!data)
                return true;
            if (data.canSearch === undefined)
                return true;
            __classPrivateFieldGet(this, _SearchLocker_instances, "m", _SearchLocker_show).call(this, data);
            return false;
        }
    }
    _SearchLocker_options = new WeakMap(), _SearchLocker_url = new WeakMap(), _SearchLocker_instances = new WeakSet(), _SearchLocker_show = function _SearchLocker_show(data) {
        $(this.container)
            .empty()
            .append(App.templates.Messages.LockSearchMessage({ allowedCountries: data.allowedCountries }));
        __classPrivateFieldSet(this, _SearchLocker_url, data.seo.url, "f");
        $('.js-as-neworder', this.container).on('click', () => __classPrivateFieldGet(this, _SearchLocker_instances, "m", _SearchLocker_openUrl).call(this));
        const elementOffset = this.container.offset();
        if (elementOffset)
            window.scrollTo(elementOffset.left, elementOffset.top - 300);
    }, _SearchLocker_openUrl = function _SearchLocker_openUrl() {
        if (__classPrivateFieldGet(this, _SearchLocker_url, "f"))
            window.location.href = App.removeContext(__classPrivateFieldGet(this, _SearchLocker_url, "f"));
    };
    App.SearchLocker = SearchLocker;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Модель для отрисовки выпадающих списков с одиночным выбором.
     */
    class SelectListModel {
        get selected() {
            const result = this.items.find(v => v.selected);
            if (result)
                return result;
            return this.items.length > 0 ? this.items[0] : null;
        }
        constructor(options) {
            Object.defineProperty(this, "name", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "inputName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "form", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "autocomplete", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "htmlAttributes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isRequired", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.name = options.name || 'name';
            this.inputName = options.inputName || this.name;
            this.form = options.form || false;
            this.autocomplete = options.autocomplete || false;
            this.htmlAttributes = options.htmlAttributes || {};
            this.isRequired = options.isRequired || false;
            this.items = options.items || new Array();
        }
    }
    App.SelectListModel = SelectListModel;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _Seo_options, _Seo_updateCanonical, _Seo_updateFields;
    class Seo {
        constructor(options) {
            _Seo_options.set(this, void 0);
            __classPrivateFieldSet(this, _Seo_options, options, "f");
            __classPrivateFieldGet(_a, _a, "m", _Seo_updateFields).call(_a, __classPrivateFieldGet(this, _Seo_options, "f").fields);
        }
        update(info) {
            var _b, _c;
            const container = $('head');
            // На случай, если по SEO мы не получили информации по title и поэтому не хотим перезаписать текущий title на пустоту.
            if (info.title)
                $('title', container).text(info.title);
            $('meta[name="description"]', container).attr('content', (_b = info.description) !== null && _b !== void 0 ? _b : '');
            $('meta[name="keywords"]', container).attr('content', (_c = info.keywords) !== null && _c !== void 0 ? _c : '');
            __classPrivateFieldGet(_a, _a, "m", _Seo_updateCanonical).call(_a, container, info.url, info.canonicalUrl);
            __classPrivateFieldGet(_a, _a, "m", _Seo_updateFields).call(_a, info.fields);
        }
    }
    _a = Seo, _Seo_options = new WeakMap(), _Seo_updateCanonical = function _Seo_updateCanonical(container, currentUrl, value) {
        const el = $('link[rel="canonical"]', container);
        if (value == null || value.length <= 0 || value === currentUrl) {
            el.remove();
        }
        else if (el.length <= 0) {
            $(document.createElement('link'))
                .attr('rel', 'canonical')
                .attr('href', value)
                .appendTo(container);
        }
        else {
            el.attr('href', value);
        }
    }, _Seo_updateFields = function _Seo_updateFields(fields) {
        if (fields == null)
            return;
        const container = $('body');
        fields.forEach(v => { var _b; return $(`${v.fieldCode}`, container).html((_b = v.fieldValue) !== null && _b !== void 0 ? _b : ''); });
    };
    App.Seo = Seo;
})(App || (App = {}));
var App;
(function (App) {
    var _StorageService_storage;
    class StorageService {
        constructor({ storage = window.sessionStorage } = {}) {
            _StorageService_storage.set(this, void 0);
            __classPrivateFieldSet(this, _StorageService_storage, storage, "f");
        }
        get(key) {
            const item = __classPrivateFieldGet(this, _StorageService_storage, "f").getItem(key);
            if (item && item !== 'undefined')
                return JSON.parse(item);
            return undefined;
        }
        set(key, value) {
            __classPrivateFieldGet(this, _StorageService_storage, "f").setItem(key, JSON.stringify(value));
        }
        retrieve(key, valueFactory) {
            const item = __classPrivateFieldGet(this, _StorageService_storage, "f").getItem(key);
            if (item && item !== 'undefined')
                return JSON.parse(item);
            const value = valueFactory();
            this.set(key, value);
            return value;
        }
    }
    _StorageService_storage = new WeakMap();
    App.StorageService = StorageService;
})(App || (App = {}));
var App;
(function (App) {
    var _TabsMobile_instances, _TabsMobile_tab, _TabsMobile_tabWrap, _TabsMobile_queryParams, _TabsMobile_getTabData, _TabsMobile_changeActive;
    class TabsMobile {
        constructor(options) {
            _TabsMobile_instances.add(this);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _TabsMobile_tab.set(this, void 0);
            _TabsMobile_tabWrap.set(this, void 0);
            _TabsMobile_queryParams.set(this, void 0);
            const opts = options || {};
            if (opts.root)
                this.root = opts.root;
            else if (opts.self)
                this.root = $(opts.self);
            else
                this.root = App.app.appContainer;
            __classPrivateFieldSet(this, _TabsMobile_tab, $('.js-tab', this.root), "f");
            __classPrivateFieldSet(this, _TabsMobile_tabWrap, $('.js-tab-wrap', this.root), "f");
            __classPrivateFieldGet(this, _TabsMobile_tab, "f").on('click', e => this.onTabClick(e));
            __classPrivateFieldSet(this, _TabsMobile_queryParams, new App.QueryParams(window.location.pathname), "f");
            const hash = __classPrivateFieldGet(this, _TabsMobile_queryParams, "f").getAncher();
            if (hash.length > 0) {
                const re = /#(\d+)-([\w-%]+)$/;
                const matches = re.exec(hash);
                if (matches != null)
                    this.show(matches[2], (matches[1] != '0' ? Number(matches[1]) : null));
            }
        }
        showActive() {
            const tabs = __classPrivateFieldGet(this, _TabsMobile_tab, "f").filter('.tab-button--active');
            tabs.each((_, element) => {
                const jqElement = $(element);
                const tabData = __classPrivateFieldGet(this, _TabsMobile_instances, "m", _TabsMobile_getTabData).call(this, jqElement);
                if (!tabData)
                    return;
                if (tabData.group)
                    __classPrivateFieldGet(this, _TabsMobile_tabWrap, "f").filter(`[data-group="${tabData.group}"][data-tab="${tabData.tab}"]`).fadeIn();
                else
                    __classPrivateFieldGet(this, _TabsMobile_tabWrap, "f").filter(`[data-tab="${tabData.tab}"]`).fadeIn();
            });
        }
        show(name, groupId = null) {
            let target = __classPrivateFieldGet(this, _TabsMobile_tab, "f").filter(`[data-tab="${name}"]`);
            if (groupId) {
                // target = this.#tab.filter(`.js-tabs-block[data-group="${groupId}"] > [data-tab="${name}"]`);
                target = target.filter(`[data-group="${groupId}"]`);
            }
            __classPrivateFieldGet(this, _TabsMobile_instances, "m", _TabsMobile_changeActive).call(this, target, groupId);
            target.trigger("tab:click" /* Events.TabClick */);
        }
        onTabClick(e) {
            __classPrivateFieldGet(this, _TabsMobile_instances, "m", _TabsMobile_changeActive).call(this, $(e.currentTarget));
            $(e.currentTarget).trigger("tab:click" /* Events.TabClick */);
        }
    }
    _TabsMobile_tab = new WeakMap(), _TabsMobile_tabWrap = new WeakMap(), _TabsMobile_queryParams = new WeakMap(), _TabsMobile_instances = new WeakSet(), _TabsMobile_getTabData = function _TabsMobile_getTabData(jqElement) {
        if (!jqElement)
            return undefined;
        const tab = jqElement.attr('data-tab');
        if (!tab)
            return undefined;
        // NOTE: в отличии от PC версии номер группы не в родителе, а в самой вкладке
        // const group = jqElement.closest('.js-tabs-block').attr('data-group');
        const group = jqElement.attr('data-group');
        // NOTE: в отличии от PC версии номер группы не обязателен
        return { tab: tab || 'none', group: group };
    }, _TabsMobile_changeActive = function _TabsMobile_changeActive(target, groupId = null) {
        const notActive = !target.hasClass('tab-button--active');
        const tabData = __classPrivateFieldGet(this, _TabsMobile_instances, "m", _TabsMobile_getTabData).call(this, target);
        if (!tabData)
            return;
        if (groupId)
            tabData.group = groupId.toString();
        let ancher = `#${tabData.group || 0}-${tabData.tab}`;
        if (target.length === 0)
            ancher = '';
        __classPrivateFieldSet(this, _TabsMobile_queryParams, new App.QueryParams(window.location.pathname), "f");
        __classPrivateFieldGet(this, _TabsMobile_queryParams, "f").setAncher(ancher);
        App.History.replaceState('', __classPrivateFieldGet(this, _TabsMobile_queryParams, "f").getUrl(true), true);
        if (notActive) {
            target.siblings('.js-tab').removeClass('tab-button--active');
            target.addClass('tab-button--active');
            // TODO: протестировать вариант с group, верно ли понял логику (пока не встречалось практическое применение)
            if (tabData.group) {
                __classPrivateFieldGet(this, _TabsMobile_tabWrap, "f").filter(`[data-group="${tabData.group}"]`).hide();
                __classPrivateFieldGet(this, _TabsMobile_tabWrap, "f").filter(`[data-group="${tabData.group}"][data-tab="${tabData.tab}"]`).fadeIn();
            }
            else {
                __classPrivateFieldGet(this, _TabsMobile_tabWrap, "f").hide();
                __classPrivateFieldGet(this, _TabsMobile_tabWrap, "f").filter(`[data-tab="${tabData.tab}"]`).fadeIn();
            }
        }
    };
    App.TabsMobile = TabsMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _Tabs_instances, _Tabs_tab, _Tabs_tabWrap, _Tabs_queryParams, _Tabs_changeActive, _Tabs_updateDigestAfterTabSwitch;
    class Tabs {
        constructor(options) {
            _Tabs_instances.add(this);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _Tabs_tab.set(this, void 0);
            _Tabs_tabWrap.set(this, void 0);
            _Tabs_queryParams.set(this, void 0);
            const opts = options || {};
            if (opts.root)
                this.root = opts.root;
            else if (opts.self)
                this.root = $(opts.self);
            else
                this.root = App.app.appContainer;
            __classPrivateFieldSet(this, _Tabs_tab, $('.js-tab', this.root), "f");
            __classPrivateFieldSet(this, _Tabs_tabWrap, $('.js-tab-wrap', this.root), "f");
            __classPrivateFieldGet(this, _Tabs_tab, "f").on('click', e => this.onTabClick(e));
            __classPrivateFieldSet(this, _Tabs_queryParams, new App.QueryParams(window.location.pathname), "f");
            const hash = __classPrivateFieldGet(this, _Tabs_queryParams, "f").getAncher();
            if (hash.length > 0) {
                const re = /#(\d+)-([\w-%]+)$/;
                const matches = re.exec(hash);
                if (matches != null)
                    this.show(matches[2], Number(matches[1]));
            }
        }
        showActive() {
            const tabs = __classPrivateFieldGet(this, _Tabs_tab, "f").filter('._active');
            tabs.each((_, element) => {
                const jqElement = $(element);
                const tab = jqElement.attr('data-tab');
                if (!tab)
                    return;
                const group = jqElement.closest('.js-tabs-block').attr('data-group');
                if (!group)
                    return;
                __classPrivateFieldGet(this, _Tabs_tabWrap, "f").filter(`[data-group="${group}"][data-tab="${tab}"]`).fadeIn();
            });
        }
        show(name, groupId = null) {
            let target = __classPrivateFieldGet(this, _Tabs_tab, "f").filter(`[data-tab="${name}"]`);
            if (groupId)
                target = __classPrivateFieldGet(this, _Tabs_tab, "f").filter(`.js-tabs-block[data-group="${groupId}"] > [data-tab="${name}"]`);
            __classPrivateFieldGet(this, _Tabs_instances, "m", _Tabs_changeActive).call(this, target, groupId);
            target.trigger("tab:click" /* Events.TabClick */);
        }
        onTabClick(e) {
            __classPrivateFieldGet(this, _Tabs_instances, "m", _Tabs_changeActive).call(this, $(e.currentTarget));
            $(e.currentTarget).trigger("tab:click" /* Events.TabClick */);
        }
    }
    _Tabs_tab = new WeakMap(), _Tabs_tabWrap = new WeakMap(), _Tabs_queryParams = new WeakMap(), _Tabs_instances = new WeakSet(), _Tabs_changeActive = function _Tabs_changeActive(target, groupId = null) {
        const notActive = !target.hasClass('_active');
        const group = groupId == null ? target.closest('.js-tabs-block').attr('data-group') : groupId;
        if (!group)
            return;
        const tab = target.attr('data-tab');
        if (!tab)
            return;
        let ancher = `#${group}-${tab}`;
        if (target.length === 0)
            ancher = '';
        __classPrivateFieldSet(this, _Tabs_queryParams, new App.QueryParams(window.location.pathname), "f");
        __classPrivateFieldGet(this, _Tabs_queryParams, "f").setAncher(ancher);
        App.History.replaceState('', __classPrivateFieldGet(this, _Tabs_queryParams, "f").getUrl(true), true);
        if (notActive) {
            target.siblings('.js-tab').removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _Tabs_tabWrap, "f").filter(`[data-group="${group}"]`).hide();
            __classPrivateFieldGet(this, _Tabs_tabWrap, "f").filter(`[data-group="${group}"][data-tab="${tab}"]`).fadeIn();
            __classPrivateFieldGet(this, _Tabs_instances, "m", _Tabs_updateDigestAfterTabSwitch).call(this);
        }
    }, _Tabs_updateDigestAfterTabSwitch = function _Tabs_updateDigestAfterTabSwitch() {
        setTimeout(() => {
            var _a, _b;
            (_b = (_a = App.app.page) === null || _a === void 0 ? void 0 : _a.digest) === null || _b === void 0 ? void 0 : _b.updateAll();
        }, 100);
    };
    App.Tabs = Tabs;
})(App || (App = {}));
var App;
(function (App) {
    var _UnavailableOfferService_instances, _a, _UnavailableOfferService_s_lifetime, _UnavailableOfferService_s_storageKey, _UnavailableOfferService_storage, _UnavailableOfferService_getItems;
    class UnavailableOfferService {
        constructor(storage) {
            _UnavailableOfferService_instances.add(this);
            _UnavailableOfferService_storage.set(this, void 0);
            __classPrivateFieldSet(this, _UnavailableOfferService_storage, storage, "f");
        }
        get() {
            return __classPrivateFieldGet(this, _UnavailableOfferService_instances, "m", _UnavailableOfferService_getItems).call(this).map(v => v.key);
        }
        add(key) {
            this.addRange([key]);
        }
        addRange(keys) {
            const items = __classPrivateFieldGet(this, _UnavailableOfferService_instances, "m", _UnavailableOfferService_getItems).call(this);
            const expireAt = new App.XDate().addSeconds(__classPrivateFieldGet(_a, _a, "f", _UnavailableOfferService_s_lifetime)).getTime();
            keys.forEach(v => {
                const item = items.find(x => x.key === v);
                if (item == null)
                    items.push({ key: v, expireAt });
                else
                    item.expireAt = expireAt;
            });
            __classPrivateFieldGet(this, _UnavailableOfferService_storage, "f").set(__classPrivateFieldGet(_a, _a, "f", _UnavailableOfferService_s_storageKey), items);
        }
    }
    _a = UnavailableOfferService, _UnavailableOfferService_storage = new WeakMap(), _UnavailableOfferService_instances = new WeakSet(), _UnavailableOfferService_getItems = function _UnavailableOfferService_getItems() {
        const now = new Date().getTime();
        return __classPrivateFieldGet(this, _UnavailableOfferService_storage, "f").retrieve(__classPrivateFieldGet(_a, _a, "f", _UnavailableOfferService_s_storageKey), () => new Array())
            .filter(v => v.expireAt >= now);
    };
    _UnavailableOfferService_s_lifetime = { value: 24 * 60 * 60 };
    _UnavailableOfferService_s_storageKey = { value: `__${_a.name}` };
    App.UnavailableOfferService = UnavailableOfferService;
})(App || (App = {}));
var App;
(function (App) {
    App.emptyArray = (source) => {
        // https://stackoverflow.com/questions/1232040/how-do-i-empty-an-array-in-javascript
        source.length = 0;
    };
    App.removeElement = (source, element) => {
        const index = source.indexOf(element);
        if (index >= 0)
            source.splice(index, 1);
    };
    App.removeElementAt = (source, index) => {
        if (index >= 0 && index < source.length)
            source.splice(index, 1);
    };
    App.removeAllElements = (source, predicate) => {
        let i = 0;
        while (i < source.length) {
            if (predicate(source[i]))
                source.splice(i, 1);
            else
                i++;
        }
    };
})(App || (App = {}));
var App;
(function (App) {
    App.millisecondsPerSecond = 1000;
    App.secondsPerMillisecond = 1 / App.millisecondsPerSecond;
    App.secondsPerMinute = 60;
    App.millisecondsPerMinute = App.secondsPerMinute * App.millisecondsPerSecond;
    App.minutesPerMillisecond = 1 / App.millisecondsPerMinute;
    App.minutesPerHour = 60;
    App.millisecondsPerHour = App.minutesPerHour * App.millisecondsPerMinute;
    App.hoursPerMillisecond = 1 / App.millisecondsPerHour;
    App.hoursPerDay = 24;
    App.millisecondsPerDay = App.hoursPerDay * App.millisecondsPerHour;
    App.daysPerMillisecond = 1 / App.millisecondsPerDay;
    // https://stackoverflow.com/a/67927025
    const getTimezoneOffset = (timeZone) => {
        // Сдвиг временной зоны выражается в кол-ве минут от UTC, поэтому убираем все компоненты меньшие минуты, чтобы не мешали расчетам.
        const nowTimestamp = Math.trunc(Date.now() / App.millisecondsPerMinute) * App.millisecondsPerMinute;
        const now = new Date(nowTimestamp);
        const tzString = now.toLocaleString('en-US', { timeZone });
        const tzOffset = (Date.parse(tzString) - nowTimestamp) / App.millisecondsPerMinute;
        return tzOffset - now.getTimezoneOffset();
    };
    /**
     * Псевдонимы (aliases) для используемых в приложении временных зон.
     * Note: при добавлении новых свойств необходимо добавить переводы в файлы "messages/{locale}.json".
     */
    const timezoneOffsets = {
        utc: 0,
        moscow: getTimezoneOffset('Europe/Moscow'),
    };
    App.getTimezone = () => {
        var _a;
        const result = (_a = App.Cookie.get("timezone" /* KnownCookie.Timezone */)) !== null && _a !== void 0 ? _a : App.app.settings.defaultTimezone;
        if (!Object.prototype.hasOwnProperty.call(timezoneOffsets, result))
            return Object.keys(timezoneOffsets)[0];
        return result;
    };
    App.parseDate = (value, format) => {
        return dateFns.parse(value, format !== null && format !== void 0 ? format : 'dd.MM.yyyy', new Date());
    };
    // TODO: заменить на использование метода date-fns.parseISO. Проверить как он работает с UTC-датами.
    /**
     * Получает дату из строки в одном из ISO-форматов. Если в строке указана временная зона, то дата приводится к UTC.
     * Не производится валидация компонентов даты и времени!
     * @param value
     * Поддерживаемые форматы:
     * yyyy-MM-dd[THH[:mm[:ss[.fff]]]][K]
     * yyyy-MM-dd[THH[:mm[:ss[,fff]]]][K]
     * yyyyMMdd[THH[mm[ss[.fff]]]][K]
     * yyyyMMdd[THH[mm[ss[,fff]]]][K]
     *
     * Форматы временных зон (компонента 'K'):
     * Z
     * ±hh:mm
     * ±hhmm
     * ±hh
     */
    App.parseIsoDate = (value) => {
        const dateTimeParts = value.split('T');
        // Обработка даты.
        const datePart = dateTimeParts[0];
        const withDateSeparators = (datePart.length > 8);
        const year = parseInt(datePart.substring(0, 4), 10);
        let datePartPos = (withDateSeparators ? 5 : 4);
        const month = parseInt(datePart.substring(datePartPos, datePartPos + 2), 10);
        datePartPos += (withDateSeparators ? 3 : 2);
        const day = parseInt(datePart.substring(datePartPos, datePartPos + 2), 10);
        if (dateTimeParts.length <= 1) {
            // Note: сразу в конструкторе Date не ставим распарсенный год, т.к. если он находится в интервале от 0 до 99, то в этом случае
            // год интерпретируется как 1970+(0..99). Однако изначально устанавливаемый год должен быть високосный (любой), чтобы в случае
            // необходимости корректно установилась дата 29 февраля.
            const result = new Date(2020, month - 1, day);
            result.setFullYear(year);
            return result;
        }
        let timePart = dateTimeParts[1];
        let utcOffsetMinutes = 0;
        // Обработка временной зоны.
        const offsetSigns = ['-', '−', '+'];
        if (timePart.endsWith('Z')) {
            timePart = timePart.substring(0, timePart.length - 1);
        }
        else if (offsetSigns.includes(timePart[timePart.length - 3])) {
            // ±hh
            utcOffsetMinutes = parseInt(timePart.substring(timePart.length - 2), 10) * 60;
            if (timePart[timePart.length - 3] !== '+')
                utcOffsetMinutes = -utcOffsetMinutes;
            timePart = timePart.substring(0, timePart.length - 3);
        }
        else if (offsetSigns.includes(timePart[timePart.length - 5])) {
            // ±hhmm
            utcOffsetMinutes = parseInt(timePart.substring(timePart.length - 4, timePart.length - 2), 10) * 60
                + parseInt(timePart.substring(timePart.length - 2), 10);
            if (timePart[timePart.length - 5] !== '+')
                utcOffsetMinutes = -utcOffsetMinutes;
            timePart = timePart.substring(0, timePart.length - 5);
        }
        else if (offsetSigns.includes(timePart[timePart.length - 6])) {
            // ±hh:mm
            utcOffsetMinutes = parseInt(timePart.substring(timePart.length - 5, timePart.length - 3), 10) * 60
                + parseInt(timePart.substring(timePart.length - 2), 10);
            if (timePart[timePart.length - 6] !== '+')
                utcOffsetMinutes = -utcOffsetMinutes;
            timePart = timePart.substring(0, timePart.length - 6);
        }
        // Обработка времени.
        const hours = parseInt(timePart.substring(0, 2), 10);
        let minutes = 0;
        let seconds = 0;
        let ms = 0;
        let timePartPos = 2;
        if (timePart.length > timePartPos) {
            if (timePart[timePartPos] === ':')
                timePartPos += 1;
            minutes = parseInt(timePart.substring(timePartPos, timePartPos + 2), 10);
            timePartPos += 2;
            if (timePart.length > timePartPos) {
                if (timePart[timePartPos] === ':')
                    timePartPos += 1;
                seconds = parseInt(timePart.substring(timePartPos, timePartPos + 2), 10);
                timePartPos += 2;
                if (timePart.length > timePartPos && (timePart[timePartPos] === '.' || timePart[timePartPos] === ','))
                    ms = parseInt(timePart.substring(timePartPos + 1, timePartPos + 4), 10);
            }
        }
        // Note: сразу в конструкторе Date не ставим распарсенный год, т.к. если он находится в интервале от 0 до 99, то в этом случае
        // год интерпретируется как 1970+(0..99). Однако изначально устанавливаемый год должен быть високосный (любой), чтобы в случае
        // необходимости корректно установилась дата 29 февраля.
        const result = new Date(2020, month - 1, day, hours, minutes, seconds, ms);
        result.setFullYear(year);
        if (utcOffsetMinutes !== 0)
            result.setMinutes(minutes - utcOffsetMinutes);
        return result;
    };
    /**
     * Получает TimeSpan (по сути number, являющийся кол-ом миллисекунд) из строки в одном из нейтральных форматов.
     * Не производится валидация компонентов времени!
     * @param value
     * Поддерживаемые форматы:
     * d
     * [d.]hh:mm[:ss[.fff]]]
     */
    App.parseTimeSpan = (value) => {
        const parts = value.split(':');
        if (parts.length <= 1)
            return parseInt(parts[0], 10) * App.millisecondsPerDay;
        let result = 0;
        // дни и часы
        const daysHours = parts[0].split('.');
        if (daysHours.length <= 1)
            result += parseInt(daysHours[0], 10) * App.millisecondsPerHour;
        else
            result += parseInt(daysHours[0], 10) * App.millisecondsPerDay + parseInt(daysHours[1], 10) * App.millisecondsPerHour;
        // минуты
        result += parseInt(parts[1], 10) * App.millisecondsPerMinute;
        // секунды и миллисекунды
        if (parts.length > 2) {
            const secondsMilliseconds = parts[2].split('.');
            result += parseInt(secondsMilliseconds[0], 10) * App.millisecondsPerSecond;
            if (secondsMilliseconds.length > 1)
                result += parseInt(secondsMilliseconds[1], 10);
        }
        return result;
    };
    /** TODO: убрать метод
     * Изготовление из нормальной даты вида 29.09.2017 14:22:42
     * даты в формате ISO 'yyyyMMdd'
     */
    App.localDateToIso = (dateInput) => {
        // расчленяем дату в фильтре вида 29.09.2017 14:22:42
        const year = dateInput.substring(6, 10);
        const month = dateInput.substring(3, 5);
        const day = dateInput.substring(0, 2);
        return `${year}${month}${day}`;
    };
    /**
     * Рассчитать возраст на указанную дату.
     * @param birthday Дата рождения.
     * @param current Дата, на момент которой производить расчет.
     */
    App.getAge = (birthday, current = new Date()) => {
        if (birthday > current)
            return 0;
        let result = current.getFullYear() - birthday.getFullYear();
        if (current.getMonth() < birthday.getMonth())
            result -= 1;
        else if (current.getMonth() === birthday.getMonth() && current.getDate() < birthday.getDate())
            result -= 1;
        return result;
    };
    const defaultDateTimeFormat = 'yyyy-MM-ddTHH:mm:ss';
    /**
     * Псевдонимы (aliases) для используемых в приложении форматов дат и времени.
     */
    const dateTimeFormats = {
        iso: 'yyyy-MM-ddTHH:mm:ss',
        isoDate: 'yyyy-MM-dd',
        isoTime: 'HH:mm:ss',
        shortIso: 'yyyyMMddTHHmmss',
        shortIsoDate: 'yyyyMMdd',
        shortIsoTime: 'HHmmss',
        searchShortDate: 'd MMM, ccc',
        searchLongDate: 'd MMMM, cccc',
        bookShortDate: 'd MMM, ccc',
        bookLongDate: 'd MMMM, cccc',
        digestShortDate: 'd MMMM',
        digestShortYearDate: 'dd.MM.yyyy, ccc',
        digestLongDate: 'd MMM, ccc',
        cancellationDate: 'dd.MM.yyyy HH:mm',
        checkinDate: 'dd.MM.yyyy',
        timeLimitDate: 'dd.MM.yyyy HH:mm',
        longDateTime: 'dd.MM.yyyy HH:mm',
        dayOfMonth: 'dd MMM, ccc',
        birthdayDate: 'dd.MM.yyyy',
        shortDate: 'dd.MM.yyyy',
        shortTime: 'HH:mm',
        dayOfWeek: 'E',
        searchXSDate: 'dd MMM',
    };
    App.formatDate = (value, format) => {
        var _a;
        const date = typeof value === 'string' ? App.parseIsoDate(value) : value;
        return dateFns.format(date, (_a = dateTimeFormats[format]) !== null && _a !== void 0 ? _a : defaultDateTimeFormat);
    };
    // sync with FormatTimezoneDateTime function in ApplicationValueFormatter.cs on server
    App.formatTimezoneDate = (value, format) => {
        var _a;
        let date = typeof value === 'string' ? App.parseIsoDate(value) : value;
        const timezoneOffset = timezoneOffsets[App.getTimezone()];
        if (timezoneOffset !== 0)
            date = new Date(date.getTime() + timezoneOffset * App.millisecondsPerMinute);
        const formattedDate = dateFns.format(date, (_a = dateTimeFormats[format]) !== null && _a !== void 0 ? _a : defaultDateTimeFormat);
        const timezoneName = App.formatMessage(`timezones/${App.getTimezone()}`);
        return `${formattedDate} (${timezoneName})`;
    };
    App.dateDiff = (base, value) => {
        const milliseconds = base.getTime() - value.getTime();
        return {
            getMilliseconds() {
                return milliseconds % App.millisecondsPerSecond;
            },
            getSeconds() {
                return (milliseconds / App.millisecondsPerSecond) % App.secondsPerMinute;
            },
            getMinutes() {
                return (milliseconds / App.millisecondsPerMinute) % App.minutesPerHour;
            },
            getHours() {
                return (milliseconds / App.millisecondsPerHour) % App.hoursPerDay;
            },
            getDays() {
                return milliseconds < 0
                    ? Math.ceil(milliseconds / App.millisecondsPerDay)
                    : Math.floor(milliseconds / App.millisecondsPerDay);
            },
            getTotalMilliseconds() {
                return milliseconds;
            },
            getTotalSeconds() {
                return milliseconds * App.secondsPerMillisecond;
            },
            getTotalMinutes() {
                return milliseconds * App.minutesPerMillisecond;
            },
            getTotalHours() {
                return milliseconds * App.hoursPerMillisecond;
            },
            getTotalDays() {
                return milliseconds * App.daysPerMillisecond;
            },
        };
    };
    App.minDate = (...values) => {
        if (values.length <= 0)
            throw new Error('At least one value must be passed.');
        return values.reduce((previous, current) => current.valueOf() < previous.valueOf() ? current : previous);
    };
    App.maxDate = (...values) => {
        if (values.length <= 0)
            throw new Error('At least one value must be passed.');
        return values.reduce((previous, current) => current.valueOf() > previous.valueOf() ? current : previous);
    };
    // TODO: рассмотреть вариант замены на "new XDate(date).addDays(value)" в местах вызова.
    App.addDays = (date, value) => {
        const result = new Date(date);
        result.setDate(result.getDate() + value);
        return result;
    };
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Псевдонимы (aliases) для используемых в приложении форматов чисел.
     */
    const numberFormats = {
        money: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
        intMoney: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        rate: { minimumFractionDigits: 4, maximumFractionDigits: 4 },
        // Note: только для использования с toLocaleString / Intl.toString !
        // TODO: возможно название имеет смысл "выровнять" с названием маски, в данном случае - moneyRu.
        moneyEdit: { minimumFractionDigits: 0, maximumFractionDigits: 2 },
    };
    App.formatNumber = (value, format) => {
        if (typeof format !== 'string')
            return Intl.NumberFormat(App.app.language, format).format(value);
        if (format.endsWith('Edit'))
            return value.toLocaleString('ru-RU', numberFormats[format]);
        return Intl.NumberFormat(App.app.language, numberFormats[format]).format(value);
    };
    App.numberToRuString = (value, format) => {
        if (typeof format !== 'string')
            return Intl.NumberFormat('ru-RU', format).format(value);
        return value.toLocaleString('ru-RU', numberFormats[format]);
    };
    const radiansPerDegree = Math.PI / 180;
    // https://en.wikipedia.org/wiki/Earth_radius
    const earthRadiusKm = 6371;
    /**
     * Получить расстояние (в километрах) между 2-мя координатами (по haversine-алгоритму).
     * https://www.movable-type.co.uk/scripts/latlong.html
     * https://stackoverflow.com/questions/365826/calculate-distance-between-2-gps-coordinates
     * @param src
     * @param dst
     */
    App.distance = (src, dst) => {
        const deltaLat = (dst.latitude - src.latitude) * radiansPerDegree;
        const deltaLon = (dst.longitude - src.longitude) * radiansPerDegree;
        const a1 = Math.sin(deltaLat / 2);
        const a2 = Math.sin(deltaLon / 2);
        const b1 = Math.cos(src.latitude * radiansPerDegree);
        const b2 = Math.cos(dst.latitude * radiansPerDegree);
        const a = a1 * a1 + a2 * a2 * b1 * b2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earthRadiusKm * c;
    };
    App.randomInt = (minInclusive, maxExclusive) => (Math.floor(Math.random() * (maxExclusive - minInclusive) + minInclusive));
    App.uniqueRandomInt = (minInclusive, maxExclusive, count) => {
        if (count <= 0)
            return new Array();
        const minInclusiveInt = Math.ceil(minInclusive);
        const maxExclusiveInt = Math.ceil(maxExclusive);
        const itemCount = Math.min(count, maxExclusiveInt - minInclusiveInt);
        const result = new Array();
        while (result.length < itemCount) {
            const item = App.randomInt(minInclusive, maxExclusive);
            if (!result.includes(item))
                result.push(item);
        }
        return result;
    };
    App.addSafe = (val1, val2) => val1 != null && val2 != null ? val1 + val2 : undefined;
})(App || (App = {}));
var App;
(function (App) {
    const getCultures = () => {
        const val = App.Cookie.get("culture" /* KnownCookie.Culture */);
        if (val == null || val === '')
            return undefined;
        const pairs = val.split('|')
            .map(v => v.split('='));
        if (pairs.length <= 0 || pairs.some(v => v.length !== 2))
            return undefined;
        const culturePair = pairs.find(v => v[0] === 'c' && App.app.settings.supportedLanguages.includes(v[1]));
        const culture = culturePair === null || culturePair === void 0 ? void 0 : culturePair[1];
        const uiCulturePair = pairs.find(v => v[0] === 'uic' && App.app.settings.supportedLanguages.includes(v[1]));
        const uiCulture = uiCulturePair === null || uiCulturePair === void 0 ? void 0 : uiCulturePair[1];
        return {
            culture: culture !== null && culture !== void 0 ? culture : uiCulture,
            uiCulture: uiCulture !== null && uiCulture !== void 0 ? uiCulture : culture,
        };
    };
    App.getCulture = () => {
        var _a, _b;
        return (_b = (_a = getCultures()) === null || _a === void 0 ? void 0 : _a.culture) !== null && _b !== void 0 ? _b : App.app.settings.defaultLanguage;
    };
    App.getUICulture = () => {
        var _a, _b;
        return (_b = (_a = getCultures()) === null || _a === void 0 ? void 0 : _a.uiCulture) !== null && _b !== void 0 ? _b : App.app.settings.defaultLanguage;
    };
    App.isEnglishLanguage = () => {
        return App.getUICulture() === 'en';
    };
    /* eslint-disable object-property-newline */
    const translitCyrLat = {
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'E', 'Ж': 'ZH', 'З': 'Z', 'И': 'I',
        'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T',
        'У': 'U', 'Ф': 'F', 'Х': 'KH', 'Ц': 'TS', 'Ч': 'CH', 'Ш': 'SH', 'Щ': 'SHCH', 'Ы': 'Y', 'Ъ': '', 'Ь': '',
        'Э': 'E', 'Ю': 'YU', 'Я': 'YA',
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
        'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
        'у': 'u', 'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ы': 'y', 'ъ': '', 'ь': '',
        'э': 'e', 'ю': 'yu', 'я': 'ya',
        'Є': 'E', 'Ї': 'I', 'Ґ': 'G',
    };
    /* eslint-enable object-property-newline */
    App.transliterate = (value) => {
        let buf = '';
        for (let i = 0; i < value.length; i++) {
            const chr = value.charAt(i);
            const replace = translitCyrLat[chr];
            buf += (replace !== undefined ? replace : chr);
        }
        return buf;
    };
    App.normalizeName = (value) => value.trim().toUpperCase();
    App.transliterateName = (value) => App.transliterate(App.normalizeName(value));
    App.pluralRu = (count, textOne, textFew, textMany) => {
        var _a;
        const textGroups = {
            one: textOne,
            few: textFew,
            other: textMany !== null && textMany !== void 0 ? textMany : textFew,
        };
        return (_a = textGroups[Globalize.plural(count)]) !== null && _a !== void 0 ? _a : textGroups.other;
    };
    App.formatMessage = (path, variables) => {
        return Globalize.formatMessage(path, variables);
    };
    App.removeEndChar = (str, char) => {
        if (!str)
            return str;
        const index = str.indexOf(char, str.length - 1);
        if (index < 0)
            return str;
        return str.substring(0, index);
    };
    App.splitNonEmpty = (value, separator = ',') => {
        if (!value)
            return [];
        return value.split(separator);
    };
})(App || (App = {}));
var App;
(function (App) {
    App.isTouch = $('html').hasClass('touchevents');
    // TODO: перенести в др.место, это не utility-функция.
    App.scrollLinkClickHandler = (event) => {
        const target = $(event.currentTarget);
        const destId = target.attr('data-scroll');
        if (!destId)
            return;
        const dest = $(`[data-dest="${destId}"]`);
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += (App.app.container.scrollTop() || 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    };
    // TODO: перенести в др.место, это не utility-функция.
    App.readMoreClickHandler = (event) => {
        const target = $(event.currentTarget);
        const blockWrap = target.parent();
        const blockGradient = $('.js-read-more-gradient', blockWrap);
        if (target.hasClass('_active')) {
            target.removeClass('_active');
            target.text('Читать полностью');
            blockGradient.removeClass('_hidden');
            blockWrap.addClass('_folded');
        }
        else {
            target.addClass('_active');
            target.text('Свернуть');
            blockGradient.addClass('_hidden');
            blockWrap.removeClass('_folded');
        }
    };
    const showMessage = (messages, messenger, messageOptions) => {
        if (messenger)
            messenger.show(messages, messageOptions);
        else
            App.ConsoleMessenger.instance.show(messages);
    };
    App.validateResponse = (response, messenger, validator, options) => {
        if (!response) {
            showMessage([{ type: 2 /* MessageType.Error */, text: 'Произошла ошибка. Попробуйте еще раз через некоторое время.' }]);
            return false;
        }
        if (response.redirect != null) {
            window.location.href = response.redirect;
            return true;
        }
        if (messenger)
            messenger.hide();
        if (response.status.messages && response.status.messages.length > 0) {
            const fatalErrors = response.status.messages.filter(v => v.type === 3 /* MessageType.Fatal */);
            if (fatalErrors.length > 0) {
                App.app.appContainerContent.html(App.templates.Error(fatalErrors));
                return response.status.success;
            }
            const opts = Object.assign(Object.assign({}, App.Messages.defaults), options);
            showMessage(response.status.messages, messenger, opts);
        }
        if (validator && response.status.modelState && !response.status.modelState.isValid) {
            const modelErrors = new Array();
            const fieldErrors = {};
            let hasFieldErrors = false;
            Object.entries(response.status.modelState.errors)
                .forEach(([k, v]) => {
                if (k) {
                    fieldErrors[k] = v.join('<br />');
                    hasFieldErrors = true;
                }
                else {
                    v.forEach(x => modelErrors.push(x));
                }
            });
            if (modelErrors.length > 0) {
                // TODO: use templates.Messages.ModelValidationError for text property
                // this.#options.messenger.show({ type: MessageType.Error, text: modelErrors.join('<br />') });
            }
            if (hasFieldErrors)
                validator.showErrors(fieldErrors);
            return false;
        }
        return response.status.success;
    };
    // вывод не модального окна, с крестиком
    App.popupShow = (content, title = '', onShowDelegate, onHideDelegate) => {
        const popup = new App.PopupOld({
            modal: false,
            title,
            content,
            onShowDelegate,
            onHideDelegate,
        });
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
        return popup;
    };
    // вывод модального окна, без крестика
    App.modalShow = (content, title = '', onShowDelegate, onHideDelegate) => {
        const popup = new App.PopupOld({
            modal: true,
            title,
            content,
            onShowDelegate,
            onHideDelegate,
        });
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
        return popup;
    };
    App.popupHide = () => {
        $('body').trigger("popup:close" /* Events.PopupClose */);
    };
    // установка таймера протухания результатов поиска.
    App.setSearchResultsExpirationTimer = (root, beforeHandler, interval) => {
        const timeout = interval || (30 * 60 * 1000);
        const timer = window.setTimeout(actualizeSearchResult, timeout);
        function actualizeSearchResult() {
            if ($(document).find(root).length <= 0) {
                if (timer)
                    clearTimeout(timer);
                return;
            }
            if (beforeHandler)
                beforeHandler();
            setTimeout(() => App.modalShow($(App.templates.ExpiredDialog({}))), 500);
        }
    };
    App.scheduleExpirationPopup = (options = {}) => {
        var _a;
        const timer = window.setTimeout(() => {
            const template = options.templateName != null ? App.findTemplate(options.templateName) : App.templates.Messages.Expired;
            const content = $(template({ url: options.url, customRefresh: options.customRefresh || false }));
            if (options.isContainerPopup) {
                const popup = new App.Popup({ root: $('.js-popup-search', options.root) });
                popup.show({
                    group: 'main',
                    content,
                    modal: true,
                });
            }
            else {
                // TODO: заменить на использование класса Popup.
                App.modalShow(content);
            }
        }, (_a = options.interval) !== null && _a !== void 0 ? _a : App.app.settings.relevantResultTime);
        let canceled = false;
        return {
            canceled: canceled,
            cancel() {
                if (canceled)
                    return;
                canceled = true;
                clearTimeout(timer);
            },
        };
    };
    // выделение текста и копирование его в буфер обмена
    App.selectAndCopy = (element) => {
        const selection = window.getSelection();
        if (!selection)
            return;
        const range = document.createRange();
        range.selectNodeContents($(element)[0]);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
    };
    App.copyToClipboard = (text) => {
        const temp = $('<input>');
        $('body').append(temp);
        temp.val(text).trigger('select');
        document.execCommand('copy');
        temp.remove();
    };
    App.download = (filename, text) => {
        const pom = document.createElement('a');
        pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        pom.setAttribute('download', filename);
        if (document.createEvent) {
            const event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            pom.dispatchEvent(event);
        }
        else {
            pom.click();
        }
    };
    App.textCounter = (field, countFieldId, maxLimit) => {
        const countField = document.getElementById(countFieldId);
        if (countField != null) {
            if (field.value.length > maxLimit) {
                field.value = field.value.substring(0, maxLimit);
                return false;
            }
            else {
                countField.innerHTML = `${maxLimit - field.value.length}`;
            }
        }
        return true;
    };
    App.asNewOrder = () => {
        window.location.href = App.removeContext(window.location.href);
    };
    App.removeContext = (url) => url.replace(new RegExp('/context-[a-z0-9]+', 'ig'), '');
})(App || (App = {}));
var App;
(function (App) {
    App.isObject = (value) => (typeof value === 'object' && value !== null && Array.isArray(value));
    /**
     * Полная копия объекта, без методов.
     * https://stackoverflow.com/questions/28150967/typescript-cloning-object
     * Если нужна shallow-copy:
     * 1. const clone = { ...obj };
     * 2. const clone = Object.assign({}, obj);
     * 3. const clone = Object.create(obj);
     * @param obj
     */
    App.deepCopy = (obj) => {
        // Handle the 3 simple types, and null or undefined
        if (obj == null || typeof obj !== 'object')
            return obj;
        // Handle Date
        if (obj instanceof Date) {
            const result = new Date();
            result.setTime(obj.getTime());
            return result;
        }
        // Handle Array
        if (obj instanceof Array) {
            const result = [];
            for (let i = 0, len = obj.length; i < len; i++)
                result[i] = App.deepCopy(obj[i]);
            return result;
        }
        // Handle Object
        if (obj instanceof Object) {
            const result = {};
            Object.entries(obj)
                .forEach(([k, v]) => (result[k] = App.deepCopy(v)));
            return result;
        }
        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    };
    App.notUndefined = (v) => v !== undefined;
    App.createAbortError = (message) => new DOMException(message !== null && message !== void 0 ? message : 'This operation was aborted.', 'AbortError');
    App.createTimeoutError = (message) => new DOMException(message !== null && message !== void 0 ? message : 'This operation was timed out.', 'TimeoutError');
    /**
     * Returns a promise that resolves after a specified number of milliseconds.
     * This is an equivalent to Task.Delay(Int32, CancellationToken) method in .NET Framework.
     * @param duration The number of milliseconds to wait before resolving the returned task.
     * @param signal An abort signal to observe while waiting for the promise to resolve.
     */
    App.delay = (duration, signal) => new Promise((resolve, reject) => {
        signal.throwIfAborted();
        // eslint-disable-next-line prefer-const
        let timer;
        const listener = () => {
            window.clearTimeout(timer);
            reject(App.createAbortError());
        };
        timer = window.setTimeout(() => {
            signal.removeEventListener('abort', listener);
            resolve();
        }, duration);
        signal.addEventListener('abort', listener, { once: true });
    });
    App.isJQueryAjaxErrorInfo = (obj) => (typeof obj === 'object' && obj !== null && 'status' in obj && 'statusText' in obj);
    App.requiredParam = (param) => {
        const error = new Error(`Required parameter "${param}" is missing.`);
        // сохраним исходный стек-трейс
        if (typeof Error.captureStackTrace === 'function')
            Error.captureStackTrace(error, App.requiredParam);
        throw error;
    };
    const createUrlSearchParamsCore = (prefix, obj, append) => {
        if (Array.isArray(obj)) {
            for (const [i, v] of obj.entries())
                createUrlSearchParamsCore(v != null && typeof v === 'object' ? `${prefix}[${i}]` : prefix, v, append);
        }
        else if (obj != null && typeof obj === 'object') {
            for (const [name, value] of Object.entries(obj))
                createUrlSearchParamsCore(`${prefix}.${name}`, value, append);
        }
        else {
            append(prefix, obj);
        }
    };
    App.createUrlSearchParams = (data) => {
        const result = new URLSearchParams();
        const append = (name, value) => {
            result.append(name, value == null ? '' : value.toString());
        };
        if (Array.isArray(data)) {
            for (const { name, value } of data)
                createUrlSearchParamsCore(name, value, append);
        }
        else {
            for (const [name, value] of Object.entries(data))
                createUrlSearchParamsCore(name, value, append);
        }
        return result;
    };
    /**
     * Returns a new signal that will be signaled when any of the signals in the specified array are signaled.
     * This is an equivalent to CancellationTokenSource.CreateLinkedTokenSource(CancellationToken[]) method in .NET Framework.
     * @param signals An abort signals to observe.
     */
    App.createLinkedSignal = (...signals) => {
        const controller = new AbortController();
        for (let i = 0; i < signals.length; i++) {
            if (signals[i].aborted) {
                onAbort();
                break;
            }
            signals[i].addEventListener('abort', onAbort, { once: true });
        }
        return controller.signal;
        function onAbort() {
            controller.abort();
            for (let i = 0; i < signals.length; i++)
                signals[i].removeEventListener('abort', onAbort);
        }
    };
    // Note: вместо "createCountdownSignal" использовать нативный "AbortSignal.timeout".
    const noneAC = new AbortController();
    App.noneSignal = noneAC.signal;
    App.noneSignal.addEventListener = () => {
    };
    App.noneSignal.removeEventListener = () => {
    };
    App.noneSignal.dispatchEvent = () => true;
    const abortedAC = new AbortController();
    abortedAC.abort();
    App.abortedSignal = abortedAC.signal;
    App.abortedSignal.addEventListener = () => {
    };
    App.abortedSignal.removeEventListener = () => {
    };
    App.abortedSignal.dispatchEvent = () => true;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _VariantCancellationViewModel_minDate, _VariantCancellationViewModel_createCancellationRuleViewModel;
    /**
     * Модель для представления вариантов размещения.
     * Note: при изменении синхронизировать с содержимым C#-класса VariantCancellationViewModel.
     */
    class VariantCancellationViewModel {
        /**
         * Конструктор.
         * @param variantKey Ключ варианта.
         * @param cancellationPolicy Политика отмены.
         * @param available Предложение доступно для бронирования.
         * @param byRequest По запросу - пока используется только для экскурсий.
         */
        constructor(variantKey, cancellationPolicy, available = true, byRequest = false) {
            var _b;
            /**
             * Ключ варианта.
             */
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Модель для представления правил отмены в виде частично раскрашенной фразы.
             */
            Object.defineProperty(this, "coloredPhrase", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Правила отмены в виде списка.
             */
            Object.defineProperty(this, "cancellationInfoList", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Код политики отмены.
             */
            Object.defineProperty(this, "cancellationPolicyCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Доступность варианта размещения для бронирования.
             * Доступность проверяется на этапе проверки правил отмены - запроcа к сервисам.
             * Т.е. до проверки предложеине доступно.
             */
            Object.defineProperty(this, "available", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Код валюты, в которой рассчитаны суммы штрафов. Если отсутствует, то суммы указаны в валюте самого предложения.
             */
            // TODO: исправить, конфликтует из-за IHotelVariant.
            // currencyCode?: string;
            Object.defineProperty(this, "currencyCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.key = variantKey;
            // Если предложение недоступно, нет смысла пихать туда правила отмены - выводится "Недоступно".
            this.available = available;
            if (!available)
                return;
            // Если правила отмены нет, сразу выходим.
            if (cancellationPolicy === null || cancellationPolicy === void 0 ? void 0 : cancellationPolicy.code) {
                this.cancellationPolicyCode = cancellationPolicy.code;
                return;
            }
            if (!(cancellationPolicy === null || cancellationPolicy === void 0 ? void 0 : cancellationPolicy.rules) || cancellationPolicy.rules.length <= 0) {
                this.coloredPhrase = {
                    coloredMessage: 'Условия удержаний по запросу после оформления заказа',
                    isFree: false,
                };
                return;
            }
            // Если есть правила отмены, обнуляем код политики отмены, т.к. если его раз получили, больше он не меняется.
            // Проверяется он только в сервисах, когда запрашивается корзина у поставщиков при резервировании.
            this.cancellationPolicyCode = undefined;
            const cancellationRules = cancellationPolicy.rules;
            const minDate = __classPrivateFieldGet(_a, _a, "f", _VariantCancellationViewModel_minDate).getTime();
            const utcNow = App.XDate.utcNow();
            // Найдем ближайшее по дате просроченное штрафное правило
            let closestPenaltyRule = Enumerable.from(cancellationRules)
                .where(v => {
                const date = App.parseIsoDate(v.date).getTime();
                return (date === minDate || date <= utcNow) && v.penalty > 0;
            })
                .orderByDescending(v => v.date)
                .firstOrDefault();
            // Если null, значит просроченных нет, найдем актуальное
            // TODO: возможно, это неудачное решение, пока не охота переписывать. Если в предыдущем запросе null - значит, это бесплатная
            // отмена скорее всего и надо передать дату.
            if (closestPenaltyRule == null) {
                closestPenaltyRule = Enumerable.from(cancellationRules)
                    .orderBy(v => v.date)
                    .firstOrDefault(v => v.penalty > 0);
            }
            this.coloredPhrase = __classPrivateFieldGet(_a, _a, "m", _VariantCancellationViewModel_createCancellationRuleViewModel).call(_a, closestPenaltyRule, byRequest);
            // Найдем правила отмены кроме ближайшего
            const unClosestPenaltyRules = Enumerable.from(cancellationRules)
                .where(v => {
                const date = App.parseIsoDate(v.date).getTime();
                return (date !== minDate && date > utcNow) && v.penalty > 0;
            })
                .orderBy(v => v.date);
            // Сформируем итоговый список.
            // Сначала запихаем в него из правил не ближайших, если они есть
            this.cancellationInfoList = Enumerable.from(unClosestPenaltyRules)
                .select(v => ({
                date: `c ${App.formatTimezoneDate(v.date, 'cancellationDate')}`,
                price: v.penalty,
            }))
                .toArray();
            // Потом добавим в начало из ближайших
            // Если у нас есть в ближайших правилах правило с удержанием, надо так и написать словами, вместо даты "С"
            if (!this.coloredPhrase.isFree) {
                let message = this.coloredPhrase.coloredMessage;
                if (this.coloredPhrase.nonColoredMessage)
                    message += ` ${this.coloredPhrase.nonColoredMessage}`;
                this.cancellationInfoList.unshift({
                    date: message,
                    price: closestPenaltyRule === null || closestPenaltyRule === void 0 ? void 0 : closestPenaltyRule.penalty,
                });
            }
            // TODO: исправить, конфликтует из-за IHotelVariant.
            // this.currencyCode = cancellationPolicy.currencyCode;
            this.currencyCode = (_b = cancellationPolicy.currencyCode) !== null && _b !== void 0 ? _b : '';
        }
    }
    _a = VariantCancellationViewModel, _VariantCancellationViewModel_createCancellationRuleViewModel = function _VariantCancellationViewModel_createCancellationRuleViewModel(closestPenaltyRule, byRequest) {
        if (closestPenaltyRule == null) {
            return {
                coloredMessage: 'Отмена без удержаний',
                isFree: true,
            };
        }
        const utcNow = App.XDate.utcNow();
        const closestPenaltyRuleDate = App.parseIsoDate(closestPenaltyRule.date);
        if (byRequest && closestPenaltyRule != null && closestPenaltyRuleDate.getTime() <= utcNow) {
            return {
                coloredMessage: 'Согласно фактически понесенным расходам',
                isFree: false,
            };
        }
        if (closestPenaltyRuleDate.getTime() > utcNow) {
            return {
                coloredMessage: 'Отмена без удержаний',
                isFree: true,
                nonColoredMessage: App.formatTimezoneDate(closestPenaltyRuleDate, 'cancellationDate'),
            };
        }
        return {
            coloredMessage: 'Удержание',
            isFree: false,
            nonColoredMessage: 'с момента подтверждения',
            penalty: closestPenaltyRule.penalty,
        };
    };
    _VariantCancellationViewModel_minDate = { value: new Date(-62135605817000) };
    App.VariantCancellationViewModel = VariantCancellationViewModel;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _VariantsShowMoreComponent_options, _VariantsShowMoreComponent_isClosed, _VariantsShowMoreComponent_getHiddableItems;
    class VariantsShowMoreComponent {
        constructor(options) {
            _VariantsShowMoreComponent_options.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
            };
            __classPrivateFieldSet(this, _VariantsShowMoreComponent_options, Object.assign(defaults, options), "f");
            __classPrivateFieldGet(this, _VariantsShowMoreComponent_options, "f").root.on('change', '.js-variants-show-more-item input[type="radio"]', e => _a.update($(e.currentTarget)));
            __classPrivateFieldGet(this, _VariantsShowMoreComponent_options, "f").root.on('click', '.js-variants-show-more-link-show', e => _a.show($(e.currentTarget)));
            __classPrivateFieldGet(this, _VariantsShowMoreComponent_options, "f").root.on('click', '.js-variants-show-more-link-hide', e => _a.hide($(e.currentTarget)));
        }
        static update(target) {
            const container = target.hasClass('js-variants-show-more')
                ? target
                : target.closest('.js-variants-show-more');
            if (!__classPrivateFieldGet(_a, _a, "m", _VariantsShowMoreComponent_isClosed).call(_a, container))
                return;
            container.find('.js-variants-show-more-item')
                .has('input:checked')
                .slideDown();
            container.find('.js-variants-show-more-item')
                .has('input:not(:checked)')
                .slideUp();
        }
        static show(target) {
            const container = target.closest('.js-variants-show-more');
            __classPrivateFieldGet(this, _a, "m", _VariantsShowMoreComponent_getHiddableItems).call(this, container).slideDown();
            container.find('.js-variants-show-more-link-show')
                .removeClass('_folded')
                .addClass('_unfolded')
                .slideUp();
            container.find('.js-variants-show-more-link-hide')
                .removeClass('_unfolded')
                .addClass('_folded')
                .slideDown();
            container.trigger("pw:show" /* Events.Show */, [{ target: container }]);
        }
        static hide(target) {
            const container = target.closest('.js-variants-show-more');
            __classPrivateFieldGet(this, _a, "m", _VariantsShowMoreComponent_getHiddableItems).call(this, container).slideUp();
            container.find('.js-variants-show-more-link-show')
                .removeClass('_unfolded')
                .addClass('_folded')
                .slideDown();
            container.find('.js-variants-show-more-link-hide')
                .removeClass('_folded')
                .addClass('_unfolded')
                .slideUp();
            container.trigger("pw:hide" /* Events.Hide */, [{ target: container }]);
        }
        static toggle(target, show) {
            if (show)
                _a.show(target);
            else
                _a.hide(target);
        }
    }
    _a = VariantsShowMoreComponent, _VariantsShowMoreComponent_options = new WeakMap(), _VariantsShowMoreComponent_isClosed = function _VariantsShowMoreComponent_isClosed(container) {
        const showLinks = container.find('.js-variants-show-more-link-show');
        if (showLinks.length > 0 && showLinks.hasClass('_folded'))
            return true;
        const hideLinks = container.find('.js-variants-show-more-link-hide');
        if (hideLinks.length > 0 && hideLinks.hasClass('_unfolded'))
            return true;
        return false;
    }, _VariantsShowMoreComponent_getHiddableItems = function _VariantsShowMoreComponent_getHiddableItems(container) {
        const items = container.find('.js-variants-show-more-item');
        return items.has('input:not(:checked)').add(items.not(':has(input)'));
    };
    App.VariantsShowMoreComponent = VariantsShowMoreComponent;
})(App || (App = {}));
var App;
(function (App) {
    class XDate extends Date {
        static today() {
            const now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate());
        }
        static utcToday() {
            const now = new Date();
            return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        }
        static current() {
            return new Date();
        }
        static utcCurrent() {
            const now = new Date();
            return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
        }
        static utcNow() {
            return XDate.utcCurrent().getTime();
        }
        toDate() {
            return new Date(this.getTime());
        }
        equals(another) {
            return this.getTime() === another.getTime();
        }
        trimTime() {
            return new XDate(new Date(this.getFullYear(), this.getMonth(), this.getDate()));
        }
        addMilliseconds(value) {
            return new XDate(new Date(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds() + value));
        }
        addSeconds(value) {
            return new XDate(new Date(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds() + value, this.getMilliseconds()));
        }
        addMinutes(value) {
            return new XDate(new Date(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes() + value, this.getSeconds(), this.getMilliseconds()));
        }
        addHours(value) {
            return new XDate(new Date(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours() + value, this.getMinutes(), this.getSeconds(), this.getMilliseconds()));
        }
        addDays(value) {
            return new XDate(new Date(this.getFullYear(), this.getMonth(), this.getDate() + value, this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds()));
        }
        addMonths(value) {
            return new XDate(new Date(this.getFullYear(), this.getMonth() + value, this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds()));
        }
        addYears(value) {
            return new XDate(new Date(this.getFullYear() + value, this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds()));
        }
    }
    App.XDate = XDate;
})(App || (App = {}));
var App;
(function (App) {
    var _BookmarkDomElements_labelWrapper, _BookmarkDomElements_bookmarkLabel, _BookmarkDomElements_bookmarkLabelText;
    /**
     * Класс для объявления и предоставления доступа к DOM элементам для добавления в избранное
     * TODO: вынесли некоторые элементы по аналогии со сравнением.
     * TODO: Когда будем делать добавление в избранное, возможно, надо будет привести сравнение в избранное к единым интерфейсам
     */
    class BookmarkDomElements {
        /**
         * Ярлык 'Избранное' (на странице с количеством в избранном)
         * @returns {}
         */
        get bookmarkLabel() {
            return __classPrivateFieldGet(this, _BookmarkDomElements_bookmarkLabel, "f");
        }
        /**
         * Текст в ярлыке 'Избранное'
         * @returns {}
         */
        get bookmarkLabelText() {
            return __classPrivateFieldGet(this, _BookmarkDomElements_bookmarkLabelText, "f");
        }
        constructor() {
            _BookmarkDomElements_labelWrapper.set(this, void 0);
            _BookmarkDomElements_bookmarkLabel.set(this, void 0);
            _BookmarkDomElements_bookmarkLabelText.set(this, void 0);
            __classPrivateFieldSet(this, _BookmarkDomElements_labelWrapper, $('.main-block__labels-block__wrap'), "f");
            __classPrivateFieldSet(this, _BookmarkDomElements_bookmarkLabel, $('.js-bookmark-label', __classPrivateFieldGet(this, _BookmarkDomElements_labelWrapper, "f")), "f");
            __classPrivateFieldSet(this, _BookmarkDomElements_bookmarkLabelText, $('.js-bookmark-text', __classPrivateFieldGet(this, _BookmarkDomElements_bookmarkLabel, "f")), "f");
        }
        /**
         * Инициализирует ярлычки 'Добавить в избранное'
         * Надо вызывать после каждой отрисовки элементов
         */
        bookmarkButtonsInitialize(root) {
            return $('.js-bookmark-btn', root);
        }
    }
    _BookmarkDomElements_labelWrapper = new WeakMap(), _BookmarkDomElements_bookmarkLabel = new WeakMap(), _BookmarkDomElements_bookmarkLabelText = new WeakMap();
    App.BookmarkDomElements = BookmarkDomElements;
})(App || (App = {}));
var App;
(function (App) {
    var _CompareAndBookmarkBinder_instances, _CompareAndBookmarkBinder_root, _CompareAndBookmarkBinder_compareLabel, _CompareAndBookmarkBinder_compareLabelText, _CompareAndBookmarkBinder_bookmarkLabel, _CompareAndBookmarkBinder_bookmarkLabelText, _CompareAndBookmarkBinder_compareButtons, _CompareAndBookmarkBinder_bookmarkButtons, _CompareAndBookmarkBinder_targetElementContainers, _CompareAndBookmarkBinder_compareDomElements, _CompareAndBookmarkBinder_bookmarkDomElements, _CompareAndBookmarkBinder_maxHotelsToCompare, _CompareAndBookmarkBinder_execute, _CompareAndBookmarkBinder_onLabelBtnClick;
    /** Класс для привязки обработки клика на ярлычки добавления в сравнение и в избранное */
    class CompareAndBookmarkBinder {
        constructor(root, maxHotelsToCompare) {
            _CompareAndBookmarkBinder_instances.add(this);
            _CompareAndBookmarkBinder_root.set(this, void 0);
            _CompareAndBookmarkBinder_compareLabel.set(this, void 0);
            _CompareAndBookmarkBinder_compareLabelText.set(this, void 0);
            _CompareAndBookmarkBinder_bookmarkLabel.set(this, void 0);
            _CompareAndBookmarkBinder_bookmarkLabelText.set(this, void 0);
            _CompareAndBookmarkBinder_compareButtons.set(this, void 0);
            _CompareAndBookmarkBinder_bookmarkButtons.set(this, void 0);
            _CompareAndBookmarkBinder_targetElementContainers.set(this, void 0);
            _CompareAndBookmarkBinder_compareDomElements.set(this, void 0);
            _CompareAndBookmarkBinder_bookmarkDomElements.set(this, void 0);
            // TODO: не уверенна, что надо здесь управлять максимальным количеством отелей к сравнению
            _CompareAndBookmarkBinder_maxHotelsToCompare.set(this, void 0);
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_maxHotelsToCompare, maxHotelsToCompare, "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_root, root, "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_compareDomElements, new App.CompareDomElements(), "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_bookmarkDomElements, new App.BookmarkDomElements(), "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_compareLabel, __classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareDomElements, "f").compareLabel, "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_compareLabelText, __classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareDomElements, "f").compareLabelText, "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_bookmarkLabel, __classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkDomElements, "f").bookmarkLabel, "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_bookmarkLabelText, __classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkDomElements, "f").bookmarkLabelText, "f");
        }
        bind(targetElementContainers) {
            if (!targetElementContainers)
                throw new Error('targetElementContainers is empty');
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_targetElementContainers, targetElementContainers, "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_compareButtons, __classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareDomElements, "f").compareButtonsInitialize(__classPrivateFieldGet(this, _CompareAndBookmarkBinder_root, "f")), "f");
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_bookmarkButtons, __classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkDomElements, "f").bookmarkButtonsInitialize(__classPrivateFieldGet(this, _CompareAndBookmarkBinder_root, "f")), "f");
            // Переключаем иконку 'К сравнению'
            __classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareButtons, "f").on('click', e => __classPrivateFieldGet(this, _CompareAndBookmarkBinder_instances, "m", _CompareAndBookmarkBinder_onLabelBtnClick).call(this, e));
            // Переключаем иконку 'В избранное'
            __classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkButtons, "f").on('click', e => __classPrivateFieldGet(this, _CompareAndBookmarkBinder_instances, "m", _CompareAndBookmarkBinder_onLabelBtnClick).call(this, e));
        }
        unbind() {
            if (__classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareButtons, "f"))
                __classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareButtons, "f").off('click', e => __classPrivateFieldGet(this, _CompareAndBookmarkBinder_instances, "m", _CompareAndBookmarkBinder_onLabelBtnClick).call(this, e));
            if (__classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkButtons, "f"))
                __classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkButtons, "f").off('click', e => __classPrivateFieldGet(this, _CompareAndBookmarkBinder_instances, "m", _CompareAndBookmarkBinder_onLabelBtnClick).call(this, e));
            __classPrivateFieldSet(this, _CompareAndBookmarkBinder_targetElementContainers, undefined, "f");
        }
    }
    _CompareAndBookmarkBinder_root = new WeakMap(), _CompareAndBookmarkBinder_compareLabel = new WeakMap(), _CompareAndBookmarkBinder_compareLabelText = new WeakMap(), _CompareAndBookmarkBinder_bookmarkLabel = new WeakMap(), _CompareAndBookmarkBinder_bookmarkLabelText = new WeakMap(), _CompareAndBookmarkBinder_compareButtons = new WeakMap(), _CompareAndBookmarkBinder_bookmarkButtons = new WeakMap(), _CompareAndBookmarkBinder_targetElementContainers = new WeakMap(), _CompareAndBookmarkBinder_compareDomElements = new WeakMap(), _CompareAndBookmarkBinder_bookmarkDomElements = new WeakMap(), _CompareAndBookmarkBinder_maxHotelsToCompare = new WeakMap(), _CompareAndBookmarkBinder_instances = new WeakSet(), _CompareAndBookmarkBinder_execute = function _CompareAndBookmarkBinder_execute(targetElement) {
        if (!__classPrivateFieldGet(this, _CompareAndBookmarkBinder_targetElementContainers, "f"))
            throw new Error('You have to bind onLabelBtnClick event first!');
        const id = targetElement.closest('.js-tour-item').attr('id');
        if (!id)
            return;
        const isCompare = targetElement.hasClass('js-compare-btn');
        let cssClass;
        let el;
        let textEl;
        if (isCompare) {
            // Если 'К сравнению'
            cssClass = '.js-compare-btn';
            el = __classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareLabel, "f");
            textEl = __classPrivateFieldGet(this, _CompareAndBookmarkBinder_compareLabelText, "f");
            // Проверить, что не превышено допустимое количество отелей для сравнения
            const hotelsToCompare = parseInt(textEl.text(), 10);
            if (hotelsToCompare >= __classPrivateFieldGet(this, _CompareAndBookmarkBinder_maxHotelsToCompare, "f") && !targetElement.hasClass('_active')) {
                const popup = new App.Popup();
                popup.show({
                    content: `Можно добавить не более ${__classPrivateFieldGet(this, _CompareAndBookmarkBinder_maxHotelsToCompare, "f")} ${App.pluralRu(__classPrivateFieldGet(this, _CompareAndBookmarkBinder_maxHotelsToCompare, "f"), 'отеля', 'отелей')} к сравнению`,
                });
                return;
            }
        }
        else {
            // Если 'В избранное'
            cssClass = '.js-bookmark-btn';
            el = __classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkLabel, "f");
            textEl = __classPrivateFieldGet(this, _CompareAndBookmarkBinder_bookmarkLabelText, "f");
            __classPrivateFieldGet(this, _CompareAndBookmarkBinder_root, "f").trigger("to-bookmarks:click" /* Events.ToBookmarksClick */, { targetId: id });
        }
        if (targetElement.hasClass('_active')) {
            __classPrivateFieldGet(this, _CompareAndBookmarkBinder_targetElementContainers, "f").forEach(container => {
                container.filter(`[id="${id}"]`).find(cssClass).removeClass('_active');
            });
            textEl.text(parseInt(textEl.text(), 10) - 1);
            if (parseInt(textEl.text(), 10) === 0)
                el.addClass('_disabled');
        }
        else {
            __classPrivateFieldGet(this, _CompareAndBookmarkBinder_targetElementContainers, "f").forEach(container => {
                container.filter(`[id="${id}"]`).find(cssClass).addClass('_active');
            });
            textEl.text(parseInt(textEl.text(), 10) + 1);
            el.removeClass('_disabled');
        }
        // TODO: пока так. по крайней мере выделить функции для сравнения и избранного - не пихать все в одну
        __classPrivateFieldGet(this, _CompareAndBookmarkBinder_root, "f").trigger("to-compare:click" /* Events.ToCompareClick */, { targetId: id });
    }, _CompareAndBookmarkBinder_onLabelBtnClick = function _CompareAndBookmarkBinder_onLabelBtnClick(e) {
        e.preventDefault();
        e.stopPropagation();
        __classPrivateFieldGet(this, _CompareAndBookmarkBinder_instances, "m", _CompareAndBookmarkBinder_execute).call(this, $(e.currentTarget));
    };
    App.CompareAndBookmarkBinder = CompareAndBookmarkBinder;
})(App || (App = {}));
var App;
(function (App) {
    var _CompareDomElements_labelWrapper, _CompareDomElements_compareLabel, _CompareDomElements_compareLabelText;
    /**
     * Класс для объявления и предоставления доступа к DOM элементам для сравнения
     */
    class CompareDomElements {
        /**
         * Ярлык 'Сравнить' (на странице с количеством в сравнении)
         * @returns {}
         */
        get compareLabel() {
            return __classPrivateFieldGet(this, _CompareDomElements_compareLabel, "f");
        }
        /**
         * Текст в ярлыке 'Сравнить'
         * @returns {}
         */
        get compareLabelText() {
            return __classPrivateFieldGet(this, _CompareDomElements_compareLabelText, "f");
        }
        /**
         * Элемент для ссылки в ярлыке 'Сравнить'
         */
        get compareLink() {
            return __classPrivateFieldGet(this, _CompareDomElements_compareLabel, "f").closest('a');
        }
        constructor() {
            // #root: JQuery;
            _CompareDomElements_labelWrapper.set(this, void 0);
            _CompareDomElements_compareLabel.set(this, void 0);
            _CompareDomElements_compareLabelText.set(this, void 0);
            __classPrivateFieldSet(this, _CompareDomElements_labelWrapper, $('.main-block__labels-block__wrap'), "f");
            __classPrivateFieldSet(this, _CompareDomElements_compareLabel, $('.js-compare-label', __classPrivateFieldGet(this, _CompareDomElements_labelWrapper, "f")), "f");
            __classPrivateFieldSet(this, _CompareDomElements_compareLabelText, $('.js-compare-text', __classPrivateFieldGet(this, _CompareDomElements_compareLabel, "f")), "f");
        }
        /**
         * Инициализирует ярлычки 'Добавить к сравнению'
         * Надо вызывать после каждой отрисовки элементов
         */
        compareButtonsInitialize(root) {
            return $('.js-compare-btn', root);
        }
        /**
         * Сбрасывает кнопку 'Сравнить' и прячет ее
         * Обнуляет цЫфры
         */
        resetCompareLabel() {
            __classPrivateFieldGet(this, _CompareDomElements_compareLabel, "f").addClass('_disabled');
            __classPrivateFieldGet(this, _CompareDomElements_compareLabelText, "f").text(0);
        }
        /**
         * Устанавливает ссылку на кнопке 'Сравнить', цЫфру и показывает ее
         */
        setCompareLabel(link, count) {
            this.compareLink.attr('href', link).attr('target', '_blank');
            __classPrivateFieldGet(this, _CompareDomElements_compareLabelText, "f").text(count);
            __classPrivateFieldGet(this, _CompareDomElements_compareLabel, "f").removeClass('_disabled');
        }
    }
    _CompareDomElements_labelWrapper = new WeakMap(), _CompareDomElements_compareLabel = new WeakMap(), _CompareDomElements_compareLabelText = new WeakMap();
    App.CompareDomElements = CompareDomElements;
})(App || (App = {}));
var App;
(function (App) {
    var _CompareTempName_compareDom;
    /**
     * Класс для работы со сравнением
     * (Пока только отелей)
     * TODO: переименовать класс, когда определюсь, что конкретно он делает
     */
    class CompareTempName {
        constructor(compareDom) {
            _CompareTempName_compareDom.set(this, void 0);
            __classPrivateFieldSet(this, _CompareTempName_compareDom, compareDom, "f");
        }
        /**
         * Получить id отелей в сравнении из куки
         */
        getCompareHotelIdsFromCookie() {
            const hotelsCookieRaw = App.Cookie.get("hotelCompare" /* KnownCookie.HotelCompare */);
            let hotelsFromCookie = new Array();
            if (hotelsCookieRaw)
                hotelsFromCookie = decodeURIComponent(decodeURI(hotelsCookieRaw)).split(',');
            return hotelsFromCookie;
        }
        /**
         * Ставит отметку 'к сравнению' отелям приложения
         * @param hotelToCompareIds - список id отелей, которые надо отметить
         * @return возвращает массив id отелей, которые есть на странице поиска и которые добавлены в сравнение
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        markAppHotelsToCompare(hotelToCompareIds, applicationHotelsData, hotelsToCompare) {
            // отметить в найденных отелях признак 'добавлен к сравнению'
            // Проверить, какие отели из куки есть в приложении
            // Зафигачить их в переменную 'отели для сравнения'
            applicationHotelsData.forEach(appHotel => {
                appHotel.toCompare = false;
            });
            const result = new Array();
            hotelToCompareIds
                .map(v => parseInt(v, 10))
                .forEach(fromCookie => {
                const hotel = applicationHotelsData.find(appHotel => appHotel.key === fromCookie);
                if (hotel) {
                    hotel.toCompare = true;
                    result.push(hotel.key.toString());
                }
            });
            return result;
        }
        /* eslint-enable @typescript-eslint/no-unused-vars */
        markAppHotelInfoToCompare(hotelToCompareIds, applicationHotelInfo) {
            const compareId = hotelToCompareIds.find(id => id === applicationHotelInfo.key.toString());
            if (compareId)
                applicationHotelInfo.toCompare = true;
            else
                applicationHotelInfo.toCompare = false;
        }
        /**
         * Устанавливает урл значку 'В сравнении столько-то отелей' и количество
         */
        setCompareLabel(currentUrlParameters, hotelsToCompare) {
            // Если нет номеров отелей для сравнения, очищаем урл и выходим
            if (hotelsToCompare.length === 0) {
                __classPrivateFieldGet(this, _CompareTempName_compareDom, "f").resetCompareLabel();
                return;
            }
            // Сформировать ссылку
            const newCompareLink = this.makeCompareLink(currentUrlParameters, hotelsToCompare);
            // Вставить ее в label 'к сравнению'
            __classPrivateFieldGet(this, _CompareTempName_compareDom, "f").setCompareLabel(newCompareLink, hotelsToCompare.length);
        }
        /**
         * Сформировать ссылку на отели в сравнении
         */
        makeCompareLink(currentUrlParameters, hotelIds) {
            let compareUrlParameters = hotelIds.length > 0
                ? [{ name: App.HotelUrlParameters.hotels, values: hotelIds }]
                : [];
            compareUrlParameters = compareUrlParameters.concat(this.findComparePageUrlParametersInCurrent(currentUrlParameters));
            return App.app.url.route(App.HotelPageUrls.Compare, compareUrlParameters);
        }
        /**
         * Ищет параметры урла, необходимые для страницы сравнения, в текущих параметрах
         * @param currentUrlParameters - текущие параметры, в которых надо искать
         */
        findComparePageUrlParametersInCurrent(currentUrlParameters) {
            const compareUrlParameters = new Array();
            currentUrlParameters.forEach(parameter => {
                if (parameter.name === App.HotelUrlParameters.checkin
                    || parameter.name === App.HotelUrlParameters.checkout
                    || parameter.name === App.HotelUrlParameters.rooms)
                    compareUrlParameters.push(parameter);
            });
            return compareUrlParameters;
        }
    }
    _CompareTempName_compareDom = new WeakMap();
    App.CompareTempName = CompareTempName;
})(App || (App = {}));
var App;
(function (App) {
    class FilterBlockBase {
        constructor(options) {
            Object.defineProperty(this, "options", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "name", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.options = options;
            const { root } = this.options;
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            if (!this.root.length)
                return;
            this.name = this.root.attr('data-name') || null;
        }
        /**
         * Сброс значения элемента управления в default-состояние.
        */
        reset() {
        }
        /**
         * Полная очистка состояния элемента управления.
        */
        clear() {
        }
        isValueSet() {
            return true;
        }
    }
    App.FilterBlockBase = FilterBlockBase;
})(App || (App = {}));
/// <reference path='FilterBlockBase.ts' />
var App;
(function (App) {
    var _FilterAutocompleteBlock_instances, _FilterAutocompleteBlock_pointInput, _FilterAutocompleteBlock_pointCode, _FilterAutocompleteBlock_pointType, _FilterAutocompleteBlock_pointPlaceholder, _FilterAutocompleteBlock_findUrl, _FilterAutocompleteBlock_addParams, _FilterAutocompleteBlock_searchIcon, _FilterAutocompleteBlock_clearLocation, _FilterAutocompleteBlock_loader, _FilterAutocompleteBlock_getSearchData, _FilterAutocompleteBlock_onClearLocation, _FilterAutocompleteBlock_toggleInputIcons;
    class FilterAutocompleteBlock extends App.FilterBlockBase {
        constructor(options) {
            super(Object.assign(Object.assign({}, FilterAutocompleteBlock.s_defaults), options));
            _FilterAutocompleteBlock_instances.add(this);
            Object.defineProperty(this, "filterResults", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pointAutocomplete", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _FilterAutocompleteBlock_pointInput.set(this, void 0);
            _FilterAutocompleteBlock_pointCode.set(this, void 0);
            _FilterAutocompleteBlock_pointType.set(this, void 0);
            _FilterAutocompleteBlock_pointPlaceholder.set(this, void 0);
            _FilterAutocompleteBlock_findUrl.set(this, void 0);
            // Для передачи доп.параметров, передаются все значения, найденные по переданным id:
            // [data-addParams="Pickup_Key,Pickup_Type"] => input#Pickup_Key, input#Pickup_Type
            _FilterAutocompleteBlock_addParams.set(this, void 0);
            _FilterAutocompleteBlock_searchIcon.set(this, void 0);
            _FilterAutocompleteBlock_clearLocation.set(this, void 0);
            _FilterAutocompleteBlock_loader.set(this, void 0);
            if (!this.root.length)
                return;
            this.filterResults = $('.js-point-results', this.root);
            this.pointAutocomplete = $('.js-point-autocomplete', this.root);
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_pointInput, this.root.find('.js-point-select-input'), "f");
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_pointCode, this.root.find('.js-point-code'), "f");
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_pointType, this.root.find('.js-point-type'), "f");
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_pointPlaceholder, this.root.find('.js-point-placeholder'), "f");
            const url = this.root.attr('data-url');
            if (!url)
                return;
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_findUrl, url, "f");
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_addParams, this.root.attr('data-addparams'), "f");
            const scrollerWrap = $('.js-scroller-wrap', this.root);
            // Стилизуем скролл
            const scroll = scrollerWrap.baron({
                scroller: '.js-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            const pointInput = $('.js-point-select-input', this.root);
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_searchIcon, $('.js-search-icon', this.root), "f");
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_clearLocation, $('.js-clear-location', this.root), "f");
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_clearLocation, "f").on('click', () => __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_onClearLocation).call(this));
            __classPrivateFieldSet(this, _FilterAutocompleteBlock_loader, $('.js-loader', this.root), "f");
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_toggleInputIcons).call(this, __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").val() === '' && __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointCode, "f").val() === '0');
            // TODO: пример уменьшение кол-ва запросов к серверу за счет их объединения.
            // jqElement.on('keyup', $.debounce(500, () => this.onAutocomleteType()));
            pointInput.autocomplete({
                appendTo: this.filterResults,
                minLength: this.options.minLength,
                source: (request, response) => {
                    /* eslint-disable @typescript-eslint/no-floating-promises */
                    $.ajax({
                        url: __classPrivateFieldGet(this, _FilterAutocompleteBlock_findUrl, "f"),
                        method: 'GET',
                        data: __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_getSearchData).call(this, request.term),
                        beforeSend: () => {
                            if (__classPrivateFieldGet(this, _FilterAutocompleteBlock_loader, "f").length > 0)
                                __classPrivateFieldGet(this, _FilterAutocompleteBlock_loader, "f").show();
                        },
                        success: (data) => {
                            response(data.data.items.map(item => ({
                                key: item.key,
                                name: item.name,
                                typeCode: item.typeCode,
                                // TODO: перенести на сервер (в ХП FindPointsXxx).
                                typeName: App.isEnglishLanguage() ? item.typeCode : item.typeName,
                            })));
                        },
                    });
                    /* eslint-enable @typescript-eslint/no-floating-promises */
                },
                response: (_, ui) => {
                    if (ui.content.length === 0) {
                        __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointCode, "f").val('');
                        __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointType, "f").val('');
                        $('.js-noSearchData', this.root).fadeIn('slow').delay(5000).fadeOut('slow');
                    }
                    if (__classPrivateFieldGet(this, _FilterAutocompleteBlock_loader, "f").length > 0)
                        __classPrivateFieldGet(this, _FilterAutocompleteBlock_loader, "f").hide();
                    this.pointAutocomplete.show();
                    scroll.update();
                },
                select: (_, ui) => {
                    // убираем запятые, чтобы можно было продолжить поиск
                    // const value = ui.item.value.replace(/,/g, ' ').replace(/ {2,}/g, ' ');
                    // this.#pointInput.val(value);
                    __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").val(ui.item.name);
                    // this.#pointInput.attr('value', value);
                    __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointCode, "f").val(ui.item.key);
                    __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointType, "f").val(ui.item.typeCode);
                    __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_toggleInputIcons).call(this, false);
                    this.root.trigger("autocompleteOption:click" /* Events.AutocompleteOptionClick */);
                    __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").trigger('blur');
                    return false;
                },
                close: () => {
                    this.pointAutocomplete.hide();
                },
            });
        }
        reset() {
            super.reset();
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").val('');
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").trigger('focus');
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointCode, "f").val('');
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointType, "f").val('');
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointPlaceholder, "f").html('');
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_toggleInputIcons).call(this, true);
        }
        clear() {
            super.clear();
            this.reset();
        }
        setValue(name, key, typeCode) {
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").val(name);
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointCode, "f").val(key);
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointType, "f").val(typeCode);
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_toggleInputIcons).call(this, name === '' && key === 0);
        }
        setValueStr(name, key, typeCode) {
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").val(name);
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointCode, "f").val(key.toString());
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointType, "f").val(typeCode);
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_toggleInputIcons).call(this, name === '' && key === '');
        }
        switchInputIcons() {
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_instances, "m", _FilterAutocompleteBlock_toggleInputIcons).call(this, __classPrivateFieldGet(this, _FilterAutocompleteBlock_pointInput, "f").val() === '');
        }
    }
    _FilterAutocompleteBlock_pointInput = new WeakMap(), _FilterAutocompleteBlock_pointCode = new WeakMap(), _FilterAutocompleteBlock_pointType = new WeakMap(), _FilterAutocompleteBlock_pointPlaceholder = new WeakMap(), _FilterAutocompleteBlock_findUrl = new WeakMap(), _FilterAutocompleteBlock_addParams = new WeakMap(), _FilterAutocompleteBlock_searchIcon = new WeakMap(), _FilterAutocompleteBlock_clearLocation = new WeakMap(), _FilterAutocompleteBlock_loader = new WeakMap(), _FilterAutocompleteBlock_instances = new WeakSet(), _FilterAutocompleteBlock_getSearchData = function _FilterAutocompleteBlock_getSearchData(searchString) {
        const data = {};
        data.search = searchString;
        if (__classPrivateFieldGet(this, _FilterAutocompleteBlock_addParams, "f")) {
            __classPrivateFieldGet(this, _FilterAutocompleteBlock_addParams, "f").split(',').forEach(id => {
                const value = $(`#${id}`).valString();
                if (value) {
                    // TODO: изменить, пока так, чтобы отправить на сертификацию
                    const position = id.search('-');
                    const name = position >= 0 ? id.slice(position + 1) : id;
                    // TODO: изменить, пока так, чтобы отправить на сертификацию
                    data[name.toLowerCase().replace('_', '')] = value;
                }
            });
        }
        return data;
    }, _FilterAutocompleteBlock_onClearLocation = function _FilterAutocompleteBlock_onClearLocation() {
        this.clear();
        this.root.trigger("autocompleteClearLocaton" /* Events.AutocompleteClearLocation */);
    }, _FilterAutocompleteBlock_toggleInputIcons = function _FilterAutocompleteBlock_toggleInputIcons(clear) {
        __classPrivateFieldGet(this, _FilterAutocompleteBlock_searchIcon, "f").toggle(clear);
        __classPrivateFieldGet(this, _FilterAutocompleteBlock_clearLocation, "f").toggle(!clear);
    };
    Object.defineProperty(FilterAutocompleteBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-filter-autocomplete-block, .js-form-autocomplete-block',
            minLength: 3,
        }
    });
    App.FilterAutocompleteBlock = FilterAutocompleteBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterDateBlock_instances, _FilterDateBlock_calendar, _FilterDateBlock_validateValue, _FilterDateBlock_getDefaultDate;
    class FilterDateBlock extends App.FilterBlockBase {
        constructor(options) {
            super(Object.assign(Object.assign({}, FilterDateBlock.s_defaults), options));
            _FilterDateBlock_instances.add(this);
            _FilterDateBlock_calendar.set(this, void 0);
            if (!this.root.length)
                return;
            const datepickerOptions = {
                constrainInput: true,
                onSelect: (_, inst) => {
                    const date = __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").datepicker('getDate');
                    __classPrivateFieldGet(this, _FilterDateBlock_instances, "m", _FilterDateBlock_validateValue).call(this, date);
                    // Note: при наличии onSelect-обработчика, событие 'change' на input не инициируется!
                    inst.input.trigger('change');
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                },
                minDate: this.options.minDate,
                maxDate: this.options.maxDate,
            };
            if (this.options.changeMonthYear) {
                datepickerOptions.changeYear = true;
                datepickerOptions.changeMonth = true;
                if (this.options.minDate && this.options.maxDate)
                    datepickerOptions.yearRange = `${this.options.minDate.getFullYear()}:${this.options.maxDate.getFullYear()}`;
            }
            __classPrivateFieldSet(this, _FilterDateBlock_calendar, $('.js-filter-date, .js-form-date', this.root), "f");
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f")
                .attr('autocomplete', 'off')
                .inputmask('date');
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").datepicker(datepickerOptions);
            const dateIcon = $('.js-filter-date-icon, .js-form-date-icon', this.root);
            dateIcon.on('click', () => {
                __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").trigger('focus');
            });
        }
        reset() {
            super.reset();
            this.setValue(__classPrivateFieldGet(this, _FilterDateBlock_instances, "m", _FilterDateBlock_getDefaultDate).call(this));
        }
        clear() {
            super.clear();
            this.reset();
        }
        getValue() {
            return __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").datepicker('getDate');
        }
        setValue(value) {
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").trigger('focusin');
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").datepicker('setDate', value);
            __classPrivateFieldGet(this, _FilterDateBlock_instances, "m", _FilterDateBlock_validateValue).call(this, value);
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").trigger('focusout');
        }
        /**
         * Установка новых настроек.
         * @param value
         */
        setOptions(value) {
            this.options = Object.assign(Object.assign({}, this.options), value);
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").datepicker('option', 'minDate', this.options.minDate);
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").datepicker('option', 'maxDate', this.options.maxDate);
        }
    }
    _FilterDateBlock_calendar = new WeakMap(), _FilterDateBlock_instances = new WeakSet(), _FilterDateBlock_validateValue = function _FilterDateBlock_validateValue(value) {
        const minValue = this.options.minDate;
        const maxValue = this.options.maxDate;
        if (value > minValue && value < maxValue)
            __classPrivateFieldGet(this, _FilterDateBlock_calendar, "f").datepicker('setDate', value);
    }, _FilterDateBlock_getDefaultDate = function _FilterDateBlock_getDefaultDate() {
        var _a;
        return App.addDays(new Date(), (_a = this.options.defaultDateShift) !== null && _a !== void 0 ? _a : 0);
    };
    Object.defineProperty(FilterDateBlock, "yearRangeLeft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: -110
    });
    Object.defineProperty(FilterDateBlock, "yearRangeRight", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(FilterDateBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-filter-date-block, .js-form-date-block',
            minDate: App.addDays(new Date(), FilterDateBlock.yearRangeLeft * 365),
            maxDate: App.addDays(new Date(), FilterDateBlock.yearRangeRight * 365),
            changeMonthYear: false,
        }
    });
    App.FilterDateBlock = FilterDateBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterDatesBlock_instances, _a, _FilterDatesBlock_s_defaults, _FilterDatesBlock_calendarFrom, _FilterDatesBlock_calendarTo, _FilterDatesBlock_validateOptions, _FilterDatesBlock_getDefaultDateFrom, _FilterDatesBlock_getDefaultDateTo;
    class FilterDatesBlock extends App.FilterBlockBase {
        constructor(options) {
            var _b, _c, _d, _e;
            super(Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _FilterDatesBlock_s_defaults)), options));
            _FilterDatesBlock_instances.add(this);
            _FilterDatesBlock_calendarFrom.set(this, void 0);
            _FilterDatesBlock_calendarTo.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldGet(_a, _a, "m", _FilterDatesBlock_validateOptions).call(_a, this.options);
            __classPrivateFieldSet(this, _FilterDatesBlock_calendarFrom, $('.js-filter-date-from, .js-form-date-from', this.root), "f");
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f")
                .attr('autocomplete', 'off')
                .inputmask('date');
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f")
                .datepicker({
                minDate: (_b = this.options.minDateFrom) !== null && _b !== void 0 ? _b : this.options.minDateFromShift,
                maxDate: (_c = this.options.maxDateFrom) !== null && _c !== void 0 ? _c : this.options.maxDateFromShift,
                constrainInput: true,
                onSelect: (dateText, inst) => {
                    const prevValue = $.datepicker.parseDate(__classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('option', 'dateFormat'), inst.lastVal);
                    const valueTo = __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('getDate');
                    const value = __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('getDate');
                    if (this.options.preserveDatesOffset && valueTo && prevValue) {
                        const diffDays = Math.ceil((valueTo.getTime() - prevValue.getTime()) / App.millisecondsPerDay);
                        __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('setDate', App.addDays(value, diffDays));
                    }
                    // Note: при наличии onSelect-обработчика, событие 'change' на input не инициируется!
                    inst.input.trigger('change');
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                },
            })
                .on('change', e => {
                const value = $.datepicker.parseDate(__classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('option', 'dateFormat'), $(e.currentTarget).valString());
                this.setFromValue(value);
            });
            __classPrivateFieldSet(this, _FilterDatesBlock_calendarTo, $('.js-filter-date-to, .js-form-date-to', this.root), "f");
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f")
                .attr('autocomplete', 'off')
                .inputmask('date');
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f")
                .datepicker({
                minDate: this.options.minDateTo,
                maxDate: this.options.maxDateTo,
                constrainInput: true,
                onSelect: (dateText, inst) => {
                    // Note: при наличии onSelect-обработчика, событие 'change' на input не инициируется!
                    inst.input.trigger('change');
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                },
            })
                .on('change', e => {
                const value = $.datepicker.parseDate(__classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('option', 'dateFormat'), $(e.currentTarget).valString());
                this.setToValue(value);
            });
            if (!this.options.keepEmpty) {
                const dateFrom = (_d = __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('getDate')) !== null && _d !== void 0 ? _d : __classPrivateFieldGet(this, _FilterDatesBlock_instances, "m", _FilterDatesBlock_getDefaultDateFrom).call(this);
                const dateTo = (_e = __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('getDate')) !== null && _e !== void 0 ? _e : __classPrivateFieldGet(this, _FilterDatesBlock_instances, "m", _FilterDatesBlock_getDefaultDateTo).call(this, dateFrom);
                this.setValues(dateFrom, dateTo);
            }
            const dateFromIcon = $('.js-filter-date-from-icon, .js-form-date-from-icon', this.root);
            dateFromIcon.on('click', () => {
                __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").trigger('focus');
            });
            const dateToIcon = $('.js-filter-date-to-icon, .js-form-date-to-icon', this.root);
            dateToIcon.on('click', () => {
                __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").trigger('focus');
            });
        }
        reset() {
            super.reset();
            if (!this.options.keepEmpty) {
                const dateFrom = __classPrivateFieldGet(this, _FilterDatesBlock_instances, "m", _FilterDatesBlock_getDefaultDateFrom).call(this);
                const dateTo = __classPrivateFieldGet(this, _FilterDatesBlock_instances, "m", _FilterDatesBlock_getDefaultDateTo).call(this, dateFrom);
                this.setValues(dateFrom, dateTo);
            }
        }
        clear() {
            super.clear();
            this.reset();
        }
        /**
         * Возвращает значения контрола
         * @returns {}
         */
        getValues() {
            return [__classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('getDate'), __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('getDate')];
        }
        setValues(valueFrom, valueTo) {
            this.setFromValue(valueFrom);
            this.setToValue(valueTo);
        }
        setFromValue(value) {
            var _b;
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").trigger('focusin');
            if (value) {
                const minValue = (_b = this.options.minDateFrom) !== null && _b !== void 0 ? _b : App.addDays(new Date(), this.options.minDateFromShift);
                let newValue = value;
                if (newValue < minValue) {
                    newValue = minValue;
                }
                else if (this.options.maxDateFrom != null) {
                    if (newValue > this.options.maxDateFrom)
                        newValue = this.options.maxDateFrom;
                }
                else if (this.options.maxDateFromShift != null) {
                    const maxValue = App.addDays(new Date(), this.options.maxDateFromShift);
                    if (newValue > maxValue)
                        newValue = maxValue;
                }
                __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('setDate', newValue);
                if (this.options.minDateTo == null)
                    __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('option', 'minDate', App.addDays(newValue, this.options.minDateToOffset));
                if (this.options.maxDateTo == null
                    && (this.options.maxDateToOffset != null || this.options.absoluteMaxDateToOffset != null))
                    __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('option', 'maxDate', App.addDays(newValue, Math.min(this.options.maxDateToOffset || Number.MAX_VALUE, this.options.absoluteMaxDateToOffset || Number.MAX_VALUE)));
            }
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").trigger('focusout');
        }
        setToValue(value) {
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").trigger('focusin');
            if (value) {
                const dateFrom = __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('getDate');
                const minValue = App.addDays(dateFrom, this.options.minDateToOffset);
                let newValue = value;
                if (newValue < minValue) {
                    newValue = minValue;
                }
                else if (this.options.maxDateToOffset != null) {
                    const maxValue = App.addDays(dateFrom, this.options.maxDateToOffset);
                    if (newValue > maxValue)
                        newValue = maxValue;
                }
                __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('setDate', newValue);
            }
            __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").trigger('focusout');
        }
        /**
         * Установка новых настроек.
         * @param value
         */
        setOptions(value) {
            this.options = Object.assign(Object.assign({}, this.options), value);
            __classPrivateFieldGet(_a, _a, "m", _FilterDatesBlock_validateOptions).call(_a, this.options);
            const dateFrom = __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('getDate');
            if (this.options.minDateFromShift != null)
                __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('option', 'minDate', App.addDays(new Date(), this.options.minDateFromShift));
            if (this.options.maxDateFromShift != null || this.options.absoluteMaxDateToOffset != null)
                __classPrivateFieldGet(this, _FilterDatesBlock_calendarFrom, "f").datepicker('option', 'maxDate', App.addDays(new Date(), Math.min(this.options.maxDateFromShift || Number.MAX_VALUE, this.options.absoluteMaxDateToOffset || Number.MAX_VALUE)));
            this.setFromValue(dateFrom);
            const dateTo = __classPrivateFieldGet(this, _FilterDatesBlock_calendarTo, "f").datepicker('getDate');
            this.setToValue(dateTo);
        }
    }
    _a = FilterDatesBlock, _FilterDatesBlock_calendarFrom = new WeakMap(), _FilterDatesBlock_calendarTo = new WeakMap(), _FilterDatesBlock_instances = new WeakSet(), _FilterDatesBlock_validateOptions = function _FilterDatesBlock_validateOptions(value) {
        if (value.minDateFrom != null && value.maxDateFrom != null && value.maxDateFrom.getTime() < value.minDateFrom.getTime())
            throw new Error('If set, the "maxDateFrom" option must be greater or equal to "minDateFrom" option.');
        if (value.minDateTo != null && value.maxDateTo != null && value.maxDateTo.getTime() < value.minDateTo.getTime())
            throw new Error('If set, the "maxDateTo" option must be greater or equal to "minDateTo" option.');
        if (value.maxDateFromShift != null && value.maxDateFromShift < value.minDateFromShift)
            throw new Error('If set, the "maxDateFromShift" option must be greater or equal to "minDateFromShift" option.');
        if (value.defaultDateFromShift != null) {
            if (value.defaultDateFromShift < value.minDateFromShift)
                throw new Error('The "defaultDateFromShift" option must be greater or equal to "minDateFromShift" option.');
            if (value.maxDateFromShift != null && value.defaultDateFromShift > value.maxDateFromShift)
                throw new Error('The "defaultDateFromShift" option must be less or equal to "maxDateFromShift" option.');
        }
        if (value.minDateToOffset < 0)
            throw new Error('The "minDateToOffset" option must be greater or equal to 0.');
        if (value.maxDateToOffset != null) {
            if (value.maxDateToOffset < 0)
                throw new Error('If set, the "maxDateToOffset" option must be greater or equal to 0.');
            if (value.maxDateToOffset < value.minDateToOffset)
                throw new Error('If set, the "maxDateToOffset" option must be greater or equal to "minDateToOffset" option.');
        }
        if (value.defaultDateToOffset != null) {
            if (value.defaultDateToOffset < 0)
                throw new Error('The "defaultDateToOffset" option must be greater or equal to 0.');
            if (value.defaultDateToOffset < value.minDateToOffset)
                throw new Error('The "defaultDateToOffset" option must be greater or equal to "minDateToOffset" option.');
            if (value.maxDateToOffset != null && value.defaultDateToOffset > value.maxDateToOffset)
                throw new Error('The "defaultDateToOffset" option must be less or equal to "maxDateToOffset" option.');
        }
    }, _FilterDatesBlock_getDefaultDateFrom = function _FilterDatesBlock_getDefaultDateFrom() {
        var _b;
        return App.addDays(new Date(), (_b = this.options.defaultDateFromShift) !== null && _b !== void 0 ? _b : this.options.minDateFromShift);
    }, _FilterDatesBlock_getDefaultDateTo = function _FilterDatesBlock_getDefaultDateTo(dateFrom) {
        var _b;
        return App.addDays(dateFrom, (_b = this.options.defaultDateToOffset) !== null && _b !== void 0 ? _b : this.options.minDateToOffset);
    };
    _FilterDatesBlock_s_defaults = { value: {
            root: '.js-filter-dates-block, .js-form-dates-block',
            minDateFromShift: 0,
            minDateToOffset: 0,
            preserveDatesOffset: true,
            keepEmpty: false,
        } };
    App.FilterDatesBlock = FilterDatesBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _FilterHotelStarsBlock_minValue, _FilterHotelStarsBlock_maxValue, _FilterHotelStarsBlock_starsFrom, _FilterHotelStarsBlock_starsTo, _FilterHotelStarsBlock_starsFromInput, _FilterHotelStarsBlock_starsToInput, _FilterHotelStarsBlock_starsFromVal, _FilterHotelStarsBlock_starsToVal, _FilterHotelStarsBlock_starsReset, _FilterHotelStarsBlock_validateOptions;
    class FilterHotelStarsBlock extends App.FilterBlockBase {
        constructor(options) {
            super(Object.assign({ root: App.app.appContainer, defaultFromValue: 1, defaultToValue: __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_maxValue) }, options));
            _FilterHotelStarsBlock_starsFrom.set(this, void 0);
            _FilterHotelStarsBlock_starsTo.set(this, void 0);
            _FilterHotelStarsBlock_starsFromInput.set(this, void 0);
            _FilterHotelStarsBlock_starsToInput.set(this, void 0);
            _FilterHotelStarsBlock_starsFromVal.set(this, void 0);
            _FilterHotelStarsBlock_starsToVal.set(this, void 0);
            _FilterHotelStarsBlock_starsReset.set(this, void 0);
            if (this.root.length <= 0)
                return;
            __classPrivateFieldGet(_a, _a, "m", _FilterHotelStarsBlock_validateOptions).call(_a, this.options);
            __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsFrom, this.root.find('[data-name="hotel_stars_from"] .js-hotel-star'), "f");
            __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsTo, this.root.find('[data-name="hotel_stars_to"] .js-hotel-star'), "f");
            const filterHotelStars = this.root.find('.js-hotel-star');
            __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsFromInput, this.root.find('[data-input-name="hotel_stars_from"]'), "f");
            __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsToInput, this.root.find('[data-input-name="hotel_stars_to"]'), "f");
            __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsFromVal, __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFrom, "f").filter('._active').length, "f");
            __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsToVal, __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsTo, "f").filter('._active').length, "f");
            __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsReset, $(), "f");
            // Переключение звезд От
            __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFrom, "f").on('click', e => {
                const target = $(e.currentTarget);
                const valueFrom = target.index() + 1;
                this.setValues(valueFrom, __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsToVal, "f") >= valueFrom ? __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsToVal, "f") : valueFrom);
                __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFromInput, "f").trigger('change');
                this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
            });
            // Переключение звезд До
            __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsTo, "f").on('click', e => {
                const target = $(e.currentTarget);
                const valueTo = target.index() + 1;
                this.setValues(__classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFromVal, "f") > valueTo ? valueTo : __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFromVal, "f"), valueTo);
                __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsToInput, "f").trigger('change');
                this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                return true;
            });
            filterHotelStars.on('mouseover', e => {
                const target = $(e.currentTarget);
                const stars = target.closest('.js-filter-hotel-stars').find('.js-hotel-star');
                const isFrom = target.closest('[data-name="hotel_stars_from"]').length;
                target.addClass('_hover');
                stars.slice(0, target.index() + 1).addClass('_hover');
                __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsReset, stars.filter('._active'), "f");
                // Если навели на звезду От ИЛИ если навели на звезду До и звезд До больше, чем звезд От
                if (isFrom || target.index() + 1 >= __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFromVal, "f"))
                    stars.slice(target.index() + 1).removeClass('_active');
            });
            filterHotelStars.on('mouseout', e => {
                const target = $(e.currentTarget);
                const stars = target.closest('.js-filter-hotel-stars').find('.js-hotel-star');
                __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsReset, "f").addClass('_active');
                target.removeClass('_hover');
                stars.slice(0, target.index() + 1).removeClass('_hover');
            });
            $('.js-filter-reset-link', this.root).on('click', () => {
                this.setValues(__classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_minValue), __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_maxValue));
                this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
            });
        }
        reset() {
            super.reset();
            this.setValues(this.options.defaultFromValue, this.options.defaultToValue);
        }
        clear() {
            super.clear();
            this.reset();
        }
        setValues(valueFrom, valueTo) {
            const from = Math.min(Math.max(valueFrom, __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_minValue)), __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_maxValue));
            let to = Math.min(Math.max(valueTo, __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_minValue)), __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_maxValue));
            if (to < from)
                to = from;
            if (from !== __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFromVal, "f")) {
                __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFrom, "f").removeClass('_active');
                if (from > 0)
                    __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFrom, "f").slice(0, from).addClass('_active');
                __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsFromVal, from, "f");
                __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsReset, __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFrom, "f").filter('._active'), "f");
                __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsFromInput, "f").val(from);
            }
            if (to !== __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsToVal, "f")) {
                __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsTo, "f").removeClass('_active');
                if (to > 0)
                    __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsTo, "f").slice(0, to).addClass('_active');
                __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsToVal, to, "f");
                __classPrivateFieldSet(this, _FilterHotelStarsBlock_starsReset, __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsTo, "f").filter('._active'), "f");
                __classPrivateFieldGet(this, _FilterHotelStarsBlock_starsToInput, "f").val(to);
            }
        }
    }
    _a = FilterHotelStarsBlock, _FilterHotelStarsBlock_starsFrom = new WeakMap(), _FilterHotelStarsBlock_starsTo = new WeakMap(), _FilterHotelStarsBlock_starsFromInput = new WeakMap(), _FilterHotelStarsBlock_starsToInput = new WeakMap(), _FilterHotelStarsBlock_starsFromVal = new WeakMap(), _FilterHotelStarsBlock_starsToVal = new WeakMap(), _FilterHotelStarsBlock_starsReset = new WeakMap(), _FilterHotelStarsBlock_validateOptions = function _FilterHotelStarsBlock_validateOptions(value) {
        if (value.defaultFromValue > value.defaultToValue)
            throw new Error('The "defaultFromValue" option must be less or equal to "defaultToValue".');
        if (value.defaultFromValue < __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_minValue))
            throw new Error(`The "defaultFromValue" option must be more or equal to ${__classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_minValue)}.`);
        if (value.defaultToValue > __classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_maxValue))
            throw new Error(`The "defaultToValue" option must be less or equal to ${__classPrivateFieldGet(_a, _a, "f", _FilterHotelStarsBlock_maxValue)}.`);
        // TODO: надо ли делать другие проверки? типа, что все это больше нуля
    };
    _FilterHotelStarsBlock_minValue = { value: 0 };
    _FilterHotelStarsBlock_maxValue = { value: 5 };
    App.FilterHotelStarsBlock = FilterHotelStarsBlock;
})(App || (App = {}));
var App;
(function (App) {
    class FilterListBlockBase extends App.FilterBlockBase {
        constructor(options) {
            super(Object.assign({}, options));
        }
        replaceOptions(items, preserveDefault = false) {
            this.clearOptions(preserveDefault);
            this.addOptions(items);
        }
        isValueSet() {
            const value = this.getValue();
            return value != null && value !== '';
        }
    }
    App.FilterListBlockBase = FilterListBlockBase;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterNameBlock_value;
    /**
     * Блок для поиска по названию предложения
     */
    class FilterNameBlock extends App.FilterBlockBase {
        constructor(options) {
            super(Object.assign({}, options));
            /**
             * Значение контрола
             * Им является значение, на которое контрол должен реагировать
             * Сохраняем его для того, чтобы НЕ БЫЛО такой ситуации:
             * - сработали на 0 символов, т.е. на очистку контрола,
             * - потом ввели 1-2 символа, т.е. не среагировали,
             * - и потом опять очистка - 0 символов, реагируем
             */
            _FilterNameBlock_value.set(this, void 0);
            if (!this.root.length)
                return;
            this.root.on('input', () => {
                const newValue = this.root.valString();
                // Если новое значени совпадает со старым, не реагируем
                if (newValue === __classPrivateFieldGet(this, _FilterNameBlock_value, "f"))
                    return;
                // Реагировать только если введено 3 или больше букв или 0 - т.е. значение очищено
                if (newValue.length >= 3 || newValue.length === 0) {
                    __classPrivateFieldSet(this, _FilterNameBlock_value, newValue, "f");
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                }
            });
        }
        reset() {
            super.reset();
            this.setValue('');
        }
        clear() {
            super.clear();
            this.reset();
        }
        /**
         * Установить значение
         * @param newValue
         */
        setValue(newValue) {
            __classPrivateFieldSet(this, _FilterNameBlock_value, newValue, "f");
            this.root.val(__classPrivateFieldGet(this, _FilterNameBlock_value, "f"));
        }
    }
    _FilterNameBlock_value = new WeakMap();
    App.FilterNameBlock = FilterNameBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterPeopleBlock_instances, _a, _FilterPeopleBlock_maxPeopleNum, _FilterPeopleBlock_peopleCount, _FilterPeopleBlock_filterChildAge, _FilterPeopleBlock_filterPeopleChildReset, _FilterPeopleBlock_filterResetLink, _FilterPeopleBlock_filterPeopleChild, _FilterPeopleBlock_filterPeopleMan, _FilterPeopleBlock_manToReset, _FilterPeopleBlock_filterPeopleManInput, _FilterPeopleBlock_filterPersonInput, _FilterPeopleBlock_filterChildAgeForm, _FilterPeopleBlock_filterChildAgeInput, _FilterPeopleBlock_filterChildAgeSubmit, _FilterPeopleBlock_filterPersonNum, _FilterPeopleBlock_childToHide, _FilterPeopleBlock_setChildAge, _FilterPeopleBlock_onPeopleManClick, _FilterPeopleBlock_renderAdultCount, _FilterPeopleBlock_onPeopleChildClick, _FilterPeopleBlock_renderChildrenCount, _FilterPeopleBlock_positionChildrenAgeBlock, _FilterPeopleBlock_resetChild, _FilterPeopleBlock_setRemainingPeople, _FilterPeopleBlock_getLastChild, _FilterPeopleBlock_checkNumber;
    class FilterPeopleBlock extends App.FilterBlockBase {
        constructor(options) {
            var _b;
            super(Object.assign({ root: App.app.appContainer, maxChildAge: 17, defaultAdultCountValue: 1 }, options));
            _FilterPeopleBlock_instances.add(this);
            _FilterPeopleBlock_maxPeopleNum.set(this, void 0);
            _FilterPeopleBlock_peopleCount.set(this, void 0);
            _FilterPeopleBlock_filterChildAge.set(this, void 0);
            _FilterPeopleBlock_filterPeopleChildReset.set(this, void 0);
            _FilterPeopleBlock_filterResetLink.set(this, void 0);
            _FilterPeopleBlock_filterPeopleChild.set(this, void 0);
            _FilterPeopleBlock_filterPeopleMan.set(this, void 0);
            _FilterPeopleBlock_manToReset.set(this, void 0);
            _FilterPeopleBlock_filterPeopleManInput.set(this, void 0);
            _FilterPeopleBlock_filterPersonInput.set(this, void 0);
            _FilterPeopleBlock_filterChildAgeForm.set(this, void 0);
            _FilterPeopleBlock_filterChildAgeInput.set(this, void 0);
            _FilterPeopleBlock_filterChildAgeSubmit.set(this, void 0);
            _FilterPeopleBlock_filterPersonNum.set(this, void 0);
            _FilterPeopleBlock_childToHide.set(this, void 0);
            if (!this.root.length)
                return;
            // TODO: сделать-таки нормальную установку default-значений.
            __classPrivateFieldSet(this, _FilterPeopleBlock_maxPeopleNum, parseInt((_b = this.root.attr('data-max')) !== null && _b !== void 0 ? _b : '12', 10), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterChildAge, $('.js-filter-child-age', this.root), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterPeopleChildReset, $('.js-filter-child-reset', this.root), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterResetLink, $('.js-filter-reset-link', this.root), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterPeopleChild, this.root.find('.js-filter-child'), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterPeopleMan, $('.js-filter-man', this.root), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterPeopleManInput, this.root.find('[data-input-name="people_men"]'), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterPersonInput, this.root.find('.js-filter-person-input'), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterChildAgeForm, this.root.find('.js-filter-child-age-form'), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterChildAgeInput, __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeForm, "f").find('.js-filter-child-age-input'), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterChildAgeSubmit, __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeForm, "f").find('.js-filter-child-age-submit'), "f");
            __classPrivateFieldSet(this, _FilterPeopleBlock_filterPersonNum, this.root.find('.js-filter-person-num'), "f");
            let childToReset;
            let grayCountPlus;
            let grayCountMinus;
            this.root.data('is_first', true);
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").on('focusout click', e => {
                $(e.currentTarget).removeClass('_js-selected');
            });
            // навешиваем клик по ссылке 'сбросить'
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterResetLink, "f").on('click', () => __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_resetChild).call(this));
            // Блок Взрослых и детей
            if (this.root.length) {
                // Переключение Взрослых
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").on('click', e => __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_onPeopleManClick).call(this, e));
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").on('mouseover', e => {
                    const target = $(e.currentTarget);
                    const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
                    if (allowed) {
                        target.addClass('_hover');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").slice(0, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").index(target) + 1).addClass('_hover');
                        // Сколько взрослых (из уже выбранных) надо показать при уводе мыши
                        __classPrivateFieldSet(this, _FilterPeopleBlock_manToReset, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").filter('._active'), "f");
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").slice(target.index() + 1).removeClass('_active');
                        if (!App.isTouch) {
                            // Делаем серыми иконки детей, которые исчезнут, если кликнуть по взрослому, на которого сейчас навели
                            grayCountPlus = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").filter('._hover').length - __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").filter('._active').length;
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").removeClass('_gray');
                            if (grayCountPlus > 0) {
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").not('._off').slice(-grayCountPlus).addClass('_gray');
                            }
                            else {
                                // Делаем серыми иконки детей, которые добавятся, если кликнуть по взрослому, на которого сейчас навели
                                grayCountMinus = __classPrivateFieldGet(this, _FilterPeopleBlock_manToReset, "f").length - __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").filter('._active').length;
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f")
                                    .slice(__classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").not('._off').length, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").not('._off').length + grayCountMinus)
                                    .addClass('_gray');
                            }
                        }
                    }
                });
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").on('mouseout', e => {
                    const target = $(e.currentTarget);
                    const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
                    if (allowed) {
                        __classPrivateFieldGet(this, _FilterPeopleBlock_manToReset, "f").addClass('_active');
                        target.removeClass('_hover');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").slice(0, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").index(target) + 1).removeClass('_hover');
                        if (!App.isTouch)
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").removeClass('_gray');
                    }
                });
                // Переключение Детей
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").on('click', e => __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_onPeopleChildClick).call(this, e));
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").on('mouseover', e => {
                    const target = $(e.currentTarget);
                    const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
                    if (allowed) {
                        target.addClass('_hover');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").slice(0, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").index(target) + 1).addClass('_hover');
                        // Сколько детей (из уже выбранных) надо показать при уводе мыши
                        __classPrivateFieldSet(this, _FilterPeopleBlock_childToHide, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active'), "f");
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").slice(__classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").index(target) + 1).removeClass('_active');
                        if (!App.isTouch) {
                            // Делаем серыми иконки взрослых, которые исчезнут, если кликнуть по ребенку, на которого сейчас навели
                            grayCountPlus = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._hover').length - __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active').length;
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").removeClass('_gray');
                            if (grayCountPlus > 0) {
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").not('._off').slice(-grayCountPlus).addClass('_gray');
                            }
                            else {
                                // Делаем серыми иконки взрослых, которые добавятся, если кликнуть по ребенку, на которого сейчас навели
                                grayCountMinus = __classPrivateFieldGet(this, _FilterPeopleBlock_childToHide, "f").length - __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active').length;
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f")
                                    .slice(__classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").not('._off').length, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").not('._off').length + grayCountMinus)
                                    .addClass('_gray');
                            }
                        }
                    }
                });
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").on('mouseout', e => {
                    const target = $(e.currentTarget);
                    const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
                    if (allowed)
                        __classPrivateFieldGet(this, _FilterPeopleBlock_childToHide, "f").addClass('_active');
                    target.removeClass('_hover');
                    __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").slice(0, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").index(target) + 1).removeClass('_hover');
                    if (!App.isTouch)
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").removeClass('_gray');
                });
                // Сброс количества Детей
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChildReset, "f").on('mouseover', () => {
                    const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
                    // Если блок ввода текста скрыт
                    if (allowed) {
                        childToReset = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").removeClass('_hover _active');
                        if (!App.isTouch) {
                            if (__classPrivateFieldGet(this, _FilterPeopleBlock_childToHide, "f")) {
                                grayCountMinus = __classPrivateFieldGet(this, _FilterPeopleBlock_childToHide, "f").length - __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active').length;
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f")
                                    .slice(__classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").not('._off').length, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").not('._off').length + grayCountMinus)
                                    .addClass('_gray');
                            }
                        }
                    }
                });
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChildReset, "f").on('mouseout', () => {
                    const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
                    // Если блок ввода текста скрыт
                    if (allowed) {
                        childToReset.addClass('_active');
                        if (!App.isTouch)
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").removeClass('_gray');
                    }
                });
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChildReset, "f").on('click', () => {
                    const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
                    // Если блок ввода текста скрыт
                    if (allowed) {
                        this.root.data('is_first', true);
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").removeClass('_active');
                        childToReset = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonNum, "f").text('');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").attr('data-child', 1);
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").removeAttr('class');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").addClass('filter-people__child-age _hidden js-filter-child-age _child-1');
                        // Сколько детей (из уже выбранных) надо показать при уводе мыши
                        __classPrivateFieldSet(this, _FilterPeopleBlock_childToHide, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active'), "f");
                        // Считаем, сколько еще человек можно добавить, и корректируем количество отображаемых иконок людей
                        __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_setRemainingPeople).call(this, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f"), __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f"));
                        if (!App.isTouch)
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").removeClass('_gray');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonInput, "f").val('');
                        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonInput, "f").attr('disabled', '');
                    }
                    this.root.trigger("filter-people-block:change" /* Events.FilterPeopleBlockChange */);
                });
                // Обрабатываем ввод возраста детей
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").on('keydown', e => {
                    const target = $(e.currentTarget);
                    let count = target.valString().length + 1;
                    if (target.hasClass('_js-selected'))
                        count = 0;
                    if (e.key === App.Key.Escape) {
                        const lastChild = __classPrivateFieldGet(_a, _a, "m", _FilterPeopleBlock_getLastChild).call(_a, this.root) - 1;
                        if (lastChild === -1) {
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterResetLink, "f").trigger('click');
                        }
                        else {
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").eq(lastChild).trigger('click');
                            this.root.find('.js-filter-child-age-input').trigger(jQuery.Event('keypress', {
                                key: App.Key.Enter,
                            }));
                        }
                    }
                    if (__classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_checkNumber).call(this, e.key, e.ctrlKey, target.valString(), count))
                        target.removeClass('_js-selected');
                    else
                        e.preventDefault();
                });
                // Добавляем возраст ребенку при нажатии на Enter
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").on('keypress', e => {
                    if (e.key === App.Key.Enter) {
                        const inputText = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").valString();
                        const activeChild = parseInt(__classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").attr('data-child') || '0', 10);
                        if (inputText !== '') {
                            // Если не пустое поле
                            __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_setChildAge).call(this, activeChild - 1, inputText);
                            __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").val('');
                            if (activeChild + 1 <= __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active').length) {
                                // Сдвигаем ввод к следующему выбранному ребенку (если они еще есть)
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").trigger('focus');
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").attr('data-child', activeChild + 1);
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").removeClass(`_child-${activeChild}`);
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").addClass(`_child-${activeChild + 1}`);
                            }
                            else {
                                // Или скрываем блок ввода возраста
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").addClass('_hidden');
                                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").trigger('blur');
                                this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                            }
                            this.root.trigger("filter-people-block:change" /* Events.FilterPeopleBlockChange */);
                        }
                        return false;
                    }
                    return true;
                });
                // Добавляем возраст ребенку при клике на OK
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeSubmit, "f").on('click', () => {
                    __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").trigger(jQuery.Event('keypress', {
                        key: App.Key.Enter,
                    }));
                });
            }
        }
        reset() {
            super.reset();
            this.setValues(this.options.defaultAdultCountValue, []);
        }
        clear() {
            super.clear();
            this.reset();
        }
        /**
         * Устанавливает значения элемента управления.
         * @param adultsNumber - Количество взрослых
         * @param children - массив с возрастами детей
         */
        setValues(adultsNumber, children) {
            // TODO: наверное тут надо как-то валидировать допустимое количество взрослых
            // очистить сначала
            const firstPeopleMan = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").removeClass('_active _hover').first();
            firstPeopleMan.addClass('_active');
            __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_renderAdultCount).call(this, firstPeopleMan);
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").addClass('_hidden');
            __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_resetChild).call(this);
            // установить взрослых
            if (adultsNumber === 0)
                return;
            const adultElement = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").eq(adultsNumber - 1);
            __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_renderAdultCount).call(this, adultElement);
            // установить детей
            if (children.length <= 0)
                return;
            // проверить возраст
            let correctChildren = children.filter(v => v <= this.options.maxChildAge);
            // проверить количество детей, которое можно ввести и если оно меньше чем то, которое пришло, обрезаем пришедшее
            const childCountAllowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").not('._off').length;
            if (childCountAllowed < correctChildren.length)
                correctChildren = correctChildren.slice(0, childCountAllowed);
            // установить
            const lastChildElementIndex = correctChildren.length - 1;
            const childElement = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").eq(lastChildElementIndex);
            __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_renderChildrenCount).call(this, childElement, lastChildElementIndex);
            for (let i = 0; i < correctChildren.length; i++)
                __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_setChildAge).call(this, i, correctChildren[i].toString());
        }
    }
    _a = FilterPeopleBlock, _FilterPeopleBlock_maxPeopleNum = new WeakMap(), _FilterPeopleBlock_peopleCount = new WeakMap(), _FilterPeopleBlock_filterChildAge = new WeakMap(), _FilterPeopleBlock_filterPeopleChildReset = new WeakMap(), _FilterPeopleBlock_filterResetLink = new WeakMap(), _FilterPeopleBlock_filterPeopleChild = new WeakMap(), _FilterPeopleBlock_filterPeopleMan = new WeakMap(), _FilterPeopleBlock_manToReset = new WeakMap(), _FilterPeopleBlock_filterPeopleManInput = new WeakMap(), _FilterPeopleBlock_filterPersonInput = new WeakMap(), _FilterPeopleBlock_filterChildAgeForm = new WeakMap(), _FilterPeopleBlock_filterChildAgeInput = new WeakMap(), _FilterPeopleBlock_filterChildAgeSubmit = new WeakMap(), _FilterPeopleBlock_filterPersonNum = new WeakMap(), _FilterPeopleBlock_childToHide = new WeakMap(), _FilterPeopleBlock_instances = new WeakSet(), _FilterPeopleBlock_setChildAge = function _FilterPeopleBlock_setChildAge(currentElementIndex, age) {
        const textField = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonNum, "f").eq(currentElementIndex);
        const personInput = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonInput, "f").eq(currentElementIndex);
        textField.text(age);
        personInput.val(age);
    }, _FilterPeopleBlock_onPeopleManClick = function _FilterPeopleBlock_onPeopleManClick(event) {
        const target = $(event.currentTarget);
        __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_renderAdultCount).call(this, target);
    }, _FilterPeopleBlock_renderAdultCount = function _FilterPeopleBlock_renderAdultCount(element) {
        const manIndex = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").index(element);
        const allowed = __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").hasClass('_hidden');
        if (allowed) {
            if (element.hasClass('_active')) {
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").slice(manIndex + 1).removeClass('_active');
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").slice(0, manIndex).addClass('_active');
            }
            else {
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").removeClass('_active');
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").slice(0, manIndex + 1).addClass('_active');
            }
            // Сколько взрослых (из уже выбранных) надо показать при уводе мыши
            __classPrivateFieldSet(this, _FilterPeopleBlock_manToReset, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").filter('._active'), "f");
            // Считаем, сколько еще человек можно добавить, и корректируем количество отображаемых иконок людей
            __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_setRemainingPeople).call(this, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f"), __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f"));
            if (!App.isTouch)
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").removeClass('_gray');
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleManInput, "f").val(manIndex + 1);
        }
        this.root.trigger("filter-people-block:change" /* Events.FilterPeopleBlockChange */);
        this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
    }, _FilterPeopleBlock_onPeopleChildClick = function _FilterPeopleBlock_onPeopleChildClick(event) {
        const target = $(event.currentTarget);
        const childIndex = __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").index(target);
        __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_renderChildrenCount).call(this, target, childIndex);
        __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_positionChildrenAgeBlock).call(this, target, childIndex);
    }, _FilterPeopleBlock_renderChildrenCount = function _FilterPeopleBlock_renderChildrenCount(element, childElementIndex) {
        // Если блок ввода текста скрыт
        __classPrivateFieldGet(this, _FilterPeopleBlock_filterResetLink, "f").show();
        if (element.hasClass('_active')) {
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").slice(childElementIndex + 1).removeClass('_active');
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").slice(0, childElementIndex).addClass('_active');
        }
        else {
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").removeClass('_active');
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").slice(0, childElementIndex + 1).addClass('_active');
        }
        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonInput, "f").slice(0, childElementIndex + 1).removeAttr('disabled');
        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonInput, "f").slice(childElementIndex + 1).attr('disabled', '');
        // Сколько детей (из уже выбранных) надо показать при уводе мыши
        __classPrivateFieldSet(this, _FilterPeopleBlock_childToHide, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").filter('._active'), "f");
        // Считаем, сколько еще человек можно добавить, и корректируем количество отображаемых иконок людей
        __classPrivateFieldGet(this, _FilterPeopleBlock_instances, "m", _FilterPeopleBlock_setRemainingPeople).call(this, __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f"), __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f"));
        if (!App.isTouch)
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleMan, "f").removeClass('_gray');
    }, _FilterPeopleBlock_positionChildrenAgeBlock = function _FilterPeopleBlock_positionChildrenAgeBlock(element, childIndex) {
        const activeChild = parseInt(__classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").attr('data-child') || '0', 10);
        const needIndex = __classPrivateFieldGet(_a, _a, "m", _FilterPeopleBlock_getLastChild).call(_a, this.root);
        if (!element.data('is_first')) {
            // Если НЕ самый первый раз щелкают по детям
            if (childIndex + 1 === activeChild) {
                // Позиционируем блок ввода возраста, если количество детей осталось прежним
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").removeClass('_hidden');
            }
            else if (childIndex + 1 < activeChild) {
                // Позиционируем блок ввода возраста, если количество детей уменьшили
                element.find('.js-filter-child:not(._active)').find('.js-filter-person-num').text('');
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").attr('data-child', childIndex + 1);
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").removeAttr('class');
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").addClass(`filter-people__child-age js-filter-child-age _child-${childIndex + 1}`);
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterPersonNum, "f").slice(needIndex).text('');
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f")
                    .val(__classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChild, "f").eq(childIndex).find('.js-filter-person-num').text())
                    .trigger('select')
                    .trigger('focus')
                    .addClass('_js-selected');
            }
            else if (childIndex + 1 > activeChild) {
                // Позиционируем блок ввода возраста, если количество детей увеличили
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").attr('data-child', needIndex + 1);
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").removeAttr('class');
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").addClass(`filter-people__child-age js-filter-child-age _child-${needIndex + 1}`);
                __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").val('').trigger('focus');
            }
        }
        else {
            // Если самый первый раз щелкают по детям
            element.data('is_first', false);
            __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").removeClass('_hidden');
        }
        // Показываем блок ввода возраста
        __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAgeInput, "f").trigger('focus');
    }, _FilterPeopleBlock_resetChild = function _FilterPeopleBlock_resetChild() {
        __classPrivateFieldGet(this, _FilterPeopleBlock_filterChildAge, "f").addClass('_hidden');
        __classPrivateFieldGet(this, _FilterPeopleBlock_filterPeopleChildReset, "f").trigger('click');
        __classPrivateFieldGet(this, _FilterPeopleBlock_filterResetLink, "f").hide();
    }, _FilterPeopleBlock_setRemainingPeople = function _FilterPeopleBlock_setRemainingPeople(man, child) {
        // Считаем, сколько еще человек можно добавить
        __classPrivateFieldSet(this, _FilterPeopleBlock_peopleCount, man.filter('._active').length + child.filter('._active').length, "f");
        // И корректируем количество отображаемых иконок людей
        man.addClass('_off');
        man.slice(0, man.filter('._active').length + __classPrivateFieldGet(this, _FilterPeopleBlock_maxPeopleNum, "f") - __classPrivateFieldGet(this, _FilterPeopleBlock_peopleCount, "f")).removeClass('_off');
        child.addClass('_off');
        child.slice(0, child.filter('._active').length + __classPrivateFieldGet(this, _FilterPeopleBlock_maxPeopleNum, "f") - __classPrivateFieldGet(this, _FilterPeopleBlock_peopleCount, "f")).removeClass('_off');
    }, _FilterPeopleBlock_getLastChild = function _FilterPeopleBlock_getLastChild(filterPeopleBlock) {
        let count = 0;
        filterPeopleBlock.find('.js-filter-child._active').each((index2, element2) => {
            if ($(element2).find('.js-filter-person-num').text().length !== 0)
                count += 1;
        });
        return count;
    }, _FilterPeopleBlock_checkNumber = function _FilterPeopleBlock_checkNumber(key, ctrlKey, value, count) {
        // Разрешаем: backspace, delete, tab, escape, enter и Ctrl+A
        if (key === App.Key.Delete
            || key === App.Key.Backspace
            || key === App.Key.Tab
            || key === App.Key.Escape
            || key === App.Key.Enter
            || (ctrlKey && (key === App.Key.LetterA || key === App.Key.LetterSmallA)))
            return true;
        // Запрещаем: не цифры
        const digit = key.charCodeAt(0) - '0'.charCodeAt(0);
        if (digit < 0 || digit > 9)
            return false;
        if (this.options.maxChildAge < 10)
            throw new Error('Check of child age less than 10 is not implemented.');
        if (this.options.maxChildAge > 19)
            throw new Error('Check of child age larger than 19 is not implemented.');
        if (count <= 1)
            return true;
        // если трехзначное число или более то запретить ввод
        if (count > 2)
            return false;
        if (value !== App.Key.Digit1)
            return false;
        // если первая цифра '1'
        return digit <= this.options.maxChildAge % 10;
    };
    App.FilterPeopleBlock = FilterPeopleBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterRoomsBlock_instances, _FilterRoomsBlock_filterAddRoom, _FilterRoomsBlock_filterDeleteRoom, _FilterRoomsBlock_filter, _FilterRoomsBlock_resultManTitle, _FilterRoomsBlock_resultChild, _FilterRoomsBlock_resultChildTitle, _FilterRoomsBlock_resultRoomsTitle, _FilterRoomsBlock_values, _FilterRoomsBlock_roomTouristBlocks, _FilterRoomsBlock_createPeopleBlocks, _FilterRoomsBlock_activateDeleteRoomBlock, _FilterRoomsBlock_updateResultRooms, _FilterRoomsBlock_setBlockValue, _FilterRoomsBlock_addRoom;
    // TODO: добавить сюда значения по умолчанию, как в датах
    class FilterRoomsBlock extends App.FilterBlockBase {
        /**
         * Конструктор
         * @param opts - опции
         * @param filter - фильтр, к котрому принадлежит блок. Необходим, т.к. является рутом для всего контрола, что очень полезно, когда
         * контролов больше, чем 1 на странице
         * @returns {}
         */
        constructor(options) {
            super(Object.assign({ root: App.app.appContainer, filter: App.app.appContainer, maxChildAge: 12, defaultAdultCountValue: 1, defaultRoomCountValue: 1 }, options));
            _FilterRoomsBlock_instances.add(this);
            _FilterRoomsBlock_filterAddRoom.set(this, void 0);
            _FilterRoomsBlock_filterDeleteRoom.set(this, void 0);
            _FilterRoomsBlock_filter.set(this, void 0);
            _FilterRoomsBlock_resultManTitle.set(this, void 0);
            _FilterRoomsBlock_resultChild.set(this, void 0);
            _FilterRoomsBlock_resultChildTitle.set(this, void 0);
            _FilterRoomsBlock_resultRoomsTitle.set(this, void 0);
            // Значения
            _FilterRoomsBlock_values.set(this, void 0);
            _FilterRoomsBlock_roomTouristBlocks.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FilterRoomsBlock_filter, this.options.filter, "f");
            __classPrivateFieldSet(this, _FilterRoomsBlock_filterDeleteRoom, $('.js-delete-number', this.root), "f");
            __classPrivateFieldSet(this, _FilterRoomsBlock_filterAddRoom, $('.js-filter-add-room', this.root), "f");
            __classPrivateFieldGet(this, _FilterRoomsBlock_filterAddRoom, "f").on('click', () => __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_addRoom).call(this));
            __classPrivateFieldSet(this, _FilterRoomsBlock_resultManTitle, $('.js-result-man-title', __classPrivateFieldGet(this, _FilterRoomsBlock_filter, "f")), "f");
            __classPrivateFieldSet(this, _FilterRoomsBlock_resultChild, $('.js-result-child', __classPrivateFieldGet(this, _FilterRoomsBlock_filter, "f")), "f");
            __classPrivateFieldSet(this, _FilterRoomsBlock_resultChildTitle, $('.js-result-child-title', __classPrivateFieldGet(this, _FilterRoomsBlock_filter, "f")), "f");
            __classPrivateFieldSet(this, _FilterRoomsBlock_resultRoomsTitle, $('.js-result-rooms-title', __classPrivateFieldGet(this, _FilterRoomsBlock_filter, "f")), "f");
            __classPrivateFieldSet(this, _FilterRoomsBlock_values, new Array(), "f");
            __classPrivateFieldSet(this, _FilterRoomsBlock_roomTouristBlocks, new Array(), "f");
            __classPrivateFieldGet(this, _FilterRoomsBlock_filter, "f").on("filter-people-block:change" /* Events.FilterPeopleBlockChange */, () => __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_updateResultRooms).call(this));
            __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_activateDeleteRoomBlock).call(this);
            __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_createPeopleBlocks).call(this);
            __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_updateResultRooms).call(this);
        }
        reset() {
            super.reset();
            const tourists = new Array();
            // В соответствии с количеством номеров по умолчанию подготовим массив туристов с заданным количеством туристов
            for (let i = 1; i <= this.options.defaultRoomCountValue; i++)
                tourists.push({ adultCount: this.options.defaultAdultCountValue, childAges: new Array() });
            this.setValues(tourists);
        }
        clear() {
            super.clear();
            this.reset();
        }
        /**
        .* Устанавливает значение
         * @param tourists - туристы по номерам.
         */
        setValues(tourists) {
            // Удалить все номера (кнопка удаления есть у всех номеров, кроме первого)
            __classPrivateFieldGet(this, _FilterRoomsBlock_filterDeleteRoom, "f").each((index, element) => {
                const jqRoomElement = $(element).closest('.js-filter-room-item');
                this.deleteRoom(jqRoomElement);
            });
            // Добавить сколько надо
            const roomRenderedCount = tourists.length - 1;
            // TODO: сделать дефолтные значения и здесь проверять на них - чтобы не было 150 номеров
            for (let index = 0; index < roomRenderedCount; index++)
                __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_addRoom).call(this);
            // Обновить людей в номерах
            let counter = 0;
            tourists.forEach(tourist => {
                const peopleBlock = __classPrivateFieldGet(this, _FilterRoomsBlock_roomTouristBlocks, "f")[counter];
                peopleBlock.setValues(tourist.adultCount, tourist.childAges);
                counter += 1;
            });
            __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_updateResultRooms).call(this);
        }
        /**
         * Возвращает значения контрола
         * @returns {}
         */
        getValues() {
            return __classPrivateFieldGet(this, _FilterRoomsBlock_values, "f");
        }
        /**
         *Удаляет номер
         * @returns {}
         */
        deleteRoom(needRoom) {
            needRoom.hideByClass();
            // задизейблить все инпуты в удаляемом элементы, чтобы не передавались на сервер
            needRoom.find('input:not(#child-age)').attr('disabled', '');
            __classPrivateFieldGet(this, _FilterRoomsBlock_filterAddRoom, "f").showByClass();
            __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_updateResultRooms).call(this);
        }
        static parseUrlParameter(value) {
            return {
                adultCount: parseInt(value.values[0], 10),
                childAges: value.values.slice(1).map(v => parseInt(v, 10)),
            };
        }
    }
    _FilterRoomsBlock_filterAddRoom = new WeakMap(), _FilterRoomsBlock_filterDeleteRoom = new WeakMap(), _FilterRoomsBlock_filter = new WeakMap(), _FilterRoomsBlock_resultManTitle = new WeakMap(), _FilterRoomsBlock_resultChild = new WeakMap(), _FilterRoomsBlock_resultChildTitle = new WeakMap(), _FilterRoomsBlock_resultRoomsTitle = new WeakMap(), _FilterRoomsBlock_values = new WeakMap(), _FilterRoomsBlock_roomTouristBlocks = new WeakMap(), _FilterRoomsBlock_instances = new WeakSet(), _FilterRoomsBlock_createPeopleBlocks = function _FilterRoomsBlock_createPeopleBlocks() {
        const filterPeopleBlock = this.root.find('.js-filter-room-block');
        filterPeopleBlock.each((i, v) => { __classPrivateFieldGet(this, _FilterRoomsBlock_roomTouristBlocks, "f").push(new App.FilterPeopleBlock({ root: $(v) })); });
    }, _FilterRoomsBlock_activateDeleteRoomBlock = function _FilterRoomsBlock_activateDeleteRoomBlock() {
        __classPrivateFieldGet(this, _FilterRoomsBlock_filterDeleteRoom, "f").each((index, element) => {
            const jqElement = $(element);
            jqElement.on('click', () => {
                const needRoom = jqElement.closest('.js-filter-room-item');
                this.deleteRoom(needRoom);
            });
        });
    }, _FilterRoomsBlock_updateResultRooms = function _FilterRoomsBlock_updateResultRooms() {
        const roomsItems = this.root.find('.js-filter-room-item:not(._hidden-2)');
        const roomsCount = roomsItems.length;
        const manCount = roomsItems.find('.js-filter-man._active').length;
        const childCount = roomsItems.find('.js-filter-child._active').length;
        __classPrivateFieldGet(this, _FilterRoomsBlock_resultRoomsTitle, "f").html(App.formatMessage('hotel/rooms', { count: roomsCount }));
        __classPrivateFieldGet(this, _FilterRoomsBlock_resultManTitle, "f").html(App.formatMessage('hotel/adults', { count: manCount }));
        if (childCount > 0) {
            __classPrivateFieldGet(this, _FilterRoomsBlock_resultChildTitle, "f").html(App.formatMessage('hotel/children', { count: childCount }));
            __classPrivateFieldGet(this, _FilterRoomsBlock_resultChild, "f").showByClass();
        }
        else {
            __classPrivateFieldGet(this, _FilterRoomsBlock_resultChild, "f").hideByClass();
        }
        // установить значения для блока
        __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_setBlockValue).call(this, roomsItems);
    }, _FilterRoomsBlock_setBlockValue = function _FilterRoomsBlock_setBlockValue(roomsItems) {
        // Сначала сбросить, т.к. сюда приходим не один раз при работе с контролом
        __classPrivateFieldSet(this, _FilterRoomsBlock_values, new Array(), "f");
        // Пройтись по каждому выбранному номеру
        roomsItems.each((index, element) => {
            const jqElement = $(element);
            // Взять из соответствующих элементов блока значения.
            // Взрослых
            const itemAdultCount = jqElement.find('.js-filter-man._active').length;
            // Детей
            const itemChilds = new Array();
            const enabledChildrenInput = jqElement.find('[data-input-name="people_child"]:enabled');
            enabledChildrenInput.each((i, el) => {
                itemChilds.push($(el).valNumber() || 0);
            });
            // Пихаем детей и взрослых в модель со значениями контрола
            if (itemAdultCount)
                __classPrivateFieldGet(this, _FilterRoomsBlock_values, "f").push(new App.TouristsModel(itemAdultCount, itemChilds));
        });
    }, _FilterRoomsBlock_addRoom = function _FilterRoomsBlock_addRoom() {
        var _a;
        const rooms = this.root.find('.js-filter-room-item._hidden-2');
        const needRoom = rooms.first();
        if (rooms.length > 1) {
            needRoom.showByClass();
            __classPrivateFieldGet(this, _FilterRoomsBlock_filterAddRoom, "f").showByClass();
        }
        else {
            needRoom.showByClass();
            __classPrivateFieldGet(this, _FilterRoomsBlock_filterAddRoom, "f").hideByClass();
        }
        // По порядковому номеру данного номера в фильтре найдем соответствующий контрол людей и установим туда дефолтное количество
        // взрослых (детей, пока по крайней мере, не устанавливаю из настроек, т.к. не вижу смысла - есть комент в файле appsettings)
        const roomNumber = parseInt((_a = needRoom.attr('data-number')) !== null && _a !== void 0 ? _a : '1', 10);
        const peopleBlock = __classPrivateFieldGet(this, _FilterRoomsBlock_roomTouristBlocks, "f")[roomNumber - 1];
        peopleBlock.setValues(this.options.defaultAdultCountValue, []);
        // Если есть активные взрослые и дети, раздизейблим инпуты.
        if (needRoom.find('.js-filter-man._active').length > 0) {
            needRoom.find('input[data-input-name="people_men"]').removeAttr('disabled');
            // инпут для выравнивания индексов с пропусками в массиве
            needRoom.find('input[data-input-name="index"]').removeAttr('disabled');
        }
        if (needRoom.find('.js-filter-child._active').length > 0)
            needRoom.find('input[data-input-name="people_child"]').removeAttr('disabled');
        needRoom.find('.js-filter-man._active').last().trigger('click');
        __classPrivateFieldGet(this, _FilterRoomsBlock_instances, "m", _FilterRoomsBlock_updateResultRooms).call(this);
    };
    App.FilterRoomsBlock = FilterRoomsBlock;
})(App || (App = {}));
/// <reference path='FilterRoomsBlock.ts' />
var App;
(function (App) {
    var _FilterRoomsAccordionBlock_instances, _FilterRoomsAccordionBlock_roomAccordion;
    class FilterRoomsAccordionBlock extends App.FilterRoomsBlock {
        /**
         * Конструктор
         * @param opts - опции
         * @param filter - фильтр, к которому принадлежит блок. Необходим, т.к. является рутом для всего контрола, что очень полезно, когда
         * контролов больше, чем 1 на странице
         * @returns {}
         */
        constructor(options) {
            super(Object.assign({}, options));
            _FilterRoomsAccordionBlock_instances.add(this);
            if (!this.root.length)
                return;
            __classPrivateFieldGet(this, _FilterRoomsAccordionBlock_instances, "m", _FilterRoomsAccordionBlock_roomAccordion).call(this);
            $('.js-filter-room-item', this.root).on('click', e => {
                // TODO: здесь событие инициируется разными блоками, в итоге в дебагере видно, что оно может возникнуть раза три,
                // если кликнуть на взрослого.НЕ стала обрабатывать, т.к. мы правда можем кликнуть в любое место блока и событие
                // должно сработать.
                // TODO: специально не обрабатываю клик на плюсик (добавление), оно само отрабатывает, т.к. под ним лежит невидимый блок
                __classPrivateFieldGet(this, _FilterRoomsAccordionBlock_instances, "m", _FilterRoomsAccordionBlock_roomAccordion).call(this, $(e.currentTarget));
            });
        }
        deleteRoom(needRoom) {
            super.deleteRoom(needRoom);
            __classPrivateFieldGet(this, _FilterRoomsAccordionBlock_instances, "m", _FilterRoomsAccordionBlock_roomAccordion).call(this, needRoom);
        }
    }
    _FilterRoomsAccordionBlock_instances = new WeakSet(), _FilterRoomsAccordionBlock_roomAccordion = function _FilterRoomsAccordionBlock_roomAccordion(currentRoom) {
        const roomsItems = $('.js-filter-room-item:not(._hidden-2)', this.root);
        // Сворачиваем/разворачиваем только, если больше 2 номеров (3 и более)
        // Если меньше или 2 - только разворачиваем
        if (roomsItems.length > 2) {
            roomsItems
                .removeClass('wide-room-people__item-wrapper')
                .addClass('narrow-room-people__item-wrapper');
            roomsItems.find('.js-filter-people-input').hideByClass();
            roomsItems.find('.js-filter-man-narrow').showByClass();
            roomsItems.find('.js-filter-child-narrow').showByClass();
            roomsItems.each((index, element) => {
                const jqElement = $(element);
                const adultCount = jqElement.find('.js-filter-man._active').length;
                const childrenCount = jqElement.find('.js-filter-child._active').length;
                const manElement = jqElement.find('.js-filter-man-narrow');
                $('.js-count', manElement).text(adultCount);
                if (adultCount > 0)
                    manElement.addClass('_active');
                else
                    manElement.removeClass('_active');
                const childElement = jqElement.find('.js-filter-child-narrow');
                $('.js-count', childElement).text(childrenCount);
                if (childrenCount > 0)
                    childElement.addClass('_active');
                else
                    childElement.removeClass('_active');
            });
            if (currentRoom) {
                currentRoom
                    .removeClass('narrow-room-people__item-wrapper')
                    .addClass('wide-room-people__item-wrapper');
                currentRoom.find('.js-filter-people-input').showByClass();
                currentRoom.find('.js-filter-man-narrow').hideByClass();
                currentRoom.find('.js-filter-child-narrow').hideByClass();
            }
        }
        else {
            roomsItems
                .removeClass('narrow-room-people__item-wrapper')
                .addClass('wide-room-people__item-wrapper');
            roomsItems.find('.js-filter-people-input').showByClass();
            roomsItems.find('.js-filter-man-narrow').hideByClass();
            roomsItems.find('.js-filter-child-narrow').hideByClass();
        }
    };
    App.FilterRoomsAccordionBlock = FilterRoomsAccordionBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterScrollBlock_instances, _a, _FilterScrollBlock_input, _FilterScrollBlock_selectAll, _FilterScrollBlock_clearAll, _FilterScrollBlock_searchClear, _FilterScrollBlock_optionContainer, _FilterScrollBlock_hasIcons, _FilterScrollBlock_selectMode, _FilterScrollBlock_activityClass, _FilterScrollBlock_hasCheckboxes, _FilterScrollBlock_scroller, _FilterScrollBlock_incompleteSet, _FilterScrollBlock_getOptions, _FilterScrollBlock_resetOptions, _FilterScrollBlock_updateInput, _FilterScrollBlock_updateInputValue, _FilterScrollBlock_bindOptions, _FilterScrollBlock_onOptionClick;
    class FilterScrollBlock extends App.FilterListBlockBase {
        constructor(options) {
            super(Object.assign({}, options));
            _FilterScrollBlock_instances.add(this);
            _FilterScrollBlock_input.set(this, void 0);
            _FilterScrollBlock_selectAll.set(this, void 0);
            _FilterScrollBlock_clearAll.set(this, void 0);
            _FilterScrollBlock_searchClear.set(this, void 0);
            _FilterScrollBlock_optionContainer.set(this, void 0);
            _FilterScrollBlock_hasIcons.set(this, void 0);
            _FilterScrollBlock_selectMode.set(this, void 0);
            _FilterScrollBlock_activityClass.set(this, void 0);
            _FilterScrollBlock_hasCheckboxes.set(this, void 0);
            _FilterScrollBlock_scroller.set(this, void 0);
            _FilterScrollBlock_incompleteSet.set(this, void 0);
            if (!this.root.length)
                return;
            this.name = this.root.attr('data-select') || '';
            __classPrivateFieldSet(this, _FilterScrollBlock_input, $('.js-jelect-input', this.root), "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_selectAll, $('.js-filter-select-all', this.root), "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_clearAll, $('.js-filter-clear-all', this.root), "f");
            const searchContainer = $('.js-filter-search', this.root);
            const searchInput = $('.js-filter-search-input', searchContainer);
            __classPrivateFieldSet(this, _FilterScrollBlock_searchClear, $('.js-clear-filter-search', searchContainer), "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_optionContainer, $('.js-jelect-options', this.root), "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_hasIcons, this.root.hasClass('js-icons-select'), "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_activityClass, __classPrivateFieldGet(this, _FilterScrollBlock_hasIcons, "f") ? '_off' : '_active', "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_hasCheckboxes, this.root.hasClass('js-checkbox-select'), "f");
            const scrollerWrap = $('.js-scroller-wrap', this.root);
            __classPrivateFieldSet(this, _FilterScrollBlock_scroller, $('.js-scroller', this.root), "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_incompleteSet, __classPrivateFieldGet(this, _FilterScrollBlock_scroller, "f").attr('data-incomplete-set') === 'True', "f");
            __classPrivateFieldSet(this, _FilterScrollBlock_selectMode, 'choice', "f");
            scrollerWrap.baron({
                scroller: '.js-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            if (__classPrivateFieldGet(this, _FilterScrollBlock_hasIcons, "f") || __classPrivateFieldGet(this, _FilterScrollBlock_hasCheckboxes, "f"))
                __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_bindOptions).call(this, __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f")));
            __classPrivateFieldGet(this, _FilterScrollBlock_selectAll, "f").on('click', () => {
                const filterOptions = __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f"));
                if (__classPrivateFieldGet(this, _FilterScrollBlock_selectMode, "f") == 'choice') {
                    filterOptions.each((i, v) => { $(v).toggle($(v).hasClass(__classPrivateFieldGet(this, _FilterScrollBlock_activityClass, "f"))); });
                    __classPrivateFieldSet(this, _FilterScrollBlock_selectMode, 'all', "f");
                }
                else {
                    filterOptions.show();
                    __classPrivateFieldSet(this, _FilterScrollBlock_selectMode, 'choice', "f");
                }
                __classPrivateFieldGet(this, _FilterScrollBlock_selectAll, "f").children('span').text(__classPrivateFieldGet(this, _FilterScrollBlock_selectMode, "f") === 'choice' ? 'Выбор' : 'Все');
                __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_updateInput).call(this);
            });
            __classPrivateFieldGet(this, _FilterScrollBlock_clearAll, "f").on('click', () => {
                __classPrivateFieldSet(this, _FilterScrollBlock_selectMode, 'choice', "f");
                __classPrivateFieldGet(this, _FilterScrollBlock_selectAll, "f").children('span').text('Выбор');
                const filterOptions = __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f"));
                if (__classPrivateFieldGet(this, _FilterScrollBlock_hasIcons, "f"))
                    filterOptions.addClass(__classPrivateFieldGet(this, _FilterScrollBlock_activityClass, "f"));
                else
                    filterOptions.removeClass(__classPrivateFieldGet(this, _FilterScrollBlock_activityClass, "f"));
                filterOptions.show();
                __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_updateInput).call(this);
                searchInput.val('');
                __classPrivateFieldGet(this, _FilterScrollBlock_clearAll, "f").hide();
                __classPrivateFieldGet(this, _FilterScrollBlock_selectAll, "f").hide();
            });
            searchInput.on('keyup', () => {
                const search = searchInput.valString().toLowerCase();
                __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f"))
                    .each((i, v) => { $(v).toggle(v.innerHTML.toLowerCase().includes(search)); });
            });
            __classPrivateFieldGet(this, _FilterScrollBlock_searchClear, "f").on('click', () => {
                __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f")).show();
                searchInput.val('');
            });
            __classPrivateFieldGet(this, _FilterScrollBlock_clearAll, "f").hide();
            __classPrivateFieldGet(this, _FilterScrollBlock_selectAll, "f").hide();
        }
        reset() {
            super.reset();
            __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_resetOptions).call(this);
            __classPrivateFieldGet(this, _FilterScrollBlock_searchClear, "f").trigger('click');
        }
        clear() {
            super.clear();
            this.clearOptions();
            __classPrivateFieldGet(this, _FilterScrollBlock_searchClear, "f").trigger('click');
        }
        clearOptions(preserveDefault = false) {
            let options = __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f"));
            if (preserveDefault)
                options = options.not('.js-default-option');
            options.remove();
            __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_updateInputValue).call(this);
        }
        addOptions(items) {
            var _b;
            const templateName = __classPrivateFieldGet(this, _FilterScrollBlock_scroller, "f").attr('data-template');
            if (!templateName)
                return;
            const iconPrefix = (_b = __classPrivateFieldGet(this, _FilterScrollBlock_scroller, "f").attr('data-icon-prefix')) !== null && _b !== void 0 ? _b : '';
            items.forEach(v => (v.custom = iconPrefix + v.value));
            const options = $(App.findTemplate(templateName)(items));
            __classPrivateFieldGet(this, _FilterScrollBlock_scroller, "f").append(options);
            __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_updateInputValue).call(this);
            __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_bindOptions).call(this, options);
        }
        getValue() {
            return __classPrivateFieldGet(this, _FilterScrollBlock_input, "f").valString();
        }
    }
    _a = FilterScrollBlock, _FilterScrollBlock_input = new WeakMap(), _FilterScrollBlock_selectAll = new WeakMap(), _FilterScrollBlock_clearAll = new WeakMap(), _FilterScrollBlock_searchClear = new WeakMap(), _FilterScrollBlock_optionContainer = new WeakMap(), _FilterScrollBlock_hasIcons = new WeakMap(), _FilterScrollBlock_selectMode = new WeakMap(), _FilterScrollBlock_activityClass = new WeakMap(), _FilterScrollBlock_hasCheckboxes = new WeakMap(), _FilterScrollBlock_scroller = new WeakMap(), _FilterScrollBlock_incompleteSet = new WeakMap(), _FilterScrollBlock_instances = new WeakSet(), _FilterScrollBlock_getOptions = function _FilterScrollBlock_getOptions(container) {
        return $('.js-filter-option', container);
    }, _FilterScrollBlock_resetOptions = function _FilterScrollBlock_resetOptions() {
        const options = __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f"));
        if (__classPrivateFieldGet(this, _FilterScrollBlock_hasIcons, "f"))
            options.addClass(__classPrivateFieldGet(this, _FilterScrollBlock_activityClass, "f"));
        else
            options.removeClass(__classPrivateFieldGet(this, _FilterScrollBlock_activityClass, "f"));
        options.show();
        __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_updateInputValue).call(this);
    }, _FilterScrollBlock_updateInput = function _FilterScrollBlock_updateInput() {
        __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_updateInputValue).call(this);
        __classPrivateFieldGet(this, _FilterScrollBlock_input, "f").trigger('change');
        this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
    }, _FilterScrollBlock_updateInputValue = function _FilterScrollBlock_updateInputValue() {
        __classPrivateFieldGet(this, _FilterScrollBlock_input, "f").trigger('focusin');
        const options = __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f"));
        const activeOptions = (__classPrivateFieldGet(this, _FilterScrollBlock_hasCheckboxes, "f") ? options.filter('._active') : options.not('._off').not('._reset'));
        const values = new Array();
        if (options.length > activeOptions.length || __classPrivateFieldGet(this, _FilterScrollBlock_incompleteSet, "f")) {
            activeOptions.each((_, element) => {
                values.push(($(element).attr('data-val') || '').trim());
            });
        }
        const valuesStr = values.join(',');
        __classPrivateFieldGet(this, _FilterScrollBlock_input, "f")
            .val(valuesStr)
            .attr('value', valuesStr);
        __classPrivateFieldGet(this, _FilterScrollBlock_input, "f").trigger('focusout');
    }, _FilterScrollBlock_bindOptions = function _FilterScrollBlock_bindOptions(options) {
        options.on('click', e => __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_onOptionClick).call(this, e));
    }, _FilterScrollBlock_onOptionClick = function _FilterScrollBlock_onOptionClick(e) {
        const target = $(e.currentTarget);
        target.toggleClass(__classPrivateFieldGet(this, _FilterScrollBlock_activityClass, "f"));
        __classPrivateFieldGet(this, _FilterScrollBlock_instances, "m", _FilterScrollBlock_updateInput).call(this);
        const options = __classPrivateFieldGet(_a, _a, "m", _FilterScrollBlock_getOptions).call(_a, __classPrivateFieldGet(this, _FilterScrollBlock_optionContainer, "f"));
        const activeOptions = (__classPrivateFieldGet(this, _FilterScrollBlock_hasCheckboxes, "f") ? options.filter('._active') : options.not('._off').not('._reset'));
        if (activeOptions.length > 0) {
            __classPrivateFieldGet(this, _FilterScrollBlock_clearAll, "f").show();
            __classPrivateFieldGet(this, _FilterScrollBlock_selectAll, "f").show();
        }
        else {
            __classPrivateFieldGet(this, _FilterScrollBlock_clearAll, "f").hide();
            __classPrivateFieldGet(this, _FilterScrollBlock_selectAll, "f").hide();
        }
    };
    App.FilterScrollBlock = FilterScrollBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterSelectBlock_instances, _FilterSelectBlock_jelect, _FilterSelectBlock_jelectInput, _FilterSelectBlock_jelectCurrent, _FilterSelectBlock_searchClear, _FilterSelectBlock_scrollerWrap, _FilterSelectBlock_scroller, _FilterSelectBlock_optionContainer, _FilterSelectBlock_hasIcons, _FilterSelectBlock_activityClass, _FilterSelectBlock_hasCheckboxes, _FilterSelectBlock_jelectInstance, _FilterSelectBlock_getItems, _FilterSelectBlock_resetOptions, _FilterSelectBlock_updateInput, _FilterSelectBlock_bindOptions, _FilterSelectBlock_onOptionClick;
    class FilterSelectBlock extends App.FilterListBlockBase {
        constructor(options) {
            super(Object.assign({}, options));
            _FilterSelectBlock_instances.add(this);
            _FilterSelectBlock_jelect.set(this, void 0);
            _FilterSelectBlock_jelectInput.set(this, void 0);
            _FilterSelectBlock_jelectCurrent.set(this, void 0);
            _FilterSelectBlock_searchClear.set(this, void 0);
            _FilterSelectBlock_scrollerWrap.set(this, void 0);
            _FilterSelectBlock_scroller.set(this, void 0);
            _FilterSelectBlock_optionContainer.set(this, void 0);
            _FilterSelectBlock_hasIcons.set(this, void 0);
            _FilterSelectBlock_activityClass.set(this, void 0);
            _FilterSelectBlock_hasCheckboxes.set(this, void 0);
            _FilterSelectBlock_jelectInstance.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FilterSelectBlock_jelect, $('.js-jelect', this.root), "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_jelectInput, $('.js-jelect-input', __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f")), "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_jelectCurrent, $('.js-jelect-current', __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f")), "f");
            const searchContainer = $('.js-filter-search', this.root);
            const searchInput = $('.js-filter-search-input', searchContainer);
            __classPrivateFieldSet(this, _FilterSelectBlock_searchClear, $('.js-clear-filter-search', searchContainer), "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_scrollerWrap, $('.js-scroller-wrap', this.root), "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_scroller, $('.js-scroller', this.root), "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_optionContainer, $('.js-jelect-options', this.root), "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_hasIcons, this.root.hasClass('js-icons-select'), "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_activityClass, __classPrivateFieldGet(this, _FilterSelectBlock_hasIcons, "f") ? '_off' : '_active', "f");
            __classPrivateFieldSet(this, _FilterSelectBlock_hasCheckboxes, this.root.hasClass('js-checkbox-select'), "f");
            this.name = this.root.attr('data-select') || __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f").attr('name') || null;
            // Инициализируем выпадающие списки
            const plugins = new Array();
            if (__classPrivateFieldGet(this, _FilterSelectBlock_searchClear, "f").length > 0)
                plugins.push('clearFilter');
            if ((__classPrivateFieldGet(this, _FilterSelectBlock_hasIcons, "f") || __classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f")) && __classPrivateFieldGet(this, _FilterSelectBlock_scroller, "f").attr('data-selected-first') === 'True')
                plugins.push('selectFirst');
            __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").jelect({ plugins });
            const initialValue = __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f").val() || '';
            if (__classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").val() !== initialValue)
                __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").val(initialValue);
            __classPrivateFieldSet(this, _FilterSelectBlock_jelectInstance, __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").data('jelect'), "f");
            // Стилизуем скролл
            const scroll = __classPrivateFieldGet(this, _FilterSelectBlock_scrollerWrap, "f").baron({
                scroller: '.js-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").on('click', () => {
                scroll.update();
            });
            // Если блок содержит иконки или чекбоксы
            if (__classPrivateFieldGet(this, _FilterSelectBlock_hasIcons, "f") || __classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f")) {
                // Обрабатываем клики по элементам списков
                __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_bindOptions).call(this, __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this));
            }
            else {
                __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").on('change', () => {
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                });
            }
            searchInput.on('keyup', () => {
                const search = searchInput.valString().toLowerCase();
                __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this).each((i, v) => { $(v).toggle(v.innerHTML.toLowerCase().includes(search)); });
            });
            __classPrivateFieldGet(this, _FilterSelectBlock_searchClear, "f").on('click', () => {
                __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this).show();
                searchInput.val('');
            });
        }
        reset() {
            super.reset();
            __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_resetOptions).call(this);
            __classPrivateFieldGet(this, _FilterSelectBlock_searchClear, "f").trigger('click');
        }
        clear() {
            super.clear();
            this.clearOptions();
            __classPrivateFieldGet(this, _FilterSelectBlock_searchClear, "f").trigger('click');
        }
        clearOptions(preserveDefault = false) {
            let options = __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this);
            if (preserveDefault)
                options = options.not('.js-default-option');
            options.remove();
            this.updateInputValue();
        }
        updateInputValue() {
            __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f").trigger('focusin');
            const options = __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this);
            // Контролы с одиночным выбором корректно отрабатываются самим скриптом jelect.
            if (!__classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f")) {
                const activeOptions = options.filter('.jelect-option_state_active');
                const value = ($(activeOptions[0]).attr('data-val') || '').trim();
                const text = $(activeOptions[0]).text().trim();
                // Note: если использовать стандартный метод setValue от jelect, то мы не будем иметь возможность управлять инициированием
                // события 'change' только тогда когда нам нужно и оно будет инициироваться всегда.
                // this.#jelect.jelect('setValue', option.attr('data-val'));
                __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").val(value);
                // TODO: непонятно как узнать о поддержке autocomplete данным экземпляром jelect.
                // if (this.#jelect.jelect('autocomplete')) {
                //   current.val(value);
                // } else {
                __classPrivateFieldGet(this, _FilterSelectBlock_jelectCurrent, "f")
                    .text(text)
                    .attr('data-val', value);
                __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f")
                    .val(value)
                    .attr('value', value);
                // }
            }
            else {
                /* TODO Titov: дерево курортов
                - какие-то проблемы при авто выборе ранее выбранных вариантов при изменении parent-фильтров (например, страны)
                - после изменения parent-фильтров (например, страны) почему то выбор одной опции у курортов включает кучу опций
                - если в url присутствует курорт, находящийся в дереве на 2+ уровне, то в текстовом поле не отображается выбранные варианты
                - если выбраны не все опции одного уровня, то у parent'ов отображается галочка, хотя должен отображаться квадратик (как в
                выборе экскурсий в корзине)
                - если выбрана parent-опция, то нельзя убрать/выбрать child-опции, пока не снимешь parent-опцию
                - если выбрать child-опцию и потом parent-опцию, то при снятии parent-опции ранее выбранная child-опция остается выбранной
                - если выбрать parent-опцию и потом попытаться снять child-опцию, то parent-опция должна сниматься, а все child-опции (кроме
                той которую пытались снять) - быть выбраны
                - если выбрана child-опция, то parent не помечается как выбранная полностью или частично (в зависимости от наличия еще
                невыбранных child-опций)
                */
                const values = new Array();
                const texts = new Array();
                options.filter('._active').each((index2, element2) => {
                    values.push(($(element2).attr('data-val') || '').trim());
                    texts.push($(element2).text().trim());
                });
                const valuesStr = values.join(',');
                __classPrivateFieldGet(this, _FilterSelectBlock_jelectCurrent, "f")
                    .text(texts.join(', '))
                    .attr('data-val', valuesStr);
                __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f")
                    .val(valuesStr)
                    .attr('value', valuesStr);
            }
            __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f").trigger('focusout');
        }
        addOptions(items) {
            const templateName = __classPrivateFieldGet(this, _FilterSelectBlock_scroller, "f").attr('data-template');
            if (!templateName)
                return;
            const options = $(App.findTemplate(templateName)(items));
            __classPrivateFieldGet(this, _FilterSelectBlock_scroller, "f").append(options);
            if (!__classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f"))
                __classPrivateFieldGet(this, _FilterSelectBlock_jelectInstance, "f").values = __classPrivateFieldGet(this, _FilterSelectBlock_jelectInstance, "f").serialize();
            const allOptions = __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this);
            const defaultOptions = allOptions.filter(__classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f") ? '.js-filter-option-all' : '.js-default-option');
            const activeOptions = allOptions
                .not(defaultOptions)
                .filter(__classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f") ? '._active' : '.jelect-option_state_active');
            if (defaultOptions.length > 0) {
                if (activeOptions.length === 0)
                    defaultOptions.addClass(__classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f") ? '_active' : 'jelect-option_state_active');
                else
                    defaultOptions.removeClass(__classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f") ? '_active' : 'jelect-option_state_active');
            }
            this.updateInputValue();
            if (__classPrivateFieldGet(this, _FilterSelectBlock_hasIcons, "f") || __classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f"))
                __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_bindOptions).call(this, options);
        }
        getOptions() {
            const result = new Array();
            __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this).each((_, v) => {
                const item = $(v);
                result.push({
                    value: (item.attr('data-val') || '').trim(),
                    text: item.text().trim(),
                    selected: item.hasClass(__classPrivateFieldGet(this, _FilterSelectBlock_hasCheckboxes, "f") ? '._active' : '.jelect-option_state_active'),
                });
            });
            return result;
        }
        setValue(value) {
            __classPrivateFieldGet(this, _FilterSelectBlock_jelect, "f").jelect('setValue', value);
        }
        getValue() {
            return __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f").valString();
        }
    }
    _FilterSelectBlock_jelect = new WeakMap(), _FilterSelectBlock_jelectInput = new WeakMap(), _FilterSelectBlock_jelectCurrent = new WeakMap(), _FilterSelectBlock_searchClear = new WeakMap(), _FilterSelectBlock_scrollerWrap = new WeakMap(), _FilterSelectBlock_scroller = new WeakMap(), _FilterSelectBlock_optionContainer = new WeakMap(), _FilterSelectBlock_hasIcons = new WeakMap(), _FilterSelectBlock_activityClass = new WeakMap(), _FilterSelectBlock_hasCheckboxes = new WeakMap(), _FilterSelectBlock_jelectInstance = new WeakMap(), _FilterSelectBlock_instances = new WeakSet(), _FilterSelectBlock_getItems = function _FilterSelectBlock_getItems() {
        return $('.js-filter-option', __classPrivateFieldGet(this, _FilterSelectBlock_optionContainer, "f"));
    }, _FilterSelectBlock_resetOptions = function _FilterSelectBlock_resetOptions() {
        __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this).show();
        this.updateInputValue();
    }, _FilterSelectBlock_updateInput = function _FilterSelectBlock_updateInput(target) {
        const options = __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_getItems).call(this);
        // Если кликнули НЕ по пункту 'Сбросить'
        if (target.hasClass(__classPrivateFieldGet(this, _FilterSelectBlock_activityClass, "f"))) {
            // Сняли выделение с пункта
            target.removeClass(__classPrivateFieldGet(this, _FilterSelectBlock_activityClass, "f"));
            // Если в результате нет активных пунктов, выбираем пункт 'Все ... (страны, например)'
            if (options.filter(`.${__classPrivateFieldGet(this, _FilterSelectBlock_activityClass, "f")}`).length === 0)
                options.filter('.js-filter-option-all').trigger('click');
        }
        else {
            // Отметили пункт как активный
            // Если выбран вариант 'Все ... (страны, например)'
            if (target.hasClass('js-filter-option-all'))
                options.filter(`.${__classPrivateFieldGet(this, _FilterSelectBlock_activityClass, "f")}`).removeClass(__classPrivateFieldGet(this, _FilterSelectBlock_activityClass, "f"));
            else
                options.filter('.js-filter-option-all').removeClass(__classPrivateFieldGet(this, _FilterSelectBlock_activityClass, "f"));
            target.addClass(__classPrivateFieldGet(this, _FilterSelectBlock_activityClass, "f"));
        }
        this.updateInputValue();
        __classPrivateFieldGet(this, _FilterSelectBlock_jelectInput, "f").trigger('change');
        this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
    }, _FilterSelectBlock_bindOptions = function _FilterSelectBlock_bindOptions(options) {
        options.on('click', e => __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_onOptionClick).call(this, e));
    }, _FilterSelectBlock_onOptionClick = function _FilterSelectBlock_onOptionClick(e) {
        // Данный вызов предотвращает вызов стандартного обработчика в плагине jelect, что позволяет оставить список открытым для
        // единовременного выбора нескольких опций.
        e.preventDefault();
        __classPrivateFieldGet(this, _FilterSelectBlock_instances, "m", _FilterSelectBlock_updateInput).call(this, $(e.target).closest('.js-jelect-option'));
        return false;
    };
    App.FilterSelectBlock = FilterSelectBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterServicesBlock_instances, _a, _FilterServicesBlock_input, _FilterServicesBlock_optionContainer, _FilterServicesBlock_resetOptions, _FilterServicesBlock_updateInput, _FilterServicesBlock_updateInputValue, _FilterServicesBlock_getOptions;
    class FilterServicesBlock extends App.FilterListBlockBase {
        constructor(options) {
            super(Object.assign({}, options));
            _FilterServicesBlock_instances.add(this);
            _FilterServicesBlock_input.set(this, void 0);
            _FilterServicesBlock_optionContainer.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FilterServicesBlock_input, $('.js-services-input', this.root), "f");
            __classPrivateFieldSet(this, _FilterServicesBlock_optionContainer, $('.js-service-items', this.root), "f");
            // Обрабатываем клики по элементам
            __classPrivateFieldGet(this, _FilterServicesBlock_optionContainer, "f").on('click', '.js-service-item', e => {
                const target = $(e.currentTarget);
                target.toggleClass('_off');
                __classPrivateFieldGet(this, _FilterServicesBlock_instances, "m", _FilterServicesBlock_updateInput).call(this);
            });
        }
        reset() {
            super.reset();
            __classPrivateFieldGet(this, _FilterServicesBlock_instances, "m", _FilterServicesBlock_resetOptions).call(this);
        }
        clear() {
            super.clear();
            this.clearOptions();
        }
        clearOptions() {
            __classPrivateFieldGet(_a, _a, "m", _FilterServicesBlock_getOptions).call(_a, this.root).remove();
            __classPrivateFieldGet(this, _FilterServicesBlock_instances, "m", _FilterServicesBlock_updateInputValue).call(this);
        }
        addOptions(items) {
            var _b;
            const templateName = __classPrivateFieldGet(this, _FilterServicesBlock_optionContainer, "f").attr('data-template');
            if (!templateName)
                return;
            const iconPrefix = (_b = __classPrivateFieldGet(this, _FilterServicesBlock_optionContainer, "f").attr('data-icon-prefix')) !== null && _b !== void 0 ? _b : '';
            items.forEach(v => (v.custom = iconPrefix + v.value));
            const options = $(App.findTemplate(templateName)(items));
            __classPrivateFieldGet(this, _FilterServicesBlock_optionContainer, "f").append(options);
            __classPrivateFieldGet(this, _FilterServicesBlock_instances, "m", _FilterServicesBlock_updateInputValue).call(this);
        }
        getValue() {
            return __classPrivateFieldGet(this, _FilterServicesBlock_input, "f").valString();
        }
    }
    _a = FilterServicesBlock, _FilterServicesBlock_input = new WeakMap(), _FilterServicesBlock_optionContainer = new WeakMap(), _FilterServicesBlock_instances = new WeakSet(), _FilterServicesBlock_resetOptions = function _FilterServicesBlock_resetOptions() {
        __classPrivateFieldGet(_a, _a, "m", _FilterServicesBlock_getOptions).call(_a, this.root).addClass('_off');
        __classPrivateFieldGet(this, _FilterServicesBlock_instances, "m", _FilterServicesBlock_updateInputValue).call(this);
    }, _FilterServicesBlock_updateInput = function _FilterServicesBlock_updateInput() {
        __classPrivateFieldGet(this, _FilterServicesBlock_instances, "m", _FilterServicesBlock_updateInputValue).call(this);
        __classPrivateFieldGet(this, _FilterServicesBlock_input, "f").trigger('change');
        this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
    }, _FilterServicesBlock_updateInputValue = function _FilterServicesBlock_updateInputValue() {
        __classPrivateFieldGet(this, _FilterServicesBlock_input, "f").trigger('focusin');
        const values = new Array();
        __classPrivateFieldGet(_a, _a, "m", _FilterServicesBlock_getOptions).call(_a, this.root)
            .not('._off')
            .each((index, element) => {
            values.push(($(element).attr('data-val') || '').trim());
        });
        const valuesStr = values.join(',');
        __classPrivateFieldGet(this, _FilterServicesBlock_input, "f")
            .val(valuesStr)
            .attr('value', valuesStr);
        __classPrivateFieldGet(this, _FilterServicesBlock_input, "f").trigger('focusout');
    }, _FilterServicesBlock_getOptions = function _FilterServicesBlock_getOptions(container) {
        return $('.js-service-item', container);
    };
    App.FilterServicesBlock = FilterServicesBlock;
})(App || (App = {}));
var App;
(function (App) {
    // TODO: удалить и использовать FilterSlidingButtonBlock!
    class FilterSingleCheckBoxBlock extends App.FilterBlockBase {
        constructor(options) {
            super(Object.assign({}, options));
            Object.defineProperty(this, "value", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "input", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            this.name = this.root.attr('data-name') || '';
            this.value = false;
            this.input = $('.js-filter-single-checkbox-input', this.root);
            this.root.on('click', e => {
                const target = $(e.currentTarget);
                const isActive = target.hasClass('_on');
                this.setValue((!isActive).toString());
                target.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
            });
        }
        reset() {
            super.reset();
            this.setValue('false');
        }
        clear() {
            super.clear();
            this.reset();
        }
        /**
         * Установить значение
         * @param newValue
         */
        setValue(newValue, triggerChange = false) {
            const isActive = newValue.toLowerCase() === 'true';
            if (isActive === this.value)
                return;
            this.root.toggleClass('_off _on');
            if (this.input) {
                if (isActive) {
                    this.input.val('true').attr('value', 'true');
                }
                else {
                    this.input.val('').attr('value', '');
                }
            }
            this.value = isActive;
            this.root.val(newValue);
            if (triggerChange)
                this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
        }
    }
    App.FilterSingleCheckBoxBlock = FilterSingleCheckBoxBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterSliderBlock_instances, _a, _FilterSliderBlock_s_defaults, _FilterSliderBlock_slider, _FilterSliderBlock_sliderFrom, _FilterSliderBlock_sliderTo, _FilterSliderBlock_min, _FilterSliderBlock_max, _FilterSliderBlock_changeValue, _FilterSliderBlock_insertValueToTextbox;
    class FilterSliderBlock extends App.FilterBlockBase {
        constructor(options) {
            var _b, _c;
            super(Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _FilterSliderBlock_s_defaults)), options));
            _FilterSliderBlock_instances.add(this);
            _FilterSliderBlock_slider.set(this, void 0);
            _FilterSliderBlock_sliderFrom.set(this, void 0);
            _FilterSliderBlock_sliderTo.set(this, void 0);
            _FilterSliderBlock_min.set(this, void 0);
            _FilterSliderBlock_max.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FilterSliderBlock_slider, $('.js-filter-slider', this.root), "f");
            __classPrivateFieldSet(this, _FilterSliderBlock_sliderFrom, $('[data-name="filter_price_from"]', this.root), "f");
            __classPrivateFieldSet(this, _FilterSliderBlock_sliderTo, $('[data-name="filter_price_to"]', this.root), "f");
            __classPrivateFieldSet(this, _FilterSliderBlock_min, this.options.min, "f");
            __classPrivateFieldSet(this, _FilterSliderBlock_max, this.options.max, "f");
            // Создаем слайдер
            __classPrivateFieldGet(this, _FilterSliderBlock_slider, "f").slider({
                range: true,
                slide: (e, ui) => {
                    if (ui.handle == null || ui.values == null)
                        return;
                    // TODO: проверить в других местах, в круизах ui.handle.index() не работает, поменяла на $(ui.handle).index(). Может
                    // лучше использовать ui.handle.handleIndex ????
                    if ($(ui.handle).index() === 1) {
                        // Если двигаем значение От
                        __classPrivateFieldGet(_a, _a, "m", _FilterSliderBlock_insertValueToTextbox).call(_a, ui.values[0], __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f"));
                    }
                    else if (ui.values[1] > __classPrivateFieldGet(this, _FilterSliderBlock_max, "f")) {
                        // Если двигаем значение До и значение До превышает максимум, ограничиваем его максимумом
                        __classPrivateFieldGet(_a, _a, "m", _FilterSliderBlock_insertValueToTextbox).call(_a, __classPrivateFieldGet(this, _FilterSliderBlock_max, "f"), __classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f"));
                    }
                    else {
                        __classPrivateFieldGet(_a, _a, "m", _FilterSliderBlock_insertValueToTextbox).call(_a, ui.values[1], __classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f"));
                    }
                },
                stop: () => {
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                },
            });
            // Выставляем начальные значения в инпутах, если нет
            let fromValue = Number((_b = __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f").attr('data-money-amount')) !== null && _b !== void 0 ? _b : '0');
            let toValue = Number((_c = __classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f").attr('data-money-amount')) !== null && _c !== void 0 ? _c : '0');
            if (fromValue === 0)
                fromValue = __classPrivateFieldGet(this, _FilterSliderBlock_min, "f");
            if (toValue === 0)
                toValue = __classPrivateFieldGet(this, _FilterSliderBlock_max, "f");
            // Применяем маску к инпутам - только цифры и пробел
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f").add(__classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f")).inputmask({
                regex: '[0-9 ]*',
            });
            // После определения минумума, максимума и значения от и до задаем эти параметры слайдеру
            this.setValues(fromValue, toValue, __classPrivateFieldGet(this, _FilterSliderBlock_min, "f"), __classPrivateFieldGet(this, _FilterSliderBlock_max, "f"));
            // Обрабатываем клик или фокус по инпуту
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f").add(__classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f")).on('click focus', e => {
                var _b;
                const target = $(e.currentTarget);
                target.val((_b = target.attr('data-text')) !== null && _b !== void 0 ? _b : '');
            });
            // Отслеживаем и форматируем значение инпута и слайдера при вводе в инпутах
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f").on('change blur', e => {
                var _b;
                const target = $(e.currentTarget);
                const value = (_b = target.valNumber()) !== null && _b !== void 0 ? _b : 0;
                // Если значение ОТ меньше минимума или больше максимума, ограничиваем его минимумом
                if (value < __classPrivateFieldGet(this, _FilterSliderBlock_min, "f") || value > __classPrivateFieldGet(this, _FilterSliderBlock_max, "f")) {
                    target.val(__classPrivateFieldGet(this, _FilterSliderBlock_min, "f"));
                    return;
                }
                __classPrivateFieldGet(this, _FilterSliderBlock_instances, "m", _FilterSliderBlock_changeValue).call(this, target, 0);
                if (e.type === 'blur') {
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                }
            });
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f").on('change blur', e => {
                var _b;
                const target = $(e.currentTarget);
                const value = (_b = target.valNumber()) !== null && _b !== void 0 ? _b : 0;
                // Если значение До превышает максимум или меньше минимума, ограничиваем его максимумом
                if (value > __classPrivateFieldGet(this, _FilterSliderBlock_max, "f") || value < __classPrivateFieldGet(this, _FilterSliderBlock_min, "f")) {
                    target.val(__classPrivateFieldGet(this, _FilterSliderBlock_max, "f"));
                    return;
                }
                __classPrivateFieldGet(this, _FilterSliderBlock_instances, "m", _FilterSliderBlock_changeValue).call(this, target, 1);
                if (e.type === 'blur') {
                    this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
                }
            });
        }
        reset() {
            super.reset();
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f").val(__classPrivateFieldGet(this, _FilterSliderBlock_slider, "f").slider('option', 'min'));
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f").trigger('change');
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f").val(__classPrivateFieldGet(this, _FilterSliderBlock_slider, "f").slider('option', 'max'));
            __classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f").trigger('change');
        }
        clear() {
            super.clear();
            this.reset();
        }
        /**
         * Устанавливает значение контролу.
         * @param from цена от
         * @param to цена до
         * @param min минимальная цена
         * @param max максимальная цена
         */
        setValues(from, to, min, max) {
            // Округляем from и min до меньшего целого. to и max - до большего целого,
            // т.к. когда цены с копейками, выглядит не красиво, а при округлении охват диапазона цен сохранится
            const newFrom = Math.floor(from);
            const newTo = Math.ceil(to);
            __classPrivateFieldSet(this, _FilterSliderBlock_min, Math.floor(min), "f");
            __classPrivateFieldSet(this, _FilterSliderBlock_max, Math.ceil(max), "f");
            __classPrivateFieldGet(_a, _a, "m", _FilterSliderBlock_insertValueToTextbox).call(_a, newFrom, __classPrivateFieldGet(this, _FilterSliderBlock_sliderFrom, "f"));
            __classPrivateFieldGet(_a, _a, "m", _FilterSliderBlock_insertValueToTextbox).call(_a, newTo, __classPrivateFieldGet(this, _FilterSliderBlock_sliderTo, "f"));
            __classPrivateFieldGet(this, _FilterSliderBlock_slider, "f").slider('option', { min: __classPrivateFieldGet(this, _FilterSliderBlock_min, "f"), max: __classPrivateFieldGet(this, _FilterSliderBlock_max, "f") });
            __classPrivateFieldGet(this, _FilterSliderBlock_slider, "f").slider('values', [newFrom, newTo]);
        }
    }
    _a = FilterSliderBlock, _FilterSliderBlock_slider = new WeakMap(), _FilterSliderBlock_sliderFrom = new WeakMap(), _FilterSliderBlock_sliderTo = new WeakMap(), _FilterSliderBlock_min = new WeakMap(), _FilterSliderBlock_max = new WeakMap(), _FilterSliderBlock_instances = new WeakSet(), _FilterSliderBlock_changeValue = function _FilterSliderBlock_changeValue(textBox, sliderValueIndex) {
        const newValue = Number(textBox.valString());
        __classPrivateFieldGet(_a, _a, "m", _FilterSliderBlock_insertValueToTextbox).call(_a, newValue, textBox);
        __classPrivateFieldGet(this, _FilterSliderBlock_slider, "f").slider('values', sliderValueIndex, newValue);
    }, _FilterSliderBlock_insertValueToTextbox = function _FilterSliderBlock_insertValueToTextbox(newValue, textBox) {
        textBox.val(App.formatNumber(newValue, 'intMoney'));
        textBox.attr('data-text', newValue);
    };
    _FilterSliderBlock_s_defaults = { value: {
            root: '.js-filter-slider-block',
            min: 0,
            max: 500000,
        } };
    App.FilterSliderBlock = FilterSliderBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterSlidingButtonBlock_wrap, _FilterSlidingButtonBlock_input;
    class FilterSlidingButtonBlock extends App.FilterBlockBase {
        get disabled() {
            return this.root.hasClass('overlayed');
        }
        set disabled(value) {
            if (value)
                this.root.addClass('overlayed');
            else
                this.root.removeClass('overlayed');
        }
        constructor(options) {
            super(Object.assign({ root: App.app.appContainer, defaultValue: false }, options));
            _FilterSlidingButtonBlock_wrap.set(this, void 0);
            _FilterSlidingButtonBlock_input.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FilterSlidingButtonBlock_wrap, this.root.find('.js-sliding-btn'), "f");
            __classPrivateFieldSet(this, _FilterSlidingButtonBlock_input, this.root.find('input'), "f");
            if (!this.name) {
                const inputElement = __classPrivateFieldGet(this, _FilterSlidingButtonBlock_input, "f").get(0);
                if (inputElement)
                    this.name = inputElement.name;
            }
            __classPrivateFieldGet(this, _FilterSlidingButtonBlock_wrap, "f").on('click', e => {
                if (this.disabled)
                    return;
                this.setValue(!this.getValue());
                __classPrivateFieldGet(this, _FilterSlidingButtonBlock_input, "f").trigger('change');
                $(e.currentTarget).trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
            });
        }
        reset() {
            super.reset();
            this.setValue(this.options.defaultValue);
        }
        clear() {
            super.clear();
            this.reset();
        }
        getValue() {
            return __classPrivateFieldGet(this, _FilterSlidingButtonBlock_wrap, "f").hasClass('_on');
        }
        setValue(value) {
            __classPrivateFieldGet(this, _FilterSlidingButtonBlock_wrap, "f").toggleClass('_off', !value);
            __classPrivateFieldGet(this, _FilterSlidingButtonBlock_wrap, "f").toggleClass('_on', value);
            __classPrivateFieldGet(this, _FilterSlidingButtonBlock_input, "f").val(value.toString());
        }
    }
    _FilterSlidingButtonBlock_wrap = new WeakMap(), _FilterSlidingButtonBlock_input = new WeakMap();
    App.FilterSlidingButtonBlock = FilterSlidingButtonBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _FilterTimeOfDaySliderBlock_instances, _a, _FilterTimeOfDaySliderBlock_s_defaults, _FilterTimeOfDaySliderBlock_slider, _FilterTimeOfDaySliderBlock_sliderFrom, _FilterTimeOfDaySliderBlock_sliderTo, _FilterTimeOfDaySliderBlock_clear, _FilterTimeOfDaySliderBlock_min, _FilterTimeOfDaySliderBlock_max, _FilterTimeOfDaySliderBlock_fireSliderChange, _FilterTimeOfDaySliderBlock_onValueChange, _FilterTimeOfDaySliderBlock_insertValueToTextbox, _FilterTimeOfDaySliderBlock_getFormattedValue;
    class FilterTimeOfDaySliderBlock extends App.FilterBlockBase {
        constructor(options) {
            super(Object.assign(Object.assign({}, __classPrivateFieldGet(_a, _a, "f", _FilterTimeOfDaySliderBlock_s_defaults)), options));
            _FilterTimeOfDaySliderBlock_instances.add(this);
            _FilterTimeOfDaySliderBlock_slider.set(this, void 0);
            _FilterTimeOfDaySliderBlock_sliderFrom.set(this, void 0);
            _FilterTimeOfDaySliderBlock_sliderTo.set(this, void 0);
            _FilterTimeOfDaySliderBlock_clear.set(this, void 0);
            _FilterTimeOfDaySliderBlock_min.set(this, void 0);
            _FilterTimeOfDaySliderBlock_max.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_slider, $('.js-filter-slider', this.root), "f");
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_sliderFrom, $('[data-name="filter_from"]', this.root), "f");
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderFrom, "f").inputmask();
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_sliderTo, $('[data-name="filter_to"]', this.root), "f");
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_clear, $('.js-clear', this.root), "f");
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f").inputmask();
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderFrom, "f").on('keyup', e => __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_instances, "m", _FilterTimeOfDaySliderBlock_onValueChange).call(this, e));
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f").on('keyup', e => __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_instances, "m", _FilterTimeOfDaySliderBlock_onValueChange).call(this, e));
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_clear, "f").on('click', () => this.clear());
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_min, this.options.min, "f");
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_max, this.options.max, "f");
            // Создаем слайдер
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_slider, "f").slider({
                range: true,
                step: 5,
                slide: (e, ui) => {
                    if (ui.handle == null || ui.values == null)
                        return;
                    if ($(ui.handle).index() === 1) {
                        // Если двигаем значение От
                        __classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_insertValueToTextbox).call(_a, ui.values[0], __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderFrom, "f"));
                    }
                    else if (ui.values[1] >= __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_max, "f")) {
                        // Если двигаем значение До и значение До превышает максимум, ограничиваем его максимумом
                        __classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_insertValueToTextbox).call(_a, __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_max, "f") - 1, __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f"));
                    }
                    else {
                        __classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_insertValueToTextbox).call(_a, ui.values[1], __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f"));
                    }
                },
                stop: () => {
                    __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_instances, "m", _FilterTimeOfDaySliderBlock_fireSliderChange).call(this);
                },
            });
            // Выставляем начальные значения в инпутах, если нет
            let fromValue = _a.getMinutes(__classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderFrom, "f").valString());
            if (!fromValue)
                fromValue = __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_min, "f");
            let toValue = _a.getMinutes(__classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f").valString());
            if (!toValue)
                toValue = __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_max, "f");
            this.setValues(fromValue, toValue, __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_min, "f"), __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_max, "f"));
        }
        static getMinutes(value) {
            try {
                const hours = Number.parseInt(value.substring(0, 2));
                const minutes = Number.parseInt(value.substring(3, 5));
                return hours * 60 + minutes;
            }
            catch (_b) {
                return null;
            }
        }
        reset() {
            super.reset();
            const min = __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_slider, "f").slider('option', 'min');
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderFrom, "f").val(__classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_getFormattedValue).call(_a, min));
            const max = __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_slider, "f").slider('option', 'max');
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f").val(__classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_getFormattedValue).call(_a, max - 1));
            // достаточно одного триггера
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f").trigger('keyup');
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_instances, "m", _FilterTimeOfDaySliderBlock_fireSliderChange).call(this);
        }
        clear() {
            super.clear();
            this.reset();
        }
        /**
         * Устанавливает значение контролу.
         * @param from время от
         * @param to время до
         * @param min минимальное время
         * @param max максимальное время
         */
        setValues(from, to, min, max) {
            // Округляем from и min до меньшего целого. to и max - до большего целого,
            const newFrom = Math.floor(from);
            const newTo = Math.ceil(to);
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_min, Math.floor(min), "f");
            __classPrivateFieldSet(this, _FilterTimeOfDaySliderBlock_max, Math.ceil(max), "f");
            __classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_insertValueToTextbox).call(_a, newFrom, __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderFrom, "f"));
            __classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_insertValueToTextbox).call(_a, newTo, __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f"));
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_slider, "f").slider('option', { min: __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_min, "f"), max: __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_max, "f") });
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_slider, "f").slider('values', [newFrom, newTo]);
        }
        getValues() {
            return __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_slider, "f").slider('values');
        }
    }
    _a = FilterTimeOfDaySliderBlock, _FilterTimeOfDaySliderBlock_slider = new WeakMap(), _FilterTimeOfDaySliderBlock_sliderFrom = new WeakMap(), _FilterTimeOfDaySliderBlock_sliderTo = new WeakMap(), _FilterTimeOfDaySliderBlock_clear = new WeakMap(), _FilterTimeOfDaySliderBlock_min = new WeakMap(), _FilterTimeOfDaySliderBlock_max = new WeakMap(), _FilterTimeOfDaySliderBlock_instances = new WeakSet(), _FilterTimeOfDaySliderBlock_fireSliderChange = function _FilterTimeOfDaySliderBlock_fireSliderChange() {
        this.root.trigger("filter:change" /* Events.FilterChange */, [{ instance: this }]);
    }, _FilterTimeOfDaySliderBlock_onValueChange = function _FilterTimeOfDaySliderBlock_onValueChange(event) {
        const fromStr = __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderFrom, "f").valString();
        const from = _a.getMinutes(fromStr);
        const toStr = __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_sliderTo, "f").valString();
        const to = _a.getMinutes(toStr);
        if (from != null && to != null && from <= to) {
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_slider, "f").slider('values', [Math.floor(from), Math.ceil(to)]);
            __classPrivateFieldGet(this, _FilterTimeOfDaySliderBlock_instances, "m", _FilterTimeOfDaySliderBlock_fireSliderChange).call(this);
        }
        else {
            event.preventDefault();
            event.stopPropagation();
        }
    }, _FilterTimeOfDaySliderBlock_insertValueToTextbox = function _FilterTimeOfDaySliderBlock_insertValueToTextbox(value, textBox) {
        const fvalue = __classPrivateFieldGet(_a, _a, "m", _FilterTimeOfDaySliderBlock_getFormattedValue).call(_a, value);
        textBox.val(fvalue);
    }, _FilterTimeOfDaySliderBlock_getFormattedValue = function _FilterTimeOfDaySliderBlock_getFormattedValue(value) {
        const hours = Math.floor(value / 60).toString();
        const minutes = value % 60;
        if (minutes === 0)
            return (hours.length == 1 ? '0' : '') + hours + ':00';
        else
            return (hours.length == 1 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    };
    _FilterTimeOfDaySliderBlock_s_defaults = { value: {
            root: '.js-filter-timeofday-slider-block',
            min: 0,
            max: 1440,
        } };
    App.FilterTimeOfDaySliderBlock = FilterTimeOfDaySliderBlock;
})(App || (App = {}));
var App;
(function (App) {
    class ApiError extends Error {
        constructor(code, problem, request) {
            super('Api error');
            Object.defineProperty(this, "code", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "problem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "request", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, ApiError.prototype);
            this.code = code;
            this.problem = problem;
            this.request = request;
        }
    }
    App.ApiError = ApiError;
})(App || (App = {}));
var App;
(function (App) {
    var _Http_instances, _a, _Http_baseUrl, _Http_defaultRequestHeaders, _Http_handler, _Http_sendCore, _Http_processRelativeUrl, _Http_isAbsoluteUrl;
    const sendCookieFixHandler = (request, next) => __awaiter(this, void 0, void 0, function* () {
        if (request.credentials === 'same-origin')
            return yield next(request);
        // By spec, till August 2017 fetch won’t send cookies, unless you set "credentials: 'same-origin'".
        return yield next(new Request(request, { credentials: 'same-origin' }));
    });
    const overrideHttpMethodHandler = (request, next) => __awaiter(this, void 0, void 0, function* () {
        const { method } = request;
        if (method !== 'PUT' && method !== 'PATCH' && method !== 'DELETE')
            return yield next(request);
        const newRequest = new Request(request, { method: 'POST' });
        newRequest.headers.append('X-HTTP-Method-Override', method);
        return yield next(newRequest);
    });
    const httpErrorHandler = (request, next) => __awaiter(this, void 0, void 0, function* () {
        const response = yield next(request);
        if (response.ok)
            return response;
        const contentType = response.headers.get('Content-Type');
        if (contentType != null && contentType.split(';')[0] !== 'application/problem+json')
            throw new App.HttpError(response.status, response.statusText, request);
        const problemDetails = yield response.json();
        throw new App.ApiError(response.status, problemDetails);
    });
    /**
     * USAGE EXAMPLE:
     *
     * // Create Http instance.
     * const client = new Http({
     *  baseUrl: 'https://api.example.com/',
     *  throwOnResponseError: true,
     *  defaultRequestHeaders: {
     *    'Content-Type': HttpHeaderContentType.Json,
     *  },
     *  handlers: [
     *    async (request, next) => {
     *      request.headers.append('X-Referrer', window.location.href);
     *      return await next(request);
     *    },
     *  ],
     * });
     *
     * // Use for a GET request with relative url.
     * const response = await client.get('search');
     *
     * // Use for a POST request with absolute url and specified request body data.
     * const response = await client.post('https://example.com/book', { body: JSON.stringify({ 'field1': 1, 'field2': 'string' }) });
     *
     * // Use for a GET request and return parsed body text as JSON.
     * const config = await client.getJson<IConfig>('config.json');
     *
     * // Use for a request with an explicitly specified HTTP method.
     * const response = await client.send(`find.aspx?term=${search}`, { method: 'GET' });
     */
    class Http {
        constructor(options) {
            var _b, _c;
            _Http_instances.add(this);
            _Http_baseUrl.set(this, void 0);
            _Http_defaultRequestHeaders.set(this, void 0);
            _Http_handler.set(this, void 0);
            __classPrivateFieldSet(this, _Http_baseUrl, options === null || options === void 0 ? void 0 : options.baseUrl, "f");
            // Note: не реализовано через handler из-за проблемы неявного добавления заголовков при создании объекта Request внутри вызова
            // fetch из переданных аргументов. Например, добавляется заголовок "content-type" при использовании свойства "body" в запросе.
            if ((options === null || options === void 0 ? void 0 : options.defaultRequestHeaders) != null)
                __classPrivateFieldSet(this, _Http_defaultRequestHeaders, new Headers(options.defaultRequestHeaders), "f");
            const builder = new App.HandlerBuilder()
                .add(sendCookieFixHandler);
            if ((_b = options === null || options === void 0 ? void 0 : options.overrideHttpMethod) !== null && _b !== void 0 ? _b : false)
                builder.add(overrideHttpMethodHandler);
            if ((_c = options === null || options === void 0 ? void 0 : options.throwOnResponseError) !== null && _c !== void 0 ? _c : false)
                builder.add(httpErrorHandler);
            if (options === null || options === void 0 ? void 0 : options.handlers)
                builder.add(...options.handlers);
            __classPrivateFieldSet(this, _Http_handler, builder.build(window.fetch), "f");
        }
        send(input, init) {
            return __classPrivateFieldGet(this, _Http_instances, "m", _Http_sendCore).call(this, undefined, input, init);
        }
    }
    _a = Http, _Http_baseUrl = new WeakMap(), _Http_defaultRequestHeaders = new WeakMap(), _Http_handler = new WeakMap(), _Http_instances = new WeakSet(), _Http_sendCore = function _Http_sendCore(method, input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new Headers(init === null || init === void 0 ? void 0 : init.headers);
            if (__classPrivateFieldGet(this, _Http_defaultRequestHeaders, "f") != null) {
                const inputHeaders = typeof input === 'string' ? new Headers() : input.headers;
                __classPrivateFieldGet(this, _Http_defaultRequestHeaders, "f").forEach((v, k) => {
                    if (!inputHeaders.has(k) && !headers.has(k))
                        headers.set(k, v);
                });
            }
            const request = new Request(__classPrivateFieldGet(this, _Http_instances, "m", _Http_processRelativeUrl).call(this, input), Object.assign(Object.assign({}, init), { method, headers }));
            return yield __classPrivateFieldGet(this, _Http_handler, "f").call(this, request);
        });
    }, _Http_processRelativeUrl = function _Http_processRelativeUrl(input) {
        if (__classPrivateFieldGet(this, _Http_baseUrl, "f") != null && typeof input === 'string' && !__classPrivateFieldGet(_a, _a, "m", _Http_isAbsoluteUrl).call(_a, input))
            return new URL(input, __classPrivateFieldGet(this, _Http_baseUrl, "f")).href;
        return input;
    }, _Http_isAbsoluteUrl = function _Http_isAbsoluteUrl(url) {
        return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
    };
    App.Http = Http;
})(App || (App = {}));
/// <reference path='Http.ts' />
var App;
(function (App) {
    App.Http.prototype.getJson = function (input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (yield this.get(input, init)).json();
        });
    };
    App.Http.prototype.postJson = function (input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (yield this.post(input, init)).json();
        });
    };
    App.Http.prototype.putJson = function (input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (yield this.put(input, init)).json();
        });
    };
    App.Http.prototype.patchJson = function (input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (yield this.patch(input, init)).json();
        });
    };
    App.Http.prototype.deleteJson = function (input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (yield this.delete(input, init)).json();
        });
    };
    App.Http.prototype.sendJson = function (input, init) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (yield this.send(input, init)).json();
        });
    };
})(App || (App = {}));
/// <reference path='Http.ts' />
var App;
(function (App) {
    App.Http.prototype.get = function (input, init) {
        return this.send(new Request(input, { method: 'GET' }), init);
    };
    App.Http.prototype.post = function (input, init) {
        return this.send(new Request(input, { method: 'POST' }), init);
    };
    App.Http.prototype.put = function (input, init) {
        return this.send(new Request(input, { method: 'PUT' }), init);
    };
    App.Http.prototype.patch = function (input, init) {
        return this.send(new Request(input, { method: 'PATCH' }), init);
    };
    App.Http.prototype.delete = function (input, init) {
        return this.send(new Request(input, { method: 'DELETE' }), init);
    };
})(App || (App = {}));
var App;
(function (App) {
    class HttpError extends Error {
        constructor(code, text, request) {
            super('Http error');
            Object.defineProperty(this, "code", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "text", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "request", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, HttpError.prototype);
            this.code = code;
            this.text = text;
            this.request = request;
        }
    }
    App.HttpError = HttpError;
})(App || (App = {}));
var App;
(function (App) {
    var _CustomMarker_instances, _a, _CustomMarker_options, _CustomMarker_latlng, _CustomMarker_div, _CustomMarker_onCustomMarkerClick, _CustomMarker_getContentMarker;
    class CustomMarker extends google.maps.OverlayView {
        constructor(latlng, map, options) {
            super();
            _CustomMarker_instances.add(this);
            _CustomMarker_options.set(this, void 0);
            _CustomMarker_latlng.set(this, void 0);
            _CustomMarker_div.set(this, void 0);
            Object.defineProperty(this, "id", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "selected", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "minPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CustomMarker_latlng, latlng, "f");
            __classPrivateFieldSet(this, _CustomMarker_options, options, "f");
            if (options.markerId) {
                this.id = options.markerId;
            }
            this.minPrice = options.minPrice;
            this.setMap(map);
        }
        createDiv() {
            __classPrivateFieldSet(this, _CustomMarker_div, document.createElement('div'), "f");
            __classPrivateFieldGet(this, _CustomMarker_div, "f").className = 'customMarker';
            __classPrivateFieldGet(this, _CustomMarker_div, "f").innerHTML = __classPrivateFieldGet(_a, _a, "m", _CustomMarker_getContentMarker).call(_a, __classPrivateFieldGet(this, _CustomMarker_options, "f").content);
            if (typeof (__classPrivateFieldGet(this, _CustomMarker_options, "f").markerId) !== 'undefined') {
                __classPrivateFieldGet(this, _CustomMarker_div, "f").dataset.marker_id = __classPrivateFieldGet(this, _CustomMarker_options, "f").markerId.toString();
            }
        }
        draw() {
            const point = this.getProjection().fromLatLngToDivPixel(__classPrivateFieldGet(this, _CustomMarker_latlng, "f"));
            if (point) {
                __classPrivateFieldGet(this, _CustomMarker_div, "f").style.left = `${(point.x - __classPrivateFieldGet(this, _CustomMarker_div, "f").offsetWidth / 2)}px`;
                __classPrivateFieldGet(this, _CustomMarker_div, "f").style.top = `${(point.y - __classPrivateFieldGet(this, _CustomMarker_div, "f").offsetHeight)}px`;
            }
        }
        onAdd() {
            var _b;
            this.createDiv();
            __classPrivateFieldGet(this, _CustomMarker_div, "f").addEventListener('click', () => __classPrivateFieldGet(this, _CustomMarker_instances, "m", _CustomMarker_onCustomMarkerClick).call(this));
            (_b = this.getPanes()) === null || _b === void 0 ? void 0 : _b.overlayMouseTarget.appendChild(__classPrivateFieldGet(this, _CustomMarker_div, "f"));
        }
        getPosition() {
            return __classPrivateFieldGet(this, _CustomMarker_latlng, "f");
        }
        onRemove() {
            if (__classPrivateFieldGet(this, _CustomMarker_div, "f")) {
                __classPrivateFieldGet(this, _CustomMarker_div, "f").parentNode.removeChild(__classPrivateFieldGet(this, _CustomMarker_div, "f"));
            }
        }
        getOverlay() {
            return __classPrivateFieldGet(this, _CustomMarker_div, "f");
        }
        updateContent(content) {
            if (__classPrivateFieldGet(this, _CustomMarker_div, "f"))
                __classPrivateFieldGet(this, _CustomMarker_div, "f").innerHTML = __classPrivateFieldGet(_a, _a, "m", _CustomMarker_getContentMarker).call(_a, content);
        }
    }
    _a = CustomMarker, _CustomMarker_options = new WeakMap(), _CustomMarker_latlng = new WeakMap(), _CustomMarker_div = new WeakMap(), _CustomMarker_instances = new WeakSet(), _CustomMarker_onCustomMarkerClick = function _CustomMarker_onCustomMarkerClick() {
        google.maps.event.trigger(this, 'click');
    }, _CustomMarker_getContentMarker = function _CustomMarker_getContentMarker(price) {
        return `<div class="text-pin"><div class="text-pin__shadow"></div><div class="text-pin__container"><div class="text-pin__text"><span>от</span> ${price}</div></div><div class="text-pin__arrow"></div></div>`;
    };
    App.CustomMarker = CustomMarker;
})(App || (App = {}));
var App;
(function (App) {
    var _GoogleMap_instances, _GoogleMap_root, _GoogleMap_bound, _GoogleMap_map, _GoogleMap_points, _GoogleMap_createMap;
    /**
     * Класс для работы с гугло-картами
     * Использовать его для создания своих классов.
     * Типа UnfoldMap, HotelMAp
     */
    class GoogleMap {
        get map() {
            return __classPrivateFieldGet(this, _GoogleMap_map, "f");
        }
        /**
         * Конструктор
         * @param templateName - имя шаблона для отрисовки карты
         * @param drawModel - модель для отрисовки (передается в шаблон и может быть любой)
         * @param root - jQuery селектор для root-элемента карты
         */
        constructor(templateName, drawModel, root) {
            _GoogleMap_instances.add(this);
            _GoogleMap_root.set(this, void 0);
            _GoogleMap_bound.set(this, void 0);
            _GoogleMap_map.set(this, void 0);
            _GoogleMap_points.set(this, void 0);
            __classPrivateFieldSet(this, _GoogleMap_root, $(root), "f");
            __classPrivateFieldGet(this, _GoogleMap_instances, "m", _GoogleMap_createMap).call(this, templateName, drawModel);
            __classPrivateFieldSet(this, _GoogleMap_bound, new google.maps.LatLngBounds(), "f");
            __classPrivateFieldSet(this, _GoogleMap_points, new Array(), "f");
        }
        /**
         * Добавление точек на карту.
         * Не делает отрисовку, добавляет точки во внутреннюю модель и в границы карты
         * TODO: так сделано, потому что в каждой карте, которая пользуется этим классом, маркеры отрисовываются по своему
         */
        addMapPoints(coordinates) {
            coordinates.forEach(coord => {
                // расширим границы карты по координатам точек
                __classPrivateFieldGet(this, _GoogleMap_bound, "f").extend(new google.maps.LatLng(coord.latitude, coord.longitude));
                // Добавим точки во внутреннюю модель
                __classPrivateFieldGet(this, _GoogleMap_points, "f").push(coord);
            });
        }
        /**
         * Убирание точку с карты.
         * Не делает отрисовку, убирает точку из внутренней модели и из границ карты
         */
        removePoint(coordinate) {
            // сузим границы карты по координатам точек
            __classPrivateFieldSet(this, _GoogleMap_bound, new google.maps.LatLngBounds(), "f");
            // уберем точку из внутренней модели
            __classPrivateFieldSet(this, _GoogleMap_points, __classPrivateFieldGet(this, _GoogleMap_points, "f").filter(item => item.latitude !== coordinate.latitude && item.longitude !== coordinate.longitude), "f");
            // Расширим границы в соответствии с обновленными точками
            __classPrivateFieldGet(this, _GoogleMap_points, "f").forEach(coord => {
                __classPrivateFieldGet(this, _GoogleMap_bound, "f").extend(new google.maps.LatLng(coord.latitude, coord.longitude));
            });
        }
        /**
         * Убирание все точки с карты.
         * Не делает отрисовку, убирает все точки из внутренней модели и из границ карты
         */
        resetPoints() {
            __classPrivateFieldSet(this, _GoogleMap_bound, new google.maps.LatLngBounds(), "f");
            __classPrivateFieldSet(this, _GoogleMap_points, new Array(), "f");
        }
        /**
         * Устанавливает дополнительные опции карты
         * @param newOptions - новые опции
         */
        setAdditionalOptions(newOptions) {
            __classPrivateFieldGet(this, _GoogleMap_map, "f").setOptions(newOptions);
        }
        /**
         * Обновляет центр карты - позиционирует карты по центру и по границам объектов,
         * которые на ней размещены.
         * перед вызовом метода надо вызвать метод extendBounds
         * Надо, чтобы контейнер с картой не был display: none; т.к. в этом случае размера контейнера будет вычислен как 0х0 и не будет
         * правильно установлен масштаб
         */
        renewMapCenter() {
            // если точек мало, слегка расширить границы карты, т.к. точки получаются слишком близко
            if (__classPrivateFieldGet(this, _GoogleMap_points, "f") && __classPrivateFieldGet(this, _GoogleMap_points, "f").length === 1) {
                __classPrivateFieldGet(this, _GoogleMap_map, "f").setZoom(18);
                __classPrivateFieldGet(this, _GoogleMap_map, "f").setCenter(__classPrivateFieldGet(this, _GoogleMap_bound, "f").getCenter());
            }
            else {
                // TODO: пока убрала это. т.к. если две точки довольно далеко, то при зумме 15 они будут не видны. Наверное чтобы делать это
                // красиво и динамически рассчитывать, надо изучить координаты и как высчитать, сколько прибавить для нормальных границ
                // else if (this.#points && this.#points.length === 2)
                //   this.#map.setZoom(15);
                __classPrivateFieldGet(this, _GoogleMap_map, "f").fitBounds(__classPrivateFieldGet(this, _GoogleMap_bound, "f"));
            }
        }
        /**
         * Надо вызывать этот метод после изменения размера контейнера карты  - событие resize
         */
        resizeMap() {
            google.maps.event.trigger(__classPrivateFieldGet(this, _GoogleMap_map, "f"), 'resize');
        }
    }
    _GoogleMap_root = new WeakMap(), _GoogleMap_bound = new WeakMap(), _GoogleMap_map = new WeakMap(), _GoogleMap_points = new WeakMap(), _GoogleMap_instances = new WeakSet(), _GoogleMap_createMap = function _GoogleMap_createMap(templateName, drawModel) {
        const mapTemplate = App.findTemplate(templateName);
        const content = $(mapTemplate(drawModel));
        __classPrivateFieldGet(this, _GoogleMap_root, "f").empty();
        __classPrivateFieldGet(this, _GoogleMap_root, "f").append(content);
        const placesMapOptions = {
            zoom: 13,
            panControl: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: true,
        };
        const mapHolderId = __classPrivateFieldGet(this, _GoogleMap_root, "f").find('.js-map-holder').attr('id') || 'resorts-map';
        const mapDiv = document.getElementById(mapHolderId);
        if (mapDiv)
            __classPrivateFieldSet(this, _GoogleMap_map, new google.maps.Map(mapDiv, placesMapOptions), "f");
    };
    App.GoogleMap = GoogleMap;
})(App || (App = {}));
var App;
(function (App) {
    var _SimpleGoogleMap_instances, _a, _SimpleGoogleMap_mapWrap, _SimpleGoogleMap_mapContainerClass, _SimpleGoogleMap_points, _SimpleGoogleMap_zoom, _SimpleGoogleMap_iconImage, _SimpleGoogleMap_map, _SimpleGoogleMap_markers, _SimpleGoogleMap_latlngbounds, _SimpleGoogleMap_createMap, _SimpleGoogleMap_addMapHandler, _SimpleGoogleMap_displayPoints, _SimpleGoogleMap_createMarker, _SimpleGoogleMap_setViewport;
    class SimpleGoogleMap {
        constructor(points, wrap) {
            _SimpleGoogleMap_instances.add(this);
            _SimpleGoogleMap_mapWrap.set(this, void 0);
            _SimpleGoogleMap_mapContainerClass.set(this, void 0);
            _SimpleGoogleMap_points.set(this, void 0);
            _SimpleGoogleMap_zoom.set(this, void 0);
            _SimpleGoogleMap_iconImage.set(this, void 0);
            _SimpleGoogleMap_map.set(this, void 0);
            _SimpleGoogleMap_markers.set(this, void 0);
            _SimpleGoogleMap_latlngbounds.set(this, void 0);
            __classPrivateFieldSet(this, _SimpleGoogleMap_mapWrap, wrap, "f");
            __classPrivateFieldSet(this, _SimpleGoogleMap_mapContainerClass, '.js-auto-point-map', "f");
            __classPrivateFieldSet(this, _SimpleGoogleMap_points, points, "f");
            __classPrivateFieldSet(this, _SimpleGoogleMap_zoom, 14, "f");
            __classPrivateFieldSet(this, _SimpleGoogleMap_iconImage, '/img/resorts/map-marker-resort.png', "f");
            __classPrivateFieldSet(this, _SimpleGoogleMap_latlngbounds, new google.maps.LatLngBounds(), "f");
            __classPrivateFieldSet(this, _SimpleGoogleMap_markers, Array(), "f");
            __classPrivateFieldGet(this, _SimpleGoogleMap_instances, "m", _SimpleGoogleMap_createMap).call(this);
            __classPrivateFieldGet(_a, _a, "m", _SimpleGoogleMap_addMapHandler).call(_a, __classPrivateFieldGet(this, _SimpleGoogleMap_map, "f"), 'tilesloaded', () => __classPrivateFieldGet(this, _SimpleGoogleMap_instances, "m", _SimpleGoogleMap_displayPoints).call(this), true);
        }
        static show(points, wrap) {
            return new _a(points, wrap);
        }
    }
    _a = SimpleGoogleMap, _SimpleGoogleMap_mapWrap = new WeakMap(), _SimpleGoogleMap_mapContainerClass = new WeakMap(), _SimpleGoogleMap_points = new WeakMap(), _SimpleGoogleMap_zoom = new WeakMap(), _SimpleGoogleMap_iconImage = new WeakMap(), _SimpleGoogleMap_map = new WeakMap(), _SimpleGoogleMap_markers = new WeakMap(), _SimpleGoogleMap_latlngbounds = new WeakMap(), _SimpleGoogleMap_instances = new WeakSet(), _SimpleGoogleMap_createMap = function _SimpleGoogleMap_createMap() {
        const jqElement = $(__classPrivateFieldGet(this, _SimpleGoogleMap_mapContainerClass, "f"), __classPrivateFieldGet(this, _SimpleGoogleMap_mapWrap, "f"));
        const element = jqElement.get(0);
        if (!element)
            return;
        const options = {
            center: new google.maps.LatLng(__classPrivateFieldGet(this, _SimpleGoogleMap_points, "f")[0].coordinate.latitude, __classPrivateFieldGet(this, _SimpleGoogleMap_points, "f")[0].coordinate.longitude, false),
            zoom: __classPrivateFieldGet(this, _SimpleGoogleMap_zoom, "f"),
            zoomControl: true,
            zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP },
            panControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
        };
        __classPrivateFieldSet(this, _SimpleGoogleMap_map, new google.maps.Map(element, options), "f");
    }, _SimpleGoogleMap_addMapHandler = function _SimpleGoogleMap_addMapHandler(object, event, callback, isOnce = false) {
        if (isOnce)
            google.maps.event.addListenerOnce(object, event, callback);
        else
            google.maps.event.addListener(object, event, callback);
    }, _SimpleGoogleMap_displayPoints = function _SimpleGoogleMap_displayPoints() {
        __classPrivateFieldGet(this, _SimpleGoogleMap_points, "f").forEach(v => __classPrivateFieldGet(this, _SimpleGoogleMap_instances, "m", _SimpleGoogleMap_createMarker).call(this, v));
        __classPrivateFieldGet(this, _SimpleGoogleMap_instances, "m", _SimpleGoogleMap_setViewport).call(this);
    }, _SimpleGoogleMap_createMarker = function _SimpleGoogleMap_createMarker(point, isNeedUpdateCenter = true) {
        const icon = __classPrivateFieldGet(this, _SimpleGoogleMap_iconImage, "f");
        const position = new google.maps.LatLng(point.coordinate.latitude, point.coordinate.longitude, false);
        const markerOption = {
            position,
            map: __classPrivateFieldGet(this, _SimpleGoogleMap_map, "f"),
            title: point.title,
            id: point.id || 0,
            icon,
            has_infowin: false,
        };
        const marker = new google.maps.Marker(markerOption);
        // пока push, потом надо иметь уникальный id => this.#markers[marker.id]
        __classPrivateFieldGet(this, _SimpleGoogleMap_markers, "f").push(marker);
        if (isNeedUpdateCenter)
            __classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").extend(position);
        // this.addMapHandler(marker, 'click', e => this.onMarkerClick(e, marker), true);
    }, _SimpleGoogleMap_setViewport = function _SimpleGoogleMap_setViewport() {
        __classPrivateFieldGet(this, _SimpleGoogleMap_map, "f").setCenter(__classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").getCenter());
        if (__classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").getNorthEast().equals(__classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").getSouthWest())) {
            const extendPoint1 = new google.maps.LatLng(__classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").getNorthEast().lat() + 0.01, __classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").getNorthEast().lng() + 0.01);
            const extendPoint2 = new google.maps.LatLng(__classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").getNorthEast().lat() - 0.01, __classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").getNorthEast().lng() - 0.01);
            __classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").extend(extendPoint1);
            __classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f").extend(extendPoint2);
        }
        __classPrivateFieldGet(this, _SimpleGoogleMap_map, "f").fitBounds(__classPrivateFieldGet(this, _SimpleGoogleMap_latlngbounds, "f"));
    };
    App.SimpleGoogleMap = SimpleGoogleMap;
})(App || (App = {}));
var App;
(function (App) {
    var _UnfoldMap_instances, _UnfoldMap_googleMap, _UnfoldMap_needLegend, _UnfoldMap_mapModel, _UnfoldMap_mapButton, _UnfoldMap_mapButtonWrapper, _UnfoldMap_placesMapWrapper, _UnfoldMap_placesMap, _UnfoldMap_legendWrapper, _UnfoldMap_legendHeight, _UnfoldMap_defaultHeightMap, _UnfoldMap_mapWrapClass, _UnfoldMap_richMarkers, _UnfoldMap_createMap, _UnfoldMap_showHideMap, _UnfoldMap_buttonWrapperClick, _UnfoldMap_mapGenerateMarkers;
    /**
     * Разворачивающаяся карта (скрыть/показать)
     */
    class UnfoldMap {
        constructor(mapModel, needLegend = true, mapWrapClass = '') {
            _UnfoldMap_instances.add(this);
            _UnfoldMap_googleMap.set(this, void 0);
            _UnfoldMap_needLegend.set(this, void 0);
            _UnfoldMap_mapModel.set(this, void 0);
            _UnfoldMap_mapButton.set(this, void 0);
            _UnfoldMap_mapButtonWrapper.set(this, void 0);
            _UnfoldMap_placesMapWrapper.set(this, void 0);
            _UnfoldMap_placesMap.set(this, void 0);
            _UnfoldMap_legendWrapper.set(this, void 0);
            _UnfoldMap_legendHeight.set(this, void 0);
            _UnfoldMap_defaultHeightMap.set(this, void 0);
            _UnfoldMap_mapWrapClass.set(this, void 0);
            _UnfoldMap_richMarkers.set(this, new Array());
            __classPrivateFieldSet(this, _UnfoldMap_mapWrapClass, mapWrapClass.length > 0 ? mapWrapClass : '.js-resort-town-page', "f");
            __classPrivateFieldSet(this, _UnfoldMap_needLegend, needLegend, "f");
            __classPrivateFieldSet(this, _UnfoldMap_googleMap, new App.GoogleMap('Map', mapModel, __classPrivateFieldGet(this, _UnfoldMap_mapWrapClass, "f")), "f");
            if (__classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").map)
                __classPrivateFieldGet(this, _UnfoldMap_instances, "m", _UnfoldMap_createMap).call(this, mapModel);
        }
        /**
         * Делаем refresh гугло-карты
         */
        reinitMap() {
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").renewMapCenter();
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").resizeMap();
        }
        setSelection(coordinate) {
            const point = new google.maps.LatLng(coordinate.latitude, coordinate.longitude);
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").map.setCenter(point);
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").map.setZoom(18);
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").resizeMap();
        }
        /**
         * Открытие карты
         * Если карта открыта, не закрывает ее
         */
        openMap() {
            __classPrivateFieldGet(this, _UnfoldMap_instances, "m", _UnfoldMap_showHideMap).call(this, true);
        }
        removePoint(coordinate) {
            __classPrivateFieldGet(this, _UnfoldMap_mapModel, "f").mapPoints = __classPrivateFieldGet(this, _UnfoldMap_mapModel, "f").mapPoints
                .filter(item => item.coordinates.latitude !== coordinate.latitude && item.coordinates.longitude !== coordinate.longitude);
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").removePoint(coordinate);
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").renewMapCenter();
        }
    }
    _UnfoldMap_googleMap = new WeakMap(), _UnfoldMap_needLegend = new WeakMap(), _UnfoldMap_mapModel = new WeakMap(), _UnfoldMap_mapButton = new WeakMap(), _UnfoldMap_mapButtonWrapper = new WeakMap(), _UnfoldMap_placesMapWrapper = new WeakMap(), _UnfoldMap_placesMap = new WeakMap(), _UnfoldMap_legendWrapper = new WeakMap(), _UnfoldMap_legendHeight = new WeakMap(), _UnfoldMap_defaultHeightMap = new WeakMap(), _UnfoldMap_mapWrapClass = new WeakMap(), _UnfoldMap_richMarkers = new WeakMap(), _UnfoldMap_instances = new WeakSet(), _UnfoldMap_createMap = function _UnfoldMap_createMap(mapModel) {
        __classPrivateFieldSet(this, _UnfoldMap_mapModel, mapModel, "f");
        __classPrivateFieldSet(this, _UnfoldMap_placesMapWrapper, $('.js-map-wrapper'), "f");
        __classPrivateFieldSet(this, _UnfoldMap_placesMap, $('.js-places-map', __classPrivateFieldGet(this, _UnfoldMap_placesMapWrapper, "f")), "f");
        // кнопка показать
        __classPrivateFieldSet(this, _UnfoldMap_mapButton, $('.js-map-button', __classPrivateFieldGet(this, _UnfoldMap_placesMapWrapper, "f")), "f");
        __classPrivateFieldSet(this, _UnfoldMap_mapButtonWrapper, $('.js-map-overlay', __classPrivateFieldGet(this, _UnfoldMap_placesMapWrapper, "f")), "f");
        __classPrivateFieldGet(this, _UnfoldMap_mapButton, "f").on('click', () => {
            __classPrivateFieldGet(this, _UnfoldMap_instances, "m", _UnfoldMap_showHideMap).call(this);
        });
        __classPrivateFieldGet(this, _UnfoldMap_mapButtonWrapper, "f").on('click', () => __classPrivateFieldGet(this, _UnfoldMap_instances, "m", _UnfoldMap_buttonWrapperClick).call(this));
        __classPrivateFieldSet(this, _UnfoldMap_defaultHeightMap, parseInt(__classPrivateFieldGet(this, _UnfoldMap_placesMap, "f").css('height'), 10), "f");
        // Если нужна легенда, вычисляем ее высоту, чтобы потом развернуть при разворачивании карты
        // Если не нужна - ее высота равна 0 и она не развернется
        __classPrivateFieldSet(this, _UnfoldMap_legendHeight, 0, "f");
        if (__classPrivateFieldGet(this, _UnfoldMap_needLegend, "f")) {
            __classPrivateFieldSet(this, _UnfoldMap_legendWrapper, $('.legend-wrapper', __classPrivateFieldGet(this, _UnfoldMap_placesMapWrapper, "f")), "f");
            const legend = $('.legend', __classPrivateFieldGet(this, _UnfoldMap_legendWrapper, "f"));
            __classPrivateFieldSet(this, _UnfoldMap_legendHeight, legend.outerHeight() || 0, "f");
        }
        __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").addMapPoints(__classPrivateFieldGet(this, _UnfoldMap_mapModel, "f").mapPoints.map(item => item.coordinates));
        __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").renewMapCenter();
        __classPrivateFieldGet(this, _UnfoldMap_instances, "m", _UnfoldMap_mapGenerateMarkers).call(this, __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").map);
    }, _UnfoldMap_showHideMap = function _UnfoldMap_showHideMap(openAlways) {
        let needBlockHeight = 500;
        let needButtonText = __classPrivateFieldGet(this, _UnfoldMap_mapButton, "f").attr('data-replace');
        let legendHeight = __classPrivateFieldGet(this, _UnfoldMap_legendHeight, "f");
        __classPrivateFieldGet(this, _UnfoldMap_placesMapWrapper, "f").toggleClass('opened', openAlways);
        if (!__classPrivateFieldGet(this, _UnfoldMap_placesMapWrapper, "f").hasClass('opened')) {
            needBlockHeight = __classPrivateFieldGet(this, _UnfoldMap_defaultHeightMap, "f");
            needButtonText = __classPrivateFieldGet(this, _UnfoldMap_mapButton, "f").attr('data-default');
            legendHeight = 0;
        }
        if (__classPrivateFieldGet(this, _UnfoldMap_legendWrapper, "f"))
            __classPrivateFieldGet(this, _UnfoldMap_legendWrapper, "f").stop().animate({ 'height': legendHeight });
        __classPrivateFieldGet(this, _UnfoldMap_placesMap, "f")
            .stop()
            .animate({ 'height': needBlockHeight }, 10, () => {
            __classPrivateFieldGet(this, _UnfoldMap_googleMap, "f").resizeMap();
            // если это развернутый вариант, перецентрировать
            if (__classPrivateFieldGet(this, _UnfoldMap_placesMapWrapper, "f").hasClass('opened'))
                this.reinitMap();
        });
        if (needButtonText)
            __classPrivateFieldGet(this, _UnfoldMap_mapButton, "f").find('span').html(needButtonText);
    }, _UnfoldMap_buttonWrapperClick = function _UnfoldMap_buttonWrapperClick() {
        __classPrivateFieldGet(this, _UnfoldMap_mapButton, "f").trigger('click');
    }, _UnfoldMap_mapGenerateMarkers = function _UnfoldMap_mapGenerateMarkers(currMap) {
        __classPrivateFieldGet(this, _UnfoldMap_mapModel, "f").mapPoints.forEach(item => {
            const point = new google.maps.LatLng(item.coordinates.latitude, item.coordinates.longitude);
            // Есть белые маркеры - это не отели и не достопримечательности. Делаю проверку здесь, т.к. в шаблоне слишком громоздко
            const contentMarkerData = Object.assign({ isWhite: item.type !== "places" /* MapPointType.Places */
                    && item.type !== "hotel" /* MapPointType.Hotel */ ? 'white' : '' }, item);
            const contentMarker = App.templates.MapMarker(contentMarkerData).toString();
            __classPrivateFieldGet(this, _UnfoldMap_richMarkers, "f").push(new RichMarker({
                position: point,
                map: currMap,
                flat: true,
                content: contentMarker,
                optimized: false,
                zIndex: 9999,
            }));
        });
    };
    App.UnfoldMap = UnfoldMap;
})(App || (App = {}));
var App;
(function (App) {
    var _BannerSlider_options, _BannerSlider_root, _BannerSlider_self;
    class BannerSlider {
        constructor(options) {
            _BannerSlider_options.set(this, void 0);
            _BannerSlider_root.set(this, void 0);
            _BannerSlider_self.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
                self: '.js-banner-slider',
            };
            __classPrivateFieldSet(this, _BannerSlider_options, Object.assign(Object.assign({}, defaults), options), "f");
            __classPrivateFieldSet(this, _BannerSlider_root, __classPrivateFieldGet(this, _BannerSlider_options, "f").root, "f");
            __classPrivateFieldSet(this, _BannerSlider_self, $(__classPrivateFieldGet(this, _BannerSlider_options, "f").self, __classPrivateFieldGet(this, _BannerSlider_root, "f")), "f");
            // Инициализируем Баннерный слайдер
            __classPrivateFieldGet(this, _BannerSlider_self, "f").slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 600,
                centerMode: false,
                variableWidth: false,
                autoplay: true,
                autoplaySpeed: 4000,
                draggable: false,
                appendArrows: $('.js-banner-arrows', __classPrivateFieldGet(this, _BannerSlider_root, "f")),
                nextArrow: '<div data-bannerslider-ts class="slick-next" style=""></div>',
                prevArrow: '<div class="slick-prev" style=""></div>',
            });
        }
    }
    _BannerSlider_options = new WeakMap(), _BannerSlider_root = new WeakMap(), _BannerSlider_self = new WeakMap();
    App.BannerSlider = BannerSlider;
})(App || (App = {}));
var App;
(function (App) {
    var _CarouselSlider_instances, _CarouselSlider_options, _CarouselSlider_root, _CarouselSlider_self, _CarouselSlider_sliderObj, _CarouselSlider_cals, _CarouselSlider_onSliderInit, _CarouselSlider_onSliderRemove, _CarouselSlider_onSliderRefresh;
    class CarouselSlider {
        constructor(options) {
            _CarouselSlider_instances.add(this);
            _CarouselSlider_options.set(this, void 0);
            _CarouselSlider_root.set(this, void 0);
            _CarouselSlider_self.set(this, void 0);
            _CarouselSlider_sliderObj.set(this, void 0);
            _CarouselSlider_cals.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
                self: '.js-carousel-slider',
                cals: false,
                slidesNum: 1,
                speed: 0,
            };
            __classPrivateFieldSet(this, _CarouselSlider_options, Object.assign(Object.assign({}, defaults), options), "f");
            __classPrivateFieldSet(this, _CarouselSlider_root, __classPrivateFieldGet(this, _CarouselSlider_options, "f").root, "f");
            __classPrivateFieldSet(this, _CarouselSlider_self, $(__classPrivateFieldGet(this, _CarouselSlider_options, "f").self, __classPrivateFieldGet(this, _CarouselSlider_root, "f")), "f");
            // Если слайдер вызывается НЕ из попапа с датами заездов
            if (!__classPrivateFieldGet(this, _CarouselSlider_options, "f").cals) {
                __classPrivateFieldGet(this, _CarouselSlider_instances, "m", _CarouselSlider_onSliderInit).call(this);
                // Если слайдер вызывается из попапа с датами заездов
            }
            else {
                // Обновляем слайдер
                $('body').on("carousel-slider:init" /* Events.CarouselSliderInit */, (e, data) => __classPrivateFieldGet(this, _CarouselSlider_instances, "m", _CarouselSlider_onSliderInit).call(this, e, data));
                // Отменяем слайдер
                $('body').on("carousel-slider:remove" /* Events.CarouselSliderRemove */, () => __classPrivateFieldGet(this, _CarouselSlider_instances, "m", _CarouselSlider_onSliderRemove).call(this));
                // Обновляем слайдер
                $('body').on("carousel-slider:refresh" /* Events.CarouselSliderRefresh */, () => __classPrivateFieldGet(this, _CarouselSlider_instances, "m", _CarouselSlider_onSliderRefresh).call(this));
            }
        }
        /**
         * Удаляет элемент из слайдера
         * @param childElement - элемент, который надо удалить.
         * Элемент берется без учета оболочки, которую дорисовывает сам слайдер
         */
        deleteElement(childElement) {
            const elemForDelete = childElement.closest('.slick-slide');
            const elemForDeleteIndex = $('.slick-slide').index(elemForDelete);
            // индекс элемента должен быть не слайдеровский (атрибут data-slick-index),
            // а индекс элемента в коллекции подобных. По атрибуту не работает - пробовала
            __classPrivateFieldGet(this, _CarouselSlider_self, "f").slick('slickRemove', elemForDeleteIndex);
        }
    }
    _CarouselSlider_options = new WeakMap(), _CarouselSlider_root = new WeakMap(), _CarouselSlider_self = new WeakMap(), _CarouselSlider_sliderObj = new WeakMap(), _CarouselSlider_cals = new WeakMap(), _CarouselSlider_instances = new WeakSet(), _CarouselSlider_onSliderInit = function _CarouselSlider_onSliderInit(e, data) {
        if (!__classPrivateFieldGet(this, _CarouselSlider_sliderObj, "f")) {
            __classPrivateFieldSet(this, _CarouselSlider_sliderObj, __classPrivateFieldGet(this, _CarouselSlider_self, "f").slick({
                infinite: false,
                slidesToShow: __classPrivateFieldGet(this, _CarouselSlider_options, "f").slidesNum || 1,
                slidesToScroll: __classPrivateFieldGet(this, _CarouselSlider_options, "f").slidesNum || 1,
                speed: __classPrivateFieldGet(this, _CarouselSlider_options, "f").speed,
                centerMode: false,
                variableWidth: false,
                autoplay: false,
                draggable: false,
                edgeFriction: 0,
                appendArrows: $('.js-carousel-arrows', __classPrivateFieldGet(this, _CarouselSlider_root, "f")),
                nextArrow: '<div data-carousel-ts class="slick-next"></div>',
                prevArrow: '<div class="slick-prev" style=""></div>',
                initialSlide: data ? data.initialSlide : undefined,
            }), "f");
        }
        if (data && data.cals) {
            __classPrivateFieldSet(this, _CarouselSlider_cals, data.cals, "f");
            __classPrivateFieldGet(this, _CarouselSlider_cals, "f").removeClass('_hidden');
        }
    }, _CarouselSlider_onSliderRemove = function _CarouselSlider_onSliderRemove() {
        __classPrivateFieldGet(this, _CarouselSlider_cals, "f").addClass('_hidden');
        __classPrivateFieldGet(this, _CarouselSlider_self, "f").slick('unslick');
        __classPrivateFieldSet(this, _CarouselSlider_sliderObj, null, "f");
    }, _CarouselSlider_onSliderRefresh = function _CarouselSlider_onSliderRefresh() {
        __classPrivateFieldGet(this, _CarouselSlider_self, "f").slick('slickSetOption', 'infinite', false, true);
    };
    App.CarouselSlider = CarouselSlider;
})(App || (App = {}));
var App;
(function (App) {
    var _MediaGalleryMobile_instances, _MediaGalleryMobile_options, _MediaGalleryMobile_self, _MediaGalleryMobile_slides, _MediaGalleryMobile_fancyboxItems, _MediaGalleryMobile_fancyboxOpts, _MediaGalleryMobile_onItemClick;
    /**
     * Мобильная версия универсальной галереи.
     * Поддерживает переменную ширину слайдов и интеграцию с Fancybox.
     */
    class MediaGalleryMobile {
        constructor(options) {
            _MediaGalleryMobile_instances.add(this);
            _MediaGalleryMobile_options.set(this, void 0);
            _MediaGalleryMobile_self.set(this, void 0);
            _MediaGalleryMobile_slides.set(this, void 0);
            _MediaGalleryMobile_fancyboxItems.set(this, []);
            _MediaGalleryMobile_fancyboxOpts.set(this, void 0);
            const defaults = {
                self: '.js-media-gallery-mobile',
                noImagePath: '/img/common/no_412-260.png',
            };
            __classPrivateFieldSet(this, _MediaGalleryMobile_options, Object.assign(Object.assign({}, defaults), options), "f");
            __classPrivateFieldSet(this, _MediaGalleryMobile_self, typeof __classPrivateFieldGet(this, _MediaGalleryMobile_options, "f").self === 'string' ? $(__classPrivateFieldGet(this, _MediaGalleryMobile_options, "f").self) : __classPrivateFieldGet(this, _MediaGalleryMobile_options, "f").self, "f");
            if (!__classPrivateFieldGet(this, _MediaGalleryMobile_self, "f").length)
                return;
            __classPrivateFieldSet(this, _MediaGalleryMobile_slides, __classPrivateFieldGet(this, _MediaGalleryMobile_self, "f").find('.swiper-slide'), "f");
            const container = __classPrivateFieldGet(this, _MediaGalleryMobile_self, "f").get(0);
            if (!container)
                return;
            __classPrivateFieldSet(this, _MediaGalleryMobile_fancyboxOpts, {
                closeButton: true,
                Toolbar: false,
            }, "f");
            // Собираем элементы для Fancybox
            __classPrivateFieldGet(this, _MediaGalleryMobile_slides, "f").each((_, v) => {
                const link = $(v).attr('data-full') || __classPrivateFieldGet(this, _MediaGalleryMobile_options, "f").noImagePath;
                __classPrivateFieldGet(this, _MediaGalleryMobile_fancyboxItems, "f").push({ src: link, type: 'image' });
            });
            // Инициализация Swiper
            if (__classPrivateFieldGet(this, _MediaGalleryMobile_self, "f").data('swiper-initialized'))
                return;
            __classPrivateFieldGet(this, _MediaGalleryMobile_self, "f").data('swiper-initialized', true);
            const swiperObj = new Swiper(container, {
                direction: 'horizontal',
                speed: 450,
                slidesPerView: 'auto',
                watchSlidesProgress: true,
                autoHeight: true,
                grabCursor: true,
                pagination: {
                    el: __classPrivateFieldGet(this, _MediaGalleryMobile_self, "f").find('.media-gallery__pagination').get(0) || '.js-tour-arrows',
                    type: 'bullets',
                    clickable: true,
                },
            });
            __classPrivateFieldGet(this, _MediaGalleryMobile_self, "f").data('swiper-instance', swiperObj);
            __classPrivateFieldGet(this, _MediaGalleryMobile_slides, "f").on('click', e => __classPrivateFieldGet(this, _MediaGalleryMobile_instances, "m", _MediaGalleryMobile_onItemClick).call(this, e));
        }
    }
    _MediaGalleryMobile_options = new WeakMap(), _MediaGalleryMobile_self = new WeakMap(), _MediaGalleryMobile_slides = new WeakMap(), _MediaGalleryMobile_fancyboxItems = new WeakMap(), _MediaGalleryMobile_fancyboxOpts = new WeakMap(), _MediaGalleryMobile_instances = new WeakSet(), _MediaGalleryMobile_onItemClick = function _MediaGalleryMobile_onItemClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const index = parseInt(($(event.currentTarget).attr('data-index') || '0'), 10);
        Fancybox.show(__classPrivateFieldGet(this, _MediaGalleryMobile_fancyboxItems, "f"), Object.assign({ startIndex: index }, __classPrivateFieldGet(this, _MediaGalleryMobile_fancyboxOpts, "f")));
        return false;
    };
    App.MediaGalleryMobile = MediaGalleryMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _MediaGallery_options, _MediaGallery_sliderWrap;
    /**
     * Универсальный компонент галереи изображений на базе Swiper.
     * Заменяет устаревший TourSlider.
     */
    class MediaGallery {
        constructor(options) {
            _MediaGallery_options.set(this, void 0);
            _MediaGallery_sliderWrap.set(this, void 0);
            const defaults = {
                wrap: App.app.appContainer,
                self: '.js-media-gallery',
            };
            __classPrivateFieldSet(this, _MediaGallery_options, Object.assign(Object.assign({}, defaults), options), "f");
            __classPrivateFieldSet(this, _MediaGallery_sliderWrap, typeof __classPrivateFieldGet(this, _MediaGallery_options, "f").wrap === 'string' ? $(__classPrivateFieldGet(this, _MediaGallery_options, "f").wrap) : __classPrivateFieldGet(this, _MediaGallery_options, "f").wrap, "f");
            const wrappers = $(__classPrivateFieldGet(this, _MediaGallery_options, "f").self, __classPrivateFieldGet(this, _MediaGallery_sliderWrap, "f"));
            if (wrappers.length === 0)
                return;
            wrappers.each((_, el) => {
                const wrapper = $(el);
                if (wrapper.data('swiper-initialized'))
                    return;
                wrapper.data('swiper-initialized', true);
                const topEl = wrapper.find('.media-gallery__main').get(0);
                const thumbsEl = wrapper.find('.media-gallery__thumbs').get(0);
                if (!topEl)
                    return;
                // Читаем настройки из CSS переменных
                const thumbsCount = parseInt(wrapper.css('--thumbs-count')) || 6;
                const thumbsGap = parseInt(wrapper.css('--thumbs-gap')) || 2;
                let thumbsSwiper = null;
                if (thumbsEl) {
                    thumbsSwiper = new Swiper(thumbsEl, {
                        slidesPerView: thumbsCount,
                        spaceBetween: thumbsGap,
                        watchSlidesProgress: true,
                        allowTouchMove: false,
                        speed: 600,
                    });
                }
                const swiperObj = new Swiper(topEl, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 600,
                    allowTouchMove: false,
                    navigation: {
                        nextEl: wrapper.find('.media-gallery__control-button--next').get(0),
                        prevEl: wrapper.find('.media-gallery__control-button--prev').get(0),
                    },
                    pagination: {
                        el: wrapper.find('.media-gallery__pagination').get(0),
                        type: 'fraction',
                    },
                    thumbs: {
                        swiper: thumbsSwiper,
                    },
                    on: {
                        init: s => {
                            console.log('MediaGallery: Swiper Initialized', s.el);
                        },
                        update: s => {
                            console.log('MediaGallery: Swiper Updated', s.el);
                        },
                    },
                });
                wrapper.data('swiper-instance', swiperObj);
            });
        }
    }
    _MediaGallery_options = new WeakMap(), _MediaGallery_sliderWrap = new WeakMap();
    App.MediaGallery = MediaGallery;
})(App || (App = {}));
var App;
(function (App) {
    var _SectionsSlider_instances, _SectionsSlider_options, _SectionsSlider_root, _SectionsSlider_self, _SectionsSlider_sliderObjs, _SectionsSlider_sliderInit;
    class SectionsSlider {
        constructor(options) {
            _SectionsSlider_instances.add(this);
            _SectionsSlider_options.set(this, void 0);
            _SectionsSlider_root.set(this, void 0);
            _SectionsSlider_self.set(this, void 0);
            _SectionsSlider_sliderObjs.set(this, new Array());
            const defaults = {
                root: App.app.appContainer,
                self: '.js-sections-slider',
            };
            __classPrivateFieldSet(this, _SectionsSlider_options, Object.assign(Object.assign({}, defaults), options), "f");
            __classPrivateFieldSet(this, _SectionsSlider_root, __classPrivateFieldGet(this, _SectionsSlider_options, "f").root, "f");
            __classPrivateFieldSet(this, _SectionsSlider_self, $(__classPrivateFieldGet(this, _SectionsSlider_options, "f").self, __classPrivateFieldGet(this, _SectionsSlider_root, "f")), "f");
            // Обходим все подходящие корневые элементы и инициализируем секционный слайдер
            __classPrivateFieldGet(this, _SectionsSlider_self, "f").each((i, v) => __classPrivateFieldGet(this, _SectionsSlider_instances, "m", _SectionsSlider_sliderInit).call(this, i, v));
        }
    }
    _SectionsSlider_options = new WeakMap(), _SectionsSlider_root = new WeakMap(), _SectionsSlider_self = new WeakMap(), _SectionsSlider_sliderObjs = new WeakMap(), _SectionsSlider_instances = new WeakSet(), _SectionsSlider_sliderInit = function _SectionsSlider_sliderInit(index, el) {
        const item = $(el).slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 600,
            centerMode: false,
            variableWidth: false,
            autoplay: false,
            draggable: false,
            appendArrows: $(el).siblings('.js-sections-arrows'),
            nextArrow: '<div data-sectionsslider-ts class="slick-next" style=""></div>',
            prevArrow: '<div class="slick-prev" style=""></div>',
        });
        __classPrivateFieldGet(this, _SectionsSlider_sliderObjs, "f").push(item);
    };
    App.SectionsSlider = SectionsSlider;
})(App || (App = {}));
var App;
(function (App) {
    var _TourInfoSlider_options, _TourInfoSlider_wrap, _TourInfoSlider_sliderObjs;
    class TourInfoSlider {
        constructor(options) {
            _TourInfoSlider_options.set(this, void 0);
            _TourInfoSlider_wrap.set(this, void 0);
            _TourInfoSlider_sliderObjs.set(this, new Array());
            const defaults = {
                wrap: '.js-tour-info-slider-wrap',
            };
            __classPrivateFieldSet(this, _TourInfoSlider_options, Object.assign(Object.assign({}, defaults), options), "f");
            __classPrivateFieldSet(this, _TourInfoSlider_wrap, $(__classPrivateFieldGet(this, _TourInfoSlider_options, "f").wrap), "f");
            if (!__classPrivateFieldGet(this, _TourInfoSlider_wrap, "f").length)
                return;
            // Обходим каждый слайдер
            __classPrivateFieldGet(this, _TourInfoSlider_wrap, "f").each((index, el) => {
                const wrap = $(el);
                // Инициализируем слайдер Информация о туре
                const item = $('.js-tour-info-slider', wrap).slick({
                    infinite: true,
                    lazyLoad: 'ondemand',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 600,
                    centerMode: false,
                    variableWidth: false,
                    autoplay: false,
                    draggable: false,
                    appendArrows: $('.js-tour-info-arrows', wrap),
                    nextArrow: '<div data-tourinfoslider-ts class="slick-next" style=""></div>',
                    prevArrow: '<div class="slick-prev" style=""></div>',
                });
                __classPrivateFieldGet(this, _TourInfoSlider_sliderObjs, "f").push(item);
            });
        }
    }
    _TourInfoSlider_options = new WeakMap(), _TourInfoSlider_wrap = new WeakMap(), _TourInfoSlider_sliderObjs = new WeakMap();
    App.TourInfoSlider = TourInfoSlider;
})(App || (App = {}));
var App;
(function (App) {
    var _VariableWidthSlider_instances, _VariableWidthSlider_options, _VariableWidthSlider_root, _VariableWidthSlider_self, _VariableWidthSlider_slides, _VariableWidthSlider_arrowPrev, _VariableWidthSlider_arrowNext, _VariableWidthSlider_variableSlider, _VariableWidthSlider_onSlideNext;
    class VariableWidthSlider {
        constructor(options) {
            _VariableWidthSlider_instances.add(this);
            _VariableWidthSlider_options.set(this, void 0);
            _VariableWidthSlider_root.set(this, void 0);
            _VariableWidthSlider_self.set(this, void 0);
            _VariableWidthSlider_slides.set(this, void 0);
            _VariableWidthSlider_arrowPrev.set(this, void 0);
            _VariableWidthSlider_arrowNext.set(this, void 0);
            _VariableWidthSlider_variableSlider.set(this, void 0);
            const defaults = {
                root: App.app.appContainer,
                self: '.js-variable-slider',
            };
            __classPrivateFieldSet(this, _VariableWidthSlider_options, Object.assign(Object.assign({}, defaults), options), "f");
            __classPrivateFieldSet(this, _VariableWidthSlider_root, __classPrivateFieldGet(this, _VariableWidthSlider_options, "f").root, "f");
            __classPrivateFieldSet(this, _VariableWidthSlider_self, $(__classPrivateFieldGet(this, _VariableWidthSlider_options, "f").self, __classPrivateFieldGet(this, _VariableWidthSlider_root, "f")), "f");
            __classPrivateFieldSet(this, _VariableWidthSlider_slides, $('.js-variable-item', __classPrivateFieldGet(this, _VariableWidthSlider_self, "f")), "f");
            __classPrivateFieldSet(this, _VariableWidthSlider_arrowPrev, $('.js-variable-prev', __classPrivateFieldGet(this, _VariableWidthSlider_root, "f")), "f");
            __classPrivateFieldSet(this, _VariableWidthSlider_arrowNext, $('.js-variable-next', __classPrivateFieldGet(this, _VariableWidthSlider_root, "f")), "f");
            // Инициализируем слайдер 'Карусель с переменной шириной слайдов'
            const container = __classPrivateFieldGet(this, _VariableWidthSlider_self, "f").get(0);
            if (!container)
                return;
            __classPrivateFieldSet(this, _VariableWidthSlider_variableSlider, new Swiper(container, {
                direction: 'horizontal',
                speed: 450,
                slidesPerView: 'auto',
                wrapperClass: 'js-variable-wrapper',
                slideClass: 'js-variable-item',
                slideVisibleClass: '_visible',
                resistanceRatio: 1,
                simulateTouch: false,
                watchSlidesProgress: true,
            }), "f");
            // Переключение слайдов стрелочками
            __classPrivateFieldGet(this, _VariableWidthSlider_arrowNext, "f").on('click', () => __classPrivateFieldGet(this, _VariableWidthSlider_instances, "m", _VariableWidthSlider_onSlideNext).call(this));
            __classPrivateFieldGet(this, _VariableWidthSlider_arrowPrev, "f").on('click', () => this.onSlidePrev());
        }
        // Функция обрабатывает переключение слайдов назад
        onSlidePrev() {
            const visibleSlides = __classPrivateFieldGet(this, _VariableWidthSlider_slides, "f").filter('._visible');
            const index = __classPrivateFieldGet(this, _VariableWidthSlider_slides, "f").index($(visibleSlides[visibleSlides.length - 1])) - 1;
            // Скрываем / показываем стрелочки
            __classPrivateFieldGet(this, _VariableWidthSlider_arrowNext, "f").removeClass('_disabled');
            if (index === 0)
                __classPrivateFieldGet(this, _VariableWidthSlider_arrowPrev, "f").addClass('_disabled');
            __classPrivateFieldGet(this, _VariableWidthSlider_variableSlider, "f").slideTo(index);
        }
    }
    _VariableWidthSlider_options = new WeakMap(), _VariableWidthSlider_root = new WeakMap(), _VariableWidthSlider_self = new WeakMap(), _VariableWidthSlider_slides = new WeakMap(), _VariableWidthSlider_arrowPrev = new WeakMap(), _VariableWidthSlider_arrowNext = new WeakMap(), _VariableWidthSlider_variableSlider = new WeakMap(), _VariableWidthSlider_instances = new WeakSet(), _VariableWidthSlider_onSlideNext = function _VariableWidthSlider_onSlideNext() {
        const visibleSlides = __classPrivateFieldGet(this, _VariableWidthSlider_slides, "f").filter('._visible');
        const index = __classPrivateFieldGet(this, _VariableWidthSlider_slides, "f").index($(visibleSlides[visibleSlides.length - 1])) + 1;
        // Скрываем / показываем стрелочки
        __classPrivateFieldGet(this, _VariableWidthSlider_arrowPrev, "f").removeClass('_disabled');
        if (index === __classPrivateFieldGet(this, _VariableWidthSlider_slides, "f").length - 1)
            __classPrivateFieldGet(this, _VariableWidthSlider_arrowNext, "f").addClass('_disabled');
        __classPrivateFieldGet(this, _VariableWidthSlider_variableSlider, "f").slideTo(index);
    };
    App.VariableWidthSlider = VariableWidthSlider;
})(App || (App = {}));
var App;
(function (App) {
    var _EmptyUrlChecker_emptyParameterList;
    /** Класс, проверяющий пустоту урла */
    class EmptyUrlChecker {
        constructor(emptyParameterList) {
            _EmptyUrlChecker_emptyParameterList.set(this, void 0);
            if (!emptyParameterList || emptyParameterList.emptyItems.length <= 0)
                throw new Error('IEmptyUrlParameters');
            __classPrivateFieldSet(this, _EmptyUrlChecker_emptyParameterList, emptyParameterList, "f");
        }
        /**
         * Пустота урла проверяется по полному отсутвию параметров или могут быть параметры,
         * наличие которых  приравнивается к пустому урлу (например, есть 1 параметр, но это context - значит пусто)
         * @param urlParameters
         */
        isEmpty(urlParameters) {
            return urlParameters.length === 0 ||
                !urlParameters.some(v => __classPrivateFieldGet(this, _EmptyUrlChecker_emptyParameterList, "f").emptyItems.indexOf(v.name) < 0);
        }
    }
    _EmptyUrlChecker_emptyParameterList = new WeakMap();
    App.EmptyUrlChecker = EmptyUrlChecker;
})(App || (App = {}));
var App;
(function (App) {
    var _RequiredUrlChecker_parameterList;
    /** Класс, проверяющий наличие обязательных для поиска параметров урла */
    class RequiredUrlChecker {
        constructor(parameterList) {
            _RequiredUrlChecker_parameterList.set(this, void 0);
            if (!parameterList || parameterList.items.length <= 0)
                throw new Error('IRequiredUrlParameters');
            __classPrivateFieldSet(this, _RequiredUrlChecker_parameterList, parameterList, "f");
        }
        isValid(urlParameters) {
            const names = Enumerable.from(urlParameters).select(x => x.name).toArray();
            return __classPrivateFieldGet(this, _RequiredUrlChecker_parameterList, "f").items.length > 0 &&
                Enumerable.from(__classPrivateFieldGet(this, _RequiredUrlChecker_parameterList, "f").items).all(v => names.indexOf(v) >= 0);
        }
    }
    _RequiredUrlChecker_parameterList = new WeakMap();
    App.RequiredUrlChecker = RequiredUrlChecker;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _UrlHelper_options, _UrlHelper_routeData, _UrlHelper_getRouteData, _UrlHelper_isUrlParameters;
    // TODO: тип URLRouteParams реализовать по аналогии с URLSearchParams (но не наследником!).
    class UrlHelper {
        constructor(options) {
            _UrlHelper_options.set(this, void 0);
            _UrlHelper_routeData.set(this, void 0);
            __classPrivateFieldSet(this, _UrlHelper_options, Object.assign(Object.assign({}, _a.defaults), options), "f");
        }
        // TODO оставить только route(baseRoute: string, id?: number | string, parameters?: URLRouteParams): string;
        route(...args) {
            const baseRoute = args[0];
            let id;
            let parameters;
            if (arguments.length > 2) {
                id = args[1];
                parameters = args[2];
            }
            else if (arguments.length > 1) {
                id = args[1] !== null && typeof args[1] === 'object' ? undefined : args[1];
                parameters = args[1] !== null && typeof args[1] === 'object' ? args[1] : undefined;
            }
            let result = baseRoute;
            if (result.length > 0 && result.endsWith('/'))
                result = result.substring(0, result.length - 1);
            if (id != null)
                result += `/${id}`;
            if (parameters != null) {
                let serializedParameters = '';
                if (__classPrivateFieldGet(_a, _a, "m", _UrlHelper_isUrlParameters).call(_a, parameters)) {
                    for (const parameter of parameters)
                        serializedParameters += `/${parameter.name}-${parameter.values.join(',')}`;
                }
                else {
                    for (const [key, value] of Object.entries(parameters))
                        serializedParameters += `/${key}-${Array.isArray(value) ? value.join(',') : value}`;
                }
                if (serializedParameters.length > 0)
                    result += serializedParameters;
            }
            if (__classPrivateFieldGet(this, _UrlHelper_options, "f").lowercaseUrls)
                result = result.toLowerCase();
            if (__classPrivateFieldGet(this, _UrlHelper_options, "f").appendTrailingSlash)
                result += '/';
            return result;
        }
        get routeData() {
            const path = window.location.pathname;
            if (__classPrivateFieldGet(this, _UrlHelper_routeData, "f") == null || __classPrivateFieldGet(this, _UrlHelper_routeData, "f").path !== path)
                __classPrivateFieldSet(this, _UrlHelper_routeData, __classPrivateFieldGet(_a, _a, "m", _UrlHelper_getRouteData).call(_a, path), "f");
            return __classPrivateFieldGet(this, _UrlHelper_routeData, "f");
        }
    }
    _a = UrlHelper, _UrlHelper_options = new WeakMap(), _UrlHelper_routeData = new WeakMap(), _UrlHelper_getRouteData = function _UrlHelper_getRouteData(path) {
        if (path.length <= 0)
            return { path };
        const startOffset = path[0] === '/' ? 1 : 0;
        const endOffset = path.length > 1 && path[path.length - 1] === '/' ? 1 : 0;
        const parts = path.substring(startOffset, path.length - endOffset).split('/');
        return {
            path,
            controller: parts.length > 0 ? parts[0] : undefined,
            action: parts.length > 1 ? parts[1] : undefined,
            id: parts.length > 2 && !parts[2].includes('-') ? parts[2] : undefined,
        };
    }, _UrlHelper_isUrlParameters = function _UrlHelper_isUrlParameters(value) {
        return value != null && Array.isArray(value);
    };
    Object.defineProperty(UrlHelper, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            lowercaseUrls: false,
            appendTrailingSlash: false,
        }
    });
    App.UrlHelper = UrlHelper;
})(App || (App = {}));
var App;
(function (App) {
    var _UrlParameterHelper_instances, _a, _UrlParameterHelper_hotFilterList, _UrlParameterHelper_prepareUrl, _UrlParameterHelper_setNewUrl, _UrlParameterHelper_replaceUrl, _UrlParameterHelper_addUrlParameter, _UrlParameterHelper_deleteUrlParameter, _UrlParameterHelper_getRegexpa, _UrlParameterHelper_locationPathname;
    /**
     * Класс для работы с адресной строкой
     */
    class UrlParameterHelper {
        constructor(hotFilterList) {
            _UrlParameterHelper_instances.add(this);
            _UrlParameterHelper_hotFilterList.set(this, void 0);
            if (!hotFilterList)
                throw new Error('hotFilterList parameter is empty!!!');
            __classPrivateFieldSet(this, _UrlParameterHelper_hotFilterList, hotFilterList, "f");
        }
        /**
         * устанавливает URL как есть
         * Если новый урл не равен текущему
         * @param newUrl - url, который надо установить
         */
        static setUrlAsIs(newUrl) {
            const currentUrl = __classPrivateFieldGet(this, _a, "m", _UrlParameterHelper_locationPathname).call(this);
            if (currentUrl !== newUrl.toLowerCase())
                __classPrivateFieldGet(this, _a, "m", _UrlParameterHelper_setNewUrl).call(this, newUrl);
        }
        /**
         * Проверяет, что Url содержит строку
         * @param urlForCompare - строка, вхождение которой проверяется
         */
        static contains(urlForCompare) {
            if (!urlForCompare)
                return false;
            return __classPrivateFieldGet(this, _a, "m", _UrlParameterHelper_locationPathname).call(this).search(urlForCompare.toLowerCase()) !== -1;
        }
        /**
         * Парсит Url вида параметр-значения,через,запятую/параметр-значения,через,запятую
         * @return Возвращает массив строк, где каждая строка - 'параметр-значения,через,запятую'
         */
        static urlParse() {
            const currentUrl = __classPrivateFieldGet(this, _a, "m", _UrlParameterHelper_locationPathname).call(this);
            const nameValueString = currentUrl.split('/');
            const result = new Array();
            nameValueString.forEach(nameValue => {
                if (nameValue) {
                    const separatorIndex = nameValue.indexOf('-');
                    const name = nameValue.substring(0, separatorIndex);
                    const value = nameValue.substring(separatorIndex + 1);
                    if (name && value)
                        result.push({ name, values: value.split(',') });
                }
            });
            return result;
        }
        static isManual(items) {
            return items.some(v => v.name === 'manual' && v.values.indexOf('true') >= 0);
        }
        static isTourBook(items) {
            return items.some(v => v.name === 'tour' && v.values.indexOf('book') >= 0);
        }
        /**
         * Добавляет URL в хистори
         * @param parameters - параметры для изменения. Приходят все параметры, которые надо менять или добавлять, не зависимо от того, уже
         * есть они в урле или нет
         * @param deleteExtraParameters - признак, что надо удалить лишние параметры.
         */
        changeUrl(parameters, deleteExtraParameters = false) {
            const resultUrl = __classPrivateFieldGet(this, _UrlParameterHelper_instances, "m", _UrlParameterHelper_prepareUrl).call(this, parameters, deleteExtraParameters);
            if (resultUrl)
                __classPrivateFieldGet(_a, _a, "m", _UrlParameterHelper_setNewUrl).call(_a, resultUrl);
        }
        /**
         * Заменяет Url в history
         * @param parameters - параметры для изменения. Приходят все параметры, которые надо менять или добавлять, не зависимо от того, уже
         * есть они в урле или нет
         * @param deleteExtraParameters - признак, что надо удалить лишние параметры.
         */
        replaceUrl(parameters, deleteExtraParameters = false) {
            const resultUrl = __classPrivateFieldGet(this, _UrlParameterHelper_instances, "m", _UrlParameterHelper_prepareUrl).call(this, parameters, deleteExtraParameters);
            if (resultUrl)
                __classPrivateFieldGet(_a, _a, "m", _UrlParameterHelper_replaceUrl).call(_a, resultUrl);
        }
    }
    _a = UrlParameterHelper, _UrlParameterHelper_hotFilterList = new WeakMap(), _UrlParameterHelper_instances = new WeakSet(), _UrlParameterHelper_prepareUrl = function _UrlParameterHelper_prepareUrl(parameters, deleteExtraParameters = false) {
        let resultUrl = __classPrivateFieldGet(_a, _a, "m", _UrlParameterHelper_locationPathname).call(_a);
        // Сначала просто добавляем или заменяем пришедшие параметры, т.к. эта операция стандартна с признаком deleteExtraParameters
        // или без
        parameters.forEach(parameter => {
            const parameterName = parameter.name.toLowerCase();
            const parameterValues = parameter.values.join(',').toLowerCase();
            // если у параметра есть значение, заменяем его или добавляем
            if (parameterValues) {
                const fullParameterString = `${parameterName}-${parameterValues}`;
                resultUrl = __classPrivateFieldGet(_a, _a, "m", _UrlParameterHelper_addUrlParameter).call(_a, resultUrl, fullParameterString, parameterName);
            }
        });
        // если есть признак, что надо удалять лишние параметры, удаляем их
        if (deleteExtraParameters) {
            __classPrivateFieldGet(this, _UrlParameterHelper_hotFilterList, "f").filters.forEach(filter => {
                // Проверка, что этот параметр лишний - его нет в списке параметров, пришедших на изменение
                const extraParameter = !parameters.some(item => item.name.toLowerCase() === filter.name);
                // если он лишний, удалим
                if (extraParameter)
                    resultUrl = __classPrivateFieldGet(_a, _a, "m", _UrlParameterHelper_deleteUrlParameter).call(_a, resultUrl, filter.name);
            });
        }
        return resultUrl;
    }, _UrlParameterHelper_setNewUrl = function _UrlParameterHelper_setNewUrl(newPathParameterString) {
        window.history.pushState(null, '', newPathParameterString);
    }, _UrlParameterHelper_replaceUrl = function _UrlParameterHelper_replaceUrl(newPathParameterString) {
        window.history.replaceState(null, '', newPathParameterString);
    }, _UrlParameterHelper_addUrlParameter = function _UrlParameterHelper_addUrlParameter(currentUrl, newParameterFull, newParameterKey) {
        // проверяем наличие такого параметра в строке адреса
        const regExpa = __classPrivateFieldGet(this, _a, "m", _UrlParameterHelper_getRegexpa).call(this, newParameterKey);
        const isParameterExist = currentUrl.search(regExpa);
        // если параметр есть, заменяем его новым, если нет - добавляем
        let newPathParameterString;
        if (isParameterExist !== -1)
            newPathParameterString = currentUrl.replace(regExpa, newParameterFull);
        else
            newPathParameterString = currentUrl + (currentUrl.endsWith('/') ? '' : '/') + newParameterFull;
        if (App.app.settings.route.appendTrailingSlash && !newPathParameterString.endsWith('/'))
            newPathParameterString += '/';
        return newPathParameterString;
    }, _UrlParameterHelper_deleteUrlParameter = function _UrlParameterHelper_deleteUrlParameter(currentUrl, newParameterKey) {
        let result = currentUrl;
        // проверяем наличие такого параметра в строке адреса
        const regExpa = __classPrivateFieldGet(this, _a, "m", _UrlParameterHelper_getRegexpa).call(this, newParameterKey);
        const isParameterExist = result.search(regExpa);
        // если параметр есть, удаляем его, если нет - ничего не делаем
        if (isParameterExist !== -1)
            result = result.replace(regExpa, '');
        // возвращаем url, заменяя получившиеся из-за манипуляций с параметрами повторяющиеся слеши типа '///' на один слеш
        // и отрезая в конце слеш
        result = result.replace(new RegExp('/+', 'g'), '/');
        if (!App.app.settings.route.appendTrailingSlash && result.endsWith('/'))
            result = result.substring(0, result.length - 1);
        return result;
    }, _UrlParameterHelper_getRegexpa = function _UrlParameterHelper_getRegexpa(parameter) {
        // Паттерн для регулярки задает шаблон для строк вида 'price-137,4598', 'minrating-3.5', 'accommodationname-hbv%20gj',
        // 'accommodationname-рус%20текст'. В название можно вставить любой набор символов кроме '/'. Поиск заканчивается символом '/'
        // http://javascript.ru/basic/regular-expression+
        // https://learn.javascript.ru/regular-expressions-javascript
        return new RegExp(`(?:${parameter})-{1}(?:[^/]+[,.]?)+`, 'gi');
    }, _UrlParameterHelper_locationPathname = function _UrlParameterHelper_locationPathname() {
        return decodeURIComponent(encodeURI(window.location.pathname.toLowerCase()));
    };
    App.UrlParameterHelper = UrlParameterHelper;
})(App || (App = {}));
var App;
(function (App) {
    var _UrlChangeBaseStrategy_instances, _UrlChangeBaseStrategy_hotFilterList, _UrlChangeBaseStrategy_setSortUrl, _UrlChangeBaseStrategy_setFilterUrl, _UrlChangeBaseStrategy_setPagingUrl;
    class UrlChangeBaseStrategy {
        constructor(hotFilterList) {
            _UrlChangeBaseStrategy_instances.add(this);
            _UrlChangeBaseStrategy_hotFilterList.set(this, void 0);
            Object.defineProperty(this, "urlParameterHelper", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!hotFilterList)
                throw new Error('hotFilterList parameter is empty!!!');
            __classPrivateFieldSet(this, _UrlChangeBaseStrategy_hotFilterList, hotFilterList, "f");
            // Хэлпер для работы с урлом
            this.urlParameterHelper = new App.UrlParameterHelper(hotFilterList);
        }
        bind(pageHotFilter, pageRoot) {
            pageHotFilter.root.on("filter:sort" /* Events.FilterSort */, (e, data) => __classPrivateFieldGet(this, _UrlChangeBaseStrategy_instances, "m", _UrlChangeBaseStrategy_setSortUrl).call(this, e, data));
            pageHotFilter.root.on("filter:filter" /* Events.FilterFilter */, (e, data) => __classPrivateFieldGet(this, _UrlChangeBaseStrategy_instances, "m", _UrlChangeBaseStrategy_setFilterUrl).call(this, e, data));
            pageRoot.on("paging:change" /* Events.PagingChange */, (e, data) => __classPrivateFieldGet(this, _UrlChangeBaseStrategy_instances, "m", _UrlChangeBaseStrategy_setPagingUrl).call(this, e, data));
        }
        /**
         * Устанавливает новый урл
         */
        setUrl(parameters, deleteExtraParameters = false) {
            this.urlParameterHelper.changeUrl(parameters, deleteExtraParameters);
        }
    }
    _UrlChangeBaseStrategy_hotFilterList = new WeakMap(), _UrlChangeBaseStrategy_instances = new WeakSet(), _UrlChangeBaseStrategy_setSortUrl = function _UrlChangeBaseStrategy_setSortUrl(event, data) {
        const sortParameters = { name: 'sort', values: [data.field, `${data.reverse ? 'desc' : 'asc'}`] };
        this.setUrl([sortParameters]);
    }, _UrlChangeBaseStrategy_setFilterUrl = function _UrlChangeBaseStrategy_setFilterUrl(event, data) {
        const urlParameters = data.items
            .filter(v => {
            const filter = __classPrivateFieldGet(this, _UrlChangeBaseStrategy_hotFilterList, "f").filters.find(x => x.name === v.name.toLowerCase());
            if ((filter === null || filter === void 0 ? void 0 : filter.defaultValue) == null)
                return true;
            if (v.values.length === 1 && filter.defaultValue === v.values[0])
                return false;
            return true;
        })
            .map(v => ({ name: v.name, values: v.values }));
        this.setUrl(urlParameters, true);
    }, _UrlChangeBaseStrategy_setPagingUrl = function _UrlChangeBaseStrategy_setPagingUrl(event, data) {
        const pageParameters = { name: 'page', values: [data.index.toString(), data.size.toString()] };
        this.setUrl([pageParameters]);
    };
    App.UrlChangeBaseStrategy = UrlChangeBaseStrategy;
})(App || (App = {}));
var App;
(function (App) {
    class UrlChangeStrategy extends App.UrlChangeBaseStrategy {
    }
    App.UrlChangeStrategy = UrlChangeStrategy;
})(App || (App = {}));
var App;
(function (App) {
    class UrlReplaceStrategy extends App.UrlChangeBaseStrategy {
        /**
         * Устанавливает новый урл
         */
        setUrl(parameters, deleteExtraParameters = false) {
            this.urlParameterHelper.replaceUrl(parameters, deleteExtraParameters);
        }
    }
    App.UrlReplaceStrategy = UrlReplaceStrategy;
})(App || (App = {}));
var App;
(function (App) {
    // see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
    /* eslint-disable no-tabs */
    let Key;
    (function (Key) {
        // Special values
        Key.Unidentified = 'Unidentified';
        // Modifier keys
        Key.Alt = 'Alt';
        Key.AltGraph = 'AltGraph';
        Key.CapsLock = 'CapsLock';
        Key.Control = 'Control';
        Key.Fn = 'Fn';
        Key.FnLock = 'FnLock';
        Key.Hyper = 'Hyper';
        Key.Meta = 'Meta';
        Key.NumLock = 'NumLock';
        Key.ScrollLock = 'ScrollLock';
        Key.Shift = 'Shift';
        Key.Super = 'Super';
        Key.Symbol = 'Symbol';
        Key.SymbolLock = 'SymbolLock';
        // Whitespace keys
        Key.Enter = 'Enter';
        Key.Tab = 'Tab';
        Key.Space = ' ';
        // Navigation keys
        Key.ArrowDown = 'ArrowDown';
        Key.ArrowLeft = 'ArrowLeft';
        Key.ArrowRight = 'ArrowRight';
        Key.ArrowUp = 'ArrowUp';
        Key.End = 'End';
        Key.Home = 'Home';
        Key.PageDown = 'PageDown';
        Key.PageUp = 'PageUp';
        // Editing keys
        Key.Backspace = 'Backspace';
        Key.Clear = 'Clear';
        Key.Copy = 'Copy';
        Key.CursorSelect = 'CrSel';
        Key.Cut = 'Cut';
        Key.Delete = 'Delete';
        Key.EraseEof = 'EraseEof';
        Key.ExtendSelection = 'ExSel';
        Key.Insert = 'Insert';
        Key.Paste = 'Paste';
        Key.Redo = 'Redo';
        Key.Undo = 'Undo';
        // UI keys
        Key.Accept = 'Accept';
        Key.Again = 'Again';
        Key.Attention = 'Attn';
        Key.Cancel = 'Cancel';
        Key.ContextMenu = 'ContextMenu';
        Key.Escape = 'Escape';
        Key.Execute = 'Execute';
        Key.Find = 'Find';
        Key.Finish = 'Finish';
        Key.Help = 'Help';
        Key.Pause = 'Pause';
        Key.Play = 'Play';
        Key.Properties = 'Props';
        Key.Select = 'Select';
        Key.ZoomIn = 'ZoomIn';
        Key.ZoomOut = 'ZoomOut';
        Key.Exclamation = '!';
        Key.DoubleQuote = '"';
        Key.Hash = '#';
        Key.Dollar = '$';
        Key.Percent = '%';
        Key.Ampersand = '&';
        Key.SingleQuote = '\'';
        Key.OpenParenthesis = '(';
        Key.CloseParenthesis = ')';
        Key.Asterisk = '*';
        Key.Plus = '+';
        Key.Comma = ',';
        Key.Minus = '-';
        Key.Period = '.';
        Key.Slash = '/';
        Key.Digit0 = '0';
        Key.Digit1 = '1';
        Key.Digit2 = '2';
        Key.Digit3 = '3';
        Key.Digit4 = '4';
        Key.Digit5 = '5';
        Key.Digit6 = '6';
        Key.Digit7 = '7';
        Key.Digit8 = '8';
        Key.Digit9 = '9';
        Key.Colon = ':';
        Key.Semicolon = ';';
        Key.LessThan = '<';
        Key.Equals = '=';
        Key.GreaterThan = '>';
        Key.Question = '?';
        Key.At = '@';
        Key.OpenBracket = '[';
        Key.Backslash = '\\';
        Key.CloseBracket = ']';
        Key.Caret = '^';
        Key.Underscore = '_';
        Key.Backtick = '`';
        Key.OpenCurlyBracket = '{';
        Key.Bar = '|';
        Key.CloseCurlyBracket = '}';
        Key.Tilde = '~';
        Key.LetterA = 'A';
        Key.LetterB = 'B';
        Key.LetterC = 'C';
        Key.LetterD = 'D';
        Key.LetterE = 'E';
        Key.LetterF = 'F';
        Key.LetterG = 'G';
        Key.LetterH = 'H';
        Key.LetterI = 'I';
        Key.LetterJ = 'J';
        Key.LetterK = 'K';
        Key.LetterL = 'L';
        Key.LetterM = 'M';
        Key.LetterN = 'N';
        Key.LetterO = 'O';
        Key.LetterP = 'P';
        Key.LetterQ = 'Q';
        Key.LetterR = 'R';
        Key.LetterS = 'S';
        Key.LetterT = 'T';
        Key.LetterU = 'U';
        Key.LetterV = 'V';
        Key.LetterW = 'W';
        Key.LetterX = 'X';
        Key.LetterY = 'Y';
        Key.LetterZ = 'Z';
        Key.LetterSmallA = 'a';
        Key.LetterSmallB = 'b';
        Key.LetterSmallC = 'c';
        Key.LetterSmallD = 'd';
        Key.LetterSmallE = 'e';
        Key.LetterSmallF = 'f';
        Key.LetterSmallG = 'g';
        Key.LetterSmallH = 'h';
        Key.LetterSmallI = 'i';
        Key.LetterSmallJ = 'j';
        Key.LetterSmallK = 'k';
        Key.LetterSmallL = 'l';
        Key.LetterSmallM = 'm';
        Key.LetterSmallN = 'n';
        Key.LetterSmallO = 'o';
        Key.LetterSmallP = 'p';
        Key.LetterSmallQ = 'q';
        Key.LetterSmallR = 'r';
        Key.LetterSmallS = 's';
        Key.LetterSmallT = 't';
        Key.LetterSmallU = 'u';
        Key.LetterSmallV = 'v';
        Key.LetterSmallW = 'w';
        Key.LetterSmallX = 'x';
        Key.LetterSmallY = 'y';
        Key.LetterSmallZ = 'z';
    })(Key = App.Key || (App.Key = {}));
    /* eslint-enable no-tabs */
})(App || (App = {}));
var App;
(function (App) {
    // see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    /* eslint-disable no-tabs */
    let KeyCode;
    (function (KeyCode) {
        KeyCode.Null = 0x00;
        KeyCode.Backspace = 0x08; // \b
        KeyCode.Tab = 0x09; // \t
        KeyCode.LineFeed = 0x0A; // \n
        KeyCode.VerticalTab = 0x0B; // \v
        KeyCode.FormFeed = 0x0C; // \f
        KeyCode.NumpadEqual = 0x0C;
        KeyCode.CarriageReturn = 0x0D; // \r
        KeyCode.Enter = 0x0D;
        KeyCode.NumpadEnter = 0x0D;
        KeyCode.Shift = 0x10;
        KeyCode.Control = 0x11;
        KeyCode.Alt = 0x12;
        KeyCode.Pause = 0x13;
        KeyCode.CapsLock = 0x14;
        KeyCode.Escape = 0x1B;
        KeyCode.Space = 0x20;
        KeyCode.Exclamation = 0x21; // !
        KeyCode.DoubleQuote = 0x22; // "
        KeyCode.Hash = 0x23; // #
        KeyCode.Dollar = 0x24; // $
        KeyCode.Percent = 0x25; // %
        KeyCode.Ampersand = 0x26; // &
        KeyCode.SingleQuote = 0x27; // '
        KeyCode.OpenParenthesis = 0x28; // (
        KeyCode.CloseParenthesis = 0x29; // )
        KeyCode.Asterisk = 0x2A; // *
        KeyCode.Plus = 0x2B; // +
        KeyCode.Comma = 0x2C; // ,
        KeyCode.Minus = 0x2D; // -
        KeyCode.Period = 0x2E; // .
        KeyCode.Slash = 0x2F; // /
        KeyCode.Digit0 = 0x30; // 0
        KeyCode.Digit1 = 0x31; // 1
        KeyCode.Digit2 = 0x32; // 2
        KeyCode.Digit3 = 0x33; // 3
        KeyCode.Digit4 = 0x34; // 4
        KeyCode.Digit5 = 0x35; // 5
        KeyCode.Digit6 = 0x36; // 6
        KeyCode.Digit7 = 0x37; // 7
        KeyCode.Digit8 = 0x38; // 8
        KeyCode.Digit9 = 0x39; // 9
        KeyCode.Colon = 0x3A; // :
        KeyCode.Semicolon = 0x3B; // ;
        KeyCode.LessThan = 0x3C; // <
        KeyCode.Equals = 0x3D; // =
        KeyCode.GreaterThan = 0x3E; // >
        KeyCode.Question = 0x3F; // ?
        KeyCode.At = 0x40; // @
        KeyCode.OpenBracket = 0x5B; // [
        KeyCode.Backslash = 0x5C; // \
        KeyCode.CloseBracket = 0x5D; // ]
        KeyCode.Caret = 0x5E; // ^
        KeyCode.Underscore = 0x5F; // _
        KeyCode.Backtick = 0x60; // `
        KeyCode.OpenCurlyBracket = 0x7B; // {
        KeyCode.Bar = 0x7C; // |
        KeyCode.CloseCurlyBracket = 0x7D; // }
        KeyCode.Tilde = 0x7E; // ~
        KeyCode.LetterA = 0x41; // A
        KeyCode.LetterB = 0x42; // B
        KeyCode.LetterC = 0x43; // C
        KeyCode.LetterD = 0x44; // D
        KeyCode.LetterE = 0x45; // E
        KeyCode.LetterF = 0x46; // F
        KeyCode.LetterG = 0x47; // G
        KeyCode.LetterH = 0x48; // H
        KeyCode.LetterI = 0x49; // I
        KeyCode.LetterJ = 0x4A; // J
        KeyCode.LetterK = 0x4B; // K
        KeyCode.LetterL = 0x4C; // L
        KeyCode.LetterM = 0x4D; // M
        KeyCode.LetterN = 0x4E; // N
        KeyCode.LetterO = 0x4F; // O
        KeyCode.LetterP = 0x50; // P
        KeyCode.LetterQ = 0x51; // Q
        KeyCode.LetterR = 0x52; // R
        KeyCode.LetterS = 0x53; // S
        KeyCode.LetterT = 0x54; // T
        KeyCode.LetterU = 0x55; // U
        KeyCode.LetterV = 0x56; // V
        KeyCode.LetterW = 0x57; // W
        KeyCode.LetterX = 0x58; // X
        KeyCode.LetterY = 0x59; // Y
        KeyCode.LetterZ = 0x5A; // Z
        KeyCode.LetterSmallA = 0x61; // a
        KeyCode.LetterSmallB = 0x62; // b
        KeyCode.LetterSmallC = 0x63; // c
        KeyCode.LetterSmallD = 0x64; // d
        KeyCode.LetterSmallE = 0x65; // e
        KeyCode.LetterSmallF = 0x66; // f
        KeyCode.LetterSmallG = 0x67; // g
        KeyCode.LetterSmallH = 0x68; // h
        KeyCode.LetterSmallI = 0x69; // i
        KeyCode.LetterSmallJ = 0x6A; // j
        KeyCode.LetterSmallK = 0x6B; // k
        KeyCode.LetterSmallL = 0x6C; // l
        KeyCode.LetterSmallM = 0x6D; // m
        KeyCode.LetterSmallN = 0x6E; // n
        KeyCode.LetterSmallO = 0x6F; // o
        KeyCode.LetterSmallP = 0x70; // p
        KeyCode.LetterSmallQ = 0x71; // q
        KeyCode.LetterSmallR = 0x72; // r
        KeyCode.LetterSmallS = 0x73; // s
        KeyCode.LetterSmallT = 0x74; // t
        KeyCode.LetterSmallU = 0x75; // u
        KeyCode.LetterSmallV = 0x76; // v
        KeyCode.LetterSmallW = 0x77; // w
        KeyCode.LetterSmallX = 0x78; // x
        KeyCode.LetterSmallY = 0x79; // y
        KeyCode.LetterSmallZ = 0x7A; // z
        KeyCode.WinLeft = 0x5B;
        KeyCode.WinRight = 0x5C;
        KeyCode.ContextMenu = 0x5D;
        KeyCode.Sleep = 0x5F;
        KeyCode.PageUp = 0x21;
        KeyCode.PageDown = 0x22;
        KeyCode.End = 0x23;
        KeyCode.Home = 0x24;
        KeyCode.ArrowLeft = 0x25;
        KeyCode.ArrowUp = 0x26;
        KeyCode.ArrowRight = 0x27;
        KeyCode.ArrowDown = 0x28;
        KeyCode.PrintScreen = 0x2C;
        KeyCode.Insert = 0x2D;
        KeyCode.Delete = 0x2E;
        KeyCode.NumpadPageUp = 0x21;
        KeyCode.NumpadPageDown = 0x22;
        KeyCode.NumpadEnd = 0x23;
        KeyCode.NumpadHome = 0x24;
        KeyCode.NumpadArrowLeft = 0x25;
        KeyCode.NumpadArrowUp = 0x26;
        KeyCode.NumpadArrowRight = 0x27;
        KeyCode.NumpadArrowDown = 0x28;
        KeyCode.NumpadInsert = 0x2D;
        KeyCode.NumpadDelete = 0x2E;
        KeyCode.Numpad0 = 0x60;
        KeyCode.Numpad1 = 0x61;
        KeyCode.Numpad2 = 0x62;
        KeyCode.Numpad3 = 0x63;
        KeyCode.Numpad4 = 0x64;
        KeyCode.Numpad5 = 0x65;
        KeyCode.Numpad6 = 0x66;
        KeyCode.Numpad7 = 0x67;
        KeyCode.Numpad8 = 0x68;
        KeyCode.Numpad9 = 0x69;
        KeyCode.NumpadMultiply = 0x6A;
        KeyCode.NumpadAdd = 0x6B;
        KeyCode.NumpadSubtract = 0x6D;
        KeyCode.NumpadDecimal = 0x6E;
        KeyCode.NumpadDivide = 0x6F;
        KeyCode.F1 = 0x70;
        KeyCode.F2 = 0x71;
        KeyCode.F3 = 0x72;
        KeyCode.F4 = 0x73;
        KeyCode.F5 = 0x74;
        KeyCode.F6 = 0x75;
        KeyCode.F7 = 0x76;
        KeyCode.F8 = 0x77;
        KeyCode.F9 = 0x78;
        KeyCode.F10 = 0x79;
        KeyCode.F11 = 0x7A;
        KeyCode.F12 = 0x7B;
        KeyCode.F13 = 0x7C;
        KeyCode.F14 = 0x7D;
        KeyCode.F15 = 0x7E;
        KeyCode.F16 = 0x7F;
        KeyCode.F17 = 0x80;
        KeyCode.F18 = 0x81;
        KeyCode.F19 = 0x82;
        KeyCode.F20 = 0x83;
        KeyCode.F21 = 0x84;
        KeyCode.F22 = 0x85;
        KeyCode.F23 = 0x86;
        KeyCode.F24 = 0x87;
        KeyCode.NumLock = 0x90;
        KeyCode.ScrollLock = 0x91;
        KeyCode.NumpadComma = 0xC2;
    })(KeyCode = App.KeyCode || (App.KeyCode = {}));
    /* eslint-enable no-tabs */
})(App || (App = {}));
// TODO: очистка фильтра: сбрасываетя валюта всегда на рубли в слайдере
var App;
(function (App) {
    var _CruisePageBase_instances, _a, _CruisePageBase_getParamsFromSearchBlock, _CruisePageBase_getParamsOfSelectElementByFilter, _CruisePageBase_getParamsOfInputElementByFilter, _CruisePageBase_onLinkClick, _CruisePageBase_closeCabinDescription;
    class CruisePageBase extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruisePageBase_instances.add(this);
            Object.defineProperty(this, "options", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "routeNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "searchExecuting", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "state", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "states", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "preloader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "seo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "responseValidator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pricePresenter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "scrollBookLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "bookScrollToWrap", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // protected digest: Digest;
            Object.defineProperty(this, "tabs", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "popupInfo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "expirationPopup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "context", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cabinDescrWrapClass", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.options = options;
            if (!this.root.length)
                return;
            this.context = new App.QueryParams(window.location.pathname).getContext();
            this.preloader = new App.Preloader();
            this.seo = {};
            this.cabinDescrWrapClass = 'js-cruise-cabinDescr';
            this.components.push(new App.Digest({ container: this.root }));
            // Прокрутка якорных ссылок
            this.root.on('click', '.js-scroll-to', e => App.scrollLinkClickHandler(e));
            // Читать полностью
            this.root.on('click', '.js-read-more', e => App.readMoreClickHandler(e));
            // открытие ссылок внутри блоков (ссылок)
            this.root.on('click', '[data-href]', (e) => __classPrivateFieldGet(_a, _a, "m", _CruisePageBase_onLinkClick).call(_a, e));
        }
        static sortArray(values, checkProperty) {
            return values.sort((a, b) => {
                if (a[checkProperty] > b[checkProperty])
                    return 1;
                if (a[checkProperty] < b[checkProperty])
                    return -1;
                // a должно быть равным b
                return 0;
            });
        }
        static uniqArray(values, checkProperties) {
            // массив простых типов
            if (checkProperties.length === 0)
                return Array.from(new Set(values));
            // массив объектов
            return values.filter((value, index) => index === values.findIndex(element => {
                let predicate = false;
                checkProperties.forEach(prop => {
                    predicate = (element[prop] === value[prop]);
                });
                return predicate;
            }));
        }
        static show(jqObj, scrollTop, typeTopScroll) {
            if (!jqObj)
                return;
            /* typeTopScroll: 1 - body, 2 - сам элемент jqObj*/
            const scrollObj = typeTopScroll === 1 ? $('body') : jqObj;
            jqObj.removeClass('_hidden-2');
            if (scrollTop) {
                const scrollObjOffset = scrollObj.offset();
                $('html, body').animate({ scrollTop: (scrollObjOffset != null ? scrollObjOffset.top : 0) }, 'slow');
            }
        }
        static hide(jqObj) {
            if (!jqObj)
                return;
            jqObj.addClass('_hidden-2');
        }
        static formatDate(date) {
            // 25.03.2017 -> 20170325 - Russian
            const dateParts = date.split('.');
            return dateParts[2] + dateParts[1] + dateParts[0];
        }
        static addDaysAndFormat(dateStr, days) {
            const date = App.addDays(new Date(dateStr), days);
            return App.formatDate(date, 'shortIsoDate');
        }
        static abbreviateMulti(text, maxLength, abbrText) {
            return {
                item1: text.length >= maxLength ? text : '',
                item2: text.substring(0, maxLength) + abbrText,
            };
        }
        run() {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, arguments, void 0, function* (signal = App.noneSignal) {
                yield _super.run.call(this, signal);
                this.cleanPage();
                yield this.states[this.state].handler();
            });
        }
        cleanPage() {
        }
        updateSeo(seoInfo) {
            App.app.seo.update(seoInfo);
        }
        saveState(state, add, replace, isReplace = false) {
            this.state = state;
            const queryParams = new App.QueryParams(window.location.pathname);
            queryParams.clear();
            queryParams.setAction(this.states[this.state].actionName);
            if (add) {
                Object.getOwnPropertyNames(add).forEach(value => {
                    if (add[value].length === 1 && add[value][0] === '')
                        queryParams.remove(value);
                    else
                        queryParams.add(value, add[value]);
                });
            }
            if (replace) {
                Object.getOwnPropertyNames(replace).forEach(value => {
                    if (replace[value].length === 1 && replace[value][0] === '')
                        queryParams.remove(value);
                    else
                        queryParams.replace(value, replace[value]);
                });
            }
            const url = queryParams.getUrl();
            if (isReplace)
                App.History.replaceState(this.state, url, true);
            else
                App.History.saveState(this.state, url);
        }
        getParamsFromFilters(filter) {
            const params = {};
            const filterParams = __classPrivateFieldGet(_a, _a, "m", _CruisePageBase_getParamsFromSearchBlock).call(_a, filter);
            filterParams.forEach(value => {
                if (this.options.changes.includes(value.key))
                    params[value.key] = value.value;
            });
            return params;
        }
        static convertArrayToRequestData(elements) {
            const data = {};
            $.each(elements, (_, v) => {
                if (v.value == null || v.value === '')
                    return true;
                let values = v.value;
                if (typeof v.value === 'string')
                    values = v.value.split(',');
                if (v.name.length > 0 && values.length > 0)
                    data[v.name] = values;
                return true;
            });
            return data;
        }
        onScrollDescrBlock() {
            // TODO: https://jquery.com/upgrade-guide/3.0/#breaking-change-outerwidth-or-outerheight-on-window-includes-scrollbar-width-height
            const scrolledPos = ($(window).scrollTop() || 0) + ($(window).outerHeight() || 0);
            const offset = this.bookScrollToWrap.offset();
            const offsetTop = (offset != null ? offset.top : 0);
            if (scrolledPos >= offsetTop && scrolledPos < offsetTop + (this.bookScrollToWrap.outerHeight() || 0))
                this.scrollBookLink.addClass('_fixed_book');
            else
                this.scrollBookLink.removeClass('_fixed_book');
        }
        onCabinTitleClick(event) {
            var _b;
            event.preventDefault();
            event.stopPropagation();
            if (this.popupInfo)
                App.popupHide();
            const cabinKey = (_b = $(event.currentTarget).attr('data-key')) !== null && _b !== void 0 ? _b : '';
            const qp = new App.QueryParams(window.location.pathname);
            if (cabinKey.length > 0) {
                qp.setParamAncher(cabinKey);
                App.History.replaceState(this.state, qp.getUrl(), true);
            }
            this.popupInfo = new App.PopupOld({
                content: $(`<div class="${this.cabinDescrWrapClass} cruise-cabinDescr"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
                onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { return yield this.getCabinDescription(cabinKey); }),
                onHideDelegate: () => __classPrivateFieldGet(this, _CruisePageBase_instances, "m", _CruisePageBase_closeCabinDescription).call(this, qp),
            });
            $('body').trigger("popup:open" /* Events.PopupOpen */, []);
        }
        getCabinDescription(key) {
            return __awaiter(this, void 0, void 0, function* () {
                const xhr = $.ajax({
                    url: this.options.urls.getCabinDescription,
                    method: 'POST',
                    data: { cabinKey: key },
                });
                try {
                    const response = yield xhr;
                    if (!this.responseValidator.process(response))
                        return;
                    if (response.data.cabin.experience != null) {
                        const experience = response.data.cabin.experience.toLowerCase().replace(' ', '-');
                        response.data.cabin.experienceLink = `/help/cruise/msc-cruises/cabin-experience/${experience}/`;
                    }
                    const blockDescr = $(App.templates.Cruise.Route.CabinDescr({ cabin: response.data.cabin }));
                    $(`.${this.cabinDescrWrapClass}`, $('.js-popup')).empty().append(blockDescr);
                    // инициализация фоток
                    this.components.push(new App.MediaGallery({ wrap: '.js-cruise-cabinDescr' }));
                }
                catch (ex) {
                    if (!this.responseValidator.processError(ex))
                        throw ex;
                }
            });
        }
    }
    _a = CruisePageBase, _CruisePageBase_instances = new WeakSet(), _CruisePageBase_getParamsFromSearchBlock = function _CruisePageBase_getParamsFromSearchBlock(filter) {
        const params = [];
        filter.find('.filter-block').each((_, element) => {
            const jqElement = $(element);
            let key = '';
            let value = [];
            const select = jqElement.attr('data-select');
            if (select) {
                key = select.toLowerCase();
                value = __classPrivateFieldGet(_a, _a, "m", _CruisePageBase_getParamsOfSelectElementByFilter).call(_a, element);
            }
            else {
                const name = jqElement.attr('data-name');
                if (name) {
                    key = name.toLowerCase();
                    value = __classPrivateFieldGet(_a, _a, "m", _CruisePageBase_getParamsOfInputElementByFilter).call(_a, element);
                }
                else if (jqElement.attr('data-nights') !== undefined) {
                    key = 'night';
                    value = __classPrivateFieldGet(_a, _a, "m", _CruisePageBase_getParamsOfInputElementByFilter).call(_a, element);
                }
            }
            if (key.length > 0 && value.length > 0)
                params.push({ key, value });
        });
        return params;
    }, _CruisePageBase_getParamsOfSelectElementByFilter = function _CruisePageBase_getParamsOfSelectElementByFilter(el) {
        const values = [];
        const valueStr = $(el).find('.js-jelect-input').valString();
        // проверка на пустоту убрана, все списки без значений будут удалены из url в saveState
        valueStr.split(',').forEach(value => {
            values.push(value);
        });
        return values;
    }, _CruisePageBase_getParamsOfInputElementByFilter = function _CruisePageBase_getParamsOfInputElementByFilter(el) {
        const values = [];
        $(el).find('input').each((_, element) => {
            if ($(element).hasClass('js-not_for_filter'))
                return;
            let value = $(element).valString().toLowerCase();
            if ($(element).hasClass('filter-date-input'))
                value = _a.formatDate(value);
            if ($(element).hasClass('js-return-same'))
                value = (value === 'true' ? 1 : 0).toString();
            if ($(element).hasClass('filter-slider-input'))
                value = $(element).attr('data-text') || '';
            if (value)
                values.push(value.toString().toLowerCase());
        });
        return values;
    }, _CruisePageBase_onLinkClick = function _CruisePageBase_onLinkClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const link = $(event.currentTarget).attr('data-href');
        window.open(link);
        return false;
    }, _CruisePageBase_closeCabinDescription = function _CruisePageBase_closeCabinDescription(qp) {
        const dopParam = qp.getParamAncher();
        if (dopParam.length > 0) {
            qp.setParamAncher('');
            App.History.replaceState(this.state, qp.getUrl(), true);
        }
    };
    App.CruisePageBase = CruisePageBase;
})(App || (App = {}));
/// <reference path='CruisePageBase.ts' />
var App;
(function (App) {
    var _CruiseActivityBookPage_instances, _a, _CruiseActivityBookPage_optionsSet, _CruiseActivityBookPage_formOrder, _CruiseActivityBookPage_selectedOptionsChanged, _CruiseActivityBookPage_getServicePrices, _CruiseActivityBookPage_checkActivityDateCommon, _CruiseActivityBookPage_checkActivityDate, _CruiseActivityBookPage_applyDiscount, _CruiseActivityBookPage_onGroupCheckboxClick, _CruiseActivityBookPage_onTouristCheckboxClick, _CruiseActivityBookPage_onBookClick;
    class CruiseActivityBookPage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-activity-book-page' }, options));
            _CruiseActivityBookPage_instances.add(this);
            _CruiseActivityBookPage_optionsSet.set(this, void 0);
            _CruiseActivityBookPage_formOrder.set(this, void 0);
            this.states = {
                'activityBook': {
                    handler: () => __awaiter(this, void 0, void 0, function* () { }),
                    actionName: 'activityBook',
                    keysForUrl: [],
                },
            };
            this.state = 'activityBook';
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseActivityBookPage_optionsSet, $('.js-options-set', this.root), "f");
            __classPrivateFieldSet(this, _CruiseActivityBookPage_formOrder, $('.js-cruise-activity_order', this.root), "f");
            // Группа опций (экскурсии).
            __classPrivateFieldGet(this, _CruiseActivityBookPage_optionsSet, "f").each((index, element) => {
                const jqElement = $(element);
                const toggle = $('.js-options-set-toggle', jqElement);
                // Общий чекбокс для группы.
                toggle.on('click', e => __classPrivateFieldGet(this, _CruiseActivityBookPage_instances, "m", _CruiseActivityBookPage_onGroupCheckboxClick).call(this, e, jqElement));
                // Синхронизуем чекбоксы персон с общим чекбоксом.
                jqElement.on('click', '.js-options-set-item', (e) => __classPrivateFieldGet(this, _CruiseActivityBookPage_instances, "m", _CruiseActivityBookPage_onTouristCheckboxClick).call(this, e, jqElement, toggle));
            });
            __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseActivityBookPage_instances, "m", _CruiseActivityBookPage_onBookClick).call(this, e); }));
        }
    }
    _a = CruiseActivityBookPage, _CruiseActivityBookPage_optionsSet = new WeakMap(), _CruiseActivityBookPage_formOrder = new WeakMap(), _CruiseActivityBookPage_instances = new WeakSet(), _CruiseActivityBookPage_selectedOptionsChanged = function _CruiseActivityBookPage_selectedOptionsChanged(container) {
        var _b;
        const adultCount = $('.js-options-set-adult .js-order-options-input', container).filter(':checked, ._checked').not(':disabled').length;
        const childCount = $('.js-options-set-child .js-order-options-input', container).filter(':checked, ._checked').not(':disabled').length;
        const isGroup = (_b = Number(container.attr('data-group'))) !== null && _b !== void 0 ? _b : 1;
        const prices = adultCount + childCount > 0 ?
            __classPrivateFieldGet(_a, _a, "m", _CruiseActivityBookPage_getServicePrices).call(_a, container, adultCount, childCount, isGroup == 1) :
            [0, 0];
        const totalItem = prices[0];
        const elTotal = container.find('.js-options-set-total');
        elTotal.attr('data-price', totalItem);
        elTotal.attr('data-price-commission', prices[1]);
        elTotal.toggleClass('_zero', totalItem === 0);
        elTotal.find(App.Money.tagName).get(0).amount = totalItem;
        let total = 0, totalCom = 0;
        $('.js-options-set', __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f")).find('.js-options-set-total').each((index, el) => {
            const price = $(el).attr('data-price');
            const commission = $(el).attr('data-price-commission');
            if (price) {
                total += Number(price);
                totalCom += Number(commission);
            }
        });
        total = __classPrivateFieldGet(this, _CruiseActivityBookPage_instances, "m", _CruiseActivityBookPage_applyDiscount).call(this, container, total);
        $('.js-order-options-total', __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f")).get(0).amount = total;
        $('.js-order-options-total-netto', __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f")).get(0).amount = total - totalCom;
        $('.js-order-options-total-commission', __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f")).get(0).amount = totalCom;
    }, _CruiseActivityBookPage_getServicePrices = function _CruiseActivityBookPage_getServicePrices(container, adultCount, childCount, isGroup) {
        let price = 0, commission = 0;
        const adultPriceBlock = $('.js-options-set-adult .js-person-options-initials', container).eq(0).find('.js-blockPrice');
        const adultPrice = adultPriceBlock.find(App.Money.tagName).get(0).amount;
        const adultPriceCommission = adultPriceBlock.attr('data-price-commission');
        const childPriceBlock = $('.js-options-set-child .js-person-options-initials', container).length > 0
            ? $('.js-options-set-child .js-person-options-initials', container).eq(0).find('.js-blockPrice')
            : null;
        const childPrice = childPriceBlock ? childPriceBlock.find(App.Money.tagName).get(0).amount : 0;
        const childPriceCommission = childPriceBlock ? childPriceBlock.attr('data-price-commission') : 0;
        if (isGroup) {
            price += adultPrice * adultCount + childPrice * childCount;
            commission += Number(adultPriceCommission) * adultCount + Number(childPriceCommission) * childCount;
        }
        else {
            price += adultPrice;
            commission = Number(adultPriceCommission);
        }
        return [price, commission];
    }, _CruiseActivityBookPage_checkActivityDateCommon = function _CruiseActivityBookPage_checkActivityDateCommon(container, checked) {
        // чекбоксы у туристов
        const items = container.parents('.js-options-set').find('.js-options-set-item');
        const itemsActive = items.not(':disabled');
        itemsActive.each((index, el) => {
            __classPrivateFieldGet(_a, _a, "m", _CruiseActivityBookPage_checkActivityDate).call(_a, $(el), checked);
        });
        // общие чекбоксы
        const parent = container.parents('.js-cruise-activity-packet');
        const date = container.parents('.js-options-set').attr('data-date');
        const els = $(`.js-options-set[data-date="${date}"]`, parent)
            .find('.js-options-set-toggle')
            .not(container);
        if (checked) {
            if (itemsActive.length === items.length) {
                els.attr('disabled', 'disabled');
                els.parents('.js-options-set').addClass('_disabled');
            }
        }
        else {
            els.removeAttr('disabled');
            els.parents('.js-options-set').removeClass('_disabled');
        }
    }, _CruiseActivityBookPage_checkActivityDate = function _CruiseActivityBookPage_checkActivityDate(container, checked) {
        // чекбоксы у туристов
        const parent = container.parents('.js-cruise-activity-packet');
        const person = container.parents('.js-person-options-initials').attr('data-target');
        const date = container.parents('.js-options-set').attr('data-date');
        const els = $(`.js-options-set[data-date="${date}"]`, parent)
            .find(`.js-person-options-initials[data-target="${person}"]`)
            .find('.js-order-options-input')
            .not(container);
        if (checked) {
            els.attr('disabled', 'disabled');
            els.parents('.js-options-set').addClass('_disabled');
        }
        else {
            els.removeAttr('disabled');
            els.parents('.js-options-set').removeClass('_disabled');
        }
        // общие чекбоксы
        const currentCommonCheckbox = container.parents('.js-options-set').find('.js-options-set-toggle');
        const commonCheckboxes = $(`.js-options-set[data-date="${date}"]`, parent)
            .find('.js-options-set-toggle')
            .not(currentCommonCheckbox);
        commonCheckboxes.each((index, el) => {
            const items = $(el).parents('.js-options-set').find('.js-options-set-item');
            const itemsActive = items.not(':disabled');
            if (checked) {
                if (itemsActive.length === items.length || itemsActive.length === 0)
                    commonCheckboxes.attr('disabled', 'disabled');
            }
            else {
                commonCheckboxes.removeAttr('disabled');
            }
        });
    }, _CruiseActivityBookPage_applyDiscount = function _CruiseActivityBookPage_applyDiscount(currentExcurtion, totalPrice) {
        const adultCount = $('.js-options-set-adult .js-person-options-initials', currentExcurtion).length;
        const childCount = $('.js-options-set-child .js-person-options-initials', currentExcurtion).length;
        const discountBlock = $('.js-block-discount', __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f"));
        discountBlock.hide();
        let discount = 0;
        $('.js-cruise-activity-packet', __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f")).each((index, el) => {
            const discountAd = Number($(el).attr('data-discount-adult'));
            const discountCh = Number($(el).attr('data-discount-child'));
            const countExcur = $(el).find('.js-options-set').length;
            for (let i = 0; i < adultCount; ++i) {
                const elements = $(`.js-person-options-initials[data-target=adult${i}]`).find(':checked');
                if (elements.length >= countExcur)
                    discount += discountAd;
            }
            for (let j = 0; j < childCount; ++j) {
                const elements = $(`.js-person-options-initials[data-target=child${j}]`).find(':checked');
                if (elements.length >= countExcur)
                    discount += discountCh;
            }
        });
        if (discount > 0) {
            discountBlock.get(0).amount = discount;
            discountBlock.show();
        }
        return totalPrice - discount;
    }, _CruiseActivityBookPage_onGroupCheckboxClick = function _CruiseActivityBookPage_onGroupCheckboxClick(e, jqElement) {
        const target = $(e.currentTarget);
        const checkbox = target.is(':checkbox');
        const checked = checkbox ? target.is(':checked') : !target.is('._checked, ._checked-half');
        if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
            return false;
        if (!checkbox)
            target.removeClass('_checked-half').toggleClass('_checked', checked);
        if (checked && $('.js-options-set-item:disabled', jqElement).length > 0)
            target.removeClass('_checked').addClass('_checked-half');
        const items = $('.js-options-set-item', jqElement).not(':disabled');
        items.each((index, element) => {
            const itemTarget = $(element);
            const itemCheckbox = itemTarget.is(':checkbox');
            if (itemCheckbox)
                itemTarget.prop('checked', checked);
            else
                itemTarget.toggleClass('_checked', checked);
        });
        __classPrivateFieldGet(this, _CruiseActivityBookPage_instances, "m", _CruiseActivityBookPage_selectedOptionsChanged).call(this, jqElement);
        __classPrivateFieldGet(_a, _a, "m", _CruiseActivityBookPage_checkActivityDateCommon).call(_a, target, checked);
        return true;
    }, _CruiseActivityBookPage_onTouristCheckboxClick = function _CruiseActivityBookPage_onTouristCheckboxClick(e, jqElement, toggle) {
        const target = $(e.currentTarget);
        const checkbox = target.is(':checkbox');
        const checked = checkbox ? target.is(':checked') : !target.is('._checked');
        const toggleCheckbox = toggle.is(':checkbox');
        if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
            return false;
        if (!checkbox)
            target.toggleClass('_checked', checked);
        const items = $('.js-options-set-item', jqElement);
        const checkedCount = items.filter(':checked, ._checked').length;
        if (toggleCheckbox) {
            target.prop('checked', checkedCount > 0);
        }
        else {
            toggle
                .toggleClass('_checked', checkedCount === items.length)
                .toggleClass('_checked-half', checkedCount !== 0 && checkedCount < items.length);
        }
        __classPrivateFieldGet(this, _CruiseActivityBookPage_instances, "m", _CruiseActivityBookPage_selectedOptionsChanged).call(this, jqElement);
        __classPrivateFieldGet(_a, _a, "m", _CruiseActivityBookPage_checkActivityDate).call(_a, target, checked);
        return true;
    }, _CruiseActivityBookPage_onBookClick = function _CruiseActivityBookPage_onBookClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const data = __classPrivateFieldGet(this, _CruiseActivityBookPage_formOrder, "f").serializeArray();
            const xhr = $.ajax({
                url: this.options.urls.activityBook,
                method: 'POST',
                data,
            });
            const popup = new App.Popup();
            const popupGroup = popup.show({
                group: 'main',
                content: App.templates.Cruise.Messages.ActivityBooking({}),
                delay: 500,
                modal: true,
            });
            const responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) });
            try {
                const response = yield xhr;
                if (!responseValidator.process(response))
                    return;
                return;
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                popup.hide(popupGroup);
            }
        });
    };
    App.CruiseActivityBookPage = CruiseActivityBookPage;
})(App || (App = {}));
// TODO: очистка фильтра: сбрасываетя валюта всегда на рубли в слайдере
var App;
(function (App) {
    var _CruisePageMobileBase_instances, _a, _CruisePageMobileBase_seoModule, _CruisePageMobileBase_getParamsFromMainFiltersSearchBlock, _CruisePageMobileBase_addParamSearchBlock, _CruisePageMobileBase_getParamsFromSortBlock, _CruisePageMobileBase_getParamsFromSearchBlock, _CruisePageMobileBase_getParamsOfSelectElementByFilter, _CruisePageMobileBase_getParamsOfInputElementByFilter, _CruisePageMobileBase_onLinkClick, _CruisePageMobileBase_closeCabinDescription;
    class CruisePageMobileBase extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruisePageMobileBase_instances.add(this);
            Object.defineProperty(this, "options", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _CruisePageMobileBase_seoModule.set(this, void 0);
            Object.defineProperty(this, "routeNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "searchExecuting", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "state", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "states", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "preloader", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "seo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "responseValidator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pricePresenter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "scrollBookLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "bookScrollToWrap", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // protected digest: Digest;
            Object.defineProperty(this, "tabs", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "popupInfo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "expirationPopup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "context", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cabinDescrWrapClass", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.options = options;
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruisePageMobileBase_seoModule, App.app.seo, "f");
            this.context = new App.QueryParams(window.location.pathname).getContext();
            this.preloader = new App.Preloader();
            this.seo = {};
            this.cabinDescrWrapClass = 'js-cruise-cabinDescr';
            // Прокрутка якорных ссылок
            this.root.on('click', '.js-scroll-to', e => App.scrollLinkClickHandler(e));
            // Читать полностью
            this.root.on('click', '.js-read-more', e => App.readMoreClickHandler(e));
            // открытие ссылок внутри блоков (ссылок)
            this.root.on('click', '[data-href]', (e) => __classPrivateFieldGet(_a, _a, "m", _CruisePageMobileBase_onLinkClick).call(_a, e));
        }
        static sortArray(values, checkProperty) {
            return values.sort((a, b) => {
                if (a[checkProperty] > b[checkProperty])
                    return 1;
                if (a[checkProperty] < b[checkProperty])
                    return -1;
                // a должно быть равным b
                return 0;
            });
        }
        static uniqArray(values, checkProperties) {
            // массив простых типов
            if (checkProperties.length === 0)
                return Array.from(new Set(values));
            // массив объектов
            return values.filter((value, index) => index === values.findIndex(element => {
                let predicate = false;
                checkProperties.forEach(prop => {
                    predicate = (element[prop] === value[prop]);
                });
                return predicate;
            }));
        }
        static show(jqObj, scrollTop, typeTopScroll) {
            if (!jqObj)
                return;
            /* typeTopScroll: 1 - body, 2 - сам элемент jqObj*/
            const scrollObj = typeTopScroll === 1 ? $('body') : jqObj;
            jqObj.removeClass('_hidden-2');
            if (scrollTop) {
                const scrollObjOffset = scrollObj.offset();
                $('html, body').animate({ scrollTop: (scrollObjOffset != null ? scrollObjOffset.top : 0) }, 'slow');
            }
        }
        static hide(jqObj) {
            if (!jqObj)
                return;
            jqObj.addClass('_hidden-2');
        }
        static formatDate(date) {
            // 25.03.2017 -> 20170325 - Russian
            const dateParts = date.split('.');
            return dateParts[2] + dateParts[1] + dateParts[0];
        }
        static addDaysAndFormat(dateStr, days) {
            const date = App.addDays(new Date(dateStr), days);
            return App.formatDate(date, 'shortIsoDate');
        }
        static formatTime(time) {
            // 12:00:00 -> 1200
            const timeParts = time.split(':');
            return timeParts[0] + timeParts[1];
        }
        static addDays(dateStr, countDays) {
            const date = new Date(dateStr);
            date.setDate(date.getDate() + countDays);
            return App.formatDate(date, 'shortIsoDate');
        }
        static abbreviateMulti(text, maxLength, abbrText) {
            return {
                item1: text.length >= maxLength ? text : '',
                item2: text.substring(0, maxLength) + abbrText,
            };
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                this.cleanPage();
                yield this.states[this.state].handler();
            });
        }
        cleanPage() {
        }
        updateSeo(seoInfo) {
            if (__classPrivateFieldGet(this, _CruisePageMobileBase_seoModule, "f") != null && seoInfo != null)
                App.app.seo.update(seoInfo);
        }
        saveState(state, add, replace, isReplace = false) {
            this.state = state;
            const queryParams = new App.QueryParams(window.location.pathname);
            queryParams.clear();
            queryParams.setAction(this.states[this.state].actionName);
            if (add) {
                Object.getOwnPropertyNames(add).forEach(value => {
                    if (add[value].length === 1 && add[value][0] === '')
                        queryParams.remove(value);
                    else
                        queryParams.add(value, add[value]);
                });
            }
            if (replace) {
                Object.getOwnPropertyNames(replace).forEach(value => {
                    if (replace[value].length === 1 && replace[value][0] === '')
                        queryParams.remove(value);
                    else
                        queryParams.replace(value, replace[value]);
                });
            }
            const url = queryParams.getUrl();
            if (isReplace)
                App.History.replaceState(this.state, url, true);
            else
                App.History.saveState(this.state, url);
        }
        getParamsFromFilters(filter) {
            const params = {};
            const filterParams = __classPrivateFieldGet(_a, _a, "m", _CruisePageMobileBase_getParamsFromSearchBlock).call(_a, filter);
            filterParams.forEach(value => {
                if (this.options.changes.includes(value.key))
                    params[value.key] = value.value;
            });
            return params;
        }
        getParamsFromFiltersMobile(filter, otherHotFilter) {
            const params = {};
            let filterParams = __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_getParamsFromMainFiltersSearchBlock).call(this, filter);
            if (otherHotFilter) {
                const hotFilterParams = otherHotFilter.getParamsForSearch(true);
                filterParams = filterParams.concat(hotFilterParams);
                filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _CruisePageMobileBase_getParamsFromSortBlock).call(_a, otherHotFilter.root));
            }
            filterParams.forEach(value => {
                params[value.key] = value.value;
            });
            return params;
        }
        static convertArrayToRequestData(elements) {
            const data = {};
            $.each(elements, (_, v) => {
                if (v.value == null || v.value === '')
                    return true;
                let values = v.value;
                if (typeof v.value === 'string')
                    values = v.value.split(',');
                if (v.name.length > 0 && values.length > 0)
                    data[v.name] = values;
                return true;
            });
            return data;
        }
        onScrollDescrBlock() {
            // TODO: https://jquery.com/upgrade-guide/3.0/#breaking-change-outerwidth-or-outerheight-on-window-includes-scrollbar-width-height
            const scrolledPos = ($(window).scrollTop() || 0) + ($(window).outerHeight() || 0);
            const offset = this.bookScrollToWrap.offset();
            const offsetTop = (offset != null ? offset.top : 0);
            if (scrolledPos >= offsetTop && scrolledPos < offsetTop + (this.bookScrollToWrap.outerHeight() || 0))
                this.scrollBookLink.addClass('_fixed_book');
            else
                this.scrollBookLink.removeClass('_fixed_book');
        }
        onCabinTitleClick(event) {
            var _b;
            event.preventDefault();
            event.stopPropagation();
            if (this.popupInfo)
                App.popupHide();
            const cabinKey = (_b = $(event.currentTarget).attr('data-key')) !== null && _b !== void 0 ? _b : '';
            const qp = new App.QueryParams(window.location.pathname);
            if (cabinKey.length > 0) {
                qp.setParamAncher(cabinKey);
                App.History.replaceState(this.state, qp.getUrl(), true);
            }
            this.popupInfo = new App.PopupOld({
                content: $(`<div class="${this.cabinDescrWrapClass} cruise-cabinDescr"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
                onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { return yield this.getCabinDescription(cabinKey); }),
                onHideDelegate: () => __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_closeCabinDescription).call(this, qp),
            });
            $('body').trigger("popup:open" /* Events.PopupOpen */, []);
        }
        getCabinDescription(key) {
            return __awaiter(this, void 0, void 0, function* () {
                const xhr = $.ajax({
                    url: this.options.urls.getCabinDescription,
                    method: 'POST',
                    data: { cabinKey: key },
                });
                try {
                    const response = yield xhr;
                    if (!this.responseValidator.process(response))
                        return;
                    if (response.data.cabin.experience != null) {
                        const experience = response.data.cabin.experience.toLowerCase().replace(' ', '-');
                        response.data.cabin.experienceLink = `/help/cruise/msc-cruises/cabin-experience/${experience}/`;
                    }
                    const blockDescr = $(App.templates.Cruise.Route.CabinDescr({ cabin: response.data.cabin }));
                    $(`.${this.cabinDescrWrapClass}`, $('.js-popup')).empty().append(blockDescr);
                    // инициализация фоток
                    this.components.push(new App.MediaGallery({ wrap: '.js-cruise-cabinDescr' }));
                }
                catch (ex) {
                    if (!this.responseValidator.processError(ex))
                        throw ex;
                }
            });
        }
    }
    _a = CruisePageMobileBase, _CruisePageMobileBase_seoModule = new WeakMap(), _CruisePageMobileBase_instances = new WeakSet(), _CruisePageMobileBase_getParamsFromMainFiltersSearchBlock = function _CruisePageMobileBase_getParamsFromMainFiltersSearchBlock(filter) {
        const params = [];
        const filterParams = filter.getParamsForSearch(true);
        const valuesByKey = new Map(filterParams.map(item => {
            var _b;
            return [
                item.key.toLowerCase(),
                ((_b = item.value) !== null && _b !== void 0 ? _b : []).map(value => value.toString()),
            ];
        }));
        const getValues = (...keys) => {
            return keys.flatMap(key => { var _b; return (_b = valuesByKey.get(key.toLowerCase())) !== null && _b !== void 0 ? _b : []; });
        };
        const formatDate = (value) => {
            if (!value)
                return value;
            if (/^\d{8}$/.test(value))
                return value;
            if (/^\d{2}\.\d{2}\.\d{4}$/.test(value))
                return _a.formatDate(value);
            return value;
        };
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'checkin', getValues('Checkin.From', 'Checkin.To').map(formatDate));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'city', getValues('City'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'fare', getValues('Fare'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'type', getValues('Type'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'region', getValues('Region'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'port', getValues('Port'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'ship', getValues('Ship'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'night', getValues('Night.From', 'Night.To'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'cabin', getValues('Cabin'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'seats', getValues('Seats'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'rusgroup', getValues('RusGroup'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'direct', getValues('Direct'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'tourist', getValues('Tourist'));
        __classPrivateFieldGet(this, _CruisePageMobileBase_instances, "m", _CruisePageMobileBase_addParamSearchBlock).call(this, params, 'price', getValues('price'));
        return params;
    }, _CruisePageMobileBase_addParamSearchBlock = function _CruisePageMobileBase_addParamSearchBlock(params, key, value) {
        if (!value || value.length <= 0)
            return;
        if (value.length == 1 && (value[0] == 'false' || value[0] == '0' || value[0] == ''))
            return;
        const existKey = params.findIndex(el => el.key === key);
        if (existKey !== -1)
            params[existKey].value = params[existKey].value.concat(value);
        else
            params.push({ key, value });
    }, _CruisePageMobileBase_getParamsFromSortBlock = function _CruisePageMobileBase_getParamsFromSortBlock(filter) {
        var _b;
        const params = [];
        const sortValue = (_b = $('.js-sort-item._active', filter).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
        params.push({ key: 'sort', value: [sortValue] });
        return params;
    }, _CruisePageMobileBase_getParamsFromSearchBlock = function _CruisePageMobileBase_getParamsFromSearchBlock(filter) {
        const params = [];
        filter.find('.filter-block').each((_, element) => {
            const jqElement = $(element);
            let key = '';
            let value = [];
            const select = jqElement.attr('data-select');
            if (select) {
                key = select.toLowerCase();
                value = __classPrivateFieldGet(_a, _a, "m", _CruisePageMobileBase_getParamsOfSelectElementByFilter).call(_a, element);
            }
            else {
                const name = jqElement.attr('data-name');
                if (name) {
                    key = name.toLowerCase();
                    value = __classPrivateFieldGet(_a, _a, "m", _CruisePageMobileBase_getParamsOfInputElementByFilter).call(_a, element);
                }
                else if (jqElement.attr('data-nights') !== undefined) {
                    key = 'night';
                    value = __classPrivateFieldGet(_a, _a, "m", _CruisePageMobileBase_getParamsOfInputElementByFilter).call(_a, element);
                }
            }
            if (key.length > 0 && value.length > 0)
                params.push({ key, value });
        });
        return params;
    }, _CruisePageMobileBase_getParamsOfSelectElementByFilter = function _CruisePageMobileBase_getParamsOfSelectElementByFilter(el) {
        const values = [];
        const valueStr = $(el).find('.js-jelect-input').valString();
        // проверка на пустоту убрана, все списки без значений будут удалены из url в saveState
        valueStr.split(',').forEach(value => {
            values.push(value);
        });
        return values;
    }, _CruisePageMobileBase_getParamsOfInputElementByFilter = function _CruisePageMobileBase_getParamsOfInputElementByFilter(el) {
        const values = [];
        $(el).find('input').each((_, element) => {
            if ($(element).hasClass('js-not_for_filter'))
                return;
            let value = $(element).valString().toLowerCase();
            if ($(element).hasClass('filter-date-input'))
                value = App.CruisePageBase.formatDate(value);
            if ($(element).hasClass('js-return-same'))
                value = (value === 'true' ? 1 : 0).toString();
            if ($(element).hasClass('filter-slider-input'))
                value = $(element).attr('data-text') || '';
            if (value)
                values.push(value.toString().toLowerCase());
        });
        return values;
    }, _CruisePageMobileBase_onLinkClick = function _CruisePageMobileBase_onLinkClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const link = $(event.currentTarget).attr('data-href');
        window.open(link);
        return false;
    }, _CruisePageMobileBase_closeCabinDescription = function _CruisePageMobileBase_closeCabinDescription(qp) {
        const dopParam = qp.getParamAncher();
        if (dopParam.length > 0) {
            qp.setParamAncher('');
            App.History.replaceState(this.state, qp.getUrl(), true);
        }
    };
    App.CruisePageMobileBase = CruisePageMobileBase;
})(App || (App = {}));
/// <reference path='CruisePageBase.Mobile.ts' />
var App;
(function (App) {
    var _CruiseActivityInfoPageMobile_portTabs;
    class CruiseActivityInfoPageMobile extends App.CruisePageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-activity-info-page' }, options));
            _CruiseActivityInfoPageMobile_portTabs.set(this, void 0);
            this.states = {
                'info': {
                    handler: () => __awaiter(this, void 0, void 0, function* () { }),
                    actionName: 'info',
                    keysForUrl: [],
                },
            };
            this.state = 'info';
            if (!this.root.length)
                return;
            // инициализация фоток
            this.components.push(new App.MediaGalleryMobile());
            // инициализация табов
            __classPrivateFieldSet(this, _CruiseActivityInfoPageMobile_portTabs, new App.Tabs(), "f");
            __classPrivateFieldGet(this, _CruiseActivityInfoPageMobile_portTabs, "f").showActive();
        }
    }
    _CruiseActivityInfoPageMobile_portTabs = new WeakMap();
    App.CruiseActivityInfoPageMobile = CruiseActivityInfoPageMobile;
})(App || (App = {}));
/// <reference path='CruisePageBase.ts' />
var App;
(function (App) {
    var _CruiseActivityInfoPage_portTabs;
    class CruiseActivityInfoPage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-activity-info-page' }, options));
            _CruiseActivityInfoPage_portTabs.set(this, void 0);
            this.states = {
                'info': {
                    handler: () => __awaiter(this, void 0, void 0, function* () { }),
                    actionName: 'info',
                    keysForUrl: [],
                },
            };
            this.state = 'info';
            if (!this.root.length)
                return;
            // инициализация фоток
            this.components.push(new App.MediaGallery({ wrap: '.tour-slider-and-info-block' }));
            // инициализация табов
            __classPrivateFieldSet(this, _CruiseActivityInfoPage_portTabs, new App.Tabs(), "f");
            __classPrivateFieldGet(this, _CruiseActivityInfoPage_portTabs, "f").showActive();
        }
    }
    _CruiseActivityInfoPage_portTabs = new WeakMap();
    App.CruiseActivityInfoPage = CruiseActivityInfoPage;
})(App || (App = {}));
/// <reference path='CruisePageBase.ts' />
var App;
(function (App) {
    var _CruiseBoardServicePage_instances, _CruiseBoardServicePage_formOrder, _CruiseBoardServicePage_onBookClick, _CruiseBoardServicePage_onSwitchDogovor, _CruiseBoardServicePage_changeBoardServices;
    class CruiseBoardServicePage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-boardservice-page .js-app-container-content' }, options));
            _CruiseBoardServicePage_instances.add(this);
            _CruiseBoardServicePage_formOrder.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseBoardServicePage_formOrder, $('.js-cruise-boardservice_order', this.root), "f");
            __classPrivateFieldGet(this, _CruiseBoardServicePage_formOrder, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBoardServicePage_instances, "m", _CruiseBoardServicePage_onBookClick).call(this, e); }));
            $('.js-boardservice-switchDogovor', __classPrivateFieldGet(this, _CruiseBoardServicePage_formOrder, "f")).on('change', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBoardServicePage_instances, "m", _CruiseBoardServicePage_onSwitchDogovor).call(this, e); }));
        }
    }
    _CruiseBoardServicePage_formOrder = new WeakMap(), _CruiseBoardServicePage_instances = new WeakSet(), _CruiseBoardServicePage_onBookClick = function _CruiseBoardServicePage_onBookClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const data = __classPrivateFieldGet(this, _CruiseBoardServicePage_formOrder, "f").serializeArray();
            const xhr = $.ajax({
                url: this.options.urls.bookBoardService,
                method: 'POST',
                data,
            });
            const popup = new App.Popup();
            const popupGroup = popup.show({
                group: 'main',
                content: App.templates.Cruise.Messages.BoardServiceBooking({}),
                delay: 500,
                modal: true,
            });
            const responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) });
            try {
                const response = yield xhr;
                if (!responseValidator.process(response))
                    return;
                return;
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                popup.hide(popupGroup);
            }
        });
    }, _CruiseBoardServicePage_onSwitchDogovor = function _CruiseBoardServicePage_onSwitchDogovor(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const data = __classPrivateFieldGet(this, _CruiseBoardServicePage_formOrder, "f").serializeArray();
            const xhr = $.ajax({
                url: this.options.urls.getBoardServices,
                method: 'POST',
                data,
            });
            const popup = new App.Popup();
            const popupGroup = popup.show({
                group: 'main',
                content: App.templates.Cruise.Messages.BoardServiceBooking({}),
                delay: 500,
                modal: true,
            });
            const responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) });
            try {
                const response = yield xhr;
                if (!responseValidator.process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseBoardServicePage_instances, "m", _CruiseBoardServicePage_changeBoardServices).call(this, response.data);
                return;
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                popup.hide(popupGroup);
            }
        });
    }, _CruiseBoardServicePage_changeBoardServices = function _CruiseBoardServicePage_changeBoardServices(service) {
        if (service.availableServices.length === 0) {
            const content = $(App.templates.Cruise.BoardService.ServiceEmpty({}));
            $('.js-cruise-boardservice-items', __classPrivateFieldGet(this, _CruiseBoardServicePage_formOrder, "f")).empty().append(content);
            return;
        }
        const bService = service.availableServices[0];
        const promo = bService.options.find(v => v.details.fare === 'promo');
        const standard = bService.options.find(v => v.details.fare === 'standard');
        const optionKey = promo !== undefined ? promo.optionKey : standard === null || standard === void 0 ? void 0 : standard.optionKey;
        const grossCost = promo !== undefined ? promo.grossCost : standard === null || standard === void 0 ? void 0 : standard.grossCost;
        const content = $(App.templates.Cruise.BoardService.Service({
            groupKey: bService.groupKey,
            optionKey,
            currency: service.currency,
            grossCost,
            type: promo !== undefined ? 'ПРОМО' : 'СТАНДАРТ',
        }));
        $('.js-cruise-boardservice-item', __classPrivateFieldGet(this, _CruiseBoardServicePage_formOrder, "f")).empty().append(content);
    };
    App.CruiseBoardServicePage = CruiseBoardServicePage;
})(App || (App = {}));
/// <reference path='CruisePageBase.Mobile.ts' />
var App;
(function (App) {
    var _CruiseBookPageMobile_instances, _a, _CruiseBookPageMobile_bookFilter, _CruiseBookPageMobile_formBook, _CruiseBookPageMobile_popup, _CruiseBookPageMobile_popupGroup, _CruiseBookPageMobile_bookWrapClass, _CruiseBookPageMobile_bookWrap, _CruiseBookPageMobile_optionsSet, _CruiseBookPageMobile_formOrder, _CruiseBookPageMobile_controls, _CruiseBookPageMobile_currentCabin, _CruiseBookPageMobile_cabinCategoryKey, _CruiseBookPageMobile_fareCode, _CruiseBookPageMobile_cruiseId, _CruiseBookPageMobile_hotelsInfo, _CruiseBookPageMobile_availableCabinsData, _CruiseBookPageMobile_cruisePartsData, _CruiseBookPageMobile_quotesData, _CruiseBookPageMobile_hasDynamicFlights, _CruiseBookPageMobile_checkActivities, _CruiseBookPageMobile_activityTotalPrice, _CruiseBookPageMobile_activityTotalCommision, _CruiseBookPageMobile_activitiesData, _CruiseBookPageMobile_orderPlacement, _CruiseBookPageMobile_placementHotels, _CruiseBookPageMobile_isVaucherOrderChecked, _CruiseBookPageMobile_baseOrder, _CruiseBookPageMobile_baseOrderWrap, _CruiseBookPageMobile_clubCardData, _CruiseBookPageMobile_aviaResultComponent, _CruiseBookPageMobile_svgLoaderClass, _CruiseBookPageMobile_bookDigest, _CruiseBookPageMobile_validator, _CruiseBookPageMobile_agentBlackListComponent, _CruiseBookPageMobile_showBookPage, _CruiseBookPageMobile_initSvgLayer, _CruiseBookPageMobile_initFlights, _CruiseBookPageMobile_finishInitialization, _CruiseBookPageMobile_initInc, _CruiseBookPageMobile_onAviaGroupClick, _CruiseBookPageMobile_getBookContentDigestServices, _CruiseBookPageMobile_getBookPriceDigestServices, _CruiseBookPageMobile_isNullOrEmpty, _CruiseBookPageMobile_geServiceTypeString, _CruiseBookPageMobile_getInsuranceTypeName, _CruiseBookPageMobile_getServiceTypeName, _CruiseBookPageMobile_getServiceOrder, _CruiseBookPageMobile_getAvailableServicesByType, _CruiseBookPageMobile_generateFlightTags, _CruiseBookPageMobile_nextDayArrival, _CruiseBookPageMobile_getFlightService, _CruiseBookPageMobile_getFlightResults, _CruiseBookPageMobile_getCruiseParts, _CruiseBookPageMobile_getHotelsInfo, _CruiseBookPageMobile_getHotelServices, _CruiseBookPageMobile_changeHotelServicesSelected, _CruiseBookPageMobile_prepareDataForGetQuotes, _CruiseBookPageMobile_prepareDataForBook, _CruiseBookPageMobile_initPlacement, _CruiseBookPageMobile_checkActivityDateCommon, _CruiseBookPageMobile_checkActivityDate, _CruiseBookPageMobile_selectedOptionsChanged, _CruiseBookPageMobile_saveActivityChangedData, _CruiseBookPageMobile_applyActivityPacketDiscount, _CruiseBookPageMobile_getActivityTotalPrice, _CruiseBookPageMobile_getDigestData, _CruiseBookPageMobile_updateDigest, _CruiseBookPageMobile_onBookSend, _CruiseBookPageMobile_onBookingButtonClick, _CruiseBookPageMobile_onBookFilterChanged, _CruiseBookPageMobile_focusFirstInvalidField, _CruiseBookPageMobile_getQuotes, _CruiseBookPageMobile_changeHotelPlacement, _CruiseBookPageMobile_book, _CruiseBookPageMobile_checkBaseOrder, _CruiseBookPageMobile_checkClubCard, _CruiseBookPageMobile_toggleCheckerError, _CruiseBookPageMobile_toggleCheckerSuccess, _CruiseBookPageMobile_onServiceVariantSelect, _CruiseBookPageMobile_onServiceChange, _CruiseBookPageMobile_onQuotesChange, _CruiseBookPageMobile_onDeckChange, _CruiseBookPageMobile_onCabinChange, _CruiseBookPageMobile_onSvgLayerCabinClick, _CruiseBookPageMobile_onSvgLayerLoaded, _CruiseBookPageMobile_onPersonTabClick, _CruiseBookPageMobile_onBookButtonClick, _CruiseBookPageMobile_onFioChange, _CruiseBookPageMobile_onShowMoreVariants, _CruiseBookPageMobile_initTouristDocumentMask, _CruiseBookPageMobile_changeTouristDocumentMask, _CruiseBookPageMobile_getDocumentNumberMask, _CruiseBookPageMobile_onHotelEditClick, _CruiseBookPageMobile_onHotelChange, _CruiseBookPageMobile_onHotelBoardChange, _CruiseBookPageMobile_onHotelRoomChange, _CruiseBookPageMobile_onBaseOrderChange, _CruiseBookPageMobile_onCheckBaseOrderClick, _CruiseBookPageMobile_onFioPhoneChange, _CruiseBookPageMobile_onClubCardNumberChange, _CruiseBookPageMobile_onCheckClubCardClick, _CruiseBookPageMobile_onBookPrivateClick, _CruiseBookPageMobile_switchSvgLoaderLegend;
    class CruiseBookPageMobile extends App.CruisePageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-page .js-app-container-content' }, options));
            _CruiseBookPageMobile_instances.add(this);
            _CruiseBookPageMobile_bookFilter.set(this, void 0);
            _CruiseBookPageMobile_formBook.set(this, void 0);
            _CruiseBookPageMobile_popup.set(this, void 0);
            _CruiseBookPageMobile_popupGroup.set(this, void 0);
            _CruiseBookPageMobile_bookWrapClass.set(this, void 0);
            _CruiseBookPageMobile_bookWrap.set(this, void 0);
            _CruiseBookPageMobile_optionsSet.set(this, void 0);
            // обертка для бронирования круиза
            _CruiseBookPageMobile_formOrder.set(this, void 0);
            _CruiseBookPageMobile_controls.set(this, new Array());
            _CruiseBookPageMobile_currentCabin.set(this, void 0);
            /* бронирование*/
            _CruiseBookPageMobile_cabinCategoryKey.set(this, void 0);
            _CruiseBookPageMobile_fareCode.set(this, void 0);
            _CruiseBookPageMobile_cruiseId.set(this, void 0);
            _CruiseBookPageMobile_hotelsInfo.set(this, void 0);
            /* результаты запросов*/
            _CruiseBookPageMobile_availableCabinsData.set(this, void 0);
            _CruiseBookPageMobile_cruisePartsData.set(this, void 0);
            _CruiseBookPageMobile_quotesData.set(this, void 0);
            _CruiseBookPageMobile_hasDynamicFlights.set(this, void 0);
            /* экскурсии в круизе */
            _CruiseBookPageMobile_checkActivities.set(this, void 0);
            _CruiseBookPageMobile_activityTotalPrice.set(this, void 0);
            _CruiseBookPageMobile_activityTotalCommision.set(this, void 0);
            _CruiseBookPageMobile_activitiesData.set(this, void 0);
            /* размещение в отеле*/
            _CruiseBookPageMobile_orderPlacement.set(this, void 0);
            _CruiseBookPageMobile_placementHotels.set(this, void 0);
            _CruiseBookPageMobile_isVaucherOrderChecked.set(this, false);
            _CruiseBookPageMobile_baseOrder.set(this, '');
            _CruiseBookPageMobile_baseOrderWrap.set(this, void 0);
            _CruiseBookPageMobile_clubCardData.set(this, void 0);
            _CruiseBookPageMobile_aviaResultComponent.set(this, void 0);
            _CruiseBookPageMobile_svgLoaderClass.set(this, void 0);
            _CruiseBookPageMobile_bookDigest.set(this, void 0);
            _CruiseBookPageMobile_validator.set(this, void 0);
            // #filters: FiltersMobileBase;
            _CruiseBookPageMobile_agentBlackListComponent.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseBookPageMobile_bookWrapClass, '.js-cruise-book', "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_svgLoaderClass, '#svgLoader', "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_bookWrap, $(__classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrapClass, "f"), $('.js-cruise-page')), "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_cruiseId, Number($('#cruiseId').val()), "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_fareCode, $('#fareCode').valString(), "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_cabinCategoryKey, Number($('#categoryKey').val()), "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_hasDynamicFlights, Number($('#hasDynamicFlights').val()), "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_currentCabin, this.options.offer, "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_cruisePartsData, this.options.parts, "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_availableCabinsData, this.options.cabins, "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_quotesData, this.options.quotes, "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_clubCardData, [], "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_activitiesData, [], "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_checkActivities, this.options.activities.length > 0, "f");
            // this.components.push(new FindTourist());
            // this.components.push(new AgentBlackListComponent());
            this.states = {
                'book': {
                    handler: () => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_showBookPage).call(this),
                    actionName: 'book',
                    keysForUrl: [],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseBookPageMobile_formOrder, $('.js-form-order', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")), "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_baseOrderWrap, $('.js-baseOrderWrap', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")), "f");
            // Note: переносим до создания класса Form и используем неделегируемые события для внесения изменений в значение поля перед
            // его валидацией.
            $('.js-person-tab-initials-a, .js-person-tab-initials-b, .js-person-birthday', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).on('change', e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onFioChange).call(this, e));
            this.components.push(new App.VariantsShowMoreComponent({ root: this.root }));
            __classPrivateFieldSet(this, _CruiseBookPageMobile_bookFilter, new App.FiltersMobileBase({ root: __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f") }), "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_formBook, new App.Form({ root: __classPrivateFieldGet(this, _CruiseBookPageMobile_bookFilter, "f").root, disableStepValidation: true }), "f");
            this.pricePresenter = new App.NetPricePresenter({ root: this.root, desired: App.AdditionalPriceShow.ToPay });
            // ваучер с бортовым кредитом
            // const vaucherSwitcher = this.#bookFilter.root.find('[data-name="creditvaucher"]');
            // vaucherSwitcher.on('click', e => this.#onSwitcherClick(e));
            $('#baseOrder').on('change', () => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onBaseOrderChange).call(this));
            $('#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onCheckBaseOrderClick).call(this, e); }));
            // табы туристов
            __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").on('click', '.js-person-tab', e => __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_onPersonTabClick).call(_a, e));
            __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").on('click', '.js-person-tab-next', e => {
                const tabs = $(e.currentTarget).closest('.js-persons-tabs');
                const tab = $('.js-person-tab', tabs);
                tab.filter('._active').next().trigger('click');
            });
            // клубная карта
            $('.js-needForClubCard', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).on('change', e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onFioPhoneChange).call(this, e));
            $('.js-clubCardNumber', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).on('change', e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onClubCardNumberChange).call(this, e));
            $('.js-checkClubCard', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onCheckClubCardClick).call(this, e); }));
            // Изменение гражданства.
            __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").find('.js-person-tab-wrap').each((i, v) => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_initTouristDocumentMask).call(this, $(v)));
            __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").on('change', '.js-person-citizenship .js-jelect', e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_changeTouristDocumentMask).call(this, e));
            // выбор страховок, сервисного сбора
            $('.js-service-insurance, .js-service-fee', this.root).on('change', '.js-basic-variant-input', (e) => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_onServiceVariantSelect).call(_a, e);
                yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onServiceChange).call(this);
            }));
            // развернуть выбор вариантов
            __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").on('click', '.js-show-more-variants', e => __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_onShowMoreVariants).call(_a, e));
            // формат календаря для даты рождения
            const currentYear = new Date().getFullYear();
            // Человеком, который прожил самую долгую жизнь, считается француженка Жанна Кальман. Она успела отметить свой 122 день
            // рождения прежде, чем отошла в мир иной.
            const minYear = currentYear - 125;
            const calendars = $('.js-form-date', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f"));
            calendars.inputmask('date');
            const calendarIcons = $('.js-filter-date-from-icon', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f"));
            calendarIcons.on('click', (event) => {
                $(event.currentTarget).prev('.js-form-date').trigger('focus');
            });
            const calendarBirthday = $('._birthday .js-form-date', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f"));
            calendarBirthday.datepicker('option', {
                yearRange: `${minYear}:${currentYear}`,
                minDate: -110 * 365,
                maxDate: 50 * 365,
            });
            $('.js-decks', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")).on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onDeckChange).call(this, e));
            $('.js-cabins', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")).on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onCabinChange).call(this, e));
            // выбор виз
            $('.table_insurance', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")).on('click', '.js-book-services-checkbox', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onServiceChange).call(this); }));
            __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f").on("quotes:change" /* Events.QuotesChange */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onQuotesChange).call(this); }));
            $('.js-digest-floater-button', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onBookButtonClick).call(this, e); }));
            // корзина просрочена
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            this.expirationPopup = App.scheduleExpirationPopup({
                interval: this.options.offerExpiration,
                url: this.options.urls.searchRoutes,
            });
            __classPrivateFieldSet(this, _CruiseBookPageMobile_popup, new App.Popup({
                onShow: () => {
                    $('.js-popup-close', __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").hide());
                },
            }), "f");
            // вывод скидки
            const digest = $('.js-digest', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f"));
            digest.on('click', '.js-digest-footer-details-show', () => {
                $('.js-digest-footer-wrap', digest).addClass('_detail');
            });
            digest.on('click', '.js-digest-footer-details-hide', () => {
                $('.js-digest-footer-wrap', digest).removeClass('_detail');
            });
            $(document).on("NetPricePresenter:click" /* Events.NetPricePresenterClick */, () => {
                $('.js-digest-footer-wrap', digest).removeClass('_detail');
            });
            // заявка для неавторизованных пользователей
            $('.js-pw-order-submit-private', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onBookPrivateClick).call(this); }));
            App.AviaResultComponent.initMiddleName(this.root, false);
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, (e) => __awaiter(this, void 0, void 0, function* () {
                const data = yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getDigestData).call(this);
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта(при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data,
                    },
                }));
            }));
            // показать/скрыть легенду для палубы
            $('.js-ship-svg-legend-button', '.js-ship-svg-legend-wrap').on('click', e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_switchSvgLoaderLegend).call(this, e));
        }
    }
    _a = CruiseBookPageMobile, _CruiseBookPageMobile_bookFilter = new WeakMap(), _CruiseBookPageMobile_formBook = new WeakMap(), _CruiseBookPageMobile_popup = new WeakMap(), _CruiseBookPageMobile_popupGroup = new WeakMap(), _CruiseBookPageMobile_bookWrapClass = new WeakMap(), _CruiseBookPageMobile_bookWrap = new WeakMap(), _CruiseBookPageMobile_optionsSet = new WeakMap(), _CruiseBookPageMobile_formOrder = new WeakMap(), _CruiseBookPageMobile_controls = new WeakMap(), _CruiseBookPageMobile_currentCabin = new WeakMap(), _CruiseBookPageMobile_cabinCategoryKey = new WeakMap(), _CruiseBookPageMobile_fareCode = new WeakMap(), _CruiseBookPageMobile_cruiseId = new WeakMap(), _CruiseBookPageMobile_hotelsInfo = new WeakMap(), _CruiseBookPageMobile_availableCabinsData = new WeakMap(), _CruiseBookPageMobile_cruisePartsData = new WeakMap(), _CruiseBookPageMobile_quotesData = new WeakMap(), _CruiseBookPageMobile_hasDynamicFlights = new WeakMap(), _CruiseBookPageMobile_checkActivities = new WeakMap(), _CruiseBookPageMobile_activityTotalPrice = new WeakMap(), _CruiseBookPageMobile_activityTotalCommision = new WeakMap(), _CruiseBookPageMobile_activitiesData = new WeakMap(), _CruiseBookPageMobile_orderPlacement = new WeakMap(), _CruiseBookPageMobile_placementHotels = new WeakMap(), _CruiseBookPageMobile_isVaucherOrderChecked = new WeakMap(), _CruiseBookPageMobile_baseOrder = new WeakMap(), _CruiseBookPageMobile_baseOrderWrap = new WeakMap(), _CruiseBookPageMobile_clubCardData = new WeakMap(), _CruiseBookPageMobile_aviaResultComponent = new WeakMap(), _CruiseBookPageMobile_svgLoaderClass = new WeakMap(), _CruiseBookPageMobile_bookDigest = new WeakMap(), _CruiseBookPageMobile_validator = new WeakMap(), _CruiseBookPageMobile_agentBlackListComponent = new WeakMap(), _CruiseBookPageMobile_instances = new WeakSet(), _CruiseBookPageMobile_showBookPage = function _CruiseBookPageMobile_showBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageMobileBase.show(__classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f"), true, 1);
            const messenger = new App.PopupMessenger(__classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f"));
            this.responseValidator = new App.ResponseValidatorOld({ messenger, validator: this.validator });
            __classPrivateFieldSet(this, _CruiseBookPageMobile_popupGroup, __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Valuating({}),
                modal: true,
                delay: 3000,
            }), "f");
            const data = JSON.parse(JSON.stringify(__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f")));
            const hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getAvailableServicesByType).call(_a, data, 'hotel', true);
            if (hotelServices.length > 0)
                __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_initPlacement).call(this, hotelServices);
            App.AviaResultComponent.initMiddleName(this.root, false);
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_initFlights).call(this);
            __classPrivateFieldSet(this, _CruiseBookPageMobile_optionsSet, $('.js-options-set', this.root), "f");
            // Группа опций (экскурсии).
            __classPrivateFieldGet(this, _CruiseBookPageMobile_optionsSet, "f").each((_, element) => {
                const jqElement = $(element);
                const toggle = $('.js-options-set-toggle', jqElement);
                // Общий чекбокс для группы.
                toggle.on('click', e => {
                    const target = $(e.currentTarget);
                    const checkbox = target.is(':checkbox');
                    // Note: для НЕ-checkbox инвертируем значение, т.к. click на checkbox возвращает новое значение (а-ля после нажатия),
                    // а click на НЕ-checkbox - старое (до нажатия).
                    const checked = checkbox ? target.is(':checked') : !target.is('._checked, ._checked-half');
                    if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
                        return false;
                    if (!checkbox)
                        target.removeClass('_checked-half').toggleClass('_checked', checked);
                    if (checked && $('.js-options-set-item:disabled', jqElement).length > 0)
                        target.removeClass('_checked').addClass('_checked-half');
                    const items = $('.js-options-set-item', jqElement).not(':disabled');
                    items.each((__, element2) => {
                        const itemTarget = $(element2);
                        const itemCheckbox = itemTarget.is(':checkbox');
                        if (itemCheckbox)
                            itemTarget.prop('checked', checked);
                        else
                            itemTarget.toggleClass('_checked', checked);
                    });
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_selectedOptionsChanged).call(this, jqElement);
                    __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_checkActivityDateCommon).call(_a, target, checked);
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
                    return true;
                });
                // Синхронизуем чекбоксы персон с общим чекбоксом.
                jqElement.on('click', '.js-options-set-item', (e) => {
                    const target = $(e.currentTarget);
                    const checkbox = target.is(':checkbox');
                    // Note: для НЕ-checkbox инвертируем значение, т.к. click на checkbox возвращает новое значение (а-ля после нажатия), а
                    // click на НЕ-checkbox - старое (до нажатия).
                    const checked = checkbox ? target.is(':checked') : !target.is('._checked');
                    const toggleCheckbox = toggle.is(':checkbox');
                    if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
                        return false;
                    if (!checkbox)
                        target.toggleClass('_checked', checked);
                    const items = $('.js-options-set-item', jqElement);
                    const checkedCount = items.filter(':checked, ._checked').length;
                    if (toggleCheckbox) {
                        target.prop('checked', checkedCount > 0);
                    }
                    else {
                        toggle
                            .toggleClass('_checked', checkedCount === items.length)
                            .toggleClass('_checked-half', checkedCount !== 0 && checkedCount < items.length);
                    }
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_selectedOptionsChanged).call(this, jqElement);
                    __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_checkActivityDateCommon).call(_a, target, checked);
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
                    return true;
                });
            });
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_initSvgLayer).call(this);
            __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPageMobile_popupGroup, "f"));
        });
    }, _CruiseBookPageMobile_initSvgLayer = function _CruiseBookPageMobile_initSvgLayer() {
        return __awaiter(this, void 0, void 0, function* () {
            $(this.root).on("cruiseSvgLoader:loaded" /* Events.CruiseSvgLoaderLoaded */, __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f"), () => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onSvgLayerLoaded).call(this));
            const params = {
                root: __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f"),
                width: 599,
                shipSchemaSvg: '',
                deck: 0,
                shipId: this.options.shipId,
                shipCode: this.options.shipCode,
                svgNS: 'http://www.w3.org/2000/svg',
            };
            const svgLoader = new App.CruiseSvgLoader();
            yield svgLoader.init(params, this.options.decks);
        });
    }, _CruiseBookPageMobile_initFlights = function _CruiseBookPageMobile_initFlights() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseBookPageMobile_hasDynamicFlights, "f") > 0) {
                __classPrivateFieldSet(this, _CruiseBookPageMobile_aviaResultComponent, new App.AviaResultComponent({
                    root: $('.js-flights-regular', this.root),
                    formRoot: __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f"),
                    data: __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").serializeArray(),
                    beginDate: App.parseIsoDate(__classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").checkinDate),
                    urls: this.options.urls.aviaUrls,
                }), "f");
                __classPrivateFieldGet(this, _CruiseBookPageMobile_aviaResultComponent, "f").getRoot()
                    .on("avia:searchCompleted" /* Events.AviaSearchCompleted */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_finishInitialization).call(this); }))
                    .on("avia:toggleBookButton" /* Events.AviaToggleBookButton */, (_, data) => __awaiter(this, void 0, void 0, function* () { return $('.js-form-book', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")).prop('disabled', data); }))
                    .on("avia:groupClick" /* Events.AviaGroupClick */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onAviaGroupClick).call(this, e, data); }))
                    .on("avia:flightChanged" /* Events.AviaFlightChanged */, () => __awaiter(this, void 0, void 0, function* () {
                    $('.js-form-flights', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")).show();
                    $('.js-form-book', this.root).prop('disabled', false);
                }));
                this.components.push(__classPrivateFieldGet(this, _CruiseBookPageMobile_aviaResultComponent, "f"));
            }
            else {
                yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_finishInitialization).call(this);
            }
            $('.js-flight-class input, .js-flight-direct input', this.root).on('change', () => __awaiter(this, void 0, void 0, function* () { yield __classPrivateFieldGet(this, _CruiseBookPageMobile_aviaResultComponent, "f").newSearch(__classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").serializeArray()); }));
        });
    }, _CruiseBookPageMobile_finishInitialization = function _CruiseBookPageMobile_finishInitialization() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onQuotesChange).call(this);
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_initInc).call(this);
        });
    }, _CruiseBookPageMobile_initInc = function _CruiseBookPageMobile_initInc() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"))
                return;
            const tourists = [];
            __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").tourists.forEach((value, i) => {
                tourists[i] = {};
                if (!this.options.isAgencyBelarus) {
                    // страховка "Отмена поездки" всегда с ценой
                    $('.js-service-insurance', $(`.js-person-tab-wrap[data-tab="person${i}"]`))
                        .find('.js-book-services-select')
                        .each((index, elem) => {
                        const groupId = $(elem).attr('data-groupkey') || '';
                        const option = $(elem).find('.js-basic-variant-input.js-ins-cancellation-min');
                        if (option.length > 0) {
                            tourists[i][groupId] = option.valString();
                            option.attr('checked', 'true');
                            const selectedVariant = option.closest('.js-basic-variant');
                            const container = option.closest('.js-basic-variants');
                            const variants = container.find('.js-basic-variant');
                            variants.removeClass('_active').slideDown();
                            selectedVariant.addClass('_active');
                            variants.not('._active').slideUp();
                        }
                    });
                }
                // сервисный сбор всегда включен
                const serviceFee = $('.js-service-fee', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")).find('.js-book-services-select');
                const serviceFeeGroupId = serviceFee.attr('data-groupkey') || '';
                const serviceFeeVal = serviceFee.find('.js-basic-variant-input').valString();
                if (serviceFeeGroupId.length > 0 && serviceFeeVal.length > 0) {
                    tourists[i][serviceFeeGroupId] = serviceFeeVal;
                }
            });
            if (tourists.length > 0) {
                yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getQuotes).call(this, tourists);
                __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
            }
        });
    }, _CruiseBookPageMobile_onAviaGroupClick = function _CruiseBookPageMobile_onAviaGroupClick(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const needDocument = data.needDocument;
            $('.js-person-document-number, .js-person-document-expirationdate', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).each((i, v) => {
                const block = $(v);
                $('.form-item', block).toggleClass('_required', needDocument);
                if (needDocument)
                    $('input', block).attr('required', 'required');
                else
                    $('input', block).removeAttr('required');
            });
            // const needIssueDate = needDocument && (this.#selectedFlight?.needIssueDate ?? false);
            const needIssueDate = needDocument && data.needIssueDate;
            $('.js-person-document-issuedate', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).each((i, v) => {
                const block = $(v);
                $('.form-item', block).toggleClass('_required', needIssueDate);
                if (needIssueDate)
                    $('input', block).attr('required', 'required');
                else
                    $('input', block).removeAttr('required');
            });
            const needMiddleName = data.needMiddleName;
            App.AviaResultComponent.initMiddleName(this.root, needMiddleName);
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onQuotesChange).call(this);
        });
    }, _CruiseBookPageMobile_getBookContentDigestServices = function _CruiseBookPageMobile_getBookContentDigestServices() {
        if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f") || __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").tourists.length === 0)
            return new Array();
        const services = {};
        // услуги: отель, круиз, сборы, страховка, виза
        __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").tourists.forEach(tourist => {
            tourist.appliedServices.forEach(value => {
                let index = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceOrder).call(_a, value.type);
                let service = null;
                let cruise = null;
                let hotel = null;
                if (value.type === 'cruise') {
                    cruise = {
                        shipName: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").ship.name,
                        cabinCategory: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").cabin.code,
                        cabinName: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").cabin.name,
                        cabinExperience: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").cabin.experience,
                        occupancy: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").occupancy,
                        pansion: localizer.meal,
                        beginDate: App.CruisePageMobileBase.addDays(__classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").checkinDate, value.beginDay - 1),
                        duration: value.duration,
                        fare: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").fare,
                        isLuxeMode: this.options.isLuxeMode,
                        existRusGroup: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").existRusGroup,
                    };
                    index = value.beginDay;
                }
                else if (value.type === 'hotel') {
                    hotel = value.options[0].details.hotelDetail.hotelInfo;
                    index = value.beginDay;
                }
                else {
                    service = {
                        name: value.options[0].title,
                        duration: value.duration,
                        count: 1,
                        key: value.options[0].optionKey,
                    };
                }
                if (service == null && cruise == null && hotel == null)
                    return;
                if (!services[index]) {
                    services[index] = {
                        key: value.type,
                        type: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, value.type),
                        sortOrder: index,
                        groupIds: [value.groupKey],
                        daysBeforeFlight: 0,
                        packetFlights: [],
                        flights: null,
                        hotel,
                        cruise,
                        transfers: [],
                        services: service == null ? [] : [service],
                    };
                    return;
                }
                if (service) {
                    if (index === 0)
                        return;
                    const indexServiceCount = services[index].services.findIndex(v => v.key == value.options[0].optionKey);
                    if (!services[index].groupIds.includes(value.groupKey)) {
                        services[index].groupIds.push(value.groupKey);
                        services[index].services.push(service);
                    }
                    else {
                        if (indexServiceCount != -1)
                            services[index].services[indexServiceCount].count = services[index].services[indexServiceCount].count + 1;
                        else
                            services[index].services.push(service);
                    }
                }
            });
        });
        const beginDate = App.parseIsoDate(__classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").checkinDate);
        let aviaIndex = 0;
        // услуги: авиа, трансфер, экскурсия
        if (__classPrivateFieldGet(this, _CruiseBookPageMobile_cruisePartsData, "f").length > 0) {
            __classPrivateFieldGet(this, _CruiseBookPageMobile_cruisePartsData, "f").forEach(value => {
                const typeKey = value.serviceTypeKey;
                const type = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_geServiceTypeString).call(_a, typeKey);
                const index = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceOrder).call(_a, type);
                let service = null;
                let packetFlights = new Array();
                let transfer = null;
                if (type === 'avia') {
                    packetFlights = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getFlightService).call(this, value, aviaIndex);
                    ++aviaIndex;
                }
                else if (type === 'transfer') {
                    const transferPart = value;
                    transfer = {
                        beginDate: transferPart.beginDate,
                        byProgram: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_isNullOrEmpty).call(_a, transferPart.pickupPlace)
                            && __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_isNullOrEmpty).call(_a, transferPart.dropoffPlace),
                        transferDropoffPlace: transferPart.dropoffPlace,
                        transferPickupPlace: transferPart.pickupPlace,
                    };
                }
                else if (type === 'excursion') {
                    service = {
                        name: value.description,
                        duration: App.dateDiff(new App.XDate(App.parseIsoDate(value.beginDate)).trimTime(), new App.XDate(App.parseIsoDate(value.endDate)).trimTime()).getDays(),
                        count: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").occupancy.adults + __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").occupancy.children.length,
                    };
                }
                if (packetFlights.length === 0 && transfer == null && service == null)
                    return;
                if (!services[index]) {
                    services[index] = {
                        key: type,
                        type: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, type),
                        sortOrder: index,
                        groupIds: [0],
                        daysBeforeFlight: 0,
                        packetFlights: [],
                        flights: null,
                        hotel: null,
                        cruise: null,
                        transfers: [],
                        services: [],
                    };
                }
                if (service)
                    services[index].services.push(service);
                if (transfer)
                    services[index].transfers.push(transfer);
                if (packetFlights.length > 0) {
                    services[index].packetFlights = services[index].packetFlights.concat(packetFlights);
                    services[index].daysBeforeFlight = -Math.min(0, packetFlights != null && packetFlights.length > 0
                        ? App.dateDiff(new App.XDate(App.parseIsoDate(packetFlights[0].beginDate)).trimTime(), beginDate).getDays()
                        : 0);
                }
            });
        }
        // услуги: ДП
        const flightResults = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getFlightResults).call(this);
        if (flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) {
            const indexDynamicAvia = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceOrder).call(_a, 'dynamicAvia');
            const flightDate = App.parseIsoDate(flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight.variants[0].legs[0].date);
            services[indexDynamicAvia] = {
                key: 'dynamicAvia',
                type: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, 'dynamicAvia'),
                sortOrder: indexDynamicAvia,
                groupIds: [0],
                daysBeforeFlight: -Math.min(0, App.dateDiff(new App.XDate(flightDate).trimTime(), beginDate).getDays()),
                packetFlights: [],
                flights: __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getFlightService).call(this),
                hotel: null,
                cruise: null,
                transfers: [],
                services: [],
            };
        }
        // услуги: экскурсии
        if (__classPrivateFieldGet(this, _CruiseBookPageMobile_checkActivities, "f") && __classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalPrice, "f") > 0) {
            const indexActivity = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceOrder).call(_a, 'excursion');
            services[indexActivity] = {
                key: 'excursion',
                type: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, 'excursion'),
                sortOrder: indexActivity,
                groupIds: [0],
                daysBeforeFlight: 0,
                packetFlights: [],
                flights: null,
                hotel: null,
                cruise: null,
                transfers: [],
                services: [],
            };
            __classPrivateFieldGet(this, _CruiseBookPageMobile_activitiesData, "f").forEach(el => {
                services[indexActivity].services.push({
                    name: this.options.activities[el.packetKey].list[el.key].title,
                    count: el.count,
                });
            });
        }
        return Object.values(services);
    }, _CruiseBookPageMobile_getBookPriceDigestServices = function _CruiseBookPageMobile_getBookPriceDigestServices() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c, _d, _e;
            const servicePricesMap = new Map();
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"))
                return [];
            __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").tourists.forEach(tourist => {
                tourist.appliedServices.forEach(value => {
                    let subType;
                    if (value.type === 'insurance')
                        subType = value.options[0].details.insuranceType;
                    if (value.type === 'tax.hsc')
                        subType = 'hsc';
                    let sortOrder = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceOrder).call(_a, value.type, subType);
                    if (value.type === 'cruise' || value.type === 'hotel') {
                        sortOrder = value.beginDay;
                    }
                    const key = value.type + (subType === 'cancellation' ? '-' : '');
                    const price = value.options[0].netPrice || value.options[0].grossCost;
                    const grossPrice = value.options[0].grossCost;
                    const priceByPerson = value.options[0].costByPerson;
                    const discount = grossPrice - price;
                    const service = servicePricesMap.get(value.groupKey);
                    if (service === undefined) {
                        servicePricesMap.set(value.groupKey, {
                            type: value.type,
                            nameDetails: '',
                            isBonus: false,
                            discount,
                            grossPrice,
                            name: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, value.type, subType, 'digest'),
                            price,
                            currency: __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f") ? __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency : '',
                            needCount: priceByPerson,
                            sortOrder: sortOrder,
                            key,
                        });
                    }
                    else {
                        if (service.needCount) {
                            service.price += price;
                            service.grossPrice += grossPrice;
                            service.discount += discount;
                        }
                    }
                });
            });
            const servicePrices = new Array();
            for (const value of servicePricesMap.values()) {
                const service = servicePrices.find(v => v.key == value.key);
                if (service === undefined) {
                    servicePrices.push(value);
                }
                else {
                    service.price += value.price;
                    service.grossPrice += value.grossPrice;
                    service.discount += value.discount;
                }
            }
            const flightResults = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getFlightResults).call(this);
            if (flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) {
                const flightGrossPrice = (_b = yield App.CurrencyManager.exchange(flightResults.selectedFlight.grossPrice, flightResults.selectedFlight.currency, __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency)) !== null && _b !== void 0 ? _b : 0;
                const flightPrice = (_c = yield App.CurrencyManager.exchange(flightResults.selectedFlight.price, flightResults.selectedFlight.currency, __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency)) !== null && _c !== void 0 ? _c : flightGrossPrice;
                servicePrices.push({
                    type: 'dynamicAvia',
                    name: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, 'dynamicAvia'),
                    price: flightPrice,
                    currency: __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency,
                    needCount: false,
                    sortOrder: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceOrder).call(_a, 'dynamicAvia'),
                    discount: flightGrossPrice - flightPrice,
                    grossPrice: flightGrossPrice,
                    isBonus: false,
                    nameDetails: '',
                });
            }
            if (__classPrivateFieldGet(this, _CruiseBookPageMobile_checkActivities, "f") && __classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalPrice, "f") > 0) {
                const activityGrossPrice = (_d = yield App.CurrencyManager.exchange(__classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalPrice, "f"), this.options.activities[0].currency, __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency)) !== null && _d !== void 0 ? _d : 0;
                const activityPrice = (_e = yield App.CurrencyManager.exchange(__classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalPrice, "f") - __classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalCommision, "f"), this.options.activities[0].currency, __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency)) !== null && _e !== void 0 ? _e : 0;
                servicePrices.push({
                    type: 'excursion',
                    name: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, 'excursion'),
                    price: activityPrice,
                    currency: __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency,
                    needCount: false,
                    sortOrder: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceOrder).call(_a, 'excursion'),
                    discount: __classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalCommision, "f"),
                    grossPrice: activityGrossPrice,
                    isBonus: false,
                    nameDetails: '',
                });
            }
            return servicePrices;
        });
    }, _CruiseBookPageMobile_isNullOrEmpty = function _CruiseBookPageMobile_isNullOrEmpty(value) {
        if (!value)
            return true;
        if (value.trim().length === 0)
            return true;
        return false;
    }, _CruiseBookPageMobile_geServiceTypeString = function _CruiseBookPageMobile_geServiceTypeString(typeKey) {
        switch (typeKey) {
            case 1:
                return 'hotel';
            case 2:
                return 'excursion';
            case 4:
                return 'transfer';
            case 5:
                return 'avia';
            default:
                return 'cruise';
        }
    }, _CruiseBookPageMobile_getInsuranceTypeName = function _CruiseBookPageMobile_getInsuranceTypeName(type) {
        switch (type) {
            case 'medical':
                return localizer.insuranceMedical;
            case 'accident':
                return localizer.insuranceAccident;
            case 'cancellation':
                return localizer.insuranceCancellation;
            case 'medical.ost':
                return localizer.insuranceMedicalOst;
            case 'savemoney':
                return localizer.insuranceSaveMoney;
            default:
                return '';
        }
    }, _CruiseBookPageMobile_getServiceTypeName = function _CruiseBookPageMobile_getServiceTypeName(type, subType, position) {
        switch (type) {
            case 'insurance':
                {
                    switch (subType) {
                        case 'cancellation':
                            return localizer.insuranceCancellation;
                        default:
                            return localizer.insurance;
                    }
                }
            case 'visa':
                return localizer.visa;
            case 'tax':
                {
                    switch (position) {
                        case 'digest':
                            return localizer.portTaxes;
                        default:
                            return localizer.tax;
                    }
                }
            case 'tax.hsc':
                {
                    switch (position) {
                        case 'digest':
                            return localizer.serviceCharge;
                        default:
                            return localizer.tax;
                    }
                }
            case 'avia':
            case 'flight':
            case 'dynamicAvia':
            case 5:
                return localizer.avia;
            case 'transfer':
            case 4:
                return localizer.transfer;
            case 'excursion':
            case 2:
                return localizer.excursion;
            case 'cruise':
            case 8:
                return localizer.cruise;
            case 'hotel':
            case 1:
                return localizer.hotel;
            default:
                return '';
        }
    }, _CruiseBookPageMobile_getServiceOrder = function _CruiseBookPageMobile_getServiceOrder(type, subType) {
        switch (type) {
            case 'insurance':
                {
                    switch (subType) {
                        case 'cancellation':
                            return App.CruiseServiceOrder.InsuranceCancellation;
                        default:
                            return App.CruiseServiceOrder.Insurance;
                    }
                }
            case 'visa':
                return App.CruiseServiceOrder.Visa;
            case 'tax':
                return App.CruiseServiceOrder.PortTax;
            case 'tax.hsc':
                {
                    switch (subType) {
                        case 'hsc':
                            return App.CruiseServiceOrder.ServiceTax;
                        default:
                            return App.CruiseServiceOrder.PortTax;
                    }
                }
            case 'avia':
            case 'flight':
            case 5:
                return App.CruiseServiceOrder.Avia;
            case 'transfer':
            case 4:
                return App.CruiseServiceOrder.Transfer;
            case 'excursion':
            case 2:
                return App.CruiseServiceOrder.Excursion;
            case 'cruise':
            case 8:
                return App.CruiseServiceOrder.Cruise;
            case 'dynamicAvia':
                return App.CruiseServiceOrder.DynamicAvia;
            case 'hotel':
            case 1:
                return App.CruiseServiceOrder.Hotel;
            default:
                return 100;
        }
    }, _CruiseBookPageMobile_getAvailableServicesByType = function _CruiseBookPageMobile_getAvailableServicesByType(data, type, checkSelected = false) {
        if (!data || data.tourists.length === 0)
            return [];
        const result = [];
        data.availableServices.forEach(service => {
            if (service.type === type) {
                service.typeRus = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getServiceTypeName).call(_a, service.type);
                if (type === 'insurance')
                    service.subTypeRus = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getInsuranceTypeName).call(_a, service.options[0].details.insuranceType);
                if (checkSelected) {
                    const tservice = data.tourists[0].appliedServices.find(val => val.groupKey === service.groupKey);
                    if (tservice) {
                        service.options.forEach(val => {
                            val.details.selected = false;
                            if (val.optionKey === tservice.options[0].optionKey)
                                val.details.selected = true;
                        });
                    }
                }
                result.push(service);
            }
        });
        return result;
    }, _CruiseBookPageMobile_generateFlightTags = function _CruiseBookPageMobile_generateFlightTags(item) {
        const result = new Array();
        const nextDayArrival = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_nextDayArrival).call(_a, item.beginDate, item.endDate);
        if (nextDayArrival)
            result.push(['day-before', 'Вылет накануне']);
        return result;
    }, _CruiseBookPageMobile_nextDayArrival = function _CruiseBookPageMobile_nextDayArrival(beginDate, endDate) {
        return App.parseIsoDate(beginDate).getDate() !== App.parseIsoDate(endDate).getDate();
    }, _CruiseBookPageMobile_getFlightService = function _CruiseBookPageMobile_getFlightService(charterFlight, index) {
        const result = new Array();
        if (charterFlight) {
            result.push({
                beginDate: charterFlight.beginDate,
                endDate: charterFlight.endDate,
                nextDayArrival: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_nextDayArrival).call(_a, charterFlight.beginDate, charterFlight.endDate),
                flight: {
                    departureCityKey: 0,
                    departureCityName: charterFlight.departureCity ? charterFlight.departureCity.name : '',
                    departureAirportCode: charterFlight.portFrom,
                    departureTerminal: '',
                    arrivalCityKey: 0,
                    arrivalCityName: charterFlight.arrivalCity ? charterFlight.arrivalCity.name : '',
                    arrivalAirportCode: charterFlight.portTo,
                    arrivalTerminal: '',
                    airlineCode: charterFlight.airline ? charterFlight.airline.code : '',
                    flightNumber: charterFlight.flightNumber.toString(),
                },
                serviceClassCode: '',
                serviceClassName: '',
                hasMoreVariants: false,
                tags: index == 0 ? __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_generateFlightTags).call(_a, charterFlight) : undefined,
                transferCount: 0,
            });
        }
        else {
            const flightResults = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getFlightResults).call(this);
            if ((flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) == null)
                return result;
            const selectedFlight = flightResults.selectedFlight;
            return selectedFlight.variants[0].legs
                .map((v, i) => ({
                beginDate: v.date,
                endDate: v.endDate,
                nextDayArrival: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_nextDayArrival).call(_a, v.date, v.endDate),
                flight: {
                    departureCityKey: v.segments[0].cityKey,
                    departureCityName: v.segments[0].cityName,
                    departureAirportCode: v.segments[0].airportCode,
                    departureTerminal: '',
                    arrivalCityKey: v.segments[v.segments.length - 1].endCityKey,
                    arrivalCityName: v.segments[v.segments.length - 1].endCityName,
                    arrivalAirportCode: v.segments[v.segments.length - 1].endAirportCode,
                    arrivalTerminal: '',
                    airlineCode: v.segments[0].airlineCode,
                    flightNumber: v.segments[0].flightNumber,
                },
                serviceClassCode: v.segments[0].serviceClass,
                serviceClassName: v.segments[0].serviceClass,
                hasMoreVariants: selectedFlight.hasMoreVariants,
                tags: i <= 0 ? selectedFlight.tags : undefined,
                transferCount: v.segments.length - 1,
                wayTime: v.wayTime,
            }));
        }
        return result;
    }, _CruiseBookPageMobile_getFlightResults = function _CruiseBookPageMobile_getFlightResults() {
        var _b;
        return (_b = __classPrivateFieldGet(this, _CruiseBookPageMobile_aviaResultComponent, "f")) === null || _b === void 0 ? void 0 : _b.getResults();
    }, _CruiseBookPageMobile_getCruiseParts = function _CruiseBookPageMobile_getCruiseParts() {
        const cruiseParts = {};
        __classPrivateFieldGet(this, _CruiseBookPageMobile_cruisePartsData, "f").forEach(v => {
            // TODO: костыль.
            const type = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_geServiceTypeString).call(_a, v.serviceTypeKey);
            if (cruiseParts[type] == null)
                cruiseParts[type] = [];
            cruiseParts[type].push(v);
        });
        return cruiseParts;
    }, _CruiseBookPageMobile_getHotelsInfo = function _CruiseBookPageMobile_getHotelsInfo(services) {
        const result = [];
        // TODO группировать по категории
        services.forEach(service => {
            const hotels = [];
            service.options.forEach(option => {
                if (!option.details.hotelDetail)
                    return;
                const key = option.details.hotelDetail.hotelInfo.masterKey;
                const roomKey = option.details.hotelDetail.hotelInfo.roomMasterKey;
                const pansionKey = option.details.hotelDetail.hotelInfo.pansionMasterKey;
                const { selected } = option.details;
                const { hotelInfo } = option.details.hotelDetail;
                const board = {
                    key: pansionKey,
                    value: hotelInfo.hotel.pansion,
                    selected,
                };
                const room = {
                    key: roomKey,
                    value: `${hotelInfo.hotel.roomAccommodation}, ${hotelInfo.hotel.roomType} ${hotelInfo.hotel.roomCategory}`,
                    selected,
                    boards: [board],
                };
                const currentHotel = hotels.find(value => value.key === key);
                // есть такой элемент => добавляем размещение
                if (currentHotel) {
                    const currentRoom = currentHotel.rooms.find(value => value.key === roomKey);
                    // есть такой элемент => добавляем питание
                    if (currentRoom)
                        currentRoom.boards.push(board);
                    else
                        currentHotel.rooms.push(room);
                }
                else {
                    hotels.push({
                        key: hotelInfo.masterKey,
                        value: hotelInfo.hotel.name,
                        rooms: [room],
                        city: hotelInfo.hotel.address,
                        category: hotelInfo.hotel.category,
                    });
                }
            });
            hotels.forEach(hotel => {
                hotel.rooms.forEach(room => {
                    room.boards = App.CruisePageBase.uniqArray(room.boards, ['key']);
                });
            });
            App.CruisePageBase.sortArray(hotels, 'category');
            result[service.beginDay] = hotels;
        });
        return result;
    }, _CruiseBookPageMobile_getHotelServices = function _CruiseBookPageMobile_getHotelServices(services, selectedDefault = false) {
        services.forEach(value => {
            const selected = value.options.find(option => option.details.selected);
            if (selected) {
                value.options = [selected];
            }
            else {
                const first = value.options.shift() || {};
                value.options = [first];
            }
            const hServ = __classPrivateFieldGet(this, _CruiseBookPageMobile_hotelsInfo, "f")[value.beginDay] || null;
            if (hServ) {
                value.allowEdit = hServ.length > 1;
                let hotel;
                if (value.options[0].details.hotelDetail)
                    hotel = hServ.find(service => service.key === value.options[0].details.hotelDetail.hotelInfo.masterKey);
                if (hotel) {
                    value.options[0].details.hotelDetail.rooms = new App.SelectListModel({
                        name: 'rooms',
                        form: true,
                        autocomplete: false,
                        items: hotel.rooms
                            .map((room, index) => ({
                            value: room.key.toString(),
                            text: room.value,
                            selected: selectedDefault ? index === 0 : room.selected,
                        })),
                    });
                    value.options[0].details.hotelDetail.boards = new App.SelectListModel({
                        name: 'boards',
                        form: true,
                        autocomplete: false,
                        items: hotel.rooms[0].boards.map((board, index) => ({
                            value: board.key.toString(),
                            text: board.value,
                            selected: selectedDefault ? index === 0 : board.selected,
                        })),
                    });
                    value.allowEditPlacement = hotel.rooms.length > 1 || hotel.rooms[0].boards.length > 1;
                }
            }
        });
        return services;
    }, _CruiseBookPageMobile_changeHotelServicesSelected = function _CruiseBookPageMobile_changeHotelServicesSelected(services, hotelKey, index) {
        services.forEach(service => {
            service.options.forEach(option => {
                option.details.selected = false;
            });
        });
        const needService = services.find(value => value.beginDay === index);
        if (!needService)
            return services;
        needService.options.forEach(option => {
            if (option.details.hotelDetail != null && option.details.hotelDetail.hotelInfo.masterKey === hotelKey)
                option.details.selected = true;
        });
        return services;
    }, _CruiseBookPageMobile_prepareDataForGetQuotes = function _CruiseBookPageMobile_prepareDataForGetQuotes(tourists = []) {
        const data = App.CruisePageMobileBase.convertArrayToRequestData(this.options.searchData);
        data.CruiseKey = __classPrivateFieldGet(this, _CruiseBookPageMobile_cruiseId, "f").toString();
        data.FareCode = __classPrivateFieldGet(this, _CruiseBookPageMobile_fareCode, "f");
        data.CategoryKey = __classPrivateFieldGet(this, _CruiseBookPageMobile_cabinCategoryKey, "f").toString();
        if (tourists.length === 0)
            return data;
        const birthdayInputs = $('.form-item', $('.js-form-order')).not('._invalid').find('.js-form-date.js-person-birthday');
        // serializeArray не работает с полями disabled
        // TODO: разобаться, зачем вот это, не нашла когда даты disabled
        const disabled = $('.js-form-order').find('.js-form-date:disabled').removeAttr('disabled');
        const birthdays = birthdayInputs.serializeArray();
        disabled.attr('disabled', 'disabled');
        // TODO: разобаться, зачем вот это
        for (let touristIndex = 0; touristIndex < tourists.length; touristIndex++) {
            const tourist = tourists[touristIndex];
            const services = Object.entries(tourist);
            for (let serviceIndex = 0; serviceIndex < services.length; serviceIndex++) {
                const [groupKey, groupValue] = services[serviceIndex];
                data[`ServicesGroup[${touristIndex}].Services[${serviceIndex}].GroupKey`] = groupKey;
                data[`ServicesGroup[${touristIndex}].Services[${serviceIndex}].OptionKey`] = groupValue;
            }
            // services[0].Tourist.Birthday  services[1].Tourist.Birthday
            const birthday = birthdays.find(v => v.name === `services[${touristIndex}].Tourist.Birthday`);
            if (birthday && birthday.value.length > 0)
                data[`ServicesGroup[${touristIndex}].Birthday`] = birthday.value;
        }
        return data;
    }, _CruiseBookPageMobile_prepareDataForBook = function _CruiseBookPageMobile_prepareDataForBook() {
        const elements = $('.js-form-order', $('.js-cruise-book')).serializeArray();
        const elementsMobile = __classPrivateFieldGet(this, _CruiseBookPageMobile_bookFilter, "f").serializeArray();
        const idx = new Map();
        elements.forEach((e, i) => idx.set(e.name, i));
        for (const m of elementsMobile) {
            const i = idx.get(m.name);
            if (i == null) {
                idx.set(m.name, elements.length);
                elements.push({ name: m.name, value: m.value });
            }
            else {
                elements[i].value = m.value;
            }
        }
        let data = elements.concat(this.options.searchData);
        if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"))
            return data;
        __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").tourists.forEach((tourist, index) => {
            tourist.appliedServices.forEach(service => {
                data.push({ name: `services[${index}].services[]`, value: `${service.groupKey}_${service.options[0].optionKey}` });
            });
        });
        if (this.context)
            data.push({ name: 'context', value: this.context });
        // data = $.grep(data, v => v.value != null && v.value !== '');
        data = data.filter(v => v.value != null && v.value !== '');
        return data;
    }, _CruiseBookPageMobile_initPlacement = function _CruiseBookPageMobile_initPlacement(services) {
        __classPrivateFieldSet(this, _CruiseBookPageMobile_hotelsInfo, __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getHotelsInfo).call(_a, services), "f");
        const hotelServices = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getHotelServices).call(this, services);
        const block = $(App.templates.Cruise.Book.ServiceHotelBlockMain({
            hotelServices,
            cruiseParts: __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getCruiseParts).call(this),
            hotelsList: __classPrivateFieldGet(this, _CruiseBookPageMobile_hotelsInfo, "f"),
        }));
        $('.js-cruise-services-block-main-step1', $(__classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrapClass, "f"))).append(block);
        $('.js-filter-select-block', $('.js-cruise-services-block-main-step1')).each((i, v) => {
            __classPrivateFieldGet(this, _CruiseBookPageMobile_controls, "f").push(new App.FilterSelectBlock({ root: $(v) }));
        });
        __classPrivateFieldSet(this, _CruiseBookPageMobile_orderPlacement, $('.js-order-placement', this.root), "f");
        __classPrivateFieldSet(this, _CruiseBookPageMobile_placementHotels, $('.js-order-placement-hotels', __classPrivateFieldGet(this, _CruiseBookPageMobile_orderPlacement, "f")), "f");
        // Выбираем новый отель вместо старого.
        __classPrivateFieldGet(this, _CruiseBookPageMobile_placementHotels, "f").on('click', '.js-order-placement-hotels-btn', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onHotelChange).call(this, e); }));
        // Изменить тип номера.
        __classPrivateFieldGet(this, _CruiseBookPageMobile_orderPlacement, "f").on('change', '.js-placement-hotel-room .js-jelect', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onHotelRoomChange).call(this, e); }));
        // Изменить тип питания.
        __classPrivateFieldGet(this, _CruiseBookPageMobile_orderPlacement, "f").on('change', '.js-placement-hotel-food .js-jelect', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onHotelBoardChange).call(this, e); }));
        // Выбор другого отеля
        __classPrivateFieldGet(this, _CruiseBookPageMobile_orderPlacement, "f").on('click', '.js-order-placement-hotel-edit', e => __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_onHotelEditClick).call(_a, e));
    }, _CruiseBookPageMobile_checkActivityDateCommon = function _CruiseBookPageMobile_checkActivityDateCommon(container, checked) {
        // чекбоксы у туристов
        const items = container.parents('.js-options-set').find('.js-options-set-item');
        const itemsActive = items.not(':disabled');
        itemsActive.each((index, el) => {
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_checkActivityDate).call(_a, $(el), checked);
        });
        // общие чекбоксы
        const parent = container.parents('.js-cruise-activity-packet');
        const date = container.parents('.js-options-set').attr('data-date');
        const els = $(`.js-options-set[data-date="${date}"]`, parent)
            .find('.js-options-set-toggle')
            .not(container);
        if (checked) {
            if (itemsActive.length === items.length) {
                els.attr('disabled', 'disabled');
                els.parents('.js-options-set').addClass('_disabled');
            }
        }
        else {
            els.removeAttr('disabled');
            els.parents('.js-options-set').removeClass('_disabled');
        }
    }, _CruiseBookPageMobile_checkActivityDate = function _CruiseBookPageMobile_checkActivityDate(container, checked) {
        // чекбоксы у туристов
        const parent = container.parents('.js-cruise-activity-packet');
        const person = container.parents('.js-person-options-initials').attr('data-target');
        const date = container.parents('.js-options-set').attr('data-date');
        const els = $(`.js-options-set[data-date="${date}"]`, parent)
            .find(`.js-person-options-initials[data-target="${person}"]`)
            .find('.js-order-options-input')
            .not(container);
        if (checked) {
            els.attr('disabled', 'disabled');
            els.parents('.js-options-set').addClass('_disabled');
        }
        else {
            els.removeAttr('disabled');
            els.parents('.js-options-set').removeClass('_disabled');
        }
        // общие чекбоксы
        const currentCommonCheckbox = container.parents('.js-options-set').find('.js-options-set-toggle');
        const commonCheckboxes = $(`.js-options-set[data-date="${date}"]`, parent)
            .find('.js-options-set-toggle')
            .not(currentCommonCheckbox);
        commonCheckboxes.each((index, el) => {
            const items = $(el).parents('.js-options-set').find('.js-options-set-item');
            const itemsActive = items.not(':disabled');
            if (checked) {
                if (itemsActive.length === items.length || itemsActive.length === 0)
                    commonCheckboxes.attr('disabled', 'disabled');
            }
            else {
                commonCheckboxes.removeAttr('disabled');
            }
        });
    }, _CruiseBookPageMobile_selectedOptionsChanged = function _CruiseBookPageMobile_selectedOptionsChanged(container) {
        var _b, _c;
        const adults = $('.js-options-set-adult .js-order-options-input', container).filter(':checked, ._checked').not(':disabled');
        const adultCount = adults.length;
        const adultServiceKey = (_b = adults.eq(0).attr('data-key')) !== null && _b !== void 0 ? _b : '';
        const adultPriceData = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getActivityTotalPrice).call(this, Number(adultServiceKey), adultCount);
        const adultPrice = adultPriceData[0];
        const adultCommision = adultPriceData[1];
        const childs = $('.js-options-set-child .js-order-options-input', container).filter(':checked, ._checked').not(':disabled');
        const childCount = childs.length;
        const childServiceKey = (_c = childs.eq(0).attr('data-key')) !== null && _c !== void 0 ? _c : '';
        const childPriceData = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getActivityTotalPrice).call(this, Number(childServiceKey), childCount);
        const childPrice = childPriceData[0];
        const childCommision = childPriceData[1];
        __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_saveActivityChangedData).call(this, container, adults.length + childs.length);
        const totalPrice = adultPrice + childPrice;
        const totalCommision = adultCommision + childCommision;
        const elTotal = container.find('.js-options-set-total');
        elTotal.attr('data-price', totalPrice);
        elTotal.attr('data-commision', totalCommision);
        elTotal.toggleClass('_zero', totalPrice === 0);
        elTotal.find(App.Money.tagName).get(0).amount = totalPrice;
        let priceTotal = 0;
        let commisionTotal = 0;
        $('.js-options-set', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).find('.js-options-set-total').each((index, el) => {
            const price = $(el).attr('data-price');
            const commision = $(el).attr('data-commision');
            if (price) {
                priceTotal += Number(price);
                commisionTotal += Number(commision);
            }
        });
        priceTotal = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_applyActivityPacketDiscount).call(this, priceTotal);
        __classPrivateFieldSet(this, _CruiseBookPageMobile_activityTotalPrice, priceTotal, "f");
        __classPrivateFieldSet(this, _CruiseBookPageMobile_activityTotalCommision, commisionTotal, "f");
        $('.js-order-options-total', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).get(0).amount = priceTotal;
    }, _CruiseBookPageMobile_saveActivityChangedData = function _CruiseBookPageMobile_saveActivityChangedData(container, count) {
        const packetKey = Number(container.attr('data-packet-key'));
        const activityKey = Number(container.attr('data-key'));
        const index = __classPrivateFieldGet(this, _CruiseBookPageMobile_activitiesData, "f").findIndex(val => val.packetKey === packetKey && val.key === activityKey);
        if (count === 0) {
            if (index > -1)
                __classPrivateFieldGet(this, _CruiseBookPageMobile_activitiesData, "f").splice(index, 1);
            return;
        }
        const data = {
            packetKey,
            key: activityKey,
            count,
        };
        if (index > -1)
            __classPrivateFieldGet(this, _CruiseBookPageMobile_activitiesData, "f")[index] = data;
        else
            __classPrivateFieldGet(this, _CruiseBookPageMobile_activitiesData, "f").push(data);
    }, _CruiseBookPageMobile_applyActivityPacketDiscount = function _CruiseBookPageMobile_applyActivityPacketDiscount(totalPrice) {
        /* уточнить у Жени по поводу скидки на пакеты, где невозможно выбрать все экскурсии */
        const adultCount = this.options.offer.adults;
        const childCount = this.options.offer.children.length;
        const discountBlock = $('.js-block-discount', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f"));
        discountBlock.hide();
        let discount = 0;
        $('.js-cruise-activity-packet', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).each((index, el) => {
            const discountAd = Number($(el).attr('data-discount-adult'));
            const discountCh = Number($(el).attr('data-discount-child'));
            const countExcur = $(el).find('.js-options-set').length;
            for (let i = 0; i < adultCount; ++i) {
                const elements = $(`.js-person-options-initials[data-target=person${i}]`).find(':checked');
                if (elements.length >= countExcur)
                    discount += discountAd;
            }
            for (let j = adultCount; j < adultCount + childCount; ++j) {
                const elements = $(`.js-person-options-initials[data-target=person${j}]`).find(':checked');
                if (elements.length >= countExcur)
                    discount += discountCh;
            }
        });
        if (discount > 0) {
            $('.js-block-discount-total', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).get(0).amount = discount;
            discountBlock.show();
        }
        return totalPrice - discount;
    }, _CruiseBookPageMobile_getActivityTotalPrice = function _CruiseBookPageMobile_getActivityTotalPrice(key, personCount) {
        let price = 0;
        let commission = 0;
        let isGroup = false;
        this.options.activities.every(a => a.list.every(l => {
            const op = l.options.find(o => o.id === key);
            if (op) {
                price = op.price;
                commission = op.commission;
                isGroup = l.isGroup == '1';
                return false;
            }
            return true;
        }));
        return [!isGroup ? price : price * personCount, !isGroup ? commission : commission * personCount];
    }, _CruiseBookPageMobile_getDigestData = function _CruiseBookPageMobile_getDigestData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"))
                return null;
            const services = yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getBookPriceDigestServices).call(this);
            let grossPrice = __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.charges.totalGrossPriceAmount;
            let netPrice = 0;
            let discount = 0;
            services.forEach(v => {
                netPrice += v.price;
                discount += v.discount;
            });
            const flightResults = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getFlightResults).call(this);
            if (flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) {
                const avia = services.find(v => v.type === 'dynamicAvia');
                if (avia)
                    grossPrice += avia.grossPrice;
            }
            if (__classPrivateFieldGet(this, _CruiseBookPageMobile_checkActivities, "f") && __classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalPrice, "f") > 0) {
                grossPrice += __classPrivateFieldGet(this, _CruiseBookPageMobile_activityTotalPrice, "f");
            }
            return {
                servicePrices: Enumerable.from(services)
                    .where(v => v.price !== 0)
                    .orderBy(v => v.sortOrder)
                    .select(v => ({
                    name: v.name,
                    isBonus: false,
                    nameDetails: '',
                    grossPrice: v.grossPrice,
                    discount: v.discount,
                    price: v.price,
                    currencyCode: v.currency,
                }))
                    .toArray(),
                grossPrice,
                discount,
                price: netPrice,
                currencyCode: __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").priceInfo.currency,
                hasDetails: true,
                pricePresenter: {
                    type: this.pricePresenter.type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                notes: [],
                isLuxeMode: this.options.isLuxeMode,
                cruiseUrl: this.options.cruiseUrl,
                cruiseTitle: this.options.cruiseTitle,
                hasAction: this.options.hasAction,
                checkinDate: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").checkinDate,
                checkoutDate: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").checkoutDate,
                adultCount: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").occupancy.adults,
                childCount: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").occupancy.children.length,
                nightsTotal: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").nightsTotal,
                services: Enumerable.from(__classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getBookContentDigestServices).call(this))
                    .orderBy(v => v.sortOrder)
                    .toArray(),
                cancellationPolicy: __classPrivateFieldGet(this, _CruiseBookPageMobile_currentCabin, "f").cancellationPolicy,
            };
        });
    }, _CruiseBookPageMobile_updateDigest = function _CruiseBookPageMobile_updateDigest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseBookPageMobile_formOrder, $('form', this.root), "f");
            __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onBookingButtonClick).call(this, e); }));
            __classPrivateFieldSet(this, _CruiseBookPageMobile_bookDigest, new App.DigestMobile({
                buttonTitle: 'Забронировать',
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onBookSend).call(this),
                allowBooking: true, // allowBooking,
            }), "f");
            __classPrivateFieldGet(this, _CruiseBookPageMobile_bookDigest, "f").empty();
            const digestContent = $(App.templates.Cruise.Book.BookDigestContent_Mobile(data));
            const digestFloater = $(App.templates.Cruise.Book.BookDigest_Floater_Mobile(data));
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_bookDigest, "f").setContent(digestContent);
            __classPrivateFieldGet(this, _CruiseBookPageMobile_bookDigest, "f").setFloater(digestFloater);
            App.ExistingPassengersMobile.Creates();
            App.FindTouristMobile.Creates();
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _CruiseBookPageMobile_agentBlackListComponent, new App.AgentBlackListMobile(), "f");
                this.components.push(__classPrivateFieldGet(this, _CruiseBookPageMobile_agentBlackListComponent, "f"));
            }
            const filter = new App.FilterMobile({
                root: __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f"),
                onFilterChanged: v => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onBookFilterChanged).call(this, v),
            });
            __classPrivateFieldSet(this, _CruiseBookPageMobile_validator, filter.validator, "f");
            __classPrivateFieldSet(this, _CruiseBookPageMobile_popup, new App.Popup(), "f");
            this.responseValidator = new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f")),
                validator: filter.validator, // this.#form.validator,
            });
        });
    }, _CruiseBookPageMobile_onBookSend = function _CruiseBookPageMobile_onBookSend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseBookPageMobile_bookDigest, "f"))
                __classPrivateFieldGet(this, _CruiseBookPageMobile_bookDigest, "f").close();
            $('.js-booking-submit').trigger('click');
        });
    }, _CruiseBookPageMobile_onBookingButtonClick = function _CruiseBookPageMobile_onBookingButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_validator, "f").form())
                return;
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _CruiseBookPageMobile_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_book).call(this); }));
            }
            else {
                // собственно бронирование
                yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_book).call(this);
            }
        });
    }, _CruiseBookPageMobile_onBookFilterChanged = function _CruiseBookPageMobile_onBookFilterChanged(filterName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (filterName === 'activity-checkbox') {
                $('div.fake_checkbox.js-options-set-toggle').first().triggerHandler('click');
            }
            // no-op
        });
    }, _CruiseBookPageMobile_focusFirstInvalidField = function _CruiseBookPageMobile_focusFirstInvalidField() {
        const invalidField = __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").find('._invalid').first();
        const step = invalidField.closest('.js-form-step-content').index();
        if (step >= 0)
            __classPrivateFieldGet(this, _CruiseBookPageMobile_formBook, "f").steps.show(step);
        const tab = invalidField.closest('.js-person-tab-wrap');
        if (tab.length) {
            const tabs = tab.closest('.js-persons-tabs');
            tabs.find('.js-person-tab').eq(tab.index()).trigger('click');
        }
        const position = __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f").find('.js-persons-tabs').offset();
        $('html, body').animate({ scrollTop: position ? position.top : 0 }, 'slow');
        setTimeout(() => { invalidField.trigger('focus'); }, 1000);
    }, _CruiseBookPageMobile_getQuotes = function _CruiseBookPageMobile_getQuotes() {
        return __awaiter(this, arguments, void 0, function* (tourists = []) {
            const data = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_prepareDataForGetQuotes).call(this, tourists);
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            const xhr = $.ajax({
                url: this.options.urls.getQuotes,
                method: 'POST',
                data,
            });
            let success = false;
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.quotes)
                    __classPrivateFieldSet(this, _CruiseBookPageMobile_quotesData, response.data.quotes, "f");
                this.expirationPopup = App.scheduleExpirationPopup({
                    interval: response.data.dataExpiration,
                    url: this.options.urls.searchRoutes,
                });
                success = true;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            return success;
        });
    }, _CruiseBookPageMobile_changeHotelPlacement = function _CruiseBookPageMobile_changeHotelPlacement(event, room, board) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"))
                return;
            const target = $(event.currentTarget);
            const hotelKey = Number(target.closest('.js-order-placement-hotel').attr('data-hotelkey'));
            const id = Number(target.closest('.js-order-placement-hotel').attr('data-idx'));
            const hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getAvailableServicesByType).call(_a, __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"), 'hotel');
            let optionFind;
            hotelServices.forEach(value => {
                if (value.beginDay === id) {
                    optionFind = value.options.find(option => {
                        const { hotelInfo } = option.details.hotelDetail;
                        return hotelInfo.masterKey === hotelKey && hotelInfo.pansionMasterKey === board && hotelInfo.roomMasterKey === room;
                    });
                }
            });
            if (optionFind) {
                target.closest('.js-order-placement-hotel').attr('data-optionkey', optionFind.optionKey);
                yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onServiceChange).call(this);
            }
        });
    }, _CruiseBookPageMobile_book = function _CruiseBookPageMobile_book() {
        return __awaiter(this, void 0, void 0, function* () {
            const useVaucher = $('#useVoucher', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).val() === 'true';
            if (useVaucher && __classPrivateFieldGet(this, _CruiseBookPageMobile_baseOrder, "f") && !__classPrivateFieldGet(this, _CruiseBookPageMobile_isVaucherOrderChecked, "f")) {
                return;
            }
            if (__classPrivateFieldGet(this, _CruiseBookPageMobile_clubCardData, "f")) {
                const personErrorCard = __classPrivateFieldGet(this, _CruiseBookPageMobile_clubCardData, "f").findIndex(el => el.number > 0 && !el.isChecked);
                if (personErrorCard !== -1) {
                    $('.js-clubCardNumber', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")).eq(personErrorCard).closest('.form-item').addClass('_invalid');
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_focusFirstInvalidField).call(this);
                    return;
                }
            }
            const data = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_prepareDataForBook).call(this);
            const xhr = $.ajax({
                url: this.options.urls.book,
                method: 'POST',
                data,
            });
            __classPrivateFieldSet(this, _CruiseBookPageMobile_popupGroup, __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.Booking({}),
                modal: true,
            }), "f");
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response)) {
                    // TODO Titov: костыль пока из process не будут возвращаться конкретные коды классов ошибок (ValidationError, MessageError, etc).
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_focusFirstInvalidField).call(this);
                    return;
                }
                if (response.data.note.length > 0) {
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPageMobile_popupGroup, "f"));
                    __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").show({
                        group: '',
                        content: App.templates.Cruise.Messages.BookingNote({
                            note: response.data.note,
                            url: response.data.url,
                        }),
                        modal: true,
                    });
                }
                return;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPageMobile_popupGroup, "f"));
            }
        });
    }, _CruiseBookPageMobile_checkBaseOrder = function _CruiseBookPageMobile_checkBaseOrder(target, order) {
        return __awaiter(this, void 0, void 0, function* () {
            const elements = $('.js-form-order', $('.js-cruise-book')).serializeArray();
            const data = App.CruisePageMobileBase.convertArrayToRequestData(elements);
            const xhr = $.ajax({
                url: this.options.urls.checkBaseOrder,
                method: 'POST',
                data: {
                    orderCode: order,
                    lastName: data['services[0].Tourist.Lastname'] || '',
                    name: data['services[0].Tourist.Firstname'] || '',
                    birthday: data['services[0].Tourist.Birthday'] || '',
                },
                beforeSend: () => {
                    // После получения ответа эта штука заменится вместе со всем контентом
                    $('.js-progress-data-loading', target).show();
                },
                complete: () => {
                    // После получения ответа эта штука заменится вместе со всем контентом
                    $('.js-progress-data-loading', target).hide();
                },
            });
            const response = yield xhr;
            if (!this.responseValidator.process(response)) {
                // TODO Titov: костыль пока из process не будут возвращаться конкретные коды классов ошибок (ValidationError, MessageError, etc).
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '#checkBaseOrder', $('.js-baseOrderWrap', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f")), 'Произошла ошибка.Попробуйте еще раз позднее.');
                return;
            }
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPageMobile_baseOrderWrap, "f"), response.data.errorText);
            if (!response.data.error) {
                __classPrivateFieldSet(this, _CruiseBookPageMobile_isVaucherOrderChecked, true, "f");
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerSuccess).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPageMobile_baseOrderWrap, "f"), true);
                __classPrivateFieldSet(this, _CruiseBookPageMobile_baseOrder, order, "f");
            }
        });
    }, _CruiseBookPageMobile_checkClubCard = function _CruiseBookPageMobile_checkClubCard(personTab, cardNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const elements = $('.js-form-order', $('.js-cruise-book')).serializeArray();
            const data = App.CruisePageMobileBase.convertArrayToRequestData(elements);
            const personIndex = Number(personTab.attr('data-personindex'));
            const xhr = $.ajax({
                url: this.options.urls.checkClubCard,
                method: 'POST',
                data: {
                    cardNumber,
                    lastName: data[`services[${personIndex}].Tourist.Lastname`] || '',
                    name: data[`services[${personIndex}].Tourist.Firstname`] || '',
                    birthday: data[`services[${personIndex}].Tourist.Birthday`] || '',
                },
                beforeSend: () => {
                    $('.js-progress-data-loading', personTab).show();
                },
                complete: () => {
                    $('.js-progress-data-loading', personTab).hide();
                },
            });
            const response = yield xhr;
            if (!this.responseValidator.process(response)) {
                // TODO Titov: костыль пока из process не будут возвращаться конкретные коды классов ошибок (ValidationError, MessageError, etc).
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '.checkClubCard', personTab, 'Произошла ошибка. Попробуйте еще раз позднее.');
                return;
            }
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '.checkClubCard', personTab, response.data.errorText);
            if (!response.data.error) {
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, true);
                const success = {
                    number: cardNumber,
                    isChecked: true,
                };
                __classPrivateFieldGet(this, _CruiseBookPageMobile_clubCardData, "f")[personIndex] = success;
            }
        });
    }, _CruiseBookPageMobile_toggleCheckerError = function _CruiseBookPageMobile_toggleCheckerError(selector, wrap, text = '') {
        const errorEl = $(`${selector}Error`, wrap);
        if (text.length > 0) {
            errorEl.html(text);
            App.CruisePageBase.show(errorEl);
        }
        else {
            App.CruisePageBase.hide(errorEl);
        }
    }, _CruiseBookPageMobile_toggleCheckerSuccess = function _CruiseBookPageMobile_toggleCheckerSuccess(selector, wrap, show) {
        const errorEl = $(`${selector}Success`, wrap);
        if (show) {
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, `${selector}Error`, wrap);
            App.CruisePageBase.show(errorEl);
        }
        else {
            App.CruisePageBase.hide(errorEl);
        }
    }, _CruiseBookPageMobile_onServiceVariantSelect = function _CruiseBookPageMobile_onServiceVariantSelect(event) {
        const target = $(event.currentTarget);
        const selectedVariant = target.closest('.js-basic-variant');
        const container = target.closest('.js-basic-variants');
        const slide = !container.hasClass('js-not-slide-variants');
        const variants = container.find('.js-basic-variant');
        const showMore = container.find('.js-show-more-variants');
        variants.removeClass('_active');
        selectedVariant.addClass('_active');
        if (slide)
            variants.not('._active').slideUp();
        showMore.removeClass('_unfolded');
        showMore.addClass('_folded');
        showMore.slideDown();
    }, _CruiseBookPageMobile_onServiceChange = function _CruiseBookPageMobile_onServiceChange() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"))
                return;
            const tourists = [];
            __classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f").tourists.forEach((value, i) => {
                tourists[i] = {};
                // для всех туристов
                $('.js-order-placement-hotel', __classPrivateFieldGet(this, _CruiseBookPageMobile_orderPlacement, "f"))
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).attr('data-optionkey') || '';
                    tourists[i][groupId] = optionId;
                });
                $('.js-service-fee', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f"))
                    .find('.js-book-services-select')
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).find('.js-basic-variant-input:checked').valString();
                    tourists[i][groupId] = optionId;
                });
                // для каждого туристов
                $('.js-order-insurance-standard', $(`.js-person-tab-wrap[data-tab="person${i}"]`))
                    .find('.js-book-services-checkbox:checked')
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).attr('data-optionkey') || '';
                    tourists[i][groupId] = optionId;
                });
                $('.js-service-insurance', $(`.js-person-tab-wrap[data-tab="person${i}"]`))
                    .find('.js-book-services-select')
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).find('.js-basic-variant-input:checked').valString();
                    tourists[i][groupId] = optionId;
                });
            });
            __classPrivateFieldSet(this, _CruiseBookPageMobile_popupGroup, __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Valuating({}),
                modal: true,
            }), "f");
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getQuotes).call(this, tourists);
            __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
            __classPrivateFieldGet(this, _CruiseBookPageMobile_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPageMobile_popupGroup, "f"));
        });
    }, _CruiseBookPageMobile_onQuotesChange = function _CruiseBookPageMobile_onQuotesChange() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getDigestData).call(this);
            if (data)
                yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_updateDigest).call(this, data);
            return true;
        });
    }, _CruiseBookPageMobile_onDeckChange = function _CruiseBookPageMobile_onDeckChange(event) {
        event.preventDefault();
        if (__classPrivateFieldGet(this, _CruiseBookPageMobile_availableCabinsData, "f").length === 0)
            return;
        const deckKey = $(event.currentTarget).find('input').val();
        const cabins = __classPrivateFieldGet(this, _CruiseBookPageMobile_availableCabinsData, "f").find(value => value.deckKey === Number(deckKey));
        if (!cabins)
            return;
        const data = cabins.cabins
            .map((v, i) => ({
            value: v.cabinNo.toString(),
            text: `Каюта №${v.cabinNo}`,
            selected: i === 0,
        }));
        const control = __classPrivateFieldGet(this, _CruiseBookPageMobile_bookFilter, "f").findControl('cabinNo');
        if (control)
            control.setValueByListOptions(data, true); // .replaceOptions(data, false);
        const target = $(event.currentTarget);
        target.trigger("cruiseSvgLoader:deckChange" /* Events.CruiseSvgLoaderDeckChange */, cabins.deckNumber);
    }, _CruiseBookPageMobile_onCabinChange = function _CruiseBookPageMobile_onCabinChange(event) {
        var _b, _c, _d, _e;
        const cabin = Number($(event.currentTarget).find('input').val());
        $('[id^="cabins_"] ._active, [id^="numbers_"] ._active', __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f")).removeClass('_current');
        $(`[id^="cabin${cabin}_"], [id^="numbers_"] text:contains("${cabin}")`, __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f")).addClass('_current');
        const el = $('#pac_msc_liner_schema_deck_mini #cabins_deckMini ._current').first(), wnd = $('#pac_msc_liner_deck_zoom_catch').first();
        const e_x = ((_b = el.offset()) === null || _b === void 0 ? void 0 : _b.left) || 0, e_y = ((_c = el.offset()) === null || _c === void 0 ? void 0 : _c.top) || 0, w_x = ((_d = wnd === null || wnd === void 0 ? void 0 : wnd.offset()) === null || _d === void 0 ? void 0 : _d.left) || 0, w_y = ((_e = wnd === null || wnd === void 0 ? void 0 : wnd.offset()) === null || _e === void 0 ? void 0 : _e.top) || 0;
        const pos = {
            offsetX: e_x - w_x /* + rect.width / 2 */,
            offsetY: e_y - w_y /* + rect.height / 2 */,
        };
        wnd.trigger($.Event('mousedown', pos));
        wnd.trigger($.Event('mouseup', pos));
    }, _CruiseBookPageMobile_onSvgLayerCabinClick = function _CruiseBookPageMobile_onSvgLayerCabinClick(event) {
        event.preventDefault();
        if ($(event.currentTarget).hasClass('_current'))
            return;
        const cabin = $(event.currentTarget).attr('data-svg-cabin');
        const control = __classPrivateFieldGet(this, _CruiseBookPageMobile_bookFilter, "f").findControl('cabinNo');
        if (control && cabin) {
            if (cabin != control.getValueString())
                control.setValue([{ value: cabin }]);
        }
        $('[id^="cabins_"] ._active, [id^="numbers_"] ._active', __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f")).removeClass('_current');
        $(`[id^="cabin${cabin}_"], [id^="numbers_"] text:contains("${cabin}")`, __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f")).addClass('_current');
    }, _CruiseBookPageMobile_onSvgLayerLoaded = function _CruiseBookPageMobile_onSvgLayerLoaded() {
        __classPrivateFieldGet(this, _CruiseBookPageMobile_availableCabinsData, "f").forEach(d => {
            d.cabins.forEach((c, index) => {
                let classCss = '_active ';
                classCss += d.cabins.length == 1 ? '_current' : (index == 0 ? '_current' : '');
                $(`[id^="cabin${c.cabinNo}_"], [id^="numbers_"] text:contains("${c.cabinNo}")`, __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f"))
                    .addClass(classCss)
                    .attr('data-svg-cabin', `${c.cabinNo}`);
            });
        });
        $('#cabins_deckFull ._active, #numbers_deckFull ._active', __classPrivateFieldGet(this, _CruiseBookPageMobile_svgLoaderClass, "f")).on('click', e => __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onSvgLayerCabinClick).call(this, e));
        $('.js-cabins', __classPrivateFieldGet(this, _CruiseBookPageMobile_bookWrap, "f")).trigger("filter:change" /* Events.FilterChange */);
    }, _CruiseBookPageMobile_onPersonTabClick = function _CruiseBookPageMobile_onPersonTabClick(event) {
        const target = $(event.currentTarget);
        const tabs = $(event.currentTarget).closest('.js-persons-tabs');
        const tab = $('.js-person-tab', tabs);
        const wrap = $('.js-person-tab-wrap', tabs);
        const next = $('.js-person-tab-next', tabs);
        tab.removeClass('_active');
        target.addClass('_active');
        wrap.removeClass('_active').eq(target.index()).addClass('_active');
        // Прячем кнопку 'Следующий турист'.
        next.toggleClass('_hidden', wrap.length - 1 === target.index());
    }, _CruiseBookPageMobile_onBookButtonClick = function _CruiseBookPageMobile_onBookButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_formBook, "f").validator.form()) {
                __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_focusFirstInvalidField).call(this);
                return;
            }
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_book).call(this);
        });
    }, _CruiseBookPageMobile_onFioChange = function _CruiseBookPageMobile_onFioChange(event) {
        const target = $(event.currentTarget);
        // изменение текста на Uppercase
        target.val(App.transliterateName(target.valString()));
        // инициалы
        const container = target.closest('.js-person-tab-wrap');
        const id = container.attr('data-tab');
        const initials = container.closest('.js-persons-tabs').find(`[data-target="${id}"] .initials`);
        const lastName = container.find('.js-person-tab-initials-b').valString();
        const firstName = container.find('.js-person-tab-initials-a').valString();
        const birthday = container.find('.js-person-birthday').datepicker('getDate');
        const currentAge = (birthday ? App.getAge(birthday, App.parseIsoDate(this.options.quotes.tourDate)) : null);
        const text = (lastName != null && lastName.length > 0 ? lastName[0] : '?') + (firstName != null && firstName.length > 0 ? firstName[0] : '?');
        const ageTitle = currentAge ? `, ${currentAge} ${App.pluralRu(currentAge, 'год', 'года', 'лет')}` : '';
        const title = `${lastName} ${firstName}${ageTitle}`;
        initials.text(text);
        __classPrivateFieldGet(this, _CruiseBookPageMobile_optionsSet, "f").find(`[data-target=${id}]`).find('.initials')
            .text(text)
            .attr('title', title);
    }, _CruiseBookPageMobile_onShowMoreVariants = function _CruiseBookPageMobile_onShowMoreVariants(event) {
        const target = $(event.currentTarget);
        const container = target.closest('.js-basic-variants');
        const inactive = container.find('.js-basic-variant').not('._active');
        if (target.hasClass('_folded')) {
            inactive.slideDown();
            target.removeClass('_folded');
            target.addClass('_unfolded');
            target.slideUp();
        }
    }, _CruiseBookPageMobile_initTouristDocumentMask = function _CruiseBookPageMobile_initTouristDocumentMask(personContainer) {
        const documentInput = $('.js-person-document-number .js-form-item-field', personContainer);
        const citizenshipKey = $('.js-person-citizenship .js-jelect-input', personContainer).valNumber();
        const mask = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getDocumentNumberMask).call(_a, citizenshipKey, this.options.externalCountryKey);
        $('.js-person-document-type', personContainer).val(mask.type);
        documentInput.inputmask(mask.inputmask);
    }, _CruiseBookPageMobile_changeTouristDocumentMask = function _CruiseBookPageMobile_changeTouristDocumentMask(e) {
        const target = $(e.currentTarget);
        const personContainer = target.closest('.js-person-tab-wrap');
        __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_initTouristDocumentMask).call(this, personContainer);
    }, _CruiseBookPageMobile_getDocumentNumberMask = function _CruiseBookPageMobile_getDocumentNumberMask(citizenshipCountryKey, countryKey) {
        var _b, _c;
        // TODO Titov: перенести в ConfigController.Settings.
        const defaultMask = { type: 'Passport', inputmask: { mask: '*{6,18}', autoUnmask: true, greedy: false } };
        const maskRules = {
            // RU
            460: {
                // паспорт
                213151: {
                    type: 'Passport',
                    inputmask: {
                        mask: '9999-999999',
                        autoUnmask: true,
                    },
                },
                // загранпаспорт
                0: {
                    type: 'ForeignPassport',
                    inputmask: {
                        mask: '99-9999999',
                        autoUnmask: true,
                    },
                },
            },
        };
        if (!citizenshipCountryKey)
            return defaultMask;
        const maskRule = maskRules[citizenshipCountryKey];
        if (!maskRule)
            return defaultMask;
        if (!countryKey)
            return (_b = maskRule[0]) !== null && _b !== void 0 ? _b : defaultMask;
        const rule = maskRule[countryKey];
        if (!rule)
            return (_c = maskRule[0]) !== null && _c !== void 0 ? _c : defaultMask;
        return rule;
    }, _CruiseBookPageMobile_onHotelEditClick = function _CruiseBookPageMobile_onHotelEditClick(event) {
        const target = $(event.currentTarget);
        const placementHotel = target.closest('.js-order-placement-hotel');
        const hotelKey = Number(placementHotel.attr('data-hotelkey'));
        const index = Number(placementHotel.attr('data-idx'));
        placementHotel.hide();
        const placementHotels = placementHotel.parent().find(`.js-order-placement-hotels[data-idx=${index}]`);
        placementHotels.slideDown();
        placementHotels.find('.js-order-placement-hotels-item').removeClass('_active');
        placementHotels.find('.js-spoiler-content').hide();
        placementHotels
            .find(`.js-order-placement-hotels-btn[data-hotelkey=${hotelKey}]`)
            .closest('.js-order-placement-hotels-item')
            .addClass('_active')
            .closest('.js-spoiler-content')
            .show();
    }, _CruiseBookPageMobile_onHotelChange = function _CruiseBookPageMobile_onHotelChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f"))
                return;
            const target = $(event.currentTarget);
            const hotelKey = parseInt(target.attr('data-hotelkey') || '', 10);
            const index = parseInt(target.closest('.js-order-placement-hotels').attr('data-idx') || '', 10);
            const groupContainer = target.closest('.js-order-placement-item');
            const placementHotels = $('.js-order-placement-hotels', groupContainer);
            let placementHotel = $(`.js-order-placement-hotel[data-idx='${index}']`, groupContainer);
            const data = JSON.parse(JSON.stringify(__classPrivateFieldGet(this, _CruiseBookPageMobile_quotesData, "f")));
            let hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getAvailableServicesByType).call(_a, data, 'hotel');
            if (hotelServices.length > 0)
                __classPrivateFieldSet(this, _CruiseBookPageMobile_hotelsInfo, __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_getHotelsInfo).call(_a, hotelServices), "f");
            hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_changeHotelServicesSelected).call(_a, hotelServices, hotelKey, index);
            hotelServices = __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getHotelServices).call(this, hotelServices, true);
            const dataTplHotelBlockMain = {
                hotel: hotelServices.find(v => v.beginDay === index) || hotelServices[0],
                cruiseParts: __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getCruiseParts).call(this),
            };
            placementHotels.hide();
            placementHotel.replaceWith(App.templates.Cruise.Book.HotelBlockMain(dataTplHotelBlockMain));
            placementHotel = $(`.js-order-placement-hotel[data-idx='${index}']`, groupContainer);
            placementHotel.show();
            placementHotel.find('.js-filter-select-block').each((i, v) => {
                __classPrivateFieldGet(this, _CruiseBookPageMobile_controls, "f").push(new App.FilterSelectBlock({ root: $(v) }));
            });
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_onServiceChange).call(this);
        });
    }, _CruiseBookPageMobile_onHotelBoardChange = function _CruiseBookPageMobile_onHotelBoardChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const room = Number(__classPrivateFieldGet(this, _CruiseBookPageMobile_orderPlacement, "f").find('[data-select="HotelRoom"] input').val());
            const board = Number($(event.currentTarget).find('input').val());
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_changeHotelPlacement).call(this, event, room, board);
        });
    }, _CruiseBookPageMobile_onHotelRoomChange = function _CruiseBookPageMobile_onHotelRoomChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const board = Number(__classPrivateFieldGet(this, _CruiseBookPageMobile_orderPlacement, "f").find('[data-select="HotelFood"] input').val());
            const room = Number($(event.currentTarget).find('input').val());
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_changeHotelPlacement).call(this, event, room, board);
        });
    }, _CruiseBookPageMobile_onBaseOrderChange = function _CruiseBookPageMobile_onBaseOrderChange() {
        __classPrivateFieldSet(this, _CruiseBookPageMobile_isVaucherOrderChecked, false, "f");
    }, _CruiseBookPageMobile_onCheckBaseOrderClick = function _CruiseBookPageMobile_onCheckBaseOrderClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPageMobile_baseOrderWrap, "f"));
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerSuccess).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPageMobile_baseOrderWrap, "f"), false);
            const baseOrderEl = $('#baseOrder', __classPrivateFieldGet(this, _CruiseBookPageMobile_formOrder, "f"));
            baseOrderEl.closest('.form-item').removeClass('_invalid');
            const checkedValue = baseOrderEl.val();
            if (!checkedValue) {
                baseOrderEl.closest('.form-item').addClass('_invalid');
                return;
            }
            __classPrivateFieldSet(this, _CruiseBookPageMobile_baseOrder, checkedValue, "f");
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_checkBaseOrder).call(this, target, __classPrivateFieldGet(this, _CruiseBookPageMobile_baseOrder, "f"));
        });
    }, _CruiseBookPageMobile_onFioPhoneChange = function _CruiseBookPageMobile_onFioPhoneChange(event) {
        const personTab = $(event.currentTarget).closest('.js-person-tab-wrap');
        const personIndex = Number(personTab.attr('data-personindex'));
        const findEmptyVal = $('.js-needForClubCard', personTab).toArray().findIndex(el => $(el).val() === '');
        $('.js-clubCardNumber', personTab).prop('disabled', findEmptyVal !== -1);
        if (findEmptyVal === -1) {
            $('.js-checkClubCard', personTab).show();
        }
        else {
            $('.js-clubCardNumber', personTab).val('');
            $('.js-checkClubCard', personTab).hide();
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '.checkClubCard', personTab);
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
            __classPrivateFieldGet(this, _CruiseBookPageMobile_clubCardData, "f")[personIndex] = {
                number: 0,
                isChecked: false,
            };
        }
    }, _CruiseBookPageMobile_onClubCardNumberChange = function _CruiseBookPageMobile_onClubCardNumberChange(event) {
        const personTab = $(event.currentTarget).closest('.js-person-tab-wrap');
        const personIndex = Number(personTab.attr('data-personindex'));
        __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '.checkClubCard', personTab);
        __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
        const checkedValue = $(event.currentTarget).val();
        __classPrivateFieldGet(this, _CruiseBookPageMobile_clubCardData, "f")[personIndex] = {
            number: !checkedValue ? 0 : checkedValue,
            isChecked: false,
        };
    }, _CruiseBookPageMobile_onCheckClubCardClick = function _CruiseBookPageMobile_onCheckClubCardClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const personTab = $(event.currentTarget).closest('.js-person-tab-wrap');
            const personIndex = Number(personTab.attr('data-personindex'));
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '.checkClubCard', personTab);
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
            const cardEl = $('.js-clubCardNumber', personTab);
            const checkedValue = cardEl.val();
            if (!checkedValue) {
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPageMobile_toggleCheckerError).call(_a, '.checkClubCard', personTab, 'Укажите корректный номер карты');
                return;
            }
            __classPrivateFieldGet(this, _CruiseBookPageMobile_clubCardData, "f")[personIndex] = {
                number: checkedValue,
                isChecked: false,
            };
            yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_checkClubCard).call(this, personTab, __classPrivateFieldGet(this, _CruiseBookPageMobile_clubCardData, "f")[personIndex].number);
        });
    }, _CruiseBookPageMobile_onBookPrivateClick = function _CruiseBookPageMobile_onBookPrivateClick() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = (yield __classPrivateFieldGet(this, _CruiseBookPageMobile_instances, "m", _CruiseBookPageMobile_getDigestData).call(this)) || {};
                pac.api.FormClientRequest({
                    url: window.location.href,
                    data,
                });
            }
            catch (ex) {
                console.warn(ex);
            }
        });
    }, _CruiseBookPageMobile_switchSvgLoaderLegend = function _CruiseBookPageMobile_switchSvgLoaderLegend(event) {
        event.preventDefault();
        const legendWrap = $(event.currentTarget).parent();
        const legendBlock = $('.js-ship-svg-legend', legendWrap);
        const isOpen = legendWrap.hasClass('_open');
        if (isOpen) {
            legendWrap.removeClass('_open');
            legendBlock.hide();
            $(event.currentTarget).find('.pseudo-link').html(localizer.showSvgDetails);
        }
        else {
            legendWrap.addClass('_open');
            legendBlock.show();
            $(event.currentTarget).find('.pseudo-link').html(localizer.hideSvgDetails);
        }
    };
    App.CruiseBookPageMobile = CruiseBookPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseBookPage_instances, _a, _CruiseBookPage_bookFilter, _CruiseBookPage_formBook, _CruiseBookPage_popup, _CruiseBookPage_popupGroup, _CruiseBookPage_bookWrapClass, _CruiseBookPage_bookWrap, _CruiseBookPage_optionsSet, _CruiseBookPage_formOrder, _CruiseBookPage_controls, _CruiseBookPage_currentCabin, _CruiseBookPage_cabinCategoryKey, _CruiseBookPage_fareCode, _CruiseBookPage_cruiseId, _CruiseBookPage_hotelsInfo, _CruiseBookPage_availableCabinsData, _CruiseBookPage_cruisePartsData, _CruiseBookPage_quotesData, _CruiseBookPage_hasDynamicFlights, _CruiseBookPage_checkActivities, _CruiseBookPage_activityTotalPrice, _CruiseBookPage_activityTotalCommision, _CruiseBookPage_activitiesData, _CruiseBookPage_orderPlacement, _CruiseBookPage_placementHotels, _CruiseBookPage_isVaucherOrderChecked, _CruiseBookPage_baseOrder, _CruiseBookPage_baseOrderWrap, _CruiseBookPage_clubCardData, _CruiseBookPage_aviaResultComponent, _CruiseBookPage_svgLoaderClass, _CruiseBookPage_agentBlackListComponent, _CruiseBookPage_showBookPage, _CruiseBookPage_initSvgLayer, _CruiseBookPage_initFlights, _CruiseBookPage_finishInitialization, _CruiseBookPage_initInc, _CruiseBookPage_onAviaGroupClick, _CruiseBookPage_getBookContentDigestServices, _CruiseBookPage_getBookPriceDigestServices, _CruiseBookPage_isNullOrEmpty, _CruiseBookPage_geServiceTypeString, _CruiseBookPage_getInsuranceTypeName, _CruiseBookPage_getServiceTypeName, _CruiseBookPage_getServiceOrder, _CruiseBookPage_getAvailableServicesByType, _CruiseBookPage_generateFlightTags, _CruiseBookPage_nextDayArrival, _CruiseBookPage_getFlightService, _CruiseBookPage_getFlightResults, _CruiseBookPage_getCruiseParts, _CruiseBookPage_getHotelsInfo, _CruiseBookPage_getHotelServices, _CruiseBookPage_changeHotelServicesSelected, _CruiseBookPage_prepareDataForGetQuotes, _CruiseBookPage_prepareDataForBook, _CruiseBookPage_initPlacement, _CruiseBookPage_checkActivityDateCommon, _CruiseBookPage_checkActivityDate, _CruiseBookPage_selectedOptionsChanged, _CruiseBookPage_saveActivityChangedData, _CruiseBookPage_applyActivityPacketDiscount, _CruiseBookPage_getActivityTotalPrice, _CruiseBookPage_getDigestData, _CruiseBookPage_updateDigest, _CruiseBookPage_focusFirstInvalidField, _CruiseBookPage_getQuotes, _CruiseBookPage_changeHotelPlacement, _CruiseBookPage_book, _CruiseBookPage_checkBaseOrder, _CruiseBookPage_checkClubCard, _CruiseBookPage_toggleCheckerError, _CruiseBookPage_toggleCheckerSuccess, _CruiseBookPage_onServiceVariantSelect, _CruiseBookPage_onServiceChange, _CruiseBookPage_onQuotesChange, _CruiseBookPage_onDeckChange, _CruiseBookPage_onCabinChange, _CruiseBookPage_onSvgLayerCabinClick, _CruiseBookPage_onSvgLayerLoaded, _CruiseBookPage_onPersonTabClick, _CruiseBookPage_onBookButtonClick, _CruiseBookPage_checkBookForm, _CruiseBookPage_checkPassengerUnique, _CruiseBookPage_onFioChange, _CruiseBookPage_onShowMoreVariants, _CruiseBookPage_initTouristDocumentMask, _CruiseBookPage_changeTouristDocumentMask, _CruiseBookPage_getDocumentNumberMask, _CruiseBookPage_onHotelEditClick, _CruiseBookPage_onHotelChange, _CruiseBookPage_onHotelBoardChange, _CruiseBookPage_onHotelRoomChange, _CruiseBookPage_onSwitcherClick, _CruiseBookPage_onBaseOrderChange, _CruiseBookPage_onCheckBaseOrderClick, _CruiseBookPage_onFioPhoneChange, _CruiseBookPage_onClubCardNumberChange, _CruiseBookPage_onCheckClubCardClick, _CruiseBookPage_onBookPrivateClick, _CruiseBookPage_switchSvgLoaderLegend;
    class CruiseBookPage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-page .js-app-container-content' }, options));
            _CruiseBookPage_instances.add(this);
            _CruiseBookPage_bookFilter.set(this, void 0);
            _CruiseBookPage_formBook.set(this, void 0);
            _CruiseBookPage_popup.set(this, void 0);
            _CruiseBookPage_popupGroup.set(this, void 0);
            _CruiseBookPage_bookWrapClass.set(this, void 0);
            _CruiseBookPage_bookWrap.set(this, void 0);
            _CruiseBookPage_optionsSet.set(this, void 0);
            // обертка для бронирования круиза
            _CruiseBookPage_formOrder.set(this, void 0);
            _CruiseBookPage_controls.set(this, new Array());
            _CruiseBookPage_currentCabin.set(this, void 0);
            /* бронирование*/
            _CruiseBookPage_cabinCategoryKey.set(this, void 0);
            _CruiseBookPage_fareCode.set(this, void 0);
            _CruiseBookPage_cruiseId.set(this, void 0);
            _CruiseBookPage_hotelsInfo.set(this, void 0);
            /* результаты запросов*/
            _CruiseBookPage_availableCabinsData.set(this, void 0);
            _CruiseBookPage_cruisePartsData.set(this, void 0);
            _CruiseBookPage_quotesData.set(this, void 0);
            _CruiseBookPage_hasDynamicFlights.set(this, void 0);
            /* экскурсии в круизе */
            _CruiseBookPage_checkActivities.set(this, void 0);
            _CruiseBookPage_activityTotalPrice.set(this, void 0);
            _CruiseBookPage_activityTotalCommision.set(this, void 0);
            _CruiseBookPage_activitiesData.set(this, void 0);
            /* размещение в отеле*/
            _CruiseBookPage_orderPlacement.set(this, void 0);
            _CruiseBookPage_placementHotels.set(this, void 0);
            _CruiseBookPage_isVaucherOrderChecked.set(this, false);
            _CruiseBookPage_baseOrder.set(this, '');
            _CruiseBookPage_baseOrderWrap.set(this, void 0);
            _CruiseBookPage_clubCardData.set(this, void 0);
            _CruiseBookPage_aviaResultComponent.set(this, void 0);
            _CruiseBookPage_svgLoaderClass.set(this, void 0);
            _CruiseBookPage_agentBlackListComponent.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseBookPage_bookWrapClass, '.js-cruise-book', "f");
            __classPrivateFieldSet(this, _CruiseBookPage_svgLoaderClass, '#svgLoader', "f");
            __classPrivateFieldSet(this, _CruiseBookPage_bookWrap, $(__classPrivateFieldGet(this, _CruiseBookPage_bookWrapClass, "f"), $('.js-cruise-page')), "f");
            __classPrivateFieldSet(this, _CruiseBookPage_cruiseId, Number($('#cruiseId').val()), "f");
            __classPrivateFieldSet(this, _CruiseBookPage_fareCode, $('#fareCode').valString(), "f");
            __classPrivateFieldSet(this, _CruiseBookPage_cabinCategoryKey, Number($('#categoryKey').val()), "f");
            __classPrivateFieldSet(this, _CruiseBookPage_hasDynamicFlights, Number($('#hasDynamicFlights').val()), "f");
            __classPrivateFieldSet(this, _CruiseBookPage_currentCabin, this.options.offer, "f");
            __classPrivateFieldSet(this, _CruiseBookPage_cruisePartsData, this.options.parts, "f");
            __classPrivateFieldSet(this, _CruiseBookPage_availableCabinsData, this.options.cabins, "f");
            __classPrivateFieldSet(this, _CruiseBookPage_quotesData, this.options.quotes, "f");
            __classPrivateFieldSet(this, _CruiseBookPage_clubCardData, [], "f");
            __classPrivateFieldSet(this, _CruiseBookPage_activitiesData, [], "f");
            __classPrivateFieldSet(this, _CruiseBookPage_checkActivities, this.options.activities.length > 0, "f");
            this.components.push(new App.FindTourist());
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _CruiseBookPage_agentBlackListComponent, new App.AgentBlackListComponent(), "f");
                this.components.push(__classPrivateFieldGet(this, _CruiseBookPage_agentBlackListComponent, "f"));
            }
            this.states = {
                'book': {
                    handler: () => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_showBookPage).call(this),
                    actionName: 'book',
                    keysForUrl: [],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseBookPage_formOrder, $('.js-form-order', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")), "f");
            __classPrivateFieldSet(this, _CruiseBookPage_baseOrderWrap, $('.js-baseOrderWrap', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")), "f");
            // Note: переносим до создания класса Form и используем неделегируемые события для внесения изменений в значение поля перед
            // его валидацией.
            $('.js-person-tab-initials-a, .js-person-tab-initials-b, .js-person-birthday', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).on('change', e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onFioChange).call(this, e));
            this.components.push(new App.VariantsShowMoreComponent({ root: this.root }));
            this.components.push(new App.Digest({ container: __classPrivateFieldGet(this, _CruiseBookPage_bookWrapClass, "f") }));
            __classPrivateFieldSet(this, _CruiseBookPage_bookFilter, new App.Filter({ root: __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f") }), "f");
            __classPrivateFieldSet(this, _CruiseBookPage_formBook, new App.Form({ root: __classPrivateFieldGet(this, _CruiseBookPage_bookFilter, "f").root, disableStepValidation: true }), "f");
            this.responseValidator = new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _CruiseBookPage_popup, "f")),
                validator: __classPrivateFieldGet(this, _CruiseBookPage_formBook, "f").validator,
            });
            this.pricePresenter = new App.NetPricePresenter({ root: this.root, desired: App.AdditionalPriceShow.ToPay });
            // ваучер с бортовым кредитом
            const vaucherSwitcher = __classPrivateFieldGet(this, _CruiseBookPage_bookFilter, "f").root.find('[data-name="creditvaucher"]');
            vaucherSwitcher.on('click', e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onSwitcherClick).call(this, e));
            $('#baseOrder').on('change', () => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onBaseOrderChange).call(this));
            $('#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onCheckBaseOrderClick).call(this, e); }));
            // табы туристов
            __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").on('click', '.js-person-tab', e => __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_onPersonTabClick).call(_a, e));
            __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").on('click', '.js-person-tab-next', e => {
                const tabs = $(e.currentTarget).closest('.js-persons-tabs');
                const tab = $('.js-person-tab', tabs);
                tab.filter('._active').next().trigger('click');
            });
            // Переключение пола М/Ж.
            __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").on('change', '.js-form-gender-input', e => {
                const input = $(e.currentTarget);
                const gender = input.closest('.js-form-gender');
                const icon = $('.js-form-gender-icon', gender);
                const tab = input.closest('[data-tab]').attr('data-tab');
                const tabIcon = input.closest('.js-persons-tabs').find(`[data-target="${tab}"] .js-form-gender-icon`);
                icon.add(tabIcon).toggleClass('_man', input.is(':checked') && input.val() === 'Male');
                icon.add(tabIcon).toggleClass('_woman', input.is(':checked') && input.val() === 'Female');
            });
            // клубная карта
            $('.js-needForClubCard', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).on('change', e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onFioPhoneChange).call(this, e));
            $('.js-clubCardNumber', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).on('change', e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onClubCardNumberChange).call(this, e));
            $('.js-checkClubCard', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onCheckClubCardClick).call(this, e); }));
            // Изменение гражданства.
            __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").find('.js-person-tab-wrap').each((i, v) => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_initTouristDocumentMask).call(this, $(v)));
            __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").on('change', '.js-person-citizenship .js-jelect', e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_changeTouristDocumentMask).call(this, e));
            // выбор страховок, сервисного сбора
            $('.js-service-insurance, .js-service-fee', this.root).on('change', '.js-basic-variant-input', (e) => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_onServiceVariantSelect).call(_a, e);
                yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onServiceChange).call(this);
            }));
            // развернуть выбор вариантов
            __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").on('click', '.js-show-more-variants', e => __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_onShowMoreVariants).call(_a, e));
            const calendars = $('.js-form-date', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f"));
            calendars.inputmask('date');
            const calendarIcons = $('.js-filter-date-from-icon', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f"));
            calendarIcons.on('click', (event) => {
                $(event.currentTarget).prev('.js-form-date').trigger('focus');
            });
            $('.js-decks', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")).on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onDeckChange).call(this, e));
            $('.js-cabins', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")).on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onCabinChange).call(this, e));
            // выбор виз
            $('.table_insurance', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")).on('click', '.js-book-services-checkbox', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onServiceChange).call(this); }));
            __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f").on("quotes:change" /* Events.QuotesChange */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onQuotesChange).call(this); }));
            $('.js-form-book', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onBookButtonClick).call(this, e); }));
            // корзина просрочена
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            this.expirationPopup = App.scheduleExpirationPopup({
                interval: this.options.offerExpiration,
                url: this.options.urls.searchRoutes,
            });
            __classPrivateFieldSet(this, _CruiseBookPage_popup, new App.Popup({
                onShow: () => {
                    $('.js-popup-close', __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").hide());
                },
            }), "f");
            // вывод скидки
            const digest = $('.js-digest', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f"));
            digest.on('click', '.js-digest-footer-details-show', () => {
                $('.js-digest-footer-wrap', digest).addClass('_detail');
            });
            digest.on('click', '.js-digest-footer-details-hide', () => {
                $('.js-digest-footer-wrap', digest).removeClass('_detail');
            });
            $(document).on("NetPricePresenter:click" /* Events.NetPricePresenterClick */, () => {
                $('.js-digest-footer-wrap', digest).removeClass('_detail');
            });
            // заявка для неавторизованных пользователей
            $('.js-pw-order-submit-private', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onBookPrivateClick).call(this); }));
            App.AviaResultComponent.initMiddleName(this.root, false);
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, (e) => __awaiter(this, void 0, void 0, function* () {
                const data = yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getDigestData).call(this);
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта(при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data,
                    },
                }));
            }));
            // показать/скрыть легенду для палубы
            $('.js-ship-svg-legend-button', '.js-ship-svg-legend-wrap').on('click', e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_switchSvgLoaderLegend).call(this, e));
        }
    }
    _a = CruiseBookPage, _CruiseBookPage_bookFilter = new WeakMap(), _CruiseBookPage_formBook = new WeakMap(), _CruiseBookPage_popup = new WeakMap(), _CruiseBookPage_popupGroup = new WeakMap(), _CruiseBookPage_bookWrapClass = new WeakMap(), _CruiseBookPage_bookWrap = new WeakMap(), _CruiseBookPage_optionsSet = new WeakMap(), _CruiseBookPage_formOrder = new WeakMap(), _CruiseBookPage_controls = new WeakMap(), _CruiseBookPage_currentCabin = new WeakMap(), _CruiseBookPage_cabinCategoryKey = new WeakMap(), _CruiseBookPage_fareCode = new WeakMap(), _CruiseBookPage_cruiseId = new WeakMap(), _CruiseBookPage_hotelsInfo = new WeakMap(), _CruiseBookPage_availableCabinsData = new WeakMap(), _CruiseBookPage_cruisePartsData = new WeakMap(), _CruiseBookPage_quotesData = new WeakMap(), _CruiseBookPage_hasDynamicFlights = new WeakMap(), _CruiseBookPage_checkActivities = new WeakMap(), _CruiseBookPage_activityTotalPrice = new WeakMap(), _CruiseBookPage_activityTotalCommision = new WeakMap(), _CruiseBookPage_activitiesData = new WeakMap(), _CruiseBookPage_orderPlacement = new WeakMap(), _CruiseBookPage_placementHotels = new WeakMap(), _CruiseBookPage_isVaucherOrderChecked = new WeakMap(), _CruiseBookPage_baseOrder = new WeakMap(), _CruiseBookPage_baseOrderWrap = new WeakMap(), _CruiseBookPage_clubCardData = new WeakMap(), _CruiseBookPage_aviaResultComponent = new WeakMap(), _CruiseBookPage_svgLoaderClass = new WeakMap(), _CruiseBookPage_agentBlackListComponent = new WeakMap(), _CruiseBookPage_instances = new WeakSet(), _CruiseBookPage_showBookPage = function _CruiseBookPage_showBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageBase.show(__classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f"), true, 1);
            const messenger = new App.PopupMessenger(__classPrivateFieldGet(this, _CruiseBookPage_popup, "f"));
            this.responseValidator = new App.ResponseValidatorOld({ messenger, validator: this.validator });
            __classPrivateFieldSet(this, _CruiseBookPage_popupGroup, __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Valuating({}),
                modal: true,
                delay: 3000,
            }), "f");
            const data = JSON.parse(JSON.stringify(__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f")));
            const hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getAvailableServicesByType).call(_a, data, 'hotel', true);
            if (hotelServices.length > 0)
                __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_initPlacement).call(this, hotelServices);
            App.AviaResultComponent.initMiddleName(this.root, false);
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_initFlights).call(this);
            __classPrivateFieldSet(this, _CruiseBookPage_optionsSet, $('.js-options-set', this.root), "f");
            // Группа опций (экскурсии).
            __classPrivateFieldGet(this, _CruiseBookPage_optionsSet, "f").each((_, element) => {
                const jqElement = $(element);
                const toggle = $('.js-options-set-toggle', jqElement);
                // Общий чекбокс для группы.
                toggle.on('click', e => {
                    const target = $(e.currentTarget);
                    const checkbox = target.is(':checkbox');
                    // Note: для НЕ-checkbox инвертируем значение, т.к. click на checkbox возвращает новое значение (а-ля после нажатия),
                    // а click на НЕ-checkbox - старое (до нажатия).
                    const checked = checkbox ? target.is(':checked') : !target.is('._checked, ._checked-half');
                    if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
                        return false;
                    if (!checkbox)
                        target.removeClass('_checked-half').toggleClass('_checked', checked);
                    if (checked && $('.js-options-set-item:disabled', jqElement).length > 0)
                        target.removeClass('_checked').addClass('_checked-half');
                    const items = $('.js-options-set-item', jqElement).not(':disabled');
                    items.each((__, element2) => {
                        const itemTarget = $(element2);
                        const itemCheckbox = itemTarget.is(':checkbox');
                        if (itemCheckbox)
                            itemTarget.prop('checked', checked);
                        else
                            itemTarget.toggleClass('_checked', checked);
                    });
                    __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_selectedOptionsChanged).call(this, jqElement);
                    __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_checkActivityDateCommon).call(_a, target, checked);
                    __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
                    return true;
                });
                // Синхронизуем чекбоксы персон с общим чекбоксом.
                jqElement.on('click', '.js-options-set-item', (e) => {
                    const target = $(e.currentTarget);
                    const checkbox = target.is(':checkbox');
                    // Note: для НЕ-checkbox инвертируем значение, т.к. click на checkbox возвращает новое значение (а-ля после нажатия), а
                    // click на НЕ-checkbox - старое (до нажатия).
                    const checked = checkbox ? target.is(':checked') : !target.is('._checked');
                    const toggleCheckbox = toggle.is(':checkbox');
                    if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
                        return false;
                    if (!checkbox)
                        target.toggleClass('_checked', checked);
                    const items = $('.js-options-set-item', jqElement);
                    const checkedCount = items.filter(':checked, ._checked').length;
                    if (toggleCheckbox) {
                        target.prop('checked', checkedCount > 0);
                    }
                    else {
                        toggle
                            .toggleClass('_checked', checkedCount === items.length)
                            .toggleClass('_checked-half', checkedCount !== 0 && checkedCount < items.length);
                    }
                    __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_selectedOptionsChanged).call(this, jqElement);
                    __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_checkActivityDateCommon).call(_a, target, checked);
                    __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
                    return true;
                });
            });
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_initSvgLayer).call(this);
            __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPage_popupGroup, "f"));
        });
    }, _CruiseBookPage_initSvgLayer = function _CruiseBookPage_initSvgLayer() {
        return __awaiter(this, void 0, void 0, function* () {
            $(this.root).on("cruiseSvgLoader:loaded" /* Events.CruiseSvgLoaderLoaded */, __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f"), () => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onSvgLayerLoaded).call(this));
            const params = {
                root: __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f"),
                width: 599,
                shipSchemaSvg: '',
                deck: 0,
                shipId: this.options.shipId,
                shipCode: this.options.shipCode,
                svgNS: 'http://www.w3.org/2000/svg',
            };
            const svgLoader = new App.CruiseSvgLoader();
            yield svgLoader.init(params, this.options.decks);
        });
    }, _CruiseBookPage_initFlights = function _CruiseBookPage_initFlights() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseBookPage_hasDynamicFlights, "f") > 0) {
                __classPrivateFieldSet(this, _CruiseBookPage_aviaResultComponent, new App.AviaResultComponent({
                    root: $('.js-flights-regular', this.root),
                    formRoot: __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f"),
                    data: __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").serializeArray(),
                    beginDate: App.parseIsoDate(__classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").checkinDate),
                    urls: this.options.urls.aviaUrls,
                }), "f");
                __classPrivateFieldGet(this, _CruiseBookPage_aviaResultComponent, "f").getRoot()
                    .on("avia:searchCompleted" /* Events.AviaSearchCompleted */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_finishInitialization).call(this); }))
                    .on("avia:toggleBookButton" /* Events.AviaToggleBookButton */, (_, data) => __awaiter(this, void 0, void 0, function* () { return $('.js-form-book', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")).prop('disabled', data); }))
                    .on("avia:groupClick" /* Events.AviaGroupClick */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onAviaGroupClick).call(this, e, data); }))
                    .on("avia:flightChanged" /* Events.AviaFlightChanged */, () => __awaiter(this, void 0, void 0, function* () {
                    $('.js-form-flights', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")).show();
                    $('.js-form-book', this.root).prop('disabled', false);
                }));
                this.components.push(__classPrivateFieldGet(this, _CruiseBookPage_aviaResultComponent, "f"));
            }
            else {
                yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_finishInitialization).call(this);
            }
            $('.js-flight-class input, .js-flight-direct input', this.root).on('change', () => __awaiter(this, void 0, void 0, function* () { yield __classPrivateFieldGet(this, _CruiseBookPage_aviaResultComponent, "f").newSearch(__classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").serializeArray()); }));
        });
    }, _CruiseBookPage_finishInitialization = function _CruiseBookPage_finishInitialization() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onQuotesChange).call(this);
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_initInc).call(this);
        });
    }, _CruiseBookPage_initInc = function _CruiseBookPage_initInc() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"))
                return;
            const tourists = [];
            __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").tourists.forEach((value, i) => {
                tourists[i] = {};
                if (!this.options.isAgencyBelarus) {
                    // страховка "Отмена поездки" всегда с ценой
                    $('.js-service-insurance', $(`.js-person-tab-wrap[data-tab="person${i}"]`))
                        .find('.js-book-services-select')
                        .each((index, elem) => {
                        const groupId = $(elem).attr('data-groupkey') || '';
                        const option = $(elem).find('.js-basic-variant-input.js-ins-cancellation-min');
                        if (option.length > 0) {
                            tourists[i][groupId] = option.valString();
                            option.attr('checked', 'true');
                            const selectedVariant = option.closest('.js-basic-variant');
                            const container = option.closest('.js-basic-variants');
                            const variants = container.find('.js-basic-variant');
                            variants.removeClass('_active').slideDown();
                            selectedVariant.addClass('_active');
                            variants.not('._active').slideUp();
                        }
                    });
                }
                // сервисный сбор всегда включен
                const serviceFee = $('.js-service-fee', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")).find('.js-book-services-select');
                const serviceFeeGroupId = serviceFee.attr('data-groupkey') || '';
                const serviceFeeVal = serviceFee.find('.js-basic-variant-input').valString();
                if (serviceFeeGroupId.length > 0 && serviceFeeVal.length > 0) {
                    tourists[i][serviceFeeGroupId] = serviceFeeVal;
                }
            });
            if (tourists.length > 0) {
                yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getQuotes).call(this, tourists);
                __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
            }
        });
    }, _CruiseBookPage_onAviaGroupClick = function _CruiseBookPage_onAviaGroupClick(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const needDocument = data.needDocument;
            $('.js-person-document-number, .js-person-document-expirationdate', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).each((i, v) => {
                const block = $(v);
                $('.form-item', block).toggleClass('_required', needDocument);
                if (needDocument)
                    $('input', block).attr('required', 'required');
                else
                    $('input', block).removeAttr('required');
            });
            // const needIssueDate = needDocument && (this.#selectedFlight?.needIssueDate ?? false);
            const needIssueDate = needDocument && data.needIssueDate;
            $('.js-person-document-issuedate', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).each((i, v) => {
                const block = $(v);
                $('.form-item', block).toggleClass('_required', needIssueDate);
                if (needIssueDate)
                    $('input', block).attr('required', 'required');
                else
                    $('input', block).removeAttr('required');
            });
            const needMiddleName = data.needMiddleName;
            App.AviaResultComponent.initMiddleName(this.root, needMiddleName);
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onQuotesChange).call(this);
        });
    }, _CruiseBookPage_getBookContentDigestServices = function _CruiseBookPage_getBookContentDigestServices() {
        if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f") || __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").tourists.length === 0)
            return new Array();
        const services = {};
        // услуги: отель, круиз, сборы, страховка, виза
        __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").tourists.forEach(tourist => {
            tourist.appliedServices.forEach(value => {
                let index = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceOrder).call(_a, value.type);
                let service = null;
                let cruise = null;
                let hotel = null;
                if (value.type === 'cruise') {
                    cruise = {
                        shipName: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").ship.name,
                        cabinCategory: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").cabin.code,
                        cabinName: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").cabin.name,
                        cabinExperience: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").cabin.experience,
                        occupancy: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").occupancy,
                        pansion: localizer.meal,
                        beginDate: App.CruisePageBase.addDaysAndFormat(__classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").checkinDate, value.beginDay - 1),
                        duration: value.duration,
                        fare: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").fare,
                        isLuxeMode: this.options.isLuxeMode,
                        existRusGroup: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").existRusGroup,
                    };
                    index = value.beginDay;
                }
                else if (value.type === 'hotel') {
                    hotel = value.options[0].details.hotelDetail.hotelInfo;
                    index = value.beginDay;
                }
                else {
                    service = {
                        name: value.options[0].title,
                        duration: value.duration,
                        count: 1,
                        key: value.options[0].optionKey,
                    };
                }
                if (service == null && cruise == null && hotel == null)
                    return;
                const typeName = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, value.type);
                if (!services[index]) {
                    services[index] = {
                        key: value.type,
                        type: typeName.length > 0 ? typeName : value.options[0].title,
                        sortOrder: index,
                        groupIds: [value.groupKey],
                        daysBeforeFlight: 0,
                        packetFlights: [],
                        flights: null,
                        hotel,
                        cruise,
                        transfers: [],
                        services: service == null ? [] : [service],
                    };
                    return;
                }
                if (service) {
                    if (index === 0)
                        return;
                    const indexServiceCount = services[index].services.findIndex(v => v.key == value.options[0].optionKey);
                    if (!services[index].groupIds.includes(value.groupKey)) {
                        services[index].groupIds.push(value.groupKey);
                        services[index].services.push(service);
                    }
                    else {
                        if (indexServiceCount != -1)
                            services[index].services[indexServiceCount].count = services[index].services[indexServiceCount].count + 1;
                        else
                            services[index].services.push(service);
                    }
                }
            });
        });
        const beginDate = App.parseIsoDate(__classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").checkinDate);
        let aviaIndex = 0;
        // услуги: авиа, трансфер, экскурсия
        if (__classPrivateFieldGet(this, _CruiseBookPage_cruisePartsData, "f").length > 0) {
            __classPrivateFieldGet(this, _CruiseBookPage_cruisePartsData, "f").forEach(value => {
                const typeKey = value.serviceTypeKey;
                const type = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_geServiceTypeString).call(_a, typeKey);
                const index = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceOrder).call(_a, type);
                let service = null;
                let packetFlights = new Array();
                let transfer = null;
                if (type === 'avia') {
                    packetFlights = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getFlightService).call(this, value, aviaIndex);
                    ++aviaIndex;
                }
                else if (type === 'transfer') {
                    const transferPart = value;
                    transfer = {
                        beginDate: transferPart.beginDate,
                        byProgram: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_isNullOrEmpty).call(_a, transferPart.pickupPlace)
                            && __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_isNullOrEmpty).call(_a, transferPart.dropoffPlace),
                        transferDropoffPlace: transferPart.dropoffPlace,
                        transferPickupPlace: transferPart.pickupPlace,
                    };
                }
                else if (type === 'excursion') {
                    service = {
                        name: value.description,
                        duration: App.dateDiff(new App.XDate(App.parseIsoDate(value.beginDate)).trimTime(), new App.XDate(App.parseIsoDate(value.endDate)).trimTime()).getDays(),
                        count: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").occupancy.adults + __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").occupancy.children.length,
                    };
                }
                if (packetFlights.length === 0 && transfer == null && service == null)
                    return;
                if (!services[index]) {
                    services[index] = {
                        key: type,
                        type: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, type),
                        sortOrder: index,
                        groupIds: [0],
                        daysBeforeFlight: 0,
                        packetFlights: [],
                        flights: null,
                        hotel: null,
                        cruise: null,
                        transfers: [],
                        services: [],
                    };
                }
                if (service)
                    services[index].services.push(service);
                if (transfer)
                    services[index].transfers.push(transfer);
                if (packetFlights.length > 0) {
                    services[index].packetFlights = services[index].packetFlights.concat(packetFlights);
                    services[index].daysBeforeFlight = -Math.min(0, packetFlights != null && packetFlights.length > 0
                        ? App.dateDiff(new App.XDate(App.parseIsoDate(packetFlights[0].beginDate)).trimTime(), beginDate).getDays()
                        : 0);
                }
            });
        }
        // услуги: ДП
        const flightResults = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getFlightResults).call(this);
        if (flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) {
            const indexDynamicAvia = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceOrder).call(_a, 'dynamicAvia');
            const flightDate = App.parseIsoDate(flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight.variants[0].legs[0].date);
            services[indexDynamicAvia] = {
                key: 'dynamicAvia',
                type: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, 'dynamicAvia'),
                sortOrder: indexDynamicAvia,
                groupIds: [0],
                daysBeforeFlight: -Math.min(0, App.dateDiff(new App.XDate(flightDate).trimTime(), beginDate).getDays()),
                packetFlights: [],
                flights: __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getFlightService).call(this),
                hotel: null,
                cruise: null,
                transfers: [],
                services: [],
            };
        }
        // услуги: экскурсии
        if (__classPrivateFieldGet(this, _CruiseBookPage_checkActivities, "f") && __classPrivateFieldGet(this, _CruiseBookPage_activityTotalPrice, "f") > 0) {
            const indexActivity = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceOrder).call(_a, 'excursion');
            services[indexActivity] = {
                key: 'excursion',
                type: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, 'excursion'),
                sortOrder: indexActivity,
                groupIds: [0],
                daysBeforeFlight: 0,
                packetFlights: [],
                flights: null,
                hotel: null,
                cruise: null,
                transfers: [],
                services: [],
            };
            __classPrivateFieldGet(this, _CruiseBookPage_activitiesData, "f").forEach(el => {
                services[indexActivity].services.push({
                    name: this.options.activities[el.packetKey].list[el.key].title,
                    count: el.count,
                });
            });
        }
        return Object.values(services);
    }, _CruiseBookPage_getBookPriceDigestServices = function _CruiseBookPage_getBookPriceDigestServices() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c, _d, _e;
            const servicePricesMap = new Map();
            if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"))
                return [];
            __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").tourists.forEach(tourist => {
                tourist.appliedServices.forEach(value => {
                    let subType;
                    if (value.type === 'insurance')
                        subType = value.options[0].details.insuranceType;
                    if (value.type === 'tax.hsc')
                        subType = 'hsc';
                    let sortOrder = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceOrder).call(_a, value.type, subType);
                    if (value.type === 'cruise' || value.type === 'hotel') {
                        sortOrder = value.beginDay;
                    }
                    const key = value.type + (subType === 'cancellation' ? '-' : '');
                    const price = value.options[0].netPrice || value.options[0].grossCost;
                    const grossPrice = value.options[0].grossCost;
                    const priceByPerson = value.options[0].costByPerson;
                    const discount = grossPrice - price;
                    const service = servicePricesMap.get(value.groupKey);
                    const name = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, value.type, subType, 'digest');
                    if (service === undefined) {
                        servicePricesMap.set(value.groupKey, {
                            type: value.type,
                            nameDetails: '',
                            isBonus: false,
                            discount,
                            grossPrice,
                            name: name.length > 0 ? name : value.options[0].title,
                            price,
                            currency: __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f") ? __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency : '',
                            needCount: priceByPerson,
                            sortOrder: sortOrder,
                            key,
                        });
                    }
                    else {
                        if (service.needCount) {
                            service.price += price;
                            service.grossPrice += grossPrice;
                            service.discount += discount;
                        }
                    }
                });
            });
            const servicePrices = new Array();
            for (const value of servicePricesMap.values()) {
                const service = servicePrices.find(v => v.key == value.key);
                if (service === undefined) {
                    servicePrices.push(value);
                }
                else {
                    service.price += value.price;
                    service.grossPrice += value.grossPrice;
                    service.discount += value.discount;
                }
            }
            const flightResults = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getFlightResults).call(this);
            if (flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) {
                const flightGrossPrice = (_b = yield App.CurrencyManager.exchange(flightResults.selectedFlight.grossPrice, flightResults.selectedFlight.currency, __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency)) !== null && _b !== void 0 ? _b : 0;
                const flightPrice = (_c = yield App.CurrencyManager.exchange(flightResults.selectedFlight.price, flightResults.selectedFlight.currency, __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency)) !== null && _c !== void 0 ? _c : flightGrossPrice;
                servicePrices.push({
                    type: 'dynamicAvia',
                    name: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, 'dynamicAvia'),
                    price: flightPrice,
                    currency: __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency,
                    needCount: false,
                    sortOrder: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceOrder).call(_a, 'dynamicAvia'),
                    discount: flightGrossPrice - flightPrice,
                    grossPrice: flightGrossPrice,
                    isBonus: false,
                    nameDetails: '',
                });
            }
            if (__classPrivateFieldGet(this, _CruiseBookPage_checkActivities, "f") && __classPrivateFieldGet(this, _CruiseBookPage_activityTotalPrice, "f") > 0) {
                const activityGrossPrice = (_d = yield App.CurrencyManager.exchange(__classPrivateFieldGet(this, _CruiseBookPage_activityTotalPrice, "f"), this.options.activities[0].currency, __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency)) !== null && _d !== void 0 ? _d : 0;
                const activityPrice = (_e = yield App.CurrencyManager.exchange(__classPrivateFieldGet(this, _CruiseBookPage_activityTotalPrice, "f") - __classPrivateFieldGet(this, _CruiseBookPage_activityTotalCommision, "f"), this.options.activities[0].currency, __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency)) !== null && _e !== void 0 ? _e : 0;
                servicePrices.push({
                    type: 'excursion',
                    name: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, 'excursion'),
                    price: activityPrice,
                    currency: __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency,
                    needCount: false,
                    sortOrder: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceOrder).call(_a, 'excursion'),
                    discount: activityGrossPrice - activityPrice,
                    grossPrice: activityGrossPrice,
                    isBonus: false,
                    nameDetails: '',
                });
            }
            return servicePrices;
        });
    }, _CruiseBookPage_isNullOrEmpty = function _CruiseBookPage_isNullOrEmpty(value) {
        if (!value)
            return true;
        if (value.trim().length === 0)
            return true;
        return false;
    }, _CruiseBookPage_geServiceTypeString = function _CruiseBookPage_geServiceTypeString(typeKey) {
        switch (typeKey) {
            case 1:
                return 'hotel';
            case 2:
                return 'excursion';
            case 4:
                return 'transfer';
            case 5:
                return 'avia';
            default:
                return 'cruise';
        }
    }, _CruiseBookPage_getInsuranceTypeName = function _CruiseBookPage_getInsuranceTypeName(type) {
        switch (type) {
            case 'medical':
                return localizer.insuranceMedical;
            case 'accident':
                return localizer.insuranceAccident;
            case 'cancellation':
                return localizer.insuranceCancellation;
            case 'medical.ost':
                return localizer.insuranceMedicalOst;
            case 'savemoney':
                return localizer.insuranceSaveMoney;
            default:
                return '';
        }
    }, _CruiseBookPage_getServiceTypeName = function _CruiseBookPage_getServiceTypeName(type, subType, position) {
        switch (type) {
            case 'insurance':
                {
                    switch (subType) {
                        case 'cancellation':
                            return localizer.insuranceCancellation;
                        default:
                            return localizer.insurance;
                    }
                }
            case 'visa':
                return localizer.visa;
            case 'tax':
                {
                    switch (position) {
                        case 'digest':
                            return localizer.portTaxes;
                        default:
                            return localizer.tax;
                    }
                }
            case 'tax.hsc':
                {
                    switch (position) {
                        case 'digest':
                            return localizer.serviceCharge;
                        default:
                            return localizer.tax;
                    }
                }
            case 'msc.extra':
                return localizer.tarifExtraServices;
            case 'avia':
            case 'flight':
            case 'dynamicAvia':
            case 5:
                return localizer.avia;
            case 'transfer':
            case 4:
                return localizer.transfer;
            case 'excursion':
            case 2:
                return localizer.excursion;
            case 'cruise':
            case 8:
                return localizer.cruise;
            case 'hotel':
            case 1:
                return localizer.hotel;
            default:
                return '';
        }
    }, _CruiseBookPage_getServiceOrder = function _CruiseBookPage_getServiceOrder(type, subType) {
        switch (type) {
            case 'insurance':
                {
                    switch (subType) {
                        case 'cancellation':
                            return App.CruiseServiceOrder.InsuranceCancellation;
                        default:
                            return App.CruiseServiceOrder.Insurance;
                    }
                }
            case 'visa':
                return App.CruiseServiceOrder.Visa;
            case 'tax':
                return App.CruiseServiceOrder.PortTax;
            case 'tax.hsc':
                {
                    switch (subType) {
                        case 'hsc':
                            return App.CruiseServiceOrder.ServiceTax;
                        default:
                            return App.CruiseServiceOrder.PortTax;
                    }
                }
            case 'avia':
            case 'flight':
            case 5:
                return App.CruiseServiceOrder.Avia;
            case 'transfer':
            case 4:
                return App.CruiseServiceOrder.Transfer;
            case 'excursion':
            case 2:
                return App.CruiseServiceOrder.Excursion;
            case 'cruise':
            case 8:
                return App.CruiseServiceOrder.Cruise;
            case 'dynamicAvia':
                return App.CruiseServiceOrder.DynamicAvia;
            case 'hotel':
            case 1:
                return App.CruiseServiceOrder.Hotel;
            default:
                return 100;
        }
    }, _CruiseBookPage_getAvailableServicesByType = function _CruiseBookPage_getAvailableServicesByType(data, type, checkSelected = false) {
        if (!data || data.tourists.length === 0)
            return [];
        const result = [];
        data.availableServices.forEach(service => {
            if (service.type === type) {
                service.typeRus = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getServiceTypeName).call(_a, service.type);
                if (type === 'insurance')
                    service.subTypeRus = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getInsuranceTypeName).call(_a, service.options[0].details.insuranceType);
                if (checkSelected) {
                    const tservice = data.tourists[0].appliedServices.find(val => val.groupKey === service.groupKey);
                    if (tservice) {
                        service.options.forEach(val => {
                            val.details.selected = false;
                            if (val.optionKey === tservice.options[0].optionKey)
                                val.details.selected = true;
                        });
                    }
                }
                result.push(service);
            }
        });
        return result;
    }, _CruiseBookPage_generateFlightTags = function _CruiseBookPage_generateFlightTags(item) {
        const result = new Array();
        const nextDayArrival = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_nextDayArrival).call(_a, item.beginDate, item.endDate);
        if (nextDayArrival)
            result.push(['day-before', 'Вылет накануне']);
        return result;
    }, _CruiseBookPage_nextDayArrival = function _CruiseBookPage_nextDayArrival(beginDate, endDate) {
        return App.parseIsoDate(beginDate).getDate() !== App.parseIsoDate(endDate).getDate();
    }, _CruiseBookPage_getFlightService = function _CruiseBookPage_getFlightService(charterFlight, index) {
        const result = new Array();
        if (charterFlight) {
            result.push({
                beginDate: charterFlight.beginDate,
                endDate: charterFlight.endDate,
                nextDayArrival: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_nextDayArrival).call(_a, charterFlight.beginDate, charterFlight.endDate),
                flight: {
                    departureCityKey: 0,
                    departureCityName: charterFlight.departureCity ? charterFlight.departureCity.name : '',
                    departureAirportCode: charterFlight.portFrom,
                    departureTerminal: '',
                    arrivalCityKey: 0,
                    arrivalCityName: charterFlight.arrivalCity ? charterFlight.arrivalCity.name : '',
                    arrivalAirportCode: charterFlight.portTo,
                    arrivalTerminal: '',
                    airlineCode: charterFlight.airline ? charterFlight.airline.code : '',
                    flightNumber: charterFlight.flightNumber.toString(),
                },
                serviceClassCode: '',
                serviceClassName: '',
                hasMoreVariants: false,
                tags: index == 0 ? __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_generateFlightTags).call(_a, charterFlight) : undefined,
                transferCount: 0,
            });
        }
        else {
            const flightResults = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getFlightResults).call(this);
            if ((flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) == null)
                return result;
            const selectedFlight = flightResults.selectedFlight;
            return selectedFlight.variants[0].legs
                .map((v, i) => ({
                beginDate: v.date,
                endDate: v.endDate,
                nextDayArrival: __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_nextDayArrival).call(_a, v.date, v.endDate),
                flight: {
                    departureCityKey: v.segments[0].cityKey,
                    departureCityName: v.segments[0].cityName,
                    departureAirportCode: v.segments[0].airportCode,
                    departureTerminal: '',
                    arrivalCityKey: v.segments[v.segments.length - 1].endCityKey,
                    arrivalCityName: v.segments[v.segments.length - 1].endCityName,
                    arrivalAirportCode: v.segments[v.segments.length - 1].endAirportCode,
                    arrivalTerminal: '',
                    airlineCode: v.segments[0].airlineCode,
                    flightNumber: v.segments[0].flightNumber,
                },
                serviceClassCode: v.segments[0].serviceClass,
                serviceClassName: v.segments[0].serviceClass,
                hasMoreVariants: selectedFlight.hasMoreVariants,
                tags: i <= 0 ? selectedFlight.tags : undefined,
                transferCount: v.segments.length - 1,
                wayTime: v.wayTime,
            }));
        }
        return result;
    }, _CruiseBookPage_getFlightResults = function _CruiseBookPage_getFlightResults() {
        var _b;
        return (_b = __classPrivateFieldGet(this, _CruiseBookPage_aviaResultComponent, "f")) === null || _b === void 0 ? void 0 : _b.getResults();
    }, _CruiseBookPage_getCruiseParts = function _CruiseBookPage_getCruiseParts() {
        const cruiseParts = {};
        __classPrivateFieldGet(this, _CruiseBookPage_cruisePartsData, "f").forEach(v => {
            // TODO: костыль.
            const type = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_geServiceTypeString).call(_a, v.serviceTypeKey);
            if (cruiseParts[type] == null)
                cruiseParts[type] = [];
            cruiseParts[type].push(v);
        });
        return cruiseParts;
    }, _CruiseBookPage_getHotelsInfo = function _CruiseBookPage_getHotelsInfo(services) {
        const result = [];
        // TODO группировать по категории
        services.forEach(service => {
            const hotels = [];
            service.options.forEach(option => {
                if (!option.details.hotelDetail)
                    return;
                const key = option.details.hotelDetail.hotelInfo.masterKey;
                const roomKey = option.details.hotelDetail.hotelInfo.roomMasterKey;
                const pansionKey = option.details.hotelDetail.hotelInfo.pansionMasterKey;
                const { selected } = option.details;
                const { hotelInfo } = option.details.hotelDetail;
                const board = {
                    key: pansionKey,
                    value: hotelInfo.hotel.pansion,
                    selected,
                };
                const room = {
                    key: roomKey,
                    value: `${hotelInfo.hotel.roomAccommodation}, ${hotelInfo.hotel.roomType} ${hotelInfo.hotel.roomCategory}`,
                    selected,
                    boards: [board],
                };
                const currentHotel = hotels.find(value => value.key === key);
                // есть такой элемент => добавляем размещение
                if (currentHotel) {
                    const currentRoom = currentHotel.rooms.find(value => value.key === roomKey);
                    // есть такой элемент => добавляем питание
                    if (currentRoom)
                        currentRoom.boards.push(board);
                    else
                        currentHotel.rooms.push(room);
                }
                else {
                    hotels.push({
                        key: hotelInfo.masterKey,
                        value: hotelInfo.hotel.name,
                        rooms: [room],
                        city: hotelInfo.hotel.address,
                        category: hotelInfo.hotel.category,
                    });
                }
            });
            hotels.forEach(hotel => {
                hotel.rooms.forEach(room => {
                    room.boards = App.CruisePageBase.uniqArray(room.boards, ['key']);
                });
            });
            App.CruisePageBase.sortArray(hotels, 'category');
            result[service.beginDay] = hotels;
        });
        return result;
    }, _CruiseBookPage_getHotelServices = function _CruiseBookPage_getHotelServices(services, selectedDefault = false) {
        services.forEach(value => {
            const selected = value.options.find(option => option.details.selected);
            if (selected) {
                value.options = [selected];
            }
            else {
                const first = value.options.shift() || {};
                value.options = [first];
            }
            const hServ = __classPrivateFieldGet(this, _CruiseBookPage_hotelsInfo, "f")[value.beginDay] || null;
            if (hServ) {
                value.allowEdit = hServ.length > 1;
                let hotel;
                if (value.options[0].details.hotelDetail)
                    hotel = hServ.find(service => service.key === value.options[0].details.hotelDetail.hotelInfo.masterKey);
                if (hotel) {
                    value.options[0].details.hotelDetail.rooms = new App.SelectListModel({
                        name: 'rooms',
                        form: true,
                        autocomplete: false,
                        items: hotel.rooms
                            .map((room, index) => ({
                            value: room.key.toString(),
                            text: room.value,
                            selected: selectedDefault ? index === 0 : room.selected,
                        })),
                    });
                    value.options[0].details.hotelDetail.boards = new App.SelectListModel({
                        name: 'boards',
                        form: true,
                        autocomplete: false,
                        items: hotel.rooms[0].boards.map((board, index) => ({
                            value: board.key.toString(),
                            text: board.value,
                            selected: selectedDefault ? index === 0 : board.selected,
                        })),
                    });
                    value.allowEditPlacement = hotel.rooms.length > 1 || hotel.rooms[0].boards.length > 1;
                }
            }
        });
        return services;
    }, _CruiseBookPage_changeHotelServicesSelected = function _CruiseBookPage_changeHotelServicesSelected(services, hotelKey, index) {
        services.forEach(service => {
            service.options.forEach(option => {
                option.details.selected = false;
            });
        });
        const needService = services.find(value => value.beginDay === index);
        if (!needService)
            return services;
        needService.options.forEach(option => {
            if (option.details.hotelDetail != null && option.details.hotelDetail.hotelInfo.masterKey === hotelKey)
                option.details.selected = true;
        });
        return services;
    }, _CruiseBookPage_prepareDataForGetQuotes = function _CruiseBookPage_prepareDataForGetQuotes(tourists = []) {
        const data = App.CruisePageBase.convertArrayToRequestData(this.options.searchData);
        data.CruiseKey = __classPrivateFieldGet(this, _CruiseBookPage_cruiseId, "f").toString();
        data.FareCode = __classPrivateFieldGet(this, _CruiseBookPage_fareCode, "f");
        data.CategoryKey = __classPrivateFieldGet(this, _CruiseBookPage_cabinCategoryKey, "f").toString();
        if (tourists.length === 0)
            return data;
        const birthdayInputs = $('.form-item', $('.js-form-order')).not('._invalid').find('.js-form-date.js-person-birthday');
        // serializeArray не работает с полями disabled
        // TODO: разобаться, зачем вот это, не нашла когда даты disabled
        const disabled = $('.js-form-order').find('.js-form-date:disabled').removeAttr('disabled');
        const birthdays = birthdayInputs.serializeArray();
        disabled.attr('disabled', 'disabled');
        // TODO: разобаться, зачем вот это
        for (let touristIndex = 0; touristIndex < tourists.length; touristIndex++) {
            const tourist = tourists[touristIndex];
            const services = Object.entries(tourist);
            for (let serviceIndex = 0; serviceIndex < services.length; serviceIndex++) {
                const [groupKey, groupValue] = services[serviceIndex];
                data[`ServicesGroup[${touristIndex}].Services[${serviceIndex}].GroupKey`] = groupKey;
                data[`ServicesGroup[${touristIndex}].Services[${serviceIndex}].OptionKey`] = groupValue;
            }
            // services[0].Tourist.Birthday  services[1].Tourist.Birthday
            const birthday = birthdays.find(v => v.name === `services[${touristIndex}].Tourist.Birthday`);
            if (birthday && birthday.value.length > 0)
                data[`ServicesGroup[${touristIndex}].Birthday`] = birthday.value;
        }
        return data;
    }, _CruiseBookPage_prepareDataForBook = function _CruiseBookPage_prepareDataForBook() {
        const elements = $('.js-form-order', $('.js-cruise-book')).serializeArray();
        let data = elements.concat(this.options.searchData);
        if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"))
            return data;
        __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").tourists.forEach((tourist, index) => {
            tourist.appliedServices.forEach(service => {
                data.push({ name: `services[${index}].services[]`, value: `${service.groupKey}_${service.options[0].optionKey}` });
            });
        });
        if (this.context)
            data.push({ name: 'context', value: this.context });
        // data = $.grep(data, v => v.value != null && v.value !== '');
        data = data.filter(v => v.value != null && v.value !== '');
        return data;
    }, _CruiseBookPage_initPlacement = function _CruiseBookPage_initPlacement(services) {
        __classPrivateFieldSet(this, _CruiseBookPage_hotelsInfo, __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getHotelsInfo).call(_a, services), "f");
        const hotelServices = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getHotelServices).call(this, services);
        const block = $(App.templates.Cruise.Book.ServiceHotelBlockMain({
            hotelServices,
            cruiseParts: __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getCruiseParts).call(this),
            hotelsList: __classPrivateFieldGet(this, _CruiseBookPage_hotelsInfo, "f"),
        }));
        $('.js-cruise-services-block-main-step1', $(__classPrivateFieldGet(this, _CruiseBookPage_bookWrapClass, "f"))).append(block);
        $('.js-filter-select-block', $('.js-cruise-services-block-main-step1')).each((i, v) => {
            __classPrivateFieldGet(this, _CruiseBookPage_controls, "f").push(new App.FilterSelectBlock({ root: $(v) }));
        });
        __classPrivateFieldSet(this, _CruiseBookPage_orderPlacement, $('.js-order-placement', this.root), "f");
        __classPrivateFieldSet(this, _CruiseBookPage_placementHotels, $('.js-order-placement-hotels', __classPrivateFieldGet(this, _CruiseBookPage_orderPlacement, "f")), "f");
        // Выбираем новый отель вместо старого.
        __classPrivateFieldGet(this, _CruiseBookPage_placementHotels, "f").on('click', '.js-order-placement-hotels-btn', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onHotelChange).call(this, e); }));
        // Изменить тип номера.
        __classPrivateFieldGet(this, _CruiseBookPage_orderPlacement, "f").on('change', '.js-placement-hotel-room .js-jelect', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onHotelRoomChange).call(this, e); }));
        // Изменить тип питания.
        __classPrivateFieldGet(this, _CruiseBookPage_orderPlacement, "f").on('change', '.js-placement-hotel-food .js-jelect', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onHotelBoardChange).call(this, e); }));
        // Выбор другого отеля
        __classPrivateFieldGet(this, _CruiseBookPage_orderPlacement, "f").on('click', '.js-order-placement-hotel-edit', e => __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_onHotelEditClick).call(_a, e));
    }, _CruiseBookPage_checkActivityDateCommon = function _CruiseBookPage_checkActivityDateCommon(container, checked) {
        // чекбоксы у туристов
        const items = container.parents('.js-options-set').find('.js-options-set-item');
        const itemsActive = items.not(':disabled');
        itemsActive.each((index, el) => {
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_checkActivityDate).call(_a, $(el), checked);
        });
        // общие чекбоксы
        const parent = container.parents('.js-cruise-activity-packet');
        const date = container.parents('.js-options-set').attr('data-date');
        const els = $(`.js-options-set[data-date="${date}"]`, parent)
            .find('.js-options-set-toggle')
            .not(container);
        if (checked) {
            if (itemsActive.length === items.length) {
                els.attr('disabled', 'disabled');
                els.parents('.js-options-set').addClass('_disabled');
            }
        }
        else {
            els.removeAttr('disabled');
            els.parents('.js-options-set').removeClass('_disabled');
        }
    }, _CruiseBookPage_checkActivityDate = function _CruiseBookPage_checkActivityDate(container, checked) {
        // чекбоксы у туристов
        const parent = container.parents('.js-cruise-activity-packet');
        const person = container.parents('.js-person-options-initials').attr('data-target');
        const date = container.parents('.js-options-set').attr('data-date');
        const els = $(`.js-options-set[data-date="${date}"]`, parent)
            .find(`.js-person-options-initials[data-target="${person}"]`)
            .find('.js-order-options-input')
            .not(container);
        if (checked) {
            els.attr('disabled', 'disabled');
            els.parents('.js-options-set').addClass('_disabled');
        }
        else {
            els.removeAttr('disabled');
            els.parents('.js-options-set').removeClass('_disabled');
        }
        // общие чекбоксы
        const currentCommonCheckbox = container.parents('.js-options-set').find('.js-options-set-toggle');
        const commonCheckboxes = $(`.js-options-set[data-date="${date}"]`, parent)
            .find('.js-options-set-toggle')
            .not(currentCommonCheckbox);
        commonCheckboxes.each((index, el) => {
            const items = $(el).parents('.js-options-set').find('.js-options-set-item');
            const itemsActive = items.not(':disabled');
            if (checked) {
                if (itemsActive.length === items.length || itemsActive.length === 0)
                    commonCheckboxes.attr('disabled', 'disabled');
            }
            else {
                commonCheckboxes.removeAttr('disabled');
            }
        });
    }, _CruiseBookPage_selectedOptionsChanged = function _CruiseBookPage_selectedOptionsChanged(container) {
        var _b, _c, _d;
        const isGroup = Number((_b = container.attr('data-group')) !== null && _b !== void 0 ? _b : '1');
        const adults = $('.js-options-set-adult .js-order-options-input', container).filter(':checked, ._checked').not(':disabled');
        const adultCount = adults.length;
        const adultServiceKey = (_c = adults.eq(0).attr('data-key')) !== null && _c !== void 0 ? _c : '';
        const adultPriceData = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getActivityTotalPrice).call(this, Number(adultServiceKey), adultCount, isGroup == 1);
        const adultPrice = adultPriceData[0];
        const adultCommision = adultPriceData[1];
        const childs = $('.js-options-set-child .js-order-options-input', container).filter(':checked, ._checked').not(':disabled');
        const childCount = childs.length;
        const childServiceKey = (_d = childs.eq(0).attr('data-key')) !== null && _d !== void 0 ? _d : '';
        const childPriceData = isGroup == 0 ? [0, 0] : __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getActivityTotalPrice).call(this, Number(childServiceKey), childCount, isGroup == 1);
        const childPrice = childPriceData[0];
        const childCommision = childPriceData[1];
        __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_saveActivityChangedData).call(this, container, adults.length + childs.length);
        const totalPrice = adultPrice + childPrice;
        const totalCommision = adultCommision + childCommision;
        const elTotal = container.find('.js-options-set-total');
        elTotal.attr('data-price', totalPrice);
        elTotal.attr('data-commision', totalCommision);
        elTotal.toggleClass('_zero', totalPrice === 0);
        elTotal.find(App.Money.tagName).get(0).amount = totalPrice;
        let priceTotal = 0;
        let commisionTotal = 0;
        $('.js-options-set', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).find('.js-options-set-total').each((index, el) => {
            const price = $(el).attr('data-price');
            const commision = $(el).attr('data-commision');
            if (price) {
                priceTotal += Number(price);
                commisionTotal += Number(commision);
            }
        });
        priceTotal = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_applyActivityPacketDiscount).call(this, priceTotal);
        __classPrivateFieldSet(this, _CruiseBookPage_activityTotalPrice, priceTotal, "f");
        __classPrivateFieldSet(this, _CruiseBookPage_activityTotalCommision, commisionTotal, "f");
        $('.js-order-options-total', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).get(0).amount = priceTotal;
    }, _CruiseBookPage_saveActivityChangedData = function _CruiseBookPage_saveActivityChangedData(container, count) {
        const packetKey = Number(container.attr('data-packet-key'));
        const activityKey = Number(container.attr('data-key'));
        const index = __classPrivateFieldGet(this, _CruiseBookPage_activitiesData, "f").findIndex(val => val.packetKey === packetKey && val.key === activityKey);
        if (count === 0) {
            if (index > -1)
                __classPrivateFieldGet(this, _CruiseBookPage_activitiesData, "f").splice(index, 1);
            return;
        }
        const data = {
            packetKey,
            key: activityKey,
            count,
        };
        if (index > -1)
            __classPrivateFieldGet(this, _CruiseBookPage_activitiesData, "f")[index] = data;
        else
            __classPrivateFieldGet(this, _CruiseBookPage_activitiesData, "f").push(data);
    }, _CruiseBookPage_applyActivityPacketDiscount = function _CruiseBookPage_applyActivityPacketDiscount(totalPrice) {
        /* уточнить у Жени по поводу скидки на пакеты, где невозможно выбрать все экскурсии */
        const adultCount = this.options.offer.adults;
        const childCount = this.options.offer.children.length;
        const discountBlock = $('.js-block-discount', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f"));
        discountBlock.hide();
        let discount = 0;
        $('.js-cruise-activity-packet', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).each((index, el) => {
            const discountAd = Number($(el).attr('data-discount-adult'));
            const discountCh = Number($(el).attr('data-discount-child'));
            const countExcur = $(el).find('.js-options-set').length;
            for (let i = 0; i < adultCount; ++i) {
                const elements = $(`.js-person-options-initials[data-target=person${i}]`).find(':checked');
                if (elements.length >= countExcur)
                    discount += discountAd;
            }
            for (let j = adultCount; j < adultCount + childCount; ++j) {
                const elements = $(`.js-person-options-initials[data-target=person${j}]`).find(':checked');
                if (elements.length >= countExcur)
                    discount += discountCh;
            }
        });
        if (discount > 0) {
            $('.js-block-discount-total', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).get(0).amount = discount;
            discountBlock.show();
        }
        return totalPrice - discount;
    }, _CruiseBookPage_getActivityTotalPrice = function _CruiseBookPage_getActivityTotalPrice(key, personCount, isGroup) {
        let price = 0;
        let commission = 0;
        this.options.activities.every(a => a.list.every(l => {
            const op = l.options.find(o => o.id === key);
            if (op) {
                price = op.price;
                commission = op.commission;
                return false;
            }
            return true;
        }));
        return [isGroup ? price * personCount : price, isGroup ? commission * personCount : commission];
    }, _CruiseBookPage_getDigestData = function _CruiseBookPage_getDigestData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"))
                return null;
            const services = yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getBookPriceDigestServices).call(this);
            let grossPrice = __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.charges.totalGrossPriceAmount;
            let netPrice = 0;
            let discount = 0;
            services.forEach(v => {
                netPrice += v.price;
                discount += v.discount;
            });
            const flightResults = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getFlightResults).call(this);
            if (flightResults === null || flightResults === void 0 ? void 0 : flightResults.selectedFlight) {
                const avia = services.find(v => v.type === 'dynamicAvia');
                if (avia)
                    grossPrice += avia.grossPrice;
            }
            if (__classPrivateFieldGet(this, _CruiseBookPage_checkActivities, "f") && __classPrivateFieldGet(this, _CruiseBookPage_activityTotalPrice, "f") > 0) {
                const activity = services.find(v => v.type === 'excursion');
                if (activity)
                    grossPrice += activity.grossPrice;
            }
            return {
                servicePrices: Enumerable.from(services)
                    .where(v => v.price !== 0)
                    .orderBy(v => v.sortOrder)
                    .select(v => ({
                    name: v.name,
                    isBonus: false,
                    nameDetails: '',
                    grossPrice: v.grossPrice,
                    discount: v.discount,
                    price: v.price,
                    currencyCode: v.currency,
                }))
                    .toArray(),
                grossPrice,
                discount,
                price: netPrice,
                currencyCode: __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").priceInfo.currency,
                hasDetails: true,
                pricePresenter: {
                    type: this.pricePresenter.type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                notes: [],
                isLuxeMode: this.options.isLuxeMode,
                cruiseUrl: this.options.cruiseUrl,
                cruiseTitle: this.options.cruiseTitle,
                hasAction: this.options.hasAction,
                checkinDate: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").checkinDate,
                checkoutDate: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").checkoutDate,
                adultCount: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").occupancy.adults,
                childCount: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").occupancy.children.length,
                nightsTotal: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").nightsTotal,
                services: Enumerable.from(__classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getBookContentDigestServices).call(this))
                    .orderBy(v => v.sortOrder)
                    .toArray(),
                cancellationPolicy: __classPrivateFieldGet(this, _CruiseBookPage_currentCabin, "f").cancellationPolicy,
            };
        });
    }, _CruiseBookPage_updateDigest = function _CruiseBookPage_updateDigest(data) {
        const digest = $('.js-digest', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f"));
        const containerContent = $('.js-digest-content', digest);
        containerContent.empty();
        const contentContent = $(App.templates.Cruise.Book.BookDigestContent(data));
        containerContent.append(contentContent);
        const containerFooter = $('.js-digest-footer', this.root);
        containerFooter.empty();
        const contentFooter = $(App.templates.BookDigestFooter(data));
        containerFooter.append(contentFooter);
        // Обновляем размеры дайджеста.
        $(document).trigger("digest:update" /* Events.DigestUpdate */);
        $('.js-steps-final__total-price').find(App.Money.tagName).get(0).amount = data.grossPrice;
    }, _CruiseBookPage_focusFirstInvalidField = function _CruiseBookPage_focusFirstInvalidField() {
        const invalidField = __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").find('._invalid').first();
        const step = invalidField.closest('.js-form-step-content').index();
        if (step >= 0)
            __classPrivateFieldGet(this, _CruiseBookPage_formBook, "f").steps.show(step);
        const tab = invalidField.closest('.js-person-tab-wrap');
        if (tab.length) {
            const tabs = tab.closest('.js-persons-tabs');
            tabs.find('.js-person-tab').eq(tab.index()).trigger('click');
        }
        const position = __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").find('.js-persons-tabs').offset();
        $('html, body').animate({ scrollTop: position ? position.top : 0 }, 'slow');
        setTimeout(() => { invalidField.trigger('focus'); }, 1000);
    }, _CruiseBookPage_getQuotes = function _CruiseBookPage_getQuotes() {
        return __awaiter(this, arguments, void 0, function* (tourists = []) {
            const data = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_prepareDataForGetQuotes).call(this, tourists);
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            const xhr = $.ajax({
                url: this.options.urls.getQuotes,
                method: 'POST',
                data,
            });
            let success = false;
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.quotes)
                    __classPrivateFieldSet(this, _CruiseBookPage_quotesData, response.data.quotes, "f");
                this.expirationPopup = App.scheduleExpirationPopup({
                    interval: response.data.dataExpiration,
                    url: this.options.urls.searchRoutes,
                });
                success = true;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            return success;
        });
    }, _CruiseBookPage_changeHotelPlacement = function _CruiseBookPage_changeHotelPlacement(event, room, board) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"))
                return;
            const target = $(event.currentTarget);
            const hotelKey = Number(target.closest('.js-order-placement-hotel').attr('data-hotelkey'));
            const id = Number(target.closest('.js-order-placement-hotel').attr('data-idx'));
            const hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getAvailableServicesByType).call(_a, __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"), 'hotel');
            let optionFind;
            hotelServices.forEach(value => {
                if (value.beginDay === id) {
                    optionFind = value.options.find(option => {
                        const { hotelInfo } = option.details.hotelDetail;
                        return hotelInfo.masterKey === hotelKey && hotelInfo.pansionMasterKey === board && hotelInfo.roomMasterKey === room;
                    });
                }
            });
            if (optionFind) {
                target.closest('.js-order-placement-hotel').attr('data-optionkey', optionFind.optionKey);
                yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onServiceChange).call(this);
            }
        });
    }, _CruiseBookPage_book = function _CruiseBookPage_book() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_prepareDataForBook).call(this);
            const xhr = $.ajax({
                url: this.options.urls.book,
                method: 'POST',
                data,
            });
            __classPrivateFieldSet(this, _CruiseBookPage_popupGroup, __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.Booking({}),
                modal: true,
            }), "f");
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response)) {
                    // TODO Titov: костыль пока из process не будут возвращаться конкретные коды классов ошибок (ValidationError, MessageError, etc).
                    __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_focusFirstInvalidField).call(this);
                    return;
                }
                if (response.data.note.length > 0) {
                    __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPage_popupGroup, "f"));
                    __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").show({
                        group: '',
                        content: App.templates.Cruise.Messages.BookingNote({
                            note: response.data.note,
                            url: response.data.url,
                        }),
                        modal: true,
                    });
                }
                return;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPage_popupGroup, "f"));
            }
        });
    }, _CruiseBookPage_checkBaseOrder = function _CruiseBookPage_checkBaseOrder(target, order) {
        return __awaiter(this, void 0, void 0, function* () {
            const elements = $('.js-form-order', $('.js-cruise-book')).serializeArray();
            const data = App.CruisePageBase.convertArrayToRequestData(elements);
            const xhr = $.ajax({
                url: this.options.urls.checkBaseOrder,
                method: 'POST',
                data: {
                    orderCode: order,
                    lastName: data['services[0].Tourist.Lastname'] || '',
                    name: data['services[0].Tourist.Firstname'] || '',
                    birthday: data['services[0].Tourist.Birthday'] || '',
                },
                beforeSend: () => {
                    // После получения ответа эта штука заменится вместе со всем контентом
                    $('.js-progress-data-loading', target).show();
                },
                complete: () => {
                    // После получения ответа эта штука заменится вместе со всем контентом
                    $('.js-progress-data-loading', target).hide();
                },
            });
            const response = yield xhr;
            if (!this.responseValidator.process(response)) {
                // TODO Titov: костыль пока из process не будут возвращаться конкретные коды классов ошибок (ValidationError, MessageError, etc).
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '#checkBaseOrder', $('.js-baseOrderWrap', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")), 'Произошла ошибка.Попробуйте еще раз позднее.');
                return;
            }
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_baseOrderWrap, "f"), response.data.errorText);
            if (!response.data.error) {
                __classPrivateFieldSet(this, _CruiseBookPage_isVaucherOrderChecked, true, "f");
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_baseOrderWrap, "f"), true);
                __classPrivateFieldSet(this, _CruiseBookPage_baseOrder, order, "f");
            }
        });
    }, _CruiseBookPage_checkClubCard = function _CruiseBookPage_checkClubCard(personTab, cardNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const elements = $('.js-form-order', $('.js-cruise-book')).serializeArray();
            const data = App.CruisePageBase.convertArrayToRequestData(elements);
            const personIndex = Number(personTab.attr('data-personindex'));
            const xhr = $.ajax({
                url: this.options.urls.checkClubCard,
                method: 'POST',
                data: {
                    cardNumber,
                    lastName: data[`services[${personIndex}].Tourist.Lastname`] || '',
                    name: data[`services[${personIndex}].Tourist.Firstname`] || '',
                    birthday: data[`services[${personIndex}].Tourist.Birthday`] || '',
                },
                beforeSend: () => {
                    $('.js-progress-data-loading', personTab).show();
                },
                complete: () => {
                    $('.js-progress-data-loading', personTab).hide();
                },
            });
            const response = yield xhr;
            if (!this.responseValidator.process(response)) {
                // TODO Titov: костыль пока из process не будут возвращаться конкретные коды классов ошибок (ValidationError, MessageError, etc).
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '.checkClubCard', personTab, 'Произошла ошибка. Попробуйте еще раз позднее.');
                return;
            }
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '.checkClubCard', personTab, response.data.errorText);
            if (!response.data.error) {
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, true);
                const success = {
                    number: cardNumber,
                    isChecked: true,
                };
                __classPrivateFieldGet(this, _CruiseBookPage_clubCardData, "f")[personIndex] = success;
            }
        });
    }, _CruiseBookPage_toggleCheckerError = function _CruiseBookPage_toggleCheckerError(selector, wrap, text = '') {
        const errorEl = $(`${selector}Error`, wrap);
        if (text.length > 0) {
            errorEl.html(text);
            App.CruisePageBase.show(errorEl);
        }
        else {
            App.CruisePageBase.hide(errorEl);
        }
    }, _CruiseBookPage_toggleCheckerSuccess = function _CruiseBookPage_toggleCheckerSuccess(selector, wrap, show) {
        const errorEl = $(`${selector}Success`, wrap);
        if (show) {
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, `${selector}Error`, wrap);
            App.CruisePageBase.show(errorEl);
        }
        else {
            App.CruisePageBase.hide(errorEl);
        }
    }, _CruiseBookPage_onServiceVariantSelect = function _CruiseBookPage_onServiceVariantSelect(event) {
        const target = $(event.currentTarget);
        const selectedVariant = target.closest('.js-basic-variant');
        const container = target.closest('.js-basic-variants');
        const slide = !container.hasClass('js-not-slide-variants');
        const variants = container.find('.js-basic-variant');
        const showMore = container.find('.js-show-more-variants');
        variants.removeClass('_active');
        selectedVariant.addClass('_active');
        if (slide)
            variants.not('._active').slideUp();
        showMore.removeClass('_unfolded');
        showMore.addClass('_folded');
        showMore.slideDown();
    }, _CruiseBookPage_onServiceChange = function _CruiseBookPage_onServiceChange() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"))
                return;
            const tourists = [];
            __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f").tourists.forEach((value, i) => {
                tourists[i] = {};
                // для всех туристов
                $('.js-order-placement-hotel', __classPrivateFieldGet(this, _CruiseBookPage_orderPlacement, "f"))
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).attr('data-optionkey') || '';
                    tourists[i][groupId] = optionId;
                });
                $('.js-service-fee', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f"))
                    .find('.js-book-services-select')
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).find('.js-basic-variant-input:checked').valString();
                    tourists[i][groupId] = optionId;
                });
                // для каждого туристов
                $('.js-order-insurance-standard', $(`.js-person-tab-wrap[data-tab="person${i}"]`))
                    .find('.js-book-services-checkbox:checked')
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).attr('data-optionkey') || '';
                    tourists[i][groupId] = optionId;
                });
                $('.js-service-insurance', $(`.js-person-tab-wrap[data-tab="person${i}"]`))
                    .find('.js-book-services-select')
                    .each((index, elem) => {
                    const groupId = $(elem).attr('data-groupkey') || '';
                    const optionId = $(elem).find('.js-basic-variant-input:checked').valString();
                    tourists[i][groupId] = optionId;
                });
            });
            __classPrivateFieldSet(this, _CruiseBookPage_popupGroup, __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Valuating({}),
                modal: true,
            }), "f");
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getQuotes).call(this, tourists);
            __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f").trigger("quotes:change" /* Events.QuotesChange */);
            __classPrivateFieldGet(this, _CruiseBookPage_popup, "f").hide(__classPrivateFieldGet(this, _CruiseBookPage_popupGroup, "f"));
        });
    }, _CruiseBookPage_onQuotesChange = function _CruiseBookPage_onQuotesChange() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getDigestData).call(this);
            if (data)
                __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_updateDigest).call(this, data);
            return true;
        });
    }, _CruiseBookPage_onDeckChange = function _CruiseBookPage_onDeckChange(event) {
        event.preventDefault();
        if (__classPrivateFieldGet(this, _CruiseBookPage_availableCabinsData, "f").length === 0)
            return;
        const deckKey = $(event.currentTarget).find('input').val();
        const cabins = __classPrivateFieldGet(this, _CruiseBookPage_availableCabinsData, "f").find(value => value.deckKey === Number(deckKey));
        if (!cabins)
            return;
        const data = cabins.cabins
            .map((v, i) => ({
            value: v.cabinNo.toString(),
            text: `Каюта №${v.cabinNo}`,
            selected: i === 0,
        }));
        const control = __classPrivateFieldGet(this, _CruiseBookPage_bookFilter, "f").findControl('cabinNo');
        if (control)
            control.replaceOptions(data, false);
        const target = $(event.currentTarget);
        target.trigger("cruiseSvgLoader:deckChange" /* Events.CruiseSvgLoaderDeckChange */, cabins.deckNumber);
    }, _CruiseBookPage_onCabinChange = function _CruiseBookPage_onCabinChange(event) {
        var _b, _c, _d, _e;
        const cabin = Number($(event.currentTarget).find('input').val());
        $('[id^="cabins_"] ._active, [id^="numbers_"] ._active', __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f")).removeClass('_current');
        $(`[id^="cabin${cabin}_"], [id^="numbers_"] text:contains("${cabin}")`, __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f")).addClass('_current');
        const el = $('#pac_msc_liner_schema_deck_mini #cabins_deckMini ._current').first(), wnd = $('#pac_msc_liner_deck_zoom_catch').first();
        const e_x = ((_b = el.offset()) === null || _b === void 0 ? void 0 : _b.left) || 0, e_y = ((_c = el.offset()) === null || _c === void 0 ? void 0 : _c.top) || 0, w_x = ((_d = wnd === null || wnd === void 0 ? void 0 : wnd.offset()) === null || _d === void 0 ? void 0 : _d.left) || 0, w_y = ((_e = wnd === null || wnd === void 0 ? void 0 : wnd.offset()) === null || _e === void 0 ? void 0 : _e.top) || 0;
        const pos = {
            offsetX: e_x - w_x /* + rect.width / 2 */,
            offsetY: e_y - w_y /* + rect.height / 2 */,
        };
        wnd.trigger($.Event('mousedown', pos));
        wnd.trigger($.Event('mouseup', pos));
    }, _CruiseBookPage_onSvgLayerCabinClick = function _CruiseBookPage_onSvgLayerCabinClick(event) {
        event.preventDefault();
        if ($(event.currentTarget).hasClass('_current'))
            return;
        const cabin = $(event.currentTarget).attr('data-svg-cabin');
        const control = __classPrivateFieldGet(this, _CruiseBookPage_bookFilter, "f").findControl('cabinNo');
        if (control && cabin) {
            if (cabin != control.getValue())
                control.setValue(cabin);
        }
        $('[id^="cabins_"] ._active, [id^="numbers_"] ._active', __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f")).removeClass('_current');
        $(`[id^="cabin${cabin}_"], [id^="numbers_"] text:contains("${cabin}")`, __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f")).addClass('_current');
    }, _CruiseBookPage_onSvgLayerLoaded = function _CruiseBookPage_onSvgLayerLoaded() {
        __classPrivateFieldGet(this, _CruiseBookPage_availableCabinsData, "f").forEach(d => {
            d.cabins.forEach((c, index) => {
                let classCss = '_active ';
                classCss += d.cabins.length == 1 ? '_current' : (index == 0 ? '_current' : '');
                $(`[id^="cabin${c.cabinNo}_"], [id^="numbers_"] text:contains("${c.cabinNo}")`, __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f"))
                    .addClass(classCss)
                    .attr('data-svg-cabin', `${c.cabinNo}`);
            });
        });
        $('#cabins_deckFull ._active, #numbers_deckFull ._active', __classPrivateFieldGet(this, _CruiseBookPage_svgLoaderClass, "f")).on('click', e => __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onSvgLayerCabinClick).call(this, e));
        $('.js-cabins', __classPrivateFieldGet(this, _CruiseBookPage_bookWrap, "f")).trigger("filter:change" /* Events.FilterChange */);
    }, _CruiseBookPage_onPersonTabClick = function _CruiseBookPage_onPersonTabClick(event) {
        const target = $(event.currentTarget);
        const tabs = $(event.currentTarget).closest('.js-persons-tabs');
        const tab = $('.js-person-tab', tabs);
        const wrap = $('.js-person-tab-wrap', tabs);
        const next = $('.js-person-tab-next', tabs);
        tab.removeClass('_active');
        target.addClass('_active');
        wrap.removeClass('_active').eq(target.index()).addClass('_active');
        // Прячем кнопку 'Следующий турист'.
        next.toggleClass('_hidden', wrap.length - 1 === target.index());
    }, _CruiseBookPage_onBookButtonClick = function _CruiseBookPage_onBookButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_checkBookForm).call(this))
                return;
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _CruiseBookPage_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_book).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_book).call(this);
            }
        });
    }, _CruiseBookPage_checkBookForm = function _CruiseBookPage_checkBookForm() {
        if (!__classPrivateFieldGet(this, _CruiseBookPage_formBook, "f").validator.form()) {
            __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_focusFirstInvalidField).call(this);
            return false;
        }
        const useVaucher = $('#useVoucher', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).val() === 'true';
        if (useVaucher && __classPrivateFieldGet(this, _CruiseBookPage_baseOrder, "f") && !__classPrivateFieldGet(this, _CruiseBookPage_isVaucherOrderChecked, "f")) {
            return false;
        }
        if (__classPrivateFieldGet(this, _CruiseBookPage_clubCardData, "f")) {
            const personErrorCard = __classPrivateFieldGet(this, _CruiseBookPage_clubCardData, "f").findIndex(el => el.number > 0 && !el.isChecked);
            if (personErrorCard !== -1) {
                $('.js-clubCardNumber', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).eq(personErrorCard).closest('.form-item').addClass('_invalid');
                __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_focusFirstInvalidField).call(this);
                return false;
            }
        }
        const flights = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getAvailableServicesByType).call(_a, __classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"), 'flight');
        if (__classPrivateFieldGet(this, _CruiseBookPage_hasDynamicFlights, "f") > 0 || flights.length > 0)
            return __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_checkPassengerUnique).call(this);
        return true;
    }, _CruiseBookPage_checkPassengerUnique = function _CruiseBookPage_checkPassengerUnique() {
        const passengers = __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f").find('.js-passenger').toArray();
        const passengerStrings = passengers.map(bookingItem => {
            const fieldValues = $(bookingItem)
                .find('[data-type="lastname"],[data-type="firstname"],[data-type="middlename"],[data-type="birthday"]')
                .toArray()
                .map(element => $(element).valString().trim().toUpperCase());
            return fieldValues.join('|');
        });
        if (passengers.length === new Set(passengerStrings).size) {
            return true;
        }
        App.popupShow($(`<p><b>${localizer.touristDuplicateError}</b></p>`));
        return false;
    }, _CruiseBookPage_onFioChange = function _CruiseBookPage_onFioChange(event) {
        const target = $(event.currentTarget);
        // изменение текста на Uppercase
        target.val(App.transliterateName(target.valString()));
        // инициалы
        const container = target.closest('.js-person-tab-wrap');
        const id = container.attr('data-tab');
        const initials = container.closest('.js-persons-tabs').find(`[data-target="${id}"] .initials`);
        const lastName = container.find('.js-person-tab-initials-b').valString();
        const firstName = container.find('.js-person-tab-initials-a').valString();
        const birthday = container.find('.js-person-birthday').datepicker('getDate');
        const currentAge = (birthday ? App.getAge(birthday, App.parseIsoDate(this.options.quotes.tourDate)) : null);
        const text = (lastName != null && lastName.length > 0 ? lastName[0] : '?') + (firstName != null && firstName.length > 0 ? firstName[0] : '?');
        const ageTitle = currentAge ? `, ${currentAge} ${App.pluralRu(currentAge, 'год', 'года', 'лет')}` : '';
        const title = `${lastName} ${firstName}${ageTitle}`;
        initials.text(text);
        __classPrivateFieldGet(this, _CruiseBookPage_optionsSet, "f").find(`[data-target=${id}]`).find('.initials')
            .text(text)
            .attr('title', title);
    }, _CruiseBookPage_onShowMoreVariants = function _CruiseBookPage_onShowMoreVariants(event) {
        const target = $(event.currentTarget);
        const container = target.closest('.js-basic-variants');
        const inactive = container.find('.js-basic-variant').not('._active');
        if (target.hasClass('_folded')) {
            inactive.slideDown();
            target.removeClass('_folded');
            target.addClass('_unfolded');
            target.slideUp();
        }
    }, _CruiseBookPage_initTouristDocumentMask = function _CruiseBookPage_initTouristDocumentMask(personContainer) {
        const documentInput = $('.js-person-document-number .js-form-item-field', personContainer);
        const citizenshipKey = $('.js-person-citizenship .js-jelect-input', personContainer).valNumber();
        const mask = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getDocumentNumberMask).call(_a, citizenshipKey, this.options.externalCountryKey);
        $('.js-person-document-type', personContainer).val(mask.type);
        documentInput.inputmask(mask.inputmask);
    }, _CruiseBookPage_changeTouristDocumentMask = function _CruiseBookPage_changeTouristDocumentMask(e) {
        const target = $(e.currentTarget);
        const personContainer = target.closest('.js-person-tab-wrap');
        __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_initTouristDocumentMask).call(this, personContainer);
    }, _CruiseBookPage_getDocumentNumberMask = function _CruiseBookPage_getDocumentNumberMask(citizenshipCountryKey, countryKey) {
        var _b, _c;
        // TODO Titov: перенести в ConfigController.Settings.
        const defaultMask = { type: 'Passport', inputmask: { mask: '*{6,18}', autoUnmask: true, greedy: false } };
        const maskRules = {
            // RU
            460: {
                // паспорт
                213151: {
                    type: 'Passport',
                    inputmask: {
                        mask: '9999-999999',
                        autoUnmask: true,
                    },
                },
                // загранпаспорт
                0: {
                    type: 'ForeignPassport',
                    inputmask: {
                        mask: '99-9999999',
                        autoUnmask: true,
                    },
                },
            },
        };
        if (!citizenshipCountryKey)
            return defaultMask;
        const maskRule = maskRules[citizenshipCountryKey];
        if (!maskRule)
            return defaultMask;
        if (!countryKey)
            return (_b = maskRule[0]) !== null && _b !== void 0 ? _b : defaultMask;
        const rule = maskRule[countryKey];
        if (!rule)
            return (_c = maskRule[0]) !== null && _c !== void 0 ? _c : defaultMask;
        return rule;
    }, _CruiseBookPage_onHotelEditClick = function _CruiseBookPage_onHotelEditClick(event) {
        const target = $(event.currentTarget);
        const placementHotel = target.closest('.js-order-placement-hotel');
        const hotelKey = Number(placementHotel.attr('data-hotelkey'));
        const index = Number(placementHotel.attr('data-idx'));
        placementHotel.hide();
        const placementHotels = placementHotel.parent().find(`.js-order-placement-hotels[data-idx=${index}]`);
        placementHotels.slideDown();
        placementHotels.find('.js-order-placement-hotels-item').removeClass('_active');
        placementHotels.find('.js-spoiler-content').hide();
        placementHotels
            .find(`.js-order-placement-hotels-btn[data-hotelkey=${hotelKey}]`)
            .closest('.js-order-placement-hotels-item')
            .addClass('_active')
            .closest('.js-spoiler-content')
            .show();
    }, _CruiseBookPage_onHotelChange = function _CruiseBookPage_onHotelChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f"))
                return;
            const target = $(event.currentTarget);
            const hotelKey = parseInt(target.attr('data-hotelkey') || '', 10);
            const index = parseInt(target.closest('.js-order-placement-hotels').attr('data-idx') || '', 10);
            const groupContainer = target.closest('.js-order-placement-item');
            const placementHotels = $('.js-order-placement-hotels', groupContainer);
            let placementHotel = $(`.js-order-placement-hotel[data-idx='${index}']`, groupContainer);
            const data = JSON.parse(JSON.stringify(__classPrivateFieldGet(this, _CruiseBookPage_quotesData, "f")));
            let hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getAvailableServicesByType).call(_a, data, 'hotel');
            if (hotelServices.length > 0)
                __classPrivateFieldSet(this, _CruiseBookPage_hotelsInfo, __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_getHotelsInfo).call(_a, hotelServices), "f");
            hotelServices = __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_changeHotelServicesSelected).call(_a, hotelServices, hotelKey, index);
            hotelServices = __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getHotelServices).call(this, hotelServices, true);
            const dataTplHotelBlockMain = {
                hotel: hotelServices.find(v => v.beginDay === index) || hotelServices[0],
                cruiseParts: __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getCruiseParts).call(this),
            };
            placementHotels.hide();
            placementHotel.replaceWith(App.templates.Cruise.Book.HotelBlockMain(dataTplHotelBlockMain));
            placementHotel = $(`.js-order-placement-hotel[data-idx='${index}']`, groupContainer);
            placementHotel.show();
            placementHotel.find('.js-filter-select-block').each((i, v) => {
                __classPrivateFieldGet(this, _CruiseBookPage_controls, "f").push(new App.FilterSelectBlock({ root: $(v) }));
            });
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_onServiceChange).call(this);
        });
    }, _CruiseBookPage_onHotelBoardChange = function _CruiseBookPage_onHotelBoardChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const room = Number(__classPrivateFieldGet(this, _CruiseBookPage_orderPlacement, "f").find('[data-select="HotelRoom"] input').val());
            const board = Number($(event.currentTarget).find('input').val());
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_changeHotelPlacement).call(this, event, room, board);
        });
    }, _CruiseBookPage_onHotelRoomChange = function _CruiseBookPage_onHotelRoomChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const board = Number(__classPrivateFieldGet(this, _CruiseBookPage_orderPlacement, "f").find('[data-select="HotelFood"] input').val());
            const room = Number($(event.currentTarget).find('input').val());
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_changeHotelPlacement).call(this, event, room, board);
        });
    }, _CruiseBookPage_onSwitcherClick = function _CruiseBookPage_onSwitcherClick(event) {
        const isOn = $(event.currentTarget).find('input').val() === 'true';
        $('#baseOrder', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).prop('disabled', !isOn);
        if (isOn) {
            $('#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).show();
        }
        else {
            $('#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f")).hide();
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_baseOrderWrap, "f"));
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_baseOrderWrap, "f"), false);
        }
    }, _CruiseBookPage_onBaseOrderChange = function _CruiseBookPage_onBaseOrderChange() {
        __classPrivateFieldSet(this, _CruiseBookPage_isVaucherOrderChecked, false, "f");
    }, _CruiseBookPage_onCheckBaseOrderClick = function _CruiseBookPage_onCheckBaseOrderClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_baseOrderWrap, "f"));
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '#checkBaseOrder', __classPrivateFieldGet(this, _CruiseBookPage_baseOrderWrap, "f"), false);
            const baseOrderEl = $('#baseOrder', __classPrivateFieldGet(this, _CruiseBookPage_formOrder, "f"));
            baseOrderEl.closest('.form-item').removeClass('_invalid');
            const checkedValue = baseOrderEl.val();
            if (!checkedValue) {
                baseOrderEl.closest('.form-item').addClass('_invalid');
                return;
            }
            __classPrivateFieldSet(this, _CruiseBookPage_baseOrder, checkedValue, "f");
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_checkBaseOrder).call(this, target, __classPrivateFieldGet(this, _CruiseBookPage_baseOrder, "f"));
        });
    }, _CruiseBookPage_onFioPhoneChange = function _CruiseBookPage_onFioPhoneChange(event) {
        const personTab = $(event.currentTarget).closest('.js-person-tab-wrap');
        const personIndex = Number(personTab.attr('data-personindex'));
        const findEmptyVal = $('.js-needForClubCard', personTab).toArray().findIndex(el => $(el).val() === '');
        $('.js-clubCardNumber', personTab).prop('disabled', findEmptyVal !== -1);
        if (findEmptyVal === -1) {
            $('.js-checkClubCard', personTab).show();
        }
        else {
            $('.js-clubCardNumber', personTab).val('');
            $('.js-checkClubCard', personTab).hide();
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '.checkClubCard', personTab);
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
            __classPrivateFieldGet(this, _CruiseBookPage_clubCardData, "f")[personIndex] = {
                number: 0,
                isChecked: false,
            };
        }
    }, _CruiseBookPage_onClubCardNumberChange = function _CruiseBookPage_onClubCardNumberChange(event) {
        const personTab = $(event.currentTarget).closest('.js-person-tab-wrap');
        const personIndex = Number(personTab.attr('data-personindex'));
        __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '.checkClubCard', personTab);
        __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
        const checkedValue = $(event.currentTarget).val();
        __classPrivateFieldGet(this, _CruiseBookPage_clubCardData, "f")[personIndex] = {
            number: !checkedValue ? 0 : checkedValue,
            isChecked: false,
        };
    }, _CruiseBookPage_onCheckClubCardClick = function _CruiseBookPage_onCheckClubCardClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const personTab = $(event.currentTarget).closest('.js-person-tab-wrap');
            const personIndex = Number(personTab.attr('data-personindex'));
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '.checkClubCard', personTab);
            __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
            const cardEl = $('.js-clubCardNumber', personTab);
            const checkedValue = cardEl.val();
            if (!checkedValue) {
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerSuccess).call(_a, '.checkClubCard', personTab, false);
                __classPrivateFieldGet(_a, _a, "m", _CruiseBookPage_toggleCheckerError).call(_a, '.checkClubCard', personTab, 'Укажите корректный номер карты');
                return;
            }
            __classPrivateFieldGet(this, _CruiseBookPage_clubCardData, "f")[personIndex] = {
                number: checkedValue,
                isChecked: false,
            };
            yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_checkClubCard).call(this, personTab, __classPrivateFieldGet(this, _CruiseBookPage_clubCardData, "f")[personIndex].number);
        });
    }, _CruiseBookPage_onBookPrivateClick = function _CruiseBookPage_onBookPrivateClick() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = (yield __classPrivateFieldGet(this, _CruiseBookPage_instances, "m", _CruiseBookPage_getDigestData).call(this)) || {};
                pac.api.FormClientRequest({
                    url: window.location.href,
                    data,
                });
            }
            catch (ex) {
                console.warn(ex);
            }
        });
    }, _CruiseBookPage_switchSvgLoaderLegend = function _CruiseBookPage_switchSvgLoaderLegend(event) {
        event.preventDefault();
        const legendWrap = $(event.currentTarget).parent();
        const legendBlock = $('.js-ship-svg-legend', legendWrap);
        const isOpen = legendWrap.hasClass('_open');
        if (isOpen) {
            legendWrap.removeClass('_open');
            legendBlock.hide();
            $(event.currentTarget).find('.pseudo-link').html(localizer.showSvgDetails);
        }
        else {
            legendWrap.addClass('_open');
            legendBlock.show();
            $(event.currentTarget).find('.pseudo-link').html(localizer.hideSvgDetails);
        }
    };
    App.CruiseBookPage = CruiseBookPage;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseGroupPage_instances, _a, _CruiseGroupPage_form, _CruiseGroupPage_filter, _CruiseGroupPage_popup, _CruiseGroupPage_onChangeSpinner, _CruiseGroupPage_changeTotalCabinsInRow, _CruiseGroupPage_changeTotalCabinsInCol, _CruiseGroupPage_changeTotalCabins, _CruiseGroupPage_onFilterSubmit;
    class CruiseGroupPage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-page .js-app-container-content' }, options));
            _CruiseGroupPage_instances.add(this);
            _CruiseGroupPage_form.set(this, void 0);
            _CruiseGroupPage_filter.set(this, void 0);
            _CruiseGroupPage_popup.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseGroupPage_filter, new App.CruiseGroupMainFilter({
                root: '.js-cruise-group-filter',
                urls: this.options.urls,
                checkin: this.options.checkin,
            }), "f");
            __classPrivateFieldSet(this, _CruiseGroupPage_form, new App.Form({ root: __classPrivateFieldGet(this, _CruiseGroupPage_filter, "f").root }), "f");
            this.validator = __classPrivateFieldGet(this, _CruiseGroupPage_filter, "f").root.validate({ ignore: '.filter-slider-input' });
            __classPrivateFieldSet(this, _CruiseGroupPage_popup, new App.Popup(), "f");
            this.responseValidator = new App.ResponseValidatorOld({
                messenger: new App.BlockMessenger(new App.Messages({ root: '.js-messages-sendMail' })),
                validator: __classPrivateFieldGet(this, _CruiseGroupPage_form, "f").validator,
            });
            $('.js-price-custom').inputmask({ mask: '9', repeat: 7, greedy: false });
            $('.spinner').inputmask({ mask: '9', repeat: 2, greedy: false });
            $('.spinner').spinner({
                min: 0,
            });
            $('.spinner').on('spinstop', e => __classPrivateFieldGet(this, _CruiseGroupPage_instances, "m", _CruiseGroupPage_onChangeSpinner).call(this, e));
            __classPrivateFieldGet(this, _CruiseGroupPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseGroupPage_instances, "m", _CruiseGroupPage_onFilterSubmit).call(this); }));
        }
    }
    _a = CruiseGroupPage, _CruiseGroupPage_form = new WeakMap(), _CruiseGroupPage_filter = new WeakMap(), _CruiseGroupPage_popup = new WeakMap(), _CruiseGroupPage_instances = new WeakSet(), _CruiseGroupPage_onChangeSpinner = function _CruiseGroupPage_onChangeSpinner(event) {
        if (__classPrivateFieldGet(this, _CruiseGroupPage_filter, "f") == null)
            return;
        const target = $(event.currentTarget);
        const indexTd = target.parents('td').attr('data-index_td') || '';
        const indexTr = target.parents('tr').attr('data-index_tr') || '';
        __classPrivateFieldGet(_a, _a, "m", _CruiseGroupPage_changeTotalCabinsInRow).call(_a, indexTr);
        __classPrivateFieldGet(_a, _a, "m", _CruiseGroupPage_changeTotalCabinsInCol).call(_a, indexTd);
        __classPrivateFieldGet(_a, _a, "m", _CruiseGroupPage_changeTotalCabins).call(_a);
    }, _CruiseGroupPage_changeTotalCabinsInRow = function _CruiseGroupPage_changeTotalCabinsInRow(indexRow) {
        const row = $('.js-group-matrix table').find(`tr[data-index_tr='${indexRow}']`);
        const container = $('.totalTR', row);
        let val = 0;
        row.find('.spinner').each((i, el) => {
            val += $(el).spinner('value');
        });
        container.html(val.toString());
    }, _CruiseGroupPage_changeTotalCabinsInCol = function _CruiseGroupPage_changeTotalCabinsInCol(indexCol) {
        const cols = $('.js-group-matrix table').find(`td[data-index_td='${indexCol}']`);
        const container = $(`.totalTD[data-index_td='${indexCol}']`, '.js-group-matrix table');
        let val = 0;
        cols.find('.spinner').each((i, el) => {
            val += $(el).spinner('value');
        });
        container.html(val.toString());
    }, _CruiseGroupPage_changeTotalCabins = function _CruiseGroupPage_changeTotalCabins() {
        const containers = $('.totalTD', '.js-group-matrix table');
        let val = 0;
        containers.each((i, el) => {
            val += Number($(el).html());
        });
        $('.totalCount', '.js-group-matrix table').html(val.toString());
        $('.totalCountInput', '.js-group-matrix table').val(val.toString());
    }, _CruiseGroupPage_onFilterSubmit = function _CruiseGroupPage_onFilterSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseGroupPage_form, "f").validator.form())
                return;
            $('.js-m-filter-submit', '.js-cruise-group-filter').attr('disabled', 'disabled');
            const data = $('.js-cruise-group-filter', $('.js-cruise-page')).serializeArray();
            for (let i = 0; i < data.length; ++i) {
                if (data[i].name === 'Cabins[]' || data[i].name === 'CustomPrices[]') {
                    if (data[i].value === '')
                        data[i].value = '0';
                }
            }
            const xhr = $.ajax({
                url: this.options.urls.sendGroupMail,
                method: 'POST',
                dataType: 'json',
                data,
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseGroupPage_filter, "f").reset();
                $('.js-m-filter-submit', '.js-cruise-group-filter').removeAttr('disabled');
                __classPrivateFieldGet(this, _CruiseGroupPage_popup, "f").show({
                    group: 'filter',
                    content: App.templates.Cruise.Messages.GroupRequest({}),
                    modal: false,
                    delay: 500,
                });
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
        });
    };
    App.CruiseGroupPage = CruiseGroupPage;
})(App || (App = {}));
var App;
(function (App) {
    var _CruisePortPageMobile_instances, _a, _CruisePortPageMobile_portFilter, _CruisePortPageMobile_portResult, _CruisePortPageMobile_portTabs, _CruisePortPageMobile_portWrapClass, _CruisePortPageMobile_portHotFilterClass, _CruisePortPageMobile_portMainFilterClass, _CruisePortPageMobile_searchResultsWrap, _CruisePortPageMobile_portId, _CruisePortPageMobile_popup, _CruisePortPageMobile_offers, _CruisePortPageMobile_onClickTab, _CruisePortPageMobile_renderPortResults, _CruisePortPageMobile_prepareDataForPortSearch, _CruisePortPageMobile_searchPortRoutes, _CruisePortPageMobile_onPortFilterSearch, _CruisePortPageMobile_onServiceFeeSwitch;
    class CruisePortPageMobile extends App.CruisePageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-port' }, options));
            _CruisePortPageMobile_instances.add(this);
            _CruisePortPageMobile_portFilter.set(this, void 0);
            _CruisePortPageMobile_portResult.set(this, void 0);
            _CruisePortPageMobile_portTabs.set(this, void 0);
            _CruisePortPageMobile_portWrapClass.set(this, void 0);
            _CruisePortPageMobile_portHotFilterClass.set(this, void 0);
            _CruisePortPageMobile_portMainFilterClass.set(this, void 0);
            _CruisePortPageMobile_searchResultsWrap.set(this, void 0);
            _CruisePortPageMobile_portId.set(this, void 0);
            _CruisePortPageMobile_popup.set(this, void 0);
            _CruisePortPageMobile_offers.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruisePortPageMobile_popup, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            __classPrivateFieldSet(this, _CruisePortPageMobile_portWrapClass, '.js-cruise-port', "f");
            __classPrivateFieldSet(this, _CruisePortPageMobile_portHotFilterClass, '.js-port-hot-filter', "f");
            __classPrivateFieldSet(this, _CruisePortPageMobile_portMainFilterClass, '.js-port-main-filter', "f");
            this.scrollBookLink = $('.js-scroll-book-link', this.root);
            this.bookScrollToWrap = $('.js-book-to-scroll', this.root);
            __classPrivateFieldSet(this, _CruisePortPageMobile_searchResultsWrap, $('.js-port-search-results', this.root), "f");
            this.states = {
                'port': {
                    handler: () => __classPrivateFieldGet(this, _CruisePortPageMobile_instances, "m", _CruisePortPageMobile_renderPortResults).call(this),
                    actionName: 'port',
                    keysForUrl: ['ship', 'fare', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruisePortPageMobile_portId, Number($('#portId').val()), "f");
            // инициализация формы поиска
            __classPrivateFieldSet(this, _CruisePortPageMobile_portFilter, new App.CruisePortMainFilterMobile({
                root: __classPrivateFieldGet(this, _CruisePortPageMobile_portMainFilterClass, "f"),
                urls: this.options.urls,
                defaults: this.options.defaults,
                changes: this.options.changes,
                checkin: this.options.checkin,
                portId: __classPrivateFieldGet(this, _CruisePortPageMobile_portId, "f"),
                peopleOptions: {
                    maxChildAge: App.app.settings.cruiseOptions.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: App.app.settings.cruiseOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.cruiseOptions.defaultCheckinDateInterval,
                    maxDateToOffset: App.app.settings.cruiseOptions.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: App.app.settings.cruiseOptions.minPrice,
                    max: App.app.settings.cruiseOptions.maxPrice,
                },
            }), "f");
            this.validator = __classPrivateFieldGet(this, _CruisePortPageMobile_portFilter, "f").root.validate({ ignore: '' });
            this.responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            this.components.push(new App.Digest({ container: this.root }));
            __classPrivateFieldSet(this, _CruisePortPageMobile_portResult, new App.CruisePortResult({
                root: '.js-placement-output',
                hotFilter: new App.CruisePortHotFilterMobile({
                    root: __classPrivateFieldGet(this, _CruisePortPageMobile_portHotFilterClass, "f"),
                }),
            }), "f");
            __classPrivateFieldGet(this, _CruisePortPageMobile_portFilter, "f").portFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruisePortPageMobile_instances, "m", _CruisePortPageMobile_onPortFilterSearch).call(this); }));
            // инициализация фоток
            this.components.push(new App.MediaGalleryMobile());
            // событие на клик по табу добавляем перед инициализацией табов
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _CruisePortPageMobile_instances, "m", _CruisePortPageMobile_onClickTab).call(this, e));
            // инициализация табов
            __classPrivateFieldSet(this, _CruisePortPageMobile_portTabs, new App.Tabs({ self: __classPrivateFieldGet(this, _CruisePortPageMobile_portWrapClass, "f") }), "f");
            __classPrivateFieldGet(this, _CruisePortPageMobile_portTabs, "f").showActive();
            // прилипание/отлипание ссылки 'к бронированию'
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => this.onScrollDescrBlock()));
            $('.js-filter-service-fee', __classPrivateFieldGet(this, _CruisePortPageMobile_searchResultsWrap, "f")).on('click', e => __classPrivateFieldGet(_a, _a, "m", _CruisePortPageMobile_onServiceFeeSwitch).call(_a, e));
        }
    }
    _a = CruisePortPageMobile, _CruisePortPageMobile_portFilter = new WeakMap(), _CruisePortPageMobile_portResult = new WeakMap(), _CruisePortPageMobile_portTabs = new WeakMap(), _CruisePortPageMobile_portWrapClass = new WeakMap(), _CruisePortPageMobile_portHotFilterClass = new WeakMap(), _CruisePortPageMobile_portMainFilterClass = new WeakMap(), _CruisePortPageMobile_searchResultsWrap = new WeakMap(), _CruisePortPageMobile_portId = new WeakMap(), _CruisePortPageMobile_popup = new WeakMap(), _CruisePortPageMobile_offers = new WeakMap(), _CruisePortPageMobile_instances = new WeakSet(), _CruisePortPageMobile_onClickTab = function _CruisePortPageMobile_onClickTab(event) {
        if ($(event.currentTarget).attr('id') === 'placementTab') {
            if (!__classPrivateFieldGet(this, _CruisePortPageMobile_offers, "f") || __classPrivateFieldGet(this, _CruisePortPageMobile_offers, "f").length === 0)
                (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruisePortPageMobile_instances, "m", _CruisePortPageMobile_renderPortResults).call(this); }))();
        }
    }, _CruisePortPageMobile_renderPortResults = function _CruisePortPageMobile_renderPortResults() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageMobileBase.hide($(__classPrivateFieldGet(this, _CruisePortPageMobile_searchResultsWrap, "f")));
            if (!(yield __classPrivateFieldGet(this, _CruisePortPageMobile_instances, "m", _CruisePortPageMobile_searchPortRoutes).call(this)))
                return;
            App.CruisePageMobileBase.show($(__classPrivateFieldGet(this, _CruisePortPageMobile_searchResultsWrap, "f")));
            this.saveState('port', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruisePortPageMobile_portFilter, "f").portFilter), true);
        });
    }, _CruisePortPageMobile_prepareDataForPortSearch = function _CruisePortPageMobile_prepareDataForPortSearch() {
        var _b;
        let elements = __classPrivateFieldGet(this, _CruisePortPageMobile_portFilter, "f").filters.serializeArray();
        const priceValue = (_b = elements.find(x => x.name == 'price')) === null || _b === void 0 ? void 0 : _b.value;
        elements = elements.filter(x => x.name != 'price');
        elements.push({
            name: 'Price.From',
            value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[0],
        });
        elements.push({
            name: 'Price.To',
            value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[1],
        });
        const currencyFilter = $('.filter_price_currency');
        if (currencyFilter) {
            elements.push({
                name: currencyFilter.attr('name'),
                value: currencyFilter.attr('value'),
            });
        }
        const city = elements.find(x => x.name == 'City');
        if (city && !city.value) {
            city.value = '0';
        }
        const data = App.CruisePageMobileBase.convertArrayToRequestData(elements);
        data.port = __classPrivateFieldGet(this, _CruisePortPageMobile_portId, "f").toString();
        return data;
    }, _CruisePortPageMobile_searchPortRoutes = function _CruisePortPageMobile_searchPortRoutes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.searchExecuting)
                return false;
            this.searchExecuting = true;
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            __classPrivateFieldGet(this, _CruisePortPageMobile_portResult, "f").resetDataSource();
            const data = __classPrivateFieldGet(this, _CruisePortPageMobile_instances, "m", _CruisePortPageMobile_prepareDataForPortSearch).call(this);
            if (this.context)
                data.context = this.context;
            const xhr = $.ajax({
                url: this.options.urls.searchRoutes,
                method: 'POST',
                data,
            });
            let returnS = false;
            const popupGroup = __classPrivateFieldGet(this, _CruisePortPageMobile_popup, "f").show({
                group: 'main',
                content: App.templates.Cruise.Messages.Searching({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null)
                    this.updateSeo(response.data.seo);
                if (response.data.offers && response.data.offers.length > 0) {
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: this.options.urls.searchRoutes,
                    });
                    response.data.offers.forEach(v => {
                        v.route = App.CruisePageBase.abbreviateMulti(v.routeElements.map(z => z.value).join(', '), 75, '...');
                        v.portsDeparture = v.portDepartureElements.map(z => z.value).join(', ');
                        v.isPGManager = this.options.isPGManager;
                    });
                    __classPrivateFieldSet(this, _CruisePortPageMobile_offers, response.data.offers, "f");
                    yield __classPrivateFieldGet(this, _CruisePortPageMobile_portResult, "f").changeDataSource(__classPrivateFieldGet(this, _CruisePortPageMobile_offers, "f"));
                    returnS = true;
                }
                else {
                    __classPrivateFieldGet(this, _CruisePortPageMobile_portResult, "f").resetDataSource();
                }
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                this.searchExecuting = false;
                __classPrivateFieldGet(this, _CruisePortPageMobile_popup, "f").hide(popupGroup);
            }
            return returnS;
        });
    }, _CruisePortPageMobile_onPortFilterSearch = function _CruisePortPageMobile_onPortFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _CruisePortPageMobile_portTabs, "f").show('placement');
            yield __classPrivateFieldGet(this, _CruisePortPageMobile_instances, "m", _CruisePortPageMobile_renderPortResults).call(this);
        });
    }, _CruisePortPageMobile_onServiceFeeSwitch = function _CruisePortPageMobile_onServiceFeeSwitch(event) {
        const target = $(event.currentTarget);
        const filterFeeBtn = target.find('.js-sliding-btn');
        const serviceFee = $('.js-service-fee', '.js-port-route-output');
        if (filterFeeBtn.hasClass('_on')) {
            serviceFee.removeClass('_off');
            serviceFee.find('.js-serviceFee_text').showByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').hideByClass();
        }
        else {
            serviceFee.addClass('_off');
            serviceFee.find('.js-serviceFee_text').hideByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').showByClass();
        }
    };
    App.CruisePortPageMobile = CruisePortPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _CruisePortPage_instances, _a, _CruisePortPage_portFilter, _CruisePortPage_portResult, _CruisePortPage_portTabs, _CruisePortPage_portWrapClass, _CruisePortPage_portHotFilterClass, _CruisePortPage_portMainFilterClass, _CruisePortPage_searchResultsWrap, _CruisePortPage_portId, _CruisePortPage_popup2, _CruisePortPage_offers, _CruisePortPage_onClickTab, _CruisePortPage_renderPortResults, _CruisePortPage_prepareDataForPortSearch, _CruisePortPage_searchPortRoutes, _CruisePortPage_onPortFilterSearch, _CruisePortPage_onServiceFeeSwitch;
    class CruisePortPage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-port' }, options));
            _CruisePortPage_instances.add(this);
            _CruisePortPage_portFilter.set(this, void 0);
            _CruisePortPage_portResult.set(this, void 0);
            _CruisePortPage_portTabs.set(this, void 0);
            _CruisePortPage_portWrapClass.set(this, void 0);
            _CruisePortPage_portHotFilterClass.set(this, void 0);
            _CruisePortPage_portMainFilterClass.set(this, void 0);
            _CruisePortPage_searchResultsWrap.set(this, void 0);
            _CruisePortPage_portId.set(this, void 0);
            _CruisePortPage_popup2.set(this, void 0);
            _CruisePortPage_offers.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruisePortPage_popup2, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            __classPrivateFieldSet(this, _CruisePortPage_portWrapClass, '.js-cruise-port', "f");
            __classPrivateFieldSet(this, _CruisePortPage_portHotFilterClass, '.js-port-hot-filter', "f");
            __classPrivateFieldSet(this, _CruisePortPage_portMainFilterClass, '.js-port-main-filter', "f");
            this.scrollBookLink = $('.js-scroll-book-link', this.root);
            this.bookScrollToWrap = $('.js-book-to-scroll', this.root);
            __classPrivateFieldSet(this, _CruisePortPage_searchResultsWrap, $('.js-port-search-results', this.root), "f");
            this.states = {
                'port': {
                    handler: () => __classPrivateFieldGet(this, _CruisePortPage_instances, "m", _CruisePortPage_renderPortResults).call(this),
                    actionName: 'port',
                    keysForUrl: ['ship', 'fare', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruisePortPage_portId, Number($('#portId').val()), "f");
            // инициализация формы поиска
            __classPrivateFieldSet(this, _CruisePortPage_portFilter, new App.CruisePortMainFilter({
                root: __classPrivateFieldGet(this, _CruisePortPage_portMainFilterClass, "f"),
                urls: this.options.urls,
                defaults: this.options.defaults,
                changes: this.options.changes,
                checkin: this.options.checkin,
                portId: __classPrivateFieldGet(this, _CruisePortPage_portId, "f"),
                peopleOptions: {
                    maxChildAge: App.app.settings.cruiseOptions.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: App.app.settings.cruiseOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.cruiseOptions.defaultCheckinDateInterval,
                    maxDateToOffset: App.app.settings.cruiseOptions.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: App.app.settings.cruiseOptions.minPrice,
                    max: App.app.settings.cruiseOptions.maxPrice,
                },
            }), "f");
            this.validator = __classPrivateFieldGet(this, _CruisePortPage_portFilter, "f").root.validate({ ignore: '' });
            this.responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            this.components.push(new App.Digest({ container: this.root }));
            __classPrivateFieldSet(this, _CruisePortPage_portResult, new App.CruisePortResult({
                root: '.js-placement-output',
                hotFilter: new App.CruisePortHotFilter({
                    root: __classPrivateFieldGet(this, _CruisePortPage_portHotFilterClass, "f"),
                }),
            }), "f");
            __classPrivateFieldGet(this, _CruisePortPage_portFilter, "f").portFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruisePortPage_instances, "m", _CruisePortPage_onPortFilterSearch).call(this); }));
            // инициализация фоток
            this.components.push(new App.MediaGallery({ wrap: '.tour-slider-and-info-block' }));
            // событие на клик по табу добавляем перед инициализацией табов
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _CruisePortPage_instances, "m", _CruisePortPage_onClickTab).call(this, e));
            // инициализация табов
            __classPrivateFieldSet(this, _CruisePortPage_portTabs, new App.Tabs({ self: __classPrivateFieldGet(this, _CruisePortPage_portWrapClass, "f") }), "f");
            __classPrivateFieldGet(this, _CruisePortPage_portTabs, "f").showActive();
            // прилипание/отлипание ссылки 'к бронированию'
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => this.onScrollDescrBlock()));
            $('.js-filter-service-fee', __classPrivateFieldGet(this, _CruisePortPage_searchResultsWrap, "f")).on('click', e => __classPrivateFieldGet(_a, _a, "m", _CruisePortPage_onServiceFeeSwitch).call(_a, e));
        }
    }
    _a = CruisePortPage, _CruisePortPage_portFilter = new WeakMap(), _CruisePortPage_portResult = new WeakMap(), _CruisePortPage_portTabs = new WeakMap(), _CruisePortPage_portWrapClass = new WeakMap(), _CruisePortPage_portHotFilterClass = new WeakMap(), _CruisePortPage_portMainFilterClass = new WeakMap(), _CruisePortPage_searchResultsWrap = new WeakMap(), _CruisePortPage_portId = new WeakMap(), _CruisePortPage_popup2 = new WeakMap(), _CruisePortPage_offers = new WeakMap(), _CruisePortPage_instances = new WeakSet(), _CruisePortPage_onClickTab = function _CruisePortPage_onClickTab(event) {
        if ($(event.currentTarget).attr('id') === 'placementTab') {
            if (!__classPrivateFieldGet(this, _CruisePortPage_offers, "f") || __classPrivateFieldGet(this, _CruisePortPage_offers, "f").length === 0)
                (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruisePortPage_instances, "m", _CruisePortPage_renderPortResults).call(this); }))();
        }
    }, _CruisePortPage_renderPortResults = function _CruisePortPage_renderPortResults() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageBase.hide($(__classPrivateFieldGet(this, _CruisePortPage_searchResultsWrap, "f")));
            if (!(yield __classPrivateFieldGet(this, _CruisePortPage_instances, "m", _CruisePortPage_searchPortRoutes).call(this)))
                return;
            App.CruisePageBase.show($(__classPrivateFieldGet(this, _CruisePortPage_searchResultsWrap, "f")));
            this.saveState('port', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruisePortPage_portFilter, "f").portFilter), true);
        });
    }, _CruisePortPage_prepareDataForPortSearch = function _CruisePortPage_prepareDataForPortSearch() {
        const elements = __classPrivateFieldGet(this, _CruisePortPage_portFilter, "f").portFilter.serializeArray();
        const data = App.CruisePageBase.convertArrayToRequestData(elements);
        data.port = __classPrivateFieldGet(this, _CruisePortPage_portId, "f").toString();
        return data;
    }, _CruisePortPage_searchPortRoutes = function _CruisePortPage_searchPortRoutes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.searchExecuting)
                return false;
            this.searchExecuting = true;
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            __classPrivateFieldGet(this, _CruisePortPage_portResult, "f").resetDataSource();
            const data = __classPrivateFieldGet(this, _CruisePortPage_instances, "m", _CruisePortPage_prepareDataForPortSearch).call(this);
            if (this.context)
                data.context = this.context;
            const xhr = $.ajax({
                url: this.options.urls.searchRoutes,
                method: 'POST',
                data,
            });
            let returnS = false;
            const popupGroup = __classPrivateFieldGet(this, _CruisePortPage_popup2, "f").show({
                group: 'main',
                content: App.templates.Cruise.Messages.Searching({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null)
                    this.updateSeo(response.data.seo);
                // Определение наличия результатов поиска
                if (response.data.offers && response.data.offers.length > 0) {
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: this.options.urls.searchRoutes,
                    });
                    response.data.offers.forEach(v => {
                        v.route = App.CruisePageBase.abbreviateMulti(v.routeElements.map(z => z.value).join(', '), 75, '...');
                        v.portsDeparture = v.portDepartureElements.map(z => z.value).join(', ');
                        v.isPGManager = this.options.isPGManager;
                    });
                    __classPrivateFieldSet(this, _CruisePortPage_offers, response.data.offers, "f");
                    yield __classPrivateFieldGet(this, _CruisePortPage_portResult, "f").changeDataSource(__classPrivateFieldGet(this, _CruisePortPage_offers, "f"));
                    returnS = true;
                }
                else {
                    __classPrivateFieldGet(this, _CruisePortPage_portResult, "f").resetDataSource();
                }
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                this.searchExecuting = false;
                __classPrivateFieldGet(this, _CruisePortPage_popup2, "f").hide(popupGroup);
            }
            return returnS;
        });
    }, _CruisePortPage_onPortFilterSearch = function _CruisePortPage_onPortFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _CruisePortPage_portTabs, "f").show('placement');
            yield __classPrivateFieldGet(this, _CruisePortPage_instances, "m", _CruisePortPage_renderPortResults).call(this);
        });
    }, _CruisePortPage_onServiceFeeSwitch = function _CruisePortPage_onServiceFeeSwitch(event) {
        const target = $(event.currentTarget);
        const filterFeeBtn = target.find('.js-sliding-btn');
        const serviceFee = $('.js-service-fee', '.js-port-route-output');
        if (filterFeeBtn.hasClass('_on')) {
            serviceFee.removeClass('_off');
            serviceFee.find('.js-serviceFee_text').showByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').hideByClass();
        }
        else {
            serviceFee.addClass('_off');
            serviceFee.find('.js-serviceFee_text').hideByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').showByClass();
        }
    };
    App.CruisePortPage = CruisePortPage;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseRoutePageMobile_instances, _CruiseRoutePageMobile_routeVariantOption, _CruiseRoutePageMobile_routeVariantBlock, _CruiseRoutePageMobile_routeWrapClass, _CruiseRoutePageMobile_routeHotFilterClass, _CruiseRoutePageMobile_cruiseScheduleWrapClass, _CruiseRoutePageMobile_routeWrap, _CruiseRoutePageMobile_routeFilter, _CruiseRoutePageMobile_routeResult, _CruiseRoutePageMobile_priceInfo, _CruiseRoutePageMobile_visaInfo, _CruiseRoutePageMobile_scheduleInfo, _CruiseRoutePageMobile_routeCabinGroups, _CruiseRoutePageMobile_routeCabins, _CruiseRoutePageMobile_isLuxeMode, _CruiseRoutePageMobile_popup2, _CruiseRoutePageMobile_showRoutePage, _CruiseRoutePageMobile_renderRouteCabins, _CruiseRoutePageMobile_prepareDataForCabinSearch, _CruiseRoutePageMobile_updateVisaInfo, _CruiseRoutePageMobile_updatePriceInfo, _CruiseRoutePageMobile_updateScheduleInfo, _CruiseRoutePageMobile_getCruiseSchedule, _CruiseRoutePageMobile_getVariantInfo, _CruiseRoutePageMobile_searchCabins, _CruiseRoutePageMobile_updateCabins, _CruiseRoutePageMobile_findRouteGroup, _CruiseRoutePageMobile_onOpenGroupCabinsClick, _CruiseRoutePageMobile_onCloseGroupCabinsClick, _CruiseRoutePageMobile_onVisaInfoClick, _CruiseRoutePageMobile_onVisaPortChange, _CruiseRoutePageMobile_onScheduleClick, _CruiseRoutePageMobile_onRouteFilterSearch, _CruiseRoutePageMobile_onVariantClick, _CruiseRoutePageMobile_onPortChange;
    class CruiseRoutePageMobile extends App.CruisePageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-page .js-app-container-content' }, options));
            _CruiseRoutePageMobile_instances.add(this);
            _CruiseRoutePageMobile_routeVariantOption.set(this, void 0);
            _CruiseRoutePageMobile_routeVariantBlock.set(this, void 0);
            _CruiseRoutePageMobile_routeWrapClass.set(this, void 0);
            _CruiseRoutePageMobile_routeHotFilterClass.set(this, void 0);
            _CruiseRoutePageMobile_cruiseScheduleWrapClass.set(this, void 0);
            _CruiseRoutePageMobile_routeWrap.set(this, void 0);
            _CruiseRoutePageMobile_routeFilter.set(this, void 0);
            _CruiseRoutePageMobile_routeResult.set(this, void 0);
            _CruiseRoutePageMobile_priceInfo.set(this, void 0);
            _CruiseRoutePageMobile_visaInfo.set(this, void 0);
            _CruiseRoutePageMobile_scheduleInfo.set(this, void 0);
            _CruiseRoutePageMobile_routeCabinGroups.set(this, void 0);
            _CruiseRoutePageMobile_routeCabins.set(this, void 0);
            _CruiseRoutePageMobile_isLuxeMode.set(this, void 0);
            _CruiseRoutePageMobile_popup2.set(this, void 0);
            Object.defineProperty(this, "detailsSliderBlock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeWrapClass, '.js-cruise-route', "f");
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeHotFilterClass, '.js-cruise-route .js-cruise-route-hot-filter', "f");
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_cruiseScheduleWrapClass, 'js-cruise-schedule', "f");
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_popup2, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            this.detailsSliderBlock = $('.tour-slider-and-info-block', this.root);
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeWrap, $(__classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrapClass, "f"), this.root), "f");
            this.routeNumber = $('#routeNumber').valString();
            this.states = {
                'route': {
                    handler: () => __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_showRoutePage).call(this),
                    actionName: 'route',
                    keysForUrl: ['port', 'fare', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeVariantOption, $('.js-routeVariant-option', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")), "f");
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeVariantBlock, $('.js-routeVariant-block', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")), "f");
            this.scrollBookLink = $('.js-scroll-book-link', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"));
            this.bookScrollToWrap = $('.js-book-to-scroll', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"));
            const routeDigest = $('.js-cruise-route .js-digest');
            if (!routeDigest.hasClass('initialized')) {
                this.components.push(new App.Digest({ container: '.js-cruise-route' }));
                routeDigest.addClass('initialized');
            }
            this.components.push(
            // инициализация фоток
            new App.MediaGalleryMobile(), new App.ActionInfoComponent());
            // инициализация табов
            this.tabs = new App.Tabs({ self: __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrapClass, "f") });
            this.tabs.showActive();
            // Переключаем варианты программ
            __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantOption, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onVariantClick).call(this, e); }));
            // инициализация формы поиска
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeFilter, new App.CruiseRouteMainFilterMobile({
                // root: '.js-main-filter.js-route-filter',
                urls: this.options.urls,
                checkin: this.options.checkin,
                defaults: this.options.defaults,
                changes: this.options.changes,
                routeNumber: this.routeNumber,
                shipId: this.options.shipId ? this.options.shipId : 0,
                peopleOptions: {
                    maxChildAge: App.app.settings.cruiseOptions.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: App.app.settings.cruiseOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.cruiseOptions.defaultCheckinDateInterval,
                    maxDateToOffset: App.app.settings.cruiseOptions.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: App.app.settings.cruiseOptions.minPrice,
                    max: App.app.settings.cruiseOptions.maxPrice,
                },
            }), "f");
            __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeResult, new App.CruiseRouteResultMobile({
                root: __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrapClass, "f"),
                hotFilter: new App.CruiseRouteHotFilterMobile({
                    root: __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeHotFilterClass, "f"),
                }),
            }), "f");
            this.validator = __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").routeFilter.validate({ ignore: '.filter-slider-input' });
            this.responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            let changedElement = $();
            const queryParams = new App.QueryParams(window.location.pathname);
            if (queryParams.param('fare').length > 0)
                changedElement = $('.filter-block[data-select="fare"]');
            if (queryParams.param('cabin').length > 0)
                changedElement = $('.filter-block[data-select="cabin"]');
            if (changedElement.length > 0) {
                // TODO Timoshkina: некорректное использование, данное событие должно инициироваться только в наследниках FilterBlockBase.
                changedElement.trigger("filter:change" /* Events.FilterChange */);
            }
            __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").routeFilter.on("routeFilter:search" /* Events.RouteFilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onRouteFilterSearch).call(this); }));
            __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f").on('click', '.js-placement-cabin-title.show-description', (e) => this.onCabinTitleClick(e));
            __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f").on('click', '.js-show-schedule', (e) => __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onScheduleClick).call(this, e));
            __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f").on('click', '.js-cruise-group-show-more-open .js-cruise-group-show-more-link', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onOpenGroupCabinsClick).call(this, e); }));
            __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f").on('click', '.js-cruise-group-show-more-close .js-cruise-group-show-more-link', e => __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onCloseGroupCabinsClick).call(this, e));
            __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").root.on('change', '[data-select="port"] .js-jelect', () => __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onPortChange).call(this));
            this.root.on('click', '.js-button-expired-refresh-custom', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onRouteFilterSearch).call(this); }));
            // прилипание/отлипание ссылки 'к бронированию'
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => this.onScrollDescrBlock()));
        }
    }
    _CruiseRoutePageMobile_routeVariantOption = new WeakMap(), _CruiseRoutePageMobile_routeVariantBlock = new WeakMap(), _CruiseRoutePageMobile_routeWrapClass = new WeakMap(), _CruiseRoutePageMobile_routeHotFilterClass = new WeakMap(), _CruiseRoutePageMobile_cruiseScheduleWrapClass = new WeakMap(), _CruiseRoutePageMobile_routeWrap = new WeakMap(), _CruiseRoutePageMobile_routeFilter = new WeakMap(), _CruiseRoutePageMobile_routeResult = new WeakMap(), _CruiseRoutePageMobile_priceInfo = new WeakMap(), _CruiseRoutePageMobile_visaInfo = new WeakMap(), _CruiseRoutePageMobile_scheduleInfo = new WeakMap(), _CruiseRoutePageMobile_routeCabinGroups = new WeakMap(), _CruiseRoutePageMobile_routeCabins = new WeakMap(), _CruiseRoutePageMobile_isLuxeMode = new WeakMap(), _CruiseRoutePageMobile_popup2 = new WeakMap(), _CruiseRoutePageMobile_instances = new WeakSet(), _CruiseRoutePageMobile_showRoutePage = function _CruiseRoutePageMobile_showRoutePage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageBase.show(__classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"), true, 1);
            if (yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_searchCabins).call(this)) {
                this.saveState('route', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").routeFilter), true);
            }
        });
    }, _CruiseRoutePageMobile_renderRouteCabins = function _CruiseRoutePageMobile_renderRouteCabins() {
        return __awaiter(this, void 0, void 0, function* () {
            this.responseValidator = new App.ResponseValidatorOld({
                messenger: new App.BlockMessenger(new App.Messages({ root: $('.js-tab-wrap[data-tab="placement"]').find('.js-messages') })),
                validator: this.validator,
            });
            if (yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_searchCabins).call(this)) {
                this.saveState('route', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").routeFilter), true);
            }
        });
    }, _CruiseRoutePageMobile_prepareDataForCabinSearch = function _CruiseRoutePageMobile_prepareDataForCabinSearch() {
        var _a;
        let elements = __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").filters.serializeArray();
        const priceValue = (_a = elements.find(x => x.name == 'price')) === null || _a === void 0 ? void 0 : _a.value;
        elements = elements.filter(x => x.name != 'price');
        elements.push({
            name: 'Price.From',
            value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[0],
        });
        elements.push({
            name: 'Price.To',
            value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[1],
        });
        const currencyFilter = $('.filter_price_currency');
        if (currencyFilter) {
            elements.push({
                name: currencyFilter.attr('name'),
                value: currencyFilter.attr('value'),
            });
        }
        const city = elements.find(x => x.name == 'City');
        if (city && !city.value) {
            city.value = '0';
        }
        const data = App.CruisePageMobileBase.convertArrayToRequestData(elements);
        data.RouteNumber = this.routeNumber;
        return data;
    }, _CruiseRoutePageMobile_updateVisaInfo = function _CruiseRoutePageMobile_updateVisaInfo() {
        if (__classPrivateFieldGet(this, _CruiseRoutePageMobile_visaInfo, "f") == null || __classPrivateFieldGet(this, _CruiseRoutePageMobile_visaInfo, "f").length === 0) {
            $('.js-visa-info', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")).hide();
        }
        else {
            const ports = new App.SelectListModel({
                name: 'visaPorts',
                form: true,
                autocomplete: false,
                items: __classPrivateFieldGet(this, _CruiseRoutePageMobile_visaInfo, "f")
                    .map((port, index) => ({
                    value: port.portKey.toString(),
                    text: port.portName,
                    selected: index === 0,
                })),
            });
            const content = $(App.templates.Cruise.Route.VisaInfo({
                visaInfo: __classPrivateFieldGet(this, _CruiseRoutePageMobile_visaInfo, "f"),
                ports: ports,
                isNeedVisaHref: this.options.isNeedVisaHref,
            }));
            $('.js-visa-info-content', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")).empty().append(content);
            $('.js-visa-info', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")).show();
            this.components.push(new App.Filter({ root: $('.js-visa-info-content', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")) }));
            // Переключаем порты
            const visaInfoBlock = $('.js-visa-info-content', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"));
            visaInfoBlock.on('change', '.js-route-visa-port-select .js-jelect', e => __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onVisaPortChange).call(this, e));
            // Переключаем визы
            const routeVisaOptions = $('.js-routeVisa-option', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"));
            routeVisaOptions.on('click', e => __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onVisaInfoClick).call(this, e));
        }
    }, _CruiseRoutePageMobile_updatePriceInfo = function _CruiseRoutePageMobile_updatePriceInfo() {
        if (__classPrivateFieldGet(this, _CruiseRoutePageMobile_priceInfo, "f") != null) {
            const content = $(App.templates.Cruise.Route.PriceInfo({ priceInfo: __classPrivateFieldGet(this, _CruiseRoutePageMobile_priceInfo, "f") }));
            $('.js-route-price-info-data', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")).empty().append(content);
        }
    }, _CruiseRoutePageMobile_updateScheduleInfo = function _CruiseRoutePageMobile_updateScheduleInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseRoutePageMobile_scheduleInfo, "f") != null && __classPrivateFieldGet(this, _CruiseRoutePageMobile_scheduleInfo, "f").length !== 0) {
                const content = $(App.templates.Cruise.Route.ScheduleInfo({ schedules: __classPrivateFieldGet(this, _CruiseRoutePageMobile_scheduleInfo, "f") }));
                $('.js-route-schedule-info .js-route-schedule-info-data', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"))
                    .empty()
                    .append(content);
                __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeVariantOption, $('.js-routeVariant-option', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")), "f");
                __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeVariantBlock, $('.js-routeVariant-block', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")), "f");
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantOption, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_onVariantClick).call(this, e); }));
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantOption, "f").filter('._active').trigger('click');
            }
        });
    }, _CruiseRoutePageMobile_getCruiseSchedule = function _CruiseRoutePageMobile_getCruiseSchedule(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: this.options.urls.getCruiseSchedule,
                method: 'POST',
                data: { cruiseKey: key },
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return;
                const blockDescr = $(App.templates.Cruise.Route.Schedule({ schedules: response.data.items, info: response.data.info }));
                $(`.${__classPrivateFieldGet(this, _CruiseRoutePageMobile_cruiseScheduleWrapClass, "f")}`, $('.js-popup')).empty().append(blockDescr);
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
        });
    }, _CruiseRoutePageMobile_getVariantInfo = function _CruiseRoutePageMobile_getVariantInfo(cruiseKey, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const adults = $('[data-input-name="people_men"]', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").routeFilter).val();
            const children = $('.js-filter-person-input', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").routeFilter)
                .not(':disabled')
                .get()
                .map(v => $(v).valNumber());
            const xhr = $.ajax({
                url: this.options.urls.getCruisePortsInfo,
                method: 'POST',
                data: { cruiseKey, adultCount: adults, childrenAges: children },
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return;
                const schedule = __classPrivateFieldGet(this, _CruiseRoutePageMobile_scheduleInfo, "f").find(s => s.cruiseKey === cruiseKey);
                const blockDescr = $(App.templates.Cruise.Route.PortInfo({
                    ports: response.data.items,
                    routeImageUrl: schedule ? schedule.routeImageUrl : '',
                    ship: __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeCabinGroups, "f")[0].ship,
                    path: (new App.QueryParams(window.location.pathname)).getController(),
                }));
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantOption, "f").filter(`[data-variant="${id}"]`).attr('data-loaded', '1');
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantBlock, "f").filter(`[data-variant="${id}"]`).empty().append(blockDescr);
                this.components.push(
                // инициализация фоток
                new App.TourInfoSlider({ wrap: `.js-routeVariant-block[data-variant="${id}"] .js-tour-info-slider-wrap` }));
                $('.lazy').Lazy();
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
        });
    }, _CruiseRoutePageMobile_searchCabins = function _CruiseRoutePageMobile_searchCabins() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            App.CruisePageBase.hide($('.js-route-search-results', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"))); // блок результатов поиска вместе с заголовком
            let success = false;
            const data = __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_prepareDataForCabinSearch).call(this);
            const xhr = $.ajax({
                url: this.options.urls.searchCabins,
                method: 'POST',
                data,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseRoutePageMobile_popup2, "f").show({
                group: 'main',
                content: App.templates.Cruise.Messages.Searching({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null) {
                    this.updateSeo(response.data.seo);
                    this.seo.route = response.data.seo;
                }
                if (response.data.priceInfo)
                    __classPrivateFieldSet(this, _CruiseRoutePageMobile_priceInfo, response.data.priceInfo, "f");
                if (response.data.visaInfo)
                    __classPrivateFieldSet(this, _CruiseRoutePageMobile_visaInfo, response.data.visaInfo, "f");
                if (response.data.scheduleInfo)
                    __classPrivateFieldSet(this, _CruiseRoutePageMobile_scheduleInfo, response.data.scheduleInfo, "f");
                if (response.data.offers && response.data.offers.length > 0) {
                    __classPrivateFieldSet(this, _CruiseRoutePageMobile_isLuxeMode, response.data.isLuxeMode, "f");
                    response.data.offers.forEach(v => {
                        v.isPGManager = this.options.isPGManager;
                        v.isLuxeMode = __classPrivateFieldGet(this, _CruiseRoutePageMobile_isLuxeMode, "f");
                    });
                    __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeCabinGroups, response.data.offers, "f");
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        customRefresh: true,
                        isContainerPopup: true,
                        root: this.root,
                    });
                    App.CruisePageBase.show($('.js-route-search-results', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f")));
                    yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeResult, "f").changeDataSource(__classPrivateFieldGet(this, _CruiseRoutePageMobile_routeCabinGroups, "f"));
                    yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_updateScheduleInfo).call(this);
                    this.components.push(
                    // инициализация Печать программы
                    new App.PrintComponent({
                        modes: {
                            'text': 'Программа без картинок',
                            'image': 'Программа с картинками',
                            'default': 'Страница целиком',
                        },
                    }));
                    __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_updatePriceInfo).call(this);
                    __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_updateVisaInfo).call(this);
                    success = true;
                    return true;
                }
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeResult, "f").resetDataSource();
                return false;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_popup2, "f").hide(popupGroup);
            }
            return success;
        });
    }, _CruiseRoutePageMobile_updateCabins = function _CruiseRoutePageMobile_updateCabins(cruiseKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_prepareDataForCabinSearch).call(this);
            data.cruiseKey = cruiseKey;
            const xhr = $.ajax({
                url: this.options.urls.updateCabins,
                method: 'POST',
                data,
            });
            const button = $(`.js-cruise-group-show-more-open[data-cruiseid="${cruiseKey}"] .js-cruise-group-show-more-link`, __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"));
            const loading = button.find('.loading');
            let success = false;
            App.CruisePageBase.show(loading);
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.offers) {
                    __classPrivateFieldSet(this, _CruiseRoutePageMobile_routeCabins, response.data.offers, "f");
                    __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeCabins, "f").forEach(v => {
                        v.cabin.experienceLink = v.cabin.experience == null ?
                            '' : `/help/cruise/msc-cruises/cabin-experience/${v.cabin.experience.toLowerCase().replace(' ', '-')}/`;
                    });
                    success = true;
                    return true;
                }
                return false;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                App.CruisePageBase.hide(loading);
            }
            return success;
        });
    }, _CruiseRoutePageMobile_findRouteGroup = function _CruiseRoutePageMobile_findRouteGroup(id) {
        return __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeCabinGroups, "f").find(v => v.key === id);
    }, _CruiseRoutePageMobile_onOpenGroupCabinsClick = function _CruiseRoutePageMobile_onOpenGroupCabinsClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            const target = $(event.currentTarget).closest('.js-route-group-cabin-title');
            const id = Number(target.attr('data-cruiseid'));
            const groupObj = __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_findRouteGroup).call(this, id);
            if (!groupObj)
                return;
            groupObj.isOpen = true;
            const group = target.closest('.js-route-group-cabin');
            const cabinWrap = group.find('.js-route-group-cabin-content');
            const cabinItems = group.find('.js-offer-cabin-items');
            const linksToChange = group.find('.js-needChange');
            if ((!groupObj.items || groupObj.items.length === 0) && (yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_updateCabins).call(this, id.toString())))
                groupObj.items = __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeCabins, "f");
            if (groupObj.items.length > 0) {
                const content = $(App.templates.Cruise.Route.CabinOffer({ cabins: groupObj.items, isLuxeMode: __classPrivateFieldGet(this, _CruiseRoutePageMobile_isLuxeMode, "f") }));
                cabinItems.empty().append(content);
            }
            else {
                const content = '<div class="alert">' + localizer.noOffers + '</div>';
                cabinItems.empty().append(content);
            }
            group.addClass('_open');
            cabinWrap.show();
            if (linksToChange.length > 0) {
                linksToChange.switchClass('js-cruise-group-show-more-open', 'js-cruise-group-show-more-close');
                linksToChange.find('.js-cruise-group-show-more-link').find('.pseudo-link').html(localizer.hideAvailability);
            }
        });
    }, _CruiseRoutePageMobile_onCloseGroupCabinsClick = function _CruiseRoutePageMobile_onCloseGroupCabinsClick(event) {
        event.preventDefault();
        event.stopPropagation();
        let target = $(event.currentTarget).closest('.js-route-group-cabin-title');
        if (target.length === 0)
            target = $(event.currentTarget).parents('.js-route-group-cabin').find('.js-route-group-cabin-title');
        const id = Number(target.attr('data-cruiseid'));
        const groupObj = __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_findRouteGroup).call(this, id);
        if (!groupObj)
            return;
        groupObj.isOpen = false;
        const group = target.closest('.js-route-group-cabin');
        const cabinWrap = group.find('.js-route-group-cabin-content');
        const linksToChange = group.find('.js-needChange');
        group.removeClass('_open');
        cabinWrap.hide();
        if (linksToChange.length > 0) {
            linksToChange.switchClass('js-cruise-group-show-more-close', 'js-cruise-group-show-more-open');
            linksToChange.find('.js-cruise-group-show-more-link').find('.pseudo-link').html(localizer.seeAvailability);
        }
        const scrollTo = $('.js-scroll-to', group);
        scrollTo.on('click', e => App.scrollLinkClickHandler(e));
    }, _CruiseRoutePageMobile_onVisaInfoClick = function _CruiseRoutePageMobile_onVisaInfoClick(event) {
        const target = $(event.currentTarget);
        const id = Number(target.attr('data-visablock'));
        const isActive = target.hasClass('_active');
        if (!isActive) {
            const links = $('.js-routeVisa-option', '.js-route-visa-port-block._active');
            links.removeClass('_active');
            target.addClass('_active');
            const visaBlocks = $('.js-routeVisa-block', '.js-route-visa-port-block._active');
            visaBlocks.removeClass('_active');
            visaBlocks.hide();
            const tab = visaBlocks.filter(`[data-visablock="${id}"]`);
            tab.fadeIn(300);
            tab.addClass('_active');
        }
    }, _CruiseRoutePageMobile_onVisaPortChange = function _CruiseRoutePageMobile_onVisaPortChange(event) {
        const target = $(event.currentTarget);
        const portKey = target.valString();
        const routeVisaPortBlocks = $('.js-route-visa-port-block', __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeWrap, "f"));
        routeVisaPortBlocks.removeClass('_active');
        routeVisaPortBlocks.filter(`[data-visaport="${portKey}"]`).addClass('_active');
    }, _CruiseRoutePageMobile_onScheduleClick = function _CruiseRoutePageMobile_onScheduleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.popupInfo)
            App.popupHide();
        this.popupInfo = new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _CruiseRoutePageMobile_cruiseScheduleWrapClass, "f")} cruise-schedule user-content"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _a; return yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_getCruiseSchedule).call(this, (_a = $(event.currentTarget).attr('data-key')) !== null && _a !== void 0 ? _a : ''); }),
        });
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _CruiseRoutePageMobile_onRouteFilterSearch = function _CruiseRoutePageMobile_onRouteFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_renderRouteCabins).call(this);
        });
    }, _CruiseRoutePageMobile_onVariantClick = function _CruiseRoutePageMobile_onVariantClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const id = Number(target.attr('data-variant'));
            const cruise = Number(target.attr('data-cruise'));
            const isActive = target.hasClass('_active');
            const isLoaded = Number(target.attr('data-loaded'));
            if (isLoaded === 0) {
                yield __classPrivateFieldGet(this, _CruiseRoutePageMobile_instances, "m", _CruiseRoutePageMobile_getVariantInfo).call(this, cruise, id);
            }
            // Показываем нужную программу
            if (!isActive) {
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantOption, "f").removeClass('_active');
                target.addClass('_active');
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantBlock, "f").removeClass('_active');
                __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantBlock, "f").hide();
                const tab = __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantBlock, "f").filter(`[data-variant="${id}"]`);
                tab.fadeIn(300);
            }
        });
    }, _CruiseRoutePageMobile_onPortChange = function _CruiseRoutePageMobile_onPortChange() {
        const portKey = __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeFilter, "f").root.find('[data-select="port"] input').valString();
        const keys = portKey.split(',');
        __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantOption, "f").each((i, v) => {
            const jqElement = $(v);
            jqElement.toggleByClass((keys.includes(jqElement.attr('data-port') || '')) || portKey === '');
        });
        __classPrivateFieldGet(this, _CruiseRoutePageMobile_routeVariantOption, "f").find(':visible').first().trigger('click');
    };
    App.CruiseRoutePageMobile = CruiseRoutePageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseRoutePage_instances, _CruiseRoutePage_routeVariantOption, _CruiseRoutePage_routeVariantBlock, _CruiseRoutePage_routeWrapClass, _CruiseRoutePage_routeHotFilterClass, _CruiseRoutePage_cruiseScheduleWrapClass, _CruiseRoutePage_routeWrap, _CruiseRoutePage_routeFilter, _CruiseRoutePage_routeResult, _CruiseRoutePage_priceInfo, _CruiseRoutePage_visaInfo, _CruiseRoutePage_scheduleInfo, _CruiseRoutePage_routeCabinGroups, _CruiseRoutePage_routeCabins, _CruiseRoutePage_isLuxeMode, _CruiseRoutePage_popup2, _CruiseRoutePage_showRoutePage, _CruiseRoutePage_renderRouteCabins, _CruiseRoutePage_prepareDataForCabinSearch, _CruiseRoutePage_updateVisaInfo, _CruiseRoutePage_updatePriceInfo, _CruiseRoutePage_updateScheduleInfo, _CruiseRoutePage_getCruiseSchedule, _CruiseRoutePage_getVariantInfo, _CruiseRoutePage_searchCabins, _CruiseRoutePage_updateCabins, _CruiseRoutePage_findRouteGroup, _CruiseRoutePage_onOpenGroupCabinsClick, _CruiseRoutePage_onCloseGroupCabinsClick, _CruiseRoutePage_onVisaInfoClick, _CruiseRoutePage_onVisaPortChange, _CruiseRoutePage_onScheduleClick, _CruiseRoutePage_onRouteFilterSearch, _CruiseRoutePage_onVariantClick, _CruiseRoutePage_onPortChange;
    class CruiseRoutePage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-page .js-app-container-content' }, options));
            _CruiseRoutePage_instances.add(this);
            _CruiseRoutePage_routeVariantOption.set(this, void 0);
            _CruiseRoutePage_routeVariantBlock.set(this, void 0);
            _CruiseRoutePage_routeWrapClass.set(this, void 0);
            _CruiseRoutePage_routeHotFilterClass.set(this, void 0);
            _CruiseRoutePage_cruiseScheduleWrapClass.set(this, void 0);
            _CruiseRoutePage_routeWrap.set(this, void 0);
            _CruiseRoutePage_routeFilter.set(this, void 0);
            _CruiseRoutePage_routeResult.set(this, void 0);
            _CruiseRoutePage_priceInfo.set(this, void 0);
            _CruiseRoutePage_visaInfo.set(this, void 0);
            _CruiseRoutePage_scheduleInfo.set(this, void 0);
            _CruiseRoutePage_routeCabinGroups.set(this, void 0);
            _CruiseRoutePage_routeCabins.set(this, void 0);
            _CruiseRoutePage_isLuxeMode.set(this, void 0);
            _CruiseRoutePage_popup2.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseRoutePage_routeWrapClass, '.js-cruise-route', "f");
            __classPrivateFieldSet(this, _CruiseRoutePage_routeHotFilterClass, '.js-cruise-route .js-cruise-route-hot-filter', "f");
            __classPrivateFieldSet(this, _CruiseRoutePage_cruiseScheduleWrapClass, 'js-cruise-schedule', "f");
            __classPrivateFieldSet(this, _CruiseRoutePage_popup2, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            __classPrivateFieldSet(this, _CruiseRoutePage_routeWrap, $(__classPrivateFieldGet(this, _CruiseRoutePage_routeWrapClass, "f"), this.root), "f");
            this.routeNumber = $('#routeNumber').valString();
            this.states = {
                'route': {
                    handler: () => __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_showRoutePage).call(this),
                    actionName: 'route',
                    keysForUrl: ['port', 'fare', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseRoutePage_routeVariantOption, $('.js-routeVariant-option', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")), "f");
            __classPrivateFieldSet(this, _CruiseRoutePage_routeVariantBlock, $('.js-routeVariant-block', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")), "f");
            this.scrollBookLink = $('.js-scroll-book-link', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"));
            this.bookScrollToWrap = $('.js-book-to-scroll', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"));
            this.components.push(
            // инициализация фоток
            new App.MediaGallery({ wrap: '.tour-slider-and-info-block' }), new App.ActionInfoComponent());
            // инициализация табов
            this.tabs = new App.Tabs({ self: __classPrivateFieldGet(this, _CruiseRoutePage_routeWrapClass, "f") });
            this.tabs.showActive();
            // Переключаем варианты программ
            __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantOption, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onVariantClick).call(this, e); }));
            // инициализация формы поиска
            __classPrivateFieldSet(this, _CruiseRoutePage_routeFilter, new App.CruiseRouteMainFilter({
                root: '.js-main-filter.js-route-filter',
                urls: this.options.urls,
                checkin: this.options.checkin,
                defaults: this.options.defaults,
                changes: this.options.changes,
                routeNumber: this.routeNumber,
                shipId: this.options.shipId ? this.options.shipId : 0,
                peopleOptions: {
                    maxChildAge: App.app.settings.cruiseOptions.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: App.app.settings.cruiseOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.cruiseOptions.defaultCheckinDateInterval,
                    maxDateToOffset: App.app.settings.cruiseOptions.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: App.app.settings.cruiseOptions.minPrice,
                    max: App.app.settings.cruiseOptions.maxPrice,
                },
            }), "f");
            __classPrivateFieldSet(this, _CruiseRoutePage_routeResult, new App.CruiseRouteResult({
                root: __classPrivateFieldGet(this, _CruiseRoutePage_routeWrapClass, "f"),
                hotFilter: new App.CruiseRouteHotFilter({
                    root: __classPrivateFieldGet(this, _CruiseRoutePage_routeHotFilterClass, "f"),
                }),
            }), "f");
            this.validator = __classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").routeFilter.validate({ ignore: '.filter-slider-input' });
            this.responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            let changedElement = $();
            const queryParams = new App.QueryParams(window.location.pathname);
            if (queryParams.param('fare').length > 0)
                changedElement = $('.filter-block[data-select="fare"]');
            if (queryParams.param('cabin').length > 0)
                changedElement = $('.filter-block[data-select="cabin"]');
            if (changedElement.length > 0) {
                // TODO Timoshkina: некорректное использование, данное событие должно инициироваться только в наследниках FilterBlockBase.
                changedElement.trigger("filter:change" /* Events.FilterChange */);
            }
            __classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").routeFilter.on("routeFilter:search" /* Events.RouteFilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onRouteFilterSearch).call(this); }));
            __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f").on('click', '.js-placement-cabin-title.show-description', (e) => this.onCabinTitleClick(e));
            __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f").on('click', '.js-show-schedule', (e) => __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onScheduleClick).call(this, e));
            __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f").on('click', '.js-cruise-group-show-more-open .js-cruise-group-show-more-link', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onOpenGroupCabinsClick).call(this, e); }));
            __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f").on('click', '.js-cruise-group-show-more-close .js-cruise-group-show-more-link', e => __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onCloseGroupCabinsClick).call(this, e));
            __classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").root.on('change', '[data-select="port"] .js-jelect', () => __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onPortChange).call(this));
            this.root.on('click', '.js-button-expired-refresh-custom', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onRouteFilterSearch).call(this); }));
            // прилипание/отлипание ссылки 'к бронированию'
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => this.onScrollDescrBlock()));
        }
    }
    _CruiseRoutePage_routeVariantOption = new WeakMap(), _CruiseRoutePage_routeVariantBlock = new WeakMap(), _CruiseRoutePage_routeWrapClass = new WeakMap(), _CruiseRoutePage_routeHotFilterClass = new WeakMap(), _CruiseRoutePage_cruiseScheduleWrapClass = new WeakMap(), _CruiseRoutePage_routeWrap = new WeakMap(), _CruiseRoutePage_routeFilter = new WeakMap(), _CruiseRoutePage_routeResult = new WeakMap(), _CruiseRoutePage_priceInfo = new WeakMap(), _CruiseRoutePage_visaInfo = new WeakMap(), _CruiseRoutePage_scheduleInfo = new WeakMap(), _CruiseRoutePage_routeCabinGroups = new WeakMap(), _CruiseRoutePage_routeCabins = new WeakMap(), _CruiseRoutePage_isLuxeMode = new WeakMap(), _CruiseRoutePage_popup2 = new WeakMap(), _CruiseRoutePage_instances = new WeakSet(), _CruiseRoutePage_showRoutePage = function _CruiseRoutePage_showRoutePage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageBase.show(__classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"), true, 1);
            if (yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_searchCabins).call(this)) {
                this.saveState('route', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").routeFilter), true);
            }
        });
    }, _CruiseRoutePage_renderRouteCabins = function _CruiseRoutePage_renderRouteCabins() {
        return __awaiter(this, void 0, void 0, function* () {
            this.responseValidator = new App.ResponseValidatorOld({
                messenger: new App.BlockMessenger(new App.Messages({ root: $('.js-tab-wrap[data-tab="placement"]').find('.js-messages') })),
                validator: this.validator,
            });
            if (yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_searchCabins).call(this)) {
                this.saveState('route', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").routeFilter), true);
            }
        });
    }, _CruiseRoutePage_prepareDataForCabinSearch = function _CruiseRoutePage_prepareDataForCabinSearch() {
        const elements = __classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").routeFilter.serializeArray();
        const data = App.CruisePageBase.convertArrayToRequestData(elements);
        data.RouteNumber = this.routeNumber;
        return data;
    }, _CruiseRoutePage_updateVisaInfo = function _CruiseRoutePage_updateVisaInfo() {
        if (__classPrivateFieldGet(this, _CruiseRoutePage_visaInfo, "f") == null || __classPrivateFieldGet(this, _CruiseRoutePage_visaInfo, "f").length === 0) {
            $('.js-visa-info', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")).hide();
        }
        else {
            const ports = new App.SelectListModel({
                name: 'visaPorts',
                form: true,
                autocomplete: false,
                items: __classPrivateFieldGet(this, _CruiseRoutePage_visaInfo, "f")
                    .map((port, index) => ({
                    value: port.portKey.toString(),
                    text: port.portName,
                    selected: index === 0,
                })),
            });
            const content = $(App.templates.Cruise.Route.VisaInfo({
                visaInfo: __classPrivateFieldGet(this, _CruiseRoutePage_visaInfo, "f"),
                ports: ports,
                isNeedVisaHref: this.options.isNeedVisaHref,
            }));
            $('.js-visa-info-content', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")).empty().append(content);
            $('.js-visa-info', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")).show();
            this.components.push(new App.Filter({ root: $('.js-visa-info-content', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")) }));
            // Переключаем порты
            const visaInfoBlock = $('.js-visa-info-content', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"));
            visaInfoBlock.on('change', '.js-route-visa-port-select .js-jelect', e => __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onVisaPortChange).call(this, e));
            // Переключаем визы
            const routeVisaOptions = $('.js-routeVisa-option', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"));
            routeVisaOptions.on('click', e => __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onVisaInfoClick).call(this, e));
        }
    }, _CruiseRoutePage_updatePriceInfo = function _CruiseRoutePage_updatePriceInfo() {
        if (__classPrivateFieldGet(this, _CruiseRoutePage_priceInfo, "f") != null) {
            const content = $(App.templates.Cruise.Route.PriceInfo({ priceInfo: __classPrivateFieldGet(this, _CruiseRoutePage_priceInfo, "f") }));
            $('.js-route-price-info-data', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")).empty().append(content);
        }
    }, _CruiseRoutePage_updateScheduleInfo = function _CruiseRoutePage_updateScheduleInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseRoutePage_scheduleInfo, "f") != null && __classPrivateFieldGet(this, _CruiseRoutePage_scheduleInfo, "f").length !== 0) {
                const content = $(App.templates.Cruise.Route.ScheduleInfo({ schedules: __classPrivateFieldGet(this, _CruiseRoutePage_scheduleInfo, "f") }));
                $('.js-route-schedule-info .js-route-schedule-info-data', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"))
                    .empty()
                    .append(content);
                __classPrivateFieldSet(this, _CruiseRoutePage_routeVariantOption, $('.js-routeVariant-option', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")), "f");
                __classPrivateFieldSet(this, _CruiseRoutePage_routeVariantBlock, $('.js-routeVariant-block', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")), "f");
                __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantOption, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_onVariantClick).call(this, e); }));
                __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantOption, "f").filter('._active').trigger('click');
            }
        });
    }, _CruiseRoutePage_getCruiseSchedule = function _CruiseRoutePage_getCruiseSchedule(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: this.options.urls.getCruiseSchedule,
                method: 'POST',
                data: { cruiseKey: key },
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return;
                const blockDescr = $(App.templates.Cruise.Route.Schedule({ schedules: response.data.items, info: response.data.info }));
                $(`.${__classPrivateFieldGet(this, _CruiseRoutePage_cruiseScheduleWrapClass, "f")}`, $('.js-popup')).empty().append(blockDescr);
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
        });
    }, _CruiseRoutePage_getVariantInfo = function _CruiseRoutePage_getVariantInfo(cruiseKey, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const adults = $('[data-input-name="people_men"]', __classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").routeFilter).val();
            const children = $('.js-filter-person-input', __classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").routeFilter)
                .not(':disabled')
                .get()
                .map(v => $(v).valNumber());
            const xhr = $.ajax({
                url: this.options.urls.getCruisePortsInfo,
                method: 'POST',
                data: { cruiseKey, adultCount: adults, childrenAges: children },
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return;
                const schedule = __classPrivateFieldGet(this, _CruiseRoutePage_scheduleInfo, "f").find(s => s.cruiseKey === cruiseKey);
                const blockDescr = $(App.templates.Cruise.Route.PortInfo({
                    ports: response.data.items,
                    routeImageUrl: schedule ? schedule.routeImageUrl : '',
                    ship: __classPrivateFieldGet(this, _CruiseRoutePage_routeCabinGroups, "f")[0].ship,
                    path: (new App.QueryParams(window.location.pathname)).getController(),
                }));
                __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantOption, "f").filter(`[data-variant="${id}"]`).attr('data-loaded', '1');
                __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantBlock, "f").filter(`[data-variant="${id}"]`).empty().append(blockDescr);
                this.components.push(
                // инициализация фоток
                new App.TourInfoSlider({ wrap: `.js-routeVariant-block[data-variant="${id}"] .js-tour-info-slider-wrap` }));
                $('.lazy').Lazy();
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
        });
    }, _CruiseRoutePage_searchCabins = function _CruiseRoutePage_searchCabins() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            App.CruisePageBase.hide($('.js-route-search-results', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"))); // блок результатов поиска вместе с заголовком
            let success = false;
            const data = __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_prepareDataForCabinSearch).call(this);
            const xhr = $.ajax({
                url: this.options.urls.searchCabins,
                method: 'POST',
                data,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseRoutePage_popup2, "f").show({
                group: 'main',
                content: App.templates.Cruise.Messages.Searching({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null) {
                    this.updateSeo(response.data.seo);
                    this.seo.route = response.data.seo;
                }
                if (response.data.priceInfo)
                    __classPrivateFieldSet(this, _CruiseRoutePage_priceInfo, response.data.priceInfo, "f");
                if (response.data.visaInfo)
                    __classPrivateFieldSet(this, _CruiseRoutePage_visaInfo, response.data.visaInfo, "f");
                if (response.data.scheduleInfo)
                    __classPrivateFieldSet(this, _CruiseRoutePage_scheduleInfo, response.data.scheduleInfo, "f");
                // Определение наличия результатов поиска
                if (response.data.offers && response.data.offers.length > 0) {
                    __classPrivateFieldSet(this, _CruiseRoutePage_isLuxeMode, response.data.isLuxeMode, "f");
                    response.data.offers.forEach(v => {
                        v.isPGManager = this.options.isPGManager;
                        v.isLuxeMode = __classPrivateFieldGet(this, _CruiseRoutePage_isLuxeMode, "f");
                    });
                    __classPrivateFieldSet(this, _CruiseRoutePage_routeCabinGroups, response.data.offers, "f");
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        customRefresh: true,
                        isContainerPopup: true,
                        root: this.root,
                    });
                    App.CruisePageBase.show($('.js-route-search-results', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f")));
                    yield __classPrivateFieldGet(this, _CruiseRoutePage_routeResult, "f").changeDataSource(__classPrivateFieldGet(this, _CruiseRoutePage_routeCabinGroups, "f"));
                    yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_updateScheduleInfo).call(this);
                    this.components.push(
                    // инициализация Печать программы
                    new App.PrintComponent({
                        modes: {
                            'text': 'Программа без картинок',
                            'image': 'Программа с картинками',
                            'default': 'Страница целиком',
                        },
                    }));
                    __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_updatePriceInfo).call(this);
                    __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_updateVisaInfo).call(this);
                    success = true;
                    return true;
                }
                __classPrivateFieldGet(this, _CruiseRoutePage_routeResult, "f").resetDataSource();
                return false;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseRoutePage_popup2, "f").hide(popupGroup);
            }
            return success;
        });
    }, _CruiseRoutePage_updateCabins = function _CruiseRoutePage_updateCabins(cruiseKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_prepareDataForCabinSearch).call(this);
            data.cruiseKey = cruiseKey;
            const xhr = $.ajax({
                url: this.options.urls.updateCabins,
                method: 'POST',
                data,
            });
            const button = $(`.js-cruise-group-show-more-open[data-cruiseid="${cruiseKey}"] .js-cruise-group-show-more-link`, __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"));
            const loading = button.find('.loading');
            let success = false;
            App.CruisePageBase.show(loading);
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.offers) {
                    __classPrivateFieldSet(this, _CruiseRoutePage_routeCabins, response.data.offers, "f");
                    __classPrivateFieldGet(this, _CruiseRoutePage_routeCabins, "f").forEach(v => {
                        v.cabin.experienceLink = v.cabin.experience == null ?
                            '' : `/help/cruise/msc-cruises/cabin-experience/${v.cabin.experience.toLowerCase().replace(' ', '-')}/`;
                    });
                    success = true;
                    return true;
                }
                return false;
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                App.CruisePageBase.hide(loading);
            }
            return success;
        });
    }, _CruiseRoutePage_findRouteGroup = function _CruiseRoutePage_findRouteGroup(id) {
        return __classPrivateFieldGet(this, _CruiseRoutePage_routeCabinGroups, "f").find(v => v.key === id);
    }, _CruiseRoutePage_onOpenGroupCabinsClick = function _CruiseRoutePage_onOpenGroupCabinsClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            const target = $(event.currentTarget).closest('.js-route-group-cabin-title');
            const id = Number(target.attr('data-cruiseid'));
            const groupObj = __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_findRouteGroup).call(this, id);
            if (!groupObj)
                return;
            groupObj.isOpen = true;
            const group = target.closest('.js-route-group-cabin');
            const cabinWrap = group.find('.js-route-group-cabin-content');
            const cabinItems = group.find('.js-offer-cabin-items');
            const linksToChange = group.find('.js-needChange');
            if ((!groupObj.items || groupObj.items.length === 0) && (yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_updateCabins).call(this, id.toString())))
                groupObj.items = __classPrivateFieldGet(this, _CruiseRoutePage_routeCabins, "f");
            if (groupObj.items.length > 0) {
                const content = $(App.templates.Cruise.Route.CabinOffer({ cabins: groupObj.items, isLuxeMode: __classPrivateFieldGet(this, _CruiseRoutePage_isLuxeMode, "f") }));
                cabinItems.empty().append(content);
            }
            else {
                const content = '<div class="alert">' + localizer.noOffers + '</div>';
                cabinItems.empty().append(content);
            }
            group.addClass('_open');
            cabinWrap.show();
            if (linksToChange.length > 0) {
                linksToChange.switchClass('js-cruise-group-show-more-open', 'js-cruise-group-show-more-close');
                linksToChange.find('.js-cruise-group-show-more-link').find('.pseudo-link').html(localizer.hideAvailability);
            }
        });
    }, _CruiseRoutePage_onCloseGroupCabinsClick = function _CruiseRoutePage_onCloseGroupCabinsClick(event) {
        event.preventDefault();
        event.stopPropagation();
        let target = $(event.currentTarget).closest('.js-route-group-cabin-title');
        if (target.length === 0)
            target = $(event.currentTarget).parents('.js-route-group-cabin').find('.js-route-group-cabin-title');
        const id = Number(target.attr('data-cruiseid'));
        const groupObj = __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_findRouteGroup).call(this, id);
        if (!groupObj)
            return;
        groupObj.isOpen = false;
        const group = target.closest('.js-route-group-cabin');
        const cabinWrap = group.find('.js-route-group-cabin-content');
        const linksToChange = group.find('.js-needChange');
        group.removeClass('_open');
        cabinWrap.hide();
        if (linksToChange.length > 0) {
            linksToChange.switchClass('js-cruise-group-show-more-close', 'js-cruise-group-show-more-open');
            linksToChange.find('.js-cruise-group-show-more-link').find('.pseudo-link').html(localizer.seeAvailability);
        }
        const scrollTo = $('.js-scroll-to', group);
        scrollTo.on('click', e => App.scrollLinkClickHandler(e));
    }, _CruiseRoutePage_onVisaInfoClick = function _CruiseRoutePage_onVisaInfoClick(event) {
        const target = $(event.currentTarget);
        const id = Number(target.attr('data-visablock'));
        const isActive = target.hasClass('_active');
        if (!isActive) {
            const links = $('.js-routeVisa-option', '.js-route-visa-port-block._active');
            links.removeClass('_active');
            target.addClass('_active');
            const visaBlocks = $('.js-routeVisa-block', '.js-route-visa-port-block._active');
            visaBlocks.removeClass('_active');
            visaBlocks.hide();
            const tab = visaBlocks.filter(`[data-visablock="${id}"]`);
            tab.fadeIn(300);
            tab.addClass('_active');
        }
    }, _CruiseRoutePage_onVisaPortChange = function _CruiseRoutePage_onVisaPortChange(event) {
        const target = $(event.currentTarget);
        const portKey = target.valString();
        const routeVisaPortBlocks = $('.js-route-visa-port-block', __classPrivateFieldGet(this, _CruiseRoutePage_routeWrap, "f"));
        routeVisaPortBlocks.removeClass('_active');
        routeVisaPortBlocks.filter(`[data-visaport="${portKey}"]`).addClass('_active');
    }, _CruiseRoutePage_onScheduleClick = function _CruiseRoutePage_onScheduleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.popupInfo)
            App.popupHide();
        this.popupInfo = new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _CruiseRoutePage_cruiseScheduleWrapClass, "f")} cruise-schedule user-content"><div style='padding:10px;'><img src='/img/main/load-sm.gif'/></div></div>`),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _a; return yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_getCruiseSchedule).call(this, (_a = $(event.currentTarget).attr('data-key')) !== null && _a !== void 0 ? _a : ''); }),
        });
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _CruiseRoutePage_onRouteFilterSearch = function _CruiseRoutePage_onRouteFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_renderRouteCabins).call(this);
        });
    }, _CruiseRoutePage_onVariantClick = function _CruiseRoutePage_onVariantClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const id = Number(target.attr('data-variant'));
            const cruise = Number(target.attr('data-cruise'));
            const isActive = target.hasClass('_active');
            const isLoaded = Number(target.attr('data-loaded'));
            if (isLoaded === 0) {
                yield __classPrivateFieldGet(this, _CruiseRoutePage_instances, "m", _CruiseRoutePage_getVariantInfo).call(this, cruise, id);
            }
            // Показываем нужную программу
            if (!isActive) {
                __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantOption, "f").removeClass('_active');
                target.addClass('_active');
                __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantBlock, "f").removeClass('_active');
                __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantBlock, "f").hide();
                const tab = __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantBlock, "f").filter(`[data-variant="${id}"]`);
                tab.fadeIn(300);
            }
        });
    }, _CruiseRoutePage_onPortChange = function _CruiseRoutePage_onPortChange() {
        const portKey = __classPrivateFieldGet(this, _CruiseRoutePage_routeFilter, "f").root.find('[data-select="port"] input').valString();
        const keys = portKey.split(',');
        __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantOption, "f").each((i, v) => {
            const jqElement = $(v);
            jqElement.toggleByClass((keys.includes(jqElement.attr('data-port') || '')) || portKey === '');
        });
        __classPrivateFieldGet(this, _CruiseRoutePage_routeVariantOption, "f").find(':visible').first().trigger('click');
    };
    App.CruiseRoutePage = CruiseRoutePage;
})(App || (App = {}));
/// <reference path='CruisePageBase.Mobile.ts' />
var App;
(function (App) {
    var _CruiseSearchPageMobile_instances, _CruiseSearchPageMobile_formMainFilter, _CruiseSearchPageMobile_filter, _CruiseSearchPageMobile_result, _CruiseSearchPageMobile_searchWrapClass, _CruiseSearchPageMobile_searchWrap, _CruiseSearchPageMobile_hotFilter, _CruiseSearchPageMobile_cruiseReionList, _CruiseSearchPageMobile_searchXhr, _CruiseSearchPageMobile_searchHotFilterClass, _CruiseSearchPageMobile_routeResults, _CruiseSearchPageMobile_run, _CruiseSearchPageMobile_showSearchPage, _CruiseSearchPageMobile_showSearchResultsPage, _CruiseSearchPageMobile_searchRoutes, _CruiseSearchPageMobile_onMainFilterSearch, _CruiseSearchPageMobile_onHotFilterBeforeFiltering;
    class CruiseSearchPageMobile extends App.CruisePageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-page .js-app-container-content' }, options));
            _CruiseSearchPageMobile_instances.add(this);
            _CruiseSearchPageMobile_formMainFilter.set(this, void 0);
            _CruiseSearchPageMobile_filter.set(this, void 0);
            _CruiseSearchPageMobile_result.set(this, void 0);
            _CruiseSearchPageMobile_searchWrapClass.set(this, void 0);
            _CruiseSearchPageMobile_searchWrap.set(this, void 0);
            _CruiseSearchPageMobile_hotFilter.set(this, void 0);
            _CruiseSearchPageMobile_cruiseReionList.set(this, void 0);
            _CruiseSearchPageMobile_searchXhr.set(this, void 0);
            // обертка для результатов поиска и вторичного фильтра
            _CruiseSearchPageMobile_searchHotFilterClass.set(this, void 0);
            _CruiseSearchPageMobile_routeResults.set(this, []);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_searchWrapClass, '.js-cruise-search-results', "f");
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_cruiseReionList, $('.js-cruise-regions-output', this.root), "f");
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_searchHotFilterClass, '.js-cruise-search-results .js-cruise-search-results-hot-filter', "f");
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_searchWrap, $(__classPrivateFieldGet(this, _CruiseSearchPageMobile_searchWrapClass, "f"), this.root), "f");
            this.states = {
                'search': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _CruiseSearchPageMobile_instances, "m", _CruiseSearchPageMobile_showSearchPage).call(this))),
                    actionName: 'search',
                    keysForUrl: [],
                },
                'search_results': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _CruiseSearchPageMobile_instances, "m", _CruiseSearchPageMobile_showSearchResultsPage).call(this))),
                    actionName: 'search',
                    keysForUrl: ['fare', 'region', 'port', 'ship', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_filter, new App.CruiseSearchMainFilterMobile({
                root: '.js-cruise-main-filter',
                urls: this.options.urls,
                defaults: this.options.defaults,
                checkin: this.options.checkin,
                changes: this.options.changes,
                peopleOptions: {
                    maxChildAge: this.options.defaults.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: this.options.defaults.defaultCheckinDateShift,
                    defaultDateToOffset: this.options.defaults.defaultCheckinDateInterval,
                    maxDateToOffset: this.options.defaults.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: this.options.defaults.minPrice,
                    max: this.options.defaults.maxPrice,
                },
            }), "f");
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_formMainFilter, new App.Form({ root: __classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter }), "f");
            this.validator = __classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter.validate({ ignore: '.filter-slider-input' });
            this.responseValidator = new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_hotFilter, new App.CruiseHotFilterMobile({
                root: __classPrivateFieldGet(this, _CruiseSearchPageMobile_searchHotFilterClass, "f"),
            }), "f");
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_result, new App.CruiseResultMobile({
                root: __classPrivateFieldGet(this, _CruiseSearchPageMobile_searchWrapClass, "f"),
                hotFilter: __classPrivateFieldGet(this, _CruiseSearchPageMobile_hotFilter, "f"),
            }), "f");
            __classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseSearchPageMobile_instances, "m", _CruiseSearchPageMobile_onMainFilterSearch).call(this); }));
            __classPrivateFieldGet(this, _CruiseSearchPageMobile_hotFilter, "f").hotFilter.on("hotFilter:beforeFiltering" /* Events.HotFilterBeforeFiltering */, (_, filters, element) => __classPrivateFieldGet(this, _CruiseSearchPageMobile_instances, "m", _CruiseSearchPageMobile_onHotFilterBeforeFiltering).call(this, filters, element));
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield this.onHistoryStateChange(); }));
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _CruiseSearchPageMobile_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            const queryParams = new App.QueryParams(window.location.pathname);
            App.History.replaceState(this.state, queryParams.getUrl());
            (() => __awaiter(this, void 0, void 0, function* () {
                yield new Promise(resolve => setTimeout(resolve, 0));
                __classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").initializeFromUrl(queryParams);
                yield __classPrivateFieldGet(this, _CruiseSearchPageMobile_instances, "m", _CruiseSearchPageMobile_run).call(this);
            }))();
        }
        renderSearchResultsPage() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.validator.form())
                    return;
                App.CruisePageMobileBase.show(__classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter, true, 1);
                if (!(yield __classPrivateFieldGet(this, _CruiseSearchPageMobile_instances, "m", _CruiseSearchPageMobile_searchRoutes).call(this)))
                    return;
                this.showSearchResults();
                let isStateReplace = false;
                if (this.state !== 'search')
                    isStateReplace = true;
                this.saveState('search_results', this.getParamsFromFiltersMobile(__classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").filters), null, isStateReplace);
            });
        }
        showSearchResults() {
            App.CruisePageMobileBase.show(__classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter, true, 1);
            App.CruisePageMobileBase.show(__classPrivateFieldGet(this, _CruiseSearchPageMobile_searchWrap, "f"));
        }
        cleanPage() {
            App.CruisePageMobileBase.hide(__classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter);
            App.CruisePageMobileBase.hide(__classPrivateFieldGet(this, _CruiseSearchPageMobile_searchWrap, "f"));
        }
        prepareDataForSearch() {
            var _a;
            let elements = __classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").filters.serializeArray();
            const priceValue = (_a = elements.find(x => x.name == 'price')) === null || _a === void 0 ? void 0 : _a.value;
            elements = elements.filter(x => x.name != 'price');
            elements.push({
                name: 'Price.From',
                value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[0],
            });
            elements.push({
                name: 'Price.To',
                value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[1],
            });
            const currencyFilter = $('.filter_price_currency');
            if (currencyFilter) {
                elements.push({
                    name: currencyFilter.attr('name'),
                    value: currencyFilter.attr('value'),
                });
            }
            const city = elements.find(x => x.name == 'City');
            if (city && !city.value) {
                city.value = '0';
            }
            if (this.options.searchData.length > 0)
                elements = this.options.searchData;
            return App.CruisePageMobileBase.convertArrayToRequestData(elements);
        }
        onHistoryStateChange() {
            return __awaiter(this, void 0, void 0, function* () {
                this.state = App.History.getState();
                this.updateSeo(this.seo[this.state]);
                yield this.run(App.noneSignal);
            });
        }
    }
    _CruiseSearchPageMobile_formMainFilter = new WeakMap(), _CruiseSearchPageMobile_filter = new WeakMap(), _CruiseSearchPageMobile_result = new WeakMap(), _CruiseSearchPageMobile_searchWrapClass = new WeakMap(), _CruiseSearchPageMobile_searchWrap = new WeakMap(), _CruiseSearchPageMobile_hotFilter = new WeakMap(), _CruiseSearchPageMobile_cruiseReionList = new WeakMap(), _CruiseSearchPageMobile_searchXhr = new WeakMap(), _CruiseSearchPageMobile_searchHotFilterClass = new WeakMap(), _CruiseSearchPageMobile_routeResults = new WeakMap(), _CruiseSearchPageMobile_instances = new WeakSet(), _CruiseSearchPageMobile_run = function _CruiseSearchPageMobile_run() {
        return __awaiter(this, void 0, void 0, function* () {
            this.cleanPage();
            yield this.states[this.state].handler();
        });
    }, _CruiseSearchPageMobile_showSearchPage = function _CruiseSearchPageMobile_showSearchPage() {
        App.CruisePageMobileBase.show(__classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter, true, 1);
    }, _CruiseSearchPageMobile_showSearchResultsPage = function _CruiseSearchPageMobile_showSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: если поиска маршрутов не было или результаты поиска отличаются от формы => новый поиск
            if (!__classPrivateFieldGet(this, _CruiseSearchPageMobile_routeResults, "f"))
                yield this.renderSearchResultsPage();
            else if (__classPrivateFieldGet(this, _CruiseSearchPageMobile_filter, "f").searchFilter.length === 0)
                window.location.reload();
            else
                this.showSearchResults();
        });
    }, _CruiseSearchPageMobile_searchRoutes = function _CruiseSearchPageMobile_searchRoutes() {
        return __awaiter(this, arguments, void 0, function* (onlySearch = false) {
            if (this.searchExecuting)
                return false;
            this.searchExecuting = true;
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            this.preloader.show();
            if (!onlySearch)
                __classPrivateFieldGet(this, _CruiseSearchPageMobile_result, "f").resetDataSource();
            const data = this.prepareDataForSearch();
            if (this.context)
                data.context = this.context;
            __classPrivateFieldSet(this, _CruiseSearchPageMobile_searchXhr, $.ajax({
                url: this.options.urls.searchRoutes,
                method: 'POST',
                data,
            }), "f");
            let success = false;
            try {
                const response = yield __classPrivateFieldGet(this, _CruiseSearchPageMobile_searchXhr, "f");
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null) {
                    this.updateSeo(response.data.seo);
                    this.seo.search = response.data.seo;
                    this.seo.search_results = response.data.seo;
                }
                if (response.data.offers && response.data.offers.length > 0) {
                    response.data.offers.forEach(v => {
                        v.regions = v.regionElements.map(z => z.value).join(', ');
                        v.route = App.CruisePageMobileBase.abbreviateMulti(v.routeElements.map(z => z.value).join(', '), 75, '...');
                        v.portsDeparture = v.portDepartureElements.map(z => z.value).join(', ');
                        v.isPGManager = this.options.isPGManager;
                    });
                    __classPrivateFieldSet(this, _CruiseSearchPageMobile_routeResults, response.data.offers, "f");
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: this.options.urls.searchRoutes,
                    });
                    if (!onlySearch) {
                        yield __classPrivateFieldGet(this, _CruiseSearchPageMobile_result, "f").changeDataSource(__classPrivateFieldGet(this, _CruiseSearchPageMobile_routeResults, "f"));
                        __classPrivateFieldGet(this, _CruiseSearchPageMobile_hotFilter, "f").refreshHotFilters(response.data.offers, [], undefined, data.RusGroup[0] === 'true');
                    }
                    const scrollOffset = __classPrivateFieldGet(this, _CruiseSearchPageMobile_hotFilter, "f").root.offset();
                    if (scrollOffset)
                        window.scrollTo(scrollOffset.left, scrollOffset.top);
                    success = true;
                }
                else {
                    __classPrivateFieldGet(this, _CruiseSearchPageMobile_result, "f").resetDataSource();
                }
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                this.searchExecuting = false;
                this.preloader.hide();
            }
            return success;
        });
    }, _CruiseSearchPageMobile_onMainFilterSearch = function _CruiseSearchPageMobile_onMainFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseSearchPageMobile_formMainFilter, "f").validator.form())
                return;
            __classPrivateFieldGet(this, _CruiseSearchPageMobile_cruiseReionList, "f").hideByClass();
            yield this.renderSearchResultsPage();
        });
    }, _CruiseSearchPageMobile_onHotFilterBeforeFiltering = function _CruiseSearchPageMobile_onHotFilterBeforeFiltering(filters, element) {
        __classPrivateFieldGet(this, _CruiseSearchPageMobile_hotFilter, "f").refreshHotFilters(__classPrivateFieldGet(this, _CruiseSearchPageMobile_routeResults, "f"), filters, element);
        // this.saveState("route", null, this.getParamsFromFilters(this._routeHotFilter.routeHotFilter, "route"), true);
    };
    App.CruiseSearchPageMobile = CruiseSearchPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseSearchPage_instances, _CruiseSearchPage_formMainFilter, _CruiseSearchPage_filter, _CruiseSearchPage_result, _CruiseSearchPage_searchWrapClass, _CruiseSearchPage_searchWrap, _CruiseSearchPage_hotFilter, _CruiseSearchPage_cruiseReionList, _CruiseSearchPage_searchXhr, _CruiseSearchPage_searchHotFilterClass, _CruiseSearchPage_routeResults, _CruiseSearchPage_showSearchPage, _CruiseSearchPage_showSearchResultsPage, _CruiseSearchPage_searchRoutes, _CruiseSearchPage_onMainFilterSearch, _CruiseSearchPage_onHotFilterBeforeFiltering;
    class CruiseSearchPage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-page .js-app-container-content' }, options));
            _CruiseSearchPage_instances.add(this);
            _CruiseSearchPage_formMainFilter.set(this, void 0);
            _CruiseSearchPage_filter.set(this, void 0);
            _CruiseSearchPage_result.set(this, void 0);
            _CruiseSearchPage_searchWrapClass.set(this, void 0);
            _CruiseSearchPage_searchWrap.set(this, void 0);
            _CruiseSearchPage_hotFilter.set(this, void 0);
            _CruiseSearchPage_cruiseReionList.set(this, void 0);
            _CruiseSearchPage_searchXhr.set(this, void 0);
            // обертка для результатов поиска и вторичного фильтра
            _CruiseSearchPage_searchHotFilterClass.set(this, void 0);
            _CruiseSearchPage_routeResults.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseSearchPage_searchWrapClass, '.js-cruise-search-results', "f");
            __classPrivateFieldSet(this, _CruiseSearchPage_cruiseReionList, $('.js-cruise-regions-output', this.root), "f");
            __classPrivateFieldSet(this, _CruiseSearchPage_searchHotFilterClass, '.js-cruise-search-results .js-cruise-search-results-hot-filter', "f");
            __classPrivateFieldSet(this, _CruiseSearchPage_searchWrap, $(__classPrivateFieldGet(this, _CruiseSearchPage_searchWrapClass, "f"), this.root), "f");
            this.states = {
                'search': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _CruiseSearchPage_instances, "m", _CruiseSearchPage_showSearchPage).call(this))),
                    actionName: 'search',
                    keysForUrl: [],
                },
                'search_results': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _CruiseSearchPage_instances, "m", _CruiseSearchPage_showSearchResultsPage).call(this))),
                    actionName: 'search',
                    keysForUrl: ['fare', 'region', 'port', 'ship', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseSearchPage_filter, new App.CruiseSearchMainFilter({
                root: '.js-cruise-main-filter',
                urls: this.options.urls,
                defaults: this.options.defaults,
                checkin: this.options.checkin,
                changes: this.options.changes,
                peopleOptions: {
                    maxChildAge: App.app.settings.cruiseOptions.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: App.app.settings.cruiseOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.cruiseOptions.defaultCheckinDateInterval,
                    maxDateToOffset: App.app.settings.cruiseOptions.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: App.app.settings.cruiseOptions.minPrice,
                    max: App.app.settings.cruiseOptions.maxPrice,
                },
            }), "f");
            __classPrivateFieldSet(this, _CruiseSearchPage_formMainFilter, new App.Form({ root: __classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter }), "f");
            this.validator = __classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter.validate({ ignore: '.filter-slider-input' });
            this.responseValidator = new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            __classPrivateFieldSet(this, _CruiseSearchPage_hotFilter, new App.CruiseHotFilter({
                root: __classPrivateFieldGet(this, _CruiseSearchPage_searchHotFilterClass, "f"),
            }), "f");
            __classPrivateFieldSet(this, _CruiseSearchPage_result, new App.CruiseResult({
                root: __classPrivateFieldGet(this, _CruiseSearchPage_searchWrapClass, "f"),
                hotFilter: __classPrivateFieldGet(this, _CruiseSearchPage_hotFilter, "f"),
            }), "f");
            __classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseSearchPage_instances, "m", _CruiseSearchPage_onMainFilterSearch).call(this); }));
            __classPrivateFieldGet(this, _CruiseSearchPage_hotFilter, "f").hotFilter.on("hotFilter:beforeFiltering" /* Events.HotFilterBeforeFiltering */, (_, filters, element) => __classPrivateFieldGet(this, _CruiseSearchPage_instances, "m", _CruiseSearchPage_onHotFilterBeforeFiltering).call(this, filters, element));
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield this.onHistoryStateChange(); }));
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _CruiseSearchPage_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            App.History.replaceState(this.state, new App.QueryParams(window.location.pathname).getUrl());
        }
        renderSearchResultsPage() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.validator.form())
                    return;
                App.CruisePageBase.show(__classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter, true, 1);
                if (!(yield __classPrivateFieldGet(this, _CruiseSearchPage_instances, "m", _CruiseSearchPage_searchRoutes).call(this)))
                    return;
                this.showSearchResults();
                let isStateReplace = false;
                if (this.state !== 'search')
                    isStateReplace = true;
                this.saveState('search_results', this.getParamsFromFilters(__classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter), null, isStateReplace);
            });
        }
        showSearchResults() {
            App.CruisePageBase.show(__classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter, true, 1);
            App.CruisePageBase.show(__classPrivateFieldGet(this, _CruiseSearchPage_searchWrap, "f"));
        }
        cleanPage() {
            // TODO: скрываем только результаты, фильтр оставляем видимым, чтобы пользователь мог изменить критерии поиска.
            // CruisePageBase.hide(this.#filter.searchFilter);
            App.CruisePageBase.hide(__classPrivateFieldGet(this, _CruiseSearchPage_searchWrap, "f"));
        }
        prepareDataForSearch() {
            let elements = __classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter.serializeArray();
            if (this.options.searchData.length > 0)
                elements = this.options.searchData;
            return App.CruisePageBase.convertArrayToRequestData(elements);
        }
        onHistoryStateChange() {
            return __awaiter(this, void 0, void 0, function* () {
                this.state = App.History.getState();
                this.updateSeo(this.seo[this.state]);
                yield this.run(App.noneSignal);
            });
        }
    }
    _CruiseSearchPage_formMainFilter = new WeakMap(), _CruiseSearchPage_filter = new WeakMap(), _CruiseSearchPage_result = new WeakMap(), _CruiseSearchPage_searchWrapClass = new WeakMap(), _CruiseSearchPage_searchWrap = new WeakMap(), _CruiseSearchPage_hotFilter = new WeakMap(), _CruiseSearchPage_cruiseReionList = new WeakMap(), _CruiseSearchPage_searchXhr = new WeakMap(), _CruiseSearchPage_searchHotFilterClass = new WeakMap(), _CruiseSearchPage_routeResults = new WeakMap(), _CruiseSearchPage_instances = new WeakSet(), _CruiseSearchPage_showSearchPage = function _CruiseSearchPage_showSearchPage() {
        App.CruisePageBase.show(__classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter, true, 1);
    }, _CruiseSearchPage_showSearchResultsPage = function _CruiseSearchPage_showSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: если поиска маршрутов не было или результаты поиска отличаются от формы => новый поиск
            if (!__classPrivateFieldGet(this, _CruiseSearchPage_routeResults, "f"))
                yield this.renderSearchResultsPage();
            else if (__classPrivateFieldGet(this, _CruiseSearchPage_filter, "f").searchFilter.length === 0)
                window.location.reload();
            else
                this.showSearchResults();
        });
    }, _CruiseSearchPage_searchRoutes = function _CruiseSearchPage_searchRoutes() {
        return __awaiter(this, arguments, void 0, function* (onlySearch = false) {
            if (this.searchExecuting)
                return false;
            this.searchExecuting = true;
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            this.preloader.show();
            if (!onlySearch)
                __classPrivateFieldGet(this, _CruiseSearchPage_result, "f").resetDataSource();
            const data = this.prepareDataForSearch();
            if (this.context)
                data.context = this.context;
            __classPrivateFieldSet(this, _CruiseSearchPage_searchXhr, $.ajax({
                url: this.options.urls.searchRoutes,
                method: 'POST',
                data,
            }), "f");
            let success = false;
            try {
                const response = yield __classPrivateFieldGet(this, _CruiseSearchPage_searchXhr, "f");
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null) {
                    this.updateSeo(response.data.seo);
                    this.seo.search = response.data.seo;
                    this.seo.search_results = response.data.seo;
                }
                // Определение наличия результатов поиска
                if (response.data.offers && response.data.offers.length > 0) {
                    response.data.offers.forEach(v => {
                        v.regions = v.regionElements.map(z => z.value).join(', ');
                        v.route = App.CruisePageBase.abbreviateMulti(v.routeElements.map(z => z.value).join(', '), 75, '...');
                        v.portsDeparture = v.portDepartureElements.map(z => z.value).join(', ');
                        v.isPGManager = this.options.isPGManager;
                    });
                    __classPrivateFieldSet(this, _CruiseSearchPage_routeResults, response.data.offers, "f");
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: this.options.urls.searchRoutes,
                    });
                    if (!onlySearch) {
                        yield __classPrivateFieldGet(this, _CruiseSearchPage_result, "f").changeDataSource(__classPrivateFieldGet(this, _CruiseSearchPage_routeResults, "f"));
                        __classPrivateFieldGet(this, _CruiseSearchPage_hotFilter, "f").refreshHotFilters(response.data.offers, [], undefined, data.RusGroup[0] === 'true');
                    }
                    // Скролл к результатам поиска
                    setTimeout(() => {
                        const scrollOffset = __classPrivateFieldGet(this, _CruiseSearchPage_searchWrap, "f").offset();
                        if (scrollOffset) {
                            $('html, body').stop(true, true);
                            window.scrollTo(0, scrollOffset.top);
                        }
                    }, 700);
                    success = true;
                }
                else {
                    __classPrivateFieldGet(this, _CruiseSearchPage_result, "f").resetDataSource();
                    App.CruisePageBase.hide(__classPrivateFieldGet(this, _CruiseSearchPage_searchWrap, "f"));
                }
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                this.searchExecuting = false;
                this.preloader.hide();
            }
            return success;
        });
    }, _CruiseSearchPage_onMainFilterSearch = function _CruiseSearchPage_onMainFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _CruiseSearchPage_formMainFilter, "f").validator.form())
                return;
            yield this.renderSearchResultsPage();
            __classPrivateFieldGet(this, _CruiseSearchPage_cruiseReionList, "f").hideByClass();
        });
    }, _CruiseSearchPage_onHotFilterBeforeFiltering = function _CruiseSearchPage_onHotFilterBeforeFiltering(filters, element) {
        __classPrivateFieldGet(this, _CruiseSearchPage_hotFilter, "f").refreshHotFilters(__classPrivateFieldGet(this, _CruiseSearchPage_routeResults, "f"), filters, element);
        // this.saveState("route", null, this.getParamsFromFilters(this._routeHotFilter.routeHotFilter, "route"), true);
    };
    App.CruiseSearchPage = CruiseSearchPage;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseShipPageMobile_instances, _a, _CruiseShipPageMobile_shipFilter, _CruiseShipPageMobile_shipResult, _CruiseShipPageMobile_shipTabs, _CruiseShipPageMobile_shipWrapClass, _CruiseShipPageMobile_shipHotFilterClass, _CruiseShipPageMobile_shipMainFilterClass, _CruiseShipPageMobile_searchResultsWrap, _CruiseShipPageMobile_deckOption, _CruiseShipPageMobile_deckDescr, _CruiseShipPageMobile_cabinOption, _CruiseShipPageMobile_shipId, _CruiseShipPageMobile_popup2, _CruiseShipPageMobile_offers, _CruiseShipPageMobile_cabinDescr, _CruiseShipPageMobile_onClickTab, _CruiseShipPageMobile_onClickDeckTab, _CruiseShipPageMobile_renderShipResults, _CruiseShipPageMobile_prepareDataForShipSearch, _CruiseShipPageMobile_searchShipRoutes, _CruiseShipPageMobile_onSwitchDeckDescr, _CruiseShipPageMobile_onSwitchCabinDescr, _CruiseShipPageMobile_onShipFilterSearch, _CruiseShipPageMobile_onServiceFeeSwitch;
    class CruiseShipPageMobile extends App.CruisePageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-ship' }, options));
            _CruiseShipPageMobile_instances.add(this);
            _CruiseShipPageMobile_shipFilter.set(this, void 0);
            _CruiseShipPageMobile_shipResult.set(this, void 0);
            _CruiseShipPageMobile_shipTabs.set(this, void 0);
            _CruiseShipPageMobile_shipWrapClass.set(this, void 0);
            _CruiseShipPageMobile_shipHotFilterClass.set(this, void 0);
            _CruiseShipPageMobile_shipMainFilterClass.set(this, void 0);
            _CruiseShipPageMobile_searchResultsWrap.set(this, void 0);
            _CruiseShipPageMobile_deckOption.set(this, void 0);
            _CruiseShipPageMobile_deckDescr.set(this, void 0);
            _CruiseShipPageMobile_cabinOption.set(this, void 0);
            _CruiseShipPageMobile_shipId.set(this, void 0);
            _CruiseShipPageMobile_popup2.set(this, void 0);
            _CruiseShipPageMobile_offers.set(this, void 0);
            _CruiseShipPageMobile_cabinDescr.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseShipPageMobile_popup2, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            __classPrivateFieldSet(this, _CruiseShipPageMobile_shipWrapClass, '.js-cruise-ship', "f");
            __classPrivateFieldSet(this, _CruiseShipPageMobile_shipHotFilterClass, '.js-ship-hot-filter', "f");
            __classPrivateFieldSet(this, _CruiseShipPageMobile_shipMainFilterClass, '.js-ship-main-filter', "f");
            __classPrivateFieldSet(this, _CruiseShipPageMobile_deckOption, $('.js-deck-descr-option', this.root), "f");
            __classPrivateFieldSet(this, _CruiseShipPageMobile_deckDescr, $('.js-deck-descr', this.root), "f");
            __classPrivateFieldSet(this, _CruiseShipPageMobile_cabinOption, $('.js-cabin-descr-option', this.root), "f");
            __classPrivateFieldSet(this, _CruiseShipPageMobile_cabinDescr, $('.js-cabin-descr', this.root), "f");
            this.scrollBookLink = $('.js-scroll-book-link', this.root);
            this.bookScrollToWrap = $('.js-book-to-scroll', this.root);
            __classPrivateFieldSet(this, _CruiseShipPageMobile_searchResultsWrap, $('.js-ship-search-results', this.root), "f");
            this.states = {
                'ship': {
                    handler: () => __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_renderShipResults).call(this),
                    actionName: 'ship',
                    keysForUrl: ['port', 'fare', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseShipPageMobile_shipId, Number($('#shipId').val()), "f");
            // инициализация формы поиска
            __classPrivateFieldSet(this, _CruiseShipPageMobile_shipFilter, new App.CruiseShipMainFilterMobile({
                root: __classPrivateFieldGet(this, _CruiseShipPageMobile_shipMainFilterClass, "f"),
                urls: this.options.urls,
                defaults: this.options.defaults,
                changes: this.options.changes,
                checkin: this.options.checkin,
                shipId: __classPrivateFieldGet(this, _CruiseShipPageMobile_shipId, "f"),
                peopleOptions: {
                    maxChildAge: App.app.settings.cruiseOptions.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: App.app.settings.cruiseOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.cruiseOptions.defaultCheckinDateInterval,
                    maxDateToOffset: App.app.settings.cruiseOptions.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: App.app.settings.cruiseOptions.minPrice,
                    max: App.app.settings.cruiseOptions.maxPrice,
                },
            }), "f");
            this.validator = __classPrivateFieldGet(this, _CruiseShipPageMobile_shipFilter, "f").root.validate({ ignore: '' });
            this.responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            this.components.push(new App.Digest({ container: this.root }));
            __classPrivateFieldSet(this, _CruiseShipPageMobile_shipResult, new App.CruiseShipResult({
                root: '.js-placement-output',
                hotFilter: new App.CruiseRouteHotFilterMobile({
                    root: __classPrivateFieldGet(this, _CruiseShipPageMobile_shipHotFilterClass, "f"),
                }),
            }), "f");
            __classPrivateFieldGet(this, _CruiseShipPageMobile_shipFilter, "f").shipFilter.on("shipFilter:search" /* Events.ShipFilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_onShipFilterSearch).call(this); }));
            $('.js-media-gallery-mobile').each((_, el) => {
                new App.MediaGalleryMobile({ self: $(el) });
            });
            // событие на клик по табу добавляем перед инициализацией табов
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_onClickTab).call(this, e); }));
            // инициализация табов
            __classPrivateFieldSet(this, _CruiseShipPageMobile_shipTabs, new App.Tabs({ self: __classPrivateFieldGet(this, _CruiseShipPageMobile_shipWrapClass, "f") }), "f");
            __classPrivateFieldGet(this, _CruiseShipPageMobile_shipTabs, "f").showActive();
            // Переключаем описание палуб
            __classPrivateFieldGet(this, _CruiseShipPageMobile_deckOption, "f").on('click', e => __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_onSwitchDeckDescr).call(this, e));
            // Переключаем описание кают
            __classPrivateFieldGet(this, _CruiseShipPageMobile_cabinOption, "f").on('click', e => __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_onSwitchCabinDescr).call(this, e));
            // прилипание/отлипание ссылки 'к бронированию'
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => this.onScrollDescrBlock()));
            $('.js-cruise-ship').on('click', '.js-placement-cabin-title.show-description', (e) => this.onCabinTitleClick(e));
            $('.js-filter-service-fee', __classPrivateFieldGet(this, _CruiseShipPageMobile_searchResultsWrap, "f")).on('click', e => __classPrivateFieldGet(_a, _a, "m", _CruiseShipPageMobile_onServiceFeeSwitch).call(_a, e));
            const queryParams = new App.QueryParams(window.location.pathname);
            if (queryParams.getParamAncher().length > 0) {
                $(`.js-placement-cabin-title[data-key="${queryParams.getParamAncher()}"]`, '.js-cruise-ship').trigger('click');
            }
        }
    }
    _a = CruiseShipPageMobile, _CruiseShipPageMobile_shipFilter = new WeakMap(), _CruiseShipPageMobile_shipResult = new WeakMap(), _CruiseShipPageMobile_shipTabs = new WeakMap(), _CruiseShipPageMobile_shipWrapClass = new WeakMap(), _CruiseShipPageMobile_shipHotFilterClass = new WeakMap(), _CruiseShipPageMobile_shipMainFilterClass = new WeakMap(), _CruiseShipPageMobile_searchResultsWrap = new WeakMap(), _CruiseShipPageMobile_deckOption = new WeakMap(), _CruiseShipPageMobile_deckDescr = new WeakMap(), _CruiseShipPageMobile_cabinOption = new WeakMap(), _CruiseShipPageMobile_shipId = new WeakMap(), _CruiseShipPageMobile_popup2 = new WeakMap(), _CruiseShipPageMobile_offers = new WeakMap(), _CruiseShipPageMobile_cabinDescr = new WeakMap(), _CruiseShipPageMobile_instances = new WeakSet(), _CruiseShipPageMobile_onClickTab = function _CruiseShipPageMobile_onClickTab(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if ($(event.currentTarget).attr('id') === 'tabDecks')
                yield __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_onClickDeckTab).call(this, event);
            if ($(event.currentTarget).attr('id') === 'placementTab') {
                if (!__classPrivateFieldGet(this, _CruiseShipPageMobile_offers, "f") || __classPrivateFieldGet(this, _CruiseShipPageMobile_offers, "f").length === 0)
                    (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_renderShipResults).call(this); }))();
            }
            if ($(event.currentTarget).attr('id') === 'info') {
                // Получаем слайдеры в программе
                const sliders = $('.js-tour-info-slider', __classPrivateFieldGet(this, _CruiseShipPageMobile_shipWrapClass, "f"));
                // Обходим каждый слайдер и принудительно выставляем первый слайд, чтобы слайдер проинициализировался
                if (sliders.length) {
                    sliders.each((index, element) => {
                        const jqElement = $(element);
                        jqElement.slick('refresh');
                    });
                }
            }
        });
    }, _CruiseShipPageMobile_onClickDeckTab = function _CruiseShipPageMobile_onClickDeckTab(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const isSvgLoaded = $(event.currentTarget).attr('svgLoader');
            if (isSvgLoaded === '0') {
                $(event.currentTarget).attr('svgLoader', '1');
                const params = {
                    root: '#svgLoader',
                    width: 599,
                    shipSchemaSvg: this.options.shipSchemeUrl,
                    deck: this.options.decks.length === 0 ? 0 : this.options.decks[0].key,
                    shipId: this.options.shipId,
                    shipCode: this.options.shipCode,
                    svgNS: 'http://www.w3.org/2000/svg',
                };
                const svgLoader = new App.CruiseSvgLoader();
                yield svgLoader.init(params, this.options.decks);
            }
        });
    }, _CruiseShipPageMobile_renderShipResults = function _CruiseShipPageMobile_renderShipResults() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageBase.hide($(__classPrivateFieldGet(this, _CruiseShipPageMobile_searchResultsWrap, "f")));
            if (!(yield __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_searchShipRoutes).call(this)))
                return;
            App.CruisePageBase.show($(__classPrivateFieldGet(this, _CruiseShipPageMobile_searchResultsWrap, "f")));
            this.saveState('ship', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruiseShipPageMobile_shipFilter, "f").shipFilter), true);
        });
    }, _CruiseShipPageMobile_prepareDataForShipSearch = function _CruiseShipPageMobile_prepareDataForShipSearch() {
        var _b;
        let elements = __classPrivateFieldGet(this, _CruiseShipPageMobile_shipFilter, "f").filters.serializeArray();
        const priceValue = (_b = elements.find(x => x.name == 'price')) === null || _b === void 0 ? void 0 : _b.value;
        elements = elements.filter(x => x.name != 'price');
        elements.push({
            name: 'Price.From',
            value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[0],
        });
        elements.push({
            name: 'Price.To',
            value: priceValue === null || priceValue === void 0 ? void 0 : priceValue.split(',')[1],
        });
        const currencyFilter = $('.filter_price_currency');
        if (currencyFilter) {
            elements.push({
                name: currencyFilter.attr('name'),
                value: currencyFilter.attr('value'),
            });
        }
        const city = elements.find(x => x.name == 'City');
        if (city && !city.value) {
            city.value = '0';
        }
        const data = App.CruisePageMobileBase.convertArrayToRequestData(elements);
        data.ship = __classPrivateFieldGet(this, _CruiseShipPageMobile_shipId, "f").toString();
        return data;
    }, _CruiseShipPageMobile_searchShipRoutes = function _CruiseShipPageMobile_searchShipRoutes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.searchExecuting)
                return false;
            this.searchExecuting = true;
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            __classPrivateFieldGet(this, _CruiseShipPageMobile_shipResult, "f").resetDataSource();
            const data = __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_prepareDataForShipSearch).call(this);
            if (this.context)
                data.context = this.context;
            const xhr = $.ajax({
                url: this.options.urls.searchRoutes,
                method: 'POST',
                data,
            });
            let returnS = false;
            const popupGroup = __classPrivateFieldGet(this, _CruiseShipPageMobile_popup2, "f").show({
                group: 'main',
                content: App.templates.Cruise.Messages.Searching({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null)
                    this.updateSeo(response.data.seo);
                if (response.data.offers && response.data.offers.length > 0) {
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: this.options.urls.searchRoutes,
                    });
                    response.data.offers.forEach(v => {
                        v.route = App.CruisePageBase.abbreviateMulti(v.routeElements.map(z => z.value).join(', '), 75, '...');
                        v.portsDeparture = v.portDepartureElements.map(z => z.value).join(', ');
                        v.isPGManager = this.options.isPGManager;
                    });
                    __classPrivateFieldSet(this, _CruiseShipPageMobile_offers, response.data.offers, "f");
                    yield __classPrivateFieldGet(this, _CruiseShipPageMobile_shipResult, "f").changeDataSource(__classPrivateFieldGet(this, _CruiseShipPageMobile_offers, "f"));
                    returnS = true;
                }
                else {
                    __classPrivateFieldGet(this, _CruiseShipPageMobile_shipResult, "f").resetDataSource();
                }
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                this.searchExecuting = false;
                __classPrivateFieldGet(this, _CruiseShipPageMobile_popup2, "f").hide(popupGroup);
            }
            return returnS;
        });
    }, _CruiseShipPageMobile_onSwitchDeckDescr = function _CruiseShipPageMobile_onSwitchDeckDescr(event) {
        const target = $(event.currentTarget);
        const id = target.attr('data-deck');
        const isActive = target.hasClass('_active');
        // Показываем нужное описание
        if (!isActive) {
            __classPrivateFieldGet(this, _CruiseShipPageMobile_deckOption, "f").removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPageMobile_deckDescr, "f").removeClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPageMobile_deckDescr, "f").hide();
            const tab = __classPrivateFieldGet(this, _CruiseShipPageMobile_deckDescr, "f").filter(`[data-deck="${id}"]`).addClass('_active');
            const number = Number(target.attr('data-deck-number'));
            target.trigger("cruiseSvgLoader:deckChange" /* Events.CruiseSvgLoaderDeckChange */, number);
            tab.fadeIn(300, () => {
                $('.js-cabin-descr-option', tab).eq(0).trigger('click');
            });
        }
    }, _CruiseShipPageMobile_onSwitchCabinDescr = function _CruiseShipPageMobile_onSwitchCabinDescr(event) {
        const target = $(event.currentTarget);
        const id = target.attr('data-cabin');
        const isActive = target.hasClass('_active');
        // Показываем нужное описание
        if (!isActive) {
            __classPrivateFieldGet(this, _CruiseShipPageMobile_cabinOption, "f").removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPageMobile_cabinDescr, "f").removeClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPageMobile_cabinDescr, "f").hide();
            const tab = __classPrivateFieldGet(this, _CruiseShipPageMobile_cabinDescr, "f").filter(`[data-cabin="${id}"]`).addClass('_active');
            tab.fadeIn(200, () => {
                // инициализация фоток в каютах
                const wrapper = $('.js-ship-cabin-gallery .js-media-gallery', tab);
                if (!wrapper.data('swiper-initialized')) {
                    this.components.push(new App.MediaGallery({ wrap: '.js-cabin-descr._active' }));
                }
                const swiper = wrapper.data('swiper-instance');
                if (swiper) {
                    swiper.update();
                    if (swiper.thumbs && swiper.thumbs.swiper) {
                        swiper.thumbs.swiper.update();
                    }
                }
            });
        }
    }, _CruiseShipPageMobile_onShipFilterSearch = function _CruiseShipPageMobile_onShipFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _CruiseShipPageMobile_shipTabs, "f").show('placement');
            yield __classPrivateFieldGet(this, _CruiseShipPageMobile_instances, "m", _CruiseShipPageMobile_renderShipResults).call(this);
        });
    }, _CruiseShipPageMobile_onServiceFeeSwitch = function _CruiseShipPageMobile_onServiceFeeSwitch(event) {
        const target = $(event.currentTarget);
        const filterFeeBtn = target.find('.js-sliding-btn');
        const serviceFee = $('.js-service-fee', '.js-ship-route-output');
        if (filterFeeBtn.hasClass('_on')) {
            serviceFee.removeClass('_off');
            serviceFee.find('.js-serviceFee_text').showByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').hideByClass();
        }
        else {
            serviceFee.addClass('_off');
            serviceFee.find('.js-serviceFee_text').hideByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').showByClass();
        }
    };
    App.CruiseShipPageMobile = CruiseShipPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseShipPage_instances, _a, _CruiseShipPage_shipFilter, _CruiseShipPage_shipResult, _CruiseShipPage_shipTabs, _CruiseShipPage_shipWrapClass, _CruiseShipPage_shipHotFilterClass, _CruiseShipPage_shipMainFilterClass, _CruiseShipPage_searchResultsWrap, _CruiseShipPage_deckOption, _CruiseShipPage_deckDescr, _CruiseShipPage_cabinOption, _CruiseShipPage_shipId, _CruiseShipPage_popup2, _CruiseShipPage_offers, _CruiseShipPage_cabinDescr, _CruiseShipPage_onClickTab, _CruiseShipPage_onClickDeckTab, _CruiseShipPage_renderShipResults, _CruiseShipPage_prepareDataForShipSearch, _CruiseShipPage_searchShipRoutes, _CruiseShipPage_onSwitchDeckDescr, _CruiseShipPage_onSwitchCabinDescr, _CruiseShipPage_onShipFilterSearch, _CruiseShipPage_onServiceFeeSwitch;
    class CruiseShipPage extends App.CruisePageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-ship' }, options));
            _CruiseShipPage_instances.add(this);
            _CruiseShipPage_shipFilter.set(this, void 0);
            _CruiseShipPage_shipResult.set(this, void 0);
            _CruiseShipPage_shipTabs.set(this, void 0);
            _CruiseShipPage_shipWrapClass.set(this, void 0);
            _CruiseShipPage_shipHotFilterClass.set(this, void 0);
            _CruiseShipPage_shipMainFilterClass.set(this, void 0);
            _CruiseShipPage_searchResultsWrap.set(this, void 0);
            _CruiseShipPage_deckOption.set(this, void 0);
            _CruiseShipPage_deckDescr.set(this, void 0);
            _CruiseShipPage_cabinOption.set(this, void 0);
            _CruiseShipPage_shipId.set(this, void 0);
            _CruiseShipPage_popup2.set(this, void 0);
            _CruiseShipPage_offers.set(this, void 0);
            _CruiseShipPage_cabinDescr.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _CruiseShipPage_popup2, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            __classPrivateFieldSet(this, _CruiseShipPage_shipWrapClass, '.js-cruise-ship', "f");
            __classPrivateFieldSet(this, _CruiseShipPage_shipHotFilterClass, '.js-ship-hot-filter', "f");
            __classPrivateFieldSet(this, _CruiseShipPage_shipMainFilterClass, '.js-ship-main-filter', "f");
            __classPrivateFieldSet(this, _CruiseShipPage_deckOption, $('.js-deck-descr-option', this.root), "f");
            __classPrivateFieldSet(this, _CruiseShipPage_deckDescr, $('.js-deck-descr', this.root), "f");
            __classPrivateFieldSet(this, _CruiseShipPage_cabinOption, $('.js-cabin-descr-option', this.root), "f");
            __classPrivateFieldSet(this, _CruiseShipPage_cabinDescr, $('.js-cabin-descr', this.root), "f");
            this.scrollBookLink = $('.js-scroll-book-link', this.root);
            this.bookScrollToWrap = $('.js-book-to-scroll', this.root);
            __classPrivateFieldSet(this, _CruiseShipPage_searchResultsWrap, $('.js-ship-search-results', this.root), "f");
            this.states = {
                'ship': {
                    handler: () => __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_renderShipResults).call(this),
                    actionName: 'ship',
                    keysForUrl: ['port', 'fare', 'cabin'],
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            __classPrivateFieldSet(this, _CruiseShipPage_shipId, Number($('#shipId').val()), "f");
            // инициализация формы поиска
            __classPrivateFieldSet(this, _CruiseShipPage_shipFilter, new App.CruiseShipMainFilter({
                root: __classPrivateFieldGet(this, _CruiseShipPage_shipMainFilterClass, "f"),
                urls: this.options.urls,
                defaults: this.options.defaults,
                changes: this.options.changes,
                checkin: this.options.checkin,
                shipId: __classPrivateFieldGet(this, _CruiseShipPage_shipId, "f"),
                peopleOptions: {
                    maxChildAge: App.app.settings.cruiseOptions.maxChildAge,
                },
                datesOptions: {
                    defaultDateFromShift: App.app.settings.cruiseOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.cruiseOptions.defaultCheckinDateInterval,
                    maxDateToOffset: App.app.settings.cruiseOptions.maxCheckinDateOffset,
                },
                sliderOptions: {
                    min: App.app.settings.cruiseOptions.minPrice,
                    max: App.app.settings.cruiseOptions.maxPrice,
                },
            }), "f");
            this.validator = __classPrivateFieldGet(this, _CruiseShipPage_shipFilter, "f").root.validate({ ignore: '' });
            this.responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()), validator: this.validator });
            this.components.push(new App.Digest({ container: this.root }));
            __classPrivateFieldSet(this, _CruiseShipPage_shipResult, new App.CruiseShipResult({
                root: '.js-placement-output',
                hotFilter: new App.CruiseRouteHotFilter({
                    root: __classPrivateFieldGet(this, _CruiseShipPage_shipHotFilterClass, "f"),
                }),
            }), "f");
            __classPrivateFieldGet(this, _CruiseShipPage_shipFilter, "f").shipFilter.on("shipFilter:search" /* Events.ShipFilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_onShipFilterSearch).call(this); }));
            // инициализация фоток
            this.components.push(new App.MediaGallery({ wrap: '.tour-slider-and-info-block' }), new App.TourInfoSlider());
            // событие на клик по табу добавляем перед инициализацией табов
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_onClickTab).call(this, e); }));
            // инициализация табов
            __classPrivateFieldSet(this, _CruiseShipPage_shipTabs, new App.Tabs({ self: __classPrivateFieldGet(this, _CruiseShipPage_shipWrapClass, "f") }), "f");
            __classPrivateFieldGet(this, _CruiseShipPage_shipTabs, "f").showActive();
            // Переключаем описание палуб
            __classPrivateFieldGet(this, _CruiseShipPage_deckOption, "f").on('click', e => __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_onSwitchDeckDescr).call(this, e));
            // Переключаем описание кают
            __classPrivateFieldGet(this, _CruiseShipPage_cabinOption, "f").on('click', e => __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_onSwitchCabinDescr).call(this, e));
            // прилипание/отлипание ссылки 'к бронированию'
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => this.onScrollDescrBlock()));
            $('.js-cruise-ship').on('click', '.js-placement-cabin-title.show-description', (e) => this.onCabinTitleClick(e));
            $('.js-filter-service-fee', __classPrivateFieldGet(this, _CruiseShipPage_searchResultsWrap, "f")).on('click', e => __classPrivateFieldGet(_a, _a, "m", _CruiseShipPage_onServiceFeeSwitch).call(_a, e));
            const queryParams = new App.QueryParams(window.location.pathname);
            if (queryParams.getParamAncher().length > 0) {
                $(`.js-placement-cabin-title[data-key="${queryParams.getParamAncher()}"]`, '.js-cruise-ship').trigger('click');
            }
        }
    }
    _a = CruiseShipPage, _CruiseShipPage_shipFilter = new WeakMap(), _CruiseShipPage_shipResult = new WeakMap(), _CruiseShipPage_shipTabs = new WeakMap(), _CruiseShipPage_shipWrapClass = new WeakMap(), _CruiseShipPage_shipHotFilterClass = new WeakMap(), _CruiseShipPage_shipMainFilterClass = new WeakMap(), _CruiseShipPage_searchResultsWrap = new WeakMap(), _CruiseShipPage_deckOption = new WeakMap(), _CruiseShipPage_deckDescr = new WeakMap(), _CruiseShipPage_cabinOption = new WeakMap(), _CruiseShipPage_shipId = new WeakMap(), _CruiseShipPage_popup2 = new WeakMap(), _CruiseShipPage_offers = new WeakMap(), _CruiseShipPage_cabinDescr = new WeakMap(), _CruiseShipPage_instances = new WeakSet(), _CruiseShipPage_onClickTab = function _CruiseShipPage_onClickTab(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if ($(event.currentTarget).attr('id') === 'tabDecks')
                yield __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_onClickDeckTab).call(this, event);
            if ($(event.currentTarget).attr('id') === 'placementTab') {
                if (!__classPrivateFieldGet(this, _CruiseShipPage_offers, "f") || __classPrivateFieldGet(this, _CruiseShipPage_offers, "f").length === 0)
                    (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_renderShipResults).call(this); }))();
            }
            if ($(event.currentTarget).attr('id') === 'info') {
                // Получаем слайдеры в программе
                const sliders = $('.js-tour-info-slider', __classPrivateFieldGet(this, _CruiseShipPage_shipWrapClass, "f"));
                // Обходим каждый слайдер и принудительно выставляем первый слайд, чтобы слайдер проинициализировался
                if (sliders.length) {
                    sliders.each((index, element) => {
                        const jqElement = $(element);
                        jqElement.slick('refresh');
                    });
                }
            }
        });
    }, _CruiseShipPage_onClickDeckTab = function _CruiseShipPage_onClickDeckTab(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const isSvgLoaded = $(event.currentTarget).attr('svgLoader');
            if (isSvgLoaded === '0') {
                $(event.currentTarget).attr('svgLoader', '1');
                const params = {
                    root: '#svgLoader',
                    width: 599,
                    shipSchemaSvg: this.options.shipSchemeUrl,
                    deck: this.options.decks.length === 0 ? 0 : this.options.decks[0].key,
                    shipId: this.options.shipId,
                    shipCode: this.options.shipCode,
                    svgNS: 'http://www.w3.org/2000/svg',
                };
                const svgLoader = new App.CruiseSvgLoader();
                yield svgLoader.init(params, this.options.decks);
            }
        });
    }, _CruiseShipPage_renderShipResults = function _CruiseShipPage_renderShipResults() {
        return __awaiter(this, void 0, void 0, function* () {
            App.CruisePageBase.hide($(__classPrivateFieldGet(this, _CruiseShipPage_searchResultsWrap, "f")));
            if (!(yield __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_searchShipRoutes).call(this)))
                return;
            App.CruisePageBase.show($(__classPrivateFieldGet(this, _CruiseShipPage_searchResultsWrap, "f")));
            this.saveState('ship', null, this.getParamsFromFilters(__classPrivateFieldGet(this, _CruiseShipPage_shipFilter, "f").shipFilter), true);
        });
    }, _CruiseShipPage_prepareDataForShipSearch = function _CruiseShipPage_prepareDataForShipSearch() {
        const elements = __classPrivateFieldGet(this, _CruiseShipPage_shipFilter, "f").shipFilter.serializeArray();
        const data = App.CruisePageBase.convertArrayToRequestData(elements);
        data.ship = __classPrivateFieldGet(this, _CruiseShipPage_shipId, "f").toString();
        return data;
    }, _CruiseShipPage_searchShipRoutes = function _CruiseShipPage_searchShipRoutes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.searchExecuting)
                return false;
            this.searchExecuting = true;
            if (this.expirationPopup != null)
                this.expirationPopup.cancel();
            __classPrivateFieldGet(this, _CruiseShipPage_shipResult, "f").resetDataSource();
            const data = __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_prepareDataForShipSearch).call(this);
            if (this.context)
                data.context = this.context;
            const xhr = $.ajax({
                url: this.options.urls.searchRoutes,
                method: 'POST',
                data,
            });
            let returnS = false;
            const popupGroup = __classPrivateFieldGet(this, _CruiseShipPage_popup2, "f").show({
                group: 'main',
                content: App.templates.Cruise.Messages.Searching({}),
                modal: true,
            });
            try {
                const response = yield xhr;
                if (!this.responseValidator.process(response))
                    return false;
                if (response.data.seo != null)
                    this.updateSeo(response.data.seo);
                // Определение наличия результатов поиска
                if (response.data.offers && response.data.offers.length > 0) {
                    this.expirationPopup = App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: this.options.urls.searchRoutes,
                    });
                    response.data.offers.forEach(v => {
                        v.route = App.CruisePageBase.abbreviateMulti(v.routeElements.map(z => z.value).join(', '), 75, '...');
                        v.portsDeparture = v.portDepartureElements.map(z => z.value).join(', ');
                        v.isPGManager = this.options.isPGManager;
                    });
                    __classPrivateFieldSet(this, _CruiseShipPage_offers, response.data.offers, "f");
                    yield __classPrivateFieldGet(this, _CruiseShipPage_shipResult, "f").changeDataSource(__classPrivateFieldGet(this, _CruiseShipPage_offers, "f"));
                    returnS = true;
                }
                else {
                    __classPrivateFieldGet(this, _CruiseShipPage_shipResult, "f").resetDataSource();
                }
            }
            catch (ex) {
                if (!this.responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                this.searchExecuting = false;
                __classPrivateFieldGet(this, _CruiseShipPage_popup2, "f").hide(popupGroup);
            }
            return returnS;
        });
    }, _CruiseShipPage_onSwitchDeckDescr = function _CruiseShipPage_onSwitchDeckDescr(event) {
        const target = $(event.currentTarget);
        const id = target.attr('data-deck');
        const isActive = target.hasClass('_active');
        // Показываем нужное описание
        if (!isActive) {
            __classPrivateFieldGet(this, _CruiseShipPage_deckOption, "f").removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPage_deckDescr, "f").removeClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPage_deckDescr, "f").hide();
            const tab = __classPrivateFieldGet(this, _CruiseShipPage_deckDescr, "f").filter(`[data-deck="${id}"]`).addClass('_active');
            const number = Number(target.attr('data-deck-number'));
            target.trigger("cruiseSvgLoader:deckChange" /* Events.CruiseSvgLoaderDeckChange */, number);
            tab.fadeIn(300, () => {
                $('.js-cabin-descr-option', tab).eq(0).trigger('click');
            });
        }
    }, _CruiseShipPage_onSwitchCabinDescr = function _CruiseShipPage_onSwitchCabinDescr(event) {
        const target = $(event.currentTarget);
        const id = target.attr('data-cabin');
        const isActive = target.hasClass('_active');
        // Показываем нужное описание
        if (!isActive) {
            __classPrivateFieldGet(this, _CruiseShipPage_cabinOption, "f").removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPage_cabinDescr, "f").removeClass('_active');
            __classPrivateFieldGet(this, _CruiseShipPage_cabinDescr, "f").hide();
            const tab = __classPrivateFieldGet(this, _CruiseShipPage_cabinDescr, "f").filter(`[data-cabin="${id}"]`).addClass('_active');
            tab.fadeIn(200, () => {
                // инициализация фоток в каютах
                const wrapper = $('.js-ship-cabin-gallery .js-media-gallery', tab);
                if (!wrapper.data('swiper-initialized')) {
                    this.components.push(new App.MediaGallery({ wrap: '.js-cabin-descr._active' }));
                }
                const swiper = wrapper.data('swiper-instance');
                if (swiper) {
                    swiper.update();
                    if (swiper.thumbs && swiper.thumbs.swiper) {
                        swiper.thumbs.swiper.update();
                    }
                }
            });
        }
    }, _CruiseShipPage_onShipFilterSearch = function _CruiseShipPage_onShipFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _CruiseShipPage_shipTabs, "f").show('placement');
            yield __classPrivateFieldGet(this, _CruiseShipPage_instances, "m", _CruiseShipPage_renderShipResults).call(this);
        });
    }, _CruiseShipPage_onServiceFeeSwitch = function _CruiseShipPage_onServiceFeeSwitch(event) {
        const target = $(event.currentTarget);
        const filterFeeBtn = target.find('.js-sliding-btn');
        const serviceFee = $('.js-service-fee', '.js-ship-route-output');
        if (filterFeeBtn.hasClass('_on')) {
            serviceFee.removeClass('_off');
            serviceFee.find('.js-serviceFee_text').showByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').hideByClass();
        }
        else {
            serviceFee.addClass('_off');
            serviceFee.find('.js-serviceFee_text').hideByClass();
            serviceFee.find('.js-serviceFee_text.js-serviceFee-off').showByClass();
        }
    };
    App.CruiseShipPage = CruiseShipPage;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseMainFilterBase_options;
    class CruiseMainFilterBase extends App.MainFilter {
        constructor(options) {
            super(options);
            _CruiseMainFilterBase_options.set(this, void 0);
            __classPrivateFieldSet(this, _CruiseMainFilterBase_options, options !== null && options !== void 0 ? options : {}, "f");
        }
        changePriceInSlider(filter, block) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if (filter.length === 0)
                    return;
                const sliderFrom = $('[data-name="filter_price_from"]', filter);
                const sliderTo = $('[data-name="filter_price_to"]', filter);
                const sliderCurrency = $('[data-name="filter_price_currency"]', filter);
                const fromValue = Number((_a = sliderFrom.attr('data-text')) !== null && _a !== void 0 ? _a : '0');
                const fromCurrency = (sliderFrom.attr('data-money-amount-currency') || '').toUpperCase();
                const fromConvert = yield App.CurrencyManager.exchange(fromValue, fromCurrency);
                const toValue = Number((_b = sliderTo.attr('data-text')) !== null && _b !== void 0 ? _b : '0');
                const toCurrency = (sliderTo.attr('data-money-amount-currency') || '').toUpperCase();
                let toConvert = yield App.CurrencyManager.exchange(toValue, toCurrency);
                const defMinValue = __classPrivateFieldGet(this, _CruiseMainFilterBase_options, "f").sliderOptions && __classPrivateFieldGet(this, _CruiseMainFilterBase_options, "f").sliderOptions.min ? __classPrivateFieldGet(this, _CruiseMainFilterBase_options, "f").sliderOptions.min : 0;
                const defMinCurrency = (sliderFrom.attr(App.CurrencyManager.defaults.currencyAttribute) || '').toUpperCase();
                const defMinConvert = yield App.CurrencyManager.exchange(defMinValue, defMinCurrency);
                const defMaxValue = __classPrivateFieldGet(this, _CruiseMainFilterBase_options, "f").sliderOptions && __classPrivateFieldGet(this, _CruiseMainFilterBase_options, "f").sliderOptions.max ? __classPrivateFieldGet(this, _CruiseMainFilterBase_options, "f").sliderOptions.max : 0;
                const defMaxCurrency = (sliderTo.attr(App.CurrencyManager.defaults.currencyAttribute) || '').toUpperCase();
                const defMaxConvert = yield App.CurrencyManager.exchange(defMaxValue, defMaxCurrency);
                if (fromConvert == null || toConvert == null || defMinConvert == null || defMaxConvert == null)
                    return;
                if (toConvert > defMaxConvert)
                    toConvert = defMaxConvert;
                // меняем текущую валюту
                const currencyCode = App.CurrencyManager.currentCurrencyCode;
                sliderFrom.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
                sliderFrom.attr('data-money-amount-currency', currencyCode);
                sliderTo.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
                sliderTo.attr('data-money-amount-currency', currencyCode);
                sliderCurrency.val(currencyCode);
                block.setValues(fromConvert, toConvert, defMinConvert, defMaxConvert);
            });
        }
        static updateOptions(controls, key, options) {
            const data = options.map(v => ({ value: v.key.toString(), text: v.title, selected: v.selected }));
            const control = controls[key];
            if (control == null)
                return;
            if (control.block !== undefined && control.block instanceof App.FilterListBlockBase) {
                control.block.replaceOptions(data, true);
            }
            else {
                const optionsContainer = $('.js-scroller', control.element);
                $('.js-filter-option', optionsContainer).not('.js-default-option').remove();
                const templateName = optionsContainer.attr('data-template');
                optionsContainer.append(App.findTemplate(templateName)(data));
            }
        }
        static getDataForSearchFilters(eventData) {
            const control = eventData.controls[eventData.sender];
            const rqData = {
                ChangeType: control ? (control.changeType || eventData.sender) : eventData.sender,
            };
            Object.getOwnPropertyNames(eventData.controls).forEach(key => {
                const selector = eventData.controls[key].element.is('input')
                    ? eventData.controls[key].element
                    : eventData.controls[key].element.find('input');
                const values = selector.valString();
                if (values.length === 0)
                    return;
                rqData[key] = eventData.controls[key].multiple ? values.split(',') : values;
            });
            return rqData;
        }
        static markDates(filters, dates) {
            const values = dates.map(v => App.parseIsoDate(v).getTime());
            filters.checkinFrom.element.datepicker('option', 'beforeShowDay', v => [true, (values.includes(v.getTime()) ? '_arrival-date' : ''), null]);
            filters.checkinTo.element.datepicker('option', 'beforeShowDay', v => [true, (values.includes(v.getTime()) ? '_arrival-date' : ''), null]);
        }
        onCurrencyChange(filter, block) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.changePriceInSlider(filter, block);
            });
        }
        static onPriceSliderChange(event) {
            const sliderFrom = $('[data-name="filter_price_from"]', event.target);
            const sliderTo = $('[data-name="filter_price_to"]', event.target);
            // const sliderCurrency = $('[data-name="filter_price_currency"]', event.target);
            sliderFrom.attr('data-money-amount', sliderFrom.attr('data-text') || '');
            sliderTo.attr('data-money-amount', sliderTo.attr('data-text') || '');
            sliderFrom.attr('data-money-amount-currency', sliderFrom.attr('data-money-current') || '');
            sliderTo.attr('data-money-amount-currency', sliderTo.attr('data-money-current') || '');
        }
    }
    _CruiseMainFilterBase_options = new WeakMap();
    App.CruiseMainFilterBase = CruiseMainFilterBase;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.ts' />
var App;
(function (App) {
    var _CruiseGroupMainFilter_instances, _a, _CruiseGroupMainFilter_options, _CruiseGroupMainFilter_filters, _CruiseGroupMainFilter_popup, _CruiseGroupMainFilter_responseValidator, _CruiseGroupMainFilter_initSearchFilterEvents, _CruiseGroupMainFilter_markAvailableCheckinDates, _CruiseGroupMainFilter_getFilterControls, _CruiseGroupMainFilter_getSearchFilters, _CruiseGroupMainFilter_updateSearchFilter, _CruiseGroupMainFilter_updateCruisePrice, _CruiseGroupMainFilter_getDataForGroupFilters, _CruiseGroupMainFilter_onFilterChange, _CruiseGroupMainFilter_onNightChange, _CruiseGroupMainFilter_onFilterSearch, _CruiseGroupMainFilter_hidePrices;
    class CruiseGroupMainFilter extends App.CruiseMainFilterBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruiseGroupMainFilter_instances.add(this);
            _CruiseGroupMainFilter_options.set(this, void 0);
            _CruiseGroupMainFilter_filters.set(this, void 0);
            _CruiseGroupMainFilter_popup.set(this, void 0);
            _CruiseGroupMainFilter_responseValidator.set(this, void 0);
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruiseGroupMainFilter_options, options, "f");
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            __classPrivateFieldSet(this, _CruiseGroupMainFilter_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruiseGroupMainFilter_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_initSearchFilterEvents).call(this);
        }
        reset() {
            $('textarea, input.js-form-item-field, input.spinner, input.js-price-custom, input.totalCountInput', this.searchFilter).val('');
            $('div.totalTR, div.totalTD, div.totalCount').html('');
            __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_hidePrices).call(this);
            const slidings = $('.js-filter-sliding-btn-b', this.searchFilter);
            slidings.each((i, val) => {
                const sliding = $(val);
                if (sliding.find('input').val() !== 'false')
                    sliding.find('.js-sliding-btn').trigger('click');
            });
            const dateBlock = __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f").date.block;
            dateBlock.setValue(new Date());
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_onFilterChange).call(this, { sender: 'none', controls: __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f") }); }))();
        }
    }
    _a = CruiseGroupMainFilter, _CruiseGroupMainFilter_options = new WeakMap(), _CruiseGroupMainFilter_filters = new WeakMap(), _CruiseGroupMainFilter_popup = new WeakMap(), _CruiseGroupMainFilter_responseValidator = new WeakMap(), _CruiseGroupMainFilter_instances = new WeakSet(), _CruiseGroupMainFilter_initSearchFilterEvents = function _CruiseGroupMainFilter_initSearchFilterEvents() {
        __classPrivateFieldSet(this, _CruiseGroupMainFilter_filters, __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_getFilterControls).call(this, this.searchFilter), "f");
        Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f")).forEach(controlName => {
            if (__classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f")[controlName].trackChanges) {
                const data = { sender: __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f")[controlName].changeType, controls: __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f") };
                __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f")[controlName].element.on('change', data, (event) => __awaiter(this, void 0, void 0, function* () {
                    yield __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_onFilterChange).call(this, event.data);
                }));
            }
        });
        __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f").night.element.on('change', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_onNightChange).call(this); }));
        this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_onFilterSearch).call(this, e));
        __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruiseGroupMainFilter_options, "f").checkin);
    }, _CruiseGroupMainFilter_markAvailableCheckinDates = function _CruiseGroupMainFilter_markAvailableCheckinDates(dates) {
        const values = dates.map(v => App.parseIsoDate(v).getTime());
        __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f").date.element.datepicker('option', 'beforeShowDay', v => [true, (values.includes(v.getTime()) ? '_arrival-date' : ''), null]);
    }, _CruiseGroupMainFilter_getFilterControls = function _CruiseGroupMainFilter_getFilterControls(container) {
        return {
            region: {
                element: container.find('.js-form-select-block[data-select="region"] .js-jelect'),
                block: this.findControl('region'),
                trackChanges: true,
                multiple: false,
                changeType: 'region',
            },
            ship: {
                element: container.find('.js-form-select-block[data-select="ship"] .js-jelect'),
                block: this.findControl('ship'),
                trackChanges: true,
                multiple: false,
                changeType: 'ship',
            },
            date: {
                element: container.find('.js-groupfilter-date'),
                block: this.findControl('date'),
                trackChanges: true,
                multiple: false,
                changeType: 'date',
            },
            night: {
                element: container.find('.js-form-select-block[data-select="night"] .js-jelect'),
                block: this.findControl('night'),
                trackChanges: false,
                multiple: false,
                changeType: 'night',
            },
        };
    }, _CruiseGroupMainFilter_getSearchFilters = function _CruiseGroupMainFilter_getSearchFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.submitButton.prop('disabled', true);
            this.submitButton.addClass('_disabled');
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseGroupMainFilter_options, "f").urls.getSearchFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseGroupMainFilter_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseGroupMainFilter_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_updateSearchFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseGroupMainFilter_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                this.submitButton.removeClass('_disabled');
                this.submitButton.prop('disabled', false);
                __classPrivateFieldGet(this, _CruiseGroupMainFilter_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseGroupMainFilter_updateSearchFilter = function _CruiseGroupMainFilter_updateSearchFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = new Array();
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_markAvailableCheckinDates).call(this, dates);
                    break;
                }
                case 'date': {
                    const checkin = this.findControl('date');
                    if (checkin) {
                        const checkinFrom = App.parseIsoDate(items[key][0].title);
                        checkin.setValue(checkinFrom);
                    }
                    break;
                }
                default:
                    App.CruiseMainFilterBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruiseGroupMainFilter_updateCruisePrice = function _CruiseGroupMainFilter_updateCruisePrice(prices) {
        if (prices == null || prices.length === 0)
            return;
        prices.forEach(price => {
            $(`#${price.categoryCode}`).find(App.Money.tagName).get(0).amount = price.grossPriceAmount / 2;
            App.CruisePageBase.show($(`#${price.categoryCode}`), false);
            App.CruisePageBase.hide($(`#${price.categoryCode}`).next());
        });
        $('.portCharge').find(App.Money.tagName).get(0).amount = prices[0].portCharge / 2;
        App.CruisePageBase.show($('.portCharge', this.searchFilter), false);
    }, _CruiseGroupMainFilter_getDataForGroupFilters = function _CruiseGroupMainFilter_getDataForGroupFilters(eventData) {
        const control = eventData.controls[eventData.sender];
        const rqData = {
            ChangeType: control ? (control.changeType || eventData.sender) : eventData.sender,
        };
        Object.getOwnPropertyNames(eventData.controls).forEach(key => {
            const selector = eventData.controls[key].element.is('input')
                ? eventData.controls[key].element
                : eventData.controls[key].element.find('input');
            const values = selector.valString();
            if (values.length === 0 || values == '0')
                return;
            rqData[key] = eventData.controls[key].multiple ? values.split(',') : values;
        });
        return rqData;
    }, _CruiseGroupMainFilter_onFilterChange = function _CruiseGroupMainFilter_onFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const rqData = __classPrivateFieldGet(_a, _a, "m", _CruiseGroupMainFilter_getDataForGroupFilters).call(_a, eventData);
            __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_hidePrices).call(this);
            yield __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_getSearchFilters).call(this, rqData, eventData);
        });
    }, _CruiseGroupMainFilter_onNightChange = function _CruiseGroupMainFilter_onNightChange() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f").region.element.val() === ''
                || __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f").ship.element.val() === ''
                || __classPrivateFieldGet(this, _CruiseGroupMainFilter_filters, "f").night.element.val() === '')
                return;
            const data = $('.js-cruise-group-filter', $('.js-cruise-page')).serializeArray();
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseGroupMainFilter_options, "f").urls.getCruisePriceInfo,
                method: 'POST',
                dataType: 'json',
                data,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseGroupMainFilter_popup, "f").show({
                group: 'filter',
                // TODO: использовать templates.Tour.Messages.UpdatingFilters.
                content: App.templates.Messages.Valuating({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseGroupMainFilter_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseGroupMainFilter_instances, "m", _CruiseGroupMainFilter_updateCruisePrice).call(this, response.data.items);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseGroupMainFilter_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseGroupMainFilter_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseGroupMainFilter_onFilterSearch = function _CruiseGroupMainFilter_onFilterSearch(event) {
        event.preventDefault();
        App.CruisePageBase.hide($('.errorCount', '.js-cruise-group-filter'));
        const value = Number($('.totalCount', '.js-group-matrix table').html());
        if (value < 8) {
            App.CruisePageBase.show($('.errorCount', '.js-cruise-group-filter'), true);
            return;
        }
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    }, _CruiseGroupMainFilter_hidePrices = function _CruiseGroupMainFilter_hidePrices() {
        App.CruisePageBase.hide($('.priceApi', this.searchFilter));
        App.CruisePageBase.show($('.js-emptyPrice'), false);
        App.CruisePageBase.hide($('.portCharge', '.js-cruise-group-filter'));
    };
    App.CruiseGroupMainFilter = CruiseGroupMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseHotFilterMobile_instances, _a, _CruiseHotFilterMobile_refreshSelectList, _CruiseHotFilterMobile_getSelectListDefaultOption;
    class CruiseHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(options);
            _CruiseHotFilterMobile_instances.add(this);
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
            if (!this.root.length) {
                this.hotFilter = $();
                return;
            }
            this.hotFilter = this.root;
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: () => this.onSelfFilterChanged() });
        }
        onSelfFilterChanged() {
            return __awaiter(this, void 0, void 0, function* () {
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
            });
        }
        refreshHotFilters(cruiseOffers, selected, element, hideRusGroupFilter) {
            var _b;
            if ((cruiseOffers === null || cruiseOffers === void 0 ? void 0 : cruiseOffers.length) <= 1) {
                $('.js-filter-body', this.hotFilter).hide();
                return;
            }
            if (hideRusGroupFilter !== undefined) {
                // если в основном фильтре фильтр Русскоязычная группа установлен - во вторичном фильтре устанавливаю этот фильтр и скрываю,
                // если нет - делаю этот фильтр неустановленным и показываю его
                const slider = $('.js-filter-sliding-btn-b', this.hotFilter);
                slider.show();
                if (hideRusGroupFilter) {
                    if (slider.find('input').val() !== 'true')
                        slider.find('.js-sliding-btn').trigger('click');
                    $('.js-filter-sliding-btn-b', this.hotFilter).hide();
                }
                else if (slider.find('input').val() !== 'false') {
                    slider.find('.js-sliding-btn').trigger('click');
                }
            }
            const changeType = element
                ? ((_b = $(element).attr('data-select')) !== null && _b !== void 0 ? _b : '')
                : '';
            function findElementByKey(filters, key) {
                const item = filters.find(value => value.name === key);
                if (item)
                    return item.values;
                return Array();
            }
            function createListOption(selectedVals, value, text = '', checkValue = '') {
                return {
                    value,
                    text: text === '' ? value : text,
                    selected: selectedVals.includes(checkValue === '' ? value : checkValue),
                };
            }
            const filteredList = Array({
                name: 'region',
                value: findElementByKey(selected, 'region'),
                filter: (values, selectedVals) => values
                    .filter(value => {
                    const m = value.regionElements.map(z => z.key);
                    return m.filter(v => selectedVals.includes(v.toString())).length > 0;
                }),
                get: (values, selectedVals) => {
                    let regions = [];
                    values === null || values === void 0 ? void 0 : values.forEach(value => {
                        value.regionElements.forEach(v => {
                            regions.push(createListOption(selectedVals, v.key.toString(), v.value));
                        });
                    });
                    regions = [...new Map(regions.map(item => [item.text, item])).values()]; // distinct object
                    return App.CruisePageBase.sortArray(regions, 'text');
                },
                needDefaultOption: false,
            }, {
                name: 'route',
                value: findElementByKey(selected, 'route'),
                filter: (values, selectedVals) => values
                    .filter(value => {
                    const m = value.routeElements.map(z => z.key);
                    return m.filter(v => selectedVals.includes(v.toString())).length > 0;
                }),
                get: (values, selectedVals) => {
                    let routes = [];
                    values === null || values === void 0 ? void 0 : values.forEach(value => {
                        value.routeElements.forEach(v => {
                            routes.push(createListOption(selectedVals, v.key.toString(), v.value));
                        });
                    });
                    routes = [...new Map(routes.map(item => [item.text, item])).values()]; // distinct object
                    routes = App.CruisePageBase.sortArray(routes, 'text');
                    return routes;
                },
                needDefaultOption: false,
            });
            let currentFilters = cruiseOffers;
            if (changeType !== '') {
                for (let i = 0; i < filteredList.length; ++i) {
                    currentFilters = filteredList[i].value != null && filteredList[i].value.length !== 0
                        ? filteredList[i].filter(currentFilters, filteredList[i].value)
                        : currentFilters;
                    if (filteredList[i].name !== changeType)
                        continue;
                    for (let j = i + 1; j < filteredList.length; ++j) {
                        const optionListData = filteredList[j].get(currentFilters, filteredList[j].value);
                        // если есть выбранные чекбоксы, то default чекбокс 'Все' не выбран
                        let defaultOptionSelected = true;
                        const findSelected = optionListData.find(val => val.selected || false);
                        if (typeof findSelected !== 'undefined')
                            defaultOptionSelected = false;
                        __classPrivateFieldGet(this, _CruiseHotFilterMobile_instances, "m", _CruiseHotFilterMobile_refreshSelectList).call(this, filteredList[j].name, optionListData, defaultOptionSelected, filteredList[j].needDefaultOption);
                    }
                }
            }
            else {
                for (let i = 0; i < filteredList.length; ++i) {
                    const optionListData = filteredList[i].get(currentFilters, filteredList[i].value);
                    // если есть выбранные чекбоксы, то default чекбокс 'Все' не выбран
                    let defaultOptionSelected = true;
                    const findSelected = optionListData.find(val => val.selected || false);
                    if (typeof findSelected !== 'undefined')
                        defaultOptionSelected = false;
                    __classPrivateFieldGet(this, _CruiseHotFilterMobile_instances, "m", _CruiseHotFilterMobile_refreshSelectList).call(this, filteredList[i].name, optionListData, defaultOptionSelected, filteredList[i].needDefaultOption);
                }
            }
        }
        onHotFiltersChange(event) {
            const selectedHotFilters = this.filters.serializeArray();
            const filters = selectedHotFilters
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            this.hotFilter.trigger("hotFilter:beforeFiltering" /* Events.HotFilterBeforeFiltering */, [filters, event.target]);
            this.hotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    _a = CruiseHotFilterMobile, _CruiseHotFilterMobile_instances = new WeakSet(), _CruiseHotFilterMobile_refreshSelectList = function _CruiseHotFilterMobile_refreshSelectList(key, options, defaultOptionSelected, needDefaultOption) {
        const filterControl = this.filters.findControl(key);
        if (!filterControl)
            return;
        let optionListData = [];
        filterControl.clear(); // filterControl.clearOptions(false);
        if (needDefaultOption)
            optionListData.push(__classPrivateFieldGet(_a, _a, "m", _CruiseHotFilterMobile_getSelectListDefaultOption).call(_a, defaultOptionSelected));
        optionListData = optionListData.concat(options);
        filterControl.setValueByListOptions(optionListData); // filterControl.replaceOptions(optionListData, true);
    }, _CruiseHotFilterMobile_getSelectListDefaultOption = function _CruiseHotFilterMobile_getSelectListDefaultOption(selected) {
        return { text: 'Все', selected, value: '' };
    };
    App.CruiseHotFilterMobile = CruiseHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseHotFilter_instances, _a, _CruiseHotFilter_refreshSelectList, _CruiseHotFilter_getSelectListDefaultOption;
    class CruiseHotFilter extends App.HotFilter {
        constructor(options) {
            super(options);
            _CruiseHotFilter_instances.add(this);
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.hotFilter = $();
                return;
            }
            this.hotFilter = this.root;
        }
        refreshHotFilters(cruiseOffers, selected, element, hideRusGroupFilter) {
            var _b;
            if (cruiseOffers.length <= 1) {
                $('.js-filter-body', this.hotFilter).hide();
                return;
            }
            $('.js-filter-body', this.hotFilter).show();
            if (hideRusGroupFilter !== undefined) {
                // если в основном фильтре фильтр Русскоязычная группа установлен - во вторичном фильтре устанавливаю этот фильтр и скрываю,
                // если нет - делаю этот фильтр неустановленным и показываю его
                const slider = $('.js-filter-sliding-btn-b', this.hotFilter);
                slider.show();
                if (hideRusGroupFilter) {
                    if (slider.find('input').val() !== 'true')
                        slider.find('.js-sliding-btn').trigger('click');
                    $('.js-filter-sliding-btn-b', this.hotFilter).hide();
                }
                else if (slider.find('input').val() !== 'false') {
                    slider.find('.js-sliding-btn').trigger('click');
                }
            }
            const changeType = element
                ? ((_b = $(element).attr('data-select')) !== null && _b !== void 0 ? _b : '')
                : '';
            function findElementByKey(filters, key) {
                const item = filters.find(value => value.name === key);
                if (item)
                    return item.values;
                return Array();
            }
            function createListOption(selectedVals, value, text = '', checkValue = '') {
                return {
                    value,
                    text: text === '' ? value : text,
                    selected: selectedVals.includes(checkValue === '' ? value : checkValue),
                };
            }
            const filteredList = Array({
                name: 'region',
                value: findElementByKey(selected, 'region'),
                filter: (values, selectedVals) => values
                    .filter(value => {
                    const m = value.regionElements.map(z => z.key);
                    return m.filter(v => selectedVals.includes(v.toString())).length > 0;
                }),
                get: (values, selectedVals) => {
                    let regions = [];
                    values.forEach(value => {
                        value.regionElements.forEach(v => {
                            regions.push(createListOption(selectedVals, v.key.toString(), v.value));
                        });
                    });
                    regions = [...new Map(regions.map(item => [item.text, item])).values()]; // distinct object
                    return App.CruisePageBase.sortArray(regions, 'text');
                },
                needDefaultOption: false,
            }, {
                name: 'route',
                value: findElementByKey(selected, 'route'),
                filter: (values, selectedVals) => values
                    .filter(value => {
                    const m = value.routeElements.map(z => z.key);
                    return m.filter(v => selectedVals.includes(v.toString())).length > 0;
                }),
                get: (values, selectedVals) => {
                    let routes = [];
                    values.forEach(value => {
                        value.routeElements.forEach(v => {
                            routes.push(createListOption(selectedVals, v.key.toString(), v.value));
                        });
                    });
                    routes = [...new Map(routes.map(item => [item.text, item])).values()]; // distinct object
                    routes = App.CruisePageBase.sortArray(routes, 'text');
                    return routes;
                },
                needDefaultOption: false,
            });
            let currentFilters = cruiseOffers;
            if (changeType !== '') {
                for (let i = 0; i < filteredList.length; ++i) {
                    currentFilters = filteredList[i].value != null && filteredList[i].value.length !== 0
                        ? filteredList[i].filter(currentFilters, filteredList[i].value)
                        : currentFilters;
                    if (filteredList[i].name !== changeType)
                        continue;
                    for (let j = i + 1; j < filteredList.length; ++j) {
                        const optionListData = filteredList[j].get(currentFilters, filteredList[j].value);
                        // если есть выбранные чекбоксы, то default чекбокс 'Все' не выбран
                        let defaultOptionSelected = true;
                        const findSelected = optionListData.find(val => val.selected || false);
                        if (typeof findSelected !== 'undefined')
                            defaultOptionSelected = false;
                        __classPrivateFieldGet(this, _CruiseHotFilter_instances, "m", _CruiseHotFilter_refreshSelectList).call(this, filteredList[j].name, optionListData, defaultOptionSelected, filteredList[j].needDefaultOption);
                    }
                }
            }
            else {
                for (let i = 0; i < filteredList.length; ++i) {
                    const optionListData = filteredList[i].get(currentFilters, filteredList[i].value);
                    // если есть выбранные чекбоксы, то default чекбокс 'Все' не выбран
                    let defaultOptionSelected = true;
                    const findSelected = optionListData.find(val => val.selected || false);
                    if (typeof findSelected !== 'undefined')
                        defaultOptionSelected = false;
                    __classPrivateFieldGet(this, _CruiseHotFilter_instances, "m", _CruiseHotFilter_refreshSelectList).call(this, filteredList[i].name, optionListData, defaultOptionSelected, filteredList[i].needDefaultOption);
                }
            }
        }
        onHotFiltersChange(event) {
            const selectedHotFilters = this.hotFilter.find('input').serializeArray();
            const filters = selectedHotFilters
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            this.hotFilter.trigger("hotFilter:beforeFiltering" /* Events.HotFilterBeforeFiltering */, [filters, event.target]);
            this.hotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    _a = CruiseHotFilter, _CruiseHotFilter_instances = new WeakSet(), _CruiseHotFilter_refreshSelectList = function _CruiseHotFilter_refreshSelectList(key, options, defaultOptionSelected, needDefaultOption) {
        const filterControl = this.findControl(key);
        if (!filterControl)
            return;
        let optionListData = [];
        filterControl.clearOptions(false);
        if (needDefaultOption)
            optionListData.push(__classPrivateFieldGet(_a, _a, "m", _CruiseHotFilter_getSelectListDefaultOption).call(_a, defaultOptionSelected));
        optionListData = optionListData.concat(options);
        filterControl.replaceOptions(optionListData, true);
    }, _CruiseHotFilter_getSelectListDefaultOption = function _CruiseHotFilter_getSelectListDefaultOption(selected) {
        return { text: 'Все', selected, value: '' };
    };
    App.CruiseHotFilter = CruiseHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseMainFilterMobileBase_options;
    class CruiseMainFilterMobileBase extends App.MainFilterMobile {
        constructor(options) {
            super(options);
            _CruiseMainFilterMobileBase_options.set(this, void 0);
            __classPrivateFieldSet(this, _CruiseMainFilterMobileBase_options, options !== null && options !== void 0 ? options : {}, "f");
        }
        changePriceInSlider(filter, block) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if (filter.length === 0)
                    return;
                const sliderFrom = $('[data-name="filter_price_from"]', filter);
                const sliderTo = $('[data-name="filter_price_to"]', filter);
                const sliderCurrency = $('[data-name="filter_price_currency"]', filter);
                const fromValue = Number((_a = sliderFrom.attr('data-text')) !== null && _a !== void 0 ? _a : '0');
                const fromCurrency = (sliderFrom.attr('data-money-amount-currency') || '').toUpperCase();
                const fromConvert = yield App.CurrencyManager.exchange(fromValue, fromCurrency);
                const toValue = Number((_b = sliderTo.attr('data-text')) !== null && _b !== void 0 ? _b : '0');
                const toCurrency = (sliderTo.attr('data-money-amount-currency') || '').toUpperCase();
                let toConvert = yield App.CurrencyManager.exchange(toValue, toCurrency);
                const defMinValue = __classPrivateFieldGet(this, _CruiseMainFilterMobileBase_options, "f").sliderOptions && __classPrivateFieldGet(this, _CruiseMainFilterMobileBase_options, "f").sliderOptions.min ? __classPrivateFieldGet(this, _CruiseMainFilterMobileBase_options, "f").sliderOptions.min : 0;
                const defMinCurrency = (sliderFrom.attr(App.CurrencyManager.defaults.currencyAttribute) || '').toUpperCase();
                const defMinConvert = yield App.CurrencyManager.exchange(defMinValue, defMinCurrency);
                const defMaxValue = __classPrivateFieldGet(this, _CruiseMainFilterMobileBase_options, "f").sliderOptions && __classPrivateFieldGet(this, _CruiseMainFilterMobileBase_options, "f").sliderOptions.max ? __classPrivateFieldGet(this, _CruiseMainFilterMobileBase_options, "f").sliderOptions.max : 0;
                const defMaxCurrency = (sliderTo.attr(App.CurrencyManager.defaults.currencyAttribute) || '').toUpperCase();
                const defMaxConvert = yield App.CurrencyManager.exchange(defMaxValue, defMaxCurrency);
                if (fromConvert == null || toConvert == null || defMinConvert == null || defMaxConvert == null)
                    return;
                if (toConvert > defMaxConvert)
                    toConvert = defMaxConvert;
                // меняем текущую валюту
                const currencyCode = App.CurrencyManager.currentCurrencyCode;
                sliderFrom.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
                sliderFrom.attr('data-money-amount-currency', currencyCode);
                sliderTo.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
                sliderTo.attr('data-money-amount-currency', currencyCode);
                sliderCurrency.val(currencyCode);
                block.setValues(fromConvert, toConvert, defMinConvert, defMaxConvert);
            });
        }
        static updateOptions(controls, key, options) {
            const data = options.map(v => ({ value: v.key.toString(), text: v.title, selected: v.selected }));
            const control = controls[key];
            if (control == null)
                return;
            if (control.block !== undefined && control.block instanceof App.FilterListBlockBase) {
                control.block.replaceOptions(data, true);
            }
            else {
                const optionsContainer = $('.js-scroller', control.element);
                $('.js-filter-option', optionsContainer).not('.js-default-option').remove();
                const templateName = optionsContainer.attr('data-template');
                optionsContainer.append(App.findTemplate(templateName)(data));
            }
        }
        static getDataForSearchFilters(eventData) {
            const control = eventData.controls[eventData.sender];
            const rqData = {
                ChangeType: control ? (control.changeType || eventData.sender) : eventData.sender,
            };
            Object.getOwnPropertyNames(eventData.controls).forEach(key => {
                const selector = eventData.controls[key].element.is('input')
                    ? eventData.controls[key].element
                    : eventData.controls[key].element.find('input');
                const values = selector.valString();
                if (values.length === 0)
                    return;
                rqData[key] = eventData.controls[key].multiple ? values.split(',') : values;
            });
            return rqData;
        }
        static markDates(filters, dates) {
            const values = dates.map(v => App.parseIsoDate(v).getTime());
            filters.checkinFrom.element.datepicker('option', 'beforeShowDay', v => [true, (values.includes(v.getTime()) ? '_arrival-date' : ''), null]);
            filters.checkinTo.element.datepicker('option', 'beforeShowDay', v => [true, (values.includes(v.getTime()) ? '_arrival-date' : ''), null]);
        }
        onCurrencyChange(filter, block) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.changePriceInSlider(filter, block);
            });
        }
        static onPriceSliderChange(event) {
            const sliderFrom = $('[data-name="filter_price_from"]', event.target);
            const sliderTo = $('[data-name="filter_price_to"]', event.target);
            // const sliderCurrency = $('[data-name="filter_price_currency"]', event.target);
            sliderFrom.attr('data-money-amount', sliderFrom.attr('data-text') || '');
            sliderTo.attr('data-money-amount', sliderTo.attr('data-text') || '');
            sliderFrom.attr('data-money-amount-currency', sliderFrom.attr('data-money-current') || '');
            sliderTo.attr('data-money-amount-currency', sliderTo.attr('data-money-current') || '');
        }
    }
    _CruiseMainFilterMobileBase_options = new WeakMap();
    App.CruiseMainFilterMobileBase = CruiseMainFilterMobileBase;
})(App || (App = {}));
var App;
(function (App) {
    class CruisePortHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(options);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.CruisePortHotFilterMobile = CruisePortHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class CruisePortHotFilter extends App.HotFilter {
        constructor(options) {
            super(options);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.CruisePortHotFilter = CruisePortHotFilter;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.ts' />
var App;
(function (App) {
    var _CruisePortMainFilterMobile_instances, _CruisePortMainFilterMobile_options, _CruisePortMainFilterMobile_filters, _CruisePortMainFilterMobile_popup, _CruisePortMainFilterMobile_responseValidator, _CruisePortMainFilterMobile_initPortFilterEvents, _CruisePortMainFilterMobile_markAvailableCheckinDates, _CruisePortMainFilterMobile_getPortFilterControls, _CruisePortMainFilterMobile_getPortFilters, _CruisePortMainFilterMobile_updatePortFilter, _CruisePortMainFilterMobile_onPortFilterChange, _CruisePortMainFilterMobile_onPortFilterSearch;
    class CruisePortMainFilterMobile extends App.CruiseMainFilterMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-detail-filter', customFilters: {
                    root: '.js-cruise-detail-filter',
                    clickSelector: '.js-cruise-detail-filters-open',
                    modalKey: 'cruise-detail-filters-modal',
                    contentSelector: '#js-cruise-detail-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать', // TODO: @Localizer.Text("Auto.SearchButton")
                } }, options));
            _CruisePortMainFilterMobile_instances.add(this);
            _CruisePortMainFilterMobile_options.set(this, void 0);
            _CruisePortMainFilterMobile_filters.set(this, void 0);
            _CruisePortMainFilterMobile_popup.set(this, void 0);
            _CruisePortMainFilterMobile_responseValidator.set(this, void 0);
            Object.defineProperty(this, "portFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruisePortMainFilterMobile_options, options, "f");
            if (!this.root.length) {
                this.portFilter = $();
                return;
            }
            this.portFilter = this.root;
            __classPrivateFieldSet(this, _CruisePortMainFilterMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruisePortMainFilterMobile_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_initPortFilterEvents).call(this); }))();
        }
        clear() {
        }
    }
    _CruisePortMainFilterMobile_options = new WeakMap(), _CruisePortMainFilterMobile_filters = new WeakMap(), _CruisePortMainFilterMobile_popup = new WeakMap(), _CruisePortMainFilterMobile_responseValidator = new WeakMap(), _CruisePortMainFilterMobile_instances = new WeakSet(), _CruisePortMainFilterMobile_initPortFilterEvents = function _CruisePortMainFilterMobile_initPortFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruisePortMainFilterMobile_filters, __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_getPortFilterControls).call(this, this.portFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruisePortMainFilterMobile_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruisePortMainFilterMobile_filters, "f")[controlName].trackChanges) {
                    __classPrivateFieldGet(this, _CruisePortMainFilterMobile_filters, "f")[controlName].element.on('change', { sender: controlName, controls: __classPrivateFieldGet(this, _CruisePortMainFilterMobile_filters, "f") }, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_onPortFilterChange).call(this, event.data);
                    }));
                }
            });
            this.portFilter.on('submit', e => __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_onPortFilterSearch).call(this, e));
            $('body').on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.portFilter, __classPrivateFieldGet(this, _CruisePortMainFilterMobile_filters, "f").price.block); }));
            yield this.changePriceInSlider(this.portFilter, __classPrivateFieldGet(this, _CruisePortMainFilterMobile_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruisePortMainFilterMobile_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruisePortMainFilterMobile_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruisePortMainFilterMobile_options, "f").changes.push(name);
            });
        });
    }, _CruisePortMainFilterMobile_markAvailableCheckinDates = function _CruisePortMainFilterMobile_markAvailableCheckinDates(dates) {
        App.CruiseMainFilterMobileBase.markDates(__classPrivateFieldGet(this, _CruisePortMainFilterMobile_filters, "f"), dates);
    }, _CruisePortMainFilterMobile_getPortFilterControls = function _CruisePortMainFilterMobile_getPortFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('.js-filter-select-block[data-select="city"] input'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] input'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('[data-select="type"] .js-jelect'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            region: {
                element: container.find('[data-select="region"] .js-jelect'),
                block: this.findControl('region'),
                trackChanges: true,
                multiple: true,
                changeType: 'region',
            },
            ship: {
                element: container.find('[data-select="ship"] .js-jelect'),
                block: this.findControl('ship'),
                trackChanges: true,
                multiple: true,
                changeType: 'ship',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] input'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruisePortMainFilterMobile_getPortFilters = function _CruisePortMainFilterMobile_getPortFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruisePortMainFilterMobile_options, "f").urls.getPortFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruisePortMainFilterMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruisePortMainFilterMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_updatePortFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruisePortMainFilterMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruisePortMainFilterMobile_popup, "f").hide(popupGroup);
            }
        });
    }, _CruisePortMainFilterMobile_updatePortFilter = function _CruisePortMainFilterMobile_updatePortFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = [];
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_markAvailableCheckinDates).call(this, dates);
                    break;
                }
                case 'checkin': {
                    const checkin = this.findControl('checkin');
                    if (checkin) {
                        const checkinFrom = App.parseIsoDate(items[key][0].title);
                        const checkinTo = App.parseIsoDate(items[key][1].title);
                        checkin.setValues(checkinFrom, checkinTo);
                    }
                    break;
                }
                default:
                    App.CruiseMainFilterMobileBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruisePortMainFilterMobile_onPortFilterChange = function _CruisePortMainFilterMobile_onPortFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const rqData = App.CruiseMainFilterMobileBase.getDataForSearchFilters(eventData);
            rqData.portId = __classPrivateFieldGet(this, _CruisePortMainFilterMobile_options, "f").portId.toString();
            rqData['port[]'] = __classPrivateFieldGet(this, _CruisePortMainFilterMobile_options, "f").portId.toString();
            yield __classPrivateFieldGet(this, _CruisePortMainFilterMobile_instances, "m", _CruisePortMainFilterMobile_getPortFilters).call(this, rqData, eventData);
        });
    }, _CruisePortMainFilterMobile_onPortFilterSearch = function _CruisePortMainFilterMobile_onPortFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    };
    App.CruisePortMainFilterMobile = CruisePortMainFilterMobile;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.ts' />
var App;
(function (App) {
    var _CruisePortMainFilter_instances, _CruisePortMainFilter_options, _CruisePortMainFilter_filters, _CruisePortMainFilter_popup, _CruisePortMainFilter_responseValidator, _CruisePortMainFilter_initPortFilterEvents, _CruisePortMainFilter_markAvailableCheckinDates, _CruisePortMainFilter_getPortFilterControls, _CruisePortMainFilter_getPortFilters, _CruisePortMainFilter_updatePortFilter, _CruisePortMainFilter_onPortFilterChange, _CruisePortMainFilter_onPortFilterSearch;
    class CruisePortMainFilter extends App.CruiseMainFilterBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruisePortMainFilter_instances.add(this);
            _CruisePortMainFilter_options.set(this, void 0);
            _CruisePortMainFilter_filters.set(this, void 0);
            _CruisePortMainFilter_popup.set(this, void 0);
            _CruisePortMainFilter_responseValidator.set(this, void 0);
            Object.defineProperty(this, "portFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruisePortMainFilter_options, options, "f");
            if (!this.root.length) {
                this.portFilter = $();
                return;
            }
            this.portFilter = this.root;
            __classPrivateFieldSet(this, _CruisePortMainFilter_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruisePortMainFilter_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_initPortFilterEvents).call(this); }))();
        }
        clear() {
        }
    }
    _CruisePortMainFilter_options = new WeakMap(), _CruisePortMainFilter_filters = new WeakMap(), _CruisePortMainFilter_popup = new WeakMap(), _CruisePortMainFilter_responseValidator = new WeakMap(), _CruisePortMainFilter_instances = new WeakSet(), _CruisePortMainFilter_initPortFilterEvents = function _CruisePortMainFilter_initPortFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruisePortMainFilter_filters, __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_getPortFilterControls).call(this, this.portFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruisePortMainFilter_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruisePortMainFilter_filters, "f")[controlName].trackChanges) {
                    __classPrivateFieldGet(this, _CruisePortMainFilter_filters, "f")[controlName].element.on('change', { sender: controlName, controls: __classPrivateFieldGet(this, _CruisePortMainFilter_filters, "f") }, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_onPortFilterChange).call(this, event.data);
                    }));
                }
            });
            this.portFilter.on('submit', e => __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_onPortFilterSearch).call(this, e));
            $('body').on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.portFilter, __classPrivateFieldGet(this, _CruisePortMainFilter_filters, "f").price.block); }));
            yield this.changePriceInSlider(this.portFilter, __classPrivateFieldGet(this, _CruisePortMainFilter_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruisePortMainFilter_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruisePortMainFilter_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruisePortMainFilter_options, "f").changes.push(name);
            });
        });
    }, _CruisePortMainFilter_markAvailableCheckinDates = function _CruisePortMainFilter_markAvailableCheckinDates(dates) {
        App.CruiseMainFilterBase.markDates(__classPrivateFieldGet(this, _CruisePortMainFilter_filters, "f"), dates);
    }, _CruisePortMainFilter_getPortFilterControls = function _CruisePortMainFilter_getPortFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('.js-filter-select-block[data-select="city"] input'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] input'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('[data-select="type"] .js-jelect'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            region: {
                element: container.find('[data-select="region"] .js-jelect'),
                block: this.findControl('region'),
                trackChanges: true,
                multiple: true,
                changeType: 'region',
            },
            ship: {
                element: container.find('[data-select="ship"] .js-jelect'),
                block: this.findControl('ship'),
                trackChanges: true,
                multiple: true,
                changeType: 'ship',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] input'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruisePortMainFilter_getPortFilters = function _CruisePortMainFilter_getPortFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruisePortMainFilter_options, "f").urls.getPortFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruisePortMainFilter_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruisePortMainFilter_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_updatePortFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruisePortMainFilter_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruisePortMainFilter_popup, "f").hide(popupGroup);
            }
        });
    }, _CruisePortMainFilter_updatePortFilter = function _CruisePortMainFilter_updatePortFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = [];
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_markAvailableCheckinDates).call(this, dates);
                    break;
                }
                case 'checkin': {
                    const checkin = this.findControl('checkin');
                    if (checkin) {
                        const checkinFrom = App.parseIsoDate(items[key][0].title);
                        const checkinTo = App.parseIsoDate(items[key][1].title);
                        checkin.setValues(checkinFrom, checkinTo);
                    }
                    break;
                }
                default:
                    App.CruiseMainFilterBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruisePortMainFilter_onPortFilterChange = function _CruisePortMainFilter_onPortFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const rqData = App.CruiseMainFilterBase.getDataForSearchFilters(eventData);
            rqData.portId = __classPrivateFieldGet(this, _CruisePortMainFilter_options, "f").portId.toString();
            rqData['port[]'] = __classPrivateFieldGet(this, _CruisePortMainFilter_options, "f").portId.toString();
            yield __classPrivateFieldGet(this, _CruisePortMainFilter_instances, "m", _CruisePortMainFilter_getPortFilters).call(this, rqData, eventData);
        });
    }, _CruisePortMainFilter_onPortFilterSearch = function _CruisePortMainFilter_onPortFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    };
    App.CruisePortMainFilter = CruisePortMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    class CruisePortResult extends App.Result {
        constructor(options) {
            super(Object.assign({ tableTemplate: App.templates.Cruise.Ship.TableOutput }, options));
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case 'date':
                    return items.sort((a, b) => App.Result.sort(a.dateStart, b.dateStart, a.price, b.price, this.sorting.reverse));
                default:
                    return items.sort((a, b) => App.Result.sort(a.price, b.price, a.dateStart, b.dateStart, this.sorting.reverse));
            }
        }
    }
    App.CruisePortResult = CruisePortResult;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _CruiseResultMobileBase_getBannerPosition;
    class CruiseResultMobileBase extends App.Result {
        constructor(options) {
            super(Object.assign({}, options));
            Object.defineProperty(this, "bannerIncutPositions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        prepareData(viewType, items, addBlock) {
            if (!this.bannerIncutPositions)
                return items;
            const skipCount = addBlock ? this.paging.index * this.paging.size : 0;
            for (let i = 0; i < items.length; i++) {
                const idx = skipCount + i;
                const pos = __classPrivateFieldGet(_a, _a, "m", _CruiseResultMobileBase_getBannerPosition).call(_a, this.bannerIncutPositions, idx);
                if (!pos) {
                    items[i].bannerIncutId = null;
                    items[i].bannerIncutUrl = null;
                }
                else {
                    this.fillBannerIncut(items[i], pos, viewType);
                }
            }
            return items;
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        fillBannerIncut(item, pos, viewType) {
            item.bannerIncutId = null;
            item.bannerIncutUrl = null;
        }
    }
    _a = CruiseResultMobileBase, _CruiseResultMobileBase_getBannerPosition = function _CruiseResultMobileBase_getBannerPosition(bannerIncutPositions, index) {
        const bannerIndex = bannerIncutPositions.indexOf(index + 1);
        return bannerIndex < 0 ? null : bannerIndex + 1;
    };
    App.CruiseResultMobileBase = CruiseResultMobileBase;
})(App || (App = {}));
/// <reference path='CruiseResultBase.Mobile.ts' />
var App;
(function (App) {
    class CruiseResultMobile extends App.CruiseResultMobileBase {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Cruise.Search.BlockOutput, tableTemplate: App.templates.Cruise.Search.TableOutput }, options));
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case 'date':
                    return items.sort((a, b) => App.Result.sort(a.dateStart, b.dateStart, a.price, b.price, this.sorting.reverse));
                default:
                    return items.sort((a, b) => App.Result.sort(a.price, b.price, a.dateStart, b.dateStart, this.sorting.reverse));
            }
        }
        applyFilters(items) {
            if (this.filtering.items.length <= 0)
                return items;
            let result = items;
            this.filtering.items
                .filter(v => v.values.length > 0)
                .forEach(v => {
                switch (v.name.toLowerCase()) {
                    case 'region': {
                        result = result.filter(item => v.values.some(x => item.regionElements.map(k => k.key).includes(Number(x))));
                        break;
                    }
                    case 'route': {
                        result = result.filter(item => v.values.some(x => item.routeElements.map(k => k.key).includes(Number(x))));
                        break;
                    }
                    case 'port': {
                        const vals = v.values;
                        result = result.filter(item => vals.some(x => item.portDepartureElements.map(k => k.key).includes(Number(x))));
                        break;
                    }
                    case 'rusgroup': {
                        result = result.filter(item => v.values.some(x => {
                            if (x === 'true')
                                return x === item.existRusGroup.toString();
                            return true;
                        }));
                        break;
                    }
                    // no default
                }
            });
            return result;
        }
        prepareData(viewType, items, addBlock) {
            if (viewType === 'table')
                this.bannerIncutPositions = App.app.settings.cruiseOptions.bannerIncutPositions.groupTable;
            else
                this.bannerIncutPositions = App.app.settings.cruiseOptions.bannerIncutPositions.groupBlock;
            return super.prepareData(viewType, items, addBlock);
        }
        fillBannerIncut(item, pos, viewType) {
            const siteUserKey = $('#siteUserKey').valNumber();
            const cookiesCity = App.Cookie.get("location" /* KnownCookie.Location */);
            const city = cookiesCity ? parseInt(cookiesCity) : 0;
            const host = window.location.hostname;
            item.bannerIncutId = `bannerIncut${item.number}-${viewType}-${pos}`;
            item.bannerIncutUrl = `//store.pac.ru/advh.ashx?dom=${item.bannerIncutId}&br=pw-cruise-search-big-${pos}&pd=0&sc=10&sb=1&ms=5&ac=0&bc=7&fdp=${city}&dm=${host}`;
            if (siteUserKey && siteUserKey > 0)
                item.bannerIncutUrl += `&uk=${siteUserKey}`;
        }
    }
    App.CruiseResultMobile = CruiseResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _CruiseResultBase_getBannerPosition;
    class CruiseResultBase extends App.Result {
        constructor(options) {
            super(Object.assign({}, options));
            Object.defineProperty(this, "bannerIncutPositions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        prepareData(viewType, items, addBlock) {
            if (!this.bannerIncutPositions)
                return items;
            const skipCount = addBlock ? this.paging.index * this.paging.size : 0;
            for (let i = 0; i < items.length; i++) {
                const idx = skipCount + i;
                const pos = __classPrivateFieldGet(_a, _a, "m", _CruiseResultBase_getBannerPosition).call(_a, this.bannerIncutPositions, idx);
                if (!pos) {
                    items[i].bannerIncutId = null;
                    items[i].bannerIncutUrl = null;
                }
                else {
                    this.fillBannerIncut(items[i], pos, viewType);
                }
            }
            return items;
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        fillBannerIncut(item, pos, viewType) {
            item.bannerIncutId = null;
            item.bannerIncutUrl = null;
        }
    }
    _a = CruiseResultBase, _CruiseResultBase_getBannerPosition = function _CruiseResultBase_getBannerPosition(bannerIncutPositions, index) {
        const bannerIndex = bannerIncutPositions.indexOf(index + 1);
        return bannerIndex < 0 ? null : bannerIndex + 1;
    };
    App.CruiseResultBase = CruiseResultBase;
})(App || (App = {}));
/// <reference path='CruiseResultBase.ts' />
var App;
(function (App) {
    class CruiseResult extends App.CruiseResultBase {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Cruise.Search.BlockOutput, tableTemplate: App.templates.Cruise.Search.TableOutput }, options));
        }
        changeDataSource(data, append = false) {
            const result = super.changeDataSource(data, append);
            if (data.length > 0)
                this.root.showByClass();
            return result;
        }
        resetDataSource() {
            this.root.hideByClass();
            super.resetDataSource();
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case 'date':
                    return items.sort((a, b) => App.Result.sort(a.dateStart, b.dateStart, a.price, b.price, this.sorting.reverse));
                default:
                    return items.sort((a, b) => App.Result.sort(a.price, b.price, a.dateStart, b.dateStart, this.sorting.reverse));
            }
        }
        applyFilters(items) {
            if (this.filtering.items.length <= 0)
                return items;
            let result = items;
            this.filtering.items
                .filter(v => v.values.length > 0)
                .forEach(v => {
                switch (v.name.toLowerCase()) {
                    case 'region': {
                        result = result.filter(item => v.values.some(x => item.regionElements.map(k => k.key).includes(Number(x))));
                        break;
                    }
                    case 'route': {
                        result = result.filter(item => v.values.some(x => item.routeElements.map(k => k.key).includes(Number(x))));
                        break;
                    }
                    case 'port': {
                        const vals = v.values;
                        result = result.filter(item => vals.some(x => item.portDepartureElements.map(k => k.key).includes(Number(x))));
                        break;
                    }
                    case 'rusgroup': {
                        result = result.filter(item => v.values.some(x => {
                            if (x === 'true')
                                return x === item.existRusGroup.toString();
                            return true;
                        }));
                        break;
                    }
                    // no default
                }
            });
            return result;
        }
        prepareData(viewType, items, addBlock) {
            if (viewType === 'table')
                this.bannerIncutPositions = App.app.settings.cruiseOptions.bannerIncutPositions.groupTable;
            else
                this.bannerIncutPositions = App.app.settings.cruiseOptions.bannerIncutPositions.groupBlock;
            return super.prepareData(viewType, items, addBlock);
        }
        fillBannerIncut(item, pos, viewType) {
            const siteUserKey = $('#siteUserKey').valNumber();
            const cookiesCity = App.Cookie.get("location" /* KnownCookie.Location */);
            const city = cookiesCity ? parseInt(cookiesCity) : 0;
            const host = window.location.hostname;
            item.bannerIncutId = `bannerIncut${item.number}-${viewType}-${pos}`;
            item.bannerIncutUrl = `//store.pac.ru/advh.ashx?dom=${item.bannerIncutId}&br=pw-cruise-search-big-${pos}&pd=0&sc=10&sb=1&ms=5&ac=0&bc=7&ver=wide&fdp=${city}&dm=${host}`;
            if (siteUserKey && siteUserKey > 0)
                item.bannerIncutUrl += `&uk=${siteUserKey}`;
        }
    }
    App.CruiseResult = CruiseResult;
})(App || (App = {}));
var App;
(function (App) {
    class CruiseRouteHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(options);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.CruiseRouteHotFilterMobile = CruiseRouteHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class CruiseRouteHotFilter extends App.HotFilter {
        constructor(options) {
            super(options);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.CruiseRouteHotFilter = CruiseRouteHotFilter;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.Mobile.ts' />
var App;
(function (App) {
    var _CruiseRouteMainFilterMobile_instances, _CruiseRouteMainFilterMobile_options, _CruiseRouteMainFilterMobile_filters, _CruiseRouteMainFilterMobile_popup, _CruiseRouteMainFilterMobile_responseValidator, _CruiseRouteMainFilterMobile_initRouteFilterEvents, _CruiseRouteMainFilterMobile_markAvailableCheckinDates, _CruiseRouteMainFilterMobile_getRouteFilterControls, _CruiseRouteMainFilterMobile_getRouteFilters, _CruiseRouteMainFilterMobile_updateRouteFilter, _CruiseRouteMainFilterMobile_onRouteFilterChange, _CruiseRouteMainFilterMobile_onRouteFilterSearch;
    class CruiseRouteMainFilterMobile extends App.CruiseMainFilterMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-detail-filter', customFilters: {
                    root: '.js-cruise-detail-filter',
                    clickSelector: '.js-cruise-detail-filters-open',
                    modalKey: 'cruise-detail-filters-modal',
                    contentSelector: '#js-cruise-detail-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать', // TODO: @Localizer.Text("Auto.SearchButton")
                } }, options));
            _CruiseRouteMainFilterMobile_instances.add(this);
            _CruiseRouteMainFilterMobile_options.set(this, void 0);
            _CruiseRouteMainFilterMobile_filters.set(this, void 0);
            _CruiseRouteMainFilterMobile_popup.set(this, void 0);
            _CruiseRouteMainFilterMobile_responseValidator.set(this, void 0);
            Object.defineProperty(this, "routeFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruiseRouteMainFilterMobile_options, options, "f");
            if (!this.root.length) {
                this.routeFilter = $();
                return;
            }
            this.routeFilter = this.root;
            __classPrivateFieldSet(this, _CruiseRouteMainFilterMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruiseRouteMainFilterMobile_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_initRouteFilterEvents).call(this); }))();
        }
        clear() {
        }
    }
    _CruiseRouteMainFilterMobile_options = new WeakMap(), _CruiseRouteMainFilterMobile_filters = new WeakMap(), _CruiseRouteMainFilterMobile_popup = new WeakMap(), _CruiseRouteMainFilterMobile_responseValidator = new WeakMap(), _CruiseRouteMainFilterMobile_instances = new WeakSet(), _CruiseRouteMainFilterMobile_initRouteFilterEvents = function _CruiseRouteMainFilterMobile_initRouteFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseRouteMainFilterMobile_filters, __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_getRouteFilterControls).call(this, this.routeFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f")[controlName].trackChanges) {
                    __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f")[controlName].element.on('change', { sender: controlName, controls: __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f") }, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_onRouteFilterChange).call(this, event.data);
                    }));
                }
            });
            this.routeFilter.on('submit', e => __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_onRouteFilterSearch).call(this, e));
            $(document).on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.routeFilter, __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f").price.block); }));
            __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f").price.element.on("filter:change" /* Events.FilterChange */, e => App.CruiseMainFilterMobileBase.onPriceSliderChange(e));
            yield this.changePriceInSlider(this.routeFilter, __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_options, "f").changes.push(name);
            });
        });
    }, _CruiseRouteMainFilterMobile_markAvailableCheckinDates = function _CruiseRouteMainFilterMobile_markAvailableCheckinDates(dates) {
        // маркировка
        App.CruiseMainFilterMobileBase.markDates(__classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_filters, "f"), dates);
    }, _CruiseRouteMainFilterMobile_getRouteFilterControls = function _CruiseRouteMainFilterMobile_getRouteFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: this.filters.findControl('seats'),
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('[data-select="city"] .js-jelect'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] input'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('.js-filter-select-block[data-select="type"] input'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            port: {
                element: container.find('[data-select="port"] .js-jelect'),
                block: this.findControl('port'),
                trackChanges: true,
                multiple: true,
                changeType: 'port',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] input'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruiseRouteMainFilterMobile_getRouteFilters = function _CruiseRouteMainFilterMobile_getRouteFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_options, "f").urls.getRouteFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_updateRouteFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseRouteMainFilterMobile_updateRouteFilter = function _CruiseRouteMainFilterMobile_updateRouteFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = [];
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_markAvailableCheckinDates).call(this, dates /* , true*/);
                    break;
                }
                default:
                    App.CruiseMainFilterMobileBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruiseRouteMainFilterMobile_onRouteFilterChange = function _CruiseRouteMainFilterMobile_onRouteFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const rqData = App.CruiseMainFilterMobileBase.getDataForSearchFilters(eventData);
            rqData.routeId = __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_options, "f").routeNumber;
            rqData.shipId = __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_options, "f").shipId.toString();
            yield __classPrivateFieldGet(this, _CruiseRouteMainFilterMobile_instances, "m", _CruiseRouteMainFilterMobile_getRouteFilters).call(this, rqData, eventData);
        });
    }, _CruiseRouteMainFilterMobile_onRouteFilterSearch = function _CruiseRouteMainFilterMobile_onRouteFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("routeFilter:search" /* Events.RouteFilterSearch */);
    };
    App.CruiseRouteMainFilterMobile = CruiseRouteMainFilterMobile;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.ts' />
var App;
(function (App) {
    var _CruiseRouteMainFilter_instances, _CruiseRouteMainFilter_options, _CruiseRouteMainFilter_filters, _CruiseRouteMainFilter_popup, _CruiseRouteMainFilter_responseValidator, _CruiseRouteMainFilter_initRouteFilterEvents, _CruiseRouteMainFilter_markAvailableCheckinDates, _CruiseRouteMainFilter_getRouteFilterControls, _CruiseRouteMainFilter_getRouteFilters, _CruiseRouteMainFilter_updateRouteFilter, _CruiseRouteMainFilter_onRouteFilterChange, _CruiseRouteMainFilter_onRouteFilterSearch;
    class CruiseRouteMainFilter extends App.CruiseMainFilterBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruiseRouteMainFilter_instances.add(this);
            _CruiseRouteMainFilter_options.set(this, void 0);
            _CruiseRouteMainFilter_filters.set(this, void 0);
            _CruiseRouteMainFilter_popup.set(this, void 0);
            _CruiseRouteMainFilter_responseValidator.set(this, void 0);
            Object.defineProperty(this, "routeFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruiseRouteMainFilter_options, options, "f");
            if (!this.root.length) {
                this.routeFilter = $();
                return;
            }
            this.routeFilter = this.root;
            __classPrivateFieldSet(this, _CruiseRouteMainFilter_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruiseRouteMainFilter_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_initRouteFilterEvents).call(this); }))();
        }
        clear() {
        }
    }
    _CruiseRouteMainFilter_options = new WeakMap(), _CruiseRouteMainFilter_filters = new WeakMap(), _CruiseRouteMainFilter_popup = new WeakMap(), _CruiseRouteMainFilter_responseValidator = new WeakMap(), _CruiseRouteMainFilter_instances = new WeakSet(), _CruiseRouteMainFilter_initRouteFilterEvents = function _CruiseRouteMainFilter_initRouteFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseRouteMainFilter_filters, __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_getRouteFilterControls).call(this, this.routeFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f")[controlName].trackChanges) {
                    __classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f")[controlName].element.on('change', { sender: controlName, controls: __classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f") }, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_onRouteFilterChange).call(this, event.data);
                    }));
                }
            });
            this.routeFilter.on('submit', e => __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_onRouteFilterSearch).call(this, e));
            $(document).on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.routeFilter, __classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f").price.block); }));
            __classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f").price.element.on("filter:change" /* Events.FilterChange */, e => App.CruiseMainFilterBase.onPriceSliderChange(e));
            yield this.changePriceInSlider(this.routeFilter, __classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruiseRouteMainFilter_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruiseRouteMainFilter_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruiseRouteMainFilter_options, "f").changes.push(name);
            });
        });
    }, _CruiseRouteMainFilter_markAvailableCheckinDates = function _CruiseRouteMainFilter_markAvailableCheckinDates(dates) {
        // маркировка
        App.CruiseMainFilterBase.markDates(__classPrivateFieldGet(this, _CruiseRouteMainFilter_filters, "f"), dates);
    }, _CruiseRouteMainFilter_getRouteFilterControls = function _CruiseRouteMainFilter_getRouteFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('[data-select="city"] .js-jelect'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] input'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('.js-filter-select-block[data-select="type"] input'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            port: {
                element: container.find('[data-select="port"] .js-jelect'),
                block: this.findControl('port'),
                trackChanges: true,
                multiple: true,
                changeType: 'port',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] input'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruiseRouteMainFilter_getRouteFilters = function _CruiseRouteMainFilter_getRouteFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseRouteMainFilter_options, "f").urls.getRouteFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseRouteMainFilter_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseRouteMainFilter_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_updateRouteFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseRouteMainFilter_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseRouteMainFilter_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseRouteMainFilter_updateRouteFilter = function _CruiseRouteMainFilter_updateRouteFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = [];
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_markAvailableCheckinDates).call(this, dates /* , true*/);
                    break;
                }
                default:
                    App.CruiseMainFilterBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruiseRouteMainFilter_onRouteFilterChange = function _CruiseRouteMainFilter_onRouteFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const rqData = App.CruiseMainFilterBase.getDataForSearchFilters(eventData);
            rqData.routeId = __classPrivateFieldGet(this, _CruiseRouteMainFilter_options, "f").routeNumber;
            rqData.shipId = __classPrivateFieldGet(this, _CruiseRouteMainFilter_options, "f").shipId.toString();
            yield __classPrivateFieldGet(this, _CruiseRouteMainFilter_instances, "m", _CruiseRouteMainFilter_getRouteFilters).call(this, rqData, eventData);
        });
    }, _CruiseRouteMainFilter_onRouteFilterSearch = function _CruiseRouteMainFilter_onRouteFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("routeFilter:search" /* Events.RouteFilterSearch */);
    };
    App.CruiseRouteMainFilter = CruiseRouteMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    class CruiseRouteResultMobile extends App.CruiseResultMobileBase {
        constructor(options) {
            super(Object.assign({ tableTemplate: App.templates.Cruise.Route.TableOutput }, options));
            this.bannerIncutPositions = App.app.settings.cruiseOptions.bannerIncutPositions.route;
        }
        clearFilteringData() {
            this.filtering.items = [];
        }
        applySorting(items) {
            const rvs = this.sorting.reverse;
            switch (this.sorting.field) {
                case 'checkindate':
                    return items.sort((a, b) => App.Result.sort(a.checkinDate, b.checkinDate, a.price, b.price, rvs));
                case 'price':
                    return items.sort((a, b) => App.Result.sort(a.price, b.price, a.checkinDate, b.checkinDate, rvs));
                case 'port':
                    return items.sort((a, b) => App.Result.sort(a.portDeparture.name, b.portDeparture.name, a.price, b.price, rvs));
                default:
                    return items.sort((a, b) => App.Result.sort(a.checkinDate, b.checkinDate, a.price, b.price, rvs));
            }
        }
        fillBannerIncut(item, pos, viewType) {
            const siteUserKey = $('#siteUserKey').valNumber();
            const cookiesCity = App.Cookie.get("location" /* KnownCookie.Location */);
            const city = cookiesCity ? parseInt(cookiesCity) : 0;
            const host = window.location.hostname;
            item.bannerIncutId = `bannerIncut${item.key}-${viewType}-${pos}`;
            item.bannerIncutUrl = `//store.pac.ru/advh.ashx?dom=${item.bannerIncutId}&br=pw-cruise-route-big-${pos}&pd=0&sc=10&sb=1&ms=5&ac=0&bc=7&fdp=${city}&dm=${host}`;
            if (siteUserKey && siteUserKey > 0)
                item.bannerIncutUrl += `&uk=${siteUserKey}`;
        }
    }
    App.CruiseRouteResultMobile = CruiseRouteResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    class CruiseRouteResult extends App.CruiseResultBase {
        constructor(options) {
            super(Object.assign({ tableTemplate: App.templates.Cruise.Route.TableOutput }, options));
            this.bannerIncutPositions = App.app.settings.cruiseOptions.bannerIncutPositions.route;
        }
        clearFilteringData() {
            this.filtering.items = [];
        }
        applySorting(items) {
            const rvs = this.sorting.reverse;
            switch (this.sorting.field) {
                case 'checkindate':
                    return items.sort((a, b) => App.Result.sort(a.checkinDate, b.checkinDate, a.price, b.price, rvs));
                case 'price':
                    return items.sort((a, b) => App.Result.sort(a.price, b.price, a.checkinDate, b.checkinDate, rvs));
                case 'port':
                    return items.sort((a, b) => App.Result.sort(a.portDeparture.name, b.portDeparture.name, a.price, b.price, rvs));
                default:
                    return items.sort((a, b) => App.Result.sort(a.checkinDate, b.checkinDate, a.price, b.price, rvs));
            }
        }
        fillBannerIncut(item, pos, viewType) {
            const siteUserKey = $('#siteUserKey').valNumber();
            const cookiesCity = App.Cookie.get("location" /* KnownCookie.Location */);
            const city = cookiesCity ? parseInt(cookiesCity) : 0;
            const host = window.location.hostname;
            item.bannerIncutId = `bannerIncut${item.key}-${viewType}-${pos}`;
            item.bannerIncutUrl = `//store.pac.ru/advh.ashx?dom=${item.bannerIncutId}&br=pw-cruise-route-big-${pos}&pd=0&sc=10&sb=1&ms=5&ac=0&bc=7&ver=wide&fdp=${city}&dm=${host}`;
            if (siteUserKey && siteUserKey > 0)
                item.bannerIncutUrl += `&uk=${siteUserKey}`;
        }
    }
    App.CruiseRouteResult = CruiseRouteResult;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.Mobile.ts' />
var App;
(function (App) {
    var _CruiseSearchMainFilterMobile_instances, _CruiseSearchMainFilterMobile_options, _CruiseSearchMainFilterMobile_filters, _CruiseSearchMainFilterMobile_popup, _CruiseSearchMainFilterMobile_responseValidator, _CruiseSearchMainFilterMobile_setSelectListFromUrl, _CruiseSearchMainFilterMobile_setDateFromUrl, _CruiseSearchMainFilterMobile_setToggleFromUrl, _CruiseSearchMainFilterMobile_initSearchFilterEvents, _CruiseSearchMainFilterMobile_markAvailableCheckinDates, _CruiseSearchMainFilterMobile_getFilterControls, _CruiseSearchMainFilterMobile_getSearchFilters, _CruiseSearchMainFilterMobile_updateSearchFilter, _CruiseSearchMainFilterMobile_onFilterChange, _CruiseSearchMainFilterMobile_onFilterSearch;
    class CruiseSearchMainFilterMobile extends App.CruiseMainFilterMobileBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruiseSearchMainFilterMobile_instances.add(this);
            _CruiseSearchMainFilterMobile_options.set(this, void 0);
            _CruiseSearchMainFilterMobile_filters.set(this, void 0);
            _CruiseSearchMainFilterMobile_popup.set(this, void 0);
            _CruiseSearchMainFilterMobile_responseValidator.set(this, void 0);
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruiseSearchMainFilterMobile_options, options, "f");
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            __classPrivateFieldSet(this, _CruiseSearchMainFilterMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruiseSearchMainFilterMobile_responseValidator, new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_initSearchFilterEvents).call(this); }))();
        }
        initializeFromUrl(queryParams) {
            const checkin = queryParams.param('checkin');
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setDateFromUrl).call(this, 'Checkin.From', checkin[0]);
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setDateFromUrl).call(this, 'Checkin.To', checkin[1]);
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'City', queryParams.param('city'));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Fare', queryParams.param('fare'));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Type', queryParams.param('type'));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Region', queryParams.param('region'));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Port', queryParams.param('port'));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Ship', queryParams.param('ship'));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Cabin', queryParams.param('cabin'));
            const night = queryParams.param('night');
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Night.From', night.slice(0, 1));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setSelectListFromUrl).call(this, 'Night.To', night.slice(1, 2));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setToggleFromUrl).call(this, 'Seats', queryParams.param('seats')[0]);
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_setToggleFromUrl).call(this, 'RusGroup', queryParams.param('rusgroup')[0]);
        }
        reset() {
            const priceSlider = __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").price.block;
            priceSlider.setValues(__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.minPrice, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.maxPrice, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.minPrice, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.maxPrice);
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").price.element.find('[data-name="filter_price_from"]').attr('data-money-amount', __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.minPrice);
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").price.element.find('[data-name="filter_price_to"]').attr('data-money-amount', __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.maxPrice);
            (() => __awaiter(this, void 0, void 0, function* () {
                yield this.changePriceInSlider(this.searchFilter, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").price.block);
            }))();
            const dateBlock = __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").checkinFrom.block;
            dateBlock.clear();
            const tourist = this.findControl('tourist');
            if (tourist)
                tourist.setValues(__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.adultCount, []);
            const slidings = $('.js-filter-sliding-btn-b', this.searchFilter);
            slidings.each((i, val) => {
                const sliding = $(val);
                const name = sliding.attr('data-name') || '';
                if (sliding.find('input').val() !== __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults[name].toString())
                    sliding.find('.js-sliding-btn').trigger('click');
            });
            (() => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_onFilterChange).call(this, { sender: 'none', controls: __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f") });
            }))();
        }
    }
    _CruiseSearchMainFilterMobile_options = new WeakMap(), _CruiseSearchMainFilterMobile_filters = new WeakMap(), _CruiseSearchMainFilterMobile_popup = new WeakMap(), _CruiseSearchMainFilterMobile_responseValidator = new WeakMap(), _CruiseSearchMainFilterMobile_instances = new WeakSet(), _CruiseSearchMainFilterMobile_setSelectListFromUrl = function _CruiseSearchMainFilterMobile_setSelectListFromUrl(controlName, values) {
        if (!values.length)
            return;
        const control = this.filters.findControl(controlName);
        if (!control)
            return;
        const selectedValues = new Set(values.map(value => decodeURIComponent(value).toLowerCase()));
        const items = this.filters.getControlValue(controlName);
        if (!Array.isArray(items))
            return;
        const newItems = items.map(item => (Object.assign(Object.assign({}, item), { checked: !item.select_all
                && selectedValues.has(item.value.toString().toLowerCase()) })));
        control.setValue(newItems, false);
    }, _CruiseSearchMainFilterMobile_setDateFromUrl = function _CruiseSearchMainFilterMobile_setDateFromUrl(controlName, value) {
        var _a;
        if (!value)
            return;
        const match = /^(\d{4})(\d{2})(\d{2})$/.exec(value);
        if (!match)
            return;
        const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
        (_a = this.filters
            .findControl(controlName)) === null || _a === void 0 ? void 0 : _a.setValue(date, false);
    }, _CruiseSearchMainFilterMobile_setToggleFromUrl = function _CruiseSearchMainFilterMobile_setToggleFromUrl(controlName, value) {
        var _a;
        if (value == null)
            return;
        const checked = value.toLowerCase() === 'true'
            || value === '1';
        (_a = this.filters
            .findControl(controlName)) === null || _a === void 0 ? void 0 : _a.setValue(checked, false);
    }, _CruiseSearchMainFilterMobile_initSearchFilterEvents = function _CruiseSearchMainFilterMobile_initSearchFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseSearchMainFilterMobile_filters, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_getFilterControls).call(this, this.searchFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f")[controlName].trackChanges) {
                    const data = { sender: __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f")[controlName].changeType, controls: __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f") };
                    __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f")[controlName].element.on('change', data, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_onFilterChange).call(this, event.data);
                    }));
                }
            });
            this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_onFilterSearch).call(this, e));
            $(document).on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.searchFilter, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").price.block); }));
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").price.element.on("filter:change" /* Events.FilterChange */, e => App.CruiseMainFilterMobileBase.onPriceSliderChange(e));
            yield this.changePriceInSlider(this.searchFilter, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").changes.push(name);
            });
        });
    }, _CruiseSearchMainFilterMobile_markAvailableCheckinDates = function _CruiseSearchMainFilterMobile_markAvailableCheckinDates(dates) {
        // маркировка
        App.CruiseMainFilterMobileBase.markDates(__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_filters, "f"), dates);
    }, _CruiseSearchMainFilterMobile_getFilterControls = function _CruiseSearchMainFilterMobile_getFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('.js-filter-select-block[data-select="city"] .js-jelect'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] .js-jelect'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('.js-filter-select-block[data-select="type"] .js-jelect'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            region: {
                element: container.find('.js-filter-select-block[data-select="region"] .js-jelect'),
                block: this.findControl('region'),
                trackChanges: true,
                multiple: true,
                changeType: 'region',
            },
            port: {
                element: container.find('.js-filter-select-block[data-select="port"] .js-jelect'),
                block: this.findControl('port'),
                trackChanges: true,
                multiple: true,
                changeType: 'port',
            },
            ship: {
                element: container.find('.js-filter-select-block[data-select="ship"] .js-jelect'),
                block: this.findControl('ship'),
                trackChanges: true,
                multiple: true,
                changeType: 'ship',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                block: this.findControl('Checkin'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                block: this.findControl('Checkin'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'night',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'night',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] .js-jelect'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruiseSearchMainFilterMobile_getSearchFilters = function _CruiseSearchMainFilterMobile_getSearchFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.submitButton.prop('disabled', true);
            this.submitButton.addClass('_disabled');
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").urls.getSearchFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_updateSearchFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                this.submitButton.removeClass('_disabled');
                this.submitButton.prop('disabled', false);
                __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseSearchMainFilterMobile_updateSearchFilter = function _CruiseSearchMainFilterMobile_updateSearchFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = new Array();
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_markAvailableCheckinDates).call(this, dates);
                    break;
                }
                case 'checkin': {
                    const checkin = this.findControl('checkin');
                    if (checkin) {
                        const checkinFrom = App.parseIsoDate(items[key][0].title);
                        const checkinTo = App.parseIsoDate(items[key][1].title);
                        checkin.setValues(checkinFrom, checkinTo);
                    }
                    break;
                }
                default:
                    App.CruiseMainFilterMobileBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruiseSearchMainFilterMobile_onFilterChange = function _CruiseSearchMainFilterMobile_onFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const changes = [...__classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").changes];
            if (eventData.sender !== 'none' && !changes.includes(eventData.sender))
                changes.push(eventData.sender);
            const rqData = App.CruiseMainFilterMobileBase.getDataForSearchFilters(eventData);
            if (eventData.sender === 'none') {
                rqData.city = '0';
                rqData.nightFrom = __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.nightFrom.toString();
                rqData.nightTo = __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_options, "f").defaults.nightTo.toString();
                delete rqData.type;
                delete rqData.fare;
                delete rqData.region;
                delete rqData.port;
                delete rqData.ship;
                delete rqData.cabin;
            }
            rqData.changes = changes;
            yield __classPrivateFieldGet(this, _CruiseSearchMainFilterMobile_instances, "m", _CruiseSearchMainFilterMobile_getSearchFilters).call(this, rqData, eventData);
        });
    }, _CruiseSearchMainFilterMobile_onFilterSearch = function _CruiseSearchMainFilterMobile_onFilterSearch(event) {
        event.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    };
    App.CruiseSearchMainFilterMobile = CruiseSearchMainFilterMobile;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.ts' />
var App;
(function (App) {
    var _CruiseSearchMainFilter_instances, _CruiseSearchMainFilter_options, _CruiseSearchMainFilter_filters, _CruiseSearchMainFilter_popup, _CruiseSearchMainFilter_responseValidator, _CruiseSearchMainFilter_initSearchFilterEvents, _CruiseSearchMainFilter_markAvailableCheckinDates, _CruiseSearchMainFilter_getFilterControls, _CruiseSearchMainFilter_getSearchFilters, _CruiseSearchMainFilter_updateSearchFilter, _CruiseSearchMainFilter_onFilterChange, _CruiseSearchMainFilter_onFilterSearch;
    class CruiseSearchMainFilter extends App.CruiseMainFilterBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruiseSearchMainFilter_instances.add(this);
            _CruiseSearchMainFilter_options.set(this, void 0);
            _CruiseSearchMainFilter_filters.set(this, void 0);
            _CruiseSearchMainFilter_popup.set(this, void 0);
            _CruiseSearchMainFilter_responseValidator.set(this, void 0);
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruiseSearchMainFilter_options, options, "f");
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            __classPrivateFieldSet(this, _CruiseSearchMainFilter_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruiseSearchMainFilter_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_initSearchFilterEvents).call(this); }))();
        }
        reset() {
            const priceSlider = __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").price.block;
            priceSlider.setValues(App.app.settings.cruiseOptions.minPrice, App.app.settings.cruiseOptions.maxPrice, App.app.settings.cruiseOptions.minPrice, App.app.settings.cruiseOptions.maxPrice);
            __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").price.element.find('[data-name="filter_price_from"]').attr('data-money-amount', App.app.settings.cruiseOptions.minPrice);
            __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").price.element.find('[data-name="filter_price_to"]').attr('data-money-amount', App.app.settings.cruiseOptions.maxPrice);
            (() => __awaiter(this, void 0, void 0, function* () {
                yield this.changePriceInSlider(this.searchFilter, __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").price.block);
            }))();
            const dateBlock = __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").checkinFrom.block;
            dateBlock.clear();
            const tourist = this.findControl('tourist');
            if (tourist)
                tourist.setValues(__classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").defaults.adultCount, []);
            const slidings = $('.js-filter-sliding-btn-b', this.searchFilter);
            slidings.each((i, val) => {
                const sliding = $(val);
                const name = sliding.attr('data-name') || '';
                if (sliding.find('input').val() !== __classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").defaults[name].toString())
                    sliding.find('.js-sliding-btn').trigger('click');
            });
            (() => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_onFilterChange).call(this, { sender: 'none', controls: __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f") });
            }))();
        }
    }
    _CruiseSearchMainFilter_options = new WeakMap(), _CruiseSearchMainFilter_filters = new WeakMap(), _CruiseSearchMainFilter_popup = new WeakMap(), _CruiseSearchMainFilter_responseValidator = new WeakMap(), _CruiseSearchMainFilter_instances = new WeakSet(), _CruiseSearchMainFilter_initSearchFilterEvents = function _CruiseSearchMainFilter_initSearchFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseSearchMainFilter_filters, __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_getFilterControls).call(this, this.searchFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f")[controlName].trackChanges) {
                    const data = { sender: __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f")[controlName].changeType, controls: __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f") };
                    __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f")[controlName].element.on('change', data, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_onFilterChange).call(this, event.data);
                    }));
                }
            });
            this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_onFilterSearch).call(this, e));
            $(document).on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.searchFilter, __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").price.block); }));
            __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").price.element.on("filter:change" /* Events.FilterChange */, e => App.CruiseMainFilterBase.onPriceSliderChange(e));
            yield this.changePriceInSlider(this.searchFilter, __classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").changes.push(name);
            });
        });
    }, _CruiseSearchMainFilter_markAvailableCheckinDates = function _CruiseSearchMainFilter_markAvailableCheckinDates(dates) {
        // маркировка
        App.CruiseMainFilterBase.markDates(__classPrivateFieldGet(this, _CruiseSearchMainFilter_filters, "f"), dates);
    }, _CruiseSearchMainFilter_getFilterControls = function _CruiseSearchMainFilter_getFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('.js-filter-select-block[data-select="city"] .js-jelect'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] .js-jelect'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('.js-filter-select-block[data-select="type"] .js-jelect'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            region: {
                element: container.find('.js-filter-select-block[data-select="region"] .js-jelect'),
                block: this.findControl('region'),
                trackChanges: true,
                multiple: true,
                changeType: 'region',
            },
            port: {
                element: container.find('.js-filter-select-block[data-select="port"] .js-jelect'),
                block: this.findControl('port'),
                trackChanges: true,
                multiple: true,
                changeType: 'port',
            },
            ship: {
                element: container.find('.js-filter-select-block[data-select="ship"] .js-jelect'),
                block: this.findControl('ship'),
                trackChanges: true,
                multiple: true,
                changeType: 'ship',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                block: this.findControl('Checkin'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                block: this.findControl('Checkin'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'night',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'night',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] .js-jelect'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruiseSearchMainFilter_getSearchFilters = function _CruiseSearchMainFilter_getSearchFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.submitButton.prop('disabled', true);
            this.submitButton.addClass('_disabled');
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").urls.getSearchFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseSearchMainFilter_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseSearchMainFilter_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_updateSearchFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseSearchMainFilter_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                this.submitButton.removeClass('_disabled');
                this.submitButton.prop('disabled', false);
                __classPrivateFieldGet(this, _CruiseSearchMainFilter_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseSearchMainFilter_updateSearchFilter = function _CruiseSearchMainFilter_updateSearchFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = new Array();
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_markAvailableCheckinDates).call(this, dates);
                    break;
                }
                case 'checkin': {
                    const checkin = this.findControl('checkin');
                    if (checkin) {
                        const checkinFrom = App.parseIsoDate(items[key][0].title);
                        const checkinTo = App.parseIsoDate(items[key][1].title);
                        checkin.setValues(checkinFrom, checkinTo);
                    }
                    break;
                }
                default:
                    App.CruiseMainFilterBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruiseSearchMainFilter_onFilterChange = function _CruiseSearchMainFilter_onFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const changes = [...__classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").changes];
            if (eventData.sender !== 'none' && !changes.includes(eventData.sender))
                changes.push(eventData.sender);
            const rqData = App.CruiseMainFilterBase.getDataForSearchFilters(eventData);
            if (eventData.sender === 'none') {
                rqData.city = '0';
                rqData.nightFrom = __classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").defaults.nightFrom.toString();
                rqData.nightTo = __classPrivateFieldGet(this, _CruiseSearchMainFilter_options, "f").defaults.nightTo.toString();
                delete rqData.type;
                delete rqData.fare;
                delete rqData.region;
                delete rqData.port;
                delete rqData.ship;
                delete rqData.cabin;
            }
            rqData.changes = changes;
            yield __classPrivateFieldGet(this, _CruiseSearchMainFilter_instances, "m", _CruiseSearchMainFilter_getSearchFilters).call(this, rqData, eventData);
        });
    }, _CruiseSearchMainFilter_onFilterSearch = function _CruiseSearchMainFilter_onFilterSearch(event) {
        event.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    };
    App.CruiseSearchMainFilter = CruiseSearchMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    class CruiseShipHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(options);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.CruiseShipHotFilterMobile = CruiseShipHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class CruiseShipHotFilter extends App.HotFilter {
        constructor(options) {
            super(options);
            Object.defineProperty(this, "routeHotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.routeHotFilter = $();
                return;
            }
            this.routeHotFilter = this.root;
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('cruise/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.CruiseShipHotFilter = CruiseShipHotFilter;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.ts' />
var App;
(function (App) {
    var _CruiseShipMainFilterMobile_instances, _CruiseShipMainFilterMobile_options, _CruiseShipMainFilterMobile_filters, _CruiseShipMainFilterMobile_popup, _CruiseShipMainFilterMobile_responseValidator, _CruiseShipMainFilterMobile_initShipFilterEvents, _CruiseShipMainFilterMobile_markAvailableCheckinDates, _CruiseShipMainFilterMobile_getShipFilterControls, _CruiseShipMainFilterMobile_getShipFilters, _CruiseShipMainFilterMobile_updateShipFilter, _CruiseShipMainFilterMobile_onShipFilterChange, _CruiseShipMainFilterMobile_onShipFilterSearch;
    class CruiseShipMainFilterMobile extends App.CruiseMainFilterMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-cruise-detail-filter', customFilters: {
                    root: '.js-cruise-detail-filter',
                    clickSelector: '.js-cruise-detail-filters-open',
                    modalKey: 'cruise-detail-filters-modal',
                    contentSelector: '#js-cruise-detail-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать', // TODO: @Localizer.Text("Auto.SearchButton")
                } }, options));
            _CruiseShipMainFilterMobile_instances.add(this);
            _CruiseShipMainFilterMobile_options.set(this, void 0);
            _CruiseShipMainFilterMobile_filters.set(this, void 0);
            _CruiseShipMainFilterMobile_popup.set(this, void 0);
            _CruiseShipMainFilterMobile_responseValidator.set(this, void 0);
            Object.defineProperty(this, "shipFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruiseShipMainFilterMobile_options, options, "f");
            if (!this.root.length) {
                this.shipFilter = $();
                return;
            }
            this.shipFilter = this.root;
            __classPrivateFieldSet(this, _CruiseShipMainFilterMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruiseShipMainFilterMobile_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_initShipFilterEvents).call(this); }))();
        }
        clear() {
        }
    }
    _CruiseShipMainFilterMobile_options = new WeakMap(), _CruiseShipMainFilterMobile_filters = new WeakMap(), _CruiseShipMainFilterMobile_popup = new WeakMap(), _CruiseShipMainFilterMobile_responseValidator = new WeakMap(), _CruiseShipMainFilterMobile_instances = new WeakSet(), _CruiseShipMainFilterMobile_initShipFilterEvents = function _CruiseShipMainFilterMobile_initShipFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseShipMainFilterMobile_filters, __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_getShipFilterControls).call(this, this.shipFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruiseShipMainFilterMobile_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruiseShipMainFilterMobile_filters, "f")[controlName].trackChanges) {
                    __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_filters, "f")[controlName].element.on('change', { sender: controlName, controls: __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_filters, "f") }, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_onShipFilterChange).call(this, event.data);
                    }));
                }
            });
            this.shipFilter.on('submit', e => __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_onShipFilterSearch).call(this, e));
            $('body').on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.shipFilter, __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_filters, "f").price.block); }));
            yield this.changePriceInSlider(this.shipFilter, __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruiseShipMainFilterMobile_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_options, "f").changes.push(name);
            });
        });
    }, _CruiseShipMainFilterMobile_markAvailableCheckinDates = function _CruiseShipMainFilterMobile_markAvailableCheckinDates(dates) {
        App.CruiseMainFilterMobileBase.markDates(__classPrivateFieldGet(this, _CruiseShipMainFilterMobile_filters, "f"), dates);
    }, _CruiseShipMainFilterMobile_getShipFilterControls = function _CruiseShipMainFilterMobile_getShipFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('.js-filter-select-block[data-select="city"] input'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] input'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('[data-select="type"] .js-jelect'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            region: {
                element: container.find('[data-select="region"] .js-jelect'),
                block: this.findControl('region'),
                trackChanges: true,
                multiple: true,
                changeType: 'region',
            },
            port: {
                element: container.find('[data-select="port"] .js-jelect'),
                block: this.findControl('port'),
                trackChanges: true,
                multiple: true,
                changeType: 'port',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] input'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruiseShipMainFilterMobile_getShipFilters = function _CruiseShipMainFilterMobile_getShipFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_options, "f").urls.getShipFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseShipMainFilterMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_updateShipFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseShipMainFilterMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseShipMainFilterMobile_updateShipFilter = function _CruiseShipMainFilterMobile_updateShipFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = [];
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_markAvailableCheckinDates).call(this, dates);
                    break;
                }
                case 'checkin': {
                    const checkin = this.findControl('checkin');
                    if (checkin) {
                        const checkinFrom = App.parseIsoDate(items[key][0].title);
                        const checkinTo = App.parseIsoDate(items[key][1].title);
                        checkin.setValues(checkinFrom, checkinTo);
                    }
                    break;
                }
                default:
                    App.CruiseMainFilterMobileBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruiseShipMainFilterMobile_onShipFilterChange = function _CruiseShipMainFilterMobile_onShipFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const rqData = App.CruiseMainFilterMobileBase.getDataForSearchFilters(eventData);
            rqData.shipId = __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_options, "f").shipId.toString();
            rqData['ship[]'] = __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_options, "f").shipId.toString();
            yield __classPrivateFieldGet(this, _CruiseShipMainFilterMobile_instances, "m", _CruiseShipMainFilterMobile_getShipFilters).call(this, rqData, eventData);
        });
    }, _CruiseShipMainFilterMobile_onShipFilterSearch = function _CruiseShipMainFilterMobile_onShipFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("shipFilter:search" /* Events.ShipFilterSearch */);
    };
    App.CruiseShipMainFilterMobile = CruiseShipMainFilterMobile;
})(App || (App = {}));
/// <reference path='CruiseMainFilterBase.ts' />
var App;
(function (App) {
    var _CruiseShipMainFilter_instances, _CruiseShipMainFilter_options, _CruiseShipMainFilter_filters, _CruiseShipMainFilter_popup, _CruiseShipMainFilter_responseValidator, _CruiseShipMainFilter_initShipFilterEvents, _CruiseShipMainFilter_markAvailableCheckinDates, _CruiseShipMainFilter_getShipFilterControls, _CruiseShipMainFilter_getShipFilters, _CruiseShipMainFilter_updateShipFilter, _CruiseShipMainFilter_onShipFilterChange, _CruiseShipMainFilter_onShipFilterSearch;
    class CruiseShipMainFilter extends App.CruiseMainFilterBase {
        constructor(options) {
            super(Object.assign({}, options));
            _CruiseShipMainFilter_instances.add(this);
            _CruiseShipMainFilter_options.set(this, void 0);
            _CruiseShipMainFilter_filters.set(this, void 0);
            _CruiseShipMainFilter_popup.set(this, void 0);
            _CruiseShipMainFilter_responseValidator.set(this, void 0);
            Object.defineProperty(this, "shipFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _CruiseShipMainFilter_options, options, "f");
            if (!this.root.length) {
                this.shipFilter = $();
                return;
            }
            this.shipFilter = this.root;
            __classPrivateFieldSet(this, _CruiseShipMainFilter_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _CruiseShipMainFilter_responseValidator, new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_initShipFilterEvents).call(this); }))();
        }
        clear() {
        }
    }
    _CruiseShipMainFilter_options = new WeakMap(), _CruiseShipMainFilter_filters = new WeakMap(), _CruiseShipMainFilter_popup = new WeakMap(), _CruiseShipMainFilter_responseValidator = new WeakMap(), _CruiseShipMainFilter_instances = new WeakSet(), _CruiseShipMainFilter_initShipFilterEvents = function _CruiseShipMainFilter_initShipFilterEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseShipMainFilter_filters, __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_getShipFilterControls).call(this, this.shipFilter), "f");
            Object.getOwnPropertyNames(__classPrivateFieldGet(this, _CruiseShipMainFilter_filters, "f")).forEach(controlName => {
                if (__classPrivateFieldGet(this, _CruiseShipMainFilter_filters, "f")[controlName].trackChanges) {
                    __classPrivateFieldGet(this, _CruiseShipMainFilter_filters, "f")[controlName].element.on('change', { sender: controlName, controls: __classPrivateFieldGet(this, _CruiseShipMainFilter_filters, "f") }, (event) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_onShipFilterChange).call(this, event.data);
                    }));
                }
            });
            this.shipFilter.on('submit', e => __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_onShipFilterSearch).call(this, e));
            $('body').on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield this.onCurrencyChange(this.shipFilter, __classPrivateFieldGet(this, _CruiseShipMainFilter_filters, "f").price.block); }));
            yield this.changePriceInSlider(this.shipFilter, __classPrivateFieldGet(this, _CruiseShipMainFilter_filters, "f").price.block);
            __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_markAvailableCheckinDates).call(this, __classPrivateFieldGet(this, _CruiseShipMainFilter_options, "f").checkin);
            // сохраняем изменившийся элемент фильтра
            this.root.on("filter:change" /* Events.FilterChange */, e => {
                let name = $(e.target).closest('.filter-block').find(':input').attr('name');
                if (!name)
                    return;
                name = name.toLowerCase();
                const complexPos = name.indexOf('.');
                if (complexPos >= 0)
                    name = name.substring(0, complexPos);
                if (!__classPrivateFieldGet(this, _CruiseShipMainFilter_options, "f").changes.includes(name))
                    __classPrivateFieldGet(this, _CruiseShipMainFilter_options, "f").changes.push(name);
            });
        });
    }, _CruiseShipMainFilter_markAvailableCheckinDates = function _CruiseShipMainFilter_markAvailableCheckinDates(dates) {
        App.CruiseMainFilterBase.markDates(__classPrivateFieldGet(this, _CruiseShipMainFilter_filters, "f"), dates);
    }, _CruiseShipMainFilter_getShipFilterControls = function _CruiseShipMainFilter_getShipFilterControls(container) {
        return {
            rusGroup: {
                element: container.find('.js-filter-sliding-btn-b[data-name="rusGroup"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'rusGroup',
            },
            seats: {
                element: container.find('.js-filter-sliding-btn-b[data-name="seats"] input'),
                block: undefined,
                trackChanges: true,
                multiple: false,
                changeType: 'seats',
            },
            city: {
                element: container.find('.js-filter-select-block[data-select="city"] input'),
                block: this.findControl('city'),
                trackChanges: true,
                multiple: false,
                changeType: 'city',
            },
            fare: {
                element: container.find('.js-filter-select-block[data-select="fare"] input'),
                block: this.findControl('fare'),
                trackChanges: true,
                multiple: true,
                changeType: 'fare',
            },
            type: {
                element: container.find('[data-select="type"] .js-jelect'),
                block: this.findControl('type'),
                trackChanges: true,
                multiple: true,
                changeType: 'type',
            },
            region: {
                element: container.find('[data-select="region"] .js-jelect'),
                block: this.findControl('region'),
                trackChanges: true,
                multiple: true,
                changeType: 'region',
            },
            port: {
                element: container.find('[data-select="port"] .js-jelect'),
                block: this.findControl('port'),
                trackChanges: true,
                multiple: true,
                changeType: 'port',
            },
            price: {
                element: container.find('.js-filter-slider-block'),
                block: this.findControl('price'),
                trackChanges: false,
                multiple: false,
                changeType: 'price',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                trackChanges: true,
                multiple: false,
                changeType: 'checkin',
            },
            nightFrom: {
                element: container.find('[data-name="filter_nights_from"] .js-jelect'),
                block: this.findControl('NightFrom'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            nightTo: {
                element: container.find('[data-name="filter_nights_to"] .js-jelect'),
                block: this.findControl('NightTo'),
                trackChanges: true,
                multiple: false,
                changeType: 'nights',
            },
            cabin: {
                element: container.find('.js-filter-select-block[data-select="cabin"] input'),
                block: this.findControl('cabin'),
                trackChanges: false,
                multiple: true,
                changeType: 'cabin',
            },
        };
    }, _CruiseShipMainFilter_getShipFilters = function _CruiseShipMainFilter_getShipFilters(rqData, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _CruiseShipMainFilter_options, "f").urls.getShipFilters,
                method: 'POST',
                dataType: 'json',
                data: rqData,
            });
            const popupGroup = __classPrivateFieldGet(this, _CruiseShipMainFilter_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _CruiseShipMainFilter_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_updateShipFilter).call(this, response.data.filters, eventData);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _CruiseShipMainFilter_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _CruiseShipMainFilter_popup, "f").hide(popupGroup);
            }
        });
    }, _CruiseShipMainFilter_updateShipFilter = function _CruiseShipMainFilter_updateShipFilter(items, eventData) {
        Object.getOwnPropertyNames(items).forEach(key => {
            switch (key) {
                case 'dates': {
                    const dates = [];
                    items[key].forEach((element, index) => {
                        dates[index] = element.title;
                    });
                    __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_markAvailableCheckinDates).call(this, dates);
                    break;
                }
                case 'checkin': {
                    const checkin = this.findControl('checkin');
                    if (checkin) {
                        const checkinFrom = App.parseIsoDate(items[key][0].title);
                        const checkinTo = App.parseIsoDate(items[key][1].title);
                        checkin.setValues(checkinFrom, checkinTo);
                    }
                    break;
                }
                default:
                    App.CruiseMainFilterBase.updateOptions(eventData.controls, key, items[key]);
                    break;
            }
        });
    }, _CruiseShipMainFilter_onShipFilterChange = function _CruiseShipMainFilter_onShipFilterChange(eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            const rqData = App.CruiseMainFilterBase.getDataForSearchFilters(eventData);
            rqData.shipId = __classPrivateFieldGet(this, _CruiseShipMainFilter_options, "f").shipId.toString();
            rqData['ship[]'] = __classPrivateFieldGet(this, _CruiseShipMainFilter_options, "f").shipId.toString();
            yield __classPrivateFieldGet(this, _CruiseShipMainFilter_instances, "m", _CruiseShipMainFilter_getShipFilters).call(this, rqData, eventData);
        });
    }, _CruiseShipMainFilter_onShipFilterSearch = function _CruiseShipMainFilter_onShipFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("shipFilter:search" /* Events.ShipFilterSearch */);
    };
    App.CruiseShipMainFilter = CruiseShipMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    class CruiseShipResult extends App.Result {
        constructor(options) {
            super(Object.assign({ tableTemplate: App.templates.Cruise.Ship.TableOutput }, options));
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case 'date':
                    return items.sort((a, b) => App.Result.sort(a.dateStart, b.dateStart, a.price, b.price, this.sorting.reverse));
                default:
                    return items.sort((a, b) => App.Result.sort(a.price, b.price, a.dateStart, b.dateStart, this.sorting.reverse));
            }
        }
    }
    App.CruiseShipResult = CruiseShipResult;
})(App || (App = {}));
var App;
(function (App) {
    var _CruiseSvgLoader_instances, _a, _CruiseSvgLoader_options, _CruiseSvgLoader_root, _CruiseSvgLoader_decks, _CruiseSvgLoader_move, _CruiseSvgLoader_panzooms, _CruiseSvgLoader_heightRelations, _CruiseSvgLoader_headerClass, _CruiseSvgLoader_schemaId, _CruiseSvgLoader_deckLinkClass, _CruiseSvgLoader_leftDelimiterId, _CruiseSvgLoader_rightDelimiterId, _CruiseSvgLoader_schemaShipId, _CruiseSvgLoader_deckMiniHolderId, _CruiseSvgLoader_deckMiniId, _CruiseSvgLoader_deckFullId, _CruiseSvgLoader_deckZoomCatch, _CruiseSvgLoader_deckZoomPosition, _CruiseSvgLoader_deckMiniZoomHolderId, _CruiseSvgLoader_spinnerContainerId, _CruiseSvgLoader_spinnerId, _CruiseSvgLoader_errorId, _CruiseSvgLoader_errorDeckSideId, _CruiseSvgLoader_deckSelectedLegend, _CruiseSvgLoader_svgViewBox, _CruiseSvgLoader_globalError, _CruiseSvgLoader_svgViewBoxShip, _CruiseSvgLoader_timeout, _CruiseSvgLoader_isDecksEmpty, _CruiseSvgLoader_loadShipSide, _CruiseSvgLoader_onLoadShipSide, _CruiseSvgLoader_loadSvg, _CruiseSvgLoader_prepareSvg, _CruiseSvgLoader_loadShipDeck, _CruiseSvgLoader_onLoadDeckMini, _CruiseSvgLoader_onLoadDeckFull, _CruiseSvgLoader_colorSelectedDeck, _CruiseSvgLoader_changeHeader, _CruiseSvgLoader_mouseToSvg, _CruiseSvgLoader_svgToMouse, _CruiseSvgLoader_moveTo, _CruiseSvgLoader_showLoading, _CruiseSvgLoader_hideLoading, _CruiseSvgLoader_showUserError, _CruiseSvgLoader_showDeckSideError, _CruiseSvgLoader_onDeckOverlayHover, _CruiseSvgLoader_onDeckOverlayClick, _CruiseSvgLoader_switchDeck;
    class CruiseSvgLoader {
        constructor() {
            _CruiseSvgLoader_instances.add(this);
            _CruiseSvgLoader_options.set(this, void 0);
            _CruiseSvgLoader_root.set(this, void 0);
            _CruiseSvgLoader_decks.set(this, void 0);
            _CruiseSvgLoader_move.set(this, void 0);
            _CruiseSvgLoader_panzooms.set(this, void 0);
            _CruiseSvgLoader_heightRelations.set(this, void 0);
            _CruiseSvgLoader_headerClass.set(this, void 0);
            _CruiseSvgLoader_schemaId.set(this, void 0);
            _CruiseSvgLoader_deckLinkClass.set(this, void 0);
            _CruiseSvgLoader_leftDelimiterId.set(this, void 0);
            _CruiseSvgLoader_rightDelimiterId.set(this, void 0);
            _CruiseSvgLoader_schemaShipId.set(this, void 0);
            _CruiseSvgLoader_deckMiniHolderId.set(this, void 0);
            _CruiseSvgLoader_deckMiniId.set(this, void 0);
            _CruiseSvgLoader_deckFullId.set(this, void 0);
            _CruiseSvgLoader_deckZoomCatch.set(this, void 0);
            _CruiseSvgLoader_deckZoomPosition.set(this, void 0);
            _CruiseSvgLoader_deckMiniZoomHolderId.set(this, void 0);
            _CruiseSvgLoader_spinnerContainerId.set(this, void 0);
            _CruiseSvgLoader_spinnerId.set(this, void 0);
            _CruiseSvgLoader_errorId.set(this, void 0);
            _CruiseSvgLoader_errorDeckSideId.set(this, void 0);
            _CruiseSvgLoader_deckSelectedLegend.set(this, void 0);
            _CruiseSvgLoader_svgViewBox.set(this, void 0);
            _CruiseSvgLoader_globalError.set(this, void 0);
            _CruiseSvgLoader_svgViewBoxShip.set(this, void 0);
            _CruiseSvgLoader_timeout.set(this, void 0);
            __classPrivateFieldSet(this, _CruiseSvgLoader_options, {
                svgNS: 'http://www.w3.org/2000/svg',
                deck: 0,
                shipId: 0,
                shipCode: '',
                width: 800,
                shipSchemaSvg: '',
                root: '',
            }, "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_svgViewBox, [0, 0, 900, 170], "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_svgViewBoxShip, {}, "f");
            /* eslint-disable dot-notation */
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").PO = '70 0 710 170'; // 1
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").MU = '70 0 710 170'; // 2
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").AX = '70 0 800 170'; // 3
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").FA = '25 0 800 170'; // 4
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").OR = '70 0 710 170'; // 5
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").MA = '80 0 710 170'; // 6
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").SP = '25 0 800 170'; // 7
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").DI = '0 0 850 170'; // 8
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").PR = '42 0 800 170'; // 9
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").SX = '70 0 800 170'; // 10
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").LX = '70 0 800 170'; // 11
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").OX = '70 0 800 170'; // 12
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").MR = '0 0 850 170'; // 13
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").SV = '0 0 850 170'; // 14
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").SE = '0 0 850 170'; // 15
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").BE = '0 0 850 170'; // 16
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").GR = '0 0 850 170'; // 17
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").VI = '0 0 850 170'; // 18
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").SH = '0 0 900 170'; // 19
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").EU = '0 0 900 170'; // 20
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").SC = '0 0 900 170'; // 21
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").ER = '0 0 850 170'; // 22
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").EX = '0 0 600 140'; // 24
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").EP = '0 0 600 140'; // 25
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f").EL = '0 0 600 140'; // 26
            /* eslint-enable dot-notation */
            __classPrivateFieldSet(this, _CruiseSvgLoader_move, false, "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_globalError, false, "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_headerClass, 'pac_msc_liner_header', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_schemaId, 'pac_msc_liner_schema', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_leftDelimiterId, 'pac_msc_liner_left_delimiter', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_rightDelimiterId, 'pac_msc_liner_right_delimiter', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_schemaShipId, 'pac_msc_liner_schema_ship', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckMiniHolderId, 'pac_msc_liner_schema_deck_mini_holder', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckMiniId, 'pac_msc_liner_schema_deck_mini', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckFullId, 'pac_msc_liner_schema_deck1', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckZoomCatch, 'pac_msc_liner_deck_zoom_catch', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckZoomPosition, 'pac_msc_liner_deck_zoom_position1', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckMiniZoomHolderId, 'pac_msc_liner_deck_zoom_position_holder', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_spinnerContainerId, 'spinner-container', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_spinnerId, 'deckplan-spinner', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_errorId, 'deckplan-error', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_errorDeckSideId, 'shipDeckSide-error', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckSelectedLegend, 'deckSelectedLegend', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_deckLinkClass, '.cruise__deck-links .js-deck-descr-option', "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_heightRelations, {
                delimiter: 1.6,
                shipSchema: 3.4,
                deckMini: 3.5,
                deckFull: 1.2,
            }, "f");
            __classPrivateFieldSet(this, _CruiseSvgLoader_panzooms, {
                deckMini: null,
                deckFull: null,
                deckFullPanzoom: null,
            }, "f");
        }
        init(params, decks) {
            return __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldSet(this, _CruiseSvgLoader_options, Object.assign(__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f"), params), "f");
                if (__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").root.length === 0)
                    return;
                if (__classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_isDecksEmpty).call(this, decks)) {
                    __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_showDeckSideError).call(this);
                    return;
                }
                __classPrivateFieldSet(this, _CruiseSvgLoader_decks, decks, "f");
                __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck = decks[0].key;
                __classPrivateFieldSet(this, _CruiseSvgLoader_root, $(__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").root), "f");
                if (__classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f")[__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").shipCode]) {
                    __classPrivateFieldSet(this, _CruiseSvgLoader_svgViewBox, __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBoxShip, "f")[__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").shipCode].split(' ').map(key => Number(key)), "f");
                }
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaId, "f")}`, __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f")).css('width', '100%');
                __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width = $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaId, "f")}`).width();
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_leftDelimiterId, "f")}`, __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f")).css('height', `${__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width / __classPrivateFieldGet(this, _CruiseSvgLoader_heightRelations, "f").delimiter}px`);
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_rightDelimiterId, "f")}`, __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f")).css('height', `${__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width / __classPrivateFieldGet(this, _CruiseSvgLoader_heightRelations, "f").delimiter}px`);
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaShipId, "f")}`, __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f")).css('height', `${__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width / __classPrivateFieldGet(this, _CruiseSvgLoader_heightRelations, "f").shipSchema}px`);
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniZoomHolderId, "f")}`, __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f")).css('height', `${__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width / __classPrivateFieldGet(this, _CruiseSvgLoader_heightRelations, "f").deckMini}px`);
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniHolderId, "f")}`, __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f")).css('height', `${__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width / __classPrivateFieldGet(this, _CruiseSvgLoader_heightRelations, "f").deckMini}px`);
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckFullId, "f")}`, __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f")).css('height', `${__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width / __classPrivateFieldGet(this, _CruiseSvgLoader_heightRelations, "f").deckFull}px`);
                $('html').on("cruiseSvgLoader:deckChange" /* Events.CruiseSvgLoaderDeckChange */, (e, id) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_switchDeck).call(this, e, id); }));
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckZoomCatch, "f")}`)
                    .on('mousedown', e => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_moveTo).call(this, e))
                    .on('mouseup', e => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_moveTo).call(this, e))
                    .on('mousemove', e => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_moveTo).call(this, e));
                if (__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").shipSchemaSvg.length === 0)
                    yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_loadShipDeck).call(this);
                else
                    yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_loadShipSide).call(this);
                __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f").trigger("cruiseSvgLoader:deckloaded" /* Events.CruiseSvgLoaderDeckLoaded */);
                __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_colorSelectedDeck).call(this);
                __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_changeHeader).call(this);
            });
        }
    }
    _a = CruiseSvgLoader, _CruiseSvgLoader_options = new WeakMap(), _CruiseSvgLoader_root = new WeakMap(), _CruiseSvgLoader_decks = new WeakMap(), _CruiseSvgLoader_move = new WeakMap(), _CruiseSvgLoader_panzooms = new WeakMap(), _CruiseSvgLoader_heightRelations = new WeakMap(), _CruiseSvgLoader_headerClass = new WeakMap(), _CruiseSvgLoader_schemaId = new WeakMap(), _CruiseSvgLoader_deckLinkClass = new WeakMap(), _CruiseSvgLoader_leftDelimiterId = new WeakMap(), _CruiseSvgLoader_rightDelimiterId = new WeakMap(), _CruiseSvgLoader_schemaShipId = new WeakMap(), _CruiseSvgLoader_deckMiniHolderId = new WeakMap(), _CruiseSvgLoader_deckMiniId = new WeakMap(), _CruiseSvgLoader_deckFullId = new WeakMap(), _CruiseSvgLoader_deckZoomCatch = new WeakMap(), _CruiseSvgLoader_deckZoomPosition = new WeakMap(), _CruiseSvgLoader_deckMiniZoomHolderId = new WeakMap(), _CruiseSvgLoader_spinnerContainerId = new WeakMap(), _CruiseSvgLoader_spinnerId = new WeakMap(), _CruiseSvgLoader_errorId = new WeakMap(), _CruiseSvgLoader_errorDeckSideId = new WeakMap(), _CruiseSvgLoader_deckSelectedLegend = new WeakMap(), _CruiseSvgLoader_svgViewBox = new WeakMap(), _CruiseSvgLoader_globalError = new WeakMap(), _CruiseSvgLoader_svgViewBoxShip = new WeakMap(), _CruiseSvgLoader_timeout = new WeakMap(), _CruiseSvgLoader_instances = new WeakSet(), _CruiseSvgLoader_isDecksEmpty = function _CruiseSvgLoader_isDecksEmpty(decks) {
        return decks.length === 0 || (decks.length == 1 && decks[0].key == 0);
    }, _CruiseSvgLoader_loadShipSide = function _CruiseSvgLoader_loadShipSide() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CruiseSvgLoader_timeout, window.setTimeout(() => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_showLoading).call(this), 100), "f");
            yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_loadSvg).call(this, __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").shipSchemaSvg, $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaShipId, "f")}`), () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_onLoadShipSide).call(this); }), 'side', true);
        });
    }, _CruiseSvgLoader_onLoadShipSide = function _CruiseSvgLoader_onLoadShipSide() {
        return __awaiter(this, void 0, void 0, function* () {
            $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaId, "f")}`).show();
            let viewBox = '15 0 938 283';
            const currentViewBox = $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaShipId, "f")}`).find('svg').attr('viewBox');
            if (currentViewBox) {
                viewBox = currentViewBox;
                const currentViewBoxNum = currentViewBox.split(' ');
                if (Number(currentViewBoxNum[2]) >= 1133)
                    viewBox = '15 0 1110 283';
                if (Number(currentViewBoxNum[2]) >= 1190)
                    viewBox = '100 0 1010 283';
            }
            $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaShipId, "f")}`).find('svg').attr('viewBox', viewBox);
            const ship = $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaShipId, "f")}`).find('svg');
            const overlays = ship.find('#overlays').detach();
            ship.append(overlays);
            ship.find('#ship > g').css('opacity', 1);
            ship.find('#ship').css('opacity', 0.3);
            ship.find('#decks').css('opacity', 0);
            ship.find('#overlays > rect').on('click', e => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_onDeckOverlayClick).call(this, e));
            ship.find('#overlays > rect').on('mouseenter', e => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_onDeckOverlayHover).call(this, e, true));
            ship.find('#overlays > rect').on('mouseleave', e => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_onDeckOverlayHover).call(this, e, false));
            yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_loadShipDeck).call(this);
        });
    }, _CruiseSvgLoader_loadSvg = function _CruiseSvgLoader_loadSvg(src_1, target_1, onLoadFunction_1, suffix_1) {
        return __awaiter(this, arguments, void 0, function* (src, target, onLoadFunction, suffix, isFirstLoad = false) {
            const xhr = $.ajax({
                dataType: 'html',
                method: 'GET',
                url: src,
            });
            try {
                let data = yield xhr;
                data = __classPrivateFieldGet(_a, _a, "m", _CruiseSvgLoader_prepareSvg).call(_a, data, suffix);
                const object = target.find('object');
                if (object.length > 0)
                    object.remove();
                target.html(`<div style="width: 100%; height: 100%;">${data}</div>`);
                onLoadFunction();
                __classPrivateFieldSet(this, _CruiseSvgLoader_globalError, false, "f");
            }
            catch (_b) {
                __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom = null;
                if (isFirstLoad)
                    __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_showDeckSideError).call(this);
                else
                    __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_showUserError).call(this, '<div class="info">Схема палубы будет опубликована в ближайшее время.</div>');
            }
        });
    }, _CruiseSvgLoader_prepareSvg = function _CruiseSvgLoader_prepareSvg(svg, suffix) {
        const regex_id = /id\s*=\s*"([^"]+)"/g;
        let resultSvg = svg;
        for (const m of svg.matchAll(regex_id)) {
            resultSvg = resultSvg.replace(m[1], `${m[1]}_${suffix}`);
        }
        return resultSvg;
    }, _CruiseSvgLoader_loadShipDeck = function _CruiseSvgLoader_loadShipDeck() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseSvgLoader_timeout, "f") === 0)
                __classPrivateFieldSet(this, _CruiseSvgLoader_timeout, window.setTimeout(() => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_showLoading).call(this), 100), "f");
            if (__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck <= 0)
                return;
            if (__classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom) {
                __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom.destroy();
                $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckZoomPosition, "f")}`).hide();
            }
            const deck = __classPrivateFieldGet(this, _CruiseSvgLoader_decks, "f").find(value => value.key === __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck);
            if (!deck)
                return;
            if (deck.schemaSvg.length == 0) {
                __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_showDeckSideError).call(this);
                return;
            }
            $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaId, "f")}`).show();
            yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_loadSvg).call(this, deck.schemaSvg, $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniId, "f")}`), () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_onLoadDeckMini).call(this); }), 'deckMini');
            $(`.${__classPrivateFieldGet(this, _CruiseSvgLoader_deckSelectedLegend, "f")}`).html(__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck.toString());
        });
    }, _CruiseSvgLoader_onLoadDeckMini = function _CruiseSvgLoader_onLoadDeckMini() {
        return __awaiter(this, void 0, void 0, function* () {
            let elHeightN = '100';
            const currentViewBox = $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniId, "f")}`).find('svg').attr('viewBox');
            if (currentViewBox)
                [, , , elHeightN] = currentViewBox.split(' ');
            const elHeightStr = $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniId, "f")}`).find('svg').attr('height') || elHeightN;
            const elHeight = parseInt(elHeightStr, 10);
            const ofset = Math.abs(__classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[3] - elHeight) / 2;
            __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[1] = -ofset;
            const height = __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[3];
            $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniId, "f")}`).find('svg').attr('viewBox', __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f").join(' ')).attr('height', height);
            $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniId, "f")}`).find('svg > g#numbers').remove();
            const deck = __classPrivateFieldGet(this, _CruiseSvgLoader_decks, "f").find(value => value.key === __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck);
            if (!deck)
                return;
            yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_loadSvg).call(this, deck.schemaSvg, $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckFullId, "f")}`), () => __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_onLoadDeckFull).call(this), 'deckFull');
        });
    }, _CruiseSvgLoader_onLoadDeckFull = function _CruiseSvgLoader_onLoadDeckFull() {
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckMiniId, "f")}`).find('svg').append($(document.createElementNS('http://www.w3.org/2000/svg', 'rect')).attr({
            'id': __classPrivateFieldGet(this, _CruiseSvgLoader_deckZoomPosition, "f"),
            'stroke': '#FF9B25',
            'stroke-width': 2,
            'fill': 'none',
        }));
        const beforePan = (oldPan, pan) => {
            if (!__classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom)
                return { x: 0, y: 0 };
            const offsetX = __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[0];
            const offsetY = __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[1];
            const height = __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[3];
            const width = __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[2];
            const sizes = __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom.getSizes();
            const x = pan.x / sizes.realZoom;
            const y = pan.y / sizes.realZoom;
            const w = sizes.width / sizes.realZoom;
            const h = sizes.height / sizes.realZoom;
            return {
                x: Math.max(Math.min(x, -offsetX), w - width - offsetX) * sizes.realZoom,
                y: Math.max(Math.min(y, -offsetY), h - height - offsetY) * sizes.realZoom,
            };
        };
        const drawZoomBox = () => {
            if (!__classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom)
                return;
            const pan = __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom.getPan();
            const sizes = __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom.getSizes();
            $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckZoomPosition, "f")}`).attr({
                x: -pan.x / sizes.realZoom,
                y: -pan.y / sizes.realZoom,
                width: sizes.width / sizes.realZoom,
                height: sizes.height / sizes.realZoom,
            });
            $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckZoomPosition, "f")}`).show();
        };
        __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom = svgPanZoom(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckFullId, "f")} svg`, {
            zoomEnabled: true,
            dblClickZoomEnabled: false,
            controlIconsEnabled: true,
            fit: true,
            center: true,
            minZoom: 5,
            maxZoom: 8,
            beforePan,
            onPan: drawZoomBox,
            onZoom: drawZoomBox,
        });
        __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom.zoom(3);
        __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_hideLoading).call(this);
        __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f").trigger("cruiseSvgLoader:loaded" /* Events.CruiseSvgLoaderLoaded */);
    }, _CruiseSvgLoader_colorSelectedDeck = function _CruiseSvgLoader_colorSelectedDeck() {
        const shipSvg = $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaShipId, "f")}`).find('svg');
        shipSvg.find('#overlays_side > rect').each((i, v) => {
            const rect = $(v);
            const deckString = rect.attr('id') || '';
            const deck = Number((deckString.split('_')[0]).substring(7));
            const exDeck = __classPrivateFieldGet(this, _CruiseSvgLoader_decks, "f").find(value => value.key === deck);
            if (exDeck) {
                rect.css('fill-opacity', '0');
                if (deck === __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck) {
                    rect.css('fill', 'rgb(0, 112, 9)');
                    rect.css('fill-opacity', '0.7');
                    rect.css('opacity', '1');
                }
            }
        });
    }, _CruiseSvgLoader_changeHeader = function _CruiseSvgLoader_changeHeader() {
        let header = `№${__classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck}`;
        const deck = __classPrivateFieldGet(this, _CruiseSvgLoader_decks, "f").find(value => value.key === __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck);
        if (deck)
            header += ` - ${deck.name}`;
        $(`.${__classPrivateFieldGet(this, _CruiseSvgLoader_headerClass, "f")}`).html(header);
    }, _CruiseSvgLoader_mouseToSvg = function _CruiseSvgLoader_mouseToSvg(ev, viewport, zoomFactor) {
        return {
            x: (ev.offsetX || 0) / zoomFactor + viewport[0],
            y: ((ev.offsetY || 0) - 25) / zoomFactor + viewport[1],
        };
    }, _CruiseSvgLoader_svgToMouse = function _CruiseSvgLoader_svgToMouse(point, viewport, zoomFactor, offset) {
        return {
            x: offset.x - (point.x - viewport.x) * zoomFactor,
            y: offset.y - (point.y - viewport.y) * zoomFactor,
        };
    }, _CruiseSvgLoader_moveTo = function _CruiseSvgLoader_moveTo(event) {
        if (!__classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom)
            return;
        const offset = {
            x: ($(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_deckFullId, "f")}`).width() || 0) / 2,
            y: ($('#' + __classPrivateFieldGet(this, _CruiseSvgLoader_deckFullId, "f")).height() || 0) / 2,
        };
        const factor = __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").width / __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f")[2];
        const sizes = __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom.getSizes();
        const p = __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_mouseToSvg).call(this, event, __classPrivateFieldGet(this, _CruiseSvgLoader_svgViewBox, "f"), factor);
        const svgPan = __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_svgToMouse).call(this, p, { x: 0, y: 0 }, sizes.realZoom, offset);
        if (event.type === 'mousedown' || (__classPrivateFieldGet(this, _CruiseSvgLoader_move, "f") && event.type === 'mousemove')) {
            __classPrivateFieldGet(this, _CruiseSvgLoader_panzooms, "f").deckFullPanzoom.pan(svgPan);
            __classPrivateFieldSet(this, _CruiseSvgLoader_move, true, "f");
        }
        else if (event.type === 'mouseup') {
            __classPrivateFieldSet(this, _CruiseSvgLoader_move, false, "f");
        }
    }, _CruiseSvgLoader_showLoading = function _CruiseSvgLoader_showLoading() {
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_spinnerContainerId, "f")}`).show();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_spinnerId, "f")}`).show();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_errorId, "f")}`).hide();
    }, _CruiseSvgLoader_hideLoading = function _CruiseSvgLoader_hideLoading() {
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_spinnerContainerId, "f")}`).hide();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_spinnerId, "f")}`).hide();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_errorId, "f")}`).hide();
        clearTimeout(__classPrivateFieldGet(this, _CruiseSvgLoader_timeout, "f"));
        __classPrivateFieldSet(this, _CruiseSvgLoader_timeout, 0, "f");
    }, _CruiseSvgLoader_showUserError = function _CruiseSvgLoader_showUserError(err) {
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_spinnerContainerId, "f")}`).show();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_spinnerId, "f")}`).hide();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_errorId, "f")}`).show();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_errorId, "f")}`).html(err);
    }, _CruiseSvgLoader_showDeckSideError = function _CruiseSvgLoader_showDeckSideError() {
        __classPrivateFieldSet(this, _CruiseSvgLoader_globalError, true, "f");
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_schemaId, "f")}`).hide();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_errorId, "f")}`).hide();
        $(`#${__classPrivateFieldGet(this, _CruiseSvgLoader_errorDeckSideId, "f")}`).show();
    }, _CruiseSvgLoader_onDeckOverlayHover = function _CruiseSvgLoader_onDeckOverlayHover(event, isEnter) {
        const rect = $(event.currentTarget);
        const deckString = rect.attr('id') || '';
        const deck = Number(deckString.substring(7));
        const exDeck = __classPrivateFieldGet(this, _CruiseSvgLoader_decks, "f").find(value => value.key === deck);
        if (exDeck && deck !== __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck) {
            if (isEnter) {
                rect.css('fill', 'rgb(0, 32, 70)');
                rect.css('fill-opacity', '0.6');
            }
            else {
                rect.css('fill-opacity', '0');
            }
        }
    }, _CruiseSvgLoader_onDeckOverlayClick = function _CruiseSvgLoader_onDeckOverlayClick(event) {
        const rect = $(event.currentTarget);
        const deckString = rect.attr('id') || '';
        const deck = Number(deckString.substring(7));
        const exDeck = __classPrivateFieldGet(this, _CruiseSvgLoader_decks, "f").find(value => value.key === deck);
        if (exDeck) {
            __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck = deck;
            $(`${__classPrivateFieldGet(this, _CruiseSvgLoader_deckLinkClass, "f")}[data-deck-number="${deck}"]`).trigger('click');
        }
    }, _CruiseSvgLoader_switchDeck = function _CruiseSvgLoader_switchDeck(event, id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _CruiseSvgLoader_globalError, "f"))
                return;
            // var id = Number($(event.currentTarget).attr('data-deck-number'));
            if (id) {
                __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck = id;
                const exDeck = __classPrivateFieldGet(this, _CruiseSvgLoader_decks, "f").find(value => value.key === __classPrivateFieldGet(this, _CruiseSvgLoader_options, "f").deck);
                if (exDeck && exDeck.schemaSvg.length > 0) {
                    yield __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_loadShipDeck).call(this);
                    __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_colorSelectedDeck).call(this);
                    __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_changeHeader).call(this);
                    __classPrivateFieldGet(this, _CruiseSvgLoader_root, "f").trigger("cruiseSvgLoader:deckloaded" /* Events.CruiseSvgLoaderDeckLoaded */);
                }
                else {
                    __classPrivateFieldGet(this, _CruiseSvgLoader_instances, "m", _CruiseSvgLoader_showUserError).call(this, '<div class="info">Схема палубы будет опубликована в ближайшее время.</div>');
                }
            }
        });
    };
    App.CruiseSvgLoader = CruiseSvgLoader;
})(App || (App = {}));
var App;
(function (App) {
    let CruiseServiceOrder;
    (function (CruiseServiceOrder) {
        CruiseServiceOrder[CruiseServiceOrder["Cruise"] = 1000001] = "Cruise";
        CruiseServiceOrder[CruiseServiceOrder["Hotel"] = 1000002] = "Hotel";
        CruiseServiceOrder[CruiseServiceOrder["Avia"] = 1000003] = "Avia";
        CruiseServiceOrder[CruiseServiceOrder["DynamicAvia"] = 1000004] = "DynamicAvia";
        CruiseServiceOrder[CruiseServiceOrder["Transfer"] = 1000005] = "Transfer";
        CruiseServiceOrder[CruiseServiceOrder["Insurance"] = 1000006] = "Insurance";
        CruiseServiceOrder[CruiseServiceOrder["Excursion"] = 1000007] = "Excursion";
        CruiseServiceOrder[CruiseServiceOrder["Visa"] = 1000008] = "Visa";
        CruiseServiceOrder[CruiseServiceOrder["PortTax"] = 1000009] = "PortTax";
        CruiseServiceOrder[CruiseServiceOrder["ServiceTax"] = 10000010] = "ServiceTax";
        CruiseServiceOrder[CruiseServiceOrder["InsuranceCancellation"] = 1000100] = "InsuranceCancellation";
    })(CruiseServiceOrder = App.CruiseServiceOrder || (App.CruiseServiceOrder = {}));
})(App || (App = {}));
var App;
(function (App) {
    App.Http.prototype.getPwJson = function (input, init) {
        return this.getJson(input, init);
    };
    App.Http.prototype.postPwJson = function (input, init) {
        return this.postJson(input, init);
    };
    App.Http.prototype.putPwJson = function (input, init) {
        return this.putJson(input, init);
    };
    App.Http.prototype.patchPwJson = function (input, init) {
        return this.patchJson(input, init);
    };
    App.Http.prototype.deletePwJson = function (input, init) {
        return this.deleteJson(input, init);
    };
    App.Http.prototype.sendPwJson = function (input, init) {
        return this.sendJson(input, init);
    };
})(App || (App = {}));
Fancybox.getDefaults().l10n = {
    CLOSE: 'Закрыть',
    NEXT: 'Вперед',
    PREV: 'Назад',
    MODAL: 'Вы можете закрыть это диалоговое окно клавишей ESC',
    ERROR: 'Требуемое содержимое не может быть загружено. <br/> Пожалуйста, повторите запрос позднее.',
    IMAGE_ERROR: 'Изображение не найдено',
    ELEMENT_NOT_FOUND: 'HTML-элемент не найден',
    AJAX_NOT_FOUND: 'Ошибка AJAX: страница не найдена',
    AJAX_FORBIDDEN: 'Ошибка AJAX: доступ запрещён',
    IFRAME_ERROR: 'Ошибка загрузки страницы',
    TOGGLE_ZOOM: 'Увеличить',
    TOGGLE_THUMBS: 'Миниатюры',
    TOGGLE_SLIDESHOW: 'Слайдшоу',
    TOGGLE_FULLSCREEN: 'На полный экран',
    DOWNLOAD: 'Загрузить',
};
// Note: прежде чем писать свой helper с нуля, проверьте есть ли уже готовый аналогичный вот здесь https://www.npmjs.com/package/handlebars-helpers
// Note: после добавления/переименования/удаления helpers также необходимо обновить т.н. known-список при предкомпиляции handlebars-шаблонов
// в gulp/config.ts (см. значение в src/hbs_helpers). Автоматизировать этот процесс будет возможно после перевода кода на ES-модули.
((hbs) => {
    const isOptions = (options) => {
        return options != null
            && typeof options === 'object'
            && 'hash' in options
            && typeof options.hash === 'object';
    };
    const isBlock = (options) => {
        return isOptions(options)
            && typeof options.fn === 'function'
            && typeof options.inverse === 'function';
    };
    const value = (val, context, options) => {
        if (isBlock(options))
            return val ? options.fn(context) : options.inverse(context);
        return val;
    };
    /**
     * Block helper that renders the block if an array has the
     * given `value`. Optionally specify an inverse block to render
     * when the array does not have the given value.
     *
     * ```handlebars
     * <!-- array: ['a', 'b', 'c'] -->
     * {{#inArray array "d"}}
     *   foo
     * {{else}}
     *   bar
     * {{/inArray}}
     * <!-- results in: 'bar' -->
     * ```
     */
    hbs.registerHelper('inArray', function inArrayHelper(array, val, options) {
        return value(array.includes(val), this, options);
    });
    /**
     * Returns the item from `array` at index `idx`.
     * https://www.npmjs.com/package/handlebars-helpers#itemat
     *
     * ```handlebars
     * <!-- array: ['a', 'b', 'c'] -->
     * {{itemAt array 1}}
     * <!-- results in: 'b' -->
     * ```
     */
    hbs.registerHelper('itemAt', (array, idx) => {
        if (idx < 0) {
            if (-idx < array.length)
                return array[array.length + idx];
        }
        if (idx < array.length)
            return array[idx];
        return undefined;
    });
    /**
     * Return the sum of `a` plus `b`.
     * https://www.npmjs.com/package/handlebars-helpers#add
     */
    hbs.registerHelper('add', (a, b) => a + b);
    /**
     * Prepends the given `string` with the specified `prefix`.
     * https://www.npmjs.com/package/handlebars-helpers#prepend
     *
     * ```handlebars
     * <!-- given that "val" is "bar" -->
     * {{prepend val "foo-"}}
     * <!-- results in: 'foo-bar' -->
     * ```
     */
    hbs.registerHelper('prepend', (str, prefix) => `${prefix}${str}`);
    /**
     * Append the specified `suffix` to the given string.
     * https://www.npmjs.com/package/handlebars-helpers#append
     *
     * ```handlebars
     * <!-- given that "item.stem" is "foo" -->
     * {{append item.stem ".html"}}
     * <!-- results in: 'foo.html' -->
     * ```
     */
    hbs.registerHelper('append', (str, suffix) => `${str}${suffix}`);
    /**
     * Uppercase all of the characters in the given string. If used as a
     * block helper it will uppercase the entire block. This helper
     * does not support inverse blocks.
     * https://www.npmjs.com/package/handlebars-helpers#uppercase
     *
     * ```handlebars
     * {{uppercase "aBcDeF"}}
     * <!-- results in: 'ABCDEF' -->
     * ```
     */
    hbs.registerHelper('uppercase', function uppercaseHelper(valueOrOptions) {
        if (!valueOrOptions)
            return valueOrOptions;
        if (typeof valueOrOptions === 'string')
            return valueOrOptions.toUpperCase();
        return valueOrOptions.fn(this).toUpperCase();
    });
    // TODO: убрать поддержку не строгого равенства/неравенства или в шаблонах использовать аргумент-операторы '==' и '!=', но здесь в коде их трактовать как строгое равенство и неравенство, а варианты '===' и '!==' - убрать.
    // TODO: заменить ifc-helper на соответствующие helpers из https://github.com/helpers/handlebars-helpers (compare, eq, gt, gte, lt, lte, unlessEq, unlessGt, unlessGteq, unlessLt, unlessLteq, ...).
    /* eslint-disable eqeqeq, @typescript-eslint/no-explicit-any */
    // TODO: заменить на 'compare' (или более специфичную проверку), т.к. он из либы 'handlebars-helpers', и 'ifc' очень легко перепутать с 'if'.
    hbs.registerHelper('ifc', function ifcHelper(v1, operator, v2, options) {
        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            default:
                throw new Error('Unsupported operator passed into "ifc" helper.');
        }
    });
    /* eslint-enable eqeqeq, @typescript-eslint/no-explicit-any */
    /**
     * Render a block when a comparison of the first and third
     * arguments returns true. The second argument is
     * the [arithmetic operator][operators] to use. You may also
     * optionally specify an inverse block to render when falsy.
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    hbs.registerHelper('compare', function compareHelper(a, operator, b, options) {
        if (arguments.length < 4)
            throw new Error('handlebars Helper {{compare}} expects 4 arguments');
        let result;
        switch (operator) {
            case '==':
                result = a == b;
                break;
            case '===':
                result = a === b;
                break;
            case '!=':
                result = a != b;
                break;
            case '!==':
                result = a !== b;
                break;
            case '<':
                result = a < b;
                break;
            case '>':
                result = a > b;
                break;
            case '<=':
                result = a <= b;
                break;
            case '>=':
                result = a >= b;
                break;
            case 'typeof':
                result = typeof a === b;
                break;
            default: {
                throw new Error('helper {{compare}}: invalid operator: `' + operator + '`');
            }
        }
        return value(result, this, options);
    });
    /**
     * Block helper that renders a block if `a` is **equal to** `b`.
     * If an inverse block is specified it will be rendered when falsy.
     */
    hbs.registerHelper('eq', function eqHelper(a, b, options) {
        return value(a === b, this, options);
    });
    /**
     * Block helper that renders a block if `a` is **greater than** `b`.
     * If an inverse block is specified it will be rendered when falsy.
     */
    hbs.registerHelper('gt', function gtHelper(a, b, options) {
        return value(a > b, this, options);
    });
    /**
     * Block helper that renders a block if `a` is **greater than or
     * equal to** `b`.
     * If an inverse block is specified it will be rendered when falsy.
     */
    hbs.registerHelper('gte', function gteHelper(a, b, options) {
        return value(a >= b, this, options);
    });
    /**
     * Block helper that renders a block if `a` is **less than** `b`.
     * If an inverse block is specified it will be rendered when falsy.
     */
    hbs.registerHelper('lt', function ltHelper(a, b, options) {
        return value(a < b, this, options);
    });
    /**
     * Block helper that renders a block if `a` is **less than or
     * equal to** `b`.
     * If an inverse block is specified it will be rendered when falsy.
     */
    hbs.registerHelper('lte', function lteHelper(a, b, options) {
        return value(a <= b, this, options);
    });
    /**
     * Block helper that always renders the inverse block **unless `a` is
     * is equal to `b`**.
     */
    hbs.registerHelper('unlessEq', function unlessEqHelper(a, b, options) {
        return value(a !== b, this, options);
    });
    /**
     * Block helper that always renders the inverse block **unless `a` is
     * is greater than `b`**.
     */
    hbs.registerHelper('unlessGt', function unlessGtHelper(a, b, options) {
        return value(a <= b, this, options);
    });
    /**
     * Block helper that always renders the inverse block **unless `a` is
     * is greater than or equal to `b`**.
     */
    hbs.registerHelper('unlessGte', function unlessGteqHelper(a, b, options) {
        return value(a < b, this, options);
    });
    /**
     * Block helper that always renders the inverse block **unless `a` is
     * is less than `b`**.
     */
    hbs.registerHelper('unlessLt', function unlessLtHelper(a, b, options) {
        return value(a >= b, this, options);
    });
    /**
     * Block helper that always renders the inverse block **unless `a` is
     * is less than or equal to `b`**.
     */
    hbs.registerHelper('unlessLte', function unlessLteqHelper(a, b, options) {
        return value(a > b, this, options);
    });
    /**
     * Helper that renders the block if **both** of the given values
     * are truthy. If an inverse block is specified it will be rendered
     * when falsy. Works as a block helper, inline helper or
     * subexpression.
     *
     * ```handlebars
     * <!-- {great: true, magnificent: true} -->
     * {{#and great magnificent}}A{{else}}B{{/and}}
     * <!-- results in: 'A' -->
     * ```
     */
    hbs.registerHelper('and', function andHelper(...args) {
        const len = args.length - 1;
        const options = args[len];
        let result = true;
        for (let i = 0; i < len; i++) {
            if (!args[i]) {
                result = false;
                break;
            }
        }
        return value(result, this, options);
    });
    /**
     * Block helper that renders a block if **any of** the given values
     * is truthy. If an inverse block is specified it will be rendered
     * when falsy.
     *
     * ```handlebars
     * {{#or a b c}}
     *   If any value is true this will be rendered.
     * {{/or}}
     * ```
     */
    hbs.registerHelper('or', function orHelper(...args) {
        const len = args.length - 1;
        const options = args[len];
        let result = false;
        for (let i = 0; i < len; i++) {
            if (args[i]) {
                result = true;
                break;
            }
        }
        return value(result, this, options);
    });
    // TODO Dragushin: переделать (сделать поддержку со стороны объекта данных) и убрать данный helper.
    let customArray = new Array();
    hbs.registerHelper('notContains', function notContainsHelper(val, options) {
        if (val == null || typeof customArray === 'undefined')
            customArray = [];
        if (val) {
            if (!customArray.includes(val)) {
                customArray.push(val);
                return options.fn(this);
            }
        }
        return options.inverse(this);
    });
    hbs.registerHelper('repeat', function repeatHelper(count, options) {
        let result = '';
        const data = options.data ? Handlebars.createFrame(options.data) : undefined;
        for (let i = 0; i < count; i++) {
            if (data)
                data.index = i;
            result += options.fn(this, { data });
        }
        return result;
    });
    // преобразование числа в строку в русской локали - дробная часть через запятую - для биндинга на сервер.
    hbs.registerHelper('numberToRuString', (val, format) => App.numberToRuString(val, format));
    hbs.registerHelper('formatNumber', (val, format) => App.formatNumber(val, format));
    hbs.registerHelper('formatDate', (val, format) => App.formatDate(val, format));
    hbs.registerHelper('formatTimezoneDate', (val, format) => App.formatTimezoneDate(val, format));
    hbs.registerHelper('i18n', function i18nHelper(path, variablesOrOptions, options) {
        let variables;
        if (isOptions(options) && App.isObject(variablesOrOptions)) {
            variables = Object.assign({}, variablesOrOptions, options.hash);
        }
        else if (isOptions(variablesOrOptions)) {
            variables = Object.assign({}, variablesOrOptions.hash);
        }
        else {
            variables = variablesOrOptions;
        }
        return App.formatMessage(path, variables);
    });
    hbs.registerHelper('pluralRu', (val, format0, format1, format2) => App.pluralRu(val, format0, format1, format2 || format1));
    hbs.registerHelper('left', (val, length) => val.substring(0, length));
    hbs.registerHelper('noindex', function noindexHelper(conditional, options) {
        const result = options.fn(this);
        if (!conditional)
            return result;
        return `<!--googleoff: all--><noindex>${result}</noindex><!--/googleoff: all-->`;
    });
    hbs.registerHelper('notIncludes', function (val, search, options) {
        return (val.indexOf(search) === -1) ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('json', function (context) {
        return JSON.stringify(context);
    });
    // TODO: убрать, заменить на вызов extension-метода i18n.
    /**
     * Форматирование строки.
     * Пример: {{formatString 'He is {name} and {surname}' this name='Vasia' surname='Pupkin'}}
     * Пример: {{formatString 'He is {name} and {surname}' someUser}}
     * Пример: {{> myHelper name=(formatString 'Service.Extras[{_k}].Quantity' this _k=existsObj.quantity) }}
     */
    hbs.registerHelper('formatString', function (strFormat, obj, options) {
        if (typeof (strFormat) === 'undefined' || strFormat === null)
            return '';
        let strOut = strFormat;
        // с объекта
        if (typeof (obj) !== 'undefined' && obj !== null && App.isObject(obj)) {
            Object.keys(obj).forEach(key => {
                const reg = new RegExp('\\{' + key + '\\}', 'gm');
                strOut = strOut.replace(reg, obj[key]);
            });
        }
        // с hash
        if (!isOptions(options))
            return strOut;
        const hobj = options.hash;
        Object.keys(hobj).forEach(key => {
            const reg = new RegExp('\\{' + key + '\\}', 'gm');
            strOut = strOut.replace(reg, (hobj[key]));
        });
        // отдаем
        return strOut;
    });
    /**
     * Генератор GUID.
     * Пример: {{ guid }}
     * Пример: {{ guid 'prefix_' }}
     * Пример: {{> myPartial uid=(guid)}}
     */
    hbs.registerHelper('guid', function (prefix, postfix) {
        return `${prefix !== null && prefix !== void 0 ? prefix : ''}${App.Guid.newGuid()}${postfix !== null && postfix !== void 0 ? postfix : ''}`;
    });
    /**
     * Для передачи объекта в частичные вьюшки.
     * Пример: {{> myPartial user=(object name="steve" age=40)}}
     */
    hbs.registerHelper('object', function ({ hash }) {
        return hash;
    });
})(Handlebars);
((inputmask) => {
    // Note: костыль для обработки псевдо-пустых значений, возвращаемых когда пользователь ничего не ввел в поле и по сути
    // возвращается только сама маска, причем не оригинальная, а с убранными некоторами символами. Например вместо маски
    // "+_(___)___-__-__" возвращается "+___________" и потом (например, в нашем правиле "mask" в jquery.validation) уже невозможно
    // определить введено ли какое-либо значение пользователем или это пустая маска. Однако например даже для тех же наших
    // кастомных масок "date" / "time" в onUnMask-обработчике "из коробки" unmasking выполняется корректно.
    // Note: это измененный метод abstractphone.onUnMask, взятый из inputmask.phone/dist/inputmask.phone/inputmask.phone.extensions.js.
    function onUnMask(maskedValue, unmaskedValue, opts) {
        const unmasked = maskedValue.replace(/[()#-]/g, '');
        if ((opts === null || opts === void 0 ? void 0 : opts.placeholder) && new RegExp(`^\\+${opts.placeholder}*$`).test(unmasked))
            return '';
        return unmasked;
    }
    inputmask.extendAliases({
        name: {
            regex: '^[a-zA-Zа-яА-ЯёЁ -]+$',
            placeholder: '',
        },
        namesimple: {
            regex: '^[a-zA-Zа-яА-ЯёЁ ]+$',
            placeholder: '',
        },
        names: {
            regex: '^[a-zA-Zа-яА-ЯёЁ -]+$',
            placeholder: '',
        },
        pacphone: {
            alias: 'phone',
            // keepStatic не использовать!
            //  keepStatic: false - теряются скобки, например, для + 4916096267359.
            //  keepStatic: true - неудаляемая лидирующая единица "+1"
            onUnMask,
        },
        pacphoneru: {
            alias: 'phoneru',
            onUnMask,
        },
        date: {
            alias: 'datetime',
            inputFormat: 'dd.mm.yyyy',
            placeholder: '_',
            clearIncomplete: true,
        },
        time: {
            alias: 'datetime',
            inputFormat: 'HH:MM',
            placeholder: '_',
            clearIncomplete: true,
        },
        flightnumber: {
            mask: '((9)|(a)){1,2} 9{1,4}',
            placeholder: '_',
            clearIncomplete: true,
        },
        // Note: culture на сервере зафиксирована на "ru", поэтому десятичный разделитель для дробных чисел всегда ожидается ','.
        // TODO: возможно название имеет смысл "выровнять" с названием формата, в данном случае - moneyedit.
        moneyru: {
            alias: 'numeric',
            digits: 2,
            radixPoint: ',',
        },
        login: {
            regex: '^[a-zA-Z0-9]+$',
            placeholder: '',
        },
        password: {
            regex: '^[a-zA-Z0-9]+$',
            placeholder: '',
        },
    });
})(Inputmask);
// Note: код можно убрать после перехода на inputmask v5.0.10-beta.20+.
// see https://github.com/RobinHerbots/Inputmask/issues/2409
// @ts-expect-error флаг для проименения patch к FormData для фикса issue
if (FormData.Inputmask === undefined) {
    class FormDataPatch extends FormData {
        constructor(form, submitter) {
            super(form, submitter);
            if (form) {
                this.forEach((v, k) => {
                    const element = form[k];
                    // Apply masking only if it's not a File and the element has inputmask
                    if (element && element.inputmask !== undefined && !(v instanceof File))
                        this.set(k, element.value);
                });
            }
            return this;
        }
    }
    // @ts-expect-error флаг для проименения patch к FormData для фикса issue
    FormDataPatch.Inputmask = true;
    // eslint-disable-next-line no-global-assign
    FormData = FormDataPatch;
}
(($) => {
    const lastValues = {};
    function getUniqueKey(data) {
        return data.$jelectInput.attr('name') || '';
    }
    function clearFilter() {
        $($.jelect.selectors.options)
            .find('.js-clear-filter-search')
            .trigger('click');
    }
    /**
     * Плагин для jquery.jelect, очищающий поле контекстного поиска после закрытия списка.
     * Активируется ТОЛЬКО для раскрывающихся списков с одиночным выбором.
     *
     * Реализован через костыли, т.к. у jquery.jelect нет события на скрытие списка элементов.
     */
    $.jelect.plugins.clearFilter = {
        change: () => {
            clearFilter();
        },
        clickOutside: () => {
            clearFilter();
        },
    };
    /**
     * Плагин для jquery.jelect, перемещающий выбранные элементы (options) в начало списка.
     * Активируется ТОЛЬКО для раскрывающихся списков с множественным выбором.
     *
     * Реализован через костыли, т.к. у jquery.jelect нет события на скрытие списка элементов.
     */
    $.jelect.plugins.selectFirst = {
        init: (data) => {
            lastValues[getUniqueKey(data)] = data.$jelectInput.valString();
        },
        beforeOpen: (data) => {
            const key = getUniqueKey(data);
            const value = data.$jelectInput.valString();
            if (lastValues[key] === value)
                return;
            lastValues[key] = value;
            const options = $('.js-jelect-option', data.$jelectOptions).not('.js-default-option');
            const activeOptions = options.filter('._active').get();
            sort(activeOptions);
            for (let i1 = 0; i1 < activeOptions.length; i1++) {
                const { parentNode } = activeOptions[i1];
                parentNode === null || parentNode === void 0 ? void 0 : parentNode.appendChild(activeOptions[i1]);
            }
            const inactiveOptions = options.not('._active').get();
            sort(inactiveOptions);
            for (let i2 = 0; i2 < inactiveOptions.length; i2++) {
                const { parentNode } = inactiveOptions[i2];
                parentNode === null || parentNode === void 0 ? void 0 : parentNode.appendChild(inactiveOptions[i2]);
            }
            function sort(items) {
                if (!items.length)
                    return;
                if (items[0].hasAttribute('data-order'))
                    items.sort((v1, v2) => Number(v1.getAttribute('data-order')) - Number(v2.getAttribute('data-order')));
                else
                    items.sort((v1, v2) => v1.innerHTML.toLowerCase().localeCompare(v2.innerHTML.toLowerCase()));
            }
        },
        change: (data) => {
            lastValues[getUniqueKey(data)] = data.$jelectInput.valString();
        },
    };
})(jQuery);
(($) => {
    Object.assign($.valHooks, {
        // Fix: Using .val() on textarea elements strips carriage return characters from the browser-reported value. When this value is sent
        // to the server via XHR however, carriage returns are preserved (or added by browsers which do not include them in the raw value).
        // A workaround for this issue can be achieved using a valHook as follows:
        textarea: {
            get(elem) {
                return elem.value.replace(/\r?\n/g, '\r\n');
            },
        },
    });
    $.fn.extend({
        showByClass() {
            return this.removeClass('_hidden-2');
        },
        hideByClass() {
            return this.addClass('_hidden-2');
        },
        toggleByClass(state) {
            if (typeof state === 'boolean')
                return state ? this.showByClass() : this.hideByClass();
            /* TODO return this.each(function () {
                if (isHiddenWithinTree(this)) {
                    jQuery(this).showByClass();
                } else {
                    jQuery(this).hideByClass();
                }
            });*/
            return this;
        },
        valString() {
            let val = this.val();
            if (Array.isArray(val))
                val = (val.length > 0 ? val[0] : undefined);
            if (typeof val === 'string')
                return val;
            if (typeof val === 'number')
                return `${val}`;
            return '';
        },
        valNumber() {
            let val = this.val();
            if (Array.isArray(val))
                val = (val.length > 0 ? val[0] : undefined);
            if (typeof val === 'number')
                return val;
            if (typeof val === 'string')
                return Number(val);
            return null;
        },
    });
})(jQuery);
(($) => {
    // Манипуляция private-членами библиотеки - опасная затея, и уж тем более не приходится рассчитывать на типизацию таких членов.
    /* eslint-disable */
    $.widget('app.autocomplete', $.ui.autocomplete, {
        categoryItem: 0,
        options: {
            highlightClass: 'ui-state-highlight',
        },
        _create() {
            this._super();
            this.widget().menu('option', 'items', '> :not(.ui-autocomplete-category)');
        },
        _renderMenu(ul, items) {
            let currentCategory = '';
            $.each(items, (index, item) => {
                if (item.typeCode && item.typeName && item.typeCode !== currentCategory) {
                    ul.append(`<li class="ui-autocomplete-category filter-point-category"><div>${item.typeName}</div></li>`);
                    currentCategory = item.typeCode;
                }
                this._renderItemData(ul, item);
            });
        },
        _renderItem(ul, item) {
            const result = $('<li class="js-filter-point-item filter-point-item">').data('item.autocomplete', item).appendTo(ul);
            result.html(`<div>${item.name}</div>`);
            return result;
        },
    });
    /* eslint-enable */
})(jQuery);
(($) => {
    // Note: в оригинальной реализации не дается никаких точек расширения для собственных правил-интервалов.
    const oldNormalizeRules = $.validator.normalizeRules;
    $.validator.normalizeRules = function normalizeRules(rules, element) {
        oldNormalizeRules(rules, element);
        $.each(['daterange', 'timerange'], function callback() {
            if (rules[this] && typeof rules[this] === 'string') {
                const parts = rules[this].replace(/[[\]]/g, '').split(/[\s,]+/);
                rules[this] = [parts[0], parts[1]];
            }
        });
        if ($.validator.autoCreateRanges) {
            if (rules.datemin != null && rules.datemax != null) {
                rules.daterange = [rules.datemin, rules.datemax];
                delete rules.datemin;
                delete rules.datemax;
            }
            if (rules.timemin != null && rules.timemax != null) {
                rules.timerange = [rules.timemin, rules.timemax];
                delete rules.timemin;
                delete rules.timemax;
            }
        }
        return rules;
    };
    // Note: в оригинальной реализации почему-то сделано предположение, что если в названии метода есть слово 'min', 'max' или 'step', то
    // значение в value должно быть числом и поэтому явно конвертируется в тип number.
    const oldNormalizeAttributeRule = $.validator.normalizeAttributeRule;
    $.validator.normalizeAttributeRule = function normalizeAttributeRule(rules, type, method, value) {
        if (/datemin|datemax|daterange|timemin|timemax|timerange/.test(method) && (value || value === 0))
            rules[method] = value;
        else
            oldNormalizeAttributeRule(rules, type, method, value);
    };
    $.validator.addMethod('time', function method(value, element) {
        return this.optional(element) || (typeof value === 'string' && /^([0-1][0-9]|2[0-3]):?[0-5][0-9]$/.test(value));
    });
    // Note: в оригинальном варианте библиотеки данный метод не срабатывает для дат, размещенных в input[type="text"], из-за тупой
    // реализации метода normalizeAttributeRule в jquery.validate.
    $.validator.addMethod('datemin', function dateMin(value, element, params) {
        if (this.optional(element))
            return true;
        if (typeof value !== 'string')
            return false;
        const val = App.parseIsoDate(value);
        const min = App.parseIsoDate(params);
        if (val >= min)
            return true;
        const name = element.name || $(element).attr('name');
        if (name) {
            const messages = { 'datemin': formatMessage($.validator.messages.datemin, formatDate(min)) };
            if (typeof this.settings.messages[name] !== 'string')
                this.settings.messages[name] = Object.assign(Object.assign({}, this.settings.messages[name]), messages);
        }
        return false;
    });
    // Note: в оригинальном варианте библиотеки данный метод не срабатывает для дат, размещенных в input[type="text"], из-за тупой
    // реализации метода normalizeAttributeRule в jquery.validate.
    $.validator.addMethod('datemax', function dateMax(value, element, params) {
        if (this.optional(element))
            return true;
        if (typeof value !== 'string')
            return false;
        const val = App.parseIsoDate(value);
        const max = App.parseIsoDate(params);
        if (val <= max)
            return true;
        const name = element.name || $(element).attr('name');
        if (name) {
            const messages = { 'datemax': formatMessage($.validator.messages.datemax, formatDate(max)) };
            if (typeof this.settings.messages[name] !== 'string')
                this.settings.messages[name] = Object.assign(Object.assign({}, this.settings.messages[name]), messages);
        }
        return false;
    });
    $.validator.addMethod('daterange', function dateRange(value, element, params) {
        if (this.optional(element))
            return true;
        if (typeof value !== 'string')
            return false;
        const val = App.parseIsoDate(value);
        const min = App.parseIsoDate(params[0]);
        const max = App.parseIsoDate(params[1]);
        if (val >= min && val <= max)
            return true;
        const name = element.name || $(element).attr('name');
        if (name) {
            const messages = { 'daterange': formatMessage($.validator.messages.daterange, formatDate(min), formatDate(max)) };
            if (typeof this.settings.messages[name] !== 'string')
                this.settings.messages[name] = Object.assign(Object.assign({}, this.settings.messages[name]), messages);
        }
        return false;
    });
    // Note: в оригинальном варианте библиотеки данный метод не срабатывает для времен, размещенных в input[type="text"], из-за тупой
    // реализации метода normalizeAttributeRule в jquery.validate.
    $.validator.addMethod('timemin', function timeMin(value, element, params) {
        if (this.optional(element))
            return true;
        if (typeof value !== 'string')
            return false;
        const val = App.parseIsoDate(`1901-01-01T${value}`);
        const min = App.parseIsoDate(`1901-01-01T${params}`);
        if (val >= min)
            return true;
        const name = element.name || $(element).attr('name');
        if (name) {
            const messages = { 'timemin': formatMessage($.validator.messages.timemin, formatTime(min)) };
            if (typeof this.settings.messages[name] !== 'string')
                this.settings.messages[name] = Object.assign(Object.assign({}, this.settings.messages[name]), messages);
        }
        return false;
    });
    // Note: в оригинальном варианте библиотеки данный метод не срабатывает для времен, размещенных в input[type="text"], из-за тупой
    // реализации метода normalizeAttributeRule в jquery.validate.
    $.validator.addMethod('timemax', function timeMax(value, element, params) {
        if (this.optional(element))
            return true;
        if (typeof value !== 'string')
            return false;
        const val = App.parseIsoDate(`1901-01-01T${value}`);
        const max = App.parseIsoDate(`1901-01-01T${params}`);
        if (val <= max)
            return true;
        const name = element.name || $(element).attr('name');
        if (name) {
            const messages = { 'timemax': formatMessage($.validator.messages.timemax, formatTime(max)) };
            if (typeof this.settings.messages[name] !== 'string')
                this.settings.messages[name] = Object.assign(Object.assign({}, this.settings.messages[name]), messages);
        }
        return false;
    });
    $.validator.addMethod('timerange', function timeRange(value, element, params) {
        if (this.optional(element))
            return true;
        if (typeof value !== 'string')
            return false;
        const val = App.parseIsoDate(`1901-01-01T${value}`);
        const min = App.parseIsoDate(`1901-01-01T${params[0]}`);
        const max = App.parseIsoDate(`1901-01-01T${params[1]}`);
        if (val >= min && val <= max)
            return true;
        const name = element.name || $(element).attr('name');
        if (name) {
            const messages = { 'timerange': formatMessage($.validator.messages.timerange, formatTime(min), formatTime(max)) };
            if (typeof this.settings.messages[name] !== 'string')
                this.settings.messages[name] = Object.assign(Object.assign({}, this.settings.messages[name]), messages);
        }
        return false;
    });
    // TODO: попробовать реализовать добавление данного правила автоматически (на основе наличия у элемента атрибутов data-inputmask-alias / ...). Например, через добавление в classRuleSettings (напрямую или через вызов addClassRules), attributeRules (попробовать создать validation-метод "data-inputmask-alias") или staticRules.
    $.validator.addMethod('mask', function mask(value, element) {
        return this.optional(element) || $(element).inputmask('isComplete');
    });
    $.validator.addMethod('pacemail', function pacEmail(value, element) {
        const reEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
        return this.optional(element) || (typeof value === 'string' && reEmail.test(value));
    });
    $.validator.addMethod('touristname', function touristName(value, element) {
        return this.optional(element) || (typeof value === 'string' && /^[A-Z]+(?:[ -]?[A-Z]+)*$/.test(value));
    });
    function formatMessage(errorMessage, ...args) {
        if (typeof errorMessage === 'string')
            return errorMessage;
        return errorMessage(...args);
    }
    function formatDate(value) {
        return Intl.DateTimeFormat(App.app.language, { dateStyle: 'short' }).format(value);
    }
    function formatTime(value) {
        return Intl.DateTimeFormat(App.app.language, { timeStyle: 'short' }).format(value);
    }
})(jQuery);
if (!AbortSignal.prototype.throwIfAborted) {
    AbortSignal.prototype.throwIfAborted = function throwIfAborted() {
        if (this.aborted)
            throw App.createAbortError();
    };
}
var App;
(function (App) {
    var _FitOrderBookPage_instances, _FitOrderBookPage_formOrder, _FitOrderBookPage_bookFilter, _FitOrderBookPage_orderId, _FitOrderBookPage_createOrderTemplate, _FitOrderBookPage_cancelOrderTemplate, _FitOrderBookPage_getCities, _FitOrderBookPage_getTours, _FitOrderBookPage_getServiceKeys;
    class FitOrderBookPage extends App.PageBase {
        constructor() {
            super();
            _FitOrderBookPage_instances.add(this);
            _FitOrderBookPage_formOrder.set(this, void 0);
            _FitOrderBookPage_bookFilter.set(this, void 0);
            _FitOrderBookPage_orderId.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FitOrderBookPage_formOrder, $('.js-form-order', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderBookPage_bookFilter, new App.Filter({ root: __classPrivateFieldGet(this, _FitOrderBookPage_formOrder, "f") }), "f");
            __classPrivateFieldSet(this, _FitOrderBookPage_orderId, Number($('#OrderKey', this.root).val()), "f");
            $('.js-fit-create-order-template-mt', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderBookPage_instances, "m", _FitOrderBookPage_createOrderTemplate).call(this); }));
            $('.js-fit-cancel-order-template-mt', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderBookPage_instances, "m", _FitOrderBookPage_cancelOrderTemplate).call(this); }));
            $('[data-select="country"]', this.root).on('change', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderBookPage_instances, "m", _FitOrderBookPage_getCities).call(this); }));
            $('[data-select="tour"]', this.root).on('change', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderBookPage_instances, "m", _FitOrderBookPage_getServiceKeys).call(this); }));
        }
    }
    _FitOrderBookPage_formOrder = new WeakMap(), _FitOrderBookPage_bookFilter = new WeakMap(), _FitOrderBookPage_orderId = new WeakMap(), _FitOrderBookPage_instances = new WeakSet(), _FitOrderBookPage_createOrderTemplate = function _FitOrderBookPage_createOrderTemplate() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = $('.js-form-order', $('.js-fit-order-book-page')).serializeArray();
            yield App.app.http.postPwJson('/fit/makemasterorder/', { body: App.createUrlSearchParams(data) });
            window.open(`/fit/${__classPrivateFieldGet(this, _FitOrderBookPage_orderId, "f")}`, '_self');
        });
    }, _FitOrderBookPage_cancelOrderTemplate = function _FitOrderBookPage_cancelOrderTemplate() {
        return __awaiter(this, void 0, void 0, function* () {
            window.open(`/fit/${__classPrivateFieldGet(this, _FitOrderBookPage_orderId, "f")}`, '_self');
        });
    }, _FitOrderBookPage_getCities = function _FitOrderBookPage_getCities() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = $('.js-form-order', $('.js-fit-order-book-page')).serializeArray();
            const response = yield App.app.http.postPwJson('/fit/getcities/', { body: App.createUrlSearchParams(data) });
            const city = __classPrivateFieldGet(this, _FitOrderBookPage_bookFilter, "f").findControl('city');
            if (city)
                city.replaceOptions(response.data, true);
            yield __classPrivateFieldGet(this, _FitOrderBookPage_instances, "m", _FitOrderBookPage_getTours).call(this);
        });
    }, _FitOrderBookPage_getTours = function _FitOrderBookPage_getTours() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = $('.js-form-order', $('.js-fit-order-book-page')).serializeArray();
            const response = yield App.app.http.postPwJson('/fit/gettours/', { body: App.createUrlSearchParams(data) });
            const tour = __classPrivateFieldGet(this, _FitOrderBookPage_bookFilter, "f").findControl('tour');
            if (tour)
                tour.replaceOptions(response.data, true);
        });
    }, _FitOrderBookPage_getServiceKeys = function _FitOrderBookPage_getServiceKeys() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = $('.js-form-order', $('.js-fit-order-book-page')).serializeArray();
            const response = yield App.app.http.postPwJson('/fit/getservicekeys/', { body: App.createUrlSearchParams(data) });
            const serviceKeys = __classPrivateFieldGet(this, _FitOrderBookPage_bookFilter, "f").findControl('servicekeys');
            if (serviceKeys)
                serviceKeys.replaceOptions(response.data, true);
        });
    };
    App.FitOrderBookPage = FitOrderBookPage;
})(App || (App = {}));
var App;
(function (App) {
    var _FitOrderDetailPage_instances, _FitOrderDetailPage_orderId, _FitOrderDetailPage_stateId, _FitOrderDetailPage_popup, _FitOrderDetailPage_readMessage, _FitOrderDetailPage_sendMessage, _FitOrderDetailPage_uploadFiles, _FitOrderDetailPage_sendCalculation, _FitOrderDetailPage_sendCalculationByEmail, _FitOrderDetailPage_finalization, _FitOrderDetailPage_book, _FitOrderDetailPage_workStopped, _FitOrderDetailPage_allowAgentBookerModal, _FitOrderDetailPage_assignLeadManager, _FitOrderDetailPage_addOrderEvent, _FitOrderDetailPage_createOrderTemplate, _FitOrderDetailPage_correspondenceMessage, _FitOrderDetailPage_setByMail;
    class FitOrderDetailPage extends App.PageBase {
        constructor() {
            super();
            _FitOrderDetailPage_instances.add(this);
            _FitOrderDetailPage_orderId.set(this, void 0);
            _FitOrderDetailPage_stateId.set(this, void 0);
            _FitOrderDetailPage_popup.set(this, void 0);
            $('.js-read-message', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_readMessage).call(this); }));
            $('.js-send-message', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_sendMessage).call(this); }));
            $('.js-upload-files', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_uploadFiles).call(this); }));
            $('.js-fit-send-calculation', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_sendCalculation).call(this); }));
            $('.js-fit-send-calculation-by-email', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_sendCalculationByEmail).call(this); }));
            $('.js-fit-finalization', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_finalization).call(this); }));
            $('.js-fit-book', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_book).call(this); }));
            $('.js-fit-work-stopped', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_workStopped).call(this); }));
            $('.js-fit-allow-agent-booker-modal', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_allowAgentBookerModal).call(this); }));
            $('.js-fit-assign-lead-manager', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_assignLeadManager).call(this); }));
            $('.js-fit-add-order-event', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_addOrderEvent).call(this); }));
            $('.js-fit-create-order-template-mt', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_createOrderTemplate).call(this); }));
            $('.js-fit-correspondence-message').on('paste', e => __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_correspondenceMessage).call(this, e));
            $('.js-fit-accept-by-mail', this.root).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderDetailPage_instances, "m", _FitOrderDetailPage_setByMail).call(this); }));
            __classPrivateFieldSet(this, _FitOrderDetailPage_orderId, Number($('.js-order-id', this.root).val()), "f");
            __classPrivateFieldSet(this, _FitOrderDetailPage_stateId, Number($('.js-order-state-id', this.root).val()), "f");
            __classPrivateFieldSet(this, _FitOrderDetailPage_popup, new App.Popup(), "f");
        }
    }
    _FitOrderDetailPage_orderId = new WeakMap(), _FitOrderDetailPage_stateId = new WeakMap(), _FitOrderDetailPage_popup = new WeakMap(), _FitOrderDetailPage_instances = new WeakSet(), _FitOrderDetailPage_readMessage = function _FitOrderDetailPage_readMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: '/fit/readmessage/',
                type: 'POST',
                data: { id: __classPrivateFieldGet(this, _FitOrderDetailPage_orderId, "f") },
                async: true,
            });
            try {
                yield xhr;
                return;
            }
            catch (ex) { /* empty */ }
        });
    }, _FitOrderDetailPage_sendMessage = function _FitOrderDetailPage_sendMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            const message = $('.js-message-content', this.root).val();
            const xhr = $.ajax({
                url: '/fit/sendmessage/',
                type: 'POST',
                data: { id: __classPrivateFieldGet(this, _FitOrderDetailPage_orderId, "f"), message: message },
                async: true,
            });
            try {
                yield xhr;
                return;
            }
            catch (ex) { /* empty */ }
        });
    }, _FitOrderDetailPage_uploadFiles = function _FitOrderDetailPage_uploadFiles() {
        return __awaiter(this, void 0, void 0, function* () {
            const files = $('.js-form-files', this.root)[0].files;
            const formData = new FormData();
            $.each(files, (key, input) => formData.append('files', input));
            formData.append('id', __classPrivateFieldGet(this, _FitOrderDetailPage_orderId, "f").toString());
            const xhr = $.ajax({
                url: '/fit/uploadfiles/',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                async: true,
            });
            try {
                yield xhr;
                return;
            }
            catch (ex) { /* empty */ }
        });
    }, _FitOrderDetailPage_sendCalculation = function _FitOrderDetailPage_sendCalculation() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Расчёт отправлен');
        });
    }, _FitOrderDetailPage_sendCalculationByEmail = function _FitOrderDetailPage_sendCalculationByEmail() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Расчёт отправлен по e-mail');
        });
    }, _FitOrderDetailPage_finalization = function _FitOrderDetailPage_finalization() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Доработка');
        });
    }, _FitOrderDetailPage_book = function _FitOrderDetailPage_book() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Забронировать');
        });
    }, _FitOrderDetailPage_workStopped = function _FitOrderDetailPage_workStopped() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Работа прекращена');
        });
    }, _FitOrderDetailPage_allowAgentBookerModal = function _FitOrderDetailPage_allowAgentBookerModal() {
        return __awaiter(this, void 0, void 0, function* () {
            const popupGroup = __classPrivateFieldGet(this, _FitOrderDetailPage_popup, "f").show({
                group: 'main',
                content: App.templates.Fit.Backoffice.Popups.Booker({}),
                modal: true,
            });
            $('.js-save-reason', __classPrivateFieldGet(this, _FitOrderDetailPage_popup, "f").root).on('click', () => __awaiter(this, void 0, void 0, function* () {
                const reasonText = $('.js-reason-text', __classPrivateFieldGet(this, _FitOrderDetailPage_popup, "f").root).val();
                const xhr = $.ajax({
                    url: '/fit/allowagentbookerdialog/',
                    type: 'POST',
                    data: { id: __classPrivateFieldGet(this, _FitOrderDetailPage_orderId, "f"), reasonText: reasonText },
                    async: true,
                });
                try {
                    yield xhr;
                    __classPrivateFieldGet(this, _FitOrderDetailPage_popup, "f").hide(popupGroup);
                    return;
                }
                catch (ex) { /* empty */ }
            }));
            $('.js-popup-close', __classPrivateFieldGet(this, _FitOrderDetailPage_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _FitOrderDetailPage_popup, "f").hide(popupGroup));
        });
    }, _FitOrderDetailPage_assignLeadManager = function _FitOrderDetailPage_assignLeadManager() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Ведущий менеджер назначен');
        });
    }, _FitOrderDetailPage_addOrderEvent = function _FitOrderDetailPage_addOrderEvent() {
        return __awaiter(this, void 0, void 0, function* () {
            const message = $('.js-fit-order-event-message', this.root).val();
            const xhr = $.ajax({
                url: '/fit/addorderevent/',
                type: 'POST',
                data: { id: __classPrivateFieldGet(this, _FitOrderDetailPage_orderId, "f"), message: message, stateId: __classPrivateFieldGet(this, _FitOrderDetailPage_stateId, "f") },
                async: true,
            });
            try {
                yield xhr;
                return;
            }
            catch (ex) { /* empty */ }
        });
    }, _FitOrderDetailPage_createOrderTemplate = function _FitOrderDetailPage_createOrderTemplate() {
        return __awaiter(this, void 0, void 0, function* () {
            window.open(`/fit/book/${__classPrivateFieldGet(this, _FitOrderDetailPage_orderId, "f")}`, '_self');
        });
    }, _FitOrderDetailPage_correspondenceMessage = function _FitOrderDetailPage_correspondenceMessage(event) {
        var _a, _b;
        const items = (_b = (_a = event.originalEvent) === null || _a === void 0 ? void 0 : _a.clipboardData) === null || _b === void 0 ? void 0 : _b.items;
        if (items == null)
            return;
        let imageFound = false;
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') === -1)
                continue;
            const blob = items[i].getAsFile();
            if (blob == null)
                continue;
            const reader = new FileReader();
            reader.onload = function (e) {
                var _a;
                $('.js-preview-image').html(`<img src="${(_a = e.target) === null || _a === void 0 ? void 0 : _a.result}">`);
            };
            reader.readAsDataURL(blob);
            imageFound = true;
            break;
        }
        if (imageFound) {
            event.preventDefault();
        }
    }, _FitOrderDetailPage_setByMail = function _FitOrderDetailPage_setByMail() {
        return __awaiter(this, void 0, void 0, function* () {
            const byMail = $('.js-fit-set-by-mail', this.root).is(':checked');
            const xhr = $.ajax({
                url: '/fit/setbymail/',
                type: 'POST',
                data: { id: __classPrivateFieldGet(this, _FitOrderDetailPage_orderId, "f"), byMail: byMail },
                async: true,
            });
            try {
                yield xhr;
                return;
            }
            catch (ex) { /* empty */ }
        });
    };
    App.FitOrderDetailPage = FitOrderDetailPage;
})(App || (App = {}));
var App;
(function (App) {
    var _FitOrderListPage_instances, _a, _FitOrderListPage_options, _FitOrderListPage_searchExecuting, _FitOrderListPage_currentPosition, _FitOrderListPage_preloader, _FitOrderListPage_filter, _FitOrderListPage_searchXhr, _FitOrderListPage_orderHeader, _FitOrderListPage_outputBlock, _FitOrderListPage_orderBlocks, _FitOrderListPage_foundBlock, _FitOrderListPage_notFoundBlock, _FitOrderListPage_currentPageSize, _FitOrderListPage_currentPageIndex, _FitOrderListPage_sortBy, _FitOrderListPage_sortDir, _FitOrderListPage_showMoreBlock, _FitOrderListPage_showMoreLink, _FitOrderListPage_showMoreCurrent, _FitOrderListPage_showMoreCountSelected, _FitOrderListPage_showMoreCountOption, _FitOrderListPage_showMoreTotal, _FitOrderListPage_totalCount, _FitOrderListPage_showCount, _FitOrderListPage_sortingBlock, _FitOrderListPage_initShowMoreBlock, _FitOrderListPage_resetData, _FitOrderListPage_onSearch, _FitOrderListPage_onSearchBefore, _FitOrderListPage_onSearchDone, _FitOrderListPage_appendData, _FitOrderListPage_onSearchAlways, _FitOrderListPage_onShowMoreOrders, _FitOrderListPage_onShowMoreBefore, _FitOrderListPage_onShowMoreDone, _FitOrderListPage_onShowMoreAlways, _FitOrderListPage_doSearch, _FitOrderListPage_changePageSize, _FitOrderListPage_sortOrders, _FitOrderListPage_onSortingBefore, _FitOrderListPage_onSortingDone, _FitOrderListPage_onSortingAlways, _FitOrderListPage_orderDetails;
    class FitOrderListPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-fit-order-list-page' }, options));
            _FitOrderListPage_instances.add(this);
            _FitOrderListPage_options.set(this, void 0);
            _FitOrderListPage_searchExecuting.set(this, false);
            _FitOrderListPage_currentPosition.set(this, void 0);
            _FitOrderListPage_preloader.set(this, void 0);
            _FitOrderListPage_filter.set(this, void 0);
            _FitOrderListPage_searchXhr.set(this, void 0);
            _FitOrderListPage_orderHeader.set(this, void 0);
            _FitOrderListPage_outputBlock.set(this, void 0);
            _FitOrderListPage_orderBlocks.set(this, void 0);
            _FitOrderListPage_foundBlock.set(this, void 0);
            _FitOrderListPage_notFoundBlock.set(this, void 0);
            _FitOrderListPage_currentPageSize.set(this, void 0);
            _FitOrderListPage_currentPageIndex.set(this, void 0);
            _FitOrderListPage_sortBy.set(this, void 0);
            _FitOrderListPage_sortDir.set(this, void 0);
            _FitOrderListPage_showMoreBlock.set(this, void 0);
            _FitOrderListPage_showMoreLink.set(this, void 0);
            _FitOrderListPage_showMoreCurrent.set(this, void 0);
            _FitOrderListPage_showMoreCountSelected.set(this, void 0);
            _FitOrderListPage_showMoreCountOption.set(this, void 0);
            _FitOrderListPage_showMoreTotal.set(this, void 0);
            _FitOrderListPage_totalCount.set(this, void 0);
            // сколько показано.
            _FitOrderListPage_showCount.set(this, void 0);
            _FitOrderListPage_sortingBlock.set(this, void 0);
            __classPrivateFieldSet(this, _FitOrderListPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FitOrderListPage_orderHeader, $('.js-orders-output-head', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderListPage_foundBlock, $('.js-result-found', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderListPage_notFoundBlock, $('.js-result-not-found', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderListPage_currentPageIndex, __classPrivateFieldGet(this, _FitOrderListPage_options, "f").pageIndex, "f");
            __classPrivateFieldSet(this, _FitOrderListPage_currentPageSize, __classPrivateFieldGet(this, _FitOrderListPage_options, "f").pageSize, "f");
            __classPrivateFieldSet(this, _FitOrderListPage_showCount, __classPrivateFieldGet(this, _FitOrderListPage_currentPageSize, "f"), "f");
            __classPrivateFieldSet(this, _FitOrderListPage_sortBy, __classPrivateFieldGet(this, _FitOrderListPage_options, "f").sortBy, "f");
            __classPrivateFieldSet(this, _FitOrderListPage_sortDir, __classPrivateFieldGet(this, _FitOrderListPage_options, "f").sortDir, "f");
            __classPrivateFieldSet(this, _FitOrderListPage_filter, new App.FitOrderListFilter({
                datesOptions: {
                    keepEmpty: true,
                    // если не ставить минимальную дату, то она ставится текущей датой
                    minDateFromShift: App.FitOrderListFilter.checkinMinDateShift,
                    preserveDatesOffset: false,
                },
            }), "f");
            __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSearch).call(this, e, data); }));
            __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").setPaging(__classPrivateFieldGet(this, _FitOrderListPage_currentPageIndex, "f"), __classPrivateFieldGet(this, _FitOrderListPage_currentPageSize, "f"));
            __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").setSorting(__classPrivateFieldGet(this, _FitOrderListPage_sortBy, "f"), __classPrivateFieldGet(this, _FitOrderListPage_sortDir, "f"));
            __classPrivateFieldSet(this, _FitOrderListPage_preloader, new App.Preloader(), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _FitOrderListPage_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_initShowMoreBlock).call(this);
            __classPrivateFieldSet(this, _FitOrderListPage_outputBlock, $('.js-orders-output', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderListPage_orderBlocks, $('.js-order', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderListPage_totalCount, $('.js-filter-totalcount', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderListPage_sortingBlock, $('.js-orders-sort-items', this.root), "f");
            $.each($('.js-sort-item', __classPrivateFieldGet(this, _FitOrderListPage_sortingBlock, "f")), (index, item) => {
                $(item).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_sortOrders).call(this, e); }));
            });
            $('.js-order-number', this.root).on('keypress', event => __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_orderDetails).call(this, event));
        }
    }
    _a = FitOrderListPage, _FitOrderListPage_options = new WeakMap(), _FitOrderListPage_searchExecuting = new WeakMap(), _FitOrderListPage_currentPosition = new WeakMap(), _FitOrderListPage_preloader = new WeakMap(), _FitOrderListPage_filter = new WeakMap(), _FitOrderListPage_searchXhr = new WeakMap(), _FitOrderListPage_orderHeader = new WeakMap(), _FitOrderListPage_outputBlock = new WeakMap(), _FitOrderListPage_orderBlocks = new WeakMap(), _FitOrderListPage_foundBlock = new WeakMap(), _FitOrderListPage_notFoundBlock = new WeakMap(), _FitOrderListPage_currentPageSize = new WeakMap(), _FitOrderListPage_currentPageIndex = new WeakMap(), _FitOrderListPage_sortBy = new WeakMap(), _FitOrderListPage_sortDir = new WeakMap(), _FitOrderListPage_showMoreBlock = new WeakMap(), _FitOrderListPage_showMoreLink = new WeakMap(), _FitOrderListPage_showMoreCurrent = new WeakMap(), _FitOrderListPage_showMoreCountSelected = new WeakMap(), _FitOrderListPage_showMoreCountOption = new WeakMap(), _FitOrderListPage_showMoreTotal = new WeakMap(), _FitOrderListPage_totalCount = new WeakMap(), _FitOrderListPage_showCount = new WeakMap(), _FitOrderListPage_sortingBlock = new WeakMap(), _FitOrderListPage_instances = new WeakSet(), _FitOrderListPage_initShowMoreBlock = function _FitOrderListPage_initShowMoreBlock() {
        __classPrivateFieldSet(this, _FitOrderListPage_showMoreBlock, $('.js-show-more-block', this.root), "f");
        __classPrivateFieldSet(this, _FitOrderListPage_showMoreLink, $('.js-show-more-link', __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _FitOrderListPage_showMoreCurrent, $('.js-show-more-current', __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _FitOrderListPage_showMoreCountSelected, $('.js-show-count-selected', __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _FitOrderListPage_showMoreCountOption, $('.js-show-count-option', __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _FitOrderListPage_showMoreTotal, $('.js-show-more-total', __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreLink, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onShowMoreOrders).call(this, e); }));
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreCountOption, "f").on('click', __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_changePageSize).bind(this));
        const leftToShow = __classPrivateFieldGet(this, _FitOrderListPage_options, "f").totalCount - __classPrivateFieldGet(this, _FitOrderListPage_showCount, "f");
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreTotal, "f").text(leftToShow);
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f").toggleByClass(leftToShow > 0);
    }, _FitOrderListPage_resetData = function _FitOrderListPage_resetData() {
        __classPrivateFieldSet(this, _FitOrderListPage_currentPageIndex, 0, "f");
        __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").setPaging(__classPrivateFieldGet(this, _FitOrderListPage_currentPageIndex, "f"), __classPrivateFieldGet(this, _FitOrderListPage_currentPageSize, "f"));
    }, _FitOrderListPage_onSearch = function _FitOrderListPage_onSearch(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _FitOrderListPage_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _FitOrderListPage_searchExecuting, true, "f");
            yield __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_doSearch).call(this, data, __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSearchBefore).bind(this), __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSearchDone).bind(this), __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSearchAlways).bind(this));
        });
    }, _FitOrderListPage_onSearchBefore = function _FitOrderListPage_onSearchBefore() {
        __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_resetData).call(this);
        __classPrivateFieldGet(this, _FitOrderListPage_preloader, "f").show();
    }, _FitOrderListPage_onSearchDone = function _FitOrderListPage_onSearchDone(data) {
        if (data)
            __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_appendData).call(this, data.output, data.totalCount);
    }, _FitOrderListPage_appendData = function _FitOrderListPage_appendData(data, totalCount, clearBefore = true) {
        if (clearBefore) {
            __classPrivateFieldGet(this, _FitOrderListPage_outputBlock, "f").empty();
            __classPrivateFieldSet(this, _FitOrderListPage_showCount, __classPrivateFieldGet(this, _FitOrderListPage_currentPageSize, "f"), "f");
        }
        else {
            __classPrivateFieldSet(this, _FitOrderListPage_showCount, __classPrivateFieldGet(this, _FitOrderListPage_showCount, "f") + __classPrivateFieldGet(this, _FitOrderListPage_currentPageSize, "f"), "f");
        }
        const found = totalCount > 0;
        __classPrivateFieldGet(this, _FitOrderListPage_orderHeader, "f").toggle(found);
        __classPrivateFieldGet(this, _FitOrderListPage_sortingBlock, "f").toggle(found);
        __classPrivateFieldGet(this, _FitOrderListPage_foundBlock, "f").toggle(found);
        __classPrivateFieldGet(this, _FitOrderListPage_notFoundBlock, "f").toggle(!found);
        const leftToShow = totalCount - __classPrivateFieldGet(this, _FitOrderListPage_showCount, "f");
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f").toggleByClass(leftToShow > 0);
        if (found) {
            __classPrivateFieldGet(this, _FitOrderListPage_outputBlock, "f").append(data);
            __classPrivateFieldGet(this, _FitOrderListPage_totalCount, "f").text(`${totalCount} ${App.pluralRu(totalCount, 'заказ', 'заказа', 'заказов')}`);
            __classPrivateFieldGet(this, _FitOrderListPage_showMoreTotal, "f").text(leftToShow);
            __classPrivateFieldSet(this, _FitOrderListPage_orderBlocks, $('.js-order', __classPrivateFieldGet(this, _FitOrderListPage_outputBlock, "f")), "f");
            __classPrivateFieldGet(this, _FitOrderListPage_orderBlocks, "f").removeClass('_hidden');
            __classPrivateFieldGet(this, _FitOrderListPage_showMoreCurrent, "f").text(Math.min(__classPrivateFieldGet(this, _FitOrderListPage_currentPageSize, "f"), leftToShow));
        }
    }, _FitOrderListPage_onSearchAlways = function _FitOrderListPage_onSearchAlways() {
        __classPrivateFieldGet(this, _FitOrderListPage_preloader, "f").hide();
        __classPrivateFieldSet(this, _FitOrderListPage_searchExecuting, false, "f");
    }, _FitOrderListPage_onShowMoreOrders = function _FitOrderListPage_onShowMoreOrders(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const self = $(event.currentTarget);
            const selfOffset = self.offset();
            __classPrivateFieldSet(this, _FitOrderListPage_currentPosition, selfOffset != null ? selfOffset.top : 0, "f");
            __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f").addClass('_pulsate');
            __classPrivateFieldSet(this, _FitOrderListPage_currentPageIndex, (_b = __classPrivateFieldGet(this, _FitOrderListPage_currentPageIndex, "f"), _b++, _b), "f");
            __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").setPaging(__classPrivateFieldGet(this, _FitOrderListPage_currentPageIndex, "f"), __classPrivateFieldGet(this, _FitOrderListPage_currentPageSize, "f"));
            yield __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_doSearch).call(this, __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").getData(), __classPrivateFieldGet(_a, _a, "m", _FitOrderListPage_onShowMoreBefore), __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onShowMoreDone).bind(this), __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onShowMoreAlways).bind(this));
        });
    }, _FitOrderListPage_onShowMoreBefore = function _FitOrderListPage_onShowMoreBefore() {
    }, _FitOrderListPage_onShowMoreDone = function _FitOrderListPage_onShowMoreDone(data) {
        if (data) {
            __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_appendData).call(this, data.output, data.totalCount, false);
            if (__classPrivateFieldGet(this, _FitOrderListPage_currentPosition, "f"))
                $('html, body').animate({ scrollTop: __classPrivateFieldGet(this, _FitOrderListPage_currentPosition, "f") - 50 }, 'slow');
        }
    }, _FitOrderListPage_onShowMoreAlways = function _FitOrderListPage_onShowMoreAlways() {
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreBlock, "f").removeClass('_pulsate');
    }, _FitOrderListPage_doSearch = function _FitOrderListPage_doSearch(data, beforeCallback, doneCallback, alwaysCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _FitOrderListPage_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _FitOrderListPage_options, "f").urls.search,
                type: 'POST',
                data,
                beforeSend: () => beforeCallback(),
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _FitOrderListPage_searchXhr, "f");
                if (!response)
                    return;
                // TODO: обрабатывать результат 'Вариантов, соответствующих заданным критериям, нет.'
                if (!response.status.success || response.data == null)
                    return;
                if (response.redirect)
                    window.location.href = response.redirect;
                doneCallback(response.data);
            }
            catch (ex) {
                // Запрос не удался
                console.log(ex);
            }
            finally {
                alwaysCallback();
            }
        });
    }, _FitOrderListPage_changePageSize = function _FitOrderListPage_changePageSize(event) {
        const target = $(event.currentTarget);
        __classPrivateFieldSet(this, _FitOrderListPage_currentPageSize, parseInt(target.text(), 10), "f");
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreCountOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreCountSelected, "f").text(target.text());
        __classPrivateFieldGet(this, _FitOrderListPage_showMoreCurrent, "f").text(target.text());
    }, _FitOrderListPage_sortOrders = function _FitOrderListPage_sortOrders(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.currentTarget);
            target.siblings().removeClass('_active');
            target.toggleClass('_sort-up _sort-down');
            target.addClass('_active');
            __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_resetData).call(this);
            __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").setSorting((_b = target.attr('data-code')) !== null && _b !== void 0 ? _b : '', target.hasClass('_sort-up') ? 'Asc' : 'Desc');
            yield __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_doSearch).call(this, __classPrivateFieldGet(this, _FitOrderListPage_filter, "f").getData(), __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSortingBefore).bind(this), __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSortingDone).bind(this), __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSortingAlways).bind(this));
        });
    }, _FitOrderListPage_onSortingBefore = function _FitOrderListPage_onSortingBefore() {
        // сброс параметров нужно делать ДО получения данных getData()
        __classPrivateFieldGet(this, _FitOrderListPage_preloader, "f").show();
    }, _FitOrderListPage_onSortingDone = function _FitOrderListPage_onSortingDone(data) {
        __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSearchDone).call(this, data);
    }, _FitOrderListPage_onSortingAlways = function _FitOrderListPage_onSortingAlways() {
        __classPrivateFieldGet(this, _FitOrderListPage_instances, "m", _FitOrderListPage_onSearchAlways).call(this);
    }, _FitOrderListPage_orderDetails = function _FitOrderListPage_orderDetails(event) {
        var _b, _c;
        if (event.which === 13) {
            event.preventDefault();
            const orderNumber = (_c = (_b = $('.js-order-number', this.root)) === null || _b === void 0 ? void 0 : _b.val()) === null || _c === void 0 ? void 0 : _c.toString();
            if (orderNumber) {
                window.open(orderNumber, '_self');
            }
        }
    };
    App.FitOrderListPage = FitOrderListPage;
})(App || (App = {}));
var App;
(function (App) {
    var _FitOrderNewPage_instances, _FitOrderNewPage_formOrder, _FitOrderNewPage_bookFilter, _FitOrderNewPage_formBook, _FitOrderNewPage_popup, _FitOrderNewPage_popupGroup, _FitOrderNewPage_onBookButtonClick, _FitOrderNewPage_book, _FitOrderNewPage_showHotelStars;
    class FitOrderNewPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-fit-order-new-page' }, options));
            _FitOrderNewPage_instances.add(this);
            _FitOrderNewPage_formOrder.set(this, void 0);
            _FitOrderNewPage_bookFilter.set(this, void 0);
            _FitOrderNewPage_formBook.set(this, void 0);
            _FitOrderNewPage_popup.set(this, void 0);
            _FitOrderNewPage_popupGroup.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _FitOrderNewPage_formOrder, $('.js-form-order', this.root), "f");
            __classPrivateFieldSet(this, _FitOrderNewPage_bookFilter, new App.Filter({ root: __classPrivateFieldGet(this, _FitOrderNewPage_formOrder, "f") }), "f");
            __classPrivateFieldSet(this, _FitOrderNewPage_formBook, new App.Form({ root: __classPrivateFieldGet(this, _FitOrderNewPage_bookFilter, "f").root, disableStepValidation: true }), "f");
            console.log(__classPrivateFieldGet(this, _FitOrderNewPage_formBook, "f"));
            $('.js-form-book', __classPrivateFieldGet(this, _FitOrderNewPage_formOrder, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _FitOrderNewPage_instances, "m", _FitOrderNewPage_onBookButtonClick).call(this, e); }));
            $('.js-hotel-stars', this.root).css('display', 'none');
            $('[name="Service.NeedHotel"]', this.root).on('change', e => __classPrivateFieldGet(this, _FitOrderNewPage_instances, "m", _FitOrderNewPage_showHotelStars).call(this, e));
            __classPrivateFieldSet(this, _FitOrderNewPage_popup, new App.Popup({
                onShow: () => {
                    $('.js-popup-close', __classPrivateFieldGet(this, _FitOrderNewPage_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _FitOrderNewPage_popup, "f").hide());
                },
            }), "f");
        }
    }
    _FitOrderNewPage_formOrder = new WeakMap(), _FitOrderNewPage_bookFilter = new WeakMap(), _FitOrderNewPage_formBook = new WeakMap(), _FitOrderNewPage_popup = new WeakMap(), _FitOrderNewPage_popupGroup = new WeakMap(), _FitOrderNewPage_instances = new WeakSet(), _FitOrderNewPage_onBookButtonClick = function _FitOrderNewPage_onBookButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            yield __classPrivateFieldGet(this, _FitOrderNewPage_instances, "m", _FitOrderNewPage_book).call(this);
        });
    }, _FitOrderNewPage_book = function _FitOrderNewPage_book() {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            const files = $('.js-form-attached-files', this.root)[0].files;
            $.each(files, (_, file) => formData.append('files', file));
            const data = $('.js-form-order', $('.js-fit-order-new-page')).serializeArray();
            $.each(data, (_, item) => formData.append(item.name, item.value));
            const xhr = $.ajax({
                url: '/fit/save/',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                async: true,
            });
            __classPrivateFieldSet(this, _FitOrderNewPage_popupGroup, __classPrivateFieldGet(this, _FitOrderNewPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Cruise.Messages.Booking({}),
                modal: true,
            }), "f");
            try {
                const response = yield xhr;
                console.log(response);
                return;
            }
            finally {
                __classPrivateFieldGet(this, _FitOrderNewPage_popup, "f").hide(__classPrivateFieldGet(this, _FitOrderNewPage_popupGroup, "f"));
            }
        });
    }, _FitOrderNewPage_showHotelStars = function _FitOrderNewPage_showHotelStars(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        const checked = target.attr('value');
        $('.js-hotel-stars', this.root).css('display', checked === 'true' ? 'block' : 'none');
    };
    App.FitOrderNewPage = FitOrderNewPage;
})(App || (App = {}));
var App;
(function (App) {
    var _FitOrderListFilter_calendarFrom, _FitOrderListFilter_calendarTo, _FitOrderListFilter_calendarCreatedFrom, _FitOrderListFilter_calendarCreatedTo, _FitOrderListFilter_currentPageSize, _FitOrderListFilter_currentPageIndex, _FitOrderListFilter_sortBy, _FitOrderListFilter_sortDir;
    class FitOrderListFilter extends App.MainFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-order-list-filter' }, options));
            _FitOrderListFilter_calendarFrom.set(this, void 0);
            _FitOrderListFilter_calendarTo.set(this, void 0);
            _FitOrderListFilter_calendarCreatedFrom.set(this, void 0);
            _FitOrderListFilter_calendarCreatedTo.set(this, void 0);
            _FitOrderListFilter_currentPageSize.set(this, void 0);
            _FitOrderListFilter_currentPageIndex.set(this, void 0);
            _FitOrderListFilter_sortBy.set(this, void 0);
            _FitOrderListFilter_sortDir.set(this, void 0);
            if (!this.root.length)
                return;
            this.initDates();
            this.root.on('submit', this.onSearch.bind(this));
        }
        initDates() {
            // Создаем календарь 'Заезд От'
            __classPrivateFieldSet(this, _FitOrderListFilter_calendarFrom, $('.js-filter-checkin-date-from', this.root), "f");
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarFrom, "f")
                .attr('autocomplete', 'off')
                .inputmask('date');
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarFrom, "f").datepicker({
                constrainInput: true,
                // события нужны для обновления правой границы интервала
                onSelect: (dateText, inst) => {
                    inst.input.trigger('change');
                },
            });
            // Создаем календарь 'Заезд До'
            __classPrivateFieldSet(this, _FitOrderListFilter_calendarTo, $('.js-filter-checkin-date-to', this.root), "f");
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarTo, "f")
                .attr('autocomplete', 'off')
                .inputmask('date');
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarTo, "f").datepicker({
                constrainInput: true,
            });
            const fromDate = __classPrivateFieldGet(this, _FitOrderListFilter_calendarFrom, "f").datepicker('getDate');
            if (fromDate)
                __classPrivateFieldGet(this, _FitOrderListFilter_calendarTo, "f").datepicker('option', 'minDate', fromDate);
            // Создаем календарь 'Создан От'
            __classPrivateFieldSet(this, _FitOrderListFilter_calendarCreatedFrom, $('.js-filter-created-date-from', this.root), "f");
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarCreatedFrom, "f")
                .attr('autocomplete', 'off')
                .inputmask('date');
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarCreatedFrom, "f").datepicker({
                constrainInput: true,
            });
            // Создаем календарь 'Создан До'
            __classPrivateFieldSet(this, _FitOrderListFilter_calendarCreatedTo, $('.js-filter-created-date-to', this.root), "f");
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarCreatedTo, "f")
                .attr('autocomplete', 'off')
                .inputmask('date');
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarCreatedTo, "f").datepicker({
                constrainInput: true,
            });
        }
        reset() {
            // не нужен вызов базового метода reset, т.к. очищаются списки.
            this.resetCalendars();
            $('#OrderKey', this.root).val('');
            $('#IsVip', this.root).prop('checked', false);
            $('#IsNewAgentMessages', this.root).prop('checked', false);
            $('[data-select="countries"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="statuses"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="agentnames"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="bymail"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="agentbookerdialog"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="mices"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="filials"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="partnerbranches"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="partnerdepartments"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="partnerdepartmentbookers"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="partners"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="bookers"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="agencycategories"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="hotelstars"] .js-filter-option', this.root).eq(0).trigger('click');
            $.each($('.js-filter-sliding-btn-b', this.root), (index, item) => {
                if ($(item).find(':hidden').val() === 'true') {
                    $(item).find('.js-sliding-btn').trigger('click');
                }
            });
            this.search();
            // TODO реализовать очистку формы
        }
        resetCalendars() {
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarFrom, "f").datepicker('setDate', null);
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarTo, "f").datepicker('setDate', null);
            const minDate = new Date();
            minDate.setDate(minDate.getDate() + FitOrderListFilter.checkinMinDateShift);
            // сбрасываем минимально возможную дату у правой границы.
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarTo, "f").datepicker('option', 'minDate', minDate);
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarCreatedFrom, "f").datepicker('setDate', null);
            __classPrivateFieldGet(this, _FitOrderListFilter_calendarCreatedTo, "f").datepicker('setDate', null);
        }
        setPaging(index, size) {
            __classPrivateFieldSet(this, _FitOrderListFilter_currentPageIndex, index, "f");
            __classPrivateFieldSet(this, _FitOrderListFilter_currentPageSize, size, "f");
        }
        setSorting(by, direction) {
            __classPrivateFieldSet(this, _FitOrderListFilter_sortBy, by, "f");
            __classPrivateFieldSet(this, _FitOrderListFilter_sortDir, direction, "f");
        }
        // TODO: придумать как обойтись без вызова этого метода в OrderListPage
        getData() {
            this.setFields();
            const elements = this.root.serializeArray();
            const data = {};
            $.each(elements, (i, item) => {
                // skip empty form elements
                if (item.value == null || item.value === '')
                    return true;
                // TODO: детектить тип данных - единичный или множественный и только для множественного делать split.
                data[item.name] = item.value.split(',');
                return undefined;
            });
            return data;
        }
        onSearch(event) {
            event.preventDefault();
            this.search();
        }
        search() {
            __classPrivateFieldSet(this, _FitOrderListFilter_currentPageIndex, 0, "f");
            const data = this.getData();
            // TODO: переделать на событие экземпляра текущего класса.
            this.root.trigger("filter:search" /* Events.FilterSearch */, [data]);
        }
        setFields() {
            $(':hidden[name$="PageSize"]', this.root).val(__classPrivateFieldGet(this, _FitOrderListFilter_currentPageSize, "f"));
            $(':hidden[name$="PageIndex"]', this.root).val(__classPrivateFieldGet(this, _FitOrderListFilter_currentPageIndex, "f"));
            $(':hidden[name$="SortBy"]', this.root).val(__classPrivateFieldGet(this, _FitOrderListFilter_sortBy, "f"));
            $(':hidden[name$="SortDir"]', this.root).val(__classPrivateFieldGet(this, _FitOrderListFilter_sortDir, "f"));
        }
    }
    _FitOrderListFilter_calendarFrom = new WeakMap(), _FitOrderListFilter_calendarTo = new WeakMap(), _FitOrderListFilter_calendarCreatedFrom = new WeakMap(), _FitOrderListFilter_calendarCreatedTo = new WeakMap(), _FitOrderListFilter_currentPageSize = new WeakMap(), _FitOrderListFilter_currentPageIndex = new WeakMap(), _FitOrderListFilter_sortBy = new WeakMap(), _FitOrderListFilter_sortDir = new WeakMap();
    // 5лет - вполне достаточно, чтобы дата окончания тура попала в 3хлетний интервал.
    Object.defineProperty(FitOrderListFilter, "checkinMinDateShift", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: -1825
    });
    App.FitOrderListFilter = FitOrderListFilter;
})(App || (App = {}));
var App;
(function (App) {
    let FitPageUrls;
    (function (FitPageUrls) {
        FitPageUrls.SaveOrderFromBestPrice = '/fit/saveorderfrombestprice/';
    })(FitPageUrls = App.FitPageUrls || (App.FitPageUrls = {}));
})(App || (App = {}));
var App;
(function (App) {
    var _HotelPageMobileBase_instances, _a, _HotelPageMobileBase_container, _HotelPageMobileBase_content, _HotelPageMobileBase_header, _HotelPageMobileBase_mainFilter, _HotelPageMobileBase_messenger, _HotelPageMobileBase_bookingComButton, _HotelPageMobileBase_emptyUrlChecker, _HotelPageMobileBase_requiredUrlChecker, _HotelPageMobileBase_cancellationRuleChecker, _HotelPageMobileBase_chooseNumbersScrollingBlock, _HotelPageMobileBase_reserveHotelButtonSelector, _HotelPageMobileBase_changeApplicationDataCancellationPolicy, _HotelPageMobileBase_changeVariantsCancellationPolicy, _HotelPageMobileBase_onBookingComButtonClick, _HotelPageMobileBase_checkCriticalChanges, _HotelPageMobileBase_makeCancellationRuleDifferenceString, _HotelPageMobileBase_renewVariants, _HotelPageMobileBase_makeLinkForReservedVariants, _HotelPageMobileBase_bindScrollOnBookedClick;
    class HotelPageMobileBase extends App.PageMobileBase {
        get container() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f");
        }
        get content() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_content, "f");
        }
        get header() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_header, "f");
        }
        // Возвращает главный фильтр страницы (который не горячий)
        get mainFilter() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_mainFilter, "f");
        }
        get messenger() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_messenger, "f");
        }
        /**
         * Возвращает кнопку 'Показать на букинге'
         */
        get bookingComButton() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_bookingComButton, "f");
        }
        get emptyUrlChecker() {
            if (!__classPrivateFieldGet(this, _HotelPageMobileBase_emptyUrlChecker, "f"))
                __classPrivateFieldSet(this, _HotelPageMobileBase_emptyUrlChecker, new App.EmptyUrlChecker(new App.HotelUrlParameters()), "f");
            return __classPrivateFieldGet(this, _HotelPageMobileBase_emptyUrlChecker, "f");
        }
        get requiredUrlChecker() {
            if (!__classPrivateFieldGet(this, _HotelPageMobileBase_requiredUrlChecker, "f"))
                __classPrivateFieldSet(this, _HotelPageMobileBase_requiredUrlChecker, new App.RequiredUrlChecker(new App.HotelUrlParameters()), "f");
            return __classPrivateFieldGet(this, _HotelPageMobileBase_requiredUrlChecker, "f");
        }
        get cancellationRuleChecker() {
            if (!__classPrivateFieldGet(this, _HotelPageMobileBase_cancellationRuleChecker, "f"))
                __classPrivateFieldSet(this, _HotelPageMobileBase_cancellationRuleChecker, new App.CancellationRuleChecker(), "f");
            return __classPrivateFieldGet(this, _HotelPageMobileBase_cancellationRuleChecker, "f");
        }
        get chooseNumbersScrollingBlock() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_chooseNumbersScrollingBlock, "f");
        }
        constructor(options) {
            super(Object.assign({ multipleRootOwners: true }, options));
            _HotelPageMobileBase_instances.add(this);
            Object.defineProperty(this, "options", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _HotelPageMobileBase_container.set(this, void 0);
            _HotelPageMobileBase_content.set(this, void 0);
            _HotelPageMobileBase_header.set(this, void 0);
            /**
            * Главный фильтр страницы (присвоить конкретный контейнер в конкретном классе)
            */
            _HotelPageMobileBase_mainFilter.set(this, void 0);
            _HotelPageMobileBase_messenger.set(this, void 0);
            Object.defineProperty(this, "form", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Кнопка 'Показать на букинге'. Инициализировать в производном классе
             */
            _HotelPageMobileBase_bookingComButton.set(this, void 0);
            _HotelPageMobileBase_emptyUrlChecker.set(this, void 0);
            _HotelPageMobileBase_requiredUrlChecker.set(this, void 0);
            _HotelPageMobileBase_cancellationRuleChecker.set(this, void 0);
            _HotelPageMobileBase_chooseNumbersScrollingBlock.set(this, void 0);
            _HotelPageMobileBase_reserveHotelButtonSelector.set(this, void 0);
            Object.defineProperty(this, "isPromoCodeApplied", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            this.options = options;
            if (!this.root.length)
                return;
            // инициализация элементов
            __classPrivateFieldSet(this, _HotelPageMobileBase_container, $(this.options.container), "f");
            __classPrivateFieldSet(this, _HotelPageMobileBase_content, $(this.options.content, __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f")), "f");
            __classPrivateFieldSet(this, _HotelPageMobileBase_header, $('h1.js-header'), "f");
            __classPrivateFieldSet(this, _HotelPageMobileBase_mainFilter, $(this.options.mainFilter, this.root), "f");
            __classPrivateFieldSet(this, _HotelPageMobileBase_bookingComButton, $(this.options.bookingComButtonName, __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f")), "f");
            __classPrivateFieldSet(this, _HotelPageMobileBase_messenger, new App.BlockMessenger(new App.Messages({ root: $('.js-messages', __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f")) })), "f");
            this.initForm();
            // Плавающий блок 'Выберите номера'
            __classPrivateFieldSet(this, _HotelPageMobileBase_chooseNumbersScrollingBlock, $('.js-scrolling-reserve-block', this.root), "f");
            // Кнопка бронирования при добавлении отеля перерисовывается вместе со всем блоком резервирования,
            // поэтому нельзя инициализировать ее здесь. Пишет здесь только название селектора
            __classPrivateFieldSet(this, _HotelPageMobileBase_reserveHotelButtonSelector, '.js-reserve-hotel', "f");
            __classPrivateFieldGet(this, _HotelPageMobileBase_bookingComButton, "f").on('click', e => __classPrivateFieldGet(this, _HotelPageMobileBase_instances, "m", _HotelPageMobileBase_onBookingComButtonClick).call(this, e));
            __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f").on('click', __classPrivateFieldGet(this, _HotelPageMobileBase_reserveHotelButtonSelector, "f"), e => {
                e.preventDefault();
                $(e.currentTarget).trigger("variant:book" /* Events.VariantBook */);
            });
        }
        initForm() {
            this.form = new App.Form({ root: __classPrivateFieldGet(this, _HotelPageMobileBase_mainFilter, "f"), disableStepValidation: true });
        }
        /**
         * Активировать работу страницы.
         */
        start() {
            if (this.options.searchError) {
                this.messenger.hide();
                this.messenger.show({ type: 2 /* MessageType.Error */, text: this.options.searchError });
            }
            return Promise.resolve();
        }
        // TODO: дублирование с экскурсиями
        getSeo(urlParameters, url, formFields) {
            return __awaiter(this, void 0, void 0, function* () {
                let form = formFields !== null && formFields !== void 0 ? formFields : new Array();
                // Если форма типа-пустая, то оставляем в ней только context и передаем таким образом на сервер
                if (this.emptyUrlChecker.isEmpty(urlParameters))
                    form = form.filter(item => item.name === App.HotelFilterFields.Context);
                try {
                    const response = yield $.ajax({
                        url: App.app.url.route(url),
                        method: 'POST',
                        dataType: 'json',
                        data: form,
                    });
                    App.app.seo.update(response.data);
                }
                catch (e) {
                    // TODO: логгировать ошибку, но не выводить
                }
            });
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        renderChangedVariants(changedVariants) {
            /* eslint-disable no-await-in-loop */
            for (let index = 0; index < changedVariants.length; index++) {
                // Для использования этого шаблона, в него надо передать массив HotelVariant
                // Поэтому от исходного массива берем часть, равную только одному элементу
                // TODO: Antonov - использовать DetailTableItem_Mobile позже
                const content = $(App.templates.Hotel.DetailTableItem(changedVariants[index]));
                App.NetPricePresenter.setVisibility(content, App.NetPricePresenter.getVisibility());
                const variantId = changedVariants[index].key;
                __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f").find($(`.js-tours-output-table .js-hotel_item-without-tour[data-id='${variantId}']`))
                    .replaceWith(content);
            }
            /* eslint-enable no-await-in-loop */
        }
        /**
         * Возвращает сериализованный массив полей фильтра
         * Переопределить в конкретном классе, если есть отличия в реализации
         */
        getFilterSerializeArray() {
            return __classPrivateFieldGet(this, _HotelPageMobileBase_mainFilter, "f").find('input').serializeArray();
        }
        /**
         * Показать кнопку 'искать на букинге'
         * если она есть
         */
        showBookingComButton() {
            var _b;
            (_b = __classPrivateFieldGet(this, _HotelPageMobileBase_bookingComButton, "f")) === null || _b === void 0 ? void 0 : _b.show();
        }
        /**
         * Спрятать кнопку 'искать на букинге'
         * если она есть
         */
        hideBookingComButton() {
            var _b;
            (_b = __classPrivateFieldGet(this, _HotelPageMobileBase_bookingComButton, "f")) === null || _b === void 0 ? void 0 : _b.hide();
        }
        validateHotelResponse(response) {
            // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не
            // очень подходят (либо их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут
            // обращаться и к сайту.
            if (!response.status.success && response.data == null) {
                if (response.status.messages)
                    this.messenger.show(response.status.messages);
                return undefined;
            }
            if (response.redirect != null)
                window.location.href = response.redirect;
            return response.data;
        }
        /**
         * Бронирует варианты размещения
         * Возвращает урл бронирования, если все ок и перешли на форму бронирования
         * Или пустую строку, если не ОК
         * Или void чисто для того, что все возвраты здесь происходят из колбэк - функции, а после вызова функции отправки запроса ничего
         * не возвращаем, т.к. он асинхронный
         */
        book(hotelKey) {
            return __awaiter(this, void 0, void 0, function* () {
                let bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (bookedVariants.length <= 0)
                    return;
                const context = App.UrlParameterHelper.urlParse().find(item => item.name === 'context');
                const contextNumber = context ? context.values[0] : '';
                const bookingMode = 'bookingMode';
                if (App.app.url.routeData.action !== 'book') {
                    sessionStorage.setItem(bookingMode, 'continuous');
                }
                else if (sessionStorage.getItem(bookingMode) === 'continuous') {
                    sessionStorage.removeItem(bookingMode);
                    yield this.reservationComplete(bookedVariants, contextNumber);
                    return;
                }
                const oldBookedVariants = [...bookedVariants];
                if (!(yield this.valuate(hotelKey)))
                    return;
                // Проверим, что нет критических изменений: если есть, то покажем сообщение.
                bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                const differences = __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_checkCriticalChanges).call(_a, oldBookedVariants, bookedVariants);
                if (differences && differences.length > 0) {
                    const popupConfirm = new App.Popup({
                        onShow: () => {
                            $('.js-reservation-not-confirm').on('click', () => {
                                this.renderChangedVariants(bookedVariants);
                                this.clearReservation(hotelKey);
                                popupConfirm.hide();
                            });
                            $('.js-reservation-confirm').on('click', () => __awaiter(this, void 0, void 0, function* () {
                                yield this.reservationComplete(bookedVariants, contextNumber);
                                popupConfirm.hide();
                            }));
                        },
                    });
                    const reservationPopupContent = $(App.templates.Hotel.Popups.ReservationConfirm(differences));
                    popupConfirm.show({
                        content: reservationPopupContent,
                        modal: true,
                    });
                }
                else {
                    yield this.reservationComplete(bookedVariants, contextNumber);
                }
            });
        }
        valuate(hotelKey, promoCode) {
            return __awaiter(this, void 0, void 0, function* () {
                const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (bookedVariants.length <= 0)
                    return false;
                const context = App.UrlParameterHelper.urlParse().find(item => item.name === 'context');
                const contextNumber = context ? context.values[0] : '';
                const request = {
                    offers: bookedVariants.map(v => v.key),
                    promoCode,
                };
                const popup = new App.Popup();
                const popupGroup = popup.show({
                    group: 'main',
                    content: App.templates.Messages.Valuating({}),
                    modal: true,
                });
                const responseValidator = new App.ResponseValidator({
                    messenger: new App.PopupMessenger(popup),
                    validator: $(this.mainFilter).validate(),
                });
                this.isPromoCodeApplied = false;
                try {
                    const response = yield $.ajax({
                        url: App.app.url.route(App.HotelPageUrls.Valuate, contextNumber ? { context: contextNumber } : undefined),
                        method: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(request),
                        contentType: 'application/json; charset=utf-8',
                    });
                    if (!responseValidator.process(response))
                        return false;
                    const responseData = response.data;
                    // Проверим доступность для бронирования
                    if (!responseData.available) {
                        this.options.unavailableOfferService.addRange(responseData.unavailableOffers);
                        // TODO: костыль (очередной...)
                        responseData.unavailableOffers.forEach(v => {
                            const searchVariant = this.options.manager.variants.find(x => x.providerItemKey === v);
                            if (searchVariant) {
                                searchVariant.available = false;
                                this.markUnavailableVariants([searchVariant.key]);
                            }
                            const bookedVariant = bookedVariants.find(x => x.providerItemKey === v);
                            if (bookedVariant)
                                bookedVariant.available = false;
                        });
                        // Очистка забронированного
                        bookedVariants.forEach(v => (App.Hotel.toggleVariant(__classPrivateFieldGet(this, _HotelPageMobileBase_container, "f"), v.key, false)));
                        this.clearReservation(hotelKey);
                        popup.show({ content: 'Предложение недоступно для бронирования' });
                        return false;
                    }
                    if (!responseData.basketVariants || responseData.basketVariants.length <= 0)
                        return false;
                    this.isPromoCodeApplied = responseData.basketVariants.some(v => v.promotions.isPromoCodeApplied);
                    // Обновим данные приложения пришедшими после резервирования данными
                    this.options.manager.offers.forEach(offer => {
                        __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_renewVariants).call(_a, offer.variants, responseData.basketVariants);
                    });
                    __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_renewVariants).call(_a, this.options.manager.variants, responseData.basketVariants);
                    __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_renewVariants).call(_a, bookedVariants, responseData.basketVariants);
                }
                catch (ex) {
                    if (!responseValidator.processError(ex))
                        throw ex;
                    return false;
                }
                finally {
                    popup.hide(popupGroup);
                }
                return true;
            });
        }
        /**
         * Завершает резервирование вариантов размещения показом формы бронирования
         * @param basketVariants - забронированные варианты
         * @param contextNumber - номер заказа
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        reservationComplete(basketVariants, contextNumber) {
            return Promise.resolve();
        }
        /**
         * Очищает зарезервированное:
         * варианты и блок с кнопкой 'Забронировать'
         */
        clearReservation(hotelKey) {
            const variants = this.options.manager.getBookedVariants(hotelKey);
            App.emptyArray(variants);
            this.renderReserveBlock(__classPrivateFieldGet(this, _HotelPageMobileBase_container, "f"), {
                variants,
                totalPrice: 0,
                currencyCode: '',
                link: '',
            });
        }
        /**
         ** Получает правила отмены для каждого варианта размещения
         */
        getCancellationRule(event, hotelKey) {
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                const targetElement = $(event.target);
                const cancellationVariant = yield this.cancellationRuleChecker.getCancellationRule($(event.target), this.messenger);
                if (!cancellationVariant)
                    return;
                __classPrivateFieldGet(this, _HotelPageMobileBase_instances, "m", _HotelPageMobileBase_changeApplicationDataCancellationPolicy).call(this, [cancellationVariant]);
                if (!cancellationVariant.available) {
                    this.options.unavailableOfferService.add(cancellationVariant.key);
                    this.markUnavailableVariants([cancellationVariant.key]);
                    const block = targetElement.parents('.js-output-block');
                    const variantKey = (_b = targetElement.attr('data-variant-key')) !== null && _b !== void 0 ? _b : '';
                    const variant = this.options.manager.variants.find(item => item.key === variantKey);
                    if (variant && App.Hotel.isSelectedVariant(block, variantKey)) {
                        const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                        App.removeAllElements(bookedVariants, v => v.key === variant.key);
                        variant.selected = false;
                        App.Hotel.toggleVariant(block, variantKey, false);
                        yield this.renderReservedHotelVariants(block, hotelKey, bookedVariants);
                    }
                }
                App.CancellationRuleChecker.renderChangedCancellationPolicy(cancellationVariant, targetElement, false);
            });
        }
        markUnavailableVariants(keys) {
            for (let i = 0; i < keys.length; i++) {
                $(`.js-hotel_item-without-tour[data-id='${keys[i]}']`, __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f"))
                    .addClass('hotel-variant-unavailable');
            }
        }
        /**
         * показывает блок 'Выберите номера'
         */
        showChooseNumbersBlock() {
            __classPrivateFieldGet(this, _HotelPageMobileBase_chooseNumbersScrollingBlock, "f").showByClass();
        }
        /**
         * скрывает блок 'Выберите номера'
         */
        hideChooseNumbersBlock() {
            __classPrivateFieldGet(this, _HotelPageMobileBase_chooseNumbersScrollingBlock, "f").hideByClass();
        }
        getBookingLink(container) {
            var _b;
            return (_b = $(__classPrivateFieldGet(this, _HotelPageMobileBase_reserveHotelButtonSelector, "f"), container !== null && container !== void 0 ? container : __classPrivateFieldGet(this, _HotelPageMobileBase_container, "f")).attr('href')) !== null && _b !== void 0 ? _b : '';
        }
        reserveVariant(target, hotelKey) {
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                const block = target.parents('.js-output-block');
                const variantKey = (_b = target.attr('data-id')) !== null && _b !== void 0 ? _b : '';
                // По ключу найти в имеющихся вариантах
                const currentVariant = this.options.manager.variants.find(item => item.key === variantKey);
                if (!currentVariant || !currentVariant.available)
                    return;
                // Проверить, добавлять отмеченный вариант или удалять (уже выбран - удалять, еще не выбран - добавлять)
                const isAdd = !App.Hotel.isSelectedVariant(block, variantKey);
                // Добавляем или удаляем элемент в зависимости от признака
                const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (isAdd) {
                    // Проверить, что количество к бронированию не превышает max допустимого количества
                    const roomCount = Enumerable.from(bookedVariants).sum(s => s.quantity);
                    // Для правильной обработки случаев, когда в варианте quantity > 1 проверяем уже зарезервированные + те,
                    // что собираемся добавить(2 + 2 + 2 > 5, но 2 + 2 < 5 и позволит добавить еще 2, что не верно)
                    if (roomCount + currentVariant.quantity > this.options.maxHotelsToBook) {
                        const popup = new App.Popup();
                        const bookingLimitationContent = $(App.templates.Hotel.Popups.BookingLimitationPopup(this.options.maxHotelsToBook));
                        popup.show({ content: bookingLimitationContent });
                        return;
                    }
                    bookedVariants.push(currentVariant);
                }
                else {
                    App.removeAllElements(bookedVariants, v => v.key === currentVariant.key);
                }
                // Поставить или снять галку с чекбокса
                currentVariant.selected = isAdd;
                App.Hotel.toggleVariant(block, variantKey, isAdd);
                yield this.renderReservedHotelVariants(block, hotelKey, bookedVariants);
            });
        }
        renderReservedHotelVariants(block, hotelKey, variants) {
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                let totalPrice = 0;
                let currencyCode = '';
                if (variants && variants.length > 0) {
                    currencyCode = variants[0].currencyCode;
                    for (let i = 0; i < variants.length; i++)
                        totalPrice += (_b = yield App.CurrencyManager.exchange(variants[i].totalGrossPrice, variants[i].currencyCode, currencyCode)) !== null && _b !== void 0 ? _b : 0;
                }
                const reserved = {
                    variants,
                    totalPrice,
                    currencyCode,
                    link: __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_makeLinkForReservedVariants).call(_a, this.getHotelVariantsUrlData(), hotelKey, this.options.manager.getBookedVariants(hotelKey).map(item => item.key)),
                };
                this.renderReserveBlock(block, reserved);
            });
        }
        getHotelVariantsUrlData() {
            return new Array();
        }
        /**
         * Отрисовка блока выбора вариантов
         * @param reserved - Зарезервированные варианты для отрисовки
         */
        renderReserveBlock(container, reserved) {
            const content = $(App.templates.Hotel.ReservedHotels(reserved));
            $('.js-scrolling-reserve-block', container)
                .empty()
                .append(content)
                .showByClass();
            __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_bindScrollOnBookedClick).call(_a);
        }
        static getPriceTotals(variants) {
            var _b, _c;
            const result = {
                netPrice: 0,
                grossPrice: 0,
                price: 0,
                discount: 0,
                currencyCode: variants[0].currencyCode,
            };
            for (const variant of variants) {
                result.netPrice = App.addSafe(result.netPrice, variant.netPrice);
                result.grossPrice += variant.grossPrice;
                result.price += ((_b = variant.price) !== null && _b !== void 0 ? _b : variant.grossPrice);
                for (const extra of variant.extraGroups) {
                    for (const item of extra.items.filter(v => v.selected)) {
                        result.netPrice = App.addSafe(result.netPrice, item.netPrice);
                        result.grossPrice += item.grossPrice;
                        result.price += ((_c = item.price) !== null && _c !== void 0 ? _c : item.grossPrice);
                    }
                }
            }
            result.discount = result.grossPrice - result.price;
            return result;
        }
    }
    _a = HotelPageMobileBase, _HotelPageMobileBase_container = new WeakMap(), _HotelPageMobileBase_content = new WeakMap(), _HotelPageMobileBase_header = new WeakMap(), _HotelPageMobileBase_mainFilter = new WeakMap(), _HotelPageMobileBase_messenger = new WeakMap(), _HotelPageMobileBase_bookingComButton = new WeakMap(), _HotelPageMobileBase_emptyUrlChecker = new WeakMap(), _HotelPageMobileBase_requiredUrlChecker = new WeakMap(), _HotelPageMobileBase_cancellationRuleChecker = new WeakMap(), _HotelPageMobileBase_chooseNumbersScrollingBlock = new WeakMap(), _HotelPageMobileBase_reserveHotelButtonSelector = new WeakMap(), _HotelPageMobileBase_instances = new WeakSet(), _HotelPageMobileBase_changeApplicationDataCancellationPolicy = function _HotelPageMobileBase_changeApplicationDataCancellationPolicy(responseData) {
        // обновляем данные приложения, делая нужные варианты недоступными
        this.options.manager.offers.forEach(offer => {
            __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_changeVariantsCancellationPolicy).call(_a, offer.variants, responseData);
        });
        __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_changeVariantsCancellationPolicy).call(_a, this.options.manager.variants, responseData);
    }, _HotelPageMobileBase_changeVariantsCancellationPolicy = function _HotelPageMobileBase_changeVariantsCancellationPolicy(variantsToUnavailable, variantFromRequest) {
        variantFromRequest.forEach(fromRequest => {
            const targetVariant = variantsToUnavailable.find(variant => variant.key === fromRequest.key);
            if (targetVariant)
                Object.assign(targetVariant, fromRequest);
        });
    }, _HotelPageMobileBase_onBookingComButtonClick = function _HotelPageMobileBase_onBookingComButtonClick(event) {
        event.preventDefault();
        if (!this.form.validator.form())
            return;
        __classPrivateFieldGet(this, _HotelPageMobileBase_bookingComButton, "f").trigger("bookingComButton:click" /* Events.BookingComButtonClick */);
    }, _HotelPageMobileBase_checkCriticalChanges = function _HotelPageMobileBase_checkCriticalChanges(oldVariants, newVariants) {
        var _b;
        const differences = new Array();
        for (let i = 0; i < oldVariants.length; i++) {
            const oldItem = oldVariants[i];
            const newItem = newVariants.find(item => item.providerItemKey === oldItem.providerItemKey);
            if (!newItem)
                continue;
            // Проверить на совпадение
            // - питание
            if (oldItem.board !== newItem.board) {
                differences.push({
                    name: 'Питание',
                    oldValue: oldItem.board,
                    newValue: newItem.board,
                });
            }
            // - цена и валюта
            const grossPriceDifference = newItem.totalGrossPrice - oldItem.totalGrossPrice;
            if ((grossPriceDifference > 0 || grossPriceDifference < -1) || oldItem.currencyCode !== newItem.currencyCode) {
                differences.push({
                    name: 'Стоимость',
                    oldValue: App.templates.Money({ amount: oldItem.totalGrossPrice, currency: oldItem.currencyCode }),
                    newValue: App.templates.Money({ amount: newItem.totalGrossPrice, currency: newItem.currencyCode }),
                });
            }
            // - правила отмены (правила отмены может не быть, т.к. еще не было проверено => тогда не сравниваем)
            if (oldItem.cancellationInfoList) {
                const oldList = oldItem.cancellationInfoList;
                const newList = (_b = newItem.cancellationInfoList) !== null && _b !== void 0 ? _b : new Array();
                const newLength = newList.length;
                const oldLength = oldList.length;
                // Если длины массивов разные, значит правила отмены отличаются, писать в различия
                if (oldLength !== newLength) {
                    // Найдем. какой массив длинней и его крутим в цикле
                    const iteratedCancellationRules = oldLength > newLength ? oldList : newList;
                    const iteratedCancellationRulesLength = iteratedCancellationRules.length;
                    for (let index = 0; index < iteratedCancellationRulesLength; index++) {
                        // Чтобы не вылезти за пределы массива, сравниваем длинны старого, нового и прокручиваемого массива
                        differences.push({
                            name: 'Правило отмены',
                            oldValue: index < oldLength
                                ? __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_makeCancellationRuleDifferenceString).call(_a, oldList[index], oldItem.currencyCode)
                                : '',
                            newValue: index < newLength
                                ? __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_makeCancellationRuleDifferenceString).call(_a, newList[index], newItem.currencyCode)
                                : '',
                        });
                    }
                }
                else {
                    for (let index = 0; index < oldList.length; index++) {
                        // Проверяем дату и штраф правил отмены
                        if (oldList[index].date !== newList[index].date || oldList[index].price !== newList[index].price) {
                            differences.push({
                                name: 'Правило отмены',
                                oldValue: __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_makeCancellationRuleDifferenceString).call(_a, oldList[index], oldItem.currencyCode),
                                newValue: __classPrivateFieldGet(_a, _a, "m", _HotelPageMobileBase_makeCancellationRuleDifferenceString).call(_a, newList[index], newItem.currencyCode),
                            });
                        }
                    }
                }
            }
        }
        return differences;
    }, _HotelPageMobileBase_makeCancellationRuleDifferenceString = function _HotelPageMobileBase_makeCancellationRuleDifferenceString(cancellationInfo, currencyCode) {
        let result = cancellationInfo.date;
        result += ` ${App.templates.Money({ amount: cancellationInfo.price, currency: currencyCode })}`;
        return result;
    }, _HotelPageMobileBase_renewVariants = function _HotelPageMobileBase_renewVariants(oldVariants, newVariants) {
        for (let i = 0; i < oldVariants.length; i++) {
            const newVariant = newVariants.find(v => v.providerItemKey === oldVariants[i].providerItemKey);
            if (newVariant != null)
                oldVariants[i] = Object.assign({}, oldVariants[i], newVariant);
        }
    }, _HotelPageMobileBase_makeLinkForReservedVariants = function _HotelPageMobileBase_makeLinkForReservedVariants(detailFilterParameters, hotelKey, variantKeуs) {
        // добавим параметр для варианта
        let urlParameters = new Array();
        urlParameters = urlParameters.concat(detailFilterParameters);
        urlParameters.push({ name: 'reserved', values: variantKeуs });
        // сформируем урл для бронирования
        return App.app.url.route(App.HotelPageUrls.Book, hotelKey, urlParameters);
    }, _HotelPageMobileBase_bindScrollOnBookedClick = function _HotelPageMobileBase_bindScrollOnBookedClick() {
        const reserveRoomsWrapper = $('.js-reserved-rooms');
        reserveRoomsWrapper.find('.js-my-reserved-rooms').off('click');
        reserveRoomsWrapper.find('.js-my-reserved-rooms').on('click', event => {
            var _b;
            const currentId = $(event.currentTarget).attr('data-id');
            if (!currentId)
                return;
            const hotelsBlockOffset = $('.js-hotels-without__block').find(`div[data-id="${currentId}"]`).offset();
            const needScrollTop = hotelsBlockOffset != null ? hotelsBlockOffset.top : 0;
            if (!App.isTouch)
                $('html, body').animate({ scrollTop: needScrollTop }, 300);
            else
                App.app.container.animate({ scrollTop: needScrollTop + ((_b = App.app.container.scrollTop()) !== null && _b !== void 0 ? _b : 0) }, 300);
        });
    };
    App.HotelPageMobileBase = HotelPageMobileBase;
})(App || (App = {}));
/// <reference path='HotelPageBase.Mobile.ts' />
var App;
(function (App) {
    var _HotelBookPageMobile_instances, _HotelBookPageMobile_passengers, _HotelBookPageMobile_popup, _HotelBookPageMobile_responseValidator, _HotelBookPageMobile_pricePresenter, _HotelBookPageMobile_bookingForm, _HotelBookPageMobile_bookingTemplate, _HotelBookPageMobile_preloaderField, _HotelBookPageMobile_activeRequest, _HotelBookPageMobile_extraServices, _HotelBookPageMobile_bookDigest, _HotelBookPageMobile_validator, _HotelBookPageMobile_filters, _HotelBookPageMobile_bestPriceItems, _HotelBookPageMobile_agentBlackListComponent, _HotelBookPageMobile_preloader_get, _HotelBookPageMobile_reactivate, _HotelBookPageMobile_onBookFilterChanged, _HotelBookPageMobile_onBookSend, _HotelBookPageMobile_showBookingForm, _HotelBookPageMobile_searchHotelByIdForBookingPage, _HotelBookPageMobile_searchHotelVariantsForBookingPage, _HotelBookPageMobile_onBookingButtonClick, _HotelBookPageMobile_renderBookingSection, _HotelBookPageMobile_scrollToOutputBlock, _HotelBookPageMobile_booking, _HotelBookPageMobile_serializeRemarks, _HotelBookPageMobile_recalcPrice, _HotelBookPageMobile_getDigestData, _HotelBookPageMobile_applyPromoCode, _HotelBookPageMobile_getLateArrivalTimes, _HotelBookPageMobile_updateLateArrivalControlsVisibility;
    class HotelBookPageMobile extends App.HotelPageMobileBase {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelBookPageMobile_instances.add(this);
            _HotelBookPageMobile_passengers.set(this, void 0);
            _HotelBookPageMobile_popup.set(this, void 0);
            _HotelBookPageMobile_responseValidator.set(this, void 0);
            _HotelBookPageMobile_pricePresenter.set(this, void 0);
            _HotelBookPageMobile_bookingForm.set(this, void 0);
            _HotelBookPageMobile_bookingTemplate.set(this, void 0);
            _HotelBookPageMobile_preloaderField.set(this, void 0);
            _HotelBookPageMobile_activeRequest.set(this, void 0);
            _HotelBookPageMobile_extraServices.set(this, void 0);
            _HotelBookPageMobile_bookDigest.set(this, void 0);
            _HotelBookPageMobile_validator.set(this, void 0);
            _HotelBookPageMobile_filters.set(this, void 0);
            _HotelBookPageMobile_bestPriceItems.set(this, []);
            _HotelBookPageMobile_agentBlackListComponent.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _HotelBookPageMobile_bookingTemplate, App.templates.Hotel.BookingForm_Mobile, "f");
            __classPrivateFieldSet(this, _HotelBookPageMobile_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                var _a;
                if (action === 'interrupt') {
                    (_a = __classPrivateFieldGet(this, _HotelBookPageMobile_activeRequest, "f")) === null || _a === void 0 ? void 0 : _a.abort();
                    inst.hide();
                }
            });
        }
        start() {
            const _super = Object.create(null, {
                start: { get: () => super.start }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                yield _super.start.call(this);
                $('.js-add-mode-context-message').hide();
                this.root.showByClass();
                const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
                const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (bookedVariants.length > 0 && this.options.manager.hotel && this.options.manager.hotel.key === hotelKey) {
                    const context = App.UrlParameterHelper.urlParse().find(item => item.name === 'context');
                    const contextNumber = context ? context.values[0] : '';
                    yield this.reservationComplete(bookedVariants, contextNumber);
                }
                else {
                    if (this.emptyUrlChecker.isEmpty(App.UrlParameterHelper.urlParse()))
                        return;
                    this.messenger.hide();
                    // Отправить запросы для получения инфы об отеле и списка вариантов
                    __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "a", _HotelBookPageMobile_preloader_get).show();
                    // Думаю, что в данном случае целесообразно отменить все запросы при нажатии на кнопку - все равно тут это
                    // надо для правильной отрисовки формы бронирования - оба запроса важны одинаково.
                    const operations = new Array();
                    if (bookedVariants.length <= 0)
                        operations.push(__classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_searchHotelVariantsForBookingPage).call(this, hotelKey));
                    if (!this.options.manager.hotel || this.options.manager.hotel.key !== hotelKey)
                        operations.push(__classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_searchHotelByIdForBookingPage).call(this, hotelKey));
                    yield Promise.all(operations);
                    __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "a", _HotelBookPageMobile_preloader_get).hide();
                    yield this.book(hotelKey);
                    __classPrivateFieldSet(this, _HotelBookPageMobile_activeRequest, undefined, "f");
                }
                this.components.push(
                // new ExistingPassengers(),
                // new FindTourist(),
                new App.BestPriceComponent({ container: this.container, getData: () => __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f") }));
                App.ExistingPassengersMobile.Creates();
                App.FindTouristMobile.Creates();
                this.components.push(new App.PromoCodeComponentMobile({
                    root: this.root,
                    onSubmit: (promoCode) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_applyPromoCode).call(this, hotelKey, promoCode);
                        return this.isPromoCodeApplied;
                    }),
                    onRemove: () => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_applyPromoCode).call(this, hotelKey);
                    }),
                }));
                if (App.app.userSettings.isAgentInBlackList) {
                    __classPrivateFieldSet(this, _HotelBookPageMobile_agentBlackListComponent, new App.AgentBlackListMobile({ useForm: true }), "f");
                    this.components.push(__classPrivateFieldGet(this, _HotelBookPageMobile_agentBlackListComponent, "f"));
                }
            });
        }
        stop() {
            var _a;
            // TODO: очередной костыль - скрыть popup жжОсско
            $('.js-popup').hide();
            // Остановить активные поиски кроме hotel/search
            (_a = __classPrivateFieldGet(this, _HotelBookPageMobile_activeRequest, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.root.hideByClass();
        }
        // Костыль: блокируем стандартное создание формы из базового класса.
        initForm() {
        }
        reservationComplete(basketVariants, contextNumber) {
            return __awaiter(this, void 0, void 0, function* () {
                // Сделаем запрос существующих туристов, если это добавление услуги в заказ
                // Делаем проверку на наличие туристов. Такое может быть, если уже переходили на фому бронирования, потом
                // вернулись на поиск, а потом опять перешли на бронирование.
                if (contextNumber && !__classPrivateFieldGet(this, _HotelBookPageMobile_passengers, "f")) {
                    const touristsResponse = yield $.ajax({
                        url: App.app.url.route(App.HotelPageUrls.ExistingTourists, { context: contextNumber }),
                        method: 'POST',
                        dataType: 'json',
                        data: new Array(0),
                    });
                    // TODO: мне кажется, тут обработку ошибок можно пропустить - если что-то пойдет не так, просто не
                    // будет предыдущих туристов.
                    if (touristsResponse.data)
                        __classPrivateFieldSet(this, _HotelBookPageMobile_passengers, touristsResponse.data, "f");
                    else
                        __classPrivateFieldSet(this, _HotelBookPageMobile_passengers, undefined, "f");
                }
                const bookData = yield $.ajax({
                    url: App.app.url.route(App.HotelPageUrls.BookData),
                    method: 'POST',
                    dataType: 'json',
                    data: new Array(0),
                });
                // Отобразим форму
                if (this.options.manager.hotel) {
                    yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_showBookingForm).call(this, basketVariants, this.options.manager.hotel, contextNumber, bookData.data.allowBooking, bookData.data.agencyCountryKey);
                }
            });
        }
    }
    _HotelBookPageMobile_passengers = new WeakMap(), _HotelBookPageMobile_popup = new WeakMap(), _HotelBookPageMobile_responseValidator = new WeakMap(), _HotelBookPageMobile_pricePresenter = new WeakMap(), _HotelBookPageMobile_bookingForm = new WeakMap(), _HotelBookPageMobile_bookingTemplate = new WeakMap(), _HotelBookPageMobile_preloaderField = new WeakMap(), _HotelBookPageMobile_activeRequest = new WeakMap(), _HotelBookPageMobile_extraServices = new WeakMap(), _HotelBookPageMobile_bookDigest = new WeakMap(), _HotelBookPageMobile_validator = new WeakMap(), _HotelBookPageMobile_filters = new WeakMap(), _HotelBookPageMobile_bestPriceItems = new WeakMap(), _HotelBookPageMobile_agentBlackListComponent = new WeakMap(), _HotelBookPageMobile_instances = new WeakSet(), _HotelBookPageMobile_preloader_get = function _HotelBookPageMobile_preloader_get() {
        if (!__classPrivateFieldGet(this, _HotelBookPageMobile_preloaderField, "f"))
            __classPrivateFieldSet(this, _HotelBookPageMobile_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _HotelBookPageMobile_preloaderField, "f");
    }, _HotelBookPageMobile_reactivate = function _HotelBookPageMobile_reactivate(digestData, allowBooking) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _HotelBookPageMobile_bookingForm, $('form', this.root), "f");
            __classPrivateFieldGet(this, _HotelBookPageMobile_bookingForm, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_onBookingButtonClick).call(this, e); }));
            __classPrivateFieldSet(this, _HotelBookPageMobile_extraServices, $('.js-person-extra-service-group', __classPrivateFieldGet(this, _HotelBookPageMobile_bookingForm, "f")), "f");
            __classPrivateFieldGet(this, _HotelBookPageMobile_extraServices, "f").on('change', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_recalcPrice).call(this); }));
            // Дайджест
            // this.components.push(new Digest({ container: this.root }));
            __classPrivateFieldSet(this, _HotelBookPageMobile_bookDigest, new App.DigestMobile({
                buttonTitle: 'Забронировать',
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_onBookSend).call(this),
                allowBooking: allowBooking,
            }), "f");
            __classPrivateFieldGet(this, _HotelBookPageMobile_bookDigest, "f").empty();
            const digestContent = $(App.templates.Hotel.BookDigest_Content_Mobile(digestData));
            yield App.CurrencyManager.convertAll(digestContent);
            const digestFloater = $(App.templates.Hotel.BookDigest_Floater_Mobile(digestData));
            yield App.CurrencyManager.convertAll(digestFloater);
            yield __classPrivateFieldGet(this, _HotelBookPageMobile_bookDigest, "f").setContent(digestContent);
            __classPrivateFieldGet(this, _HotelBookPageMobile_bookDigest, "f").setFloater(digestFloater);
            // Переключение пола М/Ж
            $('.js-form-gender', this.root).each((index, element) => {
                const icon = $('.js-form-gender-icon', element);
                const input = $('.js-form-gender-input', element);
                input.on('change', event => {
                    // Чтобы в MVC контроллере пришло в виде перечисления полов, надо, чтобы value у радиобатонов полов были male и
                    // female (в шаблоне)
                    icon.toggleClass('_man', $(event.target).is(':checked') && $(event.target).val() === 'Male');
                    icon.toggleClass('_woman', $(event.target).is(':checked') && $(event.target).val() === 'Female');
                }).filter(':checked').trigger('change');
            });
            // Инициализация дат рождения
            // TODO: пересекается с инитом датапикера в Filter. Оставила этот метод, т.к. здесь делается возможность выбора месяца и года
            const currentYear = new Date().getFullYear();
            // Человеком, который прожил самую долгую жизнь, считается француженка Жанна Кальман. Она успела отметить свой 122 день
            // рождения прежде, чем отошла в мир иной.
            const minYear = currentYear - 125;
            $('.js-form-date', this.root).each((index, element) => {
                const el = $(element);
                el
                    .attr('autocomplete', 'off')
                    .inputmask('date');
                el.datepicker({
                    constrainInput: true,
                    yearRange: `${minYear}:${currentYear}`,
                });
            });
            // Инициализация полей, содержащих данные ФИО:
            $('.js-form-fio', this.root).on('change', e => {
                const target = $(e.currentTarget);
                target.val(App.transliterateName(target.valString()));
            });
            // const filter = new Filter({ root: this.#bookingForm });
            const filter = new App.FilterMobile({
                root: __classPrivateFieldGet(this, _HotelBookPageMobile_bookingForm, "f"),
                onFilterChanged: () => __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_onBookFilterChanged).call(this),
            });
            __classPrivateFieldSet(this, _HotelBookPageMobile_validator, filter.validator, "f");
            __classPrivateFieldSet(this, _HotelBookPageMobile_filters, filter.filters, "f");
            __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_updateLateArrivalControlsVisibility).call(this);
            // this.form = new Form({ root: filter.root });
            __classPrivateFieldSet(this, _HotelBookPageMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _HotelBookPageMobile_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _HotelBookPageMobile_popup, "f")),
                validator: filter.validator,
            }), "f");
        });
    }, _HotelBookPageMobile_onBookFilterChanged = function _HotelBookPageMobile_onBookFilterChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_updateLateArrivalControlsVisibility).call(this);
        });
    }, _HotelBookPageMobile_onBookSend = function _HotelBookPageMobile_onBookSend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _HotelBookPageMobile_bookDigest, "f"))
                __classPrivateFieldGet(this, _HotelBookPageMobile_bookDigest, "f").close();
            $('.js-booking-submit').trigger('click');
        });
    }, _HotelBookPageMobile_showBookingForm = function _HotelBookPageMobile_showBookingForm(reservedVariants, hotel, context, allowBooking, agencyCountryKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (reservedVariants.length < 0)
                return;
            if (!hotel)
                return;
            // Достанем даты отъезда/заезда из урла
            const urlParameters = App.UrlParameterHelper.urlParse();
            const dateFromArr = urlParameters.find(item => item.name.toLowerCase() === 'checkin');
            const dateToArr = urlParameters.find(item => item.name.toLowerCase() === 'checkout');
            if (!dateFromArr || !dateToArr)
                return;
            const dateFrom = App.parseIsoDate(dateFromArr.values[0]);
            const dateTo = App.parseIsoDate(dateToArr.values[0]);
            // передать данные в шаблон и вставить его
            yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_renderBookingSection).call(this, reservedVariants, hotel, dateFrom, dateTo, context, allowBooking, agencyCountryKey, __classPrivateFieldGet(this, _HotelBookPageMobile_passengers, "f"));
            this.header.html(localizer.bookingAccommodation);
            __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_scrollToOutputBlock).call(this);
        });
    }, _HotelBookPageMobile_searchHotelByIdForBookingPage = function _HotelBookPageMobile_searchHotelByIdForBookingPage(hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield $.ajax({
                url: App.app.url.route(App.HotelPageUrls.Hotel, hotelKey),
                method: 'POST',
                dataType: 'json',
                data: new Array(0),
            });
            const responseData = this.validateHotelResponse(response);
            if (!responseData)
                return;
            this.options.manager.hotel = responseData;
        });
    }, _HotelBookPageMobile_searchHotelVariantsForBookingPage = function _HotelBookPageMobile_searchHotelVariantsForBookingPage(hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const urlParameters = App.UrlParameterHelper.urlParse();
            // Найдем id забронированных вариантов
            const reservedVariants = urlParameters.find(item => item.name === 'reserved');
            if (!reservedVariants)
                return;
            const serializedForm = yield this.options.manager.getHotelVariantsRequestData(urlParameters);
            reservedVariants.values.forEach((value, index) => {
                serializedForm.push({
                    name: `variantKeys[${index}]`,
                    value,
                });
            });
            const xhr = $.ajax({
                url: App.app.url.route(App.HotelPageUrls.ReservedVariants, hotelKey),
                method: 'POST',
                dataType: 'json',
                data: serializedForm,
            });
            __classPrivateFieldSet(this, _HotelBookPageMobile_activeRequest, xhr, "f");
            const response = yield xhr;
            if (!App.validateResponse(response, this.messenger))
                return;
            if (!response.data)
                return;
            const responseData = response.data;
            const responseVariants = (_a = responseData.variants) !== null && _a !== void 0 ? _a : new Array(0);
            // Из контроллера приходят уже отобранные по ключу варианты, но здесь все равно проверяем, что пришли все, которые есть в урле,
            // т.к.там проверки не делается
            for (let i = 0; i < reservedVariants.values.length; i++) {
                const variantId = reservedVariants.values[i];
                const currentVariant = responseVariants.find(v => v.key.toLowerCase() === variantId.toLowerCase());
                if (!currentVariant) {
                    this.messenger.show({
                        type: 1 /* MessageType.Warning */,
                        text: 'Один из вариантов размещения уже недоступен',
                    });
                    return;
                }
                currentVariant.selected = true;
                this.options.manager.addBookedVariants(hotelKey, currentVariant);
            }
        });
    }, _HotelBookPageMobile_onBookingButtonClick = function _HotelBookPageMobile_onBookingButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _HotelBookPageMobile_validator, "f").form())
                return;
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _HotelBookPageMobile_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_booking).call(this); }));
            }
            else {
                // собственно бронирование
                yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_booking).call(this);
            }
        });
    }, _HotelBookPageMobile_renderBookingSection = function _HotelBookPageMobile_renderBookingSection(reservedVariants, hotel, dateFrom, dateTo, context, allowBooking, agencyCountryKey, existingPassengers) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: много дублирования с экскурсиями, только там один объект, а тут цикл
            const bookingVariants = reservedVariants;
            const durationInNights = App.dateDiff(dateTo, dateFrom).getTotalDays();
            bookingVariants.forEach(variant => {
                // TODO: из-за сложностей с обработкой дат в JS пока не делаю ограничения на даты в датапикере. Пихаю в поля min и max строкой
                variant.adults = new Array();
                for (let i = 0; variant.adultCount > i; i++) {
                    variant.adults.push(new App.BookingTouristMobile(
                    // первым должен быть взрослый, все остальные могут быть кем угодно.
                    i === 0 ? this.options.adultAge : 0, this.options.maxAdultAge, dateFrom, existingPassengers));
                }
                variant.children = new Array();
                variant.childAges.forEach(childAge => {
                    variant.children.push(new App.BookingChildMobile(this.options.minChildAge, this.options.maxChildAge, dateTo, childAge, existingPassengers));
                });
                variant.rooms = new Array();
                for (let index = 1; index <= variant.quantity; index++)
                    variant.rooms.push(index);
            });
            const data = Object.assign({
                hotel,
                variants: bookingVariants,
                hasCashBack: hotel.facilities.some(v => v.key === App.HotelFacility.CashBack),
                dateFrom,
                dateTo,
                durationInNights,
                durationInDays: durationInNights + 1,
                // если кол-во гостей больше 2х, при этом взрослых больше одного
                showWarningMessage1: bookingVariants.some(v => v.adultCount + v.childCount > 2 && v.adultCount > 1),
                // если бронируют одного взрослого + сколько угодно детей
                showWarningMessage2: bookingVariants.some(v => v.adultCount == 1 && v.childCount > 0),
                context: context ? { number: context } : undefined,
                allowBooking,
                agencyCountryKey,
                lateArrivalTimes: __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_getLateArrivalTimes).call(this, dateFrom),
            }, yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_getDigestData).call(this));
            __classPrivateFieldSet(this, _HotelBookPageMobile_bestPriceItems, [], "f");
            if (data) {
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'hotelName', value: data.hotel.name });
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'hotelCategory', value: data.hotel.stars });
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'hotelUrl', value: data.hotel.link });
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'country', value: data.hotel.country });
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'dateFrom', value: App.formatDate(dateFrom, 'isoDate') });
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'dateTo', value: App.formatDate(dateTo, 'isoDate') });
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'price', value: App.formatNumber(data.grossPrice, 'moneyEdit') });
                __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: 'currencyCode', value: data.currencyCode });
                data.variants.map((v, i) => {
                    __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: `rooms[${i}].roomType`, value: v.room });
                    __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: `rooms[${i}].boardType`, value: v.board });
                    __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: `rooms[${i}].touristCount`, value: `${(v.adultCount + v.childCount)}` });
                    v.childAges.forEach((x, j) => __classPrivateFieldGet(this, _HotelBookPageMobile_bestPriceItems, "f").push({ key: `rooms[${i}].childAges[${j}]`, value: `${x}` }));
                });
            }
            const content = $(__classPrivateFieldGet(this, _HotelBookPageMobile_bookingTemplate, "f").call(this, data));
            yield App.CurrencyManager.convertAll(content);
            this.content.empty();
            this.content.append(content);
            yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_reactivate).call(this, data, data.allowBooking);
        });
    }, _HotelBookPageMobile_scrollToOutputBlock = function _HotelBookPageMobile_scrollToOutputBlock() {
        // инит блока здесь, т.к. в момент инициализации страницы элемента еще нет, он появляется при отрисовке данных
        const scrollToBlock = $('.js-room-booking', this.root);
        if (scrollToBlock) {
            const scrollOffset = scrollToBlock.offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
    }, _HotelBookPageMobile_booking = function _HotelBookPageMobile_booking() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let formData = __classPrivateFieldGet(this, _HotelBookPageMobile_filters, "f").serializeArray();
            formData = formData.filter(x => !(x.name.includes('remarks') && x.value == 'false'));
            const withValueAttr = __classPrivateFieldGet(this, _HotelBookPageMobile_filters, "f").controls.filter(x => !(x.name.includes('remarks') && x.getValueString() == 'false')
                && x.root.attr('value'));
            withValueAttr.forEach(x => {
                const existing = formData.find(item => item.name === x.name);
                if (existing) {
                    existing.value = x.root.attr('value');
                }
                else {
                    formData.push({
                        name: x.name,
                        value: x.root.attr('value'),
                    });
                }
            });
            formData = __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_serializeRemarks).call(this, formData);
            const popupGroup = __classPrivateFieldGet(this, _HotelBookPageMobile_popup, "f").show({
                group: 'main',
                content: App.templates.Hotel.Popups.Booking({}),
                modal: true,
            });
            try {
                const response = yield $.ajax({
                    url: App.app.url.route(window.location.href),
                    method: 'POST',
                    dataType: 'json',
                    data: formData,
                });
                this.options.unavailableOfferService.addRange((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.unavailableOffers) !== null && _b !== void 0 ? _b : []);
                if (!__classPrivateFieldGet(this, _HotelBookPageMobile_responseValidator, "f").process(response))
                    return;
                if (response.data && response.data.dialog) {
                    if (response.data.status === 0 /* MessageType.Information */) {
                        __classPrivateFieldGet(this, _HotelBookPageMobile_popup, "f").show({
                            content: App.templates.RelatedServiceDialog(response.data.dialog),
                            modal: true,
                        });
                    }
                    else if (response.data.status === 1 /* MessageType.Warning */) {
                        __classPrivateFieldGet(this, _HotelBookPageMobile_popup, "f").show({
                            content: App.templates.Hotel.Popups.BookingAnomalyPopup(response.data.dialog),
                            modal: true,
                        });
                    }
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelBookPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelBookPageMobile_popup, "f").hide(popupGroup);
            }
        });
    }, _HotelBookPageMobile_serializeRemarks = function _HotelBookPageMobile_serializeRemarks(formData) {
        const result = new Array();
        const remarks = new Map();
        const lateArrivalTimes = new Map();
        const remarkPattern = /^form\.services\[(\d+)]\.remarks(?:\.[^.]+)?$/i;
        const lateArrivalTimePattern = /^form\.services\[(\d+)]\.lateArrivalTime$/i;
        formData.forEach(item => {
            var _a;
            const lateArrivalTimeMatch = item.name.match(lateArrivalTimePattern);
            if (lateArrivalTimeMatch) {
                if (item.value)
                    lateArrivalTimes.set(parseInt(lateArrivalTimeMatch[1], 10), item.value.toString());
                return;
            }
            const remarkMatch = item.name.match(remarkPattern);
            if (!remarkMatch) {
                result.push(item);
                return;
            }
            const serviceIndex = parseInt(remarkMatch[1], 10);
            const remarkKey = Number(item.value);
            if (!Number.isInteger(remarkKey) || remarkKey <= 0)
                return;
            const serviceRemarks = (_a = remarks.get(serviceIndex)) !== null && _a !== void 0 ? _a : [];
            serviceRemarks.push({ key: remarkKey });
            remarks.set(serviceIndex, serviceRemarks);
        });
        lateArrivalTimes.forEach((value, serviceIndex) => {
            var _a;
            const lateArrival = (_a = remarks.get(serviceIndex)) === null || _a === void 0 ? void 0 : _a.find(v => v.key === 15);
            if (lateArrival)
                lateArrival.value = value;
        });
        remarks.forEach((serviceRemarks, serviceIndex) => {
            serviceRemarks.forEach((remark, remarkIndex) => {
                result.push({
                    name: `form.services[${serviceIndex}].remarks[${remarkIndex}].key`,
                    value: remark.key.toString(),
                });
                if (remark.value) {
                    result.push({
                        name: `form.services[${serviceIndex}].remarks[${remarkIndex}].value`,
                        value: remark.value,
                    });
                }
            });
        });
        return result;
    }, _HotelBookPageMobile_recalcPrice = function _HotelBookPageMobile_recalcPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            // const data = await this.#getDigestData(this.#filters.serializeArray());
            // await this.#updateDigest(data);
        });
    }, _HotelBookPageMobile_getDigestData = function _HotelBookPageMobile_getDigestData(formData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
            const bookingVariants = this.options.manager.getBookedVariants(hotelKey);
            if (formData) {
                bookingVariants.forEach((v, vi) => {
                    v.extraGroups.forEach((x, xi) => {
                        x.items.forEach(item => {
                            const extra = formData.filter(d => d.name === `form.services[${vi}].extras[${xi}]`);
                            item.selected = extra.some(e => e.value === item.code);
                        });
                    });
                });
            }
            const urlParameters = App.UrlParameterHelper.urlParse();
            const dateFromArr = urlParameters.find(item => item.name.toLowerCase() === 'checkin');
            const dateToArr = urlParameters.find(item => item.name.toLowerCase() === 'checkout');
            const dateFrom = !dateFromArr ? new Date() : App.parseIsoDate(dateFromArr.values[0]);
            const dateTo = !dateToArr ? new Date() : App.parseIsoDate(dateToArr.values[0]);
            const durationInNights = (dateFrom && dateTo) ? App.dateDiff(dateTo, dateFrom).getTotalDays() : 0;
            const hotel = (_b = this.options.manager.hotel) !== null && _b !== void 0 ? _b : {};
            const notes = new Array();
            if ([115 /* KnownCountry.Russia */, 118177 /* KnownCountry.Crimea */].includes(hotel.countryKey))
                notes.push('Стоимость фиксируется в евро и оплачивается в национальной валюте по внутреннему курсу Компании.');
            const servicePrices = Enumerable.from(bookingVariants)
                .selectMany(v => v.extraGroups)
                .selectMany(v => v.items.filter(x => x.selected), (v1, v2) => {
                var _a;
                return ({
                    name: v1.name,
                    grossPrice: v2.grossPrice,
                    price: (_a = v2.price) !== null && _a !== void 0 ? _a : v2.grossPrice,
                    currencyCode: v2.currencyCode,
                });
            })
                .groupBy(v => ({ name: v.name, currencyCode: v.currencyCode }), v => v, (k, v) => {
                const result = {
                    name: k.name,
                    isBonus: false,
                    grossPrice: 0,
                    discount: 0,
                    price: 0,
                    currencyCode: k.currencyCode,
                };
                v.forEach(x => {
                    result.grossPrice += x.grossPrice;
                    result.discount += x.grossPrice - x.price;
                    result.price += x.price;
                });
                return result;
            }, v => `${v.name}:${v.currencyCode}`)
                .toArray();
            const priceTotals = App.HotelPageMobileBase.getPriceTotals(bookingVariants);
            let discount = priceTotals.discount;
            const bonusAmount = bookingVariants
                .map(v => v.promotions.bonusPrice.amount)
                .reduce((p, v) => p + v, 0);
            if (bonusAmount !== 0) {
                servicePrices.push({
                    name: 'Бонус',
                    isBonus: true,
                    grossPrice: -bonusAmount,
                    discount: 0,
                    price: -bonusAmount,
                    currencyCode: priceTotals.currencyCode,
                });
                discount -= bonusAmount;
            }
            return {
                hotel,
                variants: bookingVariants,
                dateFrom,
                dateTo,
                durationInNights,
                durationInDays: durationInNights + 1,
                // Для BookDigestFooter
                servicePrices,
                netPrice: priceTotals.netPrice,
                grossPrice: priceTotals.grossPrice,
                price: priceTotals.price,
                discount,
                currencyCode: priceTotals.currencyCode,
                hasDetails: false,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _HotelBookPageMobile_pricePresenter, "f").type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                notes,
            };
        });
    }, _HotelBookPageMobile_applyPromoCode = function _HotelBookPageMobile_applyPromoCode(hotelKey, promoCode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.valuate(hotelKey, promoCode))
                yield __classPrivateFieldGet(this, _HotelBookPageMobile_instances, "m", _HotelBookPageMobile_recalcPrice).call(this);
        });
    }, _HotelBookPageMobile_getLateArrivalTimes = function _HotelBookPageMobile_getLateArrivalTimes(checkIn) {
        const result = new Array();
        const locale = document.documentElement.lang || 'ru-RU';
        const dateFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });
        for (let hourOffset = 14; hourOffset <= 34; hourOffset++) {
            const nextDay = hourOffset >= 24;
            const hour = hourOffset % 24;
            const time = `${hour.toString().padStart(2, '0')}:00`;
            const date = new Date(checkIn.getFullYear(), checkIn.getMonth(), checkIn.getDate() + (nextDay ? 1 : 0), 12);
            result.push({
                value: `${App.formatDate(date, 'isoDate')}T${time}:00`,
                label: nextDay ? `${time}, ${dateFormatter.format(date)}` : time,
                checked: false,
            });
        }
        return result;
    }, _HotelBookPageMobile_updateLateArrivalControlsVisibility = function _HotelBookPageMobile_updateLateArrivalControlsVisibility() {
        const timePattern = /^form\.services\[(\d+)]\.lateArrivalTime$/i;
        __classPrivateFieldGet(this, _HotelBookPageMobile_filters, "f").controls.forEach(control => {
            const match = control.name.match(timePattern);
            if (!match)
                return;
            const serviceIndex = parseInt(match[1], 10);
            const toggleName = `form.services[${serviceIndex}].remarks.requestRoomLateArrival`;
            const toggleControl = __classPrivateFieldGet(this, _HotelBookPageMobile_filters, "f").controls.find(v => v.name === toggleName);
            if (!toggleControl)
                return;
            control.root.toggle(toggleControl.getControlValueString() === 'true');
        });
    };
    App.HotelBookPageMobile = HotelBookPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelPageBase_instances, _a, _HotelPageBase_container, _HotelPageBase_content, _HotelPageBase_header, _HotelPageBase_mainFilter, _HotelPageBase_messenger, _HotelPageBase_bookingComButton, _HotelPageBase_emptyUrlChecker, _HotelPageBase_requiredUrlChecker, _HotelPageBase_cancellationRuleChecker, _HotelPageBase_chooseNumbersScrollingBlock, _HotelPageBase_reserveHotelButtonSelector, _HotelPageBase_changeApplicationDataCancellationPolicy, _HotelPageBase_changeVariantsCancellationPolicy, _HotelPageBase_onBookingComButtonClick, _HotelPageBase_checkCriticalChanges, _HotelPageBase_makeCancellationRuleDifferenceString, _HotelPageBase_renewVariants, _HotelPageBase_makeLinkForReservedVariants, _HotelPageBase_bindScrollOnBookedClick;
    class HotelPageBase extends App.PageBase {
        get container() {
            return __classPrivateFieldGet(this, _HotelPageBase_container, "f");
        }
        get content() {
            return __classPrivateFieldGet(this, _HotelPageBase_content, "f");
        }
        get header() {
            return __classPrivateFieldGet(this, _HotelPageBase_header, "f");
        }
        // Возвращает главный фильтр страницы (который не горячий)
        get mainFilter() {
            return __classPrivateFieldGet(this, _HotelPageBase_mainFilter, "f");
        }
        get messenger() {
            return __classPrivateFieldGet(this, _HotelPageBase_messenger, "f");
        }
        /**
         * Возвращает кнопку 'Показать на букинге'
         */
        get bookingComButton() {
            return __classPrivateFieldGet(this, _HotelPageBase_bookingComButton, "f");
        }
        get emptyUrlChecker() {
            if (!__classPrivateFieldGet(this, _HotelPageBase_emptyUrlChecker, "f"))
                __classPrivateFieldSet(this, _HotelPageBase_emptyUrlChecker, new App.EmptyUrlChecker(new App.HotelUrlParameters()), "f");
            return __classPrivateFieldGet(this, _HotelPageBase_emptyUrlChecker, "f");
        }
        get requiredUrlChecker() {
            if (!__classPrivateFieldGet(this, _HotelPageBase_requiredUrlChecker, "f"))
                __classPrivateFieldSet(this, _HotelPageBase_requiredUrlChecker, new App.RequiredUrlChecker(new App.HotelUrlParameters()), "f");
            return __classPrivateFieldGet(this, _HotelPageBase_requiredUrlChecker, "f");
        }
        get cancellationRuleChecker() {
            if (!__classPrivateFieldGet(this, _HotelPageBase_cancellationRuleChecker, "f"))
                __classPrivateFieldSet(this, _HotelPageBase_cancellationRuleChecker, new App.CancellationRuleChecker(), "f");
            return __classPrivateFieldGet(this, _HotelPageBase_cancellationRuleChecker, "f");
        }
        get chooseNumbersScrollingBlock() {
            return __classPrivateFieldGet(this, _HotelPageBase_chooseNumbersScrollingBlock, "f");
        }
        constructor(options) {
            super(options);
            _HotelPageBase_instances.add(this);
            Object.defineProperty(this, "options", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _HotelPageBase_container.set(this, void 0);
            _HotelPageBase_content.set(this, void 0);
            _HotelPageBase_header.set(this, void 0);
            /**
            * Главный фильтр страницы (присвоить конкретный контейнер в конкретном классе)
            */
            _HotelPageBase_mainFilter.set(this, void 0);
            _HotelPageBase_messenger.set(this, void 0);
            Object.defineProperty(this, "form", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Кнопка 'Показать на букинге'. Инициализировать в производном классе
             */
            _HotelPageBase_bookingComButton.set(this, void 0);
            _HotelPageBase_emptyUrlChecker.set(this, void 0);
            _HotelPageBase_requiredUrlChecker.set(this, void 0);
            _HotelPageBase_cancellationRuleChecker.set(this, void 0);
            _HotelPageBase_chooseNumbersScrollingBlock.set(this, void 0);
            _HotelPageBase_reserveHotelButtonSelector.set(this, void 0);
            Object.defineProperty(this, "isPromoCodeApplied", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            this.options = options;
            if (!this.root.length)
                return;
            // инициализация элементов
            __classPrivateFieldSet(this, _HotelPageBase_container, $(this.options.container), "f");
            __classPrivateFieldSet(this, _HotelPageBase_content, $(this.options.content, __classPrivateFieldGet(this, _HotelPageBase_container, "f")), "f");
            __classPrivateFieldSet(this, _HotelPageBase_header, $('h1.js-header'), "f");
            __classPrivateFieldSet(this, _HotelPageBase_mainFilter, $(this.options.mainFilter, this.root), "f");
            __classPrivateFieldSet(this, _HotelPageBase_bookingComButton, $(this.options.bookingComButtonName, __classPrivateFieldGet(this, _HotelPageBase_container, "f")), "f");
            __classPrivateFieldSet(this, _HotelPageBase_messenger, new App.BlockMessenger(new App.Messages({ root: $('.js-messages', __classPrivateFieldGet(this, _HotelPageBase_container, "f")) })), "f");
            this.initForm();
            // Плавающий блок 'Выберите номера'
            __classPrivateFieldSet(this, _HotelPageBase_chooseNumbersScrollingBlock, $('.js-scrolling-reserve-block', this.root), "f");
            // Кнопка бронирования при добавлении отеля перерисовывается вместе со всем блоком резервирования,
            // поэтому нельзя инициализировать ее здесь. Пишет здесь только название селектора
            __classPrivateFieldSet(this, _HotelPageBase_reserveHotelButtonSelector, '.js-reserve-hotel', "f");
            __classPrivateFieldGet(this, _HotelPageBase_bookingComButton, "f").on('click', e => __classPrivateFieldGet(this, _HotelPageBase_instances, "m", _HotelPageBase_onBookingComButtonClick).call(this, e));
            __classPrivateFieldGet(this, _HotelPageBase_container, "f").on('click', __classPrivateFieldGet(this, _HotelPageBase_reserveHotelButtonSelector, "f"), e => {
                e.preventDefault();
                $(e.currentTarget).trigger("variant:book" /* Events.VariantBook */);
            });
        }
        initForm() {
            this.form = new App.Form({ root: __classPrivateFieldGet(this, _HotelPageBase_mainFilter, "f"), disableStepValidation: true });
        }
        /**
         * Активировать работу страницы.
         */
        start() {
            if (this.options.searchError) {
                this.messenger.hide();
                this.messenger.show({ type: 2 /* MessageType.Error */, text: this.options.searchError });
            }
            return Promise.resolve();
        }
        // TODO: дублирование с экскурсиями
        getSeo(urlParameters, url, formFields) {
            return __awaiter(this, void 0, void 0, function* () {
                let form = formFields !== null && formFields !== void 0 ? formFields : new Array();
                // Если форма типа-пустая, то оставляем в ней только context и передаем таким образом на сервер
                if (this.emptyUrlChecker.isEmpty(urlParameters))
                    form = form.filter(item => item.name === App.HotelFilterFields.Context);
                try {
                    const response = yield $.ajax({
                        url: App.app.url.route(url),
                        method: 'POST',
                        dataType: 'json',
                        data: form,
                    });
                    App.app.seo.update(response.data);
                }
                catch (e) {
                    // TODO: логгировать ошибку, но не выводить
                }
            });
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        renderChangedVariants(changedVariants) {
            /* eslint-disable no-await-in-loop */
            for (let index = 0; index < changedVariants.length; index++) {
                // Для использования этого шаблона, в него надо передать массив HotelVariant
                // Поэтому от исходного массива берем часть, равную только одному элементу
                const content = $(App.templates.Hotel.DetailTableItem(changedVariants[index]));
                App.NetPricePresenter.setVisibility(content, App.NetPricePresenter.getVisibility());
                const variantId = changedVariants[index].key;
                __classPrivateFieldGet(this, _HotelPageBase_container, "f").find($(`.js-tours-output-table .js-hotel_item-without-tour[data-id='${variantId}']`))
                    .replaceWith(content);
            }
            /* eslint-enable no-await-in-loop */
        }
        /**
         * Возвращает сериализованный массив полей фильтра
         * Переопределить в конкретном классе, если есть отличия в реализации
         */
        getFilterSerializeArray() {
            return __classPrivateFieldGet(this, _HotelPageBase_mainFilter, "f").find('input').serializeArray();
        }
        /**
         * Показать кнопку 'искать на букинге'
         * если она есть
         */
        showBookingComButton() {
            var _b;
            (_b = __classPrivateFieldGet(this, _HotelPageBase_bookingComButton, "f")) === null || _b === void 0 ? void 0 : _b.show();
        }
        /**
         * Спрятать кнопку 'искать на букинге'
         * если она есть
         */
        hideBookingComButton() {
            var _b;
            (_b = __classPrivateFieldGet(this, _HotelPageBase_bookingComButton, "f")) === null || _b === void 0 ? void 0 : _b.hide();
        }
        validateHotelResponse(response) {
            // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не
            // очень подходят (либо их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут
            // обращаться и к сайту.
            if (!response.status.success && response.data == null) {
                if (response.status.messages)
                    this.messenger.show(response.status.messages);
                return undefined;
            }
            if (response.redirect != null)
                window.location.href = response.redirect;
            return response.data;
        }
        /**
         * Бронирует варианты размещения
         * Возвращает урл бронирования, если все ок и перешли на форму бронирования
         * Или пустую строку, если не ОК
         * Или void чисто для того, что все возвраты здесь происходят из колбэк - функции, а после вызова функции отправки запроса ничего
         * не возвращаем, т.к. он асинхронный
         */
        book(hotelKey) {
            return __awaiter(this, void 0, void 0, function* () {
                let bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (bookedVariants.length <= 0)
                    return;
                const context = App.UrlParameterHelper.urlParse().find(item => item.name === 'context');
                const contextNumber = context ? context.values[0] : '';
                const bookingMode = 'bookingMode';
                if (App.app.url.routeData.action !== 'book') {
                    sessionStorage.setItem(bookingMode, 'continuous');
                }
                else if (sessionStorage.getItem(bookingMode) === 'continuous') {
                    sessionStorage.removeItem(bookingMode);
                    yield this.reservationComplete(bookedVariants, contextNumber);
                    return;
                }
                const oldBookedVariants = [...bookedVariants];
                if (!(yield this.valuate(hotelKey)))
                    return;
                // Проверим, что нет критических изменений: если есть, то покажем сообщение.
                bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                const differences = __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_checkCriticalChanges).call(_a, oldBookedVariants, bookedVariants);
                if (differences && differences.length > 0) {
                    const popupConfirm = new App.Popup({
                        onShow: () => {
                            $('.js-reservation-not-confirm').on('click', () => {
                                this.renderChangedVariants(bookedVariants);
                                this.clearReservation(hotelKey);
                                popupConfirm.hide();
                            });
                            $('.js-reservation-confirm').on('click', () => __awaiter(this, void 0, void 0, function* () {
                                yield this.reservationComplete(bookedVariants, contextNumber);
                                popupConfirm.hide();
                            }));
                        },
                    });
                    const reservationPopupContent = $(App.templates.Hotel.Popups.ReservationConfirm(differences));
                    popupConfirm.show({
                        content: reservationPopupContent,
                        modal: true,
                    });
                }
                else {
                    yield this.reservationComplete(bookedVariants, contextNumber);
                }
            });
        }
        valuate(hotelKey, promoCode) {
            return __awaiter(this, void 0, void 0, function* () {
                const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (bookedVariants.length <= 0)
                    return false;
                const context = App.UrlParameterHelper.urlParse().find(item => item.name === 'context');
                const contextNumber = context ? context.values[0] : '';
                const request = {
                    offers: bookedVariants.map(v => v.key),
                    promoCode,
                };
                const popup = new App.Popup();
                const popupGroup = popup.show({
                    group: 'main',
                    content: App.templates.Messages.Valuating({}),
                    modal: true,
                });
                const responseValidator = new App.ResponseValidator({
                    messenger: new App.PopupMessenger(popup),
                    validator: $(this.mainFilter).validate(),
                });
                this.isPromoCodeApplied = false;
                try {
                    const response = yield $.ajax({
                        url: App.app.url.route(App.HotelPageUrls.Valuate, contextNumber ? { context: contextNumber } : undefined),
                        method: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(request),
                        contentType: 'application/json; charset=utf-8',
                    });
                    if (!responseValidator.process(response))
                        return false;
                    const responseData = response.data;
                    // Проверим доступность для бронирования
                    if (!responseData.available) {
                        this.options.unavailableOfferService.addRange(responseData.unavailableOffers);
                        // TODO: костыль (очередной...)
                        responseData.unavailableOffers.forEach(v => {
                            const searchVariant = this.options.manager.variants.find(x => x.providerItemKey === v);
                            if (searchVariant) {
                                searchVariant.available = false;
                                this.markUnavailableVariants([searchVariant.key]);
                            }
                            const bookedVariant = bookedVariants.find(x => x.providerItemKey === v);
                            if (bookedVariant)
                                bookedVariant.available = false;
                        });
                        // Очистка забронированного
                        bookedVariants.forEach(v => (App.Hotel.toggleVariant(__classPrivateFieldGet(this, _HotelPageBase_container, "f"), v.key, false)));
                        this.clearReservation(hotelKey);
                        popup.show({ content: 'Предложение недоступно для бронирования' });
                        return false;
                    }
                    if (!responseData.basketVariants || responseData.basketVariants.length <= 0)
                        return false;
                    this.isPromoCodeApplied = responseData.basketVariants.some(v => v.promotions.isPromoCodeApplied);
                    // Обновим данные приложения пришедшими после резервирования данными
                    this.options.manager.offers.forEach(offer => {
                        __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_renewVariants).call(_a, offer.variants, responseData.basketVariants);
                    });
                    __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_renewVariants).call(_a, this.options.manager.variants, responseData.basketVariants);
                    __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_renewVariants).call(_a, bookedVariants, responseData.basketVariants);
                }
                catch (ex) {
                    if (!responseValidator.processError(ex))
                        throw ex;
                    return false;
                }
                finally {
                    popup.hide(popupGroup);
                }
                return true;
            });
        }
        /**
         * Завершает резервирование вариантов размещения показом формы бронирования
         * @param basketVariants - забронированные варианты
         * @param contextNumber - номер заказа
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        reservationComplete(basketVariants, contextNumber) {
            return Promise.resolve();
        }
        /**
         * Очищает зарезервированное:
         * варианты и блок с кнопкой 'Забронировать'
         */
        clearReservation(hotelKey) {
            const variants = this.options.manager.getBookedVariants(hotelKey);
            App.emptyArray(variants);
            this.renderReserveBlock(__classPrivateFieldGet(this, _HotelPageBase_container, "f"), {
                variants,
                totalPrice: 0,
                currencyCode: '',
                link: '',
            });
        }
        /**
         ** Получает правила отмены для каждого варианта размещения
         */
        getCancellationRule(event, hotelKey) {
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                const targetElement = $(event.target);
                const cancellationVariant = yield this.cancellationRuleChecker.getCancellationRule($(event.target), this.messenger);
                if (!cancellationVariant)
                    return;
                __classPrivateFieldGet(this, _HotelPageBase_instances, "m", _HotelPageBase_changeApplicationDataCancellationPolicy).call(this, [cancellationVariant]);
                if (!cancellationVariant.available) {
                    this.options.unavailableOfferService.add(cancellationVariant.key);
                    this.markUnavailableVariants([cancellationVariant.key]);
                    const block = targetElement.parents('.js-output-block');
                    const variantKey = (_b = targetElement.attr('data-variant-key')) !== null && _b !== void 0 ? _b : '';
                    const variant = this.options.manager.variants.find(item => item.key === variantKey);
                    if (variant && App.Hotel.isSelectedVariant(block, variantKey)) {
                        const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                        App.removeAllElements(bookedVariants, v => v.key === variant.key);
                        variant.selected = false;
                        App.Hotel.toggleVariant(block, variantKey, false);
                        yield this.renderReservedHotelVariants(block, hotelKey, bookedVariants);
                    }
                }
                App.CancellationRuleChecker.renderChangedCancellationPolicy(cancellationVariant, targetElement, false);
            });
        }
        markUnavailableVariants(keys) {
            for (let i = 0; i < keys.length; i++) {
                $(`.js-hotel_item-without-tour[data-id='${keys[i]}']`, __classPrivateFieldGet(this, _HotelPageBase_container, "f"))
                    .addClass('hotel-variant-unavailable');
            }
        }
        /**
         * показывает блок 'Выберите номера'
         */
        showChooseNumbersBlock() {
            __classPrivateFieldGet(this, _HotelPageBase_chooseNumbersScrollingBlock, "f").showByClass();
        }
        /**
         * скрывает блок 'Выберите номера'
         */
        hideChooseNumbersBlock() {
            __classPrivateFieldGet(this, _HotelPageBase_chooseNumbersScrollingBlock, "f").hideByClass();
        }
        getBookingLink(container) {
            var _b;
            return (_b = $(__classPrivateFieldGet(this, _HotelPageBase_reserveHotelButtonSelector, "f"), container !== null && container !== void 0 ? container : __classPrivateFieldGet(this, _HotelPageBase_container, "f")).attr('href')) !== null && _b !== void 0 ? _b : '';
        }
        reserveVariant(target, hotelKey) {
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                const block = target.parents('.js-output-block');
                const variantKey = (_b = target.attr('data-id')) !== null && _b !== void 0 ? _b : '';
                // По ключу найти в имеющихся вариантах
                const currentVariant = this.options.manager.variants.find(item => item.key === variantKey);
                if (!currentVariant || !currentVariant.available)
                    return;
                // Проверить, добавлять отмеченный вариант или удалять (уже выбран - удалять, еще не выбран - добавлять)
                const isAdd = !App.Hotel.isSelectedVariant(block, variantKey);
                // Добавляем или удаляем элемент в зависимости от признака
                const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (isAdd) {
                    // Проверить, что количество к бронированию не превышает max допустимого количества
                    const roomCount = Enumerable.from(bookedVariants).sum(s => s.quantity);
                    // Для правильной обработки случаев, когда в варианте quantity > 1 проверяем уже зарезервированные + те,
                    // что собираемся добавить(2 + 2 + 2 > 5, но 2 + 2 < 5 и позволит добавить еще 2, что не верно)
                    if (roomCount + currentVariant.quantity > this.options.maxHotelsToBook) {
                        const popup = new App.Popup();
                        const bookingLimitationContent = $(App.templates.Hotel.Popups.BookingLimitationPopup(this.options.maxHotelsToBook));
                        popup.show({ content: bookingLimitationContent });
                        return;
                    }
                    bookedVariants.push(currentVariant);
                }
                else {
                    App.removeAllElements(bookedVariants, v => v.key === currentVariant.key);
                }
                // Поставить или снять галку с чекбокса
                currentVariant.selected = isAdd;
                App.Hotel.toggleVariant(block, variantKey, isAdd);
                yield this.renderReservedHotelVariants(block, hotelKey, bookedVariants);
            });
        }
        renderReservedHotelVariants(block, hotelKey, variants) {
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                let totalPrice = 0;
                let currencyCode = '';
                if (variants && variants.length > 0) {
                    currencyCode = variants[0].currencyCode;
                    for (let i = 0; i < variants.length; i++)
                        totalPrice += (_b = yield App.CurrencyManager.exchange(variants[i].totalGrossPrice, variants[i].currencyCode, currencyCode)) !== null && _b !== void 0 ? _b : 0;
                }
                const reserved = {
                    variants,
                    totalPrice,
                    currencyCode,
                    link: __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_makeLinkForReservedVariants).call(_a, this.getHotelVariantsUrlData(), hotelKey, this.options.manager.getBookedVariants(hotelKey).map(item => item.key)),
                };
                this.renderReserveBlock(block, reserved);
            });
        }
        getHotelVariantsUrlData() {
            return new Array();
        }
        /**
         * Отрисовка блока выбора вариантов
         * @param reserved - Зарезервированные варианты для отрисовки
         */
        renderReserveBlock(container, reserved) {
            const content = $(App.templates.Hotel.ReservedHotels(reserved));
            $('.js-scrolling-reserve-block', container)
                .empty()
                .append(content)
                .showByClass();
            __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_bindScrollOnBookedClick).call(_a);
        }
        static getPriceTotals(variants) {
            var _b, _c;
            const result = {
                netPrice: 0,
                grossPrice: 0,
                price: 0,
                discount: 0,
                currencyCode: variants[0].currencyCode,
            };
            for (const variant of variants) {
                result.netPrice = App.addSafe(result.netPrice, variant.netPrice);
                result.grossPrice += variant.grossPrice;
                result.price += ((_b = variant.price) !== null && _b !== void 0 ? _b : variant.grossPrice);
                for (const extra of variant.extraGroups) {
                    for (const item of extra.items.filter(v => v.selected)) {
                        result.netPrice = App.addSafe(result.netPrice, item.netPrice);
                        result.grossPrice += item.grossPrice;
                        result.price += ((_c = item.price) !== null && _c !== void 0 ? _c : item.grossPrice);
                    }
                }
            }
            result.discount = result.grossPrice - result.price;
            return result;
        }
    }
    _a = HotelPageBase, _HotelPageBase_container = new WeakMap(), _HotelPageBase_content = new WeakMap(), _HotelPageBase_header = new WeakMap(), _HotelPageBase_mainFilter = new WeakMap(), _HotelPageBase_messenger = new WeakMap(), _HotelPageBase_bookingComButton = new WeakMap(), _HotelPageBase_emptyUrlChecker = new WeakMap(), _HotelPageBase_requiredUrlChecker = new WeakMap(), _HotelPageBase_cancellationRuleChecker = new WeakMap(), _HotelPageBase_chooseNumbersScrollingBlock = new WeakMap(), _HotelPageBase_reserveHotelButtonSelector = new WeakMap(), _HotelPageBase_instances = new WeakSet(), _HotelPageBase_changeApplicationDataCancellationPolicy = function _HotelPageBase_changeApplicationDataCancellationPolicy(responseData) {
        // обновляем данные приложения, делая нужные варианты недоступными
        this.options.manager.offers.forEach(offer => {
            __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_changeVariantsCancellationPolicy).call(_a, offer.variants, responseData);
        });
        __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_changeVariantsCancellationPolicy).call(_a, this.options.manager.variants, responseData);
    }, _HotelPageBase_changeVariantsCancellationPolicy = function _HotelPageBase_changeVariantsCancellationPolicy(variantsToUnavailable, variantFromRequest) {
        variantFromRequest.forEach(fromRequest => {
            const targetVariant = variantsToUnavailable.find(variant => variant.key === fromRequest.key);
            if (targetVariant)
                Object.assign(targetVariant, fromRequest);
        });
    }, _HotelPageBase_onBookingComButtonClick = function _HotelPageBase_onBookingComButtonClick(event) {
        event.preventDefault();
        if (!this.form.validator.form())
            return;
        __classPrivateFieldGet(this, _HotelPageBase_bookingComButton, "f").trigger("bookingComButton:click" /* Events.BookingComButtonClick */);
    }, _HotelPageBase_checkCriticalChanges = function _HotelPageBase_checkCriticalChanges(oldVariants, newVariants) {
        var _b;
        const differences = new Array();
        for (let i = 0; i < oldVariants.length; i++) {
            const oldItem = oldVariants[i];
            const newItem = newVariants.find(item => item.providerItemKey === oldItem.providerItemKey);
            if (!newItem)
                continue;
            // Проверить на совпадение
            // - питание
            if (oldItem.board !== newItem.board) {
                differences.push({
                    name: 'Питание',
                    oldValue: oldItem.board,
                    newValue: newItem.board,
                });
            }
            // - цена и валюта
            const grossPriceDifference = newItem.totalGrossPrice - oldItem.totalGrossPrice;
            if ((grossPriceDifference > 0 || grossPriceDifference < -1) || oldItem.currencyCode !== newItem.currencyCode) {
                differences.push({
                    name: 'Стоимость',
                    oldValue: App.templates.Money({ amount: oldItem.totalGrossPrice, currency: oldItem.currencyCode }),
                    newValue: App.templates.Money({ amount: newItem.totalGrossPrice, currency: newItem.currencyCode }),
                });
            }
            // - правила отмены (правила отмены может не быть, т.к. еще не было проверено => тогда не сравниваем)
            if (oldItem.cancellationInfoList) {
                const oldList = oldItem.cancellationInfoList;
                const newList = (_b = newItem.cancellationInfoList) !== null && _b !== void 0 ? _b : new Array();
                const newLength = newList.length;
                const oldLength = oldList.length;
                // Если длины массивов разные, значит правила отмены отличаются, писать в различия
                if (oldLength !== newLength) {
                    // Найдем. какой массив длинней и его крутим в цикле
                    const iteratedCancellationRules = oldLength > newLength ? oldList : newList;
                    const iteratedCancellationRulesLength = iteratedCancellationRules.length;
                    for (let index = 0; index < iteratedCancellationRulesLength; index++) {
                        // Чтобы не вылезти за пределы массива, сравниваем длинны старого, нового и прокручиваемого массива
                        differences.push({
                            name: 'Правило отмены',
                            oldValue: index < oldLength
                                ? __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_makeCancellationRuleDifferenceString).call(_a, oldList[index], oldItem.currencyCode)
                                : '',
                            newValue: index < newLength
                                ? __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_makeCancellationRuleDifferenceString).call(_a, newList[index], newItem.currencyCode)
                                : '',
                        });
                    }
                }
                else {
                    for (let index = 0; index < oldList.length; index++) {
                        // Проверяем дату и штраф правил отмены
                        if (oldList[index].date !== newList[index].date || oldList[index].price !== newList[index].price) {
                            differences.push({
                                name: 'Правило отмены',
                                oldValue: __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_makeCancellationRuleDifferenceString).call(_a, oldList[index], oldItem.currencyCode),
                                newValue: __classPrivateFieldGet(_a, _a, "m", _HotelPageBase_makeCancellationRuleDifferenceString).call(_a, newList[index], newItem.currencyCode),
                            });
                        }
                    }
                }
            }
        }
        return differences;
    }, _HotelPageBase_makeCancellationRuleDifferenceString = function _HotelPageBase_makeCancellationRuleDifferenceString(cancellationInfo, currencyCode) {
        let result = cancellationInfo.date;
        result += ` ${App.templates.Money({ amount: cancellationInfo.price, currency: currencyCode })}`;
        return result;
    }, _HotelPageBase_renewVariants = function _HotelPageBase_renewVariants(oldVariants, newVariants) {
        for (let i = 0; i < oldVariants.length; i++) {
            const newVariant = newVariants.find(v => v.providerItemKey === oldVariants[i].providerItemKey);
            if (newVariant != null)
                oldVariants[i] = Object.assign({}, oldVariants[i], newVariant);
        }
    }, _HotelPageBase_makeLinkForReservedVariants = function _HotelPageBase_makeLinkForReservedVariants(detailFilterParameters, hotelKey, variantKeуs) {
        // добавим параметр для варианта
        let urlParameters = new Array();
        urlParameters = urlParameters.concat(detailFilterParameters);
        urlParameters.push({ name: 'reserved', values: variantKeуs });
        // сформируем урл для бронирования
        return App.app.url.route(App.HotelPageUrls.Book, hotelKey, urlParameters);
    }, _HotelPageBase_bindScrollOnBookedClick = function _HotelPageBase_bindScrollOnBookedClick() {
        const reserveRoomsWrapper = $('.js-reserved-rooms');
        reserveRoomsWrapper.find('.js-my-reserved-rooms').off('click');
        reserveRoomsWrapper.find('.js-my-reserved-rooms').on('click', event => {
            var _b;
            const currentId = $(event.currentTarget).attr('data-id');
            if (!currentId)
                return;
            const hotelsBlockOffset = $('.js-hotels-without__block').find(`div[data-id="${currentId}"]`).offset();
            const needScrollTop = hotelsBlockOffset != null ? hotelsBlockOffset.top : 0;
            if (!App.isTouch)
                $('html, body').animate({ scrollTop: needScrollTop }, 300);
            else
                App.app.container.animate({ scrollTop: needScrollTop + ((_b = App.app.container.scrollTop()) !== null && _b !== void 0 ? _b : 0) }, 300);
        });
    };
    App.HotelPageBase = HotelPageBase;
})(App || (App = {}));
/// <reference path='HotelPageBase.ts' />
var App;
(function (App) {
    var _HotelBookPage_instances, _HotelBookPage_passengers, _HotelBookPage_popup, _HotelBookPage_responseValidator, _HotelBookPage_pricePresenter, _HotelBookPage_bookingForm, _HotelBookPage_bookingTemplate, _HotelBookPage_preloaderField, _HotelBookPage_activeRequest, _HotelBookPage_extraServices, _HotelBookPage_bestPriceItems, _HotelBookPage_agentBlackListComponent, _HotelBookPage_preloader_get, _HotelBookPage_reactivate, _HotelBookPage_showBookingForm, _HotelBookPage_searchHotelByIdForBookingPage, _HotelBookPage_searchHotelVariantsForBookingPage, _HotelBookPage_onBookingButtonClick, _HotelBookPage_renderBookingSection, _HotelBookPage_scrollToOutputBlock, _HotelBookPage_booking, _HotelBookPage_recalcPrice, _HotelBookPage_getDigestData, _HotelBookPage_updateDigest, _HotelBookPage_applyPromoCode, _HotelBookPage_onCheckCancellationClick, _HotelBookPage_getLateArrivalTimes, _HotelBookPage_serializeBookingForm;
    class HotelBookPage extends App.HotelPageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelBookPage_instances.add(this);
            _HotelBookPage_passengers.set(this, void 0);
            _HotelBookPage_popup.set(this, void 0);
            _HotelBookPage_responseValidator.set(this, void 0);
            _HotelBookPage_pricePresenter.set(this, void 0);
            _HotelBookPage_bookingForm.set(this, void 0);
            _HotelBookPage_bookingTemplate.set(this, void 0);
            _HotelBookPage_preloaderField.set(this, void 0);
            _HotelBookPage_activeRequest.set(this, void 0);
            _HotelBookPage_extraServices.set(this, void 0);
            _HotelBookPage_bestPriceItems.set(this, []);
            _HotelBookPage_agentBlackListComponent.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _HotelBookPage_bookingTemplate, App.templates.Hotel.BookingForm, "f");
            __classPrivateFieldSet(this, _HotelBookPage_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                var _a;
                if (action === 'interrupt') {
                    (_a = __classPrivateFieldGet(this, _HotelBookPage_activeRequest, "f")) === null || _a === void 0 ? void 0 : _a.abort();
                    inst.hide();
                }
            });
            this.root.on('click', '.js-cancellation-rules', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_onCheckCancellationClick).call(this, e); }));
        }
        start() {
            const _super = Object.create(null, {
                start: { get: () => super.start }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                yield _super.start.call(this);
                $('.js-add-mode-context-message').hide();
                this.root.showByClass();
                const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
                const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                if (bookedVariants.length > 0 && this.options.manager.hotel && this.options.manager.hotel.key === hotelKey) {
                    const context = App.UrlParameterHelper.urlParse().find(item => item.name === 'context');
                    const contextNumber = context ? context.values[0] : '';
                    yield this.reservationComplete(bookedVariants, contextNumber);
                }
                else {
                    if (this.emptyUrlChecker.isEmpty(App.UrlParameterHelper.urlParse()))
                        return;
                    this.messenger.hide();
                    // Отправить запросы для получения инфы об отеле и списка вариантов
                    __classPrivateFieldGet(this, _HotelBookPage_instances, "a", _HotelBookPage_preloader_get).show();
                    // Думаю, что в данном случае целесообразно отменить все запросы при нажатии на кнопку - все равно тут это
                    // надо для правильной отрисовки формы бронирования - оба запроса важны одинаково.
                    const operations = new Array();
                    if (bookedVariants.length <= 0)
                        operations.push(__classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_searchHotelVariantsForBookingPage).call(this, hotelKey));
                    if (!this.options.manager.hotel || this.options.manager.hotel.key !== hotelKey)
                        operations.push(__classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_searchHotelByIdForBookingPage).call(this, hotelKey));
                    yield Promise.all(operations);
                    __classPrivateFieldGet(this, _HotelBookPage_instances, "a", _HotelBookPage_preloader_get).hide();
                    yield this.book(hotelKey);
                    __classPrivateFieldSet(this, _HotelBookPage_activeRequest, undefined, "f");
                }
                this.components.push(new App.ExistingPassengers(), new App.FindTourist(), new App.PromoCodeComponent({
                    root: this.root,
                    onSubmit: (promoCode) => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_applyPromoCode).call(this, hotelKey, promoCode);
                        return this.isPromoCodeApplied;
                    }),
                    onRemove: () => __awaiter(this, void 0, void 0, function* () {
                        yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_applyPromoCode).call(this, hotelKey);
                    }),
                }), new App.BestPriceComponent({ container: this.container, getData: () => __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f") }));
                if (App.app.userSettings.isAgentInBlackList) {
                    __classPrivateFieldSet(this, _HotelBookPage_agentBlackListComponent, new App.AgentBlackListComponent({ useForm: true }), "f");
                    this.components.push(__classPrivateFieldGet(this, _HotelBookPage_agentBlackListComponent, "f"));
                }
            });
        }
        stop() {
            var _a;
            // TODO: очередной костыль - скрыть popup жжОсско
            $('.js-popup').hide();
            // Остановить активные поиски кроме hotel/search
            (_a = __classPrivateFieldGet(this, _HotelBookPage_activeRequest, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.root.hideByClass();
        }
        // Костыль: блокируем стандартное создание формы из базового класса.
        initForm() {
        }
        reservationComplete(basketVariants, contextNumber) {
            return __awaiter(this, void 0, void 0, function* () {
                // Сделаем запрос существующих туристов, если это добавление услуги в заказ
                // Делаем проверку на наличие туристов. Такое может быть, если уже переходили на фому бронирования, потом
                // вернулись на поиск, а потом опять перешли на бронирование.
                if (contextNumber && !__classPrivateFieldGet(this, _HotelBookPage_passengers, "f")) {
                    const touristsResponse = yield $.ajax({
                        url: App.app.url.route(App.HotelPageUrls.ExistingTourists, { context: contextNumber }),
                        method: 'POST',
                        dataType: 'json',
                        data: new Array(0),
                    });
                    // TODO: мне кажется, тут обработку ошибок можно пропустить - если что-то пойдет не так, просто не
                    // будет предыдущих туристов.
                    if (touristsResponse.data)
                        __classPrivateFieldSet(this, _HotelBookPage_passengers, touristsResponse.data, "f");
                    else
                        __classPrivateFieldSet(this, _HotelBookPage_passengers, undefined, "f");
                }
                const bookData = yield $.ajax({
                    url: App.app.url.route(App.HotelPageUrls.BookData),
                    method: 'POST',
                    dataType: 'json',
                    data: new Array(0),
                });
                // Отобразим форму
                if (this.options.manager.hotel) {
                    yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_showBookingForm).call(this, basketVariants, this.options.manager.hotel, contextNumber, bookData.data.allowBooking, bookData.data.agencyCountryKey);
                }
            });
        }
    }
    _HotelBookPage_passengers = new WeakMap(), _HotelBookPage_popup = new WeakMap(), _HotelBookPage_responseValidator = new WeakMap(), _HotelBookPage_pricePresenter = new WeakMap(), _HotelBookPage_bookingForm = new WeakMap(), _HotelBookPage_bookingTemplate = new WeakMap(), _HotelBookPage_preloaderField = new WeakMap(), _HotelBookPage_activeRequest = new WeakMap(), _HotelBookPage_extraServices = new WeakMap(), _HotelBookPage_bestPriceItems = new WeakMap(), _HotelBookPage_agentBlackListComponent = new WeakMap(), _HotelBookPage_instances = new WeakSet(), _HotelBookPage_preloader_get = function _HotelBookPage_preloader_get() {
        if (!__classPrivateFieldGet(this, _HotelBookPage_preloaderField, "f"))
            __classPrivateFieldSet(this, _HotelBookPage_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _HotelBookPage_preloaderField, "f");
    }, _HotelBookPage_reactivate = function _HotelBookPage_reactivate() {
        __classPrivateFieldSet(this, _HotelBookPage_bookingForm, $('form', this.root), "f");
        __classPrivateFieldGet(this, _HotelBookPage_bookingForm, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_onBookingButtonClick).call(this, e); }));
        __classPrivateFieldSet(this, _HotelBookPage_extraServices, $('.js-person-extra-service-group', __classPrivateFieldGet(this, _HotelBookPage_bookingForm, "f")), "f");
        __classPrivateFieldGet(this, _HotelBookPage_extraServices, "f").on('change', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_recalcPrice).call(this); }));
        __classPrivateFieldGet(this, _HotelBookPage_bookingForm, "f").find('.js-late-arrival-checkbox').on('change', e => {
            const checkbox = $(e.currentTarget);
            checkbox.closest('.form-item')
                .find('.js-late-arrival-time-wrap')
                .toggle(checkbox.is(':checked'));
        });
        // Дайджест
        this.components.push(new App.Digest({ container: this.root }));
        // Переключение пола М/Ж
        $('.js-form-gender', this.root).each((index, element) => {
            const icon = $('.js-form-gender-icon', element);
            const input = $('.js-form-gender-input', element);
            input.on('change', event => {
                // Чтобы в MVC контроллере пришло в виде перечисления полов, надо, чтобы value у радиобатонов полов были male и
                // female (в шаблоне)
                icon.toggleClass('_man', $(event.target).is(':checked') && $(event.target).val() === 'Male');
                icon.toggleClass('_woman', $(event.target).is(':checked') && $(event.target).val() === 'Female');
            }).filter(':checked').trigger('change');
        });
        // Инициализация дат рождения
        // TODO: пересекается с инитом датапикера в Filter. Оставила этот метод, т.к. здесь делается возможность выбора месяца и года
        const currentYear = new Date().getFullYear();
        // Человеком, который прожил самую долгую жизнь, считается француженка Жанна Кальман. Она успела отметить свой 122 день
        // рождения прежде, чем отошла в мир иной.
        const minYear = currentYear - 125;
        $('.js-form-date', this.root).each((index, element) => {
            const el = $(element);
            el
                .attr('autocomplete', 'off')
                .inputmask('date');
            el.datepicker({
                constrainInput: true,
                yearRange: `${minYear}:${currentYear}`,
            });
        });
        // Инициализация полей, содержащих данные ФИО:
        $('.js-form-fio', this.root).on('change', e => {
            const target = $(e.currentTarget);
            target.val(App.transliterateName(target.valString()));
        });
        const filter = new App.Filter({ root: __classPrivateFieldGet(this, _HotelBookPage_bookingForm, "f") });
        this.form = new App.Form({ root: filter.root });
        __classPrivateFieldSet(this, _HotelBookPage_popup, new App.Popup(), "f");
        __classPrivateFieldSet(this, _HotelBookPage_responseValidator, new App.ResponseValidatorOld({
            messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _HotelBookPage_popup, "f")),
            validator: this.form.validator,
        }), "f");
    }, _HotelBookPage_showBookingForm = function _HotelBookPage_showBookingForm(reservedVariants, hotel, context, allowBooking, agencyCountryKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (reservedVariants.length < 0)
                return;
            if (!hotel)
                return;
            // Достанем даты отъезда/заезда из урла
            const urlParameters = App.UrlParameterHelper.urlParse();
            const dateFromArr = urlParameters.find(item => item.name.toLowerCase() === 'checkin');
            const dateToArr = urlParameters.find(item => item.name.toLowerCase() === 'checkout');
            if (!dateFromArr || !dateToArr)
                return;
            const dateFrom = App.parseIsoDate(dateFromArr.values[0]);
            const dateTo = App.parseIsoDate(dateToArr.values[0]);
            // передать данные в шаблон и вставить его
            yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_renderBookingSection).call(this, reservedVariants, hotel, dateFrom, dateTo, context, allowBooking, agencyCountryKey, __classPrivateFieldGet(this, _HotelBookPage_passengers, "f"));
            this.header.html(localizer.bookingAccommodation);
            __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_scrollToOutputBlock).call(this);
        });
    }, _HotelBookPage_searchHotelByIdForBookingPage = function _HotelBookPage_searchHotelByIdForBookingPage(hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield $.ajax({
                url: App.app.url.route(App.HotelPageUrls.Hotel, hotelKey),
                method: 'POST',
                dataType: 'json',
                data: new Array(0),
            });
            const responseData = this.validateHotelResponse(response);
            if (!responseData)
                return;
            this.options.manager.hotel = responseData;
        });
    }, _HotelBookPage_searchHotelVariantsForBookingPage = function _HotelBookPage_searchHotelVariantsForBookingPage(hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const urlParameters = App.UrlParameterHelper.urlParse();
            // Найдем id забронированных вариантов
            const reservedVariants = urlParameters.find(item => item.name === 'reserved');
            if (!reservedVariants)
                return;
            const serializedForm = yield this.options.manager.getHotelVariantsRequestData(urlParameters);
            reservedVariants.values.forEach((value, index) => {
                serializedForm.push({
                    name: `variantKeys[${index}]`,
                    value,
                });
            });
            const xhr = $.ajax({
                url: App.app.url.route(App.HotelPageUrls.ReservedVariants, hotelKey),
                method: 'POST',
                dataType: 'json',
                data: serializedForm,
            });
            __classPrivateFieldSet(this, _HotelBookPage_activeRequest, xhr, "f");
            const response = yield xhr;
            if (!App.validateResponse(response, this.messenger))
                return;
            if (!response.data)
                return;
            const responseData = response.data;
            const responseVariants = (_a = responseData.variants) !== null && _a !== void 0 ? _a : new Array(0);
            // Из контроллера приходят уже отобранные по ключу варианты, но здесь все равно проверяем, что пришли все, которые есть в урле,
            // т.к.там проверки не делается
            for (let i = 0; i < reservedVariants.values.length; i++) {
                const variantId = reservedVariants.values[i];
                const currentVariant = responseVariants.find(v => v.key.toLowerCase() === variantId.toLowerCase());
                if (!currentVariant) {
                    this.messenger.show({
                        type: 1 /* MessageType.Warning */,
                        text: 'Один из вариантов размещения уже недоступен',
                    });
                    return;
                }
                currentVariant.selected = true;
                this.options.manager.addBookedVariants(hotelKey, currentVariant);
            }
        });
    }, _HotelBookPage_onBookingButtonClick = function _HotelBookPage_onBookingButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!this.form.validator.form())
                return;
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _HotelBookPage_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_booking).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_booking).call(this);
            }
        });
    }, _HotelBookPage_renderBookingSection = function _HotelBookPage_renderBookingSection(reservedVariants, hotel, dateFrom, dateTo, context, allowBooking, agencyCountryKey, existingPassengers) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: много дублирования с экскурсиями, только там один объект, а тут цикл
            const bookingVariants = reservedVariants;
            const durationInNights = App.dateDiff(dateTo, dateFrom).getTotalDays();
            bookingVariants.forEach(variant => {
                // TODO: из-за сложностей с обработкой дат в JS пока не делаю ограничения на даты в датапикере. Пихаю в поля min и max строкой
                variant.adults = new Array();
                for (let i = 0; variant.adultCount > i; i++) {
                    variant.adults.push(new App.BookingTourist(
                    // первым должен быть взрослый, все остальные могут быть кем угодно.
                    i === 0 ? this.options.adultAge : 0, this.options.maxAdultAge, dateFrom, existingPassengers));
                }
                variant.children = new Array();
                variant.childAges.forEach(childAge => {
                    variant.children.push(new App.BookingChild(this.options.minChildAge, this.options.maxChildAge, dateTo, childAge, existingPassengers));
                });
                variant.rooms = new Array();
                for (let index = 1; index <= variant.quantity; index++)
                    variant.rooms.push(index);
            });
            const data = Object.assign({
                hotel,
                variants: bookingVariants,
                hasCashBack: hotel.facilities.some(v => v.key === App.HotelFacility.CashBack),
                dateFrom,
                dateTo,
                durationInNights,
                durationInDays: durationInNights + 1,
                // если кол-во гостей больше 2х, при этом взрослых больше одного
                showWarningMessage1: bookingVariants.some(v => v.adultCount + v.childCount > 2 && v.adultCount > 1),
                // если бронируют одного взрослого + сколько угодно детей
                showWarningMessage2: bookingVariants.some(v => v.adultCount == 1 && v.childCount > 0),
                context: context ? { number: context } : undefined,
                allowBooking,
                agencyCountryKey,
                lateArrivalTimes: __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_getLateArrivalTimes).call(this, dateFrom),
            }, yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_getDigestData).call(this));
            __classPrivateFieldSet(this, _HotelBookPage_bestPriceItems, [], "f");
            if (data) {
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'hotelName', value: data.hotel.name });
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'hotelCategory', value: data.hotel.stars });
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'hotelUrl', value: data.hotel.link });
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'country', value: data.hotel.country });
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'dateFrom', value: App.formatDate(dateFrom, 'isoDate') });
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'dateTo', value: App.formatDate(dateTo, 'isoDate') });
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'price', value: App.formatNumber(data.grossPrice, 'moneyEdit') });
                __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: 'currencyCode', value: data.currencyCode });
                data.variants.map((v, i) => {
                    __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: `rooms[${i}].roomType`, value: v.room });
                    __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: `rooms[${i}].boardType`, value: v.board });
                    __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: `rooms[${i}].touristCount`, value: `${(v.adultCount + v.childCount)}` });
                    v.childAges.forEach((x, j) => __classPrivateFieldGet(this, _HotelBookPage_bestPriceItems, "f").push({ key: `rooms[${i}].childAges[${j}]`, value: `${x}` }));
                });
            }
            const content = $(__classPrivateFieldGet(this, _HotelBookPage_bookingTemplate, "f").call(this, data));
            const bestPrice = $('.js-best-price-component').detach();
            this.content.empty();
            this.content.append(content);
            __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_reactivate).call(this);
            content.find('.js-digest-footer-wrap').append(bestPrice.toggle(data.price > 0));
        });
    }, _HotelBookPage_scrollToOutputBlock = function _HotelBookPage_scrollToOutputBlock() {
        // инит блока здесь, т.к. в момент инициализации страницы элемента еще нет, он появляется при отрисовке данных
        const scrollToBlock = $('.js-room-booking', this.root);
        if (scrollToBlock) {
            const scrollOffset = scrollToBlock.offset();
            if (scrollOffset)
                window.scrollTo(scrollOffset.left, scrollOffset.top);
        }
    }, _HotelBookPage_booking = function _HotelBookPage_booking() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const formData = __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_serializeBookingForm).call(this);
            const popupGroup = __classPrivateFieldGet(this, _HotelBookPage_popup, "f").show({
                group: 'main',
                content: App.templates.Hotel.Popups.Booking({}),
                modal: true,
            });
            try {
                const response = yield $.ajax({
                    url: App.app.url.route(window.location.href),
                    method: 'POST',
                    dataType: 'json',
                    data: formData,
                });
                this.options.unavailableOfferService.addRange((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.unavailableOffers) !== null && _b !== void 0 ? _b : []);
                if (!__classPrivateFieldGet(this, _HotelBookPage_responseValidator, "f").process(response))
                    return;
                if (response.data && response.data.dialog) {
                    if (response.data.status === 0 /* MessageType.Information */) {
                        __classPrivateFieldGet(this, _HotelBookPage_popup, "f").show({
                            content: App.templates.RelatedServiceDialog(response.data.dialog),
                            modal: true,
                        });
                    }
                    else if (response.data.status === 1 /* MessageType.Warning */) {
                        __classPrivateFieldGet(this, _HotelBookPage_popup, "f").show({
                            content: App.templates.Hotel.Popups.BookingAnomalyPopup(response.data.dialog),
                            modal: true,
                        });
                    }
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelBookPage_popup, "f").hide(popupGroup);
            }
        });
    }, _HotelBookPage_recalcPrice = function _HotelBookPage_recalcPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_getDigestData).call(this, __classPrivateFieldGet(this, _HotelBookPage_bookingForm, "f").find('input').serializeArray());
            __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_updateDigest).call(this, data);
        });
    }, _HotelBookPage_getDigestData = function _HotelBookPage_getDigestData(formData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
            const bookingVariants = this.options.manager.getBookedVariants(hotelKey);
            if (formData) {
                bookingVariants.forEach((v, vi) => {
                    v.extraGroups.forEach((x, xi) => {
                        x.items.forEach(item => {
                            const extra = formData.filter(d => d.name === `form.services[${vi}].extras[${xi}]`);
                            item.selected = extra.some(e => e.value === item.code);
                        });
                    });
                });
            }
            const urlParameters = App.UrlParameterHelper.urlParse();
            const dateFromArr = urlParameters.find(item => item.name.toLowerCase() === 'checkin');
            const dateToArr = urlParameters.find(item => item.name.toLowerCase() === 'checkout');
            const dateFrom = !dateFromArr ? new Date() : App.parseIsoDate(dateFromArr.values[0]);
            const dateTo = !dateToArr ? new Date() : App.parseIsoDate(dateToArr.values[0]);
            const durationInNights = (dateFrom && dateTo) ? App.dateDiff(dateTo, dateFrom).getTotalDays() : 0;
            const hotel = (_b = this.options.manager.hotel) !== null && _b !== void 0 ? _b : {};
            const notes = new Array();
            if ([115 /* KnownCountry.Russia */, 118177 /* KnownCountry.Crimea */].includes(hotel.countryKey))
                notes.push('Стоимость фиксируется в евро и оплачивается в национальной валюте по внутреннему курсу Компании.');
            const servicePrices = Enumerable.from(bookingVariants)
                .selectMany(v => v.extraGroups)
                .selectMany(v => v.items.filter(x => x.selected), (v1, v2) => {
                var _a;
                return ({
                    name: v1.name,
                    grossPrice: v2.grossPrice,
                    price: (_a = v2.price) !== null && _a !== void 0 ? _a : v2.grossPrice,
                    currencyCode: v2.currencyCode,
                });
            })
                .groupBy(v => ({ name: v.name, currencyCode: v.currencyCode }), v => v, (k, v) => {
                const result = {
                    name: k.name,
                    isBonus: false,
                    grossPrice: 0,
                    discount: 0,
                    price: 0,
                    currencyCode: k.currencyCode,
                };
                v.forEach(x => {
                    result.grossPrice += x.grossPrice;
                    result.discount += x.grossPrice - x.price;
                    result.price += x.price;
                });
                return result;
            }, v => `${v.name}:${v.currencyCode}`)
                .toArray();
            const priceTotals = App.HotelPageBase.getPriceTotals(bookingVariants);
            let discount = priceTotals.discount;
            const bonusAmount = bookingVariants
                .map(v => v.promotions.bonusPrice.amount)
                .reduce((p, v) => p + v, 0);
            if (bonusAmount !== 0) {
                servicePrices.push({
                    name: 'Бонус',
                    isBonus: true,
                    grossPrice: -bonusAmount,
                    discount: 0,
                    price: -bonusAmount,
                    currencyCode: priceTotals.currencyCode,
                });
                discount -= bonusAmount;
            }
            return {
                hotel,
                variants: bookingVariants,
                dateFrom,
                dateTo,
                durationInNights,
                durationInDays: durationInNights + 1,
                // Для BookDigestFooter
                servicePrices,
                netPrice: priceTotals.netPrice,
                grossPrice: priceTotals.grossPrice,
                price: priceTotals.price,
                discount,
                currencyCode: priceTotals.currencyCode,
                hasDetails: false,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _HotelBookPage_pricePresenter, "f").type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                notes,
            };
        });
    }, _HotelBookPage_updateDigest = function _HotelBookPage_updateDigest(data) {
        $('.js-digest-content', this.root)
            .empty()
            .append(App.templates.Hotel.BookDigestContent(data));
        const containerFooter = $('.js-digest-footer', this.root);
        containerFooter.empty();
        const contentFooter = $(App.templates.BookDigestFooter(data));
        containerFooter.append(contentFooter);
        // Обновляем размеры дайджеста.
        $(document).trigger("digest:update" /* Events.DigestUpdate */);
    }, _HotelBookPage_applyPromoCode = function _HotelBookPage_applyPromoCode(hotelKey, promoCode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.valuate(hotelKey, promoCode))
                yield __classPrivateFieldGet(this, _HotelBookPage_instances, "m", _HotelBookPage_recalcPrice).call(this);
        });
    }, _HotelBookPage_onCheckCancellationClick = function _HotelBookPage_onCheckCancellationClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            event.preventDefault();
            event.stopPropagation();
            yield this.getCancellationRule(event, parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10));
        });
    }, _HotelBookPage_getLateArrivalTimes = function _HotelBookPage_getLateArrivalTimes(checkIn) {
        const result = new Array();
        const locale = document.documentElement.lang || 'ru-RU';
        const dateFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });
        for (let hourOffset = 14; hourOffset <= 34; hourOffset++) {
            const nextDay = hourOffset >= 24;
            const hour = hourOffset % 24;
            const time = `${hour.toString().padStart(2, '0')}:00`;
            const date = new Date(checkIn.getFullYear(), checkIn.getMonth(), checkIn.getDate() + (nextDay ? 1 : 0), 12);
            result.push({
                value: `${App.formatDate(date, 'isoDate')}T${time}:00`,
                label: nextDay ? `${time}, ${dateFormatter.format(date)}` : time,
            });
        }
        return result;
    }, _HotelBookPage_serializeBookingForm = function _HotelBookPage_serializeBookingForm() {
        const serialized = __classPrivateFieldGet(this, _HotelBookPage_bookingForm, "f").serializeArray();
        const data = new Array();
        const remarks = new Map();
        const remarkPattern = /^form\.services\[(\d+)]\.remarks$/i;
        serialized.forEach(item => {
            var _a;
            const match = item.name.match(remarkPattern);
            if (!match) {
                data.push(item);
                return;
            }
            const serviceIndex = parseInt(match[1], 10);
            const serviceRemarks = (_a = remarks.get(serviceIndex)) !== null && _a !== void 0 ? _a : [];
            serviceRemarks.push({ key: parseInt(item.value, 10) });
            remarks.set(serviceIndex, serviceRemarks);
        });
        __classPrivateFieldGet(this, _HotelBookPage_bookingForm, "f").find('.js-late-arrival-time')
            .each((_, element) => {
            var _a, _b;
            const select = $(element);
            const value = select.valString();
            if (!value)
                return;
            const serviceIndex = parseInt((_a = select.attr('data-service-index')) !== null && _a !== void 0 ? _a : '', 10);
            if (Number.isNaN(serviceIndex))
                throw new Error('Invalid late arrival service index.');
            const lateArrival = (_b = remarks.get(serviceIndex)) === null || _b === void 0 ? void 0 : _b.find(v => v.key === 15);
            if (lateArrival)
                lateArrival.value = value;
        });
        remarks.forEach((serviceRemarks, serviceIndex) => {
            serviceRemarks.forEach((remark, remarkIndex) => {
                data.push({
                    name: `form.services[${serviceIndex}].remarks[${remarkIndex}].key`,
                    value: remark.key.toString(),
                });
                if (remark.value) {
                    data.push({
                        name: `form.services[${serviceIndex}].remarks[${remarkIndex}].value`,
                        value: remark.value,
                    });
                }
            });
        });
        return data;
    };
    App.HotelBookPage = HotelBookPage;
})(App || (App = {}));
/// <reference path='HotelPageBase.ts' />
var App;
(function (App) {
    var _HotelComparePage_instances, _a, _HotelComparePage_compareBlock, _HotelComparePage_compareParameters, _HotelComparePage_hotelSliderBlock, _HotelComparePage_variantsProgressBar, _HotelComparePage_mapContainer, _HotelComparePage_printButton, _HotelComparePage_emailButton, _HotelComparePage_unfoldMap, _HotelComparePage_hotelSlider, _HotelComparePage_facilitiesPresenter, _HotelComparePage_hotels, _HotelComparePage_allCompareCountBlock, _HotelComparePage_currentCompareCountBlock, _HotelComparePage_clearCompareButton, _HotelComparePage_showAllInCompareLink, _HotelComparePage_compareDomElements, _HotelComparePage_compare, _HotelComparePage_showOnMap, _HotelComparePage_showEmailPopup, _HotelComparePage_findHotels, _HotelComparePage_variantsFind, _HotelComparePage_hotelInfoFind, _HotelComparePage_createFilter, _HotelComparePage_renderCompareParametersBlock, _HotelComparePage_renderVariantsBlock, _HotelComparePage_renderHotelsBlock, _HotelComparePage_onCompareLabelClick, _HotelComparePage_carousel, _HotelComparePage_onCheckCancellationClick, _HotelComparePage_renderMap, _HotelComparePage_sendEmail, _HotelComparePage_renewCompareCount, _HotelComparePage_renewAllToCompareLink, _HotelComparePage_clearCompare, _HotelComparePage_hideIfEmpty;
    class HotelComparePage extends App.HotelPageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelComparePage_instances.add(this);
            _HotelComparePage_compareBlock.set(this, void 0);
            _HotelComparePage_compareParameters.set(this, void 0);
            _HotelComparePage_hotelSliderBlock.set(this, void 0);
            _HotelComparePage_variantsProgressBar.set(this, void 0);
            _HotelComparePage_mapContainer.set(this, void 0);
            _HotelComparePage_printButton.set(this, void 0);
            _HotelComparePage_emailButton.set(this, void 0);
            _HotelComparePage_unfoldMap.set(this, void 0);
            _HotelComparePage_hotelSlider.set(this, void 0);
            _HotelComparePage_facilitiesPresenter.set(this, void 0);
            _HotelComparePage_hotels.set(this, void 0);
            _HotelComparePage_allCompareCountBlock.set(this, void 0);
            _HotelComparePage_currentCompareCountBlock.set(this, void 0);
            _HotelComparePage_clearCompareButton.set(this, void 0);
            _HotelComparePage_showAllInCompareLink.set(this, void 0);
            _HotelComparePage_compareDomElements.set(this, void 0);
            _HotelComparePage_compare.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _HotelComparePage_compareBlock, $('.js-hotel-compare-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_compareParameters, $('.js-compare-parameters', this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_hotelSliderBlock, $('.js-hotel-slider-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_variantsProgressBar, $('.js-progress-data-loading', this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_mapContainer, $('.js-resort-town-page'), "f");
            __classPrivateFieldSet(this, _HotelComparePage_printButton, $('.js-compare-print', this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_emailButton, $('.js-compare-email', this.root), "f");
            __classPrivateFieldGet(this, _HotelComparePage_printButton, "f").on('click', () => { window.print(); });
            __classPrivateFieldGet(this, _HotelComparePage_emailButton, "f").on('click', () => __classPrivateFieldGet(_a, _a, "m", _HotelComparePage_showEmailPopup).call(_a));
            __classPrivateFieldSet(this, _HotelComparePage_facilitiesPresenter, new App.DifferentFacilitiesPresenter(this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_allCompareCountBlock, $('.js-compare-all-count', this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_currentCompareCountBlock, $('.js-compare-current-count', this.root), "f");
            __classPrivateFieldSet(this, _HotelComparePage_clearCompareButton, $('.js-compare-clear-all', this.root), "f");
            __classPrivateFieldGet(this, _HotelComparePage_clearCompareButton, "f").on('click', () => __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_clearCompare).call(this));
            __classPrivateFieldSet(this, _HotelComparePage_showAllInCompareLink, $('.js-compare-show-all', this.root), "f");
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_findHotels).call(this); }))();
            new App.NetPricePresenter({ root: this.root }).init();
            __classPrivateFieldSet(this, _HotelComparePage_compareDomElements, new App.CompareDomElements(), "f");
            __classPrivateFieldSet(this, _HotelComparePage_compare, new App.CompareTempName(__classPrivateFieldGet(this, _HotelComparePage_compareDomElements, "f")), "f");
            __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renewCompareCount).call(this);
            __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renewAllToCompareLink).call(this);
        }
        start() {
            return Promise.resolve();
        }
        stop() {
        }
    }
    _a = HotelComparePage, _HotelComparePage_compareBlock = new WeakMap(), _HotelComparePage_compareParameters = new WeakMap(), _HotelComparePage_hotelSliderBlock = new WeakMap(), _HotelComparePage_variantsProgressBar = new WeakMap(), _HotelComparePage_mapContainer = new WeakMap(), _HotelComparePage_printButton = new WeakMap(), _HotelComparePage_emailButton = new WeakMap(), _HotelComparePage_unfoldMap = new WeakMap(), _HotelComparePage_hotelSlider = new WeakMap(), _HotelComparePage_facilitiesPresenter = new WeakMap(), _HotelComparePage_hotels = new WeakMap(), _HotelComparePage_allCompareCountBlock = new WeakMap(), _HotelComparePage_currentCompareCountBlock = new WeakMap(), _HotelComparePage_clearCompareButton = new WeakMap(), _HotelComparePage_showAllInCompareLink = new WeakMap(), _HotelComparePage_compareDomElements = new WeakMap(), _HotelComparePage_compare = new WeakMap(), _HotelComparePage_instances = new WeakSet(), _HotelComparePage_showOnMap = function _HotelComparePage_showOnMap(hotels, event) {
        event.preventDefault();
        event.stopPropagation();
        __classPrivateFieldGet(this, _HotelComparePage_unfoldMap, "f").openMap();
        const mapOffset = __classPrivateFieldGet(this, _HotelComparePage_mapContainer, "f").offset();
        if (mapOffset)
            window.scrollTo(mapOffset.left, mapOffset.top);
        const element = $(event.target);
        const dataHotelKey = element.attr('data-id');
        if (!dataHotelKey)
            return;
        const hotelKey = parseInt(dataHotelKey, 10);
        const selectedHotel = hotels.find(hotel => hotel.key === hotelKey);
        if (!selectedHotel)
            return;
        setTimeout(() => {
            __classPrivateFieldGet(this, _HotelComparePage_unfoldMap, "f").setSelection(selectedHotel.coordinate);
        }, 500);
    }, _HotelComparePage_showEmailPopup = function _HotelComparePage_showEmailPopup() {
        const popup = new App.Popup({
            onShow: () => {
                const emailForm = $('#email');
                const emailAddress = $('#Address');
                const emailName = $('#Name');
                const form = new App.Form({ root: emailForm });
                emailForm.on('submit', (e) => __awaiter(this, void 0, void 0, function* () {
                    e.preventDefault();
                    if (!form.validator.form())
                        return;
                    yield __classPrivateFieldGet(_a, _a, "m", _HotelComparePage_sendEmail).call(_a, popup, form, emailAddress.valString(), emailName.valString());
                }));
            },
        });
        const reservationPopupContent = $(App.templates.Hotel.Popups.CompareEmailForm(''));
        popup.show({ content: reservationPopupContent });
    }, _HotelComparePage_findHotels = function _HotelComparePage_findHotels() {
        return __awaiter(this, void 0, void 0, function* () {
            // Покажем прелоадер в самом начале, чтобы была минимальная задержка
            const preloader = new App.Preloader();
            preloader.show();
            // Парсить урл
            const urlParameters = App.UrlParameterHelper.urlParse();
            const hotelIdParameter = urlParameters
                .find(item => item.name === App.HotelUrlParameters.hotels);
            const dateFrom = urlParameters
                .find(item => item.name.toLowerCase() === App.HotelUrlParameters.checkin);
            const dateTo = urlParameters
                .find(item => item.name.toLowerCase() === App.HotelUrlParameters.checkout);
            const rooms = urlParameters
                .filter(item => item.name.toLowerCase() === App.HotelUrlParameters.rooms);
            if (!dateFrom || !dateTo || !rooms || !hotelIdParameter) {
                preloader.hide();
                __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_hideIfEmpty).call(this);
                return;
            }
            // Подготовим модель туристов для более удобного манипулирования
            const roomsModel = rooms.map(room => {
                const touristModel = {
                    adultCount: parseInt(room.values[0], 10),
                    childAges: new Array(),
                };
                if (Number.isNaN(touristModel.adultCount))
                    touristModel.adultCount = 0;
                // дети из параметров урла - это значения после нулевого индекса
                // (tourist - 3, 2, 4, 3 - дети - 2, 4, 3)
                // Поэтому цикл не с нулевого индекса, а с первого
                for (let i = 1; i < room.values.length; i++)
                    touristModel.childAges.push(parseInt(room.values[i], 10));
                return touristModel;
            });
            // Заполнить блок с параметрами поиска
            __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renderCompareParametersBlock).call(this, dateFrom.values[0], dateTo.values[0], roomsModel);
            // Конвертировать значения hotelId в число
            const hotelIds = hotelIdParameter.values.map(item => parseInt(item, 10));
            // Если нет значений или хотя бы одно не конвертировалось в число, выходим
            if (hotelIds.length === 0 || hotelIds.some(item => Number.isNaN(item)))
                return;
            const responseValidator = new App.ResponseValidatorOld({
                messenger: this.messenger,
            });
            const filter = __classPrivateFieldGet(_a, _a, "m", _HotelComparePage_createFilter).call(_a, dateFrom, dateTo, roomsModel, hotelIds);
            // Два запроса параллельно - все равно отели найдутся быстрее, чем варианты. Вообще надо, чтобы варианты на
            // закончились раньше отелей и отельный прелоадер не убрался, пока отелей нет
            yield __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_hotelInfoFind).call(this, hotelIds, urlParameters, responseValidator, preloader);
            yield __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_variantsFind).call(this, filter, roomsModel, responseValidator);
        });
    }, _HotelComparePage_variantsFind = function _HotelComparePage_variantsFind(filter, roomsModel, responseValidator) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _HotelComparePage_variantsProgressBar, "f").showByClass();
            try {
                const response = yield $.ajax({
                    url: App.app.url.route(App.HotelPageUrls.CompareVariants),
                    method: 'POST',
                    dataType: 'json',
                    data: filter,
                });
                if (!responseValidator.process(response))
                    return;
                // Найдем лучшие варианты и заполним модель для отрисовки
                const currencyConverter = yield App.CurrencyManager.findConverter();
                const hotelVariants = response.data.map(item => {
                    var _b, _c, _d;
                    const currencyCode = item.variants[0].currencyCode;
                    const bestVariants = App.BestVariantsSelector.select(item.variants, roomsModel);
                    let grossPrice = 0;
                    let price = 0;
                    let netPrice = 0;
                    if (bestVariants) {
                        for (const bestVariant of bestVariants) {
                            const rate = (_b = currencyConverter === null || currencyConverter === void 0 ? void 0 : currencyConverter.exchange(1, bestVariant.currencyCode, currencyCode)) !== null && _b !== void 0 ? _b : 1;
                            netPrice += ((_c = bestVariant.totalNetPrice) !== null && _c !== void 0 ? _c : 0) * rate;
                            grossPrice += bestVariant.totalGrossPrice * rate;
                            price += ((_d = bestVariant.totalPrice) !== null && _d !== void 0 ? _d : 0) * rate;
                        }
                    }
                    return {
                        hotelId: item.hotelId,
                        variants: bestVariants,
                        grossPrice,
                        netPrice,
                        price,
                        currencyCode,
                        moreThanOneVariants: bestVariants && bestVariants.length > 1,
                    };
                });
                __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renderVariantsBlock).call(this, hotelVariants);
                $('.js-cancellation-rules', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_onCheckCancellationClick).call(this, e); }));
            }
            catch (ex2) {
                if (!responseValidator.processError(ex2))
                    throw ex2;
            }
            finally {
                __classPrivateFieldGet(this, _HotelComparePage_variantsProgressBar, "f").hideByClass();
            }
        });
    }, _HotelComparePage_hotelInfoFind = function _HotelComparePage_hotelInfoFind(hotelIds, urlParameters, responseValidator, preloader) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield $.ajax({
                    url: App.app.url.route(App.HotelPageUrls.Hotels),
                    method: 'POST',
                    dataType: 'json',
                    data: { ids: hotelIds },
                });
                if (!responseValidator.process(response))
                    return;
                const hotelLinkUrlParameters = urlParameters
                    .filter(v => [App.HotelUrlParameters.checkin, App.HotelUrlParameters.checkout, App.HotelUrlParameters.rooms].includes(v.name));
                __classPrivateFieldSet(this, _HotelComparePage_hotels, response.data, "f");
                // Для вывода услуг - создать массив для всех услуг всех отелей
                const generalFacilities = new Array();
                __classPrivateFieldGet(this, _HotelComparePage_hotels, "f").forEach(hotel => {
                    hotel.link = App.app.url.route(App.HotelPageUrls.Info, hotel.key, hotelLinkUrlParameters);
                    // Сортировать их услуги
                    const orderedFacilities = Enumerable.from(hotel.facilities)
                        .orderBy(o => o.key).toArray();
                    // Добавлять в общий массив услуг услуги, которых в нем нет
                    orderedFacilities.forEach(facility => {
                        const isExist = generalFacilities.some(v => v.key === facility.key);
                        if (!isExist)
                            generalFacilities.push(facility);
                    });
                });
                // Еще один цикл по отелям для заполнения свойства услуг для отрисовки
                __classPrivateFieldGet(this, _HotelComparePage_hotels, "f").forEach(hotel => {
                    const renderFacilities = new Array();
                    generalFacilities.forEach(general => {
                        let isExist = false;
                        if (hotel.facilities.some(existing => existing.key === general.key))
                            isExist = true;
                        renderFacilities.push({
                            key: general.key,
                            isExist,
                            icon: general.icon,
                            name: general.name,
                        });
                    });
                    hotel.renderFacilities = renderFacilities;
                });
                __classPrivateFieldGet(this, _HotelComparePage_facilitiesPresenter, "f").hotels = __classPrivateFieldGet(this, _HotelComparePage_hotels, "f");
                __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renderHotelsBlock).call(this, __classPrivateFieldGet(this, _HotelComparePage_hotels, "f"));
                __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renderMap).call(this, __classPrivateFieldGet(this, _HotelComparePage_hotels, "f"));
                __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renewCompareCount).call(this);
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                preloader.hide();
            }
        });
    }, _HotelComparePage_createFilter = function _HotelComparePage_createFilter(dateFrom, dateTo, roomsModel, hotelIds) {
        const filter = new Array();
        filter.push({
            name: 'CheckinDates.Checkin',
            value: App.parseIsoDate(dateFrom.values[0]).toISOString(),
        });
        filter.push({
            name: 'CheckinDates.Checkout',
            value: App.parseIsoDate(dateTo.values[0]).toISOString(),
        });
        roomsModel.forEach((room, indexRoom) => {
            if (!room.adultCount)
                return;
            filter.push({
                name: `Rooms.Tourists[${indexRoom}].AdultCount`,
                value: room.adultCount.toString(),
            });
            // дети из параметров урла - это значения после нулевого индекса
            // (tourist - 3, 2, 4, 3 - дети - 2, 4, 3)
            room.childAges.forEach((child, indexChild) => {
                filter.push({
                    name: `Rooms.Tourists[${indexRoom}].ChildAges[${indexChild}]`,
                    value: child.toString(),
                });
            });
        });
        hotelIds.forEach((hotel, indexHotel) => {
            filter.push({
                name: `ids[${indexHotel}]`,
                value: hotel.toString(),
            });
        });
        return filter;
    }, _HotelComparePage_renderCompareParametersBlock = function _HotelComparePage_renderCompareParametersBlock(dateFrom, dateTo, rooms) {
        const dateFromAsDate = App.parseIsoDate(dateFrom);
        const dateToAsDate = App.parseIsoDate(dateTo);
        const adultsCount = Enumerable.from(rooms).sum(s => s.adultCount);
        const childrenCount = Enumerable.from(rooms).sum(s => s.childAges.length);
        const roomsCount = rooms.length;
        if (dateFrom && dateTo && rooms) {
            const children = childrenCount > 0
                ? `${childrenCount} ${App.pluralRu(childrenCount, 'ребенок', 'ребенка', 'детей')}`
                : '';
            const content = App.templates.Hotel.Compare.SearchParameters({
                dateFrom: App.formatDate(dateFromAsDate, 'shortDate'),
                dateTo: App.formatDate(dateToAsDate, 'shortDate'),
                nights: App.dateDiff(dateToAsDate, dateFromAsDate).getTotalDays(),
                rooms: `${adultsCount} ${App.pluralRu(adultsCount, 'взрослый', 'взрослых', 'взрослых')}
							${children}
							в ${roomsCount} ${App.pluralRu(roomsCount, 'номере', 'номерах', 'номерах')}`,
            });
            __classPrivateFieldGet(this, _HotelComparePage_compareParameters, "f").empty();
            __classPrivateFieldGet(this, _HotelComparePage_compareParameters, "f").append(content);
        }
    }, _HotelComparePage_renderVariantsBlock = function _HotelComparePage_renderVariantsBlock(variants) {
        if (variants) {
            variants.forEach(variant => {
                const hotelBlock = $(`a#${variant.hotelId}`, this.root);
                if (!hotelBlock)
                    return;
                const content = $(App.templates.Hotel.Compare.Variants(variant));
                hotelBlock.append(content);
            });
            App.NetPricePresenter.setVisibility(__classPrivateFieldGet(this, _HotelComparePage_compareBlock, "f"), App.NetPricePresenter.getVisibility());
        }
    }, _HotelComparePage_renderHotelsBlock = function _HotelComparePage_renderHotelsBlock(hotelCompare) {
        if (hotelCompare) {
            const content = App.templates.Hotel.Compare.Hotels(hotelCompare);
            __classPrivateFieldGet(this, _HotelComparePage_compareBlock, "f").empty();
            __classPrivateFieldGet(this, _HotelComparePage_compareBlock, "f").append(content);
        }
        $('.js-show-on-map').on('click', e => __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_showOnMap).call(this, hotelCompare, e));
        const compareLabel = __classPrivateFieldGet(this, _HotelComparePage_compareDomElements, "f").compareButtonsInitialize(this.root);
        compareLabel.on('click', e => __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_onCompareLabelClick).call(this, e));
        __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_carousel).call(this);
    }, _HotelComparePage_onCompareLabelClick = function _HotelComparePage_onCompareLabelClick(e) {
        var _b;
        e.preventDefault();
        e.stopPropagation();
        const id = (_b = $(e.currentTarget).closest('a').attr('id')) !== null && _b !== void 0 ? _b : '';
        const deletedHotel = __classPrivateFieldGet(this, _HotelComparePage_hotels, "f").find(hotel => hotel.key.toString() === id);
        if (!deletedHotel)
            return;
        // По-моему, удалять элементы из массива геморнее, в том числе по производительности, чем отфильтровать
        __classPrivateFieldSet(this, _HotelComparePage_hotels, __classPrivateFieldGet(this, _HotelComparePage_hotels, "f").filter(item => item.key.toString() !== id), "f");
        __classPrivateFieldGet(this, _HotelComparePage_unfoldMap, "f").removePoint(deletedHotel.coordinate);
        __classPrivateFieldGet(this, _HotelComparePage_hotelSlider, "f").deleteElement($(e.currentTarget));
        // Удалить текущий id из куки, т.к. здесь пока других манипуляций не требуется
        const hotelIdsInCookie = __classPrivateFieldGet(this, _HotelComparePage_compare, "f").getCompareHotelIdsFromCookie();
        const index = hotelIdsInCookie.indexOf(id);
        if (index > -1) {
            hotelIdsInCookie.splice(index, 1);
            App.Cookie.set("hotelCompare" /* KnownCookie.HotelCompare */, hotelIdsInCookie.join(','));
        }
        // Удалить текущий id из урла
        const newUrl = __classPrivateFieldGet(this, _HotelComparePage_compare, "f").makeCompareLink(App.UrlParameterHelper.urlParse(), __classPrivateFieldGet(this, _HotelComparePage_hotels, "f").map(hotel => hotel.key.toString()));
        App.UrlParameterHelper.setUrlAsIs(newUrl);
        __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renewCompareCount).call(this);
        __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renewAllToCompareLink).call(this);
        if (__classPrivateFieldGet(this, _HotelComparePage_hotels, "f").length === 0)
            __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_hideIfEmpty).call(this);
    }, _HotelComparePage_carousel = function _HotelComparePage_carousel() {
        if (__classPrivateFieldGet(this, _HotelComparePage_compareBlock, "f").length)
            __classPrivateFieldSet(this, _HotelComparePage_hotelSlider, new App.CarouselSlider({ root: __classPrivateFieldGet(this, _HotelComparePage_hotelSliderBlock, "f"), slidesNum: 4, speed: 450 }), "f");
    }, _HotelComparePage_onCheckCancellationClick = function _HotelComparePage_onCheckCancellationClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            const targetElement = $(event.target);
            const cancellationVariant = yield this.cancellationRuleChecker.getCancellationRule($(event.target), this.messenger);
            if (!cancellationVariant)
                return;
            App.CancellationRuleChecker.renderChangedCancellationPolicy(cancellationVariant, targetElement, false);
        });
    }, _HotelComparePage_renderMap = function _HotelComparePage_renderMap(hotelCompare) {
        const mapModel = {
            mapTitle: 'Отели на карте',
            showHide: true,
            mapPoints: hotelCompare.map(hotel => ({
                type: "hotel" /* MapPointType.Hotel */,
                coordinates: hotel.coordinate,
                text: hotel.name,
                selected: false,
                stars: hotel.stars,
            })),
        };
        __classPrivateFieldSet(this, _HotelComparePage_unfoldMap, new App.UnfoldMap(mapModel, false), "f");
    }, _HotelComparePage_sendEmail = function _HotelComparePage_sendEmail(popup, form, emailAddress, name) {
        return __awaiter(this, void 0, void 0, function* () {
            const email = {
                address: emailAddress,
                name,
                link: window.location.href,
            };
            const responseValidator = new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(popup),
                validator: form.validator,
                allowEmptyData: true,
            });
            try {
                const response = yield $.ajax({
                    url: App.app.url.route(App.HotelPageUrls.CompareEmail),
                    method: 'POST',
                    dataType: 'json',
                    data: email,
                });
                if (responseValidator.process(response))
                    popup.show({ content: 'Сообщение отправлено на почту' });
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
        });
    }, _HotelComparePage_renewCompareCount = function _HotelComparePage_renewCompareCount() {
        const allHotelIds = __classPrivateFieldGet(this, _HotelComparePage_compare, "f").getCompareHotelIdsFromCookie();
        __classPrivateFieldGet(this, _HotelComparePage_allCompareCountBlock, "f").text(`${allHotelIds.length} ${App.pluralRu(allHotelIds.length, 'отель', 'отеля', 'отелей')}`);
        const currentCount = __classPrivateFieldGet(this, _HotelComparePage_hotels, "f") ? __classPrivateFieldGet(this, _HotelComparePage_hotels, "f").length : 0;
        __classPrivateFieldGet(this, _HotelComparePage_currentCompareCountBlock, "f").text(`${currentCount} ${App.pluralRu(currentCount, 'отель', 'отеля', 'отелей')}`);
    }, _HotelComparePage_renewAllToCompareLink = function _HotelComparePage_renewAllToCompareLink() {
        // Получить ссылку
        const link = __classPrivateFieldGet(this, _HotelComparePage_compare, "f").makeCompareLink(App.UrlParameterHelper.urlParse(), __classPrivateFieldGet(this, _HotelComparePage_compare, "f").getCompareHotelIdsFromCookie());
        // Вставить ссылку в href
        __classPrivateFieldGet(this, _HotelComparePage_showAllInCompareLink, "f").attr('href', link);
    }, _HotelComparePage_clearCompare = function _HotelComparePage_clearCompare() {
        App.Cookie.remove("hotelCompare" /* KnownCookie.HotelCompare */);
        __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renewCompareCount).call(this);
        __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_renewAllToCompareLink).call(this);
        const newUrl = __classPrivateFieldGet(this, _HotelComparePage_compare, "f").makeCompareLink(App.UrlParameterHelper.urlParse(), new Array());
        App.UrlParameterHelper.setUrlAsIs(newUrl);
        __classPrivateFieldGet(this, _HotelComparePage_instances, "m", _HotelComparePage_hideIfEmpty).call(this);
    }, _HotelComparePage_hideIfEmpty = function _HotelComparePage_hideIfEmpty() {
        __classPrivateFieldGet(this, _HotelComparePage_hotelSliderBlock, "f").hideByClass();
        __classPrivateFieldGet(this, _HotelComparePage_mapContainer, "f").hideByClass();
        __classPrivateFieldGet(this, _HotelComparePage_facilitiesPresenter, "f").hideFacilitiesLink();
        __classPrivateFieldGet(this, _HotelComparePage_variantsProgressBar, "f").hideByClass();
        $('.js-filter-netto-link').hideByClass();
    };
    App.HotelComparePage = HotelComparePage;
})(App || (App = {}));
/// <reference path='HotelPageBase.Mobile.ts' />
var App;
(function (App) {
    var _HotelInfoPageMobile_instances, _HotelInfoPageMobile_compareBinder, _HotelInfoPageMobile_detailsSliderBlock, _HotelInfoPageMobile_scrollBookLink, _HotelInfoPageMobile_scrollToBlock, _HotelInfoPageMobile_bookScrollToWrap, _HotelInfoPageMobile_detailsBlock, _HotelInfoPageMobile_descriptionBlock, _HotelInfoPageMobile_accreditationBlock, _HotelInfoPageMobile_resultOutputBlock, _HotelInfoPageMobile_tabs, _HotelInfoPageMobile_progressDataLoading, _HotelInfoPageMobile_bookingComEmptyBlock, _HotelInfoPageMobile_hotelInTourLink, _HotelInfoPageMobile_variantsTable, _HotelInfoPageMobile_preloaderField, _HotelInfoPageMobile_mainFilter, _HotelInfoPageMobile_resultField, _HotelInfoPageMobile_hotFilterSetField, _HotelInfoPageMobile_hotFilterField, _HotelInfoPageMobile_form, _HotelInfoPageMobile_responseValidator, _HotelInfoPageMobile_searchExpirationPopup, _HotelInfoPageMobile_hotelData, _HotelInfoPageMobile_loadMap, _HotelInfoPageMobile_changes, _HotelInfoPageMobile_variantsFilters, _HotelInfoPageMobile_searchAbortController, _HotelInfoPageMobile_preloader_get, _HotelInfoPageMobile_result_get, _HotelInfoPageMobile_hotFilterSet_get, _HotelInfoPageMobile_hotFilterSet_set, _HotelInfoPageMobile_hotFilter_get, _HotelInfoPageMobile_showDetails, _HotelInfoPageMobile_makeHotelInTourLink, _HotelInfoPageMobile_infoFilterChange, _HotelInfoPageMobile_searchByKey, _HotelInfoPageMobile_pageOpenOnlyHotelInfo, _HotelInfoPageMobile_search, _HotelInfoPageMobile_applyUnavailableOffers, _HotelInfoPageMobile_setNewVariantUrl, _HotelInfoPageMobile_searchBookingCom, _HotelInfoPageMobile_cancelSearch, _HotelInfoPageMobile_resetBookingComElements, _HotelInfoPageMobile_scrollToOutputBlock, _HotelInfoPageMobile_showBookingComSearching, _HotelInfoPageMobile_hideBookingComSearching, _HotelInfoPageMobile_showBookingComEmpty, _HotelInfoPageMobile_hideBookingComEmpty, _HotelInfoPageMobile_renderHotelInfo, _HotelInfoPageMobile_renderDescription, _HotelInfoPageMobile_scrollLinkShow, _HotelInfoPageMobile_onSearchButtonClick, _HotelInfoPageMobile_onScrollLinkClick, _HotelInfoPageMobile_setBookingPosition, _HotelInfoPageMobile_onReserveVariant, _HotelInfoPageMobile_updateReserveBlock, _HotelInfoPageMobile_addControl, _HotelInfoPageMobile_onTabClick, _HotelInfoPageMobile_onActionInfoShow, _HotelInfoPageMobile_loadAnnouncement;
    class HotelInfoPageMobile extends App.HotelPageMobileBase {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelInfoPageMobile_instances.add(this);
            _HotelInfoPageMobile_compareBinder.set(this, void 0);
            _HotelInfoPageMobile_detailsSliderBlock.set(this, void 0);
            _HotelInfoPageMobile_scrollBookLink.set(this, void 0);
            _HotelInfoPageMobile_scrollToBlock.set(this, void 0);
            _HotelInfoPageMobile_bookScrollToWrap.set(this, void 0);
            _HotelInfoPageMobile_detailsBlock.set(this, void 0);
            _HotelInfoPageMobile_descriptionBlock.set(this, void 0);
            _HotelInfoPageMobile_accreditationBlock.set(this, void 0);
            _HotelInfoPageMobile_resultOutputBlock.set(this, void 0);
            _HotelInfoPageMobile_tabs.set(this, void 0);
            _HotelInfoPageMobile_progressDataLoading.set(this, void 0);
            _HotelInfoPageMobile_bookingComEmptyBlock.set(this, void 0);
            _HotelInfoPageMobile_hotelInTourLink.set(this, void 0);
            _HotelInfoPageMobile_variantsTable.set(this, void 0);
            _HotelInfoPageMobile_preloaderField.set(this, void 0);
            _HotelInfoPageMobile_mainFilter.set(this, void 0);
            _HotelInfoPageMobile_resultField.set(this, void 0);
            _HotelInfoPageMobile_hotFilterSetField.set(this, void 0);
            _HotelInfoPageMobile_hotFilterField.set(this, void 0);
            _HotelInfoPageMobile_form.set(this, void 0);
            _HotelInfoPageMobile_responseValidator.set(this, void 0);
            _HotelInfoPageMobile_searchExpirationPopup.set(this, void 0);
            _HotelInfoPageMobile_hotelData.set(this, void 0);
            _HotelInfoPageMobile_loadMap.set(this, false);
            _HotelInfoPageMobile_changes.set(this, void 0);
            _HotelInfoPageMobile_variantsFilters.set(this, void 0);
            _HotelInfoPageMobile_searchAbortController.set(this, void 0);
            if (!this.root.length)
                return;
            const checkinLimit = this.options.checkinLimit == null
                ? undefined
                : { min: App.parseIsoDate(this.options.checkinLimit.min), max: App.parseIsoDate(this.options.checkinLimit.max) };
            __classPrivateFieldSet(this, _HotelInfoPageMobile_mainFilter, new App.HotelInfoMainFilterMobile({
                datesOptions: {
                    minDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    maxDateToOffset: this.options.maxDateToOffset,
                    defaultDateFromShift: this.options.defaultDateFromShift,
                    defaultDateToOffset: this.options.defaultDateToShift - this.options.defaultDateFromShift,
                    minDateFromShift: this.options.minDateFromShift,
                    minDateToOffset: this.options.minDateToOffset,
                },
                hotelStarsValues: {
                    defaultFromValue: this.options.defaultMinCategory,
                    defaultToValue: this.options.defaultMaxCategory,
                },
                peopleOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                },
                roomsOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                    defaultRoomCountValue: this.options.defaultRoomCount,
                },
                defaultAccommodationTypesOptions: this.options.defaultAccommodationTypes,
            }), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_form, new App.Form({
                root: __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").root,
                disableStepValidation: true,
            }), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_responseValidator, new App.ResponseValidator({
                messenger: this.messenger,
                validator: __classPrivateFieldGet(this, _HotelInfoPageMobile_form, "f").validator,
            }), "f");
            // инициализация элементов
            __classPrivateFieldSet(this, _HotelInfoPageMobile_detailsSliderBlock, $('.tour-slider-and-info-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_detailsBlock, $('.js-hotel-details-block'), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_scrollBookLink, $('.js-scroll-book-link', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_scrollToBlock, __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsSliderBlock, "f"), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_descriptionBlock, $('.js-description-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_accreditationBlock, $('.js-accreditation-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_bookScrollToWrap, $('.js-book-to-scroll', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_resultOutputBlock, $('.js-output-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_variantsTable, $('.js-variants-table', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_hotelInTourLink, $('.js-hotel-in-tour-link', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_progressDataLoading, $('.js-progress-data-loading', __classPrivateFieldGet(this, _HotelInfoPageMobile_resultOutputBlock, "f")), "f");
            __classPrivateFieldSet(this, _HotelInfoPageMobile_bookingComEmptyBlock, $('.js-booking-com-empty', __classPrivateFieldGet(this, _HotelInfoPageMobile_resultOutputBlock, "f")), "f");
            this.components.push(new App.Digest({ container: this.root }), new App.ActionInfoComponent(), new App.BestPriceComponent({ container: this.container, getData: () => [] }));
            __classPrivateFieldSet(this, _HotelInfoPageMobile_changes, [], "f");
            // Показываем активные вкладки
            __classPrivateFieldSet(this, _HotelInfoPageMobile_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _HotelInfoPageMobile_tabs, "f").showActive();
            this.root.on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_onTabClick).call(this, e));
            __classPrivateFieldSet(this, _HotelInfoPageMobile_compareBinder, new App.CompareAndBookmarkBinder(this.root, this.options.maxHotelsToCompare), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_cancelSearch).call(this);
                    inst.hide();
                }
            });
            this.container.on("detailSearchButton:click" /* Events.DetailSearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
                this.clearReservation(hotelKey);
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_cancelSearch).call(this);
                yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_search).call(this);
            }));
            __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsBlock, "f")
                .on("getCancellation:click" /* Events.GetCancellationClick */, (e) => __awaiter(this, void 0, void 0, function* () { var _a; return yield this.getCancellationRule(e, parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10)); }))
                .on('click', '.js-checkbox-hotel', (e) => __awaiter(this, void 0, void 0, function* () { var _a; return yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_onReserveVariant).call(this, e, parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10)); }))
                .on("variant:book" /* Events.VariantBook */, () => __awaiter(this, void 0, void 0, function* () { var _a; return yield this.book(parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10)); }));
            // события
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом -
            // выбираем из выпадающего списка стрелками и Enter ? потом жмем Enter - и ничего.Возможно из - за того, что
            // перемудрили с контролами
            this.mainFilter.on('submit', e => __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_onSearchButtonClick).call(this, e));
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_setBookingPosition).call(this)));
            __classPrivateFieldGet(this, _HotelInfoPageMobile_scrollBookLink, "f").on('click', () => __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_onScrollLinkClick).call(this));
            // $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => this.#reservationBlockScroll()));
            this.bookingComButton.on("bookingComButton:click" /* Events.BookingComButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_searchBookingCom).call(this); }));
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_cancelSearch).call(this);
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).hideProgressDataLoader();
            });
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_onActionInfoShow).call(this, e, data); }));
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                // TODO Titov: договориться с Кириллом и заменить '#offer-sub-ids' на 'input[name="pacngo-offer-sub-ids"]'.
                const variantKeys = __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsBlock, "f").find('input[name="pacngo-offer-sub-ids"]').valString().split(';').filter(v => v !== '');
                const variants = variantKeys.map(v => this.options.manager.variants.find(x => x.key === v));
                const filters = Enumerable.from(this.getFilterSerializeArray());
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта(при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data: {
                            type: 'hotel',
                            filter: {
                                checkin: filters
                                    .where(v => v.name === 'CheckinDates.Checkin')
                                    .select(v => App.parseDate(v.value))
                                    .first(),
                                checkout: filters
                                    .where(v => v.name === 'CheckinDates.Checkout')
                                    .select(v => App.parseDate(v.value))
                                    .first(),
                            },
                            hotel: this.options.manager.hotel,
                            variants,
                        },
                    },
                }));
            });
            __classPrivateFieldSet(this, _HotelInfoPageMobile_variantsFilters, new App.FiltersMobileBase({
                root: __classPrivateFieldGet(this, _HotelInfoPageMobile_variantsTable, "f"), // $('<div/>'), // this.#variantsTable,
                onFilterChanged: v => this.onVariantCheckboxChecked(v),
            }), "f");
        }
        onVariantCheckboxChecked(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (!this.options.manager.variants.some(v => v.key === filterName) || filterName == PwStore.FILTER_ALL) {
                    //
                }
                else {
                    const block = $('.js-output-block');
                    const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
                    const variantKey = filterName;
                    const currentCheckbox = __classPrivateFieldGet(this, _HotelInfoPageMobile_variantsFilters, "f").findControl(filterName);
                    if (!currentCheckbox)
                        return;
                    const currentVariant = this.options.manager.variants.find(item => item.key === variantKey);
                    if (!currentVariant || !currentVariant.available)
                        return;
                    // Проверить, добавлять отмеченный вариант или удалять (уже выбран - удалять, еще не выбран - добавлять)
                    const isAdd = currentCheckbox.getValue(); // !Hotel.isSelectedVariant(block, variantKey);
                    // Добавляем или удаляем элемент в зависимости от признака
                    const bookedVariants = this.options.manager.getBookedVariants(hotelKey);
                    if (isAdd) {
                        // Проверить, что количество к бронированию не превышает max допустимого количества
                        const roomCount = Enumerable.from(bookedVariants).sum(s => s.quantity);
                        // Для правильной обработки случаев, когда в варианте quantity > 1 проверяем уже зарезервированные + те,
                        // что собираемся добавить(2 + 2 + 2 > 5, но 2 + 2 < 5 и позволит добавить еще 2, что не верно)
                        if (roomCount + currentVariant.quantity > this.options.maxHotelsToBook) {
                            const popup = new App.Popup();
                            const bookingLimitationContent = $(App.templates.Hotel.Popups.BookingLimitationPopup(this.options.maxHotelsToBook));
                            popup.show({ content: bookingLimitationContent });
                            return;
                        }
                        bookedVariants.push(currentVariant);
                    }
                    else {
                        App.removeAllElements(bookedVariants, v => v.key === currentVariant.key);
                    }
                    // Поставить или снять галку с чекбокса
                    currentVariant.selected = isAdd;
                    // currentCheckbox // Hotel.toggleVariant(block, variantKey, isAdd);
                    yield this.renderReservedHotelVariants(block, hotelKey, bookedVariants);
                }
            });
        }
        start() {
            const _super = Object.create(null, {
                start: { get: () => super.start }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.start.call(this);
                // Парсим урл
                const urlParameters = App.UrlParameterHelper.urlParse();
                // соответствуют данные урлу или нет
                const dataMatchUrl = !!this.options.manager.variantsKey && App.UrlParameterHelper.contains(this.options.manager.variantsKey);
                // 1. Если данные соответствуют урлу, всегда запускаем поиск заново
                // 2. Если данные не соответствуют урлу, пихаем параметры поиска в главный фильтр и запускаем поиск
                // 3. Если это страница поиска, т.е. урл типа hotel/search, то скрываем отображенное, очищаем фильтры и оставляем только форму
                const hotelId = App.app.url.routeData.id;
                const doSearch = hotelId != null && !App.UrlParameterHelper.isManual(urlParameters);
                if (!dataMatchUrl) {
                    if (doSearch) {
                        // подставить соответствующие значения урла на форму поиска
                        yield __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").setFromParameters(urlParameters);
                    }
                    else {
                        // TODO: дублирование с экскурсиями
                        if (hotelId != null) {
                            // сюда приходим, если вернулись с подбора вариантов
                            if (this.options.manager.hotel && this.options.manager.hotel.key.toString() === hotelId)
                                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_pageOpenOnlyHotelInfo).call(this);
                            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).resetDataSource();
                            // Скрыть сообщение об ошибке. оставшееся от предыдущих действий
                            this.messenger.hide();
                        }
                        else {
                            // TODO: возможно, надо будет  сделать очистку формы, но пока пусть будет так
                            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).resetDataSource();
                        }
                        yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoInfo, hotelId), this.getFilterSerializeArray());
                    }
                }
                __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsBlock, "f").showByClass();
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_scrollLinkShow).call(this);
                if (this.options.manager.variants.length <= 0)
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).resetDataSource();
                else
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_pageOpenOnlyHotelInfo).call(this);
                yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_showDetails).call(this, doSearch);
            });
        }
        stop() {
            var _a;
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_cancelSearch).call(this);
            (_a = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchExpirationPopup, "f")) === null || _a === void 0 ? void 0 : _a.cancel();
            // TODO: очередной костыль - скрыть popup жжОсско
            $('.js-popup').hide();
            __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsBlock, "f").hideByClass();
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_scrollLinkShow).call(this);
        }
        setMainFilterFromParameters(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").setFromParameters(urlParameters);
            });
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        reservationComplete(basketVariants, contextNumber) {
            const currentBookingUrl = this.getBookingLink();
            if (currentBookingUrl) {
                App.UrlParameterHelper.setUrlAsIs(currentBookingUrl);
                this.options.manager.router.dispatch('on', currentBookingUrl);
            }
            return Promise.resolve();
        }
        getHotelVariantsUrlData() {
            return __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").getUrlDataFromFilter();
        }
        getFilterSerializeArray() {
            if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f"))
                return [];
            return __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").serializeArray();
        }
    }
    _HotelInfoPageMobile_compareBinder = new WeakMap(), _HotelInfoPageMobile_detailsSliderBlock = new WeakMap(), _HotelInfoPageMobile_scrollBookLink = new WeakMap(), _HotelInfoPageMobile_scrollToBlock = new WeakMap(), _HotelInfoPageMobile_bookScrollToWrap = new WeakMap(), _HotelInfoPageMobile_detailsBlock = new WeakMap(), _HotelInfoPageMobile_descriptionBlock = new WeakMap(), _HotelInfoPageMobile_accreditationBlock = new WeakMap(), _HotelInfoPageMobile_resultOutputBlock = new WeakMap(), _HotelInfoPageMobile_tabs = new WeakMap(), _HotelInfoPageMobile_progressDataLoading = new WeakMap(), _HotelInfoPageMobile_bookingComEmptyBlock = new WeakMap(), _HotelInfoPageMobile_hotelInTourLink = new WeakMap(), _HotelInfoPageMobile_variantsTable = new WeakMap(), _HotelInfoPageMobile_preloaderField = new WeakMap(), _HotelInfoPageMobile_mainFilter = new WeakMap(), _HotelInfoPageMobile_resultField = new WeakMap(), _HotelInfoPageMobile_hotFilterSetField = new WeakMap(), _HotelInfoPageMobile_hotFilterField = new WeakMap(), _HotelInfoPageMobile_form = new WeakMap(), _HotelInfoPageMobile_responseValidator = new WeakMap(), _HotelInfoPageMobile_searchExpirationPopup = new WeakMap(), _HotelInfoPageMobile_hotelData = new WeakMap(), _HotelInfoPageMobile_loadMap = new WeakMap(), _HotelInfoPageMobile_changes = new WeakMap(), _HotelInfoPageMobile_variantsFilters = new WeakMap(), _HotelInfoPageMobile_searchAbortController = new WeakMap(), _HotelInfoPageMobile_instances = new WeakSet(), _HotelInfoPageMobile_preloader_get = function _HotelInfoPageMobile_preloader_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_preloaderField, "f"))
            __classPrivateFieldSet(this, _HotelInfoPageMobile_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _HotelInfoPageMobile_preloaderField, "f");
    }, _HotelInfoPageMobile_result_get = function _HotelInfoPageMobile_result_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_resultField, "f")) {
            __classPrivateFieldSet(this, _HotelInfoPageMobile_resultField, new App.HotelInfoResultMobile({
                hotFilter: __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get),
                mainFilter: __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f"),
                maxHotelsToCompare: this.options.maxHotelsToCompare,
                onAfterDataDraw: () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_updateReserveBlock).call(this); }),
            }), "f");
        }
        return __classPrivateFieldGet(this, _HotelInfoPageMobile_resultField, "f");
    }, _HotelInfoPageMobile_hotFilterSet_get = function _HotelInfoPageMobile_hotFilterSet_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_hotFilterSetField, "f"))
            __classPrivateFieldSet(this, _HotelInfoPageMobile_hotFilterSetField, new App.HotelHotFilterSet(), "f");
        return __classPrivateFieldGet(this, _HotelInfoPageMobile_hotFilterSetField, "f");
    }, _HotelInfoPageMobile_hotFilterSet_set = function _HotelInfoPageMobile_hotFilterSet_set(value) {
        __classPrivateFieldSet(this, _HotelInfoPageMobile_hotFilterSetField, value, "f");
    }, _HotelInfoPageMobile_hotFilter_get = function _HotelInfoPageMobile_hotFilter_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_hotFilterField, "f"))
            __classPrivateFieldSet(this, _HotelInfoPageMobile_hotFilterField, new App.HotelInfoHotFilterMobile(), "f");
        return __classPrivateFieldGet(this, _HotelInfoPageMobile_hotFilterField, "f");
    }, _HotelInfoPageMobile_showDetails = function _HotelInfoPageMobile_showDetails() {
        return __awaiter(this, arguments, void 0, function* (showVariants = true, searchBookingVariants = false) {
            var _a, _b, _c;
            const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
            this.clearReservation(hotelKey);
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_cancelSearch).call(this);
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).resetDataSource();
            // Для конструктора предложений.
            $('.js-select-offer-btn', this.root).attr('data-offer-uid', hotelKey);
            this.messenger.hide();
            const urlParameters = App.UrlParameterHelper.urlParse();
            yield __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").setFromParameters(urlParameters);
            const keys = urlParameters.map(v => v.name);
            __classPrivateFieldSet(this, _HotelInfoPageMobile_changes, __classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").concat(keys), "f");
            // сохраняем изменившийся элемент фильтра
            $('.js-hotel-detail-filter').on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_infoFilterChange).call(this, e));
            if (showVariants) {
                yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_searchByKey).call(this, hotelKey);
                // В зависимости от того, искать на букинге или нет, выбираем метод для поиска вариантов
                if (searchBookingVariants)
                    yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_searchBookingCom).call(this);
                else
                    yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_search).call(this, false);
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_scrollToOutputBlock).call(this);
            }
            else {
                (_b = __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get)) === null || _b === void 0 ? void 0 : _b.show();
                try {
                    yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_searchByKey).call(this, hotelKey);
                }
                finally {
                    (_c = __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get)) === null || _c === void 0 ? void 0 : _c.hide();
                }
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_pageOpenOnlyHotelInfo).call(this);
                yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoInfo, hotelKey));
            }
            // Если имеются активные туры с отелем, то создаём ссылку на тур.
            if (__classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").tourHotelId != null) {
                const link = __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_makeHotelInTourLink).call(this, __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").tourHotelId);
                __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelInTourLink, "f").attr('href', link);
            }
            this.renderReserveBlock(this.root, {
                variants: undefined,
                totalPrice: 0,
                currencyCode: '',
                link: '',
            });
        });
    }, _HotelInfoPageMobile_makeHotelInTourLink = function _HotelInfoPageMobile_makeHotelInTourLink(tourHotelId) {
        const urlParameters = this.getHotelVariantsUrlData();
        const checkinDateParam = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkin);
        const checkoutDateParam = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkout);
        if (checkinDateParam && checkoutDateParam) {
            const checkinDate = checkinDateParam.values[0];
            const checkoutDate = checkoutDateParam.values[0];
            const tourHotelUrlParameters = new Array();
            tourHotelUrlParameters.push({
                name: 'city',
                values: ['0'],
            }, {
                name: App.HotelUrlParameters.checkin,
                values: [`${checkinDate},${checkoutDate}`],
            }, {
                name: 'night',
                values: [App.dateDiff(App.parseIsoDate(checkoutDate), App.parseIsoDate(checkinDate)).getTotalDays().toString()],
            });
            return App.app.url.route('/tour/hotel/', tourHotelId, tourHotelUrlParameters) + '#1-search';
        }
        return '#';
    }, _HotelInfoPageMobile_infoFilterChange = function _HotelInfoPageMobile_infoFilterChange(event) {
        let name = $(event.target).closest('.filter-block').find(':input').attr('name');
        if (!name)
            return;
        name = name.toLowerCase();
        const complexPos = name.indexOf('.');
        let pname = name;
        if (complexPos >= 0)
            pname = name.substring(0, complexPos);
        // пока так, не придумала как лучше, обе даты нужны для дальнейших условий в HotelMainFilter.setMainFilter
        if (pname == 'checkindates') {
            if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").includes('checkin'))
                __classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").push('checkin');
            if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").includes('checkout'))
                __classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").push('checkout');
            return;
        }
        if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").includes(pname))
            __classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").push(pname);
    }, _HotelInfoPageMobile_searchByKey = function _HotelInfoPageMobile_searchByKey(hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield $.ajax({
                url: App.app.url.route(App.HotelPageUrls.Hotel, hotelKey),
                method: 'POST',
                dataType: 'json',
                data: new Array(0),
            });
            const responseData = this.validateHotelResponse(response);
            if (!responseData)
                return;
            __classPrivateFieldSet(this, _HotelInfoPageMobile_hotelData, responseData, "f");
            this.options.manager.hotel = App.DataTransformer.hotelInfoTransform(__classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f"));
            /* TODO
            const hotelIdsFromCookie = this.compare.getCompareHotelIdsFromCookie();
            this.compare.markAppHotelInfoToCompare(hotelIdsFromCookie, this.options.manager.hotel);
            // TODO: пока не понятно, что делать, когда страница info грузится по урлу - ведь в куках могут быть отели из разных городов и
            // стран
            // TODO: а переменная this.hotesToCompare - пустая, т.к. мы не делали полный поиск и не заполнили ее
            // Отмечаем на ярлыке все отели из куки, если нет отелей в переменной this.hotelsToCompare
            this.compare.setCompareLabel(
                this.#searchMainFilter.getUrlDataFromFilter(),
                this.hotelsToCompare.length > 0 ? this.hotelsToCompare : hotelIdsFromCookie,
            );
            */
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_renderHotelInfo).call(this, __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f"));
        });
    }, _HotelInfoPageMobile_pageOpenOnlyHotelInfo = function _HotelInfoPageMobile_pageOpenOnlyHotelInfo() {
        this.hideBookingComButton();
        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_hideBookingComSearching).call(this);
    }, _HotelInfoPageMobile_search = function _HotelInfoPageMobile_search() {
        return __awaiter(this, arguments, void 0, function* (onclick = true) {
            var _a, _b, _c, _d, _e;
            const hotelId = (_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0';
            // При нажатии кнопки поиска сбрасывать элементы поиска на букинге в исходное состояние
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_resetBookingComElements).call(this);
            (_b = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            (_c = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.cancel();
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).resetDataSource();
            __classPrivateFieldSet(this, _HotelInfoPageMobile_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).show();
            try {
                const rooms = __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.HotelPageUrls.Variants, hotelId), { body: App.createUrlSearchParams(data), signal });
                        if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    const items = (_d = response.data.variants) !== null && _d !== void 0 ? _d : new Array();
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_applyUnavailableOffers).call(this, items);
                    hasResults = items.length > 0;
                    continueSearch = response.data.continueSearch;
                    __classPrivateFieldSet(this, _HotelInfoPageMobile_instances, response.data.subFilters, "a", _HotelInfoPageMobile_hotFilterSet_set);
                    // Рассчитываем фильтр по ценам только для тех предложений, которые будем отрисовывать
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(items);
                    // Если для поиска по отелям не показываем те предложения, где нет полного набора лучших вариантов для каждого типа
                    // номеров, то для вариантов показываем все (по крайней мере, пока), но лучшие варианты не сортируем.
                    App.emptyArray(this.options.manager.variants);
                    this.options.manager.variants.push(...items);
                    // TODO: смотреть на установку урла в хистори и в переменную. Есть еще для showDetail в onBlockClick. этот метод используется
                    // в showDetail
                    const newUrl = __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_setNewVariantUrl).call(this, hotelId);
                    // Если поиск происходит после ввода адреса с параметрами, не перезаписывать историю, т.к. этот
                    // адрес итак в истории, а другие параметры удаляются, например, хотфильтры
                    // устанавливаем параметры, необходимые для работы с данными
                    const urlParameters = App.UrlParameterHelper.urlParse();
                    if (onclick) {
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).setDataManipulateParameters([{
                                name: 'sort',
                                values: ["getting" /* SortByItem.Getting */],
                            }]);
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        App.UrlParameterHelper.setUrlAsIs(newUrl);
                        yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get));
                    }
                    else {
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).setDataManipulateParameters(urlParameters);
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        // TODO: какой-то винегрет - цены выпадают из общей концепции, поэтому пихаю в них данные как-то через зад
                        yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get), dataManipulateParameters.filtering);
                    }
                    this.options.manager.variantsKey = newUrl;
                    __classPrivateFieldSet(this, _HotelInfoPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: App.app.url.route(App.HotelPageUrls.Info, hotelId),
                    }), "f");
                    if (hasResults) {
                        yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).changeDataSource(items);
                        // TODO Timoshkina: некорректное использование, данное событие должно инициироваться только в наследниках FilterBlockBase.
                        // пока так, по-другому не получается
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).root.trigger("filter:change" /* Events.FilterChange */);
                        this.showChooseNumbersBlock();
                    }
                    else {
                        this.hideChooseNumbersBlock();
                        if (!continueSearch)
                            this.messenger.show(App.Message.SearchNoVariants);
                    }
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_scrollLinkShow).call(this);
                    App.app.seo.update(response.data.seo);
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_scrollToOutputBlock).call(this);
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelInfoContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.variants, this, __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get), __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get), __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get), 
                    // Для HotelVariantsContinueSearcher это фейковый параметр.
                    [], rooms, App.app.url.route(App.HotelPageUrls.ContinueSearchVariants, hotelId), undefined, hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).hide(), signal)) || hasResults;
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_applyUnavailableOffers).call(this, this.options.manager.variants);
                }
                if (!hasResults) {
                    (_e = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchExpirationPopup, "f")) === null || _e === void 0 ? void 0 : _e.cancel();
                    this.messenger.show(App.Message.SearchNoVariantsWithLink(window.location.href, App.app.settings.tenant == 2 /* KnownTenant.PacUa */));
                }
                // Note: позволяем запускать поиск booking.com только после завершения/отмены основного поиска.
                if (this.options.allowBookingCom)
                    this.showBookingComButton();
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).hide();
            }
        });
    }, _HotelInfoPageMobile_applyUnavailableOffers = function _HotelInfoPageMobile_applyUnavailableOffers(variants) {
        const unavailableOfferKeys = this.options.unavailableOfferService.get();
        if (unavailableOfferKeys.length <= 0)
            return;
        variants.forEach(v => (v.available = !unavailableOfferKeys.includes(v.key)
            && !unavailableOfferKeys.includes(v.providerItemKey)));
        this.markUnavailableVariants(unavailableOfferKeys);
    }, _HotelInfoPageMobile_setNewVariantUrl = function _HotelInfoPageMobile_setNewVariantUrl(hotelId) {
        const mainFilterParameters = __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").getUrlDataFromFilter();
        const newParams = new Array(0);
        mainFilterParameters.forEach(v => {
            if (__classPrivateFieldGet(this, _HotelInfoPageMobile_changes, "f").includes(v.name))
                newParams.push(v);
        });
        return App.app.url.route(App.HotelPageUrls.Info, hotelId, newParams);
    }, _HotelInfoPageMobile_searchBookingCom = function _HotelInfoPageMobile_searchBookingCom() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const hotelId = App.app.url.routeData.id;
            (_a = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            __classPrivateFieldSet(this, _HotelInfoPageMobile_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).show();
            __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_showBookingComSearching).call(this);
            try {
                const rooms = __classPrivateFieldGet(this, _HotelInfoPageMobile_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.HotelPageUrls.SearchBookingComVariants, hotelId), { body: App.createUrlSearchParams(data), signal });
                        if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    const { subFilters, variants } = response.data;
                    hasResults = variants.length > 0;
                    continueSearch = response.data.continueSearch;
                    // TODO: пока не проверяю на уникальность с уже имеющимися
                    this.options.manager.variants.push(...variants);
                    // Найти лучшие варианты
                    const bestVariants = App.BestVariantsSelector.select(this.options.manager.variants, rooms);
                    // в букинге не приходят типы питания, но они определяются по-умолчанию.
                    if (subFilters) {
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).roomTypes = App.HotelInfoHotFilter.compareHotFilters(subFilters.roomTypes, __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).roomTypes);
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).boards = App.HotelInfoHotFilter.compareHotFilters(subFilters.boards, __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).boards);
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).provider = App.HotelInfoHotFilter.compareHotFilters(subFilters.provider, __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).provider);
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).offerSource = App.HotelInfoHotFilter.compareHotFilters(subFilters.offerSource, __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).offerSource);
                    }
                    // Рассчитываем фильтр по ценам только для тех предложений, которые будем отрисовывать
                    // TODO: пока фильтр по цене не делаем. Как дойду, сделать метод расчета для вариантов - выделить этот метод из
                    // метода calcMinMaxPrice
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(bestVariants !== null && bestVariants !== void 0 ? bestVariants : new Array(0));
                    const urlParameters = App.UrlParameterHelper.urlParse();
                    const filters = urlParameters.map(v => ({ name: v.name, values: v.values }));
                    yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get), filters);
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).resetDataSource();
                    yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).changeDataSource(App.DataTransformer.variantsDataTransformation(this.options.manager.variants, bestVariants), true);
                    if (((_b = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.canceled) !== false) {
                        __classPrivateFieldSet(this, _HotelInfoPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: response.data.dataExpiration,
                            url: App.app.url.route(App.HotelPageUrls.Search),
                        }), "f");
                    }
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelInfoContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.variants, this, __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get), __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilter_get), __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_hotFilterSet_get), 
                    // Для HotelVariantsContinueSearcher это фейковый параметр.
                    [], rooms, App.app.url.route(App.HotelPageUrls.ContinueSearchBookingComVariants, hotelId), undefined, hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).hide(), signal)) || hasResults;
                }
                if (!hasResults) {
                    __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_showBookingComEmpty).call(this);
                    // Note: данные могли остаться от основного поиска.
                    if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_result_get).hasData)
                        (_c = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.cancel();
                    this.messenger.show(App.Message.SearchNoVariants);
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_hideBookingComSearching).call(this);
                __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "a", _HotelInfoPageMobile_preloader_get).hide();
            }
        });
    }, _HotelInfoPageMobile_cancelSearch = function _HotelInfoPageMobile_cancelSearch() {
        var _a;
        (_a = __classPrivateFieldGet(this, _HotelInfoPageMobile_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
    }, _HotelInfoPageMobile_resetBookingComElements = function _HotelInfoPageMobile_resetBookingComElements() {
        this.showBookingComButton();
        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_hideBookingComSearching).call(this);
        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_hideBookingComEmpty).call(this);
    }, _HotelInfoPageMobile_scrollToOutputBlock = function _HotelInfoPageMobile_scrollToOutputBlock() {
        const scrollOffset = __classPrivateFieldGet(this, _HotelInfoPageMobile_scrollToBlock, "f").offset();
        if (scrollOffset)
            window.scrollTo(scrollOffset.left, scrollOffset.top);
    }, _HotelInfoPageMobile_showBookingComSearching = function _HotelInfoPageMobile_showBookingComSearching() {
        __classPrivateFieldGet(this, _HotelInfoPageMobile_progressDataLoading, "f").showByClass();
    }, _HotelInfoPageMobile_hideBookingComSearching = function _HotelInfoPageMobile_hideBookingComSearching() {
        __classPrivateFieldGet(this, _HotelInfoPageMobile_progressDataLoading, "f").hideByClass();
    }, _HotelInfoPageMobile_showBookingComEmpty = function _HotelInfoPageMobile_showBookingComEmpty() {
        __classPrivateFieldGet(this, _HotelInfoPageMobile_bookingComEmptyBlock, "f").showByClass();
    }, _HotelInfoPageMobile_hideBookingComEmpty = function _HotelInfoPageMobile_hideBookingComEmpty() {
        __classPrivateFieldGet(this, _HotelInfoPageMobile_bookingComEmptyBlock, "f").hideByClass();
    }, _HotelInfoPageMobile_renderHotelInfo = function _HotelInfoPageMobile_renderHotelInfo(hotel) {
        var _a, _b;
        hotel.isHostUa = window.location.hostname === 'www.pac.ua';
        if (hotel) {
            const content = $(App.templates.Hotel.DetailInfo_Mobile(hotel));
            __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsSliderBlock, "f").empty();
            __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsSliderBlock, "f").append(content);
        }
        this.components.push(new App.MediaGalleryMobile());
        // соц сети
        (_b = (_a = window.pac) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.SocialLikes();
        __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_renderDescription).call(this, hotel.description, hotel.descriptionNoIndex, hotel.registryNumber, hotel.registryExpireDate, hotel.registryUrl);
        __classPrivateFieldGet(this, _HotelInfoPageMobile_compareBinder, "f").bind([$('.js-tour-item', this.root)]);
        const scrollTo = $('.js-scroll-to', __classPrivateFieldGet(this, _HotelInfoPageMobile_detailsSliderBlock, "f"));
        scrollTo.on('click', e => App.scrollLinkClickHandler(e));
    }, _HotelInfoPageMobile_renderDescription = function _HotelInfoPageMobile_renderDescription(description, noIndex, registryNumber, registryExpireDate, registryUrl) {
        if (description)
            __classPrivateFieldGet(this, _HotelInfoPageMobile_descriptionBlock, "f").html(noIndex ? `<!--googleoff: all--><noindex>${description}</noindex><!--/googleoff: all-->` : description).show();
        else
            __classPrivateFieldGet(this, _HotelInfoPageMobile_descriptionBlock, "f").html('').hide();
        if (registryNumber) {
            $('.js-accreditation-block-tab').show();
            let registryValue = registryNumber;
            if (registryExpireDate)
                registryValue += ` (до ${App.formatDate(registryExpireDate, 'shortDate')})`;
            $('.js-value', __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f")).text(registryValue);
            $('.js-hotel-name', __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f")).text(__classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").name + ' ' + (__classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").stars != null ? __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").stars + '*' : ''));
            if (registryUrl) {
                $('.js-href-value', __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f")).attr('href', registryUrl);
                $('.js-href-suffix', __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f")).hide();
            }
            else {
                const currentHref = $('.js-href-value', __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f")).attr('href');
                $('.js-href-value', __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f")).attr('href', currentHref + registryNumber);
            }
            __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f").show();
        }
        else {
            __classPrivateFieldGet(this, _HotelInfoPageMobile_accreditationBlock, "f").hide();
            $('.js-accreditation-block-tab').hide();
        }
    }, _HotelInfoPageMobile_scrollLinkShow = function _HotelInfoPageMobile_scrollLinkShow() {
        var _a;
        if (((_a = __classPrivateFieldGet(this, _HotelInfoPageMobile_variantsTable, "f").height()) !== null && _a !== void 0 ? _a : 0) > 0)
            __classPrivateFieldGet(this, _HotelInfoPageMobile_scrollBookLink, "f").show();
        else
            __classPrivateFieldGet(this, _HotelInfoPageMobile_scrollBookLink, "f").hide();
    }, _HotelInfoPageMobile_onSearchButtonClick = function _HotelInfoPageMobile_onSearchButtonClick(event) {
        event.preventDefault();
        if (!this.form.validator.form())
            return;
        this.container.trigger("detailSearchButton:click" /* Events.DetailSearchButtonClick */);
    }, _HotelInfoPageMobile_onScrollLinkClick = function _HotelInfoPageMobile_onScrollLinkClick() {
        var _a;
        // TODO: дублирование кода - есть в классе TourProgrammPage.ts
        const dest = __classPrivateFieldGet(this, _HotelInfoPageMobile_variantsTable, "f");
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += ((_a = App.app.container.scrollTop()) !== null && _a !== void 0 ? _a : 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    }, _HotelInfoPageMobile_setBookingPosition = function _HotelInfoPageMobile_setBookingPosition() {
        var _a, _b, _c;
        // TODO: https://jquery.com/upgrade-guide/3.0/#breaking-change-outerwidth-or-outerheight-on-window-includes-scrollbar-width-height
        const scrolledPos = ((_a = $(window).scrollTop()) !== null && _a !== void 0 ? _a : 0) + ((_b = $(window).outerHeight()) !== null && _b !== void 0 ? _b : 0);
        const offset = __classPrivateFieldGet(this, _HotelInfoPageMobile_bookScrollToWrap, "f").offset();
        const offsetTop = (offset != null ? offset.top : 0);
        if (scrolledPos >= offsetTop && scrolledPos < offsetTop + ((_c = __classPrivateFieldGet(this, _HotelInfoPageMobile_bookScrollToWrap, "f").outerHeight()) !== null && _c !== void 0 ? _c : 0))
            __classPrivateFieldGet(this, _HotelInfoPageMobile_scrollBookLink, "f").addClass('_fixed_book');
        else
            __classPrivateFieldGet(this, _HotelInfoPageMobile_scrollBookLink, "f").removeClass('_fixed_book');
    }, _HotelInfoPageMobile_onReserveVariant = function _HotelInfoPageMobile_onReserveVariant(event, hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reserveVariant($(event.currentTarget), hotelKey);
        });
    }, _HotelInfoPageMobile_updateReserveBlock = function _HotelInfoPageMobile_updateReserveBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const key = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
            const value = this.options.manager.getBookedVariants(key);
            const block = $('.js-output-block', this.container);
            yield this.renderReservedHotelVariants(block, key, value);
            const fbToggles = __classPrivateFieldGet(this, _HotelInfoPageMobile_variantsTable, "f").find('.js-mobile-filter-toggle-block');
            fbToggles.each((i, v) => { __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_addControl).call(this, new App.MobileFilterToggleBlock(Object.assign({ root: $(v) }, {}))); });
        });
    }, _HotelInfoPageMobile_addControl = function _HotelInfoPageMobile_addControl(control) {
        if (!control || !control.created || __classPrivateFieldGet(this, _HotelInfoPageMobile_variantsFilters, "f").controls.some(c => c.name === control.name))
            return;
        control.initialize();
        __classPrivateFieldGet(this, _HotelInfoPageMobile_variantsFilters, "f").controls.push(control);
    }, _HotelInfoPageMobile_onTabClick = function _HotelInfoPageMobile_onTabClick(e) {
        if ($(e.target).attr('data-tab') === 'map' && !__classPrivateFieldGet(this, _HotelInfoPageMobile_loadMap, "f") && __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f")) {
            if (__classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").coordinate) {
                const mapModel = {
                    mapTitle: '',
                    mapPoints: [
                        {
                            type: "hotel" /* MapPointType.Hotel */,
                            coordinates: __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").coordinate,
                            text: __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").name,
                            selected: true,
                            stars: __classPrivateFieldGet(this, _HotelInfoPageMobile_hotelData, "f").stars,
                        },
                    ],
                };
                this.components.push(new App.UnfoldMap(mapModel, false));
                __classPrivateFieldSet(this, _HotelInfoPageMobile_loadMap, true, "f");
            }
        }
    }, _HotelInfoPageMobile_onActionInfoShow = function _HotelInfoPageMobile_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelInfoPageMobile_instances, "m", _HotelInfoPageMobile_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _HotelInfoPageMobile_loadAnnouncement = function _HotelInfoPageMobile_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _a;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(
                    // TODO: убрать вызов toString после апгрейда "@typescript-eslint/eslint-plugin".
                    App.app.url.route(App.HotelPageUrls.Announcement) + `?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelInfoPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.HotelInfoPageMobile = HotelInfoPageMobile;
})(App || (App = {}));
/// <reference path='HotelPageBase.ts' />
var App;
(function (App) {
    var _HotelInfoPage_instances, _HotelInfoPage_compareBinder, _HotelInfoPage_detailsSliderBlock, _HotelInfoPage_scrollBookLink, _HotelInfoPage_scrollToBlock, _HotelInfoPage_bookScrollToWrap, _HotelInfoPage_detailsBlock, _HotelInfoPage_descriptionBlock, _HotelInfoPage_accreditationBlock, _HotelInfoPage_resultOutputBlock, _HotelInfoPage_tabs, _HotelInfoPage_progressDataLoading, _HotelInfoPage_bookingComEmptyBlock, _HotelInfoPage_hotelInTourLink, _HotelInfoPage_variantsTable, _HotelInfoPage_preloaderField, _HotelInfoPage_mainFilter, _HotelInfoPage_resultField, _HotelInfoPage_hotFilterSetField, _HotelInfoPage_hotFilterField, _HotelInfoPage_form, _HotelInfoPage_responseValidator, _HotelInfoPage_searchExpirationPopup, _HotelInfoPage_hotelData, _HotelInfoPage_loadMap, _HotelInfoPage_changes, _HotelInfoPage_searchAbortController, _HotelInfoPage_preloader_get, _HotelInfoPage_result_get, _HotelInfoPage_hotFilterSet_get, _HotelInfoPage_hotFilterSet_set, _HotelInfoPage_hotFilter_get, _HotelInfoPage_showDetails, _HotelInfoPage_makeHotelInTourLink, _HotelInfoPage_infoFilterChange, _HotelInfoPage_searchByKey, _HotelInfoPage_pageOpenOnlyHotelInfo, _HotelInfoPage_search, _HotelInfoPage_applyUnavailableOffers, _HotelInfoPage_setNewVariantUrl, _HotelInfoPage_searchBookingCom, _HotelInfoPage_cancelSearch, _HotelInfoPage_resetBookingComElements, _HotelInfoPage_reservationBlockScroll, _HotelInfoPage_scrollToOutputBlock, _HotelInfoPage_showBookingComSearching, _HotelInfoPage_hideBookingComSearching, _HotelInfoPage_showBookingComEmpty, _HotelInfoPage_hideBookingComEmpty, _HotelInfoPage_renderHotelInfo, _HotelInfoPage_renderDescription, _HotelInfoPage_scrollLinkShow, _HotelInfoPage_onSearchButtonClick, _HotelInfoPage_onScrollLinkClick, _HotelInfoPage_setBookingPosition, _HotelInfoPage_onReserveVariant, _HotelInfoPage_updateReserveBlock, _HotelInfoPage_onTabClick, _HotelInfoPage_onActionInfoShow, _HotelInfoPage_loadAnnouncement;
    class HotelInfoPage extends App.HotelPageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelInfoPage_instances.add(this);
            _HotelInfoPage_compareBinder.set(this, void 0);
            _HotelInfoPage_detailsSliderBlock.set(this, void 0);
            _HotelInfoPage_scrollBookLink.set(this, void 0);
            _HotelInfoPage_scrollToBlock.set(this, void 0);
            _HotelInfoPage_bookScrollToWrap.set(this, void 0);
            _HotelInfoPage_detailsBlock.set(this, void 0);
            _HotelInfoPage_descriptionBlock.set(this, void 0);
            _HotelInfoPage_accreditationBlock.set(this, void 0);
            _HotelInfoPage_resultOutputBlock.set(this, void 0);
            _HotelInfoPage_tabs.set(this, void 0);
            _HotelInfoPage_progressDataLoading.set(this, void 0);
            _HotelInfoPage_bookingComEmptyBlock.set(this, void 0);
            _HotelInfoPage_hotelInTourLink.set(this, void 0);
            _HotelInfoPage_variantsTable.set(this, void 0);
            _HotelInfoPage_preloaderField.set(this, void 0);
            _HotelInfoPage_mainFilter.set(this, void 0);
            _HotelInfoPage_resultField.set(this, void 0);
            _HotelInfoPage_hotFilterSetField.set(this, void 0);
            _HotelInfoPage_hotFilterField.set(this, void 0);
            _HotelInfoPage_form.set(this, void 0);
            _HotelInfoPage_responseValidator.set(this, void 0);
            _HotelInfoPage_searchExpirationPopup.set(this, void 0);
            _HotelInfoPage_hotelData.set(this, void 0);
            _HotelInfoPage_loadMap.set(this, false);
            _HotelInfoPage_changes.set(this, void 0);
            _HotelInfoPage_searchAbortController.set(this, void 0);
            if (!this.root.length)
                return;
            const checkinLimit = this.options.checkinLimit == null
                ? undefined
                : { min: App.parseIsoDate(this.options.checkinLimit.min), max: App.parseIsoDate(this.options.checkinLimit.max) };
            __classPrivateFieldSet(this, _HotelInfoPage_mainFilter, new App.HotelInfoMainFilter({
                datesOptions: {
                    minDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    maxDateToOffset: this.options.maxDateToOffset,
                    defaultDateFromShift: this.options.defaultDateFromShift,
                    defaultDateToOffset: this.options.defaultDateToShift - this.options.defaultDateFromShift,
                    minDateFromShift: this.options.minDateFromShift,
                    minDateToOffset: this.options.minDateToOffset,
                },
                hotelStarsValues: {
                    defaultFromValue: this.options.defaultMinCategory,
                    defaultToValue: this.options.defaultMaxCategory,
                },
                peopleOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                },
                roomsOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                    defaultRoomCountValue: this.options.defaultRoomCount,
                },
                defaultAccommodationTypesOptions: this.options.defaultAccommodationTypes,
            }), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_form, new App.Form({
                root: __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").root,
                disableStepValidation: true,
            }), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_responseValidator, new App.ResponseValidator({
                messenger: this.messenger,
                validator: __classPrivateFieldGet(this, _HotelInfoPage_form, "f").validator,
            }), "f");
            // инициализация элементов
            __classPrivateFieldSet(this, _HotelInfoPage_detailsSliderBlock, $('.tour-slider-and-info-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_detailsBlock, $('.js-hotel-details-block'), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_scrollBookLink, $('.js-scroll-book-link', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_scrollToBlock, __classPrivateFieldGet(this, _HotelInfoPage_detailsSliderBlock, "f"), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_descriptionBlock, $('.js-description-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_accreditationBlock, $('.js-accreditation-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_bookScrollToWrap, $('.js-book-to-scroll', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_resultOutputBlock, $('.js-output-block', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_variantsTable, $('.js-variants-table', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_hotelInTourLink, $('.js-hotel-in-tour-link', this.root), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_progressDataLoading, $('.js-progress-data-loading', __classPrivateFieldGet(this, _HotelInfoPage_resultOutputBlock, "f")), "f");
            __classPrivateFieldSet(this, _HotelInfoPage_bookingComEmptyBlock, $('.js-booking-com-empty', __classPrivateFieldGet(this, _HotelInfoPage_resultOutputBlock, "f")), "f");
            this.components.push(new App.Digest({ container: this.root }), new App.ActionInfoComponent(), new App.BestPriceComponent({ container: this.container, getData: () => [] }));
            __classPrivateFieldSet(this, _HotelInfoPage_changes, [], "f");
            // Показываем активные вкладки
            __classPrivateFieldSet(this, _HotelInfoPage_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _HotelInfoPage_tabs, "f").showActive();
            this.root.on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_onTabClick).call(this, e));
            __classPrivateFieldSet(this, _HotelInfoPage_compareBinder, new App.CompareAndBookmarkBinder(this.root, this.options.maxHotelsToCompare), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_cancelSearch).call(this);
                    inst.hide();
                }
            });
            this.container.on("detailSearchButton:click" /* Events.DetailSearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
                this.clearReservation(hotelKey);
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_cancelSearch).call(this);
                yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_search).call(this);
            }));
            __classPrivateFieldGet(this, _HotelInfoPage_detailsBlock, "f")
                .on("getCancellation:click" /* Events.GetCancellationClick */, (e) => __awaiter(this, void 0, void 0, function* () { var _a; return yield this.getCancellationRule(e, parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10)); }))
                .on('click', '.js-checkbox-hotel', (e) => __awaiter(this, void 0, void 0, function* () { var _a; return yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_onReserveVariant).call(this, e, parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10)); }))
                .on("variant:book" /* Events.VariantBook */, () => __awaiter(this, void 0, void 0, function* () { var _a; return yield this.book(parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10)); }));
            // события
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом -
            // выбираем из выпадающего списка стрелками и Enter ? потом жмем Enter - и ничего.Возможно из - за того, что
            // перемудрили с контролами
            this.mainFilter.on('submit', e => __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_onSearchButtonClick).call(this, e));
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_setBookingPosition).call(this)));
            __classPrivateFieldGet(this, _HotelInfoPage_scrollBookLink, "f").on('click', () => __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_onScrollLinkClick).call(this));
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_reservationBlockScroll).call(this)));
            this.bookingComButton.on("bookingComButton:click" /* Events.BookingComButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_searchBookingCom).call(this); }));
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_cancelSearch).call(this);
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).hideProgressDataLoader();
            });
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_onActionInfoShow).call(this, e, data); }));
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                // TODO Titov: договориться с Кириллом и заменить '#offer-sub-ids' на 'input[name="pacngo-offer-sub-ids"]'.
                const variantKeys = __classPrivateFieldGet(this, _HotelInfoPage_detailsBlock, "f").find('input[name="pacngo-offer-sub-ids"]').valString().split(';').filter(v => v !== '');
                const variants = variantKeys.map(v => this.options.manager.variants.find(x => x.key === v));
                const filters = Enumerable.from(this.getFilterSerializeArray());
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта(при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data: {
                            type: 'hotel',
                            filter: {
                                checkin: filters
                                    .where(v => v.name === 'CheckinDates.Checkin')
                                    .select(v => App.parseDate(v.value))
                                    .first(),
                                checkout: filters
                                    .where(v => v.name === 'CheckinDates.Checkout')
                                    .select(v => App.parseDate(v.value))
                                    .first(),
                            },
                            hotel: this.options.manager.hotel,
                            variants,
                        },
                    },
                }));
            });
        }
        start() {
            const _super = Object.create(null, {
                start: { get: () => super.start }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.start.call(this);
                // Парсим урл
                const urlParameters = App.UrlParameterHelper.urlParse();
                // соответствуют данные урлу или нет
                const dataMatchUrl = !!this.options.manager.variantsKey && App.UrlParameterHelper.contains(this.options.manager.variantsKey);
                // 1. Если данные соответствуют урлу, всегда запускаем поиск заново
                // 2. Если данные не соответствуют урлу, пихаем параметры поиска в главный фильтр и запускаем поиск
                // 3. Если это страница поиска, т.е. урл типа hotel/search, то скрываем отображенное, очищаем фильтры и оставляем только форму
                const hotelId = App.app.url.routeData.id;
                const doSearch = hotelId != null && !App.UrlParameterHelper.isManual(urlParameters);
                if (!dataMatchUrl) {
                    if (doSearch) {
                        // подставить соответствующие значения урла на форму поиска
                        yield __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").setFromParameters(urlParameters);
                    }
                    else {
                        // TODO: дублирование с экскурсиями
                        if (hotelId != null) {
                            // сюда приходим, если вернулись с подбора вариантов
                            if (this.options.manager.hotel && this.options.manager.hotel.key.toString() === hotelId)
                                __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_pageOpenOnlyHotelInfo).call(this);
                            __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).resetDataSource();
                            // Скрыть сообщение об ошибке. оставшееся от предыдущих действий
                            this.messenger.hide();
                        }
                        else {
                            // TODO: возможно, надо будет  сделать очистку формы, но пока пусть будет так
                            __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).resetDataSource();
                        }
                        yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoInfo, hotelId), this.getFilterSerializeArray());
                    }
                }
                __classPrivateFieldGet(this, _HotelInfoPage_detailsBlock, "f").showByClass();
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_scrollLinkShow).call(this);
                if (this.options.manager.variants.length <= 0)
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).resetDataSource();
                else
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_pageOpenOnlyHotelInfo).call(this);
                yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_showDetails).call(this, doSearch);
            });
        }
        stop() {
            var _a;
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_cancelSearch).call(this);
            (_a = __classPrivateFieldGet(this, _HotelInfoPage_searchExpirationPopup, "f")) === null || _a === void 0 ? void 0 : _a.cancel();
            // TODO: очередной костыль - скрыть popup жжОсско
            $('.js-popup').hide();
            __classPrivateFieldGet(this, _HotelInfoPage_detailsBlock, "f").hideByClass();
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_scrollLinkShow).call(this);
        }
        setMainFilterFromParameters(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").setFromParameters(urlParameters);
            });
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        reservationComplete(basketVariants, contextNumber) {
            const currentBookingUrl = this.getBookingLink();
            if (currentBookingUrl) {
                App.UrlParameterHelper.setUrlAsIs(currentBookingUrl);
                this.options.manager.router.dispatch('on', currentBookingUrl);
            }
            return Promise.resolve();
        }
        getHotelVariantsUrlData() {
            return __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").getUrlDataFromFilter();
        }
    }
    _HotelInfoPage_compareBinder = new WeakMap(), _HotelInfoPage_detailsSliderBlock = new WeakMap(), _HotelInfoPage_scrollBookLink = new WeakMap(), _HotelInfoPage_scrollToBlock = new WeakMap(), _HotelInfoPage_bookScrollToWrap = new WeakMap(), _HotelInfoPage_detailsBlock = new WeakMap(), _HotelInfoPage_descriptionBlock = new WeakMap(), _HotelInfoPage_accreditationBlock = new WeakMap(), _HotelInfoPage_resultOutputBlock = new WeakMap(), _HotelInfoPage_tabs = new WeakMap(), _HotelInfoPage_progressDataLoading = new WeakMap(), _HotelInfoPage_bookingComEmptyBlock = new WeakMap(), _HotelInfoPage_hotelInTourLink = new WeakMap(), _HotelInfoPage_variantsTable = new WeakMap(), _HotelInfoPage_preloaderField = new WeakMap(), _HotelInfoPage_mainFilter = new WeakMap(), _HotelInfoPage_resultField = new WeakMap(), _HotelInfoPage_hotFilterSetField = new WeakMap(), _HotelInfoPage_hotFilterField = new WeakMap(), _HotelInfoPage_form = new WeakMap(), _HotelInfoPage_responseValidator = new WeakMap(), _HotelInfoPage_searchExpirationPopup = new WeakMap(), _HotelInfoPage_hotelData = new WeakMap(), _HotelInfoPage_loadMap = new WeakMap(), _HotelInfoPage_changes = new WeakMap(), _HotelInfoPage_searchAbortController = new WeakMap(), _HotelInfoPage_instances = new WeakSet(), _HotelInfoPage_preloader_get = function _HotelInfoPage_preloader_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPage_preloaderField, "f"))
            __classPrivateFieldSet(this, _HotelInfoPage_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _HotelInfoPage_preloaderField, "f");
    }, _HotelInfoPage_result_get = function _HotelInfoPage_result_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPage_resultField, "f")) {
            __classPrivateFieldSet(this, _HotelInfoPage_resultField, new App.HotelInfoResult({
                hotFilter: __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get),
                mainFilter: __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f"),
                maxHotelsToCompare: this.options.maxHotelsToCompare,
                onAfterDataDraw: () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_updateReserveBlock).call(this); }),
            }), "f");
        }
        return __classPrivateFieldGet(this, _HotelInfoPage_resultField, "f");
    }, _HotelInfoPage_hotFilterSet_get = function _HotelInfoPage_hotFilterSet_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPage_hotFilterSetField, "f"))
            __classPrivateFieldSet(this, _HotelInfoPage_hotFilterSetField, new App.HotelHotFilterSet(), "f");
        return __classPrivateFieldGet(this, _HotelInfoPage_hotFilterSetField, "f");
    }, _HotelInfoPage_hotFilterSet_set = function _HotelInfoPage_hotFilterSet_set(value) {
        __classPrivateFieldSet(this, _HotelInfoPage_hotFilterSetField, value, "f");
    }, _HotelInfoPage_hotFilter_get = function _HotelInfoPage_hotFilter_get() {
        if (!__classPrivateFieldGet(this, _HotelInfoPage_hotFilterField, "f"))
            __classPrivateFieldSet(this, _HotelInfoPage_hotFilterField, new App.HotelInfoHotFilter(), "f");
        return __classPrivateFieldGet(this, _HotelInfoPage_hotFilterField, "f");
    }, _HotelInfoPage_showDetails = function _HotelInfoPage_showDetails() {
        return __awaiter(this, arguments, void 0, function* (showVariants = true, searchBookingVariants = false) {
            var _a, _b, _c;
            const hotelKey = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
            this.clearReservation(hotelKey);
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_cancelSearch).call(this);
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).resetDataSource();
            // Для конструктора предложений.
            $('.js-select-offer-btn', this.root).attr('data-offer-uid', hotelKey);
            this.messenger.hide();
            const urlParameters = App.UrlParameterHelper.urlParse();
            yield __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").setFromParameters(urlParameters);
            const keys = urlParameters.map(v => v.name);
            __classPrivateFieldSet(this, _HotelInfoPage_changes, __classPrivateFieldGet(this, _HotelInfoPage_changes, "f").concat(keys), "f");
            // сохраняем изменившийся элемент фильтра
            $('.js-hotel-detail-filter').on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_infoFilterChange).call(this, e));
            if (showVariants) {
                yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_searchByKey).call(this, hotelKey);
                // В зависимости от того, искать на букинге или нет, выбираем метод для поиска вариантов
                if (searchBookingVariants)
                    yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_searchBookingCom).call(this);
                else
                    yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_search).call(this, false);
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_scrollToOutputBlock).call(this);
            }
            else {
                (_b = __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get)) === null || _b === void 0 ? void 0 : _b.show();
                try {
                    yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_searchByKey).call(this, hotelKey);
                }
                finally {
                    (_c = __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get)) === null || _c === void 0 ? void 0 : _c.hide();
                }
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_pageOpenOnlyHotelInfo).call(this);
                yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoInfo, hotelKey));
            }
            // Если имеются активные туры с отелем, то создаём ссылку на тур.
            if (__classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").tourHotelId != null) {
                const link = __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_makeHotelInTourLink).call(this, __classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").tourHotelId);
                __classPrivateFieldGet(this, _HotelInfoPage_hotelInTourLink, "f").attr('href', link);
            }
            this.renderReserveBlock(this.root, {
                variants: undefined,
                totalPrice: 0,
                currencyCode: '',
                link: '',
            });
        });
    }, _HotelInfoPage_makeHotelInTourLink = function _HotelInfoPage_makeHotelInTourLink(tourHotelId) {
        const urlParameters = this.getHotelVariantsUrlData();
        const checkinDateParam = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkin);
        const checkoutDateParam = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkout);
        if (checkinDateParam && checkoutDateParam) {
            const checkinDate = checkinDateParam.values[0];
            const checkoutDate = checkoutDateParam.values[0];
            const tourHotelUrlParameters = new Array();
            tourHotelUrlParameters.push({
                name: 'city',
                values: ['0'],
            }, {
                name: App.HotelUrlParameters.checkin,
                values: [`${checkinDate},${checkoutDate}`],
            }, {
                name: 'night',
                values: [App.dateDiff(App.parseIsoDate(checkoutDate), App.parseIsoDate(checkinDate)).getTotalDays().toString()],
            });
            return App.app.url.route('/tour/hotel/', tourHotelId, tourHotelUrlParameters) + '#1-search';
        }
        return '#';
    }, _HotelInfoPage_infoFilterChange = function _HotelInfoPage_infoFilterChange(event) {
        let name = $(event.target).closest('.filter-block').find(':input').attr('name');
        if (!name)
            return;
        name = name.toLowerCase();
        const complexPos = name.indexOf('.');
        let pname = name;
        if (complexPos >= 0)
            pname = name.substring(0, complexPos);
        // пока так, не придумала как лучше, обе даты нужны для дальнейших условий в HotelMainFilter.setMainFilter
        if (pname == 'checkindates') {
            if (!__classPrivateFieldGet(this, _HotelInfoPage_changes, "f").includes('checkin'))
                __classPrivateFieldGet(this, _HotelInfoPage_changes, "f").push('checkin');
            if (!__classPrivateFieldGet(this, _HotelInfoPage_changes, "f").includes('checkout'))
                __classPrivateFieldGet(this, _HotelInfoPage_changes, "f").push('checkout');
            return;
        }
        if (!__classPrivateFieldGet(this, _HotelInfoPage_changes, "f").includes(pname))
            __classPrivateFieldGet(this, _HotelInfoPage_changes, "f").push(pname);
    }, _HotelInfoPage_searchByKey = function _HotelInfoPage_searchByKey(hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield $.ajax({
                url: App.app.url.route(App.HotelPageUrls.Hotel, hotelKey),
                method: 'POST',
                dataType: 'json',
                data: new Array(0),
            });
            const responseData = this.validateHotelResponse(response);
            if (!responseData)
                return;
            __classPrivateFieldSet(this, _HotelInfoPage_hotelData, responseData, "f");
            this.options.manager.hotel = App.DataTransformer.hotelInfoTransform(__classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f"));
            /* TODO
            const hotelIdsFromCookie = this.compare.getCompareHotelIdsFromCookie();
            this.compare.markAppHotelInfoToCompare(hotelIdsFromCookie, this.options.manager.hotel);
            // TODO: пока не понятно, что делать, когда страница info грузится по урлу - ведь в куках могут быть отели из разных городов и
            // стран
            // TODO: а переменная this.hotesToCompare - пустая, т.к. мы не делали полный поиск и не заполнили ее
            // Отмечаем на ярлыке все отели из куки, если нет отелей в переменной this.hotelsToCompare
            this.compare.setCompareLabel(
                this.#searchMainFilter.getUrlDataFromFilter(),
                this.hotelsToCompare.length > 0 ? this.hotelsToCompare : hotelIdsFromCookie,
            );
            */
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_renderHotelInfo).call(this, __classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f"));
        });
    }, _HotelInfoPage_pageOpenOnlyHotelInfo = function _HotelInfoPage_pageOpenOnlyHotelInfo() {
        this.hideBookingComButton();
        __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_hideBookingComSearching).call(this);
    }, _HotelInfoPage_search = function _HotelInfoPage_search() {
        return __awaiter(this, arguments, void 0, function* (onclick = true) {
            var _a, _b, _c, _d, _e;
            const hotelId = (_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0';
            // При нажатии кнопки поиска сбрасывать элементы поиска на букинге в исходное состояние
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_resetBookingComElements).call(this);
            (_b = __classPrivateFieldGet(this, _HotelInfoPage_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            (_c = __classPrivateFieldGet(this, _HotelInfoPage_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.cancel();
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).resetDataSource();
            __classPrivateFieldSet(this, _HotelInfoPage_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelInfoPage_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).show();
            try {
                const rooms = __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.HotelPageUrls.Variants, hotelId), { body: App.createUrlSearchParams(data), signal });
                        if (!__classPrivateFieldGet(this, _HotelInfoPage_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    const items = (_d = response.data.variants) !== null && _d !== void 0 ? _d : new Array();
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_applyUnavailableOffers).call(this, items);
                    // Определение наличия результатов поиска
                    hasResults = items.length > 0;
                    continueSearch = response.data.continueSearch;
                    __classPrivateFieldSet(this, _HotelInfoPage_instances, response.data.subFilters, "a", _HotelInfoPage_hotFilterSet_set);
                    // Рассчитываем фильтр по ценам только для тех предложений, которые будем отрисовывать
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(items);
                    // Если для поиска по отелям не показываем те предложения, где нет полного набора лучших вариантов для каждого типа
                    // номеров, то для вариантов показываем все (по крайней мере, пока), но лучшие варианты не сортируем.
                    App.emptyArray(this.options.manager.variants);
                    this.options.manager.variants.push(...items);
                    // TODO: смотреть на установку урла в хистори и в переменную. Есть еще для showDetail в onBlockClick. этот метод используется
                    // в showDetail
                    const newUrl = __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_setNewVariantUrl).call(this, hotelId);
                    // Если поиск происходит после ввода адреса с параметрами, не перезаписывать историю, т.к. этот
                    // адрес итак в истории, а другие параметры удаляются, например, хотфильтры
                    // устанавливаем параметры, необходимые для работы с данными
                    const urlParameters = App.UrlParameterHelper.urlParse();
                    if (onclick) {
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).setDataManipulateParameters([{
                                name: 'sort',
                                values: ["getting" /* SortByItem.Getting */],
                            }]);
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        App.UrlParameterHelper.setUrlAsIs(newUrl);
                        yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get));
                    }
                    else {
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).setDataManipulateParameters(urlParameters);
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        // TODO: какой-то винегрет - цены выпадают из общей концепции, поэтому пихаю в них данные как-то через зад
                        yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get), dataManipulateParameters.filtering);
                    }
                    this.options.manager.variantsKey = newUrl;
                    __classPrivateFieldSet(this, _HotelInfoPage_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: App.app.url.route(App.HotelPageUrls.Info, hotelId),
                    }), "f");
                    if (hasResults) {
                        yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).changeDataSource(items);
                        // TODO Timoshkina: некорректное использование, данное событие должно инициироваться только в наследниках FilterBlockBase.
                        // пока так, по-другому не получается
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).root.trigger("filter:change" /* Events.FilterChange */);
                        this.showChooseNumbersBlock();
                    }
                    else {
                        this.hideChooseNumbersBlock();
                        if (!continueSearch)
                            this.messenger.show(App.Message.SearchNoVariants);
                    }
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_scrollLinkShow).call(this);
                    App.app.seo.update(response.data.seo);
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_scrollToOutputBlock).call(this);
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelInfoContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.variants, this, __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get), __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get), __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get), 
                    // Для HotelVariantsContinueSearcher это фейковый параметр.
                    [], rooms, App.app.url.route(App.HotelPageUrls.ContinueSearchVariants, hotelId), undefined, hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).hide(), signal)) || hasResults;
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_applyUnavailableOffers).call(this, this.options.manager.variants);
                }
                if (!hasResults) {
                    (_e = __classPrivateFieldGet(this, _HotelInfoPage_searchExpirationPopup, "f")) === null || _e === void 0 ? void 0 : _e.cancel();
                    this.messenger.show(App.Message.SearchNoVariantsWithLink(window.location.href, App.app.settings.tenant == 2 /* KnownTenant.PacUa */));
                }
                // Note: позволяем запускать поиск booking.com только после завершения/отмены основного поиска.
                if (this.options.allowBookingCom)
                    this.showBookingComButton();
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelInfoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).hide();
            }
        });
    }, _HotelInfoPage_applyUnavailableOffers = function _HotelInfoPage_applyUnavailableOffers(variants) {
        const unavailableOfferKeys = this.options.unavailableOfferService.get();
        if (unavailableOfferKeys.length <= 0)
            return;
        variants.forEach(v => (v.available = !unavailableOfferKeys.includes(v.key)
            && !unavailableOfferKeys.includes(v.providerItemKey)));
        this.markUnavailableVariants(unavailableOfferKeys);
    }, _HotelInfoPage_setNewVariantUrl = function _HotelInfoPage_setNewVariantUrl(hotelId) {
        const mainFilterParameters = __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").getUrlDataFromFilter();
        const newParams = new Array(0);
        mainFilterParameters.forEach(v => {
            if (__classPrivateFieldGet(this, _HotelInfoPage_changes, "f").includes(v.name))
                newParams.push(v);
        });
        return App.app.url.route(App.HotelPageUrls.Info, hotelId, newParams);
    }, _HotelInfoPage_searchBookingCom = function _HotelInfoPage_searchBookingCom() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const hotelId = App.app.url.routeData.id;
            (_a = __classPrivateFieldGet(this, _HotelInfoPage_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            __classPrivateFieldSet(this, _HotelInfoPage_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelInfoPage_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).show();
            __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_showBookingComSearching).call(this);
            try {
                const rooms = __classPrivateFieldGet(this, _HotelInfoPage_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.HotelPageUrls.SearchBookingComVariants, hotelId), { body: App.createUrlSearchParams(data), signal });
                        if (!__classPrivateFieldGet(this, _HotelInfoPage_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    const { subFilters, variants } = response.data;
                    // Определение наличия результатов поиска
                    hasResults = variants.length > 0;
                    continueSearch = response.data.continueSearch;
                    // TODO: пока не проверяю на уникальность с уже имеющимися
                    this.options.manager.variants.push(...variants);
                    // Найти лучшие варианты
                    const bestVariants = App.BestVariantsSelector.select(this.options.manager.variants, rooms);
                    // в букинге не приходят типы питания, но они определяются по-умолчанию.
                    if (subFilters) {
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).roomTypes = App.HotelInfoHotFilter.compareHotFilters(subFilters.roomTypes, __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).roomTypes);
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).boards = App.HotelInfoHotFilter.compareHotFilters(subFilters.boards, __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).boards);
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).provider = App.HotelInfoHotFilter.compareHotFilters(subFilters.provider, __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).provider);
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).offerSource = App.HotelInfoHotFilter.compareHotFilters(subFilters.offerSource, __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).offerSource);
                    }
                    // Рассчитываем фильтр по ценам только для тех предложений, которые будем отрисовывать
                    // TODO: пока фильтр по цене не делаем. Как дойду, сделать метод расчета для вариантов - выделить этот метод из
                    // метода calcMinMaxPrice
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(bestVariants !== null && bestVariants !== void 0 ? bestVariants : new Array(0));
                    const urlParameters = App.UrlParameterHelper.urlParse();
                    const filters = urlParameters.map(v => ({ name: v.name, values: v.values }));
                    yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get), filters);
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).resetDataSource();
                    yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).changeDataSource(App.DataTransformer.variantsDataTransformation(this.options.manager.variants, bestVariants), true);
                    if (((_b = __classPrivateFieldGet(this, _HotelInfoPage_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.canceled) !== false) {
                        __classPrivateFieldSet(this, _HotelInfoPage_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: response.data.dataExpiration,
                            url: App.app.url.route(App.HotelPageUrls.Search),
                        }), "f");
                    }
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelInfoContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.variants, this, __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get), __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilter_get), __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_hotFilterSet_get), 
                    // Для HotelVariantsContinueSearcher это фейковый параметр.
                    [], rooms, App.app.url.route(App.HotelPageUrls.ContinueSearchBookingComVariants, hotelId), undefined, hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).hide(), signal)) || hasResults;
                }
                if (!hasResults) {
                    __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_showBookingComEmpty).call(this);
                    // Note: данные могли остаться от основного поиска.
                    if (!__classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_result_get).hasData)
                        (_c = __classPrivateFieldGet(this, _HotelInfoPage_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.cancel();
                    this.messenger.show(App.Message.SearchNoVariants);
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelInfoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_hideBookingComSearching).call(this);
                __classPrivateFieldGet(this, _HotelInfoPage_instances, "a", _HotelInfoPage_preloader_get).hide();
            }
        });
    }, _HotelInfoPage_cancelSearch = function _HotelInfoPage_cancelSearch() {
        var _a;
        (_a = __classPrivateFieldGet(this, _HotelInfoPage_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
    }, _HotelInfoPage_resetBookingComElements = function _HotelInfoPage_resetBookingComElements() {
        this.showBookingComButton();
        __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_hideBookingComSearching).call(this);
        __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_hideBookingComEmpty).call(this);
    }, _HotelInfoPage_reservationBlockScroll = function _HotelInfoPage_reservationBlockScroll() {
        var _a, _b, _c, _d, _e;
        const scrollingBlock = this.chooseNumbersScrollingBlock;
        const scrollOrientedBlock = $('.js-hotels-without__block', this.root);
        const orientedBlock = scrollOrientedBlock;
        const orientedBlockOffset = orientedBlock.offset();
        const orientedBlockOffsetTop = orientedBlockOffset != null ? orientedBlockOffset.top : 0;
        const blockScrollTop = ((_a = $(window).scrollTop()) !== null && _a !== void 0 ? _a : 0) - orientedBlockOffsetTop;
        const topBottom = ((_b = orientedBlock.outerHeight()) !== null && _b !== void 0 ? _b : 0) - ((_c = scrollingBlock.outerHeight()) !== null && _c !== void 0 ? _c : 0);
        let scrolledDistance = (_d = $(window).scrollTop()) !== null && _d !== void 0 ? _d : 0;
        if (!App.isTouch)
            scrolledDistance = (_e = App.app.container.scrollTop()) !== null && _e !== void 0 ? _e : 0;
        if (scrolledDistance >= orientedBlockOffsetTop) {
            scrollingBlock.addClass('_fixed_scroll');
            if (blockScrollTop >= topBottom)
                scrollingBlock.removeClass('_fixed_scroll').css({ 'top': topBottom });
            else
                scrollingBlock.addClass('_fixed_scroll').css({ 'top': 0 });
        }
        else {
            scrollingBlock.removeClass('_fixed_scroll');
        }
    }, _HotelInfoPage_scrollToOutputBlock = function _HotelInfoPage_scrollToOutputBlock() {
        const scrollOffset = __classPrivateFieldGet(this, _HotelInfoPage_scrollToBlock, "f").offset();
        if (scrollOffset)
            window.scrollTo(scrollOffset.left, scrollOffset.top);
    }, _HotelInfoPage_showBookingComSearching = function _HotelInfoPage_showBookingComSearching() {
        __classPrivateFieldGet(this, _HotelInfoPage_progressDataLoading, "f").showByClass();
    }, _HotelInfoPage_hideBookingComSearching = function _HotelInfoPage_hideBookingComSearching() {
        __classPrivateFieldGet(this, _HotelInfoPage_progressDataLoading, "f").hideByClass();
    }, _HotelInfoPage_showBookingComEmpty = function _HotelInfoPage_showBookingComEmpty() {
        __classPrivateFieldGet(this, _HotelInfoPage_bookingComEmptyBlock, "f").showByClass();
    }, _HotelInfoPage_hideBookingComEmpty = function _HotelInfoPage_hideBookingComEmpty() {
        __classPrivateFieldGet(this, _HotelInfoPage_bookingComEmptyBlock, "f").hideByClass();
    }, _HotelInfoPage_renderHotelInfo = function _HotelInfoPage_renderHotelInfo(hotel) {
        var _a, _b;
        hotel.isHostUa = window.location.hostname === 'www.pac.ua';
        if (hotel) {
            const content = $(App.templates.Hotel.DetailInfo(hotel));
            __classPrivateFieldGet(this, _HotelInfoPage_detailsSliderBlock, "f").empty();
            __classPrivateFieldGet(this, _HotelInfoPage_detailsSliderBlock, "f").append(content);
        }
        this.components.push(new App.MediaGallery());
        // соц сети
        (_b = (_a = window.pac) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.SocialLikes();
        __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_renderDescription).call(this, hotel.description, hotel.descriptionNoIndex, hotel.registryNumber, hotel.registryExpireDate, hotel.registryUrl);
        __classPrivateFieldGet(this, _HotelInfoPage_compareBinder, "f").bind([$('.js-tour-item', this.root)]);
        const scrollTo = $('.js-scroll-to', __classPrivateFieldGet(this, _HotelInfoPage_detailsSliderBlock, "f"));
        scrollTo.on('click', e => App.scrollLinkClickHandler(e));
    }, _HotelInfoPage_renderDescription = function _HotelInfoPage_renderDescription(description, noIndex, registryNumber, registryExpireDate, registryUrl) {
        if (description)
            __classPrivateFieldGet(this, _HotelInfoPage_descriptionBlock, "f").html(noIndex ? `<!--googleoff: all--><noindex>${description}</noindex><!--/googleoff: all-->` : description).show();
        else
            __classPrivateFieldGet(this, _HotelInfoPage_descriptionBlock, "f").html('').hide();
        if (registryNumber) {
            $('.js-accreditation-block-tab').show();
            let registryValue = registryNumber;
            if (registryExpireDate)
                registryValue += ` (до ${App.formatDate(registryExpireDate, 'shortDate')})`;
            $('.js-value', __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f")).text(registryValue);
            $('.js-hotel-name', __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f")).text(__classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").name + ' ' + (__classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").stars != null ? __classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").stars + '*' : ''));
            if (registryUrl) {
                $('.js-href-value', __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f")).attr('href', registryUrl);
                $('.js-href-suffix', __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f")).hide();
            }
            else {
                const currentHref = $('.js-href-value', __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f")).attr('href');
                $('.js-href-value', __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f")).attr('href', currentHref + registryNumber);
            }
            __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f").show();
        }
        else {
            __classPrivateFieldGet(this, _HotelInfoPage_accreditationBlock, "f").hide();
            $('.js-accreditation-block-tab').hide();
        }
    }, _HotelInfoPage_scrollLinkShow = function _HotelInfoPage_scrollLinkShow() {
        var _a;
        if (((_a = __classPrivateFieldGet(this, _HotelInfoPage_variantsTable, "f").height()) !== null && _a !== void 0 ? _a : 0) > 0)
            __classPrivateFieldGet(this, _HotelInfoPage_scrollBookLink, "f").show();
        else
            __classPrivateFieldGet(this, _HotelInfoPage_scrollBookLink, "f").hide();
    }, _HotelInfoPage_onSearchButtonClick = function _HotelInfoPage_onSearchButtonClick(event) {
        event.preventDefault();
        if (!this.form.validator.form())
            return;
        this.container.trigger("detailSearchButton:click" /* Events.DetailSearchButtonClick */);
    }, _HotelInfoPage_onScrollLinkClick = function _HotelInfoPage_onScrollLinkClick() {
        var _a;
        // TODO: дублирование кода - есть в классе TourProgramPage.ts
        const dest = __classPrivateFieldGet(this, _HotelInfoPage_variantsTable, "f");
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += ((_a = App.app.container.scrollTop()) !== null && _a !== void 0 ? _a : 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    }, _HotelInfoPage_setBookingPosition = function _HotelInfoPage_setBookingPosition() {
        var _a, _b, _c;
        // TODO: https://jquery.com/upgrade-guide/3.0/#breaking-change-outerwidth-or-outerheight-on-window-includes-scrollbar-width-height
        const scrolledPos = ((_a = $(window).scrollTop()) !== null && _a !== void 0 ? _a : 0) + ((_b = $(window).outerHeight()) !== null && _b !== void 0 ? _b : 0);
        const offset = __classPrivateFieldGet(this, _HotelInfoPage_bookScrollToWrap, "f").offset();
        const offsetTop = (offset != null ? offset.top : 0);
        if (scrolledPos >= offsetTop && scrolledPos < offsetTop + ((_c = __classPrivateFieldGet(this, _HotelInfoPage_bookScrollToWrap, "f").outerHeight()) !== null && _c !== void 0 ? _c : 0))
            __classPrivateFieldGet(this, _HotelInfoPage_scrollBookLink, "f").addClass('_fixed_book');
        else
            __classPrivateFieldGet(this, _HotelInfoPage_scrollBookLink, "f").removeClass('_fixed_book');
    }, _HotelInfoPage_onReserveVariant = function _HotelInfoPage_onReserveVariant(event, hotelKey) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.reserveVariant($(event.currentTarget), hotelKey);
        });
    }, _HotelInfoPage_updateReserveBlock = function _HotelInfoPage_updateReserveBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const key = parseInt((_a = App.app.url.routeData.id) !== null && _a !== void 0 ? _a : '0', 10);
            const value = this.options.manager.getBookedVariants(key);
            const block = $('.js-output-block', this.container);
            yield this.renderReservedHotelVariants(block, key, value);
        });
    }, _HotelInfoPage_onTabClick = function _HotelInfoPage_onTabClick(e) {
        if ($(e.target).attr('data-tab') === 'map' && !__classPrivateFieldGet(this, _HotelInfoPage_loadMap, "f") && __classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f")) {
            if (__classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").coordinate) {
                const mapModel = {
                    mapTitle: '',
                    mapPoints: [
                        {
                            type: "hotel" /* MapPointType.Hotel */,
                            coordinates: __classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").coordinate,
                            text: __classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").name,
                            selected: true,
                            stars: __classPrivateFieldGet(this, _HotelInfoPage_hotelData, "f").stars,
                        },
                    ],
                };
                this.components.push(new App.UnfoldMap(mapModel, false));
                __classPrivateFieldSet(this, _HotelInfoPage_loadMap, true, "f");
            }
        }
    }, _HotelInfoPage_onActionInfoShow = function _HotelInfoPage_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelInfoPage_instances, "m", _HotelInfoPage_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _HotelInfoPage_loadAnnouncement = function _HotelInfoPage_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _a;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(
                    // TODO: убрать вызов toString после апгрейда "@typescript-eslint/eslint-plugin".
                    App.app.url.route(App.HotelPageUrls.Announcement) + `?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _HotelInfoPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelInfoPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.HotelInfoPage = HotelInfoPage;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelPageManagerMobile_instances, _HotelPageManagerMobile_options, _HotelPageManagerMobile_router, _HotelPageManagerMobile_searchPageField, _HotelPageManagerMobile_infoPageField, _HotelPageManagerMobile_bookPageField, _HotelPageManagerMobile_offersKey, _HotelPageManagerMobile_offers, _HotelPageManagerMobile_hotel, _HotelPageManagerMobile_variantsKey, _HotelPageManagerMobile_variants, _HotelPageManagerMobile_bookedVariants, _HotelPageManagerMobile_searchPage_get, _HotelPageManagerMobile_infoPage_get, _HotelPageManagerMobile_bookPage_get;
    // Примерно такая идеология
    // 1. Поиск(Url activity / search)
    //    a. При клике по кнопке фильтра -
    //        - поиск на сервере
    //        - Установка applicationData
    //        - Установка _currentDataUrl
    //        - Установка истории
    //        - Отдаются все экскурсии, соответствующие фильтру с вариантами
    //    b. При клике по блоку
    //        - Поиск в applicationData
    //        - Нет установки applicationData
    //        - Нет установки _currentDataUrl
    //        - Есть установка истории
    //    c. При поиске по фильтру в вариантах
    //        - поиск на сервере по одному отелю
    //        - ? Установка applicationData - ведь мы можем вернуться на поиск экскурсий.
    //        - ? Установка _currentDataUrl
    //        - Установка истории
    //    d. Назад -
    //        - т.к. всегда меняется Url после поиска и данные, то каждый раз новый поиск
    // 2. Ввод url activity / search - тоже самое кроме того, что не устанавливаем историю по options.manualSearch = false
    // 3. Поиск вариантов по фильтру вариантов(Url activity / variant)
    //    a. При клике по кнопке фильтра -
    //        - поиск на сервере
    //        - Установка applicationData
    //        - Установка _currentDataUrl
    //        - Установка истории
    //        - Отдается одна экскурсия, соответствующая фильтру с ЕЁ вариантами
    //    b. При клике по блоку
    //        - Поиск в applicationData
    //        - Нет установки applicationData
    //        - Нет установки _currentDataUrl
    //        - Есть установка истории
    //    c. При поиске по фильтру в вариантах
    //        - поиск на сервере по одному отелю
    //        - ? Установка applicationData - ведь мы можем вернуться на поиск экскурсий.
    //        - ? Установка _currentDataUrl
    //        - Установка истории
    //    d. Назад
    //        - Поиски могут меняться, значит данные уже новые и урлы новые - т.е.новый поиск по отелю
    //        - Может быть, что сразу вернуться на search - тогда поиска еще не было, данные те же и url тот же.
    // Итого
    //  1. При поисках на сервере менять _currentDataUrl и applicationData
    //      a. При переходах по клику не менять
    //  2. В поиске если !options.manualSearch - НЕ менять history,
    // При кликах - менять history
    // TODO: history немного глючит.
    class HotelPageManagerMobile {
        get router() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f");
        }
        get route() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").getPath();
        }
        get offersKey() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_offersKey, "f");
        }
        set offersKey(value) {
            __classPrivateFieldSet(this, _HotelPageManagerMobile_offersKey, value, "f");
        }
        get offers() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_offers, "f");
        }
        get hotel() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_hotel, "f");
        }
        set hotel(value) {
            __classPrivateFieldSet(this, _HotelPageManagerMobile_hotel, value, "f");
        }
        get variantsKey() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_variantsKey, "f");
        }
        set variantsKey(value) {
            __classPrivateFieldSet(this, _HotelPageManagerMobile_variantsKey, value, "f");
        }
        get variants() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_variants, "f");
        }
        get bookedVariants() {
            return __classPrivateFieldGet(this, _HotelPageManagerMobile_bookedVariants, "f");
        }
        constructor(options) {
            _HotelPageManagerMobile_instances.add(this);
            _HotelPageManagerMobile_options.set(this, void 0);
            _HotelPageManagerMobile_router.set(this, void 0);
            _HotelPageManagerMobile_searchPageField.set(this, void 0);
            _HotelPageManagerMobile_infoPageField.set(this, void 0);
            _HotelPageManagerMobile_bookPageField.set(this, void 0);
            // TODO: пока ничего умнее не придумал, как обмениваться данными между страницами (Web Storage, IndexedDB, CacheAPI+ServiceWorkerAPI ?).
            // Некий cache-ключ для данных в _offers.
            _HotelPageManagerMobile_offersKey.set(this, void 0);
            _HotelPageManagerMobile_offers.set(this, new Array());
            _HotelPageManagerMobile_hotel.set(this, void 0);
            // Некий cache-ключ для данных в _variants.
            _HotelPageManagerMobile_variantsKey.set(this, void 0);
            _HotelPageManagerMobile_variants.set(this, new Array());
            _HotelPageManagerMobile_bookedVariants.set(this, {});
            __classPrivateFieldSet(this, _HotelPageManagerMobile_options, options, "f");
            // TODO: есть возможность разделить инициализацию роутера (перенести в App.ts) и добавление в него маршрутов (оставить в каждом PageManager).
            const sharedRoutes = {
            /* TODO: реализовать страницу ErrorPage с использованием шаблона Error.hbs
            '/error/?(.*)': (path: string, next: Function) => {
                this.errorPage.start()
                    .then(next(false));
            },
            */
            };
            __classPrivateFieldSet(this, _HotelPageManagerMobile_router, new Router(sharedRoutes)
                .configure({
                strict: false,
                async: true,
                html5history: true,
                run_handler_in_init: false,
                // TODO: реализовать страницу ErrorPage с использованием шаблона Error.hbs
                // notfound: (next: (err: boolean) => void) => {
                //   this.#router.dispatch('on', '/error/404/');
                //   next(false);
                // },
            })
                .init(), "f");
            // Добавление hotel-маршрутов.
            __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").route('on', '/hotel/search/?.*', (next) => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_searchPage_get).start();
                next(false);
            }));
            __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").route('after', '/hotel/search/?.*', (next) => {
                __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_searchPage_get).stop();
                next(false);
            });
            /*
            this.#router.route('on', '/hotel/compare/?.*', async (next: (err?: boolean) => void) => {
                await this.comparePage.start();
                next(false);
            });
            this.#router.route('after', '/hotel/compare/?.*', (next: (err?: boolean) => void) => {
                this.comparePage.stop();
                next(false);
            });
            */
            __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").route('on', '/hotel/info/?.*', (next) => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_infoPage_get).start();
                next(false);
            }));
            __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").route('after', '/hotel/info/?.*', (next) => {
                __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_infoPage_get).stop();
                next(false);
            });
            __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").route('on', '/hotel/book/?.*', (next) => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_bookPage_get).start();
                next(false);
            }));
            __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").route('after', '/hotel/book/?.*', (next) => {
                __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_bookPage_get).stop();
                next(false);
            });
            __classPrivateFieldGet(this, _HotelPageManagerMobile_router, "f").handler();
        }
        // TODO: костыль, переделать.
        getHotelVariantsRequestData(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                // TODO: костыль - установим фильтр, т.к. для отправки запроса сериализуем данные - это проще, чем руками формировать соответствующий массив из
                // параметров урла
                yield __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_infoPage_get).setMainFilterFromParameters(urlParameters);
                // Добавим в форму поиска список забронированных вариантов размещения
                return __classPrivateFieldGet(this, _HotelPageManagerMobile_instances, "a", _HotelPageManagerMobile_infoPage_get).getFilterSerializeArray();
            });
        }
        addBookedVariants(hotelKey, ...items) {
            const variants = this.bookedVariants[hotelKey];
            if (variants)
                variants.push(...items);
            else
                this.bookedVariants[hotelKey] = items;
        }
        getBookedVariants(hotelKey) {
            let result = this.bookedVariants[hotelKey];
            if (!result) {
                result = new Array();
                this.bookedVariants[hotelKey] = result;
            }
            return result;
        }
    }
    _HotelPageManagerMobile_options = new WeakMap(), _HotelPageManagerMobile_router = new WeakMap(), _HotelPageManagerMobile_searchPageField = new WeakMap(), _HotelPageManagerMobile_infoPageField = new WeakMap(), _HotelPageManagerMobile_bookPageField = new WeakMap(), _HotelPageManagerMobile_offersKey = new WeakMap(), _HotelPageManagerMobile_offers = new WeakMap(), _HotelPageManagerMobile_hotel = new WeakMap(), _HotelPageManagerMobile_variantsKey = new WeakMap(), _HotelPageManagerMobile_variants = new WeakMap(), _HotelPageManagerMobile_bookedVariants = new WeakMap(), _HotelPageManagerMobile_instances = new WeakSet(), _HotelPageManagerMobile_searchPage_get = function _HotelPageManagerMobile_searchPage_get() {
        if (!__classPrivateFieldGet(this, _HotelPageManagerMobile_searchPageField, "f")) {
            __classPrivateFieldSet(this, _HotelPageManagerMobile_searchPageField, new App.HotelSearchPageMobile(Object.assign({ root: '.js-hotels-results-page', container: '.js-hotel-search-block', content: '.js-hotel-search-content', manager: this, mainFilter: '.js-hotel-main-filter', bookingComButtonName: '.js-booking-com-hotels-search' }, __classPrivateFieldGet(this, _HotelPageManagerMobile_options, "f"))), "f");
        }
        return __classPrivateFieldGet(this, _HotelPageManagerMobile_searchPageField, "f");
    }, _HotelPageManagerMobile_infoPage_get = function _HotelPageManagerMobile_infoPage_get() {
        if (!__classPrivateFieldGet(this, _HotelPageManagerMobile_infoPageField, "f")) {
            __classPrivateFieldSet(this, _HotelPageManagerMobile_infoPageField, new App.HotelInfoPageMobile(Object.assign({ root: '.js-hotel-details-block', container: '.js-hotel-details-block', content: '.js-hotel-details-content', manager: this, mainFilter: '.js-hotel-detail-filter', bookingComButtonName: '.js-booking-com-variants-search' }, __classPrivateFieldGet(this, _HotelPageManagerMobile_options, "f"))), "f");
        }
        return __classPrivateFieldGet(this, _HotelPageManagerMobile_infoPageField, "f");
    }, _HotelPageManagerMobile_bookPage_get = function _HotelPageManagerMobile_bookPage_get() {
        if (!__classPrivateFieldGet(this, _HotelPageManagerMobile_bookPageField, "f")) {
            __classPrivateFieldSet(this, _HotelPageManagerMobile_bookPageField, new App.HotelBookPageMobile(Object.assign({ root: '.js-hotel-booking-block', container: '.js-hotel-booking-block', content: '.js-hotel-booking-content', manager: this, mainFilter: '.js-hotel-main-filter', bookingComButtonName: '.js-booking-com-hotels-search' }, __classPrivateFieldGet(this, _HotelPageManagerMobile_options, "f"))), "f");
        }
        return __classPrivateFieldGet(this, _HotelPageManagerMobile_bookPageField, "f");
    };
    App.HotelPageManagerMobile = HotelPageManagerMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelPageManager_instances, _HotelPageManager_options, _HotelPageManager_router, _HotelPageManager_searchPageField, _HotelPageManager_infoPageField, _HotelPageManager_bookPageField, _HotelPageManager_offersKey, _HotelPageManager_offers, _HotelPageManager_hotel, _HotelPageManager_variantsKey, _HotelPageManager_variants, _HotelPageManager_bookedVariants, _HotelPageManager_searchPage_get, _HotelPageManager_infoPage_get, _HotelPageManager_bookPage_get;
    // Примерно такая идеология
    // 1. Поиск(Url activity / search)
    //    a. При клике по кнопке фильтра -
    //        - поиск на сервере
    //        - Установка applicationData
    //        - Установка _currentDataUrl
    //        - Установка истории
    //        - Отдаются все экскурсии, соответствующие фильтру с вариантами
    //    b. При клике по блоку
    //        - Поиск в applicationData
    //        - Нет установки applicationData
    //        - Нет установки _currentDataUrl
    //        - Есть установка истории
    //    c. При поиске по фильтру в вариантах
    //        - поиск на сервере по одному отелю
    //        - ? Установка applicationData - ведь мы можем вернуться на поиск экскурсий.
    //        - ? Установка _currentDataUrl
    //        - Установка истории
    //    d. Назад -
    //        - т.к. всегда меняется Url после поиска и данные, то каждый раз новый поиск
    // 2. Ввод url activity / search - тоже самое кроме того, что не устанавливаем историю по options.manualSearch = false
    // 3. Поиск вариантов по фильтру вариантов(Url activity / variant)
    //    a. При клике по кнопке фильтра -
    //        - поиск на сервере
    //        - Установка applicationData
    //        - Установка _currentDataUrl
    //        - Установка истории
    //        - Отдается одна экскурсия, соответствующая фильтру с ЕЁ вариантами
    //    b. При клике по блоку
    //        - Поиск в applicationData
    //        - Нет установки applicationData
    //        - Нет установки _currentDataUrl
    //        - Есть установка истории
    //    c. При поиске по фильтру в вариантах
    //        - поиск на сервере по одному отелю
    //        - ? Установка applicationData - ведь мы можем вернуться на поиск экскурсий.
    //        - ? Установка _currentDataUrl
    //        - Установка истории
    //    d. Назад
    //        - Поиски могут меняться, значит данные уже новые и урлы новые - т.е.новый поиск по отелю
    //        - Может быть, что сразу вернуться на search - тогда поиска еще не было, данные те же и url тот же.
    // Итого
    //  1. При поисках на сервере менять _currentDataUrl и applicationData
    //      a. При переходах по клику не менять
    //  2. В поиске если !options.manualSearch - НЕ менять history,
    // При кликах - менять history
    // TODO: history немного глючит.
    class HotelPageManager {
        get router() {
            return __classPrivateFieldGet(this, _HotelPageManager_router, "f");
        }
        get route() {
            return __classPrivateFieldGet(this, _HotelPageManager_router, "f").getPath();
        }
        get offersKey() {
            return __classPrivateFieldGet(this, _HotelPageManager_offersKey, "f");
        }
        set offersKey(value) {
            __classPrivateFieldSet(this, _HotelPageManager_offersKey, value, "f");
        }
        get offers() {
            return __classPrivateFieldGet(this, _HotelPageManager_offers, "f");
        }
        get hotel() {
            return __classPrivateFieldGet(this, _HotelPageManager_hotel, "f");
        }
        set hotel(value) {
            __classPrivateFieldSet(this, _HotelPageManager_hotel, value, "f");
        }
        get variantsKey() {
            return __classPrivateFieldGet(this, _HotelPageManager_variantsKey, "f");
        }
        set variantsKey(value) {
            __classPrivateFieldSet(this, _HotelPageManager_variantsKey, value, "f");
        }
        get variants() {
            return __classPrivateFieldGet(this, _HotelPageManager_variants, "f");
        }
        get bookedVariants() {
            return __classPrivateFieldGet(this, _HotelPageManager_bookedVariants, "f");
        }
        constructor(options) {
            _HotelPageManager_instances.add(this);
            _HotelPageManager_options.set(this, void 0);
            _HotelPageManager_router.set(this, void 0);
            _HotelPageManager_searchPageField.set(this, void 0);
            _HotelPageManager_infoPageField.set(this, void 0);
            _HotelPageManager_bookPageField.set(this, void 0);
            // TODO: пока ничего умнее не придумал, как обмениваться данными между страницами (Web Storage, IndexedDB, CacheAPI+ServiceWorkerAPI ?).
            // Некий cache-ключ для данных в _offers.
            _HotelPageManager_offersKey.set(this, void 0);
            _HotelPageManager_offers.set(this, new Array());
            _HotelPageManager_hotel.set(this, void 0);
            // Некий cache-ключ для данных в _variants.
            _HotelPageManager_variantsKey.set(this, void 0);
            _HotelPageManager_variants.set(this, new Array());
            _HotelPageManager_bookedVariants.set(this, {});
            __classPrivateFieldSet(this, _HotelPageManager_options, options, "f");
            // TODO: есть возможность разделить инициализацию роутера (перенести в App.ts) и добавление в него маршрутов (оставить в каждом PageManager).
            const sharedRoutes = {
            /* TODO: реализовать страницу ErrorPage с использованием шаблона Error.hbs
            '/error/?(.*)': (path: string, next: Function) => {
                this.errorPage.start()
                    .then(next(false));
            },
            */
            };
            __classPrivateFieldSet(this, _HotelPageManager_router, new Router(sharedRoutes)
                .configure({
                strict: false,
                async: true,
                html5history: true,
                run_handler_in_init: false,
                // TODO: реализовать страницу ErrorPage с использованием шаблона Error.hbs
                // notfound: (next: (err: boolean) => void) => {
                //   this.#router.dispatch('on', '/error/404/');
                //   next(false);
                // },
            })
                .init(), "f");
            // Добавление hotel-маршрутов.
            __classPrivateFieldGet(this, _HotelPageManager_router, "f").route('on', '/hotel/search/?.*', (next) => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_searchPage_get).start();
                next(false);
            }));
            __classPrivateFieldGet(this, _HotelPageManager_router, "f").route('after', '/hotel/search/?.*', (next) => {
                __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_searchPage_get).stop();
                next(false);
            });
            /*
            this.#router.route('on', '/hotel/compare/?.*', async (next: (err?: boolean) => void) => {
                await this.comparePage.start();
                next(false);
            });
            this.#router.route('after', '/hotel/compare/?.*', (next: (err?: boolean) => void) => {
                this.comparePage.stop();
                next(false);
            });
            */
            __classPrivateFieldGet(this, _HotelPageManager_router, "f").route('on', '/hotel/info/?.*', (next) => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_infoPage_get).start();
                next(false);
            }));
            __classPrivateFieldGet(this, _HotelPageManager_router, "f").route('after', '/hotel/info/?.*', (next) => {
                __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_infoPage_get).stop();
                next(false);
            });
            __classPrivateFieldGet(this, _HotelPageManager_router, "f").route('on', '/hotel/book/?.*', (next) => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_bookPage_get).start();
                next(false);
            }));
            __classPrivateFieldGet(this, _HotelPageManager_router, "f").route('after', '/hotel/book/?.*', (next) => {
                __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_bookPage_get).stop();
                next(false);
            });
            __classPrivateFieldGet(this, _HotelPageManager_router, "f").handler();
        }
        // TODO: костыль, переделать.
        getHotelVariantsRequestData(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                // TODO: костыль - установим фильтр, т.к. для отправки запроса сериализуем данные - это проще, чем руками формировать соответствующий массив из
                // параметров урла
                yield __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_infoPage_get).setMainFilterFromParameters(urlParameters);
                // Добавим в форму поиска список забронированных вариантов размещения
                return __classPrivateFieldGet(this, _HotelPageManager_instances, "a", _HotelPageManager_infoPage_get).getFilterSerializeArray();
            });
        }
        addBookedVariants(hotelKey, ...items) {
            const variants = this.bookedVariants[hotelKey];
            if (variants)
                variants.push(...items);
            else
                this.bookedVariants[hotelKey] = items;
        }
        getBookedVariants(hotelKey) {
            let result = this.bookedVariants[hotelKey];
            if (!result) {
                result = new Array();
                this.bookedVariants[hotelKey] = result;
            }
            return result;
        }
    }
    _HotelPageManager_options = new WeakMap(), _HotelPageManager_router = new WeakMap(), _HotelPageManager_searchPageField = new WeakMap(), _HotelPageManager_infoPageField = new WeakMap(), _HotelPageManager_bookPageField = new WeakMap(), _HotelPageManager_offersKey = new WeakMap(), _HotelPageManager_offers = new WeakMap(), _HotelPageManager_hotel = new WeakMap(), _HotelPageManager_variantsKey = new WeakMap(), _HotelPageManager_variants = new WeakMap(), _HotelPageManager_bookedVariants = new WeakMap(), _HotelPageManager_instances = new WeakSet(), _HotelPageManager_searchPage_get = function _HotelPageManager_searchPage_get() {
        if (!__classPrivateFieldGet(this, _HotelPageManager_searchPageField, "f")) {
            __classPrivateFieldSet(this, _HotelPageManager_searchPageField, new App.HotelSearchPage(Object.assign({ root: '.js-hotels-results-page', container: '.js-hotel-search-block', content: '.js-hotel-search-content', manager: this, mainFilter: '.js-hotel-main-filter', bookingComButtonName: '.js-booking-com-hotels-search' }, __classPrivateFieldGet(this, _HotelPageManager_options, "f"))), "f");
        }
        return __classPrivateFieldGet(this, _HotelPageManager_searchPageField, "f");
    }, _HotelPageManager_infoPage_get = function _HotelPageManager_infoPage_get() {
        if (!__classPrivateFieldGet(this, _HotelPageManager_infoPageField, "f")) {
            __classPrivateFieldSet(this, _HotelPageManager_infoPageField, new App.HotelInfoPage(Object.assign({ root: '.js-hotel-details-block', container: '.js-hotel-details-block', content: '.js-hotel-details-content', manager: this, mainFilter: '.js-hotel-detail-filter', bookingComButtonName: '.js-booking-com-variants-search' }, __classPrivateFieldGet(this, _HotelPageManager_options, "f"))), "f");
        }
        return __classPrivateFieldGet(this, _HotelPageManager_infoPageField, "f");
    }, _HotelPageManager_bookPage_get = function _HotelPageManager_bookPage_get() {
        if (!__classPrivateFieldGet(this, _HotelPageManager_bookPageField, "f")) {
            __classPrivateFieldSet(this, _HotelPageManager_bookPageField, new App.HotelBookPage(Object.assign({ root: '.js-hotel-booking-block', container: '.js-hotel-booking-block', content: '.js-hotel-booking-content', manager: this, mainFilter: '.js-hotel-main-filter', bookingComButtonName: '.js-booking-com-hotels-search' }, __classPrivateFieldGet(this, _HotelPageManager_options, "f"))), "f");
        }
        return __classPrivateFieldGet(this, _HotelPageManager_bookPageField, "f");
    };
    App.HotelPageManager = HotelPageManager;
})(App || (App = {}));
/// <reference path='HotelPageBase.Mobile.ts' />
var App;
(function (App) {
    var _HotelSearchPageMobile_instances, _HotelSearchPageMobile_mainFilterWrap, _HotelSearchPageMobile_filterHot, _HotelSearchPageMobile_searchButton, _HotelSearchPageMobile_searchBlock, _HotelSearchPageMobile_scrollToBlock, _HotelSearchPageMobile_searchExpirationPopup, _HotelSearchPageMobile_preloaderField, _HotelSearchPageMobile_mainFilter, _HotelSearchPageMobile_resultField, _HotelSearchPageMobile_hotFilterSetField, _HotelSearchPageMobile_hotFilterField, _HotelSearchPageMobile_form, _HotelSearchPageMobile_responseValidator, _HotelSearchPageMobile_pointOfInterest, _HotelSearchPageMobile_compareField, _HotelSearchPageMobile_hotelsToCompareField, _HotelSearchPageMobile_currentSearchUrlParameters, _HotelSearchPageMobile_searchAbortController, _HotelSearchPageMobile_currentBookBlock, _HotelSearchPageMobile_preloader_get, _HotelSearchPageMobile_result_get, _HotelSearchPageMobile_hotFilterSet_get, _HotelSearchPageMobile_hotFilterSet_set, _HotelSearchPageMobile_hotFilter_get, _HotelSearchPageMobile_compare_get, _HotelSearchPageMobile_hotelsToCompare_get, _HotelSearchPageMobile_hotelsToCompare_set, _HotelSearchPageMobile_checkSearchForm, _HotelSearchPageMobile_search, _HotelSearchPageMobile_cancelSearch, _HotelSearchPageMobile_prepareBestVariantsOffers, _HotelSearchPageMobile_checkAndRenderHotelsToCompare, _HotelSearchPageMobile_searchBookingCom, _HotelSearchPageMobile_onBlockClick, _HotelSearchPageMobile_changeHotelsToCompare, _HotelSearchPageMobile_scrollToOutputBlock, _HotelSearchPageMobile_onSearchButtonClick, _HotelSearchPageMobile_onReserveVariant, _HotelSearchPageMobile_updateReserveBlocks, _HotelSearchPageMobile_onActionInfoShow, _HotelSearchPageMobile_loadAnnouncement;
    class HotelSearchPageMobile extends App.HotelPageMobileBase {
        constructor(options) {
            super(Object.assign({ root: 'js-hotels-results-page' }, options));
            _HotelSearchPageMobile_instances.add(this);
            _HotelSearchPageMobile_mainFilterWrap.set(this, void 0);
            _HotelSearchPageMobile_filterHot.set(this, void 0);
            _HotelSearchPageMobile_searchButton.set(this, void 0);
            _HotelSearchPageMobile_searchBlock.set(this, void 0);
            _HotelSearchPageMobile_scrollToBlock.set(this, void 0);
            _HotelSearchPageMobile_searchExpirationPopup.set(this, void 0);
            _HotelSearchPageMobile_preloaderField.set(this, void 0);
            _HotelSearchPageMobile_mainFilter.set(this, void 0);
            _HotelSearchPageMobile_resultField.set(this, void 0);
            _HotelSearchPageMobile_hotFilterSetField.set(this, void 0);
            _HotelSearchPageMobile_hotFilterField.set(this, void 0);
            _HotelSearchPageMobile_form.set(this, void 0);
            _HotelSearchPageMobile_responseValidator.set(this, void 0);
            /**
             * Координаты достопримечательности (или аэропорта или может другой точки, вокруг которой надо искать)
             * 1. При инициализации поиска в контроллере MVC находятся координаты этой точки.
             * 2. Они передаются на клиент в ответе.
             * 3. В продолжении порционного поиска и в поиске по букингу координаты уже не передаются, поэтому их надо
             * сохранять между поисками в этом поле.
             * 4. Если следующий поиск не будет учитывать координаты, то в ответе будет null и это поле обнулится.
             */
            _HotelSearchPageMobile_pointOfInterest.set(this, void 0);
            _HotelSearchPageMobile_compareField.set(this, void 0);
            _HotelSearchPageMobile_hotelsToCompareField.set(this, void 0);
            /**
             * Параметры урла текущего поиска
             * Сохраняем сюда значения с главного фильтра в виде параметров урла при начале поиска и потом юзаем. Таким
             * образом везде, где будут нужны эти данные в дальнейшем (особенно в продолжающемся порционном поиске) они не
             * будут меняться. Раньше, когда каждый раз брала параметры с фильтра, возможна была ситуация, что пока идет
             * запрос, пользователь натыкал фильтр, но кнопку не нажал - и уже значения не правильные.
             */
            _HotelSearchPageMobile_currentSearchUrlParameters.set(this, void 0);
            _HotelSearchPageMobile_searchAbortController.set(this, void 0);
            _HotelSearchPageMobile_currentBookBlock.set(this, void 0);
            if (!this.root.length)
                return;
            const checkinLimit = this.options.checkinLimit == null
                ? undefined
                : { min: App.parseIsoDate(this.options.checkinLimit.min), max: App.parseIsoDate(this.options.checkinLimit.max) };
            __classPrivateFieldSet(this, _HotelSearchPageMobile_mainFilter, new App.HotelSearchMainFilterMobile({
                datesOptions: {
                    minDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    maxDateToOffset: this.options.maxDateToOffset,
                    defaultDateFromShift: this.options.defaultDateFromShift,
                    defaultDateToOffset: this.options.defaultDateToShift - this.options.defaultDateFromShift,
                    minDateFromShift: this.options.minDateFromShift,
                    minDateToOffset: this.options.minDateToOffset,
                },
                hotelStarsValues: {
                    defaultFromValue: this.options.defaultMinCategory,
                    defaultToValue: this.options.defaultMaxCategory,
                },
                peopleOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                },
                roomsOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                    defaultRoomCountValue: this.options.defaultRoomCount,
                },
                defaultAccommodationTypesOptions: this.options.defaultAccommodationTypes,
            }), "f");
            __classPrivateFieldSet(this, _HotelSearchPageMobile_form, new App.Form({
                root: __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").root,
                disableStepValidation: true,
            }), "f");
            __classPrivateFieldSet(this, _HotelSearchPageMobile_responseValidator, new App.ResponseValidator({
                messenger: this.messenger,
                validator: __classPrivateFieldGet(this, _HotelSearchPageMobile_form, "f").validator,
            }), "f");
            // TODO: много дублирования в названии и обработке элементов с ActivityPаge
            // инициализация элементов
            // TODO: не очень понял, почему многие элементы данной страницы находятся вне ее root.
            __classPrivateFieldSet(this, _HotelSearchPageMobile_mainFilterWrap, $('.js-m-filter-wrap', App.app.appContainerContent), "f");
            __classPrivateFieldSet(this, _HotelSearchPageMobile_filterHot, $('.js-hot-filter', App.app.appContainerContent), "f");
            __classPrivateFieldSet(this, _HotelSearchPageMobile_searchButton, $('.js-m-filter-submit', this.mainFilter), "f");
            __classPrivateFieldSet(this, _HotelSearchPageMobile_searchBlock, $('.js-hotel-search-block'), "f");
            __classPrivateFieldSet(this, _HotelSearchPageMobile_scrollToBlock, __classPrivateFieldGet(this, _HotelSearchPageMobile_filterHot, "f"), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_cancelSearch).call(this);
                    inst.hide();
                }
            });
            this.components.push(new App.ActionInfoComponent(), new App.BestPriceComponent({ container: this.container, getData: () => [] }));
            __classPrivateFieldGet(this, _HotelSearchPageMobile_searchButton, "f").on("searchButton:click" /* Events.SearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_search).call(this); }));
            __classPrivateFieldGet(this, _HotelSearchPageMobile_searchBlock, "f")
                .on("block:click" /* Events.BlockClick */, (e, data) => __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_onBlockClick).call(this, e, data))
                .on("pw:show" /* Events.Show */, '.js-output-block', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const target = $(e.target);
                const hotelKey = parseInt((_a = target.attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                App.emptyArray(this.options.manager.getBookedVariants(hotelKey));
                yield this.renderReservedHotelVariants($(e.currentTarget), hotelKey, undefined);
            }))
                .on("pw:hide" /* Events.Hide */, '.js-output-block', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const target = $(e.target);
                const hotelKey = parseInt((_a = target.attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                yield this.renderReservedHotelVariants($(e.currentTarget), hotelKey, undefined);
            }))
                .on("getCancellation:click" /* Events.GetCancellationClick */, '.js-output-block', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const hotelKey = parseInt((_a = $(e.currentTarget).parents('.js-output-block').attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                yield this.getCancellationRule(e, hotelKey);
            }))
                .on('click', '.js-output-block .js-checkbox-hotel', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_onReserveVariant).call(this, e); }))
                .on("variant:book" /* Events.VariantBook */, '.js-output-block .js-reserve-hotel', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const hotelKey = parseInt((_a = $(e.currentTarget).parents('.js-output-block').attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                __classPrivateFieldSet(this, _HotelSearchPageMobile_currentBookBlock, $(e.currentTarget), "f");
                yield this.book(hotelKey);
            }));
            this.bookingComButton.on("bookingComButton:click" /* Events.BookingComButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_searchBookingCom).call(this); }));
            __classPrivateFieldGet(this, _HotelSearchPageMobile_searchBlock, "f").on('click', '.js-booking-com-book', e => App.HotelResult.onBookingComClick(e));
            // события для блока с инфо об отеле на карте (возникающем при клике на маркер)
            $('body').on("hotelMarkerInfo:show" /* Events.HotelMarkerInfoShow */, e => __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).bindCheckCancellationRules($(e.target)));
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом -
            // выбираем из выпадающего списка стрелками и Enter ? потом жму Enter - и ничего. Возможно из-за того,
            // что перемудрили с контролами.
            this.mainFilter.on('submit', e => __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_onSearchButtonClick).call(this, e));
            $('body').on("to-compare:click" /* Events.ToCompareClick */, (e, data) => __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_changeHotelsToCompare).call(this, e, data));
            __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_cancelSearch).call(this);
                __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).hideProgressDataLoader();
            });
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_onActionInfoShow).call(this, e, data); }));
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                var _a;
                const container = ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.container) ? $(e.detail.container) : __classPrivateFieldGet(this, _HotelSearchPageMobile_searchBlock, "f");
                const keys = container.find('input[name="pacngo-offer-sub-ids"]').valString().split(';').filter(v => v !== '');
                if (keys.length <= 0)
                    return;
                let info;
                const variants = new Array();
                if (__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).activeView === 'block') {
                    info = this.options.manager.offers.find(v => v.key === parseInt(keys[0], 10));
                }
                else if (__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).activeView === 'table') {
                    const items = Enumerable.from(this.options.manager.offers)
                        .selectMany(v => v.variants, (v1, v2) => ({ offer: v1, variant: v2 }))
                        .where(v => keys.includes(v.variant.key))
                        .toArray();
                    if (items.length > 0) {
                        variants.push(...items.map(v => v.variant));
                        info = items[0].offer;
                    }
                }
                if (!info)
                    return;
                const filterDates = __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getDates();
                const data = {
                    type: 'hotel',
                    filter: {
                        checkin: !filterDates ? new Date() : filterDates[0],
                        checkout: !filterDates ? new Date() : filterDates[1],
                        rooms: __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getRooms(),
                    },
                    info: {
                        key: info.key,
                        name: info.name,
                        categoryName: info.stars,
                        countryName: info.countryName,
                        address: info.address,
                        rating: info.generalRating,
                        pacRating: info.pacRating,
                        tripadvisorRating: info.tripadvisorRating,
                        tripadvisorReviews: info.tripadvisorResponses,
                        facilities: info.facilities,
                    },
                    variants: variants
                        .map(v => ({
                        roomTypeName: v.room,
                        boardName: v.board,
                        quantity: v.quantity,
                        adultCount: v.adultCount,
                        childAges: v.childAges,
                        cancellationPolicy: v.cancellationPolicy,
                        netPrice: v.netPrice,
                        grossPrice: v.grossPrice,
                        price: v.price,
                        totalNetPrice: v.totalNetPrice,
                        totalGrossPrice: v.totalGrossPrice,
                        totalPrice: v.totalPrice,
                        currencyCode: v.currencyCode,
                    })),
                };
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта(при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data,
                    },
                }));
            });
        }
        start() {
            const _super = Object.create(null, {
                start: { get: () => super.start }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.start.call(this);
                $('.js-add-mode-context-message').show();
                const urlParameters = App.UrlParameterHelper.urlParse();
                // соответствуют данные урлу или нет
                const dataMatchUrl = App.UrlParameterHelper.contains(this.options.manager.offersKey);
                // 1. Если данные соответствуют урлу, просто отображаем данные в соответствии с параметрами, не загружаем данные заново
                // 2. Если данные не соответствуют урлу, пихаем парамтры поиска в главный фильтр и запускаем поиск
                // 3. Если это страница поиска, т.е. урл типа hotel/search, то скрываем отображенное, очищаем фильтры и оставляем только форму
                let doSearch = false;
                if (dataMatchUrl) {
                    // устанавливаем параметры необходимые для работы с данными
                    const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).setDataManipulateParameters(urlParameters);
                    yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get), dataManipulateParameters.filtering);
                    const unavailableOfferKeys = this.options.unavailableOfferService.get();
                    if (unavailableOfferKeys.length > 0) {
                        Enumerable.from(this.options.manager.offers)
                            .selectMany(v => v.variants)
                            .forEach(v => (v.available = !unavailableOfferKeys.includes(v.providerItemKey)));
                    }
                    if (this.options.manager.offers.length > 0)
                        yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).changeDataSource(this.options.manager.offers);
                    yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoSearch), this.getFilterSerializeArray());
                }
                else if (this.requiredUrlChecker.isValid(urlParameters) && !App.UrlParameterHelper.isManual(urlParameters)) {
                    doSearch = true;
                    // TODO: возможно, надо будет сделать очистку формы, но пока пусть будет так
                    __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).resetDataSource();
                    yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoSearch), this.getFilterSerializeArray());
                }
                __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilterWrap, "f").showByClass();
                this.mainFilter.showByClass();
                __classPrivateFieldGet(this, _HotelSearchPageMobile_searchBlock, "f").showByClass();
                // если надо делать автопоиск сразу при загрузке скрипта
                // Это делается, если введен url в браузер и надо найти все, что в нем
                yield __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").setFromParameters(urlParameters);
                if (doSearch)
                    yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_search).call(this, false);
            });
        }
        stop() {
            var _a;
            __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_cancelSearch).call(this);
            (_a = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchExpirationPopup, "f")) === null || _a === void 0 ? void 0 : _a.cancel();
            // TODO: очередной костыль - скрыть popup жжОсско
            $('.js-popup').hide();
            __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilterWrap, "f").hideByClass();
            this.mainFilter.hideByClass();
            __classPrivateFieldGet(this, _HotelSearchPageMobile_searchBlock, "f").hideByClass();
        }
        /**
         * Возвращает сериализованный массив полей фильтра.
         * Переопределен из-за услуг. Возможно, после прически фильтров, уберется
         */
        getFilterSerializeArray() {
            // return this.mainFilter.find('input').not('[name="Facility"]').serializeArray();
            return __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").serializeArray();
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        reservationComplete(basketVariants, contextNumber) {
            if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_currentBookBlock, "f"))
                return Promise.resolve();
            const url = __classPrivateFieldGet(this, _HotelSearchPageMobile_currentBookBlock, "f").attr('href');
            if (url) {
                if (__classPrivateFieldGet(this, _HotelSearchPageMobile_currentBookBlock, "f").attr('target') === '_blank') {
                    window.open(url);
                }
                else {
                    App.UrlParameterHelper.setUrlAsIs(url);
                    this.options.manager.router.dispatch('on', url);
                }
            }
            __classPrivateFieldSet(this, _HotelSearchPageMobile_currentBookBlock, undefined, "f");
            return Promise.resolve();
        }
        getHotelVariantsUrlData() {
            return __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getUrlDataFromFilter();
        }
    }
    _HotelSearchPageMobile_mainFilterWrap = new WeakMap(), _HotelSearchPageMobile_filterHot = new WeakMap(), _HotelSearchPageMobile_searchButton = new WeakMap(), _HotelSearchPageMobile_searchBlock = new WeakMap(), _HotelSearchPageMobile_scrollToBlock = new WeakMap(), _HotelSearchPageMobile_searchExpirationPopup = new WeakMap(), _HotelSearchPageMobile_preloaderField = new WeakMap(), _HotelSearchPageMobile_mainFilter = new WeakMap(), _HotelSearchPageMobile_resultField = new WeakMap(), _HotelSearchPageMobile_hotFilterSetField = new WeakMap(), _HotelSearchPageMobile_hotFilterField = new WeakMap(), _HotelSearchPageMobile_form = new WeakMap(), _HotelSearchPageMobile_responseValidator = new WeakMap(), _HotelSearchPageMobile_pointOfInterest = new WeakMap(), _HotelSearchPageMobile_compareField = new WeakMap(), _HotelSearchPageMobile_hotelsToCompareField = new WeakMap(), _HotelSearchPageMobile_currentSearchUrlParameters = new WeakMap(), _HotelSearchPageMobile_searchAbortController = new WeakMap(), _HotelSearchPageMobile_currentBookBlock = new WeakMap(), _HotelSearchPageMobile_instances = new WeakSet(), _HotelSearchPageMobile_preloader_get = function _HotelSearchPageMobile_preloader_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_preloaderField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPageMobile_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPageMobile_preloaderField, "f");
    }, _HotelSearchPageMobile_result_get = function _HotelSearchPageMobile_result_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_resultField, "f")) {
            __classPrivateFieldSet(this, _HotelSearchPageMobile_resultField, new App.HotelSearchResultMobile({
                hotFilter: __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get),
                maxHotelsToCompare: this.options.maxHotelsToCompare,
                onAfterDataDraw: () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_updateReserveBlocks).call(this); }),
            }), "f");
        }
        return __classPrivateFieldGet(this, _HotelSearchPageMobile_resultField, "f");
    }, _HotelSearchPageMobile_hotFilterSet_get = function _HotelSearchPageMobile_hotFilterSet_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_hotFilterSetField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPageMobile_hotFilterSetField, new App.HotelHotFilterSet(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPageMobile_hotFilterSetField, "f");
    }, _HotelSearchPageMobile_hotFilterSet_set = function _HotelSearchPageMobile_hotFilterSet_set(value) {
        __classPrivateFieldSet(this, _HotelSearchPageMobile_hotFilterSetField, value, "f");
    }, _HotelSearchPageMobile_hotFilter_get = function _HotelSearchPageMobile_hotFilter_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_hotFilterField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPageMobile_hotFilterField, new App.HotelSearchHotFilterMobile(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPageMobile_hotFilterField, "f");
    }, _HotelSearchPageMobile_compare_get = function _HotelSearchPageMobile_compare_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_compareField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPageMobile_compareField, new App.CompareTempName(new App.CompareDomElements()), "f");
        return __classPrivateFieldGet(this, _HotelSearchPageMobile_compareField, "f");
    }, _HotelSearchPageMobile_hotelsToCompare_get = function _HotelSearchPageMobile_hotelsToCompare_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_hotelsToCompareField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPageMobile_hotelsToCompareField, new Array(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPageMobile_hotelsToCompareField, "f");
    }, _HotelSearchPageMobile_hotelsToCompare_set = function _HotelSearchPageMobile_hotelsToCompare_set(value) {
        __classPrivateFieldSet(this, _HotelSearchPageMobile_hotelsToCompareField, value, "f");
    }, _HotelSearchPageMobile_checkSearchForm = function _HotelSearchPageMobile_checkSearchForm() {
        let msg = '';
        $('.js-point-code', $('.hotels-results__search-line', this.root)).each((index, elem) => {
            var _a;
            if (((_a = $(elem).val()) === null || _a === void 0 ? void 0 : _a.toString()) === '0')
                msg = 'Такого элемента поиска не найдено. Необходимо выбрать элемент поиска из выпадающего списка.';
        });
        const popup = new App.Popup();
        if (msg) {
            popup.show({
                group: 'filter',
                content: msg,
                modal: false,
                delay: 500,
            });
            return false;
        }
        return true;
    }, _HotelSearchPageMobile_search = function _HotelSearchPageMobile_search() {
        return __awaiter(this, arguments, void 0, function* (isManual = true) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            (_a = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            (_b = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
            __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).resetDataSource();
            if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_checkSearchForm).call(this))
                return;
            __classPrivateFieldSet(this, _HotelSearchPageMobile_currentSearchUrlParameters, __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getUrlDataFromFilter(), "f");
            __classPrivateFieldSet(this, _HotelSearchPageMobile_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).show();
            try {
                const rooms = __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const url = App.app.url.route(App.HotelPageUrls.Search);
                    const bodyParams = App.createUrlSearchParams(data);
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(url, { body: bodyParams, signal });
                        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    if (!new App.SearchLocker().check(response.data)) {
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).hide();
                        return;
                    }
                    const items = (_c = response.data.offers) !== null && _c !== void 0 ? _c : new Array();
                    hasResults = items.length > 0;
                    continueSearch = response.data.continueSearch;
                    // Установить переменную с координатами точки поиска
                    __classPrivateFieldSet(this, _HotelSearchPageMobile_pointOfInterest, response.data.pointOfInterest, "f");
                    App.emptyArray(this.options.manager.offers);
                    const bestOffers = yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_prepareBestVariantsOffers).call(this, items, rooms);
                    __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_checkAndRenderHotelsToCompare).call(this);
                    __classPrivateFieldSet(this, _HotelSearchPageMobile_instances, response.data.subFilters, "a", _HotelSearchPageMobile_hotFilterSet_set);
                    __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(Enumerable.from(items)
                        .selectMany(v => v.variants)
                        .toArray());
                    __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get).category = new App.HotelHotCategory();
                    // Если поиск происходит после ввода адреса с параметрами, не перезаписывать историю,
                    // т.к. этот адрес и так в истории, а другие параметры удаляются, например, хотфильтры
                    const urlParameters = App.UrlParameterHelper.urlParse();
                    if (isManual) {
                        // 1. При вводе урла оставляем сортировку как есть, т.к. человек ввел урл и ждет определенного набора и порядка
                        // данных. Если нет сортировки, то ставим по-умолчанию.
                        // 2. При нажатии кнопки Поиск меняем сортировку на указанную - меняем поле сортировки, меняем активность
                        // кнопок сортировки. Урл не меняем, т.к. в данном случае это типа по-умолчанию.
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).setDataManipulateParameters([
                            {
                                name: 'sort',
                                values: ["price" /* SortByItem.Price */],
                            },
                            {
                                name: App.HotelHotFilterFields.Categories,
                                values: [
                                    (_e = (_d = data.find(v => v.name.toLowerCase() === App.HotelFilterFields.CategoryFrom)) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '1',
                                    (_g = (_f = data.find(v => v.name.toLowerCase() === App.HotelFilterFields.CategoryTo)) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : '5',
                                ],
                            },
                        ]);
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        App.UrlParameterHelper.setUrlAsIs(response.data.seo.url);
                        if (App.Hotel.isAccommodationPointType(data))
                            App.removeAllElements(dataManipulateParameters.filtering, v => v.name === App.HotelHotFilterFields.Categories);
                        yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get), dataManipulateParameters.filtering);
                    }
                    else {
                        // устанавливаем параметры, необходимые для работы с данными
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).setDataManipulateParameters(urlParameters);
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        // TODO: какой-то винегрет - цены выпадают из общей концепции, поэтому пихаю в них данные как-то через зад
                        if (App.Hotel.isAccommodationPointType(data))
                            App.removeAllElements(dataManipulateParameters.filtering, v => v.name === App.HotelHotFilterFields.Categories);
                        yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get), dataManipulateParameters.filtering);
                    }
                    this.options.manager.offersKey = response.data.seo.url;
                    if (__classPrivateFieldGet(this, _HotelSearchPageMobile_pointOfInterest, "f")) {
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).showSortByDistance();
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).addPointOfInterestOnMap(__classPrivateFieldGet(this, _HotelSearchPageMobile_pointOfInterest, "f"));
                    }
                    else {
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).hideSortByDistance();
                    }
                    __classPrivateFieldSet(this, _HotelSearchPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: App.app.url.route(App.HotelPageUrls.Search),
                    }), "f");
                    // Дальше идет отрисовка результата и другие манипуляции, связанные с ней.
                    if (hasResults)
                        yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).changeDataSource(bestOffers);
                    App.app.seo.update(response.data.seo);
                    __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_scrollToOutputBlock).call(this);
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelSearchContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.offers, this, __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get), __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get), __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get), __classPrivateFieldGet(this, _HotelSearchPageMobile_currentSearchUrlParameters, "f"), rooms, App.app.url.route(App.HotelPageUrls.ContinueSearch), __classPrivateFieldGet(this, _HotelSearchPageMobile_pointOfInterest, "f"), hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).hide(), signal)) || hasResults;
                }
                if (!hasResults) {
                    (_h = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchExpirationPopup, "f")) === null || _h === void 0 ? void 0 : _h.cancel();
                    this.messenger.show(App.Message.SearchNoVariantsWithLink(window.location.href, App.app.settings.tenant == 2 /* KnownTenant.PacUa */));
                }
                // Note: позволяем запускать поиск booking.com только после завершения/отмены основного поиска.
                if (this.options.allowBookingCom) {
                    this.showBookingComButton();
                    $('.js-booking-com-variants-search', this.container).show();
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).hide();
            }
        });
    }, _HotelSearchPageMobile_cancelSearch = function _HotelSearchPageMobile_cancelSearch() {
        var _a;
        (_a = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
    }, _HotelSearchPageMobile_prepareBestVariantsOffers = function _HotelSearchPageMobile_prepareBestVariantsOffers(responseOffers, rooms) {
        return __awaiter(this, void 0, void 0, function* () {
            // Перенумеровать по порядку получения
            App.DataTransformer.setGettingOrderToOffers(responseOffers);
            // Получить лучшие предложения для всего, что пришло в ответе
            const currencyConverter = yield App.CurrencyManager.findConverter();
            responseOffers.forEach(item => {
                var _a, _b, _c;
                item.bestVariants = App.BestVariantsSelector.select(item.variants, rooms);
                // выбор цен (если нет разрешений на какие-то цены, то они уже проверены
                // на сервере для вариантов, из которых на клиенте мы отбирали лучшие варианты)
                if (item.bestVariants) {
                    item.netPrice = 0;
                    item.grossPrice = 0;
                    item.price = 0;
                    for (const bestVariant of item.bestVariants) {
                        const rate = (_a = currencyConverter === null || currencyConverter === void 0 ? void 0 : currencyConverter.exchange(1, bestVariant.currencyCode, item.currencyCode)) !== null && _a !== void 0 ? _a : 1;
                        item.netPrice += ((_b = bestVariant.netPrice) !== null && _b !== void 0 ? _b : 0) * rate;
                        item.grossPrice += bestVariant.grossPrice * rate;
                        item.price += ((_c = bestVariant.price) !== null && _c !== void 0 ? _c : 0) * rate;
                    }
                }
            });
            // Сохраняем все пришедшие, немного обработанные данные, в данных приложения
            const offers = App.DataTransformer.hotelsDataTransformation(responseOffers, __classPrivateFieldGet(this, _HotelSearchPageMobile_currentSearchUrlParameters, "f"), __classPrivateFieldGet(this, _HotelSearchPageMobile_pointOfInterest, "f"));
            // Проверяем, какие отели из пришедших добавлять, в каких добавлять только варианты
            offers.forEach(responseOffer => {
                // Найти такое же предложение в существующих данных
                const applicationOffer = this.options.manager.offers.find(item => item.key === responseOffer.key);
                // Если отеля нет, добавляем его, если был - добавляем его варианты
                if (applicationOffer) {
                    // Проверка на уникальность вариантов одного поставщика
                    App.HotelContinueSearcher.compareApplicationAndResponseVariants(applicationOffer.variants, responseOffer.variants);
                }
                else {
                    // Вновь добавленому предложению проставляем порядок получения - отсчет с 0, поэтому ставим 'length' массива, потом
                    // добавляем элемент
                    responseOffer.gettingOrder = this.options.manager.offers.length;
                    this.options.manager.offers.push(responseOffer);
                }
            });
            // Отрисовываем только те предложения, в которых есть полный набор лучших вариантов
            // для всех запрашиваемых номеров
            return responseOffers
                .filter(w => w.bestVariants !== undefined && w.bestVariants.length > 0);
        });
    }, _HotelSearchPageMobile_checkAndRenderHotelsToCompare = function _HotelSearchPageMobile_checkAndRenderHotelsToCompare() {
        const hotelIdsFromCookie = __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_compare_get).getCompareHotelIdsFromCookie();
        __classPrivateFieldSet(this, _HotelSearchPageMobile_instances, __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_compare_get).markAppHotelsToCompare(hotelIdsFromCookie, this.options.manager.offers, __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotelsToCompare_get)), "a", _HotelSearchPageMobile_hotelsToCompare_set);
        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_compare_get).setCompareLabel(__classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getUrlDataFromFilter(), __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotelsToCompare_get));
    }, _HotelSearchPageMobile_searchBookingCom = function _HotelSearchPageMobile_searchBookingCom() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            (_a = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_checkSearchForm).call(this))
                return;
            __classPrivateFieldSet(this, _HotelSearchPageMobile_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).show();
            try {
                const rooms = __classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.HotelPageUrls.SearchBookingCom), { body: App.createUrlSearchParams(data), signal });
                        if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    const items = (_b = response.data.offers) !== null && _b !== void 0 ? _b : new Array();
                    hasResults = items.length > 0;
                    continueSearch = response.data.continueSearch;
                    const bestOffers = yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_prepareBestVariantsOffers).call(this, items, rooms);
                    __classPrivateFieldSet(this, _HotelSearchPageMobile_instances, response.data.subFilters, "a", _HotelSearchPageMobile_hotFilterSet_set);
                    __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(bestOffers);
                    yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get));
                    if (((_c = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.canceled) !== false) {
                        __classPrivateFieldSet(this, _HotelSearchPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: response.data.dataExpiration,
                            url: App.app.url.route(App.HotelPageUrls.Search),
                        }), "f");
                    }
                    if (hasResults)
                        yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).changeDataSource(bestOffers, true);
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelSearchContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.offers, this, __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get), __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilter_get), __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotFilterSet_get), __classPrivateFieldGet(this, _HotelSearchPageMobile_currentSearchUrlParameters, "f"), rooms, App.app.url.route(App.HotelPageUrls.ContinueSearchBookingCom), __classPrivateFieldGet(this, _HotelSearchPageMobile_pointOfInterest, "f"), hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).hide(), signal)) || hasResults;
                }
                if (!hasResults) {
                    // Note: данные могли остаться от основного поиска.
                    if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_result_get).hasData)
                        (_d = __classPrivateFieldGet(this, _HotelSearchPageMobile_searchExpirationPopup, "f")) === null || _d === void 0 ? void 0 : _d.cancel();
                    this.messenger.show(App.Message.SearchNoVariants);
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_preloader_get).hide();
            }
        });
    }, _HotelSearchPageMobile_onBlockClick = function _HotelSearchPageMobile_onBlockClick(event, data) {
        const hotels = data.data;
        const targetId = parseInt(data.targetId, 10);
        const currentHotel = hotels.find(item => item.key === targetId);
        if (!currentHotel || !currentHotel.link)
            return;
        // TODO: в экскурсиях это вынесено в верхние методы, которые вызывают showDetails в блокклик и поиск по кнопке детального
        // фильтра.
        // TODO: здесь скорее всего сделать тут или в верхних методах - т.к. здесь еще запрос после поиска, то и главный урл и
        // данные приложения меняются
        this.options.manager.variantsKey = currentHotel.link;
        const typeView = $('.js-search-hot-filter').find('.js-view-item[data-code="table"]').hasClass('_active') ? 'table' : 'block';
        let currentBlock = $(event.currentTarget);
        currentBlock = typeView === 'block' ? currentBlock.find(`a#${targetId}`) : currentBlock.find(`div#${targetId}`);
        if (currentBlock.attr('target') === '_blank') {
            window.open(currentHotel.link);
            return;
        }
        App.UrlParameterHelper.setUrlAsIs(currentHotel.link);
        this.options.manager.router.dispatch('on', currentHotel.link);
    }, _HotelSearchPageMobile_changeHotelsToCompare = function _HotelSearchPageMobile_changeHotelsToCompare(event, data) {
        const hotelId = data.targetId;
        if (!hotelId)
            return;
        // Определить, добавить отель или нет - это надо делать здесь,
        // т.к.пока на странице отрисованы отели, пусть даже кука уже изменилась на другой странице,
        // пользователь ожидает действий, в зависимости от того, что отрисовано
        // Т.е. отмечено, что отель в сравнении, но его на другой странице
        // удалили и пользователь опять жмет - он ожидает, что отель удалится. Так и делаем
        const exists = __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotelsToCompare_get).some(item => item === hotelId);
        const hotelIdsFromCookie = __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_compare_get).getCompareHotelIdsFromCookie();
        // Если такого id нет в выбранных к сравнению, добавить
        // Если есть - удалить
        const index = hotelIdsFromCookie.indexOf(hotelId);
        if (!exists) {
            if (index === -1)
                hotelIdsFromCookie.push(hotelId);
        }
        else if (index !== -1) {
            hotelIdsFromCookie.splice(index, 1);
        }
        __classPrivateFieldSet(this, _HotelSearchPageMobile_instances, __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_compare_get).markAppHotelsToCompare(hotelIdsFromCookie, this.options.manager.offers, __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotelsToCompare_get)), "a", _HotelSearchPageMobile_hotelsToCompare_set);
        this.options.manager.offers.forEach(v => {
            $(`[data-id=${v.key}] .js-compare-btn`).toggleClass('_active', v.toCompare);
        });
        // Обновить куку значениями из массива, который получили при разборе куки
        App.Cookie.set("hotelCompare" /* KnownCookie.HotelCompare */, hotelIdsFromCookie.join(','));
        __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_compare_get).setCompareLabel(__classPrivateFieldGet(this, _HotelSearchPageMobile_mainFilter, "f").getUrlDataFromFilter(), __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "a", _HotelSearchPageMobile_hotelsToCompare_get));
    }, _HotelSearchPageMobile_scrollToOutputBlock = function _HotelSearchPageMobile_scrollToOutputBlock() {
        const scrollOffset = __classPrivateFieldGet(this, _HotelSearchPageMobile_scrollToBlock, "f").offset();
        if (scrollOffset)
            window.scrollTo(scrollOffset.left, scrollOffset.top);
    }, _HotelSearchPageMobile_onSearchButtonClick = function _HotelSearchPageMobile_onSearchButtonClick(event) {
        event.preventDefault();
        if (!this.form.validator.form())
            return;
        __classPrivateFieldGet(this, _HotelSearchPageMobile_searchButton, "f").trigger("searchButton:click" /* Events.SearchButtonClick */);
    }, _HotelSearchPageMobile_onReserveVariant = function _HotelSearchPageMobile_onReserveVariant(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const target = $(event.currentTarget);
            const block = target.parents('.js-output-block');
            const hotelKey = parseInt((_a = block.attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
            const hotel = this.options.manager.offers.find(v => v.key === hotelKey);
            if (!hotel)
                return;
            App.emptyArray(this.options.manager.variants);
            this.options.manager.variants.push(...hotel.variants);
            yield this.reserveVariant(target, hotelKey);
        });
    }, _HotelSearchPageMobile_updateReserveBlocks = function _HotelSearchPageMobile_updateReserveBlocks() {
        return __awaiter(this, void 0, void 0, function* () {
            const tasks = new Array();
            Object.entries(this.options.manager.bookedVariants).forEach(([key, value]) => {
                const block = $(`.js-output-block[data-id='${key}']`, this.container);
                tasks.push(this.renderReservedHotelVariants(block, parseInt(key, 10), value));
            });
            yield Promise.all(tasks);
        });
    }, _HotelSearchPageMobile_onActionInfoShow = function _HotelSearchPageMobile_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelSearchPageMobile_instances, "m", _HotelSearchPageMobile_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _HotelSearchPageMobile_loadAnnouncement = function _HotelSearchPageMobile_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _a;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(
                    // TODO: убрать вызов toString после апгрейда "@typescript-eslint/eslint-plugin".
                    App.app.url.route(App.HotelPageUrls.Announcement) + `?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelSearchPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.HotelSearchPageMobile = HotelSearchPageMobile;
})(App || (App = {}));
/// <reference path='HotelPageBase.ts' />
var App;
(function (App) {
    var _HotelSearchPage_instances, _HotelSearchPage_mainFilterWrap, _HotelSearchPage_searchButton, _HotelSearchPage_searchBlock, _HotelSearchPage_scrollToBlock, _HotelSearchPage_searchExpirationPopup, _HotelSearchPage_preloaderField, _HotelSearchPage_mainFilter, _HotelSearchPage_resultField, _HotelSearchPage_hotFilterSetField, _HotelSearchPage_hotFilterField, _HotelSearchPage_form, _HotelSearchPage_responseValidator, _HotelSearchPage_pointOfInterest, _HotelSearchPage_compareField, _HotelSearchPage_hotelsToCompareField, _HotelSearchPage_currentSearchUrlParameters, _HotelSearchPage_searchAbortController, _HotelSearchPage_currentBookBlock, _HotelSearchPage_preloader_get, _HotelSearchPage_result_get, _HotelSearchPage_hotFilterSet_get, _HotelSearchPage_hotFilterSet_set, _HotelSearchPage_hotFilter_get, _HotelSearchPage_compare_get, _HotelSearchPage_hotelsToCompare_get, _HotelSearchPage_hotelsToCompare_set, _HotelSearchPage_checkSearchForm, _HotelSearchPage_search, _HotelSearchPage_cancelSearch, _HotelSearchPage_prepareBestVariantsOffers, _HotelSearchPage_checkAndRenderHotelsToCompare, _HotelSearchPage_searchBookingCom, _HotelSearchPage_onBlockClick, _HotelSearchPage_changeHotelsToCompare, _HotelSearchPage_scrollToOutputBlock, _HotelSearchPage_onSearchButtonClick, _HotelSearchPage_onReserveVariant, _HotelSearchPage_updateReserveBlocks, _HotelSearchPage_onActionInfoShow, _HotelSearchPage_loadAnnouncement;
    class HotelSearchPage extends App.HotelPageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelSearchPage_instances.add(this);
            _HotelSearchPage_mainFilterWrap.set(this, void 0);
            _HotelSearchPage_searchButton.set(this, void 0);
            _HotelSearchPage_searchBlock.set(this, void 0);
            _HotelSearchPage_scrollToBlock.set(this, void 0);
            _HotelSearchPage_searchExpirationPopup.set(this, void 0);
            _HotelSearchPage_preloaderField.set(this, void 0);
            _HotelSearchPage_mainFilter.set(this, void 0);
            _HotelSearchPage_resultField.set(this, void 0);
            _HotelSearchPage_hotFilterSetField.set(this, void 0);
            _HotelSearchPage_hotFilterField.set(this, void 0);
            _HotelSearchPage_form.set(this, void 0);
            _HotelSearchPage_responseValidator.set(this, void 0);
            /**
             * Координаты достопримечательности (или аэропорта или может другой точки, вокруг которой надо искать)
             * 1. При инициализации поиска в контроллере MVC находятся координаты этой точки.
             * 2. Они передаются на клиент в ответе.
             * 3. В продолжении порционного поиска и в поиске по букингу координаты уже не передаются, поэтому их надо
             * сохранять между поисками в этом поле.
             * 4. Если следующий поиск не будет учитывать координаты, то в ответе будет null и это поле обнулится.
             */
            _HotelSearchPage_pointOfInterest.set(this, void 0);
            _HotelSearchPage_compareField.set(this, void 0);
            _HotelSearchPage_hotelsToCompareField.set(this, void 0);
            /**
             * Параметры урла текущего поиска
             * Сохраняем сюда значения с главного фильтра в виде параметров урла при начале поиска и потом юзаем. Таким
             * образом везде, где будут нужны эти данные в дальнейшем (особенно в продолжающемся порционном поиске) они не
             * будут меняться. Раньше, когда каждый раз брала параметры с фильтра, возможна была ситуация, что пока идет
             * запрос, пользователь натыкал фильтр, но кнопку не нажал - и уже значения не правильные.
             */
            _HotelSearchPage_currentSearchUrlParameters.set(this, void 0);
            _HotelSearchPage_searchAbortController.set(this, void 0);
            _HotelSearchPage_currentBookBlock.set(this, void 0);
            if (!this.root.length)
                return;
            const checkinLimit = this.options.checkinLimit == null
                ? undefined
                : { min: App.parseIsoDate(this.options.checkinLimit.min), max: App.parseIsoDate(this.options.checkinLimit.max) };
            __classPrivateFieldSet(this, _HotelSearchPage_mainFilter, new App.HotelSearchMainFilter({
                datesOptions: {
                    minDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    maxDateToOffset: this.options.maxDateToOffset,
                    defaultDateFromShift: this.options.defaultDateFromShift,
                    defaultDateToOffset: this.options.defaultDateToShift - this.options.defaultDateFromShift,
                    minDateFromShift: this.options.minDateFromShift,
                    minDateToOffset: this.options.minDateToOffset,
                },
                hotelStarsValues: {
                    defaultFromValue: this.options.defaultMinCategory,
                    defaultToValue: this.options.defaultMaxCategory,
                },
                peopleOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                },
                roomsOptions: {
                    maxChildAge: this.options.maxChildAge,
                    defaultAdultCountValue: this.options.defaultAdultCount,
                    defaultRoomCountValue: this.options.defaultRoomCount,
                },
                defaultAccommodationTypesOptions: this.options.defaultAccommodationTypes,
            }), "f");
            __classPrivateFieldSet(this, _HotelSearchPage_form, new App.Form({
                root: __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").root,
                disableStepValidation: true,
            }), "f");
            __classPrivateFieldSet(this, _HotelSearchPage_responseValidator, new App.ResponseValidator({
                messenger: this.messenger,
                validator: __classPrivateFieldGet(this, _HotelSearchPage_form, "f").validator,
            }), "f");
            // TODO: много дублирования в названии и обработке элементов с ActivityPаge
            // инициализация элементов
            // TODO: не очень понял, почему многие элементы данной страницы находятся вне ее root.
            __classPrivateFieldSet(this, _HotelSearchPage_mainFilterWrap, $('.js-m-filter-wrap', App.app.appContainerContent), "f");
            __classPrivateFieldSet(this, _HotelSearchPage_searchButton, $('.js-m-filter-submit', this.mainFilter), "f");
            __classPrivateFieldSet(this, _HotelSearchPage_searchBlock, $('.js-hotel-search-block'), "f");
            __classPrivateFieldSet(this, _HotelSearchPage_scrollToBlock, $('.js-search-results-section', this.root), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_cancelSearch).call(this);
                    inst.hide();
                }
            });
            this.components.push(new App.Digest({ container: this.root }), new App.ActionInfoComponent(), new App.BestPriceComponent({ container: this.container, getData: () => [] }));
            __classPrivateFieldGet(this, _HotelSearchPage_searchButton, "f").on("searchButton:click" /* Events.SearchButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_search).call(this); }));
            __classPrivateFieldGet(this, _HotelSearchPage_searchBlock, "f")
                .on("block:click" /* Events.BlockClick */, (e, data) => __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_onBlockClick).call(this, e, data))
                .on("pw:show" /* Events.Show */, '.js-output-block', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const target = $(e.target);
                const hotelKey = parseInt((_a = target.attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                App.emptyArray(this.options.manager.getBookedVariants(hotelKey));
                yield this.renderReservedHotelVariants($(e.currentTarget), hotelKey, undefined);
            }))
                .on("pw:hide" /* Events.Hide */, '.js-output-block', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const target = $(e.target);
                const hotelKey = parseInt((_a = target.attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                yield this.renderReservedHotelVariants($(e.currentTarget), hotelKey, undefined);
            }))
                .on("getCancellation:click" /* Events.GetCancellationClick */, '.js-output-block', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const hotelKey = parseInt((_a = $(e.currentTarget).parents('.js-output-block').attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                yield this.getCancellationRule(e, hotelKey);
            }))
                .on('click', '.js-output-block .js-checkbox-hotel', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_onReserveVariant).call(this, e); }))
                .on("variant:book" /* Events.VariantBook */, '.js-output-block .js-reserve-hotel', (e) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const hotelKey = parseInt((_a = $(e.currentTarget).parents('.js-output-block').attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
                __classPrivateFieldSet(this, _HotelSearchPage_currentBookBlock, $(e.currentTarget), "f");
                yield this.book(hotelKey);
            }));
            this.bookingComButton.on("bookingComButton:click" /* Events.BookingComButtonClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_searchBookingCom).call(this); }));
            __classPrivateFieldGet(this, _HotelSearchPage_searchBlock, "f").on('click', '.js-booking-com-book', e => App.HotelResult.onBookingComClick(e));
            // события для блока с инфо об отеле на карте (возникающем при клике на маркер)
            $('body').on("hotelMarkerInfo:show" /* Events.HotelMarkerInfoShow */, e => __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).bindCheckCancellationRules($(e.target)));
            // TODO: не работает submit на некоторых элементах - типа номеров или дат. И глючит с автокомплитом -
            // выбираем из выпадающего списка стрелками и Enter ? потом жму Enter - и ничего. Возможно из-за того,
            // что перемудрили с контролами.
            this.mainFilter.on('submit', e => __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_onSearchButtonClick).call(this, e));
            $('body').on("to-compare:click" /* Events.ToCompareClick */, (e, data) => __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_changeHotelsToCompare).call(this, e, data));
            __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_cancelSearch).call(this);
                __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).hideProgressDataLoader();
            });
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_onActionInfoShow).call(this, e, data); }));
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, e => {
                var _a;
                const container = ((_a = e.detail) === null || _a === void 0 ? void 0 : _a.container) ? $(e.detail.container) : __classPrivateFieldGet(this, _HotelSearchPage_searchBlock, "f");
                const keys = container.find('input[name="pacngo-offer-sub-ids"]').valString().split(';').filter(v => v !== '');
                if (keys.length <= 0)
                    return;
                let info;
                const variants = new Array();
                if (__classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).activeView === 'block') {
                    info = this.options.manager.offers.find(v => v.key === parseInt(keys[0], 10));
                }
                else if (__classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).activeView === 'table') {
                    const items = Enumerable.from(this.options.manager.offers)
                        .selectMany(v => v.variants, (v1, v2) => ({ offer: v1, variant: v2 }))
                        .where(v => keys.includes(v.variant.key))
                        .toArray();
                    if (items.length > 0) {
                        variants.push(...items.map(v => v.variant));
                        info = items[0].offer;
                    }
                }
                if (!info)
                    return;
                const filterDates = __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getDates();
                const data = {
                    type: 'hotel',
                    filter: {
                        checkin: !filterDates ? new Date() : filterDates[0],
                        checkout: !filterDates ? new Date() : filterDates[1],
                        rooms: __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getRooms(),
                    },
                    info: {
                        key: info.key,
                        name: info.name,
                        categoryName: info.stars,
                        countryName: info.countryName,
                        address: info.address,
                        rating: info.generalRating,
                        pacRating: info.pacRating,
                        tripadvisorRating: info.tripadvisorRating,
                        tripadvisorReviews: info.tripadvisorResponses,
                        facilities: info.facilities,
                    },
                    variants: variants
                        .map(v => ({
                        roomTypeName: v.room,
                        boardName: v.board,
                        quantity: v.quantity,
                        adultCount: v.adultCount,
                        childAges: v.childAges,
                        cancellationPolicy: v.cancellationPolicy,
                        netPrice: v.netPrice,
                        grossPrice: v.grossPrice,
                        price: v.price,
                        totalNetPrice: v.totalNetPrice,
                        totalGrossPrice: v.totalGrossPrice,
                        totalPrice: v.totalPrice,
                        currencyCode: v.currencyCode,
                    })),
                };
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом
                // addEventListener на стороне сайта(при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data,
                    },
                }));
            });
        }
        start() {
            const _super = Object.create(null, {
                start: { get: () => super.start }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.start.call(this);
                $('.js-add-mode-context-message').show();
                const urlParameters = App.UrlParameterHelper.urlParse();
                // соответствуют данные урлу или нет
                const dataMatchUrl = App.UrlParameterHelper.contains(this.options.manager.offersKey);
                // 1. Если данные соответствуют урлу, просто отображаем данные в соответствии с параметрами, не загружаем данные заново
                // 2. Если данные не соответствуют урлу, пихаем парамтры поиска в главный фильтр и запускаем поиск
                // 3. Если это страница поиска, т.е. урл типа hotel/search, то скрываем отображенное, очищаем фильтры и оставляем только форму
                let doSearch = false;
                if (dataMatchUrl) {
                    // устанавливаем параметры необходимые для работы с данными
                    const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).setDataManipulateParameters(urlParameters);
                    yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get), dataManipulateParameters.filtering);
                    const unavailableOfferKeys = this.options.unavailableOfferService.get();
                    if (unavailableOfferKeys.length > 0) {
                        Enumerable.from(this.options.manager.offers)
                            .selectMany(v => v.variants)
                            .forEach(v => (v.available = !unavailableOfferKeys.includes(v.providerItemKey)));
                    }
                    if (this.options.manager.offers.length > 0)
                        yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).changeDataSource(this.options.manager.offers);
                    yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoSearch), this.getFilterSerializeArray());
                }
                else if (this.requiredUrlChecker.isValid(urlParameters) && !App.UrlParameterHelper.isManual(urlParameters)) {
                    doSearch = true;
                    // TODO: возможно, надо будет сделать очистку формы, но пока пусть будет так
                    __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).resetDataSource();
                    yield this.getSeo(urlParameters, App.app.url.route(App.HotelPageUrls.SeoSearch), this.getFilterSerializeArray());
                }
                __classPrivateFieldGet(this, _HotelSearchPage_mainFilterWrap, "f").showByClass();
                this.mainFilter.showByClass();
                if (this.options.searchError)
                    __classPrivateFieldGet(this, _HotelSearchPage_searchBlock, "f").showByClass();
                // если надо делать автопоиск сразу при загрузке скрипта
                // Это делается, если введен url в браузер и надо найти все, что в нем
                yield __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").setFromParameters(urlParameters);
                if (doSearch)
                    yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_search).call(this, false);
            });
        }
        stop() {
            var _a;
            __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_cancelSearch).call(this);
            (_a = __classPrivateFieldGet(this, _HotelSearchPage_searchExpirationPopup, "f")) === null || _a === void 0 ? void 0 : _a.cancel();
            // TODO: очередной костыль - скрыть popup жжОсско
            $('.js-popup').hide();
            __classPrivateFieldGet(this, _HotelSearchPage_mainFilterWrap, "f").hideByClass();
            this.mainFilter.hideByClass();
            __classPrivateFieldGet(this, _HotelSearchPage_searchBlock, "f").hideByClass();
        }
        /**
         * Возвращает сериализованный массив полей фильтра.
         * Переопределен из-за услуг. Возможно, после прически фильтров, уберется
         */
        getFilterSerializeArray() {
            return this.mainFilter.find('input').not('[name="Facility"]').serializeArray();
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        reservationComplete(basketVariants, contextNumber) {
            if (!__classPrivateFieldGet(this, _HotelSearchPage_currentBookBlock, "f"))
                return Promise.resolve();
            const url = __classPrivateFieldGet(this, _HotelSearchPage_currentBookBlock, "f").attr('href');
            if (url) {
                if (__classPrivateFieldGet(this, _HotelSearchPage_currentBookBlock, "f").attr('target') === '_blank') {
                    window.open(url);
                }
                else {
                    App.UrlParameterHelper.setUrlAsIs(url);
                    this.options.manager.router.dispatch('on', url);
                }
            }
            __classPrivateFieldSet(this, _HotelSearchPage_currentBookBlock, undefined, "f");
            return Promise.resolve();
        }
        getHotelVariantsUrlData() {
            return __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getUrlDataFromFilter();
        }
    }
    _HotelSearchPage_mainFilterWrap = new WeakMap(), _HotelSearchPage_searchButton = new WeakMap(), _HotelSearchPage_searchBlock = new WeakMap(), _HotelSearchPage_scrollToBlock = new WeakMap(), _HotelSearchPage_searchExpirationPopup = new WeakMap(), _HotelSearchPage_preloaderField = new WeakMap(), _HotelSearchPage_mainFilter = new WeakMap(), _HotelSearchPage_resultField = new WeakMap(), _HotelSearchPage_hotFilterSetField = new WeakMap(), _HotelSearchPage_hotFilterField = new WeakMap(), _HotelSearchPage_form = new WeakMap(), _HotelSearchPage_responseValidator = new WeakMap(), _HotelSearchPage_pointOfInterest = new WeakMap(), _HotelSearchPage_compareField = new WeakMap(), _HotelSearchPage_hotelsToCompareField = new WeakMap(), _HotelSearchPage_currentSearchUrlParameters = new WeakMap(), _HotelSearchPage_searchAbortController = new WeakMap(), _HotelSearchPage_currentBookBlock = new WeakMap(), _HotelSearchPage_instances = new WeakSet(), _HotelSearchPage_preloader_get = function _HotelSearchPage_preloader_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPage_preloaderField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPage_preloaderField, new App.Preloader(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPage_preloaderField, "f");
    }, _HotelSearchPage_result_get = function _HotelSearchPage_result_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPage_resultField, "f")) {
            __classPrivateFieldSet(this, _HotelSearchPage_resultField, new App.HotelSearchResult({
                hotFilter: __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get),
                maxHotelsToCompare: this.options.maxHotelsToCompare,
                onAfterDataDraw: () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_updateReserveBlocks).call(this); }),
            }), "f");
        }
        return __classPrivateFieldGet(this, _HotelSearchPage_resultField, "f");
    }, _HotelSearchPage_hotFilterSet_get = function _HotelSearchPage_hotFilterSet_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPage_hotFilterSetField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPage_hotFilterSetField, new App.HotelHotFilterSet(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPage_hotFilterSetField, "f");
    }, _HotelSearchPage_hotFilterSet_set = function _HotelSearchPage_hotFilterSet_set(value) {
        __classPrivateFieldSet(this, _HotelSearchPage_hotFilterSetField, value, "f");
    }, _HotelSearchPage_hotFilter_get = function _HotelSearchPage_hotFilter_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPage_hotFilterField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPage_hotFilterField, new App.HotelSearchHotFilter(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPage_hotFilterField, "f");
    }, _HotelSearchPage_compare_get = function _HotelSearchPage_compare_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPage_compareField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPage_compareField, new App.CompareTempName(new App.CompareDomElements()), "f");
        return __classPrivateFieldGet(this, _HotelSearchPage_compareField, "f");
    }, _HotelSearchPage_hotelsToCompare_get = function _HotelSearchPage_hotelsToCompare_get() {
        if (!__classPrivateFieldGet(this, _HotelSearchPage_hotelsToCompareField, "f"))
            __classPrivateFieldSet(this, _HotelSearchPage_hotelsToCompareField, new Array(), "f");
        return __classPrivateFieldGet(this, _HotelSearchPage_hotelsToCompareField, "f");
    }, _HotelSearchPage_hotelsToCompare_set = function _HotelSearchPage_hotelsToCompare_set(value) {
        __classPrivateFieldSet(this, _HotelSearchPage_hotelsToCompareField, value, "f");
    }, _HotelSearchPage_checkSearchForm = function _HotelSearchPage_checkSearchForm() {
        let msg = '';
        $('.js-point-code', $('.hotels-results__search-line', this.root)).each((index, elem) => {
            var _a;
            if (((_a = $(elem).val()) === null || _a === void 0 ? void 0 : _a.toString()) === '0')
                msg = 'Такого элемента поиска не найдено. Необходимо выбрать элемент поиска из выпадающего списка.';
        });
        const popup = new App.Popup();
        if (msg) {
            popup.show({
                group: 'filter',
                content: msg,
                modal: false,
                delay: 500,
            });
            return false;
        }
        return true;
    }, _HotelSearchPage_search = function _HotelSearchPage_search() {
        return __awaiter(this, arguments, void 0, function* (isManual = true) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            (_a = __classPrivateFieldGet(this, _HotelSearchPage_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            (_b = __classPrivateFieldGet(this, _HotelSearchPage_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
            __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).resetDataSource();
            if (!__classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_checkSearchForm).call(this))
                return;
            __classPrivateFieldSet(this, _HotelSearchPage_currentSearchUrlParameters, __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getUrlDataFromFilter(), "f");
            __classPrivateFieldSet(this, _HotelSearchPage_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelSearchPage_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).show();
            try {
                const rooms = __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const url = App.app.url.route(App.HotelPageUrls.Search);
                    const bodyParams = App.createUrlSearchParams(data);
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(url, { body: bodyParams, signal });
                        if (!__classPrivateFieldGet(this, _HotelSearchPage_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    if (!new App.SearchLocker().check(response.data)) {
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).hide();
                        return;
                    }
                    const items = (_c = response.data.offers) !== null && _c !== void 0 ? _c : new Array();
                    // Определение наличия результатов поиска
                    hasResults = items.length > 0;
                    continueSearch = response.data.continueSearch;
                    // Установить переменную с координатами точки поиска
                    __classPrivateFieldSet(this, _HotelSearchPage_pointOfInterest, response.data.pointOfInterest, "f");
                    App.emptyArray(this.options.manager.offers);
                    const bestOffers = yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_prepareBestVariantsOffers).call(this, items, rooms);
                    __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_checkAndRenderHotelsToCompare).call(this);
                    __classPrivateFieldSet(this, _HotelSearchPage_instances, response.data.subFilters, "a", _HotelSearchPage_hotFilterSet_set);
                    __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(Enumerable.from(items)
                        .selectMany(v => v.variants)
                        .toArray());
                    __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get).category = new App.HotelHotCategory();
                    // Если поиск происходит после ввода адреса с параметрами, не перезаписывать историю,
                    // т.к. этот адрес и так в истории, а другие параметры удаляются, например, хотфильтры
                    const urlParameters = App.UrlParameterHelper.urlParse();
                    if (isManual) {
                        // 1. При вводе урла оставляем сортировку как есть, т.к. человек ввел урл и ждет определенного набора и порядка
                        // данных. Если нет сортировки, то ставим по-умолчанию.
                        // 2. При нажатии кнопки Поиск меняем сортировку на указанную - меняем поле сортировки, меняем активность
                        // кнопок сортировки. Урл не меняем, т.к. в данном случае это типа по-умолчанию.
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).setDataManipulateParameters([
                            {
                                name: 'sort',
                                values: ["price" /* SortByItem.Price */],
                            },
                            {
                                name: App.HotelHotFilterFields.Categories,
                                values: [
                                    (_e = (_d = data.find(v => v.name.toLowerCase() === App.HotelFilterFields.CategoryFrom)) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '1',
                                    (_g = (_f = data.find(v => v.name.toLowerCase() === App.HotelFilterFields.CategoryTo)) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : '5',
                                ],
                            },
                        ]);
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        App.UrlParameterHelper.setUrlAsIs(response.data.seo.url);
                        if (App.Hotel.isAccommodationPointType(data))
                            App.removeAllElements(dataManipulateParameters.filtering, v => v.name === App.HotelHotFilterFields.Categories);
                        yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get), dataManipulateParameters.filtering);
                    }
                    else {
                        // устанавливаем параметры, необходимые для работы с данными
                        const dataManipulateParameters = yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).setDataManipulateParameters(urlParameters);
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).setFilterSortItems(dataManipulateParameters.sorting);
                        // TODO: какой-то винегрет - цены выпадают из общей концепции, поэтому пихаю в них данные как-то через зад
                        if (App.Hotel.isAccommodationPointType(data))
                            App.removeAllElements(dataManipulateParameters.filtering, v => v.name === App.HotelHotFilterFields.Categories);
                        yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get), dataManipulateParameters.filtering);
                    }
                    this.options.manager.offersKey = response.data.seo.url;
                    if (__classPrivateFieldGet(this, _HotelSearchPage_pointOfInterest, "f")) {
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).showSortByDistance();
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).addPointOfInterestOnMap(__classPrivateFieldGet(this, _HotelSearchPage_pointOfInterest, "f"));
                    }
                    else {
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).hideSortByDistance();
                    }
                    __classPrivateFieldSet(this, _HotelSearchPage_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: App.app.url.route(App.HotelPageUrls.Search),
                    }), "f");
                    // Дальше идет отрисовка результата и другие манипуляции, связанные с ней.
                    if (hasResults)
                        yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).changeDataSource(bestOffers);
                    App.app.seo.update(response.data.seo);
                    __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_scrollToOutputBlock).call(this);
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelSearchContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.offers, this, __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get), __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get), __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get), __classPrivateFieldGet(this, _HotelSearchPage_currentSearchUrlParameters, "f"), rooms, App.app.url.route(App.HotelPageUrls.ContinueSearch), __classPrivateFieldGet(this, _HotelSearchPage_pointOfInterest, "f"), hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).hide(), signal)) || hasResults;
                }
                if (!hasResults) {
                    (_h = __classPrivateFieldGet(this, _HotelSearchPage_searchExpirationPopup, "f")) === null || _h === void 0 ? void 0 : _h.cancel();
                    __classPrivateFieldGet(this, _HotelSearchPage_searchBlock, "f").showByClass();
                    this.messenger.show(App.Message.SearchNoVariantsWithLink(window.location.href, App.app.settings.tenant == 2 /* KnownTenant.PacUa */));
                }
                // Note: позволяем запускать поиск booking.com только после завершения/отмены основного поиска.
                if (this.options.allowBookingCom) {
                    this.showBookingComButton();
                    $('.js-booking-com-variants-search', this.container).show();
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelSearchPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).hide();
            }
        });
    }, _HotelSearchPage_cancelSearch = function _HotelSearchPage_cancelSearch() {
        var _a;
        (_a = __classPrivateFieldGet(this, _HotelSearchPage_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
    }, _HotelSearchPage_prepareBestVariantsOffers = function _HotelSearchPage_prepareBestVariantsOffers(responseOffers, rooms) {
        return __awaiter(this, void 0, void 0, function* () {
            // Перенумеровать по порядку получения
            App.DataTransformer.setGettingOrderToOffers(responseOffers);
            // Получить лучшие предложения для всего, что пришло в ответе
            const currencyConverter = yield App.CurrencyManager.findConverter();
            responseOffers.forEach(item => {
                var _a, _b, _c;
                item.bestVariants = App.BestVariantsSelector.select(item.variants, rooms);
                // выбор цен (если нет разрешений на какие-то цены, то они уже проверены
                // на сервере для вариантов, из которых на клиенте мы отбирали лучшие варианты)
                if (item.bestVariants) {
                    item.netPrice = 0;
                    item.grossPrice = 0;
                    item.price = 0;
                    for (const bestVariant of item.bestVariants) {
                        const rate = (_a = currencyConverter === null || currencyConverter === void 0 ? void 0 : currencyConverter.exchange(1, bestVariant.currencyCode, item.currencyCode)) !== null && _a !== void 0 ? _a : 1;
                        item.netPrice += ((_b = bestVariant.netPrice) !== null && _b !== void 0 ? _b : 0) * rate;
                        item.grossPrice += bestVariant.grossPrice * rate;
                        item.price += ((_c = bestVariant.price) !== null && _c !== void 0 ? _c : 0) * rate;
                    }
                }
            });
            // Сохраняем все пришедшие, немного обработанные данные, в данных приложения
            const offers = App.DataTransformer.hotelsDataTransformation(responseOffers, __classPrivateFieldGet(this, _HotelSearchPage_currentSearchUrlParameters, "f"), __classPrivateFieldGet(this, _HotelSearchPage_pointOfInterest, "f"));
            // Проверяем, какие отели из пришедших добавлять, в каких добавлять только варианты
            offers.forEach(responseOffer => {
                // Найти такое же предложение в существующих данных
                const applicationOffer = this.options.manager.offers.find(item => item.key === responseOffer.key);
                // Если отеля нет, добавляем его, если был - добавляем его варианты
                if (applicationOffer) {
                    // Проверка на уникальность вариантов одного поставщика
                    App.HotelContinueSearcher.compareApplicationAndResponseVariants(applicationOffer.variants, responseOffer.variants);
                }
                else {
                    // Вновь добавленому предложению проставляем порядок получения - отсчет с 0, поэтому ставим 'length' массива, потом
                    // добавляем элемент
                    responseOffer.gettingOrder = this.options.manager.offers.length;
                    this.options.manager.offers.push(responseOffer);
                }
            });
            // Отрисовываем только те предложения, в которых есть полный набор лучших вариантов
            // для всех запрашиваемых номеров
            return responseOffers
                .filter(w => w.bestVariants !== undefined && w.bestVariants.length > 0);
        });
    }, _HotelSearchPage_checkAndRenderHotelsToCompare = function _HotelSearchPage_checkAndRenderHotelsToCompare() {
        const hotelIdsFromCookie = __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_compare_get).getCompareHotelIdsFromCookie();
        __classPrivateFieldSet(this, _HotelSearchPage_instances, __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_compare_get).markAppHotelsToCompare(hotelIdsFromCookie, this.options.manager.offers, __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotelsToCompare_get)), "a", _HotelSearchPage_hotelsToCompare_set);
        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_compare_get).setCompareLabel(__classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getUrlDataFromFilter(), __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotelsToCompare_get));
    }, _HotelSearchPage_searchBookingCom = function _HotelSearchPage_searchBookingCom() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            (_a = __classPrivateFieldGet(this, _HotelSearchPage_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
            this.messenger.hide();
            this.hideBookingComButton();
            if (!__classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_checkSearchForm).call(this))
                return;
            __classPrivateFieldSet(this, _HotelSearchPage_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _HotelSearchPage_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).show();
            try {
                const rooms = __classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getRooms();
                let hasResults = false;
                let continueSearch = false;
                try {
                    const data = this.getFilterSerializeArray();
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.HotelPageUrls.SearchBookingCom), { body: App.createUrlSearchParams(data), signal });
                        if (!__classPrivateFieldGet(this, _HotelSearchPage_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    const items = (_b = response.data.offers) !== null && _b !== void 0 ? _b : new Array();
                    // Определение наличия результатов поиска
                    hasResults = items.length > 0;
                    continueSearch = response.data.continueSearch;
                    const bestOffers = yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_prepareBestVariantsOffers).call(this, items, rooms);
                    __classPrivateFieldSet(this, _HotelSearchPage_instances, response.data.subFilters, "a", _HotelSearchPage_hotFilterSet_set);
                    __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get).price = yield App.DataTransformer.calcMinMaxPriceForOffers(bestOffers);
                    yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get).refreshHotFilters(__classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get));
                    if (((_c = __classPrivateFieldGet(this, _HotelSearchPage_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.canceled) !== false) {
                        __classPrivateFieldSet(this, _HotelSearchPage_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: response.data.dataExpiration,
                            url: App.app.url.route(App.HotelPageUrls.Search),
                        }), "f");
                    }
                    if (hasResults)
                        yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).changeDataSource(bestOffers, true);
                }
                finally {
                    if (hasResults)
                        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).hide();
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                if (continueSearch) {
                    const searcher = new App.HotelSearchContinueSearcher();
                    hasResults = (yield searcher.continueSearch(this.options.manager.offers, this, __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get), __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilter_get), __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotFilterSet_get), __classPrivateFieldGet(this, _HotelSearchPage_currentSearchUrlParameters, "f"), rooms, App.app.url.route(App.HotelPageUrls.ContinueSearchBookingCom), __classPrivateFieldGet(this, _HotelSearchPage_pointOfInterest, "f"), hasResults ? () => { } : () => __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).hide(), signal)) || hasResults;
                }
                if (!hasResults) {
                    // Note: данные могли остаться от основного поиска.
                    if (!__classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_result_get).hasData)
                        (_d = __classPrivateFieldGet(this, _HotelSearchPage_searchExpirationPopup, "f")) === null || _d === void 0 ? void 0 : _d.cancel();
                    __classPrivateFieldGet(this, _HotelSearchPage_searchBlock, "f").showByClass();
                    this.messenger.show(App.Message.SearchNoVariants);
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelSearchPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_preloader_get).hide();
            }
        });
    }, _HotelSearchPage_onBlockClick = function _HotelSearchPage_onBlockClick(event, data) {
        const hotels = data.data;
        const targetId = parseInt(data.targetId, 10);
        const currentHotel = hotels.find(item => item.key === targetId);
        if (!currentHotel || !currentHotel.link)
            return;
        // TODO: в экскурсиях это вынесено в верхние методы, которые вызывают showDetails в блокклик и поиск по кнопке детального
        // фильтра.
        // TODO: здесь скорее всего сделать тут или в верхних методах - т.к. здесь еще запрос после поиска, то и главный урл и
        // данные приложения меняются
        this.options.manager.variantsKey = currentHotel.link;
        const typeView = $('.js-search-hot-filter').find('.js-view-item[data-code="table"]').hasClass('_active') ? 'table' : 'block';
        let currentBlock = $(event.currentTarget);
        currentBlock = typeView === 'block' ? currentBlock.find(`a#${targetId}`) : currentBlock.find(`div#${targetId}`);
        if (currentBlock.attr('target') === '_blank') {
            window.open(currentHotel.link);
            return;
        }
        App.UrlParameterHelper.setUrlAsIs(currentHotel.link);
        this.options.manager.router.dispatch('on', currentHotel.link);
    }, _HotelSearchPage_changeHotelsToCompare = function _HotelSearchPage_changeHotelsToCompare(event, data) {
        const hotelId = data.targetId;
        if (!hotelId)
            return;
        // Определить, добавить отель или нет - это надо делать здесь,
        // т.к.пока на странице отрисованы отели, пусть даже кука уже изменилась на другой странице,
        // пользователь ожидает действий, в зависимости от того, что отрисовано
        // Т.е. отмечено, что отель в сравнении, но его на другой странице
        // удалили и пользователь опять жмет - он ожидает, что отель удалится. Так и делаем
        const exists = __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotelsToCompare_get).some(item => item === hotelId);
        const hotelIdsFromCookie = __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_compare_get).getCompareHotelIdsFromCookie();
        // Если такого id нет в выбранных к сравнению, добавить
        // Если есть - удалить
        const index = hotelIdsFromCookie.indexOf(hotelId);
        if (!exists) {
            if (index === -1)
                hotelIdsFromCookie.push(hotelId);
        }
        else if (index !== -1) {
            hotelIdsFromCookie.splice(index, 1);
        }
        __classPrivateFieldSet(this, _HotelSearchPage_instances, __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_compare_get).markAppHotelsToCompare(hotelIdsFromCookie, this.options.manager.offers, __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotelsToCompare_get)), "a", _HotelSearchPage_hotelsToCompare_set);
        this.options.manager.offers.forEach(v => {
            $(`[data-id=${v.key}] .js-compare-btn`).toggleClass('_active', v.toCompare);
        });
        // Обновить куку значениями из массива, который получили при разборе куки
        App.Cookie.set("hotelCompare" /* KnownCookie.HotelCompare */, hotelIdsFromCookie.join(','));
        __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_compare_get).setCompareLabel(__classPrivateFieldGet(this, _HotelSearchPage_mainFilter, "f").getUrlDataFromFilter(), __classPrivateFieldGet(this, _HotelSearchPage_instances, "a", _HotelSearchPage_hotelsToCompare_get));
    }, _HotelSearchPage_scrollToOutputBlock = function _HotelSearchPage_scrollToOutputBlock() {
        setTimeout(() => {
            const scrollOffset = __classPrivateFieldGet(this, _HotelSearchPage_scrollToBlock, "f").offset();
            if (scrollOffset) {
                $('html, body').stop(true, true);
                window.scrollTo(0, scrollOffset.top);
            }
        }, 700);
    }, _HotelSearchPage_onSearchButtonClick = function _HotelSearchPage_onSearchButtonClick(event) {
        event.preventDefault();
        if (!this.form.validator.form())
            return;
        __classPrivateFieldGet(this, _HotelSearchPage_searchButton, "f").trigger("searchButton:click" /* Events.SearchButtonClick */);
    }, _HotelSearchPage_onReserveVariant = function _HotelSearchPage_onReserveVariant(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const target = $(event.currentTarget);
            const block = target.parents('.js-output-block');
            const hotelKey = parseInt((_a = block.attr('data-id')) !== null && _a !== void 0 ? _a : '0', 10);
            const hotel = this.options.manager.offers.find(v => v.key === hotelKey);
            if (!hotel)
                return;
            App.emptyArray(this.options.manager.variants);
            this.options.manager.variants.push(...hotel.variants);
            yield this.reserveVariant(target, hotelKey);
        });
    }, _HotelSearchPage_updateReserveBlocks = function _HotelSearchPage_updateReserveBlocks() {
        return __awaiter(this, void 0, void 0, function* () {
            const tasks = new Array();
            Object.entries(this.options.manager.bookedVariants).forEach(([key, value]) => {
                const block = $(`.js-output-block[data-id='${key}']`, this.container);
                tasks.push(this.renderReservedHotelVariants(block, parseInt(key, 10), value));
            });
            yield Promise.all(tasks);
        });
    }, _HotelSearchPage_onActionInfoShow = function _HotelSearchPage_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _HotelSearchPage_instances, "m", _HotelSearchPage_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _HotelSearchPage_loadAnnouncement = function _HotelSearchPage_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _a;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(
                    // TODO: убрать вызов toString после апгрейда "@typescript-eslint/eslint-plugin".
                    App.app.url.route(App.HotelPageUrls.Announcement) + `?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _HotelSearchPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _HotelSearchPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.HotelSearchPage = HotelSearchPage;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _BestVariantsSelector_checkVariantMatchRoom, _BestVariantsSelector_scanAllRoomsByCurrentVariant, _BestVariantsSelector_checkRelevanceTourists, _BestVariantsSelector_checkNotRelevanceTourists, _BestVariantsSelector_checkRestOfChildrenMatched, _BestVariantsSelector_sortRooms;
    class BestVariantsSelector {
        /**
         * Подбор лучших вариантов (самых дешевых) для каждого номера с нужным количеством туристов.
         * Пример - если задано два номера с 2 и 3 туристами, то будут найдены по одному
         * с минимальной ценой дабл и трипл
         * @param allVariants - Все варианты
         * @param rooms - Номера с туристами
         * @return - Подобранные варианты по комнатам и количеству туристов
         */
        static select(allVariants, rooms) {
            // 1. Номера сортировать по релевантности - сначала взрослые, потом дети.
            // Возраст детей - в порядке убывания, т.к.ребенок может разместиться во взрослом номере,
            // наоборот - нет.
            // TODO: пока не совсем понимаю, зачем нужна была сортировка номеров. Если потом пойму, доработать
            let sortedRooms = Enumerable.from(__classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_sortRooms).call(_a, rooms))
                .select(s => new App.TouristModelWithVariant(s.adultCount, s.childAges))
                .toArray();
            // 2.Варианты - группировать по количеству, сортировать по цене внутри группы,
            // группы сортировать по количеству по возрастанию.
            const groupedSortedVariants = Enumerable.from(allVariants)
                .orderBy(o => o.sortPrice)
                .groupBy(g => g.quantity)
                .orderBy(o => o.key())
                .toArray();
            // Цикл по группам
            groupedSortedVariants.forEach(variantGroup => {
                const variants = variantGroup.toArray();
                for (let i = 0; i < variants.length; i++) {
                    const variant = variants[i];
                    // TODO: надо ли из этого цикла выйти раньше, чем переберем все?
                    // Если все номера уже заполнены вариантами, и по сумме цен они меньше
                    // или равны новому текущему варианту, выходим из цикла
                    if (Enumerable.from(sortedRooms).all(a => a.variant != null)
                        && Enumerable.from(sortedRooms).distinct(d => d.variant)
                            .sum(s => s.variant.sortPrice) <= variant.sortPrice)
                        break;
                    // счетчик взятых вариантов
                    const takenVariantsCounter = { count: 0 };
                    sortedRooms = Enumerable.from(sortedRooms)
                        .orderByDescending(o => (o.variant == null || !o.variant ? Number.MAX_VALUE : o.variant.sortPrice))
                        .toArray();
                    // TODO: здесь лучше сделать цикл while пока не кончатся варианты или пока не найдем нужный вариант
                    for (let j = 0; j < sortedRooms.length; j++) {
                        const sortedRoom = sortedRooms[j];
                        // Проверить, что в принципе есть такое количество номеров
                        // (TODO: пока не делаю, но где-то что - то с количеством надо делать наверное)
                        // Сначала найти те номера, которые строго соответствуют количеству
                        // людей и детей и возрастам детей
                        if (__classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_checkRelevanceTourists).call(_a, sortedRoom, variant)
                            && __classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_checkVariantMatchRoom).call(_a, sortedRoom, variant, sortedRooms, takenVariantsCounter))
                            break;
                        // Если строгого соответствия нет, найти нестрогое и запихнуть
                        // 1. В номерах равно общее количество туристов
                        // 2. Взрослых больше, чем детей
                        // 3. Оставшиеся в варианте дети, отсортированные desc, каждый
                        // старше оставшихся отсортированных в desc детей в номерах
                        // Делаем тоже, что для строгого соответствия по людям
                        // Если сюда пришло, значит, строгого не найдено
                        if (__classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_checkNotRelevanceTourists).call(_a, sortedRoom, variant)
                            && __classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_checkVariantMatchRoom).call(_a, sortedRoom, variant, sortedRooms, takenVariantsCounter))
                            break;
                    }
                }
            });
            // Подведем этоге
            if (Enumerable.from(sortedRooms).any(a => a.variant == null))
                return undefined;
            const result = Enumerable.from(sortedRooms)
                .distinct(d => d.variant)
                .select(s => s.variant)
                .toArray();
            // Проверка на то, чтобы количество в результате точно совпадало
            // с запрашиваемым количеством номеров.
            // Т.е, к примеру, нельзя, чтобы надо было три номера, а выдавали quantity 2+2
            if (Enumerable.from(result).sum(s => s.quantity) !== sortedRooms.length)
                return undefined;
            return Enumerable.from(result)
                .orderBy(o => o.sortPrice)
                .toArray();
        }
    }
    _a = BestVariantsSelector, _BestVariantsSelector_checkVariantMatchRoom = function _BestVariantsSelector_checkVariantMatchRoom(room, variant, sortedRooms, takenVariantsCounter) {
        // Проверим, что в номере нет варианта или он есть, но цена, в пересчете на один номер, больше, чем у
        // проверяемого варианта.
        if (room.variant == null) {
            room.variant = variant;
            takenVariantsCounter.count++;
        }
        else {
            // Выберем из номеров все, совпадающие по туристам с точным соответствием или нет
            const variantRooms = Enumerable.from(sortedRooms)
                .where(w => __classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_checkRelevanceTourists).call(_a, w, variant)
                || __classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_checkNotRelevanceTourists).call(_a, w, variant))
                .toArray();
            // Эти условия уже мало поддаются комментированию и пониманию. Это типа на случай, когда в текущем
            // номере есть вариант и он дешевле текущего, но если мы не засунем текущий, то останемся вообще без
            // вариантов (пример - надо 5 номеров по 2 взрослых, есть варианты - 2 по 1 штуке и 2 по 4, мы
            // запихнули первый два по 1 шт, но 4 не можем запихнуть, т.к. при делении на количество 1 меньше 4-х и
            // мы не можем его заменить).
            if ((room.variant.sortPrice / room.variant.quantity > variant.sortPrice / variant.quantity)
                || (variantRooms.every(c => c.variant != null)
                    && Enumerable.from(variantRooms).count(c => c.variant.key === variant.key) < variant.quantity
                    && room.variant.quantity < variant.quantity
                    && Enumerable.from(variantRooms).distinct(d => d.variant).sum(s => s.variant.sortPrice)
                        !== variantRooms.length)) {
                // Если количество таких равно или больше Quantity в варианте, записываем в номер, выходим из цикла
                if (variantRooms.length >= variant.quantity
                    && !__classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_scanAllRoomsByCurrentVariant).call(_a, room, variant, sortedRooms, takenVariantsCounter, true))
                    __classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_scanAllRoomsByCurrentVariant).call(_a, room, variant, sortedRooms, takenVariantsCounter, false);
            }
        }
        return takenVariantsCounter.count === variant.quantity;
    }, _BestVariantsSelector_scanAllRoomsByCurrentVariant = function _BestVariantsSelector_scanAllRoomsByCurrentVariant(room, variant, sortedRooms, takenVariantsCounter, includeCurrentRoom) {
        // Заполняем временный вариант настоящими вариантами, которые должны остаться неизменными до конца метода
        // отбора лучших вариантов.
        sortedRooms.forEach(f => (f.tempVariant = f.variant));
        // Сортировка номеров по количеству номеров в вариантах. Если вариант еще пустой, то он рассматривается как
        // 0. ВКЛЮЧАЕМ или исключаем текущий номер из поиска в зависимости от признака (Исключить, на случай, если
        // он дороже, но остальные еще пустые).
        const sortedByQuantityRooms = Enumerable.from(sortedRooms)
            .where(w => w.tempVariant == null || includeCurrentRoom || room.variant == null || w.tempVariant.key !== room.variant.key)
            .orderBy(o => (!o.tempVariant ? 0 : o.tempVariant.quantity))
            .toArray();
        // Признак, что в этом проходе был найден и добавлен вариант
        let addedInThisIteration = false;
        sortedByQuantityRooms.forEach(sortedRoom => {
            if (sortedRoom.tempVariant == null) {
                sortedRoom.tempVariant = variant;
                addedInThisIteration = true;
            }
            else if (sortedRoom.tempVariant.sortPrice / sortedRoom.tempVariant.quantity > variant.sortPrice / variant.quantity) {
                sortedRoom.tempVariant = variant;
                addedInThisIteration = true;
            }
            else if (Enumerable.from(sortedByQuantityRooms).all(a => a.tempVariant != null)
                && Enumerable.from(sortedByQuantityRooms)
                    .count(c => c.tempVariant != null && c.tempVariant.key === variant.key) < variant.quantity
                && Enumerable.from(sortedByQuantityRooms).count(a => a.variant == null) < variant.quantity
                && sortedRoom.tempVariant.quantity < variant.quantity
                && Enumerable.from(sortedByQuantityRooms)
                    .distinct(d => d.tempVariant)
                    .sum(s => (!s.tempVariant ? 0 : s.tempVariant.quantity)) !== sortedByQuantityRooms.length) {
                // Эти условия уже мало поддаются комментированию и пониманию
                // Это типа на  случай, когда в текущем номере есть вариант и он дешевле текущего,
                // но если мы не засунем текущий, то останемся вообще без вариантов
                // (пример - надо 5 номеров по 2 взрослых, есть варианты - 2 по 1 штуке и 2 по 4,
                // мы запихнули первый два по 1 шт, н о4 не можем запихнуть, т.к.при делении на
                // количество 1 меньше 4 - х и мы не можем его заменить)
                sortedRoom.tempVariant = variant;
                addedInThisIteration = true;
            }
        });
        // Если после добавления текущего варианты во все подходящие номера общее количество номеров
        // (в TempVariant.Quantity)
        // не превышает искомое количество номеров, добавляем текущий вариант к текущему номеру
        let result = false;
        if (Enumerable.from(sortedByQuantityRooms)
            .distinct(d => d.tempVariant)
            .sum(d => (!d.tempVariant ? 0 : d.tempVariant.quantity))
            <= sortedRooms.length && addedInThisIteration) {
            room.variant = variant;
            takenVariantsCounter.count++;
            result = true;
        }
        // Сбрасываем временные варианты
        sortedRooms.forEach(f => (f.tempVariant = undefined));
        return result;
    }, _BestVariantsSelector_checkRelevanceTourists = function _BestVariantsSelector_checkRelevanceTourists(room, variant) {
        if (room.adultCount !== variant.adultCount)
            return false;
        return Enumerable.from(room.childAges)
            .orderBy(v => v)
            .sequenceEqual(Enumerable.from(variant.childAges).orderBy(v => v));
    }, _BestVariantsSelector_checkNotRelevanceTourists = function _BestVariantsSelector_checkNotRelevanceTourists(room, variant) {
        return room.touristCount === variant.touristCount
            && room.adultCount <= variant.adultCount
            && __classPrivateFieldGet(_a, _a, "m", _BestVariantsSelector_checkRestOfChildrenMatched).call(_a, room, variant);
    }, _BestVariantsSelector_checkRestOfChildrenMatched = function _BestVariantsSelector_checkRestOfChildrenMatched(room, variant) {
        // Сортируем детей в варианте
        variant.childAges = Enumerable.from(variant.childAges).orderByDescending(o => o).toArray();
        // Берем нужное количество детей с конца в номере (они уже отсортированы в обратном порядке)
        const restChildren = Enumerable.from(room.childAges)
            .skip(variant.adultCount - room.adultCount).toArray();
        // Если детей не осталось, значит номер для взрослых, проверка пройдена, т.к. на месте взрослого может
        // разместиться любой ребенок.
        let ageMatched = restChildren.length === 0;
        for (let index = 0; index < variant.childAges.length; index++) {
            const variantChildAge = variant.childAges[index];
            ageMatched = variantChildAge > restChildren[index];
        }
        return ageMatched;
    }, _BestVariantsSelector_sortRooms = function _BestVariantsSelector_sortRooms(rooms) {
        return Enumerable.from(rooms)
            // сначала вообще по количеству людей
            .orderBy(o => o.adultCount + o.childAges.length)
            // потом по взрослым в порядке убывания
            .thenByDescending(t => t.adultCount)
            // сортировать детей по возрастам в порядке убывания
            .select(s => new App.TouristsModel(s.adultCount, Enumerable.from(s.childAges).orderByDescending(o => o).toArray()))
            .toArray();
    };
    App.BestVariantsSelector = BestVariantsSelector;
})(App || (App = {}));
var App;
(function (App) {
    var _CancellationRuleChecker_options;
    class CancellationRuleChecker {
        constructor(options) {
            _CancellationRuleChecker_options.set(this, void 0);
            const defaults = {
                url: App.app.url.route(App.HotelPageUrls.GetCancellationPolicy),
            };
            __classPrivateFieldSet(this, _CancellationRuleChecker_options, Object.assign(defaults, options), "f");
        }
        /**
         ** Получает правила отмены для каждого варианта размещения
         * @param targetElement - элемент, по которому кликнули для проверки правил отмены
         * @param messenger - компонент для показа сообщений и ошибок
         */
        // [Obsolete]
        getCancellationRule(targetElement, messenger) {
            return __awaiter(this, void 0, void 0, function* () {
                const variantKey = targetElement.attr('data-variant-key');
                if (!variantKey)
                    return undefined;
                const xhr = $.ajax({
                    url: __classPrivateFieldGet(this, _CancellationRuleChecker_options, "f").url,
                    method: 'GET',
                    data: {
                        variantKey,
                        cancellationPolicyCode: targetElement.attr('data-cancellation-policy-code'),
                    },
                    beforeSend: () => {
                        // После получения ответа эта штука заменится вместе со всем контентом
                        $('.js-progress-data-loading', targetElement).show();
                    },
                });
                const responseValidator = new App.ResponseValidator({ messenger });
                let cancellationVariant;
                try {
                    const response = yield xhr;
                    if (!responseValidator.process(response))
                        return cancellationVariant;
                    cancellationVariant = response.data;
                    if (!cancellationVariant)
                        return cancellationVariant;
                }
                catch (ex) {
                    if (!responseValidator.processError(ex))
                        throw ex;
                }
                return cancellationVariant;
            });
        }
        /**
         ** Получает правила отмены для каждого варианта размещения
         * @param targetElement - элемент, по которому кликнули для проверки правил отмены
         * @param messenger - компонент для показа сообщений и ошибок
         */
        getCancellationPolicy(targetElement, messenger) {
            return __awaiter(this, void 0, void 0, function* () {
                const xhr = $.ajax({
                    url: __classPrivateFieldGet(this, _CancellationRuleChecker_options, "f").url,
                    method: 'GET',
                    data: {
                        variantKey: targetElement.attr('data-variant-key'),
                        cancellationPolicyCode: targetElement.attr('data-cancellation-policy-code'),
                    },
                    beforeSend: () => {
                        // После получения ответа эта штука заменится вместе со всем контентом
                        $('.js-progress-data-loading', targetElement).show();
                    },
                });
                const responseValidator = new App.ResponseValidator({ messenger });
                try {
                    const response = yield xhr;
                    if (!responseValidator.process(response))
                        return null;
                    return response.data;
                }
                catch (ex) {
                    if (!responseValidator.processError(ex))
                        throw ex;
                }
                return null;
            });
        }
        /**
         * Отрисовка изменившейся политики отмены
         * @param newCancellationPolicy - новая политика отмены
         * @param targetElement - jQuery элемент который надо заменить
         * @param cancellationInfoHide - показывать всплывающую таблицу со всеми условиями размещения или нет
         */
        static renderChangedCancellationPolicy(newCancellationPolicy, targetElement, cancellationInfoHide) {
            var _a;
            if (!newCancellationPolicy)
                return;
            const content = $(App.templates.CancellationPolicy({
                cancellationVariant: newCancellationPolicy,
                currencyCode: (_a = newCancellationPolicy.currencyCode) !== null && _a !== void 0 ? _a : targetElement.data('currencyCode'),
                cancellationInfoHide,
            }));
            targetElement.replaceWith(content);
        }
    }
    _CancellationRuleChecker_options = new WeakMap();
    App.CancellationRuleChecker = CancellationRuleChecker;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Класс, преобразующий данные
     */
    class DataTransformer {
        /**
         * Перенумеровывает предложения отелей по порядку получения
         * Проставляет свойство gettingOrder в соответсвии с индексом элемента в массиве
         * @param offers - массив предложений для сортировки
         */
        static setGettingOrderToOffers(offers) {
            offers.forEach((offer, index) => {
                offer.gettingOrder = index;
            });
        }
        /**
         * Преобразование полученных данных по отелям
         * @param rawData - не обработанные данные
         * @param currentSearchUrlParameters - Параметры урла текущего поиска
         * @param pointOfInterest - достопримечательность
         */
        static hotelsDataTransformation(rawData, currentSearchUrlParameters, pointOfInterest) {
            // удалим лишние параметры из параметров урла
            const reducedSearchUrlParameters = currentSearchUrlParameters
                .filter(v => ![App.HotelUrlParameters.location, App.HotelUrlParameters.category, App.HotelUrlParameters.types].includes(v.name));
            return rawData.map(item => {
                item.link = App.app.url.route(App.HotelPageUrls.Info, item.key, reducedSearchUrlParameters);
                if (pointOfInterest && item.coordinate) {
                    item.distanceFromPointOfInterest = Math.round(App.distance(pointOfInterest.coordinate, item.coordinate));
                    item.distanceFromPointOfInterestText = `${item.distanceFromPointOfInterest.toLocaleString('ru-ru')} км от ${pointOfInterest.name}`;
                }
                return item;
            });
        }
        /**
         * Готовит данные по вариантам для передачи в шаблон
         */
        static variantsDataTransformation(variants, bestVariants) {
            variants.forEach(variant => {
                // Сначала очищаем предыдущие 'лучшие варианты', т.к. с приходом новой порции поиска они могут изменится
                variant.isBest = false;
                // Потом проставляем признак 'лучший вариант', если совпадает с лучшим
                if (bestVariants) {
                    const best = bestVariants.find(v => variant.key === v.key);
                    if (best)
                        best.isBest = true;
                }
            });
            return variants;
        }
        /**
         * Вычисляет минимальную и максимальную цену в отелях
         * @param offers
         */
        static calcMinMaxPriceForOffers(offers) {
            return __awaiter(this, void 0, void 0, function* () {
                const prices = new App.HotelHotPrice();
                if (offers.length <= 0)
                    return prices;
                const convertedGrossPrices = new Array();
                /* eslint-disable no-await-in-loop */
                for (let i = 0; i < offers.length; i++) {
                    const temp = yield App.CurrencyManager.exchange(offers[i].totalGrossPrice, offers[i].currencyCode);
                    if (temp != null)
                        convertedGrossPrices.push(temp);
                }
                /* eslint-enable no-await-in-loop */
                const defaultMin = 0;
                prices.min = convertedGrossPrices.length > 0
                    ? Enumerable.from(convertedGrossPrices).min(m => m)
                    : defaultMin;
                const defaultMax = 500000;
                prices.max = convertedGrossPrices.length > 0
                    ? Enumerable.from(convertedGrossPrices).max(m => m)
                    : defaultMax;
                prices.currencyCode = App.Cookie.get("currency" /* KnownCookie.Currency */) || '';
                return prices;
            });
        }
        static hotelInfoTransform(hotel) {
            if (hotel.description == null)
                return hotel;
            const matchedParagraphs = hotel.description
                .replace(/<p>/g, '')
                .replace(/<\/p>/g, '\n')
                .split(/\r\n|\n\r|\n|\r/g);
            const paragraphs = matchedParagraphs != null
                ? matchedParagraphs.map(p => (p ? `<p>${p.trim()}</p>` : ''))
                : new Array();
            hotel.description = paragraphs.join('');
            return hotel;
        }
    }
    App.DataTransformer = DataTransformer;
})(App || (App = {}));
var App;
(function (App) {
    var _DifferentFacilitiesPresenter_instances, _DifferentFacilitiesPresenter_compareFacilitiesLink, _DifferentFacilitiesPresenter_compareFacilitiesCheckBox, _DifferentFacilitiesPresenter_root, _DifferentFacilitiesPresenter_hotels, _DifferentFacilitiesPresenter_differentFacilitiesField, _DifferentFacilitiesPresenter_differentFacilities_get, _DifferentFacilitiesPresenter_onFacilitiesSwitch, _DifferentFacilitiesPresenter_showAllFacilities, _DifferentFacilitiesPresenter_showDifferentFacilities, _DifferentFacilitiesPresenter_findDifferentFacilities;
    class DifferentFacilitiesPresenter {
        set hotels(value) {
            if (value)
                __classPrivateFieldSet(this, _DifferentFacilitiesPresenter_hotels, value, "f");
            else
                __classPrivateFieldSet(this, _DifferentFacilitiesPresenter_hotels, new Array(), "f");
        }
        constructor(root) {
            _DifferentFacilitiesPresenter_instances.add(this);
            _DifferentFacilitiesPresenter_compareFacilitiesLink.set(this, void 0);
            _DifferentFacilitiesPresenter_compareFacilitiesCheckBox.set(this, void 0);
            _DifferentFacilitiesPresenter_root.set(this, void 0);
            _DifferentFacilitiesPresenter_hotels.set(this, void 0);
            _DifferentFacilitiesPresenter_differentFacilitiesField.set(this, void 0);
            __classPrivateFieldSet(this, _DifferentFacilitiesPresenter_root, root, "f");
            __classPrivateFieldSet(this, _DifferentFacilitiesPresenter_hotels, new Array(), "f");
            __classPrivateFieldSet(this, _DifferentFacilitiesPresenter_compareFacilitiesLink, $('.js-compare-facilities-link', __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_root, "f")), "f");
            __classPrivateFieldSet(this, _DifferentFacilitiesPresenter_compareFacilitiesCheckBox, $('.js-compare-facilities-check', __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_compareFacilitiesLink, "f")), "f");
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_compareFacilitiesLink, "f").on('click', () => __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_instances, "m", _DifferentFacilitiesPresenter_onFacilitiesSwitch).call(this));
        }
        hideFacilitiesLink() {
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_compareFacilitiesLink, "f").hideByClass();
        }
    }
    _DifferentFacilitiesPresenter_compareFacilitiesLink = new WeakMap(), _DifferentFacilitiesPresenter_compareFacilitiesCheckBox = new WeakMap(), _DifferentFacilitiesPresenter_root = new WeakMap(), _DifferentFacilitiesPresenter_hotels = new WeakMap(), _DifferentFacilitiesPresenter_differentFacilitiesField = new WeakMap(), _DifferentFacilitiesPresenter_instances = new WeakSet(), _DifferentFacilitiesPresenter_differentFacilities_get = function _DifferentFacilitiesPresenter_differentFacilities_get() {
        if (!__classPrivateFieldGet(this, _DifferentFacilitiesPresenter_differentFacilitiesField, "f"))
            __classPrivateFieldSet(this, _DifferentFacilitiesPresenter_differentFacilitiesField, __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_instances, "m", _DifferentFacilitiesPresenter_findDifferentFacilities).call(this), "f");
        return __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_differentFacilitiesField, "f");
    }, _DifferentFacilitiesPresenter_onFacilitiesSwitch = function _DifferentFacilitiesPresenter_onFacilitiesSwitch() {
        if (__classPrivateFieldGet(this, _DifferentFacilitiesPresenter_compareFacilitiesCheckBox, "f").hasClass('_active')) {
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_compareFacilitiesCheckBox, "f").removeClass('_active');
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_instances, "m", _DifferentFacilitiesPresenter_showAllFacilities).call(this);
        }
        else {
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_compareFacilitiesCheckBox, "f").addClass('_active');
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_instances, "m", _DifferentFacilitiesPresenter_showDifferentFacilities).call(this);
        }
    }, _DifferentFacilitiesPresenter_showAllFacilities = function _DifferentFacilitiesPresenter_showAllFacilities() {
        if (!__classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f"))
            return;
        if (__classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f")) {
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f").forEach(hotel => {
                const facilitiesBlock = $(`a#${hotel.key} .js-hotel-facilities`, __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_root, "f"));
                if (!facilitiesBlock)
                    return;
                const content = App.templates.Hotel.Compare.Facilities(hotel.renderFacilities);
                facilitiesBlock.html(content);
            });
        }
    }, _DifferentFacilitiesPresenter_showDifferentFacilities = function _DifferentFacilitiesPresenter_showDifferentFacilities() {
        if (!__classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f"))
            return;
        if (__classPrivateFieldGet(this, _DifferentFacilitiesPresenter_instances, "a", _DifferentFacilitiesPresenter_differentFacilities_get)) {
            __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_instances, "a", _DifferentFacilitiesPresenter_differentFacilities_get).forEach(different => {
                const facilitiesBlock = $(`a#${different.hotelId} .js-hotel-facilities`, __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_root, "f"));
                if (!facilitiesBlock)
                    return;
                const content = App.templates.Hotel.Compare.Facilities(different.facilities);
                facilitiesBlock.html(content);
            });
        }
    }, _DifferentFacilitiesPresenter_findDifferentFacilities = function _DifferentFacilitiesPresenter_findDifferentFacilities() {
        // Создадим объект различающихся услуг для последующей отрисовки
        const differentFacilities = __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f").map(hotel => ({
            hotelId: hotel.key,
            facilities: new Array(),
        }));
        // Возьмем список услуг первого отеля за основу и сделаем по нему цикл
        const baseFacilities = __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f")[0].renderFacilities;
        for (let firstIndex = 0; firstIndex < baseFacilities.length; firstIndex++) {
            // В каждом проходе брать в каждом последующем отеле (поэтому цикл с 1 индекса) услугу с тем же
            // индексом и проверять, на совпадение с исходной (исходная - это услуга в первом отеле, совпадение
            // проверять как по наличию услуги так и по отсутствию - просто isExist === isExist).
            for (let hotelsIndex = 1; hotelsIndex < __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f").length; hotelsIndex++) {
                // Если совпадают - идти дальше по отелям и услугам с тем же индексом, не совпадают - прерывать
                // проверку и добавлять к различающимся услугам все услуги с этим индексом из других отелей.
                if (baseFacilities[firstIndex].isExist !== __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f")[hotelsIndex].renderFacilities[firstIndex].isExist) {
                    differentFacilities.forEach(different => {
                        const hotel = __classPrivateFieldGet(this, _DifferentFacilitiesPresenter_hotels, "f").find(item => item.key === different.hotelId);
                        if (!hotel)
                            return;
                        different.facilities.push(hotel.renderFacilities[firstIndex]);
                    });
                    break;
                }
            }
        }
        return differentFacilities;
    };
    App.DifferentFacilitiesPresenter = DifferentFacilitiesPresenter;
})(App || (App = {}));
var App;
(function (App) {
    let Hotel;
    (function (Hotel) {
        /**
         * Проверяет, выбран чекбокс выбора варианта или нет - true - выбран, false - выбор снят
         * @param variantContainer - контейнер с вариантами
         * @param variantId - id варианта
         */
        Hotel.isSelectedVariant = (variantContainer, variantId) => {
            const checkedElement = variantContainer.find(`.js-checkbox-hotel[data-id="${variantId}"]`);
            // Если чекбокс отмечен, добавить вариант, если не отмечен - нет, т.е. отнять
            return checkedElement.hasClass('checked');
        };
        /**
         * Выбрать вариант  - отмечает чекбокс выбора варианта или снимает выбор
         * @param variantContainer - контейнер с вариантами
         * @param variantId - id варианта
         * @param state
         */
        Hotel.toggleVariant = (variantContainer, variantId, state) => {
            const checkedElement = variantContainer.find(`.js-checkbox-hotel[data-id="${variantId}"]`);
            checkedElement.toggleClass('checked', state);
            checkedElement.siblings('.js-select-count').toggle(state);
        };
        Hotel.isAccommodationPointType = (data) => {
            return data
                .filter(v => v.name.toLowerCase() === App.HotelFilterFields.PointType)
                .some(v => v.value.toLowerCase() === App.HotelPointType.Accommodation);
        };
    })(Hotel = App.Hotel || (App.Hotel = {}));
})(App || (App = {}));
var App;
(function (App) {
    let HotelSortFields;
    (function (HotelSortFields) {
        HotelSortFields.Alphabet = 'alphabet';
        HotelSortFields.Distance = 'distance';
        HotelSortFields.Getting = 'getting';
        HotelSortFields.PeopleCount = 'peoplecount';
        HotelSortFields.Price = 'price';
        HotelSortFields.Rating = 'rating';
        HotelSortFields.StarRating = 'starrating';
    })(HotelSortFields = App.HotelSortFields || (App.HotelSortFields = {}));
})(App || (App = {}));
var App;
(function (App) {
    var _HotelsMap_instances, _a, _HotelsMap_googleMap, _HotelsMap_mapContainer, _HotelsMap_hotelOnMapInfoContainer, _HotelsMap_markers, _HotelsMap_blockTemplate, _HotelsMap_hotelOffers, _HotelsMap_markerInfoPosition, _HotelsMap_styleMapPosition, _HotelsMap_firstLoad, _HotelsMap_addHotelsOnMap, _HotelsMap_mapGenerateMarkers, _HotelsMap_bindMarkers, _HotelsMap_selectMarker, _HotelsMap_resetMarkersIcons, _HotelsMap_setMarkerIconActivity, _HotelsMap_deleteInfoMarker, _HotelsMap_showMarkerInfo, _HotelsMap_mapRecenter, _HotelsMap_generatePointOfInterestMarker;
    class HotelsMap {
        constructor() {
            _HotelsMap_instances.add(this);
            _HotelsMap_googleMap.set(this, void 0);
            _HotelsMap_mapContainer.set(this, void 0);
            _HotelsMap_hotelOnMapInfoContainer.set(this, void 0);
            _HotelsMap_markers.set(this, void 0);
            _HotelsMap_blockTemplate.set(this, void 0);
            _HotelsMap_hotelOffers.set(this, void 0);
            _HotelsMap_markerInfoPosition.set(this, void 0);
            _HotelsMap_styleMapPosition.set(this, void 0);
            _HotelsMap_firstLoad.set(this, void 0);
            __classPrivateFieldSet(this, _HotelsMap_mapContainer, $('.js-hotels-town-output-map'), "f");
            __classPrivateFieldSet(this, _HotelsMap_hotelOnMapInfoContainer, $('.js-resorts-map-info-wrap', __classPrivateFieldGet(this, _HotelsMap_mapContainer, "f")), "f");
            __classPrivateFieldSet(this, _HotelsMap_blockTemplate, App.templates.Hotel.Table, "f");
            __classPrivateFieldSet(this, _HotelsMap_markers, new Array(), "f");
            __classPrivateFieldSet(this, _HotelsMap_hotelOffers, new Array(), "f");
            __classPrivateFieldSet(this, _HotelsMap_markerInfoPosition, google.maps.ControlPosition.BOTTOM_CENTER, "f");
            __classPrivateFieldSet(this, _HotelsMap_styleMapPosition, google.maps.ControlPosition.TOP_LEFT, "f");
            __classPrivateFieldSet(this, _HotelsMap_firstLoad, true, "f");
        }
        initMap() {
            __classPrivateFieldSet(this, _HotelsMap_googleMap, new App.GoogleMap('HotelMap', {}, '.js-hotels-town-output-map'), "f");
            if (!__classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map) {
                return;
            }
            const additionalMapOptions = {
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP,
                },
                styles: [
                    {
                        featureType: 'poi',
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }],
                    },
                ],
            };
            __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").setAdditionalOptions(additionalMapOptions);
            const styleControl = document.getElementById('style-selector-control');
            __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _HotelsMap_styleMapPosition, "f")].push(styleControl);
            __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_addHotelsOnMap).call(this);
            __classPrivateFieldGet(this, _HotelsMap_mapContainer, "f").on('click', '.map-control-option', e => this.changeStyleMap(e));
        }
        changeStyleMap(event) {
            $('#style-selector-control .map-control-option').removeClass('_on');
            $(event.currentTarget).addClass('_on');
            const id = $(event.currentTarget).attr('id');
            __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.setOptions({
                styles: [
                    {
                        featureType: 'poi',
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        featureType: `poi.${id}`,
                        stylers: [{ visibility: 'on' }],
                    },
                ],
            });
        }
        addHotelPoints(hotelOffers) {
            __classPrivateFieldSet(this, _HotelsMap_hotelOffers, __classPrivateFieldGet(this, _HotelsMap_hotelOffers, "f").concat(hotelOffers), "f");
            if (this.isInitMap()) {
                __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_addHotelsOnMap).call(this, hotelOffers);
            }
        }
        isInitMap() {
            return __classPrivateFieldGet(this, _HotelsMap_googleMap, "f") != undefined;
        }
        isActiveMap() {
            return !__classPrivateFieldGet(this, _HotelsMap_mapContainer, "f").is(':hidden');
        }
        resetPoints() {
            __classPrivateFieldGet(this, _HotelsMap_markers, "f").forEach(v => {
                v.setMap(null);
            });
            __classPrivateFieldSet(this, _HotelsMap_markers, new Array(), "f");
            __classPrivateFieldSet(this, _HotelsMap_hotelOffers, new Array(), "f");
            __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").resetPoints();
            __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_deleteInfoMarker).call(this);
            __classPrivateFieldSet(this, _HotelsMap_firstLoad, true, "f");
        }
        /**
         * Обновляет карту
         * Вызывать после добавления на нее отелей для нового центрирования
         */
        renewMap() {
            __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").renewMapCenter();
            __classPrivateFieldGet(this, _HotelsMap_hotelOnMapInfoContainer, "f").hide();
        }
        /**
         * Показывает карту по отелю (по клику)
         * @param selectedOffer
         */
        openMapByOffer(selectedOffer) {
            const finded = __classPrivateFieldGet(this, _HotelsMap_markers, "f").find(value => value.id === selectedOffer.key);
            if (finded) {
                __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.setZoom(18);
                // Сделаем типа-клик на маркер
                google.maps.event.trigger(finded, 'click');
            }
        }
        /**
         * Добавляет достопримечательность на карту
         * @param pointOfInterest
         */
        addPointOfInterestOnMap(pointOfInterest) {
            if (!this.isInitMap())
                this.initMap();
            if (!__classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map) {
                return;
            }
            __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_generatePointOfInterestMarker).call(this, pointOfInterest);
            this.renewMap();
        }
    }
    _a = HotelsMap, _HotelsMap_googleMap = new WeakMap(), _HotelsMap_mapContainer = new WeakMap(), _HotelsMap_hotelOnMapInfoContainer = new WeakMap(), _HotelsMap_markers = new WeakMap(), _HotelsMap_blockTemplate = new WeakMap(), _HotelsMap_hotelOffers = new WeakMap(), _HotelsMap_markerInfoPosition = new WeakMap(), _HotelsMap_styleMapPosition = new WeakMap(), _HotelsMap_firstLoad = new WeakMap(), _HotelsMap_instances = new WeakSet(), _HotelsMap_addHotelsOnMap = function _HotelsMap_addHotelsOnMap(addOffers = []) {
        const offers = addOffers.length > 0 ? addOffers : __classPrivateFieldGet(this, _HotelsMap_hotelOffers, "f");
        const coordinates = offers.map(v => v.coordinate);
        __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").addMapPoints(coordinates);
        setTimeout(() => {
            // генерим новые маркеры
            __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_mapGenerateMarkers).call(this, offers);
            if (addOffers.length > 0 && __classPrivateFieldGet(this, _HotelsMap_firstLoad, "f")) {
                this.renewMap();
                __classPrivateFieldSet(this, _HotelsMap_firstLoad, false, "f");
            }
            $('#style-selector-control', __classPrivateFieldGet(this, _HotelsMap_mapContainer, "f")).show();
        }, 500);
    }, _HotelsMap_mapGenerateMarkers = function _HotelsMap_mapGenerateMarkers(hotelOffers) {
        hotelOffers.forEach(offer => {
            const point = new google.maps.LatLng(offer.coordinate.latitude, offer.coordinate.longitude);
            const jqMarkerContent = $(App.templates.Money({ amount: offer.totalGrossPrice, currency: offer.currencyCode, format: '0' }));
            const markerContent = jqMarkerContent.get(0);
            if (!markerContent)
                return;
            const found = __classPrivateFieldGet(this, _HotelsMap_markers, "f").find(value => value.id === offer.key);
            if (found) {
                if (found.minPrice !== offer.totalGrossPrice) {
                    found.minPrice = offer.totalGrossPrice;
                    found.updateContent(markerContent.outerHTML);
                    if (found.selected)
                        google.maps.event.trigger(found, 'click');
                }
            }
            else {
                const marker = new App.CustomMarker(point, __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map, {
                    markerId: offer.key,
                    content: markerContent.outerHTML,
                    minPrice: offer.totalGrossPrice,
                });
                // Добавляем маркер в объект с маркерами
                __classPrivateFieldGet(this, _HotelsMap_markers, "f").push(marker);
                // Навешиваем обработчики на маркер
                __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_bindMarkers).call(this, marker, offer);
            }
        });
    }, _HotelsMap_bindMarkers = function _HotelsMap_bindMarkers(marker, hotelOffer) {
        // Клик по маркеру
        marker.addListener('click', () => __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_selectMarker).call(this, marker, hotelOffer));
    }, _HotelsMap_selectMarker = function _HotelsMap_selectMarker(marker, hotelOffer) {
        __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_resetMarkersIcons).call(this);
        __classPrivateFieldGet(_a, _a, "m", _HotelsMap_setMarkerIconActivity).call(_a, marker, true);
        const markerPosition = marker.getPosition();
        if (markerPosition)
            __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_mapRecenter).call(this, markerPosition, 0, 50);
        __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_showMarkerInfo).call(this, hotelOffer);
    }, _HotelsMap_resetMarkersIcons = function _HotelsMap_resetMarkersIcons() {
        for (let i = 0; i < __classPrivateFieldGet(this, _HotelsMap_markers, "f").length; ++i) {
            __classPrivateFieldGet(_a, _a, "m", _HotelsMap_setMarkerIconActivity).call(_a, __classPrivateFieldGet(this, _HotelsMap_markers, "f")[i], false);
            __classPrivateFieldGet(this, _HotelsMap_markers, "f")[i].selected = false;
        }
    }, _HotelsMap_setMarkerIconActivity = function _HotelsMap_setMarkerIconActivity(marker, activity) {
        const overlay = marker.getOverlay();
        if (!overlay)
            return;
        $(overlay).removeClass('_selected');
        marker.selected = false;
        if (activity) {
            $(overlay).addClass('_selected');
            marker.selected = true;
        }
    }, _HotelsMap_deleteInfoMarker = function _HotelsMap_deleteInfoMarker() {
        __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_resetMarkersIcons).call(this);
        __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _HotelsMap_markerInfoPosition, "f")].clear();
    }, _HotelsMap_showMarkerInfo = function _HotelsMap_showMarkerInfo(hotelOffer) {
        __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _HotelsMap_markerInfoPosition, "f")].clear();
        if (__classPrivateFieldGet(this, _HotelsMap_blockTemplate, "f") == null)
            return;
        const onMap = { onMap: true };
        const content = $(__classPrivateFieldGet(this, _HotelsMap_blockTemplate, "f").call(this, [Object.assign(Object.assign({}, hotelOffer), onMap)]));
        const closeButton = $('.js-map-info-close', content);
        App.NetPricePresenter.setVisibility(content, App.NetPricePresenter.getVisibility());
        const hotelInfo = content.get()[0];
        hotelInfo.classList.add('_opened');
        const hotelInfoContainer = document.createElement('div');
        hotelInfoContainer.className = 'tours-output-table resorts-map-info-wrap';
        hotelInfoContainer.appendChild(hotelInfo);
        __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _HotelsMap_markerInfoPosition, "f")].push(hotelInfoContainer);
        closeButton.on('click', () => {
            __classPrivateFieldGet(this, _HotelsMap_instances, "m", _HotelsMap_deleteInfoMarker).call(this);
        });
        // TODO: навесила на body, чтобы не ковыряться в Result или PageManager для поулчения этого блока. Может
        // все же открыть доступ к нему и навесить событие адресно.
        $('body').trigger("hotelMarkerInfo:show" /* Events.HotelMarkerInfoShow */);
    }, _HotelsMap_mapRecenter = function _HotelsMap_mapRecenter(latlng, offsetx, offsety) {
        const projection = __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.getProjection();
        if (projection == null)
            return;
        const latLng = (latlng instanceof google.maps.LatLng) ? latlng : __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.getCenter();
        if (latLng == null)
            return;
        const zoom = __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.getZoom();
        if (zoom == null)
            return;
        const oldPoint = projection.fromLatLngToPoint(latLng);
        if (oldPoint == null)
            return;
        const newPoint = new google.maps.Point(((typeof (offsetx) === 'number' ? offsetx : 0) / (Math.pow(2, zoom))) || 0, ((typeof (offsety) === 'number' ? offsety : 0) / (Math.pow(2, zoom))) || 0);
        const newCenter = projection.fromPointToLatLng(new google.maps.Point(oldPoint.x - newPoint.x, oldPoint.y + newPoint.y));
        if (newCenter == null)
            return;
        __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map.panTo(newCenter);
    }, _HotelsMap_generatePointOfInterestMarker = function _HotelsMap_generatePointOfInterestMarker(pointOfInterest) {
        const point = new google.maps.LatLng(pointOfInterest.coordinate.latitude, pointOfInterest.coordinate.longitude);
        const contentMarkerData = {
            isWhite: false,
            coordinates: pointOfInterest.coordinate,
            text: pointOfInterest.name,
            type: "places" /* MapPointType.Places */,
        };
        const contentMarker = App.templates.MapMarker(contentMarkerData).toString();
        /* eslint-disable no-new */
        new RichMarker({
            position: point,
            map: __classPrivateFieldGet(this, _HotelsMap_googleMap, "f").map,
            flat: true,
            content: contentMarker,
            optimized: false,
            zIndex: 9999,
        });
        /* eslint-enable no-new */
    };
    App.HotelsMap = HotelsMap;
})(App || (App = {}));
var App;
(function (App) {
    /** Модель туристов в номерах */
    class TouristsModel {
        /**
         * Общее количество туристов в номере.
         */
        get touristCount() {
            return this.adultCount + this.childAges.length;
        }
        constructor(adultCount, childAges) {
            /**
             * Количество взрослых
             */
            Object.defineProperty(this, "adultCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Возраста детей - массив возрастов в годах
             */
            Object.defineProperty(this, "childAges", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.adultCount = adultCount;
            this.childAges = childAges;
        }
    }
    App.TouristsModel = TouristsModel;
})(App || (App = {}));
/// <reference path='../models/TouristsModel.ts' />
var App;
(function (App) {
    class TouristModelWithVariant extends App.TouristsModel {
        constructor() {
            super(...arguments);
            /**
             * Подходящий вариант
             */
            Object.defineProperty(this, "variant", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * Временный подходящий вариант. Нужен для заполнения во время перебора и последующего сброса
             */
            Object.defineProperty(this, "tempVariant", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
    }
    App.TouristModelWithVariant = TouristModelWithVariant;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Порционный поисковик отелей.
     * TODO: пока используется только для порционного поиска. Возможно, переименовать соответственно
     */
    class HotelContinueSearcher {
        /**
         * Продолжение поиска
         * Рекурсия, пока continueSearch = true;
         *
         * При начале поиска получаются данные и проверяет свойство continueSearch
         * Если оно true, приходим в этот метод, запускаем его, пока continueSearch не false
         * Порядок получения проставляем данным, полученным при начале поиска скопом для всего массива,
         * Здесь проставляем порядок получения каждому вновьдобавляемому элементу ПЕРЕД добавлением
         * Сначала думала, что данные итак остаются в том порядке, в котором их получили, но оказывается, порядок меняется в методе
         * сортировки
         *
         * @param applicationOffers - предложения приложения (данные, хранящиеся в приложении, с которыми оно работает между поисками)
         * @param previousRawOffers - результаты предыдущего поиска в чистом виде (для нового определения лучших вариантов вместе с новыми
         * порциями и не отрисованными старыми)
         * @param currentSearchUrlParameters - параметры урла текущего поиска
         */
        continueSearch(applicationOffers, page, result, hotFilter, hotFilterSet, currentSearchUrlParameters, rooms, url, pointOfInterest, onFound, signal) {
            return __awaiter(this, void 0, void 0, function* () {
                // TODO: signal.throwIfAborted();
                if (signal.aborted)
                    return false;
                hotFilter.showProgressDataLoader();
                yield App.delay(App.randomInt(5000, 10000), App.noneSignal);
                // TODO: signal.throwIfAborted();
                if (signal.aborted)
                    return false;
                // TODO: как доделаю контроллер, убрать передачу данных с формы
                // TODO: если возникнет желание не убирать форму, то подумать о том, что если каждый раз сериализовать фильтр, можно получить другие данные на форме, т.к. фильтр могут изменить, но не нажать на кнопку поиска
                const data = page.getFilterSerializeArray();
                const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
                // TODO: не использовать retryPolicy на 2-м шаге и последующих.
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const innerResponse = yield App.app.http.postPwJson(App.app.url.route(url), { body: App.createUrlSearchParams(data), signal });
                    if (!App.validateResponse(innerResponse, page.messenger, $(page.mainFilter).validate()) || !innerResponse.data)
                        return;
                    return innerResponse;
                }), signal);
                // TODO: игнорировать ошибки на 2-м шаге и последующих - сразу пробовать повторить запрос, НО ограничивать кол-во попыток, чтобы не зависнуть здесь бесконечно и не мучить сервер в случае проблем на нем (сконфигурировать retryPolicy для этих целей?).
                if (!response)
                    return false;
                // TODO: signal.throwIfAborted();
                if (signal.aborted)
                    return false;
                const responseData = response.data;
                const compareResult = yield this.compareApplicationAndResponseData(applicationOffers, hotFilterSet, currentSearchUrlParameters, responseData, rooms, pointOfInterest);
                const renderOffers = compareResult.offers;
                if (renderOffers.length > 0)
                    onFound();
                if (compareResult.hasNewOffers) {
                    // TODO: сюда мы можем попасть не только с данными 2-й и т.д. порций, но и с самой 1-й порцией, поэтому безусловное использование append=true здесь неверно.
                    yield result.changeDataSource(renderOffers, true);
                }
                if (hotFilterSet) {
                    const urlParameters = App.UrlParameterHelper.urlParse();
                    const filters = yield result.setDataManipulateParameters(urlParameters);
                    if (filters) {
                        if (App.Hotel.isAccommodationPointType(data))
                            App.removeAllElements(filters.filtering, v => v.name === App.HotelHotFilterFields.Categories);
                        yield hotFilter.refreshHotFilters(hotFilterSet, filters.filtering);
                    }
                    else {
                        yield hotFilter.refreshHotFilters(hotFilterSet);
                    }
                }
                // Если надо продолжать поиск, запустить функцию продолжения поиска
                // TODO: signal.throwIfAborted();
                if (signal.aborted)
                    return false;
                if (responseData.continueSearch) {
                    return (yield this.continueSearch(applicationOffers, page, result, hotFilter, hotFilterSet, currentSearchUrlParameters, rooms, url, pointOfInterest, renderOffers.length > 0 ? () => { } : onFound, signal)) || renderOffers.length > 0;
                }
                else {
                    hotFilter.hideProgressDataLoader();
                    this.continueSearchComplete(result, hotFilter, pointOfInterest);
                    return renderOffers.length > 0;
                }
            });
        }
        /**
         * Сравнивает пришедшие варианты с существующими вариантами приложения - новые данные добавляет, существующие игнорирует
         * @param applicationVariants - существующие варианты
         * @param responseVariants - варианты из ответа
         */
        static compareApplicationAndResponseVariants(applicationVariants, responseVariants) {
            // Проверка на уникальность вариантов одного поставщика TODO: коммент с pw2: 'неуникальность может быть только у размещений
            // букинга.'
            for (let i = 0; i < responseVariants.length; i++) {
                const responseVariant = responseVariants[i];
                const existedVariant = applicationVariants
                    .find(item => item.key === responseVariant.key);
                if (!existedVariant)
                    applicationVariants.push(responseVariant);
            }
        }
        /**
         * Завершение продолжающегося поиска - действие, если свойство continuesSearch = false
         * @param applicationOffers - данные приложения
         * @param result - Класс Resul для страницы
         * @param hotFilter - хотфильтры для страницы
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        continueSearchComplete(result, hotFilter, pointOfInterest) {
        }
    }
    App.HotelContinueSearcher = HotelContinueSearcher;
})(App || (App = {}));
var App;
(function (App) {
    class HotelInfoContinueSearcher extends App.HotelContinueSearcher {
        compareApplicationAndResponseData(applicationVariantOffers, hotFilterSet, currentSearchUrlParameters, responseData, rooms) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                const responseVariants = (_a = responseData.variants) !== null && _a !== void 0 ? _a : new Array(0);
                // Проверка на уникальность вариантов одного поставщика
                App.HotelContinueSearcher.compareApplicationAndResponseVariants(applicationVariantOffers, responseVariants);
                // Найдем лучшие варианты
                const bestVariants = App.BestVariantsSelector.select(applicationVariantOffers, rooms);
                // Добавляем в хотфильтры вновьпришедшие данные, пересчитываем фильтры по цене
                hotFilterSet.roomTypes = App.HotelInfoHotFilter.compareHotFilters(responseData.subFilters.roomTypes, hotFilterSet.roomTypes);
                hotFilterSet.boards = App.HotelInfoHotFilter.compareHotFilters(responseData.subFilters.boards, hotFilterSet.boards);
                hotFilterSet.provider = App.HotelInfoHotFilter.compareHotFilters(responseData.subFilters.provider, hotFilterSet.provider);
                hotFilterSet.offerSource = App.HotelInfoHotFilter.compareHotFilters(responseData.subFilters.offerSource, hotFilterSet.offerSource);
                hotFilterSet.price = yield App.DataTransformer.calcMinMaxPriceForOffers(applicationVariantOffers);
                // При сравнении hasVatIncluded учитываем, что если уже есть признак true, мы не можем заменить его на false - т.к. в предыдущей
                // порции уже есть варианты с НДС, а false на true меняем.
                hotFilterSet.vatIncluded = responseData.subFilters.vatIncluded || hotFilterSet.vatIncluded;
                hotFilterSet.transferIncluded = responseData.subFilters.transferIncluded || hotFilterSet.transferIncluded;
                hotFilterSet.visaAssistance = responseData.subFilters.visaAssistance || hotFilterSet.visaAssistance;
                hotFilterSet.inStock = responseData.subFilters.inStock || hotFilterSet.inStock;
                // TODO: выяснить, нужны ли именно лучшие варианты для расчета цены - я не помню, почему я туда передаю лучшие, а не все, которые будут отображены. если они там не нужны, убрать из метода лучшие варианты - они рассчитываются при фильтрации данных (applyFilter)
                return {
                    offers: App.DataTransformer.variantsDataTransformation(applicationVariantOffers, bestVariants),
                    hasNewOffers: responseVariants.length > 0,
                };
            });
        }
    }
    App.HotelInfoContinueSearcher = HotelInfoContinueSearcher;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _HotelSearchContinueSearcher_sortOffers;
    class HotelSearchContinueSearcher extends App.HotelContinueSearcher {
        /**
         * Нюансы реализации - новые отели добавляет, у существующих проверяет варианты размещения и тоже новый добавляет, старые игнорит
         * То же самое с набором хотфильтров - добавляет, если есть новое
         * TODO: получилась функция, которая делает все - сравнивает предложения и хотфлиьтры, обновляет их...
         * @param applicationHotelOffers - предложения приложения по отелям
         * @param currentSearchUrlParameters - параметры урла текущего поиска
         * @param responseData - данные из ответа
         */
        compareApplicationAndResponseData(applicationHotelOffers, hotFilterSet, currentSearchUrlParameters, responseData, rooms, pointOfInterest) {
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                let responseOffers = (_b = responseData.offers) !== null && _b !== void 0 ? _b : new Array(0);
                // Добавить данные к имеющимся и проверять их и проставлять сортировку по получению
                // Сначала добавляем к rawOffers, т.к. мы заново сначала определить на всех данных, потом отсечь предложения БЕЗ полного набора
                // лучших вариантов.
                responseOffers = App.DataTransformer.hotelsDataTransformation(responseOffers, currentSearchUrlParameters, pointOfInterest);
                // Проверяем, какие отели из пришедших добавлять, в каких добавлять только варианты
                responseOffers.forEach(responseOffer => {
                    // Найти такое же предложение в существующих данных
                    const applicationOffer = applicationHotelOffers.find(item => item.key === responseOffer.key);
                    // Если отеля нет, добавляем его, если был - добавляем его варианты
                    if (applicationOffer) {
                        // Проверка на уникальность вариантов одного поставщика
                        App.HotelContinueSearcher.compareApplicationAndResponseVariants(applicationOffer.variants, responseOffer.variants);
                    }
                    else {
                        // Вновь добавленому предложению проставляем порядок получения - отсчет с 0, поэтому ставим 'length' массива, потом
                        // добавляем элемент
                        responseOffer.gettingOrder = applicationHotelOffers.length;
                        applicationHotelOffers.push(responseOffer);
                    }
                });
                // выбрать лучшие варианты для rawOffers (это уже то, что пришло сейчас и предыдущее)
                // TODO: не проверять лучшие предложения заново для всего - только для нового
                const currencyConverter = yield App.CurrencyManager.findConverter();
                applicationHotelOffers.forEach(item => {
                    var _b, _c, _d, _e, _f;
                    item.bestVariants = App.BestVariantsSelector.select(item.variants, rooms);
                    // выбор цен (если нет разрешений на какие-то цены, то они уже проверены на сервере для вариантов, из которых на клиенте мы
                    // отбирали лучшие варианты)
                    if (item.bestVariants) {
                        item.netPrice = 0;
                        item.grossPrice = 0;
                        item.price = 0;
                        item.totalNetPrice = 0;
                        item.totalGrossPrice = 0;
                        item.totalPrice = 0;
                        for (const bestVariant of item.bestVariants) {
                            const rate = (_b = currencyConverter === null || currencyConverter === void 0 ? void 0 : currencyConverter.exchange(1, bestVariant.currencyCode, item.currencyCode)) !== null && _b !== void 0 ? _b : 1;
                            item.netPrice += ((_c = bestVariant.netPrice) !== null && _c !== void 0 ? _c : 0) * rate;
                            item.grossPrice += bestVariant.grossPrice * rate;
                            item.price += ((_d = bestVariant.price) !== null && _d !== void 0 ? _d : 0) * rate;
                            item.totalNetPrice += ((_e = bestVariant.totalNetPrice) !== null && _e !== void 0 ? _e : 0) * rate;
                            item.totalGrossPrice += bestVariant.totalGrossPrice * rate;
                            item.totalPrice += ((_f = bestVariant.totalPrice) !== null && _f !== void 0 ? _f : 0) * rate;
                        }
                    }
                });
                // В итоговый результат идут только те предложения, в которых есть полный набор лучших вариантов для всех запрашиваемых номеров
                const bestVariantOffers = Enumerable.from(applicationHotelOffers)
                    .where(w => w.bestVariants !== undefined && w.bestVariants.length > 0)
                    .toArray();
                // Добавляем в хотфильтры вновьпришедшие данные, пересчитываем фильтры по цене
                hotFilterSet.accommodationTypes = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.accommodationTypes, hotFilterSet.accommodationTypes);
                hotFilterSet.roomTypes = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.roomTypes, hotFilterSet.roomTypes);
                hotFilterSet.boards = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.boards, hotFilterSet.boards);
                hotFilterSet.provider = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.provider, hotFilterSet.provider);
                hotFilterSet.offerSource = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.offerSource, hotFilterSet.offerSource);
                hotFilterSet.areas = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.areas, hotFilterSet.areas);
                hotFilterSet.minRating = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.minRating, hotFilterSet.minRating);
                hotFilterSet.facilities = App.HotelSearchHotFilter.compareHotFilters(responseData.subFilters.facilities, hotFilterSet.facilities);
                hotFilterSet.price = yield App.DataTransformer.calcMinMaxPriceForOffers(Enumerable.from(applicationHotelOffers)
                    .selectMany(v => v.variants)
                    .toArray());
                hotFilterSet.transferIncluded = responseData.subFilters.transferIncluded || hotFilterSet.transferIncluded;
                hotFilterSet.visaAssistance = responseData.subFilters.visaAssistance || hotFilterSet.visaAssistance;
                hotFilterSet.inStock = responseData.subFilters.inStock || hotFilterSet.inStock;
                return {
                    offers: bestVariantOffers,
                    hasNewOffers: responseOffers.length > 0,
                };
            });
        }
        /**
         * В данной реализации показывает окно с вопросом пересортировать по цене или нет
         * @param applicationOffers - данные приложения
         * @param result - Класс Resul для страницы
         * @param hotFilter - хотфильтры для страницы
         */
        continueSearchComplete(result, hotFilter, pointOfInterest) {
            return;
            // Если текущий урл - не search, завершать поиск 'тихо', т.е. без окна.
            if (App.app.url.routeData.action !== 'search')
                return;
            // Загрузить шаблон
            const popupTemplate = $(App.templates.Hotel.Popups.ContinueSearchPopup({}));
            if (popupTemplate) {
                App.popupShow(popupTemplate, '', () => {
                    const distanceSortButton = $('.js-continue-search-popup-sort[data-sort=distance]');
                    if (pointOfInterest)
                        distanceSortButton.showByClass();
                    else
                        distanceSortButton.hideByClass();
                    // Активировать кнопку 'Сортировать по цене'
                    const sortButton = $('.js-continue-search-popup-sort:not(._hidden-2)');
                    sortButton
                        .on('click', e => __classPrivateFieldGet(_a, _a, "m", _HotelSearchContinueSearcher_sortOffers).call(_a, e, result, hotFilter));
                });
            }
        }
    }
    _a = HotelSearchContinueSearcher, _HotelSearchContinueSearcher_sortOffers = function _HotelSearchContinueSearcher_sortOffers(event, result, hotFilter) {
        const targetElement = $(event.target);
        const sortingField = targetElement.attr('data-sort');
        if (sortingField) {
            // Пересортировка предложение отелей по цене
            hotFilter.setFilterSortItems({ field: sortingField, reverse: false }, true);
        }
        // Закрыть попап
        $('body').trigger("popup:close" /* Events.PopupClose */, []);
    };
    App.HotelSearchContinueSearcher = HotelSearchContinueSearcher;
})(App || (App = {}));
var App;
(function (App) {
    var _DynamicGroupCollection_instances, _a, _DynamicGroupCollection_allowMultiple, _DynamicGroupCollection_default, _DynamicGroupCollection_items, _DynamicGroupCollection_matchSingle, _DynamicGroupCollection_matchMultiple, _DynamicGroupCollection_matchGroup;
    class DynamicGroupCollection {
        get items() {
            return __classPrivateFieldGet(this, _DynamicGroupCollection_items, "f");
        }
        set items(value) {
            __classPrivateFieldSet(this, _DynamicGroupCollection_items, value, "f");
        }
        constructor(allowMultiple = false, defaultGroup = null, items) {
            _DynamicGroupCollection_instances.add(this);
            _DynamicGroupCollection_allowMultiple.set(this, void 0);
            _DynamicGroupCollection_default.set(this, void 0);
            _DynamicGroupCollection_items.set(this, void 0);
            __classPrivateFieldSet(this, _DynamicGroupCollection_allowMultiple, allowMultiple, "f");
            __classPrivateFieldSet(this, _DynamicGroupCollection_default, defaultGroup, "f");
            __classPrivateFieldSet(this, _DynamicGroupCollection_items, items || [], "f");
        }
        /**
         * Получить группу(-ы), которые подходят для указанного кандидата.
         * @param candidate
         */
        match(candidate) {
            if (__classPrivateFieldGet(this, _DynamicGroupCollection_allowMultiple, "f"))
                return __classPrivateFieldGet(this, _DynamicGroupCollection_instances, "m", _DynamicGroupCollection_matchMultiple).call(this, candidate);
            return __classPrivateFieldGet(this, _DynamicGroupCollection_instances, "m", _DynamicGroupCollection_matchSingle).call(this, candidate);
        }
    }
    _a = DynamicGroupCollection, _DynamicGroupCollection_allowMultiple = new WeakMap(), _DynamicGroupCollection_default = new WeakMap(), _DynamicGroupCollection_items = new WeakMap(), _DynamicGroupCollection_instances = new WeakSet(), _DynamicGroupCollection_matchSingle = function _DynamicGroupCollection_matchSingle(candidate) {
        const result = __classPrivateFieldGet(this, _DynamicGroupCollection_items, "f").find(v => __classPrivateFieldGet(_a, _a, "m", _DynamicGroupCollection_matchGroup).call(_a, v, candidate));
        if (result)
            return [result];
        if (__classPrivateFieldGet(this, _DynamicGroupCollection_default, "f"))
            return [__classPrivateFieldGet(this, _DynamicGroupCollection_default, "f")];
        return [];
    }, _DynamicGroupCollection_matchMultiple = function _DynamicGroupCollection_matchMultiple(candidate) {
        let result = __classPrivateFieldGet(this, _DynamicGroupCollection_items, "f").filter(v => !v.isExclusive && __classPrivateFieldGet(_a, _a, "m", _DynamicGroupCollection_matchGroup).call(_a, v, candidate));
        if (result.length > 0)
            return result;
        result = Enumerable.from(__classPrivateFieldGet(this, _DynamicGroupCollection_items, "f"))
            .where(v => v.isExclusive)
            .where(v => __classPrivateFieldGet(_a, _a, "m", _DynamicGroupCollection_matchGroup).call(_a, v, candidate))
            .take(2)
            .toArray();
        if (result.length === 1)
            return result;
        if (__classPrivateFieldGet(this, _DynamicGroupCollection_default, "f"))
            return [__classPrivateFieldGet(this, _DynamicGroupCollection_default, "f")];
        return [];
    }, _DynamicGroupCollection_matchGroup = function _DynamicGroupCollection_matchGroup(group, candidate) {
        if (!group.rules || group.rules.length <= 0)
            return false;
        if (group.matchAllRules)
            return group.rules.every(v => v(candidate));
        return group.rules.some(v => v(candidate));
    };
    App.DynamicGroupCollection = DynamicGroupCollection;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Creates generic "equals" DynamicGroupRule.
     * @param names
     */
    const createRangeRule = (minValue, maxValue) => (candidate) => candidate >= minValue
        && candidate <= maxValue;
    class DynamicGroupConfig {
        constructor() {
            Object.defineProperty(this, "ratings", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.ratings = new App.DynamicGroupCollection(false, null, [
                {
                    code: '45',
                    name: 'Отлично 4,5+',
                    sortOrder: 1,
                    isExclusive: false,
                    rules: [
                        createRangeRule(4.5, Number.MAX_VALUE),
                    ],
                },
                {
                    code: '40',
                    name: 'Очень хорошо 4,0+',
                    sortOrder: 2,
                    isExclusive: false,
                    rules: [
                        createRangeRule(4.0, 4.49),
                    ],
                },
                {
                    code: '35',
                    name: 'Хорошо 3,5+',
                    sortOrder: 3,
                    isExclusive: false,
                    rules: [
                        createRangeRule(3.5, 3.99),
                    ],
                },
                {
                    code: '30',
                    name: 'Нормально 3,0+',
                    sortOrder: 4,
                    isExclusive: false,
                    rules: [
                        createRangeRule(3.0, 3.49),
                    ],
                },
            ]);
        }
    }
    App.DynamicGroupConfig = DynamicGroupConfig;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelHotFilterMobile_instances, _a, _HotelHotFilterMobile_hotFilterSet, _HotelHotFilterMobile_onCurrencyChange, _HotelHotFilterMobile_onPriceSliderChange, _HotelHotFilterMobile_replaceListBlockOptions, _HotelHotFilterMobile_setPriceFilterValue, _HotelHotFilterMobile_refreshVatFilter, _HotelHotFilterMobile_setNameFilterValue, _HotelHotFilterMobile_setSingleCheckBoxFilterValue, _HotelHotFilterMobile_setCategoryFilterValue, _HotelHotFilterMobile_setSelectedOptions, _HotelHotFilterMobile_sortByAlphabet, _HotelHotFilterMobile_initSelectListDefaultOption, _HotelHotFilterMobile_triggerOnFiltersChange;
    class HotelHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-search-hot-filter' }, options));
            _HotelHotFilterMobile_instances.add(this);
            /**
             * Набор хотфильтров отеля (на странице поиска)
             */
            _HotelHotFilterMobile_hotFilterSet.set(this, void 0);
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
            $(document).on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelHotFilterMobile_instances, "m", _HotelHotFilterMobile_onCurrencyChange).call(this); }));
            $('.js-filter-slider-block', this.root).on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_onPriceSliderChange).call(_a, e));
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: () => this.onHotFiltersChangeMobile() });
        }
        // TODO: все три метода - дублирование с ActivityHotFilter
        // Обновляет хот-фильтры
        refreshHotFilters(hotFilters, selectedFilters) {
            return __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldSet(this, _HotelHotFilterMobile_hotFilterSet, hotFilters, "f");
                const hotFilterKeys = Object.keys(hotFilters);
                for (let i = 0; i < hotFilterKeys.length; i++) {
                    const key = hotFilterKeys[i];
                    const filterControl = this.filters.findControl(key);
                    if (!filterControl) {
                        // TODO: слайдер батон для vatIncluded пока не отдельный контрол - его нет в коллекции filterControl
                        if (key.toLowerCase() === App.HotelHotFilterFields.VatIncluded)
                            __classPrivateFieldGet(this, _HotelHotFilterMobile_instances, "m", _HotelHotFilterMobile_refreshVatFilter).call(this, hotFilters.vatIncluded, selectedFilters);
                        if (key.toLowerCase() === App.HotelHotFilterFields.Categories)
                            __classPrivateFieldGet(this, _HotelHotFilterMobile_instances, "m", _HotelHotFilterMobile_setCategoryFilterValue).call(this, App.HotelHotFilterFields.Categories, selectedFilters);
                        continue;
                    }
                    const selectedFilterName = key.toLowerCase();
                    const selectedFilter = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.find(v => v.name === selectedFilterName);
                    let optionListData = new Array();
                    switch (selectedFilterName) {
                        case App.HotelHotFilterFields.AccommodationTypes:
                            filterControl.clear(); // .clearOptions(false);
                            // если есть хотя бы один выбранный элемент, 'Все' не выбраны
                            __classPrivateFieldGet(this, _HotelHotFilterMobile_instances, "m", _HotelHotFilterMobile_initSelectListDefaultOption).call(this, App.HotelHotFilterFields.AccommodationTypes, !selectedFilters || selectedFilters
                                .every(filter => filter.name.toLowerCase() !== App.HotelHotFilterFields.AccommodationTypes));
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.AccommodationTypes, hotFilters.accommodationTypes, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.RoomTypes:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.RoomTypes, hotFilters.roomTypes, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.Boards:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.Boards, hotFilters.boards, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.Provider:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.Provider, hotFilters.provider, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            filterControl.root.toggle(optionListData.length > 0);
                            break;
                        case App.HotelHotFilterFields.OfferSource:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.OfferSource, hotFilters.offerSource, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            filterControl.root.toggle(optionListData.length > 0);
                            break;
                        case App.HotelHotFilterFields.Areas:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.Areas, hotFilters.areas, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.MinRating:
                            filterControl.clear(); // .clearOptions(false);
                            // если есть хотя бы один выбранный элемент, 'Все' не выбраны
                            __classPrivateFieldGet(this, _HotelHotFilterMobile_instances, "m", _HotelHotFilterMobile_initSelectListDefaultOption).call(this, App.HotelHotFilterFields.MinRating, !selectedFilters || selectedFilters
                                .every(filter => filter.name.toLowerCase() !== App.HotelHotFilterFields.MinRating));
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.MinRating, hotFilters.minRating, selectedFilters);
                            if (optionListData) {
                                // сортировка рейтинга в порядке убывания значений
                                optionListData.sort((a, b) => {
                                    if (Number(a.value) < Number(b.value))
                                        return (1);
                                    if (Number(a.value) > Number(b.value))
                                        return (-1);
                                    return 0;
                                });
                            }
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.AccommodationName:
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setNameFilterValue).call(_a, App.HotelHotFilterFields.AccommodationName, filterControl, selectedFilters);
                            break;
                        case App.HotelHotFilterFields.Prices:
                            yield __classPrivateFieldGet(this, _HotelHotFilterMobile_instances, "m", _HotelHotFilterMobile_setPriceFilterValue).call(this, hotFilters.price, App.HotelHotFilterFields.Prices, filterControl, selectedFilters);
                            break;
                        case App.HotelHotFilterFields.Facilities:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSelectedOptions).call(_a, App.HotelHotFilterFields.Facilities, hotFilters.facilities, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.FreeCancellation:
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_setSingleCheckBoxFilterValue).call(_a, App.HotelHotFilterFields.FreeCancellation, filterControl, selectedFilters);
                            break;
                        case App.HotelHotFilterFields.TransferIncluded:
                            {
                                const value = selectedFilter
                                    ? selectedFilter.values[0] === 'true'
                                    : false;
                                filterControl.setValue(value);
                                filterControl.root.toggle(hotFilters.transferIncluded);
                                break;
                            }
                        case App.HotelHotFilterFields.VisaAssistance:
                            {
                                const value = selectedFilter
                                    ? selectedFilter.values[0] === 'true'
                                    : false;
                                filterControl.setValue(value);
                                filterControl.root.toggle(hotFilters.visaAssistance);
                                break;
                            }
                        case App.HotelHotFilterFields.InStock:
                            {
                                const value = selectedFilter
                                    ? selectedFilter.values[0] === 'true'
                                    : false;
                                filterControl.setValue(value); // as FilterSlidingButtonBlock).setValue(value);
                                filterControl.root.toggle(hotFilters.inStock);
                                break;
                            }
                        // no default
                    }
                }
                /* eslint-enable no-await-in-loop */
            });
        }
        /**
         * Сравнивает вновьпришедший набор хотфильтров с существующим. Если есть новое, добавляет
         * Работает только со списком для одного фильтра.
         * @param newFilterOptions - новый набор
         * @param oldFilterOptions - старый набор
         */
        static compareHotFilters(newFilterOptions, oldFilterOptions) {
            if (!newFilterOptions || newFilterOptions.length <= 0)
                return oldFilterOptions;
            if (!oldFilterOptions || oldFilterOptions.length === 0)
                return newFilterOptions;
            newFilterOptions.forEach(option => {
                if (!oldFilterOptions.some(item => item.text === option.text))
                    oldFilterOptions.push(option);
            });
            // Возврат обновленных старых опций
            return oldFilterOptions;
        }
        onHotFiltersChange() {
            // const mapper = new HotFilterMapper(this.root);
            // this.root.trigger(Events.FilterFilter, { items: mapper.execute() });
            // NOTE: ничего не делаем по "обычной" подписке - обработаем сами
            // NOTE: этот метод оставлен, чтобы не переписывать весь HotFilter ради изменения в одной строчке кода
        }
        onHotFiltersChangeMobile() {
            return __awaiter(this, void 0, void 0, function* () {
                const mapper = new App.HotFilterMapperMobile(this.root, this.filters);
                const filters = mapper.execute();
                __classPrivateFieldGet(this, _HotelHotFilterMobile_instances, "m", _HotelHotFilterMobile_triggerOnFiltersChange).call(this, filters);
            });
        }
        reset() {
            super.reset();
            this.filters.reset();
        }
        clear() {
            super.clear();
            this.filters.clear();
        }
    }
    _a = HotelHotFilterMobile, _HotelHotFilterMobile_hotFilterSet = new WeakMap(), _HotelHotFilterMobile_instances = new WeakSet(), _HotelHotFilterMobile_onCurrencyChange = function _HotelHotFilterMobile_onCurrencyChange() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            const sliderFrom = $('[data-name="filter_price_from"]', this.root);
            const sliderTo = $('[data-name="filter_price_to"]', this.root);
            const sliderCurrency = $('[data-name="filter_price_currency"]', this.root);
            const fromValue = Number((_b = sliderFrom.attr('data-money-amount')) !== null && _b !== void 0 ? _b : '0');
            const toValue = Number((_c = sliderTo.attr('data-money-amount')) !== null && _c !== void 0 ? _c : '0');
            const fromConvert = yield App.CurrencyManager.exchange(fromValue, (sliderFrom.attr('data-money-amount-currency') || '').toUpperCase());
            let toConvert = yield App.CurrencyManager.exchange(toValue, (sliderTo.attr('data-money-amount-currency') || '').toUpperCase());
            if (!__classPrivateFieldGet(this, _HotelHotFilterMobile_hotFilterSet, "f"))
                return;
            const defMin = __classPrivateFieldGet(this, _HotelHotFilterMobile_hotFilterSet, "f").price.min;
            const defMinConvert = yield App.CurrencyManager.exchange(defMin, __classPrivateFieldGet(this, _HotelHotFilterMobile_hotFilterSet, "f").price.currencyCode.toUpperCase());
            const defMax = __classPrivateFieldGet(this, _HotelHotFilterMobile_hotFilterSet, "f").price.max;
            const defMaxConvert = yield App.CurrencyManager.exchange(defMax, __classPrivateFieldGet(this, _HotelHotFilterMobile_hotFilterSet, "f").price.currencyCode.toUpperCase());
            if (fromConvert == null || toConvert == null || defMinConvert == null || defMaxConvert == null)
                return;
            if (toConvert > defMaxConvert)
                toConvert = defMaxConvert;
            // меняем текущую валюту
            const currencyCode = ($('.js-left-sidebar-currency').filter('._active').attr('data-code') || '').toUpperCase();
            sliderFrom.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
            sliderTo.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
            sliderCurrency.val(currencyCode);
            const priceFilter = this.findControl(App.HotelHotFilterFields.Prices);
            if (priceFilter)
                priceFilter.setValues(fromConvert, toConvert, defMinConvert, defMaxConvert);
        });
    }, _HotelHotFilterMobile_onPriceSliderChange = function _HotelHotFilterMobile_onPriceSliderChange(event) {
        const sliderFrom = $('[data-name="filter_price_from"]', event.target);
        const sliderTo = $('[data-name="filter_price_to"]', event.target);
        sliderFrom.attr('data-money-amount', sliderFrom.attr('data-text') || '');
        sliderTo.attr('data-money-amount', sliderTo.attr('data-text') || '');
        sliderFrom.attr('data-money-amount-currency', sliderFrom.attr('data-money-current') || '');
        sliderTo.attr('data-money-amount-currency', sliderTo.attr('data-money-current') || '');
    }, _HotelHotFilterMobile_replaceListBlockOptions = function _HotelHotFilterMobile_replaceListBlockOptions(filterControl, optionListData) {
        const filterListBlockBase = filterControl;
        if (filterListBlockBase)
            filterListBlockBase.setValueByListOptions(optionListData, true);
    }, _HotelHotFilterMobile_setPriceFilterValue = function _HotelHotFilterMobile_setPriceFilterValue(prices, parameterName, filterControl, selectedFilters) {
        return __awaiter(this, void 0, void 0, function* () {
            const priceControl = filterControl; // as FilterSliderBlock;
            if (!priceControl)
                return;
            // Если цен от и до нет или они равны максимуму и минимуму, то в контрол в качестве значений передаем максимум и минимум
            let priceFromParameter = prices.min;
            let priceToParameter = prices.max;
            if (selectedFilters) {
                const priceFilter = selectedFilters.find(selected => selected.name === parameterName);
                if (priceFilter && priceFilter.values.length === 3) {
                    const tempFrom = parseInt(priceFilter.values[0], 10);
                    priceFromParameter = !Number.isNaN(tempFrom) && tempFrom <= prices.min ? prices.min : tempFrom;
                    const tempTo = parseInt(priceFilter.values[1], 10);
                    priceToParameter = !Number.isNaN(tempTo) && tempTo >= prices.max ? prices.max : tempTo;
                }
            }
            else {
                priceFromParameter = (!prices.from || prices.from >= prices.min) ? prices.min : prices.from;
                priceToParameter = (!prices.to || prices.to <= prices.max) ? prices.max : prices.to;
            }
            let currentCurrency = prices.currencyCode;
            const cookieCurrency = App.Cookie.get("currency" /* KnownCookie.Currency */);
            if (cookieCurrency && cookieCurrency !== currentCurrency) {
                const fromConvert = yield App.CurrencyManager.exchange(priceFromParameter, currentCurrency);
                const toConvert = yield App.CurrencyManager.exchange(priceToParameter, currentCurrency);
                if (fromConvert && toConvert) {
                    priceFromParameter = Math.ceil(fromConvert);
                    priceToParameter = Math.floor(toConvert);
                }
                const minConvert = yield App.CurrencyManager.exchange(prices.min, currentCurrency);
                const maxConvert = yield App.CurrencyManager.exchange(prices.max, currentCurrency);
                if (minConvert && maxConvert) {
                    prices.min = Math.ceil(minConvert);
                    prices.max = Math.floor(maxConvert);
                }
                currentCurrency = cookieCurrency;
            }
            priceControl.setValue({
                min: prices.min,
                max: prices.max,
                from: priceFromParameter,
                to: priceToParameter,
            });
            $('[data-input-name="price_from"]', this.root)
                .attr('data-money-current', currentCurrency)
                .attr('data-money-amount', priceFromParameter)
                .attr('data-money-amount-currency', currentCurrency);
            $('[data-input-name="price_to"]', this.root)
                .attr('data-money-current', currentCurrency)
                .attr('data-money-amount', priceToParameter)
                .attr('data-money-amount-currency', currentCurrency);
            $('[data-input-name="price_currency"]', this.root).val(currentCurrency);
        });
    }, _HotelHotFilterMobile_refreshVatFilter = function _HotelHotFilterMobile_refreshVatFilter(hasVatIncluded, selectedFilters) {
        const filterControl = this.root.find('.js-filter-sliding-btn-b');
        if (!filterControl)
            return;
        if (hasVatIncluded) {
            filterControl.showByClass();
            // TODO: не стала делать отдельный контрол для слайдер батона - меняю значение и класс прямо тут
            const selectedVatIncluded = selectedFilters
                ? selectedFilters.find(filter => filter.name === App.HotelHotFilterFields.VatIncluded)
                : null;
            const isChecked = selectedVatIncluded ? decodeURI(selectedVatIncluded.values[0]) : 'false';
            const input = filterControl.find('input');
            const filterSlidingBtn = this.root.find('.js-sliding-btn');
            filterSlidingBtn.addClass(isChecked === 'true' ? '_on' : '_off');
            filterSlidingBtn.removeClass(isChecked === 'false' ? '_on' : '_off');
            input.val(isChecked);
        }
        else {
            filterControl.hideByClass();
        }
    }, _HotelHotFilterMobile_setNameFilterValue = function _HotelHotFilterMobile_setNameFilterValue(parameterName, filterControl, selectedFilters) {
        const nameControl = filterControl; // as FilterNameBlock;
        if (nameControl && selectedFilters) {
            const nameFilter = selectedFilters.find(filter => filter.name === parameterName);
            nameControl.setValue(nameFilter ? decodeURI(nameFilter.values[0]) : '');
        }
    }, _HotelHotFilterMobile_setSingleCheckBoxFilterValue = function _HotelHotFilterMobile_setSingleCheckBoxFilterValue(parameterName, filterControl, selectedFilters) {
        const nameControl = filterControl; // as FilterSingleCheckBoxBlock;
        if (nameControl && selectedFilters) {
            const nameFilter = selectedFilters.find(filter => filter.name === parameterName);
            nameControl.setValue(nameFilter ? decodeURI(nameFilter.values[0]) : '');
        }
    }, _HotelHotFilterMobile_setCategoryFilterValue = function _HotelHotFilterMobile_setCategoryFilterValue(parameterName, selectedFilters) {
        const filterControl = this.findControl('hotel_stars');
        const nameControl = filterControl;
        if (nameControl && selectedFilters) {
            const nameFilter = selectedFilters.find(filter => filter.name === parameterName);
            if (!nameFilter || nameFilter.values.length !== 2)
                return;
            // найдем значения и проверим их
            const from = parseInt(decodeURI(nameFilter.values[0]), 10);
            const to = parseInt(decodeURI(nameFilter.values[1]), 10);
            if (!from || !to)
                return;
            nameControl.setValues(from, to);
        }
    }, _HotelHotFilterMobile_setSelectedOptions = function _HotelHotFilterMobile_setSelectedOptions(parameterName, hotFilterOptionList, selectedFilters) {
        let optionListData = hotFilterOptionList;
        if (selectedFilters) {
            const currentSelectedFilter = selectedFilters
                .find(filter => filter.name === parameterName);
            if (currentSelectedFilter && currentSelectedFilter.values.length > 0) {
                // если в списке хотфильтра есть такие значения, как в параметрах, помечаем их выбранными
                optionListData = hotFilterOptionList
                    .map(listItem => {
                    // если среди параметров есть значение элемента, делаем элемент выбранным
                    let itemSelected = false;
                    if (currentSelectedFilter.values.some(value => value.toLowerCase() === listItem.value.toLowerCase()))
                        itemSelected = true;
                    return {
                        value: listItem.value,
                        text: listItem.text,
                        selected: itemSelected,
                        custom: listItem.custom,
                    };
                });
            }
        }
        // TODO: пока вынесла в функцию, но не стала убирать из этого метода. Поэтому получается, что рейтинг сортируется дважды
        return Enumerable.from(optionListData)
            .orderByDescending(v => v.sortOrder)
            .thenBy(v => v, (a, b) => __classPrivateFieldGet(_a, _a, "m", _HotelHotFilterMobile_sortByAlphabet).call(_a, a, b))
            .toArray();
    }, _HotelHotFilterMobile_sortByAlphabet = function _HotelHotFilterMobile_sortByAlphabet(a, b) {
        if (a.value === '0')
            return 1;
        if (b.value === '0')
            return -1;
        if (a.value === b.value)
            return 0;
        return a.text < b.text ? -1 : 1;
    }, _HotelHotFilterMobile_initSelectListDefaultOption = function _HotelHotFilterMobile_initSelectListDefaultOption(controlName, selected) {
        const control = this.findControl(controlName);
        if (control) {
            const allOption = { value: '', text: localizer.all, selected };
            control.replaceOptions([allOption], true);
        }
    }, _HotelHotFilterMobile_triggerOnFiltersChange = function _HotelHotFilterMobile_triggerOnFiltersChange(filters) {
        this.root.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
    };
    App.HotelHotFilterMobile = HotelHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelHotFilter_instances, _a, _HotelHotFilter_hotFilterSet, _HotelHotFilter_onCurrencyChange, _HotelHotFilter_onPriceSliderChange, _HotelHotFilter_formatVatIncludeFilter, _HotelHotFilter_formatPriceFilters, _HotelHotFilter_formatCategoryFilters, _HotelHotFilter_replaceListBlockOptions, _HotelHotFilter_setPriceFilterValue, _HotelHotFilter_refreshVatFilter, _HotelHotFilter_setNameFilterValue, _HotelHotFilter_setSingleCheckBoxFilterValue, _HotelHotFilter_setCategoryFilterValue, _HotelHotFilter_setSelectedOptions, _HotelHotFilter_sortByAlphabet, _HotelHotFilter_initSelectListDefaultOption, _HotelHotFilter_triggerOnFiltersChange;
    class HotelHotFilter extends App.HotFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-search-hot-filter' }, options));
            _HotelHotFilter_instances.add(this);
            /**
             * Набор хотфильтров отеля (на странице поиска)
             */
            _HotelHotFilter_hotFilterSet.set(this, void 0);
            $(document).on("app:currencychanged" /* Events.CurrencyChanged */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_onCurrencyChange).call(this); }));
            $('.js-filter-slider-block', this.root).on("filter:change" /* Events.FilterChange */, e => __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_onPriceSliderChange).call(_a, e));
        }
        // TODO: все три метода - дублирование с ActivityHotFilter
        // Обновляет хот-фильтры
        refreshHotFilters(hotFilters, selectedFilters) {
            return __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldSet(this, _HotelHotFilter_hotFilterSet, hotFilters, "f");
                const hotFilterKeys = Object.keys(hotFilters);
                /* eslint-disable no-await-in-loop */
                for (let i = 0; i < hotFilterKeys.length; i++) {
                    const key = hotFilterKeys[i];
                    const filterControl = this.findControl(key);
                    if (!filterControl) {
                        // TODO: слайдер батон для vatIncluded пока не отдельный контрол - его нет в коллекции filterControl
                        if (key.toLowerCase() === App.HotelHotFilterFields.VatIncluded)
                            __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_refreshVatFilter).call(this, hotFilters.vatIncluded, selectedFilters);
                        if (key.toLowerCase() === App.HotelHotFilterFields.Categories)
                            __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_setCategoryFilterValue).call(this, App.HotelHotFilterFields.Categories, selectedFilters);
                        continue;
                    }
                    const selectedFilterName = key.toLowerCase();
                    const selectedFilter = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.find(v => v.name === selectedFilterName);
                    let optionListData = new Array();
                    switch (selectedFilterName) {
                        case App.HotelHotFilterFields.AccommodationTypes:
                            filterControl.clearOptions(false);
                            // если есть хотя бы один выбранный элемент, 'Все' не выбраны
                            __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_initSelectListDefaultOption).call(this, App.HotelHotFilterFields.AccommodationTypes, !selectedFilters || selectedFilters
                                .every(filter => filter.name.toLowerCase() !== App.HotelHotFilterFields.AccommodationTypes));
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.AccommodationTypes, hotFilters.accommodationTypes, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.RoomTypes:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.RoomTypes, hotFilters.roomTypes, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.Boards:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.Boards, hotFilters.boards, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.Provider:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.Provider, hotFilters.provider, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            filterControl.root.toggle(optionListData.length > 0);
                            break;
                        case App.HotelHotFilterFields.OfferSource:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.OfferSource, hotFilters.offerSource, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            filterControl.root.toggle(optionListData.length > 0);
                            break;
                        case App.HotelHotFilterFields.Areas:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.Areas, hotFilters.areas, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.MinRating:
                            filterControl.clearOptions(false);
                            // если есть хотя бы один выбранный элемент, 'Все' не выбраны
                            __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_initSelectListDefaultOption).call(this, App.HotelHotFilterFields.MinRating, !selectedFilters || selectedFilters
                                .every(filter => filter.name.toLowerCase() !== App.HotelHotFilterFields.MinRating));
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.MinRating, hotFilters.minRating, selectedFilters);
                            if (optionListData) {
                                // сортировка рейтинга в порядке убывания значений
                                optionListData.sort((a, b) => {
                                    if (Number(a.value) < Number(b.value))
                                        return (1);
                                    if (Number(a.value) > Number(b.value))
                                        return (-1);
                                    return 0;
                                });
                            }
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.AccommodationName:
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setNameFilterValue).call(_a, App.HotelHotFilterFields.AccommodationName, filterControl, selectedFilters);
                            break;
                        case App.HotelHotFilterFields.Prices:
                            yield __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_setPriceFilterValue).call(this, hotFilters.price, App.HotelHotFilterFields.Prices, filterControl, selectedFilters);
                            break;
                        case App.HotelHotFilterFields.Facilities:
                            optionListData = __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSelectedOptions).call(_a, App.HotelHotFilterFields.Facilities, hotFilters.facilities, selectedFilters);
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_replaceListBlockOptions).call(_a, filterControl, optionListData);
                            break;
                        case App.HotelHotFilterFields.FreeCancellation:
                            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_setSingleCheckBoxFilterValue).call(_a, App.HotelHotFilterFields.FreeCancellation, filterControl, selectedFilters);
                            break;
                        case App.HotelHotFilterFields.TransferIncluded:
                            {
                                const value = selectedFilter
                                    ? selectedFilter.values[0] === 'true'
                                    : false;
                                filterControl.setValue(value);
                                filterControl.root.toggle(hotFilters.transferIncluded);
                                break;
                            }
                        case App.HotelHotFilterFields.VisaAssistance:
                            {
                                const value = selectedFilter
                                    ? selectedFilter.values[0] === 'true'
                                    : false;
                                filterControl.setValue(value);
                                filterControl.root.toggle(hotFilters.visaAssistance);
                                break;
                            }
                        case App.HotelHotFilterFields.InStock:
                            {
                                const value = selectedFilter
                                    ? selectedFilter.values[0] === 'true'
                                    : false;
                                filterControl.setValue(value);
                                filterControl.root.toggle(hotFilters.inStock);
                                break;
                            }
                        // no default
                    }
                }
                /* eslint-enable no-await-in-loop */
            });
        }
        /**
         * Сравнивает вновьпришедший набор хотфильтров с существующим. Если есть новое, добавляет
         * Работает только со списком для одного фильтра.
         * @param newFilterOptions - новый набор
         * @param oldFilterOptions - старый набор
         */
        static compareHotFilters(newFilterOptions, oldFilterOptions) {
            if (!newFilterOptions || newFilterOptions.length <= 0)
                return oldFilterOptions;
            if (!oldFilterOptions || oldFilterOptions.length === 0)
                return newFilterOptions;
            newFilterOptions.forEach(option => {
                if (!oldFilterOptions.some(item => item.text === option.text))
                    oldFilterOptions.push(option);
            });
            // Возврат обновленных старых опций
            return oldFilterOptions;
        }
        onHotFiltersChange() {
            const mapper = new App.HotFilterMapper(this.root);
            const filters = mapper.execute();
            // Удалить из набора фильтров фильтра по ценам и вставить туда их же, но в нужном виде
            // Т.к. для цен отдельные инпуты и они приходят сюда как price.To и price.From, а надо просто price и два значения
            __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_formatPriceFilters).call(this, filters);
            __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_formatCategoryFilters).call(this, filters);
            // Удалим фильтр 'НДС включен', т.к. это его смысл такой - если true - фильтруем, если false - показываем все, т.е. как будто
            // фильтра нет. Найдем в сериализованном массиве формы поля, включающие название поля с ценой.
            __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_formatVatIncludeFilter).call(_a, filters);
            __classPrivateFieldGet(this, _HotelHotFilter_instances, "m", _HotelHotFilter_triggerOnFiltersChange).call(this, filters);
        }
    }
    _a = HotelHotFilter, _HotelHotFilter_hotFilterSet = new WeakMap(), _HotelHotFilter_instances = new WeakSet(), _HotelHotFilter_onCurrencyChange = function _HotelHotFilter_onCurrencyChange() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            const sliderFrom = $('[data-name="filter_price_from"]', this.root);
            const sliderTo = $('[data-name="filter_price_to"]', this.root);
            const sliderCurrency = $('[data-name="filter_price_currency"]', this.root);
            const fromValue = Number((_b = sliderFrom.attr('data-money-amount')) !== null && _b !== void 0 ? _b : '0');
            const toValue = Number((_c = sliderTo.attr('data-money-amount')) !== null && _c !== void 0 ? _c : '0');
            const fromConvert = yield App.CurrencyManager.exchange(fromValue, (sliderFrom.attr('data-money-amount-currency') || '').toUpperCase());
            let toConvert = yield App.CurrencyManager.exchange(toValue, (sliderTo.attr('data-money-amount-currency') || '').toUpperCase());
            if (!__classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f"))
                return;
            const defMin = __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.min;
            const defMinConvert = yield App.CurrencyManager.exchange(defMin, __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.currencyCode.toUpperCase());
            const defMax = __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.max;
            const defMaxConvert = yield App.CurrencyManager.exchange(defMax, __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.currencyCode.toUpperCase());
            if (fromConvert == null || toConvert == null || defMinConvert == null || defMaxConvert == null)
                return;
            if (toConvert > defMaxConvert)
                toConvert = defMaxConvert;
            // меняем текущую валюту
            const currencyCode = ($('.js-left-sidebar-currency').filter('._active').attr('data-code') || '').toUpperCase();
            sliderFrom.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
            sliderTo.attr(App.CurrencyManager.defaults.currentCurrencyAttribute, currencyCode);
            sliderCurrency.val(currencyCode);
            const priceFilter = this.findControl(App.HotelHotFilterFields.Prices);
            if (priceFilter)
                priceFilter.setValues(fromConvert, toConvert, defMinConvert, defMaxConvert);
        });
    }, _HotelHotFilter_onPriceSliderChange = function _HotelHotFilter_onPriceSliderChange(event) {
        const sliderFrom = $('[data-name="filter_price_from"]', event.target);
        const sliderTo = $('[data-name="filter_price_to"]', event.target);
        sliderFrom.attr('data-money-amount', sliderFrom.attr('data-text') || '');
        sliderTo.attr('data-money-amount', sliderTo.attr('data-text') || '');
        sliderFrom.attr('data-money-amount-currency', sliderFrom.attr('data-money-current') || '');
        sliderTo.attr('data-money-amount-currency', sliderTo.attr('data-money-current') || '');
    }, _HotelHotFilter_formatVatIncludeFilter = function _HotelHotFilter_formatVatIncludeFilter(filters) {
        const vatIncluded = filters.find(item => item.name.toLowerCase() === App.HotelHotFilterFields.VatIncluded);
        // Если false, удалим их из результата
        if (vatIncluded && vatIncluded.values[0] === 'false')
            filters.splice(filters.indexOf(vatIncluded), 1);
    }, _HotelHotFilter_formatPriceFilters = function _HotelHotFilter_formatPriceFilters(filters) {
        // Найдем в сериализованном массиве формы поля, включающие название поля с ценой
        const priceRange = filters.filter(item => item.name.includes(App.HotelHotFilterFields.Prices));
        if (!priceRange || priceRange.length <= 0 || !__classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f"))
            return;
        // Удалим их из результата
        // в ценах должно быть 3 значения:
        filters.splice(filters.indexOf(priceRange[0]), 1); // ОТ
        filters.splice(filters.indexOf(priceRange[1]), 1); // ДО
        filters.splice(filters.indexOf(priceRange[2]), 1); // валюта
        // Потом добавим значения from и to в набор хотфильтров
        __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.from = Number(priceRange[0].values[0]);
        __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.to = Number(priceRange[1].values[0]);
        // Если min и max равны from и to, не добавляем цены в параметры фильтрации
        // Т.к. цена - это инпуты, а если в инпутах min и max значения, то фильтровать не надо,
        // соответственно, просто не добавляем значения в параметры фильтрации
        if (__classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.min === __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.from
            && __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.max === __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.to)
            return;
        filters.push({
            name: App.HotelHotFilterFields.Prices,
            values: [
                __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.from.toString(),
                __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").price.to.toString(),
                App.Cookie.get("currency" /* KnownCookie.Currency */) || App.CurrencyManager.currentCurrencyCode,
            ],
        });
    }, _HotelHotFilter_formatCategoryFilters = function _HotelHotFilter_formatCategoryFilters(filters) {
        // Найдем в сериализованном массиве формы поля, включающие название поля с категорией
        const starsRange = filters.filter(item => item.name.includes(App.HotelHotFilterFields.Categories));
        if (!starsRange || starsRange.length <= 0 || !__classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f"))
            return;
        // Удалим их из результата
        // в категориях должно быть 2 значения:
        filters.splice(filters.indexOf(starsRange[0]), 1); // ОТ
        filters.splice(filters.indexOf(starsRange[1]), 1); // ДО
        __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").category = new App.HotelHotCategory();
        // Потом добавим значения from и to в набор хотфильтров
        __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").category.from = Number(starsRange[0].values[0]);
        __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").category.to = Number(starsRange[1].values[0]);
        filters.push({
            name: App.HotelHotFilterFields.Categories,
            values: [
                __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").category.from.toString(),
                __classPrivateFieldGet(this, _HotelHotFilter_hotFilterSet, "f").category.to.toString(),
            ],
        });
    }, _HotelHotFilter_replaceListBlockOptions = function _HotelHotFilter_replaceListBlockOptions(filterControl, optionListData) {
        const filterListBlockBase = filterControl;
        if (filterListBlockBase)
            filterListBlockBase.replaceOptions(optionListData, true);
    }, _HotelHotFilter_setPriceFilterValue = function _HotelHotFilter_setPriceFilterValue(prices, parameterName, filterControl, selectedFilters) {
        return __awaiter(this, void 0, void 0, function* () {
            const priceControl = filterControl;
            if (!priceControl)
                return;
            // Если цен от и до нет или они равны максимуму и минимуму, то в контрол в качестве значений передаем максимум и минимум
            let priceFromParameter = prices.min;
            let priceToParameter = prices.max;
            if (selectedFilters) {
                const priceFilter = selectedFilters.find(selected => selected.name === parameterName);
                if (priceFilter && priceFilter.values.length === 3) {
                    const tempFrom = parseInt(priceFilter.values[0], 10);
                    priceFromParameter = !Number.isNaN(tempFrom) && tempFrom <= prices.min ? prices.min : tempFrom;
                    const tempTo = parseInt(priceFilter.values[1], 10);
                    priceToParameter = !Number.isNaN(tempTo) && tempTo >= prices.max ? prices.max : tempTo;
                }
            }
            else {
                priceFromParameter = (!prices.from || prices.from >= prices.min) ? prices.min : prices.from;
                priceToParameter = (!prices.to || prices.to <= prices.max) ? prices.max : prices.to;
            }
            let currentCurrency = prices.currencyCode;
            const cookieCurrency = App.Cookie.get("currency" /* KnownCookie.Currency */);
            if (cookieCurrency && cookieCurrency !== currentCurrency) {
                const fromConvert = yield App.CurrencyManager.exchange(priceFromParameter, currentCurrency);
                const toConvert = yield App.CurrencyManager.exchange(priceToParameter, currentCurrency);
                if (fromConvert && toConvert) {
                    priceFromParameter = Math.ceil(fromConvert);
                    priceToParameter = Math.floor(toConvert);
                }
                const minConvert = yield App.CurrencyManager.exchange(prices.min, currentCurrency);
                const maxConvert = yield App.CurrencyManager.exchange(prices.max, currentCurrency);
                if (minConvert && maxConvert) {
                    prices.min = Math.ceil(minConvert);
                    prices.max = Math.floor(maxConvert);
                }
                currentCurrency = cookieCurrency;
            }
            priceControl.setValues(priceFromParameter, priceToParameter, prices.min, prices.max);
            $('[data-input-name="price_from"]', this.root)
                .attr('data-money-current', currentCurrency)
                .attr('data-money-amount', priceFromParameter)
                .attr('data-money-amount-currency', currentCurrency);
            $('[data-input-name="price_to"]', this.root)
                .attr('data-money-current', currentCurrency)
                .attr('data-money-amount', priceToParameter)
                .attr('data-money-amount-currency', currentCurrency);
            $('[data-input-name="price_currency"]', this.root).val(currentCurrency);
        });
    }, _HotelHotFilter_refreshVatFilter = function _HotelHotFilter_refreshVatFilter(hasVatIncluded, selectedFilters) {
        const filterControl = this.root.find('.js-filter-sliding-btn-b');
        if (!filterControl)
            return;
        if (hasVatIncluded) {
            filterControl.showByClass();
            // TODO: не стала делать отдельный контрол для слайдер батона - меняю значение и класс прямо тут
            const selectedVatIncluded = selectedFilters
                ? selectedFilters.find(filter => filter.name === App.HotelHotFilterFields.VatIncluded)
                : null;
            const isChecked = selectedVatIncluded ? decodeURI(selectedVatIncluded.values[0]) : 'false';
            const input = filterControl.find('input');
            const filterSlidingBtn = this.root.find('.js-sliding-btn');
            filterSlidingBtn.addClass(isChecked === 'true' ? '_on' : '_off');
            filterSlidingBtn.removeClass(isChecked === 'false' ? '_on' : '_off');
            input.val(isChecked);
        }
        else {
            filterControl.hideByClass();
        }
    }, _HotelHotFilter_setNameFilterValue = function _HotelHotFilter_setNameFilterValue(parameterName, filterControl, selectedFilters) {
        const nameControl = filterControl;
        if (nameControl && selectedFilters) {
            const nameFilter = selectedFilters.find(filter => filter.name === parameterName);
            nameControl.setValue(nameFilter ? decodeURI(nameFilter.values[0]) : '');
        }
    }, _HotelHotFilter_setSingleCheckBoxFilterValue = function _HotelHotFilter_setSingleCheckBoxFilterValue(parameterName, filterControl, selectedFilters) {
        const nameControl = filterControl;
        if (nameControl && selectedFilters) {
            const nameFilter = selectedFilters.find(filter => filter.name === parameterName);
            nameControl.setValue(nameFilter ? decodeURI(nameFilter.values[0]) : '');
        }
    }, _HotelHotFilter_setCategoryFilterValue = function _HotelHotFilter_setCategoryFilterValue(parameterName, selectedFilters) {
        const filterControl = this.findControl('hotel_stars');
        const nameControl = filterControl;
        if (nameControl && selectedFilters) {
            const nameFilter = selectedFilters.find(filter => filter.name === parameterName);
            if (!nameFilter || nameFilter.values.length !== 2)
                return;
            // найдем значения и проверим их
            const from = parseInt(decodeURI(nameFilter.values[0]), 10);
            const to = parseInt(decodeURI(nameFilter.values[1]), 10);
            if (!from || !to)
                return;
            nameControl.setValues(from, to);
        }
    }, _HotelHotFilter_setSelectedOptions = function _HotelHotFilter_setSelectedOptions(parameterName, hotFilterOptionList, selectedFilters) {
        let optionListData = hotFilterOptionList;
        if (selectedFilters) {
            const currentSelectedFilter = selectedFilters
                .find(filter => filter.name === parameterName);
            if (currentSelectedFilter && currentSelectedFilter.values.length > 0) {
                // если в списке хотфильтра есть такие значения, как в параметрах, помечаем их выбранными
                optionListData = hotFilterOptionList
                    .map(listItem => {
                    // если среди параметров есть значение элемента, делаем элемент выбранным
                    let itemSelected = false;
                    if (currentSelectedFilter.values.some(value => value.toLowerCase() === listItem.value.toLowerCase()))
                        itemSelected = true;
                    return {
                        value: listItem.value,
                        text: listItem.text,
                        selected: itemSelected,
                        custom: listItem.custom,
                    };
                });
            }
        }
        // TODO: пока вынесла в функцию, но не стала убирать из этого метода. Поэтому получается, что рейтинг сортируется дважды
        return Enumerable.from(optionListData)
            .orderByDescending(v => v.sortOrder)
            .thenBy(v => v, (a, b) => __classPrivateFieldGet(_a, _a, "m", _HotelHotFilter_sortByAlphabet).call(_a, a, b))
            .toArray();
    }, _HotelHotFilter_sortByAlphabet = function _HotelHotFilter_sortByAlphabet(a, b) {
        if (a.value === '0')
            return 1;
        if (b.value === '0')
            return -1;
        if (a.value === b.value)
            return 0;
        return a.text < b.text ? -1 : 1;
    }, _HotelHotFilter_initSelectListDefaultOption = function _HotelHotFilter_initSelectListDefaultOption(controlName, selected) {
        const control = this.findControl(controlName);
        if (control) {
            const allOption = { value: '', text: localizer.all, selected };
            control.replaceOptions([allOption], true);
        }
    }, _HotelHotFilter_triggerOnFiltersChange = function _HotelHotFilter_triggerOnFiltersChange(filters) {
        this.root.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
    };
    App.HotelHotFilter = HotelHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    class HotelInfoHotFilterMobile extends App.HotelHotFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-detail-hot-filter' }, options));
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('hotel/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.HotelInfoHotFilterMobile = HotelInfoHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class HotelInfoHotFilter extends App.HotelHotFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-detail-hot-filter' }, options));
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('hotel/hotFilterFoundTitle', { count: data.length }));
        }
    }
    App.HotelInfoHotFilter = HotelInfoHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelSearchHotFilterMobile_distanceSortingItem;
    class HotelSearchHotFilterMobile extends App.HotelHotFilterMobile {
        constructor() {
            super({ root: '.js-search-hot-filter' });
            _HotelSearchHotFilterMobile_distanceSortingItem.set(this, void 0);
            __classPrivateFieldSet(this, _HotelSearchHotFilterMobile_distanceSortingItem, $('.js-sort-item[data-sort=distance]', this.root), "f");
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('hotel/hotFilterGroupFoundTitle', {
                groupCount: data.length,
                count: data.reduce((prev, cur) => prev + (cur.variants ? cur.variants.length : 0), 0),
            }));
        }
        showSortByDistance() {
            __classPrivateFieldGet(this, _HotelSearchHotFilterMobile_distanceSortingItem, "f").showByClass();
        }
        hideSortByDistance() {
            __classPrivateFieldGet(this, _HotelSearchHotFilterMobile_distanceSortingItem, "f").hideByClass();
        }
    }
    _HotelSearchHotFilterMobile_distanceSortingItem = new WeakMap();
    App.HotelSearchHotFilterMobile = HotelSearchHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelSearchHotFilter_distanceSortingItem;
    class HotelSearchHotFilter extends App.HotelHotFilter {
        constructor() {
            super({ root: '.js-search-hot-filter' });
            _HotelSearchHotFilter_distanceSortingItem.set(this, void 0);
            __classPrivateFieldSet(this, _HotelSearchHotFilter_distanceSortingItem, $('.js-sort-item[data-sort=distance]', this.root), "f");
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('hotel/hotFilterGroupFoundTitle', {
                groupCount: data.length,
                count: data.reduce((prev, cur) => prev + (cur.variants ? cur.variants.length : 0), 0),
            }));
        }
        showSortByDistance() {
            __classPrivateFieldGet(this, _HotelSearchHotFilter_distanceSortingItem, "f").showByClass();
        }
        hideSortByDistance() {
            __classPrivateFieldGet(this, _HotelSearchHotFilter_distanceSortingItem, "f").hideByClass();
        }
    }
    _HotelSearchHotFilter_distanceSortingItem = new WeakMap();
    App.HotelSearchHotFilter = HotelSearchHotFilter;
})(App || (App = {}));
/// <reference path='../../../common/components/MainFilter.Mobile.ts' />
var App;
(function (App) {
    var _a, _HotelMainFilterMobile_options, _HotelMainFilterMobile_pushUrlParameter;
    class HotelMainFilterMobile extends App.MainFilterMobile {
        constructor(options) {
            super(Object.assign(Object.assign({}, _a.s_defaults), options));
            _HotelMainFilterMobile_options.set(this, void 0); // & Partial<IMainFilterOptions>;
            __classPrivateFieldSet(this, _HotelMainFilterMobile_options, this.getOptions(), "f");
            const filterRoomBlock = $('.js-filter-rooms-block', this.root);
            filterRoomBlock.each((_, v) => {
                const rooms = new App.FilterRoomsAccordionBlock(Object.assign({ root: $(v), filter: this.root }, __classPrivateFieldGet(this, _HotelMainFilterMobile_options, "f").roomsOptions));
                this.controls.push(rooms);
            });
        }
        onFilterChanged(filterName) {
            const _super = Object.create(null, {
                onFilterChanged: { get: () => super.onFilterChanged }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                yield _super.onFilterChanged.call(this, filterName);
                if (filterName == 'Nights') {
                    const dateFrom = this.findFilter('Nights');
                    // const dateTo = this.findFilter<MobileFilterDateBlock>('DateTo');
                    if (dateFrom) {
                        // TODO: я так и не понял, сколько дней от даты начала? на боевом сайте это число меняется, если переключать дату С-По
                        const dateOffset = ((_b = __classPrivateFieldGet(this, _HotelMainFilterMobile_options, "f").datesOptions) === null || _b === void 0 ? void 0 : _b.defaultDateToOffset) || 0;
                        console.log(dateOffset);
                    }
                }
            });
        }
        findFilter(name) {
            const result = this.filters.findControl(name);
            if (!result)
                return result;
            return result;
        }
        getDates() {
            var _b;
            return (_b = this.findControl('dates')) === null || _b === void 0 ? void 0 : _b.getValues();
        }
        /** Получает комнаты, выбранные на фильтре */
        getRooms() {
            var _b, _c;
            const roomsCount = (_b = this.root.find('.js-filter-room-item:not(._hidden-2)')) === null || _b === void 0 ? void 0 : _b.length;
            const touristsArray = [];
            for (let i = 0; i < roomsCount; i++) {
                const filter = this.findFilter(`Rooms.Tourists[${i}]`);
                const value = filter === null || filter === void 0 ? void 0 : filter.getValue();
                touristsArray.push({
                    adultCount: value === null || value === void 0 ? void 0 : value.adults,
                    childAges: (_c = value === null || value === void 0 ? void 0 : value.childAges) !== null && _c !== void 0 ? _c : [],
                });
            }
            return touristsArray;
        }
        /**
         * Устанавливает главный фильтр по параметрам из урла
         * @param urlParameters - параметры из урла
         */
        setFromParameters(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                // сначала очистить форму
                this.root.find('.js-clear-filter').trigger('click');
                // УСТАНОВИТЬ ЗНАЧЕНИЯ ПОЛЕЙ
                // Значение автокомплита
                let pointType = '';
                let pointKey = '';
                const location = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.location);
                if (location && location.values.length === 2)
                    [pointType, pointKey] = location.values;
                if (pointKey && pointType) {
                    const response = yield $.ajax({
                        url: App.app.url.route(App.HotelPageUrls.FindPointName),
                        method: 'POST',
                        dataType: 'json',
                        data: { Key: pointKey, Type: pointType },
                    });
                    // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
                    if (!response.status.success || response.data == null)
                        return;
                    this.setPointInput(response.data.name, parseInt(pointKey, 10), pointType, false);
                }
                // значения дат
                // TODO: почти дублирование с экскурсиями
                const dateFromArr = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkin);
                if (dateFromArr) {
                    const dateFilter = this.findFilter('CheckinDates.Checkin');
                    if (dateFilter) {
                        const dateFrom = App.parseIsoDate(dateFromArr.values[0]);
                        dateFilter.setValue(dateFrom, false);
                    }
                }
                const dateToArr = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkout);
                if (dateToArr) {
                    const dateFilter = this.findFilter('CheckinDates.Checkout');
                    if (dateFilter) {
                        const dateFrom = App.parseIsoDate(dateToArr.values[0]);
                        dateFilter.setValue(dateFrom, false);
                    }
                }
                // Категории (звездность)
                const category = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.category);
                if (category && category.values.length === 2) {
                    const starsFrom = parseInt(category.values[0], 10);
                    const starsTo = parseInt(category.values[1], 10);
                    this.setSelectListInput(starsFrom, 'Category.From');
                    this.setSelectListInput(starsTo, 'Category.To');
                }
                // Типы размещения
                // types-Hotel,Villa,GuestHouse,Apartment
                const types = urlParameters.find(item => item.name.toLowerCase() === App.HotelUrlParameters.types);
                // Типы размещения - простые чекбоксы
                if (types && types.values) {
                    // Сначала сбросить все тогглы типов, т.к. по умолчанию Hotel включён сервером,
                    // а из URL могут быть выбраны только конкретные типы
                    const allTypeNames = ['Types.Hotel', 'Types.Villa', 'Types.GuestHouse', 'Types.Apartment'];
                    allTypeNames.forEach(name => {
                        const filter = this.findFilter(name);
                        if (filter)
                            filter.setValue(false, false);
                    });
                    // Включить только типы из URL
                    types.values.forEach(value => {
                        let filterName = '';
                        switch (value) {
                            case 'hotel':
                                filterName = 'Types.Hotel';
                                break;
                            case 'villa':
                                filterName = 'Types.Villa';
                                break;
                            case 'guesthouse':
                                filterName = 'Types.GuestHouse';
                                break;
                            case 'apartment':
                                filterName = 'Types.Apartment';
                                break;
                        }
                        const typeFilter = this.findFilter(filterName);
                        if (typeFilter) {
                            typeFilter.setValue(true);
                        }
                    });
                }
                // Номера
                const rooms = urlParameters.filter(item => item.name.toLowerCase() === App.HotelUrlParameters.rooms);
                if (rooms && rooms.length > 0) {
                    const roomControl = this.findControl('rooms');
                    if (roomControl) {
                        const tourists = rooms.map(item => App.FilterRoomsBlock.parseUrlParameter(item));
                        roomControl.setValues(tourists);
                    }
                }
                // Гражданство
                const citizenship = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.citizenship);
                if (citizenship && citizenship.values) {
                    const selectedVal = citizenship.values[0].toUpperCase();
                    this.setSelectListInput(selectedVal, 'Citizenship');
                }
            });
        }
        setPointInput(pointName, pointKey, pointType, triggerChange) {
            const point = this.findFilter('Point');
            if (point)
                point.setValueByGuide(pointName, pointKey, pointType, triggerChange);
        }
        setSelectListInput(code, filterName) {
            const filter = this.findFilter(filterName);
            if (filter) {
                const values = filter.getDefaultValue();
                const itemToCheck = values.find(i => i.value === code);
                if (itemToCheck) {
                    itemToCheck.checked = true;
                }
                filter.setValue(values, false);
            }
        }
        /**
         * Получает параметры с главного фильтра
         **/
        getUrlDataFromFilter() {
            // установить значения в url
            const parameters = new Array(0);
            const types = new Array(0);
            let categoryFrom = '';
            let categoryTo = '';
            let pointtype = '';
            let pointkey = '';
            let context = '';
            let citizenship = '';
            const serialized = this.filters.serializeArray();
            serialized
                // превращаем сериализованный массив в массив типа IUrlParameter
                .forEach(serializedArrayItem => {
                // что удобно, разбираем из сериализованного массива
                // остальное (номера, типы размещения и частично звездность),
                // разбираем отдельно
                switch (serializedArrayItem.name.toLowerCase()) {
                    case App.HotelFilterFields.PointType:
                        pointtype = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.PointKey:
                        pointkey = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.CheckinDatesCheckin:
                        __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.checkin, [App.localDateToIso(serializedArrayItem.value)]);
                        break;
                    case App.HotelFilterFields.CheckinDatesCheckout:
                        __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.checkout, [App.localDateToIso(serializedArrayItem.value)]);
                        break;
                    // Мобильный блок звёздности сериализует как 'category=3,5'
                    case 'category': {
                        const parts = serializedArrayItem.value.split(',');
                        if (parts.length >= 2) {
                            categoryFrom = parts[0];
                            categoryTo = parts[1];
                        }
                        break;
                    }
                    case App.HotelFilterFields.CategoryFrom:
                        categoryFrom = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.CategoryTo:
                        categoryTo = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.Types:
                        types.push(serializedArrayItem.value);
                        break;
                    case App.HotelFilterFields.Context:
                        // Контекст должен быть в САМОМ начале строки
                        context = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.Citizenship:
                        citizenship = serializedArrayItem.value;
                        break;
                    // Мобильные тогглы типов размещения: Types.Hotel=true, Types.Villa=false, ...
                    // Включаем только активные (value === 'true')
                    default: {
                        const nameLower = serializedArrayItem.name.toLowerCase();
                        if (nameLower.startsWith('types.') && serializedArrayItem.value === 'true') {
                            types.push(nameLower.split('.')[1]);
                        }
                        break;
                    }
                }
            });
            // Пихаем в параметры урла то, что не получается разбирать при проходе
            // сериализованного массива
            // Локация поиска
            if (pointtype && pointkey)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.location, [pointtype, pointkey], true);
            // контекст в САМОЕ начало строки
            if (context)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.context, [context], true);
            if (citizenship)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.citizenship, [citizenship], true);
            // Звездность
            if (categoryFrom && categoryTo)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.category, [categoryFrom, categoryTo]);
            // Типы размещения (надо представить как types-Hotel,Villa,GuestHouse)
            if (types.length > 0)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.types, types);
            // Номера
            const roomControl = this.findControl('rooms');
            if (roomControl) {
                const rooms = roomControl.getValues();
                rooms.forEach(room => {
                    const urlParameterValue = new Array();
                    urlParameterValue.push(room.adultCount.toString());
                    room.childAges.forEach(child => {
                        urlParameterValue.push(child.toString());
                    });
                    __classPrivateFieldGet(_a, _a, "m", _HotelMainFilterMobile_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.rooms, urlParameterValue);
                });
            }
            return parameters;
        }
        /**
         ** Поиск названия пункта поиска (переопределить в производном фильтре)
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        findPointName(pointKey, pointType) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield Promise.resolve('город');
            });
        }
    }
    _a = HotelMainFilterMobile, _HotelMainFilterMobile_options = new WeakMap(), _HotelMainFilterMobile_pushUrlParameter = function _HotelMainFilterMobile_pushUrlParameter(targetArray, name, values, makeFirst = false) {
        if (makeFirst) {
            targetArray.unshift({ name: name.toLowerCase(), values });
            return;
        }
        targetArray.push({ name: name.toLowerCase(), values });
    };
    Object.defineProperty(HotelMainFilterMobile, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-hotel-page',
            maxChildAge: 12,
            defaultAccommodationTypesOptions: ['hotel'],
        }
    });
    App.HotelMainFilterMobile = HotelMainFilterMobile;
})(App || (App = {}));
/// <reference path='HotelMainFilter.Mobile.ts' />
var App;
(function (App) {
    class HotelInfoMainFilterMobile extends App.HotelMainFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-detail-filter', customFilters: {
                    root: '.js-hotel-detail-filter',
                    clickSelector: '.js-hotel-detail-filters-open',
                    modalKey: 'hotel-detail-filters-modal',
                    contentSelector: '#js-hotel-detail-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать', // TODO: @Localizer.Text("Auto.SearchButton")
                } }, options));
        }
        serializeArray() {
            const serialized = this.filters.serializeArray();
            const others = serialized.filter(item => !item.name.startsWith('Types.'));
            // Только включённые тогглы (value === 'true') попадают в payload
            const typesFlattened = serialized
                .filter(item => item.name.startsWith('Types.') && item.value === 'true')
                .map(item => ({
                name: 'Types',
                value: item.name.split('.')[1],
            }));
            const filteredByTypes = [
                ...others,
                ...typesFlattened,
            ];
            const filteredByRooms = filteredByTypes.filter(item => !(item.name.startsWith('Rooms.') && item.value === '0'));
            return filteredByRooms;
        }
    }
    App.HotelInfoMainFilterMobile = HotelInfoMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelMainFilter_instances, _a, _HotelMainFilter_options, _HotelMainFilter_pushUrlParameter, _HotelMainFilter_onFilterChange, _HotelMainFilter_setNightsByCheckout, _HotelMainFilter_setAccommodationTypesValue;
    class HotelMainFilter extends App.MainFilter {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelMainFilter_instances.add(this);
            _HotelMainFilter_options.set(this, void 0);
            __classPrivateFieldSet(this, _HotelMainFilter_options, options, "f");
            // Инит блока с номерами
            const filterRoomBlock = $('.js-filter-rooms-block', this.root);
            filterRoomBlock.each((_, v) => {
                const rooms = new App.FilterRoomsAccordionBlock(Object.assign({ root: $(v), filter: this.root }, __classPrivateFieldGet(this, _HotelMainFilter_options, "f").roomsOptions));
                this.controls.push(rooms);
            });
            // TODO: при чем тут хот-фильтр?
            this.root.on("filter:change" /* Events.FilterChange */, (e, data) => __classPrivateFieldGet(this, _HotelMainFilter_instances, "m", _HotelMainFilter_onFilterChange).call(this, e, data));
        }
        reset() {
            const pickupPoint = this.findControl('pickupPoint');
            if (pickupPoint)
                pickupPoint.reset();
            // Сбросить типы размещения - они сделаны не контролом, а обычными чекбоксами
            __classPrivateFieldGet(this, _HotelMainFilter_instances, "m", _HotelMainFilter_setAccommodationTypesValue).call(this, __classPrivateFieldGet(this, _HotelMainFilter_options, "f").defaultAccommodationTypesOptions);
            const rooms = this.findControl('rooms');
            if (rooms)
                rooms.reset();
            const citizenship = this.findControl('citizenship');
            if (citizenship)
                citizenship.setValue(App.app.settings.hotelOptions.defaultCitizenship);
            const dates = this.findControl('dates');
            if (dates)
                dates.reset();
            const nights = this.findControl('nights');
            if (nights)
                __classPrivateFieldGet(this, _HotelMainFilter_instances, "m", _HotelMainFilter_setNightsByCheckout).call(this);
            const hotelStars = this.findControl('hotel_stars');
            if (hotelStars)
                hotelStars.reset();
        }
        getDates() {
            var _b;
            return (_b = this.findControl('dates')) === null || _b === void 0 ? void 0 : _b.getValues();
        }
        /** Получает комнаты, выбранные на фильтре */
        getRooms() {
            const roomControl = this.findControl('rooms');
            return roomControl.getValues();
        }
        /**
         * Устанавливает главный фильтр по параметрам из урла
         * @param urlParameters - параметры из урла
         */
        setFromParameters(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                // Значение автокомплита
                // TODO: дублирование с экскурсиями
                const location = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.location);
                if (location && location.values.length === 2) {
                    const pointType = location.values[0];
                    const pointKey = location.values[1];
                    const locationControl = this.findControl('pickupPoint');
                    if (locationControl) {
                        locationControl.setValue(yield this.findPointName(pointKey, pointType), parseInt(pointKey, 10), pointType);
                    }
                }
                // значения дат
                // TODO: почти дублирование с экскурсиями
                const dateFromArr = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkin);
                const dateToArr = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.checkout);
                if (dateFromArr && dateToArr) {
                    const dateFilter = this.findControl('dates');
                    if (dateFilter) {
                        const dateFrom = App.parseIsoDate(dateFromArr.values[0]);
                        const dateTo = App.parseIsoDate(dateToArr.values[0]);
                        dateFilter.setValues(dateFrom, dateTo);
                    }
                }
                // Установим выбранное в зависимости от даты. Полную переустановку не делаем,
                // т.к.теперь не очищаем селект
                __classPrivateFieldGet(this, _HotelMainFilter_instances, "m", _HotelMainFilter_setNightsByCheckout).call(this);
                // Категории (звездность)
                const category = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.category);
                if (category && category.values.length === 2) {
                    const categoryFilter = this.findControl('hotel_stars');
                    if (categoryFilter) {
                        // в параметре типа category-3,5 индекс 0 будет всегда From, 1 - To
                        const starsFrom = parseInt(category.values[0], 10);
                        const starsTo = parseInt(category.values[1], 10);
                        categoryFilter.setValues(starsFrom, starsTo);
                    }
                }
                // Типы размещения
                // types-Hotel,Villa,GuestHouse,Apartment
                const types = urlParameters.find(item => item.name.toLowerCase() === App.HotelUrlParameters.types);
                // Типы размещения - простые чекбоксы
                if (types && types.values)
                    __classPrivateFieldGet(this, _HotelMainFilter_instances, "m", _HotelMainFilter_setAccommodationTypesValue).call(this, types.values);
                // Номера
                const rooms = urlParameters.filter(item => item.name.toLowerCase() === App.HotelUrlParameters.rooms);
                if (rooms && rooms.length > 0) {
                    const roomControl = this.findControl('rooms');
                    if (roomControl) {
                        const tourists = rooms.map(item => App.FilterRoomsBlock.parseUrlParameter(item));
                        roomControl.setValues(tourists);
                    }
                }
                // Гражданство
                const citizenship = urlParameters.find(v => v.name.toLowerCase() === App.HotelUrlParameters.citizenship);
                if (citizenship && citizenship.values) {
                    const selectedVal = citizenship.values[0].toUpperCase();
                    const citizenshipControl = this.findControl('citizenship');
                    if (citizenshipControl)
                        citizenshipControl.setValue(selectedVal);
                }
            });
        }
        /**
         * Получает параметры с главного фильтра
         **/
        getUrlDataFromFilter() {
            // установить значения в url
            const parameters = new Array(0);
            const types = new Array(0);
            let categoryFrom = '';
            let categoryTo = '';
            let pointtype = '';
            let pointkey = '';
            let context = '';
            let citizenship = '';
            this.root.find('input').serializeArray()
                // превращаем сериализованный массив в массив типа IUrlParameter
                .forEach(serializedArrayItem => {
                // что удобно, разбираем из сериализованного массива
                // остальное (номера, типы размещения и частично звездность),
                // разбираем отдельно
                switch (serializedArrayItem.name.toLowerCase()) {
                    case App.HotelFilterFields.PointType:
                        pointtype = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.PointKey:
                        pointkey = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.CheckinDatesCheckin:
                        __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.checkin, [App.localDateToIso(serializedArrayItem.value)]);
                        break;
                    case App.HotelFilterFields.CheckinDatesCheckout:
                        __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.checkout, [App.localDateToIso(serializedArrayItem.value)]);
                        break;
                    case App.HotelFilterFields.CategoryFrom:
                        categoryFrom = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.CategoryTo:
                        categoryTo = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.Types:
                        types.push(serializedArrayItem.value);
                        break;
                    case App.HotelFilterFields.Context:
                        // Контекст должен быть в САМОМ начале строки
                        context = serializedArrayItem.value;
                        break;
                    case App.HotelFilterFields.Citizenship:
                        citizenship = serializedArrayItem.value;
                        break;
                    // no default
                }
            });
            // Пихаем в параметры урла то, что не получается разбирать при проходе
            // сериализованного массива
            // Локация поиска
            if (pointtype && pointkey)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.location, [pointtype, pointkey], true);
            // контекст в САМОЕ начало строки
            if (context)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.context, [context], true);
            if (citizenship)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.citizenship, [citizenship], true);
            // Звездность
            if (categoryFrom && categoryTo)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.category, [categoryFrom, categoryTo]);
            // Типы размещения (надо представить как types-Hotel,Villa,GuestHouse)
            if (types.length > 0)
                __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.types, types);
            // Номера
            const roomControl = this.findControl('rooms');
            if (roomControl) {
                const rooms = roomControl.getValues();
                rooms.forEach(room => {
                    const urlParameterValue = new Array();
                    urlParameterValue.push(room.adultCount.toString());
                    room.childAges.forEach(child => {
                        urlParameterValue.push(child.toString());
                    });
                    __classPrivateFieldGet(_a, _a, "m", _HotelMainFilter_pushUrlParameter).call(_a, parameters, App.HotelUrlParameters.rooms, urlParameterValue);
                });
            }
            return parameters;
        }
        /**
         ** Поиск названия пункта поиска (переопределить в производном фильтре)
         */
        /* eslint-disable @typescript-eslint/no-unused-vars */
        findPointName(pointKey, pointType) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield Promise.resolve('город');
            });
        }
    }
    _a = HotelMainFilter, _HotelMainFilter_options = new WeakMap(), _HotelMainFilter_instances = new WeakSet(), _HotelMainFilter_pushUrlParameter = function _HotelMainFilter_pushUrlParameter(targetArray, name, values, makeFirst = false) {
        if (makeFirst) {
            targetArray.unshift({ name: name.toLowerCase(), values });
            return;
        }
        targetArray.push({ name: name.toLowerCase(), values });
    }, _HotelMainFilter_onFilterChange = function _HotelMainFilter_onFilterChange(event, data) {
        var _b;
        if (data.instance.name === 'dates')
            __classPrivateFieldGet(this, _HotelMainFilter_instances, "m", _HotelMainFilter_setNightsByCheckout).call(this);
        if (data.instance.name === 'nights') {
            const dateBlock = this.findControl('dates');
            if (dateBlock) {
                const nights = (_b = $('[data-name="filter_nights_from"] .js-jelect-input', this.root).valNumber()) !== null && _b !== void 0 ? _b : 0;
                const dateFrom = $('.js-filter-date-from', this.root).datepicker('getDate');
                const dateFromDay = dateFrom.getDate();
                dateFrom.setDate(dateFromDay + nights);
                dateBlock.setToValue(dateFrom);
            }
        }
    }, _HotelMainFilter_setNightsByCheckout = function _HotelMainFilter_setNightsByCheckout() {
        const dateFrom = $('.js-filter-date-from', this.root).datepicker('getDate');
        const dateTo = $('.js-filter-date-to', this.root).datepicker('getDate');
        if (!dateFrom || !dateTo)
            return;
        // ищем разницу в миллисекундах и переводим в дни
        let delta = App.dateDiff(dateTo, dateFrom).getTotalDays();
        // т.к. в выпадающем списке нет значения 0, ставим 1.
        if (delta <= 0)
            delta = 1;
        // устанавливаем значение ночей
        // TODO: временное решение, т.к. в этом контролле и города и промежуток ночей ОТ и До. Скорее всего, его
        // надо будет переделать.
        $('[data-name="filter_nights_from"] .js-filter-option', this.root).eq(delta - 1).trigger('click');
    }, _HotelMainFilter_setAccommodationTypesValue = function _HotelMainFilter_setAccommodationTypesValue(values) {
        const typesBlocks = $('.js-apartaments-types', this.root);
        // Коллекция инпутов-чекбоксов
        $('[name="Types"]', typesBlocks).each((index, element) => {
            const checkbox = $(element);
            // Если в параметрах урла есть значение с таким именем, ставим галку
            // в соответствующий чекбокс
            const checkboxAsParameter = values.find(v => v.toLowerCase() === checkbox.valString().toLowerCase());
            if (checkboxAsParameter) {
                checkbox.prop('checked', true);
            }
            else {
                // Если в урле нет значения - галку снимаем
                checkbox.prop('checked', false);
            }
        });
    };
    App.HotelMainFilter = HotelMainFilter;
})(App || (App = {}));
/// <reference path='HotelMainFilter.ts' />
var App;
(function (App) {
    class HotelInfoMainFilter extends App.HotelMainFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-detail-filter' }, options));
        }
    }
    App.HotelInfoMainFilter = HotelInfoMainFilter;
})(App || (App = {}));
/// <reference path='HotelMainFilter.Mobile.ts' />
var App;
(function (App) {
    class HotelSearchMainFilterMobile extends App.HotelMainFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-main-filter' }, options));
            const pointFilter = this.findFilter('Point');
            if (pointFilter != null) {
                pointFilter.setOptions({ serializeNameWithoutDot: true });
            }
        }
        serializeArray() {
            const serialized = this.filters.serializeArray();
            // Категорию отеля мобильный блок сериализует в виде 'category=3,5',
            // а сервер ожидает 'Category.From=3&Category.To=5'
            const categoryItem = serialized.find(item => item.name === 'category');
            const categoryParams = [];
            if (categoryItem) {
                const parts = categoryItem.value.split(',');
                if (parts.length >= 2) {
                    categoryParams.push({ name: 'Category.From', value: parts[0] });
                    categoryParams.push({ name: 'Category.To', value: parts[1] });
                }
            }
            const others = serialized.filter(item => !item.name.startsWith('Types.')
                && item.name !== 'category');
            // Только включённые тогглы (value === 'true') попадают в payload
            const typesFlattened = serialized
                .filter(item => item.name.startsWith('Types.') && item.value === 'true')
                .map(item => ({
                name: 'Types',
                value: item.name.split('.')[1],
            }));
            const filteredByTypes = [
                ...others,
                ...categoryParams,
                ...typesFlattened,
            ];
            // Отфильтровать пустые значения в номерах (AdultCount=0 и т.д.)
            const filteredByRooms = filteredByTypes.filter(item => !(item.name.startsWith('Rooms.') && item.value === '0'));
            // Добавить Rooms.Tourists.Index для каждого номера,
            const roomIndices = new Set();
            filteredByRooms.forEach(item => {
                const match = item.name.match(/^Rooms\.Tourists\[(\d+)\]/);
                if (match)
                    roomIndices.add(match[1]);
            });
            const indexParams = Array.from(roomIndices)
                .sort()
                .map(idx => ({ name: 'Rooms.Tourists.Index', value: idx }));
            return [...indexParams, ...filteredByRooms];
        }
        findPointName(pointKey, pointType) {
            return __awaiter(this, void 0, void 0, function* () {
                const xhr = $.ajax({
                    url: App.app.url.route(App.HotelPageUrls.FindPointName),
                    type: 'Post',
                    dataType: 'json',
                    data: { Key: pointKey, Type: pointType },
                });
                const response = yield xhr;
                // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
                if (!response.status.success || response.data == null)
                    return '';
                return response.data.name;
            });
        }
    }
    App.HotelSearchMainFilterMobile = HotelSearchMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class HotelSearchMainFilter extends App.HotelMainFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-main-filter' }, options));
        }
        findPointName(pointKey, pointType) {
            return __awaiter(this, void 0, void 0, function* () {
                const xhr = $.ajax({
                    url: App.app.url.route(App.HotelPageUrls.FindPointName),
                    method: 'POST',
                    dataType: 'json',
                    data: { Key: pointKey, Type: pointType },
                });
                const response = yield xhr;
                // TODO: универсально обрабатывать данные случаи всех ajax-вызовов к PacWorld. Глобальные перехватчики не очень подходят (либо их нужно навешивать только на наш PacWorld экземпляры вызова), т.к. ajax'ом могут обращаться и к сайту.
                if (!response.status.success || response.data == null)
                    return '';
                return response.data.name;
            });
        }
    }
    App.HotelSearchMainFilter = HotelSearchMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelResult_instances, _a, _HotelResult_onCheckCancellationClick, _HotelResult_setSortingByUrlParameters, _HotelResult_setHotFiltersByUrlParameters, _HotelResult_convertPriceParameters, _HotelResult_setPagingByUrlParameters;
    class HotelResult extends App.Result {
        constructor(options) {
            super(Object.assign({}, options));
            _HotelResult_instances.add(this);
            this.root.on('click', '.js-cancellation-rules', e => __classPrivateFieldGet(_a, _a, "m", _HotelResult_onCheckCancellationClick).call(_a, e));
        }
        /**
         * устанавливает параметры, которые влияют на манипуляцию с данными (фильтры, сортировка и т.д.)
         * параметры - массив параметров урла. Передаем весь, в методе отделятся нужные, не нужные не будут использоваться
         * @param urlParameter - параметры урла для установки. Если пустой массив - сортировка и пейджинг берутся предыдущие, хотфильтры
         * сбрасываются
         */
        setDataManipulateParameters(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                const filtering = yield __classPrivateFieldGet(this, _HotelResult_instances, "m", _HotelResult_setHotFiltersByUrlParameters).call(this, urlParameters);
                if (!urlParameters) {
                    return {
                        filtering,
                        sorting: this.sorting,
                        paging: this.paging,
                    };
                }
                return {
                    filtering,
                    sorting: __classPrivateFieldGet(this, _HotelResult_instances, "m", _HotelResult_setSortingByUrlParameters).call(this, urlParameters),
                    paging: __classPrivateFieldGet(this, _HotelResult_instances, "m", _HotelResult_setPagingByUrlParameters).call(this, urlParameters),
                };
            });
        }
        /**
         * Прицепляет событие на проверку правил отмены
         * @param root - корневой элемент для ссылок 'проверить правила отмены'.
         * Например, это body для большинства случаев и конкретный блок с инфой о конкретном отеле для страницы с картой отелей
         */
        bindCheckCancellationRules(root) {
            // TODO: убедиться нужно ли это, в связи с добавляемым handler в конструкторе.
            $('.js-cancellation-rules', root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _HotelResult_onCheckCancellationClick).call(_a, e));
        }
        bindBlocks() {
            super.bindBlocks();
            $('.js-booking-com-book').on('click', e => _a.onBookingComClick(e));
        }
        unbindBlocks() {
            super.unbindBlocks();
            $('.js-booking-com-book').off('click', _a.onBookingComClick);
            // убрать обработчики, в Result.ts bindBlocks() обработчики будут установлены по вызову "Показать ещё" для
            // существующих и вновь добавленных данных.
            const toursOutputBlock = $('.js-tours-output-block', this.root);
            const toursOutputTable = $('.js-tours-output-table', this.root);
            const clickableBlocks = $('.js-clickable-block', toursOutputBlock);
            const clickableTableBlocks = $('.js-clickable-block', toursOutputTable);
            clickableBlocks.off('click');
            clickableTableBlocks.off('click');
        }
        /**
         * На событие клика на ссылку бронирования на букинге
         * @param event
         */
        static onBookingComClick(event) {
            // Если у данного варианта нет ссылки на bookin.com, то пользователь не авторизован.
            // Т.е. если ссылка есть, выводит подтверждение перехода по ней, если нет - просьбу авторизоваться
            const element = $(event.currentTarget);
            const bookingComLink = element.attr('data-booking-com-link');
            // В попапе сразу два блока - для авторизованного или нет. Надо просто брать нужный для вставки в попап
            const popupContent = App.templates.Hotel.Popups.BookingComPopups({});
            let bookingComBlock;
            if (bookingComLink) {
                bookingComBlock = $(popupContent).find('.js-booking-com-go');
                if (bookingComBlock)
                    bookingComBlock.find('.js-booking-com-link').attr('href', bookingComLink);
            }
            else {
                bookingComBlock = $(popupContent).find('.js-booking-com-notauthorized');
            }
            if (bookingComBlock && bookingComBlock.length > 0)
                App.popupShow(bookingComBlock, 'Купить на Booking.com');
        }
    }
    _a = HotelResult, _HotelResult_instances = new WeakSet(), _HotelResult_onCheckCancellationClick = function _HotelResult_onCheckCancellationClick(event) {
        // Предотвращаем клик на ссылку, которой является блок в блочном представлении при поиске
        event.preventDefault();
        event.stopPropagation();
        $(event.target).trigger("getCancellation:click" /* Events.GetCancellationClick */);
    }, _HotelResult_setSortingByUrlParameters = function _HotelResult_setSortingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'sort');
        if (pageUrlParameter) {
            [this.sorting.field] = pageUrlParameter.values;
            this.sorting.reverse = pageUrlParameter.values[1] === 'desc';
        }
        return this.sorting;
    }, _HotelResult_setHotFiltersByUrlParameters = function _HotelResult_setHotFiltersByUrlParameters(urlParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (urlParameters) {
                const parameters = urlParameters
                    .filter(v => {
                    const itemName = v.name.toLowerCase();
                    return itemName === App.HotelHotFilterFields.AccommodationTypes
                        || itemName === App.HotelHotFilterFields.RoomTypes
                        || itemName === App.HotelHotFilterFields.Boards
                        || itemName === App.HotelHotFilterFields.Provider
                        || itemName === App.HotelHotFilterFields.OfferSource
                        || itemName === App.HotelHotFilterFields.Areas
                        || itemName === App.HotelHotFilterFields.MinRating
                        || itemName === App.HotelHotFilterFields.AccommodationName
                        || itemName === App.HotelHotFilterFields.Facilities
                        || itemName === App.HotelHotFilterFields.Prices
                        || itemName === App.HotelHotFilterFields.VatIncluded
                        || itemName === App.HotelHotFilterFields.FreeCancellation
                        || itemName === App.HotelHotFilterFields.TransferIncluded
                        || itemName === App.HotelHotFilterFields.VisaAssistance
                        || itemName === App.HotelHotFilterFields.InStock
                        || itemName === App.HotelHotFilterFields.Categories;
                });
                this.filtering.items = new Array();
                /* eslint-disable no-await-in-loop */
                for (let i = 0; i < parameters.length; i++) {
                    this.filtering.items.push({
                        name: parameters[i].name,
                        // В цене 3 значения: from, to, валюта
                        values: parameters[i].name === App.HotelHotFilterFields.Prices && parameters[i].values.length === 3
                            ? yield __classPrivateFieldGet(_a, _a, "m", _HotelResult_convertPriceParameters).call(_a, parameters[i])
                            : parameters[i].values,
                    });
                }
                /* eslint-enable no-await-in-loop */
            }
            else {
                this.filtering.items = new Array();
            }
            return this.filtering.items;
        });
    }, _HotelResult_convertPriceParameters = function _HotelResult_convertPriceParameters(filterParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentCurrency = App.Cookie.get("currency" /* KnownCookie.Currency */) || App.CurrencyManager.currentCurrencyCode;
            // Заменяем значения на конвертированный в текущую валюту
            const from = yield App.CurrencyManager.exchange(parseInt(filterParameters.values[0], 10), filterParameters.values[2].toUpperCase(), currentCurrency);
            const to = yield App.CurrencyManager.exchange(parseInt(filterParameters.values[1], 10), filterParameters.values[2].toUpperCase(), currentCurrency);
            return [
                from ? from.toString() : filterParameters.values[0],
                to ? to.toString() : filterParameters.values[1],
                // здесь валюта не нужна, т.к. при фильтрации берется из кук, но добавила на всякий -
                // т.к. где-то могу проверять длину массива значений(3) или могу ожидать, то будет, как в урле, код валюты
                currentCurrency,
            ];
        });
    }, _HotelResult_setPagingByUrlParameters = function _HotelResult_setPagingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'page');
        if (pageUrlParameter) {
            this.paging.index = parseInt(pageUrlParameter.values[0], 10);
            this.paging.size = parseInt(App.Cookie.get("showCount" /* KnownCookie.ShowCount */) || pageUrlParameter.values[1], 10);
        }
        return this.paging;
    };
    App.HotelResult = HotelResult;
})(App || (App = {}));
/// <reference path='HotelResult.ts' />
var App;
(function (App) {
    var _HotelInfoResultMobile_instances, _a, _HotelInfoResultMobile_options, _HotelInfoResultMobile_urlChangeStrategy, _HotelInfoResultMobile_resultTableHeader, _HotelInfoResultMobile_currencyConverter, _HotelInfoResultMobile_sortCurrencyCode, _HotelInfoResultMobile_filter, _HotelInfoResultMobile_afterSortVariants, _HotelInfoResultMobile_setLastBest;
    class HotelInfoResultMobile extends App.HotelResult {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-details-block .js-output-block', tableTemplate: App.templates.Hotel.DetailTable }, options));
            _HotelInfoResultMobile_instances.add(this);
            _HotelInfoResultMobile_options.set(this, void 0);
            _HotelInfoResultMobile_urlChangeStrategy.set(this, void 0);
            _HotelInfoResultMobile_resultTableHeader.set(this, void 0);
            _HotelInfoResultMobile_currencyConverter.set(this, void 0);
            _HotelInfoResultMobile_sortCurrencyCode.set(this, "RUB" /* KnownCurrencyCode.RUB */);
            __classPrivateFieldSet(this, _HotelInfoResultMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _HotelInfoResultMobile_urlChangeStrategy, new App.UrlReplaceStrategy(new App.HotelHotFilterSet()), "f");
            __classPrivateFieldGet(this, _HotelInfoResultMobile_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
            __classPrivateFieldSet(this, _HotelInfoResultMobile_resultTableHeader, $('.js-table-header', this.root), "f");
        }
        resetDataSource() {
            __classPrivateFieldGet(this, _HotelInfoResultMobile_resultTableHeader, "f").hideByClass();
            super.resetDataSource();
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                __classPrivateFieldGet(this, _HotelInfoResultMobile_resultTableHeader, "f").showByClass();
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _HotelInfoResultMobile_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _HotelInfoResultMobile_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _HotelInfoResultMobile_currencyConverter, "f");
                    if (currencyConverter) {
                        if (!append)
                            __classPrivateFieldSet(this, _HotelInfoResultMobile_sortCurrencyCode, data[0].currencyCode, "f");
                        data.forEach(v => {
                            var _b;
                            v.sortPrice = (_b = currencyConverter.exchange(v.totalGrossPrice, v.currencyCode, __classPrivateFieldGet(this, _HotelInfoResultMobile_sortCurrencyCode, "f"))) !== null && _b !== void 0 ? _b : v.totalGrossPrice;
                        });
                    }
                }
                yield _super.changeDataSource.call(this, data, append);
            });
        }
        applyFilters(items) {
            if (typeof this.filtering === 'undefined')
                return items;
            if (items == null || items.length <= 0)
                return items;
            return __classPrivateFieldGet(this, _HotelInfoResultMobile_instances, "m", _HotelInfoResultMobile_filter).call(this, items);
        }
        applySorting(items) {
            // TODO: вынести в какой-нить абстрактный класс типа как в фильтрах
            switch (this.sorting.field) {
                case App.HotelSortFields.PeopleCount: {
                    let result;
                    if (!this.sorting.reverse) {
                        result = Enumerable.from(items)
                            .orderBy(o => o.touristCount)
                            .thenBy(o => o.adultCount)
                            // TODO: здесь использована сортировка, потому что не нашла как еще отсортировать массив детей, но не делать селект для всего объекта HotelVariant. Будет ли сохраняться порядок после ThenBy по length?
                            .thenBy(o => o.childAges
                            .sort((a, b) => App.Result.sort(a, b, a, b, this.sorting.reverse))
                            .length)
                            .thenBy(o => o.sortPrice)
                            .toArray();
                    }
                    else {
                        result = Enumerable.from(items)
                            .orderByDescending(o => o.touristCount)
                            .thenByDescending(o => o.adultCount)
                            // TODO: здесь использована сортировка, потому что не нашла как еще отсортировать массив детей. но не делать селект для всего объекта HotelVariant. Будет ли сохраняться порядок после ThenBy по length?
                            .thenByDescending(o => o.childAges
                            .sort((a, b) => App.Result.sort(a, b, a, b, this.sorting.reverse))
                            .length)
                            .thenByDescending(o => o.sortPrice)
                            .toArray();
                    }
                    // 'Досортировка вариантов'
                    return __classPrivateFieldGet(_a, _a, "m", _HotelInfoResultMobile_afterSortVariants).call(_a, result);
                }
                default:
                    items.sort((a, b) => App.Result.sort(a.isBest, b.isBest, a.sortPrice, b.sortPrice, this.sorting.reverse));
                    // 'Досортировка вариантов'
                    return __classPrivateFieldGet(_a, _a, "m", _HotelInfoResultMobile_afterSortVariants).call(_a, items);
            }
        }
    }
    _a = HotelInfoResultMobile, _HotelInfoResultMobile_options = new WeakMap(), _HotelInfoResultMobile_urlChangeStrategy = new WeakMap(), _HotelInfoResultMobile_resultTableHeader = new WeakMap(), _HotelInfoResultMobile_currencyConverter = new WeakMap(), _HotelInfoResultMobile_sortCurrencyCode = new WeakMap(), _HotelInfoResultMobile_instances = new WeakSet(), _HotelInfoResultMobile_filter = function _HotelInfoResultMobile_filter(variants) {
        let result = variants;
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            switch (filter.name.toLowerCase()) {
                case App.HotelHotFilterFields.RoomTypes:
                    result = result
                        .filter(variant => variant.roomGroups
                        // Первое условие - id типа номера варианта совпадает с id типа номера из хотфильтра
                        .some(roomType => filter.values
                        .some(currentFilter => roomType === currentFilter))
                        // Второе условие - в фильтре есть id типа номера варианта 0 - это 'Другой', а в типах номера варианта нет
                        // ничего (). Имеются ввиду сгруппированные типы номеров. Могут быть ДРУГИЕ
                        || (variant.roomGroups.length === 0 && filter.values.some(currentFilter => currentFilter === '0')));
                    break;
                case App.HotelHotFilterFields.Boards: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result
                        .filter(variant => values
                        .some(currentFilter => variant.boardGroup.toLowerCase() === currentFilter));
                    break;
                }
                case App.HotelHotFilterFields.Provider: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result
                        .filter(variant => values
                        .some(currentFilter => variant.provider && variant.provider.key.toString() === currentFilter));
                    break;
                }
                case App.HotelHotFilterFields.OfferSource: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result
                        .filter(variant => values
                        .some(currentFilter => variant.offerSource && variant.offerSource.key.toString() === currentFilter));
                    break;
                }
                case App.HotelHotFilterFields.VatIncluded:
                    // Фильтровать, только если значение true, иначе - показывать все
                    if (filter.values[0] === 'true')
                        result = result.filter(variant => variant.vatIncluded === true);
                    break;
                case App.HotelHotFilterFields.Prices: {
                    // должно быть три значения - from, to и код валюты
                    if (filter.values.length !== 3)
                        continue;
                    // найдем значения и проверим их
                    const from = parseInt(filter.values[0], 10);
                    const to = parseInt(filter.values[1], 10);
                    if (!from || !to)
                        continue;
                    // Цикл for используется, т.к. он работает с асинхронными методами
                    const filteredResult = new Array();
                    for (let j = 0; j < result.length; j++) {
                        const convertedGrossPrice = __classPrivateFieldGet(this, _HotelInfoResultMobile_currencyConverter, "f")
                            ? __classPrivateFieldGet(this, _HotelInfoResultMobile_currencyConverter, "f").exchange(result[j].totalGrossPrice, result[j].currencyCode, App.CurrencyManager.currentCurrencyCode)
                            : null;
                        if (convertedGrossPrice && convertedGrossPrice > from && convertedGrossPrice < to)
                            filteredResult.push(result[j]);
                    }
                    result = filteredResult;
                    break;
                }
                case App.HotelHotFilterFields.FreeCancellation:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.freeCancellation === true);
                    break;
                case App.HotelHotFilterFields.TransferIncluded:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.transferIncluded === true);
                    break;
                case App.HotelHotFilterFields.VisaAssistance:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.visaAssistance === true);
                    break;
                case App.HotelHotFilterFields.InStock:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.byRequest === false);
                    break;
                // no default
            }
        }
        const rooms = __classPrivateFieldGet(this, _HotelInfoResultMobile_options, "f").mainFilter.getRooms();
        const bestResult = App.BestVariantsSelector.select(result, rooms);
        return App.DataTransformer.variantsDataTransformation(result, bestResult) || Array();
    }, _HotelInfoResultMobile_afterSortVariants = function _HotelInfoResultMobile_afterSortVariants(source) {
        // После сортировки из массива выбираем только лучшие предложения и только Нелучшие и соединяем их в новом массиве
        // Надо, чтобы лучшие предложения учитывались при всех операциях с данными с Result, y овсегда были наверху - по-другому не
        // смогла сделать
        const bestVariants = source.filter(f => f.isBest);
        const worstVariants = source.filter(f => !f.isBest);
        const newArray = bestVariants.concat(worstVariants);
        source.sort((a, b) => {
            if (a.isBest === b.isBest)
                return 0;
            return a.isBest ? -1 : 1;
        });
        __classPrivateFieldGet(_a, _a, "m", _HotelInfoResultMobile_setLastBest).call(_a, newArray);
        return newArray;
    }, _HotelInfoResultMobile_setLastBest = function _HotelInfoResultMobile_setLastBest(items) {
        // Сначала сбросить последний
        items.forEach(item => (item.isLastBest = false));
        // Потом снова установить последний
        const lastBestItem = Enumerable.from(items)
            .lastOrDefault(l => l.isBest);
        if (lastBestItem)
            lastBestItem.isLastBest = true;
        return items;
    };
    App.HotelInfoResultMobile = HotelInfoResultMobile;
})(App || (App = {}));
/// <reference path='HotelResult.ts' />
var App;
(function (App) {
    var _HotelInfoResult_instances, _a, _HotelInfoResult_options, _HotelInfoResult_urlChangeStrategy, _HotelInfoResult_resultTableHeader, _HotelInfoResult_currencyConverter, _HotelInfoResult_sortCurrencyCode, _HotelInfoResult_filter, _HotelInfoResult_afterSortVariants, _HotelInfoResult_setLastBest;
    class HotelInfoResult extends App.HotelResult {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-details-block .js-output-block', tableTemplate: App.templates.Hotel.DetailTable }, options));
            _HotelInfoResult_instances.add(this);
            _HotelInfoResult_options.set(this, void 0);
            _HotelInfoResult_urlChangeStrategy.set(this, void 0);
            _HotelInfoResult_resultTableHeader.set(this, void 0);
            _HotelInfoResult_currencyConverter.set(this, void 0);
            _HotelInfoResult_sortCurrencyCode.set(this, "RUB" /* KnownCurrencyCode.RUB */);
            __classPrivateFieldSet(this, _HotelInfoResult_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _HotelInfoResult_urlChangeStrategy, new App.UrlReplaceStrategy(new App.HotelHotFilterSet()), "f");
            __classPrivateFieldGet(this, _HotelInfoResult_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
            __classPrivateFieldSet(this, _HotelInfoResult_resultTableHeader, $('.js-table-header', this.root), "f");
        }
        resetDataSource() {
            __classPrivateFieldGet(this, _HotelInfoResult_resultTableHeader, "f").hideByClass();
            super.resetDataSource();
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                __classPrivateFieldGet(this, _HotelInfoResult_resultTableHeader, "f").showByClass();
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _HotelInfoResult_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _HotelInfoResult_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _HotelInfoResult_currencyConverter, "f");
                    if (currencyConverter) {
                        if (!append)
                            __classPrivateFieldSet(this, _HotelInfoResult_sortCurrencyCode, data[0].currencyCode, "f");
                        data.forEach(v => {
                            var _b;
                            v.sortPrice = (_b = currencyConverter.exchange(v.totalGrossPrice, v.currencyCode, __classPrivateFieldGet(this, _HotelInfoResult_sortCurrencyCode, "f"))) !== null && _b !== void 0 ? _b : v.totalGrossPrice;
                        });
                    }
                }
                yield _super.changeDataSource.call(this, data, append);
            });
        }
        applyFilters(items) {
            if (typeof this.filtering === 'undefined')
                return items;
            if (items == null || items.length <= 0)
                return items;
            return __classPrivateFieldGet(this, _HotelInfoResult_instances, "m", _HotelInfoResult_filter).call(this, items);
        }
        applySorting(items) {
            // TODO: вынести в какой-нить абстрактный класс типа как в фильтрах
            switch (this.sorting.field) {
                case App.HotelSortFields.PeopleCount: {
                    let result;
                    if (!this.sorting.reverse) {
                        result = Enumerable.from(items)
                            .orderBy(o => o.touristCount)
                            .thenBy(o => o.adultCount)
                            // TODO: здесь использована сортировка, потому что не нашла как еще отсортировать массив детей, но не делать селект для всего объекта HotelVariant. Будет ли сохраняться порядок после ThenBy по length?
                            .thenBy(o => o.childAges
                            .sort((a, b) => App.Result.sort(a, b, a, b, this.sorting.reverse))
                            .length)
                            .thenBy(o => o.sortPrice)
                            .toArray();
                    }
                    else {
                        result = Enumerable.from(items)
                            .orderByDescending(o => o.touristCount)
                            .thenByDescending(o => o.adultCount)
                            // TODO: здесь использована сортировка, потому что не нашла как еще отсортировать массив детей. но не делать селект для всего объекта HotelVariant. Будет ли сохраняться порядок после ThenBy по length?
                            .thenByDescending(o => o.childAges
                            .sort((a, b) => App.Result.sort(a, b, a, b, this.sorting.reverse))
                            .length)
                            .thenByDescending(o => o.sortPrice)
                            .toArray();
                    }
                    // 'Досортировка вариантов'
                    return __classPrivateFieldGet(_a, _a, "m", _HotelInfoResult_afterSortVariants).call(_a, result);
                }
                default:
                    items.sort((a, b) => App.Result.sort(a.isBest, b.isBest, a.sortPrice, b.sortPrice, this.sorting.reverse));
                    // 'Досортировка вариантов'
                    return __classPrivateFieldGet(_a, _a, "m", _HotelInfoResult_afterSortVariants).call(_a, items);
            }
        }
    }
    _a = HotelInfoResult, _HotelInfoResult_options = new WeakMap(), _HotelInfoResult_urlChangeStrategy = new WeakMap(), _HotelInfoResult_resultTableHeader = new WeakMap(), _HotelInfoResult_currencyConverter = new WeakMap(), _HotelInfoResult_sortCurrencyCode = new WeakMap(), _HotelInfoResult_instances = new WeakSet(), _HotelInfoResult_filter = function _HotelInfoResult_filter(variants) {
        let result = variants;
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            switch (filter.name.toLowerCase()) {
                case App.HotelHotFilterFields.RoomTypes:
                    result = result
                        .filter(variant => variant.roomGroups
                        // Первое условие - id типа номера варианта совпадает с id типа номера из хотфильтра
                        .some(roomType => filter.values
                        .some(currentFilter => roomType === currentFilter))
                        // Второе условие - в фильтре есть id типа номера варианта 0 - это 'Другой', а в типах номера варианта нет
                        // ничего (). Имеются ввиду сгруппированные типы номеров. Могут быть ДРУГИЕ
                        || (variant.roomGroups.length === 0 && filter.values.some(currentFilter => currentFilter === '0')));
                    break;
                case App.HotelHotFilterFields.Boards: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result
                        .filter(variant => values
                        .some(currentFilter => variant.boardGroup.toLowerCase() === currentFilter));
                    break;
                }
                case App.HotelHotFilterFields.Provider: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result
                        .filter(variant => values
                        .some(currentFilter => variant.provider && variant.provider.key.toString() === currentFilter));
                    break;
                }
                case App.HotelHotFilterFields.OfferSource: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result
                        .filter(variant => values
                        .some(currentFilter => variant.offerSource && variant.offerSource.key.toString() === currentFilter));
                    break;
                }
                case App.HotelHotFilterFields.VatIncluded:
                    // Фильтровать, только если значение true, иначе - показывать все
                    if (filter.values[0] === 'true')
                        result = result.filter(variant => variant.vatIncluded === true);
                    break;
                case App.HotelHotFilterFields.Prices: {
                    // должно быть три значения - from, to и код валюты
                    if (filter.values.length !== 3)
                        continue;
                    // найдем значения и проверим их
                    const from = parseInt(filter.values[0], 10);
                    const to = parseInt(filter.values[1], 10);
                    if (!from || !to)
                        continue;
                    // Цикл for используется, т.к. он работает с асинхронными методами
                    const filteredResult = new Array();
                    for (let j = 0; j < result.length; j++) {
                        const convertedGrossPrice = __classPrivateFieldGet(this, _HotelInfoResult_currencyConverter, "f")
                            ? __classPrivateFieldGet(this, _HotelInfoResult_currencyConverter, "f").exchange(result[j].totalGrossPrice, result[j].currencyCode, App.CurrencyManager.currentCurrencyCode)
                            : null;
                        if (convertedGrossPrice && convertedGrossPrice > from && convertedGrossPrice < to)
                            filteredResult.push(result[j]);
                    }
                    result = filteredResult;
                    break;
                }
                case App.HotelHotFilterFields.FreeCancellation:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.freeCancellation === true);
                    break;
                case App.HotelHotFilterFields.TransferIncluded:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.transferIncluded === true);
                    break;
                case App.HotelHotFilterFields.VisaAssistance:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.visaAssistance === true);
                    break;
                case App.HotelHotFilterFields.InStock:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.byRequest === false);
                    break;
                // no default
            }
        }
        const rooms = __classPrivateFieldGet(this, _HotelInfoResult_options, "f").mainFilter.getRooms();
        const bestResult = App.BestVariantsSelector.select(result, rooms);
        return App.DataTransformer.variantsDataTransformation(result, bestResult) || Array();
    }, _HotelInfoResult_afterSortVariants = function _HotelInfoResult_afterSortVariants(source) {
        // После сортировки из массива выбираем только лучшие предложения и только Нелучшие и соединяем их в новом массиве
        // Надо, чтобы лучшие предложения учитывались при всех операциях с данными с Result, y овсегда были наверху - по-другому не
        // смогла сделать
        const bestVariants = source.filter(f => f.isBest);
        const worstVariants = source.filter(f => !f.isBest);
        const newArray = bestVariants.concat(worstVariants);
        source.sort((a, b) => {
            if (a.isBest === b.isBest)
                return 0;
            return a.isBest ? -1 : 1;
        });
        __classPrivateFieldGet(_a, _a, "m", _HotelInfoResult_setLastBest).call(_a, newArray);
        return newArray;
    }, _HotelInfoResult_setLastBest = function _HotelInfoResult_setLastBest(items) {
        // Сначала сбросить последний
        items.forEach(item => (item.isLastBest = false));
        // Потом снова установить последний
        const lastBestItem = Enumerable.from(items)
            .lastOrDefault(l => l.isBest);
        if (lastBestItem)
            lastBestItem.isLastBest = true;
        return items;
    };
    App.HotelInfoResult = HotelInfoResult;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelResultMobile_instances, _a, _HotelResultMobile_onCheckCancellationClick, _HotelResultMobile_setSortingByUrlParameters, _HotelResultMobile_setHotFiltersByUrlParameters, _HotelResultMobile_convertPriceParameters, _HotelResultMobile_setPagingByUrlParameters;
    class HotelResultMobile extends App.Result {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-search-block', blockTemplate: App.templates.Hotel.Blocks, tableTemplate: App.templates.Hotel.Table }, options));
            _HotelResultMobile_instances.add(this);
            this.root.on('click', '.js-cancellation-rules', e => __classPrivateFieldGet(_a, _a, "m", _HotelResultMobile_onCheckCancellationClick).call(_a, e));
        }
        /**
         * устанавливает параметры, которые влияют на манипуляцию с данными (фильтры, сортировка и т.д.)
         * параметры - массив параметров урла. Передаем весь, в методе отделятся нужные, не нужные не будут использоваться
         * @param urlParameter - параметры урла для установки. Если пустой массив - сортировка и пейджинг берутся предыдущие, хотфильтры
         * сбрасываются
         */
        setDataManipulateParameters(urlParameters) {
            return __awaiter(this, void 0, void 0, function* () {
                const filtering = yield __classPrivateFieldGet(this, _HotelResultMobile_instances, "m", _HotelResultMobile_setHotFiltersByUrlParameters).call(this, urlParameters);
                if (!urlParameters) {
                    return {
                        filtering,
                        sorting: this.sorting,
                        paging: this.paging,
                    };
                }
                return {
                    filtering,
                    sorting: __classPrivateFieldGet(this, _HotelResultMobile_instances, "m", _HotelResultMobile_setSortingByUrlParameters).call(this, urlParameters),
                    paging: __classPrivateFieldGet(this, _HotelResultMobile_instances, "m", _HotelResultMobile_setPagingByUrlParameters).call(this, urlParameters),
                };
            });
        }
        /**
         * Прицепляет событие на проверку правил отмены
         * @param root - корневой элемент для ссылок 'проверить правила отмены'.
         * Например, это body для большинства случаев и конкретный блок с инфой о конкретном отеле для страницы с картой отелей
         */
        bindCheckCancellationRules(root) {
            // TODO: убедиться нужно ли это, в связи с добавляемым handler в конструкторе.
            $('.js-cancellation-rules', root).on('click', e => __classPrivateFieldGet(_a, _a, "m", _HotelResultMobile_onCheckCancellationClick).call(_a, e));
        }
        bindBlocks() {
            super.bindBlocks();
            $('.js-booking-com-book').on('click', e => _a.onBookingComClick(e));
        }
        unbindBlocks() {
            super.unbindBlocks();
            $('.js-booking-com-book').off('click', _a.onBookingComClick);
            // убрать обработчики, в Result.ts bindBlocks() обработчики будут установлены по вызову "Показать ещё" для
            // существующих и вновь добавленных данных.
            const toursOutputBlock = $('.js-tours-output-block', this.root);
            const toursOutputTable = $('.js-tours-output-table', this.root);
            const clickableBlocks = $('.js-clickable-block', toursOutputBlock);
            const clickableTableBlocks = $('.js-clickable-block', toursOutputTable);
            clickableBlocks.off('click');
            clickableTableBlocks.off('click');
        }
        /**
         * На событие клика на ссылку бронирования на букинге
         * @param event
         */
        static onBookingComClick(event) {
            // Если у данного варианта нет ссылки на bookin.com, то пользователь не авторизован.
            // Т.е. если ссылка есть, выводит подтверждение перехода по ней, если нет - просьбу авторизоваться
            const element = $(event.currentTarget);
            const bookingComLink = element.attr('data-booking-com-link');
            // В попапе сразу два блока - для авторизованного или нет. Надо просто брать нужный для вставки в попап
            const popupContent = App.templates.Hotel.Popups.BookingComPopups({});
            let bookingComBlock;
            if (bookingComLink) {
                bookingComBlock = $(popupContent).find('.js-booking-com-go');
                if (bookingComBlock)
                    bookingComBlock.find('.js-booking-com-link').attr('href', bookingComLink);
            }
            else {
                bookingComBlock = $(popupContent).find('.js-booking-com-notauthorized');
            }
            if (bookingComBlock && bookingComBlock.length > 0)
                App.popupShow(bookingComBlock, 'Купить на Booking.com');
        }
    }
    _a = HotelResultMobile, _HotelResultMobile_instances = new WeakSet(), _HotelResultMobile_onCheckCancellationClick = function _HotelResultMobile_onCheckCancellationClick(event) {
        // Предотвращаем клик на ссылку, которой является блок в блочном представлении при поиске
        event.preventDefault();
        event.stopPropagation();
        $(event.target).trigger("getCancellation:click" /* Events.GetCancellationClick */);
    }, _HotelResultMobile_setSortingByUrlParameters = function _HotelResultMobile_setSortingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'sort');
        if (pageUrlParameter) {
            [this.sorting.field] = pageUrlParameter.values;
            this.sorting.reverse = pageUrlParameter.values[1] === 'desc';
        }
        return this.sorting;
    }, _HotelResultMobile_setHotFiltersByUrlParameters = function _HotelResultMobile_setHotFiltersByUrlParameters(urlParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (urlParameters) {
                const parameters = urlParameters
                    .filter(v => {
                    const itemName = v.name.toLowerCase();
                    return itemName === App.HotelHotFilterFields.AccommodationTypes
                        || itemName === App.HotelHotFilterFields.RoomTypes
                        || itemName === App.HotelHotFilterFields.Boards
                        || itemName === App.HotelHotFilterFields.Provider
                        || itemName === App.HotelHotFilterFields.OfferSource
                        || itemName === App.HotelHotFilterFields.Areas
                        || itemName === App.HotelHotFilterFields.MinRating
                        || itemName === App.HotelHotFilterFields.AccommodationName
                        || itemName === App.HotelHotFilterFields.Facilities
                        || itemName === App.HotelHotFilterFields.Prices
                        || itemName === App.HotelHotFilterFields.VatIncluded
                        || itemName === App.HotelHotFilterFields.FreeCancellation
                        || itemName === App.HotelHotFilterFields.TransferIncluded
                        || itemName === App.HotelHotFilterFields.VisaAssistance
                        || itemName === App.HotelHotFilterFields.InStock
                        || itemName === App.HotelHotFilterFields.Categories;
                });
                this.filtering.items = new Array();
                /* eslint-disable no-await-in-loop */
                for (let i = 0; i < parameters.length; i++) {
                    this.filtering.items.push({
                        name: parameters[i].name,
                        // В цене 3 значения: from, to, валюта
                        values: parameters[i].name === App.HotelHotFilterFields.Prices && parameters[i].values.length === 3
                            ? yield __classPrivateFieldGet(_a, _a, "m", _HotelResultMobile_convertPriceParameters).call(_a, parameters[i])
                            : parameters[i].values,
                    });
                }
                /* eslint-enable no-await-in-loop */
            }
            else {
                this.filtering.items = new Array();
            }
            return this.filtering.items;
        });
    }, _HotelResultMobile_convertPriceParameters = function _HotelResultMobile_convertPriceParameters(filterParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentCurrency = App.Cookie.get("currency" /* KnownCookie.Currency */) || App.CurrencyManager.currentCurrencyCode;
            // Заменяем значения на конвертированный в текущую валюту
            const from = yield App.CurrencyManager.exchange(parseInt(filterParameters.values[0], 10), filterParameters.values[2].toUpperCase(), currentCurrency);
            const to = yield App.CurrencyManager.exchange(parseInt(filterParameters.values[1], 10), filterParameters.values[2].toUpperCase(), currentCurrency);
            return [
                from ? from.toString() : filterParameters.values[0],
                to ? to.toString() : filterParameters.values[1],
                // здесь валюта не нужна, т.к. при фильтрации берется из кук, но добавила на всякий -
                // т.к. где-то могу проверять длину массива значений(3) или могу ожидать, то будет, как в урле, код валюты
                currentCurrency,
            ];
        });
    }, _HotelResultMobile_setPagingByUrlParameters = function _HotelResultMobile_setPagingByUrlParameters(urlParameters) {
        const pageUrlParameter = urlParameters
            .find(item => item.name === 'page');
        if (pageUrlParameter) {
            this.paging.index = parseInt(pageUrlParameter.values[0], 10);
            this.paging.size = parseInt(App.Cookie.get("showCount" /* KnownCookie.ShowCount */) || pageUrlParameter.values[1], 10);
        }
        return this.paging;
    };
    App.HotelResultMobile = HotelResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelSearchResultMobile_instances, _a, _HotelSearchResultMobile_urlChangeStrategy, _HotelSearchResultMobile_map, _HotelSearchResultMobile_currencyConverter, _HotelSearchResultMobile_sortCurrencyCode, _HotelSearchResultMobile_renderedData, _HotelSearchResultMobile_newSearchData, _HotelSearchResultMobile_fillFullSetOfVariants, _HotelSearchResultMobile_filterHotels, _HotelSearchResultMobile_filterHotelVariants, _HotelSearchResultMobile_getRoomsModel, _HotelSearchResultMobile_filterVariants, _HotelSearchResultMobile_showOnMap, _HotelSearchResultMobile_toggleHotelVariants;
    class HotelSearchResultMobile extends App.HotelResult {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-search-block', blockTemplate: App.templates.Hotel.Blocks, tableTemplate: App.templates.Hotel.Table_Mobile }, options));
            _HotelSearchResultMobile_instances.add(this);
            _HotelSearchResultMobile_urlChangeStrategy.set(this, void 0);
            _HotelSearchResultMobile_map.set(this, void 0);
            _HotelSearchResultMobile_currencyConverter.set(this, void 0);
            _HotelSearchResultMobile_sortCurrencyCode.set(this, "RUB" /* KnownCurrencyCode.RUB */);
            /**
             * Отрендеренные данные - которые в базовом Result были отфильтрованны, отсортированны и т.д.
             */
            _HotelSearchResultMobile_renderedData.set(this, void 0);
            _HotelSearchResultMobile_newSearchData.set(this, false);
            if (!this.root.length)
                return;
            this.sorting.field = "price" /* SortByItem.Price */;
            __classPrivateFieldSet(this, _HotelSearchResultMobile_urlChangeStrategy, new App.UrlChangeStrategy(new App.HotelHotFilterSet()), "f");
            __classPrivateFieldGet(this, _HotelSearchResultMobile_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
            __classPrivateFieldSet(this, _HotelSearchResultMobile_renderedData, new Array(), "f");
            __classPrivateFieldSet(this, _HotelSearchResultMobile_map, new App.HotelsMap(), "f");
            __classPrivateFieldSet(this, _HotelSearchResultMobile_sortCurrencyCode, App.app.settings.defaultCurrency, "f");
            this.root.on('click', '.js-show-variants', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _HotelSearchResultMobile_instances, "m", _HotelSearchResultMobile_toggleHotelVariants).call(this, e); }));
        }
        applyFilters(items) {
            if (this.filtering === undefined)
                return items;
            if (items == null || items.length <= 0)
                return items;
            // заполнить полный нефильтрованный список вариантов отелей
            __classPrivateFieldGet(_a, _a, "m", _HotelSearchResultMobile_fillFullSetOfVariants).call(_a, items);
            // фильтрация отелей
            items.forEach(hotel => {
                var _b;
                hotel.variants = (_b = hotel.fullSetOfVariants) !== null && _b !== void 0 ? _b : hotel.variants;
            });
            let result = __classPrivateFieldGet(this, _HotelSearchResultMobile_instances, "m", _HotelSearchResultMobile_filterHotels).call(this, items);
            // фильтрация вариантов отелей
            __classPrivateFieldGet(this, _HotelSearchResultMobile_instances, "m", _HotelSearchResultMobile_filterHotelVariants).call(this, result);
            result = result.filter(v => v.variants.length > 0);
            return result;
        }
        /**
         * Добавляет достопримечательность на карту
         * @param pointOfInterest
         */
        addPointOfInterestOnMap(pointOfInterest) {
            __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").addPointOfInterestOnMap(pointOfInterest);
        }
        /**
         * Обновление данных
         * @param data
         */
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _HotelSearchResultMobile_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _HotelSearchResultMobile_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _HotelSearchResultMobile_currencyConverter, "f");
                    if (currencyConverter) {
                        if (!append)
                            __classPrivateFieldSet(this, _HotelSearchResultMobile_sortCurrencyCode, data[0].currencyCode, "f");
                        Enumerable.from(data)
                            .selectMany(v => v.variants)
                            .forEach(v => {
                            var _b;
                            v.sortPrice = (_b = currencyConverter.exchange(v.totalGrossPrice, v.currencyCode, __classPrivateFieldGet(this, _HotelSearchResultMobile_sortCurrencyCode, "f"))) !== null && _b !== void 0 ? _b : v.totalGrossPrice;
                        });
                    }
                    data.forEach(v => v.variants.sort((a, b) => a.sortPrice - b.sortPrice));
                }
                yield _super.changeDataSource.call(this, data, append);
            });
        }
        resetDataSource() {
            __classPrivateFieldSet(this, _HotelSearchResultMobile_renderedData, new Array(), "f");
            if (__classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").isInitMap())
                __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").resetPoints();
            super.resetDataSource();
        }
        /**
         * Инит карты.
         * @param data -данные. Приходят все данные, которые есть в приложении.
         */
        initMapBlock(hotelOffers, addBlock) {
            if (addBlock)
                return;
            // Новые данные, еще не добавленные на карту
            let newPartToRender = new Array();
            const offers = hotelOffers.filter(v => v.coordinate != null);
            if (__classPrivateFieldGet(this, _HotelSearchResultMobile_renderedData, "f").length === 0 || offers.length < __classPrivateFieldGet(this, _HotelSearchResultMobile_renderedData, "f").length) {
                __classPrivateFieldSet(this, _HotelSearchResultMobile_renderedData, new Array(), "f");
                newPartToRender = offers;
                if (!__classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").isInitMap())
                    __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").initMap();
                if (__classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").isInitMap())
                    __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").resetPoints();
            }
            else {
                if (offers && __classPrivateFieldGet(this, _HotelSearchResultMobile_renderedData, "f")) {
                    newPartToRender = offers.filter(newOffer => {
                        const renderedOffer = __classPrivateFieldGet(this, _HotelSearchResultMobile_renderedData, "f").find(rendered => rendered.key === newOffer.key);
                        return !renderedOffer;
                    });
                }
            }
            __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").addHotelPoints(newPartToRender);
            if (!__classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").isActiveMap())
                __classPrivateFieldSet(this, _HotelSearchResultMobile_newSearchData, true, "f");
            // обновим коллекцию отрендеренных данных
            __classPrivateFieldSet(this, _HotelSearchResultMobile_renderedData, __classPrivateFieldGet(this, _HotelSearchResultMobile_renderedData, "f").concat(newPartToRender), "f");
        }
        showMapView(event) {
            super.showMapView(event);
            if (!__classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").isInitMap())
                __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").initMap();
            if (event != undefined && __classPrivateFieldGet(this, _HotelSearchResultMobile_newSearchData, "f")) {
                __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").renewMap();
                __classPrivateFieldSet(this, _HotelSearchResultMobile_newSearchData, false, "f");
            }
        }
        bindBlocks() {
            super.bindBlocks();
            $('.js-show-on-map').on('click', e => __classPrivateFieldGet(this, _HotelSearchResultMobile_instances, "m", _HotelSearchResultMobile_showOnMap).call(this, e));
        }
        unbindBlocks() {
            super.unbindBlocks();
            $('.js-show-on-map').off('click', e => __classPrivateFieldGet(this, _HotelSearchResultMobile_instances, "m", _HotelSearchResultMobile_showOnMap).call(this, e));
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case App.HotelSortFields.Alphabet: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.name);
                    else
                        result = Enumerable.from(items).orderBy(v => v.name);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Distance: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.distanceFromPointOfInterest);
                    else
                        result = Enumerable.from(items).orderBy(v => v.distanceFromPointOfInterest);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Getting: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.gettingOrder);
                    else
                        result = Enumerable.from(items).orderBy(v => v.gettingOrder);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Price: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.sortPrice);
                    else
                        result = Enumerable.from(items).orderBy(v => v.sortPrice);
                    return result
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Rating: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => { var _b; return (_b = v.pacRating) !== null && _b !== void 0 ? _b : Number.MIN_VALUE; });
                    else
                        result = Enumerable.from(items).orderBy(v => { var _b; return (_b = v.pacRating) !== null && _b !== void 0 ? _b : Number.MAX_VALUE; });
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.StarRating: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.stars);
                    else
                        result = Enumerable.from(items).orderBy(v => v.stars);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .reverse()
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .toArray();
                }
            }
        }
    }
    _a = HotelSearchResultMobile, _HotelSearchResultMobile_urlChangeStrategy = new WeakMap(), _HotelSearchResultMobile_map = new WeakMap(), _HotelSearchResultMobile_currencyConverter = new WeakMap(), _HotelSearchResultMobile_sortCurrencyCode = new WeakMap(), _HotelSearchResultMobile_renderedData = new WeakMap(), _HotelSearchResultMobile_newSearchData = new WeakMap(), _HotelSearchResultMobile_instances = new WeakSet(), _HotelSearchResultMobile_fillFullSetOfVariants = function _HotelSearchResultMobile_fillFullSetOfVariants(hotels) {
        hotels.forEach(hotel => {
            if (hotel.fullSetOfVariants == null)
                hotel.fullSetOfVariants = hotel.variants;
        });
    }, _HotelSearchResultMobile_filterHotels = function _HotelSearchResultMobile_filterHotels(hotels) {
        let result = hotels;
        // при изменении фильтра - меняем ссылку на отель, с учетом параметров фильтра (тип номера и питание)
        const urlParameters = App.UrlParameterHelper.urlParse();
        // параметры основного фильтра неиспользуемые при формировании ссылки на отель
        const unnecessaryUrlParameters = [
            App.HotelUrlParameters.location.toLowerCase(),
            App.HotelUrlParameters.category.toLowerCase(),
            App.HotelUrlParameters.types.toLowerCase(),
        ];
        // параметры дополнительного фильтра, которые могли измениться
        const extraUrlParameters = [
            App.HotelHotFilterFields.Prices,
            App.HotelHotFilterFields.AccommodationTypes,
            App.HotelHotFilterFields.RoomTypes,
            App.HotelHotFilterFields.Boards,
            App.HotelHotFilterFields.Provider,
            App.HotelHotFilterFields.OfferSource,
            App.HotelHotFilterFields.AccommodationName,
            App.HotelHotFilterFields.FreeCancellation,
            App.HotelHotFilterFields.TransferIncluded,
            App.HotelHotFilterFields.VisaAssistance,
            App.HotelHotFilterFields.InStock,
        ];
        const reducedSearchUrlParameters = urlParameters.filter(item => {
            const name = item.name.toLowerCase();
            return !unnecessaryUrlParameters.includes(name) && !extraUrlParameters.includes(name);
        });
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            // Note: здесь только фильтры, применяемые к самим отелям, а не к вариантам.
            const filterName = filter.name.toLowerCase();
            switch (filterName) {
                case App.HotelHotFilterFields.AccommodationTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => item.accommodationTypeCode === currentFilter));
                    break;
                case App.HotelHotFilterFields.Areas:
                    result = result
                        .filter(item => item.cityAreas
                        // Первое условие - id района предложения совпадает с id района из хотфильтра
                        .some(area => filter.values
                        .some(currentFilter => area.toString() === currentFilter))
                        // Второе условие - в фильтре есть id района 0 - это 'Другой', а в районах предложения нет ничего
                        || (item.cityAreas.length === 0 && filter.values.some(currentFilter => currentFilter === '0')));
                    break;
                case App.HotelHotFilterFields.MinRating: {
                    const filterRating = parseFloat(filter.values[0]);
                    result = result.filter(item => item.generalRating >= filterRating);
                    break;
                }
                case App.HotelHotFilterFields.Facilities:
                    result = result
                        .filter(item => filter.values
                        // Если для чекбоксовых фильтров фильтры действуют как услвоие ИЛИ - т.е. отмечаем Ватикан, добавляем отели
                        // в ватикане, отмечаем Вокзал, ДОБАВЛЯЕМ вокзал в Ватикану
                        // То для услуг - И, т.е. каждый отель должен содержать ВСЕ отмеченные в фильтре услуги
                        .every(currentFilter => item.facilities
                        .some(facility => facility.key.toString() === currentFilter.toLowerCase())));
                    break;
                case App.HotelHotFilterFields.AccommodationName:
                    result = result.filter(v => v.name.toLowerCase().includes(decodeURI(filter.values[0]).toLowerCase()));
                    break;
                case App.HotelHotFilterFields.Categories: {
                    // должно быть два значения - from, to
                    if (filter.values.length !== 2)
                        continue;
                    // найдем значения и проверим их
                    const from = parseInt(filter.values[0], 10);
                    const to = parseInt(filter.values[1], 10);
                    if (from > to)
                        continue;
                    result = result.filter(v => {
                        var _b;
                        const stars = parseInt((_b = v.stars) !== null && _b !== void 0 ? _b : '0', 10);
                        return stars >= from && stars <= to;
                    });
                    break;
                }
                // no default
            }
            reducedSearchUrlParameters.push({
                name: filterName,
                values: filter.values,
            });
        }
        // обновляем ссылку на отель (костыль: только если находимся в отельной услуге)
        if (result.length > 0 && (result[0].link == null || result[0].link.startsWith(App.HotelPageUrls.Info))) {
            result.forEach(item => {
                item.link = App.app.url.route(App.HotelPageUrls.Info, item.key, reducedSearchUrlParameters);
            });
        }
        return result;
    }, _HotelSearchResultMobile_filterHotelVariants = function _HotelSearchResultMobile_filterHotelVariants(result) {
        const roomsModel = __classPrivateFieldGet(_a, _a, "m", _HotelSearchResultMobile_getRoomsModel).call(_a);
        const currencyConverter = __classPrivateFieldGet(this, _HotelSearchResultMobile_currencyConverter, "f");
        result.forEach(hotel => {
            var _b, _c, _d, _e, _f;
            hotel.variants = __classPrivateFieldGet(this, _HotelSearchResultMobile_instances, "m", _HotelSearchResultMobile_filterVariants).call(this, hotel.variants);
            hotel.bestVariants = App.BestVariantsSelector.select(hotel.variants, roomsModel);
            if (hotel.bestVariants) {
                hotel.netPrice = 0;
                hotel.grossPrice = 0;
                hotel.price = 0;
                hotel.totalNetPrice = 0;
                hotel.totalGrossPrice = 0;
                hotel.totalPrice = 0;
                hotel.sortPrice = 0;
                for (const bestVariant of hotel.bestVariants) {
                    const rate = (_b = currencyConverter === null || currencyConverter === void 0 ? void 0 : currencyConverter.exchange(1, bestVariant.currencyCode, hotel.currencyCode)) !== null && _b !== void 0 ? _b : 1;
                    hotel.netPrice += ((_c = bestVariant.netPrice) !== null && _c !== void 0 ? _c : 0) * rate;
                    hotel.grossPrice += bestVariant.grossPrice * rate;
                    hotel.price += ((_d = bestVariant.price) !== null && _d !== void 0 ? _d : 0) * rate;
                    hotel.totalNetPrice += ((_e = bestVariant.totalNetPrice) !== null && _e !== void 0 ? _e : 0) * rate;
                    hotel.totalGrossPrice += bestVariant.totalGrossPrice * rate;
                    hotel.totalPrice += ((_f = bestVariant.totalPrice) !== null && _f !== void 0 ? _f : 0) * rate;
                    hotel.sortPrice += bestVariant.sortPrice;
                }
            }
            else {
                hotel.sortPrice = Number.MAX_SAFE_INTEGER;
            }
        });
    }, _HotelSearchResultMobile_getRoomsModel = function _HotelSearchResultMobile_getRoomsModel() {
        const urlParameters = App.UrlParameterHelper.urlParse();
        const rooms = urlParameters
            .filter(item => item.name.toLowerCase() === App.HotelUrlParameters.rooms);
        const roomsModel = rooms.map(room => {
            const touristModel = {
                adultCount: parseInt(room.values[0], 10),
                childAges: new Array(),
            };
            if (Number.isNaN(touristModel.adultCount))
                touristModel.adultCount = 0;
            // дети из параметров урла - это значения после нулевого индекса
            // (tourist - 3, 2, 4, 3 - дети - 2, 4, 3)
            // Поэтому цикл не с нулевого индекса, а с первого
            for (let i = 1; i < room.values.length; i++)
                touristModel.childAges.push(parseInt(room.values[i], 10));
            return touristModel;
        });
        return roomsModel;
    }, _HotelSearchResultMobile_filterVariants = function _HotelSearchResultMobile_filterVariants(variants) {
        let result = variants;
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            switch (filter.name.toLowerCase()) {
                case App.HotelHotFilterFields.Keys:
                    result = result.filter(v => !filter.values.includes(v.key));
                    break;
                case App.HotelHotFilterFields.RoomTypes:
                    result = result.filter(v => v.roomGroups.some(rg => filter.values.includes(rg))
                        || (v.roomGroups.length === 0 && filter.values.includes('0')));
                    break;
                case App.HotelHotFilterFields.Boards: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result.filter(v => values.includes(v.boardGroup.toLowerCase()));
                    break;
                }
                case App.HotelHotFilterFields.Provider: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result.filter(v => v.provider && values.includes(v.provider.key.toString()));
                    break;
                }
                case App.HotelHotFilterFields.OfferSource: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result.filter(v => v.offerSource && values.includes(v.offerSource.key.toString()));
                    break;
                }
                case App.HotelHotFilterFields.Prices: {
                    if (filter.values.length !== 2)
                        continue;
                    // найдем значения и проверим их
                    const from = parseInt(filter.values[0], 10);
                    const to = parseInt(filter.values[1], 10);
                    if (!from || !to)
                        continue;
                    const filteredResult = new Array();
                    for (let j = 0; j < result.length; j++) {
                        const variant = result[j];
                        const convertedGrossPrice = __classPrivateFieldGet(this, _HotelSearchResultMobile_currencyConverter, "f")
                            ? __classPrivateFieldGet(this, _HotelSearchResultMobile_currencyConverter, "f").exchange(variant.totalGrossPrice, variant.currencyCode, App.CurrencyManager.currentCurrencyCode)
                            : null;
                        if (convertedGrossPrice && convertedGrossPrice > from && convertedGrossPrice < to)
                            filteredResult.push(variant);
                    }
                    result = filteredResult;
                    break;
                }
                case App.HotelHotFilterFields.FreeCancellation:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.freeCancellation === true);
                    break;
                case App.HotelHotFilterFields.TransferIncluded:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.transferIncluded === true);
                    break;
                case App.HotelHotFilterFields.VisaAssistance:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.visaAssistance === true);
                    break;
                case App.HotelHotFilterFields.InStock:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.byRequest === false);
                    break;
                // no default
            }
        }
        return result;
    }, _HotelSearchResultMobile_showOnMap = function _HotelSearchResultMobile_showOnMap(event) {
        event.preventDefault();
        event.stopPropagation();
        const filterMapViewBtn = $('.js-view-item[data-code="map"]');
        const filterMapViewBtnOffset = filterMapViewBtn.offset();
        filterMapViewBtn.trigger('click');
        $('html, body').animate({ scrollTop: (filterMapViewBtnOffset != null ? filterMapViewBtnOffset.top : 0) }, 500);
        const element = $(event.target);
        const dataOfferKey = element.attr('data-id');
        if (!dataOfferKey)
            return;
        const offerKey = parseInt(dataOfferKey, 10);
        const selectedOffer = __classPrivateFieldGet(this, _HotelSearchResultMobile_renderedData, "f").find(item => item.key === offerKey);
        if (!selectedOffer)
            return;
        setTimeout(() => __classPrivateFieldGet(this, _HotelSearchResultMobile_map, "f").openMapByOffer(selectedOffer), 500);
    }, _HotelSearchResultMobile_toggleHotelVariants = function _HotelSearchResultMobile_toggleHotelVariants(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.target);
            const hotelKey = parseInt((_b = target.attr('data-id')) !== null && _b !== void 0 ? _b : '0', 10);
            const hotel = this.data.find(v => v.key === hotelKey);
            if (!hotel)
                return;
            const variants = hotel.variants;
            variants.forEach(v => (v.selected = false));
            const element = $('.js-show-variants', `.js-tour-table-block[data-id='${hotelKey}']`);
            const block = $(`.js-output-block[data-id='${hotelKey}']`);
            if (block.hasClass('_hidden-2')) {
                hotel.active = true;
                element.html(localizer.hideRooms);
                block.showByClass();
                // TODO: можно реализовать в HotelSearchResult, как это реализовано в HotelInfoResult (из-за того, что лучший вариант должен пересчитываться при каждом изменении вторичной фильтрации), но возникает проблема с тем, что в HotelSearchResult манипуляция данными производится в плоском виде, без учета группировки по отелю, поэтому либо нужно передавать ID отеля, по которому нужно найти лучший вариант, либо лучший вариант искать по каждому отелю.
                // const rooms = this.#searchMainFilter.getRooms();
                // const bestVariants = BestVariantsSelector.select(variants, rooms);
                // DataTransformer.variantsDataTransformation(variants, bestVariants);
                const content = $(App.templates.Hotel.DetailTable(variants));
                yield App.CurrencyManager.convertAll(content);
                App.NetPricePresenter.setVisibility(content, App.NetPricePresenter.getVisibility());
                $('.js-tours-output-table', block)
                    .empty()
                    .append(content);
                block.trigger("pw:show" /* Events.Show */, [{ target: block }]);
            }
            else {
                hotel.active = false;
                element.html(localizer.showRooms);
                block.hideByClass();
                variants.forEach(v => (App.Hotel.toggleVariant(block, v.key, false)));
                block.trigger("pw:hide" /* Events.Hide */, [{ target: block }]);
            }
        });
    };
    App.HotelSearchResultMobile = HotelSearchResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelSearchResult_instances, _a, _HotelSearchResult_urlChangeStrategy, _HotelSearchResult_map, _HotelSearchResult_currencyConverter, _HotelSearchResult_sortCurrencyCode, _HotelSearchResult_renderedData, _HotelSearchResult_newSearchData, _HotelSearchResult_searchContent, _HotelSearchResult_fillFullSetOfVariants, _HotelSearchResult_filterHotels, _HotelSearchResult_filterHotelVariants, _HotelSearchResult_getRoomsModel, _HotelSearchResult_filterVariants, _HotelSearchResult_showOnMap, _HotelSearchResult_toggleHotelVariants;
    class HotelSearchResult extends App.HotelResult {
        constructor(options) {
            super(Object.assign({ root: '.js-hotel-search-block', blockTemplate: App.templates.Hotel.Blocks, tableTemplate: App.templates.Hotel.Table }, options));
            _HotelSearchResult_instances.add(this);
            _HotelSearchResult_urlChangeStrategy.set(this, void 0);
            _HotelSearchResult_map.set(this, void 0);
            _HotelSearchResult_currencyConverter.set(this, void 0);
            _HotelSearchResult_sortCurrencyCode.set(this, "RUB" /* KnownCurrencyCode.RUB */);
            /**
             * Отрендеренные данные - которые в базовом Result были отфильтрованны, отсортированны и т.д.
             */
            _HotelSearchResult_renderedData.set(this, void 0);
            _HotelSearchResult_newSearchData.set(this, false);
            _HotelSearchResult_searchContent.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _HotelSearchResult_searchContent, $('.js-hotel-search-content', this.root), "f");
            this.sorting.field = "price" /* SortByItem.Price */;
            __classPrivateFieldSet(this, _HotelSearchResult_urlChangeStrategy, new App.UrlChangeStrategy(new App.HotelHotFilterSet()), "f");
            __classPrivateFieldGet(this, _HotelSearchResult_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
            __classPrivateFieldSet(this, _HotelSearchResult_renderedData, new Array(), "f");
            __classPrivateFieldSet(this, _HotelSearchResult_map, new App.HotelsMap(), "f");
            __classPrivateFieldSet(this, _HotelSearchResult_sortCurrencyCode, App.app.settings.defaultCurrency, "f");
            this.root.on('click', '.js-show-variants', e => __classPrivateFieldGet(this, _HotelSearchResult_instances, "m", _HotelSearchResult_toggleHotelVariants).call(this, e));
        }
        applyFilters(items) {
            if (this.filtering === undefined)
                return items;
            if (items == null || items.length <= 0)
                return items;
            // заполнить полный нефильтрованный список вариантов отелей
            __classPrivateFieldGet(_a, _a, "m", _HotelSearchResult_fillFullSetOfVariants).call(_a, items);
            // фильтрация отелей
            items.forEach(hotel => {
                var _b;
                hotel.variants = (_b = hotel.fullSetOfVariants) !== null && _b !== void 0 ? _b : hotel.variants;
            });
            let result = __classPrivateFieldGet(this, _HotelSearchResult_instances, "m", _HotelSearchResult_filterHotels).call(this, items);
            // фильтрация вариантов отелей
            __classPrivateFieldGet(this, _HotelSearchResult_instances, "m", _HotelSearchResult_filterHotelVariants).call(this, result);
            result = result.filter(v => v.variants.length > 0);
            return result;
        }
        /**
         * Добавляет достопримечательность на карту
         * @param pointOfInterest
         */
        addPointOfInterestOnMap(pointOfInterest) {
            __classPrivateFieldGet(this, _HotelSearchResult_map, "f").addPointOfInterestOnMap(pointOfInterest);
        }
        /**
         * Обновление данных
         * @param data
         */
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _HotelSearchResult_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _HotelSearchResult_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _HotelSearchResult_currencyConverter, "f");
                    if (currencyConverter) {
                        if (!append)
                            __classPrivateFieldSet(this, _HotelSearchResult_sortCurrencyCode, data[0].currencyCode, "f");
                        Enumerable.from(data)
                            .selectMany(v => v.variants)
                            .forEach(v => {
                            var _b;
                            v.sortPrice = (_b = currencyConverter.exchange(v.totalGrossPrice, v.currencyCode, __classPrivateFieldGet(this, _HotelSearchResult_sortCurrencyCode, "f"))) !== null && _b !== void 0 ? _b : v.totalGrossPrice;
                        });
                    }
                    data.forEach(v => v.variants.sort((a, b) => a.sortPrice - b.sortPrice));
                }
                yield _super.changeDataSource.call(this, data, append);
                if (data.length > 0) {
                    this.root.showByClass();
                    __classPrivateFieldGet(this, _HotelSearchResult_searchContent, "f").showByClass();
                }
            });
        }
        resetDataSource() {
            __classPrivateFieldGet(this, _HotelSearchResult_searchContent, "f").hideByClass();
            __classPrivateFieldSet(this, _HotelSearchResult_renderedData, new Array(), "f");
            if (__classPrivateFieldGet(this, _HotelSearchResult_map, "f").isInitMap())
                __classPrivateFieldGet(this, _HotelSearchResult_map, "f").resetPoints();
            super.resetDataSource();
        }
        /**
         * Инит карты.
         * @param data -данные. Приходят все данные, которые есть в приложении.
         */
        initMapBlock(hotelOffers, addBlock) {
            if (addBlock)
                return;
            // Новые данные, еще не добавленные на карту
            let newPartToRender = new Array();
            const offers = hotelOffers.filter(v => v.coordinate != null);
            if (__classPrivateFieldGet(this, _HotelSearchResult_renderedData, "f").length === 0 || offers.length < __classPrivateFieldGet(this, _HotelSearchResult_renderedData, "f").length) {
                __classPrivateFieldSet(this, _HotelSearchResult_renderedData, new Array(), "f");
                newPartToRender = offers;
                if (!__classPrivateFieldGet(this, _HotelSearchResult_map, "f").isInitMap())
                    __classPrivateFieldGet(this, _HotelSearchResult_map, "f").initMap();
                if (__classPrivateFieldGet(this, _HotelSearchResult_map, "f").isInitMap())
                    __classPrivateFieldGet(this, _HotelSearchResult_map, "f").resetPoints();
            }
            else {
                if (offers && __classPrivateFieldGet(this, _HotelSearchResult_renderedData, "f")) {
                    newPartToRender = offers.filter(newOffer => {
                        const renderedOffer = __classPrivateFieldGet(this, _HotelSearchResult_renderedData, "f").find(rendered => rendered.key === newOffer.key);
                        return !renderedOffer;
                    });
                }
            }
            __classPrivateFieldGet(this, _HotelSearchResult_map, "f").addHotelPoints(newPartToRender);
            if (!__classPrivateFieldGet(this, _HotelSearchResult_map, "f").isActiveMap())
                __classPrivateFieldSet(this, _HotelSearchResult_newSearchData, true, "f");
            // обновим коллекцию отрендеренных данных
            __classPrivateFieldSet(this, _HotelSearchResult_renderedData, __classPrivateFieldGet(this, _HotelSearchResult_renderedData, "f").concat(newPartToRender), "f");
        }
        showMapView(event) {
            super.showMapView(event);
            if (!__classPrivateFieldGet(this, _HotelSearchResult_map, "f").isInitMap())
                __classPrivateFieldGet(this, _HotelSearchResult_map, "f").initMap();
            if (event != undefined && __classPrivateFieldGet(this, _HotelSearchResult_newSearchData, "f")) {
                __classPrivateFieldGet(this, _HotelSearchResult_map, "f").renewMap();
                __classPrivateFieldSet(this, _HotelSearchResult_newSearchData, false, "f");
            }
        }
        bindBlocks() {
            super.bindBlocks();
            $('.js-show-on-map').on('click', e => __classPrivateFieldGet(this, _HotelSearchResult_instances, "m", _HotelSearchResult_showOnMap).call(this, e));
        }
        unbindBlocks() {
            super.unbindBlocks();
            $('.js-show-on-map').off('click', e => __classPrivateFieldGet(this, _HotelSearchResult_instances, "m", _HotelSearchResult_showOnMap).call(this, e));
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case App.HotelSortFields.Alphabet: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.name);
                    else
                        result = Enumerable.from(items).orderBy(v => v.name);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Distance: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.distanceFromPointOfInterest);
                    else
                        result = Enumerable.from(items).orderBy(v => v.distanceFromPointOfInterest);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Getting: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.gettingOrder);
                    else
                        result = Enumerable.from(items).orderBy(v => v.gettingOrder);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Price: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.sortPrice);
                    else
                        result = Enumerable.from(items).orderBy(v => v.sortPrice);
                    return result
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.Rating: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => { var _b; return (_b = v.pacRating) !== null && _b !== void 0 ? _b : Number.MIN_VALUE; });
                    else
                        result = Enumerable.from(items).orderBy(v => { var _b; return (_b = v.pacRating) !== null && _b !== void 0 ? _b : Number.MAX_VALUE; });
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.HotelSortFields.StarRating: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.stars);
                    else
                        result = Enumerable.from(items).orderBy(v => v.stars);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .reverse()
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .toArray();
                }
            }
        }
    }
    _a = HotelSearchResult, _HotelSearchResult_urlChangeStrategy = new WeakMap(), _HotelSearchResult_map = new WeakMap(), _HotelSearchResult_currencyConverter = new WeakMap(), _HotelSearchResult_sortCurrencyCode = new WeakMap(), _HotelSearchResult_renderedData = new WeakMap(), _HotelSearchResult_newSearchData = new WeakMap(), _HotelSearchResult_searchContent = new WeakMap(), _HotelSearchResult_instances = new WeakSet(), _HotelSearchResult_fillFullSetOfVariants = function _HotelSearchResult_fillFullSetOfVariants(hotels) {
        hotels.forEach(hotel => {
            if (hotel.fullSetOfVariants == null)
                hotel.fullSetOfVariants = hotel.variants;
        });
    }, _HotelSearchResult_filterHotels = function _HotelSearchResult_filterHotels(hotels) {
        let result = hotels;
        // при изменении фильтра - меняем ссылку на отель, с учетом параметров фильтра (тип номера и питание)
        const urlParameters = App.UrlParameterHelper.urlParse();
        // параметры основного фильтра неиспользуемые при формировании ссылки на отель
        const unnecessaryUrlParameters = [
            App.HotelUrlParameters.location.toLowerCase(),
            App.HotelUrlParameters.category.toLowerCase(),
            App.HotelUrlParameters.types.toLowerCase(),
        ];
        // параметры дополнительного фильтра, которые могли измениться
        const extraUrlParameters = [
            App.HotelHotFilterFields.Prices,
            App.HotelHotFilterFields.AccommodationTypes,
            App.HotelHotFilterFields.RoomTypes,
            App.HotelHotFilterFields.Boards,
            App.HotelHotFilterFields.Provider,
            App.HotelHotFilterFields.OfferSource,
            App.HotelHotFilterFields.AccommodationName,
            App.HotelHotFilterFields.FreeCancellation,
            App.HotelHotFilterFields.TransferIncluded,
            App.HotelHotFilterFields.VisaAssistance,
            App.HotelHotFilterFields.InStock,
        ];
        const reducedSearchUrlParameters = urlParameters.filter(item => {
            const name = item.name.toLowerCase();
            return !unnecessaryUrlParameters.includes(name) && !extraUrlParameters.includes(name);
        });
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            // Note: здесь только фильтры, применяемые к самим отелям, а не к вариантам.
            const filterName = filter.name.toLowerCase();
            switch (filterName) {
                case App.HotelHotFilterFields.AccommodationTypes:
                    result = result
                        .filter(item => filter.values
                        .some(currentFilter => item.accommodationTypeCode === currentFilter));
                    break;
                case App.HotelHotFilterFields.Areas:
                    result = result
                        .filter(item => item.cityAreas
                        // Первое условие - id района предложения совпадает с id района из хотфильтра
                        .some(area => filter.values
                        .some(currentFilter => area.toString() === currentFilter))
                        // Второе условие - в фильтре есть id района 0 - это 'Другой', а в районах предложения нет ничего
                        || (item.cityAreas.length === 0 && filter.values.some(currentFilter => currentFilter === '0')));
                    break;
                case App.HotelHotFilterFields.MinRating: {
                    const filterRating = parseFloat(filter.values[0]);
                    result = result.filter(item => item.generalRating >= filterRating);
                    break;
                }
                case App.HotelHotFilterFields.Facilities:
                    result = result
                        .filter(item => filter.values
                        // Если для чекбоксовых фильтров фильтры действуют как услвоие ИЛИ - т.е. отмечаем Ватикан, добавляем отели
                        // в ватикане, отмечаем Вокзал, ДОБАВЛЯЕМ вокзал в Ватикану
                        // То для услуг - И, т.е. каждый отель должен содержать ВСЕ отмеченные в фильтре услуги
                        .every(currentFilter => item.facilities
                        .some(facility => facility.key.toString() === currentFilter.toLowerCase())));
                    break;
                case App.HotelHotFilterFields.AccommodationName:
                    result = result.filter(v => v.name.toLowerCase().includes(decodeURI(filter.values[0]).toLowerCase()));
                    break;
                case App.HotelHotFilterFields.Categories: {
                    // должно быть два значения - from, to
                    if (filter.values.length !== 2)
                        continue;
                    // найдем значения и проверим их
                    const from = parseInt(filter.values[0], 10);
                    const to = parseInt(filter.values[1], 10);
                    if (from > to)
                        continue;
                    result = result.filter(v => {
                        var _b;
                        const stars = parseInt((_b = v.stars) !== null && _b !== void 0 ? _b : '0', 10);
                        return stars >= from && stars <= to;
                    });
                    break;
                }
                // no default
            }
            reducedSearchUrlParameters.push({
                name: filterName,
                values: filter.values,
            });
        }
        // обновляем ссылку на отель (костыль: только если находимся в отельной услуге)
        if (result.length > 0 && (result[0].link == null || result[0].link.startsWith(App.HotelPageUrls.Info))) {
            result.forEach(item => {
                item.link = App.app.url.route(App.HotelPageUrls.Info, item.key, reducedSearchUrlParameters);
            });
        }
        return result;
    }, _HotelSearchResult_filterHotelVariants = function _HotelSearchResult_filterHotelVariants(result) {
        const roomsModel = __classPrivateFieldGet(_a, _a, "m", _HotelSearchResult_getRoomsModel).call(_a);
        const currencyConverter = __classPrivateFieldGet(this, _HotelSearchResult_currencyConverter, "f");
        result.forEach(hotel => {
            var _b, _c, _d, _e, _f;
            hotel.variants = __classPrivateFieldGet(this, _HotelSearchResult_instances, "m", _HotelSearchResult_filterVariants).call(this, hotel.variants);
            hotel.bestVariants = App.BestVariantsSelector.select(hotel.variants, roomsModel);
            if (hotel.bestVariants) {
                hotel.netPrice = 0;
                hotel.grossPrice = 0;
                hotel.price = 0;
                hotel.totalNetPrice = 0;
                hotel.totalGrossPrice = 0;
                hotel.totalPrice = 0;
                hotel.sortPrice = 0;
                for (const bestVariant of hotel.bestVariants) {
                    const rate = (_b = currencyConverter === null || currencyConverter === void 0 ? void 0 : currencyConverter.exchange(1, bestVariant.currencyCode, hotel.currencyCode)) !== null && _b !== void 0 ? _b : 1;
                    hotel.netPrice += ((_c = bestVariant.netPrice) !== null && _c !== void 0 ? _c : 0) * rate;
                    hotel.grossPrice += bestVariant.grossPrice * rate;
                    hotel.price += ((_d = bestVariant.price) !== null && _d !== void 0 ? _d : 0) * rate;
                    hotel.totalNetPrice += ((_e = bestVariant.totalNetPrice) !== null && _e !== void 0 ? _e : 0) * rate;
                    hotel.totalGrossPrice += bestVariant.totalGrossPrice * rate;
                    hotel.totalPrice += ((_f = bestVariant.totalPrice) !== null && _f !== void 0 ? _f : 0) * rate;
                    hotel.sortPrice += bestVariant.sortPrice;
                }
            }
            else {
                hotel.sortPrice = Number.MAX_SAFE_INTEGER;
            }
        });
    }, _HotelSearchResult_getRoomsModel = function _HotelSearchResult_getRoomsModel() {
        const urlParameters = App.UrlParameterHelper.urlParse();
        const rooms = urlParameters
            .filter(item => item.name.toLowerCase() === App.HotelUrlParameters.rooms);
        const roomsModel = rooms.map(room => {
            const touristModel = {
                adultCount: parseInt(room.values[0], 10),
                childAges: new Array(),
            };
            if (Number.isNaN(touristModel.adultCount))
                touristModel.adultCount = 0;
            // дети из параметров урла - это значения после нулевого индекса
            // (tourist - 3, 2, 4, 3 - дети - 2, 4, 3)
            // Поэтому цикл не с нулевого индекса, а с первого
            for (let i = 1; i < room.values.length; i++)
                touristModel.childAges.push(parseInt(room.values[i], 10));
            return touristModel;
        });
        return roomsModel;
    }, _HotelSearchResult_filterVariants = function _HotelSearchResult_filterVariants(variants) {
        let result = variants;
        for (let i = 0; i < this.filtering.items.length; i++) {
            const filter = this.filtering.items[i];
            if (filter.values.length <= 0)
                continue;
            switch (filter.name.toLowerCase()) {
                case App.HotelHotFilterFields.Keys:
                    result = result.filter(v => !filter.values.includes(v.key));
                    break;
                case App.HotelHotFilterFields.RoomTypes:
                    result = result.filter(v => v.roomGroups.some(rg => filter.values.includes(rg))
                        || (v.roomGroups.length === 0 && filter.values.includes('0')));
                    break;
                case App.HotelHotFilterFields.Boards: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result.filter(v => values.includes(v.boardGroup.toLowerCase()));
                    break;
                }
                case App.HotelHotFilterFields.Provider: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result.filter(v => v.provider && values.includes(v.provider.key.toString()));
                    break;
                }
                case App.HotelHotFilterFields.OfferSource: {
                    const values = filter.values.map(v => v.toLowerCase());
                    result = result.filter(v => v.offerSource && values.includes(v.offerSource.key.toString()));
                    break;
                }
                case App.HotelHotFilterFields.Prices: {
                    if (filter.values.length !== 3)
                        continue;
                    // найдем значения и проверим их
                    const from = parseInt(filter.values[0], 10);
                    const to = parseInt(filter.values[1], 10);
                    if (!from || !to)
                        continue;
                    const filteredResult = new Array();
                    for (let j = 0; j < result.length; j++) {
                        const variant = result[j];
                        const convertedGrossPrice = __classPrivateFieldGet(this, _HotelSearchResult_currencyConverter, "f")
                            ? __classPrivateFieldGet(this, _HotelSearchResult_currencyConverter, "f").exchange(variant.totalGrossPrice, variant.currencyCode, App.CurrencyManager.currentCurrencyCode)
                            : null;
                        if (convertedGrossPrice && convertedGrossPrice > from && convertedGrossPrice < to)
                            filteredResult.push(variant);
                    }
                    result = filteredResult;
                    break;
                }
                case App.HotelHotFilterFields.FreeCancellation:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.freeCancellation === true);
                    break;
                case App.HotelHotFilterFields.TransferIncluded:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.transferIncluded === true);
                    break;
                case App.HotelHotFilterFields.VisaAssistance:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.visaAssistance === true);
                    break;
                case App.HotelHotFilterFields.InStock:
                    if (filter.values[0].toLowerCase() === 'true')
                        result = result.filter(v => v.byRequest === false);
                    break;
                // no default
            }
        }
        return result;
    }, _HotelSearchResult_showOnMap = function _HotelSearchResult_showOnMap(event) {
        event.preventDefault();
        event.stopPropagation();
        const filterMapViewBtn = $('.js-view-item[data-code="map"]');
        const filterMapViewBtnOffset = filterMapViewBtn.offset();
        filterMapViewBtn.trigger('click');
        $('html, body').animate({ scrollTop: (filterMapViewBtnOffset != null ? filterMapViewBtnOffset.top : 0) }, 500);
        const element = $(event.target);
        const dataOfferKey = element.attr('data-id');
        if (!dataOfferKey)
            return;
        const offerKey = parseInt(dataOfferKey, 10);
        const selectedOffer = __classPrivateFieldGet(this, _HotelSearchResult_renderedData, "f").find(item => item.key === offerKey);
        if (!selectedOffer)
            return;
        setTimeout(() => __classPrivateFieldGet(this, _HotelSearchResult_map, "f").openMapByOffer(selectedOffer), 500);
    }, _HotelSearchResult_toggleHotelVariants = function _HotelSearchResult_toggleHotelVariants(event) {
        var _b;
        const target = $(event.target);
        const hotelKey = parseInt((_b = target.attr('data-id')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotel = this.data.find(v => v.key === hotelKey);
        if (!hotel)
            return;
        const variants = hotel.variants;
        variants.forEach(v => (v.selected = false));
        const element = $('.js-show-variants', `.js-tour-table-block[data-id='${hotelKey}']`);
        const block = $(`.js-output-block[data-id='${hotelKey}']`);
        if (block.hasClass('_hidden-2')) {
            hotel.active = true;
            element.html(localizer.hideRooms);
            block.showByClass();
            // TODO: можно реализовать в HotelSearchResult, как это реализовано в HotelInfoResult (из-за того, что лучший вариант должен пересчитываться при каждом изменении вторичной фильтрации), но возникает проблема с тем, что в HotelSearchResult манипуляция данными производится в плоском виде, без учета группировки по отелю, поэтому либо нужно передавать ID отеля, по которому нужно найти лучший вариант, либо лучший вариант искать по каждому отелю.
            // const rooms = this.#searchMainFilter.getRooms();
            // const bestVariants = BestVariantsSelector.select(variants, rooms);
            // DataTransformer.variantsDataTransformation(variants, bestVariants);
            const content = $(App.templates.Hotel.DetailTable(variants));
            App.NetPricePresenter.setVisibility(content, App.NetPricePresenter.getVisibility());
            $('.js-tours-output-table', block)
                .empty()
                .append(content);
            block.trigger("pw:show" /* Events.Show */, [{ target: block }]);
        }
        else {
            hotel.active = false;
            element.html(localizer.showRooms);
            block.hideByClass();
            variants.forEach(v => (App.Hotel.toggleVariant(block, v.key, false)));
            block.trigger("pw:hide" /* Events.Hide */, [{ target: block }]);
        }
    };
    App.HotelSearchResult = HotelSearchResult;
})(App || (App = {}));
var App;
(function (App) {
    let HotelFacility;
    (function (HotelFacility) {
        HotelFacility.CashBack = 581;
    })(HotelFacility = App.HotelFacility || (App.HotelFacility = {}));
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Названия полей главного фильтра для отелей
     */
    let HotelFilterFields;
    (function (HotelFilterFields) {
        HotelFilterFields.PointName = 'pointname';
        HotelFilterFields.PointType = 'pointtype';
        HotelFilterFields.PointKey = 'pointkey';
        HotelFilterFields.CategoryFrom = 'category.from';
        HotelFilterFields.CategoryTo = 'category.to';
        HotelFilterFields.CheckinDatesCheckin = 'checkindates.checkin';
        HotelFilterFields.CheckinDatesCheckout = 'checkindates.checkout';
        HotelFilterFields.Types = 'types';
        HotelFilterFields.Context = 'context';
        HotelFilterFields.Citizenship = 'citizenship';
    })(HotelFilterFields = App.HotelFilterFields || (App.HotelFilterFields = {}));
})(App || (App = {}));
var App;
(function (App) {
    var _HotelHotCategory_min, _HotelHotCategory_max, _HotelHotCategory_from, _HotelHotCategory_to;
    class HotelHotCategory {
        constructor() {
            _HotelHotCategory_min.set(this, void 0);
            _HotelHotCategory_max.set(this, void 0);
            _HotelHotCategory_from.set(this, void 0);
            _HotelHotCategory_to.set(this, void 0);
        }
        get min() {
            return __classPrivateFieldGet(this, _HotelHotCategory_min, "f");
        }
        set min(value) {
            __classPrivateFieldSet(this, _HotelHotCategory_min, Math.floor(value), "f");
        }
        get max() {
            return __classPrivateFieldGet(this, _HotelHotCategory_max, "f");
        }
        set max(value) {
            __classPrivateFieldSet(this, _HotelHotCategory_max, Math.ceil(value), "f");
        }
        get from() {
            return __classPrivateFieldGet(this, _HotelHotCategory_from, "f");
        }
        set from(value) {
            __classPrivateFieldSet(this, _HotelHotCategory_from, Math.floor(value), "f");
        }
        get to() {
            return __classPrivateFieldGet(this, _HotelHotCategory_to, "f");
        }
        set to(value) {
            __classPrivateFieldSet(this, _HotelHotCategory_to, Math.ceil(value), "f");
        }
    }
    _HotelHotCategory_min = new WeakMap(), _HotelHotCategory_max = new WeakMap(), _HotelHotCategory_from = new WeakMap(), _HotelHotCategory_to = new WeakMap();
    App.HotelHotCategory = HotelHotCategory;
})(App || (App = {}));
var App;
(function (App) {
    let HotelHotFilterFields;
    (function (HotelHotFilterFields) {
        HotelHotFilterFields.Keys = 'keys';
        HotelHotFilterFields.AccommodationTypes = 'accommodationtypes';
        HotelHotFilterFields.RoomTypes = 'roomtypes';
        HotelHotFilterFields.Boards = 'boards';
        HotelHotFilterFields.Provider = 'provider';
        HotelHotFilterFields.OfferSource = 'offersource';
        HotelHotFilterFields.Areas = 'areas';
        HotelHotFilterFields.MinRating = 'minrating';
        HotelHotFilterFields.AccommodationName = 'accommodationname';
        HotelHotFilterFields.Facilities = 'facilities';
        HotelHotFilterFields.Prices = 'price';
        HotelHotFilterFields.VatIncluded = 'vatincluded';
        HotelHotFilterFields.FreeCancellation = 'freecancellation';
        HotelHotFilterFields.TransferIncluded = 'transferincluded';
        HotelHotFilterFields.VisaAssistance = 'visaassistance';
        HotelHotFilterFields.InStock = 'instock';
        HotelHotFilterFields.Categories = 'category';
    })(HotelHotFilterFields = App.HotelHotFilterFields || (App.HotelHotFilterFields = {}));
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Набор хот фильтров отелей
     */
    class HotelHotFilterSet {
        constructor() {
            Object.defineProperty(this, "accommodationTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "accommodationName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "roomTypes", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "boards", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "provider", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "offerSource", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "areas", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "facilities", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minRating", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "price", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "vatIncluded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "freeCancellation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "transferIncluded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "visaAssistance", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "inStock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "category", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    { name: App.HotelHotFilterFields.AccommodationTypes },
                    { name: App.HotelHotFilterFields.RoomTypes },
                    { name: App.HotelHotFilterFields.Boards },
                    { name: App.HotelHotFilterFields.Provider },
                    { name: App.HotelHotFilterFields.OfferSource },
                    { name: App.HotelHotFilterFields.Areas },
                    { name: App.HotelHotFilterFields.MinRating },
                    { name: App.HotelHotFilterFields.AccommodationName },
                    { name: App.HotelHotFilterFields.Facilities },
                    { name: App.HotelHotFilterFields.Prices },
                    { name: App.HotelHotFilterFields.VatIncluded },
                    { name: App.HotelHotFilterFields.FreeCancellation },
                    { name: App.HotelHotFilterFields.TransferIncluded, defaultValue: 'false' },
                    { name: App.HotelHotFilterFields.VisaAssistance, defaultValue: 'false' },
                    { name: App.HotelHotFilterFields.InStock, defaultValue: 'false' },
                    { name: App.HotelHotFilterFields.Categories },
                ]
            });
        }
    }
    App.HotelHotFilterSet = HotelHotFilterSet;
})(App || (App = {}));
var App;
(function (App) {
    var _HotelHotPrice_min, _HotelHotPrice_max, _HotelHotPrice_from, _HotelHotPrice_to, _HotelHotPrice_currencyCode;
    class HotelHotPrice {
        constructor() {
            _HotelHotPrice_min.set(this, void 0);
            _HotelHotPrice_max.set(this, void 0);
            _HotelHotPrice_from.set(this, void 0);
            _HotelHotPrice_to.set(this, void 0);
            _HotelHotPrice_currencyCode.set(this, void 0);
        }
        // TODO: сначала сделала округление в контроле слайдер, но понадобилось округлять в самом фильтре. Пока
        // дублируется - округляется и там и там.Потом или убрать из контрола или оставить, если сильно надо.
        get currencyCode() {
            return __classPrivateFieldGet(this, _HotelHotPrice_currencyCode, "f");
        }
        set currencyCode(value) {
            __classPrivateFieldSet(this, _HotelHotPrice_currencyCode, value, "f");
        }
        get min() {
            return __classPrivateFieldGet(this, _HotelHotPrice_min, "f");
        }
        set min(value) {
            __classPrivateFieldSet(this, _HotelHotPrice_min, Math.floor(value), "f");
        }
        get max() {
            return __classPrivateFieldGet(this, _HotelHotPrice_max, "f");
        }
        set max(value) {
            __classPrivateFieldSet(this, _HotelHotPrice_max, Math.ceil(value), "f");
        }
        get from() {
            return __classPrivateFieldGet(this, _HotelHotPrice_from, "f");
        }
        set from(value) {
            __classPrivateFieldSet(this, _HotelHotPrice_from, Math.floor(value), "f");
        }
        get to() {
            return __classPrivateFieldGet(this, _HotelHotPrice_to, "f");
        }
        set to(value) {
            __classPrivateFieldSet(this, _HotelHotPrice_to, Math.ceil(value), "f");
        }
    }
    _HotelHotPrice_min = new WeakMap(), _HotelHotPrice_max = new WeakMap(), _HotelHotPrice_from = new WeakMap(), _HotelHotPrice_to = new WeakMap(), _HotelHotPrice_currencyCode = new WeakMap();
    App.HotelHotPrice = HotelHotPrice;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Урлы для страниц с отелями
     */
    let HotelPageUrls;
    (function (HotelPageUrls) {
        HotelPageUrls.Search = '/hotel/search/';
        HotelPageUrls.Info = '/hotel/info/';
        HotelPageUrls.FindPointName = '/hotel/findpointname/';
        HotelPageUrls.GetCancellationPolicy = '/hotel/getcancellationpolicy/';
        HotelPageUrls.Book = '/hotel/book/';
        HotelPageUrls.BookData = '/hotel/bookdata/';
        HotelPageUrls.Variants = '/hotel/variants/';
        HotelPageUrls.ReservedVariants = '/hotel/reservedvariants/';
        HotelPageUrls.Hotel = '/hotel/hotel/';
        HotelPageUrls.Valuate = '/hotel/valuate/';
        HotelPageUrls.Hotels = '/hotel/hotels/';
        HotelPageUrls.CompareVariants = '/hotel/comparevariants/';
        HotelPageUrls.Compare = '/hotel/compare/';
        HotelPageUrls.CompareEmail = '/hotel/compareemail/';
        HotelPageUrls.ContinueSearch = '/hotel/continuesearch/';
        HotelPageUrls.ContinueSearchVariants = '/hotel/continuesearchvariants/';
        HotelPageUrls.SearchBookingCom = '/hotel/searchbookingcom/';
        HotelPageUrls.ContinueSearchBookingCom = '/hotel/continuesearchbookingcom/';
        HotelPageUrls.SearchBookingComVariants = '/hotel/searchbookingcomvariants/';
        HotelPageUrls.ContinueSearchBookingComVariants = '/hotel/continuesearchbookingcomvariants/';
        HotelPageUrls.Announcement = '/hotel/announcement/';
        HotelPageUrls.ExistingTourists = '/hotel/existingtourists/';
        HotelPageUrls.SeoSearch = '/hotel/seosearch/';
        HotelPageUrls.SeoInfo = '/hotel/seoinfo/';
        HotelPageUrls.GetGeoLocations = '/hotel/getgeolocations/';
    })(HotelPageUrls = App.HotelPageUrls || (App.HotelPageUrls = {}));
})(App || (App = {}));
var App;
(function (App) {
    let HotelPointType;
    (function (HotelPointType) {
        HotelPointType.Accommodation = 'accommodation';
    })(HotelPointType = App.HotelPointType || (App.HotelPointType = {}));
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Названия параметров урла для отелей
     */
    class HotelUrlParameters {
        constructor() {
            Object.defineProperty(this, "emptyItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    HotelUrlParameters.context,
                ]
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    HotelUrlParameters.location,
                ]
            });
        }
    }
    Object.defineProperty(HotelUrlParameters, "location", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'location'
    });
    Object.defineProperty(HotelUrlParameters, "category", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'category'
    });
    Object.defineProperty(HotelUrlParameters, "types", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'types'
    });
    Object.defineProperty(HotelUrlParameters, "rooms", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'rooms'
    });
    Object.defineProperty(HotelUrlParameters, "checkin", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'checkin'
    });
    Object.defineProperty(HotelUrlParameters, "checkout", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'checkout'
    });
    Object.defineProperty(HotelUrlParameters, "context", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'context'
    });
    Object.defineProperty(HotelUrlParameters, "citizenship", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'citizenship'
    });
    Object.defineProperty(HotelUrlParameters, "hotels", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'hotels'
    });
    Object.defineProperty(HotelUrlParameters, "manualSearch", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'manual'
    });
    App.HotelUrlParameters = HotelUrlParameters;
})(App || (App = {}));
var App;
(function (App) {
    var _ImportBookPage_instances, _ImportBookPage_options, _ImportBookPage_popup, _ImportBookPage_form, _ImportBookPage_filter, _ImportBookPage_switcherUseOtherAgency, _ImportBookPage_importButton, _ImportBookPage_autocompleteBlock, _ImportBookPage_validator, _ImportBookPage_responseValidator, _ImportBookPage_reset, _ImportBookPage_getData, _ImportBookPage_onSwitcherAgencyClick, _ImportBookPage_onAutocompleteClearClick, _ImportBookPage_checkAgent, _ImportBookPage_onImportClick, _ImportBookPage_onAutocompleteOptionClick;
    class ImportBookPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-msc-book-import-page' }, options));
            _ImportBookPage_instances.add(this);
            _ImportBookPage_options.set(this, void 0);
            _ImportBookPage_popup.set(this, void 0);
            _ImportBookPage_form.set(this, void 0);
            _ImportBookPage_filter.set(this, void 0);
            _ImportBookPage_switcherUseOtherAgency.set(this, void 0);
            _ImportBookPage_importButton.set(this, void 0);
            Object.defineProperty(this, "errorPlace", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ImportBookPage_autocompleteBlock.set(this, void 0);
            _ImportBookPage_validator.set(this, void 0);
            _ImportBookPage_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _ImportBookPage_options, options, "f");
            __classPrivateFieldSet(this, _ImportBookPage_form, new App.Form({ root: this.root.find('form') }), "f");
            __classPrivateFieldSet(this, _ImportBookPage_filter, new App.Filter({ root: this.root.find('form') }), "f");
            __classPrivateFieldSet(this, _ImportBookPage_importButton, $('.js-import-submit', this.root), "f");
            __classPrivateFieldGet(this, _ImportBookPage_importButton, "f").on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ImportBookPage_instances, "m", _ImportBookPage_onImportClick).call(this); }));
            this.root.find('.js-clear-import-data').on('click', () => __classPrivateFieldGet(this, _ImportBookPage_instances, "m", _ImportBookPage_reset).call(this));
            this.errorPlace = $('.js-error-place', this.root);
            // импорт круиза для менеджеров PG
            __classPrivateFieldSet(this, _ImportBookPage_switcherUseOtherAgency, this.root.find('.js-sliding-otherAgency'), "f");
            __classPrivateFieldGet(this, _ImportBookPage_switcherUseOtherAgency, "f").on('click', e => __classPrivateFieldGet(this, _ImportBookPage_instances, "m", _ImportBookPage_onSwitcherAgencyClick).call(this, e));
            __classPrivateFieldSet(this, _ImportBookPage_validator, this.root.validate(), "f");
            const messages = new App.Messages({ root: this.getErrorPlace() });
            __classPrivateFieldSet(this, _ImportBookPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.BlockMessenger(messages),
                validator: __classPrivateFieldGet(this, _ImportBookPage_validator, "f"),
            }), "f");
            __classPrivateFieldSet(this, _ImportBookPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _ImportBookPage_autocompleteBlock, $('.js-form-autocomplete-block[data-name="AgencyName"]', this.root), "f");
            // обработчик на клик по выбранному агентству
            __classPrivateFieldGet(this, _ImportBookPage_autocompleteBlock, "f").on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ImportBookPage_instances, "m", _ImportBookPage_onAutocompleteOptionClick).call(this); }));
            // обработчик на 'очистить выбранное агентство'
            __classPrivateFieldGet(this, _ImportBookPage_autocompleteBlock, "f").on("autocompleteClearLocaton" /* Events.AutocompleteClearLocation */, () => __classPrivateFieldGet(this, _ImportBookPage_instances, "m", _ImportBookPage_onAutocompleteClearClick).call(this));
        }
        getErrorPlace() {
            return this.errorPlace;
        }
    }
    _ImportBookPage_options = new WeakMap(), _ImportBookPage_popup = new WeakMap(), _ImportBookPage_form = new WeakMap(), _ImportBookPage_filter = new WeakMap(), _ImportBookPage_switcherUseOtherAgency = new WeakMap(), _ImportBookPage_importButton = new WeakMap(), _ImportBookPage_autocompleteBlock = new WeakMap(), _ImportBookPage_validator = new WeakMap(), _ImportBookPage_responseValidator = new WeakMap(), _ImportBookPage_instances = new WeakSet(), _ImportBookPage_reset = function _ImportBookPage_reset() {
        this.root.find('input[text], textarea').each((index, element) => {
            $(element).val('');
        });
    }, _ImportBookPage_getData = function _ImportBookPage_getData() {
        const elements = this.root.find('input, textarea').serializeArray();
        const data = {};
        $.each(elements, (i, v) => {
            if (v.value == null || v.value === '')
                return true;
            data[v.name] = v.value;
            return true;
        });
        return data;
    }, _ImportBookPage_onSwitcherAgencyClick = function _ImportBookPage_onSwitcherAgencyClick(event) {
        const isOn = $(event.currentTarget).find('input').val() === 'true';
        if (isOn) {
            $('#AgencyName', this.root).removeAttr('disabled');
            $('#AgentNameBlock', this.root).removeClass('overlayed');
        }
        else {
            $('#AgencyName', this.root).attr('disabled', 'disabled');
            $('#AgencyName', this.root).closest('.form-item').removeClass('_invalid');
            $('#AgentNameBlock', this.root).addClass('overlayed');
            $('#AgentNameBlock', this.root).closest('.form-item').removeClass('_invalid');
        }
    }, _ImportBookPage_onAutocompleteClearClick = function _ImportBookPage_onAutocompleteClearClick() {
        const filterControl = __classPrivateFieldGet(this, _ImportBookPage_filter, "f").findControl('Agent');
        if (!filterControl)
            return;
        const filterSelectBlock = filterControl;
        if (filterSelectBlock) {
            const defaultOption = { value: '', text: '- Выберите пользователя -', selected: true };
            filterSelectBlock.replaceOptions([defaultOption]);
        }
    }, _ImportBookPage_checkAgent = function _ImportBookPage_checkAgent() {
        const needcheck = $('#useotheragency', this.root).val();
        if (needcheck === 'false')
            return true;
        $('#AgentNameBlock input', this.root).closest('.form-item').removeClass('_invalid');
        const agent = $('#AgentNameBlock input', this.root).val();
        if (agent !== '')
            return true;
        $('#AgentNameBlock input', this.root).closest('.form-item').addClass('_invalid');
        return false;
    }, _ImportBookPage_onImportClick = function _ImportBookPage_onImportClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _ImportBookPage_form, "f").validator.form())
                return;
            if (!__classPrivateFieldGet(this, _ImportBookPage_instances, "m", _ImportBookPage_checkAgent).call(this))
                return;
            const data = __classPrivateFieldGet(this, _ImportBookPage_instances, "m", _ImportBookPage_getData).call(this);
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _ImportBookPage_options, "f").urls.import,
                method: 'POST',
                data,
            });
            const popupGroup = __classPrivateFieldGet(this, _ImportBookPage_popup, "f").show({
                group: 'import',
                content: App.templates.Messages.Executing({}),
                modal: true,
                delay: 100,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _ImportBookPage_responseValidator, "f").process(response))
                    return;
                if (response.redirect)
                    window.location.href = response.redirect;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ImportBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _ImportBookPage_popup, "f").hide(popupGroup);
            }
        });
    }, _ImportBookPage_onAutocompleteOptionClick = function _ImportBookPage_onAutocompleteOptionClick() {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _ImportBookPage_options, "f").urls.getUsers,
                method: 'GET',
                data: { agencyId: $('#AgencyKey', this.root).val() },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _ImportBookPage_responseValidator, "f").process(response))
                    return;
                const filterControl = __classPrivateFieldGet(this, _ImportBookPage_filter, "f").findControl('Agent');
                if (!filterControl)
                    return;
                const filterSelectBlock = filterControl;
                if (filterSelectBlock)
                    filterSelectBlock.replaceOptions(response.data.items, false);
                filterSelectBlock.root.removeClass('overlayed');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ImportBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.ImportBookPage = ImportBookPage;
})(App || (App = {}));
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
var App;
(function (App) {
    var _FiltersMobileBase_instances, _FiltersMobileBase_options, _FiltersMobileBase_initFiltersControls, _FiltersMobileBase_addControl, _FiltersMobileBase_initControlDependencies, _FiltersMobileBase_initSearchFilterEvents, _FiltersMobileBase_onFilterSearch, _FiltersMobileBase_removeControl;
    /**
     * Базовый класс для мобильных фильтров.
     * Необходимо переопределить метод async onFilterChanged(filterName: string) для реагирования на изменения в фильтрах
     * или передать в options обработчик,
     * либо переопределить метод onFilterChanged на всей странице PageMobileBase.
     */
    class FiltersMobileBase {
        constructor(options = {}) {
            var _a;
            _FiltersMobileBase_instances.add(this);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onFilterChangedByOptionsEvent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onFilterChangedEvent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            /**
             * По сути то же, что и root этих фильтров.
             */
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "controls", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Array()
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _FiltersMobileBase_options.set(this, void 0);
            const root = (_a = options.root) !== null && _a !== void 0 ? _a : App.app.appContainer;
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            __classPrivateFieldSet(this, _FiltersMobileBase_options, options, "f");
            this.searchFilter = this.root;
            this.onFilterChangedEvent = v => this.onFilterChanged(v);
            this.onFilterChangedByOptionsEvent = options.onFilterChanged;
            // -- валидация --
            // реализация через имеющийся jquery плагин, который уже используется на сайте
            // что-бы наименьшие изменения вносить в мобильную версию логику страниц
            // NOTE: Не очень удобно, но мобильные контролы должны придерживаться этих правил:
            //   - все контролы лежат в form
            //   - каждый контрол обернут в свой js-mobile-validate
            //   - текст ошибки в блоке js-mobile-filter-error
            //   - должен быть аттрибут name у самого input со значением и валидаторами
            //   - если значение не в input, то самостоятельно класть в hidden input и вызывать validate
            if (!options.ignoreValidator) {
                this.validate();
            }
            // вешаем валидацию на форму
            const form = this.root.is('form') ? this.root : this.root.find('form');
            if (form)
                form.validate();
            // инициализация контролов (после необходимого)
            __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_initFiltersControls).call(this, this.root);
            // PwStore.AddFilterListener(this); // => onFilterChanged
            PwStore.AddListener(this); // => onCommit
            // events
            __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_initSearchFilterEvents).call(this);
        }
        /**
         * Уничтожение объекта.
         * Отвязка своих контролов от прослушки/посылки событий.
         */
        dispose() {
            this.removeControlLogicAll();
            PwStore.RemoveListener(this);
        }
        getPayloadModel(payload) {
            if (!payload)
                return undefined;
            return payload;
        }
        onCommit(eventName, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (eventName == 'filters/updated') {
                    // NOTE: не слушаем изменения кодом (предполагается, если кодом меняем значения, то и обработаем там же)
                    // no-op
                }
                else if (eventName == 'filters/changed') {
                    // произошли изменения пользователем
                    yield this.onFilterChangedEvent(payload); // => onFilterChanged
                    if (this.onFilterChangedByOptionsEvent)
                        yield this.onFilterChangedByOptionsEvent(payload);
                }
                else if (eventName == 'filters/changeFilter') {
                    // no-op
                }
            });
        }
        /**
         * Произошли изменения в фильтрах (выбрали что-то) пользователем (не кодом).
         * Выполняем автопоиск, либо обновляем зависимые фильтры (например, при смене страны обновляем список городов в фильтре)
         * Возможно еще слушать аналогичное событие на всей странице PageMobileBase от всех фильтров.
         * @param filterName
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                /*
                --- Примеры обработки ---
                if (filterName == PwStore.FILTER_ALL) {
                    console.log('Выполнили сброс всех фильтров');
    
                } else if (filterName == 'hotelFeatures') {
                    const v = PwStore.GetFilterItems<PwStore.IFilterSelectListValue>('hotelFeatures', false);
                    console.log('Выбрали особенности отеля: ' + v.map(item => item.label).join(', '));
    
                } else if (filterName == 'dateFrom') {
                    const v = PwStore.GetFilter<Date>('dateFrom');
                    console.log('Выбрали дату: ' + v.toString());
                }
                */
            });
        }
        /**
         * Инициализация логики валидации (не сам процесс валидации).
         * @returns
         */
        validate() {
            if (this.validator) { // NOTE: однократно?
                return this.validator;
            }
            this.validator = this.root.validate({
                ignore: '',
                errorElement: 'span',
                errorClass: '_invalid',
                validClass: '_valid',
                errorPlacement: function (error, element) {
                    const errEl = $(element).parents('.js-mobile-validate').find('.js-mobile-filter-error');
                    if (errEl)
                        error.appendTo(errEl);
                },
                highlight: function (element, errorClass, validClass) {
                    const parentEl = $(element).parents('.js-mobile-validate');
                    parentEl.addClass('text-input--error').addClass(errorClass).removeClass(validClass);
                    const errEl = parentEl.find('.js-mobile-filter-error');
                    errEl.show();
                },
                unhighlight: function (element, errorClass, validClass) {
                    const parentEl = $(element).parents('.js-mobile-validate');
                    parentEl.removeClass('text-input--error').removeClass(errorClass).addClass(validClass);
                    const errEl = parentEl.find('.js-mobile-filter-error');
                    errEl.hide();
                },
                rules: __classPrivateFieldGet(this, _FiltersMobileBase_options, "f").validatorRules,
            });
            // to each controls
            this.controls.forEach(c => c.setValidator(this.validator));
            // return
            return this.validator;
        }
        /**
         * Валидация контролов (ручная).
         * @returns
         */
        controlsCheck() {
            let isCorrect = true;
            this.controls.forEach(c => {
                if (!c.controlCheck())
                    isCorrect = false;
            });
            return isCorrect;
        }
        /**
         * Валидация контролов (ручная).
         * @returns
         */
        validateControls() {
            return this.controlsCheck();
        }
        /**
         * Сериализованные данные контролов.
         * @returns
         */
        serializeArray(separator = ',') {
            let params = [];
            this.controls.forEach(c => {
                const values = c.serializeArray(separator);
                params = params.concat(values);
            });
            return params;
        }
        /**
         * Сериализованные в параметры (p=1&p=2) данные для отправки.
         * @returns
         */
        serialize() {
            let str = '';
            $.each(this.controls, (i, v) => {
                const value = v.getControlValueString(); // .getValueString();
                if (value == null || value === '')
                    return true;
                if (str !== '')
                    str += '&';
                str += v.name;
                str += '=';
                str += value;
                return true;
            });
            return str;
        }
        /**
         * JSON.stringify данные для отправки.
         * @returns
         */
        stringify() {
            return JSON.stringify(this.prepareDataForSearch());
        }
        /**
         * Данные контролов для отправки.
         * @returns
         */
        prepareDataForSearch() {
            const data = {};
            $.each(this.controls, (i, v) => {
                const value = v.getValueString();
                if (value == null || value === '')
                    return true;
                data[v.name] = value;
                return true;
            });
            return data;
        }
        /**
         * Данные контролов для отправки.
         * Как правило, для заполнения URL.
         * @returns
         */
        getParamsForSearch(notEmptyValue = true) {
            const params = [];
            this.controls.forEach(c => {
                const key = c.name;
                const value = c.getValueStringArr();
                const isValueEmpty = (value.length == 1 && (value[0] == 'false' || value[0] == '0' || value[0] == ''));
                if (!notEmptyValue || !isValueEmpty) {
                    const existKey = params.findIndex(el => el.key === key);
                    if (existKey !== -1)
                        params[existKey].value = params[existKey].value.concat(value);
                    else
                        params.push({ key, value });
                }
            });
            return params;
        }
        /**
         * Добавление контролов-фильтров в логику.
         * Как правило, после добавления новых на страницу, например, в результатах поиска.
         * @param $block
         */
        addControls($block) {
            __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_initFiltersControls).call(this, $block);
        }
        /**
         * Удаление контролов-фильтров из разметки и из логики.
         * @param $block
         * @param $removeFromDom удалять из разметки (не только логику)
         */
        removeControls($block, removeFromDom = true, triggerChange = false) {
            if (!$block)
                return;
            const ctrlClass = App.MobileFilterBlockBase.uidClassName;
            const ctrlAttrUid = App.MobileFilterBlockBase.uidAttrName;
            // если один контрол
            if ($block.hasClass(ctrlClass)) {
                __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_removeControl).call(this, $block.attr(ctrlAttrUid) || 'fakeuid', triggerChange);
            }
            else {
                $block.find('.' + ctrlClass).each((i, v) => {
                    __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_removeControl).call(this, $(v).attr(ctrlAttrUid) || 'fakeuid', triggerChange);
                });
            }
            // удаляем из разметки
            if (removeFromDom)
                $block.remove();
        }
        removeControlLogic(control, triggerChange = false) {
            if (!control)
                return;
            __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_removeControl).call(this, control.uid, triggerChange);
        }
        removeControlLogicByName(filterName, triggerChange = false) {
            const ctrl = this.getControl(filterName);
            this.removeControlLogic(ctrl, triggerChange);
        }
        removeControlLogicAll(triggerChange = false) {
            this.controls.forEach(ctrl => {
                __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_removeControl).call(this, ctrl.uid, triggerChange, false);
            });
            this.controls = [];
        }
        /**
         * Контрол по имени.
         * @param filterName
         */
        getControl(filterName) {
            return this.controls.find(f => f.name == filterName);
        }
        /**
         * Контрол по имени.
         * @param filterName
         */
        findControl(filterName) {
            const result = this.controls.find(f => f.name == filterName);
            if (!result)
                return result;
            return result;
        }
        /**
         * Список контролов по имени.
         * NOTE: Не гарантирует, что все элементы в ответе будут указанного типа данных (не фильтрует по типу).
         * @returns
         */
        filterControls(filterNameStarts, filterNameEnds, filterNameNotStarts, filterNameNotEnds) {
            const result = this.controls.filter(f => (filterNameStarts ? f.name.startsWith(filterNameStarts) : true) &&
                (filterNameEnds ? f.name.endsWith(filterNameEnds) : true) &&
                (filterNameNotStarts ? !f.name.startsWith(filterNameNotStarts) : true) &&
                (filterNameNotEnds ? !f.name.endsWith(filterNameNotEnds) : true));
            if (!result)
                return [];
            const arr = [];
            result.forEach(r => {
                // NOTE: это не фильтрация по типу (к сожалению)
                if (r)
                    arr.push(r);
            });
            return arr;
        }
        /**
         * Получение текущего значения от контрола.
         * NOTE: Если котрол содержит перечисления, то будет получен весь список (и не выбранные),
         * в таком случае следует применять или getControlItemValues.
         * @param filterName
         * @returns
         */
        getControlValue(filterName) {
            return PwStore.GetFilter(filterName);
        }
        /**
         * Получение текущего значения от контрола переключателя.
         * @param filterName
         * @returns
         */
        getControlToggle(filterName) {
            return PwStore.GetFilter(filterName);
        }
        /**
         * Получение текущего выбранного одного элемента из массива значений от контрола.
         * NOTE: если необходимо значение единственного переключателя (который может быть false),
         * то использовать либо getControlValue, либо getControlToggle.
         * @param filterName
         * @returns
         */
        getControlItemValue(filterName) {
            return PwStore.GetFilterItem(filterName, false);
        }
        /**
         * Отдает список выбранных фильтров.
         * NOTE: если контрол содержит одно значение (не список),
         * то использовать getControlValue.
         * @param filterName
         * @returns
         */
        getControlItemValues(filterName) {
            return PwStore.GetFilterItems(filterName, false);
        }
        /**
         * Получение строки текущего значения от контрола.
         * @param filterName
         * @returns
         */
        getControlValueString(filterName, separator = ',') {
            const ctrl = this.getControl(filterName);
            if (!ctrl)
                return '';
            return ctrl.getControlValueString(separator);
            /*
            const value = ctrl.getValueString();
            if (!value)
                return '';
            if (typeof (value) === 'string')
                return value;
            if (Array.isArray(value))
                return value.join(',');
            return value as string;
            */
        }
        /**
         * Получение текущего значения контрола в массиве.
         * @param filterName
         * @returns
         */
        getControlValueStringArr(filterName) {
            const ctrl = this.getControl(filterName);
            if (!ctrl)
                return [];
            return ctrl.getValueStringArr();
        }
        /**
         * Отдает первый (должен быть и единственный) выбранный фильтр из списка.
         * @param filterName
         * @returns
         */
        getControlListItem(filterName) {
            return PwStore.GetFilterItem(filterName, false);
        }
        /**
         * Получение массива текущих выбранных значений от контрола автокомлита.
         * @param filterName
         * @returns
         */
        getControlAutocompleteValues(filterName) {
            return this.getControlItemValues(filterName);
        }
        /**
         * Получение массива текущих выбранных значений от контрола автокомлита.
         * Получение объекта из свойства 'original' элементов.
         * @param filterName
         * @returns
         */
        getControlAutocompleteOriginalValues(filterName) {
            const itms = this.getControlAutocompleteValues(filterName);
            if (!itms || itms.length <= 0)
                return [];
            return itms.map(s => s.original);
        }
        /**
         * Установка нового значения контролу.
         * Как правило, когда пришли новые данные и необходимо изменить начальное значение контролу.
         * @param filterName
         * @param value
         */
        setControlValue(filterName, value, triggerChange = true) {
            PwStore.ChangeFilter(filterName, value, triggerChange);
        }
        /**
         * Установка значений из списка на основе ListOption[].
         * @param key
         * @param arrOpts
         * @param triggerChange
         */
        setControlValueByListOptions(key, arrOpts, triggerChange = true) {
            const ctrl = this.findControl(key);
            if (ctrl) {
                ctrl.setValueByListOptions(arrOpts, triggerChange);
            }
        }
        reset() {
            this.controls.forEach(c => c.reset());
        }
        clear() {
            this.controls.forEach(c => c.clear());
        }
    }
    _FiltersMobileBase_options = new WeakMap(), _FiltersMobileBase_instances = new WeakSet(), _FiltersMobileBase_initFiltersControls = function _FiltersMobileBase_initFiltersControls($block) {
        if (!$block || $block.length <= 0)
            return;
        const opts = { validator: this.validator, triggerModalKey: __classPrivateFieldGet(this, _FiltersMobileBase_options, "f").triggerModalKey };
        // блоки inputs
        const fbInputs = $block.find('.js-mobile-filter-input-block'); // .not('[flag-inited="1"]');
        // fbInputs.each((i, v) => { this.#addControl(new MobileFilterInputBlock({ root: $(v), validator: this.validator })); });
        fbInputs.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterInputBlock(Object.assign({ root: $(v) }, opts))); });
        // блоки даты (с календарем)
        const fbDates = $block.find('.js-mobile-filter-date-block');
        fbDates.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterDateBlock(Object.assign({ root: $(v) }, opts))); });
        // блоки времени (не диапазон, а выбиралка из списка)
        const fbTimes = $block.find('.js-mobile-filter-time-block');
        fbTimes.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterTimeBlock(Object.assign({ root: $(v) }, opts))); });
        // блоки selectlist
        const fbSelects = $block.find('.js-mobile-filter-selectlist-block');
        fbSelects.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterSelectListBlock(Object.assign({ root: $(v) }, opts))); });
        // блоки autocomplete (гайдовые сущности - страны, города)
        const fbAutosGuides = $block.find('.js-mobile-filter-autocomplete-guide-block');
        fbAutosGuides.each((i, v) => {
            __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterAutocompleteGuideBlock(Object.assign({ root: $(v) }, opts)));
        });
        // блоки autocomplete
        const fbAutos = $block.find('.js-mobile-filter-autocomplete-block');
        fbAutos.each((i, v) => {
            __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterAutocompleteBlock(Object.assign({ root: $(v) }, opts)));
        });
        // блоки toggle
        const fbToggles = $block.find('.js-mobile-filter-toggle-block');
        fbToggles.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterToggleBlock(Object.assign({ root: $(v) }, opts))); });
        // блоки gender
        const fbGenders = $block.find('.js-mobile-filter-gender-block');
        fbGenders.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterGenderBlock(Object.assign({ root: $(v) }, opts))); });
        // блоки туристы
        const fbTourists = $block.find('.js-mobile-filter-tourists-block');
        fbTourists.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterTouristsBlock(Object.assign({ root: $(v) }, opts))); });
        // диапазон значений
        const fbRanges = $block.find('.js-mobile-filter-range-block');
        fbRanges.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterRangeBlock(Object.assign({ root: $(v) }, opts))); });
        // диапазон времени
        const fbTimeRanges = $block.find('.js-mobile-filter-time-range-block');
        fbTimeRanges.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterTimeRangeBlock(Object.assign({ root: $(v) }, opts))); });
        const fbStarRanges = $block.find('.js-mobile-filter-star-rating-range-block');
        fbStarRanges.each((i, v) => { __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_addControl).call(this, new App.MobileFilterStarRatingRangeBlock(Object.assign({ root: $(v) }, opts))); });
        // .. другие блоки управления
        // зависимости кнопок
        __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_initControlDependencies).call(this);
    }, _FiltersMobileBase_addControl = function _FiltersMobileBase_addControl(control) {
        if (!control || !control.created)
            return;
        control.initialize();
        this.controls.push(control);
    }, _FiltersMobileBase_initControlDependencies = function _FiltersMobileBase_initControlDependencies() {
        // TODO: изменить логику на мобильную (по аналогии как в Filter.ts)
        // Зависимость кнопки от чекбоксов [data-depends="name1,name1,..."]
        $('[data-depends]', this.root).each((i, v) => {
            const jqElement = $(v);
            const selector = ($(v).attr('data-depends') || '').split(',')
                .map(x => `[name="${x}"]`)
                .join(', ');
            const depends = this.root.find(selector);
            // TODO: эта часть должна перехать в сами кнопки в логику их?
            depends.on('change', () => {
                if (depends.filter(':checked').length !== depends.length)
                    jqElement.attr('disabled', 'disabled');
                else
                    jqElement.removeAttr('disabled');
            }).trigger('change');
        });
    }, _FiltersMobileBase_initSearchFilterEvents = function _FiltersMobileBase_initSearchFilterEvents() {
        this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _FiltersMobileBase_instances, "m", _FiltersMobileBase_onFilterSearch).call(this, e));
    }, _FiltersMobileBase_onFilterSearch = function _FiltersMobileBase_onFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    }, _FiltersMobileBase_removeControl = function _FiltersMobileBase_removeControl(uid, triggerChange = false, removeFromList = true) {
        const filter = this.controls.find(f => f.uid == uid);
        if (!filter)
            return;
        // удаляем из Подписки событий
        PwStore.RemoveFilterListener(filter);
        // удаление из Стора
        // NOTE: тут возможен ли случай, когда фильтр не уникальный и не надо удалять из Стора запись?
        PwStore.RemoveFilter(filter.name, triggerChange);
        // удаляем из своего списка
        if (removeFromList)
            this.controls = this.controls.filter(f => f.uid !== uid);
    };
    App.FiltersMobileBase = FiltersMobileBase;
})(App || (App = {}));
var App;
(function (App) {
    var _MobileFilterBlockBase_instances, _MobileFilterBlockBase_clearDefaultValue, _MobileFilterBlockBase_inputValidateRef, _MobileFilterBlockBase_removeUndefinedProps;
    class MobileFilterBlockBase {
        constructor(isArray, clearDefaultValue, defaultOptions, extendedOptions) {
            _MobileFilterBlockBase_instances.add(this);
            Object.defineProperty(this, "created", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "options", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isArray", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "uid", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _MobileFilterBlockBase_clearDefaultValue.set(this, void 0);
            Object.defineProperty(this, "name", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "disabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "errorRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _MobileFilterBlockBase_inputValidateRef.set(this, void 0); // элемент в разметке для валидации (ручной)
            this.options = Object.assign(Object.assign({}, defaultOptions), extendedOptions);
            this.isArray = isArray;
            __classPrivateFieldSet(this, _MobileFilterBlockBase_clearDefaultValue, clearDefaultValue, "f");
            const { root } = this.options;
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            if (!this.root.length)
                return;
            // флаг, чтобы видеть по разметке, что уже инициализирован (и не трогать внешкой)
            if (this.root.attr('flag-inited') == '1') {
                // NOTE: сбрасываем объект root, чтобы наследующий класс прекратил свою логику инициализации
                this.root = jQuery();
                return;
            }
            this.root.attr('flag-inited', '1');
            this.created = true;
            this.name = this.root.attr('data-name') || 'noname';
            this.disabled = (this.root.attr('data-disabled') == 'True') || false;
            // uid (уникальный ID на странице - для удаления контрола со страницы (т.к. имя фильтра может быть не уникальным))
            this.uid = MobileFilterBlockBase.GuidGenerator();
            this.root.attr(MobileFilterBlockBase.uidAttrName, this.uid);
            this.root.addClass(MobileFilterBlockBase.uidClassName);
            // meta (для Vue)
            this.options.filterKey = this.name;
            // render ref
            this.errorRef = $('.js-mobile-filter-error', this.root);
            this.validator = this.options.validator;
            // мы не реактивные - подписываемся на события (обновление разметки по событию от Vue)
            PwStore.AddFilterListener(this); // => onFilterChanged
            // данные из разметки имеют приоритет над опциями по-умолчанию
            const metaFromPage = this.root.find('.js-mobile-filter-meta');
            if (metaFromPage) {
                const dataVal = metaFromPage.val();
                if (dataVal && typeof (dataVal) != 'undefined' && dataVal != '') {
                    let pageMeta = JSON.parse(dataVal);
                    // удаляем все Null свойства (если не переопределили, то не затираем дефолтные)
                    pageMeta = __classPrivateFieldGet(this, _MobileFilterBlockBase_instances, "m", _MobileFilterBlockBase_removeUndefinedProps).call(this, pageMeta);
                    this.options = Object.assign(Object.assign({}, this.options), pageMeta);
                }
                // чистим dom, больше не требуется это в разметке (все лежит в options и в PwStore.state)
                metaFromPage.remove();
            }
            // данные из extendedOptions еще более высокий приоритет (снова их накатываем, после данных из разметки)
            this.options = Object.assign(Object.assign({}, this.options), extendedOptions);
        }
        initialize() {
            // default value
            const defaultValue = this.initDefaultValue();
            // инициализация данных фильтра (если передали)
            if (defaultValue != undefined) {
                const typedValue = this.parseDefaultValue(defaultValue);
                // добавляем фильтр, только если есть данные
                // чтобы изначально (при загрузке страницы) не отработала проверка валидации на пустом контроле
                if (typedValue) {
                    let triggerChange = true;
                    if (this.options.notTriggerEventOnInit == true)
                        triggerChange = false;
                    PwStore.AddFilter(this.options.filterKey, typedValue, triggerChange);
                }
                // тут изначальные данные больше не требуются (они итак есть в PwStore.state.filtersConst)
                if (__classPrivateFieldGet(this, _MobileFilterBlockBase_clearDefaultValue, "f"))
                    this.options.defaultValue = undefined;
            }
        }
        /**
         * Параметр по-умолчанию.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @returns
         */
        initDefaultValue() {
            return this.options.defaultValue;
        }
        /**
         * Установка новых настроек.
         * @param value
         */
        setOptions(value) {
            this.options = Object.assign(Object.assign({}, this.options), value);
        }
        setValidator(validator) {
            this.validator = validator;
        }
        setInputValidateRef(inputRef) {
            __classPrivateFieldSet(this, _MobileFilterBlockBase_inputValidateRef, inputRef, "f");
        }
        setRequired(isRequired) {
            this.root.prop('required', isRequired);
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем при необходимости.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            return jsonValue;
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                if (filterName == this.options.filterKey || filterName == PwStore.FILTER_ALL) { // если изменился наш фильтр (или все)
                    // this.resetError(); // TODO: точно всегда нужно обнулять ошибку у контрола?
                    this.onChanged();
                    // оповестить нашего слушателя (страницу - будет делать новый поиск, например)
                    // TODO: или через событие Events.FilterChange? this.root.trigger(Events.FilterChange, [{ instance: this }]); ??
                    if (this.options.onChanged)
                        this.options.onChanged();
                }
            });
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
        }
        /**
         * Установка новых фильтров.
         * @param data
         * @param isNew
         */
        setFilters(data, isNew = true, triggerChange = true) {
            if (isNew)
                PwStore.AddFilter(this.options.filterKey, data);
            else
                PwStore.ChangeFilter(this.options.filterKey, data, triggerChange);
        }
        /**
         * Установка новых фильтров.
         * @param data
         * @param isNew
         */
        setFiltersByJson(dataVal, isNew = true, triggerChange = true) {
            if (dataVal && typeof (dataVal) != 'undefined' && dataVal != '') {
                const value = JSON.parse(dataVal);
                const typedValue = this.parseDefaultValue(value);
                this.setFilters(typedValue, isNew, triggerChange);
            }
        }
        /**
         * Установка нового значения.
         */
        setValue(data, triggerChange = true) {
            this.setFilters(data, false, triggerChange);
        }
        /**
         * Установка значений из списка на основе ListOption[].
         * @param arrOpts
         * @param triggerChange
         */
        setValueByListOptions(arrOpts, triggerChange = true) {
            this.setFilters(this.convertFromListOptions(arrOpts), triggerChange);
        }
        /**
         * Отдаем свое текущее значение в нужном формате для поиска.
         * Переопределяется контролом.
         * @returns
         */
        getValueString() {
            return this.getValueOrigin();
        }
        /**
         * Получение строки текущего значения от контрола.
         */
        getControlValueString(separator = ',') {
            const value = this.getValueString();
            if (!value)
                return '';
            if (typeof (value) === 'string')
                return value;
            if (Array.isArray(value))
                return value.join(separator);
            return value;
        }
        getValueStringArr() {
            const value = this.getValueString();
            return typeof (value) === 'string' ? [value] : value;
        }
        /**
         * Отдает числовое значение текущего значения.
         * Если это список, то отдает значение первого элемента из текущих значений.
         * @param defaultValue
         * @returns
         */
        getControlValueNumber(defaultValue = 0) {
            let value = this.getValueString();
            if (!value)
                return defaultValue;
            if (Array.isArray(value)) {
                value = value[0];
            }
            const num = parseInt(value, 10);
            if (isNaN(num))
                return defaultValue;
            return num;
        }
        getValueOrigin() {
            if (this.isArray)
                return PwStore.GetFilterItems(this.options.filterKey, false);
            return PwStore.GetFilter(this.options.filterKey);
        }
        /**
         * Сброс значения элемента управления в default-состояние.
        */
        reset() {
            PwStore.ResetFilterByName(this.options.filterKey);
            // this.resetError();
        }
        /**
         * Полная очистка состояния элемента управления.
        */
        clear() {
            this.reset();
            // NOTE: кому (контролу) требуется иное поведение, то override
        }
        getDefaultValue() {
            // return PwStore.GetFilterDefault<TValue>(this.options.filterKey) || ''; // this.options.defaultValue || ''
            return PwStore.GetFilterDefault(this.options.filterKey);
        }
        /**
         * Сериализованные данные контрола (как правило, для параметров поиска).
         * Котрол может отдавать множество ключ-значение.
         * @returns
         */
        serializeArray(separator = ',') {
            const params = [];
            const v = this.getValueString();
            if (v != null && v !== '') {
                params.push({
                    name: this.name,
                    value: (!v || !Array.isArray(v) ? v : v.join(separator)),
                });
            }
            return params;
        }
        /**
         * Список опций в формате для контрола на основе данных из ListOption[].
         * NOTE: новые данные не применяются в этот момент.
         * @param arrFrom
         * @returns
         */
        convertFromListOptions(arrFrom) {
            if (!arrFrom)
                return this.isArray ? new Array() : this.getDefaultValue();
            const list = new Array();
            arrFrom.forEach(a => {
                list.push({ name: a.text, label: a.text, value: a.value, checked: a.selected || false, select_all: a.value === '' });
            });
            return list;
        }
        /**
         * Список опций в формате для контрола на основе данных из ListOption[].
         * NOTE: новые данные не применяются.
         * NOTE: метод статичный, применять на контролах-списках.
         * @param arrFrom
         * @returns
         */
        static convertArrayFromListOptions(arrFrom) {
            const list = new Array();
            if (!arrFrom)
                return list;
            arrFrom.forEach(a => {
                list.push({ name: a.text, label: a.text, value: a.value, checked: a.selected || false, select_all: a.value === '' });
            });
            return list;
        }
        /*
        setError(errorMsg: string): void {
            this.error = errorMsg;
            this.updateErrorView();
        }


        resetError(): void {
            this.setError('');
        }

        updateErrorView(): void {
            if (!this.errorRef)
                return;
            this.errorRef.html(this.error);
            if (this.error) {
                this.root.addClass('text-input--error');
                this.errorRef.show();
            } else {
                this.root.removeClass('text-input--error');
                this.errorRef.hide();
            }
        }
        */
        getInputRef() {
            return __classPrivateFieldGet(this, _MobileFilterBlockBase_inputValidateRef, "f");
        }
        // валидация контрола
        validate(el) {
            // валидация через плагин
            if (el && this.validator) {
                return this.validator.element(el);
            }
            return true;
        }
        controlCheck() {
            return this.validate(__classPrivateFieldGet(this, _MobileFilterBlockBase_inputValidateRef, "f"));
        }
        /**
         * Включение/выключение контрола.
         * @param isEnabled
         */
        setEnabled(isEnabled) {
            this.disabled = !isEnabled;
            this.root.attr('data-disabled', this.disabled ? 'True' : 'False');
            this.refreshEnabledView(!this.disabled);
        }
        /**
         * Обновление вида после включения/выключения.
         * NOTE: кому необходимо, должны вызвать в конце своей инициализации
         * после того, как известны все элементы для изменения.
         * @param isEnabled
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        refreshEnabledView(isEnabled) {
            // NOTE: кому необходимо переопределяют
        }
        /**
         * Имеет ли контрол класс (на корневом элементе).
         * @param className
         */
        hasClass(className) {
            if (!this.root)
                return false;
            return this.root.hasClass(className);
        }
        // TODO: to library
        static GuidGenerator() {
            const S4 = () => {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
        }
    }
    _MobileFilterBlockBase_clearDefaultValue = new WeakMap(), _MobileFilterBlockBase_inputValidateRef = new WeakMap(), _MobileFilterBlockBase_instances = new WeakSet(), _MobileFilterBlockBase_removeUndefinedProps = function _MobileFilterBlockBase_removeUndefinedProps(obj) {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) && (obj[key] === undefined || obj[key] == null)) {
                delete obj[key];
            }
        }
        return obj;
    };
    Object.defineProperty(MobileFilterBlockBase, "uidAttrName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'data-m-filter-uid'
    });
    Object.defineProperty(MobileFilterBlockBase, "uidClassName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'js-mobile-filter-ref'
    });
    App.MobileFilterBlockBase = MobileFilterBlockBase;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterAutocompleteBlock_instances, _MobileFilterAutocompleteBlock_loader, _MobileFilterAutocompleteBlock_findUrl, _MobileFilterAutocompleteBlock_addParams, _MobileFilterAutocompleteBlock_addAttributes, _MobileFilterAutocompleteBlock_initAutocompleteLogic, _MobileFilterAutocompleteBlock_mapDataToItemsDefault, _MobileFilterAutocompleteBlock_getSearchData, _MobileFilterAutocompleteBlock_refreshView, _MobileFilterAutocompleteBlock_getValueProp, _MobileFilterAutocompleteBlock_updateView, _MobileFilterAutocompleteBlock_getItemString;
    let IMobileFilterAutocompleteValueProps;
    (function (IMobileFilterAutocompleteValueProps) {
        IMobileFilterAutocompleteValueProps[IMobileFilterAutocompleteValueProps["Label"] = 0] = "Label";
        IMobileFilterAutocompleteValueProps[IMobileFilterAutocompleteValueProps["Value"] = 1] = "Value";
        IMobileFilterAutocompleteValueProps[IMobileFilterAutocompleteValueProps["Name"] = 2] = "Name";
        // NOTE: при добавлении тут, добавить и ниже в #getValueProp
    })(IMobileFilterAutocompleteValueProps = App.IMobileFilterAutocompleteValueProps || (App.IMobileFilterAutocompleteValueProps = {}));
    class MobileFilterAutocompleteBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(true, true, MobileFilterAutocompleteBlock.s_defaults, options);
            _MobileFilterAutocompleteBlock_instances.add(this);
            Object.defineProperty(this, "valueRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            }); // копия значения в инпут (для валидатора)
            // readonly searchInputRef: JQuery<HTMLInputElement>; // pointInput
            _MobileFilterAutocompleteBlock_loader.set(this, void 0);
            _MobileFilterAutocompleteBlock_findUrl.set(this, void 0);
            // Для передачи доп.параметров, передаются все значения, найденные по переданным id:
            // [data-addParams="Pickup_Key,Pickup_Type"] => input#Pickup_Key, input#Pickup_Type
            _MobileFilterAutocompleteBlock_addParams.set(this, void 0);
            // Для передачи доп.параметров, передаются все значения атрибутов:
            // [data-addAttributes="data-findtourist-type,data-findtourist-type1"] =>
            // attr('data-findtourist-type'), attr('data-findtourist-type1')
            _MobileFilterAutocompleteBlock_addAttributes.set(this, void 0);
            Object.defineProperty(this, "autocompleteRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filterResults", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            }); // скрытый блок для результатов от плагина (иначе сыпит в body)
            if (!this.root.length)
                return;
            // render ref
            this.valueRef = $('.js-mobile-filter-value', this.root);
            this.valueInputRef = $('.js-mobile-filter-value-input', this.root);
            this.setInputValidateRef(this.valueInputRef);
            // указатель на инпут поиска (из Vue компонента)
            // this.searchInputRef = $('.js-vue-autocomplete-search-input', this.root);
            this.filterResults = $('.js-point-results', this.root);
            // TODO: добавить в разметку в \Views\Shared\Mobile\Inputs\AutocompleteSelect.cshtml
            __classPrivateFieldSet(this, _MobileFilterAutocompleteBlock_loader, $('.js-loader', this.root), "f");
            const url = this.root.attr('data-url');
            __classPrivateFieldSet(this, _MobileFilterAutocompleteBlock_findUrl, url || 'url_not_setted', "f");
            __classPrivateFieldSet(this, _MobileFilterAutocompleteBlock_addParams, this.root.attr('data-addparams'), "f");
            __classPrivateFieldSet(this, _MobileFilterAutocompleteBlock_addAttributes, this.root.attr('data-addAttributes'), "f");
            // show modal
            this.root.on('click', () => {
                if (this.disabled)
                    return;
                PwStore.OpenModal('select-autocomplete-list-filter', Object.assign(Object.assign({}, this.options), { filterItems: this.options.filterKey }));
            });
            __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_initAutocompleteLogic).call(this);
            // слушаем все события - интересует кастомный от SelectAutocompleteListFilter.vue
            PwStore.AddListener(this); // => onCommit
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_updateView).call(this);
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            return jsonValue;
        }
        /**
         * Установка кастомной функции преобразования данных в список.
         * @param mapDataToItems
         */
        setMapDataToItems(mapDataToItems) {
            this.options.mapDataToItems = mapDataToItems;
        }
        onCommit(eventName, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!payload)
                    return;
                const payloadData = payload;
                if (!payloadData || !payloadData.name || payloadData.name != this.name)
                    return;
                if (eventName == 'custom/Autocomplete/changeSearch') {
                    this.valueInputRef.val(payloadData.value);
                    this.autocompleteRef.autocomplete('search', payloadData.value);
                    if (!payloadData.value) {
                        // this.reset();
                        this.setFilters([], false);
                    }
                    this.root.trigger("autocompleteOption:click" /* Events.AutocompleteOptionClick */);
                }
            });
        }
        /**
         * Установка новых фильтров.
         * @param data
         * @param isNew
         */
        setFilters(data, isNew = true, triggerChange = true) {
            if (isNew) {
                PwStore.AddFilter(this.options.filterKey, data);
            }
            else {
                let arr = data || [];
                // если возможен множественный выбор
                if (this.options.isMulti) {
                    // берем уже выбранные элементы
                    const checkedItems = PwStore.GetFilterItems(this.name, false);
                    if (checkedItems) {
                        checkedItems.forEach(checkedItem => {
                            // если такой элемент есть в новых данных, то удаляем его
                            const existsIndex = arr.findIndex(f => f.value == checkedItem.value);
                            if (existsIndex >= 0) {
                                arr.splice(existsIndex, 1);
                            }
                        });
                        // сначала идут выбранные
                        checkedItems.push(...arr);
                        arr = checkedItems;
                    }
                }
                // append
                PwStore.ChangeFilter(this.options.filterKey, arr, triggerChange);
            }
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_updateView).call(this);
        }
        /**
         * Сериализованные данные контрола (как правило, для параметров поиска).
         * Котрол может отдавать множество ключ-значение.
         * @returns
         */
        serializeArray() {
            const params = [];
            const v = this.getValue();
            if (v != null && v.length > 0) {
                // value
                params.push({
                    name: this.valueInputRef.attr('name'),
                    value: this.valueInputRef.val(),
                });
            }
            return params;
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            const value = this.getValue();
            if (!value)
                return [];
            return value.map(v => __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_getItemString).call(this, v));
        }
        getValuesString(separator = ',') {
            const value = this.getValue();
            if (!value)
                return '';
            return value.map(v => __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_getItemString).call(this, v)).join(separator);
        }
        getValue() {
            return this.getValueOrigin();
        }
        setValue(value, triggerChange = true) {
            // this.resetError();
            PwStore.ChangeFilter(this.options.filterKey || '', value, triggerChange);
        }
        getAutocompleteValues() {
            return this.getValueOrigin();
        }
        getAutocompleteOriginalValues() {
            const itms = this.getAutocompleteValues();
            if (!itms || itms.length <= 0)
                return [];
            return itms.map(s => s.original);
        }
        setRequired(isRequired) {
            this.valueInputRef.prop('required', isRequired);
        }
    }
    _MobileFilterAutocompleteBlock_loader = new WeakMap(), _MobileFilterAutocompleteBlock_findUrl = new WeakMap(), _MobileFilterAutocompleteBlock_addParams = new WeakMap(), _MobileFilterAutocompleteBlock_addAttributes = new WeakMap(), _MobileFilterAutocompleteBlock_instances = new WeakSet(), _MobileFilterAutocompleteBlock_initAutocompleteLogic = function _MobileFilterAutocompleteBlock_initAutocompleteLogic() {
        this.autocompleteRef = this.valueInputRef.autocomplete({
            appendTo: this.filterResults,
            minLength: this.options.minLength,
            source: (request, response) => {
                /* eslint-disable @typescript-eslint/no-floating-promises */
                $.ajax({
                    url: __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_findUrl, "f"),
                    method: 'GET',
                    data: __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_getSearchData).call(this, request.term),
                    beforeSend: () => {
                        if (__classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_loader, "f").length > 0)
                            __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_loader, "f").show();
                    },
                    success: (data) => {
                        let items = [];
                        if (this.options.mapDataToItems)
                            items = this.options.mapDataToItems(data);
                        else
                            items = __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_mapDataToItemsDefault).call(this, data);
                        response(items);
                    },
                });
                /* eslint-enable @typescript-eslint/no-floating-promises */
            },
            response: (_, ui) => {
                if (ui.content.length === 0) {
                    this.setFilters([], false);
                    $('.js-noSearchData', this.root).fadeIn('slow').delay(5000).fadeOut('slow');
                }
                if (__classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_loader, "f").length > 0)
                    __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_loader, "f").hide();
                // this.pointAutocomplete.show();
                // данные пробрасываем во Vue компонент
                this.setFilters(ui.content, false);
            },
            select: () => {
                // убираем запятые, чтобы можно было продолжить поиск
                // const value = ui.item.value.replace(/,/g, ' ').replace(/ {2,}/g, ' ');
                // this.#pointInput.val(value);
                // this.#pointInput.attr('value', value);
                // this.#pointCode.val(ui.item.key);
                // this.#pointType.val(ui.item.typeCode);
                // this.#toggleInputIcons(false);
                // this.root.trigger(Events.AutocompleteOptionClick);
                // this.#pointInput.trigger('blur');
                return false;
            },
        });
    }, _MobileFilterAutocompleteBlock_mapDataToItemsDefault = function _MobileFilterAutocompleteBlock_mapDataToItemsDefault(data) {
        var _a;
        if (!data)
            return [];
        // Ответ API: { data: { items: [ { key, name, typeCode, typeName } ] } }
        const wrapped = data;
        const raw = (_a = wrapped === null || wrapped === void 0 ? void 0 : wrapped.data) === null || _a === void 0 ? void 0 : _a.items;
        if (!Array.isArray(raw))
            return [];
        return raw.map(item => ({
            original: Object.assign({}, item),
            value: item.key,
            label: item.name,
            name: item.name,
            isGroup: false,
            checked: false,
        }));
    }, _MobileFilterAutocompleteBlock_getSearchData = function _MobileFilterAutocompleteBlock_getSearchData(searchString) {
        const data = {};
        data.search = searchString;
        if (__classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_addParams, "f")) {
            __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_addParams, "f").split(',').forEach(id => {
                const value = $(`#${id}`).valString();
                if (value) {
                    // TODO: изменить, пока так, чтобы отправить на сертификацию
                    const position = id.search('-');
                    const name = position >= 0 ? id.slice(position + 1) : id;
                    // TODO: изменить, пока так, чтобы отправить на сертификацию
                    data[name.toLowerCase().replace('_', '')] = value;
                }
            });
        }
        if (__classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_addAttributes, "f")) {
            __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_addAttributes, "f").split(',').forEach(attr => {
                const value = this.root.attr(`${attr}`);
                if (value) {
                    const position = attr.lastIndexOf('-'); // data-findtourist-type
                    const name = position >= 0 ? attr.slice(position + 1) : attr;
                    data[name.toLowerCase()] = value;
                }
            });
        }
        return data;
    }, _MobileFilterAutocompleteBlock_refreshView = function _MobileFilterAutocompleteBlock_refreshView(value) {
        if (!value) {
            this.valueRef.html(this.options.emptyText);
            // для валидатора
            this.valueInputRef.val(''); // именно пустота кладется для валидатора
            this.validate(this.valueInputRef);
            return;
        }
        // рендер
        const html = value.map(item => item.label).join(', ');
        this.valueRef.html(html || this.options.emptyText);
        // для валидатора и для данных поиска
        const vals = value.map(item => __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_getValueProp).call(this, item)).join(', ');
        this.valueInputRef.val(vals);
        this.validate(this.valueInputRef);
    }, _MobileFilterAutocompleteBlock_getValueProp = function _MobileFilterAutocompleteBlock_getValueProp(item) {
        switch (this.options.mapValueProp) {
            case IMobileFilterAutocompleteValueProps.Label:
                return item.label;
                break;
            case IMobileFilterAutocompleteValueProps.Value:
                return item.value;
                break;
            case IMobileFilterAutocompleteValueProps.Name:
                return item.name || '';
                break;
        }
        // default
        return item.label;
    }, _MobileFilterAutocompleteBlock_updateView = function _MobileFilterAutocompleteBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterAutocompleteBlock_instances, "m", _MobileFilterAutocompleteBlock_refreshView).call(this, value);
    }, _MobileFilterAutocompleteBlock_getItemString = function _MobileFilterAutocompleteBlock_getItemString(item) {
        if (!item)
            return '';
        if (this.options.stringFormat != undefined)
            return this.options.stringFormat(item);
        return `${item.name}`;
    };
    Object.defineProperty(MobileFilterAutocompleteBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-autocomplete-block',
            title: 'Выбор',
            filterKey: 'noname',
            defaultValue: [],
            emptyText: '- не выбрано -',
            withIcons: true,
            isMulti: false,
            mapValueProp: IMobileFilterAutocompleteValueProps.Label, // изначально было по label (оставляю для обратной совместимости)
            minLength: 3,
        }
    });
    App.MobileFilterAutocompleteBlock = MobileFilterAutocompleteBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterAutocompleteGuideBlock_instances, _MobileFilterAutocompleteGuideBlock_loader, _MobileFilterAutocompleteGuideBlock_findUrl, _MobileFilterAutocompleteGuideBlock_addParams, _MobileFilterAutocompleteGuideBlock_mapItem_GuideDefault, _MobileFilterAutocompleteGuideBlock_mapItem_GuideAvia, _MobileFilterAutocompleteGuideBlock_mapItem_FromApiObject, _MobileFilterAutocompleteGuideBlock_initAutocompleteLogic, _MobileFilterAutocompleteGuideBlock_getSearchData, _MobileFilterAutocompleteGuideBlock_refreshView, _MobileFilterAutocompleteGuideBlock_updateView, _MobileFilterAutocompleteGuideBlock_serializeName, _MobileFilterAutocompleteGuideBlock_getItemString;
    let MobileFilterAutocompleteGuideType;
    (function (MobileFilterAutocompleteGuideType) {
        MobileFilterAutocompleteGuideType[MobileFilterAutocompleteGuideType["Default"] = 0] = "Default";
        MobileFilterAutocompleteGuideType[MobileFilterAutocompleteGuideType["Avia"] = 1] = "Avia";
        // NOTE: при добавлении тут, добавить и ниже необходимые методы маппинга
    })(MobileFilterAutocompleteGuideType = App.MobileFilterAutocompleteGuideType || (App.MobileFilterAutocompleteGuideType = {}));
    class MobileFilterAutocompleteGuideBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(true, true, MobileFilterAutocompleteGuideBlock.s_defaults, options);
            _MobileFilterAutocompleteGuideBlock_instances.add(this);
            Object.defineProperty(this, "valueRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            }); // копия значения в инпут (для валидатора)
            Object.defineProperty(this, "nameInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "typeInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "keyInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // readonly searchInputRef: JQuery<HTMLInputElement>; // pointInput
            _MobileFilterAutocompleteGuideBlock_loader.set(this, void 0);
            _MobileFilterAutocompleteGuideBlock_findUrl.set(this, void 0);
            // Для передачи доп.параметров, передаются все значения, найденные по переданным id:
            // [data-addParams="Pickup_Key,Pickup_Type"] => input#Pickup_Key, input#Pickup_Type
            _MobileFilterAutocompleteGuideBlock_addParams.set(this, void 0);
            Object.defineProperty(this, "autocompleteRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filterResults", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            }); // скрытый блок для результатов от плагина (иначе сыпит в body)
            if (!this.root.length)
                return;
            // render ref
            this.valueRef = $('.js-mobile-filter-value', this.root);
            this.valueInputRef = $('.js-mobile-filter-value-input', this.root);
            this.nameInputRef = $('.js-mobile-filter-value-input-name', this.root);
            this.typeInputRef = $('.js-mobile-filter-value-input-type', this.root);
            this.keyInputRef = $('.js-mobile-filter-value-input-key', this.root);
            this.setInputValidateRef(this.valueInputRef);
            // указатель на инпут поиска (из Vue компонента)
            // this.searchInputRef = $('.js-vue-autocomplete-search-input', this.root);
            this.filterResults = $('.js-point-results', this.root);
            // TODO: добавить в разметку в \Views\Shared\Mobile\Inputs\AutocompleteSelect.cshtml
            __classPrivateFieldSet(this, _MobileFilterAutocompleteGuideBlock_loader, $('.js-loader', this.root), "f");
            const url = this.root.attr('data-url');
            __classPrivateFieldSet(this, _MobileFilterAutocompleteGuideBlock_findUrl, url || 'url_not_setted', "f");
            __classPrivateFieldSet(this, _MobileFilterAutocompleteGuideBlock_addParams, this.root.attr('data-addparams'), "f");
            // guide type from dom
            const guidTypeStr = this.root.attr('data-guide-type');
            if (guidTypeStr) {
                this.options.guideType = MobileFilterAutocompleteGuideType[guidTypeStr];
            }
            // show modal
            this.root.on('click', () => {
                if (this.disabled)
                    return;
                PwStore.OpenModal('select-autocomplete-list-filter', Object.assign(Object.assign({}, this.options), { filterItems: this.options.filterKey }));
            });
            __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_initAutocompleteLogic).call(this);
            // слушаем все события - интересует кастомный от SelectAutocompleteListFilter.vue
            PwStore.AddListener(this); // => onCommit
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_updateView).call(this);
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            return jsonValue;
        }
        /**
         * Установка новых настроек.
         * @param value
         */
        setOptions(value) {
            this.options = Object.assign(Object.assign({}, this.options), value);
        }
        onCommit(eventName, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!payload)
                    return;
                const payloadData = payload;
                if (!payloadData || !payloadData.name || payloadData.name != this.name)
                    return;
                if (eventName == 'custom/Autocomplete/changeSearch') {
                    this.valueInputRef.val(payloadData.value);
                    this.autocompleteRef.autocomplete('search', payloadData.value);
                    if (!payloadData.value) {
                        // this.reset();
                        this.setFilters([], false);
                    }
                    this.root.trigger("autocompleteOption:click" /* Events.AutocompleteOptionClick */);
                }
            });
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_updateView).call(this);
        }
        /**
         * Сериализованные данные контрола (как правило, для параметров поиска).
         * Котрол может отдавать множество ключ-значение.
         * @returns
         */
        serializeArray() {
            const params = [];
            // TODO: в параметр - передавать ли данные в поиск, если ничего не указано?
            const mustBeSettedForSend = false;
            const v = this.getValue();
            if (!mustBeSettedForSend || (v != null && v.length > 0)) {
                // name
                params.push({
                    name: __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_serializeName).call(this, this.nameInputRef.attr('name')),
                    value: this.nameInputRef.val(),
                });
                // type
                params.push({
                    name: __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_serializeName).call(this, this.typeInputRef.attr('name')),
                    value: this.typeInputRef.val(),
                });
                // key
                params.push({
                    name: __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_serializeName).call(this, this.keyInputRef.attr('name')),
                    value: this.keyInputRef.val(),
                });
            }
            return params;
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            const value = this.getValue();
            if (!value)
                return [];
            return value.map(v => __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_getItemString).call(this, v));
        }
        getValuesString(separator = ',') {
            const value = this.getValue();
            if (!value)
                return '';
            return value.map(v => __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_getItemString).call(this, v)).join(separator);
        }
        getValue() {
            return this.getValueOrigin();
        }
        setValue(value, triggerChange = true) {
            // this.resetError();
            PwStore.ChangeFilter(this.options.filterKey || '', value, triggerChange);
        }
        setValueByGuide(text, code, type, triggerChange = true) {
            const value = {
                key: code,
                typeCode: type,
                typeName: type,
                typeKey: code,
                isGroup: false,
                label: text,
                inputLabel: text,
                value: text,
                checked: true,
            };
            this.setValue([value], triggerChange);
        }
        setRequired(isRequired) {
            this.valueInputRef.prop('required', isRequired);
        }
    }
    _MobileFilterAutocompleteGuideBlock_loader = new WeakMap(), _MobileFilterAutocompleteGuideBlock_findUrl = new WeakMap(), _MobileFilterAutocompleteGuideBlock_addParams = new WeakMap(), _MobileFilterAutocompleteGuideBlock_instances = new WeakSet(), _MobileFilterAutocompleteGuideBlock_mapItem_GuideDefault = function _MobileFilterAutocompleteGuideBlock_mapItem_GuideDefault(item) {
        return {
            key: item[0],
            value: item[1],
            name: item[2],
            typeCode: item[3] || '',
            typeName: App.isEnglishLanguage() ? item[3] : item[4],
            typeKey: item[5],
            checked: false,
            label: item[2],
            svg: '', // TODO: иконка для элемента выбора по typeCode??
            isGroup: false,
        };
    }, _MobileFilterAutocompleteGuideBlock_mapItem_GuideAvia = function _MobileFilterAutocompleteGuideBlock_mapItem_GuideAvia(item) {
        return {
            key: item[0],
            value: item[2],
            name: item[1],
            typeCode: item[3] || '',
            typeName: App.isEnglishLanguage() ? item[3] : item[4],
            typeKey: item[5],
            checked: false,
            label: item[2],
            svg: '', // TODO: иконка для элемента выбора по typeCode??
            isGroup: false,
        };
    }, _MobileFilterAutocompleteGuideBlock_mapItem_FromApiObject = function _MobileFilterAutocompleteGuideBlock_mapItem_FromApiObject(item) {
        return {
            key: item.key,
            value: item.key,
            name: item.name,
            typeCode: item.typeCode || '',
            typeName: item.typeName || '',
            typeKey: item.typeCode || '',
            checked: false,
            label: item.name,
            svg: '',
            isGroup: false,
        };
    }, _MobileFilterAutocompleteGuideBlock_initAutocompleteLogic = function _MobileFilterAutocompleteGuideBlock_initAutocompleteLogic() {
        this.autocompleteRef = this.valueInputRef.autocomplete({
            appendTo: this.filterResults,
            minLength: this.options.minLength,
            source: (request, response) => {
                /* eslint-disable @typescript-eslint/no-floating-promises */
                $.ajax({
                    url: __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_findUrl, "f"),
                    method: 'GET',
                    data: __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_getSearchData).call(this, request.term),
                    beforeSend: () => {
                        if (__classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_loader, "f").length > 0)
                            __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_loader, "f").show();
                    },
                    success: (data) => {
                        var _a;
                        const rawItems = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.items;
                        if (!Array.isArray(rawItems) || rawItems.length === 0) {
                            response([]);
                            return;
                        }
                        // Ответ API: { data: { items: [ { key, name, typeCode, typeName } ] } }
                        const isObjectFormat = typeof rawItems[0] === 'object' && rawItems[0] !== null
                            && !Array.isArray(rawItems[0])
                            && 'key' in (rawItems[0])
                            && 'name' in (rawItems[0]);
                        let itemsRender;
                        if (isObjectFormat) {
                            itemsRender = rawItems
                                .map(item => __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_mapItem_FromApiObject).call(this, item));
                        }
                        else {
                            let mapFunction = (itm) => __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_mapItem_GuideDefault).call(this, itm);
                            if (this.options.guideType == MobileFilterAutocompleteGuideType.Avia) {
                                mapFunction = (itm) => __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_mapItem_GuideAvia).call(this, itm);
                            }
                            itemsRender = rawItems
                                .map(item => mapFunction(item));
                        }
                        // подцепляем группы
                        const groups = [...new Map(itemsRender.map(item => [item.typeName, item])).values()];
                        const itemsGrouped = [];
                        groups.forEach(g => {
                            const group = {
                                key: '',
                                isGroup: true,
                                checked: false,
                                value: g.typeName,
                                name: g.typeName,
                                label: g.typeName,
                                svg: '',
                            };
                            itemsGrouped.push(group);
                            itemsGrouped.push(...itemsRender.filter(m => m.typeName == g.typeName));
                        });
                        response(itemsGrouped);
                    },
                });
                /* eslint-enable @typescript-eslint/no-floating-promises */
            },
            response: (_, ui) => {
                if (ui.content.length === 0) {
                    // this.#pointCode.val('');
                    // this.#pointType.val('');
                    // this.nameInputRef.val('');
                    // this.typeInputRef.val('');
                    // this.keyInputRef.val('');
                    this.setFilters([], false);
                    $('.js-noSearchData', this.root).fadeIn('slow').delay(5000).fadeOut('slow');
                }
                if (__classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_loader, "f").length > 0)
                    __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_loader, "f").hide();
                // this.pointAutocomplete.show();
                // данные пробрасываем во Vue компонент
                this.setFilters(ui.content, false);
            },
            select: () => {
                // убираем запятые, чтобы можно было продолжить поиск
                // const value = ui.item.value.replace(/,/g, ' ').replace(/ {2,}/g, ' ');
                // this.#pointInput.val(value);
                // this.#pointInput.attr('value', value);
                // this.#pointCode.val(ui.item.key);
                // this.#pointType.val(ui.item.typeCode);
                // this.#toggleInputIcons(false);
                // this.root.trigger(Events.AutocompleteOptionClick);
                // this.#pointInput.trigger('blur');
                return false;
            },
        });
    }, _MobileFilterAutocompleteGuideBlock_getSearchData = function _MobileFilterAutocompleteGuideBlock_getSearchData(searchString) {
        const data = {};
        data.search = searchString;
        if (__classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_addParams, "f")) {
            __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_addParams, "f").split(',').forEach(id => {
                const value = $(`#${id}`).valString();
                if (value) {
                    // TODO: изменить, пока так, чтобы отправить на сертификацию
                    const position = id.search('-');
                    const name = position >= 0 ? id.slice(position + 1) : id;
                    // TODO: изменить, пока так, чтобы отправить на сертификацию
                    data[name.toLowerCase().replace('_', '')] = value;
                }
            });
        }
        return data;
    }, _MobileFilterAutocompleteGuideBlock_refreshView = function _MobileFilterAutocompleteGuideBlock_refreshView(value) {
        if (!value) {
            this.valueRef.html(this.options.emptyText);
            // для валидатора
            this.valueInputRef.val(''); // именно пустота кладется для валидатора
            this.nameInputRef.val('');
            this.typeInputRef.val('');
            this.keyInputRef.val('');
            this.validate(this.valueInputRef);
            return;
        }
        // рендер
        // const html = value.map(item => item.label).join(', ');
        let html = '';
        // NOTE: на основе типа гайда
        if (this.options.guideType == MobileFilterAutocompleteGuideType.Avia) {
            html = value.map(item => {
                if (!item.name)
                    return item.name;
                return item.name.replace(/,/g, ' ').replace(/ {2,}/g, ' ');
            }).join(', ');
        }
        else { // DEFAULT
            html = value.map(item => {
                if (!item.label)
                    return item.label;
                return item.label.replace(/,/g, ' ').replace(/ {2,}/g, ' ');
            }).join(', ');
        }
        // render
        this.valueRef.html(html || this.options.emptyText);
        // для валидатора
        this.valueInputRef.val(html);
        this.nameInputRef.val(html);
        this.typeInputRef.val(value.map(itm => itm.typeCode).join(', '));
        this.keyInputRef.val(value.map(itm => itm.key).join(', '));
        this.validate(this.valueInputRef);
    }, _MobileFilterAutocompleteGuideBlock_updateView = function _MobileFilterAutocompleteGuideBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterAutocompleteGuideBlock_instances, "m", _MobileFilterAutocompleteGuideBlock_refreshView).call(this, value);
    }, _MobileFilterAutocompleteGuideBlock_serializeName = function _MobileFilterAutocompleteGuideBlock_serializeName(originalName) {
        if (!originalName)
            return '';
        if (this.options.serializeNameWithoutDot) {
            return originalName.replace('.', '');
        }
        return originalName;
    }, _MobileFilterAutocompleteGuideBlock_getItemString = function _MobileFilterAutocompleteGuideBlock_getItemString(item) {
        if (!item)
            return '';
        if (this.options.stringFormat != undefined)
            return this.options.stringFormat(item);
        // return `${item.typeCode.toLowerCase()},${item.key}`;
        return `${item.name}`;
    };
    Object.defineProperty(MobileFilterAutocompleteGuideBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-autocomplete-guide-block',
            title: 'Выбор',
            filterKey: 'noname',
            defaultValue: [],
            emptyText: '- не выбрано -',
            guideType: MobileFilterAutocompleteGuideType.Default,
            withIcons: true,
            minLength: 3,
            serializeNameWithoutDot: false,
        }
    });
    App.MobileFilterAutocompleteGuideBlock = MobileFilterAutocompleteGuideBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterDateBlock_instances, _MobileFilterDateBlock_refreshView, _MobileFilterDateBlock_updateView, _MobileFilterDateBlock_validateValue, _MobileFilterDateBlock_clampValue;
    class MobileFilterDateBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(false, false, MobileFilterDateBlock.s_defaults, options);
            _MobileFilterDateBlock_instances.add(this);
            Object.defineProperty(this, "valueRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            }); // копия значения в инпут (для валидатора)
            if (!this.root.length)
                return;
            // render ref
            this.valueRef = $('.js-mobile-filter-value', this.root);
            this.valueInputRef = $('.js-mobile-filter-value-input', this.root);
            this.setInputValidateRef(this.valueInputRef);
            // show modal
            this.root.on('click', () => {
                if (this.disabled)
                    return;
                PwStore.OpenModal('date-filter', this.options);
            });
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterDateBlock_instances, "m", _MobileFilterDateBlock_updateView).call(this, true);
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            if (!jsonValue)
                return undefined;
            return new Date(jsonValue);
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterDateBlock_instances, "m", _MobileFilterDateBlock_updateView).call(this, false);
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            const date = this.getValue();
            if (!date)
                return '';
            return App.formatDate(date, this.options.formatReturn);
        }
        getValue() {
            return this.getValueOrigin();
        }
        setValue(value, triggerChange = true) {
            // this.#calendar.trigger('focusin');
            __classPrivateFieldGet(this, _MobileFilterDateBlock_instances, "m", _MobileFilterDateBlock_validateValue).call(this, value, triggerChange);
            // this.#calendar.trigger('focusout');
        }
        setValueByStr(dateStr, format, triggerChange = true) {
            this.setValue(App.parseDate(dateStr, format), triggerChange);
        }
        setValueAndAddDays(value, days, triggerChange = true) {
            this.setValue(App.addDays(value, days), triggerChange);
        }
        /**
         * Установка новых настроек.
         * @param value
         */
        setOptions(value) {
            this.options = Object.assign(Object.assign({}, this.options), value);
        }
        /**
         * Разница в количестве дней между двумя датами.
         * @param date1
         * @param date2
         * @returns
         */
        static getDaysDiff(date1, date2) {
            if (!date1 || !date2)
                return 0;
            const diff = (date2 > date1) ? Math.abs(date2.getTime() - date1.getTime()) : Math.abs(date1.getTime() - date2.getTime());
            return Math.ceil(diff / (1000 * 3600 * 24));
        }
        getDefaultValue() {
            var _a;
            const v = PwStore.GetFilterDefault(this.options.filterKey) || this.options.defaultValue;
            if (!v)
                return v;
            return App.addDays(v, (_a = this.options.defaultDateShift) !== null && _a !== void 0 ? _a : 0);
        }
        setMinDate(minDate, days = 0, triggerChange = true) {
            this.options.minDate = days == 0 ? minDate : App.addDays(minDate, days);
            __classPrivateFieldGet(this, _MobileFilterDateBlock_instances, "m", _MobileFilterDateBlock_clampValue).call(this, this.getValue(), triggerChange);
        }
        setMaxDate(maxDate, days = 0, triggerChange = true) {
            this.options.maxDate = days == 0 ? maxDate : App.addDays(maxDate, days);
            __classPrivateFieldGet(this, _MobileFilterDateBlock_instances, "m", _MobileFilterDateBlock_clampValue).call(this, this.getValue(), triggerChange);
        }
        static parseDate(dateStr, format) {
            return App.parseDate(dateStr, format);
        }
        setRequired(isRequired) {
            this.valueInputRef.prop('required', isRequired);
        }
    }
    _MobileFilterDateBlock_instances = new WeakSet(), _MobileFilterDateBlock_refreshView = function _MobileFilterDateBlock_refreshView(date, fromInit = false) {
        if (!date) {
            this.valueRef.html('');
            // для валидатора
            this.valueInputRef.val('');
            if (!fromInit)
                this.validate(this.valueInputRef);
            return;
        }
        // рендер даты по маске
        const valueStr = App.formatDate(date, this.options.formatView);
        this.valueRef.html(valueStr);
        // для валидатора
        const valueValidStr = App.formatDate(date, this.options.formatReturn);
        this.valueInputRef.val(valueValidStr);
        if (!fromInit)
            this.validate(this.valueInputRef);
    }, _MobileFilterDateBlock_updateView = function _MobileFilterDateBlock_updateView(fromInit = false) {
        const date = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterDateBlock_instances, "m", _MobileFilterDateBlock_refreshView).call(this, date, fromInit);
    }, _MobileFilterDateBlock_validateValue = function _MobileFilterDateBlock_validateValue(value, triggerChange = true) {
        const minValue = this.options.minDate; // NOTE: тут еще не оборачиваем в new Date, т.к. нам важно проверка на Null
        const maxValue = this.options.maxDate;
        const compareValue = new Date(value);
        // NOTE: сравниваем с оборачиванием в new Date, т.к. могут быть разные типы Date (0_o)
        if ((!minValue || compareValue >= new Date(minValue)) && (!maxValue || compareValue <= new Date(maxValue))) {
            PwStore.ChangeFilter(this.options.filterKey || '', value, triggerChange);
        }
    }, _MobileFilterDateBlock_clampValue = function _MobileFilterDateBlock_clampValue(value, triggerChange = true) {
        if (!value)
            return;
        let v = value;
        if (this.options.minDate && v < this.options.minDate) {
            v = this.options.minDate; // addDays(this.options.minDate, 1);
        }
        if (this.options.maxDate && v > this.options.maxDate) {
            v = this.options.maxDate; // addDays(this.options.maxDate, -1);
        }
        // TODO: check disabled dates
        if (v != value)
            this.setValue(v, triggerChange);
    };
    Object.defineProperty(MobileFilterDateBlock, "yearRangeLeft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: -110
    });
    Object.defineProperty(MobileFilterDateBlock, "yearRangeRight", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(MobileFilterDateBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-date-block',
            title: 'Дата',
            filterKey: 'noname',
            defaultValue: undefined,
            minDate: App.addDays(new Date(), MobileFilterDateBlock.yearRangeLeft * 365),
            maxDate: App.addDays(new Date(), MobileFilterDateBlock.yearRangeRight * 365),
            disabledDates: [],
            range: 1,
            formatView: 'shortDate',
            formatReturn: 'iso',
            // changeMonthYear: false,
            defaultDateShift: 0,
        }
    });
    App.MobileFilterDateBlock = MobileFilterDateBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterGenderBlock_instances, _MobileFilterGenderBlock_valueCache, _MobileFilterGenderBlock_onEventClick, _MobileFilterGenderBlock_refreshView, _MobileFilterGenderBlock_updateView;
    let MobileFilterGenderValue;
    (function (MobileFilterGenderValue) {
        MobileFilterGenderValue["Male"] = "Male";
        MobileFilterGenderValue["Female"] = "Female";
    })(MobileFilterGenderValue = App.MobileFilterGenderValue || (App.MobileFilterGenderValue = {}));
    class MobileFilterGenderBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(false, false, MobileFilterGenderBlock.s_defaults, options);
            _MobileFilterGenderBlock_instances.add(this);
            // NOTE: для получения актуального значения применять метод getValue (а это значение для внутреннего использования)
            _MobileFilterGenderBlock_valueCache.set(this, void 0);
            if (!this.root.length)
                return;
            // events
            this.root.on('click', e => __classPrivateFieldGet(this, _MobileFilterGenderBlock_instances, "m", _MobileFilterGenderBlock_onEventClick).call(this, e));
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterGenderBlock_instances, "m", _MobileFilterGenderBlock_updateView).call(this);
        }
        /**
         * Параметр по-умолчанию.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @returns
         */
        initDefaultValue() {
            __classPrivateFieldSet(this, _MobileFilterGenderBlock_valueCache, this.options ? (this.options.defaultValue) : MobileFilterGenderValue.Male, "f");
            if (this.root.attr('data-value-default')) {
                __classPrivateFieldSet(this, _MobileFilterGenderBlock_valueCache, MobileFilterGenderBlock.getValueByString(this.root.attr('data-value-default')), "f");
            }
            return __classPrivateFieldGet(this, _MobileFilterGenderBlock_valueCache, "f");
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            // return jsonValue as MobileFilterGenderValue;
            return MobileFilterGenderBlock.getValueByString(jsonValue);
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterGenderBlock_instances, "m", _MobileFilterGenderBlock_updateView).call(this);
            // custom event
            if (this.options.onEventChange) {
                this.options.onEventChange(this.getValue());
            }
        }
        /**
         * Установка кастомной функции дополнительной реакции на смену значения.
         * @param mapDataToItems
         */
        setCustomEventChange(onEventChange) {
            this.options.onEventChange = onEventChange;
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            return this.getValue();
        }
        static getValueByString(value) {
            if (!value)
                return MobileFilterGenderValue.Male; // this.options.defaultValue;
            if (value == '0' || value == 'Male')
                return MobileFilterGenderValue.Male;
            return MobileFilterGenderValue.Female;
        }
        getValue() {
            return this.getValueOrigin();
        }
        setValue(value, triggerChange = true) {
            // NOTE: не проверяем disable, т.к. выключен для пользователя только, а не для логики
            PwStore.ChangeFilter(this.options.filterKey || '', MobileFilterGenderBlock.getValueByString(value), triggerChange);
        }
        /**
         * Переключение состояния тумблера.
         * Учитывается disable. Если необходимо обновить состояние у выключенного, то применить setValue.
         * @returns
         */
        toggle() {
            if (this.disabled)
                return;
            this.setValue(__classPrivateFieldGet(this, _MobileFilterGenderBlock_valueCache, "f") == MobileFilterGenderValue.Male ? MobileFilterGenderValue.Female : MobileFilterGenderValue.Male);
        }
        /**
         * Список опций в формате для контрола на основе данных из ListOption[].
         * NOTE: новые данные не применяются в этот момент.
         * @param arrFrom
         * @returns
         */
        convertFromListOptions(arrFrom) {
            if (!arrFrom)
                return this.getDefaultValue();
            const itemFrom = arrFrom.find(f => f.text == this.name);
            if (!itemFrom)
                return this.getDefaultValue();
            if (itemFrom.selected == undefined)
                return this.getDefaultValue();
            return (itemFrom.selected == true && itemFrom.value == 'Male') ? MobileFilterGenderValue.Male : MobileFilterGenderValue.Female;
        }
    }
    _MobileFilterGenderBlock_valueCache = new WeakMap(), _MobileFilterGenderBlock_instances = new WeakSet(), _MobileFilterGenderBlock_onEventClick = function _MobileFilterGenderBlock_onEventClick(event) {
        event.preventDefault();
        if (this.disabled)
            return;
        this.toggle();
        // this.resetError();
    }, _MobileFilterGenderBlock_refreshView = function _MobileFilterGenderBlock_refreshView(value) {
        if (value == MobileFilterGenderValue.Male) {
            this.root.addClass('toggle-input--left');
            this.root.removeClass('toggle-input--right');
        }
        else {
            this.root.addClass('toggle-input--right');
            this.root.removeClass('toggle-input--left');
        }
        // TODO: валидировать аналогично как MobileFilterDateBlock?
    }, _MobileFilterGenderBlock_updateView = function _MobileFilterGenderBlock_updateView() {
        __classPrivateFieldSet(this, _MobileFilterGenderBlock_valueCache, this.getValue(), "f");
        __classPrivateFieldGet(this, _MobileFilterGenderBlock_instances, "m", _MobileFilterGenderBlock_refreshView).call(this, __classPrivateFieldGet(this, _MobileFilterGenderBlock_valueCache, "f"));
    };
    Object.defineProperty(MobileFilterGenderBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-gender-block',
            filterKey: 'noname',
            defaultValue: MobileFilterGenderValue.Male,
        }
    });
    App.MobileFilterGenderBlock = MobileFilterGenderBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterInputBlock_instances, _MobileFilterInputBlock_onChangeMaps, _MobileFilterInputBlock_onEventChange, _MobileFilterInputBlock_valueMapTranslate, _MobileFilterInputBlock_valueMapTranslateName, _MobileFilterInputBlock_onEventKeyUp, _MobileFilterInputBlock_refreshView, _MobileFilterInputBlock_updateView;
    class MobileFilterInputBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(false, false, MobileFilterInputBlock.s_defaults, options);
            _MobileFilterInputBlock_instances.add(this);
            Object.defineProperty(this, "valueRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _MobileFilterInputBlock_onChangeMaps.set(this, void 0);
            if (!this.root.length)
                return;
            // render ref
            this.valueRef = $('.js-mobile-filter-value', this.root);
            this.setInputValidateRef(this.valueRef);
            // maps (автообработчик поле вода - например, перевод текста)
            __classPrivateFieldSet(this, _MobileFilterInputBlock_onChangeMaps, [], "f");
            if (this.hasClass('js-field-transliterate'))
                __classPrivateFieldGet(this, _MobileFilterInputBlock_onChangeMaps, "f").push(v => __classPrivateFieldGet(this, _MobileFilterInputBlock_instances, "m", _MobileFilterInputBlock_valueMapTranslate).call(this, v));
            if (this.hasClass('js-field-transliterate-name'))
                __classPrivateFieldGet(this, _MobileFilterInputBlock_onChangeMaps, "f").push(v => __classPrivateFieldGet(this, _MobileFilterInputBlock_instances, "m", _MobileFilterInputBlock_valueMapTranslateName).call(this, v));
            // events
            this.valueRef.on('change', e => __classPrivateFieldGet(this, _MobileFilterInputBlock_instances, "m", _MobileFilterInputBlock_onEventChange).call(this, e.currentTarget));
            this.valueRef.on('keyup', e => __classPrivateFieldGet(this, _MobileFilterInputBlock_instances, "m", _MobileFilterInputBlock_onEventKeyUp).call(this, e.currentTarget));
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            // NOTE: очень странный случай - затирает данные в поле value, если в PwStore еще нет ничего (и если нет defaultValue)
            if (this.options.withUpdateView)
                __classPrivateFieldGet(this, _MobileFilterInputBlock_instances, "m", _MobileFilterInputBlock_updateView).call(this);
            this.refreshEnabledView(!this.disabled);
            // this.updateErrorView();
        }
        /**
         * Параметр по-умолчанию.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @returns
         */
        initDefaultValue() {
            // super.initDefaultValue();
            // текущение значение и есть значение по-умолчанию
            const valueRef = $('.js-mobile-filter-value', this.root);
            if (!valueRef)
                return this.options.defaultValue;
            const v = valueRef.val();
            if (v && v != undefined && v != '')
                return v;
            return this.options.defaultValue;
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            return jsonValue;
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterInputBlock_instances, "m", _MobileFilterInputBlock_updateView).call(this);
        }
        /**
         * Установка обработчика события при изменении поля.
         * Например, для подмены значения - транслитерация текста.
         * NOTE: не путать с основным событием изменения фильтра.
         * NOTE: данный метод применяется до изменения фильтра (после ввода нового значения).
         * @param value
         */
        setOptionsOnChangeMap(onChangeMap) {
            this.options = Object.assign(Object.assign({}, this.options), { onChangeMap: onChangeMap });
        }
        /**
         * Установка обработчика события при вводе символа в поле.
         * @param value
         */
        setOptionsOnKeyup(onKeyupMap) {
            this.options = Object.assign(Object.assign({}, this.options), { onKeyupMap: onKeyupMap });
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            return this.getValue();
        }
        getValue() {
            return this.getValueOrigin();
        }
        setValue(value, triggerChange = true) {
            PwStore.ChangeFilter(this.options.filterKey || '', value, triggerChange);
        }
        /**
         * Обновление вида после включения/выключения.
         * @param isEnabled
         */
        refreshEnabledView(isEnabled) {
            super.refreshEnabledView(isEnabled);
            this.valueRef.enable(isEnabled);
        }
        setRequired(isRequired) {
            this.valueRef.prop('required', isRequired);
        }
    }
    _MobileFilterInputBlock_onChangeMaps = new WeakMap(), _MobileFilterInputBlock_instances = new WeakSet(), _MobileFilterInputBlock_onEventChange = function _MobileFilterInputBlock_onEventChange(el) {
        if (this.disabled)
            return;
        let value = $(el).val() || '';
        // maps
        __classPrivateFieldGet(this, _MobileFilterInputBlock_onChangeMaps, "f").forEach(m => { value = m(value); });
        // custom map
        if (this.options.onChangeMap)
            value = this.options.onChangeMap(value);
        // TODO: проблема самообновления после ввода в input наш же
        // TODO: избыточно, когда пользователь ввел что-то в Input, мы сами отправили Диспетчеру сообщение, что фильтр обновился - и сами слушаем это событие и сами себя перерисовываем!
        this.setValue(value, true);
    }, _MobileFilterInputBlock_valueMapTranslate = function _MobileFilterInputBlock_valueMapTranslate(v) {
        return App.transliterate(v);
    }, _MobileFilterInputBlock_valueMapTranslateName = function _MobileFilterInputBlock_valueMapTranslateName(v) {
        return App.transliterateName(v);
    }, _MobileFilterInputBlock_onEventKeyUp = function _MobileFilterInputBlock_onEventKeyUp(el) {
        // this.resetError();
        const value = $(el).val() || '';
        // custom
        if (this.options.onKeyupMap)
            this.options.onKeyupMap(value);
    }, _MobileFilterInputBlock_refreshView = function _MobileFilterInputBlock_refreshView(value) {
        // рендер
        this.valueRef.val(value);
        // для валидатора
        if (value) {
            this.validate(this.valueRef);
        }
    }, _MobileFilterInputBlock_updateView = function _MobileFilterInputBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterInputBlock_instances, "m", _MobileFilterInputBlock_refreshView).call(this, value);
        // this.validate(true); // валидируется плагином, который подцеплен в FiltersMobileBase
    };
    Object.defineProperty(MobileFilterInputBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-input-block',
            title: 'Название',
            filterKey: 'noname',
            defaultValue: '',
            withUpdateView: true,
        }
    });
    App.MobileFilterInputBlock = MobileFilterInputBlock;
})(App || (App = {}));
/// <reference path="MobileFilterBlockBase.ts" />
var App;
(function (App) {
    var _MobileFilterRangeBlock_instances, _MobileFilterRangeBlock_refreshView, _MobileFilterRangeBlock_updateView;
    class MobileFilterRangeBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(true, false, MobileFilterRangeBlock.defaults, options);
            _MobileFilterRangeBlock_instances.add(this);
            Object.defineProperty(this, "valueFromRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueToRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            this.valueFromRef = $('.js-mobile-filter-value-from', this.root);
            this.valueToRef = $('.js-mobile-filter-value-to', this.root);
            this.valueInputRef = $('.js-mobile-filter-value-input', this.root);
            this.setInputValidateRef(this.valueInputRef);
            PwStore.AddFilter(this.options.filterNameMin, this.options.min);
            PwStore.AddFilter(this.options.filterNameMax, this.options.max);
            PwStore.AddFilter(this.options.filterNameFrom, this.options.from);
            PwStore.AddFilter(this.options.filterNameTo, this.options.to);
            this.root.on('click', () => {
                console.log('options', this.options);
                // const filterMin = PwStore.GetFilterItem(this.options.filterNameMin);
                const current = this.getValueOrigin();
                console.log('filterMin', current);
                PwStore.OpenModal('date-range-filter', this.options);
            });
            // сразу отрендерим текущее значение
            __classPrivateFieldGet(this, _MobileFilterRangeBlock_instances, "m", _MobileFilterRangeBlock_updateView).call(this);
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                if (filterName == this.options.filterKey
                    || filterName == this.options.filterNameMin
                    || filterName == this.options.filterNameMax
                    || filterName == this.options.filterNameFrom
                    || filterName == this.options.filterNameTo
                    || filterName == PwStore.FILTER_ALL) { // если изменился наш фильтр (или все)
                    this.onChanged();
                    // оповестить нашего слушателя (страницу - будет делать новый поиск, например)
                    if (this.options.onChanged)
                        this.options.onChanged();
                }
            });
        }
        /** Когда PwStore шлёт событие об изменении нашего фильтра */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterRangeBlock_instances, "m", _MobileFilterRangeBlock_updateView).call(this);
        }
        setOptions(value) {
            super.setOptions(value);
        }
        getValueString() {
            const value = this.getValue();
            if (!value)
                return '';
            return `${value.from},${value.to}`;
        }
        getValue() {
            return this.getValueOrigin();
        }
        getValueOrigin() {
            const min = PwStore.GetFilter(this.options.filterNameMin);
            const max = PwStore.GetFilter(this.options.filterNameMax);
            const from = PwStore.GetFilter(this.options.filterNameFrom);
            const to = PwStore.GetFilter(this.options.filterNameTo);
            return { min, max, from, to };
        }
        setValue(value, triggerChange = true) {
            PwStore.ChangeFilter(this.options.filterNameMin || '', value.min, triggerChange);
            PwStore.ChangeFilter(this.options.filterNameMax || '', value.max, triggerChange);
            PwStore.ChangeFilter(this.options.filterNameFrom || '', value.from, triggerChange);
            PwStore.ChangeFilter(this.options.filterNameTo || '', value.to, triggerChange);
            this.options.min = value.min;
            this.options.max = value.max;
            this.options.from = value.from;
            this.options.to = value.to;
        }
        serializeArray() {
            const params = [];
            const value = this.getValue();
            if (value != null) {
                params.push({
                    name: this.options.filterKey,
                    value: this.getValueString(),
                });
            }
            return params;
        }
        /**
         * Сброс значения элемента управления в default-состояние.
        */
        reset() {
            PwStore.ResetFilterByName(this.options.filterNameMin);
            PwStore.ResetFilterByName(this.options.filterNameMax);
            PwStore.ResetFilterByName(this.options.filterNameFrom);
            PwStore.ResetFilterByName(this.options.filterNameTo);
        }
        setRequired(isRequired) {
            this.valueInputRef.prop('required', isRequired);
        }
    }
    _MobileFilterRangeBlock_instances = new WeakSet(), _MobileFilterRangeBlock_refreshView = function _MobileFilterRangeBlock_refreshView(value) {
        var _a, _b;
        if (!value) {
            this.valueFromRef.html('0');
            this.valueToRef.html('0');
            this.valueInputRef.val('');
            this.validate(this.valueInputRef);
            return;
        }
        this.valueFromRef.html((_a = value.from) === null || _a === void 0 ? void 0 : _a.toString());
        this.valueToRef.html((_b = value.to) === null || _b === void 0 ? void 0 : _b.toString());
        const html = `${value.from},${value.to}`;
        this.valueInputRef.val(html);
        this.validate(this.valueInputRef);
    }, _MobileFilterRangeBlock_updateView = function _MobileFilterRangeBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterRangeBlock_instances, "m", _MobileFilterRangeBlock_refreshView).call(this, value);
    };
    /** Опции по-умолчанию, которые можно переопределить при инстанцировании */
    Object.defineProperty(MobileFilterRangeBlock, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-range-block',
            filterKey: 'range', // ключ фильтра в PwStore
            defaultValue: { min: 0, max: 100, from: 0, to: 1000 },
            filterNameMin: 'rangeMinFilter',
            filterNameMax: 'rangeMaxFilter',
            filterNameFrom: 'rangeFromFilter',
            filterNameTo: 'rangeToFilter',
            title: 'Диапазон',
            min: 0,
            max: 1000,
            from: 200,
            to: 300,
            step: 1,
        }
    });
    App.MobileFilterRangeBlock = MobileFilterRangeBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterSelectListBlock_instances, _MobileFilterSelectListBlock_refreshView, _MobileFilterSelectListBlock_updateView;
    class MobileFilterSelectListBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(true, true, MobileFilterSelectListBlock.s_defaults, options);
            _MobileFilterSelectListBlock_instances.add(this);
            Object.defineProperty(this, "valueRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            }); // копия значения в инпут (для валидатора)
            if (!this.root.length)
                return;
            // render ref
            this.valueRef = $('.js-mobile-filter-value', this.root);
            this.valueInputRef = $('.js-mobile-filter-value-input', this.root);
            this.setInputValidateRef(this.valueInputRef);
            // show modal
            this.root.on('click', () => {
                if (this.disabled)
                    return;
                PwStore.OpenModal(this.options.withIcons ? 'select-icon-list-filter' : 'select-list-filter', this.options);
            });
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterSelectListBlock_instances, "m", _MobileFilterSelectListBlock_updateView).call(this);
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            return jsonValue;
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterSelectListBlock_instances, "m", _MobileFilterSelectListBlock_updateView).call(this);
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            const value = this.getValue();
            if (!value)
                return [];
            return value.map(v => v.value);
        }
        getValuesString(separator = ',') {
            const value = this.getValue();
            if (!value)
                return '';
            return value.map(v => v.value).join(separator);
        }
        getValue() {
            return this.getValueOrigin();
        }
        /**
         * Установка новых фильтров.
         */
        setValue(value, triggerChange = true) {
            // this.resetError();
            PwStore.ChangeFilter(this.options.filterKey || '', value, triggerChange);
        }
        /**
         * Установка выбранного фильтра из имеющихся.
         */
        setValueChecked(selectedValue, triggerChange = true) {
            const items = this.getValue();
            $.each(items, (i, item) => {
                if (item.value === selectedValue)
                    item.checked = true;
                else
                    item.checked = false;
            });
            this.setFilters(items, false, triggerChange);
        }
        setRequired(isRequired) {
            this.valueInputRef.prop('required', isRequired);
        }
    }
    _MobileFilterSelectListBlock_instances = new WeakSet(), _MobileFilterSelectListBlock_refreshView = function _MobileFilterSelectListBlock_refreshView(value) {
        if (!value) {
            this.valueRef.html(this.options.emptyText);
            // для валидатора
            this.valueInputRef.val(''); // именно пустота кладется для валидатора
            this.validate(this.valueInputRef);
            return;
        }
        // рендер
        const html = value.map(item => item.label).join(', ');
        this.valueRef.html(html || this.options.emptyText);
        // для валидатора
        this.valueInputRef.val(html);
        this.validate(this.valueInputRef);
    }, _MobileFilterSelectListBlock_updateView = function _MobileFilterSelectListBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterSelectListBlock_instances, "m", _MobileFilterSelectListBlock_refreshView).call(this, value);
    };
    Object.defineProperty(MobileFilterSelectListBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-selectlist-block',
            title: 'Выбор',
            filterKey: 'noname',
            defaultValue: [],
            emptyText: '- не выбрано -',
            withIcons: false,
        }
    });
    App.MobileFilterSelectListBlock = MobileFilterSelectListBlock;
})(App || (App = {}));
/// <reference path="MobileFilterBlockBase.ts" />
var App;
(function (App) {
    var _MobileFilterStarRatingRangeBlock_instances, _MobileFilterStarRatingRangeBlock_refreshView, _MobileFilterStarRatingRangeBlock_updateView;
    class MobileFilterStarRatingRangeBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            // isArray = true, clearDefaultValue = false
            super(true, false, MobileFilterStarRatingRangeBlock.defaults, options);
            _MobileFilterStarRatingRangeBlock_instances.add(this);
            Object.defineProperty(this, "valueFromRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueToRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            this.valueFromRef = $('.js-mobile-filter-stars-from', this.root);
            this.valueToRef = $('.js-mobile-filter-stars-to', this.root);
            this.valueInputRef = $('.js-mobile-filter-stars-input', this.root);
            // PwStore.AddFilter(this.options.filterNameMin, this.options.min);
            // PwStore.AddFilter(this.options.filterNameMax, this.options.max);
            PwStore.AddFilter(this.options.filterNameFrom, this.options.from);
            PwStore.AddFilter(this.options.filterNameTo, this.options.to);
            this.root.on('click', () => {
                PwStore.OpenModal('star-rating-range-filter', this.options);
            });
            // сразу отрендерим текущее значение
            // this.#updateView();
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                if (filterName == this.options.filterKey
                    || filterName == this.options.filterNameFrom
                    || filterName == this.options.filterNameTo
                    || filterName == PwStore.FILTER_ALL) { // если изменился наш фильтр (или все)
                    this.onChanged();
                    // оповестить нашего слушателя (страницу - будет делать новый поиск, например)
                    if (this.options.onChanged)
                        this.options.onChanged();
                }
            });
        }
        /** Когда PwStore шлёт событие об изменении нашего фильтра */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterStarRatingRangeBlock_instances, "m", _MobileFilterStarRatingRangeBlock_updateView).call(this);
        }
        setOptions(value) {
            super.setOptions(value);
        }
        getValueString() {
            const value = this.getValue();
            if (!value)
                return '';
            return `${value.from},${value.to}`;
        }
        getValue() {
            return this.getValueOrigin();
        }
        getValueOrigin() {
            const from = PwStore.GetFilter(this.options.filterNameFrom);
            const to = PwStore.GetFilter(this.options.filterNameTo);
            return { from, to };
        }
        setValue(value, triggerChange = true) {
            PwStore.ChangeFilter(this.options.filterNameFrom || '', value.from, triggerChange);
            PwStore.ChangeFilter(this.options.filterNameTo || '', value.to, triggerChange);
            this.options.from = value.from;
            this.options.to = value.to;
        }
        serializeArray() {
            const params = [];
            const value = this.getValue();
            if (value != null) {
                params.push({
                    name: this.options.filterKey,
                    value: this.getValueString(),
                });
            }
            return params;
        }
        /**
         * Сброс значения элемента управления в default-состояние.
        */
        reset() {
            PwStore.ResetFilterByName(this.options.filterNameFrom);
            PwStore.ResetFilterByName(this.options.filterNameTo);
        }
    }
    _MobileFilterStarRatingRangeBlock_instances = new WeakSet(), _MobileFilterStarRatingRangeBlock_refreshView = function _MobileFilterStarRatingRangeBlock_refreshView(value) {
        var _a, _b;
        if (!value) {
            this.valueFromRef.html('0');
            this.valueToRef.html('0');
            this.valueInputRef.val('');
            this.validate(this.valueInputRef);
            return;
        }
        this.valueFromRef.html((_a = value.from) === null || _a === void 0 ? void 0 : _a.toString());
        this.valueToRef.html((_b = value.to) === null || _b === void 0 ? void 0 : _b.toString());
        const html = `${value.from},${value.to}`;
        this.valueInputRef.val(html);
        this.validate(this.valueInputRef);
    }, _MobileFilterStarRatingRangeBlock_updateView = function _MobileFilterStarRatingRangeBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterStarRatingRangeBlock_instances, "m", _MobileFilterStarRatingRangeBlock_refreshView).call(this, value);
    };
    /** Опции по-умолчанию, которые можно переопределить при инстанцировании */
    Object.defineProperty(MobileFilterStarRatingRangeBlock, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-star-rating-range-block',
            filterKey: 'stars', // ключ фильтра в PwStore
            defaultValue: { from: 0, to: 5 },
            filterNameFrom: 'starsFromFilter',
            filterNameTo: 'starsToFilter',
            title: 'Диапазон',
            min: 0,
            max: 5,
            from: 3,
            to: 5,
        }
    });
    App.MobileFilterStarRatingRangeBlock = MobileFilterStarRatingRangeBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterTimeBlock_instances, _MobileFilterTimeBlock_refreshView, _MobileFilterTimeBlock_updateView;
    class MobileFilterTimeBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(true, false, MobileFilterTimeBlock.s_defaults, options);
            _MobileFilterTimeBlock_instances.add(this);
            Object.defineProperty(this, "valueRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            // render ref
            this.valueRef = $('.js-mobile-filter-value', this.root);
            // this.setInputValidateRef(this.valueInputRef);
            // show modal
            this.root.on('click', () => {
                if (this.disabled)
                    return;
                PwStore.OpenModal('select-list-filter', this.options);
            });
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterTimeBlock_instances, "m", _MobileFilterTimeBlock_updateView).call(this);
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterTimeBlock_instances, "m", _MobileFilterTimeBlock_updateView).call(this);
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            const value = this.getValue();
            if (!value)
                return [];
            return value.map(v => v.value);
        }
        getValuesString(separator = ',') {
            const value = this.getValue();
            if (!value)
                return '';
            return value.map(v => v.value).join(separator);
        }
        getValue() {
            return this.getValueOrigin();
        }
        setValue(value, triggerChange = true) {
            // TODO: this.validateValue(value);
            PwStore.ChangeFilter(this.options.filterKey || '', value, triggerChange);
        }
        setRequired(isRequired) {
            this.valueRef.prop('required', isRequired);
        }
    }
    _MobileFilterTimeBlock_instances = new WeakSet(), _MobileFilterTimeBlock_refreshView = function _MobileFilterTimeBlock_refreshView(value) {
        if (!value) {
            this.valueRef.html(this.options.emptyText);
            return;
        }
        // рендер
        const html = value.map(item => item.label).join(', ');
        this.valueRef.html(html || this.options.emptyText);
    }, _MobileFilterTimeBlock_updateView = function _MobileFilterTimeBlock_updateView() {
        const date = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterTimeBlock_instances, "m", _MobileFilterTimeBlock_refreshView).call(this, date);
        // this.validate(true); // валидируется плагином, который подцеплен в FiltersMobileBase
    };
    Object.defineProperty(MobileFilterTimeBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-time-block',
            title: 'Время',
            filterKey: 'noname',
            defaultValue: [],
            emptyText: '- не выбрано -',
        }
    });
    App.MobileFilterTimeBlock = MobileFilterTimeBlock;
})(App || (App = {}));
/// <reference path="MobileFilterBlockBase.ts" />
var App;
(function (App) {
    var _MobileFilterTimeRangeBlock_instances, _a, _MobileFilterTimeRangeBlock_getDefaultValue, _MobileFilterTimeRangeBlock_tooltipFormatValue, _MobileFilterTimeRangeBlock_formatValue, _MobileFilterTimeRangeBlock_refreshView, _MobileFilterTimeRangeBlock_updateView;
    class MobileFilterTimeRangeBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(true, false, _a.defaults, options);
            _MobileFilterTimeRangeBlock_instances.add(this);
            Object.defineProperty(this, "valueFromRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueToRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            this.valueFromRef = $('.js-mobile-filter-value-from', this.root);
            this.valueToRef = $('.js-mobile-filter-value-to', this.root);
            this.valueInputRef = $('.js-mobile-filter-value-input', this.root);
            this.setInputValidateRef(this.valueInputRef);
            // формат тултипа
            this.options.tooltipFormatterFn = (v) => {
                return __classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_tooltipFormatValue).call(this, v);
            };
            // show modal
            this.root.on('click', () => {
                if (this.disabled)
                    return;
                PwStore.OpenModal('time-range-filter', this.options);
            });
            // сразу отрендерим текущее значение
            __classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_updateView).call(this);
        }
        /**
         * Параметр по-умолчанию.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @returns
         */
        initDefaultValue() {
            return __classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_getDefaultValue).call(this);
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            return _a.getValueByString(jsonValue);
        }
        static getValueByString(value) {
            const defaultValue = _a.defaults.defaultValue
                || { from: 0, to: 86400 };
            if (!value)
                return defaultValue;
            if (Array.isArray(value))
                return { from: value[0], to: value[1] };
            if (typeof value === 'string' && value.indexOf(',') >= 0) {
                const vArr = value.split(',');
                return { from: vArr[0], to: vArr[1] };
            }
            return value;
        }
        /** Когда PwStore шлёт событие об изменении нашего фильтра */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_updateView).call(this);
        }
        setOptions(value) {
            super.setOptions(value);
        }
        getValueString() {
            const value = this.getValue();
            if (!value)
                return '';
            return `${value.from},${value.to}`;
        }
        /**
         * Возвращает модель данных из значений. В секундах.
         * @returns
         */
        getValue() {
            return this.getValueOrigin();
        }
        /**
         * Возвращает массив (из двух значений) в минутах.
         * @returns
         */
        getValuesInMinutes() {
            const value = this.getValue();
            if (!value)
                return [0, 0]; // TODO: или в этом случае возвращать default значение? что ожидает принимающий?
            return [(value.from / 60), (value.to / 60)];
        }
        getValueOrigin() {
            const value = PwStore.GetFilter(this.options.filterName);
            if (!value)
                return { from: this.options.from, to: this.options.to };
            if (value && Array.isArray(value))
                return { from: value[0], to: value[1] };
            return value;
        }
        setValue(value, triggerChange = true) {
            PwStore.ChangeFilter(this.options.filterName || '', [value.from, value.to], triggerChange);
        }
        /**
         * Сериализованные данные контрола (как правило, для параметров поиска).
         * Котрол может отдавать множество ключ-значение.
         * @returns
         */
        serializeArray() {
            const params = [];
            const value = this.getValue();
            if (value != null) {
                params.push({
                    name: this.name,
                    value: this.getValueString(),
                });
            }
            return params;
        }
        /**
         * Сброс значения элемента управления в default-состояние.
        */
        reset() {
            PwStore.ResetFilterByName(this.options.filterName);
        }
        setRequired(isRequired) {
            this.valueInputRef.prop('required', isRequired);
        }
    }
    _a = MobileFilterTimeRangeBlock, _MobileFilterTimeRangeBlock_instances = new WeakSet(), _MobileFilterTimeRangeBlock_getDefaultValue = function _MobileFilterTimeRangeBlock_getDefaultValue() {
        if (this.valueInputRef.val())
            return _a.getValueByString(this.valueInputRef.val());
        if (this.options && this.options.defaultValue)
            return this.options.defaultValue;
        return _a.defaults.defaultValue || { from: 0, to: 86400 };
    }, _MobileFilterTimeRangeBlock_tooltipFormatValue = function _MobileFilterTimeRangeBlock_tooltipFormatValue(value) {
        if (!value)
            return __classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_formatValue).call(this, 0);
        const num = parseInt(value, 10);
        return __classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_formatValue).call(this, num);
    }, _MobileFilterTimeRangeBlock_formatValue = function _MobileFilterTimeRangeBlock_formatValue(value) {
        let str = '';
        const num = value || 0;
        const hours = Math.floor(num / 3600);
        const minutes = Math.floor((num % 3600) / 60);
        // TODO: format to options
        str = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        if (this.options.showSeconds) {
            const seconds = num - ((hours * 60 * 60) + (minutes * 60));
            str += `:${String(seconds).padStart(2, '0')}`;
        }
        return str;
    }, _MobileFilterTimeRangeBlock_refreshView = function _MobileFilterTimeRangeBlock_refreshView(value) {
        if (!value) {
            this.valueFromRef.html(__classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_formatValue).call(this, 0));
            this.valueToRef.html(__classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_formatValue).call(this, 0));
            this.valueInputRef.val('');
            this.validate(this.valueInputRef);
            return;
        }
        this.valueFromRef.html(__classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_formatValue).call(this, value.from));
        this.valueToRef.html(__classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_formatValue).call(this, value.to));
        const html = `${value.from},${value.to}`;
        this.valueInputRef.val(html);
        this.validate(this.valueInputRef);
    }, _MobileFilterTimeRangeBlock_updateView = function _MobileFilterTimeRangeBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterTimeRangeBlock_instances, "m", _MobileFilterTimeRangeBlock_refreshView).call(this, value);
    };
    /** Опции по-умолчанию, которые можно переопределить при инстанцировании */
    Object.defineProperty(MobileFilterTimeRangeBlock, "defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-time-range-block',
            filterKey: 'range', // ключ фильтра в PwStore
            defaultValue: { from: 0, to: 86400 },
            filterName: 'timeRangeFilter',
            title: 'Диапазон',
            min: 0,
            max: 86400,
            from: 0,
            to: 86400,
            step: 300,
            showSeconds: false,
            tooltipFormatterFn: function (val) { return val; },
        }
    });
    App.MobileFilterTimeRangeBlock = MobileFilterTimeRangeBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterToggleBlock_instances, _MobileFilterToggleBlock_valueCache, _MobileFilterToggleBlock_onEventClick, _MobileFilterToggleBlock_refreshView, _MobileFilterToggleBlock_updateView;
    class MobileFilterToggleBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(false, false, MobileFilterToggleBlock.s_defaults, options);
            _MobileFilterToggleBlock_instances.add(this);
            // NOTE: для получения актуального значения применять метод getValue (а это значение для внутреннего использования)
            _MobileFilterToggleBlock_valueCache.set(this, void 0);
            if (!this.root.length)
                return;
            // events
            this.root.on('click', e => __classPrivateFieldGet(this, _MobileFilterToggleBlock_instances, "m", _MobileFilterToggleBlock_onEventClick).call(this, e));
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterToggleBlock_instances, "m", _MobileFilterToggleBlock_updateView).call(this);
        }
        /**
         * Параметр по-умолчанию.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @returns
         */
        initDefaultValue() {
            __classPrivateFieldSet(this, _MobileFilterToggleBlock_valueCache, this.options ? (this.options.defaultValue || false) : false, "f");
            __classPrivateFieldSet(this, _MobileFilterToggleBlock_valueCache, (this.root.attr('data-value-default') && this.root.attr('data-value-default') == 'True') || __classPrivateFieldGet(this, _MobileFilterToggleBlock_valueCache, "f"), "f");
            return __classPrivateFieldGet(this, _MobileFilterToggleBlock_valueCache, "f");
        }
        /**
         * Значение по-умолчанию на основе json объекта.
         * Как правило при инициализации контрола данными из разметки.
         * Не все json могут привестись к нужному типу через as. Помогаем.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @param jsonValue
         * @returns
         */
        parseDefaultValue(jsonValue) {
            return jsonValue;
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterToggleBlock_instances, "m", _MobileFilterToggleBlock_updateView).call(this);
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            return this.getValue() ? 'true' : 'false';
        }
        getValue() {
            return this.getValueOrigin();
        }
        setValue(value, triggerChange = true) {
            // NOTE: не проверяем disable, т.к. выключен для пользователя только, а не для логики
            PwStore.ChangeFilter(this.options.filterKey || '', value, triggerChange);
        }
        /**
         * Переключение состояния тумблера.
         * Учитывается disable. Если необходимо обновить состояние у выключенного, то применить setValue.
         * @returns
         */
        toggle() {
            if (this.disabled)
                return;
            this.setValue(!__classPrivateFieldGet(this, _MobileFilterToggleBlock_valueCache, "f"));
        }
        /**
         * Список опций в формате для контрола на основе данных из ListOption[].
         * NOTE: новые данные не применяются в этот момент.
         * @param arrFrom
         * @returns
         */
        convertFromListOptions(arrFrom) {
            if (!arrFrom)
                return this.getDefaultValue();
            const itemFrom = arrFrom.find(f => f.text == this.name);
            if (!itemFrom)
                return this.getDefaultValue();
            if (itemFrom.selected == undefined)
                return this.getDefaultValue();
            return itemFrom.selected == true && itemFrom.value == 'true';
        }
    }
    _MobileFilterToggleBlock_valueCache = new WeakMap(), _MobileFilterToggleBlock_instances = new WeakSet(), _MobileFilterToggleBlock_onEventClick = function _MobileFilterToggleBlock_onEventClick(event) {
        event.preventDefault();
        if (this.disabled)
            return;
        this.toggle();
        // this.resetError();
    }, _MobileFilterToggleBlock_refreshView = function _MobileFilterToggleBlock_refreshView(value) {
        if (value)
            this.root.removeClass('toggle-input--off');
        else
            this.root.addClass('toggle-input--off');
        // TODO: валидировать аналогично как MobileFilterDateBlock?
    }, _MobileFilterToggleBlock_updateView = function _MobileFilterToggleBlock_updateView() {
        __classPrivateFieldSet(this, _MobileFilterToggleBlock_valueCache, this.getValue(), "f");
        __classPrivateFieldGet(this, _MobileFilterToggleBlock_instances, "m", _MobileFilterToggleBlock_refreshView).call(this, __classPrivateFieldGet(this, _MobileFilterToggleBlock_valueCache, "f"));
    };
    Object.defineProperty(MobileFilterToggleBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-toggle-block',
            title: 'Название',
            filterKey: 'noname',
            defaultValue: false,
        }
    });
    App.MobileFilterToggleBlock = MobileFilterToggleBlock;
})(App || (App = {}));
/// <reference path='MobileFilterBlockBase.ts' />
var App;
(function (App) {
    var _MobileFilterTouristsBlock_instances, _MobileFilterTouristsBlock_refreshView, _MobileFilterTouristsBlock_updateView, _MobileFilterTouristsBlock_correctOptions;
    class MobileFilterTouristsBlock extends App.MobileFilterBlockBase {
        constructor(options) {
            super(true, true, MobileFilterTouristsBlock.s_defaults, options);
            _MobileFilterTouristsBlock_instances.add(this);
            Object.defineProperty(this, "valueAdultsRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueChildrenRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueInputRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            }); // копия значения в инпут (для валидатора)
            if (!this.root.length)
                return;
            // render ref
            this.valueAdultsRef = $('.js-mobile-filter-value-adults', this.root);
            this.valueChildrenRef = $('.js-mobile-filter-value-children', this.root);
            this.valueInputRef = $('.js-mobile-filter-value-input', this.root);
            this.setInputValidateRef(this.valueInputRef);
            // corrections
            __classPrivateFieldGet(this, _MobileFilterTouristsBlock_instances, "m", _MobileFilterTouristsBlock_correctOptions).call(this);
            // filters
            PwStore.AddFilter(this.options.filterNameAdultCount, this.options.valueAdults);
            PwStore.AddFilter(this.options.filterNameChildrenCount, this.options.valueChildren);
            if (this.options.filterNameChildrenAges)
                PwStore.AddFilter(this.options.filterNameChildrenAges, this.options.valueChildAges);
            // show modal
            this.root.on('click', () => {
                if (this.disabled)
                    return;
                PwStore.OpenModal('tourists-filter', this.options);
            });
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            __classPrivateFieldGet(this, _MobileFilterTouristsBlock_instances, "m", _MobileFilterTouristsBlock_updateView).call(this);
        }
        /**
         * Параметр по-умолчанию.
         * NOTE: данный метод вызывается базовым конструктором - не использовать внутри методы инстанса.
         * @returns
         */
        initDefaultValue() {
            return undefined; // отдаем пустоту, чтобы базовый класс не инициализировал фильтры - мы их сами добавим
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                if (filterName == this.options.filterKey
                    || filterName == this.options.filterNameAdultCount
                    || filterName == this.options.filterNameChildrenCount
                    || filterName == this.options.filterNameChildrenAges
                    || filterName == PwStore.FILTER_ALL) { // если изменился наш фильтр (или все)
                    this.onChanged();
                    // оповестить нашего слушателя (страницу - будет делать новый поиск, например)
                    if (this.options.onChanged)
                        this.options.onChanged();
                }
            });
        }
        /**
         * Реакция на изменение нашего (или всех) фильтров.
         * Как правило контрол перерисовывает свою разметку (новое значание уже в this.getValueOrigin()).
         */
        onChanged() {
            __classPrivateFieldGet(this, _MobileFilterTouristsBlock_instances, "m", _MobileFilterTouristsBlock_updateView).call(this);
        }
        /**
         * Установка новых настроек.
         * @param value
         */
        setOptions(value) {
            super.setOptions(value);
            __classPrivateFieldGet(this, _MobileFilterTouristsBlock_instances, "m", _MobileFilterTouristsBlock_correctOptions).call(this);
        }
        /**
         * Отдаем свое текущее значение.
         * @returns
         */
        getValueString() {
            const value = this.getValue();
            // TODO: кто это использует, в каком виде надо??
            // рассчитываю по-умолчанию отдавать в виде:
            //  1,5,10 (взрослый, возраста детей), либо
            //  1,2 (взрослый, количество детей)
            if (!value)
                return '';
            const adultsStr = `${value.adults}`;
            if (value.children <= 0)
                return `${adultsStr}`;
            let childStr = '';
            if (!this.options.withChildAges)
                childStr += value.children;
            else if (value.childAges && value.childAges.length > 0)
                childStr += value.childAges.map(m => m).join(',');
            return `${adultsStr},${childStr}`;
        }
        getValue() {
            return this.getValueOrigin();
        }
        getValueOrigin() {
            const adults = PwStore.GetFilter(this.options.filterNameAdultCount);
            const children = PwStore.GetFilter(this.options.filterNameChildrenCount);
            const childAges = PwStore.GetFilterItems(this.options.filterNameChildrenAges || 'childAges', true);
            return { adults, children, childAges };
        }
        setValue(value, triggerChange = true) {
            var _a;
            // corrections
            if ((!value.children || value.children == 0) && (value.childAges && value.childAges.length > 0))
                value.children = value.childAges.length;
            // проверить возраст
            const correctChildrenAges = (_a = value.childAges) === null || _a === void 0 ? void 0 : _a.filter(v => v >= (this.options.childMinAge || 0)
                && v <= (this.options.childMaxAge || 17));
            // sets
            PwStore.ChangeFilter(this.options.filterNameAdultCount || '', value.adults, triggerChange);
            PwStore.ChangeFilter(this.options.filterNameChildrenCount || '', value.children, triggerChange);
            PwStore.ChangeFilter(this.options.filterNameChildrenAges || '', correctChildrenAges, triggerChange);
        }
        /**
         * Сериализованные данные контрола (как правило, для параметров поиска).
         * Котрол может отдавать множество ключ-значение.
         * @returns
         */
        serializeArray() {
            const params = [];
            const v = this.getValue();
            if (v != null) {
                // AdultCount
                params.push({
                    name: this.options.filterNameAdultCount,
                    value: v.adults.toString(),
                });
                // ChildCount
                const childCount = (v.children <= 0 && v.childAges && v.childAges.length > 0) ? v.childAges.length : v.children;
                if (childCount) {
                    params.push({
                        name: this.options.filterNameChildrenCount,
                        value: childCount.toString(),
                    });
                }
                // ChildAges
                if (v.childAges && v.childAges.length > 0) {
                    for (let i = 0; i < v.childAges.length; i++) {
                        params.push({
                            name: `${this.options.filterNameChildrenAges}[${i}]`,
                            value: `${(v.childAges[i] || '')}`,
                        });
                    }
                }
                // довешиваем неустановленные возраста детей (важно валидатору)
                // NOTE: сейчас ОТКЛЮЧЕНО, т.к. валидаторы не научены подсвечивать ощибку возвраста детей (кидает исключение)
                // NOTE: на данный момент так: указав 2 детей, и только одному возраст - мы будем видеть детей 2 указано счетчик,
                // но, по факту отправки формы будет отослан возраст только одного и посчитается, что указали одного! это не лучшее решение
                const withCheckChildAges = false; // TODO: научить валидатор отображать ошибку не указания возраста детей
                if (withCheckChildAges) {
                    const childAgesLength = (v.childAges ? v.childAges.length : 0);
                    if (v.children > childAgesLength) {
                        const childrenOut = v.children - childAgesLength;
                        for (let i = 0; i < childrenOut; i++) {
                            params.push({
                                name: `${this.options.filterNameChildrenAges}[${i + childAgesLength}]`,
                                value: '',
                            });
                        }
                    }
                }
            }
            return params;
        }
        /**
         * Сброс значения элемента управления в default-состояние.
        */
        reset() {
            PwStore.ResetFilterByName(this.options.filterNameAdultCount);
            PwStore.ResetFilterByName(this.options.filterNameChildrenCount);
            if (this.options.filterNameChildrenAges)
                PwStore.ResetFilterByName(this.options.filterNameChildrenAges);
        }
        setRequired(isRequired) {
            this.valueInputRef.prop('required', isRequired);
        }
    }
    _MobileFilterTouristsBlock_instances = new WeakSet(), _MobileFilterTouristsBlock_refreshView = function _MobileFilterTouristsBlock_refreshView(value) {
        var _a;
        if (!value) {
            // this.valueRef.html(this.options.emptyText);
            this.valueAdultsRef.html('0');
            this.valueChildrenRef.html('0');
            // для валидатора
            this.valueInputRef.val(''); // именно пустота кладется для валидатора
            this.validate(this.valueInputRef);
            return;
        }
        // correction
        // NOTE: а точно так всегда надо при рендере? может быть сценарий, когда нет детей,
        // NOTE: но возвраст детей указан и это важно отобразить?
        const children = ((!value.children || value.children == 0) && (value.childAges && value.childAges.length > 0))
            ? value.childAges.length : value.children;
        // рендер
        this.valueAdultsRef.html((_a = value.adults) === null || _a === void 0 ? void 0 : _a.toString());
        this.valueChildrenRef.html(children === null || children === void 0 ? void 0 : children.toString());
        // value.childAges
        // для валидатора (не понятно, как это валидировать)
        const html = `${value.adults},${children}`;
        this.valueInputRef.val(html);
        this.validate(this.valueInputRef);
    }, _MobileFilterTouristsBlock_updateView = function _MobileFilterTouristsBlock_updateView() {
        const value = this.getValue();
        __classPrivateFieldGet(this, _MobileFilterTouristsBlock_instances, "m", _MobileFilterTouristsBlock_refreshView).call(this, value);
    }, _MobileFilterTouristsBlock_correctOptions = function _MobileFilterTouristsBlock_correctOptions() {
        this.options.totalMaxCount = (!this.options.totalMaxCount || this.options.totalMaxCount <= 0) ? 99 : this.options.totalMaxCount;
        this.options.childMaxAge = (!this.options.childMaxAge || this.options.childMaxAge <= 0) ? 20 : this.options.childMaxAge;
        if ((!this.options.adultMaxCount || this.options.adultMaxCount <= 0)
            && (!this.options.childMaxCount || this.options.childMaxCount <= 0)) {
            this.options.adultMaxCount = 99;
            this.options.childMaxCount = 99;
        }
    };
    Object.defineProperty(MobileFilterTouristsBlock, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-tourists-block',
            title: 'Туристы',
            filterKey: 'tourists', // используется для обращения к контролу (названия фильтров в filterName..)
            defaultValue: { adults: 0, children: 0, childAges: [] },
            filterNameAdultCount: 'adults',
            filterNameChildrenCount: 'children',
            filterNameChildrenAges: 'childrenAges',
            adultMaxCount: 10,
            childMaxCount: 4,
            totalMaxCount: 0,
            childMinAge: 0,
            childMaxAge: 17,
            withChildAges: true,
            valueAdults: 0,
            valueChildren: 0,
            valueChildAges: [],
        }
    });
    App.MobileFilterTouristsBlock = MobileFilterTouristsBlock;
})(App || (App = {}));
var App;
(function (App) {
    var _MobileCustomContentModal_instances, _MobileCustomContentModal_refreshByHeader;
    class MobileCustomContentModal {
        /**
         * Фильтры через скрытый блок для отображения в кастомном модальном окне.
         * @param options
         * @returns
         */
        constructor(options) {
            _MobileCustomContentModal_instances.add(this);
            Object.defineProperty(this, "inited", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "options", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "clickRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "placerRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.options = Object.assign(Object.assign({}, MobileCustomContentModal.s_defaults), options);
            const { root } = this.options;
            if (typeof root === 'string')
                this.root = $(root);
            else
                this.root = root;
            if (!this.root.length)
                return;
            // флаг, чтобы видеть по разметке, что уже инициализирован (и не трогать внешкой)
            if (this.root.attr('flag-inited') == '1') {
                // NOTE: сбрасываем объект root, чтобы наследующий класс прекратил свою логику инициализации
                this.root = jQuery();
                return;
            }
            this.root.attr('flag-inited', '1');
            this.inited = true;
            // render ref
            this.placerRef = $('.js-moba-ctrl-customfilter-placer', this.root);
            // modal props
            const selector = this.options.contentSelector;
            const modalMeta = {
                key: this.options.modalKey,
                title: this.options.title,
                applyTitle: this.options.applyTitle,
                variant: (this.options.variant || 'window'),
                getContent: () => { return 'загрузка..'; },
                onRender: ($placer) => { $placer.html(''); $placer.append($(selector).clone(true)); },
                onApplyClick: () => { this.root.trigger('submit'); return false; },
            };
            // show modal
            this.clickRef = this.root;
            if (this.options.clickSelector) {
                const { clickSelector } = this.options;
                if (typeof clickSelector === 'string')
                    this.clickRef = $(clickSelector);
                else
                    this.clickRef = clickSelector;
            }
            if (this.clickRef) {
                this.clickRef.on('click', () => {
                    PwStore.OpenModal('custom-content-modal', modalMeta);
                });
            }
            // init filters
            if (this.options.withFilters) {
                this.filters = new App.FiltersMobileBase({
                    root: this.root,
                    ignoreValidator: false,
                    onFilterChanged: v => this.onFilterChanged(v),
                    triggerModalKey: this.options.modalKey,
                });
            }
            // PwStore.AddFilterListener(this); // => onFilterChanged
            PwStore.AddListener(this); // => onCommit
            // отображение в разметке уже имеющихся данных в фильтрах
            // на тот случай, если фильтр добавили уже давно, а мы (контрол) только добавились
            // this.updateView(true);
        }
        onCommit(eventName, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (eventName == 'header.visiblechanged') {
                    __classPrivateFieldGet(this, _MobileCustomContentModal_instances, "m", _MobileCustomContentModal_refreshByHeader).call(this);
                }
                else if (eventName == 'ui/triggerModal') {
                    if (this.options.modalKey == payload) {
                        if (this.clickRef) {
                            this.clickRef.trigger('click');
                        }
                    }
                }
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                // no-op
            });
        }
        nop() {
        }
    }
    _MobileCustomContentModal_instances = new WeakSet(), _MobileCustomContentModal_refreshByHeader = function _MobileCustomContentModal_refreshByHeader() {
        // if (this.refs.moba.states.isHeaderShown) this.refs.$sideBar.addClass("sidebar--header-shown-sticky");
        // else this.refs.$sideBar.removeClass("sidebar--header-shown-sticky");
    };
    Object.defineProperty(MobileCustomContentModal, "s_defaults", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            root: '.js-mobile-filter-date-block',
            title: '',
            variant: 'window',
            modalKey: 'my-custom-modal',
            contentSelector: '#modal-custom-my-filters',
            withFilters: false,
            applyTitle: '',
            onApplyClick: () => { },
        }
    });
    App.MobileCustomContentModal = MobileCustomContentModal;
})(App || (App = {}));
var App;
(function (App) {
    class DialogType {
        constructor(actionType, message, messageFree, prompt, promptPrivateFare, processMessage) {
            Object.defineProperty(this, "actionType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: actionType
            });
            Object.defineProperty(this, "message", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: message
            });
            Object.defineProperty(this, "messageFree", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: messageFree
            });
            Object.defineProperty(this, "prompt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: prompt
            });
            Object.defineProperty(this, "promptPrivateFare", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: promptPrivateFare
            });
            Object.defineProperty(this, "processMessage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: processMessage
            });
        }
    }
    App.DialogType = DialogType;
})(App || (App = {}));
/// <reference path='DialogType.ts' />
var App;
(function (App) {
    var _ActionDialog_instances, _a, _ActionDialog_root, _ActionDialog_invoker, _ActionDialog_actionType, _ActionDialog_customPrompt, _ActionDialog_dialogType, _ActionDialog_dialogForm, _ActionDialog_ccpElement, _ActionDialog_ccpAdditionalElementIds, _ActionDialog_confirmFormMessage0, _ActionDialog_confirmFormMessage, _ActionDialog_confirmFormMessage2, _ActionDialog_cancelRules, _ActionDialog_acceptCheckboxes, _ActionDialog_ccpConfirm, _ActionDialog_ccpAction, _ActionDialog_ccpClose, _ActionDialog_onConfirmCancellationRulesBlock, _ActionDialog_onCancelCancellationRulesBlock, _ActionDialog_dialogTypes, _ActionDialog_ccpInit, _ActionDialog_ccpEnableOkButton, _ActionDialog_toggleOkButton, _ActionDialog_findDialogType, _ActionDialog_blockButton, _ActionDialog_unblockButton, _ActionDialog_onCloseDialog, _ActionDialog_onConfirmDialog;
    let ActionType;
    (function (ActionType) {
        ActionType[ActionType["confirmation"] = 0] = "confirmation";
        ActionType[ActionType["cancellation"] = 1] = "cancellation";
        ActionType[ActionType["reprice"] = 2] = "reprice";
        ActionType[ActionType["preissue"] = 3] = "preissue";
        ActionType[ActionType["issue"] = 4] = "issue";
    })(ActionType = App.ActionType || (App.ActionType = {}));
    class ActionDialog {
        constructor(invoker, actionType, customPrompt, warningText) {
            _ActionDialog_instances.add(this);
            _ActionDialog_root.set(this, void 0);
            _ActionDialog_invoker.set(this, void 0);
            _ActionDialog_actionType.set(this, void 0);
            _ActionDialog_customPrompt.set(this, void 0);
            _ActionDialog_dialogType.set(this, void 0);
            _ActionDialog_dialogForm.set(this, void 0);
            _ActionDialog_ccpElement.set(this, void 0);
            _ActionDialog_ccpAdditionalElementIds.set(this, void 0);
            _ActionDialog_confirmFormMessage0.set(this, void 0);
            _ActionDialog_confirmFormMessage.set(this, void 0);
            _ActionDialog_confirmFormMessage2.set(this, void 0);
            _ActionDialog_cancelRules.set(this, void 0);
            _ActionDialog_acceptCheckboxes.set(this, void 0);
            _ActionDialog_ccpConfirm.set(this, void 0);
            _ActionDialog_ccpAction.set(this, void 0);
            _ActionDialog_ccpClose.set(this, void 0);
            _ActionDialog_onConfirmCancellationRulesBlock.set(this, void 0);
            _ActionDialog_onCancelCancellationRulesBlock.set(this, void 0);
            __classPrivateFieldSet(this, _ActionDialog_invoker, invoker, "f");
            __classPrivateFieldSet(this, _ActionDialog_actionType, actionType, "f");
            __classPrivateFieldSet(this, _ActionDialog_customPrompt, customPrompt, "f");
            __classPrivateFieldSet(this, _ActionDialog_dialogType, __classPrivateFieldGet(_a, _a, "m", _ActionDialog_findDialogType).call(_a, __classPrivateFieldGet(this, _ActionDialog_actionType, "f")), "f");
            __classPrivateFieldSet(this, _ActionDialog_root, __classPrivateFieldGet(this, _ActionDialog_invoker, "f").closest('.js-order-service-item'), "f");
            __classPrivateFieldSet(this, _ActionDialog_onConfirmCancellationRulesBlock, $('.js-onconfirm-cancellation-rule-container', __classPrivateFieldGet(this, _ActionDialog_root, "f"))
                .find('.js-cancellation-rule'), "f");
            __classPrivateFieldSet(this, _ActionDialog_onCancelCancellationRulesBlock, $('.js-oncancel-cancellation-rule-container', __classPrivateFieldGet(this, _ActionDialog_root, "f"))
                .find('.js-cancellation-rule'), "f");
            __classPrivateFieldSet(this, _ActionDialog_dialogForm, $(App.templates.Order.ActionDialog({
                prompt: __classPrivateFieldGet(this, _ActionDialog_dialogType, "f").prompt,
                customPrompt: __classPrivateFieldGet(this, _ActionDialog_customPrompt, "f"),
                warningText,
            })), "f");
            __classPrivateFieldSet(this, _ActionDialog_confirmFormMessage, $('#confirmFormMessage', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")), "f");
            __classPrivateFieldSet(this, _ActionDialog_confirmFormMessage0, $('#confirmFormMessage0', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")), "f");
            __classPrivateFieldSet(this, _ActionDialog_confirmFormMessage2, $('#confirmFormMessage2', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")), "f");
            __classPrivateFieldSet(this, _ActionDialog_cancelRules, $('#cancelRules', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")), "f");
            // берем штрафы из той же строки брони/услуги из элемента js-cancellation-rule из блока, соответствующего действию.
            let finalRules;
            if (__classPrivateFieldGet(this, _ActionDialog_actionType, "f") === ActionType.issue)
                finalRules = 'смотрите условия и штрафы';
            else if (__classPrivateFieldGet(this, _ActionDialog_actionType, "f") === ActionType.confirmation)
                finalRules = __classPrivateFieldGet(this, _ActionDialog_onConfirmCancellationRulesBlock, "f").html();
            else
                finalRules = __classPrivateFieldGet(this, _ActionDialog_onCancelCancellationRulesBlock, "f").html();
            if (finalRules)
                __classPrivateFieldGet(this, _ActionDialog_cancelRules, "f").html(finalRules);
            __classPrivateFieldSet(this, _ActionDialog_ccpConfirm, $('#ccpConfirm', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")), "f");
            __classPrivateFieldSet(this, _ActionDialog_ccpAction, $('#ccpAction', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")), "f");
            __classPrivateFieldGet(this, _ActionDialog_ccpAction, "f").val(__classPrivateFieldGet(this, _ActionDialog_dialogType, "f").processMessage);
            __classPrivateFieldGet(this, _ActionDialog_ccpAction, "f").hide();
            __classPrivateFieldSet(this, _ActionDialog_ccpClose, $('#ccpClose', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")), "f");
            __classPrivateFieldGet(this, _ActionDialog_ccpClose, "f").on('click', e => __classPrivateFieldGet(this, _ActionDialog_instances, "m", _ActionDialog_onCloseDialog).call(this, e));
            __classPrivateFieldGet(this, _ActionDialog_ccpConfirm, "f").on('click', () => __classPrivateFieldGet(this, _ActionDialog_instances, "m", _ActionDialog_onConfirmDialog).call(this));
            const showPrompt = __classPrivateFieldGet(this, _ActionDialog_actionType, "f") === ActionType.issue
                || (finalRules && finalRules.length > 0)
                || __classPrivateFieldGet(this, _ActionDialog_customPrompt, "f") !== undefined;
            if (!showPrompt)
                $('.toggleShow', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")).remove();
            __classPrivateFieldSet(this, _ActionDialog_acceptCheckboxes, [], "f");
            $.each(__classPrivateFieldGet(this, _ActionDialog_dialogForm, "f").find(':checkbox'), (index, item) => __classPrivateFieldGet(this, _ActionDialog_acceptCheckboxes, "f").push($(item)));
            $.each(__classPrivateFieldGet(this, _ActionDialog_acceptCheckboxes, "f"), (index, item) => $(item).on('click', () => __classPrivateFieldGet(this, _ActionDialog_instances, "m", _ActionDialog_ccpEnableOkButton).call(this)));
            const hasPrivateFare = __classPrivateFieldGet(this, _ActionDialog_invoker, "f").attr('data-has-private-fare') === 'true';
            __classPrivateFieldGet(this, _ActionDialog_instances, "m", _ActionDialog_ccpInit).call(this, !showPrompt, hasPrivateFare);
        }
        show() {
            const element = __classPrivateFieldGet(this, _ActionDialog_invoker, "f");
            const additionalElementIds = App.splitNonEmpty(element.attr('data-ids'));
            __classPrivateFieldSet(this, _ActionDialog_ccpElement, element, "f");
            __classPrivateFieldSet(this, _ActionDialog_ccpAdditionalElementIds, additionalElementIds, "f");
            __classPrivateFieldGet(_a, _a, "m", _ActionDialog_blockButton).call(_a, element);
            if (additionalElementIds) {
                for (let i = 0; i < additionalElementIds.length; i++)
                    __classPrivateFieldGet(_a, _a, "m", _ActionDialog_blockButton).call(_a, $(additionalElementIds[i]));
            }
            App.modalShow(__classPrivateFieldGet(this, _ActionDialog_dialogForm, "f"));
        }
        displayText(value) {
            __classPrivateFieldGet(this, _ActionDialog_confirmFormMessage, "f").text(value);
        }
        setConfirmButtonText(value) {
            __classPrivateFieldGet(this, _ActionDialog_ccpConfirm, "f").val(value);
        }
        changeContent(value) {
            $('.js-action-dialog-content-block', __classPrivateFieldGet(this, _ActionDialog_dialogForm, "f")).empty().append(value);
        }
    }
    _a = ActionDialog, _ActionDialog_root = new WeakMap(), _ActionDialog_invoker = new WeakMap(), _ActionDialog_actionType = new WeakMap(), _ActionDialog_customPrompt = new WeakMap(), _ActionDialog_dialogType = new WeakMap(), _ActionDialog_dialogForm = new WeakMap(), _ActionDialog_ccpElement = new WeakMap(), _ActionDialog_ccpAdditionalElementIds = new WeakMap(), _ActionDialog_confirmFormMessage0 = new WeakMap(), _ActionDialog_confirmFormMessage = new WeakMap(), _ActionDialog_confirmFormMessage2 = new WeakMap(), _ActionDialog_cancelRules = new WeakMap(), _ActionDialog_acceptCheckboxes = new WeakMap(), _ActionDialog_ccpConfirm = new WeakMap(), _ActionDialog_ccpAction = new WeakMap(), _ActionDialog_ccpClose = new WeakMap(), _ActionDialog_onConfirmCancellationRulesBlock = new WeakMap(), _ActionDialog_onCancelCancellationRulesBlock = new WeakMap(), _ActionDialog_instances = new WeakSet(), _ActionDialog_ccpInit = function _ActionDialog_ccpInit(checked, hasPrivateFare) {
        __classPrivateFieldGet(this, _ActionDialog_instances, "m", _ActionDialog_toggleOkButton).call(this);
        // title
        __classPrivateFieldGet(this, _ActionDialog_confirmFormMessage0, "f").text(__classPrivateFieldGet(this, _ActionDialog_dialogType, "f").message);
        // sub-title
        __classPrivateFieldGet(this, _ActionDialog_confirmFormMessage, "f").text((__classPrivateFieldGet(this, _ActionDialog_actionType, "f") === ActionType.cancellation)
            && checked ? __classPrivateFieldGet(this, _ActionDialog_dialogType, "f").messageFree : '');
        // content
        __classPrivateFieldGet(this, _ActionDialog_confirmFormMessage2, "f")
            .text(__classPrivateFieldGet(this, _ActionDialog_dialogType, "f").promptPrivateFare)
            .toggle(hasPrivateFare && __classPrivateFieldGet(this, _ActionDialog_dialogType, "f").promptPrivateFare != null);
    }, _ActionDialog_ccpEnableOkButton = function _ActionDialog_ccpEnableOkButton() {
        __classPrivateFieldGet(this, _ActionDialog_instances, "m", _ActionDialog_toggleOkButton).call(this);
    }, _ActionDialog_toggleOkButton = function _ActionDialog_toggleOkButton() {
        const checked = __classPrivateFieldGet(this, _ActionDialog_acceptCheckboxes, "f").length <= 0 || Enumerable.from(__classPrivateFieldGet(this, _ActionDialog_acceptCheckboxes, "f")).all(v => $(v).is(':checked'));
        __classPrivateFieldGet(this, _ActionDialog_ccpConfirm, "f")
            .prop('disabled', !checked)
            .css({ 'cursor': (checked ? 'pointer' : 'not-allowed') });
    }, _ActionDialog_findDialogType = function _ActionDialog_findDialogType(actionType) {
        return __classPrivateFieldGet(_a, _a, "f", _ActionDialog_dialogTypes).filter(v => v.actionType === actionType)[0];
    }, _ActionDialog_blockButton = function _ActionDialog_blockButton(element) {
        const jqobj = $(element);
        if (!jqobj.data('old-value'))
            jqobj.data('old-value', jqobj.val() || '');
        jqobj
            .prop('disabled', true)
            .addClass('button-wait');
    }, _ActionDialog_unblockButton = function _ActionDialog_unblockButton(element) {
        const jqobj = $(element);
        const value = jqobj.attr('data-old-value');
        if (value)
            jqobj.val(value);
        jqobj
            .prop('disabled', false)
            .removeClass('button-wait');
    }, _ActionDialog_onCloseDialog = function _ActionDialog_onCloseDialog(event) {
        const target = $(event.currentTarget);
        if (!__classPrivateFieldGet(this, _ActionDialog_ccpElement, "f"))
            return;
        __classPrivateFieldGet(_a, _a, "m", _ActionDialog_unblockButton).call(_a, __classPrivateFieldGet(this, _ActionDialog_ccpElement, "f"));
        if (__classPrivateFieldGet(this, _ActionDialog_ccpAdditionalElementIds, "f")) {
            for (let i = 0; i < __classPrivateFieldGet(this, _ActionDialog_ccpAdditionalElementIds, "f").length; i++)
                __classPrivateFieldGet(_a, _a, "m", _ActionDialog_unblockButton).call(_a, $(__classPrivateFieldGet(this, _ActionDialog_ccpAdditionalElementIds, "f")[i]));
        }
        __classPrivateFieldGet(_a, _a, "m", _ActionDialog_unblockButton).call(_a, target);
        __classPrivateFieldSet(this, _ActionDialog_ccpElement, null, "f");
        __classPrivateFieldSet(this, _ActionDialog_ccpAdditionalElementIds, null, "f");
        App.popupHide();
    }, _ActionDialog_onConfirmDialog = function _ActionDialog_onConfirmDialog() {
        if (!__classPrivateFieldGet(this, _ActionDialog_ccpElement, "f"))
            return;
        if (__classPrivateFieldGet(this, _ActionDialog_dialogType, "f").processMessage) {
            __classPrivateFieldGet(this, _ActionDialog_ccpClose, "f").hide();
            __classPrivateFieldGet(this, _ActionDialog_ccpConfirm, "f").hide();
            __classPrivateFieldGet(this, _ActionDialog_ccpAction, "f").show();
        }
        __classPrivateFieldGet(_a, _a, "m", _ActionDialog_blockButton).call(_a, __classPrivateFieldGet(this, _ActionDialog_ccpElement, "f"));
        if (__classPrivateFieldGet(this, _ActionDialog_ccpAdditionalElementIds, "f")) {
            for (let i = 0; i < __classPrivateFieldGet(this, _ActionDialog_ccpAdditionalElementIds, "f").length; i++)
                __classPrivateFieldGet(_a, _a, "m", _ActionDialog_blockButton).call(_a, $(__classPrivateFieldGet(this, _ActionDialog_ccpAdditionalElementIds, "f")[i]));
        }
        // нужно в случае отказа при подтверждении
        __classPrivateFieldGet(_a, _a, "m", _ActionDialog_unblockButton).call(_a, __classPrivateFieldGet(this, _ActionDialog_ccpElement, "f"));
        __classPrivateFieldSet(this, _ActionDialog_ccpElement, null, "f");
        __classPrivateFieldSet(this, _ActionDialog_ccpAdditionalElementIds, null, "f");
        const serviceKey = __classPrivateFieldGet(this, _ActionDialog_root, "f").attr('data-key');
        __classPrivateFieldGet(this, _ActionDialog_invoker, "f").trigger("action:continue" /* Events.ActionContinue */, [__classPrivateFieldGet(this, _ActionDialog_invoker, "f"), serviceKey, __classPrivateFieldGet(this, _ActionDialog_actionType, "f")]);
    };
    _ActionDialog_dialogTypes = { value: [
            new App.DialogType(ActionType.cancellation, 'Аннуляция брони', 'Бронь будет аннулирована без удержаний', 'Принимаю условия по удержаниям', 'Для туристов выписан билет по спецтарифу. По правилам данного тарифа при посадке на рейс турист обязан предоставить ваучер на проживание', 'Выполняется аннуляция...'),
            new App.DialogType(ActionType.confirmation, 'Подтверждение брони', '', 'Принимаю условия по удержаниям', '', 'Выполняется подтверждение...'),
            new App.DialogType(ActionType.reprice, 'Обновление стоимости', '', '', '', 'Операция выполняется...'),
            new App.DialogType(ActionType.preissue, '', '', '', '', ''),
            new App.DialogType(ActionType.issue, 'Выписка авиабилета', '', 'Принимаю условия авиакомпании', 'Билет забронирован по спецтарифу, проверьте у туриста наличие проживания на даты перелета', 'Производится выписка авиабилета...'),
        ] };
    App.ActionDialog = ActionDialog;
})(App || (App = {}));
var App;
(function (App) {
    var _OrderListPageMobile_instances, _a, _OrderListPageMobile_options, _OrderListPageMobile_searchExecuting, _OrderListPageMobile_currentPosition, _OrderListPageMobile_preloader, _OrderListPageMobile_filter, _OrderListPageMobile_searchXhr, _OrderListPageMobile_orderHeader, _OrderListPageMobile_outputBlock, _OrderListPageMobile_orderBlocks, _OrderListPageMobile_foundBlock, _OrderListPageMobile_notFoundBlock, _OrderListPageMobile_currentPageSize, _OrderListPageMobile_currentPageIndex, _OrderListPageMobile_sortBy, _OrderListPageMobile_sortDir, _OrderListPageMobile_showMoreBlock, _OrderListPageMobile_showMoreLink, _OrderListPageMobile_showMoreCurrent, _OrderListPageMobile_showMoreCountSelected, _OrderListPageMobile_showMoreCountOption, _OrderListPageMobile_showMoreTotal, _OrderListPageMobile_totalCount, _OrderListPageMobile_showCount, _OrderListPageMobile_sortingBlock, _OrderListPageMobile_export2excelBlock, _OrderListPageMobile_exportXhr, _OrderListPageMobile_popupInfo, _OrderListPageMobile_showQualityControl, _OrderListPageMobile_export2Excel, _OrderListPageMobile_initShowMoreBlock, _OrderListPageMobile_resetData, _OrderListPageMobile_onSearch, _OrderListPageMobile_onSearchBefore, _OrderListPageMobile_onSearchDone, _OrderListPageMobile_appendData, _OrderListPageMobile_onSearchAlways, _OrderListPageMobile_onShowMoreOrders, _OrderListPageMobile_onShowMoreBefore, _OrderListPageMobile_onShowMoreDone, _OrderListPageMobile_onShowMoreAlways, _OrderListPageMobile_doSearch, _OrderListPageMobile_changePageSize, _OrderListPageMobile_sortOrders, _OrderListPageMobile_onSortingBefore, _OrderListPageMobile_onSortingDone, _OrderListPageMobile_onSortingAlways, _OrderListPageMobile_onScheduleClick, _OrderListPageMobile_getCruiseSchedule, _OrderListPageMobile_onVipStatusShow;
    class OrderListPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-order-list-page' }, options));
            _OrderListPageMobile_instances.add(this);
            _OrderListPageMobile_options.set(this, void 0);
            _OrderListPageMobile_searchExecuting.set(this, false);
            _OrderListPageMobile_currentPosition.set(this, void 0);
            _OrderListPageMobile_preloader.set(this, void 0);
            _OrderListPageMobile_filter.set(this, void 0);
            _OrderListPageMobile_searchXhr.set(this, void 0);
            _OrderListPageMobile_orderHeader.set(this, void 0);
            _OrderListPageMobile_outputBlock.set(this, void 0);
            _OrderListPageMobile_orderBlocks.set(this, void 0);
            _OrderListPageMobile_foundBlock.set(this, void 0);
            _OrderListPageMobile_notFoundBlock.set(this, void 0);
            _OrderListPageMobile_currentPageSize.set(this, void 0);
            _OrderListPageMobile_currentPageIndex.set(this, void 0);
            _OrderListPageMobile_sortBy.set(this, void 0);
            _OrderListPageMobile_sortDir.set(this, void 0);
            _OrderListPageMobile_showMoreBlock.set(this, void 0);
            _OrderListPageMobile_showMoreLink.set(this, void 0);
            _OrderListPageMobile_showMoreCurrent.set(this, void 0);
            _OrderListPageMobile_showMoreCountSelected.set(this, void 0);
            _OrderListPageMobile_showMoreCountOption.set(this, void 0);
            _OrderListPageMobile_showMoreTotal.set(this, void 0);
            _OrderListPageMobile_totalCount.set(this, void 0);
            // сколько показано.
            _OrderListPageMobile_showCount.set(this, void 0);
            _OrderListPageMobile_sortingBlock.set(this, void 0);
            _OrderListPageMobile_export2excelBlock.set(this, void 0);
            _OrderListPageMobile_exportXhr.set(this, void 0);
            _OrderListPageMobile_popupInfo.set(this, void 0);
            __classPrivateFieldSet(this, _OrderListPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _OrderListPageMobile_orderHeader, $('.js-orders-output-head', this.root), "f");
            __classPrivateFieldGet(this, _OrderListPageMobile_orderHeader, "f").toggle(__classPrivateFieldGet(this, _OrderListPageMobile_options, "f").totalCount > 0);
            __classPrivateFieldSet(this, _OrderListPageMobile_foundBlock, $('.js-result-found', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_notFoundBlock, $('.js-result-not-found', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_currentPageIndex, __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").pageIndex, "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_currentPageSize, __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").pageSize, "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_showCount, __classPrivateFieldGet(this, _OrderListPageMobile_currentPageSize, "f"), "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_sortBy, __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").sortBy, "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_sortDir, __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").sortDir, "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_filter, new App.OrderListFilterMobile({
                datesOptions: {
                    keepEmpty: true,
                    // если не ставить минимальную дату, то она ставится текущей датой
                    minDateFromShift: App.OrderListFilterMobile.checkinMinDateShift,
                    preserveDatesOffset: false,
                },
                findPartnerManagersUrl: __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").urls.findPartnerManagers,
            }), "f");
            __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSearch).call(this, e, data); }));
            __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").setPaging(__classPrivateFieldGet(this, _OrderListPageMobile_currentPageIndex, "f"), __classPrivateFieldGet(this, _OrderListPageMobile_currentPageSize, "f"));
            __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").setSorting(__classPrivateFieldGet(this, _OrderListPageMobile_sortBy, "f"), __classPrivateFieldGet(this, _OrderListPageMobile_sortDir, "f"));
            __classPrivateFieldSet(this, _OrderListPageMobile_preloader, new App.Preloader(), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _OrderListPageMobile_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_initShowMoreBlock).call(this);
            __classPrivateFieldSet(this, _OrderListPageMobile_outputBlock, $('.js-orders-output', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_orderBlocks, $('.js-order', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_totalCount, $('.js-filter-totalcount', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPageMobile_sortingBlock, $('.js-orders-sort-items', this.root), "f");
            __classPrivateFieldGet(this, _OrderListPageMobile_sortingBlock, "f").toggle(__classPrivateFieldGet(this, _OrderListPageMobile_options, "f").totalCount > 0);
            $.each($('.js-sort-item', __classPrivateFieldGet(this, _OrderListPageMobile_sortingBlock, "f")), (index, item) => {
                $(item).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_sortOrders).call(this, e); }));
            });
            __classPrivateFieldSet(this, _OrderListPageMobile_export2excelBlock, $('.js-export2excel', this.root), "f");
            __classPrivateFieldGet(this, _OrderListPageMobile_export2excelBlock, "f").on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_export2Excel).call(this); }));
            __classPrivateFieldGet(this, _OrderListPageMobile_outputBlock, "f").on('click', '.js-show_qualityControlForm', e => __classPrivateFieldGet(_a, _a, "m", _OrderListPageMobile_showQualityControl).call(_a, e));
            __classPrivateFieldGet(this, _OrderListPageMobile_outputBlock, "f").on('click', '.js-show-schedule', (e) => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onScheduleClick).call(this, e));
            $(document).on("booking-conditions:show" /* Events.BookingConditionsShow */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onVipStatusShow).call(this, e); }));
        }
    }
    _a = OrderListPageMobile, _OrderListPageMobile_options = new WeakMap(), _OrderListPageMobile_searchExecuting = new WeakMap(), _OrderListPageMobile_currentPosition = new WeakMap(), _OrderListPageMobile_preloader = new WeakMap(), _OrderListPageMobile_filter = new WeakMap(), _OrderListPageMobile_searchXhr = new WeakMap(), _OrderListPageMobile_orderHeader = new WeakMap(), _OrderListPageMobile_outputBlock = new WeakMap(), _OrderListPageMobile_orderBlocks = new WeakMap(), _OrderListPageMobile_foundBlock = new WeakMap(), _OrderListPageMobile_notFoundBlock = new WeakMap(), _OrderListPageMobile_currentPageSize = new WeakMap(), _OrderListPageMobile_currentPageIndex = new WeakMap(), _OrderListPageMobile_sortBy = new WeakMap(), _OrderListPageMobile_sortDir = new WeakMap(), _OrderListPageMobile_showMoreBlock = new WeakMap(), _OrderListPageMobile_showMoreLink = new WeakMap(), _OrderListPageMobile_showMoreCurrent = new WeakMap(), _OrderListPageMobile_showMoreCountSelected = new WeakMap(), _OrderListPageMobile_showMoreCountOption = new WeakMap(), _OrderListPageMobile_showMoreTotal = new WeakMap(), _OrderListPageMobile_totalCount = new WeakMap(), _OrderListPageMobile_showCount = new WeakMap(), _OrderListPageMobile_sortingBlock = new WeakMap(), _OrderListPageMobile_export2excelBlock = new WeakMap(), _OrderListPageMobile_exportXhr = new WeakMap(), _OrderListPageMobile_popupInfo = new WeakMap(), _OrderListPageMobile_instances = new WeakSet(), _OrderListPageMobile_showQualityControl = function _OrderListPageMobile_showQualityControl(event) {
        const self = $(event.currentTarget);
        const action = self.attr('data-action');
        if (action)
            window.location.href = action;
        return true;
    }, _OrderListPageMobile_export2Excel = function _OrderListPageMobile_export2Excel() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _OrderListPageMobile_exportXhr, $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").urls.export,
                method: 'POST',
                data: __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").getData(),
                xhrFields: {
                    responseType: 'blob',
                },
                beforeSend: () => __classPrivateFieldGet(this, _OrderListPageMobile_preloader, "f").show(),
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _OrderListPageMobile_exportXhr, "f");
                if (!response)
                    return;
                const contentType = 'application/vnd.ms-excel';
                const blob = new Blob([response], { type: contentType });
                const anchor = document.createElement('a');
                anchor.download = 'orders.xlsx';
                anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
                anchor.dataset.downloadurl = ['application/vnd.ms-excel', anchor.download, anchor.href].join(':');
                anchor.click();
            }
            catch (e) {
                console.log(e);
            }
            finally {
                __classPrivateFieldGet(this, _OrderListPageMobile_preloader, "f").hide();
            }
        });
    }, _OrderListPageMobile_initShowMoreBlock = function _OrderListPageMobile_initShowMoreBlock() {
        __classPrivateFieldSet(this, _OrderListPageMobile_showMoreBlock, $('.js-show-more-block', this.root), "f");
        __classPrivateFieldSet(this, _OrderListPageMobile_showMoreLink, $('.js-show-more-link', __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPageMobile_showMoreCurrent, $('.js-show-more-current', __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPageMobile_showMoreCountSelected, $('.js-show-count-selected', __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPageMobile_showMoreCountOption, $('.js-show-count-option', __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPageMobile_showMoreTotal, $('.js-show-more-total', __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f")), "f");
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreLink, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onShowMoreOrders).call(this, e); }));
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreCountOption, "f").on('click', e => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_changePageSize).call(this, e));
        const leftToShow = __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").totalCount - __classPrivateFieldGet(this, _OrderListPageMobile_showCount, "f");
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreTotal, "f").text(leftToShow);
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f").toggleByClass(leftToShow > 0);
    }, _OrderListPageMobile_resetData = function _OrderListPageMobile_resetData() {
        __classPrivateFieldSet(this, _OrderListPageMobile_currentPageIndex, 0, "f");
        __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").setPaging(__classPrivateFieldGet(this, _OrderListPageMobile_currentPageIndex, "f"), __classPrivateFieldGet(this, _OrderListPageMobile_currentPageSize, "f"));
        // TODO: нужно ли сбрасывать сортировку??
        /* this.sortBy = 'CreateDate';
        this.sortDir = 'Desc';
        this.filter.setSorting(this.sortBy, this.sortDir);*/
    }, _OrderListPageMobile_onSearch = function _OrderListPageMobile_onSearch(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-debugger
            debugger;
            if (!data || __classPrivateFieldGet(this, _OrderListPageMobile_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderListPageMobile_searchExecuting, true, "f");
            yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_doSearch).call(this, data, () => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSearchBefore).call(this), v => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSearchDone).call(this, v), () => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSearchAlways).call(this));
        });
    }, _OrderListPageMobile_onSearchBefore = function _OrderListPageMobile_onSearchBefore() {
        __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_resetData).call(this);
        __classPrivateFieldGet(this, _OrderListPageMobile_preloader, "f").show();
    }, _OrderListPageMobile_onSearchDone = function _OrderListPageMobile_onSearchDone(data) {
        if (data)
            __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_appendData).call(this, data.output, data.totalCount);
    }, _OrderListPageMobile_appendData = function _OrderListPageMobile_appendData(data, totalCount, clearBefore = true) {
        if (clearBefore) {
            __classPrivateFieldGet(this, _OrderListPageMobile_outputBlock, "f").empty(); /* .not('.js-no-ajax-output')*/
            __classPrivateFieldSet(this, _OrderListPageMobile_showCount, __classPrivateFieldGet(this, _OrderListPageMobile_currentPageSize, "f"), "f");
        }
        else {
            __classPrivateFieldSet(this, _OrderListPageMobile_showCount, __classPrivateFieldGet(this, _OrderListPageMobile_showCount, "f") + __classPrivateFieldGet(this, _OrderListPageMobile_currentPageSize, "f"), "f");
        }
        const found = totalCount > 0;
        __classPrivateFieldGet(this, _OrderListPageMobile_orderHeader, "f").toggle(found);
        __classPrivateFieldGet(this, _OrderListPageMobile_sortingBlock, "f").toggle(found);
        __classPrivateFieldGet(this, _OrderListPageMobile_foundBlock, "f").toggle(found);
        __classPrivateFieldGet(this, _OrderListPageMobile_notFoundBlock, "f").toggle(!found);
        const leftToShow = totalCount - __classPrivateFieldGet(this, _OrderListPageMobile_showCount, "f");
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f").toggleByClass(leftToShow > 0);
        if (found) {
            __classPrivateFieldGet(this, _OrderListPageMobile_outputBlock, "f").append(data);
            __classPrivateFieldGet(this, _OrderListPageMobile_totalCount, "f").text(`${totalCount} ${App.pluralRu(totalCount, 'заказ', 'заказа', 'заказов')}`);
            __classPrivateFieldGet(this, _OrderListPageMobile_showMoreTotal, "f").text(leftToShow);
            __classPrivateFieldSet(this, _OrderListPageMobile_orderBlocks, $('.js-order', __classPrivateFieldGet(this, _OrderListPageMobile_outputBlock, "f")), "f");
            __classPrivateFieldGet(this, _OrderListPageMobile_orderBlocks, "f").removeClass('_hidden');
            __classPrivateFieldGet(this, _OrderListPageMobile_showMoreCurrent, "f").text(Math.min(__classPrivateFieldGet(this, _OrderListPageMobile_currentPageSize, "f"), leftToShow));
        }
    }, _OrderListPageMobile_onSearchAlways = function _OrderListPageMobile_onSearchAlways() {
        __classPrivateFieldGet(this, _OrderListPageMobile_preloader, "f").hide();
        __classPrivateFieldSet(this, _OrderListPageMobile_searchExecuting, false, "f");
    }, _OrderListPageMobile_onShowMoreOrders = function _OrderListPageMobile_onShowMoreOrders(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const self = $(event.currentTarget);
            const selfOffset = self.offset();
            __classPrivateFieldSet(this, _OrderListPageMobile_currentPosition, selfOffset != null ? selfOffset.top : 0, "f");
            __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f").addClass('_pulsate');
            __classPrivateFieldSet(this, _OrderListPageMobile_currentPageIndex, (_b = __classPrivateFieldGet(this, _OrderListPageMobile_currentPageIndex, "f"), _b++, _b), "f");
            __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").setPaging(__classPrivateFieldGet(this, _OrderListPageMobile_currentPageIndex, "f"), __classPrivateFieldGet(this, _OrderListPageMobile_currentPageSize, "f"));
            yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_doSearch).call(this, __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").getData(), () => __classPrivateFieldGet(_a, _a, "m", _OrderListPageMobile_onShowMoreBefore).call(_a), v => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onShowMoreDone).call(this, v), () => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onShowMoreAlways).call(this));
        });
    }, _OrderListPageMobile_onShowMoreBefore = function _OrderListPageMobile_onShowMoreBefore() {
    }, _OrderListPageMobile_onShowMoreDone = function _OrderListPageMobile_onShowMoreDone(data) {
        if (data) {
            __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_appendData).call(this, data.output, data.totalCount, false);
            if (__classPrivateFieldGet(this, _OrderListPageMobile_currentPosition, "f"))
                $('html, body').animate({ scrollTop: __classPrivateFieldGet(this, _OrderListPageMobile_currentPosition, "f") - 50 }, 'slow');
        }
    }, _OrderListPageMobile_onShowMoreAlways = function _OrderListPageMobile_onShowMoreAlways() {
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreBlock, "f").removeClass('_pulsate');
    }, _OrderListPageMobile_doSearch = function _OrderListPageMobile_doSearch(data, beforeCallback, doneCallback, alwaysCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _OrderListPageMobile_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").urls.search,
                method: 'POST',
                data,
                beforeSend: () => beforeCallback(),
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _OrderListPageMobile_searchXhr, "f");
                if (!response)
                    return;
                // TODO: обрабатывать результат 'Вариантов, соответствующих заданным критериям, нет.'
                if (!response.status.success || response.data == null)
                    return;
                if (response.redirect)
                    window.location.href = response.redirect;
                doneCallback(response.data);
            }
            catch (ex) {
                // Запрос не удался
                console.log(ex);
            }
            finally {
                alwaysCallback();
            }
        });
    }, _OrderListPageMobile_changePageSize = function _OrderListPageMobile_changePageSize(event) {
        const target = $(event.currentTarget);
        __classPrivateFieldSet(this, _OrderListPageMobile_currentPageSize, parseInt(target.text(), 10), "f");
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreCountOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreCountSelected, "f").text(target.text());
        __classPrivateFieldGet(this, _OrderListPageMobile_showMoreCurrent, "f").text(target.text());
    }, _OrderListPageMobile_sortOrders = function _OrderListPageMobile_sortOrders(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.currentTarget);
            target.siblings().removeClass('_active');
            target.toggleClass('_sort-up _sort-down');
            target.addClass('_active');
            __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_resetData).call(this);
            __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").setSorting((_b = target.attr('data-code')) !== null && _b !== void 0 ? _b : '', target.hasClass('_sort-up') ? 'Asc' : 'Desc');
            yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_doSearch).call(this, __classPrivateFieldGet(this, _OrderListPageMobile_filter, "f").getData(), () => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSortingBefore).call(this), v => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSortingDone).call(this, v), () => __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSortingAlways).call(this));
        });
    }, _OrderListPageMobile_onSortingBefore = function _OrderListPageMobile_onSortingBefore() {
        // сброс параметров нужно делать ДО получения данных getData()
        __classPrivateFieldGet(this, _OrderListPageMobile_preloader, "f").show();
    }, _OrderListPageMobile_onSortingDone = function _OrderListPageMobile_onSortingDone(data) {
        __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSearchDone).call(this, data);
    }, _OrderListPageMobile_onSortingAlways = function _OrderListPageMobile_onSortingAlways() {
        __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_onSearchAlways).call(this);
    }, _OrderListPageMobile_onScheduleClick = function _OrderListPageMobile_onScheduleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _OrderListPageMobile_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _OrderListPageMobile_popupInfo, new App.PopupOld({
            content: $('<div class="js-cruise-schedule cruise-schedule user-content"><div style="padding:10px;"><img src="/img/main/load-sm.gif"/></div></div>'),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _OrderListPageMobile_instances, "m", _OrderListPageMobile_getCruiseSchedule).call(this, (_b = $(event.currentTarget).attr('data-ordernumber')) !== null && _b !== void 0 ? _b : ''); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _OrderListPageMobile_getCruiseSchedule = function _OrderListPageMobile_getCruiseSchedule(orderNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").urls.getCruiseSchedule,
                method: 'POST',
                data: { orderNumber: orderNumber },
            });
            const response = yield xhr;
            if (!response || !response.status.success || response.data == null) {
                App.popupHide();
                return;
            }
            let blockDescr = $('<div>Расписание будет позже.</div>');
            if (response && response.data && response.data.item) {
                blockDescr = $(App.templates.Order.CruiseSchedule({ scheduleData: response.data.item }));
            }
            $('.js-cruise-schedule', $('.js-popup')).empty().append(blockDescr);
        });
    }, _OrderListPageMobile_onVipStatusShow = function _OrderListPageMobile_onVipStatusShow(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            e.preventDefault();
            e.stopPropagation();
            const targetElement = $(e.target).parents('.js-show-cancellation-conditions');
            const key = parseInt((_b = targetElement.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPageMobile_options, "f").urls.getVipStatus,
                method: 'POST',
                data: { key: key },
            });
            const response = yield xhr;
            if (response && response.data && response.data.item.description.length > 0) {
                const blockDescr = $(App.templates.Order.VipStatus({ data: response.data.item }));
                targetElement.find('.js-reserve-info-block-info').empty().append(blockDescr);
            }
        });
    };
    App.OrderListPageMobile = OrderListPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _OrderListPage_instances, _a, _OrderListPage_options, _OrderListPage_searchExecuting, _OrderListPage_currentPosition, _OrderListPage_preloader, _OrderListPage_filter, _OrderListPage_searchXhr, _OrderListPage_orderHeader, _OrderListPage_outputBlock, _OrderListPage_orderBlocks, _OrderListPage_foundBlock, _OrderListPage_notFoundBlock, _OrderListPage_currentPageSize, _OrderListPage_currentPageIndex, _OrderListPage_sortBy, _OrderListPage_sortDir, _OrderListPage_showMoreBlock, _OrderListPage_showMoreLink, _OrderListPage_showMoreCurrent, _OrderListPage_showMoreCountSelected, _OrderListPage_showMoreCountOption, _OrderListPage_showMoreTotal, _OrderListPage_totalCount, _OrderListPage_showCount, _OrderListPage_sortingBlock, _OrderListPage_export2excelBlock, _OrderListPage_exportXhr, _OrderListPage_popupInfo, _OrderListPage_showQualityControl, _OrderListPage_export2Excel, _OrderListPage_initShowMoreBlock, _OrderListPage_resetData, _OrderListPage_onSearch, _OrderListPage_onSearchBefore, _OrderListPage_onSearchDone, _OrderListPage_appendData, _OrderListPage_onSearchAlways, _OrderListPage_onShowMoreOrders, _OrderListPage_onShowMoreBefore, _OrderListPage_onShowMoreDone, _OrderListPage_onShowMoreAlways, _OrderListPage_doSearch, _OrderListPage_changePageSize, _OrderListPage_sortOrders, _OrderListPage_onSortingBefore, _OrderListPage_onSortingDone, _OrderListPage_onSortingAlways, _OrderListPage_onScheduleClick, _OrderListPage_getCruiseSchedule, _OrderListPage_onVipStatusShow;
    class OrderListPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-order-list-page' }, options));
            _OrderListPage_instances.add(this);
            _OrderListPage_options.set(this, void 0);
            _OrderListPage_searchExecuting.set(this, false);
            _OrderListPage_currentPosition.set(this, void 0);
            _OrderListPage_preloader.set(this, void 0);
            _OrderListPage_filter.set(this, void 0);
            _OrderListPage_searchXhr.set(this, void 0);
            _OrderListPage_orderHeader.set(this, void 0);
            _OrderListPage_outputBlock.set(this, void 0);
            _OrderListPage_orderBlocks.set(this, void 0);
            _OrderListPage_foundBlock.set(this, void 0);
            _OrderListPage_notFoundBlock.set(this, void 0);
            _OrderListPage_currentPageSize.set(this, void 0);
            _OrderListPage_currentPageIndex.set(this, void 0);
            _OrderListPage_sortBy.set(this, void 0);
            _OrderListPage_sortDir.set(this, void 0);
            _OrderListPage_showMoreBlock.set(this, void 0);
            _OrderListPage_showMoreLink.set(this, void 0);
            _OrderListPage_showMoreCurrent.set(this, void 0);
            _OrderListPage_showMoreCountSelected.set(this, void 0);
            _OrderListPage_showMoreCountOption.set(this, void 0);
            _OrderListPage_showMoreTotal.set(this, void 0);
            _OrderListPage_totalCount.set(this, void 0);
            // сколько показано.
            _OrderListPage_showCount.set(this, void 0);
            _OrderListPage_sortingBlock.set(this, void 0);
            _OrderListPage_export2excelBlock.set(this, void 0);
            _OrderListPage_exportXhr.set(this, void 0);
            _OrderListPage_popupInfo.set(this, void 0);
            __classPrivateFieldSet(this, _OrderListPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _OrderListPage_orderHeader, $('.js-orders-output-head', this.root), "f");
            __classPrivateFieldGet(this, _OrderListPage_orderHeader, "f").toggle(__classPrivateFieldGet(this, _OrderListPage_options, "f").totalCount > 0);
            __classPrivateFieldSet(this, _OrderListPage_foundBlock, $('.js-result-found', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPage_notFoundBlock, $('.js-result-not-found', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPage_currentPageIndex, __classPrivateFieldGet(this, _OrderListPage_options, "f").pageIndex, "f");
            __classPrivateFieldSet(this, _OrderListPage_currentPageSize, __classPrivateFieldGet(this, _OrderListPage_options, "f").pageSize, "f");
            __classPrivateFieldSet(this, _OrderListPage_showCount, __classPrivateFieldGet(this, _OrderListPage_currentPageSize, "f"), "f");
            __classPrivateFieldSet(this, _OrderListPage_sortBy, __classPrivateFieldGet(this, _OrderListPage_options, "f").sortBy, "f");
            __classPrivateFieldSet(this, _OrderListPage_sortDir, __classPrivateFieldGet(this, _OrderListPage_options, "f").sortDir, "f");
            __classPrivateFieldSet(this, _OrderListPage_filter, new App.OrderListFilter({
                datesOptions: {
                    keepEmpty: true,
                    // если не ставить минимальную дату, то она ставится текущей датой
                    minDateFromShift: App.OrderListFilter.checkinMinDateShift,
                    preserveDatesOffset: false,
                },
            }), "f");
            __classPrivateFieldGet(this, _OrderListPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSearch).call(this, e, data); }));
            __classPrivateFieldGet(this, _OrderListPage_filter, "f").setPaging(__classPrivateFieldGet(this, _OrderListPage_currentPageIndex, "f"), __classPrivateFieldGet(this, _OrderListPage_currentPageSize, "f"));
            __classPrivateFieldGet(this, _OrderListPage_filter, "f").setSorting(__classPrivateFieldGet(this, _OrderListPage_sortBy, "f"), __classPrivateFieldGet(this, _OrderListPage_sortDir, "f"));
            __classPrivateFieldSet(this, _OrderListPage_preloader, new App.Preloader(), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _OrderListPage_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_initShowMoreBlock).call(this);
            __classPrivateFieldSet(this, _OrderListPage_outputBlock, $('.js-orders-output', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPage_orderBlocks, $('.js-order', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPage_totalCount, $('.js-filter-totalcount', this.root), "f");
            __classPrivateFieldSet(this, _OrderListPage_sortingBlock, $('.js-orders-sort-items', this.root), "f");
            __classPrivateFieldGet(this, _OrderListPage_sortingBlock, "f").toggle(__classPrivateFieldGet(this, _OrderListPage_options, "f").totalCount > 0);
            $.each($('.js-sort-item', __classPrivateFieldGet(this, _OrderListPage_sortingBlock, "f")), (index, item) => {
                $(item).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_sortOrders).call(this, e); }));
            });
            __classPrivateFieldSet(this, _OrderListPage_export2excelBlock, $('.js-export2excel', this.root), "f");
            __classPrivateFieldGet(this, _OrderListPage_export2excelBlock, "f").on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_export2Excel).call(this); }));
            __classPrivateFieldGet(this, _OrderListPage_outputBlock, "f").on('click', '.js-show_qualityControlForm', e => __classPrivateFieldGet(_a, _a, "m", _OrderListPage_showQualityControl).call(_a, e));
            __classPrivateFieldGet(this, _OrderListPage_outputBlock, "f").on('click', '.js-show-schedule', (e) => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onScheduleClick).call(this, e));
            $(document).on("booking-conditions:show" /* Events.BookingConditionsShow */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onVipStatusShow).call(this, e); }));
        }
    }
    _a = OrderListPage, _OrderListPage_options = new WeakMap(), _OrderListPage_searchExecuting = new WeakMap(), _OrderListPage_currentPosition = new WeakMap(), _OrderListPage_preloader = new WeakMap(), _OrderListPage_filter = new WeakMap(), _OrderListPage_searchXhr = new WeakMap(), _OrderListPage_orderHeader = new WeakMap(), _OrderListPage_outputBlock = new WeakMap(), _OrderListPage_orderBlocks = new WeakMap(), _OrderListPage_foundBlock = new WeakMap(), _OrderListPage_notFoundBlock = new WeakMap(), _OrderListPage_currentPageSize = new WeakMap(), _OrderListPage_currentPageIndex = new WeakMap(), _OrderListPage_sortBy = new WeakMap(), _OrderListPage_sortDir = new WeakMap(), _OrderListPage_showMoreBlock = new WeakMap(), _OrderListPage_showMoreLink = new WeakMap(), _OrderListPage_showMoreCurrent = new WeakMap(), _OrderListPage_showMoreCountSelected = new WeakMap(), _OrderListPage_showMoreCountOption = new WeakMap(), _OrderListPage_showMoreTotal = new WeakMap(), _OrderListPage_totalCount = new WeakMap(), _OrderListPage_showCount = new WeakMap(), _OrderListPage_sortingBlock = new WeakMap(), _OrderListPage_export2excelBlock = new WeakMap(), _OrderListPage_exportXhr = new WeakMap(), _OrderListPage_popupInfo = new WeakMap(), _OrderListPage_instances = new WeakSet(), _OrderListPage_showQualityControl = function _OrderListPage_showQualityControl(event) {
        const self = $(event.currentTarget);
        const action = self.attr('data-action');
        if (action)
            window.location.href = action;
        return true;
    }, _OrderListPage_export2Excel = function _OrderListPage_export2Excel() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _OrderListPage_exportXhr, $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPage_options, "f").urls.export,
                method: 'POST',
                data: __classPrivateFieldGet(this, _OrderListPage_filter, "f").getData(),
                xhrFields: {
                    responseType: 'blob',
                },
                beforeSend: () => __classPrivateFieldGet(this, _OrderListPage_preloader, "f").show(),
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _OrderListPage_exportXhr, "f");
                if (!response)
                    return;
                const contentType = 'application/vnd.ms-excel';
                const blob = new Blob([response], { type: contentType });
                const anchor = document.createElement('a');
                anchor.download = 'orders.xlsx';
                anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
                anchor.dataset.downloadurl = ['application/vnd.ms-excel', anchor.download, anchor.href].join(':');
                anchor.click();
            }
            catch (e) {
                console.log(e);
            }
            finally {
                __classPrivateFieldGet(this, _OrderListPage_preloader, "f").hide();
            }
        });
    }, _OrderListPage_initShowMoreBlock = function _OrderListPage_initShowMoreBlock() {
        __classPrivateFieldSet(this, _OrderListPage_showMoreBlock, $('.js-show-more-block', this.root), "f");
        __classPrivateFieldSet(this, _OrderListPage_showMoreLink, $('.js-show-more-link', __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPage_showMoreCurrent, $('.js-show-more-current', __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPage_showMoreCountSelected, $('.js-show-count-selected', __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPage_showMoreCountOption, $('.js-show-count-option', __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldSet(this, _OrderListPage_showMoreTotal, $('.js-show-more-total', __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f")), "f");
        __classPrivateFieldGet(this, _OrderListPage_showMoreLink, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onShowMoreOrders).call(this, e); }));
        __classPrivateFieldGet(this, _OrderListPage_showMoreCountOption, "f").on('click', e => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_changePageSize).call(this, e));
        const leftToShow = __classPrivateFieldGet(this, _OrderListPage_options, "f").totalCount - __classPrivateFieldGet(this, _OrderListPage_showCount, "f");
        __classPrivateFieldGet(this, _OrderListPage_showMoreTotal, "f").text(leftToShow);
        __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f").toggleByClass(leftToShow > 0);
    }, _OrderListPage_resetData = function _OrderListPage_resetData() {
        __classPrivateFieldSet(this, _OrderListPage_currentPageIndex, 0, "f");
        __classPrivateFieldGet(this, _OrderListPage_filter, "f").setPaging(__classPrivateFieldGet(this, _OrderListPage_currentPageIndex, "f"), __classPrivateFieldGet(this, _OrderListPage_currentPageSize, "f"));
        // TODO: нужно ли сбрасывать сортировку??
        /* this.sortBy = 'CreateDate';
        this.sortDir = 'Desc';
        this.filter.setSorting(this.sortBy, this.sortDir);*/
    }, _OrderListPage_onSearch = function _OrderListPage_onSearch(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderListPage_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderListPage_searchExecuting, true, "f");
            yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_doSearch).call(this, data, () => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSearchBefore).call(this), v => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSearchDone).call(this, v), () => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSearchAlways).call(this));
        });
    }, _OrderListPage_onSearchBefore = function _OrderListPage_onSearchBefore() {
        __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_resetData).call(this);
        __classPrivateFieldGet(this, _OrderListPage_preloader, "f").show();
    }, _OrderListPage_onSearchDone = function _OrderListPage_onSearchDone(data) {
        if (data)
            __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_appendData).call(this, data.output, data.totalCount);
    }, _OrderListPage_appendData = function _OrderListPage_appendData(data, totalCount, clearBefore = true) {
        if (clearBefore) {
            __classPrivateFieldGet(this, _OrderListPage_outputBlock, "f").empty(); /* .not('.js-no-ajax-output')*/
            __classPrivateFieldSet(this, _OrderListPage_showCount, __classPrivateFieldGet(this, _OrderListPage_currentPageSize, "f"), "f");
        }
        else {
            __classPrivateFieldSet(this, _OrderListPage_showCount, __classPrivateFieldGet(this, _OrderListPage_showCount, "f") + __classPrivateFieldGet(this, _OrderListPage_currentPageSize, "f"), "f");
        }
        const found = totalCount > 0;
        __classPrivateFieldGet(this, _OrderListPage_orderHeader, "f").toggle(found);
        __classPrivateFieldGet(this, _OrderListPage_sortingBlock, "f").toggle(found);
        __classPrivateFieldGet(this, _OrderListPage_foundBlock, "f").toggle(found);
        __classPrivateFieldGet(this, _OrderListPage_notFoundBlock, "f").toggle(!found);
        const leftToShow = totalCount - __classPrivateFieldGet(this, _OrderListPage_showCount, "f");
        __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f").toggleByClass(leftToShow > 0);
        if (found) {
            __classPrivateFieldGet(this, _OrderListPage_outputBlock, "f").append(data);
            __classPrivateFieldGet(this, _OrderListPage_totalCount, "f").text(`${totalCount} ${App.pluralRu(totalCount, 'заказ', 'заказа', 'заказов')}`);
            __classPrivateFieldGet(this, _OrderListPage_showMoreTotal, "f").text(leftToShow);
            __classPrivateFieldSet(this, _OrderListPage_orderBlocks, $('.js-order', __classPrivateFieldGet(this, _OrderListPage_outputBlock, "f")), "f");
            __classPrivateFieldGet(this, _OrderListPage_orderBlocks, "f").removeClass('_hidden');
            __classPrivateFieldGet(this, _OrderListPage_showMoreCurrent, "f").text(Math.min(__classPrivateFieldGet(this, _OrderListPage_currentPageSize, "f"), leftToShow));
        }
    }, _OrderListPage_onSearchAlways = function _OrderListPage_onSearchAlways() {
        __classPrivateFieldGet(this, _OrderListPage_preloader, "f").hide();
        __classPrivateFieldSet(this, _OrderListPage_searchExecuting, false, "f");
    }, _OrderListPage_onShowMoreOrders = function _OrderListPage_onShowMoreOrders(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const self = $(event.currentTarget);
            const selfOffset = self.offset();
            __classPrivateFieldSet(this, _OrderListPage_currentPosition, selfOffset != null ? selfOffset.top : 0, "f");
            __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f").addClass('_pulsate');
            __classPrivateFieldSet(this, _OrderListPage_currentPageIndex, (_b = __classPrivateFieldGet(this, _OrderListPage_currentPageIndex, "f"), _b++, _b), "f");
            __classPrivateFieldGet(this, _OrderListPage_filter, "f").setPaging(__classPrivateFieldGet(this, _OrderListPage_currentPageIndex, "f"), __classPrivateFieldGet(this, _OrderListPage_currentPageSize, "f"));
            yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_doSearch).call(this, __classPrivateFieldGet(this, _OrderListPage_filter, "f").getData(), () => __classPrivateFieldGet(_a, _a, "m", _OrderListPage_onShowMoreBefore).call(_a), v => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onShowMoreDone).call(this, v), () => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onShowMoreAlways).call(this));
        });
    }, _OrderListPage_onShowMoreBefore = function _OrderListPage_onShowMoreBefore() {
    }, _OrderListPage_onShowMoreDone = function _OrderListPage_onShowMoreDone(data) {
        if (data) {
            __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_appendData).call(this, data.output, data.totalCount, false);
            if (__classPrivateFieldGet(this, _OrderListPage_currentPosition, "f"))
                $('html, body').animate({ scrollTop: __classPrivateFieldGet(this, _OrderListPage_currentPosition, "f") - 50 }, 'slow');
        }
    }, _OrderListPage_onShowMoreAlways = function _OrderListPage_onShowMoreAlways() {
        __classPrivateFieldGet(this, _OrderListPage_showMoreBlock, "f").removeClass('_pulsate');
    }, _OrderListPage_doSearch = function _OrderListPage_doSearch(data, beforeCallback, doneCallback, alwaysCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _OrderListPage_searchXhr, $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPage_options, "f").urls.search,
                method: 'POST',
                data,
                beforeSend: () => beforeCallback(),
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _OrderListPage_searchXhr, "f");
                if (!response)
                    return;
                // TODO: обрабатывать результат 'Вариантов, соответствующих заданным критериям, нет.'
                if (!response.status.success || response.data == null)
                    return;
                if (response.redirect)
                    window.location.href = response.redirect;
                doneCallback(response.data);
            }
            catch (ex) {
                // Запрос не удался
                console.log(ex);
            }
            finally {
                alwaysCallback();
            }
        });
    }, _OrderListPage_changePageSize = function _OrderListPage_changePageSize(event) {
        const target = $(event.currentTarget);
        __classPrivateFieldSet(this, _OrderListPage_currentPageSize, parseInt(target.text(), 10), "f");
        __classPrivateFieldGet(this, _OrderListPage_showMoreCountOption, "f").removeClass('_active');
        target.addClass('_active');
        __classPrivateFieldGet(this, _OrderListPage_showMoreCountSelected, "f").text(target.text());
        __classPrivateFieldGet(this, _OrderListPage_showMoreCurrent, "f").text(target.text());
    }, _OrderListPage_sortOrders = function _OrderListPage_sortOrders(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.currentTarget);
            target.siblings().removeClass('_active');
            target.toggleClass('_sort-up _sort-down');
            target.addClass('_active');
            __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_resetData).call(this);
            __classPrivateFieldGet(this, _OrderListPage_filter, "f").setSorting((_b = target.attr('data-code')) !== null && _b !== void 0 ? _b : '', target.hasClass('_sort-up') ? 'Asc' : 'Desc');
            yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_doSearch).call(this, __classPrivateFieldGet(this, _OrderListPage_filter, "f").getData(), () => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSortingBefore).call(this), v => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSortingDone).call(this, v), () => __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSortingAlways).call(this));
        });
    }, _OrderListPage_onSortingBefore = function _OrderListPage_onSortingBefore() {
        // сброс параметров нужно делать ДО получения данных getData()
        __classPrivateFieldGet(this, _OrderListPage_preloader, "f").show();
    }, _OrderListPage_onSortingDone = function _OrderListPage_onSortingDone(data) {
        __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSearchDone).call(this, data);
    }, _OrderListPage_onSortingAlways = function _OrderListPage_onSortingAlways() {
        __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_onSearchAlways).call(this);
    }, _OrderListPage_onScheduleClick = function _OrderListPage_onScheduleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _OrderListPage_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _OrderListPage_popupInfo, new App.PopupOld({
            content: $('<div class="js-cruise-schedule cruise-schedule user-content"><div style="padding:10px;"><img src="/img/main/load-sm.gif"/></div></div>'),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _OrderListPage_instances, "m", _OrderListPage_getCruiseSchedule).call(this, (_b = $(event.currentTarget).attr('data-ordernumber')) !== null && _b !== void 0 ? _b : ''); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _OrderListPage_getCruiseSchedule = function _OrderListPage_getCruiseSchedule(orderNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPage_options, "f").urls.getCruiseSchedule,
                method: 'POST',
                data: { orderNumber: orderNumber },
            });
            const response = yield xhr;
            if (!response || !response.status.success || response.data == null) {
                App.popupHide();
                return;
            }
            let blockDescr = $('<div>Расписание будет позже.</div>');
            if (response && response.data && response.data.item) {
                blockDescr = $(App.templates.Order.CruiseSchedule({ scheduleData: response.data.item }));
            }
            $('.js-cruise-schedule', $('.js-popup')).empty().append(blockDescr);
        });
    }, _OrderListPage_onVipStatusShow = function _OrderListPage_onVipStatusShow(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            e.preventDefault();
            e.stopPropagation();
            const targetElement = $(e.target).parents('.js-show-cancellation-conditions');
            const key = parseInt((_b = targetElement.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderListPage_options, "f").urls.getVipStatus,
                method: 'POST',
                data: { key: key },
            });
            const response = yield xhr;
            if (response && response.data && response.data.item.description.length > 0) {
                const blockDescr = $(App.templates.Order.VipStatus({ data: response.data.item }));
                targetElement.find('.js-reserve-info-block-info').empty().append(blockDescr);
            }
        });
    };
    App.OrderListPage = OrderListPage;
})(App || (App = {}));
var App;
(function (App) {
    var _OrderPage_instances, _a, _OrderPage_options, _OrderPage_fareTranslations, _OrderPage_defaultError, _OrderPage_infoBlocksTemplate, _OrderPage_invalidOrder, _OrderPage_header, _OrderPage_genders, _OrderPage_citizenshipsCountries, _OrderPage_chinaCities, _OrderPage_relationships, _OrderPage_visas, _OrderPage_renderSpeed, _OrderPage_touristData, _OrderPage_messages, _OrderPage_chatModel, _OrderPage_popup, _OrderPage_responseValidator, _OrderPage_popupInfo, _OrderPage_orderHeaderContainer, _OrderPage_charterInfoContainer, _OrderPage_servicesOutput, _OrderPage_servicesContainer, _OrderPage_canceledServicesOutput, _OrderPage_canceledServicesContainer, _OrderPage_cruiseServicesContainer, _OrderPage_managerContainer, _OrderPage_chatContainer, _OrderPage_chatSubmitButton, _OrderPage_chatObjectType, _OrderPage_chatObjectContainer, _OrderPage_chatSubjectContainer, _OrderPage_chatSubjectType, _OrderPage_chatPnr, _OrderPage_pnrsSelectBlock, _OrderPage_cancelOrderContainer, _OrderPage_electronicTripContainer, _OrderPage_electronicTripForm, _OrderPage_addBusSeatsButton, _OrderPage_mapWrapClass, _OrderPage_headerTemplate, _OrderPage_servicesTemplate, _OrderPage_charterInfoTemplate, _OrderPage_managerTemplate, _OrderPage_chatTemplate, _OrderPage_chatMessagesTemplate, _OrderPage_chatMessageItems, _OrderPage_mscNoTouristMatchingTemplate, _OrderPage_mscValueTemplate, _OrderPage_schedulePopupInfo, _OrderPage_processExecuting, _OrderPage_saveElectronicTripExecuting, _OrderPage_loadElectronicTripExecuting, _OrderPage_insuranceServices, _OrderPage_hasJapanVisa, _OrderPage_hasAliveJapanHotel, _OrderPage_onSelectedInsurance, _OrderPage_canEditOrder, _OrderPage_render, _OrderPage_getHeader, _OrderPage_renderHeader, _OrderPage_initTourist, _OrderPage_renderManager, _OrderPage_getServices, _OrderPage_renderServices, _OrderPage_renderCharterInfo, _OrderPage_renderChat, _OrderPage_onActionShowMoreMessage, _OrderPage_mergeChatGroups, _OrderPage_renderChatPage, _OrderPage_setAgreeFlagMessage, _OrderPage_onMessageObjectChange, _OrderPage_onMessageSubjectChange, _OrderPage_onPnrChange, _OrderPage_toggleVisaBlocks, _OrderPage_toggleSubmitButton, _OrderPage_aviaAskQuestion, _OrderPage_addChatMessage, _OrderPage_setSerializedValue, _OrderPage_appendVisaChatFields, _OrderPage_getChatModel, _OrderPage_clickMessageReply, _OrderPage_showReplyDialog, _OrderPage_scrollToMessageFromReply, _OrderPage_mouseOverMessage, _OrderPage_scrollTo, _OrderPage_animBackground, _OrderPage_animBackgroundYellow, _OrderPage_copyTouristData, _OrderPage_onClickCustomerTourist, _OrderPage_showElectronicTripContainer, _OrderPage_loadElectronicTrip, _OrderPage_setDocumentNumberMask, _OrderPage_getDocumentNumberMask, _OrderPage_onETDocumentTypeChange, _OrderPage_hideElectronicTripContainer, _OrderPage_onCustomerTypeChange, _OrderPage_saveElectronicTrip, _OrderPage_showCancelOrderDialog, _OrderPage_sendCancelOrderReason, _OrderPage_closeCancelOrderDialog, _OrderPage_openTouristEditor, _OrderPage_onChangeFindTourist, _OrderPage_onChangeChinaVisaType, _OrderPage_updateVisibleFields, _OrderPage_onChangeChinaCountry, _OrderPage_showTouristEditor, _OrderPage_transliterate, _OrderPage_cancelTouristEditor, _OrderPage_isConfidantPhoneContainedInTouristsPhones, _OrderPage_editTourist, _OrderPage_addPwService, _OrderPage_showAddAviaCruiseDialog, _OrderPage_agreeToAddAviaCruise, _OrderPage_closeAddAviaCruiseDialog, _OrderPage_addCruiseService, _OrderPage_showQualityControl, _OrderPage_showCruiseActivityRefusalDialog, _OrderPage_showAddVisaDialog, _OrderPage_setDependencies, _OrderPage_setSubmitAvailability, _OrderPage_loadVisaServices, _OrderPage_changeVisaServices, _OrderPage_jelectInit, _OrderPage_autocompleteInit, _OrderPage_calendarInit, _OrderPage_setIssueDateValidation, _OrderPage_saveVisas, _OrderPage_cancelVisas, _OrderPage_showAddInsuranceDialog, _OrderPage_saveInsurances, _OrderPage_cancelInsurances, _OrderPage_addPacFitService, _OrderPage_getDocumentsDialog, _OrderPage_openBookingDetails, _OrderPage_openServiceTourists, _OrderPage_onStopsClick, _OrderPage_renderBookingDetails, _OrderPage_showBusTourists, _OrderPage_showBusSeats, _OrderPage_takeBusSeat, _OrderPage_showFareConditions, _OrderPage_showFarePenalties, _OrderPage_showFareInfo, _OrderPage_getFareTranslation, _OrderPage_loadFareTranslation, _OrderPage_showBrandRules, _OrderPage_renderBrandFare, _OrderPage_onShowMapClick, _OrderPage_showMap, _OrderPage_onActionConfirm, _OrderPage_onActionConfirmCruise, _OrderPage_onConfirmCruiseDialogClose, _OrderPage_onConfirmCruiseDialogContinueAsync, _OrderPage_onActionCancel, _OrderPage_onActionRefreshPrice, _OrderPage_onInactiveIssueButtonClick, _OrderPage_onActionIssue, _OrderPage_doActionIssue, _OrderPage_onActionContinue, _OrderPage_onCancelCurrentAccommodationBooking, _OrderPage_onBookAlternativeHotel, _OrderPage_onCancelIssue, _OrderPage_onConfirmIssue, _OrderPage_onActionPacManual, _OrderPage_onAviaRebook, _OrderPage_onAviaRebookContinue, _OrderPage_aviaRebookCore, _OrderPage_onAviaRebookNewSearch, _OrderPage_onActionAviaSynchronize, _OrderPage_onShowPaymentHistory, _OrderPage_closePaymentHistory, _OrderPage_onShowCancelledServices, _OrderPage_onCloseCancelledServices, _OrderPage_onFillMscTourists, _OrderPage_fillTouristMscData, _OrderPage_onRewriteByMsc, _OrderPage_onRewriteTouristByMsc, _OrderPage_onCruiseChangeRouteRequest, _OrderPage_onCruiseIssueRequest, _OrderPage_onCruiseIssueAgreed, _OrderPage_onShowTermsClick, _OrderPage_getVehicleTerms, _OrderPage_getRequiredParameter, _OrderPage_reloadAll, _OrderPage_setLoadingText, _OrderPage_onSearchBefore, _OrderPage_onSearchAlways, _OrderPage_hidePreloader, _OrderPage_getDataLoading, _OrderPage_getDataSaving, _OrderPage_getDataRebooking, _OrderPage_getDataBooking, _OrderPage_getDataCurrentBookingCancellation, _OrderPage_getReport, _OrderPage_getCruiseDoc, _OrderPage_getDocumentDownloadLinkDialog, _OrderPage_setContractConfirmationDate, _OrderPage_onAcceptDownloadLinkClick, _OrderPage_onScheduleClick, _OrderPage_getCruiseSchedule, _OrderPage_onTouristPriceEditClick, _OrderPage_onTouristPriceSaveClick, _OrderPage_onTouristPriceSaveCancelClick, _OrderPage_markMessageAsRead, _OrderPage_checkUnreadMessages, _OrderPage_onExpansionPanelAfterToggle, _OrderPage_loadPriceBreakdown;
    App.VisaQuestionWho = {
        Opvd: 'ОПВД',
        VisaSpecialist: 'Визовик',
    };
    const doAction = (url_1, ...args_1) => __awaiter(this, [url_1, ...args_1], void 0, function* (url, data = {}, before = () => { }, always = () => { }) {
        try {
            const result = yield $.ajax({
                url,
                method: 'POST',
                data,
                beforeSend: () => before(),
                complete: () => always(),
            });
            return result;
        }
        catch (e) {
            window.console.error(e);
            return undefined;
        }
    });
    class OrderPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-order-page' }, options));
            _OrderPage_instances.add(this);
            _OrderPage_options.set(this, void 0);
            _OrderPage_fareTranslations.set(this, new Map());
            _OrderPage_infoBlocksTemplate.set(this, void 0);
            _OrderPage_invalidOrder.set(this, void 0);
            _OrderPage_header.set(this, void 0);
            _OrderPage_genders.set(this, void 0);
            _OrderPage_citizenshipsCountries.set(this, void 0);
            _OrderPage_chinaCities.set(this, void 0);
            _OrderPage_relationships.set(this, void 0);
            _OrderPage_visas.set(this, void 0);
            _OrderPage_renderSpeed.set(this, 1 /* RenderSpeed.fast */.toString());
            _OrderPage_touristData.set(this, void 0);
            _OrderPage_messages.set(this, void 0);
            _OrderPage_chatModel.set(this, void 0);
            _OrderPage_popup.set(this, void 0);
            _OrderPage_responseValidator.set(this, void 0);
            _OrderPage_popupInfo.set(this, void 0);
            _OrderPage_orderHeaderContainer.set(this, void 0);
            _OrderPage_charterInfoContainer.set(this, void 0);
            _OrderPage_servicesOutput.set(this, void 0);
            _OrderPage_servicesContainer.set(this, void 0);
            _OrderPage_canceledServicesOutput.set(this, void 0);
            _OrderPage_canceledServicesContainer.set(this, void 0);
            _OrderPage_cruiseServicesContainer.set(this, void 0);
            _OrderPage_managerContainer.set(this, void 0);
            _OrderPage_chatContainer.set(this, void 0);
            _OrderPage_chatSubmitButton.set(this, void 0);
            _OrderPage_chatObjectType.set(this, void 0);
            _OrderPage_chatObjectContainer.set(this, void 0);
            _OrderPage_chatSubjectContainer.set(this, void 0);
            _OrderPage_chatSubjectType.set(this, void 0);
            _OrderPage_chatPnr.set(this, void 0);
            _OrderPage_pnrsSelectBlock.set(this, void 0);
            _OrderPage_cancelOrderContainer.set(this, void 0);
            _OrderPage_electronicTripContainer.set(this, void 0);
            _OrderPage_electronicTripForm.set(this, void 0);
            _OrderPage_addBusSeatsButton.set(this, void 0);
            _OrderPage_mapWrapClass.set(this, void 0);
            _OrderPage_headerTemplate.set(this, void 0);
            _OrderPage_servicesTemplate.set(this, void 0);
            _OrderPage_charterInfoTemplate.set(this, void 0);
            _OrderPage_managerTemplate.set(this, void 0);
            _OrderPage_chatTemplate.set(this, void 0);
            _OrderPage_chatMessagesTemplate.set(this, void 0);
            _OrderPage_chatMessageItems.set(this, void 0);
            _OrderPage_mscNoTouristMatchingTemplate.set(this, void 0);
            _OrderPage_mscValueTemplate.set(this, void 0);
            _OrderPage_schedulePopupInfo.set(this, void 0);
            _OrderPage_processExecuting.set(this, false);
            _OrderPage_saveElectronicTripExecuting.set(this, false);
            _OrderPage_loadElectronicTripExecuting.set(this, false);
            _OrderPage_insuranceServices.set(this, []);
            _OrderPage_hasJapanVisa.set(this, void 0);
            _OrderPage_hasAliveJapanHotel.set(this, void 0);
            __classPrivateFieldSet(this, _OrderPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _OrderPage_infoBlocksTemplate, App.templates.InfoBlocks, "f");
            __classPrivateFieldSet(this, _OrderPage_invalidOrder, true, "f");
            __classPrivateFieldSet(this, _OrderPage_messages, new App.Messages(), "f");
            __classPrivateFieldSet(this, _OrderPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _OrderPage_responseValidator, new App.ResponseValidator({ messenger: new App.BlockMessenger(__classPrivateFieldGet(this, _OrderPage_messages, "f")) }), "f");
            __classPrivateFieldSet(this, _OrderPage_headerTemplate, App.templates.Order.Header, "f");
            __classPrivateFieldSet(this, _OrderPage_servicesTemplate, App.templates.Order.Services, "f");
            __classPrivateFieldSet(this, _OrderPage_charterInfoTemplate, App.templates.Order.CharterInfo, "f");
            __classPrivateFieldSet(this, _OrderPage_managerTemplate, App.templates.Order.Manager, "f");
            __classPrivateFieldSet(this, _OrderPage_chatTemplate, App.templates.Order.Chat, "f");
            __classPrivateFieldSet(this, _OrderPage_chatMessagesTemplate, App.templates.Order.ChatMessages, "f");
            __classPrivateFieldSet(this, _OrderPage_mscNoTouristMatchingTemplate, App.templates.Order.MscNoTouristMatching, "f");
            __classPrivateFieldSet(this, _OrderPage_mscValueTemplate, App.templates.Order.MscValue, "f");
            __classPrivateFieldSet(this, _OrderPage_orderHeaderContainer, $('.js-order-header', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_charterInfoContainer, $('.js-order-charter-info', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_servicesOutput, $('.js-order-services-output', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_servicesContainer, $('.js-order-services', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_canceledServicesOutput, $('.js-order-canceled-services-output', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_canceledServicesContainer, $('.js-order-canceled-services', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_cruiseServicesContainer, $('.js-order-add-msc-service', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_managerContainer, $('.js-order-manager', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_chatContainer, $('.js-order-chat', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_electronicTripContainer, $('.js-electronic-trip-container', this.root), "f");
            __classPrivateFieldSet(this, _OrderPage_addBusSeatsButton, $('.js-order-add-bus-seats', this.root), "f");
            __classPrivateFieldGet(this, _OrderPage_addBusSeatsButton, "f").on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showBusTourists).call(this); }));
            __classPrivateFieldSet(this, _OrderPage_mapWrapClass, 'js-point-map-wrap', "f");
            __classPrivateFieldSet(this, _OrderPage_touristData, new Array(), "f");
            this.components.push(new App.ExpansionPanelComponent());
            $(this.root)
                .on('click', '.js-cancel-order', () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showCancelOrderDialog).call(this))
                .on('click', '.js-order-tourist-edit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showTouristEditor).call(this, e); }))
                .on('blur', '.js-needTransliterate', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_transliterate).call(this, e))
                .on('click', '.js-order-tourist-editor-cancel', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_cancelTouristEditor).call(_a, e))
                .on('click', '.js-order-tourist-change', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_editTourist).call(this, e); }))
                .on('click', '.js-order-add-service', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_addPwService).call(this, e); }))
                .on('click', '.js-show-add-avia-cruise-dialog', () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showAddAviaCruiseDialog).call(this))
                .on('click', '.js-add-avia-cruise-cancel', () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_closeAddAviaCruiseDialog).call(_a))
                .on('click', '#addAviaCruiseAgree', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_agreeToAddAviaCruise).call(this, e))
                .on('click', '.js-order-add-cruise-serviceOption', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_addCruiseService).call(this, e))
                .on('click', '.js-show_qualityControlForm', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_showQualityControl).call(_a, e))
                .on('click', '.js-cruise-refusal', () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showCruiseActivityRefusalDialog).call(this))
                .on('click', '.js-order-add-visa', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showAddVisaDialog).call(this); }))
                .on('click', '.js-order-add-insurance', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showAddInsuranceDialog).call(this); }))
                .on('click', '.js-order-add-anyservice', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_addPacFitService).call(this); }))
                .on('click', '#getDocumentsButton', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getDocumentsDialog).call(this); }))
                .on('click', '#getDocDownloadLink', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getDocumentDownloadLinkDialog).call(this); }))
                .on('click', '#setContractConfirmationDate', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_setContractConfirmationDate).call(this); }))
                .on('click', '.js-copyTouristConfidantData', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_copyTouristData).call(this, e, 'js-touristConfidantData', true); }))
                .on('click', '.js-copyTouristPostData', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_copyTouristData).call(this, e, 'js-touristPostData', false); }))
                .on('click', '.js-order-canceled-show', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onShowCancelledServices).call(_a, e))
                .on('click', '.js-order-canceled-close', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onCloseCancelledServices).call(_a, e))
                .on('click', '.js-scroll-to-messages', e => App.scrollLinkClickHandler(e))
                .on('click', '.js-avia-ask-question', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_aviaAskQuestion).call(this, e); }))
                .on('click', '.js-avia-ask-question', e => App.scrollLinkClickHandler(e))
                .on('click', '.js-filter-option', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onSelectedInsurance).call(this, e));
            $(__classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f"))
                .on('click', '.js-fill-msc-tourists', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onFillMscTourists).call(this); }))
                .on('click', '.js-order-payment-history-link', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onShowPaymentHistory).call(this, e); }));
            $(__classPrivateFieldGet(this, _OrderPage_servicesContainer, "f")).add(__classPrivateFieldGet(this, _OrderPage_canceledServicesContainer, "f"))
                .on('click', '.js-order-service .js-order-service-open', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_openBookingDetails).call(this, e); }))
                .on('click', '.js-order-service-tourist-more', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_openServiceTourists).call(this, e); }))
                .on('click', '.js-segment-stop-info', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onStopsClick).call(_a, e))
                .on('click', '.js-booking-action-confirm', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionConfirm).call(this, e); }))
                .on('click', '.js-booking-action-confirm-cruise', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionConfirmCruise).call(this, e))
                .on('click', '.js-booking-action-cancel', (e) => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionCancel).call(this, e))
                .on('click', '.js-service-action-cancel', (e) => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionCancel).call(this, e))
                .on('click', '.js-inactive-issue', () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onInactiveIssueButtonClick).call(_a))
                .on('click', '.js-booking-action-issue', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionIssue).call(this, e); }))
                .on('click', '.js-booking-action-refresh-price', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionRefreshPrice).call(this, e); }))
                .on('click', '.js-booking-action-pac-manual', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionPacManual).call(this, e); }))
                .on('click', '.js-avia-rebook', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onAviaRebook).call(this, e); }))
                .on('click', '.js-booking-action-mark-avia-issued, .js-booking-action-mark-avia-cancelled', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionAviaSynchronize).call(this, e); }))
                .on('click', '.js-cruise-issue-request', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onCruiseIssueRequest).call(this, e))
                .on('click', '.js-cruise-changeRoute-request', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onCruiseChangeRouteRequest).call(this, e); }))
                .on('click', '.js-lk-order-cruisedoc-link', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getCruiseDoc).call(this, e))
                .on('click', '.js-order-service .js-order-service-hidden .js-show-terms', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onShowTermsClick).call(this, e); }))
                .on("action:continue" /* Events.ActionContinue */, (e, invoker, serviceKey, actionType) => __awaiter(this, void 0, void 0, function* () {
                return (yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionContinue).call(this, e, invoker, serviceKey, actionType));
            }));
            $(document).on("expansion-panel:aftertoggle" /* Events.ExpansionPanelAfterToggle */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onExpansionPanelAfterToggle).call(this, e, data); }));
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_render).call(this);
            });
        }
        getCommonInfoBlockCompact(message) {
            return this.getCommonInfoBlock(message.type, message.text);
        }
        getCommonInfoBlock(messageType, text) {
            return $(__classPrivateFieldGet(this, _OrderPage_infoBlocksTemplate, "f").call(this, { type: messageType, text }));
        }
        updateCityOptions(items, parent, setRequired = false) {
            const model = new App.SelectListModel({
                name: 'Tourist.ChinaReturnFlightArrCity',
                form: true,
                autocomplete: false,
                items: items,
            });
            const cities = $(App.templates.FilterSelect(model));
            const citySelect = $('.js-chinaArrCities', parent);
            citySelect
                .empty()
                .append(cities);
            if (setRequired)
                $('input', citySelect).not('[name$=".Search"]').not('[data-not-required]').each((i, v) => v.setAttribute('required', 'required'));
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_jelectInit).call(_a, citySelect.parent());
        }
    }
    _a = OrderPage, _OrderPage_options = new WeakMap(), _OrderPage_fareTranslations = new WeakMap(), _OrderPage_infoBlocksTemplate = new WeakMap(), _OrderPage_invalidOrder = new WeakMap(), _OrderPage_header = new WeakMap(), _OrderPage_genders = new WeakMap(), _OrderPage_citizenshipsCountries = new WeakMap(), _OrderPage_chinaCities = new WeakMap(), _OrderPage_relationships = new WeakMap(), _OrderPage_visas = new WeakMap(), _OrderPage_renderSpeed = new WeakMap(), _OrderPage_touristData = new WeakMap(), _OrderPage_messages = new WeakMap(), _OrderPage_chatModel = new WeakMap(), _OrderPage_popup = new WeakMap(), _OrderPage_responseValidator = new WeakMap(), _OrderPage_popupInfo = new WeakMap(), _OrderPage_orderHeaderContainer = new WeakMap(), _OrderPage_charterInfoContainer = new WeakMap(), _OrderPage_servicesOutput = new WeakMap(), _OrderPage_servicesContainer = new WeakMap(), _OrderPage_canceledServicesOutput = new WeakMap(), _OrderPage_canceledServicesContainer = new WeakMap(), _OrderPage_cruiseServicesContainer = new WeakMap(), _OrderPage_managerContainer = new WeakMap(), _OrderPage_chatContainer = new WeakMap(), _OrderPage_chatSubmitButton = new WeakMap(), _OrderPage_chatObjectType = new WeakMap(), _OrderPage_chatObjectContainer = new WeakMap(), _OrderPage_chatSubjectContainer = new WeakMap(), _OrderPage_chatSubjectType = new WeakMap(), _OrderPage_chatPnr = new WeakMap(), _OrderPage_pnrsSelectBlock = new WeakMap(), _OrderPage_cancelOrderContainer = new WeakMap(), _OrderPage_electronicTripContainer = new WeakMap(), _OrderPage_electronicTripForm = new WeakMap(), _OrderPage_addBusSeatsButton = new WeakMap(), _OrderPage_mapWrapClass = new WeakMap(), _OrderPage_headerTemplate = new WeakMap(), _OrderPage_servicesTemplate = new WeakMap(), _OrderPage_charterInfoTemplate = new WeakMap(), _OrderPage_managerTemplate = new WeakMap(), _OrderPage_chatTemplate = new WeakMap(), _OrderPage_chatMessagesTemplate = new WeakMap(), _OrderPage_chatMessageItems = new WeakMap(), _OrderPage_mscNoTouristMatchingTemplate = new WeakMap(), _OrderPage_mscValueTemplate = new WeakMap(), _OrderPage_schedulePopupInfo = new WeakMap(), _OrderPage_processExecuting = new WeakMap(), _OrderPage_saveElectronicTripExecuting = new WeakMap(), _OrderPage_loadElectronicTripExecuting = new WeakMap(), _OrderPage_insuranceServices = new WeakMap(), _OrderPage_hasJapanVisa = new WeakMap(), _OrderPage_hasAliveJapanHotel = new WeakMap(), _OrderPage_instances = new WeakSet(), _OrderPage_onSelectedInsurance = function _OrderPage_onSelectedInsurance(e) {
        var _b, _c;
        const value = $(e.currentTarget).attr('data-val');
        const description = (_c = (_b = __classPrivateFieldGet(this, _OrderPage_insuranceServices, "f").find(v => v.key === value)) === null || _b === void 0 ? void 0 : _b.description) !== null && _c !== void 0 ? _c : '';
        $(e.currentTarget)
            .parents('.form-item')
            .find('.js-form-item-description')
            .html(description);
    }, _OrderPage_canEditOrder = function _OrderPage_canEditOrder() {
        return !__classPrivateFieldGet(this, _OrderPage_invalidOrder, "f");
    }, _OrderPage_render = function _OrderPage_render() {
        return __awaiter(this, void 0, void 0, function* () {
            App.modalShow($(App.templates.Order.Messages.Loading({})));
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getHeader).call(this);
            if (__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getServices).call(this);
        });
    }, _OrderPage_getHeader = function _OrderPage_getHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.getOrderHeader,
                method: 'POST',
                data: { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id },
            });
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_setLoadingText).call(_a, 'Загружается информация о заказе...');
            __classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f").append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldSet(this, _OrderPage_invalidOrder, false, "f");
                __classPrivateFieldSet(this, _OrderPage_header, response.data.item, "f");
                __classPrivateFieldSet(this, _OrderPage_genders, response.data.genders, "f");
                __classPrivateFieldSet(this, _OrderPage_citizenshipsCountries, response.data.citizenshipCountries, "f");
                __classPrivateFieldSet(this, _OrderPage_chinaCities, response.data.chinaCities, "f");
                __classPrivateFieldSet(this, _OrderPage_relationships, response.data.relationships, "f");
                __classPrivateFieldSet(this, _OrderPage_hasJapanVisa, response.data.hasJapanVisa, "f");
                __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderHeader).call(this, response.data);
                __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderManager).call(this, response.data.item);
                __classPrivateFieldSet(this, _OrderPage_chatModel, __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getChatModel).call(this, response.data.chat), "f");
                __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderChat).call(this, __classPrivateFieldGet(this, _OrderPage_chatModel, "f"));
                $('.js-lk-order-docs-list .js-lk-order-doc-link').on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getReport).call(this, e); }));
                $('.js-order-header .js-show-schedule').on('click', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onScheduleClick).call(this, e));
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                App.popupHide();
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_checkUnreadMessages).call(this, $('.js-chat-messages', this.root));
                // TODO: hide .js-loading ?
            }
        });
    }, _OrderPage_renderHeader = function _OrderPage_renderHeader(data) {
        __classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f")
            .empty()
            .append(__classPrivateFieldGet(this, _OrderPage_headerTemplate, "f").call(this, Object.assign(Object.assign({}, data.item), { reports: data.reports })));
        __classPrivateFieldSet(this, _OrderPage_cancelOrderContainer, $('.js-cancel-order-container', __classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f")), "f");
        if (data.item.canChooseBusSeats)
            __classPrivateFieldGet(this, _OrderPage_addBusSeatsButton, "f").show();
        // Стилизуем скролл
        const scrollerWrap = $('.lk-order-docs').find('.js-lk-scroller-wrap');
        const scroll = scrollerWrap.baron({
            scroller: '.js-lk-scroller',
            track: '.js-lk-scroller-bar-wrap',
            bar: '.js-lk-scroller-bar',
            barOnCls: 'baron',
        });
        scroll.update();
        // стоимость заказа по договору с туристом
        const touristPriceWrap = $('.js-order-header').find('.js-order-touristPriceWrap');
        if (touristPriceWrap.length > 0) {
            touristPriceWrap.on('click', '.js-order-touristPriceEdit', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onTouristPriceEditClick).call(this, e));
            touristPriceWrap.on('click', '.js-order-touristPriceSave', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onTouristPriceSaveClick).call(this, e); }));
            touristPriceWrap.on('click', '.js-order-touristPriceSaveCancel', () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onTouristPriceSaveCancelClick).call(this));
        }
        const epShowHideContainer = $('.js-ep-show-hide-container', this.root);
        $('.js-ep-show-more-link-show', epShowHideContainer).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showElectronicTripContainer).call(this, e); }));
        $('.js-ep-show-more-link-hide', epShowHideContainer).on('click', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_hideElectronicTripContainer).call(this, e));
        if (data.item.isNeedShowActivities) {
            __classPrivateFieldGet(this, _OrderPage_cruiseServicesContainer, "f")
                .addClass('_cruise')
                .append(App.templates.Order.CruiseActivityButton({ number: __classPrivateFieldGet(this, _OrderPage_options, "f").id, isLuxeCruise: data.item.isLuxeCruise }));
        }
        if (data.item.hasAgreement) {
            $('#hasAgreement').attr('checked', 'checked');
            $('#hasAgreement').attr('disabled', 'disabled');
            $('#hasOrderForm').attr('checked', 'checked');
            $('#hasOrderForm').attr('disabled', 'disabled');
            $('#setContractConfirmationDate').attr('disabled', 'disabled');
        }
    }, _OrderPage_initTourist = function _OrderPage_initTourist(tourist) {
        tourist.genders = new App.SelectListModel({
            name: 'Tourist.GenderType',
            form: true,
            autocomplete: false,
            items: __classPrivateFieldGet(this, _OrderPage_genders, "f")
                .map(v => ({
                value: v.value,
                text: v.text,
                selected: tourist.genderTypeValue === v.value,
            })),
        });
        tourist.countries = new App.SelectListModel({
            name: 'Tourist.Citizenship',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPage_citizenshipsCountries, "f")
                .map(v => ({
                value: v.name,
                text: v.countryName,
                selected: tourist.citizenship.value === v.name,
            })),
            isRequired: true,
        });
        tourist.postCountries = new App.SelectListModel({
            name: 'Tourist.ResidenceCountry',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPage_citizenshipsCountries, "f")
                .map(v => ({
                value: v.name,
                text: v.countryName,
                selected: tourist.residenceCountry.value === v.name,
            })),
        });
        tourist.relationships = new App.SelectListModel({
            name: 'Tourist.RelationshipKey',
            form: true,
            autocomplete: false,
            items: __classPrivateFieldGet(this, _OrderPage_relationships, "f")
                .map(v => ({
                value: v.key.toString(),
                text: v.name,
                selected: tourist.confidantRelationship.value == v.key.toString(),
            })),
        });
        tourist.relationships.items.unshift({ value: '', text: 'Выберите', selected: tourist.confidantRelationship.value === null });
        tourist.chinaTypeEntries = new App.SelectListModel({
            name: 'Tourist.ChinaVisaType',
            form: true,
            autocomplete: true,
            items: [
                { value: '0', text: 'Выберите', selected: tourist.chinaTypeEntry.value === null },
                { value: '24', text: 'Воспользуюсь правилом безвизового транзита в третью страну «до 24 часов»', selected: tourist.chinaTypeEntry.value === '24' },
                { value: '240', text: 'Воспользуюсь правилом безвизового транзита в третью страну «240 часов» ', selected: tourist.chinaTypeEntry.value === '240' },
                { value: 'visa', text: 'Самостоятельно оформлена соответствующая виза Китая', selected: tourist.chinaTypeEntry.value === 'visa' },
            ],
        });
        tourist.chinaDptCities = new App.SelectListModel({
            name: 'Tourist.chinaReturnFlightDptCity',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPage_chinaCities, "f")
                .map(v => ({
                value: v.name,
                text: v.name,
                selected: tourist.chinaReturnFlightDptCity.value === v.name,
            })),
        });
        tourist.chinaDptCities.items.unshift({ value: 'null', text: 'Выберите', selected: tourist.chinaReturnFlightDptCity.value === null });
        tourist.chinaArrCountries = new App.SelectListModel({
            name: 'chinaReturnFlightArrCountryId',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPage_citizenshipsCountries, "f")
                .map(v => ({
                value: v.key.toString(),
                text: v.name,
                selected: tourist.chinaReturnFlightArrCountry.value === v.name,
            })),
        });
        tourist.chinaArrCities = new App.SelectListModel({
            name: 'Tourist.ChinaReturnFlightArrCity',
            form: true,
            autocomplete: true,
            items: tourist.chinaReturnFlightArrCity.value != null
                ? [{ value: tourist.chinaReturnFlightArrCity.value, text: tourist.chinaReturnFlightArrCity.value, selected: true }]
                : [{ value: '0', text: 'Выберите сначала страну', selected: true }],
        });
    }, _OrderPage_renderManager = function _OrderPage_renderManager(data) {
        __classPrivateFieldGet(this, _OrderPage_managerContainer, "f").empty();
        if (data.showManager)
            __classPrivateFieldGet(this, _OrderPage_managerContainer, "f").append(__classPrivateFieldGet(this, _OrderPage_managerTemplate, "f").call(this, data.manager));
    }, _OrderPage_getServices = function _OrderPage_getServices() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return;
            App.popupHide();
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getServices, {
                id: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                statusKey: __classPrivateFieldGet(this, _OrderPage_options, "f").statusKey,
                isTour: __classPrivateFieldGet(this, _OrderPage_header, "f").isTour,
            }, () => {
                __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f")
                    .empty()
                    .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
            });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                return;
            if (!response)
                return;
            if (!response.data) {
                __classPrivateFieldGet(this, _OrderPage_messages, "f").show({ type: 2 /* MessageType.Error */, text: 'Услуги заказа не найдены' }, { canHide: true });
                return;
            }
            const { items } = response.data;
            __classPrivateFieldSet(this, _OrderPage_hasAliveJapanHotel, items.some(v => v.typeCode == 'Accommodation' && !v.canceled && v.countryKey == 27), "f");
            if (Enumerable.from(items).all(v => !v.isPw))
                __classPrivateFieldGet(this, _OrderPage_options, "f").contentType = 0 /* OrderContentType.MT */;
            else if (Enumerable.from(items).all(v => v.isPw))
                __classPrivateFieldGet(this, _OrderPage_options, "f").contentType = 1 /* OrderContentType.PW */;
            else
                __classPrivateFieldGet(this, _OrderPage_options, "f").contentType = 2 /* OrderContentType.Mixed */;
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderServices).call(this, items);
        });
    }, _OrderPage_renderServices = function _OrderPage_renderServices(items) {
        // TODO: показывать кнопку, если есть хоть одна 'живая' услуга.
        // показываем кнопку Отменить только после того, как получили статус содержимого заказа this.options.contentType.
        if (__classPrivateFieldGet(this, _OrderPage_cancelOrderContainer, "f"))
            __classPrivateFieldGet(this, _OrderPage_cancelOrderContainer, "f").show();
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderCharterInfo).call(this, items.filter(v => v.charter === true).length > 0);
        const activeServices = items.filter(v => !v.canceled || (v.canceled && (v.isPw ? v.withPenalty : v.withPenaltyMt)));
        const canceledServices = items.filter(v => v.canceled && (v.isPw ? !v.withPenalty : !v.withPenaltyMt));
        if (activeServices.length > 0) {
            __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f")
                .empty()
                .hide()
                .append(__classPrivateFieldGet(this, _OrderPage_servicesTemplate, "f").call(this, Object.assign(activeServices, {
                isNonLuxeCruise: __classPrivateFieldGet(this, _OrderPage_header, "f").isCruise && !__classPrivateFieldGet(this, _OrderPage_header, "f").isLuxeCruise,
                hasFictionalServices: activeServices.some(v => v.isFictional),
                hasJapanVisa: __classPrivateFieldGet(this, _OrderPage_hasJapanVisa, "f"),
            })))
                .show(__classPrivateFieldGet(this, _OrderPage_renderSpeed, "f"));
        }
        __classPrivateFieldGet(this, _OrderPage_servicesOutput, "f").toggle(activeServices.length > 0);
        if (canceledServices.length > 0) {
            __classPrivateFieldGet(this, _OrderPage_canceledServicesContainer, "f")
                .empty()
                .hide()
                .append(__classPrivateFieldGet(this, _OrderPage_servicesTemplate, "f").call(this, Object.assign(canceledServices, {
                isNonLuxeCruise: __classPrivateFieldGet(this, _OrderPage_header, "f").isCruise && !__classPrivateFieldGet(this, _OrderPage_header, "f").isLuxeCruise,
                hasFictionalServices: canceledServices.some(v => v.isFictional),
            })))
                .show(__classPrivateFieldGet(this, _OrderPage_renderSpeed, "f"));
        }
        __classPrivateFieldGet(this, _OrderPage_canceledServicesOutput, "f").toggle(canceledServices.length > 0);
    }, _OrderPage_renderCharterInfo = function _OrderPage_renderCharterInfo(flag) {
        __classPrivateFieldGet(this, _OrderPage_charterInfoContainer, "f").empty();
        if (flag)
            __classPrivateFieldGet(this, _OrderPage_charterInfoContainer, "f").append(__classPrivateFieldGet(this, _OrderPage_charterInfoTemplate, "f").call(this, {}));
    }, _OrderPage_renderChat = function _OrderPage_renderChat(chat) {
        __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")
            .empty()
            .append(__classPrivateFieldGet(this, _OrderPage_chatTemplate, "f").call(this, chat));
        __classPrivateFieldSet(this, _OrderPage_chatObjectContainer, $('.js-messages-container', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPage_chatObjectType, $('.js-message-object-select', __classPrivateFieldGet(this, _OrderPage_chatObjectContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPage_chatSubjectContainer, $('.js-message-subject-container', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPage_chatSubjectType, $('.js-message-subject-select', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPage_chatPnr, $('.js-message-pnr-select', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPage_pnrsSelectBlock, new App.FilterSelectBlock({ root: __classPrivateFieldGet(this, _OrderPage_chatPnr, "f") }), "f");
        $.each(__classPrivateFieldGet(this, _OrderPage_chatPnr, "f").find('.js-filter-option'), (xi, x) => {
            var _b;
            if (chat.pnrs != null && ((_b = chat.pnrs.items[xi].group) === null || _b === void 0 ? void 0 : _b.name) == '-1')
                $(x).addClass('_cancelled-avia');
        });
        __classPrivateFieldSet(this, _OrderPage_chatSubmitButton, $('.js-chat-send-message', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")), "f");
        if (chat.canChangeObject)
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, __classPrivateFieldGet(this, _OrderPage_chatObjectType, "f").valNumber(), null);
        __classPrivateFieldGet(this, _OrderPage_chatSubmitButton, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_addChatMessage).call(this, e); }));
        __classPrivateFieldSet(this, _OrderPage_chatMessageItems, $('.js-chat-message-item', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")), "f");
        $('.js-chat-agree-btn', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_setAgreeFlagMessage).call(this, e, true); }));
        $('.js-chat-disagree-btn', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_setAgreeFlagMessage).call(this, e, false); }));
        new App.Filter({ root: __classPrivateFieldGet(this, _OrderPage_chatContainer, "f") });
        __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f").hide();
        $('input:radio', __classPrivateFieldGet(this, _OrderPage_chatObjectType, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onMessageObjectChange).call(this, e));
        $('input:radio', __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onMessageSubjectChange).call(this, e));
        $('.js-jelect', __classPrivateFieldGet(this, _OrderPage_chatPnr, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onPnrChange).call(this, e));
        $('.js-visa-question-select', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f"))
            .on('change', () => {
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleVisaBlocks).call(this, __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f").find(':checked').valNumber());
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, null, __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f").find(':checked').valNumber());
        });
        $('.js-visa-city-select', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f"))
            .on('change', () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, null, __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f").find('input:radio:checked').valNumber()));
        $('.js-message-reply-on', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_scrollToMessageFromReply).call(this, e); }));
        __classPrivateFieldGet(this, _OrderPage_chatMessageItems, "f").on('mouseover', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_mouseOverMessage).call(this, $(e.currentTarget), true); }));
        __classPrivateFieldGet(this, _OrderPage_chatMessageItems, "f").on('mouseout', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_mouseOverMessage).call(this, $(e.currentTarget), false); }));
        $('.js-chat-reply-btn', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_clickMessageReply).call(this, e); }));
        $('.js-show-more-messages', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onActionShowMoreMessage).call(this); }));
    }, _OrderPage_onActionShowMoreMessage = function _OrderPage_onActionShowMoreMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            const pageIndex = __classPrivateFieldGet(this, _OrderPage_chatModel, "f").pageIndex + 1;
            // TODO: на бэке реализовать отдельным endpoint, возвращащим только сообщения для указанной страницы.
            const chatResponse = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getChat, 
            // TODO: использование pageIndex/pageSize не подходит, т.к. будут проблемы, если новое сообщение добавят вне данного инстанса чата (другой менеджер агента или ответит менеджер PW).
            { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id, pageIndex, pageSize: __classPrivateFieldGet(this, _OrderPage_chatModel, "f").pageSize });
            if (!chatResponse)
                return;
            __classPrivateFieldGet(this, _OrderPage_chatModel, "f").pageIndex = pageIndex;
            __classPrivateFieldGet(this, _OrderPage_chatModel, "f").groups = __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_mergeChatGroups).call(this, chatResponse.data.groups);
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderChatPage).call(this, __classPrivateFieldGet(this, _OrderPage_chatModel, "f").groups);
        });
    }, _OrderPage_mergeChatGroups = function _OrderPage_mergeChatGroups(newGroups) {
        const groups = [...__classPrivateFieldGet(this, _OrderPage_chatModel, "f").groups];
        newGroups.forEach(newGroup => {
            const currentGroup = groups.find(group => group.date === newGroup.date);
            if (currentGroup) {
                currentGroup.messages.push(...newGroup.messages);
            }
            else {
                groups.push(newGroup);
            }
        });
        return groups;
    }, _OrderPage_renderChatPage = function _OrderPage_renderChatPage(groups) {
        const messagesContainer = $('.js-chat-messages', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f"));
        const renderedGroups = $('.js-chat-messages-group', messagesContainer);
        groups.forEach((group, index) => {
            const renderedGroup = renderedGroups.eq(index);
            if (renderedGroup.length === 0) {
                messagesContainer.append(__classPrivateFieldGet(this, _OrderPage_chatMessagesTemplate, "f").call(this, [group]));
            }
            else if ($('.js-chat-message-item', renderedGroup).length !== group.messages.length) {
                renderedGroup.replaceWith(__classPrivateFieldGet(this, _OrderPage_chatMessagesTemplate, "f").call(this, [group]));
            }
        });
        messagesContainer.show(__classPrivateFieldGet(this, _OrderPage_renderSpeed, "f"));
        const showMoreMessagesContainer = $('.js-show-more-messages', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f"));
        if (__classPrivateFieldGet(this, _OrderPage_chatModel, "f").remainingTotalCount > 0) {
            showMoreMessagesContainer.show();
            $('.js-show-more-messages-remaining-total-count', showMoreMessagesContainer).text(__classPrivateFieldGet(this, _OrderPage_chatModel, "f").remainingTotalCount);
            $('.js-show-more-messages-remaining-page-size', showMoreMessagesContainer).text(__classPrivateFieldGet(this, _OrderPage_chatModel, "f").remainingPageSize);
        }
        else {
            showMoreMessagesContainer.hide();
        }
    }, _OrderPage_setAgreeFlagMessage = function _OrderPage_setAgreeFlagMessage(event, flag) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            const dataKey = $(target).parents('.js-message-agree-container').attr('data-key');
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.setAgreeFlagMessage, { key: dataKey, isAgree: flag });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: false }))
                return false;
            if (!response)
                return false;
            const chatResponse = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getChat, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id });
            if (chatResponse) {
                __classPrivateFieldSet(this, _OrderPage_chatModel, __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getChatModel).call(this, chatResponse.data), "f");
                __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderChat).call(this, __classPrivateFieldGet(this, _OrderPage_chatModel, "f"));
                const offset = __classPrivateFieldGet(this, _OrderPage_chatContainer, "f").find(`[data-key]=${dataKey}`).offset();
                $('html, body').animate({ scrollTop: (offset != null ? offset.top : 500) }, 'slow');
            }
            return true;
        });
    }, _OrderPage_onMessageObjectChange = function _OrderPage_onMessageObjectChange(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        const messageObject = target.valNumber();
        if (messageObject == null) {
            __classPrivateFieldGet(this, _OrderPage_pnrsSelectBlock, "f").setValue('');
            __classPrivateFieldGet(this, _OrderPage_chatPnr, "f").closest('.form-item').hide();
            __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f").hide();
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, null, null);
            return;
        }
        const messageObjectValue = messageObject.toString();
        const isAvia = messageObject === 1 /* MessageObjectKey.Avia */;
        const subjectItems = __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f").find('.js-message-subject-item');
        subjectItems.each((_, item) => {
            const subjectItem = $(item);
            const objectValue = subjectItem.attr('data-object-value');
            const isMatched = objectValue === messageObjectValue;
            subjectItem.toggle(isMatched);
            if (!isMatched) {
                subjectItem
                    .find(':radio')
                    .prop('checked', false)
                    .removeAttr('checked');
            }
        });
        const matchedSubjectItems = subjectItems.filter((_, item) => $(item).attr('data-object-value') === messageObjectValue);
        if (!isAvia) {
            __classPrivateFieldGet(this, _OrderPage_pnrsSelectBlock, "f").setValue('');
        }
        __classPrivateFieldGet(this, _OrderPage_chatPnr, "f").closest('.form-item').toggle(isAvia);
        if (matchedSubjectItems.length === 0) {
            __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f").hide();
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, messageObject, null);
            return;
        }
        __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f").show();
        const checkedMatchedSubject = matchedSubjectItems.find('input:radio[name="Form.MessageSubject"]:checked');
        if (checkedMatchedSubject.length === 0) {
            matchedSubjectItems
                .first()
                .find(':radio')
                .prop('checked', true)
                .trigger('change');
        }
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleVisaBlocks).call(this, __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f").find(':checked').valNumber());
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, messageObject, null);
    }, _OrderPage_onMessageSubjectChange = function _OrderPage_onMessageSubjectChange(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        const subjectKey = target.valNumber();
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleVisaBlocks).call(this, subjectKey);
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, null, subjectKey);
    }, _OrderPage_onPnrChange = function _OrderPage_onPnrChange(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        const subjectKey = __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f").find(':checked').valNumber();
        const clsName = '_cancelled-avia';
        if (target.find('.jelect-option_state_active').hasClass(clsName))
            target.closest('.form-item').addClass(clsName);
        else
            target.closest('.form-item').removeClass(clsName);
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, null, subjectKey);
    }, _OrderPage_toggleVisaBlocks = function _OrderPage_toggleVisaBlocks(subjectKey) {
        var _b, _c;
        const visaQuestionContainer = $('.js-visa-question-container', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f"));
        const visaQuestionSelect = $('.js-visa-question-select', visaQuestionContainer);
        const visaQuestionAnswer = $('.js-visa-question-answer', visaQuestionContainer);
        const visaCityContainer = $('.js-visa-city-container', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f"));
        const visaCitySelect = $('.js-visa-city-select', visaCityContainer);
        let visaQuestionWho = null;
        switch (subjectKey) {
            case 13 /* MessageSubjectKey.SubmittedDocuments */:
            case 14 /* MessageSubjectKey.IssuanceOfDocuments */:
                visaQuestionWho = App.VisaQuestionWho.Opvd;
                break;
            case 15 /* MessageSubjectKey.VisaFormalities */:
                visaQuestionWho = App.VisaQuestionWho.VisaSpecialist;
                break;
        }
        const shouldShowVisaQuestions = visaQuestionWho !== null;
        visaQuestionContainer.toggle(shouldShowVisaQuestions);
        visaQuestionSelect.find('option').each((_, element) => {
            var _b, _c;
            const option = $(element);
            const value = (_c = (_b = option.val()) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
            const optionWho = option.attr('data-who');
            const shouldShow = value === ''
                || value === '0'
                || optionWho === visaQuestionWho;
            option.prop('hidden', !shouldShow)
                .prop('disabled', !shouldShow);
        });
        const selectedOption = visaQuestionSelect.find(':selected');
        if (selectedOption.prop('disabled'))
            visaQuestionSelect.val('0');
        visaQuestionAnswer.empty().hide();
        if (!shouldShowVisaQuestions)
            visaQuestionSelect.val('0');
        const selectedVisaQuestion = (_c = (_b = visaQuestionSelect.val()) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '0';
        const shouldHideMessageInput = shouldShowVisaQuestions
            && selectedVisaQuestion !== ''
            && selectedVisaQuestion !== '0';
        const messageInput = $('.js-chat-input', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f"));
        messageInput.closest('.form-item')
            .toggle(!shouldHideMessageInput);
        if (shouldHideMessageInput)
            messageInput.val('');
        const shouldShowVisaCities = subjectKey === 15 /* MessageSubjectKey.VisaFormalities */
            || (shouldShowVisaQuestions
                && selectedVisaQuestion === '0');
        visaCityContainer.toggle(shouldShowVisaCities);
        if (!shouldShowVisaCities)
            visaCitySelect.val('');
    }, _OrderPage_toggleSubmitButton = function _OrderPage_toggleSubmitButton(objectKey, subjectKey) {
        var _b, _c, _d, _e;
        const selectedObjectKey = objectKey !== null && objectKey !== void 0 ? objectKey : __classPrivateFieldGet(this, _OrderPage_chatObjectType, "f")
            .find(':checked')
            .valNumber();
        const selectedSubjectKey = subjectKey !== null && subjectKey !== void 0 ? subjectKey : __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f")
            .find(':checked')
            .valNumber();
        const hasSubjectsForSelectedObject = selectedObjectKey != null
            && __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f")
                .find(`.js-message-subject-item[data-object-value="${selectedObjectKey}"]`)
                .length > 0;
        const isAvia = selectedObjectKey === 1 /* MessageObjectKey.Avia */;
        const isVisa = selectedObjectKey === 3 /* MessageObjectKey.Visa */;
        const isSubmittedDocuments = selectedSubjectKey === 13 /* MessageSubjectKey.SubmittedDocuments */;
        const isIssuanceOfDocuments = selectedSubjectKey === 14 /* MessageSubjectKey.IssuanceOfDocuments */;
        const isVisaSubmissionCity = selectedSubjectKey === 15 /* MessageSubjectKey.VisaFormalities */;
        const selectedVisaQuestion = (_c = (_b = $('.js-visa-question-select', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f")).val()) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
        const selectedVisaCity = (_e = (_d = $('.js-visa-city-select', __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f")).val()) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '';
        const isVisaQuestionWithoutConcreteAnswer = selectedVisaQuestion === '0';
        const isVisaCityRequired = isVisa
            && (isVisaSubmissionCity
                || ((isSubmittedDocuments || isIssuanceOfDocuments) && isVisaQuestionWithoutConcreteAnswer));
        const isDisabled = selectedObjectKey == null
            || (hasSubjectsForSelectedObject && selectedSubjectKey == null)
            || (isAvia && __classPrivateFieldGet(this, _OrderPage_pnrsSelectBlock, "f").getValue() === '')
            || (isVisaCityRequired && selectedVisaCity === '');
        __classPrivateFieldGet(this, _OrderPage_chatSubmitButton, "f").toggleClass('_disabled', isDisabled);
    }, _OrderPage_aviaAskQuestion = function _OrderPage_aviaAskQuestion(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            $('input[value=1]', __classPrivateFieldGet(this, _OrderPage_chatObjectType, "f")).prop('checked', true);
            __classPrivateFieldGet(this, _OrderPage_chatSubjectType, "f").find('input:radio').each((ix, x) => {
                $(x).attr('checked', '');
                $(x).removeAttr('checked');
            });
            __classPrivateFieldGet(this, _OrderPage_chatSubjectContainer, "f").show();
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_toggleSubmitButton).call(this, 1, null);
            const target = $(event.currentTarget);
            const pnr = '' + $(target).attr('data-val');
            __classPrivateFieldGet(this, _OrderPage_pnrsSelectBlock, "f").setValue(pnr);
        });
    }, _OrderPage_addChatMessage = function _OrderPage_addChatMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPage_header, "f").isPw)
                return false;
            const target = $(event.currentTarget);
            const form = target.closest('form');
            const messageInput = form.find('.js-chat-input');
            const selectedObjectKey = form
                .find('input:radio[name="Form.MessageObject"]:checked')
                .valNumber();
            const visaQuestionSelect = form.find('.js-visa-question-select');
            const selectedVisaQuestion = (_c = (_b = visaQuestionSelect.val()) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
            const hasSelectedVisaQuestion = selectedObjectKey === 3 /* MessageObjectKey.Visa */
                && selectedVisaQuestion !== ''
                && selectedVisaQuestion !== '0';
            let message = messageInput.valString();
            if (hasSelectedVisaQuestion) {
                const visaQuestionText = visaQuestionSelect
                    .find(':selected')
                    .text()
                    .trim();
                messageInput.val(visaQuestionText);
                message = visaQuestionText;
            }
            if (message.length <= 0)
                return false;
            // TODO: перенести в настройки, получаемые от сервера.
            if (message.length > 1500) {
                $('.js-chat-validate-message', __classPrivateFieldGet(this, _OrderPage_chatContainer, "f")).show();
                return false;
            }
            const serializedForm = form.serializeArray();
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_appendVisaChatFields).call(this, serializedForm, form);
            App.popupHide();
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.addChatMessage, $.param(serializedForm), () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataSaving).call(_a)), () => App.popupHide());
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: false }))
                return false;
            messageInput.val('');
            const chatResponse = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getChat, {
                id: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                pageIndex: 0,
                pageSize: __classPrivateFieldGet(this, _OrderPage_chatModel, "f").pageSize,
            });
            if (!chatResponse)
                return false;
            __classPrivateFieldSet(this, _OrderPage_chatModel, __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getChatModel).call(this, chatResponse.data), "f");
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderChat).call(this, __classPrivateFieldGet(this, _OrderPage_chatModel, "f"));
            const offset = __classPrivateFieldGet(this, _OrderPage_chatContainer, "f").offset();
            $('html, body').animate({ scrollTop: (offset != null ? offset.top : 500) }, 'slow');
            return true;
        });
    }, _OrderPage_setSerializedValue = function _OrderPage_setSerializedValue(items, name, value) {
        const stringValue = value == null ? '' : value.toString();
        const existingItem = items.find(v => v.name === name);
        if (existingItem) {
            existingItem.value = stringValue;
            return;
        }
        items.push({
            name,
            value: stringValue,
        });
    }, _OrderPage_appendVisaChatFields = function _OrderPage_appendVisaChatFields(items, form) {
        var _b, _c, _d, _e, _f;
        const messageObject = form.find(':checked').valNumber();
        if (messageObject !== 3 /* MessageObjectKey.Visa */)
            return;
        const visaQuestionSelect = form.find('.js-visa-question-select');
        const visaCitySelect = form.find('.js-visa-city-select');
        const visaQuestion = (_c = (_b = visaQuestionSelect.val()) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
        const visaCity = (_e = (_d = visaCitySelect.val()) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '';
        const visaAnswer = (_f = visaQuestionSelect.find(':selected').attr('data-answer')) !== null && _f !== void 0 ? _f : '';
        __classPrivateFieldGet(_a, _a, "m", _OrderPage_setSerializedValue).call(_a, items, 'Form.VisaQuestion', visaQuestion);
        __classPrivateFieldGet(_a, _a, "m", _OrderPage_setSerializedValue).call(_a, items, 'Form.VisaCity', visaCity);
        __classPrivateFieldGet(_a, _a, "m", _OrderPage_setSerializedValue).call(_a, items, 'Form.VisaAnswer', visaAnswer);
    }, _OrderPage_getChatModel = function _OrderPage_getChatModel(data) {
        const model = new App.OrderChatModel(data);
        model.dogovorKey = __classPrivateFieldGet(this, _OrderPage_header, "f").key;
        model.dogovorNumber = __classPrivateFieldGet(this, _OrderPage_options, "f").id;
        return model;
    }, _OrderPage_clickMessageReply = function _OrderPage_clickMessageReply(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            const dataKey = $(target).parent('.js-message-reply-container').attr('data-key');
            if (!dataKey) {
                return;
            }
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showReplyDialog).call(this, Number(dataKey || '0'));
        });
    }, _OrderPage_showReplyDialog = function _OrderPage_showReplyDialog(dataKey) {
        const originMessage = __classPrivateFieldGet(this, _OrderPage_chatModel, "f").messages.find(m => m.key == dataKey);
        const title = 'Ответ на сообщение';
        const chatData = new App.OrderChatModel(__classPrivateFieldGet(this, _OrderPage_chatModel, "f")); // chatData это клон от _chatModel (чтобы не затереть данные в _chatModel)
        chatData.canSendMessage = true;
        chatData.canChangeObject = false;
        chatData.messageObjectItems = [];
        chatData.messageSubjectItems = [];
        chatData.visaQuestionItems = [];
        chatData.visaCities = [];
        chatData.reply = {
            key: dataKey,
            text: originMessage != null ? originMessage.text : '',
        };
        App.popupHide();
        const dialog = $(App.templates.Order.ChatReply(chatData));
        App.popupShow(dialog, title);
        dialog.on('click', '.js-chat-send-message', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_addChatMessage).call(this, e); }));
    }, _OrderPage_scrollToMessageFromReply = function _OrderPage_scrollToMessageFromReply(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            const dataKey = $(target).attr('data-replyon-key');
            __classPrivateFieldGet(this, _OrderPage_chatMessageItems, "f").each((i, v) => {
                const $v = $(v);
                if ($v.attr('data-key') == dataKey) {
                    __classPrivateFieldGet(_a, _a, "m", _OrderPage_scrollTo).call(_a, $v);
                    __classPrivateFieldGet(_a, _a, "m", _OrderPage_animBackgroundYellow).call(_a, $v.find('.message__content'));
                    return false;
                }
            });
        });
    }, _OrderPage_mouseOverMessage = function _OrderPage_mouseOverMessage(target, isOver) {
        return __awaiter(this, void 0, void 0, function* () {
            const replyBlock = target.find('.js-message-reply-container');
            if (replyBlock) {
                replyBlock.toggle(isOver);
            }
        });
    }, _OrderPage_scrollTo = function _OrderPage_scrollTo(target, speed = 200) {
        const targetOffset = target.offset();
        if (!targetOffset) {
            return;
        }
        $('html, body').animate({ scrollTop: targetOffset.top }, speed);
    }, _OrderPage_animBackground = function _OrderPage_animBackground(target, backgroundColor = '#52A300', color = '#FFF', speed = 500) {
        const orcolor = target.css('background-color');
        target.css('transition', 'background-color 0.0s');
        target.animate({ backgroundColor: backgroundColor, color: color }, speed).animate({ backgroundColor: orcolor, color: '#000000' }, speed, 'swing', function () { $(this).css('background-color', ''); $(this).css('color', ''); $(this).css('transition', ''); });
    }, _OrderPage_animBackgroundYellow = function _OrderPage_animBackgroundYellow(target, speed = 1000) {
        __classPrivateFieldGet(_a, _a, "m", _OrderPage_animBackground).call(_a, target, '#ffc107', '#000000', speed);
    }, _OrderPage_copyTouristData = function _OrderPage_copyTouristData(event, cssClass, isPhoneData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.currentTarget);
            const baseBlock = target.closest('.js-order-tourist');
            const savedData = new Array();
            baseBlock.find(`.${cssClass} input`).each((i, v) => {
                savedData.push({ name: $(v).attr('name') || '', value: $(v).val() });
            });
            if (isPhoneData) {
                const cPhone = ((_b = savedData.find(i => i.name === 'Tourist.ConfidantPhone')) === null || _b === void 0 ? void 0 : _b.value) || '';
                if (savedData.length === 0 || cPhone.length === 0)
                    return;
                baseBlock.find('.js-errorComparePhones').hide();
                if (__classPrivateFieldGet(_a, _a, "m", _OrderPage_isConfidantPhoneContainedInTouristsPhones).call(_a, cPhone)) {
                    baseBlock.find('.js-errorComparePhones').show();
                    return;
                }
            }
            const promises = [];
            baseBlock.nextAll('.js-order-tourist').each((i, v) => {
                if (!$(v).find('.js-order-tourist-editor').hasClass('js-editor-open')) {
                    promises.push(__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_openTouristEditor).call(this, $(v).find('.js-order-tourist-edit')));
                }
            });
            yield Promise.all(promises);
            baseBlock.nextAll('.js-order-tourist').each((i, v) => {
                savedData.forEach(d => {
                    const finded = $(v).find(`.${cssClass} input[name="${d.name}"]`);
                    if (finded.hasClass('js-jelect-input')) {
                        finded.parent().find(`.js-jelect-option[data-val="${d.value}"]`).trigger('click');
                    }
                    else {
                        finded.val(d.value).attr('value', d.value);
                    }
                });
            });
        });
    }, _OrderPage_onClickCustomerTourist = function _OrderPage_onClickCustomerTourist(e) {
        if ($(e.target).is(':checked')) {
            $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
        }
        else {
            $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('input[name="ExistingTouristKey"]', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).val('');
        }
    }, _OrderPage_showElectronicTripContainer = function _OrderPage_showElectronicTripContainer(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const container = target.closest('.js-ep-show-hide-container');
            if (__classPrivateFieldGet(this, _OrderPage_loadElectronicTripExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderPage_loadElectronicTripExecuting, true, "f");
            container.find('.js-ep-show-more-link-show')
                .find('span')
                .text('Идет загрузка...');
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_loadElectronicTrip).call(this);
            container.find('.js-ep-show-more-link-show')
                .removeClass('_folded')
                .addClass('_unfolded')
                .slideUp();
            container.find('.js-ep-show-more-link-show')
                .find('span')
                .text('Открыть информацию для Электронной путевки');
            container.find('.js-ep-show-more-link-hide')
                .removeClass('_unfolded')
                .addClass('_folded')
                .slideDown();
            __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f").show();
            __classPrivateFieldSet(this, _OrderPage_electronicTripForm, new App.Form({ root: __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f").find('form') }), "f");
            __classPrivateFieldSet(this, _OrderPage_loadElectronicTripExecuting, false, "f");
        });
    }, _OrderPage_loadElectronicTrip = function _OrderPage_loadElectronicTrip() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_options, "f").showElectronicTrip)
                return;
            const tripResponse = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.loadElectronicTrip, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id });
            if (!tripResponse || !tripResponse.data)
                return null;
            if (tripResponse.data.countries.length <= 0 || tripResponse.data.documentTypes.length <= 0) {
                App.popupShow($('<h3>Данные из справочников отсутствуют</h3>'), 'Получение данных');
                return null;
            }
            const electronicTrip = tripResponse.data.electronicTrip;
            const etModel = Object.assign(Object.assign({}, electronicTrip), { orderNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id, tourSum: __classPrivateFieldGet(this, _OrderPage_options, "f").electronicTripTourSum, tourCostMax: __classPrivateFieldGet(this, _OrderPage_options, "f").electronicTripTourCostMax, countries: new App.SelectListModel({
                    name: 'CustomerCountry',
                    form: true,
                    autocomplete: true,
                    items: tripResponse.data.countries
                        .map(v => ({
                        value: v.value,
                        text: v.text,
                        selected: electronicTrip.customerCountry == v.value || electronicTrip.customerCountry == null && v.value == '',
                    })),
                    htmlAttributes: {
                        required: 'required',
                    },
                }), documentTypes: new App.SelectListModel({
                    name: 'CustomerDocumentType',
                    form: true,
                    autocomplete: false,
                    items: tripResponse.data.documentTypes
                        .map(v => ({
                        value: v.value,
                        text: v.text,
                        selected: electronicTrip.customerDocumentType == v.value || electronicTrip.customerDocumentType == null && v.value == '',
                    })),
                    htmlAttributes: {
                        required: 'required',
                    },
                }), customerTypes: new App.SelectListModel({
                    name: 'CustomerType',
                    form: true,
                    autocomplete: false,
                    items: tripResponse.data.customerTypes
                        .map(v => ({
                        value: v.value,
                        text: v.text,
                        selected: electronicTrip.customerType == v.value || electronicTrip.customerType == null && v.value == '',
                    })),
                    htmlAttributes: {
                        required: 'required',
                    },
                }), existingTourists: __classPrivateFieldGet(this, _OrderPage_header, "f").tourists, canSave: tripResponse.data.canSave });
            const templateElectronicTrip = $(App.templates.Order.ElectronicTrip(etModel));
            __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")
                .empty()
                .append(templateElectronicTrip);
            this.components.push(new App.ExistingTourists());
            new App.Filter({ root: __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f") });
            const currentDate = new Date();
            const minYear = currentDate.getFullYear() - 50;
            const contractNumberInput = $('.js-form-item-field', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f"));
            contractNumberInput.inputmask();
            const calendar = $('.js-form-date', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f"));
            calendar.inputmask('date');
            const calendarIcons = $('.js-form-date-icon', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f"));
            calendarIcons.on('click', e => $(e.currentTarget).prev('.js-form-date').trigger('focus'));
            const calendarField = $('.js-past-date .js-form-date', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f"));
            calendarField.datepicker('option', {
                yearRange: `${minYear}:${currentDate.getFullYear()}`,
                minDate: -50 * 365,
                maxDate: currentDate,
            });
            $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-surname', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-phone', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-email', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-inn', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
            $('.js-customer-type-select .js-jelect', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onCustomerTypeChange).call(this, e));
            $('.js-customer-tourist-checkbox', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).on('click', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onClickCustomerTourist).call(this, e));
            $('.js-jelect-ep-document-types', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onETDocumentTypeChange).call(this, e));
            $('.js-electronictrip-save', templateElectronicTrip).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_saveElectronicTrip).call(this, e); }));
            $('.js-customer-type-select .js-jelect', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).trigger('change');
            if ($('.js-customer-tourist-checkbox', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).is(':checked')) {
                $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
            }
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_setDocumentNumberMask).call(_a, __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f"));
        });
    }, _OrderPage_setDocumentNumberMask = function _OrderPage_setDocumentNumberMask(container) {
        const documentTypeBlock = $('.js-jelect-ep-document-types', container);
        const documentType = $('.js-jelect-input', documentTypeBlock).valString();
        const documentInput = $('.js-et-document-number .js-form-item-field', container);
        const mask = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getDocumentNumberMask).call(_a, documentType);
        documentTypeBlock.val(mask.type);
        documentInput.inputmask(mask.inputmask);
    }, _OrderPage_getDocumentNumberMask = function _OrderPage_getDocumentNumberMask(documentType) {
        const defaultMask = { type: 'ХХ01001', inputmask: { mask: '*{6,18}', autoUnmask: true, greedy: false } };
        if (documentType == 'RU01004') {
            return {
                type: 'RU01004',
                inputmask: {
                    mask: '999999999',
                    autoUnmask: true,
                },
            };
        }
        if (documentType == 'RU01001') {
            return {
                type: 'RU01001',
                inputmask: {
                    mask: '9999999999',
                    autoUnmask: true,
                },
            };
        }
        return defaultMask;
    }, _OrderPage_onETDocumentTypeChange = function _OrderPage_onETDocumentTypeChange(event) {
        event.preventDefault();
        __classPrivateFieldGet(_a, _a, "m", _OrderPage_setDocumentNumberMask).call(_a, __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f"));
    }, _OrderPage_hideElectronicTripContainer = function _OrderPage_hideElectronicTripContainer(event) {
        const target = $(event.currentTarget);
        const container = target.closest('.js-ep-show-hide-container');
        container.find('.js-ep-show-more-link-show')
            .removeClass('_unfolded')
            .addClass('_folded')
            .slideDown();
        container.find('.js-ep-show-more-link-hide')
            .removeClass('_folded')
            .addClass('_unfolded')
            .slideUp();
        __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f").hide();
        __classPrivateFieldSet(this, _OrderPage_electronicTripForm, undefined, "f");
    }, _OrderPage_onCustomerTypeChange = function _OrderPage_onCustomerTypeChange(event) {
        event.preventDefault();
        $('.js-save-button-container', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).removeClass('_dspn');
        const target = $(event.currentTarget);
        const customerType = target.valString();
        switch (customerType) {
            case 'ФЛ':
                $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                if ($('.js-customer-tourist-checkbox', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).is(':checked')) {
                    $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                }
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                break;
            case 'ЮЛ':
                $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-inn .js-form-item-field', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).inputmask({ mask: '9999999999', autoUnmask: true });
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                break;
            case 'ИП':
                $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).show();
                $('.js-et-inn .js-form-item-field', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).inputmask({ mask: '999999999999', autoUnmask: true });
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                break;
            case '':
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).hide();
                $('.js-save-button-container', __classPrivateFieldGet(this, _OrderPage_electronicTripContainer, "f")).addClass('_dspn');
                break;
        }
    }, _OrderPage_saveElectronicTrip = function _OrderPage_saveElectronicTrip(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _OrderPage_electronicTripForm, "f") || !__classPrivateFieldGet(this, _OrderPage_electronicTripForm, "f").validator.form())
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_saveElectronicTripExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_saveElectronicTripExecuting, true, "f");
            const root = $(e.currentTarget).closest('form');
            const responseValidator = new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _OrderPage_popup, "f")),
                validator: __classPrivateFieldGet(this, _OrderPage_electronicTripForm, "f").validator,
                allowEmptyData: true,
            });
            const data = root.serialize();
            const popupGroup = __classPrivateFieldGet(this, _OrderPage_popup, "f").show({
                group: 'main',
                content: App.templates.Order.Messages.Saving({}),
                delay: 300,
                modal: true,
            });
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const xhr = $.ajax({
                        url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.saveElectronicTrip,
                        method: 'POST',
                        data,
                    });
                    const result = yield xhr;
                    if (!responseValidator.process(result))
                        return undefined;
                    return result;
                }), signal);
                if (!response)
                    return false;
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _OrderPage_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _OrderPage_saveElectronicTripExecuting, false, "f");
            }
            return true;
        });
    }, _OrderPage_showCancelOrderDialog = function _OrderPage_showCancelOrderDialog() {
        const title = __classPrivateFieldGet(this, _OrderPage_options, "f").contentType === 1 /* OrderContentType.PW */
            ? 'Аннуляция заказа'
            : 'Запрос аннуляции заказа';
        const data = {
            hasMtSerices: __classPrivateFieldGet(this, _OrderPage_options, "f").contentType === 0 /* OrderContentType.MT */
                || __classPrivateFieldGet(this, _OrderPage_options, "f").contentType === 2 /* OrderContentType.Mixed */,
            hasPwSerices: __classPrivateFieldGet(this, _OrderPage_options, "f").contentType === 1 /* OrderContentType.PW */
                || __classPrivateFieldGet(this, _OrderPage_options, "f").contentType === 2 /* OrderContentType.Mixed */,
        };
        const dialog = $(App.templates.Order.CancelOrderDialog(data));
        App.popupShow(dialog, title);
        dialog.on('click', '.js-cancel-order-close', () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_closeCancelOrderDialog).call(this));
        dialog.on('click', '.js-cancel-order-reason-send', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_sendCancelOrderReason).call(this, e); }));
    }, _OrderPage_sendCancelOrderReason = function _OrderPage_sendCancelOrderReason(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const input = target.closest('.js-cancel-order-dialog').find('textarea');
                const reason = input.valString();
                if (reason.length <= 0) {
                    input.trigger('focus');
                    return false;
                }
                yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.cancelOrder, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id, reason });
                // TODO: возможно, проверять ответ.
                App.modalShow($(App.templates.Order.CancelOrderSuccess({})), 'Сообщение отправлено.');
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_closeCancelOrderDialog = function _OrderPage_closeCancelOrderDialog() {
        App.popupHide();
        const servicesContainerOffset = __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f").offset();
        $('html, body').animate({ scrollTop: (servicesContainerOffset != null ? servicesContainerOffset.top - 100 : 0) }, 'slow');
    }, _OrderPage_openTouristEditor = function _OrderPage_openTouristEditor(target) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const parent = target.closest('.js-order-tourist');
            const touristKey = Number(parent.find('.js-order-tourist-info').attr('data-touristkey'));
            target.toggle();
            $('.js-loader', target.parent()).toggle();
            let existTourist = null;
            if (__classPrivateFieldGet(this, _OrderPage_touristData, "f").length > 0)
                existTourist = __classPrivateFieldGet(this, _OrderPage_touristData, "f").find(v => v.key === touristKey);
            if (!existTourist) {
                const touristResponse = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.loadTourist, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id, touristKey });
                App.popupHide();
                if (!App.validateResponse(touristResponse, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return;
                if (!touristResponse)
                    return;
                existTourist = touristResponse.data;
                __classPrivateFieldGet(this, _OrderPage_touristData, "f").push(existTourist);
            }
            __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_initTourist).call(this, existTourist);
            parent
                .empty()
                .append(App.templates.Order.OrderTourist(existTourist));
            parent
                .css('height', '34px')
                .find('.js-order-tourist-editor')
                .addClass('js-editor-open')
                .empty()
                .append(App.templates.Order.OrderTouristEditor(existTourist));
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_jelectInit).call(_a, parent);
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_autocompleteInit).call(_a, parent);
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_calendarInit).call(_a, parent);
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_setIssueDateValidation).call(_a, parent);
            this.components.push(new App.FindTourist());
            parent.find('.js-order-tourist-filter').on("findTouristOption:click" /* Events.FindTouristOptionClick */, (e, data) => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onChangeFindTourist).call(this, e, data));
            const visaType = ((_b = $('.js-order-visaType .js-jelect', parent).val()) === null || _b === void 0 ? void 0 : _b.toString()) || '';
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_updateVisibleFields).call(_a, visaType);
            $('.js-form-item-field', parent).inputmask();
            // TODO Timoshkina: перейти на Filter
            const visaTypesBlock = $('.js-order-visaType', parent);
            $('.js-jelect', visaTypesBlock).on('change', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onChangeChinaVisaType).call(this, e));
            const countryBlock = $('.js-order-load-chinaCities', parent);
            $('.js-jelect', countryBlock).on('change', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onChangeChinaCountry).call(this, e); }));
            const autocompleteBlock = $('.js-form-autocomplete-block[data-name="ChinaHotelName"]', parent);
            autocompleteBlock.on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, () => __awaiter(this, void 0, void 0, function* () {
                const address = $('.js-point-type', parent).val() || '';
                $('input[name="Tourist.ChinaHotelAddress"]', parent).val(address);
            }));
            $('.js-jelect', countryBlock).on('change', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onChangeChinaCountry).call(this, e); }));
            parent
                .find('.js-order-tourist-info')
                .hide();
            parent
                .css('height', '70px')
                .find('.js-order-tourist-editor')
                .show('slow');
            $('.js-form-item-field', this.root).inputmask();
            $('.js-msc-birthCountry', this.root).inputmask({
                regex: '^[a-zA-Z]+$',
                placeholder: '',
            });
        });
    }, _OrderPage_onChangeFindTourist = function _OrderPage_onChangeFindTourist(event, data) {
        const target = $(event.currentTarget);
        // gender, на странице заказа пол указан через запятую: '0,0' и '1,1'
        const value = data.gender;
        if (value) {
            const selectBlock = target.find('.js-form-select-block[data-type="gender"]');
            if (selectBlock.length > 0) {
                const sblock = new App.FilterSelectBlock({ root: $(selectBlock) });
                const newval = value + ',' + value;
                sblock.setValue(newval);
            }
        }
        // паспорт
        const isRusPassport = data.isRussianPassport == '1';
        const nameParts = ['docSeries', 'docNumber', 'documentIssueDate', 'documentExpirationDate'];
        $.each(nameParts, (__, item2) => {
            const inputNameDop = isRusPassport ? 'Ru' : 'Zg';
            const input = target.find(`input[data-type='${item2}${inputNameDop}']`);
            if (input.length > 0) {
                input.val('');
                input.val(data[item2]).trigger('change');
            }
        });
    }, _OrderPage_onChangeChinaVisaType = function _OrderPage_onChangeChinaVisaType(event) {
        const val = $(event.currentTarget).valString();
        __classPrivateFieldGet(_a, _a, "m", _OrderPage_updateVisibleFields).call(_a, val);
    }, _OrderPage_updateVisibleFields = function _OrderPage_updateVisibleFields(value) {
        const parent = $('.js-order-visaType').closest('.js-tourist-china-block');
        if (value == '240') {
            $('[data-visaType]', parent).show();
            $('input', $('[data-visaType="240"]', parent)).not('[name$=".Search"]').not('[data-not-required]').each((i, v) => v.setAttribute('required', 'required'));
        }
        else if (value == '24') {
            $('[data-visaType="24"]', parent).show();
            $('input', $('[data-visaType="24"]', parent)).not('[name$=".Search"]').each((i, v) => v.setAttribute('required', 'required'));
            $('[data-visaType="240"]', parent).hide();
            $('[data-visaType="240"] input').val('');
            $('input', $('[data-visaType="240"]', parent)).each((i, v) => v.removeAttribute('required'));
        }
        else {
            $('[data-visaType]', parent).hide();
            $('[data-visaType] input').val('');
            $('input', $('[data-visaType]', parent)).each((i, v) => v.removeAttribute('required'));
            $('[data-visaType] .js-scroller .js-filter-option[data-val="0"]').trigger('click');
        }
    }, _OrderPage_onChangeChinaCountry = function _OrderPage_onChangeChinaCountry(event_1) {
        return __awaiter(this, arguments, void 0, function* (event, signal = App.noneSignal) {
            const target = $(event.currentTarget);
            const parent = target.closest('.js-tourist-china-block');
            const val = target.valNumber();
            if (val == 0) {
                const defOpt = [{ text: 'Выберите сначала страну', selected: true }];
                this.updateCityOptions(defOpt, parent);
                return true;
            }
            const textVal = target.find('.jelect-option_state_active .js-jelect-option-value').text();
            $('#js-chinaReturnFlightArrCountry', parent).val(textVal);
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const editHhr = $.ajax({
                        url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.getCities,
                        method: 'POST',
                        data: `id=${val}`,
                    });
                    const result = yield editHhr;
                    if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(result))
                        return null;
                    return result;
                }), signal);
                if (!response)
                    return false;
                this.updateCityOptions(response.data.items, parent, true);
                return true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex)) {
                    throw ex;
                }
            }
            finally {
                __classPrivateFieldGet(this, _OrderPage_popup, "f").hide();
            }
            return true;
        });
    }, _OrderPage_showTouristEditor = function _OrderPage_showTouristEditor(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPage_header, "f").isPw)
                return;
            const target = $(event.currentTarget);
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_openTouristEditor).call(this, target);
        });
    }, _OrderPage_transliterate = function _OrderPage_transliterate(event) {
        if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPage_header, "f").isPw)
            return false;
        const target = $(event.currentTarget);
        target.val(App.transliterateName(target.valString()));
        return true;
    }, _OrderPage_cancelTouristEditor = function _OrderPage_cancelTouristEditor(event) {
        const target = $(event.currentTarget);
        const parent = target.closest('.js-order-tourist');
        parent
            .css('height', '34px')
            .find('.js-order-tourist-editor')
            .hide('slow')
            .removeClass('js-editor-open');
        parent
            .find('.js-order-tourist-info')
            .show('slow');
    }, _OrderPage_isConfidantPhoneContainedInTouristsPhones = function _OrderPage_isConfidantPhoneContainedInTouristsPhones(phone) {
        const listTouristPhones = $('.js-order-tourist-editor').find('.js-tourist-phone').get().map(item => $(item).valString().replace('+', '')).filter(x => x);
        return listTouristPhones.includes(phone.replace('+', ''));
    }, _OrderPage_editTourist = function _OrderPage_editTourist(event_1) {
        return __awaiter(this, arguments, void 0, function* (event, signal = App.noneSignal) {
            var _b;
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPage_header, "f").isPw)
                return false;
            const target = $(event.currentTarget);
            const form = target.closest('form');
            const newform = new App.Form({ root: form, disableStepValidation: true });
            __classPrivateFieldSet(this, _OrderPage_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _OrderPage_popup, "f")),
                validator: newform.validator,
                allowEmptyData: true,
            }), "f");
            if (!newform.validator.form())
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_options, "f").isCruiseOrder) {
                const curTourist = target.closest('.js-order-tourist-editor');
                const confidantPhone = (_b = curTourist.find('.js-confidantPhone').valString()) !== null && _b !== void 0 ? _b : '';
                curTourist.find('.js-errorComparePhones').hide();
                if (__classPrivateFieldGet(_a, _a, "m", _OrderPage_isConfidantPhoneContainedInTouristsPhones).call(_a, confidantPhone)) {
                    curTourist.find('.js-errorComparePhones').show();
                    return false;
                }
            }
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataSaving).call(_a));
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const editHhr = $.ajax({
                        url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.editTourist,
                        method: 'POST',
                        data: `${form.serialize()}&DogovorNumber=${__classPrivateFieldGet(this, _OrderPage_options, "f").id}`,
                    });
                    const result = yield editHhr;
                    if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(result))
                        return null;
                    return result;
                }), signal);
                if (!response)
                    return false;
                const touristKey = form.find('[name$="Key"]').valNumber();
                const touristResponse = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.loadTourist, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id, touristKey });
                App.popupHide();
                if (!App.validateResponse(touristResponse, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!touristResponse)
                    return false;
                const existTouristIndex = __classPrivateFieldGet(this, _OrderPage_touristData, "f").findIndex(v => v.key === touristKey);
                if (existTouristIndex === -1)
                    __classPrivateFieldGet(this, _OrderPage_touristData, "f").push(touristResponse.data);
                else
                    __classPrivateFieldGet(this, _OrderPage_touristData, "f")[existTouristIndex] = touristResponse.data;
                __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_initTourist).call(this, touristResponse.data);
                const parent = form.closest('.js-order-tourist');
                parent
                    .empty()
                    .css('height', '34px')
                    .append(App.templates.Order.OrderTourist(touristResponse.data));
                __classPrivateFieldGet(_a, _a, "m", _OrderPage_jelectInit).call(_a, parent);
                __classPrivateFieldGet(_a, _a, "m", _OrderPage_calendarInit).call(_a, parent);
                return true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex)) {
                    throw ex;
                }
            }
            finally {
                __classPrivateFieldGet(this, _OrderPage_popup, "f").hide();
                App.popupHide();
            }
            return true;
        });
    }, _OrderPage_addPwService = function _OrderPage_addPwService(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            const self = $(event.currentTarget);
            if (self.attr('data-no-booking') != null) {
                App.popupShow($('<div class="pr-subtitle">Добронь услуги возможна только к заказу, номинированному в EUR или USD. Просим обратиться к ведущему менеджеру</div>'), 'Добавление услуги');
                return false;
            }
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.addPwService, {
                id: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                serviceType: self.attr('data-service-type'),
                forCruise: self.attr('data-for-cruise'),
            }, () => { App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataLoading).call(_a)); });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                return false;
            if (!response || !response.data)
                return null;
            if (!response.data.link) {
                App.popupShow($('<div class="pr-subtitle">Произошла ошибка. Попробуйте еще раз</div>'), 'Добавление услуги');
                return null;
            }
            window.location.href = `${response.data.link}`;
            return true;
        });
    }, _OrderPage_showAddAviaCruiseDialog = function _OrderPage_showAddAviaCruiseDialog() {
        if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
            return false;
        App.popupShow($(App.templates.Order.AddAviaCruiseDialog({})), 'Добронирование авиаперелета');
        return true;
    }, _OrderPage_agreeToAddAviaCruise = function _OrderPage_agreeToAddAviaCruise(event) {
        const self = $(event.currentTarget);
        if (self.is(':checked'))
            $('.js-order-add-service', this.root).removeAttr('disabled');
        else
            $('.js-order-add-service', this.root).attr('disabled', 'disabled');
    }, _OrderPage_closeAddAviaCruiseDialog = function _OrderPage_closeAddAviaCruiseDialog() {
        App.popupHide();
    }, _OrderPage_addCruiseService = function _OrderPage_addCruiseService(event) {
        if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
            return false;
        const self = $(event.currentTarget);
        const action = self.attr('data-action');
        if (action)
            window.location.href = action;
        return true;
    }, _OrderPage_showQualityControl = function _OrderPage_showQualityControl(event) {
        const self = $(event.currentTarget);
        const action = self.attr('data-action');
        if (action)
            window.location.href = action;
        return true;
    }, _OrderPage_showCruiseActivityRefusalDialog = function _OrderPage_showCruiseActivityRefusalDialog() {
        if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
            return false;
        return true;
    }, _OrderPage_showAddVisaDialog = function _OrderPage_showAddVisaDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getVisaTourists, { 'id': __classPrivateFieldGet(this, _OrderPage_options, "f").id }, () => { App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataLoading).call(_a)); });
            if (!response) {
                App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPage_defaultError));
                return null;
            }
            if (!response.data) {
                if (!response.status) {
                    App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPage_defaultError));
                }
                else if (!response.status.success) {
                    if (!response.status.messages || response.status.messages.length <= 0)
                        App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPage_defaultError));
                    else
                        App.popupShow($(`<h3>${response.status.messages[0].text}</h3>`));
                }
                return null;
            }
            if (response.data.noVisaAvailable) {
                App.popupShow($(`<h3>${response.data.noVisaAvialableMessage}</h3>`));
                return null;
            }
            __classPrivateFieldSet(this, _OrderPage_visas, response.data.visas, "f");
            const model = {
                dogovorNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                tourists: response.data.tourists,
                visaCities: new App.SelectListModel({
                    name: '',
                    form: true,
                    autocomplete: false,
                    items: __classPrivateFieldGet(this, _OrderPage_visas, "f")
                        .map(v => ({
                        value: v.city,
                        text: v.city,
                        selected: v.selected,
                    })),
                }),
                needPenaltyAgreement: __classPrivateFieldGet(this, _OrderPage_hasAliveJapanHotel, "f"),
            };
            const form = $(App.templates.Order.AddVisas(model));
            App.popupShow(form, 'Добавление визы');
            $('.js-visa-city', form)
                .on('change', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_loadVisaServices).call(this, e))
                .trigger('change');
            const agreeButton = $('.js-visas-save', form);
            agreeButton.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_saveVisas).call(this, e); }));
            $('.js-visas-cancel', form).on('click', () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_cancelVisas).call(_a));
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_jelectInit).call(_a, $('.js-visa-city').parent());
            if (model.needPenaltyAgreement)
                __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_setDependencies).call(this, form, agreeButton);
            return true;
        });
    }, _OrderPage_setDependencies = function _OrderPage_setDependencies(mainForm, submitBtn) {
        const deps = mainForm.find(`[data-name="${submitBtn.attr('data-depends').split(',').join('"], [data-name="')}"]`);
        deps
            .off()
            .on('change', () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_setSubmitAvailability).call(this, deps, submitBtn))
            .trigger('change');
    }, _OrderPage_setSubmitAvailability = function _OrderPage_setSubmitAvailability(dependencies, submitBtn) {
        if (dependencies.filter(':checked').length !== dependencies.length)
            submitBtn.attr('disabled', 'disabled');
        else
            submitBtn.removeAttr('disabled');
    }, _OrderPage_loadVisaServices = function _OrderPage_loadVisaServices(event) {
        const target = $(event.currentTarget);
        const city = target.find('input').valString();
        const cityVisas = __classPrivateFieldGet(this, _OrderPage_visas, "f").filter(v => v.city === city)[0];
        if (!cityVisas)
            return;
        const row = target.closest('tr');
        const touristPrefix = row.find('.js-tourist-visa-prefix').valString();
        if (!touristPrefix)
            return;
        const model = new App.SelectListModel({
            name: `${touristPrefix}ServiceKey`,
            form: true,
            autocomplete: false,
            items: cityVisas.services
                .map(v => ({
                value: v.value,
                text: v.text,
                selected: v.selected,
            })),
        });
        const services = $(App.templates.FilterSelect(model));
        const rowVisaServices = $('.js-visa-services', row);
        rowVisaServices
            .empty()
            .append(services);
        __classPrivateFieldGet(_a, _a, "m", _OrderPage_jelectInit).call(_a, rowVisaServices.parent());
        rowVisaServices.on('change', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_changeVisaServices).call(_a, e));
    }, _OrderPage_changeVisaServices = function _OrderPage_changeVisaServices(event) {
        $(event.currentTarget)
            .closest('form')
            .find('.js-visa-validation-message')
            .empty()
            .hide();
    }, _OrderPage_jelectInit = function _OrderPage_jelectInit(container) {
        const components = new Array();
        container.find('.js-filter-select-block, .js-form-select-block').each((i, v) => {
            components.push(new App.FilterSelectBlock({ root: $(v) }));
        });
    }, _OrderPage_autocompleteInit = function _OrderPage_autocompleteInit(container) {
        const components = new Array();
        container.find('.js-filter-autocomplete-block, .js-form-autocomplete-block').each((i, v) => {
            components.push(new App.FilterAutocompleteBlock({ root: $(v) }));
        });
    }, _OrderPage_calendarInit = function _OrderPage_calendarInit(container) {
        const components = new Array();
        container.find('.js-filter-date-block, .js-form-date-block').each((i, v) => {
            if ($(v).hasClass('js-past-date'))
                components.push(new App.FilterDateBlock({ root: $(v), changeMonthYear: true, maxDate: new Date() }));
            else if ($(v).hasClass('js-future-date'))
                components.push(new App.FilterDateBlock({ root: $(v), changeMonthYear: true, minDate: new Date() }));
            else
                components.push(new App.FilterDateBlock({ root: $(v), changeMonthYear: true }));
        });
    }, _OrderPage_setIssueDateValidation = function _OrderPage_setIssueDateValidation(container) {
        const birthdayInput = $('[name="Tourist.Birthday"]', container);
        // чтобы установать правила валидации нужно сначала привязать валидатор к форме:
        $('form', container).validate();
        // TO DO: сделать для перехвата ввода с клавиатуры
        // в FilterDateBlock
        // birthdayInput.datepicker('option', 'onClose', () => birthdayInput.trigger('filter:close'));
        birthdayInput.on('change', () => {
            const birthdayVal = birthdayInput.valString();
            if (birthdayVal == '')
                return;
            const birthday = App.parseDate(birthdayVal, 'dd.MM.yyyy');
            const citizenship = $('[name="Tourist.Citizenship"]', container).valString();
            $('[name="Tourist.PassportIssueDateRu"], [name="Tourist.PassportIssueDate"]', container)
                .each((_, v) => {
                App.PassportPage.setDocumentIssueDateValidation(birthday, $(v).attr('data-document-type'), citizenship, $(v));
            });
        });
        birthdayInput.trigger('change');
    }, _OrderPage_saveVisas = function _OrderPage_saveVisas(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const form = target.closest('form');
                const validation = form.find('.js-visa-validation-message');
                validation.empty();
                // валидация
                const inputs = form.find('.js-jelect-input')
                    .filter('[data-select$="ServiceKey"]')
                    .filter('[value!="0"]');
                if (inputs.length <= 0) {
                    validation.text('Выберите визу хотя бы для одного туриста.');
                    validation.show();
                    return false;
                }
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.saveVisas, form.serialize(), () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataSaving).call(_a)));
                App.popupHide();
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!response) {
                    App.popupShow($('Произошла ошибка. Попробуйте еще раз через некоторое время.'), 'Ошибка');
                    return false;
                }
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                const servicesContainerOffset = __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f").offset();
                $('html, body').animate({ scrollTop: (servicesContainerOffset != null ? servicesContainerOffset.top - 100 : 0) }, 'slow');
                App.popupShow($('<div>Услуга <b>Виза</b> успешно добавлена</div>'));
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_cancelVisas = function _OrderPage_cancelVisas() {
        App.popupHide();
    }, _OrderPage_showAddInsuranceDialog = function _OrderPage_showAddInsuranceDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataLoading).call(_a));
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getInsuranceTourists, { body: new URLSearchParams({ id: __classPrivateFieldGet(this, _OrderPage_options, "f").id }) });
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(response))
                    return null;
                if (response.data.items.length <= 0) {
                    App.popupShow($('<h3>Отсутствуют туристы без страховки</h3>'), 'Добавление страховки');
                    return null;
                }
                const emptyItem = { value: '', text: 'Выберите страховку...', selected: true };
                const model = {
                    dogovorNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                    tourists: response.data.items
                        .map((v, i) => ({
                        key: v.key,
                        name: v.name,
                        managerMessage: v.managerMessage,
                        showMedicalServices: v.medicalServices.length > 0,
                        medicalServices: new App.SelectListModel({
                            name: `Form.Tourists[${i}].MedicalServiceKey`,
                            form: true,
                            autocomplete: false,
                            items: Enumerable.from(v.medicalServices)
                                .select(x => ({
                                value: x.key,
                                text: x.name,
                                selected: false,
                            }))
                                .insert(0, [emptyItem])
                                .toArray(),
                        }),
                        showDeclineServices: v.declineServices.length > 0,
                        declineServices: new App.SelectListModel({
                            name: `Form.Tourists[${i}].DeclineServiceKey`,
                            form: true,
                            autocomplete: false,
                            items: Enumerable.from(v.declineServices)
                                .select(x => ({
                                value: x.key,
                                text: x.name,
                                selected: false,
                            }))
                                .insert(0, [emptyItem])
                                .toArray(),
                        }),
                        declineDeniedMessage: v.declineDeniedMessage,
                        showLiabilityServices: v.liabilityServices.length > 0,
                        liabilityServices: new App.SelectListModel({
                            name: `Form.Tourists[${i}].LiabilityServiceKey`,
                            form: true,
                            autocomplete: false,
                            items: Enumerable.from(v.liabilityServices)
                                .select(x => ({
                                value: x.key,
                                text: x.name,
                                selected: false,
                            }))
                                .insert(0, [emptyItem])
                                .toArray(),
                        }),
                    })),
                };
                __classPrivateFieldSet(this, _OrderPage_insuranceServices, response.data.items
                    .flatMap(v => [...v.medicalServices, ...v.declineServices, ...v.liabilityServices]), "f");
                const form = $(App.templates.Order.AddInsurance(model));
                App.popupShow(form, 'Добавление страховки');
                __classPrivateFieldGet(_a, _a, "m", _OrderPage_jelectInit).call(_a, $('.js-popup-container'));
                $('.js-insurance-save', form).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_saveInsurances).call(this, e); }));
                $('.js-insurance-cancel', form).on('click', () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_cancelInsurances).call(_a));
                return true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex))
                    throw ex;
                return null;
            }
        });
    }, _OrderPage_saveInsurances = function _OrderPage_saveInsurances(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const form = target.closest('form');
                const validation = form.find('.js-insurance-validation-message');
                validation.empty();
                // валидация
                const inputs = form.find('.js-jelect-input')
                    .filter('[data-select$="ServiceKey"]')
                    .filter('[value!="0"]');
                if (inputs.length === 0) {
                    validation.text('Выберите страховку хотя бы для одного туриста.');
                    validation.show();
                    return false;
                }
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.saveInsurances, form.serialize(), () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataSaving).call(_a)));
                App.popupHide();
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!response) {
                    App.popupShow($('Произошла ошибка. Попробуйте еще раз через некоторое время.'), 'Ошибка');
                    return false;
                }
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                const servicesContainerOffset = __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f").offset();
                $('html, body').animate({ scrollTop: (servicesContainerOffset != null ? servicesContainerOffset.top - 100 : 0) }, 'slow');
                App.popupShow($('<div>Услуга <b>Страховка</b> успешно добавлена</div>'));
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_cancelInsurances = function _OrderPage_cancelInsurances() {
        App.popupHide();
    }, _OrderPage_addPacFitService = function _OrderPage_addPacFitService() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.addPacFitService, { 'id': __classPrivateFieldGet(this, _OrderPage_options, "f").id });
            if (!response || !response.redirect)
                return null;
            window.location.href = response.redirect;
            return true;
        });
    }, _OrderPage_getDocumentsDialog = function _OrderPage_getDocumentsDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPage_header, "f").isPw)
                return false;
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.packet,
                method: 'GET',
            });
            // TODO const popupGroup = this.#popup.show({ group: 'main', content: templates.Tour.Messages.Valuating({}), delay: 1000, modal: true });
            try {
                const response = yield request;
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!response) {
                    App.popupShow($('Произошла ошибка. Попробуйте еще раз через некоторое время.'), 'Ошибка');
                    return false;
                }
                let url = response.data.link;
                if (__classPrivateFieldGet(this, _OrderPage_header, "f").waitingForMK)
                    url = App.removeEndChar(response.data.link, '/') + '?waitingForMK=true';
                App.popupShow($(App.templates.Order.Messages.GetDocumentsDialog({
                    message: response.data.message,
                    url: url,
                    domain: window.location.hostname.substring(window.location.hostname.lastIndexOf('.') + 1),
                    cityCode: response.data.cityCode,
                    waitingForMK: __classPrivateFieldGet(this, _OrderPage_header, "f").waitingForMK,
                })));
                $(document)
                    .on('click', '#acceptGetDocuments', () => {
                    App.popupHide();
                })
                    .on('click', '#declineGetDocuments', () => App.popupHide());
                return true;
            }
            catch (ex) {
                window.console.error(ex);
                return false;
            }
        });
    }, _OrderPage_openBookingDetails = function _OrderPage_openBookingDetails(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            const target = $(event.currentTarget);
            const serviceBlock = target.closest('.js-order-service');
            const hiddenInfoBlock = serviceBlock.find('.js-order-service-hidden');
            const visibleInfoBlock = serviceBlock.find('.js-order-service-visible');
            target.toggleClass('_unfolded');
            serviceBlock.toggleClass('_opened');
            if (serviceBlock.hasClass('_opened')) {
                if (serviceBlock.attr('data-loaded') !== 'true') {
                    const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getBooking, { 'number': serviceBlock.attr('data-booking-number') }, () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onSearchBefore).call(_a, target), () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onSearchAlways).call(_a, target));
                    if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                        return false;
                    if (!response)
                        return false;
                    if (!response.data) {
                        __classPrivateFieldGet(this, _OrderPage_messages, "f").show({ type: 2 /* MessageType.Error */, text: 'Бронь не найдена.' }, { canHide: true });
                        return false;
                    }
                    __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_renderBookingDetails).call(this, hiddenInfoBlock, response.data, serviceBlock);
                    serviceBlock.data('loaded', 'true');
                }
                else {
                    hiddenInfoBlock.show(__classPrivateFieldGet(this, _OrderPage_renderSpeed, "f"));
                    visibleInfoBlock.show();
                }
            }
            else {
                hiddenInfoBlock.hide(__classPrivateFieldGet(this, _OrderPage_renderSpeed, "f"));
                visibleInfoBlock.hide();
            }
            return true;
        });
    }, _OrderPage_openServiceTourists = function _OrderPage_openServiceTourists(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const serviceTouristBlock = target.closest('.js-order-service-tourists');
            const serviceTouristMoreBlock = serviceTouristBlock.find('.js-order-service-tourist-more');
            const hiddenTourists = serviceTouristBlock.find('.js-order-service-tourist-more-item');
            serviceTouristMoreBlock.hide();
            hiddenTourists.show(__classPrivateFieldGet(this, _OrderPage_renderSpeed, "f"));
            return true;
        });
    }, _OrderPage_onStopsClick = function _OrderPage_onStopsClick(event) {
        const target = $(event.currentTarget);
        const info = target.attr('data-info');
        if (!info)
            return;
        const infos = info.split('|');
        const form = $(App.templates.Avia.Stop({}));
        $.each(infos, (index, item) => $('.js-info', form).append($(`<div>${item}</div>`)));
        App.popupShow(form, 'Техническая посадка');
    }, _OrderPage_renderBookingDetails = function _OrderPage_renderBookingDetails(container, booking, serviceBlock) {
        const template = serviceBlock.attr('data-template');
        if (!template)
            return;
        const bruttoBlock = $('.js-service-price', serviceBlock).filter('[data-price-type="brutto"]');
        booking.showGrossPrice = bruttoBlock != null && bruttoBlock.length > 0;
        const serviceTemplate = App.findTemplate(template);
        container
            .empty()
            .append(serviceTemplate(booking))
            .show(__classPrivateFieldGet(this, _OrderPage_renderSpeed, "f"));
        $('.js-brand-name', container).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showBrandRules).call(this, e); }));
        $('.js-fare-conditions', container).on('click', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showFareConditions).call(this, e));
        $('.js-fare-penalties', container).on('click', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showFarePenalties).call(this, e));
        $('.js-show-on-map', container).on('click', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onShowMapClick).call(this, e));
        // TODO: для авиа внести эту часть внутрь js-order-service-hidden
        /* if (response.data.item.notes) {
            visibleInfoBlock
                .append(templates.Order.ServiceNotes(response.data.item.notes))
                .show();
        }*/
    }, _OrderPage_showBusTourists = function _OrderPage_showBusTourists() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getTouristBusSeats, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id }, () => { App.modalShow($(App.templates.Order.Messages.Loading({}))); }, () => { });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            const dialog = $(App.templates.Order.BusTouristList(response.data.tourists));
            $('.js-show-seats', dialog).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showBusSeats).call(this, e); }));
            App.popupShow(dialog, 'Добавление услуги');
            return undefined;
        });
    }, _OrderPage_showBusSeats = function _OrderPage_showBusSeats(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const column = target.closest('td');
            const row = target.closest('tr');
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getBusSeats, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id }, () => {
                $('.js-seats-container').remove();
                $('.js-bus-tourist-list .js-show-seats').show();
                target.hide();
                column.append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
            }, () => { $('.js-loading', column).remove(); });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            const busSeats = $(App.templates.Order.BusSeats(response.data.items));
            if (response.data.items)
                $('.js-take-bus-seat', busSeats).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_takeBusSeat).call(this, e); }));
            row.after(busSeats);
            return undefined;
        });
    }, _OrderPage_takeBusSeat = function _OrderPage_takeBusSeat(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.takeBusSeat, {
                    id: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                    touristKey: target.closest('tbody').attr('data-tourist-key'),
                    priceCode: target.attr('data-price-code'),
                    subcode1: target.attr('data-subcode1'),
                    subcode2: target.attr('data-subcode2'),
                    partnerKey: target.attr('data-partner'),
                    packetKey: target.attr('data-packet'),
                }, () => { App.modalShow($(App.templates.Order.Messages.Loading({}))); }, () => { });
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true })) {
                    App.popupHide();
                    return false;
                }
                if (!response)
                    return false;
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showBusTourists).call(this);
                return undefined;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_showFareConditions = function _OrderPage_showFareConditions(event) {
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showFareInfo).call(this, $(event.currentTarget), 'Авиаперелет. Правила и условия');
    }, _OrderPage_showFarePenalties = function _OrderPage_showFarePenalties(event) {
        __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showFareInfo).call(this, $(event.currentTarget), 'Авиаперелет. Информация по штрафам');
    }, _OrderPage_showFareInfo = function _OrderPage_showFareInfo(selector, title) {
        const value = selector.attr('data-value');
        if (!value)
            return;
        const content = $('<div class="_scrolling _pre font-11 lh-14"></div>').html(value);
        const toggleButton = $('<button type="button" class="form-btn form-btn_default mt-3">Показать перевод</button>');
        let translatedValue;
        let translationPromise;
        let showTranslation = false;
        toggleButton.on('click', () => {
            showTranslation = !showTranslation;
            toggleButton.text(showTranslation ? 'Показать оригинал' : 'Показать перевод');
            if (!showTranslation) {
                content.html(value);
                return;
            }
            if (translatedValue != null) {
                content.html(translatedValue);
                return;
            }
            content.empty().append(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataLoading).call(_a));
            translationPromise !== null && translationPromise !== void 0 ? translationPromise : (translationPromise = __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getFareTranslation).call(this, value));
            void translationPromise.then(translation => {
                translatedValue = translation;
                if (showTranslation)
                    content.html(translatedValue);
            });
        });
        // TODO: после того как отображение правил перевозчика будет единым для корзины и для заказа, вернуть обратно
        // App.popupShow($('<div></div>').append(content, toggleButton), title);
        App.popupShow($('<div></div>').append(content), title);
    }, _OrderPage_getFareTranslation = function _OrderPage_getFareTranslation(value) {
        const existing = __classPrivateFieldGet(this, _OrderPage_fareTranslations, "f").get(value);
        if (existing)
            return existing;
        const promise = __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_loadFareTranslation).call(this, value);
        __classPrivateFieldGet(this, _OrderPage_fareTranslations, "f").set(value, promise);
        return promise;
    }, _OrderPage_loadFareTranslation = function _OrderPage_loadFareTranslation(value) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.getTranslation, { body: new URLSearchParams({ text: value }) });
                return (_b = response.data) !== null && _b !== void 0 ? _b : value;
            }
            catch (e) {
                window.console.error(e);
                __classPrivateFieldGet(this, _OrderPage_fareTranslations, "f").delete(value);
                return value;
            }
        });
    }, _OrderPage_showBrandRules = function _OrderPage_showBrandRules(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action');
            const brandName = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-brand-name');
            const carrierName = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-carrier-name');
            const carrierLogo = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-carrier-logo');
            if (!action || !brandName || !carrierName || !carrierLogo)
                return false;
            let data;
            const segmentKey = target.attr('data-segment-key');
            if (segmentKey) {
                data = { 'segmentKey': segmentKey };
            }
            else {
                data = {
                    'carrier': target.attr('data-carrier-code'),
                    'programSystemCode': target.attr('data-program-system-code'),
                    'programCode': target.attr('data-program-code'),
                    'brand': target.attr('data-brand-id'),
                };
            }
            const brandBlock = $('<div></div>');
            const response = yield doAction(action, data, () => {
                brandBlock.text('Пожалуйста, подождите.');
                App.popupShow(brandBlock, `Тариф ${brandName}<br/><small>а/к ${carrierName}<img style="height: 25px" src="${carrierLogo}" /></small>`);
            }, () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_hidePreloader).call(_a, target));
            if (!response)
                return false;
            brandBlock.empty();
            if (!response.data) {
                brandBlock.append($('<h3>Описание тарифа не найдено</h3>'));
                return false;
            }
            if (!response.status || !response.status.success) {
                if (response.status.messages)
                    brandBlock.append($(`<h3>${response.status.messages[0].text}</h3>`));
                return false;
            }
            __classPrivateFieldGet(_a, _a, "m", _OrderPage_renderBrandFare).call(_a, brandBlock, response.data);
            return true;
        });
    }, _OrderPage_renderBrandFare = function _OrderPage_renderBrandFare(container, data) {
        container.append(App.templates.BrandFareRules({
            rules: data.rules,
            url: data.url,
            isUrlContent: data.isUrlContent,
            production: data.production,
        }));
    }, _OrderPage_onShowMapClick = function _OrderPage_onShowMapClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _OrderPage_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _OrderPage_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _OrderPage_mapWrapClass, "f")}"><div style="width: 700px; height: 600px !important; min-height: 600px;" class="js-auto-point-map"></div></div>`),
            onShowDelegate: () => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_showMap).call(this, $(event.currentTarget)),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _OrderPage_showMap = function _OrderPage_showMap(target) {
        const coordinates = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-coordinates');
        if (!coordinates)
            return;
        const coords = Enumerable.from(coordinates.split(':')).select(v => parseFloat(v)).toArray();
        if (coords.length !== 2)
            return;
        const point = {
            coordinate: {
                latitude: coords[0],
                longitude: coords[1],
            },
            title: $(target).attr('data-point-type'),
            id: 0,
        };
        App.SimpleGoogleMap.show([point], $('.js-popup').find(`.${__classPrivateFieldGet(this, _OrderPage_mapWrapClass, "f")}`));
    }, _OrderPage_onActionConfirm = function _OrderPage_onActionConfirm(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const customPrompt = target.attr('data-custom_prompt');
                const prerequirement = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-prerequirement');
                if (!prerequirement)
                    return false;
                const preRequirementResponse = yield doAction(prerequirement, {});
                if (!preRequirementResponse) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return false;
                }
                if (preRequirementResponse.status.success
                    && preRequirementResponse.data.preRequirementMessage
                    && preRequirementResponse.data.preRequirementMessage.length > 0) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, preRequirementResponse.data.preRequirementMessage));
                    return false;
                }
                const dialog = new App.ActionDialog(target, App.ActionType.confirmation, customPrompt);
                dialog.show();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onActionConfirmCruise = function _OrderPage_onActionConfirmCruise(event) {
        if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
            return false;
        const target = $(event.currentTarget);
        const dialog = $(App.templates.Order.Messages.ConfirmCruiseDialog({
            serviceKey: target.attr('data-service-key'),
            referenceNumber: target.attr('data-reference-number'),
            paymentMessage: target.attr('data-needPaymentMessage'),
            guaranteeLetterMessage: target.attr('data-needGuaranteeLetterMessage'),
        }));
        dialog.on('click', '.js-confirm-cruise-dialog-continue', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onConfirmCruiseDialogContinueAsync).call(this, e); }));
        dialog.on('click', '.js-confirm-cruise-dialog-close', () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onConfirmCruiseDialogClose).call(_a));
        App.popupShow(dialog, 'Подтверждение брони');
        return true;
    }, _OrderPage_onConfirmCruiseDialogClose = function _OrderPage_onConfirmCruiseDialogClose() {
        App.popupHide();
    }, _OrderPage_onConfirmCruiseDialogContinueAsync = function _OrderPage_onConfirmCruiseDialogContinueAsync(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.confirmCruise, {
                    dogovorNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                    referenceNumber: target.attr('data-reference-number'),
                }, () => App.modalShow($('<div>Производится подтверждение брони</div>')
                    .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))))));
                if (!response)
                    return false;
                if (response.status.success && response.data && response.data.cruiseDogovorCode) {
                    const dialog = $(App.templates.Order.Messages.RefuseCruiseConfirm({
                        dogovorCode: response.data.cruiseDogovorCode,
                    }));
                    App.popupShow(dialog, 'Ошибка подтверждения круиза');
                    return undefined;
                }
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                if (response.status.messages)
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                return undefined;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onActionCancel = function _OrderPage_onActionCancel(event) {
        if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
            return false;
        const target = $(event.currentTarget);
        const japanHotelCancellation = Boolean(target.attr('data-japan-hotel-cancellation'));
        const dialog = new App.ActionDialog(target, App.ActionType.cancellation, undefined, !japanHotelCancellation
            ? undefined
            : 'При аннуляции отеля после получения туристами виз удержанию по заказу дополнительно подлежит сумма в размере рублевого эквивалента 300 евро. ' +
                'Также компания PAC GROUP сообщает, что по условиям аккредитации обязана информировать консульство об аннуляции услуг размещения, ' +
                'в целях аннуляции въездной визы туристов.Просим проинформировать туристов о возможном возникновении сложностей при пересечении границ.');
        dialog.show();
        return true;
    }, _OrderPage_onActionRefreshPrice = function _OrderPage_onActionRefreshPrice(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action');
                if (!action)
                    return false;
                const changeTimelimit = target.attr('data-change-timelimit');
                // Task 25145.  Бронирование Сирены при обновлении стоимости, если билеты не выписываются в течении 15 минут, аннулируется.
                if (changeTimelimit == 'true') {
                    const dialog = new App.ActionDialog(target, App.ActionType.reprice);
                    dialog.displayText('В случае продолжения операции выписка авиабилетов будет возможна в течение 10 минут. Рекомендуем произвести операцию обновления стоимости перед выпиской');
                    dialog.setConfirmButtonText('Продолжить');
                    dialog.show();
                    return false;
                }
                const response = yield doAction(action, {}, () => App.modalShow($(App.templates.Order.Messages.Repricing({}))));
                if (!response)
                    return false;
                if (response.status.messages)
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
            // вывод сообщений в шапку - недобно возвращаться обратно
            /* App.validateResponse(response, this.#messages, undefined, { showOnPage: true });
            App.popupHide();*/
        });
    }, _OrderPage_onInactiveIssueButtonClick = function _OrderPage_onInactiveIssueButtonClick() {
        App.popupShow($('<span>Перед выпиской билета необходимо передать паспортные данные в авиакомпанию</span>'), '', () => { }, () => {
            setTimeout(() => {
                $('.js-add-passport')
                    .animate({ 'background-color': '#fe0335' }, 1000)
                    .animate({ 'background-color': '#03affe' }, 1000);
            }, 0);
        });
    }, _OrderPage_onActionIssue = function _OrderPage_onActionIssue(event) {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_doActionIssue).call(this, $(event.currentTarget), true);
        });
    }, _OrderPage_doActionIssue = function _OrderPage_doActionIssue(invoker, checkStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            let preaction = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, invoker, 'data-preaction');
            const prerequirement = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, invoker, 'data-prerequirement');
            if (!preaction || !prerequirement)
                return false;
            preaction = `${preaction}/${__classPrivateFieldGet(this, _OrderPage_options, "f").id}`;
            const changeTimelimit = invoker.attr('data-change-timelimit');
            // Task 25145.  Бронирование Сирены при обновлении стоимости, если билеты не выписываются в течении 15 минут, аннулируется.
            if (changeTimelimit == 'true') {
                const dialog = new App.ActionDialog(invoker, App.ActionType.issue);
                dialog.displayText('В случае​ изменения стоимости выписка авиабилетов будет возможна в течение 10 минут');
                dialog.setConfirmButtonText('Продолжить');
                dialog.show();
                return false;
            }
            const preRequirementResponse = yield doAction(prerequirement, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataLoading).call(_a)));
            if (!preRequirementResponse) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                return false;
            }
            if (preRequirementResponse.status.success
                && preRequirementResponse.data.preRequirementMessage
                && preRequirementResponse.data.preRequirementMessage.length > 0) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, preRequirementResponse.data.preRequirementMessage));
                return false;
            }
            if (checkStatus) {
                const response = yield doAction(preaction, {});
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return false;
                }
                if (response.status.success && response.data.text.length > 0) {
                    const dialog = new App.ActionDialog(invoker, App.ActionType.preissue);
                    dialog.displayText(response.data.text);
                    dialog.setConfirmButtonText('Согласен');
                    dialog.show();
                    return true;
                }
            }
            const dialog = new App.ActionDialog(invoker, App.ActionType.issue, undefined, invoker.attr('data-warning-text'));
            if (invoker.attr('data-charter') == 'true')
                dialog.changeContent($(App.templates.Order.Messages.CharterIssueInfo({})));
            dialog.show();
            return true;
        });
    }, _OrderPage_onActionContinue = function _OrderPage_onActionContinue(event, invoker, serviceKey, actionType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                if (actionType === App.ActionType.preissue) {
                    yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_doActionIssue).call(this, invoker, false);
                    return true;
                }
                if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                    return false;
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, invoker, 'data-action');
                if (!action)
                    return false;
                const response = yield doAction(action, {});
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return false;
                }
                const { messages } = response.status;
                if (messages && messages.length > 0) {
                    if (messages[0].type === 2 /* MessageType.Error */ || messages[0].type === 1 /* MessageType.Warning */) {
                        yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                        App.popupShow(this.getCommonInfoBlockCompact(messages[0]));
                        // Если у отеля отказ по одной из комнат, то статус оставшейся услуги меняется на Запрос. Поэтому
                        // нужно перегрузить и открыть Подробности.
                        const service = __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f").find(`.js-order-service[data-key=${serviceKey}]`);
                        const scrollPosition = service.offset();
                        if (scrollPosition)
                            $('html, body').animate({ scrollTop: scrollPosition.top }, 'slow');
                        $('.js-order-service-open', service).trigger('click');
                    }
                    else {
                        yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                        const scsm = invoker.attr('data-skip-success-message');
                        if (scsm && scsm !== 'true')
                            App.popupShow(this.getCommonInfoBlockCompact(messages[0]));
                    }
                    return false;
                }
                if (actionType === App.ActionType.confirmation) {
                    if (response.data) {
                        if (response.data.priceHasChanged) {
                            const dialog = $(App.templates.Order.Messages.BookingPriceHasChanged(response.data));
                            dialog.on('click', '.js-cancel-current-booking', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onCancelCurrentAccommodationBooking).call(this, e); }));
                            dialog.on('click', '.js-book-alternative-accommodation', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onBookAlternativeHotel).call(this, e); }));
                            App.popupShow(dialog, 'Внимание!');
                            return false;
                        }
                    }
                }
                if (actionType === App.ActionType.issue) {
                    // цена изменилась! сразу перегружаем заказ и показываем сообщение.
                    yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                    const service = __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f").find(`.js-order-service[data-key=${serviceKey}]`);
                    const scrollPosition = service.offset();
                    if (scrollPosition)
                        $('html, body').animate({ scrollTop: scrollPosition.top }, 'slow');
                    const dialog = $(App.templates.Order.IssuePriceChanged(response.data));
                    dialog.on('click', '.js-cancel-issue-ticket', () => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onCancelIssue).call(_a));
                    // передаем селектор выписываемой услуги, чтобы потом к ней перейти
                    $('.js-confirm-issue-ticket', dialog).on('click', e => __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onConfirmIssue).call(this, e, serviceKey));
                    App.popupShow(dialog, 'Выписка билета');
                    return false;
                }
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onCancelCurrentAccommodationBooking = function _OrderPage_onCancelCurrentAccommodationBooking(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action');
            if (!action)
                return false;
            const response = yield doAction(action, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataCurrentBookingCancellation).call(_a)));
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            if (!response.data.success)
                return false;
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
            App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, response.data.message));
            return true;
        });
    }, _OrderPage_onBookAlternativeHotel = function _OrderPage_onBookAlternativeHotel(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action');
            if (!action)
                return false;
            const response = yield doAction(action, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataBooking).call(_a)));
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            if (!response.data.success)
                return false;
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
            App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, response.data.message));
            return true;
        });
    }, _OrderPage_onCancelIssue = function _OrderPage_onCancelIssue() {
        App.popupHide();
    }, _OrderPage_onConfirmIssue = function _OrderPage_onConfirmIssue(event, serviceKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            if (!serviceKey)
                return false;
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action');
            const id = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-id');
            const agreeWithPriceChanging = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-agree-with-price-changing');
            if (!action || !id || !agreeWithPriceChanging)
                return false;
            App.modalShow($(App.templates.Order.Messages.Issuing({})));
            const response = yield doAction(action, {
                id,
                agreeWithPriceChanging,
            });
            if (!response)
                return false;
            if (response.status.messages) {
                if (response.status.messages[0].type === 0 /* MessageType.Information */) {
                    yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getServices).call(this);
                    const service = __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f").find(`.js-order-service[data-key=${serviceKey}]`);
                    let scrollPosition = service.offset();
                    if (scrollPosition) {
                        $('html, body').animate({ scrollTop: scrollPosition.top - 50 }, 'slow');
                    }
                    else {
                        scrollPosition = __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f").offset();
                        if (scrollPosition)
                            $('html, body').animate({ scrollTop: scrollPosition.top - 100 }, 'slow');
                    }
                }
                App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
            }
            return true;
        });
    }, _OrderPage_onActionPacManual = function _OrderPage_onActionPacManual(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action');
                const actionType = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action-type');
                if (!action || !actionType)
                    return false;
                const response = yield doAction(action, {}, () => App.modalShow($(App.findTemplate(`Order.Messages.${actionType}`)({}))));
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true })) {
                    App.popupHide();
                    return false;
                }
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                App.popupHide();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onAviaRebook = function _OrderPage_onAviaRebook(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const bookingNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-booking-number');
            if (!bookingNumber)
                return false;
            const action = __classPrivateFieldGet(this, _OrderPage_options, "f").urls.aviaRebook;
            return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_aviaRebookCore).call(this, bookingNumber, action);
        });
    }, _OrderPage_onAviaRebookContinue = function _OrderPage_onAviaRebookContinue(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const bookingNumber = data;
            const action = __classPrivateFieldGet(this, _OrderPage_options, "f").urls.aviaRebookContinue;
            return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_aviaRebookCore).call(this, bookingNumber, action);
        });
    }, _OrderPage_aviaRebookCore = function _OrderPage_aviaRebookCore(bookingNumber, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const response = yield doAction(action, {
                    orderNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                    orderBookingNumber: bookingNumber,
                }, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataRebooking).call(_a)));
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true })) {
                    App.popupHide();
                    return false;
                }
                if (!response)
                    return false;
                if (response.data.success) {
                    yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                    App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, response.data.message));
                    return true;
                }
                if (response.data.doubleBookingFound === true) {
                    const doublesDialog = $(App.templates.Order.Messages.AviaRebookContinueDialog({
                        message: response.data.message,
                        continueAction: response.data.continueAction,
                    }));
                    doublesDialog.on('click', '.js-avia-rebook-continue', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onAviaRebookContinue).call(this, e, bookingNumber); }));
                    doublesDialog.on('click', '.js-avia-rebook-close', () => App.popupHide());
                    App.popupShow(doublesDialog, 'Предупреждение');
                    return true;
                }
                if (response.data.message) {
                    const dialog = $(App.templates.Order.Messages.AviaRebookDialog({
                        message: response.data.message,
                        searchUrl: response.data.searchUrl,
                    }));
                    dialog.on('click', '.js-avia-rebook-search', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onAviaRebookNewSearch).call(_a, e));
                    dialog.on('click', '.js-avia-rebook-close', () => App.popupHide());
                    App.popupShow(dialog, 'Ошибка бронирования');
                    return true;
                }
                App.popupHide();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onAviaRebookNewSearch = function _OrderPage_onAviaRebookNewSearch(event) {
        const target = $(event.currentTarget);
        if (target) {
            const href = target.attr('data-href');
            if (href)
                window.location.href = href;
        }
    }, _OrderPage_onActionAviaSynchronize = function _OrderPage_onActionAviaSynchronize(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return;
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-action');
                if (!action)
                    return;
                const response = yield doAction(action, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataSaving).call(_a)));
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return;
                }
                yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_reloadAll).call(this);
                if (response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                    return;
                }
                App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, 'Бронь синхронизирована.'));
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onShowPaymentHistory = function _OrderPage_onShowPaymentHistory(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const block = target.parent();
            block.children('.js-order-payment-history-result').remove();
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataLoading).call(_a));
            const response = yield $.ajax({
                url: App.app.url.route(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.paymentHistory),
                method: 'POST',
                dataType: 'json',
                data: { orderNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id },
            });
            App.popupHide();
            target.addClass('_dspn');
            if (response && response.data) {
                const result = $(App.templates.Order.OrderPaymentHistory({
                    items: response.data.items,
                    averageRateRub: response.data.averageRateRub,
                }));
                block.append(result);
                $('.js-order-payment-history-result-close', result).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_closePaymentHistory).call(_a, e));
                return true;
            }
            if (response.status.success && response.status.messages && response.status.messages[0].type === 1 /* MessageType.Warning */) {
                const result = $(App.templates.Order.OrderPaymentHistory({
                    message: response.status.messages[0].text,
                }));
                block.append(result);
                $('.js-order-payment-history-result-close', result).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_closePaymentHistory).call(_a, e));
            }
            return false;
        });
    }, _OrderPage_closePaymentHistory = function _OrderPage_closePaymentHistory(event) {
        const target = $(event.currentTarget);
        const block = target.parent().parent();
        block.find('.js-order-payment-history-link').removeClass('_dspn');
        target.closest('.js-order-payment-history-result').hide('fast');
    }, _OrderPage_onShowCancelledServices = function _OrderPage_onShowCancelledServices(event) {
        const target = $(event.currentTarget);
        const block = target.parent();
        $('.js-order-canceled-show', block).hide();
        $('.js-order-canceled-close', block).show();
        $('.js-order-canceled-result', block).show();
        block.removeClass('_off');
    }, _OrderPage_onCloseCancelledServices = function _OrderPage_onCloseCancelledServices(event) {
        const target = $(event.currentTarget);
        const block = target.parent();
        $('.js-order-canceled-show', block).show();
        $('.js-order-canceled-close', block).hide();
        $('.js-order-canceled-result', block).hide();
        block.addClass('_off');
    }, _OrderPage_onFillMscTourists = function _OrderPage_onFillMscTourists() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
                return false;
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPage_getDataLoading).call(_a));
            const response = yield $.ajax({
                url: App.app.url.route(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.fillMscTourists),
                method: 'POST',
                dataType: 'json',
                data: { orderNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id },
            });
            App.popupHide();
            if (response && response.data) {
                $('.js-fill-msc-tourists', __classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f")).hide();
                const promises = new Array();
                $('.js-order-tourist-info', __classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f")).each((i, item) => {
                    const tourist = response.data.tourists.filter(v => v.lastName.toUpperCase() === $(item).attr('data-lastname')
                        && v.firstName.toUpperCase() === $(item).attr('data-firstname')
                        && v.birthday === $(item).attr('data-birthday'))[0];
                    if (tourist) {
                        promises.push(__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_openTouristEditor).call(this, $(item)));
                    }
                    else {
                        $(item).after(__classPrivateFieldGet(this, _OrderPage_mscNoTouristMatchingTemplate, "f").call(this, {}));
                    }
                });
                yield Promise.all(promises);
                $('.js-order-tourist-info', __classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f")).each((i, item) => {
                    const tourist = response.data.tourists.filter(v => v.lastName.toUpperCase() === $(item).attr('data-lastname')
                        && v.firstName.toUpperCase() === $(item).attr('data-firstname')
                        && v.birthday === $(item).attr('data-birthday'))[0];
                    if (tourist) {
                        const editor = $(item).siblings('.js-order-tourist-editor');
                        const hasAnotherValue = __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_fillTouristMscData).call(this, tourist, editor);
                        $('.js-rewrite-tourist-block', $(editor)).toggle(hasAnotherValue);
                        $('.js-rewrite-by-msc', $(editor)).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onRewriteByMsc).call(_a, e));
                        $('.js-rewrite-tourist-by-msc', $(editor)).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPage_onRewriteTouristByMsc).call(_a, e));
                    }
                    else {
                        $(item).after(__classPrivateFieldGet(this, _OrderPage_mscNoTouristMatchingTemplate, "f").call(this, {}));
                    }
                });
            }
            else {
                $('.js-fill-msc-tourists', __classPrivateFieldGet(this, _OrderPage_orderHeaderContainer, "f")).hide();
                if (response.status && !response.status.success && response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                }
            }
            return true;
        });
    }, _OrderPage_fillTouristMscData = function _OrderPage_fillTouristMscData(tourist, editor) {
        // Идем по всем элементам с атрибутом data-msc-type и сравниваем их содержимое с содержимым одноименных свойств
        // туриста.
        let hasAnotherValue = false;
        $('[data-msc-type]', editor).each((i2, item2) => {
            const mscType = $(item2).attr('data-msc-type');
            const controlType = $(item2).attr('data-type');
            let value = tourist[mscType];
            if (value == undefined)
                return;
            value = value.toString();
            if (controlType === 'select') {
                if (value) {
                    const block = new App.FilterSelectBlock({ root: $(item2) });
                    const selectValue = block.getValue();
                    if (!selectValue || selectValue === '') {
                        block.setValue(value);
                        $(item2).parent().addClass('_msc-data');
                        $(item2).parent().append(__classPrivateFieldGet(this, _OrderPage_mscValueTemplate, "f").call(this, { differs: 'use' }));
                    }
                    else if (selectValue === value) {
                        $(item2).parent().append(__classPrivateFieldGet(this, _OrderPage_mscValueTemplate, "f").call(this, { differs: 'equal' }));
                        $(item2).addClass('_msc-data-equal');
                    }
                    else {
                        $(item2).parent().append(__classPrivateFieldGet(this, _OrderPage_mscValueTemplate, "f").call(this, { differs: 'different', value, mscType }));
                        $(item2).addClass('_msc-data-different');
                        hasAnotherValue = true;
                    }
                }
            }
            else if ($(item2).val() === '') {
                if (value !== '') {
                    $(item2).val(value);
                    $(item2).parent().addClass('_msc-data');
                    $(item2).parent().append(__classPrivateFieldGet(this, _OrderPage_mscValueTemplate, "f").call(this, { differs: 'use' }));
                }
            }
            else if (value) {
                if ($(item2).valString().replace('+', '') === value) {
                    $(item2).parent().append(__classPrivateFieldGet(this, _OrderPage_mscValueTemplate, "f").call(this, { differs: 'equal' }));
                    $(item2).parent().addClass('_msc-data-equal');
                }
                else {
                    $(item2).parent().append(__classPrivateFieldGet(this, _OrderPage_mscValueTemplate, "f").call(this, { differs: 'different', value, mscType }));
                    $(item2).parent().addClass('_msc-data-different');
                    hasAnotherValue = true;
                }
            }
        });
        return hasAnotherValue;
    }, _OrderPage_onRewriteByMsc = function _OrderPage_onRewriteByMsc(event) {
        var _b;
        const target = $(event.currentTarget);
        const editor = target.closest('.js-order-tourist-editor');
        const forMscType = target.attr('data-for-msc-type');
        if (!forMscType)
            return;
        const mscTypeBlock = editor.find(`[data-msc-type="${forMscType}"]`);
        const value = (_b = target.attr('data-val')) !== null && _b !== void 0 ? _b : '';
        if (mscTypeBlock.attr('data-type') === 'select') {
            const selectBlock = new App.FilterSelectBlock({ root: mscTypeBlock });
            selectBlock.setValue(value);
        }
        else {
            mscTypeBlock.val(value).addClass('text-red');
        }
        target.parent('.js-msc-value-block').hide();
    }, _OrderPage_onRewriteTouristByMsc = function _OrderPage_onRewriteTouristByMsc(event) {
        const target = $(event.currentTarget);
        const editor = target.closest('.js-order-tourist-editor');
        $('.js-rewrite-by-msc', $(editor)).trigger('click').parent().hide();
    }, _OrderPage_onCruiseChangeRouteRequest = function _OrderPage_onCruiseChangeRouteRequest(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const reqValue = Number(target.attr('data-request-value'));
            const action = __classPrivateFieldGet(this, _OrderPage_options, "f").urls.sendCruiseChangeRouteRequest;
            const response = yield doAction(action, {
                orderNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                operation: reqValue,
            });
            if (!response) {
                App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPage_defaultError));
                return false;
            }
            if (!response.status.success && response.status.messages) {
                App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                return true;
            }
            const dialog = $(App.templates.Order.Messages.CruiseChangeRouteRequestInfo({
                operation: reqValue === 1,
            }));
            App.popupShow(dialog, 'Внимание');
            const block = target.parent('.js-cruise-needChangeRoute');
            block.hide();
            return true;
        });
    }, _OrderPage_onCruiseIssueRequest = function _OrderPage_onCruiseIssueRequest(event) {
        if (!__classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_canEditOrder).call(this))
            return false;
        const target = $(event.currentTarget);
        const bookingNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-booking-number');
        const cabinNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-cabin-number');
        if (!bookingNumber || !cabinNumber)
            return false;
        const dialog = $(App.templates.Order.Messages.CruiseCheckTouristsDialog({
            bookingNumber,
            cabinNumber,
            isLuxeCruise: __classPrivateFieldGet(this, _OrderPage_header, "f").isLuxeCruise,
        }));
        dialog.on('click', '.js-cruise-issue-dialog-confirm', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onCruiseIssueAgreed).call(this, e); }));
        dialog.on('click', '.js-cruise-issue-dialog-close', () => App.popupHide());
        App.popupShow(dialog, 'Выписка круизного билета');
        return true;
    }, _OrderPage_onCruiseIssueAgreed = function _OrderPage_onCruiseIssueAgreed(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const bookingNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-booking-number');
                const cabinNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPage_getRequiredParameter).call(_a, target, 'data-cabin-number');
                if (!bookingNumber || !cabinNumber)
                    return false;
                const action = __classPrivateFieldGet(this, _OrderPage_options, "f").urls.sendCruiseIssueRequest;
                const response = yield doAction(action, {
                    orderNumber: __classPrivateFieldGet(this, _OrderPage_options, "f").id,
                    bookingNumber,
                    cabinNumber,
                });
                if (!response) {
                    App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPage_defaultError));
                    return false;
                }
                if (!response.status.success && response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                    return true;
                }
                const dialog = $(App.templates.Order.Messages.CruiseIssueRequestInfo({
                    isRealCabinNumber: response.data.isRealCabinNumber,
                    isIssueInWork: response.data.isIssueInWork,
                }));
                App.popupShow(dialog, 'Внимание');
                // скрыть кнопку "Выписать"
                $(`.js-cruise-issue-request[data-booking-number="${bookingNumber}"]`, __classPrivateFieldGet(this, _OrderPage_servicesContainer, "f")).parents('.js-order-service-details').hide();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onShowTermsClick = function _OrderPage_onShowTermsClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            if (__classPrivateFieldGet(this, _OrderPage_popupInfo, "f"))
                App.popupHide();
            const target = $(event.currentTarget);
            __classPrivateFieldSet(this, _OrderPage_popupInfo, new App.PopupOld({
                content: $('<div class="js-auto-terms-wrap"><div style="padding:10px;"><img src="/img/main/load-sm.gif"/></div></div>'),
                onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b, _c; return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getVehicleTerms).call(this, (_b = target.attr('href')) !== null && _b !== void 0 ? _b : '', (_c = target.closest('.js-order-service').attr('data-booking-number')) !== null && _c !== void 0 ? _c : ''); }),
            }), "f");
            $('body').trigger("popup:open" /* Events.PopupOpen */, []);
            return true;
        });
    }, _OrderPage_getVehicleTerms = function _OrderPage_getVehicleTerms(key, bookingNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.getVehicleTerms,
                method: 'POST',
                data: { key },
            });
            try {
                const response = yield xhr;
                let term = 'Произошла ошибка. Попробуйте еще раз позднее.';
                let isDebit = false;
                let isCredit = false;
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(response)) {
                    if (response.status.messages && response.status.messages.length > 0)
                        term = response.status.messages[0].text;
                }
                else {
                    term = response.data.term;
                    const domNodes = jQuery.parseHTML(response.data.searchText);
                    let searchText = $(domNodes).find('h4').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dt').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dd').text();
                    if (searchText.includes('дебетов'))
                        isDebit = true;
                    if (searchText.includes('кредитн'))
                        isCredit = true;
                    if (response.data.isNeedCarDeposit)
                        isCredit = true;
                }
                const termContent = $(App.templates.VehicleTerms({ term, isDebit, isCredit }));
                const parent = $('.js-popup').find('.js-auto-terms-wrap');
                parent.empty().append(termContent);
                parent.addClass('auto-terms-wrap');
                const html = parent.clone().html();
                const copyButton = $(document.createElement('input'))
                    .attr('type', 'button')
                    .attr('value', 'Сохранить')
                    .attr('class', 'form-btn form-btn_alert _save');
                copyButton.on('click', () => App.download(`Service terms for ${bookingNumber}.html`, `${html}`));
                parent.prepend(copyButton);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _OrderPage_getRequiredParameter = function _OrderPage_getRequiredParameter(element, name) {
        const value = element.attr(name);
        if (!value || value.length <= 0)
            window.console.log(`Ошибка. У формы не задан параметр ${name}`);
        return value;
    }, _OrderPage_reloadAll = function _OrderPage_reloadAll() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getHeader).call(this);
            yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getServices).call(this);
            // прокрутка не нужна
        });
    }, _OrderPage_setLoadingText = function _OrderPage_setLoadingText(text) {
        $('.js-popup-container').find('.js-loading-text').text(text);
    }, _OrderPage_onSearchBefore = function _OrderPage_onSearchBefore(container) {
        container.hide();
        $('.js-details-loading', container.closest('.js-order-service-details')).show();
    }, _OrderPage_onSearchAlways = function _OrderPage_onSearchAlways(container) {
        container.show();
        $('.js-details-loading', container.closest('.js-order-service-details')).hide();
    }, _OrderPage_hidePreloader = function _OrderPage_hidePreloader(container) {
        $('.js-loading', container).remove();
    }, _OrderPage_getDataLoading = function _OrderPage_getDataLoading() {
        return $('<br/><div>Данные загружаются</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPage_getDataSaving = function _OrderPage_getDataSaving() {
        return $('<br/><div>Данные сохраняются</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPage_getDataRebooking = function _OrderPage_getDataRebooking() {
        return $('<br/><div>Выполняется перебронирование</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPage_getDataBooking = function _OrderPage_getDataBooking() {
        return $('<br/><div>Выполняется бронирование</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPage_getDataCurrentBookingCancellation = function _OrderPage_getDataCurrentBookingCancellation() {
        return $('<br/><div>Выполняется аннуляция текущей брони</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPage_getReport = function _OrderPage_getReport(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = $.ajax({
                url: $(e.currentTarget).attr('data-href'),
                method: 'GET',
            });
            const popupGroup = __classPrivateFieldGet(this, _OrderPage_popup, "f").show({
                group: 'report',
                content: App.templates.Order.Messages.Loading({}),
                delay: 2000,
            });
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(response))
                    return;
                if (response.data.errorMessage) {
                    const message = { type: 0 /* MessageType.Information */, text: response.data.errorMessage };
                    __classPrivateFieldGet(this, _OrderPage_popup, "f").show({ content: App.templates.Message(message) });
                    return;
                }
                if (!response.data.hasForm) {
                    window.location.href = response.data.url;
                    return;
                }
                Fancybox.show([
                    {
                        src: response.data.url,
                        type: 'iframe',
                        width: 800,
                        height: '80%',
                    },
                ]);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _OrderPage_popup, "f").hide(popupGroup);
            }
        });
    }, _OrderPage_getCruiseDoc = function _OrderPage_getCruiseDoc(e) {
        let url = $(e.currentTarget).attr('data-href');
        if (url && url.length !== 0) {
            url += `order-${__classPrivateFieldGet(this, _OrderPage_options, "f").id}/`;
            window.location.href = url;
        }
    }, _OrderPage_getDocumentDownloadLinkDialog = function _OrderPage_getDocumentDownloadLinkDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            this.root.off('click', '#acceptGetDocumentLink');
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.checkPackageAvailableForLink,
                method: 'POST',
                data: { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id },
            });
            const popupGroup = __classPrivateFieldGet(this, _OrderPage_popup, "f").show({
                group: 'link',
                content: App.templates.Order.Messages.Loading({}),
                delay: 250,
            });
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(response)) {
                    __classPrivateFieldGet(this, _OrderPage_popup, "f").hide(popupGroup);
                    return;
                }
                __classPrivateFieldGet(this, _OrderPage_popup, "f").show({
                    group: popupGroup,
                    content: App.templates.Order.Messages.DocumentDownloadLinkDialog({ message: response.data.message }),
                });
            }
            catch (ex) {
                __classPrivateFieldGet(this, _OrderPage_popup, "f").hide(popupGroup);
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            this.root.on('click', '#acceptGetDocumentLink', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_onAcceptDownloadLinkClick).call(this, e, popupGroup); }));
            this.root.on('click', '#declineGetDocumentLink', () => __classPrivateFieldGet(this, _OrderPage_popup, "f").hide(popupGroup));
        });
    }, _OrderPage_setContractConfirmationDate = function _OrderPage_setContractConfirmationDate() {
        return __awaiter(this, void 0, void 0, function* () {
            const hasAgreement = $('#hasAgreement').is(':checked');
            const hasOrderForm = $('#hasOrderForm').is(':checked');
            if (!hasAgreement) {
                alert($('#hasAgreement').attr('data-msg-required'));
                return;
            }
            if (!hasOrderForm) {
                alert($('#hasOrderForm').attr('data-msg-required'));
                return;
            }
            const xhr = $.ajax({
                url: '/my/order/setcontractconfirmationdate',
                type: 'POST',
                data: { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id },
                async: true,
            });
            try {
                yield xhr;
                return;
            }
            catch (ex) { /* empty */ }
        });
    }, _OrderPage_onAcceptDownloadLinkClick = function _OrderPage_onAcceptDownloadLinkClick(event, popupGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.getDocumentDownloadLink,
                method: 'POST',
                data: { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id },
            });
            __classPrivateFieldGet(this, _OrderPage_popup, "f").show({
                group: popupGroup,
                content: App.templates.Order.Messages.Loading({}),
                delay: 250,
            });
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(response)) {
                    __classPrivateFieldGet(this, _OrderPage_popup, "f").hide(popupGroup);
                    return;
                }
                __classPrivateFieldGet(this, _OrderPage_popup, "f").show({
                    content: App.templates.Order.Messages.DocumentDownloadLink({
                        url: response.data.url,
                        lifetime: response.data.lifetime,
                    }),
                });
            }
            catch (ex) {
                __classPrivateFieldGet(this, _OrderPage_popup, "f").hide(popupGroup);
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _OrderPage_onScheduleClick = function _OrderPage_onScheduleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _OrderPage_schedulePopupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _OrderPage_schedulePopupInfo, new App.PopupOld({
            content: $('<div class="js-cruise-schedule cruise-schedule user-content"><div style="padding:10px;"><img src="/img/main/load-sm.gif"/></div></div>'),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_getCruiseSchedule).call(this, (_b = $(event.currentTarget).attr('data-ordernumber')) !== null && _b !== void 0 ? _b : ''); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _OrderPage_getCruiseSchedule = function _OrderPage_getCruiseSchedule(orderNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPage_options, "f").urls.getCruiseSchedule,
                method: 'POST',
                data: { orderNumber: orderNumber },
            });
            const response = yield xhr;
            if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(response)) {
                App.popupHide();
                return;
            }
            let blockDescr = $('<div>Расписание будет позже.</div>');
            if (response && response.data && response.data.item) {
                blockDescr = $(App.templates.Order.CruiseSchedule({ scheduleData: response.data.item }));
            }
            $('.js-cruise-schedule', $('.js-popup')).empty().append(blockDescr);
        });
    }, _OrderPage_onTouristPriceEditClick = function _OrderPage_onTouristPriceEditClick(event) {
        event.preventDefault();
        $('.js-order-header .js-order-touristPriceEditWrap').showByClass();
        $('.js-order-header .js-order-touristPriceViewWrap').hideByClass();
    }, _OrderPage_onTouristPriceSaveClick = function _OrderPage_onTouristPriceSaveClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (__classPrivateFieldGet(this, _OrderPage_processExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderPage_processExecuting, true, "f");
            try {
                $('.js-order-header .js-order-touristPriceEditItem').removeClass('_invalid');
                const price = $('.js-order-header .js-order-touristPriceEditItem input').valNumber();
                if (!price || price <= 0 || price < __classPrivateFieldGet(this, _OrderPage_header, "f").touristPrice.limitFrom || price > __classPrivateFieldGet(this, _OrderPage_header, "f").touristPrice.limitTo) {
                    $('.js-order-header .js-order-touristPriceEditItem').addClass('_invalid');
                    return;
                }
                const touristPriceResponse = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.saveTouristPrice, { id: __classPrivateFieldGet(this, _OrderPage_options, "f").id, price });
                if (!App.validateResponse(touristPriceResponse, __classPrivateFieldGet(this, _OrderPage_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return;
                if (!touristPriceResponse)
                    return;
                $('.js-order-header .js-order-touristPrice').find(App.Money.tagName).get(0).amount = price;
                $('.js-order-header .js-order-touristPriceEditWrap').hideByClass();
                $('.js-order-header .js-order-touristPriceViewWrap').showByClass();
            }
            finally {
                __classPrivateFieldSet(this, _OrderPage_processExecuting, false, "f");
            }
        });
    }, _OrderPage_onTouristPriceSaveCancelClick = function _OrderPage_onTouristPriceSaveCancelClick() {
        $('.js-order-header .js-order-touristPrice').find(App.Money.tagName).get(0).amount = __classPrivateFieldGet(this, _OrderPage_header, "f").touristPrice.price;
        $('.js-order-header .js-order-touristPriceEditWrap').hideByClass();
        $('.js-order-header .js-order-touristPriceViewWrap').showByClass();
    }, _OrderPage_markMessageAsRead = function _OrderPage_markMessageAsRead(messageKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.setChatMessageRead, { messageKeys: messageKeys });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPage_messages, "f"), undefined, { showOnPage: true }))
                return;
            if (!response)
                return;
        });
    }, _OrderPage_checkUnreadMessages = function _OrderPage_checkUnreadMessages(container) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                rootMargin: '0px',
                threshold: 1.0,
            };
            const callback = (me) => {
                return function (entries, observer) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const keys = [];
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                const item = $(entry.target);
                                item.addClass('_off');
                                observer.unobserve(entry.target);
                                const key = Number(item.attr('data-key'));
                                keys.push(key);
                                item.removeAttr('data-key');
                            }
                        });
                        if (keys.length != 0) {
                            yield __classPrivateFieldGet(me, _OrderPage_instances, "m", _OrderPage_markMessageAsRead).call(me, keys);
                            App.emptyArray(keys);
                        }
                    });
                };
            };
            const observer = new IntersectionObserver(callback(this), options);
            const mes = container.find('._new:not(._off)');
            mes.each((i, v) => observer.observe(v));
        });
    }, _OrderPage_onExpansionPanelAfterToggle = function _OrderPage_onExpansionPanelAfterToggle(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            if (!data.opened)
                return;
            const target = $(e.target);
            if (target.attr('data-remote-loaded') === 'true')
                return;
            target.attr('data-remote-loaded', 'true');
            switch (data.type) {
                case 'priceBreakdown':
                    yield __classPrivateFieldGet(this, _OrderPage_instances, "m", _OrderPage_loadPriceBreakdown).call(this, target, data.key);
                    break;
                // no default
            }
        });
    }, _OrderPage_loadPriceBreakdown = function _OrderPage_loadPriceBreakdown(target_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (target, key, signal = App.noneSignal) {
            var _b;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(App.app.url.route(__classPrivateFieldGet(this, _OrderPage_options, "f").urls.orderPriceBreakdown, key), { signal });
                    if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                target.find('.js-expansion-panel-content').replaceWith(App.templates.Order.OrderPriceBreakdown({
                    grossPrice: __classPrivateFieldGet(this, _OrderPage_header, "f").grossPrice,
                    currency: __classPrivateFieldGet(this, _OrderPage_header, "f").currency,
                    totalDiscount: __classPrivateFieldGet(this, _OrderPage_header, "f").totalDiscount,
                    discount: __classPrivateFieldGet(this, _OrderPage_header, "f").discount,
                    bonusAmount: __classPrivateFieldGet(this, _OrderPage_header, "f").bonusAmount,
                    fakeMarkup: __classPrivateFieldGet(this, _OrderPage_header, "f").fakeMarkup,
                    onlyAvia: __classPrivateFieldGet(this, _OrderPage_header, "f").onlyAvia,
                    items: (_b = response === null || response === void 0 ? void 0 : response.data.items) !== null && _b !== void 0 ? _b : [],
                }));
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    _OrderPage_defaultError = { value: $('<h3>Произошла непредвиденная ошибка. Попробуйте позже</h3>') };
    App.OrderPage = OrderPage;
})(App || (App = {}));
/// <reference path='OrderPage.ts' />
var App;
(function (App) {
    var _OrderPageMobile_instances, _a, _OrderPageMobile_options, _OrderPageMobile_fareTranslations, _OrderPageMobile_defaultError, _OrderPageMobile_infoBlocksTemplate, _OrderPageMobile_invalidOrder, _OrderPageMobile_header, _OrderPageMobile_genders, _OrderPageMobile_citizenshipsCountries, _OrderPageMobile_chinaCities, _OrderPageMobile_relationships, _OrderPageMobile_visas, _OrderPageMobile_renderSpeed, _OrderPageMobile_touristData, _OrderPageMobile_messages, _OrderPageMobile_chatModel, _OrderPageMobile_popup, _OrderPageMobile_responseValidator, _OrderPageMobile_popupInfo, _OrderPageMobile_orderHeaderContainer, _OrderPageMobile_orderDocumentsContainer, _OrderPageMobile_orderTouristsContainer, _OrderPageMobile_orderPaymentsContainer, _OrderPageMobile_charterInfoContainer, _OrderPageMobile_servicesOutput, _OrderPageMobile_servicesContainer, _OrderPageMobile_canceledServicesOutput, _OrderPageMobile_canceledServicesContainer, _OrderPageMobile_cruiseServicesContainer, _OrderPageMobile_managerContainer, _OrderPageMobile_chatContainer, _OrderPageMobile_chatSubmitButton, _OrderPageMobile_chatObjectType, _OrderPageMobile_chatObjectContainer, _OrderPageMobile_chatSubjectContainer, _OrderPageMobile_chatSubjectType, _OrderPageMobile_chatPnr, _OrderPageMobile_pnrsSelectBlock, _OrderPageMobile_cancelOrderContainer, _OrderPageMobile_electronicTripContainer, _OrderPageMobile_electronicTripForm, _OrderPageMobile_addBusSeatsButton, _OrderPageMobile_mapWrapClass, _OrderPageMobile_headerTemplate, _OrderPageMobile_documentsTemplate, _OrderPageMobile_touristsTemplate, _OrderPageMobile_paymentsTemplate, _OrderPageMobile_servicesTemplate, _OrderPageMobile_charterInfoTemplate, _OrderPageMobile_managerTemplate, _OrderPageMobile_chatTemplate, _OrderPageMobile_chatMessagesTemplate, _OrderPageMobile_chatMessageItems, _OrderPageMobile_mscNoTouristMatchingTemplate, _OrderPageMobile_mscValueTemplate, _OrderPageMobile_schedulePopupInfo, _OrderPageMobile_processExecuting, _OrderPageMobile_saveElectronicTripExecuting, _OrderPageMobile_loadElectronicTripExecuting, _OrderPageMobile_insuranceServices, _OrderPageMobile_tabs, _OrderPageMobile_hasJapanVisa, _OrderPageMobile_hasAliveJapanHotel, _OrderPageMobile_onSelectedInsurance, _OrderPageMobile_canEditOrder, _OrderPageMobile_render, _OrderPageMobile_getHeader, _OrderPageMobile_renderHeader, _OrderPageMobile_renderDocuments, _OrderPageMobile_renderTourists, _OrderPageMobile_renderPayments, _OrderPageMobile_initTourist, _OrderPageMobile_renderManager, _OrderPageMobile_getServices, _OrderPageMobile_renderServices, _OrderPageMobile_renderCharterInfo, _OrderPageMobile_renderChat, _OrderPageMobile_onActionShowMoreMessage, _OrderPageMobile_mergeChatGroups, _OrderPageMobile_renderChatPage, _OrderPageMobile_setAgreeFlagMessage, _OrderPageMobile_onMessageObjectChange, _OrderPageMobile_onMessageSubjectChange, _OrderPageMobile_onPnrChange, _OrderPageMobile_toggleSubmitButton, _OrderPageMobile_aviaAskQuestion, _OrderPageMobile_addChatMessage, _OrderPageMobile_getChatModel, _OrderPageMobile_clickMessageReply, _OrderPageMobile_showReplyDialog, _OrderPageMobile_scrollToMessageFromReply, _OrderPageMobile_mouseOverMessage, _OrderPageMobile_scrollTo, _OrderPageMobile_animBackground, _OrderPageMobile_animBackgroundYellow, _OrderPageMobile_copyTouristData, _OrderPageMobile_onClickCustomerTourist, _OrderPageMobile_showElectronicTripContainer, _OrderPageMobile_loadElectronicTrip, _OrderPageMobile_setDocumentNumberMask, _OrderPageMobile_getDocumentNumberMask, _OrderPageMobile_onETDocumentTypeChange, _OrderPageMobile_hideElectronicTripContainer, _OrderPageMobile_onCustomerTypeChange, _OrderPageMobile_saveElectronicTrip, _OrderPageMobile_showCancelOrderDialog, _OrderPageMobile_sendCancelOrderReason, _OrderPageMobile_closeCancelOrderDialog, _OrderPageMobile_openTouristEditor, _OrderPageMobile_onChangeFindTourist, _OrderPageMobile_onChangeChinaVisaType, _OrderPageMobile_updateVisibleFields, _OrderPageMobile_onChangeChinaCountry, _OrderPageMobile_showTouristEditor, _OrderPageMobile_transliterate, _OrderPageMobile_cancelTouristEditor, _OrderPageMobile_isConfidantPhoneContainedInTouristsPhones, _OrderPageMobile_editTourist, _OrderPageMobile_addPwService, _OrderPageMobile_showAddAviaCruiseDialog, _OrderPageMobile_agreeToAddAviaCruise, _OrderPageMobile_closeAddAviaCruiseDialog, _OrderPageMobile_addCruiseService, _OrderPageMobile_showQualityControl, _OrderPageMobile_showCruiseActivityRefusalDialog, _OrderPageMobile_showAddVisaDialog, _OrderPageMobile_setDependencies, _OrderPageMobile_setSubmitAvailability, _OrderPageMobile_loadVisaServices, _OrderPageMobile_changeVisaServices, _OrderPageMobile_jelectInit, _OrderPageMobile_autocompleteInit, _OrderPageMobile_calendarInit, _OrderPageMobile_saveVisas, _OrderPageMobile_cancelVisas, _OrderPageMobile_showAddInsuranceDialog, _OrderPageMobile_saveInsurances, _OrderPageMobile_cancelInsurances, _OrderPageMobile_addPacFitService, _OrderPageMobile_getDocumentsDialog, _OrderPageMobile_openBookingDetails, _OrderPageMobile_openServiceTourists, _OrderPageMobile_onStopsClick, _OrderPageMobile_renderBookingDetails, _OrderPageMobile_showBusTourists, _OrderPageMobile_showBusSeats, _OrderPageMobile_takeBusSeat, _OrderPageMobile_showFareConditions, _OrderPageMobile_showFarePenalties, _OrderPageMobile_showFareInfo, _OrderPageMobile_getFareTranslation, _OrderPageMobile_loadFareTranslation, _OrderPageMobile_showBrandRules, _OrderPageMobile_renderBrandFare, _OrderPageMobile_onShowMapClick, _OrderPageMobile_showMap, _OrderPageMobile_onActionConfirm, _OrderPageMobile_onActionConfirmCruise, _OrderPageMobile_onConfirmCruiseDialogClose, _OrderPageMobile_onConfirmCruiseDialogContinueAsync, _OrderPageMobile_onActionCancel, _OrderPageMobile_onActionRefreshPrice, _OrderPageMobile_onInactiveIssueButtonClick, _OrderPageMobile_onActionIssue, _OrderPageMobile_doActionIssue, _OrderPageMobile_onActionContinue, _OrderPageMobile_onCancelCurrentAccommodationBooking, _OrderPageMobile_onBookAlternativeHotel, _OrderPageMobile_onCancelIssue, _OrderPageMobile_onConfirmIssue, _OrderPageMobile_onActionPacManual, _OrderPageMobile_onAviaRebook, _OrderPageMobile_onAviaRebookContinue, _OrderPageMobile_aviaRebookCore, _OrderPageMobile_onAviaRebookNewSearch, _OrderPageMobile_onActionAviaSynchronize, _OrderPageMobile_onShowPaymentHistory, _OrderPageMobile_closePaymentHistory, _OrderPageMobile_onShowCancelledServices, _OrderPageMobile_onCloseCancelledServices, _OrderPageMobile_onFillMscTourists, _OrderPageMobile_fillTouristMscData, _OrderPageMobile_onRewriteByMsc, _OrderPageMobile_onRewriteTouristByMsc, _OrderPageMobile_onCruiseChangeRouteRequest, _OrderPageMobile_onCruiseIssueRequest, _OrderPageMobile_onCruiseIssueAgreed, _OrderPageMobile_onShowTermsClick, _OrderPageMobile_getVehicleTerms, _OrderPageMobile_getRequiredParameter, _OrderPageMobile_reloadAll, _OrderPageMobile_setLoadingText, _OrderPageMobile_onSearchBefore, _OrderPageMobile_onSearchAlways, _OrderPageMobile_hidePreloader, _OrderPageMobile_getDataLoading, _OrderPageMobile_getDataSaving, _OrderPageMobile_getDataRebooking, _OrderPageMobile_getDataBooking, _OrderPageMobile_getDataCurrentBookingCancellation, _OrderPageMobile_getReport, _OrderPageMobile_getCruiseDoc, _OrderPageMobile_getDocumentDownloadLinkDialog, _OrderPageMobile_onAcceptDownloadLinkClick, _OrderPageMobile_onScheduleClick, _OrderPageMobile_getCruiseSchedule, _OrderPageMobile_onTouristPriceEditClick, _OrderPageMobile_onTouristPriceSaveClick, _OrderPageMobile_onTouristPriceSaveCancelClick, _OrderPageMobile_markMessageAsRead, _OrderPageMobile_checkUnreadMessages, _OrderPageMobile_onExpansionPanelAfterToggle, _OrderPageMobile_loadPriceBreakdown;
    const doAction = (url_1, ...args_1) => __awaiter(this, [url_1, ...args_1], void 0, function* (url, data = {}, before = () => { }, always = () => { }) {
        try {
            const result = yield $.ajax({
                url,
                method: 'POST',
                data,
                beforeSend: () => before(),
                complete: () => always(),
            });
            return result;
        }
        catch (e) {
            window.console.error(e);
            return undefined;
        }
    });
    class OrderPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-order-page' }, options));
            _OrderPageMobile_instances.add(this);
            _OrderPageMobile_options.set(this, void 0);
            _OrderPageMobile_fareTranslations.set(this, new Map());
            _OrderPageMobile_infoBlocksTemplate.set(this, void 0);
            _OrderPageMobile_invalidOrder.set(this, void 0);
            _OrderPageMobile_header.set(this, void 0);
            _OrderPageMobile_genders.set(this, void 0);
            _OrderPageMobile_citizenshipsCountries.set(this, void 0);
            _OrderPageMobile_chinaCities.set(this, void 0);
            _OrderPageMobile_relationships.set(this, void 0);
            _OrderPageMobile_visas.set(this, void 0);
            _OrderPageMobile_renderSpeed.set(this, 1 /* RenderSpeed.fast */.toString());
            _OrderPageMobile_touristData.set(this, void 0);
            _OrderPageMobile_messages.set(this, void 0);
            _OrderPageMobile_chatModel.set(this, void 0);
            _OrderPageMobile_popup.set(this, void 0);
            _OrderPageMobile_responseValidator.set(this, void 0);
            _OrderPageMobile_popupInfo.set(this, void 0);
            _OrderPageMobile_orderHeaderContainer.set(this, void 0);
            _OrderPageMobile_orderDocumentsContainer.set(this, void 0);
            _OrderPageMobile_orderTouristsContainer.set(this, void 0);
            _OrderPageMobile_orderPaymentsContainer.set(this, void 0);
            _OrderPageMobile_charterInfoContainer.set(this, void 0);
            _OrderPageMobile_servicesOutput.set(this, void 0);
            _OrderPageMobile_servicesContainer.set(this, void 0);
            _OrderPageMobile_canceledServicesOutput.set(this, void 0);
            _OrderPageMobile_canceledServicesContainer.set(this, void 0);
            _OrderPageMobile_cruiseServicesContainer.set(this, void 0);
            _OrderPageMobile_managerContainer.set(this, void 0);
            _OrderPageMobile_chatContainer.set(this, void 0);
            _OrderPageMobile_chatSubmitButton.set(this, void 0);
            _OrderPageMobile_chatObjectType.set(this, void 0);
            _OrderPageMobile_chatObjectContainer.set(this, void 0);
            _OrderPageMobile_chatSubjectContainer.set(this, void 0);
            _OrderPageMobile_chatSubjectType.set(this, void 0);
            _OrderPageMobile_chatPnr.set(this, void 0);
            _OrderPageMobile_pnrsSelectBlock.set(this, void 0);
            _OrderPageMobile_cancelOrderContainer.set(this, void 0);
            _OrderPageMobile_electronicTripContainer.set(this, void 0);
            _OrderPageMobile_electronicTripForm.set(this, void 0);
            _OrderPageMobile_addBusSeatsButton.set(this, void 0);
            _OrderPageMobile_mapWrapClass.set(this, void 0);
            _OrderPageMobile_headerTemplate.set(this, void 0);
            _OrderPageMobile_documentsTemplate.set(this, void 0);
            _OrderPageMobile_touristsTemplate.set(this, void 0);
            _OrderPageMobile_paymentsTemplate.set(this, void 0);
            _OrderPageMobile_servicesTemplate.set(this, void 0);
            _OrderPageMobile_charterInfoTemplate.set(this, void 0);
            _OrderPageMobile_managerTemplate.set(this, void 0);
            _OrderPageMobile_chatTemplate.set(this, void 0);
            _OrderPageMobile_chatMessagesTemplate.set(this, void 0);
            _OrderPageMobile_chatMessageItems.set(this, void 0);
            _OrderPageMobile_mscNoTouristMatchingTemplate.set(this, void 0);
            _OrderPageMobile_mscValueTemplate.set(this, void 0);
            _OrderPageMobile_schedulePopupInfo.set(this, void 0);
            _OrderPageMobile_processExecuting.set(this, false);
            _OrderPageMobile_saveElectronicTripExecuting.set(this, false);
            _OrderPageMobile_loadElectronicTripExecuting.set(this, false);
            _OrderPageMobile_insuranceServices.set(this, []);
            _OrderPageMobile_tabs.set(this, void 0);
            _OrderPageMobile_hasJapanVisa.set(this, void 0);
            _OrderPageMobile_hasAliveJapanHotel.set(this, void 0);
            __classPrivateFieldSet(this, _OrderPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _OrderPageMobile_infoBlocksTemplate, App.templates.InfoBlocks, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_invalidOrder, true, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_messages, new App.Messages(), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_responseValidator, new App.ResponseValidator({ messenger: new App.BlockMessenger(__classPrivateFieldGet(this, _OrderPageMobile_messages, "f")) }), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_headerTemplate, App.templates.Order.Header_Mobile, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_documentsTemplate, App.templates.Order.Documents_Mobile, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_touristsTemplate, App.templates.Order.OrderTouristsBlock_Mobile, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_paymentsTemplate, App.templates.Order.OrderPaymentReportBlock_Mobile, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_servicesTemplate, App.templates.Order.Services_Mobile, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_charterInfoTemplate, App.templates.Order.CharterInfo, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_managerTemplate, App.templates.Order.Manager, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_chatTemplate, App.templates.Order.Chat, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_chatMessagesTemplate, App.templates.Order.ChatMessages, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_mscNoTouristMatchingTemplate, App.templates.Order.MscNoTouristMatching, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_mscValueTemplate, App.templates.Order.MscValue, "f");
            __classPrivateFieldSet(this, _OrderPageMobile_orderHeaderContainer, $('.js-order-header', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_orderDocumentsContainer, $('.js-order-documents', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_orderTouristsContainer, $('.js-order-tourists', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_orderPaymentsContainer, $('.js-order-payments', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_charterInfoContainer, $('.js-order-charter-info', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_servicesOutput, $('.js-order-services-output', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_servicesContainer, $('.js-order-services', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_canceledServicesOutput, $('.js-order-canceled-services-output', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_canceledServicesContainer, $('.js-order-canceled-services', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_cruiseServicesContainer, $('.js-order-add-cruise-serviceOption', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_managerContainer, $('.js-order-manager', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_chatContainer, $('.js-order-chat', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_electronicTripContainer, $('.js-electronic-trip-container', this.root), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_addBusSeatsButton, $('.js-order-add-bus-seats', this.root), "f");
            __classPrivateFieldGet(this, _OrderPageMobile_addBusSeatsButton, "f").on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showBusTourists).call(this); }));
            __classPrivateFieldSet(this, _OrderPageMobile_mapWrapClass, 'js-point-map-wrap', "f");
            __classPrivateFieldSet(this, _OrderPageMobile_touristData, new Array(), "f");
            this.components.push(new App.ExpansionPanelComponent());
            $(this.root)
                .on('click', '.js-cancel-order', () => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showCancelOrderDialog).call(this))
                .on('click', '.js-order-tourist-edit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showTouristEditor).call(this, e); }))
                .on('blur', '.js-needTransliterate', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_transliterate).call(this, e))
                .on('click', '.js-order-tourist-editor-cancel', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_cancelTouristEditor).call(_a, e))
                .on('click', '.js-order-tourist-change', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_editTourist).call(this, e); }))
                .on('click', '.js-order-add-service', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_addPwService).call(this, e); }))
                .on('click', '.js-show-add-avia-cruise-dialog', () => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showAddAviaCruiseDialog).call(this))
                .on('click', '.js-add-avia-cruise-cancel', () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_closeAddAviaCruiseDialog).call(_a))
                .on('click', '#addAviaCruiseAgree', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_agreeToAddAviaCruise).call(this, e))
                .on('click', '.js-order-add-cruise-serviceOption', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_addCruiseService).call(this, e))
                .on('click', '.js-show_qualityControlForm', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_showQualityControl).call(_a, e))
                .on('click', '.js-cruise-refusal', () => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showCruiseActivityRefusalDialog).call(this))
                .on('click', '.js-order-add-visa', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showAddVisaDialog).call(this); }))
                .on('click', '.js-order-add-insurance', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showAddInsuranceDialog).call(this); }))
                .on('click', '.js-order-add-anyservice', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_addPacFitService).call(this); }))
                .on('click', '#getDocumentsButton', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getDocumentsDialog).call(this); }))
                .on('click', '#getDocDownloadLink', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getDocumentDownloadLinkDialog).call(this); }))
                .on('click', '.js-copyTouristConfidantData', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_copyTouristData).call(this, e, 'js-touristConfidantData', true); }))
                .on('click', '.js-copyTouristPostData', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_copyTouristData).call(this, e, 'js-touristPostData', false); }))
                .on('click', '.js-order-canceled-show', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onShowCancelledServices).call(_a, e))
                .on('click', '.js-order-canceled-close', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onCloseCancelledServices).call(_a, e))
                .on('click', '.js-scroll-to-messages', e => App.scrollLinkClickHandler(e))
                .on('click', '.js-avia-ask-question', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_aviaAskQuestion).call(this, e); }))
                .on('click', '.js-avia-ask-question', e => App.scrollLinkClickHandler(e))
                .on('click', '.js-filter-option', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onSelectedInsurance).call(this, e));
            $(__classPrivateFieldGet(this, _OrderPageMobile_orderTouristsContainer, "f"))
                .on('click', '.js-fill-msc-tourists', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onFillMscTourists).call(this); }));
            $(__classPrivateFieldGet(this, _OrderPageMobile_orderPaymentsContainer, "f"))
                .on('click', '.js-order-payment-history-link', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onShowPaymentHistory).call(this, e); }));
            $(__classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f")).add(__classPrivateFieldGet(this, _OrderPageMobile_canceledServicesContainer, "f"))
                .on('click', '.js-order-service .js-order-service-open', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_openBookingDetails).call(this, e); }))
                .on('click', '.js-order-service-tourist-more', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_openServiceTourists).call(this, e); }))
                .on('click', '.js-segment-stop-info', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onStopsClick).call(_a, e))
                .on('click', '.js-booking-action-confirm', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionConfirm).call(this, e); }))
                .on('click', '.js-booking-action-confirm-cruise', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionConfirmCruise).call(this, e))
                .on('click', '.js-booking-action-cancel', (e) => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionCancel).call(this, e))
                .on('click', '.js-service-action-cancel', (e) => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionCancel).call(this, e))
                .on('click', '.js-inactive-issue', () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onInactiveIssueButtonClick).call(_a))
                .on('click', '.js-booking-action-issue', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionIssue).call(this, e); }))
                .on('click', '.js-booking-action-refresh-price', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionRefreshPrice).call(this, e); }))
                .on('click', '.js-booking-action-pac-manual', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionPacManual).call(this, e); }))
                .on('click', '.js-avia-rebook', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onAviaRebook).call(this, e); }))
                .on('click', '.js-booking-action-mark-avia-issued, .js-booking-action-mark-avia-cancelled', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionAviaSynchronize).call(this, e); }))
                .on('click', '.js-cruise-issue-request', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onCruiseIssueRequest).call(this, e))
                .on('click', '.js-cruise-changeRoute-request', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onCruiseChangeRouteRequest).call(this, e); }))
                .on('click', '.js-lk-order-cruisedoc-link', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getCruiseDoc).call(this, e))
                .on('click', '.js-order-service .js-order-service-hidden .js-show-terms', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onShowTermsClick).call(this, e); }))
                .on("action:continue" /* Events.ActionContinue */, (e, invoker, serviceKey, actionType) => __awaiter(this, void 0, void 0, function* () {
                return (yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionContinue).call(this, e, invoker, serviceKey, actionType));
            }));
            // $('.js-tab', this.root).on(Events.TabClick, e => this.#onTabClick(e));
            __classPrivateFieldSet(this, _OrderPageMobile_tabs, new App.TabsMobile({ root: this.root }), "f");
            __classPrivateFieldGet(this, _OrderPageMobile_tabs, "f").showActive();
            $(document).on("expansion-panel:aftertoggle" /* Events.ExpansionPanelAfterToggle */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onExpansionPanelAfterToggle).call(this, e, data); }));
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_render).call(this);
            });
        }
        getCommonInfoBlockCompact(message) {
            return this.getCommonInfoBlock(message.type, message.text);
        }
        getCommonInfoBlock(messageType, text) {
            return $(__classPrivateFieldGet(this, _OrderPageMobile_infoBlocksTemplate, "f").call(this, { type: messageType, text }));
        }
        updateCityOptions(items, parent, setRequired = false) {
            const model = new App.SelectListModel({
                name: 'Tourist.ChinaReturnFlightArrCity',
                form: true,
                autocomplete: false,
                items: items,
            });
            const cities = $(App.templates.FilterSelect(model));
            const citySelect = $('.js-chinaArrCities', parent);
            citySelect
                .empty()
                .append(cities);
            if (setRequired)
                $('input', citySelect).not('[name$=".Search"]').not('[data-not-required]').each((i, v) => v.setAttribute('required', 'required'));
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_jelectInit).call(_a, citySelect.parent());
        }
    }
    _a = OrderPageMobile, _OrderPageMobile_options = new WeakMap(), _OrderPageMobile_fareTranslations = new WeakMap(), _OrderPageMobile_infoBlocksTemplate = new WeakMap(), _OrderPageMobile_invalidOrder = new WeakMap(), _OrderPageMobile_header = new WeakMap(), _OrderPageMobile_genders = new WeakMap(), _OrderPageMobile_citizenshipsCountries = new WeakMap(), _OrderPageMobile_chinaCities = new WeakMap(), _OrderPageMobile_relationships = new WeakMap(), _OrderPageMobile_visas = new WeakMap(), _OrderPageMobile_renderSpeed = new WeakMap(), _OrderPageMobile_touristData = new WeakMap(), _OrderPageMobile_messages = new WeakMap(), _OrderPageMobile_chatModel = new WeakMap(), _OrderPageMobile_popup = new WeakMap(), _OrderPageMobile_responseValidator = new WeakMap(), _OrderPageMobile_popupInfo = new WeakMap(), _OrderPageMobile_orderHeaderContainer = new WeakMap(), _OrderPageMobile_orderDocumentsContainer = new WeakMap(), _OrderPageMobile_orderTouristsContainer = new WeakMap(), _OrderPageMobile_orderPaymentsContainer = new WeakMap(), _OrderPageMobile_charterInfoContainer = new WeakMap(), _OrderPageMobile_servicesOutput = new WeakMap(), _OrderPageMobile_servicesContainer = new WeakMap(), _OrderPageMobile_canceledServicesOutput = new WeakMap(), _OrderPageMobile_canceledServicesContainer = new WeakMap(), _OrderPageMobile_cruiseServicesContainer = new WeakMap(), _OrderPageMobile_managerContainer = new WeakMap(), _OrderPageMobile_chatContainer = new WeakMap(), _OrderPageMobile_chatSubmitButton = new WeakMap(), _OrderPageMobile_chatObjectType = new WeakMap(), _OrderPageMobile_chatObjectContainer = new WeakMap(), _OrderPageMobile_chatSubjectContainer = new WeakMap(), _OrderPageMobile_chatSubjectType = new WeakMap(), _OrderPageMobile_chatPnr = new WeakMap(), _OrderPageMobile_pnrsSelectBlock = new WeakMap(), _OrderPageMobile_cancelOrderContainer = new WeakMap(), _OrderPageMobile_electronicTripContainer = new WeakMap(), _OrderPageMobile_electronicTripForm = new WeakMap(), _OrderPageMobile_addBusSeatsButton = new WeakMap(), _OrderPageMobile_mapWrapClass = new WeakMap(), _OrderPageMobile_headerTemplate = new WeakMap(), _OrderPageMobile_documentsTemplate = new WeakMap(), _OrderPageMobile_touristsTemplate = new WeakMap(), _OrderPageMobile_paymentsTemplate = new WeakMap(), _OrderPageMobile_servicesTemplate = new WeakMap(), _OrderPageMobile_charterInfoTemplate = new WeakMap(), _OrderPageMobile_managerTemplate = new WeakMap(), _OrderPageMobile_chatTemplate = new WeakMap(), _OrderPageMobile_chatMessagesTemplate = new WeakMap(), _OrderPageMobile_chatMessageItems = new WeakMap(), _OrderPageMobile_mscNoTouristMatchingTemplate = new WeakMap(), _OrderPageMobile_mscValueTemplate = new WeakMap(), _OrderPageMobile_schedulePopupInfo = new WeakMap(), _OrderPageMobile_processExecuting = new WeakMap(), _OrderPageMobile_saveElectronicTripExecuting = new WeakMap(), _OrderPageMobile_loadElectronicTripExecuting = new WeakMap(), _OrderPageMobile_insuranceServices = new WeakMap(), _OrderPageMobile_tabs = new WeakMap(), _OrderPageMobile_hasJapanVisa = new WeakMap(), _OrderPageMobile_hasAliveJapanHotel = new WeakMap(), _OrderPageMobile_instances = new WeakSet(), _OrderPageMobile_onSelectedInsurance = function _OrderPageMobile_onSelectedInsurance(e) {
        var _b, _c;
        const value = $(e.currentTarget).attr('data-val');
        const description = (_c = (_b = __classPrivateFieldGet(this, _OrderPageMobile_insuranceServices, "f").find(v => v.key === value)) === null || _b === void 0 ? void 0 : _b.description) !== null && _c !== void 0 ? _c : '';
        $(e.currentTarget)
            .parents('.form-item')
            .find('.js-form-item-description')
            .html(description);
    }, _OrderPageMobile_canEditOrder = function _OrderPageMobile_canEditOrder() {
        return !__classPrivateFieldGet(this, _OrderPageMobile_invalidOrder, "f");
    }, _OrderPageMobile_render = function _OrderPageMobile_render() {
        return __awaiter(this, void 0, void 0, function* () {
            App.modalShow($(App.templates.Order.Messages.Loading({})));
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getHeader).call(this);
            if (__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getServices).call(this);
        });
    }, _OrderPageMobile_getHeader = function _OrderPageMobile_getHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getOrderHeader,
                method: 'POST',
                data: { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id },
            });
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_setLoadingText).call(_a, 'Загружается информация о заказе...');
            __classPrivateFieldGet(this, _OrderPageMobile_orderHeaderContainer, "f").append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldSet(this, _OrderPageMobile_invalidOrder, false, "f");
                __classPrivateFieldSet(this, _OrderPageMobile_header, response.data.item, "f");
                __classPrivateFieldSet(this, _OrderPageMobile_genders, response.data.genders, "f");
                __classPrivateFieldSet(this, _OrderPageMobile_citizenshipsCountries, response.data.citizenshipCountries, "f");
                __classPrivateFieldSet(this, _OrderPageMobile_chinaCities, response.data.chinaCities, "f");
                __classPrivateFieldSet(this, _OrderPageMobile_relationships, response.data.relationships, "f");
                __classPrivateFieldSet(this, _OrderPageMobile_hasJapanVisa, response.data.hasJapanVisa, "f");
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderHeader).call(this, response.data);
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderDocuments).call(this, response.data);
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderTourists).call(this, response.data.item);
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderPayments).call(this, response.data.item);
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderManager).call(this, response.data.item);
                __classPrivateFieldSet(this, _OrderPageMobile_chatModel, __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getChatModel).call(this, response.data.chat), "f");
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderChat).call(this, __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f"));
                $('.js-lk-order-docs-list .js-lk-order-doc-link').on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getReport).call(this, e); }));
                $('.js-order-header .js-show-schedule').on('click', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onScheduleClick).call(this, e));
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                App.popupHide();
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_checkUnreadMessages).call(this, $('.js-chat-messages', this.root));
                // TODO: hide .js-loading ?
            }
        });
    }, _OrderPageMobile_renderHeader = function _OrderPageMobile_renderHeader(data) {
        __classPrivateFieldGet(this, _OrderPageMobile_orderHeaderContainer, "f")
            .empty()
            .append(__classPrivateFieldGet(this, _OrderPageMobile_headerTemplate, "f").call(this, Object.assign(Object.assign({}, data.item), { reports: data.reports })));
        __classPrivateFieldSet(this, _OrderPageMobile_cancelOrderContainer, $('.js-cancel-order-container', __classPrivateFieldGet(this, _OrderPageMobile_orderHeaderContainer, "f")), "f");
        if (data.item.canChooseBusSeats)
            __classPrivateFieldGet(this, _OrderPageMobile_addBusSeatsButton, "f").show();
        // стоимость заказа по договору с туристом
        const touristPriceWrap = $('.js-order-header').find('.js-order-touristPriceWrap');
        if (touristPriceWrap.length > 0) {
            touristPriceWrap.on('click', '.js-order-touristPriceEdit', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onTouristPriceEditClick).call(this, e));
            touristPriceWrap.on('click', '.js-order-touristPriceSave', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onTouristPriceSaveClick).call(this, e); }));
            touristPriceWrap.on('click', '.js-order-touristPriceSaveCancel', () => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onTouristPriceSaveCancelClick).call(this));
        }
        const epShowHideContainer = $('.js-ep-show-hide-container', this.root);
        $('.js-ep-show-more-link-show', epShowHideContainer).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showElectronicTripContainer).call(this, e); }));
        $('.js-ep-show-more-link-hide', epShowHideContainer).on('click', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_hideElectronicTripContainer).call(this, e));
        if (data.item.isNeedShowActivities) {
            __classPrivateFieldGet(this, _OrderPageMobile_cruiseServicesContainer, "f")
                .addClass('_cruise')
                .append(App.templates.Order.CruiseActivityButton({ number: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id, isLuxeCruise: data.item.isLuxeCruise }));
        }
    }, _OrderPageMobile_renderDocuments = function _OrderPageMobile_renderDocuments(data) {
        __classPrivateFieldGet(this, _OrderPageMobile_orderDocumentsContainer, "f")
            .empty()
            .append(__classPrivateFieldGet(this, _OrderPageMobile_documentsTemplate, "f").call(this, Object.assign(Object.assign({}, data.item), { reports: data.reports })));
    }, _OrderPageMobile_renderTourists = function _OrderPageMobile_renderTourists(data) {
        __classPrivateFieldGet(this, _OrderPageMobile_orderTouristsContainer, "f")
            .empty()
            .append(__classPrivateFieldGet(this, _OrderPageMobile_touristsTemplate, "f").call(this, data));
    }, _OrderPageMobile_renderPayments = function _OrderPageMobile_renderPayments(data) {
        __classPrivateFieldGet(this, _OrderPageMobile_orderPaymentsContainer, "f")
            .empty()
            .append(__classPrivateFieldGet(this, _OrderPageMobile_paymentsTemplate, "f").call(this, data));
    }, _OrderPageMobile_initTourist = function _OrderPageMobile_initTourist(tourist) {
        tourist.genders = new App.SelectListModel({
            name: 'Tourist.GenderType',
            form: true,
            autocomplete: false,
            items: __classPrivateFieldGet(this, _OrderPageMobile_genders, "f")
                .map(v => ({
                value: v.value,
                text: v.text,
                selected: tourist.genderTypeValue === v.value,
            })),
        });
        tourist.countries = new App.SelectListModel({
            name: 'Tourist.Citizenship',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPageMobile_citizenshipsCountries, "f")
                .map(v => ({
                value: v.name,
                text: v.countryName,
                selected: tourist.citizenship.value === v.name,
            })),
            isRequired: true,
        });
        tourist.postCountries = new App.SelectListModel({
            name: 'Tourist.ResidenceCountry',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPageMobile_citizenshipsCountries, "f")
                .map(v => ({
                value: v.name,
                text: v.countryName,
                selected: tourist.residenceCountry.value === v.name,
            })),
        });
        tourist.relationships = new App.SelectListModel({
            name: 'Tourist.RelationshipKey',
            form: true,
            autocomplete: false,
            items: __classPrivateFieldGet(this, _OrderPageMobile_relationships, "f")
                .map(v => ({
                value: v.key.toString(),
                text: v.name,
                selected: tourist.confidantRelationship.value == v.key.toString(),
            })),
        });
        tourist.relationships.items.unshift({ value: '', text: 'Выберите', selected: tourist.confidantRelationship.value === null });
        tourist.chinaTypeEntries = new App.SelectListModel({
            name: 'Tourist.ChinaVisaType',
            form: true,
            autocomplete: true,
            items: [
                { value: '0', text: 'Выберите', selected: tourist.chinaTypeEntry.value === null },
                { value: '24', text: 'Воспользуюсь правилом безвизового транзита в третью страну «до 24 часов»', selected: tourist.chinaTypeEntry.value === '24' },
                { value: '240', text: 'Воспользуюсь правилом безвизового транзита в третью страну «240 часов» ', selected: tourist.chinaTypeEntry.value === '240' },
                { value: 'visa', text: 'Самостоятельно оформлена соответствующая виза Китая', selected: tourist.chinaTypeEntry.value === 'visa' },
            ],
        });
        tourist.chinaDptCities = new App.SelectListModel({
            name: 'Tourist.chinaReturnFlightDptCity',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPageMobile_chinaCities, "f")
                .map(v => ({
                value: v.name,
                text: v.name,
                selected: tourist.chinaReturnFlightDptCity.value === v.name,
            })),
        });
        tourist.chinaDptCities.items.unshift({ value: 'null', text: 'Выберите', selected: tourist.chinaReturnFlightDptCity.value === null });
        tourist.chinaArrCountries = new App.SelectListModel({
            name: 'chinaReturnFlightArrCountryId',
            form: true,
            autocomplete: true,
            items: __classPrivateFieldGet(this, _OrderPageMobile_citizenshipsCountries, "f")
                .map(v => ({
                value: v.key.toString(),
                text: v.name,
                selected: tourist.chinaReturnFlightArrCountry.value === v.name,
            })),
        });
        tourist.chinaArrCities = new App.SelectListModel({
            name: 'Tourist.ChinaReturnFlightArrCity',
            form: true,
            autocomplete: true,
            items: tourist.chinaReturnFlightArrCity.value != null
                ? [{ value: tourist.chinaReturnFlightArrCity.value, text: tourist.chinaReturnFlightArrCity.value, selected: true }]
                : [{ value: '0', text: 'Выберите сначала страну', selected: true }],
        });
    }, _OrderPageMobile_renderManager = function _OrderPageMobile_renderManager(data) {
        __classPrivateFieldGet(this, _OrderPageMobile_managerContainer, "f").empty();
        if (data.showManager)
            __classPrivateFieldGet(this, _OrderPageMobile_managerContainer, "f").append(__classPrivateFieldGet(this, _OrderPageMobile_managerTemplate, "f").call(this, data.manager));
    }, _OrderPageMobile_getServices = function _OrderPageMobile_getServices() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return;
            App.popupHide();
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getServices, {
                id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                statusKey: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").statusKey,
                isTour: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isTour,
            }, () => {
                __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f")
                    .empty()
                    .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
            });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                return;
            if (!response)
                return;
            if (!response.data) {
                __classPrivateFieldGet(this, _OrderPageMobile_messages, "f").show({ type: 2 /* MessageType.Error */, text: 'Услуги заказа не найдены' }, { canHide: true });
                return;
            }
            const { items } = response.data;
            __classPrivateFieldSet(this, _OrderPageMobile_hasAliveJapanHotel, items.some(v => v.typeCode == 'Accommodation' && !v.canceled && v.countryKey == 27), "f");
            if (Enumerable.from(items).all(v => !v.isPw))
                __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType = 0 /* OrderContentType.MT */;
            else if (Enumerable.from(items).all(v => v.isPw))
                __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType = 1 /* OrderContentType.PW */;
            else
                __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType = 2 /* OrderContentType.Mixed */;
            __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderServices).call(this, items);
        });
    }, _OrderPageMobile_renderServices = function _OrderPageMobile_renderServices(items) {
        // TODO: показывать кнопку, если есть хоть одна 'живая' услуга.
        // показываем кнопку Отменить только после того, как получили статус содержимого заказа this.options.contentType.
        if (__classPrivateFieldGet(this, _OrderPageMobile_cancelOrderContainer, "f"))
            __classPrivateFieldGet(this, _OrderPageMobile_cancelOrderContainer, "f").show();
        __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderCharterInfo).call(this, items.filter(v => v.charter === true).length > 0);
        const activeServices = items.filter(v => !v.canceled || (v.canceled && (v.isPw ? v.withPenalty : v.withPenaltyMt)));
        const canceledServices = items.filter(v => v.canceled && (v.isPw ? !v.withPenalty : !v.withPenaltyMt));
        if (activeServices.length > 0) {
            __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f")
                .empty()
                .hide()
                .append(__classPrivateFieldGet(this, _OrderPageMobile_servicesTemplate, "f").call(this, Object.assign(activeServices, {
                isNonLuxeCruise: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isCruise && !__classPrivateFieldGet(this, _OrderPageMobile_header, "f").isLuxeCruise,
                hasFictionalServices: activeServices.some(v => v.isFictional),
                hasJapanVisa: __classPrivateFieldGet(this, _OrderPageMobile_hasJapanVisa, "f"),
            })))
                .show(__classPrivateFieldGet(this, _OrderPageMobile_renderSpeed, "f"));
        }
        __classPrivateFieldGet(this, _OrderPageMobile_servicesOutput, "f").toggle(activeServices.length > 0);
        if (canceledServices.length > 0) {
            __classPrivateFieldGet(this, _OrderPageMobile_canceledServicesContainer, "f")
                .empty()
                .hide()
                .append(__classPrivateFieldGet(this, _OrderPageMobile_servicesTemplate, "f").call(this, Object.assign(canceledServices, {
                isNonLuxeCruise: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isCruise && !__classPrivateFieldGet(this, _OrderPageMobile_header, "f").isLuxeCruise,
                hasFictionalServices: canceledServices.some(v => v.isFictional),
            })))
                .show(__classPrivateFieldGet(this, _OrderPageMobile_renderSpeed, "f"));
        }
        __classPrivateFieldGet(this, _OrderPageMobile_canceledServicesOutput, "f").toggle(canceledServices.length > 0);
    }, _OrderPageMobile_renderCharterInfo = function _OrderPageMobile_renderCharterInfo(flag) {
        __classPrivateFieldGet(this, _OrderPageMobile_charterInfoContainer, "f").empty();
        if (flag)
            __classPrivateFieldGet(this, _OrderPageMobile_charterInfoContainer, "f").append(__classPrivateFieldGet(this, _OrderPageMobile_charterInfoTemplate, "f").call(this, {}));
    }, _OrderPageMobile_renderChat = function _OrderPageMobile_renderChat(chat) {
        __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f").append(__classPrivateFieldGet(this, _OrderPageMobile_chatTemplate, "f").call(this, chat));
        __classPrivateFieldSet(this, _OrderPageMobile_chatObjectContainer, $('.js-messages-container', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPageMobile_chatObjectType, $('.js-message-object-select', __classPrivateFieldGet(this, _OrderPageMobile_chatObjectContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPageMobile_chatSubjectContainer, $('.js-message-subject-container', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPageMobile_chatSubjectType, $('.js-message-subject-select', __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPageMobile_chatPnr, $('.js-message-pnr-select', __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectContainer, "f")), "f");
        __classPrivateFieldSet(this, _OrderPageMobile_pnrsSelectBlock, new App.FilterSelectBlock({ root: __classPrivateFieldGet(this, _OrderPageMobile_chatPnr, "f") }), "f");
        $.each(__classPrivateFieldGet(this, _OrderPageMobile_chatPnr, "f").find('.js-filter-option'), (xi, x) => {
            var _b;
            if (chat.pnrs != null && ((_b = chat.pnrs.items[xi].group) === null || _b === void 0 ? void 0 : _b.name) == '-1')
                $(x).addClass('_cancelled-avia');
        });
        __classPrivateFieldSet(this, _OrderPageMobile_chatSubmitButton, $('.js-chat-send-message', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")), "f");
        if (chat.canChangeObject)
            __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_toggleSubmitButton).call(this, __classPrivateFieldGet(this, _OrderPageMobile_chatObjectType, "f").valNumber(), null);
        __classPrivateFieldGet(this, _OrderPageMobile_chatSubmitButton, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_addChatMessage).call(this, e); }));
        __classPrivateFieldSet(this, _OrderPageMobile_chatMessageItems, $('.js-chat-message-item', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")), "f");
        $('.js-chat-agree-btn', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_setAgreeFlagMessage).call(this, e, true); }));
        $('.js-chat-disagree-btn', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_setAgreeFlagMessage).call(this, e, false); }));
        new App.Filter({ root: __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f") });
        __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectContainer, "f").hide();
        $('input:radio', __classPrivateFieldGet(this, _OrderPageMobile_chatObjectType, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onMessageObjectChange).call(this, e));
        $('input:radio', __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectType, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onMessageSubjectChange).call(this, e));
        $('.js-jelect', __classPrivateFieldGet(this, _OrderPageMobile_chatPnr, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onPnrChange).call(this, e));
        $('.js-message-reply-on', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_scrollToMessageFromReply).call(this, e); }));
        __classPrivateFieldGet(this, _OrderPageMobile_chatMessageItems, "f").on('mouseover', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_mouseOverMessage).call(this, $(e.currentTarget), true); }));
        __classPrivateFieldGet(this, _OrderPageMobile_chatMessageItems, "f").on('mouseout', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_mouseOverMessage).call(this, $(e.currentTarget), false); }));
        $('.js-chat-reply-btn', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_clickMessageReply).call(this, e); }));
        $('.js-show-more-messages', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onActionShowMoreMessage).call(this); }));
    }, _OrderPageMobile_onActionShowMoreMessage = function _OrderPageMobile_onActionShowMoreMessage() {
        return __awaiter(this, void 0, void 0, function* () {
            const pageIndex = __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").pageIndex + 1;
            // TODO: на бэке реализовать отдельным endpoint, возвращащим только сообщения для указанной страницы.
            const chatResponse = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getChat, 
            // TODO: использование pageIndex/pageSize не подходит, т.к. будут проблемы, если новое сообщение добавят вне данного инстанса чата (другой менеджер агента или ответит менеджер PW).
            { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id, pageIndex, pageSize: __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").pageSize });
            if (!chatResponse)
                return;
            __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").pageIndex = pageIndex;
            __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").groups = __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_mergeChatGroups).call(this, chatResponse.data.groups);
            __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderChatPage).call(this, __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").groups);
        });
    }, _OrderPageMobile_mergeChatGroups = function _OrderPageMobile_mergeChatGroups(newGroups) {
        const groups = [...__classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").groups];
        newGroups.forEach(newGroup => {
            const currentGroup = groups.find(group => group.date === newGroup.date);
            if (currentGroup) {
                currentGroup.messages.push(...newGroup.messages);
            }
            else {
                groups.push(newGroup);
            }
        });
        return groups;
    }, _OrderPageMobile_renderChatPage = function _OrderPageMobile_renderChatPage(groups) {
        const messagesContainer = $('.js-chat-messages', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f"));
        const renderedGroups = $('.js-chat-messages-group', messagesContainer);
        groups.forEach((group, index) => {
            const renderedGroup = renderedGroups.eq(index);
            if (renderedGroup.length === 0) {
                messagesContainer.append(__classPrivateFieldGet(this, _OrderPageMobile_chatMessagesTemplate, "f").call(this, [group]));
            }
            else if ($('.js-chat-message-item', renderedGroup).length !== group.messages.length) {
                renderedGroup.replaceWith(__classPrivateFieldGet(this, _OrderPageMobile_chatMessagesTemplate, "f").call(this, [group]));
            }
        });
        messagesContainer.show(__classPrivateFieldGet(this, _OrderPageMobile_renderSpeed, "f"));
        const showMoreMessagesContainer = $('.js-show-more-messages', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f"));
        if (__classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").remainingTotalCount > 0) {
            showMoreMessagesContainer.show();
            $('.js-show-more-messages-remaining-total-count', showMoreMessagesContainer).text(__classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").remainingTotalCount);
            $('.js-show-more-messages-remaining-page-size', showMoreMessagesContainer).text(__classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").remainingPageSize);
        }
        else {
            showMoreMessagesContainer.hide();
        }
    }, _OrderPageMobile_setAgreeFlagMessage = function _OrderPageMobile_setAgreeFlagMessage(event, flag) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            const dataKey = $(target).parents('.js-message-agree-container').attr('data-key');
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.setAgreeFlagMessage, { key: dataKey, isAgree: flag });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: false }))
                return false;
            if (!response)
                return false;
            const chatResponse = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getChat, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id });
            if (chatResponse) {
                __classPrivateFieldSet(this, _OrderPageMobile_chatModel, __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getChatModel).call(this, chatResponse.data), "f");
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderChat).call(this, __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f"));
                const offset = __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f").find(`[data-key]=${dataKey}`).offset();
                $('html, body').animate({ scrollTop: (offset != null ? offset.top : 500) }, 'slow');
            }
            return true;
        });
    }, _OrderPageMobile_onMessageObjectChange = function _OrderPageMobile_onMessageObjectChange(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        const messageObject = target.valNumber();
        if (messageObject != 1) {
            __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectType, "f").find('input:radio').each((ix, x) => {
                $(x).attr('checked', '');
                $(x).removeAttr('checked');
            });
            __classPrivateFieldGet(this, _OrderPageMobile_pnrsSelectBlock, "f").setValue('');
        }
        __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectContainer, "f").toggle(messageObject === 1);
        __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_toggleSubmitButton).call(this, messageObject, null);
    }, _OrderPageMobile_onMessageSubjectChange = function _OrderPageMobile_onMessageSubjectChange(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_toggleSubmitButton).call(this, null, target.valNumber());
    }, _OrderPageMobile_onPnrChange = function _OrderPageMobile_onPnrChange(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        const subjectKey = __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectType, "f").find(':checked').valNumber();
        const clsName = '_cancelled-avia';
        if (target.find('.jelect-option_state_active').hasClass(clsName))
            target.closest('.form-item').addClass(clsName);
        else
            target.closest('.form-item').removeClass(clsName);
        __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_toggleSubmitButton).call(this, null, subjectKey);
    }, _OrderPageMobile_toggleSubmitButton = function _OrderPageMobile_toggleSubmitButton(objectKey, subjectKey) {
        if (objectKey != null)
            __classPrivateFieldGet(this, _OrderPageMobile_chatSubmitButton, "f").toggleClass('_disabled', objectKey !== 2);
        if (subjectKey != null)
            __classPrivateFieldGet(this, _OrderPageMobile_chatSubmitButton, "f").toggleClass('_disabled', subjectKey === 0 || __classPrivateFieldGet(this, _OrderPageMobile_pnrsSelectBlock, "f").getValue() === '');
    }, _OrderPageMobile_aviaAskQuestion = function _OrderPageMobile_aviaAskQuestion(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            $('input[value=1]', __classPrivateFieldGet(this, _OrderPageMobile_chatObjectType, "f")).prop('checked', true);
            __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectType, "f").find('input:radio').each((ix, x) => {
                $(x).attr('checked', '');
                $(x).removeAttr('checked');
            });
            __classPrivateFieldGet(this, _OrderPageMobile_chatSubjectContainer, "f").show();
            __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_toggleSubmitButton).call(this, 1, null);
            const target = $(event.currentTarget);
            const pnr = '' + $(target).attr('data-val');
            __classPrivateFieldGet(this, _OrderPageMobile_pnrsSelectBlock, "f").setValue(pnr);
        });
    }, _OrderPageMobile_addChatMessage = function _OrderPageMobile_addChatMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isPw)
                return false;
            const target = $(event.currentTarget);
            const form = target.closest('form');
            const messageInput = form.find('.js-chat-input'); // this.#chatMessageInput;
            const message = messageInput.valString();
            if (message.length <= 0)
                return false;
            // TODO: перенести в настройки, получаемые от сервера.
            if (message.length > 1500) {
                $('.js-chat-validate-message', __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f")).show();
                return false;
            }
            App.popupHide();
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.addChatMessage, form.serialize(), () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataSaving).call(_a)), () => App.popupHide());
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: false }))
                return false;
            messageInput.val('');
            const chatResponse = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getChat, {
                id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                pageIndex: 0,
                pageSize: __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").pageSize,
            });
            if (!chatResponse)
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_chatModel, __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getChatModel).call(this, chatResponse.data), "f");
            __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderChat).call(this, __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f"));
            const offset = __classPrivateFieldGet(this, _OrderPageMobile_chatContainer, "f").offset();
            $('html, body').animate({ scrollTop: (offset != null ? offset.top : 500) }, 'slow');
            return true;
        });
    }, _OrderPageMobile_getChatModel = function _OrderPageMobile_getChatModel(data) {
        const model = new App.OrderChatModel(data);
        model.dogovorKey = __classPrivateFieldGet(this, _OrderPageMobile_header, "f").key;
        model.dogovorNumber = __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id;
        return model;
    }, _OrderPageMobile_clickMessageReply = function _OrderPageMobile_clickMessageReply(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            const dataKey = $(target).parent('.js-message-reply-container').attr('data-key');
            if (!dataKey) {
                return;
            }
            __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showReplyDialog).call(this, Number(dataKey || '0'));
        });
    }, _OrderPageMobile_showReplyDialog = function _OrderPageMobile_showReplyDialog(dataKey) {
        const originMessage = __classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f").messages.find(m => m.key == dataKey);
        const title = 'Ответ на сообщение';
        const chatData = new App.OrderChatModel(__classPrivateFieldGet(this, _OrderPageMobile_chatModel, "f")); // chatData это клон от _chatModel (чтобы не затереть данные в _chatModel)
        chatData.canSendMessage = true;
        chatData.canChangeObject = false;
        chatData.messageObjectItems = [];
        chatData.messageSubjectItems = [];
        chatData.reply = {
            key: dataKey,
            text: originMessage != null ? originMessage.text : '',
        };
        App.popupHide();
        const dialog = $(App.templates.Order.ChatReply(chatData));
        App.popupShow(dialog, title);
        dialog.on('click', '.js-chat-send-message', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_addChatMessage).call(this, e); }));
    }, _OrderPageMobile_scrollToMessageFromReply = function _OrderPageMobile_scrollToMessageFromReply(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            const dataKey = $(target).attr('data-replyon-key');
            __classPrivateFieldGet(this, _OrderPageMobile_chatMessageItems, "f").each((i, v) => {
                const $v = $(v);
                if ($v.attr('data-key') == dataKey) {
                    __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_scrollTo).call(_a, $v);
                    __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_animBackgroundYellow).call(_a, $v.find('.message__content'));
                    return false;
                }
            });
        });
    }, _OrderPageMobile_mouseOverMessage = function _OrderPageMobile_mouseOverMessage(target, isOver) {
        return __awaiter(this, void 0, void 0, function* () {
            const replyBlock = target.find('.js-message-reply-container');
            if (replyBlock) {
                replyBlock.toggle(isOver);
            }
        });
    }, _OrderPageMobile_scrollTo = function _OrderPageMobile_scrollTo(target, speed = 200) {
        const targetOffset = target.offset();
        if (!targetOffset) {
            return;
        }
        $('html, body').animate({ scrollTop: targetOffset.top }, speed);
    }, _OrderPageMobile_animBackground = function _OrderPageMobile_animBackground(target, backgroundColor = '#52A300', color = '#FFF', speed = 500) {
        const orcolor = target.css('background-color');
        target.css('transition', 'background-color 0.0s');
        target.animate({ backgroundColor: backgroundColor, color: color }, speed).animate({ backgroundColor: orcolor, color: '#000000' }, speed, 'swing', function () { $(this).css('background-color', ''); $(this).css('color', ''); $(this).css('transition', ''); });
    }, _OrderPageMobile_animBackgroundYellow = function _OrderPageMobile_animBackgroundYellow(target, speed = 1000) {
        __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_animBackground).call(_a, target, '#ffc107', '#000000', speed);
    }, _OrderPageMobile_copyTouristData = function _OrderPageMobile_copyTouristData(event, cssClass, isPhoneData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const target = $(event.currentTarget);
            const baseBlock = target.closest('.js-order-tourist');
            const savedData = new Array();
            baseBlock.find(`.${cssClass} input`).each((i, v) => {
                savedData.push({ name: $(v).attr('name') || '', value: $(v).val() });
            });
            if (isPhoneData) {
                const cPhone = ((_b = savedData.find(i => i.name === 'Tourist.ConfidantPhone')) === null || _b === void 0 ? void 0 : _b.value) || '';
                if (savedData.length === 0 || cPhone.length === 0)
                    return;
                baseBlock.find('.js-errorComparePhones').hide();
                if (__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_isConfidantPhoneContainedInTouristsPhones).call(_a, cPhone)) {
                    baseBlock.find('.js-errorComparePhones').show();
                    return;
                }
            }
            const promises = [];
            baseBlock.nextAll('.js-order-tourist').each((i, v) => {
                if (!$(v).find('.js-order-tourist-editor').hasClass('js-editor-open')) {
                    promises.push(__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_openTouristEditor).call(this, $(v).find('.js-order-tourist-edit')));
                }
            });
            yield Promise.all(promises);
            baseBlock.nextAll('.js-order-tourist').each((i, v) => {
                savedData.forEach(d => {
                    const finded = $(v).find(`.${cssClass} input[name="${d.name}"]`);
                    if (finded.hasClass('js-jelect-input')) {
                        finded.parent().find(`.js-jelect-option[data-val="${d.value}"]`).trigger('click');
                    }
                    else {
                        finded.val(d.value).attr('value', d.value);
                    }
                });
            });
        });
    }, _OrderPageMobile_onClickCustomerTourist = function _OrderPageMobile_onClickCustomerTourist(e) {
        if ($(e.target).is(':checked')) {
            $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
        }
        else {
            $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('input[name="ExistingTouristKey"]', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).val('');
        }
    }, _OrderPageMobile_showElectronicTripContainer = function _OrderPageMobile_showElectronicTripContainer(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const container = target.closest('.js-ep-show-hide-container');
            if (__classPrivateFieldGet(this, _OrderPageMobile_loadElectronicTripExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderPageMobile_loadElectronicTripExecuting, true, "f");
            container.find('.js-ep-show-more-link-show')
                .find('span')
                .text('Идет загрузка...');
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_loadElectronicTrip).call(this);
            container.find('.js-ep-show-more-link-show')
                .removeClass('_folded')
                .addClass('_unfolded')
                .slideUp();
            container.find('.js-ep-show-more-link-show')
                .find('span')
                .text('Открыть информацию для Электронной путевки');
            container.find('.js-ep-show-more-link-hide')
                .removeClass('_unfolded')
                .addClass('_folded')
                .slideDown();
            __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f").show();
            __classPrivateFieldSet(this, _OrderPageMobile_electronicTripForm, new App.Form({ root: __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f").find('form') }), "f");
            __classPrivateFieldSet(this, _OrderPageMobile_loadElectronicTripExecuting, false, "f");
        });
    }, _OrderPageMobile_loadElectronicTrip = function _OrderPageMobile_loadElectronicTrip() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_options, "f").showElectronicTrip)
                return;
            const tripResponse = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.loadElectronicTrip, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id });
            if (!tripResponse || !tripResponse.data)
                return null;
            if (tripResponse.data.countries.length <= 0 || tripResponse.data.documentTypes.length <= 0) {
                App.popupShow($('<h3>Данные из справочников отсутствуют</h3>'), 'Получение данных');
                return null;
            }
            const electronicTrip = tripResponse.data.electronicTrip;
            const etModel = Object.assign(Object.assign({}, electronicTrip), { orderNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id, tourSum: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").electronicTripTourSum, tourCostMax: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").electronicTripTourCostMax, countries: new App.SelectListModel({
                    name: 'CustomerCountry',
                    form: true,
                    autocomplete: true,
                    items: tripResponse.data.countries
                        .map(v => ({
                        value: v.value,
                        text: v.text,
                        selected: electronicTrip.customerCountry == v.value || electronicTrip.customerCountry == null && v.value == '',
                    })),
                    htmlAttributes: {
                        required: 'required',
                    },
                }), documentTypes: new App.SelectListModel({
                    name: 'CustomerDocumentType',
                    form: true,
                    autocomplete: false,
                    items: tripResponse.data.documentTypes
                        .map(v => ({
                        value: v.value,
                        text: v.text,
                        selected: electronicTrip.customerDocumentType == v.value || electronicTrip.customerDocumentType == null && v.value == '',
                    })),
                    htmlAttributes: {
                        required: 'required',
                    },
                }), customerTypes: new App.SelectListModel({
                    name: 'CustomerType',
                    form: true,
                    autocomplete: false,
                    items: tripResponse.data.customerTypes
                        .map(v => ({
                        value: v.value,
                        text: v.text,
                        selected: electronicTrip.customerType == v.value || electronicTrip.customerType == null && v.value == '',
                    })),
                    htmlAttributes: {
                        required: 'required',
                    },
                }), existingTourists: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").tourists, canSave: tripResponse.data.canSave });
            const templateElectronicTrip = $(App.templates.Order.ElectronicTrip(etModel));
            __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")
                .empty()
                .append(templateElectronicTrip);
            this.components.push(new App.ExistingTourists());
            new App.Filter({ root: __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f") });
            const currentDate = new Date();
            const minYear = currentDate.getFullYear() - 50;
            const contractNumberInput = $('.js-form-item-field', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f"));
            contractNumberInput.inputmask();
            const calendar = $('.js-form-date', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f"));
            calendar.inputmask('date');
            const calendarIcons = $('.js-form-date-icon', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f"));
            calendarIcons.on('click', e => $(e.currentTarget).prev('.js-form-date').trigger('focus'));
            const calendarField = $('.js-past-date .js-form-date', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f"));
            calendarField.datepicker('option', {
                yearRange: `${minYear}:${currentDate.getFullYear()}`,
                minDate: -50 * 365,
                maxDate: currentDate,
            });
            $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-surname', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-phone', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-email', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-inn', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
            $('.js-customer-type-select .js-jelect', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onCustomerTypeChange).call(this, e));
            $('.js-customer-tourist-checkbox', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).on('click', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onClickCustomerTourist).call(this, e));
            $('.js-jelect-ep-document-types', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).on('change', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onETDocumentTypeChange).call(this, e));
            $('.js-electronictrip-save', templateElectronicTrip).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_saveElectronicTrip).call(this, e); }));
            $('.js-customer-type-select .js-jelect', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).trigger('change');
            if ($('.js-customer-tourist-checkbox', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).is(':checked')) {
                $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
            }
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_setDocumentNumberMask).call(_a, __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f"));
        });
    }, _OrderPageMobile_setDocumentNumberMask = function _OrderPageMobile_setDocumentNumberMask(container) {
        const documentTypeBlock = $('.js-jelect-ep-document-types', container);
        const documentType = $('.js-jelect-input', documentTypeBlock).valString();
        const documentInput = $('.js-et-document-number .js-form-item-field', container);
        const mask = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDocumentNumberMask).call(_a, documentType);
        documentTypeBlock.val(mask.type);
        documentInput.inputmask(mask.inputmask);
    }, _OrderPageMobile_getDocumentNumberMask = function _OrderPageMobile_getDocumentNumberMask(documentType) {
        const defaultMask = { type: 'ХХ01001', inputmask: { mask: '*{6,18}', autoUnmask: true, greedy: false } };
        if (documentType == 'RU01004') {
            return {
                type: 'RU01004',
                inputmask: {
                    mask: '999999999',
                    autoUnmask: true,
                },
            };
        }
        if (documentType == 'RU01001') {
            return {
                type: 'RU01001',
                inputmask: {
                    mask: '9999999999',
                    autoUnmask: true,
                },
            };
        }
        return defaultMask;
    }, _OrderPageMobile_onETDocumentTypeChange = function _OrderPageMobile_onETDocumentTypeChange(event) {
        event.preventDefault();
        __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_setDocumentNumberMask).call(_a, __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f"));
    }, _OrderPageMobile_hideElectronicTripContainer = function _OrderPageMobile_hideElectronicTripContainer(event) {
        const target = $(event.currentTarget);
        const container = target.closest('.js-ep-show-hide-container');
        container.find('.js-ep-show-more-link-show')
            .removeClass('_unfolded')
            .addClass('_folded')
            .slideDown();
        container.find('.js-ep-show-more-link-hide')
            .removeClass('_folded')
            .addClass('_unfolded')
            .slideUp();
        __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f").hide();
        __classPrivateFieldSet(this, _OrderPageMobile_electronicTripForm, undefined, "f");
    }, _OrderPageMobile_onCustomerTypeChange = function _OrderPageMobile_onCustomerTypeChange(event) {
        event.preventDefault();
        $('.js-save-button-container', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).removeClass('_dspn');
        const target = $(event.currentTarget);
        const customerType = target.valString();
        switch (customerType) {
            case 'ФЛ':
                $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                if ($('.js-customer-tourist-checkbox', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).is(':checked')) {
                    $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                }
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                break;
            case 'ЮЛ':
                $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-inn .js-form-item-field', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).inputmask({ mask: '9999999999', autoUnmask: true });
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                break;
            case 'ИП':
                $('.js-et-customer-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-tourist', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).show();
                $('.js-et-inn .js-form-item-field', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).inputmask({ mask: '999999999999', autoUnmask: true });
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                break;
            case '':
                $('.js-et-surname', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-patron-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-phone', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-email', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-address-registration', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-citizenships', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-document-types', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-document-number', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-inn', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-et-org-name', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).hide();
                $('.js-save-button-container', __classPrivateFieldGet(this, _OrderPageMobile_electronicTripContainer, "f")).addClass('_dspn');
                break;
        }
    }, _OrderPageMobile_saveElectronicTrip = function _OrderPageMobile_saveElectronicTrip(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _OrderPageMobile_electronicTripForm, "f") || !__classPrivateFieldGet(this, _OrderPageMobile_electronicTripForm, "f").validator.form())
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_saveElectronicTripExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_saveElectronicTripExecuting, true, "f");
            const root = $(e.currentTarget).closest('form');
            const responseValidator = new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _OrderPageMobile_popup, "f")),
                validator: __classPrivateFieldGet(this, _OrderPageMobile_electronicTripForm, "f").validator,
                allowEmptyData: true,
            });
            const data = root.serialize();
            const popupGroup = __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").show({
                group: 'main',
                content: App.templates.Order.Messages.Saving({}),
                delay: 300,
                modal: true,
            });
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const xhr = $.ajax({
                        url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.saveElectronicTrip,
                        method: 'POST',
                        data,
                    });
                    const result = yield xhr;
                    if (!responseValidator.process(result))
                        return undefined;
                    return result;
                }), signal);
                if (!response)
                    return false;
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _OrderPageMobile_saveElectronicTripExecuting, false, "f");
            }
            return true;
        });
    }, _OrderPageMobile_showCancelOrderDialog = function _OrderPageMobile_showCancelOrderDialog() {
        const title = __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType === 1 /* OrderContentType.PW */
            ? 'Аннуляция заказа'
            : 'Запрос аннуляции заказа';
        const data = {
            hasMtSerices: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType === 0 /* OrderContentType.MT */
                || __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType === 2 /* OrderContentType.Mixed */,
            hasPwSerices: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType === 1 /* OrderContentType.PW */
                || __classPrivateFieldGet(this, _OrderPageMobile_options, "f").contentType === 2 /* OrderContentType.Mixed */,
        };
        const dialog = $(App.templates.Order.CancelOrderDialog(data));
        App.popupShow(dialog, title);
        dialog.on('click', '.js-cancel-order-close', () => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_closeCancelOrderDialog).call(this));
        dialog.on('click', '.js-cancel-order-reason-send', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_sendCancelOrderReason).call(this, e); }));
    }, _OrderPageMobile_sendCancelOrderReason = function _OrderPageMobile_sendCancelOrderReason(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const input = target.closest('.js-cancel-order-dialog').find('textarea');
                const reason = input.valString();
                if (reason.length <= 0) {
                    input.trigger('focus');
                    return false;
                }
                yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.cancelOrder, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id, reason });
                // TODO: возможно, проверять ответ.
                App.modalShow($(App.templates.Order.CancelOrderSuccess({})), 'Сообщение отправлено.');
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_closeCancelOrderDialog = function _OrderPageMobile_closeCancelOrderDialog() {
        App.popupHide();
        const servicesContainerOffset = __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f").offset();
        $('html, body').animate({ scrollTop: (servicesContainerOffset != null ? servicesContainerOffset.top - 100 : 0) }, 'slow');
    }, _OrderPageMobile_openTouristEditor = function _OrderPageMobile_openTouristEditor(target) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const parent = target.closest('.js-order-tourist');
            const touristKey = Number(parent.find('.js-order-tourist-info').attr('data-touristkey'));
            target.toggle();
            $('.js-loader', target.parent()).toggle();
            let existTourist = null;
            if (__classPrivateFieldGet(this, _OrderPageMobile_touristData, "f").length > 0)
                existTourist = __classPrivateFieldGet(this, _OrderPageMobile_touristData, "f").find(v => v.key === touristKey);
            if (!existTourist) {
                const touristResponse = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.loadTourist, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id, touristKey });
                App.popupHide();
                if (!App.validateResponse(touristResponse, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return;
                if (!touristResponse)
                    return;
                existTourist = touristResponse.data;
                __classPrivateFieldGet(this, _OrderPageMobile_touristData, "f").push(existTourist);
            }
            __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_initTourist).call(this, existTourist);
            parent
                .empty()
                .append(App.templates.Order.OrderTourist(existTourist));
            parent
                .css('height', '34px')
                .find('.js-order-tourist-editor')
                .addClass('js-editor-open')
                .empty()
                .append(App.templates.Order.OrderTouristEditor(existTourist));
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_jelectInit).call(_a, parent);
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_autocompleteInit).call(_a, parent);
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_calendarInit).call(_a, parent);
            this.components.push(new App.FindTourist());
            parent.find('.js-order-tourist-filter').on("findTouristOption:click" /* Events.FindTouristOptionClick */, (e, data) => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onChangeFindTourist).call(this, e, data));
            const visaType = ((_b = $('.js-order-visaType .js-jelect', parent).val()) === null || _b === void 0 ? void 0 : _b.toString()) || '';
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_updateVisibleFields).call(_a, visaType);
            $('.js-form-item-field', parent).inputmask();
            // TODO Timoshkina: перейти на Filter
            const visaTypesBlock = $('.js-order-visaType', parent);
            $('.js-jelect', visaTypesBlock).on('change', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onChangeChinaVisaType).call(this, e));
            const countryBlock = $('.js-order-load-chinaCities', parent);
            $('.js-jelect', countryBlock).on('change', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onChangeChinaCountry).call(this, e); }));
            const autocompleteBlock = $('.js-form-autocomplete-block[data-name="ChinaHotelName"]', parent);
            autocompleteBlock.on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, () => __awaiter(this, void 0, void 0, function* () {
                const address = $('.js-point-type', parent).val() || '';
                $('input[name="Tourist.ChinaHotelAddress"]', parent).val(address);
            }));
            $('.js-jelect', countryBlock).on('change', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onChangeChinaCountry).call(this, e); }));
            parent
                .find('.js-order-tourist-info')
                .hide();
            parent
                .css('height', '70px')
                .find('.js-order-tourist-editor')
                .show('slow');
            $('.js-form-item-field', this.root).inputmask();
            $('.js-msc-birthCountry', this.root).inputmask({
                regex: '^[a-zA-Z]+$',
                placeholder: '',
            });
        });
    }, _OrderPageMobile_onChangeFindTourist = function _OrderPageMobile_onChangeFindTourist(event, data) {
        const target = $(event.currentTarget);
        // gender, на странице заказа пол указан через запятую: '0,0' и '1,1'
        const value = data.gender;
        if (value) {
            const selectBlock = target.find('.js-form-select-block[data-type="gender"]');
            if (selectBlock.length > 0) {
                const sblock = new App.FilterSelectBlock({ root: $(selectBlock) });
                const newval = value + ',' + value;
                sblock.setValue(newval);
            }
        }
        // паспорт
        const isRusPassport = data.isRussianPassport == '1';
        const nameParts = ['docSeries', 'docNumber', 'documentIssueDate', 'documentExpirationDate'];
        $.each(nameParts, (__, item2) => {
            const inputNameDop = isRusPassport ? 'Ru' : 'Zg';
            const input = target.find(`input[data-type='${item2}${inputNameDop}']`);
            if (input.length > 0) {
                input.val('');
                input.val(data[item2]).trigger('change');
            }
        });
    }, _OrderPageMobile_onChangeChinaVisaType = function _OrderPageMobile_onChangeChinaVisaType(event) {
        const val = $(event.currentTarget).valString();
        __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_updateVisibleFields).call(_a, val);
    }, _OrderPageMobile_updateVisibleFields = function _OrderPageMobile_updateVisibleFields(value) {
        const parent = $('.js-order-visaType').closest('.js-tourist-china-block');
        if (value == '240') {
            $('[data-visaType]', parent).show();
            $('input', $('[data-visaType="240"]', parent)).not('[name$=".Search"]').not('[data-not-required]').each((i, v) => v.setAttribute('required', 'required'));
        }
        else if (value == '24') {
            $('[data-visaType="24"]', parent).show();
            $('input', $('[data-visaType="24"]', parent)).not('[name$=".Search"]').each((i, v) => v.setAttribute('required', 'required'));
            $('[data-visaType="240"]', parent).hide();
            $('[data-visaType="240"] input').val('');
            $('input', $('[data-visaType="240"]', parent)).each((i, v) => v.removeAttribute('required'));
        }
        else {
            $('[data-visaType]', parent).hide();
            $('[data-visaType] input').val('');
            $('input', $('[data-visaType]', parent)).each((i, v) => v.removeAttribute('required'));
            $('[data-visaType] .js-scroller .js-filter-option[data-val="0"]').trigger('click');
        }
    }, _OrderPageMobile_onChangeChinaCountry = function _OrderPageMobile_onChangeChinaCountry(event_1) {
        return __awaiter(this, arguments, void 0, function* (event, signal = App.noneSignal) {
            const target = $(event.currentTarget);
            const parent = target.closest('.js-tourist-china-block');
            const val = target.valNumber();
            if (val == 0) {
                const defOpt = [{ text: 'Выберите сначала страну', selected: true }];
                this.updateCityOptions(defOpt, parent);
                return true;
            }
            const textVal = target.find('.jelect-option_state_active .js-jelect-option-value').text();
            $('#js-chinaReturnFlightArrCountry', parent).val(textVal);
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const editHhr = $.ajax({
                        url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getCities,
                        method: 'POST',
                        data: `id=${val}`,
                    });
                    const result = yield editHhr;
                    if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(result))
                        return null;
                    return result;
                }), signal);
                if (!response)
                    return false;
                this.updateCityOptions(response.data.items, parent, true);
                return true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex)) {
                    throw ex;
                }
            }
            finally {
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide();
            }
            return true;
        });
    }, _OrderPageMobile_showTouristEditor = function _OrderPageMobile_showTouristEditor(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isPw)
                return;
            const target = $(event.currentTarget);
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_openTouristEditor).call(this, target);
        });
    }, _OrderPageMobile_transliterate = function _OrderPageMobile_transliterate(event) {
        if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isPw)
            return false;
        const target = $(event.currentTarget);
        target.val(App.transliterateName(target.valString()));
        return true;
    }, _OrderPageMobile_cancelTouristEditor = function _OrderPageMobile_cancelTouristEditor(event) {
        const target = $(event.currentTarget);
        const parent = target.closest('.js-order-tourist');
        parent
            .css('height', '34px')
            .find('.js-order-tourist-editor')
            .hide('slow')
            .removeClass('js-editor-open');
        parent
            .find('.js-order-tourist-info')
            .show('slow');
    }, _OrderPageMobile_isConfidantPhoneContainedInTouristsPhones = function _OrderPageMobile_isConfidantPhoneContainedInTouristsPhones(phone) {
        const listTouristPhones = $('.js-order-tourist-editor').find('.js-tourist-phone').get().map(item => $(item).valString().replace('+', '')).filter(x => x);
        return listTouristPhones.includes(phone.replace('+', ''));
    }, _OrderPageMobile_editTourist = function _OrderPageMobile_editTourist(event_1) {
        return __awaiter(this, arguments, void 0, function* (event, signal = App.noneSignal) {
            var _b;
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isPw)
                return false;
            const target = $(event.currentTarget);
            const form = target.closest('form');
            const newform = new App.Form({ root: form, disableStepValidation: true });
            __classPrivateFieldSet(this, _OrderPageMobile_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _OrderPageMobile_popup, "f")),
                validator: newform.validator,
                allowEmptyData: true,
            }), "f");
            if (!newform.validator.form())
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_options, "f").isCruiseOrder) {
                const curTourist = target.closest('.js-order-tourist-editor');
                const confidantPhone = (_b = curTourist.find('.js-confidantPhone').valString()) !== null && _b !== void 0 ? _b : '';
                curTourist.find('.js-errorComparePhones').hide();
                if (__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_isConfidantPhoneContainedInTouristsPhones).call(_a, confidantPhone)) {
                    curTourist.find('.js-errorComparePhones').show();
                    return false;
                }
            }
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataSaving).call(_a));
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const editHhr = $.ajax({
                        url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.editTourist,
                        method: 'POST',
                        data: `${form.serialize()}&DogovorNumber=${__classPrivateFieldGet(this, _OrderPageMobile_options, "f").id}`,
                    });
                    const result = yield editHhr;
                    if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(result))
                        return null;
                    return result;
                }), signal);
                if (!response)
                    return false;
                const touristKey = form.find('[name$="Key"]').valNumber();
                const touristResponse = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.loadTourist, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id, touristKey });
                App.popupHide();
                if (!App.validateResponse(touristResponse, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!touristResponse)
                    return false;
                const existTouristIndex = __classPrivateFieldGet(this, _OrderPageMobile_touristData, "f").findIndex(v => v.key === touristKey);
                if (existTouristIndex === -1)
                    __classPrivateFieldGet(this, _OrderPageMobile_touristData, "f").push(touristResponse.data);
                else
                    __classPrivateFieldGet(this, _OrderPageMobile_touristData, "f")[existTouristIndex] = touristResponse.data;
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_initTourist).call(this, touristResponse.data);
                const parent = form.closest('.js-order-tourist');
                parent
                    .empty()
                    .css('height', '34px')
                    .append(App.templates.Order.OrderTourist(touristResponse.data));
                __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_jelectInit).call(_a, parent);
                __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_calendarInit).call(_a, parent);
                return true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex)) {
                    throw ex;
                }
            }
            finally {
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide();
            }
            return true;
        });
    }, _OrderPageMobile_addPwService = function _OrderPageMobile_addPwService(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            const self = $(event.currentTarget);
            if (self.attr('data-no-booking') != null) {
                App.popupShow($('<div class="pr-subtitle">Добронь услуги возможна только к заказу, номинированному в EUR или USD. Просим обратиться к ведущему менеджеру</div>'), 'Добавление услуги');
                return false;
            }
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.addPwService, {
                id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                serviceType: self.attr('data-service-type'),
                forCruise: self.attr('data-for-cruise'),
            }, () => { App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataLoading).call(_a)); });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                return false;
            if (!response || !response.data)
                return null;
            if (!response.data.link) {
                App.popupShow($('<div class="pr-subtitle">Произошла ошибка. Попробуйте еще раз</div>'), 'Добавление услуги');
                return null;
            }
            window.location.href = `${response.data.link}`;
            return true;
        });
    }, _OrderPageMobile_showAddAviaCruiseDialog = function _OrderPageMobile_showAddAviaCruiseDialog() {
        if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
            return false;
        App.popupShow($(App.templates.Order.AddAviaCruiseDialog({})), 'Добронирование авиаперелета');
        return true;
    }, _OrderPageMobile_agreeToAddAviaCruise = function _OrderPageMobile_agreeToAddAviaCruise(event) {
        const self = $(event.currentTarget);
        if (self.is(':checked'))
            $('.js-order-add-service', this.root).removeAttr('disabled');
        else
            $('.js-order-add-service', this.root).attr('disabled', 'disabled');
    }, _OrderPageMobile_closeAddAviaCruiseDialog = function _OrderPageMobile_closeAddAviaCruiseDialog() {
        App.popupHide();
    }, _OrderPageMobile_addCruiseService = function _OrderPageMobile_addCruiseService(event) {
        if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
            return false;
        const self = $(event.currentTarget);
        const action = self.attr('data-action');
        if (action)
            window.location.href = action;
        return true;
    }, _OrderPageMobile_showQualityControl = function _OrderPageMobile_showQualityControl(event) {
        const self = $(event.currentTarget);
        const action = self.attr('data-action');
        if (action)
            window.location.href = action;
        return true;
    }, _OrderPageMobile_showCruiseActivityRefusalDialog = function _OrderPageMobile_showCruiseActivityRefusalDialog() {
        if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
            return false;
        return true;
    }, _OrderPageMobile_showAddVisaDialog = function _OrderPageMobile_showAddVisaDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getVisaTourists, { 'id': __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id }, () => { App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataLoading).call(_a)); });
            if (!response) {
                App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPageMobile_defaultError));
                return null;
            }
            if (!response.data) {
                if (!response.status) {
                    App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPageMobile_defaultError));
                }
                else if (!response.status.success) {
                    if (!response.status.messages || response.status.messages.length <= 0)
                        App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPageMobile_defaultError));
                    else
                        App.popupShow($(`<h3>${response.status.messages[0].text}</h3>`));
                }
                return null;
            }
            if (response.data.noVisaAvailable) {
                App.popupShow($(`<h3>${response.data.noVisaAvialableMessage}</h3>`));
                return null;
            }
            __classPrivateFieldSet(this, _OrderPageMobile_visas, response.data.visas, "f");
            const model = {
                dogovorNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                tourists: response.data.tourists,
                visaCities: new App.SelectListModel({
                    name: '',
                    form: true,
                    autocomplete: false,
                    items: __classPrivateFieldGet(this, _OrderPageMobile_visas, "f")
                        .map(v => ({
                        value: v.city,
                        text: v.city,
                        selected: v.selected,
                    })),
                }),
                needPenaltyAgreement: __classPrivateFieldGet(this, _OrderPageMobile_hasAliveJapanHotel, "f"),
            };
            const form = $(App.templates.Order.AddVisas(model));
            App.popupShow(form, 'Добавление визы');
            $('.js-visa-city', form)
                .on('change', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_loadVisaServices).call(this, e))
                .trigger('change');
            const agreeButton = $('.js-visas-save', form);
            agreeButton.on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_saveVisas).call(this, e); }));
            $('.js-visas-cancel', form).on('click', () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_cancelVisas).call(_a));
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_jelectInit).call(_a, $('.js-visa-city').parent());
            if (model.needPenaltyAgreement)
                __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_setDependencies).call(this, form, agreeButton);
            return true;
        });
    }, _OrderPageMobile_setDependencies = function _OrderPageMobile_setDependencies(mainForm, submitBtn) {
        const deps = mainForm.find(`[data-name="${submitBtn.attr('data-depends').split(',').join('"], [data-name="')}"]`);
        deps
            .off()
            .on('change', () => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_setSubmitAvailability).call(this, deps, submitBtn))
            .trigger('change');
    }, _OrderPageMobile_setSubmitAvailability = function _OrderPageMobile_setSubmitAvailability(dependencies, submitBtn) {
        if (dependencies.filter(':checked').length !== dependencies.length)
            submitBtn.attr('disabled', 'disabled');
        else
            submitBtn.removeAttr('disabled');
    }, _OrderPageMobile_loadVisaServices = function _OrderPageMobile_loadVisaServices(event) {
        const target = $(event.currentTarget);
        const city = target.find('input').valString();
        const cityVisas = __classPrivateFieldGet(this, _OrderPageMobile_visas, "f").filter(v => v.city === city)[0];
        if (!cityVisas)
            return;
        const row = target.closest('tr');
        const touristPrefix = row.find('.js-tourist-visa-prefix').valString();
        if (!touristPrefix)
            return;
        const model = new App.SelectListModel({
            name: `${touristPrefix}ServiceKey`,
            form: true,
            autocomplete: false,
            items: cityVisas.services
                .map(v => ({
                value: v.value,
                text: v.text,
                selected: v.selected,
            })),
        });
        const services = $(App.templates.FilterSelect(model));
        const rowVisaServices = $('.js-visa-services', row);
        rowVisaServices
            .empty()
            .append(services);
        __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_jelectInit).call(_a, rowVisaServices.parent());
        rowVisaServices.on('change', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_changeVisaServices).call(_a, e));
    }, _OrderPageMobile_changeVisaServices = function _OrderPageMobile_changeVisaServices(event) {
        $(event.currentTarget)
            .closest('form')
            .find('.js-visa-validation-message')
            .empty()
            .hide();
    }, _OrderPageMobile_jelectInit = function _OrderPageMobile_jelectInit(container) {
        const components = new Array();
        container.find('.js-filter-select-block, .js-form-select-block').each((i, v) => {
            components.push(new App.FilterSelectBlock({ root: $(v) }));
        });
    }, _OrderPageMobile_autocompleteInit = function _OrderPageMobile_autocompleteInit(container) {
        const components = new Array();
        container.find('.js-filter-autocomplete-block, .js-form-autocomplete-block').each((i, v) => {
            components.push(new App.FilterAutocompleteBlock({ root: $(v) }));
        });
    }, _OrderPageMobile_calendarInit = function _OrderPageMobile_calendarInit(container) {
        const components = new Array();
        container.find('.js-filter-date-block, .js-form-date-block').each((i, v) => {
            if ($(v).hasClass('js-past-date'))
                components.push(new App.FilterDateBlock({ root: $(v), changeMonthYear: true, maxDate: new Date() }));
            else if ($(v).hasClass('js-future-date'))
                components.push(new App.FilterDateBlock({ root: $(v), changeMonthYear: true, minDate: new Date() }));
            else
                components.push(new App.FilterDateBlock({ root: $(v), changeMonthYear: true }));
        });
    }, _OrderPageMobile_saveVisas = function _OrderPageMobile_saveVisas(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const form = target.closest('form');
                const validation = form.find('.js-visa-validation-message');
                validation.empty();
                // валидация
                const inputs = form.find('.js-jelect-input')
                    .filter('[data-select$="ServiceKey"]')
                    .filter('[value!="0"]');
                if (inputs.length <= 0) {
                    validation.text('Выберите визу хотя бы для одного туриста.');
                    validation.show();
                    return false;
                }
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.saveVisas, form.serialize(), () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataSaving).call(_a)));
                App.popupHide();
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!response) {
                    App.popupShow($('Произошла ошибка. Попробуйте еще раз через некоторое время.'), 'Ошибка');
                    return false;
                }
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                const servicesContainerOffset = __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f").offset();
                $('html, body').animate({ scrollTop: (servicesContainerOffset != null ? servicesContainerOffset.top - 100 : 0) }, 'slow');
                App.popupShow($('<div>Услуга <b>Виза</b> успешно добавлена</div>'));
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_cancelVisas = function _OrderPageMobile_cancelVisas() {
        App.popupHide();
    }, _OrderPageMobile_showAddInsuranceDialog = function _OrderPageMobile_showAddInsuranceDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataLoading).call(_a));
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getInsuranceTourists, { body: new URLSearchParams({ id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id }) });
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(response))
                    return null;
                if (response.data.items.length <= 0) {
                    App.popupShow($('<h3>Отсутствуют туристы без страховки</h3>'), 'Добавление страховки');
                    return null;
                }
                const emptyItem = { value: '', text: 'Выберите страховку...', selected: true };
                const model = {
                    dogovorNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                    tourists: response.data.items
                        .map((v, i) => ({
                        key: v.key,
                        name: v.name,
                        managerMessage: v.managerMessage,
                        showMedicalServices: v.medicalServices.length > 0,
                        medicalServices: new App.SelectListModel({
                            name: `Form.Tourists[${i}].MedicalServiceKey`,
                            form: true,
                            autocomplete: false,
                            items: Enumerable.from(v.medicalServices)
                                .select(x => ({
                                value: x.key,
                                text: x.name,
                                selected: false,
                            }))
                                .insert(0, [emptyItem])
                                .toArray(),
                        }),
                        showDeclineServices: v.declineServices.length > 0,
                        declineServices: new App.SelectListModel({
                            name: `Form.Tourists[${i}].DeclineServiceKey`,
                            form: true,
                            autocomplete: false,
                            items: Enumerable.from(v.declineServices)
                                .select(x => ({
                                value: x.key,
                                text: x.name,
                                selected: false,
                            }))
                                .insert(0, [emptyItem])
                                .toArray(),
                        }),
                        declineDeniedMessage: v.declineDeniedMessage,
                        showLiabilityServices: v.liabilityServices.length > 0,
                        liabilityServices: new App.SelectListModel({
                            name: `Form.Tourists[${i}].LiabilityServiceKey`,
                            form: true,
                            autocomplete: false,
                            items: Enumerable.from(v.liabilityServices)
                                .select(x => ({
                                value: x.key,
                                text: x.name,
                                selected: false,
                            }))
                                .insert(0, [emptyItem])
                                .toArray(),
                        }),
                    })),
                };
                __classPrivateFieldSet(this, _OrderPageMobile_insuranceServices, response.data.items
                    .flatMap(v => [...v.medicalServices, ...v.declineServices, ...v.liabilityServices]), "f");
                const form = $(App.templates.Order.AddInsurance(model));
                App.popupShow(form, 'Добавление страховки');
                __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_jelectInit).call(_a, $('.js-popup-container'));
                $('.js-insurance-save', form).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_saveInsurances).call(this, e); }));
                $('.js-insurance-cancel', form).on('click', () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_cancelInsurances).call(_a));
                return true;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
                return null;
            }
        });
    }, _OrderPageMobile_saveInsurances = function _OrderPageMobile_saveInsurances(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const form = target.closest('form');
                const validation = form.find('.js-insurance-validation-message');
                validation.empty();
                // валидация
                const inputs = form.find('.js-jelect-input')
                    .filter('[data-select$="ServiceKey"]')
                    .filter('[value!="0"]');
                if (inputs.length === 0) {
                    validation.text('Выберите страховку хотя бы для одного туриста.');
                    validation.show();
                    return false;
                }
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.saveInsurances, form.serialize(), () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataSaving).call(_a)));
                App.popupHide();
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!response) {
                    App.popupShow($('Произошла ошибка. Попробуйте еще раз через некоторое время.'), 'Ошибка');
                    return false;
                }
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                const servicesContainerOffset = __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f").offset();
                $('html, body').animate({ scrollTop: (servicesContainerOffset != null ? servicesContainerOffset.top - 100 : 0) }, 'slow');
                App.popupShow($('<div>Услуга <b>Страховка</b> успешно добавлена</div>'));
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_cancelInsurances = function _OrderPageMobile_cancelInsurances() {
        App.popupHide();
    }, _OrderPageMobile_addPacFitService = function _OrderPageMobile_addPacFitService() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.addPacFitService, { 'id': __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id });
            if (!response || !response.redirect)
                return null;
            window.location.href = response.redirect;
            return true;
        });
    }, _OrderPageMobile_getDocumentsDialog = function _OrderPageMobile_getDocumentsDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this) || __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isPw)
                return false;
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.packet,
                method: 'GET',
            });
            // TODO const popupGroup = this.#popup.show({ group: 'main', content: templates.Tour.Messages.Valuating({}), delay: 1000, modal: true });
            try {
                const response = yield request;
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return false;
                if (!response) {
                    App.popupShow($('Произошла ошибка. Попробуйте еще раз через некоторое время.'), 'Ошибка');
                    return false;
                }
                let url = response.data.link;
                if (__classPrivateFieldGet(this, _OrderPageMobile_header, "f").waitingForMK)
                    url = App.removeEndChar(response.data.link, '/') + '?waitingForMK=true';
                App.popupShow($(App.templates.Order.Messages.GetDocumentsDialog({
                    message: response.data.message,
                    url: url,
                    domain: window.location.hostname.substring(window.location.hostname.lastIndexOf('.') + 1),
                    cityCode: response.data.cityCode,
                    waitingForMK: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").waitingForMK,
                })));
                $(document)
                    .on('click', '#acceptGetDocuments', () => {
                    App.popupHide();
                })
                    .on('click', '#declineGetDocuments', () => App.popupHide());
                return true;
            }
            catch (ex) {
                window.console.error(ex);
                return false;
            }
        });
    }, _OrderPageMobile_openBookingDetails = function _OrderPageMobile_openBookingDetails(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            const target = $(event.currentTarget);
            const serviceBlock = target.closest('.js-order-service');
            const hiddenInfoBlock = serviceBlock.find('.js-order-service-hidden');
            const visibleInfoBlock = serviceBlock.find('.js-order-service-visible');
            target.toggleClass('_unfolded');
            serviceBlock.toggleClass('_opened');
            if (serviceBlock.hasClass('_opened')) {
                if (serviceBlock.attr('data-loaded') !== 'true') {
                    const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getBooking, { 'number': serviceBlock.attr('data-booking-number') }, () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onSearchBefore).call(_a, target), () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onSearchAlways).call(_a, target));
                    if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                        return false;
                    if (!response)
                        return false;
                    if (!response.data) {
                        __classPrivateFieldGet(this, _OrderPageMobile_messages, "f").show({ type: 2 /* MessageType.Error */, text: 'Бронь не найдена.' }, { canHide: true });
                        return false;
                    }
                    __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_renderBookingDetails).call(this, hiddenInfoBlock, response.data, serviceBlock);
                    serviceBlock.data('loaded', 'true');
                }
                else {
                    hiddenInfoBlock.show(__classPrivateFieldGet(this, _OrderPageMobile_renderSpeed, "f"));
                    visibleInfoBlock.show();
                }
            }
            else {
                hiddenInfoBlock.hide(__classPrivateFieldGet(this, _OrderPageMobile_renderSpeed, "f"));
                visibleInfoBlock.hide();
            }
            return true;
        });
    }, _OrderPageMobile_openServiceTourists = function _OrderPageMobile_openServiceTourists(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const serviceTouristBlock = target.closest('.js-order-service-tourists');
            const serviceTouristMoreBlock = serviceTouristBlock.find('.js-order-service-tourist-more');
            const hiddenTourists = serviceTouristBlock.find('.js-order-service-tourist-more-item');
            serviceTouristMoreBlock.hide();
            hiddenTourists.show(__classPrivateFieldGet(this, _OrderPageMobile_renderSpeed, "f"));
            return true;
        });
    }, _OrderPageMobile_onStopsClick = function _OrderPageMobile_onStopsClick(event) {
        const target = $(event.currentTarget);
        const info = target.attr('data-info');
        if (!info)
            return;
        const infos = info.split('|');
        const form = $(App.templates.Avia.Stop({}));
        $.each(infos, (index, item) => $('.js-info', form).append($(`<div>${item}</div>`)));
        App.popupShow(form, 'Техническая посадка');
    }, _OrderPageMobile_renderBookingDetails = function _OrderPageMobile_renderBookingDetails(container, booking, serviceBlock) {
        const template = serviceBlock.attr('data-template');
        if (!template)
            return;
        const bruttoBlock = $('.js-service-price', serviceBlock).filter('[data-price-type="brutto"]');
        booking.showGrossPrice = bruttoBlock != null && bruttoBlock.length > 0;
        const serviceTemplate = App.findTemplate(template);
        container
            .empty()
            .append(serviceTemplate(booking))
            .show(__classPrivateFieldGet(this, _OrderPageMobile_renderSpeed, "f"));
        $('.js-brand-name', container).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showBrandRules).call(this, e); }));
        $('.js-fare-conditions', container).on('click', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showFareConditions).call(this, e));
        $('.js-fare-penalties', container).on('click', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showFarePenalties).call(this, e));
        $('.js-show-on-map', container).on('click', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onShowMapClick).call(this, e));
        // TODO: для авиа внести эту часть внутрь js-order-service-hidden
        /* if (response.data.item.notes) {
            visibleInfoBlock
                .append(templates.Order.ServiceNotes(response.data.item.notes))
                .show();
        }*/
    }, _OrderPageMobile_showBusTourists = function _OrderPageMobile_showBusTourists() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getTouristBusSeats, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id }, () => { App.modalShow($(App.templates.Order.Messages.Loading({}))); }, () => { });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            const dialog = $(App.templates.Order.BusTouristList(response.data.tourists));
            $('.js-show-seats', dialog).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showBusSeats).call(this, e); }));
            App.popupShow(dialog, 'Добавление услуги');
            return undefined;
        });
    }, _OrderPageMobile_showBusSeats = function _OrderPageMobile_showBusSeats(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const column = target.closest('td');
            const row = target.closest('tr');
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getBusSeats, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id }, () => {
                $('.js-seats-container').remove();
                $('.js-bus-tourist-list .js-show-seats').show();
                target.hide();
                column.append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
            }, () => { $('.js-loading', column).remove(); });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            const busSeats = $(App.templates.Order.BusSeats(response.data.items));
            if (response.data.items)
                $('.js-take-bus-seat', busSeats).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_takeBusSeat).call(this, e); }));
            row.after(busSeats);
            return undefined;
        });
    }, _OrderPageMobile_takeBusSeat = function _OrderPageMobile_takeBusSeat(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.takeBusSeat, {
                    id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                    touristKey: target.closest('tbody').attr('data-tourist-key'),
                    priceCode: target.attr('data-price-code'),
                    subcode1: target.attr('data-subcode1'),
                    subcode2: target.attr('data-subcode2'),
                    partnerKey: target.attr('data-partner'),
                    packetKey: target.attr('data-packet'),
                }, () => { App.modalShow($(App.templates.Order.Messages.Loading({}))); }, () => { });
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true })) {
                    App.popupHide();
                    return false;
                }
                if (!response)
                    return false;
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showBusTourists).call(this);
                return undefined;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_showFareConditions = function _OrderPageMobile_showFareConditions(event) {
        __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showFareInfo).call(this, $(event.currentTarget), 'Авиаперелет. Правила и условия');
    }, _OrderPageMobile_showFarePenalties = function _OrderPageMobile_showFarePenalties(event) {
        __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showFareInfo).call(this, $(event.currentTarget), 'Авиаперелет. Информация по штрафам');
    }, _OrderPageMobile_showFareInfo = function _OrderPageMobile_showFareInfo(selector, title) {
        const value = selector.attr('data-value');
        if (!value)
            return;
        const content = $('<div class="_scrolling _pre font-11 lh-14"></div>').html(value);
        const toggleButton = $('<button type="button" class="form-btn form-btn_default mt-3">Показать перевод</button>');
        let translatedValue;
        let translationPromise;
        let showTranslation = false;
        toggleButton.on('click', () => {
            showTranslation = !showTranslation;
            toggleButton.text(showTranslation ? 'Показать оригинал' : 'Показать перевод');
            if (!showTranslation) {
                content.html(value);
                return;
            }
            if (translatedValue != null) {
                content.html(translatedValue);
                return;
            }
            content.empty().append(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataLoading).call(_a));
            translationPromise !== null && translationPromise !== void 0 ? translationPromise : (translationPromise = __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getFareTranslation).call(this, value));
            void translationPromise.then(translation => {
                translatedValue = translation;
                if (showTranslation)
                    content.html(translatedValue);
            });
        });
        // TODO: после того как отображение правил перевозчика будет единым для корзины и для заказа, вернуть обратно
        // App.popupShow($('<div></div>').append(content, toggleButton), title);
        App.popupShow($('<div></div>').append(content), title);
    }, _OrderPageMobile_getFareTranslation = function _OrderPageMobile_getFareTranslation(value) {
        const existing = __classPrivateFieldGet(this, _OrderPageMobile_fareTranslations, "f").get(value);
        if (existing)
            return existing;
        const promise = __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_loadFareTranslation).call(this, value);
        __classPrivateFieldGet(this, _OrderPageMobile_fareTranslations, "f").set(value, promise);
        return promise;
    }, _OrderPageMobile_loadFareTranslation = function _OrderPageMobile_loadFareTranslation(value) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getTranslation, { body: new URLSearchParams({ text: value }) });
                return (_b = response.data) !== null && _b !== void 0 ? _b : value;
            }
            catch (e) {
                window.console.error(e);
                __classPrivateFieldGet(this, _OrderPageMobile_fareTranslations, "f").delete(value);
                return value;
            }
        });
    }, _OrderPageMobile_showBrandRules = function _OrderPageMobile_showBrandRules(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action');
            const brandName = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-brand-name');
            const carrierName = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-carrier-name');
            const carrierLogo = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-carrier-logo');
            if (!action || !brandName || !carrierName || !carrierLogo)
                return false;
            let data;
            const segmentKey = target.attr('data-segment-key');
            if (segmentKey) {
                data = { 'segmentKey': segmentKey };
            }
            else {
                data = {
                    'carrier': target.attr('data-carrier-code'),
                    'programSystemCode': target.attr('data-program-system-code'),
                    'programCode': target.attr('data-program-code'),
                    'brand': target.attr('data-brand-id'),
                };
            }
            const brandBlock = $('<div></div>');
            const response = yield doAction(action, data, () => {
                brandBlock.text('Пожалуйста, подождите.');
                App.popupShow(brandBlock, `Тариф ${brandName}<br/><small>а/к ${carrierName}<img style="height: 25px" src="${carrierLogo}" /></small>`);
            }, () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_hidePreloader).call(_a, target));
            if (!response)
                return false;
            brandBlock.empty();
            if (!response.data) {
                brandBlock.append($('<h3>Описание тарифа не найдено</h3>'));
                return false;
            }
            if (!response.status || !response.status.success) {
                if (response.status.messages)
                    brandBlock.append($(`<h3>${response.status.messages[0].text}</h3>`));
                return false;
            }
            __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_renderBrandFare).call(_a, brandBlock, response.data);
            return true;
        });
    }, _OrderPageMobile_renderBrandFare = function _OrderPageMobile_renderBrandFare(container, data) {
        container.append(App.templates.BrandFareRules({
            rules: data.rules,
            url: data.url,
            isUrlContent: data.isUrlContent,
            production: data.production,
        }));
    }, _OrderPageMobile_onShowMapClick = function _OrderPageMobile_onShowMapClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _OrderPageMobile_popupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _OrderPageMobile_popupInfo, new App.PopupOld({
            content: $(`<div class="${__classPrivateFieldGet(this, _OrderPageMobile_mapWrapClass, "f")}"><div style="width: 700px; height: 600px !important; min-height: 600px;" class="js-auto-point-map"></div></div>`),
            onShowDelegate: () => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_showMap).call(this, $(event.currentTarget)),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _OrderPageMobile_showMap = function _OrderPageMobile_showMap(target) {
        const coordinates = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-coordinates');
        if (!coordinates)
            return;
        const coords = Enumerable.from(coordinates.split(':')).select(v => parseFloat(v)).toArray();
        if (coords.length !== 2)
            return;
        const point = {
            coordinate: {
                latitude: coords[0],
                longitude: coords[1],
            },
            title: $(target).attr('data-point-type'),
            id: 0,
        };
        App.SimpleGoogleMap.show([point], $('.js-popup').find(`.${__classPrivateFieldGet(this, _OrderPageMobile_mapWrapClass, "f")}`));
    }, _OrderPageMobile_onActionConfirm = function _OrderPageMobile_onActionConfirm(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const customPrompt = target.attr('data-custom_prompt');
                const prerequirement = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-prerequirement');
                if (!prerequirement)
                    return false;
                const preRequirementResponse = yield doAction(prerequirement, {});
                if (!preRequirementResponse) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return false;
                }
                if (preRequirementResponse.status.success
                    && preRequirementResponse.data.preRequirementMessage
                    && preRequirementResponse.data.preRequirementMessage.length > 0) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, preRequirementResponse.data.preRequirementMessage));
                    return false;
                }
                const dialog = new App.ActionDialog(target, App.ActionType.confirmation, customPrompt);
                dialog.show();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onActionConfirmCruise = function _OrderPageMobile_onActionConfirmCruise(event) {
        if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
            return false;
        const target = $(event.currentTarget);
        const dialog = $(App.templates.Order.Messages.ConfirmCruiseDialog({
            serviceKey: target.attr('data-service-key'),
            referenceNumber: target.attr('data-reference-number'),
            paymentMessage: target.attr('data-needPaymentMessage'),
            guaranteeLetterMessage: target.attr('data-needGuaranteeLetterMessage'),
        }));
        dialog.on('click', '.js-confirm-cruise-dialog-continue', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onConfirmCruiseDialogContinueAsync).call(this, e); }));
        dialog.on('click', '.js-confirm-cruise-dialog-close', () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onConfirmCruiseDialogClose).call(_a));
        App.popupShow(dialog, 'Подтверждение брони');
        return true;
    }, _OrderPageMobile_onConfirmCruiseDialogClose = function _OrderPageMobile_onConfirmCruiseDialogClose() {
        App.popupHide();
    }, _OrderPageMobile_onConfirmCruiseDialogContinueAsync = function _OrderPageMobile_onConfirmCruiseDialogContinueAsync(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.confirmCruise, {
                    dogovorNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                    referenceNumber: target.attr('data-reference-number'),
                }, () => App.modalShow($('<div>Производится подтверждение брони</div>')
                    .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))))));
                if (!response)
                    return false;
                if (response.status.success && response.data && response.data.cruiseDogovorCode) {
                    const dialog = $(App.templates.Order.Messages.RefuseCruiseConfirm({
                        dogovorCode: response.data.cruiseDogovorCode,
                    }));
                    App.popupShow(dialog, 'Ошибка подтверждения круиза');
                    return undefined;
                }
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                if (response.status.messages)
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                return undefined;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onActionCancel = function _OrderPageMobile_onActionCancel(event) {
        if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
            return false;
        const target = $(event.currentTarget);
        const japanHotelCancellation = Boolean(target.attr('data-japan-hotel-cancellation'));
        const dialog = new App.ActionDialog(target, App.ActionType.cancellation, undefined, !japanHotelCancellation
            ? undefined
            : 'При аннуляции отеля после получения туристами виз удержанию по заказу дополнительно подлежит сумма в размере рублевого эквивалента 300 евро. ' +
                'Также компания PAC GROUP сообщает, что по условиям аккредитации обязана информировать консульство об аннуляции услуг размещения, ' +
                'в целях аннуляции въездной визы туристов.Просим проинформировать туристов о возможном возникновении сложностей при пересечении границ.');
        dialog.show();
        return true;
    }, _OrderPageMobile_onActionRefreshPrice = function _OrderPageMobile_onActionRefreshPrice(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action');
                if (!action)
                    return false;
                const changeTimelimit = target.attr('data-change-timelimit');
                // Task 25145.  Бронирование Сирены при обновлении стоимости, если билеты не выписываются в течении 15 минут, аннулируется.
                if (changeTimelimit == 'true') {
                    const dialog = new App.ActionDialog(target, App.ActionType.reprice);
                    dialog.displayText('В случае продолжения операции выписка авиабилетов будет возможна в течение 10 минут. Рекомендуем произвести операцию обновления стоимости перед выпиской');
                    dialog.setConfirmButtonText('Продолжить');
                    dialog.show();
                    return false;
                }
                const response = yield doAction(action, {}, () => App.modalShow($(App.templates.Order.Messages.Repricing({}))));
                if (!response)
                    return false;
                if (response.status.messages)
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
            // вывод сообщений в шапку - недобно возвращаться обратно
            /* App.validateResponse(response, this.#messages, undefined, { showOnPage: true });
            App.popupHide();*/
        });
    }, _OrderPageMobile_onInactiveIssueButtonClick = function _OrderPageMobile_onInactiveIssueButtonClick() {
        App.popupShow($('<span>Перед выпиской билета необходимо передать паспортные данные в авиакомпанию</span>'), '', () => { }, () => {
            setTimeout(() => {
                $('.js-add-passport')
                    .animate({ 'background-color': '#fe0335' }, 1000)
                    .animate({ 'background-color': '#03affe' }, 1000);
            }, 0);
        });
    }, _OrderPageMobile_onActionIssue = function _OrderPageMobile_onActionIssue(event) {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_doActionIssue).call(this, $(event.currentTarget), true);
        });
    }, _OrderPageMobile_doActionIssue = function _OrderPageMobile_doActionIssue(invoker, checkStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            let preaction = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, invoker, 'data-preaction');
            const prerequirement = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, invoker, 'data-prerequirement');
            if (!preaction || !prerequirement)
                return false;
            preaction = `${preaction}/${__classPrivateFieldGet(this, _OrderPageMobile_options, "f").id}`;
            const changeTimelimit = invoker.attr('data-change-timelimit');
            // Task 25145.  Бронирование Сирены при обновлении стоимости, если билеты не выписываются в течении 15 минут, аннулируется.
            if (changeTimelimit == 'true') {
                const dialog = new App.ActionDialog(invoker, App.ActionType.issue);
                dialog.displayText('В случае​ изменения стоимости выписка авиабилетов будет возможна в течение 10 минут');
                dialog.setConfirmButtonText('Продолжить');
                dialog.show();
                return false;
            }
            const preRequirementResponse = yield doAction(prerequirement, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataLoading).call(_a)));
            if (!preRequirementResponse) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                return false;
            }
            if (preRequirementResponse.status.success
                && preRequirementResponse.data.preRequirementMessage
                && preRequirementResponse.data.preRequirementMessage.length > 0) {
                App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, preRequirementResponse.data.preRequirementMessage));
                return false;
            }
            if (checkStatus) {
                const response = yield doAction(preaction, {});
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return false;
                }
                if (response.status.success && response.data.text.length > 0) {
                    const dialog = new App.ActionDialog(invoker, App.ActionType.preissue);
                    dialog.displayText(response.data.text);
                    dialog.setConfirmButtonText('Согласен');
                    dialog.show();
                    return true;
                }
            }
            const dialog = new App.ActionDialog(invoker, App.ActionType.issue, undefined, invoker.attr('data-warning-text'));
            if (invoker.attr('data-charter') == 'true')
                dialog.changeContent($(App.templates.Order.Messages.CharterIssueInfo({})));
            dialog.show();
            return true;
        });
    }, _OrderPageMobile_onActionContinue = function _OrderPageMobile_onActionContinue(event, invoker, serviceKey, actionType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                if (actionType === App.ActionType.preissue) {
                    yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_doActionIssue).call(this, invoker, false);
                    return true;
                }
                if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                    return false;
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, invoker, 'data-action');
                if (!action)
                    return false;
                const response = yield doAction(action, {});
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return false;
                }
                const { messages } = response.status;
                if (messages && messages.length > 0) {
                    if (messages[0].type === 2 /* MessageType.Error */ || messages[0].type === 1 /* MessageType.Warning */) {
                        yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                        App.popupShow(this.getCommonInfoBlockCompact(messages[0]));
                        // Если у отеля отказ по одной из комнат, то статус оставшейся услуги меняется на Запрос. Поэтому
                        // нужно перегрузить и открыть Подробности.
                        const service = __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f").find(`.js-order-service[data-key=${serviceKey}]`);
                        const scrollPosition = service.offset();
                        if (scrollPosition)
                            $('html, body').animate({ scrollTop: scrollPosition.top }, 'slow');
                        $('.js-order-service-open', service).trigger('click');
                    }
                    else {
                        yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                        const scsm = invoker.attr('data-skip-success-message');
                        if (scsm && scsm !== 'true')
                            App.popupShow(this.getCommonInfoBlockCompact(messages[0]));
                    }
                    return false;
                }
                if (actionType === App.ActionType.confirmation) {
                    if (response.data) {
                        if (response.data.priceHasChanged) {
                            const dialog = $(App.templates.Order.Messages.BookingPriceHasChanged(response.data));
                            dialog.on('click', '.js-cancel-current-booking', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onCancelCurrentAccommodationBooking).call(this, e); }));
                            dialog.on('click', '.js-book-alternative-accommodation', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onBookAlternativeHotel).call(this, e); }));
                            App.popupShow(dialog, 'Внимание!');
                            return false;
                        }
                    }
                }
                if (actionType === App.ActionType.issue) {
                    // цена изменилась! сразу перегружаем заказ и показываем сообщение.
                    yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                    const service = __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f").find(`.js-order-service[data-key=${serviceKey}]`);
                    const scrollPosition = service.offset();
                    if (scrollPosition)
                        $('html, body').animate({ scrollTop: scrollPosition.top }, 'slow');
                    const dialog = $(App.templates.Order.IssuePriceChanged(response.data));
                    dialog.on('click', '.js-cancel-issue-ticket', () => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onCancelIssue).call(_a));
                    // передаем селектор выписываемой услуги, чтобы потом к ней перейти
                    $('.js-confirm-issue-ticket', dialog).on('click', e => __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onConfirmIssue).call(this, e, serviceKey));
                    App.popupShow(dialog, 'Выписка билета');
                    return false;
                }
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onCancelCurrentAccommodationBooking = function _OrderPageMobile_onCancelCurrentAccommodationBooking(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action');
            if (!action)
                return false;
            const response = yield doAction(action, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataCurrentBookingCancellation).call(_a)));
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            if (!response.data.success)
                return false;
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
            App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, response.data.message));
            return true;
        });
    }, _OrderPageMobile_onBookAlternativeHotel = function _OrderPageMobile_onBookAlternativeHotel(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action');
            if (!action)
                return false;
            const response = yield doAction(action, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataBooking).call(_a)));
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true })) {
                App.popupHide();
                return false;
            }
            if (!response)
                return false;
            if (!response.data.success)
                return false;
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
            App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, response.data.message));
            return true;
        });
    }, _OrderPageMobile_onCancelIssue = function _OrderPageMobile_onCancelIssue() {
        App.popupHide();
    }, _OrderPageMobile_onConfirmIssue = function _OrderPageMobile_onConfirmIssue(event, serviceKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            if (!serviceKey)
                return false;
            const target = $(event.currentTarget);
            const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action');
            const id = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-id');
            const agreeWithPriceChanging = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-agree-with-price-changing');
            if (!action || !id || !agreeWithPriceChanging)
                return false;
            App.modalShow($(App.templates.Order.Messages.Issuing({})));
            const response = yield doAction(action, {
                id,
                agreeWithPriceChanging,
            });
            if (!response)
                return false;
            if (response.status.messages) {
                if (response.status.messages[0].type === 0 /* MessageType.Information */) {
                    yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getServices).call(this);
                    const service = __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f").find(`.js-order-service[data-key=${serviceKey}]`);
                    let scrollPosition = service.offset();
                    if (scrollPosition) {
                        $('html, body').animate({ scrollTop: scrollPosition.top - 50 }, 'slow');
                    }
                    else {
                        scrollPosition = __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f").offset();
                        if (scrollPosition)
                            $('html, body').animate({ scrollTop: scrollPosition.top - 100 }, 'slow');
                    }
                }
                App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
            }
            return true;
        });
    }, _OrderPageMobile_onActionPacManual = function _OrderPageMobile_onActionPacManual(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action');
                const actionType = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action-type');
                if (!action || !actionType)
                    return false;
                const response = yield doAction(action, {}, () => App.modalShow($(App.findTemplate(`Order.Messages.${actionType}`)({}))));
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true })) {
                    App.popupHide();
                    return false;
                }
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                App.popupHide();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onAviaRebook = function _OrderPageMobile_onAviaRebook(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const bookingNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-booking-number');
            if (!bookingNumber)
                return false;
            const action = __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.aviaRebook;
            return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_aviaRebookCore).call(this, bookingNumber, action);
        });
    }, _OrderPageMobile_onAviaRebookContinue = function _OrderPageMobile_onAviaRebookContinue(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const bookingNumber = data;
            const action = __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.aviaRebookContinue;
            return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_aviaRebookCore).call(this, bookingNumber, action);
        });
    }, _OrderPageMobile_aviaRebookCore = function _OrderPageMobile_aviaRebookCore(bookingNumber, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const response = yield doAction(action, {
                    orderNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                    orderBookingNumber: bookingNumber,
                }, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataRebooking).call(_a)));
                if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true })) {
                    App.popupHide();
                    return false;
                }
                if (!response)
                    return false;
                if (response.data.success) {
                    yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                    App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, response.data.message));
                    return true;
                }
                if (response.data.doubleBookingFound === true) {
                    const doublesDialog = $(App.templates.Order.Messages.AviaRebookContinueDialog({
                        message: response.data.message,
                        continueAction: response.data.continueAction,
                    }));
                    doublesDialog.on('click', '.js-avia-rebook-continue', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onAviaRebookContinue).call(this, e, bookingNumber); }));
                    doublesDialog.on('click', '.js-avia-rebook-close', () => App.popupHide());
                    App.popupShow(doublesDialog, 'Предупреждение');
                    return true;
                }
                if (response.data.message) {
                    const dialog = $(App.templates.Order.Messages.AviaRebookDialog({
                        message: response.data.message,
                        searchUrl: response.data.searchUrl,
                    }));
                    dialog.on('click', '.js-avia-rebook-search', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onAviaRebookNewSearch).call(_a, e));
                    dialog.on('click', '.js-avia-rebook-close', () => App.popupHide());
                    App.popupShow(dialog, 'Ошибка бронирования');
                    return true;
                }
                App.popupHide();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onAviaRebookNewSearch = function _OrderPageMobile_onAviaRebookNewSearch(event) {
        const target = $(event.currentTarget);
        if (target) {
            const href = target.attr('data-href');
            if (href)
                window.location.href = href;
        }
    }, _OrderPageMobile_onActionAviaSynchronize = function _OrderPageMobile_onActionAviaSynchronize(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return;
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const action = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-action');
                if (!action)
                    return;
                const response = yield doAction(action, {}, () => App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataSaving).call(_a)));
                if (!response) {
                    App.popupShow(this.getCommonInfoBlock(2 /* MessageType.Error */, 'Произошла ошибка. Попробуйте еще раз через некоторое время.'));
                    return;
                }
                yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_reloadAll).call(this);
                if (response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                    return;
                }
                App.popupShow(this.getCommonInfoBlock(0 /* MessageType.Information */, 'Бронь синхронизирована.'));
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onShowPaymentHistory = function _OrderPageMobile_onShowPaymentHistory(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const block = target.parent();
            block.children('.js-order-payment-history-result').remove();
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataLoading).call(_a));
            const response = yield $.ajax({
                url: App.app.url.route(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.paymentHistory),
                method: 'POST',
                dataType: 'json',
                data: { orderNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id },
            });
            App.popupHide();
            target.addClass('_dspn');
            if (response && response.data) {
                const result = $(App.templates.Order.OrderPaymentHistory({
                    items: response.data.items,
                    averageRateRub: response.data.averageRateRub,
                }));
                block.append(result);
                $('.js-order-payment-history-result-close', result).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_closePaymentHistory).call(_a, e));
                return true;
            }
            if (response.status.success && response.status.messages && response.status.messages[0].type === 1 /* MessageType.Warning */) {
                const result = $(App.templates.Order.OrderPaymentHistory({
                    message: response.status.messages[0].text,
                }));
                block.append(result);
                $('.js-order-payment-history-result-close', result).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_closePaymentHistory).call(_a, e));
            }
            return false;
        });
    }, _OrderPageMobile_closePaymentHistory = function _OrderPageMobile_closePaymentHistory(event) {
        const target = $(event.currentTarget);
        const block = target.parent().parent();
        block.find('.js-order-payment-history-link').removeClass('_dspn');
        target.closest('.js-order-payment-history-result').hide('fast');
    }, _OrderPageMobile_onShowCancelledServices = function _OrderPageMobile_onShowCancelledServices(event) {
        const target = $(event.currentTarget);
        const block = target.parent();
        $('.js-order-canceled-show', block).hide();
        $('.js-order-canceled-close', block).show();
        $('.js-order-canceled-result', block).show();
        block.removeClass('_off');
    }, _OrderPageMobile_onCloseCancelledServices = function _OrderPageMobile_onCloseCancelledServices(event) {
        const target = $(event.currentTarget);
        const block = target.parent();
        $('.js-order-canceled-show', block).show();
        $('.js-order-canceled-close', block).hide();
        $('.js-order-canceled-result', block).hide();
        block.addClass('_off');
    }, _OrderPageMobile_onFillMscTourists = function _OrderPageMobile_onFillMscTourists() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
                return false;
            App.modalShow(__classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getDataLoading).call(_a));
            const response = yield $.ajax({
                url: App.app.url.route(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.fillMscTourists),
                method: 'POST',
                dataType: 'json',
                data: { orderNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id },
            });
            App.popupHide();
            if (response && response.data) {
                $('.js-fill-msc-tourists', __classPrivateFieldGet(this, _OrderPageMobile_orderHeaderContainer, "f")).hide();
                const promises = new Array();
                $('.js-order-tourist-info', __classPrivateFieldGet(this, _OrderPageMobile_orderHeaderContainer, "f")).each((i, item) => {
                    const tourist = response.data.tourists.filter(v => v.lastName.toUpperCase() === $(item).attr('data-lastname')
                        && v.firstName.toUpperCase() === $(item).attr('data-firstname')
                        && v.birthday === $(item).attr('data-birthday'))[0];
                    if (tourist) {
                        promises.push(__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_openTouristEditor).call(this, $(item)));
                    }
                    else {
                        $(item).after(__classPrivateFieldGet(this, _OrderPageMobile_mscNoTouristMatchingTemplate, "f").call(this, {}));
                    }
                });
                yield Promise.all(promises);
                $('.js-order-tourist-info', __classPrivateFieldGet(this, _OrderPageMobile_orderHeaderContainer, "f")).each((i, item) => {
                    const tourist = response.data.tourists.filter(v => v.lastName.toUpperCase() === $(item).attr('data-lastname')
                        && v.firstName.toUpperCase() === $(item).attr('data-firstname')
                        && v.birthday === $(item).attr('data-birthday'))[0];
                    if (tourist) {
                        const editor = $(item).siblings('.js-order-tourist-editor');
                        const hasAnotherValue = __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_fillTouristMscData).call(this, tourist, editor);
                        $('.js-rewrite-tourist-block', $(editor)).toggle(hasAnotherValue);
                        $('.js-rewrite-by-msc', $(editor)).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onRewriteByMsc).call(_a, e));
                        $('.js-rewrite-tourist-by-msc', $(editor)).on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_onRewriteTouristByMsc).call(_a, e));
                    }
                    else {
                        $(item).after(__classPrivateFieldGet(this, _OrderPageMobile_mscNoTouristMatchingTemplate, "f").call(this, {}));
                    }
                });
            }
            else {
                $('.js-fill-msc-tourists', __classPrivateFieldGet(this, _OrderPageMobile_orderHeaderContainer, "f")).hide();
                if (response.status && !response.status.success && response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                }
            }
            return true;
        });
    }, _OrderPageMobile_fillTouristMscData = function _OrderPageMobile_fillTouristMscData(tourist, editor) {
        // Идем по всем элементам с атрибутом data-msc-type и сравниваем их содержимое с содержимым одноименных свойств
        // туриста.
        let hasAnotherValue = false;
        $('[data-msc-type]', editor).each((i2, item2) => {
            const mscType = $(item2).attr('data-msc-type');
            const controlType = $(item2).attr('data-type');
            let value = tourist[mscType];
            if (value == undefined)
                return;
            value = value.toString();
            if (controlType === 'select') {
                if (value) {
                    const block = new App.FilterSelectBlock({ root: $(item2) });
                    const selectValue = block.getValue();
                    if (!selectValue || selectValue === '') {
                        block.setValue(value);
                        $(item2).parent().addClass('_msc-data');
                        $(item2).parent().append(__classPrivateFieldGet(this, _OrderPageMobile_mscValueTemplate, "f").call(this, { differs: 'use' }));
                    }
                    else if (selectValue === value) {
                        $(item2).parent().append(__classPrivateFieldGet(this, _OrderPageMobile_mscValueTemplate, "f").call(this, { differs: 'equal' }));
                        $(item2).addClass('_msc-data-equal');
                    }
                    else {
                        $(item2).parent().append(__classPrivateFieldGet(this, _OrderPageMobile_mscValueTemplate, "f").call(this, { differs: 'different', value, mscType }));
                        $(item2).addClass('_msc-data-different');
                        hasAnotherValue = true;
                    }
                }
            }
            else if ($(item2).val() === '') {
                if (value !== '') {
                    $(item2).val(value);
                    $(item2).parent().addClass('_msc-data');
                    $(item2).parent().append(__classPrivateFieldGet(this, _OrderPageMobile_mscValueTemplate, "f").call(this, { differs: 'use' }));
                }
            }
            else if (value) {
                if ($(item2).valString().replace('+', '') === value) {
                    $(item2).parent().append(__classPrivateFieldGet(this, _OrderPageMobile_mscValueTemplate, "f").call(this, { differs: 'equal' }));
                    $(item2).parent().addClass('_msc-data-equal');
                }
                else {
                    $(item2).parent().append(__classPrivateFieldGet(this, _OrderPageMobile_mscValueTemplate, "f").call(this, { differs: 'different', value, mscType }));
                    $(item2).parent().addClass('_msc-data-different');
                    hasAnotherValue = true;
                }
            }
        });
        return hasAnotherValue;
    }, _OrderPageMobile_onRewriteByMsc = function _OrderPageMobile_onRewriteByMsc(event) {
        var _b;
        const target = $(event.currentTarget);
        const editor = target.closest('.js-order-tourist-editor');
        const forMscType = target.attr('data-for-msc-type');
        if (!forMscType)
            return;
        const mscTypeBlock = editor.find(`[data-msc-type="${forMscType}"]`);
        const value = (_b = target.attr('data-val')) !== null && _b !== void 0 ? _b : '';
        if (mscTypeBlock.attr('data-type') === 'select') {
            const selectBlock = new App.FilterSelectBlock({ root: mscTypeBlock });
            selectBlock.setValue(value);
        }
        else {
            mscTypeBlock.val(value).addClass('text-red');
        }
        target.parent('.js-msc-value-block').hide();
    }, _OrderPageMobile_onRewriteTouristByMsc = function _OrderPageMobile_onRewriteTouristByMsc(event) {
        const target = $(event.currentTarget);
        const editor = target.closest('.js-order-tourist-editor');
        $('.js-rewrite-by-msc', $(editor)).trigger('click').parent().hide();
    }, _OrderPageMobile_onCruiseChangeRouteRequest = function _OrderPageMobile_onCruiseChangeRouteRequest(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const target = $(event.currentTarget);
            const reqValue = Number(target.attr('data-request-value'));
            const action = __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.sendCruiseChangeRouteRequest;
            const response = yield doAction(action, {
                orderNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                operation: reqValue,
            });
            if (!response) {
                App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPageMobile_defaultError));
                return false;
            }
            if (!response.status.success && response.status.messages) {
                App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                return true;
            }
            const dialog = $(App.templates.Order.Messages.CruiseChangeRouteRequestInfo({
                operation: reqValue === 1,
            }));
            App.popupShow(dialog, 'Внимание');
            const block = target.parent('.js-cruise-needChangeRoute');
            block.hide();
            return true;
        });
    }, _OrderPageMobile_onCruiseIssueRequest = function _OrderPageMobile_onCruiseIssueRequest(event) {
        if (!__classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_canEditOrder).call(this))
            return false;
        const target = $(event.currentTarget);
        const bookingNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-booking-number');
        const cabinNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-cabin-number');
        if (!bookingNumber || !cabinNumber)
            return false;
        const dialog = $(App.templates.Order.Messages.CruiseCheckTouristsDialog({
            bookingNumber,
            cabinNumber,
            isLuxeCruise: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").isLuxeCruise,
        }));
        dialog.on('click', '.js-cruise-issue-dialog-confirm', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onCruiseIssueAgreed).call(this, e); }));
        dialog.on('click', '.js-cruise-issue-dialog-close', () => App.popupHide());
        App.popupShow(dialog, 'Выписка круизного билета');
        return true;
    }, _OrderPageMobile_onCruiseIssueAgreed = function _OrderPageMobile_onCruiseIssueAgreed(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                const target = $(event.currentTarget);
                const bookingNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-booking-number');
                const cabinNumber = __classPrivateFieldGet(_a, _a, "m", _OrderPageMobile_getRequiredParameter).call(_a, target, 'data-cabin-number');
                if (!bookingNumber || !cabinNumber)
                    return false;
                const action = __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.sendCruiseIssueRequest;
                const response = yield doAction(action, {
                    orderNumber: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id,
                    bookingNumber,
                    cabinNumber,
                });
                if (!response) {
                    App.popupShow(__classPrivateFieldGet(_a, _a, "f", _OrderPageMobile_defaultError));
                    return false;
                }
                if (!response.status.success && response.status.messages) {
                    App.popupShow(this.getCommonInfoBlockCompact(response.status.messages[0]));
                    return true;
                }
                const dialog = $(App.templates.Order.Messages.CruiseIssueRequestInfo({
                    isRealCabinNumber: response.data.isRealCabinNumber,
                    isIssueInWork: response.data.isIssueInWork,
                }));
                App.popupShow(dialog, 'Внимание');
                // скрыть кнопку "Выписать"
                $(`.js-cruise-issue-request[data-booking-number="${bookingNumber}"]`, __classPrivateFieldGet(this, _OrderPageMobile_servicesContainer, "f")).parents('.js-order-service-details').hide();
                return true;
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onShowTermsClick = function _OrderPageMobile_onShowTermsClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            if (__classPrivateFieldGet(this, _OrderPageMobile_popupInfo, "f"))
                App.popupHide();
            const target = $(event.currentTarget);
            __classPrivateFieldSet(this, _OrderPageMobile_popupInfo, new App.PopupOld({
                content: $('<div class="js-auto-terms-wrap"><div style="padding:10px;"><img src="/img/main/load-sm.gif"/></div></div>'),
                onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b, _c; return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getVehicleTerms).call(this, (_b = target.attr('href')) !== null && _b !== void 0 ? _b : '', (_c = target.closest('.js-order-service').attr('data-booking-number')) !== null && _c !== void 0 ? _c : ''); }),
            }), "f");
            $('body').trigger("popup:open" /* Events.PopupOpen */, []);
            return true;
        });
    }, _OrderPageMobile_getVehicleTerms = function _OrderPageMobile_getVehicleTerms(key, bookingNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getVehicleTerms,
                method: 'POST',
                data: { key },
            });
            try {
                const response = yield xhr;
                let term = 'Произошла ошибка. Попробуйте еще раз позднее.';
                let isDebit = false;
                let isCredit = false;
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(response)) {
                    if (response.status.messages && response.status.messages.length > 0)
                        term = response.status.messages[0].text;
                }
                else {
                    term = response.data.term;
                    const domNodes = jQuery.parseHTML(response.data.searchText);
                    let searchText = $(domNodes).find('h4').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dt').text();
                    if (searchText.length == 0)
                        searchText = $(domNodes).find('dd').text();
                    if (searchText.includes('дебетов'))
                        isDebit = true;
                    if (searchText.includes('кредитн'))
                        isCredit = true;
                    if (response.data.isNeedCarDeposit)
                        isCredit = true;
                }
                const termContent = $(App.templates.VehicleTerms({ term, isDebit, isCredit }));
                const parent = $('.js-popup').find('.js-auto-terms-wrap');
                parent.empty().append(termContent);
                parent.addClass('auto-terms-wrap');
                const html = parent.clone().html();
                const copyButton = $(document.createElement('input'))
                    .attr('type', 'button')
                    .attr('value', 'Сохранить')
                    .attr('class', 'form-btn form-btn_alert _save');
                copyButton.on('click', () => App.download(`Service terms for ${bookingNumber}.html`, `${html}`));
                parent.prepend(copyButton);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _OrderPageMobile_getRequiredParameter = function _OrderPageMobile_getRequiredParameter(element, name) {
        const value = element.attr(name);
        if (!value || value.length <= 0)
            window.console.log(`Ошибка. У формы не задан параметр ${name}`);
        return value;
    }, _OrderPageMobile_reloadAll = function _OrderPageMobile_reloadAll() {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getHeader).call(this);
            yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getServices).call(this);
            // прокрутка не нужна
        });
    }, _OrderPageMobile_setLoadingText = function _OrderPageMobile_setLoadingText(text) {
        $('.js-popup-container').find('.js-loading-text').text(text);
    }, _OrderPageMobile_onSearchBefore = function _OrderPageMobile_onSearchBefore(container) {
        container.hide();
        $('.js-details-loading', container.closest('.js-order-service-details')).show();
    }, _OrderPageMobile_onSearchAlways = function _OrderPageMobile_onSearchAlways(container) {
        container.show();
        $('.js-details-loading', container.closest('.js-order-service-details')).hide();
    }, _OrderPageMobile_hidePreloader = function _OrderPageMobile_hidePreloader(container) {
        $('.js-loading', container).remove();
    }, _OrderPageMobile_getDataLoading = function _OrderPageMobile_getDataLoading() {
        return $('<br/><div>Данные загружаются</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPageMobile_getDataSaving = function _OrderPageMobile_getDataSaving() {
        return $('<br/><div>Данные сохраняются</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPageMobile_getDataRebooking = function _OrderPageMobile_getDataRebooking() {
        return $('<br/><div>Выполняется перебронирование</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPageMobile_getDataBooking = function _OrderPageMobile_getDataBooking() {
        return $('<br/><div>Выполняется бронирование</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPageMobile_getDataCurrentBookingCancellation = function _OrderPageMobile_getDataCurrentBookingCancellation() {
        return $('<br/><div>Выполняется аннуляция текущей брони</div>')
            .append($('.js-loading', $(App.templates.Order.Messages.Loading({}))));
    }, _OrderPageMobile_getReport = function _OrderPageMobile_getReport(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = $.ajax({
                url: $(e.currentTarget).attr('data-href'),
                method: 'GET',
            });
            const popupGroup = __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").show({
                group: 'report',
                content: App.templates.Order.Messages.Loading({}),
                delay: 2000,
            });
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(response))
                    return;
                if (response.data.errorMessage) {
                    const message = { type: 0 /* MessageType.Information */, text: response.data.errorMessage };
                    __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").show({ content: App.templates.Message(message) });
                    return;
                }
                if (!response.data.hasForm) {
                    window.location.href = response.data.url;
                    return;
                }
                Fancybox.show([
                    {
                        src: response.data.url,
                        type: 'iframe',
                        width: 800,
                        height: '80%',
                    },
                ]);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide(popupGroup);
            }
        });
    }, _OrderPageMobile_getCruiseDoc = function _OrderPageMobile_getCruiseDoc(e) {
        let url = $(e.currentTarget).attr('data-href');
        if (url && url.length !== 0) {
            url += `order-${__classPrivateFieldGet(this, _OrderPageMobile_options, "f").id}/`;
            window.location.href = url;
        }
    }, _OrderPageMobile_getDocumentDownloadLinkDialog = function _OrderPageMobile_getDocumentDownloadLinkDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            this.root.off('click', '#acceptGetDocumentLink');
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.checkPackageAvailableForLink,
                method: 'POST',
                data: { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id },
            });
            const popupGroup = __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").show({
                group: 'link',
                content: App.templates.Order.Messages.Loading({}),
                delay: 250,
            });
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(response)) {
                    __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide(popupGroup);
                    return;
                }
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").show({
                    group: popupGroup,
                    content: App.templates.Order.Messages.DocumentDownloadLinkDialog({ message: response.data.message }),
                });
            }
            catch (ex) {
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide(popupGroup);
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            this.root.on('click', '#acceptGetDocumentLink', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_onAcceptDownloadLinkClick).call(this, e, popupGroup); }));
            this.root.on('click', '#declineGetDocumentLink', () => __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide(popupGroup));
        });
    }, _OrderPageMobile_onAcceptDownloadLinkClick = function _OrderPageMobile_onAcceptDownloadLinkClick(event, popupGroup) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            event.stopPropagation();
            const request = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getDocumentDownloadLink,
                method: 'POST',
                data: { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id },
            });
            __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").show({
                group: popupGroup,
                content: App.templates.Order.Messages.Loading({}),
                delay: 250,
            });
            try {
                const response = yield request;
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(response)) {
                    __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide(popupGroup);
                    return;
                }
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").show({
                    content: App.templates.Order.Messages.DocumentDownloadLink({
                        url: response.data.url,
                        lifetime: response.data.lifetime,
                    }),
                });
            }
            catch (ex) {
                __classPrivateFieldGet(this, _OrderPageMobile_popup, "f").hide(popupGroup);
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _OrderPageMobile_onScheduleClick = function _OrderPageMobile_onScheduleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (__classPrivateFieldGet(this, _OrderPageMobile_schedulePopupInfo, "f"))
            App.popupHide();
        __classPrivateFieldSet(this, _OrderPageMobile_schedulePopupInfo, new App.PopupOld({
            content: $('<div class="js-cruise-schedule cruise-schedule user-content"><div style="padding:10px;"><img src="/img/main/load-sm.gif"/></div></div>'),
            onShowDelegate: () => __awaiter(this, void 0, void 0, function* () { var _b; return yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_getCruiseSchedule).call(this, (_b = $(event.currentTarget).attr('data-ordernumber')) !== null && _b !== void 0 ? _b : ''); }),
        }), "f");
        $('body').trigger("popup:open" /* Events.PopupOpen */, []);
    }, _OrderPageMobile_getCruiseSchedule = function _OrderPageMobile_getCruiseSchedule(orderNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.getCruiseSchedule,
                method: 'POST',
                data: { orderNumber: orderNumber },
            });
            const response = yield xhr;
            if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(response)) {
                App.popupHide();
                return;
            }
            let blockDescr = $('<div>Расписание будет позже.</div>');
            if (response && response.data && response.data.item) {
                blockDescr = $(App.templates.Order.CruiseSchedule({ scheduleData: response.data.item }));
            }
            $('.js-cruise-schedule', $('.js-popup')).empty().append(blockDescr);
        });
    }, _OrderPageMobile_onTouristPriceEditClick = function _OrderPageMobile_onTouristPriceEditClick(event) {
        event.preventDefault();
        $('.js-order-header .js-order-touristPriceEditWrap').showByClass();
        $('.js-order-header .js-order-touristPriceViewWrap').hideByClass();
    }, _OrderPageMobile_onTouristPriceSaveClick = function _OrderPageMobile_onTouristPriceSaveClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (__classPrivateFieldGet(this, _OrderPageMobile_processExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, true, "f");
            try {
                $('.js-order-header .js-order-touristPriceEditItem').removeClass('_invalid');
                const price = $('.js-order-header .js-order-touristPriceEditItem input').valNumber();
                if (!price || price <= 0 || price < __classPrivateFieldGet(this, _OrderPageMobile_header, "f").touristPrice.limitFrom || price > __classPrivateFieldGet(this, _OrderPageMobile_header, "f").touristPrice.limitTo) {
                    $('.js-order-header .js-order-touristPriceEditItem').addClass('_invalid');
                    return;
                }
                const touristPriceResponse = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.saveTouristPrice, { id: __classPrivateFieldGet(this, _OrderPageMobile_options, "f").id, price });
                if (!App.validateResponse(touristPriceResponse, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f") /* TODO, validator*/, undefined, { showOnPage: true }))
                    return;
                if (!touristPriceResponse)
                    return;
                $('.js-order-header .js-order-touristPrice').find(App.Money.tagName).get(0).amount = price;
                $('.js-order-header .js-order-touristPriceEditWrap').hideByClass();
                $('.js-order-header .js-order-touristPriceViewWrap').showByClass();
            }
            finally {
                __classPrivateFieldSet(this, _OrderPageMobile_processExecuting, false, "f");
            }
        });
    }, _OrderPageMobile_onTouristPriceSaveCancelClick = function _OrderPageMobile_onTouristPriceSaveCancelClick() {
        $('.js-order-header .js-order-touristPrice').find(App.Money.tagName).get(0).amount = __classPrivateFieldGet(this, _OrderPageMobile_header, "f").touristPrice.price;
        $('.js-order-header .js-order-touristPriceEditWrap').hideByClass();
        $('.js-order-header .js-order-touristPriceViewWrap').showByClass();
    }, _OrderPageMobile_markMessageAsRead = function _OrderPageMobile_markMessageAsRead(messageKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield doAction(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.setChatMessageRead, { messageKeys: messageKeys });
            if (!App.validateResponse(response, __classPrivateFieldGet(this, _OrderPageMobile_messages, "f"), undefined, { showOnPage: true }))
                return;
            if (!response)
                return;
        });
    }, _OrderPageMobile_checkUnreadMessages = function _OrderPageMobile_checkUnreadMessages(container) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                rootMargin: '0px',
                threshold: 1.0,
            };
            const callback = (me) => {
                return function (entries, observer) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const keys = [];
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                const item = $(entry.target);
                                item.addClass('_off');
                                observer.unobserve(entry.target);
                                const key = Number(item.attr('data-key'));
                                keys.push(key);
                                item.removeAttr('data-key');
                            }
                        });
                        if (keys.length != 0) {
                            yield __classPrivateFieldGet(me, _OrderPageMobile_instances, "m", _OrderPageMobile_markMessageAsRead).call(me, keys);
                            App.emptyArray(keys);
                        }
                    });
                };
            };
            const observer = new IntersectionObserver(callback(this), options);
            const mes = container.find('._new:not(._off)');
            mes.each((i, v) => observer.observe(v));
        });
    }, _OrderPageMobile_onExpansionPanelAfterToggle = function _OrderPageMobile_onExpansionPanelAfterToggle(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            if (!data.opened)
                return;
            const target = $(e.target);
            if (target.attr('data-remote-loaded') === 'true')
                return;
            target.attr('data-remote-loaded', 'true');
            switch (data.type) {
                case 'priceBreakdown':
                    yield __classPrivateFieldGet(this, _OrderPageMobile_instances, "m", _OrderPageMobile_loadPriceBreakdown).call(this, target, data.key);
                    break;
                // no default
            }
        });
    }, _OrderPageMobile_loadPriceBreakdown = function _OrderPageMobile_loadPriceBreakdown(target_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (target, key, signal = App.noneSignal) {
            var _b;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(App.app.url.route(__classPrivateFieldGet(this, _OrderPageMobile_options, "f").urls.orderPriceBreakdown, key), { signal });
                    if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                target.find('.js-expansion-panel-content').replaceWith(App.templates.Order.OrderPriceBreakdown({
                    grossPrice: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").grossPrice,
                    currency: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").currency,
                    totalDiscount: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").totalDiscount,
                    discount: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").discount,
                    bonusAmount: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").bonusAmount,
                    fakeMarkup: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").fakeMarkup,
                    onlyAvia: __classPrivateFieldGet(this, _OrderPageMobile_header, "f").onlyAvia,
                    items: (_b = response === null || response === void 0 ? void 0 : response.data.items) !== null && _b !== void 0 ? _b : [],
                }));
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _OrderPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    _OrderPageMobile_defaultError = { value: $('<h3>Произошла непредвиденная ошибка. Попробуйте позже</h3>') };
    App.OrderPageMobile = OrderPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _QualityControlPage_instances, _QualityControlPage_filter, _QualityControlPage_headerQuestion, _QualityControlPage_commentElement, _QualityControlPage_onCommentChange, _QualityControlPage_onCategoryChange, _QualityControlPage_changeHeaderQuestion, _QualityControlPage_isFormError, _QualityControlPage_onSubmitForm, _QualityControlPage_booking;
    class QualityControlPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-order-qualityControl-page' }, options));
            _QualityControlPage_instances.add(this);
            _QualityControlPage_filter.set(this, void 0);
            _QualityControlPage_headerQuestion.set(this, void 0);
            _QualityControlPage_commentElement.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _QualityControlPage_headerQuestion, $('.js-qc-header-question'), "f");
            __classPrivateFieldSet(this, _QualityControlPage_filter, new App.Filter({ root: '.js-order-qualityControl-form' }), "f");
            __classPrivateFieldGet(this, _QualityControlPage_filter, "f").root.on('change', '.js-order-qualityControl-main [data-input-name="hotel_stars_from"]', e => __classPrivateFieldGet(this, _QualityControlPage_instances, "m", _QualityControlPage_onCategoryChange).call(this, e));
            __classPrivateFieldGet(this, _QualityControlPage_filter, "f").root.on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _QualityControlPage_instances, "m", _QualityControlPage_onSubmitForm).call(this, e); }));
            __classPrivateFieldSet(this, _QualityControlPage_commentElement, $('#qc-comment', __classPrivateFieldGet(this, _QualityControlPage_filter, "f").root), "f");
            __classPrivateFieldGet(this, _QualityControlPage_commentElement, "f").on('input', e => __classPrivateFieldGet(this, _QualityControlPage_instances, "m", _QualityControlPage_onCommentChange).call(this, e));
        }
    }
    _QualityControlPage_filter = new WeakMap(), _QualityControlPage_headerQuestion = new WeakMap(), _QualityControlPage_commentElement = new WeakMap(), _QualityControlPage_instances = new WeakSet(), _QualityControlPage_onCommentChange = function _QualityControlPage_onCommentChange(event) {
        const target = $(event.currentTarget);
        const value = target.valString();
        const maxLength = Number(target.attr('maxlength'));
        const realLength = value.length;
        if (realLength > maxLength) {
            target.val(value.slice(0, maxLength));
        }
    }, _QualityControlPage_onCategoryChange = function _QualityControlPage_onCategoryChange(event) {
        const value = Number($(event.currentTarget).val());
        __classPrivateFieldGet(this, _QualityControlPage_instances, "m", _QualityControlPage_changeHeaderQuestion).call(this, value);
    }, _QualityControlPage_changeHeaderQuestion = function _QualityControlPage_changeHeaderQuestion(count) {
        let text = '';
        if (count === 5)
            text = 'Что вам понравилось?';
        if (count === 4)
            text = 'Что нам необходимо улучшить?';
        if (count <= 3)
            text = 'Что вам не понравилось?';
        __classPrivateFieldGet(this, _QualityControlPage_headerQuestion, "f").html(text);
        $('.js-qc-questions').show();
        $('.js-order-qualityControl-services').show();
        $('.js-review-submit').show();
    }, _QualityControlPage_isFormError = function _QualityControlPage_isFormError() {
        const mainBlock = $('.js-order-qualityControl-main', __classPrivateFieldGet(this, _QualityControlPage_filter, "f").root);
        const stars = Number($('#mainStarFrom', mainBlock).val());
        const questionsSelected = $('.js-question-input:checked', mainBlock).length;
        const comment = __classPrivateFieldGet(this, _QualityControlPage_commentElement, "f").val();
        let isError = stars <= 4 && questionsSelected === 0 && (comment === undefined || comment.toString().length === 0);
        if (isError) {
            $('.errorMessage', mainBlock).show();
        }
        const isVip = $('#isVip', __classPrivateFieldGet(this, _QualityControlPage_filter, "f").root).val() === 'true';
        if (isVip) {
            const serviceBlock = $('.js-order-qualityControl-services', __classPrivateFieldGet(this, _QualityControlPage_filter, "f").root);
            $('.js-order-qualityControl-service', serviceBlock).each(function (i, el) {
                const star = Number($(`#serviceStarFrom${i}`, el).val());
                const note = $(`#note${i}`, el).val();
                if (isNaN(star) || star == 0 || (star < 5 && (note === undefined || note.toString().length === 0))) {
                    isError = true;
                    $('.form-item', el).addClass('_invalid');
                    $('.errorMessage', el).show();
                }
            });
        }
        return isError;
    }, _QualityControlPage_onSubmitForm = function _QualityControlPage_onSubmitForm(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            $('.errorMessage').hide();
            $('.form-item').removeClass('_invalid');
            if (__classPrivateFieldGet(this, _QualityControlPage_instances, "m", _QualityControlPage_isFormError).call(this)) {
                return;
            }
            yield __classPrivateFieldGet(this, _QualityControlPage_instances, "m", _QualityControlPage_booking).call(this);
        });
    }, _QualityControlPage_booking = function _QualityControlPage_booking() {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = __classPrivateFieldGet(this, _QualityControlPage_filter, "f").root.serializeArray();
            const xhr = $.ajax({
                url: '/my/order/savequalitycontrolanswers/',
                method: 'POST',
                dataType: 'json',
                data: formData,
            });
            const messages = new App.Messages();
            const responseValidator = new App.ResponseValidatorOld({ messenger: new App.BlockMessenger(messages) });
            const response = yield xhr;
            if (!responseValidator.process(response))
                return false;
            App.popupShow($('<h3>Спасибо! Ваша оценка принята.</h3>'), '');
            $('.js-order-qualityControl-form').hideByClass();
            return true;
        });
    };
    App.QualityControlPage = QualityControlPage;
})(App || (App = {}));
var App;
(function (App) {
    class OrderChatMessageModel {
        constructor(source) {
            // #region Original
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "time", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "userName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "text", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "textShort", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isNotRead", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "messageType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isAgent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isNeedAnswer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "agreement", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pnr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "subject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "replyOnKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #endregion
            // #region Additional
            Object.defineProperty(this, "replyOn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #endregion
            Object.defineProperty(this, "totalCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "messageItemsCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.assign(this, source);
        }
    }
    App.OrderChatMessageModel = OrderChatMessageModel;
})(App || (App = {}));
var App;
(function (App) {
    var _OrderChatModel_instances, _OrderChatModel_totalCount, _OrderChatModel_pageIndex, _OrderChatModel_pageSize, _OrderChatModel_remainingPageSize, _OrderChatModel_remainingTotalCount, _OrderChatModel_updateRemainingCounts;
    class OrderChatModel {
        get totalCount() {
            return __classPrivateFieldGet(this, _OrderChatModel_totalCount, "f");
        }
        set totalCount(value) {
            __classPrivateFieldSet(this, _OrderChatModel_totalCount, value, "f");
            __classPrivateFieldGet(this, _OrderChatModel_instances, "m", _OrderChatModel_updateRemainingCounts).call(this);
        }
        get pageIndex() {
            return __classPrivateFieldGet(this, _OrderChatModel_pageIndex, "f");
        }
        set pageIndex(value) {
            __classPrivateFieldSet(this, _OrderChatModel_pageIndex, value, "f");
            __classPrivateFieldGet(this, _OrderChatModel_instances, "m", _OrderChatModel_updateRemainingCounts).call(this);
        }
        get pageSize() {
            return __classPrivateFieldGet(this, _OrderChatModel_pageSize, "f");
        }
        set pageSize(value) {
            __classPrivateFieldSet(this, _OrderChatModel_pageSize, value, "f");
            __classPrivateFieldGet(this, _OrderChatModel_instances, "m", _OrderChatModel_updateRemainingCounts).call(this);
        }
        get remainingPageSize() {
            return __classPrivateFieldGet(this, _OrderChatModel_remainingPageSize, "f");
        }
        get remainingTotalCount() {
            return __classPrivateFieldGet(this, _OrderChatModel_remainingTotalCount, "f");
        }
        constructor(source) {
            _OrderChatModel_instances.add(this);
            // #region Original
            Object.defineProperty(this, "groups", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "canSendMessage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "canChangeObject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "hasUnreadMessages", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "messageObjectItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "messageSubjectItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "visaQuestionItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "visaCities", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pnrItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #endregion
            // #region Additional
            Object.defineProperty(this, "dogovorKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dogovorNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "pnrs", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "messages", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "reply", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #endregion
            _OrderChatModel_totalCount.set(this, 0);
            _OrderChatModel_pageIndex.set(this, 0);
            _OrderChatModel_pageSize.set(this, 1);
            _OrderChatModel_remainingPageSize.set(this, void 0);
            _OrderChatModel_remainingTotalCount.set(this, void 0);
            Object.assign(this, source);
            if (source instanceof OrderChatModel)
                return;
            if (source.pnrItems) {
                this.pnrs = new App.SelectListModel({
                    name: 'Form.Pnr',
                    form: true,
                    autocomplete: false,
                    items: source.pnrItems
                        .map(v => ({
                        value: v.value,
                        text: v.text,
                        selected: v.selected,
                        group: v.group,
                    })),
                });
            }
            // NOTE: все сообщения перекладываю в линейный список (для поиска)
            source.groups
                .flatMap(v => v.messages)
                .forEach(v => this.messages.push(new App.OrderChatMessageModel(v)));
            // NOTE: replies - подцепляю к сообщениям, сообщения на что они были ответом
            // NOTE: и кладу в replyOn - это не событие, это 'ответ НА'
            this.messages.forEach(m => {
                if (m.replyOnKey && m.key != m.replyOnKey)
                    m.replyOn = this.messages.find(p => p.key == m.replyOnKey);
            });
        }
    }
    _OrderChatModel_totalCount = new WeakMap(), _OrderChatModel_pageIndex = new WeakMap(), _OrderChatModel_pageSize = new WeakMap(), _OrderChatModel_remainingPageSize = new WeakMap(), _OrderChatModel_remainingTotalCount = new WeakMap(), _OrderChatModel_instances = new WeakSet(), _OrderChatModel_updateRemainingCounts = function _OrderChatModel_updateRemainingCounts() {
        __classPrivateFieldSet(this, _OrderChatModel_remainingTotalCount, __classPrivateFieldGet(this, _OrderChatModel_totalCount, "f") - (__classPrivateFieldGet(this, _OrderChatModel_pageIndex, "f") + 1) * __classPrivateFieldGet(this, _OrderChatModel_pageSize, "f"), "f");
        if (__classPrivateFieldGet(this, _OrderChatModel_remainingTotalCount, "f") < 0)
            __classPrivateFieldSet(this, _OrderChatModel_remainingTotalCount, 0, "f");
        __classPrivateFieldSet(this, _OrderChatModel_remainingPageSize, Math.min(__classPrivateFieldGet(this, _OrderChatModel_remainingTotalCount, "f"), this.pageSize), "f");
    };
    App.OrderChatModel = OrderChatModel;
})(App || (App = {}));
var App;
(function (App) {
    var _OrderListFilterMobile_instances, _a, _OrderListFilterMobile_tab, _OrderListFilterMobile_searchInput, _OrderListFilterMobile_calendarFrom, _OrderListFilterMobile_calendarTo, _OrderListFilterMobile_calendarCreatedFrom, _OrderListFilterMobile_calendarCreatedTo, _OrderListFilterMobile_calendarCheckoutFrom, _OrderListFilterMobile_calendarCheckoutTo, _OrderListFilterMobile_currentPageSize, _OrderListFilterMobile_currentPageIndex, _OrderListFilterMobile_sortBy, _OrderListFilterMobile_sortDir, _OrderListFilterMobile_partnersBlock, _OrderListFilterMobile_partnersInput, _OrderListFilterMobile_partnersInputId, _OrderListFilterMobile_partnersPlaceholder, _OrderListFilterMobile_options, _OrderListFilterMobile_partnerManagersXhr, _OrderListFilterMobile_getPartnerManagersFilter, _OrderListFilterMobile_createPartnerManagerOption, _OrderListFilterMobile_loadPartnerManagers, _OrderListFilterMobile_setPartnerManagerOptions, _OrderListFilterMobile_resetPartnerManagers, _OrderListFilterMobile_onPartnersInputFocus, _OrderListFilterMobile_onPartnersInputChange, _OrderListFilterMobile_initDates, _OrderListFilterMobile_onTabClick, _OrderListFilterMobile_chooseAllServices, _OrderListFilterMobile_resetCalendars, _OrderListFilterMobile_getOptions, _OrderListFilterMobile_onSearch, _OrderListFilterMobile_setFields;
    class OrderListFilterMobile extends App.MainFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-order-list-filter' }, options));
            _OrderListFilterMobile_instances.add(this);
            // TODO: использовать контрол Tabs или создать его наследника
            _OrderListFilterMobile_tab.set(this, void 0);
            _OrderListFilterMobile_searchInput.set(this, void 0);
            _OrderListFilterMobile_calendarFrom.set(this, void 0);
            _OrderListFilterMobile_calendarTo.set(this, void 0);
            _OrderListFilterMobile_calendarCreatedFrom.set(this, void 0);
            _OrderListFilterMobile_calendarCreatedTo.set(this, void 0);
            _OrderListFilterMobile_calendarCheckoutFrom.set(this, void 0);
            _OrderListFilterMobile_calendarCheckoutTo.set(this, void 0);
            _OrderListFilterMobile_currentPageSize.set(this, void 0);
            _OrderListFilterMobile_currentPageIndex.set(this, void 0);
            _OrderListFilterMobile_sortBy.set(this, void 0);
            _OrderListFilterMobile_sortDir.set(this, void 0);
            _OrderListFilterMobile_partnersBlock.set(this, void 0);
            _OrderListFilterMobile_partnersInput.set(this, void 0);
            // #partnersResults: JQuery;
            _OrderListFilterMobile_partnersInputId.set(this, void 0);
            _OrderListFilterMobile_partnersPlaceholder.set(this, void 0);
            // #partnersAutocomplete: JQuery;
            _OrderListFilterMobile_options.set(this, void 0);
            _OrderListFilterMobile_partnerManagersXhr.set(this, null);
            __classPrivateFieldSet(this, _OrderListFilterMobile_options, options !== null && options !== void 0 ? options : {}, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_initDates).call(this);
            __classPrivateFieldSet(this, _OrderListFilterMobile_partnersBlock, $('.js-partners-block', this.root), "f");
            __classPrivateFieldSet(this, _OrderListFilterMobile_partnersInput, $('.js-partners-input', __classPrivateFieldGet(this, _OrderListFilterMobile_partnersBlock, "f")), "f");
            __classPrivateFieldSet(this, _OrderListFilterMobile_partnersInputId, $('.js-partners-input-id', __classPrivateFieldGet(this, _OrderListFilterMobile_partnersBlock, "f")), "f");
            __classPrivateFieldSet(this, _OrderListFilterMobile_partnersPlaceholder, $('.js-partners-placeholder', __classPrivateFieldGet(this, _OrderListFilterMobile_partnersBlock, "f")), "f");
            __classPrivateFieldGet(this, _OrderListFilterMobile_partnersInput, "f").on('focus', () => __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_onPartnersInputFocus).call(this));
            __classPrivateFieldGet(this, _OrderListFilterMobile_partnersInput, "f").on('change', () => __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_onPartnersInputChange).call(this));
            // тип перелета
            __classPrivateFieldSet(this, _OrderListFilterMobile_tab, $('.js-feed-tab', this.root), "f");
            // Переключаем закладки
            __classPrivateFieldGet(this, _OrderListFilterMobile_tab, "f").on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderListFilterMobile_onTabClick).call(_a, e));
            __classPrivateFieldSet(this, _OrderListFilterMobile_searchInput, $('#m-filter_lk-search'), "f");
            this.root.on('submit', e => __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_onSearch).call(this, e));
            const filterPartnerId = this.filters.findControl('Form.PartnerId');
            if (filterPartnerId) {
                _a.mapAirlinesResponseModel(filterPartnerId);
            }
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this, 'Загрузка...');
            void __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_loadPartnerManagers).call(this, '0');
        }
        onFilterChanged(filterName) {
            const _super = Object.create(null, {
                onFilterChanged: { get: () => super.onFilterChanged }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _b, _c;
                yield _super.onFilterChanged.call(this, filterName);
                if (filterName == 'Form.PartnerId') {
                    const partnerId = (_c = (_b = this.filters.findControl('Form.PartnerId')) === null || _b === void 0 ? void 0 : _b.getValueOrigin()[0]) === null || _c === void 0 ? void 0 : _c.value;
                    __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this, 'Загрузка...');
                    if (!partnerId) {
                        __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this);
                        return;
                    }
                    yield __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_loadPartnerManagers).call(this, partnerId);
                }
            });
        }
        static mapAirlinesResponseModel(filterPartnerId) {
            if (!filterPartnerId)
                return;
            filterPartnerId.setMapDataToItems((response) => {
                if (!response)
                    return [];
                const d = response;
                if (!Array.isArray(d.data))
                    return [];
                const items = d.data.map(item => ({
                    original: Object.assign({}, item),
                    value: item[0],
                    name: `${item[0]} ${item[1]}`,
                    label: `${item[0]} ${item[1]}`,
                    isGroup: false,
                }));
                return items;
            });
        }
        reset() {
            // не нужен вызов базового метода reset, т.к. очищаются списки.
            __classPrivateFieldGet(this, _OrderListFilterMobile_tab, "f").removeClass('_active');
            __classPrivateFieldGet(this, _OrderListFilterMobile_tab, "f").eq(0).addClass('_active');
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetCalendars).call(this);
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_chooseAllServices).call(this);
            __classPrivateFieldGet(this, _OrderListFilterMobile_searchInput, "f").val('');
            $('[data-name="order_services"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="country"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-name="statuses"] .js-filter-option', this.root).eq(0).trigger('click');
            $.each($('.js-filter-sliding-btn-b', this.root), (index, item) => {
                if ($(item).find(':hidden').val() === 'true')
                    $(item).find('.js-sliding-btn').trigger('click');
            });
            __classPrivateFieldGet(this, _OrderListFilterMobile_partnersInputId, "f").val('');
            __classPrivateFieldGet(this, _OrderListFilterMobile_partnersInput, "f").val('');
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this);
            $(this.root.find('.js-filter-hotel-key')).val('');
            this.search();
            // TODO реализовать очистку формы
        }
        setPaging(index, size) {
            __classPrivateFieldSet(this, _OrderListFilterMobile_currentPageIndex, index, "f");
            __classPrivateFieldSet(this, _OrderListFilterMobile_currentPageSize, size, "f");
        }
        setSorting(by, direction) {
            __classPrivateFieldSet(this, _OrderListFilterMobile_sortBy, by, "f");
            __classPrivateFieldSet(this, _OrderListFilterMobile_sortDir, direction, "f");
        }
        // TODO: придумать как обойтись без вызова этого метода в OrderListPage
        getData() {
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_setFields).call(this);
            const elements = this.root.serializeArray();
            const elementsMobile = this.filters.serializeArray();
            const idx = new Map();
            elements.forEach((e, i) => idx.set(e.name, i));
            for (const m of elementsMobile) {
                const i = idx.get(m.name);
                if (i == null) {
                    idx.set(m.name, elements.length);
                    elements.push({ name: m.name, value: m.value });
                }
                else {
                    elements[i].value = m.value;
                }
            }
            const data = {};
            $.each(elements, (i, item) => {
                // skip empty form elements
                if (item.value == null || item.value === '')
                    return true;
                // TODO: детектить тип данных - единичный или множественный и только для множественного делать split.
                data[item.name] = item.value.split(',');
                return undefined;
            });
            return data;
        }
        search() {
            __classPrivateFieldSet(this, _OrderListFilterMobile_currentPageIndex, 0, "f");
            const data = this.getData();
            // TODO: переделать на событие экземпляра текущего класса.
            this.root.trigger("filter:search" /* Events.FilterSearch */, [data]);
        }
    }
    _a = OrderListFilterMobile, _OrderListFilterMobile_tab = new WeakMap(), _OrderListFilterMobile_searchInput = new WeakMap(), _OrderListFilterMobile_calendarFrom = new WeakMap(), _OrderListFilterMobile_calendarTo = new WeakMap(), _OrderListFilterMobile_calendarCreatedFrom = new WeakMap(), _OrderListFilterMobile_calendarCreatedTo = new WeakMap(), _OrderListFilterMobile_calendarCheckoutFrom = new WeakMap(), _OrderListFilterMobile_calendarCheckoutTo = new WeakMap(), _OrderListFilterMobile_currentPageSize = new WeakMap(), _OrderListFilterMobile_currentPageIndex = new WeakMap(), _OrderListFilterMobile_sortBy = new WeakMap(), _OrderListFilterMobile_sortDir = new WeakMap(), _OrderListFilterMobile_partnersBlock = new WeakMap(), _OrderListFilterMobile_partnersInput = new WeakMap(), _OrderListFilterMobile_partnersInputId = new WeakMap(), _OrderListFilterMobile_partnersPlaceholder = new WeakMap(), _OrderListFilterMobile_options = new WeakMap(), _OrderListFilterMobile_partnerManagersXhr = new WeakMap(), _OrderListFilterMobile_instances = new WeakSet(), _OrderListFilterMobile_getPartnerManagersFilter = function _OrderListFilterMobile_getPartnerManagersFilter() {
        var _b;
        return (_b = this.filters.findControl('Form.PartnerManagers')) !== null && _b !== void 0 ? _b : null;
    }, _OrderListFilterMobile_createPartnerManagerOption = function _OrderListFilterMobile_createPartnerManagerOption(value, label, checked = false) {
        return {
            value,
            name: label,
            label,
            checked,
            original: null,
        };
    }, _OrderListFilterMobile_loadPartnerManagers = function _OrderListFilterMobile_loadPartnerManagers(partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            (_b = __classPrivateFieldGet(this, _OrderListFilterMobile_partnerManagersXhr, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            const url = __classPrivateFieldGet(this, _OrderListFilterMobile_options, "f").findPartnerManagersUrl;
            if (!url) {
                __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this, 'Ошибка загрузки');
                return;
            }
            const xhr = $.ajax({
                url,
                method: 'GET',
                data: {
                    partnerId,
                },
            });
            __classPrivateFieldSet(this, _OrderListFilterMobile_partnerManagersXhr, xhr, "f");
            try {
                const response = yield xhr;
                if (!response.data || response.data.length === 0) {
                    __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this, 'Менеджеры не найдены');
                    return;
                }
                __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_setPartnerManagerOptions).call(this, [
                    __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_createPartnerManagerOption).call(this, '', 'Все менеджеры', true),
                    ...response.data.map(([key, name]) => __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_createPartnerManagerOption).call(this, key, name)),
                ]);
            }
            catch (e) {
                if (e.statusText === 'abort')
                    return;
                __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this, 'Ошибка загрузки');
            }
            finally {
                if (__classPrivateFieldGet(this, _OrderListFilterMobile_partnerManagersXhr, "f") === xhr)
                    __classPrivateFieldSet(this, _OrderListFilterMobile_partnerManagersXhr, null, "f");
            }
        });
    }, _OrderListFilterMobile_setPartnerManagerOptions = function _OrderListFilterMobile_setPartnerManagerOptions(items) {
        const filter = __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_getPartnerManagersFilter).call(this);
        if (!filter)
            return;
        filter.setValue(items);
    }, _OrderListFilterMobile_resetPartnerManagers = function _OrderListFilterMobile_resetPartnerManagers(label = 'Все менеджеры') {
        var _b;
        (_b = __classPrivateFieldGet(this, _OrderListFilterMobile_partnerManagersXhr, "f")) === null || _b === void 0 ? void 0 : _b.abort();
        __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_setPartnerManagerOptions).call(this, [
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_createPartnerManagerOption).call(this, '', label, true),
        ]);
    }, _OrderListFilterMobile_onPartnersInputFocus = function _OrderListFilterMobile_onPartnersInputFocus() {
        __classPrivateFieldGet(this, _OrderListFilterMobile_partnersPlaceholder, "f").find('ul').html('');
        __classPrivateFieldGet(this, _OrderListFilterMobile_partnersInput, "f").val('');
        __classPrivateFieldGet(this, _OrderListFilterMobile_partnersInputId, "f").val('');
        __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this);
    }, _OrderListFilterMobile_onPartnersInputChange = function _OrderListFilterMobile_onPartnersInputChange() {
        if (__classPrivateFieldGet(this, _OrderListFilterMobile_partnersInput, "f").val() === '') {
            __classPrivateFieldGet(this, _OrderListFilterMobile_partnersPlaceholder, "f").html('');
            __classPrivateFieldGet(this, _OrderListFilterMobile_instances, "m", _OrderListFilterMobile_resetPartnerManagers).call(this);
        }
    }, _OrderListFilterMobile_initDates = function _OrderListFilterMobile_initDates() {
        // Создаем календарь 'От'
        __classPrivateFieldSet(this, _OrderListFilterMobile_calendarFrom, $('.js-filter-checkin-date-from', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarFrom, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarFrom, "f").datepicker({
            constrainInput: true,
            // события нужны для обновления правой границы интервала
            onSelect: (dateText, inst) => {
                inst.input.trigger('change');
            },
        });
        // Создаем календарь 'До'
        __classPrivateFieldSet(this, _OrderListFilterMobile_calendarTo, $('.js-filter-checkin-date-to', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarTo, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarTo, "f").datepicker({
            constrainInput: true,
        });
        const fromDate = __classPrivateFieldGet(this, _OrderListFilterMobile_calendarFrom, "f").datepicker('getDate');
        if (fromDate)
            __classPrivateFieldGet(this, _OrderListFilterMobile_calendarTo, "f").datepicker('option', 'minDate', fromDate);
        // Создаем календарь 'Создан От'
        __classPrivateFieldSet(this, _OrderListFilterMobile_calendarCreatedFrom, $('.js-filter-created-date-from', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCreatedFrom, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCreatedFrom, "f").datepicker({
            constrainInput: true,
        });
        // Создаем календарь 'Создан До'
        __classPrivateFieldSet(this, _OrderListFilterMobile_calendarCreatedTo, $('.js-filter-created-date-to', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCreatedTo, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCreatedTo, "f").datepicker({
            constrainInput: true,
        });
        // Создаем календарь 'Выезд От'
        __classPrivateFieldSet(this, _OrderListFilterMobile_calendarCheckoutFrom, $('.js-filter-checkout-date-from', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCheckoutFrom, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCheckoutFrom, "f").datepicker({
            constrainInput: true,
            // события нужны для обновления правой границы интервала
            onSelect: (dateText, inst) => {
                inst.input.trigger('change');
            },
        });
        // Создаем календарь 'Выезд До'
        __classPrivateFieldSet(this, _OrderListFilterMobile_calendarCheckoutTo, $('.js-filter-checkout-date-to', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCheckoutTo, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCheckoutTo, "f").datepicker({
            constrainInput: true,
            // события нужны для обновления правой границы интервала
            onSelect: (dateText, inst) => {
                inst.input.trigger('change');
            },
        });
    }, _OrderListFilterMobile_onTabClick = function _OrderListFilterMobile_onTabClick(event) {
        const target = $(event.currentTarget);
        const notActive = !target.hasClass('_active');
        if (notActive) {
            target.siblings('.js-feed-tab').removeClass('_active');
            target.addClass('_active');
        }
    }, _OrderListFilterMobile_chooseAllServices = function _OrderListFilterMobile_chooseAllServices() {
        const servicesBlock = $('.js-services-block', this.root);
        const services = __classPrivateFieldGet(_a, _a, "m", _OrderListFilterMobile_getOptions).call(_a, servicesBlock);
        const input = $('.js-services-input', servicesBlock);
        $(services).each((i, v) => {
            $(v).toggleClass('_off', true);
        });
        // если выбраны все опции, передаем на сервер пустое множество
        const valuesStr = '';
        input
            .val(valuesStr)
            .attr('value', valuesStr);
    }, _OrderListFilterMobile_resetCalendars = function _OrderListFilterMobile_resetCalendars() {
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarFrom, "f").datepicker('setDate', new Date());
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarTo, "f").datepicker('setDate', null);
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCheckoutFrom, "f").datepicker('setDate', null);
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCheckoutTo, "f").datepicker('setDate', null);
        const minDate = new Date();
        minDate.setDate(minDate.getDate() + App.OrderListFilter.checkinMinDateShift);
        // сбрасываем минимально возможную дату у правой границы.
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarTo, "f").datepicker('option', 'minDate', minDate);
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCreatedFrom, "f").datepicker('setDate', null);
        __classPrivateFieldGet(this, _OrderListFilterMobile_calendarCreatedTo, "f").datepicker('setDate', null);
    }, _OrderListFilterMobile_getOptions = function _OrderListFilterMobile_getOptions(container) {
        return $('.js-service-item', container);
    }, _OrderListFilterMobile_onSearch = function _OrderListFilterMobile_onSearch(event) {
        event.preventDefault();
        this.search();
    }, _OrderListFilterMobile_setFields = function _OrderListFilterMobile_setFields() {
        $(':hidden[name$="NumberOrTouristName"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilterMobile_searchInput, "f").val() || '');
        $(':hidden[name$="PageSize"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilterMobile_currentPageSize, "f"));
        $(':hidden[name$="PageIndex"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilterMobile_currentPageIndex, "f"));
        $(':hidden[name$="SortBy"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilterMobile_sortBy, "f"));
        $(':hidden[name$="SortDir"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilterMobile_sortDir, "f"));
    };
    // 5лет - вполне достаточно, чтобы дата окончания тура попала в 3хлетний интервал.
    Object.defineProperty(OrderListFilterMobile, "checkinMinDateShift", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: -1825
    });
    App.OrderListFilterMobile = OrderListFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _OrderListFilter_instances, _a, _OrderListFilter_tab, _OrderListFilter_searchInput, _OrderListFilter_calendarFrom, _OrderListFilter_calendarTo, _OrderListFilter_calendarCreatedFrom, _OrderListFilter_calendarCreatedTo, _OrderListFilter_calendarCheckoutFrom, _OrderListFilter_calendarCheckoutTo, _OrderListFilter_currentPageSize, _OrderListFilter_currentPageIndex, _OrderListFilter_sortBy, _OrderListFilter_sortDir, _OrderListFilter_partnersBlock, _OrderListFilter_partnersInput, _OrderListFilter_partnersResults, _OrderListFilter_partnersInputId, _OrderListFilter_partnersPlaceholder, _OrderListFilter_partnersAutocomplete, _OrderListFilter_partnerManagersBlock, _OrderListFilter_partnerManagersXhr, _OrderListFilter_loadPartnerManagers, _OrderListFilter_getPartnerManagersControl, _OrderListFilter_renderPartnerManagers, _OrderListFilter_resetPartnerManagers, _OrderListFilter_setPartnerManagersEnabled, _OrderListFilter_onPartnersInputFocus, _OrderListFilter_onPartnersInputChange, _OrderListFilter_onFilterChange, _OrderListFilter_initDates, _OrderListFilter_onTabClick, _OrderListFilter_onSearchInputEnter, _OrderListFilter_chooseAllServices, _OrderListFilter_resetCalendars, _OrderListFilter_getOptions, _OrderListFilter_onSearch, _OrderListFilter_setFields;
    class OrderListFilter extends App.MainFilter {
        constructor(options) {
            super(Object.assign({ root: '.js-order-list-filter' }, options));
            _OrderListFilter_instances.add(this);
            // TODO: использовать контрол Tabs или создать его наследника
            _OrderListFilter_tab.set(this, void 0);
            _OrderListFilter_searchInput.set(this, void 0);
            _OrderListFilter_calendarFrom.set(this, void 0);
            _OrderListFilter_calendarTo.set(this, void 0);
            _OrderListFilter_calendarCreatedFrom.set(this, void 0);
            _OrderListFilter_calendarCreatedTo.set(this, void 0);
            _OrderListFilter_calendarCheckoutFrom.set(this, void 0);
            _OrderListFilter_calendarCheckoutTo.set(this, void 0);
            _OrderListFilter_currentPageSize.set(this, void 0);
            _OrderListFilter_currentPageIndex.set(this, void 0);
            _OrderListFilter_sortBy.set(this, void 0);
            _OrderListFilter_sortDir.set(this, void 0);
            _OrderListFilter_partnersBlock.set(this, void 0);
            _OrderListFilter_partnersInput.set(this, void 0);
            _OrderListFilter_partnersResults.set(this, void 0);
            _OrderListFilter_partnersInputId.set(this, void 0);
            _OrderListFilter_partnersPlaceholder.set(this, void 0);
            _OrderListFilter_partnersAutocomplete.set(this, void 0);
            _OrderListFilter_partnerManagersBlock.set(this, void 0);
            _OrderListFilter_partnerManagersXhr.set(this, null);
            if (!this.root.length)
                return;
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_initDates).call(this);
            __classPrivateFieldSet(this, _OrderListFilter_partnersBlock, $('.js-partners-block', this.root), "f");
            __classPrivateFieldSet(this, _OrderListFilter_partnersInput, $('.js-partners-input', __classPrivateFieldGet(this, _OrderListFilter_partnersBlock, "f")), "f");
            __classPrivateFieldSet(this, _OrderListFilter_partnersResults, __classPrivateFieldGet(this, _OrderListFilter_partnersBlock, "f").find('.js-partners-results'), "f");
            __classPrivateFieldSet(this, _OrderListFilter_partnersInputId, $('.js-partners-input-id', __classPrivateFieldGet(this, _OrderListFilter_partnersBlock, "f")), "f");
            __classPrivateFieldSet(this, _OrderListFilter_partnersPlaceholder, $('.js-partners-placeholder', __classPrivateFieldGet(this, _OrderListFilter_partnersBlock, "f")), "f");
            __classPrivateFieldSet(this, _OrderListFilter_partnersAutocomplete, $('.js-partners-autocomplete', __classPrivateFieldGet(this, _OrderListFilter_partnersBlock, "f")), "f");
            __classPrivateFieldSet(this, _OrderListFilter_partnerManagersBlock, $('.js-partner-managers-block', this.root), "f");
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this, 'Загрузка...');
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
            void __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_loadPartnerManagers).call(this, '0');
            const scrollerWrap = $('.js-scroller-wrap', this.root);
            // Стилизуем скролл
            const scroll = scrollerWrap.baron({
                scroller: '.js-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").autocomplete({
                minLength: 3,
                appendTo: __classPrivateFieldGet(this, _OrderListFilter_partnersResults, "f"),
                source: (request, response) => {
                    /* eslint-disable @typescript-eslint/no-floating-promises */
                    $.ajax({
                        url: $(__classPrivateFieldGet(this, _OrderListFilter_partnersBlock, "f")).attr('data-partners'),
                        method: 'GET',
                        data: {
                            'search': request.term,
                        },
                        success: (data) => {
                            response(data.data.map(v => ({ key: v[0], name: `${v[1]} (${v[0]})` })));
                        },
                    });
                    /* eslint-enable @typescript-eslint/no-floating-promises */
                },
                // Добавляем подсказку ввода внутрь инпута
                response: (_, ui) => {
                    if (ui.content.length === 0) {
                        __classPrivateFieldGet(this, _OrderListFilter_partnersInputId, "f").val('');
                        return;
                    }
                    const result = ui.content[0];
                    const searchValue = __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").valString();
                    let hint;
                    if (result) {
                        __classPrivateFieldGet(this, _OrderListFilter_partnersAutocomplete, "f").show();
                        hint = result.name;
                    }
                    else {
                        hint = '';
                    }
                    scroll.update();
                    const hintBegin = hint.substring(0, searchValue.length);
                    if (hintBegin.toUpperCase() === searchValue.toUpperCase())
                        __classPrivateFieldGet(this, _OrderListFilter_partnersPlaceholder, "f").html(`<span>${searchValue}</span>${hint.substring(searchValue.length)}`);
                    else
                        __classPrivateFieldGet(this, _OrderListFilter_partnersPlaceholder, "f").html('');
                },
                // Убираем подсказку из инпута, при выборе результата
                select: (event, ui) => {
                    event.preventDefault();
                    const key = ui.item.key;
                    const value = ui.item.name;
                    __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").val(value);
                    __classPrivateFieldGet(this, _OrderListFilter_partnersInputId, "f").val(key);
                    __classPrivateFieldGet(this, _OrderListFilter_partnersAutocomplete, "f").hide();
                    __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this, 'Загрузка...');
                    __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
                    void __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_loadPartnerManagers).call(this, key);
                },
                focus: (_, ui) => {
                    const result = ui.item.name;
                    const searchValue = __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").valString();
                    let hint;
                    if (result)
                        hint = result;
                    else
                        hint = '';
                    if (hint.toUpperCase() === searchValue.toUpperCase())
                        __classPrivateFieldGet(this, _OrderListFilter_partnersPlaceholder, "f").html(hint);
                    else
                        __classPrivateFieldGet(this, _OrderListFilter_partnersPlaceholder, "f").html('');
                },
            });
            __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").on('click', () => __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_onPartnersInputFocus).call(this));
            __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").on('change', () => __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_onPartnersInputChange).call(this));
            // тип перелета
            __classPrivateFieldSet(this, _OrderListFilter_tab, $('.js-feed-tab', this.root), "f");
            // Переключаем закладки
            __classPrivateFieldGet(this, _OrderListFilter_tab, "f").on('click', e => __classPrivateFieldGet(_a, _a, "m", _OrderListFilter_onTabClick).call(_a, e));
            __classPrivateFieldSet(this, _OrderListFilter_searchInput, $('#m-filter_lk-search'), "f");
            __classPrivateFieldGet(this, _OrderListFilter_searchInput, "f").on('keypress', e => __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_onSearchInputEnter).call(this, e));
            this.root.on('submit', e => __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_onSearch).call(this, e));
            this.root.on("filter:change" /* Events.FilterChange */, (_, data) => __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_onFilterChange).call(this, data));
        }
        reset() {
            // не нужен вызов базового метода reset, т.к. очищаются списки.
            __classPrivateFieldGet(this, _OrderListFilter_tab, "f").removeClass('_active');
            __classPrivateFieldGet(this, _OrderListFilter_tab, "f").eq(0).addClass('_active');
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetCalendars).call(this);
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_chooseAllServices).call(this);
            __classPrivateFieldGet(this, _OrderListFilter_searchInput, "f").val('');
            $('[data-name="order_services"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-select="country"] .js-filter-option', this.root).eq(0).trigger('click');
            $('[data-name="statuses"] .js-filter-option', this.root).eq(0).trigger('click');
            $.each($('.js-filter-sliding-btn-b', this.root), (index, item) => {
                if ($(item).find(':hidden').val() === 'true')
                    $(item).find('.js-sliding-btn').trigger('click');
            });
            __classPrivateFieldGet(this, _OrderListFilter_partnersInputId, "f").val('');
            __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").val('');
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this);
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
            $(this.root.find('.js-filter-hotel-key')).val('');
            this.search();
            // TODO реализовать очистку формы
        }
        setPaging(index, size) {
            __classPrivateFieldSet(this, _OrderListFilter_currentPageIndex, index, "f");
            __classPrivateFieldSet(this, _OrderListFilter_currentPageSize, size, "f");
        }
        setSorting(by, direction) {
            __classPrivateFieldSet(this, _OrderListFilter_sortBy, by, "f");
            __classPrivateFieldSet(this, _OrderListFilter_sortDir, direction, "f");
        }
        // TODO: придумать как обойтись без вызова этого метода в OrderListPage
        getData() {
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setFields).call(this);
            const elements = this.root.serializeArray();
            const data = {};
            $.each(elements, (i, item) => {
                // skip empty form elements
                if (item.value == null || item.value === '')
                    return true;
                // TODO: детектить тип данных - единичный или множественный и только для множественного делать split.
                data[item.name] = item.value.split(',');
                return undefined;
            });
            return data;
        }
        search() {
            __classPrivateFieldSet(this, _OrderListFilter_currentPageIndex, 0, "f");
            const data = this.getData();
            // TODO: переделать на событие экземпляра текущего класса.
            this.root.trigger("filter:search" /* Events.FilterSearch */, [data]);
        }
    }
    _a = OrderListFilter, _OrderListFilter_tab = new WeakMap(), _OrderListFilter_searchInput = new WeakMap(), _OrderListFilter_calendarFrom = new WeakMap(), _OrderListFilter_calendarTo = new WeakMap(), _OrderListFilter_calendarCreatedFrom = new WeakMap(), _OrderListFilter_calendarCreatedTo = new WeakMap(), _OrderListFilter_calendarCheckoutFrom = new WeakMap(), _OrderListFilter_calendarCheckoutTo = new WeakMap(), _OrderListFilter_currentPageSize = new WeakMap(), _OrderListFilter_currentPageIndex = new WeakMap(), _OrderListFilter_sortBy = new WeakMap(), _OrderListFilter_sortDir = new WeakMap(), _OrderListFilter_partnersBlock = new WeakMap(), _OrderListFilter_partnersInput = new WeakMap(), _OrderListFilter_partnersResults = new WeakMap(), _OrderListFilter_partnersInputId = new WeakMap(), _OrderListFilter_partnersPlaceholder = new WeakMap(), _OrderListFilter_partnersAutocomplete = new WeakMap(), _OrderListFilter_partnerManagersBlock = new WeakMap(), _OrderListFilter_partnerManagersXhr = new WeakMap(), _OrderListFilter_instances = new WeakSet(), _OrderListFilter_loadPartnerManagers = function _OrderListFilter_loadPartnerManagers(partnerId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            (_b = __classPrivateFieldGet(this, _OrderListFilter_partnerManagersXhr, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            if (!partnerId) {
                __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this);
                __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
                return;
            }
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _OrderListFilter_partnerManagersBlock, "f").attr('data-managers'),
                method: 'GET',
                data: {
                    partnerId,
                },
            });
            __classPrivateFieldSet(this, _OrderListFilter_partnerManagersXhr, xhr, "f");
            try {
                const response = yield xhr;
                if (response.data.length === 0) {
                    __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this, 'Менеджеры не найдены');
                    __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
                    return;
                }
                __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_renderPartnerManagers).call(this, response.data);
                __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, true);
            }
            catch (e) {
                if (e.statusText === 'abort')
                    return;
                __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this, 'Ошибка загрузки');
                __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
            }
            finally {
                if (__classPrivateFieldGet(this, _OrderListFilter_partnerManagersXhr, "f") === xhr)
                    __classPrivateFieldSet(this, _OrderListFilter_partnerManagersXhr, null, "f");
            }
        });
    }, _OrderListFilter_getPartnerManagersControl = function _OrderListFilter_getPartnerManagersControl() {
        const control = this.findControl('Form.PartnerManagers');
        return control !== null && control !== void 0 ? control : null;
    }, _OrderListFilter_renderPartnerManagers = function _OrderListFilter_renderPartnerManagers(items) {
        const control = __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_getPartnerManagersControl).call(this);
        if (!control)
            return;
        const options = [
            {
                value: '',
                text: 'Все менеджеры',
                selected: true,
            },
            ...items.map(([key, name]) => ({
                value: key,
                text: name,
                selected: false,
            })),
        ];
        control.replaceOptions(options, false);
    }, _OrderListFilter_resetPartnerManagers = function _OrderListFilter_resetPartnerManagers(text = 'Выберите менеджера') {
        var _b;
        (_b = __classPrivateFieldGet(this, _OrderListFilter_partnerManagersXhr, "f")) === null || _b === void 0 ? void 0 : _b.abort();
        const control = __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_getPartnerManagersControl).call(this);
        if (!control)
            return;
        const defaultOption = {
            value: '',
            text,
            selected: true,
        };
        control.replaceOptions([defaultOption]);
    }, _OrderListFilter_setPartnerManagersEnabled = function _OrderListFilter_setPartnerManagersEnabled(enabled) {
        __classPrivateFieldGet(this, _OrderListFilter_partnerManagersBlock, "f").toggleClass('_disabled', !enabled);
    }, _OrderListFilter_onPartnersInputFocus = function _OrderListFilter_onPartnersInputFocus() {
        __classPrivateFieldGet(this, _OrderListFilter_partnersPlaceholder, "f").find('ul').html('');
        __classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").val('');
        __classPrivateFieldGet(this, _OrderListFilter_partnersInputId, "f").val('');
        __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this);
        __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
    }, _OrderListFilter_onPartnersInputChange = function _OrderListFilter_onPartnersInputChange() {
        if (__classPrivateFieldGet(this, _OrderListFilter_partnersInput, "f").val() === '') {
            __classPrivateFieldGet(this, _OrderListFilter_partnersPlaceholder, "f").html('');
            __classPrivateFieldGet(this, _OrderListFilter_partnersInputId, "f").val('');
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_resetPartnerManagers).call(this);
            __classPrivateFieldGet(this, _OrderListFilter_instances, "m", _OrderListFilter_setPartnerManagersEnabled).call(this, false);
        }
    }, _OrderListFilter_onFilterChange = function _OrderListFilter_onFilterChange(data) {
        if (data.instance.name === 'Form.ShowUnpaid') {
            const sourceValue = data.instance.getValue();
            const target = this.findControl('Form.ShowOverpaid');
            if (sourceValue && (target === null || target === void 0 ? void 0 : target.getValue()))
                target.setValue(false);
        }
        else if (data.instance.name === 'Form.ShowOverpaid') {
            const sourceValue = data.instance.getValue();
            const target = this.findControl('Form.ShowUnpaid');
            if (sourceValue && (target === null || target === void 0 ? void 0 : target.getValue()))
                target.setValue(false);
        }
    }, _OrderListFilter_initDates = function _OrderListFilter_initDates() {
        // Создаем календарь 'От'
        __classPrivateFieldSet(this, _OrderListFilter_calendarFrom, $('.js-filter-checkin-date-from', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilter_calendarFrom, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilter_calendarFrom, "f").datepicker({
            constrainInput: true,
            // события нужны для обновления правой границы интервала
            onSelect: (dateText, inst) => {
                inst.input.trigger('change');
            },
        });
        // Создаем календарь 'До'
        __classPrivateFieldSet(this, _OrderListFilter_calendarTo, $('.js-filter-checkin-date-to', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilter_calendarTo, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilter_calendarTo, "f").datepicker({
            constrainInput: true,
        });
        const fromDate = __classPrivateFieldGet(this, _OrderListFilter_calendarFrom, "f").datepicker('getDate');
        if (fromDate)
            __classPrivateFieldGet(this, _OrderListFilter_calendarTo, "f").datepicker('option', 'minDate', fromDate);
        // Создаем календарь 'Создан От'
        __classPrivateFieldSet(this, _OrderListFilter_calendarCreatedFrom, $('.js-filter-created-date-from', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilter_calendarCreatedFrom, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilter_calendarCreatedFrom, "f").datepicker({
            constrainInput: true,
        });
        // Создаем календарь 'Создан До'
        __classPrivateFieldSet(this, _OrderListFilter_calendarCreatedTo, $('.js-filter-created-date-to', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilter_calendarCreatedTo, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilter_calendarCreatedTo, "f").datepicker({
            constrainInput: true,
        });
        // Создаем календарь 'Выезд От'
        __classPrivateFieldSet(this, _OrderListFilter_calendarCheckoutFrom, $('.js-filter-checkout-date-from', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilter_calendarCheckoutFrom, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilter_calendarCheckoutFrom, "f").datepicker({
            constrainInput: true,
            // события нужны для обновления правой границы интервала
            onSelect: (dateText, inst) => {
                inst.input.trigger('change');
            },
        });
        // Создаем календарь 'Выезд До'
        __classPrivateFieldSet(this, _OrderListFilter_calendarCheckoutTo, $('.js-filter-checkout-date-to', this.root), "f");
        __classPrivateFieldGet(this, _OrderListFilter_calendarCheckoutTo, "f")
            .attr('autocomplete', 'off')
            .inputmask('date');
        __classPrivateFieldGet(this, _OrderListFilter_calendarCheckoutTo, "f").datepicker({
            constrainInput: true,
            // события нужны для обновления правой границы интервала
            onSelect: (dateText, inst) => {
                inst.input.trigger('change');
            },
        });
    }, _OrderListFilter_onTabClick = function _OrderListFilter_onTabClick(event) {
        const target = $(event.currentTarget);
        const notActive = !target.hasClass('_active');
        if (notActive) {
            target.siblings('.js-feed-tab').removeClass('_active');
            target.addClass('_active');
        }
    }, _OrderListFilter_onSearchInputEnter = function _OrderListFilter_onSearchInputEnter(event) {
        if (event.which === 13) {
            this.root.trigger('submit');
            return false;
        }
        return undefined;
    }, _OrderListFilter_chooseAllServices = function _OrderListFilter_chooseAllServices() {
        const servicesBlock = $('.js-services-block', this.root);
        const services = __classPrivateFieldGet(_a, _a, "m", _OrderListFilter_getOptions).call(_a, servicesBlock);
        const input = $('.js-services-input', servicesBlock);
        $(services).each((i, v) => {
            $(v).toggleClass('_off', true);
            // that.setServiceType(servicesBlock, $(v), true);
        });
        // если выбраны все опции, передаем на сервер пустое множество
        const valuesStr = '';
        input
            .val(valuesStr)
            .attr('value', valuesStr);
    }, _OrderListFilter_resetCalendars = function _OrderListFilter_resetCalendars() {
        __classPrivateFieldGet(this, _OrderListFilter_calendarFrom, "f").datepicker('setDate', new Date());
        __classPrivateFieldGet(this, _OrderListFilter_calendarTo, "f").datepicker('setDate', null);
        __classPrivateFieldGet(this, _OrderListFilter_calendarCheckoutFrom, "f").datepicker('setDate', null);
        __classPrivateFieldGet(this, _OrderListFilter_calendarCheckoutTo, "f").datepicker('setDate', null);
        const minDate = new Date();
        minDate.setDate(minDate.getDate() + _a.checkinMinDateShift);
        // сбрасываем минимально возможную дату у правой границы.
        __classPrivateFieldGet(this, _OrderListFilter_calendarTo, "f").datepicker('option', 'minDate', minDate);
        __classPrivateFieldGet(this, _OrderListFilter_calendarCreatedFrom, "f").datepicker('setDate', null);
        __classPrivateFieldGet(this, _OrderListFilter_calendarCreatedTo, "f").datepicker('setDate', null);
    }, _OrderListFilter_getOptions = function _OrderListFilter_getOptions(container) {
        return $('.js-service-item', container);
    }, _OrderListFilter_onSearch = function _OrderListFilter_onSearch(event) {
        event.preventDefault();
        this.search();
    }, _OrderListFilter_setFields = function _OrderListFilter_setFields() {
        $(':hidden[name$="NumberOrTouristName"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilter_searchInput, "f").val() || '');
        $(':hidden[name$="PageSize"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilter_currentPageSize, "f"));
        $(':hidden[name$="PageIndex"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilter_currentPageIndex, "f"));
        $(':hidden[name$="SortBy"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilter_sortBy, "f"));
        $(':hidden[name$="SortDir"]', this.root).val(__classPrivateFieldGet(this, _OrderListFilter_sortDir, "f"));
    };
    // 5лет - вполне достаточно, чтобы дата окончания тура попала в 3хлетний интервал.
    Object.defineProperty(OrderListFilter, "checkinMinDateShift", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: -1825
    });
    App.OrderListFilter = OrderListFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileAccountPage_instances, _ProfileAccountPage_options, _ProfileAccountPage_hotFilter, _ProfileAccountPage_result, _ProfileAccountPage_searchResultsWrapClass, _ProfileAccountPage_form, _ProfileAccountPage_bookFilter, _ProfileAccountPage_formEdit, _ProfileAccountPage_roles, _ProfileAccountPage_searchXhr, _ProfileAccountPage_preloader, _ProfileAccountPage_userData, _ProfileAccountPage_responseValidator, _ProfileAccountPage_responseValidatorForm, _ProfileAccountPage_updateUserKey, _ProfileAccountPage_initScripts, _ProfileAccountPage_saveUser, _ProfileAccountPage_getUsers, _ProfileAccountPage_getUser, _ProfileAccountPage_checkLogin, _ProfileAccountPage_updateUser, _ProfileAccountPage_onShowUserFormClick, _ProfileAccountPage_onCheckLoginInput, _ProfileAccountPage_onSearchUserInput, _ProfileAccountPage_onClearUserClick, _ProfileAccountPage_onChangeStatusClick, _ProfileAccountPage_onSaveUserClick;
    class ProfileAccountPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.lk-agent-page' }, options));
            _ProfileAccountPage_instances.add(this);
            _ProfileAccountPage_options.set(this, void 0);
            _ProfileAccountPage_hotFilter.set(this, void 0);
            _ProfileAccountPage_result.set(this, void 0);
            _ProfileAccountPage_searchResultsWrapClass.set(this, void 0);
            _ProfileAccountPage_form.set(this, void 0);
            _ProfileAccountPage_bookFilter.set(this, void 0);
            _ProfileAccountPage_formEdit.set(this, void 0);
            _ProfileAccountPage_roles.set(this, void 0);
            _ProfileAccountPage_searchXhr.set(this, void 0);
            _ProfileAccountPage_preloader.set(this, void 0);
            _ProfileAccountPage_userData.set(this, void 0);
            _ProfileAccountPage_responseValidator.set(this, void 0);
            _ProfileAccountPage_responseValidatorForm.set(this, void 0);
            _ProfileAccountPage_updateUserKey.set(this, void 0);
            __classPrivateFieldSet(this, _ProfileAccountPage_options, options, "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_roles, __classPrivateFieldGet(this, _ProfileAccountPage_options, "f").roles, "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_searchResultsWrapClass, '.js-account-search-results', "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_hotFilter, new App.ProfileAccountHotFilter({ root: '.js-account-hot-filter' }), "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_result, new App.ProfileAccountResult({ root: __classPrivateFieldGet(this, _ProfileAccountPage_searchResultsWrapClass, "f"), hotFilter: __classPrivateFieldGet(this, _ProfileAccountPage_hotFilter, "f") }), "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_preloader, new App.Preloader(), "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.BlockMessenger(new App.Messages({ root: '.js-messages-error' })),
            }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _ProfileAccountPage_searchXhr, "f").abort();
                    inst.hide();
                }
            });
            this.components.push(new App.ActionInfoComponent());
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_getUsers).call(this); }))();
            $('#searchUser').on('input', e => __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_onSearchUserInput).call(this, e));
            $('#clearSearchUser').on('click', () => __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_onClearUserClick).call(this));
            $(__classPrivateFieldGet(this, _ProfileAccountPage_searchResultsWrapClass, "f")).on('click', '.js-edit-user', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_onShowUserFormClick).call(this, e); }));
            $('#addUser').on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_onShowUserFormClick).call(this, e); }));
        }
    }
    _ProfileAccountPage_options = new WeakMap(), _ProfileAccountPage_hotFilter = new WeakMap(), _ProfileAccountPage_result = new WeakMap(), _ProfileAccountPage_searchResultsWrapClass = new WeakMap(), _ProfileAccountPage_form = new WeakMap(), _ProfileAccountPage_bookFilter = new WeakMap(), _ProfileAccountPage_formEdit = new WeakMap(), _ProfileAccountPage_roles = new WeakMap(), _ProfileAccountPage_searchXhr = new WeakMap(), _ProfileAccountPage_preloader = new WeakMap(), _ProfileAccountPage_userData = new WeakMap(), _ProfileAccountPage_responseValidator = new WeakMap(), _ProfileAccountPage_responseValidatorForm = new WeakMap(), _ProfileAccountPage_updateUserKey = new WeakMap(), _ProfileAccountPage_instances = new WeakSet(), _ProfileAccountPage_initScripts = function _ProfileAccountPage_initScripts() {
        const filterSlidingBtn = $(__classPrivateFieldGet(this, _ProfileAccountPage_searchResultsWrapClass, "f")).find('.js-filter-sliding-btn-b');
        filterSlidingBtn.each((i, v) => { this.components.push(new App.FilterSlidingButtonBlock({ root: $(v) })); });
        $(__classPrivateFieldGet(this, _ProfileAccountPage_searchResultsWrapClass, "f")).on('click', '.js-sliding-btn', e => __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_onChangeStatusClick).call(this, e));
    }, _ProfileAccountPage_saveUser = function _ProfileAccountPage_saveUser(data, responseValidator, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: '/my/profile/saveuser/',
                method: 'POST',
                data,
            });
            try {
                const response = yield xhr;
                const validated = responseValidator.process(response);
                __classPrivateFieldSet(this, _ProfileAccountPage_updateUserKey, response.data.key, "f");
                if (validated && callback !== undefined) {
                    yield callback();
                }
            }
            catch (ex) {
                if (!responseValidator.processError(ex))
                    throw ex;
            }
        });
    }, _ProfileAccountPage_getUsers = function _ProfileAccountPage_getUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _ProfileAccountPage_preloader, "f").show();
            __classPrivateFieldSet(this, _ProfileAccountPage_searchXhr, $.ajax({
                url: '/my/profile/getusers/',
                method: 'POST',
            }), "f");
            try {
                const response = yield __classPrivateFieldGet(this, _ProfileAccountPage_searchXhr, "f");
                if (!__classPrivateFieldGet(this, _ProfileAccountPage_responseValidator, "f").process(response))
                    return;
                yield __classPrivateFieldGet(this, _ProfileAccountPage_result, "f").changeDataSource(response.data.users);
                __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_initScripts).call(this);
                return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ProfileAccountPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _ProfileAccountPage_preloader, "f").hide();
            }
        });
    }, _ProfileAccountPage_getUser = function _ProfileAccountPage_getUser(key, needUpdateUserData) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: '/my/profile/getuser/',
                method: 'POST',
                data: { key: key },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _ProfileAccountPage_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldSet(this, _ProfileAccountPage_userData, response.data.user, "f");
                if (needUpdateUserData) {
                    __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_updateUser).call(this, __classPrivateFieldGet(this, _ProfileAccountPage_userData, "f"));
                }
                return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ProfileAccountPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _ProfileAccountPage_checkLogin = function _ProfileAccountPage_checkLogin(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const xhr = $.ajax({
                url: '/my/profile/checklogin/',
                method: 'POST',
                data: { login: value },
            });
            let success = false;
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _ProfileAccountPage_responseValidatorForm, "f").process(response))
                    return false;
                success = response.data.status;
                if (success && value.length > 2) {
                    $('.js-login-error', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f")).removeClass('_invalid-login');
                    $('.js-login-error', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f")).addClass('_valid-login');
                    $('.js-login-error-text').html('Логин свободен');
                }
                else {
                    $('.js-login-error', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f")).removeClass('_valid-login');
                    $('.js-login-error', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f")).addClass('_invalid-login');
                    $('.js-login-error-text').html('Логин занят');
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ProfileAccountPage_responseValidatorForm, "f").processError(ex))
                    throw ex;
            }
            return success;
        });
    }, _ProfileAccountPage_updateUser = function _ProfileAccountPage_updateUser(user) {
        const userBlock = $('.js-lk-employee-block[data-userkey="' + user.key + '"]', this.root);
        let userBlockWrap = userBlock.parent();
        if (userBlock.length == 0) {
            $('.js-tours-output-table', this.root).append('<div class="js-lk-employee-block-wrap"></div>');
            userBlockWrap = $('.js-lk-employee-block-wrap', '.js-tours-output-table').last();
        }
        userBlockWrap.empty();
        const contentContent = $(App.templates.Profile.UserData(user));
        userBlockWrap.append(contentContent);
        const filterSlidingBtn = userBlockWrap.find('.js-filter-sliding-btn-b');
        this.components.push(new App.FilterSlidingButtonBlock({ root: $(filterSlidingBtn) }));
    }, _ProfileAccountPage_onShowUserFormClick = function _ProfileAccountPage_onShowUserFormClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if ($('.js-tours-output-table .js-user-form-wrap[data-userkey]', this.root).length > 0) {
                App.popupShow($('<div>Закройте предыдущее редактирование, пожалуйста!</div>'));
                return;
            }
            const id = Number($(event.currentTarget).attr('data-userKey')) || null;
            let rolesSelected = [];
            const roles = __classPrivateFieldGet(this, _ProfileAccountPage_roles, "f");
            if (id != null) {
                yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_getUser).call(this, id, false);
                if (__classPrivateFieldGet(this, _ProfileAccountPage_userData, "f") != undefined) {
                    rolesSelected = Enumerable.from(__classPrivateFieldGet(this, _ProfileAccountPage_userData, "f").roles)
                        .selectMany(v => v.items)
                        .select(v => v.key)
                        .toArray();
                }
            }
            const dialog = $(App.templates.Profile.UserForm({
                roles: roles,
                id,
                userData: __classPrivateFieldGet(this, _ProfileAccountPage_userData, "f"),
                isNew: id == null,
                rolesSelected: rolesSelected,
            }));
            if (id != null) {
                const userBlock = $('.js-lk-employee-block[data-userkey="' + id + '"]', this.root);
                const userBlockWrap = userBlock.parent();
                userBlockWrap.after(dialog);
            }
            else {
                App.popupShow(dialog, 'Добавить нового пользователя');
            }
            __classPrivateFieldSet(this, _ProfileAccountPage_formEdit, $('.js-user-form', dialog), "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_bookFilter, new App.Filter({ root: __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f") }), "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_form, new App.Form({ root: __classPrivateFieldGet(this, _ProfileAccountPage_bookFilter, "f").root }), "f");
            __classPrivateFieldSet(this, _ProfileAccountPage_responseValidatorForm, new App.ResponseValidatorOld({
                messenger: new App.BlockMessenger(new App.Messages({ root: '.js-messages-error-save' })),
                validator: __classPrivateFieldGet(this, _ProfileAccountPage_form, "f").validator,
            }), "f");
            $('.js-save-user', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f")).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_onSaveUserClick).call(this, e, id); }));
            $('.js-check-login', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f")).on('input', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_onCheckLoginInput).call(this, e); }));
            if (id != null) {
                $('.js-popup-close', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f")).on('click', () => {
                    __classPrivateFieldSet(this, _ProfileAccountPage_userData, undefined, "f");
                    __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f").parent().remove();
                });
            }
            const calendarIcons = $('.js-filter-date-from-icon', __classPrivateFieldGet(this, _ProfileAccountPage_formEdit, "f"));
            calendarIcons.on('click', (e) => {
                $(e.currentTarget).prev('.js-form-date').trigger('focus');
            });
        });
    }, _ProfileAccountPage_onCheckLoginInput = function _ProfileAccountPage_onCheckLoginInput(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const val = $(event.currentTarget).valString();
            if (val.length < 3)
                return;
            yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_checkLogin).call(this, val);
        });
    }, _ProfileAccountPage_onSearchUserInput = function _ProfileAccountPage_onSearchUserInput(event) {
        const target = $(event.currentTarget);
        const value = String(target.val() || '');
        if (value.length < 3)
            return;
        __classPrivateFieldGet(this, _ProfileAccountPage_hotFilter, "f").root.trigger("filter:change" /* Events.FilterChange */);
    }, _ProfileAccountPage_onClearUserClick = function _ProfileAccountPage_onClearUserClick() {
        $('#searchUser', this.root).val('');
        __classPrivateFieldGet(this, _ProfileAccountPage_hotFilter, "f").root.trigger("filter:change" /* Events.FilterChange */);
    }, _ProfileAccountPage_onChangeStatusClick = function _ProfileAccountPage_onChangeStatusClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const root = $(event.currentTarget).parent('.js-filter-sliding-btn-b');
            const id = Number(root.find('input').attr('data-userKey')) || null;
            if (id == null)
                return;
            const data = [{ name: 'Key', value: id.toString() }, { name: 'Status', value: root.find('input').valString() == 'true' ? '1' : '0' }];
            yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_saveUser).call(this, data, __classPrivateFieldGet(this, _ProfileAccountPage_responseValidator, "f"), () => __awaiter(this, void 0, void 0, function* () {
                yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_getUser).call(this, id, true);
            }));
        });
    }, _ProfileAccountPage_onSaveUserClick = function _ProfileAccountPage_onSaveUserClick(event_1) {
        return __awaiter(this, arguments, void 0, function* (event, id = null) {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _ProfileAccountPage_form, "f").validator.form()) {
                return;
            }
            const data = $(__classPrivateFieldGet(this, _ProfileAccountPage_form, "f").root).serializeArray();
            yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_saveUser).call(this, data, __classPrivateFieldGet(this, _ProfileAccountPage_responseValidatorForm, "f"), () => __awaiter(this, void 0, void 0, function* () {
                App.popupHide();
                if (id != null) {
                    $('.js-user-form-wrap[data-userKey="' + id + '"]', this.root).remove();
                }
                yield __classPrivateFieldGet(this, _ProfileAccountPage_instances, "m", _ProfileAccountPage_getUser).call(this, __classPrivateFieldGet(this, _ProfileAccountPage_updateUserKey, "f"), true);
            }));
        });
    };
    App.ProfileAccountPage = ProfileAccountPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileAgencyWorkTimePage_instances, _ProfileAgencyWorkTimePage_options, _ProfileAgencyWorkTimePage_form, _ProfileAgencyWorkTimePage_workingTimes, _ProfileAgencyWorkTimePage_workingTimesHasChanged, _ProfileAgencyWorkTimePage_itemsCount, _ProfileAgencyWorkTimePage_successMsg, _ProfileAgencyWorkTimePage_initDatePicker, _ProfileAgencyWorkTimePage_initWeekDaysForExistingDates, _ProfileAgencyWorkTimePage_initTagsVisibility, _ProfileAgencyWorkTimePage_checkWeekDayByDate, _ProfileAgencyWorkTimePage_setHolidayHours, _ProfileAgencyWorkTimePage_updateTagsVisibility, _ProfileAgencyWorkTimePage_changeWorkingDay, _ProfileAgencyWorkTimePage_deleteWorkingLine, _ProfileAgencyWorkTimePage_setWorkingEveryDays, _ProfileAgencyWorkTimePage_setWorkingEveryHours, _ProfileAgencyWorkTimePage_setJelectValue, _ProfileAgencyWorkTimePage_addWorkingTimeLine, _ProfileAgencyWorkTimePage_createTimeLineContainer, _ProfileAgencyWorkTimePage_addWeekDaysBlock, _ProfileAgencyWorkTimePage_addIconBlock, _ProfileAgencyWorkTimePage_addTimeBlock, _ProfileAgencyWorkTimePage_addEveryHourButton, _ProfileAgencyWorkTimePage_addTimeSelectors, _ProfileAgencyWorkTimePage_addTimeSelector, _ProfileAgencyWorkTimePage_createHiddenInput, _ProfileAgencyWorkTimePage_createCurrentValueDisplay, _ProfileAgencyWorkTimePage_createOptionsList, _ProfileAgencyWorkTimePage_createOption, _ProfileAgencyWorkTimePage_addPriorityFields, _ProfileAgencyWorkTimePage_addPhoneField, _ProfileAgencyWorkTimePage_addDateField, _ProfileAgencyWorkTimePage_addDeleteButton, _ProfileAgencyWorkTimePage_addTagsBlock, _ProfileAgencyWorkTimePage_initCustomSelects, _ProfileAgencyWorkTimePage_initCustomSelectsForElement, _ProfileAgencyWorkTimePage_initPhoneMasksForElement, _ProfileAgencyWorkTimePage_initEvents, _ProfileAgencyWorkTimePage_isChanged, _ProfileAgencyWorkTimePage_onSubmit, _ProfileAgencyWorkTimePage_updateAllJelectValues;
    class ProfileAgencyWorkTimePage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ProfileAgencyWorkTimePage_instances.add(this);
            _ProfileAgencyWorkTimePage_options.set(this, void 0);
            _ProfileAgencyWorkTimePage_form.set(this, void 0);
            _ProfileAgencyWorkTimePage_workingTimes.set(this, void 0);
            _ProfileAgencyWorkTimePage_workingTimesHasChanged.set(this, void 0);
            _ProfileAgencyWorkTimePage_itemsCount.set(this, void 0);
            _ProfileAgencyWorkTimePage_successMsg.set(this, void 0);
            __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_options, options, "f");
            __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_workingTimes, __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_options, "f").workingTimes, "f");
            __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_workingTimesHasChanged, false, "f");
            __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_itemsCount, __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_workingTimes, "f").length, "f");
            const filter = new App.Filter({ root: $('.js-form', this.root) });
            __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_form, new App.Form({
                root: filter.root,
            }), "f");
            __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_successMsg, this.root.find('.js-success-msg'), "f");
            // Инициализируем кастомные селекты для существующих элементов
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initCustomSelects).call(this);
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initEvents).call(this);
            $('.js-work-button-not-priority', this.root).on('click', e => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addWorkingTimeLine).call(this, e, false));
            $('.js-work-button-priority', this.root).on('click', e => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addWorkingTimeLine).call(this, e, true));
            $('.js-work-time-phone, .js-work-time-date', this.root).on('change', () => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this));
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initDatePicker).call(this, this.root);
            // Инициализируем чекбоксы для уже установленных дат
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initWeekDaysForExistingDates).call(this);
            $('.js-submit', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_onSubmit).call(this, e); }));
            // Инициализируем видимость тегов для всех work-time-line
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initTagsVisibility).call(this);
        }
    }
    _ProfileAgencyWorkTimePage_options = new WeakMap(), _ProfileAgencyWorkTimePage_form = new WeakMap(), _ProfileAgencyWorkTimePage_workingTimes = new WeakMap(), _ProfileAgencyWorkTimePage_workingTimesHasChanged = new WeakMap(), _ProfileAgencyWorkTimePage_itemsCount = new WeakMap(), _ProfileAgencyWorkTimePage_successMsg = new WeakMap(), _ProfileAgencyWorkTimePage_instances = new WeakSet(), _ProfileAgencyWorkTimePage_initDatePicker = function _ProfileAgencyWorkTimePage_initDatePicker($container) {
        $('.js-work-time-date', $container).datepicker({
            minDate: new Date(),
            onSelect: (dateText, inst) => {
                // При выборе даты отмечаем соответствующий день недели
                __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_checkWeekDayByDate).call(this, inst.input, dateText);
                inst.input.trigger('change');
            },
        });
    }, _ProfileAgencyWorkTimePage_initWeekDaysForExistingDates = function _ProfileAgencyWorkTimePage_initWeekDaysForExistingDates() {
        $('.js-work-time-date', this.root).each((index, element) => {
            const $dateInput = $(element);
            const dateValue = $dateInput.val();
            if (dateValue && dateValue.trim() !== '') {
                __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_checkWeekDayByDate).call(this, $dateInput, dateValue);
            }
        });
    }, _ProfileAgencyWorkTimePage_initTagsVisibility = function _ProfileAgencyWorkTimePage_initTagsVisibility() {
        $('.work-time-line', this.root).each((index, element) => {
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_updateTagsVisibility).call(this, $(element));
        });
    }, _ProfileAgencyWorkTimePage_checkWeekDayByDate = function _ProfileAgencyWorkTimePage_checkWeekDayByDate($dateInput, dateText) {
        // Парсим дату из строки формата "dd.mm.yy"
        const parts = dateText.split('.');
        if (parts.length !== 3)
            return;
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // месяцы в JS от 0 до 11
        const year = parseInt(parts[2], 10) + 2000; // предполагаем формат yy, преобразуем в yyyy
        const date = new Date(year, month, day);
        const dayOfWeek = date.getDay(); // 0 - воскресенье, 1 - понедельник, ..., 6 - суббота
        // Находим родительский контейнер work-time-line
        const $workTimeLine = $dateInput.closest('.work-time-line');
        if ($workTimeLine.length === 0)
            return;
        // Сначала снимаем все отметки с чекбоксов дней недели
        $workTimeLine.find('.js-week-day').prop('checked', false).val('false');
        // Определяем какой чекбокс соответствует выбранному дню недели
        let targetCheckbox = null;
        switch (dayOfWeek) {
            case 0: // Воскресенье
                targetCheckbox = $workTimeLine.find('.js-week-day.sunday, .day7');
                break;
            case 1: // Понедельник
                targetCheckbox = $workTimeLine.find('.js-week-day.monday, .day1');
                break;
            case 2: // Вторник
                targetCheckbox = $workTimeLine.find('.js-week-day.tuesday, .day2');
                break;
            case 3: // Среда
                targetCheckbox = $workTimeLine.find('.js-week-day.wednesday, .day3');
                break;
            case 4: // Четверг
                targetCheckbox = $workTimeLine.find('.js-week-day.thursday, .day4');
                break;
            case 5: // Пятница
                targetCheckbox = $workTimeLine.find('.js-week-day.friday, .day5');
                break;
            case 6: // Суббота
                targetCheckbox = $workTimeLine.find('.js-week-day.saturday, .day6');
                break;
        }
        // Если нашли соответствующий чекбокс - отмечаем его
        if (targetCheckbox && targetCheckbox.length > 0) {
            targetCheckbox.prop('checked', true);
            targetCheckbox.val('true');
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
        }
    }, _ProfileAgencyWorkTimePage_setHolidayHours = function _ProfileAgencyWorkTimePage_setHolidayHours(e) {
        const $target = $(e.currentTarget);
        const $workTimeLine = $target.closest('.work-time-line');
        if ($workTimeLine.length === 0)
            return;
        // Устанавливаем значение '00' для всех jelect в этом work-time-line
        $workTimeLine.find('.js-jelect').each((index, element) => {
            const $jelect = $(element);
            const $hiddenInput = $jelect.find('.js-jelect-input');
            const $current = $jelect.find('.js-jelect-current');
            if ($hiddenInput.length > 0) {
                $hiddenInput.val('00').attr('data-text', '00');
                if ($current.length > 0) {
                    $current.text('00');
                }
                // Обновляем активную опцию в списке
                const $options = $jelect.find('.jelect-option');
                $options.removeClass('jelect-option_state_active');
                $jelect.find('.jelect-option[data-val="00"]').addClass('jelect-option_state_active');
            }
        });
        // Обновляем видимость тегов
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_updateTagsVisibility).call(this, $workTimeLine);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
    }, _ProfileAgencyWorkTimePage_updateTagsVisibility = function _ProfileAgencyWorkTimePage_updateTagsVisibility($workTimeLine) {
        const $tags = $workTimeLine.find('.js-work-time-tags');
        if ($tags.length === 0)
            return;
        // Проверяем все jelect в этом work-time-line
        const allJelects = $workTimeLine.find('.js-jelect');
        if (allJelects.length === 0) {
            $tags.hide();
            return;
        }
        // Проверяем, все ли jelect имеют значение '00'
        let allAreZero = true;
        allJelects.each((index, element) => {
            const $jelect = $(element);
            const $hiddenInput = $jelect.find('.js-jelect-input');
            const value = $hiddenInput.val();
            if (value !== '00') {
                allAreZero = false;
                return false; // Прерываем each
            }
        });
        // Показываем или скрываем теги
        if (allAreZero) {
            $tags.show();
        }
        else {
            $tags.hide();
        }
    }, _ProfileAgencyWorkTimePage_changeWorkingDay = function _ProfileAgencyWorkTimePage_changeWorkingDay(e) {
        $(e.currentTarget).val(`${$(e.currentTarget).is(':checked')}`);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
    }, _ProfileAgencyWorkTimePage_deleteWorkingLine = function _ProfileAgencyWorkTimePage_deleteWorkingLine(e) {
        $(e.currentTarget).parents('.work-time-line').remove();
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
    }, _ProfileAgencyWorkTimePage_setWorkingEveryDays = function _ProfileAgencyWorkTimePage_setWorkingEveryDays(e) {
        $(e.currentTarget).parents('.work-time-line-week-block').find('.js-week-day').each(function () {
            $(this).prop('checked', true);
            $(this).prop('value', true);
        });
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
    }, _ProfileAgencyWorkTimePage_setWorkingEveryHours = function _ProfileAgencyWorkTimePage_setWorkingEveryHours(e) {
        const $target = $(e.currentTarget);
        const $workTimeLine = $target.closest('.work-time-line');
        const $timeBlock = $target.parents('.work-time-line-time-block');
        const indexStr = $target.attr('index');
        const index = indexStr ? parseInt(indexStr, 10) : 0;
        // Используем метод для установки значений в кастомные селекты
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_setJelectValue).call(this, $timeBlock, index, 'FromHour', '00');
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_setJelectValue).call(this, $timeBlock, index, 'FromMinute', '00');
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_setJelectValue).call(this, $timeBlock, index, 'ToHour', '23');
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_setJelectValue).call(this, $timeBlock, index, 'ToMinute', '59');
        // Обновляем видимость тегов
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_updateTagsVisibility).call(this, $workTimeLine);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
    }, _ProfileAgencyWorkTimePage_setJelectValue = function _ProfileAgencyWorkTimePage_setJelectValue($container, index, fieldName, value) {
        const $hiddenInput = $container.find(`input[name="WorkingTimes[${index}].${fieldName}"]`);
        if ($hiddenInput.length > 0) {
            $hiddenInput.val(value).attr('data-text', value);
            const $jelectCurrent = $hiddenInput.siblings('.js-jelect-current');
            if ($jelectCurrent.length > 0) {
                $jelectCurrent.text(value);
            }
            const $options = $container.find(`.jelect-option[data-val="${value}"]`);
            $container.find('.jelect-option').removeClass('jelect-option_state_active');
            $options.addClass('jelect-option_state_active');
        }
    }, _ProfileAgencyWorkTimePage_addWorkingTimeLine = function _ProfileAgencyWorkTimePage_addWorkingTimeLine(e, isPriority) {
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
        const index = __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_itemsCount, "f");
        let $content;
        // Проверяем доступен ли шаблон через templates
        if (typeof App.templates !== 'undefined' && App.templates.Profile && App.templates.Profile.WorkingTimeLine) {
            // Используем существующий .hbs шаблон
            const templateData = {
                index: index,
                isPriority: isPriority,
                hours: [...Array(24).keys()],
                minutes: [...Array(60).keys()],
                minDate: new Date(),
            };
            const html = App.templates.Profile.WorkingTimeLine(templateData);
            $content = $(html);
        }
        else {
            // Создаем через jQuery (резервный способ)
            $content = __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_createTimeLineContainer).call(this, index, isPriority);
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addWeekDaysBlock).call(this, $content, index);
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addIconBlock).call(this, $content);
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addTimeBlock).call(this, $content, index, isPriority);
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addPriorityFields).call(this, $content, index, isPriority);
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addDeleteButton).call(this, $content);
            // Добавляем блок тегов для приоритетных work-time-line
            if (isPriority) {
                __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addTagsBlock).call(this, $content);
            }
        }
        $(e.currentTarget).parents('.work-bo-block').find('.work-time-placer').append($content);
        __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_itemsCount, __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_itemsCount, "f") + 1, "f");
        // Инициализируем кастомные селекты для нового элемента
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initCustomSelectsForElement).call(this, $content);
        if (isPriority) {
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initDatePicker).call(this, $content);
        }
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_initPhoneMasksForElement).call(this, $content);
        // Инициализируем видимость тегов для нового элемента
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_updateTagsVisibility).call(this, $content);
    }, _ProfileAgencyWorkTimePage_createTimeLineContainer = function _ProfileAgencyWorkTimePage_createTimeLineContainer(index, isPriority) {
        return $('<div>').addClass('work-time-line')
            .append(`<input type="hidden" name="WorkingTimes.Index" value="${index}" />`)
            .append(`<input type="hidden" name="WorkingTimes[${index}].SortOrder" value="${index}" />`)
            .append(`<input type="hidden" name="WorkingTimes[${index}].IsPriority" value="${isPriority}" />`);
    }, _ProfileAgencyWorkTimePage_addWeekDaysBlock = function _ProfileAgencyWorkTimePage_addWeekDaysBlock($content, index) {
        const $divWeek = $('<div>').addClass('work-time-line-week-block');
        $('<div>').addClass('work-time-line-down')
            .append($('<div>').addClass('work-time-line-button work-time-line-button-every-day js-every-day-btn lm__content-link').html('ежедневно'))
            .appendTo($divWeek);
        const $weekBlock = $('<div>').addClass('work-time-line-week-block_block').appendTo($divWeek);
        const days = [
            { class: 'day1', name: 'Monday', title: 'пн' },
            { class: 'day2', name: 'Tuesday', title: 'вт' },
            { class: 'day3', name: 'Wednesday', title: 'ср' },
            { class: 'day4', name: 'Thursday', title: 'чт' },
            { class: 'day5', name: 'Friday', title: 'пт' },
            { class: 'day6', name: 'Saturday', title: 'сб' },
            { class: 'day7', name: 'Sunday', title: 'вс' },
        ];
        days.forEach(day => {
            $weekBlock.append($('<div class="form-item">')
                .append($('<label>')
                .append($('<span class="form-item-field _checkbox">')
                .append($(`<input class="js-form-item-field work-time-line-week-block-day js-week-day ${day.class}">`)
                .attr('name', `WorkingTimes[${index}].${day.name}`)
                .attr('type', 'checkbox')
                .attr('checked', null)
                .attr('value', 'false')
                .attr('title', day.title))
                .append($('<span>')))
                .append(day.title)));
        });
        $divWeek.appendTo($content);
    }, _ProfileAgencyWorkTimePage_addIconBlock = function _ProfileAgencyWorkTimePage_addIconBlock($content) {
        $('<div>').addClass('work-time-line-icon-block').appendTo($content);
    }, _ProfileAgencyWorkTimePage_addTimeBlock = function _ProfileAgencyWorkTimePage_addTimeBlock($content, index, isPriority) {
        const $divTime = $('<div>').addClass('work-time-line-time-block');
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addEveryHourButton).call(this, $divTime, index, isPriority);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addTimeSelectors).call(this, $divTime, index);
        $divTime.appendTo($content);
    }, _ProfileAgencyWorkTimePage_addEveryHourButton = function _ProfileAgencyWorkTimePage_addEveryHourButton($divTime, index, isPriority) {
        const $downContainer = $('<div>').addClass('work-time-line-down');
        // Кнопка "круглосуточно"
        $downContainer.append($('<div>').addClass('work-time-line-button work-time-line-button-every-hour js-every-hour-btn lm__content-link')
            .attr('index', index.toString())
            .html('круглосуточно'));
        // Кнопка "выходной" только для приоритетных work-time-line
        if (isPriority) {
            $downContainer.append($('<div>').addClass('work-time-line-button work-time-line-button-holiday js-holyday-button lm__content-link')
                .html('выходной'));
        }
        $downContainer.appendTo($divTime);
    }, _ProfileAgencyWorkTimePage_addTimeSelectors = function _ProfileAgencyWorkTimePage_addTimeSelectors($divTime, index) {
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addTimeSelector).call(this, $divTime, index, 'FromHour', '00');
        $divTime.append($('<div>').addClass('work-time-line-time-block-separator').html(':'));
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addTimeSelector).call(this, $divTime, index, 'FromMinute', '00');
        $divTime.append($('<div>').addClass('work-time-line-time-block-separator').html(' — '));
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addTimeSelector).call(this, $divTime, index, 'ToHour', '23');
        $divTime.append($('<div>').addClass('work-time-line-time-block-separator').html(':'));
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addTimeSelector).call(this, $divTime, index, 'ToMinute', '59');
    }, _ProfileAgencyWorkTimePage_addTimeSelector = function _ProfileAgencyWorkTimePage_addTimeSelector($container, index, fieldName, defaultValue) {
        const $hourBlock = $('<div>').addClass('work-time-line-time-block-hour').appendTo($container);
        const $selectContainer = $('<div>').addClass('form-select jelect js-jelect').attr('data-name', `WorkingTimes[${index}].${fieldName}`).appendTo($hourBlock);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_createHiddenInput).call(this, $selectContainer, index, fieldName, defaultValue);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_createCurrentValueDisplay).call(this, $selectContainer, defaultValue);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_createOptionsList).call(this, $selectContainer, fieldName);
    }, _ProfileAgencyWorkTimePage_createHiddenInput = function _ProfileAgencyWorkTimePage_createHiddenInput($container, index, fieldName, defaultValue) {
        $container.append($('<input>').addClass('jelect-input js-jelect-input js-form-item-field')
            .attr('name', `WorkingTimes[${index}].${fieldName}`)
            .attr('value', defaultValue)
            .attr('data-text', defaultValue)
            .attr('type', 'hidden'));
    }, _ProfileAgencyWorkTimePage_createCurrentValueDisplay = function _ProfileAgencyWorkTimePage_createCurrentValueDisplay($container, value) {
        $container.append($('<div>').addClass('form-select-current jelect-current js-jelect-current')
            .attr('tabindex', '0')
            .html(value));
    }, _ProfileAgencyWorkTimePage_createOptionsList = function _ProfileAgencyWorkTimePage_createOptionsList($container, fieldName) {
        const isHour = fieldName.includes('Hour');
        const maxValue = isHour ? 24 : 60;
        const $optionsContainer = $('<div>').addClass('form-select-list jelect-options js-jelect-options js-scroller-wrap').appendTo($container);
        const $scroller = $('<div>').addClass('jelect-scroller js-jelect-scroller scroller js-scroller').appendTo($optionsContainer);
        for (let i = 0; i < maxValue; i++) {
            const value = i < 10 ? `0${i}` : i.toString();
            $scroller.append(__classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_createOption).call(this, value));
        }
        $optionsContainer.append('<div class="js-scrollbar-placeholder"></div>');
    }, _ProfileAgencyWorkTimePage_createOption = function _ProfileAgencyWorkTimePage_createOption(value) {
        return $('<div>').attr('data-val', value)
            .attr('tabindex', '0')
            .addClass('jelect-option js-jelect-option js-filter-option')
            .append($('<div>').addClass('jelect-option__value js-jelect-option-value').html(value));
    }, _ProfileAgencyWorkTimePage_addPriorityFields = function _ProfileAgencyWorkTimePage_addPriorityFields($content, index, isPriority) {
        const lineClass = isPriority ? 'work-time-line-priority-line' : 'work-time-line-line';
        const $line = $('<div>').addClass(`${lineClass} work-time-line-line-for-js`);
        __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addPhoneField).call(this, $line, index, isPriority);
        if (isPriority) {
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_addDateField).call(this, $line, index);
        }
        $line.appendTo($content);
    }, _ProfileAgencyWorkTimePage_addPhoneField = function _ProfileAgencyWorkTimePage_addPhoneField($container, index, isPriority) {
        const phoneClass = isPriority ? 'work-time-priority-phone js-work-time-phone' : 'js-work-time-phone work-time-priority-phone work-time-phone';
        $container.append($('<div>').addClass('work-time-line-priority-line-bed')
            .append($('<div>').addClass('form-item-title').html('Телефон'))
            .append($('<div>').addClass('form-item-field')
            .append($('<input>').addClass(`${phoneClass} js-form-item-field`)
            .attr('name', `WorkingTimes[${index}].PriorityPhone`))));
    }, _ProfileAgencyWorkTimePage_addDateField = function _ProfileAgencyWorkTimePage_addDateField($container, index) {
        $container.append($('<div>').addClass('work-time-line-priority-line-bed form-item _required')
            .append($('<div>').addClass('form-item-title').html('Дата'))
            .append($('<div>').addClass('form-item-field _date')
            .append($('<input>').addClass('work-time-priority-date js-work-time-date js-form-item-field')
            .attr({
            'name': `WorkingTimes[${index}].PriorityDate`,
            'required': 'required',
            'data-msg-required': 'Укажите дату',
        }))
            .append($('<div>').addClass('form-item-error'))));
    }, _ProfileAgencyWorkTimePage_addDeleteButton = function _ProfileAgencyWorkTimePage_addDeleteButton($content) {
        $('<div>').addClass('work-time-line-del-block')
            .append($('<div>').addClass('form-addable__remove js-remove-line-btn'))
            .appendTo($content);
    }, _ProfileAgencyWorkTimePage_addTagsBlock = function _ProfileAgencyWorkTimePage_addTagsBlock($content) {
        $('<div>').addClass('js-work-time-tags work-time-tags')
            .css('display', 'none') // По умолчанию скрыт
            .html('Выходной')
            .appendTo($content);
    }, _ProfileAgencyWorkTimePage_initCustomSelects = function _ProfileAgencyWorkTimePage_initCustomSelects() {
        $('.js-jelect').jelect();
    }, _ProfileAgencyWorkTimePage_initCustomSelectsForElement = function _ProfileAgencyWorkTimePage_initCustomSelectsForElement($element) {
        $element.find('.js-jelect').jelect();
    }, _ProfileAgencyWorkTimePage_initPhoneMasksForElement = function _ProfileAgencyWorkTimePage_initPhoneMasksForElement($element) {
        $element.find('.js-work-time-phone').inputmask('pacphone');
    }, _ProfileAgencyWorkTimePage_initEvents = function _ProfileAgencyWorkTimePage_initEvents() {
        // Для чекбоксов дней недели
        this.root.on('click', '.js-week-day', e => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_changeWorkingDay).call(this, e));
        // Для кнопок удаления
        this.root.on('click', '.js-remove-line-btn', e => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_deleteWorkingLine).call(this, e));
        // Для кнопок "ежедневно"
        this.root.on('click', '.js-every-day-btn', e => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_setWorkingEveryDays).call(this, e));
        // Для кнопок "круглосуточно"
        this.root.on('click', '.js-every-hour-btn', e => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_setWorkingEveryHours).call(this, e));
        // Для кнопок "выходной"
        this.root.on('click', '.js-holyday-button', e => __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_setHolidayHours).call(this, e));
        // Для кастомных селектов - обновляем видимость тегов при изменении
        this.root.on('change', '.js-jelect-input', e => {
            const $jelectInput = $(e.currentTarget);
            const $workTimeLine = $jelectInput.closest('.work-time-line');
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_updateTagsVisibility).call(this, $workTimeLine);
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_isChanged).call(this);
        });
        // Инициализируем маски для телефонов
        $('.js-work-time-phone', this.root).inputmask('pacphone');
    }, _ProfileAgencyWorkTimePage_isChanged = function _ProfileAgencyWorkTimePage_isChanged() {
        __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_workingTimesHasChanged, true, "f");
        $('.js-submit', this.root).removeAttr('disabled');
    }, _ProfileAgencyWorkTimePage_onSubmit = function _ProfileAgencyWorkTimePage_onSubmit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_form, "f") || !__classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_form, "f").validator.form()) {
                return;
            }
            __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_instances, "m", _ProfileAgencyWorkTimePage_updateAllJelectValues).call(this);
            $('input[name="workingTimesHasChanged"]').val(`${__classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_workingTimesHasChanged, "f")}`);
            const $submitBtn = $('.js-submit', this.root);
            $submitBtn.prop('disabled', true);
            try {
                const formData = new FormData(__classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_form, "f").root[0]);
                const response = yield fetch(__classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_options, "f").url, {
                    method: 'POST',
                    body: formData,
                });
                if (response.status !== 200) {
                    throw new Error(`HTTP ошибка: ${response.status} ${response.statusText}`);
                }
                __classPrivateFieldSet(this, _ProfileAgencyWorkTimePage_workingTimesHasChanged, false, "f");
                __classPrivateFieldGet(this, _ProfileAgencyWorkTimePage_successMsg, "f").show();
            }
            catch (error) {
                console.error('Ошибка при сохранении:', error);
                $submitBtn.prop('disabled', false);
            }
        });
    }, _ProfileAgencyWorkTimePage_updateAllJelectValues = function _ProfileAgencyWorkTimePage_updateAllJelectValues() {
        $('.js-jelect', this.root).each((index, element) => {
            const $jelect = $(element);
            const $current = $jelect.find('.js-jelect-current');
            const $hiddenInput = $jelect.find('.js-jelect-input');
            if ($current.length && $hiddenInput.length) {
                const currentValue = $current.text().trim();
                $hiddenInput.val(currentValue).attr('data-text', currentValue);
            }
        });
    };
    App.ProfileAgencyWorkTimePage = ProfileAgencyWorkTimePage;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileBankGuaranteePage_instances, _ProfileBankGuaranteePage_options, _ProfileBankGuaranteePage_form, _ProfileBankGuaranteePage_submitButton, _ProfileBankGuaranteePage_popup, _ProfileBankGuaranteePage_responseValidator, _ProfileBankGuaranteePage_executing, _ProfileBankGuaranteePage_onSubmit;
    class ProfileBankGuaranteePage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ProfileBankGuaranteePage_instances.add(this);
            _ProfileBankGuaranteePage_options.set(this, void 0);
            _ProfileBankGuaranteePage_form.set(this, void 0);
            _ProfileBankGuaranteePage_submitButton.set(this, void 0);
            _ProfileBankGuaranteePage_popup.set(this, void 0);
            _ProfileBankGuaranteePage_responseValidator.set(this, void 0);
            _ProfileBankGuaranteePage_executing.set(this, false);
            __classPrivateFieldSet(this, _ProfileBankGuaranteePage_options, options, "f");
            const filter = new App.Filter({ root: $('.js-form', this.root) });
            __classPrivateFieldSet(this, _ProfileBankGuaranteePage_form, new App.Form({
                root: filter.root,
            }), "f");
            __classPrivateFieldSet(this, _ProfileBankGuaranteePage_submitButton, $('.js-submit', this.root), "f");
            __classPrivateFieldSet(this, _ProfileBankGuaranteePage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _ProfileBankGuaranteePage_responseValidator, new App.ResponseValidator({
                messenger: new App.BlockMessenger(new App.Messages()),
                validator: __classPrivateFieldGet(this, _ProfileBankGuaranteePage_form, "f").validator,
            }), "f");
            __classPrivateFieldGet(this, _ProfileBankGuaranteePage_form, "f").root.on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileBankGuaranteePage_instances, "m", _ProfileBankGuaranteePage_onSubmit).call(this, e); }));
        }
    }
    _ProfileBankGuaranteePage_options = new WeakMap(), _ProfileBankGuaranteePage_form = new WeakMap(), _ProfileBankGuaranteePage_submitButton = new WeakMap(), _ProfileBankGuaranteePage_popup = new WeakMap(), _ProfileBankGuaranteePage_responseValidator = new WeakMap(), _ProfileBankGuaranteePage_executing = new WeakMap(), _ProfileBankGuaranteePage_instances = new WeakSet(), _ProfileBankGuaranteePage_onSubmit = function _ProfileBankGuaranteePage_onSubmit(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            e.preventDefault();
            e.stopPropagation();
            if (!__classPrivateFieldGet(this, _ProfileBankGuaranteePage_form, "f").validator.form())
                return;
            if (__classPrivateFieldGet(this, _ProfileBankGuaranteePage_executing, "f"))
                return;
            __classPrivateFieldSet(this, _ProfileBankGuaranteePage_executing, true, "f");
            const popupGroup = __classPrivateFieldGet(this, _ProfileBankGuaranteePage_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Executing({}),
                modal: true,
                delay: 1000,
            });
            __classPrivateFieldGet(this, _ProfileBankGuaranteePage_submitButton, "f").prop('disabled', true);
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const result = yield $.ajax({
                        url: __classPrivateFieldGet(this, _ProfileBankGuaranteePage_options, "f").url,
                        method: 'POST',
                        data: __classPrivateFieldGet(this, _ProfileBankGuaranteePage_form, "f").root.serializeArray(),
                    });
                    if (!__classPrivateFieldGet(this, _ProfileBankGuaranteePage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                if (!response)
                    return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ProfileBankGuaranteePage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _ProfileBankGuaranteePage_submitButton, "f").prop('disabled', false);
                __classPrivateFieldGet(this, _ProfileBankGuaranteePage_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _ProfileBankGuaranteePage_executing, false, "f");
            }
        });
    };
    App.ProfileBankGuaranteePage = ProfileBankGuaranteePage;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileCorporateCardsPage_instances, _ProfileCorporateCardsPage_options, _ProfileCorporateCardsPage_form, _ProfileCorporateCardsPage_activeCards, _ProfileCorporateCardsPage_submitButton, _ProfileCorporateCardsPage_popup, _ProfileCorporateCardsPage_messenger, _ProfileCorporateCardsPage_responseValidator, _ProfileCorporateCardsPage_scrollerWrap, _ProfileCorporateCardsPage_executing, _ProfileCorporateCardsPage_setupNumericInputValidation, _ProfileCorporateCardsPage_clearForm, _ProfileCorporateCardsPage_onSubmit, _ProfileCorporateCardsPage_renderActiveCards;
    class ProfileCorporateCardsPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ProfileCorporateCardsPage_instances.add(this);
            _ProfileCorporateCardsPage_options.set(this, void 0);
            _ProfileCorporateCardsPage_form.set(this, void 0);
            _ProfileCorporateCardsPage_activeCards.set(this, void 0);
            _ProfileCorporateCardsPage_submitButton.set(this, void 0);
            _ProfileCorporateCardsPage_popup.set(this, void 0);
            _ProfileCorporateCardsPage_messenger.set(this, void 0);
            _ProfileCorporateCardsPage_responseValidator.set(this, void 0);
            _ProfileCorporateCardsPage_scrollerWrap.set(this, void 0);
            _ProfileCorporateCardsPage_executing.set(this, false);
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_options, options, "f");
            const filter = new App.Filter({ root: $('.js-form', this.root) });
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_form, new App.Form({
                root: filter.root,
            }), "f");
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_activeCards, $('.js-active-cards', this.root), "f");
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_submitButton, $('.js-submit', this.root), "f");
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_responseValidator, new App.ResponseValidator({ messenger: __classPrivateFieldGet(this, _ProfileCorporateCardsPage_messenger, "f"), validator: __classPrivateFieldGet(this, _ProfileCorporateCardsPage_form, "f").validator }), "f");
            __classPrivateFieldSet(this, _ProfileCorporateCardsPage_scrollerWrap, $('.js-scroller-wrap', this.root), "f");
            __classPrivateFieldGet(this, _ProfileCorporateCardsPage_instances, "m", _ProfileCorporateCardsPage_setupNumericInputValidation).call(this);
            $('.js-clear-form', this.root).on('click', () => __classPrivateFieldGet(this, _ProfileCorporateCardsPage_instances, "m", _ProfileCorporateCardsPage_clearForm).call(this));
            __classPrivateFieldGet(this, _ProfileCorporateCardsPage_form, "f").root.on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileCorporateCardsPage_instances, "m", _ProfileCorporateCardsPage_onSubmit).call(this, e); }));
            __classPrivateFieldGet(this, _ProfileCorporateCardsPage_instances, "m", _ProfileCorporateCardsPage_renderActiveCards).call(this);
            // Стилизуем скролл
            const scroll = __classPrivateFieldGet(this, _ProfileCorporateCardsPage_scrollerWrap, "f").baron({
                scroller: '.js-scroller',
                track: '.js-scroller-bar-wrap',
                bar: '.js-scroller-bar',
                barOnCls: 'baron',
            });
            __classPrivateFieldGet(this, _ProfileCorporateCardsPage_submitButton, "f").on('click', () => {
                scroll.update();
            });
        }
    }
    _ProfileCorporateCardsPage_options = new WeakMap(), _ProfileCorporateCardsPage_form = new WeakMap(), _ProfileCorporateCardsPage_activeCards = new WeakMap(), _ProfileCorporateCardsPage_submitButton = new WeakMap(), _ProfileCorporateCardsPage_popup = new WeakMap(), _ProfileCorporateCardsPage_messenger = new WeakMap(), _ProfileCorporateCardsPage_responseValidator = new WeakMap(), _ProfileCorporateCardsPage_scrollerWrap = new WeakMap(), _ProfileCorporateCardsPage_executing = new WeakMap(), _ProfileCorporateCardsPage_instances = new WeakSet(), _ProfileCorporateCardsPage_setupNumericInputValidation = function _ProfileCorporateCardsPage_setupNumericInputValidation() {
        const cardInputs = $('.js-card-input', this.root);
        cardInputs.each((index, input) => {
            $(input).on('input', () => {
                const value = $(this).valString() || '';
                $(this).val(value.replace(/\D/g, ''));
            });
        });
    }, _ProfileCorporateCardsPage_clearForm = function _ProfileCorporateCardsPage_clearForm() {
        __classPrivateFieldGet(this, _ProfileCorporateCardsPage_form, "f").root.find('input[type="text"]').val('');
        __classPrivateFieldGet(this, _ProfileCorporateCardsPage_form, "f").validator.resetForm();
    }, _ProfileCorporateCardsPage_onSubmit = function _ProfileCorporateCardsPage_onSubmit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            if (!__classPrivateFieldGet(this, _ProfileCorporateCardsPage_form, "f").validator.form())
                return;
            if (__classPrivateFieldGet(this, _ProfileCorporateCardsPage_executing, "f"))
                return;
            let allInputsValid = true;
            const cardInputs = $('.js-card-input', __classPrivateFieldGet(this, _ProfileCorporateCardsPage_form, "f").root);
            cardInputs.each((index, element) => {
                const cardInputValue = String($(element).val() || '');
                const cardDigitsCount = cardInputValue.replace(/\D/g, '').length;
                if (cardDigitsCount < 4) {
                    allInputsValid = false;
                    return false;
                }
            });
            if (!allInputsValid) {
                __classPrivateFieldGet(this, _ProfileCorporateCardsPage_popup, "f").show({ content: App.templates.Message({ type: 1 /* MessageType.Warning */, text: 'Пожалуйста, введите 4 цифры в каждое поле для корпоративной карты.' }) });
                return;
            }
            __classPrivateFieldGet(this, _ProfileCorporateCardsPage_submitButton, "f").prop('disabled', true);
            try {
                const response = yield $.ajax({
                    url: __classPrivateFieldGet(this, _ProfileCorporateCardsPage_options, "f").url,
                    method: 'POST',
                    data: __classPrivateFieldGet(this, _ProfileCorporateCardsPage_form, "f").root.serializeArray(),
                });
                if (!__classPrivateFieldGet(this, _ProfileCorporateCardsPage_responseValidator, "f").process(response))
                    return;
                if (response.status.success) {
                    const cardNumber = `${response.data.numberPart1}-XXXX-XXXX-${response.data.numberPart2}`;
                    if (response.data.result === 1) {
                        __classPrivateFieldGet(this, _ProfileCorporateCardsPage_popup, "f").show({ content: App.templates.Message({ type: 0 /* MessageType.Information */, text: `Корпоративная карта с номером ${cardNumber} успешно зарегистрирована.` }) });
                        __classPrivateFieldGet(this, _ProfileCorporateCardsPage_options, "f").activeCards.push(cardNumber);
                        __classPrivateFieldGet(this, _ProfileCorporateCardsPage_instances, "m", _ProfileCorporateCardsPage_renderActiveCards).call(this);
                    }
                    else {
                        __classPrivateFieldGet(this, _ProfileCorporateCardsPage_popup, "f").show({ content: App.templates.Message({ type: 1 /* MessageType.Warning */, text: `Корпоративная карта с номером ${cardNumber} была зарегистрирована ранее.` }) });
                    }
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ProfileCorporateCardsPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _ProfileCorporateCardsPage_submitButton, "f").prop('disabled', false);
                __classPrivateFieldSet(this, _ProfileCorporateCardsPage_executing, false, "f");
            }
        });
    }, _ProfileCorporateCardsPage_renderActiveCards = function _ProfileCorporateCardsPage_renderActiveCards() {
        __classPrivateFieldGet(this, _ProfileCorporateCardsPage_activeCards, "f")
            .empty()
            .append(App.templates.Profile.CorporateCardsActive(__classPrivateFieldGet(this, _ProfileCorporateCardsPage_options, "f").activeCards));
    };
    App.ProfileCorporateCardsPage = ProfileCorporateCardsPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileInfoPageMobile_tabs;
    class ProfileInfoPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-agent-info-page' }, options));
            _ProfileInfoPageMobile_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _ProfileInfoPageMobile_tabs, new App.TabsMobile({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ProfileInfoPageMobile_tabs, "f").showActive();
        }
    }
    _ProfileInfoPageMobile_tabs = new WeakMap();
    App.ProfileInfoPageMobile = ProfileInfoPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileMarkupPage_instances, _ProfileMarkupPage_options, _ProfileMarkupPage_typeInput, _ProfileMarkupPage_economyInput, _ProfileMarkupPage_premiumEconomyInput, _ProfileMarkupPage_businessInput, _ProfileMarkupPage_firstInput, _ProfileMarkupPage_currencyContainer, _ProfileMarkupPage_currencyInput, _ProfileMarkupPage_form, _ProfileMarkupPage_submitButton, _ProfileMarkupPage_popup, _ProfileMarkupPage_responseValidator, _ProfileMarkupPage_executing, _ProfileMarkupPage_updateLimits, _ProfileMarkupPage_getMaxAmount, _ProfileMarkupPage_onSubmit;
    class ProfileMarkupPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ProfileMarkupPage_instances.add(this);
            _ProfileMarkupPage_options.set(this, void 0);
            _ProfileMarkupPage_typeInput.set(this, void 0);
            _ProfileMarkupPage_economyInput.set(this, void 0);
            _ProfileMarkupPage_premiumEconomyInput.set(this, void 0);
            _ProfileMarkupPage_businessInput.set(this, void 0);
            _ProfileMarkupPage_firstInput.set(this, void 0);
            _ProfileMarkupPage_currencyContainer.set(this, void 0);
            _ProfileMarkupPage_currencyInput.set(this, void 0);
            _ProfileMarkupPage_form.set(this, void 0);
            _ProfileMarkupPage_submitButton.set(this, void 0);
            _ProfileMarkupPage_popup.set(this, void 0);
            _ProfileMarkupPage_responseValidator.set(this, void 0);
            _ProfileMarkupPage_executing.set(this, false);
            __classPrivateFieldSet(this, _ProfileMarkupPage_options, options, "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_typeInput, $('.js-form-field-type .js-jelect', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_economyInput, $('.js-form-field-economy input', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_premiumEconomyInput, $('.js-form-field-premium-economy input', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_businessInput, $('.js-form-field-business input', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_firstInput, $('.js-form-field-first input', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_currencyContainer, $('.js-form-field-currency', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_currencyInput, $('.js-jelect', __classPrivateFieldGet(this, _ProfileMarkupPage_currencyContainer, "f")), "f");
            const filter = new App.Filter({ root: $('.js-form', this.root) });
            __classPrivateFieldSet(this, _ProfileMarkupPage_form, new App.Form({
                root: filter.root,
            }), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_submitButton, $('.js-submit', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _ProfileMarkupPage_responseValidator, new App.ResponseValidator({
                messenger: new App.BlockMessenger(new App.Messages()),
                validator: __classPrivateFieldGet(this, _ProfileMarkupPage_form, "f").validator,
            }), "f");
            __classPrivateFieldGet(this, _ProfileMarkupPage_form, "f").root.on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_onSubmit).call(this, e); }));
            let previousTypeValue = __classPrivateFieldGet(this, _ProfileMarkupPage_typeInput, "f").valString() === 'Percent';
            let previousAmounts = ['', '', ''];
            __classPrivateFieldGet(this, _ProfileMarkupPage_typeInput, "f").on('change', () => {
                const typeValue = __classPrivateFieldGet(this, _ProfileMarkupPage_typeInput, "f").valString() === 'Percent';
                if (previousTypeValue === typeValue)
                    return;
                previousTypeValue = typeValue;
                __classPrivateFieldGet(this, _ProfileMarkupPage_currencyContainer, "f").toggle(!typeValue);
                __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_updateLimits).call(this);
                const newPreviousAmounts = [
                    __classPrivateFieldGet(this, _ProfileMarkupPage_economyInput, "f").valString(),
                    __classPrivateFieldGet(this, _ProfileMarkupPage_premiumEconomyInput, "f").valString(),
                    __classPrivateFieldGet(this, _ProfileMarkupPage_businessInput, "f").valString(),
                    __classPrivateFieldGet(this, _ProfileMarkupPage_firstInput, "f").valString(),
                ];
                __classPrivateFieldGet(this, _ProfileMarkupPage_economyInput, "f").val(previousAmounts[0]);
                __classPrivateFieldGet(this, _ProfileMarkupPage_premiumEconomyInput, "f").val(previousAmounts[1]);
                __classPrivateFieldGet(this, _ProfileMarkupPage_businessInput, "f").val(previousAmounts[2]);
                __classPrivateFieldGet(this, _ProfileMarkupPage_firstInput, "f").val(previousAmounts[3]);
                previousAmounts = newPreviousAmounts;
            });
            __classPrivateFieldGet(this, _ProfileMarkupPage_currencyInput, "f").on('change', () => __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_updateLimits).call(this));
            __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_updateLimits).call(this);
        }
    }
    _ProfileMarkupPage_options = new WeakMap(), _ProfileMarkupPage_typeInput = new WeakMap(), _ProfileMarkupPage_economyInput = new WeakMap(), _ProfileMarkupPage_premiumEconomyInput = new WeakMap(), _ProfileMarkupPage_businessInput = new WeakMap(), _ProfileMarkupPage_firstInput = new WeakMap(), _ProfileMarkupPage_currencyContainer = new WeakMap(), _ProfileMarkupPage_currencyInput = new WeakMap(), _ProfileMarkupPage_form = new WeakMap(), _ProfileMarkupPage_submitButton = new WeakMap(), _ProfileMarkupPage_popup = new WeakMap(), _ProfileMarkupPage_responseValidator = new WeakMap(), _ProfileMarkupPage_executing = new WeakMap(), _ProfileMarkupPage_instances = new WeakSet(), _ProfileMarkupPage_updateLimits = function _ProfileMarkupPage_updateLimits() {
        const isPercent = __classPrivateFieldGet(this, _ProfileMarkupPage_typeInput, "f").valString() === 'Percent';
        const currency = __classPrivateFieldGet(this, _ProfileMarkupPage_currencyInput, "f").valString().toLowerCase();
        // TODO: заменить '_min' на 'min' и '_max' на 'max' после фикса проблемы с разделителем дробной части.
        __classPrivateFieldGet(this, _ProfileMarkupPage_economyInput, "f").attr('_min', 0);
        __classPrivateFieldGet(this, _ProfileMarkupPage_economyInput, "f").attr('_max', __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_getMaxAmount).call(this, isPercent, currency, 'economy'));
        __classPrivateFieldGet(this, _ProfileMarkupPage_premiumEconomyInput, "f").attr('_min', 0);
        __classPrivateFieldGet(this, _ProfileMarkupPage_premiumEconomyInput, "f").attr('_max', __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_getMaxAmount).call(this, isPercent, currency, 'premiumEconomy'));
        __classPrivateFieldGet(this, _ProfileMarkupPage_businessInput, "f").attr('_min', 0);
        __classPrivateFieldGet(this, _ProfileMarkupPage_businessInput, "f").attr('_max', __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_getMaxAmount).call(this, isPercent, currency, 'business'));
        __classPrivateFieldGet(this, _ProfileMarkupPage_firstInput, "f").attr('_min', 0);
        __classPrivateFieldGet(this, _ProfileMarkupPage_firstInput, "f").attr('_max', __classPrivateFieldGet(this, _ProfileMarkupPage_instances, "m", _ProfileMarkupPage_getMaxAmount).call(this, isPercent, currency, 'first'));
    }, _ProfileMarkupPage_getMaxAmount = function _ProfileMarkupPage_getMaxAmount(isPercent, currency, serviceClass) {
        var _a, _b, _c;
        if (isPercent)
            return (_a = __classPrivateFieldGet(this, _ProfileMarkupPage_options, "f").percentLimits[serviceClass]) !== null && _a !== void 0 ? _a : 0;
        return (_c = ((_b = __classPrivateFieldGet(this, _ProfileMarkupPage_options, "f").amountLimits[currency]) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _ProfileMarkupPage_options, "f").amountLimits[''])[serviceClass]) !== null && _c !== void 0 ? _c : 0;
    }, _ProfileMarkupPage_onSubmit = function _ProfileMarkupPage_onSubmit(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            e.preventDefault();
            e.stopPropagation();
            if (!__classPrivateFieldGet(this, _ProfileMarkupPage_form, "f").validator.form())
                return;
            if (__classPrivateFieldGet(this, _ProfileMarkupPage_executing, "f"))
                return;
            __classPrivateFieldSet(this, _ProfileMarkupPage_executing, true, "f");
            const popupGroup = __classPrivateFieldGet(this, _ProfileMarkupPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Executing({}),
                modal: true,
                delay: 1000,
            });
            __classPrivateFieldGet(this, _ProfileMarkupPage_submitButton, "f").prop('disabled', true);
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const result = yield $.ajax({
                        url: __classPrivateFieldGet(this, _ProfileMarkupPage_options, "f").url,
                        method: 'POST',
                        data: __classPrivateFieldGet(this, _ProfileMarkupPage_form, "f").root.serializeArray(),
                    });
                    if (!__classPrivateFieldGet(this, _ProfileMarkupPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                if (!response)
                    return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ProfileMarkupPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _ProfileMarkupPage_submitButton, "f").prop('disabled', false);
                __classPrivateFieldGet(this, _ProfileMarkupPage_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _ProfileMarkupPage_executing, false, "f");
            }
        });
    };
    App.ProfileMarkupPage = ProfileMarkupPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileMyPage_instances, _ProfileMyPage_options, _ProfileMyPage_submitButton, _ProfileMyPage_popup, _ProfileMyPage_responseValidator, _ProfileMyPage_messenger, _ProfileMyPage_decode, _ProfileMyPage_getPromocode;
    class ProfileMyPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ProfileMyPage_instances.add(this);
            _ProfileMyPage_options.set(this, void 0);
            _ProfileMyPage_submitButton.set(this, void 0);
            _ProfileMyPage_popup.set(this, void 0);
            _ProfileMyPage_responseValidator.set(this, void 0);
            _ProfileMyPage_messenger.set(this, void 0);
            __classPrivateFieldSet(this, _ProfileMyPage_options, options, "f");
            __classPrivateFieldSet(this, _ProfileMyPage_submitButton, $('.js-getPromocode', this.root), "f");
            __classPrivateFieldSet(this, _ProfileMyPage_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _ProfileMyPage_responseValidator, new App.ResponseValidator({
                messenger: __classPrivateFieldGet(this, _ProfileMyPage_messenger, "f"),
            }), "f");
            __classPrivateFieldSet(this, _ProfileMyPage_popup, new App.Popup(), "f");
            __classPrivateFieldGet(this, _ProfileMyPage_submitButton, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ProfileMyPage_instances, "m", _ProfileMyPage_getPromocode).call(this, e); }));
        }
    }
    _ProfileMyPage_options = new WeakMap(), _ProfileMyPage_submitButton = new WeakMap(), _ProfileMyPage_popup = new WeakMap(), _ProfileMyPage_responseValidator = new WeakMap(), _ProfileMyPage_messenger = new WeakMap(), _ProfileMyPage_instances = new WeakSet(), _ProfileMyPage_decode = function _ProfileMyPage_decode(data) {
        const hashedCode = Uint8Array.from(atob(data), s => s.charCodeAt(0));
        for (let i = 1; i != hashedCode.length; ++i)
            hashedCode[i] ^= hashedCode[0];
        return new TextDecoder().decode(hashedCode.slice(1));
    }, _ProfileMyPage_getPromocode = function _ProfileMyPage_getPromocode(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            e.preventDefault();
            e.stopPropagation();
            const popupGroup = __classPrivateFieldGet(this, _ProfileMyPage_popup, "f").show({
                group: 'filter',
                content: App.templates.Messages.Executing({}),
                modal: true,
                delay: 1000,
            });
            $(e.currentTarget).prop('disabled', true);
            const promocodeKey = Number($(e.currentTarget).attr('data-promocodeKey'));
            const retryPolicy = App.Retry.createRetryPolicy(App.jqueryAjaxErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const result = yield $.ajax({
                        url: __classPrivateFieldGet(this, _ProfileMyPage_options, "f").url,
                        method: 'POST',
                        data: { promocodeKey: promocodeKey },
                    });
                    if (!__classPrivateFieldGet(this, _ProfileMyPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                if (!response)
                    return;
                if ([0, 3, 5].includes(response.data.code)) {
                    const code_b64 = $(e.currentTarget).attr('data-promocode') || '';
                    const parent = $(e.currentTarget).parent('.js-promocodeItem');
                    parent.find('.js-getPromocode').hideByClass();
                    parent.find('.js-promocode').html(__classPrivateFieldGet(this, _ProfileMyPage_instances, "m", _ProfileMyPage_decode).call(this, code_b64)).showByClass();
                }
                else {
                    __classPrivateFieldGet(this, _ProfileMyPage_messenger, "f").show({ type: 0 /* MessageType.Information */, text: response.data.message }, { group: 'ajax' });
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ProfileMyPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                $(e.currentTarget).prop('disabled', false);
                __classPrivateFieldGet(this, _ProfileMyPage_popup, "f").hide(popupGroup);
            }
        });
    };
    App.ProfileMyPage = ProfileMyPage;
})(App || (App = {}));
/// <reference path="./ProfileMyPage.ts" />
var App;
(function (App) {
    var _ProfileMyPageMobile_tabs;
    class ProfileMyPageMobile extends App.ProfileMyPage {
        constructor(options) {
            super(Object.assign({ root: '.js-lk-profile-page' }, options));
            _ProfileMyPageMobile_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _ProfileMyPageMobile_tabs, new App.TabsMobile({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ProfileMyPageMobile_tabs, "f").showActive();
        }
    }
    _ProfileMyPageMobile_tabs = new WeakMap();
    App.ProfileMyPageMobile = ProfileMyPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfilePageMobile_tabs;
    class ProfilePageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-lk-profile-page' }, options));
            _ProfilePageMobile_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _ProfilePageMobile_tabs, new App.TabsMobile({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ProfilePageMobile_tabs, "f").showActive();
        }
    }
    _ProfilePageMobile_tabs = new WeakMap();
    App.ProfilePageMobile = ProfilePageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _ProfileReportPageMobile_tabs;
    class ProfileReportPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-agent-info-page' }, options));
            _ProfileReportPageMobile_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _ProfileReportPageMobile_tabs, new App.TabsMobile({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ProfileReportPageMobile_tabs, "f").showActive();
        }
    }
    _ProfileReportPageMobile_tabs = new WeakMap();
    App.ProfileReportPageMobile = ProfileReportPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    class ProfileAccountHotFilter extends App.HotFilter {
        constructor(opts) {
            super(opts);
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.hotFilter = $();
                return;
            }
            this.hotFilter = this.root;
        }
        onHotFiltersChange() {
            const selectedHotFilters = this.hotFilter.find('input').serializeArray();
            const filters = selectedHotFilters
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            this.hotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
    }
    App.ProfileAccountHotFilter = ProfileAccountHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    class ProfileAccountResult extends App.Result {
        constructor(options) {
            super(Object.assign({ tableTemplate: App.templates.Profile.TableOutput }, options));
            if (!this.root.length)
                return;
        }
        applySorting(items) {
            return items;
        }
        applyFilters(items) {
            if (this.filtering.items.length <= 0)
                return items;
            let result = items;
            this.filtering.items
                .filter(v => v.values.length > 0)
                .forEach(v => {
                switch (v.name.toLowerCase()) {
                    case 'searchuser': {
                        result = result.filter(item => v.values.some(x => item.managerName.toLowerCase().includes(x.toLowerCase())
                            || item.phones.toLowerCase().includes(x.toLowerCase())
                            || item.emails.toLowerCase().includes(x.toLowerCase())));
                        break;
                    }
                    // no default
                }
            });
            return result;
        }
    }
    App.ProfileAccountResult = ProfileAccountResult;
})(App || (App = {}));
var App;
(function (App) {
    var _RatingPageMobile_tabs;
    class RatingPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({ root: '.js-agent-info-page' }, options));
            _RatingPageMobile_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _RatingPageMobile_tabs, new App.TabsMobile({ root: this.root }), "f");
            __classPrivateFieldGet(this, _RatingPageMobile_tabs, "f").showActive();
        }
    }
    _RatingPageMobile_tabs = new WeakMap();
    App.RatingPageMobile = RatingPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _ReportAgentPage_instances, _ReportAgentPage_waitForDLComplete;
    class ReportAgentPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ReportAgentPage_instances.add(this);
            const filter = new App.Filter({ root: $('.js-form', this.root) });
            this.components.push(new App.Form({ root: filter.root }));
            $('input', filter.root).on('click', e => {
                const target = e.currentTarget;
                $('#Form_ReportType').val(($(target).attr('report-type') || '').toString());
                $(target).toggle();
                $('.js-loading', $(target).closest('.js-filter-type')).toggle();
                setTimeout(() => __classPrivateFieldGet(this, _ReportAgentPage_instances, "m", _ReportAgentPage_waitForDLComplete).call(this, e), 30000);
            });
        }
    }
    _ReportAgentPage_instances = new WeakSet(), _ReportAgentPage_waitForDLComplete = function _ReportAgentPage_waitForDLComplete(e) {
        const target = e.currentTarget;
        $(target).toggle();
        $('.js-loading', $(target).closest('.js-filter-type')).hide();
    };
    App.ReportAgentPage = ReportAgentPage;
})(App || (App = {}));
var App;
(function (App) {
    class ReportAviaPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            const filter = new App.Filter({
                root: $('.js-form', this.root),
                datesOptions: {
                    minDateFromShift: -365 * 3,
                    maxDateFromShift: 0,
                    minDateToOffset: 0,
                    preserveDatesOffset: false,
                },
            });
            this.components.push(new App.Form({ root: filter.root }));
        }
    }
    App.ReportAviaPage = ReportAviaPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ReportCommissionPage_tabs;
    class ReportCommissionPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ReportCommissionPage_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _ReportCommissionPage_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ReportCommissionPage_tabs, "f").showActive();
        }
    }
    _ReportCommissionPage_tabs = new WeakMap();
    App.ReportCommissionPage = ReportCommissionPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ReportCommissionPageMobile_tabs;
    class ReportCommissionPageMobile extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ReportCommissionPageMobile_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _ReportCommissionPageMobile_tabs, new App.TabsMobile({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ReportCommissionPageMobile_tabs, "f").showActive();
        }
    }
    _ReportCommissionPageMobile_tabs = new WeakMap();
    App.ReportCommissionPageMobile = ReportCommissionPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _ReportDebtPage_instances, _ReportDebtPage_options, _ReportDebtPage_headerCheckbox, _ReportDebtPage_itemCheckboxes, _ReportDebtPage_popup, _ReportDebtPage_toggleFormButton, _ReportDebtPage_clearCheckboxes, _ReportDebtPage_togglePaymentRegistryForm, _ReportDebtPage_showPaymentRegistryDialog;
    class ReportDebtPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({ root: '.js-agent-info-page' }, options));
            _ReportDebtPage_instances.add(this);
            _ReportDebtPage_options.set(this, void 0);
            _ReportDebtPage_headerCheckbox.set(this, void 0);
            _ReportDebtPage_itemCheckboxes.set(this, void 0);
            _ReportDebtPage_popup.set(this, void 0);
            _ReportDebtPage_toggleFormButton.set(this, void 0);
            __classPrivateFieldSet(this, _ReportDebtPage_options, options, "f");
            __classPrivateFieldSet(this, _ReportDebtPage_headerCheckbox, $(this.root).find('.js-form-item-field.js-select-all'), "f");
            __classPrivateFieldSet(this, _ReportDebtPage_itemCheckboxes, $(this.root).find('.js-debt-item .js-form-item-field'), "f");
            __classPrivateFieldSet(this, _ReportDebtPage_toggleFormButton, $('.js-debt-registry-toggle', this.root), "f");
            __classPrivateFieldSet(this, _ReportDebtPage_popup, new App.Popup(), "f");
            __classPrivateFieldGet(this, _ReportDebtPage_headerCheckbox, "f").on('change', () => {
                const isChecked = __classPrivateFieldGet(this, _ReportDebtPage_headerCheckbox, "f").is(':checked');
                __classPrivateFieldGet(this, _ReportDebtPage_itemCheckboxes, "f").prop('checked', isChecked);
            });
            $('.js-debt-registry-cancel', this.root).on('click', () => __classPrivateFieldGet(this, _ReportDebtPage_instances, "m", _ReportDebtPage_clearCheckboxes).call(this));
            $('.js-debt-registry-send', this.root).on('click', () => __classPrivateFieldGet(this, _ReportDebtPage_instances, "m", _ReportDebtPage_showPaymentRegistryDialog).call(this));
            __classPrivateFieldGet(this, _ReportDebtPage_toggleFormButton, "f").on('click', () => __classPrivateFieldGet(this, _ReportDebtPage_instances, "m", _ReportDebtPage_togglePaymentRegistryForm).call(this));
        }
    }
    _ReportDebtPage_options = new WeakMap(), _ReportDebtPage_headerCheckbox = new WeakMap(), _ReportDebtPage_itemCheckboxes = new WeakMap(), _ReportDebtPage_popup = new WeakMap(), _ReportDebtPage_toggleFormButton = new WeakMap(), _ReportDebtPage_instances = new WeakSet(), _ReportDebtPage_clearCheckboxes = function _ReportDebtPage_clearCheckboxes() {
        __classPrivateFieldGet(this, _ReportDebtPage_headerCheckbox, "f").prop('checked', false);
        __classPrivateFieldGet(this, _ReportDebtPage_itemCheckboxes, "f").prop('checked', false);
    }, _ReportDebtPage_togglePaymentRegistryForm = function _ReportDebtPage_togglePaymentRegistryForm() {
        var _a;
        const state = Number(__classPrivateFieldGet(this, _ReportDebtPage_toggleFormButton, "f").attr('data-state'));
        __classPrivateFieldGet(this, _ReportDebtPage_toggleFormButton, "f").html((_a = __classPrivateFieldGet(this, _ReportDebtPage_toggleFormButton, "f").attr(`data-state${state}-text`)) !== null && _a !== void 0 ? _a : '');
        __classPrivateFieldGet(this, _ReportDebtPage_toggleFormButton, "f").attr('data-state', 1 - state);
        __classPrivateFieldGet(this, _ReportDebtPage_instances, "m", _ReportDebtPage_clearCheckboxes).call(this);
        if (state) {
            __classPrivateFieldGet(this, _ReportDebtPage_headerCheckbox, "f").closest('span').hideByClass();
            $('.js-debt-item .js-form-item-field', this.root).closest('span').hideByClass();
            $('.js-debt-registry-form', this.root).hideByClass();
        }
        else {
            __classPrivateFieldGet(this, _ReportDebtPage_headerCheckbox, "f").closest('span').showByClass();
            $('.js-debt-item .js-form-item-field', this.root).closest('span').showByClass();
            $('.js-debt-registry-form', this.root).showByClass();
        }
    }, _ReportDebtPage_showPaymentRegistryDialog = function _ReportDebtPage_showPaymentRegistryDialog() {
        if (__classPrivateFieldGet(this, _ReportDebtPage_itemCheckboxes, "f").filter(':checked').length === 0) {
            __classPrivateFieldGet(this, _ReportDebtPage_popup, "f").show({
                content: App.templates.Message({ type: 1 /* MessageType.Warning */, text: 'Пожалуйста, выберите хотя бы один заказ.' }),
            });
            return false;
        }
        const ids = $('.js-debt-item .js-form-item-field')
            .filter(':checked')
            .get()
            .map(v => $(v).val());
        const dialog = $(App.templates.Report.Messages.ConfirmPaymentRegistryDialog({
            orders: ids,
            ordersStr: ids.join(', '),
            url: __classPrivateFieldGet(this, _ReportDebtPage_options, "f").urls.getReportPaymentRegistry,
        }));
        dialog.on('click', '#acceptPaymentRegistry', () => App.popupHide());
        dialog.on('click', '#declinePaymentRegistry', () => App.popupHide());
        App.popupShow(dialog, 'Сформировать реестр на оплату');
        __classPrivateFieldGet(this, _ReportDebtPage_instances, "m", _ReportDebtPage_clearCheckboxes).call(this);
        return true;
    };
    App.ReportDebtPage = ReportDebtPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ReportFtaPage_instances, _ReportFtaPage_filterByTerritory;
    class ReportFtaPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ReportFtaPage_instances.add(this);
            const filter = new App.Filter();
            this.components.push(new App.Form({ root: filter.root }));
            $('.js-filter-territory', this.root).on('change', e => __classPrivateFieldGet(this, _ReportFtaPage_instances, "m", _ReportFtaPage_filterByTerritory).call(this, e));
        }
    }
    _ReportFtaPage_instances = new WeakSet(), _ReportFtaPage_filterByTerritory = function _ReportFtaPage_filterByTerritory(event) {
        event.preventDefault();
        const self = $(event.currentTarget);
        const value = Number(self.find('input').val());
        $('.js-table-report', this.root).find('tr').removeClass('_hidden-2');
        if (value > -1) {
            $('.js-table-report', this.root).find(`tr[data-territory!='${value}']`).addClass('_hidden-2');
        }
    };
    App.ReportFtaPage = ReportFtaPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ReportRatingPage_instances, _ReportRatingPage_options, _ReportRatingPage_ratingTypeOption, _ReportRatingPage_tabs, _ReportRatingPage_filter, _ReportRatingPage_responseValidator, _ReportRatingPage_onSwitchRatingType, _ReportRatingPage_loadOrders, _ReportRatingPage_loadStarHistory, _ReportRatingPage_onSubmitPeriodForm, _ReportRatingPage_updateOptions;
    class ReportRatingPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ReportRatingPage_instances.add(this);
            _ReportRatingPage_options.set(this, void 0);
            _ReportRatingPage_ratingTypeOption.set(this, void 0);
            _ReportRatingPage_tabs.set(this, void 0);
            _ReportRatingPage_filter.set(this, void 0);
            _ReportRatingPage_responseValidator.set(this, void 0);
            __classPrivateFieldSet(this, _ReportRatingPage_options, options, "f");
            __classPrivateFieldSet(this, _ReportRatingPage_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ReportRatingPage_tabs, "f").showActive();
            __classPrivateFieldSet(this, _ReportRatingPage_filter, new App.Filter(), "f");
            __classPrivateFieldSet(this, _ReportRatingPage_ratingTypeOption, $('.js-rating-type-option', this.root), "f");
            __classPrivateFieldGet(this, _ReportRatingPage_ratingTypeOption, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ReportRatingPage_instances, "m", _ReportRatingPage_onSwitchRatingType).call(this, e); }));
            __classPrivateFieldGet(this, _ReportRatingPage_filter, "f").root.on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _ReportRatingPage_instances, "m", _ReportRatingPage_onSubmitPeriodForm).call(this, e); }));
            $('.js-bonus-period .js-jelect').on('change', (e) => __awaiter(this, void 0, void 0, function* () {
                const target = $(e.target);
                const value = Number(target.val());
                __classPrivateFieldGet(this, _ReportRatingPage_instances, "m", _ReportRatingPage_updateOptions).call(this, target, value);
            }));
        }
    }
    _ReportRatingPage_options = new WeakMap(), _ReportRatingPage_ratingTypeOption = new WeakMap(), _ReportRatingPage_tabs = new WeakMap(), _ReportRatingPage_filter = new WeakMap(), _ReportRatingPage_responseValidator = new WeakMap(), _ReportRatingPage_instances = new WeakSet(), _ReportRatingPage_onSwitchRatingType = function _ReportRatingPage_onSwitchRatingType(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const target = $(event.currentTarget);
            const isActive = target.hasClass('_active');
            const id = target.attr('data-type');
            const ratingWrap = target.parents('.js-rating-type-wrap');
            const ratingTypeWrap = $(`.js-rating-type-data[data-type="${id}"]`, ratingWrap);
            if (!isActive) {
                $('.js-rating-type-option', ratingWrap).removeClass('_active');
                target.addClass('_active');
                $('.js-rating-type-data', ratingWrap).removeClass('_active').hide();
                ratingTypeWrap.addClass('_active').show();
            }
            const isNeedLoadOrders = target.hasClass('js-rating-load-orders');
            const isNeedLoadStarHistory = target.hasClass('js-rating-load-starhistory');
            const isDataLoaded = Number(target.attr('data-loaded')) === 1;
            const ratingId = (_a = ratingWrap.attr('data-tab')) !== null && _a !== void 0 ? _a : '';
            if (isNeedLoadOrders && !isDataLoaded)
                yield __classPrivateFieldGet(this, _ReportRatingPage_instances, "m", _ReportRatingPage_loadOrders).call(this, ratingTypeWrap, ratingId);
            else if (isNeedLoadStarHistory && !isDataLoaded)
                yield __classPrivateFieldGet(this, _ReportRatingPage_instances, "m", _ReportRatingPage_loadStarHistory).call(this, ratingTypeWrap, ratingId);
        });
    }, _ReportRatingPage_loadOrders = function _ReportRatingPage_loadOrders(wrap, ratingId) {
        return __awaiter(this, void 0, void 0, function* () {
            $('.js-loading', wrap).toggle();
            $('.js-rating-orders-empty', wrap).hide();
            $('.js-rating-orders', wrap).empty();
            __classPrivateFieldSet(this, _ReportRatingPage_responseValidator, new App.ResponseValidator({
                messenger: new App.BlockMessenger(new App.Messages({ root: $('.js-messages', wrap) })),
            }), "f");
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _ReportRatingPage_options, "f").urls.getOrders, { body: new URLSearchParams({ ratingId: ratingId }) });
                if (!__classPrivateFieldGet(this, _ReportRatingPage_responseValidator, "f").process(response))
                    return;
                const parentWrap = wrap.parent();
                if (response.data.include.length === 0) {
                    $('.js-rating-type-data[data-type="include"] .js-rating-orders-empty', parentWrap).show();
                }
                else {
                    const incList = $(App.templates.Rating.RatingOrders({ orders: response.data.include }));
                    $('.js-rating-type-data[data-type="include"] .js-rating-orders', parentWrap).empty().append(incList);
                }
                if (response.data.notInclude.length === 0) {
                    $('.js-rating-type-data[data-type="notinclude"] .js-rating-orders-empty', parentWrap).show();
                }
                else {
                    const notIncList = $(App.templates.Rating.RatingOrders({ orders: response.data.notInclude }));
                    $('.js-rating-type-data[data-type="notinclude"] .js-rating-orders', parentWrap).empty().append(notIncList);
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ReportRatingPage_responseValidator, "f").processError(ex))
                    throw ex;
                return;
            }
            finally {
                $('.js-loading', wrap).toggle();
                wrap.parent().find('.js-rating-load-orders').attr('data-loaded', '1');
            }
        });
    }, _ReportRatingPage_loadStarHistory = function _ReportRatingPage_loadStarHistory(wrap, ratingId) {
        return __awaiter(this, void 0, void 0, function* () {
            $('.js-loading', wrap).toggle();
            $('.js-rating-starhistory-empty', wrap).hide();
            $('.js-rating-starhistory', wrap).empty();
            __classPrivateFieldSet(this, _ReportRatingPage_responseValidator, new App.ResponseValidator({
                messenger: new App.BlockMessenger(new App.Messages({ root: $('.js-messages', wrap) })),
            }), "f");
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _ReportRatingPage_options, "f").urls.getStarHistory, { body: new URLSearchParams({ ratingId: ratingId }) });
                if (!__classPrivateFieldGet(this, _ReportRatingPage_responseValidator, "f").process(response))
                    return;
                if (response.data.history.length === 0) {
                    $('.js-rating-starhistory-empty', wrap).show();
                }
                else {
                    const history = $(App.templates.Rating.StarHistory({ items: response.data.history }));
                    $('.js-rating-starhistory', wrap).empty().append(history);
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ReportRatingPage_responseValidator, "f").processError(ex))
                    throw ex;
                return;
            }
            finally {
                $('.js-loading', wrap).toggle();
                wrap.parent().find('.js-rating-load-starhistory').attr('data-loaded', '1');
            }
        });
    }, _ReportRatingPage_onSubmitPeriodForm = function _ReportRatingPage_onSubmitPeriodForm(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const target = $(event.currentTarget);
            const wrap = target.parents('.js-rating-type-data');
            $('.js-loading-result', wrap).toggle();
            __classPrivateFieldSet(this, _ReportRatingPage_responseValidator, new App.ResponseValidator({
                messenger: new App.BlockMessenger(new App.Messages({ root: $('.js-messages', wrap) })),
            }), "f");
            try {
                const data = new FormData($('.js-periodForm', wrap).get(0));
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _ReportRatingPage_options, "f").urls.getRatingByPeriod, { body: data });
                if (!__classPrivateFieldGet(this, _ReportRatingPage_responseValidator, "f").process(response))
                    return;
                $('.js-rating-result', wrap).empty().html(response.data);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _ReportRatingPage_responseValidator, "f").processError(ex))
                    throw ex;
                return;
            }
            finally {
                $('.js-loading-result', wrap).toggle();
            }
        });
    }, _ReportRatingPage_updateOptions = function _ReportRatingPage_updateOptions(target, value) {
        const wrap = target.parents('.js-rating-type-data');
        const type = Number($('.js-periodForm', wrap).find('input[name="RatingTypeKey"]').val());
        const key = Number($('.js-periodForm', wrap).find('input[name="RatingKey"]').val());
        const control = __classPrivateFieldGet(this, _ReportRatingPage_filter, "f").findControl('Months');
        const periods = __classPrivateFieldGet(this, _ReportRatingPage_options, "f").typePeriods[key][type];
        const data = periods[value];
        data[0].selected = true;
        if (control == null)
            return;
        if (control !== undefined && control instanceof App.FilterListBlockBase)
            control.replaceOptions(data, true);
    };
    App.ReportRatingPage = ReportRatingPage;
})(App || (App = {}));
var App;
(function (App) {
    var _ReportSeasonAccentPage_tabs;
    class ReportSeasonAccentPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _ReportSeasonAccentPage_tabs.set(this, void 0);
            __classPrivateFieldSet(this, _ReportSeasonAccentPage_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _ReportSeasonAccentPage_tabs, "f").showActive();
        }
    }
    _ReportSeasonAccentPage_tabs = new WeakMap();
    App.ReportSeasonAccentPage = ReportSeasonAccentPage;
})(App || (App = {}));
var App;
(function (App) {
    var _TourBookPage_instances, _a, _TourBookPage_defaultDigestServiceOrder, _TourBookPage_options, _TourBookPage_initialized, _TourBookPage_offer, _TourBookPage_services, _TourBookPage_tourInsuranceCoverage, _TourBookPage_formOrder, _TourBookPage_buttonOrder, _TourBookPage_filter, _TourBookPage_form, _TourBookPage_popup, _TourBookPage_responseValidator, _TourBookPage_pricePresenter, _TourBookPage_spoilerContent, _TourBookPage_hotelData, _TourBookPage_extraServices, _TourBookPage_placementPersons, _TourBookPage_cancellationRuleCheckerField, _TourBookPage_controls, _TourBookPage_optionsSet, _TourBookPage_valuateOrBookExecuting, _TourBookPage_valuateAbortController, _TourBookPage_bookAbortController, _TourBookPage_aviaResultComponent, _TourBookPage_dynamicHotelVariants, _TourBookPage_existingPassengers, _TourBookPage_bestPriceItems, _TourBookPage_agentBlackListComponent, _TourBookPage_cancellationRuleChecker_get, _TourBookPage_initHotelData, _TourBookPage_showHotelVariantSelection, _TourBookPage_generateHotelImage, _TourBookPage_updateDynamicHotelVariants, _TourBookPage_finishInitialization, _TourBookPage_onAviaGroupClick, _TourBookPage_initInsurances, _TourBookPage_initInsurance, _TourBookPage_updateGroupedService, _TourBookPage_addCustomValidationRules, _TourBookPage_onSpoilerClick, _TourBookPage_changeOffer, _TourBookPage_onBasicVariantSelect, _TourBookPage_updateHotelVariant, _TourBookPage_updateDynamicHotelVariant, _TourBookPage_updateHotelAvailability, _TourBookPage_getSelectedHotelVariant, _TourBookPage_changeHotelRoom, _TourBookPage_changeActivePersonTab, _TourBookPage_filterTransfers, _TourBookPage_createTransferVisiblePredicate, _TourBookPage_isTransferVisible, _TourBookPage_valuate, _TourBookPage_recalcPrice, _TourBookPage_getServiceTourists, _TourBookPage_updateTourInsuranceCoverage, _TourBookPage_getDigestData, _TourBookPage_generateFlightTags, _TourBookPage_getDigestServiceOrder, _TourBookPage_getServiceName, _TourBookPage_getFlightResults, _TourBookPage_getServiceDescription, _TourBookPage_getDigestServiceName, _TourBookPage_changeInitials, _TourBookPage_filterAllTouristServices, _TourBookPage_filterTouristServices, _TourBookPage_validateAge, _TourBookPage_validateIssueCity, _TourBookPage_validateWithVisa, _TourBookPage_validateCoverage, _TourBookPage_getServiceCurrentPrices, _TourBookPage_getServicePrices, _TourBookPage_selectedOptionsChanged, _TourBookPage_onBookingButtonClick, _TourBookPage_booking, _TourBookPage_onBookPrivateClick, _TourBookPage_tryFocusFirstInvalidField, _TourBookPage_isByProgramTransfer, _TourBookPage_onChangeTouristCitizenship, _TourBookPage_getIsDomestic, _TourBookPage_onChangeTouristDocumentType, _TourBookPage_initTouristDocumentProperties, _TourBookPage_checkQuota, _TourBookPage_onActionInfoShow, _TourBookPage_loadAnnouncement, _TourBookPage_loadDynamicHotels, _TourBookPage_fillDocumentTypes, _TourBookPage_onTouristChosen;
    class TourBookPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _TourBookPage_instances.add(this);
            _TourBookPage_options.set(this, void 0);
            _TourBookPage_initialized.set(this, void 0);
            // TODO: '!' используется из-за https://github.com/microsoft/TypeScript/issues/21132
            _TourBookPage_offer.set(this, void 0);
            // TODO: '!' используется из-за https://github.com/microsoft/TypeScript/issues/21132
            _TourBookPage_services.set(this, void 0);
            _TourBookPage_tourInsuranceCoverage.set(this, void 0);
            _TourBookPage_formOrder.set(this, void 0);
            _TourBookPage_buttonOrder.set(this, void 0);
            _TourBookPage_filter.set(this, void 0);
            _TourBookPage_form.set(this, void 0);
            _TourBookPage_popup.set(this, void 0);
            _TourBookPage_responseValidator.set(this, void 0);
            _TourBookPage_pricePresenter.set(this, void 0);
            _TourBookPage_spoilerContent.set(this, void 0);
            _TourBookPage_hotelData.set(this, void 0);
            _TourBookPage_extraServices.set(this, void 0);
            _TourBookPage_placementPersons.set(this, void 0);
            _TourBookPage_cancellationRuleCheckerField.set(this, void 0);
            _TourBookPage_controls.set(this, new Array());
            _TourBookPage_optionsSet.set(this, void 0);
            _TourBookPage_valuateOrBookExecuting.set(this, false);
            _TourBookPage_valuateAbortController.set(this, void 0);
            _TourBookPage_bookAbortController.set(this, void 0);
            _TourBookPage_aviaResultComponent.set(this, void 0);
            _TourBookPage_dynamicHotelVariants.set(this, []);
            _TourBookPage_existingPassengers.set(this, void 0);
            _TourBookPage_bestPriceItems.set(this, []);
            _TourBookPage_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _TourBookPage_options, options, "f");
        }
        mount() {
            super.mount();
            __classPrivateFieldSet(this, _TourBookPage_initialized, false, "f");
            __classPrivateFieldSet(this, _TourBookPage_formOrder, $('.js-form-order', this.root), "f");
            this.components.push(App.scheduleExpirationPopup({
                interval: __classPrivateFieldGet(this, _TourBookPage_options, "f").offerExpiration,
            }));
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_changeOffer).call(this, __classPrivateFieldGet(this, _TourBookPage_options, "f").offer);
            __classPrivateFieldSet(this, _TourBookPage_tourInsuranceCoverage, {
                amount: 0,
                currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
            }, "f");
            this.components.push(new App.FindTourist());
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _TourBookPage_agentBlackListComponent, new App.AgentBlackListComponent({ useForm: true }), "f");
                this.components.push(__classPrivateFieldGet(this, _TourBookPage_agentBlackListComponent, "f"));
            }
            // Контейнер размещение туристов.
            __classPrivateFieldSet(this, _TourBookPage_placementPersons, $('.js-order-placement-persons', this.root), "f");
            // Note: инициализируем по шагам ДО создания экземпляра Form, т.к. нам нужно перехватывать события change у полей ФИО и заменять
            // значения этих полей до вызова валидации данных.
            // Перенесено inline из методов из-за https://github.com/microsoft/TypeScript/issues/21132.
            // #region initStep1
            // Спойлер списка отелей.
            const spoilerSwitcher = $('.js-spoiler-toggle', this.root);
            __classPrivateFieldSet(this, _TourBookPage_spoilerContent, $('.js-spoiler-content', this.root), "f");
            spoilerSwitcher.on('click', e => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onSpoilerClick).call(this, e));
            __classPrivateFieldSet(this, _TourBookPage_hotelData, __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_initHotelData).call(this), "f");
            __classPrivateFieldSet(this, _TourBookPage_extraServices, $('.js-person-extra-service-group', __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").container), "f");
            __classPrivateFieldGet(this, _TourBookPage_extraServices, "f").on('change', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this); }));
            $('.js-basic-variants', __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").container).on("pw:show" /* Events.Show */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_showHotelVariantSelection).call(this, e, data); }));
            $('.js-basic-variants', __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").container).on("pw:hide" /* Events.Hide */, (e, data) => {
                var _b;
                if (!data.target.hasClass('js-basic-variants'))
                    return;
                const itemContainer = $(e.currentTarget);
                const index = parseInt((_b = itemContainer.attr('data-idx')) !== null && _b !== void 0 ? _b : '0', 10);
                const groupContainer = itemContainer.closest('.js-order-placement-item');
                $(`.js-order-placement-item-hotel:eq(${index})`, groupContainer).show();
            });
            // Запрос условий аннуляции
            this.root.on('click', '.js-order-placement-hotel .js-cancellation-rules', (e) => __awaiter(this, void 0, void 0, function* () {
                e.preventDefault();
                e.stopPropagation();
                const targetElement = $(e.target);
                const policy = yield __classPrivateFieldGet(this, _TourBookPage_instances, "a", _TourBookPage_cancellationRuleChecker_get).getCancellationPolicy(targetElement, new App.BlockMessenger(new App.Messages({ root: $('.js-messages', targetElement) })));
                if (!policy)
                    return;
                const model = new App.VariantCancellationViewModel('', policy);
                const updateTarget = $('.js-order-placement-hotel .js-cancellation-rules', this.root);
                App.CancellationRuleChecker.renderChangedCancellationPolicy(model, updateTarget, false);
            }));
            // Выбор другого номера.
            __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").container.on('click', '.js-checkbox-hotel', (e) => __awaiter(this, void 0, void 0, function* () {
                var _b, _c;
                const target = $(e.currentTarget);
                const variantKey = target.attr('data-id');
                if (!variantKey)
                    return;
                const itemContainer = target.closest('.js-basic-variants');
                const index = parseInt((_b = itemContainer.attr('data-idx')) !== null && _b !== void 0 ? _b : '0', 10);
                const groupContainer = itemContainer.closest('.js-order-placement-item');
                const groupIndex = parseInt((_c = groupContainer.attr('data-idx')) !== null && _c !== void 0 ? _c : '0', 10);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateHotelVariant).call(this, groupContainer, groupIndex, index, variantKey);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_changeHotelRoom).call(this, groupIndex);
                App.VariantsShowMoreComponent.hide(target);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTransfers).call(this);
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateHotelAvailability).call(this, groupContainer);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this, App.TourServiceType.Hotel);
            }));
            /* TODO: на данный момент не используется.
            // Удаление отеля.
            hotel.find('.js-order-placement-hotel-close').on('click', e => {
                hotel.addClass('_hidden').slideUp({
                    complete: () => {
                        this.#optionsSet
                            .find('[name*="hotels[' + hotel.attr('data-increment') + '][persons]"]')
                            .closest('.js-person-options-initials')
                            .remove();
                        this.#placementPersons
                            .find('.js-order-placement-persons-item[data-increment=' + hotel.attr('data-increment') + ']')
                            .remove();
                        this.#digestHotels.find('[data-idx=' + hotel.attr('data-increment') + ']').remove();
                        $(e.currentTarget).remove();
                        this.getBasePrice();
                    }
                });
                this.#placementHotels.slideUp();
            });
            */
            $('.js-basic-flight', this.root).on('change', '.js-basic-variant-input', () => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTransfers).call(this);
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this, App.TourServiceType.Flight);
            }));
            $('.js-basic-transfer', this.root).on('change', '.js-basic-variant-input', () => __awaiter(this, void 0, void 0, function* () {
                // Note: для фильтрации обратных трансферов.
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTransfers).call(this);
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this, App.TourServiceType.Transfer);
            }));
            $('.js-basic-other', this.root).on('change', '.js-basic-variant-input', (e) => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(_a, _a, "m", _TourBookPage_onBasicVariantSelect).call(_a, e);
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this, App.TourServiceType.Custom);
            }));
            this.components.push(new App.VariantsShowMoreComponent({ root: this.root }));
            // Изменение страховок у всех туристов разом.
            $('.js-person-service-group input', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                const target = $(e.currentTarget);
                const group = target.closest('.js-person-service-group');
                const groupKey = group.attr('data-group-key');
                if (!groupKey)
                    return;
                group
                    .find('input[value="different"]').closest('.js-person-service')
                    .hideByClass();
                const personsGroup = $(`.js-person-insurance-services[data-group-key="${groupKey}"]`, __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f"));
                const value = target.valString();
                const input = $(`.js-person-services .js-person-service input[value="${value}"]:enabled`, personsGroup);
                input.prop('checked', true);
                App.VariantsShowMoreComponent.update(input);
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this, true);
            }));
            // #endregion
            // #region initStep2
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").find('.js-form-date')
                .datepicker('option', 'changeYear', true)
                .datepicker('option', 'changeMonth', true)
                .inputmask('date');
            // Табы персон в одной группе отелей.
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('click', '.js-person-tab', e => {
                const target = $(e.currentTarget);
                const tabs = $(e.currentTarget).closest('.js-persons-tabs');
                const tab = $('.js-person-tab', tabs);
                const wrap = $('.js-person-tab-wrap', tabs);
                const next = $('.js-person-tab-next', tabs);
                tab.removeClass('_active');
                target.addClass('_active');
                wrap.removeClass('_active').eq(target.index()).addClass('_active');
                // Прячем кнопку 'Следующий турист'.
                next.toggleClass('_hidden', wrap.length - 1 === target.index());
            });
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('click', '.js-person-tab-next', e => {
                const tabs = $(e.currentTarget).closest('.js-persons-tabs');
                const tab = $('.js-person-tab', tabs);
                tab.filter('._active').next().trigger('click');
            });
            // Переключение пола М/Ж.
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('change', '.js-form-gender-input', e => {
                const input = $(e.currentTarget);
                const gender = input.closest('.js-form-gender');
                const icon = $('.js-form-gender-icon', gender);
                const tab = input.closest('[data-tab]').attr('data-tab');
                if (!tab)
                    return;
                const tabIcon = input.closest('.js-persons-tabs').find(`[data-target="${tab}"] .js-form-gender-icon`);
                icon.add(tabIcon).toggleClass('_man', input.is(':checked') && input.val() === 'Male');
                icon.add(tabIcon).toggleClass('_woman', input.is(':checked') && input.val() === 'Female');
            });
            // TODO: также реализовать для динамически добавляемых туристов.
            $('.js-person-tab-initials-a, .js-person-tab-initials-b', __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f")).on('change', e => {
                const target = $(e.currentTarget);
                target.val(App.transliterateName(target.valString()));
            });
            // Инициалы персон в табах.
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('change', '.js-person-tab-initials-a, .js-person-tab-initials-b', e => {
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_changeInitials).call(this, e);
            });
            // Изменение даты рождения.
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('change', '.js-person-birthday', (e) => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_changeInitials).call(this, e);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTouristServices).call(this, $(e.currentTarget));
                const target = $(e.currentTarget);
                const personContainer = target.closest('.js-person-tab-wrap');
                App.PassportPage.setDocumentIssueDateValidationForTour($(personContainer));
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this);
            }));
            // Изменение гражданства.
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('change', '.js-person-citizenship .js-jelect', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onChangeTouristCitizenship).call(this, e); }));
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('change', '.js-person-document-type .js-jelect', e => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onChangeTouristDocumentType).call(this, e));
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('click', '.js-person-visa-services input', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this, true); }));
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('click', '.js-person-insurance-services input', (e) => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateGroupedService).call(this, $(e.currentTarget));
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this, true);
            }));
            // Изменение города подачи визы.
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('change', '.js-person-visa-city .js-jelect', (e) => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTouristServices).call(this, $(e.currentTarget));
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this, true);
            }));
            // Изменение страхования невыхода визы.
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").on('change', '.js-person-insurance-visa .js-jelect', (e) => __awaiter(this, void 0, void 0, function* () {
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTouristServices).call(this, $(e.currentTarget));
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this, true);
            }));
            // #endregion
            // #region initStep3
            // Используется для установки инициалов.
            __classPrivateFieldSet(this, _TourBookPage_optionsSet, $('.js-options-set', this.root), "f");
            // Группа опций (экскурсии).
            __classPrivateFieldGet(this, _TourBookPage_optionsSet, "f").each((index, element) => {
                const jqElement = $(element);
                const toggle = $('.js-options-set-toggle', jqElement);
                const dateSelector = jqElement.find('.js-options-date .js-jelect');
                // Общий чекбокс для группы.
                toggle.on('click', (e) => __awaiter(this, void 0, void 0, function* () {
                    const target = $(e.currentTarget);
                    const checkbox = target.is(':checkbox');
                    // Note: для НЕ-checkbox инвертируем значение, т.к. click на checkbox возвращает новое значение (а-ля после нажатия),
                    // а click на НЕ-checkbox - старое (до нажатия).
                    const checked = checkbox ? target.is(':checked') : !target.is('._checked, ._checked-half');
                    if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
                        return false;
                    if (checked)
                        dateSelector.find('.js-jelect-input').attr('required', 'required');
                    else
                        dateSelector.find('.js-jelect-input').removeAttr('required');
                    if (!checkbox)
                        target.removeClass('_checked-half').toggleClass('_checked', checked);
                    const items = $('.js-options-set-item', jqElement);
                    items.each((index2, element2) => {
                        const itemTarget = $(element2);
                        const itemCheckbox = itemTarget.is(':checkbox');
                        if (itemCheckbox)
                            itemTarget.prop('checked', checked);
                        else
                            itemTarget.toggleClass('_checked', checked);
                    });
                    yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_selectedOptionsChanged).call(this, jqElement);
                    return true;
                }));
                dateSelector.on('change', (e) => __awaiter(this, void 0, void 0, function* () {
                    const target = $(e.currentTarget);
                    const serviceKey = target.valString();
                    jqElement.attr('data-key', serviceKey);
                    toggle.filter(':input').val(serviceKey);
                    jqElement.find('.js-order-options-input').filter(':input').val(serviceKey);
                    jqElement.find('.js-person-options-price').hideByClass();
                    const variant = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].services)
                        .selectMany(v => v.variants)
                        .firstOrDefault(v => v.key === serviceKey);
                    if (variant != null && !variant.isGroupPrice) {
                        const adults = $('.js-options-set-adult .js-person-options-price', jqElement);
                        adults.map((_, adult) => { var _b; return adult.children[0].setAttribute('amount', ((_b = variant.adultGrossPrice) !== null && _b !== void 0 ? _b : 0).toString()); });
                        const childs = $('.js-options-set-child .js-person-options-price', jqElement);
                        childs.map((_, child) => { var _b; return child.children[0].setAttribute('amount', ((_b = variant.childGrossPrice) !== null && _b !== void 0 ? _b : 0).toString()); });
                        jqElement.find('.js-person-options-price').showByClass();
                    }
                    yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_selectedOptionsChanged).call(this, jqElement);
                }));
                // Синхронизуем чекбоксы персон с общим чекбоксом.
                jqElement.on('click', '.js-options-set-item', (e) => __awaiter(this, void 0, void 0, function* () {
                    const target = $(e.currentTarget);
                    const checkbox = target.is(':checkbox');
                    // Note: для НЕ-checkbox инвертируем значение, т.к. click на checkbox возвращает новое значение (а-ля после нажатия), а
                    // click на НЕ-checkbox - старое (до нажатия).
                    const checked = checkbox ? target.is(':checked') : !target.is('._checked');
                    const toggleCheckbox = toggle.is(':checkbox');
                    if (target.attr('disabled') === 'true' || target.attr('disabled') === 'disabled')
                        return false;
                    if (!checkbox)
                        target.toggleClass('_checked', checked);
                    const items = $('.js-options-set-item', jqElement);
                    const checkedCount = items.filter(':checked, ._checked').length;
                    if (toggleCheckbox) {
                        target.prop('checked', checkedCount > 0);
                    }
                    else {
                        toggle
                            .toggleClass('_checked', checkedCount === items.length)
                            .toggleClass('_checked-half', checkedCount !== 0 && checkedCount < items.length);
                    }
                    yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_selectedOptionsChanged).call(this, jqElement);
                    return true;
                }));
            });
            // #endregion
            __classPrivateFieldSet(this, _TourBookPage_buttonOrder, $('.js-order-submit', __classPrivateFieldGet(this, _TourBookPage_formOrder, "f")), "f");
            __classPrivateFieldSet(this, _TourBookPage_filter, new App.Filter({ root: __classPrivateFieldGet(this, _TourBookPage_formOrder, "f") }), "f");
            __classPrivateFieldSet(this, _TourBookPage_form, new App.Form({ root: __classPrivateFieldGet(this, _TourBookPage_filter, "f").root, disableStepValidation: true }), "f");
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_addCustomValidationRules).call(this);
            __classPrivateFieldSet(this, _TourBookPage_popup, new App.Popup({
                onShow: () => {
                    $('.js-popup-close', __classPrivateFieldGet(this, _TourBookPage_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _TourBookPage_popup, "f").hide());
                    $('.js-popup-redirect', __classPrivateFieldGet(this, _TourBookPage_popup, "f").root).on('click', e => {
                        const url = e.target.getAttribute('data-url');
                        if (url)
                            window.location.href = url;
                    });
                },
            }), "f");
            __classPrivateFieldSet(this, _TourBookPage_responseValidator, new App.ResponseValidator({
                messenger: new App.PopupMessenger(__classPrivateFieldGet(this, _TourBookPage_popup, "f")),
                validator: __classPrivateFieldGet(this, _TourBookPage_form, "f").validator,
                allowEmptyData: true,
            }), "f");
            this.components.push(new App.Digest({ container: this.root }));
            const digest = $('.js-digest', this.root);
            digest.on('click', '.js-digest-footer-details-show', () => {
                $('.js-digest-footer-wrap', digest).addClass('_detail');
            });
            digest.on('click', '.js-digest-footer-details-hide', () => {
                $('.js-digest-footer-wrap', digest).removeClass('_detail');
            });
            $(document).on("NetPricePresenter:click" /* Events.NetPricePresenterClick */, () => {
                $('.js-digest-footer-wrap', digest).removeClass('_detail');
            });
            this.components.push(new App.PromoCodeComponent({
                root: this.root,
                onSubmit: () => __awaiter(this, void 0, void 0, function* () {
                    yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this, false, App.noneSignal);
                    return __classPrivateFieldGet(this, _TourBookPage_offer, "f").isPromoCodeApplied;
                }),
                onRemove: () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this, false, App.noneSignal); }),
            }));
            __classPrivateFieldGet(this, _TourBookPage_buttonOrder, "f").on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onBookingButtonClick).call(this, e); }));
            $('.js-pw-order-submit-private', __classPrivateFieldGet(this, _TourBookPage_formOrder, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onBookPrivateClick).call(this); }));
            __classPrivateFieldSet(this, _TourBookPage_pricePresenter, new App.NetPricePresenter({ root: this.root, desired: App.AdditionalPriceShow.ToPay }), "f");
            this.components.push(new App.ActionInfoComponent());
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onActionInfoShow).call(this, e, data); }));
            __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f").find('.js-person-tab-wrap').each((i, v) => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_initTouristDocumentProperties).call(this, $(v)));
            this.components.push(new App.BestPriceComponent({
                getData: () => __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f"),
            }));
            $(document).on("store:pac:offerconstructor:serviceadd" /* widgets.Events.OfferConstructorServiceAdd */, (e) => __awaiter(this, void 0, void 0, function* () {
                const data = yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getDigestData).call(this);
                // Note: используется dispatchEvent, т.к. события, вызываемые при помощи jQuery.trigger, не ловятся методом addEventListener
                // на стороне сайта (при помощи своей копии jQuery).
                document.dispatchEvent(new CustomEvent("store:pac:offerconstructor:servicejson" /* widgets.Events.OfferConstructorServiceJson */, {
                    detail: {
                        // Свойство необходимо для связки ответа с первоначальным запросом на запрашиваемой стороне.
                        state: e.detail,
                        data,
                    },
                }));
            }));
            $('.js-flight-class input, .js-flight-direct input', this.root).on('change', () => __awaiter(this, void 0, void 0, function* () { yield __classPrivateFieldGet(this, _TourBookPage_aviaResultComponent, "f").newSearch(__classPrivateFieldGet(this, _TourBookPage_formOrder, "f").serializeArray()); }));
            App.AviaResultComponent.initMiddleName(this.root, false);
            __classPrivateFieldSet(this, _TourBookPage_existingPassengers, new App.ExistingPassengers(), "f");
            __classPrivateFieldGet(this, _TourBookPage_existingPassengers, "f").root.on("tourist:choose" /* Events.TouristChoose */, (_, passengerWrap) => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onTouristChosen).call(this, passengerWrap));
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                if (__classPrivateFieldGet(this, _TourBookPage_offer, "f").dynamicFlight) {
                    __classPrivateFieldSet(this, _TourBookPage_aviaResultComponent, new App.AviaResultComponent({
                        root: $('.js-flights-regular', this.root),
                        formRoot: $('.js-form-order', this.root),
                        data: __classPrivateFieldGet(this, _TourBookPage_formOrder, "f").serializeArray(),
                        beginDate: App.parseIsoDate(__classPrivateFieldGet(this, _TourBookPage_offer, "f").beginDate),
                        urls: __classPrivateFieldGet(this, _TourBookPage_options, "f").urls.aviaUrls,
                    }), "f");
                    __classPrivateFieldGet(this, _TourBookPage_aviaResultComponent, "f").getRoot()
                        .on("avia:searchCompleted" /* Events.AviaSearchCompleted */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_finishInitialization).call(this); }))
                        .on("avia:toggleBookButton" /* Events.AviaToggleBookButton */, (_, data) => __awaiter(this, void 0, void 0, function* () {
                        __classPrivateFieldGet(this, _TourBookPage_buttonOrder, "f").prop('disabled', data);
                    }))
                        .on("avia:groupClick" /* Events.AviaGroupClick */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_onAviaGroupClick).call(this, e, data); }))
                        .on("avia:flightChanged" /* Events.AviaFlightChanged */, () => __awaiter(this, void 0, void 0, function* () {
                        if (__classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTransfers).call(this))
                            yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this);
                        else
                            yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this);
                    }));
                    this.components.push(__classPrivateFieldGet(this, _TourBookPage_aviaResultComponent, "f"));
                }
                else {
                    const personContainers = this.root.find('.js-person-tab-wrap');
                    $.each(personContainers, (i, personContainer) => {
                        const isDomestic = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getIsDomestic).call(this, $(personContainer));
                        // устанавливаем наиболее правильный тип документа
                        const touristType = $(personContainer).attr('data-tourist-type');
                        App.PassportPage.tuneTouristDocumentPropertiesForTour($(personContainer), touristType, isDomestic);
                    });
                    yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_finishInitialization).call(this);
                }
            });
        }
        updateDigest(data) {
            this.updateBestPriceItems(data);
            $('.js-digest-content', this.root)
                .empty()
                .append(App.templates.Tour.BookDigestContent(data));
            const containerFooter = $('.js-digest-footer', this.root);
            const bestPrice = $('.js-best-price-component').detach();
            containerFooter.empty();
            const contentFooter = $(App.templates.BookDigestFooter(data));
            contentFooter.append(bestPrice.toggle(data.price > 0));
            containerFooter.append(contentFooter);
            $(document).trigger("digest:update" /* Events.DigestUpdate */);
        }
        updateBestPriceItems(data) {
            const hotel = data.hotels[0];
            if (!hotel)
                return;
            __classPrivateFieldSet(this, _TourBookPage_bestPriceItems, [], "f");
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'hotelName', value: hotel.hotel.name });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'hotelCategory', value: hotel.hotel.categoryCode.toString() });
            if (hotel.url)
                __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'hotelUrl', value: hotel.url });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'country', value: data.countryName });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'resort', value: data.resortName });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'dateFrom', value: hotel.beginDate });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'dateTo', value: hotel.endDate });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'price', value: App.formatNumber(data.grossPrice, 'moneyEdit') });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'currencyCode', value: data.currencyCode });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'rooms[0].roomType', value: hotel.roomTypeName });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'rooms[0].boardType', value: hotel.boardName });
            __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: 'rooms[0].touristCount', value: `${data.adultCount + data.childCount}` });
            hotel.childAges.forEach((v, i) => __classPrivateFieldGet(this, _TourBookPage_bestPriceItems, "f").push({ key: `rooms[0].childAges[${i}]`, value: `${v}` }));
        }
    }
    _a = TourBookPage, _TourBookPage_options = new WeakMap(), _TourBookPage_initialized = new WeakMap(), _TourBookPage_offer = new WeakMap(), _TourBookPage_services = new WeakMap(), _TourBookPage_tourInsuranceCoverage = new WeakMap(), _TourBookPage_formOrder = new WeakMap(), _TourBookPage_buttonOrder = new WeakMap(), _TourBookPage_filter = new WeakMap(), _TourBookPage_form = new WeakMap(), _TourBookPage_popup = new WeakMap(), _TourBookPage_responseValidator = new WeakMap(), _TourBookPage_pricePresenter = new WeakMap(), _TourBookPage_spoilerContent = new WeakMap(), _TourBookPage_hotelData = new WeakMap(), _TourBookPage_extraServices = new WeakMap(), _TourBookPage_placementPersons = new WeakMap(), _TourBookPage_cancellationRuleCheckerField = new WeakMap(), _TourBookPage_controls = new WeakMap(), _TourBookPage_optionsSet = new WeakMap(), _TourBookPage_valuateOrBookExecuting = new WeakMap(), _TourBookPage_valuateAbortController = new WeakMap(), _TourBookPage_bookAbortController = new WeakMap(), _TourBookPage_aviaResultComponent = new WeakMap(), _TourBookPage_dynamicHotelVariants = new WeakMap(), _TourBookPage_existingPassengers = new WeakMap(), _TourBookPage_bestPriceItems = new WeakMap(), _TourBookPage_agentBlackListComponent = new WeakMap(), _TourBookPage_instances = new WeakSet(), _TourBookPage_cancellationRuleChecker_get = function _TourBookPage_cancellationRuleChecker_get() {
        if (!__classPrivateFieldGet(this, _TourBookPage_cancellationRuleCheckerField, "f"))
            __classPrivateFieldSet(this, _TourBookPage_cancellationRuleCheckerField, new App.CancellationRuleChecker({ url: __classPrivateFieldGet(this, _TourBookPage_options, "f").urls.hotelCancellationPolicy }), "f");
        return __classPrivateFieldGet(this, _TourBookPage_cancellationRuleCheckerField, "f");
    }, _TourBookPage_initHotelData = function _TourBookPage_initHotelData() {
        const container = $('.js-hotels', this.root);
        return {
            container,
            dynamicHotelInput: $('[name="Form.Hotel"]', container),
            dynamicProgressLoader: $('.js-progress-data-loading', container),
            searchResults: __classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels
                .map(() => ({
                initialized: false,
            })),
        };
    }, _TourBookPage_showHotelVariantSelection = function _TourBookPage_showHotelVariantSelection(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            if (!data.target.hasClass('js-basic-variants'))
                return;
            if (!__classPrivateFieldGet(this, _TourBookPage_hotelData, "f"))
                return;
            const itemContainer = $(e.currentTarget);
            const index = parseInt((_b = itemContainer.attr('data-idx')) !== null && _b !== void 0 ? _b : '0', 10);
            const groupContainer = itemContainer.closest('.js-order-placement-item');
            $(`.js-order-placement-item-hotel:eq(${index})`, groupContainer).hide();
            const searchResultData = __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").searchResults[index];
            const service = __classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels[index];
            if (!searchResultData.initialized) {
                const offers = Enumerable.from(service.variants)
                    .where(v => !v.hotel.isVirtual)
                    .groupBy(v => v.hotel.key, v => v, (_, v) => {
                    const services = v.toArray();
                    return { hotel: services[0].hotel, services };
                })
                    .select(v => ({
                    // from IHotelOfferBase
                    grossPrice: 0,
                    totalGrossPrice: 0,
                    price: 0,
                    currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                    key: v.hotel.key,
                    link: v.hotel.isFake
                        ? ''
                        : v.services[0].url,
                    countryName: v.hotel.countryName,
                    name: v.hotel.name,
                    stars: `${v.hotel.categoryCode}`,
                    address: v.hotel.isFake
                        // TODO: вынести в WCF-сервис и убрать поля countryName / cityName.
                        ? `${v.hotel.countryName}, ${v.hotel.cityName}, ${v.hotel.address}`
                        : v.hotel.address,
                    /* TODO: не генерить ссылку на fake-отели (необходимы изменения в модели и шаблонах отелей)
                    @if (Model.Hotel.IsFake)
                        <img src="..." alt="" />
                    else
                        <a href="..." target="_blank">
                            <img src="..." alt="" />
                        </a>
                    */
                    // TODO: переносить формирование ссылок для картинок на HBS или в саму модель?
                    image: __classPrivateFieldGet(_a, _a, "m", _TourBookPage_generateHotelImage).call(_a, v.hotel),
                    coordinate: {
                        latitude: 0,
                        longitude: 0,
                    },
                    generalRating: 0,
                    accommodationTypeCode: '',
                    type: '',
                    cityAreas: [],
                    facilities: [],
                    // from HotelOfferViewModel
                    variants: Enumerable.from(v.services)
                        .select(x => ({
                        // from IHotelOfferBase
                        grossPrice: x.grossPrice,
                        totalGrossPrice: x.grossPrice,
                        price: x.price,
                        currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                        // from ICancellationVariant
                        key: x.key,
                        coloredPhrase: undefined,
                        cancellationInfoList: undefined,
                        cancellationPolicyCode: undefined,
                        available: x.quota !== App.QuotaStatus.No,
                        // from IHotelVariant
                        // from HotelSimpleVariantViewModel
                        providerItemKey: x.key,
                        adultCount: x.adultCount,
                        childCount: x.childAges.length,
                        childAges: x.childAges,
                        touristCount: x.adultCount + x.childAges.length,
                        room: x.roomName,
                        roomGroups: [x.roomName],
                        board: x.boardName,
                        boardGroup: x.boardName,
                        quantity: 1,
                        // from HotelVariantViewModel
                        included: x.included,
                        provider: undefined,
                        notes: x.notes,
                        // TODO: не используется, т.к. нужна информация в другом виде, которую я сразу получаю с сервера
                        // TODO: использовать это поле, как при поиске туров с ДД.
                        cancellationPolicy: {
                            code: null,
                            hasPenalty: false,
                            rules: [],
                        },
                        freeCancellation: false,
                        transferIncluded: undefined,
                        visaAssistance: undefined,
                        byRequest: undefined,
                        extraGroups: [],
                        promotions: {
                            appliedPromotions: [],
                            bonusPrice: {
                                amount: 0,
                                currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                            },
                            isPromoCodeApplied: false,
                        },
                        // Нижележащие поля заполняются вне данной услуги.
                        dynamic: true,
                        // Нижележащие поля заполняются после получения данных с сервера.
                        link: '',
                        currency: {
                            code: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                            symbol: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                            name: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                        },
                        beginDate: x.beginDate,
                        endDate: x.endDate,
                        isBest: false,
                        isLastBest: false,
                        selected: false,
                        sortPrice: x.grossPrice,
                        showOptions: false,
                    }))
                        .toArray(),
                    // Нижележащие поля заполняются вне данной услуги.
                    dynamic: true,
                    // Нижележащие поля заполняются после получения данных с сервера.
                    gettingOrder: 0,
                    bookingComOffer: false,
                    distanceFromPointOfInterest: 0,
                    distanceFromPointOfInterestText: '',
                    toCompare: false,
                    active: false,
                    sortPrice: 0,
                }))
                    .toArray();
                const hotFilter = new App.HotFilter();
                // TODO: в шаблоне присутствует только лишь контейнер для view='table' и отсутствуют элементы .js-view-item, определяющие список доступных view и по которым можно определить активный или fallback view, без чего по-умолчанию считается view='block', контейнера под который нет в текущем шаблоне.
                hotFilter.activeView = 'table';
                const control = new App.HotelSearchResult({
                    root: App.app.container.find(`.js-hotels .js-basic-variants[data-idx="${index}"] .js-basic-variant`),
                    hotFilter,
                });
                searchResultData.control = control;
                searchResultData.initialized = true;
                yield searchResultData.control.changeDataSource(offers);
                if (__classPrivateFieldGet(this, _TourBookPage_offer, "f").hasExtraDynamicHotels) {
                    __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").dynamicProgressLoader.show();
                    try {
                        __classPrivateFieldGet(this, _TourBookPage_dynamicHotelVariants, "f").push(...service.variants);
                        yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_loadDynamicHotels).call(this, (variants) => __awaiter(this, void 0, void 0, function* () {
                            return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateDynamicHotelVariants).call(this, service, control, offers[0], variants);
                        }));
                    }
                    finally {
                        __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").dynamicProgressLoader.hide();
                    }
                }
            }
            else if (__classPrivateFieldGet(this, _TourBookPage_offer, "f").hasExtraDynamicHotels) {
                const selectedKeys = service.variants.filter(v => v.selectedCount > 0).map(v => v.key);
                App.emptyArray(service.variants);
                service.variants.push(...__classPrivateFieldGet(this, _TourBookPage_dynamicHotelVariants, "f"));
                service.variants.forEach(v => (v.selectedCount = selectedKeys.includes(v.key) ? 1 : 0));
            }
            $('.js-basic-variant', itemContainer).show();
        });
    }, _TourBookPage_generateHotelImage = function _TourBookPage_generateHotelImage(hotel) {
        if (hotel.isFake)
            return `/img/tour/hotel_${hotel.categoryCode}.jpg`;
        if (!hotel.image)
            return '/img/common/no_photo.png';
        return `https://store.pac.ru/img.ashx?it=1&id=${hotel.image.id}&is=p107&bp=1`;
    }, _TourBookPage_updateDynamicHotelVariants = function _TourBookPage_updateDynamicHotelVariants(service, control, offer, variants) {
        return __awaiter(this, void 0, void 0, function* () {
            /* const oldVariant = Enumerable.from(service.variants)
                .where(v => v.key === this.#hotelData.dynamicHotelInput.val())
                .first();*/
            variants.forEach(v => {
                const days = App.dateDiff(App.parseIsoDate(v.checkout), App.parseIsoDate(v.checkin)).getTotalDays();
                const serviceVariant = {
                    key: v.key,
                    // providerKey: oldVariant.providerKey,
                    providerKey: v.providerKey,
                    // beginDate: oldVariant.beginDate,
                    beginDate: v.checkin,
                    // days: oldVariant.days,
                    days,
                    // nights: oldVariant.nights,
                    nights: days - 1,
                    hasPrice: true,
                    isGroupPrice: true,
                    isFixedPrice: true,
                    isRelativePrice: false,
                    adultGrossPrice: undefined,
                    adultPrice: undefined,
                    childGrossPrice: undefined,
                    childPrice: undefined,
                    netPrice: v.netPrice,
                    grossPrice: v.grossPrice,
                    price: v.price,
                    // adultCount: oldVariant.adultCount,
                    adultCount: v.adultCount,
                    // childAges: oldVariant.childAges,
                    childAges: v.childAges,
                    quota: App.QuotaStatus.Yes,
                    selectedCount: 0,
                    isDefault: false,
                    nonCommission: false,
                    // endDate: oldVariant.endDate,
                    endDate: v.checkout,
                    // hotel: oldVariant.hotel,
                    hotel: service.variants[0].hotel,
                    roomKey: 1,
                    roomTypeName: v.room,
                    roomCategoryName: '',
                    roomAccommodationName: '',
                    boardKey: 1,
                    boardName: v.board,
                    cancellationPolicy: v.cancellationPolicy,
                    included: v.included,
                    notes: v.notes,
                    extras: [],
                    extraGroups: [],
                    roomName: v.room,
                    url: '',
                };
                __classPrivateFieldGet(this, _TourBookPage_dynamicHotelVariants, "f").push(serviceVariant);
                /* if (v.key !== oldVariant.key)
                    service.variants.push(serviceVariant);*/
                service.variants.push(serviceVariant);
                const cancellationViewModel = new App.VariantCancellationViewModel(v.key, v.cancellationPolicy);
                const variant = Object.assign(Object.assign({}, v), { 
                    // from IHotelVariant
                    childCount: v.childAges.length, touristCount: v.adultCount + v.childAges.length, cancellationPolicy: null, freeCancellation: false, 
                    // from ICancellationVariant
                    coloredPhrase: cancellationViewModel === null || cancellationViewModel === void 0 ? void 0 : cancellationViewModel.coloredPhrase, cancellationInfoList: cancellationViewModel === null || cancellationViewModel === void 0 ? void 0 : cancellationViewModel.cancellationInfoList, cancellationPolicyCode: cancellationViewModel === null || cancellationViewModel === void 0 ? void 0 : cancellationViewModel.cancellationPolicyCode, available: true, extraGroups: [], promotions: {
                        appliedPromotions: [],
                        bonusPrice: {
                            amount: 0,
                            currencyCode: v.currencyCode,
                        },
                        isPromoCodeApplied: false,
                    }, 
                    // Нижележащие поля заполняются вне данной услуги.
                    dynamic: true, 
                    // Нижележащие поля заполняются после получения данных с сервера.
                    isBest: false, isLastBest: false, selected: false, sortPrice: v.grossPrice, showOptions: false });
                offer.variants.push(variant);
            });
            yield control.changeDataSource([offer], true);
        });
    }, _TourBookPage_finishInitialization = function _TourBookPage_finishInitialization() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTransfers).call(this))
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this, true);
            const data = yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getDigestData).call(this);
            yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateTourInsuranceCoverage).call(this, data);
            yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_fillDocumentTypes).call(this);
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_initInsurances).call(this);
            __classPrivateFieldSet(this, _TourBookPage_initialized, true, "f");
            yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this);
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this);
        });
    }, _TourBookPage_onAviaGroupClick = function _TourBookPage_onAviaGroupClick(event, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const needDocument = data.needDocument;
            $('.js-person-document-number, .js-person-document-expirationdate', __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f")).each((i, v) => {
                const block = $(v);
                $('.form-item', block).toggleClass('_required', needDocument);
                if (needDocument)
                    $('input', block).attr('required', 'required');
                else
                    $('input', block).removeAttr('required');
            });
            const needIssueDate = needDocument && data.needIssueDate;
            $('.js-person-document-issuedate', __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f")).each((i, v) => {
                const block = $(v);
                $('.form-item', block).toggleClass('_required', needIssueDate);
                if (needIssueDate)
                    $('input', block).attr('required', 'required');
                else
                    $('input', block).removeAttr('required');
            });
            const needMiddleName = data.needMiddleName;
            App.AviaResultComponent.initMiddleName(this.root, needMiddleName);
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this, App.TourServiceType.Flight);
        });
    }, _TourBookPage_initInsurances = function _TourBookPage_initInsurances() {
        const basicContainer = $('.js-form-step-content', this.root).eq(0).find('.js-basic-container');
        const health = __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances.find(v => v.variants[0].type === 0 /* KnownInsuranceType.Health */);
        if (health)
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_initInsurance).call(this, basicContainer, health, false, 1);
        const requiredContainer = $('.js-form-step-content', this.root).eq(0).find('.js-required-container');
        const cc = __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances.find(v => v.variants[0].type === 3 /* KnownInsuranceType.CancellationCoverage */);
        if (cc)
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_initInsurance).call(this, requiredContainer, cc, true, 1);
        const sm = __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances.find(v => v.variants[0].type === 13 /* KnownInsuranceType.SaveMoney */);
        if (sm)
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_initInsurance).call(this, requiredContainer, sm, true);
        const fd = __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances.find(v => v.variants[0].type === 8 /* KnownInsuranceType.FlightDelay */);
        if (fd)
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_initInsurance).call(this, requiredContainer, fd, true, 1);
    }, _TourBookPage_initInsurance = function _TourBookPage_initInsurance(container, service, filterByCoverage, selectedIndex = 0) {
        var _b;
        const variants = Enumerable.from(service.variants).orderBy(v => { var _b; return (_b = v.coverage.min) !== null && _b !== void 0 ? _b : 0; }).toArray();
        const groupContainer = container.find(`.js-person-service-group[data-group-key="insurance.${(_b = variants[0].type) !== null && _b !== void 0 ? _b : 0}"]`);
        if (filterByCoverage) {
            $('.js-person-service', groupContainer).hideByClass();
            $('.js-person-service:has(input[value=""])', groupContainer).showByClass();
            const minVariant = variants[0];
            $(`.js-person-service:has(input[value="${minVariant.key}"])`, groupContainer).showByClass();
            const suitableVariant = variants.find(v => (v.coverage.min == null || v.coverage.min <= __classPrivateFieldGet(this, _TourBookPage_tourInsuranceCoverage, "f").amount)
                && (v.coverage.max == null || v.coverage.max >= __classPrivateFieldGet(this, _TourBookPage_tourInsuranceCoverage, "f").amount));
            if (suitableVariant)
                $(`.js-person-service:has(input[value="${suitableVariant.key}"])`, groupContainer).showByClass();
        }
        const jqSelected = $('.js-person-service:visible', groupContainer).eq(selectedIndex).find('input');
        if (jqSelected.length > 0 && !jqSelected.is(':checked'))
            jqSelected.trigger('click');
    }, _TourBookPage_updateGroupedService = function _TourBookPage_updateGroupedService(target) {
        const container = target.closest('.js-person-insurance-services');
        const groupKey = container.attr('data-group-key');
        if (groupKey == null)
            return;
        const step1Container = $('.js-form-step-content', this.root).eq(0).find(`.js-person-service-group[data-group-key="${groupKey}"]`);
        if (step1Container.length <= 0)
            return;
        const elements = __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f")
            .find(`.js-person-insurance-services[data-group-key="${groupKey}"] input:checked`);
        const values = elements.get().map(v => v.value);
        const step1Input = step1Container.find(`.js-person-service input[value="${values[0]}"]`);
        const hasGroupedVariant = values.every(v => v === values[0]) && step1Input.length > 0;
        if (hasGroupedVariant)
            step1Input.prop('checked', true);
        const step1Different = step1Container.find('input[value="different"]').closest('.js-person-service');
        if (step1Different.length > 0) {
            if (!hasGroupedVariant) {
                const amount = elements.get()
                    .map(v => { var _b; return Number((_b = $(v).attr('data-price')) !== null && _b !== void 0 ? _b : '0'); })
                    .reduce((p, c) => p + c);
                step1Different.find(App.Money.tagName).get(0).amount = amount;
                step1Different.find('input').prop('checked', true);
            }
            step1Different.toggleByClass(!hasGroupedVariant);
        }
    }, _TourBookPage_addCustomValidationRules = function _TourBookPage_addCustomValidationRules() {
        $.validator.addMethod('nonvirtualhotel', (value) => {
            if (typeof value !== 'string')
                return false;
            const variant = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels)
                .selectMany(v => v.variants)
                .firstOrDefault(v => v.key === value);
            return !!variant && !variant.hotel.isVirtual;
        });
    }, _TourBookPage_onSpoilerClick = function _TourBookPage_onSpoilerClick(e) {
        const target = $(e.currentTarget);
        const data = target.attr('data-spoiler');
        if (!data)
            return;
        target.toggleClass('_opened');
        __classPrivateFieldGet(this, _TourBookPage_spoilerContent, "f").filter(`[data-spoiler="${data}"]`).slideToggle();
    }, _TourBookPage_changeOffer = function _TourBookPage_changeOffer(offer) {
        __classPrivateFieldSet(this, _TourBookPage_offer, offer, "f");
        const serviceGroup = __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0];
        /* eslint-disable max-len */
        __classPrivateFieldSet(this, _TourBookPage_services, {
            // Для шага 1.
            basicHotels: serviceGroup.services
                .filter(v => !v.isAdditional && !v.isTourist && v.type.code === App.KnownPacketServiceType.Hotel),
            basicFlights: serviceGroup.services
                .filter(v => !v.isAdditional && !v.isTourist && v.type.code === App.KnownPacketServiceType.Flight),
            basicTransfers: serviceGroup.services
                .filter(v => !v.isAdditional && !v.isTourist && v.type.code === App.KnownPacketServiceType.Transfer),
            optionalTransfers: serviceGroup.services
                .filter(v => v.isAdditional && v.isOptional && !v.isTourist && v.type.code === App.KnownPacketServiceType.Transfer),
            basicActivities: serviceGroup.services
                .filter(v => !v.isAdditional && !v.isTourist && v.type.code === App.KnownPacketServiceType.Excursion),
            basicOthers: serviceGroup.services
                .filter(v => !v.isAdditional && !v.isTourist && v.type.code !== App.KnownPacketServiceType.Hotel && v.type.code !== App.KnownPacketServiceType.Flight && v.type.code !== App.KnownPacketServiceType.Transfer && v.type.code !== App.KnownPacketServiceType.Insurance && v.type.code !== App.KnownPacketServiceType.Excursion),
            required: serviceGroup.services
                .filter(v => v.isAdditional && !v.isOptional && !v.isTourist),
            // Для шага 2.
            touristVisas: Enumerable.from(serviceGroup.services)
                .where(v => v.isTourist && v.type.code === App.KnownPacketServiceType.Visa)
                .selectMany(v => v.variants)
                .toArray(),
            touristInsurances: serviceGroup.services
                .filter(v => v.isTourist && v.type.code === App.KnownPacketServiceType.Insurance),
            touristOthers: serviceGroup.services
                .filter(v => v.isTourist && v.type.code !== App.KnownPacketServiceType.Visa && v.type.code !== App.KnownPacketServiceType.Insurance && v.type.code !== App.KnownPacketServiceType.Excursion),
            // Для шага 3.
            optionalActivities: serviceGroup.services
                .filter(v => v.isAdditional && v.isOptional && !v.isTourist && v.type.code === App.KnownPacketServiceType.Excursion),
            touristActivities: serviceGroup.services
                .filter(v => v.isTourist && v.type.code === App.KnownPacketServiceType.Excursion),
            optionalOthers: serviceGroup.services
                .filter(v => v.isAdditional && v.isOptional && !v.isTourist && v.type.code !== App.KnownPacketServiceType.Transfer && v.type.code !== App.KnownPacketServiceType.Excursion),
        }, "f");
        /* eslint-enable max-len */
    }, _TourBookPage_onBasicVariantSelect = function _TourBookPage_onBasicVariantSelect(e) {
        App.VariantsShowMoreComponent.hide($(e.currentTarget));
    }, _TourBookPage_updateHotelVariant = function _TourBookPage_updateHotelVariant(container, groupIndex, index, variantKey) {
        const variants = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels).selectMany(v => v.variants);
        const currentVariant = variants.first(v => v.key === $('.js-placement-hotel-input', container).valString());
        currentVariant.selectedCount = 0;
        const selectedVariant = variants.first(v => v.key === variantKey);
        selectedVariant.selectedCount = 1;
        $(`.js-placement-hotel-input:eq(${index})`, container).val(selectedVariant.key);
        __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateDynamicHotelVariant).call(this);
        const data = {
            variant: selectedVariant,
            cancellationPolicy: new App.VariantCancellationViewModel(selectedVariant.key, selectedVariant.cancellationPolicy),
            currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
        };
        const placementPersonsItem = $(`.js-order-placement-persons-item:eq(${groupIndex})`, __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f"));
        $(`.js-order-placement-item-hotel:eq(${index})`, container)
            .empty()
            .append(App.templates.Tour.OrderPlacementHotelView(data));
        $(`.js-order-placement-item:eq(${index})`, placementPersonsItem)
            .empty()
            .append(App.templates.Tour.OrderPlacementHotelView(data));
    }, _TourBookPage_updateDynamicHotelVariant = function _TourBookPage_updateDynamicHotelVariant() {
        if (__classPrivateFieldGet(this, _TourBookPage_offer, "f").dynamicHotel) {
            const dynamicHotelOfferKeys = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels)
                .selectMany(v => v.variants)
                .where(v => v.selectedCount > 0)
                .select(v => v.key)
                .toArray();
            __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").dynamicHotelInput.val(dynamicHotelOfferKeys.join(';'));
        }
    }, _TourBookPage_updateHotelAvailability = function _TourBookPage_updateHotelAvailability(container) {
        const selectedVariant = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getSelectedHotelVariant).call(this, container);
        const data = {
            variant: selectedVariant,
        };
        $('.js-placement-availability', __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").container)
            .empty()
            .append(App.templates.Tour.OrderPlacementHotelAvailability(data));
    }, _TourBookPage_getSelectedHotelVariant = function _TourBookPage_getSelectedHotelVariant(container) {
        const variants = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels).selectMany(v => v.variants);
        return variants.first(v => v.key === $('.js-placement-hotel-input', container).valString());
    }, _TourBookPage_changeHotelRoom = function _TourBookPage_changeHotelRoom(groupIndex) {
        const group = __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[groupIndex];
        // Определяем предыдущее кол-во взрослых и детей в группе.
        const placementPersonsItem = $(`.js-order-placement-persons-item:eq(${groupIndex})`, __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f"));
        const adultInitials = $('.js-person-tab-initials-adult', placementPersonsItem);
        const prevAdults = adultInitials.length;
        // Корректируем кол-во контейнеров для вводимой инф-ии по туристам и кол-во галочек по опциональным услугам.
        const adultWraps = $('.js-person-tab-wrap-adult', placementPersonsItem);
        const optionsSetOptional = $('.js-options-set-optional', __classPrivateFieldGet(this, _TourBookPage_optionsSet, "f"));
        const optionsSetTourist = $('.js-options-set-tourist', __classPrivateFieldGet(this, _TourBookPage_optionsSet, "f"));
        if (prevAdults !== group.adultCount) {
            if (prevAdults < group.adultCount) {
                const lastAdultInitial = adultInitials.last();
                const lastAdultWrap = adultWraps.last();
                for (let i = group.adultCount - 1; i >= prevAdults; i--) {
                    const personIndex = i;
                    lastAdultInitial.after(App.templates.Tour.BookTouristTab({ index: i, isChild: false }));
                    const model = {
                        groupIndex,
                        index: i,
                        touristAge: null,
                        // TODO minBirthday?: Date
                        // TODO maxBirthday?: Date
                        maxIssueDate: new Date(),
                        // TODO minExpirationDate?: Date
                        requiresEmail: __classPrivateFieldGet(this, _TourBookPage_offer, "f").dynamicFlight,
                        isChild: false,
                        selected: false,
                        visaServices: __classPrivateFieldGet(this, _TourBookPage_services, "f").touristVisas,
                        insuranceServices: __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances,
                        otherServices: __classPrivateFieldGet(this, _TourBookPage_services, "f").touristOthers,
                        citizenshipCountries: new App.SelectListModel({
                            name: `Form.ServiceGroups[${groupIndex}].TouristServices[adult${i}].Tourist.CitizenshipCountryKey`,
                            form: true,
                            autocomplete: false,
                            items: __classPrivateFieldGet(this, _TourBookPage_options, "f").citizenshipCountries
                                .map(v => ({
                                value: v.value,
                                text: v.text,
                                selected: v.selected,
                            })),
                        }),
                    };
                    const wrapContent = $(App.templates.Tour.BookTouristWrap(model));
                    const blocks = wrapContent.find('.js-filter-select-block, .js-form-select-block').get();
                    for (let j = 0; j < blocks.length; j++) {
                        // TODO: добавлять в this.#form
                        __classPrivateFieldGet(this, _TourBookPage_controls, "f").push(new App.FilterSelectBlock({ root: $(blocks[j]) }));
                    }
                    lastAdultWrap.after(wrapContent);
                    // TODO: не оптимально.
                    optionsSetOptional.each((_, element) => {
                        const target = $(element);
                        const optionsSet = target.closest('.js-options-set');
                        const selected = optionsSet.find('.js-options-set-toggle').is(':checked');
                        const container = target.find('.js-options-set-adult');
                        container.append(App.templates.Tour.BookOptionOptional({ index: personIndex, isChild: false, selected }));
                    });
                    // TODO: не оптимально.
                    optionsSetTourist.each((_, element) => {
                        const target = $(element);
                        const optionsSet = target.closest('.js-options-set');
                        const serviceIndex = optionsSet.attr('data-idx');
                        const key = optionsSet.attr('data-key');
                        const selected = optionsSet.find('.js-options-set-toggle').is('._checked');
                        const container = target.find('.js-options-set-adult');
                        container.append(App.templates.Tour.BookOptionTourist({
                            serviceIndex,
                            index: personIndex,
                            isChild: false,
                            selected,
                            key,
                        }));
                    });
                }
            }
            else if (prevAdults > group.adultCount) {
                $(`:gt(${group.adultCount - 1})`, adultInitials).remove();
                $(`:gt(${group.adultCount - 1})`, adultWraps).remove();
                __classPrivateFieldGet(this, _TourBookPage_optionsSet, "f").each((i, v) => { $(`.js-options-set-men .js-person-options-initials:gt(${group.adultCount - 1})`, v).remove(); });
            }
        }
        // Note: элементы childInitials могут отсутствовать.
        let childInitials = $('.js-person-tab-initials-child', placementPersonsItem);
        const prevChildren = childInitials.length;
        if (prevChildren !== group.childAges.length) {
            // Note: не можем использовать adultInitials, т.к. их кол-во могло измениться (см. код выше).
            if (childInitials.length <= 0)
                childInitials = $('.js-person-tab-initials-adult', placementPersonsItem);
            let childWraps = $('.js-person-tab-wrap-child', placementPersonsItem);
            // Note: не можем использовать adultWraps, т.к. их кол-во могло измениться (см. код выше).
            if (childWraps.length <= 0)
                childWraps = $('.js-person-tab-wrap-adult', placementPersonsItem);
            if (prevChildren < group.childAges.length) {
                const lastChildInitial = childInitials.last();
                const lastChildWrap = childWraps.last();
                for (let i = group.childAges.length - 1; i >= prevChildren; i--) {
                    const personIndex = i;
                    lastChildInitial.after(App.templates.Tour.BookTouristTab({ index: i, isChild: true }));
                    const model = {
                        groupIndex,
                        index: i,
                        touristAge: group.childAges[i],
                        // TODO minBirthday?: Date
                        // TODO maxBirthday?: Date
                        maxIssueDate: new Date(),
                        // TODO minExpirationDate?: Date
                        requiresEmail: false,
                        isChild: true,
                        selected: false,
                        visaServices: __classPrivateFieldGet(this, _TourBookPage_services, "f").touristVisas,
                        insuranceServices: __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances,
                        otherServices: __classPrivateFieldGet(this, _TourBookPage_services, "f").touristOthers,
                        citizenshipCountries: new App.SelectListModel({
                            name: `Form.ServiceGroups[${groupIndex}].TouristServices[child{i}].Tourist.CitizenshipCountryKey`,
                            form: true,
                            autocomplete: false,
                            items: __classPrivateFieldGet(this, _TourBookPage_options, "f").citizenshipCountries
                                .map(v => ({
                                value: v.value,
                                text: v.text,
                                selected: v.selected,
                            })),
                        }),
                    };
                    lastChildWrap.after(App.templates.Tour.BookTouristWrap(model));
                    // TODO: не оптимально.
                    optionsSetOptional.each((index, element) => {
                        const target = $(element);
                        const optionsSet = target.closest('.js-options-set');
                        const selected = optionsSet.find('.js-options-set-toggle').is(':checked');
                        const container = target.find('.js-options-set-child');
                        container.append(App.templates.Tour.BookOptionOptional({ index: personIndex, isChild: true, selected }));
                    });
                    // TODO: не оптимально.
                    optionsSetTourist.each((index, element) => {
                        const target = $(element);
                        const optionsSet = target.closest('.js-options-set');
                        const serviceIndex = optionsSet.attr('data-idx');
                        const key = optionsSet.attr('data-key');
                        const selected = optionsSet.find('.js-options-set-toggle').is('._checked');
                        const container = target.find('.js-options-set-child');
                        container.append(App.templates.Tour.BookOptionTourist({
                            serviceIndex,
                            index: personIndex,
                            isChild: true,
                            selected,
                            key,
                        }));
                    });
                }
            }
            else if (prevChildren > group.childAges.length) {
                $(`:gt(${group.childAges.length - 1})`, childInitials).remove();
                $(`:gt(${group.childAges.length - 1})`, childWraps).remove();
                __classPrivateFieldGet(this, _TourBookPage_optionsSet, "f").each((i, v) => { $(`.js-options-set-child .js-person-options-initials:gt(${group.childAges.length - 1})`, v).remove(); });
            }
            // Чтобы не заморачиваться с отслеживанием предыдущего активного туриста (например, если активным был второй взрослый в
            // номере 2ADT+1CHD, а потом тип номера поменяли на 1ADT+1CHD, то активным должен стать взрослый или ребенок?), просто
            // делаем активным первого взрослого.
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_changeActivePersonTab).call(this, 'adult0');
        }
    }, _TourBookPage_changeActivePersonTab = function _TourBookPage_changeActivePersonTab(id) {
        $(`.js-person-tab[data-target="${id}"]`, __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f")).trigger('click');
    }, _TourBookPage_filterTransfers = function _TourBookPage_filterTransfers() {
        const isTransferVisiblePredicate = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_createTransferVisiblePredicate).call(this);
        // Обработка основных трансферов.
        const basicTransfers = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicTransfers).selectMany(v => v.variants);
        let basicChanged = false;
        const selectedBasicTransfers = new Array();
        $('.js-basic-transfer', this.root).each((groupIndex, groupElement) => {
            var _b;
            const service = __classPrivateFieldGet(this, _TourBookPage_services, "f").basicTransfers[groupIndex];
            // Note: трансферы, которые идут не в дни перелета (первый и последний день тура), не должны фильтроваться.
            if (App.parseIsoDate(service.variants[0].beginDate).getTime() !== App.parseIsoDate(__classPrivateFieldGet(this, _TourBookPage_offer, "f").beginDate).getTime()
                && App.parseIsoDate(service.variants[0].endDate).getTime() !== App.parseIsoDate(__classPrivateFieldGet(this, _TourBookPage_offer, "f").endDate).getTime())
                return;
            let oldSelectedItem = Enumerable.from(service.variants)
                .where(v => v.selectedCount > 0)
                .firstOrDefault();
            if (oldSelectedItem == null && !service.isOptional)
                oldSelectedItem = service.variants[0];
            const emptyVariantElements = $('.js-basic-variant', groupElement).get()
                .filter(v => $('.js-basic-variant-input', $(v)).valString() === '');
            const emptyVariants = emptyVariantElements
                .map(element => {
                const container = $(element);
                return {
                    money: $(App.Money.tagName, container).get(0),
                    grossPrice: 0,
                };
            });
            const variantElements = $('.js-basic-variant', groupElement).get()
                .filter(v => $('.js-basic-variant-input', $(v)).valString() !== '');
            const variants = variantElements
                .map(element => {
                const container = $(element);
                const input = $('.js-basic-variant-input', container);
                const item = basicTransfers.first(v => v.key === input.valString());
                if (input.prop('checked'))
                    oldSelectedItem = item;
                return {
                    container,
                    input,
                    money: $(App.Money.tagName, container).get(0),
                    service: item,
                    isVisible: isTransferVisiblePredicate(item),
                    isDisabled: false,
                    grossPrice: item.grossPrice,
                };
            });
            let visibleVariants = variants.filter(v => v.isVisible);
            let availableVariants;
            if (visibleVariants.length > 0) {
                if (!service.isOptional) {
                    const baseGrossPrice = visibleVariants.length > 0 ? visibleVariants[0].grossPrice : 0;
                    visibleVariants.forEach(v => {
                        v.grossPrice -= baseGrossPrice;
                        v.isVisible = v.grossPrice >= 0;
                    });
                }
                const applyMaldivesFilter = __classPrivateFieldGet(this, _TourBookPage_offer, "f").countryKey === App.TourCountry.Maldives
                    && __classPrivateFieldGet(this, _TourBookPage_services, "f").basicTransfers.length === 2
                    && groupIndex > 0;
                if (applyMaldivesFilter) {
                    visibleVariants
                        .forEach(v => (v.isDisabled = v.service.transportName !== selectedBasicTransfers[0].transportName));
                }
                availableVariants = visibleVariants.filter(v => !v.isDisabled);
                if (availableVariants.length <= 0) {
                    visibleVariants.forEach(v => (v.isDisabled = false));
                    availableVariants = visibleVariants;
                }
            }
            else {
                // Если в результате фильтрации недоступны абсолютно все доступные варианты, то игнорируем фильтрацию и показываем всё.
                variants.forEach(v => (v.isVisible = true));
                visibleVariants = variants;
                availableVariants = visibleVariants;
            }
            // Определяем выбранный вариант.
            let newSelectedVariant = variants.find(v => v.input.prop('checked'));
            if (newSelectedVariant != null && (!newSelectedVariant.isVisible || newSelectedVariant.isDisabled)) {
                newSelectedVariant = availableVariants.find(v => v.service.isDefault);
                if (newSelectedVariant == null)
                    newSelectedVariant = Enumerable.from(availableVariants).minBy(v => v.service.grossPrice);
            }
            if (service.isOptional) {
                const grossPriceDelta = (_b = newSelectedVariant === null || newSelectedVariant === void 0 ? void 0 : newSelectedVariant.grossPrice) !== null && _b !== void 0 ? _b : 0;
                emptyVariants.forEach(v => (v.grossPrice -= grossPriceDelta));
                visibleVariants.forEach(v => (v.grossPrice -= grossPriceDelta));
            }
            // Применяем фильтрацию.
            emptyVariants.forEach(v => {
                v.money.amount = v.grossPrice;
            });
            variants.forEach(v => {
                if (v.money)
                    v.money.amount = v.grossPrice;
                v.container.toggle(v.isVisible);
                v.input.prop('checked', v.service.key === (newSelectedVariant === null || newSelectedVariant === void 0 ? void 0 : newSelectedVariant.service.key));
                v.container.toggleClass('_disabled', v.isDisabled);
                v.input.prop('disabled', v.isDisabled);
            });
            if (newSelectedVariant != null && (oldSelectedItem == null || oldSelectedItem.key !== newSelectedVariant.service.key)) {
                newSelectedVariant.container.toggle(true);
                if (!basicChanged)
                    basicChanged = oldSelectedItem == null || oldSelectedItem.key !== newSelectedVariant.service.key;
            }
            selectedBasicTransfers.push(...availableVariants.filter(v => v.input.prop('checked')).map(v => v.service));
        });
        // Обработка опциональных трансферов.
        const optionalTransfers = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").optionalTransfers)
            .selectMany(v => v.variants)
            .toArray();
        __classPrivateFieldGet(this, _TourBookPage_optionsSet, "f").each((index, element) => {
            const jqElement = $(element);
            const item = optionalTransfers.find(v => v.key === jqElement.attr('data-key'));
            if (!item)
                return;
            const isVisible = isTransferVisiblePredicate(item);
            jqElement.toggle(isVisible);
            if (!isVisible) {
                const toggle = $('.js-options-set-toggle', jqElement);
                // TODO: перенести логику сброса выбора опций в общую функцию или класс (см. toggle.on('click') в методе initStep3).
                const checkbox = toggle.is(':checkbox');
                // Note: для НЕ-checkbox инвертируем значение, т.к. click на checkbox возвращает новое значение (а-ля после нажатия),
                // а click на НЕ-checkbox - старое (до нажатия).
                const checked = checkbox ? toggle.is(':checked') : !toggle.is('._checked, ._checked-half');
                if (checked)
                    toggle.trigger('click');
            }
        });
        return basicChanged;
    }, _TourBookPage_createTransferVisiblePredicate = function _TourBookPage_createTransferVisiblePredicate() {
        var _b;
        if (__classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels.length <= 0)
            return () => true;
        const outboundArrivalCityKeys = new Array();
        const returnDepartureCityKeys = new Array();
        // Сбор информации по выбранным основным услугам (для фильтрации по новым правилам).
        const selectedCharterFlights = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicFlights)
            .selectMany(v => v.variants)
            .where(v => v.selectedCount > 0)
            .toArray();
        const selectedRegularFlight = (_b = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getFlightResults).call(this)) === null || _b === void 0 ? void 0 : _b.selectedFlight;
        const selectedHotels = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels)
            .selectMany(v => v.variants)
            .where(x => x.selectedCount > 0)
            .toArray();
        // Сбор информации по чартеру (для фильтрации по старым правилам).
        if (__classPrivateFieldGet(this, _TourBookPage_services, "f").basicFlights.length > 0) {
            // Услуги типа Отель здесь выступают в роли границы между перелетами туда-обратно.
            const charterGroups = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].services)
                .where(v => !v.isAdditional)
                .where(v => v.type.code === App.KnownPacketServiceType.Flight || v.type.code === App.KnownPacketServiceType.Hotel)
                .orderBy(v => new App.XDate(App.parseIsoDate(v.variants[0].beginDate)).trimTime().getTime())
                .thenBy(v => v.type.key)
                .toArray();
            const selectedCharterElements = $('.js-basic-flight .js-basic-variant-input', this.root).filter(':checked').get();
            const selectedCharterKeys = selectedCharterElements.map(v => $(v).valString());
            // Есть перелет 'туда'.
            if (charterGroups[0].type.code === App.KnownPacketServiceType.Flight) {
                const lastDepartureSegment = Enumerable.from(charterGroups)
                    .takeWhile(v => v.type.code === App.KnownPacketServiceType.Flight)
                    .last();
                lastDepartureSegment.variants
                    .filter(v => selectedCharterKeys.some(x => x === v.key))
                    .map(v => v.flight.arrivalCityKey)
                    .forEach(v => outboundArrivalCityKeys.push(v));
            }
            // Есть перелет 'обратно'.
            if (charterGroups[charterGroups.length - 1].type.code === App.KnownPacketServiceType.Flight) {
                const firstArrivalSegment = Enumerable.from(charterGroups)
                    .reverse()
                    .takeWhile(v => v.type.code === App.KnownPacketServiceType.Flight)
                    .last();
                firstArrivalSegment.variants
                    .filter(v => selectedCharterKeys.some(x => x === v.key))
                    .map(v => v.flight.departureCityKey)
                    .forEach(v => returnDepartureCityKeys.push(v));
            }
        }
        // Сбор информации по регулярке (для фильтрации по старым правилам).
        const flightResults = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getFlightResults).call(this);
        if (flightResults) {
            const selectedVariant = flightResults.selectedFlight.variants[0];
            if (flightResults.selectedFlight.flightType === 'RoundTrip') {
                const outboundLegSegments = selectedVariant.legs[0].segments;
                let cityKey = flightResults.flightCityMappings[outboundLegSegments[outboundLegSegments.length - 1].endCityKey];
                if (cityKey)
                    outboundArrivalCityKeys.push(cityKey);
                cityKey = flightResults.flightCityMappings[selectedVariant.legs[1].segments[0].cityKey];
                if (cityKey)
                    returnDepartureCityKeys.push(cityKey);
            }
            else if (flightResults.selectedFlight.isOutboundOneWay) {
                const { segments } = selectedVariant.legs[0];
                const cityKey = flightResults.flightCityMappings[segments[segments.length - 1].endCityKey];
                if (cityKey)
                    outboundArrivalCityKeys.push(cityKey);
            }
            else {
                const cityKey = flightResults.flightCityMappings[selectedVariant.legs[0].segments[0].cityKey];
                if (cityKey)
                    returnDepartureCityKeys.push(cityKey);
            }
        }
        return v => __classPrivateFieldGet(_a, _a, "m", _TourBookPage_isTransferVisible).call(_a, v, outboundArrivalCityKeys, returnDepartureCityKeys, selectedHotels, selectedCharterFlights, selectedRegularFlight);
    }, _TourBookPage_isTransferVisible = function _TourBookPage_isTransferVisible(source, outboundArrivalCityKeys, returnDepartureCityKeys, hotels, charterFlights, regularFlight) {
        const beginDate = App.parseIsoDate(source.beginDate);
        const endDate = App.parseIsoDate(source.endDate);
        // Note: новый механизм фильтрации (явно-заданные правила).
        if (source.pickupType !== 0 /* PacketTransferFilterType.None */ || source.dropoffType !== 0 /* PacketTransferFilterType.None */) {
            let isVisible = true;
            if (source.pickupType === 1 /* PacketTransferFilterType.Flight */) {
                if (source.pickupRegularAirportKeys.length > 0 || source.pickupAirportCodes.length > 0) {
                    if (regularFlight && source.pickupRegularAirportKeys.length > 0) {
                        const { legs } = regularFlight.variants[0];
                        isVisible = legs.some(v => new App.XDate(App.parseIsoDate(v.endDate)).trimTime().equals(beginDate)
                            && source.pickupRegularAirportKeys.includes(v.segments[v.segments.length - 1].endAirportKey));
                    }
                    if (isVisible && charterFlights.length > 0 && source.pickupAirportCodes.length > 0) {
                        isVisible = charterFlights.some(v => new App.XDate(App.parseIsoDate(v.endDate)).trimTime().equals(beginDate)
                            && source.pickupAirportCodes.includes(v.flight.arrivalAirportCode));
                    }
                }
                else if (source.pickupRegularCityKeys.length > 0 || source.pickupCityKeys.length > 0) {
                    if (regularFlight && source.pickupRegularCityKeys.length > 0) {
                        const { legs } = regularFlight.variants[0];
                        isVisible = legs.some(v => new App.XDate(App.parseIsoDate(v.endDate)).trimTime().equals(beginDate)
                            && source.pickupRegularCityKeys.includes(v.segments[v.segments.length - 1].endCityKey));
                    }
                    if (isVisible && charterFlights.length > 0 && source.pickupCityKeys.length > 0) {
                        isVisible = charterFlights.some(v => new App.XDate(App.parseIsoDate(v.endDate)).trimTime().equals(beginDate)
                            && source.pickupCityKeys.includes(v.flight.arrivalCityKey));
                    }
                }
            }
            else if (source.pickupType === 2 /* PacketTransferFilterType.Hotel */) {
                if (source.pickupHotelKeys.length > 0) {
                    isVisible = hotels.some(v => new App.XDate(App.parseIsoDate(v.beginDate)).addDays(v.days - 1).equals(beginDate)
                        && source.pickupHotelKeys.includes(v.hotel.masterTourKey));
                }
                else if (source.pickupHotelCityKeys.length > 0) {
                    isVisible = hotels.some(v => new App.XDate(App.parseIsoDate(v.beginDate)).addDays(v.days - 1).equals(beginDate)
                        && source.pickupHotelCityKeys.includes(v.hotel.cityKey));
                }
            }
            if (!isVisible)
                return false;
            if (source.dropoffType === 1 /* PacketTransferFilterType.Flight */) {
                if (source.dropoffRegularAirportKeys.length > 0 || source.dropoffAirportCodes.length > 0) {
                    if (regularFlight && source.dropoffRegularAirportKeys.length > 0) {
                        const { legs } = regularFlight.variants[0];
                        isVisible = legs.some(v => new App.XDate(App.parseIsoDate(v.date)).trimTime().equals(endDate)
                            && source.dropoffRegularAirportKeys.includes(v.segments[0].airportKey));
                    }
                    if (isVisible && charterFlights.length > 0 && source.dropoffAirportCodes.length > 0) {
                        isVisible = charterFlights.some(v => new App.XDate(App.parseIsoDate(v.beginDate)).trimTime().equals(endDate)
                            && source.dropoffAirportCodes.includes(v.flight.departureAirportCode));
                    }
                }
                else if (source.dropoffRegularCityKeys.length > 0 || source.dropoffCityKeys.length > 0) {
                    if (regularFlight && source.dropoffRegularCityKeys.length > 0) {
                        const { legs } = regularFlight.variants[0];
                        isVisible = legs.some(v => new App.XDate(App.parseIsoDate(v.date)).trimTime().equals(endDate)
                            && source.dropoffRegularCityKeys.includes(v.segments[0].cityKey));
                    }
                    if (isVisible && charterFlights.length > 0 && source.dropoffCityKeys.length > 0) {
                        isVisible = charterFlights.some(v => new App.XDate(App.parseIsoDate(v.beginDate)).trimTime().equals(endDate)
                            && source.dropoffCityKeys.includes(v.flight.departureCityKey));
                    }
                }
            }
            else if (source.dropoffType === 2 /* PacketTransferFilterType.Hotel */) {
                if (source.dropoffHotelKeys.length > 0) {
                    isVisible = hotels.some(v => new App.XDate(App.parseIsoDate(v.beginDate)).equals(endDate)
                        && source.dropoffHotelKeys.includes(v.hotel.masterTourKey));
                }
                else if (source.dropoffHotelCityKeys.length > 0) {
                    isVisible = hotels.some(v => new App.XDate(App.parseIsoDate(v.beginDate)).equals(endDate)
                        && source.dropoffHotelCityKeys.includes(v.hotel.cityKey));
                }
            }
            return isVisible;
        }
        // Note: старый механизм фильтрации.
        if (outboundArrivalCityKeys.length > 0 || returnDepartureCityKeys.length > 0) {
            if (!source.isDirect && !source.isReturn)
                return true;
            const isVisible = source.isDirect !== source.isReturn;
            if (isVisible) {
                const isDirectMatch = source.isDirect
                    && outboundArrivalCityKeys.length > 0
                    && outboundArrivalCityKeys.includes(source.transferCityKey);
                const isReturnMatch = source.isReturn
                    && returnDepartureCityKeys.length > 0
                    && returnDepartureCityKeys.includes(source.transferCityKey);
                return isDirectMatch || isReturnMatch;
            }
        }
        return true;
    }, _TourBookPage_valuate = function _TourBookPage_valuate() {
        return __awaiter(this, arguments, void 0, function* (ignoreRecalc = false, signal = App.noneSignal) {
            var _b;
            if (__classPrivateFieldGet(this, _TourBookPage_valuateOrBookExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _TourBookPage_valuateOrBookExecuting, true, "f");
            (_b = __classPrivateFieldGet(this, _TourBookPage_valuateAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            __classPrivateFieldSet(this, _TourBookPage_valuateAbortController, new AbortController(), "f");
            const data = new FormData(__classPrivateFieldGet(this, _TourBookPage_formOrder, "f").get(0));
            const popupGroup = __classPrivateFieldGet(this, _TourBookPage_popup, "f").show({
                group: 'main',
                content: App.templates.Messages.Valuating({}),
                delay: 500,
                modal: true,
            });
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const localSignal = App.createLinkedSignal(signal, __classPrivateFieldGet(this, _TourBookPage_valuateAbortController, "f").signal);
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    localSignal.throwIfAborted();
                    const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourBookPage_options, "f").urls.valuate, {
                        body: data,
                        signal: localSignal,
                    });
                    if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").process(result))
                        return;
                    return result;
                }), localSignal);
                if (!response)
                    return;
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_changeOffer).call(this, response.data);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateDynamicHotelVariant).call(this);
                // Обновить варианты авиа.
                for (let i = 0; i < __classPrivateFieldGet(this, _TourBookPage_services, "f").basicFlights.length; i++) {
                    const flight = __classPrivateFieldGet(this, _TourBookPage_services, "f").basicFlights[i];
                    const dataBookFlight = {
                        fieldPrefix: 'Form.ServiceGroups[0]',
                        serviceIndex: i,
                        items: Enumerable.from(flight.variants)
                            .orderBy(v => v.beginDate)
                            .thenBy(v => v.endDate)
                            .toArray(),
                    };
                    $(`.js-flights-charter .js-basic-variants[data-idx='${i}']`)
                        .empty()
                        .append(App.templates.Tour.BookFlight(dataBookFlight));
                }
                // Обновить обязательные услуги.
                // TODO detect changes if (oldServices.required[0]..length !== newFlight.variants.length || oldFlight.variants.some((v, j) => v.key !== oldFlight.variants[j].key)) {
                const services = new Array();
                for (let i = 0; i < __classPrivateFieldGet(this, _TourBookPage_services, "f").required.length; i++) {
                    services.push({
                        service: __classPrivateFieldGet(this, _TourBookPage_services, "f").required[i],
                        variant: __classPrivateFieldGet(this, _TourBookPage_services, "f").required[i].variants[0],
                        adultCount: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].adultCount,
                        childAges: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].childAges,
                    });
                }
                for (let i = 0; i < __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances.length; i++) {
                    const service = __classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances[i];
                    if (!(service.isAdditional || (!service.isOptional && service.variants.length === 1)))
                        continue;
                    const insuranceType = service.variants[0].type;
                    const excludeByInsuranceType = insuranceType && [3 /* KnownInsuranceType.CancellationCoverage */, 13 /* KnownInsuranceType.SaveMoney */,
                        0 /* KnownInsuranceType.Health */, 12 /* KnownInsuranceType.HealthOtherExpenses */, 1 /* KnownInsuranceType.AlpineSkiing */,
                        2 /* KnownInsuranceType.CivilLiability */].includes(insuranceType);
                    if (excludeByInsuranceType)
                        continue;
                    services.push({
                        service,
                        variant: Enumerable.from(service.variants)
                            .where(v => v.isDefault)
                            .defaultIfEmpty(Enumerable.from(service.variants)
                            .where(v => v.selectedCount > 0)
                            .defaultIfEmpty(service.variants[0])
                            .first())
                            .first(),
                        adultCount: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].adultCount,
                        childAges: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].childAges,
                    });
                }
                const dataBookRequired = services
                    .map(v => ({
                    name: __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServiceName).call(this, v),
                    description: __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServiceDescription).call(this, v),
                    isBonus: App.app.settings.bonusServiceTypes.includes(v.service.type.key),
                    grossPrice: v.variant.grossPrice,
                    currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                }));
                const container = $('.js-required-container');
                $('.js-required-item', container).remove();
                const content = $(App.templates.Tour.BookRequired(dataBookRequired));
                container.append(content);
                if (!ignoreRecalc)
                    yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _TourBookPage_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _TourBookPage_valuateOrBookExecuting, false, "f");
            }
        });
    }, _TourBookPage_recalcPrice = function _TourBookPage_recalcPrice() {
        return __awaiter(this, arguments, void 0, function* (ignoreTourInsuranceCoverageUpdate = false) {
            /* TODO: костыль, иначе при инициализации корзины возможно несколько параллельных вызовов #recalcPrice, которые приведут к
            дублированию вывода digest footer. Например:
            - из #finishInitialization
            - из #finishInitialization -> #initInsurances/#initInsurance -> click handler (изменение страховок)
            */
            if (!__classPrivateFieldGet(this, _TourBookPage_initialized, "f"))
                return;
            const data = yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getDigestData).call(this);
            if (!ignoreTourInsuranceCoverageUpdate) {
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateTourInsuranceCoverage).call(this, data);
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterAllTouristServices).call(this);
            }
            this.updateDigest(data);
            $('.js-order-options-total', this.root).get()[0].amount = data.optionsPrice;
            // TODO: костыль с округлением из-за ошибки валидации на сервере - видимо из-за десятичной точки, которая для ru-локали ожидается как ','.
            $('.js-consistency-control-price', this.root).val(Math.round(data.grossPrice));
        });
    }, _TourBookPage_getServiceTourists = function _TourBookPage_getServiceTourists(service, fieldName) {
        var _b;
        if (!service.isTourist) {
            return {
                adultCount: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].adultCount,
                childAges: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].childAges,
            };
        }
        if (fieldName.includes('[child')) {
            return {
                adultCount: 0,
                childAges: [parseInt((_b = $(`[name="${fieldName}"]`).attr('data-age')) !== null && _b !== void 0 ? _b : '0', 10)],
            };
        }
        return {
            adultCount: 1,
            childAges: [],
        };
    }, _TourBookPage_updateTourInsuranceCoverage = function _TourBookPage_updateTourInsuranceCoverage(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const touristCount = __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups.reduce((p, c) => p + c.adultCount + c.childAges.length, 0);
            __classPrivateFieldSet(this, _TourBookPage_tourInsuranceCoverage, {
                amount: data.tourInsuranceCoverage / touristCount,
                currencyCode: data.currencyCode,
            }, "f");
        });
    }, _TourBookPage_getDigestData = function _TourBookPage_getDigestData() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c, _d;
            const services = new Array();
            const formData = __classPrivateFieldGet(this, _TourBookPage_formOrder, "f").serializeArray();
            const allServices = __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].services;
            for (let i = 0; i < formData.length; i++) {
                if (!formData[i].name.startsWith('Form.ServiceGroups'))
                    continue;
                for (let j = 0; j < allServices.length; j++) {
                    const variant = allServices[j].variants.find(v => v.key === formData[i].value);
                    if (!variant)
                        continue;
                    const serviceTourists = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServiceTourists).call(this, allServices[j], formData[i].name);
                    const service = services.find(v => v.variant.key === variant.key);
                    if (service) {
                        service.adultCount += serviceTourists.adultCount;
                        service.childAges.push(...serviceTourists.childAges);
                    }
                    else {
                        services.push({
                            service: allServices[j],
                            variant,
                            adultCount: serviceTourists.adultCount,
                            childAges: serviceTourists.childAges,
                        });
                    }
                    break;
                }
            }
            for (let i = 0; i < __classPrivateFieldGet(this, _TourBookPage_services, "f").required.length; i++) {
                services.push({
                    service: __classPrivateFieldGet(this, _TourBookPage_services, "f").required[i],
                    variant: __classPrivateFieldGet(this, _TourBookPage_services, "f").required[i].variants[0],
                    adultCount: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].adultCount,
                    childAges: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].childAges,
                });
            }
            const hotelServices = services
                .filter(v => !v.service.isAdditional && v.service.type.code === App.KnownPacketServiceType.Hotel)
                .map(v => v.variant);
            // TODO: переделать для комбинации отелей (если будет)
            hotelServices.forEach(v => {
                v.extraGroups.forEach((x, xi) => {
                    x.items.forEach(item => {
                        const extra = formData.filter(d => d.name === `Form.HotelExtraKeys[${xi}]`);
                        item.selected = extra.length > 0 && item.code === extra[0].value;
                    });
                });
            });
            // Note: сортировка необходима для обработки ситуаций с разным кол-ом взрослых на разных отелях, например, если в 1-м отеле -
            // 2ADT, а во 2-м - 1ADT+1CHD(5-7).
            const people = Enumerable.from(hotelServices)
                .orderBy(v => v.adultCount)
                .first();
            const beginDate = App.parseIsoDate(__classPrivateFieldGet(this, _TourBookPage_offer, "f").beginDate);
            const regularFlight = (_b = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getFlightResults).call(this)) === null || _b === void 0 ? void 0 : _b.selectedFlight;
            const packetFlights = !regularFlight ? null : regularFlight.variants[0].legs
                .map((v, i) => ({
                beginDate: v.date,
                endDate: v.endDate,
                nextDayArrival: App.parseIsoDate(v.date).getDate() !== App.parseIsoDate(v.endDate).getDate(),
                flight: {
                    departureCityKey: v.segments[0].cityKey,
                    departureCityName: v.segments[0].cityName,
                    departureAirportCode: v.segments[0].airportCode,
                    departureTerminal: null,
                    arrivalCityKey: v.segments[v.segments.length - 1].endCityKey,
                    arrivalCityName: v.segments[v.segments.length - 1].endCityName,
                    arrivalAirportCode: v.segments[v.segments.length - 1].endAirportCode,
                    arrivalTerminal: null,
                    airlineCode: v.segments[0].airlineCode,
                    flightNumber: v.segments[0].flightNumber,
                },
                serviceClassCode: v.segments[0].serviceClass,
                serviceClassName: v.segments[0].serviceClass,
                hasMoreVariants: regularFlight.hasMoreVariants,
                tags: i <= 0 ? regularFlight.tags : undefined,
                transferCount: v.segments.length - 1,
                wayTime: v.wayTime,
                flightNumbers: v.segments.map(x => x.airlineCode + x.flightNumber),
            }));
            const flights = services
                .filter(v => !v.service.isAdditional && v.service.type.code === App.KnownPacketServiceType.Flight)
                .map(v => v.variant);
            const basicTouristServicePrices = Enumerable.from(services)
                .where(v => !v.service.isAdditional && v.service.isTourist)
                .select(v => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServiceCurrentPrices).call(this, v.variant.key, v.adultCount, v.childAges))
                .toArray();
            const servicePrices = Enumerable.from(services)
                .where(v => v.service.isAdditional)
                .groupBy(v => ({
                type: v.service.type,
                insuranceType: v.service.type.key === App.TourServiceType.Insurance
                    ? ({
                        key: v.variant.type,
                        name: v.variant.typeName,
                    })
                    : undefined,
            }), v => v, (k, v) => ({ key: k, values: v }), v => {
                var _b;
                let result = `${v.type.key}`;
                if (v.insuranceType && (v.insuranceType.key === 3 /* KnownInsuranceType.CancellationCoverage */
                    || v.insuranceType.key === 13 /* KnownInsuranceType.SaveMoney */))
                    result += `,${(_b = v.insuranceType.key) !== null && _b !== void 0 ? _b : 0}`;
                return result;
            })
                .select(v => {
                var _b, _c;
                let { name } = v.key.type;
                if (((_b = v.key.insuranceType) === null || _b === void 0 ? void 0 : _b.key) === 3 /* KnownInsuranceType.CancellationCoverage */)
                    name = 'Страховка от невыезда';
                else if (((_c = v.key.insuranceType) === null || _c === void 0 ? void 0 : _c.key) === 13 /* KnownInsuranceType.SaveMoney */)
                    name = 'Save Money';
                const items = v.values.toArray();
                const prices = Enumerable.from(items)
                    .select(x => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServiceCurrentPrices).call(this, x.variant.key, x.adultCount, x.childAges))
                    .toArray();
                const grossPrice = Enumerable.from(prices).sum(x => x.grossPrice);
                const price = Enumerable.from(prices).sum(x => x.price);
                return {
                    typeKey: v.key.type.key,
                    name,
                    nameDetails: '',
                    isBonus: items.some(x => App.app.settings.bonusServiceTypes.includes(x.service.type.key)),
                    grossPrice,
                    discount: grossPrice - price,
                    price,
                    currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                    order: __classPrivateFieldGet(_a, _a, "m", _TourBookPage_getDigestServiceOrder).call(_a, v.key.type.key, items[0].variant),
                };
            })
                .where(v => v.grossPrice !== 0)
                .toArray();
            const hotelExtraServicePrices = Enumerable.from(hotelServices)
                .selectMany(v => v.extraGroups)
                .selectMany(v => v.items.filter(x => x.selected), (v1, v2) => {
                var _b;
                return ({
                    name: v1.name,
                    grossPrice: v2.grossPrice,
                    price: (_b = v2.price) !== null && _b !== void 0 ? _b : v2.grossPrice,
                    currencyCode: v2.currencyCode,
                });
            })
                .groupBy(v => ({ name: v.name, currencyCode: v.currencyCode }), v => v, (k, v) => {
                const result = {
                    typeKey: App.TourServiceType.Undefined,
                    name: k.name,
                    nameDetails: '',
                    isBonus: false,
                    grossPrice: 0,
                    discount: 0,
                    price: 0,
                    currencyCode: k.currencyCode,
                    order: __classPrivateFieldGet(_a, _a, "f", _TourBookPage_defaultDigestServiceOrder),
                };
                v.forEach(x => {
                    result.grossPrice += x.grossPrice;
                    result.discount += x.grossPrice - x.price;
                    result.price += x.price;
                });
                return result;
            })
                .toArray();
            servicePrices.push(...hotelExtraServicePrices);
            let regularFlightGrossPrice = 0;
            let regularFlightPrice = 0;
            if (regularFlight) {
                regularFlightGrossPrice = (_c = yield App.CurrencyManager.exchange(regularFlight.grossPrice, regularFlight.currency, __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode)) !== null && _c !== void 0 ? _c : 0;
                regularFlightPrice = (_d = yield App.CurrencyManager.exchange(regularFlight.price, regularFlight.currency, __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode)) !== null && _d !== void 0 ? _d : regularFlightGrossPrice;
            }
            let nonCommissionFlightGrossPrice = 0;
            let nonCommissionFlightPrice = 0;
            const nonCommissionFlights = flights.filter(v => v.nonCommission);
            if (nonCommissionFlights.length > 0) {
                const prices = flights.map(v => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServiceCurrentPrices).call(this, v.key, v.adultCount, v.childAges));
                nonCommissionFlightGrossPrice = prices.reduce((p, v) => p + v.grossPrice, 0);
                nonCommissionFlightPrice = prices.reduce((p, v) => p + v.price, 0);
            }
            if (regularFlightGrossPrice > 0 || nonCommissionFlightGrossPrice > 0) {
                servicePrices.push({
                    typeKey: App.TourServiceType.Flight,
                    name: 'Авиаперелет',
                    nameDetails: '',
                    isBonus: false,
                    grossPrice: regularFlightGrossPrice + nonCommissionFlightGrossPrice,
                    discount: regularFlightGrossPrice - regularFlightPrice
                        + nonCommissionFlightGrossPrice - nonCommissionFlightPrice,
                    price: regularFlightPrice + nonCommissionFlightPrice,
                    currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                    order: 1,
                });
            }
            const basicServiceTypeNames = Enumerable.from(services)
                .where(v => !v.service.isAdditional)
                .where(v => v.service.type.key !== App.TourServiceType.Flight || !v.variant.nonCommission)
                .select(v => v.service.type.name.toLowerCase())
                .distinct()
                .aggregate('', (p, v) => (p === '' ? v : `${p}, ${v}`));
            const baseGrossPrice = __classPrivateFieldGet(this, _TourBookPage_offer, "f").baseGrossPrice
                + Enumerable.from(basicTouristServicePrices).sum(v => v.grossPrice)
                - nonCommissionFlightGrossPrice;
            const basePrice = __classPrivateFieldGet(this, _TourBookPage_offer, "f").basePrice
                + Enumerable.from(basicTouristServicePrices).sum(v => v.price)
                - nonCommissionFlightPrice;
            const grossPrice = baseGrossPrice
                + Enumerable.from(servicePrices).sum(v => v.grossPrice)
                - Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").required)
                    .where(v => App.app.settings.bonusServiceTypes.includes(v.type.key))
                    .sum(v => v.variants[0].grossPrice);
            const price = basePrice
                + Enumerable.from(servicePrices).sum(v => v.price);
            const tourInsuranceCoverage = grossPrice
                - Enumerable.from(servicePrices)
                    .where(v => v.typeKey === App.TourServiceType.Visa || v.typeKey === App.TourServiceType.Insurance)
                    .sum(v => v.grossPrice);
            servicePrices.push({
                typeKey: App.TourServiceType.Undefined,
                name: 'Программа тура',
                nameDetails: basicServiceTypeNames,
                isBonus: false,
                grossPrice: baseGrossPrice,
                discount: baseGrossPrice - basePrice,
                price: basePrice,
                currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                order: 0,
            });
            return {
                servicePrices: servicePrices.sort((a, b) => a.order - b.order),
                grossPrice,
                discount: grossPrice - price,
                price,
                currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                hasDetails: true,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _TourBookPage_pricePresenter, "f").type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                notes: [],
                tourFares: __classPrivateFieldGet(this, _TourBookPage_options, "f").tourFares,
                programName: __classPrivateFieldGet(this, _TourBookPage_options, "f").programName,
                programUrl: __classPrivateFieldGet(this, _TourBookPage_options, "f").programUrl,
                countryName: __classPrivateFieldGet(this, _TourBookPage_options, "f").countryName,
                resortName: __classPrivateFieldGet(this, _TourBookPage_options, "f").resortName,
                restTypeName: __classPrivateFieldGet(this, _TourBookPage_options, "f").restTypeName,
                adultCount: people.adultCount,
                childCount: people.childAges.length,
                beginDate: __classPrivateFieldGet(this, _TourBookPage_offer, "f").beginDate,
                endDate: __classPrivateFieldGet(this, _TourBookPage_offer, "f").endDate,
                nights: __classPrivateFieldGet(this, _TourBookPage_offer, "f").nights,
                packetFlights,
                flights: flights.map(v => ({
                    beginDate: v.beginDate,
                    endDate: v.endDate,
                    flight: {
                        departureCityKey: v.flight.departureCityKey,
                        departureCityName: v.flight.departureCityName,
                        departureAirportCode: v.flight.departureAirportCode,
                        departureTerminal: v.flight.departureTerminal,
                        arrivalCityKey: v.flight.arrivalCityKey,
                        arrivalCityName: v.flight.arrivalCityName,
                        arrivalAirportCode: v.flight.arrivalAirportCode,
                        arrivalTerminal: v.flight.arrivalTerminal,
                        airlineCode: v.flight.airlineCode,
                        flightNumber: v.flight.flightNumber,
                    },
                    serviceClassCode: v.serviceClassCode,
                    serviceClassName: v.serviceClassName,
                    hasMoreVariants: false,
                    tags: __classPrivateFieldGet(_a, _a, "m", _TourBookPage_generateFlightTags).call(_a, v),
                    transferCount: 0,
                })),
                daysBeforeFlight: -Math.min(0, packetFlights != null && packetFlights.length > 0
                    ? App.dateDiff(new App.XDate(App.parseIsoDate(packetFlights[0].beginDate)).trimTime(), beginDate).getDays()
                    : 0, flights.length > 0
                    ? App.dateDiff(new App.XDate(App.parseIsoDate(flights[0].beginDate)).trimTime(), beginDate).getDays()
                    : 0),
                hotels: hotelServices
                    .map(v => (Object.assign(Object.assign({}, (v)), { nights: v.days - 1 }))),
                transfers: services
                    .filter(v => !v.service.isAdditional && v.service.type.code === App.KnownPacketServiceType.Transfer)
                    .map(v => Object.assign(v.variant, { byProgram: __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_isByProgramTransfer).call(this, v.variant) })),
                others: Enumerable.from(services)
                    .where(v => v.service.isAdditional
                    || (v.service.type.code !== App.KnownPacketServiceType.Flight
                        && v.service.type.code !== App.KnownPacketServiceType.Hotel
                        && v.service.type.code !== App.KnownPacketServiceType.Transfer))
                    .groupBy(v => v.service.type.name)
                    .select(v => ({
                    name: v.key(),
                    services: v
                        .groupBy(x => __classPrivateFieldGet(_a, _a, "m", _TourBookPage_getDigestServiceName).call(_a, x))
                        .select(x => ({
                        name: x.key(),
                        count: x.sum(y => y.adultCount + y.childAges.length),
                    }))
                        .orderBy(x => x.name)
                        .toArray(),
                }))
                    .toArray(),
                optionsPrice: Enumerable.from(services)
                    .where(v => (!v.service.isTourist && v.service.isOptional && v.service.type.code !== App.KnownPacketServiceType.Transfer)
                    || v.service.type.code === App.KnownPacketServiceType.Excursion)
                    .sum(v => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServiceCurrentPrices).call(this, v.variant.key, v.adultCount, v.childAges).grossPrice),
                tourInsuranceCoverage,
            };
        });
    }, _TourBookPage_generateFlightTags = function _TourBookPage_generateFlightTags(item) {
        const result = new Array();
        if (item.nextDayArrival)
            result.push(['day-before', 'Вылет накануне']);
        return result;
    }, _TourBookPage_getDigestServiceOrder = function _TourBookPage_getDigestServiceOrder(typeKey, variant) {
        if (typeKey === App.TourServiceType.Flight)
            return 1;
        if (typeKey === App.TourServiceType.FuelSurcharge)
            return 2;
        if (typeKey === App.TourServiceType.Transfer)
            return 3;
        if (typeKey === App.TourServiceType.Excursion)
            return 4;
        if (typeKey === App.TourServiceType.Insurance) {
            const insuranceVariant = variant;
            if (insuranceVariant.type === 3 /* KnownInsuranceType.CancellationCoverage */)
                return 1000;
            if (insuranceVariant.type === 13 /* KnownInsuranceType.SaveMoney */)
                return 1001;
        }
        return __classPrivateFieldGet(_a, _a, "f", _TourBookPage_defaultDigestServiceOrder);
    }, _TourBookPage_getServiceName = function _TourBookPage_getServiceName(item) {
        if (item.service.type.code === App.KnownPacketServiceType.Excursion) {
            const activity = item.variant;
            return `${activity.activityName}, ${activity.transportName}, ${App.formatDate(activity.beginDate, 'shortDate')}`;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Flight) {
            const flight = item.variant;
            return `${flight.flight.departureCityName}, ${flight.flight.arrivalCityName}`;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Hotel) {
            const hotel = item.variant;
            return hotel.hotel.name;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Insurance) {
            const insurance = item.variant;
            let result = `${insurance.name} на ${insurance.days} ${App.pluralRu(insurance.days, 'день', 'дня', 'дней')}`;
            if (insurance.showCoverage && insurance.coverage.max) {
                const coverage = App.templates.Money({ amount: insurance.coverage.max, currency: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode, format: '0', fixed: true });
                result += `, покрытие ${coverage}`;
            }
            return result;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Transfer) {
            const transfer = item.variant;
            return `${transfer.transferCityName}, ${transfer.transferName}, ${transfer.transportName}`;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Visa) {
            const visa = item.variant;
            return visa.name;
        }
        const common = item.variant;
        return common.name + (common.description1 ? `, ${common.description1}` : '') + (common.description2 ? `, ${common.description2}` : '');
    }, _TourBookPage_getFlightResults = function _TourBookPage_getFlightResults() {
        var _b;
        return (_b = __classPrivateFieldGet(this, _TourBookPage_aviaResultComponent, "f")) === null || _b === void 0 ? void 0 : _b.getResults();
    }, _TourBookPage_getServiceDescription = function _TourBookPage_getServiceDescription(item) {
        let result = '';
        if (item.service.type.code === App.KnownPacketServiceType.Insurance) {
            const insurance = item.variant;
            if (insurance.type != null) {
                const description = App.templates.Tour.InsuranceDescription({
                    type: insurance.type,
                    groupCode: insurance.groupCode,
                    coverage: insurance.coverage,
                    currencyCode: __classPrivateFieldGet(this, _TourBookPage_offer, "f").currencyCode,
                });
                result += `<div class="description-info-wrap js-show-cancellation-conditions"><div class="booking-conditions-info-link description-info-icon"></div><div class="booking-conditions-info service-info-block js-reserve-info-block"><div class="fancybox-close js-reserve-info-block-close" data-fancybox-close title="Закрыть"></div><h3>Описание услуги</h3><div class="service-info">${description}</div></div></div>`;
            }
        }
        return result;
    }, _TourBookPage_getDigestServiceName = function _TourBookPage_getDigestServiceName(item) {
        if (item.service.type.code === App.KnownPacketServiceType.Excursion) {
            const activity = item.variant;
            return `${activity.activityName}, ${activity.transportName}`;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Flight) {
            const flight = item.variant;
            return `${flight.flight.departureCityName}, ${flight.flight.arrivalCityName}`;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Hotel) {
            const hotel = item.variant;
            return hotel.hotel.name;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Insurance) {
            const insurance = item.variant;
            return `${insurance.name} на ${insurance.days} ${App.pluralRu(insurance.days, 'день', 'дня', 'дней')}`;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Transfer) {
            const transfer = item.variant;
            return `${transfer.transferCityName}, ${transfer.transferName}, ${transfer.transportName}`;
        }
        if (item.service.type.code === App.KnownPacketServiceType.Visa) {
            const visa = item.variant;
            return visa.name;
        }
        const common = item.variant;
        return common.name + (common.description1 ? `, ${common.description1}` : '') + (common.description2 ? `, ${common.description2}` : '');
    }, _TourBookPage_changeInitials = function _TourBookPage_changeInitials(e) {
        const target = $(e.currentTarget);
        const container = target.closest('.js-person-tab-wrap');
        const id = container.attr('data-tab');
        if (!id)
            return;
        const initials = container.closest('.js-persons-tabs').find(`[data-target="${id}"] .initials`);
        const lastName = container.find('.js-person-tab-initials-b').valString();
        const firstName = container.find('.js-person-tab-initials-a').valString();
        const birthday = container.find('.js-person-birthday').datepicker('getDate');
        const currentAge = (birthday ? App.getAge(birthday, App.parseIsoDate(__classPrivateFieldGet(this, _TourBookPage_offer, "f").beginDate)) : null);
        const text = (lastName != null && lastName.length > 0 ? lastName[0] : '?') + (firstName != null && firstName.length > 0 ? firstName[0] : '?');
        const ageTitle = currentAge ? `, ${currentAge} ${App.pluralRu(currentAge, 'год', 'года', 'лет')}` : '';
        const title = `${lastName} ${firstName}${ageTitle}`;
        initials.text(text);
        __classPrivateFieldGet(this, _TourBookPage_optionsSet, "f").find(`[data-target=${id}]`).find('.initials')
            .text(text)
            .attr('title', title);
    }, _TourBookPage_filterAllTouristServices = function _TourBookPage_filterAllTouristServices() {
        $('.js-person-tab-wrap', __classPrivateFieldGet(this, _TourBookPage_placementPersons, "f")).each((_, v) => __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTouristServices).call(this, $(v)));
    }, _TourBookPage_filterTouristServices = function _TourBookPage_filterTouristServices(target) {
        const personContainer = target.closest('.js-person-tab-wrap');
        const birthday = $('.js-person-birthday', personContainer).datepicker('getDate');
        const currentAge = (birthday ? App.getAge(birthday, App.parseIsoDate(__classPrivateFieldGet(this, _TourBookPage_offer, "f").endDate)) : null);
        // Фильтрация виз.
        $('.js-person-visa-services', personContainer).each((_, serviceElement) => {
            const jqService = $(serviceElement);
            let needChangeVariant = false;
            const currentCity = $('.js-person-visa-city .js-jelect-input', jqService).valNumber();
            $('.js-person-service', jqService).each((__, variantElement) => {
                const jqVariant = $(variantElement);
                const inputElement = jqVariant.find('input');
                const visible = (!currentAge || __classPrivateFieldGet(_a, _a, "m", _TourBookPage_validateAge).call(_a, currentAge, inputElement))
                    && (!currentCity || __classPrivateFieldGet(_a, _a, "m", _TourBookPage_validateIssueCity).call(_a, currentCity, inputElement));
                jqVariant.toggleByClass(visible);
                if (!visible && inputElement.is(':checked'))
                    needChangeVariant = true;
            });
            // Если был скрыт выбранный элемент, то сделать выбранным default-элемент или первый доступный элемент (если есть такой).
            if (needChangeVariant) {
                let newSelection = jqService.find('.js-person-service input[value=""]').first();
                if (newSelection.length <= 0)
                    newSelection = jqService.find('.js-person-service:not(._hidden-2) input').first();
                if (newSelection.length > 0)
                    newSelection.trigger('click');
            }
        });
        // Фильтрация страховок.
        $('.js-person-insurance-services', personContainer).each((_, serviceElement) => {
            const jqService = $(serviceElement);
            const service = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").touristInsurances)
                .first(v => v.variants.some(x => x.key === $('.js-person-service input[value!=""]', jqService).valString()));
            $('.js-messages', jqService).empty().hideByClass();
            const currentVisa = $('.js-person-insurance-visa .js-jelect-input', jqService).valString();
            const tourCoverageValidation = service.variants[0].type === 3 /* KnownInsuranceType.CancellationCoverage */
                || service.variants[0].type === 13 /* KnownInsuranceType.SaveMoney */;
            let oldSelectedVariant;
            // Фильтруем варианты.
            const variantElements = $('.js-person-service', jqService).get();
            const variants = variantElements
                .map(element => {
                const jqVariant = $(element);
                const inputElement = jqVariant.find('input');
                const variant = Enumerable.from(service.variants).firstOrDefault(v => v.key === inputElement.valString());
                if (inputElement.prop('checked'))
                    oldSelectedVariant = variant;
                return {
                    container: jqVariant,
                    input: inputElement,
                    variant,
                    visible: (!currentAge || __classPrivateFieldGet(_a, _a, "m", _TourBookPage_validateAge).call(_a, currentAge, inputElement))
                        && (!currentVisa || __classPrivateFieldGet(_a, _a, "m", _TourBookPage_validateWithVisa).call(_a, currentVisa, inputElement))
                        && (!tourCoverageValidation || __classPrivateFieldGet(_a, _a, "m", _TourBookPage_validateCoverage).call(_a, __classPrivateFieldGet(this, _TourBookPage_tourInsuranceCoverage, "f"), inputElement)),
                };
            });
            // Сообщения и исключения в фильтрации
            if (service.variants[0].type === 3 /* KnownInsuranceType.CancellationCoverage */) {
                const partnerMaxAge = __classPrivateFieldGet(this, _TourBookPage_offer, "f").maxCancellationCoverageInsuranceAge;
                if (currentAge != null && partnerMaxAge != null && currentAge > partnerMaxAge) {
                    $('.js-messages', jqService)
                        .append(`Туристы старше ${partnerMaxAge} на страхование от невыезда не принимаются`)
                        .showByClass();
                }
                else {
                    const maxAge = Enumerable.from(service.variants).max(v => { var _b; return (_b = v.touristAge.max) !== null && _b !== void 0 ? _b : 0; });
                    if (currentAge != null && maxAge > 0 && currentAge > maxAge) {
                        variants.filter(v => { var _b; return ((_b = v.variant) === null || _b === void 0 ? void 0 : _b.touristAge.max) === maxAge; }).forEach(v => (v.visible = true));
                        $('.js-messages', jqService)
                            .append('Для расчета стоимости страховки от невыезда для возрастного туриста обратитесь к ведущему менеджеру')
                            .showByClass();
                    }
                    else {
                        const maxCoverage = Enumerable.from(service.variants).max(v => { var _b; return (_b = v.coverage.max) !== null && _b !== void 0 ? _b : 0; });
                        if (tourCoverageValidation && maxCoverage > 0 && __classPrivateFieldGet(this, _TourBookPage_tourInsuranceCoverage, "f").amount > maxCoverage) {
                            variants.filter(v => { var _b; return ((_b = v.variant) === null || _b === void 0 ? void 0 : _b.coverage.max) === maxCoverage; }).forEach(v => (v.visible = true));
                            $('.js-messages', jqService)
                                .append('Для расчета стоимости страховки от невыезда на полную стоимость тура обратитесь к ведущему менеджеру')
                                .showByClass();
                        }
                    }
                }
            }
            if (service.variants[0].type === 2 /* KnownInsuranceType.CivilLiability */ && currentAge != null && currentAge >= 86) {
                $('.js-messages', jqService)
                    .append('Для расчета стоимости страховки гражданская ответственность обратитесь к ведущему менеджеру')
                    .showByClass();
            }
            // Если для обязательной услуги скрываются абсолютно все доступные варианты, то игнорируем фильтрацию и показываем всё.
            if (!service.isOptional && !variants.some(v => v.visible))
                variants.forEach(v => (v.visible = true));
            // Применяем фильтрацию.
            let needChangeVariant = false;
            variants.forEach(v => {
                v.container.toggleByClass(v.visible);
                if (!v.visible && v.input.prop('checked'))
                    needChangeVariant = true;
            });
            // Выбрать др.вариант, если текущий выбранный скрывается.
            if (needChangeVariant) {
                let newSelection = $();
                if (oldSelectedVariant)
                    newSelection = jqService.find('.js-person-service:not(._hidden-2) input').first();
                if (newSelection.length <= 0)
                    newSelection = jqService.find('.js-person-service input[value=""]').first();
                if (newSelection.length <= 0)
                    newSelection = jqService.find('.js-person-service:not(._hidden-2) input').first();
                if (newSelection.length > 0)
                    newSelection.trigger('click');
            }
        });
    }, _TourBookPage_validateAge = function _TourBookPage_validateAge(age, element) {
        const dataMin = element.attr('data-age-min');
        if (dataMin != null && dataMin.length > 0) {
            const min = parseInt(dataMin, 10);
            if (age < min)
                return false;
        }
        const dataMax = element.attr('data-age-max');
        if (dataMax != null && dataMax.length > 0) {
            const max = parseInt(dataMax, 10);
            if (age > max)
                return false;
        }
        return true;
    }, _TourBookPage_validateIssueCity = function _TourBookPage_validateIssueCity(issueCity, element) {
        const dataValue = element.attr('data-issue-city');
        if (dataValue != null && dataValue.length > 0) {
            const issueCityLimit = parseInt(dataValue, 10);
            if (issueCity !== issueCityLimit)
                return false;
        }
        return true;
    }, _TourBookPage_validateWithVisa = function _TourBookPage_validateWithVisa(withVisa, element) {
        if (withVisa == null || withVisa.length <= 0)
            return true;
        const dataValue = element.attr('data-with-visa');
        if (dataValue == null || dataValue.length <= 0)
            return true;
        return withVisa === dataValue;
    }, _TourBookPage_validateCoverage = function _TourBookPage_validateCoverage(coverage, element) {
        const dataMin = element.attr('data-coverage-min');
        if (dataMin != null && dataMin.length > 0) {
            const min = Number(dataMin);
            return coverage.amount > min;
        }
        return true;
    }, _TourBookPage_getServiceCurrentPrices = function _TourBookPage_getServiceCurrentPrices(key, adultCount, childAges) {
        var _b, _c, _d, _e;
        const variant = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].services)
            .selectMany(v => v.variants)
            .firstOrDefault(v => v.key === key);
        if (variant == null)
            return { grossPrice: 0, price: 0 };
        if (!variant.isGroupPrice) {
            const newChildAges = [...childAges];
            return {
                grossPrice: ((_b = variant.adultGrossPrice) !== null && _b !== void 0 ? _b : 0) * adultCount + ((_c = variant.childGrossPrice) !== null && _c !== void 0 ? _c : 0) * newChildAges.length,
                price: ((_d = variant.adultPrice) !== null && _d !== void 0 ? _d : 0) * adultCount + ((_e = variant.childPrice) !== null && _e !== void 0 ? _e : 0) * newChildAges.length,
            };
        }
        return { grossPrice: variant.grossPrice, price: variant.price };
    }, _TourBookPage_getServicePrices = function _TourBookPage_getServicePrices(key_1, adultCount_1, childAges_1) {
        return __awaiter(this, arguments, void 0, function* (key, adultCount, childAges, ignoreRecalc = false) {
            var _b, _c, _d, _e;
            const variant = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].services)
                .selectMany(v => v.variants)
                .firstOrDefault(v => v.key === key);
            if (variant == null)
                return { grossPrice: 0, price: 0 };
            if (!variant.isGroupPrice) {
                const newChildAges = [...childAges];
                return {
                    grossPrice: ((_b = variant.adultGrossPrice) !== null && _b !== void 0 ? _b : 0) * adultCount + ((_c = variant.childGrossPrice) !== null && _c !== void 0 ? _c : 0) * newChildAges.length,
                    price: ((_d = variant.adultPrice) !== null && _d !== void 0 ? _d : 0) * adultCount + ((_e = variant.childPrice) !== null && _e !== void 0 ? _e : 0) * newChildAges.length,
                };
            }
            if (variant.isFixedPrice || (variant.adultCount === adultCount && variant.childAges.length === childAges.length))
                return { grossPrice: variant.grossPrice, price: variant.price };
            if (!ignoreRecalc) {
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_valuate).call(this, true);
                return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServicePrices).call(this, key, adultCount, childAges, true);
            }
            return { grossPrice: variant.grossPrice, price: variant.price };
        });
    }, _TourBookPage_selectedOptionsChanged = function _TourBookPage_selectedOptionsChanged(container) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            // TODO: замена цен по отдельным туристам (в связи с возможной сменой даты в select-списке).
            const serviceKey = (_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '';
            const adultCount = $('.js-options-set-adult .js-order-options-input', container).filter(':checked, ._checked').length;
            const childAgeElements = $('.js-options-set-child .js-order-options-input', container).filter(':checked, ._checked').get();
            const childAges = childAgeElements.map(v => { var _b; return parseInt((_b = $(v).attr('data-age')) !== null && _b !== void 0 ? _b : '0', 10); });
            const total = adultCount + childAges.length > 0
                ? (yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getServicePrices).call(this, serviceKey, adultCount, childAges)).grossPrice
                : 0;
            const elTotal = container.find('.js-options-set-total');
            elTotal.toggleClass('_zero', total === 0);
            elTotal.find(App.Money.tagName).get(0).amount = total;
            yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this);
        });
    }, _TourBookPage_onBookingButtonClick = function _TourBookPage_onBookingButtonClick(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _TourBookPage_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_booking).call(this, e, signal); }));
            }
            else {
                yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_booking).call(this, e, signal);
            }
        });
    }, _TourBookPage_booking = function _TourBookPage_booking(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            var _b, _c;
            e.preventDefault();
            if (!__classPrivateFieldGet(this, _TourBookPage_form, "f").validator.form() || !__classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this)) {
                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_tryFocusFirstInvalidField).call(this);
                return;
            }
            if (__classPrivateFieldGet(this, _TourBookPage_valuateOrBookExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _TourBookPage_valuateOrBookExecuting, true, "f");
            (_b = __classPrivateFieldGet(this, _TourBookPage_bookAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            __classPrivateFieldSet(this, _TourBookPage_bookAbortController, new AbortController(), "f");
            const data = new FormData(__classPrivateFieldGet(this, _TourBookPage_formOrder, "f").get(0));
            const popupGroup = __classPrivateFieldGet(this, _TourBookPage_popup, "f").show({
                group: 'main',
                content: App.templates.Tour.Messages.Booking({}),
                delay: 500,
                modal: true,
            });
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const localSignal = App.createLinkedSignal(signal, __classPrivateFieldGet(this, _TourBookPage_bookAbortController, "f").signal);
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    localSignal.throwIfAborted();
                    const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourBookPage_options, "f").urls.book, {
                        body: data,
                        signal: localSignal,
                    });
                    if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), localSignal);
                if (!response)
                    return;
                if ('expiredServices' in response.data) {
                    for (const expiredService of response.data.expiredServices) {
                        switch (expiredService.type) {
                            case 1 /* KnownServiceType.Accommodation */: {
                                const basicVariant = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_services, "f").basicHotels)
                                    .selectMany(v => v.variants)
                                    .firstOrDefault(v => v.key === expiredService.key);
                                if (basicVariant != null)
                                    basicVariant.quota = App.QuotaStatus.No;
                                const dynamicVariant = Enumerable.from(__classPrivateFieldGet(this, _TourBookPage_dynamicHotelVariants, "f"))
                                    .firstOrDefault(v => v.key === expiredService.key);
                                if (dynamicVariant != null)
                                    dynamicVariant.quota = App.QuotaStatus.No;
                                const groupContainer = $('.js-order-placement-item', __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").container);
                                __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_updateHotelAvailability).call(this, groupContainer);
                                break;
                            }
                            case 5 /* KnownServiceType.Flight */: {
                                const selectedFlight = (_c = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getFlightResults).call(this)) === null || _c === void 0 ? void 0 : _c.selectedFlight;
                                if (selectedFlight) {
                                    selectedFlight.variants[0].legs.forEach(v => (v.available = false));
                                    __classPrivateFieldGet(this, _TourBookPage_aviaResultComponent, "f").selectFlightVariant(selectedFlight.key);
                                }
                                break;
                            }
                            default:
                                console.error(`The '${expiredService.type}' service type wasn't expected for processing as expired.`);
                                break;
                        }
                    }
                    if (response.data.expiredServices.length > 1)
                        __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this);
                    else if (response.data.expiredServices[0].type == 1 /* KnownServiceType.Accommodation */)
                        __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this, App.TourServiceType.Hotel);
                    else
                        __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_checkQuota).call(this, App.TourServiceType.Flight);
                    __classPrivateFieldGet(this, _TourBookPage_form, "f").steps.show(0);
                }
                else if (response.data.isPartial) {
                    __classPrivateFieldGet(this, _TourBookPage_popup, "f").show({
                        content: App.templates.Tour.Messages.PartialOrder({
                            redirect: response.data.redirect,
                        }),
                        modal: true,
                    });
                }
                else {
                    window.location.href = response.data.redirect;
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").processError(ex)) {
                    __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_tryFocusFirstInvalidField).call(this);
                    throw ex;
                }
            }
            finally {
                __classPrivateFieldGet(this, _TourBookPage_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _TourBookPage_valuateOrBookExecuting, false, "f");
            }
        });
    }, _TourBookPage_onBookPrivateClick = function _TourBookPage_onBookPrivateClick() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getDigestData).call(this);
                pac.api.FormClientRequest({
                    url: window.location.href,
                    data,
                });
            }
            catch (ex) {
                console.warn(ex);
            }
        });
    }, _TourBookPage_tryFocusFirstInvalidField = function _TourBookPage_tryFocusFirstInvalidField() {
        const invalidField = __classPrivateFieldGet(this, _TourBookPage_formOrder, "f").find('._invalid').first();
        const step = invalidField.closest('.js-form-step-content').index();
        if (step >= 0)
            __classPrivateFieldGet(this, _TourBookPage_form, "f").steps.show(step);
        const tab = invalidField.closest('.js-person-tab-wrap');
        if (tab.length) {
            const tabs = tab.closest('.js-persons-tabs');
            tabs.find('.js-person-tab').eq(tab.index()).trigger('click');
        }
        invalidField.trigger('focus');
    }, _TourBookPage_isByProgramTransfer = function _TourBookPage_isByProgramTransfer(item) {
        return !item.transferPickupPlace
            && !item.transferDropoffPlace
            && item.beginDate !== __classPrivateFieldGet(this, _TourBookPage_offer, "f").beginDate
            && item.endDate !== __classPrivateFieldGet(this, _TourBookPage_offer, "f").endDate;
    }, _TourBookPage_onChangeTouristCitizenship = function _TourBookPage_onChangeTouristCitizenship(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const target = $(e.currentTarget);
            const personContainer = target.closest('.js-person-tab-wrap');
            __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_filterTouristServices).call(this, target);
            const isDomestic = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getIsDomestic).call(this, personContainer);
            const touristType = $(personContainer).attr('data-tourist-type');
            App.PassportPage.tuneTouristDocumentPropertiesForTour(personContainer, touristType, isDomestic);
            yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_recalcPrice).call(this);
        });
    }, _TourBookPage_getIsDomestic = function _TourBookPage_getIsDomestic(personContainer) {
        const flight = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getFlightResults).call(this);
        if (flight)
            return flight.selectedFlight.isDomestic;
        // тип тура определяем по гражданству и стране назначения
        const citizenshipKey = $('.js-person-citizenship .js-jelect-input', personContainer).valNumber();
        return citizenshipKey == 460
            && [213148, 213151, 213169, 213170, 213180, 213181, 458844].includes(__classPrivateFieldGet(this, _TourBookPage_offer, "f").externalCountryKey || 0);
    }, _TourBookPage_onChangeTouristDocumentType = function _TourBookPage_onChangeTouristDocumentType(e) {
        e.preventDefault();
        const target = $(e.currentTarget);
        const personContainer = target.closest('.js-person-tab-wrap');
        const isDomestic = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getIsDomestic).call(this, personContainer);
        const touristType = $(personContainer).attr('data-tourist-type');
        App.PassportPage.tuneTouristDocumentPropertiesForTour(personContainer, touristType, isDomestic, true);
    }, _TourBookPage_initTouristDocumentProperties = function _TourBookPage_initTouristDocumentProperties(personContainer) {
        const isDomestic = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getIsDomestic).call(this, personContainer);
        const touristType = $(personContainer).attr('data-tourist-type');
        App.PassportPage.tuneTouristDocumentPropertiesForTour(personContainer, touristType, isDomestic);
    }, _TourBookPage_checkQuota = function _TourBookPage_checkQuota(changedServiceTypeKey) {
        var _b, _c;
        const serviceGroup = __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0];
        const selectedBasicServices = Enumerable.from(serviceGroup.services)
            .where(v => !v.isAdditional && !v.isTourist)
            .selectMany(v => v.variants, (v1, v2) => ({ service: v1, variant: v2 }))
            .where(v => v.variant.selectedCount > 0);
        let hasInvalidServices = selectedBasicServices
            .any(v => v.variant.quota === App.QuotaStatus.No && (!changedServiceTypeKey || v.service.type.key === changedServiceTypeKey));
        if (!hasInvalidServices
            && __classPrivateFieldGet(this, _TourBookPage_offer, "f").dynamicFlight
            && (!changedServiceTypeKey || changedServiceTypeKey === App.TourServiceType.Flight)) {
            const selectedVariant = (_b = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getFlightResults).call(this)) === null || _b === void 0 ? void 0 : _b.selectedFlight.variants[0];
            hasInvalidServices = (_c = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legs.some(v => v.available != null && !v.available)) !== null && _c !== void 0 ? _c : false;
        }
        __classPrivateFieldGet(this, _TourBookPage_buttonOrder, "f").prop('disabled', hasInvalidServices);
        if (hasInvalidServices)
            __classPrivateFieldGet(this, _TourBookPage_popup, "f").show({ content: App.templates.Message({ type: 1 /* MessageType.Warning */, text: 'На одну из выбранных услуг закончились места. Выберите другой вариант услуги.' }) });
        return !hasInvalidServices;
    }, _TourBookPage_onActionInfoShow = function _TourBookPage_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _TourBookPage_loadAnnouncement = function _TourBookPage_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _b;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(
                    // TODO: убрать вызов toString после апгрейда "@typescript-eslint/eslint-plugin".
                    `${__classPrivateFieldGet(this, _TourBookPage_options, "f").urls.announcement}?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_b = response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _TourBookPage_loadDynamicHotels = function _TourBookPage_loadDynamicHotels(stepCallback_1) {
        return __awaiter(this, arguments, void 0, function* (stepCallback, signal = App.noneSignal) {
            signal.throwIfAborted();
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            const data = {
                key: __classPrivateFieldGet(this, _TourBookPage_offer, "f").key,
                hotel: __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").dynamicHotelInput.valString(),
                tourist: {
                    adultCount: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].adultCount,
                    childAges: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].childAges,
                },
                continueSearch: false,
            };
            do {
                let retries = 3;
                try {
                    signal.throwIfAborted();
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourBookPage_options, "f").urls.hotels, { body: App.createUrlSearchParams(data), signal });
                        if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").process(result))
                            return undefined;
                        return result;
                    }), signal);
                    if (!response)
                        return;
                    signal.throwIfAborted();
                    data.continueSearch = response.data.continueSearch;
                    if (response.data.items && response.data.items.length > 0)
                        yield stepCallback(response.data.items[0].variants);
                    if (response.data.continueSearch)
                        yield App.delay(App.randomInt(500, 2000), App.noneSignal);
                }
                catch (ex) {
                    retries--;
                    if (retries < 0) {
                        Sentry.captureException(ex);
                        return;
                    }
                }
            } while (data.continueSearch);
        });
    }, _TourBookPage_fillDocumentTypes = function _TourBookPage_fillDocumentTypes() {
        return __awaiter(this, arguments, void 0, function* (signal = App.noneSignal) {
            const flightResult = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getFlightResults).call(this);
            if (!flightResult)
                return;
            const data = {
                key: __classPrivateFieldGet(this, _TourBookPage_offer, "f").key,
                tourist: {
                    adultCount: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].adultCount,
                    childAges: __classPrivateFieldGet(this, _TourBookPage_offer, "f").serviceGroups[0].childAges,
                },
                routeType: flightResult.selectedFlight.routeType,
                childRouteType: flightResult.selectedFlight.childRouteType,
                city: __classPrivateFieldGet(this, _TourBookPage_options, "f").departureCityKey,
                hotel: __classPrivateFieldGet(this, _TourBookPage_hotelData, "f").dynamicHotelInput.valString(),
            };
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                signal.throwIfAborted();
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourBookPage_options, "f").urls.aviaUrls.flightDocumentTypes, { body: App.createUrlSearchParams(data), signal });
                    if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").process(result))
                        return null;
                    return result;
                }), signal);
                if (!response)
                    return;
                // убираем все документы, которые не могут использоваться для данного типа перелета.
                const personContainers = this.root.find('.js-person-tab-wrap');
                $.each(personContainers, (i, personContainer) => {
                    const touristIndex = $(personContainer).attr('data-tab');
                    const docTypeSelectBlock = $('.js-person-document-type', personContainer);
                    const docTypeSelectJelect = docTypeSelectBlock.find('.js-jelect');
                    const docTypeSelectOptions = docTypeSelectBlock.find('.js-filter-option');
                    const docTypes = Enumerable.from(response.data.items).first(v => v.touristIndex === touristIndex).items;
                    const items = Enumerable.from(docTypes).select(v => v.value).toArray();
                    $.each(docTypeSelectOptions, (_, item) => {
                        var _b;
                        const val = ((_b = $(item).attr('data-val')) === null || _b === void 0 ? void 0 : _b.toString()) || '';
                        if (!items.includes(val))
                            docTypeSelectJelect.jelect('disable', val);
                        else
                            docTypeSelectJelect.jelect('enable', val);
                    });
                    // устанавливаем наиболее правильный тип документа
                    const isDomestic = __classPrivateFieldGet(this, _TourBookPage_instances, "m", _TourBookPage_getIsDomestic).call(this, $(personContainer));
                    const touristType = $(personContainer).attr('data-tourist-type');
                    App.PassportPage.tuneTouristDocumentPropertiesForTour($(personContainer), touristType, isDomestic);
                });
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _TourBookPage_onTouristChosen = function _TourBookPage_onTouristChosen(passengerWrap) {
        $('input', passengerWrap).each((i, v) => App.AviaFormBase.validateField($(v)));
    };
    _TourBookPage_defaultDigestServiceOrder = { value: 5 };
    App.TourBookPage = TourBookPage;
})(App || (App = {}));
/// <reference path='TourBookPage.ts' />
var App;
(function (App) {
    var _TourBookPageMobile_instances, _TourBookPageMobile_bookDigest, _TourBookPageMobile_onDigestBookClick;
    /**
     * Мобильная версия страницы бронирования тура.
     *
     */
    class TourBookPageMobile extends App.TourBookPage {
        constructor(options) {
            super(Object.assign({ root: '.js-tour-book-page .js-app-container-content' }, options));
            _TourBookPageMobile_instances.add(this);
            _TourBookPageMobile_bookDigest.set(this, void 0);
            __classPrivateFieldSet(this, _TourBookPageMobile_bookDigest, new App.DigestMobile({
                buttonTitle: 'Забронировать',
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _TourBookPageMobile_instances, "m", _TourBookPageMobile_onDigestBookClick).call(this),
                // При отсутствии кнопки «Завершить бронирование» (неавторизованный пользователь)
                // бронирование недоступно.
                allowBooking: $('.js-order-submit', this.root).length > 0,
            }), "f");
        }
        updateDigest(data) {
            return __awaiter(this, void 0, void 0, function* () {
                // Данные для компонента «Нашли дешевле?».
                this.updateBestPriceItems(data);
                // Детали заказа
                const digestContent = $(App.templates.Tour.BookDigestContent(data));
                // Флоатер с суммой «К оплате».
                const digestFloater = $(App.templates.Tour.BookDigest_Floater_Mobile(data));
                yield __classPrivateFieldGet(this, _TourBookPageMobile_bookDigest, "f").setContent(digestContent);
                __classPrivateFieldGet(this, _TourBookPageMobile_bookDigest, "f").setFloater(digestFloater);
            });
        }
    }
    _TourBookPageMobile_bookDigest = new WeakMap(), _TourBookPageMobile_instances = new WeakSet(), _TourBookPageMobile_onDigestBookClick = function _TourBookPageMobile_onDigestBookClick() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _TourBookPageMobile_bookDigest, "f").close();
            $('.js-order-submit', this.root).trigger('click');
        });
    };
    App.TourBookPageMobile = TourBookPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TourHotelPageMobile_instances, _a, _TourHotelPageMobile_options, _TourHotelPageMobile_scrollBookLink, _TourHotelPageMobile_bookScrollToWrap, _TourHotelPageMobile_tabs, _TourHotelPageMobile_filter, _TourHotelPageMobile_hotFilter, _TourHotelPageMobile_result, _TourHotelPageMobile_messenger, _TourHotelPageMobile_responseValidator, _TourHotelPageMobile_searchPopup, _TourHotelPageMobile_loadMap, _TourHotelPageMobile_searchExecuting, _TourHotelPageMobile_placementSearchExecuted, _TourHotelPageMobile_searchAbortController, _TourHotelPageMobile_searchExpirationPopup, _TourHotelPageMobile_cancellationRuleCheckerField, _TourHotelPageMobile_cancellationRuleChecker_get, _TourHotelPageMobile_mountSearch, _TourHotelPageMobile_setBookingPosition, _TourHotelPageMobile_onScrollLinkClick, _TourHotelPageMobile_onTabClick, _TourHotelPageMobile_onSearchSubmit, _TourHotelPageMobile_onFilterSearch, _TourHotelPageMobile_searchStep, _TourHotelPageMobile_cancelSearch, _TourHotelPageMobile_successSearch, _TourHotelPageMobile_transformSearchResponse, _TourHotelPageMobile_onHotelGroupShowMore, _TourHotelPageMobile_onDateGroupShowMore, _TourHotelPageMobile_onCheckCancellationClick, _TourHotelPageMobile_onActionInfoShow, _TourHotelPageMobile_loadAnnouncement;
    class TourHotelPageMobile extends App.PageMobileBase {
        constructor(options) {
            // NOTE: root задаем явно, т.к. в мобильном layout нет элемента .js-app-container
            // (app.appContainer пуст, а контент находится в js-app-container-content)
            super(Object.assign({ root: '.js-tour-hotel-page .js-app-container-content' }, options));
            _TourHotelPageMobile_instances.add(this);
            _TourHotelPageMobile_options.set(this, void 0);
            _TourHotelPageMobile_scrollBookLink.set(this, void 0);
            _TourHotelPageMobile_bookScrollToWrap.set(this, void 0);
            _TourHotelPageMobile_tabs.set(this, void 0);
            _TourHotelPageMobile_filter.set(this, void 0);
            _TourHotelPageMobile_hotFilter.set(this, void 0);
            _TourHotelPageMobile_result.set(this, void 0);
            _TourHotelPageMobile_messenger.set(this, void 0);
            _TourHotelPageMobile_responseValidator.set(this, void 0);
            _TourHotelPageMobile_searchPopup.set(this, void 0);
            _TourHotelPageMobile_loadMap.set(this, false);
            _TourHotelPageMobile_searchExecuting.set(this, false);
            _TourHotelPageMobile_placementSearchExecuted.set(this, false);
            _TourHotelPageMobile_searchAbortController.set(this, void 0);
            _TourHotelPageMobile_searchExpirationPopup.set(this, void 0);
            _TourHotelPageMobile_cancellationRuleCheckerField.set(this, void 0);
            __classPrivateFieldSet(this, _TourHotelPageMobile_options, options, "f");
        }
        mount() {
            super.mount();
            __classPrivateFieldSet(this, _TourHotelPageMobile_scrollBookLink, $('.js-scroll-book-link', this.root), "f");
            __classPrivateFieldSet(this, _TourHotelPageMobile_bookScrollToWrap, $('.js-tab-wrap[data-tab="placement"]', this.root), "f");
            // прилипание/отлипание ссылки 'к бронированию'
            if (__classPrivateFieldGet(this, _TourHotelPageMobile_scrollBookLink, "f").length > 0)
                $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_setBookingPosition).call(this)));
            this.root.on('click', '.js-scroll-to', e => __classPrivateFieldGet(_a, _a, "m", _TourHotelPageMobile_onScrollLinkClick).call(_a, e));
            // Галерея с изображениями
            $('.js-media-gallery-mobile', this.root).each((_, el) => {
                new App.MediaGalleryMobile({ self: $(el) });
            });
            __classPrivateFieldSet(this, _TourHotelPageMobile_messenger, new App.BlockMessenger(new App.Messages()), "f");
            if (__classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").hasSearch)
                __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_mountSearch).call(this);
            else
                __classPrivateFieldSet(this, _TourHotelPageMobile_responseValidator, new App.ResponseValidator({ messenger: __classPrivateFieldGet(this, _TourHotelPageMobile_messenger, "f") }), "f");
            // Вкладки описания отеля.
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_onTabClick).call(this, e));
            __classPrivateFieldSet(this, _TourHotelPageMobile_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _TourHotelPageMobile_tabs, "f").showActive();
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_onActionInfoShow).call(this, e, data); }));
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _b;
                yield _super.run.call(this, signal);
                if (__classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").hasSearch && !__classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").manual) {
                    __classPrivateFieldSet(this, _TourHotelPageMobile_placementSearchExecuted, true, "f");
                    (_b = __classPrivateFieldGet(this, _TourHotelPageMobile_filter, "f")) === null || _b === void 0 ? void 0 : _b.search(false);
                }
            });
        }
    }
    _a = TourHotelPageMobile, _TourHotelPageMobile_options = new WeakMap(), _TourHotelPageMobile_scrollBookLink = new WeakMap(), _TourHotelPageMobile_bookScrollToWrap = new WeakMap(), _TourHotelPageMobile_tabs = new WeakMap(), _TourHotelPageMobile_filter = new WeakMap(), _TourHotelPageMobile_hotFilter = new WeakMap(), _TourHotelPageMobile_result = new WeakMap(), _TourHotelPageMobile_messenger = new WeakMap(), _TourHotelPageMobile_responseValidator = new WeakMap(), _TourHotelPageMobile_searchPopup = new WeakMap(), _TourHotelPageMobile_loadMap = new WeakMap(), _TourHotelPageMobile_searchExecuting = new WeakMap(), _TourHotelPageMobile_placementSearchExecuted = new WeakMap(), _TourHotelPageMobile_searchAbortController = new WeakMap(), _TourHotelPageMobile_searchExpirationPopup = new WeakMap(), _TourHotelPageMobile_cancellationRuleCheckerField = new WeakMap(), _TourHotelPageMobile_instances = new WeakSet(), _TourHotelPageMobile_cancellationRuleChecker_get = function _TourHotelPageMobile_cancellationRuleChecker_get() {
        if (!__classPrivateFieldGet(this, _TourHotelPageMobile_cancellationRuleCheckerField, "f"))
            __classPrivateFieldSet(this, _TourHotelPageMobile_cancellationRuleCheckerField, new App.CancellationRuleChecker({ url: __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").urls.cancellationPolicy }), "f");
        return __classPrivateFieldGet(this, _TourHotelPageMobile_cancellationRuleCheckerField, "f");
    }, _TourHotelPageMobile_mountSearch = function _TourHotelPageMobile_mountSearch() {
        // Параметры поиска (кнопка "Изменить поиск" открывает модалку)
        const filter = new App.TourHotelMainFilterMobile({
            urls: __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").urls,
            changes: __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").changes,
        });
        __classPrivateFieldSet(this, _TourHotelPageMobile_filter, filter, "f");
        // Хот-фильтр (сортировка + фильтры вариантов размещения)
        const resultOptions = {
            dynamicRoomTypes: __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").dynamicRoomTypes,
            dynamicBoardTypes: __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").dynamicBoardTypes,
        };
        const hotFilter = new App.TourHotelHotFilterMobile({ resultOptions });
        __classPrivateFieldSet(this, _TourHotelPageMobile_hotFilter, hotFilter, "f");
        hotFilter.root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
            __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_cancelSearch).call(this);
            hotFilter.hideProgressDataLoader();
        });
        // Выдача результатов
        const result = new App.TourHotelResultMobile(Object.assign({ root: this.root, hotFilter }, resultOptions));
        __classPrivateFieldSet(this, _TourHotelPageMobile_result, result, "f");
        __classPrivateFieldSet(this, _TourHotelPageMobile_responseValidator, new App.ResponseValidator({
            messenger: __classPrivateFieldGet(this, _TourHotelPageMobile_messenger, "f"),
            validator: filter.filters.validator,
        }), "f");
        __classPrivateFieldSet(this, _TourHotelPageMobile_searchPopup, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
        $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
            if (action === 'interrupt') {
                __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_cancelSearch).call(this);
                inst.hide();
            }
        });
        this.root.on('click', '.js-tour-group-show-more-link', e => __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_onHotelGroupShowMore).call(this, e));
        this.root.on('click', '.js-tour-date-group-link', e => __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_onDateGroupShowMore).call(this, e));
        filter.filters.searchFilter.on("filter:search" /* Events.FilterSearch */, (_, data, manual) => __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_onFilterSearch).call(this, data !== null && data !== void 0 ? data : filter.buildSearchData(), manual !== false));
        filter.root.on('submit', e => __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_onSearchSubmit).call(this, e));
        // сортировка по умолчанию - по цене (как на десктопе)
        hotFilter.setFilterSortItems({ field: App.TourSortFields.Price, reverse: false }, false);
        result.root.on('click', '.js-cancellation-rules', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_onCheckCancellationClick).call(this, e); }));
    }, _TourHotelPageMobile_setBookingPosition = function _TourHotelPageMobile_setBookingPosition() {
        var _b, _c, _d;
        const scrolledPos = ((_b = $(window).scrollTop()) !== null && _b !== void 0 ? _b : 0) + ((_c = $(window).outerHeight()) !== null && _c !== void 0 ? _c : 0);
        const offset = __classPrivateFieldGet(this, _TourHotelPageMobile_bookScrollToWrap, "f").offset();
        const offsetTop = (offset != null ? offset.top : 0);
        if (scrolledPos >= offsetTop && scrolledPos < offsetTop + ((_d = __classPrivateFieldGet(this, _TourHotelPageMobile_bookScrollToWrap, "f").outerHeight()) !== null && _d !== void 0 ? _d : 0))
            __classPrivateFieldGet(this, _TourHotelPageMobile_scrollBookLink, "f").addClass('_fixed_book');
        else
            __classPrivateFieldGet(this, _TourHotelPageMobile_scrollBookLink, "f").removeClass('_fixed_book');
    }, _TourHotelPageMobile_onScrollLinkClick = function _TourHotelPageMobile_onScrollLinkClick(e) {
        var _b;
        const target = $(e.currentTarget);
        const destId = target.attr('data-scroll');
        if (!destId)
            return;
        // вкладка карты - сначала открываем ее
        const tab = $(`.js-tab[data-dest="${destId}"]`);
        if (tab.length > 0 && !tab.hasClass('_active'))
            tab.trigger('click');
        const dest = tab.length > 0 ? tab : $(`[data-dest="${destId}"]`).first();
        const destOffset = dest.offset();
        let top = (destOffset != null ? destOffset.top : 0);
        if (App.isTouch)
            top += ((_b = App.app.container.scrollTop()) !== null && _b !== void 0 ? _b : 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
    }, _TourHotelPageMobile_onTabClick = function _TourHotelPageMobile_onTabClick(e) {
        var _b;
        const tabName = $(e.currentTarget).attr('data-tab');
        // Переход во вкладку "Размещение с туром" запускает поиск, если он еще не выполнялся
        // (как на десктопе - TourHotelPage.#onTabClick).
        if (tabName === 'placement' && !__classPrivateFieldGet(this, _TourHotelPageMobile_searchExecuting, "f") && !__classPrivateFieldGet(this, _TourHotelPageMobile_placementSearchExecuted, "f")) {
            __classPrivateFieldSet(this, _TourHotelPageMobile_placementSearchExecuted, true, "f");
            (_b = __classPrivateFieldGet(this, _TourHotelPageMobile_filter, "f")) === null || _b === void 0 ? void 0 : _b.search(false);
        }
        if (tabName === 'map' && !__classPrivateFieldGet(this, _TourHotelPageMobile_loadMap, "f") && __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").hotel.coordinate) {
            const mapModel = {
                mapTitle: '',
                mapPoints: [
                    {
                        type: "hotel" /* MapPointType.Hotel */,
                        coordinates: __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").hotel.coordinate,
                        text: __classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").hotel.name,
                        selected: true,
                        stars: `${__classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").hotel.categoryCode}`,
                    },
                ],
            };
            this.components.push(new App.UnfoldMap(mapModel, false));
            __classPrivateFieldSet(this, _TourHotelPageMobile_loadMap, true, "f");
        }
    }, _TourHotelPageMobile_onSearchSubmit = function _TourHotelPageMobile_onSearchSubmit(event) {
        var _b;
        event.preventDefault();
        (_b = __classPrivateFieldGet(this, _TourHotelPageMobile_filter, "f")) === null || _b === void 0 ? void 0 : _b.search(true);
    }, _TourHotelPageMobile_onFilterSearch = function _TourHotelPageMobile_onFilterSearch(data, manual) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const filter = __classPrivateFieldGet(this, _TourHotelPageMobile_filter, "f");
            const hotFilter = __classPrivateFieldGet(this, _TourHotelPageMobile_hotFilter, "f");
            const result = __classPrivateFieldGet(this, _TourHotelPageMobile_result, "f");
            if (!filter || !hotFilter || !result)
                return;
            __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_cancelSearch).call(this);
            (_b = __classPrivateFieldGet(this, _TourHotelPageMobile_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
            result.resetDataSource();
            hotFilter.reset();
            if (!filter.filters.validator.form())
                return;
            // при ручном поиске переходим на вкладку "Размещение с туром" (как на десктопе).
            // показ вкладки выполняется после установки #searchExecuting, чтобы можно было
            // определить, что поиск уже запущен (и не запустить его повторно в #onTabClick).
            __classPrivateFieldSet(this, _TourHotelPageMobile_searchExecuting, true, "f");
            if (manual)
                __classPrivateFieldGet(this, _TourHotelPageMobile_tabs, "f").show('placement', 1);
            __classPrivateFieldSet(this, _TourHotelPageMobile_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _TourHotelPageMobile_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            const tasks = new Array();
            if (__classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").hasDynamicHotel) {
                tasks.push(__classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external' }), retryPolicy, signal));
                tasks.push(__classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'internal' }), retryPolicy, signal));
            }
            else {
                tasks.push(__classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_searchStep).call(this, data, retryPolicy, signal));
            }
            let firstStep = true;
            let successSteps = 0;
            let error;
            const popupGroup = __classPrivateFieldGet(this, _TourHotelPageMobile_searchPopup, "f").show({
                group: 'main',
                content: App.templates.Tour.Messages.Searching({}),
                modal: true,
            });
            /* eslint-disable no-await-in-loop */
            while (tasks.length > 0) {
                try {
                    signal.throwIfAborted();
                    const [task] = yield Promise.race(tasks.map(v => v.then(() => [v], () => [v])));
                    App.removeElement(tasks, task);
                    const response = yield task;
                    if (response) {
                        signal.throwIfAborted();
                        if (yield __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_successSearch).call(this, response, firstStep, successSteps, tasks.length > 0, manual, data, signal))
                            successSteps++;
                        if (response.data.continuationState)
                            tasks.push(__classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external', continuationState: response.data.continuationState }), retryPolicy, signal));
                    }
                    if (tasks.length <= 0)
                        break;
                }
                catch (ex) {
                    if (signal.aborted)
                        break;
                    error = ex;
                }
                finally {
                    if (successSteps === 1 || tasks.length <= 0)
                        __classPrivateFieldGet(this, _TourHotelPageMobile_searchPopup, "f").hide(popupGroup);
                }
                firstStep = false;
                hotFilter.showProgressDataLoader();
            }
            /* eslint-enable no-await-in-loop */
            __classPrivateFieldSet(this, _TourHotelPageMobile_searchExecuting, false, "f");
            hotFilter.hideProgressDataLoader();
            if (successSteps <= 0 && error != null && !__classPrivateFieldGet(this, _TourHotelPageMobile_responseValidator, "f").processError(error)) {
                /* eslint-disable-next-line @typescript-eslint/no-throw-literal */
                throw error;
            }
            if (successSteps > 0 && tasks.length <= 0) {
                if (successSteps === 1) {
                    // Поиск полностью завершен за 1 шаг.
                    hotFilter.setFilterSortItems({ field: App.TourSortFields.Price, reverse: false }, true);
                }
                else if (hotFilter.activeSorting.field !== App.TourSortFields.Price) {
                    // Поиск полностью завершен за более чем 1 шаг.
                    __classPrivateFieldGet(this, _TourHotelPageMobile_searchPopup, "f").show({
                        content: App.templates.Tour.Messages.PartialSearchCompleted({}),
                        modal: true,
                    });
                }
            }
        });
    }, _TourHotelPageMobile_searchStep = function _TourHotelPageMobile_searchStep(data, retryPolicy, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                signal.throwIfAborted();
                const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").urls.search, { body: App.createUrlSearchParams(data), signal });
                if (!__classPrivateFieldGet(this, _TourHotelPageMobile_responseValidator, "f").process(result))
                    return;
                return result;
            }), signal);
        });
    }, _TourHotelPageMobile_cancelSearch = function _TourHotelPageMobile_cancelSearch() {
        var _b;
        (_b = __classPrivateFieldGet(this, _TourHotelPageMobile_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
    }, _TourHotelPageMobile_successSearch = function _TourHotelPageMobile_successSearch(response, firstStep, successSteps, hasMoreSteps, manual, data, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = __classPrivateFieldGet(this, _TourHotelPageMobile_result, "f");
            if (!result)
                return false;
            signal.throwIfAborted();
            if (firstStep && response.data.seo != null) {
                App.app.seo.update(response.data.seo);
                // NOTE: сохраняем якорь активной вкладки (#1-info и т.п.)
                const url = response.data.seo.url + window.location.hash;
                if (!manual)
                    window.history.replaceState(null, document.title, url);
                else
                    window.history.pushState(null, document.title, url);
            }
            signal.throwIfAborted();
            // Определение наличия результатов поиска
            if (response.data.offers && response.data.offers.length > 0) {
                if (successSteps <= 0) {
                    __classPrivateFieldSet(this, _TourHotelPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        customRefresh: true,
                        isContainerPopup: true,
                        root: this.root,
                    }), "f");
                }
                result.filters = data;
                const { offers } = response.data;
                const showVariants = successSteps <= 0
                    && !hasMoreSteps
                    && !response.data.continuationState
                    && (offers.length <= 1 || offers.every(v => v.hotel.key === offers[0].hotel.key));
                const responseData = __classPrivateFieldGet(_a, _a, "m", _TourHotelPageMobile_transformSearchResponse).call(_a, offers, showVariants);
                yield result.changeDataSource(responseData, successSteps > 0);
                return true;
            }
            if (successSteps <= 0 && !hasMoreSteps) {
                __classPrivateFieldGet(this, _TourHotelPageMobile_messenger, "f").show({ type: 0 /* MessageType.Information */, text: 'Вариантов, соответствующих заданным критериям, нет.' }, { group: 'ajax' });
            }
            return false;
        });
    }, _TourHotelPageMobile_transformSearchResponse = function _TourHotelPageMobile_transformSearchResponse(offers, showVariants) {
        return Enumerable.from(offers)
            .select(x => new App.TourHotelSearchViewModel(x))
            .groupBy(v => v.hotel.key, v => v, (k, v) => new App.TourHotelProgramGroupSearchViewModel(v.first().hotel, v
            .groupBy(x => x.beginDate, x => x, (k2, v2) => new App.TourHotelDateGroupSearchViewModel(k2, v2.toArray()))
            .toArray(), showVariants))
            .toArray();
    }, _TourHotelPageMobile_onHotelGroupShowMore = function _TourHotelPageMobile_onHotelGroupShowMore(e) {
        var _b, _c, _d, _e, _f, _g, _h;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        const container = target.parents('.js-tour-table-block');
        const showLinks = container.find('.js-tour-group-show-more-link-show');
        const hideLinks = container.find('.js-tour-group-show-more-link-hide');
        const isHidden = (showLinks.length > 0 && !showLinks.hasClass('_hidden-2'))
            || (hideLinks.length > 0 && hideLinks.hasClass('_hidden-2'));
        const groupContainer = container.find('.js-tour-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-group-content-items');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = (_c = __classPrivateFieldGet(this, _TourHotelPageMobile_result, "f")) === null || _c === void 0 ? void 0 : _c.findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        hotelGroup.showVariants = isHidden;
        const currentOffset = ((_e = (_d = container.offset()) === null || _d === void 0 ? void 0 : _d.top) !== null && _e !== void 0 ? _e : 0) - ((_f = $(document).scrollTop()) !== null && _f !== void 0 ? _f : 0);
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.HotelProgramGroup(hotelGroup.visibleItems));
            groupItemsContainer.append(content);
            container.addClass('_open');
        }
        else {
            container.removeClass('_open');
        }
        showLinks.toggleByClass(!hotelGroup.showVariants);
        hideLinks.toggleByClass(hotelGroup.showVariants);
        $(document).scrollTop(((_h = (_g = container.offset()) === null || _g === void 0 ? void 0 : _g.top) !== null && _h !== void 0 ? _h : 0) - currentOffset);
    }, _TourHotelPageMobile_onDateGroupShowMore = function _TourHotelPageMobile_onDateGroupShowMore(e) {
        var _b, _c, _d;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        if (target.hasClass('_active'))
            return;
        const container = target.parents('.js-tour-table-block');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = (_c = __classPrivateFieldGet(this, _TourHotelPageMobile_result, "f")) === null || _c === void 0 ? void 0 : _c.findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        const groupContainer = target.parents('.js-tour-date-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-date-group-content-items');
        const dateGroupKey = (_d = target.attr('data-key')) !== null && _d !== void 0 ? _d : '';
        const dateGroup = App.TourHotelResult.findDateGroup(hotelGroup, dateGroupKey);
        const showLinks = groupContainer.find('.js-tour-date-group-link');
        if (!dateGroup)
            return;
        hotelGroup.items.forEach(v => (v.active = false));
        showLinks.removeClass('_active');
        dateGroup.active = true;
        target.addClass('_active');
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.HotelDateGroup(dateGroup.visibleItems));
            groupItemsContainer.append(content);
        }
    }, _TourHotelPageMobile_onCheckCancellationClick = function _TourHotelPageMobile_onCheckCancellationClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            e.preventDefault();
            e.stopPropagation();
            const targetElement = $(e.target);
            const policy = yield __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "a", _TourHotelPageMobile_cancellationRuleChecker_get).getCancellationPolicy(targetElement, __classPrivateFieldGet(this, _TourHotelPageMobile_messenger, "f"));
            if (!policy)
                return;
            const variantKey = (_b = targetElement.attr('data-variant-key')) !== null && _b !== void 0 ? _b : '';
            const variant = (_c = __classPrivateFieldGet(this, _TourHotelPageMobile_result, "f")) === null || _c === void 0 ? void 0 : _c.findOfferByDynamicHotel(variantKey);
            if (variant)
                variant.cancellationPolicy = policy;
            const model = new App.VariantCancellationViewModel('', policy);
            App.CancellationRuleChecker.renderChangedCancellationPolicy(model, targetElement, false);
        });
    }, _TourHotelPageMobile_onActionInfoShow = function _TourHotelPageMobile_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourHotelPageMobile_instances, "m", _TourHotelPageMobile_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _TourHotelPageMobile_loadAnnouncement = function _TourHotelPageMobile_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _b;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(`${__classPrivateFieldGet(this, _TourHotelPageMobile_options, "f").urls.announcement}?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _TourHotelPageMobile_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_b = response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourHotelPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.TourHotelPageMobile = TourHotelPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TourHotelPage_instances, _a, _TourHotelPage_options, _TourHotelPage_scrolledFixedBlock, _TourHotelPage_scrollOrientedBlock, _TourHotelPage_tabs, _TourHotelPage_filter, _TourHotelPage_searchButton, _TourHotelPage_hotFilter, _TourHotelPage_result, _TourHotelPage_form, _TourHotelPage_messenger, _TourHotelPage_popup, _TourHotelPage_responseValidator, _TourHotelPage_searchPopup, _TourHotelPage_loadMap, _TourHotelPage_searchExecuting, _TourHotelPage_placementSearchExecuted, _TourHotelPage_searchExpirationPopup, _TourHotelPage_searchAbortController, _TourHotelPage_cancellationRuleCheckerField, _TourHotelPage_cancellationRuleChecker_get, _TourHotelPage_onSearchButtonClick, _TourHotelPage_generatePositionAction, _TourHotelPage_onScrollLinkClick, _TourHotelPage_onFilterSearch, _TourHotelPage_searchStep, _TourHotelPage_cancelSearch, _TourHotelPage_successSearch, _TourHotelPage_transformSearchResponse, _TourHotelPage_onTabClick, _TourHotelPage_onHotelGroupShowMore, _TourHotelPage_onDateGroupShowMore, _TourHotelPage_onCheckCancellationClick, _TourHotelPage_onActionInfoShow, _TourHotelPage_loadAnnouncement;
    class TourHotelPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _TourHotelPage_instances.add(this);
            _TourHotelPage_options.set(this, void 0);
            _TourHotelPage_scrolledFixedBlock.set(this, void 0);
            _TourHotelPage_scrollOrientedBlock.set(this, void 0);
            _TourHotelPage_tabs.set(this, void 0);
            _TourHotelPage_filter.set(this, void 0);
            _TourHotelPage_searchButton.set(this, void 0);
            _TourHotelPage_hotFilter.set(this, void 0);
            _TourHotelPage_result.set(this, void 0);
            _TourHotelPage_form.set(this, void 0);
            _TourHotelPage_messenger.set(this, void 0);
            _TourHotelPage_popup.set(this, void 0);
            _TourHotelPage_responseValidator.set(this, void 0);
            _TourHotelPage_searchPopup.set(this, void 0);
            _TourHotelPage_loadMap.set(this, false);
            _TourHotelPage_searchExecuting.set(this, false);
            _TourHotelPage_placementSearchExecuted.set(this, false);
            _TourHotelPage_searchExpirationPopup.set(this, void 0);
            _TourHotelPage_searchAbortController.set(this, void 0);
            _TourHotelPage_cancellationRuleCheckerField.set(this, void 0);
            __classPrivateFieldSet(this, _TourHotelPage_options, options, "f");
        }
        mount() {
            super.mount();
            __classPrivateFieldSet(this, _TourHotelPage_searchButton, $('.js-m-filter-submit', this.root), "f");
            __classPrivateFieldSet(this, _TourHotelPage_scrolledFixedBlock, $('.js-scrolling-reserve-block', this.root), "f");
            __classPrivateFieldSet(this, _TourHotelPage_scrollOrientedBlock, $('.js-hotels-without__block', this.root), "f");
            this.components.push(new App.Digest({ container: this.root }));
            if (__classPrivateFieldGet(this, _TourHotelPage_scrolledFixedBlock, "f").length > 0)
                $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_generatePositionAction).call(this)));
            this.components.push(new App.MediaGallery());
            const checkinLimit = __classPrivateFieldGet(this, _TourHotelPage_options, "f").checkinLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _TourHotelPage_options, "f").checkinLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _TourHotelPage_options, "f").checkinLimit.max) };
            __classPrivateFieldSet(this, _TourHotelPage_filter, new App.TourHotelMainFilter({
                datesOptions: {
                    minDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    minDateFromShift: App.app.settings.tourOptions.minCheckinDateShift,
                    maxDateToOffset: App.app.settings.tourOptions.maxHotelCheckinDateOffset,
                },
                peopleOptions: {
                    maxChildAge: App.app.settings.tourOptions.minAdultAge - 1,
                },
                urls: __classPrivateFieldGet(this, _TourHotelPage_options, "f").urls,
                changes: __classPrivateFieldGet(this, _TourHotelPage_options, "f").changes,
                regularCheckin: __classPrivateFieldGet(this, _TourHotelPage_options, "f").regularCheckin,
                charterCheckin: __classPrivateFieldGet(this, _TourHotelPage_options, "f").charterCheckin,
                isDateRange: false,
                hasMultipleHotels: false,
            }), "f");
            __classPrivateFieldGet(this, _TourHotelPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data, manual) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_onFilterSearch).call(this, e, data, manual); }));
            __classPrivateFieldSet(this, _TourHotelPage_hotFilter, new App.TourHotelHotFilter(), "f");
            __classPrivateFieldSet(this, _TourHotelPage_result, new App.TourHotelResult({
                hotFilter: __classPrivateFieldGet(this, _TourHotelPage_hotFilter, "f"),
                tableTemplate: App.templates.Tour.HotelTableOutput,
                dynamicRoomTypes: __classPrivateFieldGet(this, _TourHotelPage_options, "f").dynamicRoomTypes,
                dynamicBoardTypes: __classPrivateFieldGet(this, _TourHotelPage_options, "f").dynamicBoardTypes,
            }), "f");
            $('.js-scroll-to', this.root).on('click', __classPrivateFieldGet(_a, _a, "m", _TourHotelPage_onScrollLinkClick));
            __classPrivateFieldSet(this, _TourHotelPage_form, new App.Form({
                root: __classPrivateFieldGet(this, _TourHotelPage_filter, "f").root,
                disableStepValidation: true,
            }), "f");
            __classPrivateFieldGet(this, _TourHotelPage_searchButton, "f").on('click', e => __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_onSearchButtonClick).call(this, e));
            __classPrivateFieldSet(this, _TourHotelPage_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _TourHotelPage_popup, new App.Popup({
                onShow: () => {
                    // Для popup выбора сортировки результатов поиска после его окончания.
                    const sortButtons = $('.js-continue-search-popup-sort', __classPrivateFieldGet(this, _TourHotelPage_popup, "f").root);
                    sortButtons.on('click', e => {
                        var _b;
                        const sort = (_b = $(e.target).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
                        __classPrivateFieldGet(this, _TourHotelPage_hotFilter, "f").setFilterSortItems({ field: sort, reverse: false }, true);
                        __classPrivateFieldGet(this, _TourHotelPage_popup, "f").hide();
                    });
                    $('.js-popup-close', __classPrivateFieldGet(this, _TourHotelPage_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _TourHotelPage_popup, "f").hide());
                },
            }), "f");
            __classPrivateFieldSet(this, _TourHotelPage_responseValidator, new App.ResponseValidator({
                messenger: __classPrivateFieldGet(this, _TourHotelPage_messenger, "f"),
                validator: __classPrivateFieldGet(this, _TourHotelPage_form, "f").validator,
            }), "f");
            __classPrivateFieldSet(this, _TourHotelPage_searchPopup, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            __classPrivateFieldGet(this, _TourHotelPage_result, "f").root.on('click', '.js-cancellation-rules', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_onCheckCancellationClick).call(this, e); }));
            // TODO: подцепляться к событию отмены запроса именно этого экземпляра Preloader, а не к глобальному событию всех Preloader'ов.
            // $('body').on(Events.PreloaderClosed, () => this.#searchXhr.abort());
            this.root.on('click', '.js-tour-group-show-more-link', e => __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_onHotelGroupShowMore).call(this, e));
            this.root.on('click', '.js-tour-date-group-link', e => __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_onDateGroupShowMore).call(this, e));
            $('.js-tab', this.root).on("tab:click" /* Events.TabClick */, e => __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_onTabClick).call(this, e));
            __classPrivateFieldSet(this, _TourHotelPage_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _TourHotelPage_tabs, "f").showActive();
            // Синхронизация табов между группами 1 и 3
            let isSyncing = false;
            const syncTabGroups = (sourceGroup, targetGroup) => {
                $(`.js-tabs-block[data-group="${sourceGroup}"] .js-tab`, this.root).on("tab:click" /* Events.TabClick */, e => {
                    if (!isSyncing && e.originalEvent) {
                        const tabName = $(e.currentTarget).attr('data-tab');
                        if (tabName) {
                            isSyncing = true;
                            __classPrivateFieldGet(this, _TourHotelPage_tabs, "f").show(tabName, targetGroup);
                            isSyncing = false;
                        }
                    }
                });
            };
            syncTabGroups(1, 3);
            syncTabGroups(3, 1);
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_onActionInfoShow).call(this, e, data); }));
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                if (!__classPrivateFieldGet(this, _TourHotelPage_options, "f").manual)
                    __classPrivateFieldGet(this, _TourHotelPage_filter, "f").search(false);
            });
        }
    }
    _a = TourHotelPage, _TourHotelPage_options = new WeakMap(), _TourHotelPage_scrolledFixedBlock = new WeakMap(), _TourHotelPage_scrollOrientedBlock = new WeakMap(), _TourHotelPage_tabs = new WeakMap(), _TourHotelPage_filter = new WeakMap(), _TourHotelPage_searchButton = new WeakMap(), _TourHotelPage_hotFilter = new WeakMap(), _TourHotelPage_result = new WeakMap(), _TourHotelPage_form = new WeakMap(), _TourHotelPage_messenger = new WeakMap(), _TourHotelPage_popup = new WeakMap(), _TourHotelPage_responseValidator = new WeakMap(), _TourHotelPage_searchPopup = new WeakMap(), _TourHotelPage_loadMap = new WeakMap(), _TourHotelPage_searchExecuting = new WeakMap(), _TourHotelPage_placementSearchExecuted = new WeakMap(), _TourHotelPage_searchExpirationPopup = new WeakMap(), _TourHotelPage_searchAbortController = new WeakMap(), _TourHotelPage_cancellationRuleCheckerField = new WeakMap(), _TourHotelPage_instances = new WeakSet(), _TourHotelPage_cancellationRuleChecker_get = function _TourHotelPage_cancellationRuleChecker_get() {
        if (!__classPrivateFieldGet(this, _TourHotelPage_cancellationRuleCheckerField, "f"))
            __classPrivateFieldSet(this, _TourHotelPage_cancellationRuleCheckerField, new App.CancellationRuleChecker({ url: __classPrivateFieldGet(this, _TourHotelPage_options, "f").urls.cancellationPolicy }), "f");
        return __classPrivateFieldGet(this, _TourHotelPage_cancellationRuleCheckerField, "f");
    }, _TourHotelPage_onSearchButtonClick = function _TourHotelPage_onSearchButtonClick(event) {
        event.preventDefault();
        if (!__classPrivateFieldGet(this, _TourHotelPage_form, "f").validator.form())
            return;
        __classPrivateFieldGet(this, _TourHotelPage_filter, "f").search(true);
    }, _TourHotelPage_generatePositionAction = function _TourHotelPage_generatePositionAction() {
        var _b, _c, _d, _e, _f;
        const scrollingBlock = __classPrivateFieldGet(this, _TourHotelPage_scrolledFixedBlock, "f");
        const orientedBlock = __classPrivateFieldGet(this, _TourHotelPage_scrollOrientedBlock, "f");
        const orientedBlockOffset = orientedBlock.offset();
        const orientedBlockOffsetTop = (orientedBlockOffset != null ? orientedBlockOffset.top : 0);
        const blockScrollTop = ((_b = $(window).scrollTop()) !== null && _b !== void 0 ? _b : 0) - orientedBlockOffsetTop;
        const topBottom = ((_c = orientedBlock.outerHeight()) !== null && _c !== void 0 ? _c : 0) - ((_d = scrollingBlock.outerHeight()) !== null && _d !== void 0 ? _d : 0);
        let scrolledDistance = (_e = $(window).scrollTop()) !== null && _e !== void 0 ? _e : 0;
        if (!App.isTouch)
            scrolledDistance = (_f = App.app.container.scrollTop()) !== null && _f !== void 0 ? _f : 0;
        if (scrolledDistance >= orientedBlockOffsetTop) {
            scrollingBlock.addClass('_fixed_scroll');
            if (blockScrollTop >= topBottom)
                scrollingBlock.removeClass('_fixed_scroll').css({ 'top': topBottom });
            else
                scrollingBlock.addClass('_fixed_scroll').css({ 'top': 0 });
        }
        else {
            scrollingBlock.removeClass('_fixed_scroll');
        }
    }, _TourHotelPage_onScrollLinkClick = function _TourHotelPage_onScrollLinkClick(e) {
        var _b;
        const target = $(e.currentTarget);
        const destId = target.attr('data-scroll');
        if (!destId)
            return;
        const dest = $(`[data-dest="${destId}"]`);
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += ((_b = App.app.container.scrollTop()) !== null && _b !== void 0 ? _b : 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    }, _TourHotelPage_onFilterSearch = function _TourHotelPage_onFilterSearch(event, data, manual) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c, _d, _e;
            __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_cancelSearch).call(this);
            (_b = __classPrivateFieldGet(this, _TourHotelPage_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
            __classPrivateFieldGet(this, _TourHotelPage_result, "f").resetDataSource();
            __classPrivateFieldGet(this, _TourHotelPage_hotFilter, "f").reset();
            const popupGroup = __classPrivateFieldGet(this, _TourHotelPage_searchPopup, "f").show({
                group: 'main',
                content: App.templates.Tour.Messages.Searching({}),
                modal: true,
            });
            (_c = __classPrivateFieldGet(this, _TourHotelPage_searchAbortController, "f")) === null || _c === void 0 ? void 0 : _c.abort();
            __classPrivateFieldSet(this, _TourHotelPage_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _TourHotelPage_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            const tasks = new Array();
            if (__classPrivateFieldGet(this, _TourHotelPage_options, "f").hasDynamicHotel) {
                tasks.push(__classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external' }), retryPolicy, signal));
                tasks.push(__classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'internal' }), retryPolicy, signal));
            }
            else {
                tasks.push(__classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_searchStep).call(this, data, retryPolicy, signal));
            }
            __classPrivateFieldSet(this, _TourHotelPage_searchExecuting, true, "f");
            // Note: менять на вкладку 'placement' после установки #searchExecuting, чтобы можно было определить запущен поиск или нет.
            (_d = __classPrivateFieldGet(this, _TourHotelPage_tabs, "f")) === null || _d === void 0 ? void 0 : _d.show('placement', 1);
            (_e = __classPrivateFieldGet(this, _TourHotelPage_tabs, "f")) === null || _e === void 0 ? void 0 : _e.show('placement', 3);
            let firstStep = true;
            let successSteps = 0;
            let error;
            /* eslint-disable no-await-in-loop */
            while (tasks.length > 0) {
                try {
                    signal.throwIfAborted();
                    const [task] = yield Promise.race(tasks.map(v => v.then(() => [v], () => [v])));
                    App.removeElement(tasks, task);
                    const response = yield task;
                    if (response) {
                        signal.throwIfAborted();
                        if (yield __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_successSearch).call(this, response, firstStep, successSteps, tasks.length > 0, manual, data, signal))
                            successSteps++;
                        if (response.data.continuationState)
                            tasks.push(__classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external', continuationState: response.data.continuationState }), retryPolicy, signal));
                    }
                    // Быстрый выход из цикла, чтобы переменная firstStep осталась равна true, если завершение происходит на первом же шаге.
                    if (tasks.length <= 0)
                        break;
                }
                catch (ex) {
                    if (signal.aborted)
                        break;
                    error = ex;
                }
                finally {
                    if (successSteps === 1 || tasks.length <= 0)
                        __classPrivateFieldGet(this, _TourHotelPage_searchPopup, "f").hide(popupGroup);
                }
                firstStep = false;
                __classPrivateFieldGet(this, _TourHotelPage_hotFilter, "f").showProgressDataLoader();
            }
            /* eslint-enable no-await-in-loop */
            __classPrivateFieldSet(this, _TourHotelPage_searchExecuting, false, "f");
            __classPrivateFieldGet(this, _TourHotelPage_hotFilter, "f").hideProgressDataLoader();
            if (successSteps <= 0 && error != null && !__classPrivateFieldGet(this, _TourHotelPage_responseValidator, "f").processError(error)) {
                /* eslint-disable-next-line @typescript-eslint/no-throw-literal */
                throw error;
            }
            if (successSteps > 0 && tasks.length <= 0) {
                if (successSteps === 1) {
                    // Поиск полностью завершен за 1 шаг.
                    __classPrivateFieldGet(this, _TourHotelPage_hotFilter, "f").setFilterSortItems({ field: App.TourSortFields.Price, reverse: false }, true);
                }
                else if (__classPrivateFieldGet(this, _TourHotelPage_hotFilter, "f").activeSorting.field !== App.TourSortFields.Price) {
                    // Поиск полностью завершен за более чем 1 шаг.
                    __classPrivateFieldGet(this, _TourHotelPage_popup, "f").show({
                        content: App.templates.Tour.Messages.PartialSearchCompleted({}),
                        modal: true,
                    });
                }
            }
        });
    }, _TourHotelPage_searchStep = function _TourHotelPage_searchStep(data, retryPolicy, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                signal.throwIfAborted();
                const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourHotelPage_options, "f").urls.search, { body: App.createUrlSearchParams(data), signal });
                if (!__classPrivateFieldGet(this, _TourHotelPage_responseValidator, "f").process(result))
                    return;
                return result;
            }), signal);
        });
    }, _TourHotelPage_cancelSearch = function _TourHotelPage_cancelSearch() {
        var _b;
        (_b = __classPrivateFieldGet(this, _TourHotelPage_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
    }, _TourHotelPage_successSearch = function _TourHotelPage_successSearch(response, firstStep, successSteps, hasMoreSteps, manual, data, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            signal.throwIfAborted();
            if (firstStep && response.data.seo != null) {
                App.app.seo.update(response.data.seo);
                if (!manual)
                    window.history.replaceState(null, document.title, response.data.seo.url);
                else
                    window.history.pushState(null, document.title, response.data.seo.url);
            }
            signal.throwIfAborted();
            // Определение наличия результатов поиска
            if (response.data.offers && response.data.offers.length > 0) {
                if (successSteps <= 0) {
                    __classPrivateFieldSet(this, _TourHotelPage_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: __classPrivateFieldGet(this, _TourHotelPage_options, "f").urls.base,
                    }), "f");
                }
                __classPrivateFieldGet(this, _TourHotelPage_result, "f").filters = data;
                const { offers } = response.data;
                const showVariants = (Array.isArray(data.Hotel) && data.Hotel.length === 1)
                    || (successSteps <= 0
                        && !hasMoreSteps
                        && !response.data.continuationState
                        && (offers.length <= 1 || offers.every(v => v.hotel.key === offers[0].hotel.key)));
                const responseData = __classPrivateFieldGet(_a, _a, "m", _TourHotelPage_transformSearchResponse).call(_a, offers, showVariants);
                yield __classPrivateFieldGet(this, _TourHotelPage_result, "f").changeDataSource(responseData, successSteps > 0);
                if (successSteps <= 0) {
                    const scrollOffset = __classPrivateFieldGet(this, _TourHotelPage_result, "f").root.offset();
                    if (scrollOffset)
                        window.scrollTo(scrollOffset.left, scrollOffset.top);
                }
                return true;
            }
            if (successSteps <= 0 && !hasMoreSteps) {
                __classPrivateFieldGet(this, _TourHotelPage_messenger, "f").show({ type: 0 /* MessageType.Information */, text: 'Вариантов, соответствующих заданным критериям, нет.' }, { group: 'ajax' });
            }
            return false;
        });
    }, _TourHotelPage_transformSearchResponse = function _TourHotelPage_transformSearchResponse(offers, showVariants) {
        return Enumerable.from(offers)
            .select(x => new App.TourHotelSearchViewModel(x))
            .groupBy(v => v.hotel.key, v => v, (k, v) => new App.TourHotelProgramGroupSearchViewModel(v.first().hotel, v
            .groupBy(x => x.beginDate, x => x, (k2, v2) => new App.TourHotelDateGroupSearchViewModel(k2, v2.toArray()))
            .toArray(), showVariants))
            .toArray();
    }, _TourHotelPage_onTabClick = function _TourHotelPage_onTabClick(e) {
        const tabName = $(e.target).attr('data-tab');
        if (tabName === 'placement' && !__classPrivateFieldGet(this, _TourHotelPage_searchExecuting, "f") && !__classPrivateFieldGet(this, _TourHotelPage_placementSearchExecuted, "f")) {
            __classPrivateFieldSet(this, _TourHotelPage_placementSearchExecuted, true, "f");
            __classPrivateFieldGet(this, _TourHotelPage_filter, "f").search(false);
        }
        if (tabName === 'map' && !__classPrivateFieldGet(this, _TourHotelPage_loadMap, "f")) {
            if (__classPrivateFieldGet(this, _TourHotelPage_options, "f").hotel.coordinate) {
                const mapModel = {
                    mapTitle: '',
                    mapPoints: [
                        {
                            type: "hotel" /* MapPointType.Hotel */,
                            coordinates: __classPrivateFieldGet(this, _TourHotelPage_options, "f").hotel.coordinate,
                            text: __classPrivateFieldGet(this, _TourHotelPage_options, "f").hotel.name,
                            selected: true,
                            stars: `${__classPrivateFieldGet(this, _TourHotelPage_options, "f").hotel.categoryCode}`,
                        },
                    ],
                };
                this.components.push(new App.UnfoldMap(mapModel, false));
                __classPrivateFieldSet(this, _TourHotelPage_loadMap, true, "f");
            }
        }
    }, _TourHotelPage_onHotelGroupShowMore = function _TourHotelPage_onHotelGroupShowMore(e) {
        var _b, _c, _d, _e, _f, _g;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        const container = target.parents('.js-tour-table-block');
        const showLinks = container.find('.js-tour-group-show-more-link-show');
        const hideLinks = container.find('.js-tour-group-show-more-link-hide');
        const isHidden = (showLinks.length > 0 && !showLinks.hasClass('_hidden-2'))
            || (hideLinks.length > 0 && hideLinks.hasClass('_hidden-2'));
        const groupContainer = container.find('.js-tour-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-group-content-items');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = __classPrivateFieldGet(this, _TourHotelPage_result, "f").findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        hotelGroup.showVariants = isHidden;
        const currentOffset = ((_d = (_c = container.offset()) === null || _c === void 0 ? void 0 : _c.top) !== null && _d !== void 0 ? _d : 0) - ((_e = $(document).scrollTop()) !== null && _e !== void 0 ? _e : 0);
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.HotelProgramGroup(hotelGroup.visibleItems));
            groupItemsContainer.append(content);
            container.addClass('_open');
        }
        else {
            container.removeClass('_open');
        }
        showLinks.toggleByClass(!hotelGroup.showVariants);
        hideLinks.toggleByClass(hotelGroup.showVariants);
        $(document).scrollTop(((_g = (_f = container.offset()) === null || _f === void 0 ? void 0 : _f.top) !== null && _g !== void 0 ? _g : 0) - currentOffset);
    }, _TourHotelPage_onDateGroupShowMore = function _TourHotelPage_onDateGroupShowMore(e) {
        var _b, _c;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        if (target.hasClass('_active'))
            return;
        const container = target.parents('.js-tour-table-block');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = __classPrivateFieldGet(this, _TourHotelPage_result, "f").findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        const groupContainer = target.parents('.js-tour-date-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-date-group-content-items');
        const dateGroupKey = (_c = target.attr('data-key')) !== null && _c !== void 0 ? _c : '';
        const dateGroup = App.TourHotelResult.findDateGroup(hotelGroup, dateGroupKey);
        const showLinks = groupContainer.find('.js-tour-date-group-link');
        if (!dateGroup)
            return;
        hotelGroup.items.forEach(v => (v.active = false));
        showLinks.removeClass('_active');
        dateGroup.active = true;
        target.addClass('_active');
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.HotelDateGroup(dateGroup.visibleItems));
            groupItemsContainer.append(content);
        }
    }, _TourHotelPage_onCheckCancellationClick = function _TourHotelPage_onCheckCancellationClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            e.preventDefault();
            e.stopPropagation();
            const targetElement = $(e.target);
            const policy = yield __classPrivateFieldGet(this, _TourHotelPage_instances, "a", _TourHotelPage_cancellationRuleChecker_get).getCancellationPolicy(targetElement, __classPrivateFieldGet(this, _TourHotelPage_messenger, "f"));
            if (!policy)
                return;
            const variantKey = (_b = targetElement.attr('data-variant-key')) !== null && _b !== void 0 ? _b : '';
            const variant = __classPrivateFieldGet(this, _TourHotelPage_result, "f").findOfferByDynamicHotel(variantKey);
            if (variant)
                variant.cancellationPolicy = policy;
            const model = new App.VariantCancellationViewModel('', policy);
            App.CancellationRuleChecker.renderChangedCancellationPolicy(model, targetElement, false);
        });
    }, _TourHotelPage_onActionInfoShow = function _TourHotelPage_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourHotelPage_instances, "m", _TourHotelPage_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _TourHotelPage_loadAnnouncement = function _TourHotelPage_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _b;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(
                    // TODO: убрать вызов toString после апгрейда "@typescript-eslint/eslint-plugin".
                    `${__classPrivateFieldGet(this, _TourHotelPage_options, "f").urls.announcement}?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _TourHotelPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_b = response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourHotelPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.TourHotelPage = TourHotelPage;
})(App || (App = {}));
var App;
(function (App) {
    var _TourProgramPageMobile_instances, _a, _TourProgramPageMobile_options, _TourProgramPageMobile_arrivalOption, _TourProgramPageMobile_arrivalProgram, _TourProgramPageMobile_scrollBookLink, _TourProgramPageMobile_bookScrollToWrap, _TourProgramPageMobile_tourInfoTextBlock, _TourProgramPageMobile_readMoreLink, _TourProgramPageMobile_filter, _TourProgramPageMobile_hotFilter, _TourProgramPageMobile_result, _TourProgramPageMobile_messenger, _TourProgramPageMobile_responseValidator, _TourProgramPageMobile_searchPopup, _TourProgramPageMobile_searchAbortController, _TourProgramPageMobile_searchExpirationPopup, _TourProgramPageMobile_cancellationRuleCheckerField, _TourProgramPageMobile_cancellationRuleChecker_get, _TourProgramPageMobile_setBookingPosition, _TourProgramPageMobile_onScrollLinkClick, _TourProgramPageMobile_toggleVariantVisibility, _TourProgramPageMobile_isVisibleVariant, _TourProgramPageMobile_switchProgram, _TourProgramPageMobile_onSearchSubmit, _TourProgramPageMobile_onFilterSearch, _TourProgramPageMobile_searchStep, _TourProgramPageMobile_cancelSearch, _TourProgramPageMobile_successSearch, _TourProgramPageMobile_transformSearchResponse, _TourProgramPageMobile_onHotelGroupShowMore, _TourProgramPageMobile_onDateGroupShowMore, _TourProgramPageMobile_onCheckCancellationClick, _TourProgramPageMobile_onActionInfoShow, _TourProgramPageMobile_loadAnnouncement;
    class TourProgramPageMobile extends App.PageMobileBase {
        constructor(options) {
            // NOTE: root задаем явно, т.к. в мобильном layout нет элемента .js-app-container
            // (app.appContainer пуст, а выдача находится в js-app-container-content)
            super(Object.assign({ root: '.js-tour-program-page .js-app-container-content' }, options));
            _TourProgramPageMobile_instances.add(this);
            _TourProgramPageMobile_options.set(this, void 0);
            _TourProgramPageMobile_arrivalOption.set(this, void 0);
            _TourProgramPageMobile_arrivalProgram.set(this, void 0);
            _TourProgramPageMobile_scrollBookLink.set(this, void 0);
            _TourProgramPageMobile_bookScrollToWrap.set(this, void 0);
            _TourProgramPageMobile_tourInfoTextBlock.set(this, void 0);
            _TourProgramPageMobile_readMoreLink.set(this, void 0);
            _TourProgramPageMobile_filter.set(this, void 0);
            _TourProgramPageMobile_hotFilter.set(this, void 0);
            _TourProgramPageMobile_result.set(this, void 0);
            _TourProgramPageMobile_messenger.set(this, void 0);
            _TourProgramPageMobile_responseValidator.set(this, void 0);
            _TourProgramPageMobile_searchPopup.set(this, void 0);
            _TourProgramPageMobile_searchAbortController.set(this, void 0);
            _TourProgramPageMobile_searchExpirationPopup.set(this, void 0);
            _TourProgramPageMobile_cancellationRuleCheckerField.set(this, void 0);
            __classPrivateFieldSet(this, _TourProgramPageMobile_options, options, "f");
        }
        mount() {
            var _b;
            super.mount();
            __classPrivateFieldSet(this, _TourProgramPageMobile_tourInfoTextBlock, $('.js-tour-info-text-block', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_readMoreLink, $('.js-read-more', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_arrivalOption, $('.js-arrival-option', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_arrivalProgram, $('.js-arrival-program', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_scrollBookLink, $('.js-scroll-book-link', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_bookScrollToWrap, $('.js-book-to-scroll', this.root), "f");
            // прилипание/отлипание ссылки 'к бронированию'
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_setBookingPosition).call(this)));
            const scrollOffset = $('.js-header', this.root).offset();
            if (scrollOffset)
                window.scrollTo(0, scrollOffset.top);
            // Проверяем высоту текстового блока с описанием и скрываем лишнее (если надо)
            const textBlockHeight = (_b = __classPrivateFieldGet(this, _TourProgramPageMobile_tourInfoTextBlock, "f").height()) !== null && _b !== void 0 ? _b : 0;
            if (textBlockHeight > 60) {
                $('.js-read-more-gradient', this.root).removeClass('_hidden');
                __classPrivateFieldGet(this, _TourProgramPageMobile_readMoreLink, "f").removeClass('_hidden');
            }
            this.root.on('click', '.js-read-more', App.readMoreClickHandler);
            this.root.on('click', '.js-scroll-to', e => __classPrivateFieldGet(_a, _a, "m", _TourProgramPageMobile_onScrollLinkClick).call(_a, e));
            // Галерея с изображениями
            $('.js-media-gallery-mobile', this.root).each((_, el) => {
                new App.MediaGalleryMobile({ self: $(el) });
            });
            // Параметры поиска (кнопка "Изменить поиск" открывает модалку)
            __classPrivateFieldSet(this, _TourProgramPageMobile_filter, new App.TourProgramMainFilterMobile({
                urls: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").urls,
                changes: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").changes,
                hasDynamicHotel: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").hasDynamicHotel,
            }), "f");
            // Хот-фильтр (сортировка + фильтры по результатам)
            __classPrivateFieldSet(this, _TourProgramPageMobile_hotFilter, new App.TourProgramHotFilterMobile({
                resultOptions: {
                    hasDynamicHotel: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").hasDynamicHotel,
                    hotelBoards: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").hotelBoards,
                    dynamicRoomTypes: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").dynamicRoomTypes,
                    dynamicBoardTypes: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").dynamicBoardTypes,
                    restTypeKey: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").restTypeKey,
                    countryKey: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").countryKey,
                },
            }), "f");
            __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_cancelSearch).call(this);
                __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").hideProgressDataLoader();
            });
            // Выдача результатов
            __classPrivateFieldSet(this, _TourProgramPageMobile_result, new App.TourProgramResultMobile({
                root: this.root,
                hotFilter: __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f"),
                hasDynamicHotel: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").hasDynamicHotel,
                hotelBoards: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").hotelBoards,
                dynamicRoomTypes: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").dynamicRoomTypes,
                dynamicBoardTypes: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").dynamicBoardTypes,
                restTypeKey: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").restTypeKey,
                countryKey: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").countryKey,
            }), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_responseValidator, new App.ResponseValidator({
                messenger: __classPrivateFieldGet(this, _TourProgramPageMobile_messenger, "f"),
                validator: __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.validator,
            }), "f");
            __classPrivateFieldSet(this, _TourProgramPageMobile_searchPopup, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_cancelSearch).call(this);
                    inst.hide();
                }
            });
            this.root.on('click', '.js-tour-group-show-more-link', e => __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_onHotelGroupShowMore).call(this, e));
            this.root.on('click', '.js-tour-date-group-link', e => __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_onDateGroupShowMore).call(this, e));
            __classPrivateFieldGet(this, _TourProgramPageMobile_arrivalOption, "f").on('click', e => __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_switchProgram).call(this, e));
            __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.searchFilter.on("filter:search" /* Events.FilterSearch */, (_, data, manual) => __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_onFilterSearch).call(this, data !== null && data !== void 0 ? data : __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").buildSearchData(), manual !== false));
            __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").root.on('submit', e => __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_onSearchSubmit).call(this, e));
            // сортировка по умолчанию - по цене (как на десктопе)
            __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").setFilterSortItems({ field: App.TourSortFields.Price, reverse: false }, false);
            this.components.push(new App.PrintComponent({
                modes: {
                    'text': 'Программа без картинок',
                    'image': 'Программа с картинками',
                    'default': 'Страница целиком',
                },
            }));
            __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").root.on('click', '.js-cancellation-rules', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_onCheckCancellationClick).call(this, e); }));
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_onActionInfoShow).call(this, e, data); }));
            __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_toggleVariantVisibility).call(this);
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                if (!__classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").manual)
                    __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").search(false);
            });
        }
    }
    _a = TourProgramPageMobile, _TourProgramPageMobile_options = new WeakMap(), _TourProgramPageMobile_arrivalOption = new WeakMap(), _TourProgramPageMobile_arrivalProgram = new WeakMap(), _TourProgramPageMobile_scrollBookLink = new WeakMap(), _TourProgramPageMobile_bookScrollToWrap = new WeakMap(), _TourProgramPageMobile_tourInfoTextBlock = new WeakMap(), _TourProgramPageMobile_readMoreLink = new WeakMap(), _TourProgramPageMobile_filter = new WeakMap(), _TourProgramPageMobile_hotFilter = new WeakMap(), _TourProgramPageMobile_result = new WeakMap(), _TourProgramPageMobile_messenger = new WeakMap(), _TourProgramPageMobile_responseValidator = new WeakMap(), _TourProgramPageMobile_searchPopup = new WeakMap(), _TourProgramPageMobile_searchAbortController = new WeakMap(), _TourProgramPageMobile_searchExpirationPopup = new WeakMap(), _TourProgramPageMobile_cancellationRuleCheckerField = new WeakMap(), _TourProgramPageMobile_instances = new WeakSet(), _TourProgramPageMobile_cancellationRuleChecker_get = function _TourProgramPageMobile_cancellationRuleChecker_get() {
        if (!__classPrivateFieldGet(this, _TourProgramPageMobile_cancellationRuleCheckerField, "f"))
            __classPrivateFieldSet(this, _TourProgramPageMobile_cancellationRuleCheckerField, new App.CancellationRuleChecker({ url: __classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").urls.cancellationPolicy }), "f");
        return __classPrivateFieldGet(this, _TourProgramPageMobile_cancellationRuleCheckerField, "f");
    }, _TourProgramPageMobile_setBookingPosition = function _TourProgramPageMobile_setBookingPosition() {
        var _b, _c, _d;
        const scrolledPos = ((_b = $(window).scrollTop()) !== null && _b !== void 0 ? _b : 0) + ((_c = $(window).outerHeight()) !== null && _c !== void 0 ? _c : 0);
        const offset = __classPrivateFieldGet(this, _TourProgramPageMobile_bookScrollToWrap, "f").offset();
        const offsetTop = (offset != null ? offset.top : 0);
        if (scrolledPos >= offsetTop && scrolledPos < offsetTop + ((_d = __classPrivateFieldGet(this, _TourProgramPageMobile_bookScrollToWrap, "f").outerHeight()) !== null && _d !== void 0 ? _d : 0))
            __classPrivateFieldGet(this, _TourProgramPageMobile_scrollBookLink, "f").addClass('_fixed_book');
        else
            __classPrivateFieldGet(this, _TourProgramPageMobile_scrollBookLink, "f").removeClass('_fixed_book');
    }, _TourProgramPageMobile_onScrollLinkClick = function _TourProgramPageMobile_onScrollLinkClick(e) {
        var _b;
        const target = $(e.currentTarget);
        const destId = target.attr('data-scroll');
        if (!destId)
            return;
        const dest = $(`[data-dest="${destId}"]`);
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += ((_b = App.app.container.scrollTop()) !== null && _b !== void 0 ? _b : 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    }, _TourProgramPageMobile_toggleVariantVisibility = function _TourProgramPageMobile_toggleVariantVisibility() {
        var _b, _c, _d, _e;
        const cityKey = parseInt((_b = __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.getControlValueString('City')) !== null && _b !== void 0 ? _b : '-1', 10) || 0;
        let dateFrom;
        let dateTo;
        if (__classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").hasDynamicHotel) {
            const value = (_c = __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.findControl('Checkin.From')) === null || _c === void 0 ? void 0 : _c.getValue();
            dateFrom = dateTo = value !== null && value !== void 0 ? value : new Date();
        }
        else {
            const from = (_d = __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.findControl('Checkin.From')) === null || _d === void 0 ? void 0 : _d.getValue();
            const to = (_e = __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.findControl('Checkin.To')) === null || _e === void 0 ? void 0 : _e.getValue();
            dateFrom = from !== null && from !== void 0 ? from : new Date();
            dateTo = to !== null && to !== void 0 ? to : dateFrom;
        }
        const nights = __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.getControlValueStringArr('Night')
            .join(',')
            .split(',')
            .filter(v => v !== '')
            .map(v => parseInt(v, 10));
        __classPrivateFieldGet(this, _TourProgramPageMobile_arrivalOption, "f").each((i, v) => {
            const jqElement = $(v);
            const isVisible = __classPrivateFieldGet(_a, _a, "m", _TourProgramPageMobile_isVisibleVariant).call(_a, jqElement, cityKey, dateFrom, dateTo, nights);
            jqElement.toggleByClass(isVisible);
        });
        // первый видимый вариант заезда выбирается
        __classPrivateFieldGet(this, _TourProgramPageMobile_arrivalOption, "f").filter(':visible').first().trigger('click');
    }, _TourProgramPageMobile_isVisibleVariant = function _TourProgramPageMobile_isVisibleVariant(element, cityKey, dateFrom, dateTo, nights) {
        const validTransportStr = element.attr('data-program-transport');
        const validTransport = validTransportStr ? Number(validTransportStr) : null;
        if (validTransport === /* авиаперелет*/ 1) {
            const depCityKeysStr = element.attr('data-program-departure-city');
            const depCityKeys = depCityKeysStr
                ? depCityKeysStr.split(',').map(v => Number(v))
                : new Array();
            if (cityKey <= 0 || (depCityKeys.length > 0 && !depCityKeys.includes(cityKey)))
                return false;
        }
        else if (validTransport !== null) {
            if (cityKey > 0)
                return false;
        }
        const beginDateStr = element.attr('data-program-begin-date');
        const beginDate = beginDateStr ? App.parseIsoDate(beginDateStr) : null;
        if (beginDate && beginDate > dateTo)
            return false;
        const endDateStr = element.attr('data-program-end-date');
        const endDate = endDateStr ? App.parseIsoDate(endDateStr) : null;
        if (endDate && dateFrom > endDate)
            return false;
        const durationDaysStr = element.attr('data-program-duration');
        const durationNights = durationDaysStr ? Number(durationDaysStr) - 1 : null;
        if (durationNights && !nights.includes(durationNights))
            return false;
        const weekdayFlagsStr = element.attr('data-program-weekdays');
        const weekdayFlags = weekdayFlagsStr ? Number(weekdayFlagsStr) : null;
        if (weekdayFlags && weekdayFlags !== App.PacketWeekdays.All) {
            const effectiveBeginDate = beginDate ? App.maxDate(beginDate, dateFrom) : dateFrom;
            const effectiveEndDate = endDate ? App.minDate(endDate, dateTo) : dateTo;
            if (effectiveBeginDate > effectiveEndDate)
                return false;
            const totalDays = App.dateDiff(effectiveEndDate, effectiveBeginDate).getTotalDays() + 1;
            if (totalDays < 7) {
                let found = false;
                let isoWeekday = (effectiveBeginDate.getDay() + 6) % 7;
                for (let i = 0; i < totalDays; i++) {
                    const weekdayMask = 1 << (6 - isoWeekday);
                    if ((weekdayFlags & weekdayMask) === weekdayMask) {
                        found = true;
                        break;
                    }
                    isoWeekday = (isoWeekday + 1) % 7;
                }
                if (!found)
                    return false;
            }
        }
        return true;
    }, _TourProgramPageMobile_switchProgram = function _TourProgramPageMobile_switchProgram(e) {
        const target = $(e.currentTarget);
        const id = target.attr('data-program');
        if (!id)
            return;
        const isActive = target.hasClass('_active');
        // Показываем нужную программу
        if (!isActive) {
            __classPrivateFieldGet(this, _TourProgramPageMobile_arrivalOption, "f").removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _TourProgramPageMobile_arrivalProgram, "f").removeClass('_active');
            __classPrivateFieldGet(this, _TourProgramPageMobile_arrivalProgram, "f").hide();
            const tab = __classPrivateFieldGet(this, _TourProgramPageMobile_arrivalProgram, "f").filter(`[data-program="${id}"]`);
            tab.fadeIn(300);
            // Получаем слайдеры в программе и принудительно выставляем первый слайд,
            // чтобы слайдер проинициализировался
            const sliders = $('.js-tour-info-slider', tab);
            if (sliders.length) {
                sliders.each((index, element) => {
                    $(element).slick('refresh');
                });
            }
        }
    }, _TourProgramPageMobile_onSearchSubmit = function _TourProgramPageMobile_onSearchSubmit(event) {
        event.preventDefault();
        __classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").search(true);
    }, _TourProgramPageMobile_onFilterSearch = function _TourProgramPageMobile_onFilterSearch(data, manual) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_cancelSearch).call(this);
            (_b = __classPrivateFieldGet(this, _TourProgramPageMobile_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
            __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").resetDataSource();
            __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").reset();
            if (!__classPrivateFieldGet(this, _TourProgramPageMobile_filter, "f").filters.validator.form())
                return;
            __classPrivateFieldSet(this, _TourProgramPageMobile_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _TourProgramPageMobile_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            const tasks = new Array();
            if (__classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").hasDynamicHotel) {
                tasks.push(__classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external' }), retryPolicy, signal));
                tasks.push(__classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'internal' }), retryPolicy, signal));
            }
            else {
                tasks.push(__classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_searchStep).call(this, data, retryPolicy, signal));
            }
            let firstStep = true;
            let successSteps = 0;
            let error;
            const popupGroup = __classPrivateFieldGet(this, _TourProgramPageMobile_searchPopup, "f").show({
                group: 'main',
                content: App.templates.Tour.Messages.Searching({}),
                modal: true,
            });
            /* eslint-disable no-await-in-loop */
            while (tasks.length > 0) {
                try {
                    signal.throwIfAborted();
                    const [task] = yield Promise.race(tasks.map(v => v.then(() => [v], () => [v])));
                    App.removeElement(tasks, task);
                    const response = yield task;
                    if (response) {
                        signal.throwIfAborted();
                        if (yield __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_successSearch).call(this, response, firstStep, successSteps, tasks.length > 0, manual, data, signal))
                            successSteps++;
                        if (response.data.continuationState) {
                            yield App.delay(App.randomInt(500, 2000), App.noneSignal);
                            tasks.push(__classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external', continuationState: response.data.continuationState }), retryPolicy, signal));
                        }
                    }
                    if (tasks.length <= 0)
                        break;
                }
                catch (ex) {
                    if (signal.aborted)
                        break;
                    error = ex;
                }
                finally {
                    if (successSteps === 1 || tasks.length <= 0)
                        __classPrivateFieldGet(this, _TourProgramPageMobile_searchPopup, "f").hide(popupGroup);
                }
                firstStep = false;
                __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").showProgressDataLoader();
            }
            /* eslint-enable no-await-in-loop */
            __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").hideProgressDataLoader();
            if (successSteps <= 0 && error != null && !__classPrivateFieldGet(this, _TourProgramPageMobile_responseValidator, "f").processError(error)) {
                /* eslint-disable-next-line @typescript-eslint/no-throw-literal */
                throw error;
            }
            if (successSteps > 0 && tasks.length <= 0) {
                if (successSteps === 1) {
                    // Поиск полностью завершен за 1 шаг.
                    __classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").setFilterSortItems({ field: App.TourSortFields.Price, reverse: false }, true);
                }
                else if (__classPrivateFieldGet(this, _TourProgramPageMobile_hotFilter, "f").activeSorting.field !== App.TourSortFields.Price) {
                    // Поиск полностью завершен за более чем 1 шаг.
                    __classPrivateFieldGet(this, _TourProgramPageMobile_searchPopup, "f").show({
                        content: App.templates.Tour.Messages.PartialSearchCompleted({}),
                        modal: true,
                    });
                }
            }
        });
    }, _TourProgramPageMobile_searchStep = function _TourProgramPageMobile_searchStep(data, retryPolicy, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                signal.throwIfAborted();
                const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").urls.search, { body: App.createUrlSearchParams(data), signal });
                if (!__classPrivateFieldGet(this, _TourProgramPageMobile_responseValidator, "f").process(result))
                    return;
                return result;
            }), signal);
        });
    }, _TourProgramPageMobile_cancelSearch = function _TourProgramPageMobile_cancelSearch() {
        var _b;
        (_b = __classPrivateFieldGet(this, _TourProgramPageMobile_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
    }, _TourProgramPageMobile_successSearch = function _TourProgramPageMobile_successSearch(response, firstStep, successSteps, hasMoreSteps, manual, data, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            signal.throwIfAborted();
            if (firstStep && response.data.seo != null) {
                App.app.seo.update(response.data.seo);
                if (!manual)
                    window.history.replaceState(null, document.title, response.data.seo.url);
                else
                    window.history.pushState(null, document.title, response.data.seo.url);
            }
            signal.throwIfAborted();
            // Определение наличия результатов поиска
            if (response.data.offers && response.data.offers.length > 0) {
                if (successSteps <= 0) {
                    __classPrivateFieldSet(this, _TourProgramPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        customRefresh: true,
                        isContainerPopup: true,
                        root: this.root,
                    }), "f");
                }
                __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").filters = data;
                __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").filters["Country" /* TourFilterFields.Country */] = `${__classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").countryKey}`;
                const { offers } = response.data;
                const showVariants = (Array.isArray(data.Hotel) && data.Hotel.length === 1)
                    || (successSteps <= 0
                        && !hasMoreSteps
                        && !response.data.continuationState
                        && (offers.length <= 1 || offers.every(v => v.hotels[0].key === offers[0].hotels[0].key)));
                const responseData = __classPrivateFieldGet(_a, _a, "m", _TourProgramPageMobile_transformSearchResponse).call(_a, offers, showVariants);
                yield __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").changeDataSource(responseData, successSteps > 0);
                return true;
            }
            if (successSteps <= 0 && !hasMoreSteps) {
                __classPrivateFieldGet(this, _TourProgramPageMobile_messenger, "f").show({ type: 0 /* MessageType.Information */, text: 'Вариантов, соответствующих заданным критериям, нет.' }, { group: 'ajax' });
            }
            return false;
        });
    }, _TourProgramPageMobile_transformSearchResponse = function _TourProgramPageMobile_transformSearchResponse(offers, showVariants) {
        return Enumerable.from(offers)
            .select(x => new App.TourProgramSearchViewModel(x))
            .where(v => v.hotels.length > 0)
            .groupBy(v => v.hotels[0].key, v => v, (k, v) => new App.TourProgramHotelGroupSearchViewModel(v.first().hotels[0], v
            .groupBy(x => x.beginDate, x => x, (k2, v2) => new App.TourProgramDateGroupSearchViewModel(k2, v2.toArray()))
            .toArray(), showVariants))
            .toArray();
    }, _TourProgramPageMobile_onHotelGroupShowMore = function _TourProgramPageMobile_onHotelGroupShowMore(e) {
        var _b, _c, _d, _e, _f, _g;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        const container = target.parents('.js-tour-table-block');
        const showLinks = container.find('.js-tour-group-show-more-link-show');
        const hideLinks = container.find('.js-tour-group-show-more-link-hide');
        const isHidden = (showLinks.length > 0 && !showLinks.hasClass('_hidden-2'))
            || (hideLinks.length > 0 && hideLinks.hasClass('_hidden-2'));
        const groupContainer = container.find('.js-tour-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-group-content-items');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        hotelGroup.showVariants = isHidden;
        const currentOffset = ((_d = (_c = container.offset()) === null || _c === void 0 ? void 0 : _c.top) !== null && _d !== void 0 ? _d : 0) - ((_e = $(document).scrollTop()) !== null && _e !== void 0 ? _e : 0);
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.ProgramHotelGroup(hotelGroup.visibleItems));
            groupItemsContainer.append(content);
            container.addClass('_open');
        }
        else {
            container.removeClass('_open');
        }
        showLinks.toggleByClass(!hotelGroup.showVariants);
        hideLinks.toggleByClass(hotelGroup.showVariants);
        $(document).scrollTop(((_g = (_f = container.offset()) === null || _f === void 0 ? void 0 : _f.top) !== null && _g !== void 0 ? _g : 0) - currentOffset);
    }, _TourProgramPageMobile_onDateGroupShowMore = function _TourProgramPageMobile_onDateGroupShowMore(e) {
        var _b, _c;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        if (target.hasClass('_active'))
            return;
        const container = target.parents('.js-tour-table-block');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        const groupContainer = target.parents('.js-tour-date-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-date-group-content-items');
        const dateGroupKey = (_c = target.attr('data-key')) !== null && _c !== void 0 ? _c : '';
        const dateGroup = App.TourProgramResult.findDateGroup(hotelGroup, dateGroupKey);
        const showLinks = groupContainer.find('.js-tour-date-group-link');
        if (!dateGroup)
            return;
        hotelGroup.items.forEach(v => (v.active = false));
        showLinks.removeClass('_active');
        dateGroup.active = true;
        target.addClass('_active');
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.ProgramDateGroup(dateGroup.visibleItems));
            groupItemsContainer.append(content);
        }
    }, _TourProgramPageMobile_onCheckCancellationClick = function _TourProgramPageMobile_onCheckCancellationClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            e.preventDefault();
            e.stopPropagation();
            const targetElement = $(e.target);
            const policy = yield __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "a", _TourProgramPageMobile_cancellationRuleChecker_get).getCancellationPolicy(targetElement, __classPrivateFieldGet(this, _TourProgramPageMobile_messenger, "f"));
            if (!policy)
                return;
            const variantKey = (_b = targetElement.attr('data-variant-key')) !== null && _b !== void 0 ? _b : '';
            const variant = __classPrivateFieldGet(this, _TourProgramPageMobile_result, "f").findOfferByDynamicHotel(variantKey);
            if (variant)
                variant.cancellationPolicy = policy;
            const model = new App.VariantCancellationViewModel('', policy);
            App.CancellationRuleChecker.renderChangedCancellationPolicy(model, targetElement, false);
        });
    }, _TourProgramPageMobile_onActionInfoShow = function _TourProgramPageMobile_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourProgramPageMobile_instances, "m", _TourProgramPageMobile_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _TourProgramPageMobile_loadAnnouncement = function _TourProgramPageMobile_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _b;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(`${__classPrivateFieldGet(this, _TourProgramPageMobile_options, "f").urls.announcement}?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _TourProgramPageMobile_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_b = response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourProgramPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.TourProgramPageMobile = TourProgramPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TourProgramPage_instances, _a, _TourProgramPage_options, _TourProgramPage_header, _TourProgramPage_readMoreLink, _TourProgramPage_tourInfoTextBlock, _TourProgramPage_tourInfoGradient, _TourProgramPage_textBlockHeight, _TourProgramPage_placementOutputBlock, _TourProgramPage_placementHotel, _TourProgramPage_placementHotelTitle, _TourProgramPage_arrivalOption, _TourProgramPage_arrivalProgram, _TourProgramPage_scrollBookLink, _TourProgramPage_bookScrollToWrap, _TourProgramPage_filter, _TourProgramPage_hotFilter, _TourProgramPage_result, _TourProgramPage_form, _TourProgramPage_messenger, _TourProgramPage_popup, _TourProgramPage_responseValidator, _TourProgramPage_searchPopup, _TourProgramPage_tabs, _TourProgramPage_searchAbortController, _TourProgramPage_searchExpirationPopup, _TourProgramPage_cancellationRuleCheckerField, _TourProgramPage_cancellationRuleChecker_get, _TourProgramPage_setBookingPosition, _TourProgramPage_fixHotelTitles, _TourProgramPage_onScrollLinkClick, _TourProgramPage_toggleVariantVisibility, _TourProgramPage_isVisibleVariant, _TourProgramPage_switchProgram, _TourProgramPage_onFilterSearch, _TourProgramPage_searchStep, _TourProgramPage_cancelSearch, _TourProgramPage_successSearch, _TourProgramPage_transformSearchResponse, _TourProgramPage_onHotelGroupShowMore, _TourProgramPage_onDateGroupShowMore, _TourProgramPage_onCheckCancellationClick, _TourProgramPage_onActionInfoShow, _TourProgramPage_loadAnnouncement;
    class TourProgramPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _TourProgramPage_instances.add(this);
            _TourProgramPage_options.set(this, void 0);
            _TourProgramPage_header.set(this, void 0);
            _TourProgramPage_readMoreLink.set(this, void 0);
            _TourProgramPage_tourInfoTextBlock.set(this, void 0);
            _TourProgramPage_tourInfoGradient.set(this, void 0);
            _TourProgramPage_textBlockHeight.set(this, void 0);
            _TourProgramPage_placementOutputBlock.set(this, void 0);
            _TourProgramPage_placementHotel.set(this, void 0);
            _TourProgramPage_placementHotelTitle.set(this, void 0);
            _TourProgramPage_arrivalOption.set(this, void 0);
            _TourProgramPage_arrivalProgram.set(this, void 0);
            _TourProgramPage_scrollBookLink.set(this, void 0);
            _TourProgramPage_bookScrollToWrap.set(this, void 0);
            _TourProgramPage_filter.set(this, void 0);
            _TourProgramPage_hotFilter.set(this, void 0);
            _TourProgramPage_result.set(this, void 0);
            _TourProgramPage_form.set(this, void 0);
            _TourProgramPage_messenger.set(this, void 0);
            _TourProgramPage_popup.set(this, void 0);
            _TourProgramPage_responseValidator.set(this, void 0);
            _TourProgramPage_searchPopup.set(this, void 0);
            _TourProgramPage_tabs.set(this, void 0);
            _TourProgramPage_searchAbortController.set(this, void 0);
            _TourProgramPage_searchExpirationPopup.set(this, void 0);
            _TourProgramPage_cancellationRuleCheckerField.set(this, void 0);
            __classPrivateFieldSet(this, _TourProgramPage_options, options, "f");
        }
        mount() {
            var _b, _c;
            super.mount();
            __classPrivateFieldSet(this, _TourProgramPage_readMoreLink, $('.js-read-more', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_header, $('.js-header', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_tourInfoTextBlock, $('.js-tour-info-text-block', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_tourInfoGradient, $('.js-read-more-gradient', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_placementOutputBlock, $('.js-placement-output', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_placementHotel, $('.js-tour-page-hotel', __classPrivateFieldGet(this, _TourProgramPage_placementOutputBlock, "f")), "f");
            __classPrivateFieldSet(this, _TourProgramPage_placementHotelTitle, $('.js-placement-hotel-title', __classPrivateFieldGet(this, _TourProgramPage_placementHotel, "f")), "f");
            __classPrivateFieldSet(this, _TourProgramPage_arrivalOption, $('.js-arrival-option', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_arrivalProgram, $('.js-arrival-program', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_scrollBookLink, $('.js-scroll-book-link', this.root), "f");
            __classPrivateFieldSet(this, _TourProgramPage_bookScrollToWrap, $('.js-book-to-scroll', this.root), "f");
            $(window).on('scroll touchend touchstart touchmove', $.throttle(100, () => __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_setBookingPosition).call(this)));
            const scrollOffset = __classPrivateFieldGet(this, _TourProgramPage_header, "f").offset();
            if (scrollOffset) {
                window.scrollTo(0, scrollOffset.top);
            }
            __classPrivateFieldSet(this, _TourProgramPage_tabs, new App.Tabs({ root: this.root }), "f");
            __classPrivateFieldGet(this, _TourProgramPage_tabs, "f").showActive();
            // Проверяем высоту текстового блока с описанием и скрываем лишнее (если надо)
            __classPrivateFieldSet(this, _TourProgramPage_textBlockHeight, (_b = __classPrivateFieldGet(this, _TourProgramPage_tourInfoTextBlock, "f").height()) !== null && _b !== void 0 ? _b : 0, "f");
            if (__classPrivateFieldGet(this, _TourProgramPage_textBlockHeight, "f") > 60) {
                __classPrivateFieldGet(this, _TourProgramPage_tourInfoGradient, "f").removeClass('_hidden');
                __classPrivateFieldGet(this, _TourProgramPage_readMoreLink, "f").removeClass('_hidden');
            }
            __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_fixHotelTitles).call(this);
            this.root.on('click', '.js-read-more', App.readMoreClickHandler);
            this.root.on('click', '.js-scroll-to', e => __classPrivateFieldGet(_a, _a, "m", _TourProgramPage_onScrollLinkClick).call(_a, e));
            this.components.push(new App.Digest({ container: this.root }), new App.MediaGallery(), new App.TourInfoSlider(), new App.ActionInfoComponent());
            const checkinLimit = __classPrivateFieldGet(this, _TourProgramPage_options, "f").checkinLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _TourProgramPage_options, "f").checkinLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _TourProgramPage_options, "f").checkinLimit.max) };
            __classPrivateFieldSet(this, _TourProgramPage_filter, new App.TourProgramMainFilter({
                dateOptions: {
                    minDate: (_c = checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min) !== null && _c !== void 0 ? _c : App.addDays(new Date(), App.app.settings.tourOptions.minCheckinDateShift),
                    maxDate: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                },
                datesOptions: {
                    minDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    minDateFromShift: App.app.settings.tourOptions.minCheckinDateShift,
                    maxDateToOffset: App.app.settings.tourOptions.maxProgramCheckinDateOffset,
                },
                peopleOptions: {
                    maxChildAge: App.app.settings.tourOptions.minAdultAge - 1,
                },
                urls: __classPrivateFieldGet(this, _TourProgramPage_options, "f").urls,
                changes: __classPrivateFieldGet(this, _TourProgramPage_options, "f").changes,
                regularCheckin: __classPrivateFieldGet(this, _TourProgramPage_options, "f").regularCheckin,
                charterCheckin: __classPrivateFieldGet(this, _TourProgramPage_options, "f").charterCheckin,
                isDateRange: !__classPrivateFieldGet(this, _TourProgramPage_options, "f").hasDynamicHotel,
                hasMultipleHotels: __classPrivateFieldGet(this, _TourProgramPage_options, "f").isCombinedTour,
            }), "f");
            __classPrivateFieldGet(this, _TourProgramPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (e, data, manual) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_onFilterSearch).call(this, e, data, manual); }));
            this.root.on('click', '.js-button-expired-refresh-custom', () => __classPrivateFieldGet(this, _TourProgramPage_filter, "f").root.trigger('submit'));
            __classPrivateFieldGet(this, _TourProgramPage_filter, "f").root.on('change', '[data-select="city"] .js-jelect, [name="Checkin.From"], [name="Checkin.To"], [data-select="night"] .js-jelect', () => __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_toggleVariantVisibility).call(this));
            __classPrivateFieldSet(this, _TourProgramPage_hotFilter, new App.TourProgramHotFilter(), "f");
            __classPrivateFieldSet(this, _TourProgramPage_result, new App.TourProgramResult({
                hotFilter: __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f"),
                tableTemplate: App.templates.Tour.ProgramTableOutput,
                hasDynamicHotel: __classPrivateFieldGet(this, _TourProgramPage_options, "f").hasDynamicHotel,
                hotelBoards: __classPrivateFieldGet(this, _TourProgramPage_options, "f").hotelBoards,
                dynamicRoomTypes: __classPrivateFieldGet(this, _TourProgramPage_options, "f").dynamicRoomTypes,
                dynamicBoardTypes: __classPrivateFieldGet(this, _TourProgramPage_options, "f").dynamicBoardTypes,
                restTypeKey: __classPrivateFieldGet(this, _TourProgramPage_options, "f").restTypeKey,
                countryKey: __classPrivateFieldGet(this, _TourProgramPage_options, "f").countryKey,
            }), "f");
            __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_cancelSearch).call(this);
                __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").hideProgressDataLoader();
            });
            __classPrivateFieldSet(this, _TourProgramPage_form, new App.Form({
                root: __classPrivateFieldGet(this, _TourProgramPage_filter, "f").root,
                disableStepValidation: true,
            }), "f");
            __classPrivateFieldSet(this, _TourProgramPage_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _TourProgramPage_popup, new App.Popup({
                onShow: () => {
                    // Для popup выбора сортировки результатов поиска после его окончания.
                    const sortButtons = $('.js-continue-search-popup-sort', __classPrivateFieldGet(this, _TourProgramPage_popup, "f").root);
                    sortButtons.on('click', e => {
                        var _b;
                        const sort = (_b = $(e.target).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
                        __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").setFilterSortItems({ field: sort, reverse: false }, true);
                        __classPrivateFieldGet(this, _TourProgramPage_popup, "f").hide();
                    });
                    $('.js-popup-close', __classPrivateFieldGet(this, _TourProgramPage_popup, "f").root).on('click', () => __classPrivateFieldGet(this, _TourProgramPage_popup, "f").hide());
                },
            }), "f");
            __classPrivateFieldSet(this, _TourProgramPage_responseValidator, new App.ResponseValidator({
                messenger: __classPrivateFieldGet(this, _TourProgramPage_messenger, "f"),
                validator: __classPrivateFieldGet(this, _TourProgramPage_form, "f").validator,
            }), "f");
            __classPrivateFieldSet(this, _TourProgramPage_searchPopup, new App.Popup({ root: $('.js-popup-search', this.root) }), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_cancelSearch).call(this);
                    inst.hide();
                }
            });
            this.root.on('click', '.js-tour-group-show-more-link', e => __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_onHotelGroupShowMore).call(this, e));
            this.root.on('click', '.js-tour-date-group-link', e => __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_onDateGroupShowMore).call(this, e));
            __classPrivateFieldGet(this, _TourProgramPage_arrivalOption, "f").on('click', e => __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_switchProgram).call(this, e));
            __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_toggleVariantVisibility).call(this);
            this.components.push(new App.PrintComponent({
                modes: {
                    'text': 'Программа без картинок',
                    'image': 'Программа с картинками',
                    'default': 'Страница целиком',
                },
            }));
            __classPrivateFieldGet(this, _TourProgramPage_result, "f").root.on('click', '.js-cancellation-rules', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_onCheckCancellationClick).call(this, e); }));
            $(document).on("action-info:show" /* Events.ActionInfoShow */, (e, data) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_onActionInfoShow).call(this, e, data); }));
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                if (!__classPrivateFieldGet(this, _TourProgramPage_options, "f").manual)
                    __classPrivateFieldGet(this, _TourProgramPage_filter, "f").search(false);
            });
        }
    }
    _a = TourProgramPage, _TourProgramPage_options = new WeakMap(), _TourProgramPage_header = new WeakMap(), _TourProgramPage_readMoreLink = new WeakMap(), _TourProgramPage_tourInfoTextBlock = new WeakMap(), _TourProgramPage_tourInfoGradient = new WeakMap(), _TourProgramPage_textBlockHeight = new WeakMap(), _TourProgramPage_placementOutputBlock = new WeakMap(), _TourProgramPage_placementHotel = new WeakMap(), _TourProgramPage_placementHotelTitle = new WeakMap(), _TourProgramPage_arrivalOption = new WeakMap(), _TourProgramPage_arrivalProgram = new WeakMap(), _TourProgramPage_scrollBookLink = new WeakMap(), _TourProgramPage_bookScrollToWrap = new WeakMap(), _TourProgramPage_filter = new WeakMap(), _TourProgramPage_hotFilter = new WeakMap(), _TourProgramPage_result = new WeakMap(), _TourProgramPage_form = new WeakMap(), _TourProgramPage_messenger = new WeakMap(), _TourProgramPage_popup = new WeakMap(), _TourProgramPage_responseValidator = new WeakMap(), _TourProgramPage_searchPopup = new WeakMap(), _TourProgramPage_tabs = new WeakMap(), _TourProgramPage_searchAbortController = new WeakMap(), _TourProgramPage_searchExpirationPopup = new WeakMap(), _TourProgramPage_cancellationRuleCheckerField = new WeakMap(), _TourProgramPage_instances = new WeakSet(), _TourProgramPage_cancellationRuleChecker_get = function _TourProgramPage_cancellationRuleChecker_get() {
        if (!__classPrivateFieldGet(this, _TourProgramPage_cancellationRuleCheckerField, "f"))
            __classPrivateFieldSet(this, _TourProgramPage_cancellationRuleCheckerField, new App.CancellationRuleChecker({ url: __classPrivateFieldGet(this, _TourProgramPage_options, "f").urls.cancellationPolicy }), "f");
        return __classPrivateFieldGet(this, _TourProgramPage_cancellationRuleCheckerField, "f");
    }, _TourProgramPage_setBookingPosition = function _TourProgramPage_setBookingPosition() {
        var _b, _c, _d;
        // TODO: https://jquery.com/upgrade-guide/3.0/#breaking-change-outerwidth-or-outerheight-on-window-includes-scrollbar-width-height
        const scrolledPos = ((_b = $(window).scrollTop()) !== null && _b !== void 0 ? _b : 0) + ((_c = $(window).outerHeight()) !== null && _c !== void 0 ? _c : 0);
        const offset = __classPrivateFieldGet(this, _TourProgramPage_bookScrollToWrap, "f").offset();
        const offsetTop = (offset != null ? offset.top : 0);
        if (scrolledPos >= offsetTop && scrolledPos < offsetTop + ((_d = __classPrivateFieldGet(this, _TourProgramPage_bookScrollToWrap, "f").outerHeight()) !== null && _d !== void 0 ? _d : 0))
            __classPrivateFieldGet(this, _TourProgramPage_scrollBookLink, "f").addClass('_fixed_book');
        else
            __classPrivateFieldGet(this, _TourProgramPage_scrollBookLink, "f").removeClass('_fixed_book');
    }, _TourProgramPage_fixHotelTitles = function _TourProgramPage_fixHotelTitles() {
        __classPrivateFieldGet(this, _TourProgramPage_placementHotelTitle, "f").each((index, element) => {
            var _b;
            const jqElement = $(element);
            if (((_b = jqElement.height()) !== null && _b !== void 0 ? _b : 0) > 17)
                jqElement.addClass('mt-7');
        });
    }, _TourProgramPage_onScrollLinkClick = function _TourProgramPage_onScrollLinkClick(e) {
        var _b;
        const target = $(e.currentTarget);
        const destId = target.attr('data-scroll');
        if (!destId)
            return;
        const dest = $(`[data-dest="${destId}"]`);
        const destOffset = dest.offset();
        const destOffsetTop = (destOffset != null ? destOffset.top : 0);
        let top = destOffsetTop;
        if (App.isTouch)
            top += ((_b = App.app.container.scrollTop()) !== null && _b !== void 0 ? _b : 0);
        App.app.container.animate({ scrollTop: top - 20 }, 300);
        dest.trigger('click');
    }, _TourProgramPage_toggleVariantVisibility = function _TourProgramPage_toggleVariantVisibility() {
        const cityKey = parseInt(__classPrivateFieldGet(this, _TourProgramPage_filter, "f").findControl('city').getValue(), 10);
        let dateFrom;
        let dateTo;
        if (__classPrivateFieldGet(this, _TourProgramPage_options, "f").hasDynamicHotel)
            dateFrom = dateTo = __classPrivateFieldGet(this, _TourProgramPage_filter, "f").findControl('Checkin').getValue();
        else
            [dateFrom, dateTo] = __classPrivateFieldGet(this, _TourProgramPage_filter, "f").findControl('Checkin').getValues();
        const nights = __classPrivateFieldGet(this, _TourProgramPage_filter, "f").findControl('night').getValue().split(',').map(v => parseInt(v, 10));
        let showInfoTab = false;
        __classPrivateFieldGet(this, _TourProgramPage_arrivalOption, "f").each((i, v) => {
            const jqElement = $(v);
            const isVisible = __classPrivateFieldGet(_a, _a, "m", _TourProgramPage_isVisibleVariant).call(_a, jqElement, cityKey, dateFrom, dateTo, nights);
            if (isVisible)
                showInfoTab = true;
            jqElement.toggleByClass(isVisible);
        });
        this.root.find('.js-scroll-to[data-scroll="info"]').toggle(showInfoTab);
        this.root.find('.js-tab[data-tab="info"]').toggle(showInfoTab);
        this.root.find('.js-tab-wrap[data-tab="info"]').toggle(showInfoTab);
        if (showInfoTab)
            __classPrivateFieldGet(this, _TourProgramPage_arrivalOption, "f").find(':visible').first().trigger('click');
    }, _TourProgramPage_isVisibleVariant = function _TourProgramPage_isVisibleVariant(element, cityKey, dateFrom, dateTo, nights) {
        const validTransportStr = element.attr('data-program-transport');
        const validTransport = validTransportStr ? Number(validTransportStr) : null;
        if (validTransport === /* авиаперелет*/ 1) {
            const depCityKeysStr = element.attr('data-program-departure-city');
            const depCityKeys = depCityKeysStr
                ? depCityKeysStr.split(',').map(v => Number(v))
                : new Array();
            if (cityKey <= 0 || (depCityKeys.length > 0 && !depCityKeys.includes(cityKey)))
                return false;
        }
        else if (validTransport !== null) {
            if (cityKey > 0)
                return false;
        }
        const beginDateStr = element.attr('data-program-begin-date');
        const beginDate = beginDateStr ? App.parseIsoDate(beginDateStr) : null;
        if (beginDate && beginDate > dateTo)
            return false;
        const endDateStr = element.attr('data-program-end-date');
        const endDate = endDateStr ? App.parseIsoDate(endDateStr) : null;
        if (endDate && dateFrom > endDate)
            return false;
        const durationDaysStr = element.attr('data-program-duration');
        const durationNights = durationDaysStr ? Number(durationDaysStr) - 1 : null;
        if (durationNights && !nights.includes(durationNights))
            return false;
        const weekdayFlagsStr = element.attr('data-program-weekdays');
        const weekdayFlags = weekdayFlagsStr ? Number(weekdayFlagsStr) : null;
        if (weekdayFlags && weekdayFlags !== App.PacketWeekdays.All) {
            const effectiveBeginDate = beginDate ? App.maxDate(beginDate, dateFrom) : dateFrom;
            const effectiveEndDate = endDate ? App.minDate(endDate, dateTo) : dateTo;
            if (effectiveBeginDate > effectiveEndDate)
                return false;
            const totalDays = App.dateDiff(effectiveEndDate, effectiveBeginDate).getTotalDays() + 1;
            if (totalDays < 7) {
                let found = false;
                let isoWeekday = (effectiveBeginDate.getDay() + 6) % 7;
                for (let i = 0; i < totalDays; i++) {
                    const weekdayMask = 1 << (6 - isoWeekday);
                    if ((weekdayFlags & weekdayMask) === weekdayMask) {
                        found = true;
                        break;
                    }
                    isoWeekday = (isoWeekday + 1) % 7;
                }
                if (!found)
                    return false;
            }
        }
        return true;
    }, _TourProgramPage_switchProgram = function _TourProgramPage_switchProgram(e) {
        const target = $(e.currentTarget);
        const id = target.attr('data-program');
        if (!id)
            return;
        const isActive = target.hasClass('_active');
        // Показываем нужную программу
        if (!isActive) {
            __classPrivateFieldGet(this, _TourProgramPage_arrivalOption, "f").removeClass('_active');
            target.addClass('_active');
            __classPrivateFieldGet(this, _TourProgramPage_arrivalProgram, "f").removeClass('_active');
            __classPrivateFieldGet(this, _TourProgramPage_arrivalProgram, "f").hide();
            const tab = __classPrivateFieldGet(this, _TourProgramPage_arrivalProgram, "f").filter(`[data-program="${id}"]`);
            tab.fadeIn(300);
            // Получаем слайдеры в программе
            const sliders = $('.js-tour-info-slider', tab);
            // Обходим каждый слайдер и принудительно выставляем первый слайд, чтобы слайдер проинициализировался
            if (sliders.length) {
                sliders.each((index, element) => {
                    const jqElement = $(element);
                    jqElement.slick('refresh');
                });
            }
        }
    }, _TourProgramPage_onFilterSearch = function _TourProgramPage_onFilterSearch(event, data, manual) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_cancelSearch).call(this);
            (_b = __classPrivateFieldGet(this, _TourProgramPage_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
            __classPrivateFieldGet(this, _TourProgramPage_result, "f").resetDataSource();
            __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").reset();
            if (!__classPrivateFieldGet(this, _TourProgramPage_form, "f").validator.form())
                return;
            __classPrivateFieldSet(this, _TourProgramPage_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _TourProgramPage_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            const tasks = new Array();
            if (__classPrivateFieldGet(this, _TourProgramPage_options, "f").hasDynamicHotel) {
                tasks.push(__classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external' }), retryPolicy, signal));
                tasks.push(__classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'internal' }), retryPolicy, signal));
            }
            else {
                tasks.push(__classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_searchStep).call(this, data, retryPolicy, signal));
            }
            let firstStep = true;
            let successSteps = 0;
            let error;
            const popupGroup = __classPrivateFieldGet(this, _TourProgramPage_searchPopup, "f").show({
                group: 'main',
                content: App.templates.Tour.Messages.Searching({}),
                modal: true,
            });
            /* eslint-disable no-await-in-loop */
            while (tasks.length > 0) {
                try {
                    signal.throwIfAborted();
                    const [task] = yield Promise.race(tasks.map(v => v.then(() => [v], () => [v])));
                    App.removeElement(tasks, task);
                    const response = yield task;
                    if (response) {
                        signal.throwIfAborted();
                        if (yield __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_successSearch).call(this, response, firstStep, successSteps, tasks.length > 0, manual, data, signal))
                            successSteps++;
                        if (response.data.continuationState) {
                            yield App.delay(App.randomInt(500, 2000), App.noneSignal);
                            tasks.push(__classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_searchStep).call(this, Object.assign(Object.assign({}, data), { source: 'external', continuationState: response.data.continuationState }), retryPolicy, signal));
                        }
                    }
                    // Быстрый выход из цикла, чтобы переменная firstStep осталась равна true, если завершение происходит на первом же шаге.
                    if (tasks.length <= 0)
                        break;
                }
                catch (ex) {
                    if (signal.aborted)
                        break;
                    error = ex;
                }
                finally {
                    if (successSteps === 1 || tasks.length <= 0)
                        __classPrivateFieldGet(this, _TourProgramPage_searchPopup, "f").hide(popupGroup);
                }
                firstStep = false;
                __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").showProgressDataLoader();
            }
            /* eslint-enable no-await-in-loop */
            __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").hideProgressDataLoader();
            if (successSteps <= 0 && error != null && !__classPrivateFieldGet(this, _TourProgramPage_responseValidator, "f").processError(error)) {
                /* eslint-disable-next-line @typescript-eslint/no-throw-literal */
                throw error;
            }
            if (successSteps > 0 && tasks.length <= 0) {
                if (successSteps === 1) {
                    // Поиск полностью завершен за 1 шаг.
                    __classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").setFilterSortItems({ field: App.TourSortFields.Price, reverse: false }, true);
                }
                else if (__classPrivateFieldGet(this, _TourProgramPage_hotFilter, "f").activeSorting.field !== App.TourSortFields.Price) {
                    // Поиск полностью завершен за более чем 1 шаг.
                    __classPrivateFieldGet(this, _TourProgramPage_popup, "f").show({
                        content: App.templates.Tour.Messages.PartialSearchCompleted({}),
                        modal: true,
                    });
                }
            }
        });
    }, _TourProgramPage_searchStep = function _TourProgramPage_searchStep(data, retryPolicy, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                signal.throwIfAborted();
                const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourProgramPage_options, "f").urls.search, { body: App.createUrlSearchParams(data), signal });
                if (!__classPrivateFieldGet(this, _TourProgramPage_responseValidator, "f").process(result))
                    return;
                return result;
            }), signal);
        });
    }, _TourProgramPage_cancelSearch = function _TourProgramPage_cancelSearch() {
        var _b;
        (_b = __classPrivateFieldGet(this, _TourProgramPage_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
    }, _TourProgramPage_successSearch = function _TourProgramPage_successSearch(response, firstStep, successSteps, hasMoreSteps, manual, data, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            signal.throwIfAborted();
            if (firstStep && response.data.seo != null) {
                App.app.seo.update(response.data.seo);
                if (!manual)
                    window.history.replaceState(null, document.title, response.data.seo.url);
                else
                    window.history.pushState(null, document.title, response.data.seo.url);
            }
            signal.throwIfAborted();
            // Определение наличия результатов поиска
            if (response.data.offers && response.data.offers.length > 0) {
                if (successSteps <= 0) {
                    __classPrivateFieldSet(this, _TourProgramPage_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        customRefresh: true,
                        isContainerPopup: true,
                        root: this.root,
                    }), "f");
                }
                __classPrivateFieldGet(this, _TourProgramPage_result, "f").filters = data;
                __classPrivateFieldGet(this, _TourProgramPage_result, "f").filters["Country" /* TourFilterFields.Country */] = `${__classPrivateFieldGet(this, _TourProgramPage_options, "f").countryKey}`;
                const { offers } = response.data;
                const showVariants = (Array.isArray(data.Hotel) && data.Hotel.length === 1)
                    || (successSteps <= 0
                        && !hasMoreSteps
                        && !response.data.continuationState
                        && (offers.length <= 1 || offers.every(v => v.hotels[0].key === offers[0].hotels[0].key)));
                const responseData = __classPrivateFieldGet(_a, _a, "m", _TourProgramPage_transformSearchResponse).call(_a, offers, showVariants);
                yield __classPrivateFieldGet(this, _TourProgramPage_result, "f").changeDataSource(responseData, successSteps > 0);
                return true;
            }
            if (successSteps <= 0 && !hasMoreSteps) {
                __classPrivateFieldGet(this, _TourProgramPage_messenger, "f").show({ type: 0 /* MessageType.Information */, text: 'Вариантов, соответствующих заданным критериям, нет.' }, { group: 'ajax' });
            }
            return false;
        });
    }, _TourProgramPage_transformSearchResponse = function _TourProgramPage_transformSearchResponse(offers, showVariants) {
        return Enumerable.from(offers)
            .select(x => new App.TourProgramSearchViewModel(x))
            .where(v => v.hotels.length > 0)
            .groupBy(v => v.hotels[0].key, v => v, (k, v) => new App.TourProgramHotelGroupSearchViewModel(v.first().hotels[0], v
            .groupBy(x => x.beginDate, x => x, (k2, v2) => new App.TourProgramDateGroupSearchViewModel(k2, v2.toArray()))
            .toArray(), showVariants))
            .toArray();
    }, _TourProgramPage_onHotelGroupShowMore = function _TourProgramPage_onHotelGroupShowMore(e) {
        var _b, _c, _d, _e, _f, _g;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        const container = target.parents('.js-tour-table-block');
        const showLinks = container.find('.js-tour-group-show-more-link-show');
        const hideLinks = container.find('.js-tour-group-show-more-link-hide');
        const isHidden = (showLinks.length > 0 && !showLinks.hasClass('_hidden-2'))
            || (hideLinks.length > 0 && hideLinks.hasClass('_hidden-2'));
        const groupContainer = container.find('.js-tour-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-group-content-items');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = __classPrivateFieldGet(this, _TourProgramPage_result, "f").findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        hotelGroup.showVariants = isHidden;
        const currentOffset = ((_d = (_c = container.offset()) === null || _c === void 0 ? void 0 : _c.top) !== null && _d !== void 0 ? _d : 0) - ((_e = $(document).scrollTop()) !== null && _e !== void 0 ? _e : 0);
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.ProgramHotelGroup(hotelGroup.visibleItems));
            groupItemsContainer.append(content);
            container.addClass('_open');
        }
        else {
            container.removeClass('_open');
        }
        showLinks.toggleByClass(!hotelGroup.showVariants);
        hideLinks.toggleByClass(hotelGroup.showVariants);
        $(document).scrollTop(((_g = (_f = container.offset()) === null || _f === void 0 ? void 0 : _f.top) !== null && _g !== void 0 ? _g : 0) - currentOffset);
    }, _TourProgramPage_onDateGroupShowMore = function _TourProgramPage_onDateGroupShowMore(e) {
        var _b, _c;
        e.preventDefault();
        e.stopPropagation();
        const target = $(e.currentTarget);
        if (target.hasClass('_active'))
            return;
        const container = target.parents('.js-tour-table-block');
        const hotelGroupKey = parseInt((_b = container.attr('data-key')) !== null && _b !== void 0 ? _b : '0', 10);
        const hotelGroup = __classPrivateFieldGet(this, _TourProgramPage_result, "f").findHotelGroup(hotelGroupKey);
        if (!hotelGroup)
            return;
        const groupContainer = target.parents('.js-tour-date-group-content');
        const groupItemsContainer = groupContainer.find('.js-tour-date-group-content-items');
        const dateGroupKey = (_c = target.attr('data-key')) !== null && _c !== void 0 ? _c : '';
        const dateGroup = App.TourProgramResult.findDateGroup(hotelGroup, dateGroupKey);
        const showLinks = groupContainer.find('.js-tour-date-group-link');
        if (!dateGroup)
            return;
        hotelGroup.items.forEach(v => (v.active = false));
        showLinks.removeClass('_active');
        dateGroup.active = true;
        target.addClass('_active');
        groupItemsContainer.empty();
        if (hotelGroup.showVariants) {
            const content = $(App.templates.Tour.ProgramDateGroup(dateGroup.visibleItems));
            groupItemsContainer.append(content);
        }
    }, _TourProgramPage_onCheckCancellationClick = function _TourProgramPage_onCheckCancellationClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            e.preventDefault();
            e.stopPropagation();
            const targetElement = $(e.target);
            const policy = yield __classPrivateFieldGet(this, _TourProgramPage_instances, "a", _TourProgramPage_cancellationRuleChecker_get).getCancellationPolicy(targetElement, __classPrivateFieldGet(this, _TourProgramPage_messenger, "f"));
            if (!policy)
                return;
            const variantKey = (_b = targetElement.attr('data-variant-key')) !== null && _b !== void 0 ? _b : '';
            const variant = __classPrivateFieldGet(this, _TourProgramPage_result, "f").findOfferByDynamicHotel(variantKey);
            if (variant)
                variant.cancellationPolicy = policy;
            const model = new App.VariantCancellationViewModel('', policy);
            App.CancellationRuleChecker.renderChangedCancellationPolicy(model, targetElement, false);
        });
    }, _TourProgramPage_onActionInfoShow = function _TourProgramPage_onActionInfoShow(e, data) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            switch (data.type) {
                case 'fareAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_loadAnnouncement).call(this, $(e.target), 'fare', data.key);
                    break;
                case 'promotionAnnouncement':
                    if (typeof data.key !== 'undefined')
                        yield __classPrivateFieldGet(this, _TourProgramPage_instances, "m", _TourProgramPage_loadAnnouncement).call(this, $(e.target), 'promotion', data.key);
                    break;
                // no default
            }
        });
    }, _TourProgramPage_loadAnnouncement = function _TourProgramPage_loadAnnouncement(targetElement_1, type_1, key_1) {
        return __awaiter(this, arguments, void 0, function* (targetElement, type, key, signal = App.noneSignal) {
            var _b;
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const params = new URLSearchParams({ type, key });
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.getPwJson(
                    // TODO: убрать вызов toString после апгрейда "@typescript-eslint/eslint-plugin".
                    `${__classPrivateFieldGet(this, _TourProgramPage_options, "f").urls.announcement}?${params.toString()}`, { signal });
                    if (!__classPrivateFieldGet(this, _TourProgramPage_responseValidator, "f").process(result))
                        return undefined;
                    return result;
                }), signal);
                targetElement.find('.js-action-info-content').replaceWith((_b = response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : '');
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourProgramPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    };
    App.TourProgramPage = TourProgramPage;
})(App || (App = {}));
var App;
(function (App) {
    var _TourSearchPageMobile_instances, _TourSearchPageMobile_options, _TourSearchPageMobile_searchResult, _TourSearchPageMobile_toursOutputRest, _TourSearchPageMobile_filter, _TourSearchPageMobile_hotFilter, _TourSearchPageMobile_result, _TourSearchPageMobile_messenger, _TourSearchPageMobile_responseValidator, _TourSearchPageMobile_preloader, _TourSearchPageMobile_searchExecuting, _TourSearchPageMobile_searchAbortController, _TourSearchPageMobile_searchExpirationPopup, _TourSearchPageMobile_onFilterSearch;
    class TourSearchPageMobile extends App.PageMobileBase {
        constructor(options) {
            // NOTE: root задаем явно, т.к. в мобильном layout нет элемента .js-app-container
            // (app.appContainer пуст, а выдача/плашка Spread находятся в js-app-container-content)
            super(Object.assign({ root: '.js-tour-search-page .js-app-container-content' }, options));
            _TourSearchPageMobile_instances.add(this);
            _TourSearchPageMobile_options.set(this, void 0);
            _TourSearchPageMobile_searchResult.set(this, void 0);
            _TourSearchPageMobile_toursOutputRest.set(this, void 0);
            _TourSearchPageMobile_filter.set(this, void 0);
            _TourSearchPageMobile_hotFilter.set(this, void 0);
            _TourSearchPageMobile_result.set(this, void 0);
            _TourSearchPageMobile_messenger.set(this, void 0);
            _TourSearchPageMobile_responseValidator.set(this, void 0);
            _TourSearchPageMobile_preloader.set(this, void 0);
            _TourSearchPageMobile_searchExecuting.set(this, false);
            _TourSearchPageMobile_searchAbortController.set(this, void 0);
            _TourSearchPageMobile_searchExpirationPopup.set(this, void 0);
            __classPrivateFieldSet(this, _TourSearchPageMobile_options, options, "f");
        }
        mount() {
            super.mount();
            __classPrivateFieldSet(this, _TourSearchPageMobile_searchResult, $('.js-search-result', this.root), "f");
            __classPrivateFieldSet(this, _TourSearchPageMobile_toursOutputRest, $('.js-tours-output-rest', this.root), "f");
            // Основной фильтр (js-main-filter) на мобильных контролах.
            __classPrivateFieldSet(this, _TourSearchPageMobile_filter, new App.TourSearchMainFilterMobile({
                urls: __classPrivateFieldGet(this, _TourSearchPageMobile_options, "f").urls,
                changes: __classPrivateFieldGet(this, _TourSearchPageMobile_options, "f").changes,
                defaults: __classPrivateFieldGet(this, _TourSearchPageMobile_options, "f").defaults,
            }), "f");
            // Поиск: событие срабатывает от сабмита формы (без данных - строим сами)
            // и от автопоиска при загрузке страницы (с данными и manual=false).
            __classPrivateFieldGet(this, _TourSearchPageMobile_filter, "f").filters.searchFilter.on("filter:search" /* Events.FilterSearch */, (_, data, manual) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourSearchPageMobile_instances, "m", _TourSearchPageMobile_onFilterSearch).call(this, data !== null && data !== void 0 ? data : __classPrivateFieldGet(this, _TourSearchPageMobile_filter, "f").buildSearchData(), manual !== false); }));
            // Хот-фильтр (сортировка + фильтры по результатам).
            __classPrivateFieldSet(this, _TourSearchPageMobile_hotFilter, new App.TourHotFilterMobile({ featureSortOrder: __classPrivateFieldGet(this, _TourSearchPageMobile_options, "f").featureSortOrder }), "f");
            // Выдача результатов.
            __classPrivateFieldSet(this, _TourSearchPageMobile_result, new App.TourSearchResultMobile({ root: this.root, hotFilter: __classPrivateFieldGet(this, _TourSearchPageMobile_hotFilter, "f") }), "f");
            // Сортировка по умолчанию - по цене (как на десктопе).
            __classPrivateFieldGet(this, _TourSearchPageMobile_hotFilter, "f").setFilterSortItems({ field: App.TourSortFields.Price, reverse: false }, true);
            __classPrivateFieldSet(this, _TourSearchPageMobile_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _TourSearchPageMobile_responseValidator, new App.ResponseValidator({
                messenger: __classPrivateFieldGet(this, _TourSearchPageMobile_messenger, "f"),
                validator: __classPrivateFieldGet(this, _TourSearchPageMobile_filter, "f").filters.validator,
            }), "f");
            __classPrivateFieldSet(this, _TourSearchPageMobile_preloader, new App.Preloader(), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                var _a;
                if (action === 'interrupt') {
                    (_a = __classPrivateFieldGet(this, _TourSearchPageMobile_searchAbortController, "f")) === null || _a === void 0 ? void 0 : _a.abort();
                    inst.hide();
                }
            });
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                if (!__classPrivateFieldGet(this, _TourSearchPageMobile_options, "f").manual)
                    __classPrivateFieldGet(this, _TourSearchPageMobile_filter, "f").search(false);
            });
        }
    }
    _TourSearchPageMobile_options = new WeakMap(), _TourSearchPageMobile_searchResult = new WeakMap(), _TourSearchPageMobile_toursOutputRest = new WeakMap(), _TourSearchPageMobile_filter = new WeakMap(), _TourSearchPageMobile_hotFilter = new WeakMap(), _TourSearchPageMobile_result = new WeakMap(), _TourSearchPageMobile_messenger = new WeakMap(), _TourSearchPageMobile_responseValidator = new WeakMap(), _TourSearchPageMobile_preloader = new WeakMap(), _TourSearchPageMobile_searchExecuting = new WeakMap(), _TourSearchPageMobile_searchAbortController = new WeakMap(), _TourSearchPageMobile_searchExpirationPopup = new WeakMap(), _TourSearchPageMobile_instances = new WeakSet(), _TourSearchPageMobile_onFilterSearch = function _TourSearchPageMobile_onFilterSearch(data_1, manual_1) {
        return __awaiter(this, arguments, void 0, function* (data, manual, signal = App.noneSignal) {
            var _a, _b, _c;
            if (!__classPrivateFieldGet(this, _TourSearchPageMobile_filter, "f").filters.validator.form())
                return;
            if (__classPrivateFieldGet(this, _TourSearchPageMobile_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _TourSearchPageMobile_searchExecuting, true, "f");
            (_a = __classPrivateFieldGet(this, _TourSearchPageMobile_searchExpirationPopup, "f")) === null || _a === void 0 ? void 0 : _a.cancel();
            __classPrivateFieldGet(this, _TourSearchPageMobile_result, "f").resetDataSource();
            __classPrivateFieldGet(this, _TourSearchPageMobile_hotFilter, "f").reset();
            __classPrivateFieldGet(this, _TourSearchPageMobile_toursOutputRest, "f").empty().hideByClass();
            (_b = __classPrivateFieldGet(this, _TourSearchPageMobile_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            __classPrivateFieldSet(this, _TourSearchPageMobile_searchAbortController, new AbortController(), "f");
            __classPrivateFieldGet(this, _TourSearchPageMobile_preloader, "f").show({ delay: (!manual ? 3000 : 0) });
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const localSignal = App.createLinkedSignal(signal, __classPrivateFieldGet(this, _TourSearchPageMobile_searchAbortController, "f").signal);
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourSearchPageMobile_options, "f").urls.search, { body: App.createUrlSearchParams(data), signal: localSignal });
                    if (!__classPrivateFieldGet(this, _TourSearchPageMobile_responseValidator, "f").process(result))
                        return;
                    return result;
                }), localSignal);
                if (!response)
                    return;
                signal.throwIfAborted();
                if (response.data.seo != null) {
                    App.app.seo.update(response.data.seo);
                    if (!manual)
                        window.history.replaceState(null, document.title, response.data.seo.url);
                    else
                        window.history.pushState(null, document.title, response.data.seo.url);
                }
                signal.throwIfAborted();
                if (response.data.itemType === 'Spread') {
                    const content = App.templates.Tour.RestOutput_Mobile(response.data.offers);
                    __classPrivateFieldGet(this, _TourSearchPageMobile_toursOutputRest, "f").append(content);
                    __classPrivateFieldGet(this, _TourSearchPageMobile_toursOutputRest, "f").showByClass();
                }
                else if (response.data.offers && response.data.offers.length > 0) { // Определение наличия результатов поиска
                    __classPrivateFieldGet(this, _TourSearchPageMobile_result, "f").filters = data;
                    __classPrivateFieldSet(this, _TourSearchPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: __classPrivateFieldGet(this, _TourSearchPageMobile_options, "f").urls.base,
                    }), "f");
                    yield __classPrivateFieldGet(this, _TourSearchPageMobile_result, "f").changeDataSource(response.data.offers);
                    __classPrivateFieldGet(this, _TourSearchPageMobile_hotFilter, "f").refreshHotFilters(response.data.offers);
                    // Скролл к результатам поиска
                    setTimeout(() => {
                        const scrollOffset = __classPrivateFieldGet(this, _TourSearchPageMobile_searchResult, "f").offset();
                        if (scrollOffset) {
                            $('html, body').stop(true, true);
                            window.scrollTo(0, scrollOffset.top);
                        }
                    }, 700);
                    if (manual && response.data.offers.length === 1)
                        (_c = window.open(response.data.offers[0].url, '_blank')) === null || _c === void 0 ? void 0 : _c.focus();
                    __classPrivateFieldGet(this, _TourSearchPageMobile_searchResult, "f").showByClass();
                }
                else {
                    __classPrivateFieldGet(this, _TourSearchPageMobile_searchResult, "f").hideByClass();
                    __classPrivateFieldGet(this, _TourSearchPageMobile_messenger, "f").show({ type: 0 /* MessageType.Information */, text: 'Вариантов, соответствующих заданным критериям, нет.' }, { group: 'ajax' });
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourSearchPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _TourSearchPageMobile_preloader, "f").hide();
                __classPrivateFieldSet(this, _TourSearchPageMobile_searchExecuting, false, "f");
            }
        });
    };
    App.TourSearchPageMobile = TourSearchPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TourSearchPage_instances, _a, _TourSearchPage_options, _TourSearchPage_searchResult, _TourSearchPage_toursOutputTable, _TourSearchPage_toursOutputRest, _TourSearchPage_filter, _TourSearchPage_data, _TourSearchPage_hotFilter, _TourSearchPage_result, _TourSearchPage_form, _TourSearchPage_messenger, _TourSearchPage_responseValidator, _TourSearchPage_preloader, _TourSearchPage_popup, _TourSearchPage_searchExecuting, _TourSearchPage_searchAbortController, _TourSearchPage_lastFilter, _TourSearchPage_searchExpirationPopup, _TourSearchPage_datesPopupShowing, _TourSearchPage_onLinkClick, _TourSearchPage_onTableView, _TourSearchPage_onFilterSearch, _TourSearchPage_datesPopupOpen, _TourSearchPage_getCalendarCustomClasses, _TourSearchPage_joinFilterParameter;
    class TourSearchPage extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            _TourSearchPage_instances.add(this);
            _TourSearchPage_options.set(this, void 0);
            _TourSearchPage_searchResult.set(this, void 0);
            _TourSearchPage_toursOutputTable.set(this, void 0);
            _TourSearchPage_toursOutputRest.set(this, void 0);
            _TourSearchPage_filter.set(this, void 0);
            _TourSearchPage_data.set(this, void 0);
            _TourSearchPage_hotFilter.set(this, void 0);
            _TourSearchPage_result.set(this, void 0);
            _TourSearchPage_form.set(this, void 0);
            _TourSearchPage_messenger.set(this, void 0);
            _TourSearchPage_responseValidator.set(this, void 0);
            _TourSearchPage_preloader.set(this, void 0);
            _TourSearchPage_popup.set(this, void 0);
            _TourSearchPage_searchExecuting.set(this, false);
            _TourSearchPage_searchAbortController.set(this, void 0);
            _TourSearchPage_lastFilter.set(this, void 0);
            _TourSearchPage_searchExpirationPopup.set(this, void 0);
            _TourSearchPage_datesPopupShowing.set(this, false);
            __classPrivateFieldSet(this, _TourSearchPage_options, options, "f");
        }
        mount() {
            super.mount();
            __classPrivateFieldSet(this, _TourSearchPage_searchResult, $('.js-search-result', this.root), "f");
            const flagsScrollerWrap = $('.js-flags-scroller-wrapper', this.root);
            const flagsScroller = $('.js-flags-scroller', flagsScrollerWrap);
            const monthsBlock = $('.js-months-block', this.root);
            const holidaysBlock = $('.js-holidays-block', this.root);
            const eventsBlock = $('.js-events-block', this.root);
            __classPrivateFieldSet(this, _TourSearchPage_toursOutputTable, $('.js-tours-output-table', this.root), "f");
            __classPrivateFieldSet(this, _TourSearchPage_toursOutputRest, $('.js-tours-output-rest', this.root), "f");
            this.components.push(new App.Digest({ container: this.root }), new App.BannerSlider({ root: this.root }), new App.SectionsSlider({ root: this.root }));
            this.components.push(new App.BestPriceComponent({ getData: () => [] }));
            // Стилизуем скролл
            if (flagsScrollerWrap.length) {
                flagsScrollerWrap.baron({
                    scroller: flagsScroller.get(0),
                    bar: '.js-flags-scroller-bar',
                    track: '.js-flags-scroller-bar-wrap',
                    barOnCls: 'baron',
                });
            }
            // Инициализируем карусель 'Туры по месяцам'
            if (monthsBlock.length)
                this.components.push(new App.CarouselSlider({ root: monthsBlock, slidesNum: 4, speed: 450 }));
            // Инициализируем карусель 'Интересные предложения'
            holidaysBlock.get()
                .map(v => new App.CarouselSlider({ root: $(v), slidesNum: 4, speed: 450 }))
                .forEach(v => this.components.push(v));
            // Инициализируем карусель 'Туры на события в Европе'
            if (eventsBlock.length)
                this.components.push(new App.VariableWidthSlider({ root: eventsBlock }));
            $('body').on("tours-page:table-view" /* Events.ToursPageTableView */, () => __classPrivateFieldGet(this, _TourSearchPage_instances, "m", _TourSearchPage_onTableView).call(this));
            const checkinLimit = __classPrivateFieldGet(this, _TourSearchPage_options, "f").checkinLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _TourSearchPage_options, "f").checkinLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _TourSearchPage_options, "f").checkinLimit.max) };
            __classPrivateFieldSet(this, _TourSearchPage_filter, new App.TourGroupMainFilter({
                dateOptions: {
                    minDate: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDate: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    defaultDateShift: App.app.settings.tourOptions.defaultCheckinDateShift,
                },
                datesOptions: {
                    minDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.min,
                    maxDateFrom: checkinLimit === null || checkinLimit === void 0 ? void 0 : checkinLimit.max,
                    minDateFromShift: App.app.settings.tourOptions.minCheckinDateShift,
                    maxDateToOffset: App.app.settings.tourOptions.maxCheckinDateOffset,
                    defaultDateFromShift: App.app.settings.tourOptions.defaultCheckinDateShift,
                    defaultDateToOffset: App.app.settings.tourOptions.defaultCheckinDateInterval,
                },
                peopleOptions: {
                    defaultAdultCountValue: App.app.settings.tourOptions.defaultAdultCount,
                    maxChildAge: App.app.settings.tourOptions.minAdultAge - 1,
                },
                urls: __classPrivateFieldGet(this, _TourSearchPage_options, "f").urls,
                changes: __classPrivateFieldGet(this, _TourSearchPage_options, "f").changes,
                defaults: __classPrivateFieldGet(this, _TourSearchPage_options, "f").defaults,
                regularCheckin: __classPrivateFieldGet(this, _TourSearchPage_options, "f").regularCheckin,
                charterCheckin: __classPrivateFieldGet(this, _TourSearchPage_options, "f").charterCheckin,
                isDateRange: true,
                hasMultipleHotels: false,
            }), "f");
            __classPrivateFieldGet(this, _TourSearchPage_filter, "f").root.on("filter:search" /* Events.FilterSearch */, (_, data, manual) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourSearchPage_instances, "m", _TourSearchPage_onFilterSearch).call(this, data, manual); }));
            __classPrivateFieldSet(this, _TourSearchPage_data, new Array(), "f");
            __classPrivateFieldSet(this, _TourSearchPage_hotFilter, new App.TourHotFilter(), "f");
            __classPrivateFieldSet(this, _TourSearchPage_result, new App.TourGroupResult({
                hotFilter: __classPrivateFieldGet(this, _TourSearchPage_hotFilter, "f"),
                blockTemplate: App.templates.Tour.BlockOutput,
                tableTemplate: App.templates.Tour.TableOutput,
                featureSortOrder: __classPrivateFieldGet(this, _TourSearchPage_options, "f").featureSortOrder,
            }), "f");
            __classPrivateFieldSet(this, _TourSearchPage_form, new App.Form({
                root: __classPrivateFieldGet(this, _TourSearchPage_filter, "f").root,
                disableStepValidation: true,
                disableInstantValidation: true,
                validationOptions: {
                    rules: {
                        ["Checkin.From" /* TourFilterFields.CheckinFrom */]: {
                            activedate: true,
                        },
                        ["Checkin.To" /* TourFilterFields.CheckinTo */]: {
                            activedate: true,
                        },
                    },
                },
            }), "f");
            __classPrivateFieldSet(this, _TourSearchPage_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _TourSearchPage_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _TourSearchPage_responseValidator, new App.ResponseValidator({ messenger: __classPrivateFieldGet(this, _TourSearchPage_messenger, "f"), validator: __classPrivateFieldGet(this, _TourSearchPage_form, "f").validator }), "f");
            __classPrivateFieldSet(this, _TourSearchPage_preloader, new App.Preloader(), "f");
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                var _b;
                if (action === 'interrupt') {
                    (_b = __classPrivateFieldGet(this, _TourSearchPage_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
                    inst.hide();
                }
            });
            $('body').on('click', '.js-nearest-date', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourSearchPage_instances, "m", _TourSearchPage_datesPopupOpen).call(this, e); }));
            $('body').on('click', '[data-href]', e => __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_onLinkClick).call(_a, e));
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                if (!__classPrivateFieldGet(this, _TourSearchPage_options, "f").manual)
                    __classPrivateFieldGet(this, _TourSearchPage_filter, "f").search(false);
            });
        }
    }
    _a = TourSearchPage, _TourSearchPage_options = new WeakMap(), _TourSearchPage_searchResult = new WeakMap(), _TourSearchPage_toursOutputTable = new WeakMap(), _TourSearchPage_toursOutputRest = new WeakMap(), _TourSearchPage_filter = new WeakMap(), _TourSearchPage_data = new WeakMap(), _TourSearchPage_hotFilter = new WeakMap(), _TourSearchPage_result = new WeakMap(), _TourSearchPage_form = new WeakMap(), _TourSearchPage_messenger = new WeakMap(), _TourSearchPage_responseValidator = new WeakMap(), _TourSearchPage_preloader = new WeakMap(), _TourSearchPage_popup = new WeakMap(), _TourSearchPage_searchExecuting = new WeakMap(), _TourSearchPage_searchAbortController = new WeakMap(), _TourSearchPage_lastFilter = new WeakMap(), _TourSearchPage_searchExpirationPopup = new WeakMap(), _TourSearchPage_datesPopupShowing = new WeakMap(), _TourSearchPage_instances = new WeakSet(), _TourSearchPage_onLinkClick = function _TourSearchPage_onLinkClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const link = $(event.currentTarget).attr('data-href');
        if (link)
            window.open(link);
        return false;
    }, _TourSearchPage_onTableView = function _TourSearchPage_onTableView() {
        // Обновляем слайдер, чтобы он прогрузился
        __classPrivateFieldGet(this, _TourSearchPage_toursOutputTable, "f").find('.js-carousel-slider').slick('refresh');
    }, _TourSearchPage_onFilterSearch = function _TourSearchPage_onFilterSearch(data_1, manual_1) {
        return __awaiter(this, arguments, void 0, function* (data, manual, signal = App.noneSignal) {
            var _b, _c, _d;
            if (!__classPrivateFieldGet(this, _TourSearchPage_form, "f").validator.form())
                return;
            if (__classPrivateFieldGet(this, _TourSearchPage_searchExecuting, "f"))
                return;
            __classPrivateFieldSet(this, _TourSearchPage_searchExecuting, true, "f");
            (_b = __classPrivateFieldGet(this, _TourSearchPage_searchExpirationPopup, "f")) === null || _b === void 0 ? void 0 : _b.cancel();
            __classPrivateFieldGet(this, _TourSearchPage_result, "f").resetDataSource();
            __classPrivateFieldGet(this, _TourSearchPage_hotFilter, "f").reset();
            __classPrivateFieldGet(this, _TourSearchPage_toursOutputRest, "f").empty().hideByClass();
            __classPrivateFieldSet(this, _TourSearchPage_data, new Array(), "f");
            (_c = __classPrivateFieldGet(this, _TourSearchPage_searchAbortController, "f")) === null || _c === void 0 ? void 0 : _c.abort();
            __classPrivateFieldSet(this, _TourSearchPage_searchAbortController, new AbortController(), "f");
            __classPrivateFieldGet(this, _TourSearchPage_preloader, "f").show({ delay: (!manual ? 3000 : 0) });
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            try {
                const localSignal = App.createLinkedSignal(signal, __classPrivateFieldGet(this, _TourSearchPage_searchAbortController, "f").signal);
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    signal.throwIfAborted();
                    const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourSearchPage_options, "f").urls.search, { body: App.createUrlSearchParams(data), signal: localSignal });
                    if (!__classPrivateFieldGet(this, _TourSearchPage_responseValidator, "f").process(result))
                        return;
                    __classPrivateFieldSet(this, _TourSearchPage_lastFilter, data, "f");
                    return result;
                }), localSignal);
                if (!response)
                    return;
                signal.throwIfAborted();
                if (response.data.seo != null) {
                    App.app.seo.update(response.data.seo);
                    if (!manual)
                        window.history.replaceState(null, document.title, response.data.seo.url);
                    else
                        window.history.pushState(null, document.title, response.data.seo.url);
                }
                signal.throwIfAborted();
                if (response.data.itemType === 'Spread') {
                    const content = App.templates.Tour.RestOutput(response.data.offers);
                    __classPrivateFieldGet(this, _TourSearchPage_toursOutputRest, "f").append(content);
                    __classPrivateFieldGet(this, _TourSearchPage_toursOutputRest, "f").showByClass();
                }
                else if (response.data.offers && response.data.offers.length > 0) { // Определение наличия результатов поиска
                    __classPrivateFieldGet(this, _TourSearchPage_result, "f").filters = data;
                    __classPrivateFieldSet(this, _TourSearchPage_searchExpirationPopup, App.scheduleExpirationPopup({
                        interval: response.data.dataExpiration,
                        url: __classPrivateFieldGet(this, _TourSearchPage_options, "f").urls.base,
                    }), "f");
                    yield __classPrivateFieldGet(this, _TourSearchPage_result, "f").changeDataSource(response.data.offers);
                    __classPrivateFieldSet(this, _TourSearchPage_data, response.data.offers, "f");
                    // Скролл к результатам поиска
                    setTimeout(() => {
                        const scrollOffset = __classPrivateFieldGet(this, _TourSearchPage_searchResult, "f").offset();
                        if (scrollOffset) {
                            $('html, body').stop(true, true);
                            window.scrollTo(0, scrollOffset.top);
                        }
                    }, 700);
                    if (manual && response.data.offers.length === 1)
                        (_d = window.open(response.data.offers[0].url, '_blank')) === null || _d === void 0 ? void 0 : _d.focus();
                    __classPrivateFieldGet(this, _TourSearchPage_searchResult, "f").showByClass();
                }
                else {
                    __classPrivateFieldGet(this, _TourSearchPage_searchResult, "f").hideByClass();
                    __classPrivateFieldGet(this, _TourSearchPage_messenger, "f").show({ type: 0 /* MessageType.Information */, text: 'Вариантов, соответствующих заданным критериям, нет.' }, { group: 'ajax' });
                }
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourSearchPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _TourSearchPage_preloader, "f").hide();
                __classPrivateFieldSet(this, _TourSearchPage_searchExecuting, false, "f");
            }
        });
    }, _TourSearchPage_datesPopupOpen = function _TourSearchPage_datesPopupOpen(e_1) {
        return __awaiter(this, arguments, void 0, function* (e, signal = App.noneSignal) {
            var _b, _c, _d, _e;
            e.preventDefault();
            e.stopPropagation();
            const $element = $(e.currentTarget);
            if (__classPrivateFieldGet(this, _TourSearchPage_datesPopupShowing, "f") || !__classPrivateFieldGet(this, _TourSearchPage_lastFilter, "f"))
                return;
            __classPrivateFieldSet(this, _TourSearchPage_datesPopupShowing, true, "f");
            (_b = __classPrivateFieldGet(this, _TourSearchPage_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            __classPrivateFieldSet(this, _TourSearchPage_searchAbortController, new AbortController(), "f");
            const popupGroup = __classPrivateFieldGet(this, _TourSearchPage_popup, "f").show({
                group: 'dates',
                content: App.templates.Tour.Messages.Executing({}),
                delay: 1500,
                modal: true,
            });
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            const offerKey = parseInt((_c = $(e.currentTarget).parents('.js-tour-item').attr('data-key')) !== null && _c !== void 0 ? _c : '0', 10);
            const offer = __classPrivateFieldGet(this, _TourSearchPage_data, "f").find(v => v.key === offerKey);
            const paramCity = __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_joinFilterParameter).call(_a, __classPrivateFieldGet(this, _TourSearchPage_lastFilter, "f")["City" /* TourFilterFields.City */]);
            const paramDirect = __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_joinFilterParameter).call(_a, __classPrivateFieldGet(this, _TourSearchPage_lastFilter, "f")["Direct" /* TourFilterFields.Direct */]);
            const paramHotel = __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_joinFilterParameter).call(_a, (_d = __classPrivateFieldGet(this, _TourSearchPage_lastFilter, "f")["Hotel" /* TourFilterFields.Hotel */]) !== null && _d !== void 0 ? _d : '');
            const paramBoard = __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_joinFilterParameter).call(_a, (_e = __classPrivateFieldGet(this, _TourSearchPage_lastFilter, "f")["Board" /* TourFilterFields.Board */]) !== null && _e !== void 0 ? _e : '');
            const paramTouristChild = Object.entries(__classPrivateFieldGet(this, _TourSearchPage_lastFilter, "f"))
                .filter(v => v[0].startsWith("Tourist.ChildAges" /* TourFilterFields.TouristChildAges */))
                .map(v => __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_joinFilterParameter).call(_a, v[1]))
                .join(',');
            const paramTourist = __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_joinFilterParameter).call(_a, __classPrivateFieldGet(this, _TourSearchPage_lastFilter, "f")["Tourist.AdultCount" /* TourFilterFields.TouristAdultCount */]) + (paramTouristChild ? `,${paramTouristChild}` : '');
            try {
                const body = new URLSearchParams({
                    program: offerKey.toString(),
                    city: paramCity,
                    direct: paramDirect,
                });
                const localSignal = App.createLinkedSignal(signal, __classPrivateFieldGet(this, _TourSearchPage_searchAbortController, "f").signal);
                const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                    const result = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourSearchPage_options, "f").urls.arrivalCalendar, { body, signal: localSignal });
                    if (!__classPrivateFieldGet(this, _TourSearchPage_responseValidator, "f").process(result))
                        return;
                    return result;
                }), localSignal);
                if (!response)
                    return;
                signal.throwIfAborted();
                if (Object.keys(response.data).length <= 0) {
                    __classPrivateFieldGet(this, _TourSearchPage_popup, "f").show({ content: App.templates.Tour.Messages.EmptyArrivalCalendar({}) });
                    return;
                }
                signal.throwIfAborted();
                const selectedDate = offer ? App.parseIsoDate(offer.beginDate) : new Date();
                const datesPopup = new App.DatesPopup({
                    data: {
                        groups: Enumerable.from(Object.keys(response.data))
                            .select(v => parseInt(v, 10))
                            .orderBy(v => v)
                            .select(v => ({
                            key: `${v}`,
                            name: `${v} ${App.pluralRu(v, 'ночь', 'ночи', 'ночей')}`,
                        }))
                            .toArray(),
                        dates: Enumerable.from(response.data)
                            .toObject(v => v.key, v => v.value.map(x => App.parseIsoDate(x.date))),
                        beforeShowDayFactory: group => {
                            const dateConfigs = Enumerable.from(response.data[parseInt(group, 10)])
                                .groupBy(v => App.parseIsoDate(v.date).getTime(), v => v.isBlock)
                                .toObject(v => v.key(), v => [v.contains(false), v.contains(true)]);
                            return date => {
                                const compareDate = date.getTime();
                                const dateConfig = dateConfigs[compareDate];
                                return [
                                    dateConfig != null,
                                    __classPrivateFieldGet(_a, _a, "m", _TourSearchPage_getCalendarCustomClasses).call(_a, compareDate, selectedDate, dateConfig),
                                ];
                            };
                        },
                        onSelect: (group, date) => {
                            const directPathPart = paramDirect === 'true' ? '/direct-1' : '';
                            const hotelPathPart = paramHotel.length > 0 ? `/hotel-${paramHotel}` : '';
                            const boardPathPart = paramBoard.length > 0 ? `/board-${paramBoard}` : '';
                            const dateString = App.formatDate(date, 'shortIsoDate');
                            const url = `/tour/program/${offerKey}/city-${paramCity}${directPathPart}/checkin-${dateString},${dateString}/night-${group},${group}/tourist-${paramTourist}${hotelPathPart}${boardPathPart}/`;
                            Object.assign(document.createElement('a'), { target: '_blank', href: url }).click();
                        },
                    },
                    selectedGroup: offer ? `${offer.nights}` : undefined,
                    selectedDate,
                    link: $element,
                });
                datesPopup.show($(e.currentTarget));
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourSearchPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _TourSearchPage_popup, "f").hide(popupGroup);
                __classPrivateFieldSet(this, _TourSearchPage_datesPopupShowing, false, "f");
            }
        });
    }, _TourSearchPage_getCalendarCustomClasses = function _TourSearchPage_getCalendarCustomClasses(value, selectedValue, dateConfig) {
        const result = new Array();
        if (selectedValue.getTime() === value)
            result.push('_selected-date');
        if (dateConfig) {
            if (dateConfig[0])
                result.push('_avia-dynamic');
            if (dateConfig[1])
                result.push('_avia-block');
            result.push('_arrival-date');
        }
        return result.join(' ');
    }, _TourSearchPage_joinFilterParameter = function _TourSearchPage_joinFilterParameter(value) {
        if (value instanceof Array)
            return value.join(',');
        return value;
    };
    App.TourSearchPage = TourSearchPage;
})(App || (App = {}));
var App;
(function (App) {
    let Tour;
    (function (Tour) {
        Tour.farePromo = 20;
        Tour.restChildrenCamps = 4559;
    })(Tour = App.Tour || (App.Tour = {}));
})(App || (App = {}));
var App;
(function (App) {
    let PacketWeekdays;
    (function (PacketWeekdays) {
        PacketWeekdays[PacketWeekdays["None"] = 0] = "None";
        PacketWeekdays[PacketWeekdays["Sunday"] = 1] = "Sunday";
        PacketWeekdays[PacketWeekdays["Saturday"] = 2] = "Saturday";
        PacketWeekdays[PacketWeekdays["Friday"] = 4] = "Friday";
        PacketWeekdays[PacketWeekdays["Thursday"] = 8] = "Thursday";
        PacketWeekdays[PacketWeekdays["Wednesday"] = 16] = "Wednesday";
        PacketWeekdays[PacketWeekdays["Tuesday"] = 32] = "Tuesday";
        PacketWeekdays[PacketWeekdays["Monday"] = 64] = "Monday";
        PacketWeekdays[PacketWeekdays["All"] = 127] = "All";
    })(PacketWeekdays = App.PacketWeekdays || (App.PacketWeekdays = {}));
})(App || (App = {}));
var App;
(function (App) {
    var _TourMainFilter_instances, _a, _TourMainFilter_options, _TourMainFilter_popup, _TourMainFilter_responseValidator, _TourMainFilter_abortController, _TourMainFilter_availableRegularDates, _TourMainFilter_availableCharterDates, _TourMainFilter_getCalendarCustomClasses, _TourMainFilter_addCustomValidationRules, _TourMainFilter_getChangeName, _TourMainFilter_markAvailableRegularCheckinDates, _TourMainFilter_markAvailableCharterCheckinDates, _TourMainFilter_updateOptions, _TourMainFilter_onSearch;
    class TourMainFilter extends App.MainFilter {
        constructor(options) {
            super(Object.assign({}, options));
            _TourMainFilter_instances.add(this);
            _TourMainFilter_options.set(this, void 0);
            _TourMainFilter_popup.set(this, void 0);
            _TourMainFilter_responseValidator.set(this, void 0);
            Object.defineProperty(this, "dependencies", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ignoreControlChanges", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            _TourMainFilter_abortController.set(this, void 0);
            _TourMainFilter_availableRegularDates.set(this, []);
            _TourMainFilter_availableCharterDates.set(this, []);
            __classPrivateFieldSet(this, _TourMainFilter_options, options, "f");
            __classPrivateFieldSet(this, _TourMainFilter_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _TourMainFilter_responseValidator, new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            this.dependencies = this.getDependencies(__classPrivateFieldGet(this, _TourMainFilter_options, "f"));
            const controlNames = Object.keys(this.dependencies);
            // Note: не отслеживаем изменения в последней зависимости, т.к. нет зависимых от нее элементов управления.
            for (let i = 0; i < controlNames.length - 1; i++) {
                this.dependencies[controlNames[i]].element.on('change', { name: controlNames[i] }, (e) => __awaiter(this, void 0, void 0, function* () {
                    if (!this.ignoreControlChanges)
                        yield this.onFilterChange(e.data.name);
                }));
            }
            __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_markAvailableRegularCheckinDates).call(this, __classPrivateFieldGet(this, _TourMainFilter_options, "f").regularCheckin);
            __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_markAvailableCharterCheckinDates).call(this, __classPrivateFieldGet(this, _TourMainFilter_options, "f").charterCheckin);
            this.dependencies.checkinFrom.element.datepicker('option', 'beforeShowDay', v => [true, __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_getCalendarCustomClasses).call(this, v), null]);
            if (__classPrivateFieldGet(this, _TourMainFilter_options, "f").isDateRange)
                this.dependencies.checkinTo.element.datepicker('option', 'beforeShowDay', v => [true, __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_getCalendarCustomClasses).call(this, v), null]);
            this.root.on("filter:change" /* Events.FilterChange */, (e, data) => {
                const changeName = __classPrivateFieldGet(_a, _a, "m", _TourMainFilter_getChangeName).call(_a, $(e.target));
                if (changeName) {
                    if (data.instance.isValueSet())
                        __classPrivateFieldGet(this, _TourMainFilter_options, "f").changes.add(changeName);
                    else
                        __classPrivateFieldGet(this, _TourMainFilter_options, "f").changes.delete(changeName);
                }
            });
            __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_addCustomValidationRules).call(this);
            // TODO: реализовать в виде события и в данных события передавать фильтры поиска. На событие подписаться в классе TourPage и производить поиск.
            this.root.on('submit', e => __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_onSearch).call(this, e));
        }
        showMore(e) {
            if (!$(e.currentTarget).hasClass('_on')) {
                $('.js-main-filter-content-more .js-filter-scroll-block', this.root).each((_, v) => {
                    const jqElement = $(v);
                    const scroller = $('.js-scroller', jqElement);
                    const selectedFirst = scroller.attr('data-selected-first') === 'True';
                    if (!selectedFirst)
                        return;
                    const options = $('.js-filter-option', jqElement).not('.js-default-option');
                    const firstOption = options.get(0);
                    if (!firstOption)
                        return;
                    const parent = firstOption.parentNode;
                    if (parent == null)
                        return;
                    const activeOptions = options.filter('._active').get();
                    activeOptions.sort((a, b) => a.innerHTML.toLowerCase().localeCompare(b.innerHTML.toLowerCase()));
                    for (let i = 0; i < activeOptions.length; i++)
                        parent.appendChild(activeOptions[i]);
                    const inactiveOptions = options.not('._active').get();
                    inactiveOptions.sort((a, b) => a.innerHTML.toLowerCase().localeCompare(b.innerHTML.toLowerCase()));
                    for (let i = 0; i < inactiveOptions.length; i++)
                        parent.appendChild(inactiveOptions[i]);
                });
            }
            super.showMore(e);
        }
        onFilterChange(sender) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.filterChange(sender, v => this.getDependencyValue(v));
            });
        }
        filterChange(sender_1, valueProvider_1) {
            return __awaiter(this, arguments, void 0, function* (sender, valueProvider, signal = App.noneSignal) {
                var _b, _c, _d, _e;
                const changeType = (sender == null ? 'none' : (_b = this.dependencies[sender].changeType) !== null && _b !== void 0 ? _b : sender);
                const changes = new Set(__classPrivateFieldGet(this, _TourMainFilter_options, "f").changes);
                if (sender) {
                    const dependency = this.dependencies[sender];
                    const changeName = __classPrivateFieldGet(_a, _a, "m", _TourMainFilter_getChangeName).call(_a, dependency.element);
                    if (changeName != null) {
                        if ((_d = (_c = dependency.control) === null || _c === void 0 ? void 0 : _c.isValueSet()) !== null && _d !== void 0 ? _d : true)
                            changes.add(changeName);
                        else
                            changes.delete(changeName);
                    }
                }
                const rqData = {
                    changes: [...changes],
                    changeType,
                };
                Object.keys(this.dependencies)
                    .forEach(v => {
                    const value = valueProvider(v);
                    if (value != null)
                        rqData[v] = value;
                });
                (_e = __classPrivateFieldGet(this, _TourMainFilter_abortController, "f")) === null || _e === void 0 ? void 0 : _e.abort();
                __classPrivateFieldSet(this, _TourMainFilter_abortController, new AbortController(), "f");
                this.submitButton.prop('disabled', true);
                const popupGroup = __classPrivateFieldGet(this, _TourMainFilter_popup, "f").show({
                    group: 'filter',
                    // TODO: перенести в templates.Messages.UpdatingFilters.
                    content: App.templates.Tour.Messages.UpdatingFilters({}),
                    modal: true,
                    delay: 10000,
                });
                try {
                    const localSignal = App.createLinkedSignal(signal, __classPrivateFieldGet(this, _TourMainFilter_abortController, "f").signal);
                    const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourMainFilter_options, "f").urls.filters, { body: App.createUrlSearchParams(rqData), signal: localSignal });
                    if (!__classPrivateFieldGet(this, _TourMainFilter_responseValidator, "f").process(response))
                        return;
                    signal.throwIfAborted();
                    Object.keys(response.data)
                        .filter(v => response.data[v] != null)
                        .forEach(v => {
                        var _b;
                        switch (v) {
                            case 'direct': {
                                const direct = this.findControl('direct');
                                if (direct) {
                                    if (response.data.direct.length === 1)
                                        direct.setValue(response.data.direct[0] === 'true');
                                    direct.disabled = response.data.direct.length === 1;
                                }
                                break;
                            }
                            case 'charter': {
                                const charter = this.findControl('charter');
                                if (charter) {
                                    if (response.data.charter.length === 1)
                                        charter.setValue(response.data.charter[0] === 'true');
                                    charter.disabled = response.data.charter.length === 1;
                                }
                                break;
                            }
                            case 'checkin': {
                                const checkinFrom = App.parseIsoDate(response.data.checkin[0]);
                                const checkinTo = App.parseIsoDate(response.data.checkin[1]);
                                if (__classPrivateFieldGet(this, _TourMainFilter_options, "f").isDateRange) {
                                    const checkin = this.findControl('checkin');
                                    if (checkin && checkin.getValues().every(x => x != null))
                                        checkin.setValues(checkinFrom, checkinTo);
                                }
                                else {
                                    const checkin = this.findControl('checkin');
                                    if (checkin && checkin.getValue() != null)
                                        checkin.setValue(checkinFrom);
                                }
                                break;
                            }
                            case 'night': {
                                const control = (_b = this.dependencies.night) === null || _b === void 0 ? void 0 : _b.control;
                                const nightOptions = response.data[v];
                                if (control == null || (!control.isValueSet() && !changes.has("Night" /* TourFilterFields.Night */)))
                                    nightOptions.forEach(x => (x.selected = false));
                                __classPrivateFieldGet(_a, _a, "m", _TourMainFilter_updateOptions).call(_a, this.dependencies[v], nightOptions);
                                break;
                            }
                            case 'regularCheckinDates':
                                __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_markAvailableRegularCheckinDates).call(this, response.data.regularCheckinDates);
                                break;
                            case 'charterCheckinDates':
                                __classPrivateFieldGet(this, _TourMainFilter_instances, "m", _TourMainFilter_markAvailableCharterCheckinDates).call(this, response.data.charterCheckinDates);
                                break;
                            default:
                                if (this.dependencies[v] != null)
                                    __classPrivateFieldGet(_a, _a, "m", _TourMainFilter_updateOptions).call(_a, this.dependencies[v], response.data[v]);
                                break;
                        }
                    });
                }
                catch (ex) {
                    if (!__classPrivateFieldGet(this, _TourMainFilter_responseValidator, "f").processError(ex))
                        throw ex;
                }
                finally {
                    __classPrivateFieldGet(this, _TourMainFilter_popup, "f").hide(popupGroup);
                    this.submitButton.prop('disabled', false);
                }
            });
        }
        getDependencyValue(name) {
            const dependency = this.dependencies[name];
            // Ищем первый input среди dataElement или его потомков.
            let element = dependency.element.filter('input');
            if (element.length <= 0)
                element = dependency.element.find('input');
            if (element.length <= 0)
                return null;
            const value = element.valString();
            if (!value)
                return null;
            if (dependency.multiple && typeof value === 'string')
                return value.split(',');
            return value;
        }
        // TODO: по идее данный метод должен быть в соответствующем классе TourXxxPage
        search(manualSearch = true) {
            const elements = this.root.serializeArray();
            const data = { changes: [...__classPrivateFieldGet(this, _TourMainFilter_options, "f").changes] };
            elements
                .filter(v => v.value != null && v.value !== '')
                .forEach(v => {
                // TODO: детектить тип данных - единичный или множественный и только для множественного делать split.
                data[v.name] = v.value.split(',');
            });
            // TODO: переделать на событие экземпляра текущего класса.
            this.root.trigger("filter:search" /* Events.FilterSearch */, [data, manualSearch]);
        }
    }
    _a = TourMainFilter, _TourMainFilter_options = new WeakMap(), _TourMainFilter_popup = new WeakMap(), _TourMainFilter_responseValidator = new WeakMap(), _TourMainFilter_abortController = new WeakMap(), _TourMainFilter_availableRegularDates = new WeakMap(), _TourMainFilter_availableCharterDates = new WeakMap(), _TourMainFilter_instances = new WeakSet(), _TourMainFilter_getCalendarCustomClasses = function _TourMainFilter_getCalendarCustomClasses(value) {
        const compareValue = value.getTime();
        const result = new Array();
        if (__classPrivateFieldGet(this, _TourMainFilter_availableRegularDates, "f").includes(compareValue))
            result.push('_avia-dynamic');
        if (__classPrivateFieldGet(this, _TourMainFilter_availableCharterDates, "f").includes(compareValue))
            result.push('_avia-block');
        if (result.length > 0)
            result.push('_arrival-date');
        return result.join(' ');
    }, _TourMainFilter_addCustomValidationRules = function _TourMainFilter_addCustomValidationRules() {
        const control = this.findControl("Checkin" /* TourFilterFields.Checkin */);
        const availableRegularDates = __classPrivateFieldGet(this, _TourMainFilter_availableRegularDates, "f");
        const availableCharterDates = __classPrivateFieldGet(this, _TourMainFilter_availableCharterDates, "f");
        $.validator.addMethod('activedate', function activeDate(value, element) {
            if (this.optional(element))
                return true;
            if (!control)
                return true;
            const values = control.getValues();
            const minValue = values[0].getTime();
            const maxValue = values[1].getTime();
            return availableRegularDates.some(v => v >= minValue && v <= maxValue)
                || availableCharterDates.some(v => v >= minValue && v <= maxValue);
        }, 'Нет предложений на даты.');
    }, _TourMainFilter_getChangeName = function _TourMainFilter_getChangeName(sender) {
        let name = sender.closest('.filter-block').find(':input').attr('name');
        if (!name)
            return undefined;
        const complexPos = name.indexOf('.');
        if (complexPos >= 0)
            name = name.substring(0, complexPos);
        return name;
    }, _TourMainFilter_markAvailableRegularCheckinDates = function _TourMainFilter_markAvailableRegularCheckinDates(dates) {
        App.emptyArray(__classPrivateFieldGet(this, _TourMainFilter_availableRegularDates, "f"));
        __classPrivateFieldGet(this, _TourMainFilter_availableRegularDates, "f").push(...dates.map(v => App.parseIsoDate(v).getTime()));
    }, _TourMainFilter_markAvailableCharterCheckinDates = function _TourMainFilter_markAvailableCharterCheckinDates(dates) {
        App.emptyArray(__classPrivateFieldGet(this, _TourMainFilter_availableCharterDates, "f"));
        __classPrivateFieldGet(this, _TourMainFilter_availableCharterDates, "f").push(...dates.map(v => App.parseIsoDate(v).getTime()));
    }, _TourMainFilter_updateOptions = function _TourMainFilter_updateOptions(dependency, options) {
        if (dependency.control) {
            dependency.control.replaceOptions(options, true);
        }
        else {
            const optionsContainer = $('.js-scroller', dependency.element);
            $('.js-filter-option', optionsContainer).not('.js-default-option').remove();
            const templateName = optionsContainer.attr('data-template');
            if (templateName)
                optionsContainer.append(App.findTemplate(templateName)(options));
        }
    }, _TourMainFilter_onSearch = function _TourMainFilter_onSearch(e) {
        e.preventDefault();
        this.search();
    };
    App.TourMainFilter = TourMainFilter;
})(App || (App = {}));
/// <reference path='TourMainFilter.ts' />
var App;
(function (App) {
    var _a, _TourGroupMainFilter_options, _TourGroupMainFilter_convert;
    class TourGroupMainFilter extends App.TourMainFilter {
        constructor(options) {
            super(Object.assign({}, options));
            _TourGroupMainFilter_options.set(this, void 0);
            __classPrivateFieldSet(this, _TourGroupMainFilter_options, options, "f");
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        getDependencies(options) {
            return {
                city: {
                    element: this.root.find('[data-select="city"] .js-jelect'),
                    control: this.findControl('city'),
                    multiple: false,
                    changeType: 'departureCity',
                },
                direct: {
                    element: this.root.find('[name="Direct"]'),
                    multiple: false,
                    changeType: 'directFlight',
                },
                charter: {
                    element: this.root.find('[name="Charter"]'),
                    multiple: false,
                    changeType: 'blockFlight',
                },
                fare: {
                    element: this.root.find('[data-select="fare"] .js-jelect'),
                    control: this.findControl('fare'),
                    multiple: true,
                    changeType: 'tourFare',
                },
                rest: {
                    element: this.root.find('[data-select="rest"] .js-jelect'),
                    control: this.findControl('rest'),
                    multiple: true,
                    changeType: 'restType',
                },
                country: {
                    element: this.root.find('[data-select="country"] .js-jelect'),
                    control: this.findControl('country'),
                    multiple: true,
                    changeType: 'country',
                },
                resort: {
                    element: this.root.find('[data-select="resort"] .js-jelect'),
                    control: this.findControl('resort'),
                    multiple: true,
                    changeType: 'resort',
                },
                program: {
                    element: this.root.find('[data-select="program"] .js-jelect'),
                    control: this.findControl('program'),
                    multiple: true,
                    changeType: 'tourProgram',
                },
                checkinFrom: {
                    element: this.root.find('[name="Checkin.From"]'),
                    multiple: false,
                    changeType: 'checkinDate',
                },
                checkinTo: {
                    element: this.root.find('[name="Checkin.To"]'),
                    multiple: false,
                    changeType: 'checkinDate',
                },
                night: {
                    element: this.root.find('[data-select="night"] .js-jelect'),
                    control: this.findControl('night'),
                    multiple: true,
                    changeType: 'tourDuration',
                },
                categoryFrom: {
                    element: this.root.find('[data-input-name="hotel_stars_from"]'),
                    multiple: false,
                    changeType: 'hotelCategory',
                },
                categoryTo: {
                    element: this.root.find('[data-input-name="hotel_stars_to"]'),
                    multiple: false,
                    changeType: 'hotelCategory',
                },
                chain: {
                    element: this.root.find('[data-select="chain"] .js-jelect'),
                    control: this.findControl('chain'),
                    multiple: true,
                    changeType: 'hotelChain',
                },
                facility: {
                    element: this.root.find('[data-select="facility"].js-filter-scroll-block'),
                    control: this.findControl('facility'),
                    multiple: true,
                    changeType: 'hotelFacility',
                },
                hotel: {
                    element: this.root.find('[data-select="hotel"].js-filter-scroll-block'),
                    control: this.findControl('hotel'),
                    multiple: true,
                    changeType: 'hotel',
                },
                feature: {
                    element: this.root.find('[data-select="feature"].js-filter-scroll-block'),
                    control: this.findControl('feature'),
                    multiple: true,
                    changeType: 'tourFeature',
                },
            };
        }
        /* eslint-enable @typescript-eslint/no-unused-vars */
        onFilterChange(sender) {
            const _super = Object.create(null, {
                onFilterChange: { get: () => super.onFilterChange }
            });
            return __awaiter(this, void 0, void 0, function* () {
                let defaultAdultCount = 0;
                if (sender === 'fare') {
                    const values = this.getDependencyValue(sender);
                    const farePromo = App.Tour.farePromo.toString();
                    if (values && ((typeof values === 'string' && values === farePromo) || (values.length === 1 && values.includes(farePromo))))
                        defaultAdultCount = 1;
                }
                else if (sender === 'rest') {
                    const values = this.getDependencyValue(sender);
                    const restChildrenCamps = App.Tour.restChildrenCamps.toString();
                    if (values && ((typeof values === 'string' && values === restChildrenCamps) || (values.length === 1 && values.includes(restChildrenCamps))))
                        defaultAdultCount = 1;
                }
                if (defaultAdultCount > 0) {
                    const touristControl = this.findControl('Tourist');
                    if (touristControl)
                        touristControl.setValues(defaultAdultCount, []);
                }
                return yield _super.onFilterChange.call(this, sender);
            });
        }
        reset() {
            this.ignoreControlChanges = true;
            super.reset();
            (() => __awaiter(this, void 0, void 0, function* () {
                yield this.filterChange(null, name => __classPrivateFieldGet(_a, _a, "m", _TourGroupMainFilter_convert).call(_a, __classPrivateFieldGet(this, _TourGroupMainFilter_options, "f").defaults[name]));
                __classPrivateFieldGet(this, _TourGroupMainFilter_options, "f").changes.clear();
                this.ignoreControlChanges = false;
            }))();
        }
    }
    _a = TourGroupMainFilter, _TourGroupMainFilter_options = new WeakMap(), _TourGroupMainFilter_convert = function _TourGroupMainFilter_convert(value) {
        if (Array.isArray(value))
            return value.map(v => v.toString());
        return value.toString();
    };
    App.TourGroupMainFilter = TourGroupMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _TourResult_filters, _TourResult_getBannerPosition;
    class TourResult extends App.Result {
        get filters() {
            return __classPrivateFieldGet(this, _TourResult_filters, "f");
        }
        set filters(value) {
            __classPrivateFieldSet(this, _TourResult_filters, value !== null && value !== void 0 ? value : {}, "f");
        }
        constructor(options) {
            super(Object.assign({}, options));
            Object.defineProperty(this, "bannerIncutPositions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _TourResult_filters.set(this, void 0);
            __classPrivateFieldSet(this, _TourResult_filters, {}, "f");
        }
        prepareData(viewType, items, addBlock) {
            if (!this.bannerIncutPositions)
                return items;
            const skipCount = addBlock ? this.paging.index * this.paging.size : 0;
            for (let i = 0; i < items.length; i++) {
                const idx = skipCount + i;
                const pos = __classPrivateFieldGet(_a, _a, "m", _TourResult_getBannerPosition).call(_a, this.bannerIncutPositions, idx);
                if (!pos) {
                    items[i].bannerIncutId = null;
                    items[i].bannerIncutUrl = null;
                }
                else {
                    this.fillBannerIncut(items[i], pos, this.hotFilter.activeView, 1);
                }
            }
            return items;
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        fillBannerIncut(item, pos, viewType, groupType) {
            item.bannerIncutId = null;
            item.bannerIncutUrl = null;
        }
    }
    _a = TourResult, _TourResult_filters = new WeakMap(), _TourResult_getBannerPosition = function _TourResult_getBannerPosition(bannerIncutPositions, index) {
        const bannerIndex = bannerIncutPositions.indexOf(index + 1);
        return bannerIndex < 0 ? null : bannerIndex + 1;
    };
    App.TourResult = TourResult;
})(App || (App = {}));
/// <reference path='TourResult.ts' />
var App;
(function (App) {
    var _TourGroupResult_instances, _a, _TourGroupResult_options, _TourGroupResult_currencyConverter, _TourGroupResult_updateHotFilters, _TourGroupResult_onHotFilterChange, _TourGroupResult_updateRouteOptions;
    class TourGroupResult extends App.TourResult {
        constructor(options) {
            super(Object.assign({}, options));
            _TourGroupResult_instances.add(this);
            _TourGroupResult_options.set(this, void 0);
            _TourGroupResult_currencyConverter.set(this, void 0);
            __classPrivateFieldSet(this, _TourGroupResult_options, options, "f");
            this.hotFilter.root.on("hotfilter:change" /* Events.HotFilterChange */, (e, data) => __classPrivateFieldGet(this, _TourGroupResult_instances, "m", _TourGroupResult_onHotFilterChange).call(this, e, data));
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _TourGroupResult_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _TourGroupResult_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _TourGroupResult_currencyConverter, "f");
                    if (currencyConverter) {
                        data.forEach(v => {
                            var _b;
                            v.sortPrice = (_b = currencyConverter.exchange(v.grossPrice, v.currencyCode, data[0].currencyCode)) !== null && _b !== void 0 ? _b : v.grossPrice;
                        });
                    }
                }
                __classPrivateFieldGet(this, _TourGroupResult_instances, "m", _TourGroupResult_updateHotFilters).call(this, data);
                yield _super.changeDataSource.call(this, data, append);
            });
        }
        applyFilters(items) {
            if (this.filtering.items.length <= 0)
                return items;
            let predicate = () => true;
            this.filtering.items
                .filter(v => v.values.length > 0)
                .forEach(v => {
                switch (v.name.toLowerCase()) {
                    case 'programname': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && v.values.some(y => x.title.toLowerCase().includes(y.toLowerCase()));
                        break;
                    }
                    case 'rest': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => y === x.typeKey);
                        break;
                    }
                    case 'country': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && v.values.some(y => y === `${x.country.key}`);
                        break;
                    }
                    case 'route': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && v.values.some(y => x.mandatoryRoute.some(z => z.name === y) || x.optionalRoute.some(z => z.name === y));
                        break;
                    }
                    case 'cruisedeparturecity': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.cruiseDepartureCities.some(z => z.key === y));
                        break;
                    }
                    case 'feature': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.features.some(z => z.key === y));
                        break;
                    }
                    // no default
                }
            });
            return items.filter(predicate);
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case App.TourSortFields.Alphabet: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.title);
                    else
                        result = Enumerable.from(items).orderBy(v => v.title);
                    return result.toArray();
                }
                case App.TourSortFields.Date: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.beginDate);
                    else
                        result = Enumerable.from(items).orderBy(v => v.beginDate);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.title)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.TourSortFields.Price: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.sortPrice);
                    else
                        result = Enumerable.from(items).orderBy(v => v.sortPrice);
                    return result
                        .thenBy(v => v.title)
                        .thenBy(v => v.beginDate)
                        .thenBy(v => v.key)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse)
                        return [...items].reverse();
                    return items;
                }
            }
        }
        prepareData(viewType, items, addBlock) {
            if (viewType === 'table')
                this.bannerIncutPositions = App.app.settings.tourOptions.bannerIncutPositions.groupTable;
            else
                this.bannerIncutPositions = App.app.settings.tourOptions.bannerIncutPositions.groupBlock;
            return super.prepareData(viewType, items, addBlock);
        }
        fillBannerIncut(item, pos, viewType) {
            var _b, _c, _d, _e, _f, _g;
            const siteUserKey = $('#siteUserKey').valNumber();
            const city = ((_b = this.filters["City" /* TourFilterFields.City */]) !== null && _b !== void 0 ? _b : '').toString();
            const country = ((_c = this.filters["Country" /* TourFilterFields.Country */]) !== null && _c !== void 0 ? _c : '').toString();
            const resort = ((_d = this.filters["Resort" /* TourFilterFields.Resort */]) !== null && _d !== void 0 ? _d : '').toString();
            const rest = ((_e = this.filters["Rest" /* TourFilterFields.Rest */]) !== null && _e !== void 0 ? _e : '').toString();
            const program = ((_f = this.filters["Program" /* TourFilterFields.Program */]) !== null && _f !== void 0 ? _f : '').toString();
            const feature = ((_g = this.filters["Feature" /* TourFilterFields.Feature */]) !== null && _g !== void 0 ? _g : '').toString();
            item.bannerIncutId = `bannerIncut${item.key}-${viewType}-${pos}-Program`;
            item.bannerIncutUrl = `//store.pac.ru/advh.ashx?dom=${item.bannerIncutId}&br=pac-ts-gr-tours-big-${pos}pos&pd=0&sc=10&sb=1&ms=5&ac=1&bc=7&ver=wide&fdp=${city}&tftt=${rest}&fcns=${country}&tfst=${program}&tfat=${feature}&frts=${resort}`;
            if (siteUserKey && siteUserKey > 0)
                item.bannerIncutUrl += `&uk=${siteUserKey}`;
        }
    }
    _a = TourGroupResult, _TourGroupResult_options = new WeakMap(), _TourGroupResult_currencyConverter = new WeakMap(), _TourGroupResult_instances = new WeakSet(), _TourGroupResult_updateHotFilters = function _TourGroupResult_updateHotFilters(data) {
        const oldFilters = this.hotFilter.root.serializeArray();
        const items = Enumerable.from(data);
        const programNameControl = $('[name="ProgramName"]', this.hotFilter.root).parents('.filter-block');
        const showProgramName = programNameControl.length > 0
            && data.length > 1
            && items.any(v => v.title !== data[0].title);
        programNameControl.toggle(showProgramName);
        const restControl = this.hotFilter.findControl('Rest');
        let showRest = false;
        if (restControl) {
            const oldValues = Enumerable.from(oldFilters)
                .where(v => v.name.toLowerCase() === restControl.name)
                .selectMany(v => App.splitNonEmpty(v.value))
                .toArray();
            const options = items
                .distinct(v => v.typeKey)
                .orderBy(v => v.type)
                .select(v => ({ value: `${v.typeKey}`, text: v.type, selected: oldValues.some(x => x === `${v.typeKey}`) }))
                .toArray();
            showRest = options.length > 1;
            restControl.replaceOptions(options, true);
            restControl.root.toggle(showRest);
        }
        const countryControl = this.hotFilter.findControl('Country');
        let showCountry = false;
        if (countryControl) {
            const oldValues = Enumerable.from(oldFilters)
                .where(v => v.name.toLowerCase() === countryControl.name)
                .selectMany(v => App.splitNonEmpty(v.value))
                .toArray();
            const options = items
                .select(v => v.country)
                .distinct(v => v.key)
                .orderBy(v => v.value)
                .select(v => ({ value: `${v.key}`, text: v.value, selected: oldValues.some(x => x === `${v.key}`) }))
                .toArray();
            showCountry = options.length > 1;
            countryControl.replaceOptions(options, true);
            countryControl.root.toggle(showCountry);
        }
        const routeControl = this.hotFilter.findControl('Route');
        let showRoute = false;
        if (routeControl) {
            const options = __classPrivateFieldGet(_a, _a, "m", _TourGroupResult_updateRouteOptions).call(_a, routeControl, data, oldFilters);
            showRoute = options.length > 1;
            routeControl.root.toggle(showRoute);
        }
        const cruiseDepartureCityControl = this.hotFilter.findControl('CruiseDepartureCity');
        let showcruiseDepartureCity = false;
        if (cruiseDepartureCityControl) {
            const oldValues = Enumerable.from(oldFilters)
                .where(v => v.name.toLowerCase() === cruiseDepartureCityControl.name)
                .selectMany(v => App.splitNonEmpty(v.value))
                .where(v => !!v)
                .select(v => parseInt(v, 10))
                .toArray();
            const options = items
                .selectMany(v => v.cruiseDepartureCities)
                .distinct(v => v.key)
                .orderBy(v => v.value)
                .select(v => ({ value: `${v.key}`, text: v.value, selected: oldValues.some(x => x === v.key) }))
                .toArray();
            showcruiseDepartureCity = options.length > 1;
            cruiseDepartureCityControl.replaceOptions(options, true);
            cruiseDepartureCityControl.root.toggle(showcruiseDepartureCity);
        }
        const featureControl = this.hotFilter.findControl('Feature');
        let showFeature = false;
        if (featureControl) {
            const oldValues = Enumerable.from(oldFilters)
                .where(v => v.name.toLowerCase() === featureControl.name)
                .selectMany(v => App.splitNonEmpty(v.value))
                .where(v => !!v)
                .select(v => parseInt(v, 10))
                .toArray();
            const options = items
                .selectMany(v => v.features)
                .distinct(v => v.key)
                .join(Enumerable.from(__classPrivateFieldGet(this, _TourGroupResult_options, "f").featureSortOrder).select((v, i) => ({ value: v, sort: i })), v => v.key, v => v.value, (v1, v2) => ({ key: v1.key, value: v1.value, sort: v2.sort }))
                .orderBy(v => v.sort)
                .select(v => ({ value: `${v.key}`, text: v.value, selected: oldValues.some(x => x === v.key) }))
                .toArray();
            showFeature = options.length > 1;
            featureControl.replaceOptions(options, true);
            featureControl.root.toggle(showFeature);
        }
        const showFilters = showProgramName || showRest || showCountry || showRoute || showcruiseDepartureCity || showFeature;
        $('.js-filter-body', this.hotFilter.root).toggle(showFilters);
    }, _TourGroupResult_onHotFilterChange = function _TourGroupResult_onHotFilterChange(e, data) {
        if (data.filter.name === 'country') {
            const oldFilters = this.hotFilter.root.serializeArray();
            const countryControl = this.hotFilter.findControl('Country');
            const routeControl = this.hotFilter.findControl('Route');
            if (countryControl && routeControl) {
                const countryValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === countryControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .select(v => parseInt(v, 10))
                    .toArray();
                __classPrivateFieldGet(_a, _a, "m", _TourGroupResult_updateRouteOptions).call(_a, routeControl, this.data, oldFilters, countryValues);
            }
        }
    }, _TourGroupResult_updateRouteOptions = function _TourGroupResult_updateRouteOptions(control, data, filterValues, countryKeys = []) {
        const oldValues = Enumerable.from(filterValues)
            .where(v => v.name.toLowerCase() === control.name)
            .selectMany(v => App.splitNonEmpty(v.value))
            .toArray();
        const options = Enumerable.from(data)
            .selectMany(v => v.mandatoryRoute.concat(v.optionalRoute))
            .where(v => countryKeys.length <= 0 || countryKeys.includes(v.countryKey))
            .select(v => v.name)
            .distinct(v => v)
            .orderBy(v => v)
            .select(v => ({ value: v, text: v, selected: oldValues.some(x => x === v) }))
            .toArray();
        control.replaceOptions(options, true);
        return options;
    };
    App.TourGroupResult = TourGroupResult;
})(App || (App = {}));
/// <reference path='../../common/components/HotFilter.Mobile.ts' />
var App;
(function (App) {
    var _TourHotFilterMobile_instances, _TourHotFilterMobile_options, _TourHotFilterMobile_getRestOptions, _TourHotFilterMobile_getCountryOptions, _TourHotFilterMobile_getRouteOptions, _TourHotFilterMobile_getCruiseDepartureCityOptions, _TourHotFilterMobile_getFeatureOptions, _TourHotFilterMobile_toListOptions;
    /**
     * Мобильная версия хот-фильтра результатов поиска туров.
     *
     * Сортировка - через vue-модалку (select-list-filter), фильтры - через модалку
     * custom-content-modal (тело .js-filter-body перемещается в нее при открытии).
     */
    class TourHotFilterMobile extends App.HotFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-tour-search-hot-filter' }, options));
            _TourHotFilterMobile_instances.add(this);
            _TourHotFilterMobile_options.set(this, void 0);
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _TourHotFilterMobile_options, options, "f");
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
            if (!this.root.length) {
                this.filters = undefined;
                return;
            }
            this.filters = new App.FiltersMobileBase({
                root: this.root,
                onFilterChanged: () => this.onSelfFilterChanged(),
            });
        }
        onSelfFilterChanged() {
            return __awaiter(this, void 0, void 0, function* () {
                this.root.trigger("filter:change" /* Events.FilterChange */);
            });
        }
        onHotFiltersChange(event) {
            var _a, _b;
            const selectedHotFilters = (_b = (_a = this.filters) === null || _a === void 0 ? void 0 : _a.serializeArray()) !== null && _b !== void 0 ? _b : [];
            const filters = selectedHotFilters
                // не false и не пустые значения (их не передаем)
                .filter(item => item.value != null && item.value !== '' && item.value !== 'false')
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name.toLowerCase(),
                values: item.value.split(','),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            this.root.trigger("hotFilter:beforeFiltering" /* Events.HotFilterBeforeFiltering */, [filters, event.target]);
            this.root.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('hotFilterFoundTitle', { count: data.length }));
        }
        /**
         * Обновление опций списков хот-фильтра по данным результатов поиска.
         * Контролы без выбора (менее двух уникальных значений в результатах) скрываются - как на десктопе
         * (см. TourGroupResult.#updateHotFilters).
         * @param offers результаты поиска.
         */
        refreshHotFilters(offers) {
            if (!offers || offers.length <= 1) {
                $('.js-filter-body', this.root).hide();
                this.toggleFiltersButton(false);
                return;
            }
            // название тура показывается, только если в результатах есть разные названия
            const showProgramName = offers.some(v => v.title !== offers[0].title);
            this.toggleControl('programname', showProgramName);
            const showRest = this.refreshSelectList('rest', __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_getRestOptions).call(this, offers));
            const showCountry = this.refreshSelectList('country', __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_getCountryOptions).call(this, offers));
            const showRoute = this.refreshSelectList('route', __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_getRouteOptions).call(this, offers));
            const showCruiseDepartureCity = this.refreshSelectList('cruisedeparturecity', __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_getCruiseDepartureCityOptions).call(this, offers));
            const showFeature = this.refreshSelectList('feature', __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_getFeatureOptions).call(this, offers));
            // если нет ни одного актуального фильтра - скрываем кнопку "Фильтры"
            // (само тело .js-filter-body всегда скрыто на странице - оно отображается только в модалке)
            const showFilters = showProgramName
                || showRest
                || showCountry
                || showRoute
                || showCruiseDepartureCity
                || showFeature;
            this.toggleFiltersButton(showFilters);
        }
        /**
         * Переключение видимости кнопки "Фильтры" (открывает модалку с фильтрами).
         * @param show показывать ли кнопку.
         */
        toggleFiltersButton(show) {
            $('.js-filter-hot-filter', this.root).toggle(show);
        }
        /**
         * Обновление опций контрола-списка и его видимости (показывается при наличии выбора).
         * @param key имя контрола (FilterKey).
         * @param options новые опции.
         * @returns показывается ли контрол.
         */
        refreshSelectList(key, options) {
            var _a;
            const control = (_a = this.filters) === null || _a === void 0 ? void 0 : _a.findControl(key);
            if (!control)
                return false;
            control.setValueByListOptions(options, false);
            return this.toggleControl(key, options.length > 1);
        }
        /**
         * Переключение видимости контрола.
         * @param key имя контрола (FilterKey).
         * @param show показывать ли контрол.
         * @returns показывается ли контрол.
         */
        toggleControl(key, show) {
            var _a;
            const control = (_a = this.filters) === null || _a === void 0 ? void 0 : _a.findControl(key);
            if (!control)
                return false;
            const container = control.root.closest('.filter');
            (container.length ? container : control.root).toggle(show);
            return show;
        }
        /**
         * Текущие выбранные значения контрола (для сохранения выбора при обновлении опций).
         */
        getSelectedValues(key) {
            var _a, _b;
            // NOTE: ключи хот-фильтра - в нижнем регистре (чтобы не конфликтовать с основным фильтром в PwStore)
            return (_b = (_a = this.filters) === null || _a === void 0 ? void 0 : _a.getControlValueStringArr(key).filter(v => v != null && v !== '')) !== null && _b !== void 0 ? _b : [];
        }
    }
    _TourHotFilterMobile_options = new WeakMap(), _TourHotFilterMobile_instances = new WeakSet(), _TourHotFilterMobile_getRestOptions = function _TourHotFilterMobile_getRestOptions(offers) {
        const selected = this.getSelectedValues('rest');
        const map = new Map();
        offers.forEach(v => map.set(`${v.typeKey}`, v.type));
        return __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourHotFilterMobile_getCountryOptions = function _TourHotFilterMobile_getCountryOptions(offers) {
        const selected = this.getSelectedValues('country');
        const map = new Map();
        offers.forEach(v => map.set(`${v.country.key}`, v.country.value));
        return __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourHotFilterMobile_getRouteOptions = function _TourHotFilterMobile_getRouteOptions(offers) {
        const selected = this.getSelectedValues('route');
        const names = new Set();
        offers.forEach(v => {
            var _a, _b;
            ((_a = v.mandatoryRoute) !== null && _a !== void 0 ? _a : []).forEach(r => names.add(r.name));
            ((_b = v.optionalRoute) !== null && _b !== void 0 ? _b : []).forEach(r => names.add(r.name));
        });
        return __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_toListOptions).call(this, [...names].map(name => [name, name]), selected);
    }, _TourHotFilterMobile_getCruiseDepartureCityOptions = function _TourHotFilterMobile_getCruiseDepartureCityOptions(offers) {
        const selected = this.getSelectedValues('cruisedeparturecity');
        const map = new Map();
        offers.forEach(v => { var _a; return ((_a = v.cruiseDepartureCities) !== null && _a !== void 0 ? _a : []).forEach(c => map.set(`${c.key}`, c.value)); });
        return __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourHotFilterMobile_getFeatureOptions = function _TourHotFilterMobile_getFeatureOptions(offers) {
        var _a;
        const selected = this.getSelectedValues('feature');
        const map = new Map();
        offers.forEach(v => { var _a; return ((_a = v.features) !== null && _a !== void 0 ? _a : []).forEach(f => map.set(`${f.key}`, f.value)); });
        // сортировка особенностей по заданному порядку ключей
        const order = (_a = __classPrivateFieldGet(this, _TourHotFilterMobile_options, "f").featureSortOrder) !== null && _a !== void 0 ? _a : [];
        const entries = [...map].sort((a, b) => {
            const orderA = order.indexOf(parseInt(a[0], 10));
            const orderB = order.indexOf(parseInt(b[0], 10));
            return (orderA < 0 ? order.length : orderA) - (orderB < 0 ? order.length : orderB);
        });
        return __classPrivateFieldGet(this, _TourHotFilterMobile_instances, "m", _TourHotFilterMobile_toListOptions).call(this, entries, selected);
    }, _TourHotFilterMobile_toListOptions = function _TourHotFilterMobile_toListOptions(entries, selected) {
        return entries
            .sort((a, b) => a[1].localeCompare(b[1]))
            .map(([value, text]) => ({ value, text, selected: selected.indexOf(value) >= 0 }));
    };
    App.TourHotFilterMobile = TourHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class TourHotFilter extends App.HotFilter {
        constructor(options) {
            super(Object.assign({}, options));
        }
        onHotFiltersChange(e, data) {
            // TODO: перенести в HotFilter.ts
            this.root.trigger("hotfilter:change" /* Events.HotFilterChange */, [{ instance: this, filter: data.instance }]);
            const mapper = new App.HotFilterMapper(this.root);
            this.root.trigger("filter:filter" /* Events.FilterFilter */, { items: mapper.execute() });
        }
    }
    App.TourHotFilter = TourHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    class TourHotelDateGroupSearchViewModel {
        get minPrice() {
            return this.minPriceItem.grossPrice;
        }
        get currencyCode() {
            return this.minPriceItem.currencyCode;
        }
        get visibleItems() {
            return this.items.filter(y => !y.isHidden);
        }
        constructor(key, items) {
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "active", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minPriceItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "priceGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isHidden", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.key = key;
            this.items = items;
            this.active = false;
            [this.minPriceItem] = items;
            this.priceGroup = 0;
            this.isHidden = false;
        }
        update() {
            this.minPriceItem = Enumerable.from(this.visibleItems)
                .defaultIfEmpty(this.items[0])
                .minBy(v => v.sortPrice);
        }
    }
    App.TourHotelDateGroupSearchViewModel = TourHotelDateGroupSearchViewModel;
})(App || (App = {}));
/// <reference path='TourHotFilter.Mobile.ts' />
var App;
(function (App) {
    var _TourHotelHotFilterMobile_instances, _a, _TourHotelHotFilterMobile_options, _TourHotelHotFilterMobile_toggleAvailability, _TourHotelHotFilterMobile_getFareOptions, _TourHotelHotFilterMobile_getRoomTypeOptions, _TourHotelHotFilterMobile_getBoardTypeOptions, _TourHotelHotFilterMobile_getProviderOptions, _TourHotelHotFilterMobile_getOfferSourceOptions, _TourHotelHotFilterMobile_toDictionaryOptions, _TourHotelHotFilterMobile_toListOptions;
    class TourHotelHotFilterMobile extends App.TourHotFilterMobile {
        constructor(options) {
            var _b;
            super({ root: '.js-tour-hotel-hot-filter', featureSortOrder: [] });
            _TourHotelHotFilterMobile_instances.add(this);
            _TourHotelHotFilterMobile_options.set(this, void 0);
            __classPrivateFieldSet(this, _TourHotelHotFilterMobile_options, (_b = options === null || options === void 0 ? void 0 : options.resultOptions) !== null && _b !== void 0 ? _b : { dynamicRoomTypes: [], dynamicBoardTypes: [] }, "f");
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('tour/hotelHotFilterFoundTitle', {
                groupCount: data.length,
                count: Enumerable.from(data)
                    .selectMany(v => v.visibleItems)
                    .select(v => v.visibleItems.length)
                    .sum(),
            }));
        }
        /**
         * Обновление опций и видимости контролов хот-фильтра по результатам поиска.
         */
        refreshHotelHotFilters(data) {
            const items = [];
            (data !== null && data !== void 0 ? data : []).forEach(group => group.items.forEach(dateGroup => items.push(...dateGroup.items)));
            if (items.length <= 0) {
                this.toggleFiltersButton(false);
                return;
            }
            // наличие мест и т.д. - показываются, если есть обе ситуации
            const isYes = (v) => v.aviaQuota === App.QuotaStatus.Yes || v.aviaQuota === App.QuotaStatus.Few;
            const hotelYes = (v) => v.hotelQuota === App.QuotaStatus.Yes || v.hotelQuota === App.QuotaStatus.Few;
            const showIsAviaYes = __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_toggleAvailability).call(this, 'isaviayes', items.some(v => !isYes(v)), items.some(isYes));
            const showIsAviaRequest = __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_toggleAvailability).call(this, 'isaviarequest', items.some(v => v.aviaQuota !== App.QuotaStatus.Request), items.some(v => v.aviaQuota === App.QuotaStatus.Request));
            const showIsDynamicAvia = __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_toggleAvailability).call(this, 'isdynamicavia', items.some(v => !v.dynamicFlight), items.some(v => v.dynamicFlight));
            const showHasHotel = __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_toggleAvailability).call(this, 'hashotel', items.some(v => !hotelYes(v)), items.some(hotelYes));
            const showHasTransfer = __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_toggleAvailability).call(this, 'hastransfer', items.some(v => !v.includesTransfer), items.some(v => v.includesTransfer));
            const showHasTreatment = __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_toggleAvailability).call(this, 'hastreatment', items.some(v => !v.hasTreatment), items.some(v => v.hasTreatment));
            const showFare = this.refreshSelectList('fare', __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_getFareOptions).call(this, items));
            const showRoomType = this.refreshSelectList('roomtype', __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_getRoomTypeOptions).call(this, items));
            const showBoardType = this.refreshSelectList('boardtype', __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_getBoardTypeOptions).call(this, items));
            const showProvider = this.refreshSelectList('provider', __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_getProviderOptions).call(this, items));
            const showOfferSource = this.refreshSelectList('offersource', __classPrivateFieldGet(this, _TourHotelHotFilterMobile_instances, "m", _TourHotelHotFilterMobile_getOfferSourceOptions).call(this, items));
            // если нет ни одного актуального фильтра - скрываем кнопку "Фильтр"
            const showFilters = showIsAviaYes || showIsAviaRequest || showIsDynamicAvia
                || showHasHotel || showHasTransfer || showHasTreatment
                || showFare || showRoomType || showBoardType || showProvider || showOfferSource;
            this.toggleFiltersButton(showFilters);
        }
    }
    _a = TourHotelHotFilterMobile, _TourHotelHotFilterMobile_options = new WeakMap(), _TourHotelHotFilterMobile_instances = new WeakSet(), _TourHotelHotFilterMobile_toggleAvailability = function _TourHotelHotFilterMobile_toggleAvailability(key, hasNotMatched, hasMatched) {
        return this.toggleControl(key, hasNotMatched && hasMatched);
    }, _TourHotelHotFilterMobile_getFareOptions = function _TourHotelHotFilterMobile_getFareOptions(items) {
        const selected = this.getSelectedValues('fare');
        const map = new Map();
        items.forEach(v => { var _b; return ((_b = v.tourFares) !== null && _b !== void 0 ? _b : []).forEach(f => map.set(`${f.key}`, f.name)); });
        return __classPrivateFieldGet(_a, _a, "m", _TourHotelHotFilterMobile_toListOptions).call(_a, [...map], selected, true);
    }, _TourHotelHotFilterMobile_getRoomTypeOptions = function _TourHotelHotFilterMobile_getRoomTypeOptions(items) {
        const selected = this.getSelectedValues('roomtype');
        const codes = new Set();
        items.forEach(v => { var _b; return ((_b = v.hotel.roomGroups) !== null && _b !== void 0 ? _b : []).forEach(code => codes.add(code)); });
        return __classPrivateFieldGet(_a, _a, "m", _TourHotelHotFilterMobile_toDictionaryOptions).call(_a, __classPrivateFieldGet(this, _TourHotelHotFilterMobile_options, "f").dynamicRoomTypes, codes, selected);
    }, _TourHotelHotFilterMobile_getBoardTypeOptions = function _TourHotelHotFilterMobile_getBoardTypeOptions(items) {
        const selected = this.getSelectedValues('boardtype');
        const codes = new Set();
        items.forEach(v => {
            if (v.hotel.boardGroup)
                codes.add(v.hotel.boardGroup);
        });
        return __classPrivateFieldGet(_a, _a, "m", _TourHotelHotFilterMobile_toDictionaryOptions).call(_a, __classPrivateFieldGet(this, _TourHotelHotFilterMobile_options, "f").dynamicBoardTypes, codes, selected);
    }, _TourHotelHotFilterMobile_getProviderOptions = function _TourHotelHotFilterMobile_getProviderOptions(items) {
        const selected = this.getSelectedValues('provider');
        const map = new Map();
        items.forEach(v => {
            if (v.dynamicHotelProvider != null)
                map.set(`${v.dynamicHotelProvider.key}`, v.dynamicHotelProvider.name);
        });
        return __classPrivateFieldGet(_a, _a, "m", _TourHotelHotFilterMobile_toListOptions).call(_a, [...map], selected, false);
    }, _TourHotelHotFilterMobile_getOfferSourceOptions = function _TourHotelHotFilterMobile_getOfferSourceOptions(items) {
        const selected = this.getSelectedValues('offersource');
        const map = new Map();
        items.forEach(v => {
            if (v.dynamicHotelOfferSource != null)
                map.set(`${v.dynamicHotelOfferSource.key}`, v.dynamicHotelOfferSource.name);
        });
        return __classPrivateFieldGet(_a, _a, "m", _TourHotelHotFilterMobile_toListOptions).call(_a, [...map], selected, false);
    }, _TourHotelHotFilterMobile_toDictionaryOptions = function _TourHotelHotFilterMobile_toDictionaryOptions(dictionary, codes, selected) {
        return (dictionary !== null && dictionary !== void 0 ? dictionary : [])
            .filter(v => codes.has(v.code))
            .sort((a, b) => (a.sortOrder - b.sortOrder) || a.name.localeCompare(b.name))
            .map(v => ({ value: v.code, text: v.name, selected: selected.indexOf(v.code) >= 0 }));
    }, _TourHotelHotFilterMobile_toListOptions = function _TourHotelHotFilterMobile_toListOptions(entries, selected, byKey) {
        return entries
            .sort((a, b) => (byKey ? parseInt(a[0], 10) - parseInt(b[0], 10) : a[1].localeCompare(b[1])))
            .map(([value, text]) => ({ value, text, selected: selected.indexOf(value) >= 0 }));
    };
    App.TourHotelHotFilterMobile = TourHotelHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class TourHotelHotFilter extends App.TourHotFilter {
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('tour/hotelHotFilterFoundTitle', {
                groupCount: data.length,
                count: Enumerable.from(data)
                    .selectMany(v => v.visibleItems)
                    .select(v => v.visibleItems.length)
                    .sum(),
            }));
        }
    }
    App.TourHotelHotFilter = TourHotelHotFilter;
})(App || (App = {}));
/// <reference path='../../common/components/MainFilter.Mobile.ts' />
var App;
(function (App) {
    var _TourHotelMainFilterMobile_instances, _a, _TourHotelMainFilterMobile_options, _TourHotelMainFilterMobile_popup, _TourHotelMainFilterMobile_responseValidator, _TourHotelMainFilterMobile_abortController, _TourHotelMainFilterMobile_suppressChanges, _TourHotelMainFilterMobile_changeTypes, _TourHotelMainFilterMobile_searchFieldOrder, _TourHotelMainFilterMobile_onFilterChanged, _TourHotelMainFilterMobile_getFieldName, _TourHotelMainFilterMobile_filterChange, _TourHotelMainFilterMobile_getSelectValues, _TourHotelMainFilterMobile_getDateValue, _TourHotelMainFilterMobile_applyFiltersData, _TourHotelMainFilterMobile_updateSelectList;
    class TourHotelMainFilterMobile extends App.MainFilterMobile {
        constructor(options) {
            var _b;
            super(Object.assign({ root: '.js-tour-hotel-filter', customFilters: {
                    root: '.js-tour-hotel-filter',
                    clickSelector: '.js-tour-hotel-filters-open',
                    modalKey: 'tour-hotel-filters-modal',
                    contentSelector: '#js-tour-hotel-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать',
                    title: 'Параметры поиска',
                }, onFilterChanged: filterName => __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_onFilterChanged).call(this, filterName) }, options));
            _TourHotelMainFilterMobile_instances.add(this);
            _TourHotelMainFilterMobile_options.set(this, void 0);
            _TourHotelMainFilterMobile_popup.set(this, void 0);
            _TourHotelMainFilterMobile_responseValidator.set(this, void 0);
            _TourHotelMainFilterMobile_abortController.set(this, void 0);
            /**
             * Флаг подавления реакции на изменения фильтров.
             * Включен во время инициализации (PwStore.AddFilter в конструкторах контролов)
             * и во время применения данных от HotelFilters (иначе возникает цикл запросов).
             */
            _TourHotelMainFilterMobile_suppressChanges.set(this, true);
            __classPrivateFieldSet(this, _TourHotelMainFilterMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TourHotelMainFilterMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _TourHotelMainFilterMobile_responseValidator, new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            // блочные рейсы
            if (this.root.attr('data-charter-disabled') === 'True')
                (_b = this.filters.findControl('Charter')) === null || _b === void 0 ? void 0 : _b.setEnabled(false);
            __classPrivateFieldSet(this, _TourHotelMainFilterMobile_suppressChanges, false, "f");
        }
        /**
         * Данные для выполнения поиска (сериализация контролов в параметры формы TourHotelSearchForm).
         * Состав и порядок параметров - как у десктопного TourMainFilter.search.
         */
        buildSearchData() {
            const values = {};
            // отель и номер заказа (контекста) - hidden-поля формы (не контролы)
            for (const name of ['Hotel', 'context']) {
                const value = this.root.find(`[name="${name}"]`).valString();
                if (value)
                    values[name] = [value];
            }
            this.filters.serializeArray()
                .filter(v => v.value != null && v.value !== '')
                .forEach(v => {
                // количество детей десктоп не отправляет (передаются только возраста Tourist.ChildAges[i])
                if (v.name === 'Tourist.ChildCount')
                    return;
                values[v.name] = v.value.split(',');
            });
            // поиск выполняется по одной дате заезда
            if (values['Checkin.From'])
                values['Checkin.To'] = values['Checkin.From'];
            // сборка результата в порядке полей десктопной формы
            const data = { changes: [...__classPrivateFieldGet(this, _TourHotelMainFilterMobile_options, "f").changes] };
            const order = __classPrivateFieldGet(_a, _a, "f", _TourHotelMainFilterMobile_searchFieldOrder);
            const orderIndex = (name) => {
                // возраста детей: Tourist.ChildAges[0], Tourist.ChildAges[1], ...
                const index = order.indexOf(name.replace(/\[\d+\]$/, ''));
                return index >= 0 ? index : order.length;
            };
            Object.keys(values)
                .map((name, position) => ({ name, position }))
                .sort((a, b) => (orderIndex(a.name) - orderIndex(b.name)) || (a.position - b.position))
                .forEach(({ name }) => (data[name] = values[name]));
            return data;
        }
        /**
         * Запуск поиска (триггерит событие Events.FilterSearch с данными формы).
         * @param manualSearch признак ручного запуска (пользователем).
         */
        search(manualSearch = true) {
            this.root.trigger("filter:search" /* Events.FilterSearch */, [this.buildSearchData(), manualSearch]);
        }
        /**
         * Сброс фильтра (кнопка "Очистить фильтр")
         */
        reset() {
            __classPrivateFieldSet(this, _TourHotelMainFilterMobile_suppressChanges, true, "f");
            try {
                super.reset();
            }
            finally {
                __classPrivateFieldSet(this, _TourHotelMainFilterMobile_suppressChanges, false, "f");
            }
            __classPrivateFieldGet(this, _TourHotelMainFilterMobile_options, "f").changes.length = 0;
            // обновляем зависимые списки по значениям по умолчанию
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_filterChange).call(this, null); }))();
        }
    }
    _a = TourHotelMainFilterMobile, _TourHotelMainFilterMobile_options = new WeakMap(), _TourHotelMainFilterMobile_popup = new WeakMap(), _TourHotelMainFilterMobile_responseValidator = new WeakMap(), _TourHotelMainFilterMobile_abortController = new WeakMap(), _TourHotelMainFilterMobile_suppressChanges = new WeakMap(), _TourHotelMainFilterMobile_instances = new WeakSet(), _TourHotelMainFilterMobile_onFilterChanged = function _TourHotelMainFilterMobile_onFilterChanged(filterName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _TourHotelMainFilterMobile_suppressChanges, "f"))
                return;
            const changeType = __classPrivateFieldGet(_a, _a, "f", _TourHotelMainFilterMobile_changeTypes)[filterName];
            if (!changeType)
                return;
            // Запоминаем измененный параметр (имя поля формы без суффикса, в нижнем регистре).
            const fieldName = __classPrivateFieldGet(_a, _a, "m", _TourHotelMainFilterMobile_getFieldName).call(_a, filterName);
            if (fieldName && __classPrivateFieldGet(this, _TourHotelMainFilterMobile_options, "f").changes.indexOf(fieldName) < 0)
                __classPrivateFieldGet(this, _TourHotelMainFilterMobile_options, "f").changes.push(fieldName);
            yield __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_filterChange).call(this, changeType);
        });
    }, _TourHotelMainFilterMobile_getFieldName = function _TourHotelMainFilterMobile_getFieldName(filterName) {
        const dotPos = filterName.indexOf('.');
        const name = dotPos >= 0 ? filterName.substring(0, dotPos) : filterName;
        return name.toLowerCase();
    }, _TourHotelMainFilterMobile_filterChange = function _TourHotelMainFilterMobile_filterChange(changeType) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const rqData = {
                changes: [...__classPrivateFieldGet(this, _TourHotelMainFilterMobile_options, "f").changes],
                changeType: changeType !== null && changeType !== void 0 ? changeType : 'none',
            };
            const hotel = this.root.find('[name="Hotel"]').valString();
            if (hotel)
                rqData.hotel = hotel;
            const city = this.filters.getControlValueString('City');
            if (city)
                rqData.city = city;
            rqData.direct = this.filters.getControlToggle('Direct') ? 'true' : 'false';
            rqData.charter = this.filters.getControlToggle('Charter') ? 'true' : 'false';
            const program = this.filters.getControlValueString('Program');
            if (program)
                rqData.program = program;
            const checkin = __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_getDateValue).call(this, 'Checkin.From');
            if (checkin != null) {
                rqData.checkinFrom = checkin;
                rqData.checkinTo = checkin;
            }
            const nights = __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_getSelectValues).call(this, 'Night');
            if (nights.length > 0)
                rqData.night = nights;
            (_b = __classPrivateFieldGet(this, _TourHotelMainFilterMobile_abortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            __classPrivateFieldSet(this, _TourHotelMainFilterMobile_abortController, new AbortController(), "f");
            this.submitButton.prop('disabled', true);
            const popupGroup = __classPrivateFieldGet(this, _TourHotelMainFilterMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Tour.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourHotelMainFilterMobile_options, "f").urls.filters, { body: App.createUrlSearchParams(rqData), signal: __classPrivateFieldGet(this, _TourHotelMainFilterMobile_abortController, "f").signal });
                if (!__classPrivateFieldGet(this, _TourHotelMainFilterMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_applyFiltersData).call(this, response.data);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourHotelMainFilterMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _TourHotelMainFilterMobile_popup, "f").hide(popupGroup);
                this.submitButton.prop('disabled', false);
            }
        });
    }, _TourHotelMainFilterMobile_getSelectValues = function _TourHotelMainFilterMobile_getSelectValues(name) {
        return this.filters.getControlValueStringArr(name)
            .join(',')
            .split(',')
            .filter(v => v != null && v !== '');
    }, _TourHotelMainFilterMobile_getDateValue = function _TourHotelMainFilterMobile_getDateValue(name) {
        var _b;
        const date = (_b = this.filters.findControl(name)) === null || _b === void 0 ? void 0 : _b.getValue();
        if (!date)
            return null;
        return App.formatDate(date, 'shortDate');
    }, _TourHotelMainFilterMobile_applyFiltersData = function _TourHotelMainFilterMobile_applyFiltersData(data) {
        __classPrivateFieldSet(this, _TourHotelMainFilterMobile_suppressChanges, true, "f");
        try {
            for (const key of Object.keys(data)) {
                if (data[key] == null)
                    continue;
                switch (key) {
                    case 'charter': {
                        const { charter } = data;
                        const control = this.filters.findControl('Charter');
                        if (control) {
                            if (charter.length === 1)
                                control.setValue(charter[0] === 'true');
                            control.setEnabled(charter.length !== 1);
                        }
                        break;
                    }
                    case 'checkin': {
                        const { checkin } = data;
                        const control = this.filters.findControl('Checkin.From');
                        if (control && control.getValue() != null && checkin.length >= 1)
                            control.setValue(App.parseIsoDate(checkin[0]));
                        break;
                    }
                    case 'city':
                        __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_updateSelectList).call(this, 'City', data.city);
                        break;
                    case 'night': {
                        const options = data.night;
                        // если количество ночей не выбрано пользователем - снимаем выбор со всех опций
                        if (__classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_getSelectValues).call(this, 'Night').length <= 0 && __classPrivateFieldGet(this, _TourHotelMainFilterMobile_options, "f").changes.indexOf('night') < 0)
                            options.forEach(v => (v.selected = false));
                        __classPrivateFieldGet(this, _TourHotelMainFilterMobile_instances, "m", _TourHotelMainFilterMobile_updateSelectList).call(this, 'Night', options);
                        break;
                    }
                    // NOTE: маркировка доступных дат заезда (regularCheckinDates / charterCheckinDates)
                    // на мобильной версии не используется.
                    default:
                        break;
                }
            }
        }
        finally {
            __classPrivateFieldSet(this, _TourHotelMainFilterMobile_suppressChanges, false, "f");
        }
    }, _TourHotelMainFilterMobile_updateSelectList = function _TourHotelMainFilterMobile_updateSelectList(name, options) {
        const control = this.filters.findControl(name);
        if (!control || !options)
            return;
        control.setValueByListOptions(options.map(v => ({ value: v.value, text: v.text, selected: v.selected })));
    };
    /**
     * Карта соответствия имени контрола -> тип изменения на сервере (PacketFilterType).
     * Порядок и состав - как у TourHotelMainFilter.getDependencies (кроме последней зависимости fare,
     * изменения которой на десктопе не отслеживаются).
     */
    _TourHotelMainFilterMobile_changeTypes = { value: {
            'City': 'departureCity',
            'Direct': 'directFlight',
            'Charter': 'blockFlight',
            'Program': 'tourProgram',
            'Checkin.From': 'checkinDate',
            'Night': 'tourDuration',
        } };
    /**
     * Порядок параметров поиска - как порядок полей десктопной формы (Views/Tour/Filters/HotelFilter.cshtml),
     * чтобы payload запроса Tour/Hotel совпадал с десктопной версией.
     */
    _TourHotelMainFilterMobile_searchFieldOrder = { value: [
            'context',
            'Hotel',
            'City',
            'Direct',
            'Charter',
            'Program',
            'Checkin.From',
            'Checkin.To',
            'Night',
            'Tourist.AdultCount',
            'Tourist.ChildAges',
            'Board',
            'Fare',
        ] };
    App.TourHotelMainFilterMobile = TourHotelMainFilterMobile;
})(App || (App = {}));
/// <reference path='TourMainFilter.ts' />
var App;
(function (App) {
    class TourHotelMainFilter extends App.TourMainFilter {
        constructor(options) {
            super(Object.assign({}, options));
        }
        onFilterChange(sender) {
            const _super = Object.create(null, {
                onFilterChange: { get: () => super.onFilterChange }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                this.root.find('[name="Checkin.To"]').val((_a = this.dependencies.checkinFrom.element.val()) !== null && _a !== void 0 ? _a : '');
                yield _super.onFilterChange.call(this, sender);
            });
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        getDependencies(options) {
            return {
                hotel: {
                    element: this.root.find('[name="Hotel"]'),
                    multiple: false,
                },
                city: {
                    element: this.root.find('[data-select="city"] .js-jelect'),
                    control: this.findControl('city'),
                    multiple: false,
                    changeType: 'departureCity',
                },
                direct: {
                    element: this.root.find('[name="Direct"]'),
                    multiple: false,
                    changeType: 'directFlight',
                },
                charter: {
                    element: this.root.find('[name="Charter"]'),
                    multiple: false,
                    changeType: 'blockFlight',
                },
                program: {
                    element: this.root.find('[data-select="program"] .js-jelect'),
                    control: this.findControl('program'),
                    multiple: false,
                    changeType: 'tourProgram',
                },
                checkinFrom: {
                    element: this.root.find('[name="Checkin.From"]'),
                    multiple: false,
                    changeType: 'checkinDate',
                },
                checkinTo: {
                    element: this.root.find('[name="Checkin.To"]'),
                    multiple: false,
                    changeType: 'checkinDate',
                },
                night: {
                    element: this.root.find('[data-select="night"] .js-jelect'),
                    control: this.findControl('night'),
                    multiple: true,
                    changeType: 'tourDuration',
                },
                fare: {
                    element: this.root.find('[data-select="fare"] .js-jelect'),
                    control: this.findControl('fare'),
                    multiple: true,
                    changeType: 'tourFare',
                },
            };
        }
    }
    App.TourHotelMainFilter = TourHotelMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    class TourHotelProgramGroupSearchViewModel {
        get visibleItems() {
            return this.items.filter(y => !y.isHidden);
        }
        constructor(key, items, showVariants = false) {
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "showVariants", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "currencyCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "sortPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isHidden", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.key = key;
            this.items = items;
            this.showVariants = showVariants;
            this.minPrice = 0;
            this.currencyCode = '';
            this.sortPrice = 0;
            this.isHidden = false;
        }
        update() {
            const { visibleItems } = this;
            if (visibleItems.length > 0) {
                const activeItem = visibleItems.find(v => v.active);
                this.items.forEach(v => (v.active = false));
                if (!this.showVariants) {
                    Enumerable.from(visibleItems).minBy(v => v.minPriceItem.sortPrice).active = true;
                }
                else if (activeItem) {
                    activeItem.active = true;
                }
                else {
                    visibleItems[0].active = true;
                }
            }
            let minPriceItem;
            let maxPriceItem;
            Enumerable.from(visibleItems)
                .forEach(v => {
                if (!minPriceItem || v.minPriceItem.sortPrice < minPriceItem.sortPrice)
                    minPriceItem = v.minPriceItem;
                if (!maxPriceItem || v.minPriceItem.sortPrice > maxPriceItem.sortPrice)
                    maxPriceItem = v.minPriceItem;
            });
            if (!minPriceItem || !maxPriceItem)
                return;
            this.minPrice = minPriceItem.grossPrice;
            this.currencyCode = minPriceItem.currencyCode;
            this.sortPrice = minPriceItem.sortPrice;
            const minPrice = minPriceItem.sortPrice;
            const maxPrice = maxPriceItem.sortPrice;
            const midPrice = maxPrice - (maxPrice - minPrice) / 2;
            Enumerable.from(visibleItems)
                .forEach(v => {
                if (v.minPriceItem.sortPrice <= minPrice)
                    v.priceGroup = 1; // мин.цена
                else if (v.minPriceItem.sortPrice <= midPrice)
                    v.priceGroup = 2; // 2-ой уровень цен
                else
                    v.priceGroup = 0; // все остальное
            });
        }
    }
    App.TourHotelProgramGroupSearchViewModel = TourHotelProgramGroupSearchViewModel;
})(App || (App = {}));
var App;
(function (App) {
    var _TourPlainResult_toursOutput;
    class TourPlainResult extends App.TourResult {
        constructor(options) {
            super(Object.assign({}, options));
            _TourPlainResult_toursOutput.set(this, void 0);
            __classPrivateFieldSet(this, _TourPlainResult_toursOutput, $('.js-tours-output', this.root), "f");
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                this.updateHotFilters(data);
                yield _super.changeDataSource.call(this, data, append);
                // this.#toursOutput.showByClass();
                __classPrivateFieldGet(this, _TourPlainResult_toursOutput, "f").css('min-height', '');
            });
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        updateHotFilters(data) {
        }
        /* eslint-enable @typescript-eslint/no-unused-vars */
        resetDataSource() {
            // this.#toursOutput.hideByClass(); Закомментировал чтобы блок был виден
            __classPrivateFieldGet(this, _TourPlainResult_toursOutput, "f").css('min-height', '300px');
            super.resetDataSource();
        }
    }
    _TourPlainResult_toursOutput = new WeakMap();
    App.TourPlainResult = TourPlainResult;
})(App || (App = {}));
/// <reference path='TourPlainResult.ts' />
var App;
(function (App) {
    var _a, _TourHotelResult_options, _TourHotelResult_currencyConverter, _TourHotelResult_sortCurrencyCode, _TourHotelResult_initHotelGroup, _TourHotelResult_initDateGroup;
    class TourHotelResult extends App.TourPlainResult {
        constructor(options) {
            super(Object.assign({}, options));
            _TourHotelResult_options.set(this, void 0);
            _TourHotelResult_currencyConverter.set(this, void 0);
            _TourHotelResult_sortCurrencyCode.set(this, "RUB" /* KnownCurrencyCode.RUB */);
            __classPrivateFieldSet(this, _TourHotelResult_options, options, "f");
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _TourHotelResult_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _TourHotelResult_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _TourHotelResult_currencyConverter, "f");
                    if (currencyConverter) {
                        if (!append)
                            __classPrivateFieldSet(this, _TourHotelResult_sortCurrencyCode, data[0].items[0].items[0].currencyCode, "f");
                        Enumerable.from(data)
                            .selectMany(v => v.items)
                            .selectMany(v => v.items)
                            .forEach(v => {
                            var _b;
                            v.sortPrice = (_b = currencyConverter.exchange(v.grossPrice, v.currencyCode, __classPrivateFieldGet(this, _TourHotelResult_sortCurrencyCode, "f"))) !== null && _b !== void 0 ? _b : v.grossPrice;
                        });
                    }
                }
                // Merge data
                const result = this.data;
                if (append) {
                    data.forEach(newHotelGroup => {
                        const oldHotelGroup = result.find(v => v.key.key === newHotelGroup.key.key);
                        if (oldHotelGroup) {
                            const updatedGroups = [];
                            newHotelGroup.items.forEach(newDateGroup => {
                                const oldDateGroup = oldHotelGroup.items.find(v => v.key === newDateGroup.key);
                                if (oldDateGroup) {
                                    oldDateGroup.items.push(...newDateGroup.items);
                                    updatedGroups.push(oldDateGroup);
                                }
                                else {
                                    oldHotelGroup.items.push(newDateGroup);
                                    updatedGroups.push(newDateGroup);
                                }
                            });
                            __classPrivateFieldGet(_a, _a, "m", _TourHotelResult_initHotelGroup).call(_a, oldHotelGroup, updatedGroups);
                        }
                        else {
                            result.push(newHotelGroup);
                            __classPrivateFieldGet(_a, _a, "m", _TourHotelResult_initHotelGroup).call(_a, newHotelGroup);
                        }
                    });
                }
                else {
                    App.emptyArray(result);
                    result.push(...data);
                    data.forEach(v => __classPrivateFieldGet(_a, _a, "m", _TourHotelResult_initHotelGroup).call(_a, v));
                }
                yield _super.changeDataSource.call(this, result, append);
            });
        }
        updateHotFilters(data) {
            const oldFilters = this.hotFilter.root.serializeArray();
            const items = Enumerable.from(data)
                .selectMany(v => v.items)
                .selectMany(v => v.items);
            const isAviaYesControl = $('[name="IsAviaYes"]', this.hotFilter.root).parents('.filter-block');
            const showIsAviaYes = isAviaYesControl.length > 0
                && items.any(v => v.aviaQuota !== App.QuotaStatus.Yes && v.aviaQuota !== App.QuotaStatus.Few)
                && items.any(v => v.aviaQuota === App.QuotaStatus.Yes || v.aviaQuota === App.QuotaStatus.Few);
            isAviaYesControl.toggle(showIsAviaYes);
            const isAviaRequestControl = $('[name="IsAviaRequest"]', this.hotFilter.root).parents('.filter-block');
            const showIsAviaRequest = isAviaRequestControl.length > 0
                && items.any(v => v.aviaQuota !== App.QuotaStatus.Request)
                && items.any(v => v.aviaQuota === App.QuotaStatus.Request);
            isAviaRequestControl.toggle(showIsAviaRequest);
            const isDynamicAviaControl = $('[name="IsDynamicAvia"]', this.hotFilter.root).parents('.filter-block');
            const showIsDynamicAvia = isDynamicAviaControl.length > 0
                && items.any(v => !v.dynamicFlight)
                && items.any(v => v.dynamicFlight);
            isDynamicAviaControl.toggle(showIsDynamicAvia);
            const hasHotelControl = $('[name="HasHotel"]', this.hotFilter.root).parents('.filter-block');
            const showHasHotel = hasHotelControl.length > 0
                && items.any(v => v.hotelQuota !== App.QuotaStatus.Yes && v.hotelQuota !== App.QuotaStatus.Few)
                && items.any(v => v.hotelQuota === App.QuotaStatus.Yes || v.hotelQuota === App.QuotaStatus.Few);
            hasHotelControl.toggle(showHasHotel);
            const hasTransferControl = $('[name="HasTransfer"]', this.hotFilter.root).parents('.filter-block');
            const showHasTransfer = hasTransferControl.length > 0
                && items.any(v => !v.includesTransfer)
                && items.any(v => v.includesTransfer);
            hasTransferControl.toggle(showHasTransfer);
            const hasTreatmentControl = $('[name="HasTreatment"]', this.hotFilter.root).parents('.filter-block');
            const showHasTreatment = hasTreatmentControl.length > 0 && items.any(v => !v.hasTreatment) && items.any(v => v.hasTreatment);
            hasTreatmentControl.toggle(showHasTreatment);
            const fareControl = this.hotFilter.findControl('Fare');
            let showFare = false;
            if (fareControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === fareControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const fares = items
                    .selectMany(v => v.tourFares)
                    .distinct(v => v.key)
                    .orderBy(v => v.key)
                    .select(v => ({ value: `${v.key}`, text: v.name, selected: oldValues.some(x => x === v.code) }))
                    .toArray();
                showFare = fares.length > 1;
                fareControl.replaceOptions(fares, true);
                fareControl.root.toggle(showFare);
            }
            const roomTypeControl = this.hotFilter.findControl('RoomType');
            let showRoomType = false;
            if (roomTypeControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === roomTypeControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .selectMany(v => v.hotel.roomGroups)
                    .distinct()
                    .join(Enumerable.from(__classPrivateFieldGet(this, _TourHotelResult_options, "f").dynamicRoomTypes), v => v, v => v.code, (_, v2) => v2)
                    .orderBy(v => v.sortOrder)
                    .thenBy(v => v.name)
                    .select(v => ({ value: v.code, text: v.name, selected: oldValues.some(x => x === v.code) }))
                    .toArray();
                showRoomType = options.length > 1;
                roomTypeControl.replaceOptions(options, true);
                roomTypeControl.root.toggle(showRoomType);
            }
            const boardTypeControl = this.hotFilter.findControl('BoardType');
            let showBoardType = false;
            if (boardTypeControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === boardTypeControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .select(v => v.hotel.boardGroup)
                    .distinct()
                    .join(Enumerable.from(__classPrivateFieldGet(this, _TourHotelResult_options, "f").dynamicBoardTypes), v => v, v => v.code, (_, v2) => v2)
                    .orderBy(v => v.sortOrder)
                    .thenBy(v => v.name)
                    .select(v => ({ value: v.code, text: v.name, selected: oldValues.some(x => x === v.code) }))
                    .toArray();
                showBoardType = options.length > 1;
                boardTypeControl.replaceOptions(options, true);
                boardTypeControl.root.toggle(showBoardType);
            }
            const providerControl = this.hotFilter.findControl('Provider');
            let showProvider = false;
            if (providerControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === providerControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .where(v => v.dynamicHotelProvider != null)
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    .select(v => v.dynamicHotelProvider)
                    .distinct(v => v.key)
                    .orderBy(v => v.name)
                    .select(v => ({ value: `${v.key}`, text: v.name, selected: oldValues.some(x => x === `${v.key}`) }))
                    .toArray();
                showProvider = options.length > 1;
                providerControl.replaceOptions(options, true);
                providerControl.root.toggle(showProvider);
            }
            const offerSourceControl = this.hotFilter.findControl('OfferSource');
            let showOfferSource = false;
            if (offerSourceControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === offerSourceControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .where(v => v.dynamicHotelOfferSource != null)
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    .select(v => v.dynamicHotelOfferSource)
                    .distinct(v => v.key)
                    .orderBy(v => v.name)
                    .select(v => ({ value: `${v.key}`, text: v.name, selected: oldValues.some(x => x === `${v.key}`) }))
                    .toArray();
                showOfferSource = options.length > 1;
                offerSourceControl.replaceOptions(options, true);
                offerSourceControl.root.toggle(showOfferSource);
            }
            const showFilters = showIsAviaYes || showIsAviaRequest || showIsDynamicAvia
                || showHasHotel || showHasTransfer || showHasTreatment
                || showFare || showRoomType || showBoardType || showProvider || showOfferSource;
            $('.js-filter-body', this.hotFilter.root).toggle(showFilters);
        }
        applyFilters(items) {
            if (this.filtering.items.length <= 0)
                return items;
            let predicate = () => true;
            let aviaPredicate = () => false;
            let hasAviaPredicate = false;
            this.filtering.items
                .filter(v => v.values.length > 0)
                .forEach(filter => {
                switch (filter.name.toLowerCase()) {
                    case 'isaviayes': {
                        const tempPredicate = aviaPredicate;
                        if (filter.values[0] === 'true') {
                            aviaPredicate = (v) => tempPredicate(v)
                                || (v.aviaQuota === App.QuotaStatus.Yes || v.aviaQuota === App.QuotaStatus.Few);
                            hasAviaPredicate = true;
                        }
                        break;
                    }
                    case 'isaviarequest': {
                        const tempPredicate = aviaPredicate;
                        if (filter.values[0] === 'true') {
                            aviaPredicate = (v) => tempPredicate(v) || v.aviaQuota === App.QuotaStatus.Request;
                            hasAviaPredicate = true;
                        }
                        break;
                    }
                    case 'isdynamicavia': {
                        const tempPredicate = aviaPredicate;
                        if (filter.values[0] === 'true') {
                            aviaPredicate = (v) => tempPredicate(v) || v.dynamicFlight;
                            hasAviaPredicate = true;
                        }
                        break;
                    }
                    case 'hashotel': {
                        const tempPredicate = predicate;
                        if (filter.values[0] === 'true') {
                            predicate = (v) => tempPredicate(v)
                                && (v.hotelQuota === App.QuotaStatus.Yes || v.hotelQuota === App.QuotaStatus.Few);
                        }
                        break;
                    }
                    case 'hastransfer': {
                        const tempPredicate = predicate;
                        if (filter.values[0] === 'true')
                            predicate = (v) => tempPredicate(v) && v.includesTransfer;
                        break;
                    }
                    case 'hastreatment': {
                        const tempPredicate = predicate;
                        if (filter.values[0] === 'true')
                            predicate = (v) => tempPredicate(v) && v.hasTreatment;
                        break;
                    }
                    case 'fare': {
                        const tempPredicate = predicate;
                        predicate = (v) => tempPredicate(v)
                            && v.tourFares.some(x => filter.values.some(y => y === x.key));
                        break;
                    }
                    case 'roomtype': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && filter.values.some(y => x.hotel.roomGroups.some(a => a === y));
                        break;
                    }
                    case 'boardtype': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && filter.values.some(y => x.hotel.boardGroup === y);
                        break;
                    }
                    case 'provider': {
                        const tempPredicate = predicate;
                        const numValues = filter.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.dynamicHotelProvider && y === x.dynamicHotelProvider.key);
                        break;
                    }
                    case 'offersource': {
                        const tempPredicate = predicate;
                        const numValues = filter.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.dynamicHotelOfferSource && y === x.dynamicHotelOfferSource.key);
                        break;
                    }
                    default:
                        break;
                }
            });
            if (hasAviaPredicate) {
                const haPredicate = predicate;
                predicate = (v) => haPredicate(v) && aviaPredicate(v);
            }
            // Update 'isHidden' field in full hierarchy and recalc dynamic data.
            for (let i = 0; i < items.length; i++) {
                const hotelGroup = items[i];
                let hotelGroupHidden = true;
                for (let j = 0; j < hotelGroup.items.length; j++) {
                    const dateGroup = hotelGroup.items[j];
                    let dateGroupHidden = true;
                    for (let k = 0; k < dateGroup.items.length; k++) {
                        const item = dateGroup.items[k];
                        item.isHidden = !predicate(item);
                        if (!item.isHidden)
                            dateGroupHidden = false;
                    }
                    dateGroup.isHidden = dateGroupHidden;
                    if (!dateGroup.isHidden)
                        hotelGroupHidden = false;
                    dateGroup.update();
                }
                hotelGroup.isHidden = hotelGroupHidden;
                hotelGroup.update();
            }
            return items.filter(v => !v.isHidden);
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case App.TourSortFields.Price: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.sortPrice);
                    else
                        result = Enumerable.from(items).orderBy(v => v.sortPrice);
                    return result
                        .thenBy(v => v.key)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .reverse()
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .toArray();
                }
            }
        }
        findItem(key) {
            return Enumerable.from(this.data)
                .selectMany(v => v.items)
                .selectMany(v => v.items)
                .firstOrDefault(v => v.key === key);
        }
        findOfferByDynamicHotel(key) {
            return Enumerable.from(this.data)
                .selectMany(v => v.items)
                .selectMany(v => v.items)
                .firstOrDefault(v => v.dynamicHotelServiceKey === key);
        }
        findHotelGroup(hotelKey) {
            return this.data.find(v => v.key.key === hotelKey);
        }
        static findDateGroup(hotelGroup, date) {
            return hotelGroup.items.find(v => v.key === date);
        }
    }
    _a = TourHotelResult, _TourHotelResult_options = new WeakMap(), _TourHotelResult_currencyConverter = new WeakMap(), _TourHotelResult_sortCurrencyCode = new WeakMap(), _TourHotelResult_initHotelGroup = function _TourHotelResult_initHotelGroup(group, childGroups) {
        group.items.sort((a, b) => a.key.localeCompare(b.key));
        if (childGroups)
            childGroups.forEach(v => __classPrivateFieldGet(_a, _a, "m", _TourHotelResult_initDateGroup).call(_a, v));
        else
            group.items.forEach(v => __classPrivateFieldGet(_a, _a, "m", _TourHotelResult_initDateGroup).call(_a, v));
        group.update();
    }, _TourHotelResult_initDateGroup = function _TourHotelResult_initDateGroup(group) {
        group.items.sort((a, b) => a.sortPrice - b.sortPrice);
        group.update();
    };
    App.TourHotelResult = TourHotelResult;
})(App || (App = {}));
/// <reference path='TourHotelResult.ts' />
var App;
(function (App) {
    class TourHotelResultMobile extends App.TourHotelResult {
        constructor(options) {
            super(Object.assign(Object.assign({}, options), { tableTemplate: App.templates.Tour.HotelTableOutput }));
        }
        updateHotFilters(data) {
            const hotFilter = this.hotFilter;
            if (hotFilter === null || hotFilter === void 0 ? void 0 : hotFilter.refreshHotelHotFilters)
                hotFilter.refreshHotelHotFilters(data);
        }
        // карта в выдаче на мобильной версии не используется
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        initMapBlock(data, addBlock) {
            // no-op
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        showMapView(event) {
            // no-op
        }
    }
    App.TourHotelResultMobile = TourHotelResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    class TourPlainSearchViewModel {
        // #endregion
        constructor() {
            // #region Original
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tourPriceKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "url", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "nights", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "beginDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "endDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "grossPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "netPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "price", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "currencyCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tourFares", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tourTypeKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "markerPac", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "markerGold", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "aviaQuota", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "hotelQuota", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "includesTransfer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "hasTreatment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isAuthenticated", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicHotel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicFlight", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "nonCommissionTickets", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "excursionCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "hasOptionalTransfers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #endregion
            // #region Additional
            Object.defineProperty(this, "sortPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "bannerIncutId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "bannerIncutUrl", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.sortPrice = 0;
            this.bannerIncutId = null;
            this.bannerIncutUrl = null;
        }
    }
    App.TourPlainSearchViewModel = TourPlainSearchViewModel;
})(App || (App = {}));
/// <reference path='TourPlainSearchViewModel.ts' />
var App;
(function (App) {
    class TourHotelSearchViewModel extends App.TourPlainSearchViewModel {
        get cancellationPolicyModel() {
            var _a;
            if (!this.cancellationPolicy)
                return undefined;
            return new App.VariantCancellationViewModel((_a = this.dynamicHotelServiceKey) !== null && _a !== void 0 ? _a : '', this.cancellationPolicy);
        }
        // #endregion
        constructor(source) {
            super();
            // #region Original
            Object.defineProperty(this, "hotel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tourPacketName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicHotelServiceKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicHotelProvider", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicHotelOfferSource", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "promotions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cancellationPolicy", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "freeCancellation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "transportType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #endregion
            // #region Additional
            Object.defineProperty(this, "isHidden", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.assign(this, source);
            this.isHidden = false;
        }
    }
    App.TourHotelSearchViewModel = TourHotelSearchViewModel;
})(App || (App = {}));
var App;
(function (App) {
    class TourProgramDateGroupSearchViewModel {
        get minPrice() {
            return this.minPriceItem.grossPrice;
        }
        get currencyCode() {
            return this.minPriceItem.currencyCode;
        }
        get visibleItems() {
            return this.items.filter(y => !y.isHidden);
        }
        constructor(key, items) {
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "active", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minPriceItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "priceGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isHidden", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.key = key;
            this.items = items;
            this.active = false;
            [this.minPriceItem] = items;
            this.priceGroup = 0;
            this.isHidden = false;
        }
        update() {
            this.minPriceItem = Enumerable.from(this.visibleItems)
                .defaultIfEmpty(this.items[0])
                .minBy(v => v.sortPrice);
        }
    }
    App.TourProgramDateGroupSearchViewModel = TourProgramDateGroupSearchViewModel;
})(App || (App = {}));
/// <reference path='TourHotFilter.Mobile.ts' />
var App;
(function (App) {
    var _TourProgramHotFilterMobile_instances, _TourProgramHotFilterMobile_options, _TourProgramHotFilterMobile_toggleAvailability, _TourProgramHotFilterMobile_getFacilityOptions, _TourProgramHotFilterMobile_getFareOptions, _TourProgramHotFilterMobile_getRoomTypeOptions, _TourProgramHotFilterMobile_getBoardTypeOptions, _TourProgramHotFilterMobile_getCityAreaOptions, _TourProgramHotFilterMobile_getResortOptions, _TourProgramHotFilterMobile_getProviderOptions, _TourProgramHotFilterMobile_getOfferSourceOptions, _TourProgramHotFilterMobile_toListOptions;
    class TourProgramHotFilterMobile extends App.TourHotFilterMobile {
        constructor(options) {
            var _a;
            super({ root: '.js-tour-program-hot-filter', featureSortOrder: [] });
            _TourProgramHotFilterMobile_instances.add(this);
            _TourProgramHotFilterMobile_options.set(this, void 0);
            __classPrivateFieldSet(this, _TourProgramHotFilterMobile_options, (_a = options === null || options === void 0 ? void 0 : options.resultOptions) !== null && _a !== void 0 ? _a : { hasDynamicHotel: false, hotelBoards: [], dynamicRoomTypes: [], dynamicBoardTypes: [], restTypeKey: 0, countryKey: 0 }, "f");
        }
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('tour/programHotFilterFoundTitle', {
                groupCount: data.length,
                count: Enumerable.from(data)
                    .selectMany(v => v.visibleItems)
                    .select(v => v.visibleItems.length)
                    .sum(),
            }));
        }
        /**
         * Обновление опций и видимости контролов хот-фильтра по результатам поиска.
         * @param data группы отелей с вариантами (результаты поиска программы).
         */
        refreshProgramHotFilters(data) {
            const items = [];
            (data !== null && data !== void 0 ? data : []).forEach(hotelGroup => hotelGroup.items.forEach(dateGroup => items.push(...dateGroup.items)));
            if (items.length <= 0) {
                this.toggleFiltersButton(false);
                return;
            }
            // название отеля показывается, только если в результатах есть разные отели
            const hotelNames = new Set();
            items.forEach(v => v.hotels.forEach(h => hotelNames.add(h.name)));
            const showAccommodationName = hotelNames.size > 1;
            this.toggleControl('accommodationname', showAccommodationName);
            // наличие мест на авиаперелет / отель и т.д. - показываются, если есть обе ситуации
            const showIsAviaYes = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'isaviayes', items.some(v => !v.dynamicFlight && v.aviaQuota === App.QuotaStatus.Yes), items.some(v => v.dynamicFlight || v.aviaQuota === App.QuotaStatus.Request));
            const showIsAviaRequest = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'isaviarequest', items.some(v => !v.dynamicFlight && v.aviaQuota === App.QuotaStatus.Request), items.some(v => v.dynamicFlight || v.aviaQuota === App.QuotaStatus.Yes));
            const showIsDynamicAvia = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'isdynamicavia', items.some(v => v.dynamicFlight), items.some(v => !v.dynamicFlight && (v.aviaQuota === App.QuotaStatus.Yes || v.aviaQuota === App.QuotaStatus.Request)));
            const showHasHotel = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'hashotel', items.some(v => v.hotelQuota !== App.QuotaStatus.Yes && v.hotelQuota !== App.QuotaStatus.Few), items.some(v => v.hotelQuota === App.QuotaStatus.Yes || v.hotelQuota === App.QuotaStatus.Few));
            const showFreeCancellation = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'freecancellation', items.some(v => !v.freeCancellation), items.some(v => v.freeCancellation));
            const showHasTransfer = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'hastransfer', items.some(v => !v.includesTransfer), items.some(v => v.includesTransfer));
            const showHasTreatment = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'hastreatment', items.some(v => !v.hasTreatment), items.some(v => v.hasTreatment));
            const showPacRecommends = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'pacrecommends', items.some(v => v.hotels.some(h => !h.markerPac)), items.some(v => v.hotels.some(h => h.markerPac)));
            const showGoldCollection = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toggleAvailability).call(this, 'goldcollection', items.some(v => v.hotels.some(h => !h.markerGold)), items.some(v => v.hotels.some(h => h.markerGold)));
            const showFacility = this.refreshSelectList('facility', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getFacilityOptions).call(this, items));
            const showFare = this.refreshSelectList('fare', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getFareOptions).call(this, items));
            const showRoomType = this.refreshSelectList('roomtype', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getRoomTypeOptions).call(this, items));
            const showBoardType = this.refreshSelectList('boardtype', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getBoardTypeOptions).call(this, items));
            const showCityArea = this.refreshSelectList('cityarea', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getCityAreaOptions).call(this, items));
            const showResort = this.refreshSelectList('resort', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getResortOptions).call(this, items));
            const showProvider = this.refreshSelectList('provider', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getProviderOptions).call(this, items));
            const showOfferSource = this.refreshSelectList('offersource', __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_getOfferSourceOptions).call(this, items));
            // если нет ни одного актуального фильтра - скрываем кнопку "Фильтры"
            const showFilters = showAccommodationName
                || showIsAviaYes
                || showIsAviaRequest
                || showIsDynamicAvia
                || showHasHotel
                || showFreeCancellation
                || showHasTransfer
                || showHasTreatment
                || showPacRecommends
                || showGoldCollection
                || showFacility
                || showFare
                || showRoomType
                || showBoardType
                || showCityArea
                || showResort
                || showProvider
                || showOfferSource;
            this.toggleFiltersButton(showFilters);
        }
    }
    _TourProgramHotFilterMobile_options = new WeakMap(), _TourProgramHotFilterMobile_instances = new WeakSet(), _TourProgramHotFilterMobile_toggleAvailability = function _TourProgramHotFilterMobile_toggleAvailability(key, hasNotMatched, hasMatched) {
        return this.toggleControl(key, hasNotMatched && hasMatched);
    }, _TourProgramHotFilterMobile_getFacilityOptions = function _TourProgramHotFilterMobile_getFacilityOptions(items) {
        const selected = this.getSelectedValues('facility');
        const map = new Map();
        items.forEach(v => v.hotels.forEach(h => { var _a; return ((_a = h.features) !== null && _a !== void 0 ? _a : []).forEach(f => map.set(`${f.key}`, f.name)); }));
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_getFareOptions = function _TourProgramHotFilterMobile_getFareOptions(items) {
        const selected = this.getSelectedValues('fare');
        const map = new Map();
        items.forEach(v => v.tourFares.forEach(f => map.set(`${f.key}`, f.name)));
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_getRoomTypeOptions = function _TourProgramHotFilterMobile_getRoomTypeOptions(items) {
        const selected = this.getSelectedValues('roomtype');
        const map = new Map();
        items.forEach(v => v.hotels.forEach(h => {
            var _a;
            if (__classPrivateFieldGet(this, _TourProgramHotFilterMobile_options, "f").hasDynamicHotel) {
                ((_a = h.roomGroups) !== null && _a !== void 0 ? _a : []).forEach(code => {
                    var _a, _b;
                    const roomType = ((_a = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_options, "f").dynamicRoomTypes) !== null && _a !== void 0 ? _a : []).find(r => r.code === code);
                    map.set(code, (_b = roomType === null || roomType === void 0 ? void 0 : roomType.name) !== null && _b !== void 0 ? _b : code);
                });
            }
            else if (h.roomName) {
                map.set(h.roomName, h.roomName);
            }
        }));
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_getBoardTypeOptions = function _TourProgramHotFilterMobile_getBoardTypeOptions(items) {
        var _a, _b;
        const selected = this.getSelectedValues('boardtype');
        const map = new Map();
        const boardTypes = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_options, "f").hasDynamicHotel
            ? ((_a = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_options, "f").dynamicBoardTypes) !== null && _a !== void 0 ? _a : [])
            : ((_b = __classPrivateFieldGet(this, _TourProgramHotFilterMobile_options, "f").hotelBoards) !== null && _b !== void 0 ? _b : []);
        items.forEach(v => v.hotels.forEach(h => {
            var _a;
            if (!h.boardGroup)
                return;
            const boardType = boardTypes.find(b => b.code === h.boardGroup);
            map.set(h.boardGroup, (_a = boardType === null || boardType === void 0 ? void 0 : boardType.name) !== null && _a !== void 0 ? _a : h.boardGroup);
        }));
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_getCityAreaOptions = function _TourProgramHotFilterMobile_getCityAreaOptions(items) {
        const selected = this.getSelectedValues('cityarea');
        const map = new Map();
        items.forEach(v => v.hotels.forEach(h => { var _a; return ((_a = h.cityAreas) !== null && _a !== void 0 ? _a : []).forEach(a => map.set(`${a.key}`, a.value)); }));
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_getResortOptions = function _TourProgramHotFilterMobile_getResortOptions(items) {
        const selected = this.getSelectedValues('resort');
        const map = new Map();
        items.forEach(v => v.hotels.forEach(h => {
            if (!h.isFake)
                map.set(`${h.resortKey}`, h.resortName);
        }));
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_getProviderOptions = function _TourProgramHotFilterMobile_getProviderOptions(items) {
        const selected = this.getSelectedValues('provider');
        const map = new Map();
        items.forEach(v => {
            if (v.dynamicHotelProvider != null)
                map.set(`${v.dynamicHotelProvider.key}`, v.dynamicHotelProvider.name);
        });
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_getOfferSourceOptions = function _TourProgramHotFilterMobile_getOfferSourceOptions(items) {
        const selected = this.getSelectedValues('offersource');
        const map = new Map();
        items.forEach(v => {
            if (v.dynamicHotelOfferSource != null)
                map.set(`${v.dynamicHotelOfferSource.key}`, v.dynamicHotelOfferSource.name);
        });
        return __classPrivateFieldGet(this, _TourProgramHotFilterMobile_instances, "m", _TourProgramHotFilterMobile_toListOptions).call(this, [...map], selected);
    }, _TourProgramHotFilterMobile_toListOptions = function _TourProgramHotFilterMobile_toListOptions(entries, selected) {
        return entries
            .sort((a, b) => a[1].localeCompare(b[1]))
            .map(([value, text]) => ({ value, text, selected: selected.indexOf(value) >= 0 }));
    };
    App.TourProgramHotFilterMobile = TourProgramHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class TourProgramHotFilter extends App.TourHotFilter {
        updateFoundCount(data) {
            this.filterFoundTitle.html(App.formatMessage('tour/programHotFilterFoundTitle', {
                groupCount: data.length,
                count: Enumerable.from(data)
                    .selectMany(v => v.visibleItems)
                    .select(v => v.visibleItems.length)
                    .sum(),
            }));
        }
    }
    App.TourProgramHotFilter = TourProgramHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    class TourProgramHotelGroupSearchViewModel {
        get visibleItems() {
            return this.items.filter(y => !y.isHidden);
        }
        constructor(key, items, showVariants = false) {
            Object.defineProperty(this, "key", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "items", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "showVariants", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "currencyCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "sortPrice", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isHidden", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.key = key;
            this.items = items;
            this.showVariants = showVariants;
            this.minPrice = 0;
            this.currencyCode = '';
            this.sortPrice = 0;
            this.isHidden = false;
        }
        update() {
            const { visibleItems } = this;
            if (visibleItems.length > 0) {
                const activeItem = visibleItems.find(v => v.active);
                this.items.forEach(v => (v.active = false));
                if (!this.showVariants) {
                    Enumerable.from(visibleItems).minBy(v => v.minPriceItem.sortPrice).active = true;
                }
                else if (activeItem) {
                    activeItem.active = true;
                }
                else {
                    visibleItems[0].active = true;
                }
            }
            let minPriceItem;
            let maxPriceItem;
            Enumerable.from(visibleItems)
                .forEach(v => {
                if (!minPriceItem || v.minPriceItem.sortPrice < minPriceItem.sortPrice)
                    minPriceItem = v.minPriceItem;
                if (!maxPriceItem || v.minPriceItem.sortPrice > maxPriceItem.sortPrice)
                    maxPriceItem = v.minPriceItem;
            });
            if (!minPriceItem || !maxPriceItem)
                return;
            this.minPrice = minPriceItem.grossPrice;
            this.currencyCode = minPriceItem.currencyCode;
            this.sortPrice = minPriceItem.sortPrice;
            const minPrice = minPriceItem.sortPrice;
            const maxPrice = maxPriceItem.sortPrice;
            const midPrice = maxPrice - (maxPrice - minPrice) / 2;
            Enumerable.from(visibleItems)
                .forEach(v => {
                if (v.minPriceItem.sortPrice <= minPrice)
                    v.priceGroup = 1; // мин.цена
                else if (v.minPriceItem.sortPrice <= midPrice)
                    v.priceGroup = 2; // 2-ой уровень цен
                else
                    v.priceGroup = 0; // все остальное
            });
        }
    }
    App.TourProgramHotelGroupSearchViewModel = TourProgramHotelGroupSearchViewModel;
})(App || (App = {}));
/// <reference path='../../common/components/MainFilter.Mobile.ts' />
/// <reference path='TourMainFilter.ts' />
var App;
(function (App) {
    var _TourProgramMainFilterMobile_instances, _a, _TourProgramMainFilterMobile_options, _TourProgramMainFilterMobile_popup, _TourProgramMainFilterMobile_responseValidator, _TourProgramMainFilterMobile_abortController, _TourProgramMainFilterMobile_suppressChanges, _TourProgramMainFilterMobile_changeTypes, _TourProgramMainFilterMobile_defaultOptionTexts, _TourProgramMainFilterMobile_onFilterChanged, _TourProgramMainFilterMobile_getFieldName, _TourProgramMainFilterMobile_filterChange, _TourProgramMainFilterMobile_getCityValue, _TourProgramMainFilterMobile_getSelectValues, _TourProgramMainFilterMobile_getDateValue, _TourProgramMainFilterMobile_toCamelCase, _TourProgramMainFilterMobile_capitalize, _TourProgramMainFilterMobile_applyFiltersData, _TourProgramMainFilterMobile_updateSelectList, _TourProgramMainFilterMobile_flattenOptions, _TourProgramMainFilterMobile_searchFieldOrder;
    class TourProgramMainFilterMobile extends App.MainFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-tour-program-filter', customFilters: {
                    root: '.js-tour-program-filter',
                    clickSelector: '.js-tour-program-filters-open',
                    modalKey: 'tour-program-filters-modal',
                    contentSelector: '#js-tour-program-filters-content',
                    withFilters: true,
                    applyTitle: 'Подобрать',
                    title: 'Параметры поиска',
                }, onFilterChanged: filterName => __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_onFilterChanged).call(this, filterName) }, options));
            _TourProgramMainFilterMobile_instances.add(this);
            _TourProgramMainFilterMobile_options.set(this, void 0);
            _TourProgramMainFilterMobile_popup.set(this, void 0);
            _TourProgramMainFilterMobile_responseValidator.set(this, void 0);
            _TourProgramMainFilterMobile_abortController.set(this, void 0);
            _TourProgramMainFilterMobile_suppressChanges.set(this, true);
            __classPrivateFieldSet(this, _TourProgramMainFilterMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TourProgramMainFilterMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _TourProgramMainFilterMobile_responseValidator, new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            __classPrivateFieldSet(this, _TourProgramMainFilterMobile_suppressChanges, false, "f");
        }
        buildSearchData() {
            const values = {};
            // программа тура и номер заказа (контекста) - hidden-поля формы (не контролы)
            for (const name of ['Program', 'context']) {
                const value = this.root.find(`[name="${name}"]`).valString();
                if (value)
                    values[name] = [value];
            }
            this.filters.serializeArray()
                .filter(v => v.value != null && v.value !== '')
                .forEach(v => {
                // категория отеля сериализуется мобильным контролом как "Category=1,5",
                // а сервер ожидает "Category.From=1&Category.To=5"
                if (v.name === 'Category') {
                    const [from, to] = v.value.split(',');
                    if (from)
                        values['Category.From'] = [from];
                    if (to)
                        values['Category.To'] = [to];
                    return;
                }
                // количество детей десктоп не отправляет (передаются только возраста Tourist.ChildAges[i])
                if (v.name === 'Tourist.ChildCount')
                    return;
                values[v.name] = v.value.split(',');
            });
            // для программы с динамическим отелем поиск выполняется по одной дате заезда
            if (__classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").hasDynamicHotel && values['Checkin.From'])
                values['Checkin.To'] = values['Checkin.From'];
            // сборка результата в порядке полей десктопной формы
            const data = { changes: [...__classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").changes] };
            const orderIndex = (name) => {
                // возраста детей: Tourist.ChildAges[0], Tourist.ChildAges[1], ...
                const baseName = name.replace(/\[\d+\]$/, '');
                const index = __classPrivateFieldGet(_a, _a, "f", _TourProgramMainFilterMobile_searchFieldOrder).indexOf(baseName);
                return index >= 0 ? index : __classPrivateFieldGet(_a, _a, "f", _TourProgramMainFilterMobile_searchFieldOrder).length;
            };
            Object.keys(values)
                .map((name, position) => ({ name, position }))
                .sort((a, b) => (orderIndex(a.name) - orderIndex(b.name)) || (a.position - b.position))
                .forEach(({ name }) => (data[name] = values[name]));
            return data;
        }
        search(manualSearch = true) {
            this.root.trigger("filter:search" /* Events.FilterSearch */, [this.buildSearchData(), manualSearch]);
        }
        /**
         * Сброс фильтра (кнопка "Очистить фильтр")
         */
        reset() {
            __classPrivateFieldSet(this, _TourProgramMainFilterMobile_suppressChanges, true, "f");
            try {
                super.reset();
            }
            finally {
                __classPrivateFieldSet(this, _TourProgramMainFilterMobile_suppressChanges, false, "f");
            }
            __classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").changes.length = 0;
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_filterChange).call(this, null); }))();
        }
    }
    _a = TourProgramMainFilterMobile, _TourProgramMainFilterMobile_options = new WeakMap(), _TourProgramMainFilterMobile_popup = new WeakMap(), _TourProgramMainFilterMobile_responseValidator = new WeakMap(), _TourProgramMainFilterMobile_abortController = new WeakMap(), _TourProgramMainFilterMobile_suppressChanges = new WeakMap(), _TourProgramMainFilterMobile_instances = new WeakSet(), _TourProgramMainFilterMobile_onFilterChanged = function _TourProgramMainFilterMobile_onFilterChanged(filterName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _TourProgramMainFilterMobile_suppressChanges, "f"))
                return;
            const changeType = __classPrivateFieldGet(_a, _a, "f", _TourProgramMainFilterMobile_changeTypes)[filterName];
            if (!changeType)
                return;
            // Запоминаем измененный параметр (имя поля формы без суффикса, в нижнем регистре).
            const fieldName = __classPrivateFieldGet(_a, _a, "m", _TourProgramMainFilterMobile_getFieldName).call(_a, filterName);
            if (fieldName && __classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").changes.indexOf(fieldName) < 0)
                __classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").changes.push(fieldName);
            yield __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_filterChange).call(this, changeType);
        });
    }, _TourProgramMainFilterMobile_getFieldName = function _TourProgramMainFilterMobile_getFieldName(filterName) {
        const dotPos = filterName.indexOf('.');
        const name = dotPos >= 0 ? filterName.substring(0, dotPos) : filterName;
        return name.toLowerCase();
    }, _TourProgramMainFilterMobile_filterChange = function _TourProgramMainFilterMobile_filterChange(changeType) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const changes = [...__classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").changes];
            const rqData = {
                changes,
                changeType: changeType !== null && changeType !== void 0 ? changeType : 'none',
            };
            const program = this.root.find('[name="Program"]').valString();
            if (program)
                rqData.program = program;
            const city = __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_getCityValue).call(this);
            if (city != null)
                rqData.city = city;
            rqData.direct = this.filters.getControlToggle('Direct') ? 'true' : 'false';
            rqData.charter = this.filters.getControlToggle('Charter') ? 'true' : 'false';
            for (const name of ['Resort', 'Night', 'Facility', 'Chain', 'Hotel']) {
                const values = __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_getSelectValues).call(this, name);
                if (values.length > 0)
                    rqData[__classPrivateFieldGet(_a, _a, "m", _TourProgramMainFilterMobile_toCamelCase).call(_a, name)] = values;
            }
            const checkinFrom = __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_getDateValue).call(this, 'Checkin.From');
            const checkinTo = __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_getDateValue).call(this, 'Checkin.To');
            if (checkinFrom != null)
                rqData.checkinFrom = checkinFrom;
            if (checkinTo != null)
                rqData.checkinTo = checkinTo;
            const categoryFrom = this.filters.getControlValue('Category.From');
            const categoryTo = this.filters.getControlValue('Category.To');
            if (categoryFrom != null)
                rqData.categoryFrom = categoryFrom.toString();
            if (categoryTo != null)
                rqData.categoryTo = categoryTo.toString();
            (_b = __classPrivateFieldGet(this, _TourProgramMainFilterMobile_abortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            __classPrivateFieldSet(this, _TourProgramMainFilterMobile_abortController, new AbortController(), "f");
            this.submitButton.prop('disabled', true);
            const popupGroup = __classPrivateFieldGet(this, _TourProgramMainFilterMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Tour.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").urls.filters, { body: App.createUrlSearchParams(rqData), signal: __classPrivateFieldGet(this, _TourProgramMainFilterMobile_abortController, "f").signal });
                if (!__classPrivateFieldGet(this, _TourProgramMainFilterMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_applyFiltersData).call(this, response.data);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourProgramMainFilterMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _TourProgramMainFilterMobile_popup, "f").hide(popupGroup);
                this.submitButton.prop('disabled', false);
            }
        });
    }, _TourProgramMainFilterMobile_getCityValue = function _TourProgramMainFilterMobile_getCityValue() {
        const value = this.filters.getControlValueString('City');
        return value ? value : null;
    }, _TourProgramMainFilterMobile_getSelectValues = function _TourProgramMainFilterMobile_getSelectValues(name) {
        return this.filters.getControlValueStringArr(name)
            .filter(v => v != null && v !== '');
    }, _TourProgramMainFilterMobile_getDateValue = function _TourProgramMainFilterMobile_getDateValue(name) {
        const control = this.filters.findControl(name);
        const date = control === null || control === void 0 ? void 0 : control.getValue();
        if (!date)
            return null;
        return App.formatDate(date, 'shortDate');
    }, _TourProgramMainFilterMobile_toCamelCase = function _TourProgramMainFilterMobile_toCamelCase(name) {
        return name.charAt(0).toLowerCase() + name.slice(1);
    }, _TourProgramMainFilterMobile_capitalize = function _TourProgramMainFilterMobile_capitalize(name) {
        return name.charAt(0).toUpperCase() + name.slice(1);
    }, _TourProgramMainFilterMobile_applyFiltersData = function _TourProgramMainFilterMobile_applyFiltersData(data) {
        __classPrivateFieldSet(this, _TourProgramMainFilterMobile_suppressChanges, true, "f");
        try {
            for (const key of Object.keys(data)) {
                if (data[key] == null)
                    continue;
                switch (key) {
                    case 'charter': {
                        const charter = data.charter;
                        const control = this.filters.findControl('Charter');
                        if (control && charter.length === 1)
                            control.setValue(charter[0] === 'true');
                        break;
                    }
                    case 'checkin': {
                        const checkin = data.checkin;
                        const from = this.filters.findControl('Checkin.From');
                        const to = this.filters.findControl('Checkin.To');
                        if (from && from.getValue() != null && checkin.length >= 1)
                            from.setValue(App.parseIsoDate(checkin[0]));
                        if (to && to.getValue() != null && checkin.length >= 2)
                            to.setValue(App.parseIsoDate(checkin[1]));
                        break;
                    }
                    case 'night': {
                        const options = data.night;
                        // если количество ночей не выбрано пользователем - снимаем выбор со всех опций
                        if (__classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_getSelectValues).call(this, 'Night').length <= 0 && __classPrivateFieldGet(this, _TourProgramMainFilterMobile_options, "f").changes.indexOf('night') < 0)
                            options.forEach(v => (v.selected = false));
                        __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_updateSelectList).call(this, 'Night', options, false);
                        break;
                    }
                    case 'regularCheckinDates':
                    case 'charterCheckinDates':
                        // NOTE: маркировка доступных дат заезда (для календаря) на мобильной версии не используется.
                        break;
                    default: {
                        // ключи ответа ProgramFilters - camelCase (city, resort, ...),
                        // имена контролов - PascalCase (City, Resort, ...)
                        const controlName = __classPrivateFieldGet(_a, _a, "m", _TourProgramMainFilterMobile_capitalize).call(_a, key);
                        const withDefaultOption = __classPrivateFieldGet(_a, _a, "f", _TourProgramMainFilterMobile_defaultOptionTexts)[controlName] != null;
                        if (this.filters.getControl(controlName))
                            __classPrivateFieldGet(this, _TourProgramMainFilterMobile_instances, "m", _TourProgramMainFilterMobile_updateSelectList).call(this, controlName, data[key], withDefaultOption);
                        break;
                    }
                }
            }
        }
        finally {
            __classPrivateFieldSet(this, _TourProgramMainFilterMobile_suppressChanges, false, "f");
        }
    }, _TourProgramMainFilterMobile_updateSelectList = function _TourProgramMainFilterMobile_updateSelectList(name, options, withDefaultOption) {
        var _b;
        const control = this.filters.findControl(name);
        if (!control)
            return;
        // иерархические списки (курорты) разворачиваем в плоский список
        const flatOptions = __classPrivateFieldGet(_a, _a, "m", _TourProgramMainFilterMobile_flattenOptions).call(_a, options);
        let items = flatOptions;
        if (withDefaultOption) {
            const hasSelected = flatOptions.some(v => v.selected);
            const defaultText = (_b = __classPrivateFieldGet(_a, _a, "f", _TourProgramMainFilterMobile_defaultOptionTexts)[name]) !== null && _b !== void 0 ? _b : 'Все';
            items = [{ value: '', text: defaultText, selected: !hasSelected }, ...flatOptions];
        }
        control.setValueByListOptions(items);
    }, _TourProgramMainFilterMobile_flattenOptions = function _TourProgramMainFilterMobile_flattenOptions(options) {
        var _b;
        const result = new Array();
        for (const option of options !== null && options !== void 0 ? options : []) {
            result.push({ value: option.value, text: option.text, selected: option.selected });
            if ((_b = option.children) === null || _b === void 0 ? void 0 : _b.length)
                result.push(...__classPrivateFieldGet(_a, _a, "m", _TourProgramMainFilterMobile_flattenOptions).call(_a, option.children));
        }
        return result;
    };
    _TourProgramMainFilterMobile_changeTypes = { value: {
            'City': 'departureCity',
            'Direct': 'directFlight',
            'Charter': 'blockFlight',
            'Resort': 'resort',
            'Checkin.From': 'checkinDate',
            'Checkin.To': 'checkinDate',
            'Night': 'tourDuration',
            'Category.From': 'hotelCategory',
            'Category.To': 'hotelCategory',
            'Facility': 'hotelFacility',
            'Chain': 'hotelChain',
            'Hotel': 'hotel',
        } };
    _TourProgramMainFilterMobile_defaultOptionTexts = { value: {
            'Resort': 'Все курорты',
            'Chain': 'Все сети отелей',
            'Facility': 'Все услуги',
            'Hotel': 'Все отели',
        } };
    /**
     * Порядок параметров поиска - как порядок полей десктопной формы (Views/Tour/Filters/ProgramFilter.cshtml),
     * чтобы payload запроса Tour/Program совпадал с десктопной версией.
     */
    _TourProgramMainFilterMobile_searchFieldOrder = { value: [
            'context',
            'Program',
            'Citizenship',
            'City',
            'Direct',
            'Charter',
            'Treatment',
            'Resort',
            'Checkin.From',
            'Checkin.To',
            'Night',
            'Tourist.AdultCount',
            'Tourist.ChildAges',
            'Category.From',
            'Category.To',
            'Facility',
            'Chain',
            'Hotel',
            'Board',
            'Fare',
        ] };
    App.TourProgramMainFilterMobile = TourProgramMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TourProgramMainFilter_options;
    class TourProgramMainFilter extends App.TourMainFilter {
        constructor(options) {
            super(Object.assign({}, options));
            _TourProgramMainFilter_options.set(this, void 0);
            __classPrivateFieldSet(this, _TourProgramMainFilter_options, options, "f");
        }
        onFilterChange(sender) {
            const _super = Object.create(null, {
                onFilterChange: { get: () => super.onFilterChange }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (!__classPrivateFieldGet(this, _TourProgramMainFilter_options, "f").isDateRange)
                    this.root.find('[name="Checkin.To"]').val((_a = this.dependencies.checkinFrom.element.val()) !== null && _a !== void 0 ? _a : '');
                yield _super.onFilterChange.call(this, sender);
            });
        }
        getDependencies(options) {
            const result = {
                program: {
                    element: this.root.find('[name="Program"]'),
                    multiple: false,
                },
                city: {
                    element: this.root.find('[data-select="city"] .js-jelect'),
                    control: this.findControl('city'),
                    multiple: false,
                    changeType: 'departureCity',
                },
                direct: {
                    element: this.root.find('[name="Direct"]'),
                    multiple: false,
                    changeType: 'directFlight',
                },
                charter: {
                    element: this.root.find('[name="Charter"]'),
                    multiple: false,
                    changeType: 'blockFlight',
                },
                resort: {
                    element: this.root.find('[data-select="resort"] .js-jelect'),
                    control: this.findControl('resort'),
                    multiple: true,
                    changeType: 'resort',
                },
                checkinFrom: {
                    element: this.root.find('[name="Checkin.From"]'),
                    multiple: false,
                    changeType: 'checkinDate',
                },
            };
            if (options.isDateRange) {
                result.checkinTo = {
                    element: this.root.find('[name="Checkin.To"]'),
                    multiple: false,
                    changeType: 'checkinDate',
                };
            }
            result.night = {
                element: this.root.find('[data-select="night"] .js-jelect'),
                control: this.findControl('night'),
                multiple: options.isDateRange,
                changeType: 'tourDuration',
            };
            if (!options.hasMultipleHotels) {
                Object.assign(result, {
                    categoryFrom: {
                        element: this.root.find('[data-input-name="hotel_stars_from"]'),
                        multiple: false,
                        changeType: 'hotelCategory',
                    },
                    categoryTo: {
                        element: this.root.find('[data-input-name="hotel_stars_to"]'),
                        multiple: false,
                        changeType: 'hotelCategory',
                    },
                    facility: {
                        element: this.root.find('[name="Facility"]'),
                        control: this.findControl('facility'),
                        multiple: true,
                        changeType: 'hotelFacility',
                    },
                    chain: {
                        element: this.root.find('[data-select="chain"] .js-jelect'),
                        control: this.findControl('chain'),
                        multiple: true,
                        changeType: 'hotelChain',
                    },
                    hotel: {
                        element: this.root.find('[data-select="hotel"] .js-jelect'),
                        control: this.findControl('hotel'),
                        multiple: true,
                        changeType: 'hotel',
                    },
                });
            }
            result.fare = {
                element: this.root.find('[data-select="fare"] .js-jelect'),
                control: this.findControl('fare'),
                multiple: true,
                changeType: 'tourFare',
            };
            return result;
        }
    }
    _TourProgramMainFilter_options = new WeakMap();
    App.TourProgramMainFilter = TourProgramMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _TourProgramMap_instances, _a, _TourProgramMap_googleMap, _TourProgramMap_mapContainer, _TourProgramMap_hotelOnMapInfoContainer, _TourProgramMap_markers, _TourProgramMap_blockTemplate, _TourProgramMap_hotelOffers, _TourProgramMap_markerInfoPosition, _TourProgramMap_styleMapPosition, _TourProgramMap_changeStyleMap, _TourProgramMap_addHotelsOnMap, _TourProgramMap_mapGenerateMarkers, _TourProgramMap_bindMarkers, _TourProgramMap_selectMarker, _TourProgramMap_resetMarkersIcons, _TourProgramMap_setMarkerIconActivity, _TourProgramMap_deleteInfoMarker, _TourProgramMap_showMarkerInfo, _TourProgramMap_mapRecenter;
    class TourProgramMap {
        constructor() {
            _TourProgramMap_instances.add(this);
            _TourProgramMap_googleMap.set(this, void 0);
            _TourProgramMap_mapContainer.set(this, void 0);
            _TourProgramMap_hotelOnMapInfoContainer.set(this, void 0);
            _TourProgramMap_markers.set(this, void 0);
            _TourProgramMap_blockTemplate.set(this, void 0);
            _TourProgramMap_hotelOffers.set(this, void 0);
            _TourProgramMap_markerInfoPosition.set(this, void 0);
            _TourProgramMap_styleMapPosition.set(this, void 0);
            __classPrivateFieldSet(this, _TourProgramMap_mapContainer, $('.js-hotels-town-output-map'), "f");
            __classPrivateFieldSet(this, _TourProgramMap_hotelOnMapInfoContainer, $('.js-resorts-map-info-wrap', __classPrivateFieldGet(this, _TourProgramMap_mapContainer, "f")), "f");
            __classPrivateFieldSet(this, _TourProgramMap_blockTemplate, App.templates.Tour.ProgramTableOutput, "f");
            __classPrivateFieldSet(this, _TourProgramMap_markers, new Array(), "f");
            __classPrivateFieldSet(this, _TourProgramMap_hotelOffers, new Array(), "f");
            __classPrivateFieldSet(this, _TourProgramMap_markerInfoPosition, google.maps.ControlPosition.BOTTOM_CENTER, "f");
            __classPrivateFieldSet(this, _TourProgramMap_styleMapPosition, google.maps.ControlPosition.TOP_LEFT, "f");
        }
        initMap() {
            __classPrivateFieldSet(this, _TourProgramMap_googleMap, new App.GoogleMap('HotelMap', {}, '.js-hotels-town-output-map'), "f");
            const additionalMapOptions = {
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP,
                },
                styles: [
                    {
                        featureType: 'poi',
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }],
                    },
                ],
            };
            __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").setAdditionalOptions(additionalMapOptions);
            const styleControl = document.getElementById('style-selector-control');
            __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _TourProgramMap_styleMapPosition, "f")].push(styleControl);
            __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_addHotelsOnMap).call(this);
            this.renewMap();
            __classPrivateFieldGet(this, _TourProgramMap_mapContainer, "f").on('click', '.map-control-option', e => __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_changeStyleMap).call(this, e));
        }
        addHotelPoints(hotelOffers) {
            __classPrivateFieldSet(this, _TourProgramMap_hotelOffers, __classPrivateFieldGet(this, _TourProgramMap_hotelOffers, "f").concat(hotelOffers), "f");
            if (this.isInitMap()) {
                __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_addHotelsOnMap).call(this, hotelOffers);
            }
        }
        isInitMap() {
            return __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f") != undefined;
        }
        isActiveMap() {
            return !__classPrivateFieldGet(this, _TourProgramMap_mapContainer, "f").is(':hidden');
        }
        resetPoints() {
            __classPrivateFieldGet(this, _TourProgramMap_markers, "f").forEach(v => {
                v.setMap(null);
            });
            __classPrivateFieldSet(this, _TourProgramMap_markers, new Array(), "f");
            __classPrivateFieldSet(this, _TourProgramMap_hotelOffers, new Array(), "f");
            __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").resetPoints();
            __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_deleteInfoMarker).call(this);
            this.renewMap();
        }
        /**
         * Обновляет карту
         * Вызывать после добавления на нее отелей для нового центрирования
         */
        renewMap() {
            __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").renewMapCenter();
            __classPrivateFieldGet(this, _TourProgramMap_hotelOnMapInfoContainer, "f").hide();
        }
        /**
         * Показывает карту по отелю (по клику)
         * @param selectedOffer
         */
        openMapByOffer(selectedOffer) {
            const finded = __classPrivateFieldGet(this, _TourProgramMap_markers, "f").find(value => value.id === selectedOffer.key.key);
            if (finded) {
                __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.setZoom(18);
                // Сделаем типа-клик на маркер
                google.maps.event.trigger(finded.getOverlay(), 'click');
            }
        }
    }
    _a = TourProgramMap, _TourProgramMap_googleMap = new WeakMap(), _TourProgramMap_mapContainer = new WeakMap(), _TourProgramMap_hotelOnMapInfoContainer = new WeakMap(), _TourProgramMap_markers = new WeakMap(), _TourProgramMap_blockTemplate = new WeakMap(), _TourProgramMap_hotelOffers = new WeakMap(), _TourProgramMap_markerInfoPosition = new WeakMap(), _TourProgramMap_styleMapPosition = new WeakMap(), _TourProgramMap_instances = new WeakSet(), _TourProgramMap_changeStyleMap = function _TourProgramMap_changeStyleMap(event) {
        $('#style-selector-control .map-control-option').removeClass('_on');
        $(event.currentTarget).addClass('_on');
        const id = $(event.currentTarget).attr('id');
        __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.setOptions({
            styles: [
                {
                    featureType: 'poi',
                    elementType: 'labels.icon',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: `poi.${id}`,
                    stylers: [{ visibility: 'on' }],
                },
            ],
        });
    }, _TourProgramMap_addHotelsOnMap = function _TourProgramMap_addHotelsOnMap(addOffers = []) {
        __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_deleteInfoMarker).call(this);
        const offers = addOffers.length > 0 ? addOffers : __classPrivateFieldGet(this, _TourProgramMap_hotelOffers, "f");
        const coordinates = offers.map(v => v.key.coordinate);
        __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").addMapPoints(coordinates);
        // генерим новые маркеры
        __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_mapGenerateMarkers).call(this, offers);
        if (addOffers.length > 0)
            this.renewMap();
        $('#style-selector-control', __classPrivateFieldGet(this, _TourProgramMap_mapContainer, "f")).show();
    }, _TourProgramMap_mapGenerateMarkers = function _TourProgramMap_mapGenerateMarkers(hotelOffers) {
        hotelOffers.forEach(offer => {
            const point = new google.maps.LatLng(offer.key.coordinate.latitude, offer.key.coordinate.longitude);
            const jqMarkerContent = $(App.templates.Money({ amount: offer.minPrice, currency: offer.currencyCode, format: '0' }));
            const markerContent = jqMarkerContent.get(0);
            if (!markerContent)
                return;
            const found = __classPrivateFieldGet(this, _TourProgramMap_markers, "f").find(value => value.id === offer.key.key);
            if (found) {
                if (found.minPrice !== offer.minPrice) {
                    found.minPrice = offer.minPrice;
                    found.updateContent(markerContent.outerHTML);
                    if (found.selected)
                        google.maps.event.trigger(found.getOverlay(), 'click');
                }
            }
            else {
                const marker = new App.CustomMarker(point, __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map, {
                    markerId: offer.key.key,
                    content: markerContent.outerHTML,
                    minPrice: offer.minPrice,
                });
                // Добавляем маркер в объект с маркерами
                __classPrivateFieldGet(this, _TourProgramMap_markers, "f").push(marker);
                // Навешиваем обработчики на маркер
                __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_bindMarkers).call(this, marker, offer);
            }
        });
    }, _TourProgramMap_bindMarkers = function _TourProgramMap_bindMarkers(marker, hotelOffer) {
        // Клик по маркеру
        marker.addListener('click', () => __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_selectMarker).call(this, marker, hotelOffer));
    }, _TourProgramMap_selectMarker = function _TourProgramMap_selectMarker(marker, hotelOffer) {
        __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_resetMarkersIcons).call(this);
        __classPrivateFieldGet(_a, _a, "m", _TourProgramMap_setMarkerIconActivity).call(_a, marker, true);
        const markerPosition = marker.getPosition();
        if (markerPosition)
            __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_mapRecenter).call(this, markerPosition, 0, 50);
        __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_showMarkerInfo).call(this, hotelOffer);
    }, _TourProgramMap_resetMarkersIcons = function _TourProgramMap_resetMarkersIcons() {
        for (let i = 0; i < __classPrivateFieldGet(this, _TourProgramMap_markers, "f").length; ++i) {
            __classPrivateFieldGet(_a, _a, "m", _TourProgramMap_setMarkerIconActivity).call(_a, __classPrivateFieldGet(this, _TourProgramMap_markers, "f")[i], false);
            __classPrivateFieldGet(this, _TourProgramMap_markers, "f")[i].selected = false;
        }
    }, _TourProgramMap_setMarkerIconActivity = function _TourProgramMap_setMarkerIconActivity(marker, activity) {
        const overlay = marker.getOverlay();
        if (!overlay)
            return;
        $(overlay).removeClass('_selected');
        marker.selected = false;
        if (activity) {
            $(overlay).addClass('_selected');
            marker.selected = true;
        }
    }, _TourProgramMap_deleteInfoMarker = function _TourProgramMap_deleteInfoMarker() {
        __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_resetMarkersIcons).call(this);
        __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _TourProgramMap_markerInfoPosition, "f")].clear();
    }, _TourProgramMap_showMarkerInfo = function _TourProgramMap_showMarkerInfo(hotelOffer) {
        __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _TourProgramMap_markerInfoPosition, "f")].clear();
        if (__classPrivateFieldGet(this, _TourProgramMap_blockTemplate, "f") == null)
            return;
        const onMap = { onMap: true };
        const content = $(__classPrivateFieldGet(this, _TourProgramMap_blockTemplate, "f").call(this, [Object.assign(Object.assign({}, hotelOffer), onMap)]));
        const closeButton = $('.js-map-info-close', content);
        App.NetPricePresenter.setVisibility(content, App.NetPricePresenter.getVisibility());
        const hotelInfo = content.get()[0];
        hotelInfo.classList.add('_opened');
        const hotelInfoContainer = document.createElement('div');
        hotelInfoContainer.className = 'tours-output-table resorts-map-info-wrap';
        hotelInfoContainer.appendChild(hotelInfo);
        __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.controls[__classPrivateFieldGet(this, _TourProgramMap_markerInfoPosition, "f")].push(hotelInfoContainer);
        closeButton.on('click', () => {
            __classPrivateFieldGet(this, _TourProgramMap_instances, "m", _TourProgramMap_deleteInfoMarker).call(this);
        });
        // TODO: навесила на body, чтобы не ковыряться в Result или PageManager для поулчения этого блока. Может
        // все же открыть доступ к нему и навесить событие адресно.
        $('body').trigger("hotelMarkerInfo:show" /* Events.HotelMarkerInfoShow */);
    }, _TourProgramMap_mapRecenter = function _TourProgramMap_mapRecenter(latlng, offsetx, offsety) {
        const projection = __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.getProjection();
        if (projection == null)
            return;
        const latLng = (latlng instanceof google.maps.LatLng) ? latlng : __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.getCenter();
        if (latLng == null)
            return;
        const zoom = __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.getZoom();
        if (zoom == null)
            return;
        const oldPoint = projection.fromLatLngToPoint(latLng);
        if (oldPoint == null)
            return;
        const newPoint = new google.maps.Point(((typeof (offsetx) === 'number' ? offsetx : 0) / (Math.pow(2, zoom))) || 0, ((typeof (offsety) === 'number' ? offsety : 0) / (Math.pow(2, zoom))) || 0);
        const newCenter = projection.fromPointToLatLng(new google.maps.Point(oldPoint.x - newPoint.x, oldPoint.y + newPoint.y));
        if (newCenter == null)
            return;
        __classPrivateFieldGet(this, _TourProgramMap_googleMap, "f").map.panTo(newCenter);
    };
    App.TourProgramMap = TourProgramMap;
})(App || (App = {}));
var App;
(function (App) {
    var _TourProgramResult_instances, _a, _TourProgramResult_options, _TourProgramResult_dynamicGroupConfig, _TourProgramResult_currencyConverter, _TourProgramResult_sortCurrencyCode, _TourProgramResult_map, _TourProgramResult_renderedData, _TourProgramResult_newSearchData, _TourProgramResult_initHotelGroup, _TourProgramResult_initDateGroup, _TourProgramResult_showOnMap;
    class TourProgramResult extends App.TourPlainResult {
        constructor(options) {
            super(Object.assign({}, options));
            _TourProgramResult_instances.add(this);
            _TourProgramResult_options.set(this, void 0);
            _TourProgramResult_dynamicGroupConfig.set(this, void 0);
            _TourProgramResult_currencyConverter.set(this, void 0);
            _TourProgramResult_sortCurrencyCode.set(this, "RUB" /* KnownCurrencyCode.RUB */);
            _TourProgramResult_map.set(this, void 0);
            _TourProgramResult_renderedData.set(this, void 0);
            _TourProgramResult_newSearchData.set(this, false);
            __classPrivateFieldSet(this, _TourProgramResult_options, options, "f");
            this.bannerIncutPositions = App.app.settings.tourOptions.bannerIncutPositions.program;
            __classPrivateFieldSet(this, _TourProgramResult_renderedData, new Array(), "f");
            __classPrivateFieldSet(this, _TourProgramResult_map, new App.TourProgramMap(), "f");
            __classPrivateFieldSet(this, _TourProgramResult_dynamicGroupConfig, new App.DynamicGroupConfig(), "f");
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _TourProgramResult_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _TourProgramResult_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _TourProgramResult_currencyConverter, "f");
                    if (currencyConverter) {
                        if (!append)
                            __classPrivateFieldSet(this, _TourProgramResult_sortCurrencyCode, data[0].items[0].items[0].currencyCode, "f");
                        Enumerable.from(data)
                            .selectMany(v => v.items)
                            .selectMany(v => v.items)
                            .forEach(v => {
                            var _b;
                            v.sortPrice = (_b = currencyConverter.exchange(v.grossPrice, v.currencyCode, __classPrivateFieldGet(this, _TourProgramResult_sortCurrencyCode, "f"))) !== null && _b !== void 0 ? _b : v.grossPrice;
                        });
                    }
                }
                // Merge data
                const result = this.data;
                if (append) {
                    data.forEach(newHotelGroup => {
                        const oldHotelGroup = result.find(v => v.key.key === newHotelGroup.key.key);
                        if (oldHotelGroup) {
                            const updatedGroups = [];
                            newHotelGroup.items.forEach(newDateGroup => {
                                const oldDateGroup = oldHotelGroup.items.find(v => v.key === newDateGroup.key);
                                if (oldDateGroup) {
                                    oldDateGroup.items.push(...newDateGroup.items);
                                    updatedGroups.push(oldDateGroup);
                                }
                                else {
                                    oldHotelGroup.items.push(newDateGroup);
                                    updatedGroups.push(newDateGroup);
                                }
                            });
                            __classPrivateFieldGet(_a, _a, "m", _TourProgramResult_initHotelGroup).call(_a, oldHotelGroup, updatedGroups);
                        }
                        else {
                            result.push(newHotelGroup);
                            __classPrivateFieldGet(_a, _a, "m", _TourProgramResult_initHotelGroup).call(_a, newHotelGroup);
                        }
                    });
                }
                else {
                    App.emptyArray(result);
                    result.push(...data);
                    data.forEach(v => __classPrivateFieldGet(_a, _a, "m", _TourProgramResult_initHotelGroup).call(_a, v));
                }
                if (result[0].items.every(v => v.items.every(h => h.hotels.every(c => c.coordinate == null)))) {
                    $('.js-view-item[data-code="map"]', '.js-hot-filter').removeClass('_active').hideByClass();
                    $('.js-view-item[data-code="image"]', '.js-hot-filter').addClass('_active');
                    this.hotFilter.changeActiveView();
                }
                yield _super.changeDataSource.call(this, result, append);
            });
        }
        resetDataSource() {
            if (__classPrivateFieldGet(this, _TourProgramResult_map, "f").isInitMap())
                __classPrivateFieldGet(this, _TourProgramResult_map, "f").resetPoints();
            super.resetDataSource();
        }
        updateHotFilters(data) {
            const oldFilters = this.hotFilter.root.serializeArray();
            const items = Enumerable.from(data)
                .selectMany(v => v.items)
                .selectMany(v => v.items);
            const isAviaYesControl = $('[name="IsAviaYes"]', this.hotFilter.root).parents('.filter-block');
            const showIsAviaYes = isAviaYesControl.length > 0
                && items.any(v => !v.dynamicFlight && v.aviaQuota === App.QuotaStatus.Yes)
                && items.any(v => v.dynamicFlight || v.aviaQuota === App.QuotaStatus.Request);
            isAviaYesControl.toggle(showIsAviaYes);
            const isAviaRequestControl = $('[name="IsAviaRequest"]', this.hotFilter.root).parents('.filter-block');
            const showIsAviaRequest = isAviaRequestControl.length > 0
                && items.any(v => !v.dynamicFlight && v.aviaQuota === App.QuotaStatus.Request)
                && items.any(v => v.dynamicFlight || v.aviaQuota === App.QuotaStatus.Yes);
            isAviaRequestControl.toggle(showIsAviaRequest);
            const isDynamicAviaControl = $('[name="IsDynamicAvia"]', this.hotFilter.root).parents('.filter-block');
            const showIsDynamicAvia = isDynamicAviaControl.length > 0
                && items.any(v => v.dynamicFlight)
                && items.any(v => !v.dynamicFlight && (v.aviaQuota === App.QuotaStatus.Yes || v.aviaQuota === App.QuotaStatus.Request));
            isDynamicAviaControl.toggle(showIsDynamicAvia);
            const hasHotelControl = $('[name="HasHotel"]', this.hotFilter.root).parents('.filter-block');
            const showHasHotel = hasHotelControl.length > 0
                && items.any(v => v.hotelQuota !== App.QuotaStatus.Yes && v.hotelQuota !== App.QuotaStatus.Few)
                && items.any(v => v.hotelQuota === App.QuotaStatus.Yes || v.hotelQuota === App.QuotaStatus.Few);
            hasHotelControl.toggle(showHasHotel);
            const hasTransferControl = $('[name="HasTransfer"]', this.hotFilter.root).parents('.filter-block');
            const showHasTransfer = hasTransferControl.length > 0
                && items.any(v => !v.includesTransfer)
                && items.any(v => v.includesTransfer);
            hasTransferControl.toggle(showHasTransfer);
            const hasTreatmentControl = $('[name="HasTreatment"]', this.hotFilter.root).parents('.filter-block');
            const showHasTreatment = hasTreatmentControl.length > 0
                && items.any(v => !v.hasTreatment)
                && items.any(v => v.hasTreatment);
            hasTreatmentControl.toggle(showHasTreatment);
            const facilityControl = this.hotFilter.findControl('Facility');
            let showFacility = false;
            if (facilityControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === facilityControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .selectMany(v => v.hotels)
                    .selectMany(v => v.features)
                    .distinct(v => v.key)
                    .orderBy(v => v.key)
                    .select(v => ({ value: `${v.key}`, text: v.name, selected: oldValues.some(x => x === `${v.key}`) }))
                    .toArray();
                showFacility = options.length > 0;
                facilityControl.replaceOptions(options, true);
                facilityControl.root.toggle(showFacility);
            }
            const fareControl = this.hotFilter.findControl('Fare');
            let showFare = false;
            if (fareControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === fareControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .selectMany(v => v.tourFares)
                    .distinct(v => v.key)
                    .orderBy(v => v.key)
                    .select(v => ({ value: `${v.key}`, text: v.name, selected: oldValues.some(x => x === v.code) }))
                    .toArray();
                showFare = options.length > 1;
                fareControl.replaceOptions(options, true);
                fareControl.root.toggle(showFare);
            }
            const roomTypeControl = this.hotFilter.findControl('RoomType');
            let showRoomType = false;
            if (roomTypeControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === roomTypeControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .selectMany(v => v.hotels)
                    .selectMany(v => v.roomGroups)
                    .distinct()
                    .groupJoin(Enumerable.from(__classPrivateFieldGet(this, _TourProgramResult_options, "f").dynamicRoomTypes), v => v, v => v.code, (v1, v2) => {
                    var _b, _c;
                    const dynamicRoomType = v2.defaultIfEmpty().first();
                    return {
                        code: (_b = dynamicRoomType === null || dynamicRoomType === void 0 ? void 0 : dynamicRoomType.code) !== null && _b !== void 0 ? _b : v1,
                        name: (_c = dynamicRoomType === null || dynamicRoomType === void 0 ? void 0 : dynamicRoomType.name) !== null && _c !== void 0 ? _c : v1,
                        sortOrder: dynamicRoomType === null || dynamicRoomType === void 0 ? void 0 : dynamicRoomType.sortOrder,
                    };
                })
                    .orderBy(v => v.sortOrder)
                    .thenBy(v => v.name)
                    .select(v => ({ value: v.code, text: v.name, selected: oldValues.some(x => x === v.code) }))
                    .toArray();
                showRoomType = options.length > 1;
                roomTypeControl.replaceOptions(options, true);
                roomTypeControl.root.toggle(showRoomType);
            }
            const boardTypeControl = this.hotFilter.findControl('BoardType');
            let showBoardType = false;
            if (boardTypeControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === boardTypeControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                let options;
                if (__classPrivateFieldGet(this, _TourProgramResult_options, "f").hasDynamicHotel) {
                    options = items
                        .selectMany(v => v.hotels)
                        .select(v => v.boardGroup)
                        .distinct()
                        .join(Enumerable.from(__classPrivateFieldGet(this, _TourProgramResult_options, "f").dynamicBoardTypes), v => v, v => v.code, (_, v2) => v2)
                        .orderBy(v => v.sortOrder)
                        .thenBy(v => v.name)
                        .select(v => ({ value: v.code, text: v.name, selected: oldValues.some(x => x === v.code) }))
                        .toArray();
                }
                else {
                    options = items
                        .selectMany(v => v.hotels)
                        .select(v => v.boardGroup)
                        .distinct()
                        .join(Enumerable.from(__classPrivateFieldGet(this, _TourProgramResult_options, "f").hotelBoards), v => v, v => v.code, (_, v2) => v2)
                        .orderBy(v => v)
                        .select(v => ({ value: v.code, text: v.name, selected: oldValues.some(x => x === v.code) }))
                        .toArray();
                }
                showBoardType = options.length > 1;
                boardTypeControl.replaceOptions(options, true);
                boardTypeControl.root.toggle(showBoardType);
            }
            const freeCancellationControl = $('[name="FreeCancellation"]', this.hotFilter.root).parents('.filter-block');
            const showFreeCancellation = freeCancellationControl.length > 0
                && items.any(v => !v.freeCancellation)
                && items.any(v => v.freeCancellation);
            freeCancellationControl.toggle(showFreeCancellation);
            const ratingControl = this.hotFilter.findControl('Rating');
            let showRating = false;
            if (ratingControl) {
                if (__classPrivateFieldGet(this, _TourProgramResult_options, "f").hasDynamicHotel) {
                    const oldValues = Enumerable.from(oldFilters)
                        .where(v => v.name.toLowerCase() === ratingControl.name)
                        .selectMany(v => App.splitNonEmpty(v.value))
                        .toArray();
                    if (oldValues.length <= 0)
                        oldValues.push('0');
                    const minRating = items
                        .selectMany(v => v.hotels)
                        .select(v => v.rating)
                        .where(v => !!v)
                        .defaultIfEmpty(0)
                        .min(v => v !== null && v !== void 0 ? v : 0);
                    const options = Enumerable.from(__classPrivateFieldGet(this, _TourProgramResult_dynamicGroupConfig, "f").ratings.items)
                        .where(v => parseInt(v.code, 10) >= Math.floor(minRating) * 10)
                        .orderBy(v => v.sortOrder)
                        .thenBy(v => v.name)
                        .select(v => ({ value: v.code, text: v.name, selected: oldValues.some(x => x === v.code) }))
                        .toArray();
                    if (options.length > 1) {
                        options.unshift({ value: '0', text: 'Все', selected: oldValues.some(x => x === '0') });
                        showRating = true;
                    }
                    ratingControl.replaceOptions(options, true);
                }
                ratingControl.root.toggle(showRating);
            }
            const cityAreaControl = this.hotFilter.findControl('CityArea');
            let showCityArea = false;
            if (cityAreaControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === cityAreaControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .selectMany(v => v.hotels)
                    .selectMany(v => { var _b; return (_b = v.cityAreas) !== null && _b !== void 0 ? _b : new Array(); })
                    .distinct(v => v.key)
                    .orderBy(v => v.value)
                    .select(v => ({ value: `${v.key}`, text: v.value, selected: oldValues.some(x => x === `${v.key}`) }))
                    .toArray();
                showCityArea = options.length > 1;
                cityAreaControl.replaceOptions(options, true);
                cityAreaControl.root.toggle(showCityArea);
            }
            const resortControl = this.hotFilter.findControl('Resort');
            let showResort = false;
            if (resortControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === resortControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .selectMany(v => v.hotels)
                    .where(v => !v.isFake)
                    .distinct(v => v.resortKey)
                    .orderBy(v => v.resortName)
                    .select(v => ({ value: `${v.resortKey}`, text: v.resortName, selected: oldValues.some(x => x === `${v.key}`) }))
                    .toArray();
                showResort = options.length > 1;
                resortControl.replaceOptions(options, true);
                resortControl.root.toggle(showResort);
            }
            const providerControl = this.hotFilter.findControl('Provider');
            let showProvider = false;
            if (providerControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === providerControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .where(v => v.dynamicHotelProvider != null)
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    .select(v => v.dynamicHotelProvider)
                    .distinct(v => v.key)
                    .orderBy(v => v.name)
                    .select(v => ({ value: `${v.key}`, text: v.name, selected: oldValues.some(x => x === `${v.key}`) }))
                    .toArray();
                showProvider = options.length > 1;
                providerControl.replaceOptions(options, true);
                providerControl.root.toggle(showProvider);
            }
            const offerSourceControl = this.hotFilter.findControl('OfferSource');
            let showOfferSource = false;
            if (offerSourceControl) {
                const oldValues = Enumerable.from(oldFilters)
                    .where(v => v.name.toLowerCase() === offerSourceControl.name)
                    .selectMany(v => App.splitNonEmpty(v.value))
                    .toArray();
                const options = items
                    .where(v => v.dynamicHotelOfferSource != null)
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    .select(v => v.dynamicHotelOfferSource)
                    .distinct(v => v.key)
                    .orderBy(v => v.name)
                    .select(v => ({ value: `${v.key}`, text: v.name, selected: oldValues.some(x => x === `${v.key}`) }))
                    .toArray();
                showOfferSource = options.length > 1;
                offerSourceControl.replaceOptions(options, true);
                offerSourceControl.root.toggle(showOfferSource);
            }
            const pacRecommendsControl = $('[name="PacRecommends"]', this.hotFilter.root).parents('.filter-block');
            const showPacRecommends = pacRecommendsControl.length > 0
                && items.selectMany(v => v.hotels).any(v => !v.markerPac)
                && items.selectMany(v => v.hotels).any(v => v.markerPac);
            pacRecommendsControl.toggle(showPacRecommends);
            const goldCollectionControl = $('[name="GoldCollection"]', this.hotFilter.root).parents('.filter-block');
            const showGoldCollection = goldCollectionControl.length > 0
                && items.selectMany(v => v.hotels).any(v => !v.markerGold)
                && items.selectMany(v => v.hotels).any(v => v.markerGold);
            goldCollectionControl.toggle(showGoldCollection);
            const accommodationNameControl = $('[name="AccommodationName"]', this.hotFilter.root).parents('.filter-block');
            const showAccommodationName = accommodationNameControl.length > 0
                && items.selectMany(v => v.hotels).distinct().skip(1).any();
            accommodationNameControl.toggle(showAccommodationName);
            const showFilters = showIsAviaYes || showIsAviaRequest || showIsDynamicAvia
                || showHasHotel || showHasTransfer || showHasTreatment
                || showFacility || showFare || showRoomType || showBoardType || showFreeCancellation
                || showRating || showCityArea || showResort || showProvider || showOfferSource
                || showPacRecommends || showGoldCollection || showAccommodationName;
            $('.js-filter-body', this.hotFilter.root).toggle(showFilters);
        }
        applyFilters(items) {
            if (this.filtering.items.length <= 0)
                return items;
            let predicate = () => true;
            let aviaPredicate = () => false;
            let hasAviaPredicate = false;
            this.filtering.items
                .filter(v => v.values.length > 0)
                .forEach(v => {
                switch (v.name.toLowerCase()) {
                    case 'isaviayes': {
                        const tempPredicate = aviaPredicate;
                        if (v.values[0] === 'true') {
                            aviaPredicate = (x) => tempPredicate(x)
                                || (!x.dynamicFlight && x.aviaQuota === App.QuotaStatus.Yes);
                            hasAviaPredicate = true;
                        }
                        break;
                    }
                    case 'isaviarequest': {
                        const tempPredicate = aviaPredicate;
                        if (v.values[0] === 'true') {
                            aviaPredicate = (x) => tempPredicate(x)
                                || (!x.dynamicFlight && x.aviaQuota === App.QuotaStatus.Request);
                            hasAviaPredicate = true;
                        }
                        break;
                    }
                    case 'isdynamicavia': {
                        const tempPredicate = aviaPredicate;
                        if (v.values[0] === 'true') {
                            aviaPredicate = (x) => tempPredicate(x) || x.dynamicFlight;
                            hasAviaPredicate = true;
                        }
                        break;
                    }
                    case 'hashotel': {
                        const tempPredicate = predicate;
                        if (v.values[0] === 'true') {
                            predicate = (x) => tempPredicate(x)
                                && (x.hotelQuota === App.QuotaStatus.Yes || x.hotelQuota === App.QuotaStatus.Few);
                        }
                        break;
                    }
                    case 'hastransfer': {
                        const tempPredicate = predicate;
                        if (v.values[0] === 'true')
                            predicate = (x) => tempPredicate(x) && x.includesTransfer;
                        break;
                    }
                    case 'hastreatment': {
                        const tempPredicate = predicate;
                        if (v.values[0] === 'true')
                            predicate = (x) => tempPredicate(x) && x.hasTreatment;
                        break;
                    }
                    case 'facility': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && x.hotels.some(y => numValues.every(z => y.features && y.features.some(a => a.key === z)));
                        break;
                    }
                    case 'fare': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && x.tourFares.some(y => v.values.some(z => z === y.key));
                        break;
                    }
                    case 'roomtype': {
                        const tempPredicate = predicate;
                        if (__classPrivateFieldGet(this, _TourProgramResult_options, "f").hasDynamicHotel) {
                            predicate = (x) => tempPredicate(x)
                                && x.hotels.some(y => v.values.some(z => y.roomGroups.some(a => a === z)));
                        }
                        else {
                            predicate = (x) => tempPredicate(x)
                                && x.hotels.some(y => v.values.some(z => y.roomName === z));
                        }
                        break;
                    }
                    case 'boardtype': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && x.hotels.some(y => v.values.some(z => y.boardGroup === z));
                        break;
                    }
                    case 'freecancellation': {
                        if (v.values[0] === 'true') {
                            const tempPredicate = predicate;
                            predicate = (x) => tempPredicate(x) && x.freeCancellation;
                        }
                        break;
                    }
                    case 'rating': {
                        if (__classPrivateFieldGet(this, _TourProgramResult_options, "f").hasDynamicHotel) {
                            const numValue = parseInt(v.values[0], 10) / 10;
                            if (numValue > 0) {
                                const tempPredicate = predicate;
                                predicate = (x) => tempPredicate(x)
                                    && x.hotels.some(y => y.rating && y.rating >= numValue);
                            }
                        }
                        break;
                    }
                    case 'cityarea': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && x.hotels.some(y => numValues.some(z => y.cityAreas && y.cityAreas.some(a => a.key === z)));
                        break;
                    }
                    case 'resort': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && x.hotels.some(y => numValues.some(z => z === y.resortKey));
                        break;
                    }
                    case 'provider': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.dynamicHotelProvider && y === x.dynamicHotelProvider.key);
                        break;
                    }
                    case 'offersource': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.dynamicHotelOfferSource && y === x.dynamicHotelOfferSource.key);
                        break;
                    }
                    case 'pacrecommends': {
                        if (v.values[0] === 'true') {
                            const tempPredicate = predicate;
                            predicate = (x) => tempPredicate(x) && x.hotels.some(y => y.markerPac);
                        }
                        break;
                    }
                    case 'goldcollection': {
                        if (v.values[0] === 'true') {
                            const tempPredicate = predicate;
                            predicate = (x) => tempPredicate(x) && x.hotels.some(y => y.markerGold);
                        }
                        break;
                    }
                    case 'accommodationname': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && x.hotels.some(y => y.name.toLowerCase().includes(v.values[0].toLowerCase()));
                        break;
                    }
                    // no default
                }
            });
            if (hasAviaPredicate) {
                const haPredicate = predicate;
                predicate = (v) => haPredicate(v) && aviaPredicate(v);
            }
            // Update 'isHidden' field in full hierarchy and recalc dynamic data.
            for (let i = 0; i < items.length; i++) {
                const hotelGroup = items[i];
                let hotelGroupHidden = true;
                for (let j = 0; j < hotelGroup.items.length; j++) {
                    const dateGroup = hotelGroup.items[j];
                    let dateGroupHidden = true;
                    for (let k = 0; k < dateGroup.items.length; k++) {
                        const item = dateGroup.items[k];
                        item.isHidden = !predicate(item);
                        if (!item.isHidden)
                            dateGroupHidden = false;
                    }
                    dateGroup.isHidden = dateGroupHidden;
                    if (!dateGroup.isHidden)
                        hotelGroupHidden = false;
                    dateGroup.update();
                }
                hotelGroup.isHidden = hotelGroupHidden;
                hotelGroup.update();
            }
            return items.filter(v => !v.isHidden);
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case App.TourSortFields.Alphabet: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.key.name);
                    else
                        result = Enumerable.from(items).orderBy(v => v.key.name);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.TourSortFields.Price: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.sortPrice);
                    else
                        result = Enumerable.from(items).orderBy(v => v.sortPrice);
                    return result
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.TourSortFields.StarRating: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.key.category);
                    else
                        result = Enumerable.from(items).orderBy(v => v.key.category);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.key)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse) {
                        return Enumerable.from(items)
                            .reverse()
                            .toArray();
                    }
                    return Enumerable.from(items)
                        .toArray();
                }
            }
        }
        fillBannerIncut(item, pos) {
            var _b, _c;
            const siteUserKey = $('#siteUserKey').valNumber();
            const city = ((_b = this.filters["City" /* TourFilterFields.City */]) !== null && _b !== void 0 ? _b : '').toString();
            const program = ((_c = this.filters["Program" /* TourFilterFields.Program */]) !== null && _c !== void 0 ? _c : '').toString();
            const country = __classPrivateFieldGet(this, _TourProgramResult_options, "f").countryKey.toString();
            const rest = __classPrivateFieldGet(this, _TourProgramResult_options, "f").restTypeKey.toString();
            /* TODO Alekseeva (task 23148): использовать нижеуказанные значения в роли типа тура и страны соответственно.
            this.#options.restTypeKey
            this.#options.countryKey
            */
            item.bannerIncutId = `bannerIncut${item.key.key}`;
            item.bannerIncutUrl = `//store.pac.ru/advh.ashx?dom=${item.bannerIncutId}&br=pac-ts-program-big-${pos}pos&pd=0&sc=10&sb=1&ms=5&ac=1&bc=7&ver=wide&fdp=${city}&tfst=${program}&tftt=${rest}&fcns=${country}`;
            if (siteUserKey && siteUserKey > 0)
                item.bannerIncutUrl += `&uk=${siteUserKey}`;
        }
        findItem(key) {
            return Enumerable.from(this.data)
                .selectMany(v => v.items)
                .selectMany(v => v.items)
                .firstOrDefault(v => v.key === key);
        }
        findOfferByDynamicHotel(key) {
            return Enumerable.from(this.data)
                .selectMany(v => v.items)
                .selectMany(v => v.items)
                .firstOrDefault(v => v.dynamicHotelServiceKey === key);
        }
        findHotelGroup(hotelKey) {
            return this.data.find(v => v.key.key === hotelKey);
        }
        static findDateGroup(hotelGroup, date) {
            return hotelGroup.items.find(v => v.key === date);
        }
        initMapBlock(hotelOffers, addBlock) {
            if (addBlock)
                return;
            // Новые данные, еще не добавленные на карту
            let newPartToRender = new Array();
            const offers = hotelOffers.filter(v => v.key.coordinate != null);
            if (offers.length === 0)
                return;
            if (__classPrivateFieldGet(this, _TourProgramResult_renderedData, "f").length === 0 || offers.length < __classPrivateFieldGet(this, _TourProgramResult_renderedData, "f").length) {
                __classPrivateFieldSet(this, _TourProgramResult_renderedData, new Array(), "f");
                newPartToRender = offers;
                if (!__classPrivateFieldGet(this, _TourProgramResult_map, "f").isInitMap())
                    __classPrivateFieldGet(this, _TourProgramResult_map, "f").initMap();
                if (__classPrivateFieldGet(this, _TourProgramResult_map, "f").isInitMap())
                    __classPrivateFieldGet(this, _TourProgramResult_map, "f").resetPoints();
            }
            else {
                if (offers && __classPrivateFieldGet(this, _TourProgramResult_renderedData, "f")) {
                    newPartToRender = offers.filter(newOffer => {
                        const renderedOffer = __classPrivateFieldGet(this, _TourProgramResult_renderedData, "f").find(rendered => rendered.key === newOffer.key);
                        return !renderedOffer;
                    });
                }
            }
            __classPrivateFieldGet(this, _TourProgramResult_map, "f").addHotelPoints(newPartToRender);
            if (!__classPrivateFieldGet(this, _TourProgramResult_map, "f").isActiveMap())
                __classPrivateFieldSet(this, _TourProgramResult_newSearchData, true, "f");
            // обновим коллекцию отрендеренных данных
            __classPrivateFieldSet(this, _TourProgramResult_renderedData, __classPrivateFieldGet(this, _TourProgramResult_renderedData, "f").concat(newPartToRender), "f");
        }
        showMapView(event) {
            super.showMapView(event);
            if (!__classPrivateFieldGet(this, _TourProgramResult_map, "f").isInitMap())
                __classPrivateFieldGet(this, _TourProgramResult_map, "f").initMap();
            if (event != undefined && __classPrivateFieldGet(this, _TourProgramResult_newSearchData, "f")) {
                __classPrivateFieldGet(this, _TourProgramResult_map, "f").renewMap();
                __classPrivateFieldSet(this, _TourProgramResult_newSearchData, false, "f");
            }
        }
        bindBlocks() {
            super.bindBlocks();
            $('.js-show-on-map').on('click', e => __classPrivateFieldGet(this, _TourProgramResult_instances, "m", _TourProgramResult_showOnMap).call(this, e));
        }
        unbindBlocks() {
            super.unbindBlocks();
            $('.js-show-on-map').off('click', e => __classPrivateFieldGet(this, _TourProgramResult_instances, "m", _TourProgramResult_showOnMap).call(this, e));
        }
    }
    _a = TourProgramResult, _TourProgramResult_options = new WeakMap(), _TourProgramResult_dynamicGroupConfig = new WeakMap(), _TourProgramResult_currencyConverter = new WeakMap(), _TourProgramResult_sortCurrencyCode = new WeakMap(), _TourProgramResult_map = new WeakMap(), _TourProgramResult_renderedData = new WeakMap(), _TourProgramResult_newSearchData = new WeakMap(), _TourProgramResult_instances = new WeakSet(), _TourProgramResult_initHotelGroup = function _TourProgramResult_initHotelGroup(group, childGroups) {
        group.items.sort((a, b) => a.key.localeCompare(b.key));
        if (childGroups)
            childGroups.forEach(v => __classPrivateFieldGet(_a, _a, "m", _TourProgramResult_initDateGroup).call(_a, v));
        else
            group.items.forEach(v => __classPrivateFieldGet(_a, _a, "m", _TourProgramResult_initDateGroup).call(_a, v));
        group.update();
    }, _TourProgramResult_initDateGroup = function _TourProgramResult_initDateGroup(group) {
        group.items.sort((a, b) => a.sortPrice - b.sortPrice);
        group.update();
    }, _TourProgramResult_showOnMap = function _TourProgramResult_showOnMap(event) {
        event.preventDefault();
        event.stopPropagation();
        const filterMapViewBtn = $('.js-view-item[data-code="map"]');
        const filterMapViewBtnOffset = filterMapViewBtn.offset();
        filterMapViewBtn.trigger('click');
        $('html, body').animate({ scrollTop: (filterMapViewBtnOffset != null ? filterMapViewBtnOffset.top : 0) }, 500);
        const element = $(event.target);
        const dataOfferKey = element.attr('data-id');
        if (!dataOfferKey)
            return;
        const offerKey = parseInt(dataOfferKey, 10);
        const selectedOffer = __classPrivateFieldGet(this, _TourProgramResult_renderedData, "f").find(item => item.key.key === offerKey);
        if (!selectedOffer)
            return;
        setTimeout(() => __classPrivateFieldGet(this, _TourProgramResult_map, "f").openMapByOffer(selectedOffer), 500);
    };
    App.TourProgramResult = TourProgramResult;
})(App || (App = {}));
/// <reference path='TourProgramResult.ts' />
var App;
(function (App) {
    class TourProgramResultMobile extends App.TourProgramResult {
        constructor(options) {
            super(Object.assign(Object.assign({}, options), { tableTemplate: App.templates.Tour.ProgramTableOutput }));
        }
        updateHotFilters(data) {
            const hotFilter = this.hotFilter;
            if (hotFilter === null || hotFilter === void 0 ? void 0 : hotFilter.refreshProgramHotFilters)
                hotFilter.refreshProgramHotFilters(data);
        }
        // карта на мобильной версии пока не используется
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        initMapBlock(hotelOffers, addBlock) {
            // no-op
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        showMapView(event) {
            // no-op
        }
    }
    App.TourProgramResultMobile = TourProgramResultMobile;
})(App || (App = {}));
/// <reference path='TourPlainSearchViewModel.ts' />
var App;
(function (App) {
    class TourProgramSearchViewModel extends App.TourPlainSearchViewModel {
        get cancellationPolicyModel() {
            var _a;
            if (!this.cancellationPolicy)
                return undefined;
            return new App.VariantCancellationViewModel((_a = this.dynamicHotelServiceKey) !== null && _a !== void 0 ? _a : '', this.cancellationPolicy);
        }
        // #endregion
        constructor(source) {
            super();
            // #region Original
            Object.defineProperty(this, "hotels", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "promotions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tourPacketName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "markerTop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicHotelServiceKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicHotelProvider", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dynamicHotelOfferSource", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cancellationPolicy", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "freeCancellation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "transportType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cashBackForRussia", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cashBackForRussiaKids", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "hasShuttleBus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // #endregion
            // #region Additional
            Object.defineProperty(this, "isHidden", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.assign(this, source);
            this.isHidden = false;
        }
    }
    App.TourProgramSearchViewModel = TourProgramSearchViewModel;
})(App || (App = {}));
/// <reference path='../../common/components/MainFilter.Mobile.ts' />
/// <reference path='TourMainFilter.ts' />
var App;
(function (App) {
    var _TourSearchMainFilterMobile_instances, _a, _TourSearchMainFilterMobile_options, _TourSearchMainFilterMobile_popup, _TourSearchMainFilterMobile_responseValidator, _TourSearchMainFilterMobile_abortController, _TourSearchMainFilterMobile_suppressChanges, _TourSearchMainFilterMobile_changeTypes, _TourSearchMainFilterMobile_defaultOptionTexts, _TourSearchMainFilterMobile_onFilterChanged, _TourSearchMainFilterMobile_getFieldName, _TourSearchMainFilterMobile_filterChange, _TourSearchMainFilterMobile_getCityValue, _TourSearchMainFilterMobile_getSelectValues, _TourSearchMainFilterMobile_getDateValue, _TourSearchMainFilterMobile_toCamelCase, _TourSearchMainFilterMobile_capitalize, _TourSearchMainFilterMobile_applyFiltersData, _TourSearchMainFilterMobile_updateSelectList, _TourSearchMainFilterMobile_flattenOptions;
    class TourSearchMainFilterMobile extends App.MainFilterMobile {
        constructor(options) {
            super(Object.assign({ root: '.js-tour-main-filter', onFilterChanged: filterName => __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_onFilterChanged).call(this, filterName) }, options));
            _TourSearchMainFilterMobile_instances.add(this);
            _TourSearchMainFilterMobile_options.set(this, void 0);
            _TourSearchMainFilterMobile_popup.set(this, void 0);
            _TourSearchMainFilterMobile_responseValidator.set(this, void 0);
            _TourSearchMainFilterMobile_abortController.set(this, void 0);
            _TourSearchMainFilterMobile_suppressChanges.set(this, true);
            __classPrivateFieldSet(this, _TourSearchMainFilterMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TourSearchMainFilterMobile_popup, new App.Popup(), "f");
            __classPrivateFieldSet(this, _TourSearchMainFilterMobile_responseValidator, new App.ResponseValidator({ messenger: new App.BlockMessenger(new App.Messages()) }), "f");
            __classPrivateFieldSet(this, _TourSearchMainFilterMobile_suppressChanges, false, "f");
        }
        /**
         * Данные для выполнения поиска (сериализация контролов в параметры формы TourSearchForm).
         */
        buildSearchData() {
            const elements = this.filters.serializeArray();
            const data = { changes: [...__classPrivateFieldGet(this, _TourSearchMainFilterMobile_options, "f").changes] };
            elements
                .filter(v => v.value != null && v.value !== '')
                .forEach(v => {
                // категория отеля сериализуется мобильным контролом как "Category=1,5",
                // а сервер ожидает "Category.From=1&Category.To=5"
                if (v.name === 'Category') {
                    const [from, to] = v.value.split(',');
                    if (from)
                        data['Category.From'] = [from];
                    if (to)
                        data['Category.To'] = [to];
                    return;
                }
                data[v.name] = v.value.split(',');
            });
            return data;
        }
        search(manualSearch = true) {
            this.root.trigger("filter:search" /* Events.FilterSearch */, [this.buildSearchData(), manualSearch]);
        }
        /**
         * Сброс фильтра (кнопка "Очистить фильтр")
         */
        reset() {
            __classPrivateFieldSet(this, _TourSearchMainFilterMobile_suppressChanges, true, "f");
            try {
                super.reset();
            }
            finally {
                __classPrivateFieldSet(this, _TourSearchMainFilterMobile_suppressChanges, false, "f");
            }
            __classPrivateFieldGet(this, _TourSearchMainFilterMobile_options, "f").changes.length = 0;
            (() => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_filterChange).call(this, null); }))();
        }
    }
    _a = TourSearchMainFilterMobile, _TourSearchMainFilterMobile_options = new WeakMap(), _TourSearchMainFilterMobile_popup = new WeakMap(), _TourSearchMainFilterMobile_responseValidator = new WeakMap(), _TourSearchMainFilterMobile_abortController = new WeakMap(), _TourSearchMainFilterMobile_suppressChanges = new WeakMap(), _TourSearchMainFilterMobile_instances = new WeakSet(), _TourSearchMainFilterMobile_onFilterChanged = function _TourSearchMainFilterMobile_onFilterChanged(filterName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _TourSearchMainFilterMobile_suppressChanges, "f"))
                return;
            const changeType = __classPrivateFieldGet(_a, _a, "f", _TourSearchMainFilterMobile_changeTypes)[filterName];
            if (!changeType)
                return;
            // Запоминаем измененный параметр (имя поля формы без суффикса, в нижнем регистре).
            const fieldName = __classPrivateFieldGet(_a, _a, "m", _TourSearchMainFilterMobile_getFieldName).call(_a, filterName);
            if (fieldName && __classPrivateFieldGet(this, _TourSearchMainFilterMobile_options, "f").changes.indexOf(fieldName) < 0)
                __classPrivateFieldGet(this, _TourSearchMainFilterMobile_options, "f").changes.push(fieldName);
            yield __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_filterChange).call(this, changeType);
        });
    }, _TourSearchMainFilterMobile_getFieldName = function _TourSearchMainFilterMobile_getFieldName(filterName) {
        const dotPos = filterName.indexOf('.');
        const name = dotPos >= 0 ? filterName.substring(0, dotPos) : filterName;
        return name.toLowerCase();
    }, _TourSearchMainFilterMobile_filterChange = function _TourSearchMainFilterMobile_filterChange(changeType) {
        return __awaiter(this, void 0, void 0, function* () {
            var _b;
            const changes = [...__classPrivateFieldGet(this, _TourSearchMainFilterMobile_options, "f").changes];
            const rqData = {
                changes,
                changeType: changeType !== null && changeType !== void 0 ? changeType : 'none',
            };
            const city = __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_getCityValue).call(this);
            if (city != null)
                rqData.city = city;
            rqData.direct = this.filters.getControlToggle('Direct') ? 'true' : 'false';
            rqData.charter = this.filters.getControlToggle('Charter') ? 'true' : 'false';
            for (const name of ['Fare', 'Rest', 'Country', 'Resort', 'Program', 'Night', 'Chain', 'Facility', 'Hotel', 'Feature']) {
                const values = __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_getSelectValues).call(this, name);
                if (values.length > 0)
                    rqData[__classPrivateFieldGet(_a, _a, "m", _TourSearchMainFilterMobile_toCamelCase).call(_a, name)] = values;
            }
            const checkinFrom = __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_getDateValue).call(this, 'Checkin.From');
            const checkinTo = __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_getDateValue).call(this, 'Checkin.To');
            if (checkinFrom != null)
                rqData.checkinFrom = checkinFrom;
            if (checkinTo != null)
                rqData.checkinTo = checkinTo;
            const categoryFrom = this.filters.getControlValue('Category.From');
            const categoryTo = this.filters.getControlValue('Category.To');
            if (categoryFrom != null)
                rqData.categoryFrom = categoryFrom.toString();
            if (categoryTo != null)
                rqData.categoryTo = categoryTo.toString();
            (_b = __classPrivateFieldGet(this, _TourSearchMainFilterMobile_abortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            __classPrivateFieldSet(this, _TourSearchMainFilterMobile_abortController, new AbortController(), "f");
            this.submitButton.prop('disabled', true);
            const popupGroup = __classPrivateFieldGet(this, _TourSearchMainFilterMobile_popup, "f").show({
                group: 'filter',
                content: App.templates.Tour.Messages.UpdatingFilters({}),
                modal: true,
                delay: 10000,
            });
            try {
                const response = yield App.app.http.postPwJson(__classPrivateFieldGet(this, _TourSearchMainFilterMobile_options, "f").urls.filters, { body: App.createUrlSearchParams(rqData), signal: __classPrivateFieldGet(this, _TourSearchMainFilterMobile_abortController, "f").signal });
                if (!__classPrivateFieldGet(this, _TourSearchMainFilterMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_applyFiltersData).call(this, response.data);
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TourSearchMainFilterMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldGet(this, _TourSearchMainFilterMobile_popup, "f").hide(popupGroup);
                this.submitButton.prop('disabled', false);
            }
        });
    }, _TourSearchMainFilterMobile_getCityValue = function _TourSearchMainFilterMobile_getCityValue() {
        const value = this.filters.getControlValueString('City');
        return value ? value : null;
    }, _TourSearchMainFilterMobile_getSelectValues = function _TourSearchMainFilterMobile_getSelectValues(name) {
        return this.filters.getControlValueStringArr(name)
            .filter(v => v != null && v !== '');
    }, _TourSearchMainFilterMobile_getDateValue = function _TourSearchMainFilterMobile_getDateValue(name) {
        const control = this.filters.findControl(name);
        const date = control === null || control === void 0 ? void 0 : control.getValue();
        if (!date)
            return null;
        return App.formatDate(date, 'shortDate');
    }, _TourSearchMainFilterMobile_toCamelCase = function _TourSearchMainFilterMobile_toCamelCase(name) {
        return name.charAt(0).toLowerCase() + name.slice(1);
    }, _TourSearchMainFilterMobile_capitalize = function _TourSearchMainFilterMobile_capitalize(name) {
        return name.charAt(0).toUpperCase() + name.slice(1);
    }, _TourSearchMainFilterMobile_applyFiltersData = function _TourSearchMainFilterMobile_applyFiltersData(data) {
        __classPrivateFieldSet(this, _TourSearchMainFilterMobile_suppressChanges, true, "f");
        try {
            for (const key of Object.keys(data)) {
                if (data[key] == null)
                    continue;
                switch (key) {
                    case 'charter': {
                        const charter = data.charter;
                        const control = this.filters.findControl('Charter');
                        if (control && charter.length === 1)
                            control.setValue(charter[0] === 'true');
                        break;
                    }
                    case 'checkin': {
                        const checkin = data.checkin;
                        const from = this.filters.findControl('Checkin.From');
                        const to = this.filters.findControl('Checkin.To');
                        if (from && to && from.getValue() != null && to.getValue() != null && checkin.length >= 2) {
                            from.setValue(App.parseIsoDate(checkin[0]));
                            to.setValue(App.parseIsoDate(checkin[1]));
                        }
                        break;
                    }
                    case 'night': {
                        const options = data.night;
                        // если количество ночей не выбрано пользователем - снимаем выбор со всех опций
                        if (__classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_getSelectValues).call(this, 'Night').length <= 0 && __classPrivateFieldGet(this, _TourSearchMainFilterMobile_options, "f").changes.indexOf('night') < 0)
                            options.forEach(v => (v.selected = false));
                        __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_updateSelectList).call(this, 'Night', options, false);
                        break;
                    }
                    case 'regularCheckinDates':
                    case 'charterCheckinDates':
                        // NOTE: маркировка доступных дат заезда (для календаря) на мобильной версии пока не используется.
                        break;
                    default: {
                        const controlName = __classPrivateFieldGet(_a, _a, "m", _TourSearchMainFilterMobile_capitalize).call(_a, key);
                        const withDefaultOption = __classPrivateFieldGet(_a, _a, "f", _TourSearchMainFilterMobile_defaultOptionTexts)[key] != null;
                        if (this.filters.getControl(controlName))
                            __classPrivateFieldGet(this, _TourSearchMainFilterMobile_instances, "m", _TourSearchMainFilterMobile_updateSelectList).call(this, controlName, data[key], withDefaultOption);
                        break;
                    }
                }
            }
        }
        finally {
            __classPrivateFieldSet(this, _TourSearchMainFilterMobile_suppressChanges, false, "f");
        }
    }, _TourSearchMainFilterMobile_updateSelectList = function _TourSearchMainFilterMobile_updateSelectList(name, options, withDefaultOption) {
        var _b;
        const control = this.filters.findControl(name);
        if (!control)
            return;
        // иерархические списки (курорты) разворачиваем в плоский список
        const flatOptions = __classPrivateFieldGet(_a, _a, "m", _TourSearchMainFilterMobile_flattenOptions).call(_a, options);
        let items = flatOptions;
        if (withDefaultOption) {
            const hasSelected = flatOptions.some(v => v.selected);
            const defaultText = (_b = __classPrivateFieldGet(_a, _a, "f", _TourSearchMainFilterMobile_defaultOptionTexts)[__classPrivateFieldGet(_a, _a, "m", _TourSearchMainFilterMobile_toCamelCase).call(_a, name)]) !== null && _b !== void 0 ? _b : 'Все';
            items = [{ value: '', text: defaultText, selected: !hasSelected }, ...flatOptions];
        }
        control.setValueByListOptions(items);
    }, _TourSearchMainFilterMobile_flattenOptions = function _TourSearchMainFilterMobile_flattenOptions(options) {
        var _b;
        const result = new Array();
        for (const option of options !== null && options !== void 0 ? options : []) {
            result.push({ value: option.value, text: option.text, selected: option.selected });
            if ((_b = option.children) === null || _b === void 0 ? void 0 : _b.length)
                result.push(...__classPrivateFieldGet(_a, _a, "m", _TourSearchMainFilterMobile_flattenOptions).call(_a, option.children));
        }
        return result;
    };
    _TourSearchMainFilterMobile_changeTypes = { value: {
            'City': 'departureCity',
            'Direct': 'directFlight',
            'Charter': 'blockFlight',
            'Fare': 'tourFare',
            'Rest': 'restType',
            'Country': 'country',
            'Resort': 'resort',
            'Program': 'tourProgram',
            'Checkin.From': 'checkinDate',
            'Checkin.To': 'checkinDate',
            'Night': 'tourDuration',
            'Category.From': 'hotelCategory',
            'Category.To': 'hotelCategory',
            'Chain': 'hotelChain',
            'Facility': 'hotelFacility',
            'Hotel': 'hotel',
        } };
    /**
     * Тексты опций "Все ..." для мульти-селектов (добавляются к спискам от GroupFilters).
     * Ключи - имена полей ответа GroupFilters.
     */
    _TourSearchMainFilterMobile_defaultOptionTexts = { value: {
            'fare': 'Все тарифы',
            'rest': 'Все виды отдыха',
            'country': 'Все страны',
            'resort': 'Все курорты',
            'program': 'Все туры',
            'chain': 'Все сети отелей',
            'facility': 'Все услуги',
            'hotel': 'Все отели',
            'feature': 'Все особенности',
        } };
    App.TourSearchMainFilterMobile = TourSearchMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    let TourSortFields;
    (function (TourSortFields) {
        TourSortFields.Alphabet = 'alphabet';
        TourSortFields.Date = 'date';
        TourSortFields.Getting = 'getting';
        TourSortFields.Price = 'price';
        TourSortFields.StarRating = 'starrating';
    })(TourSortFields = App.TourSortFields || (App.TourSortFields = {}));
})(App || (App = {}));
/// <reference path='TourResult.ts' />
/// <reference path='TourSortFields.ts' />
var App;
(function (App) {
    var _TourSearchResultMobile_currencyConverter;
    class TourSearchResultMobile extends App.TourResult {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Tour.BlockOutput_Mobile, tableTemplate: App.templates.Tour.TableOutput_Mobile }, options));
            _TourSearchResultMobile_currencyConverter.set(this, void 0);
        }
        changeDataSource(data_1) {
            const _super = Object.create(null, {
                changeDataSource: { get: () => super.changeDataSource }
            });
            return __awaiter(this, arguments, void 0, function* (data, append = false) {
                if (data.length > 0) {
                    if (!__classPrivateFieldGet(this, _TourSearchResultMobile_currencyConverter, "f"))
                        __classPrivateFieldSet(this, _TourSearchResultMobile_currencyConverter, yield App.CurrencyManager.findConverter(), "f");
                    const currencyConverter = __classPrivateFieldGet(this, _TourSearchResultMobile_currencyConverter, "f");
                    if (currencyConverter) {
                        data.forEach(v => {
                            var _a;
                            v.sortPrice = (_a = currencyConverter.exchange(v.grossPrice, v.currencyCode, data[0].currencyCode)) !== null && _a !== void 0 ? _a : v.grossPrice;
                        });
                    }
                }
                yield _super.changeDataSource.call(this, data, append);
            });
        }
        applyFilters(items) {
            if (this.filtering.items.length <= 0)
                return items;
            let predicate = () => true;
            this.filtering.items
                .filter(v => v.values.length > 0)
                .forEach(v => {
                switch (v.name.toLowerCase()) {
                    case 'programname': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && v.values.some(y => x.title.toLowerCase().includes(y.toLowerCase()));
                        break;
                    }
                    case 'rest': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => y === x.typeKey);
                        break;
                    }
                    case 'country': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && v.values.some(y => y === `${x.country.key}`);
                        break;
                    }
                    case 'route': {
                        const tempPredicate = predicate;
                        predicate = (x) => tempPredicate(x)
                            && v.values.some(y => x.mandatoryRoute.some(z => z.name === y) || x.optionalRoute.some(z => z.name === y));
                        break;
                    }
                    case 'cruisedeparturecity': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.cruiseDepartureCities.some(z => z.key === y));
                        break;
                    }
                    case 'feature': {
                        const tempPredicate = predicate;
                        const numValues = v.values.map(x => parseInt(x, 10));
                        predicate = (x) => tempPredicate(x)
                            && numValues.some(y => x.features.some(z => z.key === y));
                        break;
                    }
                    // no default
                }
            });
            return items.filter(predicate);
        }
        applySorting(items) {
            switch (this.sorting.field) {
                case App.TourSortFields.Alphabet: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.title);
                    else
                        result = Enumerable.from(items).orderBy(v => v.title);
                    return result.toArray();
                }
                case App.TourSortFields.Date: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.beginDate);
                    else
                        result = Enumerable.from(items).orderBy(v => v.beginDate);
                    return result
                        .thenBy(v => v.sortPrice)
                        .thenBy(v => v.title)
                        .thenBy(v => v.key)
                        .toArray();
                }
                case App.TourSortFields.Price: {
                    let result;
                    if (this.sorting.reverse)
                        result = Enumerable.from(items).orderByDescending(v => v.sortPrice);
                    else
                        result = Enumerable.from(items).orderBy(v => v.sortPrice);
                    return result
                        .thenBy(v => v.title)
                        .thenBy(v => v.beginDate)
                        .thenBy(v => v.key)
                        .toArray();
                }
                default: {
                    if (this.sorting.reverse)
                        return [...items].reverse();
                    return items;
                }
            }
        }
        prepareData(viewType, items, addBlock) {
            if (viewType === 'table')
                this.bannerIncutPositions = App.app.settings.tourOptions.bannerIncutPositions.groupTable;
            else
                this.bannerIncutPositions = App.app.settings.tourOptions.bannerIncutPositions.groupBlock;
            return super.prepareData(viewType, items, addBlock);
        }
        fillBannerIncut(item, pos, viewType) {
            var _a, _b, _c, _d, _e, _f;
            const siteUserKey = $('#siteUserKey').valNumber();
            const city = ((_a = this.filters["City" /* TourFilterFields.City */]) !== null && _a !== void 0 ? _a : '').toString();
            const country = ((_b = this.filters["Country" /* TourFilterFields.Country */]) !== null && _b !== void 0 ? _b : '').toString();
            const resort = ((_c = this.filters["Resort" /* TourFilterFields.Resort */]) !== null && _c !== void 0 ? _c : '').toString();
            const rest = ((_d = this.filters["Rest" /* TourFilterFields.Rest */]) !== null && _d !== void 0 ? _d : '').toString();
            const program = ((_e = this.filters["Program" /* TourFilterFields.Program */]) !== null && _e !== void 0 ? _e : '').toString();
            const feature = ((_f = this.filters["Feature" /* TourFilterFields.Feature */]) !== null && _f !== void 0 ? _f : '').toString();
            item.bannerIncutId = `bannerIncut${item.key}-${viewType}-${pos}-Program`;
            item.bannerIncutUrl = `//store.pac.ru/advh.ashx?dom=${item.bannerIncutId}&br=pac-ts-gr-tours-big-${pos}pos&pd=0&sc=10&sb=1&ms=5&ac=1&bc=7&ver=wide&fdp=${city}&tftt=${rest}&fcns=${country}&tfst=${program}&tfat=${feature}&frts=${resort}`;
            if (siteUserKey && siteUserKey > 0)
                item.bannerIncutUrl += `&uk=${siteUserKey}`;
        }
    }
    _TourSearchResultMobile_currencyConverter = new WeakMap();
    App.TourSearchResultMobile = TourSearchResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    let TourServiceType;
    (function (TourServiceType) {
        TourServiceType.Undefined = 0;
        TourServiceType.Flight = 1;
        TourServiceType.Transfer = 2;
        TourServiceType.Hotel = 3;
        TourServiceType.Excursion = 4;
        TourServiceType.Visa = 5;
        TourServiceType.Insurance = 6;
        TourServiceType.Cruise = 7;
        TourServiceType.FuelSurcharge = 1777;
        TourServiceType.Custom = -1;
    })(TourServiceType = App.TourServiceType || (App.TourServiceType = {}));
    let TourCountry;
    (function (TourCountry) {
        TourCountry.Maldives = 960;
    })(TourCountry = App.TourCountry || (App.TourCountry = {}));
})(App || (App = {}));
var App;
(function (App) {
    var _a, _TransferPageMobileBase_formatTime, _TransferPageMobileBase_formatDate, _TransferPageMobileBase_getParamsFromSortBlock, _TransferPageMobileBase_getParamsFromSearchBlock, _TransferPageMobileBase_getParamsOfSelectElementByFilter, _TransferPageMobileBase_getParamsOfInputElementByFilter, _TransferPageMobileBase_onLinkClick;
    class TransferPageMobileBase extends App.PageMobileBase {
        constructor(options) {
            super(Object.assign({}, options));
            Object.defineProperty(this, "context", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "states", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "state", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "seo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "popup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "passengers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            this.context = new App.QueryParams(window.location.pathname).getContext();
            this.seo = {};
            this.popup = new App.Popup();
            // Прокрутка якорных ссылок
            this.root.on('click', '.js-scroll-to', e => App.scrollLinkClickHandler(e));
            // Читать полностью
            this.root.on('click', '.js-read-more', e => App.readMoreClickHandler(e));
            // открытие ссылок внутри блоков (ссылок)
            this.root.on('click', '[data-href]', e => __classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_onLinkClick).call(_a, e));
        }
        static show(jqObj, scrollTop, typeTopScroll) {
            if (!jqObj)
                return;
            jqObj.showByClass();
            if (scrollTop) {
                // typeTopScroll: 1 - body, 2 - сам элемент jqObj
                const scrollObj = typeTopScroll === 1 ? $('body') : jqObj;
                const scrollObjOffset = scrollObj.offset();
                $('html, body').animate({ scrollTop: (scrollObjOffset != null ? scrollObjOffset.top : 0) }, 'slow');
            }
        }
        static distinctObject(array) {
            return array.filter((obj, pos, arr) => arr.map(mapObj => mapObj.value).indexOf(obj.value) === pos);
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                this.cleanPage();
                yield this.states[this.state].handler();
            });
        }
        cleanPage() {
        }
        saveState(state, add, replace, isReplace = false) {
            this.state = state;
            console.log('saveState', add);
            const queryParams = new App.QueryParams(window.location.pathname);
            queryParams.clear();
            queryParams.setAction(this.states[this.state].actionName);
            if (add) {
                Object.getOwnPropertyNames(add).forEach(param => {
                    queryParams.add(param, add[param]);
                });
            }
            if (replace) {
                Object.getOwnPropertyNames(replace).forEach(param => {
                    queryParams.replace(param, replace[param]);
                });
            }
            const url = queryParams.getUrl();
            if (isReplace)
                App.History.replaceState(this.state, url, true);
            else
                App.History.saveState(this.state, url);
        }
        checkMainFilter() {
            return true;
        }
        static convertArrayToRequestData(elements) {
            const data = {};
            $.each(elements, (_, v) => {
                if (v.value == null || v.value === '')
                    return true;
                let values = v.value;
                if (typeof (v.value) === 'string')
                    values = v.value.split(',');
                if (v.name.length > 0 && values.length > 0)
                    data[v.name] = values;
                return true;
            });
            return data;
        }
        static getParamsFromFilters(filter, hotFilter) {
            const params = {};
            let filterParams = __classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_getParamsFromSearchBlock).call(_a, filter);
            if (hotFilter)
                filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_getParamsFromSearchBlock).call(_a, hotFilter));
            filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_getParamsFromSortBlock).call(_a, hotFilter));
            filterParams.forEach(value => {
                params[value.key] = value.value;
            });
            return params;
        }
    }
    _a = TransferPageMobileBase, _TransferPageMobileBase_formatTime = function _TransferPageMobileBase_formatTime(time) {
        // 12:00:00 -> 1200
        const timeParts = time.split(':');
        return timeParts[0] + timeParts[1];
    }, _TransferPageMobileBase_formatDate = function _TransferPageMobileBase_formatDate(date) {
        // 25.03.2017 -> 20170325
        const dateParts = date.split('.');
        return dateParts[2] + dateParts[1] + dateParts[0];
    }, _TransferPageMobileBase_getParamsFromSortBlock = function _TransferPageMobileBase_getParamsFromSortBlock(filter) {
        var _b;
        const params = [];
        const sortValue = (_b = $('.js-sort-item._active ', filter).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
        params.push({ key: 'sort', value: [sortValue] });
        return params;
    }, _TransferPageMobileBase_getParamsFromSearchBlock = function _TransferPageMobileBase_getParamsFromSearchBlock(filter) {
        const params = [];
        filter.find('.filter-block').each((i, element) => {
            var _b;
            if ($(element).hasClass('js-not_for_filter') || $(element).hasClass('overlayed'))
                return;
            const jqElement = $(element);
            // Note: специально используем '||' вместо '??' для обработки NaN.
            const index = Number(jqElement.attr('data-blocksortindex')) || 1000;
            let value = [];
            let key = ((_b = jqElement.attr('data-key')) !== null && _b !== void 0 ? _b : '').toLowerCase();
            const select = jqElement.attr('data-select');
            if (select) {
                if (!key)
                    key = select.toLowerCase();
                value = __classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_getParamsOfSelectElementByFilter).call(_a, element);
            }
            else {
                const name = jqElement.attr('data-name');
                if (name) {
                    if (!key)
                        key = name.toLowerCase();
                    value = __classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_getParamsOfInputElementByFilter).call(_a, element);
                }
            }
            if (key.length > 0 && value.length > 0) {
                const existKey = params.findIndex(el => el.key === key);
                if (existKey !== -1)
                    params[existKey].value = params[existKey].value.concat(value);
                else
                    params.push({ index, key, value });
            }
        });
        return params
            .sort((a, b) => a.index - b.index)
            .map(x => ({
            key: x.key,
            value: x.value.sort((a, b) => a.index - b.index).map(y => y.value),
        }));
    }, _TransferPageMobileBase_getParamsOfSelectElementByFilter = function _TransferPageMobileBase_getParamsOfSelectElementByFilter(el) {
        const values = [];
        const jqEl = $(el);
        jqEl.find('.jelect-option.jelect-option_state_active').each((index, element) => {
            var _b;
            const jqElement = $(element);
            // Note: специально используем '||' вместо '??' для обработки NaN.
            const i = Number(jqEl.attr('data-sortindex')) || Number(jqElement.attr('data-sortindex')) || 100;
            const v = (_b = jqElement.attr('data-val')) !== null && _b !== void 0 ? _b : '';
            if (v.length > 0)
                values.push({ index: i, value: v.toLowerCase() });
        });
        return values;
    }, _TransferPageMobileBase_getParamsOfInputElementByFilter = function _TransferPageMobileBase_getParamsOfInputElementByFilter(el) {
        const values = [];
        const jqEl = $(el);
        jqEl.find('input').each((index, element) => {
            const jqElement = $(element);
            if (jqElement.hasClass('js-not_for_filter'))
                return;
            // Note: специально используем '||' вместо '??' для обработки NaN.
            const i = Number(jqEl.attr('data-sortindex')) || Number(jqElement.attr('data-sortindex')) || 100;
            let value = jqElement.valString();
            if (jqEl.hasClass('js-filter-dates-block'))
                value = __classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_formatDate).call(_a, value);
            if (jqEl.hasClass('js-filter-time-block'))
                value = __classPrivateFieldGet(_a, _a, "m", _TransferPageMobileBase_formatTime).call(_a, value);
            if (jqElement.hasClass('js-return-same'))
                value = value === 'true' ? 'true' : '';
            if (value)
                values.push({ index: i, value: value.toLowerCase() });
        });
        return values;
    }, _TransferPageMobileBase_onLinkClick = function _TransferPageMobileBase_onLinkClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const link = $(event.currentTarget).attr('data-href');
        window.open(link);
        return false;
    };
    App.TransferPageMobileBase = TransferPageMobileBase;
})(App || (App = {}));
/// <reference path='TransferPageBase.Mobile.ts' />
var App;
(function (App) {
    var _TransferBookPageMobile_instances, _a, _TransferBookPageMobile_options, _TransferBookPageMobile_filter, _TransferBookPageMobile_formBook, _TransferBookPageMobile_bookWrapClass, _TransferBookPageMobile_bookWrap, _TransferBookPageMobile_bookForm, _TransferBookPageMobile_queryParams, _TransferBookPageMobile_pricePresenter, _TransferBookPageMobile_formOrder, _TransferBookPageMobile_dataExpiration, _TransferBookPageMobile_bookDigest, _TransferBookPageMobile_passengers, _TransferBookPageMobile_responseValidator, _TransferBookPageMobile_context, _TransferBookPageMobile_bookFilters, _TransferBookPageMobile_allowBooking, _TransferBookPageMobile_expirationPopup, _TransferBookPageMobile_agentBlackListComponent, _TransferBookPageMobile_addCustomValidationRules, _TransferBookPageMobile_showBookPage, _TransferBookPageMobile_renderBookPage, _TransferBookPageMobile_getBookFloaterDigest, _TransferBookPageMobile_getBookContentDigest, _TransferBookPageMobile_getBookContentMainBlock, _TransferBookPageMobile_getExistingPassengers, _TransferBookPageMobile_prepareDataForBook, _TransferBookPageMobile_focusFirstInvalidField, _TransferBookPageMobile_book, _TransferBookPageMobile_onBookButtonClick, _TransferBookPageMobile_onBookSend, _TransferBookPageMobile_onFioChange, _TransferBookPageMobile_onGenderSliderChange, _TransferBookPageMobile_initBookPageScripts, _TransferBookPageMobile_onAllowBookButtonClick, _TransferBookPageMobile_onBookFilterChanged;
    class TransferBookPageMobile extends App.TransferPageMobileBase {
        constructor(options) {
            super(Object.assign({ root: `.js-transfer-page .${App.Application.defaults.appContainerContentClass}` }, options));
            _TransferBookPageMobile_instances.add(this);
            _TransferBookPageMobile_options.set(this, void 0);
            _TransferBookPageMobile_filter.set(this, void 0);
            _TransferBookPageMobile_formBook.set(this, void 0);
            _TransferBookPageMobile_bookWrapClass.set(this, void 0);
            _TransferBookPageMobile_bookWrap.set(this, void 0);
            _TransferBookPageMobile_bookForm.set(this, void 0);
            _TransferBookPageMobile_queryParams.set(this, void 0);
            _TransferBookPageMobile_pricePresenter.set(this, void 0);
            _TransferBookPageMobile_formOrder.set(this, void 0);
            _TransferBookPageMobile_dataExpiration.set(this, void 0);
            _TransferBookPageMobile_bookDigest.set(this, void 0);
            _TransferBookPageMobile_passengers.set(this, void 0);
            _TransferBookPageMobile_responseValidator.set(this, void 0);
            _TransferBookPageMobile_context.set(this, void 0);
            _TransferBookPageMobile_bookFilters.set(this, void 0);
            _TransferBookPageMobile_allowBooking.set(this, void 0);
            _TransferBookPageMobile_expirationPopup.set(this, void 0);
            _TransferBookPageMobile_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _TransferBookPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TransferBookPageMobile_bookWrapClass, '.js-transfer-book', "f");
            __classPrivateFieldSet(this, _TransferBookPageMobile_bookWrap, $(__classPrivateFieldGet(this, _TransferBookPageMobile_bookWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _TransferBookPageMobile_formOrder, $('.js-form-order', __classPrivateFieldGet(this, _TransferBookPageMobile_bookWrap, "f")), "f");
            __classPrivateFieldSet(this, _TransferBookPageMobile_dataExpiration, Number(__classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").dataExpiration), "f");
            __classPrivateFieldSet(this, _TransferBookPageMobile_queryParams, new App.QueryParams(window.location.pathname), "f");
            __classPrivateFieldSet(this, _TransferBookPageMobile_context, __classPrivateFieldGet(this, _TransferBookPageMobile_queryParams, "f").getContext(), "f");
            this.states = {
                'book': {
                    handler: () => __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_showBookPage).call(this),
                    actionName: 'book',
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            // TODO: зачем здесь это? Эти же данные не передаются в конструкторе TransferBookPageMobile.
            const pickupDateLimit = __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").pickupDateLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").pickupDateLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").pickupDateLimit.max) };
            __classPrivateFieldSet(this, _TransferBookPageMobile_filter, new App.TransferBookFilterMobile({
                root: '.js-transfer-book-filter-mobile',
                urls: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").urls,
                defaults: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").defaults,
                datesOptions: {
                    minDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.min,
                    maxDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.max,
                    minDateFromShift: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").defaults.minPickupDateShift,
                    defaultDateFromShift: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").defaults.defaultPickupDateShift,
                    minDateToOffset: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").defaults.minDropoffDateOffset,
                    defaultDateToOffset: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").defaults.defaultDropoffDateOffset,
                },
            }), "f");
            // корзина просрочена
            if (__classPrivateFieldGet(this, _TransferBookPageMobile_expirationPopup, "f") != null)
                __classPrivateFieldGet(this, _TransferBookPageMobile_expirationPopup, "f").cancel();
            __classPrivateFieldSet(this, _TransferBookPageMobile_expirationPopup, App.scheduleExpirationPopup({
                interval: __classPrivateFieldGet(this, _TransferBookPageMobile_dataExpiration, "f"),
                url: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").urls.search,
            }), "f");
            __classPrivateFieldSet(this, _TransferBookPageMobile_formOrder, $('.js-form-order', this.root), "f");
            $('.js-fioFields, .js-addInfo-flightNumber', __classPrivateFieldGet(this, _TransferBookPageMobile_formOrder, "f")).on('change', e => __classPrivateFieldGet(_a, _a, "m", _TransferBookPageMobile_onFioChange).call(_a, e));
            __classPrivateFieldSet(this, _TransferBookPageMobile_formBook, new App.Form({ root: __classPrivateFieldGet(this, _TransferBookPageMobile_filter, "f").searchFilter }), "f");
            __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_addCustomValidationRules).call(this);
            __classPrivateFieldSet(this, _TransferBookPageMobile_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(this.popup),
                validator: __classPrivateFieldGet(this, _TransferBookPageMobile_formBook, "f").validator,
            }), "f");
            __classPrivateFieldGet(this, _TransferBookPageMobile_formOrder, "f").on('change', '.js-form-gender-input', e => __classPrivateFieldGet(_a, _a, "m", _TransferBookPageMobile_onGenderSliderChange).call(_a, e));
            // формат календаря для даты рождения
            const calendars = $('.js-form-date', __classPrivateFieldGet(this, _TransferBookPageMobile_formOrder, "f"));
            calendars.datepicker('option', { changeYear: true, changeMonth: true });
            calendars.inputmask('date');
            $('.js-addInfo-flightNumber', __classPrivateFieldGet(this, _TransferBookPageMobile_formOrder, "f")).inputmask('flightnumber');
            $('.js-addInfo-time', __classPrivateFieldGet(this, _TransferBookPageMobile_formOrder, "f")).inputmask('time');
            $('.js-digest-floater-button', this.root).on('click', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_onBookButtonClick).call(this, e); }));
            __classPrivateFieldSet(this, _TransferBookPageMobile_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
            App.History.replaceState(this.state, __classPrivateFieldGet(this, _TransferBookPageMobile_queryParams, "f").getUrl());
        }
    }
    _a = TransferBookPageMobile, _TransferBookPageMobile_options = new WeakMap(), _TransferBookPageMobile_filter = new WeakMap(), _TransferBookPageMobile_formBook = new WeakMap(), _TransferBookPageMobile_bookWrapClass = new WeakMap(), _TransferBookPageMobile_bookWrap = new WeakMap(), _TransferBookPageMobile_bookForm = new WeakMap(), _TransferBookPageMobile_queryParams = new WeakMap(), _TransferBookPageMobile_pricePresenter = new WeakMap(), _TransferBookPageMobile_formOrder = new WeakMap(), _TransferBookPageMobile_dataExpiration = new WeakMap(), _TransferBookPageMobile_bookDigest = new WeakMap(), _TransferBookPageMobile_passengers = new WeakMap(), _TransferBookPageMobile_responseValidator = new WeakMap(), _TransferBookPageMobile_context = new WeakMap(), _TransferBookPageMobile_bookFilters = new WeakMap(), _TransferBookPageMobile_allowBooking = new WeakMap(), _TransferBookPageMobile_expirationPopup = new WeakMap(), _TransferBookPageMobile_agentBlackListComponent = new WeakMap(), _TransferBookPageMobile_instances = new WeakSet(), _TransferBookPageMobile_addCustomValidationRules = function _TransferBookPageMobile_addCustomValidationRules() {
        $.validator.addMethod('checkdropoffdate', (value, element) => {
            const time = value;
            const date = $(element).parents('.form-group').find('.js-form-date').val();
            const isReturnPoint = $(element).hasClass('js-return-addInfo');
            if (!date || !time)
                return false;
            const pDate = isReturnPoint ? __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.returnPoints.pickup.date : __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.pickup.date;
            const minDate = new Date(pDate);
            const journeyTime = __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.journeyTime;
            const jtParts = journeyTime.split(':');
            minDate.setHours(minDate.getHours() + Number(jtParts[0]));
            minDate.setMinutes(minDate.getMinutes() + Number(jtParts[1]));
            const dParts = date.toString().split('.');
            const tParts = time.toString().split(':');
            const newDate = new Date(Number(dParts[2]), Number(dParts[1]) - 1, Number(dParts[0]), Number(tParts[0]), Number(tParts[1]));
            return newDate > minDate;
        });
        $.validator.addMethod('checkpickupdate', (value, element) => {
            const time = value;
            const date = $(element).parents('.form-group').find('.js-form-date').val();
            const isReturnPoint = $(element).hasClass('js-return-addInfo');
            if (!date || !time)
                return false;
            const pDate = isReturnPoint ? __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.returnPoints.pickup.date : __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.pickup.date;
            const minDate = new Date(pDate);
            const dParts = date.toString().split('.');
            const tParts = time.toString().split(':');
            const newDate = new Date(Number(dParts[2]), Number(dParts[1]) - 1, Number(dParts[0]), Number(tParts[0]), Number(tParts[1]));
            return newDate < minDate;
        });
    }, _TransferBookPageMobile_showBookPage = function _TransferBookPageMobile_showBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.TransferPageMobileBase.show(__classPrivateFieldGet(this, _TransferBookPageMobile_bookWrap, "f"), true, 1);
            yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_renderBookPage).call(this);
        });
    }, _TransferBookPageMobile_renderBookPage = function _TransferBookPageMobile_renderBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            __classPrivateFieldSet(this, _TransferBookPageMobile_bookDigest, new App.DigestMobile({
                buttonTitle: 'Забронировать',
                headerTitle: 'Детали',
                onClick: () => __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_onBookSend).call(this),
                allowBooking: true, // this.#allowBooking,
            }), "f");
            __classPrivateFieldGet(this, _TransferBookPageMobile_bookDigest, "f").empty();
            $('.js-transfer-book-content', __classPrivateFieldGet(this, _TransferBookPageMobile_bookWrap, "f")).empty();
            const containerFooter = $('.js-digest-footer', this.root);
            containerFooter.empty();
            const digestData = {
                offer: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer,
                bookDigestData: {
                    servicePrices: [],
                    netPrice: typeof __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.netPrice !== 'undefined' ? __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.netPrice : undefined,
                    grossPrice: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.grossPrice,
                    discount: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.grossPrice - ((_b = __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.price) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.grossPrice),
                    price: (_c = __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.price) !== null && _c !== void 0 ? _c : __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.grossPrice,
                    currencyCode: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.currencyCode,
                    hasDetails: false,
                    pricePresenter: {
                        type: __classPrivateFieldGet(this, _TransferBookPageMobile_pricePresenter, "f").type,
                        show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                    },
                    notes: [],
                },
            };
            if (__classPrivateFieldGet(this, _TransferBookPageMobile_context, "f"))
                yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_getExistingPassengers).call(this);
            const digestContent = yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_getBookContentDigest).call(this, digestData);
            const digestFloater = yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_getBookFloaterDigest).call(this, digestData);
            const mainBookBlock = __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_getBookContentMainBlock).call(this);
            yield __classPrivateFieldGet(this, _TransferBookPageMobile_bookDigest, "f").setContent(digestContent);
            __classPrivateFieldGet(this, _TransferBookPageMobile_bookDigest, "f").setFloater(digestFloater);
            $('.js-transfer-book-content', __classPrivateFieldGet(this, _TransferBookPageMobile_bookWrap, "f")).append(mainBookBlock);
            yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_initBookPageScripts).call(this);
        });
    }, _TransferBookPageMobile_getBookFloaterDigest = function _TransferBookPageMobile_getBookFloaterDigest(model) {
        return __awaiter(this, void 0, void 0, function* () {
            return $(App.templates.Transfer.Book.BlockDigest_Floater_Mobile(model));
        });
    }, _TransferBookPageMobile_getBookContentDigest = function _TransferBookPageMobile_getBookContentDigest(model) {
        return __awaiter(this, void 0, void 0, function* () {
            return $(App.templates.Transfer.Book.BlockDigest_Mobile(model));
        });
    }, _TransferBookPageMobile_getBookContentMainBlock = function _TransferBookPageMobile_getBookContentMainBlock() {
        const passengers = Object.values(__classPrivateFieldGet(this, _TransferBookPageMobile_passengers, "f") || {});
        return $(App.templates.Transfer.Book.BlockMain_Mobile({
            existingPassengers: __classPrivateFieldGet(this, _TransferBookPageMobile_passengers, "f"),
            adultsArray: Array.from({ length: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.adultsCount }, () => ({
                findTouristData: App.FindTouristMobile.ViewModel({ minLength: 4 }),
                existingPassengerData: App.ExistingPassengersMobile.ViewModelByExistingPassengers(passengers === null || passengers === void 0 ? void 0 : passengers.filter(x => App.getAge(App.parseIsoDate(x.birthday)) > __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").defaults.maxChildAge)),
            })),
            childrenArray: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.childAges.map(x => ({
                age: x,
                ageTitle: App.pluralRu(x, 'год', 'года', 'лет'),
                existingPassengerData: App.ExistingPassengersMobile.ViewModelByExistingPassengers(passengers === null || passengers === void 0 ? void 0 : passengers.filter(p => App.getAge(App.parseIsoDate(p.birthday)) <= __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").defaults.maxChildAge)),
            })),
            allowBooking: __classPrivateFieldGet(this, _TransferBookPageMobile_allowBooking, "f"),
            dateTourist: {
                meta: {
                    minDate: App.addDays(new Date(), App.MobileFilterDateBlock.yearRangeLeft * 365),
                    maxDate: App.addDays(new Date(), App.MobileFilterDateBlock.yearRangeRight * 365),
                    formatReturn: 'isoDate',
                },
            },
            offer: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer,
            isAdditionalInfo: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.pickup.isNeedTripInfo
                || __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.dropoff.isNeedTripInfo
                || (__classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.returnPoints != null && __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.returnPoints.pickup.isNeedTripInfo)
                || (__classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.returnPoints != null && __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").offer.returnPoints.dropoff.isNeedTripInfo),
        }));
    }, _TransferBookPageMobile_getExistingPassengers = function _TransferBookPageMobile_getExistingPassengers() {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _TransferBookPageMobile_passengers, undefined, "f");
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").urls.getExistingPassengers,
                method: 'GET',
                data: {
                    context: __classPrivateFieldGet(this, _TransferBookPageMobile_context, "f"),
                },
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _TransferBookPageMobile_responseValidator, "f").process(response))
                    return;
                __classPrivateFieldSet(this, _TransferBookPageMobile_passengers, response.data.existingPassengers, "f");
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TransferBookPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
        });
    }, _TransferBookPageMobile_prepareDataForBook = function _TransferBookPageMobile_prepareDataForBook() {
        var _b;
        let elements = __classPrivateFieldGet(this, _TransferBookPageMobile_bookFilters, "f").filters.serializeArray(); // this.#formOrder.serializeArray();
        elements = elements.concat(__classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").searchData);
        // fixme из шаблона, поле в фильтры не попадает, грязный фикс
        elements = elements.concat([{ name: 'Services[0].Key', value: ((_b = __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").searchData.find(item => item.name === 'Key')) === null || _b === void 0 ? void 0 : _b.value) || '' }]);
        return App.TransferPageMobileBase.convertArrayToRequestData(elements);
    }, _TransferBookPageMobile_focusFirstInvalidField = function _TransferBookPageMobile_focusFirstInvalidField() {
        const invalidField = __classPrivateFieldGet(this, _TransferBookPageMobile_bookForm, "f").find('._invalid').first();
        const position = invalidField.offset();
        $('html, body').animate({ scrollTop: position ? position.top : 0 }, 'slow');
        setTimeout(() => { invalidField.trigger('focus'); }, 1000);
    }, _TransferBookPageMobile_book = function _TransferBookPageMobile_book() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _TransferBookPageMobile_formBook, "f").validator.form())
                return;
            const data = __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_prepareDataForBook).call(this);
            if (this.context)
                data.context = this.context;
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _TransferBookPageMobile_options, "f").urls.book,
                method: 'POST',
                data,
            });
            const popupGroup = this.popup.show({
                group: 'filter',
                content: App.templates.Transfer.Messages.Booking({}),
                modal: true,
                delay: 500,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _TransferBookPageMobile_responseValidator, "f").process(response)) {
                    __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_focusFirstInvalidField).call(this);
                    return;
                }
                return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TransferBookPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                this.popup.hide(popupGroup);
            }
        });
    }, _TransferBookPageMobile_onBookButtonClick = function _TransferBookPageMobile_onBookButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _TransferBookPageMobile_formBook, "f").validator.form()) {
                __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_focusFirstInvalidField).call(this);
                return;
            }
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _TransferBookPageMobile_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_book).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_book).call(this);
            }
        });
    }, _TransferBookPageMobile_onBookSend = function _TransferBookPageMobile_onBookSend() {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _TransferBookPageMobile_bookDigest, "f"))
                __classPrivateFieldGet(this, _TransferBookPageMobile_bookDigest, "f").close();
            $('#allowBook').trigger('click');
        });
    }, _TransferBookPageMobile_onFioChange = function _TransferBookPageMobile_onFioChange(event) {
        $(event.currentTarget).val(App.transliterateName($(event.currentTarget).valString()));
    }, _TransferBookPageMobile_onGenderSliderChange = function _TransferBookPageMobile_onGenderSliderChange(event) {
        const input = $(event.currentTarget);
        input.closest('.js-form-gender').find('.js-form-gender-icon')
            .toggleClass('_man', input.is(':checked') && input.val() === 'Male')
            .toggleClass('_woman', input.is(':checked') && input.val() === 'Female');
    }, _TransferBookPageMobile_initBookPageScripts = function _TransferBookPageMobile_initBookPageScripts() {
        return __awaiter(this, void 0, void 0, function* () {
            App.ExistingPassengersMobile.Creates();
            App.FindTouristMobile.Creates();
            __classPrivateFieldSet(this, _TransferBookPageMobile_bookFilters, new App.FilterMobile({
                root: '.js-form-order',
                onFilterChanged: () => __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_onBookFilterChanged).call(this),
            }), "f");
            __classPrivateFieldSet(this, _TransferBookPageMobile_formBook, new App.Form({ root: __classPrivateFieldGet(this, _TransferBookPageMobile_bookFilters, "f").root }), "f");
            this.components.push(__classPrivateFieldGet(this, _TransferBookPageMobile_formBook, "f"));
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _TransferBookPageMobile_agentBlackListComponent, new App.AgentBlackListMobile(), "f");
                this.components.push(__classPrivateFieldGet(this, _TransferBookPageMobile_agentBlackListComponent, "f"));
            }
            __classPrivateFieldSet(this, _TransferBookPageMobile_bookForm, $('.js-form-order', this.root), "f");
            $('.js-flightNumber .js-mobile-filter-value', __classPrivateFieldGet(this, _TransferBookPageMobile_bookForm, "f")).inputmask('flightnumber');
            // разлочить кнопку бронирования
            $('.form-btn', __classPrivateFieldGet(this, _TransferBookPageMobile_bookWrap, "f")).removeAttr('disabled');
            $('#allowBook', __classPrivateFieldGet(this, _TransferBookPageMobile_bookForm, "f")).on('click', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferBookPageMobile_instances, "m", _TransferBookPageMobile_onAllowBookButtonClick).call(this); }));
        });
    }, _TransferBookPageMobile_onAllowBookButtonClick = function _TransferBookPageMobile_onAllowBookButtonClick() {
        return __awaiter(this, void 0, void 0, function* () {
            // no-op
        });
    }, _TransferBookPageMobile_onBookFilterChanged = function _TransferBookPageMobile_onBookFilterChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            // no-op
        });
    };
    App.TransferBookPageMobile = TransferBookPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _TransferPageBase_formatTime, _TransferPageBase_formatDate, _TransferPageBase_getParamsFromSortBlock, _TransferPageBase_getParamsFromSearchBlock, _TransferPageBase_getParamsOfSelectElementByFilter, _TransferPageBase_getParamsOfInputElementByFilter, _TransferPageBase_onLinkClick;
    class TransferPageBase extends App.PageBase {
        constructor(options) {
            super(Object.assign({}, options));
            Object.defineProperty(this, "context", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "states", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "state", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "seo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "popup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "passengers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length)
                return;
            this.context = new App.QueryParams(window.location.pathname).getContext();
            this.seo = {};
            this.popup = new App.Popup();
            // Прокрутка якорных ссылок
            this.root.on('click', '.js-scroll-to', e => App.scrollLinkClickHandler(e));
            // Читать полностью
            this.root.on('click', '.js-read-more', e => App.readMoreClickHandler(e));
            // открытие ссылок внутри блоков (ссылок)
            this.root.on('click', '[data-href]', e => __classPrivateFieldGet(_a, _a, "m", _TransferPageBase_onLinkClick).call(_a, e));
        }
        static show(jqObj, scrollTop, typeTopScroll) {
            if (!jqObj)
                return;
            jqObj.showByClass();
            if (scrollTop) {
                // typeTopScroll: 1 - body, 2 - сам элемент jqObj
                const scrollObj = typeTopScroll === 1 ? $('body') : jqObj;
                const scrollObjOffset = scrollObj.offset();
                $('html, body').animate({ scrollTop: (scrollObjOffset != null ? scrollObjOffset.top : 0) }, 'slow');
            }
        }
        static distinctObject(array) {
            return array.filter((obj, pos, arr) => arr.map(mapObj => mapObj.value).indexOf(obj.value) === pos);
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                this.cleanPage();
                yield this.states[this.state].handler();
            });
        }
        cleanPage() {
        }
        saveState(state, add, replace, isReplace = false) {
            this.state = state;
            const queryParams = new App.QueryParams(window.location.pathname);
            queryParams.clear();
            queryParams.setAction(this.states[this.state].actionName);
            if (add) {
                Object.getOwnPropertyNames(add).forEach(param => {
                    queryParams.add(param, add[param]);
                });
            }
            if (replace) {
                Object.getOwnPropertyNames(replace).forEach(param => {
                    queryParams.replace(param, replace[param]);
                });
            }
            const url = queryParams.getUrl();
            if (isReplace)
                App.History.replaceState(this.state, url, true);
            else
                App.History.saveState(this.state, url);
        }
        checkMainFilter() {
            return true;
        }
        static convertArrayToRequestData(elements) {
            const data = {};
            $.each(elements, (_, v) => {
                if (v.value == null || v.value === '')
                    return true;
                let values = v.value;
                if (typeof (v.value) === 'string')
                    values = v.value.split(',');
                if (v.name.length > 0 && values.length > 0)
                    data[v.name] = values;
                return true;
            });
            return data;
        }
        static getParamsFromFilters(filter, hotFilter) {
            const params = {};
            let filterParams = __classPrivateFieldGet(_a, _a, "m", _TransferPageBase_getParamsFromSearchBlock).call(_a, filter);
            if (hotFilter)
                filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _TransferPageBase_getParamsFromSearchBlock).call(_a, hotFilter));
            filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _TransferPageBase_getParamsFromSortBlock).call(_a, hotFilter));
            filterParams.forEach(value => {
                params[value.key] = value.value;
            });
            return params;
        }
    }
    _a = TransferPageBase, _TransferPageBase_formatTime = function _TransferPageBase_formatTime(time) {
        // 12:00:00 -> 1200
        const timeParts = time.split(':');
        return timeParts[0] + timeParts[1];
    }, _TransferPageBase_formatDate = function _TransferPageBase_formatDate(date) {
        // 25.03.2017 -> 20170325
        const dateParts = date.split('.');
        return dateParts[2] + dateParts[1] + dateParts[0];
    }, _TransferPageBase_getParamsFromSortBlock = function _TransferPageBase_getParamsFromSortBlock(filter) {
        var _b;
        const params = [];
        const sortValue = (_b = $('.js-sort-item._active ', filter).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
        params.push({ key: 'sort', value: [sortValue] });
        return params;
    }, _TransferPageBase_getParamsFromSearchBlock = function _TransferPageBase_getParamsFromSearchBlock(filter) {
        const params = [];
        filter.find('.filter-block').each((i, element) => {
            var _b;
            if ($(element).hasClass('js-not_for_filter') || $(element).hasClass('overlayed'))
                return;
            const jqElement = $(element);
            // Note: специально используем '||' вместо '??' для обработки NaN.
            const index = Number(jqElement.attr('data-blocksortindex')) || 1000;
            let value = [];
            let key = ((_b = jqElement.attr('data-key')) !== null && _b !== void 0 ? _b : '').toLowerCase();
            const select = jqElement.attr('data-select');
            if (select) {
                if (!key)
                    key = select.toLowerCase();
                value = __classPrivateFieldGet(_a, _a, "m", _TransferPageBase_getParamsOfSelectElementByFilter).call(_a, element);
            }
            else {
                const name = jqElement.attr('data-name');
                if (name) {
                    if (!key)
                        key = name.toLowerCase();
                    value = __classPrivateFieldGet(_a, _a, "m", _TransferPageBase_getParamsOfInputElementByFilter).call(_a, element);
                }
            }
            if (key.length > 0 && value.length > 0) {
                const existKey = params.findIndex(el => el.key === key);
                if (existKey !== -1)
                    params[existKey].value = params[existKey].value.concat(value);
                else
                    params.push({ index, key, value });
            }
        });
        return params
            .sort((a, b) => a.index - b.index)
            .map(x => ({
            key: x.key,
            value: x.value.sort((a, b) => a.index - b.index).map(y => y.value),
        }));
    }, _TransferPageBase_getParamsOfSelectElementByFilter = function _TransferPageBase_getParamsOfSelectElementByFilter(el) {
        const values = [];
        const jqEl = $(el);
        jqEl.find('.jelect-option.jelect-option_state_active').each((index, element) => {
            var _b;
            const jqElement = $(element);
            // Note: специально используем '||' вместо '??' для обработки NaN.
            const i = Number(jqEl.attr('data-sortindex')) || Number(jqElement.attr('data-sortindex')) || 100;
            const v = (_b = jqElement.attr('data-val')) !== null && _b !== void 0 ? _b : '';
            if (v.length > 0)
                values.push({ index: i, value: v.toLowerCase() });
        });
        return values;
    }, _TransferPageBase_getParamsOfInputElementByFilter = function _TransferPageBase_getParamsOfInputElementByFilter(el) {
        const values = [];
        const jqEl = $(el);
        jqEl.find('input').each((index, element) => {
            const jqElement = $(element);
            if (jqElement.hasClass('js-not_for_filter'))
                return;
            // Note: специально используем '||' вместо '??' для обработки NaN.
            const i = Number(jqEl.attr('data-sortindex')) || Number(jqElement.attr('data-sortindex')) || 100;
            let value = jqElement.valString();
            if (jqEl.hasClass('js-filter-dates-block'))
                value = __classPrivateFieldGet(_a, _a, "m", _TransferPageBase_formatDate).call(_a, value);
            if (jqEl.hasClass('js-filter-time-block'))
                value = __classPrivateFieldGet(_a, _a, "m", _TransferPageBase_formatTime).call(_a, value);
            if (jqElement.hasClass('js-return-same'))
                value = value === 'true' ? 'true' : '';
            if (value)
                values.push({ index: i, value: value.toLowerCase() });
        });
        return values;
    }, _TransferPageBase_onLinkClick = function _TransferPageBase_onLinkClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const link = $(event.currentTarget).attr('data-href');
        window.open(link);
        return false;
    };
    App.TransferPageBase = TransferPageBase;
})(App || (App = {}));
/// <reference path='TransferPageBase.ts' />
var App;
(function (App) {
    var _TransferBookPage_instances, _a, _TransferBookPage_options, _TransferBookPage_formBook, _TransferBookPage_bookWrapClass, _TransferBookPage_bookWrap, _TransferBookPage_pricePresenter, _TransferBookPage_formOrder, _TransferBookPage_responseValidator, _TransferBookPage_dataExpiration, _TransferBookPage_expirationPopup, _TransferBookPage_agentBlackListComponent, _TransferBookPage_addCustomValidationRules, _TransferBookPage_showBookPage, _TransferBookPage_updateDigestFooter, _TransferBookPage_prepareDataForBook, _TransferBookPage_focusFirstInvalidField, _TransferBookPage_book, _TransferBookPage_onBookButtonClick, _TransferBookPage_onFioChange, _TransferBookPage_onGenderSliderChange;
    class TransferBookPage extends App.TransferPageBase {
        constructor(options) {
            super(Object.assign({ root: `.js-transfer-page .${App.Application.defaults.appContainerContentClass}` }, options));
            _TransferBookPage_instances.add(this);
            _TransferBookPage_options.set(this, void 0);
            _TransferBookPage_formBook.set(this, void 0);
            _TransferBookPage_bookWrapClass.set(this, void 0);
            _TransferBookPage_bookWrap.set(this, void 0);
            _TransferBookPage_pricePresenter.set(this, void 0);
            // обертка для бронирования круиза
            _TransferBookPage_formOrder.set(this, void 0);
            _TransferBookPage_responseValidator.set(this, void 0);
            _TransferBookPage_dataExpiration.set(this, void 0);
            _TransferBookPage_expirationPopup.set(this, void 0);
            _TransferBookPage_agentBlackListComponent.set(this, void 0);
            __classPrivateFieldSet(this, _TransferBookPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TransferBookPage_bookWrapClass, '.js-transfer-book', "f");
            __classPrivateFieldSet(this, _TransferBookPage_bookWrap, $(__classPrivateFieldGet(this, _TransferBookPage_bookWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _TransferBookPage_formOrder, $('.js-form-order', __classPrivateFieldGet(this, _TransferBookPage_bookWrap, "f")), "f");
            __classPrivateFieldSet(this, _TransferBookPage_dataExpiration, Number(__classPrivateFieldGet(this, _TransferBookPage_options, "f").dataExpiration), "f");
            this.states = {
                'book': {
                    handler: () => __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_showBookPage).call(this),
                    actionName: 'book',
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            // корзина просрочена
            if (__classPrivateFieldGet(this, _TransferBookPage_expirationPopup, "f") != null)
                __classPrivateFieldGet(this, _TransferBookPage_expirationPopup, "f").cancel();
            __classPrivateFieldSet(this, _TransferBookPage_expirationPopup, App.scheduleExpirationPopup({
                interval: __classPrivateFieldGet(this, _TransferBookPage_dataExpiration, "f"),
                url: __classPrivateFieldGet(this, _TransferBookPage_options, "f").urls.search,
            }), "f");
            __classPrivateFieldSet(this, _TransferBookPage_formOrder, $('.js-form-order', this.root), "f");
            // Note: переносим до создания класса Form и используем неделегируемые события для внесения изменений в значение поля перед его
            // валидацией.
            $('.js-fioFields, .js-addInfo-flightNumber', __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f")).on('change', e => __classPrivateFieldGet(_a, _a, "m", _TransferBookPage_onFioChange).call(_a, e));
            this.components.push(new App.Digest({ container: this.root }), new App.ExistingPassengers(), new App.FindTourist());
            if (App.app.userSettings.isAgentInBlackList) {
                __classPrivateFieldSet(this, _TransferBookPage_agentBlackListComponent, new App.AgentBlackListComponent(), "f");
                this.components.push(__classPrivateFieldGet(this, _TransferBookPage_agentBlackListComponent, "f"));
            }
            const filter = new App.Filter({ root: '.js-form-order' });
            __classPrivateFieldSet(this, _TransferBookPage_formBook, new App.Form({ root: filter.root }), "f");
            __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_addCustomValidationRules).call(this);
            __classPrivateFieldSet(this, _TransferBookPage_responseValidator, new App.ResponseValidatorOld({
                messenger: new App.PopupMessenger(this.popup),
                validator: __classPrivateFieldGet(this, _TransferBookPage_formBook, "f").validator,
            }), "f");
            // пол ж/м
            __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f").on('change', '.js-form-gender-input', e => __classPrivateFieldGet(_a, _a, "m", _TransferBookPage_onGenderSliderChange).call(_a, e));
            // формат календаря для даты рождения
            const calendars = $('.js-form-date', __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f"));
            calendars.inputmask('date');
            $('.js-addInfo-flightNumber', __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f")).inputmask('flightnumber');
            $('.js-addInfo-time', __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f")).inputmask('time');
            __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f").on('submit', (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_onBookButtonClick).call(this, e); }));
            __classPrivateFieldSet(this, _TransferBookPage_pricePresenter, new App.NetPricePresenter({ root: this.root }), "f");
        }
        run(signal) {
            const _super = Object.create(null, {
                run: { get: () => super.run }
            });
            return __awaiter(this, void 0, void 0, function* () {
                yield _super.run.call(this, signal);
                yield __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_updateDigestFooter).call(this);
            });
        }
    }
    _a = TransferBookPage, _TransferBookPage_options = new WeakMap(), _TransferBookPage_formBook = new WeakMap(), _TransferBookPage_bookWrapClass = new WeakMap(), _TransferBookPage_bookWrap = new WeakMap(), _TransferBookPage_pricePresenter = new WeakMap(), _TransferBookPage_formOrder = new WeakMap(), _TransferBookPage_responseValidator = new WeakMap(), _TransferBookPage_dataExpiration = new WeakMap(), _TransferBookPage_expirationPopup = new WeakMap(), _TransferBookPage_agentBlackListComponent = new WeakMap(), _TransferBookPage_instances = new WeakSet(), _TransferBookPage_addCustomValidationRules = function _TransferBookPage_addCustomValidationRules() {
        $.validator.addMethod('checkdropoffdate', (value, element) => {
            const time = value;
            const date = $(element).parents('.form-group').find('.js-form-date').val();
            const isReturnPoint = $(element).hasClass('js-return-addInfo');
            if (!date || !time)
                return false;
            const pDate = isReturnPoint ? __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.returnPoints.pickup.date : __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.pickup.date;
            const minDate = new Date(pDate);
            const journeyTime = __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.journeyTime;
            const jtParts = journeyTime.split(':');
            minDate.setHours(minDate.getHours() + Number(jtParts[0]));
            minDate.setMinutes(minDate.getMinutes() + Number(jtParts[1]));
            const dParts = date.toString().split('.');
            const tParts = time.toString().split(':');
            const newDate = new Date(Number(dParts[2]), Number(dParts[1]) - 1, Number(dParts[0]), Number(tParts[0]), Number(tParts[1]));
            return newDate > minDate;
        });
        $.validator.addMethod('checkpickupdate', (value, element) => {
            const time = value;
            const date = $(element).parents('.form-group').find('.js-form-date').val();
            const isReturnPoint = $(element).hasClass('js-return-addInfo');
            if (!date || !time)
                return false;
            const pDate = isReturnPoint ? __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.returnPoints.pickup.date : __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.pickup.date;
            const minDate = new Date(pDate);
            const dParts = date.toString().split('.');
            const tParts = time.toString().split(':');
            const newDate = new Date(Number(dParts[2]), Number(dParts[1]) - 1, Number(dParts[0]), Number(tParts[0]), Number(tParts[1]));
            return newDate < minDate;
        });
    }, _TransferBookPage_showBookPage = function _TransferBookPage_showBookPage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.TransferPageBase.show(__classPrivateFieldGet(this, _TransferBookPage_bookWrap, "f"), true, 1);
            yield __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_updateDigestFooter).call(this);
        });
    }, _TransferBookPage_updateDigestFooter = function _TransferBookPage_updateDigestFooter() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            const containerFooter = $('.js-digest-footer', this.root);
            containerFooter.empty();
            const data = {
                servicePrices: [],
                netPrice: typeof __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.netPrice !== 'undefined' ? __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.netPrice : undefined,
                grossPrice: __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.grossPrice,
                discount: __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.grossPrice - ((_b = __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.price) !== null && _b !== void 0 ? _b : __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.grossPrice),
                price: (_c = __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.price) !== null && _c !== void 0 ? _c : __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.grossPrice,
                currencyCode: __classPrivateFieldGet(this, _TransferBookPage_options, "f").offer.currencyCode,
                hasDetails: false,
                pricePresenter: {
                    type: __classPrivateFieldGet(this, _TransferBookPage_pricePresenter, "f").type,
                    show: (yield App.app.auth.getStatus()) && App.NetPricePresenter.getVisibility(),
                },
                notes: [],
            };
            const contentFooter = $(App.templates.BookDigestFooter(data));
            containerFooter.append(contentFooter);
        });
    }, _TransferBookPage_prepareDataForBook = function _TransferBookPage_prepareDataForBook() {
        let elements = __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f").serializeArray();
        elements = elements.concat(__classPrivateFieldGet(this, _TransferBookPage_options, "f").searchData);
        return App.TransferPageBase.convertArrayToRequestData(elements);
    }, _TransferBookPage_focusFirstInvalidField = function _TransferBookPage_focusFirstInvalidField() {
        const invalidField = __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f").find('._invalid').first();
        const position = __classPrivateFieldGet(this, _TransferBookPage_formOrder, "f").find('.js-booking-content-driver_info_persons').offset();
        $('html, body').animate({ scrollTop: position ? position.top : 0 }, 'slow');
        setTimeout(() => { invalidField.trigger('focus'); }, 1000);
    }, _TransferBookPage_book = function _TransferBookPage_book() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _TransferBookPage_formBook, "f").validator.form())
                return;
            const data = __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_prepareDataForBook).call(this);
            if (this.context)
                data.context = this.context;
            const xhr = $.ajax({
                url: __classPrivateFieldGet(this, _TransferBookPage_options, "f").urls.book,
                method: 'POST',
                data,
            });
            const popupGroup = this.popup.show({
                group: 'filter',
                content: App.templates.Transfer.Messages.Booking({}),
                modal: true,
                delay: 500,
            });
            try {
                const response = yield xhr;
                if (!__classPrivateFieldGet(this, _TransferBookPage_responseValidator, "f").process(response)) {
                    __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_focusFirstInvalidField).call(this);
                    return;
                }
                return;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TransferBookPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                this.popup.hide(popupGroup);
            }
        });
    }, _TransferBookPage_onBookButtonClick = function _TransferBookPage_onBookButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (!__classPrivateFieldGet(this, _TransferBookPage_formBook, "f").validator.form()) {
                __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_focusFirstInvalidField).call(this);
                return;
            }
            if (App.app.userSettings.isAgentInBlackList && !__classPrivateFieldGet(this, _TransferBookPage_agentBlackListComponent, "f").checkAgree()) {
                $(document)
                    .off("agentInBlackList:agree" /* Events.AgentInBlackListAgree */)
                    .on("agentInBlackList:agree" /* Events.AgentInBlackListAgree */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_book).call(this); }));
            }
            else {
                yield __classPrivateFieldGet(this, _TransferBookPage_instances, "m", _TransferBookPage_book).call(this);
            }
        });
    }, _TransferBookPage_onFioChange = function _TransferBookPage_onFioChange(event) {
        $(event.currentTarget).val(App.transliterateName($(event.currentTarget).valString()));
    }, _TransferBookPage_onGenderSliderChange = function _TransferBookPage_onGenderSliderChange(event) {
        const input = $(event.currentTarget);
        input.closest('.js-form-gender').find('.js-form-gender-icon')
            .toggleClass('_man', input.is(':checked') && input.val() === 'Male')
            .toggleClass('_woman', input.is(':checked') && input.val() === 'Female');
    };
    App.TransferBookPage = TransferBookPage;
})(App || (App = {}));
/// <reference path='./TransferPageBase.Mobile.ts' />
var App;
(function (App) {
    var _TransferSearchPageMobile_instances, _a, _TransferSearchPageMobile_options, _TransferSearchPageMobile_preloader, _TransferSearchPageMobile_filter, _TransferSearchPageMobile_form, _TransferSearchPageMobile_messenger, _TransferSearchPageMobile_responseValidator, _TransferSearchPageMobile_hotFilter, _TransferSearchPageMobile_result, _TransferSearchPageMobile_searchResultsWrapClass, _TransferSearchPageMobile_searchResultsHotFilterClass, _TransferSearchPageMobile_searchResultsWrap, _TransferSearchPageMobile_routeWrapClass, _TransferSearchPageMobile_routeWrap, _TransferSearchPageMobile_results, _TransferSearchPageMobile_pickupPointType, _TransferSearchPageMobile_dropoffPointType, _TransferSearchPageMobile_pickupBlock, _TransferSearchPageMobile_dropoffBlock, _TransferSearchPageMobile_returnSwitcher, _TransferSearchPageMobile_searchExecuting, _TransferSearchPageMobile_searchAbortController, _TransferSearchPageMobile_searchExpirationPopup, _TransferSearchPageMobile_showSearchPage, _TransferSearchPageMobile_showSearchResultsPage, _TransferSearchPageMobile_renderSearchResultsPage, _TransferSearchPageMobile_showSearchResults, _TransferSearchPageMobile_prepareDataForSearch, _TransferSearchPageMobile_switchPointInfoBlocks, _TransferSearchPageMobile_search, _TransferSearchPageMobile_cancelSearch, _TransferSearchPageMobile_onHistoryStateChange, _TransferSearchPageMobile_onMainFilterSearch, _TransferSearchPageMobile_onSwitcherClick, _TransferSearchPageMobile_onPickupPointChange, _TransferSearchPageMobile_onDropoffPointChange, _TransferSearchPageMobile_setHotFiltersByUrl, _TransferSearchPageMobile_getParamsFromFiltersMobile, _TransferSearchPageMobile_getParamsFromSortBlock, _TransferSearchPageMobile_addParamSearchBlock, _TransferSearchPageMobile_formatDate, _TransferSearchPageMobile_formatTime, _TransferSearchPageMobile_getParamsFromMainFiltersSearchBlock;
    class TransferSearchPageMobile extends App.TransferPageMobileBase {
        constructor(options) {
            super(Object.assign({ root: `.js-transfer-page .${App.Application.defaults.appContainerContentClass}` }, options));
            _TransferSearchPageMobile_instances.add(this);
            _TransferSearchPageMobile_options.set(this, void 0);
            _TransferSearchPageMobile_preloader.set(this, void 0);
            _TransferSearchPageMobile_filter.set(this, void 0);
            _TransferSearchPageMobile_form.set(this, void 0);
            _TransferSearchPageMobile_messenger.set(this, void 0);
            _TransferSearchPageMobile_responseValidator.set(this, void 0);
            _TransferSearchPageMobile_hotFilter.set(this, void 0);
            _TransferSearchPageMobile_result.set(this, void 0);
            _TransferSearchPageMobile_searchResultsWrapClass.set(this, void 0);
            _TransferSearchPageMobile_searchResultsHotFilterClass.set(this, void 0);
            _TransferSearchPageMobile_searchResultsWrap.set(this, void 0);
            _TransferSearchPageMobile_routeWrapClass.set(this, void 0);
            _TransferSearchPageMobile_routeWrap.set(this, void 0);
            _TransferSearchPageMobile_results.set(this, void 0);
            _TransferSearchPageMobile_pickupPointType.set(this, void 0);
            _TransferSearchPageMobile_dropoffPointType.set(this, void 0);
            _TransferSearchPageMobile_pickupBlock.set(this, void 0);
            _TransferSearchPageMobile_dropoffBlock.set(this, void 0);
            _TransferSearchPageMobile_returnSwitcher.set(this, void 0);
            _TransferSearchPageMobile_searchExecuting.set(this, false);
            _TransferSearchPageMobile_searchAbortController.set(this, void 0);
            _TransferSearchPageMobile_searchExpirationPopup.set(this, void 0);
            __classPrivateFieldSet(this, _TransferSearchPageMobile_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TransferSearchPageMobile_searchResultsWrapClass, '.js-transfer-search-results', "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_searchResultsHotFilterClass, '.js-transfer-search-results .js-transfer-hot-filter', "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_routeWrapClass, '.js-transfer-route', "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_pickupBlock, $('.js-search-location[data-name="PickupPoint"] .js-filter-autocomplete-block', this.root), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_dropoffBlock, $('.js-search-location[data-name="DropoffPoint"] .js-filter-autocomplete-block', this.root), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_searchResultsWrap, $(__classPrivateFieldGet(this, _TransferSearchPageMobile_searchResultsWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_routeWrap, $(__classPrivateFieldGet(this, _TransferSearchPageMobile_routeWrapClass, "f"), this.root), "f");
            this.states = {
                'search': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_showSearchPage).call(this))),
                    actionName: 'search',
                },
                'search_results': {
                    handler: () => __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_showSearchResultsPage).call(this),
                    actionName: 'search',
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            /* обработчики*/
            const pickupDateLimit = __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").pickupDateLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").pickupDateLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").pickupDateLimit.max) };
            __classPrivateFieldSet(this, _TransferSearchPageMobile_preloader, new App.Preloader(), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_filter, new App.TransferMainFilterMobile({
                root: '.js-transfer-main-filter-mobile',
                urls: __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").urls,
                defaults: __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").defaults,
                datesOptions: {
                    minDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.min,
                    maxDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.max,
                    minDateFromShift: __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").defaults.minPickupDateShift,
                    defaultDateFromShift: __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").defaults.defaultPickupDateShift,
                    minDateToOffset: __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").defaults.minDropoffDateOffset,
                    defaultDateToOffset: __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").defaults.defaultDropoffDateOffset,
                },
            }), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_form, new App.Form({ root: __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter }), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_responseValidator, new App.ResponseValidator({
                messenger: __classPrivateFieldGet(this, _TransferSearchPageMobile_messenger, "f"),
                validator: __classPrivateFieldGet(this, _TransferSearchPageMobile_form, "f").validator,
            }), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_hotFilter, new App.TransferHotFilterMobile({ root: __classPrivateFieldGet(this, _TransferSearchPageMobile_searchResultsHotFilterClass, "f") }), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_result, new App.TransferResultMobile({ root: __classPrivateFieldGet(this, _TransferSearchPageMobile_searchResultsWrapClass, "f"), hotFilter: __classPrivateFieldGet(this, _TransferSearchPageMobile_hotFilter, "f") }), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_pickupPointType, __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter.find('#Pickup_Type'), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_dropoffPointType, __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter.find('#Dropoff_Type'), "f");
            __classPrivateFieldSet(this, _TransferSearchPageMobile_returnSwitcher, __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter.find('[data-name="isroundtrip"]'), "f");
            __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_onMainFilterSearch).call(this); }));
            __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_switchPointInfoBlocks).call(this);
            // обработчик на слайдер - при выборе 'И обратно' -> 'открывать' дату и время возврата
            __classPrivateFieldGet(this, _TransferSearchPageMobile_returnSwitcher, "f").on('click', () => __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_onSwitcherClick).call(this));
            // обработчик на клик по началу поездки
            __classPrivateFieldGet(this, _TransferSearchPageMobile_pickupBlock, "f").on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_onPickupPointChange).call(this, e); }));
            // обработчик на смену окончания поездки
            __classPrivateFieldGet(this, _TransferSearchPageMobile_dropoffBlock, "f").on('change', () => __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_onDropoffPointChange).call(this));
            // правильное положение слайдера, когда есть параметры
            if (__classPrivateFieldGet(this, _TransferSearchPageMobile_returnSwitcher, "f").find('input').val() === 'true')
                __classPrivateFieldGet(this, _TransferSearchPageMobile_returnSwitcher, "f").find('.js-sliding-btn').trigger('click');
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_onHistoryStateChange).call(this); }));
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_cancelSearch).call(this);
                    inst.hide();
                }
            });
            __classPrivateFieldGet(this, _TransferSearchPageMobile_hotFilter, "f").root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_cancelSearch).call(this);
                __classPrivateFieldGet(this, _TransferSearchPageMobile_hotFilter, "f").hideProgressDataLoader();
            });
            App.History.replaceState(this.state, new App.QueryParams(window.location.pathname).getUrl());
            (() => __awaiter(this, void 0, void 0, function* () { return yield this.run(App.noneSignal); }))();
        }
        cleanPage() {
            __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter.hideByClass();
            __classPrivateFieldGet(this, _TransferSearchPageMobile_searchResultsWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _TransferSearchPageMobile_routeWrap, "f").hideByClass();
        }
    }
    _a = TransferSearchPageMobile, _TransferSearchPageMobile_options = new WeakMap(), _TransferSearchPageMobile_preloader = new WeakMap(), _TransferSearchPageMobile_filter = new WeakMap(), _TransferSearchPageMobile_form = new WeakMap(), _TransferSearchPageMobile_messenger = new WeakMap(), _TransferSearchPageMobile_responseValidator = new WeakMap(), _TransferSearchPageMobile_hotFilter = new WeakMap(), _TransferSearchPageMobile_result = new WeakMap(), _TransferSearchPageMobile_searchResultsWrapClass = new WeakMap(), _TransferSearchPageMobile_searchResultsHotFilterClass = new WeakMap(), _TransferSearchPageMobile_searchResultsWrap = new WeakMap(), _TransferSearchPageMobile_routeWrapClass = new WeakMap(), _TransferSearchPageMobile_routeWrap = new WeakMap(), _TransferSearchPageMobile_results = new WeakMap(), _TransferSearchPageMobile_pickupPointType = new WeakMap(), _TransferSearchPageMobile_dropoffPointType = new WeakMap(), _TransferSearchPageMobile_pickupBlock = new WeakMap(), _TransferSearchPageMobile_dropoffBlock = new WeakMap(), _TransferSearchPageMobile_returnSwitcher = new WeakMap(), _TransferSearchPageMobile_searchExecuting = new WeakMap(), _TransferSearchPageMobile_searchAbortController = new WeakMap(), _TransferSearchPageMobile_searchExpirationPopup = new WeakMap(), _TransferSearchPageMobile_instances = new WeakSet(), _TransferSearchPageMobile_showSearchPage = function _TransferSearchPageMobile_showSearchPage() {
        App.TransferPageMobileBase.show(__classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter, false);
    }, _TransferSearchPageMobile_showSearchResultsPage = function _TransferSearchPageMobile_showSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: если поиска маршрутов не было или результаты поиска отличаются от формы => новый поиск
            if (__classPrivateFieldGet(this, _TransferSearchPageMobile_results, "f"))
                __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_showSearchResults).call(this);
            else
                yield __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_renderSearchResultsPage).call(this);
        });
    }, _TransferSearchPageMobile_renderSearchResultsPage = function _TransferSearchPageMobile_renderSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.TransferPageMobileBase.show(__classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter, true, 1);
            if (!(yield __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_search).call(this)))
                return;
            __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_showSearchResults).call(this);
            let isStateReplace = false;
            if (this.state !== 'search')
                isStateReplace = true;
            console.log('state');
            this.saveState('search_results', __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_getParamsFromFiltersMobile).call(this, __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").filters, __classPrivateFieldGet(this, _TransferSearchPageMobile_hotFilter, "f").filters), null, isStateReplace);
        });
    }, _TransferSearchPageMobile_showSearchResults = function _TransferSearchPageMobile_showSearchResults() {
        App.TransferPageMobileBase.show(__classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter, true, 1);
        App.TransferPageMobileBase.show(__classPrivateFieldGet(this, _TransferSearchPageMobile_searchResultsWrap, "f"));
        if (__classPrivateFieldGet(this, _TransferSearchPageMobile_hotFilter, "f"))
            __classPrivateFieldGet(_a, _a, "m", _TransferSearchPageMobile_setHotFiltersByUrl).call(_a, __classPrivateFieldGet(this, _TransferSearchPageMobile_hotFilter, "f"), __classPrivateFieldGet(this, _TransferSearchPageMobile_hotFilter, "f").hotFilter);
    }, _TransferSearchPageMobile_prepareDataForSearch = function _TransferSearchPageMobile_prepareDataForSearch() {
        let elements = [];
        if (__classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").filters.searchFilter.length > 0)
            elements = __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").filters.serializeArray();
        else if (__classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").searchData.length > 0)
            elements = __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").searchData;
        // const data: Record<string, string | string[]> = {};
        // $.each(elements, (i, v) => {
        //   if (v.value == null || v.value === '')
        //     return true;
        //  data[v.name] = v.value;
        //  return true;
        // });
        // return data;
        return App.TransferPageMobileBase.convertArrayToRequestData(elements);
    }, _TransferSearchPageMobile_switchPointInfoBlocks = function _TransferSearchPageMobile_switchPointInfoBlocks() {
        const infoBlocks = $('.info-blocks', __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter);
        $(infoBlocks).hide();
        $('.js-info-block', infoBlocks).hide();
        const pickup = __classPrivateFieldGet(this, _TransferSearchPageMobile_pickupPointType, "f").valString().toLowerCase();
        const dropoff = __classPrivateFieldGet(this, _TransferSearchPageMobile_dropoffPointType, "f").valString().toLowerCase();
        if (pickup === '' || pickup === '0')
            return;
        let typeTrip = '';
        const isOneWay = !(__classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter.find('[data-name="isroundtrip"] input').val() === 'true');
        if (!isOneWay) {
            if (dropoff === '' || dropoff === '0')
                return;
            const attr = `${dropoff}-${pickup}`;
            typeTrip = `.js-roundtrip-info[data-type="${attr}"]`;
        }
        else {
            let attr = '';
            if (['airport', 'port', 'station'].includes(pickup))
                attr = pickup;
            else if (dropoff === '' || dropoff === '0')
                return;
            else
                attr = `${pickup}-${dropoff}`;
            typeTrip = `.js-oneway-info[data-type="${attr}"]`;
        }
        $(typeTrip, infoBlocks).show();
        $(infoBlocks).show();
    }, _TransferSearchPageMobile_search = function _TransferSearchPageMobile_search() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c, _d;
            if (__classPrivateFieldGet(this, _TransferSearchPageMobile_searchExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _TransferSearchPageMobile_searchExecuting, true, "f");
            (_b = __classPrivateFieldGet(this, _TransferSearchPageMobile_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            (_c = __classPrivateFieldGet(this, _TransferSearchPageMobile_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.cancel();
            __classPrivateFieldGet(this, _TransferSearchPageMobile_messenger, "f").hide();
            __classPrivateFieldGet(this, _TransferSearchPageMobile_result, "f").resetDataSource();
            if (!__classPrivateFieldGet(this, _TransferSearchPageMobile_form, "f").validator.form())
                return false;
            __classPrivateFieldSet(this, _TransferSearchPageMobile_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _TransferSearchPageMobile_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _TransferSearchPageMobile_preloader, "f").show();
            try {
                const data = __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_prepareDataForSearch).call(this);
                if (this.context)
                    data.context = this.context;
                const maxSteps = 10;
                let step = 0;
                let hasResults = false;
                let continueSearch = false;
                do {
                    /* eslint-disable @typescript-eslint/no-loop-func */
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.TransferPageUrls.Search), { body: App.createUrlSearchParams(Object.assign(Object.assign({}, data), { continueSearch })), signal });
                        if (!__classPrivateFieldGet(this, _TransferSearchPageMobile_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    /* eslint-disable @typescript-eslint/no-loop-func */
                    if (!response)
                        return false;
                    signal.throwIfAborted();
                    if (step <= 0 && response.data.seo != null) {
                        App.app.seo.update(response.data.seo);
                    }
                    const offers = (_d = response.data.offers) !== null && _d !== void 0 ? _d : new Array();
                    yield __classPrivateFieldGet(this, _TransferSearchPageMobile_result, "f").changeDataSource(offers, hasResults);
                    if (!hasResults && offers.length > 0) {
                        __classPrivateFieldSet(this, _TransferSearchPageMobile_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: response.data.dataExpiration,
                            url: __classPrivateFieldGet(this, _TransferSearchPageMobile_options, "f").urls.search,
                        }), "f");
                    }
                    hasResults || (hasResults = offers.length > 0);
                    continueSearch = response.data.continueSearch;
                    yield App.delay(App.randomInt(1000, 5000), App.noneSignal);
                    step++;
                    if (step >= maxSteps)
                        break;
                } while (continueSearch);
                if (!hasResults) {
                    __classPrivateFieldGet(this, _TransferSearchPageMobile_messenger, "f").show(App.Message.SearchNoVariantsWithLink(window.location.href, App.app.settings.tenant == 2 /* KnownTenant.PacUa */));
                }
                return hasResults;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TransferSearchPageMobile_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _TransferSearchPageMobile_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _TransferSearchPageMobile_preloader, "f").hide();
            }
            return false;
        });
    }, _TransferSearchPageMobile_cancelSearch = function _TransferSearchPageMobile_cancelSearch() {
        var _b;
        (_b = __classPrivateFieldGet(this, _TransferSearchPageMobile_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
    }, _TransferSearchPageMobile_onHistoryStateChange = function _TransferSearchPageMobile_onHistoryStateChange() {
        return __awaiter(this, void 0, void 0, function* () {
            this.state = App.History.getState();
            App.app.seo.update(this.seo[this.state]);
            yield this.run(App.noneSignal);
        });
    }, _TransferSearchPageMobile_onMainFilterSearch = function _TransferSearchPageMobile_onMainFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.checkMainFilter())
                return;
            if (!__classPrivateFieldGet(this, _TransferSearchPageMobile_form, "f").validator.form())
                return;
            yield __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_renderSearchResultsPage).call(this);
        });
    }, _TransferSearchPageMobile_onSwitcherClick = function _TransferSearchPageMobile_onSwitcherClick() {
        $('.js-overlayed-switcher', __classPrivateFieldGet(this, _TransferSearchPageMobile_filter, "f").searchFilter).toggleClass('overlayed');
        // показать/скрыть доп тексты
        __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_switchPointInfoBlocks).call(this);
    }, _TransferSearchPageMobile_onPickupPointChange = function _TransferSearchPageMobile_onPickupPointChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            // показать/скрыть доп тексты
            __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_switchPointInfoBlocks).call(this);
        });
    }, _TransferSearchPageMobile_onDropoffPointChange = function _TransferSearchPageMobile_onDropoffPointChange() {
        // показать/скрыть доп тексты
        __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_switchPointInfoBlocks).call(this);
    }, _TransferSearchPageMobile_setHotFiltersByUrl = function _TransferSearchPageMobile_setHotFiltersByUrl(hotFilter, hotFilterElement) {
        const urlParameters = App.UrlParameterHelper.urlParse();
        hotFilterElement.serializeArray().forEach(filter => {
            const filterName = filter.name.toLowerCase();
            switch (filterName) {
                case App.TransferHotFilterFieldsMobile.FreeCancellation: {
                    const control = hotFilter.findControl(App.TransferHotFilterFieldsMobile.FreeCancellation);
                    if (control) {
                        const param = urlParameters.filter(p => p.name === filterName);
                        if (param && param.length > 0)
                            control.setValue(param[0].values[0], true);
                        else
                            control.setValue('', false);
                    }
                    break;
                }
                // no default
            }
        });
    }, _TransferSearchPageMobile_getParamsFromFiltersMobile = function _TransferSearchPageMobile_getParamsFromFiltersMobile(filter, otherHotFilter) {
        console.log('getParamsFromFiltersMobile');
        const params = {};
        let filterParams = __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_getParamsFromMainFiltersSearchBlock).call(this, filter);
        console.log('filterParams:', filterParams);
        if (otherHotFilter) {
            const hotFilterParams = otherHotFilter.getParamsForSearch(true);
            filterParams = filterParams.concat(hotFilterParams);
            filterParams = filterParams.concat(__classPrivateFieldGet(_a, _a, "m", _TransferSearchPageMobile_getParamsFromSortBlock).call(_a, otherHotFilter.root));
        }
        filterParams.forEach(value => {
            params[value.key] = value.value;
        });
        return params;
    }, _TransferSearchPageMobile_getParamsFromSortBlock = function _TransferSearchPageMobile_getParamsFromSortBlock(filter) {
        var _b;
        const params = [];
        const sortValue = (_b = $('.js-sort-item._active', filter).attr('data-sort')) !== null && _b !== void 0 ? _b : '';
        params.push({ key: 'sort', value: [sortValue] });
        return params;
    }, _TransferSearchPageMobile_addParamSearchBlock = function _TransferSearchPageMobile_addParamSearchBlock(params, key, value) {
        if (!value || value.length <= 0)
            return;
        if (value.length == 1 && (value[0] == 'false' || value[0] == '0' || value[0] == ''))
            return;
        const existKey = params.findIndex(el => el.key === key);
        if (existKey !== -1)
            params[existKey].value = params[existKey].value.concat(value);
        else
            params.push({ key, value });
    }, _TransferSearchPageMobile_formatDate = function _TransferSearchPageMobile_formatDate(date) {
        // 25.03.2017 -> 20170325
        const dateParts = date.split('.');
        return dateParts[2] + dateParts[1] + dateParts[0];
    }, _TransferSearchPageMobile_formatTime = function _TransferSearchPageMobile_formatTime(time) {
        // 12:00:00 -> 1200
        const timeParts = time.split(':');
        return timeParts[0] + timeParts[1];
    }, _TransferSearchPageMobile_getParamsFromMainFiltersSearchBlock = function _TransferSearchPageMobile_getParamsFromMainFiltersSearchBlock(filter) {
        const params = [];
        // pickup
        const pickupValues = [];
        const pickup = filter.getControlItemValue('Pickup');
        pickupValues.push(`${pickup.typeCode.toLowerCase()},${pickup.key}`);
        pickupValues.push(__classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_formatDate).call(this, filter.getControlValueString('Pickup.Date')));
        pickupValues.push(__classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_formatTime).call(this, filter.getControlValueString('Pickup.Time')));
        __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_addParamSearchBlock).call(this, params, 'pickup', pickupValues);
        // dropoff
        const dropoffValues = [];
        const dropoff = filter.getControlItemValue('Dropoff');
        dropoffValues.push(`${dropoff.typeCode.toLowerCase()},${dropoff.key}`);
        dropoffValues.push(__classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_formatDate).call(this, filter.getControlValueString('Dropoff.Date')));
        dropoffValues.push(__classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_formatTime).call(this, filter.getControlValueString('Dropoff.Time')));
        __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_addParamSearchBlock).call(this, params, 'dropoff', dropoffValues);
        // driverage
        __classPrivateFieldGet(this, _TransferSearchPageMobile_instances, "m", _TransferSearchPageMobile_addParamSearchBlock).call(this, params, 'driverage', filter.getControlValueStringArr('DriverAge'));
        return params;
    };
    App.TransferSearchPageMobile = TransferSearchPageMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TransferSearchPage_instances, _a, _TransferSearchPage_options, _TransferSearchPage_preloader, _TransferSearchPage_filter, _TransferSearchPage_form, _TransferSearchPage_messenger, _TransferSearchPage_responseValidator, _TransferSearchPage_hotFilter, _TransferSearchPage_result, _TransferSearchPage_searchResultsWrapClass, _TransferSearchPage_searchResultsHotFilterClass, _TransferSearchPage_searchResultsWrap, _TransferSearchPage_routeWrapClass, _TransferSearchPage_routeWrap, _TransferSearchPage_results, _TransferSearchPage_pickupPointType, _TransferSearchPage_dropoffPointType, _TransferSearchPage_pickupBlock, _TransferSearchPage_dropoffBlock, _TransferSearchPage_returnSwitcher, _TransferSearchPage_searchExecuting, _TransferSearchPage_searchAbortController, _TransferSearchPage_searchExpirationPopup, _TransferSearchPage_showSearchPage, _TransferSearchPage_showSearchResultsPage, _TransferSearchPage_renderSearchResultsPage, _TransferSearchPage_showSearchResults, _TransferSearchPage_prepareDataForSearch, _TransferSearchPage_switchPointInfoBlocks, _TransferSearchPage_search, _TransferSearchPage_cancelSearch, _TransferSearchPage_onHistoryStateChange, _TransferSearchPage_onMainFilterSearch, _TransferSearchPage_onSwitcherClick, _TransferSearchPage_onPickupPointChange, _TransferSearchPage_onDropoffPointChange, _TransferSearchPage_setHotFiltersByUrl;
    class TransferSearchPage extends App.TransferPageBase {
        constructor(options) {
            super(Object.assign({ root: `.js-transfer-page .${App.Application.defaults.appContainerContentClass}` }, options));
            _TransferSearchPage_instances.add(this);
            _TransferSearchPage_options.set(this, void 0);
            _TransferSearchPage_preloader.set(this, void 0);
            _TransferSearchPage_filter.set(this, void 0);
            _TransferSearchPage_form.set(this, void 0);
            _TransferSearchPage_messenger.set(this, void 0);
            _TransferSearchPage_responseValidator.set(this, void 0);
            _TransferSearchPage_hotFilter.set(this, void 0);
            _TransferSearchPage_result.set(this, void 0);
            _TransferSearchPage_searchResultsWrapClass.set(this, void 0);
            _TransferSearchPage_searchResultsHotFilterClass.set(this, void 0);
            _TransferSearchPage_searchResultsWrap.set(this, void 0);
            _TransferSearchPage_routeWrapClass.set(this, void 0);
            _TransferSearchPage_routeWrap.set(this, void 0);
            _TransferSearchPage_results.set(this, void 0);
            _TransferSearchPage_pickupPointType.set(this, void 0);
            _TransferSearchPage_dropoffPointType.set(this, void 0);
            _TransferSearchPage_pickupBlock.set(this, void 0);
            _TransferSearchPage_dropoffBlock.set(this, void 0);
            _TransferSearchPage_returnSwitcher.set(this, void 0);
            _TransferSearchPage_searchExecuting.set(this, false);
            _TransferSearchPage_searchAbortController.set(this, void 0);
            _TransferSearchPage_searchExpirationPopup.set(this, void 0);
            __classPrivateFieldSet(this, _TransferSearchPage_options, options, "f");
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TransferSearchPage_searchResultsWrapClass, '.js-transfer-search-results', "f");
            __classPrivateFieldSet(this, _TransferSearchPage_searchResultsHotFilterClass, '.js-transfer-search-results .js-transfer-hot-filter', "f");
            __classPrivateFieldSet(this, _TransferSearchPage_routeWrapClass, '.js-transfer-route', "f");
            __classPrivateFieldSet(this, _TransferSearchPage_pickupBlock, $('.js-search-location[data-name="PickupPoint"] .js-filter-autocomplete-block', this.root), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_dropoffBlock, $('.js-search-location[data-name="DropoffPoint"] .js-filter-autocomplete-block', this.root), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_searchResultsWrap, $(__classPrivateFieldGet(this, _TransferSearchPage_searchResultsWrapClass, "f"), this.root), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_routeWrap, $(__classPrivateFieldGet(this, _TransferSearchPage_routeWrapClass, "f"), this.root), "f");
            this.states = {
                'search': {
                    handler: () => new Promise(resolve => resolve(__classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_showSearchPage).call(this))),
                    actionName: 'search',
                },
                'search_results': {
                    handler: () => __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_showSearchResultsPage).call(this),
                    actionName: 'search',
                },
            };
            this.state = $('input[name="state"]', this.root).valString();
            /* обработчики*/
            const pickupDateLimit = __classPrivateFieldGet(this, _TransferSearchPage_options, "f").pickupDateLimit == null
                ? undefined
                : { min: App.parseIsoDate(__classPrivateFieldGet(this, _TransferSearchPage_options, "f").pickupDateLimit.min), max: App.parseIsoDate(__classPrivateFieldGet(this, _TransferSearchPage_options, "f").pickupDateLimit.max) };
            __classPrivateFieldSet(this, _TransferSearchPage_preloader, new App.Preloader(), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_filter, new App.TransferMainFilter({
                root: '.js-transfer-main-filter',
                urls: __classPrivateFieldGet(this, _TransferSearchPage_options, "f").urls,
                defaults: __classPrivateFieldGet(this, _TransferSearchPage_options, "f").defaults,
                datesOptions: {
                    minDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.min,
                    maxDateFrom: pickupDateLimit === null || pickupDateLimit === void 0 ? void 0 : pickupDateLimit.max,
                    minDateFromShift: __classPrivateFieldGet(this, _TransferSearchPage_options, "f").defaults.minPickupDateShift,
                    defaultDateFromShift: __classPrivateFieldGet(this, _TransferSearchPage_options, "f").defaults.defaultPickupDateShift,
                    minDateToOffset: __classPrivateFieldGet(this, _TransferSearchPage_options, "f").defaults.minDropoffDateOffset,
                    defaultDateToOffset: __classPrivateFieldGet(this, _TransferSearchPage_options, "f").defaults.defaultDropoffDateOffset,
                },
            }), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_form, new App.Form({ root: __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter }), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_messenger, new App.BlockMessenger(new App.Messages()), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_responseValidator, new App.ResponseValidator({
                messenger: __classPrivateFieldGet(this, _TransferSearchPage_messenger, "f"),
                validator: __classPrivateFieldGet(this, _TransferSearchPage_form, "f").validator,
            }), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_hotFilter, new App.TransferHotFilter({ root: __classPrivateFieldGet(this, _TransferSearchPage_searchResultsHotFilterClass, "f") }), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_result, new App.TransferResult({ root: __classPrivateFieldGet(this, _TransferSearchPage_searchResultsWrapClass, "f"), hotFilter: __classPrivateFieldGet(this, _TransferSearchPage_hotFilter, "f") }), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_pickupPointType, __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter.find('#Pickup_Type'), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_dropoffPointType, __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter.find('#Dropoff_Type'), "f");
            __classPrivateFieldSet(this, _TransferSearchPage_returnSwitcher, __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter.find('[data-name="isroundtrip"]'), "f");
            __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter.on("filter:search" /* Events.FilterSearch */, () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_onMainFilterSearch).call(this); }));
            __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_switchPointInfoBlocks).call(this);
            // обработчик на слайдер - при выборе 'И обратно' -> 'открывать' дату и время возврата
            __classPrivateFieldGet(this, _TransferSearchPage_returnSwitcher, "f").on('click', () => __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_onSwitcherClick).call(this));
            // обработчик на клик по началу поездки
            __classPrivateFieldGet(this, _TransferSearchPage_pickupBlock, "f").on("autocompleteOption:click" /* Events.AutocompleteOptionClick */, (e) => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_onPickupPointChange).call(this, e); }));
            // обработчик на смену окончания поездки
            __classPrivateFieldGet(this, _TransferSearchPage_dropoffBlock, "f").on('change', () => __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_onDropoffPointChange).call(this));
            // правильное положение слайдера, когда есть параметры
            if (__classPrivateFieldGet(this, _TransferSearchPage_returnSwitcher, "f").find('input').val() === 'true')
                __classPrivateFieldGet(this, _TransferSearchPage_returnSwitcher, "f").find('.js-sliding-btn').trigger('click');
            $(window).on('popstate', () => __awaiter(this, void 0, void 0, function* () { return yield __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_onHistoryStateChange).call(this); }));
            $('body').on("preloader:action" /* Events.PreloaderAction */, (e, inst, action) => {
                if (action === 'interrupt') {
                    __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_cancelSearch).call(this);
                    inst.hide();
                }
            });
            __classPrivateFieldGet(this, _TransferSearchPage_hotFilter, "f").root.on("ProgressDataLoading:cancelled" /* Events.ProgressDataLoadingCancelled */, () => {
                __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_cancelSearch).call(this);
                __classPrivateFieldGet(this, _TransferSearchPage_hotFilter, "f").hideProgressDataLoader();
            });
            App.History.replaceState(this.state, new App.QueryParams(window.location.pathname).getUrl());
            (() => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield this.run(App.noneSignal);
                }
                catch (error) {
                    console.error('[TransferSearchPage] Error during auto-run:', error);
                }
            }))();
        }
        cleanPage() {
            __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter.hideByClass();
            __classPrivateFieldGet(this, _TransferSearchPage_searchResultsWrap, "f").hideByClass();
            __classPrivateFieldGet(this, _TransferSearchPage_routeWrap, "f").hideByClass();
        }
    }
    _a = TransferSearchPage, _TransferSearchPage_options = new WeakMap(), _TransferSearchPage_preloader = new WeakMap(), _TransferSearchPage_filter = new WeakMap(), _TransferSearchPage_form = new WeakMap(), _TransferSearchPage_messenger = new WeakMap(), _TransferSearchPage_responseValidator = new WeakMap(), _TransferSearchPage_hotFilter = new WeakMap(), _TransferSearchPage_result = new WeakMap(), _TransferSearchPage_searchResultsWrapClass = new WeakMap(), _TransferSearchPage_searchResultsHotFilterClass = new WeakMap(), _TransferSearchPage_searchResultsWrap = new WeakMap(), _TransferSearchPage_routeWrapClass = new WeakMap(), _TransferSearchPage_routeWrap = new WeakMap(), _TransferSearchPage_results = new WeakMap(), _TransferSearchPage_pickupPointType = new WeakMap(), _TransferSearchPage_dropoffPointType = new WeakMap(), _TransferSearchPage_pickupBlock = new WeakMap(), _TransferSearchPage_dropoffBlock = new WeakMap(), _TransferSearchPage_returnSwitcher = new WeakMap(), _TransferSearchPage_searchExecuting = new WeakMap(), _TransferSearchPage_searchAbortController = new WeakMap(), _TransferSearchPage_searchExpirationPopup = new WeakMap(), _TransferSearchPage_instances = new WeakSet(), _TransferSearchPage_showSearchPage = function _TransferSearchPage_showSearchPage() {
        App.TransferPageBase.show(__classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter, false);
    }, _TransferSearchPage_showSearchResultsPage = function _TransferSearchPage_showSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: если поиска не было или результаты поиска отличаются от формы => новый поиск
            if (__classPrivateFieldGet(this, _TransferSearchPage_results, "f"))
                __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_showSearchResults).call(this);
            else
                yield __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_renderSearchResultsPage).call(this);
        });
    }, _TransferSearchPage_renderSearchResultsPage = function _TransferSearchPage_renderSearchResultsPage() {
        return __awaiter(this, void 0, void 0, function* () {
            App.TransferPageBase.show(__classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter, true, 1);
            if (!(yield __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_search).call(this)))
                return;
            __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_showSearchResults).call(this);
            let isStateReplace = false;
            if (this.state !== 'search')
                isStateReplace = true;
            this.saveState('search_results', App.TransferPageBase.getParamsFromFilters(__classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter, __classPrivateFieldGet(this, _TransferSearchPage_hotFilter, "f").hotFilter), null, isStateReplace);
        });
    }, _TransferSearchPage_showSearchResults = function _TransferSearchPage_showSearchResults() {
        App.TransferPageBase.show(__classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter, true, 1);
        App.TransferPageBase.show(__classPrivateFieldGet(this, _TransferSearchPage_searchResultsWrap, "f"));
        if (__classPrivateFieldGet(this, _TransferSearchPage_hotFilter, "f"))
            __classPrivateFieldGet(_a, _a, "m", _TransferSearchPage_setHotFiltersByUrl).call(_a, __classPrivateFieldGet(this, _TransferSearchPage_hotFilter, "f"), __classPrivateFieldGet(this, _TransferSearchPage_hotFilter, "f").hotFilter);
        // Скролл к результатам поиска
        setTimeout(() => {
            const scrollOffset = __classPrivateFieldGet(this, _TransferSearchPage_searchResultsWrap, "f").offset();
            if (scrollOffset) {
                $('html, body').stop(true, true);
                window.scrollTo(0, scrollOffset.top);
            }
        }, 700);
    }, _TransferSearchPage_prepareDataForSearch = function _TransferSearchPage_prepareDataForSearch() {
        let elements = __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter.find('.filter-block:not(.overlayed) input').serializeArray();
        if (__classPrivateFieldGet(this, _TransferSearchPage_options, "f").searchData.length > 0)
            elements = __classPrivateFieldGet(this, _TransferSearchPage_options, "f").searchData;
        return App.TransferPageBase.convertArrayToRequestData(elements);
    }, _TransferSearchPage_switchPointInfoBlocks = function _TransferSearchPage_switchPointInfoBlocks() {
        const infoBlocks = $('.info-blocks', __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter);
        $(infoBlocks).hide();
        $('.js-info-block', infoBlocks).hide();
        const pickup = __classPrivateFieldGet(this, _TransferSearchPage_pickupPointType, "f").valString().toLowerCase();
        const dropoff = __classPrivateFieldGet(this, _TransferSearchPage_dropoffPointType, "f").valString().toLowerCase();
        if (pickup === '' || pickup === '0')
            return;
        let typeTrip = '';
        const isOneWay = !(__classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter.find('[data-name="isroundtrip"] input').val() === 'true');
        if (!isOneWay) {
            if (dropoff === '' || dropoff === '0')
                return;
            typeTrip = `.js-roundtrip-info[data-type="${dropoff}-${pickup}"]`;
        }
        else {
            typeTrip = `.js-oneway-info[data-type="${pickup}"]`;
        }
        $(typeTrip, infoBlocks).show();
        $(infoBlocks).show();
    }, _TransferSearchPage_search = function _TransferSearchPage_search() {
        return __awaiter(this, void 0, void 0, function* () {
            var _b, _c, _d;
            if (__classPrivateFieldGet(this, _TransferSearchPage_searchExecuting, "f"))
                return false;
            __classPrivateFieldSet(this, _TransferSearchPage_searchExecuting, true, "f");
            (_b = __classPrivateFieldGet(this, _TransferSearchPage_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
            (_c = __classPrivateFieldGet(this, _TransferSearchPage_searchExpirationPopup, "f")) === null || _c === void 0 ? void 0 : _c.cancel();
            __classPrivateFieldGet(this, _TransferSearchPage_messenger, "f").hide();
            __classPrivateFieldGet(this, _TransferSearchPage_result, "f").resetDataSource();
            if (!__classPrivateFieldGet(this, _TransferSearchPage_form, "f").validator.form())
                return false;
            __classPrivateFieldSet(this, _TransferSearchPage_searchAbortController, new AbortController(), "f");
            const { signal } = __classPrivateFieldGet(this, _TransferSearchPage_searchAbortController, "f");
            const retryPolicy = App.Retry.createRetryPolicy(App.fetchErrorDetectionStrategy(), App.Retry.defaultExponential);
            __classPrivateFieldGet(this, _TransferSearchPage_preloader, "f").show();
            try {
                const data = __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_prepareDataForSearch).call(this);
                if (this.context)
                    data.context = this.context;
                const maxSteps = 10;
                let step = 0;
                let hasResults = false;
                let continueSearch = false;
                do {
                    /* eslint-disable @typescript-eslint/no-loop-func */
                    const response = yield retryPolicy.execute(() => __awaiter(this, void 0, void 0, function* () {
                        signal.throwIfAborted();
                        const result = yield App.app.http.postPwJson(App.app.url.route(App.TransferPageUrls.Search), { body: App.createUrlSearchParams(Object.assign(Object.assign({}, data), { continueSearch })), signal });
                        if (!__classPrivateFieldGet(this, _TransferSearchPage_responseValidator, "f").process(result))
                            return;
                        return result;
                    }), signal);
                    /* eslint-disable @typescript-eslint/no-loop-func */
                    if (!response)
                        return false;
                    signal.throwIfAborted();
                    if (step <= 0 && response.data.seo != null) {
                        App.app.seo.update(response.data.seo);
                    }
                    const offers = (_d = response.data.offers) !== null && _d !== void 0 ? _d : new Array();
                    yield __classPrivateFieldGet(this, _TransferSearchPage_result, "f").changeDataSource(offers, hasResults);
                    if (!hasResults && offers.length > 0) {
                        __classPrivateFieldSet(this, _TransferSearchPage_searchExpirationPopup, App.scheduleExpirationPopup({
                            interval: response.data.dataExpiration,
                            url: __classPrivateFieldGet(this, _TransferSearchPage_options, "f").urls.search,
                        }), "f");
                    }
                    // Определение наличия результатов поиска
                    hasResults || (hasResults = offers.length > 0);
                    continueSearch = response.data.continueSearch;
                    yield App.delay(App.randomInt(1000, 5000), App.noneSignal);
                    step++;
                    if (step >= maxSteps)
                        break;
                } while (continueSearch);
                if (!hasResults) {
                    __classPrivateFieldGet(this, _TransferSearchPage_messenger, "f").show(App.Message.SearchNoVariantsWithLink(window.location.href, App.app.settings.tenant == 2 /* KnownTenant.PacUa */));
                }
                return hasResults;
            }
            catch (ex) {
                if (!__classPrivateFieldGet(this, _TransferSearchPage_responseValidator, "f").processError(ex))
                    throw ex;
            }
            finally {
                __classPrivateFieldSet(this, _TransferSearchPage_searchExecuting, false, "f");
                __classPrivateFieldGet(this, _TransferSearchPage_preloader, "f").hide();
            }
            return false;
        });
    }, _TransferSearchPage_cancelSearch = function _TransferSearchPage_cancelSearch() {
        var _b;
        (_b = __classPrivateFieldGet(this, _TransferSearchPage_searchAbortController, "f")) === null || _b === void 0 ? void 0 : _b.abort();
    }, _TransferSearchPage_onHistoryStateChange = function _TransferSearchPage_onHistoryStateChange() {
        return __awaiter(this, void 0, void 0, function* () {
            this.state = App.History.getState();
            App.app.seo.update(this.seo[this.state]);
            yield this.run(App.noneSignal);
        });
    }, _TransferSearchPage_onMainFilterSearch = function _TransferSearchPage_onMainFilterSearch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.checkMainFilter())
                return;
            if (!__classPrivateFieldGet(this, _TransferSearchPage_form, "f").validator.form())
                return;
            yield __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_renderSearchResultsPage).call(this);
        });
    }, _TransferSearchPage_onSwitcherClick = function _TransferSearchPage_onSwitcherClick() {
        $('.js-overlayed-switcher', __classPrivateFieldGet(this, _TransferSearchPage_filter, "f").searchFilter).toggleClass('overlayed');
        // показать/скрыть доп тексты
        __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_switchPointInfoBlocks).call(this);
    }, _TransferSearchPage_onPickupPointChange = function _TransferSearchPage_onPickupPointChange(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            // показать/скрыть доп тексты
            __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_switchPointInfoBlocks).call(this);
        });
    }, _TransferSearchPage_onDropoffPointChange = function _TransferSearchPage_onDropoffPointChange() {
        // показать/скрыть доп тексты
        __classPrivateFieldGet(this, _TransferSearchPage_instances, "m", _TransferSearchPage_switchPointInfoBlocks).call(this);
    }, _TransferSearchPage_setHotFiltersByUrl = function _TransferSearchPage_setHotFiltersByUrl(hotFilter, hotFilterElement) {
        const urlParameters = App.UrlParameterHelper.urlParse();
        hotFilterElement.serializeArray().forEach(filter => {
            const filterName = filter.name.toLowerCase();
            switch (filterName) {
                case App.TransferHotFilterFields.FreeCancellation: {
                    const control = hotFilter.findControl(App.TransferHotFilterFields.FreeCancellation);
                    if (control) {
                        const param = urlParameters.filter(p => p.name === filterName);
                        if (param && param.length > 0)
                            control.setValue(param[0].values[0], true);
                        else
                            control.setValue('', false);
                    }
                    break;
                }
                // no default
            }
        });
    };
    App.TransferSearchPage = TransferSearchPage;
})(App || (App = {}));
var App;
(function (App) {
    var _TransferBookFilterMobile_instances, _TransferBookFilterMobile_onFilterSearch;
    class TransferBookFilterMobile extends App.MainFilter {
        constructor(options) {
            super(options);
            _TransferBookFilterMobile_instances.add(this);
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            console.log('TransferBookFilterMobile');
            // this.#options = options;
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            // mobile filters
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: v => this.onFilterChanged(v) });
            this.validator = this.filters.validator;
            console.log('TransferBookFilterMobile filters:', this.filters);
            this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _TransferBookFilterMobile_instances, "m", _TransferBookFilterMobile_onFilterSearch).call(this, e));
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                console.log('--- смена фильтра: "' + filterName + '" ---');
                if (filterName == PwStore.FILTER_ALL) {
                    // console.log('Выполнили сброс всех фильтров');
                }
                else if (filterName == 'Pickup') {
                    const isSameDropoff = this.filters.getControlToggle('SameDropoff');
                    if (isSameDropoff) {
                        const v = this.filters.getControlItemValues('Pickup');
                        this.filters.setControlValue('Dropoff', v, false);
                    }
                }
                else if (filterName == 'Pickup.Date') {
                    const v = this.filters.getControlValue('Pickup.Date');
                    if (v) {
                        const dropDate = this.filters.getControl('Dropoff.Date');
                        dropDate.setMinDate(v, 1);
                    }
                }
                else if (filterName == 'SameDropoff') {
                    const isSameDropoff = this.filters.getControlToggle('SameDropoff');
                    const ctrlDropoff = this.filters.getControl('Dropoff');
                    if (isSameDropoff) {
                        ctrlDropoff === null || ctrlDropoff === void 0 ? void 0 : ctrlDropoff.setEnabled(false);
                        ctrlDropoff === null || ctrlDropoff === void 0 ? void 0 : ctrlDropoff.setValue(this.filters.getControlItemValues('Pickup'));
                    }
                    else {
                        ctrlDropoff === null || ctrlDropoff === void 0 ? void 0 : ctrlDropoff.setEnabled(true);
                    }
                }
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
            });
        }
        reset() {
            this.filters.reset();
        }
    }
    _TransferBookFilterMobile_instances = new WeakSet(), _TransferBookFilterMobile_onFilterSearch = function _TransferBookFilterMobile_onFilterSearch(e) {
        console.log('onFilterSearch');
        e.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    };
    App.TransferBookFilterMobile = TransferBookFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TransferHotFilterMobile_instances, _TransferHotFilterMobile_onHotFiltersChangeMobile, _TransferHotFilterMobile_getFilters;
    class TransferHotFilterMobile extends App.HotFilterMobile {
        constructor(opts) {
            super(opts);
            _TransferHotFilterMobile_instances.add(this);
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // Скрываем тело фильтра на странице и помечаем его для переноса в модалку "Фильтры" (см. HotFilterMobile).
            $('.js-filter-body', this.root).hide().addClass(this.customFilterClass);
            if (!this.root.length) {
                this.hotFilter = $();
                return;
            }
            this.hotFilter = this.root;
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: () => this.onSelfFilterChanged() });
        }
        onSelfFilterChanged() {
            return __awaiter(this, void 0, void 0, function* () {
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
                __classPrivateFieldGet(this, _TransferHotFilterMobile_instances, "m", _TransferHotFilterMobile_onHotFiltersChangeMobile).call(this);
            });
        }
        onHotFiltersChange() {
        }
    }
    _TransferHotFilterMobile_instances = new WeakSet(), _TransferHotFilterMobile_onHotFiltersChangeMobile = function _TransferHotFilterMobile_onHotFiltersChangeMobile() {
        const filters = __classPrivateFieldGet(this, _TransferHotFilterMobile_instances, "m", _TransferHotFilterMobile_getFilters).call(this);
        this.hotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
    }, _TransferHotFilterMobile_getFilters = function _TransferHotFilterMobile_getFilters() {
        // const selectedHotFilters = this.hotFilter.find('input').serializeArray();
        const selectedHotFilters = this.filters.serializeArray();
        return selectedHotFilters
            // не false значения (их не передаем)
            .filter(item => item.value != null && item.value != 'false')
            // превращаем сериализованный массив в массив типа IFilterCriterion
            .map(item => ({
            name: item.name,
            values: item.value ? item.value.split(',') : new Array(),
        }))
            // возвращаем только заполненные значения
            .filter(item => item.values.length > 0);
    };
    App.TransferHotFilterMobile = TransferHotFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    class TransferHotFilter extends App.HotFilter {
        constructor(opts) {
            super(opts);
            Object.defineProperty(this, "hotFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            if (!this.root.length) {
                this.hotFilter = $();
                return;
            }
            this.hotFilter = this.root;
        }
        onHotFiltersChange() {
            const selectedHotFilters = this.hotFilter.find('input').serializeArray();
            const filters = selectedHotFilters
                // превращаем сериализованный массив в массив типа IFilterCriterion
                .map(item => ({
                name: item.name,
                values: item.value ? item.value.split(',') : new Array(),
            }))
                // возвращаем только заполненные значения
                .filter(item => item.values.length > 0);
            this.hotFilter.trigger("filter:filter" /* Events.FilterFilter */, { items: filters });
        }
    }
    App.TransferHotFilter = TransferHotFilter;
})(App || (App = {}));
var App;
(function (App) {
    let TransferHotFilterFieldsMobile;
    (function (TransferHotFilterFieldsMobile) {
        TransferHotFilterFieldsMobile.FreeCancellation = 'freecancellation';
    })(TransferHotFilterFieldsMobile = App.TransferHotFilterFieldsMobile || (App.TransferHotFilterFieldsMobile = {}));
})(App || (App = {}));
var App;
(function (App) {
    let TransferHotFilterFields;
    (function (TransferHotFilterFields) {
        TransferHotFilterFields.FreeCancellation = 'freecancellation';
    })(TransferHotFilterFields = App.TransferHotFilterFields || (App.TransferHotFilterFields = {}));
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Набор хот фильтров трансфер
     */
    class TransferHotFilterSetMobile {
        constructor() {
            Object.defineProperty(this, "freeCancellation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    { name: App.TransferHotFilterFieldsMobile.FreeCancellation },
                ]
            });
        }
    }
    App.TransferHotFilterSetMobile = TransferHotFilterSetMobile;
})(App || (App = {}));
var App;
(function (App) {
    /**
     * Набор хот фильтров трансфер
     */
    class TransferHotFilterSet {
        constructor() {
            Object.defineProperty(this, "freeCancellation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    { name: App.TransferHotFilterFields.FreeCancellation },
                ]
            });
        }
    }
    App.TransferHotFilterSet = TransferHotFilterSet;
})(App || (App = {}));
var App;
(function (App) {
    var _TransferMainFilterMobile_instances, _TransferMainFilterMobile_onFilterSearch, _TransferMainFilterMobile_setDropoffReturnControlsEnabled, _TransferMainFilterMobile_initializeControlsState;
    class TransferMainFilterMobile extends App.MainFilter {
        constructor(options) {
            super(options);
            _TransferMainFilterMobile_instances.add(this);
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "filters", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            // console.log('TransferMainFilterMobile');
            // this.#options = options;
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            // mobile filters
            this.filters = new App.FiltersMobileBase({ root: this.root, onFilterChanged: v => this.onFilterChanged(v) });
            this.validator = this.filters.validator;
            // Инициализация начальных состояний контролов
            __classPrivateFieldGet(this, _TransferMainFilterMobile_instances, "m", _TransferMainFilterMobile_initializeControlsState).call(this);
            console.log('TransferMainFilterMobile filters:', this.filters);
            this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _TransferMainFilterMobile_instances, "m", _TransferMainFilterMobile_onFilterSearch).call(this, e));
        }
        onFilterChanged(filterName) {
            return __awaiter(this, void 0, void 0, function* () {
                // console.log('--- смена фильтра: "' + filterName + '" ---');
                if (filterName == PwStore.FILTER_ALL) {
                    // console.log('Выполнили сброс всех фильтров');
                }
                else if (filterName == 'Pickup') {
                    const isSameDropoff = this.filters.getControlToggle('SameDropoff');
                    if (isSameDropoff) {
                        const v = this.filters.getControlItemValues('Pickup');
                        this.filters.setControlValue('Dropoff', v, false);
                    }
                }
                else if (filterName == 'Pickup.Date') {
                    const v = this.filters.getControlValue('Pickup.Date');
                    if (v) {
                        const dropDate = this.filters.getControl('Dropoff.Date');
                        dropDate.setMinDate(v, 1);
                    }
                }
                else if (filterName == 'IsRoundTrip') {
                    __classPrivateFieldGet(this, _TransferMainFilterMobile_instances, "m", _TransferMainFilterMobile_setDropoffReturnControlsEnabled).call(this, this.filters.getControlToggle('IsRoundTrip'));
                }
                // пробрасываем событие - мы сами подписаны (возможно, кто-то еще подписался через это событие)
                this.root.trigger("filter:change" /* Events.FilterChange */); // дергаем событие на тот случай, если кто-то еще подписан со своей реализацией
            });
        }
        reset() {
            this.filters.reset();
        }
    }
    _TransferMainFilterMobile_instances = new WeakSet(), _TransferMainFilterMobile_onFilterSearch = function _TransferMainFilterMobile_onFilterSearch(e) {
        // console.log('onFilterSearch');
        e.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    }, _TransferMainFilterMobile_setDropoffReturnControlsEnabled = function _TransferMainFilterMobile_setDropoffReturnControlsEnabled(isRoundTrip) {
        const ctrlDropoffDate = this.filters.getControl('Dropoff.Date');
        const ctrlDropoffTime = this.filters.getControl('Dropoff.Time');
        if (!ctrlDropoffDate || !ctrlDropoffTime)
            return;
        ctrlDropoffDate.setEnabled(isRoundTrip);
        ctrlDropoffTime.setEnabled(isRoundTrip);
        ctrlDropoffDate.setRequired(isRoundTrip);
        ctrlDropoffTime.setRequired(isRoundTrip);
    }, _TransferMainFilterMobile_initializeControlsState = function _TransferMainFilterMobile_initializeControlsState() {
        __classPrivateFieldGet(this, _TransferMainFilterMobile_instances, "m", _TransferMainFilterMobile_setDropoffReturnControlsEnabled).call(this, this.filters.getControlToggle('IsRoundTrip'));
    };
    App.TransferMainFilterMobile = TransferMainFilterMobile;
})(App || (App = {}));
var App;
(function (App) {
    var _TransferMainFilter_instances, _TransferMainFilter_options, _TransferMainFilter_filters, _TransferMainFilter_initSearchFilterEvents, _TransferMainFilter_getFilterControls, _TransferMainFilter_onFilterSearch, _TransferMainFilter_validateDates, _TransferMainFilter_validateFromValue;
    class TransferMainFilter extends App.MainFilter {
        constructor(options) {
            super(options);
            _TransferMainFilter_instances.add(this);
            _TransferMainFilter_options.set(this, void 0);
            _TransferMainFilter_filters.set(this, void 0);
            Object.defineProperty(this, "searchFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            __classPrivateFieldSet(this, _TransferMainFilter_options, options, "f");
            if (!this.root.length) {
                this.searchFilter = $();
                return;
            }
            this.searchFilter = this.root;
            __classPrivateFieldGet(this, _TransferMainFilter_instances, "m", _TransferMainFilter_initSearchFilterEvents).call(this);
        }
        reset() {
            if (__classPrivateFieldGet(this, _TransferMainFilter_filters, "f").pickup.block)
                __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").pickup.block.reset();
            if (__classPrivateFieldGet(this, _TransferMainFilter_filters, "f").dropoff.block)
                __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").dropoff.block.reset();
            if (__classPrivateFieldGet(this, _TransferMainFilter_filters, "f").checkinFrom.block) {
                const dateBlock = __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").checkinFrom.block;
                dateBlock.clear();
            }
            __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").timeFrom.element.val(__classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.pickupTime);
            if (__classPrivateFieldGet(this, _TransferMainFilter_filters, "f").dropoffHotel.block)
                __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").dropoffHotel.block.reset();
            $('.js-transfer-main-filter').find('.js-overlayed-dropoff').addClass('overlayed');
            if (__classPrivateFieldGet(this, _TransferMainFilter_filters, "f").checkinTo.block) {
                const dateBlock = __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").checkinTo.block;
                dateBlock.clear();
            }
            __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").timeTo.element.val(__classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.dropoffTime);
            if (__classPrivateFieldGet(this, _TransferMainFilter_filters, "f").switcher.element.find('input').val() !== __classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.isRoundTrip.toString())
                __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").switcher.element.find('.js-sliding-btn').trigger('click');
            if (__classPrivateFieldGet(this, _TransferMainFilter_filters, "f").tourist.block) {
                const block = __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").tourist.block;
                block.setValues(__classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.adultCount, __classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.childCount);
            }
        }
    }
    _TransferMainFilter_options = new WeakMap(), _TransferMainFilter_filters = new WeakMap(), _TransferMainFilter_instances = new WeakSet(), _TransferMainFilter_initSearchFilterEvents = function _TransferMainFilter_initSearchFilterEvents() {
        __classPrivateFieldSet(this, _TransferMainFilter_filters, __classPrivateFieldGet(this, _TransferMainFilter_instances, "m", _TransferMainFilter_getFilterControls).call(this, this.searchFilter), "f");
        $('.js-point-time', this.searchFilter).inputmask('time');
        // TODO: comment this and set class js-filter-dates-block to the top div
        __classPrivateFieldGet(this, _TransferMainFilter_instances, "m", _TransferMainFilter_validateDates).call(this);
        this.searchFilter.on('submit', e => __classPrivateFieldGet(this, _TransferMainFilter_instances, "m", _TransferMainFilter_onFilterSearch).call(this, e));
    }, _TransferMainFilter_getFilterControls = function _TransferMainFilter_getFilterControls(container) {
        return {
            pickup: {
                element: container.find('.js-search-location[data-name="PickupPoint"] .js-point-select-input'),
                block: this.findControl('pickupPoint'),
                changeType: 'pickup',
            },
            dropoff: {
                element: container.find('.js-search-location[data-name="DropoffPoint"] .js-point-select-input'),
                block: this.findControl('dropoffPoint'),
                changeType: 'dropoff',
            },
            dropoffHotel: {
                element: container.find('.js-search-location[data-select="DropoffHotel"] .js-point-select-input'),
                block: this.findControl('dropoffPoint'),
                changeType: 'dropoff',
            },
            checkinFrom: {
                element: container.find('.js-filter-date-from'),
                block: this.findControl('pickupDate'),
                changeType: 'checkin',
            },
            checkinTo: {
                element: container.find('.js-filter-date-to'),
                block: this.findControl('dropoffDate'),
                changeType: 'checkin',
            },
            timeFrom: {
                element: container.find('.js-filter-time-block[data-name="PickupTime"] input'),
                changeType: 'time',
            },
            timeTo: {
                element: container.find('.js-filter-time-block[data-name="DropoffTime"] input'),
                changeType: 'time',
            },
            switcher: {
                element: container.find('.js-filter-sliding-btn-b'),
                changeType: 'switcher',
            },
            tourist: {
                element: container.find('.js-filter-people-block'),
                block: this.findControl('tourist'),
                changeType: 'tourist',
            },
        };
    }, _TransferMainFilter_onFilterSearch = function _TransferMainFilter_onFilterSearch(e) {
        e.preventDefault();
        this.root.trigger("filter:search" /* Events.FilterSearch */);
    }, _TransferMainFilter_validateDates = function _TransferMainFilter_validateDates() {
        /* В трансферах и аренде авто FilterDatesBlock работает не корректно, потому что разнесены блоки from и to
         * По сути, тут дубль кода из FilterDatesBlock
         */
        /* события на смену даты в календаре */
        const calendarFrom = __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").checkinFrom.element;
        const calendarTo = __classPrivateFieldGet(this, _TransferMainFilter_filters, "f").checkinTo.element;
        calendarFrom.datepicker('option', 'onSelect', (dateText, inst) => {
            const date = calendarFrom.datepicker('getDate');
            __classPrivateFieldGet(this, _TransferMainFilter_instances, "m", _TransferMainFilter_validateFromValue).call(this, date, calendarFrom, calendarTo);
            inst.input.trigger('change');
        });
        calendarTo.datepicker('option', 'onSelect', (dateText, inst) => {
            inst.input.trigger('change');
        });
        /* дата to: min дата */
        calendarTo.datepicker('option', 'minDate', App.addDays(calendarFrom.datepicker('getDate'), __classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.minDropoffDateOffset));
    }, _TransferMainFilter_validateFromValue = function _TransferMainFilter_validateFromValue(value, calendarFrom, calendarTo) {
        const minValue = App.addDays(new Date(), __classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.minPickupDateShift);
        const newValue = value < minValue ? minValue : value;
        calendarTo.datepicker('option', 'minDate', App.addDays(newValue, __classPrivateFieldGet(this, _TransferMainFilter_options, "f").defaults.minDropoffDateOffset));
    };
    App.TransferMainFilter = TransferMainFilter;
})(App || (App = {}));
var App;
(function (App) {
    var _a, _TransferResult_urlChangeStrategy, _TransferResult_filterTransfers, _TransferResult_inArray;
    class TransferResult extends App.Result {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Transfer.Search.BlockOutput }, options));
            _TransferResult_urlChangeStrategy.set(this, void 0);
            if (!this.root.length)
                return;
            __classPrivateFieldSet(this, _TransferResult_urlChangeStrategy, new App.UrlChangeStrategy(new App.TransferHotFilterSet()), "f");
            __classPrivateFieldGet(this, _TransferResult_urlChangeStrategy, "f").bind(this.hotFilter, this.root);
        }
        applySorting(items) {
            if (this.sorting.reverse) {
                return Enumerable.from(items)
                    .orderByDescending(v => v.grossPrice)
                    .thenByDescending(v => v.key)
                    .toArray();
            }
            return Enumerable.from(items)
                .orderBy(v => v.grossPrice)
                .thenBy(v => v.key)
                .toArray();
        }
        applyFilters(items) {
            let result = items;
            this.filtering.items.forEach(filter => {
                result = result.filter(item => __classPrivateFieldGet(_a, _a, "m", _TransferResult_filterTransfers).call(_a, filter, item));
            });
            return result;
        }
    }
    _a = TransferResult, _TransferResult_urlChangeStrategy = new WeakMap(), _TransferResult_filterTransfers = function _TransferResult_filterTransfers(filter, item) {
        switch (filter.name.toLowerCase()) {
            case App.TransferHotFilterFields.FreeCancellation:
                return __classPrivateFieldGet(_a, _a, "m", _TransferResult_inArray).call(_a, item.freeCancellation.toString(), filter.values);
            default:
                return true;
        }
    }, _TransferResult_inArray = function _TransferResult_inArray(value, array) {
        return array.some(v => v === value.toString());
    };
    App.TransferResult = TransferResult;
})(App || (App = {}));
/// <reference path="./TransferResult.ts" />
var App;
(function (App) {
    class TransferResultMobile extends App.TransferResult {
        constructor(options) {
            super(Object.assign({ blockTemplate: App.templates.Transfer.Search.BlockOutput_Mobile }, options));
            if (!this.root.length)
                return;
        }
    }
    App.TransferResultMobile = TransferResultMobile;
})(App || (App = {}));
var App;
(function (App) {
    let TransferPageUrls;
    (function (TransferPageUrls) {
        TransferPageUrls.Search = '/transfer/search/';
        TransferPageUrls.GetCancellationPolicy = '/transfer/getcancellationpolicy/';
        TransferPageUrls.Book = '/transfer/book/';
    })(TransferPageUrls = App.TransferPageUrls || (App.TransferPageUrls = {}));
})(App || (App = {}));
